webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addLocaleData", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intlShape", function() { return intlShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectIntl", function() { return injectIntl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineMessages", function() { return defineMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntlProvider", function() { return IntlProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedDate", function() { return FormattedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedTime", function() { return FormattedTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedRelative", function() { return FormattedRelative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedNumber", function() { return FormattedNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedPlural", function() { return FormattedPlural; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedMessage", function() { return FormattedMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedHTMLMessage", function() { return FormattedHTMLMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(2854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(2379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache__ = __webpack_require__(2369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_intl_format_cache__);
/*
 * Copyright 2017, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */









// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
      __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;
var oneOfType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? 'wrappedInstance' : null
        }));
      }
    }]);
    return InjectIntl;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return InjectIntl;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 // months to year
};

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
}

function getNamedFormat(formats, type, name) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  if (false) {
    console.error('[React Intl] No ' + type + ' format named: ' + name);
  }
}

function formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var defaults$$1 = format && getNamedFormat(formats, 'date', format);
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting date.\n' + e);
    }
  }

  return String(date);
}

function formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var defaults$$1 = format && getNamedFormat(formats, 'time', format);
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting time.\n' + e);
    }
  }

  return String(date);
}

function formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting relative time.\n' + e);
    }
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var defaults$$1 = format && getNamedFormat(formats, 'number', format);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting number.\n' + e);
    }
  }

  return String(value);
}

function formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting plural.\n' + e);
    }
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // `id` is a required field of a Message Descriptor.

  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      if (false) {
        console.error('[React Intl] Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '') + ('\n' + e));
      }
    }
  } else {
    if (false) {
      // This prevents warnings from littering the console in development
      // when no `messages` are passed into the <IntlProvider> for the
      // default locale, and a default message is in the source.
      if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
        console.error('[React Intl] Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''));
      }
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      if (false) {
        console.error('[React Intl] Error formatting the default message for: "' + id + '"' + ('\n' + e));
      }
    }
  }

  if (!formattedMessage) {
    if (false) {
      console.error('[React Intl] Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.'));
    }
  }

  return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {}
};

var IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(Intl.DateTimeFormat),
      getNumberFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(Intl.NumberFormat),
      getMessageFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
      getRelativeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
      getPluralFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats;


        if (false) {
          console.error('[React Intl] Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.'));
        }

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
  intl: intlShape
};
IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
  intl: intlShape
};
FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
  intl: intlShape
};
FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatMessage = _context$intl.formatMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
  intl: intlShape
};
FormattedMessage.defaultProps = {
  values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__errors_ErrorIntl__ = __webpack_require__(1427);

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



var IntlMsg = function () {
  function IntlMsg(intl) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, IntlMsg);

    this.intl = intl;
    this.context = context;
    this.errorIntl = new __WEBPACK_IMPORTED_MODULE_1__errors_ErrorIntl__["a" /* default */](intl, context);
  }

  IntlMsg.prototype.msgId = function msgId(id) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;

    var intlId = id;
    if (context !== '') {
      intlId = context + "." + id;
    }
    return intlId;
  };

  IntlMsg.prototype.msg = function msg(id) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;

    var intlId = this.msgId(id, context);
    return this.intl.formatMessage({
      id: intlId,
      defaultMessage: intlId
    });
  };

  IntlMsg.prototype.errorMsg = function errorMsg(error) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;

    return this.errorIntl.msg(error, context);
  };

  IntlMsg.prototype.globalMsg = function globalMsg(id) {
    return this.msg(id, '');
  };

  return IntlMsg;
}();

/* harmony default export */ __webpack_exports__["a"] = (IntlMsg);

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(2682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(2683);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(1077);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(1076);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(2693);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(2692);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Router__ = __webpack_require__(2698);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(1078);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IndexLink__ = __webpack_require__(2694);
/* unused harmony reexport IndexLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withRouter__ = __webpack_require__(2709);
/* unused harmony reexport withRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__ = __webpack_require__(2695);
/* unused harmony reexport IndexRedirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexRoute__ = __webpack_require__(2696);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__IndexRoute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(1080);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(2697);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouteUtils__ = __webpack_require__(198);
/* unused harmony reexport createRoutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RouterContext__ = __webpack_require__(592);
/* unused harmony reexport RouterContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PropTypes__ = __webpack_require__(591);
/* unused harmony reexport locationShape */
/* unused harmony reexport routerShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__match__ = __webpack_require__(2707);
/* unused harmony reexport match */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__ = __webpack_require__(1085);
/* unused harmony reexport useRouterHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatternUtils__ = __webpack_require__(272);
/* unused harmony reexport formatPattern */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__ = __webpack_require__(2700);
/* unused harmony reexport applyRouterMiddleware */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browserHistory__ = __webpack_require__(2701);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_15__browserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hashHistory__ = __webpack_require__(2705);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_16__hashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__ = __webpack_require__(1082);
/* unused harmony reexport createMemoryHistory */
/* components */









/* components (configuration) */










/* utils */















/* histories */








/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loracfg__ = __webpack_require__(65);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var defaultProps = {
  if: false
};

var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.node.isRequired,
  if: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.oneOfType([__WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool, __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func, __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string])
};

var ShowIf = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ShowIf, _React$Component);

  function ShowIf(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ShowIf);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      if: props.if
    };
    return _this;
  }

  ShowIf.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var ifCond = nextProps.if;

    if (ifCond !== this.props.if) {
      this.setState({ if: ifCond });
    }
  };

  ShowIf.prototype.shouldShow = function shouldShow() {
    var ifCond = this.state.if;

    if (_.isString(ifCond)) {
      var _ifCond$split$map = ifCond.split(':').map(function (s) {
        return s.trim();
      }),
          key = _ifCond$split$map[0],
          value = _ifCond$split$map[1];

      if (key === 'profile' && __WEBPACK_IMPORTED_MODULE_4_loracfg__["a" /* default */].profile === value) {
        return true;
      }
    } else if (_.isFunction(ifCond)) {
      return ifCond();
    } else {
      return ifCond;
    }
    return false;
  };

  ShowIf.prototype.render = function render() {
    if (this.shouldShow()) {
      return this.props.children;
    }
    return null;
  };

  return ShowIf;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ShowIf.defaultProps = defaultProps;
ShowIf.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (ShowIf);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isFunction2 = __webpack_require__(170);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _extendReactClass = __webpack_require__(2597);

var _extendReactClass2 = _interopRequireDefault(_extendReactClass);

var _wrapStatelessFunction = __webpack_require__(2602);

var _wrapStatelessFunction2 = _interopRequireDefault(_wrapStatelessFunction);

var _makeConfiguration = __webpack_require__(2600);

var _makeConfiguration2 = _interopRequireDefault(_makeConfiguration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Determines if the given object has the signature of a class that inherits React.Component.
 */


/**
 * @see https://github.com/gajus/react-css-modules#options
 */
var isReactComponent = function isReactComponent(maybeReactComponent) {
  return 'prototype' in maybeReactComponent && (0, _isFunction3.default)(maybeReactComponent.prototype.render);
};

/**
 * When used as a function.
 */
var functionConstructor = function functionConstructor(Component, defaultStyles, options) {
  var decoratedClass = void 0;

  var configuration = (0, _makeConfiguration2.default)(options);

  if (isReactComponent(Component)) {
    decoratedClass = (0, _extendReactClass2.default)(Component, defaultStyles, configuration);
  } else {
    decoratedClass = (0, _wrapStatelessFunction2.default)(Component, defaultStyles, configuration);
  }

  if (Component.displayName) {
    decoratedClass.displayName = Component.displayName;
  } else {
    decoratedClass.displayName = Component.name;
  }

  return decoratedClass;
};

/**
 * When used as a ES7 decorator.
 */
var decoratorConstructor = function decoratorConstructor(defaultStyles, options) {
  return function (Component) {
    return functionConstructor(Component, defaultStyles, options);
  };
};

exports.default = function () {
  if ((0, _isFunction3.default)(arguments.length <= 0 ? undefined : arguments[0])) {
    return functionConstructor(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2]);
  } else {
    return decoratorConstructor(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1]);
  }
};

module.exports = exports['default'];

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss__ = __webpack_require__(2159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







var defaultProps = {
  brandIcon: null,
  brandTitle: null,
  breadcrumb: null,
  brandTools: null,
  leftTools: null,
  rightTools: null
};

var propTypes = {
  brandIcon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any,
  brandTitle: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any,
  breadcrumb: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.array,
  brandTools: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.array,
  leftTools: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.array,
  rightTools: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.array
};

var Toolbar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Toolbar, _React$Component);

  Toolbar.renderTools = function renderTools(tools) {
    var pullRight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (tools) {
      var toolComs = tools.map(function (t, idx) {
        if (t.type === 'buttons') {
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Navbar"].Form,
            {
              key: String(idx),
              pullRight: pullRight
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "ul",
              { styleName: "button-list" },
              t.buttons.map(function (b, i) {
                return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "li",
                  { key: String(i) },
                  b
                );
              })
            )
          );
        } else if (t.type === 'search') {
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Navbar"].Form,
            {
              key: String(idx),
              pullRight: pullRight
            },
            t.searchInput
          );
        } else if (t.type === 'selectpills') {
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Navbar"].Form,
            {
              key: String(idx),
              styleName: "navbar-spills",
              pullRight: pullRight
            },
            t.selectPills
          );
        }
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Navbar"].Form,
          {
            key: String(idx),
            styleName: "navbar-input",
            pullRight: pullRight
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "span",
            { styleName: "navbar-label" },
            t.label
          ),
          t.input
        );
      });
      return toolComs;
    }
    return null;
  };

  function Toolbar(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Toolbar);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      brandIcon: _this.props.brandIcon,
      brandTitle: _this.props.brandTitle,
      breadcrumb: _this.props.breadcrumb,
      brandTools: _this.props.brandTools,
      leftTools: _this.props.leftTools,
      rightTools: _this.props.rightTools
    };
    return _this;
  }

  Toolbar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.brandIcon !== this.props.brandIcon || nextProps.brandTitle !== this.props.brandTitle || nextProps.breadcrumb !== this.props.breadcrumb || nextProps.leftTools !== this.props.leftTools || nextProps.rightTools !== this.props.rightTools || nextProps.brandTools !== this.props.brandTools) {
      this.setState({
        brandIcon: nextProps.brandIcon,
        brandTitle: nextProps.brandTitle,
        brandTools: nextProps.brandTools,
        breadcrumb: nextProps.breadcrumb,
        leftTools: nextProps.leftTools,
        rightTools: nextProps.rightTools
      });
    }
  };

  Toolbar.prototype.renderBrand = function renderBrand() {
    var _state = this.state,
        brandIcon = _state.brandIcon,
        brandTitle = _state.brandTitle,
        brandTools = _state.brandTools,
        breadcrumb = _state.breadcrumb;

    var brand = [];

    if (brandIcon) {
      brand.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "span",
        { key: "brand-icon", styleName: "brand-icon" },
        brandIcon
      ));
    }
    if (brandTitle) {
      brand.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { key: "brand-title", styleName: "brand-title" },
        brandTitle
      ));
    }
    if (brandTools) {
      var tools = Toolbar.renderTools(brandTools);
      brand.push.apply(brand, tools);
    }
    if (breadcrumb) {
      brand.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { key: "breadcrumb", styleName: "breadcrumb" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Breadcrumb"],
          null,
          breadcrumb.map(function (b, idx) {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Breadcrumb"].Item,
              {
                key: idx,
                onClick: b.onClick,
                active: b.active
              },
              b.content
            );
          })
        )
      ));
    }

    return brand;
  };

  Toolbar.prototype.render = function render() {
    var _state2 = this.state,
        leftTools = _state2.leftTools,
        rightTools = _state2.rightTools;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { styleName: "toolbar" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Navbar"],
        { bsStyle: "aisz-white" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Navbar"].Header,
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Navbar"].Brand,
            null,
            this.renderBrand()
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__ShowIf__["a" /* default */],
            { "if": !_.isNil(leftTools) || !_.isNil(rightTools) },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Navbar"].Toggle,
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-caret-down" })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__ShowIf__["a" /* default */],
          { "if": !_.isNil(leftTools) || !_.isNil(rightTools) },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Navbar"].Collapse,
            null,
            leftTools && Toolbar.renderTools(leftTools),
            rightTools && Toolbar.renderTools(rightTools, true)
          )
        )
      )
    );
  };

  return Toolbar;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Toolbar.defaultProps = defaultProps;
Toolbar.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5_react_css_modules___default()(Toolbar, __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a, { allowMultiple: true }));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNull__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_has__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_forOwn__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_forOwn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_forOwn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_trimEnd__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_trimEnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_trimEnd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_trimStart__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_trimStart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_trimStart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_whatwg_fetch__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lorautils_cookies_auth__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__error__ = __webpack_require__(1135);







/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







// Fetches an API response.
/* harmony default export */ __webpack_exports__["a"] = (function (request) {
  var apiRoot = __WEBPACK_IMPORTED_MODULE_5_lodash_trimEnd___default()(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].apiBase, '/ ');
  var endpoint = request.endpoint,
      _request$method = request.method,
      method = _request$method === undefined ? 'GET' : _request$method,
      query = request.query,
      body = request.body,
      mode = request.mode;

  var fullUrl = void 0;
  if (endpoint.indexOf('http') !== 0) {
    var path = __WEBPACK_IMPORTED_MODULE_6_lodash_trimStart___default()(endpoint, ' /');
    fullUrl = apiRoot + "/" + path;
  } else {
    fullUrl = endpoint;
  }

  if (query) {
    var queryStr = '';
    var joint = '';
    __WEBPACK_IMPORTED_MODULE_4_lodash_forOwn___default()(query, function (v, k) {
      if (!_.isNil(v)) {
        queryStr += "" + joint + k + "=" + encodeURIComponent(v);
        joint = '&';
      }
    });
    if (fullUrl.indexOf('&') >= 0) {
      fullUrl = fullUrl + "&" + queryStr;
    } else {
      fullUrl = fullUrl + "?" + queryStr;
    }
  }

  var init = {
    method: method,
    credentials: 'include'
  };

  var authCookies = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lorautils_cookies_auth__["a" /* getAuthCookies */])();
  if (authCookies) {
    init.headers = {
      Authorization: "Bearer " + authCookies.access_token
    };
  }

  if (body) {
    init.body = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(body);
  }
  if (mode) {
    init.mode = mode;
  }
  return fetch(fullUrl, init).then(function (response) {
    if (mode) {
      return response;
    }
    return response.json().then(function (json) {
      if (!response.ok) {
        throw json;
      }
      if (__WEBPACK_IMPORTED_MODULE_3_lodash_has___default()(json, 'list') && __WEBPACK_IMPORTED_MODULE_2_lodash_isNull___default()(json.list)) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, json, { list: [] });
      }
      return json;
    });
  }).catch(function (error) {
    throw __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__error__["a" /* parseAPIError */])(error);
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);


/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



var ErrorSet = function () {
  ErrorSet.createEmpty = function createEmpty() {
    return new ErrorSet();
  };

  function ErrorSet() {
    var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])();

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ErrorSet);

    this.errors = errors;
  }

  ErrorSet.prototype.add = function add(code, target) {
    var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var errors = this.errors;
    var error = this.errors.find(function (e) {
      return e.get('target') === target;
    });
    if (error) {
      errors = errors.remove(error);
    }
    return new ErrorSet(errors.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ code: code, target: target }, args))));
  };

  ErrorSet.prototype.has = function has(target) {
    return this.errors.some(function (e) {
      return e.get('target') === target;
    });
  };

  ErrorSet.prototype.remove = function remove(target) {
    var error = this.errors.find(function (e) {
      return e.get('target') === target;
    });
    if (error) {
      return new ErrorSet(this.errors.remove(error));
    }
    return this;
  };

  ErrorSet.prototype.get = function get(target) {
    return this.errors.find(function (e) {
      return e.get('target') === target;
    });
  };

  ErrorSet.prototype.getCode = function getCode(target) {
    var error = this.get(target);
    if (error) {
      return error.get('code');
    }
    return null;
  };

  ErrorSet.prototype.getArg = function getArg(target, arg) {
    var error = this.get(target);
    if (error) {
      return error.get(arg);
    }
    return null;
  };

  ErrorSet.prototype.isEmpty = function isEmpty() {
    return this.errors.isEmpty();
  };

  return ErrorSet;
}();

/* harmony default export */ __webpack_exports__["a"] = (ErrorSet);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InitTheme */
/* unused harmony export InitButtonTheme */
/* unused harmony export InitFormTheme */
/* unused harmony export InitPanelTheme */
/* unused harmony export InitModalTheme */
/* unused harmony export InitProgressBar */
/* unused harmony export InitDropdownButton */
/* unused harmony export InitTabs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sass_bootstrap_scss__ = __webpack_require__(2323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sass_bootstrap_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__sass_bootstrap_scss__);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





function InitButtonTheme() {
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-default');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-default-o');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-default-b');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-info');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-info-b');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-info-o');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-primary');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-primary-o');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-primary-b');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-primary-ob');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-success');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-success-o');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-success-b');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-warning');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-warning-o');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-danger');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-danger-o');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-danger-b');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-transparent');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-link');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-link-default');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-link-danger');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-link-warning');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-link-success');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"], 'aisz-light');
}

function InitFormTheme() {}

function InitPanelTheme() {
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Panel"], 'aisz-transparent');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Panel"], 'aisz-white');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Panel"], 'aisz-warning');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Panel"], 'aisz-danger');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Panel"], 'aisz-info');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Panel"], 'aisz-light');
}

function InitModalTheme() {}

function InitNavs() {
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Nav"], 'aisz-pills');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Nav"], 'aisz-tabs');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Navbar"], 'aisz-white');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Navbar"], 'aisz-transparent');
}

function InitTabs() {
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Tabs"], 'aisz-tabs');
}

function InitProgressBar() {
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["ProgressBar"], 'aisz-primary');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["ProgressBar"], 'aisz-success');
}

function InitDropdownButton() {
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["DropdownButton"], 'aisz-primary-b');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["DropdownButton"], 'aisz-primary');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["DropdownButton"], 'aisz-transparent');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["DropdownButton"], 'aisz-success');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["DropdownButton"], 'aisz-success-b');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["DropdownButton"], 'aisz-danger-b');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["SplitButton"], 'aisz-primary');
  __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["SplitButton"], 'aisz-default-b');
}

function InitTheme() {
  InitButtonTheme();
  InitFormTheme();
  InitPanelTheme();
  InitModalTheme();
  InitNavs();
  InitTabs();
  InitProgressBar();
  InitDropdownButton();
}



(function f() {
  InitTheme();
})();

/***/ }),
/* 30 */,
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return formatMacInput; });
/* harmony export (immutable) */ __webpack_exports__["b"] = normalizeMac;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isValidMac; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return formatAppEUIInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return normalizeAppEUI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isValidAppEUI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return formatDevEUIInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeDevEUI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isValidDevEUI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return formatDevAddrInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return normalizeDevAddr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isValidDevAddr; });
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

// editPos: 9999 - bulk editing, +n - adding at position n, -n - deleting at position n
function editPos(prev, curr) {
  if (Math.abs(prev.length - curr.length) !== 1) {
    // user is editing multiple chars
    return 9999;
  }

  var l = prev;
  var s = curr;
  var adding = -1;
  if (s.length > l.length) {
    var _ref = [s, l];
    l = _ref[0];
    s = _ref[1];

    adding = 1;
  }

  var index = 9999;
  _.forEach(_.range(l.length), function (idx) {
    if ("" + l.substr(0, idx) + l.substr(idx + 1) === s) {
      index = idx;
    }
  });
  return index * adding;
}

function formatIdInput() {
  var fullPairs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (fullPairs.length === 0) {
    return function (curr) {
      return curr;
    };
  }

  var fullLens = fullPairs.map(function (p) {
    return p * 2;
  });
  var fullTrailings = fullLens.map(function (l) {
    return l + l / 2 - 1;
  });
  var breakPoints = _.range(0, _.max(fullLens), 2);

  return function (curr) {
    var prev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var id = curr.replace(':', '-').replace(/[^0-9a-fA-F-]/g, '');

    if (curr + "-" === prev) {
      // use is deleting the trailing '-'
      if (!fullTrailings.includes(id.length)) {
        id = id.substr(0, id.length - 1);
      }
      return id;
    }

    var ep = editPos(prev, curr);

    if (ep === 9999) {
      // just reformat
      var postfix = id[id.length - 1] === '-';
      id = id.replace(/[^0-9a-fA-F]/g, '');

      var fullMac = function fullMac(m) {
        var nsm = m.replace(/[^0-9a-fA-F]/g, '');
        return fullLens.includes(nsm.length);
      };

      if (!fullMac(id) && id.length % 2 === 0 && id.length > 0) {
        postfix = true;
      }

      id = breakPoints.slice(0, Math.ceil(id.length / 2)).map(function (i) {
        return id.substr(i, 2);
      }).join('-');
      if (postfix) {
        id += '-';
      }
    } else if (ep === id.length - 1) {
      // add trailing '-'
      if (id[id.length - 1] === '-') {
        return id.replace(/-+$/, '-');
      }
      // adding trailing paired alphabet
      if (/[0-9a-fA-F]{3}$/.test(id)) {
        return id.substr(0, id.length - 1) + "-" + id[id.length - 1];
      }
      var fullPair = function fullPair(m) {
        var pairs = m.split('-').length;
        return fullPairs.includes(pairs);
      };
      if (/[0-9a-fA-F]{2}$/.test(id) && !fullPair(id)) {
        return id + "-";
      }
    }

    return id;
  };
}

function normalizeId() {
  var fullPairs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (fullPairs.length === 0) {
    return function () {
      return false;
    };
  }

  var fullLens = fullPairs.map(function (p) {
    return p * 2;
  });
  var breakPoints = _.range(0, _.max(fullLens), 2);

  return function (id) {
    var nid = id.toUpperCase();
    if (nid.indexOf(':') !== -1 || nid.indexOf('-') !== -1) {
      nid = nid.split(/[:-]/).join('');
    }
    return breakPoints.slice(0, Math.ceil(nid.length / 2)).map(function (i) {
      return nid.substr(i, 2);
    }).join('-');
  };
}

function isValidId() {
  var fullPairs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (fullPairs.length === 0) {
    return function () {
      return false;
    };
  }

  var regexs = [];
  fullPairs.forEach(function (p) {
    regexs.push(new RegExp("^([0-9A-F]{2}-){" + (p - 1) + "}[0-9A-F]{2}$"));
    regexs.push(new RegExp("^([0-9A-F]{2}:){" + (p - 1) + "}[0-9A-F]{2}$"));
    regexs.push(new RegExp("^([0-9A-F]{2}){" + (p - 1) + "}[0-9A-F]{2}$"));
  });

  return function (id) {
    var nid = id.toUpperCase();
    return _.some(regexs, function (reg) {
      return reg.test(nid);
    });
  };
}

// ========================
//       MAC Addresses
// ========================

var formatMacInput = formatIdInput([6, 8]);

function normalizeMac(id) {
  var nid = id.toUpperCase();
  if (nid.indexOf(':') !== -1 || nid.indexOf('-') !== -1) {
    nid = nid.split(/[:-]/).join('');
  }
  if (nid.length === 12) {
    nid = nid.slice(0, 6) + "FFFE" + nid.slice(6, 12);
  }
  return [0, 2, 4, 6, 8, 10, 12, 14].map(function (i) {
    return nid.substr(i, 2);
  }).join('-');
}

var isValidMac = isValidId([6, 8]);

// ========================
//         AppEUI
// ========================

var formatAppEUIInput = formatIdInput([8]);
var normalizeAppEUI = normalizeId([8]);
var isValidAppEUI = isValidId([8]);

// ========================
//         DevEUI
// ========================

var formatDevEUIInput = formatIdInput([8]);
var normalizeDevEUI = normalizeId([8]);
var isValidDevEUI = isValidId([8]);

// ========================
//         DevAddr
// ========================

var formatDevAddrInput = formatIdInput([4]);
var normalizeDevAddr = normalizeId([4]);
var isValidDevAddr = isValidId([4]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (immutable) */ __webpack_exports__["a"] = callAPI;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNull__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_has__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_forOwn__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_forOwn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_forOwn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_trimEnd__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_trimEnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_trimEnd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_trimStart__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_trimStart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_trimStart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_whatwg_fetch__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracfg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cookies_auth__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__error__ = __webpack_require__(1425);







/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







// Fetches an API response.
function callAPI(request) {
  var apiRoot = __WEBPACK_IMPORTED_MODULE_5_lodash_trimEnd___default()(__WEBPACK_IMPORTED_MODULE_8_loracfg__["a" /* default */].apiBase, '/ ');
  var endpoint = request.endpoint,
      _request$method = request.method,
      method = _request$method === undefined ? 'GET' : _request$method,
      query = request.query,
      body = request.body;


  var fullUrl = void 0;
  if (endpoint.indexOf('http') !== 0) {
    var path = __WEBPACK_IMPORTED_MODULE_6_lodash_trimStart___default()(endpoint, ' /');
    fullUrl = apiRoot + "/" + path;
  } else {
    fullUrl = endpoint;
  }

  if (query) {
    var queryStr = '';
    var joint = '';
    __WEBPACK_IMPORTED_MODULE_4_lodash_forOwn___default()(query, function (v, k) {
      if (!_.isNil(v)) {
        queryStr += "" + joint + k + "=" + encodeURIComponent(v);
        joint = '&';
      }
    });
    if (fullUrl.indexOf('&') >= 0) {
      fullUrl = fullUrl + "&" + queryStr;
    } else {
      fullUrl = fullUrl + "?" + queryStr;
    }
  }

  var init = {
    method: method,
    credentials: 'include'
  };

  var authCookies = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__cookies_auth__["a" /* getAuthCookies */])();
  if (authCookies) {
    init.headers = {
      Authorization: "Bearer " + authCookies.access_token
    };
  }

  if (body) {
    init.body = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(body);
  }

  return fetch(fullUrl, init).then(function (response) {
    return response.json().then(function (json) {
      if (!response.ok) {
        throw json;
      }
      if (__WEBPACK_IMPORTED_MODULE_3_lodash_has___default()(json, 'list') && __WEBPACK_IMPORTED_MODULE_2_lodash_isNull___default()(json.list)) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, json, { list: [] });
      }
      return json;
    });
  }).catch(function (error) {
    throw __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__error__["a" /* parseAPIError */])(error);
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_has__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isNil__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss__ = __webpack_require__(2137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_scss__);





/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);






var defaultProps = {
  nul: 'empty',
  status: 'absent'
};

var propTypes = {
  status: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired,
  val: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.any,
  nul: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.any,
  formatter: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func
};

var kBuiltins = {
  empty: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    "span",
    { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.empty },
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], { id: "lora.emptyval", defaultMessage: "Empty" })
  ),
  loading: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    "span",
    { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.loading },
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" })
  )
};

var Nvl = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Nvl, _React$Component);

  function Nvl(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Nvl);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      val: props.val,
      status: props.status
    };
    return _this;
  }

  Nvl.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var val = nextProps.val,
        status = nextProps.status;

    if (val !== this.props.val) {
      this.setState({ val: val });
    }
    if (status !== this.props.status) {
      this.setState({ status: status });
    }
  };

  Nvl.prototype.render = function render() {
    var status = this.state.status;


    if (status === 'pending') {
      return kBuiltins.loading;
    }

    var nul = this.props.nul;

    if (__WEBPACK_IMPORTED_MODULE_3_lodash_has___default()(kBuiltins, nul)) {
      nul = kBuiltins[nul];
    }

    var val = this.state.val;

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default()(val)) {
      return nul;
    }
    if (this.props.formatter) {
      val = this.props.formatter(val);
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "span",
      null,
      val
    );
  };

  return Nvl;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Nvl.defaultProps = defaultProps;
Nvl.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(Nvl));

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_scss__ = __webpack_require__(2123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var defaultProps = {
  placement: 'right',
  message: ''
};

var propTypes = {
  show: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool.isRequired,
  message: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.node,
  azStyle: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.oneOf(['danger', 'info', 'primary', 'success', 'warning']).isRequired,
  placement: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.oneOf(['top', 'right', 'bottom', 'left']).isRequired
};

var ControlTips = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ControlTips, _React$Component);

  function ControlTips(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ControlTips);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      message: props.message,
      show: props.show,
      azStyle: props.azStyle
    };
    return _this;
  }

  ControlTips.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var message = nextProps.message,
        show = nextProps.show,
        azStyle = nextProps.azStyle;

    if (message !== this.props.message) {
      this.setState({ message: message });
    }
    if (show !== this.props.show) {
      this.setState({ show: show });
    }
    if (azStyle !== this.props.azStyle) {
      this.setState({ azStyle: azStyle });
    }
  };

  ControlTips.prototype.render = function render() {
    var placement = this.props.placement;
    var _state = this.state,
        message = _state.message,
        show = _state.show,
        azStyle = _state.azStyle;

    if (show) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.wrapper + " " + __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a[placement] },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.tips + " " + __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a[azStyle] + " " + __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a[placement] },
          message,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.arrow + " " + __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a[azStyle] + " " + __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a[placement] })
        )
      );
    }
    return null;
  };

  return ControlTips;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ControlTips.defaultProps = defaultProps;
ControlTips.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (ControlTips);

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fromPairs__ = __webpack_require__(2500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fromPairs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fromPairs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_assign__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_has__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AutoColor__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_scss__ = __webpack_require__(2144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_scss__);







/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







var defaultProps = {
  content: null,
  enums: null,
  theme: 'auto',
  shift: null,
  translateMap: null,
  inverse: false
};

var propTypes = {
  content: __WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.any,
  translateMap: __WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.object,
  shift: __WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.number,
  theme: __WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.string,
  enums: __WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.oneOfType([__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.array, __WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.func]),
  inverse: __WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.bool
};

var RichLabel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(RichLabel, _React$Component);

  function RichLabel(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, RichLabel);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      hovered: false
    };
    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
    _this.tooltips = {};
    return _this;
  }

  RichLabel.prototype.handleMouseOver = function handleMouseOver() {
    var _this2 = this;

    this.timeout = setTimeout(function () {
      _this2.setState({ hovered: true });
    }, 200);
  };

  RichLabel.prototype.handleMouseOut = function handleMouseOut() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.setState({ hovered: false });
  };

  RichLabel.prototype.content = function content() {
    var _props = this.props,
        enums = _props.enums,
        content = _props.content;
    var translateMap = this.props.translateMap;

    // translateMap is deprecated, when enums is used, translateMap is overwrite

    if (enums) {
      if (_.isArray(enums)) {
        translateMap = __WEBPACK_IMPORTED_MODULE_5_lodash_assign___default()(translateMap, __WEBPACK_IMPORTED_MODULE_4_lodash_fromPairs___default()(enums.filter(function (e) {
          return __WEBPACK_IMPORTED_MODULE_6_lodash_has___default()(e, 'translate');
        }).map(function (e) {
          return [e.content, e.translate];
        })));
      } else if (_.isFunction(enums)) {
        var e = enums(content);
        if (_.has(e, 'translate')) {
          var _extends2;

          translateMap = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, translateMap, (_extends2 = {}, _extends2[content] = e.translate, _extends2));
        }
      }
    }

    if (translateMap) {
      var label = translateMap[content] || content;
      var tooltip = this.tooltips[content];
      if (!tooltip) {
        tooltip = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Tooltip"],
          { placement: "top", className: "in", id: "tooltip" },
          content
        );
        this.tooltips[content] = tooltip;
      }
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        "span",
        {
          className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.translated,
          onMouseOver: this.handleMouseOver,
          onMouseOut: this.handleMouseOut
        },
        this.state.hovered && tooltip,
        label
      );
    }
    return content;
  };

  RichLabel.prototype.render = function render() {
    var _props2 = this.props,
        inverse = _props2.inverse,
        theme = _props2.theme,
        shift = _props2.shift,
        enums = _props2.enums,
        content = _props2.content;


    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__AutoColor__["a" /* default */],
      {
        className: "" + __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.richLabel,
        inverse: inverse,
        content: content,
        theme: theme,
        shift: shift,
        enums: enums
      },
      this.content()
    );
  };

  return RichLabel;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

RichLabel.propTypes = propTypes;
RichLabel.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (RichLabel);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_scss__ = __webpack_require__(2129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







var defaultProps = {
  message: '',
  closeButton: false,
  onHide: function onHide() {}
};

var propTypes = {
  show: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool.isRequired,
  azStyle: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  message: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.node,
  closeButton: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool,
  onHide: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func
};

var FormBlock = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(FormBlock, _React$Component);

  function FormBlock(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FormBlock);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      show: props.show,
      message: props.message,
      azStyle: props.azStyle
    };
    return _this;
  }

  FormBlock.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var show = nextProps.show,
        message = nextProps.message,
        azStyle = nextProps.azStyle;

    if (show !== this.props.show) {
      this.setState({ show: show });
    }
    if (message !== this.props.message) {
      this.setState({ message: message });
    }
    if (azStyle !== this.props.azStyle) {
      this.setState({ azStyle: azStyle });
    }
  };

  FormBlock.prototype.render = function render() {
    var _props = this.props,
        _props$closeButton = _props.closeButton,
        closeButton = _props$closeButton === undefined ? false : _props$closeButton,
        onHide = _props.onHide;
    var _state = this.state,
        show = _state.show,
        message = _state.message,
        azStyle = _state.azStyle;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Collapse"],
      { "in": show },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.formBlock + " " + __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a[azStyle] },
          message,
          closeButton && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_router__["f" /* Link */],
            { className: __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.closeButton, onClick: onHide },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-times" })
          )
        )
      )
    );
  };

  return FormBlock;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

FormBlock.defaultProps = defaultProps;
FormBlock.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (FormBlock);

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_animate_css_animate_min_css__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_animate_css_animate_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_animate_css_animate_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







var defaultProps = {
  status: 'default'
};

var propTypes = {
  status: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string,
  states: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.array.isRequired
};

var RichButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(RichButton, _React$Component);

  function RichButton(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RichButton);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      status: props.status,
      states: props.states
    };
    return _this;
  }

  RichButton.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var status = nextProps.status,
        states = nextProps.states;

    if (status !== this.props.status) {
      this.setState({ status: status });
    }
    if (states !== this.props.states) {
      this.setState({ states: states });
    }
  };

  RichButton.prototype.render = function render() {
    var _state = this.state,
        status = _state.status,
        states = _state.states;

    var btnState = states.filter(function (s) {
      return s.status === status;
    })[0];
    if (!btnState) {
      btnState = states.filter(function (s) {
        return s.status === 'default';
      })[0];
    }

    var _btnState = btnState,
        _btnState$style = _btnState.style,
        style = _btnState$style === undefined ? 'primary' : _btnState$style,
        label = _btnState.label,
        disabled = _btnState.disabled,
        type = _btnState.type,
        timer = _btnState.timer,
        _btnState$delay = _btnState.delay,
        delay = _btnState$delay === undefined ? 3000 : _btnState$delay;
    var _btnState2 = btnState,
        _btnState2$onClick = _btnState2.onClick,
        onClick = _btnState2$onClick === undefined ? function () {} : _btnState2$onClick;


    if (type === 'submit') {
      onClick = null;
    }

    if (timer) {
      setTimeout(timer, delay);
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
      {
        bsStyle: "aisz-" + style,
        onClick: onClick,
        disabled: disabled,
        type: type
      },
      label
    );
  };

  return RichButton;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

RichButton.defaultProps = defaultProps;
RichButton.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (RichButton);

/***/ }),
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(59);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* createTypesMap */])('device', ['getDevice', 'updateDevice', 'deleteDevice', 'getDeviceData', 'sendDeviceData', 'getTxSize', 'flushTx', 'getLinks', 'getDefLinks', 'getDevices', 'getRxQOS', 'countDevices', 'getRxParamSetupReq', 'sendRxParamSetupReq', 'getRxTimingSetupReq', 'sendRxTimingSetupReq', 'sendDutyCycleReq', 'sendDevStatusReq', 'sendLinkADRReq', 'sendNewChannelReq', 'sendUpdChPlanReq', 'sendUpdChPlanReq2', 'getMacTxSize', 'getMacLog', 'sendDlChannelReq', 'sendTxParamSetupReq', 'sendAddBroadcastReq', 'sendAddBroadcastReqV2', 'RemoveBroadcastReq', 'RemoveBroadcastReqV2']);

function getDevice(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getDevice, {
    endpoint: "/lora/nodes/" + id
  })();
}

function updateDevice(id, data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.updateDevice, {
    endpoint: "/lora/nodes/" + id,
    method: 'PUT',
    body: data
  })();
}

function deleteDevice(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.deleteDevice, {
    endpoint: "/lora/nodes/" + id,
    method: 'DELETE'
  })();
}

function getDeviceData(id, args) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getDeviceData, {
    endpoint: "/lora/nodes/" + id + "/samples",
    method: 'GET',
    query: args
  })();
}

function sendDeviceData(id, fport, data, encoding) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.sendDeviceData, {
    endpoint: "/lora/nodes/" + id + "/tx",
    method: 'POST',
    body: {
      fport: fport,
      data: data,
      encoding: encoding
    }
  })();
}

function getTxSize(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getTxSize, {
    endpoint: "/lora/nodes/" + id + "/tx/size",
    method: 'GET'
  })();
}

function flushTx(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.flushTx, {
    endpoint: "/lora/nodes/" + id + "/tx/flush",
    method: 'POST'
  })();
}

function getLinks(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getLinks, {
    endpoint: "/lora/nodes/" + id + "/links"
  })();
}

function getDefLinks(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getDefLinks, {
    endpoint: "/lora/nodes/" + id + "/deflink"
  })();
}

function getDevices(args) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getDevices, {
    endpoint: '/lora/nodes',
    query: _.assign({ sort: '-ctime', pageSize: 10 }, args)
  })();
}

function getRxQOS(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getRxQOS, {
    endpoint: "/lora/nodes/" + id + "/rxqos?download"
  })();
}

function countDevices(args) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.countDevices, {
    endpoint: '/lora/nodes/count',
    query: args
  })();
}

function getRxParamSetupReq(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getRxParamSetupReq, {
    endpoint: "/lora/nodes/" + id + "/mac/args/RXParamSetupReq"
  })();
}

function sendRxParamSetupReq(id, data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.sendRxParamSetupReq, {
    endpoint: "/lora/nodes/" + id + "/mac/tx/RXParamSetupReq",
    query: data,
    method: 'POST'
  })();
}

function getRxTimingSetupReq(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getRxTimingSetupReq, {
    endpoint: "/lora/nodes/" + id + "/mac/args/RXTimingSetupReq"
  })();
}

function sendRxTimingSetupReq(id, data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.sendRxTimingSetupReq, {
    endpoint: "/lora/nodes/" + id + "/mac/tx/RXTimingSetupReq",
    query: data,
    method: 'POST'
  })();
}

function sendDutyCycleReq(id, data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.sendDutyCycleReq, {
    endpoint: "/lora/nodes/" + id + "/mac/tx/DutyCycleReq",
    query: data,
    method: 'POST'
  })();
}

function sendDevStatusReq(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.sendDevStatusReq, {
    endpoint: "/lora/nodes/" + id + "/mac/tx/DevStatusReq",
    method: 'POST'
  })();
}

function sendLinkADRReq(id, data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.sendLinkADRReq, {
    endpoint: "/lora/nodes/" + id + "/mac/tx/LinkADRReq",
    method: 'POST',
    query: data
  })();
}

function sendNewChannelReq(id, data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.sendNewChannelReq, {
    endpoint: "/lora/nodes/" + id + "/mac/tx/NewChannelReq",
    method: 'POST',
    query: data
  })();
}

function sendDlChannelReq(id, data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.sendDlChannelReq, {
    endpoint: "/lora/nodes/" + id + "/mac/tx/DlChannelReq",
    method: 'POST',
    query: data
  })();
}

function sendTxParamSetupReq(id, data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.sendTxParamSetupReq, {
    endpoint: "/lora/nodes/" + id + "/mac/tx/TxParamSetupReq",
    method: 'POST',
    query: data
  })();
}

function sendUpdChPlanReq(id, data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.sendUpdChPlanReq, {
    endpoint: "/lora/nodes/" + id + "/mac/tx/UpdChPlanReq",
    method: 'POST',
    query: data
  })();
}

function sendUpdChPlanReq2(id, data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.sendUpdChPlanReq2, {
    endpoint: "/lora/nodes/" + id + "/mac/tx/UpdChPlanReqV2",
    method: 'POST',
    query: data
  })();
}

function getMacTxSize(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getMacTxSize, {
    endpoint: "/lora/nodes/" + id + "/mac/tx/size"
  })();
}

function getMacLog(id, args) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getMacLog, {
    endpoint: "/lora/nodes/" + id + "/mac/logs",
    query: args
  })();
}

function sendAddBroadcastReq(id, param) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.sendAddBroadcastReq, {
    endpoint: "/lora/nodes/" + id + "/mac/tx/AddBroadcastReq",
    method: 'POST',
    body: param
  })();
}

function sendAddBroadcastReqV2(id, param) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.sendAddBroadcastReqV2, {
    endpoint: "/lora/nodes/" + id + "/mac/tx/AddBroadcastReqV2",
    method: 'POST',
    body: param
  })();
}

function RemoveBroadcastReq(id, param) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.RemoveBroadcastReq, {
    endpoint: "/lora/nodes/" + id + "/mac/tx/RemoveBroadcastReq",
    method: 'POST',
    body: param
  })();
}

function RemoveBroadcastReqV2(id, param) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.RemoveBroadcastReqV2, {
    endpoint: "/lora/nodes/" + id + "/mac/tx/RemoveBroadcastReqV2",
    method: 'POST',
    body: param
  })();
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getDevice: getDevice,
  updateDevice: updateDevice,
  deleteDevice: deleteDevice,
  getDeviceData: getDeviceData,
  sendDeviceData: sendDeviceData,
  getTxSize: getTxSize,
  flushTx: flushTx,
  getLinks: getLinks,
  getDefLinks: getDefLinks,
  getDevices: getDevices,
  getRxQOS: getRxQOS,
  countDevices: countDevices,
  getRxParamSetupReq: getRxParamSetupReq,
  sendRxParamSetupReq: sendRxParamSetupReq,
  getRxTimingSetupReq: getRxTimingSetupReq,
  sendRxTimingSetupReq: sendRxTimingSetupReq,
  sendDutyCycleReq: sendDutyCycleReq,
  sendDevStatusReq: sendDevStatusReq,
  sendLinkADRReq: sendLinkADRReq,
  sendNewChannelReq: sendNewChannelReq,
  sendTxParamSetupReq: sendTxParamSetupReq,
  sendDlChannelReq: sendDlChannelReq,
  sendUpdChPlanReq: sendUpdChPlanReq,
  sendUpdChPlanReq2: sendUpdChPlanReq2,
  getMacTxSize: getMacTxSize,
  getMacLog: getMacLog,
  sendAddBroadcastReq: sendAddBroadcastReq,
  sendAddBroadcastReqV2: sendAddBroadcastReqV2,
  RemoveBroadcastReq: RemoveBroadcastReq,
  RemoveBroadcastReqV2: RemoveBroadcastReqV2
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

/**
 *  Copyright (c) 2014-2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  global.Immutable = factory();
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step > 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    findEntry: function(predicate, context) {
      var found;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findLastEntry: function(predicate, context) {
      return this.toSeq().reverse().findEntry(predicate, context);
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  // Temporary warning about using length
  (function () {
    try {
      Object.defineProperty(IterablePrototype, 'length', {
        get: function () {
          if (!Iterable.noLengthWarning) {
            var stack;
            try {
              throw new Error();
            } catch (error) {
              stack = error.stack;
            }
            if (stack.indexOf('_wrapObject') === -1) {
              console && console.warn && console.warn(
                'iterable.length has been deprecated, '+
                'use iterable.size or iterable.count(). '+
                'This warning will become a silent error in a future version. ' +
                stack
              );
              return this.size;
            }
          }
        }
      });
    } catch (e) {}
  })();



  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLastKey: function(predicate, context) {
      return this.toSeq().reverse().findKey(predicate, context);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    lastKeyOf: function(searchValue) {
      return this.findLastKey(function(value ) {return is(value, searchValue)});
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.toKeyedSeq().keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.toKeyedSeq().reverse().keyOf(searchValue);
      return key === undefined ? -1 : key;

      // var index =
      // return this.toSeq().reverse().indexOf(searchValue);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var key = this.toKeyedSeq().findLastKey(predicate, context);
      return key === undefined ? -1 : key;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : value;
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EditorState
 * @format
 * 
 */



var _assign = __webpack_require__(36);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BlockTree = __webpack_require__(749);
var ContentState = __webpack_require__(503);
var EditorBidiService = __webpack_require__(1826);
var Immutable = __webpack_require__(45);
var SelectionState = __webpack_require__(259);

var OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Stack = Immutable.Stack;


var defaultRecord = {
  allowUndo: true,
  currentContent: null,
  decorator: null,
  directionMap: null,
  forceSelection: false,
  inCompositionMode: false,
  inlineStyleOverride: null,
  lastChangeType: null,
  nativelyRenderedContent: null,
  redoStack: Stack(),
  selection: null,
  treeMap: null,
  undoStack: Stack()
};

var EditorStateRecord = Record(defaultRecord);

var EditorState = function () {
  EditorState.createEmpty = function createEmpty(decorator) {
    return EditorState.createWithContent(ContentState.createFromText(''), decorator);
  };

  EditorState.createWithContent = function createWithContent(contentState, decorator) {
    var firstKey = contentState.getBlockMap().first().getKey();
    return EditorState.create({
      currentContent: contentState,
      undoStack: Stack(),
      redoStack: Stack(),
      decorator: decorator || null,
      selection: SelectionState.createEmpty(firstKey)
    });
  };

  EditorState.create = function create(config) {
    var currentContent = config.currentContent,
        decorator = config.decorator;

    var recordConfig = _extends({}, config, {
      treeMap: generateNewTreeMap(currentContent, decorator),
      directionMap: EditorBidiService.getDirectionMap(currentContent)
    });
    return new EditorState(new EditorStateRecord(recordConfig));
  };

  EditorState.set = function set(editorState, put) {
    var map = editorState.getImmutable().withMutations(function (state) {
      var existingDecorator = state.get('decorator');
      var decorator = existingDecorator;
      if (put.decorator === null) {
        decorator = null;
      } else if (put.decorator) {
        decorator = put.decorator;
      }

      var newContent = put.currentContent || editorState.getCurrentContent();

      if (decorator !== existingDecorator) {
        var treeMap = state.get('treeMap');
        var newTreeMap;
        if (decorator && existingDecorator) {
          newTreeMap = regenerateTreeForNewDecorator(newContent, newContent.getBlockMap(), treeMap, decorator, existingDecorator);
        } else {
          newTreeMap = generateNewTreeMap(newContent, decorator);
        }

        state.merge({
          decorator: decorator,
          treeMap: newTreeMap,
          nativelyRenderedContent: null
        });
        return;
      }

      var existingContent = editorState.getCurrentContent();
      if (newContent !== existingContent) {
        state.set('treeMap', regenerateTreeForNewBlocks(editorState, newContent.getBlockMap(), newContent.getEntityMap(), decorator));
      }

      state.merge(put);
    });

    return new EditorState(map);
  };

  EditorState.prototype.toJS = function toJS() {
    return this.getImmutable().toJS();
  };

  EditorState.prototype.getAllowUndo = function getAllowUndo() {
    return this.getImmutable().get('allowUndo');
  };

  EditorState.prototype.getCurrentContent = function getCurrentContent() {
    return this.getImmutable().get('currentContent');
  };

  EditorState.prototype.getUndoStack = function getUndoStack() {
    return this.getImmutable().get('undoStack');
  };

  EditorState.prototype.getRedoStack = function getRedoStack() {
    return this.getImmutable().get('redoStack');
  };

  EditorState.prototype.getSelection = function getSelection() {
    return this.getImmutable().get('selection');
  };

  EditorState.prototype.getDecorator = function getDecorator() {
    return this.getImmutable().get('decorator');
  };

  EditorState.prototype.isInCompositionMode = function isInCompositionMode() {
    return this.getImmutable().get('inCompositionMode');
  };

  EditorState.prototype.mustForceSelection = function mustForceSelection() {
    return this.getImmutable().get('forceSelection');
  };

  EditorState.prototype.getNativelyRenderedContent = function getNativelyRenderedContent() {
    return this.getImmutable().get('nativelyRenderedContent');
  };

  EditorState.prototype.getLastChangeType = function getLastChangeType() {
    return this.getImmutable().get('lastChangeType');
  };

  /**
   * While editing, the user may apply inline style commands with a collapsed
   * cursor, intending to type text that adopts the specified style. In this
   * case, we track the specified style as an "override" that takes precedence
   * over the inline style of the text adjacent to the cursor.
   *
   * If null, there is no override in place.
   */


  EditorState.prototype.getInlineStyleOverride = function getInlineStyleOverride() {
    return this.getImmutable().get('inlineStyleOverride');
  };

  EditorState.setInlineStyleOverride = function setInlineStyleOverride(editorState, inlineStyleOverride) {
    return EditorState.set(editorState, { inlineStyleOverride: inlineStyleOverride });
  };

  /**
   * Get the appropriate inline style for the editor state. If an
   * override is in place, use it. Otherwise, the current style is
   * based on the location of the selection state.
   */


  EditorState.prototype.getCurrentInlineStyle = function getCurrentInlineStyle() {
    var override = this.getInlineStyleOverride();
    if (override != null) {
      return override;
    }

    var content = this.getCurrentContent();
    var selection = this.getSelection();

    if (selection.isCollapsed()) {
      return getInlineStyleForCollapsedSelection(content, selection);
    }

    return getInlineStyleForNonCollapsedSelection(content, selection);
  };

  EditorState.prototype.getBlockTree = function getBlockTree(blockKey) {
    return this.getImmutable().getIn(['treeMap', blockKey]);
  };

  EditorState.prototype.isSelectionAtStartOfContent = function isSelectionAtStartOfContent() {
    var firstKey = this.getCurrentContent().getBlockMap().first().getKey();
    return this.getSelection().hasEdgeWithin(firstKey, 0, 0);
  };

  EditorState.prototype.isSelectionAtEndOfContent = function isSelectionAtEndOfContent() {
    var content = this.getCurrentContent();
    var blockMap = content.getBlockMap();
    var last = blockMap.last();
    var end = last.getLength();
    return this.getSelection().hasEdgeWithin(last.getKey(), end, end);
  };

  EditorState.prototype.getDirectionMap = function getDirectionMap() {
    return this.getImmutable().get('directionMap');
  };

  /**
   * Incorporate native DOM selection changes into the EditorState. This
   * method can be used when we simply want to accept whatever the DOM
   * has given us to represent selection, and we do not need to re-render
   * the editor.
   *
   * To forcibly move the DOM selection, see `EditorState.forceSelection`.
   */


  EditorState.acceptSelection = function acceptSelection(editorState, selection) {
    return updateSelection(editorState, selection, false);
  };

  /**
   * At times, we need to force the DOM selection to be where we
   * need it to be. This can occur when the anchor or focus nodes
   * are non-text nodes, for instance. In this case, we want to trigger
   * a re-render of the editor, which in turn forces selection into
   * the correct place in the DOM. The `forceSelection` method
   * accomplishes this.
   *
   * This method should be used in cases where you need to explicitly
   * move the DOM selection from one place to another without a change
   * in ContentState.
   */


  EditorState.forceSelection = function forceSelection(editorState, selection) {
    if (!selection.getHasFocus()) {
      selection = selection.set('hasFocus', true);
    }
    return updateSelection(editorState, selection, true);
  };

  /**
   * Move selection to the end of the editor without forcing focus.
   */


  EditorState.moveSelectionToEnd = function moveSelectionToEnd(editorState) {
    var content = editorState.getCurrentContent();
    var lastBlock = content.getLastBlock();
    var lastKey = lastBlock.getKey();
    var length = lastBlock.getLength();

    return EditorState.acceptSelection(editorState, new SelectionState({
      anchorKey: lastKey,
      anchorOffset: length,
      focusKey: lastKey,
      focusOffset: length,
      isBackward: false
    }));
  };

  /**
   * Force focus to the end of the editor. This is useful in scenarios
   * where we want to programmatically focus the input and it makes sense
   * to allow the user to continue working seamlessly.
   */


  EditorState.moveFocusToEnd = function moveFocusToEnd(editorState) {
    var afterSelectionMove = EditorState.moveSelectionToEnd(editorState);
    return EditorState.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
  };

  /**
   * Push the current ContentState onto the undo stack if it should be
   * considered a boundary state, and set the provided ContentState as the
   * new current content.
   */


  EditorState.push = function push(editorState, contentState, changeType) {
    if (editorState.getCurrentContent() === contentState) {
      return editorState;
    }

    var forceSelection = changeType !== 'insert-characters';
    var directionMap = EditorBidiService.getDirectionMap(contentState, editorState.getDirectionMap());

    if (!editorState.getAllowUndo()) {
      return EditorState.set(editorState, {
        currentContent: contentState,
        directionMap: directionMap,
        lastChangeType: changeType,
        selection: contentState.getSelectionAfter(),
        forceSelection: forceSelection,
        inlineStyleOverride: null
      });
    }

    var selection = editorState.getSelection();
    var currentContent = editorState.getCurrentContent();
    var undoStack = editorState.getUndoStack();
    var newContent = contentState;

    if (selection !== currentContent.getSelectionAfter() || mustBecomeBoundary(editorState, changeType)) {
      undoStack = undoStack.push(currentContent);
      newContent = newContent.set('selectionBefore', selection);
    } else if (changeType === 'insert-characters' || changeType === 'backspace-character' || changeType === 'delete-character') {
      // Preserve the previous selection.
      newContent = newContent.set('selectionBefore', currentContent.getSelectionBefore());
    }

    var inlineStyleOverride = editorState.getInlineStyleOverride();

    // Don't discard inline style overrides for the following change types:
    var overrideChangeTypes = ['adjust-depth', 'change-block-type', 'split-block'];

    if (overrideChangeTypes.indexOf(changeType) === -1) {
      inlineStyleOverride = null;
    }

    var editorStateChanges = {
      currentContent: newContent,
      directionMap: directionMap,
      undoStack: undoStack,
      redoStack: Stack(),
      lastChangeType: changeType,
      selection: contentState.getSelectionAfter(),
      forceSelection: forceSelection,
      inlineStyleOverride: inlineStyleOverride
    };

    return EditorState.set(editorState, editorStateChanges);
  };

  /**
   * Make the top ContentState in the undo stack the new current content and
   * push the current content onto the redo stack.
   */


  EditorState.undo = function undo(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }

    var undoStack = editorState.getUndoStack();
    var newCurrentContent = undoStack.peek();
    if (!newCurrentContent) {
      return editorState;
    }

    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());

    return EditorState.set(editorState, {
      currentContent: newCurrentContent,
      directionMap: directionMap,
      undoStack: undoStack.shift(),
      redoStack: editorState.getRedoStack().push(currentContent),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: 'undo',
      nativelyRenderedContent: null,
      selection: currentContent.getSelectionBefore()
    });
  };

  /**
   * Make the top ContentState in the redo stack the new current content and
   * push the current content onto the undo stack.
   */


  EditorState.redo = function redo(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }

    var redoStack = editorState.getRedoStack();
    var newCurrentContent = redoStack.peek();
    if (!newCurrentContent) {
      return editorState;
    }

    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());

    return EditorState.set(editorState, {
      currentContent: newCurrentContent,
      directionMap: directionMap,
      undoStack: editorState.getUndoStack().push(currentContent),
      redoStack: redoStack.shift(),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: 'redo',
      nativelyRenderedContent: null,
      selection: newCurrentContent.getSelectionAfter()
    });
  };

  /**
   * Not for public consumption.
   */


  function EditorState(immutable) {
    _classCallCheck(this, EditorState);

    this._immutable = immutable;
  }

  /**
   * Not for public consumption.
   */


  EditorState.prototype.getImmutable = function getImmutable() {
    return this._immutable;
  };

  return EditorState;
}();

/**
 * Set the supplied SelectionState as the new current selection, and set
 * the `force` flag to trigger manual selection placement by the view.
 */


function updateSelection(editorState, selection, forceSelection) {
  return EditorState.set(editorState, {
    selection: selection,
    forceSelection: forceSelection,
    nativelyRenderedContent: null,
    inlineStyleOverride: null
  });
}

/**
 * Regenerate the entire tree map for a given ContentState and decorator.
 * Returns an OrderedMap that maps all available ContentBlock objects.
 */
function generateNewTreeMap(contentState, decorator) {
  return contentState.getBlockMap().map(function (block) {
    return BlockTree.generate(contentState, block, decorator);
  }).toOrderedMap();
}

/**
 * Regenerate tree map objects for all ContentBlocks that have changed
 * between the current editorState and newContent. Returns an OrderedMap
 * with only changed regenerated tree map objects.
 */
function regenerateTreeForNewBlocks(editorState, newBlockMap, newEntityMap, decorator) {
  var contentState = editorState.getCurrentContent().set('entityMap', newEntityMap);
  var prevBlockMap = contentState.getBlockMap();
  var prevTreeMap = editorState.getImmutable().get('treeMap');
  return prevTreeMap.merge(newBlockMap.toSeq().filter(function (block, key) {
    return block !== prevBlockMap.get(key);
  }).map(function (block) {
    return BlockTree.generate(contentState, block, decorator);
  }));
}

/**
 * Generate tree map objects for a new decorator object, preserving any
 * decorations that are unchanged from the previous decorator.
 *
 * Note that in order for this to perform optimally, decoration Lists for
 * decorators should be preserved when possible to allow for direct immutable
 * List comparison.
 */
function regenerateTreeForNewDecorator(content, blockMap, previousTreeMap, decorator, existingDecorator) {
  return previousTreeMap.merge(blockMap.toSeq().filter(function (block) {
    return decorator.getDecorations(block, content) !== existingDecorator.getDecorations(block, content);
  }).map(function (block) {
    return BlockTree.generate(content, block, decorator);
  }));
}

/**
 * Return whether a change should be considered a boundary state, given
 * the previous change type. Allows us to discard potential boundary states
 * during standard typing or deletion behavior.
 */
function mustBecomeBoundary(editorState, changeType) {
  var lastChangeType = editorState.getLastChangeType();
  return changeType !== lastChangeType || changeType !== 'insert-characters' && changeType !== 'backspace-character' && changeType !== 'delete-character';
}

function getInlineStyleForCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey);

  // If the cursor is not at the start of the block, look backward to
  // preserve the style of the preceding character.
  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  }

  // The caret is at position zero in this block. If the block has any
  // text at all, use the style of the first character.
  if (startBlock.getLength()) {
    return startBlock.getInlineStyleAt(0);
  }

  // Otherwise, look upward in the document to find the closest character.
  return lookUpwardForInlineStyle(content, startKey);
}

function getInlineStyleForNonCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey);

  // If there is a character just inside the selection, use its style.
  if (startOffset < startBlock.getLength()) {
    return startBlock.getInlineStyleAt(startOffset);
  }

  // Check if the selection at the end of a non-empty block. Use the last
  // style in the block.
  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  }

  // Otherwise, look upward in the document to find the closest character.
  return lookUpwardForInlineStyle(content, startKey);
}

function lookUpwardForInlineStyle(content, fromKey) {
  var lastNonEmpty = content.getBlockMap().reverse().skipUntil(function (_, k) {
    return k === fromKey;
  }).skip(1).skipUntil(function (block, _) {
    return block.getLength();
  }).first();

  if (lastNonEmpty) return lastNonEmpty.getInlineStyleAt(lastNonEmpty.getLength() - 1);
  return OrderedSet();
}

module.exports = EditorState;

/***/ }),
/* 52 */,
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export API_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return API_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return API_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return API_RESET; });
/* unused harmony export APIStatusName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return APIStatus; });
/* harmony export (immutable) */ __webpack_exports__["a"] = createAPIAction;
/* harmony export (immutable) */ __webpack_exports__["b"] = createResetAPIAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(236);



var _APIStatusName;

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



var API_REQUEST = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default()('API_REQUEST');
var API_PENDING = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default()('API_PENDING');
var API_SUCCESS = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default()('API_SUCCESS');
var API_FAILURE = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default()('API_FAILURE');
var API_RESET = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol___default()('API_RESET');

var APIStatusName = (_APIStatusName = {}, _APIStatusName[API_REQUEST] = 'request', _APIStatusName[API_PENDING] = 'pending', _APIStatusName[API_SUCCESS] = 'success', _APIStatusName[API_FAILURE] = 'failure', _APIStatusName[API_RESET] = 'reset', _APIStatusName);

var APIStatus = {
  API_REQUEST: API_REQUEST,
  API_PENDING: API_PENDING,
  API_SUCCESS: API_SUCCESS,
  API_FAILURE: API_FAILURE,
  API_RESET: API_RESET,

  complete: function complete(status) {
    return status === API_SUCCESS || status === API_FAILURE;
  },
  success: function success(status) {
    return status === API_SUCCESS;
  },
  name: function name(status) {
    return APIStatusName[status];
  }
};

function createAPIAction(type, request) {
  var payloadCreator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var metaCreator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

  var apiMetaCreator = function apiMetaCreator() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, metaCreator(args), {
      api: {
        request: request,
        status: API_REQUEST
      }
    });
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */])(type, payloadCreator, apiMetaCreator);
}

function createResetAPIAction(type) {
  var payloadCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var metaCreator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  var apiMetaCreator = function apiMetaCreator() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, metaCreator(args), {
      api: {
        reset: true
      }
    });
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */])(type, payloadCreator, apiMetaCreator);
}

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);








var propTypes = {
  onReload: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  reloading: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool,
  interval: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.number,
  loops: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.number
};

var defaultProps = {
  interval: 6,
  loops: 100,
  reloading: false
};

var Refresher = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Refresher, _React$Component);

  function Refresher(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Refresher);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      pinned: false,
      reloading: props.reloading
    };
    _this.handleReload = _this.handleReload.bind(_this);
    _this.handleReloadPinned = _this.handleReloadPinned.bind(_this);
    return _this;
  }

  Refresher.prototype.componentDidMount = function componentDidMount() {
    this.mounted = true;
  };

  Refresher.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    if (this.props.reloading !== nextProps.reloading) {
      if (this.reloadingTimeout) {
        clearTimeout(this.reloadingTimeout);
      }
      var reloading = nextProps.reloading;
      if (reloading) {
        this.setState({ reloading: reloading });
      } else {
        setTimeout(function () {
          if (_this2.mounted) {
            _this2.setState({ reloading: reloading });
          }
        }, 1000);
      }
    }
  };

  Refresher.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  Refresher.prototype.handleReload = function handleReload(e) {
    e.preventDefault();
    var reloading = this.state.reloading;

    if (!reloading) {
      this.setState({ pinned: false });
      this.props.onReload();
    } else {
      this.handleReloadPinned();
    }
  };

  Refresher.prototype.handleReloadPinned = function handleReloadPinned(e) {
    var _this3 = this;

    if (e) {
      e.preventDefault();
    }
    var _props = this.props,
        interval = _props.interval,
        loops = _props.loops;

    this.setState({
      pinned: true,
      pinnedLoops: 0
    });

    var g = function g() {
      var pinned = _this3.state.pinned;

      if (_this3.mounted && pinned) {
        _this3.props.onReload();
        var _state$pinnedLoops = _this3.state.pinnedLoops,
            pinnedLoops = _state$pinnedLoops === undefined ? 0 : _state$pinnedLoops;

        if (pinnedLoops < loops) {
          _this3.setState({
            pinnedLoops: pinnedLoops + 1
          });
          setTimeout(g, interval * 1000);
        } else {
          _this3.setState({
            pinned: false
          });
        }
      }
    };

    setTimeout(g, interval * 1000);
  };

  Refresher.prototype.render = function render() {
    var _props2 = this.props,
        interval = _props2.interval,
        loops = _props2.loops;
    var _state = this.state,
        reloading = _state.reloading,
        pinned = _state.pinned,
        pinnedLoops = _state.pinnedLoops;

    var icon = 'glyphicons glyphicons-refresh';
    if (pinned) {
      icon = 'glyphicons glyphicons-synchronization';
    }
    if (reloading) {
      icon = icon + " aisz-spin";
    }

    var refresher = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "button",
      {
        onClick: this.handleReload,
        className: "icon",
        styleName: "" + (pinned ? 'btn-link pinned' : 'btn-link')
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: icon })
    );

    if (pinned) {
      var _tooltip = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Tooltip"],
        { id: "refresher-pinned-tooltip" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], { id: "lora.coms.refresher.pinned.tooltip" }),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.progress },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
            className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.progressBar,
            style: {
              width: (loops - pinnedLoops) / loops * 100 + "%"
            }
          })
        )
      );
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["OverlayTrigger"],
        {
          placement: "top",
          overlay: _tooltip,
          trigger: ['hover', 'focus'],
          delayHide: interval * 1000
        },
        refresher
      );
    }

    var tooltip = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Tooltip"],
      { id: "refresher-tooltip" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], { id: "lora.coms.refresher.tooltip" })
    );
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["OverlayTrigger"],
      { placement: "top", overlay: tooltip, delayShow: 1500 },
      refresher
    );
  };

  return Refresher;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Refresher.propTypes = propTypes;
Refresher.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_7_react_css_modules___default()(Refresher, __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a, { allowMultiple: true }))));

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTypesMap;
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

// Action types helper functions

function createTypesMap(context, types) {
  var typesMap = {};
  types.forEach(function (type) {
    typesMap[type] = context + "." + type;
  });
  return typesMap;
}

/***/ }),
/* 60 */,
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_scss__ = __webpack_require__(2132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







var propTypes = {
  options: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.array.isRequired,
  values: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.array.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.bool,
  multiple: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.bool,
  bsSize: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string,
  bsStyle: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string
};

var defaultProps = {
  bsStyle: 'aisz-primary',
  multiple: false,
  disabled: false,
  bsSize: null
};

var InlineSelect = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(InlineSelect, _React$Component);

  function InlineSelect(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, InlineSelect);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      values: props.values,
      disabled: props.disabled
    };
    _this.toggleSelect = _this.toggleSelect.bind(_this);
    return _this;
  }

  InlineSelect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var disabled = nextProps.disabled,
        values = nextProps.values;

    if (disabled !== this.props.disabled) {
      this.setState({ disabled: disabled });
    }
    if (values !== this.props.values) {
      this.setState({ values: values });
    }
  };

  InlineSelect.prototype.active = function active(opt) {
    return this.state.values.some(function (v) {
      return v === opt.value;
    });
  };

  InlineSelect.prototype.toggleSelect = function toggleSelect(value) {
    var _props = this.props,
        _props$multiple = _props.multiple,
        multiple = _props$multiple === undefined ? false : _props$multiple,
        onChange = _props.onChange;
    var values = this.state.values;

    if (multiple) {
      if (values.includes(value)) {
        values = _.filter(values, function (v) {
          return v !== value;
        });
      } else {
        values.push(value);
      }
    } else {
      values = [value];
    }
    onChange(values);
  };

  InlineSelect.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        bsStyle = _props2.bsStyle,
        bsSize = _props2.bsSize,
        options = _props2.options;
    var disabled = this.state.disabled;

    var opts = options.map(function (opt) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
        {
          key: opt.value,
          bsSize: bsSize,
          bsStyle: _this2.active(opt) ? bsStyle : 'aisz-light',
          onClick: function onClick() {
            return _this2.toggleSelect(opt.value);
          },
          disabled: disabled
        },
        opt.label
      );
    });

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.inselect },
      opts
    );
  };

  return InlineSelect;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

InlineSelect.propTypes = propTypes;
InlineSelect.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (InlineSelect);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (immutable) */ __webpack_exports__["c"] = isHexString;
/* harmony export (immutable) */ __webpack_exports__["b"] = isInteger;
/* harmony export (immutable) */ __webpack_exports__["a"] = isNumber;
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

var kHexRegExp = /^[0-9A-Fa-f]+$/;

function isHexString(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var len = options.len,
      pair = options.pair;

  var regExp = kHexRegExp;
  if (len > 0) {
    regExp = new RegExp("^[0-9A-Fa-f]{" + len + "}$");
  }

  var valid = regExp.test(data.replace(/[:-]/g, ''));
  if (pair) {
    valid = valid && data.length % 2 === 0;
  }
  return valid;
}

function isInteger(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var min = options.min,
      max = options.max;

  var num = Number(data);
  if (!_.isInteger(num)) {
    return false;
  }

  if (min && num < min) {
    return false;
  }
  if (max && num > max) {
    return false;
  }

  return true;
}

function isNumber(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var min = options.min,
      max = options.max,
      points = options.points;

  if (!/^[0-9]+(\.[0-9]+)?$/.test(String(data))) {
    return false;
  }

  if (!_.isNil(points)) {
    var _points$min = points.min,
        minPoints = _points$min === undefined ? 0 : _points$min,
        _points$max = points.max,
        maxPoints = _points$max === undefined ? 64 : _points$max;

    var regex = new RegExp("^[0-9]+(.[0-9]{" + minPoints + "," + maxPoints + "})?$");
    if (minPoints > 0) {
      regex = new RegExp("^[0-9]+.[0-9]{" + minPoints + "," + maxPoints + "}$");
    }
    if (!regex.test(String(data))) {
      return false;
    }
  }

  var num = Number(data);
  if (!_.isNumber(num)) {
    return false;
  }

  if (min && num < min) {
    return false;
  }
  if (max && num > max) {
    return false;
  }

  return true;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_default_json__ = __webpack_require__(2389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_default_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_default_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_cloud_json__ = __webpack_require__(2387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_cloud_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config_cloud_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_cube_json__ = __webpack_require__(2388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_cube_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_cube_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json__ = __webpack_require__(2390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_dev_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asciibanner__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asciibanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__asciibanner__);

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







var nodeEnv = "production";
var profile = "cube";
var language = undefined;

var cfg = void 0;

if (nodeEnv === 'production') {
  if (profile === 'cloud') {
    console.log(__WEBPACK_IMPORTED_MODULE_5__asciibanner___default.a.cloud);
    cfg = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__config_default_json___default.a, __WEBPACK_IMPORTED_MODULE_2__config_cloud_json___default.a, {
      profile: profile
    });
  } else if (profile === 'cube') {
    console.log(__WEBPACK_IMPORTED_MODULE_5__asciibanner___default.a.cube);
    console.log('language: ', language || 'multi-lang');
    window.env = 'cube';
    cfg = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__config_default_json___default.a, __WEBPACK_IMPORTED_MODULE_3__config_cube_json___default.a, {
      profile: profile,
      language: language
    });
  }
} else {
  cfg = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__config_default_json___default.a, __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a);
  if (cfg.profile === 'cloud') {
    console.log(__WEBPACK_IMPORTED_MODULE_5__asciibanner___default.a.devCloud);
  } else {
    console.log(__WEBPACK_IMPORTED_MODULE_5__asciibanner___default.a.devCube);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, cfg));

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss__ = __webpack_require__(2149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_scss__);





/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var defaultProps = {
  className: 'aisz-form-control',
  value: '',
  children: null,
  onChange: function onChange() {},
  placeholder: null,
  options: []
};

var propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string,
  value: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.any,
  children: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.any,
  onChange: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func,
  placeholder: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string,
  options: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.array
};

var Select = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Select, _React$Component);

  function Select(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Select);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    var options = props.options;
    if (!options) {
      options = __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.map(props.children, function (c) {
        return {
          value: c.props.value,
          label: String(c.props.children)
        };
      });
    }

    _this.options = options.map(function (opt) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, opt, {
        active: opt.value === props.value
      });
    });

    _this.state = {
      value: props.value
    };
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleSelectOption = _this.handleSelectOption.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  Select.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var value = nextProps.value,
        options = nextProps.options;

    if (value !== this.props.value) {
      this.setState({ value: value });
    }
    if (options !== this.props.options) {
      this.options = options;
    }
  };

  Select.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  };

  Select.prototype.handleInputChange = function handleInputChange(e) {
    var inputLabel = e.target.value;
    var options = void 0;
    if (inputLabel === '') {
      options = this.options;
    } else {
      options = this.options.filter(function (opt) {
        return String(opt.label).toUpperCase().indexOf(inputLabel.toUpperCase()) >= 0;
      });
    }

    this.setState({
      inputLabel: inputLabel,
      options: options,
      open: true
    });
  };

  Select.prototype.handleSelectOption = function handleSelectOption(opt) {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.setState({
      value: opt.value,
      open: false
    });

    var onChange = this.props.onChange;

    if (onChange) {
      onChange(opt.value);
    }
  };

  Select.prototype.handleFocus = function handleFocus() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    var value = this.state.value;

    this.setState({
      options: this.options.map(function (opt) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, opt, {
          active: opt.value === value
        });
      }),
      inputLabel: '',
      open: true
    });
  };

  Select.prototype.handleBlur = function handleBlur() {
    var _this2 = this;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(function () {
      return _this2.setState({ open: false });
    }, 300);
  };

  Select.prototype.handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Enter') {
      var _state = this.state,
          open = _state.open,
          _state$options = _state.options,
          options = _state$options === undefined ? [] : _state$options;

      if (open && options[0]) {
        this.handleSelectOption(options[0]);
      }
    }
  };

  Select.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        children = _props.children,
        _props$className = _props.className,
        className = _props$className === undefined ? 'aisz-form-control' : _props$className,
        placeholder = _props.placeholder,
        s = _props.styles,
        v = _props.value,
        o = _props.options,
        rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ["children", "className", "placeholder", "styles", "value", "options"]);

    var _state2 = this.state,
        value = _state2.value,
        _state2$options = _state2.options,
        options = _state2$options === undefined ? [] : _state2$options,
        _state2$open = _state2.open,
        open = _state2$open === undefined ? false : _state2$open;
    var _state$inputLabel = this.state.inputLabel,
        inputLabel = _state$inputLabel === undefined ? '' : _state$inputLabel;


    if (!open) {
      var currOpt = this.options.find(function (opt) {
        return opt.value === value;
      });
      if (currOpt) {
        inputLabel = currOpt.label;
      }
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.select + " " + (open ? __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.open : '') + " select" },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "select",
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rest, { value: value || '' }),
        children
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("input", {
        className: className,
        value: inputLabel,
        onChange: this.handleInputChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onKeyDown: this.handleKeyDown,
        placeholder: placeholder
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.dropdown },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "ul",
          null,
          options.map(function (opt, idx) {
            var label = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "span",
              null,
              opt.label
            );
            if (opt.formatter) {
              label = opt.formatter(opt.label);
            }
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "li",
              {
                className: (opt.active ? __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.active : '') + " " + (idx === 0 ? __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.hover : ''),
                key: opt.value,
                style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, opt.style)
              },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
                { onClick: function onClick() {
                    return _this3.handleSelectOption(opt);
                  } },
                label
              )
            );
          })
        )
      )
    );
  };

  return Select;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Select.defaultProps = defaultProps;
Select.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss__ = __webpack_require__(2155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var defaultProps = {
  status: 'idle',
  pullRight: false,
  more: false,
  mark: null,
  reset: null
};

var propTypes = {
  more: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool,
  mark: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any,
  status: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string,
  pullRight: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool,
  onNext: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  onPrev: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any
};

var TablePager = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(TablePager, _React$Component);

  function TablePager(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TablePager);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.init(props.more, props.mark, props.status);
    _this.handleNextPage = _this.handleNextPage.bind(_this);
    _this.handlePrevPage = _this.handlePrevPage.bind(_this);
    return _this;
  }

  TablePager.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var mark = nextProps.mark,
        more = nextProps.more,
        _nextProps$status = nextProps.status,
        status = _nextProps$status === undefined ? 'idle' : _nextProps$status,
        reset = nextProps.reset;


    if (reset !== this.props.reset) {
      this.init(more, mark, status);
      return;
    }

    if (mark === this.props.mark && more === this.props.more && status === this.props.status) {
      // no changes, skip it!
      return;
    }

    this.setState({ status: status });
    if (status !== 'success') {
      return;
    }

    if (this.action === 'prev') {
      this.marks = _.dropRight(this.marks, 1);
      this.setState({
        hasPrev: this.marks.length > 1,
        hasNext: more
      });
    } else if (this.action === 'next') {
      if (more) {
        this.marks.push(mark);
      } else {
        this.marks.push('');
      }
      this.setState({
        hasPrev: this.marks.length > 1,
        hasNext: more
      });
    } else {
      // no former action
      if (more) {
        this.marks = [mark];
      } else {
        this.marks = [];
      }
      this.setState({
        hasPrev: false,
        hasNext: more
      });
    }
  };

  TablePager.prototype.init = function init(more, mark, status) {
    this.action = null;
    if (more) {
      this.marks = [mark];
    } else {
      this.marks = [];
    }
    this.state = {
      hasPrev: false,
      hasNext: this.marks.length > 0,
      status: status
    };
  };

  TablePager.prototype.handlePrevPage = function handlePrevPage() {
    this.action = 'prev';
    var mark = '';
    if (this.marks.length > 2) {
      mark = _.last(_.dropRight(this.marks, 2));
    }
    this.props.onPrev(mark);
  };

  TablePager.prototype.handleNextPage = function handleNextPage() {
    this.action = 'next';
    var mark = _.last(this.marks);
    this.props.onNext(mark);
  };

  TablePager.prototype.shouldDisableNext = function shouldDisableNext() {
    var _state = this.state,
        status = _state.status,
        hasNext = _state.hasNext;

    if (status !== 'success' && status !== 'failure') {
      return true;
    }
    return !hasNext;
  };

  TablePager.prototype.shouldDisablePrev = function shouldDisablePrev() {
    var _state2 = this.state,
        status = _state2.status,
        hasPrev = _state2.hasPrev;

    if (status !== 'success' && status !== 'failure') {
      return true;
    }
    return !hasPrev;
  };

  TablePager.prototype.renderPager = function renderPager() {
    var _state3 = this.state,
        status = _state3.status,
        hasNext = _state3.hasNext,
        hasPrev = _state3.hasPrev;

    var nextIcon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-chevron-circle-right" });
    var prevIcon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-chevron-circle-left" });

    if (status === 'loading' || status === 'request') {
      nextIcon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" });
      prevIcon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" });
    }
    if (!hasNext) {
      nextIcon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-circle" });
    }
    if (!hasPrev) {
      prevIcon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-circle" });
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "ul",
      { styleName: "table-pager", className: "list-inline" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "li",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "button",
          {
            styleName: "pager-button",
            onClick: this.handlePrevPage,
            disabled: this.shouldDisablePrev()
          },
          prevIcon
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "li",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "button",
          {
            styleName: "pager-button",
            onClick: this.handleNextPage,
            disabled: this.shouldDisableNext()
          },
          nextIcon
        )
      )
    );
  };

  TablePager.prototype.render = function render() {
    var pullRight = this.props.pullRight;


    if (pullRight) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { styleName: "wrapper-pull-right" },
        this.renderPager()
      );
    }
    return this.renderPager();
  };

  return TablePager;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

TablePager.defaultProps = defaultProps;
TablePager.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_react_css_modules___default()(TablePager, __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1445), __esModule: true };

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_scss__ = __webpack_require__(2121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var defaultProps = {
  checked: false,
  onChange: function onChange() {},
  disabled: false,
  children: null
};

var propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  checked: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func,
  disabled: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool,
  children: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.node
};

var Checkbox = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Checkbox, _React$Component);

  function Checkbox(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Checkbox);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      checked: props.checked,
      disabled: props.disabled
    };
    return _this;
  }

  Checkbox.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var checked = nextProps.checked,
        disabled = nextProps.disabled;

    if (checked !== this.props.checked) {
      this.setState({ checked: checked, disabled: disabled });
    }
    if (disabled !== this.props.disabled) {
      this.setState({ disabled: disabled });
    }
  };

  Checkbox.prototype.render = function render() {
    var _props = this.props,
        id = _props.id,
        _onChange = _props.onChange;
    var _state = this.state,
        checked = _state.checked,
        _state$disabled = _state.disabled,
        disabled = _state$disabled === undefined ? false : _state$disabled;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.checkbox + " " + (disabled ? __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.disabled : '') },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("input", {
        id: id,
        type: "checkbox",
        checked: checked,
        onChange: function onChange(e) {
          return _onChange(e.target.checked);
        },
        disabled: disabled
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("label", { htmlFor: id })
    );
  };

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Checkbox.defaultProps = defaultProps;
Checkbox.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Checkbox);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lorastyles_base_scss__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lorastyles_base_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lorastyles_base_scss__);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var PageLoading = function PageLoading() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: __WEBPACK_IMPORTED_MODULE_1_lorastyles_base_scss___default.a.loading },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin fa-5x" })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (PageLoading);

/***/ }),
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createAPIReducer;
/* harmony export (immutable) */ __webpack_exports__["b"] = combineAPIReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_mapValues__ = __webpack_require__(2506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_api__ = __webpack_require__(53);

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





function defaultStateCreator(api) {
  return {
    data: api.response,
    error: api.error,
    status: __WEBPACK_IMPORTED_MODULE_3__actions_api__["g" /* APIStatus */].name(api.status)
  };
}

/** Simple reducer for API middleware. */
function createAPIReducer(actionType) {
  var stateCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultStateCreator;

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];
    var type = action.type,
        _action$meta = action.meta;
    _action$meta = _action$meta === undefined ? {} : _action$meta;
    var api = _action$meta.api;


    if (type === actionType) {
      if (api.status === __WEBPACK_IMPORTED_MODULE_3__actions_api__["g" /* APIStatus */].API_RESET) {
        return {
          api: api,
          data: undefined,
          error: undefined,
          status: undefined
        };
      } else if (api.status) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          api: api
        }, stateCreator(api));
      }
    }
    return state;
  };
}

/** Simple combine reducers for API middleware. */
function combineAPIReducers(actionTypes) {
  var transformers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var extraReducers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var reducers = __WEBPACK_IMPORTED_MODULE_2_lodash_mapValues___default()(actionTypes, function (at, k) {
    return createAPIReducer(at, transformers[k]);
  });
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* combineReducers */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, reducers, extraReducers));
}

/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss__ = __webpack_require__(2122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







var defaultProps = {
  expanded: true,
  onChange: function onChange() {}
};

var propTypes = {
  expanded: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired
};

var CollapseToggle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(CollapseToggle, _React$Component);

  function CollapseToggle(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CollapseToggle);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      expanded: props.expanded
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'lora.coms.collapsetoggle');
    return _this;
  }

  CollapseToggle.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var expanded = nextProps.expanded;

    if (expanded !== this.props.expanded) {
      this.setState({ expanded: expanded });
    }
  };

  CollapseToggle.prototype.render = function render() {
    var onChange = this.props.onChange;
    var _state$expanded = this.state.expanded,
        expanded = _state$expanded === undefined ? true : _state$expanded;


    var tooltip = void 0;
    var icon = void 0;
    if (expanded) {
      icon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-expand" });
      tooltip = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Tooltip"],
        { id: "tooltip-collapseTogge-collapsed" },
        this.intlMsg.msg('collapse')
      );
    } else {
      icon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-collapse text-warning" });
      tooltip = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Tooltip"],
        { id: "tooltip-collapseTogge-expanded" },
        this.intlMsg.msg('expand')
      );
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["OverlayTrigger"],
      { placement: "top", overlay: tooltip },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "button",
        {
          onClick: function onClick() {
            return onChange(!expanded);
          },
          className: "icon " + __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.btnLink
        },
        icon
      )
    );
  };

  return CollapseToggle;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

CollapseToggle.propTypes = propTypes;
CollapseToggle.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(CollapseToggle));

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss__ = __webpack_require__(2147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_scss__);





/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var defaultProps = {
  placeholder: null
};

var propTypes = {
  onChange: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  placeholder: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string,
  value: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired
};

var SearchInput = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SearchInput, _React$Component);

  function SearchInput(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SearchInput);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      value: props.value
    };
    return _this;
  }

  SearchInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var value = nextProps.value;

    if (value !== this.props.value) {
      this.setState({ value: value });
    }
  };

  SearchInput.prototype.render = function render() {
    var _props = this.props,
        onChange = _props.onChange,
        value = _props.value,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ["onChange", "value"]); // eslint-disable-line


    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      bsClass: "aisz-form-control-o",
      className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.search,
      value: value,
      onChange: onChange
    }, restProps));
  };

  return SearchInput;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

SearchInput.defaultProps = defaultProps;
SearchInput.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (SearchInput);

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(59);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* createTypesMap */])('gateway', ['gateway', 'addGateway', 'updateGateway', 'deleteGateway', 'gatewayData', 'gatewayConf', 'getGateways', 'getGatewayTOAStats', 'getGatewayPktStats', 'getGatewaySFStats', 'getGatewayFreqStats', 'getAppGateway']);

function gateway(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.gateway, {
    endpoint: "/lora/gateways/" + id,
    method: 'GET'
  })();
}

function resetGetGateway() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* createResetAPIAction */])(types.gateway);
}

function addGateway(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.addGateway, {
    endpoint: '/lora/gateways',
    method: 'POST',
    body: data
  })();
}

function deleteGateway(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.deleteGateway, {
    endpoint: "/lora/gateways/" + id,
    method: 'DELETE'
  })();
}

function updateGateway(id, data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.updateGateway, {
    endpoint: "/lora/gateways/" + id,
    method: 'PUT',
    body: data
  })();
}

function resetDeleteGateway() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* createResetAPIAction */])(types.deleteGateway)();
}

function gatewayData(id, args) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.gatewayData, {
    endpoint: "/lora/gateways/" + id + "/samples",
    method: 'GET',
    query: args
  })();
}

function gatewayConf(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.gatewayConf, {
    endpoint: "/lora/gateways/" + id + "/readconf",
    method: 'POST'
  })();
}

function getGateways(args) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getGateways, {
    endpoint: '/lora/gateways',
    query: args
  })();
}

function getGatewayTOAStats(id, args) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getGatewayTOAStats, {
    endpoint: "/lora/gateways/" + id + "/stats/toa",
    query: args
  })();
}

function getGatewayPktStats(id, args) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getGatewayPktStats, {
    endpoint: "/lora/gateways/" + id + "/stats",
    query: args
  })();
}

function getGatewaySFStats(id, args) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getGatewaySFStats, {
    endpoint: "/lora/gateways/" + id + "/stats/sf",
    query: args
  })();
}

function getGatewayFreqStats(id, args) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getGatewayFreqStats, {
    endpoint: "/lora/gateways/" + id + "/stats/freq",
    query: args
  })();
}

function getAppGateway(appid) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getAppGateway, {
    endpoint: "/lora/apps/" + appid + "/gws"
  })();
}

/* harmony default export */ __webpack_exports__["a"] = ({
  gateway: gateway,
  addGateway: addGateway,
  updateGateway: updateGateway,
  deleteGateway: deleteGateway,
  resetGetGateway: resetGetGateway,
  resetDeleteGateway: resetDeleteGateway,
  gatewayData: gatewayData,
  gatewayConf: gatewayConf,
  getGateways: getGateways,
  getGatewayTOAStats: getGatewayTOAStats,
  getGatewayPktStats: getGatewayPktStats,
  getGatewaySFStats: getGatewaySFStats,
  getGatewayFreqStats: getGatewayFreqStats,
  getAppGateway: getAppGateway
});

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_line__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_tooltip__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_title__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_legend__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_grid__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_dataZoom__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_dataZoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_dataZoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_echarts_lib_echarts__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_scss__ = __webpack_require__(2133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);












var kColors = ['#22A7F0', '#00B16A', '#F7CA18', '#F9690E', '#EF4836', '#DB0A5B', '#663399', '#BF55EC', '#446CB3', '#336E7B', '#1BBC9B'];

var defaultProps = {
  title: null,
  legend: [],
  grid: null,
  xAxis: null,
  yAxis: null,
  dataZoom: null,
  tooltip: {},
  resize: null,
  collapsed: false,
  colorShift: 0,
  height: null,
  colors: kColors
};
var propTypes = {
  series: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.array.isRequired,
  categories: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.array.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any,
  legend: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any,
  grid: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any,
  xAxis: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any,
  yAxis: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any,
  dataZoom: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any,
  tooltip: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object,
  colorShift: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.number,
  colors: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.array,
  height: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.number
};

var kyAxis = {
  name: '',
  axisLine: {
    lineStyle: {
      color: '#ABB7B7'
    }
  },
  splitLine: {
    lineStyle: {
      color: ['#ECF0F1', '#DADFE1'],
      type: 'dotted'
    }
  }
};

var LineChart = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LineChart, _React$Component);

  function LineChart(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LineChart);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      series: props.series,
      categories: props.categories,
      legend: props.legend
    };
    _this.tryResizeChart = _this.tryResizeChart.bind(_this);
    return _this;
  }

  LineChart.prototype.componentDidMount = function componentDidMount() {
    this.echart = this.initChart();
    this.echart.resize();
    $(window).resize(this.tryResizeChart);
  };

  LineChart.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var series = nextProps.series,
        categories = nextProps.categories,
        legend = nextProps.legend,
        yAxis = nextProps.yAxis;

    if (series !== this.props.series) {
      this.updateChart(series, categories, legend, yAxis);
      this.setState({
        series: nextProps.series,
        categories: nextProps.categories,
        legend: nextProps.legend
      });
    }
    this.tryResizeChart();
  };

  LineChart.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_11_echarts_lib_echarts___default.a.dispose($(this.chartRef));
    $(window).off('resize', this.tryResizeChart);
  };

  LineChart.prototype.colors = function colors() {
    var _props = this.props,
        colorShift = _props.colorShift,
        colors = _props.colors;

    if (colorShift > 0) {
      return _.concat(_.drop(colors, colorShift), _.take(colors, colorShift));
    }
    return colors;
  };

  LineChart.prototype.tryResizeChart = function tryResizeChart() {
    var width = $(this.chartRef).width();
    var height = $(this.chartRef).height();
    if (height !== this.height || width !== this.width) {
      if (this.echart) {
        this.echart.resize();
      }
    }
    this.width = width;
    this.height = height;
  };

  LineChart.prototype.updateChart = function updateChart(nextSeries, nextCategories, nextLegend, nextyAxis) {
    var thisSeries = this.state.series;

    var series = nextSeries.map(function (s) {
      return _.extend({
        type: 'line'
      }, s);
    });
    var legend = nextLegend || [];
    var yAxis = kyAxis;
    if (nextyAxis) {
      if (_.isArray(nextyAxis)) {
        yAxis = nextyAxis.map(function (ya) {
          return _.extend({}, yAxis, ya);
        });
      } else {
        yAxis = _.extend(yAxis, nextyAxis);
      }
    }
    var option = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.echart.getOption(), {
      yAxis: yAxis,
      series: series,
      legend: legend
    });
    if (nextCategories) {
      option.xAxis = {
        data: nextCategories
      };
    }
    if (!_.isEqual(_.map(thisSeries, 'name'), _.map(nextSeries, 'name'))) {
      // reset option
      this.echart.clear();
    }
    this.echart.setOption(option);
    this.echart.resize();
  };

  LineChart.prototype.initChart = function initChart() {
    var echart = __WEBPACK_IMPORTED_MODULE_11_echarts_lib_echarts___default.a.init(this.chartRef);
    var series = this.state.series.map(function (s) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        name: s.name,
        data: s.data,
        type: 'line',
        lineStyle: {
          normal: {
            width: 2
          }
        },
        areaStyle: {
          normal: {
            opacity: 0.1
          }
        }
      }, s);
    });

    // xAxis
    var xAxis = {
      name: '',
      axisLine: {
        lineStyle: {
          color: '#ABB7B7'
        }
      },
      splitLine: {
        show: false
      },
      axisTick: {
        alignWithLabel: true
      },
      boundaryGap: true
    };
    if (this.props.xAxis) {
      if (_.isArray(this.props.xAxis)) {
        xAxis = this.props.xAxis.map(function (xa) {
          return _.extend({}, xAxis, xa);
        });
      } else {
        xAxis = _.extend(xAxis, this.props.xAxis);
      }
    }

    // yAxis
    var yAxis = kyAxis;
    if (this.props.yAxis) {
      if (_.isArray(this.props.yAxis)) {
        yAxis = this.props.yAxis.map(function (ya) {
          return _.extend({}, yAxis, ya);
        });
      } else {
        yAxis = _.extend(yAxis, this.props.yAxis);
      }
    }

    var _props2 = this.props,
        legend = _props2.legend,
        grid = _props2.grid,
        dataZoom = _props2.dataZoom,
        tooltip = _props2.tooltip,
        title = _props2.title;

    var option = {
      title: title,
      xAxis: xAxis,
      yAxis: yAxis,
      legend: legend,
      series: series,
      dataZoom: dataZoom,
      grid: grid,
      color: this.colors(),
      textStyle: {
        fontSize: 12,
        fontWeight: 300
      },
      tooltip: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        trigger: 'axis'
      }, tooltip),
      animationEasing: 'cubicIn',
      showLoading: true
    };
    if (this.state.categories) {
      option.xAxis.data = this.state.categories;
    }
    echart.setOption(option);
    return echart;
  };

  LineChart.prototype.render = function render() {
    var _this2 = this;

    var height = this.props.height;


    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.chart,
      style: { height: height },
      ref: function ref(_ref) {
        _this2.chartRef = _ref;
      }
    });
  };

  return LineChart;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

LineChart.propTypes = propTypes;
LineChart.defaultProps = defaultProps;

var mapStateToProps = function mapStateToProps(state) {
  return {
    collapsed: state.sidebar.collapsed
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_react_redux__["connect"])(mapStateToProps, null)(LineChart));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss__ = __webpack_require__(2140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var defaultProps = {
  tools: [' ']
};

var propTypes = {
  tools: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.array.isRequired
};

var PanelToolbar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PanelToolbar, _React$Component);

  function PanelToolbar(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PanelToolbar);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      collapsed: false
    };
    return _this;
  }

  PanelToolbar.prototype.render = function render() {
    var _this2 = this;

    var collapsed = this.state.collapsed;

    var tools = this.props.tools.map(function (tool, idx) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "li",
        { key: String(idx) },
        tool
      );
    });
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.toolbar + " " + (collapsed ? __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.collapsed : '') },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "ul",
        { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.tools },
        tools
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_router__["f" /* Link */],
        {
          className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.toggle,
          onClick: function onClick() {
            _this2.setState({ collapsed: !collapsed });
          }
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-caret-left " + __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.arrow })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", { style: { clear: 'both' } })
    );
  };

  return PanelToolbar;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

PanelToolbar.defaultProps = defaultProps;
PanelToolbar.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (PanelToolbar);

/***/ }),
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftModifier
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(117);
var ContentStateInlineStyle = __webpack_require__(1811);
var DraftFeatureFlags = __webpack_require__(190);
var Immutable = __webpack_require__(45);

var applyEntityToContentState = __webpack_require__(1830);
var getCharacterRemovalRange = __webpack_require__(1851);
var getContentStateFragment = __webpack_require__(372);
var insertFragmentIntoContentState = __webpack_require__(1856);
var insertTextIntoContentState = __webpack_require__(1857);
var invariant = __webpack_require__(23);
var modifyBlockForContentState = __webpack_require__(1868);
var removeEntitiesAtEdges = __webpack_require__(770);
var removeRangeFromContentState = __webpack_require__(1870);
var splitBlockInContentState = __webpack_require__(1872);

var OrderedSet = Immutable.OrderedSet;

/**
 * `DraftModifier` provides a set of convenience methods that apply
 * modifications to a `ContentState` object based on a target `SelectionState`.
 *
 * Any change to a `ContentState` should be decomposable into a series of
 * transaction functions that apply the required changes and return output
 * `ContentState` objects.
 *
 * These functions encapsulate some of the most common transaction sequences.
 */

var DraftModifier = {
  replaceText: function replaceText(contentState, rangeToReplace, text, inlineStyle, entityKey) {
    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToReplace);
    var withoutText = removeRangeFromContentState(withoutEntities, rangeToReplace);

    var character = CharacterMetadata.create({
      style: inlineStyle || OrderedSet(),
      entity: entityKey || null
    });

    return insertTextIntoContentState(withoutText, withoutText.getSelectionAfter(), text, character);
  },

  insertText: function insertText(contentState, targetRange, text, inlineStyle, entityKey) {
    !targetRange.isCollapsed() ?  false ? invariant(false, 'Target range must be collapsed for `insertText`.') : invariant(false) : void 0;
    return DraftModifier.replaceText(contentState, targetRange, text, inlineStyle, entityKey);
  },

  moveText: function moveText(contentState, removalRange, targetRange) {
    var movedFragment = getContentStateFragment(contentState, removalRange);

    var afterRemoval = DraftModifier.removeRange(contentState, removalRange, 'backward');

    return DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
  },

  replaceWithFragment: function replaceWithFragment(contentState, targetRange, fragment) {
    var withoutEntities = removeEntitiesAtEdges(contentState, targetRange);
    var withoutText = removeRangeFromContentState(withoutEntities, targetRange);

    return insertFragmentIntoContentState(withoutText, withoutText.getSelectionAfter(), fragment);
  },

  removeRange: function removeRange(contentState, rangeToRemove, removalDirection) {
    var startKey = void 0,
        endKey = void 0,
        startBlock = void 0,
        endBlock = void 0;
    if (rangeToRemove.getIsBackward()) {
      rangeToRemove = rangeToRemove.merge({
        anchorKey: rangeToRemove.getFocusKey(),
        anchorOffset: rangeToRemove.getFocusOffset(),
        focusKey: rangeToRemove.getAnchorKey(),
        focusOffset: rangeToRemove.getAnchorOffset(),
        isBackward: false
      });
    }
    startKey = rangeToRemove.getAnchorKey();
    endKey = rangeToRemove.getFocusKey();
    startBlock = contentState.getBlockForKey(startKey);
    endBlock = contentState.getBlockForKey(endKey);
    var startOffset = rangeToRemove.getStartOffset();
    var endOffset = rangeToRemove.getEndOffset();

    var startEntityKey = startBlock.getEntityAt(startOffset);
    var endEntityKey = endBlock.getEntityAt(endOffset - 1);

    // Check whether the selection state overlaps with a single entity.
    // If so, try to remove the appropriate substring of the entity text.
    if (startKey === endKey) {
      if (startEntityKey && startEntityKey === endEntityKey) {
        var _adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
        return removeRangeFromContentState(contentState, _adjustedRemovalRange);
      }
    }
    var adjustedRemovalRange = rangeToRemove;
    if (DraftFeatureFlags.draft_segmented_entities_behavior) {
      // Adjust the selection to properly delete segemented and immutable
      // entities
      adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
    }

    var withoutEntities = removeEntitiesAtEdges(contentState, adjustedRemovalRange);
    return removeRangeFromContentState(withoutEntities, adjustedRemovalRange);
  },

  splitBlock: function splitBlock(contentState, selectionState) {
    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
    var withoutText = removeRangeFromContentState(withoutEntities, selectionState);

    return splitBlockInContentState(withoutText, withoutText.getSelectionAfter());
  },

  applyInlineStyle: function applyInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle.add(contentState, selectionState, inlineStyle);
  },

  removeInlineStyle: function removeInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle.remove(contentState, selectionState, inlineStyle);
  },

  setBlockType: function setBlockType(contentState, selectionState, blockType) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({ type: blockType, depth: 0 });
    });
  },

  setBlockData: function setBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({ data: blockData });
    });
  },

  mergeBlockData: function mergeBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({ data: block.getData().merge(blockData) });
    });
  },

  applyEntity: function applyEntity(contentState, selectionState, entityKey) {
    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
    return applyEntityToContentState(withoutEntities, selectionState, entityKey);
  }
};

module.exports = DraftModifier;

/***/ }),
/* 108 */,
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MonthCalendar__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss__ = __webpack_require__(2124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var FORMAT = {
  zh: 'YYYY-MM-DD',
  en: 'DD/MM/YYYY'
};

var defaultProps = {
  date: new Date(),
  view: 'date',
  closeOnSelect: true,
  disabled: function disabled(d) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["isAfter"])(d, new Date());
  },
  anchor: null
};

var propTypes = {
  date: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.instanceOf(Date),
  view: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.oneOf(['year', 'month', 'date']),
  onSelect: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  locale: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.oneOfType([__WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.arrayOf(__WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.instanceOf(Date)), __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func]),
  closeOnSelect: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool,
  anchor: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.instanceOf(Date)
};

var DatePicker = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DatePicker, _React$Component);

  function DatePicker(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DatePicker);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      date: props.date,
      view: props.view,
      disabled: props.disabled,
      anchor: props.anchor
    };
    _this.id = "datepicker_" + Number(Math.random() * 10000).toFixed(0);
    _this.handleInputFocus = _this.handleInputFocus.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleInputBlur = _this.handleInputBlur.bind(_this);
    _this.handleSelect = _this.handleSelect.bind(_this);
    _this.clickToBlur = _this.clickToBlur.bind(_this);
    _this.inputChanged = false;
    return _this;
  }

  DatePicker.prototype.componentDidMount = function componentDidMount() {
    $('body').click(this.clickToBlur);
  };

  DatePicker.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var date = nextProps.date,
        view = nextProps.view,
        disabled = nextProps.disabled,
        anchor = nextProps.anchor;

    if (date !== this.props.date) {
      this.setState({ date: date });
    }
    if (view !== this.props.view) {
      this.setState({ view: view });
    }
    if (disabled !== this.props.disabled) {
      this.setState({ disabled: disabled });
    }
    if (anchor !== this.props.anchor) {
      this.setState({ anchor: anchor });
    }
  };

  DatePicker.prototype.componentWillUnmount = function componentWillUnmount() {
    $('body').off('click', this.clickToBlur);
  };

  DatePicker.prototype.clickToBlur = function clickToBlur(e) {
    var _this2 = this;

    var blurred = true;
    $(e.target).parents().each(function (idx, elem) {
      if (elem.id === _this2.id) {
        blurred = false;
      }
    });
    if (blurred) {
      this.setState({ showOverlay: false });
    }
  };

  DatePicker.prototype.handleInputFocus = function handleInputFocus() {
    this.setState({ showOverlay: true });
  };

  DatePicker.prototype.handleInputChange = function handleInputChange(e) {
    var value = e.target.value.trim();
    this.setState({ value: value });
    var date = new Date(value);
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["isValid"])(date)) {
      this.inputChanged = true;
      this.setState({ date: date });
    }
  };

  DatePicker.prototype.handleInputBlur = function handleInputBlur() {
    if (this.inputChanged) {
      var onSelect = this.props.onSelect;
      var date = this.state.date;

      onSelect(date);
      this.inputChanged = false;
    }
  };

  DatePicker.prototype.handleSelect = function handleSelect(date) {
    var _props = this.props,
        onSelect = _props.onSelect,
        closeOnSelect = _props.closeOnSelect;

    this.setState({ value: '' });
    onSelect(date);
    if (closeOnSelect) {
      this.setState({ showOverlay: false });
    }
  };

  DatePicker.prototype.renderView = function renderView() {
    var _state = this.state,
        _state$view = _state.view,
        view = _state$view === undefined ? 'date' : _state$view,
        date = _state.date,
        disabled = _state.disabled,
        anchor = _state.anchor;


    if (view === 'date') {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__MonthCalendar__["a" /* default */], {
        year: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["getYear"])(date),
        month: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["getMonth"])(date),
        selected: date,
        onSelect: this.handleSelect,
        disabled: disabled,
        anchor: anchor
      });
    }
    return null;
  };

  DatePicker.prototype.renderOverlay = function renderOverlay() {
    if (this.state.showOverlay) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.overlay },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.container },
          this.renderView()
        )
      );
    }
    return null;
  };

  DatePicker.prototype.render = function render() {
    var locale = this.props.locale;
    var _state2 = this.state,
        date = _state2.date,
        _state2$value = _state2.value,
        value = _state2$value === undefined ? '' : _state2$value;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { id: this.id, className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.datepicker },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["FormControl"], {
        bsClass: "aisz-form-control-f",
        type: "text",
        placeholder: FORMAT[locale],
        value: value || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["format"])(date, FORMAT[locale]),
        onFocus: this.handleInputFocus,
        onBlur: this.handleInputBlur,
        onChange: this.handleInputChange
      }),
      this.renderOverlay()
    );
  };

  return DatePicker;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DatePicker.propTypes = propTypes;
DatePicker.defaultProps = defaultProps;

var mapStateToProps = function mapStateToProps(state) {
  return {
    locale: state.intl.locale
  };
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, null)(DatePicker)));

/***/ }),
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CharacterMetadata
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = __webpack_require__(45),
    Map = _require.Map,
    OrderedSet = _require.OrderedSet,
    Record = _require.Record;

// Immutable.map is typed such that the value for every key in the map
// must be the same type


var EMPTY_SET = OrderedSet();

var defaultRecord = {
  style: EMPTY_SET,
  entity: null
};

var CharacterMetadataRecord = Record(defaultRecord);

var CharacterMetadata = function (_CharacterMetadataRec) {
  _inherits(CharacterMetadata, _CharacterMetadataRec);

  function CharacterMetadata() {
    _classCallCheck(this, CharacterMetadata);

    return _possibleConstructorReturn(this, _CharacterMetadataRec.apply(this, arguments));
  }

  CharacterMetadata.prototype.getStyle = function getStyle() {
    return this.get('style');
  };

  CharacterMetadata.prototype.getEntity = function getEntity() {
    return this.get('entity');
  };

  CharacterMetadata.prototype.hasStyle = function hasStyle(style) {
    return this.getStyle().includes(style);
  };

  CharacterMetadata.applyStyle = function applyStyle(record, style) {
    var withStyle = record.set('style', record.getStyle().add(style));
    return CharacterMetadata.create(withStyle);
  };

  CharacterMetadata.removeStyle = function removeStyle(record, style) {
    var withoutStyle = record.set('style', record.getStyle().remove(style));
    return CharacterMetadata.create(withoutStyle);
  };

  CharacterMetadata.applyEntity = function applyEntity(record, entityKey) {
    var withEntity = record.getEntity() === entityKey ? record : record.set('entity', entityKey);
    return CharacterMetadata.create(withEntity);
  };

  /**
   * Use this function instead of the `CharacterMetadata` constructor.
   * Since most content generally uses only a very small number of
   * style/entity permutations, we can reuse these objects as often as
   * possible.
   */


  CharacterMetadata.create = function create(config) {
    if (!config) {
      return EMPTY;
    }

    var defaultConfig = {
      style: EMPTY_SET,
      entity: null
    };

    // Fill in unspecified properties, if necessary.
    var configMap = Map(defaultConfig).merge(config);

    var existing = pool.get(configMap);
    if (existing) {
      return existing;
    }

    var newCharacter = new CharacterMetadata(configMap);
    pool = pool.set(configMap, newCharacter);
    return newCharacter;
  };

  return CharacterMetadata;
}(CharacterMetadataRecord);

var EMPTY = new CharacterMetadata();
var pool = Map([[Map(defaultRecord), EMPTY]]);

CharacterMetadata.EMPTY = EMPTY;

module.exports = CharacterMetadata;

/***/ }),
/* 118 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 119 */,
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(59);

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* createTypesMap */])('app', ['getApps', 'getApp', 'updateApp', 'deleteApp', 'getTokens']);

function getApp(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* createAPIAction */])(types.getApp, {
    endpoint: "/lora/applications/" + id
  })();
}

function updateApp(id, data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* createAPIAction */])(types.updateApp, {
    endpoint: "/lora/applications/" + id,
    body: data,
    method: 'PUT'
  })();
}

function getApps(args) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* createAPIAction */])(types.getApps, {
    endpoint: '/lora/applications',
    query: args
  })();
}

function deleteApp(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* createAPIAction */])(types.deleteApp, {
    endpoint: "/lora/applications/" + id,
    method: 'DELETE'
  })();
}

function getTokens(id, args) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* createAPIAction */])(types.getTokens, {
    endpoint: '/tokens',
    query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, args, {
      bind: id
    })
  })();
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getApps: getApps,
  getApp: getApp,
  updateApp: updateApp,
  deleteApp: deleteApp,
  getTokens: getTokens
});

/***/ }),
/* 121 */,
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentBlockNode
 * @format
 * 
 *
 * This file is a fork of ContentBlock adding support for nesting references by
 * providing links to children, parent, prevSibling, and nextSibling.
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CharacterMetadata = __webpack_require__(117);
var Immutable = __webpack_require__(45);

var findRangesImmutable = __webpack_require__(300);

var List = Immutable.List,
    Map = Immutable.Map,
    OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat;


var EMPTY_SET = OrderedSet();

var defaultRecord = {
  parent: null,
  characterList: List(),
  data: Map(),
  depth: 0,
  key: '',
  text: '',
  type: 'unstyled',
  children: List(),
  prevSibling: null,
  nextSibling: null
};

var haveEqualStyle = function haveEqualStyle(charA, charB) {
  return charA.getStyle() === charB.getStyle();
};

var haveEqualEntity = function haveEqualEntity(charA, charB) {
  return charA.getEntity() === charB.getEntity();
};

var decorateCharacterList = function decorateCharacterList(config) {
  if (!config) {
    return config;
  }

  var characterList = config.characterList,
      text = config.text;


  if (text && !characterList) {
    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
  }

  return config;
};

var ContentBlockNode = function (_Record) {
  _inherits(ContentBlockNode, _Record);

  function ContentBlockNode() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultRecord;

    _classCallCheck(this, ContentBlockNode);

    return _possibleConstructorReturn(this, _Record.call(this, decorateCharacterList(props)));
  }

  ContentBlockNode.prototype.getKey = function getKey() {
    return this.get('key');
  };

  ContentBlockNode.prototype.getType = function getType() {
    return this.get('type');
  };

  ContentBlockNode.prototype.getText = function getText() {
    return this.get('text');
  };

  ContentBlockNode.prototype.getCharacterList = function getCharacterList() {
    return this.get('characterList');
  };

  ContentBlockNode.prototype.getLength = function getLength() {
    return this.getText().length;
  };

  ContentBlockNode.prototype.getDepth = function getDepth() {
    return this.get('depth');
  };

  ContentBlockNode.prototype.getData = function getData() {
    return this.get('data');
  };

  ContentBlockNode.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET;
  };

  ContentBlockNode.prototype.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  };

  ContentBlockNode.prototype.getChildKeys = function getChildKeys() {
    return this.get('children');
  };

  ContentBlockNode.prototype.getParentKey = function getParentKey() {
    return this.get('parent');
  };

  ContentBlockNode.prototype.getPrevSiblingKey = function getPrevSiblingKey() {
    return this.get('prevSibling');
  };

  ContentBlockNode.prototype.getNextSiblingKey = function getNextSiblingKey() {
    return this.get('nextSibling');
  };

  ContentBlockNode.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
  };

  ContentBlockNode.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
  };

  return ContentBlockNode;
}(Record(defaultRecord));

module.exports = ContentBlockNode;

/***/ }),
/* 123 */,
/* 124 */,
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__VdeV4","wrapper-nopadding":"wrapper-nopadding__1NjzB","loading":"loading__1SzbK","error":"error__1jGF_","table-loading":"table-loading__30A4f","empty-val":"empty-val__CxEJN","panelheader-tools":"panelheader-tools__2OZES","propsPanels":"propsPanels__3_FJx","new":"new___83si","marginLm":"marginLm__mQ6V-","marginRm":"marginRm__OvW_i","fullWidth":"fullWidth__11XOX","fullHeight":"fullHeight__2ITy5","noData":"noData__1fjXU","tdm":"tdm__32_3X","content":"content__pxkqG","addBtn":"addBtn__2UQYD","deleteBtn":"deleteBtn__36I0k","net":"net__1Hl5P","clearRight":"clearRight__1oZiS","pager":"pager__2G_at","white":"white__1MtZA","pairs":"pairs__cFDJq","header":"header__1cvcI","body":"body__9aFgU","pair":"pair__1alLI","remove":"remove__2kbud","input":"input__36Vwj","empty":"empty__33rSv","help":"help__1lnwI","auto":"auto__12_jA","waring":"waring__1WGEd","fileName":"fileName___9KeH","uploadSuccess":"uploadSuccess__1qmEI","uploadFail":"uploadFail__kwkI8","searchIpt":"searchIpt__P6DWx","resetGateway":"resetGateway___vZyn"};

/***/ }),
/* 126 */,
/* 127 */,
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNil__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_Select__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_scss__ = __webpack_require__(2127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var defaultProps = {
  edit: false,
  control: {},
  formatter: function formatter(x) {
    if (__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(x)) return x;
    if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(x)) return x;
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "span",
      null,
      x
    );
  },
  validator: function validator() {
    return { valid: true };
  },
  visible: true,
  value: null,
  error: null,
  errorPlacement: 'top',
  onChange: function onChange() {},
  data: {}
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  edit: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.bool.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any,
  data: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object,
  onChange: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func,
  control: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object,
  error: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.node,
  formatter: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func,
  errorPlacement: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string
};

var Editable = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Editable, _React$Component);

  function Editable(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Editable);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      value: props.value,
      edit: props.edit,
      data: props.data,
      error: props.error,
      ctrlval: props.data[props.id]
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.intlMsg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(props.intl, '');
    return _this;
  }

  Editable.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var id = nextProps.id,
        value = nextProps.value,
        edit = nextProps.edit,
        data = nextProps.data,
        error = nextProps.error,
        control = nextProps.control;


    if (value !== this.props.value) {
      this.setState({ value: value });
    }
    if (edit !== this.props.edit) {
      this.setState({ edit: edit });
    }
    if (data !== this.props.data) {
      this.setState({ data: data });
      var _control$formatter = control.formatter,
          formatter = _control$formatter === undefined ? function (x) {
        return x;
      } : _control$formatter;
      var ctrlval = this.state.ctrlval;

      if (formatter(data[id]) !== ctrlval) {
        this.setState({ ctrlval: formatter(data[id]) });
      }
    }
    if (error !== this.props.error) {
      this.setState({ error: error });
    }
  };

  Editable.prototype.handleChange = function handleChange(v) {
    var _extends2;

    var _props = this.props,
        id = _props.id,
        onChange = _props.onChange,
        _props$control = _props.control,
        _props$control$format = _props$control.formatter,
        formatter = _props$control$format === undefined ? function (x) {
      return x;
    } : _props$control$format,
        _props$control$decode = _props$control.decoder,
        decoder = _props$control$decode === undefined ? function (x) {
      return x;
    } : _props$control$decode;

    var ctrlval = formatter(v);
    var data = this.state.data;


    this.setState({ ctrlval: ctrlval });
    data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, (_extends2 = {}, _extends2[id] = decoder(ctrlval), _extends2));
    onChange(data, id);
  };

  Editable.prototype.renderControl = function renderControl() {
    var _this2 = this;

    var control = this.props.control;
    var ctrlval = this.state.ctrlval;
    var type = control.type;


    if (type === 'external') {
      return control.external;
    }

    var ctrl = void 0;
    if (type === 'select') {
      ctrl = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_Select__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, control, {
        value: ctrlval,
        onChange: function onChange(v) {
          return _this2.handleChange(v);
        }
      }));
    } else {
      var placeholder = control.placeholder,
          _control$className = control.className,
          className = _control$className === undefined ? 'aisz-form-control' : _control$className;

      ctrl = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormControl"], {
        bsClass: className,
        value: ctrlval,
        placeholder: placeholder,
        onChange: function onChange(e) {
          return _this2.handleChange(e.target.value);
        }
      });
    }

    var error = this.state.error;
    var errorPlacement = this.props.errorPlacement;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.editable },
      ctrl,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
        show: !__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(error),
        azStyle: "danger",
        placement: errorPlacement,
        message: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-exclamation-circle" }),
          ' ',
          error
        )
      })
    );
  };

  Editable.prototype.render = function render() {
    var formatter = this.props.formatter;
    var _state = this.state,
        value = _state.value,
        edit = _state.edit;

    if (edit) {
      return this.renderControl();
    }
    return formatter(value);
  };

  return Editable;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Editable.defaultProps = defaultProps;
Editable.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(Editable));

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_loracfg__ = __webpack_require__(65);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



var HideIf = function HideIf(props) {
  var hide = false;
  var condition = props.if;
  if (_.isString(condition)) {
    var _condition$split$map = condition.split(':').map(function (s) {
      return s.trim();
    }),
        key = _condition$split$map[0],
        value = _condition$split$map[1];

    if (key === 'profile' && __WEBPACK_IMPORTED_MODULE_0_loracfg__["a" /* default */].profile === value) {
      hide = true;
    }
  } else if (_.isFunction(condition)) {
    hide = condition();
  } else {
    hide = condition;
  }

  if (hide) {
    return null;
  }
  return props.children;
};

/* harmony default export */ __webpack_exports__["a"] = (HideIf);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_scss__ = __webpack_require__(2134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_scss__);

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var LoadingTable = function LoadingTable(props) {
  var rows = props.rows,
      children = props.children,
      cols = props.cols,
      restProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(props, ["rows", "children", "cols"]);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["Table"],
    restProps,
    children,
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      "tbody",
      null,
      _.range(rows).map(function (idx) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "tr",
          { key: String(idx) },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "td",
            { colSpan: cols },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.loadingBar })
          )
        );
      })
    )
  );
};

LoadingTable.defaultProps = {
  children: null,
  rows: 10
};
LoadingTable.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.node,
  rows: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.number,
  cols: __WEBPACK_IMPORTED_MODULE_1_react___default.a.PropTypes.number.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (LoadingTable);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss__ = __webpack_require__(2138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);








var defaultProps = {
  description: null
};
var propTypes = {
  description: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.node,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var PageNoPerm = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PageNoPerm, _React$Component);

  function PageNoPerm(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PageNoPerm);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {};
    return _this;
  }

  PageNoPerm.prototype.render = function render() {
    var pushState = this.props.pushState;
    var description = this.props.description;

    if (_.isNil(description)) {
      description = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["FormattedMessage"], {
          id: "lora.noperm.undercomm.trial",
          defaultMessage: "lora.noperm.undercomm.trial"
        }),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_router__["f" /* Link */],
          { onClick: function onClick() {
              return pushState('/billing');
            }, className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.upgrade },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["FormattedMessage"], {
            id: "lora.noperm.undercomm.upgrade",
            defaultMessage: "lora.noperm.undercomm.upgrade"
          }),
          ' ',
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-arrow-circle-o-up" })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["FormattedMessage"], {
          id: "lora.noperm.undercomm.upgradeto",
          defaultMessage: "lora.noperm.undercomm.upgradeto"
        })
      );
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.noperm },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "h5",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-eye-slash" })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "h5",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["FormattedMessage"], {
          id: "lora.noperm",
          defaultMessage: "lora.noperm"
        })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.desc },
        description
      )
    );
  };

  return PageNoPerm;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

PageNoPerm.propTypes = propTypes;
PageNoPerm.defaultProps = defaultProps;

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(PageNoPerm)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var nullthrows = function nullthrows(x) {
  if (x != null) {
    return x;
  }
  throw new Error("Got unexpected null or undefined");
};

module.exports = nullthrows;

/***/ }),
/* 137 */,
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(59);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* createTypesMap */])('dashboard', ['getTimes', 'getDeveui', 'getDashboard', 'getDps', 'getRefreshCount', 'getGpsColor']);

var getTimes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(types.getTimes, function (times) {
  return times;
});
var getDeveui = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(types.getDeveui, function (deveuis) {
  return deveuis;
});
var getDps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(types.getDps, function (dps) {
  return dps;
});
var getRefreshCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(types.getRefreshCount, function (count) {
  return count;
});
var getGpsColor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(types.getGpsColor, function (colors) {
  return colors;
});

function getDashboard(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* createAPIAction */])(types.getDashboard, {
    endpoint: "/lora/dashboards/" + id,
    method: 'GET'
  })();
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getTimes: getTimes,
  getDeveui: getDeveui,
  getDashboard: getDashboard,
  getDps: getDps,
  getRefreshCount: getRefreshCount,
  getGpsColor: getGpsColor
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (immutable) */ __webpack_exports__["a"] = compactFormat;
/* unused harmony export formatTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_start_of_day__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_start_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_start_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_start_of_year__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_start_of_year___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_start_of_year__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_is_valid__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_is_valid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_is_valid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_is_before__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_is_before___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_is_before__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_format__);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







function compactFormat(dt) {
  var d = new Date(dt);
  if (!__WEBPACK_IMPORTED_MODULE_2_date_fns_is_valid___default()(d)) {
    return "";
  }
  var now = new Date();
  var sod = __WEBPACK_IMPORTED_MODULE_0_date_fns_start_of_day___default()(now);
  var soy = __WEBPACK_IMPORTED_MODULE_1_date_fns_start_of_year___default()(now);
  if (__WEBPACK_IMPORTED_MODULE_3_date_fns_is_before___default()(d, soy)) {
    return __WEBPACK_IMPORTED_MODULE_4_date_fns_format___default()(d, "YY-MM-DD HH:mm:ss");
  } else if (__WEBPACK_IMPORTED_MODULE_3_date_fns_is_before___default()(d, sod)) {
    return __WEBPACK_IMPORTED_MODULE_4_date_fns_format___default()(d, "MM-DD HH:mm:ss");
  }
  return __WEBPACK_IMPORTED_MODULE_4_date_fns_format___default()(d, "HH:mm:ss");
}

var formatTime = function formatTime(timestamp) {
  var withSecond = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var today = new Date();
  if (_.isNil(timestamp)) return "";

  var timeFormat = withSecond ? "HH:mm:ss" : "HH:mm";
  if (isSameYear(today, timestamp)) {
    return __WEBPACK_IMPORTED_MODULE_4_date_fns_format___default()(timestamp, "MM-DD " + timeFormat);
  }
  return __WEBPACK_IMPORTED_MODULE_4_date_fns_format___default()(timestamp, "YYYY-MM-DD " + timeFormat);
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var UserAgentData = __webpack_require__(2331);
var VersionRange = __webpack_require__(2332);

var mapObject = __webpack_require__(2345);
var memoizeStringOnly = __webpack_require__(843);

/**
 * Checks to see whether `name` and `version` satisfy `query`.
 *
 * @param {string} name Name of the browser, device, engine or platform
 * @param {?string} version Version of the browser, engine or platform
 * @param {string} query Query of form "Name [range expression]"
 * @param {?function} normalizer Optional pre-processor for range expression
 * @return {boolean}
 */
function compare(name, version, query, normalizer) {
  // check for exact match with no version
  if (name === query) {
    return true;
  }

  // check for non-matching names
  if (!query.startsWith(name)) {
    return false;
  }

  // full comparison with version
  var range = query.slice(name.length);
  if (version) {
    range = normalizer ? normalizer(range) : range;
    return VersionRange.contains(range, version);
  }

  return false;
}

/**
 * Normalizes `version` by stripping any "NT" prefix, but only on the Windows
 * platform.
 *
 * Mimics the stripping performed by the `UserAgentWindowsPlatform` PHP class.
 *
 * @param {string} version
 * @return {string}
 */
function normalizePlatformVersion(version) {
  if (UserAgentData.platformName === 'Windows') {
    return version.replace(/^\s*NT/, '');
  }

  return version;
}

/**
 * Provides client-side access to the authoritative PHP-generated User Agent
 * information supplied by the server.
 */
var UserAgent = {
  /**
   * Check if the User Agent browser matches `query`.
   *
   * `query` should be a string like "Chrome" or "Chrome > 33".
   *
   * Valid browser names include:
   *
   * - ACCESS NetFront
   * - AOL
   * - Amazon Silk
   * - Android
   * - BlackBerry
   * - BlackBerry PlayBook
   * - Chrome
   * - Chrome for iOS
   * - Chrome frame
   * - Facebook PHP SDK
   * - Facebook for iOS
   * - Firefox
   * - IE
   * - IE Mobile
   * - Mobile Safari
   * - Motorola Internet Browser
   * - Nokia
   * - Openwave Mobile Browser
   * - Opera
   * - Opera Mini
   * - Opera Mobile
   * - Safari
   * - UIWebView
   * - Unknown
   * - webOS
   * - etc...
   *
   * An authoritative list can be found in the PHP `BrowserDetector` class and
   * related classes in the same file (see calls to `new UserAgentBrowser` here:
   * https://fburl.com/50728104).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isBrowser: function isBrowser(query) {
    return compare(UserAgentData.browserName, UserAgentData.browserFullVersion, query);
  },


  /**
   * Check if the User Agent browser uses a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isBrowserArchitecture: function isBrowserArchitecture(query) {
    return compare(UserAgentData.browserArchitecture, null, query);
  },


  /**
   * Check if the User Agent device matches `query`.
   *
   * `query` should be a string like "iPhone" or "iPad".
   *
   * Valid device names include:
   *
   * - Kindle
   * - Kindle Fire
   * - Unknown
   * - iPad
   * - iPhone
   * - iPod
   * - etc...
   *
   * An authoritative list can be found in the PHP `DeviceDetector` class and
   * related classes in the same file (see calls to `new UserAgentDevice` here:
   * https://fburl.com/50728332).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name"
   * @return {boolean}
   */
  isDevice: function isDevice(query) {
    return compare(UserAgentData.deviceName, null, query);
  },


  /**
   * Check if the User Agent rendering engine matches `query`.
   *
   * `query` should be a string like "WebKit" or "WebKit >= 537".
   *
   * Valid engine names include:
   *
   * - Gecko
   * - Presto
   * - Trident
   * - WebKit
   * - etc...
   *
   * An authoritative list can be found in the PHP `RenderingEngineDetector`
   * class related classes in the same file (see calls to `new
   * UserAgentRenderingEngine` here: https://fburl.com/50728617).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isEngine: function isEngine(query) {
    return compare(UserAgentData.engineName, UserAgentData.engineVersion, query);
  },


  /**
   * Check if the User Agent platform matches `query`.
   *
   * `query` should be a string like "Windows" or "iOS 5 - 6".
   *
   * Valid platform names include:
   *
   * - Android
   * - BlackBerry OS
   * - Java ME
   * - Linux
   * - Mac OS X
   * - Mac OS X Calendar
   * - Mac OS X Internet Account
   * - Symbian
   * - SymbianOS
   * - Windows
   * - Windows Mobile
   * - Windows Phone
   * - iOS
   * - iOS Facebook Integration Account
   * - iOS Facebook Social Sharing UI
   * - webOS
   * - Chrome OS
   * - etc...
   *
   * An authoritative list can be found in the PHP `PlatformDetector` class and
   * related classes in the same file (see calls to `new UserAgentPlatform`
   * here: https://fburl.com/50729226).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isPlatform: function isPlatform(query) {
    return compare(UserAgentData.platformName, UserAgentData.platformFullVersion, query, normalizePlatformVersion);
  },


  /**
   * Check if the User Agent platform is a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isPlatformArchitecture: function isPlatformArchitecture(query) {
    return compare(UserAgentData.platformArchitecture, null, query);
  }
};

module.exports = mapObject(UserAgent, memoizeStringOnly);

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(875);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(170),
    isLength = __webpack_require__(557);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 151 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(59);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* createTypesMap */])('usage', ['apps', 'gateways', 'nodes']);

function apps() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.apps, {
    endpoint: '/lora/applications/count'
  })();
}

function gateways() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.gateways, {
    endpoint: '/lora/gateways/count'
  })();
}

function nodes() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.nodes, {
    endpoint: '/lora/nodes/count'
  })();
}

/* harmony default export */ __webpack_exports__["a"] = ({
  apps: apps,
  gateways: gateways,
  nodes: nodes
});

/***/ }),
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(1);
var factory = __webpack_require__(704);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule generateRandomKey
 * @format
 * 
 */



var seenKeys = {};
var MULTIPLIER = Math.pow(2, 24);

function generateRandomKey() {
  var key = void 0;
  while (key === undefined || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
    key = Math.floor(Math.random() * MULTIPLIER).toString(32);
  }
  seenKeys[key] = true;
  return key;
}

module.exports = generateRandomKey;

/***/ }),
/* 168 */,
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(312),
    getRawTag = __webpack_require__(2455),
    objectToString = __webpack_require__(2481);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(169),
    isObject = __webpack_require__(118);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getEnumList */
/* harmony export (immutable) */ __webpack_exports__["h"] = getDeviceList;
/* unused harmony export editDeviceDetail */
/* unused harmony export addDevice */
/* unused harmony export editDevice */
/* harmony export (immutable) */ __webpack_exports__["e"] = getDeviceDetail;
/* harmony export (immutable) */ __webpack_exports__["j"] = addOTAA;
/* harmony export (immutable) */ __webpack_exports__["k"] = importABP;
/* harmony export (immutable) */ __webpack_exports__["d"] = delDevice;
/* unused harmony export delData */
/* harmony export (immutable) */ __webpack_exports__["f"] = getDataSize;
/* unused harmony export sendData */
/* unused harmony export getAppDeviceLogRecord */
/* harmony export (immutable) */ __webpack_exports__["i"] = getAppLogs;
/* unused harmony export getDeviceMacLog */
/* unused harmony export getDeviceLog */
/* harmony export (immutable) */ __webpack_exports__["g"] = importBatch;
/* unused harmony export getApplicationCount */
/* unused harmony export dviceStatistics */
/* unused harmony export rxqosStatistics */
/* unused harmony export getDeviceCount */
/* unused harmony export getOrgBasic */
/* unused harmony export getNodesCount */
/* harmony export (immutable) */ __webpack_exports__["b"] = writeRegister;
/* harmony export (immutable) */ __webpack_exports__["c"] = readRegister;
/* harmony export (immutable) */ __webpack_exports__["a"] = getRegisterLogs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(240);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



function getEnumList(property, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/enum/' + property, {}, {}, callback);
}

function getDeviceList(args, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/nodes', args, {}, callback);
}

function editDeviceDetail(device_id, data, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('put', '/lora/nodes/' + device_id, {}, data, callback);
}

function addDevice(deveui, devaddr, type, city, area, status, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('post', '/lora/devices', {}, {
    deveui: deveui,
    devaddr: devaddr,
    type: type,
    city: city,
    area: area,
    status: status
  }, callback);
}

function editDevice(id, property, value, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('post', '/lora/devices/' + id, {}, {
    property: value
  }, callback);
}

function getDeviceDetail(device_id, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/nodes/' + device_id, {}, {}, callback);
}

function addOTAA(appeui, deveui, appkey) {
  var band = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var callback = arguments[4];

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('post', '/lora/nodes', {}, {
    appeui: appeui,
    deveui: deveui,
    appkey: appkey,
    fcntbits: 32,
    band: band
  }, callback);
}

function importABP(devaddr, nwkskey, appskey, deveui, AppEUI, band, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('post', '/lora/nodes', {}, {
    devaddr: devaddr,
    nwkskey: nwkskey,
    appskey: appskey,
    deveui: deveui,
    appeui: AppEUI,
    fcntbits: 32,
    band: band
  }, callback);
}
function delDevice(device_id, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('del', '/lora/nodes/' + device_id, {}, {}, callback);
}

function delData(device_id, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('post', '/lora/nodes/' + device_id + "/tx/flush", {}, {}, callback);
}
function getDataSize(device_id, args, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/nodes/' + device_id + "/tx/size", args, {}, callback);
}
function sendData(device_id, data, fport, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('post', '/lora/nodes/' + device_id + "/tx", {}, {
    data: data,
    fport: fport
  }, callback);
}

//export function getDeviceOnQuery(args,callback) {
//  return APIRequest('get','/lora/nodes', args, {}, callback);
//}

function getAppDeviceLogRecord(appid, args, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/applications/' + appid + '/logs', args, {}, callback);
}

function getAppLogs(id, args, cb) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', "/lora/applications/" + id + "/logs", args, {}, cb);
}
// 'get','/devlog/history?src=lora&appeui='+appid,args, {}, callback
//  GET /v1/lora/applications/#ID/logs

function getDeviceMacLog(device_id, args, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/nodes/' + device_id + "/mac/logs?deveui=" + device_id, args, {}, callback);
}

function getDeviceLog(args, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/devlog/history', args, {}, callback);
}

function importBatch(sourceObj, appid, callback) {
  //{list:[object,object,object]}
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('post', '/lora/nodes/batch', {}, {
    app: appid,
    list: sourceObj.list
  }, callback);
}
function getApplicationCount(appid, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/nodes/count?app=' + appid, {}, {}, callback);
}

function dviceStatistics(id, MILLSN, MILLSL, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/nodes/' + id + '/stats?from=' + MILLSN + '&to=' + MILLSL, {}, {}, callback);
}
function rxqosStatistics(id, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/nodes/' + id + '/rxqos?download', {}, {}, callback);
}

function getDeviceCount(appid, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/nodes/count?app=' + appid, {}, {}, callback);
}
function getOrgBasic(callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/org/basic', {}, {}, callback);
}
function getNodesCount(callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/nodes/count', {}, {}, callback);
}

function writeRegister(devid, port, registerId, value, callback) {
  var registers = {};
  registers[registerId] = value;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('post', "/lora/nodes/" + devid + "/registers", {}, { port: port, registers: registers, op: 'write' }, callback);
}

function readRegister(devid, port, registerId, callback) {
  var registers = [registerId];
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('post', "/lora/nodes/" + devid + "/registers", {}, { port: port, registers: registers, op: 'read' }, callback);
}

function getRegisterLogs(devid, query, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', "/lora/nodes/" + devid + "/registers/logs", query, {}, callback);
}

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return kLastHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return kLastDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return kLastMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return kTimeRanges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return kGroupByTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return kGroupByTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return kGroupOneMin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return kGroupTenMin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return kGroupOneHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return kGroupTimes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return kDeviceFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return kFilterTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return kGroupFuncMin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return kGroupFuncMax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return kGroupFuncAvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return kGroupFuncSum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return kGroupFuncTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return kSeriesDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return kSeriesTypes; });
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

var kLastHour = 'lasthour';
var kLastDay = 'lastday';
var kLastMonth = 'lastmon';
var kTimeRanges = [kLastHour, kLastDay, kLastMonth];

var kGroupByTime = 'time';
var kGroupByTypes = [kGroupByTime];

var kGroupOneMin = 'onemin';
var kGroupTenMin = 'tenmin';
var kGroupOneHour = 'onehour';
var kGroupTimes = [kGroupOneMin, kGroupTenMin, kGroupOneHour];

var kDeviceFilter = 'device';
var kFilterTypes = [kDeviceFilter];

var kGroupFuncMin = 'min';
var kGroupFuncMax = 'max';
var kGroupFuncAvg = 'avg';
var kGroupFuncSum = 'sum';
var kGroupFuncTypes = [kGroupFuncMin, kGroupFuncMax, kGroupFuncAvg, kGroupFuncSum];

var kSeriesDevice = 'device';
var kSeriesTypes = [kSeriesDevice];

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return toDistrTrendOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return toPktPieData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return toDistrPieData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toTOAUplinkTrendSeries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toTOAUplinkPieData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



function formatSlot(slot) {
  var s = String(slot);
  if (s.length >= 12) {
    return s.slice(6, 8) + "/" + s.slice(4, 6) + " " + s.slice(8, 10) + ":" + s.slice(10, 12);
  }
  if (s.length >= 10) {
    return s.slice(6, 8) + "/" + s.slice(4, 6) + " " + s.slice(8, 10) + ":00";
  } else if (s.length >= 8) {
    return s.slice(6, 8) + "/" + s.slice(4, 6);
  }
  return s.slice(4, 6);
}

var statsSelectors = {
  sf: function sf(state) {
    return state.gateway.getGatewaySFStats;
  },
  freq: function freq(state) {
    return state.gateway.getGatewayFreqStats;
  },
  pkt: function pkt(state) {
    return state.gateway.getGatewayPktStats;
  }
};

function toGroupBySeries(list, groupBy, dataField) {
  var timeField = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'slot';

  var categories = _.sortBy(_.uniq(_.map(list, groupBy)), Number);
  var slots = _.uniq(_.map(list, timeField)).sort();

  var series = _.map(categories, function (cat) {
    var l = _.filter(list, function (item) {
      return item[groupBy] === cat;
    });
    var data = _.map(slots, function (slot) {
      var cnt = _.find(l, { slot: slot });
      if (cnt) {
        return cnt[dataField];
      }
      return 0;
    });
    return { name: String(cat), data: data };
  });
  return {
    series: series,
    categories: _.map(slots, formatSlot),
    legend: _.map(categories, _.toString)
  };
}

var toDistrTrendOption = function toDistrTrendOption(key) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(statsSelectors[key], function (distr) {
    if (distr.status === 'success') {
      return toGroupBySeries(distr.data.list, key, 'count');
    }
    return {
      categories: [],
      series: [],
      legend: []
    };
  });
};

var toPktPieData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(statsSelectors.pkt, function (pkts) {
  if (pkts.status !== 'success') {
    return {};
  }
  return pkts.data.list.reduce(function (res, item) {
    return {
      pkts: res.pkts + item.rxpkt,
      pktsau: res.pktsau + (item.rxpkt - item.rxpktun),
      pktsun: res.pktsun + item.rxpktun
    };
  }, {
    pkts: 0,
    pktsau: 0,
    pktsun: 0
  });
});

var toDistrPieData = function toDistrPieData(key) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(statsSelectors[key], function (distr) {
    if (distr.status === 'success') {
      return _.mapValues(_.groupBy(distr.data.list, key), function (values) {
        return _.sumBy(values, 'count');
      });
    }
    return {};
  });
};

var toTOAStats = function toTOAStats(state) {
  return state.gateway.getGatewayTOAStats;
};
var toTOAUplinkTrendSeries = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(toTOAStats, function (toaStats) {
  if (toaStats.status === 'success') {
    return toGroupBySeries(toaStats.data.list, 'freq', 'uplink');
  }
  return {
    categories: [],
    series: [],
    legend: []
  };
});
var toTOAUplinkPieData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(toTOAStats, function (toaStats) {
  if (toaStats.status === 'success') {
    return _.mapValues(_.groupBy(toaStats.data.list, 'freq'), function (values) {
      return _.sumBy(values, 'uplink');
    });
  }
  return {};
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parseContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return kSFOptions; });
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

var parseContent = function parseContent() {
  var reduxObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _reduxObj$data = reduxObj.data;
  _reduxObj$data = _reduxObj$data === undefined ? {} : _reduxObj$data;
  var content = _reduxObj$data.content;

  if (!content) return { options: [], types: {} };
  var options = [];
  var types = {};
  try {
    types = JSON.parse(content);
    options = types.networktypes.map(function (n) {
      return { label: n.networks.name, value: n.networks.name };
    });
  } catch (err) {
    console.log('err', err);
    // err
  }
  return { options: options, types: types };
};

var kSFOptions = [{ label: '7', value: 7 }, { label: '8', value: 8 }, { label: '9', value: 9 }];

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(59);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* createTypesMap */])('enums', ['platforms', 'lwanvers', 'nodetypes', 'bands', 'vendors']);

function platforms() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.platforms, {
    endpoint: '/lora/enum/platform'
  })();
}

function lwanvers() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.lwanvers, {
    endpoint: '/lora/enum/lwanvers'
  })();
}

function nodetypes() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.nodetypes, {
    endpoint: '/lora/enum/nodetypes'
  })();
}

function vendors() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.vendors, {
    endpoint: '/lora/enum/vendor'
  })();
}

function bands() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.bands, {
    endpoint: '/lora/enum/bands'
  })();
}

/* harmony default export */ __webpack_exports__["a"] = ({
  platforms: platforms,
  lwanvers: lwanvers,
  nodetypes: nodetypes,
  bands: bands,
  vendors: vendors
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export toOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return enumsToOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



function toOptions(result) {
  var status = result.status;

  if (status === 'success') {
    return result.data.list.map(function (l) {
      return {
        label: l.name,
        value: l.name
      };
    });
  }
  return [];
}

var enumsToOptions = function enumsToOptions(type, state) {
  var selector = function selector(s) {
    return s.enums[type];
  };
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(selector, function (list) {
    return toOptions(list);
  })(state);
};

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = setAuthCookies;
/* harmony export (immutable) */ __webpack_exports__["a"] = getAuthCookies;
/* harmony export (immutable) */ __webpack_exports__["b"] = getTokenCookies;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeAuthCookies;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(1426);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



function setAuthCookies(auth) {
  if (!auth) {
    return;
  }
  var expires = auth.expires_in;
  var options = void 0;
  if (expires) {
    options = {
      expires: expires / 86400
    };
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* setCookies */])('auth', auth, options);
  // backward compatible with legacy api calls
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* setCookies */])('token', auth.access_token, options);
}

function getAuthCookies() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* getCookiesJSON */])('auth');
}

function getTokenCookies() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["c" /* getCookies */])('token');
}

function removeAuthCookies() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["d" /* removeCookies */])('auth');
  // backward compatible with legacy api calls
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["d" /* removeCookies */])('token');
}

/***/ }),
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Draft
 * @format
 * 
 */



var AtomicBlockUtils = __webpack_require__(1809);
var BlockMapBuilder = __webpack_require__(299);
var CharacterMetadata = __webpack_require__(117);
var CompositeDraftDecorator = __webpack_require__(1810);
var ContentBlock = __webpack_require__(219);
var ContentState = __webpack_require__(503);
var DefaultDraftBlockRenderMap = __webpack_require__(504);
var DefaultDraftInlineStyle = __webpack_require__(750);
var DraftEditor = __webpack_require__(1812);
var DraftEditorBlock = __webpack_require__(751);
var DraftEntity = __webpack_require__(370);
var DraftModifier = __webpack_require__(107);
var DraftEntityInstance = __webpack_require__(752);
var EditorState = __webpack_require__(51);
var KeyBindingUtil = __webpack_require__(505);
var RichTextEditorUtil = __webpack_require__(755);
var SelectionState = __webpack_require__(259);

var convertFromDraftStateToRaw = __webpack_require__(1831);
var convertFromHTMLToContentBlocks = __webpack_require__(756);
var convertFromRawToDraftState = __webpack_require__(1832);
var generateRandomKey = __webpack_require__(167);
var getDefaultKeyBinding = __webpack_require__(757);
var getVisibleSelectionRect = __webpack_require__(1855);

var DraftPublic = {
  Editor: DraftEditor,
  EditorBlock: DraftEditorBlock,
  EditorState: EditorState,

  CompositeDecorator: CompositeDraftDecorator,
  Entity: DraftEntity,
  EntityInstance: DraftEntityInstance,

  BlockMapBuilder: BlockMapBuilder,
  CharacterMetadata: CharacterMetadata,
  ContentBlock: ContentBlock,
  ContentState: ContentState,
  SelectionState: SelectionState,

  AtomicBlockUtils: AtomicBlockUtils,
  KeyBindingUtil: KeyBindingUtil,
  Modifier: DraftModifier,
  RichUtils: RichTextEditorUtil,

  DefaultDraftBlockRenderMap: DefaultDraftBlockRenderMap,
  DefaultDraftInlineStyle: DefaultDraftInlineStyle,

  convertFromHTML: convertFromHTMLToContentBlocks,
  convertFromRaw: convertFromRawToDraftState,
  convertToRaw: convertFromDraftStateToRaw,
  genKey: generateRandomKey,
  getDefaultKeyBinding: getDefaultKeyBinding,
  getVisibleSelectionRect: getVisibleSelectionRect
};

module.exports = DraftPublic;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftFeatureFlags
 * @format
 * 
 */



var DraftFeatureFlags = __webpack_require__(1822);

module.exports = DraftFeatureFlags;

/***/ }),
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = __webpack_require__(68);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path),
      pathname = _parsePath2.pathname,
      search = _parsePath2.search,
      hash = _parsePath2.hash;

  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path),
      search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename,
      pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(2432),
    baseMatchesProperty = __webpack_require__(2433),
    identity = __webpack_require__(234),
    isArray = __webpack_require__(80),
    property = __webpack_require__(2509);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(266);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isReactChildren;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRouteFromReactElement;
/* unused harmony export createRoutesFromReactChildren */
/* harmony export (immutable) */ __webpack_exports__["b"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function isValidChild(object) {
  return object == null || __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 199 */,
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);






var Link = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Link, _React$Component);

  function Link(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Link);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {};
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  Link.prototype.handleClick = function handleClick(e) {
    e.preventDefault();

    var _props = this.props,
        to = _props.to,
        onClick = _props.onClick,
        pushState = _props.pushState;


    if (to) {
      // let openInNewTab = false; // 默认直接在当前页面打开
      var openInNewTab = true; // 点击链接打开新页面
      if (e.metaKey || e.altKey || e.ctrlKey) {
        openInNewTab = true;
      }
      if (openInNewTab) {
        window.open(to);
      } else {
        pushState(to);
      }
    } else {
      onClick(e);
    }
  };

  Link.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_router__["f" /* Link */],
      { onClick: this.handleClick },
      this.props.children
    );
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Link.defaultProps = {
  children: null,
  onClick: function onClick() {},
  to: null
};
Link.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.node,
  onClick: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func,
  to: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(null, mapDispatchToProps)(Link));

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Select__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_main_scss__ = __webpack_require__(2139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_main_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







var propTypes = {
  pageSize: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.number.isRequired,
  options: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.array.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var PageSizer = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PageSizer, _React$Component);

  function PageSizer(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PageSizer);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      pageSize: props.pageSize
    };
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  PageSizer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.pageSize !== nextProps.pageSize) {
      this.setState({
        pageSize: nextProps.pageSize
      });
    }
  };

  PageSizer.prototype.handleChange = function handleChange(v) {
    var onChange = this.props.onChange;

    var pageSize = Number(v);
    if (onChange) {
      onChange(pageSize);
    }
  };

  PageSizer.prototype.render = function render() {
    var options = this.props.options;
    var pageSize = this.state.pageSize;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { styleName: "page-sizer" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { styleName: "page-select" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Select__["a" /* default */], {
          onChange: this.handleChange,
          value: pageSize,
          options: options.map(function (opt) {
            return { value: opt, label: opt };
          })
        })
      )
    );
  };

  return PageSizer;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

PageSizer.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_5_react_css_modules___default()(PageSizer, __WEBPACK_IMPORTED_MODULE_7__styles_main_scss___default.a, { allowMultiple: true })));

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(59);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* createTypesMap */])('chplan', ['getChannelPlans', 'getChannelPlan', 'updateChannelPlan', 'getChannelDefines', 'getDataRates', 'deleteChannelPlan']);

function getChannelPlans() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { sort: '-ctime', limit: 100 };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getChannelPlans, {
    endpoint: '/lora/chplans',
    query: args
  })();
}

function getChannelPlan(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getChannelPlan, {
    endpoint: "/lora/chplans/" + id
  })();
}

function updateChannelPlan(id, data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.updateChannelPlan, {
    endpoint: "/lora/chplans/" + id,
    body: data,
    method: 'PUT'
  })();
}

function getChannelDefines(band) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getChannelDefines, {
    endpoint: "/lora/band/" + band + "/channeldefines"
  })();
}

function getDataRates(band) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getDataRates, {
    endpoint: "/lora/band/" + band + "/datarates"
  })();
}

function deleteChannelPlan(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.deleteChannelPlan, {
    endpoint: "/lora/chplans/" + id,
    method: 'DELETE'
  })();
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getChannelPlans: getChannelPlans,
  getChannelPlan: getChannelPlan,
  updateChannelPlan: updateChannelPlan,
  getChannelDefines: getChannelDefines,
  getDataRates: getDataRates,
  deleteChannelPlan: deleteChannelPlan
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return types; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getParserCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDebugResult; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(59);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* createTypesMap */])('parsers', ['getParsers', 'getParser', 'deleteParser', 'addParser', 'countParsers', 'getParserCode', 'getDebugResult']);

function getParsers(args) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* createAPIAction */])(types.getParsers, {
    endpoint: '/lora/parsers',
    query: args
  })();
}

function getParser(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* createAPIAction */])(types.getParser, {
    endpoint: "/lora/parsers/" + id
  })();
}

function deleteParser(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* createAPIAction */])(types.deleteParser, {
    endpoint: "/lora/parsers/" + id,
    method: 'DELETE'
  })();
}

function addParser(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* createAPIAction */])(types.addParser, {
    endpoint: '/lora/parsers',
    method: 'POST',
    body: data
  })();
}

function countParsers(query) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* createAPIAction */])(types.countParsers, {
    endpoint: '/lora/parsers/count',
    query: query
  })();
}

var getParserCode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(types.getParserCode, function (c) {
  return c;
});

var getDebugResult = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(types.getDebugResult, function (v) {
  return v;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  getParsers: getParsers,
  getParser: getParser,
  deleteParser: deleteParser,
  addParser: addParser,
  countParsers: countParsers,
  getParserCode: getParserCode,
  getDebugResult: getDebugResult
});

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1449), __esModule: true };

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1452), __esModule: true };

/***/ }),
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentBlock
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CharacterMetadata = __webpack_require__(117);
var Immutable = __webpack_require__(45);

var findRangesImmutable = __webpack_require__(300);

var List = Immutable.List,
    Map = Immutable.Map,
    OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat;


var EMPTY_SET = OrderedSet();

var defaultRecord = {
  key: '',
  type: 'unstyled',
  text: '',
  characterList: List(),
  depth: 0,
  data: Map()
};

var ContentBlockRecord = Record(defaultRecord);

var decorateCharacterList = function decorateCharacterList(config) {
  if (!config) {
    return config;
  }

  var characterList = config.characterList,
      text = config.text;


  if (text && !characterList) {
    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
  }

  return config;
};

var ContentBlock = function (_ContentBlockRecord) {
  _inherits(ContentBlock, _ContentBlockRecord);

  function ContentBlock(config) {
    _classCallCheck(this, ContentBlock);

    return _possibleConstructorReturn(this, _ContentBlockRecord.call(this, decorateCharacterList(config)));
  }

  ContentBlock.prototype.getKey = function getKey() {
    return this.get('key');
  };

  ContentBlock.prototype.getType = function getType() {
    return this.get('type');
  };

  ContentBlock.prototype.getText = function getText() {
    return this.get('text');
  };

  ContentBlock.prototype.getCharacterList = function getCharacterList() {
    return this.get('characterList');
  };

  ContentBlock.prototype.getLength = function getLength() {
    return this.getText().length;
  };

  ContentBlock.prototype.getDepth = function getDepth() {
    return this.get('depth');
  };

  ContentBlock.prototype.getData = function getData() {
    return this.get('data');
  };

  ContentBlock.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET;
  };

  ContentBlock.prototype.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  };

  /**
   * Execute a callback for every contiguous range of styles within the block.
   */


  ContentBlock.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
  };

  /**
   * Execute a callback for every contiguous range of entities within the block.
   */


  ContentBlock.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
  };

  return ContentBlock;
}(ContentBlockRecord);

function haveEqualStyle(charA, charB) {
  return charA.getStyle() === charB.getStyle();
}

function haveEqualEntity(charA, charB) {
  return charA.getEntity() === charB.getEntity();
}

module.exports = ContentBlock;

/***/ }),
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1Li_B","wrapper-nopadding":"wrapper-nopadding__dvliq","loading":"loading__3hv45","error":"error__1jLyL","table-loading":"table-loading__1pE3X","empty-val":"empty-val__1Urq5","panelheader-tools":"panelheader-tools__38n_5","propsPanels":"propsPanels__32bHI","new":"new__3VZ1P","marginLm":"marginLm__3rQ7R","marginRm":"marginRm__3q-Qg","fullWidth":"fullWidth__3MD0I","fullHeight":"fullHeight__3Qw5o","noData":"noData__3l-Rh","row":"row__3wUub","status":"status__3jOR6","header":"header__3iTW5","hpie":"hpie__3JauL","pager":"pager__Xrpf8","nodeSearch":"nodeSearch__3rIH0"};

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2To1t","wrapper-nopadding":"wrapper-nopadding__1_dEP","loading":"loading__2N14R","error":"error__OjEOW","table-loading":"table-loading__2hoDG","empty-val":"empty-val__1prZk","panelheader-tools":"panelheader-tools__38r9R","propsPanels":"propsPanels__55lWt","new":"new__S5vm2","marginLm":"marginLm__3_sss","marginRm":"marginRm__2Jrf0","fullWidth":"fullWidth__2xzDO","fullHeight":"fullHeight__2khn9","noData":"noData__wJcMT","create":"create__1Q1ZO","search":"search__2tPOV","label":"label__1T4UR","active":"active__2Fv0F","selector":"selector__3gfQj","addBtn":"addBtn__1y3qI","editBtn":"editBtn__2O9jq","deleteBtn":"deleteBtn__3Tgli","edit":"edit__1wI3l","disabled":"disabled__3ocIE","icon":"icon__355Ej","memo":"memo__2sWpH","pager":"pager__254xI","pagers":"pagers__3YA7l","white":"white__3mnlv","added":"added__e3JAz","unlink":"unlink__1dlM7","gateway":"gateway__2Vmro"};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * Unicode-enabled replacesments for basic String functions.
 *
 * All the functions in this module assume that the input string is a valid
 * UTF-16 encoding of a Unicode sequence. If it's not the case, the behavior
 * will be undefined.
 *
 * WARNING: Since this module is typechecks-enforced, you may find new bugs
 * when replacing normal String functions with ones provided here.
 */



var invariant = __webpack_require__(23);

// These two ranges are consecutive so anything in [HIGH_START, LOW_END] is a
// surrogate code unit.
var SURROGATE_HIGH_START = 0xD800;
var SURROGATE_HIGH_END = 0xDBFF;
var SURROGATE_LOW_START = 0xDC00;
var SURROGATE_LOW_END = 0xDFFF;
var SURROGATE_UNITS_REGEX = /[\uD800-\uDFFF]/;

/**
 * @param {number} codeUnit   A Unicode code-unit, in range [0, 0x10FFFF]
 * @return {boolean}          Whether code-unit is in a surrogate (hi/low) range
 */
function isCodeUnitInSurrogateRange(codeUnit) {
  return SURROGATE_HIGH_START <= codeUnit && codeUnit <= SURROGATE_LOW_END;
}

/**
 * Returns whether the two characters starting at `index` form a surrogate pair.
 * For example, given the string s = "\uD83D\uDE0A", (s, 0) returns true and
 * (s, 1) returns false.
 *
 * @param {string} str
 * @param {number} index
 * @return {boolean}
 */
function isSurrogatePair(str, index) {
  !(0 <= index && index < str.length) ?  false ? invariant(false, 'isSurrogatePair: Invalid index %s for string length %s.', index, str.length) : invariant(false) : void 0;
  if (index + 1 === str.length) {
    return false;
  }
  var first = str.charCodeAt(index);
  var second = str.charCodeAt(index + 1);
  return SURROGATE_HIGH_START <= first && first <= SURROGATE_HIGH_END && SURROGATE_LOW_START <= second && second <= SURROGATE_LOW_END;
}

/**
 * @param {string} str  Non-empty string
 * @return {boolean}    True if the input includes any surrogate code units
 */
function hasSurrogateUnit(str) {
  return SURROGATE_UNITS_REGEX.test(str);
}

/**
 * Return the length of the original Unicode character at given position in the
 * String by looking into the UTF-16 code unit; that is equal to 1 for any
 * non-surrogate characters in BMP ([U+0000..U+D7FF] and [U+E000, U+FFFF]); and
 * returns 2 for the hi/low surrogates ([U+D800..U+DFFF]), which are in fact
 * representing non-BMP characters ([U+10000..U+10FFFF]).
 *
 * Examples:
 * - '\u0020' => 1
 * - '\u3020' => 1
 * - '\uD835' => 2
 * - '\uD835\uDDEF' => 2
 * - '\uDDEF' => 2
 *
 * @param {string} str  Non-empty string
 * @param {number} pos  Position in the string to look for one code unit
 * @return {number}      Number 1 or 2
 */
function getUTF16Length(str, pos) {
  return 1 + isCodeUnitInSurrogateRange(str.charCodeAt(pos));
}

/**
 * Fully Unicode-enabled replacement for String#length
 *
 * @param {string} str  Valid Unicode string
 * @return {number}     The number of Unicode characters in the string
 */
function strlen(str) {
  // Call the native functions if there's no surrogate char
  if (!hasSurrogateUnit(str)) {
    return str.length;
  }

  var len = 0;
  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    len++;
  }
  return len;
}

/**
 * Fully Unicode-enabled replacement for String#substr()
 *
 * @param {string} str      Valid Unicode string
 * @param {number} start    Location in Unicode sequence to begin extracting
 * @param {?number} length  The number of Unicode characters to extract
 *                          (default: to the end of the string)
 * @return {string}         Extracted sub-string
 */
function substr(str, start, length) {
  start = start || 0;
  length = length === undefined ? Infinity : length || 0;

  // Call the native functions if there's no surrogate char
  if (!hasSurrogateUnit(str)) {
    return str.substr(start, length);
  }

  // Obvious cases
  var size = str.length;
  if (size <= 0 || start > size || length <= 0) {
    return '';
  }

  // Find the actual starting position
  var posA = 0;
  if (start > 0) {
    for (; start > 0 && posA < size; start--) {
      posA += getUTF16Length(str, posA);
    }
    if (posA >= size) {
      return '';
    }
  } else if (start < 0) {
    for (posA = size; start < 0 && 0 < posA; start++) {
      posA -= getUTF16Length(str, posA - 1);
    }
    if (posA < 0) {
      posA = 0;
    }
  }

  // Find the actual ending position
  var posB = size;
  if (length < size) {
    for (posB = posA; length > 0 && posB < size; length--) {
      posB += getUTF16Length(str, posB);
    }
  }

  return str.substring(posA, posB);
}

/**
 * Fully Unicode-enabled replacement for String#substring()
 *
 * @param {string} str    Valid Unicode string
 * @param {number} start  Location in Unicode sequence to begin extracting
 * @param {?number} end   Location in Unicode sequence to end extracting
 *                        (default: end of the string)
 * @return {string}       Extracted sub-string
 */
function substring(str, start, end) {
  start = start || 0;
  end = end === undefined ? Infinity : end || 0;

  if (start < 0) {
    start = 0;
  }
  if (end < 0) {
    end = 0;
  }

  var length = Math.abs(end - start);
  start = start < end ? start : end;
  return substr(str, start, length);
}

/**
 * Get a list of Unicode code-points from a String
 *
 * @param {string} str        Valid Unicode string
 * @return {array<number>}    A list of code-points in [0..0x10FFFF]
 */
function getCodePoints(str) {
  var codePoints = [];
  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    codePoints.push(str.codePointAt(pos));
  }
  return codePoints;
}

var UnicodeUtils = {
  getCodePoints: getCodePoints,
  getUTF16Length: getUTF16Length,
  hasSurrogateUnit: hasSurrogateUnit,
  isCodeUnitInSurrogateRange: isCodeUnitInSurrogateRange,
  isSurrogatePair: isSurrogatePair,
  strlen: strlen,
  substring: substring,
  substr: substr
};

module.exports = UnicodeUtils;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(2427),
    getValue = __webpack_require__(2457);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 234 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 235 */,
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createAction__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handleAction__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handleActions__ = __webpack_require__(2732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__combineActions__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createActions__ = __webpack_require__(2731);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createAction__["a"]; });
/* unused harmony reexport createActions */
/* unused harmony reexport handleAction */
/* unused harmony reexport handleActions */
/* unused harmony reexport combineActions */








/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(2737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(2736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(2735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(1097);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* unused harmony reexport compose */







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function defaultEqualityCheck(a, b) {
  return a === b;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length <= 1 || arguments[1] === undefined ? defaultEqualityCheck : arguments[1];

  var lastArgs = null;
  var lastResult = null;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (lastArgs === null || lastArgs.length !== args.length || !args.every(function (value, index) {
      return equalityCheck(value, lastArgs[index]);
    })) {
      lastResult = func.apply(undefined, args);
    }
    lastArgs = args;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len2 = arguments.length, memoizeOptions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    memoizeOptions[_key2 - 1] = arguments[_key2];
  }

  return function () {
    for (var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      funcs[_key3] = arguments[_key3];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      return resultFunc.apply(undefined, arguments);
    }].concat(memoizeOptions));

    var selector = function selector(state, props) {
      for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }

      var params = dependencies.map(function (dependency) {
        return dependency.apply(undefined, [state, props].concat(args));
      });
      return memoizedResultFunc.apply(undefined, _toConsumableArray(params));
    };

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length <= 1 || arguments[1] === undefined ? createSelector : arguments[1];

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      values[_key5] = arguments[_key5];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 239 */,
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = APIRequest;
/* unused harmony export saveToState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNull__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isNull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_extend__ = __webpack_require__(2497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_extend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_extend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_merge__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_superagent__ = __webpack_require__(2748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cookie__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(65);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





function APIRequest(method, apiUrl, query, data, callback) {
  var token = __WEBPACK_IMPORTED_MODULE_5__helpers_cookie__["a" /* default */].get('token');
  var url = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].apiBase + apiUrl;
  if (apiUrl.startsWith('http')) {
    url = apiUrl;
  }

  var rq = __WEBPACK_IMPORTED_MODULE_4_superagent___default.a[method](url).set('Authorization', "Bearer " + token);
  if (query) {
    rq = rq.query(query);
  }
  if (data) {
    rq = rq.send(data);
  }

  function normError(err, res) {
    var aRes = __WEBPACK_IMPORTED_MODULE_3_lodash_merge___default()({
      body: {}
    }, res);

    return __WEBPACK_IMPORTED_MODULE_2_lodash_extend___default()({}, res, {
      errcode: err.name,
      errmsg: err.message,
      error: err
    }, {
      errcode: aRes.body._code || aRes.body.error || 'UNKNOWN',
      errmsg: aRes.body._message || aRes.body.message || 'UNKNOWN',
      error: err
    });
  }

  function normResult(res) {
    var result = __WEBPACK_IMPORTED_MODULE_3_lodash_merge___default()({ body: {} }, res);
    if (__WEBPACK_IMPORTED_MODULE_1_lodash_isNull___default()(result.body.list)) {
      result.body.list = [];
    }
    return result;
  }

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    rq.end(function (err, res) {
      var error = null;
      var result = null;

      if (err) {
        if (err.status === 401) {
          __WEBPACK_IMPORTED_MODULE_5__helpers_cookie__["a" /* default */].unset('token');
        }
        error = normError(err, res);
      } else if (res.statusCode !== 200) {
        error = normError(err, res);
      } else {
        result = normResult(res);
      }

      if (callback) {
        return callback(error, result);
      }
      if (error) {
        reject(error);
      } else {
        resolve(result);
      }
      return null;
    });
  });
}

function saveToState(call, _this, targetKey) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    call.then(function (res) {
      var obj = {};
      obj[targetKey] = res.body;
      _this.setState(obj, function () {
        resolve(res.body);
      });
    }, function (err) {
      reject(err);
    });
  });
}

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clipboard__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Flash__ = __webpack_require__(606);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);








var defaultProps = {
  text: ''
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  text: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string
};

var Copy = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Copy, _React$Component);

  function Copy(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Copy);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      text: props.text
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'lora.coms.copy');

    var copy = new __WEBPACK_IMPORTED_MODULE_4_clipboard___default.a("#" + props.id);
    var that = _this;
    copy.on('success', function () {
      that.setState({ copied: true });
    });
    return _this;
  }

  Copy.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var text = nextProps.text;

    this.setState({ text: text });
  };

  Copy.prototype.render = function render() {
    var _this2 = this;

    var id = this.props.id;
    var _state = this.state,
        text = _state.text,
        _state$copied = _state.copied,
        copied = _state$copied === undefined ? false : _state$copied;

    var tooltip = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Tooltip"],
      { id: "tooltip-" + id },
      this.intlMsg.msg('copy')
    );
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "span",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["OverlayTrigger"],
        {
          placement: "top",
          overlay: tooltip,
          delayShow: 500
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "a",
          { id: id, "data-clipboard-text": text },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-copy" })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Flash__["a" /* default */], {
        show: copied,
        message: this.intlMsg.msg('copied'),
        onHide: function onHide() {
          return _this2.setState({ copied: false });
        },
        azStyle: "success"
      })
    );
  };

  return Copy;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Copy.defaultProps = defaultProps;
Copy.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(Copy));

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_pie__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_pie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_pie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_tooltip__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_title__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_legend__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_grid__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_echarts_lib_component_dataZoom__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_echarts_lib_component_dataZoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_echarts_lib_component_dataZoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_echarts_lib_echarts__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_merge__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_isString__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss__ = __webpack_require__(2141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);















var defaultProps = {
  legend: [],
  title: '',
  height: 0
};

var defaultTitle = {
  textStyle: {
    fontSize: 16,
    fontWeight: 300
  },
  textBaseline: 'bottom'
};

var propTypes = {
  height: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  series: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  legend: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};

var defaultSeries = {
  label: {
    normal: {
      textStyle: {
        fontWeight: 300
      }
    }
  },
  radius: [0, '60%']
};

var PieChart = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PieChart, _React$Component);

  function PieChart(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PieChart);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      series: props.series,
      legend: props.legend
    };
    _this.tryResizeChart = _this.tryResizeChart.bind(_this);
    return _this;
  }

  PieChart.prototype.componentDidMount = function componentDidMount() {
    this.echart = this.initChart();
    this.echart.resize();
    $(window).resize(this.tryResizeChart);
  };

  PieChart.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var series = nextProps.series,
        legend = nextProps.legend;

    if (series !== this.props.series) {
      this.setState({
        series: nextProps.series,
        legend: nextProps.legend
      });
      this.updateChart(series, legend);
    }
    this.tryResizeChart();
  };

  PieChart.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_12_echarts_lib_echarts___default.a.dispose($(this.chartRef));
    $(window).off('resize', this.tryResizeChart);
  };

  PieChart.prototype.tryResizeChart = function tryResizeChart() {
    var width = $(this.chartRef).width();
    var height = $(this.chartRef).height();
    if (height !== this.height || width !== this.width) {
      if (this.echart) {
        this.echart.resize();
      }
    }
    this.width = width;
    this.height = height;
  };

  PieChart.prototype.updateChart = function updateChart(nextSeries, nextLegend) {
    var thisSeries = this.state.series;

    var series = nextSeries.map(function (s) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, s, { type: 'pie' });
    });
    var legend = nextLegend || [];
    var option = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.echart.getOption(), {
      series: series,
      legend: legend
    });
    if (!_.isEqual(_.map(thisSeries, 'name'), _.map(nextSeries, 'name'))) {
      // reset option
      this.echart.clear();
    }
    this.echart.setOption(option);
    this.echart.resize();
  };

  PieChart.prototype.initChart = function initChart() {
    var echart = __WEBPACK_IMPORTED_MODULE_12_echarts_lib_echarts___default.a.init(this.chartRef);
    var series = this.state.series.map(function (s) {
      return __WEBPACK_IMPORTED_MODULE_13_lodash_merge___default()(defaultSeries, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, s, {
        type: 'pie'
      }));
    });

    var legend = this.props.legend;
    var title = this.props.title;

    if (__WEBPACK_IMPORTED_MODULE_14_lodash_isString___default()(title)) {
      title = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultTitle, {
        text: title
      });
    }
    var option = {
      title: title,
      legend: legend,
      series: series,
      color: PieChart.colors
    };
    echart.setOption(option);
    return echart;
  };

  PieChart.prototype.render = function render() {
    var _this2 = this;

    var height = this.props.height;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      style: { height: height ? height + "px" : '' },
      className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.chart,
      ref: function ref(_ref) {
        _this2.chartRef = _ref;
      }
    });
  };

  return PieChart;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

PieChart.colors = ['#22A7F0', '#00B16A', '#F7CA18', '#F9690E', '#EF4836', '#DB0A5B', '#663399', '#BF55EC', '#446CB3', '#336E7B', '#1BBC9B'];
PieChart.propTypes = propTypes;
PieChart.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_react_redux__["connect"])(function (state) {
  return {
    collapsed: state.sidebar.collapsed
  };
})(PieChart));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loraactions_sidebar__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_scss__ = __webpack_require__(2152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_collapse_left_svg__ = __webpack_require__(2766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_collapse_left_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_collapse_left_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_collapse_right_svg__ = __webpack_require__(2767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_collapse_right_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_collapse_right_svg__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);












var defaultProps = {
  height: null
};

var propTypes = {
  collapsed: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool.isRequired,
  height: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.number,
  title: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  menuItems: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var SideBar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(SideBar, _React$Component);

  function SideBar(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SideBar);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      collapsed: props.collapsed
    };
    return _this;
  }

  SideBar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var collapsed = nextProps.collapsed;

    if (collapsed !== this.props.collapsed) {
      this.setState({ collapsed: collapsed });
    }
  };

  SideBar.prototype.render = function render() {
    var _this2 = this;

    var collapsed = this.state.collapsed;
    var _props = this.props,
        height = _props.height,
        title = _props.title,
        menuItems = _props.menuItems,
        toggleSidebar = _props.toggleSidebar;


    var menuNodes = menuItems.filter(function (mi) {
      return !_.has(mi, 'show') || mi.show;
    }).map(function (mi) {
      var menuNode = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
        { onClick: mi.onClick, key: mi.text },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { styleName: "menu-item " + (mi.active ? ' active' : '') + " " + (mi.beta ? ' beta' : '') },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { styleName: "menu-icon" },
            mi.icon
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { styleName: "menu-text" },
            mi.text
          )
        )
      );
      if (collapsed) {
        var tooltip = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Tooltip"],
          { id: mi.text },
          mi.text
        );
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["OverlayTrigger"],
          { key: mi.text, placement: "right", overlay: tooltip },
          menuNode
        );
      }
      return menuNode;
    });

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      {
        styleName: "sidebar " + (collapsed ? 'collapsed' : ''),
        style: { height: height },
        ref: function ref(_ref) {
          _this2.sidebarRef = _ref;
        }
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
        { onClick: toggleSidebar, href: "#" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { styleName: "toggle" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { styleName: "title" },
            title
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { styleName: "arrow" },
            collapsed ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_12__images_collapse_right_svg___default.a, alt: ">" }) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_11__images_collapse_left_svg___default.a, alt: "<" })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { styleName: "menu" },
        menuNodes
      )
    );
  };

  return SideBar;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

SideBar.defaultProps = defaultProps;
SideBar.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(function (state) {
  return {
    collapsed: state.sidebar.collapsed
  };
}, {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push,
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_9_loraactions_sidebar__["a" /* default */].toggleSidebar
})(__WEBPACK_IMPORTED_MODULE_4_react_css_modules___default()(SideBar, __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a, { allowMultiple: true })));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss__ = __webpack_require__(2153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var propTypes = {
  collapsed: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.node.isRequired
};

var SidebarContainer = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(SidebarContainer, _React$Component);

  function SidebarContainer(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SidebarContainer);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      collapsed: props.collapsed
    };
    return _this;
  }

  SidebarContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var collapsed = nextProps.collapsed;

    if (collapsed !== this.props.collapsed) {
      this.setState({ collapsed: collapsed });
    }
  };

  SidebarContainer.prototype.render = function render() {
    var collapsed = this.state.collapsed;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.content + " " + (collapsed ? __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.collapsed : '') },
      this.props.children
    );
  };

  return SidebarContainer;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

SidebarContainer.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function (state) {
  return {
    collapsed: state.sidebar.collapsed
  };
})(SidebarContainer));

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss__ = __webpack_require__(2154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var SortBtn = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(SortBtn, _React$Component);

  function SortBtn(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SortBtn);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      ascSort: props.ascSort,
      highLight: props.highLight
    };
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  SortBtn.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var highLight = nextProps.highLight;

    if (highLight !== this.props.highLight) {
      this.setState({ highLight: highLight });
    }
  };

  SortBtn.prototype.handleClick = function handleClick() {
    var ascSort = this.state.ascSort;
    var _props = this.props,
        handleSort = _props.handleSort,
        sortName = _props.sortName;

    this.setState({ ascSort: !ascSort });
    var sort = !ascSort ? sortName : "-" + sortName;
    handleSort(sort);
  };

  SortBtn.prototype.render = function render() {
    var _state = this.state,
        ascSort = _state.ascSort,
        highLight = _state.highLight;

    var sort = ascSort ? 'asc' : 'desc';
    var iconColor = highLight ? '' : __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.defalutColor;
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_router__["f" /* Link */],
      {
        className: "pull-right " + iconColor,
        onClick: this.handleClick
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-sort-alpha-" + sort, "aria-hidden": "true" })
    );
  };

  return SortBtn;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

SortBtn.propTypes = {
  sortName: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  ascSort: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool,
  handleSort: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  highLight: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool.isRequired
};

SortBtn.defaultProps = {
  ascSort: true
};

/* harmony default export */ __webpack_exports__["a"] = (SortBtn);

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(59);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* createTypesMap */])('account', ['basic', 'changePassword', 'reactivate', 'updateBasic', 'forgetPassword']);

function basic() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.basic, {
    endpoint: '/account/basic',
    method: 'GET'
  })();
}

function updateBasic(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.updateBasic, {
    endpoint: '/account/basic',
    method: 'PUT',
    body: data
  })();
}

function changePassword(oldPassword, newPassword) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.changePassword, {
    endpoint: '/account/password',
    method: 'PUT',
    body: { oldPassword: oldPassword, newPassword: newPassword }
  })();
}

function forgetPassword(email, key, verifyCode, ref) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.forgetPassword, {
    endpoint: '/account/forget',
    method: 'POST',
    body: {
      email: email,
      key: key,
      verifyCode: verifyCode,
      ref: ref
    }
  })();
}

function reactivate(email) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.reactivate, {
    endpoint: '/account/reactivate',
    method: 'POST',
    body: {
      ref: 'lora',
      email: email
    }
  })();
}

/* harmony default export */ __webpack_exports__["a"] = ({
  basic: basic,
  changePassword: changePassword,
  reactivate: reactivate,
  updateBasic: updateBasic,
  forgetPassword: forgetPassword
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(59);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* createTypesMap */])('org', ['basic', 'updateBasic']);

function basic() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.basic, {
    endpoint: '/org/basic',
    method: 'GET'
  })();
}

function updateBasic(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.updateBasic, {
    endpoint: '/org/basic',
    method: 'PUT',
    body: data
  })();
}

/* harmony default export */ __webpack_exports__["a"] = ({
  basic: basic,
  updateBasic: updateBasic
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return types; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNetwork; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateNodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateTdmGateways; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(59);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* createTypesMap */])('tdm', ['setting', 'getNetwork', 'updateNodes', 'updateTdmGateways']);

var getNetwork = function getNetwork() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* createAPIAction */])(types.getNetwork, {
    endpoint: '/tdmng/networks',
    method: 'GET'
  })();
};

var setting = function setting() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* createAPIAction */])(types.setting, {
    endpoint: '/orgdocs/types',
    method: 'GET'
  })();
};

var updateNodes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(types.updateNodes, function (payload) {
  return payload;
});
var updateTdmGateways = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(types.updateTdmGateways, function (payload) {
  return payload;
});

/* unused harmony default export */ var _unused_webpack_default_export = ({
  setting: setting,
  getNetwork: getNetwork,
  updateNodes: updateNodes,
  updateTdmGateways: updateTdmGateways
});

/***/ }),
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SelectionState
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Immutable = __webpack_require__(45);

var Record = Immutable.Record;


var defaultRecord = {
  anchorKey: '',
  anchorOffset: 0,
  focusKey: '',
  focusOffset: 0,
  isBackward: false,
  hasFocus: false
};

var SelectionStateRecord = Record(defaultRecord);

var SelectionState = function (_SelectionStateRecord) {
  _inherits(SelectionState, _SelectionStateRecord);

  function SelectionState() {
    _classCallCheck(this, SelectionState);

    return _possibleConstructorReturn(this, _SelectionStateRecord.apply(this, arguments));
  }

  SelectionState.prototype.serialize = function serialize() {
    return 'Anchor: ' + this.getAnchorKey() + ':' + this.getAnchorOffset() + ', ' + 'Focus: ' + this.getFocusKey() + ':' + this.getFocusOffset() + ', ' + 'Is Backward: ' + String(this.getIsBackward()) + ', ' + 'Has Focus: ' + String(this.getHasFocus());
  };

  SelectionState.prototype.getAnchorKey = function getAnchorKey() {
    return this.get('anchorKey');
  };

  SelectionState.prototype.getAnchorOffset = function getAnchorOffset() {
    return this.get('anchorOffset');
  };

  SelectionState.prototype.getFocusKey = function getFocusKey() {
    return this.get('focusKey');
  };

  SelectionState.prototype.getFocusOffset = function getFocusOffset() {
    return this.get('focusOffset');
  };

  SelectionState.prototype.getIsBackward = function getIsBackward() {
    return this.get('isBackward');
  };

  SelectionState.prototype.getHasFocus = function getHasFocus() {
    return this.get('hasFocus');
  };

  /**
   * Return whether the specified range overlaps with an edge of the
   * SelectionState.
   */


  SelectionState.prototype.hasEdgeWithin = function hasEdgeWithin(blockKey, start, end) {
    var anchorKey = this.getAnchorKey();
    var focusKey = this.getFocusKey();

    if (anchorKey === focusKey && anchorKey === blockKey) {
      var selectionStart = this.getStartOffset();
      var selectionEnd = this.getEndOffset();
      return start <= selectionEnd && selectionStart <= end;
    }

    if (blockKey !== anchorKey && blockKey !== focusKey) {
      return false;
    }

    var offsetToCheck = blockKey === anchorKey ? this.getAnchorOffset() : this.getFocusOffset();

    return start <= offsetToCheck && end >= offsetToCheck;
  };

  SelectionState.prototype.isCollapsed = function isCollapsed() {
    return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
  };

  SelectionState.prototype.getStartKey = function getStartKey() {
    return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
  };

  SelectionState.prototype.getStartOffset = function getStartOffset() {
    return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
  };

  SelectionState.prototype.getEndKey = function getEndKey() {
    return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
  };

  SelectionState.prototype.getEndOffset = function getEndOffset() {
    return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
  };

  SelectionState.createEmpty = function createEmpty(key) {
    return new SelectionState({
      anchorKey: key,
      anchorOffset: 0,
      focusKey: key,
      focusOffset: 0,
      isBackward: false,
      hasFocus: false
    });
  };

  return SelectionState;
}(SelectionStateRecord);

module.exports = SelectionState;

/***/ }),
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * This function is used to mark string literals representing CSS class names
 * so that they can be transformed statically. This allows for modularization
 * and minification of CSS class names.
 *
 * In static_upstream, this function is actually implemented, but it should
 * eventually be replaced with something more descriptive, and the transform
 * that is used in the main stack should be ported for use elsewhere.
 *
 * @param string|object className to modularize, or an object of key/values.
 *                      In the object case, the values are conditions that
 *                      determine if the className keys should be included.
 * @param [string ...]  Variable list of classNames in the string case.
 * @return string       Renderable space-separated CSS className.
 */
function cx(classNames) {
  if (typeof classNames == 'object') {
    return Object.keys(classNames).filter(function (className) {
      return classNames[className];
    }).map(replace).join(' ');
  }
  return Array.prototype.map.call(arguments, replace).join(' ');
}

function replace(str) {
  return str.replace(/\//g, '-');
}

module.exports = cx;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(57);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(68);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(195);

var _Actions = __webpack_require__(388);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(312),
    arrayMap = __webpack_require__(391),
    isArray = __webpack_require__(80),
    isSymbol = __webpack_require__(319);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(169),
    isArray = __webpack_require__(80),
    isObjectLike = __webpack_require__(151);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(855),
    baseKeys = __webpack_require__(863),
    isArrayLike = __webpack_require__(150);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compilePattern */
/* harmony export (immutable) */ __webpack_exports__["b"] = matchPattern;
/* harmony export (immutable) */ __webpack_exports__["a"] = getParamNames;
/* unused harmony export getParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = formatPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? invariant(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? invariant(false, 'Path "%s" is missing end paren', pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_warning___default.a.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = getBills;
/* harmony export (immutable) */ __webpack_exports__["c"] = getBill;
/* harmony export (immutable) */ __webpack_exports__["d"] = getCdrs;
/* harmony export (immutable) */ __webpack_exports__["b"] = createCharge;
/* unused harmony export getUserPlan */
/* unused harmony export getAvailablePlans */
/* harmony export (immutable) */ __webpack_exports__["f"] = applyAcctCode;
/* unused harmony export getBillingInfo */
/* harmony export (immutable) */ __webpack_exports__["a"] = rechgCard;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_ceil__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_ceil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_ceil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_round__ = __webpack_require__(2510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_round___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_round__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(240);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




function getBills(df, dt, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */])('get', '/accounting/bills', {
    df: df,
    dt: dt,
    pageSize: 1000
  }, {}, callback);
}

function getBill(id, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */])('get', "/accounting/bills/" + id, {}, {}, callback);
}

function getCdrs(bill, args, callback) {
  args = args || {};
  args.bill = bill;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */])('get', '/accounting/cdrs', args, {}, callback);
}

function createCharge(product, method, amount, plan, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */])('post', '/charging/', {}, {
    product: product,
    method: method,
    amount: amount,
    plan: plan
  }, callback);
}

function getUserPlan(callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */])('get', '/accounting/plan', {}, {}, callback);
}

function getAvailablePlans(callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */])('get', '/accounting/availableplans', {}, {}, callback);
}

function applyAcctCode(acctCode, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */])('post', '/org/acctcode/apply', { acctcode: acctCode }, {}, callback);
}

function getBillingInfo() {
  var orgBasic = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */])('get', '/org/basic', {}, {});
  var accountBasic = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */])('get', '/account/basic', {}, {});
  var plan = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */])('get', '/accounting/plan', {}, {});
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([orgBasic, accountBasic, plan]).then(function (resps) {
      var ob = resps[0],
          ab = resps[1],
          p = resps[2];

      var result = {
        nick: ab.body.name,
        email: ob.body.email,
        balance: __WEBPACK_IMPORTED_MODULE_3_lodash_round___default()(ob.body.balance, 2),
        expired: !__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(p.body.svcExpire) && p.body.svcExpire < 0.001,
        remaining: __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(p.body.svcExpire) ? 0 : __WEBPACK_IMPORTED_MODULE_1_lodash_ceil___default()(p.body.svcExpire),
        tier: p.body.tier,
        billday: p.body.billday,
        lrnodenum: ob.body.lrnodenum
      };
      resolve(result);
    }).catch(function (reason) {
      reject(reason);
    });
  });
}
function rechgCard(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */])('post', "/account/rechgcard/" + id + "/apply", {}, {});
}

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_echarts__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_bar__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_tooltip__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_title__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_legend__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_grid__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_echarts_lib_component_dataZoom__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_echarts_lib_component_dataZoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_echarts_lib_component_dataZoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_scss__ = __webpack_require__(2120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);












var defaultProps = {
  height: 300,
  width: null,
  legend: null,
  xAxis: null,
  yAxis: null,
  grid: null,
  dataZoom: null,
  tooltip: null
};

var propTypes = {
  series: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.array.isRequired,
  categories: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.array.isRequired,
  legend: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any,
  xAxis: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any,
  yAxis: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any,
  grid: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any,
  dataZoom: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any,
  height: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.number,
  tooltip: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object
};

var BarChart = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(BarChart, _React$Component);

  function BarChart(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, BarChart);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      series: props.series,
      categories: props.categories,
      legend: props.legend
    };
    _this.tryResizeChart = _this.tryResizeChart.bind(_this);
    return _this;
  }

  BarChart.prototype.componentDidMount = function componentDidMount() {
    this.echart = this.initChart();
    this.echart.resize();
    $(window).resize(this.tryResizeChart);
  };

  BarChart.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var series = nextProps.series,
        categories = nextProps.categories,
        legend = nextProps.legend;

    if (series !== this.props.series) {
      this.updateChart(series, categories, legend);
      this.setState({
        series: nextProps.series,
        categories: nextProps.categories,
        legend: nextProps.legend
      });
    }
    this.tryResizeChart();
  };

  BarChart.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_5_echarts_lib_echarts___default.a.dispose($(this.chartRef));
    $(window).off('resize', this.tryResizeChart);
  };

  BarChart.prototype.tryResizeChart = function tryResizeChart() {
    var width = $(this.chartRef).width();
    var height = $(this.chartRef).height();
    if (height !== this.height || width !== this.width) {
      if (this.echart) {
        this.echart.resize();
      }
    }
    this.width = width;
    this.height = height;
  };

  BarChart.prototype.updateChart = function updateChart(nextSeries, nextCategories, nextLegend) {
    var thisSeries = this.state.series;

    var series = nextSeries.map(function (s) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, s, {
        name: s.name,
        data: s.data,
        type: 'bar',
        yAxisIndex: s.yAxisIndex
      });
    });
    var legend = nextLegend || [];
    var option = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.echart.getOption(), {
      series: series,
      legend: legend
    });
    if (nextCategories) {
      option.xAxis = {
        data: nextCategories
      };
    }
    if (!_.isEqual(_.map(thisSeries, 'name'), _.map(nextSeries, 'name'))) {
      // reset option
      this.echart.clear();
    }
    this.echart.setOption(option);
    this.echart.resize();
  };

  BarChart.prototype.initChart = function initChart() {
    var echart = __WEBPACK_IMPORTED_MODULE_5_echarts_lib_echarts___default.a.init(this.chartRef);
    var series = this.state.series.map(function (s) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, s, {
        name: s.name,
        data: s.data,
        type: 'bar',
        lineStyle: {
          normal: {
            width: 2
          }
        },
        areaStyle: {
          normal: {
            opacity: 0.1
          }
        }
      });
    });

    // xAxis
    var xAxis = {
      name: '',
      axisLine: {
        lineStyle: {
          color: '#ABB7B7'
        }
      },
      splitLine: {
        show: false
      },
      boundaryGap: true
    };
    if (this.props.xAxis) {
      if (_.isArray(this.props.xAxis)) {
        xAxis = this.props.xAxis.map(function (xa) {
          return _.extend({}, xAxis, xa);
        });
      } else {
        xAxis = _.extend(xAxis, this.props.xAxis);
      }
    }

    // yAxis
    var yAxis = {
      name: '',
      axisLine: {
        lineStyle: {
          color: '#ABB7B7'
        }
      },
      splitLine: {
        show: false
      }
    };
    if (this.props.yAxis) {
      if (_.isArray(this.props.yAxis)) {
        yAxis = this.props.yAxis.map(function (ya) {
          return _.extend({}, yAxis, ya);
        });
      } else {
        yAxis = _.extend(yAxis, this.props.yAxis);
      }
    }

    // legends
    var legend = this.state.legend || [];
    var _props = this.props,
        grid = _props.grid,
        dataZoom = _props.dataZoom,
        tooltip = _props.tooltip;


    var option = {
      xAxis: xAxis,
      yAxis: yAxis,
      legend: legend,
      grid: grid,
      dataZoom: dataZoom,
      series: series,
      color: BarChart.colors,
      textStyle: {
        fontSize: 12,
        fontWeight: 300
      },
      tooltip: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        trigger: 'axis'
      }, tooltip),
      animationEasing: 'cubicIn'
    };
    if (this.state.categories) {
      option.xAxis.data = this.state.categories;
    }
    echart.setOption(option);
    return echart;
  };

  BarChart.prototype.render = function render() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.chart,
      ref: function ref(_ref) {
        _this2.chartRef = _ref;
      },
      style: { height: this.props.height }
    });
  };

  return BarChart;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

BarChart.colors = ['#22A7F0', '#00B16A', '#F7CA18', '#F9690E', '#EF4836', '#DB0A5B', '#663399', '#BF55EC', '#446CB3', '#336E7B', '#1BBC9B'];
BarChart.propTypes = propTypes;
BarChart.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_react_redux__["connect"])(function (state) {
  return {
    collapsed: state.sidebar.collapsed
  };
})(BarChart));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__ = __webpack_require__(7);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  showModal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  onConfirm: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onCancel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  headerText: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  text: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired
};
var defaultProps = {
  onConfirm: function onConfirm() {},
  onCancel: function onCancel() {}
};

var DeleteModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeleteModal, _React$Component);

  function DeleteModal(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeleteModal);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      showModal: props.showModal
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.dashboard');
    return _this;
  }

  DeleteModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var showModal = nextProps.showModal;

    if (showModal !== this.props.showModal) {
      this.setState({ showModal: showModal });
    }
  };

  DeleteModal.prototype.render = function render() {
    var showModal = this.state.showModal;
    var _props = this.props,
        headerText = _props.headerText,
        text = _props.text,
        onCancel = _props.onCancel,
        onConfirm = _props.onConfirm;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-danger",
        show: showModal,
        onHide: function onHide() {
          return onCancel();
        }
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Header,
        { className: "text-center", closeButton: true },
        headerText
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "p",
            null,
            text
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
            {
              bsStyle: "aisz-warning",
              onClick: function onClick() {
                return onCancel();
              }
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle", "aria-hidden": "true" }),
            "\xA0",
            this.intlMsg.msg('cancel')
          ),
          "\xA0",
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
            {
              bsStyle: "aisz-danger",
              onClick: function onClick() {
                return onConfirm();
              }
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle", "aria-hidden": "true" }),
            "\xA0",
            this.intlMsg.msg('confirm')
          )
        )
      )
    );
  };

  return DeleteModal;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DeleteModal.propTypes = propTypes;
DeleteModal.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(DeleteModal));

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_animate_css_animate_min_css__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_animate_css_animate_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_animate_css_animate_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_every__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_has__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNil__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_Editable__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_Copy__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss__ = __webpack_require__(2142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);


















var defaultProps = {
  readOnly: false,
  show: {},
  status: 'absent',
  errors: new __WEBPACK_IMPORTED_MODULE_16_lorautils_errors_ErrorSet__["a" /* default */](),
  onSubmit: function onSubmit() {},
  onChange: function onChange() {},
  onCancel: function onCancel() {},
  onEdit: function onEdit() {},
  children: null
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.any.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.oneOfType([__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string, __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object]).isRequired,
  properties: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.array.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  status: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired,
  show: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  readOnly: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.bool.isRequired,
  errors: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object,
  onSubmit: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func,
  onChange: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func,
  onCancel: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func,
  onEdit: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func,
  children: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.node
};

var PropsPanel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PropsPanel, _React$Component);

  function PropsPanel(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PropsPanel);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      data: props.data,
      status: props.status,
      show: props.show,
      errors: props.errors,
      properties: props.properties,
      dirtyIds: []
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleCancel = _this.handleCancel.bind(_this);
    _this.handleEnableEdit = _this.handleEnableEdit.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_17_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'lora.coms.propspanel');
    return _this;
  }

  PropsPanel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var data = nextProps.data,
        show = nextProps.show,
        properties = nextProps.properties,
        errors = nextProps.errors,
        status = nextProps.status;

    if (data !== this.props.data) {
      this.setState({ data: data });
    }
    if (show !== this.props.show) {
      this.setState({ show: show });
    }
    if (properties !== this.props.properties) {
      this.setState({ properties: properties });
    }
    if (errors !== this.props.errors) {
      this.setState({ errors: errors });
    }
    if (status !== this.props.status) {
      this.setState({ status: status });
    }
  };

  PropsPanel.prototype.editIds = function editIds() {
    var properties = this.state.properties;

    return properties.filter(function (p) {
      return !p.readOnly;
    }).map(function (p) {
      return p.id;
    });
  };

  PropsPanel.prototype.shouldShowEdit = function shouldShowEdit() {
    var readOnly = this.props.readOnly;
    var properties = this.state.properties;

    if (readOnly) {
      return false;
    }
    if (__WEBPACK_IMPORTED_MODULE_7_lodash_every___default()(properties, function (p) {
      return p.readOnly;
    })) {
      return false;
    }
    return true;
  };

  PropsPanel.prototype.handleChange = function handleChange(editData, id) {
    var dirtyIds = this.state.dirtyIds;

    dirtyIds = [].concat(dirtyIds, [id]);
    this.setState({ editData: editData, dirtyIds: dirtyIds });
    var onChange = this.props.onChange;

    if (onChange) {
      onChange(editData, id);
    }
  };

  PropsPanel.prototype.handleSubmit = function handleSubmit() {
    this.submitted = true;
    var onSubmit = this.props.onSubmit;
    var _state = this.state,
        editData = _state.editData,
        dirtyIds = _state.dirtyIds;

    var success = onSubmit(editData, dirtyIds, this.editIds());
    this.setState({ edit: !success });
    this.submitted = !success;
  };

  PropsPanel.prototype.handleCancel = function handleCancel() {
    this.submitted = false;
    this.setState({ edit: false });
    var onCancel = this.props.onCancel;

    if (onCancel) {
      onCancel(this.editIds());
    }
  };

  PropsPanel.prototype.handleEnableEdit = function handleEnableEdit() {
    var data = this.state.data;

    this.setState({
      edit: true,
      editData: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data),
      dirtyIds: []
    });
    var onEdit = this.props.onEdit;

    onEdit();
  };

  PropsPanel.prototype.render = function render() {
    var _this2 = this;

    var _state2 = this.state,
        _state2$edit = _state2.edit,
        edit = _state2$edit === undefined ? false : _state2$edit,
        show = _state2.show,
        data = _state2.data,
        _state2$editData = _state2.editData,
        editData = _state2$editData === undefined ? {} : _state2$editData,
        errors = _state2.errors,
        status = _state2.status;

    var shouldShow = function shouldShow(p) {
      var showFlags = void 0;
      if (edit) {
        showFlags = show.edit;
      } else {
        showFlags = show.display;
      }
      return !__WEBPACK_IMPORTED_MODULE_8_lodash_has___default()(showFlags, p.id) || showFlags[p.id];
    };

    var properties = this.state.properties;

    properties = properties.filter(shouldShow);

    var propNodes = properties.map(function (prop) {
      var id = prop.id,
          name = prop.name,
          unit = prop.unit,
          control = prop.control,
          _prop$readOnly = prop.readOnly,
          readOnly = _prop$readOnly === undefined ? false : _prop$readOnly,
          _prop$copy = prop.copy,
          copy = _prop$copy === undefined ? false : _prop$copy,
          _prop$formatter = prop.formatter,
          formatter = _prop$formatter === undefined ? function (x) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_Nvl__["a" /* default */], { val: x, nul: "empty", status: status });
      } : _prop$formatter;


      var clipboard = null;
      if (copy) {
        var clipVal = copy(data[id]);
        clipboard = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_Copy__["a" /* default */], { id: "copy-" + id, text: String(clipVal) });
      }

      var error = void 0;
      if (_this2.submitted && errors) {
        error = errors.getArg(id, 'message');
      }

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "li",
        { key: id },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "span",
          { styleName: "pname" },
          name
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "span",
          { styleName: "pval " + (error ? 'error' : '') },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Editable__["a" /* default */], {
            id: id,
            value: data[id],
            edit: edit && !readOnly,
            data: editData,
            control: control,
            onChange: function onChange(ed) {
              return _this2.handleChange(ed, id);
            },
            formatter: formatter,
            error: error
          }),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12_loracoms_ShowIf__["a" /* default */],
            { "if": !__WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(unit) },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "span",
              null,
              ' ',
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "span",
                { styleName: "punit" },
                unit
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12_loracoms_ShowIf__["a" /* default */],
            { "if": !edit },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "span",
              null,
              ' ',
              clipboard
            )
          )
        )
      );
    });

    var title = this.props.title;

    var header = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "span",
        null,
        title
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_loracoms_ShowIf__["a" /* default */],
        { "if": this.shouldShowEdit() },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "ul",
          { className: "icontools" },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "li",
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Button"],
              {
                bsStyle: "aisz-link",
                className: "icon",
                onClick: this.handleEnableEdit,
                disabled: edit || status === 'pending'
              },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "glyphicons glyphicons-pencil" })
            )
          )
        )
      )
    );

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: header },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "ul",
        { styleName: "plist" },
        propNodes
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_loracoms_ShowIf__["a" /* default */],
        { "if": edit },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: "pull-right" },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Button"],
            { bsStyle: "aisz-link", onClick: this.handleCancel },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "span",
              { styleName: "cancelBtn" },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "glyphicons glyphicons-remove" })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Button"],
            { bsStyle: "aisz-link", onClick: this.handleSubmit },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "span",
              { styleName: "submitBtn" },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "glyphicons glyphicons-ok" })
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: "clearfix" }),
      this.props.children
    );
  };

  return PropsPanel;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PropsPanel.defaultProps = defaultProps;
PropsPanel.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_6_react_css_modules___default()(PropsPanel, __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a, { allowMultiple: true })));

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_main_scss__ = __webpack_require__(2151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_main_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);








var propTypes = {
  options: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.array.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.bool,
  multiple: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func,
  bsSize: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string,
  bsStyle: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string
};

var defaultProps = {
  bsStyle: 'aisz-primary',
  multiple: false
};

var SelectPills = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(SelectPills, _React$Component);

  SelectPills.parseSelected = function parseSelected(options) {
    var selected = [];
    options.forEach(function (opt) {
      if (opt.active) {
        selected.push(opt.value);
      }
    });
    return selected;
  };

  function SelectPills(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SelectPills);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      selected: SelectPills.parseSelected(props.options),
      disabled: props.disabled
    };
    _this.toggleSelect = _this.toggleSelect.bind(_this);
    return _this;
  }

  SelectPills.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!_.eq(nextProps.disabled, this.props.disabled)) {
      this.setState({
        disabled: nextProps.disabled
      });
    }
  };

  SelectPills.prototype.active = function active(opt) {
    return this.state.selected.some(function (v) {
      return v === opt.value;
    });
  };

  SelectPills.prototype.toggleSelect = function toggleSelect(value) {
    var _props$multiple = this.props.multiple,
        multiple = _props$multiple === undefined ? false : _props$multiple;
    var selected = this.state.selected;

    if (multiple) {
      if (selected.includes(value)) {
        selected = _.filter(selected, function (v) {
          return v !== value;
        });
        this.setState({ selected: selected });
      } else {
        selected.push(value);
        this.setState({ selected: selected });
      }
    } else {
      selected = [value];
      this.setState({ selected: selected });
    }
    if (this.props.onChange) {
      this.props.onChange(selected);
    }
  };

  SelectPills.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        bsStyle = _props.bsStyle,
        bsSize = _props.bsSize,
        options = _props.options;
    var disabled = this.state.disabled;

    var opts = options.map(function (opt) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
        {
          key: opt.value,
          bsSize: bsSize,
          bsStyle: _this2.active(opt) ? bsStyle : 'aisz-light',
          onClick: function onClick() {
            return _this2.toggleSelect(opt.value);
          },
          disabled: disabled
        },
        opt.name
      );
    });

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { styleName: "select-pills" },
      opts
    );
  };

  return SelectPills;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

SelectPills.propTypes = propTypes;
SelectPills.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6_react_css_modules___default()(SelectPills, __WEBPACK_IMPORTED_MODULE_7__styles_main_scss___default.a, { allowMultiple: true }));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 282 */,
/* 283 */,
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(157);
var call = __webpack_require__(651);
var isArrayIter = __webpack_require__(649);
var anObject = __webpack_require__(156);
var toLength = __webpack_require__(343);
var getIterFn = __webpack_require__(665);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule BlockMapBuilder
 * @format
 * 
 */



var Immutable = __webpack_require__(45);

var OrderedMap = Immutable.OrderedMap;


var BlockMapBuilder = {
  createFromArray: function createFromArray(blocks) {
    return OrderedMap(blocks.map(function (block) {
      return [block.getKey(), block];
    }));
  }
};

module.exports = BlockMapBuilder;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule findRangesImmutable
 * @format
 * 
 */



/**
 * Search through an array to find contiguous stretches of elements that
 * match a specified filter function.
 *
 * When ranges are found, execute a specified `found` function to supply
 * the values to the caller.
 */
function findRangesImmutable(haystack, areEqualFn, filterFn, foundFn) {
  if (!haystack.size) {
    return;
  }

  var cursor = 0;

  haystack.reduce(function (value, nextValue, nextIndex) {
    if (!areEqualFn(value, nextValue)) {
      if (filterFn(value)) {
        foundFn(cursor, nextIndex);
      }
      cursor = nextIndex;
    }
    return nextValue;
  });

  filterFn(haystack.last()) && foundFn(cursor, haystack.count());
}

module.exports = findRangesImmutable;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isEventHandled
 * @format
 * 
 */



/**
 * Utility method for determining whether or not the value returned
 * from a handler indicates that it was handled.
 */
function isEventHandled(value) {
  return value === 'handled' || value === true;
}

module.exports = isEventHandled;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule removeTextWithStrategy
 * @format
 * 
 */



var DraftModifier = __webpack_require__(107);

/**
 * For a collapsed selection state, remove text based on the specified strategy.
 * If the selection state is not collapsed, remove the entire selected range.
 */
function removeTextWithStrategy(editorState, strategy, direction) {
  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var target = selection;
  if (selection.isCollapsed()) {
    if (direction === 'forward') {
      if (editorState.isSelectionAtEndOfContent()) {
        return content;
      }
    } else if (editorState.isSelectionAtStartOfContent()) {
      return content;
    }

    target = strategy(editorState);
    if (target === selection) {
      return content;
    }
  }
  return DraftModifier.removeRange(content, target, direction);
}

module.exports = removeTextWithStrategy;

/***/ }),
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.Immutable = factory());
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step !== 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      if (o !== o || o === Infinity) {
        return 0;
      }
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
      return emptyMap().withMutations(function(map ) {
        for (var i = 0; i < keyValues.length; i += 2) {
          if (i + 1 >= keyValues.length) {
            throw new Error('Missing value for key: ' + keyValues[i]);
          }
          map.set(keyValues[i], keyValues[i + 1]);
        }
      });
    };

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      if (end === Infinity) {
        end = originalSize;
      } else {
        end = end | 0;
      }
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      if (this._map && !this._map.has(k)) {
        var defaultVal = this._defaultValues[k];
        if (v === defaultVal) {
          return this;
        }
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findEntry: function(predicate, context, notSetValue) {
      var found = notSetValue;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    findLastEntry: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },

    findLastKey: function(predicate, context) {
      return this.toKeyedSeq().reverse().findKey(predicate, context);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    lastKeyOf: function(searchValue) {
      return this.toKeyedSeq().reverse().keyOf(searchValue);
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.lastKeyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var entry = this.findLastEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    keySeq: function() {
      return Range(0, this.size);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;
  SetIterable.prototype.contains = SetIterable.prototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : String(value);
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(149);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(873);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(393),
    createBaseEach = __webpack_require__(2447);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 315 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 316 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(2421),
    hasPath = __webpack_require__(878);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(2423),
    isObjectLike = __webpack_require__(151);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(169),
    isObjectLike = __webpack_require__(151);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = falsy;
/* unused harmony export history */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return components; });
/* unused harmony export route */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  listen: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]);
var components = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([component, __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]]);
var route = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["element"]]);
var routes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([route, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(route)]);

/***/ }),
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_animate_css_animate_min_css__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_animate_css_animate_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_animate_css_animate_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var defaultProps = {
  status: 'ready',
  icon: null,
  label: null,
  successLabel: null,
  failedLabel: null,
  loadingLabel: null,
  disabled: false,
  className: null,
  type: null,
  onClick: function onClick() {},
  onStatusReset: function onStatusReset() {}
};

var propTypes = {
  status: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string,
  icon: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.node,
  label: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.node,
  successLabel: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.node,
  failedLabel: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.node,
  loadingLabel: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.node,
  disabled: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.bool,
  className: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string,
  type: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string,
  onClick: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func,
  onStatusReset: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func
};

var ActionButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ActionButton, _React$Component);

  function ActionButton(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ActionButton);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      status: props.status
    };
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  ActionButton.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.status !== this.props.status) {
      this.setState({
        status: nextProps.status
      });

      if (nextProps.status === 'success' || nextProps.status === 'failed') {
        this.fireStatusResetTimer();
      }
    }
  };

  ActionButton.prototype.fireStatusResetTimer = function fireStatusResetTimer() {
    var _this2 = this;

    setTimeout(function () {
      if (_this2.props.onStatusReset) {
        _this2.props.onStatusReset();
      }
    }, 3000);
  };

  ActionButton.prototype.handleClick = function handleClick() {
    if (this.state.status === 'ready') {
      if (this.props.onClick) {
        this.props.onClick();
      }
    }
  };

  ActionButton.prototype.render = function render() {
    var _props = this.props,
        icon = _props.icon,
        label = _props.label,
        successLabel = _props.successLabel,
        failedLabel = _props.failedLabel,
        loadingLabel = _props.loadingLabel,
        disabled = _props.disabled;

    var status = this.state.status;
    var bsStyle = 'aisz-primary';
    var content = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "span",
      null,
      icon,
      " ",
      ' ',
      " ",
      label
    );
    if (status === 'success' && successLabel) {
      bsStyle = 'aisz-success';
      content = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "span",
        { className: "animated fadeIn" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-check-circle" }),
        ' ',
        successLabel
      );
    } else if (status === 'failed' && failedLabel) {
      bsStyle = 'aisz-danger';
      content = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "span",
        { className: "animated fadeIn" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle" }),
        ' ',
        failedLabel
      );
    } else if (status === 'loading' && loadingLabel) {
      content = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "span",
        { className: "animated fadeIn" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" }),
        ' ',
        loadingLabel
      );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
      {
        className: this.props.className,
        bsStyle: bsStyle,
        onClick: this.handleClick,
        disabled: status === 'loading' || disabled,
        type: this.props.type
      },
      content
    );
  };

  return ActionButton;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ActionButton.defaultProps = defaultProps;
ActionButton.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (ActionButton);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_scss__ = __webpack_require__(2119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var defaultProps = {
  className: '',
  content: '',
  inverse: false,
  theme: 'auto',
  shift: 0,
  enums: null,
  children: null
};
var propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string,
  content: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string,
  inverse: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool,
  theme: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.oneOf(['auto', 'blue', 'red', 'green', 'yellow']),
  shift: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.number,
  enums: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.oneOfType([__WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.array, __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func]),
  children: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.node
};

var AutoColor = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(AutoColor, _React$Component);

  function AutoColor() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AutoColor);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  AutoColor.prototype.colorClass = function colorClass() {
    var _props = this.props,
        content = _props.content,
        inverse = _props.inverse,
        shift = _props.shift,
        enums = _props.enums;
    var theme = this.props.theme;


    var text = String(content || '');
    if (text === '') {
      return '';
    }

    var index = -1;
    if (enums) {
      if (_.isArray(enums)) {
        var ei = enums.findIndex(function (e) {
          return e.content === content;
        });
        if (ei >= 0) {
          index = ei;
          theme = enums[ei].theme || theme;
        }
      } else if (_.isFunction(enums)) {
        var e = enums(content);
        index = e.index || index;
        theme = e.theme || theme;
      }
    }
    if (index < 0) {
      index = 0;
      for (var i = 0; i < text.length; i += 1) {
        index += text.charCodeAt(i);
      }
      if (shift) {
        index += shift;
      }
    }

    if (theme === 'auto') {
      theme = ['blue', 'red', 'green', 'yellow'][index % 4];
    }
    if (inverse) {
      return "fg-" + theme + "-" + index % 21;
    }
    return "bg-" + theme + "-" + index % 21;
  };

  AutoColor.prototype.render = function render() {
    var className = this.props.className;

    var color = this.colorClass();
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "span",
      { className: __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a[color] + " " + className },
      this.props.children
    );
  };

  return AutoColor;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

AutoColor.defaultProps = defaultProps;
AutoColor.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (AutoColor);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loracoms_SelectPills__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__ = __webpack_require__(7);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  plan: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object,
  bsSize: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string
};

var DataDirSwitch = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DataDirSwitch, _React$Component);

  function DataDirSwitch(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DataDirSwitch);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      plan: props.plan
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__["a" /* default */](props.intl);
    return _this;
  }

  DataDirSwitch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var plan = nextProps.plan;

    if (plan !== this.props.plan) {
      this.setState({ plan: plan });
    }
  };

  DataDirSwitch.prototype.render = function render() {
    var _props = this.props,
        _onChange = _props.onChange,
        bsSize = _props.bsSize;
    var plan = this.state.plan;


    if (plan.status !== 'success') {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" });
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_loracoms_SelectPills__["a" /* default */], {
      options: [{
        name: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-long-arrow-up" }),
          this.intlMsg.msg('lora.datadir.up')
        ),
        value: 'up',
        active: true
      }, {
        name: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-long-arrow-down" }),
          this.intlMsg.msg('lora.datadir.down')
        ),
        value: 'down'
      }],
      bsSize: bsSize,
      onChange: function onChange(selected) {
        return _onChange(selected[0]);
      },
      disabled: plan.data.tier === 1
    });
  };

  return DataDirSwitch;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DataDirSwitch.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    plan: state.billing.plan
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(DataDirSwitch)));

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_scss__ = __webpack_require__(2126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_scss__);

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);






var DetailEye = function DetailEye(props) {
  var tooltip = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["Tooltip"],
    { id: "tooltip-vd" },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["FormattedMessage"], {
      id: "lora.tooltip.viewdetail",
      defaultMessage: "View detail"
    })
  );

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["OverlayTrigger"],
    { placement: "top", overlay: tooltip },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      "button",
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: "icon " + __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.btnLink }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", { className: "glyphicons glyphicons-eye-open" })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (DetailEye);

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(59);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* createTypesMap */])('billing', ['plan', 'getBalog']);

function plan() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.plan, {
    endpoint: '/accounting/plan'
  })();
}

function getBalog(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getBalog, {
    endpoint: "/charging/" + id + "/balogs"
  })();
}

/* harmony default export */ __webpack_exports__["a"] = ({
  plan: plan,
  getBalog: getBalog
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(59);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* createTypesMap */])('flow', ['getFlows', 'countFlows']);

function getFlows(appId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getFlows, {
    endpoint: '/lora/flows',
    query: {
      appid: appId
    }
  })();
}

function countFlows(query) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.countFlows, {
    endpoint: '/lora/flows/count',
    query: query
  })();
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getFlows: getFlows,
  countFlows: countFlows
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(59);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* createTypesMap */])('reigster', ['captcha', 'checkEmail']);

function captcha() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.captcha, {
    endpoint: '/authentication/captcha'
  })();
}

function checkEmail(email) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.checkEmail, {
    endpoint: '/check/email',
    body: {
      email: email
    },
    method: 'POST'
  })();
}

function resetCheckEmail() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* createResetAPIAction */])(types.checkEmail)();
}

/* harmony default export */ __webpack_exports__["a"] = ({
  types: types,
  captcha: captcha,
  checkEmail: checkEmail,
  resetCheckEmail: resetCheckEmail
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(59);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* createTypesMap */])('roadtest', ['getTimes', 'getDevice', 'getGateway', 'getGpsColor', 'getRadius', 'updateGps', 'startDwnld']);

var getTimes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(types.getTimes, function (times) {
  return times;
});
var getDevice = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(types.getDevice, function (device) {
  return device;
});
var getGateway = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(types.getGateway, function (gateway) {
  return gateway;
});
var getGpsColor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(types.getGpsColor, function (colors) {
  return colors;
});
var getRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(types.getRadius, function (radius) {
  return radius;
});
var updateGps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(types.updateGps, function (u) {
  return u;
});
var startDwnld = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(types.startDwnld, function (s) {
  return s;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  getTimes: getTimes,
  getDevice: getDevice,
  getGateway: getGateway,
  getGpsColor: getGpsColor,
  getRadius: getRadius,
  updateGps: updateGps,
  startDwnld: startDwnld
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = allSuccess;
/* harmony export (immutable) */ __webpack_exports__["c"] = someFailure;
/* harmony export (immutable) */ __webpack_exports__["d"] = findFailure;
/* harmony export (immutable) */ __webpack_exports__["b"] = somePending;
/* unused harmony export pending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_every__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_some__ = __webpack_require__(2511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find__ = __webpack_require__(2498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_find__);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





function allSuccess() {
  for (var _len = arguments.length, results = Array(_len), _key = 0; _key < _len; _key++) {
    results[_key] = arguments[_key];
  }

  return __WEBPACK_IMPORTED_MODULE_0_lodash_every___default()(results, function (r) {
    return r.status === 'success';
  });
}

function someFailure() {
  for (var _len2 = arguments.length, results = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    results[_key2] = arguments[_key2];
  }

  return __WEBPACK_IMPORTED_MODULE_1_lodash_some___default()(results, function (r) {
    return r.status === 'failure';
  });
}

function findFailure() {
  for (var _len3 = arguments.length, results = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    results[_key3] = arguments[_key3];
  }

  return __WEBPACK_IMPORTED_MODULE_2_lodash_find___default()(results, function (r) {
    return r.status === 'failure';
  });
}

function somePending() {
  for (var _len4 = arguments.length, results = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    results[_key4] = arguments[_key4];
  }

  return __WEBPACK_IMPORTED_MODULE_1_lodash_some___default()(results, function (r) {
    return r.status === 'pending';
  });
}

function pending() {
  var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return result.status === 'request' || result.status === 'pending';
}

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateMarks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pageParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

var updateMarks = function updateMarks(oldMarks, mark) {
  var marks = _.uniq(_.concat(oldMarks, [mark]));
  marks = _.take(marks, _.indexOf(marks, mark) + 1);

  return marks;
};

var PageParams = function () {
  function PageParams() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PageParams);

    this.data = {};
  }

  PageParams.prototype.setMarks = function setMarks(m, key) {
    this.data[key] = m;
  };

  PageParams.prototype.getMarks = function getMarks(key) {
    return this.data[key];
  };

  PageParams.prototype.setFilter = function setFilter(t, key) {
    this.data[key] = t;
  };

  PageParams.prototype.getFilter = function getFilter(key) {
    return this.data[key];
  };

  return PageParams;
}();

var pageParams = new PageParams();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(36);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEntity
 * @format
 * 
 */

var DraftEntityInstance = __webpack_require__(752);
var Immutable = __webpack_require__(45);

var invariant = __webpack_require__(23);

var Map = Immutable.Map;


var instances = Map();
var instanceKey = 0;

/**
 * Temporary utility for generating the warnings
 */
function logWarning(oldMethodCall, newMethodCall) {
  console.warn('WARNING: ' + oldMethodCall + ' will be deprecated soon!\nPlease use "' + newMethodCall + '" instead.');
}

/**
 * A "document entity" is an object containing metadata associated with a
 * piece of text in a ContentBlock.
 *
 * For example, a `link` entity might include a `uri` property. When a
 * ContentBlock is rendered in the browser, text that refers to that link
 * entity may be rendered as an anchor, with the `uri` as the href value.
 *
 * In a ContentBlock, every position in the text may correspond to zero
 * or one entities. This correspondence is tracked using a key string,
 * generated via DraftEntity.create() and used to obtain entity metadata
 * via DraftEntity.get().
 */
var DraftEntity = {
  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getLastCreatedEntityKey' instead.
   * ---
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  getLastCreatedEntityKey: function getLastCreatedEntityKey() {
    logWarning('DraftEntity.getLastCreatedEntityKey', 'contentState.getLastCreatedEntityKey');
    return DraftEntity.__getLastCreatedEntityKey();
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.createEntity' instead.
   * ---
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  create: function create(type, mutability, data) {
    logWarning('DraftEntity.create', 'contentState.createEntity');
    return DraftEntity.__create(type, mutability, data);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.addEntity' instead.
   * ---
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  add: function add(instance) {
    logWarning('DraftEntity.add', 'contentState.addEntity');
    return DraftEntity.__add(instance);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getEntity' instead.
   * ---
   * Retrieve the entity corresponding to the supplied key string.
   */
  get: function get(key) {
    logWarning('DraftEntity.get', 'contentState.getEntity');
    return DraftEntity.__get(key);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.mergeEntityData' instead.
   * ---
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  mergeData: function mergeData(key, toMerge) {
    logWarning('DraftEntity.mergeData', 'contentState.mergeEntityData');
    return DraftEntity.__mergeData(key, toMerge);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.replaceEntityData' instead.
   * ---
   * Completely replace the data for a given instance.
   */
  replaceData: function replaceData(key, newData) {
    logWarning('DraftEntity.replaceData', 'contentState.replaceEntityData');
    return DraftEntity.__replaceData(key, newData);
  },

  // ***********************************WARNING******************************
  // --- the above public API will be deprecated in the next version of Draft!
  // The methods below this line are private - don't call them directly.

  /**
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  __getLastCreatedEntityKey: function __getLastCreatedEntityKey() {
    return '' + instanceKey;
  },

  /**
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  __create: function __create(type, mutability, data) {
    return DraftEntity.__add(new DraftEntityInstance({ type: type, mutability: mutability, data: data || {} }));
  },

  /**
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  __add: function __add(instance) {
    var key = '' + ++instanceKey;
    instances = instances.set(key, instance);
    return key;
  },

  /**
   * Retrieve the entity corresponding to the supplied key string.
   */
  __get: function __get(key) {
    var instance = instances.get(key);
    !!!instance ?  false ? invariant(false, 'Unknown DraftEntity key: %s.', key) : invariant(false) : void 0;
    return instance;
  },

  /**
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  __mergeData: function __mergeData(key, toMerge) {
    var instance = DraftEntity.__get(key);
    var newData = _extends({}, instance.getData(), toMerge);
    var newInstance = instance.set('data', newData);
    instances = instances.set(key, newInstance);
    return newInstance;
  },

  /**
   * Completely replace the data for a given instance.
   */
  __replaceData: function __replaceData(key, newData) {
    var instance = DraftEntity.__get(key);
    var newInstance = instance.set('data', newData);
    instances = instances.set(key, newInstance);
    return newInstance;
  }
};

module.exports = DraftEntity;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftOffsetKey
 * @format
 * 
 */



var KEY_DELIMITER = '-';

var DraftOffsetKey = {
  encode: function encode(blockKey, decoratorKey, leafKey) {
    return blockKey + KEY_DELIMITER + decoratorKey + KEY_DELIMITER + leafKey;
  },

  decode: function decode(offsetKey) {
    var _offsetKey$split = offsetKey.split(KEY_DELIMITER),
        blockKey = _offsetKey$split[0],
        decoratorKey = _offsetKey$split[1],
        leafKey = _offsetKey$split[2];

    return {
      blockKey: blockKey,
      decoratorKey: parseInt(decoratorKey, 10),
      leafKey: parseInt(leafKey, 10)
    };
  }
};

module.exports = DraftOffsetKey;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getContentStateFragment
 * @format
 * 
 */



var randomizeBlockMapKeys = __webpack_require__(769);
var removeEntitiesAtEdges = __webpack_require__(770);

var getContentStateFragment = function getContentStateFragment(contentState, selectionState) {
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  // Edge entities should be stripped to ensure that we don't preserve
  // invalid partial entities when the fragment is reused. We do, however,
  // preserve entities that are entirely within the selection range.
  var contentWithoutEdgeEntities = removeEntitiesAtEdges(contentState, selectionState);

  var blockMap = contentWithoutEdgeEntities.getBlockMap();
  var blockKeys = blockMap.keySeq();
  var startIndex = blockKeys.indexOf(startKey);
  var endIndex = blockKeys.indexOf(endKey) + 1;

  return randomizeBlockMapKeys(blockMap.slice(startIndex, endIndex).map(function (block, blockKey) {
    var text = block.getText();
    var chars = block.getCharacterList();

    if (startKey === endKey) {
      return block.merge({
        text: text.slice(startOffset, endOffset),
        characterList: chars.slice(startOffset, endOffset)
      });
    }

    if (blockKey === startKey) {
      return block.merge({
        text: text.slice(startOffset),
        characterList: chars.slice(startOffset)
      });
    }

    if (blockKey === endKey) {
      return block.merge({
        text: text.slice(0, endOffset),
        characterList: chars.slice(0, endOffset)
      });
    }

    return block;
  }));
};

module.exports = getContentStateFragment;

/***/ }),
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(2467),
    listCacheDelete = __webpack_require__(2468),
    listCacheGet = __webpack_require__(2469),
    listCacheHas = __webpack_require__(2470),
    listCacheSet = __webpack_require__(2471);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 391 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(316);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(861),
    keys = __webpack_require__(268);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(860),
    baseIsNaN = __webpack_require__(2426),
    strictIndexOf = __webpack_require__(2492);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(2438);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(2465);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(316),
    isArrayLike = __webpack_require__(150),
    isIndex = __webpack_require__(553),
    isObject = __webpack_require__(118);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(233);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(2414),
    hasUnicode = __webpack_require__(879),
    unicodeToArray = __webpack_require__(2494);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(319);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(149),
    stubFalse = __webpack_require__(2515);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(328)(module)))

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(863),
    getTag = __webpack_require__(877),
    isArguments = __webpack_require__(318),
    isArray = __webpack_require__(80),
    isArrayLike = __webpack_require__(150),
    isBuffer = __webpack_require__(401),
    isPrototype = __webpack_require__(315),
    isTypedArray = __webpack_require__(404);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 403 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

module.exports = isNull;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(2429),
    baseUnary = __webpack_require__(866),
    nodeUtil = __webpack_require__(882);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(391),
    baseIteratee = __webpack_require__(196),
    baseMap = __webpack_require__(2431),
    isArray = __webpack_require__(80);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(2516);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(550),
    unzip = __webpack_require__(2520);

/**
 * Creates an array of grouped elements, the first of which contains the
 * first elements of the given arrays, the second of which contains the
 * second elements of the given arrays, and so on.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to process.
 * @returns {Array} Returns the new array of grouped elements.
 * @example
 *
 * _.zip(['a', 'b'], [1, 2], [true, false]);
 * // => [['a', 1, true], ['b', 2, false]]
 */
var zip = baseRest(unzip);

module.exports = zip;


/***/ }),
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.update = exports.updateIntl = exports.UPDATE = exports.Provider = exports.IntlProvider = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.intlReducer = intlReducer;

var _warning = __webpack_require__(68);

var _warning2 = _interopRequireDefault(_warning);

var _IntlProvider2 = __webpack_require__(1065);

var _IntlProvider3 = _interopRequireDefault(_IntlProvider2);

var _Provider2 = __webpack_require__(2670);

var _Provider3 = _interopRequireDefault(_Provider2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.IntlProvider = _IntlProvider3.default;
exports.Provider = _Provider3.default;
var UPDATE = exports.UPDATE = '@@intl/UPDATE';

var updateIntl = exports.updateIntl = function updateIntl(_ref) {
  var locale = _ref.locale,
      messages = _ref.messages;
  return {
    type: UPDATE,
    payload: { locale: locale, messages: messages }
  };
};

var update = exports.update = function update(intl) {
   false ? (0, _warning2.default)(false, '[react-intl-redux] `update` is going to be removed, use `updateIntl` instead') : void 0;
  return updateIntl(intl);
};

var initialState = exports.initialState = {
  locale: 'en',
  messages: {}
};

function intlReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  if (action.type !== UPDATE) {
    return state;
  }

  return _extends({}, state, action.payload);
}

/***/ }),
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_zip__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_zip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_zip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_connected_svg__ = __webpack_require__(2763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_connected_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_connected_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_disconnected_svg__ = __webpack_require__(2764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_disconnected_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_disconnected_svg__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);











var kAK = 'sKOR1iZ8dB2Ry3o7NjIQaBa0LGA40vY5';
var defaultProps = {
  onZoom: function onZoom() {},
  onDrag: function onDrag() {}
};

var propTypes = {
  gateways: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.array.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  onZoom: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func,
  onDrag: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func
};

var GatewayMap = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(GatewayMap, _React$Component);

  GatewayMap.getCenterAndZoom = function getCenterAndZoom(points) {
    var span = 0.0001;
    var center = points[0];
    points.forEach(function (x) {
      if (center.lat !== x.lat || center.lng !== x.lng) {
        center = new BMap.Point((center.lng + x.lng) / 2, (center.lat + x.lat) / 2);
      }
      points.forEach(function (y) {
        span = Math.max(span, Math.max(Math.abs(x.lat - y.lat), Math.abs(x.lng - y.lng)));
      });
    });
    var zoom = 2;
    if (span < 0.001) {
      zoom = 16;
    } else if (span < 0.1) {
      zoom = 14;
    } else if (span < 0.5) {
      zoom = 11;
    } else if (span < 1) {
      zoom = 8;
    } else if (span < 10) {
      zoom = 6;
    } else if (span < 20) {
      zoom = 5;
    }
    return [center, zoom];
  };

  GatewayMap.getStatus = function getStatus(gw) {
    if (_.isNil(gw.lastOn)) {
      return false;
    }
    if (_.isNil(gw.lastOff)) {
      return true;
    }
    var onts = new Date(gw.lastOn).valueOf();
    var offts = new Date(gw.lastOff).valueOf();
    if (onts > offts) {
      return true;
    }
    return false;
  };

  function GatewayMap(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GatewayMap);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.markers = [];
    _this.listeners = [];
    _this.maxCount = 0;
    _this.gateways = [];
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gateway.map');
    _this.transformBMapPoint = _this.transformBMapPoint.bind(_this);
    return _this;
  }

  GatewayMap.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var tries = 0;
    var init = function init() {
      try {
        _this2.initMap();
      } catch (e) {
        if (tries < 10) {
          tries += 1;
          setTimeout(init, 1000);
        }
      }
    };
    init();
  };

  GatewayMap.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var gateways = nextProps.gateways;

    if (!_.isEqual(gateways, gateways)) {
      this.transform(gateways, this.transformBMapPoint);
      if (this.map) {
        this.map.clearOverlays();
      }
    }
  };

  GatewayMap.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_8_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_7_lodash_zip___default()(this.markers, this.listeners), function (_ref) {
      var marker = _ref[0],
          listener = _ref[1];

      marker.removeEventListener('click', listener);
    });
    $('#gwmap').empty();
  };

  GatewayMap.prototype.initMap = function initMap() {
    var _this3 = this;

    this.map = new BMap.Map('gwmap');
    this.map.setMaxZoom(19);
    this.map.setMinZoom(2);
    this.map.enableScrollWheelZoom();
    this.map.removeControl(this.navControl);
    this.map.removeControl(this.scaleControl);
    // eslint-disable-next-line
    this.navControl = new BMap.NavigationControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });
    // eslint-disable-next-line
    this.scaleControl = new BMap.ScaleControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });

    this.map.addControl(this.navControl);
    this.map.addControl(this.scaleControl);
    this.map.addEventListener('zoomend', function () {
      return _this3.props.onZoom(_this3.map);
    });
    this.map.addEventListener('dragend', function () {
      return _this3.props.onDrag(_this3.map);
    });
    if (this.map) {
      this.transform(this.props.gateways, this.transformBMapPoint);
    }
  };

  GatewayMap.prototype.transform = function transform(gws, callback) {
    var _this4 = this;

    var temp = gws;
    var tobeTrans = [];
    var index = 0;
    temp = temp.filter(function (gw) {
      var _gw$lat = gw.lat,
          lat = _gw$lat === undefined ? '' : _gw$lat,
          _gw$lng = gw.lng,
          lng = _gw$lng === undefined ? '' : _gw$lng;

      return lat !== '' && lng !== '' && lat !== 'undefined' && lng !== 'undefined';
    });
    var baiduGps = [];
    var gateways = [];
    _.forEach(temp, function (g) {
      if (g.gpssrc === 'auto') {
        gateways.push(g);
      } else {
        baiduGps.push(g);
      }
    });
    this.handleBaiduPoint(baiduGps);

    this.maxCount = Math.ceil(gateways.length / 100);
    if (gateways.length) {
      for (var i = 0; i < this.maxCount; i += 1) {
        var tt = gateways.slice(i * 100, (i + 1) * 100);
        tobeTrans.push(tt);
      }
      var loop = function loop() {
        if (index < _this4.maxCount) {
          var arr = tobeTrans[index];
          if (arr.length) {
            var coords = arr.map(function (gw) {
              var lng = gw.lng,
                  lat = gw.lat;

              return lng + "," + lat;
            }).join(';');
            $.ajax({
              url: "https://api.map.baidu.com/geoconv/v1/?coords=" + coords + "&from=1&to=5&ak=" + kAK + "&callback=?",
              dataType: 'jsonp',
              success: function success(res) {
                callback(arr, res);
                index += 1;
                loop();
              }
            });
          }
        }
      };
      loop();
    } else if (this.map) {
      this.map.centerAndZoom('深圳', 1);
    }
  };

  GatewayMap.prototype.handleBaiduPoint = function handleBaiduPoint(gws) {
    var gateways = _.map(gws, function (g) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, g, {
        point: new BMap.Point(g.lng, g.lat),
        status: GatewayMap.getStatus(g)
      });
    });
    this.updateData(gateways);
  };

  GatewayMap.prototype.transformBMapPoint = function transformBMapPoint(arr, res) {
    var ps = res.result || [];
    var gateways = _.map(arr, function (a, idx) {
      if (ps[idx]) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, a, {
          point: new BMap.Point(ps[idx].x, ps[idx].y),
          status: GatewayMap.getStatus(a)
        });
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, a, { status: GatewayMap.getStatus(a) });
    });
    this.updateData(gateways);
  };

  GatewayMap.prototype.updateData = function updateData(gateways) {
    var _this5 = this;

    gateways.forEach(function (obj) {
      _this5.addMarker(obj);
    });

    var points = gateways.map(function (x) {
      return x.point;
    });
    if (points.length === 1) {
      this.map.centerAndZoom(points[0], 16);
    } else if (points.length > 0) {
      // decide max span with at most 20 points
      var _GatewayMap$getCenter = GatewayMap.getCenterAndZoom(points.slice(0, 20)),
          center = _GatewayMap$getCenter[0],
          zoom = _GatewayMap$getCenter[1];

      this.map.centerAndZoom(center, zoom);
    } else {
      this.map.centerAndZoom('深圳', 1);
    }
  };

  GatewayMap.prototype.info = function info(obj) {
    var disconnected = "\n      <span style=\"color: #CF000F;\">\n        " + this.intlMsg.msg('status.disconnected') + "\n      </span>\n    ";
    var connected = "\n      <span style=\"color: #00B16A;\">\n        " + this.intlMsg.msg('status.connected') + "\n      </span>\n    ";

    var status = obj.status ? connected : disconnected;

    return "\n<div>\n  <h4 style=\"font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, PingFang SC, Source Han Sans CN, Hiragino Sans GB, Microsoft YaHei, WenQuanYi Micro Hei, sans-serif; font-weight: 300; font-size: 14px;\">\n    " + this.intlMsg.msg('id') + "&nbsp;<a id=\"infowin\">" + obj.id + "</a>\n  </h4>\n  <dl class=\"dl-horizontal\" style=\"font-size: 12px; background-color: #eeeeee; padding: 15px 5px; border-radius: 2px; border: 1px solid #efefef;\">\n    <div style=\"padding: 5px 0;\">\n      <span style=\"width: 80px; display: inline-block; text-align: right; padding-right: 10px; font-weight: 700;\">\n        " + this.intlMsg.msg('mac') + "\n      </span>\n      <span>" + obj.mac + "</span>\n    </div>\n    <div style=\"padding: 5px 0;\">\n      <span style=\"width: 80px; display: inline-block; text-align: right; padding-right: 10px; font-weight: 700;\">\n        " + this.intlMsg.msg('name') + "\n      </span>\n      <span>" + obj.name + "</span>\n    </div>\n    <div style=\"padding: 5px 0;\">\n      <span style=\"width: 80px; display: inline-block; text-align: right; padding-right: 10px; font-weight: 700;\">\n        " + this.intlMsg.msg('address') + "\n      </span>\n      <span>" + obj.area + " " + obj.address + "</span>\n    </div>\n    <div style=\"padding: 5px 0;\">\n      <span style=\"width: 80px; display: inline-block; text-align: right; padding-right: 10px; font-weight: 700;\">\n        " + this.intlMsg.msg('status') + "\n      </span>\n      <span>" + status + "</span>\n    </div>\n  </dl>\n</div>\n";
  };

  GatewayMap.prototype.addMarker = function addMarker(item) {
    var _this6 = this;

    var opts = {
      width: 400,
      height: 180,
      title: '',
      enableMessage: true
    };

    var pushState = this.props.pushState;

    var that = this;
    var openInfo = function openInfo() {
      var info = that.info(item);
      var infoWin = new BMap.InfoWindow(info, opts);
      _this6.map.openInfoWindow(infoWin, item.point);
      setTimeout(function () {
        $('#infowin').click(function () {
          return pushState("/gateway/detail/" + item.id);
        });
      }, 300);
    };

    var icon = item.status ? new BMap.Icon(__WEBPACK_IMPORTED_MODULE_11__images_connected_svg___default.a, new BMap.Size(25, 25)) : new BMap.Icon(__WEBPACK_IMPORTED_MODULE_12__images_disconnected_svg___default.a, new BMap.Size(25, 25));
    var marker = new BMap.Marker(item.point, { icon: icon });
    marker.addEventListener('click', openInfo);
    this.map.addOverlay(marker);
    this.markers.push(marker);
    this.listeners.push(openInfo);
  };

  GatewayMap.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { id: "gwmap", style: { height: '100%', width: '100%' } });
  };

  return GatewayMap;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

GatewayMap.defaultProps = defaultProps;
GatewayMap.propTypes = propTypes;

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"])(GatewayMap)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lorastyles_base_scss__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lorastyles_base_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lorastyles_base_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);






var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string,
  description: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string
};

var PageError = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PageError, _React$Component);

  function PageError(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PageError);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      title: props.title,
      description: props.description
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_5_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'lora.pageerror');
    return _this;
  }

  PageError.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var title = nextProps.title,
        description = nextProps.description;

    if (title !== this.props.title) {
      this.setState({ title: title });
    }
    if (description !== this.props.description) {
      this.setState({ description: description });
    }
  };

  PageError.prototype.render = function render() {
    var _state = this.state,
        title = _state.title,
        description = _state.description;

    if (!title) {
      title = this.intlMsg.msg('default.title');
    }
    if (!description) {
      description = this.intlMsg.msg('default.description');
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_6_lorastyles_base_scss___default.a.error },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "h5",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle" })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "h5",
        null,
        title
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "p",
        null,
        description
      )
    );
  };

  return PageError;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

PageError.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(PageError));

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_scss__ = __webpack_require__(2146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var propTypes = {
  show: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool
};

var SearchFlag = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(SearchFlag, _React$Component);

  function SearchFlag(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SearchFlag);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      show: props.show
    };
    return _this;
  }

  SearchFlag.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var show = nextProps.show;

    if (show !== this.props.show) {
      this.setState({ show: show });
    }
  };

  SearchFlag.prototype.render = function render() {
    var show = this.state.show;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-search " + __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.flag + " " + (show ? __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.show : '') });
  };

  return SearchFlag;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

SearchFlag.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (SearchFlag);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Select__ = __webpack_require__(70);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var propTypes = {
  onChange: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  options: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.array.isRequired,
  onSelect: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func,
  placeholder: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any,
  className: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string
};

var SearchSelector = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(SearchSelector, _React$Component);

  function SearchSelector(props, context) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SearchSelector);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.state = {
      options: props.options
    };
    return _this;
  }

  SearchSelector.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var options = nextProps.options;

    if (options !== this.props.options) {
      this.setState({ options: options });
    }
  };

  SearchSelector.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        placeholder = _props.placeholder,
        className = _props.className;
    var options = this.state.options;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Select__["a" /* default */], {
      onChange: function onChange(v) {
        _this2.props.onChange(v);
        if (_this2.props.onSelect) {
          _this2.props.onSelect(v);
        }
      },
      placeholder: placeholder,
      className: className,
      options: options
    });
  };

  return SearchSelector;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

SearchSelector.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (SearchSelector);

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss__ = __webpack_require__(2156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var defaultProps = {
  status: 'idle',
  pullRight: false,
  more: false,
  mark: null,
  reset: null
};

var propTypes = {
  more: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool,
  mark: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any,
  status: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string,
  pullRight: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool,
  onNext: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  onPrev: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any
};

var TablePager = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(TablePager, _React$Component);

  function TablePager(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TablePager);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.init(props.more, props.mark, props.status);
    _this.handleNextPage = _this.handleNextPage.bind(_this);
    _this.handlePrevPage = _this.handlePrevPage.bind(_this);
    return _this;
  }

  TablePager.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var mark = nextProps.mark,
        more = nextProps.more,
        _nextProps$status = nextProps.status,
        status = _nextProps$status === undefined ? 'idle' : _nextProps$status,
        reset = nextProps.reset;


    if (reset !== this.props.reset) {
      this.init(more, mark, status);
      return;
    }

    if (mark === this.props.mark && more === this.props.more && status === this.props.status) {
      // no changes, skip it!
      return;
    }

    this.setState({ status: status });
    if (status !== 'success') {
      return;
    }

    if (this.action === 'prev') {
      this.marks = _.dropRight(this.marks, 1);
      this.setState({
        hasPrev: this.marks.length > 1,
        hasNext: more
      });
    } else if (this.action === 'next') {
      // this.marks = _.uniq(_.concat(this.marks, mark));
      this.marks = mark;
      this.setState({
        hasPrev: this.marks.length > 1,
        hasNext: more
      });
    } else {
      // no former action
      this.marks = mark;
      this.state = {
        hasPrev: this.marks.length > 1,
        hasNext: more
      };
      // if (more) {
      //   this.marks = [mark];
      // } else {
      //   this.marks = [];
      // }
      // this.setState({
      //   hasPrev: false,
      //   hasNext: more,
      // });
    }
  };

  TablePager.prototype.init = function init(more, mark, status) {
    this.action = null;
    this.marks = mark;
    this.state = {
      hasPrev: this.marks.length > 1,
      hasNext: more,
      status: status
    };
  };

  TablePager.prototype.handlePrevPage = function handlePrevPage() {
    this.action = 'prev';
    var mark = '';
    if (this.marks.length > 2) {
      mark = _.last(_.dropRight(this.marks, 2));
    }
    this.props.onPrev(mark);
  };

  TablePager.prototype.handleNextPage = function handleNextPage() {
    this.action = 'next';
    var mark = _.last(this.marks);
    this.props.onNext(mark);
  };

  TablePager.prototype.shouldDisableNext = function shouldDisableNext() {
    var _state = this.state,
        status = _state.status,
        hasNext = _state.hasNext;

    if (status !== 'success' && status !== 'failure') {
      return true;
    }
    return !hasNext;
  };

  TablePager.prototype.shouldDisablePrev = function shouldDisablePrev() {
    var _state2 = this.state,
        status = _state2.status,
        hasPrev = _state2.hasPrev;

    if (status !== 'success' && status !== 'failure') {
      return true;
    }
    return !hasPrev;
  };

  TablePager.prototype.renderPager = function renderPager() {
    var _state3 = this.state,
        status = _state3.status,
        hasNext = _state3.hasNext,
        hasPrev = _state3.hasPrev;

    var nextIcon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-chevron-circle-right" });
    var prevIcon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-chevron-circle-left" });

    if (status === 'loading' || status === 'request') {
      nextIcon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" });
      prevIcon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" });
    }
    if (!hasNext) {
      nextIcon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-circle" });
    }
    if (!hasPrev) {
      prevIcon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-circle" });
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "ul",
      { styleName: "table-pager", className: "list-inline" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "li",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "button",
          {
            styleName: "pager-button",
            onClick: this.handlePrevPage,
            disabled: this.shouldDisablePrev()
          },
          prevIcon
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "li",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "button",
          {
            styleName: "pager-button",
            onClick: this.handleNextPage,
            disabled: this.shouldDisableNext()
          },
          nextIcon
        )
      )
    );
  };

  TablePager.prototype.render = function render() {
    var pullRight = this.props.pullRight;


    if (pullRight) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { styleName: "wrapper-pull-right" },
        this.renderPager()
      );
    }
    return this.renderPager();
  };

  return TablePager;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

TablePager.defaultProps = defaultProps;
TablePager.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_react_css_modules___default()(TablePager, __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loraactions_dashboard__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_Checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_InlineSelect__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_scss__ = __webpack_require__(2188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);














var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  showModal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  onConfirm: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
  // dps: PropTypes.string,
};

var defaultProps = {
  dps: ''
};

var AddDps = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(AddDps, _React$Component);

  function AddDps(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AddDps);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      showModal: props.showModal,
      checked: [],
      dataPoints: [],
      lists: [],
      modalType: 'single'
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.dashboard');
    _this.isChecked = _this.isChecked.bind(_this);
    _this.allChecked = _this.allChecked.bind(_this);
    return _this;
  }

  AddDps.prototype.componentWillMount = function componentWillMount() {
    this.loadDps();
  };

  AddDps.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var showModal = nextProps.showModal;

    if (showModal !== this.props.showModal) {
      this.setState({ showModal: showModal });
    }
    // this.setState({ checked: _.split(dps, ',') });
  };

  AddDps.prototype.loadDps = function loadDps() {
    var _this2 = this;

    var appId = this.props.appId;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lorautils_api__["a" /* callAPI */])({
      endpoint: '/lora/dps',
      query: {
        appid: appId
      }
    }).then(function (data) {
      _this2.setState({
        dataPoints: data.list,
        lists: data.list.map(function (l) {
          return l.id;
        })
      });
    }).catch(function () {});
  };

  AddDps.prototype.isChecked = function isChecked(d) {
    return _.includes(this.state.checked, d);
  };

  AddDps.prototype.toggleCheck = function toggleCheck(d) {
    var checked = this.state.checked;
    if (this.isChecked(d)) {
      this.setState({
        checked: _.filter(checked, function (a) {
          return a !== d;
        })
      });
    } else {
      checked.push(d);
      this.setState({ checked: checked });
    }
  };

  AddDps.prototype.allChecked = function allChecked() {
    var _state = this.state,
        lists = _state.lists,
        checked = _state.checked;

    return lists.length > 0 && lists.length === checked.length;
  };

  AddDps.prototype.handleToggleCheckAll = function handleToggleCheckAll() {
    this.setState({
      checked: this.allChecked() ? [] : this.state.lists
    });
  };

  AddDps.prototype.handleChangeModalType = function handleChangeModalType(modalType) {
    this.setState({ modalType: modalType });
  };

  AddDps.prototype.handleOnConfirm = function handleOnConfirm() {
    var onConfirm = this.props.onConfirm;
    var _state2 = this.state,
        modalType = _state2.modalType,
        checked = _state2.checked;

    this.handleOnCancel();
    onConfirm(_.join(checked, ','), modalType);
  };

  AddDps.prototype.handleOnCancel = function handleOnCancel() {
    this.props.onHide();
    this.setState({
      checked: [],
      modalType: 'single'
    });
  };

  AddDps.prototype.render = function render() {
    var _this3 = this;

    var _state3 = this.state,
        showModal = _state3.showModal,
        _state3$dataPoints = _state3.dataPoints,
        dataPoints = _state3$dataPoints === undefined ? [] : _state3$dataPoints,
        modalType = _state3.modalType;

    var rows = dataPoints.filter(function (it) {
      return it.id !== 'lat' && it.id !== 'lng';
    }).map(function (item) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        { key: item.id },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Checkbox__["a" /* default */], {
            id: item.id,
            checked: _this3.isChecked(item.id),
            onChange: function onChange() {
              return _this3.toggleCheck(item.id);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          item.id
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          item.desc
        )
      );
    });

    var kOption = [{ label: this.intlMsg.msg('singlechart'), value: 'single' }, { label: this.intlMsg.msg('mergechart'), value: 'merge' }];

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"],
      {
        show: showModal,
        bsSize: "large",
        bsClass: "aisz-modal-light"
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Header,
        null,
        this.intlMsg.msg('adddashboard.add.datapoint')
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Body,
        { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.content },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_InlineSelect__["a" /* default */], {
          bsStyle: "aisz-primary",
          options: kOption,
          values: [modalType],
          onChange: function onChange(selected) {
            return _this3.handleChangeModalType(selected[0]);
          }
        }),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Table"],
          {
            className: "aisz-table-light",
            style: { marginTop: '20px' },
            bordered: true,
            responsive: true
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Checkbox__["a" /* default */], {
                  id: "all",
                  checked: this.allChecked(),
                  onChange: function onChange(e) {
                    return _this3.handleToggleCheckAll(e);
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('addmodal.name')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('dpsmodal.desc')
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tbody",
            null,
            rows
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Footer,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-success",
            onClick: function onClick() {
              return _this3.handleOnConfirm();
            }
          },
          this.intlMsg.msg('confirm')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-default",
            className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.white,
            onClick: function onClick() {
              return _this3.handleOnCancel();
            }
          },
          this.intlMsg.msg('cancel')
        )
      )
    );
  };

  return AddDps;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

AddDps.propTypes = propTypes;
AddDps.defaultProps = defaultProps;

var mapDispatchToProps = {
  getDps: __WEBPACK_IMPORTED_MODULE_11_loraactions_dashboard__["a" /* default */].getDps
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_7_react_css_modules___default()(AddDps, __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a, { allowMultiple: true }))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracfg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loraactions_mark__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_DatePicker__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_DateTimePicker__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_Refresher__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_CollapseToggle__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_InlineSelect__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loracoms_TablePager__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_loracoms_PanelToolbar__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_loracoms_Link__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lorautils_DateTimeUtils__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__styles_scss__ = __webpack_require__(2236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);
























var cloudVersion = __WEBPACK_IMPORTED_MODULE_8_loracfg__["a" /* default */].profile === 'cloud';
function defaultFrom() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["subDays"])(new Date(), 7);
}

function defaultTo() {
  return new Date();
}

function isNew(time) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["differenceInSeconds"])(new Date(), time) < 10;
}

function calculateTo(to) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["addMinutes"])(to, 1);
}

var kLimit = 20;
var propTypes = {
  plan: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  getDeviceData: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  handleMark: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  deviceData: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var DeviceData = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeviceData, _React$Component);

  DeviceData.handleDisableDate = function handleDisableDate(d, from) {
    var before = cloudVersion ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["isBefore"])(d, from) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["isBefore"])(d, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["addDays"])(from, -1));
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["isAfter"])(d, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["min"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["addDays"])(from, 7), new Date())) || before;
  };

  function DeviceData(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeviceData);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      plan: props.plan,
      deviceData: props.deviceData,
      from: defaultFrom(),
      to: defaultTo(),
      dir: 'up',
      fields: ['radio']
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_21_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail');
    _this.handleChangeDir = _this.handleChangeDir.bind(_this);
    _this.handleToggleFields = _this.handleToggleFields.bind(_this);
    _this.handleChangeFrom = _this.handleChangeFrom.bind(_this);
    _this.handleChangeTo = _this.handleChangeTo.bind(_this);
    _this.handleReload = _this.handleReload.bind(_this);
    _this.handleChangeMark = _this.handleChangeMark.bind(_this);
    return _this;
  }

  DeviceData.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        deviceId = _props.deviceId,
        getDeviceData = _props.getDeviceData;
    var _state = this.state,
        dir = _state.dir,
        _state$from = _state.from,
        from = _state$from === undefined ? defaultFrom() : _state$from,
        _state$to = _state.to,
        to = _state$to === undefined ? defaultTo() : _state$to;

    getDeviceData(deviceId, {
      limit: kLimit,
      dir: dir,
      start: from.valueOf(),
      end: to.valueOf()
    });
  };

  DeviceData.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var plan = nextProps.plan,
        deviceData = nextProps.deviceData,
        deviceId = nextProps.deviceId;

    if (plan !== this.props.plan) {
      this.setState({ plan: plan });
    }
    if (!_.isEqual(deviceData, this.props.deviceData)) {
      this.setState({ deviceData: deviceData });
      var _deviceData$data = deviceData.data;
      _deviceData$data = _deviceData$data === undefined ? {} : _deviceData$data;
      var _deviceData$data$list = _deviceData$data.list,
          list = _deviceData$data$list === undefined ? [] : _deviceData$data$list,
          status = deviceData.status;

      if (status === 'success') {
        this.setState({ list: list });
        if (list.length) {
          var to = _.first(list).$time;
          var from = _.last(list).$time;
          this.props.handleMark({ from: from, to: to });
        } else {
          this.props.handleMark({ from: null, to: null });
        }
      }
    }
    if (deviceId !== this.props.deviceId) {
      this.resetRequest(deviceId);
    }
  };

  DeviceData.prototype.resetRequest = function resetRequest(deviceId) {
    var from = defaultFrom();
    var to = defaultTo();
    this.setState({ from: from, to: to, reset: new Date().valueOf() });

    this.props.getDeviceData(deviceId, {
      dir: this.state.dir,
      limit: kLimit,
      start: from.valueOf(),
      end: to.valueOf()
    });
  };

  DeviceData.prototype.handleChangeMark = function handleChangeMark() {
    var mark = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var _props2 = this.props,
        deviceId = _props2.deviceId,
        getDeviceData = _props2.getDeviceData;
    var _state2 = this.state,
        dir = _state2.dir,
        _state2$from = _state2.from,
        from = _state2$from === undefined ? defaultFrom() : _state2$from,
        _state2$to = _state2.to,
        to = _state2$to === undefined ? defaultTo() : _state2$to;


    getDeviceData(deviceId, {
      dir: dir,
      limit: kLimit,
      start: cloudVersion ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["startOfDay"])(from).valueOf() : from.valueOf(),
      end: cloudVersion ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["endOfDay"])(to).valueOf() : calculateTo(to).valueOf(),
      mark: mark
    });
  };

  DeviceData.prototype.handleChangeDir = function handleChangeDir(dir) {
    if (dir === this.state.dir) {
      return;
    }

    this.setState({
      dir: dir,
      reset: Math.random()
    });

    var _props3 = this.props,
        deviceId = _props3.deviceId,
        getDeviceData = _props3.getDeviceData;
    var _state3 = this.state,
        _state3$from = _state3.from,
        from = _state3$from === undefined ? defaultFrom() : _state3$from,
        _state3$to = _state3.to,
        to = _state3$to === undefined ? defaultTo() : _state3$to;

    getDeviceData(deviceId, {
      dir: dir,
      limit: kLimit,
      start: cloudVersion ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["startOfDay"])(from).valueOf() : from.valueOf(),
      end: cloudVersion ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["endOfDay"])(to).valueOf() : calculateTo(to).valueOf()
    });
  };

  DeviceData.prototype.handleToggleFields = function handleToggleFields(fields) {
    this.setState({ fields: fields });
  };

  DeviceData.prototype.handleChangeFrom = function handleChangeFrom(from) {
    var to = this.state.to;

    if (cloudVersion) {
      to = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["endOfDay"])(from);
    } else if (from.valueOf() > to.valueOf()) {
      to = from;
    }

    this.setState({
      from: from,
      to: to,
      reset: Date.parse(new Date())
    });
    var _props4 = this.props,
        deviceId = _props4.deviceId,
        getDeviceData = _props4.getDeviceData;
    var dir = this.state.dir;

    getDeviceData(deviceId, {
      dir: dir,
      limit: kLimit,
      start: cloudVersion ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["startOfDay"])(from).valueOf() : from.valueOf(),
      end: to.valueOf()
    });
  };

  DeviceData.prototype.handleChangeTo = function handleChangeTo(to) {
    var _state$from2 = this.state.from,
        from = _state$from2 === undefined ? defaultFrom() : _state$from2;

    this.setState({
      to: to,
      reset: Math.random()
    });

    var _props5 = this.props,
        deviceId = _props5.deviceId,
        getDeviceData = _props5.getDeviceData;
    var dir = this.state.dir;

    getDeviceData(deviceId, {
      dir: dir,
      limit: kLimit,
      start: cloudVersion ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["startOfDay"])(from).valueOf() : from.valueOf(),
      end: cloudVersion ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["endOfDay"])(to).valueOf() : calculateTo(to).valueOf()
    });
  };

  DeviceData.prototype.handleReload = function handleReload() {
    this.setState({ reset: Math.random() });

    var _props6 = this.props,
        getDeviceData = _props6.getDeviceData,
        deviceId = _props6.deviceId;
    var dir = this.state.dir;
    var _state4 = this.state,
        from = _state4.from,
        to = _state4.to;
    // 刷新时，将时间置为最新时间

    from = defaultFrom();
    to = defaultTo();
    this.setState({ from: from, to: to });

    getDeviceData(deviceId, {
      dir: dir,
      limit: kLimit,
      start: cloudVersion ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["startOfDay"])(from).valueOf() : from.valueOf(),
      end: cloudVersion ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["endOfDay"])(to).valueOf() : calculateTo(to).valueOf()
    });
  };

  DeviceData.prototype.renderDirToggle = function renderDirToggle() {
    var _this2 = this;

    var _state5 = this.state,
        plan = _state5.plan,
        dir = _state5.dir;

    if (plan.status !== 'success') {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" });
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_InlineSelect__["a" /* default */], {
      options: [{
        label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-long-arrow-up" }),
          this.intlMsg.msg('datadir.up', 'lora')
        ),
        value: 'up',
        active: true
      }, {
        label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-long-arrow-down" }),
          this.intlMsg.msg('datadir.down', 'lora')
        ),
        value: 'down'
      }],
      bsStyle: "aisz-primary",
      values: [dir],
      onChange: function onChange(selected) {
        return _this2.handleChangeDir(selected[0]);
      },
      disabled: plan.data.tier === 1
    });
  };

  DeviceData.prototype.renderFieldsToggle = function renderFieldsToggle() {
    var _this3 = this;

    var fields = this.state.fields;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_InlineSelect__["a" /* default */], {
      options: [{
        label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-wifi" }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "span",
            null,
            this.intlMsg.msg('fieldsgroup.radio')
          )
        ),
        value: 'radio',
        active: true
      }, {
        label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "span",
            null,
            this.intlMsg.msg('fieldsgroup.datamsg')
          )
        ),
        value: 'datamsg'
      }],
      bsStyle: "aisz-primary",
      values: fields,
      onChange: function onChange(selected) {
        return _this3.handleToggleFields(selected);
      },
      multiple: true
    });
  };

  DeviceData.prototype.render = function render() {
    var _this4 = this;

    var _state6 = this.state,
        _state6$deviceData$st = _state6.deviceData.status,
        status = _state6$deviceData$st === undefined ? '' : _state6$deviceData$st,
        _state6$expanded = _state6.expanded,
        expanded = _state6$expanded === undefined ? true : _state6$expanded;


    var header = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: "clearfix" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "ul",
        { className: "icontools" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Refresher__["a" /* default */], {
            onReload: this.handleReload,
            reloading: status === 'pending'
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_CollapseToggle__["a" /* default */], {
            expanded: expanded,
            onChange: function onChange(v) {
              _this4.setState({ expanded: v });
            }
          })
        )
      )
    );

    var _state7 = this.state,
        fields = _state7.fields,
        collapseDEVEUI = _state7.collapseDEVEUI,
        deviceData = _state7.deviceData,
        _state7$list = _state7.list,
        list = _state7$list === undefined ? [] : _state7$list,
        dir = _state7.dir;

    var showRadioFields = fields.includes('radio');
    var showDataFields = fields.includes('datamsg');

    var mark = '';
    var more = false;
    if (deviceData.status === 'success') {
      mark = deviceData.data.mark;
      more = deviceData.data.more;
    }

    var rows = list.map(function (d) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        { key: d.fcnt + "-" + d.$time + "-" + d.gateway, className: isNew(d.$time) ? __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new : '' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_lorautils_DateTimeUtils__["a" /* compactFormat */])(d.$time)
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_20_loracoms_Link__["a" /* default */],
            { to: "/gateway/detail/" + d.gateway },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
              { "if": collapseDEVEUI },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "span",
                null,
                "..." + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_lorautils_IdUtils__["b" /* normalizeMac */])(d.gateway).substr(-5)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
              { "if": !collapseDEVEUI },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "span",
                null,
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_lorautils_IdUtils__["b" /* normalizeMac */])(d.gateway)
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_20_loracoms_Link__["a" /* default */],
            { to: "/gateway/detail/" + d.gateway },
            d.name
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
          { "if": showRadioFields && dir === 'up' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.channel,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
          { "if": showRadioFields },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.frequency / 1000000,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
          { "if": showRadioFields },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.bandwidth + " | " + d.coderate,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
          { "if": showRadioFields },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.spreadfactor,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
          { "if": showRadioFields && dir === 'up' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            d.lorasnr && Number(d.lorasnr).toFixed(1)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
          { "if": showRadioFields && dir === 'up' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.rssi,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_RichLabel__["a" /* default */], {
            content: d.mtype,
            translateMap: {
              UnconfirmedDataUp: _this4.intlMsg.msg('detailview.unconfirmeddataup'),
              UnconfirmedDataDown: _this4.intlMsg.msg('detailview.unconfirmeddatadown'),
              ConfirmedDataUp: _this4.intlMsg.msg('detailview.confirmeddataup'),
              ConfirmedDataDown: _this4.intlMsg.msg('detailview.confirmeddatadown'),
              JoinRequest: _this4.intlMsg.msg('detailview.joinrequest'),
              JoinAccept: _this4.intlMsg.msg('detailview.joinaccept'),
              RFU: _this4.intlMsg.msg('detailview.rfu'),
              Proprietary: _this4.intlMsg.msg('detailview.proprietary')
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          d.fcnt
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
          { "if": showDataFields },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.fport,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
          { "if": showDataFields },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.fctrl,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
          { "if": showDataFields },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.fopts,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
          { "if": showDataFields && dir === 'up' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.size,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
          { "if": showDataFields },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.data,
            " "
          )
        )
      );
    });

    var _state8 = this.state,
        _state8$from = _state8.from,
        from = _state8$from === undefined ? defaultFrom() : _state8$from,
        _state8$to = _state8.to,
        to = _state8$to === undefined ? defaultTo() : _state8$to,
        reset = _state8.reset;

    var pickers = cloudVersion ? [__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_DatePicker__["a" /* default */], {
      date: from,
      onSelect: this.handleChangeFrom
    }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_DatePicker__["a" /* default */], {
      date: to,
      onSelect: this.handleChangeTo,
      disabled: function disabled(d) {
        return DeviceData.handleDisableDate(d, from);
      }
    })] : [__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_DateTimePicker__["a" /* default */], {
      date: from,
      closeOnSelect: false,
      onSelect: this.handleChangeFrom
    }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_DateTimePicker__["a" /* default */], {
      date: to,
      closeOnSelect: false,
      onSelect: this.handleChangeTo,
      disabled: function disabled(d) {
        return DeviceData.handleDisableDate(d, from);
      }
    })];

    var tools = [].concat(pickers, [this.renderDirToggle(), this.renderFieldsToggle()]);

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Panel"],
      {
        bsStyle: "aisz-white",
        header: header,
        collapsible: true,
        expanded: expanded,
        onEntered: function onEntered() {
          _this4.setState({ resize: Math.random() });
        }
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_loracoms_PanelToolbar__["a" /* default */], { tools: tools }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.dataTable },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Table"],
          { className: "aisz-table-light", striped: true, hover: true, bordered: true, responsive: true },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                " ",
                this.intlMsg.msg('data.field.time', 'lora'),
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('data.field.gateway', 'lora'),
                ' ',
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
                  { "if": collapseDEVEUI },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_20_loracoms_Link__["a" /* default */],
                    { onClick: function onClick() {
                        return _this4.setState({ collapseDEVEUI: false });
                      } },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-expand" })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
                  { "if": !collapseDEVEUI },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_20_loracoms_Link__["a" /* default */],
                    { onClick: function onClick() {
                        return _this4.setState({ collapseDEVEUI: true });
                      } },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-compress" })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('data.field.gwname', 'lora')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
                { "if": showRadioFields && dir === 'up' },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-wifi" }),
                  ' ',
                  this.intlMsg.msg('data.field.channel', 'lora')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
                { "if": showRadioFields },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-wifi" }),
                  ' ',
                  this.intlMsg.msg('data.field.frequency', 'lora')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
                { "if": showRadioFields },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-wifi" }),
                  ' ',
                  this.intlMsg.msg('data.field.bandwidth', 'lora')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
                { "if": showRadioFields },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-wifi" }),
                  ' ',
                  "SF"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
                { "if": showRadioFields && dir === 'up' },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-wifi" }),
                  ' ',
                  "SNR"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
                { "if": showRadioFields && dir === 'up' },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-wifi" }),
                  ' ',
                  "RSSI"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                " ",
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
                ' ',
                this.intlMsg.msg('data.field.msgtype', 'lora'),
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                " ",
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
                ' ',
                this.intlMsg.msg('data.field.frameno', 'lora'),
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
                { "if": showDataFields },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  " ",
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
                  ' ',
                  "FPort "
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
                { "if": showDataFields },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  " ",
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
                  ' ',
                  "FCtrl "
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
                { "if": showDataFields },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  " ",
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
                  ' ',
                  "FOpts "
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
                { "if": showDataFields && dir === 'up' },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
                  ' ',
                  this.intlMsg.msg('data.field.size', 'lora')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
                { "if": showDataFields },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
                  ' ',
                  this.intlMsg.msg('data.field.data', 'lora')
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tbody",
            null,
            rows
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.pager },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_TablePager__["a" /* default */], {
          status: status,
          mark: mark,
          more: more,
          onNext: this.handleChangeMark,
          onPrev: this.handleChangeMark,
          reset: reset
        })
      )
    );
  };

  return DeviceData;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DeviceData.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    deviceData: state.device.getDeviceData || {},
    plan: state.billing.plan || {}
  };
};

var mapDispatchToProps = {
  getDeviceData: __WEBPACK_IMPORTED_MODULE_9_loraactions_device__["a" /* default */].getDeviceData,
  handleMark: __WEBPACK_IMPORTED_MODULE_10_loraactions_mark__["a" /* default */].handleMark
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(DeviceData)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__json_zh_json__ = __webpack_require__(2394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__json_zh_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__json_zh_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__json_en_json__ = __webpack_require__(2393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__json_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__json_en_json__);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["a"] = ({ en: __WEBPACK_IMPORTED_MODULE_1__json_en_json___default.a, zh: __WEBPACK_IMPORTED_MODULE_0__json_zh_json___default.a });

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(59);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* createTypesMap */])('adr', ['getAdr', 'applyAdr', 'unapplyAdr', 'getNodeAdr', 'getNodeAdrLogs']);

function getAdr() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getAdr, {
    endpoint: '/features/adr'
  })();
}

function applyAdr() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.applyAdr, {
    endpoint: '/features/adr/apply',
    method: 'POST'
  })();
}

function unapplyAdr() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.unapplyAdr, {
    endpoint: '/features/adr/unapply',
    method: 'POST'
  })();
}

function getNodeAdr(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getNodeAdr, {
    endpoint: "/lora/nodes/" + id + "/adr",
    method: 'GET'
  })();
}

function getNodeAdrLogs(id, args) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getNodeAdrLogs, {
    endpoint: "/lora/nodes/" + id + "/adr/logs",
    method: 'GET',
    query: args
  })();
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getAdr: getAdr,
  applyAdr: applyAdr,
  unapplyAdr: unapplyAdr,
  getNodeAdr: getNodeAdr,
  getNodeAdrLogs: getNodeAdrLogs
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lorautils_cookies_auth__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(59);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* createTypesMap */])('auth', ['token', 'revoke']);

function token(username, password) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* createAPIAction */])(types.token, {
    endpoint: '/authentication/token',
    query: {
      username: username,
      password: password
    }
  })();
}

function revoke() {
  var authCookies = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lorautils_cookies_auth__["a" /* getAuthCookies */])() || {};
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* createAPIAction */])(types.revoke, {
    endpoint: '/authentication/revoke',
    query: { token: authCookies.access_token }
  })();
}

/* harmony default export */ __webpack_exports__["a"] = ({
  token: token,
  revoke: revoke
});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCenterAndZoom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return transform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return drawOval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return calLng; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return calLat; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

var getCenterAndZoom = function getCenterAndZoom(points) {
  var span = 0.0001;
  var center = points[0];
  points.forEach(function (x) {
    if (center.lat !== x.lat || center.lng !== x.lng) {
      center = new BMap.Point((center.lng + x.lng) / 2, (center.lat + x.lat) / 2);
    }
    points.forEach(function (y) {
      span = Math.max(span, Math.max(Math.abs(x.lat - y.lat), Math.abs(x.lng - y.lng)));
    });
  });
  var zoom = 2;
  if (span < 0.001) {
    zoom = 16;
  } else if (span < 0.1) {
    zoom = 14;
  } else if (span < 0.5) {
    zoom = 11;
  } else if (span < 1) {
    zoom = 8;
  } else if (span < 10) {
    zoom = 6;
  } else if (span < 20) {
    zoom = 5;
  }
  return [center, zoom];
};

var transform = function transform() {
  var devices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return devices.filter(function (gw) {
    var _gw$lat = gw.lat,
        lat = _gw$lat === undefined ? '' : _gw$lat,
        _gw$lng = gw.lng,
        lng = _gw$lng === undefined ? '' : _gw$lng;

    return lat !== '' && lng !== '';
  }).map(function (gw) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, gw, {
      point: new BMap.Point(gw.lng, gw.lat)
    });
  });
};

var drawOval = function drawOval(centre, x, y) {
  var assemble = [];
  var angle = void 0;
  var dot = void 0;
  var tangent = x / y;
  for (var i = 0; i < 36; i += 1) {
    angle = 2 * Math.PI / 36 * i;
    dot = new BMap.Point(centre.lng + Math.sin(angle) * y * tangent, centre.lat + Math.cos(angle) * y);
    assemble.push(dot);
  }
  return assemble;
};

var calLng = function calLng(km, lat) {
  // const lng = (Math.cos(lat) * km) / 111;
  var lng = km / 100;
  if (typeof lng === 'number' && Math.abs(lng) >= 0.001) {
    return Math.abs(lng);
  }
  return 0.001;
};

var calLat = function calLat(km) {
  var lat = km / 111.32;
  if (typeof lat === 'number' && Math.abs(lat) >= 0.001) {
    return Math.abs(lat);
  }
  return 0.001;
};

/* unused harmony default export */ var _unused_webpack_default_export = ({
  getCenterAndZoom: getCenterAndZoom,
  transform: transform,
  drawOval: drawOval,
  calLng: calLng
});

/***/ }),
/* 440 */,
/* 441 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(282);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 450 */,
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(182);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentState
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BlockMapBuilder = __webpack_require__(299);
var CharacterMetadata = __webpack_require__(117);
var ContentBlock = __webpack_require__(219);
var ContentBlockNode = __webpack_require__(122);
var DraftEntity = __webpack_require__(370);
var DraftFeatureFlags = __webpack_require__(190);
var Immutable = __webpack_require__(45);
var SelectionState = __webpack_require__(259);

var generateRandomKey = __webpack_require__(167);
var sanitizeDraftText = __webpack_require__(509);

var List = Immutable.List,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat;


var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;

var defaultRecord = {
  entityMap: null,
  blockMap: null,
  selectionBefore: null,
  selectionAfter: null
};

var ContentBlockNodeRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;

var ContentStateRecord = Record(defaultRecord);

var ContentState = function (_ContentStateRecord) {
  _inherits(ContentState, _ContentStateRecord);

  function ContentState() {
    _classCallCheck(this, ContentState);

    return _possibleConstructorReturn(this, _ContentStateRecord.apply(this, arguments));
  }

  ContentState.prototype.getEntityMap = function getEntityMap() {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity;
  };

  ContentState.prototype.getBlockMap = function getBlockMap() {
    return this.get('blockMap');
  };

  ContentState.prototype.getSelectionBefore = function getSelectionBefore() {
    return this.get('selectionBefore');
  };

  ContentState.prototype.getSelectionAfter = function getSelectionAfter() {
    return this.get('selectionAfter');
  };

  ContentState.prototype.getBlockForKey = function getBlockForKey(key) {
    var block = this.getBlockMap().get(key);
    return block;
  };

  ContentState.prototype.getKeyBefore = function getKeyBefore(key) {
    return this.getBlockMap().reverse().keySeq().skipUntil(function (v) {
      return v === key;
    }).skip(1).first();
  };

  ContentState.prototype.getKeyAfter = function getKeyAfter(key) {
    return this.getBlockMap().keySeq().skipUntil(function (v) {
      return v === key;
    }).skip(1).first();
  };

  ContentState.prototype.getBlockAfter = function getBlockAfter(key) {
    return this.getBlockMap().skipUntil(function (_, k) {
      return k === key;
    }).skip(1).first();
  };

  ContentState.prototype.getBlockBefore = function getBlockBefore(key) {
    return this.getBlockMap().reverse().skipUntil(function (_, k) {
      return k === key;
    }).skip(1).first();
  };

  ContentState.prototype.getBlocksAsArray = function getBlocksAsArray() {
    return this.getBlockMap().toArray();
  };

  ContentState.prototype.getFirstBlock = function getFirstBlock() {
    return this.getBlockMap().first();
  };

  ContentState.prototype.getLastBlock = function getLastBlock() {
    return this.getBlockMap().last();
  };

  ContentState.prototype.getPlainText = function getPlainText(delimiter) {
    return this.getBlockMap().map(function (block) {
      return block ? block.getText() : '';
    }).join(delimiter || '\n');
  };

  ContentState.prototype.getLastCreatedEntityKey = function getLastCreatedEntityKey() {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity.__getLastCreatedEntityKey();
  };

  ContentState.prototype.hasText = function hasText() {
    var blockMap = this.getBlockMap();
    return blockMap.size > 1 || blockMap.first().getLength() > 0;
  };

  ContentState.prototype.createEntity = function createEntity(type, mutability, data) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__create(type, mutability, data);
    return this;
  };

  ContentState.prototype.mergeEntityData = function mergeEntityData(key, toMerge) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__mergeData(key, toMerge);
    return this;
  };

  ContentState.prototype.replaceEntityData = function replaceEntityData(key, newData) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__replaceData(key, newData);
    return this;
  };

  ContentState.prototype.addEntity = function addEntity(instance) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__add(instance);
    return this;
  };

  ContentState.prototype.getEntity = function getEntity(key) {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity.__get(key);
  };

  ContentState.createFromBlockArray = function createFromBlockArray(
  // TODO: update flow type when we completely deprecate the old entity API
  blocks, entityMap) {
    // TODO: remove this when we completely deprecate the old entity API
    var theBlocks = Array.isArray(blocks) ? blocks : blocks.contentBlocks;
    var blockMap = BlockMapBuilder.createFromArray(theBlocks);
    var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
    return new ContentState({
      blockMap: blockMap,
      entityMap: entityMap || DraftEntity,
      selectionBefore: selectionState,
      selectionAfter: selectionState
    });
  };

  ContentState.createFromText = function createFromText(text) {
    var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /\r\n?|\n/g;

    var strings = text.split(delimiter);
    var blocks = strings.map(function (block) {
      block = sanitizeDraftText(block);
      return new ContentBlockNodeRecord({
        key: generateRandomKey(),
        text: block,
        type: 'unstyled',
        characterList: List(Repeat(CharacterMetadata.EMPTY, block.length))
      });
    });
    return ContentState.createFromBlockArray(blocks);
  };

  return ContentState;
}(ContentStateRecord);

module.exports = ContentState;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DefaultDraftBlockRenderMap
 * @format
 * 
 */



var _require = __webpack_require__(45),
    Map = _require.Map;

var React = __webpack_require__(1);

var cx = __webpack_require__(264);

var UL_WRAP = React.createElement('ul', { className: cx('public/DraftStyleDefault/ul') });
var OL_WRAP = React.createElement('ol', { className: cx('public/DraftStyleDefault/ol') });
var PRE_WRAP = React.createElement('pre', { className: cx('public/DraftStyleDefault/pre') });

var DefaultDraftBlockRenderMap = Map({
  'header-one': {
    element: 'h1'
  },
  'header-two': {
    element: 'h2'
  },
  'header-three': {
    element: 'h3'
  },
  'header-four': {
    element: 'h4'
  },
  'header-five': {
    element: 'h5'
  },
  'header-six': {
    element: 'h6'
  },
  'unordered-list-item': {
    element: 'li',
    wrapper: UL_WRAP
  },
  'ordered-list-item': {
    element: 'li',
    wrapper: OL_WRAP
  },
  blockquote: {
    element: 'blockquote'
  },
  atomic: {
    element: 'figure'
  },
  'code-block': {
    element: 'pre',
    wrapper: PRE_WRAP
  },
  unstyled: {
    element: 'div',
    aliasedElements: ['p']
  }
});

module.exports = DefaultDraftBlockRenderMap;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule KeyBindingUtil
 * @format
 * 
 */



var UserAgent = __webpack_require__(148);

var isOSX = UserAgent.isPlatform('Mac OS X');

var KeyBindingUtil = {
  /**
   * Check whether the ctrlKey modifier is *not* being used in conjunction with
   * the altKey modifier. If they are combined, the result is an `altGraph`
   * key modifier, which should not be handled by this set of key bindings.
   */
  isCtrlKeyCommand: function isCtrlKeyCommand(e) {
    return !!e.ctrlKey && !e.altKey;
  },

  isOptionKeyCommand: function isOptionKeyCommand(e) {
    return isOSX && e.altKey;
  },

  hasCommandModifier: function hasCommandModifier(e) {
    return isOSX ? !!e.metaKey && !e.altKey : KeyBindingUtil.isCtrlKeyCommand(e);
  }
};

module.exports = KeyBindingUtil;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule findAncestorOffsetKey
 * @format
 * 
 */



var getSelectionOffsetKeyForNode = __webpack_require__(763);

/**
 * Get the key from the node's nearest offset-aware ancestor.
 */
function findAncestorOffsetKey(node) {
  var searchNode = node;
  while (searchNode && searchNode !== document.documentElement) {
    var key = getSelectionOffsetKeyForNode(searchNode);
    if (key != null) {
      return key;
    }
    searchNode = searchNode.parentNode;
  }
  return null;
}

module.exports = findAncestorOffsetKey;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEntityKeyForSelection
 * @format
 * 
 */



/**
 * Return the entity key that should be used when inserting text for the
 * specified target selection, only if the entity is `MUTABLE`. `IMMUTABLE`
 * and `SEGMENTED` entities should not be used for insertion behavior.
 */
function getEntityKeyForSelection(contentState, targetSelection) {
  var entityKey;

  if (targetSelection.isCollapsed()) {
    var key = targetSelection.getAnchorKey();
    var offset = targetSelection.getAnchorOffset();
    if (offset > 0) {
      entityKey = contentState.getBlockForKey(key).getEntityAt(offset - 1);
      if (entityKey !== contentState.getBlockForKey(key).getEntityAt(offset)) {
        return null;
      }
      return filterKey(contentState.getEntityMap(), entityKey);
    }
    return null;
  }

  var startKey = targetSelection.getStartKey();
  var startOffset = targetSelection.getStartOffset();
  var startBlock = contentState.getBlockForKey(startKey);

  entityKey = startOffset === startBlock.getLength() ? null : startBlock.getEntityAt(startOffset);

  return filterKey(contentState.getEntityMap(), entityKey);
}

/**
 * Determine whether an entity key corresponds to a `MUTABLE` entity. If so,
 * return it. If not, return null.
 */
function filterKey(entityMap, entityKey) {
  if (entityKey) {
    var entity = entityMap.__get(entityKey);
    return entity.getMutability() === 'MUTABLE' ? entityKey : null;
  }
  return null;
}

module.exports = getEntityKeyForSelection;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule moveSelectionBackward
 * @format
 * 
 */



/**
 * Given a collapsed selection, move the focus `maxDistance` backward within
 * the selected block. If the selection will go beyond the start of the block,
 * move focus to the end of the previous block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */
function moveSelectionBackward(editorState, maxDistance) {
  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();

  var focusKey = key;
  var focusOffset = 0;

  if (maxDistance > offset) {
    var keyBefore = content.getKeyBefore(key);
    if (keyBefore == null) {
      focusKey = key;
    } else {
      focusKey = keyBefore;
      var blockBefore = content.getBlockForKey(keyBefore);
      focusOffset = blockBefore.getText().length;
    }
  } else {
    focusOffset = offset - maxDistance;
  }

  return selection.merge({
    focusKey: focusKey,
    focusOffset: focusOffset,
    isBackward: true
  });
}

module.exports = moveSelectionBackward;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule sanitizeDraftText
 * @format
 * 
 */



var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');

function sanitizeDraftText(input) {
  return input.replace(REGEX_BLOCK_DELIMITER, '');
}

module.exports = sanitizeDraftText;

/***/ }),
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
/* istanbul ignore next */
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
/* istanbul ignore next */
	else if(typeof exports === 'object')
		exports["esprima"] = factory();
	else
		root["esprima"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/* istanbul ignore if */
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/*
	  Copyright JS Foundation and other contributors, https://js.foundation/

	  Redistribution and use in source and binary forms, with or without
	  modification, are permitted provided that the following conditions are met:

	    * Redistributions of source code must retain the above copyright
	      notice, this list of conditions and the following disclaimer.
	    * Redistributions in binary form must reproduce the above copyright
	      notice, this list of conditions and the following disclaimer in the
	      documentation and/or other materials provided with the distribution.

	  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	  AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
	  ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
	  DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
	  (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
	  LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
	  ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	  (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
	  THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	"use strict";
	var comment_handler_1 = __webpack_require__(1);
	var parser_1 = __webpack_require__(3);
	var jsx_parser_1 = __webpack_require__(11);
	var tokenizer_1 = __webpack_require__(15);
	function parse(code, options, delegate) {
	    var commentHandler = null;
	    var proxyDelegate = function (node, metadata) {
	        if (delegate) {
	            delegate(node, metadata);
	        }
	        if (commentHandler) {
	            commentHandler.visit(node, metadata);
	        }
	    };
	    var parserDelegate = (typeof delegate === 'function') ? proxyDelegate : null;
	    var collectComment = false;
	    if (options) {
	        collectComment = (typeof options.comment === 'boolean' && options.comment);
	        var attachComment = (typeof options.attachComment === 'boolean' && options.attachComment);
	        if (collectComment || attachComment) {
	            commentHandler = new comment_handler_1.CommentHandler();
	            commentHandler.attach = attachComment;
	            options.comment = true;
	            parserDelegate = proxyDelegate;
	        }
	    }
	    var parser;
	    if (options && typeof options.jsx === 'boolean' && options.jsx) {
	        parser = new jsx_parser_1.JSXParser(code, options, parserDelegate);
	    }
	    else {
	        parser = new parser_1.Parser(code, options, parserDelegate);
	    }
	    var ast = (parser.parseProgram());
	    if (collectComment) {
	        ast.comments = commentHandler.comments;
	    }
	    if (parser.config.tokens) {
	        ast.tokens = parser.tokens;
	    }
	    if (parser.config.tolerant) {
	        ast.errors = parser.errorHandler.errors;
	    }
	    return ast;
	}
	exports.parse = parse;
	function tokenize(code, options, delegate) {
	    var tokenizer = new tokenizer_1.Tokenizer(code, options);
	    var tokens;
	    tokens = [];
	    try {
	        while (true) {
	            var token = tokenizer.getNextToken();
	            if (!token) {
	                break;
	            }
	            if (delegate) {
	                token = delegate(token);
	            }
	            tokens.push(token);
	        }
	    }
	    catch (e) {
	        tokenizer.errorHandler.tolerate(e);
	    }
	    if (tokenizer.errorHandler.tolerant) {
	        tokens.errors = tokenizer.errors();
	    }
	    return tokens;
	}
	exports.tokenize = tokenize;
	var syntax_1 = __webpack_require__(2);
	exports.Syntax = syntax_1.Syntax;
	// Sync with *.json manifests.
	exports.version = '3.1.3';


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var syntax_1 = __webpack_require__(2);
	var CommentHandler = (function () {
	    function CommentHandler() {
	        this.attach = false;
	        this.comments = [];
	        this.stack = [];
	        this.leading = [];
	        this.trailing = [];
	    }
	    CommentHandler.prototype.insertInnerComments = function (node, metadata) {
	        //  innnerComments for properties empty block
	        //  `function a() {/** comments **\/}`
	        if (node.type === syntax_1.Syntax.BlockStatement && node.body.length === 0) {
	            var innerComments = [];
	            for (var i = this.leading.length - 1; i >= 0; --i) {
	                var entry = this.leading[i];
	                if (metadata.end.offset >= entry.start) {
	                    innerComments.unshift(entry.comment);
	                    this.leading.splice(i, 1);
	                    this.trailing.splice(i, 1);
	                }
	            }
	            if (innerComments.length) {
	                node.innerComments = innerComments;
	            }
	        }
	    };
	    CommentHandler.prototype.findTrailingComments = function (node, metadata) {
	        var trailingComments = [];
	        if (this.trailing.length > 0) {
	            for (var i = this.trailing.length - 1; i >= 0; --i) {
	                var entry_1 = this.trailing[i];
	                if (entry_1.start >= metadata.end.offset) {
	                    trailingComments.unshift(entry_1.comment);
	                }
	            }
	            this.trailing.length = 0;
	            return trailingComments;
	        }
	        var entry = this.stack[this.stack.length - 1];
	        if (entry && entry.node.trailingComments) {
	            var firstComment = entry.node.trailingComments[0];
	            if (firstComment && firstComment.range[0] >= metadata.end.offset) {
	                trailingComments = entry.node.trailingComments;
	                delete entry.node.trailingComments;
	            }
	        }
	        return trailingComments;
	    };
	    CommentHandler.prototype.findLeadingComments = function (node, metadata) {
	        var leadingComments = [];
	        var target;
	        while (this.stack.length > 0) {
	            var entry = this.stack[this.stack.length - 1];
	            if (entry && entry.start >= metadata.start.offset) {
	                target = this.stack.pop().node;
	            }
	            else {
	                break;
	            }
	        }
	        if (target) {
	            var count = target.leadingComments ? target.leadingComments.length : 0;
	            for (var i = count - 1; i >= 0; --i) {
	                var comment = target.leadingComments[i];
	                if (comment.range[1] <= metadata.start.offset) {
	                    leadingComments.unshift(comment);
	                    target.leadingComments.splice(i, 1);
	                }
	            }
	            if (target.leadingComments && target.leadingComments.length === 0) {
	                delete target.leadingComments;
	            }
	            return leadingComments;
	        }
	        for (var i = this.leading.length - 1; i >= 0; --i) {
	            var entry = this.leading[i];
	            if (entry.start <= metadata.start.offset) {
	                leadingComments.unshift(entry.comment);
	                this.leading.splice(i, 1);
	            }
	        }
	        return leadingComments;
	    };
	    CommentHandler.prototype.visitNode = function (node, metadata) {
	        if (node.type === syntax_1.Syntax.Program && node.body.length > 0) {
	            return;
	        }
	        this.insertInnerComments(node, metadata);
	        var trailingComments = this.findTrailingComments(node, metadata);
	        var leadingComments = this.findLeadingComments(node, metadata);
	        if (leadingComments.length > 0) {
	            node.leadingComments = leadingComments;
	        }
	        if (trailingComments.length > 0) {
	            node.trailingComments = trailingComments;
	        }
	        this.stack.push({
	            node: node,
	            start: metadata.start.offset
	        });
	    };
	    CommentHandler.prototype.visitComment = function (node, metadata) {
	        var type = (node.type[0] === 'L') ? 'Line' : 'Block';
	        var comment = {
	            type: type,
	            value: node.value
	        };
	        if (node.range) {
	            comment.range = node.range;
	        }
	        if (node.loc) {
	            comment.loc = node.loc;
	        }
	        this.comments.push(comment);
	        if (this.attach) {
	            var entry = {
	                comment: {
	                    type: type,
	                    value: node.value,
	                    range: [metadata.start.offset, metadata.end.offset]
	                },
	                start: metadata.start.offset
	            };
	            if (node.loc) {
	                entry.comment.loc = node.loc;
	            }
	            node.type = type;
	            this.leading.push(entry);
	            this.trailing.push(entry);
	        }
	    };
	    CommentHandler.prototype.visit = function (node, metadata) {
	        if (node.type === 'LineComment') {
	            this.visitComment(node, metadata);
	        }
	        else if (node.type === 'BlockComment') {
	            this.visitComment(node, metadata);
	        }
	        else if (this.attach) {
	            this.visitNode(node, metadata);
	        }
	    };
	    return CommentHandler;
	}());
	exports.CommentHandler = CommentHandler;


/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	exports.Syntax = {
	    AssignmentExpression: 'AssignmentExpression',
	    AssignmentPattern: 'AssignmentPattern',
	    ArrayExpression: 'ArrayExpression',
	    ArrayPattern: 'ArrayPattern',
	    ArrowFunctionExpression: 'ArrowFunctionExpression',
	    BlockStatement: 'BlockStatement',
	    BinaryExpression: 'BinaryExpression',
	    BreakStatement: 'BreakStatement',
	    CallExpression: 'CallExpression',
	    CatchClause: 'CatchClause',
	    ClassBody: 'ClassBody',
	    ClassDeclaration: 'ClassDeclaration',
	    ClassExpression: 'ClassExpression',
	    ConditionalExpression: 'ConditionalExpression',
	    ContinueStatement: 'ContinueStatement',
	    DoWhileStatement: 'DoWhileStatement',
	    DebuggerStatement: 'DebuggerStatement',
	    EmptyStatement: 'EmptyStatement',
	    ExportAllDeclaration: 'ExportAllDeclaration',
	    ExportDefaultDeclaration: 'ExportDefaultDeclaration',
	    ExportNamedDeclaration: 'ExportNamedDeclaration',
	    ExportSpecifier: 'ExportSpecifier',
	    ExpressionStatement: 'ExpressionStatement',
	    ForStatement: 'ForStatement',
	    ForOfStatement: 'ForOfStatement',
	    ForInStatement: 'ForInStatement',
	    FunctionDeclaration: 'FunctionDeclaration',
	    FunctionExpression: 'FunctionExpression',
	    Identifier: 'Identifier',
	    IfStatement: 'IfStatement',
	    ImportDeclaration: 'ImportDeclaration',
	    ImportDefaultSpecifier: 'ImportDefaultSpecifier',
	    ImportNamespaceSpecifier: 'ImportNamespaceSpecifier',
	    ImportSpecifier: 'ImportSpecifier',
	    Literal: 'Literal',
	    LabeledStatement: 'LabeledStatement',
	    LogicalExpression: 'LogicalExpression',
	    MemberExpression: 'MemberExpression',
	    MetaProperty: 'MetaProperty',
	    MethodDefinition: 'MethodDefinition',
	    NewExpression: 'NewExpression',
	    ObjectExpression: 'ObjectExpression',
	    ObjectPattern: 'ObjectPattern',
	    Program: 'Program',
	    Property: 'Property',
	    RestElement: 'RestElement',
	    ReturnStatement: 'ReturnStatement',
	    SequenceExpression: 'SequenceExpression',
	    SpreadElement: 'SpreadElement',
	    Super: 'Super',
	    SwitchCase: 'SwitchCase',
	    SwitchStatement: 'SwitchStatement',
	    TaggedTemplateExpression: 'TaggedTemplateExpression',
	    TemplateElement: 'TemplateElement',
	    TemplateLiteral: 'TemplateLiteral',
	    ThisExpression: 'ThisExpression',
	    ThrowStatement: 'ThrowStatement',
	    TryStatement: 'TryStatement',
	    UnaryExpression: 'UnaryExpression',
	    UpdateExpression: 'UpdateExpression',
	    VariableDeclaration: 'VariableDeclaration',
	    VariableDeclarator: 'VariableDeclarator',
	    WhileStatement: 'WhileStatement',
	    WithStatement: 'WithStatement',
	    YieldExpression: 'YieldExpression'
	};


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var assert_1 = __webpack_require__(4);
	var messages_1 = __webpack_require__(5);
	var error_handler_1 = __webpack_require__(6);
	var token_1 = __webpack_require__(7);
	var scanner_1 = __webpack_require__(8);
	var syntax_1 = __webpack_require__(2);
	var Node = __webpack_require__(10);
	var ArrowParameterPlaceHolder = 'ArrowParameterPlaceHolder';
	var Parser = (function () {
	    function Parser(code, options, delegate) {
	        if (options === void 0) { options = {}; }
	        this.config = {
	            range: (typeof options.range === 'boolean') && options.range,
	            loc: (typeof options.loc === 'boolean') && options.loc,
	            source: null,
	            tokens: (typeof options.tokens === 'boolean') && options.tokens,
	            comment: (typeof options.comment === 'boolean') && options.comment,
	            tolerant: (typeof options.tolerant === 'boolean') && options.tolerant
	        };
	        if (this.config.loc && options.source && options.source !== null) {
	            this.config.source = String(options.source);
	        }
	        this.delegate = delegate;
	        this.errorHandler = new error_handler_1.ErrorHandler();
	        this.errorHandler.tolerant = this.config.tolerant;
	        this.scanner = new scanner_1.Scanner(code, this.errorHandler);
	        this.scanner.trackComment = this.config.comment;
	        this.operatorPrecedence = {
	            ')': 0,
	            ';': 0,
	            ',': 0,
	            '=': 0,
	            ']': 0,
	            '||': 1,
	            '&&': 2,
	            '|': 3,
	            '^': 4,
	            '&': 5,
	            '==': 6,
	            '!=': 6,
	            '===': 6,
	            '!==': 6,
	            '<': 7,
	            '>': 7,
	            '<=': 7,
	            '>=': 7,
	            '<<': 8,
	            '>>': 8,
	            '>>>': 8,
	            '+': 9,
	            '-': 9,
	            '*': 11,
	            '/': 11,
	            '%': 11
	        };
	        this.sourceType = (options && options.sourceType === 'module') ? 'module' : 'script';
	        this.lookahead = null;
	        this.hasLineTerminator = false;
	        this.context = {
	            allowIn: true,
	            allowYield: true,
	            firstCoverInitializedNameError: null,
	            isAssignmentTarget: false,
	            isBindingElement: false,
	            inFunctionBody: false,
	            inIteration: false,
	            inSwitch: false,
	            labelSet: {},
	            strict: (this.sourceType === 'module')
	        };
	        this.tokens = [];
	        this.startMarker = {
	            index: 0,
	            lineNumber: this.scanner.lineNumber,
	            lineStart: 0
	        };
	        this.lastMarker = {
	            index: 0,
	            lineNumber: this.scanner.lineNumber,
	            lineStart: 0
	        };
	        this.nextToken();
	        this.lastMarker = {
	            index: this.scanner.index,
	            lineNumber: this.scanner.lineNumber,
	            lineStart: this.scanner.lineStart
	        };
	    }
	    Parser.prototype.throwError = function (messageFormat) {
	        var values = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            values[_i - 1] = arguments[_i];
	        }
	        var args = Array.prototype.slice.call(arguments, 1);
	        var msg = messageFormat.replace(/%(\d)/g, function (whole, idx) {
	            assert_1.assert(idx < args.length, 'Message reference must be in range');
	            return args[idx];
	        });
	        var index = this.lastMarker.index;
	        var line = this.lastMarker.lineNumber;
	        var column = this.lastMarker.index - this.lastMarker.lineStart + 1;
	        throw this.errorHandler.createError(index, line, column, msg);
	    };
	    Parser.prototype.tolerateError = function (messageFormat) {
	        var values = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            values[_i - 1] = arguments[_i];
	        }
	        var args = Array.prototype.slice.call(arguments, 1);
	        var msg = messageFormat.replace(/%(\d)/g, function (whole, idx) {
	            assert_1.assert(idx < args.length, 'Message reference must be in range');
	            return args[idx];
	        });
	        var index = this.lastMarker.index;
	        var line = this.scanner.lineNumber;
	        var column = this.lastMarker.index - this.lastMarker.lineStart + 1;
	        this.errorHandler.tolerateError(index, line, column, msg);
	    };
	    // Throw an exception because of the token.
	    Parser.prototype.unexpectedTokenError = function (token, message) {
	        var msg = message || messages_1.Messages.UnexpectedToken;
	        var value;
	        if (token) {
	            if (!message) {
	                msg = (token.type === token_1.Token.EOF) ? messages_1.Messages.UnexpectedEOS :
	                    (token.type === token_1.Token.Identifier) ? messages_1.Messages.UnexpectedIdentifier :
	                        (token.type === token_1.Token.NumericLiteral) ? messages_1.Messages.UnexpectedNumber :
	                            (token.type === token_1.Token.StringLiteral) ? messages_1.Messages.UnexpectedString :
	                                (token.type === token_1.Token.Template) ? messages_1.Messages.UnexpectedTemplate :
	                                    messages_1.Messages.UnexpectedToken;
	                if (token.type === token_1.Token.Keyword) {
	                    if (this.scanner.isFutureReservedWord(token.value)) {
	                        msg = messages_1.Messages.UnexpectedReserved;
	                    }
	                    else if (this.context.strict && this.scanner.isStrictModeReservedWord(token.value)) {
	                        msg = messages_1.Messages.StrictReservedWord;
	                    }
	                }
	            }
	            value = (token.type === token_1.Token.Template) ? token.value.raw : token.value;
	        }
	        else {
	            value = 'ILLEGAL';
	        }
	        msg = msg.replace('%0', value);
	        if (token && typeof token.lineNumber === 'number') {
	            var index = token.start;
	            var line = token.lineNumber;
	            var column = token.start - this.lastMarker.lineStart + 1;
	            return this.errorHandler.createError(index, line, column, msg);
	        }
	        else {
	            var index = this.lastMarker.index;
	            var line = this.lastMarker.lineNumber;
	            var column = index - this.lastMarker.lineStart + 1;
	            return this.errorHandler.createError(index, line, column, msg);
	        }
	    };
	    Parser.prototype.throwUnexpectedToken = function (token, message) {
	        throw this.unexpectedTokenError(token, message);
	    };
	    Parser.prototype.tolerateUnexpectedToken = function (token, message) {
	        this.errorHandler.tolerate(this.unexpectedTokenError(token, message));
	    };
	    Parser.prototype.collectComments = function () {
	        if (!this.config.comment) {
	            this.scanner.scanComments();
	        }
	        else {
	            var comments = this.scanner.scanComments();
	            if (comments.length > 0 && this.delegate) {
	                for (var i = 0; i < comments.length; ++i) {
	                    var e = comments[i];
	                    var node = void 0;
	                    node = {
	                        type: e.multiLine ? 'BlockComment' : 'LineComment',
	                        value: this.scanner.source.slice(e.slice[0], e.slice[1])
	                    };
	                    if (this.config.range) {
	                        node.range = e.range;
	                    }
	                    if (this.config.loc) {
	                        node.loc = e.loc;
	                    }
	                    var metadata = {
	                        start: {
	                            line: e.loc.start.line,
	                            column: e.loc.start.column,
	                            offset: e.range[0]
	                        },
	                        end: {
	                            line: e.loc.end.line,
	                            column: e.loc.end.column,
	                            offset: e.range[1]
	                        }
	                    };
	                    this.delegate(node, metadata);
	                }
	            }
	        }
	    };
	    // From internal representation to an external structure
	    Parser.prototype.getTokenRaw = function (token) {
	        return this.scanner.source.slice(token.start, token.end);
	    };
	    Parser.prototype.convertToken = function (token) {
	        var t;
	        t = {
	            type: token_1.TokenName[token.type],
	            value: this.getTokenRaw(token)
	        };
	        if (this.config.range) {
	            t.range = [token.start, token.end];
	        }
	        if (this.config.loc) {
	            t.loc = {
	                start: {
	                    line: this.startMarker.lineNumber,
	                    column: this.startMarker.index - this.startMarker.lineStart
	                },
	                end: {
	                    line: this.scanner.lineNumber,
	                    column: this.scanner.index - this.scanner.lineStart
	                }
	            };
	        }
	        if (token.regex) {
	            t.regex = token.regex;
	        }
	        return t;
	    };
	    Parser.prototype.nextToken = function () {
	        var token = this.lookahead;
	        this.lastMarker.index = this.scanner.index;
	        this.lastMarker.lineNumber = this.scanner.lineNumber;
	        this.lastMarker.lineStart = this.scanner.lineStart;
	        this.collectComments();
	        this.startMarker.index = this.scanner.index;
	        this.startMarker.lineNumber = this.scanner.lineNumber;
	        this.startMarker.lineStart = this.scanner.lineStart;
	        var next;
	        next = this.scanner.lex();
	        this.hasLineTerminator = (token && next) ? (token.lineNumber !== next.lineNumber) : false;
	        if (next && this.context.strict && next.type === token_1.Token.Identifier) {
	            if (this.scanner.isStrictModeReservedWord(next.value)) {
	                next.type = token_1.Token.Keyword;
	            }
	        }
	        this.lookahead = next;
	        if (this.config.tokens && next.type !== token_1.Token.EOF) {
	            this.tokens.push(this.convertToken(next));
	        }
	        return token;
	    };
	    Parser.prototype.nextRegexToken = function () {
	        this.collectComments();
	        var token = this.scanner.scanRegExp();
	        if (this.config.tokens) {
	            // Pop the previous token, '/' or '/='
	            // This is added from the lookahead token.
	            this.tokens.pop();
	            this.tokens.push(this.convertToken(token));
	        }
	        // Prime the next lookahead.
	        this.lookahead = token;
	        this.nextToken();
	        return token;
	    };
	    Parser.prototype.createNode = function () {
	        return {
	            index: this.startMarker.index,
	            line: this.startMarker.lineNumber,
	            column: this.startMarker.index - this.startMarker.lineStart
	        };
	    };
	    Parser.prototype.startNode = function (token) {
	        return {
	            index: token.start,
	            line: token.lineNumber,
	            column: token.start - token.lineStart
	        };
	    };
	    Parser.prototype.finalize = function (meta, node) {
	        if (this.config.range) {
	            node.range = [meta.index, this.lastMarker.index];
	        }
	        if (this.config.loc) {
	            node.loc = {
	                start: {
	                    line: meta.line,
	                    column: meta.column
	                },
	                end: {
	                    line: this.lastMarker.lineNumber,
	                    column: this.lastMarker.index - this.lastMarker.lineStart
	                }
	            };
	            if (this.config.source) {
	                node.loc.source = this.config.source;
	            }
	        }
	        if (this.delegate) {
	            var metadata = {
	                start: {
	                    line: meta.line,
	                    column: meta.column,
	                    offset: meta.index
	                },
	                end: {
	                    line: this.lastMarker.lineNumber,
	                    column: this.lastMarker.index - this.lastMarker.lineStart,
	                    offset: this.lastMarker.index
	                }
	            };
	            this.delegate(node, metadata);
	        }
	        return node;
	    };
	    // Expect the next token to match the specified punctuator.
	    // If not, an exception will be thrown.
	    Parser.prototype.expect = function (value) {
	        var token = this.nextToken();
	        if (token.type !== token_1.Token.Punctuator || token.value !== value) {
	            this.throwUnexpectedToken(token);
	        }
	    };
	    // Quietly expect a comma when in tolerant mode, otherwise delegates to expect().
	    Parser.prototype.expectCommaSeparator = function () {
	        if (this.config.tolerant) {
	            var token = this.lookahead;
	            if (token.type === token_1.Token.Punctuator && token.value === ',') {
	                this.nextToken();
	            }
	            else if (token.type === token_1.Token.Punctuator && token.value === ';') {
	                this.nextToken();
	                this.tolerateUnexpectedToken(token);
	            }
	            else {
	                this.tolerateUnexpectedToken(token, messages_1.Messages.UnexpectedToken);
	            }
	        }
	        else {
	            this.expect(',');
	        }
	    };
	    // Expect the next token to match the specified keyword.
	    // If not, an exception will be thrown.
	    Parser.prototype.expectKeyword = function (keyword) {
	        var token = this.nextToken();
	        if (token.type !== token_1.Token.Keyword || token.value !== keyword) {
	            this.throwUnexpectedToken(token);
	        }
	    };
	    // Return true if the next token matches the specified punctuator.
	    Parser.prototype.match = function (value) {
	        return this.lookahead.type === token_1.Token.Punctuator && this.lookahead.value === value;
	    };
	    // Return true if the next token matches the specified keyword
	    Parser.prototype.matchKeyword = function (keyword) {
	        return this.lookahead.type === token_1.Token.Keyword && this.lookahead.value === keyword;
	    };
	    // Return true if the next token matches the specified contextual keyword
	    // (where an identifier is sometimes a keyword depending on the context)
	    Parser.prototype.matchContextualKeyword = function (keyword) {
	        return this.lookahead.type === token_1.Token.Identifier && this.lookahead.value === keyword;
	    };
	    // Return true if the next token is an assignment operator
	    Parser.prototype.matchAssign = function () {
	        if (this.lookahead.type !== token_1.Token.Punctuator) {
	            return false;
	        }
	        var op = this.lookahead.value;
	        return op === '=' ||
	            op === '*=' ||
	            op === '**=' ||
	            op === '/=' ||
	            op === '%=' ||
	            op === '+=' ||
	            op === '-=' ||
	            op === '<<=' ||
	            op === '>>=' ||
	            op === '>>>=' ||
	            op === '&=' ||
	            op === '^=' ||
	            op === '|=';
	    };
	    // Cover grammar support.
	    //
	    // When an assignment expression position starts with an left parenthesis, the determination of the type
	    // of the syntax is to be deferred arbitrarily long until the end of the parentheses pair (plus a lookahead)
	    // or the first comma. This situation also defers the determination of all the expressions nested in the pair.
	    //
	    // There are three productions that can be parsed in a parentheses pair that needs to be determined
	    // after the outermost pair is closed. They are:
	    //
	    //   1. AssignmentExpression
	    //   2. BindingElements
	    //   3. AssignmentTargets
	    //
	    // In order to avoid exponential backtracking, we use two flags to denote if the production can be
	    // binding element or assignment target.
	    //
	    // The three productions have the relationship:
	    //
	    //   BindingElements ⊆ AssignmentTargets ⊆ AssignmentExpression
	    //
	    // with a single exception that CoverInitializedName when used directly in an Expression, generates
	    // an early error. Therefore, we need the third state, firstCoverInitializedNameError, to track the
	    // first usage of CoverInitializedName and report it when we reached the end of the parentheses pair.
	    //
	    // isolateCoverGrammar function runs the given parser function with a new cover grammar context, and it does not
	    // effect the current flags. This means the production the parser parses is only used as an expression. Therefore
	    // the CoverInitializedName check is conducted.
	    //
	    // inheritCoverGrammar function runs the given parse function with a new cover grammar context, and it propagates
	    // the flags outside of the parser. This means the production the parser parses is used as a part of a potential
	    // pattern. The CoverInitializedName check is deferred.
	    Parser.prototype.isolateCoverGrammar = function (parseFunction) {
	        var previousIsBindingElement = this.context.isBindingElement;
	        var previousIsAssignmentTarget = this.context.isAssignmentTarget;
	        var previousFirstCoverInitializedNameError = this.context.firstCoverInitializedNameError;
	        this.context.isBindingElement = true;
	        this.context.isAssignmentTarget = true;
	        this.context.firstCoverInitializedNameError = null;
	        var result = parseFunction.call(this);
	        if (this.context.firstCoverInitializedNameError !== null) {
	            this.throwUnexpectedToken(this.context.firstCoverInitializedNameError);
	        }
	        this.context.isBindingElement = previousIsBindingElement;
	        this.context.isAssignmentTarget = previousIsAssignmentTarget;
	        this.context.firstCoverInitializedNameError = previousFirstCoverInitializedNameError;
	        return result;
	    };
	    Parser.prototype.inheritCoverGrammar = function (parseFunction) {
	        var previousIsBindingElement = this.context.isBindingElement;
	        var previousIsAssignmentTarget = this.context.isAssignmentTarget;
	        var previousFirstCoverInitializedNameError = this.context.firstCoverInitializedNameError;
	        this.context.isBindingElement = true;
	        this.context.isAssignmentTarget = true;
	        this.context.firstCoverInitializedNameError = null;
	        var result = parseFunction.call(this);
	        this.context.isBindingElement = this.context.isBindingElement && previousIsBindingElement;
	        this.context.isAssignmentTarget = this.context.isAssignmentTarget && previousIsAssignmentTarget;
	        this.context.firstCoverInitializedNameError = previousFirstCoverInitializedNameError || this.context.firstCoverInitializedNameError;
	        return result;
	    };
	    Parser.prototype.consumeSemicolon = function () {
	        if (this.match(';')) {
	            this.nextToken();
	        }
	        else if (!this.hasLineTerminator) {
	            if (this.lookahead.type !== token_1.Token.EOF && !this.match('}')) {
	                this.throwUnexpectedToken(this.lookahead);
	            }
	            this.lastMarker.index = this.startMarker.index;
	            this.lastMarker.lineNumber = this.startMarker.lineNumber;
	            this.lastMarker.lineStart = this.startMarker.lineStart;
	        }
	    };
	    // ECMA-262 12.2 Primary Expressions
	    Parser.prototype.parsePrimaryExpression = function () {
	        var node = this.createNode();
	        var expr;
	        var value, token, raw;
	        switch (this.lookahead.type) {
	            case token_1.Token.Identifier:
	                if (this.sourceType === 'module' && this.lookahead.value === 'await') {
	                    this.tolerateUnexpectedToken(this.lookahead);
	                }
	                expr = this.finalize(node, new Node.Identifier(this.nextToken().value));
	                break;
	            case token_1.Token.NumericLiteral:
	            case token_1.Token.StringLiteral:
	                if (this.context.strict && this.lookahead.octal) {
	                    this.tolerateUnexpectedToken(this.lookahead, messages_1.Messages.StrictOctalLiteral);
	                }
	                this.context.isAssignmentTarget = false;
	                this.context.isBindingElement = false;
	                token = this.nextToken();
	                raw = this.getTokenRaw(token);
	                expr = this.finalize(node, new Node.Literal(token.value, raw));
	                break;
	            case token_1.Token.BooleanLiteral:
	                this.context.isAssignmentTarget = false;
	                this.context.isBindingElement = false;
	                token = this.nextToken();
	                token.value = (token.value === 'true');
	                raw = this.getTokenRaw(token);
	                expr = this.finalize(node, new Node.Literal(token.value, raw));
	                break;
	            case token_1.Token.NullLiteral:
	                this.context.isAssignmentTarget = false;
	                this.context.isBindingElement = false;
	                token = this.nextToken();
	                token.value = null;
	                raw = this.getTokenRaw(token);
	                expr = this.finalize(node, new Node.Literal(token.value, raw));
	                break;
	            case token_1.Token.Template:
	                expr = this.parseTemplateLiteral();
	                break;
	            case token_1.Token.Punctuator:
	                value = this.lookahead.value;
	                switch (value) {
	                    case '(':
	                        this.context.isBindingElement = false;
	                        expr = this.inheritCoverGrammar(this.parseGroupExpression);
	                        break;
	                    case '[':
	                        expr = this.inheritCoverGrammar(this.parseArrayInitializer);
	                        break;
	                    case '{':
	                        expr = this.inheritCoverGrammar(this.parseObjectInitializer);
	                        break;
	                    case '/':
	                    case '/=':
	                        this.context.isAssignmentTarget = false;
	                        this.context.isBindingElement = false;
	                        this.scanner.index = this.startMarker.index;
	                        token = this.nextRegexToken();
	                        raw = this.getTokenRaw(token);
	                        expr = this.finalize(node, new Node.RegexLiteral(token.value, raw, token.regex));
	                        break;
	                    default:
	                        this.throwUnexpectedToken(this.nextToken());
	                }
	                break;
	            case token_1.Token.Keyword:
	                if (!this.context.strict && this.context.allowYield && this.matchKeyword('yield')) {
	                    expr = this.parseIdentifierName();
	                }
	                else if (!this.context.strict && this.matchKeyword('let')) {
	                    expr = this.finalize(node, new Node.Identifier(this.nextToken().value));
	                }
	                else {
	                    this.context.isAssignmentTarget = false;
	                    this.context.isBindingElement = false;
	                    if (this.matchKeyword('function')) {
	                        expr = this.parseFunctionExpression();
	                    }
	                    else if (this.matchKeyword('this')) {
	                        this.nextToken();
	                        expr = this.finalize(node, new Node.ThisExpression());
	                    }
	                    else if (this.matchKeyword('class')) {
	                        expr = this.parseClassExpression();
	                    }
	                    else {
	                        this.throwUnexpectedToken(this.nextToken());
	                    }
	                }
	                break;
	            default:
	                this.throwUnexpectedToken(this.nextToken());
	        }
	        return expr;
	    };
	    // ECMA-262 12.2.5 Array Initializer
	    Parser.prototype.parseSpreadElement = function () {
	        var node = this.createNode();
	        this.expect('...');
	        var arg = this.inheritCoverGrammar(this.parseAssignmentExpression);
	        return this.finalize(node, new Node.SpreadElement(arg));
	    };
	    Parser.prototype.parseArrayInitializer = function () {
	        var node = this.createNode();
	        var elements = [];
	        this.expect('[');
	        while (!this.match(']')) {
	            if (this.match(',')) {
	                this.nextToken();
	                elements.push(null);
	            }
	            else if (this.match('...')) {
	                var element = this.parseSpreadElement();
	                if (!this.match(']')) {
	                    this.context.isAssignmentTarget = false;
	                    this.context.isBindingElement = false;
	                    this.expect(',');
	                }
	                elements.push(element);
	            }
	            else {
	                elements.push(this.inheritCoverGrammar(this.parseAssignmentExpression));
	                if (!this.match(']')) {
	                    this.expect(',');
	                }
	            }
	        }
	        this.expect(']');
	        return this.finalize(node, new Node.ArrayExpression(elements));
	    };
	    // ECMA-262 12.2.6 Object Initializer
	    Parser.prototype.parsePropertyMethod = function (params) {
	        this.context.isAssignmentTarget = false;
	        this.context.isBindingElement = false;
	        var previousStrict = this.context.strict;
	        var body = this.isolateCoverGrammar(this.parseFunctionSourceElements);
	        if (this.context.strict && params.firstRestricted) {
	            this.tolerateUnexpectedToken(params.firstRestricted, params.message);
	        }
	        if (this.context.strict && params.stricted) {
	            this.tolerateUnexpectedToken(params.stricted, params.message);
	        }
	        this.context.strict = previousStrict;
	        return body;
	    };
	    Parser.prototype.parsePropertyMethodFunction = function () {
	        var isGenerator = false;
	        var node = this.createNode();
	        var previousAllowYield = this.context.allowYield;
	        this.context.allowYield = false;
	        var params = this.parseFormalParameters();
	        var method = this.parsePropertyMethod(params);
	        this.context.allowYield = previousAllowYield;
	        return this.finalize(node, new Node.FunctionExpression(null, params.params, method, isGenerator));
	    };
	    Parser.prototype.parseObjectPropertyKey = function () {
	        var node = this.createNode();
	        var token = this.nextToken();
	        var key = null;
	        switch (token.type) {
	            case token_1.Token.StringLiteral:
	            case token_1.Token.NumericLiteral:
	                if (this.context.strict && token.octal) {
	                    this.tolerateUnexpectedToken(token, messages_1.Messages.StrictOctalLiteral);
	                }
	                var raw = this.getTokenRaw(token);
	                key = this.finalize(node, new Node.Literal(token.value, raw));
	                break;
	            case token_1.Token.Identifier:
	            case token_1.Token.BooleanLiteral:
	            case token_1.Token.NullLiteral:
	            case token_1.Token.Keyword:
	                key = this.finalize(node, new Node.Identifier(token.value));
	                break;
	            case token_1.Token.Punctuator:
	                if (token.value === '[') {
	                    key = this.isolateCoverGrammar(this.parseAssignmentExpression);
	                    this.expect(']');
	                }
	                else {
	                    this.throwUnexpectedToken(token);
	                }
	                break;
	            default:
	                this.throwUnexpectedToken(token);
	        }
	        return key;
	    };
	    Parser.prototype.isPropertyKey = function (key, value) {
	        return (key.type === syntax_1.Syntax.Identifier && key.name === value) ||
	            (key.type === syntax_1.Syntax.Literal && key.value === value);
	    };
	    Parser.prototype.parseObjectProperty = function (hasProto) {
	        var node = this.createNode();
	        var token = this.lookahead;
	        var kind;
	        var key;
	        var value;
	        var computed = false;
	        var method = false;
	        var shorthand = false;
	        if (token.type === token_1.Token.Identifier) {
	            this.nextToken();
	            key = this.finalize(node, new Node.Identifier(token.value));
	        }
	        else if (this.match('*')) {
	            this.nextToken();
	        }
	        else {
	            computed = this.match('[');
	            key = this.parseObjectPropertyKey();
	        }
	        var lookaheadPropertyKey = this.qualifiedPropertyName(this.lookahead);
	        if (token.type === token_1.Token.Identifier && token.value === 'get' && lookaheadPropertyKey) {
	            kind = 'get';
	            computed = this.match('[');
	            key = this.parseObjectPropertyKey();
	            this.context.allowYield = false;
	            value = this.parseGetterMethod();
	        }
	        else if (token.type === token_1.Token.Identifier && token.value === 'set' && lookaheadPropertyKey) {
	            kind = 'set';
	            computed = this.match('[');
	            key = this.parseObjectPropertyKey();
	            value = this.parseSetterMethod();
	        }
	        else if (token.type === token_1.Token.Punctuator && token.value === '*' && lookaheadPropertyKey) {
	            kind = 'init';
	            computed = this.match('[');
	            key = this.parseObjectPropertyKey();
	            value = this.parseGeneratorMethod();
	            method = true;
	        }
	        else {
	            if (!key) {
	                this.throwUnexpectedToken(this.lookahead);
	            }
	            kind = 'init';
	            if (this.match(':')) {
	                if (!computed && this.isPropertyKey(key, '__proto__')) {
	                    if (hasProto.value) {
	                        this.tolerateError(messages_1.Messages.DuplicateProtoProperty);
	                    }
	                    hasProto.value = true;
	                }
	                this.nextToken();
	                value = this.inheritCoverGrammar(this.parseAssignmentExpression);
	            }
	            else if (this.match('(')) {
	                value = this.parsePropertyMethodFunction();
	                method = true;
	            }
	            else if (token.type === token_1.Token.Identifier) {
	                var id = this.finalize(node, new Node.Identifier(token.value));
	                if (this.match('=')) {
	                    this.context.firstCoverInitializedNameError = this.lookahead;
	                    this.nextToken();
	                    shorthand = true;
	                    var init = this.isolateCoverGrammar(this.parseAssignmentExpression);
	                    value = this.finalize(node, new Node.AssignmentPattern(id, init));
	                }
	                else {
	                    shorthand = true;
	                    value = id;
	                }
	            }
	            else {
	                this.throwUnexpectedToken(this.nextToken());
	            }
	        }
	        return this.finalize(node, new Node.Property(kind, key, computed, value, method, shorthand));
	    };
	    Parser.prototype.parseObjectInitializer = function () {
	        var node = this.createNode();
	        this.expect('{');
	        var properties = [];
	        var hasProto = { value: false };
	        while (!this.match('}')) {
	            properties.push(this.parseObjectProperty(hasProto));
	            if (!this.match('}')) {
	                this.expectCommaSeparator();
	            }
	        }
	        this.expect('}');
	        return this.finalize(node, new Node.ObjectExpression(properties));
	    };
	    // ECMA-262 12.2.9 Template Literals
	    Parser.prototype.parseTemplateHead = function () {
	        assert_1.assert(this.lookahead.head, 'Template literal must start with a template head');
	        var node = this.createNode();
	        var token = this.nextToken();
	        var value = {
	            raw: token.value.raw,
	            cooked: token.value.cooked
	        };
	        return this.finalize(node, new Node.TemplateElement(value, token.tail));
	    };
	    Parser.prototype.parseTemplateElement = function () {
	        if (this.lookahead.type !== token_1.Token.Template) {
	            this.throwUnexpectedToken();
	        }
	        var node = this.createNode();
	        var token = this.nextToken();
	        var value = {
	            raw: token.value.raw,
	            cooked: token.value.cooked
	        };
	        return this.finalize(node, new Node.TemplateElement(value, token.tail));
	    };
	    Parser.prototype.parseTemplateLiteral = function () {
	        var node = this.createNode();
	        var expressions = [];
	        var quasis = [];
	        var quasi = this.parseTemplateHead();
	        quasis.push(quasi);
	        while (!quasi.tail) {
	            expressions.push(this.parseExpression());
	            quasi = this.parseTemplateElement();
	            quasis.push(quasi);
	        }
	        return this.finalize(node, new Node.TemplateLiteral(quasis, expressions));
	    };
	    // ECMA-262 12.2.10 The Grouping Operator
	    Parser.prototype.reinterpretExpressionAsPattern = function (expr) {
	        switch (expr.type) {
	            case syntax_1.Syntax.Identifier:
	            case syntax_1.Syntax.MemberExpression:
	            case syntax_1.Syntax.RestElement:
	            case syntax_1.Syntax.AssignmentPattern:
	                break;
	            case syntax_1.Syntax.SpreadElement:
	                expr.type = syntax_1.Syntax.RestElement;
	                this.reinterpretExpressionAsPattern(expr.argument);
	                break;
	            case syntax_1.Syntax.ArrayExpression:
	                expr.type = syntax_1.Syntax.ArrayPattern;
	                for (var i = 0; i < expr.elements.length; i++) {
	                    if (expr.elements[i] !== null) {
	                        this.reinterpretExpressionAsPattern(expr.elements[i]);
	                    }
	                }
	                break;
	            case syntax_1.Syntax.ObjectExpression:
	                expr.type = syntax_1.Syntax.ObjectPattern;
	                for (var i = 0; i < expr.properties.length; i++) {
	                    this.reinterpretExpressionAsPattern(expr.properties[i].value);
	                }
	                break;
	            case syntax_1.Syntax.AssignmentExpression:
	                expr.type = syntax_1.Syntax.AssignmentPattern;
	                delete expr.operator;
	                this.reinterpretExpressionAsPattern(expr.left);
	                break;
	            default:
	                // Allow other node type for tolerant parsing.
	                break;
	        }
	    };
	    Parser.prototype.parseGroupExpression = function () {
	        var expr;
	        this.expect('(');
	        if (this.match(')')) {
	            this.nextToken();
	            if (!this.match('=>')) {
	                this.expect('=>');
	            }
	            expr = {
	                type: ArrowParameterPlaceHolder,
	                params: []
	            };
	        }
	        else {
	            var startToken = this.lookahead;
	            var params = [];
	            if (this.match('...')) {
	                expr = this.parseRestElement(params);
	                this.expect(')');
	                if (!this.match('=>')) {
	                    this.expect('=>');
	                }
	                expr = {
	                    type: ArrowParameterPlaceHolder,
	                    params: [expr]
	                };
	            }
	            else {
	                var arrow = false;
	                this.context.isBindingElement = true;
	                expr = this.inheritCoverGrammar(this.parseAssignmentExpression);
	                if (this.match(',')) {
	                    var expressions = [];
	                    this.context.isAssignmentTarget = false;
	                    expressions.push(expr);
	                    while (this.startMarker.index < this.scanner.length) {
	                        if (!this.match(',')) {
	                            break;
	                        }
	                        this.nextToken();
	                        if (this.match('...')) {
	                            if (!this.context.isBindingElement) {
	                                this.throwUnexpectedToken(this.lookahead);
	                            }
	                            expressions.push(this.parseRestElement(params));
	                            this.expect(')');
	                            if (!this.match('=>')) {
	                                this.expect('=>');
	                            }
	                            this.context.isBindingElement = false;
	                            for (var i = 0; i < expressions.length; i++) {
	                                this.reinterpretExpressionAsPattern(expressions[i]);
	                            }
	                            arrow = true;
	                            expr = {
	                                type: ArrowParameterPlaceHolder,
	                                params: expressions
	                            };
	                        }
	                        else {
	                            expressions.push(this.inheritCoverGrammar(this.parseAssignmentExpression));
	                        }
	                        if (arrow) {
	                            break;
	                        }
	                    }
	                    if (!arrow) {
	                        expr = this.finalize(this.startNode(startToken), new Node.SequenceExpression(expressions));
	                    }
	                }
	                if (!arrow) {
	                    this.expect(')');
	                    if (this.match('=>')) {
	                        if (expr.type === syntax_1.Syntax.Identifier && expr.name === 'yield') {
	                            arrow = true;
	                            expr = {
	                                type: ArrowParameterPlaceHolder,
	                                params: [expr]
	                            };
	                        }
	                        if (!arrow) {
	                            if (!this.context.isBindingElement) {
	                                this.throwUnexpectedToken(this.lookahead);
	                            }
	                            if (expr.type === syntax_1.Syntax.SequenceExpression) {
	                                for (var i = 0; i < expr.expressions.length; i++) {
	                                    this.reinterpretExpressionAsPattern(expr.expressions[i]);
	                                }
	                            }
	                            else {
	                                this.reinterpretExpressionAsPattern(expr);
	                            }
	                            var params_1 = (expr.type === syntax_1.Syntax.SequenceExpression ? expr.expressions : [expr]);
	                            expr = {
	                                type: ArrowParameterPlaceHolder,
	                                params: params_1
	                            };
	                        }
	                    }
	                    this.context.isBindingElement = false;
	                }
	            }
	        }
	        return expr;
	    };
	    // ECMA-262 12.3 Left-Hand-Side Expressions
	    Parser.prototype.parseArguments = function () {
	        this.expect('(');
	        var args = [];
	        if (!this.match(')')) {
	            while (true) {
	                var expr = this.match('...') ? this.parseSpreadElement() :
	                    this.isolateCoverGrammar(this.parseAssignmentExpression);
	                args.push(expr);
	                if (this.match(')')) {
	                    break;
	                }
	                this.expectCommaSeparator();
	            }
	        }
	        this.expect(')');
	        return args;
	    };
	    Parser.prototype.isIdentifierName = function (token) {
	        return token.type === token_1.Token.Identifier ||
	            token.type === token_1.Token.Keyword ||
	            token.type === token_1.Token.BooleanLiteral ||
	            token.type === token_1.Token.NullLiteral;
	    };
	    Parser.prototype.parseIdentifierName = function () {
	        var node = this.createNode();
	        var token = this.nextToken();
	        if (!this.isIdentifierName(token)) {
	            this.throwUnexpectedToken(token);
	        }
	        return this.finalize(node, new Node.Identifier(token.value));
	    };
	    Parser.prototype.parseNewExpression = function () {
	        var node = this.createNode();
	        var id = this.parseIdentifierName();
	        assert_1.assert(id.name === 'new', 'New expression must start with `new`');
	        var expr;
	        if (this.match('.')) {
	            this.nextToken();
	            if (this.lookahead.type === token_1.Token.Identifier && this.context.inFunctionBody && this.lookahead.value === 'target') {
	                var property = this.parseIdentifierName();
	                expr = new Node.MetaProperty(id, property);
	            }
	            else {
	                this.throwUnexpectedToken(this.lookahead);
	            }
	        }
	        else {
	            var callee = this.isolateCoverGrammar(this.parseLeftHandSideExpression);
	            var args = this.match('(') ? this.parseArguments() : [];
	            expr = new Node.NewExpression(callee, args);
	            this.context.isAssignmentTarget = false;
	            this.context.isBindingElement = false;
	        }
	        return this.finalize(node, expr);
	    };
	    Parser.prototype.parseLeftHandSideExpressionAllowCall = function () {
	        var startToken = this.lookahead;
	        var previousAllowIn = this.context.allowIn;
	        this.context.allowIn = true;
	        var expr;
	        if (this.matchKeyword('super') && this.context.inFunctionBody) {
	            expr = this.createNode();
	            this.nextToken();
	            expr = this.finalize(expr, new Node.Super());
	            if (!this.match('(') && !this.match('.') && !this.match('[')) {
	                this.throwUnexpectedToken(this.lookahead);
	            }
	        }
	        else {
	            expr = this.inheritCoverGrammar(this.matchKeyword('new') ? this.parseNewExpression : this.parsePrimaryExpression);
	        }
	        while (true) {
	            if (this.match('.')) {
	                this.context.isBindingElement = false;
	                this.context.isAssignmentTarget = true;
	                this.expect('.');
	                var property = this.parseIdentifierName();
	                expr = this.finalize(this.startNode(startToken), new Node.StaticMemberExpression(expr, property));
	            }
	            else if (this.match('(')) {
	                this.context.isBindingElement = false;
	                this.context.isAssignmentTarget = false;
	                var args = this.parseArguments();
	                expr = this.finalize(this.startNode(startToken), new Node.CallExpression(expr, args));
	            }
	            else if (this.match('[')) {
	                this.context.isBindingElement = false;
	                this.context.isAssignmentTarget = true;
	                this.expect('[');
	                var property = this.isolateCoverGrammar(this.parseExpression);
	                this.expect(']');
	                expr = this.finalize(this.startNode(startToken), new Node.ComputedMemberExpression(expr, property));
	            }
	            else if (this.lookahead.type === token_1.Token.Template && this.lookahead.head) {
	                var quasi = this.parseTemplateLiteral();
	                expr = this.finalize(this.startNode(startToken), new Node.TaggedTemplateExpression(expr, quasi));
	            }
	            else {
	                break;
	            }
	        }
	        this.context.allowIn = previousAllowIn;
	        return expr;
	    };
	    Parser.prototype.parseSuper = function () {
	        var node = this.createNode();
	        this.expectKeyword('super');
	        if (!this.match('[') && !this.match('.')) {
	            this.throwUnexpectedToken(this.lookahead);
	        }
	        return this.finalize(node, new Node.Super());
	    };
	    Parser.prototype.parseLeftHandSideExpression = function () {
	        assert_1.assert(this.context.allowIn, 'callee of new expression always allow in keyword.');
	        var node = this.startNode(this.lookahead);
	        var expr = (this.matchKeyword('super') && this.context.inFunctionBody) ? this.parseSuper() :
	            this.inheritCoverGrammar(this.matchKeyword('new') ? this.parseNewExpression : this.parsePrimaryExpression);
	        while (true) {
	            if (this.match('[')) {
	                this.context.isBindingElement = false;
	                this.context.isAssignmentTarget = true;
	                this.expect('[');
	                var property = this.isolateCoverGrammar(this.parseExpression);
	                this.expect(']');
	                expr = this.finalize(node, new Node.ComputedMemberExpression(expr, property));
	            }
	            else if (this.match('.')) {
	                this.context.isBindingElement = false;
	                this.context.isAssignmentTarget = true;
	                this.expect('.');
	                var property = this.parseIdentifierName();
	                expr = this.finalize(node, new Node.StaticMemberExpression(expr, property));
	            }
	            else if (this.lookahead.type === token_1.Token.Template && this.lookahead.head) {
	                var quasi = this.parseTemplateLiteral();
	                expr = this.finalize(node, new Node.TaggedTemplateExpression(expr, quasi));
	            }
	            else {
	                break;
	            }
	        }
	        return expr;
	    };
	    // ECMA-262 12.4 Update Expressions
	    Parser.prototype.parseUpdateExpression = function () {
	        var expr;
	        var startToken = this.lookahead;
	        if (this.match('++') || this.match('--')) {
	            var node = this.startNode(startToken);
	            var token = this.nextToken();
	            expr = this.inheritCoverGrammar(this.parseUnaryExpression);
	            if (this.context.strict && expr.type === syntax_1.Syntax.Identifier && this.scanner.isRestrictedWord(expr.name)) {
	                this.tolerateError(messages_1.Messages.StrictLHSPrefix);
	            }
	            if (!this.context.isAssignmentTarget) {
	                this.tolerateError(messages_1.Messages.InvalidLHSInAssignment);
	            }
	            var prefix = true;
	            expr = this.finalize(node, new Node.UpdateExpression(token.value, expr, prefix));
	            this.context.isAssignmentTarget = false;
	            this.context.isBindingElement = false;
	        }
	        else {
	            expr = this.inheritCoverGrammar(this.parseLeftHandSideExpressionAllowCall);
	            if (!this.hasLineTerminator && this.lookahead.type === token_1.Token.Punctuator) {
	                if (this.match('++') || this.match('--')) {
	                    if (this.context.strict && expr.type === syntax_1.Syntax.Identifier && this.scanner.isRestrictedWord(expr.name)) {
	                        this.tolerateError(messages_1.Messages.StrictLHSPostfix);
	                    }
	                    if (!this.context.isAssignmentTarget) {
	                        this.tolerateError(messages_1.Messages.InvalidLHSInAssignment);
	                    }
	                    this.context.isAssignmentTarget = false;
	                    this.context.isBindingElement = false;
	                    var operator = this.nextToken().value;
	                    var prefix = false;
	                    expr = this.finalize(this.startNode(startToken), new Node.UpdateExpression(operator, expr, prefix));
	                }
	            }
	        }
	        return expr;
	    };
	    // ECMA-262 12.5 Unary Operators
	    Parser.prototype.parseUnaryExpression = function () {
	        var expr;
	        if (this.match('+') || this.match('-') || this.match('~') || this.match('!') ||
	            this.matchKeyword('delete') || this.matchKeyword('void') || this.matchKeyword('typeof')) {
	            var node = this.startNode(this.lookahead);
	            var token = this.nextToken();
	            expr = this.inheritCoverGrammar(this.parseUnaryExpression);
	            expr = this.finalize(node, new Node.UnaryExpression(token.value, expr));
	            if (this.context.strict && expr.operator === 'delete' && expr.argument.type === syntax_1.Syntax.Identifier) {
	                this.tolerateError(messages_1.Messages.StrictDelete);
	            }
	            this.context.isAssignmentTarget = false;
	            this.context.isBindingElement = false;
	        }
	        else {
	            expr = this.parseUpdateExpression();
	        }
	        return expr;
	    };
	    Parser.prototype.parseExponentiationExpression = function () {
	        var startToken = this.lookahead;
	        var expr = this.inheritCoverGrammar(this.parseUnaryExpression);
	        if (expr.type !== syntax_1.Syntax.UnaryExpression && this.match('**')) {
	            this.nextToken();
	            this.context.isAssignmentTarget = false;
	            this.context.isBindingElement = false;
	            var left = expr;
	            var right = this.isolateCoverGrammar(this.parseExponentiationExpression);
	            expr = this.finalize(this.startNode(startToken), new Node.BinaryExpression('**', left, right));
	        }
	        return expr;
	    };
	    // ECMA-262 12.6 Exponentiation Operators
	    // ECMA-262 12.7 Multiplicative Operators
	    // ECMA-262 12.8 Additive Operators
	    // ECMA-262 12.9 Bitwise Shift Operators
	    // ECMA-262 12.10 Relational Operators
	    // ECMA-262 12.11 Equality Operators
	    // ECMA-262 12.12 Binary Bitwise Operators
	    // ECMA-262 12.13 Binary Logical Operators
	    Parser.prototype.binaryPrecedence = function (token) {
	        var op = token.value;
	        var precedence;
	        if (token.type === token_1.Token.Punctuator) {
	            precedence = this.operatorPrecedence[op] || 0;
	        }
	        else if (token.type === token_1.Token.Keyword) {
	            precedence = (op === 'instanceof' || (this.context.allowIn && op === 'in')) ? 7 : 0;
	        }
	        else {
	            precedence = 0;
	        }
	        return precedence;
	    };
	    Parser.prototype.parseBinaryExpression = function () {
	        var startToken = this.lookahead;
	        var expr = this.inheritCoverGrammar(this.parseExponentiationExpression);
	        var token = this.lookahead;
	        var prec = this.binaryPrecedence(token);
	        if (prec > 0) {
	            this.nextToken();
	            token.prec = prec;
	            this.context.isAssignmentTarget = false;
	            this.context.isBindingElement = false;
	            var markers = [startToken, this.lookahead];
	            var left = expr;
	            var right = this.isolateCoverGrammar(this.parseExponentiationExpression);
	            var stack = [left, token, right];
	            while (true) {
	                prec = this.binaryPrecedence(this.lookahead);
	                if (prec <= 0) {
	                    break;
	                }
	                // Reduce: make a binary expression from the three topmost entries.
	                while ((stack.length > 2) && (prec <= stack[stack.length - 2].prec)) {
	                    right = stack.pop();
	                    var operator = stack.pop().value;
	                    left = stack.pop();
	                    markers.pop();
	                    var node = this.startNode(markers[markers.length - 1]);
	                    stack.push(this.finalize(node, new Node.BinaryExpression(operator, left, right)));
	                }
	                // Shift.
	                token = this.nextToken();
	                token.prec = prec;
	                stack.push(token);
	                markers.push(this.lookahead);
	                stack.push(this.isolateCoverGrammar(this.parseExponentiationExpression));
	            }
	            // Final reduce to clean-up the stack.
	            var i = stack.length - 1;
	            expr = stack[i];
	            markers.pop();
	            while (i > 1) {
	                var node = this.startNode(markers.pop());
	                expr = this.finalize(node, new Node.BinaryExpression(stack[i - 1].value, stack[i - 2], expr));
	                i -= 2;
	            }
	        }
	        return expr;
	    };
	    // ECMA-262 12.14 Conditional Operator
	    Parser.prototype.parseConditionalExpression = function () {
	        var startToken = this.lookahead;
	        var expr = this.inheritCoverGrammar(this.parseBinaryExpression);
	        if (this.match('?')) {
	            this.nextToken();
	            var previousAllowIn = this.context.allowIn;
	            this.context.allowIn = true;
	            var consequent = this.isolateCoverGrammar(this.parseAssignmentExpression);
	            this.context.allowIn = previousAllowIn;
	            this.expect(':');
	            var alternate = this.isolateCoverGrammar(this.parseAssignmentExpression);
	            expr = this.finalize(this.startNode(startToken), new Node.ConditionalExpression(expr, consequent, alternate));
	            this.context.isAssignmentTarget = false;
	            this.context.isBindingElement = false;
	        }
	        return expr;
	    };
	    // ECMA-262 12.15 Assignment Operators
	    Parser.prototype.checkPatternParam = function (options, param) {
	        switch (param.type) {
	            case syntax_1.Syntax.Identifier:
	                this.validateParam(options, param, param.name);
	                break;
	            case syntax_1.Syntax.RestElement:
	                this.checkPatternParam(options, param.argument);
	                break;
	            case syntax_1.Syntax.AssignmentPattern:
	                this.checkPatternParam(options, param.left);
	                break;
	            case syntax_1.Syntax.ArrayPattern:
	                for (var i = 0; i < param.elements.length; i++) {
	                    if (param.elements[i] !== null) {
	                        this.checkPatternParam(options, param.elements[i]);
	                    }
	                }
	                break;
	            case syntax_1.Syntax.YieldExpression:
	                break;
	            default:
	                assert_1.assert(param.type === syntax_1.Syntax.ObjectPattern, 'Invalid type');
	                for (var i = 0; i < param.properties.length; i++) {
	                    this.checkPatternParam(options, param.properties[i].value);
	                }
	                break;
	        }
	    };
	    Parser.prototype.reinterpretAsCoverFormalsList = function (expr) {
	        var params = [expr];
	        var options;
	        switch (expr.type) {
	            case syntax_1.Syntax.Identifier:
	                break;
	            case ArrowParameterPlaceHolder:
	                params = expr.params;
	                break;
	            default:
	                return null;
	        }
	        options = {
	            paramSet: {}
	        };
	        for (var i = 0; i < params.length; ++i) {
	            var param = params[i];
	            if (param.type === syntax_1.Syntax.AssignmentPattern) {
	                if (param.right.type === syntax_1.Syntax.YieldExpression) {
	                    if (param.right.argument) {
	                        this.throwUnexpectedToken(this.lookahead);
	                    }
	                    param.right.type = syntax_1.Syntax.Identifier;
	                    param.right.name = 'yield';
	                    delete param.right.argument;
	                    delete param.right.delegate;
	                }
	            }
	            this.checkPatternParam(options, param);
	            params[i] = param;
	        }
	        if (this.context.strict || !this.context.allowYield) {
	            for (var i = 0; i < params.length; ++i) {
	                var param = params[i];
	                if (param.type === syntax_1.Syntax.YieldExpression) {
	                    this.throwUnexpectedToken(this.lookahead);
	                }
	            }
	        }
	        if (options.message === messages_1.Messages.StrictParamDupe) {
	            var token = this.context.strict ? options.stricted : options.firstRestricted;
	            this.throwUnexpectedToken(token, options.message);
	        }
	        return {
	            params: params,
	            stricted: options.stricted,
	            firstRestricted: options.firstRestricted,
	            message: options.message
	        };
	    };
	    Parser.prototype.parseAssignmentExpression = function () {
	        var expr;
	        if (!this.context.allowYield && this.matchKeyword('yield')) {
	            expr = this.parseYieldExpression();
	        }
	        else {
	            var startToken = this.lookahead;
	            var token = startToken;
	            expr = this.parseConditionalExpression();
	            if (expr.type === ArrowParameterPlaceHolder || this.match('=>')) {
	                // ECMA-262 14.2 Arrow Function Definitions
	                this.context.isAssignmentTarget = false;
	                this.context.isBindingElement = false;
	                var list = this.reinterpretAsCoverFormalsList(expr);
	                if (list) {
	                    if (this.hasLineTerminator) {
	                        this.tolerateUnexpectedToken(this.lookahead);
	                    }
	                    this.context.firstCoverInitializedNameError = null;
	                    var previousStrict = this.context.strict;
	                    var previousAllowYield = this.context.allowYield;
	                    this.context.allowYield = true;
	                    var node = this.startNode(startToken);
	                    this.expect('=>');
	                    var body = this.match('{') ? this.parseFunctionSourceElements() :
	                        this.isolateCoverGrammar(this.parseAssignmentExpression);
	                    var expression = body.type !== syntax_1.Syntax.BlockStatement;
	                    if (this.context.strict && list.firstRestricted) {
	                        this.throwUnexpectedToken(list.firstRestricted, list.message);
	                    }
	                    if (this.context.strict && list.stricted) {
	                        this.tolerateUnexpectedToken(list.stricted, list.message);
	                    }
	                    expr = this.finalize(node, new Node.ArrowFunctionExpression(list.params, body, expression));
	                    this.context.strict = previousStrict;
	                    this.context.allowYield = previousAllowYield;
	                }
	            }
	            else {
	                if (this.matchAssign()) {
	                    if (!this.context.isAssignmentTarget) {
	                        this.tolerateError(messages_1.Messages.InvalidLHSInAssignment);
	                    }
	                    if (this.context.strict && expr.type === syntax_1.Syntax.Identifier) {
	                        var id = (expr);
	                        if (this.scanner.isRestrictedWord(id.name)) {
	                            this.tolerateUnexpectedToken(token, messages_1.Messages.StrictLHSAssignment);
	                        }
	                        if (this.scanner.isStrictModeReservedWord(id.name)) {
	                            this.tolerateUnexpectedToken(token, messages_1.Messages.StrictReservedWord);
	                        }
	                    }
	                    if (!this.match('=')) {
	                        this.context.isAssignmentTarget = false;
	                        this.context.isBindingElement = false;
	                    }
	                    else {
	                        this.reinterpretExpressionAsPattern(expr);
	                    }
	                    token = this.nextToken();
	                    var right = this.isolateCoverGrammar(this.parseAssignmentExpression);
	                    expr = this.finalize(this.startNode(startToken), new Node.AssignmentExpression(token.value, expr, right));
	                    this.context.firstCoverInitializedNameError = null;
	                }
	            }
	        }
	        return expr;
	    };
	    // ECMA-262 12.16 Comma Operator
	    Parser.prototype.parseExpression = function () {
	        var startToken = this.lookahead;
	        var expr = this.isolateCoverGrammar(this.parseAssignmentExpression);
	        if (this.match(',')) {
	            var expressions = [];
	            expressions.push(expr);
	            while (this.startMarker.index < this.scanner.length) {
	                if (!this.match(',')) {
	                    break;
	                }
	                this.nextToken();
	                expressions.push(this.isolateCoverGrammar(this.parseAssignmentExpression));
	            }
	            expr = this.finalize(this.startNode(startToken), new Node.SequenceExpression(expressions));
	        }
	        return expr;
	    };
	    // ECMA-262 13.2 Block
	    Parser.prototype.parseStatementListItem = function () {
	        var statement = null;
	        this.context.isAssignmentTarget = true;
	        this.context.isBindingElement = true;
	        if (this.lookahead.type === token_1.Token.Keyword) {
	            switch (this.lookahead.value) {
	                case 'export':
	                    if (this.sourceType !== 'module') {
	                        this.tolerateUnexpectedToken(this.lookahead, messages_1.Messages.IllegalExportDeclaration);
	                    }
	                    statement = this.parseExportDeclaration();
	                    break;
	                case 'import':
	                    if (this.sourceType !== 'module') {
	                        this.tolerateUnexpectedToken(this.lookahead, messages_1.Messages.IllegalImportDeclaration);
	                    }
	                    statement = this.parseImportDeclaration();
	                    break;
	                case 'const':
	                    statement = this.parseLexicalDeclaration({ inFor: false });
	                    break;
	                case 'function':
	                    statement = this.parseFunctionDeclaration();
	                    break;
	                case 'class':
	                    statement = this.parseClassDeclaration();
	                    break;
	                case 'let':
	                    statement = this.isLexicalDeclaration() ? this.parseLexicalDeclaration({ inFor: false }) : this.parseStatement();
	                    break;
	                default:
	                    statement = this.parseStatement();
	                    break;
	            }
	        }
	        else {
	            statement = this.parseStatement();
	        }
	        return statement;
	    };
	    Parser.prototype.parseBlock = function () {
	        var node = this.createNode();
	        this.expect('{');
	        var block = [];
	        while (true) {
	            if (this.match('}')) {
	                break;
	            }
	            block.push(this.parseStatementListItem());
	        }
	        this.expect('}');
	        return this.finalize(node, new Node.BlockStatement(block));
	    };
	    // ECMA-262 13.3.1 Let and Const Declarations
	    Parser.prototype.parseLexicalBinding = function (kind, options) {
	        var node = this.createNode();
	        var params = [];
	        var id = this.parsePattern(params, kind);
	        // ECMA-262 12.2.1
	        if (this.context.strict && id.type === syntax_1.Syntax.Identifier) {
	            if (this.scanner.isRestrictedWord((id).name)) {
	                this.tolerateError(messages_1.Messages.StrictVarName);
	            }
	        }
	        var init = null;
	        if (kind === 'const') {
	            if (!this.matchKeyword('in') && !this.matchContextualKeyword('of')) {
	                this.expect('=');
	                init = this.isolateCoverGrammar(this.parseAssignmentExpression);
	            }
	        }
	        else if ((!options.inFor && id.type !== syntax_1.Syntax.Identifier) || this.match('=')) {
	            this.expect('=');
	            init = this.isolateCoverGrammar(this.parseAssignmentExpression);
	        }
	        return this.finalize(node, new Node.VariableDeclarator(id, init));
	    };
	    Parser.prototype.parseBindingList = function (kind, options) {
	        var list = [this.parseLexicalBinding(kind, options)];
	        while (this.match(',')) {
	            this.nextToken();
	            list.push(this.parseLexicalBinding(kind, options));
	        }
	        return list;
	    };
	    Parser.prototype.isLexicalDeclaration = function () {
	        var previousIndex = this.scanner.index;
	        var previousLineNumber = this.scanner.lineNumber;
	        var previousLineStart = this.scanner.lineStart;
	        this.collectComments();
	        var next = this.scanner.lex();
	        this.scanner.index = previousIndex;
	        this.scanner.lineNumber = previousLineNumber;
	        this.scanner.lineStart = previousLineStart;
	        return (next.type === token_1.Token.Identifier) ||
	            (next.type === token_1.Token.Punctuator && next.value === '[') ||
	            (next.type === token_1.Token.Punctuator && next.value === '{') ||
	            (next.type === token_1.Token.Keyword && next.value === 'let') ||
	            (next.type === token_1.Token.Keyword && next.value === 'yield');
	    };
	    Parser.prototype.parseLexicalDeclaration = function (options) {
	        var node = this.createNode();
	        var kind = this.nextToken().value;
	        assert_1.assert(kind === 'let' || kind === 'const', 'Lexical declaration must be either let or const');
	        var declarations = this.parseBindingList(kind, options);
	        this.consumeSemicolon();
	        return this.finalize(node, new Node.VariableDeclaration(declarations, kind));
	    };
	    // ECMA-262 13.3.3 Destructuring Binding Patterns
	    Parser.prototype.parseBindingRestElement = function (params, kind) {
	        var node = this.createNode();
	        this.expect('...');
	        var arg = this.parsePattern(params, kind);
	        return this.finalize(node, new Node.RestElement(arg));
	    };
	    Parser.prototype.parseArrayPattern = function (params, kind) {
	        var node = this.createNode();
	        this.expect('[');
	        var elements = [];
	        while (!this.match(']')) {
	            if (this.match(',')) {
	                this.nextToken();
	                elements.push(null);
	            }
	            else {
	                if (this.match('...')) {
	                    elements.push(this.parseBindingRestElement(params, kind));
	                    break;
	                }
	                else {
	                    elements.push(this.parsePatternWithDefault(params, kind));
	                }
	                if (!this.match(']')) {
	                    this.expect(',');
	                }
	            }
	        }
	        this.expect(']');
	        return this.finalize(node, new Node.ArrayPattern(elements));
	    };
	    Parser.prototype.parsePropertyPattern = function (params, kind) {
	        var node = this.createNode();
	        var computed = false;
	        var shorthand = false;
	        var method = false;
	        var key;
	        var value;
	        if (this.lookahead.type === token_1.Token.Identifier) {
	            var keyToken = this.lookahead;
	            key = this.parseVariableIdentifier();
	            var init = this.finalize(node, new Node.Identifier(keyToken.value));
	            if (this.match('=')) {
	                params.push(keyToken);
	                shorthand = true;
	                this.nextToken();
	                var expr = this.parseAssignmentExpression();
	                value = this.finalize(this.startNode(keyToken), new Node.AssignmentPattern(init, expr));
	            }
	            else if (!this.match(':')) {
	                params.push(keyToken);
	                shorthand = true;
	                value = init;
	            }
	            else {
	                this.expect(':');
	                value = this.parsePatternWithDefault(params, kind);
	            }
	        }
	        else {
	            computed = this.match('[');
	            key = this.parseObjectPropertyKey();
	            this.expect(':');
	            value = this.parsePatternWithDefault(params, kind);
	        }
	        return this.finalize(node, new Node.Property('init', key, computed, value, method, shorthand));
	    };
	    Parser.prototype.parseObjectPattern = function (params, kind) {
	        var node = this.createNode();
	        var properties = [];
	        this.expect('{');
	        while (!this.match('}')) {
	            properties.push(this.parsePropertyPattern(params, kind));
	            if (!this.match('}')) {
	                this.expect(',');
	            }
	        }
	        this.expect('}');
	        return this.finalize(node, new Node.ObjectPattern(properties));
	    };
	    Parser.prototype.parsePattern = function (params, kind) {
	        var pattern;
	        if (this.match('[')) {
	            pattern = this.parseArrayPattern(params, kind);
	        }
	        else if (this.match('{')) {
	            pattern = this.parseObjectPattern(params, kind);
	        }
	        else {
	            if (this.matchKeyword('let') && (kind === 'const' || kind === 'let')) {
	                this.tolerateUnexpectedToken(this.lookahead, messages_1.Messages.UnexpectedToken);
	            }
	            params.push(this.lookahead);
	            pattern = this.parseVariableIdentifier(kind);
	        }
	        return pattern;
	    };
	    Parser.prototype.parsePatternWithDefault = function (params, kind) {
	        var startToken = this.lookahead;
	        var pattern = this.parsePattern(params, kind);
	        if (this.match('=')) {
	            this.nextToken();
	            var previousAllowYield = this.context.allowYield;
	            this.context.allowYield = true;
	            var right = this.isolateCoverGrammar(this.parseAssignmentExpression);
	            this.context.allowYield = previousAllowYield;
	            pattern = this.finalize(this.startNode(startToken), new Node.AssignmentPattern(pattern, right));
	        }
	        return pattern;
	    };
	    // ECMA-262 13.3.2 Variable Statement
	    Parser.prototype.parseVariableIdentifier = function (kind) {
	        var node = this.createNode();
	        var token = this.nextToken();
	        if (token.type === token_1.Token.Keyword && token.value === 'yield') {
	            if (this.context.strict) {
	                this.tolerateUnexpectedToken(token, messages_1.Messages.StrictReservedWord);
	            }
	            if (!this.context.allowYield) {
	                this.throwUnexpectedToken(token);
	            }
	        }
	        else if (token.type !== token_1.Token.Identifier) {
	            if (this.context.strict && token.type === token_1.Token.Keyword && this.scanner.isStrictModeReservedWord(token.value)) {
	                this.tolerateUnexpectedToken(token, messages_1.Messages.StrictReservedWord);
	            }
	            else {
	                if (this.context.strict || token.value !== 'let' || kind !== 'var') {
	                    this.throwUnexpectedToken(token);
	                }
	            }
	        }
	        else if (this.sourceType === 'module' && token.type === token_1.Token.Identifier && token.value === 'await') {
	            this.tolerateUnexpectedToken(token);
	        }
	        return this.finalize(node, new Node.Identifier(token.value));
	    };
	    Parser.prototype.parseVariableDeclaration = function (options) {
	        var node = this.createNode();
	        var params = [];
	        var id = this.parsePattern(params, 'var');
	        // ECMA-262 12.2.1
	        if (this.context.strict && id.type === syntax_1.Syntax.Identifier) {
	            if (this.scanner.isRestrictedWord((id).name)) {
	                this.tolerateError(messages_1.Messages.StrictVarName);
	            }
	        }
	        var init = null;
	        if (this.match('=')) {
	            this.nextToken();
	            init = this.isolateCoverGrammar(this.parseAssignmentExpression);
	        }
	        else if (id.type !== syntax_1.Syntax.Identifier && !options.inFor) {
	            this.expect('=');
	        }
	        return this.finalize(node, new Node.VariableDeclarator(id, init));
	    };
	    Parser.prototype.parseVariableDeclarationList = function (options) {
	        var opt = { inFor: options.inFor };
	        var list = [];
	        list.push(this.parseVariableDeclaration(opt));
	        while (this.match(',')) {
	            this.nextToken();
	            list.push(this.parseVariableDeclaration(opt));
	        }
	        return list;
	    };
	    Parser.prototype.parseVariableStatement = function () {
	        var node = this.createNode();
	        this.expectKeyword('var');
	        var declarations = this.parseVariableDeclarationList({ inFor: false });
	        this.consumeSemicolon();
	        return this.finalize(node, new Node.VariableDeclaration(declarations, 'var'));
	    };
	    // ECMA-262 13.4 Empty Statement
	    Parser.prototype.parseEmptyStatement = function () {
	        var node = this.createNode();
	        this.expect(';');
	        return this.finalize(node, new Node.EmptyStatement());
	    };
	    // ECMA-262 13.5 Expression Statement
	    Parser.prototype.parseExpressionStatement = function () {
	        var node = this.createNode();
	        var expr = this.parseExpression();
	        this.consumeSemicolon();
	        return this.finalize(node, new Node.ExpressionStatement(expr));
	    };
	    // ECMA-262 13.6 If statement
	    Parser.prototype.parseIfStatement = function () {
	        var node = this.createNode();
	        var consequent;
	        var alternate = null;
	        this.expectKeyword('if');
	        this.expect('(');
	        var test = this.parseExpression();
	        if (!this.match(')') && this.config.tolerant) {
	            this.tolerateUnexpectedToken(this.nextToken());
	            consequent = this.finalize(this.createNode(), new Node.EmptyStatement());
	        }
	        else {
	            this.expect(')');
	            consequent = this.parseStatement();
	            if (this.matchKeyword('else')) {
	                this.nextToken();
	                alternate = this.parseStatement();
	            }
	        }
	        return this.finalize(node, new Node.IfStatement(test, consequent, alternate));
	    };
	    // ECMA-262 13.7.2 The do-while Statement
	    Parser.prototype.parseDoWhileStatement = function () {
	        var node = this.createNode();
	        this.expectKeyword('do');
	        var previousInIteration = this.context.inIteration;
	        this.context.inIteration = true;
	        var body = this.parseStatement();
	        this.context.inIteration = previousInIteration;
	        this.expectKeyword('while');
	        this.expect('(');
	        var test = this.parseExpression();
	        this.expect(')');
	        if (this.match(';')) {
	            this.nextToken();
	        }
	        return this.finalize(node, new Node.DoWhileStatement(body, test));
	    };
	    // ECMA-262 13.7.3 The while Statement
	    Parser.prototype.parseWhileStatement = function () {
	        var node = this.createNode();
	        var body;
	        this.expectKeyword('while');
	        this.expect('(');
	        var test = this.parseExpression();
	        if (!this.match(')') && this.config.tolerant) {
	            this.tolerateUnexpectedToken(this.nextToken());
	            body = this.finalize(this.createNode(), new Node.EmptyStatement());
	        }
	        else {
	            this.expect(')');
	            var previousInIteration = this.context.inIteration;
	            this.context.inIteration = true;
	            body = this.parseStatement();
	            this.context.inIteration = previousInIteration;
	        }
	        return this.finalize(node, new Node.WhileStatement(test, body));
	    };
	    // ECMA-262 13.7.4 The for Statement
	    // ECMA-262 13.7.5 The for-in and for-of Statements
	    Parser.prototype.parseForStatement = function () {
	        var init = null;
	        var test = null;
	        var update = null;
	        var forIn = true;
	        var left, right;
	        var node = this.createNode();
	        this.expectKeyword('for');
	        this.expect('(');
	        if (this.match(';')) {
	            this.nextToken();
	        }
	        else {
	            if (this.matchKeyword('var')) {
	                init = this.createNode();
	                this.nextToken();
	                var previousAllowIn = this.context.allowIn;
	                this.context.allowIn = false;
	                var declarations = this.parseVariableDeclarationList({ inFor: true });
	                this.context.allowIn = previousAllowIn;
	                if (declarations.length === 1 && this.matchKeyword('in')) {
	                    var decl = declarations[0];
	                    if (decl.init && (decl.id.type === syntax_1.Syntax.ArrayPattern || decl.id.type === syntax_1.Syntax.ObjectPattern || this.context.strict)) {
	                        this.tolerateError(messages_1.Messages.ForInOfLoopInitializer, 'for-in');
	                    }
	                    init = this.finalize(init, new Node.VariableDeclaration(declarations, 'var'));
	                    this.nextToken();
	                    left = init;
	                    right = this.parseExpression();
	                    init = null;
	                }
	                else if (declarations.length === 1 && declarations[0].init === null && this.matchContextualKeyword('of')) {
	                    init = this.finalize(init, new Node.VariableDeclaration(declarations, 'var'));
	                    this.nextToken();
	                    left = init;
	                    right = this.parseAssignmentExpression();
	                    init = null;
	                    forIn = false;
	                }
	                else {
	                    init = this.finalize(init, new Node.VariableDeclaration(declarations, 'var'));
	                    this.expect(';');
	                }
	            }
	            else if (this.matchKeyword('const') || this.matchKeyword('let')) {
	                init = this.createNode();
	                var kind = this.nextToken().value;
	                if (!this.context.strict && this.lookahead.value === 'in') {
	                    init = this.finalize(init, new Node.Identifier(kind));
	                    this.nextToken();
	                    left = init;
	                    right = this.parseExpression();
	                    init = null;
	                }
	                else {
	                    var previousAllowIn = this.context.allowIn;
	                    this.context.allowIn = false;
	                    var declarations = this.parseBindingList(kind, { inFor: true });
	                    this.context.allowIn = previousAllowIn;
	                    if (declarations.length === 1 && declarations[0].init === null && this.matchKeyword('in')) {
	                        init = this.finalize(init, new Node.VariableDeclaration(declarations, kind));
	                        this.nextToken();
	                        left = init;
	                        right = this.parseExpression();
	                        init = null;
	                    }
	                    else if (declarations.length === 1 && declarations[0].init === null && this.matchContextualKeyword('of')) {
	                        init = this.finalize(init, new Node.VariableDeclaration(declarations, kind));
	                        this.nextToken();
	                        left = init;
	                        right = this.parseAssignmentExpression();
	                        init = null;
	                        forIn = false;
	                    }
	                    else {
	                        this.consumeSemicolon();
	                        init = this.finalize(init, new Node.VariableDeclaration(declarations, kind));
	                    }
	                }
	            }
	            else {
	                var initStartToken = this.lookahead;
	                var previousAllowIn = this.context.allowIn;
	                this.context.allowIn = false;
	                init = this.inheritCoverGrammar(this.parseAssignmentExpression);
	                this.context.allowIn = previousAllowIn;
	                if (this.matchKeyword('in')) {
	                    if (!this.context.isAssignmentTarget || init.type === syntax_1.Syntax.AssignmentExpression) {
	                        this.tolerateError(messages_1.Messages.InvalidLHSInForIn);
	                    }
	                    this.nextToken();
	                    this.reinterpretExpressionAsPattern(init);
	                    left = init;
	                    right = this.parseExpression();
	                    init = null;
	                }
	                else if (this.matchContextualKeyword('of')) {
	                    if (!this.context.isAssignmentTarget || init.type === syntax_1.Syntax.AssignmentExpression) {
	                        this.tolerateError(messages_1.Messages.InvalidLHSInForLoop);
	                    }
	                    this.nextToken();
	                    this.reinterpretExpressionAsPattern(init);
	                    left = init;
	                    right = this.parseAssignmentExpression();
	                    init = null;
	                    forIn = false;
	                }
	                else {
	                    if (this.match(',')) {
	                        var initSeq = [init];
	                        while (this.match(',')) {
	                            this.nextToken();
	                            initSeq.push(this.isolateCoverGrammar(this.parseAssignmentExpression));
	                        }
	                        init = this.finalize(this.startNode(initStartToken), new Node.SequenceExpression(initSeq));
	                    }
	                    this.expect(';');
	                }
	            }
	        }
	        if (typeof left === 'undefined') {
	            if (!this.match(';')) {
	                test = this.parseExpression();
	            }
	            this.expect(';');
	            if (!this.match(')')) {
	                update = this.parseExpression();
	            }
	        }
	        var body;
	        if (!this.match(')') && this.config.tolerant) {
	            this.tolerateUnexpectedToken(this.nextToken());
	            body = this.finalize(this.createNode(), new Node.EmptyStatement());
	        }
	        else {
	            this.expect(')');
	            var previousInIteration = this.context.inIteration;
	            this.context.inIteration = true;
	            body = this.isolateCoverGrammar(this.parseStatement);
	            this.context.inIteration = previousInIteration;
	        }
	        return (typeof left === 'undefined') ?
	            this.finalize(node, new Node.ForStatement(init, test, update, body)) :
	            forIn ? this.finalize(node, new Node.ForInStatement(left, right, body)) :
	                this.finalize(node, new Node.ForOfStatement(left, right, body));
	    };
	    // ECMA-262 13.8 The continue statement
	    Parser.prototype.parseContinueStatement = function () {
	        var node = this.createNode();
	        this.expectKeyword('continue');
	        var label = null;
	        if (this.lookahead.type === token_1.Token.Identifier && !this.hasLineTerminator) {
	            label = this.parseVariableIdentifier();
	            var key = '$' + label.name;
	            if (!Object.prototype.hasOwnProperty.call(this.context.labelSet, key)) {
	                this.throwError(messages_1.Messages.UnknownLabel, label.name);
	            }
	        }
	        this.consumeSemicolon();
	        if (label === null && !this.context.inIteration) {
	            this.throwError(messages_1.Messages.IllegalContinue);
	        }
	        return this.finalize(node, new Node.ContinueStatement(label));
	    };
	    // ECMA-262 13.9 The break statement
	    Parser.prototype.parseBreakStatement = function () {
	        var node = this.createNode();
	        this.expectKeyword('break');
	        var label = null;
	        if (this.lookahead.type === token_1.Token.Identifier && !this.hasLineTerminator) {
	            label = this.parseVariableIdentifier();
	            var key = '$' + label.name;
	            if (!Object.prototype.hasOwnProperty.call(this.context.labelSet, key)) {
	                this.throwError(messages_1.Messages.UnknownLabel, label.name);
	            }
	        }
	        this.consumeSemicolon();
	        if (label === null && !this.context.inIteration && !this.context.inSwitch) {
	            this.throwError(messages_1.Messages.IllegalBreak);
	        }
	        return this.finalize(node, new Node.BreakStatement(label));
	    };
	    // ECMA-262 13.10 The return statement
	    Parser.prototype.parseReturnStatement = function () {
	        if (!this.context.inFunctionBody) {
	            this.tolerateError(messages_1.Messages.IllegalReturn);
	        }
	        var node = this.createNode();
	        this.expectKeyword('return');
	        var hasArgument = !this.match(';') && !this.match('}') &&
	            !this.hasLineTerminator && this.lookahead.type !== token_1.Token.EOF;
	        var argument = hasArgument ? this.parseExpression() : null;
	        this.consumeSemicolon();
	        return this.finalize(node, new Node.ReturnStatement(argument));
	    };
	    // ECMA-262 13.11 The with statement
	    Parser.prototype.parseWithStatement = function () {
	        if (this.context.strict) {
	            this.tolerateError(messages_1.Messages.StrictModeWith);
	        }
	        var node = this.createNode();
	        this.expectKeyword('with');
	        this.expect('(');
	        var object = this.parseExpression();
	        this.expect(')');
	        var body = this.parseStatement();
	        return this.finalize(node, new Node.WithStatement(object, body));
	    };
	    // ECMA-262 13.12 The switch statement
	    Parser.prototype.parseSwitchCase = function () {
	        var node = this.createNode();
	        var test;
	        if (this.matchKeyword('default')) {
	            this.nextToken();
	            test = null;
	        }
	        else {
	            this.expectKeyword('case');
	            test = this.parseExpression();
	        }
	        this.expect(':');
	        var consequent = [];
	        while (true) {
	            if (this.match('}') || this.matchKeyword('default') || this.matchKeyword('case')) {
	                break;
	            }
	            consequent.push(this.parseStatementListItem());
	        }
	        return this.finalize(node, new Node.SwitchCase(test, consequent));
	    };
	    Parser.prototype.parseSwitchStatement = function () {
	        var node = this.createNode();
	        this.expectKeyword('switch');
	        this.expect('(');
	        var discriminant = this.parseExpression();
	        this.expect(')');
	        var previousInSwitch = this.context.inSwitch;
	        this.context.inSwitch = true;
	        var cases = [];
	        var defaultFound = false;
	        this.expect('{');
	        while (true) {
	            if (this.match('}')) {
	                break;
	            }
	            var clause = this.parseSwitchCase();
	            if (clause.test === null) {
	                if (defaultFound) {
	                    this.throwError(messages_1.Messages.MultipleDefaultsInSwitch);
	                }
	                defaultFound = true;
	            }
	            cases.push(clause);
	        }
	        this.expect('}');
	        this.context.inSwitch = previousInSwitch;
	        return this.finalize(node, new Node.SwitchStatement(discriminant, cases));
	    };
	    // ECMA-262 13.13 Labelled Statements
	    Parser.prototype.parseLabelledStatement = function () {
	        var node = this.createNode();
	        var expr = this.parseExpression();
	        var statement;
	        if ((expr.type === syntax_1.Syntax.Identifier) && this.match(':')) {
	            this.nextToken();
	            var id = (expr);
	            var key = '$' + id.name;
	            if (Object.prototype.hasOwnProperty.call(this.context.labelSet, key)) {
	                this.throwError(messages_1.Messages.Redeclaration, 'Label', id.name);
	            }
	            this.context.labelSet[key] = true;
	            var labeledBody = this.parseStatement();
	            delete this.context.labelSet[key];
	            statement = new Node.LabeledStatement(id, labeledBody);
	        }
	        else {
	            this.consumeSemicolon();
	            statement = new Node.ExpressionStatement(expr);
	        }
	        return this.finalize(node, statement);
	    };
	    // ECMA-262 13.14 The throw statement
	    Parser.prototype.parseThrowStatement = function () {
	        var node = this.createNode();
	        this.expectKeyword('throw');
	        if (this.hasLineTerminator) {
	            this.throwError(messages_1.Messages.NewlineAfterThrow);
	        }
	        var argument = this.parseExpression();
	        this.consumeSemicolon();
	        return this.finalize(node, new Node.ThrowStatement(argument));
	    };
	    // ECMA-262 13.15 The try statement
	    Parser.prototype.parseCatchClause = function () {
	        var node = this.createNode();
	        this.expectKeyword('catch');
	        this.expect('(');
	        if (this.match(')')) {
	            this.throwUnexpectedToken(this.lookahead);
	        }
	        var params = [];
	        var param = this.parsePattern(params);
	        var paramMap = {};
	        for (var i = 0; i < params.length; i++) {
	            var key = '$' + params[i].value;
	            if (Object.prototype.hasOwnProperty.call(paramMap, key)) {
	                this.tolerateError(messages_1.Messages.DuplicateBinding, params[i].value);
	            }
	            paramMap[key] = true;
	        }
	        if (this.context.strict && param.type === syntax_1.Syntax.Identifier) {
	            if (this.scanner.isRestrictedWord((param).name)) {
	                this.tolerateError(messages_1.Messages.StrictCatchVariable);
	            }
	        }
	        this.expect(')');
	        var body = this.parseBlock();
	        return this.finalize(node, new Node.CatchClause(param, body));
	    };
	    Parser.prototype.parseFinallyClause = function () {
	        this.expectKeyword('finally');
	        return this.parseBlock();
	    };
	    Parser.prototype.parseTryStatement = function () {
	        var node = this.createNode();
	        this.expectKeyword('try');
	        var block = this.parseBlock();
	        var handler = this.matchKeyword('catch') ? this.parseCatchClause() : null;
	        var finalizer = this.matchKeyword('finally') ? this.parseFinallyClause() : null;
	        if (!handler && !finalizer) {
	            this.throwError(messages_1.Messages.NoCatchOrFinally);
	        }
	        return this.finalize(node, new Node.TryStatement(block, handler, finalizer));
	    };
	    // ECMA-262 13.16 The debugger statement
	    Parser.prototype.parseDebuggerStatement = function () {
	        var node = this.createNode();
	        this.expectKeyword('debugger');
	        this.consumeSemicolon();
	        return this.finalize(node, new Node.DebuggerStatement());
	    };
	    // ECMA-262 13 Statements
	    Parser.prototype.parseStatement = function () {
	        var statement = null;
	        switch (this.lookahead.type) {
	            case token_1.Token.BooleanLiteral:
	            case token_1.Token.NullLiteral:
	            case token_1.Token.NumericLiteral:
	            case token_1.Token.StringLiteral:
	            case token_1.Token.Template:
	            case token_1.Token.RegularExpression:
	                statement = this.parseExpressionStatement();
	                break;
	            case token_1.Token.Punctuator:
	                var value = this.lookahead.value;
	                if (value === '{') {
	                    statement = this.parseBlock();
	                }
	                else if (value === '(') {
	                    statement = this.parseExpressionStatement();
	                }
	                else if (value === ';') {
	                    statement = this.parseEmptyStatement();
	                }
	                else {
	                    statement = this.parseExpressionStatement();
	                }
	                break;
	            case token_1.Token.Identifier:
	                statement = this.parseLabelledStatement();
	                break;
	            case token_1.Token.Keyword:
	                switch (this.lookahead.value) {
	                    case 'break':
	                        statement = this.parseBreakStatement();
	                        break;
	                    case 'continue':
	                        statement = this.parseContinueStatement();
	                        break;
	                    case 'debugger':
	                        statement = this.parseDebuggerStatement();
	                        break;
	                    case 'do':
	                        statement = this.parseDoWhileStatement();
	                        break;
	                    case 'for':
	                        statement = this.parseForStatement();
	                        break;
	                    case 'function':
	                        statement = this.parseFunctionDeclaration();
	                        break;
	                    case 'if':
	                        statement = this.parseIfStatement();
	                        break;
	                    case 'return':
	                        statement = this.parseReturnStatement();
	                        break;
	                    case 'switch':
	                        statement = this.parseSwitchStatement();
	                        break;
	                    case 'throw':
	                        statement = this.parseThrowStatement();
	                        break;
	                    case 'try':
	                        statement = this.parseTryStatement();
	                        break;
	                    case 'var':
	                        statement = this.parseVariableStatement();
	                        break;
	                    case 'while':
	                        statement = this.parseWhileStatement();
	                        break;
	                    case 'with':
	                        statement = this.parseWithStatement();
	                        break;
	                    default:
	                        statement = this.parseExpressionStatement();
	                        break;
	                }
	                break;
	            default:
	                this.throwUnexpectedToken(this.lookahead);
	        }
	        return statement;
	    };
	    // ECMA-262 14.1 Function Definition
	    Parser.prototype.parseFunctionSourceElements = function () {
	        var node = this.createNode();
	        this.expect('{');
	        var body = this.parseDirectivePrologues();
	        var previousLabelSet = this.context.labelSet;
	        var previousInIteration = this.context.inIteration;
	        var previousInSwitch = this.context.inSwitch;
	        var previousInFunctionBody = this.context.inFunctionBody;
	        this.context.labelSet = {};
	        this.context.inIteration = false;
	        this.context.inSwitch = false;
	        this.context.inFunctionBody = true;
	        while (this.startMarker.index < this.scanner.length) {
	            if (this.match('}')) {
	                break;
	            }
	            body.push(this.parseStatementListItem());
	        }
	        this.expect('}');
	        this.context.labelSet = previousLabelSet;
	        this.context.inIteration = previousInIteration;
	        this.context.inSwitch = previousInSwitch;
	        this.context.inFunctionBody = previousInFunctionBody;
	        return this.finalize(node, new Node.BlockStatement(body));
	    };
	    Parser.prototype.validateParam = function (options, param, name) {
	        var key = '$' + name;
	        if (this.context.strict) {
	            if (this.scanner.isRestrictedWord(name)) {
	                options.stricted = param;
	                options.message = messages_1.Messages.StrictParamName;
	            }
	            if (Object.prototype.hasOwnProperty.call(options.paramSet, key)) {
	                options.stricted = param;
	                options.message = messages_1.Messages.StrictParamDupe;
	            }
	        }
	        else if (!options.firstRestricted) {
	            if (this.scanner.isRestrictedWord(name)) {
	                options.firstRestricted = param;
	                options.message = messages_1.Messages.StrictParamName;
	            }
	            else if (this.scanner.isStrictModeReservedWord(name)) {
	                options.firstRestricted = param;
	                options.message = messages_1.Messages.StrictReservedWord;
	            }
	            else if (Object.prototype.hasOwnProperty.call(options.paramSet, key)) {
	                options.stricted = param;
	                options.message = messages_1.Messages.StrictParamDupe;
	            }
	        }
	        /* istanbul ignore next */
	        if (typeof Object.defineProperty === 'function') {
	            Object.defineProperty(options.paramSet, key, { value: true, enumerable: true, writable: true, configurable: true });
	        }
	        else {
	            options.paramSet[key] = true;
	        }
	    };
	    Parser.prototype.parseRestElement = function (params) {
	        var node = this.createNode();
	        this.expect('...');
	        var arg = this.parsePattern(params);
	        if (this.match('=')) {
	            this.throwError(messages_1.Messages.DefaultRestParameter);
	        }
	        if (!this.match(')')) {
	            this.throwError(messages_1.Messages.ParameterAfterRestParameter);
	        }
	        return this.finalize(node, new Node.RestElement(arg));
	    };
	    Parser.prototype.parseFormalParameter = function (options) {
	        var params = [];
	        var param = this.match('...') ? this.parseRestElement(params) : this.parsePatternWithDefault(params);
	        for (var i = 0; i < params.length; i++) {
	            this.validateParam(options, params[i], params[i].value);
	        }
	        options.params.push(param);
	        return !this.match(')');
	    };
	    Parser.prototype.parseFormalParameters = function (firstRestricted) {
	        var options;
	        options = {
	            params: [],
	            firstRestricted: firstRestricted
	        };
	        this.expect('(');
	        if (!this.match(')')) {
	            options.paramSet = {};
	            while (this.startMarker.index < this.scanner.length) {
	                if (!this.parseFormalParameter(options)) {
	                    break;
	                }
	                this.expect(',');
	            }
	        }
	        this.expect(')');
	        return {
	            params: options.params,
	            stricted: options.stricted,
	            firstRestricted: options.firstRestricted,
	            message: options.message
	        };
	    };
	    Parser.prototype.parseFunctionDeclaration = function (identifierIsOptional) {
	        var node = this.createNode();
	        this.expectKeyword('function');
	        var isGenerator = this.match('*');
	        if (isGenerator) {
	            this.nextToken();
	        }
	        var message;
	        var id = null;
	        var firstRestricted = null;
	        if (!identifierIsOptional || !this.match('(')) {
	            var token = this.lookahead;
	            id = this.parseVariableIdentifier();
	            if (this.context.strict) {
	                if (this.scanner.isRestrictedWord(token.value)) {
	                    this.tolerateUnexpectedToken(token, messages_1.Messages.StrictFunctionName);
	                }
	            }
	            else {
	                if (this.scanner.isRestrictedWord(token.value)) {
	                    firstRestricted = token;
	                    message = messages_1.Messages.StrictFunctionName;
	                }
	                else if (this.scanner.isStrictModeReservedWord(token.value)) {
	                    firstRestricted = token;
	                    message = messages_1.Messages.StrictReservedWord;
	                }
	            }
	        }
	        var previousAllowYield = this.context.allowYield;
	        this.context.allowYield = !isGenerator;
	        var formalParameters = this.parseFormalParameters(firstRestricted);
	        var params = formalParameters.params;
	        var stricted = formalParameters.stricted;
	        firstRestricted = formalParameters.firstRestricted;
	        if (formalParameters.message) {
	            message = formalParameters.message;
	        }
	        var previousStrict = this.context.strict;
	        var body = this.parseFunctionSourceElements();
	        if (this.context.strict && firstRestricted) {
	            this.throwUnexpectedToken(firstRestricted, message);
	        }
	        if (this.context.strict && stricted) {
	            this.tolerateUnexpectedToken(stricted, message);
	        }
	        this.context.strict = previousStrict;
	        this.context.allowYield = previousAllowYield;
	        return this.finalize(node, new Node.FunctionDeclaration(id, params, body, isGenerator));
	    };
	    Parser.prototype.parseFunctionExpression = function () {
	        var node = this.createNode();
	        this.expectKeyword('function');
	        var isGenerator = this.match('*');
	        if (isGenerator) {
	            this.nextToken();
	        }
	        var message;
	        var id = null;
	        var firstRestricted;
	        var previousAllowYield = this.context.allowYield;
	        this.context.allowYield = !isGenerator;
	        if (!this.match('(')) {
	            var token = this.lookahead;
	            id = (!this.context.strict && !isGenerator && this.matchKeyword('yield')) ? this.parseIdentifierName() : this.parseVariableIdentifier();
	            if (this.context.strict) {
	                if (this.scanner.isRestrictedWord(token.value)) {
	                    this.tolerateUnexpectedToken(token, messages_1.Messages.StrictFunctionName);
	                }
	            }
	            else {
	                if (this.scanner.isRestrictedWord(token.value)) {
	                    firstRestricted = token;
	                    message = messages_1.Messages.StrictFunctionName;
	                }
	                else if (this.scanner.isStrictModeReservedWord(token.value)) {
	                    firstRestricted = token;
	                    message = messages_1.Messages.StrictReservedWord;
	                }
	            }
	        }
	        var formalParameters = this.parseFormalParameters(firstRestricted);
	        var params = formalParameters.params;
	        var stricted = formalParameters.stricted;
	        firstRestricted = formalParameters.firstRestricted;
	        if (formalParameters.message) {
	            message = formalParameters.message;
	        }
	        var previousStrict = this.context.strict;
	        var body = this.parseFunctionSourceElements();
	        if (this.context.strict && firstRestricted) {
	            this.throwUnexpectedToken(firstRestricted, message);
	        }
	        if (this.context.strict && stricted) {
	            this.tolerateUnexpectedToken(stricted, message);
	        }
	        this.context.strict = previousStrict;
	        this.context.allowYield = previousAllowYield;
	        return this.finalize(node, new Node.FunctionExpression(id, params, body, isGenerator));
	    };
	    // ECMA-262 14.1.1 Directive Prologues
	    Parser.prototype.parseDirective = function () {
	        var token = this.lookahead;
	        var directive = null;
	        var node = this.createNode();
	        var expr = this.parseExpression();
	        if (expr.type === syntax_1.Syntax.Literal) {
	            directive = this.getTokenRaw(token).slice(1, -1);
	        }
	        this.consumeSemicolon();
	        return this.finalize(node, directive ? new Node.Directive(expr, directive) :
	            new Node.ExpressionStatement(expr));
	    };
	    Parser.prototype.parseDirectivePrologues = function () {
	        var firstRestricted = null;
	        var body = [];
	        while (true) {
	            var token = this.lookahead;
	            if (token.type !== token_1.Token.StringLiteral) {
	                break;
	            }
	            var statement = this.parseDirective();
	            body.push(statement);
	            var directive = statement.directive;
	            if (typeof directive !== 'string') {
	                break;
	            }
	            if (directive === 'use strict') {
	                this.context.strict = true;
	                if (firstRestricted) {
	                    this.tolerateUnexpectedToken(firstRestricted, messages_1.Messages.StrictOctalLiteral);
	                }
	            }
	            else {
	                if (!firstRestricted && token.octal) {
	                    firstRestricted = token;
	                }
	            }
	        }
	        return body;
	    };
	    // ECMA-262 14.3 Method Definitions
	    Parser.prototype.qualifiedPropertyName = function (token) {
	        switch (token.type) {
	            case token_1.Token.Identifier:
	            case token_1.Token.StringLiteral:
	            case token_1.Token.BooleanLiteral:
	            case token_1.Token.NullLiteral:
	            case token_1.Token.NumericLiteral:
	            case token_1.Token.Keyword:
	                return true;
	            case token_1.Token.Punctuator:
	                return token.value === '[';
	        }
	        return false;
	    };
	    Parser.prototype.parseGetterMethod = function () {
	        var node = this.createNode();
	        this.expect('(');
	        this.expect(')');
	        var isGenerator = false;
	        var params = {
	            params: [],
	            stricted: null,
	            firstRestricted: null,
	            message: null
	        };
	        var previousAllowYield = this.context.allowYield;
	        this.context.allowYield = false;
	        var method = this.parsePropertyMethod(params);
	        this.context.allowYield = previousAllowYield;
	        return this.finalize(node, new Node.FunctionExpression(null, params.params, method, isGenerator));
	    };
	    Parser.prototype.parseSetterMethod = function () {
	        var node = this.createNode();
	        var options = {
	            params: [],
	            firstRestricted: null,
	            paramSet: {}
	        };
	        var isGenerator = false;
	        var previousAllowYield = this.context.allowYield;
	        this.context.allowYield = false;
	        this.expect('(');
	        if (this.match(')')) {
	            this.tolerateUnexpectedToken(this.lookahead);
	        }
	        else {
	            this.parseFormalParameter(options);
	        }
	        this.expect(')');
	        var method = this.parsePropertyMethod(options);
	        this.context.allowYield = previousAllowYield;
	        return this.finalize(node, new Node.FunctionExpression(null, options.params, method, isGenerator));
	    };
	    Parser.prototype.parseGeneratorMethod = function () {
	        var node = this.createNode();
	        var isGenerator = true;
	        var previousAllowYield = this.context.allowYield;
	        this.context.allowYield = true;
	        var params = this.parseFormalParameters();
	        this.context.allowYield = false;
	        var method = this.parsePropertyMethod(params);
	        this.context.allowYield = previousAllowYield;
	        return this.finalize(node, new Node.FunctionExpression(null, params.params, method, isGenerator));
	    };
	    // ECMA-262 14.4 Generator Function Definitions
	    Parser.prototype.isStartOfExpression = function () {
	        var start = true;
	        var value = this.lookahead.value;
	        switch (this.lookahead.type) {
	            case token_1.Token.Punctuator:
	                start = (value === '[') || (value === '(') || (value === '{') ||
	                    (value === '+') || (value === '-') ||
	                    (value === '!') || (value === '~') ||
	                    (value === '++') || (value === '--') ||
	                    (value === '/') || (value === '/='); // regular expression literal
	                break;
	            case token_1.Token.Keyword:
	                start = (value === 'class') || (value === 'delete') ||
	                    (value === 'function') || (value === 'let') || (value === 'new') ||
	                    (value === 'super') || (value === 'this') || (value === 'typeof') ||
	                    (value === 'void') || (value === 'yield');
	                break;
	            default:
	                break;
	        }
	        return start;
	    };
	    Parser.prototype.parseYieldExpression = function () {
	        var node = this.createNode();
	        this.expectKeyword('yield');
	        var argument = null;
	        var delegate = false;
	        if (!this.hasLineTerminator) {
	            var previousAllowYield = this.context.allowYield;
	            this.context.allowYield = false;
	            delegate = this.match('*');
	            if (delegate) {
	                this.nextToken();
	                argument = this.parseAssignmentExpression();
	            }
	            else if (this.isStartOfExpression()) {
	                argument = this.parseAssignmentExpression();
	            }
	            this.context.allowYield = previousAllowYield;
	        }
	        return this.finalize(node, new Node.YieldExpression(argument, delegate));
	    };
	    // ECMA-262 14.5 Class Definitions
	    Parser.prototype.parseClassElement = function (hasConstructor) {
	        var token = this.lookahead;
	        var node = this.createNode();
	        var kind;
	        var key;
	        var value;
	        var computed = false;
	        var method = false;
	        var isStatic = false;
	        if (this.match('*')) {
	            this.nextToken();
	        }
	        else {
	            computed = this.match('[');
	            key = this.parseObjectPropertyKey();
	            var id = key;
	            if (id.name === 'static' && (this.qualifiedPropertyName(this.lookahead) || this.match('*'))) {
	                token = this.lookahead;
	                isStatic = true;
	                computed = this.match('[');
	                if (this.match('*')) {
	                    this.nextToken();
	                }
	                else {
	                    key = this.parseObjectPropertyKey();
	                }
	            }
	        }
	        var lookaheadPropertyKey = this.qualifiedPropertyName(this.lookahead);
	        if (token.type === token_1.Token.Identifier) {
	            if (token.value === 'get' && lookaheadPropertyKey) {
	                kind = 'get';
	                computed = this.match('[');
	                key = this.parseObjectPropertyKey();
	                this.context.allowYield = false;
	                value = this.parseGetterMethod();
	            }
	            else if (token.value === 'set' && lookaheadPropertyKey) {
	                kind = 'set';
	                computed = this.match('[');
	                key = this.parseObjectPropertyKey();
	                value = this.parseSetterMethod();
	            }
	        }
	        else if (token.type === token_1.Token.Punctuator && token.value === '*' && lookaheadPropertyKey) {
	            kind = 'init';
	            computed = this.match('[');
	            key = this.parseObjectPropertyKey();
	            value = this.parseGeneratorMethod();
	            method = true;
	        }
	        if (!kind && key && this.match('(')) {
	            kind = 'init';
	            value = this.parsePropertyMethodFunction();
	            method = true;
	        }
	        if (!kind) {
	            this.throwUnexpectedToken(this.lookahead);
	        }
	        if (kind === 'init') {
	            kind = 'method';
	        }
	        if (!computed) {
	            if (isStatic && this.isPropertyKey(key, 'prototype')) {
	                this.throwUnexpectedToken(token, messages_1.Messages.StaticPrototype);
	            }
	            if (!isStatic && this.isPropertyKey(key, 'constructor')) {
	                if (kind !== 'method' || !method || value.generator) {
	                    this.throwUnexpectedToken(token, messages_1.Messages.ConstructorSpecialMethod);
	                }
	                if (hasConstructor.value) {
	                    this.throwUnexpectedToken(token, messages_1.Messages.DuplicateConstructor);
	                }
	                else {
	                    hasConstructor.value = true;
	                }
	                kind = 'constructor';
	            }
	        }
	        return this.finalize(node, new Node.MethodDefinition(key, computed, value, kind, isStatic));
	    };
	    Parser.prototype.parseClassElementList = function () {
	        var body = [];
	        var hasConstructor = { value: false };
	        this.expect('{');
	        while (!this.match('}')) {
	            if (this.match(';')) {
	                this.nextToken();
	            }
	            else {
	                body.push(this.parseClassElement(hasConstructor));
	            }
	        }
	        this.expect('}');
	        return body;
	    };
	    Parser.prototype.parseClassBody = function () {
	        var node = this.createNode();
	        var elementList = this.parseClassElementList();
	        return this.finalize(node, new Node.ClassBody(elementList));
	    };
	    Parser.prototype.parseClassDeclaration = function (identifierIsOptional) {
	        var node = this.createNode();
	        var previousStrict = this.context.strict;
	        this.context.strict = true;
	        this.expectKeyword('class');
	        var id = (identifierIsOptional && (this.lookahead.type !== token_1.Token.Identifier)) ? null : this.parseVariableIdentifier();
	        var superClass = null;
	        if (this.matchKeyword('extends')) {
	            this.nextToken();
	            superClass = this.isolateCoverGrammar(this.parseLeftHandSideExpressionAllowCall);
	        }
	        var classBody = this.parseClassBody();
	        this.context.strict = previousStrict;
	        return this.finalize(node, new Node.ClassDeclaration(id, superClass, classBody));
	    };
	    Parser.prototype.parseClassExpression = function () {
	        var node = this.createNode();
	        var previousStrict = this.context.strict;
	        this.context.strict = true;
	        this.expectKeyword('class');
	        var id = (this.lookahead.type === token_1.Token.Identifier) ? this.parseVariableIdentifier() : null;
	        var superClass = null;
	        if (this.matchKeyword('extends')) {
	            this.nextToken();
	            superClass = this.isolateCoverGrammar(this.parseLeftHandSideExpressionAllowCall);
	        }
	        var classBody = this.parseClassBody();
	        this.context.strict = previousStrict;
	        return this.finalize(node, new Node.ClassExpression(id, superClass, classBody));
	    };
	    // ECMA-262 15.1 Scripts
	    // ECMA-262 15.2 Modules
	    Parser.prototype.parseProgram = function () {
	        var node = this.createNode();
	        var body = this.parseDirectivePrologues();
	        while (this.startMarker.index < this.scanner.length) {
	            body.push(this.parseStatementListItem());
	        }
	        return this.finalize(node, new Node.Program(body, this.sourceType));
	    };
	    // ECMA-262 15.2.2 Imports
	    Parser.prototype.parseModuleSpecifier = function () {
	        var node = this.createNode();
	        if (this.lookahead.type !== token_1.Token.StringLiteral) {
	            this.throwError(messages_1.Messages.InvalidModuleSpecifier);
	        }
	        var token = this.nextToken();
	        var raw = this.getTokenRaw(token);
	        return this.finalize(node, new Node.Literal(token.value, raw));
	    };
	    // import {<foo as bar>} ...;
	    Parser.prototype.parseImportSpecifier = function () {
	        var node = this.createNode();
	        var imported;
	        var local;
	        if (this.lookahead.type === token_1.Token.Identifier) {
	            imported = this.parseVariableIdentifier();
	            local = imported;
	            if (this.matchContextualKeyword('as')) {
	                this.nextToken();
	                local = this.parseVariableIdentifier();
	            }
	        }
	        else {
	            imported = this.parseIdentifierName();
	            local = imported;
	            if (this.matchContextualKeyword('as')) {
	                this.nextToken();
	                local = this.parseVariableIdentifier();
	            }
	            else {
	                this.throwUnexpectedToken(this.nextToken());
	            }
	        }
	        return this.finalize(node, new Node.ImportSpecifier(local, imported));
	    };
	    // {foo, bar as bas}
	    Parser.prototype.parseNamedImports = function () {
	        this.expect('{');
	        var specifiers = [];
	        while (!this.match('}')) {
	            specifiers.push(this.parseImportSpecifier());
	            if (!this.match('}')) {
	                this.expect(',');
	            }
	        }
	        this.expect('}');
	        return specifiers;
	    };
	    // import <foo> ...;
	    Parser.prototype.parseImportDefaultSpecifier = function () {
	        var node = this.createNode();
	        var local = this.parseIdentifierName();
	        return this.finalize(node, new Node.ImportDefaultSpecifier(local));
	    };
	    // import <* as foo> ...;
	    Parser.prototype.parseImportNamespaceSpecifier = function () {
	        var node = this.createNode();
	        this.expect('*');
	        if (!this.matchContextualKeyword('as')) {
	            this.throwError(messages_1.Messages.NoAsAfterImportNamespace);
	        }
	        this.nextToken();
	        var local = this.parseIdentifierName();
	        return this.finalize(node, new Node.ImportNamespaceSpecifier(local));
	    };
	    Parser.prototype.parseImportDeclaration = function () {
	        if (this.context.inFunctionBody) {
	            this.throwError(messages_1.Messages.IllegalImportDeclaration);
	        }
	        var node = this.createNode();
	        this.expectKeyword('import');
	        var src;
	        var specifiers = [];
	        if (this.lookahead.type === token_1.Token.StringLiteral) {
	            // import 'foo';
	            src = this.parseModuleSpecifier();
	        }
	        else {
	            if (this.match('{')) {
	                // import {bar}
	                specifiers = specifiers.concat(this.parseNamedImports());
	            }
	            else if (this.match('*')) {
	                // import * as foo
	                specifiers.push(this.parseImportNamespaceSpecifier());
	            }
	            else if (this.isIdentifierName(this.lookahead) && !this.matchKeyword('default')) {
	                // import foo
	                specifiers.push(this.parseImportDefaultSpecifier());
	                if (this.match(',')) {
	                    this.nextToken();
	                    if (this.match('*')) {
	                        // import foo, * as foo
	                        specifiers.push(this.parseImportNamespaceSpecifier());
	                    }
	                    else if (this.match('{')) {
	                        // import foo, {bar}
	                        specifiers = specifiers.concat(this.parseNamedImports());
	                    }
	                    else {
	                        this.throwUnexpectedToken(this.lookahead);
	                    }
	                }
	            }
	            else {
	                this.throwUnexpectedToken(this.nextToken());
	            }
	            if (!this.matchContextualKeyword('from')) {
	                var message = this.lookahead.value ? messages_1.Messages.UnexpectedToken : messages_1.Messages.MissingFromClause;
	                this.throwError(message, this.lookahead.value);
	            }
	            this.nextToken();
	            src = this.parseModuleSpecifier();
	        }
	        this.consumeSemicolon();
	        return this.finalize(node, new Node.ImportDeclaration(specifiers, src));
	    };
	    // ECMA-262 15.2.3 Exports
	    Parser.prototype.parseExportSpecifier = function () {
	        var node = this.createNode();
	        var local = this.parseIdentifierName();
	        var exported = local;
	        if (this.matchContextualKeyword('as')) {
	            this.nextToken();
	            exported = this.parseIdentifierName();
	        }
	        return this.finalize(node, new Node.ExportSpecifier(local, exported));
	    };
	    Parser.prototype.parseExportDeclaration = function () {
	        if (this.context.inFunctionBody) {
	            this.throwError(messages_1.Messages.IllegalExportDeclaration);
	        }
	        var node = this.createNode();
	        this.expectKeyword('export');
	        var exportDeclaration;
	        if (this.matchKeyword('default')) {
	            // export default ...
	            this.nextToken();
	            if (this.matchKeyword('function')) {
	                // export default function foo () {}
	                // export default function () {}
	                var declaration = this.parseFunctionDeclaration(true);
	                exportDeclaration = this.finalize(node, new Node.ExportDefaultDeclaration(declaration));
	            }
	            else if (this.matchKeyword('class')) {
	                // export default class foo {}
	                var declaration = this.parseClassDeclaration(true);
	                exportDeclaration = this.finalize(node, new Node.ExportDefaultDeclaration(declaration));
	            }
	            else {
	                if (this.matchContextualKeyword('from')) {
	                    this.throwError(messages_1.Messages.UnexpectedToken, this.lookahead.value);
	                }
	                // export default {};
	                // export default [];
	                // export default (1 + 2);
	                var declaration = this.match('{') ? this.parseObjectInitializer() :
	                    this.match('[') ? this.parseArrayInitializer() : this.parseAssignmentExpression();
	                this.consumeSemicolon();
	                exportDeclaration = this.finalize(node, new Node.ExportDefaultDeclaration(declaration));
	            }
	        }
	        else if (this.match('*')) {
	            // export * from 'foo';
	            this.nextToken();
	            if (!this.matchContextualKeyword('from')) {
	                var message = this.lookahead.value ? messages_1.Messages.UnexpectedToken : messages_1.Messages.MissingFromClause;
	                this.throwError(message, this.lookahead.value);
	            }
	            this.nextToken();
	            var src = this.parseModuleSpecifier();
	            this.consumeSemicolon();
	            exportDeclaration = this.finalize(node, new Node.ExportAllDeclaration(src));
	        }
	        else if (this.lookahead.type === token_1.Token.Keyword) {
	            // export var f = 1;
	            var declaration = void 0;
	            switch (this.lookahead.value) {
	                case 'let':
	                case 'const':
	                    declaration = this.parseLexicalDeclaration({ inFor: false });
	                    break;
	                case 'var':
	                case 'class':
	                case 'function':
	                    declaration = this.parseStatementListItem();
	                    break;
	                default:
	                    this.throwUnexpectedToken(this.lookahead);
	            }
	            exportDeclaration = this.finalize(node, new Node.ExportNamedDeclaration(declaration, [], null));
	        }
	        else {
	            var specifiers = [];
	            var source = null;
	            var isExportFromIdentifier = false;
	            this.expect('{');
	            while (!this.match('}')) {
	                isExportFromIdentifier = isExportFromIdentifier || this.matchKeyword('default');
	                specifiers.push(this.parseExportSpecifier());
	                if (!this.match('}')) {
	                    this.expect(',');
	                }
	            }
	            this.expect('}');
	            if (this.matchContextualKeyword('from')) {
	                // export {default} from 'foo';
	                // export {foo} from 'foo';
	                this.nextToken();
	                source = this.parseModuleSpecifier();
	                this.consumeSemicolon();
	            }
	            else if (isExportFromIdentifier) {
	                // export {default}; // missing fromClause
	                var message = this.lookahead.value ? messages_1.Messages.UnexpectedToken : messages_1.Messages.MissingFromClause;
	                this.throwError(message, this.lookahead.value);
	            }
	            else {
	                // export {foo};
	                this.consumeSemicolon();
	            }
	            exportDeclaration = this.finalize(node, new Node.ExportNamedDeclaration(null, specifiers, source));
	        }
	        return exportDeclaration;
	    };
	    return Parser;
	}());
	exports.Parser = Parser;


/***/ },
/* 4 */
/***/ function(module, exports) {

	// Ensure the condition is true, otherwise throw an error.
	// This is only to have a better contract semantic, i.e. another safety net
	// to catch a logic error. The condition shall be fulfilled in normal case.
	// Do NOT use this to enforce a certain condition on any user input.
	"use strict";
	function assert(condition, message) {
	    /* istanbul ignore if */
	    if (!condition) {
	        throw new Error('ASSERT: ' + message);
	    }
	}
	exports.assert = assert;


/***/ },
/* 5 */
/***/ function(module, exports) {

	"use strict";
	// Error messages should be identical to V8.
	exports.Messages = {
	    UnexpectedToken: 'Unexpected token %0',
	    UnexpectedTokenIllegal: 'Unexpected token ILLEGAL',
	    UnexpectedNumber: 'Unexpected number',
	    UnexpectedString: 'Unexpected string',
	    UnexpectedIdentifier: 'Unexpected identifier',
	    UnexpectedReserved: 'Unexpected reserved word',
	    UnexpectedTemplate: 'Unexpected quasi %0',
	    UnexpectedEOS: 'Unexpected end of input',
	    NewlineAfterThrow: 'Illegal newline after throw',
	    InvalidRegExp: 'Invalid regular expression',
	    UnterminatedRegExp: 'Invalid regular expression: missing /',
	    InvalidLHSInAssignment: 'Invalid left-hand side in assignment',
	    InvalidLHSInForIn: 'Invalid left-hand side in for-in',
	    InvalidLHSInForLoop: 'Invalid left-hand side in for-loop',
	    MultipleDefaultsInSwitch: 'More than one default clause in switch statement',
	    NoCatchOrFinally: 'Missing catch or finally after try',
	    UnknownLabel: 'Undefined label \'%0\'',
	    Redeclaration: '%0 \'%1\' has already been declared',
	    IllegalContinue: 'Illegal continue statement',
	    IllegalBreak: 'Illegal break statement',
	    IllegalReturn: 'Illegal return statement',
	    StrictModeWith: 'Strict mode code may not include a with statement',
	    StrictCatchVariable: 'Catch variable may not be eval or arguments in strict mode',
	    StrictVarName: 'Variable name may not be eval or arguments in strict mode',
	    StrictParamName: 'Parameter name eval or arguments is not allowed in strict mode',
	    StrictParamDupe: 'Strict mode function may not have duplicate parameter names',
	    StrictFunctionName: 'Function name may not be eval or arguments in strict mode',
	    StrictOctalLiteral: 'Octal literals are not allowed in strict mode.',
	    StrictDelete: 'Delete of an unqualified identifier in strict mode.',
	    StrictLHSAssignment: 'Assignment to eval or arguments is not allowed in strict mode',
	    StrictLHSPostfix: 'Postfix increment/decrement may not have eval or arguments operand in strict mode',
	    StrictLHSPrefix: 'Prefix increment/decrement may not have eval or arguments operand in strict mode',
	    StrictReservedWord: 'Use of future reserved word in strict mode',
	    TemplateOctalLiteral: 'Octal literals are not allowed in template strings.',
	    ParameterAfterRestParameter: 'Rest parameter must be last formal parameter',
	    DefaultRestParameter: 'Unexpected token =',
	    DuplicateProtoProperty: 'Duplicate __proto__ fields are not allowed in object literals',
	    ConstructorSpecialMethod: 'Class constructor may not be an accessor',
	    DuplicateConstructor: 'A class may only have one constructor',
	    StaticPrototype: 'Classes may not have static property named prototype',
	    MissingFromClause: 'Unexpected token',
	    NoAsAfterImportNamespace: 'Unexpected token',
	    InvalidModuleSpecifier: 'Unexpected token',
	    IllegalImportDeclaration: 'Unexpected token',
	    IllegalExportDeclaration: 'Unexpected token',
	    DuplicateBinding: 'Duplicate binding %0',
	    ForInOfLoopInitializer: '%0 loop variable declaration may not have an initializer'
	};


/***/ },
/* 6 */
/***/ function(module, exports) {

	"use strict";
	var ErrorHandler = (function () {
	    function ErrorHandler() {
	        this.errors = [];
	        this.tolerant = false;
	    }
	    ;
	    ErrorHandler.prototype.recordError = function (error) {
	        this.errors.push(error);
	    };
	    ;
	    ErrorHandler.prototype.tolerate = function (error) {
	        if (this.tolerant) {
	            this.recordError(error);
	        }
	        else {
	            throw error;
	        }
	    };
	    ;
	    ErrorHandler.prototype.constructError = function (msg, column) {
	        var error = new Error(msg);
	        try {
	            throw error;
	        }
	        catch (base) {
	            /* istanbul ignore else */
	            if (Object.create && Object.defineProperty) {
	                error = Object.create(base);
	                Object.defineProperty(error, 'column', { value: column });
	            }
	        }
	        finally {
	            return error;
	        }
	    };
	    ;
	    ErrorHandler.prototype.createError = function (index, line, col, description) {
	        var msg = 'Line ' + line + ': ' + description;
	        var error = this.constructError(msg, col);
	        error.index = index;
	        error.lineNumber = line;
	        error.description = description;
	        return error;
	    };
	    ;
	    ErrorHandler.prototype.throwError = function (index, line, col, description) {
	        throw this.createError(index, line, col, description);
	    };
	    ;
	    ErrorHandler.prototype.tolerateError = function (index, line, col, description) {
	        var error = this.createError(index, line, col, description);
	        if (this.tolerant) {
	            this.recordError(error);
	        }
	        else {
	            throw error;
	        }
	    };
	    ;
	    return ErrorHandler;
	}());
	exports.ErrorHandler = ErrorHandler;


/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";
	(function (Token) {
	    Token[Token["BooleanLiteral"] = 1] = "BooleanLiteral";
	    Token[Token["EOF"] = 2] = "EOF";
	    Token[Token["Identifier"] = 3] = "Identifier";
	    Token[Token["Keyword"] = 4] = "Keyword";
	    Token[Token["NullLiteral"] = 5] = "NullLiteral";
	    Token[Token["NumericLiteral"] = 6] = "NumericLiteral";
	    Token[Token["Punctuator"] = 7] = "Punctuator";
	    Token[Token["StringLiteral"] = 8] = "StringLiteral";
	    Token[Token["RegularExpression"] = 9] = "RegularExpression";
	    Token[Token["Template"] = 10] = "Template";
	})(exports.Token || (exports.Token = {}));
	var Token = exports.Token;
	;
	exports.TokenName = {};
	exports.TokenName[Token.BooleanLiteral] = 'Boolean';
	exports.TokenName[Token.EOF] = '<end>';
	exports.TokenName[Token.Identifier] = 'Identifier';
	exports.TokenName[Token.Keyword] = 'Keyword';
	exports.TokenName[Token.NullLiteral] = 'Null';
	exports.TokenName[Token.NumericLiteral] = 'Numeric';
	exports.TokenName[Token.Punctuator] = 'Punctuator';
	exports.TokenName[Token.StringLiteral] = 'String';
	exports.TokenName[Token.RegularExpression] = 'RegularExpression';
	exports.TokenName[Token.Template] = 'Template';


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var assert_1 = __webpack_require__(4);
	var messages_1 = __webpack_require__(5);
	var character_1 = __webpack_require__(9);
	var token_1 = __webpack_require__(7);
	function hexValue(ch) {
	    return '0123456789abcdef'.indexOf(ch.toLowerCase());
	}
	function octalValue(ch) {
	    return '01234567'.indexOf(ch);
	}
	var Scanner = (function () {
	    function Scanner(code, handler) {
	        this.source = code;
	        this.errorHandler = handler;
	        this.trackComment = false;
	        this.length = code.length;
	        this.index = 0;
	        this.lineNumber = (code.length > 0) ? 1 : 0;
	        this.lineStart = 0;
	        this.curlyStack = [];
	    }
	    ;
	    Scanner.prototype.eof = function () {
	        return this.index >= this.length;
	    };
	    ;
	    Scanner.prototype.throwUnexpectedToken = function (message) {
	        if (message === void 0) { message = messages_1.Messages.UnexpectedTokenIllegal; }
	        this.errorHandler.throwError(this.index, this.lineNumber, this.index - this.lineStart + 1, message);
	    };
	    ;
	    Scanner.prototype.tolerateUnexpectedToken = function () {
	        this.errorHandler.tolerateError(this.index, this.lineNumber, this.index - this.lineStart + 1, messages_1.Messages.UnexpectedTokenIllegal);
	    };
	    ;
	    // ECMA-262 11.4 Comments
	    Scanner.prototype.skipSingleLineComment = function (offset) {
	        var comments;
	        var start, loc;
	        if (this.trackComment) {
	            comments = [];
	            start = this.index - offset;
	            loc = {
	                start: {
	                    line: this.lineNumber,
	                    column: this.index - this.lineStart - offset
	                },
	                end: {}
	            };
	        }
	        while (!this.eof()) {
	            var ch = this.source.charCodeAt(this.index);
	            ++this.index;
	            if (character_1.Character.isLineTerminator(ch)) {
	                if (this.trackComment) {
	                    loc.end = {
	                        line: this.lineNumber,
	                        column: this.index - this.lineStart - 1
	                    };
	                    var entry = {
	                        multiLine: false,
	                        slice: [start + offset, this.index - 1],
	                        range: [start, this.index - 1],
	                        loc: loc
	                    };
	                    comments.push(entry);
	                }
	                if (ch === 13 && this.source.charCodeAt(this.index) === 10) {
	                    ++this.index;
	                }
	                ++this.lineNumber;
	                this.lineStart = this.index;
	                return comments;
	            }
	        }
	        if (this.trackComment) {
	            loc.end = {
	                line: this.lineNumber,
	                column: this.index - this.lineStart
	            };
	            var entry = {
	                multiLine: false,
	                slice: [start + offset, this.index],
	                range: [start, this.index],
	                loc: loc
	            };
	            comments.push(entry);
	        }
	        return comments;
	    };
	    ;
	    Scanner.prototype.skipMultiLineComment = function () {
	        var comments;
	        var start, loc;
	        if (this.trackComment) {
	            comments = [];
	            start = this.index - 2;
	            loc = {
	                start: {
	                    line: this.lineNumber,
	                    column: this.index - this.lineStart - 2
	                },
	                end: {}
	            };
	        }
	        while (!this.eof()) {
	            var ch = this.source.charCodeAt(this.index);
	            if (character_1.Character.isLineTerminator(ch)) {
	                if (ch === 0x0D && this.source.charCodeAt(this.index + 1) === 0x0A) {
	                    ++this.index;
	                }
	                ++this.lineNumber;
	                ++this.index;
	                this.lineStart = this.index;
	            }
	            else if (ch === 0x2A) {
	                // Block comment ends with '*/'.
	                if (this.source.charCodeAt(this.index + 1) === 0x2F) {
	                    this.index += 2;
	                    if (this.trackComment) {
	                        loc.end = {
	                            line: this.lineNumber,
	                            column: this.index - this.lineStart
	                        };
	                        var entry = {
	                            multiLine: true,
	                            slice: [start + 2, this.index - 2],
	                            range: [start, this.index],
	                            loc: loc
	                        };
	                        comments.push(entry);
	                    }
	                    return comments;
	                }
	                ++this.index;
	            }
	            else {
	                ++this.index;
	            }
	        }
	        // Ran off the end of the file - the whole thing is a comment
	        if (this.trackComment) {
	            loc.end = {
	                line: this.lineNumber,
	                column: this.index - this.lineStart
	            };
	            var entry = {
	                multiLine: true,
	                slice: [start + 2, this.index],
	                range: [start, this.index],
	                loc: loc
	            };
	            comments.push(entry);
	        }
	        this.tolerateUnexpectedToken();
	        return comments;
	    };
	    ;
	    Scanner.prototype.scanComments = function () {
	        var comments;
	        if (this.trackComment) {
	            comments = [];
	        }
	        var start = (this.index === 0);
	        while (!this.eof()) {
	            var ch = this.source.charCodeAt(this.index);
	            if (character_1.Character.isWhiteSpace(ch)) {
	                ++this.index;
	            }
	            else if (character_1.Character.isLineTerminator(ch)) {
	                ++this.index;
	                if (ch === 0x0D && this.source.charCodeAt(this.index) === 0x0A) {
	                    ++this.index;
	                }
	                ++this.lineNumber;
	                this.lineStart = this.index;
	                start = true;
	            }
	            else if (ch === 0x2F) {
	                ch = this.source.charCodeAt(this.index + 1);
	                if (ch === 0x2F) {
	                    this.index += 2;
	                    var comment = this.skipSingleLineComment(2);
	                    if (this.trackComment) {
	                        comments = comments.concat(comment);
	                    }
	                    start = true;
	                }
	                else if (ch === 0x2A) {
	                    this.index += 2;
	                    var comment = this.skipMultiLineComment();
	                    if (this.trackComment) {
	                        comments = comments.concat(comment);
	                    }
	                }
	                else {
	                    break;
	                }
	            }
	            else if (start && ch === 0x2D) {
	                // U+003E is '>'
	                if ((this.source.charCodeAt(this.index + 1) === 0x2D) && (this.source.charCodeAt(this.index + 2) === 0x3E)) {
	                    // '-->' is a single-line comment
	                    this.index += 3;
	                    var comment = this.skipSingleLineComment(3);
	                    if (this.trackComment) {
	                        comments = comments.concat(comment);
	                    }
	                }
	                else {
	                    break;
	                }
	            }
	            else if (ch === 0x3C) {
	                if (this.source.slice(this.index + 1, this.index + 4) === '!--') {
	                    this.index += 4; // `<!--`
	                    var comment = this.skipSingleLineComment(4);
	                    if (this.trackComment) {
	                        comments = comments.concat(comment);
	                    }
	                }
	                else {
	                    break;
	                }
	            }
	            else {
	                break;
	            }
	        }
	        return comments;
	    };
	    ;
	    // ECMA-262 11.6.2.2 Future Reserved Words
	    Scanner.prototype.isFutureReservedWord = function (id) {
	        switch (id) {
	            case 'enum':
	            case 'export':
	            case 'import':
	            case 'super':
	                return true;
	            default:
	                return false;
	        }
	    };
	    ;
	    Scanner.prototype.isStrictModeReservedWord = function (id) {
	        switch (id) {
	            case 'implements':
	            case 'interface':
	            case 'package':
	            case 'private':
	            case 'protected':
	            case 'public':
	            case 'static':
	            case 'yield':
	            case 'let':
	                return true;
	            default:
	                return false;
	        }
	    };
	    ;
	    Scanner.prototype.isRestrictedWord = function (id) {
	        return id === 'eval' || id === 'arguments';
	    };
	    ;
	    // ECMA-262 11.6.2.1 Keywords
	    Scanner.prototype.isKeyword = function (id) {
	        switch (id.length) {
	            case 2:
	                return (id === 'if') || (id === 'in') || (id === 'do');
	            case 3:
	                return (id === 'var') || (id === 'for') || (id === 'new') ||
	                    (id === 'try') || (id === 'let');
	            case 4:
	                return (id === 'this') || (id === 'else') || (id === 'case') ||
	                    (id === 'void') || (id === 'with') || (id === 'enum');
	            case 5:
	                return (id === 'while') || (id === 'break') || (id === 'catch') ||
	                    (id === 'throw') || (id === 'const') || (id === 'yield') ||
	                    (id === 'class') || (id === 'super');
	            case 6:
	                return (id === 'return') || (id === 'typeof') || (id === 'delete') ||
	                    (id === 'switch') || (id === 'export') || (id === 'import');
	            case 7:
	                return (id === 'default') || (id === 'finally') || (id === 'extends');
	            case 8:
	                return (id === 'function') || (id === 'continue') || (id === 'debugger');
	            case 10:
	                return (id === 'instanceof');
	            default:
	                return false;
	        }
	    };
	    ;
	    Scanner.prototype.codePointAt = function (i) {
	        var cp = this.source.charCodeAt(i);
	        if (cp >= 0xD800 && cp <= 0xDBFF) {
	            var second = this.source.charCodeAt(i + 1);
	            if (second >= 0xDC00 && second <= 0xDFFF) {
	                var first = cp;
	                cp = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
	            }
	        }
	        return cp;
	    };
	    ;
	    Scanner.prototype.scanHexEscape = function (prefix) {
	        var len = (prefix === 'u') ? 4 : 2;
	        var code = 0;
	        for (var i = 0; i < len; ++i) {
	            if (!this.eof() && character_1.Character.isHexDigit(this.source.charCodeAt(this.index))) {
	                code = code * 16 + hexValue(this.source[this.index++]);
	            }
	            else {
	                return '';
	            }
	        }
	        return String.fromCharCode(code);
	    };
	    ;
	    Scanner.prototype.scanUnicodeCodePointEscape = function () {
	        var ch = this.source[this.index];
	        var code = 0;
	        // At least, one hex digit is required.
	        if (ch === '}') {
	            this.throwUnexpectedToken();
	        }
	        while (!this.eof()) {
	            ch = this.source[this.index++];
	            if (!character_1.Character.isHexDigit(ch.charCodeAt(0))) {
	                break;
	            }
	            code = code * 16 + hexValue(ch);
	        }
	        if (code > 0x10FFFF || ch !== '}') {
	            this.throwUnexpectedToken();
	        }
	        return character_1.Character.fromCodePoint(code);
	    };
	    ;
	    Scanner.prototype.getIdentifier = function () {
	        var start = this.index++;
	        while (!this.eof()) {
	            var ch = this.source.charCodeAt(this.index);
	            if (ch === 0x5C) {
	                // Blackslash (U+005C) marks Unicode escape sequence.
	                this.index = start;
	                return this.getComplexIdentifier();
	            }
	            else if (ch >= 0xD800 && ch < 0xDFFF) {
	                // Need to handle surrogate pairs.
	                this.index = start;
	                return this.getComplexIdentifier();
	            }
	            if (character_1.Character.isIdentifierPart(ch)) {
	                ++this.index;
	            }
	            else {
	                break;
	            }
	        }
	        return this.source.slice(start, this.index);
	    };
	    ;
	    Scanner.prototype.getComplexIdentifier = function () {
	        var cp = this.codePointAt(this.index);
	        var id = character_1.Character.fromCodePoint(cp);
	        this.index += id.length;
	        // '\u' (U+005C, U+0075) denotes an escaped character.
	        var ch;
	        if (cp === 0x5C) {
	            if (this.source.charCodeAt(this.index) !== 0x75) {
	                this.throwUnexpectedToken();
	            }
	            ++this.index;
	            if (this.source[this.index] === '{') {
	                ++this.index;
	                ch = this.scanUnicodeCodePointEscape();
	            }
	            else {
	                ch = this.scanHexEscape('u');
	                cp = ch.charCodeAt(0);
	                if (!ch || ch === '\\' || !character_1.Character.isIdentifierStart(cp)) {
	                    this.throwUnexpectedToken();
	                }
	            }
	            id = ch;
	        }
	        while (!this.eof()) {
	            cp = this.codePointAt(this.index);
	            if (!character_1.Character.isIdentifierPart(cp)) {
	                break;
	            }
	            ch = character_1.Character.fromCodePoint(cp);
	            id += ch;
	            this.index += ch.length;
	            // '\u' (U+005C, U+0075) denotes an escaped character.
	            if (cp === 0x5C) {
	                id = id.substr(0, id.length - 1);
	                if (this.source.charCodeAt(this.index) !== 0x75) {
	                    this.throwUnexpectedToken();
	                }
	                ++this.index;
	                if (this.source[this.index] === '{') {
	                    ++this.index;
	                    ch = this.scanUnicodeCodePointEscape();
	                }
	                else {
	                    ch = this.scanHexEscape('u');
	                    cp = ch.charCodeAt(0);
	                    if (!ch || ch === '\\' || !character_1.Character.isIdentifierPart(cp)) {
	                        this.throwUnexpectedToken();
	                    }
	                }
	                id += ch;
	            }
	        }
	        return id;
	    };
	    ;
	    Scanner.prototype.octalToDecimal = function (ch) {
	        // \0 is not octal escape sequence
	        var octal = (ch !== '0');
	        var code = octalValue(ch);
	        if (!this.eof() && character_1.Character.isOctalDigit(this.source.charCodeAt(this.index))) {
	            octal = true;
	            code = code * 8 + octalValue(this.source[this.index++]);
	            // 3 digits are only allowed when string starts
	            // with 0, 1, 2, 3
	            if ('0123'.indexOf(ch) >= 0 && !this.eof() && character_1.Character.isOctalDigit(this.source.charCodeAt(this.index))) {
	                code = code * 8 + octalValue(this.source[this.index++]);
	            }
	        }
	        return {
	            code: code,
	            octal: octal
	        };
	    };
	    ;
	    // ECMA-262 11.6 Names and Keywords
	    Scanner.prototype.scanIdentifier = function () {
	        var type;
	        var start = this.index;
	        // Backslash (U+005C) starts an escaped character.
	        var id = (this.source.charCodeAt(start) === 0x5C) ? this.getComplexIdentifier() : this.getIdentifier();
	        // There is no keyword or literal with only one character.
	        // Thus, it must be an identifier.
	        if (id.length === 1) {
	            type = token_1.Token.Identifier;
	        }
	        else if (this.isKeyword(id)) {
	            type = token_1.Token.Keyword;
	        }
	        else if (id === 'null') {
	            type = token_1.Token.NullLiteral;
	        }
	        else if (id === 'true' || id === 'false') {
	            type = token_1.Token.BooleanLiteral;
	        }
	        else {
	            type = token_1.Token.Identifier;
	        }
	        return {
	            type: type,
	            value: id,
	            lineNumber: this.lineNumber,
	            lineStart: this.lineStart,
	            start: start,
	            end: this.index
	        };
	    };
	    ;
	    // ECMA-262 11.7 Punctuators
	    Scanner.prototype.scanPunctuator = function () {
	        var token = {
	            type: token_1.Token.Punctuator,
	            value: '',
	            lineNumber: this.lineNumber,
	            lineStart: this.lineStart,
	            start: this.index,
	            end: this.index
	        };
	        // Check for most common single-character punctuators.
	        var str = this.source[this.index];
	        switch (str) {
	            case '(':
	            case '{':
	                if (str === '{') {
	                    this.curlyStack.push('{');
	                }
	                ++this.index;
	                break;
	            case '.':
	                ++this.index;
	                if (this.source[this.index] === '.' && this.source[this.index + 1] === '.') {
	                    // Spread operator: ...
	                    this.index += 2;
	                    str = '...';
	                }
	                break;
	            case '}':
	                ++this.index;
	                this.curlyStack.pop();
	                break;
	            case ')':
	            case ';':
	            case ',':
	            case '[':
	            case ']':
	            case ':':
	            case '?':
	            case '~':
	                ++this.index;
	                break;
	            default:
	                // 4-character punctuator.
	                str = this.source.substr(this.index, 4);
	                if (str === '>>>=') {
	                    this.index += 4;
	                }
	                else {
	                    // 3-character punctuators.
	                    str = str.substr(0, 3);
	                    if (str === '===' || str === '!==' || str === '>>>' ||
	                        str === '<<=' || str === '>>=' || str === '**=') {
	                        this.index += 3;
	                    }
	                    else {
	                        // 2-character punctuators.
	                        str = str.substr(0, 2);
	                        if (str === '&&' || str === '||' || str === '==' || str === '!=' ||
	                            str === '+=' || str === '-=' || str === '*=' || str === '/=' ||
	                            str === '++' || str === '--' || str === '<<' || str === '>>' ||
	                            str === '&=' || str === '|=' || str === '^=' || str === '%=' ||
	                            str === '<=' || str === '>=' || str === '=>' || str === '**') {
	                            this.index += 2;
	                        }
	                        else {
	                            // 1-character punctuators.
	                            str = this.source[this.index];
	                            if ('<>=!+-*%&|^/'.indexOf(str) >= 0) {
	                                ++this.index;
	                            }
	                        }
	                    }
	                }
	        }
	        if (this.index === token.start) {
	            this.throwUnexpectedToken();
	        }
	        token.end = this.index;
	        token.value = str;
	        return token;
	    };
	    ;
	    // ECMA-262 11.8.3 Numeric Literals
	    Scanner.prototype.scanHexLiteral = function (start) {
	        var number = '';
	        while (!this.eof()) {
	            if (!character_1.Character.isHexDigit(this.source.charCodeAt(this.index))) {
	                break;
	            }
	            number += this.source[this.index++];
	        }
	        if (number.length === 0) {
	            this.throwUnexpectedToken();
	        }
	        if (character_1.Character.isIdentifierStart(this.source.charCodeAt(this.index))) {
	            this.throwUnexpectedToken();
	        }
	        return {
	            type: token_1.Token.NumericLiteral,
	            value: parseInt('0x' + number, 16),
	            lineNumber: this.lineNumber,
	            lineStart: this.lineStart,
	            start: start,
	            end: this.index
	        };
	    };
	    ;
	    Scanner.prototype.scanBinaryLiteral = function (start) {
	        var number = '';
	        var ch;
	        while (!this.eof()) {
	            ch = this.source[this.index];
	            if (ch !== '0' && ch !== '1') {
	                break;
	            }
	            number += this.source[this.index++];
	        }
	        if (number.length === 0) {
	            // only 0b or 0B
	            this.throwUnexpectedToken();
	        }
	        if (!this.eof()) {
	            ch = this.source.charCodeAt(this.index);
	            /* istanbul ignore else */
	            if (character_1.Character.isIdentifierStart(ch) || character_1.Character.isDecimalDigit(ch)) {
	                this.throwUnexpectedToken();
	            }
	        }
	        return {
	            type: token_1.Token.NumericLiteral,
	            value: parseInt(number, 2),
	            lineNumber: this.lineNumber,
	            lineStart: this.lineStart,
	            start: start,
	            end: this.index
	        };
	    };
	    ;
	    Scanner.prototype.scanOctalLiteral = function (prefix, start) {
	        var number = '';
	        var octal = false;
	        if (character_1.Character.isOctalDigit(prefix.charCodeAt(0))) {
	            octal = true;
	            number = '0' + this.source[this.index++];
	        }
	        else {
	            ++this.index;
	        }
	        while (!this.eof()) {
	            if (!character_1.Character.isOctalDigit(this.source.charCodeAt(this.index))) {
	                break;
	            }
	            number += this.source[this.index++];
	        }
	        if (!octal && number.length === 0) {
	            // only 0o or 0O
	            this.throwUnexpectedToken();
	        }
	        if (character_1.Character.isIdentifierStart(this.source.charCodeAt(this.index)) || character_1.Character.isDecimalDigit(this.source.charCodeAt(this.index))) {
	            this.throwUnexpectedToken();
	        }
	        return {
	            type: token_1.Token.NumericLiteral,
	            value: parseInt(number, 8),
	            octal: octal,
	            lineNumber: this.lineNumber,
	            lineStart: this.lineStart,
	            start: start,
	            end: this.index
	        };
	    };
	    ;
	    Scanner.prototype.isImplicitOctalLiteral = function () {
	        // Implicit octal, unless there is a non-octal digit.
	        // (Annex B.1.1 on Numeric Literals)
	        for (var i = this.index + 1; i < this.length; ++i) {
	            var ch = this.source[i];
	            if (ch === '8' || ch === '9') {
	                return false;
	            }
	            if (!character_1.Character.isOctalDigit(ch.charCodeAt(0))) {
	                return true;
	            }
	        }
	        return true;
	    };
	    ;
	    Scanner.prototype.scanNumericLiteral = function () {
	        var start = this.index;
	        var ch = this.source[start];
	        assert_1.assert(character_1.Character.isDecimalDigit(ch.charCodeAt(0)) || (ch === '.'), 'Numeric literal must start with a decimal digit or a decimal point');
	        var number = '';
	        if (ch !== '.') {
	            number = this.source[this.index++];
	            ch = this.source[this.index];
	            // Hex number starts with '0x'.
	            // Octal number starts with '0'.
	            // Octal number in ES6 starts with '0o'.
	            // Binary number in ES6 starts with '0b'.
	            if (number === '0') {
	                if (ch === 'x' || ch === 'X') {
	                    ++this.index;
	                    return this.scanHexLiteral(start);
	                }
	                if (ch === 'b' || ch === 'B') {
	                    ++this.index;
	                    return this.scanBinaryLiteral(start);
	                }
	                if (ch === 'o' || ch === 'O') {
	                    return this.scanOctalLiteral(ch, start);
	                }
	                if (ch && character_1.Character.isOctalDigit(ch.charCodeAt(0))) {
	                    if (this.isImplicitOctalLiteral()) {
	                        return this.scanOctalLiteral(ch, start);
	                    }
	                }
	            }
	            while (character_1.Character.isDecimalDigit(this.source.charCodeAt(this.index))) {
	                number += this.source[this.index++];
	            }
	            ch = this.source[this.index];
	        }
	        if (ch === '.') {
	            number += this.source[this.index++];
	            while (character_1.Character.isDecimalDigit(this.source.charCodeAt(this.index))) {
	                number += this.source[this.index++];
	            }
	            ch = this.source[this.index];
	        }
	        if (ch === 'e' || ch === 'E') {
	            number += this.source[this.index++];
	            ch = this.source[this.index];
	            if (ch === '+' || ch === '-') {
	                number += this.source[this.index++];
	            }
	            if (character_1.Character.isDecimalDigit(this.source.charCodeAt(this.index))) {
	                while (character_1.Character.isDecimalDigit(this.source.charCodeAt(this.index))) {
	                    number += this.source[this.index++];
	                }
	            }
	            else {
	                this.throwUnexpectedToken();
	            }
	        }
	        if (character_1.Character.isIdentifierStart(this.source.charCodeAt(this.index))) {
	            this.throwUnexpectedToken();
	        }
	        return {
	            type: token_1.Token.NumericLiteral,
	            value: parseFloat(number),
	            lineNumber: this.lineNumber,
	            lineStart: this.lineStart,
	            start: start,
	            end: this.index
	        };
	    };
	    ;
	    // ECMA-262 11.8.4 String Literals
	    Scanner.prototype.scanStringLiteral = function () {
	        var start = this.index;
	        var quote = this.source[start];
	        assert_1.assert((quote === '\'' || quote === '"'), 'String literal must starts with a quote');
	        ++this.index;
	        var octal = false;
	        var str = '';
	        while (!this.eof()) {
	            var ch = this.source[this.index++];
	            if (ch === quote) {
	                quote = '';
	                break;
	            }
	            else if (ch === '\\') {
	                ch = this.source[this.index++];
	                if (!ch || !character_1.Character.isLineTerminator(ch.charCodeAt(0))) {
	                    switch (ch) {
	                        case 'u':
	                        case 'x':
	                            if (this.source[this.index] === '{') {
	                                ++this.index;
	                                str += this.scanUnicodeCodePointEscape();
	                            }
	                            else {
	                                var unescaped = this.scanHexEscape(ch);
	                                if (!unescaped) {
	                                    this.throwUnexpectedToken();
	                                }
	                                str += unescaped;
	                            }
	                            break;
	                        case 'n':
	                            str += '\n';
	                            break;
	                        case 'r':
	                            str += '\r';
	                            break;
	                        case 't':
	                            str += '\t';
	                            break;
	                        case 'b':
	                            str += '\b';
	                            break;
	                        case 'f':
	                            str += '\f';
	                            break;
	                        case 'v':
	                            str += '\x0B';
	                            break;
	                        case '8':
	                        case '9':
	                            str += ch;
	                            this.tolerateUnexpectedToken();
	                            break;
	                        default:
	                            if (ch && character_1.Character.isOctalDigit(ch.charCodeAt(0))) {
	                                var octToDec = this.octalToDecimal(ch);
	                                octal = octToDec.octal || octal;
	                                str += String.fromCharCode(octToDec.code);
	                            }
	                            else {
	                                str += ch;
	                            }
	                            break;
	                    }
	                }
	                else {
	                    ++this.lineNumber;
	                    if (ch === '\r' && this.source[this.index] === '\n') {
	                        ++this.index;
	                    }
	                    this.lineStart = this.index;
	                }
	            }
	            else if (character_1.Character.isLineTerminator(ch.charCodeAt(0))) {
	                break;
	            }
	            else {
	                str += ch;
	            }
	        }
	        if (quote !== '') {
	            this.index = start;
	            this.throwUnexpectedToken();
	        }
	        return {
	            type: token_1.Token.StringLiteral,
	            value: str,
	            octal: octal,
	            lineNumber: this.lineNumber,
	            lineStart: this.lineStart,
	            start: start,
	            end: this.index
	        };
	    };
	    ;
	    // ECMA-262 11.8.6 Template Literal Lexical Components
	    Scanner.prototype.scanTemplate = function () {
	        var cooked = '';
	        var terminated = false;
	        var start = this.index;
	        var head = (this.source[start] === '`');
	        var tail = false;
	        var rawOffset = 2;
	        ++this.index;
	        while (!this.eof()) {
	            var ch = this.source[this.index++];
	            if (ch === '`') {
	                rawOffset = 1;
	                tail = true;
	                terminated = true;
	                break;
	            }
	            else if (ch === '$') {
	                if (this.source[this.index] === '{') {
	                    this.curlyStack.push('${');
	                    ++this.index;
	                    terminated = true;
	                    break;
	                }
	                cooked += ch;
	            }
	            else if (ch === '\\') {
	                ch = this.source[this.index++];
	                if (!character_1.Character.isLineTerminator(ch.charCodeAt(0))) {
	                    switch (ch) {
	                        case 'n':
	                            cooked += '\n';
	                            break;
	                        case 'r':
	                            cooked += '\r';
	                            break;
	                        case 't':
	                            cooked += '\t';
	                            break;
	                        case 'u':
	                        case 'x':
	                            if (this.source[this.index] === '{') {
	                                ++this.index;
	                                cooked += this.scanUnicodeCodePointEscape();
	                            }
	                            else {
	                                var restore = this.index;
	                                var unescaped = this.scanHexEscape(ch);
	                                if (unescaped) {
	                                    cooked += unescaped;
	                                }
	                                else {
	                                    this.index = restore;
	                                    cooked += ch;
	                                }
	                            }
	                            break;
	                        case 'b':
	                            cooked += '\b';
	                            break;
	                        case 'f':
	                            cooked += '\f';
	                            break;
	                        case 'v':
	                            cooked += '\v';
	                            break;
	                        default:
	                            if (ch === '0') {
	                                if (character_1.Character.isDecimalDigit(this.source.charCodeAt(this.index))) {
	                                    // Illegal: \01 \02 and so on
	                                    this.throwUnexpectedToken(messages_1.Messages.TemplateOctalLiteral);
	                                }
	                                cooked += '\0';
	                            }
	                            else if (character_1.Character.isOctalDigit(ch.charCodeAt(0))) {
	                                // Illegal: \1 \2
	                                this.throwUnexpectedToken(messages_1.Messages.TemplateOctalLiteral);
	                            }
	                            else {
	                                cooked += ch;
	                            }
	                            break;
	                    }
	                }
	                else {
	                    ++this.lineNumber;
	                    if (ch === '\r' && this.source[this.index] === '\n') {
	                        ++this.index;
	                    }
	                    this.lineStart = this.index;
	                }
	            }
	            else if (character_1.Character.isLineTerminator(ch.charCodeAt(0))) {
	                ++this.lineNumber;
	                if (ch === '\r' && this.source[this.index] === '\n') {
	                    ++this.index;
	                }
	                this.lineStart = this.index;
	                cooked += '\n';
	            }
	            else {
	                cooked += ch;
	            }
	        }
	        if (!terminated) {
	            this.throwUnexpectedToken();
	        }
	        if (!head) {
	            this.curlyStack.pop();
	        }
	        return {
	            type: token_1.Token.Template,
	            value: {
	                cooked: cooked,
	                raw: this.source.slice(start + 1, this.index - rawOffset)
	            },
	            head: head,
	            tail: tail,
	            lineNumber: this.lineNumber,
	            lineStart: this.lineStart,
	            start: start,
	            end: this.index
	        };
	    };
	    ;
	    // ECMA-262 11.8.5 Regular Expression Literals
	    Scanner.prototype.testRegExp = function (pattern, flags) {
	        // The BMP character to use as a replacement for astral symbols when
	        // translating an ES6 "u"-flagged pattern to an ES5-compatible
	        // approximation.
	        // Note: replacing with '\uFFFF' enables false positives in unlikely
	        // scenarios. For example, `[\u{1044f}-\u{10440}]` is an invalid
	        // pattern that would not be detected by this substitution.
	        var astralSubstitute = '\uFFFF';
	        var tmp = pattern;
	        var self = this;
	        if (flags.indexOf('u') >= 0) {
	            tmp = tmp
	                .replace(/\\u\{([0-9a-fA-F]+)\}|\\u([a-fA-F0-9]{4})/g, function ($0, $1, $2) {
	                var codePoint = parseInt($1 || $2, 16);
	                if (codePoint > 0x10FFFF) {
	                    self.throwUnexpectedToken(messages_1.Messages.InvalidRegExp);
	                }
	                if (codePoint <= 0xFFFF) {
	                    return String.fromCharCode(codePoint);
	                }
	                return astralSubstitute;
	            })
	                .replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, astralSubstitute);
	        }
	        // First, detect invalid regular expressions.
	        try {
	            RegExp(tmp);
	        }
	        catch (e) {
	            this.throwUnexpectedToken(messages_1.Messages.InvalidRegExp);
	        }
	        // Return a regular expression object for this pattern-flag pair, or
	        // `null` in case the current environment doesn't support the flags it
	        // uses.
	        try {
	            return new RegExp(pattern, flags);
	        }
	        catch (exception) {
	            /* istanbul ignore next */
	            return null;
	        }
	    };
	    ;
	    Scanner.prototype.scanRegExpBody = function () {
	        var ch = this.source[this.index];
	        assert_1.assert(ch === '/', 'Regular expression literal must start with a slash');
	        var str = this.source[this.index++];
	        var classMarker = false;
	        var terminated = false;
	        while (!this.eof()) {
	            ch = this.source[this.index++];
	            str += ch;
	            if (ch === '\\') {
	                ch = this.source[this.index++];
	                // ECMA-262 7.8.5
	                if (character_1.Character.isLineTerminator(ch.charCodeAt(0))) {
	                    this.throwUnexpectedToken(messages_1.Messages.UnterminatedRegExp);
	                }
	                str += ch;
	            }
	            else if (character_1.Character.isLineTerminator(ch.charCodeAt(0))) {
	                this.throwUnexpectedToken(messages_1.Messages.UnterminatedRegExp);
	            }
	            else if (classMarker) {
	                if (ch === ']') {
	                    classMarker = false;
	                }
	            }
	            else {
	                if (ch === '/') {
	                    terminated = true;
	                    break;
	                }
	                else if (ch === '[') {
	                    classMarker = true;
	                }
	            }
	        }
	        if (!terminated) {
	            this.throwUnexpectedToken(messages_1.Messages.UnterminatedRegExp);
	        }
	        // Exclude leading and trailing slash.
	        var body = str.substr(1, str.length - 2);
	        return {
	            value: body,
	            literal: str
	        };
	    };
	    ;
	    Scanner.prototype.scanRegExpFlags = function () {
	        var str = '';
	        var flags = '';
	        while (!this.eof()) {
	            var ch = this.source[this.index];
	            if (!character_1.Character.isIdentifierPart(ch.charCodeAt(0))) {
	                break;
	            }
	            ++this.index;
	            if (ch === '\\' && !this.eof()) {
	                ch = this.source[this.index];
	                if (ch === 'u') {
	                    ++this.index;
	                    var restore = this.index;
	                    ch = this.scanHexEscape('u');
	                    if (ch) {
	                        flags += ch;
	                        for (str += '\\u'; restore < this.index; ++restore) {
	                            str += this.source[restore];
	                        }
	                    }
	                    else {
	                        this.index = restore;
	                        flags += 'u';
	                        str += '\\u';
	                    }
	                    this.tolerateUnexpectedToken();
	                }
	                else {
	                    str += '\\';
	                    this.tolerateUnexpectedToken();
	                }
	            }
	            else {
	                flags += ch;
	                str += ch;
	            }
	        }
	        return {
	            value: flags,
	            literal: str
	        };
	    };
	    ;
	    Scanner.prototype.scanRegExp = function () {
	        var start = this.index;
	        var body = this.scanRegExpBody();
	        var flags = this.scanRegExpFlags();
	        var value = this.testRegExp(body.value, flags.value);
	        return {
	            type: token_1.Token.RegularExpression,
	            value: value,
	            literal: body.literal + flags.literal,
	            regex: {
	                pattern: body.value,
	                flags: flags.value
	            },
	            lineNumber: this.lineNumber,
	            lineStart: this.lineStart,
	            start: start,
	            end: this.index
	        };
	    };
	    ;
	    Scanner.prototype.lex = function () {
	        if (this.eof()) {
	            return {
	                type: token_1.Token.EOF,
	                lineNumber: this.lineNumber,
	                lineStart: this.lineStart,
	                start: this.index,
	                end: this.index
	            };
	        }
	        var cp = this.source.charCodeAt(this.index);
	        if (character_1.Character.isIdentifierStart(cp)) {
	            return this.scanIdentifier();
	        }
	        // Very common: ( and ) and ;
	        if (cp === 0x28 || cp === 0x29 || cp === 0x3B) {
	            return this.scanPunctuator();
	        }
	        // String literal starts with single quote (U+0027) or double quote (U+0022).
	        if (cp === 0x27 || cp === 0x22) {
	            return this.scanStringLiteral();
	        }
	        // Dot (.) U+002E can also start a floating-point number, hence the need
	        // to check the next character.
	        if (cp === 0x2E) {
	            if (character_1.Character.isDecimalDigit(this.source.charCodeAt(this.index + 1))) {
	                return this.scanNumericLiteral();
	            }
	            return this.scanPunctuator();
	        }
	        if (character_1.Character.isDecimalDigit(cp)) {
	            return this.scanNumericLiteral();
	        }
	        // Template literals start with ` (U+0060) for template head
	        // or } (U+007D) for template middle or template tail.
	        if (cp === 0x60 || (cp === 0x7D && this.curlyStack[this.curlyStack.length - 1] === '${')) {
	            return this.scanTemplate();
	        }
	        // Possible identifier start in a surrogate pair.
	        if (cp >= 0xD800 && cp < 0xDFFF) {
	            if (character_1.Character.isIdentifierStart(this.codePointAt(this.index))) {
	                return this.scanIdentifier();
	            }
	        }
	        return this.scanPunctuator();
	    };
	    ;
	    return Scanner;
	}());
	exports.Scanner = Scanner;


/***/ },
/* 9 */
/***/ function(module, exports) {

	"use strict";
	// See also tools/generate-unicode-regex.js.
	var Regex = {
	    // Unicode v8.0.0 NonAsciiIdentifierStart:
	    NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/,
	    // Unicode v8.0.0 NonAsciiIdentifierPart:
	    NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFC-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C4\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/
	};
	exports.Character = {
	    fromCodePoint: function (cp) {
	        return (cp < 0x10000) ? String.fromCharCode(cp) :
	            String.fromCharCode(0xD800 + ((cp - 0x10000) >> 10)) +
	                String.fromCharCode(0xDC00 + ((cp - 0x10000) & 1023));
	    },
	    // ECMA-262 11.2 White Space
	    isWhiteSpace: function (cp) {
	        return (cp === 0x20) || (cp === 0x09) || (cp === 0x0B) || (cp === 0x0C) || (cp === 0xA0) ||
	            (cp >= 0x1680 && [0x1680, 0x2000, 0x2001, 0x2002, 0x2003, 0x2004, 0x2005, 0x2006, 0x2007, 0x2008, 0x2009, 0x200A, 0x202F, 0x205F, 0x3000, 0xFEFF].indexOf(cp) >= 0);
	    },
	    // ECMA-262 11.3 Line Terminators
	    isLineTerminator: function (cp) {
	        return (cp === 0x0A) || (cp === 0x0D) || (cp === 0x2028) || (cp === 0x2029);
	    },
	    // ECMA-262 11.6 Identifier Names and Identifiers
	    isIdentifierStart: function (cp) {
	        return (cp === 0x24) || (cp === 0x5F) ||
	            (cp >= 0x41 && cp <= 0x5A) ||
	            (cp >= 0x61 && cp <= 0x7A) ||
	            (cp === 0x5C) ||
	            ((cp >= 0x80) && Regex.NonAsciiIdentifierStart.test(exports.Character.fromCodePoint(cp)));
	    },
	    isIdentifierPart: function (cp) {
	        return (cp === 0x24) || (cp === 0x5F) ||
	            (cp >= 0x41 && cp <= 0x5A) ||
	            (cp >= 0x61 && cp <= 0x7A) ||
	            (cp >= 0x30 && cp <= 0x39) ||
	            (cp === 0x5C) ||
	            ((cp >= 0x80) && Regex.NonAsciiIdentifierPart.test(exports.Character.fromCodePoint(cp)));
	    },
	    // ECMA-262 11.8.3 Numeric Literals
	    isDecimalDigit: function (cp) {
	        return (cp >= 0x30 && cp <= 0x39); // 0..9
	    },
	    isHexDigit: function (cp) {
	        return (cp >= 0x30 && cp <= 0x39) ||
	            (cp >= 0x41 && cp <= 0x46) ||
	            (cp >= 0x61 && cp <= 0x66); // a..f
	    },
	    isOctalDigit: function (cp) {
	        return (cp >= 0x30 && cp <= 0x37); // 0..7
	    }
	};


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var syntax_1 = __webpack_require__(2);
	var ArrayExpression = (function () {
	    function ArrayExpression(elements) {
	        this.type = syntax_1.Syntax.ArrayExpression;
	        this.elements = elements;
	    }
	    return ArrayExpression;
	}());
	exports.ArrayExpression = ArrayExpression;
	var ArrayPattern = (function () {
	    function ArrayPattern(elements) {
	        this.type = syntax_1.Syntax.ArrayPattern;
	        this.elements = elements;
	    }
	    return ArrayPattern;
	}());
	exports.ArrayPattern = ArrayPattern;
	var ArrowFunctionExpression = (function () {
	    function ArrowFunctionExpression(params, body, expression) {
	        this.type = syntax_1.Syntax.ArrowFunctionExpression;
	        this.id = null;
	        this.params = params;
	        this.body = body;
	        this.generator = false;
	        this.expression = expression;
	    }
	    return ArrowFunctionExpression;
	}());
	exports.ArrowFunctionExpression = ArrowFunctionExpression;
	var AssignmentExpression = (function () {
	    function AssignmentExpression(operator, left, right) {
	        this.type = syntax_1.Syntax.AssignmentExpression;
	        this.operator = operator;
	        this.left = left;
	        this.right = right;
	    }
	    return AssignmentExpression;
	}());
	exports.AssignmentExpression = AssignmentExpression;
	var AssignmentPattern = (function () {
	    function AssignmentPattern(left, right) {
	        this.type = syntax_1.Syntax.AssignmentPattern;
	        this.left = left;
	        this.right = right;
	    }
	    return AssignmentPattern;
	}());
	exports.AssignmentPattern = AssignmentPattern;
	var BinaryExpression = (function () {
	    function BinaryExpression(operator, left, right) {
	        var logical = (operator === '||' || operator === '&&');
	        this.type = logical ? syntax_1.Syntax.LogicalExpression : syntax_1.Syntax.BinaryExpression;
	        this.operator = operator;
	        this.left = left;
	        this.right = right;
	    }
	    return BinaryExpression;
	}());
	exports.BinaryExpression = BinaryExpression;
	var BlockStatement = (function () {
	    function BlockStatement(body) {
	        this.type = syntax_1.Syntax.BlockStatement;
	        this.body = body;
	    }
	    return BlockStatement;
	}());
	exports.BlockStatement = BlockStatement;
	var BreakStatement = (function () {
	    function BreakStatement(label) {
	        this.type = syntax_1.Syntax.BreakStatement;
	        this.label = label;
	    }
	    return BreakStatement;
	}());
	exports.BreakStatement = BreakStatement;
	var CallExpression = (function () {
	    function CallExpression(callee, args) {
	        this.type = syntax_1.Syntax.CallExpression;
	        this.callee = callee;
	        this.arguments = args;
	    }
	    return CallExpression;
	}());
	exports.CallExpression = CallExpression;
	var CatchClause = (function () {
	    function CatchClause(param, body) {
	        this.type = syntax_1.Syntax.CatchClause;
	        this.param = param;
	        this.body = body;
	    }
	    return CatchClause;
	}());
	exports.CatchClause = CatchClause;
	var ClassBody = (function () {
	    function ClassBody(body) {
	        this.type = syntax_1.Syntax.ClassBody;
	        this.body = body;
	    }
	    return ClassBody;
	}());
	exports.ClassBody = ClassBody;
	var ClassDeclaration = (function () {
	    function ClassDeclaration(id, superClass, body) {
	        this.type = syntax_1.Syntax.ClassDeclaration;
	        this.id = id;
	        this.superClass = superClass;
	        this.body = body;
	    }
	    return ClassDeclaration;
	}());
	exports.ClassDeclaration = ClassDeclaration;
	var ClassExpression = (function () {
	    function ClassExpression(id, superClass, body) {
	        this.type = syntax_1.Syntax.ClassExpression;
	        this.id = id;
	        this.superClass = superClass;
	        this.body = body;
	    }
	    return ClassExpression;
	}());
	exports.ClassExpression = ClassExpression;
	var ComputedMemberExpression = (function () {
	    function ComputedMemberExpression(object, property) {
	        this.type = syntax_1.Syntax.MemberExpression;
	        this.computed = true;
	        this.object = object;
	        this.property = property;
	    }
	    return ComputedMemberExpression;
	}());
	exports.ComputedMemberExpression = ComputedMemberExpression;
	var ConditionalExpression = (function () {
	    function ConditionalExpression(test, consequent, alternate) {
	        this.type = syntax_1.Syntax.ConditionalExpression;
	        this.test = test;
	        this.consequent = consequent;
	        this.alternate = alternate;
	    }
	    return ConditionalExpression;
	}());
	exports.ConditionalExpression = ConditionalExpression;
	var ContinueStatement = (function () {
	    function ContinueStatement(label) {
	        this.type = syntax_1.Syntax.ContinueStatement;
	        this.label = label;
	    }
	    return ContinueStatement;
	}());
	exports.ContinueStatement = ContinueStatement;
	var DebuggerStatement = (function () {
	    function DebuggerStatement() {
	        this.type = syntax_1.Syntax.DebuggerStatement;
	    }
	    return DebuggerStatement;
	}());
	exports.DebuggerStatement = DebuggerStatement;
	var Directive = (function () {
	    function Directive(expression, directive) {
	        this.type = syntax_1.Syntax.ExpressionStatement;
	        this.expression = expression;
	        this.directive = directive;
	    }
	    return Directive;
	}());
	exports.Directive = Directive;
	var DoWhileStatement = (function () {
	    function DoWhileStatement(body, test) {
	        this.type = syntax_1.Syntax.DoWhileStatement;
	        this.body = body;
	        this.test = test;
	    }
	    return DoWhileStatement;
	}());
	exports.DoWhileStatement = DoWhileStatement;
	var EmptyStatement = (function () {
	    function EmptyStatement() {
	        this.type = syntax_1.Syntax.EmptyStatement;
	    }
	    return EmptyStatement;
	}());
	exports.EmptyStatement = EmptyStatement;
	var ExportAllDeclaration = (function () {
	    function ExportAllDeclaration(source) {
	        this.type = syntax_1.Syntax.ExportAllDeclaration;
	        this.source = source;
	    }
	    return ExportAllDeclaration;
	}());
	exports.ExportAllDeclaration = ExportAllDeclaration;
	var ExportDefaultDeclaration = (function () {
	    function ExportDefaultDeclaration(declaration) {
	        this.type = syntax_1.Syntax.ExportDefaultDeclaration;
	        this.declaration = declaration;
	    }
	    return ExportDefaultDeclaration;
	}());
	exports.ExportDefaultDeclaration = ExportDefaultDeclaration;
	var ExportNamedDeclaration = (function () {
	    function ExportNamedDeclaration(declaration, specifiers, source) {
	        this.type = syntax_1.Syntax.ExportNamedDeclaration;
	        this.declaration = declaration;
	        this.specifiers = specifiers;
	        this.source = source;
	    }
	    return ExportNamedDeclaration;
	}());
	exports.ExportNamedDeclaration = ExportNamedDeclaration;
	var ExportSpecifier = (function () {
	    function ExportSpecifier(local, exported) {
	        this.type = syntax_1.Syntax.ExportSpecifier;
	        this.exported = exported;
	        this.local = local;
	    }
	    return ExportSpecifier;
	}());
	exports.ExportSpecifier = ExportSpecifier;
	var ExpressionStatement = (function () {
	    function ExpressionStatement(expression) {
	        this.type = syntax_1.Syntax.ExpressionStatement;
	        this.expression = expression;
	    }
	    return ExpressionStatement;
	}());
	exports.ExpressionStatement = ExpressionStatement;
	var ForInStatement = (function () {
	    function ForInStatement(left, right, body) {
	        this.type = syntax_1.Syntax.ForInStatement;
	        this.left = left;
	        this.right = right;
	        this.body = body;
	        this.each = false;
	    }
	    return ForInStatement;
	}());
	exports.ForInStatement = ForInStatement;
	var ForOfStatement = (function () {
	    function ForOfStatement(left, right, body) {
	        this.type = syntax_1.Syntax.ForOfStatement;
	        this.left = left;
	        this.right = right;
	        this.body = body;
	    }
	    return ForOfStatement;
	}());
	exports.ForOfStatement = ForOfStatement;
	var ForStatement = (function () {
	    function ForStatement(init, test, update, body) {
	        this.type = syntax_1.Syntax.ForStatement;
	        this.init = init;
	        this.test = test;
	        this.update = update;
	        this.body = body;
	    }
	    return ForStatement;
	}());
	exports.ForStatement = ForStatement;
	var FunctionDeclaration = (function () {
	    function FunctionDeclaration(id, params, body, generator) {
	        this.type = syntax_1.Syntax.FunctionDeclaration;
	        this.id = id;
	        this.params = params;
	        this.body = body;
	        this.generator = generator;
	        this.expression = false;
	    }
	    return FunctionDeclaration;
	}());
	exports.FunctionDeclaration = FunctionDeclaration;
	var FunctionExpression = (function () {
	    function FunctionExpression(id, params, body, generator) {
	        this.type = syntax_1.Syntax.FunctionExpression;
	        this.id = id;
	        this.params = params;
	        this.body = body;
	        this.generator = generator;
	        this.expression = false;
	    }
	    return FunctionExpression;
	}());
	exports.FunctionExpression = FunctionExpression;
	var Identifier = (function () {
	    function Identifier(name) {
	        this.type = syntax_1.Syntax.Identifier;
	        this.name = name;
	    }
	    return Identifier;
	}());
	exports.Identifier = Identifier;
	var IfStatement = (function () {
	    function IfStatement(test, consequent, alternate) {
	        this.type = syntax_1.Syntax.IfStatement;
	        this.test = test;
	        this.consequent = consequent;
	        this.alternate = alternate;
	    }
	    return IfStatement;
	}());
	exports.IfStatement = IfStatement;
	var ImportDeclaration = (function () {
	    function ImportDeclaration(specifiers, source) {
	        this.type = syntax_1.Syntax.ImportDeclaration;
	        this.specifiers = specifiers;
	        this.source = source;
	    }
	    return ImportDeclaration;
	}());
	exports.ImportDeclaration = ImportDeclaration;
	var ImportDefaultSpecifier = (function () {
	    function ImportDefaultSpecifier(local) {
	        this.type = syntax_1.Syntax.ImportDefaultSpecifier;
	        this.local = local;
	    }
	    return ImportDefaultSpecifier;
	}());
	exports.ImportDefaultSpecifier = ImportDefaultSpecifier;
	var ImportNamespaceSpecifier = (function () {
	    function ImportNamespaceSpecifier(local) {
	        this.type = syntax_1.Syntax.ImportNamespaceSpecifier;
	        this.local = local;
	    }
	    return ImportNamespaceSpecifier;
	}());
	exports.ImportNamespaceSpecifier = ImportNamespaceSpecifier;
	var ImportSpecifier = (function () {
	    function ImportSpecifier(local, imported) {
	        this.type = syntax_1.Syntax.ImportSpecifier;
	        this.local = local;
	        this.imported = imported;
	    }
	    return ImportSpecifier;
	}());
	exports.ImportSpecifier = ImportSpecifier;
	var LabeledStatement = (function () {
	    function LabeledStatement(label, body) {
	        this.type = syntax_1.Syntax.LabeledStatement;
	        this.label = label;
	        this.body = body;
	    }
	    return LabeledStatement;
	}());
	exports.LabeledStatement = LabeledStatement;
	var Literal = (function () {
	    function Literal(value, raw) {
	        this.type = syntax_1.Syntax.Literal;
	        this.value = value;
	        this.raw = raw;
	    }
	    return Literal;
	}());
	exports.Literal = Literal;
	var MetaProperty = (function () {
	    function MetaProperty(meta, property) {
	        this.type = syntax_1.Syntax.MetaProperty;
	        this.meta = meta;
	        this.property = property;
	    }
	    return MetaProperty;
	}());
	exports.MetaProperty = MetaProperty;
	var MethodDefinition = (function () {
	    function MethodDefinition(key, computed, value, kind, isStatic) {
	        this.type = syntax_1.Syntax.MethodDefinition;
	        this.key = key;
	        this.computed = computed;
	        this.value = value;
	        this.kind = kind;
	        this.static = isStatic;
	    }
	    return MethodDefinition;
	}());
	exports.MethodDefinition = MethodDefinition;
	var NewExpression = (function () {
	    function NewExpression(callee, args) {
	        this.type = syntax_1.Syntax.NewExpression;
	        this.callee = callee;
	        this.arguments = args;
	    }
	    return NewExpression;
	}());
	exports.NewExpression = NewExpression;
	var ObjectExpression = (function () {
	    function ObjectExpression(properties) {
	        this.type = syntax_1.Syntax.ObjectExpression;
	        this.properties = properties;
	    }
	    return ObjectExpression;
	}());
	exports.ObjectExpression = ObjectExpression;
	var ObjectPattern = (function () {
	    function ObjectPattern(properties) {
	        this.type = syntax_1.Syntax.ObjectPattern;
	        this.properties = properties;
	    }
	    return ObjectPattern;
	}());
	exports.ObjectPattern = ObjectPattern;
	var Program = (function () {
	    function Program(body, sourceType) {
	        this.type = syntax_1.Syntax.Program;
	        this.body = body;
	        this.sourceType = sourceType;
	    }
	    return Program;
	}());
	exports.Program = Program;
	var Property = (function () {
	    function Property(kind, key, computed, value, method, shorthand) {
	        this.type = syntax_1.Syntax.Property;
	        this.key = key;
	        this.computed = computed;
	        this.value = value;
	        this.kind = kind;
	        this.method = method;
	        this.shorthand = shorthand;
	    }
	    return Property;
	}());
	exports.Property = Property;
	var RegexLiteral = (function () {
	    function RegexLiteral(value, raw, regex) {
	        this.type = syntax_1.Syntax.Literal;
	        this.value = value;
	        this.raw = raw;
	        this.regex = regex;
	    }
	    return RegexLiteral;
	}());
	exports.RegexLiteral = RegexLiteral;
	var RestElement = (function () {
	    function RestElement(argument) {
	        this.type = syntax_1.Syntax.RestElement;
	        this.argument = argument;
	    }
	    return RestElement;
	}());
	exports.RestElement = RestElement;
	var ReturnStatement = (function () {
	    function ReturnStatement(argument) {
	        this.type = syntax_1.Syntax.ReturnStatement;
	        this.argument = argument;
	    }
	    return ReturnStatement;
	}());
	exports.ReturnStatement = ReturnStatement;
	var SequenceExpression = (function () {
	    function SequenceExpression(expressions) {
	        this.type = syntax_1.Syntax.SequenceExpression;
	        this.expressions = expressions;
	    }
	    return SequenceExpression;
	}());
	exports.SequenceExpression = SequenceExpression;
	var SpreadElement = (function () {
	    function SpreadElement(argument) {
	        this.type = syntax_1.Syntax.SpreadElement;
	        this.argument = argument;
	    }
	    return SpreadElement;
	}());
	exports.SpreadElement = SpreadElement;
	var StaticMemberExpression = (function () {
	    function StaticMemberExpression(object, property) {
	        this.type = syntax_1.Syntax.MemberExpression;
	        this.computed = false;
	        this.object = object;
	        this.property = property;
	    }
	    return StaticMemberExpression;
	}());
	exports.StaticMemberExpression = StaticMemberExpression;
	var Super = (function () {
	    function Super() {
	        this.type = syntax_1.Syntax.Super;
	    }
	    return Super;
	}());
	exports.Super = Super;
	var SwitchCase = (function () {
	    function SwitchCase(test, consequent) {
	        this.type = syntax_1.Syntax.SwitchCase;
	        this.test = test;
	        this.consequent = consequent;
	    }
	    return SwitchCase;
	}());
	exports.SwitchCase = SwitchCase;
	var SwitchStatement = (function () {
	    function SwitchStatement(discriminant, cases) {
	        this.type = syntax_1.Syntax.SwitchStatement;
	        this.discriminant = discriminant;
	        this.cases = cases;
	    }
	    return SwitchStatement;
	}());
	exports.SwitchStatement = SwitchStatement;
	var TaggedTemplateExpression = (function () {
	    function TaggedTemplateExpression(tag, quasi) {
	        this.type = syntax_1.Syntax.TaggedTemplateExpression;
	        this.tag = tag;
	        this.quasi = quasi;
	    }
	    return TaggedTemplateExpression;
	}());
	exports.TaggedTemplateExpression = TaggedTemplateExpression;
	var TemplateElement = (function () {
	    function TemplateElement(value, tail) {
	        this.type = syntax_1.Syntax.TemplateElement;
	        this.value = value;
	        this.tail = tail;
	    }
	    return TemplateElement;
	}());
	exports.TemplateElement = TemplateElement;
	var TemplateLiteral = (function () {
	    function TemplateLiteral(quasis, expressions) {
	        this.type = syntax_1.Syntax.TemplateLiteral;
	        this.quasis = quasis;
	        this.expressions = expressions;
	    }
	    return TemplateLiteral;
	}());
	exports.TemplateLiteral = TemplateLiteral;
	var ThisExpression = (function () {
	    function ThisExpression() {
	        this.type = syntax_1.Syntax.ThisExpression;
	    }
	    return ThisExpression;
	}());
	exports.ThisExpression = ThisExpression;
	var ThrowStatement = (function () {
	    function ThrowStatement(argument) {
	        this.type = syntax_1.Syntax.ThrowStatement;
	        this.argument = argument;
	    }
	    return ThrowStatement;
	}());
	exports.ThrowStatement = ThrowStatement;
	var TryStatement = (function () {
	    function TryStatement(block, handler, finalizer) {
	        this.type = syntax_1.Syntax.TryStatement;
	        this.block = block;
	        this.handler = handler;
	        this.finalizer = finalizer;
	    }
	    return TryStatement;
	}());
	exports.TryStatement = TryStatement;
	var UnaryExpression = (function () {
	    function UnaryExpression(operator, argument) {
	        this.type = syntax_1.Syntax.UnaryExpression;
	        this.operator = operator;
	        this.argument = argument;
	        this.prefix = true;
	    }
	    return UnaryExpression;
	}());
	exports.UnaryExpression = UnaryExpression;
	var UpdateExpression = (function () {
	    function UpdateExpression(operator, argument, prefix) {
	        this.type = syntax_1.Syntax.UpdateExpression;
	        this.operator = operator;
	        this.argument = argument;
	        this.prefix = prefix;
	    }
	    return UpdateExpression;
	}());
	exports.UpdateExpression = UpdateExpression;
	var VariableDeclaration = (function () {
	    function VariableDeclaration(declarations, kind) {
	        this.type = syntax_1.Syntax.VariableDeclaration;
	        this.declarations = declarations;
	        this.kind = kind;
	    }
	    return VariableDeclaration;
	}());
	exports.VariableDeclaration = VariableDeclaration;
	var VariableDeclarator = (function () {
	    function VariableDeclarator(id, init) {
	        this.type = syntax_1.Syntax.VariableDeclarator;
	        this.id = id;
	        this.init = init;
	    }
	    return VariableDeclarator;
	}());
	exports.VariableDeclarator = VariableDeclarator;
	var WhileStatement = (function () {
	    function WhileStatement(test, body) {
	        this.type = syntax_1.Syntax.WhileStatement;
	        this.test = test;
	        this.body = body;
	    }
	    return WhileStatement;
	}());
	exports.WhileStatement = WhileStatement;
	var WithStatement = (function () {
	    function WithStatement(object, body) {
	        this.type = syntax_1.Syntax.WithStatement;
	        this.object = object;
	        this.body = body;
	    }
	    return WithStatement;
	}());
	exports.WithStatement = WithStatement;
	var YieldExpression = (function () {
	    function YieldExpression(argument, delegate) {
	        this.type = syntax_1.Syntax.YieldExpression;
	        this.argument = argument;
	        this.delegate = delegate;
	    }
	    return YieldExpression;
	}());
	exports.YieldExpression = YieldExpression;


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
/* istanbul ignore next */
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var character_1 = __webpack_require__(9);
	var token_1 = __webpack_require__(7);
	var parser_1 = __webpack_require__(3);
	var xhtml_entities_1 = __webpack_require__(12);
	var jsx_syntax_1 = __webpack_require__(13);
	var Node = __webpack_require__(10);
	var JSXNode = __webpack_require__(14);
	var JSXToken;
	(function (JSXToken) {
	    JSXToken[JSXToken["Identifier"] = 100] = "Identifier";
	    JSXToken[JSXToken["Text"] = 101] = "Text";
	})(JSXToken || (JSXToken = {}));
	token_1.TokenName[JSXToken.Identifier] = 'JSXIdentifier';
	token_1.TokenName[JSXToken.Text] = 'JSXText';
	// Fully qualified element name, e.g. <svg:path> returns "svg:path"
	function getQualifiedElementName(elementName) {
	    var qualifiedName;
	    switch (elementName.type) {
	        case jsx_syntax_1.JSXSyntax.JSXIdentifier:
	            var id = (elementName);
	            qualifiedName = id.name;
	            break;
	        case jsx_syntax_1.JSXSyntax.JSXNamespacedName:
	            var ns = (elementName);
	            qualifiedName = getQualifiedElementName(ns.namespace) + ':' +
	                getQualifiedElementName(ns.name);
	            break;
	        case jsx_syntax_1.JSXSyntax.JSXMemberExpression:
	            var expr = (elementName);
	            qualifiedName = getQualifiedElementName(expr.object) + '.' +
	                getQualifiedElementName(expr.property);
	            break;
	    }
	    return qualifiedName;
	}
	var JSXParser = (function (_super) {
	    __extends(JSXParser, _super);
	    function JSXParser(code, options, delegate) {
	        _super.call(this, code, options, delegate);
	    }
	    JSXParser.prototype.parsePrimaryExpression = function () {
	        return this.match('<') ? this.parseJSXRoot() : _super.prototype.parsePrimaryExpression.call(this);
	    };
	    JSXParser.prototype.startJSX = function () {
	        // Unwind the scanner before the lookahead token.
	        this.scanner.index = this.startMarker.index;
	        this.scanner.lineNumber = this.startMarker.lineNumber;
	        this.scanner.lineStart = this.startMarker.lineStart;
	    };
	    JSXParser.prototype.finishJSX = function () {
	        // Prime the next lookahead.
	        this.nextToken();
	    };
	    JSXParser.prototype.reenterJSX = function () {
	        this.startJSX();
	        this.expectJSX('}');
	        // Pop the closing '}' added from the lookahead.
	        if (this.config.tokens) {
	            this.tokens.pop();
	        }
	    };
	    JSXParser.prototype.createJSXNode = function () {
	        this.collectComments();
	        return {
	            index: this.scanner.index,
	            line: this.scanner.lineNumber,
	            column: this.scanner.index - this.scanner.lineStart
	        };
	    };
	    JSXParser.prototype.createJSXChildNode = function () {
	        return {
	            index: this.scanner.index,
	            line: this.scanner.lineNumber,
	            column: this.scanner.index - this.scanner.lineStart
	        };
	    };
	    JSXParser.prototype.scanXHTMLEntity = function (quote) {
	        var result = '&';
	        var valid = true;
	        var terminated = false;
	        var numeric = false;
	        var hex = false;
	        while (!this.scanner.eof() && valid && !terminated) {
	            var ch = this.scanner.source[this.scanner.index];
	            if (ch === quote) {
	                break;
	            }
	            terminated = (ch === ';');
	            result += ch;
	            ++this.scanner.index;
	            if (!terminated) {
	                switch (result.length) {
	                    case 2:
	                        // e.g. '&#123;'
	                        numeric = (ch === '#');
	                        break;
	                    case 3:
	                        if (numeric) {
	                            // e.g. '&#x41;'
	                            hex = (ch === 'x');
	                            valid = hex || character_1.Character.isDecimalDigit(ch.charCodeAt(0));
	                            numeric = numeric && !hex;
	                        }
	                        break;
	                    default:
	                        valid = valid && !(numeric && !character_1.Character.isDecimalDigit(ch.charCodeAt(0)));
	                        valid = valid && !(hex && !character_1.Character.isHexDigit(ch.charCodeAt(0)));
	                        break;
	                }
	            }
	        }
	        if (valid && terminated && result.length > 2) {
	            // e.g. '&#x41;' becomes just '#x41'
	            var str = result.substr(1, result.length - 2);
	            if (numeric && str.length > 1) {
	                result = String.fromCharCode(parseInt(str.substr(1), 10));
	            }
	            else if (hex && str.length > 2) {
	                result = String.fromCharCode(parseInt('0' + str.substr(1), 16));
	            }
	            else if (!numeric && !hex && xhtml_entities_1.XHTMLEntities[str]) {
	                result = xhtml_entities_1.XHTMLEntities[str];
	            }
	        }
	        return result;
	    };
	    // Scan the next JSX token. This replaces Scanner#lex when in JSX mode.
	    JSXParser.prototype.lexJSX = function () {
	        var cp = this.scanner.source.charCodeAt(this.scanner.index);
	        // < > / : = { }
	        if (cp === 60 || cp === 62 || cp === 47 || cp === 58 || cp === 61 || cp === 123 || cp === 125) {
	            var value = this.scanner.source[this.scanner.index++];
	            return {
	                type: token_1.Token.Punctuator,
	                value: value,
	                lineNumber: this.scanner.lineNumber,
	                lineStart: this.scanner.lineStart,
	                start: this.scanner.index - 1,
	                end: this.scanner.index
	            };
	        }
	        // " '
	        if (cp === 34 || cp === 39) {
	            var start = this.scanner.index;
	            var quote = this.scanner.source[this.scanner.index++];
	            var str = '';
	            while (!this.scanner.eof()) {
	                var ch = this.scanner.source[this.scanner.index++];
	                if (ch === quote) {
	                    break;
	                }
	                else if (ch === '&') {
	                    str += this.scanXHTMLEntity(quote);
	                }
	                else {
	                    str += ch;
	                }
	            }
	            return {
	                type: token_1.Token.StringLiteral,
	                value: str,
	                lineNumber: this.scanner.lineNumber,
	                lineStart: this.scanner.lineStart,
	                start: start,
	                end: this.scanner.index
	            };
	        }
	        // ... or .
	        if (cp === 46) {
	            var n1 = this.scanner.source.charCodeAt(this.scanner.index + 1);
	            var n2 = this.scanner.source.charCodeAt(this.scanner.index + 2);
	            var value = (n1 === 46 && n2 === 46) ? '...' : '.';
	            var start = this.scanner.index;
	            this.scanner.index += value.length;
	            return {
	                type: token_1.Token.Punctuator,
	                value: value,
	                lineNumber: this.scanner.lineNumber,
	                lineStart: this.scanner.lineStart,
	                start: start,
	                end: this.scanner.index
	            };
	        }
	        // `
	        if (cp === 96) {
	            // Only placeholder, since it will be rescanned as a real assignment expression.
	            return {
	                type: token_1.Token.Template,
	                lineNumber: this.scanner.lineNumber,
	                lineStart: this.scanner.lineStart,
	                start: this.scanner.index,
	                end: this.scanner.index
	            };
	        }
	        // Identifer can not contain backslash (char code 92).
	        if (character_1.Character.isIdentifierStart(cp) && (cp !== 92)) {
	            var start = this.scanner.index;
	            ++this.scanner.index;
	            while (!this.scanner.eof()) {
	                var ch = this.scanner.source.charCodeAt(this.scanner.index);
	                if (character_1.Character.isIdentifierPart(ch) && (ch !== 92)) {
	                    ++this.scanner.index;
	                }
	                else if (ch === 45) {
	                    // Hyphen (char code 45) can be part of an identifier.
	                    ++this.scanner.index;
	                }
	                else {
	                    break;
	                }
	            }
	            var id = this.scanner.source.slice(start, this.scanner.index);
	            return {
	                type: JSXToken.Identifier,
	                value: id,
	                lineNumber: this.scanner.lineNumber,
	                lineStart: this.scanner.lineStart,
	                start: start,
	                end: this.scanner.index
	            };
	        }
	        this.scanner.throwUnexpectedToken();
	    };
	    JSXParser.prototype.nextJSXToken = function () {
	        this.collectComments();
	        this.startMarker.index = this.scanner.index;
	        this.startMarker.lineNumber = this.scanner.lineNumber;
	        this.startMarker.lineStart = this.scanner.lineStart;
	        var token = this.lexJSX();
	        this.lastMarker.index = this.scanner.index;
	        this.lastMarker.lineNumber = this.scanner.lineNumber;
	        this.lastMarker.lineStart = this.scanner.lineStart;
	        if (this.config.tokens) {
	            this.tokens.push(this.convertToken(token));
	        }
	        return token;
	    };
	    JSXParser.prototype.nextJSXText = function () {
	        this.startMarker.index = this.scanner.index;
	        this.startMarker.lineNumber = this.scanner.lineNumber;
	        this.startMarker.lineStart = this.scanner.lineStart;
	        var start = this.scanner.index;
	        var text = '';
	        while (!this.scanner.eof()) {
	            var ch = this.scanner.source[this.scanner.index];
	            if (ch === '{' || ch === '<') {
	                break;
	            }
	            ++this.scanner.index;
	            text += ch;
	            if (character_1.Character.isLineTerminator(ch.charCodeAt(0))) {
	                ++this.scanner.lineNumber;
	                if (ch === '\r' && this.scanner.source[this.scanner.index] === '\n') {
	                    ++this.scanner.index;
	                }
	                this.scanner.lineStart = this.scanner.index;
	            }
	        }
	        this.lastMarker.index = this.scanner.index;
	        this.lastMarker.lineNumber = this.scanner.lineNumber;
	        this.lastMarker.lineStart = this.scanner.lineStart;
	        var token = {
	            type: JSXToken.Text,
	            value: text,
	            lineNumber: this.scanner.lineNumber,
	            lineStart: this.scanner.lineStart,
	            start: start,
	            end: this.scanner.index
	        };
	        if ((text.length > 0) && this.config.tokens) {
	            this.tokens.push(this.convertToken(token));
	        }
	        return token;
	    };
	    JSXParser.prototype.peekJSXToken = function () {
	        var previousIndex = this.scanner.index;
	        var previousLineNumber = this.scanner.lineNumber;
	        var previousLineStart = this.scanner.lineStart;
	        this.scanner.scanComments();
	        var next = this.lexJSX();
	        this.scanner.index = previousIndex;
	        this.scanner.lineNumber = previousLineNumber;
	        this.scanner.lineStart = previousLineStart;
	        return next;
	    };
	    // Expect the next JSX token to match the specified punctuator.
	    // If not, an exception will be thrown.
	    JSXParser.prototype.expectJSX = function (value) {
	        var token = this.nextJSXToken();
	        if (token.type !== token_1.Token.Punctuator || token.value !== value) {
	            this.throwUnexpectedToken(token);
	        }
	    };
	    // Return true if the next JSX token matches the specified punctuator.
	    JSXParser.prototype.matchJSX = function (value) {
	        var next = this.peekJSXToken();
	        return next.type === token_1.Token.Punctuator && next.value === value;
	    };
	    JSXParser.prototype.parseJSXIdentifier = function () {
	        var node = this.createJSXNode();
	        var token = this.nextJSXToken();
	        if (token.type !== JSXToken.Identifier) {
	            this.throwUnexpectedToken(token);
	        }
	        return this.finalize(node, new JSXNode.JSXIdentifier(token.value));
	    };
	    JSXParser.prototype.parseJSXElementName = function () {
	        var node = this.createJSXNode();
	        var elementName = this.parseJSXIdentifier();
	        if (this.matchJSX(':')) {
	            var namespace = elementName;
	            this.expectJSX(':');
	            var name_1 = this.parseJSXIdentifier();
	            elementName = this.finalize(node, new JSXNode.JSXNamespacedName(namespace, name_1));
	        }
	        else if (this.matchJSX('.')) {
	            while (this.matchJSX('.')) {
	                var object = elementName;
	                this.expectJSX('.');
	                var property = this.parseJSXIdentifier();
	                elementName = this.finalize(node, new JSXNode.JSXMemberExpression(object, property));
	            }
	        }
	        return elementName;
	    };
	    JSXParser.prototype.parseJSXAttributeName = function () {
	        var node = this.createJSXNode();
	        var attributeName;
	        var identifier = this.parseJSXIdentifier();
	        if (this.matchJSX(':')) {
	            var namespace = identifier;
	            this.expectJSX(':');
	            var name_2 = this.parseJSXIdentifier();
	            attributeName = this.finalize(node, new JSXNode.JSXNamespacedName(namespace, name_2));
	        }
	        else {
	            attributeName = identifier;
	        }
	        return attributeName;
	    };
	    JSXParser.prototype.parseJSXStringLiteralAttribute = function () {
	        var node = this.createJSXNode();
	        var token = this.nextJSXToken();
	        if (token.type !== token_1.Token.StringLiteral) {
	            this.throwUnexpectedToken(token);
	        }
	        var raw = this.getTokenRaw(token);
	        return this.finalize(node, new Node.Literal(token.value, raw));
	    };
	    JSXParser.prototype.parseJSXExpressionAttribute = function () {
	        var node = this.createJSXNode();
	        this.expectJSX('{');
	        this.finishJSX();
	        if (this.match('}')) {
	            this.tolerateError('JSX attributes must only be assigned a non-empty expression');
	        }
	        var expression = this.parseAssignmentExpression();
	        this.reenterJSX();
	        return this.finalize(node, new JSXNode.JSXExpressionContainer(expression));
	    };
	    JSXParser.prototype.parseJSXAttributeValue = function () {
	        return this.matchJSX('{') ? this.parseJSXExpressionAttribute() :
	            this.matchJSX('<') ? this.parseJSXElement() : this.parseJSXStringLiteralAttribute();
	    };
	    JSXParser.prototype.parseJSXNameValueAttribute = function () {
	        var node = this.createJSXNode();
	        var name = this.parseJSXAttributeName();
	        var value = null;
	        if (this.matchJSX('=')) {
	            this.expectJSX('=');
	            value = this.parseJSXAttributeValue();
	        }
	        return this.finalize(node, new JSXNode.JSXAttribute(name, value));
	    };
	    JSXParser.prototype.parseJSXSpreadAttribute = function () {
	        var node = this.createJSXNode();
	        this.expectJSX('{');
	        this.expectJSX('...');
	        this.finishJSX();
	        var argument = this.parseAssignmentExpression();
	        this.reenterJSX();
	        return this.finalize(node, new JSXNode.JSXSpreadAttribute(argument));
	    };
	    JSXParser.prototype.parseJSXAttributes = function () {
	        var attributes = [];
	        while (!this.matchJSX('/') && !this.matchJSX('>')) {
	            var attribute = this.matchJSX('{') ? this.parseJSXSpreadAttribute() :
	                this.parseJSXNameValueAttribute();
	            attributes.push(attribute);
	        }
	        return attributes;
	    };
	    JSXParser.prototype.parseJSXOpeningElement = function () {
	        var node = this.createJSXNode();
	        this.expectJSX('<');
	        var name = this.parseJSXElementName();
	        var attributes = this.parseJSXAttributes();
	        var selfClosing = this.matchJSX('/');
	        if (selfClosing) {
	            this.expectJSX('/');
	        }
	        this.expectJSX('>');
	        return this.finalize(node, new JSXNode.JSXOpeningElement(name, selfClosing, attributes));
	    };
	    JSXParser.prototype.parseJSXBoundaryElement = function () {
	        var node = this.createJSXNode();
	        this.expectJSX('<');
	        if (this.matchJSX('/')) {
	            this.expectJSX('/');
	            var name_3 = this.parseJSXElementName();
	            this.expectJSX('>');
	            return this.finalize(node, new JSXNode.JSXClosingElement(name_3));
	        }
	        var name = this.parseJSXElementName();
	        var attributes = this.parseJSXAttributes();
	        var selfClosing = this.matchJSX('/');
	        if (selfClosing) {
	            this.expectJSX('/');
	        }
	        this.expectJSX('>');
	        return this.finalize(node, new JSXNode.JSXOpeningElement(name, selfClosing, attributes));
	    };
	    JSXParser.prototype.parseJSXEmptyExpression = function () {
	        var node = this.createJSXChildNode();
	        this.collectComments();
	        this.lastMarker.index = this.scanner.index;
	        this.lastMarker.lineNumber = this.scanner.lineNumber;
	        this.lastMarker.lineStart = this.scanner.lineStart;
	        return this.finalize(node, new JSXNode.JSXEmptyExpression());
	    };
	    JSXParser.prototype.parseJSXExpressionContainer = function () {
	        var node = this.createJSXNode();
	        this.expectJSX('{');
	        var expression;
	        if (this.matchJSX('}')) {
	            expression = this.parseJSXEmptyExpression();
	            this.expectJSX('}');
	        }
	        else {
	            this.finishJSX();
	            expression = this.parseAssignmentExpression();
	            this.reenterJSX();
	        }
	        return this.finalize(node, new JSXNode.JSXExpressionContainer(expression));
	    };
	    JSXParser.prototype.parseJSXChildren = function () {
	        var children = [];
	        while (!this.scanner.eof()) {
	            var node = this.createJSXChildNode();
	            var token = this.nextJSXText();
	            if (token.start < token.end) {
	                var raw = this.getTokenRaw(token);
	                var child = this.finalize(node, new JSXNode.JSXText(token.value, raw));
	                children.push(child);
	            }
	            if (this.scanner.source[this.scanner.index] === '{') {
	                var container = this.parseJSXExpressionContainer();
	                children.push(container);
	            }
	            else {
	                break;
	            }
	        }
	        return children;
	    };
	    JSXParser.prototype.parseComplexJSXElement = function (el) {
	        var stack = [];
	        while (!this.scanner.eof()) {
	            el.children = el.children.concat(this.parseJSXChildren());
	            var node = this.createJSXChildNode();
	            var element = this.parseJSXBoundaryElement();
	            if (element.type === jsx_syntax_1.JSXSyntax.JSXOpeningElement) {
	                var opening = (element);
	                if (opening.selfClosing) {
	                    var child = this.finalize(node, new JSXNode.JSXElement(opening, [], null));
	                    el.children.push(child);
	                }
	                else {
	                    stack.push(el);
	                    el = { node: node, opening: opening, closing: null, children: [] };
	                }
	            }
	            if (element.type === jsx_syntax_1.JSXSyntax.JSXClosingElement) {
	                el.closing = (element);
	                var open_1 = getQualifiedElementName(el.opening.name);
	                var close_1 = getQualifiedElementName(el.closing.name);
	                if (open_1 !== close_1) {
	                    this.tolerateError('Expected corresponding JSX closing tag for %0', open_1);
	                }
	                if (stack.length > 0) {
	                    var child = this.finalize(el.node, new JSXNode.JSXElement(el.opening, el.children, el.closing));
	                    el = stack.pop();
	                    el.children.push(child);
	                }
	                else {
	                    break;
	                }
	            }
	        }
	        return el;
	    };
	    JSXParser.prototype.parseJSXElement = function () {
	        var node = this.createJSXNode();
	        var opening = this.parseJSXOpeningElement();
	        var children = [];
	        var closing = null;
	        if (!opening.selfClosing) {
	            var el = this.parseComplexJSXElement({ node: node, opening: opening, closing: closing, children: children });
	            children = el.children;
	            closing = el.closing;
	        }
	        return this.finalize(node, new JSXNode.JSXElement(opening, children, closing));
	    };
	    JSXParser.prototype.parseJSXRoot = function () {
	        // Pop the opening '<' added from the lookahead.
	        if (this.config.tokens) {
	            this.tokens.pop();
	        }
	        this.startJSX();
	        var element = this.parseJSXElement();
	        this.finishJSX();
	        return element;
	    };
	    return JSXParser;
	}(parser_1.Parser));
	exports.JSXParser = JSXParser;


/***/ },
/* 12 */
/***/ function(module, exports) {

	// Generated by generate-xhtml-entities.js. DO NOT MODIFY!
	"use strict";
	exports.XHTMLEntities = {
	    quot: '\u0022',
	    amp: '\u0026',
	    apos: '\u0027',
	    gt: '\u003E',
	    nbsp: '\u00A0',
	    iexcl: '\u00A1',
	    cent: '\u00A2',
	    pound: '\u00A3',
	    curren: '\u00A4',
	    yen: '\u00A5',
	    brvbar: '\u00A6',
	    sect: '\u00A7',
	    uml: '\u00A8',
	    copy: '\u00A9',
	    ordf: '\u00AA',
	    laquo: '\u00AB',
	    not: '\u00AC',
	    shy: '\u00AD',
	    reg: '\u00AE',
	    macr: '\u00AF',
	    deg: '\u00B0',
	    plusmn: '\u00B1',
	    sup2: '\u00B2',
	    sup3: '\u00B3',
	    acute: '\u00B4',
	    micro: '\u00B5',
	    para: '\u00B6',
	    middot: '\u00B7',
	    cedil: '\u00B8',
	    sup1: '\u00B9',
	    ordm: '\u00BA',
	    raquo: '\u00BB',
	    frac14: '\u00BC',
	    frac12: '\u00BD',
	    frac34: '\u00BE',
	    iquest: '\u00BF',
	    Agrave: '\u00C0',
	    Aacute: '\u00C1',
	    Acirc: '\u00C2',
	    Atilde: '\u00C3',
	    Auml: '\u00C4',
	    Aring: '\u00C5',
	    AElig: '\u00C6',
	    Ccedil: '\u00C7',
	    Egrave: '\u00C8',
	    Eacute: '\u00C9',
	    Ecirc: '\u00CA',
	    Euml: '\u00CB',
	    Igrave: '\u00CC',
	    Iacute: '\u00CD',
	    Icirc: '\u00CE',
	    Iuml: '\u00CF',
	    ETH: '\u00D0',
	    Ntilde: '\u00D1',
	    Ograve: '\u00D2',
	    Oacute: '\u00D3',
	    Ocirc: '\u00D4',
	    Otilde: '\u00D5',
	    Ouml: '\u00D6',
	    times: '\u00D7',
	    Oslash: '\u00D8',
	    Ugrave: '\u00D9',
	    Uacute: '\u00DA',
	    Ucirc: '\u00DB',
	    Uuml: '\u00DC',
	    Yacute: '\u00DD',
	    THORN: '\u00DE',
	    szlig: '\u00DF',
	    agrave: '\u00E0',
	    aacute: '\u00E1',
	    acirc: '\u00E2',
	    atilde: '\u00E3',
	    auml: '\u00E4',
	    aring: '\u00E5',
	    aelig: '\u00E6',
	    ccedil: '\u00E7',
	    egrave: '\u00E8',
	    eacute: '\u00E9',
	    ecirc: '\u00EA',
	    euml: '\u00EB',
	    igrave: '\u00EC',
	    iacute: '\u00ED',
	    icirc: '\u00EE',
	    iuml: '\u00EF',
	    eth: '\u00F0',
	    ntilde: '\u00F1',
	    ograve: '\u00F2',
	    oacute: '\u00F3',
	    ocirc: '\u00F4',
	    otilde: '\u00F5',
	    ouml: '\u00F6',
	    divide: '\u00F7',
	    oslash: '\u00F8',
	    ugrave: '\u00F9',
	    uacute: '\u00FA',
	    ucirc: '\u00FB',
	    uuml: '\u00FC',
	    yacute: '\u00FD',
	    thorn: '\u00FE',
	    yuml: '\u00FF',
	    OElig: '\u0152',
	    oelig: '\u0153',
	    Scaron: '\u0160',
	    scaron: '\u0161',
	    Yuml: '\u0178',
	    fnof: '\u0192',
	    circ: '\u02C6',
	    tilde: '\u02DC',
	    Alpha: '\u0391',
	    Beta: '\u0392',
	    Gamma: '\u0393',
	    Delta: '\u0394',
	    Epsilon: '\u0395',
	    Zeta: '\u0396',
	    Eta: '\u0397',
	    Theta: '\u0398',
	    Iota: '\u0399',
	    Kappa: '\u039A',
	    Lambda: '\u039B',
	    Mu: '\u039C',
	    Nu: '\u039D',
	    Xi: '\u039E',
	    Omicron: '\u039F',
	    Pi: '\u03A0',
	    Rho: '\u03A1',
	    Sigma: '\u03A3',
	    Tau: '\u03A4',
	    Upsilon: '\u03A5',
	    Phi: '\u03A6',
	    Chi: '\u03A7',
	    Psi: '\u03A8',
	    Omega: '\u03A9',
	    alpha: '\u03B1',
	    beta: '\u03B2',
	    gamma: '\u03B3',
	    delta: '\u03B4',
	    epsilon: '\u03B5',
	    zeta: '\u03B6',
	    eta: '\u03B7',
	    theta: '\u03B8',
	    iota: '\u03B9',
	    kappa: '\u03BA',
	    lambda: '\u03BB',
	    mu: '\u03BC',
	    nu: '\u03BD',
	    xi: '\u03BE',
	    omicron: '\u03BF',
	    pi: '\u03C0',
	    rho: '\u03C1',
	    sigmaf: '\u03C2',
	    sigma: '\u03C3',
	    tau: '\u03C4',
	    upsilon: '\u03C5',
	    phi: '\u03C6',
	    chi: '\u03C7',
	    psi: '\u03C8',
	    omega: '\u03C9',
	    thetasym: '\u03D1',
	    upsih: '\u03D2',
	    piv: '\u03D6',
	    ensp: '\u2002',
	    emsp: '\u2003',
	    thinsp: '\u2009',
	    zwnj: '\u200C',
	    zwj: '\u200D',
	    lrm: '\u200E',
	    rlm: '\u200F',
	    ndash: '\u2013',
	    mdash: '\u2014',
	    lsquo: '\u2018',
	    rsquo: '\u2019',
	    sbquo: '\u201A',
	    ldquo: '\u201C',
	    rdquo: '\u201D',
	    bdquo: '\u201E',
	    dagger: '\u2020',
	    Dagger: '\u2021',
	    bull: '\u2022',
	    hellip: '\u2026',
	    permil: '\u2030',
	    prime: '\u2032',
	    Prime: '\u2033',
	    lsaquo: '\u2039',
	    rsaquo: '\u203A',
	    oline: '\u203E',
	    frasl: '\u2044',
	    euro: '\u20AC',
	    image: '\u2111',
	    weierp: '\u2118',
	    real: '\u211C',
	    trade: '\u2122',
	    alefsym: '\u2135',
	    larr: '\u2190',
	    uarr: '\u2191',
	    rarr: '\u2192',
	    darr: '\u2193',
	    harr: '\u2194',
	    crarr: '\u21B5',
	    lArr: '\u21D0',
	    uArr: '\u21D1',
	    rArr: '\u21D2',
	    dArr: '\u21D3',
	    hArr: '\u21D4',
	    forall: '\u2200',
	    part: '\u2202',
	    exist: '\u2203',
	    empty: '\u2205',
	    nabla: '\u2207',
	    isin: '\u2208',
	    notin: '\u2209',
	    ni: '\u220B',
	    prod: '\u220F',
	    sum: '\u2211',
	    minus: '\u2212',
	    lowast: '\u2217',
	    radic: '\u221A',
	    prop: '\u221D',
	    infin: '\u221E',
	    ang: '\u2220',
	    and: '\u2227',
	    or: '\u2228',
	    cap: '\u2229',
	    cup: '\u222A',
	    int: '\u222B',
	    there4: '\u2234',
	    sim: '\u223C',
	    cong: '\u2245',
	    asymp: '\u2248',
	    ne: '\u2260',
	    equiv: '\u2261',
	    le: '\u2264',
	    ge: '\u2265',
	    sub: '\u2282',
	    sup: '\u2283',
	    nsub: '\u2284',
	    sube: '\u2286',
	    supe: '\u2287',
	    oplus: '\u2295',
	    otimes: '\u2297',
	    perp: '\u22A5',
	    sdot: '\u22C5',
	    lceil: '\u2308',
	    rceil: '\u2309',
	    lfloor: '\u230A',
	    rfloor: '\u230B',
	    loz: '\u25CA',
	    spades: '\u2660',
	    clubs: '\u2663',
	    hearts: '\u2665',
	    diams: '\u2666',
	    lang: '\u27E8',
	    rang: '\u27E9'
	};


/***/ },
/* 13 */
/***/ function(module, exports) {

	"use strict";
	exports.JSXSyntax = {
	    JSXAttribute: 'JSXAttribute',
	    JSXClosingElement: 'JSXClosingElement',
	    JSXElement: 'JSXElement',
	    JSXEmptyExpression: 'JSXEmptyExpression',
	    JSXExpressionContainer: 'JSXExpressionContainer',
	    JSXIdentifier: 'JSXIdentifier',
	    JSXMemberExpression: 'JSXMemberExpression',
	    JSXNamespacedName: 'JSXNamespacedName',
	    JSXOpeningElement: 'JSXOpeningElement',
	    JSXSpreadAttribute: 'JSXSpreadAttribute',
	    JSXText: 'JSXText'
	};


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var jsx_syntax_1 = __webpack_require__(13);
	var JSXClosingElement = (function () {
	    function JSXClosingElement(name) {
	        this.type = jsx_syntax_1.JSXSyntax.JSXClosingElement;
	        this.name = name;
	    }
	    return JSXClosingElement;
	}());
	exports.JSXClosingElement = JSXClosingElement;
	var JSXElement = (function () {
	    function JSXElement(openingElement, children, closingElement) {
	        this.type = jsx_syntax_1.JSXSyntax.JSXElement;
	        this.openingElement = openingElement;
	        this.children = children;
	        this.closingElement = closingElement;
	    }
	    return JSXElement;
	}());
	exports.JSXElement = JSXElement;
	var JSXEmptyExpression = (function () {
	    function JSXEmptyExpression() {
	        this.type = jsx_syntax_1.JSXSyntax.JSXEmptyExpression;
	    }
	    return JSXEmptyExpression;
	}());
	exports.JSXEmptyExpression = JSXEmptyExpression;
	var JSXExpressionContainer = (function () {
	    function JSXExpressionContainer(expression) {
	        this.type = jsx_syntax_1.JSXSyntax.JSXExpressionContainer;
	        this.expression = expression;
	    }
	    return JSXExpressionContainer;
	}());
	exports.JSXExpressionContainer = JSXExpressionContainer;
	var JSXIdentifier = (function () {
	    function JSXIdentifier(name) {
	        this.type = jsx_syntax_1.JSXSyntax.JSXIdentifier;
	        this.name = name;
	    }
	    return JSXIdentifier;
	}());
	exports.JSXIdentifier = JSXIdentifier;
	var JSXMemberExpression = (function () {
	    function JSXMemberExpression(object, property) {
	        this.type = jsx_syntax_1.JSXSyntax.JSXMemberExpression;
	        this.object = object;
	        this.property = property;
	    }
	    return JSXMemberExpression;
	}());
	exports.JSXMemberExpression = JSXMemberExpression;
	var JSXAttribute = (function () {
	    function JSXAttribute(name, value) {
	        this.type = jsx_syntax_1.JSXSyntax.JSXAttribute;
	        this.name = name;
	        this.value = value;
	    }
	    return JSXAttribute;
	}());
	exports.JSXAttribute = JSXAttribute;
	var JSXNamespacedName = (function () {
	    function JSXNamespacedName(namespace, name) {
	        this.type = jsx_syntax_1.JSXSyntax.JSXNamespacedName;
	        this.namespace = namespace;
	        this.name = name;
	    }
	    return JSXNamespacedName;
	}());
	exports.JSXNamespacedName = JSXNamespacedName;
	var JSXOpeningElement = (function () {
	    function JSXOpeningElement(name, selfClosing, attributes) {
	        this.type = jsx_syntax_1.JSXSyntax.JSXOpeningElement;
	        this.name = name;
	        this.selfClosing = selfClosing;
	        this.attributes = attributes;
	    }
	    return JSXOpeningElement;
	}());
	exports.JSXOpeningElement = JSXOpeningElement;
	var JSXSpreadAttribute = (function () {
	    function JSXSpreadAttribute(argument) {
	        this.type = jsx_syntax_1.JSXSyntax.JSXSpreadAttribute;
	        this.argument = argument;
	    }
	    return JSXSpreadAttribute;
	}());
	exports.JSXSpreadAttribute = JSXSpreadAttribute;
	var JSXText = (function () {
	    function JSXText(value, raw) {
	        this.type = jsx_syntax_1.JSXSyntax.JSXText;
	        this.value = value;
	        this.raw = raw;
	    }
	    return JSXText;
	}());
	exports.JSXText = JSXText;


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var scanner_1 = __webpack_require__(8);
	var error_handler_1 = __webpack_require__(6);
	var token_1 = __webpack_require__(7);
	var Reader = (function () {
	    function Reader() {
	        this.values = [];
	        this.curly = this.paren = -1;
	    }
	    ;
	    // A function following one of those tokens is an expression.
	    Reader.prototype.beforeFunctionExpression = function (t) {
	        return ['(', '{', '[', 'in', 'typeof', 'instanceof', 'new',
	            'return', 'case', 'delete', 'throw', 'void',
	            // assignment operators
	            '=', '+=', '-=', '*=', '**=', '/=', '%=', '<<=', '>>=', '>>>=',
	            '&=', '|=', '^=', ',',
	            // binary/unary operators
	            '+', '-', '*', '**', '/', '%', '++', '--', '<<', '>>', '>>>', '&',
	            '|', '^', '!', '~', '&&', '||', '?', ':', '===', '==', '>=',
	            '<=', '<', '>', '!=', '!=='].indexOf(t) >= 0;
	    };
	    ;
	    // Determine if forward slash (/) is an operator or part of a regular expression
	    // https://github.com/mozilla/sweet.js/wiki/design
	    Reader.prototype.isRegexStart = function () {
	        var previous = this.values[this.values.length - 1];
	        var regex = (previous !== null);
	        switch (previous) {
	            case 'this':
	            case ']':
	                regex = false;
	                break;
	            case ')':
	                var check = this.values[this.paren - 1];
	                regex = (check === 'if' || check === 'while' || check === 'for' || check === 'with');
	                break;
	            case '}':
	                // Dividing a function by anything makes little sense,
	                // but we have to check for that.
	                regex = false;
	                if (this.values[this.curly - 3] === 'function') {
	                    // Anonymous function, e.g. function(){} /42
	                    var check_1 = this.values[this.curly - 4];
	                    regex = check_1 ? !this.beforeFunctionExpression(check_1) : false;
	                }
	                else if (this.values[this.curly - 4] === 'function') {
	                    // Named function, e.g. function f(){} /42/
	                    var check_2 = this.values[this.curly - 5];
	                    regex = check_2 ? !this.beforeFunctionExpression(check_2) : true;
	                }
	        }
	        return regex;
	    };
	    ;
	    Reader.prototype.push = function (token) {
	        if (token.type === token_1.Token.Punctuator || token.type === token_1.Token.Keyword) {
	            if (token.value === '{') {
	                this.curly = this.values.length;
	            }
	            else if (token.value === '(') {
	                this.paren = this.values.length;
	            }
	            this.values.push(token.value);
	        }
	        else {
	            this.values.push(null);
	        }
	    };
	    ;
	    return Reader;
	}());
	var Tokenizer = (function () {
	    function Tokenizer(code, config) {
	        this.errorHandler = new error_handler_1.ErrorHandler();
	        this.errorHandler.tolerant = config ? (typeof config.tolerant === 'boolean' && config.tolerant) : false;
	        this.scanner = new scanner_1.Scanner(code, this.errorHandler);
	        this.scanner.trackComment = config ? (typeof config.comment === 'boolean' && config.comment) : false;
	        this.trackRange = config ? (typeof config.range === 'boolean' && config.range) : false;
	        this.trackLoc = config ? (typeof config.loc === 'boolean' && config.loc) : false;
	        this.buffer = [];
	        this.reader = new Reader();
	    }
	    ;
	    Tokenizer.prototype.errors = function () {
	        return this.errorHandler.errors;
	    };
	    ;
	    Tokenizer.prototype.getNextToken = function () {
	        if (this.buffer.length === 0) {
	            var comments = this.scanner.scanComments();
	            if (this.scanner.trackComment) {
	                for (var i = 0; i < comments.length; ++i) {
	                    var e = comments[i];
	                    var comment = void 0;
	                    var value = this.scanner.source.slice(e.slice[0], e.slice[1]);
	                    comment = {
	                        type: e.multiLine ? 'BlockComment' : 'LineComment',
	                        value: value
	                    };
	                    if (this.trackRange) {
	                        comment.range = e.range;
	                    }
	                    if (this.trackLoc) {
	                        comment.loc = e.loc;
	                    }
	                    this.buffer.push(comment);
	                }
	            }
	            if (!this.scanner.eof()) {
	                var loc = void 0;
	                if (this.trackLoc) {
	                    loc = {
	                        start: {
	                            line: this.scanner.lineNumber,
	                            column: this.scanner.index - this.scanner.lineStart
	                        },
	                        end: {}
	                    };
	                }
	                var token = void 0;
	                if (this.scanner.source[this.scanner.index] === '/') {
	                    token = this.reader.isRegexStart() ? this.scanner.scanRegExp() : this.scanner.scanPunctuator();
	                }
	                else {
	                    token = this.scanner.lex();
	                }
	                this.reader.push(token);
	                var entry = void 0;
	                entry = {
	                    type: token_1.TokenName[token.type],
	                    value: this.scanner.source.slice(token.start, token.end)
	                };
	                if (this.trackRange) {
	                    entry.range = [token.start, token.end];
	                }
	                if (this.trackLoc) {
	                    loc.end = {
	                        line: this.scanner.lineNumber,
	                        column: this.scanner.index - this.scanner.lineStart
	                    };
	                    entry.loc = loc;
	                }
	                if (token.regex) {
	                    entry.regex = token.regex;
	                }
	                this.buffer.push(entry);
	            }
	        }
	        return this.buffer.shift();
	    };
	    ;
	    return Tokenizer;
	}());
	exports.Tokenizer = Tokenizer;


/***/ }
/******/ ])
});
;

/***/ }),
/* 531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

module.exports = {
  BACKSPACE: 8,
  TAB: 9,
  RETURN: 13,
  ALT: 18,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46,
  COMMA: 188,
  PERIOD: 190,
  A: 65,
  Z: 90,
  ZERO: 48,
  NUMPAD_0: 96,
  NUMPAD_9: 105
};

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var getStyleProperty = __webpack_require__(2339);

/**
 * @param {DOMNode} element [description]
 * @param {string} name Overflow style property name.
 * @return {boolean} True if the supplied ndoe is scrollable.
 */
function _isNodeScrollable(element, name) {
  var overflow = Style.get(element, name);
  return overflow === 'auto' || overflow === 'scroll';
}

/**
 * Utilities for querying and mutating style properties.
 */
var Style = {
  /**
   * Gets the style property for the supplied node. This will return either the
   * computed style, if available, or the declared style.
   *
   * @param {DOMNode} node
   * @param {string} name Style property name.
   * @return {?string} Style property value.
   */
  get: getStyleProperty,

  /**
   * Determines the nearest ancestor of a node that is scrollable.
   *
   * NOTE: This can be expensive if used repeatedly or on a node nested deeply.
   *
   * @param {?DOMNode} node Node from which to start searching.
   * @return {?DOMWindow|DOMElement} Scroll parent of the supplied node.
   */
  getScrollParent: function getScrollParent(node) {
    if (!node) {
      return null;
    }
    var ownerDocument = node.ownerDocument;
    while (node && node !== ownerDocument.body) {
      if (_isNodeScrollable(node, 'overflow') || _isNodeScrollable(node, 'overflowY') || _isNodeScrollable(node, 'overflowX')) {
        return node;
      }
      node = node.parentNode;
    }
    return ownerDocument.defaultView || ownerDocument.parentWindow;
  }

};

module.exports = Style;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Constants to represent text directionality
 *
 * Also defines a *global* direciton, to be used in bidi algorithms as a
 * default fallback direciton, when no better direction is found or provided.
 *
 * NOTE: Use `setGlobalDir()`, or update `initGlobalDir()`, to set the initial
 *       global direction value based on the application.
 *
 * Part of the implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */



var invariant = __webpack_require__(23);

var NEUTRAL = 'NEUTRAL'; // No strong direction
var LTR = 'LTR'; // Left-to-Right direction
var RTL = 'RTL'; // Right-to-Left direction

var globalDir = null;

// == Helpers ==

/**
 * Check if a directionality value is a Strong one
 */
function isStrong(dir) {
  return dir === LTR || dir === RTL;
}

/**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property.
 */
function getHTMLDir(dir) {
  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  return dir === LTR ? 'ltr' : 'rtl';
}

/**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property, but returns null if `dir` has same value as `otherDir`.
 * `null`.
 */
function getHTMLDirIfDifferent(dir, otherDir) {
  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  !isStrong(otherDir) ?  false ? invariant(false, '`otherDir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  return dir === otherDir ? null : getHTMLDir(dir);
}

// == Global Direction ==

/**
 * Set the global direction.
 */
function setGlobalDir(dir) {
  globalDir = dir;
}

/**
 * Initialize the global direction
 */
function initGlobalDir() {
  setGlobalDir(LTR);
}

/**
 * Get the global direction
 */
function getGlobalDir() {
  if (!globalDir) {
    this.initGlobalDir();
  }
  !globalDir ?  false ? invariant(false, 'Global direction not set.') : invariant(false) : void 0;
  return globalDir;
}

var UnicodeBidiDirection = {
  // Values
  NEUTRAL: NEUTRAL,
  LTR: LTR,
  RTL: RTL,
  // Helpers
  isStrong: isStrong,
  getHTMLDir: getHTMLDir,
  getHTMLDirIfDifferent: getHTMLDirIfDifferent,
  // Global Direction
  setGlobalDir: setGlobalDir,
  initGlobalDir: initGlobalDir,
  getGlobalDir: getGlobalDir
};

module.exports = UnicodeBidiDirection;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var getDocumentScrollElement = __webpack_require__(2335);
var getUnboundedScrollPosition = __webpack_require__(841);

/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are bounded. This means that if the scroll position is
 * negative or exceeds the element boundaries (which is possible using inertial
 * scrolling), you will get zero or the maximum scroll position, respectively.
 *
 * If you need the unbound scroll position, use `getUnboundedScrollPosition`.
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */
function getScrollPosition(scrollable) {
  var documentScrollElement = getDocumentScrollElement(scrollable.ownerDocument || scrollable.document);
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    scrollable = documentScrollElement;
  }
  var scrollPosition = getUnboundedScrollPosition(scrollable);

  var viewport = scrollable === documentScrollElement ? scrollable.ownerDocument.documentElement : scrollable;

  var xMax = scrollable.scrollWidth - viewport.clientWidth;
  var yMax = scrollable.scrollHeight - viewport.clientHeight;

  scrollPosition.x = Math.max(0, Math.min(scrollPosition.x, xMax));
  scrollPosition.y = Math.max(0, Math.min(scrollPosition.y, yMax));

  return scrollPosition;
}

module.exports = getScrollPosition;

/***/ }),
/* 536 */,
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(265);

var _DOMUtils = __webpack_require__(389);

var _DOMStateStorage = __webpack_require__(845);

var _PathUtils = __webpack_require__(195);

var _ExecutionEnvironment = __webpack_require__(538);

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
      return;
    listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state,
      key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(2350);

var _PathUtils = __webpack_require__(195);

var _runTransitionHook = __webpack_require__(540);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(388);

var _LocationUtils = __webpack_require__(265);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getCurrentLocation = options.getCurrentLocation,
      getUserConfirmation = options.getUserConfirmation,
      pushLocation = options.pushLocation,
      replaceLocation = options.replaceLocation,
      go = options.go,
      keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(68);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*jshint curly:false, eqeqeq:true, laxbreak:true, noempty:false */
/* AUTO-GENERATED. DO NOT MODIFY. */
/*

  The MIT License (MIT)

  Copyright (c) 2007-2017 Einar Lielmanis, Liam Newman, and contributors.

  Permission is hereby granted, free of charge, to any person
  obtaining a copy of this software and associated documentation files
  (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge,
  publish, distribute, sublicense, and/or sell copies of the Software,
  and to permit persons to whom the Software is furnished to do so,
  subject to the following conditions:

  The above copyright notice and this permission notice shall be
  included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.


 CSS Beautifier
---------------

    Written by Harutyun Amirjanyan, (amirjanyan@gmail.com)

    Based on code initially developed by: Einar Lielmanis, <einar@jsbeautifier.org>
        http://jsbeautifier.org/

    Usage:
        css_beautify(source_text);
        css_beautify(source_text, options);

    The options are (default in brackets):
        indent_size (4)                         — indentation size,
        indent_char (space)                     — character to indent with,
        selector_separator_newline (true)       - separate selectors with newline or
                                                  not (e.g. "a,\nbr" or "a, br")
        end_with_newline (false)                - end with a newline
        newline_between_rules (true)            - add a new line after every css rule
        space_around_selector_separator (false) - ensure space around selector separators:
                                                  '>', '+', '~' (e.g. "a>b" -> "a > b")
    e.g

    css_beautify(css_source_text, {
      'indent_size': 1,
      'indent_char': '\t',
      'selector_separator': ' ',
      'end_with_newline': false,
      'newline_between_rules': true,
      'space_around_selector_separator': true
    });
*/

// http://www.w3.org/TR/CSS21/syndata.html#tokenization
// http://www.w3.org/TR/css3-syntax/

(function() {
var legacy_beautify_css =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/*jshint curly:true, eqeqeq:true, laxbreak:true, noempty:false */
/*

  The MIT License (MIT)

  Copyright (c) 2007-2017 Einar Lielmanis, Liam Newman, and contributors.

  Permission is hereby granted, free of charge, to any person
  obtaining a copy of this software and associated documentation files
  (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge,
  publish, distribute, sublicense, and/or sell copies of the Software,
  and to permit persons to whom the Software is furnished to do so,
  subject to the following conditions:

  The above copyright notice and this permission notice shall be
  included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.
*/

var mergeOpts = __webpack_require__(2).mergeOpts;
var acorn = __webpack_require__(1);
var Output = __webpack_require__(3).Output;


var lineBreak = acorn.lineBreak;
var allLineBreaks = acorn.allLineBreaks;

function Beautifier(source_text, options) {
    options = options || {};

    // Allow the setting of language/file-type specific options
    // with inheritance of overall settings
    options = mergeOpts(options, 'css');

    source_text = source_text || '';

    var newlinesFromLastWSEat = 0;
    var indentSize = options.indent_size ? parseInt(options.indent_size, 10) : 4;
    var indentCharacter = options.indent_char || ' ';
    var preserve_newlines = (options.preserve_newlines === undefined) ? false : options.preserve_newlines;
    var selectorSeparatorNewline = (options.selector_separator_newline === undefined) ? true : options.selector_separator_newline;
    var end_with_newline = (options.end_with_newline === undefined) ? false : options.end_with_newline;
    var newline_between_rules = (options.newline_between_rules === undefined) ? true : options.newline_between_rules;
    var space_around_combinator = (options.space_around_combinator === undefined) ? false : options.space_around_combinator;
    space_around_combinator = space_around_combinator || ((options.space_around_selector_separator === undefined) ? false : options.space_around_selector_separator);
    var eol = options.eol ? options.eol : 'auto';

    if (options.indent_with_tabs) {
        indentCharacter = '\t';
        indentSize = 1;
    }

    if (eol === 'auto') {
        eol = '\n';
        if (source_text && lineBreak.test(source_text || '')) {
            eol = source_text.match(lineBreak)[0];
        }
    }

    eol = eol.replace(/\\r/, '\r').replace(/\\n/, '\n');

    // HACK: newline parsing inconsistent. This brute force normalizes the input.
    source_text = source_text.replace(allLineBreaks, '\n');

    // tokenizer
    var whiteRe = /^\s+$/;

    var pos = -1,
        ch;
    var parenLevel = 0;

    function next() {
        ch = source_text.charAt(++pos);
        return ch || '';
    }

    function peek(skipWhitespace) {
        var result = '';
        var prev_pos = pos;
        if (skipWhitespace) {
            eatWhitespace();
        }
        result = source_text.charAt(pos + 1) || '';
        pos = prev_pos - 1;
        next();
        return result;
    }

    function eatString(endChars) {
        var start = pos;
        while (next()) {
            if (ch === "\\") {
                next();
            } else if (endChars.indexOf(ch) !== -1) {
                break;
            } else if (ch === "\n") {
                break;
            }
        }
        return source_text.substring(start, pos + 1);
    }

    function peekString(endChar) {
        var prev_pos = pos;
        var str = eatString(endChar);
        pos = prev_pos - 1;
        next();
        return str;
    }

    function eatWhitespace(preserve_newlines_local) {
        var result = 0;
        while (whiteRe.test(peek())) {
            next();
            if (ch === '\n' && preserve_newlines_local && preserve_newlines) {
                output.add_new_line(true);
                result++;
            }
        }
        newlinesFromLastWSEat = result;
        return result;
    }

    function skipWhitespace() {
        var result = '';
        if (ch && whiteRe.test(ch)) {
            result = ch;
        }
        while (whiteRe.test(next())) {
            result += ch;
        }
        return result;
    }

    function eatComment() {
        var start = pos;
        var singleLine = peek() === "/";
        next();
        while (next()) {
            if (!singleLine && ch === "*" && peek() === "/") {
                next();
                break;
            } else if (singleLine && ch === "\n") {
                return source_text.substring(start, pos);
            }
        }

        return source_text.substring(start, pos) + ch;
    }


    function lookBack(str) {
        return source_text.substring(pos - str.length, pos).toLowerCase() ===
            str;
    }

    // Nested pseudo-class if we are insideRule
    // and the next special character found opens
    // a new block
    function foundNestedPseudoClass() {
        var openParen = 0;
        for (var i = pos + 1; i < source_text.length; i++) {
            var ch = source_text.charAt(i);
            if (ch === "{") {
                return true;
            } else if (ch === '(') {
                // pseudoclasses can contain ()
                openParen += 1;
            } else if (ch === ')') {
                if (openParen === 0) {
                    return false;
                }
                openParen -= 1;
            } else if (ch === ";" || ch === "}") {
                return false;
            }
        }
        return false;
    }

    // printer
    var baseIndentString = '';
    var preindent_index = 0;
    if (source_text && source_text.length) {
        while ((source_text.charAt(preindent_index) === ' ' ||
                source_text.charAt(preindent_index) === '\t')) {
            preindent_index += 1;
        }
        baseIndentString = source_text.substring(0, preindent_index);
        source_text = source_text.substring(preindent_index);
    }


    var singleIndent = new Array(indentSize + 1).join(indentCharacter);
    var indentLevel;
    var nestedLevel;
    var output;

    function print_string(output_string) {
        if (output.just_added_newline()) {
            output.set_indent(indentLevel);
        }
        output.add_token(output_string);
    }

    function preserveSingleSpace(isAfterSpace) {
        if (isAfterSpace) {
            output.space_before_token = true;
        }
    }

    function indent() {
        indentLevel++;
    }

    function outdent() {
        if (indentLevel > 0) {
            indentLevel--;
        }
    }

    /*_____________________--------------------_____________________*/

    this.beautify = function() {
        // reset
        output = new Output(singleIndent, baseIndentString);
        indentLevel = 0;
        nestedLevel = 0;

        pos = -1;
        ch = null;
        parenLevel = 0;

        var insideRule = false;
        var insidePropertyValue = false;
        var enteringConditionalGroup = false;
        var top_ch = '';
        var last_top_ch = '';

        while (true) {
            var whitespace = skipWhitespace();
            var isAfterSpace = whitespace !== '';
            var isAfterNewline = whitespace.indexOf('\n') !== -1;
            last_top_ch = top_ch;
            top_ch = ch;

            if (!ch) {
                break;
            } else if (ch === '/' && peek() === '*') { /* css comment */
                var header = indentLevel === 0;

                if (isAfterNewline || header) {
                    output.add_new_line();
                }

                print_string(eatComment());
                output.add_new_line();
                if (header) {
                    output.add_new_line(true);
                }
            } else if (ch === '/' && peek() === '/') { // single line comment
                if (!isAfterNewline && last_top_ch !== '{') {
                    output.trim(true);
                }
                output.space_before_token = true;
                print_string(eatComment());
                output.add_new_line();
            } else if (ch === '@') {
                preserveSingleSpace(isAfterSpace);

                // deal with less propery mixins @{...}
                if (peek() === '{') {
                    print_string(eatString('}'));
                } else {
                    print_string(ch);

                    // strip trailing space, if present, for hash property checks
                    var variableOrRule = peekString(": ,;{}()[]/='\"");

                    if (variableOrRule.match(/[ :]$/)) {
                        // we have a variable or pseudo-class, add it and insert one space before continuing
                        next();
                        variableOrRule = eatString(": ").replace(/\s$/, '');
                        print_string(variableOrRule);
                        output.space_before_token = true;
                    }

                    variableOrRule = variableOrRule.replace(/\s$/, '');

                    // might be a nesting at-rule
                    if (variableOrRule in this.NESTED_AT_RULE) {
                        nestedLevel += 1;
                        if (variableOrRule in this.CONDITIONAL_GROUP_RULE) {
                            enteringConditionalGroup = true;
                        }
                    }
                }
            } else if (ch === '#' && peek() === '{') {
                preserveSingleSpace(isAfterSpace);
                print_string(eatString('}'));
            } else if (ch === '{') {
                if (peek(true) === '}') {
                    eatWhitespace();
                    next();
                    output.space_before_token = true;
                    print_string("{}");
                    if (!eatWhitespace(true)) {
                        output.add_new_line();
                    }

                    if (newlinesFromLastWSEat < 2 && newline_between_rules && indentLevel === 0) {
                        output.add_new_line(true);
                    }
                } else {
                    indent();
                    output.space_before_token = true;
                    print_string(ch);
                    if (!eatWhitespace(true)) {
                        output.add_new_line();
                    }

                    // when entering conditional groups, only rulesets are allowed
                    if (enteringConditionalGroup) {
                        enteringConditionalGroup = false;
                        insideRule = (indentLevel > nestedLevel);
                    } else {
                        // otherwise, declarations are also allowed
                        insideRule = (indentLevel >= nestedLevel);
                    }
                }
            } else if (ch === '}') {
                outdent();
                output.add_new_line();
                print_string(ch);
                insideRule = false;
                insidePropertyValue = false;
                if (nestedLevel) {
                    nestedLevel--;
                }

                if (!eatWhitespace(true)) {
                    output.add_new_line();
                }

                if (newlinesFromLastWSEat < 2 && newline_between_rules && indentLevel === 0) {
                    output.add_new_line(true);
                }
            } else if (ch === ":") {
                eatWhitespace();
                if ((insideRule || enteringConditionalGroup) &&
                    !(lookBack("&") || foundNestedPseudoClass()) &&
                    !lookBack("(")) {
                    // 'property: value' delimiter
                    // which could be in a conditional group query
                    print_string(':');
                    if (!insidePropertyValue) {
                        insidePropertyValue = true;
                        output.space_before_token = true;
                    }
                } else {
                    // sass/less parent reference don't use a space
                    // sass nested pseudo-class don't use a space

                    // preserve space before pseudoclasses/pseudoelements, as it means "in any child"
                    if (lookBack(" ")) {
                        output.space_before_token = true;
                    }
                    if (peek() === ":") {
                        // pseudo-element
                        next();
                        print_string("::");
                    } else {
                        // pseudo-class
                        print_string(':');
                    }
                }
            } else if (ch === '"' || ch === '\'') {
                preserveSingleSpace(isAfterSpace);
                print_string(eatString(ch));
            } else if (ch === ';') {
                insidePropertyValue = false;
                print_string(ch);
                if (!eatWhitespace(true)) {
                    output.add_new_line();
                }
            } else if (ch === '(') { // may be a url
                if (lookBack("url")) {
                    print_string(ch);
                    eatWhitespace();
                    if (next()) {
                        if (ch !== ')' && ch !== '"' && ch !== '\'') {
                            print_string(eatString(')'));
                        } else {
                            pos--;
                        }
                    }
                } else {
                    parenLevel++;
                    preserveSingleSpace(isAfterSpace);
                    print_string(ch);
                    eatWhitespace();
                }
            } else if (ch === ')') {
                print_string(ch);
                parenLevel--;
            } else if (ch === ',') {
                print_string(ch);
                if (!eatWhitespace(true) && selectorSeparatorNewline && !insidePropertyValue && parenLevel < 1) {
                    output.add_new_line();
                } else {
                    output.space_before_token = true;
                }
            } else if ((ch === '>' || ch === '+' || ch === '~') &&
                !insidePropertyValue && parenLevel < 1) {
                //handle combinator spacing
                if (space_around_combinator) {
                    output.space_before_token = true;
                    print_string(ch);
                    output.space_before_token = true;
                } else {
                    print_string(ch);
                    eatWhitespace();
                    // squash extra whitespace
                    if (ch && whiteRe.test(ch)) {
                        ch = '';
                    }
                }
            } else if (ch === ']') {
                print_string(ch);
            } else if (ch === '[') {
                preserveSingleSpace(isAfterSpace);
                print_string(ch);
            } else if (ch === '=') { // no whitespace before or after
                eatWhitespace();
                print_string('=');
                if (whiteRe.test(ch)) {
                    ch = '';
                }
            } else if (ch === '!') { // !important
                print_string(' ');
                print_string(ch);
            } else {
                preserveSingleSpace(isAfterSpace);
                print_string(ch);
            }
        }

        var sweetCode = output.get_code(end_with_newline, eol);

        return sweetCode;
    };

    // https://developer.mozilla.org/en-US/docs/Web/CSS/At-rule
    this.NESTED_AT_RULE = {
        "@page": true,
        "@font-face": true,
        "@keyframes": true,
        // also in CONDITIONAL_GROUP_RULE below
        "@media": true,
        "@supports": true,
        "@document": true
    };
    this.CONDITIONAL_GROUP_RULE = {
        "@media": true,
        "@supports": true,
        "@document": true
    };
}

module.exports.Beautifier = Beautifier;


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* jshint curly: false */
// This section of code is taken from acorn.
//
// Acorn was written by Marijn Haverbeke and released under an MIT
// license. The Unicode regexps (for identifiers and whitespace) were
// taken from [Esprima](http://esprima.org) by Ariya Hidayat.
//
// Git repositories for Acorn are available at
//
//     http://marijnhaverbeke.nl/git/acorn
//     https://github.com/marijnh/acorn.git

// ## Character categories

// Big ugly regular expressions that match characters in the
// whitespace, identifier, and identifier-start categories. These
// are only applied when a character is found to actually have a
// code point above 128.

var nonASCIIwhitespace = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/; // jshint ignore:line
var nonASCIIidentifierStartChars = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u08a0\u08a2-\u08ac\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097f\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c33\u0c35-\u0c39\u0c3d\u0c58\u0c59\u0c60\u0c61\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d60\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f0\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191c\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19c1-\u19c7\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1ce9-\u1cec\u1cee-\u1cf1\u1cf5\u1cf6\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2e2f\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309d-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fcc\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua697\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790-\ua793\ua7a0-\ua7aa\ua7f8-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa80-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uabc0-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc";
var nonASCIIidentifierChars = "\u0300-\u036f\u0483-\u0487\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u0620-\u0649\u0672-\u06d3\u06e7-\u06e8\u06fb-\u06fc\u0730-\u074a\u0800-\u0814\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0840-\u0857\u08e4-\u08fe\u0900-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962-\u0963\u0966-\u096f\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09d7\u09df-\u09e0\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a66-\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2-\u0ae3\u0ae6-\u0aef\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b56\u0b57\u0b5f-\u0b60\u0b66-\u0b6f\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0be6-\u0bef\u0c01-\u0c03\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62-\u0c63\u0c66-\u0c6f\u0c82\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2-\u0ce3\u0ce6-\u0cef\u0d02\u0d03\u0d46-\u0d48\u0d57\u0d62-\u0d63\u0d66-\u0d6f\u0d82\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0df2\u0df3\u0e34-\u0e3a\u0e40-\u0e45\u0e50-\u0e59\u0eb4-\u0eb9\u0ec8-\u0ecd\u0ed0-\u0ed9\u0f18\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f41-\u0f47\u0f71-\u0f84\u0f86-\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u1000-\u1029\u1040-\u1049\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f-\u109d\u135d-\u135f\u170e-\u1710\u1720-\u1730\u1740-\u1750\u1772\u1773\u1780-\u17b2\u17dd\u17e0-\u17e9\u180b-\u180d\u1810-\u1819\u1920-\u192b\u1930-\u193b\u1951-\u196d\u19b0-\u19c0\u19c8-\u19c9\u19d0-\u19d9\u1a00-\u1a15\u1a20-\u1a53\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1b46-\u1b4b\u1b50-\u1b59\u1b6b-\u1b73\u1bb0-\u1bb9\u1be6-\u1bf3\u1c00-\u1c22\u1c40-\u1c49\u1c5b-\u1c7d\u1cd0-\u1cd2\u1d00-\u1dbe\u1e01-\u1f15\u200c\u200d\u203f\u2040\u2054\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2d81-\u2d96\u2de0-\u2dff\u3021-\u3028\u3099\u309a\ua640-\ua66d\ua674-\ua67d\ua69f\ua6f0-\ua6f1\ua7f8-\ua800\ua806\ua80b\ua823-\ua827\ua880-\ua881\ua8b4-\ua8c4\ua8d0-\ua8d9\ua8f3-\ua8f7\ua900-\ua909\ua926-\ua92d\ua930-\ua945\ua980-\ua983\ua9b3-\ua9c0\uaa00-\uaa27\uaa40-\uaa41\uaa4c-\uaa4d\uaa50-\uaa59\uaa7b\uaae0-\uaae9\uaaf2-\uaaf3\uabc0-\uabe1\uabec\uabed\uabf0-\uabf9\ufb20-\ufb28\ufe00-\ufe0f\ufe20-\ufe26\ufe33\ufe34\ufe4d-\ufe4f\uff10-\uff19\uff3f";
var nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]");
var nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]");

// Whether a single character denotes a newline.

exports.newline = /[\n\r\u2028\u2029]/;

// Matches a whole line break (where CRLF is considered a single
// line break). Used to count lines.

// in javascript, these two differ
// in python they are the same, different methods are called on them
exports.lineBreak = new RegExp('\r\n|' + exports.newline.source);
exports.allLineBreaks = new RegExp(exports.lineBreak.source, 'g');


// Test whether a given character code starts an identifier.

exports.isIdentifierStart = function(code) {
    // permit $ (36) and @ (64). @ is used in ES7 decorators.
    if (code < 65) return code === 36 || code === 64;
    // 65 through 91 are uppercase letters.
    if (code < 91) return true;
    // permit _ (95).
    if (code < 97) return code === 95;
    // 97 through 123 are lowercase letters.
    if (code < 123) return true;
    return code >= 0xaa && nonASCIIidentifierStart.test(String.fromCharCode(code));
};

// Test whether a given character is part of an identifier.

exports.isIdentifierChar = function(code) {
    if (code < 48) return code === 36;
    if (code < 58) return true;
    if (code < 65) return false;
    if (code < 91) return true;
    if (code < 97) return code === 95;
    if (code < 123) return true;
    return code >= 0xaa && nonASCIIidentifier.test(String.fromCharCode(code));
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*jshint curly:true, eqeqeq:true, laxbreak:true, noempty:false */
/*

    The MIT License (MIT)

    Copyright (c) 2007-2017 Einar Lielmanis, Liam Newman, and contributors.

    Permission is hereby granted, free of charge, to any person
    obtaining a copy of this software and associated documentation files
    (the "Software"), to deal in the Software without restriction,
    including without limitation the rights to use, copy, modify, merge,
    publish, distribute, sublicense, and/or sell copies of the Software,
    and to permit persons to whom the Software is furnished to do so,
    subject to the following conditions:

    The above copyright notice and this permission notice shall be
    included in all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
    EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
    NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
    BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
    ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
    CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    SOFTWARE.
*/

function mergeOpts(allOptions, targetType) {
    var finalOpts = {};
    var name;

    for (name in allOptions) {
        if (name !== targetType) {
            finalOpts[name] = allOptions[name];
        }
    }

    //merge in the per type settings for the targetType
    if (targetType in allOptions) {
        for (name in allOptions[targetType]) {
            finalOpts[name] = allOptions[targetType][name];
        }
    }
    return finalOpts;
}

module.exports.mergeOpts = mergeOpts;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

/*jshint curly:true, eqeqeq:true, laxbreak:true, noempty:false */
/*

  The MIT License (MIT)

  Copyright (c) 2007-2017 Einar Lielmanis, Liam Newman, and contributors.

  Permission is hereby granted, free of charge, to any person
  obtaining a copy of this software and associated documentation files
  (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge,
  publish, distribute, sublicense, and/or sell copies of the Software,
  and to permit persons to whom the Software is furnished to do so,
  subject to the following conditions:

  The above copyright notice and this permission notice shall be
  included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.
*/

function OutputLine(parent) {
    var _character_count = 0;
    // use indent_count as a marker for lines that have preserved indentation
    var _indent_count = -1;

    var _items = [];
    var _empty = true;

    this.set_indent = function(level) {
        _character_count = parent.baseIndentLength + level * parent.indent_length;
        _indent_count = level;
    };

    this.get_character_count = function() {
        return _character_count;
    };

    this.is_empty = function() {
        return _empty;
    };

    this.last = function() {
        if (!this._empty) {
            return _items[_items.length - 1];
        } else {
            return null;
        }
    };

    this.push = function(input) {
        _items.push(input);
        _character_count += input.length;
        _empty = false;
    };

    this.pop = function() {
        var item = null;
        if (!_empty) {
            item = _items.pop();
            _character_count -= item.length;
            _empty = _items.length === 0;
        }
        return item;
    };

    this.remove_indent = function() {
        if (_indent_count > 0) {
            _indent_count -= 1;
            _character_count -= parent.indent_length;
        }
    };

    this.trim = function() {
        while (this.last() === ' ') {
            _items.pop();
            _character_count -= 1;
        }
        _empty = _items.length === 0;
    };

    this.toString = function() {
        var result = '';
        if (!this._empty) {
            if (_indent_count >= 0) {
                result = parent.indent_cache[_indent_count];
            }
            result += _items.join('');
        }
        return result;
    };
}

function Output(indent_string, baseIndentString) {
    baseIndentString = baseIndentString || '';
    this.indent_cache = [baseIndentString];
    this.baseIndentLength = baseIndentString.length;
    this.indent_length = indent_string.length;
    this.raw = false;

    var lines = [];
    this.baseIndentString = baseIndentString;
    this.indent_string = indent_string;
    this.previous_line = null;
    this.current_line = null;
    this.space_before_token = false;

    this.add_outputline = function() {
        this.previous_line = this.current_line;
        this.current_line = new OutputLine(this);
        lines.push(this.current_line);
    };

    // initialize
    this.add_outputline();


    this.get_line_number = function() {
        return lines.length;
    };

    // Using object instead of string to allow for later expansion of info about each line
    this.add_new_line = function(force_newline) {
        if (this.get_line_number() === 1 && this.just_added_newline()) {
            return false; // no newline on start of file
        }

        if (force_newline || !this.just_added_newline()) {
            if (!this.raw) {
                this.add_outputline();
            }
            return true;
        }

        return false;
    };

    this.get_code = function(end_with_newline, eol) {
        var sweet_code = lines.join('\n').replace(/[\r\n\t ]+$/, '');

        if (end_with_newline) {
            sweet_code += '\n';
        }

        if (eol !== '\n') {
            sweet_code = sweet_code.replace(/[\n]/g, eol);
        }

        return sweet_code;
    };

    this.set_indent = function(level) {
        // Never indent your first output indent at the start of the file
        if (lines.length > 1) {
            while (level >= this.indent_cache.length) {
                this.indent_cache.push(this.indent_cache[this.indent_cache.length - 1] + this.indent_string);
            }

            this.current_line.set_indent(level);
            return true;
        }
        this.current_line.set_indent(0);
        return false;
    };

    this.add_raw_token = function(token) {
        for (var x = 0; x < token.newlines; x++) {
            this.add_outputline();
        }
        this.current_line.push(token.whitespace_before);
        this.current_line.push(token.text);
        this.space_before_token = false;
    };

    this.add_token = function(printable_token) {
        this.add_space_before_token();
        this.current_line.push(printable_token);
    };

    this.add_space_before_token = function() {
        if (this.space_before_token && !this.just_added_newline()) {
            this.current_line.push(' ');
        }
        this.space_before_token = false;
    };

    this.remove_indent = function(index) {
        var output_length = lines.length;
        while (index < output_length) {
            lines[index].remove_indent();
            index++;
        }
    };

    this.trim = function(eat_newlines) {
        eat_newlines = (eat_newlines === undefined) ? false : eat_newlines;

        this.current_line.trim(indent_string, baseIndentString);

        while (eat_newlines && lines.length > 1 &&
            this.current_line.is_empty()) {
            lines.pop();
            this.current_line = lines[lines.length - 1];
            this.current_line.trim();
        }

        this.previous_line = lines.length > 1 ? lines[lines.length - 2] : null;
    };

    this.just_added_newline = function() {
        return this.current_line.is_empty();
    };

    this.just_added_blankline = function() {
        if (this.just_added_newline()) {
            if (lines.length === 1) {
                return true; // start of the file and newline = blank
            }

            var line = lines[lines.length - 2];
            return line.is_empty();
        }
        return false;
    };
}

module.exports.Output = Output;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/*jshint curly:true, eqeqeq:true, laxbreak:true, noempty:false */
/*

    The MIT License (MIT)

    Copyright (c) 2007-2017 Einar Lielmanis, Liam Newman, and contributors.

    Permission is hereby granted, free of charge, to any person
    obtaining a copy of this software and associated documentation files
    (the "Software"), to deal in the Software without restriction,
    including without limitation the rights to use, copy, modify, merge,
    publish, distribute, sublicense, and/or sell copies of the Software,
    and to permit persons to whom the Software is furnished to do so,
    subject to the following conditions:

    The above copyright notice and this permission notice shall be
    included in all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
    EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
    NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
    BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
    ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
    CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    SOFTWARE.
*/

var Beautifier = __webpack_require__(0).Beautifier;

function css_beautify(source_text, options) {
    var beautifier = new Beautifier(source_text, options);
    return beautifier.beautify();
}

module.exports = css_beautify;

/***/ })
/******/ ]);
var css_beautify = legacy_beautify_css;
/* Footer */
if (true) {
    // Add support for AMD ( https://github.com/amdjs/amdjs-api/wiki/AMD#defineamd-property- )
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
        return {
            css_beautify: css_beautify
        };
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof exports !== "undefined") {
    // Add support for CommonJS. Just put this file somewhere on your require.paths
    // and you will be able to `var html_beautify = require("beautify").html_beautify`.
    exports.css_beautify = css_beautify;
} else if (typeof window !== "undefined") {
    // If we're running a web page and don't have either of the above, add our one global
    window.css_beautify = css_beautify;
} else if (typeof global !== "undefined") {
    // If we don't even have window, try global.
    global.css_beautify = css_beautify;
}

}());


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*jshint curly:false, eqeqeq:true, laxbreak:true, noempty:false */
/* AUTO-GENERATED. DO NOT MODIFY. */
/* see js/src/javascript/index.js */
/*

  The MIT License (MIT)

  Copyright (c) 2007-2017 Einar Lielmanis, Liam Newman, and contributors.

  Permission is hereby granted, free of charge, to any person
  obtaining a copy of this software and associated documentation files
  (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge,
  publish, distribute, sublicense, and/or sell copies of the Software,
  and to permit persons to whom the Software is furnished to do so,
  subject to the following conditions:

  The above copyright notice and this permission notice shall be
  included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.

 JS Beautifier
---------------


  Written by Einar Lielmanis, <einar@jsbeautifier.org>
      http://jsbeautifier.org/

  Originally converted to javascript by Vital, <vital76@gmail.com>
  "End braces on own line" added by Chris J. Shull, <chrisjshull@gmail.com>
  Parsing improvements for brace-less statements by Liam Newman <bitwiseman@gmail.com>


  Usage:
    js_beautify(js_source_text);
    js_beautify(js_source_text, options);

  The options are:
    indent_size (default 4)          - indentation size,
    indent_char (default space)      - character to indent with,
    preserve_newlines (default true) - whether existing line breaks should be preserved,
    max_preserve_newlines (default unlimited) - maximum number of line breaks to be preserved in one chunk,

    jslint_happy (default false) - if true, then jslint-stricter mode is enforced.

            jslint_happy        !jslint_happy
            ---------------------------------
            function ()         function()

            switch () {         switch() {
            case 1:               case 1:
              break;                break;
            }                   }

    space_after_anon_function (default false) - should the space before an anonymous function's parens be added, "function()" vs "function ()",
          NOTE: This option is overriden by jslint_happy (i.e. if jslint_happy is true, space_after_anon_function is true by design)

    brace_style (default "collapse") - "collapse" | "expand" | "end-expand" | "none" | any of the former + ",preserve-inline"
            put braces on the same line as control statements (default), or put braces on own line (Allman / ANSI style), or just put end braces on own line, or attempt to keep them where they are.
            preserve-inline will try to preserve inline blocks of curly braces

    space_before_conditional (default true) - should the space before conditional statement be added, "if(true)" vs "if (true)",

    unescape_strings (default false) - should printable characters in strings encoded in \xNN notation be unescaped, "example" vs "\x65\x78\x61\x6d\x70\x6c\x65"

    wrap_line_length (default unlimited) - lines should wrap at next opportunity after this number of characters.
          NOTE: This is not a hard limit. Lines will continue until a point where a newline would
                be preserved if it were present.

    end_with_newline (default false)  - end output with a newline


    e.g

    js_beautify(js_source_text, {
      'indent_size': 1,
      'indent_char': '\t'
    });

*/

(function() {
var legacy_beautify_js =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 6);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* jshint curly: false */
// This section of code is taken from acorn.
//
// Acorn was written by Marijn Haverbeke and released under an MIT
// license. The Unicode regexps (for identifiers and whitespace) were
// taken from [Esprima](http://esprima.org) by Ariya Hidayat.
//
// Git repositories for Acorn are available at
//
//     http://marijnhaverbeke.nl/git/acorn
//     https://github.com/marijnh/acorn.git

// ## Character categories

// Big ugly regular expressions that match characters in the
// whitespace, identifier, and identifier-start categories. These
// are only applied when a character is found to actually have a
// code point above 128.

var nonASCIIwhitespace = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/; // jshint ignore:line
var nonASCIIidentifierStartChars = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u08a0\u08a2-\u08ac\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097f\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c33\u0c35-\u0c39\u0c3d\u0c58\u0c59\u0c60\u0c61\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d60\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f0\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191c\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19c1-\u19c7\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1ce9-\u1cec\u1cee-\u1cf1\u1cf5\u1cf6\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2e2f\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309d-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fcc\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua697\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790-\ua793\ua7a0-\ua7aa\ua7f8-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa80-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uabc0-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc";
var nonASCIIidentifierChars = "\u0300-\u036f\u0483-\u0487\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u0620-\u0649\u0672-\u06d3\u06e7-\u06e8\u06fb-\u06fc\u0730-\u074a\u0800-\u0814\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0840-\u0857\u08e4-\u08fe\u0900-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962-\u0963\u0966-\u096f\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09d7\u09df-\u09e0\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a66-\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2-\u0ae3\u0ae6-\u0aef\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b56\u0b57\u0b5f-\u0b60\u0b66-\u0b6f\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0be6-\u0bef\u0c01-\u0c03\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62-\u0c63\u0c66-\u0c6f\u0c82\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2-\u0ce3\u0ce6-\u0cef\u0d02\u0d03\u0d46-\u0d48\u0d57\u0d62-\u0d63\u0d66-\u0d6f\u0d82\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0df2\u0df3\u0e34-\u0e3a\u0e40-\u0e45\u0e50-\u0e59\u0eb4-\u0eb9\u0ec8-\u0ecd\u0ed0-\u0ed9\u0f18\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f41-\u0f47\u0f71-\u0f84\u0f86-\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u1000-\u1029\u1040-\u1049\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f-\u109d\u135d-\u135f\u170e-\u1710\u1720-\u1730\u1740-\u1750\u1772\u1773\u1780-\u17b2\u17dd\u17e0-\u17e9\u180b-\u180d\u1810-\u1819\u1920-\u192b\u1930-\u193b\u1951-\u196d\u19b0-\u19c0\u19c8-\u19c9\u19d0-\u19d9\u1a00-\u1a15\u1a20-\u1a53\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1b46-\u1b4b\u1b50-\u1b59\u1b6b-\u1b73\u1bb0-\u1bb9\u1be6-\u1bf3\u1c00-\u1c22\u1c40-\u1c49\u1c5b-\u1c7d\u1cd0-\u1cd2\u1d00-\u1dbe\u1e01-\u1f15\u200c\u200d\u203f\u2040\u2054\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2d81-\u2d96\u2de0-\u2dff\u3021-\u3028\u3099\u309a\ua640-\ua66d\ua674-\ua67d\ua69f\ua6f0-\ua6f1\ua7f8-\ua800\ua806\ua80b\ua823-\ua827\ua880-\ua881\ua8b4-\ua8c4\ua8d0-\ua8d9\ua8f3-\ua8f7\ua900-\ua909\ua926-\ua92d\ua930-\ua945\ua980-\ua983\ua9b3-\ua9c0\uaa00-\uaa27\uaa40-\uaa41\uaa4c-\uaa4d\uaa50-\uaa59\uaa7b\uaae0-\uaae9\uaaf2-\uaaf3\uabc0-\uabe1\uabec\uabed\uabf0-\uabf9\ufb20-\ufb28\ufe00-\ufe0f\ufe20-\ufe26\ufe33\ufe34\ufe4d-\ufe4f\uff10-\uff19\uff3f";
var nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]");
var nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]");

// Whether a single character denotes a newline.

exports.newline = /[\n\r\u2028\u2029]/;

// Matches a whole line break (where CRLF is considered a single
// line break). Used to count lines.

// in javascript, these two differ
// in python they are the same, different methods are called on them
exports.lineBreak = new RegExp('\r\n|' + exports.newline.source);
exports.allLineBreaks = new RegExp(exports.lineBreak.source, 'g');


// Test whether a given character code starts an identifier.

exports.isIdentifierStart = function(code) {
    // permit $ (36) and @ (64). @ is used in ES7 decorators.
    if (code < 65) return code === 36 || code === 64;
    // 65 through 91 are uppercase letters.
    if (code < 91) return true;
    // permit _ (95).
    if (code < 97) return code === 95;
    // 97 through 123 are lowercase letters.
    if (code < 123) return true;
    return code >= 0xaa && nonASCIIidentifierStart.test(String.fromCharCode(code));
};

// Test whether a given character is part of an identifier.

exports.isIdentifierChar = function(code) {
    if (code < 48) return code === 36;
    if (code < 58) return true;
    if (code < 65) return false;
    if (code < 91) return true;
    if (code < 97) return code === 95;
    if (code < 123) return true;
    return code >= 0xaa && nonASCIIidentifier.test(String.fromCharCode(code));
};


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/*jshint curly:true, eqeqeq:true, laxbreak:true, noempty:false */
/*

    The MIT License (MIT)

    Copyright (c) 2007-2017 Einar Lielmanis, Liam Newman, and contributors.

    Permission is hereby granted, free of charge, to any person
    obtaining a copy of this software and associated documentation files
    (the "Software"), to deal in the Software without restriction,
    including without limitation the rights to use, copy, modify, merge,
    publish, distribute, sublicense, and/or sell copies of the Software,
    and to permit persons to whom the Software is furnished to do so,
    subject to the following conditions:

    The above copyright notice and this permission notice shall be
    included in all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
    EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
    NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
    BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
    ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
    CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    SOFTWARE.
*/

var mergeOpts = __webpack_require__(3).mergeOpts;
var acorn = __webpack_require__(0);
var Output = __webpack_require__(4).Output;
var Tokenizer = __webpack_require__(7).Tokenizer;

function remove_redundant_indentation(output, frame) {
    // This implementation is effective but has some issues:
    //     - can cause line wrap to happen too soon due to indent removal
    //           after wrap points are calculated
    // These issues are minor compared to ugly indentation.

    if (frame.multiline_frame ||
        frame.mode === MODE.ForInitializer ||
        frame.mode === MODE.Conditional) {
        return;
    }

    // remove one indent from each line inside this section
    var start_index = frame.start_line_index;

    output.remove_indent(start_index);
}

function in_array(what, arr) {
    for (var i = 0; i < arr.length; i += 1) {
        if (arr[i] === what) {
            return true;
        }
    }
    return false;
}

function trim(s) {
    return s.replace(/^\s+|\s+$/g, '');
}

function ltrim(s) {
    return s.replace(/^\s+/g, '');
}

// function rtrim(s) {
//     return s.replace(/\s+$/g, '');
// }


function generateMapFromStrings(list) {
    var result = {};
    for (var x = 0; x < list.length; x++) {
        // make the mapped names underscored instead of dash
        result[list[x].replace(/-/g, '_')] = list[x];
    }
    return result;
}

function sanitizeOperatorPosition(opPosition) {
    opPosition = opPosition || OPERATOR_POSITION.before_newline;

    if (!in_array(opPosition, validPositionValues)) {
        throw new Error("Invalid Option Value: The option 'operator_position' must be one of the following values\n" +
            validPositionValues +
            "\nYou passed in: '" + opPosition + "'");
    }

    return opPosition;
}

var validPositionValues = ['before-newline', 'after-newline', 'preserve-newline'];

// Generate map from array
var OPERATOR_POSITION = generateMapFromStrings(validPositionValues);

var OPERATOR_POSITION_BEFORE_OR_PRESERVE = [OPERATOR_POSITION.before_newline, OPERATOR_POSITION.preserve_newline];

var MODE = {
    BlockStatement: 'BlockStatement', // 'BLOCK'
    Statement: 'Statement', // 'STATEMENT'
    ObjectLiteral: 'ObjectLiteral', // 'OBJECT',
    ArrayLiteral: 'ArrayLiteral', //'[EXPRESSION]',
    ForInitializer: 'ForInitializer', //'(FOR-EXPRESSION)',
    Conditional: 'Conditional', //'(COND-EXPRESSION)',
    Expression: 'Expression' //'(EXPRESSION)'
};

function Beautifier(js_source_text, options) {
    "use strict";
    var output;
    var tokens = [],
        token_pos;
    var tokenizer;
    var current_token;
    var last_type, last_last_text, indent_string;
    var flags, previous_flags, flag_store;
    var prefix;

    var handlers, opt;
    var baseIndentString = '';

    handlers = {
        'TK_START_EXPR': handle_start_expr,
        'TK_END_EXPR': handle_end_expr,
        'TK_START_BLOCK': handle_start_block,
        'TK_END_BLOCK': handle_end_block,
        'TK_WORD': handle_word,
        'TK_RESERVED': handle_word,
        'TK_SEMICOLON': handle_semicolon,
        'TK_STRING': handle_string,
        'TK_EQUALS': handle_equals,
        'TK_OPERATOR': handle_operator,
        'TK_COMMA': handle_comma,
        'TK_BLOCK_COMMENT': handle_block_comment,
        'TK_COMMENT': handle_comment,
        'TK_DOT': handle_dot,
        'TK_UNKNOWN': handle_unknown,
        'TK_EOF': handle_eof
    };

    function create_flags(flags_base, mode) {
        var next_indent_level = 0;
        if (flags_base) {
            next_indent_level = flags_base.indentation_level;
            if (!output.just_added_newline() &&
                flags_base.line_indent_level > next_indent_level) {
                next_indent_level = flags_base.line_indent_level;
            }
        }

        var next_flags = {
            mode: mode,
            parent: flags_base,
            last_text: flags_base ? flags_base.last_text : '', // last token text
            last_word: flags_base ? flags_base.last_word : '', // last 'TK_WORD' passed
            declaration_statement: false,
            declaration_assignment: false,
            multiline_frame: false,
            inline_frame: false,
            if_block: false,
            else_block: false,
            do_block: false,
            do_while: false,
            import_block: false,
            in_case_statement: false, // switch(..){ INSIDE HERE }
            in_case: false, // we're on the exact line with "case 0:"
            case_body: false, // the indented case-action block
            indentation_level: next_indent_level,
            line_indent_level: flags_base ? flags_base.line_indent_level : next_indent_level,
            start_line_index: output.get_line_number(),
            ternary_depth: 0
        };
        return next_flags;
    }

    // Some interpreters have unexpected results with foo = baz || bar;
    options = options ? options : {};

    // Allow the setting of language/file-type specific options
    // with inheritance of overall settings
    options = mergeOpts(options, 'js');

    opt = {};

    // compatibility, re
    if (options.brace_style === "expand-strict") { //graceful handling of deprecated option
        options.brace_style = "expand";
    } else if (options.brace_style === "collapse-preserve-inline") { //graceful handling of deprecated option
        options.brace_style = "collapse,preserve-inline";
    } else if (options.braces_on_own_line !== undefined) { //graceful handling of deprecated option
        options.brace_style = options.braces_on_own_line ? "expand" : "collapse";
    } else if (!options.brace_style) { //Nothing exists to set it
        options.brace_style = "collapse";
    }

    //preserve-inline in delimited string will trigger brace_preserve_inline, everything
    //else is considered a brace_style and the last one only will have an effect
    var brace_style_split = options.brace_style.split(/[^a-zA-Z0-9_\-]+/);
    opt.brace_preserve_inline = false; //Defaults in case one or other was not specified in meta-option
    opt.brace_style = "collapse";
    for (var bs = 0; bs < brace_style_split.length; bs++) {
        if (brace_style_split[bs] === "preserve-inline") {
            opt.brace_preserve_inline = true;
        } else {
            opt.brace_style = brace_style_split[bs];
        }
    }

    opt.indent_size = options.indent_size ? parseInt(options.indent_size, 10) : 4;
    opt.indent_char = options.indent_char ? options.indent_char : ' ';
    opt.eol = options.eol ? options.eol : 'auto';
    opt.preserve_newlines = (options.preserve_newlines === undefined) ? true : options.preserve_newlines;
    opt.unindent_chained_methods = (options.unindent_chained_methods === undefined) ? false : options.unindent_chained_methods;
    opt.break_chained_methods = (options.break_chained_methods === undefined) ? false : options.break_chained_methods;
    opt.max_preserve_newlines = (options.max_preserve_newlines === undefined) ? 0 : parseInt(options.max_preserve_newlines, 10);
    opt.space_in_paren = (options.space_in_paren === undefined) ? false : options.space_in_paren;
    opt.space_in_empty_paren = (options.space_in_empty_paren === undefined) ? false : options.space_in_empty_paren;
    opt.jslint_happy = (options.jslint_happy === undefined) ? false : options.jslint_happy;
    opt.space_after_anon_function = (options.space_after_anon_function === undefined) ? false : options.space_after_anon_function;
    opt.keep_array_indentation = (options.keep_array_indentation === undefined) ? false : options.keep_array_indentation;
    opt.space_before_conditional = (options.space_before_conditional === undefined) ? true : options.space_before_conditional;
    opt.unescape_strings = (options.unescape_strings === undefined) ? false : options.unescape_strings;
    opt.wrap_line_length = (options.wrap_line_length === undefined) ? 0 : parseInt(options.wrap_line_length, 10);
    opt.e4x = (options.e4x === undefined) ? false : options.e4x;
    opt.end_with_newline = (options.end_with_newline === undefined) ? false : options.end_with_newline;
    opt.comma_first = (options.comma_first === undefined) ? false : options.comma_first;
    opt.operator_position = sanitizeOperatorPosition(options.operator_position);

    // For testing of beautify ignore:start directive
    opt.test_output_raw = (options.test_output_raw === undefined) ? false : options.test_output_raw;

    // force opt.space_after_anon_function to true if opt.jslint_happy
    if (opt.jslint_happy) {
        opt.space_after_anon_function = true;
    }

    if (options.indent_with_tabs) {
        opt.indent_char = '\t';
        opt.indent_size = 1;
    }

    if (opt.eol === 'auto') {
        opt.eol = '\n';
        if (js_source_text && acorn.lineBreak.test(js_source_text || '')) {
            opt.eol = js_source_text.match(acorn.lineBreak)[0];
        }
    }

    opt.eol = opt.eol.replace(/\\r/, '\r').replace(/\\n/, '\n');

    //----------------------------------
    indent_string = '';
    while (opt.indent_size > 0) {
        indent_string += opt.indent_char;
        opt.indent_size -= 1;
    }

    var preindent_index = 0;
    if (js_source_text && js_source_text.length) {
        while ((js_source_text.charAt(preindent_index) === ' ' ||
                js_source_text.charAt(preindent_index) === '\t')) {
            preindent_index += 1;
        }
        baseIndentString = js_source_text.substring(0, preindent_index);
        js_source_text = js_source_text.substring(preindent_index);
    }

    last_type = 'TK_START_BLOCK'; // last token type
    last_last_text = ''; // pre-last token text
    output = new Output(indent_string, baseIndentString);

    // If testing the ignore directive, start with output disable set to true
    output.raw = opt.test_output_raw;


    // Stack of parsing/formatting states, including MODE.
    // We tokenize, parse, and output in an almost purely a forward-only stream of token input
    // and formatted output.  This makes the beautifier less accurate than full parsers
    // but also far more tolerant of syntax errors.
    //
    // For example, the default mode is MODE.BlockStatement. If we see a '{' we push a new frame of type
    // MODE.BlockStatement on the the stack, even though it could be object literal.  If we later
    // encounter a ":", we'll switch to to MODE.ObjectLiteral.  If we then see a ";",
    // most full parsers would die, but the beautifier gracefully falls back to
    // MODE.BlockStatement and continues on.
    flag_store = [];
    set_mode(MODE.BlockStatement);

    this.beautify = function() {

        /*jshint onevar:true */
        var sweet_code;
        tokenizer = new Tokenizer(js_source_text, opt, indent_string);
        tokens = tokenizer.tokenize();
        token_pos = 0;

        current_token = get_token();
        while (current_token) {
            handlers[current_token.type]();

            last_last_text = flags.last_text;
            last_type = current_token.type;
            flags.last_text = current_token.text;

            token_pos += 1;
            current_token = get_token();
        }

        sweet_code = output.get_code(opt.end_with_newline, opt.eol);

        return sweet_code;
    };

    function handle_whitespace_and_comments(local_token, preserve_statement_flags) {
        var newlines = local_token.newlines;
        var keep_whitespace = opt.keep_array_indentation && is_array(flags.mode);
        var temp_token = current_token;

        for (var h = 0; h < local_token.comments_before.length; h++) {
            // The cleanest handling of inline comments is to treat them as though they aren't there.
            // Just continue formatting and the behavior should be logical.
            // Also ignore unknown tokens.  Again, this should result in better behavior.
            current_token = local_token.comments_before[h];
            handle_whitespace_and_comments(current_token, preserve_statement_flags);
            handlers[current_token.type](preserve_statement_flags);
        }
        current_token = temp_token;

        if (keep_whitespace) {
            for (var i = 0; i < newlines; i += 1) {
                print_newline(i > 0, preserve_statement_flags);
            }
        } else {
            if (opt.max_preserve_newlines && newlines > opt.max_preserve_newlines) {
                newlines = opt.max_preserve_newlines;
            }

            if (opt.preserve_newlines) {
                if (local_token.newlines > 1) {
                    print_newline(false, preserve_statement_flags);
                    for (var j = 1; j < newlines; j += 1) {
                        print_newline(true, preserve_statement_flags);
                    }
                }
            }
        }

    }

    // we could use just string.split, but
    // IE doesn't like returning empty strings
    function split_linebreaks(s) {
        //return s.split(/\x0d\x0a|\x0a/);

        s = s.replace(acorn.allLineBreaks, '\n');
        var out = [],
            idx = s.indexOf("\n");
        while (idx !== -1) {
            out.push(s.substring(0, idx));
            s = s.substring(idx + 1);
            idx = s.indexOf("\n");
        }
        if (s.length) {
            out.push(s);
        }
        return out;
    }

    var newline_restricted_tokens = ['break', 'continue', 'return', 'throw', 'yield'];

    function allow_wrap_or_preserved_newline(force_linewrap) {
        force_linewrap = (force_linewrap === undefined) ? false : force_linewrap;

        // Never wrap the first token on a line
        if (output.just_added_newline()) {
            return;
        }

        var shouldPreserveOrForce = (opt.preserve_newlines && current_token.wanted_newline) || force_linewrap;
        var operatorLogicApplies = in_array(flags.last_text, tokenizer.positionable_operators) || in_array(current_token.text, tokenizer.positionable_operators);

        if (operatorLogicApplies) {
            var shouldPrintOperatorNewline = (
                    in_array(flags.last_text, tokenizer.positionable_operators) &&
                    in_array(opt.operator_position, OPERATOR_POSITION_BEFORE_OR_PRESERVE)
                ) ||
                in_array(current_token.text, tokenizer.positionable_operators);
            shouldPreserveOrForce = shouldPreserveOrForce && shouldPrintOperatorNewline;
        }

        if (shouldPreserveOrForce) {
            print_newline(false, true);
        } else if (opt.wrap_line_length) {
            if (last_type === 'TK_RESERVED' && in_array(flags.last_text, newline_restricted_tokens)) {
                // These tokens should never have a newline inserted
                // between them and the following expression.
                return;
            }
            var proposed_line_length = output.current_line.get_character_count() + current_token.text.length +
                (output.space_before_token ? 1 : 0);
            if (proposed_line_length >= opt.wrap_line_length) {
                print_newline(false, true);
            }
        }
    }

    function print_newline(force_newline, preserve_statement_flags) {
        if (!preserve_statement_flags) {
            if (flags.last_text !== ';' && flags.last_text !== ',' && flags.last_text !== '=' && last_type !== 'TK_OPERATOR') {
                var next_token = get_token(1);
                while (flags.mode === MODE.Statement &&
                    !(flags.if_block && next_token && next_token.type === 'TK_RESERVED' && next_token.text === 'else') &&
                    !flags.do_block) {
                    restore_mode();
                }
            }
        }

        if (output.add_new_line(force_newline)) {
            flags.multiline_frame = true;
        }
    }

    function print_token_line_indentation() {
        if (output.just_added_newline()) {
            if (opt.keep_array_indentation && is_array(flags.mode) && current_token.wanted_newline) {
                output.current_line.push(current_token.whitespace_before);
                output.space_before_token = false;
            } else if (output.set_indent(flags.indentation_level)) {
                flags.line_indent_level = flags.indentation_level;
            }
        }
    }

    function print_token(printable_token) {
        if (output.raw) {
            output.add_raw_token(current_token);
            return;
        }

        if (opt.comma_first && last_type === 'TK_COMMA' &&
            output.just_added_newline()) {
            if (output.previous_line.last() === ',') {
                var popped = output.previous_line.pop();
                // if the comma was already at the start of the line,
                // pull back onto that line and reprint the indentation
                if (output.previous_line.is_empty()) {
                    output.previous_line.push(popped);
                    output.trim(true);
                    output.current_line.pop();
                    output.trim();
                }

                // add the comma in front of the next token
                print_token_line_indentation();
                output.add_token(',');
                output.space_before_token = true;
            }
        }

        printable_token = printable_token || current_token.text;
        print_token_line_indentation();
        output.add_token(printable_token);
    }

    function indent() {
        flags.indentation_level += 1;
    }

    function deindent() {
        if (flags.indentation_level > 0 &&
            ((!flags.parent) || flags.indentation_level > flags.parent.indentation_level)) {
            flags.indentation_level -= 1;

        }
    }

    function set_mode(mode) {
        if (flags) {
            flag_store.push(flags);
            previous_flags = flags;
        } else {
            previous_flags = create_flags(null, mode);
        }

        flags = create_flags(previous_flags, mode);
    }

    function is_array(mode) {
        return mode === MODE.ArrayLiteral;
    }

    function is_expression(mode) {
        return in_array(mode, [MODE.Expression, MODE.ForInitializer, MODE.Conditional]);
    }

    function restore_mode() {
        if (flag_store.length > 0) {
            previous_flags = flags;
            flags = flag_store.pop();
            if (previous_flags.mode === MODE.Statement && !opt.unindent_chained_methods) {
                remove_redundant_indentation(output, previous_flags);
            }
        }
    }

    function start_of_object_property() {
        return flags.parent.mode === MODE.ObjectLiteral && flags.mode === MODE.Statement && (
            (flags.last_text === ':' && flags.ternary_depth === 0) || (last_type === 'TK_RESERVED' && in_array(flags.last_text, ['get', 'set'])));
    }

    function start_of_statement() {
        if (
            (last_type === 'TK_RESERVED' && in_array(flags.last_text, ['var', 'let', 'const']) && current_token.type === 'TK_WORD') ||
            (last_type === 'TK_RESERVED' && flags.last_text === 'do') ||
            (last_type === 'TK_RESERVED' && in_array(flags.last_text, newline_restricted_tokens) && !current_token.wanted_newline) ||
            (last_type === 'TK_RESERVED' && flags.last_text === 'else' &&
                !(current_token.type === 'TK_RESERVED' && current_token.text === 'if' && !current_token.comments_before.length)) ||
            (last_type === 'TK_END_EXPR' && (previous_flags.mode === MODE.ForInitializer || previous_flags.mode === MODE.Conditional)) ||
            (last_type === 'TK_WORD' && flags.mode === MODE.BlockStatement &&
                !flags.in_case &&
                !(current_token.text === '--' || current_token.text === '++') &&
                last_last_text !== 'function' &&
                current_token.type !== 'TK_WORD' && current_token.type !== 'TK_RESERVED') ||
            (flags.mode === MODE.ObjectLiteral && (
                (flags.last_text === ':' && flags.ternary_depth === 0) || (last_type === 'TK_RESERVED' && in_array(flags.last_text, ['get', 'set']))))
        ) {

            set_mode(MODE.Statement);
            if (!opt.unindent_chained_methods) {
                indent();
            }

            handle_whitespace_and_comments(current_token, true);

            // Issue #276:
            // If starting a new statement with [if, for, while, do], push to a new line.
            // if (a) if (b) if(c) d(); else e(); else f();
            if (!start_of_object_property()) {
                allow_wrap_or_preserved_newline(
                    current_token.type === 'TK_RESERVED' && in_array(current_token.text, ['do', 'for', 'if', 'while']));
            }

            return true;
        }
        return false;
    }

    function all_lines_start_with(lines, c) {
        for (var i = 0; i < lines.length; i++) {
            var line = trim(lines[i]);
            if (line.charAt(0) !== c) {
                return false;
            }
        }
        return true;
    }

    function each_line_matches_indent(lines, indent) {
        var i = 0,
            len = lines.length,
            line;
        for (; i < len; i++) {
            line = lines[i];
            // allow empty lines to pass through
            if (line && line.indexOf(indent) !== 0) {
                return false;
            }
        }
        return true;
    }

    function is_special_word(word) {
        return in_array(word, ['case', 'return', 'do', 'if', 'throw', 'else']);
    }

    function get_token(offset) {
        var index = token_pos + (offset || 0);
        return (index < 0 || index >= tokens.length) ? null : tokens[index];
    }

    function handle_start_expr() {
        // The conditional starts the statement if appropriate.
        if (!start_of_statement()) {
            handle_whitespace_and_comments(current_token);
        }

        var next_mode = MODE.Expression;
        if (current_token.text === '[') {

            if (last_type === 'TK_WORD' || flags.last_text === ')') {
                // this is array index specifier, break immediately
                // a[x], fn()[x]
                if (last_type === 'TK_RESERVED' && in_array(flags.last_text, tokenizer.line_starters)) {
                    output.space_before_token = true;
                }
                set_mode(next_mode);
                print_token();
                indent();
                if (opt.space_in_paren) {
                    output.space_before_token = true;
                }
                return;
            }

            next_mode = MODE.ArrayLiteral;
            if (is_array(flags.mode)) {
                if (flags.last_text === '[' ||
                    (flags.last_text === ',' && (last_last_text === ']' || last_last_text === '}'))) {
                    // ], [ goes to new line
                    // }, [ goes to new line
                    if (!opt.keep_array_indentation) {
                        print_newline();
                    }
                }
            }

        } else {
            if (last_type === 'TK_RESERVED' && flags.last_text === 'for') {
                next_mode = MODE.ForInitializer;
            } else if (last_type === 'TK_RESERVED' && in_array(flags.last_text, ['if', 'while'])) {
                next_mode = MODE.Conditional;
            } else {
                // next_mode = MODE.Expression;
            }
        }

        if (flags.last_text === ';' || last_type === 'TK_START_BLOCK') {
            print_newline();
        } else if (last_type === 'TK_END_EXPR' || last_type === 'TK_START_EXPR' || last_type === 'TK_END_BLOCK' || flags.last_text === '.') {
            // TODO: Consider whether forcing this is required.  Review failing tests when removed.
            allow_wrap_or_preserved_newline(current_token.wanted_newline);
            // do nothing on (( and )( and ][ and ]( and .(
        } else if (!(last_type === 'TK_RESERVED' && current_token.text === '(') && last_type !== 'TK_WORD' && last_type !== 'TK_OPERATOR') {
            output.space_before_token = true;
        } else if ((last_type === 'TK_RESERVED' && (flags.last_word === 'function' || flags.last_word === 'typeof')) ||
            (flags.last_text === '*' &&
                (in_array(last_last_text, ['function', 'yield']) ||
                    (flags.mode === MODE.ObjectLiteral && in_array(last_last_text, ['{', ',']))))) {
            // function() vs function ()
            // yield*() vs yield* ()
            // function*() vs function* ()
            if (opt.space_after_anon_function) {
                output.space_before_token = true;
            }
        } else if (last_type === 'TK_RESERVED' && (in_array(flags.last_text, tokenizer.line_starters) || flags.last_text === 'catch')) {
            if (opt.space_before_conditional) {
                output.space_before_token = true;
            }
        }

        // Should be a space between await and an IIFE, or async and an arrow function
        if (current_token.text === '(' && last_type === 'TK_RESERVED' && in_array(flags.last_word, ['await', 'async'])) {
            output.space_before_token = true;
        }

        // Support of this kind of newline preservation.
        // a = (b &&
        //     (c || d));
        if (current_token.text === '(') {
            if (last_type === 'TK_EQUALS' || last_type === 'TK_OPERATOR') {
                if (!start_of_object_property()) {
                    allow_wrap_or_preserved_newline();
                }
            }
        }

        // Support preserving wrapped arrow function expressions
        // a.b('c',
        //     () => d.e
        // )
        if (current_token.text === '(' && last_type !== 'TK_WORD' && last_type !== 'TK_RESERVED') {
            allow_wrap_or_preserved_newline();
        }

        set_mode(next_mode);
        print_token();
        if (opt.space_in_paren) {
            output.space_before_token = true;
        }

        // In all cases, if we newline while inside an expression it should be indented.
        indent();
    }

    function handle_end_expr() {
        // statements inside expressions are not valid syntax, but...
        // statements must all be closed when their container closes
        while (flags.mode === MODE.Statement) {
            restore_mode();
        }

        handle_whitespace_and_comments(current_token);

        if (flags.multiline_frame) {
            allow_wrap_or_preserved_newline(current_token.text === ']' && is_array(flags.mode) && !opt.keep_array_indentation);
        }

        if (opt.space_in_paren) {
            if (last_type === 'TK_START_EXPR' && !opt.space_in_empty_paren) {
                // () [] no inner space in empty parens like these, ever, ref #320
                output.trim();
                output.space_before_token = false;
            } else {
                output.space_before_token = true;
            }
        }
        if (current_token.text === ']' && opt.keep_array_indentation) {
            print_token();
            restore_mode();
        } else {
            restore_mode();
            print_token();
        }
        remove_redundant_indentation(output, previous_flags);

        // do {} while () // no statement required after
        if (flags.do_while && previous_flags.mode === MODE.Conditional) {
            previous_flags.mode = MODE.Expression;
            flags.do_block = false;
            flags.do_while = false;

        }
    }

    function handle_start_block() {
        handle_whitespace_and_comments(current_token);

        // Check if this is should be treated as a ObjectLiteral
        var next_token = get_token(1);
        var second_token = get_token(2);
        if (second_token && (
                (in_array(second_token.text, [':', ',']) && in_array(next_token.type, ['TK_STRING', 'TK_WORD', 'TK_RESERVED'])) ||
                (in_array(next_token.text, ['get', 'set', '...']) && in_array(second_token.type, ['TK_WORD', 'TK_RESERVED']))
            )) {
            // We don't support TypeScript,but we didn't break it for a very long time.
            // We'll try to keep not breaking it.
            if (!in_array(last_last_text, ['class', 'interface'])) {
                set_mode(MODE.ObjectLiteral);
            } else {
                set_mode(MODE.BlockStatement);
            }
        } else if (last_type === 'TK_OPERATOR' && flags.last_text === '=>') {
            // arrow function: (param1, paramN) => { statements }
            set_mode(MODE.BlockStatement);
        } else if (in_array(last_type, ['TK_EQUALS', 'TK_START_EXPR', 'TK_COMMA', 'TK_OPERATOR']) ||
            (last_type === 'TK_RESERVED' && in_array(flags.last_text, ['return', 'throw', 'import', 'default']))
        ) {
            // Detecting shorthand function syntax is difficult by scanning forward,
            //     so check the surrounding context.
            // If the block is being returned, imported, export default, passed as arg,
            //     assigned with = or assigned in a nested object, treat as an ObjectLiteral.
            set_mode(MODE.ObjectLiteral);
        } else {
            set_mode(MODE.BlockStatement);
        }

        var empty_braces = !next_token.comments_before.length && next_token.text === '}';
        var empty_anonymous_function = empty_braces && flags.last_word === 'function' &&
            last_type === 'TK_END_EXPR';

        if (opt.brace_preserve_inline) // check for inline, set inline_frame if so
        {
            // search forward for a newline wanted inside this block
            var index = 0;
            var check_token = null;
            flags.inline_frame = true;
            do {
                index += 1;
                check_token = get_token(index);
                if (check_token.wanted_newline) {
                    flags.inline_frame = false;
                    break;
                }
            } while (check_token.type !== 'TK_EOF' &&
                !(check_token.type === 'TK_END_BLOCK' && check_token.opened === current_token));
        }

        if ((opt.brace_style === "expand" ||
                (opt.brace_style === "none" && current_token.wanted_newline)) &&
            !flags.inline_frame) {
            if (last_type !== 'TK_OPERATOR' &&
                (empty_anonymous_function ||
                    last_type === 'TK_EQUALS' ||
                    (last_type === 'TK_RESERVED' && is_special_word(flags.last_text) && flags.last_text !== 'else'))) {
                output.space_before_token = true;
            } else {
                print_newline(false, true);
            }
        } else { // collapse || inline_frame
            if (is_array(previous_flags.mode) && (last_type === 'TK_START_EXPR' || last_type === 'TK_COMMA')) {
                if (last_type === 'TK_COMMA' || opt.space_in_paren) {
                    output.space_before_token = true;
                }

                if (last_type === 'TK_COMMA' || (last_type === 'TK_START_EXPR' && flags.inline_frame)) {
                    allow_wrap_or_preserved_newline();
                    previous_flags.multiline_frame = previous_flags.multiline_frame || flags.multiline_frame;
                    flags.multiline_frame = false;
                }
            }
            if (last_type !== 'TK_OPERATOR' && last_type !== 'TK_START_EXPR') {
                if (last_type === 'TK_START_BLOCK' && !flags.inline_frame) {
                    print_newline();
                } else {
                    output.space_before_token = true;
                }
            }
        }
        print_token();
        indent();
    }

    function handle_end_block() {
        // statements must all be closed when their container closes
        handle_whitespace_and_comments(current_token);

        while (flags.mode === MODE.Statement) {
            restore_mode();
        }

        var empty_braces = last_type === 'TK_START_BLOCK';

        if (flags.inline_frame && !empty_braces) { // try inline_frame (only set if opt.braces-preserve-inline) first
            output.space_before_token = true;
        } else if (opt.brace_style === "expand") {
            if (!empty_braces) {
                print_newline();
            }
        } else {
            // skip {}
            if (!empty_braces) {
                if (is_array(flags.mode) && opt.keep_array_indentation) {
                    // we REALLY need a newline here, but newliner would skip that
                    opt.keep_array_indentation = false;
                    print_newline();
                    opt.keep_array_indentation = true;

                } else {
                    print_newline();
                }
            }
        }
        restore_mode();
        print_token();
    }

    function handle_word() {
        if (current_token.type === 'TK_RESERVED') {
            if (in_array(current_token.text, ['set', 'get']) && flags.mode !== MODE.ObjectLiteral) {
                current_token.type = 'TK_WORD';
            } else if (in_array(current_token.text, ['as', 'from']) && !flags.import_block) {
                current_token.type = 'TK_WORD';
            } else if (flags.mode === MODE.ObjectLiteral) {
                var next_token = get_token(1);
                if (next_token.text === ':') {
                    current_token.type = 'TK_WORD';
                }
            }
        }

        if (start_of_statement()) {
            // The conditional starts the statement if appropriate.
            if (last_type === 'TK_RESERVED' && in_array(flags.last_text, ['var', 'let', 'const']) && current_token.type === 'TK_WORD') {
                flags.declaration_statement = true;
            }
        } else if (current_token.wanted_newline && !is_expression(flags.mode) &&
            (last_type !== 'TK_OPERATOR' || (flags.last_text === '--' || flags.last_text === '++')) &&
            last_type !== 'TK_EQUALS' &&
            (opt.preserve_newlines || !(last_type === 'TK_RESERVED' && in_array(flags.last_text, ['var', 'let', 'const', 'set', 'get'])))) {
            handle_whitespace_and_comments(current_token);
            print_newline();
        } else {
            handle_whitespace_and_comments(current_token);
        }

        if (flags.do_block && !flags.do_while) {
            if (current_token.type === 'TK_RESERVED' && current_token.text === 'while') {
                // do {} ## while ()
                output.space_before_token = true;
                print_token();
                output.space_before_token = true;
                flags.do_while = true;
                return;
            } else {
                // do {} should always have while as the next word.
                // if we don't see the expected while, recover
                print_newline();
                flags.do_block = false;
            }
        }

        // if may be followed by else, or not
        // Bare/inline ifs are tricky
        // Need to unwind the modes correctly: if (a) if (b) c(); else d(); else e();
        if (flags.if_block) {
            if (!flags.else_block && (current_token.type === 'TK_RESERVED' && current_token.text === 'else')) {
                flags.else_block = true;
            } else {
                while (flags.mode === MODE.Statement) {
                    restore_mode();
                }
                flags.if_block = false;
                flags.else_block = false;
            }
        }

        if (current_token.type === 'TK_RESERVED' && (current_token.text === 'case' || (current_token.text === 'default' && flags.in_case_statement))) {
            print_newline();
            if (flags.case_body || opt.jslint_happy) {
                // switch cases following one another
                deindent();
                flags.case_body = false;
            }
            print_token();
            flags.in_case = true;
            flags.in_case_statement = true;
            return;
        }

        if (last_type === 'TK_COMMA' || last_type === 'TK_START_EXPR' || last_type === 'TK_EQUALS' || last_type === 'TK_OPERATOR') {
            if (!start_of_object_property()) {
                allow_wrap_or_preserved_newline();
            }
        }

        if (current_token.type === 'TK_RESERVED' && current_token.text === 'function') {
            if (in_array(flags.last_text, ['}', ';']) ||
                (output.just_added_newline() && !(in_array(flags.last_text, ['(', '[', '{', ':', '=', ',']) || last_type === 'TK_OPERATOR'))) {
                // make sure there is a nice clean space of at least one blank line
                // before a new function definition
                if (!output.just_added_blankline() && !current_token.comments_before.length) {
                    print_newline();
                    print_newline(true);
                }
            }
            if (last_type === 'TK_RESERVED' || last_type === 'TK_WORD') {
                if (last_type === 'TK_RESERVED' && (
                        in_array(flags.last_text, ['get', 'set', 'new', 'export', 'async']) ||
                        in_array(flags.last_text, newline_restricted_tokens))) {
                    output.space_before_token = true;
                } else if (last_type === 'TK_RESERVED' && flags.last_text === 'default' && last_last_text === 'export') {
                    output.space_before_token = true;
                } else {
                    print_newline();
                }
            } else if (last_type === 'TK_OPERATOR' || flags.last_text === '=') {
                // foo = function
                output.space_before_token = true;
            } else if (!flags.multiline_frame && (is_expression(flags.mode) || is_array(flags.mode))) {
                // (function
            } else {
                print_newline();
            }

            print_token();
            flags.last_word = current_token.text;
            return;
        }

        prefix = 'NONE';

        if (last_type === 'TK_END_BLOCK') {

            if (previous_flags.inline_frame) {
                prefix = 'SPACE';
            } else if (!(current_token.type === 'TK_RESERVED' && in_array(current_token.text, ['else', 'catch', 'finally', 'from']))) {
                prefix = 'NEWLINE';
            } else {
                if (opt.brace_style === "expand" ||
                    opt.brace_style === "end-expand" ||
                    (opt.brace_style === "none" && current_token.wanted_newline)) {
                    prefix = 'NEWLINE';
                } else {
                    prefix = 'SPACE';
                    output.space_before_token = true;
                }
            }
        } else if (last_type === 'TK_SEMICOLON' && flags.mode === MODE.BlockStatement) {
            // TODO: Should this be for STATEMENT as well?
            prefix = 'NEWLINE';
        } else if (last_type === 'TK_SEMICOLON' && is_expression(flags.mode)) {
            prefix = 'SPACE';
        } else if (last_type === 'TK_STRING') {
            prefix = 'NEWLINE';
        } else if (last_type === 'TK_RESERVED' || last_type === 'TK_WORD' ||
            (flags.last_text === '*' &&
                (in_array(last_last_text, ['function', 'yield']) ||
                    (flags.mode === MODE.ObjectLiteral && in_array(last_last_text, ['{', ',']))))) {
            prefix = 'SPACE';
        } else if (last_type === 'TK_START_BLOCK') {
            if (flags.inline_frame) {
                prefix = 'SPACE';
            } else {
                prefix = 'NEWLINE';
            }
        } else if (last_type === 'TK_END_EXPR') {
            output.space_before_token = true;
            prefix = 'NEWLINE';
        }

        if (current_token.type === 'TK_RESERVED' && in_array(current_token.text, tokenizer.line_starters) && flags.last_text !== ')') {
            if (flags.inline_frame || flags.last_text === 'else' || flags.last_text === 'export') {
                prefix = 'SPACE';
            } else {
                prefix = 'NEWLINE';
            }

        }

        if (current_token.type === 'TK_RESERVED' && in_array(current_token.text, ['else', 'catch', 'finally'])) {
            if ((!(last_type === 'TK_END_BLOCK' && previous_flags.mode === MODE.BlockStatement) ||
                    opt.brace_style === "expand" ||
                    opt.brace_style === "end-expand" ||
                    (opt.brace_style === "none" && current_token.wanted_newline)) &&
                !flags.inline_frame) {
                print_newline();
            } else {
                output.trim(true);
                var line = output.current_line;
                // If we trimmed and there's something other than a close block before us
                // put a newline back in.  Handles '} // comment' scenario.
                if (line.last() !== '}') {
                    print_newline();
                }
                output.space_before_token = true;
            }
        } else if (prefix === 'NEWLINE') {
            if (last_type === 'TK_RESERVED' && is_special_word(flags.last_text)) {
                // no newline between 'return nnn'
                output.space_before_token = true;
            } else if (last_type !== 'TK_END_EXPR') {
                if ((last_type !== 'TK_START_EXPR' || !(current_token.type === 'TK_RESERVED' && in_array(current_token.text, ['var', 'let', 'const']))) && flags.last_text !== ':') {
                    // no need to force newline on 'var': for (var x = 0...)
                    if (current_token.type === 'TK_RESERVED' && current_token.text === 'if' && flags.last_text === 'else') {
                        // no newline for } else if {
                        output.space_before_token = true;
                    } else {
                        print_newline();
                    }
                }
            } else if (current_token.type === 'TK_RESERVED' && in_array(current_token.text, tokenizer.line_starters) && flags.last_text !== ')') {
                print_newline();
            }
        } else if (flags.multiline_frame && is_array(flags.mode) && flags.last_text === ',' && last_last_text === '}') {
            print_newline(); // }, in lists get a newline treatment
        } else if (prefix === 'SPACE') {
            output.space_before_token = true;
        }
        print_token();
        flags.last_word = current_token.text;

        if (current_token.type === 'TK_RESERVED') {
            if (current_token.text === 'do') {
                flags.do_block = true;
            } else if (current_token.text === 'if') {
                flags.if_block = true;
            } else if (current_token.text === 'import') {
                flags.import_block = true;
            } else if (flags.import_block && current_token.type === 'TK_RESERVED' && current_token.text === 'from') {
                flags.import_block = false;
            }
        }
    }

    function handle_semicolon() {
        if (start_of_statement()) {
            // The conditional starts the statement if appropriate.
            // Semicolon can be the start (and end) of a statement
            output.space_before_token = false;
        } else {
            handle_whitespace_and_comments(current_token);
        }

        var next_token = get_token(1);
        while (flags.mode === MODE.Statement &&
            !(flags.if_block && next_token && next_token.type === 'TK_RESERVED' && next_token.text === 'else') &&
            !flags.do_block) {
            restore_mode();
        }

        // hacky but effective for the moment
        if (flags.import_block) {
            flags.import_block = false;
        }
        print_token();
    }

    function handle_string() {
        if (start_of_statement()) {
            // The conditional starts the statement if appropriate.
            // One difference - strings want at least a space before
            output.space_before_token = true;
        } else {
            handle_whitespace_and_comments(current_token);
            if (last_type === 'TK_RESERVED' || last_type === 'TK_WORD' || flags.inline_frame) {
                output.space_before_token = true;
            } else if (last_type === 'TK_COMMA' || last_type === 'TK_START_EXPR' || last_type === 'TK_EQUALS' || last_type === 'TK_OPERATOR') {
                if (!start_of_object_property()) {
                    allow_wrap_or_preserved_newline();
                }
            } else {
                print_newline();
            }
        }
        print_token();
    }

    function handle_equals() {
        if (start_of_statement()) {
            // The conditional starts the statement if appropriate.
        } else {
            handle_whitespace_and_comments(current_token);
        }

        if (flags.declaration_statement) {
            // just got an '=' in a var-line, different formatting/line-breaking, etc will now be done
            flags.declaration_assignment = true;
        }
        output.space_before_token = true;
        print_token();
        output.space_before_token = true;
    }

    function handle_comma() {
        handle_whitespace_and_comments(current_token, true);

        print_token();
        output.space_before_token = true;
        if (flags.declaration_statement) {
            if (is_expression(flags.parent.mode)) {
                // do not break on comma, for(var a = 1, b = 2)
                flags.declaration_assignment = false;
            }

            if (flags.declaration_assignment) {
                flags.declaration_assignment = false;
                print_newline(false, true);
            } else if (opt.comma_first) {
                // for comma-first, we want to allow a newline before the comma
                // to turn into a newline after the comma, which we will fixup later
                allow_wrap_or_preserved_newline();
            }
        } else if (flags.mode === MODE.ObjectLiteral ||
            (flags.mode === MODE.Statement && flags.parent.mode === MODE.ObjectLiteral)) {
            if (flags.mode === MODE.Statement) {
                restore_mode();
            }

            if (!flags.inline_frame) {
                print_newline();
            }
        } else if (opt.comma_first) {
            // EXPR or DO_BLOCK
            // for comma-first, we want to allow a newline before the comma
            // to turn into a newline after the comma, which we will fixup later
            allow_wrap_or_preserved_newline();
        }
    }

    function handle_operator() {
        var isGeneratorAsterisk = current_token.text === '*' &&
            ((last_type === 'TK_RESERVED' && in_array(flags.last_text, ['function', 'yield'])) ||
                (in_array(last_type, ['TK_START_BLOCK', 'TK_COMMA', 'TK_END_BLOCK', 'TK_SEMICOLON']))
            );
        var isUnary = in_array(current_token.text, ['-', '+']) && (
            in_array(last_type, ['TK_START_BLOCK', 'TK_START_EXPR', 'TK_EQUALS', 'TK_OPERATOR']) ||
            in_array(flags.last_text, tokenizer.line_starters) ||
            flags.last_text === ','
        );

        if (start_of_statement()) {
            // The conditional starts the statement if appropriate.
        } else {
            var preserve_statement_flags = !isGeneratorAsterisk;
            handle_whitespace_and_comments(current_token, preserve_statement_flags);
        }

        if (last_type === 'TK_RESERVED' && is_special_word(flags.last_text)) {
            // "return" had a special handling in TK_WORD. Now we need to return the favor
            output.space_before_token = true;
            print_token();
            return;
        }

        // hack for actionscript's import .*;
        if (current_token.text === '*' && last_type === 'TK_DOT') {
            print_token();
            return;
        }

        if (current_token.text === '::') {
            // no spaces around exotic namespacing syntax operator
            print_token();
            return;
        }

        // Allow line wrapping between operators when operator_position is
        //   set to before or preserve
        if (last_type === 'TK_OPERATOR' && in_array(opt.operator_position, OPERATOR_POSITION_BEFORE_OR_PRESERVE)) {
            allow_wrap_or_preserved_newline();
        }

        if (current_token.text === ':' && flags.in_case) {
            flags.case_body = true;
            indent();
            print_token();
            print_newline();
            flags.in_case = false;
            return;
        }

        var space_before = true;
        var space_after = true;
        var in_ternary = false;
        if (current_token.text === ':') {
            if (flags.ternary_depth === 0) {
                // Colon is invalid javascript outside of ternary and object, but do our best to guess what was meant.
                space_before = false;
            } else {
                flags.ternary_depth -= 1;
                in_ternary = true;
            }
        } else if (current_token.text === '?') {
            flags.ternary_depth += 1;
        }

        // let's handle the operator_position option prior to any conflicting logic
        if (!isUnary && !isGeneratorAsterisk && opt.preserve_newlines && in_array(current_token.text, tokenizer.positionable_operators)) {
            var isColon = current_token.text === ':';
            var isTernaryColon = (isColon && in_ternary);
            var isOtherColon = (isColon && !in_ternary);

            switch (opt.operator_position) {
                case OPERATOR_POSITION.before_newline:
                    // if the current token is : and it's not a ternary statement then we set space_before to false
                    output.space_before_token = !isOtherColon;

                    print_token();

                    if (!isColon || isTernaryColon) {
                        allow_wrap_or_preserved_newline();
                    }

                    output.space_before_token = true;
                    return;

                case OPERATOR_POSITION.after_newline:
                    // if the current token is anything but colon, or (via deduction) it's a colon and in a ternary statement,
                    //   then print a newline.

                    output.space_before_token = true;

                    if (!isColon || isTernaryColon) {
                        if (get_token(1).wanted_newline) {
                            print_newline(false, true);
                        } else {
                            allow_wrap_or_preserved_newline();
                        }
                    } else {
                        output.space_before_token = false;
                    }

                    print_token();

                    output.space_before_token = true;
                    return;

                case OPERATOR_POSITION.preserve_newline:
                    if (!isOtherColon) {
                        allow_wrap_or_preserved_newline();
                    }

                    // if we just added a newline, or the current token is : and it's not a ternary statement,
                    //   then we set space_before to false
                    space_before = !(output.just_added_newline() || isOtherColon);

                    output.space_before_token = space_before;
                    print_token();
                    output.space_before_token = true;
                    return;
            }
        }

        if (isGeneratorAsterisk) {
            allow_wrap_or_preserved_newline();
            space_before = false;
            var next_token = get_token(1);
            space_after = next_token && in_array(next_token.type, ['TK_WORD', 'TK_RESERVED']);
        } else if (current_token.text === '...') {
            allow_wrap_or_preserved_newline();
            space_before = last_type === 'TK_START_BLOCK';
            space_after = false;
        } else if (in_array(current_token.text, ['--', '++', '!', '~']) || isUnary) {
            // unary operators (and binary +/- pretending to be unary) special cases

            space_before = false;
            space_after = false;

            // http://www.ecma-international.org/ecma-262/5.1/#sec-7.9.1
            // if there is a newline between -- or ++ and anything else we should preserve it.
            if (current_token.wanted_newline && (current_token.text === '--' || current_token.text === '++')) {
                print_newline(false, true);
            }

            if (flags.last_text === ';' && is_expression(flags.mode)) {
                // for (;; ++i)
                //        ^^^
                space_before = true;
            }

            if (last_type === 'TK_RESERVED') {
                space_before = true;
            } else if (last_type === 'TK_END_EXPR') {
                space_before = !(flags.last_text === ']' && (current_token.text === '--' || current_token.text === '++'));
            } else if (last_type === 'TK_OPERATOR') {
                // a++ + ++b;
                // a - -b
                space_before = in_array(current_token.text, ['--', '-', '++', '+']) && in_array(flags.last_text, ['--', '-', '++', '+']);
                // + and - are not unary when preceeded by -- or ++ operator
                // a-- + b
                // a * +b
                // a - -b
                if (in_array(current_token.text, ['+', '-']) && in_array(flags.last_text, ['--', '++'])) {
                    space_after = true;
                }
            }


            if (((flags.mode === MODE.BlockStatement && !flags.inline_frame) || flags.mode === MODE.Statement) &&
                (flags.last_text === '{' || flags.last_text === ';')) {
                // { foo; --i }
                // foo(); --bar;
                print_newline();
            }
        }

        output.space_before_token = output.space_before_token || space_before;
        print_token();
        output.space_before_token = space_after;
    }

    function handle_block_comment(preserve_statement_flags) {
        if (output.raw) {
            output.add_raw_token(current_token);
            if (current_token.directives && current_token.directives.preserve === 'end') {
                // If we're testing the raw output behavior, do not allow a directive to turn it off.
                output.raw = opt.test_output_raw;
            }
            return;
        }

        if (current_token.directives) {
            print_newline(false, preserve_statement_flags);
            print_token();
            if (current_token.directives.preserve === 'start') {
                output.raw = true;
            }
            print_newline(false, true);
            return;
        }

        // inline block
        if (!acorn.newline.test(current_token.text) && !current_token.wanted_newline) {
            output.space_before_token = true;
            print_token();
            output.space_before_token = true;
            return;
        }

        var lines = split_linebreaks(current_token.text);
        var j; // iterator for this case
        var javadoc = false;
        var starless = false;
        var lastIndent = current_token.whitespace_before;
        var lastIndentLength = lastIndent.length;

        // block comment starts with a new line
        print_newline(false, preserve_statement_flags);
        if (lines.length > 1) {
            javadoc = all_lines_start_with(lines.slice(1), '*');
            starless = each_line_matches_indent(lines.slice(1), lastIndent);
        }

        // first line always indented
        print_token(lines[0]);
        for (j = 1; j < lines.length; j++) {
            print_newline(false, true);
            if (javadoc) {
                // javadoc: reformat and re-indent
                print_token(' ' + ltrim(lines[j]));
            } else if (starless && lines[j].length > lastIndentLength) {
                // starless: re-indent non-empty content, avoiding trim
                print_token(lines[j].substring(lastIndentLength));
            } else {
                // normal comments output raw
                output.add_token(lines[j]);
            }
        }

        // for comments of more than one line, make sure there's a new line after
        print_newline(false, preserve_statement_flags);
    }

    function handle_comment(preserve_statement_flags) {
        if (current_token.wanted_newline) {
            print_newline(false, preserve_statement_flags);
        } else {
            output.trim(true);
        }

        output.space_before_token = true;
        print_token();
        print_newline(false, preserve_statement_flags);
    }

    function handle_dot() {
        if (start_of_statement()) {
            // The conditional starts the statement if appropriate.
        } else {
            handle_whitespace_and_comments(current_token, true);
        }

        if (last_type === 'TK_RESERVED' && is_special_word(flags.last_text)) {
            output.space_before_token = true;
        } else {
            // allow preserved newlines before dots in general
            // force newlines on dots after close paren when break_chained - for bar().baz()
            allow_wrap_or_preserved_newline(flags.last_text === ')' && opt.break_chained_methods);
        }

        print_token();
    }

    function handle_unknown(preserve_statement_flags) {
        print_token();

        if (current_token.text[current_token.text.length - 1] === '\n') {
            print_newline(false, preserve_statement_flags);
        }
    }

    function handle_eof() {
        // Unwind any open statements
        while (flags.mode === MODE.Statement) {
            restore_mode();
        }
        handle_whitespace_and_comments(current_token);
    }
}

module.exports.Beautifier = Beautifier;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*jshint curly:true, eqeqeq:true, laxbreak:true, noempty:false */
/*

  The MIT License (MIT)

  Copyright (c) 2007-2017 Einar Lielmanis, Liam Newman, and contributors.

  Permission is hereby granted, free of charge, to any person
  obtaining a copy of this software and associated documentation files
  (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge,
  publish, distribute, sublicense, and/or sell copies of the Software,
  and to permit persons to whom the Software is furnished to do so,
  subject to the following conditions:

  The above copyright notice and this permission notice shall be
  included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.
*/

function InputScanner(input) {
    var _input = input;
    var _input_length = _input.length;
    var _position = 0;

    this.back = function() {
        _position -= 1;
    };

    this.hasNext = function() {
        return _position < _input_length;
    };

    this.next = function() {
        var val = null;
        if (this.hasNext()) {
            val = _input.charAt(_position);
            _position += 1;
        }
        return val;
    };

    this.peek = function(index) {
        var val = null;
        index = index || 0;
        index += _position;
        if (index >= 0 && index < _input_length) {
            val = _input.charAt(index);
        }
        return val;
    };

    this.peekCharCode = function(index) {
        var val = 0;
        index = index || 0;
        index += _position;
        if (index >= 0 && index < _input_length) {
            val = _input.charCodeAt(index);
        }
        return val;
    };

    this.test = function(pattern, index) {
        index = index || 0;
        pattern.lastIndex = _position + index;
        return pattern.test(_input);
    };

    this.testChar = function(pattern, index) {
        var val = this.peek(index);
        return val !== null && pattern.test(val);
    };

    this.match = function(pattern) {
        pattern.lastIndex = _position;
        var pattern_match = pattern.exec(_input);
        if (pattern_match && pattern_match.index === _position) {
            _position += pattern_match[0].length;
        } else {
            pattern_match = null;
        }
        return pattern_match;
    };
}


module.exports.InputScanner = InputScanner;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

/*jshint curly:true, eqeqeq:true, laxbreak:true, noempty:false */
/*

    The MIT License (MIT)

    Copyright (c) 2007-2017 Einar Lielmanis, Liam Newman, and contributors.

    Permission is hereby granted, free of charge, to any person
    obtaining a copy of this software and associated documentation files
    (the "Software"), to deal in the Software without restriction,
    including without limitation the rights to use, copy, modify, merge,
    publish, distribute, sublicense, and/or sell copies of the Software,
    and to permit persons to whom the Software is furnished to do so,
    subject to the following conditions:

    The above copyright notice and this permission notice shall be
    included in all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
    EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
    NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
    BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
    ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
    CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    SOFTWARE.
*/

function mergeOpts(allOptions, targetType) {
    var finalOpts = {};
    var name;

    for (name in allOptions) {
        if (name !== targetType) {
            finalOpts[name] = allOptions[name];
        }
    }

    //merge in the per type settings for the targetType
    if (targetType in allOptions) {
        for (name in allOptions[targetType]) {
            finalOpts[name] = allOptions[targetType][name];
        }
    }
    return finalOpts;
}

module.exports.mergeOpts = mergeOpts;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

/*jshint curly:true, eqeqeq:true, laxbreak:true, noempty:false */
/*

  The MIT License (MIT)

  Copyright (c) 2007-2017 Einar Lielmanis, Liam Newman, and contributors.

  Permission is hereby granted, free of charge, to any person
  obtaining a copy of this software and associated documentation files
  (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge,
  publish, distribute, sublicense, and/or sell copies of the Software,
  and to permit persons to whom the Software is furnished to do so,
  subject to the following conditions:

  The above copyright notice and this permission notice shall be
  included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.
*/

function OutputLine(parent) {
    var _character_count = 0;
    // use indent_count as a marker for lines that have preserved indentation
    var _indent_count = -1;

    var _items = [];
    var _empty = true;

    this.set_indent = function(level) {
        _character_count = parent.baseIndentLength + level * parent.indent_length;
        _indent_count = level;
    };

    this.get_character_count = function() {
        return _character_count;
    };

    this.is_empty = function() {
        return _empty;
    };

    this.last = function() {
        if (!this._empty) {
            return _items[_items.length - 1];
        } else {
            return null;
        }
    };

    this.push = function(input) {
        _items.push(input);
        _character_count += input.length;
        _empty = false;
    };

    this.pop = function() {
        var item = null;
        if (!_empty) {
            item = _items.pop();
            _character_count -= item.length;
            _empty = _items.length === 0;
        }
        return item;
    };

    this.remove_indent = function() {
        if (_indent_count > 0) {
            _indent_count -= 1;
            _character_count -= parent.indent_length;
        }
    };

    this.trim = function() {
        while (this.last() === ' ') {
            _items.pop();
            _character_count -= 1;
        }
        _empty = _items.length === 0;
    };

    this.toString = function() {
        var result = '';
        if (!this._empty) {
            if (_indent_count >= 0) {
                result = parent.indent_cache[_indent_count];
            }
            result += _items.join('');
        }
        return result;
    };
}

function Output(indent_string, baseIndentString) {
    baseIndentString = baseIndentString || '';
    this.indent_cache = [baseIndentString];
    this.baseIndentLength = baseIndentString.length;
    this.indent_length = indent_string.length;
    this.raw = false;

    var lines = [];
    this.baseIndentString = baseIndentString;
    this.indent_string = indent_string;
    this.previous_line = null;
    this.current_line = null;
    this.space_before_token = false;

    this.add_outputline = function() {
        this.previous_line = this.current_line;
        this.current_line = new OutputLine(this);
        lines.push(this.current_line);
    };

    // initialize
    this.add_outputline();


    this.get_line_number = function() {
        return lines.length;
    };

    // Using object instead of string to allow for later expansion of info about each line
    this.add_new_line = function(force_newline) {
        if (this.get_line_number() === 1 && this.just_added_newline()) {
            return false; // no newline on start of file
        }

        if (force_newline || !this.just_added_newline()) {
            if (!this.raw) {
                this.add_outputline();
            }
            return true;
        }

        return false;
    };

    this.get_code = function(end_with_newline, eol) {
        var sweet_code = lines.join('\n').replace(/[\r\n\t ]+$/, '');

        if (end_with_newline) {
            sweet_code += '\n';
        }

        if (eol !== '\n') {
            sweet_code = sweet_code.replace(/[\n]/g, eol);
        }

        return sweet_code;
    };

    this.set_indent = function(level) {
        // Never indent your first output indent at the start of the file
        if (lines.length > 1) {
            while (level >= this.indent_cache.length) {
                this.indent_cache.push(this.indent_cache[this.indent_cache.length - 1] + this.indent_string);
            }

            this.current_line.set_indent(level);
            return true;
        }
        this.current_line.set_indent(0);
        return false;
    };

    this.add_raw_token = function(token) {
        for (var x = 0; x < token.newlines; x++) {
            this.add_outputline();
        }
        this.current_line.push(token.whitespace_before);
        this.current_line.push(token.text);
        this.space_before_token = false;
    };

    this.add_token = function(printable_token) {
        this.add_space_before_token();
        this.current_line.push(printable_token);
    };

    this.add_space_before_token = function() {
        if (this.space_before_token && !this.just_added_newline()) {
            this.current_line.push(' ');
        }
        this.space_before_token = false;
    };

    this.remove_indent = function(index) {
        var output_length = lines.length;
        while (index < output_length) {
            lines[index].remove_indent();
            index++;
        }
    };

    this.trim = function(eat_newlines) {
        eat_newlines = (eat_newlines === undefined) ? false : eat_newlines;

        this.current_line.trim(indent_string, baseIndentString);

        while (eat_newlines && lines.length > 1 &&
            this.current_line.is_empty()) {
            lines.pop();
            this.current_line = lines[lines.length - 1];
            this.current_line.trim();
        }

        this.previous_line = lines.length > 1 ? lines[lines.length - 2] : null;
    };

    this.just_added_newline = function() {
        return this.current_line.is_empty();
    };

    this.just_added_blankline = function() {
        if (this.just_added_newline()) {
            if (lines.length === 1) {
                return true; // start of the file and newline = blank
            }

            var line = lines[lines.length - 2];
            return line.is_empty();
        }
        return false;
    };
}

module.exports.Output = Output;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*jshint curly:true, eqeqeq:true, laxbreak:true, noempty:false */
/*

  The MIT License (MIT)

  Copyright (c) 2007-2017 Einar Lielmanis, Liam Newman, and contributors.

  Permission is hereby granted, free of charge, to any person
  obtaining a copy of this software and associated documentation files
  (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge,
  publish, distribute, sublicense, and/or sell copies of the Software,
  and to permit persons to whom the Software is furnished to do so,
  subject to the following conditions:

  The above copyright notice and this permission notice shall be
  included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.
*/

function Token(type, text, newlines, whitespace_before, parent) {
    this.type = type;
    this.text = text;

    // comments_before are
    // comments that have a new line before them
    // and may or may not have a newline after
    // this is a set of comments before
    this.comments_before = /* inline comment*/ [];


    this.comments_after = []; // no new line before and newline after
    this.newlines = newlines || 0;
    this.wanted_newline = newlines > 0;
    this.whitespace_before = whitespace_before || '';
    this.parent = parent || null;
    this.opened = null;
    this.directives = null;
}

module.exports.Token = Token;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/*jshint curly:true, eqeqeq:true, laxbreak:true, noempty:false */
/*

    The MIT License (MIT)

    Copyright (c) 2007-2017 Einar Lielmanis, Liam Newman, and contributors.

    Permission is hereby granted, free of charge, to any person
    obtaining a copy of this software and associated documentation files
    (the "Software"), to deal in the Software without restriction,
    including without limitation the rights to use, copy, modify, merge,
    publish, distribute, sublicense, and/or sell copies of the Software,
    and to permit persons to whom the Software is furnished to do so,
    subject to the following conditions:

    The above copyright notice and this permission notice shall be
    included in all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
    EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
    NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
    BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
    ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
    CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    SOFTWARE.
*/

var Beautifier = __webpack_require__(1).Beautifier;

function js_beautify(js_source_text, options) {
    var beautifier = new Beautifier(js_source_text, options);
    return beautifier.beautify();
}

module.exports = js_beautify;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/*jshint curly:true, eqeqeq:true, laxbreak:true, noempty:false */
/*

    The MIT License (MIT)

    Copyright (c) 2007-2017 Einar Lielmanis, Liam Newman, and contributors.

    Permission is hereby granted, free of charge, to any person
    obtaining a copy of this software and associated documentation files
    (the "Software"), to deal in the Software without restriction,
    including without limitation the rights to use, copy, modify, merge,
    publish, distribute, sublicense, and/or sell copies of the Software,
    and to permit persons to whom the Software is furnished to do so,
    subject to the following conditions:

    The above copyright notice and this permission notice shall be
    included in all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
    EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
    NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
    BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
    ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
    CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    SOFTWARE.
*/

var InputScanner = __webpack_require__(2).InputScanner;
var Token = __webpack_require__(5).Token;
var acorn = __webpack_require__(0);

function trim(s) {
    return s.replace(/^\s+|\s+$/g, '');
}

function in_array(what, arr) {
    for (var i = 0; i < arr.length; i += 1) {
        if (arr[i] === what) {
            return true;
        }
    }
    return false;
}

function Tokenizer(input_string, opts) {

    var whitespace = "\n\r\t ".split('');
    var digit = /[0-9]/;
    var digit_bin = /[01]/;
    var digit_oct = /[01234567]/;
    var digit_hex = /[0123456789abcdefABCDEF]/;

    this.positionable_operators = '!= !== % & && * ** + - / : < << <= == === > >= >> >>> ? ^ | ||'.split(' ');
    var punct = this.positionable_operators.concat(
        // non-positionable operators - these do not follow operator position settings
        '! %= &= *= **= ++ += , -- -= /= :: <<= = => >>= >>>= ^= |= ~ ...'.split(' '));

    // words which should always start on new line.
    this.line_starters = 'continue,try,throw,return,var,let,const,if,switch,case,default,for,while,break,function,import,export'.split(',');
    var reserved_words = this.line_starters.concat(['do', 'in', 'of', 'else', 'get', 'set', 'new', 'catch', 'finally', 'typeof', 'yield', 'async', 'await', 'from', 'as']);

    //  /* ... */ comment ends with nearest */ or end of file
    var block_comment_pattern = /([\s\S]*?)((?:\*\/)|$)/g;

    // comment ends just before nearest linefeed or end of file
    var comment_pattern = /([^\n\r\u2028\u2029]*)/g;

    var directives_block_pattern = /\/\* beautify( \w+[:]\w+)+ \*\//g;
    var directive_pattern = / (\w+)[:](\w+)/g;
    var directives_end_ignore_pattern = /([\s\S]*?)((?:\/\*\sbeautify\signore:end\s\*\/)|$)/g;

    var template_pattern = /((<\?php|<\?=)[\s\S]*?\?>)|(<%[\s\S]*?%>)/g;

    var n_newlines, whitespace_before_token, in_html_comment, tokens;
    var input;

    this.tokenize = function() {
        input = new InputScanner(input_string);
        in_html_comment = false;
        tokens = [];

        var next, last;
        var token_values;
        var open = null;
        var open_stack = [];
        var comments = [];

        while (!(last && last.type === 'TK_EOF')) {
            token_values = tokenize_next();
            next = new Token(token_values[1], token_values[0], n_newlines, whitespace_before_token);
            while (next.type === 'TK_COMMENT' || next.type === 'TK_BLOCK_COMMENT' || next.type === 'TK_UNKNOWN') {
                if (next.type === 'TK_BLOCK_COMMENT') {
                    next.directives = token_values[2];
                }
                comments.push(next);
                token_values = tokenize_next();
                next = new Token(token_values[1], token_values[0], n_newlines, whitespace_before_token);
            }

            if (comments.length) {
                next.comments_before = comments;
                comments = [];
            }

            if (next.type === 'TK_START_BLOCK' || next.type === 'TK_START_EXPR') {
                next.parent = last;
                open_stack.push(open);
                open = next;
            } else if ((next.type === 'TK_END_BLOCK' || next.type === 'TK_END_EXPR') &&
                (open && (
                    (next.text === ']' && open.text === '[') ||
                    (next.text === ')' && open.text === '(') ||
                    (next.text === '}' && open.text === '{')))) {
                next.parent = open.parent;
                next.opened = open;

                open = open_stack.pop();
            }

            tokens.push(next);
            last = next;
        }

        return tokens;
    };

    function get_directives(text) {
        if (!text.match(directives_block_pattern)) {
            return null;
        }

        var directives = {};
        directive_pattern.lastIndex = 0;
        var directive_match = directive_pattern.exec(text);

        while (directive_match) {
            directives[directive_match[1]] = directive_match[2];
            directive_match = directive_pattern.exec(text);
        }

        return directives;
    }

    function tokenize_next() {
        var resulting_string;
        var whitespace_on_this_line = [];

        n_newlines = 0;
        whitespace_before_token = '';

        var c = input.next();

        if (c === null) {
            return ['', 'TK_EOF'];
        }

        var last_token;
        if (tokens.length) {
            last_token = tokens[tokens.length - 1];
        } else {
            // For the sake of tokenizing we can pretend that there was on open brace to start
            last_token = new Token('TK_START_BLOCK', '{');
        }

        while (in_array(c, whitespace)) {

            if (acorn.newline.test(c)) {
                if (!(c === '\n' && input.peek(-2) === '\r')) {
                    n_newlines += 1;
                    whitespace_on_this_line = [];
                }
            } else {
                whitespace_on_this_line.push(c);
            }

            c = input.next();

            if (c === null) {
                return ['', 'TK_EOF'];
            }
        }

        if (whitespace_on_this_line.length) {
            whitespace_before_token = whitespace_on_this_line.join('');
        }

        if (digit.test(c) || (c === '.' && input.testChar(digit))) {
            var allow_decimal = true;
            var allow_e = true;
            var local_digit = digit;

            if (c === '0' && input.testChar(/[XxOoBb]/)) {
                // switch to hex/oct/bin number, no decimal or e, just hex/oct/bin digits
                allow_decimal = false;
                allow_e = false;
                if (input.testChar(/[Bb]/)) {
                    local_digit = digit_bin;
                } else if (input.testChar(/[Oo]/)) {
                    local_digit = digit_oct;
                } else {
                    local_digit = digit_hex;
                }
                c += input.next();
            } else if (c === '.') {
                // Already have a decimal for this literal, don't allow another
                allow_decimal = false;
            } else {
                // we know this first loop will run.  It keeps the logic simpler.
                c = '';
                input.back();
            }

            // Add the digits
            while (input.testChar(local_digit)) {
                c += input.next();

                if (allow_decimal && input.peek() === '.') {
                    c += input.next();
                    allow_decimal = false;
                }

                // a = 1.e-7 is valid, so we test for . then e in one loop
                if (allow_e && input.testChar(/[Ee]/)) {
                    c += input.next();

                    if (input.testChar(/[+-]/)) {
                        c += input.next();
                    }

                    allow_e = false;
                    allow_decimal = false;
                }
            }

            return [c, 'TK_WORD'];
        }

        if (acorn.isIdentifierStart(input.peekCharCode(-1))) {
            if (input.hasNext()) {
                while (acorn.isIdentifierChar(input.peekCharCode())) {
                    c += input.next();
                    if (!input.hasNext()) {
                        break;
                    }
                }
            }

            if (!(last_token.type === 'TK_DOT' ||
                    (last_token.type === 'TK_RESERVED' && in_array(last_token.text, ['set', 'get']))) &&
                in_array(c, reserved_words)) {
                if (c === 'in' || c === 'of') { // hack for 'in' and 'of' operators
                    return [c, 'TK_OPERATOR'];
                }
                return [c, 'TK_RESERVED'];
            }

            return [c, 'TK_WORD'];
        }

        if (c === '(' || c === '[') {
            return [c, 'TK_START_EXPR'];
        }

        if (c === ')' || c === ']') {
            return [c, 'TK_END_EXPR'];
        }

        if (c === '{') {
            return [c, 'TK_START_BLOCK'];
        }

        if (c === '}') {
            return [c, 'TK_END_BLOCK'];
        }

        if (c === ';') {
            return [c, 'TK_SEMICOLON'];
        }

        if (c === '/') {
            var comment = '';
            var comment_match;
            // peek for comment /* ... */
            if (input.peek() === '*') {
                input.next();
                comment_match = input.match(block_comment_pattern);
                comment = '/*' + comment_match[0];
                var directives = get_directives(comment);
                if (directives && directives.ignore === 'start') {
                    comment_match = input.match(directives_end_ignore_pattern);
                    comment += comment_match[0];
                }
                comment = comment.replace(acorn.allLineBreaks, '\n');
                return [comment, 'TK_BLOCK_COMMENT', directives];
            }
            // peek for comment // ...
            if (input.peek() === '/') {
                input.next();
                comment_match = input.match(comment_pattern);
                comment = '//' + comment_match[0];
                return [comment, 'TK_COMMENT'];
            }

        }

        var startXmlRegExp = /<()([-a-zA-Z:0-9_.]+|{[\s\S]+?}|!\[CDATA\[[\s\S]*?\]\])(\s+{[\s\S]+?}|\s+[-a-zA-Z:0-9_.]+|\s+[-a-zA-Z:0-9_.]+\s*=\s*('[^']*'|"[^"]*"|{[\s\S]+?}))*\s*(\/?)\s*>/g;

        if (c === '`' || c === "'" || c === '"' || // string
            (
                (c === '/') || // regexp
                (opts.e4x && c === "<" && input.test(startXmlRegExp, -1)) // xml
            ) && ( // regex and xml can only appear in specific locations during parsing
                (last_token.type === 'TK_RESERVED' && in_array(last_token.text, ['return', 'case', 'throw', 'else', 'do', 'typeof', 'yield'])) ||
                (last_token.type === 'TK_END_EXPR' && last_token.text === ')' &&
                    last_token.parent && last_token.parent.type === 'TK_RESERVED' && in_array(last_token.parent.text, ['if', 'while', 'for'])) ||
                (in_array(last_token.type, ['TK_COMMENT', 'TK_START_EXPR', 'TK_START_BLOCK',
                    'TK_END_BLOCK', 'TK_OPERATOR', 'TK_EQUALS', 'TK_EOF', 'TK_SEMICOLON', 'TK_COMMA'
                ]))
            )) {

            var sep = c,
                esc = false,
                has_char_escapes = false;

            resulting_string = c;

            if (sep === '/') {
                //
                // handle regexp
                //
                var in_char_class = false;
                while (input.hasNext() &&
                    ((esc || in_char_class || input.peek() !== sep) &&
                        !input.testChar(acorn.newline))) {
                    resulting_string += input.peek();
                    if (!esc) {
                        esc = input.peek() === '\\';
                        if (input.peek() === '[') {
                            in_char_class = true;
                        } else if (input.peek() === ']') {
                            in_char_class = false;
                        }
                    } else {
                        esc = false;
                    }
                    input.next();
                }
            } else if (opts.e4x && sep === '<') {
                //
                // handle e4x xml literals
                //

                var xmlRegExp = /[\s\S]*?<(\/?)([-a-zA-Z:0-9_.]+|{[\s\S]+?}|!\[CDATA\[[\s\S]*?\]\])(\s+{[\s\S]+?}|\s+[-a-zA-Z:0-9_.]+|\s+[-a-zA-Z:0-9_.]+\s*=\s*('[^']*'|"[^"]*"|{[\s\S]+?}))*\s*(\/?)\s*>/g;
                input.back();
                var xmlStr = '';
                var match = input.match(startXmlRegExp);
                if (match) {
                    // Trim root tag to attempt to
                    var rootTag = match[2].replace(/^{\s+/, '{').replace(/\s+}$/, '}');
                    var isCurlyRoot = rootTag.indexOf('{') === 0;
                    var depth = 0;
                    while (match) {
                        var isEndTag = !!match[1];
                        var tagName = match[2];
                        var isSingletonTag = (!!match[match.length - 1]) || (tagName.slice(0, 8) === "![CDATA[");
                        if (!isSingletonTag &&
                            (tagName === rootTag || (isCurlyRoot && tagName.replace(/^{\s+/, '{').replace(/\s+}$/, '}')))) {
                            if (isEndTag) {
                                --depth;
                            } else {
                                ++depth;
                            }
                        }
                        xmlStr += match[0];
                        if (depth <= 0) {
                            break;
                        }
                        match = input.match(xmlRegExp);
                    }
                    // if we didn't close correctly, keep unformatted.
                    if (!match) {
                        xmlStr += input.match(/[\s\S]*/g)[0];
                    }
                    xmlStr = xmlStr.replace(acorn.allLineBreaks, '\n');
                    return [xmlStr, "TK_STRING"];
                }
            } else {
                //
                // handle string
                //
                var parse_string = function(delimiter, allow_unescaped_newlines, start_sub) {
                    // Template strings can travers lines without escape characters.
                    // Other strings cannot
                    var current_char;
                    while (input.hasNext()) {
                        current_char = input.peek();
                        if (!(esc || (current_char !== delimiter &&
                                (allow_unescaped_newlines || !acorn.newline.test(current_char))))) {
                            break;
                        }

                        // Handle \r\n linebreaks after escapes or in template strings
                        if ((esc || allow_unescaped_newlines) && acorn.newline.test(current_char)) {
                            if (current_char === '\r' && input.peek(1) === '\n') {
                                input.next();
                                current_char = input.peek();
                            }
                            resulting_string += '\n';
                        } else {
                            resulting_string += current_char;
                        }

                        if (esc) {
                            if (current_char === 'x' || current_char === 'u') {
                                has_char_escapes = true;
                            }
                            esc = false;
                        } else {
                            esc = current_char === '\\';
                        }

                        input.next();

                        if (start_sub && resulting_string.indexOf(start_sub, resulting_string.length - start_sub.length) !== -1) {
                            if (delimiter === '`') {
                                parse_string('}', allow_unescaped_newlines, '`');
                            } else {
                                parse_string('`', allow_unescaped_newlines, '${');
                            }

                            if (input.hasNext()) {
                                resulting_string += input.next();
                            }
                        }
                    }
                };

                if (sep === '`') {
                    parse_string('`', true, '${');
                } else {
                    parse_string(sep);
                }
            }

            if (has_char_escapes && opts.unescape_strings) {
                resulting_string = unescape_string(resulting_string);
            }

            if (input.peek() === sep) {
                resulting_string += sep;
                input.next();

                if (sep === '/') {
                    // regexps may have modifiers /regexp/MOD , so fetch those, too
                    // Only [gim] are valid, but if the user puts in garbage, do what we can to take it.
                    while (input.hasNext() && acorn.isIdentifierStart(input.peekCharCode())) {
                        resulting_string += input.next();
                    }
                }
            }
            return [resulting_string, 'TK_STRING'];
        }

        if (c === '#') {

            if (tokens.length === 0 && input.peek() === '!') {
                // shebang
                resulting_string = c;
                while (input.hasNext() && c !== '\n') {
                    c = input.next();
                    resulting_string += c;
                }
                return [trim(resulting_string) + '\n', 'TK_UNKNOWN'];
            }



            // Spidermonkey-specific sharp variables for circular references
            // https://developer.mozilla.org/En/Sharp_variables_in_JavaScript
            // http://mxr.mozilla.org/mozilla-central/source/js/src/jsscan.cpp around line 1935
            var sharp = '#';
            if (input.hasNext() && input.testChar(digit)) {
                do {
                    c = input.next();
                    sharp += c;
                } while (input.hasNext() && c !== '#' && c !== '=');
                if (c === '#') {
                    //
                } else if (input.peek() === '[' && input.peek(1) === ']') {
                    sharp += '[]';
                    input.next();
                    input.next();
                } else if (input.peek() === '{' && input.peek(1) === '}') {
                    sharp += '{}';
                    input.next();
                    input.next();
                }
                return [sharp, 'TK_WORD'];
            }
        }

        if (c === '<' && (input.peek() === '?' || input.peek() === '%')) {
            input.back();
            var template_match = input.match(template_pattern);
            if (template_match) {
                c = template_match[0];
                c = c.replace(acorn.allLineBreaks, '\n');
                return [c, 'TK_STRING'];
            }
        }

        if (c === '<' && input.match(/\!--/g)) {
            c = '<!--';
            while (input.hasNext() && !input.testChar(acorn.newline)) {
                c += input.next();
            }
            in_html_comment = true;
            return [c, 'TK_COMMENT'];
        }

        if (c === '-' && in_html_comment && input.match(/->/g)) {
            in_html_comment = false;
            return ['-->', 'TK_COMMENT'];
        }

        if (c === '.') {
            if (input.peek() === '.' && input.peek(1) === '.') {
                c += input.next() + input.next();
                return [c, 'TK_OPERATOR'];
            }
            return [c, 'TK_DOT'];
        }

        if (in_array(c, punct)) {
            while (input.hasNext() && in_array(c + input.peek(), punct)) {
                c += input.next();
                if (!input.hasNext()) {
                    break;
                }
            }

            if (c === ',') {
                return [c, 'TK_COMMA'];
            } else if (c === '=') {
                return [c, 'TK_EQUALS'];
            } else {
                return [c, 'TK_OPERATOR'];
            }
        }

        return [c, 'TK_UNKNOWN'];
    }


    function unescape_string(s) {
        // You think that a regex would work for this
        // return s.replace(/\\x([0-9a-f]{2})/gi, function(match, val) {
        //         return String.fromCharCode(parseInt(val, 16));
        //     })
        // However, dealing with '\xff', '\\xff', '\\\xff' makes this more fun.
        var out = '',
            escaped = 0;

        var input_scan = new InputScanner(s);
        var matched = null;

        while (input_scan.hasNext()) {
            // Keep any whitespace, non-slash characters
            // also keep slash pairs.
            matched = input_scan.match(/([\s]|[^\\]|\\\\)+/g);

            if (matched) {
                out += matched[0];
            }

            if (input_scan.peek() === '\\') {
                input_scan.next();
                if (input_scan.peek() === 'x') {
                    matched = input_scan.match(/x([0-9A-Fa-f]{2})/g);
                } else if (input_scan.peek() === 'u') {
                    matched = input_scan.match(/u([0-9A-Fa-f]{4})/g);
                } else {
                    out += '\\';
                    if (input_scan.hasNext()) {
                        out += input_scan.next();
                    }
                    continue;
                }

                // If there's some error decoding, return the original string
                if (!matched) {
                    return s;
                }

                escaped = parseInt(matched[1], 16);

                if (escaped > 0x7e && escaped <= 0xff && matched[0].indexOf('x') === 0) {
                    // we bail out on \x7f..\xff,
                    // leaving whole string escaped,
                    // as it's probably completely binary
                    return s;
                } else if (escaped >= 0x00 && escaped < 0x20) {
                    // leave 0x00...0x1f escaped
                    out += '\\' + matched[0];
                    continue;
                } else if (escaped === 0x22 || escaped === 0x27 || escaped === 0x5c) {
                    // single-quote, apostrophe, backslash - escape these
                    out += '\\' + String.fromCharCode(escaped);
                } else {
                    out += String.fromCharCode(escaped);
                }
            }
        }

        return out;
    }
}

module.exports.Tokenizer = Tokenizer;

/***/ })
/******/ ]);
var js_beautify = legacy_beautify_js;
/* Footer */
if (true) {
    // Add support for AMD ( https://github.com/amdjs/amdjs-api/wiki/AMD#defineamd-property- )
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
        return { js_beautify: js_beautify };
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof exports !== "undefined") {
    // Add support for CommonJS. Just put this file somewhere on your require.paths
    // and you will be able to `var js_beautify = require("beautify").js_beautify`.
    exports.js_beautify = js_beautify;
} else if (typeof window !== "undefined") {
    // If we're running a web page and don't have either of the above, add our one global
    window.js_beautify = js_beautify;
} else if (typeof global !== "undefined") {
    // If we don't even have window, try global.
    global.js_beautify = js_beautify;
}

}());


/***/ }),
/* 543 */,
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(2396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(2398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(2403);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(233),
    root = __webpack_require__(149);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(2472),
    mapCacheDelete = __webpack_require__(2473),
    mapCacheGet = __webpack_require__(2474),
    mapCacheHas = __webpack_require__(2475),
    mapCacheSet = __webpack_require__(2476);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(390),
    stackClear = __webpack_require__(2487),
    stackDelete = __webpack_require__(2488),
    stackGet = __webpack_require__(2489),
    stackHas = __webpack_require__(2490),
    stackSet = __webpack_require__(2491);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 548 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2424),
    isObjectLike = __webpack_require__(151);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(234),
    overRest = __webpack_require__(2482),
    setToString = __webpack_require__(2485);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(859),
    baseAssignValue = __webpack_require__(313);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(550),
    isIterateeCall = __webpack_require__(397);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 553 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(80),
    isSymbol = __webpack_require__(319);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 555 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(150),
    isObjectLike = __webpack_require__(151);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 557 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(169),
    getPrototype = __webpack_require__(876),
    isObjectLike = __webpack_require__(151);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 559 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(855),
    baseKeysIn = __webpack_require__(2430),
    isArrayLike = __webpack_require__(150);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(2434),
    createAssigner = __webpack_require__(552);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*@license
	Papa Parse
	v4.4.0
	https://github.com/mholt/PapaParse
	License: MIT
*/
(function(root, factory)
{
	/* globals define */
	if (true)
	{
		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if (typeof module === 'object' && typeof exports !== 'undefined')
	{
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like environments that support module.exports,
		// like Node.
		module.exports = factory();
	}
	else
	{
		// Browser globals (root is window)
		root.Papa = factory();
	}
}(this, function()
{
	'use strict';

	var global = (function() {
		// alternative method, similar to `Function('return this')()`
		// but without using `eval` (which is disabled when
		// using Content Security Policy).

		if (typeof self !== 'undefined') { return self; }
		if (typeof window !== 'undefined') { return window; }
		if (typeof global !== 'undefined') { return global; }

		// When running tests none of the above have been defined
		return {};
	})();


	var IS_WORKER = !global.document && !!global.postMessage,
		IS_PAPA_WORKER = IS_WORKER && /(\?|&)papaworker(=|&|$)/.test(global.location.search),
		LOADED_SYNC = false, AUTO_SCRIPT_PATH;
	var workers = {}, workerIdCounter = 0;

	var Papa = {};

	Papa.parse = CsvToJson;
	Papa.unparse = JsonToCsv;

	Papa.RECORD_SEP = String.fromCharCode(30);
	Papa.UNIT_SEP = String.fromCharCode(31);
	Papa.BYTE_ORDER_MARK = '\ufeff';
	Papa.BAD_DELIMITERS = ['\r', '\n', '"', Papa.BYTE_ORDER_MARK];
	Papa.WORKERS_SUPPORTED = !IS_WORKER && !!global.Worker;
	Papa.SCRIPT_PATH = null;	// Must be set by your code if you use workers and this lib is loaded asynchronously

	// Configurable chunk sizes for local and remote files, respectively
	Papa.LocalChunkSize = 1024 * 1024 * 10;	// 10 MB
	Papa.RemoteChunkSize = 1024 * 1024 * 5;	// 5 MB
	Papa.DefaultDelimiter = ',';			// Used if not specified and detection fails

	// Exposed for testing and development only
	Papa.Parser = Parser;
	Papa.ParserHandle = ParserHandle;
	Papa.NetworkStreamer = NetworkStreamer;
	Papa.FileStreamer = FileStreamer;
	Papa.StringStreamer = StringStreamer;
	Papa.ReadableStreamStreamer = ReadableStreamStreamer;

	if (global.jQuery)
	{
		var $ = global.jQuery;
		$.fn.parse = function(options)
		{
			var config = options.config || {};
			var queue = [];

			this.each(function(idx)
			{
				var supported = $(this).prop('tagName').toUpperCase() === 'INPUT'
								&& $(this).attr('type').toLowerCase() === 'file'
								&& global.FileReader;

				if (!supported || !this.files || this.files.length === 0)
					return true;	// continue to next input element

				for (var i = 0; i < this.files.length; i++)
				{
					queue.push({
						file: this.files[i],
						inputElem: this,
						instanceConfig: $.extend({}, config)
					});
				}
			});

			parseNextFile();	// begin parsing
			return this;		// maintains chainability


			function parseNextFile()
			{
				if (queue.length === 0)
				{
					if (isFunction(options.complete))
						options.complete();
					return;
				}

				var f = queue[0];

				if (isFunction(options.before))
				{
					var returned = options.before(f.file, f.inputElem);

					if (typeof returned === 'object')
					{
						if (returned.action === 'abort')
						{
							error('AbortError', f.file, f.inputElem, returned.reason);
							return;	// Aborts all queued files immediately
						}
						else if (returned.action === 'skip')
						{
							fileComplete();	// parse the next file in the queue, if any
							return;
						}
						else if (typeof returned.config === 'object')
							f.instanceConfig = $.extend(f.instanceConfig, returned.config);
					}
					else if (returned === 'skip')
					{
						fileComplete();	// parse the next file in the queue, if any
						return;
					}
				}

				// Wrap up the user's complete callback, if any, so that ours also gets executed
				var userCompleteFunc = f.instanceConfig.complete;
				f.instanceConfig.complete = function(results)
				{
					if (isFunction(userCompleteFunc))
						userCompleteFunc(results, f.file, f.inputElem);
					fileComplete();
				};

				Papa.parse(f.file, f.instanceConfig);
			}

			function error(name, file, elem, reason)
			{
				if (isFunction(options.error))
					options.error({name: name}, file, elem, reason);
			}

			function fileComplete()
			{
				queue.splice(0, 1);
				parseNextFile();
			}
		};
	}


	if (IS_PAPA_WORKER)
	{
		global.onmessage = workerThreadReceivedMessage;
	}
	else if (Papa.WORKERS_SUPPORTED)
	{
		AUTO_SCRIPT_PATH = getScriptPath();

		// Check if the script was loaded synchronously
		if (!document.body)
		{
			// Body doesn't exist yet, must be synchronous
			LOADED_SYNC = true;
		}
		else
		{
			document.addEventListener('DOMContentLoaded', function() {
				LOADED_SYNC = true;
			}, true);
		}
	}




	function CsvToJson(_input, _config)
	{
		_config = _config || {};
		var dynamicTyping = _config.dynamicTyping || false;
		if (isFunction(dynamicTyping)) {
			_config.dynamicTypingFunction = dynamicTyping;
			// Will be filled on first row call
			dynamicTyping = {};
		}
		_config.dynamicTyping = dynamicTyping;

		if (_config.worker && Papa.WORKERS_SUPPORTED)
		{
			var w = newWorker();

			w.userStep = _config.step;
			w.userChunk = _config.chunk;
			w.userComplete = _config.complete;
			w.userError = _config.error;

			_config.step = isFunction(_config.step);
			_config.chunk = isFunction(_config.chunk);
			_config.complete = isFunction(_config.complete);
			_config.error = isFunction(_config.error);
			delete _config.worker;	// prevent infinite loop

			w.postMessage({
				input: _input,
				config: _config,
				workerId: w.id
			});

			return;
		}

		var streamer = null;
		if (typeof _input === 'string')
		{
			if (_config.download)
				streamer = new NetworkStreamer(_config);
			else
				streamer = new StringStreamer(_config);
		}
		else if (_input.readable === true && isFunction(_input.read) && isFunction(_input.on))
		{
			streamer = new ReadableStreamStreamer(_config);
		}
		else if ((global.File && _input instanceof File) || _input instanceof Object)	// ...Safari. (see issue #106)
			streamer = new FileStreamer(_config);

		return streamer.stream(_input);
	}






	function JsonToCsv(_input, _config)
	{
		// Default configuration

		/** whether to surround every datum with quotes */
		var _quotes = false;

		/** whether to write headers */
		var _writeHeader = true;

		/** delimiting character */
		var _delimiter = ',';

		/** newline character(s) */
		var _newline = '\r\n';

		/** quote character */
		var _quoteChar = '"';

		unpackConfig();

		var quoteCharRegex = new RegExp(_quoteChar, 'g');

		if (typeof _input === 'string')
			_input = JSON.parse(_input);

		if (_input instanceof Array)
		{
			if (!_input.length || _input[0] instanceof Array)
				return serialize(null, _input);
			else if (typeof _input[0] === 'object')
				return serialize(objectKeys(_input[0]), _input);
		}
		else if (typeof _input === 'object')
		{
			if (typeof _input.data === 'string')
				_input.data = JSON.parse(_input.data);

			if (_input.data instanceof Array)
			{
				if (!_input.fields)
					_input.fields =  _input.meta && _input.meta.fields;

				if (!_input.fields)
					_input.fields =  _input.data[0] instanceof Array
						? _input.fields
						: objectKeys(_input.data[0]);

				if (!(_input.data[0] instanceof Array) && typeof _input.data[0] !== 'object')
					_input.data = [_input.data];	// handles input like [1,2,3] or ['asdf']
			}

			return serialize(_input.fields || [], _input.data || []);
		}

		// Default (any valid paths should return before this)
		throw 'exception: Unable to serialize unrecognized input';


		function unpackConfig()
		{
			if (typeof _config !== 'object')
				return;

			if (typeof _config.delimiter === 'string'
				&& _config.delimiter.length === 1
				&& Papa.BAD_DELIMITERS.indexOf(_config.delimiter) === -1)
			{
				_delimiter = _config.delimiter;
			}

			if (typeof _config.quotes === 'boolean'
				|| _config.quotes instanceof Array)
				_quotes = _config.quotes;

			if (typeof _config.newline === 'string')
				_newline = _config.newline;

			if (typeof _config.quoteChar === 'string')
				_quoteChar = _config.quoteChar;

			if (typeof _config.header === 'boolean')
				_writeHeader = _config.header;
		}


		/** Turns an object's keys into an array */
		function objectKeys(obj)
		{
			if (typeof obj !== 'object')
				return [];
			var keys = [];
			for (var key in obj)
				keys.push(key);
			return keys;
		}

		/** The double for loop that iterates the data and writes out a CSV string including header row */
		function serialize(fields, data)
		{
			var csv = '';

			if (typeof fields === 'string')
				fields = JSON.parse(fields);
			if (typeof data === 'string')
				data = JSON.parse(data);

			var hasHeader = fields instanceof Array && fields.length > 0;
			var dataKeyedByField = !(data[0] instanceof Array);

			// If there a header row, write it first
			if (hasHeader && _writeHeader)
			{
				for (var i = 0; i < fields.length; i++)
				{
					if (i > 0)
						csv += _delimiter;
					csv += safe(fields[i], i);
				}
				if (data.length > 0)
					csv += _newline;
			}

			// Then write out the data
			for (var row = 0; row < data.length; row++)
			{
				var maxCol = hasHeader ? fields.length : data[row].length;

				for (var col = 0; col < maxCol; col++)
				{
					if (col > 0)
						csv += _delimiter;
					var colIdx = hasHeader && dataKeyedByField ? fields[col] : col;
					csv += safe(data[row][colIdx], col);
				}

				if (row < data.length - 1)
					csv += _newline;
			}

			return csv;
		}

		/** Encloses a value around quotes if needed (makes a value safe for CSV insertion) */
		function safe(str, col)
		{
			if (typeof str === 'undefined' || str === null)
				return '';

			str = str.toString().replace(quoteCharRegex, _quoteChar + _quoteChar);

			var needsQuotes = (typeof _quotes === 'boolean' && _quotes)
							|| (_quotes instanceof Array && _quotes[col])
							|| hasAny(str, Papa.BAD_DELIMITERS)
							|| str.indexOf(_delimiter) > -1
							|| str.charAt(0) === ' '
							|| str.charAt(str.length - 1) === ' ';

			return needsQuotes ? _quoteChar + str + _quoteChar : str;
		}

		function hasAny(str, substrings)
		{
			for (var i = 0; i < substrings.length; i++)
				if (str.indexOf(substrings[i]) > -1)
					return true;
			return false;
		}
	}

	/** ChunkStreamer is the base prototype for various streamer implementations. */
	function ChunkStreamer(config)
	{
		this._handle = null;
		this._finished = false;
		this._completed = false;
		this._input = null;
		this._baseIndex = 0;
		this._partialLine = '';
		this._rowCount = 0;
		this._start = 0;
		this._nextChunk = null;
		this.isFirstChunk = true;
		this._completeResults = {
			data: [],
			errors: [],
			meta: {}
		};
		replaceConfig.call(this, config);

		this.parseChunk = function(chunk, isFakeChunk)
		{
			// First chunk pre-processing
			if (this.isFirstChunk && isFunction(this._config.beforeFirstChunk))
			{
				var modifiedChunk = this._config.beforeFirstChunk(chunk);
				if (modifiedChunk !== undefined)
					chunk = modifiedChunk;
			}
			this.isFirstChunk = false;

			// Rejoin the line we likely just split in two by chunking the file
			var aggregate = this._partialLine + chunk;
			this._partialLine = '';

			var results = this._handle.parse(aggregate, this._baseIndex, !this._finished);

			if (this._handle.paused() || this._handle.aborted())
				return;

			var lastIndex = results.meta.cursor;

			if (!this._finished)
			{
				this._partialLine = aggregate.substring(lastIndex - this._baseIndex);
				this._baseIndex = lastIndex;
			}

			if (results && results.data)
				this._rowCount += results.data.length;

			var finishedIncludingPreview = this._finished || (this._config.preview && this._rowCount >= this._config.preview);

			if (IS_PAPA_WORKER)
			{
				global.postMessage({
					results: results,
					workerId: Papa.WORKER_ID,
					finished: finishedIncludingPreview
				});
			}
			else if (isFunction(this._config.chunk) && !isFakeChunk)
			{
				this._config.chunk(results, this._handle);
				if (this._handle.paused() || this._handle.aborted())
					return;
				results = undefined;
				this._completeResults = undefined;
			}

			if (!this._config.step && !this._config.chunk) {
				this._completeResults.data = this._completeResults.data.concat(results.data);
				this._completeResults.errors = this._completeResults.errors.concat(results.errors);
				this._completeResults.meta = results.meta;
			}

			if (!this._completed && finishedIncludingPreview && isFunction(this._config.complete) && (!results || !results.meta.aborted)) {
				this._config.complete(this._completeResults, this._input);
				this._completed = true;
			}

			if (!finishedIncludingPreview && (!results || !results.meta.paused))
				this._nextChunk();

			return results;
		};

		this._sendError = function(error)
		{
			if (isFunction(this._config.error))
				this._config.error(error);
			else if (IS_PAPA_WORKER && this._config.error)
			{
				global.postMessage({
					workerId: Papa.WORKER_ID,
					error: error,
					finished: false
				});
			}
		};

		function replaceConfig(config)
		{
			// Deep-copy the config so we can edit it
			var configCopy = copy(config);
			configCopy.chunkSize = parseInt(configCopy.chunkSize);	// parseInt VERY important so we don't concatenate strings!
			if (!config.step && !config.chunk)
				configCopy.chunkSize = null;  // disable Range header if not streaming; bad values break IIS - see issue #196
			this._handle = new ParserHandle(configCopy);
			this._handle.streamer = this;
			this._config = configCopy;	// persist the copy to the caller
		}
	}


	function NetworkStreamer(config)
	{
		config = config || {};
		if (!config.chunkSize)
			config.chunkSize = Papa.RemoteChunkSize;
		ChunkStreamer.call(this, config);

		var xhr;

		if (IS_WORKER)
		{
			this._nextChunk = function()
			{
				this._readChunk();
				this._chunkLoaded();
			};
		}
		else
		{
			this._nextChunk = function()
			{
				this._readChunk();
			};
		}

		this.stream = function(url)
		{
			this._input = url;
			this._nextChunk();	// Starts streaming
		};

		this._readChunk = function()
		{
			if (this._finished)
			{
				this._chunkLoaded();
				return;
			}

			xhr = new XMLHttpRequest();

			if (this._config.withCredentials)
			{
				xhr.withCredentials = this._config.withCredentials;
			}

			if (!IS_WORKER)
			{
				xhr.onload = bindFunction(this._chunkLoaded, this);
				xhr.onerror = bindFunction(this._chunkError, this);
			}

			xhr.open('GET', this._input, !IS_WORKER);
			// Headers can only be set when once the request state is OPENED
			if (this._config.downloadRequestHeaders)
			{
				var headers = this._config.downloadRequestHeaders;

				for (var headerName in headers)
				{
					xhr.setRequestHeader(headerName, headers[headerName]);
				}
			}

			if (this._config.chunkSize)
			{
				var end = this._start + this._config.chunkSize - 1;	// minus one because byte range is inclusive
				xhr.setRequestHeader('Range', 'bytes=' + this._start + '-' + end);
				xhr.setRequestHeader('If-None-Match', 'webkit-no-cache'); // https://bugs.webkit.org/show_bug.cgi?id=82672
			}

			try {
				xhr.send();
			}
			catch (err) {
				this._chunkError(err.message);
			}

			if (IS_WORKER && xhr.status === 0)
				this._chunkError();
			else
				this._start += this._config.chunkSize;
		};

		this._chunkLoaded = function()
		{
			if (xhr.readyState !== 4)
				return;

			if (xhr.status < 200 || xhr.status >= 400)
			{
				this._chunkError();
				return;
			}

			this._finished = !this._config.chunkSize || this._start > getFileSize(xhr);
			this.parseChunk(xhr.responseText);
		};

		this._chunkError = function(errorMessage)
		{
			var errorText = xhr.statusText || errorMessage;
			this._sendError(new Error(errorText));
		};

		function getFileSize(xhr)
		{
			var contentRange = xhr.getResponseHeader('Content-Range');
			if (contentRange === null) { // no content range, then finish!
				return -1;
			}
			return parseInt(contentRange.substr(contentRange.lastIndexOf('/') + 1));
		}
	}
	NetworkStreamer.prototype = Object.create(ChunkStreamer.prototype);
	NetworkStreamer.prototype.constructor = NetworkStreamer;


	function FileStreamer(config)
	{
		config = config || {};
		if (!config.chunkSize)
			config.chunkSize = Papa.LocalChunkSize;
		ChunkStreamer.call(this, config);

		var reader, slice;

		// FileReader is better than FileReaderSync (even in worker) - see http://stackoverflow.com/q/24708649/1048862
		// But Firefox is a pill, too - see issue #76: https://github.com/mholt/PapaParse/issues/76
		var usingAsyncReader = typeof FileReader !== 'undefined';	// Safari doesn't consider it a function - see issue #105

		this.stream = function(file)
		{
			this._input = file;
			slice = file.slice || file.webkitSlice || file.mozSlice;

			if (usingAsyncReader)
			{
				reader = new FileReader();		// Preferred method of reading files, even in workers
				reader.onload = bindFunction(this._chunkLoaded, this);
				reader.onerror = bindFunction(this._chunkError, this);
			}
			else
				reader = new FileReaderSync();	// Hack for running in a web worker in Firefox

			this._nextChunk();	// Starts streaming
		};

		this._nextChunk = function()
		{
			if (!this._finished && (!this._config.preview || this._rowCount < this._config.preview))
				this._readChunk();
		};

		this._readChunk = function()
		{
			var input = this._input;
			if (this._config.chunkSize)
			{
				var end = Math.min(this._start + this._config.chunkSize, this._input.size);
				input = slice.call(input, this._start, end);
			}
			var txt = reader.readAsText(input, this._config.encoding);
			if (!usingAsyncReader)
				this._chunkLoaded({ target: { result: txt } });	// mimic the async signature
		};

		this._chunkLoaded = function(event)
		{
			// Very important to increment start each time before handling results
			this._start += this._config.chunkSize;
			this._finished = !this._config.chunkSize || this._start >= this._input.size;
			this.parseChunk(event.target.result);
		};

		this._chunkError = function()
		{
			this._sendError(reader.error);
		};

	}
	FileStreamer.prototype = Object.create(ChunkStreamer.prototype);
	FileStreamer.prototype.constructor = FileStreamer;


	function StringStreamer(config)
	{
		config = config || {};
		ChunkStreamer.call(this, config);

		var remaining;
		this.stream = function(s)
		{
			remaining = s;
			return this._nextChunk();
		};
		this._nextChunk = function()
		{
			if (this._finished) return;
			var size = this._config.chunkSize;
			var chunk = size ? remaining.substr(0, size) : remaining;
			remaining = size ? remaining.substr(size) : '';
			this._finished = !remaining;
			return this.parseChunk(chunk);
		};
	}
	StringStreamer.prototype = Object.create(StringStreamer.prototype);
	StringStreamer.prototype.constructor = StringStreamer;


	function ReadableStreamStreamer(config)
	{
		config = config || {};

		ChunkStreamer.call(this, config);

		var queue = [];
		var parseOnData = true;
		var streamHasEnded = false;

		this.pause = function()
		{
			ChunkStreamer.prototype.pause.apply(this, arguments);
			this._input.pause();
		};

		this.resume = function()
		{
			ChunkStreamer.prototype.resume.apply(this, arguments);
			this._input.resume();
		};

		this.stream = function(stream)
		{
			this._input = stream;

			this._input.on('data', this._streamData);
			this._input.on('end', this._streamEnd);
			this._input.on('error', this._streamError);
		};

		this._checkIsFinished = function()
		{
			if (streamHasEnded && queue.length === 1) {
				this._finished = true;
			}
		};

		this._nextChunk = function()
		{
			this._checkIsFinished();
			if (queue.length)
			{
				this.parseChunk(queue.shift());
			}
			else
			{
				parseOnData = true;
			}
		};

		this._streamData = bindFunction(function(chunk)
		{
			try
			{
				queue.push(typeof chunk === 'string' ? chunk : chunk.toString(this._config.encoding));

				if (parseOnData)
				{
					parseOnData = false;
					this._checkIsFinished();
					this.parseChunk(queue.shift());
				}
			}
			catch (error)
			{
				this._streamError(error);
			}
		}, this);

		this._streamError = bindFunction(function(error)
		{
			this._streamCleanUp();
			this._sendError(error);
		}, this);

		this._streamEnd = bindFunction(function()
		{
			this._streamCleanUp();
			streamHasEnded = true;
			this._streamData('');
		}, this);

		this._streamCleanUp = bindFunction(function()
		{
			this._input.removeListener('data', this._streamData);
			this._input.removeListener('end', this._streamEnd);
			this._input.removeListener('error', this._streamError);
		}, this);
	}
	ReadableStreamStreamer.prototype = Object.create(ChunkStreamer.prototype);
	ReadableStreamStreamer.prototype.constructor = ReadableStreamStreamer;


	// Use one ParserHandle per entire CSV file or string
	function ParserHandle(_config)
	{
		// One goal is to minimize the use of regular expressions...
		var FLOAT = /^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i;

		var self = this;
		var _stepCounter = 0;	// Number of times step was called (number of rows parsed)
		var _input;				// The input being parsed
		var _parser;			// The core parser being used
		var _paused = false;	// Whether we are paused or not
		var _aborted = false;	// Whether the parser has aborted or not
		var _delimiterError;	// Temporary state between delimiter detection and processing results
		var _fields = [];		// Fields are from the header row of the input, if there is one
		var _results = {		// The last results returned from the parser
			data: [],
			errors: [],
			meta: {}
		};

		if (isFunction(_config.step))
		{
			var userStep = _config.step;
			_config.step = function(results)
			{
				_results = results;

				if (needsHeaderRow())
					processResults();
				else	// only call user's step function after header row
				{
					processResults();

					// It's possbile that this line was empty and there's no row here after all
					if (_results.data.length === 0)
						return;

					_stepCounter += results.data.length;
					if (_config.preview && _stepCounter > _config.preview)
						_parser.abort();
					else
						userStep(_results, self);
				}
			};
		}

		/**
		 * Parses input. Most users won't need, and shouldn't mess with, the baseIndex
		 * and ignoreLastRow parameters. They are used by streamers (wrapper functions)
		 * when an input comes in multiple chunks, like from a file.
		 */
		this.parse = function(input, baseIndex, ignoreLastRow)
		{
			if (!_config.newline)
				_config.newline = guessLineEndings(input);

			_delimiterError = false;
			if (!_config.delimiter)
			{
				var delimGuess = guessDelimiter(input, _config.newline, _config.skipEmptyLines);
				if (delimGuess.successful)
					_config.delimiter = delimGuess.bestDelimiter;
				else
				{
					_delimiterError = true;	// add error after parsing (otherwise it would be overwritten)
					_config.delimiter = Papa.DefaultDelimiter;
				}
				_results.meta.delimiter = _config.delimiter;
			}
			else if(isFunction(_config.delimiter))
			{
				_config.delimiter = _config.delimiter(input);
				_results.meta.delimiter = _config.delimiter;
			}

			var parserConfig = copy(_config);
			if (_config.preview && _config.header)
				parserConfig.preview++;	// to compensate for header row

			_input = input;
			_parser = new Parser(parserConfig);
			_results = _parser.parse(_input, baseIndex, ignoreLastRow);
			processResults();
			return _paused ? { meta: { paused: true } } : (_results || { meta: { paused: false } });
		};

		this.paused = function()
		{
			return _paused;
		};

		this.pause = function()
		{
			_paused = true;
			_parser.abort();
			_input = _input.substr(_parser.getCharIndex());
		};

		this.resume = function()
		{
			_paused = false;
			self.streamer.parseChunk(_input, true);
		};

		this.aborted = function()
		{
			return _aborted;
		};

		this.abort = function()
		{
			_aborted = true;
			_parser.abort();
			_results.meta.aborted = true;
			if (isFunction(_config.complete))
				_config.complete(_results);
			_input = '';
		};

		function processResults()
		{
			if (_results && _delimiterError)
			{
				addError('Delimiter', 'UndetectableDelimiter', 'Unable to auto-detect delimiting character; defaulted to \'' + Papa.DefaultDelimiter + '\'');
				_delimiterError = false;
			}

			if (_config.skipEmptyLines)
			{
				for (var i = 0; i < _results.data.length; i++)
					if (_results.data[i].length === 1 && _results.data[i][0] === '')
						_results.data.splice(i--, 1);
			}

			if (needsHeaderRow())
				fillHeaderFields();

			return applyHeaderAndDynamicTyping();
		}

		function needsHeaderRow()
		{
			return _config.header && _fields.length === 0;
		}

		function fillHeaderFields()
		{
			if (!_results)
				return;
			for (var i = 0; needsHeaderRow() && i < _results.data.length; i++)
				for (var j = 0; j < _results.data[i].length; j++)
				{
					var header = _results.data[i][j];

					if (_config.trimHeaders) {
						header = header.trim();
					}

					_fields.push(header);
				}
			_results.data.splice(0, 1);
		}

		function shouldApplyDynamicTyping(field) {
			// Cache function values to avoid calling it for each row
			if (_config.dynamicTypingFunction && _config.dynamicTyping[field] === undefined) {
				_config.dynamicTyping[field] = _config.dynamicTypingFunction(field);
			}
			return (_config.dynamicTyping[field] || _config.dynamicTyping) === true;
		}

		function parseDynamic(field, value)
		{
			if (shouldApplyDynamicTyping(field))
			{
				if (value === 'true' || value === 'TRUE')
					return true;
				else if (value === 'false' || value === 'FALSE')
					return false;
				else if(FLOAT.test(value)) {
					return parseFloat(value);
				}
				else {
					return (value === '' ? null : value);
				}
			}
			return value;
		}

		function applyHeaderAndDynamicTyping()
		{
			if (!_results || (!_config.header && !_config.dynamicTyping))
				return _results;

			for (var i = 0; i < _results.data.length; i++)
			{
				var row = _config.header ? {} : [];

				var j;
				for (j = 0; j < _results.data[i].length; j++)
				{
					var field = j;
					var value = _results.data[i][j];

					if (_config.header)
						field = j >= _fields.length ? '__parsed_extra' : _fields[j];

					value = parseDynamic(field, value);

					if (field === '__parsed_extra')
					{
						row[field] = row[field] || [];
						row[field].push(value);
					}
					else
						row[field] = value;
				}

				_results.data[i] = row;

				if (_config.header)
				{
					if (j > _fields.length)
						addError('FieldMismatch', 'TooManyFields', 'Too many fields: expected ' + _fields.length + ' fields but parsed ' + j, i);
					else if (j < _fields.length)
						addError('FieldMismatch', 'TooFewFields', 'Too few fields: expected ' + _fields.length + ' fields but parsed ' + j, i);
				}
			}

			if (_config.header && _results.meta)
				_results.meta.fields = _fields;
			return _results;
		}

		function guessDelimiter(input, newline, skipEmptyLines)
		{
			var delimChoices = [',', '\t', '|', ';', Papa.RECORD_SEP, Papa.UNIT_SEP];
			var bestDelim, bestDelta, fieldCountPrevRow;

			for (var i = 0; i < delimChoices.length; i++)
			{
				var delim = delimChoices[i];
				var delta = 0, avgFieldCount = 0, emptyLinesCount = 0;
				fieldCountPrevRow = undefined;

				var preview = new Parser({
					delimiter: delim,
					newline: newline,
					preview: 10
				}).parse(input);

				for (var j = 0; j < preview.data.length; j++)
				{
					if (skipEmptyLines && preview.data[j].length === 1 && preview.data[j][0].length === 0) {
						emptyLinesCount++;
						continue;
					}
					var fieldCount = preview.data[j].length;
					avgFieldCount += fieldCount;

					if (typeof fieldCountPrevRow === 'undefined')
					{
						fieldCountPrevRow = fieldCount;
						continue;
					}
					else if (fieldCount > 1)
					{
						delta += Math.abs(fieldCount - fieldCountPrevRow);
						fieldCountPrevRow = fieldCount;
					}
				}

				if (preview.data.length > 0)
					avgFieldCount /= (preview.data.length - emptyLinesCount);

				if ((typeof bestDelta === 'undefined' || delta < bestDelta)
					&& avgFieldCount > 1.99)
				{
					bestDelta = delta;
					bestDelim = delim;
				}
			}

			_config.delimiter = bestDelim;

			return {
				successful: !!bestDelim,
				bestDelimiter: bestDelim
			};
		}

		function guessLineEndings(input)
		{
			input = input.substr(0, 1024 * 1024);	// max length 1 MB

			var r = input.split('\r');

			var n = input.split('\n');

			var nAppearsFirst = (n.length > 1 && n[0].length < r[0].length);

			if (r.length === 1 || nAppearsFirst)
				return '\n';

			var numWithN = 0;
			for (var i = 0; i < r.length; i++)
			{
				if (r[i][0] === '\n')
					numWithN++;
			}

			return numWithN >= r.length / 2 ? '\r\n' : '\r';
		}

		function addError(type, code, msg, row)
		{
			_results.errors.push({
				type: type,
				code: code,
				message: msg,
				row: row
			});
		}
	}





	/** The core parser implements speedy and correct CSV parsing */
	function Parser(config)
	{
		// Unpack the config object
		config = config || {};
		var delim = config.delimiter;
		var newline = config.newline;
		var comments = config.comments;
		var step = config.step;
		var preview = config.preview;
		var fastMode = config.fastMode;
		var quoteChar;
		/** Allows for no quoteChar by setting quoteChar to undefined in config */
		if (config.quoteChar === undefined) {
			quoteChar = '"';
		} else {
			quoteChar = config.quoteChar;
		}
		var escapeChar = quoteChar;
		if (config.escapeChar !== undefined) {
			escapeChar = config.escapeChar;
		}

		// Delimiter must be valid
		if (typeof delim !== 'string'
			|| Papa.BAD_DELIMITERS.indexOf(delim) > -1)
			delim = ',';

		// Comment character must be valid
		if (comments === delim)
			throw 'Comment character same as delimiter';
		else if (comments === true)
			comments = '#';
		else if (typeof comments !== 'string'
			|| Papa.BAD_DELIMITERS.indexOf(comments) > -1)
			comments = false;

		// Newline must be valid: \r, \n, or \r\n
		if (newline !== '\n' && newline !== '\r' && newline !== '\r\n')
			newline = '\n';

		// We're gonna need these at the Parser scope
		var cursor = 0;
		var aborted = false;

		this.parse = function(input, baseIndex, ignoreLastRow)
		{
			// For some reason, in Chrome, this speeds things up (!?)
			if (typeof input !== 'string')
				throw 'Input must be a string';

			// We don't need to compute some of these every time parse() is called,
			// but having them in a more local scope seems to perform better
			var inputLen = input.length,
				delimLen = delim.length,
				newlineLen = newline.length,
				commentsLen = comments.length;
			var stepIsFunction = isFunction(step);

			// Establish starting state
			cursor = 0;
			var data = [], errors = [], row = [], lastCursor = 0;

			if (!input)
				return returnable();

			if (fastMode || (fastMode !== false && input.indexOf(quoteChar) === -1))
			{
				var rows = input.split(newline);
				for (var i = 0; i < rows.length; i++)
				{
					row = rows[i];
					cursor += row.length;
					if (i !== rows.length - 1)
						cursor += newline.length;
					else if (ignoreLastRow)
						return returnable();
					if (comments && row.substr(0, commentsLen) === comments)
						continue;
					if (stepIsFunction)
					{
						data = [];
						pushRow(row.split(delim));
						doStep();
						if (aborted)
							return returnable();
					}
					else
						pushRow(row.split(delim));
					if (preview && i >= preview)
					{
						data = data.slice(0, preview);
						return returnable(true);
					}
				}
				return returnable();
			}

			var nextDelim = input.indexOf(delim, cursor);
			var nextNewline = input.indexOf(newline, cursor);
			var quoteCharRegex = new RegExp(escapeChar.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&') + quoteChar, 'g');
			var quoteSearch;

			// Parser loop
			for (;;)
			{
				// Field has opening quote
				if (input[cursor] === quoteChar)
				{
					// Start our search for the closing quote where the cursor is
					quoteSearch = cursor;

					// Skip the opening quote
					cursor++;

					for (;;)
					{
						// Find closing quote
						quoteSearch = input.indexOf(quoteChar, quoteSearch + 1);

						//No other quotes are found - no other delimiters
						if (quoteSearch === -1)
						{
							if (!ignoreLastRow) {
								// No closing quote... what a pity
								errors.push({
									type: 'Quotes',
									code: 'MissingQuotes',
									message: 'Quoted field unterminated',
									row: data.length,	// row has yet to be inserted
									index: cursor
								});
							}
							return finish();
						}

						// Closing quote at EOF
						if (quoteSearch === inputLen - 1)
						{
							var value = input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar);
							return finish(value);
						}

						// If this quote is escaped, it's part of the data; skip it
						// If the quote character is the escape character, then check if the next character is the escape character
						if (quoteChar === escapeChar &&  input[quoteSearch + 1] === escapeChar)
						{
							quoteSearch++;
							continue;
						}

						// If the quote character is not the escape character, then check if the previous character was the escape character
						if (quoteChar !== escapeChar && quoteSearch !== 0 && input[quoteSearch - 1] === escapeChar)
						{
							continue;
						}

						var spacesBetweenQuoteAndDelimiter = extraSpaces(nextDelim);

						// Closing quote followed by delimiter or 'unnecessary steps + delimiter'
						if (input[quoteSearch + 1 + spacesBetweenQuoteAndDelimiter] === delim)
						{
							row.push(input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar));
							cursor = quoteSearch + 1 + spacesBetweenQuoteAndDelimiter + delimLen;
							nextDelim = input.indexOf(delim, cursor);
							nextNewline = input.indexOf(newline, cursor);
							break;
						}

						var spacesBetweenQuoteAndNewLine = extraSpaces(nextNewline);

						// Closing quote followed by newline or 'unnecessary spaces + newLine'
						if (input.substr(quoteSearch + 1 + spacesBetweenQuoteAndNewLine, newlineLen) === newline)
						{
							row.push(input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar));
							saveRow(quoteSearch + 1 + spacesBetweenQuoteAndNewLine + newlineLen);
							nextDelim = input.indexOf(delim, cursor);	// because we may have skipped the nextDelim in the quoted field

							if (stepIsFunction)
							{
								doStep();
								if (aborted)
									return returnable();
							}

							if (preview && data.length >= preview)
								return returnable(true);

							break;
						}


						// Checks for valid closing quotes are complete (escaped quotes or quote followed by EOF/delimiter/newline) -- assume these quotes are part of an invalid text string
						errors.push({
							type: 'Quotes',
							code: 'InvalidQuotes',
							message: 'Trailing quote on quoted field is malformed',
							row: data.length,	// row has yet to be inserted
							index: cursor
						});

						quoteSearch++;
						continue;

					}

					continue;
				}

				// Comment found at start of new line
				if (comments && row.length === 0 && input.substr(cursor, commentsLen) === comments)
				{
					if (nextNewline === -1)	// Comment ends at EOF
						return returnable();
					cursor = nextNewline + newlineLen;
					nextNewline = input.indexOf(newline, cursor);
					nextDelim = input.indexOf(delim, cursor);
					continue;
				}

				// Next delimiter comes before next newline, so we've reached end of field
				if (nextDelim !== -1 && (nextDelim < nextNewline || nextNewline === -1))
				{
					row.push(input.substring(cursor, nextDelim));
					cursor = nextDelim + delimLen;
					nextDelim = input.indexOf(delim, cursor);
					continue;
				}

				// End of row
				if (nextNewline !== -1)
				{
					row.push(input.substring(cursor, nextNewline));
					saveRow(nextNewline + newlineLen);

					if (stepIsFunction)
					{
						doStep();
						if (aborted)
							return returnable();
					}

					if (preview && data.length >= preview)
						return returnable(true);

					continue;
				}

				break;
			}


			return finish();


			function pushRow(row)
			{
				data.push(row);
				lastCursor = cursor;
			}

			/**
             * checks if there are extra spaces after closing quote and given index without any text
             * if Yes, returns the number of spaces
             */
			function extraSpaces(index) {
				var spaceLength = 0;
				if (index !== -1) {
					var textBetweenClosingQuoteAndIndex = input.substring(quoteSearch + 1, index);
					if (textBetweenClosingQuoteAndIndex && textBetweenClosingQuoteAndIndex.trim() === '') {
						spaceLength = textBetweenClosingQuoteAndIndex.length;
					}
				}
				return spaceLength;
			}

			/**
			 * Appends the remaining input from cursor to the end into
			 * row, saves the row, calls step, and returns the results.
			 */
			function finish(value)
			{
				if (ignoreLastRow)
					return returnable();
				if (typeof value === 'undefined')
					value = input.substr(cursor);
				row.push(value);
				cursor = inputLen;	// important in case parsing is paused
				pushRow(row);
				if (stepIsFunction)
					doStep();
				return returnable();
			}

			/**
			 * Appends the current row to the results. It sets the cursor
			 * to newCursor and finds the nextNewline. The caller should
			 * take care to execute user's step function and check for
			 * preview and end parsing if necessary.
			 */
			function saveRow(newCursor)
			{
				cursor = newCursor;
				pushRow(row);
				row = [];
				nextNewline = input.indexOf(newline, cursor);
			}

			/** Returns an object with the results, errors, and meta. */
			function returnable(stopped)
			{
				return {
					data: data,
					errors: errors,
					meta: {
						delimiter: delim,
						linebreak: newline,
						aborted: aborted,
						truncated: !!stopped,
						cursor: lastCursor + (baseIndex || 0)
					}
				};
			}

			/** Executes the user's step function and resets data & errors. */
			function doStep()
			{
				step(returnable());
				data = [];
				errors = [];
			}
		};

		/** Sets the abort flag */
		this.abort = function()
		{
			aborted = true;
		};

		/** Gets the cursor position */
		this.getCharIndex = function()
		{
			return cursor;
		};
	}


	// If you need to load Papa Parse asynchronously and you also need worker threads, hard-code
	// the script path here. See: https://github.com/mholt/PapaParse/issues/87#issuecomment-57885358
	function getScriptPath()
	{
		var scripts = document.getElementsByTagName('script');
		return scripts.length ? scripts[scripts.length - 1].src : '';
	}

	function newWorker()
	{
		if (!Papa.WORKERS_SUPPORTED)
			return false;
		if (!LOADED_SYNC && Papa.SCRIPT_PATH === null)
			throw new Error(
				'Script path cannot be determined automatically when Papa Parse is loaded asynchronously. ' +
				'You need to set Papa.SCRIPT_PATH manually.'
			);
		var workerUrl = Papa.SCRIPT_PATH || AUTO_SCRIPT_PATH;
		// Append 'papaworker' to the search string to tell papaparse that this is our worker.
		workerUrl += (workerUrl.indexOf('?') !== -1 ? '&' : '?') + 'papaworker';
		var w = new global.Worker(workerUrl);
		w.onmessage = mainThreadReceivedMessage;
		w.id = workerIdCounter++;
		workers[w.id] = w;
		return w;
	}

	/** Callback when main thread receives a message */
	function mainThreadReceivedMessage(e)
	{
		var msg = e.data;
		var worker = workers[msg.workerId];
		var aborted = false;

		if (msg.error)
			worker.userError(msg.error, msg.file);
		else if (msg.results && msg.results.data)
		{
			var abort = function() {
				aborted = true;
				completeWorker(msg.workerId, { data: [], errors: [], meta: { aborted: true } });
			};

			var handle = {
				abort: abort,
				pause: notImplemented,
				resume: notImplemented
			};

			if (isFunction(worker.userStep))
			{
				for (var i = 0; i < msg.results.data.length; i++)
				{
					worker.userStep({
						data: [msg.results.data[i]],
						errors: msg.results.errors,
						meta: msg.results.meta
					}, handle);
					if (aborted)
						break;
				}
				delete msg.results;	// free memory ASAP
			}
			else if (isFunction(worker.userChunk))
			{
				worker.userChunk(msg.results, handle, msg.file);
				delete msg.results;
			}
		}

		if (msg.finished && !aborted)
			completeWorker(msg.workerId, msg.results);
	}

	function completeWorker(workerId, results) {
		var worker = workers[workerId];
		if (isFunction(worker.userComplete))
			worker.userComplete(results);
		worker.terminate();
		delete workers[workerId];
	}

	function notImplemented() {
		throw 'Not implemented.';
	}

	/** Callback when worker thread receives a message */
	function workerThreadReceivedMessage(e)
	{
		var msg = e.data;

		if (typeof Papa.WORKER_ID === 'undefined' && msg)
			Papa.WORKER_ID = msg.workerId;

		if (typeof msg.input === 'string')
		{
			global.postMessage({
				workerId: Papa.WORKER_ID,
				results: Papa.parse(msg.input, msg.config),
				finished: true
			});
		}
		else if ((global.File && msg.input instanceof File) || msg.input instanceof Object)	// thank you, Safari (see issue #106)
		{
			var results = Papa.parse(msg.input, msg.config);
			if (results)
				global.postMessage({
					workerId: Papa.WORKER_ID,
					results: results,
					finished: true
				});
		}
	}

	/** Makes a deep copy of an array or object (mostly) */
	function copy(obj)
	{
		if (typeof obj !== 'object')
			return obj;
		var cpy = obj instanceof Array ? [] : {};
		for (var key in obj)
			cpy[key] = copy(obj[key]);
		return cpy;
	}

	function bindFunction(f, self)
	{
		return function() { f.apply(self, arguments); };
	}

	function isFunction(func)
	{
		return typeof func === 'function';
	}

	return Papa;
}));


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



module.exports = __webpack_require__(2711);


/***/ }),
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1), __webpack_require__(10));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types"], factory);
	else if(typeof exports === 'object')
		exports["Dropzone"] = factory(require("react"), require("prop-types"));
	else
		root["Dropzone"] = factory(root["react"], root["prop-types"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _attrAccept = __webpack_require__(4);
	
	var _attrAccept2 = _interopRequireDefault(_attrAccept);
	
	var _getDataTransferItems = __webpack_require__(5);
	
	var _getDataTransferItems2 = _interopRequireDefault(_getDataTransferItems);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint prefer-template: 0 */
	
	var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;
	
	function fileAccepted(file, accept) {
	  // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
	  // that MIME type will always be accepted
	  return file.type === 'application/x-moz-file' || (0, _attrAccept2.default)(file, accept);
	}
	
	var Dropzone = function (_React$Component) {
	  _inherits(Dropzone, _React$Component);
	
	  _createClass(Dropzone, null, [{
	    key: 'onDocumentDragOver',
	    value: function onDocumentDragOver(evt) {
	      // allow the entire document to be a drag target
	      evt.preventDefault();
	    }
	  }]);
	
	  function Dropzone(props, context) {
	    _classCallCheck(this, Dropzone);
	
	    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));
	
	    _this.renderChildren = function (children, isDragActive, isDragReject) {
	      if (typeof children === 'function') {
	        return children(_extends({}, _this.state, { isDragActive: isDragActive, isDragReject: isDragReject }));
	      }
	      return children;
	    };
	
	    _this.onClick = _this.onClick.bind(_this);
	    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
	    _this.onDragStart = _this.onDragStart.bind(_this);
	    _this.onDragEnter = _this.onDragEnter.bind(_this);
	    _this.onDragLeave = _this.onDragLeave.bind(_this);
	    _this.onDragOver = _this.onDragOver.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
	    _this.setRef = _this.setRef.bind(_this);
	    _this.setRefs = _this.setRefs.bind(_this);
	    _this.onInputElementClick = _this.onInputElementClick.bind(_this);
	    _this.isFileDialogActive = false;
	    _this.state = {
	      draggedFiles: [],
	      acceptedFiles: [],
	      rejectedFiles: []
	    };
	    return _this;
	  }
	
	  _createClass(Dropzone, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var preventDropOnDocument = this.props.preventDropOnDocument;
	
	      this.dragTargets = [];
	
	      if (preventDropOnDocument) {
	        document.addEventListener('dragover', Dropzone.onDocumentDragOver, false);
	        document.addEventListener('drop', this.onDocumentDrop, false);
	      }
	      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
	      // Tried implementing addEventListener, but didn't work out
	      document.body.onfocus = this.onFileDialogCancel;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var preventDropOnDocument = this.props.preventDropOnDocument;
	
	      if (preventDropOnDocument) {
	        document.removeEventListener('dragover', Dropzone.onDocumentDragOver);
	        document.removeEventListener('drop', this.onDocumentDrop);
	      }
	      this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
	      // Can be replaced with removeEventListener, if addEventListener works
	      document.body.onfocus = null;
	    }
	  }, {
	    key: 'onDocumentDrop',
	    value: function onDocumentDrop(evt) {
	      if (this.node.contains(evt.target)) {
	        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
	        return;
	      }
	      evt.preventDefault();
	      this.dragTargets = [];
	    }
	  }, {
	    key: 'onDragStart',
	    value: function onDragStart(evt) {
	      if (this.props.onDragStart) {
	        this.props.onDragStart.call(this, evt);
	      }
	    }
	  }, {
	    key: 'onDragEnter',
	    value: function onDragEnter(evt) {
	      evt.preventDefault();
	
	      // Count the dropzone and any children that are entered.
	      if (this.dragTargets.indexOf(evt.target) === -1) {
	        this.dragTargets.push(evt.target);
	      }
	
	      this.setState({ draggedFiles: (0, _getDataTransferItems2.default)(evt) });
	
	      if (this.props.onDragEnter) {
	        this.props.onDragEnter.call(this, evt);
	      }
	    }
	  }, {
	    key: 'onDragOver',
	    value: function onDragOver(evt) {
	      // eslint-disable-line class-methods-use-this
	      evt.preventDefault();
	      evt.stopPropagation();
	      try {
	        evt.dataTransfer.dropEffect = 'copy'; // eslint-disable-line no-param-reassign
	      } catch (err) {
	        // continue regardless of error
	      }
	
	      if (this.props.onDragOver) {
	        this.props.onDragOver.call(this, evt);
	      }
	      return false;
	    }
	  }, {
	    key: 'onDragLeave',
	    value: function onDragLeave(evt) {
	      var _this2 = this;
	
	      evt.preventDefault();
	
	      // Only deactivate once the dropzone and all children have been left.
	      this.dragTargets = this.dragTargets.filter(function (el) {
	        return el !== evt.target && _this2.node.contains(el);
	      });
	      if (this.dragTargets.length > 0) {
	        return;
	      }
	
	      // Clear dragging files state
	      this.setState({ draggedFiles: [] });
	
	      if (this.props.onDragLeave) {
	        this.props.onDragLeave.call(this, evt);
	      }
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(evt) {
	      var _this3 = this;
	
	      var _props = this.props,
	          onDrop = _props.onDrop,
	          onDropAccepted = _props.onDropAccepted,
	          onDropRejected = _props.onDropRejected,
	          multiple = _props.multiple,
	          disablePreview = _props.disablePreview,
	          accept = _props.accept;
	
	      var fileList = (0, _getDataTransferItems2.default)(evt);
	      var acceptedFiles = [];
	      var rejectedFiles = [];
	
	      // Stop default browser behavior
	      evt.preventDefault();
	
	      // Reset the counter along with the drag on a drop.
	      this.dragTargets = [];
	      this.isFileDialogActive = false;
	
	      fileList.forEach(function (file) {
	        if (!disablePreview) {
	          try {
	            file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
	          } catch (err) {
	            if (process.env.NODE_ENV !== 'production') {
	              console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
	            }
	          }
	        }
	
	        if (fileAccepted(file, accept) && _this3.fileMatchSize(file)) {
	          acceptedFiles.push(file);
	        } else {
	          rejectedFiles.push(file);
	        }
	      });
	
	      if (!multiple) {
	        // if not in multi mode add any extra accepted files to rejected.
	        // This will allow end users to easily ignore a multi file drop in "single" mode.
	        rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
	      }
	
	      if (onDrop) {
	        onDrop.call(this, acceptedFiles, rejectedFiles, evt);
	      }
	
	      if (rejectedFiles.length > 0 && onDropRejected) {
	        onDropRejected.call(this, rejectedFiles, evt);
	      }
	
	      if (acceptedFiles.length > 0 && onDropAccepted) {
	        onDropAccepted.call(this, acceptedFiles, evt);
	      }
	
	      // Clear files value
	      this.draggedFiles = null;
	
	      // Reset drag state
	      this.setState({
	        draggedFiles: [],
	        acceptedFiles: acceptedFiles,
	        rejectedFiles: rejectedFiles
	      });
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(evt) {
	      var _props2 = this.props,
	          onClick = _props2.onClick,
	          disableClick = _props2.disableClick;
	
	      if (!disableClick) {
	        evt.stopPropagation();
	
	        if (onClick) {
	          onClick.call(this, evt);
	        }
	
	        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
	        // this is so react can handle state changes in the onClick prop above above
	        // see: https://github.com/okonet/react-dropzone/issues/450
	        setTimeout(this.open.bind(this), 0);
	      }
	    }
	  }, {
	    key: 'onInputElementClick',
	    value: function onInputElementClick(evt) {
	      evt.stopPropagation();
	      if (this.props.inputProps && this.props.inputProps.onClick) {
	        this.props.inputProps.onClick();
	      }
	    }
	  }, {
	    key: 'onFileDialogCancel',
	    value: function onFileDialogCancel() {
	      // timeout will not recognize context of this method
	      var onFileDialogCancel = this.props.onFileDialogCancel;
	      var fileInputEl = this.fileInputEl;
	      var isFileDialogActive = this.isFileDialogActive;
	      // execute the timeout only if the onFileDialogCancel is defined and FileDialog
	      // is opened in the browser
	
	      if (onFileDialogCancel && isFileDialogActive) {
	        setTimeout(function () {
	          // Returns an object as FileList
	          var FileList = fileInputEl.files;
	          if (!FileList.length) {
	            isFileDialogActive = false;
	            onFileDialogCancel();
	          }
	        }, 300);
	      }
	    }
	  }, {
	    key: 'setRef',
	    value: function setRef(ref) {
	      this.node = ref;
	    }
	  }, {
	    key: 'setRefs',
	    value: function setRefs(ref) {
	      this.fileInputEl = ref;
	    }
	  }, {
	    key: 'fileMatchSize',
	    value: function fileMatchSize(file) {
	      return file.size <= this.props.maxSize && file.size >= this.props.minSize;
	    }
	  }, {
	    key: 'allFilesAccepted',
	    value: function allFilesAccepted(files) {
	      var _this4 = this;
	
	      return files.every(function (file) {
	        return fileAccepted(file, _this4.props.accept);
	      });
	    }
	
	    /**
	     * Open system file upload dialog.
	     *
	     * @public
	     */
	
	  }, {
	    key: 'open',
	    value: function open() {
	      this.isFileDialogActive = true;
	      this.fileInputEl.value = null;
	      this.fileInputEl.click();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          accept = _props3.accept,
	          activeClassName = _props3.activeClassName,
	          inputProps = _props3.inputProps,
	          multiple = _props3.multiple,
	          name = _props3.name,
	          rejectClassName = _props3.rejectClassName,
	          children = _props3.children,
	          rest = _objectWithoutProperties(_props3, ['accept', 'activeClassName', 'inputProps', 'multiple', 'name', 'rejectClassName', 'children']);
	
	      var activeStyle = rest.activeStyle,
	          className = rest.className,
	          rejectStyle = rest.rejectStyle,
	          style = rest.style,
	          props = _objectWithoutProperties(rest, ['activeStyle', 'className', 'rejectStyle', 'style']);
	
	      var draggedFiles = this.state.draggedFiles;
	
	      var filesCount = draggedFiles.length;
	      var isMultipleAllowed = multiple || filesCount <= 1;
	      var isDragActive = filesCount > 0 && this.allFilesAccepted(draggedFiles);
	      var isDragReject = filesCount > 0 && (!isDragActive || !isMultipleAllowed);
	
	      className = className || '';
	
	      if (isDragActive && activeClassName) {
	        className += ' ' + activeClassName;
	      }
	      if (isDragReject && rejectClassName) {
	        className += ' ' + rejectClassName;
	      }
	
	      if (!className && !style && !activeStyle && !rejectStyle) {
	        style = {
	          width: 200,
	          height: 200,
	          borderWidth: 2,
	          borderColor: '#666',
	          borderStyle: 'dashed',
	          borderRadius: 5
	        };
	        activeStyle = {
	          borderStyle: 'solid',
	          borderColor: '#6c6',
	          backgroundColor: '#eee'
	        };
	        rejectStyle = {
	          borderStyle: 'solid',
	          borderColor: '#c66',
	          backgroundColor: '#eee'
	        };
	      }
	
	      var appliedStyle = void 0;
	      if (activeStyle && isDragActive) {
	        appliedStyle = _extends({}, style, activeStyle);
	      } else if (rejectStyle && isDragReject) {
	        appliedStyle = _extends({}, style, rejectStyle);
	      } else {
	        appliedStyle = _extends({}, style);
	      }
	
	      var inputAttributes = {
	        accept: accept,
	        type: 'file',
	        style: { display: 'none' },
	        multiple: supportMultiple && multiple,
	        ref: this.setRefs,
	        onChange: this.onDrop
	      };
	
	      if (name && name.length) {
	        inputAttributes.name = name;
	      }
	
	      // Remove custom properties before passing them to the wrapper div element
	      var customProps = ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize'];
	      var divProps = _extends({}, props);
	      customProps.forEach(function (prop) {
	        return delete divProps[prop];
	      });
	
	      return _react2.default.createElement(
	        'div',
	        _extends({
	          className: className,
	          style: appliedStyle
	        }, divProps /* expand user provided props first so event handlers are never overridden */, {
	          onClick: this.onClick,
	          onDragStart: this.onDragStart,
	          onDragEnter: this.onDragEnter,
	          onDragOver: this.onDragOver,
	          onDragLeave: this.onDragLeave,
	          onDrop: this.onDrop,
	          ref: this.setRef
	        }),
	        this.renderChildren(children, isDragActive, isDragReject),
	        _react2.default.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
	      );
	    }
	  }]);
	
	  return Dropzone;
	}(_react2.default.Component);
	
	Dropzone.propTypes = {
	  /**
	   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
	   * Keep in mind that mime type determination is not reliable accross platforms. CSV files,
	   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
	   * Windows. In some cases there might not be a mime type set at all.
	   * See: https://github.com/okonet/react-dropzone/issues/276
	   */
	  accept: _propTypes2.default.string,
	
	  /**
	   * Contents of the dropzone
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	
	  /**
	   * Disallow clicking on the dropzone container to open file dialog
	   */
	  disableClick: _propTypes2.default.bool,
	
	  /**
	   * Enable/disable preview generation
	   */
	  disablePreview: _propTypes2.default.bool,
	
	  /**
	   * If false, allow dropped items to take over the current browser window
	   */
	  preventDropOnDocument: _propTypes2.default.bool,
	
	  /**
	   * Pass additional attributes to the `<input type="file"/>` tag
	   */
	  inputProps: _propTypes2.default.object,
	
	  /**
	   * Allow dropping multiple files
	   */
	  multiple: _propTypes2.default.bool,
	
	  /**
	   * `name` attribute for the input tag
	   */
	  name: _propTypes2.default.string,
	
	  /**
	   * Maximum file size
	   */
	  maxSize: _propTypes2.default.number,
	
	  /**
	   * Minimum file size
	   */
	  minSize: _propTypes2.default.number,
	
	  /**
	   * className
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * className for accepted state
	   */
	  activeClassName: _propTypes2.default.string,
	
	  /**
	   * className for rejected state
	   */
	  rejectClassName: _propTypes2.default.string,
	
	  /**
	   * CSS styles to apply
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * CSS styles to apply when drop will be accepted
	   */
	  activeStyle: _propTypes2.default.object,
	
	  /**
	   * CSS styles to apply when drop will be rejected
	   */
	  rejectStyle: _propTypes2.default.object,
	
	  /**
	   * onClick callback
	   * @param {Event} event
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * onDrop callback
	   */
	  onDrop: _propTypes2.default.func,
	
	  /**
	   * onDropAccepted callback
	   */
	  onDropAccepted: _propTypes2.default.func,
	
	  /**
	   * onDropRejected callback
	   */
	  onDropRejected: _propTypes2.default.func,
	
	  /**
	   * onDragStart callback
	   */
	  onDragStart: _propTypes2.default.func,
	
	  /**
	   * onDragEnter callback
	   */
	  onDragEnter: _propTypes2.default.func,
	
	  /**
	   * onDragOver callback
	   */
	  onDragOver: _propTypes2.default.func,
	
	  /**
	   * onDragLeave callback
	   */
	  onDragLeave: _propTypes2.default.func,
	
	  /**
	   * Provide a callback on clicking the cancel button of the file dialog
	   */
	  onFileDialogCancel: _propTypes2.default.func
	};
	
	Dropzone.defaultProps = {
	  preventDropOnDocument: true,
	  disablePreview: false,
	  disableClick: false,
	  multiple: true,
	  maxSize: Infinity,
	  minSize: 0
	};
	
	exports.default = Dropzone;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={exports:{},id:e,loaded:!1};return t[e].call(o.exports,o,o.exports,n),o.loaded=!0,o.exports}var r={};return n.m=t,n.c=r,n.p="",n(0)}([function(t,n,r){"use strict";n.__esModule=!0,r(8),r(9),n["default"]=function(t,n){if(t&&n){var r=function(){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return{v:r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):/\/\*$/.test(n)?i===n.replace(/\/.*$/,""):o===n})}}();if("object"==typeof r)return r.v}return!0},t.exports=n["default"]},function(t,n){var r=t.exports={version:"1.2.2"};"number"==typeof __e&&(__e=r)},function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n,r){var e=r(2),o=r(1),i=r(4),u=r(19),c="prototype",f=function(t,n){return function(){return t.apply(n,arguments)}},s=function(t,n,r){var a,p,l,y,d=t&s.G,h=t&s.P,v=d?e:t&s.S?e[n]||(e[n]={}):(e[n]||{})[c],x=d?o:o[n]||(o[n]={});d&&(r=n);for(a in r)p=!(t&s.F)&&v&&a in v,l=(p?v:r)[a],y=t&s.B&&p?f(l,e):h&&"function"==typeof l?f(Function.call,l):l,v&&!p&&u(v,a,l),x[a]!=l&&i(x,a,y),h&&((x[c]||(x[c]={}))[a]=l)};e.core=o,s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,t.exports=s},function(t,n,r){var e=r(5),o=r(18);t.exports=r(22)?function(t,n,r){return e.setDesc(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=Object;t.exports={create:r.create,getProto:r.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:r.getOwnPropertyDescriptor,setDesc:r.defineProperty,setDescs:r.defineProperties,getKeys:r.keys,getNames:r.getOwnPropertyNames,getSymbols:r.getOwnPropertySymbols,each:[].forEach}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(20)("wks"),o=r(2).Symbol;t.exports=function(t){return e[t]||(e[t]=o&&o[t]||(o||r(6))("Symbol."+t))}},function(t,n,r){r(26),t.exports=r(1).Array.some},function(t,n,r){r(25),t.exports=r(1).String.endsWith},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(10);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(e){try{return n[r(7)("match")]=!1,!"/./"[t](n)}catch(o){}}return!0}},function(t,n){t.exports=function(t){try{return!!t()}catch(n){return!0}}},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n,r){var e=r(16),o=r(11),i=r(7)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(2),o=r(4),i=r(6)("src"),u="toString",c=Function[u],f=(""+c).split(u);r(1).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,u){"function"==typeof r&&(o(r,i,t[n]?""+t[n]:f.join(String(n))),"name"in r||(r.name=n)),t===e?t[n]=r:(u||delete t[n],o(t,n,r))})(Function.prototype,u,function(){return"function"==typeof this&&this[i]||c.call(this)})},function(t,n,r){var e=r(2),o="__core-js_shared__",i=e[o]||(e[o]={});t.exports=function(t){return i[t]||(i[t]={})}},function(t,n,r){var e=r(17),o=r(13);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){t.exports=!r(15)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(23),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";var e=r(3),o=r(24),i=r(21),u="endsWith",c=""[u];e(e.P+e.F*r(14)(u),"String",{endsWith:function(t){var n=i(this,t,u),r=arguments,e=r.length>1?r[1]:void 0,f=o(n.length),s=void 0===e?f:Math.min(o(e),f),a=String(t);return c?c.call(n,a,s):n.slice(s-a.length,s)===a}})},function(t,n,r){var e=r(5),o=r(3),i=r(1).Array||Array,u={},c=function(t,n){e.each.call(t.split(","),function(t){void 0==n&&t in i?u[t]=i[t]:t in[]&&(u[t]=r(12)(Function.call,[][t],n))})};c("pop,reverse,shift,keys,values,entries",1),c("indexOf,every,some,forEach,map,filter,find,findIndex,includes",3),c("join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill"),o(o.S,"Array",u)}]);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDataTransferFiles;
	function getDataTransferFiles(event) {
	  var dataTransferItemsList = [];
	  if (event.dataTransfer) {
	    var dt = event.dataTransfer;
	    if (dt.files && dt.files.length) {
	      dataTransferItemsList = dt.files;
	    } else if (dt.items && dt.items.length) {
	      // During the drag even the dataTransfer.files is null
	      // but Chrome implements some drag store, which is accesible via dataTransfer.items
	      dataTransferItemsList = dt.items;
	    }
	  } else if (event.target && event.target.files) {
	    dataTransferItemsList = event.target.files;
	  }
	  // Convert from DataTransferItemsList to the native Array
	  return Array.prototype.slice.call(dataTransferItemsList);
	}
	module.exports = exports["default"];

/***/ })
/******/ ])
});
;
//# sourceMappingURL=index.js.map

/***/ }),
/* 586 */,
/* 587 */,
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = loopAsync;
/* harmony export (immutable) */ __webpack_exports__["a"] = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContextProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = ContextSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  eventIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

function ContextProvider(name) {
  var _childContextTypes, _ref2;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  return _ref2 = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _ref2[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _ref2;
}

function ContextSubscriber(name) {
  var _contextTypes, _ref4;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  return _ref4 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref3;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _ref4;
}

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routerShape; });
/* unused harmony export locationShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var routerShape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  setRouteLeaveHook: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var locationShape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  pathname: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  search: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  state: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
  action: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
});

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getRouteParams__ = __webpack_require__(2704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouteUtils__ = __webpack_require__(198);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };










/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */
var RouterContext = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'RouterContext',

  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["a" /* ContextProvider */])('router')],

  propTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    location: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    routes: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    params: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    components: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"].isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement
    };
  },


  childContextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getRouteParams__["a" /* default */])(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__RouteUtils__["a" /* isReactChildren */])(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element)) ?  false ? invariant(false, 'The root route must render a single element') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return element;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterContext);

/***/ }),
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.10.0
var BRUTEFORCE_CARDINALITY, MIN_GUESSES_BEFORE_GROWING_SEQUENCE, MIN_SUBMATCH_GUESSES_MULTI_CHAR, MIN_SUBMATCH_GUESSES_SINGLE_CHAR, adjacency_graphs, calc_average_degree, k, scoring, v;

adjacency_graphs = __webpack_require__(1125);

calc_average_degree = function(graph) {
  var average, k, key, n, neighbors, v;
  average = 0;
  for (key in graph) {
    neighbors = graph[key];
    average += ((function() {
      var len, o, results;
      results = [];
      for (o = 0, len = neighbors.length; o < len; o++) {
        n = neighbors[o];
        if (n) {
          results.push(n);
        }
      }
      return results;
    })()).length;
  }
  average /= ((function() {
    var results;
    results = [];
    for (k in graph) {
      v = graph[k];
      results.push(k);
    }
    return results;
  })()).length;
  return average;
};

BRUTEFORCE_CARDINALITY = 10;

MIN_GUESSES_BEFORE_GROWING_SEQUENCE = 10000;

MIN_SUBMATCH_GUESSES_SINGLE_CHAR = 10;

MIN_SUBMATCH_GUESSES_MULTI_CHAR = 50;

scoring = {
  nCk: function(n, k) {
    var d, o, r, ref;
    if (k > n) {
      return 0;
    }
    if (k === 0) {
      return 1;
    }
    r = 1;
    for (d = o = 1, ref = k; 1 <= ref ? o <= ref : o >= ref; d = 1 <= ref ? ++o : --o) {
      r *= n;
      r /= d;
      n -= 1;
    }
    return r;
  },
  log10: function(n) {
    return Math.log(n) / Math.log(10);
  },
  log2: function(n) {
    return Math.log(n) / Math.log(2);
  },
  factorial: function(n) {
    var f, i, o, ref;
    if (n < 2) {
      return 1;
    }
    f = 1;
    for (i = o = 2, ref = n; 2 <= ref ? o <= ref : o >= ref; i = 2 <= ref ? ++o : --o) {
      f *= i;
    }
    return f;
  },
  most_guessable_match_sequence: function(password, matches, _exclude_additive) {
    var _, bruteforce_update, guesses, k, l, len, len1, len2, lst, m, make_bruteforce_match, matches_by_j, n, o, optimal, optimal_l, optimal_match_sequence, q, ref, ref1, u, unwind, update, w;
    if (_exclude_additive == null) {
      _exclude_additive = false;
    }
    n = password.length;
    matches_by_j = (function() {
      var o, ref, results;
      results = [];
      for (_ = o = 0, ref = n; 0 <= ref ? o < ref : o > ref; _ = 0 <= ref ? ++o : --o) {
        results.push([]);
      }
      return results;
    })();
    for (o = 0, len = matches.length; o < len; o++) {
      m = matches[o];
      matches_by_j[m.j].push(m);
    }
    for (q = 0, len1 = matches_by_j.length; q < len1; q++) {
      lst = matches_by_j[q];
      lst.sort(function(m1, m2) {
        return m1.i - m2.i;
      });
    }
    optimal = {
      m: (function() {
        var ref, results, u;
        results = [];
        for (_ = u = 0, ref = n; 0 <= ref ? u < ref : u > ref; _ = 0 <= ref ? ++u : --u) {
          results.push({});
        }
        return results;
      })(),
      pi: (function() {
        var ref, results, u;
        results = [];
        for (_ = u = 0, ref = n; 0 <= ref ? u < ref : u > ref; _ = 0 <= ref ? ++u : --u) {
          results.push({});
        }
        return results;
      })(),
      g: (function() {
        var ref, results, u;
        results = [];
        for (_ = u = 0, ref = n; 0 <= ref ? u < ref : u > ref; _ = 0 <= ref ? ++u : --u) {
          results.push({});
        }
        return results;
      })()
    };
    update = (function(_this) {
      return function(m, l) {
        var competing_g, competing_l, g, k, pi, ref;
        k = m.j;
        pi = _this.estimate_guesses(m, password);
        if (l > 1) {
          pi *= optimal.pi[m.i - 1][l - 1];
        }
        g = _this.factorial(l) * pi;
        if (!_exclude_additive) {
          g += Math.pow(MIN_GUESSES_BEFORE_GROWING_SEQUENCE, l - 1);
        }
        ref = optimal.g[k];
        for (competing_l in ref) {
          competing_g = ref[competing_l];
          if (competing_l > l) {
            continue;
          }
          if (competing_g <= g) {
            return;
          }
        }
        optimal.g[k][l] = g;
        optimal.m[k][l] = m;
        return optimal.pi[k][l] = pi;
      };
    })(this);
    bruteforce_update = (function(_this) {
      return function(k) {
        var i, l, last_m, ref, results, u;
        m = make_bruteforce_match(0, k);
        update(m, 1);
        results = [];
        for (i = u = 1, ref = k; 1 <= ref ? u <= ref : u >= ref; i = 1 <= ref ? ++u : --u) {
          m = make_bruteforce_match(i, k);
          results.push((function() {
            var ref1, results1;
            ref1 = optimal.m[i - 1];
            results1 = [];
            for (l in ref1) {
              last_m = ref1[l];
              l = parseInt(l);
              if (last_m.pattern === 'bruteforce') {
                continue;
              }
              results1.push(update(m, l + 1));
            }
            return results1;
          })());
        }
        return results;
      };
    })(this);
    make_bruteforce_match = (function(_this) {
      return function(i, j) {
        return {
          pattern: 'bruteforce',
          token: password.slice(i, +j + 1 || 9e9),
          i: i,
          j: j
        };
      };
    })(this);
    unwind = (function(_this) {
      return function(n) {
        var candidate_g, candidate_l, g, k, l, optimal_match_sequence, ref;
        optimal_match_sequence = [];
        k = n - 1;
        l = void 0;
        g = Infinity;
        ref = optimal.g[k];
        for (candidate_l in ref) {
          candidate_g = ref[candidate_l];
          if (candidate_g < g) {
            l = candidate_l;
            g = candidate_g;
          }
        }
        while (k >= 0) {
          m = optimal.m[k][l];
          optimal_match_sequence.unshift(m);
          k = m.i - 1;
          l--;
        }
        return optimal_match_sequence;
      };
    })(this);
    for (k = u = 0, ref = n; 0 <= ref ? u < ref : u > ref; k = 0 <= ref ? ++u : --u) {
      ref1 = matches_by_j[k];
      for (w = 0, len2 = ref1.length; w < len2; w++) {
        m = ref1[w];
        if (m.i > 0) {
          for (l in optimal.m[m.i - 1]) {
            l = parseInt(l);
            update(m, l + 1);
          }
        } else {
          update(m, 1);
        }
      }
      bruteforce_update(k);
    }
    optimal_match_sequence = unwind(n);
    optimal_l = optimal_match_sequence.length;
    if (password.length === 0) {
      guesses = 1;
    } else {
      guesses = optimal.g[n - 1][optimal_l];
    }
    return {
      password: password,
      guesses: guesses,
      guesses_log10: this.log10(guesses),
      sequence: optimal_match_sequence
    };
  },
  estimate_guesses: function(match, password) {
    var estimation_functions, guesses, min_guesses;
    if (match.guesses != null) {
      return match.guesses;
    }
    min_guesses = 1;
    if (match.token.length < password.length) {
      min_guesses = match.token.length === 1 ? MIN_SUBMATCH_GUESSES_SINGLE_CHAR : MIN_SUBMATCH_GUESSES_MULTI_CHAR;
    }
    estimation_functions = {
      bruteforce: this.bruteforce_guesses,
      dictionary: this.dictionary_guesses,
      spatial: this.spatial_guesses,
      repeat: this.repeat_guesses,
      sequence: this.sequence_guesses,
      regex: this.regex_guesses,
      date: this.date_guesses
    };
    guesses = estimation_functions[match.pattern].call(this, match);
    match.guesses = Math.max(guesses, min_guesses);
    match.guesses_log10 = this.log10(match.guesses);
    return match.guesses;
  },
  bruteforce_guesses: function(match) {
    var guesses, min_guesses;
    guesses = Math.pow(BRUTEFORCE_CARDINALITY, match.token.length);
    if (guesses === Number.POSITIVE_INFINITY) {
      guesses = Number.MAX_VALUE;
    }
    min_guesses = match.token.length === 1 ? MIN_SUBMATCH_GUESSES_SINGLE_CHAR + 1 : MIN_SUBMATCH_GUESSES_MULTI_CHAR + 1;
    return Math.max(guesses, min_guesses);
  },
  repeat_guesses: function(match) {
    return match.base_guesses * match.repeat_count;
  },
  sequence_guesses: function(match) {
    var base_guesses, first_chr;
    first_chr = match.token.charAt(0);
    if (first_chr === 'a' || first_chr === 'A' || first_chr === 'z' || first_chr === 'Z' || first_chr === '0' || first_chr === '1' || first_chr === '9') {
      base_guesses = 4;
    } else {
      if (first_chr.match(/\d/)) {
        base_guesses = 10;
      } else {
        base_guesses = 26;
      }
    }
    if (!match.ascending) {
      base_guesses *= 2;
    }
    return base_guesses * match.token.length;
  },
  MIN_YEAR_SPACE: 20,
  REFERENCE_YEAR: new Date().getFullYear(),
  regex_guesses: function(match) {
    var char_class_bases, year_space;
    char_class_bases = {
      alpha_lower: 26,
      alpha_upper: 26,
      alpha: 52,
      alphanumeric: 62,
      digits: 10,
      symbols: 33
    };
    if (match.regex_name in char_class_bases) {
      return Math.pow(char_class_bases[match.regex_name], match.token.length);
    } else {
      switch (match.regex_name) {
        case 'recent_year':
          year_space = Math.abs(parseInt(match.regex_match[0]) - this.REFERENCE_YEAR);
          year_space = Math.max(year_space, this.MIN_YEAR_SPACE);
          return year_space;
      }
    }
  },
  date_guesses: function(match) {
    var guesses, year_space;
    year_space = Math.max(Math.abs(match.year - this.REFERENCE_YEAR), this.MIN_YEAR_SPACE);
    guesses = year_space * 365;
    if (match.separator) {
      guesses *= 4;
    }
    return guesses;
  },
  KEYBOARD_AVERAGE_DEGREE: calc_average_degree(adjacency_graphs.qwerty),
  KEYPAD_AVERAGE_DEGREE: calc_average_degree(adjacency_graphs.keypad),
  KEYBOARD_STARTING_POSITIONS: ((function() {
    var ref, results;
    ref = adjacency_graphs.qwerty;
    results = [];
    for (k in ref) {
      v = ref[k];
      results.push(k);
    }
    return results;
  })()).length,
  KEYPAD_STARTING_POSITIONS: ((function() {
    var ref, results;
    ref = adjacency_graphs.keypad;
    results = [];
    for (k in ref) {
      v = ref[k];
      results.push(k);
    }
    return results;
  })()).length,
  spatial_guesses: function(match) {
    var L, S, U, d, guesses, i, j, o, possible_turns, q, ref, ref1, ref2, ref3, s, shifted_variations, t, u;
    if ((ref = match.graph) === 'qwerty' || ref === 'dvorak') {
      s = this.KEYBOARD_STARTING_POSITIONS;
      d = this.KEYBOARD_AVERAGE_DEGREE;
    } else {
      s = this.KEYPAD_STARTING_POSITIONS;
      d = this.KEYPAD_AVERAGE_DEGREE;
    }
    guesses = 0;
    L = match.token.length;
    t = match.turns;
    for (i = o = 2, ref1 = L; 2 <= ref1 ? o <= ref1 : o >= ref1; i = 2 <= ref1 ? ++o : --o) {
      possible_turns = Math.min(t, i - 1);
      for (j = q = 1, ref2 = possible_turns; 1 <= ref2 ? q <= ref2 : q >= ref2; j = 1 <= ref2 ? ++q : --q) {
        guesses += this.nCk(i - 1, j - 1) * s * Math.pow(d, j);
      }
    }
    if (match.shifted_count) {
      S = match.shifted_count;
      U = match.token.length - match.shifted_count;
      if (S === 0 || U === 0) {
        guesses *= 2;
      } else {
        shifted_variations = 0;
        for (i = u = 1, ref3 = Math.min(S, U); 1 <= ref3 ? u <= ref3 : u >= ref3; i = 1 <= ref3 ? ++u : --u) {
          shifted_variations += this.nCk(S + U, i);
        }
        guesses *= shifted_variations;
      }
    }
    return guesses;
  },
  dictionary_guesses: function(match) {
    var reversed_variations;
    match.base_guesses = match.rank;
    match.uppercase_variations = this.uppercase_variations(match);
    match.l33t_variations = this.l33t_variations(match);
    reversed_variations = match.reversed && 2 || 1;
    return match.base_guesses * match.uppercase_variations * match.l33t_variations * reversed_variations;
  },
  START_UPPER: /^[A-Z][^A-Z]+$/,
  END_UPPER: /^[^A-Z]+[A-Z]$/,
  ALL_UPPER: /^[^a-z]+$/,
  ALL_LOWER: /^[^A-Z]+$/,
  uppercase_variations: function(match) {
    var L, U, chr, i, len, o, q, ref, ref1, regex, variations, word;
    word = match.token;
    if (word.match(this.ALL_LOWER) || word.toLowerCase() === word) {
      return 1;
    }
    ref = [this.START_UPPER, this.END_UPPER, this.ALL_UPPER];
    for (o = 0, len = ref.length; o < len; o++) {
      regex = ref[o];
      if (word.match(regex)) {
        return 2;
      }
    }
    U = ((function() {
      var len1, q, ref1, results;
      ref1 = word.split('');
      results = [];
      for (q = 0, len1 = ref1.length; q < len1; q++) {
        chr = ref1[q];
        if (chr.match(/[A-Z]/)) {
          results.push(chr);
        }
      }
      return results;
    })()).length;
    L = ((function() {
      var len1, q, ref1, results;
      ref1 = word.split('');
      results = [];
      for (q = 0, len1 = ref1.length; q < len1; q++) {
        chr = ref1[q];
        if (chr.match(/[a-z]/)) {
          results.push(chr);
        }
      }
      return results;
    })()).length;
    variations = 0;
    for (i = q = 1, ref1 = Math.min(U, L); 1 <= ref1 ? q <= ref1 : q >= ref1; i = 1 <= ref1 ? ++q : --q) {
      variations += this.nCk(U + L, i);
    }
    return variations;
  },
  l33t_variations: function(match) {
    var S, U, chr, chrs, i, o, p, possibilities, ref, ref1, subbed, unsubbed, variations;
    if (!match.l33t) {
      return 1;
    }
    variations = 1;
    ref = match.sub;
    for (subbed in ref) {
      unsubbed = ref[subbed];
      chrs = match.token.toLowerCase().split('');
      S = ((function() {
        var len, o, results;
        results = [];
        for (o = 0, len = chrs.length; o < len; o++) {
          chr = chrs[o];
          if (chr === subbed) {
            results.push(chr);
          }
        }
        return results;
      })()).length;
      U = ((function() {
        var len, o, results;
        results = [];
        for (o = 0, len = chrs.length; o < len; o++) {
          chr = chrs[o];
          if (chr === unsubbed) {
            results.push(chr);
          }
        }
        return results;
      })()).length;
      if (S === 0 || U === 0) {
        variations *= 2;
      } else {
        p = Math.min(U, S);
        possibilities = 0;
        for (i = o = 1, ref1 = p; 1 <= ref1 ? o <= ref1 : o >= ref1; i = 1 <= ref1 ? ++o : --o) {
          possibilities += this.nCk(U + S, i);
        }
        variations *= possibilities;
      }
    }
    return variations;
  }
};

module.exports = scoring;

//# sourceMappingURL=scoring.js.map


/***/ }),
/* 600 */,
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getEnumList */
/* unused harmony export getGatewayList */
/* unused harmony export addGateway */
/* unused harmony export editGateway */
/* unused harmony export getGatewayDetail */
/* unused harmony export delGateway */
/* harmony export (immutable) */ __webpack_exports__["c"] = gatewayStats;
/* unused harmony export gatewaySf */
/* unused harmony export gatewayFreq */
/* harmony export (immutable) */ __webpack_exports__["d"] = gatewayPing;
/* unused harmony export gatewayBand */
/* harmony export (immutable) */ __webpack_exports__["e"] = gatewayReset;
/* harmony export (immutable) */ __webpack_exports__["f"] = gatewayUpgradeSDK;
/* harmony export (immutable) */ __webpack_exports__["g"] = gatewayUpgradeSDKCom;
/* harmony export (immutable) */ __webpack_exports__["b"] = getGatewayLogRecord;
/* harmony export (immutable) */ __webpack_exports__["a"] = getGatewayLog;
/* unused harmony export getGatewaysCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(240);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



function getEnumList(property, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/enum/' + property, {}, {}, callback);
}

function getGatewayList(args, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/gateways', args, {}, callback);
}

function addGateway(mac, name, city, area, address, lat, lng, platform, lorchips, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('post', '/lora/gateways', {}, {
    mac: mac,
    name: name,
    city: city,
    area: area,
    address: address,
    lat: lat,
    lng: lng,
    platform: platform
  }, callback);
}

function editGateway(id, dict, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('put', '/lora/gateways/' + id, {}, dict, callback);
}

function getGatewayDetail(id, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/gateways/' + id, {}, {}, callback);
}

function delGateway(id, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('del', '/lora/gateways/' + id, {}, {}, callback);
}

function gatewayStats(id, from, to, cb) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', "/lora/gateways/" + id + "/stats?from=" + from + "&to=" + to, {}, {}, cb);
}

function gatewaySf(id, MILLSN, MILLSL, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/gateways/' + id + '/stats/sf?from=' + MILLSN + '&to=' + MILLSL, {}, {}, callback);
}

function gatewayFreq(id, MILLSN, MILLSL, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/gateways/' + id + '/stats/freq?from=' + MILLSN + '&to=' + MILLSL, {}, {}, callback);
}

function gatewayPing(id, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('post', '/lora/gateways/' + id + '/ping', {}, {}, callback);
}

function gatewayBand(id, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('post', '/lora/gateways/' + id + '/readconf', {}, {}, callback);
}

function gatewayReset(id, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('post', '/lora/gateways/' + id + '/reset', {}, {}, callback);
}

function gatewayUpgradeSDK(id, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('post', "/lora/gateways/" + id + "/chkupgrade", {}, {}, callback);
}

function gatewayUpgradeSDKCom(id, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('post', "/lora/gateways/" + id + "/upgrade", {}, {}, callback);
}

function getGatewayLogRecord(args, GATEWAYMACADDRESS, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/gateways/' + GATEWAYMACADDRESS + '/logs', args, {}, callback);
}
//'get','/devlog/history?src=lora&gateway='+GATEWAYMACADDRESS,args, {}, callback
//'get','/lora/gateways/'+GATEWAYMACADDRESS+'/logs',args, {}, callback
function getGatewayLog(args, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/gateways/logs', args, {}, callback);
}
//GET /v1/lora/gateways/logs?id=GATEWAYID
//return APIRequest('get','/devlog/history?src=lora&type=gateway',args, {}, callback);
function getGatewaysCount(callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/gateways/count', {}, {}, callback);
}

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNodeStatus;
/* harmony export (immutable) */ __webpack_exports__["b"] = getGatewayStatus;
/* harmony export (immutable) */ __webpack_exports__["c"] = getGatewayNodeStatus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(240);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



// pre,
function getNodeStatus(res) {
  var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "desc";

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/network/node', { sort: res, order: order }, {}, null);
}

function getGatewayStatus(res) {
  var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "desc";

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/network/gateway', { sort: res, order: order }, {}, null);
}

function getGatewayNodeStatus(gateway, res) {
  var order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "desc";

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/network/gateway/' + gateway, { sort: res, order: order }, {}, null);
}

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (immutable) */ __webpack_exports__["a"] = getTokenList;
/* harmony export (immutable) */ __webpack_exports__["d"] = editToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = addtoken;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__callAPI__ = __webpack_require__(27);

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



function getTokenList(args) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__callAPI__["a" /* default */])({ endpoint: '/tokens', method: 'get', query: args });
}

function editToken(id, name, aux) {
  var aux1 = void 0;
  if (!_.isNil(aux)) {
    aux1 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(aux);
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__callAPI__["a" /* default */])({ endpoint: "/tokens/" + id, method: 'put', query: {}, body: { name: name, aux: aux1 } });
}

function addtoken(name) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__callAPI__["a" /* default */])({ endpoint: '/tokens', method: 'post', query: {}, body: { name: name } });
}

function deleteToken(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__callAPI__["a" /* default */])({ endpoint: "/tokens/" + id, method: 'delete', query: {}, body: {} });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MonthCalendar__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_scss__ = __webpack_require__(2125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);










var FORMAT = {
  zh: 'YYYY-MM-DD HH:mm',
  en: 'DD/MM/YYYY HH:mm'
};
var kHours = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];
var kMinite = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'];

var defaultProps = {
  date: new Date(),
  view: 'date',
  closeOnSelect: true,
  disabled: function disabled(d) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["isAfter"])(d, new Date());
  },
  anchor: null
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  date: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.instanceOf(Date),
  view: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.oneOf(['year', 'month', 'date']),
  onSelect: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  locale: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.oneOfType([__WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.arrayOf(__WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.instanceOf(Date)), __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func]),
  closeOnSelect: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool,
  anchor: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.instanceOf(Date)
};

var DateTimePicker = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DateTimePicker, _React$Component);

  function DateTimePicker(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DateTimePicker);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      date: props.date,
      view: props.view,
      disabled: props.disabled,
      anchor: props.anchor,
      showDate: true,
      hour: !_.isNil(props.date) ? _.toString(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["format"])(props.date, 'HH')) : '00',
      minite: !_.isNil(props.date) ? _.toString(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["format"])(props.date, 'mm')) : '00'
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'common.picker');
    _this.id = "datepicker_" + Number(Math.random() * 10000).toFixed(0);
    _this.handleInputFocus = _this.handleInputFocus.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleInputBlur = _this.handleInputBlur.bind(_this);
    _this.handleSelect = _this.handleSelect.bind(_this);
    _this.clickToBlur = _this.clickToBlur.bind(_this);
    _this.inputChanged = false;
    return _this;
  }

  DateTimePicker.prototype.componentDidMount = function componentDidMount() {
    $('body').click(this.clickToBlur);
  };

  DateTimePicker.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var date = nextProps.date,
        view = nextProps.view,
        disabled = nextProps.disabled,
        anchor = nextProps.anchor;

    if (date !== this.props.date) {
      var _state = this.state,
          hour = _state.hour,
          minite = _state.minite;

      hour = _.toString(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["format"])(date, 'HH'));
      minite = _.toString(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["format"])(date, 'mm'));
      this.setState({ date: date, hour: hour, minite: minite });
    }
    if (view !== this.props.view) {
      this.setState({ view: view });
    }
    if (disabled !== this.props.disabled) {
      this.setState({ disabled: disabled });
    }
    if (anchor !== this.props.anchor) {
      this.setState({ anchor: anchor });
    }
  };

  DateTimePicker.prototype.componentWillUnmount = function componentWillUnmount() {
    $('body').off('click', this.clickToBlur);
  };

  DateTimePicker.prototype.clickToBlur = function clickToBlur(e) {
    var _this2 = this;

    var blurred = true;
    $(e.target).parents().each(function (idx, elem) {
      if (elem.id === _this2.id) {
        blurred = false;
      }
    });
    if (blurred) {
      this.setState({
        showOverlay: false,
        showDate: true
      });
    }
  };

  DateTimePicker.prototype.handleReturnDate = function handleReturnDate() {
    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.date;
    var _state2 = this.state,
        hour = _state2.hour,
        minite = _state2.minite;

    var newDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["format"])(date, 'YYYY-MM-DD');
    newDate = newDate + " " + hour + ":" + minite;
    newDate = new Date(newDate);
    return newDate;
  };

  DateTimePicker.prototype.handleInputFocus = function handleInputFocus() {
    this.setState({
      showOverlay: true
    });
  };

  DateTimePicker.prototype.handleInputChange = function handleInputChange(e) {
    var value = e.target.value.trim();
    this.setState({ value: value });
    var date = new Date(value);
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["isValid"])(date)) {
      this.inputChanged = true;
      this.setState({ date: date });
    }
  };

  DateTimePicker.prototype.handleInputBlur = function handleInputBlur() {
    if (this.inputChanged) {
      var onSelect = this.props.onSelect;

      var date = this.handleReturnDate();
      onSelect(date);
      this.inputChanged = false;
    }
  };

  DateTimePicker.prototype.handleSelect = function handleSelect(date) {
    var closeOnSelect = this.props.closeOnSelect;

    var newDate = this.handleReturnDate(date);
    this.setState({ value: '', date: newDate });
    // const newDate = this.handleReturnDate(date);
    // onSelect(newDate);
    if (closeOnSelect) {
      this.setState({
        showOverlay: false,
        showDate: true
      });
    }
  };

  DateTimePicker.prototype.handleComfire = function handleComfire() {
    var onSelect = this.props.onSelect;

    var date = this.handleReturnDate();
    onSelect(date);
    this.setState({
      showOverlay: false,
      showDate: true
    });
  };

  DateTimePicker.prototype.renderView = function renderView() {
    var _state3 = this.state,
        _state3$view = _state3.view,
        view = _state3$view === undefined ? 'date' : _state3$view,
        date = _state3.date,
        disabled = _state3.disabled,
        anchor = _state3.anchor;


    if (view === 'date') {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__MonthCalendar__["a" /* default */], {
        year: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["getYear"])(date),
        month: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["getMonth"])(date),
        selected: date,
        onSelect: this.handleSelect,
        disabled: disabled,
        anchor: anchor
      });
    }
    return null;
  };

  DateTimePicker.prototype.renderTime = function renderTime() {
    var _this3 = this;

    var _state4 = this.state,
        hour = _state4.hour,
        minite = _state4.minite;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.timeContent },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.timeList },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "ul",
          null,
          _.map(kHours, function (h) {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "li",
              {
                className: hour === h ? __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.selected : '',
                onClick: function onClick() {
                  return _this3.setState({ hour: h });
                }
              },
              h
            );
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "ul",
          null,
          _.map(kMinite, function (m) {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "li",
              {
                className: minite === m ? __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.selected : '',
                onClick: function onClick() {
                  return _this3.setState({ minite: m });
                }
              },
              m
            );
          })
        )
      )
    );
  };

  DateTimePicker.prototype.renderOverlay = function renderOverlay() {
    var _this4 = this;

    var _state5 = this.state,
        showDate = _state5.showDate,
        showOverlay = _state5.showOverlay;

    if (showOverlay) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.overlay },
        showDate && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.container },
          this.renderView(),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.selectTime },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "a",
              { onClick: function onClick() {
                  return _this4.setState({ showDate: false });
                } },
              this.intlMsg.msg('time')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
              {
                bsStyle: "aisz-primary",
                onClick: function onClick() {
                  return _this4.handleComfire();
                }
              },
              this.intlMsg.msg('confirm')
            )
          )
        ),
        !showDate && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.container },
          this.renderTime(),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.selectTime },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "a",
              { onClick: function onClick() {
                  return _this4.setState({ showDate: true });
                } },
              this.intlMsg.msg('date')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
              {
                bsStyle: "aisz-primary",
                onClick: function onClick() {
                  return _this4.handleComfire();
                }
              },
              this.intlMsg.msg('confirm')
            )
          )
        )
      );
    }
    // return null;
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", { style: { minHeight: '300px', zIndex: 0, position: 'absolute' } });
  };

  DateTimePicker.prototype.render = function render() {
    var locale = this.props.locale;
    var _state6 = this.state,
        date = _state6.date,
        _state6$value = _state6.value,
        value = _state6$value === undefined ? '' : _state6$value;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { id: this.id, className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.datepicker },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["FormControl"], {
        bsClass: "aisz-form-control-f",
        type: "text",
        placeholder: FORMAT[locale],
        value: value || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["format"])(date, FORMAT[locale]),
        onFocus: this.handleInputFocus,
        onBlur: this.handleInputBlur,
        onChange: this.handleInputChange
      }),
      this.renderOverlay()
    );
  };

  return DateTimePicker;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DateTimePicker.propTypes = propTypes;
DateTimePicker.defaultProps = defaultProps;

var mapStateToProps = function mapStateToProps(state) {
  return {
    locale: state.intl.locale
  };
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, null)(DateTimePicker)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_zip__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_zip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_zip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_connected_svg__ = __webpack_require__(2762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_connected_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_connected_svg__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);











var defaultProps = {
  onZoom: function onZoom() {},
  onDrag: function onDrag() {}
};

var propTypes = {
  devices: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.array.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  onZoom: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func,
  onDrag: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func
};

var DeviceMap = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DeviceMap, _React$Component);

  DeviceMap.getCenterAndZoom = function getCenterAndZoom(points) {
    var span = 0.0001;
    var center = points[0];
    points.forEach(function (x) {
      if (center.lat !== x.lat || center.lng !== x.lng) {
        center = new BMap.Point((center.lng + x.lng) / 2, (center.lat + x.lat) / 2);
      }
      points.forEach(function (y) {
        span = Math.max(span, Math.max(Math.abs(x.lat - y.lat), Math.abs(x.lng - y.lng)));
      });
    });
    var zoom = 2;
    if (span < 0.001) {
      zoom = 16;
    } else if (span < 0.1) {
      zoom = 14;
    } else if (span < 0.5) {
      zoom = 11;
    } else if (span < 1) {
      zoom = 8;
    } else if (span < 10) {
      zoom = 6;
    } else if (span < 20) {
      zoom = 5;
    }
    return [center, zoom];
  };

  DeviceMap.transform = function transform() {
    var devices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return devices.filter(function (gw) {
      var _gw$lat = gw.lat,
          lat = _gw$lat === undefined ? '' : _gw$lat,
          _gw$lng = gw.lng,
          lng = _gw$lng === undefined ? '' : _gw$lng;

      return lat !== '' && lng !== '';
    }).map(function (gw) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, gw, {
        point: new BMap.Point(gw.lng, gw.lat)
      });
    });
  };

  function DeviceMap(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DeviceMap);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.markers = [];
    _this.listeners = [];
    _this.devices = props.devices;
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.map');
    return _this;
  }

  DeviceMap.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var tries = 0;
    var init = function init() {
      try {
        _this2.initMap();
        _this2.updateData();
      } catch (e) {
        if (tries < 10) {
          tries += 1;
          setTimeout(init, 1000);
        }
      }
    };
    init();
  };

  DeviceMap.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var devices = nextProps.devices;

    if (devices !== this.props.devices) {
      this.devices = devices;
      if (this.map) {
        this.map.clearOverlays();
        this.updateData();
      }
    }
  };

  DeviceMap.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_8_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_7_lodash_zip___default()(this.markers, this.listeners), function (_ref) {
      var marker = _ref[0],
          listener = _ref[1];

      marker.removeEventListener('click', listener);
    });
    $('#devicemap').empty();
  };

  DeviceMap.prototype.initMap = function initMap() {
    var _this3 = this;

    this.map = new BMap.Map('devicemap');
    this.map.setMapStyle({ features: [] });
    this.map.setMaxZoom(16);
    this.map.setMinZoom(2);
    this.map.enableScrollWheelZoom();
    this.map.removeControl(this.navControl);
    this.map.removeControl(this.scaleControl);
    // eslint-disable-next-line
    this.navControl = new BMap.NavigationControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });
    // eslint-disable-next-line
    this.scaleControl = new BMap.ScaleControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });

    this.map.addControl(this.navControl);
    this.map.addControl(this.scaleControl);
    this.map.addEventListener('zoomend', function () {
      return _this3.props.onZoom(_this3.map);
    });
    this.map.addEventListener('dragend', function () {
      return _this3.props.onDrag(_this3.map);
    });
  };

  DeviceMap.prototype.updateData = function updateData() {
    var _this4 = this;

    this.devices = DeviceMap.transform(this.devices);
    this.devices.forEach(function (obj) {
      _this4.addMarker(obj);
    });

    var points = this.devices.map(function (x) {
      return x.point;
    });
    if (points.length === 1) {
      this.map.centerAndZoom(points[0], 16);
    } else if (points.length > 0) {
      // decide max span with at most 100 points
      var _DeviceMap$getCenterA = DeviceMap.getCenterAndZoom(points.slice(0, 100)),
          center = _DeviceMap$getCenterA[0],
          zoom = _DeviceMap$getCenterA[1];

      this.map.centerAndZoom(center, zoom);
    } else {
      this.map.centerAndZoom('深圳', 1);
    }
  };

  DeviceMap.prototype.info = function info(obj) {
    return "\n<div>\n  <h4 style=\"font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, PingFang SC, Source Han Sans CN, Hiragino Sans GB, Microsoft YaHei, WenQuanYi Micro Hei, sans-serif; font-weight: 300; font-size: 14px;\">\n    " + this.intlMsg.msg('id') + "&nbsp;<a id=\"infowin\">" + obj.id + "</a>\n  </h4>\n  <dl class=\"dl-horizontal\" style=\"font-size: 12px; background-color: #eeeeee; padding: 15px 5px; border-radius: 2px; border: 1px solid #efefef;\">\n    <div style=\"padding: 5px 0;\">\n      <span style=\"width: 80px; display: inline-block; text-align: right; padding-right: 10px; font-weight: 700;\">\n        " + this.intlMsg.msg('deveui') + "\n      </span>\n      <span>" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lorautils_IdUtils__["a" /* normalizeDevEUI */])(obj.deveui) + "</span>\n    </div>\n    <div style=\"padding: 5px 0;\">\n      <span style=\"width: 80px; display: inline-block; text-align: right; padding-right: 10px; font-weight: 700;\">\n        " + this.intlMsg.msg('devaddr') + "\n      </span>\n      <span>" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lorautils_IdUtils__["e" /* normalizeDevAddr */])(obj.devaddr) + "</span>\n    </div>\n    <div style=\"padding: 5px 0;\">\n      <span style=\"width: 80px; display: inline-block; text-align: right; padding-right: 10px; font-weight: 700;\">\n        " + this.intlMsg.msg('name') + "\n      </span>\n      <span>" + obj.name + "</span>\n    </div>\n    <div style=\"padding: 5px 0;\">\n      <span style=\"width: 80px; display: inline-block; text-align: right; padding-right: 10px; font-weight: 700;\">\n        " + this.intlMsg.msg('address') + "\n      </span>\n      <span>" + obj.area + " " + obj.address + "</span>\n    </div>\n  </dl>\n</div>\n";
  };

  DeviceMap.prototype.addMarker = function addMarker(item) {
    var _this5 = this;

    var opts = {
      width: 400,
      height: 180,
      title: '',
      enableMessage: true
    };

    var pushState = this.props.pushState;

    var that = this;
    var openInfo = function openInfo() {
      var info = that.info(item);
      var infoWin = new BMap.InfoWindow(info, opts);
      _this5.map.openInfoWindow(infoWin, item.point);
      setTimeout(function () {
        $('#infowin').click(function () {
          pushState("/application/" + item.appeui + "/devices/" + item.id);
        });
      }, 300);
    };

    var icon = new BMap.Icon(__WEBPACK_IMPORTED_MODULE_12__images_connected_svg___default.a, new BMap.Size(48, 48));
    var marker = new BMap.Marker(item.point, { icon: icon });
    marker.addEventListener('click', openInfo);
    this.map.addOverlay(marker);
    this.markers.push(marker);
    this.listeners.push(openInfo);
  };

  DeviceMap.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { id: "devicemap", style: { height: '100%', width: '100%' } });
  };

  return DeviceMap;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

DeviceMap.defaultProps = defaultProps;
DeviceMap.propTypes = propTypes;

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"])(DeviceMap)));

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss__ = __webpack_require__(2128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var defaultProps = {
  show: false,
  onHide: function onHide() {},
  azStyle: 'default'
};

var propTypes = {
  message: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  show: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool,
  onHide: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func,
  azStyle: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.oneOf(['success', 'primary', 'danger', 'info', 'warning', 'default'])
};

var Flash = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Flash, _React$Component);

  function Flash(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Flash);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      message: props.message,
      show: props.show
    };
    return _this;
  }

  Flash.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var message = nextProps.message,
        show = nextProps.show;

    if (message !== this.props.message) {
      this.setState({ message: message });
    }
    if (show !== this.props.show) {
      this.setState({ show: show });
      if (show) {
        var onHide = nextProps.onHide;

        var that = this;
        setTimeout(function () {
          that.setState({ show: false });
          onHide();
        }, 1500);
      }
    }
  };

  Flash.prototype.render = function render() {
    var azStyle = this.props.azStyle;
    var _state = this.state,
        message = _state.message,
        show = _state.show;

    var flash = void 0;
    if (show) {
      flash = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { key: "flash", className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.flash + " " + __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a[azStyle] },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.content },
          message
        )
      );
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default.a,
      {
        transitionName: {
          enter: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.enter,
          enterActive: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.enterActive,
          leave: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.leave,
          leaveActive: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.leaveActive,
          appear: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.appear,
          appearActive: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.appearActive
        },
        transitionAppear: true,
        transitionAppearTimeout: 100,
        transitionEnterTimeout: 100,
        transitionLeaveTimeout: 300
      },
      flash
    );
  };

  return Flash;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Flash.defaultProps = defaultProps;
Flash.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Flash);

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_heatmap__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_heatmap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_heatmap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_tooltip__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_title__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_legend__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_grid__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_echarts_lib_component_dataZoom__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_echarts_lib_component_dataZoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_echarts_lib_component_dataZoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_echarts_lib_component_visualMap__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_echarts_lib_component_visualMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_echarts_lib_component_visualMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_echarts_lib_echarts__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_scss__ = __webpack_require__(2131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);














var defaultProps = {
  legend: [],
  grid: null,
  xAxis: null,
  yAxis: null,
  dataZoom: null,
  tooltip: {},
  resize: null,
  collapsed: false,
  visualMap: null,
  colorShift: 0,
  height: $(window).height() / 2,
  width: '100%',
  clickFn: function clickFn() {}
};

var propTypes = {
  series: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array.isRequired,
  legend: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  grid: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  xAxis: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  yAxis: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  visualMap: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  tooltip: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  colorShift: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  clickFn: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  height: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number]),
  width: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number])
};

var HeatmapChart = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(HeatmapChart, _React$Component);

  function HeatmapChart(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, HeatmapChart);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      series: props.series,
      legend: props.legend,
      width: props.width,
      height: props.height
    };
    _this.tryResizeChart = _this.tryResizeChart.bind(_this);
    return _this;
  }

  HeatmapChart.prototype.componentDidMount = function componentDidMount() {
    this.echart = this.initChart();
    this.echart.resize();
    $(window).resize(this.tryResizeChart);
  };

  HeatmapChart.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var series = nextProps.series,
        legend = nextProps.legend,
        xAxis = nextProps.xAxis,
        yAxis = nextProps.yAxis,
        tooltip = nextProps.tooltip,
        width = nextProps.width,
        height = nextProps.height;

    if (width !== this.props.width) {
      this.setState({ width: width }, this.tryResizeChart);
    }
    if (height !== this.props.height) {
      this.setState({ height: height }, this.tryResizeChart);
    }
    if (!_.isEqual(series, this.props.series)) {
      this.updateChart(series, legend, xAxis, yAxis, tooltip);
      this.setState({
        series: nextProps.series,
        legend: nextProps.legend
      });
    }
    this.tryResizeChart();
  };

  HeatmapChart.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_13_echarts_lib_echarts___default.a.dispose($(this.chartRef));
    $(window).off('resize', this.tryResizeChart);
  };

  HeatmapChart.prototype.colors = function colors() {
    var colorShift = this.props.colorShift;

    if (colorShift > 0) {
      return _.concat(_.drop(HeatmapChart.colors, colorShift), _.take(HeatmapChart.colors, colorShift));
    }
    return HeatmapChart.colors;
  };

  HeatmapChart.prototype.tryResizeChart = function tryResizeChart() {
    var width = $(this.chartRef).width();
    var height = $(this.chartRef).height();
    if (height !== this.height || width !== this.width) {
      if (this.echart) {
        this.echart.resize();
      }
    }
    this.width = width;
    this.height = height;
  };

  HeatmapChart.prototype.updateChart = function updateChart(nextSeries, nextLegend, xAxis, yAxis, tooltip) {
    var thisSeries = this.state.series;

    var series = nextSeries.map(function (s) {
      return _.extend({
        type: 'heatmap'
      }, s);
    });
    var legend = nextLegend || [];
    var option = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.echart.getOption(), {
      xAxis: xAxis,
      yAxis: yAxis,
      series: series,
      legend: legend,
      tooltip: tooltip
    });
    if (!_.isEqual(_.map(thisSeries, 'name'), _.map(nextSeries, 'name'))) {
      // reset option
      this.echart.clear();
    }
    this.echart.setOption(option);
    this.echart.resize();
  };

  HeatmapChart.prototype.initChart = function initChart() {
    var echart = __WEBPACK_IMPORTED_MODULE_13_echarts_lib_echarts___default.a.init(this.chartRef);
    var series = this.state.series.map(function (s) {
      return {
        name: s.name,
        data: s.data,
        type: 'heatmap'
      };
    });

    var _props = this.props,
        legend = _props.legend,
        grid = _props.grid,
        visualMap = _props.visualMap,
        tooltip = _props.tooltip,
        xAxis = _props.xAxis,
        yAxis = _props.yAxis;

    var option = {
      xAxis: xAxis,
      yAxis: yAxis,
      legend: legend,
      series: series,
      visualMap: visualMap,
      grid: grid,
      color: this.colors(),
      textStyle: {
        fontSize: 12,
        fontWeight: 300
      },
      tooltip: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, tooltip),
      animationEasing: 'cubicIn',
      showLoading: true
    };
    echart.setOption(option);
    echart.on('click', this.props.clickFn);
    return echart;
  };

  HeatmapChart.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        height = _state.height,
        width = _state.width;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_15__styles_scss___default.a.chart,
      style: { width: width, height: height },
      ref: function ref(_ref) {
        _this2.chartRef = _ref;
      }
    });
  };

  return HeatmapChart;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

HeatmapChart.colors = ['#22A7F0', '#00B16A', '#F7CA18', '#F9690E', '#EF4836', '#DB0A5B', '#663399', '#BF55EC', '#446CB3', '#336E7B', '#1BBC9B'];
HeatmapChart.propTypes = propTypes;
HeatmapChart.defaultProps = defaultProps;

var mapStateToProps = function mapStateToProps(state) {
  return {
    collapsed: state.sidebar.collapsed
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_react_redux__["connect"])(mapStateToProps, null)(HeatmapChart));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_map_marker_svg__ = __webpack_require__(2765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_map_marker_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_map_marker_svg__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);






var defaultProps = {
  point: {
    lng: 113.950497,
    lat: 22.53452
  },
  zoom: 11,
  onPick: function onPick() {},
  search: 0
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  point: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object,
  zoom: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.number,
  onPick: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func,
  search: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any
};

var MapPicker = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(MapPicker, _React$Component);

  function MapPicker(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MapPicker);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      point: props.point,
      zoom: props.zoom
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_5_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'mappicker');
    return _this;
  }

  MapPicker.prototype.componentDidMount = function componentDidMount() {
    this.initMap();
  };

  MapPicker.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var point = nextProps.point,
        zoom = nextProps.zoom,
        search = nextProps.search;

    if (point !== this.props.point) {
      this.setState({ point: point });
      this.map.centerAndZoom(new BMap.Point(point.lng, point.lat), zoom);
    }
    if (zoom !== this.props.zoom) {
      this.setState({ zoom: zoom });
      this.map.centerAndZoom(new BMap.Point(point.lng, point.lat), zoom);
    }
    if (search !== this.props.search) {
      this.handleSearch(search);
    }
  };

  MapPicker.prototype.initMap = function initMap() {
    var _this2 = this;

    var _state = this.state,
        point = _state.point,
        zoom = _state.zoom;

    this.map = new BMap.Map('mappicker');
    this.map.setMapStyle({
      features: [],
      style: 'light'
    });
    this.map.setMaxZoom(19);
    this.map.setMinZoom(2);
    this.map.enableScrollWheelZoom();
    this.map.removeControl(this.navControl);
    this.map.removeControl(this.scaleControl);
    // eslint-disable-next-line
    this.navControl = new BMap.NavigationControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });
    // eslint-disable-next-line
    this.scaleControl = new BMap.ScaleControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });

    this.map.addControl(this.navControl);
    this.map.addControl(this.scaleControl);

    this.map.centerAndZoom(new BMap.Point(point.lng, point.lat), zoom);
    this.map.setDefaultCursor('crosshair');

    var icon = new BMap.Icon(__WEBPACK_IMPORTED_MODULE_6__images_map_marker_svg___default.a, new BMap.Size(32, 32));

    this.map.addEventListener('click', function (e) {
      _this2.map.clearOverlays();
      _this2.marker = new BMap.Marker(e.point, { icon: icon });
      _this2.map.addOverlay(_this2.marker);
      _this2.props.onPick(e.point);
    });
  };

  MapPicker.prototype.handleSearch = function handleSearch(search) {
    var local = new BMap.LocalSearch(this.map, {
      renderOptions: { map: this.map }
    });
    local.search(search);
  };

  MapPicker.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", { id: "mappicker", style: { height: '100%', width: '100%' } });
  };

  return MapPicker;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

MapPicker.defaultProps = defaultProps;
MapPicker.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(MapPicker));

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_sub_days__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_sub_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_sub_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_add_days__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_add_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_is_same_day__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_is_same_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_is_same_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_is_before__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_is_before___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_is_before__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_is_after__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_is_after___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns_is_after__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_is_within_range__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_is_within_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_date_fns_is_within_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_scss__ = __webpack_require__(2136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);














var kWeekdayShortNames = {
  zh: ['日', '一', '二', '三', '四', '五', '六'],
  en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
};

var kMonthNames = {
  zh: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};

var defaultProps = {
  selected: null,
  anchor: null,
  onSelect: function onSelect() {},
  disabled: null,
  onPrevMonth: function onPrevMonth() {},
  onNextMonth: function onNextMonth() {}
};

var propTypes = {
  year: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.number.isRequired,
  month: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.number.isRequired,
  selected: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.instanceOf(Date),
  anchor: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.instanceOf(Date),
  onSelect: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func,
  disabled: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.oneOfType([__WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.arrayOf(__WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.instanceOf(Date)), __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func]),
  locale: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  onPrevMonth: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func,
  onNextMonth: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func
};

var MonthCalendar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(MonthCalendar, _React$Component);

  function MonthCalendar(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MonthCalendar);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      year: props.year,
      month: props.month,
      selected: props.selected,
      disabled: props.disabled,
      anchor: props.anchor
    };
    _this.handleNextMonth = _this.handleNextMonth.bind(_this);
    _this.handlePrevMonth = _this.handlePrevMonth.bind(_this);
    return _this;
  }

  MonthCalendar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var year = nextProps.year,
        month = nextProps.month,
        selected = nextProps.selected,
        anchor = nextProps.anchor,
        disabled = nextProps.disabled;

    if (year !== this.props.year) {
      this.setState({ year: year });
    }
    if (month !== this.props.month) {
      this.setState({ month: month });
    }
    if (selected !== this.props.selected) {
      this.setState({ selected: selected });
    }
    if (disabled !== this.props.disabled) {
      this.setState({ disabled: disabled });
    }
    if (anchor !== this.props.anchor) {
      this.setState({ anchor: anchor });
    }
  };

  MonthCalendar.prototype.weekDaysOfMonth = function weekDaysOfMonth(index) {
    var _state = this.state,
        year = _state.year,
        month = _state.month;

    var som = new Date(year, month, 1);
    var somOffset = som.getDay();
    if (index === 0) {
      return [].concat(_.reverse(_.range(1, somOffset + 1).map(function (i) {
        return __WEBPACK_IMPORTED_MODULE_7_date_fns_sub_days___default()(som, i);
      })), _.range(7 - somOffset).map(function (i) {
        return __WEBPACK_IMPORTED_MODULE_8_date_fns_add_days___default()(som, i);
      }));
    }
    return _.range(7 - somOffset + (index - 1) * 7, 7 - somOffset + index * 7).map(function (i) {
      return __WEBPACK_IMPORTED_MODULE_8_date_fns_add_days___default()(som, i);
    });
  };

  MonthCalendar.prototype.handlePrevMonth = function handlePrevMonth() {
    var _state2 = this.state,
        month = _state2.month,
        year = _state2.year;

    if (month === 0) {
      month = 11;
      year -= 1;
    } else {
      month -= 1;
    }
    this.setState({ year: year, month: month });

    var onPrevMonth = this.props.onPrevMonth;

    onPrevMonth(year, month);
  };

  MonthCalendar.prototype.handleNextMonth = function handleNextMonth() {
    var _state3 = this.state,
        month = _state3.month,
        year = _state3.year;

    if (month === 11) {
      month = 0;
      year += 1;
    } else {
      month += 1;
    }
    this.setState({ year: year, month: month });

    var onNextMonth = this.props.onNextMonth;

    onNextMonth(year, month);
  };

  MonthCalendar.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        locale = _props.locale,
        onSelect = _props.onSelect;
    var _state4 = this.state,
        month = _state4.month,
        year = _state4.year,
        selected = _state4.selected,
        disabled = _state4.disabled,
        anchor = _state4.anchor,
        hover = _state4.hover;

    var weekdayNames = kWeekdayShortNames[locale];
    var monthNames = kMonthNames[locale];

    var dateBox = function dateBox(date) {
      var className = __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.box;
      var onClick = function onClick() {
        return onSelect(date);
      };

      if (date.getMonth() === month) {
        className = className + " " + __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.inMonth;
      }
      if (!_.isNil(selected) && __WEBPACK_IMPORTED_MODULE_9_date_fns_is_same_day___default()(date, selected)) {
        className = className + " " + __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.selected;
      }
      if (!_.isNil(disabled)) {
        if (_.isArray(disabled) && disabled.findIndex(function (d) {
          return __WEBPACK_IMPORTED_MODULE_9_date_fns_is_same_day___default()(d, date);
        })) {
          className = className + " " + __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.disabled;
          onClick = function onClick() {};
        } else if (disabled(date)) {
          className = className + " " + __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.disabled;
          onClick = function onClick() {};
        }
      }
      if (!_.isNil(hover) && !_.isNil(anchor)) {
        var start = hover,
            end = anchor;

        if (__WEBPACK_IMPORTED_MODULE_11_date_fns_is_after___default()(start, end)) {
          var _ref = [end, start];
          start = _ref[0];
          end = _ref[1];
        }
        if (__WEBPACK_IMPORTED_MODULE_12_date_fns_is_within_range___default()(date, start, end)) {
          className = className + " " + __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.ranged;
          if (__WEBPACK_IMPORTED_MODULE_10_date_fns_is_before___default()(date, anchor)) {
            className = className + " " + __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.rangedLeft;
          } else if (__WEBPACK_IMPORTED_MODULE_11_date_fns_is_after___default()(date, anchor)) {
            className = className + " " + __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.rangedRight;
          }
        }
        if (__WEBPACK_IMPORTED_MODULE_9_date_fns_is_same_day___default()(date, anchor)) {
          className = className + " " + __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.anchor;
        }
      }

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
        {
          key: __WEBPACK_IMPORTED_MODULE_13_date_fns_format___default()(date, 'YYYYMMDD'),
          className: className,
          onClick: onClick,
          onMouseOver: function onMouseOver() {
            if (!_.isNil(anchor)) {
              _this2.setState({ hover: date });
            }
          }
        },
        date.getDate()
      );
    };

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.month },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.navs },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
          { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.navLeft, onClick: this.handlePrevMonth },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-chevron-circle-left" })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
          { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.navCurr },
          year,
          ' - ',
          monthNames[month]
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
          { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.navRight, onClick: this.handleNextMonth },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-chevron-circle-right" })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.header },
        weekdayNames.map(function (w) {
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "span",
            { key: w, className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.box },
            w
          );
        })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.dates },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.week },
          this.weekDaysOfMonth(0).map(function (d) {
            return dateBox(d);
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.week },
          this.weekDaysOfMonth(1).map(function (d) {
            return dateBox(d);
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.week },
          this.weekDaysOfMonth(2).map(function (d) {
            return dateBox(d);
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.week },
          this.weekDaysOfMonth(3).map(function (d) {
            return dateBox(d);
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.week },
          this.weekDaysOfMonth(4).map(function (d) {
            return dateBox(d);
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.week },
          this.weekDaysOfMonth(5).map(function (d) {
            return dateBox(d);
          })
        )
      )
    );
  };

  return MonthCalendar;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

MonthCalendar.defaultProps = defaultProps;
MonthCalendar.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    locale: state.intl.locale
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(MonthCalendar)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_line__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_scatter__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_scatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_scatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_tooltip__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_title__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_legend__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_grid__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_echarts_lib_component_dataZoom__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_echarts_lib_component_dataZoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_echarts_lib_component_dataZoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_echarts_lib_component_visualMap__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_echarts_lib_component_visualMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_echarts_lib_component_visualMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_echarts_lib_echarts__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_scss__ = __webpack_require__(2145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);














var defaultProps = {
  legend: [],
  grid: null,
  xAxis: null,
  yAxis: null,
  dataZoom: null,
  tooltip: {},
  resize: null,
  collapsed: false,
  visualMap: null,
  colorShift: 0,
  height: $(window).height() / 2
};
var propTypes = {
  series: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.array.isRequired,
  legend: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any,
  grid: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any,
  xAxis: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  yAxis: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  visualMap: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  tooltip: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object,
  dataZoom: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any,
  colorShift: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.number,
  height: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.number
};

var ScatterChart = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ScatterChart, _React$Component);

  function ScatterChart(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScatterChart);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      series: props.series,
      legend: props.legend
    };
    _this.tryResizeChart = _this.tryResizeChart.bind(_this);
    return _this;
  }

  ScatterChart.prototype.componentDidMount = function componentDidMount() {
    this.echart = this.initChart();
    this.echart.resize();
    $(window).resize(this.tryResizeChart);
  };

  ScatterChart.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var series = nextProps.series,
        legend = nextProps.legend;

    if (series !== this.props.series) {
      this.updateChart(series, legend);
      this.setState({
        series: nextProps.series,
        legend: nextProps.legend
      });
    }
    this.tryResizeChart();
  };

  ScatterChart.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_13_echarts_lib_echarts___default.a.dispose($(this.chartRef));
    $(window).off('resize', this.tryResizeChart);
  };

  ScatterChart.prototype.colors = function colors() {
    var colorShift = this.props.colorShift;

    if (colorShift > 0) {
      return _.concat(_.drop(ScatterChart.colors, colorShift), _.take(ScatterChart.colors, colorShift));
    }
    return ScatterChart.colors;
  };

  ScatterChart.prototype.tryResizeChart = function tryResizeChart() {
    var width = $(this.chartRef).width();
    var height = $(this.chartRef).height();
    if (height !== this.height || width !== this.width) {
      if (this.echart) {
        this.echart.resize();
      }
    }
    this.width = width;
    this.height = height;
  };

  ScatterChart.prototype.updateChart = function updateChart(nextSeries) {
    var _props = this.props,
        legend = _props.legend,
        visualMap = _props.visualMap;
    var thisSeries = this.state.series;

    var series = nextSeries.map(function (s) {
      return _.extend({
        type: 'scatter'
      }, s);
    });
    var option = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.echart.getOption(), {
      visualMap: visualMap,
      series: series,
      legend: legend
    });
    if (!_.isEqual(_.map(thisSeries, 'name'), _.map(nextSeries, 'name'))) {
      // reset option
      this.echart.clear();
    }
    this.echart.setOption(option);
    this.echart.resize();
  };

  ScatterChart.prototype.initChart = function initChart() {
    var echart = __WEBPACK_IMPORTED_MODULE_13_echarts_lib_echarts___default.a.init(this.chartRef);
    var series = this.state.series.map(function (s) {
      return {
        name: s.name,
        data: s.data,
        type: 'scatter'
      };
    });

    var _props2 = this.props,
        legend = _props2.legend,
        grid = _props2.grid,
        visualMap = _props2.visualMap,
        dataZoom = _props2.dataZoom,
        tooltip = _props2.tooltip,
        xAxis = _props2.xAxis,
        yAxis = _props2.yAxis;

    var option = {
      dataZoom: dataZoom,
      xAxis: xAxis,
      yAxis: yAxis,
      legend: legend,
      series: series,
      visualMap: visualMap,
      grid: grid,
      color: this.colors(),
      textStyle: {
        fontSize: 12,
        fontWeight: 300
      },
      tooltip: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, tooltip),
      animationEasing: 'cubicIn',
      showLoading: true
    };
    echart.setOption(option);
    return echart;
  };

  ScatterChart.prototype.render = function render() {
    var _this2 = this;

    var height = this.props.height;


    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_15__styles_scss___default.a.chart,
      style: { height: height },
      ref: function ref(_ref) {
        _this2.chartRef = _ref;
      }
    });
  };

  return ScatterChart;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ScatterChart.colors = ['#22A7F0', '#00B16A', '#F7CA18', '#F9690E', '#EF4836', '#DB0A5B', '#663399', '#BF55EC', '#446CB3', '#336E7B', '#1BBC9B'];
ScatterChart.propTypes = propTypes;
ScatterChart.defaultProps = defaultProps;

var mapStateToProps = function mapStateToProps(state) {
  return {
    collapsed: state.sidebar.collapsed
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_react_redux__["connect"])(mapStateToProps, null)(ScatterChart));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss__ = __webpack_require__(2157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var defaultProps = {
  status: "idle",
  pullRight: false,
  more: false,
  mark: null
};

var TablePagers = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(TablePagers, _React$Component);

  function TablePagers(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TablePagers);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));
  }

  TablePagers.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        mark = _props.mark,
        more = _props.more,
        status = _props.status;

    var hasPrev = mark > 0 ? true : false;

    var nextIcon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-chevron-circle-right" });
    var prevIcon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-chevron-circle-left" });

    if (status === "loading" || status === "request") {
      nextIcon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" });
      prevIcon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" });
    }
    if (!more) {
      nextIcon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-circle" });
    }
    if (!hasPrev) {
      prevIcon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-circle" });
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "ul",
      { styleName: "table-pager", className: "list-inline" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "li",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "button",
          {
            styleName: "pager-button",
            onClick: function onClick() {
              return _this2.props.change(false);
            },
            disabled: !hasPrev
          },
          prevIcon
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "li",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "button",
          {
            styleName: "pager-button",
            onClick: function onClick() {
              return _this2.props.change(true);
            },
            disabled: !more
          },
          nextIcon
        )
      )
    );
  };

  return TablePagers;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

TablePagers.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_react_css_modules___default()(TablePagers, __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a));

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (immutable) */ __webpack_exports__["d"] = saveParserWithApp;
/* harmony export (immutable) */ __webpack_exports__["a"] = loadParserWithApp;
/* unused harmony export saveParser */
/* unused harmony export loadParser */
/* harmony export (immutable) */ __webpack_exports__["c"] = syntaxCheck;
/* harmony export (immutable) */ __webpack_exports__["b"] = transform;
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

var kLSParserKey = 'parser';

function saveParserWithApp(app, scripts) {
  window.localStorage.setItem(app, scripts);
}

function loadParserWithApp(app) {
  return (window.localStorage.getItem(app) || '').trim();
}

function saveParser(scripts) {
  window.localStorage.setItem(kLSParserKey, scripts);
}

function loadParser() {
  return (window.localStorage.getItem(kLSParserKey) || '').trim();
}

function evalInCtx(script) {
  return eval(script);
}

function evalScript(ctx, script) {
  var s = '';
  _.forOwn(ctx, function (value, name) {
    s = s + "\nvar " + name + "=this['" + name + "'];";
  });
  try {
    return [evalInCtx.call(ctx, s + script), null];
  } catch (e) {
    return [null, e];
  }
}

function dehex(str) {
  var bin = [];
  var hex = [];
  var s = str;
  while (s.length >= 2) {
    var value = s.substring(0, 2);
    bin.push(parseInt(value, 16));
    hex.push(value);
    s = str.substring(2, s.length);
  }
  return [bin, hex];
}

function syntaxCheck(script) {
  var s = '1122334455667788';

  var _dehex = dehex(s),
      bin = _dehex[0],
      hex = _dehex[1];

  var _evalScript = evalScript({
    data: s,
    bin: bin,
    hex: hex,
    appeui: s,
    deveui: s,
    fport: 1
  }, script),
      _ = _evalScript[0],
      e = _evalScript[1];

  return e && e.message;
}

function transform(parser, datalist) {
  return datalist.slice(0, 20).map(function (obj) {
    if (parser && !obj.error) {
      if (!obj._raw_) {
        obj._raw_ = obj.data;
      }

      var _dehex2 = dehex(obj._raw_),
          bin = _dehex2[0],
          hex = _dehex2[1];

      var _evalScript2 = evalScript({
        data: obj._raw_,
        bin: bin,
        hex: hex,
        appeui: obj.appeui,
        deveui: obj.deveui,
        fport: obj.fport
      }, parser);

      obj.data = _evalScript2[0];
    } else if (!obj._raw_) {
      obj._raw_ = obj.data;
    } else {
      obj.data = obj._raw_;
    }
    return obj;
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setHttpUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getHttpUrl; });
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

var kUrl = 'url';
var kHttpUrl = 'httpUrl';

var setUrl = function setUrl(url) {
  sessionStorage.setItem(kUrl, url);
};

var setHttpUrl = function setHttpUrl(httpUrl) {
  sessionStorage.setItem(kHttpUrl, httpUrl);
};

var getUrl = function getUrl() {
  return sessionStorage.getItem(kUrl);
};

var getHttpUrl = function getHttpUrl() {
  return sessionStorage.getItem(kHttpUrl);
};

/* unused harmony default export */ var _unused_webpack_default_export = ({
  setUrl: setUrl,
  setHttpUrl: setHttpUrl,
  getUrl: getUrl,
  getHttpUrl: getHttpUrl
});

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_LineChart__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loraactions_app__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loraactions_dashboard__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loraimages_chart_loading_gif__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loraimages_chart_loading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_loraimages_chart_loading_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss__ = __webpack_require__(2186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__styles_scss__);





/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

















var kChartHeight = 200;

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  deveuis: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array.isRequired,
  dps: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array.isRequired,
  dpsShow: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array.isRequired,
  // gridTop: PropTypes.string.isRequired,
  time: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  dashboardState: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  appState: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  refreshState: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number.isRequired,
  getDashboard: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  getApp: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  dashId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
  showPanel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};

var defaultProps = {
  showPanel: true
};

var Chart = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Chart, _React$Component);

  function Chart(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Chart);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.dashboard');
    _this.state = {
      series: [],
      categories: ['11', '12', '13', '14', '15', '16', '17'],
      deveuis: props.deveuis,
      dps: props.dps,
      dpsShow: props.dpsShow,
      // gridTop: props.gridTop,
      status: 'pending',
      loadStatus: 'pending',
      time: props.time,
      appState: props.appState,
      dashboardState: props.dashboardState,
      showPanel: props.showPanel,
      allDpsdata: [],
      dpsStats: [],
      statSeries: {
        drops: {
          name: 'drops', // this.intlMsg.msg('map.drops')
          data: [],
          yAxisIndex: 0
        },
        snr: {
          name: 'snr',
          data: [],
          yAxisIndex: 0
        },
        rssi: {
          name: 'rssi',
          data: [],
          yAxisIndex: 0
        },
        categories: []
      }
    };
    _this.showTo = null;
    _this.showFrom = null;
    return _this;
  }

  Chart.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        getDashboard = _props.getDashboard,
        dashId = _props.dashId,
        getApp = _props.getApp,
        appId = _props.appId,
        showPanel = _props.showPanel;
    var _state = this.state,
        data = _state.dashboardState.data,
        appState = _state.appState;

    this.loadDps();
    if (!data) {
      getDashboard(dashId);
    }
    this.handleData();
    if (!appState.data) {
      getApp(appId);
    }
    this.setState({ showPanel: showPanel });
  };

  Chart.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var deveuis = nextProps.deveuis,
        dps = nextProps.dps,
        time = nextProps.time,
        refreshState = nextProps.refreshState,
        dashboardState = nextProps.dashboardState,
        appState = nextProps.appState,
        dpsShow = nextProps.dpsShow;

    if (deveuis !== this.props.deveuis) {
      this.setState({ deveuis: deveuis }, function () {
        _this2.handleData();
      });
    }
    if (dps !== this.props.dps) {
      this.setState({ dps: dps });
    }
    if (dpsShow !== this.props.dpsShow) {
      this.setState({ dpsShow: dpsShow });
    }
    // if (gridTop !== this.props.gridTop) {
    //   this.setState({ gridTop });
    // }
    if (time !== this.props.time) {
      this.setState({ time: time }, function () {
        _this2.handleData();
      });
    }
    if (refreshState !== this.props.refreshState && refreshState !== 0) {
      this.handleData('success');
    }
    if (dashboardState !== this.props.dashboardState) {
      this.setState({ dashboardState: dashboardState });
    }
    if (appState !== this.props.appState) {
      this.setState({ appState: appState });
    }
  };

  // judgeDps(d) {
  //   return (d === 'snr' || d === 'rssi' || d === 'drops');
  // }

  Chart.prototype.loadDps = function loadDps() {
    var _this3 = this;

    var appId = this.props.appId;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__api_callAPI__["a" /* default */])({
      endpoint: '/lora/dps',
      query: {
        appid: appId
      }
    }).then(function (data) {
      _this3.setState({
        allDpsdata: data.list
      });
    }).catch(function () {});
  };

  Chart.prototype.loadData = function loadData(item, dps, stat) {
    var from = this.state.time.from;

    var to = stat ? new Date() : this.state.time.to;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__api_callAPI__["a" /* default */])({ endpoint: '/lora/timeseries',
      method: 'POST',
      body: { nodeid: item, dps: dps, from: from, to: to, limit: 10000 }
    });
  };

  Chart.prototype.loadStats = function loadStats(d) {
    var _this4 = this;

    var deveuis = this.state.deveuis;
    var dpsStats = this.state.dpsStats;
    // dpsStats = _.difference(dpsStats, [d]);

    dpsStats.push(d);
    dpsStats = _.uniq(dpsStats);

    this.setState({ dpsStats: dpsStats });

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__api_callAPI__["a" /* default */])({
      endpoint: "/lora/nodes/" + deveuis[0] + "/rxqos?download"
    }).then(function (data) {
      var drops = [];
      var snr = [];
      var rssi = [];
      var slots = [];
      _this4.showTo = __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(data.list[0].$time, 'MM-DD HH:mm:ss');
      _this4.showFrom = __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(data.list[data.list.length - 1].$time, 'MM-DD HH:mm:ss');
      data.list.reverse().forEach(function (item) {
        slots.push(__WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(item.$time, 'MM-DD HH:mm:ss'));
        drops.push(item.drops);
        snr.push(item.lorasnr);
        rssi.push(item.rssi);
      });
      var statSeries = _this4.state.statSeries;

      statSeries.drops.data = drops;
      statSeries.snr.data = snr;
      statSeries.rssi.data = rssi;
      statSeries.categories = slots;
      _this4.setState({ statSeries: statSeries, loadStatus: 'success' });
    });
  };

  Chart.prototype.handleData = function handleData(stat) {
    var _this5 = this;

    this.setState({ status: stat || 'pending', loadStatus: 'pending' });
    var _state2 = this.state,
        dps = _state2.dps,
        deveuis = _state2.deveuis;

    var categories = [];
    var seriesAll = [];
    var promises = void 0;
    if (dps.length === 1) {
      if (dps[0] === 'snr' || dps[0] === 'rssi' || dps[0] === 'drops') {
        this.loadStats(dps[0]);
      }
    } else {
      _.map(dps, function (d) {
        if (d === 'snr' || d === 'rssi' || d === 'drops') {
          _this5.loadStats(d);
        }
      });
    }
    promises = _.map(deveuis, function (item) {
      if (dps.length === 1) {
        return _this5.loadData(item, dps, stat).then(function (res) {
          var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, res, { deveui: item }, { dps: dps[0] });
          return data;
        }).catch(function () {});
      }
      return _.map(dps, function (d) {
        return _this5.loadData(item, [d], stat).then(function (res) {
          var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, res, { deveui: item }, { dps: d });
          return data;
        }).catch(function () {});
      });
    });

    if (!_.isArray(promises[0])) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function (res) {
        var status = 'empty';
        seriesAll = _.map(res, function (item) {
          var list = item.list.reverse();
          if (item.list.length !== 0) {
            status = 'success';
          }
          var data = _.map(list, function (l) {
            categories.push(__WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(l.timestamp, 'DD/MM HH:mm:ss'));
            return l.metrics[item.dps];
          });
          return { name: item.dps, yAxisIndex: 0, data: data, areaStyle: { normal: { opacity: 0.1 } } };
        });
        _this5.setState({ series: seriesAll, categories: categories, status: status });
      });
    } else if (_.isArray(promises[0])) {
      var promlength = promises[0].length - 1;
      _.map(promises[0], function (prom, idx) {
        promises = [prom];
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function (res) {
          var status = 'empty';
          var seriesSingle = _.map(res, function (item) {
            var list = item.list.reverse();
            if (item.list.length !== 0) {
              status = 'success';
            }
            var data = _.map(list, function (l) {
              if (idx === promlength) {
                categories.push(__WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(l.timestamp, 'DD/MM HH:mm:ss'));
              }
              return l.metrics[item.dps];
            });
            return {
              name: item.dps,
              yAxisIndex: 0,
              data: data,
              areaStyle: { normal: { opacity: 0.1 } }
            };
          });
          seriesAll.push(seriesSingle[0]);
          if (idx === promlength) {
            _this5.setState({ series: seriesAll, categories: categories });
            _this5.setState({ status: status });
          }
        });
      });
    }
  };

  Chart.prototype.renderHeader = function renderHeader() {
    var _state3 = this.state,
        id = _state3.dashboardState.data.id,
        appeui = _state3.appState.data.appeui,
        showPanel = _state3.showPanel;
    var _props$time = this.props.time,
        from = _props$time.from,
        to = _props$time.to;

    if (!showPanel) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      { className: "clearfix " + __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.header + " text-center" },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.chartName },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "p",
          { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.fontM },
          this.showFrom || __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(from, 'YYYY-MM-DD HH:mm:ss'),
          "\xA0\u2014\u2014\xA0",
          this.showTo || __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(to, 'YYYY-MM-DD HH:mm:ss')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router__["f" /* Link */], {
        className: "fa fa-compress " + __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.compress,
        to: "/application/" + appeui + "/dashboard/basic/" + id
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.triangle })
    );
  };

  Chart.prototype.render = function render() {
    var _state4 = this.state,
        loadStatus = _state4.loadStatus,
        statSeries = _state4.statSeries,
        dpsStats = _state4.dpsStats,
        dpsShow = _state4.dpsShow,
        dps = _state4.dps,
        allDpsdata = _state4.allDpsdata;
    var _state5 = this.state,
        series = _state5.series,
        categories = _state5.categories,
        status = _state5.status;

    if (status === 'empty') {
      if (loadStatus === 'success') {
        categories = statSeries.categories;
        var staData = [];
        _.map(dpsStats, function (d) {
          if (statSeries[d].data === []) {
            staData.push(statSeries[d]);
          }
          // series = _.difference(series, [statSeries[d]]);
          series.push(statSeries[d]);
          series = _.uniqWith(series, _.isEqual);
        });
        if (staData.length === dpsStats.length) {
          status = 'empty';
        } else {
          status = 'success';
        }
      }
    }
    var content = void 0;
    if (status === 'pending') {
      content = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_18_loraimages_chart_loading_gif___default.a, alt: "" });
    } else if (status === 'success') {
      _.map(dpsShow, function (d, idx) {
        _.map(d.data, function (da, idxd) {
          _.map(allDpsdata, function (a) {
            if (da === a.id) {
              if (a.desc !== '') {
                dpsShow[idx].data[idxd] = a.desc;
              } else {
                dpsShow[idx].data[idxd] = a.id;
              }
            }
          });
        });
      });
      _.map(series, function (s, idx) {
        _.map(allDpsdata, function (a) {
          if (s.name === a.id) {
            if (a.desc !== '') {
              series[idx].name = a.desc;
            } else {
              series[idx].name = a.id;
            }
          }
        });
      });
      content = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_LineChart__["a" /* default */], {
        yAxis: [{
          name: '',
          splitNumber: 5
        }],
        legend: dpsShow,
        series: series,
        categories: categories,
        dataZoom: [{
          type: 'slider',
          fillerColor: 'rgba(228, 241, 254, 0.4)',
          dataBackground: {
            lineStyle: { width: 0 },
            areaStyle: { color: 'rgba(107, 185, 240, 0.8)' }
          }
        }],
        grid: {
          top: 30,
          left: 60,
          right: 30,
          bottom: 60
        },
        height: kChartHeight,
        animation: true
      });
    }
    // else if (this.judgeDps() && loadStatus === 'success') {
    //   // && status === 'success'
    //   let dpsName;
    //   _.map(allDpsdata, (a) => {
    //     if (a.id === dps[0]) {
    //       if (a.desc !== '') {
    //         dpsName = a.desc;
    //       } else {
    //         dpsName = dps[0];
    //       }
    //     }
    //   });
    //   content = (
    //     <LineChart
    //       yAxis={[
    //         {
    //           name: dpsName,
    //           splitNumber: 5,
    //         },
    //       ]}
    //       xAxis={{
    //         axisTick: { alignWithLabel: true },
    //         boundaryGap: true,
    //       }}
    //       legend={{
    //         data: dps,
    //       }}
    //       series={[statSeries[dps[0]]]}
    //       categories={statSeries.categories}
    //       dataZoom={[{
    //         type: 'slider',
    //         fillerColor: 'rgba(228, 241, 254, 0.4)',
    //         dataBackground: {
    //           lineStyle: { width: 0 },
    //           areaStyle: { color: 'rgba(107, 185, 240, 0.8)' },
    //         },
    //       }]}
    //       tooltip={{
    //         formatter: (params) => {
    //           const dataLines = params.map(p =>
    //            `<span style="display: inline-block; background: ${p.color}; width: 9px; height: 9px; border-radius: 100%;"></span> ${p.seriesName} : ${_.isNil(p.value) ? '-' : Number(p.value).toFixed(1)}`).join('<br />');
    //           return `${params[0].name}<br />${dataLines}`;
    //         },
    //       }}
    //       grid={{
    //         left: 60,
    //         top: 30,
    //         right: 30,
    //         bottom: 60,
    //       }}
    //       colorShift={2}
    //       height={200}
    //       resize
    //     />
    //   );
    // }
    else if (status === 'empty') {
        var dpsName = [];
        if (dps.length === 1) {
          dpsName = dps[0];
        } else {
          _.map(dps, function (d) {
            dpsName = _.concat(dpsName, d);
          });
          dpsName = _.join(dpsName, ' , ');
        }
        content = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "span",
            null,
            dpsName
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            { styleName: "noData" },
            this.intlMsg.msg('chart.nodata')
          )
        );
      }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Panel"],
      {
        bsStyle: "aisz-white",
        header: this.renderHeader(),
        styleName: "clear-panel"
      },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { styleName: "chart-preview" },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { styleName: "graph" },
          content
        )
      )
    );
  };

  return Chart;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Chart.propTypes = propTypes;
Chart.defaultProps = defaultProps;

var mapStateToProps = function mapStateToProps(state) {
  return {
    time: state.dashboard.getTimes,
    deveuis: state.dashboard.getDeveui,
    appState: state.app.getApp,
    refreshState: state.dashboard.getRefreshCount,
    dashboardState: state.dashboard.getDashboard
  };
};

var mapDispatchToProps = {
  getDashboard: __WEBPACK_IMPORTED_MODULE_16_loraactions_dashboard__["a" /* default */].getDashboard,
  getApp: __WEBPACK_IMPORTED_MODULE_15_loraactions_app__["a" /* default */].getApp
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_8_react_css_modules___default()(Chart, __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a, { allowMultiple: true }))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_DeleteModal__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api_callAPI__ = __webpack_require__(27);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var propTypes = {
  pushState: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  appState: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  dash: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired
};

var DetailHeader = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DetailHeader, _React$Component);

  function DetailHeader(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DetailHeader);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      appState: props.appState,
      showModal: false
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.dashboard');
    return _this;
  }

  DetailHeader.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var appState = nextProps.appState;

    if (appState !== this.props.appState) {
      this.setState({ appState: appState });
    }
  };

  DetailHeader.prototype.confirmDelete = function confirmDelete() {
    var id = this.state.appState.data.id;
    var _props = this.props,
        pushState = _props.pushState,
        dash = _props.dash;


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__api_callAPI__["a" /* default */])({
      endpoint: "/lora/dashboards/" + dash.id,
      method: 'DELETE'
    }).then(function () {
      pushState("/application/" + id + "/dashboard");
    }).catch(function () {});
  };

  DetailHeader.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        pushState = _props2.pushState,
        dash = _props2.dash;
    var _state = this.state,
        showModal = _state.showModal,
        appState = _state.appState;
    var status = appState.status,
        _appState$data = appState.data;
    _appState$data = _appState$data === undefined ? {} : _appState$data;
    var name = _appState$data.name,
        id = _appState$data.id;

    if (!name) {
      return null;
    }

    var rightTools = [{
      type: 'buttons',
      buttons: [__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Button"],
        {
          bsStyle: "aisz-danger",
          onClick: function onClick() {
            return _this2.setState({ showModal: true });
          }
        },
        this.intlMsg.msg('delete.dashboard'),
        "\xA0",
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-trash-o" })
      )]
    }];

    var breadcrumb = [{
      content: this.intlMsg.globalMsg('application.breadcrumb.application'),
      onClick: function onClick() {
        return pushState('/application');
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Nvl__["a" /* default */], { status: status, val: name }),
      onClick: function onClick() {
        return pushState("/application/" + id + "/dashboard");
      }
    }, {
      content: dash.name,
      onClick: function onClick() {
        return pushState("/application/" + id + "/dashboard");
      },
      active: true
    }];

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb, rightTools: rightTools })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_DeleteModal__["a" /* default */], {
        showModal: showModal,
        onConfirm: function onConfirm() {
          return _this2.confirmDelete();
        },
        onCancel: function onCancel() {
          return _this2.setState({ showModal: false });
        },
        headerText: this.intlMsg.msg('delete.dashboard'),
        text: this.intlMsg.msg('delete.confirm')
      })
    );
  };

  return DetailHeader;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    appState: state.app.getApp
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_5_react_router_redux__["routerActions"].push
};

DetailHeader.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(DetailHeader)));

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MaskMap__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MultipleMap__ = __webpack_require__(1181);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);








var propTypes = {
  appId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  dashId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  deveuiState: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array.isRequired
};

var defaultProps = {
  type: 'preview'
};

var DeviceMap = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeviceMap, _React$Component);

  function DeviceMap(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeviceMap);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      devices: []
    };
    return _this;
  }

  DeviceMap.prototype.componentWillMount = function componentWillMount() {
    this.loadDetail();
  };

  DeviceMap.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var deveuiState = nextProps.deveuiState;

    if (deveuiState !== this.props.deveuiState) {
      this.loadDevices(deveuiState);
    }
  };

  DeviceMap.prototype.componentWillUnmount = function componentWillUnmount() {
    this.loadDetail = null;
  };

  DeviceMap.prototype.loadDevices = function loadDevices(list) {
    var _this2 = this;

    if (list) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_callAPI__["a" /* default */])({
        endpoint: 'lora/nodeinfos',
        method: 'POST',
        body: { appeui: this.props.appId, list: list }
      }).then(function (res) {
        _this2.setState({ devices: res.list });
      }).catch(function () {});
    }
  };

  DeviceMap.prototype.loadDetail = function loadDetail() {
    var _this3 = this;

    var dashId = this.props.dashId;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_callAPI__["a" /* default */])({ endpoint: "/lora/dashboards/" + dashId, method: 'get' }).then(function (res) {
      var ext = JSON.parse(res.ext);
      _this3.loadDevices(ext.deveui);
    }).catch(function () {});
  };

  DeviceMap.prototype.render = function render() {
    var _props = this.props,
        type = _props.type,
        dashId = _props.dashId;
    var devices = this.state.devices;

    if (devices.length === 0) {
      return null;
    }
    if (type === 'preview') {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__MaskMap__["a" /* default */], { devices: devices, dashId: dashId });
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__MultipleMap__["a" /* default */], { devices: devices, dashId: dashId });
  };

  return DeviceMap;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DeviceMap.propTypes = propTypes;
DeviceMap.defaultProps = defaultProps;

var mapStateToProps = function mapStateToProps(state) {
  return {
    deveuiState: state.dashboard.getDeveui
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, null)(DeviceMap));

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_SearchInput__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_TablePager__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_scss__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);















var propTypes = {
  showModal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  onChoose: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  checkedId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array
};

var defaultProps = {
  checkedId: []
};

var DeviceModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeviceModal, _React$Component);

  function DeviceModal(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeviceModal);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      showModal: props.showModal,
      lists: [],
      reset: 0,
      status: 'idle',
      checked: [],
      checkedId: props.checkedId
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.dashboard');
    _this.handleSearch = _this.handleSearch.bind(_this);
    _this.handleChangeMark = _this.handleChangeMark.bind(_this);
    _this.mark = '';
    _this.q = null;
    return _this;
  }

  DeviceModal.prototype.componentWillMount = function componentWillMount() {
    this.loadData();
  };

  DeviceModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var showModal = nextProps.showModal,
        checkedId = nextProps.checkedId;

    if (showModal !== this.props.showModal) {
      this.setState({ showModal: showModal });
    }
    if (checkedId !== this.props.checkedId) {
      this.setState({ checkedId: checkedId });
    }
  };

  DeviceModal.prototype.componentWillUnmount = function componentWillUnmount() {
    this.loadData = null;
  };

  DeviceModal.prototype.loadData = function loadData() {
    var _this2 = this;

    var appId = this.props.appId;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lorautils_api__["a" /* callAPI */])({
      endpoint: '/lora/nodes',
      query: {
        app: appId,
        pageSize: 10,
        q: this.q,
        mark: this.mark
      }
    }).then(function (data) {
      var list = data.list,
          more = data.more,
          mark = data.mark;

      _this2.setState({
        lists: list,
        status: 'success',
        more: more,
        mark: mark,
        noData: list.length === 0
      });
    }).catch(function () {
      _this2.setState({
        status: 'failure'
      });
    });
  };

  DeviceModal.prototype.handleSearch = function handleSearch(e) {
    var search = e.target.value;
    this.setState({
      search: search,
      reset: new Date()
    });
    this.mark = '';

    if (search.length > 0) {
      var s = search.replace(/[:-]/g, '');
      this.q = "or,name:*" + s + "*,deveui:*" + s + "*,devaddr:*" + s + "*,appIdeui:" + s + "*,city:*" + s + "*,area:*" + s + "*,band:*" + s + "*";
      this.loadData();
    } else {
      this.q = null;
      this.loadData();
    }
  };

  DeviceModal.prototype.handleSubmit = function handleSubmit() {
    var _this3 = this;

    var _props = this.props,
        onHide = _props.onHide,
        onChoose = _props.onChoose;
    var _state = this.state,
        checked = _state.checked,
        checkedId = _state.checkedId;

    onHide();
    if (!checked || checked.length === 0) {
      return;
    }
    onChoose(checked, checkedId);
    this.mark = '';
    this.q = null;
    this.setState({ search: '', reset: new Date() }, function () {
      _this3.loadData();
    });
  };

  DeviceModal.prototype.handleChangeMark = function handleChangeMark(mark) {
    this.mark = mark;
    this.loadData();
  };

  DeviceModal.prototype.handleChecked = function handleChecked(e, device) {
    this.setState({ checked: [device], checkedId: [device.id] });
  };

  DeviceModal.prototype.handleCancel = function handleCancel() {
    var _this4 = this;

    this.mark = '';
    this.q = null;
    this.setState({ search: '', reset: new Date() }, function () {
      _this4.loadData();
    });
    this.props.onHide();
    this.setState({ checked: [], checkedId: [] });
  };

  DeviceModal.prototype.renderTbody = function renderTbody() {
    var _this5 = this;

    var _state2 = this.state,
        lists = _state2.lists,
        checkedId = _state2.checkedId;

    var rows = _.map(lists, function (item) {
      var isChecked = checkedId[0] ? item.id === checkedId[0] : false;
      var radio = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("input", {
        id: item.id,
        type: "radio",
        name: "deveui",
        onChange: function onChange(e) {
          return _this5.handleChecked(e, item);
        },
        checked: isChecked
      });
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        { key: item.id },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_15__styles_scss___default.a.checkbox },
            radio,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("label", { htmlFor: item.id })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          { key: item.id + "-" + item.name },
          item.name
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          { key: item.id + "-" + item.deveui },
          item.deveui
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_10_date_fns_format___default()(item.createdAt, 'YYYY-MM-DD HH:mm:ss')
        )
      );
    });
    return rows;
  };

  DeviceModal.prototype.render = function render() {
    var _this6 = this;

    var _state3 = this.state,
        showModal = _state3.showModal,
        _state3$search = _state3.search,
        search = _state3$search === undefined ? '' : _state3$search,
        _state3$mark = _state3.mark,
        mark = _state3$mark === undefined ? '' : _state3$mark,
        _state3$more = _state3.more,
        more = _state3$more === undefined ? false : _state3$more,
        reset = _state3.reset,
        status = _state3.status,
        _state3$noData = _state3.noData,
        noData = _state3$noData === undefined ? false : _state3$noData;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"],
      {
        show: showModal,
        bsClass: "aisz-modal-light"
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Header,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_SearchInput__["a" /* default */], {
          onChange: this.handleSearch,
          value: search,
          placeholder: this.intlMsg.msg('search.placeholder')
        })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Body,
        { className: "clearfix" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Table"],
          {
            className: "aisz-table-light", striped: true, hover: true, bordered: true, responsive: true
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("th", null),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('addmodal.name')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('addmodal.deveui')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('addmodal.createdAt')
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tbody",
            null,
            this.renderTbody()
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
          { "if": noData },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: "text-center" },
            this.intlMsg.msg('adddevice.nodata')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "pull-right" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_TablePager__["a" /* default */], {
            status: status,
            mark: mark,
            more: more,
            onPrev: this.handleChangeMark,
            onNext: this.handleChangeMark,
            reset: reset
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Footer,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-success",
            onClick: function onClick() {
              return _this6.handleSubmit();
            }
          },
          this.intlMsg.msg('confirm')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-default",
            onClick: function onClick() {
              return _this6.handleCancel();
            },
            className: __WEBPACK_IMPORTED_MODULE_15__styles_scss___default.a.white
          },
          this.intlMsg.msg('cancel')
        )
      )
    );
  };

  return DeviceModal;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DeviceModal.propTypes = propTypes;
DeviceModal.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(null, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_6_react_css_modules___default()(DeviceModal, __WEBPACK_IMPORTED_MODULE_15__styles_scss___default.a, { allowMultiple: true }))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_SearchInput__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_TablePager__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_Checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__DeviceModal_styles_scss__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__DeviceModal_styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__DeviceModal_styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);
















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  showModal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  onChoose: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  checkedIds: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array
};

var defaultProps = {
  checkedIds: []
};

var DvcssModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DvcssModal, _React$Component);

  function DvcssModal(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DvcssModal);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      showModal: props.showModal,
      lists: [],
      reset: 0,
      status: 'idle',
      checkedIds: props.checkedIds,
      checked: []
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.dashboard');
    _this.handleSearch = _this.handleSearch.bind(_this);
    _this.handleChangeMark = _this.handleChangeMark.bind(_this);
    _this.mark = '';
    _this.q = null;
    return _this;
  }

  DvcssModal.prototype.componentWillMount = function componentWillMount() {
    this.loadData();
  };

  DvcssModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var showModal = nextProps.showModal,
        checkedIds = nextProps.checkedIds;

    if (showModal !== this.props.showModal) {
      this.setState({ showModal: showModal });
      if (showModal) {
        this.loadData();
      }
    }
    this.setState({ checkedIds: checkedIds });
  };

  DvcssModal.prototype.componentWillUnmount = function componentWillUnmount() {
    this.loadData = null;
  };

  DvcssModal.prototype.loadData = function loadData() {
    var _this2 = this;

    var appId = this.props.appId;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lorautils_api__["a" /* callAPI */])({
      endpoint: '/lora/nodes',
      query: {
        app: appId,
        pageSize: 10,
        q: this.q,
        mark: this.mark
      }
    }).then(function (data) {
      var list = data.list,
          more = data.more,
          mark = data.mark;

      _this2.setState({
        lists: list,
        status: 'success',
        more: more,
        mark: mark,
        noData: list.length === 0
      });
    }).catch(function () {
      _this2.setState({
        status: 'failure'
      });
    });
  };

  DvcssModal.prototype.allChecked = function allChecked() {
    var _state = this.state,
        lists = _state.lists,
        checked = _state.checked;

    var allChecked = true;
    if (lists.length) {
      lists.forEach(function (d) {
        if (!_.some(checked, { id: d.id })) {
          allChecked = false;
          return false;
        }
        return null;
      });
    } else {
      allChecked = false;
    }
    return allChecked;
  };

  DvcssModal.prototype.handleToggleCheckAll = function handleToggleCheckAll(check) {
    var lists = this.state.lists;
    var _state2 = this.state,
        checked = _state2.checked,
        checkedIds = _state2.checkedIds;

    if (check) {
      checked = _.concat(lists, checked);
      var ids = _.map(checked, function (a) {
        return a.id;
      });
      checkedIds = _.uniq(_.concat(checkedIds, ids));
    } else {
      _.forEach(lists, function (list) {
        checked = _.filter(checked, function (c) {
          return c.id !== list.id;
        });
        checkedIds = _.filter(checkedIds, function (h) {
          return h !== list.id;
        });
      });
    }
    this.setState({ checked: checked, checkedIds: checkedIds });
  };

  DvcssModal.prototype.isChecked = function isChecked(d) {
    var checkedIds = this.state.checkedIds;

    return _.includes(checkedIds, d.id);
  };

  DvcssModal.prototype.toggleCheck = function toggleCheck(d) {
    var _state3 = this.state,
        checked = _state3.checked,
        checkedIds = _state3.checkedIds;

    if (this.isChecked(d)) {
      checked = _.filter(checked, function (a) {
        return a.id !== d.id;
      });
      checkedIds = _.filter(checkedIds, function (c) {
        return c !== d.id;
      });
    } else {
      checked.push(d);
      checkedIds.push(d.id);
    }
    this.setState({ checked: checked, checkedIds: checkedIds });
  };

  DvcssModal.prototype.handleSearch = function handleSearch(e) {
    var search = e.target.value;
    this.setState({
      search: search,
      reset: new Date()
    });
    this.mark = '';

    if (search.length > 0) {
      var s = search.replace(/[:-]/g, '');
      this.q = "or,name:*" + s + "*,deveui:*" + s + "*,devaddr:*" + s + "*,appIdeui:" + s + "*,city:*" + s + "*,area:*" + s + "*,band:*" + s + "*";
      this.loadData();
    } else {
      this.q = null;
      this.loadData();
    }
  };

  DvcssModal.prototype.handleSubmit = function handleSubmit() {
    var _this3 = this;

    var _props = this.props,
        onHide = _props.onHide,
        onChoose = _props.onChoose;
    var _state4 = this.state,
        checked = _state4.checked,
        checkedIds = _state4.checkedIds;

    onHide();
    if (checkedIds.length === 0) {
      return;
    }
    onChoose(checked, checkedIds);
    this.mark = '';
    this.q = null;
    this.setState({ search: '', reset: new Date() }, function () {
      _this3.loadData();
    });
  };

  DvcssModal.prototype.handleChangeMark = function handleChangeMark(mark) {
    this.mark = mark;
    this.loadData();
  };

  DvcssModal.prototype.handleCancel = function handleCancel() {
    this.mark = '';
    this.q = null;
    this.setState({ search: '', reset: new Date(), checked: [] });
    this.props.onHide();
  };

  DvcssModal.prototype.render = function render() {
    var _this4 = this;

    var _state5 = this.state,
        showModal = _state5.showModal,
        _state5$search = _state5.search,
        search = _state5$search === undefined ? '' : _state5$search,
        _state5$mark = _state5.mark,
        mark = _state5$mark === undefined ? '' : _state5$mark,
        _state5$more = _state5.more,
        more = _state5$more === undefined ? false : _state5$more,
        reset = _state5.reset,
        status = _state5.status,
        lists = _state5.lists,
        _state5$noData = _state5.noData,
        noData = _state5$noData === undefined ? false : _state5$noData;

    var rows = _.map(lists, function (item) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        { key: item.id },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_16__DeviceModal_styles_scss___default.a.checkbox },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_Checkbox__["a" /* default */], {
              id: item.id,
              checked: _this4.isChecked(item),
              onChange: function onChange() {
                return _this4.toggleCheck(item);
              }
            }),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("label", { htmlFor: item.id })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          item.name
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          item.deveui
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_10_date_fns_format___default()(item.createdAt, 'YYYY-MM-DD HH:mm:ss')
        )
      );
    });
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"],
      {
        show: showModal,
        bsClass: "aisz-modal-light"
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Header,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_SearchInput__["a" /* default */], {
          onChange: this.handleSearch,
          value: search,
          placeholder: this.intlMsg.msg('search.placeholder')
        })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Body,
        { className: "clearfix" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Table"],
          {
            className: "aisz-table-light", striped: true, hover: true, bordered: true, responsive: true
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_16__DeviceModal_styles_scss___default.a.checkbox },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_Checkbox__["a" /* default */], {
                    id: "all",
                    checked: this.allChecked(),
                    onChange: function onChange(e) {
                      return _this4.handleToggleCheckAll(e);
                    }
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('addmodal.name')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('addmodal.deveui')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('addmodal.createdAt')
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tbody",
            null,
            rows
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_15_loracoms_ShowIf__["a" /* default */],
          { "if": noData },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: "text-center" },
            this.intlMsg.msg('adddevice.nodata')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "pull-right" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_TablePager__["a" /* default */], {
            status: status,
            mark: mark,
            more: more,
            onPrev: this.handleChangeMark,
            onNext: this.handleChangeMark,
            reset: reset
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Footer,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-success",
            onClick: function onClick() {
              return _this4.handleSubmit();
            }
          },
          this.intlMsg.msg('confirm')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-default",
            onClick: function onClick() {
              return _this4.handleCancel();
            },
            className: __WEBPACK_IMPORTED_MODULE_16__DeviceModal_styles_scss___default.a.white
          },
          this.intlMsg.msg('cancel')
        )
      )
    );
  };

  return DvcssModal;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DvcssModal.propTypes = propTypes;
DvcssModal.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(null, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_6_react_css_modules___default()(DvcssModal, __WEBPACK_IMPORTED_MODULE_16__DeviceModal_styles_scss___default.a, { allowMultiple: true }))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_Editable__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss__ = __webpack_require__(2189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);












var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  dashId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired
};

var EditName = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(EditName, _React$Component);

  function EditName(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, EditName);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      edit: false,
      errors: __WEBPACK_IMPORTED_MODULE_10_lorautils_errors_ErrorSet__["a" /* default */].createEmpty(),
      name: props.name,
      editNameData: { name: props.name }
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.dashboard');
    return _this;
  }

  EditName.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var name = nextProps.name;

    if (name !== this.props.name) {
      this.setState({ name: name, editNameData: { name: name } });
    }
  };

  EditName.prototype.handleChangeName = function handleChangeName(data) {
    var name = data.name;
    var errors = this.state.errors;

    if (_.trim(name).length === 0) {
      this.setState({ errors: errors.add('FE_EMPTY', 'name') });
    } else {
      this.setState({ errors: errors.remove('name') });
    }
    this.setState({ editNameData: data });
  };

  EditName.prototype.handleCancelEdit = function handleCancelEdit() {
    var _state = this.state,
        name = _state.name,
        errors = _state.errors;

    this.setState({
      name: name,
      edit: false,
      editNameData: { name: name },
      errors: errors.remove('name')
    });
  };

  EditName.prototype.handleSubmitName = function handleSubmitName() {
    var _this2 = this;

    var _state2 = this.state,
        name = _state2.editNameData.name,
        errors = _state2.errors;
    var dashId = this.props.dashId;

    if (errors.has('name')) {
      return;
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__api_callAPI__["a" /* default */])({ endpoint: "/lora/dashboards/" + dashId, method: 'PUT', body: { name: name } }).then(function () {
      _this2.setState({ name: name, editNameData: { name: name } });
    }).catch(function () {});
    this.setState({ edit: false });
  };

  EditName.prototype.render = function render() {
    var _this3 = this;

    var _state3 = this.state,
        edit = _state3.edit,
        editNameData = _state3.editNameData,
        name = _state3.name,
        errors = _state3.errors;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_Editable__["a" /* default */], {
        id: "name",
        edit: edit,
        data: editNameData,
        value: name,
        formatter: function formatter() {
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "span",
            null,
            name
          );
        },
        onChange: function onChange(d) {
          return _this3.handleChangeName(d);
        },
        error: this.intlMsg.errorMsg(errors.get('name')),
        errorPlacement: 'top'
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_loracoms_ShowIf__["a" /* default */],
        { "if": !edit },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */], {
          className: "halflings halflings-pencil " + __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.edit,
          onClick: function onClick() {
            return _this3.setState({ edit: true });
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_loracoms_ShowIf__["a" /* default */],
        { "if": edit },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.icons },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
            {
              onClick: function onClick() {
                return _this3.handleSubmitName();
              }
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-ok " + __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.ok })
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
            {
              onClick: function onClick() {
                return _this3.handleCancelEdit();
              }
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-remove " + __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.remove })
          )
        )
      )
    );
  };

  return EditName;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

EditName.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(EditName));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_Refresher_styles_scss__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_Refresher_styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_loracoms_Refresher_styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);








var propTypes = {
  onReload: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  onOneClick: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func,
  reloading: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool,
  interval: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.number,
  loops: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.number
};

var defaultProps = {
  interval: 6,
  loops: 100,
  reloading: false,
  onOneClick: function onOneClick() {}
};

var RefreshBtn = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(RefreshBtn, _React$Component);

  function RefreshBtn(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RefreshBtn);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      pinned: false,
      reloading: props.reloading
    };
    _this.handleReload = _this.handleReload.bind(_this);
    _this.handleReloadPinned = _this.handleReloadPinned.bind(_this);
    return _this;
  }

  RefreshBtn.prototype.componentDidMount = function componentDidMount() {
    this.mounted = true;
  };

  RefreshBtn.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    if (this.props.reloading !== nextProps.reloading) {
      if (this.reloadingTimeout) {
        clearTimeout(this.reloadingTimeout);
      }
      var reloading = nextProps.reloading;
      if (reloading) {
        this.setState({ reloading: reloading });
      } else {
        setTimeout(function () {
          if (_this2.mounted) {
            _this2.setState({ reloading: reloading });
          }
        }, 1000);
      }
    }
  };

  RefreshBtn.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  RefreshBtn.prototype.handleReload = function handleReload(e) {
    e.preventDefault();
    var reloading = this.state.reloading;

    if (!reloading) {
      this.setState({ pinned: false });
      this.props.onReload();
      this.props.onOneClick();
    } else {
      this.handleReloadPinned();
    }
  };

  RefreshBtn.prototype.handleReloadPinned = function handleReloadPinned(e) {
    var _this3 = this;

    if (e) {
      e.preventDefault();
    }
    var _props = this.props,
        interval = _props.interval,
        loops = _props.loops;

    this.setState({
      pinned: true,
      pinnedLoops: 0
    });

    var g = function g() {
      var pinned = _this3.state.pinned;

      if (_this3.mounted && pinned) {
        _this3.props.onReload();
        var _state$pinnedLoops = _this3.state.pinnedLoops,
            pinnedLoops = _state$pinnedLoops === undefined ? 0 : _state$pinnedLoops;

        if (pinnedLoops < loops) {
          _this3.setState({
            pinnedLoops: pinnedLoops + 1
          });
          setTimeout(g, interval * 1000);
        } else {
          _this3.setState({
            pinned: false
          });
        }
      }
    };
    this.props.onReload();
    setTimeout(g, interval * 1000);
  };

  RefreshBtn.prototype.render = function render() {
    var _props2 = this.props,
        interval = _props2.interval,
        loops = _props2.loops;
    var _state = this.state,
        reloading = _state.reloading,
        pinned = _state.pinned,
        pinnedLoops = _state.pinnedLoops;

    var icon = 'glyphicons glyphicons-refresh';
    if (pinned) {
      icon = 'glyphicons glyphicons-synchronization';
    }
    if (reloading) {
      icon = icon + " aisz-spin";
    }

    var refresher = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "button",
      {
        onClick: this.handleReload,
        className: "icon",
        styleName: "" + (pinned ? 'btn-link pinned' : 'btn-link')
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: icon })
    );

    if (pinned) {
      var _tooltip = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Tooltip"],
        { id: "refresher-pinned-tooltip" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], { id: "lora.coms.refresher.pinned.tooltip" }),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_8_loracoms_Refresher_styles_scss___default.a.progress },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
            className: __WEBPACK_IMPORTED_MODULE_8_loracoms_Refresher_styles_scss___default.a.progressBar,
            style: {
              width: (loops - pinnedLoops) / loops * 100 + "%"
            }
          })
        )
      );
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["OverlayTrigger"],
        {
          placement: "top",
          overlay: _tooltip,
          trigger: ['hover', 'focus'],
          delayHide: interval * 1000
        },
        refresher
      );
    }

    var tooltip = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Tooltip"],
      { id: "refresher-tooltip" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], { id: "lora.coms.refresher.tooltip" })
    );
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["OverlayTrigger"],
      { placement: "top", overlay: tooltip, delayShow: 1500 },
      refresher
    );
  };

  return RefreshBtn;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

RefreshBtn.propTypes = propTypes;
RefreshBtn.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_7_react_css_modules___default()(RefreshBtn, __WEBPACK_IMPORTED_MODULE_8_loracoms_Refresher_styles_scss___default.a, { allowMultiple: true }))));

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_sub_days__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_sub_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_sub_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_sub_hours__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_sub_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_sub_hours__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_day__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_add_days__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns_add_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_is_after__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_is_after___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_date_fns_is_after__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_is_before__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_is_before___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_date_fns_is_before__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_min__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_date_fns_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_DatePicker__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_InlineSelect__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loraactions_dashboard__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss__ = __webpack_require__(2194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



















var defaultTo = function defaultTo() {
  return __WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_day___default()(new Date());
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  time: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  getTimes: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};

var TimeSelect = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(TimeSelect, _React$Component);

  TimeSelect.handleDisableDate = function handleDisableDate(d, from) {
    return __WEBPACK_IMPORTED_MODULE_12_date_fns_is_after___default()(d, __WEBPACK_IMPORTED_MODULE_14_date_fns_min___default()(__WEBPACK_IMPORTED_MODULE_11_date_fns_add_days___default()(from, 7), new Date())) || __WEBPACK_IMPORTED_MODULE_13_date_fns_is_before___default()(d, from);
  };

  function TimeSelect(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TimeSelect);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      from: props.time.from,
      to: props.time.to,
      by: props.time.by || 'hour'
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_17_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.dashboard');
    return _this;
  }

  TimeSelect.prototype.handleSetFrom = function handleSetFrom(date) {
    var _this2 = this;

    this.setState({ from: __WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day___default()(date), to: __WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_day___default()(date) }, function () {
      var _state = _this2.state,
          from = _state.from,
          to = _state.to;

      _this2.props.getTimes({ from: from, to: to });
    });
  };

  TimeSelect.prototype.handleSetTo = function handleSetTo(date) {
    var _this3 = this;

    this.setState({ to: __WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day___default()(date) }, function () {
      var _state2 = _this3.state,
          from = _state2.from,
          to = _state2.to;

      _this3.props.getTimes({ from: from, to: to });
    });
  };

  TimeSelect.prototype.handleChangeBy = function handleChangeBy(by) {
    var getTimes = this.props.getTimes;

    var to = defaultTo();
    var from = void 0;
    switch (by) {
      case 'hour':
        from = __WEBPACK_IMPORTED_MODULE_8_date_fns_sub_hours___default()(new Date(), 1);
        break;
      case 'day':
        from = __WEBPACK_IMPORTED_MODULE_7_date_fns_sub_days___default()(new Date(), 1);
        break;
      case 'sevenday':
        from = __WEBPACK_IMPORTED_MODULE_7_date_fns_sub_days___default()(new Date(), 7);
        break;
      case 'month':
        from = __WEBPACK_IMPORTED_MODULE_7_date_fns_sub_days___default()(new Date(), 30);
        break;
      default:
        from = __WEBPACK_IMPORTED_MODULE_8_date_fns_sub_hours___default()(new Date(), 1);
    }
    this.setState({ by: by, from: from, to: to });
    getTimes({ from: from, to: to, by: by });
  };

  TimeSelect.prototype.render = function render() {
    var _this4 = this;

    var _state3 = this.state,
        from = _state3.from,
        to = _state3.to,
        by = _state3.by,
        selectDisabled = _state3.selectDisabled;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: "pull-right " + __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.gray },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_DatePicker__["a" /* default */], {
        date: from,
        onSelect: function onSelect(date) {
          return _this4.handleSetFrom(date);
        }
      }),
      ' ',
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_DatePicker__["a" /* default */], {
        date: to,
        onSelect: function onSelect(date) {
          return _this4.handleSetTo(date);
        },
        disabled: function disabled(d) {
          return TimeSelect.handleDisableDate(d, from);
        }
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_InlineSelect__["a" /* default */], {
        bsStyle: "aisz-primary",
        options: [{
          label: this.intlMsg.msg('toolbar.bytime.hour'),
          value: 'hour'
        }, {
          label: this.intlMsg.msg('toolbar.bytime.day'),
          value: 'day'
        }, {
          label: this.intlMsg.msg('toolbar.bytime.sevenday'),
          value: 'sevenday'
        }]
        // , {
        //   label: this.intlMsg.msg('toolbar.bytime.month'),
        //   value: 'month',
        // }
        , values: [by],
        disabled: selectDisabled,
        onChange: function onChange(selected) {
          return _this4.handleChangeBy(selected[0]);
        }
      })
    );
  };

  return TimeSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

TimeSelect.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    time: state.dashboard.getTimes
  };
};

var mapDispatchToProps = {
  getTimes: __WEBPACK_IMPORTED_MODULE_18_loraactions_dashboard__["a" /* default */].getTimes
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(TimeSelect)));

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss__ = __webpack_require__(2210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var defaultProps = {
  highlight: false,
  onHighlightExited: function onHighlightExited() {}
};

var propTypes = {
  locale: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  highlight: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  onHighlightExited: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};

var AddFlowHelp = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(AddFlowHelp, _React$Component);

  AddFlowHelp.renderZh = function renderZh(locale) {
    var tooltip = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Tooltip"],
      { id: "flow-zh" },
      "\u6587\u6863"
    );
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "h3",
        null,
        "\u89C4\u5219\u793A\u4F8B:\u5355Branch\xA0",
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["OverlayTrigger"],
          { placement: "top", overlay: tooltip },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
            { onClick: function onClick() {
                window.open("https://loraflow.io/static/docs/" + locale + "/application/Flow.html");
              } },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-question-circle" })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h4",
          null,
          "\u6E29\u5EA6(\u6570\u636E\u70B9temperature)\u8D85\u8FC730\u5EA6\uFF0C\u53D1\u9001\u901A\u77E5"
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          'temperature | temperature > 30 | warn "#deveui 温度超过30度" -> test@aisenz.com'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h4",
          null,
          "\u6E29\u5EA6(\u6570\u636E\u70B9temperature)\u8D85\u8FC730\u5EA6\uFF0C\u8FDE\u7EED\u53D1\u751F10\u6B21\uFF0C\u53D1\u9001\u901A\u77E5"
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          'temperature | temperature > 30 | repeat 10 | error "#deveui 温度超过30度10次" -> test@aisenz.com'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h4",
          null,
          "\u7EDF\u8BA1\u6700\u8FD110\u6761\u6E29\u5EA6\u6D88\u606F\u7684\u5E73\u5747\u503C\uFF0C\u53D1\u9001\u901A\u77E5"
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          'temperature | window 10 | avg as avgtemperature | info "#avgtemperature" -> test@aisenz.com'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h4",
          null,
          "\u7EDF\u8BA1\u6700\u8FD130\u5206\u949F\u7684\u6E29\u5EA6\u5E73\u5747\u503C\uFF0C\u5982\u679C\u5E73\u5747\u503C\u5927\u4E8E35\uFF0C\u53D1\u9001\u901A\u77E5"
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          'temperature | window 30 min | avg as avgtemperature | avgtemperature > 35 | warn " #deveui 30分钟内，平均温度超过35度" -> test@aisenz.com'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h4",
          null,
          "\u53D1\u73B0\u8BBE\u5907\u72B6\u6001\u5F02\u5E38(0\u4E3A\u6B63\u5E38\uFF0C1\u4E3A\u5F02\u5E38)\uFF0C\u53D1\u9001\u901A\u77E5"
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          'Status | 0 -> 1 | warn " #deveui 状态异常 " -> test@aisenz.com'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h4",
          null,
          "\u53D1\u73B0\u8BBE\u5907\u72B6\u6001\u6062\u590D\uFF0C\u53D1\u9001\u901A\u77E5"
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          'Status | 1 -> 0 | success " #deveui 状态恢复 " -> test@aisenz.com'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "h3",
        null,
        "\u89C4\u5219\u793A\u4F8B:\u591ABranch"
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h4",
          null,
          "\u68C0\u6D4B\u8BBE\u5907\u6E29\u5EA6\uFF0C\u5982\u679C\u6E29\u5EA6\u4ECE30\u5EA6\u4EE5\u4E0B\u5347\u9AD8\u523030\u5EA6\u4EE5\u4E0A\uFF0C\u53D1\u9001\u6E29\u5EA6\u8FC7\u9AD8\u901A\u77E5; \u5982\u679C\u6E29\u5EA6\u4E0B\u964D\u523030\u5EA6\u4EE5\u4E0B\u53D1\u9001\u6E29\u5EA6\u6062\u590D\u6B63\u5E38\u901A\u77E5"
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          'temperature'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|if'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|change temperature <30 -> temperature >=30'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|error "temperatureemperature is too high"  -> test@aisenz.com'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|if'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|change temperature >=30 -> temperature <30'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|success "temperaturehe temperature returned to normal" -> test@aisenz.com'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h4",
          null,
          "\u53D1\u73B0\u8BBE\u5907\u72B6\u6001\u5F02\u5E38(0\u4E3A\u6B63\u5E38\uFF0C1\u4E3A\u5F02\u5E38)\uFF0C\u53D1\u9001\u901A\u77E5;\u53D1\u73B0\u8BBE\u5907\u72B6\u6001\u6062\u590D\uFF0C\u53D1\u9001\u901A\u77E5"
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          'DeviceStatus'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|if'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|0 -> 1'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|warn " #deveui abnormal status " -> test@aisenz.com'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|if'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|1 -> 0'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|success " #deveui status restored " -> test@aisenz.com'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h4",
          null,
          "\u4EE52\u5C0F\u65F6\u4E3A\u5468\u671F\u68C0\u6D4B\u6570\u636E\u8FDE\u63A5\u72B6\u6001\uFF0C\u5982\u679C\u4E24\u4E2A\u68C0\u6D4B\u5468\u671F\u5185\u8BBE\u5907\u6CA1\u6709\u6570\u636E\u4E0A\u4F20\uFF0C\u53D1\u9001\u5931\u8054\u901A\u77E5;\u5982\u679C\u6536\u5230\u8BBE\u5907\u6570\u636E\uFF0C\u53D1\u9001\u5931\u8054\u6062\u590D\u901A\u77E5"
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          'DeviceStatus'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|if'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|timeout 2 hour'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|error " Lost connection：device[#deveui]" ->test@aisenz.com'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|if'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|recover'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|success " Resume connection：device[#deveui]" ->test@aisenz.com'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "h3",
        null,
        "\u8868\u8FBE\u5F0F\u5224\u65AD(Expression)"
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '>, <, ==, >=, <=, !='
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          'and, or, not'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "h3",
        null,
        "\u7A97\u53E3(Window)"
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h4",
          null,
          "\u957F\u5EA6\u7A97\u53E3"
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          "window 10"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h4",
          null,
          "\u65F6\u95F4\u7A97\u53E3"
        ),
        "\u652F\u6301",
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "ul",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "sec"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "min"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "hour"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "day"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          "window 10 sec"
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          "window 10 min"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "h3",
        null,
        "\u805A\u5408\u7C7B\u578B(Agg)"
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "ul",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "sum"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "avg"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "max"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "min"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "count"
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "h3",
        null,
        "\u901A\u77E5\u7EA7\u522B\uFF08Level\uFF09"
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "seciton",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "ul",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "info"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "warn"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "error"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "success"
          )
        )
      )
    );
  };

  AddFlowHelp.renderEn = function renderEn(locale) {
    var tooltip = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Tooltip"],
      { id: "flow-en" },
      "Docs"
    );
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "h3",
        null,
        "Rule Examples:Single  Branch\xA0",
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["OverlayTrigger"],
          { placement: "top", overlay: tooltip },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
            { onClick: function onClick() {
                window.open("https://loraflow.io/static/docs/" + locale + "/application/Flow.html");
              } },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-question-circle" })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h4",
          null,
          "When the temperature(DataPoint temperature) is greater than 30 degree, send notifications."
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          'temperature | temperature > 30 | warn "#deveui temperature is higher than 30 degree" -> test@aisenz.com'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h4",
          null,
          "When 10 successive temperatures which greater than 30 degree observed, send notifications."
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          'temperature | temperature > 30 | repeat 10 | error "#deveui is higher than 30 degree for 10 times" -> test@aisenz.com'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h4",
          null,
          "Calculate the average of the latest 10 temperature records and send notifications."
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          'temperature | window 10 | avg as avgtemperature | info "#avgtemperature" -> test@aisenz.com'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h4",
          null,
          "If the average temperate in 30 minutes is greater than 35, send notifications."
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          'temperature | window 30 min | avg as avgtemperature | avgtemperature > 35 | warn " #deveui the average temperature in 30 minutes is higher than 35 degree" -> test@aisenz.com'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h4",
          null,
          "If a abonormal status observed(0 is normal\uFF0C1 is abnormal), send notifications."
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          'DeviceStatus | 0 -> 1 | warn " #deveui abnormal status " -> test@aisenz.com'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h4",
          null,
          "When status restored, send notifications."
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          'DeviceStatus | 1 -> 0 | success " #deveui status restored " -> test@aisenz.com'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h4",
          null,
          "Check temperature and humidity at the same time. Send notifications if the temperature is above 30 and the humidity is above 65."
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|change temperature <=30 or humidity<=65 -> temperature>30 and humidity>65'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|error  "temperaturehe temperature and humidity are over standard"  -> test@aisenz.com'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "h3",
        null,
        "Rule Examples:Multi Branch"
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h4",
          null,
          "if the temperature rises from 30 degrees or less to 30 degrees or more, the temperature is notified too high; If the temperature drops below 30 degrees, the temperature is notified to return to normal."
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          'temperature'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|if'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|change temperature <30 -> temperature >=30'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|error "temperatureemperature is too high"  -> test@aisenz.com'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|if'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|change temperature >=30 -> temperature <30'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|success "temperaturehe temperature returned to normal" -> test@aisenz.com'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h4",
          null,
          "If a abonormal status observed(0 is normal\uFF0C1 is abnormal), send notifications; When status restored, send notifications."
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          'DeviceStatus'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|if'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|0 -> 1'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|warn " #deveui abnormal status " -> test@aisenz.com'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|if'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|1 -> 0'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|success " #deveui status restored " -> test@aisenz.com'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h4",
          null,
          "temperaturehe data connection status is detected in 2 hour cycles. If the device fails to upload data during the two detection cycle, the loss of notification is sent; if the device data is received, a loss recovery notification is sent."
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          'DeviceStatus'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|if'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|timeout 2 hour'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|error " Lost connection：device[#deveui]" ->test@aisenz.com'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|if'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|recover'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '|success " Resume connection：device[#deveui]" ->test@aisenz.com'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "h3",
        null,
        "Expression"
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          '>, <, ==, >=, <=, !='
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          'and, or, not'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "h3",
        null,
        "Window"
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h4",
          null,
          "length window"
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          "window 10"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h4",
          null,
          "time window"
        ),
        "Supported:",
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "ul",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "sec"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "min"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "hour"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "day"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          "window 10 sec"
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          "window 10 min"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "h3",
        null,
        "Aggregation"
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "section",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "ul",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "sum"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "avg"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "max"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "min"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "count"
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "h3",
        null,
        "Level"
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "seciton",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "ul",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "info"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "warn"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "error"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            "success"
          )
        )
      )
    );
  };

  function AddFlowHelp(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AddFlowHelp);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      locale: props.locale,
      highlight: props.highlight
    };
    return _this;
  }

  AddFlowHelp.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var locale = nextProps.locale,
        highlight = nextProps.highlight;

    if (locale !== this.props.locale) {
      this.setState({ locale: locale });
    }
    if (highlight !== this.props.highlight) {
      this.setState({ highlight: highlight });
      if (highlight) {
        _.delay(function () {
          return _this2.props.onHighlightExited();
        }, 1000);
      }
    }
  };

  AddFlowHelp.prototype.render = function render() {
    var _state = this.state,
        locale = _state.locale,
        _state$highlight = _state.highlight,
        highlight = _state$highlight === undefined ? false : _state$highlight;


    var content = void 0;
    if (locale === 'zh') {
      content = AddFlowHelp.renderZh(locale);
    } else {
      content = AddFlowHelp.renderEn(locale);
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.help + " " + (highlight ? __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.highlight : '') },
      content
    );
  };

  return AddFlowHelp;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

AddFlowHelp.propTypes = propTypes;
AddFlowHelp.defaultProps = defaultProps;

var mapStatetemperatureoProps = function mapStatetemperatureoProps(state) {
  return {
    locale: state.intl.locale
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStatetemperatureoProps, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(AddFlowHelp)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_esprima__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_esprima___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_esprima__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScriptSample_styles_scss__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScriptSample_styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ScriptSample_styles_scss__);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var Highlight = function Highlight(props) {
  var tokens = __WEBPACK_IMPORTED_MODULE_1_esprima___default.a.tokenize(props.code, {
    range: true,
    comment: true
  });

  var pos = 0;
  var spans = _.flatMap(tokens, function (token) {
    var _token$range = token.range,
        start = _token$range[0],
        end = _token$range[1];

    var fragments = void 0;
    if (start === pos) {
      fragments = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { key: start, className: __WEBPACK_IMPORTED_MODULE_2__ScriptSample_styles_scss___default.a[token.type] },
        props.code.substring(start, end)
      )];
    } else {
      fragments = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { key: pos },
        props.code.substring(pos, start)
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { key: start, className: __WEBPACK_IMPORTED_MODULE_2__ScriptSample_styles_scss___default.a[token.type] },
        props.code.substring(start, end)
      )];
    }
    pos = end;
    return fragments;
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    spans
  );
};

Highlight.propTypes = {
  code: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Highlight);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_draft_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_draft_js__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var Line = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Line, _React$Component);

  function Line() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Line);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Line.prototype.render = function render() {
    var blockMap = this.props.contentState.getBlockMap().toArray();
    var blockKey = this.props.block.key;
    var lineNumber = blockMap.findIndex(function (block) {
      return blockKey === block.key;
    }) + 1;
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { style: { display: 'flex' } },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "span",
        { style: { marginRight: '5px' } },
        lineNumber
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { style: { flex: '1' } },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_draft_js__["EditorBlock"], this.props)
      )
    );
  };

  return Line;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Line);

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loraactions_adr__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_PageLoading__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_PageError__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loracoms_TablePager__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_loracoms_SelectPills__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_loracoms_Select__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lorautils_api_status__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_loraapi_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__DynamicChart__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__styles_scss__ = __webpack_require__(2229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



























var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  getNodeAdr: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  getNodeAdrLogs: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  nodeAdr: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  nodeAdrLogs: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  deviceState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  appState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  replaceState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired
};

var formatters = function formatters(vl) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    "span",
    null,
    vl,
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "span",
      { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.infos },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "span",
        { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.info },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-angle-left" }),
        "MaxEIRP",
        vl > 0 ? vl * -2 + "dB" : '',
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-angle-right" })
      )
    )
  );
};

var kAU915 = 'AU915';
var kDrOptions = _.map(_.range(6), function (i) {
  return { label: i, value: i };
});
var kAU915Dr = _.map(_.range(7), function (i) {
  return { label: i, value: i };
});
var kMarginOptions = _.map(_.range(1, 21), function (i) {
  return { label: i, value: i };
});
var kPowerOptions = _.map(_.range(8), function (i) {
  return {
    label: i,
    value: i,
    formatter: function formatter() {
      return formatters(i);
    }
  };
});
var kAU915Power = _.map(_.range(11), function (i) {
  return {
    label: i,
    value: i,
    formatter: function formatter() {
      return formatters(i);
    }
  };
});

var ADRView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ADRView, _React$Component);

  function ADRView(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ADRView);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    var nodeAdr = props.nodeAdr;

    _this.state = {
      nodeAdr: nodeAdr,
      nodeAdrLogs: props.nodeAdrLogs,
      deviceState: props.deviceState,
      appState: props.appState,
      errors: __WEBPACK_IMPORTED_MODULE_24_lorautils_errors_ErrorSet__["a" /* default */].createEmpty(),
      mindr: nodeAdr.data ? nodeAdr.data.mindr : undefined,
      maxdr: nodeAdr.data ? nodeAdr.data.maxdr : undefined,
      editMax: false,
      editMin: false
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_22_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.adrview');
    _this.handlePrev = _this.handlePrev.bind(_this);
    _this.handleNext = _this.handleNext.bind(_this);
    _this.handleCancelEditMax = _this.handleCancelEditMax.bind(_this);
    _this.handleCancelEditMin = _this.handleCancelEditMin.bind(_this);
    _this.handleChangeMaxDR = _this.handleChangeMaxDR.bind(_this);
    _this.handleChangeMinDR = _this.handleChangeMinDR.bind(_this);
    _this.handleSubmitValue = _this.handleSubmitValue.bind(_this);
    return _this;
  }

  ADRView.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        deviceId = _props.deviceId,
        getNodeAdr = _props.getNodeAdr,
        getNodeAdrLogs = _props.getNodeAdrLogs;

    getNodeAdr(deviceId);
    getNodeAdrLogs(deviceId);
  };

  ADRView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nodeAdr = nextProps.nodeAdr,
        nodeAdrLogs = nextProps.nodeAdrLogs,
        deviceState = nextProps.deviceState,
        appState = nextProps.appState;

    if (nodeAdr !== this.props.nodeAdr) {
      this.setState({ nodeAdr: nodeAdr });
      if (nodeAdr.data) {
        var _nodeAdr$data = nodeAdr.data,
            mindr = _nodeAdr$data.mindr,
            maxdr = _nodeAdr$data.maxdr;

        this.setState({ mindr: mindr, maxdr: maxdr });
      }
    }
    if (nodeAdrLogs !== this.props.nodeAdrLogs) {
      this.setState({ nodeAdrLogs: nodeAdrLogs });
      if (nodeAdrLogs.status === 'success') {
        this.setState({
          list: nodeAdrLogs.data.list,
          mark: nodeAdrLogs.data.mark,
          more: nodeAdrLogs.data.more
        });
      }
    }
    if (deviceState !== this.props.deviceState) {
      this.setState({ deviceState: deviceState });
    }
    if (appState !== this.props.appState) {
      this.setState({ appState: appState });
    }
  };

  ADRView.prototype.handlePrev = function handlePrev(mark) {
    var _props2 = this.props,
        deviceId = _props2.deviceId,
        getNodeAdrLogs = _props2.getNodeAdrLogs;

    getNodeAdrLogs(deviceId, { mark: mark });
  };

  ADRView.prototype.handleNext = function handleNext(mark) {
    var _props3 = this.props,
        deviceId = _props3.deviceId,
        getNodeAdrLogs = _props3.getNodeAdrLogs;

    getNodeAdrLogs(deviceId, { mark: mark });
  };

  ADRView.prototype.handleToggleAdr = function handleToggleAdr(selected) {
    var disabled = selected !== 'on';
    var deviceId = this.props.deviceId;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_loraapi_callAPI__["a" /* default */])({ endpoint: "/lora/nodes/" + deviceId + "/adr", method: 'PUT', query: {}, body: { disabled: disabled } }).then(function () {}).catch(function () {});
  };

  ADRView.prototype.handleCancelEditMax = function handleCancelEditMax() {
    var errors = this.state.errors;

    this.setState({
      editMax: false,
      errors: errors.remove('maxdr')
    });
  };

  ADRView.prototype.handleCancelEditMin = function handleCancelEditMin() {
    var errors = this.state.errors;

    this.setState({
      editMin: false,
      errors: errors.remove('mindr')
    });
  };

  ADRView.prototype.handleChangeMaxDR = function handleChangeMaxDR(maxdr) {
    var _state = this.state,
        mindr = _state.mindr,
        errors = _state.errors;

    this.setState({ maxdr: maxdr });

    if (!_.isNil(mindr)) {
      if (maxdr < mindr) {
        this.setState({
          errors: errors.add('FE_MINGTMAX', 'mindr').add('FE_MINGTMAX', 'maxdr')
        });
      } else {
        this.setState({
          errors: errors.remove('mindr').remove('maxdr')
        });
      }
    } else {
      this.setState({
        errors: errors.remove('maxdr')
      });
    }
  };

  ADRView.prototype.handleChangeMinDR = function handleChangeMinDR(mindr) {
    var _state2 = this.state,
        maxdr = _state2.maxdr,
        errors = _state2.errors;

    this.setState({ mindr: mindr });

    if (!_.isNil(maxdr)) {
      if (maxdr < mindr) {
        this.setState({
          errors: errors.add('FE_MINGTMAX', 'mindr').add('FE_MINGTMAX', 'maxdr')
        });
      } else {
        this.setState({
          errors: errors.remove('mindr').remove('maxdr')
        });
      }
    } else {
      this.setState({
        errors: errors.remove('mindr')
      });
    }
  };

  ADRView.prototype.handleSubmitValue = function handleSubmitValue(key, callback) {
    var _body,
        _this2 = this;

    var _state3 = this.state,
        errors = _state3.errors,
        nodeAdr = _state3.nodeAdr;
    var deviceId = this.props.deviceId;

    var value = this.state[key];
    if (_.isNil(value) || errors.has(key)) {
      return;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_loraapi_callAPI__["a" /* default */])({
      endpoint: "/lora/nodes/" + deviceId + "/adr",
      method: 'PUT',
      body: (_body = {}, _body[key] = value, _body)
    }).then(function () {
      var _extends2;

      if (callback) {
        callback();
      }
      _this2.setState({
        nodeAdr: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, nodeAdr, { data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, nodeAdr.data, (_extends2 = {}, _extends2[key] = value, _extends2)) })
      });
    }).catch(function (err) {
      _this2.setState({ errors: errors.add(err.code, key) });
    });
  };

  ADRView.prototype.handleSubmitReset = function handleSubmitReset() {
    var _this3 = this;

    this.setState({ resetStatus: 'pending' });
    var deviceId = this.props.deviceId;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_loraapi_callAPI__["a" /* default */])({
      endpoint: "/lora/nodes/" + deviceId + "/adr/reset",
      method: 'POST'
    }).then(function () {
      _this3.setState({ resetStatus: 'success' });
    }).catch(function () {
      _this3.setState({ resetStatus: 'failure' });
    });
  };

  ADRView.prototype.renderAdr = function renderAdr() {
    var _this4 = this;

    var _state4 = this.state,
        nodeAdr = _state4.nodeAdr.data,
        errors = _state4.errors,
        editMax = _state4.editMax,
        editMin = _state4.editMin,
        _state4$editMargin = _state4.editMargin,
        editMargin = _state4$editMargin === undefined ? false : _state4$editMargin,
        _state4$editPower = _state4.editPower,
        editPower = _state4$editPower === undefined ? false : _state4$editPower,
        _state4$deviceState$d = _state4.deviceState.data;
    _state4$deviceState$d = _state4$deviceState$d === undefined ? {} : _state4$deviceState$d;
    var band = _state4$deviceState$d.band;

    var drOpts = band === kAU915 ? kAU915Dr : kDrOptions;
    var powerOpts = band === kAU915 ? kAU915Power : kPowerOptions;
    var options = [{ name: this.intlMsg.msg('switch.on'), value: 'on', active: !nodeAdr.disabled }, { name: this.intlMsg.msg('switch.off'), value: 'off', active: nodeAdr.disabled }];
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white" },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.title },
              this.intlMsg.msg('adrstatus.confirmed.title')
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_loracoms_SelectPills__["a" /* default */], {
              options: options,
              onChange: function onChange(selected) {
                return _this4.handleToggleAdr(selected[0]);
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.adapt },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.label },
              "Min DR:"
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
              { "if": editMin },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.selectArea },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_loracoms_Select__["a" /* default */], {
                    value: nodeAdr.mindr,
                    options: drOpts,
                    onChange: this.handleChangeMinDR
                  }),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_loracoms_ControlTips__["a" /* default */], {
                    show: errors.has('mindr'),
                    message: this.intlMsg.errorMsg(errors.get('mindr')),
                    azStyle: "danger",
                    placement: "top"
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.actions },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                    {
                      onClick: function onClick() {
                        return _this4.handleSubmitValue('mindr', function () {
                          _this4.setState({ editMin: false });
                        });
                      },
                      className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.ok
                    },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-ok" })
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                    { onClick: this.handleCancelEditMin, className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.cancel },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-remove" })
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
              { "if": !editMin },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "span",
                null,
                nodeAdr.mindr
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
              { "if": !editMin },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                { onClick: function onClick() {
                    return _this4.setState({ editMin: true });
                  }, className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.edit },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-pencil " + __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.gray })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.adapt },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.label },
              "Max DR:"
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
              { "if": editMax },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.selectArea },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_loracoms_Select__["a" /* default */], {
                    value: nodeAdr.maxdr,
                    options: drOpts,
                    onChange: this.handleChangeMaxDR
                  }),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_loracoms_ControlTips__["a" /* default */], {
                    show: errors.has('maxdr'),
                    message: this.intlMsg.errorMsg(errors.get('maxdr')),
                    azStyle: "danger",
                    placement: "top"
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.actions },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                    {
                      onClick: function onClick() {
                        return _this4.handleSubmitValue('maxdr', function () {
                          _this4.setState({ editMax: false });
                        });
                      },
                      className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.ok
                    },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-ok" })
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                    { onClick: this.handleCancelEditMax, className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.cancel },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-remove" })
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
              { "if": !editMax },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "span",
                null,
                nodeAdr.maxdr
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
              { "if": !editMax },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                { onClick: function onClick() {
                    return _this4.setState({ editMax: true });
                  }, className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.edit },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-pencil " + __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.gray })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.adapt },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.label },
              "Min Power:"
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
              { "if": editPower },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.selectArea },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_loracoms_Select__["a" /* default */], {
                    value: nodeAdr.minpower,
                    options: powerOpts,
                    onChange: function onChange(minpower) {
                      return _this4.setState({
                        minpower: minpower,
                        errors: errors.remove('minpower')
                      });
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_loracoms_ControlTips__["a" /* default */], {
                    show: errors.has('minpower'),
                    message: this.intlMsg.errorMsg(errors.get('minpower')),
                    azStyle: "danger",
                    placement: "top"
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.actions },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                    {
                      onClick: function onClick() {
                        return _this4.handleSubmitValue('minpower', function () {
                          _this4.setState({ editPower: false });
                        });
                      },
                      className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.ok
                    },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-ok" })
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                    {
                      onClick: function onClick() {
                        return _this4.setState({ editPower: false });
                      },
                      className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.cancel
                    },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-remove" })
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
              { "if": !editPower },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "span",
                null,
                nodeAdr.minpower
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
              { "if": !editPower },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                { onClick: function onClick() {
                    return _this4.setState({ editPower: true });
                  }, className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.edit },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-pencil " + __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.gray })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.adapt },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.label },
              "Margin:"
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
              { "if": editMargin },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.selectArea },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_loracoms_Select__["a" /* default */], {
                    value: nodeAdr.margin,
                    options: kMarginOptions,
                    onChange: function onChange(margin) {
                      return _this4.setState({ margin: margin });
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_loracoms_ControlTips__["a" /* default */], {
                    show: errors.has('margin'),
                    message: this.intlMsg.errorMsg(errors.get('margin')),
                    azStyle: "danger",
                    placement: "top"
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.actions },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                    {
                      onClick: function onClick() {
                        return _this4.handleSubmitValue('margin', function () {
                          _this4.setState({ editMargin: false });
                        });
                      },
                      className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.ok
                    },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-ok" })
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                    {
                      onClick: function onClick() {
                        return _this4.setState({ editMargin: false });
                      },
                      className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.cancel
                    },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-remove" })
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
              { "if": !editMargin },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "span",
                null,
                nodeAdr.margin || nodeAdr.default.margin
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
              { "if": !editMargin },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                { onClick: function onClick() {
                    return _this4.setState({ editMargin: true });
                  }, className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.edit },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-pencil " + __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.gray })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["HelpBlock"],
              { className: "aisz-help-block" },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-info-circle" }),
              "\xA0",
              this.intlMsg.msg('margin.tips')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__DynamicChart__["a" /* default */], { adr: nodeAdr })
        )
      )
    );
  };

  ADRView.prototype.renderAdrLogs = function renderAdrLogs() {
    var _this5 = this;

    var _state5 = this.state,
        _state5$list = _state5.list,
        list = _state5$list === undefined ? [] : _state5$list,
        _state5$mark = _state5.mark,
        mark = _state5$mark === undefined ? '' : _state5$mark,
        _state5$more = _state5.more,
        more = _state5$more === undefined ? false : _state5$more,
        nodeAdrLogs = _state5.nodeAdrLogs;


    var rows = list.map(function (item, idx) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "tr",
        { key: item.appeui + "-" + item.deveui + "-" + item.$time + "-" + String(idx) },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(new Date(item.$time), 'YYYY-MM-DD HH:mm:ss')
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_RichLabel__["a" /* default */], {
            content: item.event,
            enums: [{
              content: 'manual',
              translate: _this5.intlMsg.msg('adr.event.manual'),
              theme: 'blue'
            }, {
              content: 'confirm',
              translate: _this5.intlMsg.msg('adr.event.confirm'),
              theme: 'green'
            }, {
              content: 'reject',
              translate: _this5.intlMsg.msg('adr.event.reject'),
              theme: 'red'
            }, {
              content: 'info',
              translate: _this5.intlMsg.msg('adr.event.info'),
              theme: 'blue'
            }, {
              content: 'warning',
              translate: _this5.intlMsg.msg('adr.event.warning'),
              theme: 'yellow'
            }, {
              content: 'error',
              translate: _this5.intlMsg.msg('adr.event.error'),
              theme: 'red'
            }, {
              content: 'auto',
              translate: _this5.intlMsg.msg('adr.event.auto'),
              theme: 'blue'
            }]
          })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          item.dr
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          item.power
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_Nvl__["a" /* default */], { val: item.margin })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_Nvl__["a" /* default */], { val: item.message })
        )
      );
    });

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: this.intlMsg.msg('adrlogs.panelheader') },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.adrlogs },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Table"],
          { className: "aisz-table-light", responsive: true },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('adr.data.time')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('adr.data.event')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('adr.data.dr')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('adr.data.power')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('adr.data.margin')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('adr.data.message')
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "tbody",
            null,
            rows
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.pager },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_TablePager__["a" /* default */], {
          mark: mark,
          more: more,
          status: nodeAdrLogs.status,
          onPrev: this.handlePrev,
          onNext: this.handleNext
        })
      )
    );
  };

  ADRView.prototype.renderContent = function renderContent() {
    var _this6 = this;

    var _state$resetStatus = this.state.resetStatus,
        resetStatus = _state$resetStatus === undefined ? '' : _state$resetStatus;
    var _props4 = this.props,
        pushState = _props4.pushState,
        appId = _props4.appId,
        deviceId = _props4.deviceId,
        replaceState = _props4.replaceState;
    var _state6 = this.state,
        _state6$deviceState = _state6.deviceState,
        _state6$deviceState$d = _state6$deviceState.data;
    _state6$deviceState$d = _state6$deviceState$d === undefined ? {} : _state6$deviceState$d;
    var name = _state6$deviceState$d.name,
        status = _state6$deviceState.status,
        _state6$appState = _state6.appState,
        _state6$appState$data = _state6$appState.data;
    _state6$appState$data = _state6$appState$data === undefined ? {} : _state6$appState$data;
    var appName = _state6$appState$data.name,
        appStatus = _state6$appState.status;

    var breadcrumb = [{
      content: this.intlMsg.msg('application.breadcrumb.application', ''),
      onClick: function onClick() {
        return pushState('/application');
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_Nvl__["a" /* default */], { val: appName, status: appStatus }),
      onClick: function onClick() {
        return replaceState("/application/" + appId);
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_Nvl__["a" /* default */], { val: name || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_lorautils_IdUtils__["a" /* normalizeDevEUI */])(deviceId), status: status }),
      active: true
    }];

    var rightTools = [{
      type: 'buttons',
      buttons: [__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
        {
          bsStyle: "aisz-danger",
          style: { marginLeft: '30px' },
          onClick: function onClick() {
            return _this6.handleSubmitReset();
          }
        },
        this.intlMsg.msg('switch.reset'),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
          { "if": resetStatus === 'pending' },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.loading + " " + __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.resetLoad },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
          { "if": resetStatus === 'success' },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: 'fa fa-check' + " " + __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.resetLoad })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
          { "if": resetStatus === 'failure' },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: 'fa fa-exclamation' + " " + __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.resetLoad })
        )
      )]
    }];

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb, rightTools: rightTools })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
          { md: 12 },
          this.renderAdr(),
          this.renderAdrLogs()
        )
      )
    );
  };

  ADRView.prototype.render = function render() {
    var _state7 = this.state,
        nodeAdr = _state7.nodeAdr,
        nodeAdrLogs = _state7.nodeAdrLogs,
        deviceState = _state7.deviceState;

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_lorautils_api_status__["c" /* someFailure */])(nodeAdr, nodeAdrLogs, deviceState)) {
      var failOne = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_lorautils_api_status__["d" /* findFailure */])(nodeAdr, nodeAdrLogs, deviceState);
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_PageError__["a" /* default */], { title: this.intlMsg.errorMsg(failOne.error.code) });
    }
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_lorautils_api_status__["a" /* allSuccess */])(deviceState, nodeAdr)) {
      return this.renderContent();
    }
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_PageLoading__["a" /* default */], null);
  };

  return ADRView;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ADRView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    nodeAdr: state.adr.getNodeAdr || {},
    nodeAdrLogs: state.adr.getNodeAdrLogs || {},
    deviceState: state.device.getDevice || {},
    appState: state.app.getApp || {},
    appId: ownProps.params.appId,
    deviceId: ownProps.params.deviceId
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push,
  replaceState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].replace,
  getNodeAdr: __WEBPACK_IMPORTED_MODULE_11_loraactions_adr__["a" /* default */].getNodeAdr,
  getNodeAdrLogs: __WEBPACK_IMPORTED_MODULE_11_loraactions_adr__["a" /* default */].getNodeAdrLogs
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(ADRView)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_PageLoading__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_PageNoPerm__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracfg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__coms_SendData__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__coms_ResetSeq__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__coms_ParsedData__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss__ = __webpack_require__(2233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DeviceData__ = __webpack_require__(435);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  deviceState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  appState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  plan: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  replaceState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var DataToolView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DataToolView, _React$Component);

  function DataToolView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DataToolView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      deviceState: props.deviceState,
      appState: props.appState,
      plan: props.plan,
      view: 'datanews'
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.datatoolview');
    return _this;
  }

  DataToolView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var deviceState = nextProps.deviceState,
        plan = nextProps.plan,
        appState = nextProps.appState;

    if (deviceState !== this.props.deviceState) {
      this.setState({ deviceState: deviceState });
    }
    if (appState !== this.props.appState) {
      this.setState({ appState: appState });
    }
    if (plan !== this.props.plan) {
      this.setState({ plan: plan });
    }
  };

  DataToolView.prototype.handleSelect = function handleSelect(view) {
    this.setState({ view: view });
  };

  DataToolView.prototype.renderToolbar = function renderToolbar() {
    var _props = this.props,
        pushState = _props.pushState,
        appId = _props.appId,
        deviceId = _props.deviceId,
        replaceState = _props.replaceState;
    var _state = this.state,
        _state$deviceState = _state.deviceState,
        _state$deviceState$da = _state$deviceState.data,
        device = _state$deviceState$da === undefined ? {} : _state$deviceState$da,
        status = _state$deviceState.status,
        _state$appState = _state.appState,
        _state$appState$data = _state$appState.data;
    _state$appState$data = _state$appState$data === undefined ? {} : _state$appState$data;
    var appName = _state$appState$data.name,
        appStatus = _state$appState.status;

    var breadcrumb = [{
      content: this.intlMsg.msg('breadcrumb.application', 'application'),
      onClick: function onClick() {
        return pushState('/application');
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Nvl__["a" /* default */], { val: appName, status: appStatus }),
      onClick: function onClick() {
        return replaceState("/application/" + appId);
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Nvl__["a" /* default */], { val: device.name || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_lorautils_IdUtils__["a" /* normalizeDevEUI */])(deviceId), status: status }),
      active: true
    }];
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  DataToolView.prototype.renderTools = function renderTools() {
    var deviceId = this.props.deviceId;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.tools },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Tab"].Container,
        { id: "datatools", defaultActiveKey: "senddata" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
          { className: "clearfix" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Nav"],
              { bsStyle: "aisz-tabs" },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["NavItem"],
                { eventKey: "senddata" },
                this.intlMsg.msg('tab.senddata')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["NavItem"],
                { eventKey: "resetseq" },
                this.intlMsg.msg('tab.lorawanseq')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Tab"].Content,
              { animation: true, className: "aisz-tab-content-white" },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Tab"].Pane,
                { eventKey: "senddata" },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.toolWrapper },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__coms_SendData__["a" /* default */], { deviceId: deviceId })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Tab"].Pane,
                { eventKey: "resetseq" },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.toolWrapper },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__coms_ResetSeq__["a" /* default */], { deviceId: deviceId })
                )
              )
            )
          )
        )
      )
    );
  };

  DataToolView.prototype.renderData = function renderData() {
    var _this2 = this;

    var view = this.state.view;
    var _props2 = this.props,
        deviceId = _props2.deviceId,
        appId = _props2.appId;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.tools },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Tab"].Container,
        { id: "news_container", defaultActiveKey: "datanews" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
          { className: "clearfix" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Nav"],
              { bsStyle: "aisz-tabs" },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["NavItem"],
                { eventKey: "datanews", onSelect: function onSelect(e) {
                    return _this2.handleSelect(e);
                  } },
                this.intlMsg.msg('data.header', 'devicedetail')
              ),
              __WEBPACK_IMPORTED_MODULE_13_loracfg__["a" /* default */].profile === 'cloud' && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["NavItem"],
                { eventKey: "parsenews", onSelect: function onSelect(e) {
                    return _this2.handleSelect(e);
                  } },
                this.intlMsg.msg('parsed.header', 'devicedetail')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Tab"].Content,
              { animation: true, className: "aisz-tab-content-white" },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Tab"].Pane,
                { eventKey: "datanews" },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__DeviceData__["a" /* default */], { deviceId: deviceId })
              ),
              __WEBPACK_IMPORTED_MODULE_13_loracfg__["a" /* default */].profile === 'cloud' && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Tab"].Pane,
                { eventKey: "parsenews" },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__coms_ParsedData__["a" /* default */], { deveui: deviceId, appId: appId, load: view === 'parsenews' })
              )
            )
          )
        )
      )
    );
  };

  DataToolView.prototype.render = function render() {
    var plan = this.state.plan;

    if (plan.status !== 'success') {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_PageLoading__["a" /* default */], null);
    }

    if (plan.data.tier === 1) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_PageNoPerm__["a" /* default */], null);
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
          { md: 12 },
          this.renderToolbar()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
          { md: 12 },
          this.renderTools()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
          { md: 12 },
          this.renderData()
        )
      )
    );
  };

  return DataToolView;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DataToolView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    deviceState: state.device.getDevice,
    appState: state.app.getApp,
    plan: state.billing.plan,
    deviceId: ownProps.params.deviceId,
    appId: ownProps.params.appId
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_5_react_router_redux__["routerActions"].push,
  replaceState: __WEBPACK_IMPORTED_MODULE_5_react_router_redux__["routerActions"].replace
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(DataToolView)));

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, moment) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_aisztheme_sass_animate_scss__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_aisztheme_sass_animate_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_aisztheme_sass_animate_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_RichForm__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_Refresher__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_PageSizer__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loracoms_CollapseToggle__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lorautils_Validators__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_loraapi_lora_device__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_scss__ = __webpack_require__(2240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__coms_RingSwitcher__ = __webpack_require__(1242);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);























var kRegisterOpts = _.map(_.range(1, 255), function (i) {
  return { value: "r" + i, label: "r" + i };
});
var propTypes = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.any.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.string.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.string.isRequired,
  deviceState: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.object.isRequired,
  appState: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.object.isRequired,
  replaceState: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.func.isRequired
};

var LRAPView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LRAPView, _React$Component);

  function LRAPView(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LRAPView);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      deviceState: props.deviceState,
      appState: props.appState,
      showHelpDoc: false,
      status: 'idle'
    };
    _this.handleWriteSubmit = _this.handleWriteSubmit.bind(_this);
    _this.handleReadSubmit = _this.handleReadSubmit.bind(_this);
    _this.loadLogs = _this.loadLogs.bind(_this);
    _this.handleReloadLogs = _this.handleReloadLogs.bind(_this);
    _this.handleChangePageSize = _this.handleChangePageSize.bind(_this);
    _this.handleChangeValue = _this.handleChangeValue.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_21_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.lrapview');
    return _this;
  }

  LRAPView.prototype.componentDidMount = function componentDidMount() {
    this.loadLogs();
  };

  LRAPView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var deviceState = nextProps.deviceState,
        appState = nextProps.appState;

    if (deviceState !== this.props.deviceState) {
      this.setState({ deviceState: deviceState });
    }
    if (appState !== this.props.appState) {
      this.setState({ appState: appState });
    }
  };

  LRAPView.prototype.loadLogs = function loadLogs() {
    var _this2 = this;

    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var nargs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      pageSize: this.state.pageSize
    }, args);
    var cb = nargs.cb,
        _nargs$pageSize = nargs.pageSize,
        pageSize = _nargs$pageSize === undefined ? 20 : _nargs$pageSize;
    var deviceId = this.props.deviceId;

    this.setState({ status: 'loading' });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_loraapi_lora_device__["a" /* getRegisterLogs */])(deviceId, { limit: pageSize }).then(function (resp) {
      _this2.setState({
        logs: resp.body.list,
        status: 'success'
      });
      if (cb) {
        cb();
      }
    }).catch(function () {
      if (cb) {
        cb();
      }
      _this2.setState({
        status: 'failure'
      });
    });
  };

  LRAPView.prototype.handleReloadLogs = function handleReloadLogs() {
    var _this3 = this;

    this.setState({
      logsReloading: true
    });
    this.loadLogs({
      cb: function cb() {
        _this3.setState({
          logsReloading: false
        });
      }
    });
  };

  LRAPView.prototype.handleWriteSubmit = function handleWriteSubmit(data) {
    var _this4 = this;

    var deviceId = this.props.deviceId;
    var valueFormat = this.state.valueFormat;
    var port = data.port,
        register = data.register,
        value = data.value;

    if (this.writeStatusTimeout) {
      clearTimeout(this.writeStatusTimeout);
    }

    var numv = void 0;
    if (valueFormat === 'HEX') {
      numv = parseInt(value.substr(2), 16);
    } else if (valueFormat === 'BIN') {
      numv = parseInt(value.substr(2), 2);
    } else {
      numv = parseInt(value, 10);
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_loraapi_lora_device__["b" /* writeRegister */])(deviceId, Number(port), register, numv).then(function () {
      _this4.setState({ writeStatus: 'success' });
      _this4.writeStatusTimeout = setTimeout(function () {
        _this4.setState({ writeStatus: '' });
      }, 3000);
    }).catch(function () {
      _this4.setState({ writeStatus: 'error' });
      _this4.writeStatusTimeout = setTimeout(function () {
        _this4.setState({ writeStatus: '' });
      }, 3000);
    });
  };

  LRAPView.prototype.handleReadSubmit = function handleReadSubmit(data) {
    var _this5 = this;

    var deviceId = this.props.deviceId;
    var port = data.port,
        register = data.register;

    if (this.readStatusTimeout) {
      clearTimeout(this.readStatusTimeout);
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_loraapi_lora_device__["c" /* readRegister */])(deviceId, Number(port), register).then(function () {
      _this5.setState({ readStatus: 'success' });
      _this5.readStatusTimeout = setTimeout(function () {
        _this5.setState({ readStatus: '' });
      }, 3000);
    }).catch(function () {
      _this5.setState({ readStatus: 'error' });
      setTimeout(function () {
        _this5.setState({ readStatus: '' });
      }, 3000);
    });
  };

  LRAPView.prototype.handleChangePageSize = function handleChangePageSize(pageSize) {
    this.setState({ pageSize: pageSize });
    this.loadLogs({ pageSize: pageSize });
  };

  LRAPView.prototype.handleChangeValue = function handleChangeValue(v) {
    if (_.startsWith(v, '0x')) {
      this.setState({ valueFormat: 'HEX' });
    } else if (_.startsWith(v, '0b')) {
      this.setState({ valueFormat: 'BIN' });
    } else {
      this.setState({ valueFormat: null });
    }
  };

  LRAPView.prototype.renderToolbar = function renderToolbar() {
    var _this6 = this;

    var _props = this.props,
        appId = _props.appId,
        deviceId = _props.deviceId;
    var _state = this.state,
        _state$deviceState = _state.deviceState,
        _state$deviceState$da = _state$deviceState.data;
    _state$deviceState$da = _state$deviceState$da === undefined ? {} : _state$deviceState$da;
    var name = _state$deviceState$da.name,
        status = _state$deviceState.status,
        _state$appState = _state.appState,
        _state$appState$data = _state$appState.data;
    _state$appState$data = _state$appState$data === undefined ? {} : _state$appState$data;
    var appName = _state$appState$data.name,
        appStatus = _state$appState.status;


    var breadcrumb = [{
      content: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "span",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], { id: "application.breadcrumb.application" })
      ),
      onClick: function onClick() {
        return _this6.props.pushState('/application');
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_Nvl__["a" /* default */], { val: appName, status: appStatus }),
      onClick: function onClick() {
        return _this6.props.replaceState("/application/" + appId);
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_Nvl__["a" /* default */], { val: name || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_lorautils_IdUtils__["a" /* normalizeDevEUI */])(deviceId), status: status }),
      active: true
    }];

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  LRAPView.prototype.renderWriteTab = function renderWriteTab() {
    var fields = [{
      id: 'port',
      label: this.intlMsg.msg('port'),
      value: '223',
      placeholder: this.intlMsg.msg('port.placeholder'),
      validator: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_lorautils_Validators__["a" /* intValidator */])(1, 223)
    }, {
      id: 'register',
      type: 'search-selector',
      options: kRegisterOpts,
      label: this.intlMsg.msg('register'),
      placeholder: this.intlMsg.msg('register.placeholder'),
      validator: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_lorautils_Validators__["b" /* notEmptyValidator */])()
    }, {
      id: 'value',
      label: this.intlMsg.msg('value'),
      placeholder: this.intlMsg.msg('value.placeholder'),
      validator: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_lorautils_Validators__["c" /* orValidator */])([__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_lorautils_Validators__["a" /* intValidator */])(0, 4294967295), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_lorautils_Validators__["d" /* hexNumValidator */])(0, 4294967295), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_lorautils_Validators__["e" /* binNumValidator */])(0, 4294967295)]),
      inputLabel: this.state.valueFormat,
      onChange: this.handleChangeValue
    }];
    var writeStatus = this.state.writeStatus;


    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.tab },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_RichForm__["a" /* default */], {
        fields: fields,
        labelCols: 3,
        controlCols: 9,
        buttonLabel: this.intlMsg.msg('writesubmit.btn'),
        successButtonLabel: this.intlMsg.msg('writesubmit.btn.success'),
        errorButtonLabel: this.intlMsg.msg('writesubmit.btn.error'),
        onSubmit: this.handleWriteSubmit,
        submitStatus: writeStatus
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
          { mdOffset: 3, md: 9 },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Collapse"],
            { "in": writeStatus === 'success' },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.submitTips },
                this.intlMsg.msg('writesubmit.tips')
              )
            )
          )
        )
      )
    );
  };

  LRAPView.prototype.renderReadTab = function renderReadTab() {
    var fields = [{
      id: 'port',
      label: this.intlMsg.msg('port'),
      value: '223',
      placeholder: this.intlMsg.msg('port.placeholder'),
      validator: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_lorautils_Validators__["a" /* intValidator */])(1, 223)
    }, {
      id: 'register',
      type: 'search-selector',
      options: kRegisterOpts,
      label: this.intlMsg.msg('register'),
      placeholder: this.intlMsg.msg('register.placeholder'),
      validator: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_lorautils_Validators__["b" /* notEmptyValidator */])()
    }];
    var readStatus = this.state.readStatus;


    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.tab },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_RichForm__["a" /* default */], {
        fields: fields,
        labelCols: 3,
        controlCols: 9,
        buttonLabel: this.intlMsg.msg('readsubmit.btn'),
        successButtonLabel: this.intlMsg.msg('readsubmit.btn.success'),
        errorButtonLabel: this.intlMsg.msg('readsubmit.btn.error'),
        onSubmit: this.handleReadSubmit,
        submitStatus: readStatus
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
          { mdOffset: 3, md: 9 },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Collapse"],
            { "in": readStatus === 'success' },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.submitTips },
                this.intlMsg.msg('readsubmit.tips')
              )
            )
          )
        )
      )
    );
  };

  LRAPView.prototype.renderLogs = function renderLogs() {
    var _this7 = this;

    var _state2 = this.state,
        _state2$logs = _state2.logs,
        logs = _state2$logs === undefined ? [] : _state2$logs,
        _state2$pageSize = _state2.pageSize,
        pageSize = _state2$pageSize === undefined ? 20 : _state2$pageSize,
        _state2$displayFormat = _state2.displayFormat,
        displayFormat = _state2$displayFormat === undefined ? 'DEC' : _state2$displayFormat;


    var trs = _.flatMap(logs, function (l, i) {
      var log = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, l);
      if (log.op === 'read') {
        log.registers = log.registers.map(function (r) {
          return {
            key: r,
            val: ''
          };
        });
      } else {
        log.registers = _.map(log.registers, function (v, k) {
          return {
            key: k,
            val: v
          };
        });
      }
      var len = log.registers.length;

      var dir = void 0;
      if (log.op === 'read' || log.op === 'write') {
        dir = 'down';
      } else {
        dir = 'up';
      }

      return _.map(_.range(0, len), function (j) {
        var numv = Number(log.registers[j].val);
        if (displayFormat === 'HEX') {
          numv = numv === 0 ? '--' : "0x" + numv.toString(16);
        } else if (displayFormat === 'BIN') {
          numv = numv === 0 ? '--' : "0b" + numv.toString(2);
        } else if (numv === 0) {
          numv = '--';
        }
        if (j === 0) {
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "tr",
            { key: i + "-" + j },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "td",
              { rowSpan: len, className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a[dir] + " " + __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.dir },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("span", { className: "halflings halflings-direction-" + dir })
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "td",
              { rowSpan: len },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_RichLabel__["a" /* default */], {
                content: log.op,
                enums: [{
                  content: 'read',
                  theme: 'blue'
                }, {
                  content: 'write',
                  theme: 'green'
                }, {
                  content: 'trap',
                  theme: 'blue'
                }, {
                  content: 'except',
                  theme: 'red'
                }]
              })
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "td",
              { rowSpan: len },
              moment(log.$time).format('YYYY-MM-DD HH:mm:ss')
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "td",
              null,
              log.registers[j].key
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "td",
              null,
              numv
            )
          );
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "tr",
          { key: i + "-" + j },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "td",
            null,
            log.registers[j].key
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "td",
            null,
            numv
          )
        );
      });
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.logTable },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Table"],
          { className: "aisz-table-light", bordered: true, striped: true, hover: true, responsive: true },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("th", { style: { width: '30px' } }),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('op')
              ),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('optime')
              ),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('register')
              ),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('payload'),
                ' ',
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  "span",
                  { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.formatSwitcher },
                  __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__coms_RingSwitcher__["a" /* default */], {
                    options: [{ label: 'DEC', value: 'DEC' }, { label: 'HEX', value: 'HEX' }, { label: 'BIN', value: 'BIN' }],
                    onChange: function onChange(fmt) {
                      return _this7.setState({ displayFormat: fmt });
                    }
                  })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "tbody",
            null,
            trs
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "div",
        { className: "pull-right" },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_PageSizer__["a" /* default */], {
          pageSize: pageSize,
          options: [20, 50, 100],
          onChange: this.handleChangePageSize
        })
      )
    );
  };

  LRAPView.prototype.render = function render() {
    var _this8 = this;

    var _state3 = this.state,
        logsReloading = _state3.logsReloading,
        _state3$logExpanded = _state3.logExpanded,
        logExpanded = _state3$logExpanded === undefined ? true : _state3$logExpanded;

    var logHeader = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      "div",
      null,
      this.intlMsg.msg('logs.tableheader'),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "ul",
        { className: "icontools" },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_Refresher__["a" /* default */], {
            onReload: this.handleReloadLogs,
            reloading: logsReloading
          })
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_CollapseToggle__["a" /* default */], {
            expanded: logExpanded,
            onChange: function onChange(v) {
              _this8.setState({ logExpanded: v });
            }
          })
        )
      )
    );

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
          { md: 12 },
          this.renderToolbar()
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.tabs },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Tab"].Container,
              { id: "registertabs", defaultActiveKey: "write" },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Row"],
                { className: "clearfix" },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                  { md: 12 },
                  __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Nav"],
                    { bsStyle: "aisz-tabs" },
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["NavItem"],
                      { eventKey: "write" },
                      this.intlMsg.msg('tabs.write.title')
                    ),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["NavItem"],
                      { eventKey: "read" },
                      this.intlMsg.msg('tabs.read.title')
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Tab"].Content,
                    { className: "aisz-tab-content-white", animation: true },
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Tab"].Pane,
                      { eventKey: "write" },
                      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        "div",
                        null,
                        this.renderWriteTab()
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Tab"].Pane,
                      { eventKey: "read" },
                      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        "div",
                        null,
                        this.renderReadTab()
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Panel"],
            {
              bsStyle: "aisz-white",
              header: logHeader,
              collapsible: true,
              expanded: logExpanded
            },
            this.renderLogs()
          )
        )
      )
    );
  };

  return LRAPView;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

LRAPView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    appId: ownProps.params.appId,
    deviceId: ownProps.params.deviceId,
    deviceState: state.device.getDevice,
    appState: state.app.getApp
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["routerActions"].push,
  replaceState: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["routerActions"].replace
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"])(LRAPView)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11), __webpack_require__(14)))

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_PageLoading__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_PageNoPerm__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_Select__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_CollapseToggle__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__coms_RxParamSetupReq__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__coms_RxTimingSetupReq__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__coms_DutyCycleReq__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__coms_DevStatusReq__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__coms_LinkADRReq__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__coms_NewChannelReq__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__coms_DlChannelReq__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__coms_TxParamSetupReq__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__coms_UdpChPlanReq__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__coms_AddBroadcastReq__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__coms_RemoveBroadcastReq__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__coms_UdpChPlanReq2__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__coms_AddBroadcastReqV2__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__coms_RemoveBroadcastReqV2__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__coms_MacLog__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__coms_MacHelp__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__styles_scss__ = __webpack_require__(2243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




































var kCommands = ['RXParamSetupReq', 'TXParamSetupReq', 'RXTimingSetupReq', 'DutyCycleReq', 'DevStatusReq', 'LinkADRReq', 'NewChannelReq', 'DLChannelReq', 'UpdChPlanReq', 'AddBroadcastReq', 'RemoveBroadcastReq', 'UpdChPlanReqV2', 'AddBroadcastReqV2', 'RemoveBroadcastReqV2'];

var kCommandOptions = kCommands.map(function (cmd) {
  return {
    label: cmd,
    value: cmd
  };
});

var propTypes = {
  pushState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  deviceState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  getDevice: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  getMacTxSize: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  txSize: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  plan: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  appState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  replaceState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired
};

var MacView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(MacView, _React$Component);

  function MacView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MacView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      plan: props.plan,
      deviceState: props.deviceState,
      appState: props.appState,
      txSize: props.txSize,
      command: 'RXParamSetupReq'
    };
    _this.handleSelectCommand = _this.handleSelectCommand.bind(_this);
    _this.handleRefreshTxSize = _this.handleRefreshTxSize.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_18_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.macview');
    return _this;
  }

  MacView.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        deviceId = _props.deviceId,
        getMacTxSize = _props.getMacTxSize;

    getMacTxSize(deviceId);
  };

  MacView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var deviceState = nextProps.deviceState,
        txSize = nextProps.txSize,
        plan = nextProps.plan,
        appState = nextProps.appState;

    if (deviceState !== this.props.deviceState) {
      this.setState({ deviceState: deviceState });
    }
    if (txSize !== this.props.txSize) {
      this.setState({ txSize: txSize });
    }
    if (plan !== this.props.plan) {
      this.setState({ plan: plan });
    }
    if (appState !== this.props.appState) {
      this.setState({ appState: appState });
    }
  };

  MacView.prototype.handleSelectCommand = function handleSelectCommand(command) {
    this.setState({ command: command });
  };

  MacView.prototype.handleRefreshTxSize = function handleRefreshTxSize() {
    var _props2 = this.props,
        deviceId = _props2.deviceId,
        getDevice = _props2.getDevice,
        getMacTxSize = _props2.getMacTxSize;

    getDevice(deviceId);
    getMacTxSize(deviceId);
  };

  MacView.prototype.renderToolbar = function renderToolbar() {
    var _this2 = this;

    var _props3 = this.props,
        appId = _props3.appId,
        deviceId = _props3.deviceId;
    var _state = this.state,
        _state$deviceState = _state.deviceState,
        _state$deviceState$da = _state$deviceState.data;
    _state$deviceState$da = _state$deviceState$da === undefined ? {} : _state$deviceState$da;
    var name = _state$deviceState$da.name,
        status = _state$deviceState.status,
        _state$appState = _state.appState,
        _state$appState$data = _state$appState.data;
    _state$appState$data = _state$appState$data === undefined ? {} : _state$appState$data;
    var appName = _state$appState$data.name,
        appStatus = _state$appState.status;


    var breadcrumb = [{
      content: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], { id: "application.breadcrumb.application" }),
      onClick: function onClick() {
        return _this2.props.pushState('/application');
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_Nvl__["a" /* default */], { val: appName, status: appStatus }),
      onClick: function onClick() {
        return _this2.props.replaceState("/application/" + appId);
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_Nvl__["a" /* default */], { val: name || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lorautils_IdUtils__["a" /* normalizeDevEUI */])(deviceId), status: status }),
      active: true
    }];

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  MacView.prototype.renderForm = function renderForm() {
    var deviceId = this.props.deviceId;
    var command = this.state.command;

    var form = void 0;
    if (command === 'RXParamSetupReq') {
      form = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__coms_RxParamSetupReq__["a" /* default */], { deviceId: deviceId });
    } else if (command === 'RXTimingSetupReq') {
      form = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__coms_RxTimingSetupReq__["a" /* default */], { deviceId: deviceId });
    } else if (command === 'DutyCycleReq') {
      form = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__coms_DutyCycleReq__["a" /* default */], { deviceId: deviceId });
    } else if (command === 'DevStatusReq') {
      form = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__coms_DevStatusReq__["a" /* default */], { deviceId: deviceId });
    } else if (command === 'LinkADRReq') {
      form = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__coms_LinkADRReq__["a" /* default */], { deviceId: deviceId });
    } else if (command === 'NewChannelReq') {
      form = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__coms_NewChannelReq__["a" /* default */], { deviceId: deviceId });
    } else if (command === 'DLChannelReq') {
      form = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__coms_DlChannelReq__["a" /* default */], { deviceId: deviceId });
    } else if (command === 'TXParamSetupReq') {
      form = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__coms_TxParamSetupReq__["a" /* default */], { deviceId: deviceId });
    } else if (command === 'UpdChPlanReq') {
      form = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__coms_UdpChPlanReq__["a" /* default */], { deviceId: deviceId });
    } else if (command === 'AddBroadcastReq') {
      form = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__coms_AddBroadcastReq__["a" /* default */], { deviceId: deviceId });
    } else if (command === 'RemoveBroadcastReq') {
      form = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__coms_RemoveBroadcastReq__["a" /* default */], { deviceId: deviceId });
    } else if (command === 'UpdChPlanReqV2') {
      form = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__coms_UdpChPlanReq2__["a" /* default */], { deviceId: deviceId });
    } else if (command === 'AddBroadcastReqV2') {
      form = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__coms_AddBroadcastReqV2__["a" /* default */], { deviceId: deviceId });
    } else if (command === 'RemoveBroadcastReqV2') {
      form = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__coms_RemoveBroadcastReqV2__["a" /* default */], { deviceId: deviceId });
    }
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_35__styles_scss___default.a.macform },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Form"],
        { horizontal: true, onSubmit: function onSubmit(e) {
            return e.preventDefault();
          } },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["FormGroup"],
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["ControlLabel"],
              { bsClass: "aisz-control-label" },
              this.intlMsg.msg('selectmac')
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
            { md: 6 },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Select__["a" /* default */], {
              className: "aisz-form-control-f",
              options: kCommandOptions,
              onChange: this.handleSelectCommand,
              value: command
            })
          )
        )
      ),
      form
    );
  };

  MacView.prototype.renderMacCommand = function renderMacCommand() {
    var _this3 = this;

    var _state2 = this.state,
        command = _state2.command,
        txSize = _state2.txSize,
        _state2$expanded = _state2.expanded,
        expanded = _state2$expanded === undefined ? true : _state2$expanded;
    var _txSize$data = txSize.data;
    _txSize$data = _txSize$data === undefined ? {} : _txSize$data;
    var size = _txSize$data.size,
        status = txSize.status;


    var header = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      null,
      this.intlMsg.msg('maccommand'),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "ul",
        { className: "icontools" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_CollapseToggle__["a" /* default */], {
            expanded: expanded,
            onChange: function onChange(v) {
              _this3.setState({ expanded: v });
            }
          })
        )
      )
    );

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Row"],
      null,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
        { md: 7 },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Panel"],
          {
            bsStyle: "aisz-white",
            header: header,
            collapsible: true,
            expanded: expanded
          },
          this.renderForm()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
        { md: 5 },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Collapse"],
          { "in": expanded },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_35__styles_scss___default.a.qsize },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "span",
                { className: __WEBPACK_IMPORTED_MODULE_35__styles_scss___default.a.title },
                this.intlMsg.msg('sendqueue')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "span",
                { className: __WEBPACK_IMPORTED_MODULE_35__styles_scss___default.a.value },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_Nvl__["a" /* default */], { val: size, status: status })
              ),
              ' ',
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_router__["f" /* Link */],
                { onClick: this.handleRefreshTxSize },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-refresh" }),
                ' ',
                this.intlMsg.msg('refresh')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__coms_MacHelp__["a" /* default */], { command: command })
          )
        )
      )
    );
  };

  MacView.prototype.renderContent = function renderContent() {
    var deviceId = this.props.deviceId;


    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
          { md: 12 },
          this.renderToolbar()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
          { md: 12 },
          this.renderMacCommand()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__coms_MacLog__["a" /* default */], { deviceId: deviceId })
        )
      )
    );
  };

  MacView.prototype.render = function render() {
    var _state$plan = this.state.plan,
        status = _state$plan.status,
        data = _state$plan.data;

    if (status !== 'success') {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_PageLoading__["a" /* default */], null);
    }
    if (data.tier === 1) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_PageNoPerm__["a" /* default */], null);
    }
    return this.renderContent();
  };

  return MacView;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

MacView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    plan: state.billing.plan,
    deviceState: state.device.getDevice,
    appState: state.app.getApp,
    txSize: state.device.getMacTxSize,
    appId: ownProps.params.appId,
    deviceId: ownProps.params.deviceId
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_7_react_router_redux__["routerActions"].push,
  replaceState: __WEBPACK_IMPORTED_MODULE_7_react_router_redux__["routerActions"].replace,
  getDevice: __WEBPACK_IMPORTED_MODULE_17_loraactions_device__["a" /* default */].getDevice,
  getMacTxSize: __WEBPACK_IMPORTED_MODULE_17_loraactions_device__["a" /* default */].getMacTxSize
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"])(MacView)));

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aisztheme_sass_animate_scss__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aisztheme_sass_animate_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_aisztheme_sass_animate_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DeviceData__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DevicePktsTrend__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DeviceDropPktsTrend__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__DeviceSNRTrend__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__DeviceRSSITrend__ = __webpack_require__(1240);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);






















var propTypes = {
  deviceId: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.any.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  deviceState: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  appState: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  replaceState: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired
};

var StatView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(StatView, _React$Component);

  function StatView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, StatView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.statview');
    _this.state = {
      deviceState: props.deviceState,
      appState: props.appState,
      statReloading: false,
      statSeries: {
        drops: {
          name: _this.intlMsg.msg('series.droppedpackets'),
          data: [],
          yAxisIndex: 0
        },
        snr: {
          name: 'SNR',
          data: [],
          yAxisIndex: 0
        },
        rssi: {
          name: 'RSSI',
          data: [],
          yAxisIndex: 0
        },
        categories: []
      }
    };
    _this.loadStats = _this.loadStats.bind(_this);
    return _this;
  }

  StatView.prototype.componentDidMount = function componentDidMount() {
    this.loadStats();
  };

  StatView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var deviceState = nextProps.deviceState,
        appState = nextProps.appState;

    if (deviceState !== this.props.deviceState) {
      this.setState({ deviceState: deviceState });
    }
    if (appState !== this.props.appState) {
      this.setState({ appState: appState });
    }
  };

  StatView.prototype.loadStats = function loadStats() {
    var _this2 = this;

    var deviceId = this.props.deviceId;


    this.setState({ statReloading: true });

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lorautils_api__["a" /* callAPI */])({
      endpoint: "/lora/nodes/" + deviceId + "/rxqos?download"
    }).then(function (data) {
      var drops = [];
      var snr = [];
      var rssi = [];
      var slots = [];
      data.list.reverse().forEach(function (item) {
        slots.push(__WEBPACK_IMPORTED_MODULE_10_date_fns_format___default()(item.$time, 'MM-DD HH:mm:ss'));
        drops.push(item.drops);
        snr.push(item.lorasnr);
        rssi.push(item.rssi);
      });
      var statSeries = _this2.state.statSeries;

      statSeries.drops.data = drops;
      statSeries.snr.data = snr;
      statSeries.rssi.data = rssi;
      statSeries.categories = slots;
      _this2.setState({
        statSeries: statSeries,
        statReloading: false
      });
    });
  };

  StatView.prototype.renderToolbar = function renderToolbar() {
    var _this3 = this;

    var appId = this.props.appId;
    var _state = this.state,
        _state$deviceState = _state.deviceState,
        _state$deviceState$da = _state$deviceState.data;
    _state$deviceState$da = _state$deviceState$da === undefined ? {} : _state$deviceState$da;
    var name = _state$deviceState$da.name,
        deveui = _state$deviceState$da.deveui,
        status = _state$deviceState.status,
        _state$appState = _state.appState,
        _state$appState$data = _state$appState.data;
    _state$appState$data = _state$appState$data === undefined ? {} : _state$appState$data;
    var appName = _state$appState$data.name,
        appStatus = _state$appState.status;


    var breadcrumb = [{
      content: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], { id: "application.breadcrumb.application" }),
      onClick: function onClick() {
        return _this3.props.pushState('/application');
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Nvl__["a" /* default */], { val: appName, status: appStatus }),
      onClick: function onClick() {
        return _this3.props.replaceState("/application/" + appId);
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Nvl__["a" /* default */], { val: name || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lorautils_IdUtils__["a" /* normalizeDevEUI */])(deveui || ''), status: status }),
      active: true
    }];
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  StatView.prototype.render = function render() {
    var deviceId = this.props.deviceId;
    var _state2 = this.state,
        statSeries = _state2.statSeries,
        statReloading = _state2.statReloading;


    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 12 },
          this.renderToolbar()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__DevicePktsTrend__["a" /* default */], { deviceId: deviceId })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__DeviceDropPktsTrend__["a" /* default */], {
            series: statSeries,
            onReload: this.loadStats,
            reloading: statReloading
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__DeviceSNRTrend__["a" /* default */], {
            series: statSeries,
            onReload: this.loadStats,
            reloading: statReloading
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__DeviceRSSITrend__["a" /* default */], {
            series: statSeries,
            onReload: this.loadStats,
            reloading: statReloading
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__DeviceData__["a" /* default */], { deviceId: deviceId })
        )
      )
    );
  };

  return StatView;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

StatView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    appId: ownProps.params.appId,
    deviceId: ownProps.params.deviceId,
    deviceState: state.device.getDevice,
    appState: state.app.getApp
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_7_react_router_redux__["routerActions"].push,
  replaceState: __WEBPACK_IMPORTED_MODULE_7_react_router_redux__["routerActions"].replace,
  getRxQOS: __WEBPACK_IMPORTED_MODULE_14_loraactions_device__["a" /* default */].getRxQOS
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(StatView)));

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__coms_DefLink__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss__ = __webpack_require__(2247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  links: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  deviceState: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  getLinks: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  appState: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  replaceState: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};

var TopoView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(TopoView, _React$Component);

  function TopoView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TopoView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      deviceState: props.deviceState,
      appState: props.appState,
      links: props.links
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_15_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.topoview');
    return _this;
  }

  TopoView.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        deviceId = _props.deviceId,
        getLinks = _props.getLinks;

    getLinks(deviceId);
  };

  TopoView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var deviceState = nextProps.deviceState,
        appState = nextProps.appState,
        links = nextProps.links;

    if (links !== this.props.links) {
      this.setState({ links: links });
    }
    if (deviceState !== this.props.deviceState) {
      this.setState({ deviceState: deviceState });
    }
    if (appState !== this.props.appState) {
      this.setState({ appState: appState });
    }
  };

  TopoView.prototype.handleOnDelete = function handleOnDelete(gateway) {
    var _props2 = this.props,
        deviceId = _props2.deviceId,
        getLinks = _props2.getLinks;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__api_callAPI__["a" /* default */])({
      endpoint: "/lora/nodes/" + deviceId + "/links/" + gateway,
      method: 'DELETE'
    }).then(function () {
      getLinks(deviceId);
    }).catch(function () {});
  };

  TopoView.prototype.renderToolbar = function renderToolbar() {
    var _props3 = this.props,
        pushState = _props3.pushState,
        appId = _props3.appId,
        deviceId = _props3.deviceId,
        replaceState = _props3.replaceState;
    var _state = this.state,
        _state$deviceState = _state.deviceState,
        _state$deviceState$da = _state$deviceState.data;
    _state$deviceState$da = _state$deviceState$da === undefined ? {} : _state$deviceState$da;
    var name = _state$deviceState$da.name,
        status = _state$deviceState.status,
        _state$appState = _state.appState,
        _state$appState$data = _state$appState.data;
    _state$appState$data = _state$appState$data === undefined ? {} : _state$appState$data;
    var appName = _state$appState$data.name,
        appStatus = _state$appState.status;

    var breadcrumb = [{
      content: this.intlMsg.msg('breadcrumb.application', 'application'),
      onClick: function onClick() {
        return pushState('/application');
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Nvl__["a" /* default */], { val: appName, status: appStatus }),
      onClick: function onClick() {
        return replaceState("/application/" + appId);
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Nvl__["a" /* default */], { val: name || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lorautils_IdUtils__["a" /* normalizeDevEUI */])(deviceId), status: status }),
      active: true
    }];
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  TopoView.prototype.renderContent = function renderContent() {
    var _this2 = this;

    var pushState = this.props.pushState;
    var _state$links = this.state.links;
    _state$links = _state$links === undefined ? {} : _state$links;
    var _state$links$data = _state$links.data;
    _state$links$data = _state$links$data === undefined ? {} : _state$links$data;
    var _state$links$data$lin = _state$links$data.links,
        links = _state$links$data$lin === undefined ? [] : _state$links$data$lin,
        _state$links$data$bes = _state$links$data.best,
        best = _state$links$data$bes === undefined ? '' : _state$links$data$bes;

    var list = links || [];

    var rows = list.map(function (l) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        { key: l.gateway },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
            { onClick: function onClick() {
                return pushState("/gateway/detail/" + l.gateway);
              } },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lorautils_IdUtils__["b" /* normalizeMac */])(l.gateway)
          ),
          best === l.gateway && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.best },
            _this2.intlMsg.msg('best'),
            ' ',
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-thumbs-up" })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_10_date_fns_format___default()(l.time, 'YYYY-MM-DD HH:mm:ss')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          l.rssi
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          l.snr.toFixed(2)
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          l.fcnt
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_RichLabel__["a" /* default */], { content: l.dr.modulation })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          l.dr.spreadFactor
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          l.dr.bandwidth
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          l.dr.bitrate
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
            {
              className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.delete,
              onClick: function onClick() {
                return _this2.handleOnDelete(l.gateway);
              }
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-trash" })
          )
        )
      );
    });

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: this.intlMsg.msg('header') },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Table"],
        { className: "aisz-table-light", striped: true, hover: true, bordered: true, responsive: true },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              { rowSpan: 2 },
              this.intlMsg.msg('data.gateway')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              { rowSpan: 2 },
              this.intlMsg.msg('data.time')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              { rowSpan: 2 },
              "RSSI"
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              { rowSpan: 2 },
              "SNR"
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              { rowSpan: 2 },
              this.intlMsg.msg('data.fcnt')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              { colSpan: 4, className: "text-center" },
              this.intlMsg.msg('data.dr')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              { rowSpan: 2 },
              this.intlMsg.msg('data.delete')
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('data.modulation')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('data.sf')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('data.bandwidth')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('data.bitrate')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "tbody",
          null,
          rows
        )
      )
    );
  };

  TopoView.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 12 },
          this.renderToolbar()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__coms_DefLink__["a" /* default */], { deviceId: this.props.deviceId })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 12 },
          this.renderContent()
        )
      )
    );
  };

  return TopoView;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

TopoView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    deviceState: state.device.getDevice || {},
    appState: state.app.getApp || {},
    links: state.device.getLinks || {},
    deviceId: ownProps.params.deviceId,
    appId: ownProps.params.appId
  };
};

var mapDispatchToProps = {
  getLinks: __WEBPACK_IMPORTED_MODULE_14_loraactions_device__["a" /* default */].getLinks,
  pushState: __WEBPACK_IMPORTED_MODULE_7_react_router_redux__["routerActions"].push,
  replaceState: __WEBPACK_IMPORTED_MODULE_7_react_router_redux__["routerActions"].replace
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(TopoView)));

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss__ = __webpack_require__(2255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);








var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired
};

var PayStrategy = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PayStrategy, _React$Component);

  function PayStrategy(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PayStrategy);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'billing');
    return _this;
  }

  PayStrategy.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { styleName: "card-content" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "ul",
        { className: "list-unstyled" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "span",
            { styleName: "tier" },
            "[1, 50]\xA0"
          ),
          this.intlMsg.msg('pay.tier.txt1'),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "span",
            { styleName: "price" },
            "\xA02RMB/",
            this.intlMsg.msg('pay.tier.bymonth')
          ),
          this.intlMsg.msg('pay.tier.txt2')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "span",
            { styleName: "tier" },
            "[51, 500]\xA0"
          ),
          this.intlMsg.msg('pay.tier.txt1'),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "span",
            { styleName: "price" },
            "\xA01.5RMB/",
            this.intlMsg.msg('pay.tier.bymonth')
          ),
          this.intlMsg.msg('pay.tier.txt2')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "span",
            { styleName: "tier" },
            "[501, 1000]\xA0"
          ),
          this.intlMsg.msg('pay.tier.txt1'),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "span",
            { styleName: "price" },
            "\xA01.2RMB/",
            this.intlMsg.msg('pay.tier.bymonth')
          ),
          this.intlMsg.msg('pay.tier.txt2')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "span",
            { styleName: "tier" },
            "1000\xA0"
          ),
          this.intlMsg.msg('pay.tier.txt3')
        )
      )
    );
  };

  return PayStrategy;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

PayStrategy.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_6_react_css_modules___default()(PayStrategy, __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a, { allowMultiple: true })));

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_day__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_day__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_sub_days__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_sub_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_date_fns_sub_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_add_days__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_date_fns_add_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_is_after__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_is_after___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_date_fns_is_after__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_is_before__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_is_before___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_date_fns_is_before__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_date_fns_min__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_date_fns_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_date_fns_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loracoms_PageSizer__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_loracoms_PanelToolbar__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_loracoms_DatePicker__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_loraapi_lora_gateway__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__styles_scss__ = __webpack_require__(2277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

























function defaultFrom() {
  return __WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_day___default()(__WEBPACK_IMPORTED_MODULE_12_date_fns_sub_days___default()(new Date(), 7));
}

function defaultTo() {
  return __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_day___default()(new Date());
}

var defaultProps = {
  gatewayId: null
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  gatewayId: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string,
  pushState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired
};

var GatewayLog = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(GatewayLog, _React$Component);

  GatewayLog.handleDisableDate = function handleDisableDate(d, from) {
    return __WEBPACK_IMPORTED_MODULE_15_date_fns_is_after___default()(d, __WEBPACK_IMPORTED_MODULE_17_date_fns_min___default()(__WEBPACK_IMPORTED_MODULE_14_date_fns_add_days___default()(from, 7), new Date())) || __WEBPACK_IMPORTED_MODULE_16_date_fns_is_before___default()(d, from);
  };

  function GatewayLog(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GatewayLog);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      list: [],
      pageSize: 50
    };
    _this.loadLogs = _this.loadLogs.bind(_this);
    _this.handleChangePageSize = _this.handleChangePageSize.bind(_this);
    _this.handleChangeFrom = _this.handleChangeFrom.bind(_this);
    _this.handleChangeTo = _this.handleChangeTo.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_23_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaylog');
    return _this;
  }

  GatewayLog.prototype.componentDidMount = function componentDidMount() {
    this.loadLogs();
  };

  GatewayLog.prototype.loadLogs = function loadLogs(args) {
    var _this2 = this;

    var _state = this.state,
        _state$from = _state.from,
        from = _state$from === undefined ? defaultFrom() : _state$from,
        _state$to = _state.to,
        to = _state$to === undefined ? defaultTo() : _state$to;

    if (_.has(args, 'from')) {
      from = args.from;
    }
    if (_.has(args, 'to')) {
      to = args.to;
    }
    var params = _.extend({
      limit: this.state.pageSize,
      after: from.valueOf(),
      before: to.valueOf(),
      order: 'desc'
    }, args);

    var promise = null;
    if (_.isNil(this.props.gatewayId)) {
      promise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24_loraapi_lora_gateway__["a" /* getGatewayLog */])(params);
    } else {
      promise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24_loraapi_lora_gateway__["b" /* getGatewayLogRecord */])(params, this.props.gatewayId);
    }

    promise.then(function (res) {
      var list = _.map(res.body.list, function (l) {
        if (!_.isNull(l.info)) {
          var info = _.join(_.map(_.toPairs(l.info), function (e) {
            return e[0] + ":" + e[1];
          }), ',');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, l, { info: info });
        }
        return l;
      });
      _this2.setState({ list: list });
    }).catch(function () {});
  };

  GatewayLog.prototype.handleChangeFrom = function handleChangeFrom(from) {
    var to = __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_day___default()(from);
    this.setState({ from: __WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_day___default()(from), to: to });
    this.loadLogs({ from: __WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_day___default()(from), to: to });
  };

  GatewayLog.prototype.handleChangeTo = function handleChangeTo(to) {
    this.setState({ to: __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_day___default()(to) });
    this.loadLogs({ to: __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_day___default()(to) });
  };

  GatewayLog.prototype.handleChangePageSize = function handleChangePageSize(ps) {
    this.setState({ pageSize: ps });
    this.loadLogs({ limit: ps });
  };

  GatewayLog.prototype.render = function render() {
    var _props = this.props,
        gatewayId = _props.gatewayId,
        pushState = _props.pushState;
    var _state2 = this.state,
        _state2$from = _state2.from,
        from = _state2$from === undefined ? defaultFrom() : _state2$from,
        _state2$to = _state2.to,
        to = _state2$to === undefined ? defaultTo() : _state2$to,
        _state2$pageSize = _state2.pageSize,
        pageSize = _state2$pageSize === undefined ? 50 : _state2$pageSize,
        list = _state2.list;


    var LogLevels = {
      info: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Label"],
        { bsStyle: "info" },
        "INFO"
      ),
      warn: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Label"],
        { bsStyle: "warning" },
        "WARN"
      ),
      debug: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Label"],
        { bsStyle: "default" },
        "DEBUG"
      ),
      INFO: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Label"],
        { bsStyle: "info" },
        "INFO"
      )
    };

    var fromPicker = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_loracoms_DatePicker__["a" /* default */], { date: from, onSelect: this.handleChangeFrom });
    var toPicker = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_loracoms_DatePicker__["a" /* default */], {
      date: to,
      onSelect: this.handleChangeTo,
      disabled: function disabled(d) {
        return GatewayLog.handleDisableDate(d, from);
      }
    });

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: this.intlMsg.msg('thead.panelheader') },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_loracoms_PanelToolbar__["a" /* default */], { tools: [fromPicker, toPicker] }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Table"],
        { className: "aisz-table-light", striped: true, hover: true, bordered: true, responsive: true },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('thead.cat')
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('thead.time')
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_20_loracoms_ShowIf__["a" /* default */],
              { "if": _.isNil(gatewayId) },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('thead.mac')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('thead.code')
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('thead.message')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "tbody",
          null,
          list.map(function (r, idx) {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "tr",
              { key: String(idx) },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                null,
                LogLevels[r.cat]
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_13_date_fns_format___default()(r.$time, 'YYYY-MM-DD HH:mm:ss')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_20_loracoms_ShowIf__["a" /* default */],
                { "if": _.isNil(gatewayId) },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "td",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_9_react_router__["f" /* Link */],
                    { onClick: function onClick() {
                        return pushState("gateway/detail/" + r.gateway + "/log");
                      } },
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_lorautils_IdUtils__["b" /* normalizeMac */])(r.gateway)
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_loracoms_RichLabel__["a" /* default */], {
                  content: r.code,
                  enums: [{
                    content: 'GATEWAYCONNECTED',
                    theme: 'green'
                  }, {
                    content: 'GATEWAYDISCONNECTED',
                    theme: 'red'
                  }, {
                    content: 'CONFLICTCONNECTION',
                    theme: 'yellow'
                  }]
                })
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                null,
                r.info
              )
            );
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_20_loracoms_ShowIf__["a" /* default */],
        { "if": list.length > 0 },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_26__styles_scss___default.a.pager },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_PageSizer__["a" /* default */], {
            pageSize: pageSize,
            onChange: this.handleChangePageSize,
            options: [50, 100, 500]
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_20_loracoms_ShowIf__["a" /* default */],
        { "if": list.length === 0 },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_26__styles_scss___default.a.noData },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "h3",
            null,
            this.intlMsg.msg('nodata')
          )
        )
      )
    );
  };

  return GatewayLog;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

GatewayLog.defaultProps = defaultProps;
GatewayLog.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(function () {
  return {};
}, { pushState: __WEBPACK_IMPORTED_MODULE_5_react_router_redux__["routerActions"].push })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(GatewayLog)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_GatewayMap__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_HideIf__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_MapPicker__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_SearchInput__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_scss__ = __webpack_require__(2279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);














var defaultProps = {
  show: false,
  onSave: function onSave() {}
};

var propTypes = {
  gateways: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.array.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  show: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool,
  onSave: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var MapOverlay = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(MapOverlay, _React$Component);

  function MapOverlay(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MapOverlay);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      gateways: props.gateways,
      center: props.gateways[0],
      zoom: _.isNil(props.gateways[0]) ? 11 : 16,
      show: props.show,
      view: 'view'
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'mapoverlay');
    _this.handlePickPoint = _this.handlePickPoint.bind(_this);
    _this.handleSaveLocation = _this.handleSaveLocation.bind(_this);
    _this.handleHide = _this.handleHide.bind(_this);
    return _this;
  }

  MapOverlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var gateways = nextProps.gateways,
        show = nextProps.show;

    if (gateways !== this.props.gateways) {
      this.setState({ gateways: gateways });
    }
    if (show !== this.props.show) {
      this.setState({ show: show });
    }
  };

  MapOverlay.prototype.handlePickPoint = function handlePickPoint(point) {
    this.setState({ point: point });
  };

  MapOverlay.prototype.handleSaveLocation = function handleSaveLocation() {
    var point = this.state.point;

    this.props.onSave(point);
    this.handleHide();
  };

  MapOverlay.prototype.handleHide = function handleHide() {
    this.setState({ view: 'view' });
    this.props.onHide();
  };

  MapOverlay.prototype.handleOnChange = function handleOnChange(e) {
    var search = _.trim(e.target.value);
    this.setState({ search: search });
  };

  MapOverlay.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        gateways = _state.gateways,
        _state$show = _state.show,
        show = _state$show === undefined ? false : _state$show,
        _state$view = _state.view,
        view = _state$view === undefined ? 'view' : _state$view,
        _state$point = _state.point,
        point = _state$point === undefined ? {} : _state$point,
        center = _state.center,
        zoom = _state.zoom,
        _state$search = _state.search,
        search = _state$search === undefined ? '' : _state$search;


    if (!show) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.overlay },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.closeButton + " " + __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.mapButton },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
          { bsStyle: "aisz-link-default", onClick: this.handleHide },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-remove drop" })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.mapMarker + " " + __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.mapButton },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
          { bsStyle: "aisz-link-default", onClick: function onClick() {
              _this2.setState({ view: 'edit' });
            } },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-nearby-circle drop" }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_loracoms_HideIf__["a" /* default */],
            { "if": view === 'edit' && !_.isEmpty(point) },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "span",
              { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.buttonText },
              this.intlMsg.msg('edit')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
          { "if": view === 'edit' && !_.isEmpty(point) },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.point },
            "(" + point.lng + "," + point.lat + ")"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
          { "if": view === 'edit' && !_.isEmpty(point) },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
            { bsStyle: "aisz-primary", onClick: this.handleSaveLocation },
            this.intlMsg.msg('submit')
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
        { "if": view === 'view' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_GatewayMap__["a" /* default */], {
          gateways: gateways,
          onZoom: function onZoom(map) {
            _this2.setState({
              center: map.getCenter(),
              zoom: map.getZoom()
            });
          },
          onDrag: function onDrag(map) {
            _this2.setState({
              center: map.getCenter()
            });
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
        { "if": view === 'edit' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "pull-right " + __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.searchinput },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_SearchInput__["a" /* default */], {
            value: search,
            onChange: function onChange(e) {
              return _this2.handleOnChange(e);
            },
            placeholder: "search"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
        { "if": view === 'edit' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_MapPicker__["a" /* default */], {
          point: center,
          zoom: zoom,
          onPick: this.handlePickPoint,
          search: search
        })
      )
    );
  };

  return MapOverlay;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

MapOverlay.defaultProps = defaultProps;
MapOverlay.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    gateway: state.gateway.gateway
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_5_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(MapOverlay)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_DateTimeUtils__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_TablePager__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_LoadingTable__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__api_callAPI__ = __webpack_require__(27);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);















function switchColor(numb) {
  var color = '#67809f';
  if (numb < 5) {
    color = '#1e824c';
  } else if (numb < 10) {
    color = '#2574a9';
  } else if (numb < 20) {
    color = '#f4d03f';
  } else if (numb < 40) {
    color = '#ec644b';
  }
  return color;
}

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_6_react_intl__["intlShape"].isRequired,
  nodeStatus: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired
};

var Logs = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Logs, _React$Component);

  function Logs(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Logs);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      list: [],
      status: 'pending',
      nodeStatus: props.nodeStatus
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.node.channel');
    _this.onChangeMark = _this.onChangeMark.bind(_this);
    return _this;
  }

  Logs.prototype.componentWillMount = function componentWillMount() {
    this.loadLogs(this.state.nodeStatus);
  };

  Logs.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var nodeStatus = _ref.nodeStatus;

    if (!_.isEqual(nodeStatus, this.props.nodeStatus)) {
      this.setState({ nodeStatus: nodeStatus });
      this.loadLogs(nodeStatus);
    }
  };

  Logs.prototype.onChangeMark = function onChangeMark() {
    var mark = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    this.loadLogs(this.state.nodeStatus, mark);
  };

  Logs.prototype.loadLogs = function loadLogs() {
    var _this2 = this;

    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.nodeStatus,
        id = _ref2.id;

    var mark = arguments[1];

    if (!id) return;
    this.setState({ status: 'pending' });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__api_callAPI__["a" /* default */])({
      endpoint: '/tdmng/allots',
      query: {
        mark: mark,
        node: id,
        sort: '-start',
        limit: 20
      }
    }).then(function (res) {
      var list = res.list,
          more = res.more,
          m = res.mark;

      var firstRecord = !mark;
      _this2.setState({ list: list || [], status: 'success', more: more, mark: m, firstRecord: firstRecord });
    }).catch(function () {});
  };

  Logs.prototype.render = function render() {
    var _state = this.state,
        list = _state.list,
        status = _state.status,
        nodeStatus = _state.nodeStatus,
        _state$mark = _state.mark,
        mark = _state$mark === undefined ? 0 : _state$mark,
        _state$more = _state.more,
        more = _state$more === undefined ? false : _state$more,
        _state$firstRecord = _state.firstRecord,
        firstRecord = _state$firstRecord === undefined ? false : _state$firstRecord;


    var thead = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "thead",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('channel')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('network.tdm.gateway.add', '')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('startat')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('endat')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          "Aloha Up"
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          "TDM Up"
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('alohapercent'),
          "/%"
        )
      )
    );

    var table = void 0;
    if (status !== 'success') {
      var rows = Math.max(1, Math.min(10, list.length));
      table = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_14_loracoms_LoadingTable__["a" /* default */],
        {
          cols: 7,
          rows: rows,
          className: "aisz-table-light",
          striped: true,
          bordered: true,
          responsive: true
        },
        thead
      );
    } else {
      table = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Table"],
        { className: "aisz-table-light", striped: true },
        thead,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "tbody",
          null,
          _.map(list, function (l, idx) {
            var tdmup = void 0;
            var alohaup = void 0;
            var share = void 0;
            if (l.memo) {
              try {
                var memo = l.memo;
                tdmup = memo.tdmup;
                alohaup = memo.alohaup;
                share = _.isNumber(tdmup) && _.isNumber(alohaup) && alohaup + tdmup > 0 ? Number((alohaup / (alohaup + tdmup) * 100).toFixed(2)) : 0;
              } catch (err) {
                // err;
              }
            } else if (!idx && firstRecord) {
              // 最新一条历史记录显示节点状态的值
              var _nodeStatus$counters = nodeStatus.counters,
                  counters = _nodeStatus$counters === undefined ? {} : _nodeStatus$counters;

              tdmup = counters.tdmup;
              alohaup = counters.alohaup;
              share = _.isNumber(tdmup) && _.isNumber(alohaup) && alohaup + tdmup > 0 ? Number((alohaup / (alohaup + tdmup) * 100).toFixed(2)) : 0;
            }
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "tr",
              { key: idx },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_RichLabel__["a" /* default */], { content: String(l.channel) })
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                l.gw && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_react_router__["f" /* Link */],
                  { to: "/network/tdm/gateway/" + l.gw },
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lorautils_IdUtils__["a" /* normalizeDevEUI */])(l.gw)
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                l.start && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lorautils_DateTimeUtils__["a" /* compactFormat */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["subHours"])(l.start, 8))
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                l.end && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lorautils_DateTimeUtils__["a" /* compactFormat */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["subHours"])(l.end, 8))
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                alohaup
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                tdmup
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                !_.isNil(share) && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "span",
                  { style: { display: 'flex', alignItems: 'center' } },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-circle", style: { color: switchColor(share), fontSize: '0.9rem' } }),
                  "\xA0",
                  share
                )
              )
            );
          })
        )
      );
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
      {
        bsStyle: "aisz-white", header: this.intlMsg.msg('logs')
      },
      table,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: "text-right" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_TablePager__["a" /* default */], {
          status: status,
          mark: mark,
          more: more,
          onNext: this.onChangeMark,
          onPrev: this.onChangeMark
        })
      )
    );
  };

  return Logs;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Logs.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(Logs));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(59);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* createTypesMap */])('adr', ['getBroadcast']);

function getBroadcast(id) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getBroadcast, {
    endpoint: "/lora/apps/" + id + "/broadcasts"
  })();
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getBroadcast: getBroadcast
});

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(59);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* createTypesMap */])('flow', ['countDataPoints']);

function countDataPoints(query) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.countDataPoints, {
    endpoint: '/lora/dps/count',
    query: query
  })();
}

/* harmony default export */ __webpack_exports__["a"] = ({
  countDataPoints: countDataPoints
});

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(59);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* createTypesMap */])('loracube', ['getActivate']);

function getActivate() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getActivate, {
    endpoint: '/loracube/activate',
    method: 'GET'
  })();
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getActivate: getActivate
});

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(59);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* createTypesMap */])('mark', ['handleMark']);

var handleMark = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(types.handleMark, function (mark) {
  return mark;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  handleMark: handleMark
});

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(59);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* createTypesMap */])('sidebar', ['toggleSidebar']);

function toggleSidebar() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(types.toggleSidebar)();
}

/* harmony default export */ __webpack_exports__["a"] = ({
  toggleSidebar: toggleSidebar
});

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(59);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* createTypesMap */])('token', ['getTokens']);

function getTokens(query) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createAPIAction */])(types.getTokens, {
    endpoint: 'tokens',
    method: 'GET',
    query: query
  })();
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getTokens: getTokens
});

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (immutable) */ __webpack_exports__["b"] = notEmptyValidator;
/* harmony export (immutable) */ __webpack_exports__["f"] = hexValidator;
/* harmony export (immutable) */ __webpack_exports__["d"] = hexNumValidator;
/* harmony export (immutable) */ __webpack_exports__["e"] = binNumValidator;
/* harmony export (immutable) */ __webpack_exports__["a"] = intValidator;
/* harmony export (immutable) */ __webpack_exports__["c"] = orValidator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loracoms_LocaleMsg__ = __webpack_require__(1140);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




function notEmptyValidator() {
  return function (v) {
    if (_.isUndefined(v) || v.trim() === '') {
      return {
        valid: false,
        errmsg: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loracoms_LocaleMsg__["a" /* default */], { id: "lora.error.cannotbeempty" })
      };
    }
    return {
      valid: true
    };
  };
}

function hexValidator(len) {
  return function (v) {
    if (_.isUndefined(v) || v.trim() === '') {
      return {
        valid: false,
        errmsg: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loracoms_LocaleMsg__["a" /* default */], { id: "lora.error.cannotbeempty" })
      };
    }
    if (new RegExp("^[0-9A-Fa-f]{" + len + "}$").test(v.replace(/[:-]/g, ''))) {
      return {
        valid: true
      };
    }
    return {
      valid: false,
      errmsg: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loracoms_LocaleMsg__["a" /* default */], { id: "lora.error.invalidformat" })
    };
  };
}

function hexNumValidator(min, max) {
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0x';

  return function (v) {
    if (_.isUndefined(v) || v.trim() === '') {
      return {
        valid: false,
        errmsg: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loracoms_LocaleMsg__["a" /* default */], { id: "lora.error.cannotbeempty" })
      };
    }
    if (new RegExp("^" + prefix + "[0-9A-Fa-f]+$").test(v.replace(/[:-]/g, ''))) {
      var numv = parseInt(v, 16);
      if (numv < min) {
        return {
          valid: false,
          errmsg: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loracoms_LocaleMsg__["a" /* default */], { id: "lora.error.integer.toolow" })
        };
      }
      if (numv > max) {
        return {
          valid: false,
          errmsg: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loracoms_LocaleMsg__["a" /* default */], { id: "lora.error.integer.toolarge" })
        };
      }
      return {
        valid: true
      };
    }
    return {
      valid: false,
      errmsg: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loracoms_LocaleMsg__["a" /* default */], { id: "lora.error.invalidformat" })
    };
  };
}

function binNumValidator(min, max) {
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0b';

  return function (v) {
    if (_.isUndefined(v) || v.trim() === '') {
      return {
        valid: false,
        errmsg: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loracoms_LocaleMsg__["a" /* default */], { id: "lora.error.cannotbeempty" })
      };
    }
    if (new RegExp("^" + prefix + "[01]+$").test(v.replace(/[:-]/g, ''))) {
      var numv = parseInt(v, 2);
      if (numv < min) {
        return {
          valid: false,
          errmsg: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loracoms_LocaleMsg__["a" /* default */], { id: "lora.error.integer.toolow" })
        };
      }
      if (numv > max) {
        return {
          valid: false,
          errmsg: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loracoms_LocaleMsg__["a" /* default */], { id: "lora.error.integer.toolarge" })
        };
      }
      return {
        valid: true
      };
    }
    return {
      valid: false,
      errmsg: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loracoms_LocaleMsg__["a" /* default */], { id: "lora.error.invalidformat" })
    };
  };
}

function intValidator(min, max) {
  return function (v) {
    if (_.isUndefined(v) || v.trim() === '') {
      return {
        valid: false,
        errmsg: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loracoms_LocaleMsg__["a" /* default */], { id: "lora.error.cannotbeempty" })
      };
    }
    if (!/^-?\d+$/.test(v.trim())) {
      return {
        valid: false,
        errmsg: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loracoms_LocaleMsg__["a" /* default */], { id: "lora.error.integer.nan" })
      };
    }
    var numv = Number(v);
    if (numv < min) {
      return {
        valid: false,
        errmsg: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loracoms_LocaleMsg__["a" /* default */], { id: "lora.error.integer.toolow" })
      };
    }
    if (numv > max) {
      return {
        valid: false,
        errmsg: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loracoms_LocaleMsg__["a" /* default */], { id: "lora.error.integer.toolarge" })
      };
    }
    return { valid: true };
  };
}

function orValidator() {
  var validators = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (validators.length === 0) {
    return { valid: true };
  }

  return function (v) {
    var results = validators.map(function (validator) {
      return validator(v);
    });
    if (_.some(results, 'valid')) {
      return { valid: true };
    }
    return results[0];
  };
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (immutable) */ __webpack_exports__["a"] = downloadAsCSV;
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

function downloadAsCSV(rows, filename, keys, header, formatter) {
  if (_.isNil(rows) || rows.length === 0) {
    return;
  }

  var csvContent = "data:text/csv;charset=utf-8,\uFEFF";

  if (_.isArray(rows[0])) {
    rows.forEach(function (row, index) {
      var line = row.join(',');
      csvContent += index < rows.length ? line + "\n" : line;
    });
  } else {
    var ks = keys;
    if (_.isNil(ks)) {
      ks = _.uniq(_.flatMap(rows, _.keys));
    }
    // header
    if (header) {
      csvContent += _.map(ks, function (k) {
        return header[k];
      }).join(',') + "\n";
    } else {
      csvContent += ks.join(',') + "\n";
    }
    rows.forEach(function (row, index) {
      var line = _.map(ks, function (k) {
        var ky = k.split('.');
        var content = void 0;
        if (ky[1]) {
          content = (row[ky[0]] || {})[ky[1]];
        } else {
          content = row[k];
        }
        content = _.isNil(content) ? '' : content;
        if (formatter && formatter[ky]) {
          return formatter[ky](row);
        }
        return content;
      }).join(',');
      csvContent += index < rows.length ? line + "\n" : line;
    });
  }

  if (window.Blob && window.navigator.msSaveOrOpenBlob) {
    var blobObject = new Blob([csvContent]);
    window.navigator.msSaveOrOpenBlob(blobObject, filename);
  } else {
    var link = document.createElement('a');
    var encodedUri = encodeURI(csvContent);
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
  }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1453), __esModule: true };

/***/ }),
/* 644 */,
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(1436), __webpack_require__(2754), __webpack_require__(2349)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
        global.clipboard = mod.exports;
    }
})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
    'use strict';

    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

    var _goodListener2 = _interopRequireDefault(_goodListener);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var Clipboard = function (_Emitter) {
        _inherits(Clipboard, _Emitter);

        /**
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         * @param {Object} options
         */
        function Clipboard(trigger, options) {
            _classCallCheck(this, Clipboard);

            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

            _this.resolveOptions(options);
            _this.listenClick(trigger);
            return _this;
        }

        /**
         * Defines if attributes would be resolved using internal setter functions
         * or custom functions that were passed in the constructor.
         * @param {Object} options
         */


        _createClass(Clipboard, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
                this.container = _typeof(options.container) === 'object' ? options.container : document.body;
            }
        }, {
            key: 'listenClick',
            value: function listenClick(trigger) {
                var _this2 = this;

                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                    return _this2.onClick(e);
                });
            }
        }, {
            key: 'onClick',
            value: function onClick(e) {
                var trigger = e.delegateTarget || e.currentTarget;

                if (this.clipboardAction) {
                    this.clipboardAction = null;
                }

                this.clipboardAction = new _clipboardAction2.default({
                    action: this.action(trigger),
                    target: this.target(trigger),
                    text: this.text(trigger),
                    container: this.container,
                    trigger: trigger,
                    emitter: this
                });
            }
        }, {
            key: 'defaultAction',
            value: function defaultAction(trigger) {
                return getAttributeValue('action', trigger);
            }
        }, {
            key: 'defaultTarget',
            value: function defaultTarget(trigger) {
                var selector = getAttributeValue('target', trigger);

                if (selector) {
                    return document.querySelector(selector);
                }
            }
        }, {
            key: 'defaultText',
            value: function defaultText(trigger) {
                return getAttributeValue('text', trigger);
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.listener.destroy();

                if (this.clipboardAction) {
                    this.clipboardAction.destroy();
                    this.clipboardAction = null;
                }
            }
        }], [{
            key: 'isSupported',
            value: function isSupported() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

                var actions = typeof action === 'string' ? [action] : action;
                var support = !!document.queryCommandSupported;

                actions.forEach(function (action) {
                    support = support && !!document.queryCommandSupported(action);
                });

                return support;
            }
        }]);

        return Clipboard;
    }(_tinyEmitter2.default);

    /**
     * Helper function to retrieve attribute value.
     * @param {String} suffix
     * @param {Element} element
     */
    function getAttributeValue(suffix, element) {
        var attribute = 'data-clipboard-' + suffix;

        if (!element.hasAttribute(attribute)) {
            return;
        }

        return element.getAttribute(attribute);
    }

    module.exports = Clipboard;
});

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: http://codemirror.net/LICENSE

// This is CodeMirror (http://codemirror.net), a code editor
// implemented in JavaScript on top of the browser's DOM.
//
// You can find some technical background for some of the code below
// at http://marijnhaverbeke.nl/blog/#cm-internals .

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.CodeMirror = factory());
}(this, (function () { 'use strict';

// Kludges for bugs and behavior differences that can't be feature
// detected are enabled based on userAgent etc sniffing.
var userAgent = navigator.userAgent;
var platform = navigator.platform;

var gecko = /gecko\/\d/i.test(userAgent);
var ie_upto10 = /MSIE \d/.test(userAgent);
var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent);
var edge = /Edge\/(\d+)/.exec(userAgent);
var ie = ie_upto10 || ie_11up || edge;
var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : +(edge || ie_11up)[1]);
var webkit = !edge && /WebKit\//.test(userAgent);
var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent);
var chrome = !edge && /Chrome\//.test(userAgent);
var presto = /Opera\//.test(userAgent);
var safari = /Apple Computer/.test(navigator.vendor);
var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent);
var phantom = /PhantomJS/.test(userAgent);

var ios = !edge && /AppleWebKit/.test(userAgent) && /Mobile\/\w+/.test(userAgent);
var android = /Android/.test(userAgent);
// This is woefully incomplete. Suggestions for alternative methods welcome.
var mobile = ios || android || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent);
var mac = ios || /Mac/.test(platform);
var chromeOS = /\bCrOS\b/.test(userAgent);
var windows = /win/i.test(platform);

var presto_version = presto && userAgent.match(/Version\/(\d*\.\d*)/);
if (presto_version) { presto_version = Number(presto_version[1]); }
if (presto_version && presto_version >= 15) { presto = false; webkit = true; }
// Some browsers use the wrong event properties to signal cmd/ctrl on OS X
var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11));
var captureRightClick = gecko || (ie && ie_version >= 9);

function classTest(cls) { return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*") }

var rmClass = function(node, cls) {
  var current = node.className;
  var match = classTest(cls).exec(current);
  if (match) {
    var after = current.slice(match.index + match[0].length);
    node.className = current.slice(0, match.index) + (after ? match[1] + after : "");
  }
};

function removeChildren(e) {
  for (var count = e.childNodes.length; count > 0; --count)
    { e.removeChild(e.firstChild); }
  return e
}

function removeChildrenAndAdd(parent, e) {
  return removeChildren(parent).appendChild(e)
}

function elt(tag, content, className, style) {
  var e = document.createElement(tag);
  if (className) { e.className = className; }
  if (style) { e.style.cssText = style; }
  if (typeof content == "string") { e.appendChild(document.createTextNode(content)); }
  else if (content) { for (var i = 0; i < content.length; ++i) { e.appendChild(content[i]); } }
  return e
}
// wrapper for elt, which removes the elt from the accessibility tree
function eltP(tag, content, className, style) {
  var e = elt(tag, content, className, style);
  e.setAttribute("role", "presentation");
  return e
}

var range;
if (document.createRange) { range = function(node, start, end, endNode) {
  var r = document.createRange();
  r.setEnd(endNode || node, end);
  r.setStart(node, start);
  return r
}; }
else { range = function(node, start, end) {
  var r = document.body.createTextRange();
  try { r.moveToElementText(node.parentNode); }
  catch(e) { return r }
  r.collapse(true);
  r.moveEnd("character", end);
  r.moveStart("character", start);
  return r
}; }

function contains(parent, child) {
  if (child.nodeType == 3) // Android browser always returns false when child is a textnode
    { child = child.parentNode; }
  if (parent.contains)
    { return parent.contains(child) }
  do {
    if (child.nodeType == 11) { child = child.host; }
    if (child == parent) { return true }
  } while (child = child.parentNode)
}

function activeElt() {
  // IE and Edge may throw an "Unspecified Error" when accessing document.activeElement.
  // IE < 10 will throw when accessed while the page is loading or in an iframe.
  // IE > 9 and Edge will throw when accessed in an iframe if document.body is unavailable.
  var activeElement;
  try {
    activeElement = document.activeElement;
  } catch(e) {
    activeElement = document.body || null;
  }
  while (activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement)
    { activeElement = activeElement.shadowRoot.activeElement; }
  return activeElement
}

function addClass(node, cls) {
  var current = node.className;
  if (!classTest(cls).test(current)) { node.className += (current ? " " : "") + cls; }
}
function joinClasses(a, b) {
  var as = a.split(" ");
  for (var i = 0; i < as.length; i++)
    { if (as[i] && !classTest(as[i]).test(b)) { b += " " + as[i]; } }
  return b
}

var selectInput = function(node) { node.select(); };
if (ios) // Mobile Safari apparently has a bug where select() is broken.
  { selectInput = function(node) { node.selectionStart = 0; node.selectionEnd = node.value.length; }; }
else if (ie) // Suppress mysterious IE10 errors
  { selectInput = function(node) { try { node.select(); } catch(_e) {} }; }

function bind(f) {
  var args = Array.prototype.slice.call(arguments, 1);
  return function(){return f.apply(null, args)}
}

function copyObj(obj, target, overwrite) {
  if (!target) { target = {}; }
  for (var prop in obj)
    { if (obj.hasOwnProperty(prop) && (overwrite !== false || !target.hasOwnProperty(prop)))
      { target[prop] = obj[prop]; } }
  return target
}

// Counts the column offset in a string, taking tabs into account.
// Used mostly to find indentation.
function countColumn(string, end, tabSize, startIndex, startValue) {
  if (end == null) {
    end = string.search(/[^\s\u00a0]/);
    if (end == -1) { end = string.length; }
  }
  for (var i = startIndex || 0, n = startValue || 0;;) {
    var nextTab = string.indexOf("\t", i);
    if (nextTab < 0 || nextTab >= end)
      { return n + (end - i) }
    n += nextTab - i;
    n += tabSize - (n % tabSize);
    i = nextTab + 1;
  }
}

var Delayed = function() {this.id = null;};
Delayed.prototype.set = function (ms, f) {
  clearTimeout(this.id);
  this.id = setTimeout(f, ms);
};

function indexOf(array, elt) {
  for (var i = 0; i < array.length; ++i)
    { if (array[i] == elt) { return i } }
  return -1
}

// Number of pixels added to scroller and sizer to hide scrollbar
var scrollerGap = 30;

// Returned or thrown by various protocols to signal 'I'm not
// handling this'.
var Pass = {toString: function(){return "CodeMirror.Pass"}};

// Reused option objects for setSelection & friends
var sel_dontScroll = {scroll: false};
var sel_mouse = {origin: "*mouse"};
var sel_move = {origin: "+move"};

// The inverse of countColumn -- find the offset that corresponds to
// a particular column.
function findColumn(string, goal, tabSize) {
  for (var pos = 0, col = 0;;) {
    var nextTab = string.indexOf("\t", pos);
    if (nextTab == -1) { nextTab = string.length; }
    var skipped = nextTab - pos;
    if (nextTab == string.length || col + skipped >= goal)
      { return pos + Math.min(skipped, goal - col) }
    col += nextTab - pos;
    col += tabSize - (col % tabSize);
    pos = nextTab + 1;
    if (col >= goal) { return pos }
  }
}

var spaceStrs = [""];
function spaceStr(n) {
  while (spaceStrs.length <= n)
    { spaceStrs.push(lst(spaceStrs) + " "); }
  return spaceStrs[n]
}

function lst(arr) { return arr[arr.length-1] }

function map(array, f) {
  var out = [];
  for (var i = 0; i < array.length; i++) { out[i] = f(array[i], i); }
  return out
}

function insertSorted(array, value, score) {
  var pos = 0, priority = score(value);
  while (pos < array.length && score(array[pos]) <= priority) { pos++; }
  array.splice(pos, 0, value);
}

function nothing() {}

function createObj(base, props) {
  var inst;
  if (Object.create) {
    inst = Object.create(base);
  } else {
    nothing.prototype = base;
    inst = new nothing();
  }
  if (props) { copyObj(props, inst); }
  return inst
}

var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
function isWordCharBasic(ch) {
  return /\w/.test(ch) || ch > "\x80" &&
    (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch))
}
function isWordChar(ch, helper) {
  if (!helper) { return isWordCharBasic(ch) }
  if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) { return true }
  return helper.test(ch)
}

function isEmpty(obj) {
  for (var n in obj) { if (obj.hasOwnProperty(n) && obj[n]) { return false } }
  return true
}

// Extending unicode characters. A series of a non-extending char +
// any number of extending chars is treated as a single unit as far
// as editing and measuring is concerned. This is not fully correct,
// since some scripts/fonts/browsers also treat other configurations
// of code points as a group.
var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
function isExtendingChar(ch) { return ch.charCodeAt(0) >= 768 && extendingChars.test(ch) }

// Returns a number from the range [`0`; `str.length`] unless `pos` is outside that range.
function skipExtendingChars(str, pos, dir) {
  while ((dir < 0 ? pos > 0 : pos < str.length) && isExtendingChar(str.charAt(pos))) { pos += dir; }
  return pos
}

// Returns the value from the range [`from`; `to`] that satisfies
// `pred` and is closest to `from`. Assumes that at least `to`
// satisfies `pred`. Supports `from` being greater than `to`.
function findFirst(pred, from, to) {
  // At any point we are certain `to` satisfies `pred`, don't know
  // whether `from` does.
  var dir = from > to ? -1 : 1;
  for (;;) {
    if (from == to) { return from }
    var midF = (from + to) / 2, mid = dir < 0 ? Math.ceil(midF) : Math.floor(midF);
    if (mid == from) { return pred(mid) ? from : to }
    if (pred(mid)) { to = mid; }
    else { from = mid + dir; }
  }
}

// The display handles the DOM integration, both for input reading
// and content drawing. It holds references to DOM nodes and
// display-related state.

function Display(place, doc, input) {
  var d = this;
  this.input = input;

  // Covers bottom-right square when both scrollbars are present.
  d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler");
  d.scrollbarFiller.setAttribute("cm-not-content", "true");
  // Covers bottom of gutter when coverGutterNextToScrollbar is on
  // and h scrollbar is present.
  d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler");
  d.gutterFiller.setAttribute("cm-not-content", "true");
  // Will contain the actual code, positioned to cover the viewport.
  d.lineDiv = eltP("div", null, "CodeMirror-code");
  // Elements are added to these to represent selection and cursors.
  d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1");
  d.cursorDiv = elt("div", null, "CodeMirror-cursors");
  // A visibility: hidden element used to find the size of things.
  d.measure = elt("div", null, "CodeMirror-measure");
  // When lines outside of the viewport are measured, they are drawn in this.
  d.lineMeasure = elt("div", null, "CodeMirror-measure");
  // Wraps everything that needs to exist inside the vertically-padded coordinate system
  d.lineSpace = eltP("div", [d.measure, d.lineMeasure, d.selectionDiv, d.cursorDiv, d.lineDiv],
                    null, "position: relative; outline: none");
  var lines = eltP("div", [d.lineSpace], "CodeMirror-lines");
  // Moved around its parent to cover visible view.
  d.mover = elt("div", [lines], null, "position: relative");
  // Set to the height of the document, allowing scrolling.
  d.sizer = elt("div", [d.mover], "CodeMirror-sizer");
  d.sizerWidth = null;
  // Behavior of elts with overflow: auto and padding is
  // inconsistent across browsers. This is used to ensure the
  // scrollable area is big enough.
  d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;");
  // Will contain the gutters, if any.
  d.gutters = elt("div", null, "CodeMirror-gutters");
  d.lineGutter = null;
  // Actual scrollable element.
  d.scroller = elt("div", [d.sizer, d.heightForcer, d.gutters], "CodeMirror-scroll");
  d.scroller.setAttribute("tabIndex", "-1");
  // The element in which the editor lives.
  d.wrapper = elt("div", [d.scrollbarFiller, d.gutterFiller, d.scroller], "CodeMirror");

  // Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
  if (ie && ie_version < 8) { d.gutters.style.zIndex = -1; d.scroller.style.paddingRight = 0; }
  if (!webkit && !(gecko && mobile)) { d.scroller.draggable = true; }

  if (place) {
    if (place.appendChild) { place.appendChild(d.wrapper); }
    else { place(d.wrapper); }
  }

  // Current rendered range (may be bigger than the view window).
  d.viewFrom = d.viewTo = doc.first;
  d.reportedViewFrom = d.reportedViewTo = doc.first;
  // Information about the rendered lines.
  d.view = [];
  d.renderedView = null;
  // Holds info about a single rendered line when it was rendered
  // for measurement, while not in view.
  d.externalMeasured = null;
  // Empty space (in pixels) above the view
  d.viewOffset = 0;
  d.lastWrapHeight = d.lastWrapWidth = 0;
  d.updateLineNumbers = null;

  d.nativeBarWidth = d.barHeight = d.barWidth = 0;
  d.scrollbarsClipped = false;

  // Used to only resize the line number gutter when necessary (when
  // the amount of lines crosses a boundary that makes its width change)
  d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null;
  // Set to true when a non-horizontal-scrolling line widget is
  // added. As an optimization, line widget aligning is skipped when
  // this is false.
  d.alignWidgets = false;

  d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;

  // Tracks the maximum line length so that the horizontal scrollbar
  // can be kept static when scrolling.
  d.maxLine = null;
  d.maxLineLength = 0;
  d.maxLineChanged = false;

  // Used for measuring wheel scrolling granularity
  d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null;

  // True when shift is held down.
  d.shift = false;

  // Used to track whether anything happened since the context menu
  // was opened.
  d.selForContextMenu = null;

  d.activeTouch = null;

  input.init(d);
}

// Find the line object corresponding to the given line number.
function getLine(doc, n) {
  n -= doc.first;
  if (n < 0 || n >= doc.size) { throw new Error("There is no line " + (n + doc.first) + " in the document.") }
  var chunk = doc;
  while (!chunk.lines) {
    for (var i = 0;; ++i) {
      var child = chunk.children[i], sz = child.chunkSize();
      if (n < sz) { chunk = child; break }
      n -= sz;
    }
  }
  return chunk.lines[n]
}

// Get the part of a document between two positions, as an array of
// strings.
function getBetween(doc, start, end) {
  var out = [], n = start.line;
  doc.iter(start.line, end.line + 1, function (line) {
    var text = line.text;
    if (n == end.line) { text = text.slice(0, end.ch); }
    if (n == start.line) { text = text.slice(start.ch); }
    out.push(text);
    ++n;
  });
  return out
}
// Get the lines between from and to, as array of strings.
function getLines(doc, from, to) {
  var out = [];
  doc.iter(from, to, function (line) { out.push(line.text); }); // iter aborts when callback returns truthy value
  return out
}

// Update the height of a line, propagating the height change
// upwards to parent nodes.
function updateLineHeight(line, height) {
  var diff = height - line.height;
  if (diff) { for (var n = line; n; n = n.parent) { n.height += diff; } }
}

// Given a line object, find its line number by walking up through
// its parent links.
function lineNo(line) {
  if (line.parent == null) { return null }
  var cur = line.parent, no = indexOf(cur.lines, line);
  for (var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent) {
    for (var i = 0;; ++i) {
      if (chunk.children[i] == cur) { break }
      no += chunk.children[i].chunkSize();
    }
  }
  return no + cur.first
}

// Find the line at the given vertical position, using the height
// information in the document tree.
function lineAtHeight(chunk, h) {
  var n = chunk.first;
  outer: do {
    for (var i$1 = 0; i$1 < chunk.children.length; ++i$1) {
      var child = chunk.children[i$1], ch = child.height;
      if (h < ch) { chunk = child; continue outer }
      h -= ch;
      n += child.chunkSize();
    }
    return n
  } while (!chunk.lines)
  var i = 0;
  for (; i < chunk.lines.length; ++i) {
    var line = chunk.lines[i], lh = line.height;
    if (h < lh) { break }
    h -= lh;
  }
  return n + i
}

function isLine(doc, l) {return l >= doc.first && l < doc.first + doc.size}

function lineNumberFor(options, i) {
  return String(options.lineNumberFormatter(i + options.firstLineNumber))
}

// A Pos instance represents a position within the text.
function Pos(line, ch, sticky) {
  if ( sticky === void 0 ) sticky = null;

  if (!(this instanceof Pos)) { return new Pos(line, ch, sticky) }
  this.line = line;
  this.ch = ch;
  this.sticky = sticky;
}

// Compare two positions, return 0 if they are the same, a negative
// number when a is less, and a positive number otherwise.
function cmp(a, b) { return a.line - b.line || a.ch - b.ch }

function equalCursorPos(a, b) { return a.sticky == b.sticky && cmp(a, b) == 0 }

function copyPos(x) {return Pos(x.line, x.ch)}
function maxPos(a, b) { return cmp(a, b) < 0 ? b : a }
function minPos(a, b) { return cmp(a, b) < 0 ? a : b }

// Most of the external API clips given positions to make sure they
// actually exist within the document.
function clipLine(doc, n) {return Math.max(doc.first, Math.min(n, doc.first + doc.size - 1))}
function clipPos(doc, pos) {
  if (pos.line < doc.first) { return Pos(doc.first, 0) }
  var last = doc.first + doc.size - 1;
  if (pos.line > last) { return Pos(last, getLine(doc, last).text.length) }
  return clipToLen(pos, getLine(doc, pos.line).text.length)
}
function clipToLen(pos, linelen) {
  var ch = pos.ch;
  if (ch == null || ch > linelen) { return Pos(pos.line, linelen) }
  else if (ch < 0) { return Pos(pos.line, 0) }
  else { return pos }
}
function clipPosArray(doc, array) {
  var out = [];
  for (var i = 0; i < array.length; i++) { out[i] = clipPos(doc, array[i]); }
  return out
}

// Optimize some code when these features are not used.
var sawReadOnlySpans = false;
var sawCollapsedSpans = false;

function seeReadOnlySpans() {
  sawReadOnlySpans = true;
}

function seeCollapsedSpans() {
  sawCollapsedSpans = true;
}

// TEXTMARKER SPANS

function MarkedSpan(marker, from, to) {
  this.marker = marker;
  this.from = from; this.to = to;
}

// Search an array of spans for a span matching the given marker.
function getMarkedSpanFor(spans, marker) {
  if (spans) { for (var i = 0; i < spans.length; ++i) {
    var span = spans[i];
    if (span.marker == marker) { return span }
  } }
}
// Remove a span from an array, returning undefined if no spans are
// left (we don't store arrays for lines without spans).
function removeMarkedSpan(spans, span) {
  var r;
  for (var i = 0; i < spans.length; ++i)
    { if (spans[i] != span) { (r || (r = [])).push(spans[i]); } }
  return r
}
// Add a span to a line.
function addMarkedSpan(line, span) {
  line.markedSpans = line.markedSpans ? line.markedSpans.concat([span]) : [span];
  span.marker.attachLine(line);
}

// Used for the algorithm that adjusts markers for a change in the
// document. These functions cut an array of spans at a given
// character position, returning an array of remaining chunks (or
// undefined if nothing remains).
function markedSpansBefore(old, startCh, isInsert) {
  var nw;
  if (old) { for (var i = 0; i < old.length; ++i) {
    var span = old[i], marker = span.marker;
    var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh);
    if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
      var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh);(nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to));
    }
  } }
  return nw
}
function markedSpansAfter(old, endCh, isInsert) {
  var nw;
  if (old) { for (var i = 0; i < old.length; ++i) {
    var span = old[i], marker = span.marker;
    var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh);
    if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
      var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh);(nw || (nw = [])).push(new MarkedSpan(marker, startsBefore ? null : span.from - endCh,
                                            span.to == null ? null : span.to - endCh));
    }
  } }
  return nw
}

// Given a change object, compute the new set of marker spans that
// cover the line in which the change took place. Removes spans
// entirely within the change, reconnects spans belonging to the
// same marker that appear on both sides of the change, and cuts off
// spans partially within the change. Returns an array of span
// arrays with one element for each line in (after) the change.
function stretchSpansOverChange(doc, change) {
  if (change.full) { return null }
  var oldFirst = isLine(doc, change.from.line) && getLine(doc, change.from.line).markedSpans;
  var oldLast = isLine(doc, change.to.line) && getLine(doc, change.to.line).markedSpans;
  if (!oldFirst && !oldLast) { return null }

  var startCh = change.from.ch, endCh = change.to.ch, isInsert = cmp(change.from, change.to) == 0;
  // Get the spans that 'stick out' on both sides
  var first = markedSpansBefore(oldFirst, startCh, isInsert);
  var last = markedSpansAfter(oldLast, endCh, isInsert);

  // Next, merge those two ends
  var sameLine = change.text.length == 1, offset = lst(change.text).length + (sameLine ? startCh : 0);
  if (first) {
    // Fix up .to properties of first
    for (var i = 0; i < first.length; ++i) {
      var span = first[i];
      if (span.to == null) {
        var found = getMarkedSpanFor(last, span.marker);
        if (!found) { span.to = startCh; }
        else if (sameLine) { span.to = found.to == null ? null : found.to + offset; }
      }
    }
  }
  if (last) {
    // Fix up .from in last (or move them into first in case of sameLine)
    for (var i$1 = 0; i$1 < last.length; ++i$1) {
      var span$1 = last[i$1];
      if (span$1.to != null) { span$1.to += offset; }
      if (span$1.from == null) {
        var found$1 = getMarkedSpanFor(first, span$1.marker);
        if (!found$1) {
          span$1.from = offset;
          if (sameLine) { (first || (first = [])).push(span$1); }
        }
      } else {
        span$1.from += offset;
        if (sameLine) { (first || (first = [])).push(span$1); }
      }
    }
  }
  // Make sure we didn't create any zero-length spans
  if (first) { first = clearEmptySpans(first); }
  if (last && last != first) { last = clearEmptySpans(last); }

  var newMarkers = [first];
  if (!sameLine) {
    // Fill gap with whole-line-spans
    var gap = change.text.length - 2, gapMarkers;
    if (gap > 0 && first)
      { for (var i$2 = 0; i$2 < first.length; ++i$2)
        { if (first[i$2].to == null)
          { (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i$2].marker, null, null)); } } }
    for (var i$3 = 0; i$3 < gap; ++i$3)
      { newMarkers.push(gapMarkers); }
    newMarkers.push(last);
  }
  return newMarkers
}

// Remove spans that are empty and don't have a clearWhenEmpty
// option of false.
function clearEmptySpans(spans) {
  for (var i = 0; i < spans.length; ++i) {
    var span = spans[i];
    if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false)
      { spans.splice(i--, 1); }
  }
  if (!spans.length) { return null }
  return spans
}

// Used to 'clip' out readOnly ranges when making a change.
function removeReadOnlyRanges(doc, from, to) {
  var markers = null;
  doc.iter(from.line, to.line + 1, function (line) {
    if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
      var mark = line.markedSpans[i].marker;
      if (mark.readOnly && (!markers || indexOf(markers, mark) == -1))
        { (markers || (markers = [])).push(mark); }
    } }
  });
  if (!markers) { return null }
  var parts = [{from: from, to: to}];
  for (var i = 0; i < markers.length; ++i) {
    var mk = markers[i], m = mk.find(0);
    for (var j = 0; j < parts.length; ++j) {
      var p = parts[j];
      if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) { continue }
      var newParts = [j, 1], dfrom = cmp(p.from, m.from), dto = cmp(p.to, m.to);
      if (dfrom < 0 || !mk.inclusiveLeft && !dfrom)
        { newParts.push({from: p.from, to: m.from}); }
      if (dto > 0 || !mk.inclusiveRight && !dto)
        { newParts.push({from: m.to, to: p.to}); }
      parts.splice.apply(parts, newParts);
      j += newParts.length - 3;
    }
  }
  return parts
}

// Connect or disconnect spans from a line.
function detachMarkedSpans(line) {
  var spans = line.markedSpans;
  if (!spans) { return }
  for (var i = 0; i < spans.length; ++i)
    { spans[i].marker.detachLine(line); }
  line.markedSpans = null;
}
function attachMarkedSpans(line, spans) {
  if (!spans) { return }
  for (var i = 0; i < spans.length; ++i)
    { spans[i].marker.attachLine(line); }
  line.markedSpans = spans;
}

// Helpers used when computing which overlapping collapsed span
// counts as the larger one.
function extraLeft(marker) { return marker.inclusiveLeft ? -1 : 0 }
function extraRight(marker) { return marker.inclusiveRight ? 1 : 0 }

// Returns a number indicating which of two overlapping collapsed
// spans is larger (and thus includes the other). Falls back to
// comparing ids when the spans cover exactly the same range.
function compareCollapsedMarkers(a, b) {
  var lenDiff = a.lines.length - b.lines.length;
  if (lenDiff != 0) { return lenDiff }
  var aPos = a.find(), bPos = b.find();
  var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b);
  if (fromCmp) { return -fromCmp }
  var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b);
  if (toCmp) { return toCmp }
  return b.id - a.id
}

// Find out whether a line ends or starts in a collapsed span. If
// so, return the marker for that span.
function collapsedSpanAtSide(line, start) {
  var sps = sawCollapsedSpans && line.markedSpans, found;
  if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
    sp = sps[i];
    if (sp.marker.collapsed && (start ? sp.from : sp.to) == null &&
        (!found || compareCollapsedMarkers(found, sp.marker) < 0))
      { found = sp.marker; }
  } }
  return found
}
function collapsedSpanAtStart(line) { return collapsedSpanAtSide(line, true) }
function collapsedSpanAtEnd(line) { return collapsedSpanAtSide(line, false) }

function collapsedSpanAround(line, ch) {
  var sps = sawCollapsedSpans && line.markedSpans, found;
  if (sps) { for (var i = 0; i < sps.length; ++i) {
    var sp = sps[i];
    if (sp.marker.collapsed && (sp.from == null || sp.from < ch) && (sp.to == null || sp.to > ch) &&
        (!found || compareCollapsedMarkers(found, sp.marker) < 0)) { found = sp.marker; }
  } }
  return found
}

// Test whether there exists a collapsed span that partially
// overlaps (covers the start or end, but not both) of a new span.
// Such overlap is not allowed.
function conflictingCollapsedRange(doc, lineNo$$1, from, to, marker) {
  var line = getLine(doc, lineNo$$1);
  var sps = sawCollapsedSpans && line.markedSpans;
  if (sps) { for (var i = 0; i < sps.length; ++i) {
    var sp = sps[i];
    if (!sp.marker.collapsed) { continue }
    var found = sp.marker.find(0);
    var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker);
    var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker);
    if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) { continue }
    if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) ||
        fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0))
      { return true }
  } }
}

// A visual line is a line as drawn on the screen. Folding, for
// example, can cause multiple logical lines to appear on the same
// visual line. This finds the start of the visual line that the
// given line is part of (usually that is the line itself).
function visualLine(line) {
  var merged;
  while (merged = collapsedSpanAtStart(line))
    { line = merged.find(-1, true).line; }
  return line
}

function visualLineEnd(line) {
  var merged;
  while (merged = collapsedSpanAtEnd(line))
    { line = merged.find(1, true).line; }
  return line
}

// Returns an array of logical lines that continue the visual line
// started by the argument, or undefined if there are no such lines.
function visualLineContinued(line) {
  var merged, lines;
  while (merged = collapsedSpanAtEnd(line)) {
    line = merged.find(1, true).line
    ;(lines || (lines = [])).push(line);
  }
  return lines
}

// Get the line number of the start of the visual line that the
// given line number is part of.
function visualLineNo(doc, lineN) {
  var line = getLine(doc, lineN), vis = visualLine(line);
  if (line == vis) { return lineN }
  return lineNo(vis)
}

// Get the line number of the start of the next visual line after
// the given line.
function visualLineEndNo(doc, lineN) {
  if (lineN > doc.lastLine()) { return lineN }
  var line = getLine(doc, lineN), merged;
  if (!lineIsHidden(doc, line)) { return lineN }
  while (merged = collapsedSpanAtEnd(line))
    { line = merged.find(1, true).line; }
  return lineNo(line) + 1
}

// Compute whether a line is hidden. Lines count as hidden when they
// are part of a visual line that starts with another line, or when
// they are entirely covered by collapsed, non-widget span.
function lineIsHidden(doc, line) {
  var sps = sawCollapsedSpans && line.markedSpans;
  if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
    sp = sps[i];
    if (!sp.marker.collapsed) { continue }
    if (sp.from == null) { return true }
    if (sp.marker.widgetNode) { continue }
    if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc, line, sp))
      { return true }
  } }
}
function lineIsHiddenInner(doc, line, span) {
  if (span.to == null) {
    var end = span.marker.find(1, true);
    return lineIsHiddenInner(doc, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker))
  }
  if (span.marker.inclusiveRight && span.to == line.text.length)
    { return true }
  for (var sp = (void 0), i = 0; i < line.markedSpans.length; ++i) {
    sp = line.markedSpans[i];
    if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to &&
        (sp.to == null || sp.to != span.from) &&
        (sp.marker.inclusiveLeft || span.marker.inclusiveRight) &&
        lineIsHiddenInner(doc, line, sp)) { return true }
  }
}

// Find the height above the given line.
function heightAtLine(lineObj) {
  lineObj = visualLine(lineObj);

  var h = 0, chunk = lineObj.parent;
  for (var i = 0; i < chunk.lines.length; ++i) {
    var line = chunk.lines[i];
    if (line == lineObj) { break }
    else { h += line.height; }
  }
  for (var p = chunk.parent; p; chunk = p, p = chunk.parent) {
    for (var i$1 = 0; i$1 < p.children.length; ++i$1) {
      var cur = p.children[i$1];
      if (cur == chunk) { break }
      else { h += cur.height; }
    }
  }
  return h
}

// Compute the character length of a line, taking into account
// collapsed ranges (see markText) that might hide parts, and join
// other lines onto it.
function lineLength(line) {
  if (line.height == 0) { return 0 }
  var len = line.text.length, merged, cur = line;
  while (merged = collapsedSpanAtStart(cur)) {
    var found = merged.find(0, true);
    cur = found.from.line;
    len += found.from.ch - found.to.ch;
  }
  cur = line;
  while (merged = collapsedSpanAtEnd(cur)) {
    var found$1 = merged.find(0, true);
    len -= cur.text.length - found$1.from.ch;
    cur = found$1.to.line;
    len += cur.text.length - found$1.to.ch;
  }
  return len
}

// Find the longest line in the document.
function findMaxLine(cm) {
  var d = cm.display, doc = cm.doc;
  d.maxLine = getLine(doc, doc.first);
  d.maxLineLength = lineLength(d.maxLine);
  d.maxLineChanged = true;
  doc.iter(function (line) {
    var len = lineLength(line);
    if (len > d.maxLineLength) {
      d.maxLineLength = len;
      d.maxLine = line;
    }
  });
}

// BIDI HELPERS

function iterateBidiSections(order, from, to, f) {
  if (!order) { return f(from, to, "ltr", 0) }
  var found = false;
  for (var i = 0; i < order.length; ++i) {
    var part = order[i];
    if (part.from < to && part.to > from || from == to && part.to == from) {
      f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr", i);
      found = true;
    }
  }
  if (!found) { f(from, to, "ltr"); }
}

var bidiOther = null;
function getBidiPartAt(order, ch, sticky) {
  var found;
  bidiOther = null;
  for (var i = 0; i < order.length; ++i) {
    var cur = order[i];
    if (cur.from < ch && cur.to > ch) { return i }
    if (cur.to == ch) {
      if (cur.from != cur.to && sticky == "before") { found = i; }
      else { bidiOther = i; }
    }
    if (cur.from == ch) {
      if (cur.from != cur.to && sticky != "before") { found = i; }
      else { bidiOther = i; }
    }
  }
  return found != null ? found : bidiOther
}

// Bidirectional ordering algorithm
// See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
// that this (partially) implements.

// One-char codes used for character types:
// L (L):   Left-to-Right
// R (R):   Right-to-Left
// r (AL):  Right-to-Left Arabic
// 1 (EN):  European Number
// + (ES):  European Number Separator
// % (ET):  European Number Terminator
// n (AN):  Arabic Number
// , (CS):  Common Number Separator
// m (NSM): Non-Spacing Mark
// b (BN):  Boundary Neutral
// s (B):   Paragraph Separator
// t (S):   Segment Separator
// w (WS):  Whitespace
// N (ON):  Other Neutrals

// Returns null if characters are ordered as they appear
// (left-to-right), or an array of sections ({from, to, level}
// objects) in the order in which they occur visually.
var bidiOrdering = (function() {
  // Character types for codepoints 0 to 0xff
  var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN";
  // Character types for codepoints 0x600 to 0x6f9
  var arabicTypes = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";
  function charType(code) {
    if (code <= 0xf7) { return lowTypes.charAt(code) }
    else if (0x590 <= code && code <= 0x5f4) { return "R" }
    else if (0x600 <= code && code <= 0x6f9) { return arabicTypes.charAt(code - 0x600) }
    else if (0x6ee <= code && code <= 0x8ac) { return "r" }
    else if (0x2000 <= code && code <= 0x200b) { return "w" }
    else if (code == 0x200c) { return "b" }
    else { return "L" }
  }

  var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
  var isNeutral = /[stwN]/, isStrong = /[LRr]/, countsAsLeft = /[Lb1n]/, countsAsNum = /[1n]/;

  function BidiSpan(level, from, to) {
    this.level = level;
    this.from = from; this.to = to;
  }

  return function(str, direction) {
    var outerType = direction == "ltr" ? "L" : "R";

    if (str.length == 0 || direction == "ltr" && !bidiRE.test(str)) { return false }
    var len = str.length, types = [];
    for (var i = 0; i < len; ++i)
      { types.push(charType(str.charCodeAt(i))); }

    // W1. Examine each non-spacing mark (NSM) in the level run, and
    // change the type of the NSM to the type of the previous
    // character. If the NSM is at the start of the level run, it will
    // get the type of sor.
    for (var i$1 = 0, prev = outerType; i$1 < len; ++i$1) {
      var type = types[i$1];
      if (type == "m") { types[i$1] = prev; }
      else { prev = type; }
    }

    // W2. Search backwards from each instance of a European number
    // until the first strong type (R, L, AL, or sor) is found. If an
    // AL is found, change the type of the European number to Arabic
    // number.
    // W3. Change all ALs to R.
    for (var i$2 = 0, cur = outerType; i$2 < len; ++i$2) {
      var type$1 = types[i$2];
      if (type$1 == "1" && cur == "r") { types[i$2] = "n"; }
      else if (isStrong.test(type$1)) { cur = type$1; if (type$1 == "r") { types[i$2] = "R"; } }
    }

    // W4. A single European separator between two European numbers
    // changes to a European number. A single common separator between
    // two numbers of the same type changes to that type.
    for (var i$3 = 1, prev$1 = types[0]; i$3 < len - 1; ++i$3) {
      var type$2 = types[i$3];
      if (type$2 == "+" && prev$1 == "1" && types[i$3+1] == "1") { types[i$3] = "1"; }
      else if (type$2 == "," && prev$1 == types[i$3+1] &&
               (prev$1 == "1" || prev$1 == "n")) { types[i$3] = prev$1; }
      prev$1 = type$2;
    }

    // W5. A sequence of European terminators adjacent to European
    // numbers changes to all European numbers.
    // W6. Otherwise, separators and terminators change to Other
    // Neutral.
    for (var i$4 = 0; i$4 < len; ++i$4) {
      var type$3 = types[i$4];
      if (type$3 == ",") { types[i$4] = "N"; }
      else if (type$3 == "%") {
        var end = (void 0);
        for (end = i$4 + 1; end < len && types[end] == "%"; ++end) {}
        var replace = (i$4 && types[i$4-1] == "!") || (end < len && types[end] == "1") ? "1" : "N";
        for (var j = i$4; j < end; ++j) { types[j] = replace; }
        i$4 = end - 1;
      }
    }

    // W7. Search backwards from each instance of a European number
    // until the first strong type (R, L, or sor) is found. If an L is
    // found, then change the type of the European number to L.
    for (var i$5 = 0, cur$1 = outerType; i$5 < len; ++i$5) {
      var type$4 = types[i$5];
      if (cur$1 == "L" && type$4 == "1") { types[i$5] = "L"; }
      else if (isStrong.test(type$4)) { cur$1 = type$4; }
    }

    // N1. A sequence of neutrals takes the direction of the
    // surrounding strong text if the text on both sides has the same
    // direction. European and Arabic numbers act as if they were R in
    // terms of their influence on neutrals. Start-of-level-run (sor)
    // and end-of-level-run (eor) are used at level run boundaries.
    // N2. Any remaining neutrals take the embedding direction.
    for (var i$6 = 0; i$6 < len; ++i$6) {
      if (isNeutral.test(types[i$6])) {
        var end$1 = (void 0);
        for (end$1 = i$6 + 1; end$1 < len && isNeutral.test(types[end$1]); ++end$1) {}
        var before = (i$6 ? types[i$6-1] : outerType) == "L";
        var after = (end$1 < len ? types[end$1] : outerType) == "L";
        var replace$1 = before == after ? (before ? "L" : "R") : outerType;
        for (var j$1 = i$6; j$1 < end$1; ++j$1) { types[j$1] = replace$1; }
        i$6 = end$1 - 1;
      }
    }

    // Here we depart from the documented algorithm, in order to avoid
    // building up an actual levels array. Since there are only three
    // levels (0, 1, 2) in an implementation that doesn't take
    // explicit embedding into account, we can build up the order on
    // the fly, without following the level-based algorithm.
    var order = [], m;
    for (var i$7 = 0; i$7 < len;) {
      if (countsAsLeft.test(types[i$7])) {
        var start = i$7;
        for (++i$7; i$7 < len && countsAsLeft.test(types[i$7]); ++i$7) {}
        order.push(new BidiSpan(0, start, i$7));
      } else {
        var pos = i$7, at = order.length;
        for (++i$7; i$7 < len && types[i$7] != "L"; ++i$7) {}
        for (var j$2 = pos; j$2 < i$7;) {
          if (countsAsNum.test(types[j$2])) {
            if (pos < j$2) { order.splice(at, 0, new BidiSpan(1, pos, j$2)); }
            var nstart = j$2;
            for (++j$2; j$2 < i$7 && countsAsNum.test(types[j$2]); ++j$2) {}
            order.splice(at, 0, new BidiSpan(2, nstart, j$2));
            pos = j$2;
          } else { ++j$2; }
        }
        if (pos < i$7) { order.splice(at, 0, new BidiSpan(1, pos, i$7)); }
      }
    }
    if (direction == "ltr") {
      if (order[0].level == 1 && (m = str.match(/^\s+/))) {
        order[0].from = m[0].length;
        order.unshift(new BidiSpan(0, 0, m[0].length));
      }
      if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
        lst(order).to -= m[0].length;
        order.push(new BidiSpan(0, len - m[0].length, len));
      }
    }

    return direction == "rtl" ? order.reverse() : order
  }
})();

// Get the bidi ordering for the given line (and cache it). Returns
// false for lines that are fully left-to-right, and an array of
// BidiSpan objects otherwise.
function getOrder(line, direction) {
  var order = line.order;
  if (order == null) { order = line.order = bidiOrdering(line.text, direction); }
  return order
}

// EVENT HANDLING

// Lightweight event framework. on/off also work on DOM nodes,
// registering native DOM handlers.

var noHandlers = [];

var on = function(emitter, type, f) {
  if (emitter.addEventListener) {
    emitter.addEventListener(type, f, false);
  } else if (emitter.attachEvent) {
    emitter.attachEvent("on" + type, f);
  } else {
    var map$$1 = emitter._handlers || (emitter._handlers = {});
    map$$1[type] = (map$$1[type] || noHandlers).concat(f);
  }
};

function getHandlers(emitter, type) {
  return emitter._handlers && emitter._handlers[type] || noHandlers
}

function off(emitter, type, f) {
  if (emitter.removeEventListener) {
    emitter.removeEventListener(type, f, false);
  } else if (emitter.detachEvent) {
    emitter.detachEvent("on" + type, f);
  } else {
    var map$$1 = emitter._handlers, arr = map$$1 && map$$1[type];
    if (arr) {
      var index = indexOf(arr, f);
      if (index > -1)
        { map$$1[type] = arr.slice(0, index).concat(arr.slice(index + 1)); }
    }
  }
}

function signal(emitter, type /*, values...*/) {
  var handlers = getHandlers(emitter, type);
  if (!handlers.length) { return }
  var args = Array.prototype.slice.call(arguments, 2);
  for (var i = 0; i < handlers.length; ++i) { handlers[i].apply(null, args); }
}

// The DOM events that CodeMirror handles can be overridden by
// registering a (non-DOM) handler on the editor for the event name,
// and preventDefault-ing the event in that handler.
function signalDOMEvent(cm, e, override) {
  if (typeof e == "string")
    { e = {type: e, preventDefault: function() { this.defaultPrevented = true; }}; }
  signal(cm, override || e.type, cm, e);
  return e_defaultPrevented(e) || e.codemirrorIgnore
}

function signalCursorActivity(cm) {
  var arr = cm._handlers && cm._handlers.cursorActivity;
  if (!arr) { return }
  var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = []);
  for (var i = 0; i < arr.length; ++i) { if (indexOf(set, arr[i]) == -1)
    { set.push(arr[i]); } }
}

function hasHandler(emitter, type) {
  return getHandlers(emitter, type).length > 0
}

// Add on and off methods to a constructor's prototype, to make
// registering events on such objects more convenient.
function eventMixin(ctor) {
  ctor.prototype.on = function(type, f) {on(this, type, f);};
  ctor.prototype.off = function(type, f) {off(this, type, f);};
}

// Due to the fact that we still support jurassic IE versions, some
// compatibility wrappers are needed.

function e_preventDefault(e) {
  if (e.preventDefault) { e.preventDefault(); }
  else { e.returnValue = false; }
}
function e_stopPropagation(e) {
  if (e.stopPropagation) { e.stopPropagation(); }
  else { e.cancelBubble = true; }
}
function e_defaultPrevented(e) {
  return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false
}
function e_stop(e) {e_preventDefault(e); e_stopPropagation(e);}

function e_target(e) {return e.target || e.srcElement}
function e_button(e) {
  var b = e.which;
  if (b == null) {
    if (e.button & 1) { b = 1; }
    else if (e.button & 2) { b = 3; }
    else if (e.button & 4) { b = 2; }
  }
  if (mac && e.ctrlKey && b == 1) { b = 3; }
  return b
}

// Detect drag-and-drop
var dragAndDrop = function() {
  // There is *some* kind of drag-and-drop support in IE6-8, but I
  // couldn't get it to work yet.
  if (ie && ie_version < 9) { return false }
  var div = elt('div');
  return "draggable" in div || "dragDrop" in div
}();

var zwspSupported;
function zeroWidthElement(measure) {
  if (zwspSupported == null) {
    var test = elt("span", "\u200b");
    removeChildrenAndAdd(measure, elt("span", [test, document.createTextNode("x")]));
    if (measure.firstChild.offsetHeight != 0)
      { zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8); }
  }
  var node = zwspSupported ? elt("span", "\u200b") :
    elt("span", "\u00a0", null, "display: inline-block; width: 1px; margin-right: -1px");
  node.setAttribute("cm-text", "");
  return node
}

// Feature-detect IE's crummy client rect reporting for bidi text
var badBidiRects;
function hasBadBidiRects(measure) {
  if (badBidiRects != null) { return badBidiRects }
  var txt = removeChildrenAndAdd(measure, document.createTextNode("A\u062eA"));
  var r0 = range(txt, 0, 1).getBoundingClientRect();
  var r1 = range(txt, 1, 2).getBoundingClientRect();
  removeChildren(measure);
  if (!r0 || r0.left == r0.right) { return false } // Safari returns null in some cases (#2780)
  return badBidiRects = (r1.right - r0.right < 3)
}

// See if "".split is the broken IE version, if so, provide an
// alternative way to split lines.
var splitLinesAuto = "\n\nb".split(/\n/).length != 3 ? function (string) {
  var pos = 0, result = [], l = string.length;
  while (pos <= l) {
    var nl = string.indexOf("\n", pos);
    if (nl == -1) { nl = string.length; }
    var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl);
    var rt = line.indexOf("\r");
    if (rt != -1) {
      result.push(line.slice(0, rt));
      pos += rt + 1;
    } else {
      result.push(line);
      pos = nl + 1;
    }
  }
  return result
} : function (string) { return string.split(/\r\n?|\n/); };

var hasSelection = window.getSelection ? function (te) {
  try { return te.selectionStart != te.selectionEnd }
  catch(e) { return false }
} : function (te) {
  var range$$1;
  try {range$$1 = te.ownerDocument.selection.createRange();}
  catch(e) {}
  if (!range$$1 || range$$1.parentElement() != te) { return false }
  return range$$1.compareEndPoints("StartToEnd", range$$1) != 0
};

var hasCopyEvent = (function () {
  var e = elt("div");
  if ("oncopy" in e) { return true }
  e.setAttribute("oncopy", "return;");
  return typeof e.oncopy == "function"
})();

var badZoomedRects = null;
function hasBadZoomedRects(measure) {
  if (badZoomedRects != null) { return badZoomedRects }
  var node = removeChildrenAndAdd(measure, elt("span", "x"));
  var normal = node.getBoundingClientRect();
  var fromRange = range(node, 0, 1).getBoundingClientRect();
  return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1
}

// Known modes, by name and by MIME
var modes = {};
var mimeModes = {};

// Extra arguments are stored as the mode's dependencies, which is
// used by (legacy) mechanisms like loadmode.js to automatically
// load a mode. (Preferred mechanism is the require/define calls.)
function defineMode(name, mode) {
  if (arguments.length > 2)
    { mode.dependencies = Array.prototype.slice.call(arguments, 2); }
  modes[name] = mode;
}

function defineMIME(mime, spec) {
  mimeModes[mime] = spec;
}

// Given a MIME type, a {name, ...options} config object, or a name
// string, return a mode config object.
function resolveMode(spec) {
  if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) {
    spec = mimeModes[spec];
  } else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
    var found = mimeModes[spec.name];
    if (typeof found == "string") { found = {name: found}; }
    spec = createObj(found, spec);
    spec.name = found.name;
  } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) {
    return resolveMode("application/xml")
  } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) {
    return resolveMode("application/json")
  }
  if (typeof spec == "string") { return {name: spec} }
  else { return spec || {name: "null"} }
}

// Given a mode spec (anything that resolveMode accepts), find and
// initialize an actual mode object.
function getMode(options, spec) {
  spec = resolveMode(spec);
  var mfactory = modes[spec.name];
  if (!mfactory) { return getMode(options, "text/plain") }
  var modeObj = mfactory(options, spec);
  if (modeExtensions.hasOwnProperty(spec.name)) {
    var exts = modeExtensions[spec.name];
    for (var prop in exts) {
      if (!exts.hasOwnProperty(prop)) { continue }
      if (modeObj.hasOwnProperty(prop)) { modeObj["_" + prop] = modeObj[prop]; }
      modeObj[prop] = exts[prop];
    }
  }
  modeObj.name = spec.name;
  if (spec.helperType) { modeObj.helperType = spec.helperType; }
  if (spec.modeProps) { for (var prop$1 in spec.modeProps)
    { modeObj[prop$1] = spec.modeProps[prop$1]; } }

  return modeObj
}

// This can be used to attach properties to mode objects from
// outside the actual mode definition.
var modeExtensions = {};
function extendMode(mode, properties) {
  var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : (modeExtensions[mode] = {});
  copyObj(properties, exts);
}

function copyState(mode, state) {
  if (state === true) { return state }
  if (mode.copyState) { return mode.copyState(state) }
  var nstate = {};
  for (var n in state) {
    var val = state[n];
    if (val instanceof Array) { val = val.concat([]); }
    nstate[n] = val;
  }
  return nstate
}

// Given a mode and a state (for that mode), find the inner mode and
// state at the position that the state refers to.
function innerMode(mode, state) {
  var info;
  while (mode.innerMode) {
    info = mode.innerMode(state);
    if (!info || info.mode == mode) { break }
    state = info.state;
    mode = info.mode;
  }
  return info || {mode: mode, state: state}
}

function startState(mode, a1, a2) {
  return mode.startState ? mode.startState(a1, a2) : true
}

// STRING STREAM

// Fed to the mode parsers, provides helper functions to make
// parsers more succinct.

var StringStream = function(string, tabSize, lineOracle) {
  this.pos = this.start = 0;
  this.string = string;
  this.tabSize = tabSize || 8;
  this.lastColumnPos = this.lastColumnValue = 0;
  this.lineStart = 0;
  this.lineOracle = lineOracle;
};

StringStream.prototype.eol = function () {return this.pos >= this.string.length};
StringStream.prototype.sol = function () {return this.pos == this.lineStart};
StringStream.prototype.peek = function () {return this.string.charAt(this.pos) || undefined};
StringStream.prototype.next = function () {
  if (this.pos < this.string.length)
    { return this.string.charAt(this.pos++) }
};
StringStream.prototype.eat = function (match) {
  var ch = this.string.charAt(this.pos);
  var ok;
  if (typeof match == "string") { ok = ch == match; }
  else { ok = ch && (match.test ? match.test(ch) : match(ch)); }
  if (ok) {++this.pos; return ch}
};
StringStream.prototype.eatWhile = function (match) {
  var start = this.pos;
  while (this.eat(match)){}
  return this.pos > start
};
StringStream.prototype.eatSpace = function () {
    var this$1 = this;

  var start = this.pos;
  while (/[\s\u00a0]/.test(this.string.charAt(this.pos))) { ++this$1.pos; }
  return this.pos > start
};
StringStream.prototype.skipToEnd = function () {this.pos = this.string.length;};
StringStream.prototype.skipTo = function (ch) {
  var found = this.string.indexOf(ch, this.pos);
  if (found > -1) {this.pos = found; return true}
};
StringStream.prototype.backUp = function (n) {this.pos -= n;};
StringStream.prototype.column = function () {
  if (this.lastColumnPos < this.start) {
    this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
    this.lastColumnPos = this.start;
  }
  return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
};
StringStream.prototype.indentation = function () {
  return countColumn(this.string, null, this.tabSize) -
    (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
};
StringStream.prototype.match = function (pattern, consume, caseInsensitive) {
  if (typeof pattern == "string") {
    var cased = function (str) { return caseInsensitive ? str.toLowerCase() : str; };
    var substr = this.string.substr(this.pos, pattern.length);
    if (cased(substr) == cased(pattern)) {
      if (consume !== false) { this.pos += pattern.length; }
      return true
    }
  } else {
    var match = this.string.slice(this.pos).match(pattern);
    if (match && match.index > 0) { return null }
    if (match && consume !== false) { this.pos += match[0].length; }
    return match
  }
};
StringStream.prototype.current = function (){return this.string.slice(this.start, this.pos)};
StringStream.prototype.hideFirstChars = function (n, inner) {
  this.lineStart += n;
  try { return inner() }
  finally { this.lineStart -= n; }
};
StringStream.prototype.lookAhead = function (n) {
  var oracle = this.lineOracle;
  return oracle && oracle.lookAhead(n)
};
StringStream.prototype.baseToken = function () {
  var oracle = this.lineOracle;
  return oracle && oracle.baseToken(this.pos)
};

var SavedContext = function(state, lookAhead) {
  this.state = state;
  this.lookAhead = lookAhead;
};

var Context = function(doc, state, line, lookAhead) {
  this.state = state;
  this.doc = doc;
  this.line = line;
  this.maxLookAhead = lookAhead || 0;
  this.baseTokens = null;
  this.baseTokenPos = 1;
};

Context.prototype.lookAhead = function (n) {
  var line = this.doc.getLine(this.line + n);
  if (line != null && n > this.maxLookAhead) { this.maxLookAhead = n; }
  return line
};

Context.prototype.baseToken = function (n) {
    var this$1 = this;

  if (!this.baseTokens) { return null }
  while (this.baseTokens[this.baseTokenPos] <= n)
    { this$1.baseTokenPos += 2; }
  var type = this.baseTokens[this.baseTokenPos + 1];
  return {type: type && type.replace(/( |^)overlay .*/, ""),
          size: this.baseTokens[this.baseTokenPos] - n}
};

Context.prototype.nextLine = function () {
  this.line++;
  if (this.maxLookAhead > 0) { this.maxLookAhead--; }
};

Context.fromSaved = function (doc, saved, line) {
  if (saved instanceof SavedContext)
    { return new Context(doc, copyState(doc.mode, saved.state), line, saved.lookAhead) }
  else
    { return new Context(doc, copyState(doc.mode, saved), line) }
};

Context.prototype.save = function (copy) {
  var state = copy !== false ? copyState(this.doc.mode, this.state) : this.state;
  return this.maxLookAhead > 0 ? new SavedContext(state, this.maxLookAhead) : state
};


// Compute a style array (an array starting with a mode generation
// -- for invalidation -- followed by pairs of end positions and
// style strings), which is used to highlight the tokens on the
// line.
function highlightLine(cm, line, context, forceToEnd) {
  // A styles array always starts with a number identifying the
  // mode/overlays that it is based on (for easy invalidation).
  var st = [cm.state.modeGen], lineClasses = {};
  // Compute the base array of styles
  runMode(cm, line.text, cm.doc.mode, context, function (end, style) { return st.push(end, style); },
          lineClasses, forceToEnd);
  var state = context.state;

  // Run overlays, adjust style array.
  var loop = function ( o ) {
    context.baseTokens = st;
    var overlay = cm.state.overlays[o], i = 1, at = 0;
    context.state = true;
    runMode(cm, line.text, overlay.mode, context, function (end, style) {
      var start = i;
      // Ensure there's a token end at the current position, and that i points at it
      while (at < end) {
        var i_end = st[i];
        if (i_end > end)
          { st.splice(i, 1, end, st[i+1], i_end); }
        i += 2;
        at = Math.min(end, i_end);
      }
      if (!style) { return }
      if (overlay.opaque) {
        st.splice(start, i - start, end, "overlay " + style);
        i = start + 2;
      } else {
        for (; start < i; start += 2) {
          var cur = st[start+1];
          st[start+1] = (cur ? cur + " " : "") + "overlay " + style;
        }
      }
    }, lineClasses);
    context.state = state;
    context.baseTokens = null;
    context.baseTokenPos = 1;
  };

  for (var o = 0; o < cm.state.overlays.length; ++o) loop( o );

  return {styles: st, classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null}
}

function getLineStyles(cm, line, updateFrontier) {
  if (!line.styles || line.styles[0] != cm.state.modeGen) {
    var context = getContextBefore(cm, lineNo(line));
    var resetState = line.text.length > cm.options.maxHighlightLength && copyState(cm.doc.mode, context.state);
    var result = highlightLine(cm, line, context);
    if (resetState) { context.state = resetState; }
    line.stateAfter = context.save(!resetState);
    line.styles = result.styles;
    if (result.classes) { line.styleClasses = result.classes; }
    else if (line.styleClasses) { line.styleClasses = null; }
    if (updateFrontier === cm.doc.highlightFrontier)
      { cm.doc.modeFrontier = Math.max(cm.doc.modeFrontier, ++cm.doc.highlightFrontier); }
  }
  return line.styles
}

function getContextBefore(cm, n, precise) {
  var doc = cm.doc, display = cm.display;
  if (!doc.mode.startState) { return new Context(doc, true, n) }
  var start = findStartLine(cm, n, precise);
  var saved = start > doc.first && getLine(doc, start - 1).stateAfter;
  var context = saved ? Context.fromSaved(doc, saved, start) : new Context(doc, startState(doc.mode), start);

  doc.iter(start, n, function (line) {
    processLine(cm, line.text, context);
    var pos = context.line;
    line.stateAfter = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo ? context.save() : null;
    context.nextLine();
  });
  if (precise) { doc.modeFrontier = context.line; }
  return context
}

// Lightweight form of highlight -- proceed over this line and
// update state, but don't save a style array. Used for lines that
// aren't currently visible.
function processLine(cm, text, context, startAt) {
  var mode = cm.doc.mode;
  var stream = new StringStream(text, cm.options.tabSize, context);
  stream.start = stream.pos = startAt || 0;
  if (text == "") { callBlankLine(mode, context.state); }
  while (!stream.eol()) {
    readToken(mode, stream, context.state);
    stream.start = stream.pos;
  }
}

function callBlankLine(mode, state) {
  if (mode.blankLine) { return mode.blankLine(state) }
  if (!mode.innerMode) { return }
  var inner = innerMode(mode, state);
  if (inner.mode.blankLine) { return inner.mode.blankLine(inner.state) }
}

function readToken(mode, stream, state, inner) {
  for (var i = 0; i < 10; i++) {
    if (inner) { inner[0] = innerMode(mode, state).mode; }
    var style = mode.token(stream, state);
    if (stream.pos > stream.start) { return style }
  }
  throw new Error("Mode " + mode.name + " failed to advance stream.")
}

var Token = function(stream, type, state) {
  this.start = stream.start; this.end = stream.pos;
  this.string = stream.current();
  this.type = type || null;
  this.state = state;
};

// Utility for getTokenAt and getLineTokens
function takeToken(cm, pos, precise, asArray) {
  var doc = cm.doc, mode = doc.mode, style;
  pos = clipPos(doc, pos);
  var line = getLine(doc, pos.line), context = getContextBefore(cm, pos.line, precise);
  var stream = new StringStream(line.text, cm.options.tabSize, context), tokens;
  if (asArray) { tokens = []; }
  while ((asArray || stream.pos < pos.ch) && !stream.eol()) {
    stream.start = stream.pos;
    style = readToken(mode, stream, context.state);
    if (asArray) { tokens.push(new Token(stream, style, copyState(doc.mode, context.state))); }
  }
  return asArray ? tokens : new Token(stream, style, context.state)
}

function extractLineClasses(type, output) {
  if (type) { for (;;) {
    var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/);
    if (!lineClass) { break }
    type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length);
    var prop = lineClass[1] ? "bgClass" : "textClass";
    if (output[prop] == null)
      { output[prop] = lineClass[2]; }
    else if (!(new RegExp("(?:^|\s)" + lineClass[2] + "(?:$|\s)")).test(output[prop]))
      { output[prop] += " " + lineClass[2]; }
  } }
  return type
}

// Run the given mode's parser over a line, calling f for each token.
function runMode(cm, text, mode, context, f, lineClasses, forceToEnd) {
  var flattenSpans = mode.flattenSpans;
  if (flattenSpans == null) { flattenSpans = cm.options.flattenSpans; }
  var curStart = 0, curStyle = null;
  var stream = new StringStream(text, cm.options.tabSize, context), style;
  var inner = cm.options.addModeClass && [null];
  if (text == "") { extractLineClasses(callBlankLine(mode, context.state), lineClasses); }
  while (!stream.eol()) {
    if (stream.pos > cm.options.maxHighlightLength) {
      flattenSpans = false;
      if (forceToEnd) { processLine(cm, text, context, stream.pos); }
      stream.pos = text.length;
      style = null;
    } else {
      style = extractLineClasses(readToken(mode, stream, context.state, inner), lineClasses);
    }
    if (inner) {
      var mName = inner[0].name;
      if (mName) { style = "m-" + (style ? mName + " " + style : mName); }
    }
    if (!flattenSpans || curStyle != style) {
      while (curStart < stream.start) {
        curStart = Math.min(stream.start, curStart + 5000);
        f(curStart, curStyle);
      }
      curStyle = style;
    }
    stream.start = stream.pos;
  }
  while (curStart < stream.pos) {
    // Webkit seems to refuse to render text nodes longer than 57444
    // characters, and returns inaccurate measurements in nodes
    // starting around 5000 chars.
    var pos = Math.min(stream.pos, curStart + 5000);
    f(pos, curStyle);
    curStart = pos;
  }
}

// Finds the line to start with when starting a parse. Tries to
// find a line with a stateAfter, so that it can start with a
// valid state. If that fails, it returns the line with the
// smallest indentation, which tends to need the least context to
// parse correctly.
function findStartLine(cm, n, precise) {
  var minindent, minline, doc = cm.doc;
  var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1000 : 100);
  for (var search = n; search > lim; --search) {
    if (search <= doc.first) { return doc.first }
    var line = getLine(doc, search - 1), after = line.stateAfter;
    if (after && (!precise || search + (after instanceof SavedContext ? after.lookAhead : 0) <= doc.modeFrontier))
      { return search }
    var indented = countColumn(line.text, null, cm.options.tabSize);
    if (minline == null || minindent > indented) {
      minline = search - 1;
      minindent = indented;
    }
  }
  return minline
}

function retreatFrontier(doc, n) {
  doc.modeFrontier = Math.min(doc.modeFrontier, n);
  if (doc.highlightFrontier < n - 10) { return }
  var start = doc.first;
  for (var line = n - 1; line > start; line--) {
    var saved = getLine(doc, line).stateAfter;
    // change is on 3
    // state on line 1 looked ahead 2 -- so saw 3
    // test 1 + 2 < 3 should cover this
    if (saved && (!(saved instanceof SavedContext) || line + saved.lookAhead < n)) {
      start = line + 1;
      break
    }
  }
  doc.highlightFrontier = Math.min(doc.highlightFrontier, start);
}

// LINE DATA STRUCTURE

// Line objects. These hold state related to a line, including
// highlighting info (the styles array).
var Line = function(text, markedSpans, estimateHeight) {
  this.text = text;
  attachMarkedSpans(this, markedSpans);
  this.height = estimateHeight ? estimateHeight(this) : 1;
};

Line.prototype.lineNo = function () { return lineNo(this) };
eventMixin(Line);

// Change the content (text, markers) of a line. Automatically
// invalidates cached information and tries to re-estimate the
// line's height.
function updateLine(line, text, markedSpans, estimateHeight) {
  line.text = text;
  if (line.stateAfter) { line.stateAfter = null; }
  if (line.styles) { line.styles = null; }
  if (line.order != null) { line.order = null; }
  detachMarkedSpans(line);
  attachMarkedSpans(line, markedSpans);
  var estHeight = estimateHeight ? estimateHeight(line) : 1;
  if (estHeight != line.height) { updateLineHeight(line, estHeight); }
}

// Detach a line from the document tree and its markers.
function cleanUpLine(line) {
  line.parent = null;
  detachMarkedSpans(line);
}

// Convert a style as returned by a mode (either null, or a string
// containing one or more styles) to a CSS style. This is cached,
// and also looks for line-wide styles.
var styleToClassCache = {};
var styleToClassCacheWithMode = {};
function interpretTokenStyle(style, options) {
  if (!style || /^\s*$/.test(style)) { return null }
  var cache = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache;
  return cache[style] ||
    (cache[style] = style.replace(/\S+/g, "cm-$&"))
}

// Render the DOM representation of the text of a line. Also builds
// up a 'line map', which points at the DOM nodes that represent
// specific stretches of text, and is used by the measuring code.
// The returned object contains the DOM node, this map, and
// information about line-wide styles that were set by the mode.
function buildLineContent(cm, lineView) {
  // The padding-right forces the element to have a 'border', which
  // is needed on Webkit to be able to get line-level bounding
  // rectangles for it (in measureChar).
  var content = eltP("span", null, null, webkit ? "padding-right: .1px" : null);
  var builder = {pre: eltP("pre", [content], "CodeMirror-line"), content: content,
                 col: 0, pos: 0, cm: cm,
                 trailingSpace: false,
                 splitSpaces: (ie || webkit) && cm.getOption("lineWrapping")};
  lineView.measure = {};

  // Iterate over the logical lines that make up this visual line.
  for (var i = 0; i <= (lineView.rest ? lineView.rest.length : 0); i++) {
    var line = i ? lineView.rest[i - 1] : lineView.line, order = (void 0);
    builder.pos = 0;
    builder.addToken = buildToken;
    // Optionally wire in some hacks into the token-rendering
    // algorithm, to deal with browser quirks.
    if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line, cm.doc.direction)))
      { builder.addToken = buildTokenBadBidi(builder.addToken, order); }
    builder.map = [];
    var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line);
    insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate));
    if (line.styleClasses) {
      if (line.styleClasses.bgClass)
        { builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || ""); }
      if (line.styleClasses.textClass)
        { builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || ""); }
    }

    // Ensure at least a single node is present, for measuring.
    if (builder.map.length == 0)
      { builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure))); }

    // Store the map and a cache object for the current logical line
    if (i == 0) {
      lineView.measure.map = builder.map;
      lineView.measure.cache = {};
    } else {
      (lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map)
      ;(lineView.measure.caches || (lineView.measure.caches = [])).push({});
    }
  }

  // See issue #2901
  if (webkit) {
    var last = builder.content.lastChild;
    if (/\bcm-tab\b/.test(last.className) || (last.querySelector && last.querySelector(".cm-tab")))
      { builder.content.className = "cm-tab-wrap-hack"; }
  }

  signal(cm, "renderLine", cm, lineView.line, builder.pre);
  if (builder.pre.className)
    { builder.textClass = joinClasses(builder.pre.className, builder.textClass || ""); }

  return builder
}

function defaultSpecialCharPlaceholder(ch) {
  var token = elt("span", "\u2022", "cm-invalidchar");
  token.title = "\\u" + ch.charCodeAt(0).toString(16);
  token.setAttribute("aria-label", token.title);
  return token
}

// Build up the DOM representation for a single token, and add it to
// the line map. Takes care to render special characters separately.
function buildToken(builder, text, style, startStyle, endStyle, title, css) {
  if (!text) { return }
  var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text;
  var special = builder.cm.state.specialChars, mustWrap = false;
  var content;
  if (!special.test(text)) {
    builder.col += text.length;
    content = document.createTextNode(displayText);
    builder.map.push(builder.pos, builder.pos + text.length, content);
    if (ie && ie_version < 9) { mustWrap = true; }
    builder.pos += text.length;
  } else {
    content = document.createDocumentFragment();
    var pos = 0;
    while (true) {
      special.lastIndex = pos;
      var m = special.exec(text);
      var skipped = m ? m.index - pos : text.length - pos;
      if (skipped) {
        var txt = document.createTextNode(displayText.slice(pos, pos + skipped));
        if (ie && ie_version < 9) { content.appendChild(elt("span", [txt])); }
        else { content.appendChild(txt); }
        builder.map.push(builder.pos, builder.pos + skipped, txt);
        builder.col += skipped;
        builder.pos += skipped;
      }
      if (!m) { break }
      pos += skipped + 1;
      var txt$1 = (void 0);
      if (m[0] == "\t") {
        var tabSize = builder.cm.options.tabSize, tabWidth = tabSize - builder.col % tabSize;
        txt$1 = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"));
        txt$1.setAttribute("role", "presentation");
        txt$1.setAttribute("cm-text", "\t");
        builder.col += tabWidth;
      } else if (m[0] == "\r" || m[0] == "\n") {
        txt$1 = content.appendChild(elt("span", m[0] == "\r" ? "\u240d" : "\u2424", "cm-invalidchar"));
        txt$1.setAttribute("cm-text", m[0]);
        builder.col += 1;
      } else {
        txt$1 = builder.cm.options.specialCharPlaceholder(m[0]);
        txt$1.setAttribute("cm-text", m[0]);
        if (ie && ie_version < 9) { content.appendChild(elt("span", [txt$1])); }
        else { content.appendChild(txt$1); }
        builder.col += 1;
      }
      builder.map.push(builder.pos, builder.pos + 1, txt$1);
      builder.pos++;
    }
  }
  builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32;
  if (style || startStyle || endStyle || mustWrap || css) {
    var fullStyle = style || "";
    if (startStyle) { fullStyle += startStyle; }
    if (endStyle) { fullStyle += endStyle; }
    var token = elt("span", [content], fullStyle, css);
    if (title) { token.title = title; }
    return builder.content.appendChild(token)
  }
  builder.content.appendChild(content);
}

function splitSpaces(text, trailingBefore) {
  if (text.length > 1 && !/  /.test(text)) { return text }
  var spaceBefore = trailingBefore, result = "";
  for (var i = 0; i < text.length; i++) {
    var ch = text.charAt(i);
    if (ch == " " && spaceBefore && (i == text.length - 1 || text.charCodeAt(i + 1) == 32))
      { ch = "\u00a0"; }
    result += ch;
    spaceBefore = ch == " ";
  }
  return result
}

// Work around nonsense dimensions being reported for stretches of
// right-to-left text.
function buildTokenBadBidi(inner, order) {
  return function (builder, text, style, startStyle, endStyle, title, css) {
    style = style ? style + " cm-force-border" : "cm-force-border";
    var start = builder.pos, end = start + text.length;
    for (;;) {
      // Find the part that overlaps with the start of this text
      var part = (void 0);
      for (var i = 0; i < order.length; i++) {
        part = order[i];
        if (part.to > start && part.from <= start) { break }
      }
      if (part.to >= end) { return inner(builder, text, style, startStyle, endStyle, title, css) }
      inner(builder, text.slice(0, part.to - start), style, startStyle, null, title, css);
      startStyle = null;
      text = text.slice(part.to - start);
      start = part.to;
    }
  }
}

function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
  var widget = !ignoreWidget && marker.widgetNode;
  if (widget) { builder.map.push(builder.pos, builder.pos + size, widget); }
  if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
    if (!widget)
      { widget = builder.content.appendChild(document.createElement("span")); }
    widget.setAttribute("cm-marker", marker.id);
  }
  if (widget) {
    builder.cm.display.input.setUneditable(widget);
    builder.content.appendChild(widget);
  }
  builder.pos += size;
  builder.trailingSpace = false;
}

// Outputs a number of spans to make up a line, taking highlighting
// and marked text into account.
function insertLineContent(line, builder, styles) {
  var spans = line.markedSpans, allText = line.text, at = 0;
  if (!spans) {
    for (var i$1 = 1; i$1 < styles.length; i$1+=2)
      { builder.addToken(builder, allText.slice(at, at = styles[i$1]), interpretTokenStyle(styles[i$1+1], builder.cm.options)); }
    return
  }

  var len = allText.length, pos = 0, i = 1, text = "", style, css;
  var nextChange = 0, spanStyle, spanEndStyle, spanStartStyle, title, collapsed;
  for (;;) {
    if (nextChange == pos) { // Update current marker set
      spanStyle = spanEndStyle = spanStartStyle = title = css = "";
      collapsed = null; nextChange = Infinity;
      var foundBookmarks = [], endStyles = (void 0);
      for (var j = 0; j < spans.length; ++j) {
        var sp = spans[j], m = sp.marker;
        if (m.type == "bookmark" && sp.from == pos && m.widgetNode) {
          foundBookmarks.push(m);
        } else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
          if (sp.to != null && sp.to != pos && nextChange > sp.to) {
            nextChange = sp.to;
            spanEndStyle = "";
          }
          if (m.className) { spanStyle += " " + m.className; }
          if (m.css) { css = (css ? css + ";" : "") + m.css; }
          if (m.startStyle && sp.from == pos) { spanStartStyle += " " + m.startStyle; }
          if (m.endStyle && sp.to == nextChange) { (endStyles || (endStyles = [])).push(m.endStyle, sp.to); }
          if (m.title && !title) { title = m.title; }
          if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0))
            { collapsed = sp; }
        } else if (sp.from > pos && nextChange > sp.from) {
          nextChange = sp.from;
        }
      }
      if (endStyles) { for (var j$1 = 0; j$1 < endStyles.length; j$1 += 2)
        { if (endStyles[j$1 + 1] == nextChange) { spanEndStyle += " " + endStyles[j$1]; } } }

      if (!collapsed || collapsed.from == pos) { for (var j$2 = 0; j$2 < foundBookmarks.length; ++j$2)
        { buildCollapsedSpan(builder, 0, foundBookmarks[j$2]); } }
      if (collapsed && (collapsed.from || 0) == pos) {
        buildCollapsedSpan(builder, (collapsed.to == null ? len + 1 : collapsed.to) - pos,
                           collapsed.marker, collapsed.from == null);
        if (collapsed.to == null) { return }
        if (collapsed.to == pos) { collapsed = false; }
      }
    }
    if (pos >= len) { break }

    var upto = Math.min(len, nextChange);
    while (true) {
      if (text) {
        var end = pos + text.length;
        if (!collapsed) {
          var tokenText = end > upto ? text.slice(0, upto - pos) : text;
          builder.addToken(builder, tokenText, style ? style + spanStyle : spanStyle,
                           spanStartStyle, pos + tokenText.length == nextChange ? spanEndStyle : "", title, css);
        }
        if (end >= upto) {text = text.slice(upto - pos); pos = upto; break}
        pos = end;
        spanStartStyle = "";
      }
      text = allText.slice(at, at = styles[i++]);
      style = interpretTokenStyle(styles[i++], builder.cm.options);
    }
  }
}


// These objects are used to represent the visible (currently drawn)
// part of the document. A LineView may correspond to multiple
// logical lines, if those are connected by collapsed ranges.
function LineView(doc, line, lineN) {
  // The starting line
  this.line = line;
  // Continuing lines, if any
  this.rest = visualLineContinued(line);
  // Number of logical lines in this visual line
  this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1;
  this.node = this.text = null;
  this.hidden = lineIsHidden(doc, line);
}

// Create a range of LineView objects for the given lines.
function buildViewArray(cm, from, to) {
  var array = [], nextPos;
  for (var pos = from; pos < to; pos = nextPos) {
    var view = new LineView(cm.doc, getLine(cm.doc, pos), pos);
    nextPos = pos + view.size;
    array.push(view);
  }
  return array
}

var operationGroup = null;

function pushOperation(op) {
  if (operationGroup) {
    operationGroup.ops.push(op);
  } else {
    op.ownsGroup = operationGroup = {
      ops: [op],
      delayedCallbacks: []
    };
  }
}

function fireCallbacksForOps(group) {
  // Calls delayed callbacks and cursorActivity handlers until no
  // new ones appear
  var callbacks = group.delayedCallbacks, i = 0;
  do {
    for (; i < callbacks.length; i++)
      { callbacks[i].call(null); }
    for (var j = 0; j < group.ops.length; j++) {
      var op = group.ops[j];
      if (op.cursorActivityHandlers)
        { while (op.cursorActivityCalled < op.cursorActivityHandlers.length)
          { op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm); } }
    }
  } while (i < callbacks.length)
}

function finishOperation(op, endCb) {
  var group = op.ownsGroup;
  if (!group) { return }

  try { fireCallbacksForOps(group); }
  finally {
    operationGroup = null;
    endCb(group);
  }
}

var orphanDelayedCallbacks = null;

// Often, we want to signal events at a point where we are in the
// middle of some work, but don't want the handler to start calling
// other methods on the editor, which might be in an inconsistent
// state or simply not expect any other events to happen.
// signalLater looks whether there are any handlers, and schedules
// them to be executed when the last operation ends, or, if no
// operation is active, when a timeout fires.
function signalLater(emitter, type /*, values...*/) {
  var arr = getHandlers(emitter, type);
  if (!arr.length) { return }
  var args = Array.prototype.slice.call(arguments, 2), list;
  if (operationGroup) {
    list = operationGroup.delayedCallbacks;
  } else if (orphanDelayedCallbacks) {
    list = orphanDelayedCallbacks;
  } else {
    list = orphanDelayedCallbacks = [];
    setTimeout(fireOrphanDelayed, 0);
  }
  var loop = function ( i ) {
    list.push(function () { return arr[i].apply(null, args); });
  };

  for (var i = 0; i < arr.length; ++i)
    loop( i );
}

function fireOrphanDelayed() {
  var delayed = orphanDelayedCallbacks;
  orphanDelayedCallbacks = null;
  for (var i = 0; i < delayed.length; ++i) { delayed[i](); }
}

// When an aspect of a line changes, a string is added to
// lineView.changes. This updates the relevant part of the line's
// DOM structure.
function updateLineForChanges(cm, lineView, lineN, dims) {
  for (var j = 0; j < lineView.changes.length; j++) {
    var type = lineView.changes[j];
    if (type == "text") { updateLineText(cm, lineView); }
    else if (type == "gutter") { updateLineGutter(cm, lineView, lineN, dims); }
    else if (type == "class") { updateLineClasses(cm, lineView); }
    else if (type == "widget") { updateLineWidgets(cm, lineView, dims); }
  }
  lineView.changes = null;
}

// Lines with gutter elements, widgets or a background class need to
// be wrapped, and have the extra elements added to the wrapper div
function ensureLineWrapped(lineView) {
  if (lineView.node == lineView.text) {
    lineView.node = elt("div", null, null, "position: relative");
    if (lineView.text.parentNode)
      { lineView.text.parentNode.replaceChild(lineView.node, lineView.text); }
    lineView.node.appendChild(lineView.text);
    if (ie && ie_version < 8) { lineView.node.style.zIndex = 2; }
  }
  return lineView.node
}

function updateLineBackground(cm, lineView) {
  var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass;
  if (cls) { cls += " CodeMirror-linebackground"; }
  if (lineView.background) {
    if (cls) { lineView.background.className = cls; }
    else { lineView.background.parentNode.removeChild(lineView.background); lineView.background = null; }
  } else if (cls) {
    var wrap = ensureLineWrapped(lineView);
    lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild);
    cm.display.input.setUneditable(lineView.background);
  }
}

// Wrapper around buildLineContent which will reuse the structure
// in display.externalMeasured when possible.
function getLineContent(cm, lineView) {
  var ext = cm.display.externalMeasured;
  if (ext && ext.line == lineView.line) {
    cm.display.externalMeasured = null;
    lineView.measure = ext.measure;
    return ext.built
  }
  return buildLineContent(cm, lineView)
}

// Redraw the line's text. Interacts with the background and text
// classes because the mode may output tokens that influence these
// classes.
function updateLineText(cm, lineView) {
  var cls = lineView.text.className;
  var built = getLineContent(cm, lineView);
  if (lineView.text == lineView.node) { lineView.node = built.pre; }
  lineView.text.parentNode.replaceChild(built.pre, lineView.text);
  lineView.text = built.pre;
  if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
    lineView.bgClass = built.bgClass;
    lineView.textClass = built.textClass;
    updateLineClasses(cm, lineView);
  } else if (cls) {
    lineView.text.className = cls;
  }
}

function updateLineClasses(cm, lineView) {
  updateLineBackground(cm, lineView);
  if (lineView.line.wrapClass)
    { ensureLineWrapped(lineView).className = lineView.line.wrapClass; }
  else if (lineView.node != lineView.text)
    { lineView.node.className = ""; }
  var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass;
  lineView.text.className = textClass || "";
}

function updateLineGutter(cm, lineView, lineN, dims) {
  if (lineView.gutter) {
    lineView.node.removeChild(lineView.gutter);
    lineView.gutter = null;
  }
  if (lineView.gutterBackground) {
    lineView.node.removeChild(lineView.gutterBackground);
    lineView.gutterBackground = null;
  }
  if (lineView.line.gutterClass) {
    var wrap = ensureLineWrapped(lineView);
    lineView.gutterBackground = elt("div", null, "CodeMirror-gutter-background " + lineView.line.gutterClass,
                                    ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px; width: " + (dims.gutterTotalWidth) + "px"));
    cm.display.input.setUneditable(lineView.gutterBackground);
    wrap.insertBefore(lineView.gutterBackground, lineView.text);
  }
  var markers = lineView.line.gutterMarkers;
  if (cm.options.lineNumbers || markers) {
    var wrap$1 = ensureLineWrapped(lineView);
    var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px"));
    cm.display.input.setUneditable(gutterWrap);
    wrap$1.insertBefore(gutterWrap, lineView.text);
    if (lineView.line.gutterClass)
      { gutterWrap.className += " " + lineView.line.gutterClass; }
    if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"]))
      { lineView.lineNumber = gutterWrap.appendChild(
        elt("div", lineNumberFor(cm.options, lineN),
            "CodeMirror-linenumber CodeMirror-gutter-elt",
            ("left: " + (dims.gutterLeft["CodeMirror-linenumbers"]) + "px; width: " + (cm.display.lineNumInnerWidth) + "px"))); }
    if (markers) { for (var k = 0; k < cm.options.gutters.length; ++k) {
      var id = cm.options.gutters[k], found = markers.hasOwnProperty(id) && markers[id];
      if (found)
        { gutterWrap.appendChild(elt("div", [found], "CodeMirror-gutter-elt",
                                   ("left: " + (dims.gutterLeft[id]) + "px; width: " + (dims.gutterWidth[id]) + "px"))); }
    } }
  }
}

function updateLineWidgets(cm, lineView, dims) {
  if (lineView.alignable) { lineView.alignable = null; }
  for (var node = lineView.node.firstChild, next = (void 0); node; node = next) {
    next = node.nextSibling;
    if (node.className == "CodeMirror-linewidget")
      { lineView.node.removeChild(node); }
  }
  insertLineWidgets(cm, lineView, dims);
}

// Build a line's DOM representation from scratch
function buildLineElement(cm, lineView, lineN, dims) {
  var built = getLineContent(cm, lineView);
  lineView.text = lineView.node = built.pre;
  if (built.bgClass) { lineView.bgClass = built.bgClass; }
  if (built.textClass) { lineView.textClass = built.textClass; }

  updateLineClasses(cm, lineView);
  updateLineGutter(cm, lineView, lineN, dims);
  insertLineWidgets(cm, lineView, dims);
  return lineView.node
}

// A lineView may contain multiple logical lines (when merged by
// collapsed spans). The widgets for all of them need to be drawn.
function insertLineWidgets(cm, lineView, dims) {
  insertLineWidgetsFor(cm, lineView.line, lineView, dims, true);
  if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
    { insertLineWidgetsFor(cm, lineView.rest[i], lineView, dims, false); } }
}

function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
  if (!line.widgets) { return }
  var wrap = ensureLineWrapped(lineView);
  for (var i = 0, ws = line.widgets; i < ws.length; ++i) {
    var widget = ws[i], node = elt("div", [widget.node], "CodeMirror-linewidget");
    if (!widget.handleMouseEvents) { node.setAttribute("cm-ignore-events", "true"); }
    positionLineWidget(widget, node, lineView, dims);
    cm.display.input.setUneditable(node);
    if (allowAbove && widget.above)
      { wrap.insertBefore(node, lineView.gutter || lineView.text); }
    else
      { wrap.appendChild(node); }
    signalLater(widget, "redraw");
  }
}

function positionLineWidget(widget, node, lineView, dims) {
  if (widget.noHScroll) {
    (lineView.alignable || (lineView.alignable = [])).push(node);
    var width = dims.wrapperWidth;
    node.style.left = dims.fixedPos + "px";
    if (!widget.coverGutter) {
      width -= dims.gutterTotalWidth;
      node.style.paddingLeft = dims.gutterTotalWidth + "px";
    }
    node.style.width = width + "px";
  }
  if (widget.coverGutter) {
    node.style.zIndex = 5;
    node.style.position = "relative";
    if (!widget.noHScroll) { node.style.marginLeft = -dims.gutterTotalWidth + "px"; }
  }
}

function widgetHeight(widget) {
  if (widget.height != null) { return widget.height }
  var cm = widget.doc.cm;
  if (!cm) { return 0 }
  if (!contains(document.body, widget.node)) {
    var parentStyle = "position: relative;";
    if (widget.coverGutter)
      { parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;"; }
    if (widget.noHScroll)
      { parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;"; }
    removeChildrenAndAdd(cm.display.measure, elt("div", [widget.node], null, parentStyle));
  }
  return widget.height = widget.node.parentNode.offsetHeight
}

// Return true when the given mouse event happened in a widget
function eventInWidget(display, e) {
  for (var n = e_target(e); n != display.wrapper; n = n.parentNode) {
    if (!n || (n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true") ||
        (n.parentNode == display.sizer && n != display.mover))
      { return true }
  }
}

// POSITION MEASUREMENT

function paddingTop(display) {return display.lineSpace.offsetTop}
function paddingVert(display) {return display.mover.offsetHeight - display.lineSpace.offsetHeight}
function paddingH(display) {
  if (display.cachedPaddingH) { return display.cachedPaddingH }
  var e = removeChildrenAndAdd(display.measure, elt("pre", "x"));
  var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle;
  var data = {left: parseInt(style.paddingLeft), right: parseInt(style.paddingRight)};
  if (!isNaN(data.left) && !isNaN(data.right)) { display.cachedPaddingH = data; }
  return data
}

function scrollGap(cm) { return scrollerGap - cm.display.nativeBarWidth }
function displayWidth(cm) {
  return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth
}
function displayHeight(cm) {
  return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight
}

// Ensure the lineView.wrapping.heights array is populated. This is
// an array of bottom offsets for the lines that make up a drawn
// line. When lineWrapping is on, there might be more than one
// height.
function ensureLineHeights(cm, lineView, rect) {
  var wrapping = cm.options.lineWrapping;
  var curWidth = wrapping && displayWidth(cm);
  if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
    var heights = lineView.measure.heights = [];
    if (wrapping) {
      lineView.measure.width = curWidth;
      var rects = lineView.text.firstChild.getClientRects();
      for (var i = 0; i < rects.length - 1; i++) {
        var cur = rects[i], next = rects[i + 1];
        if (Math.abs(cur.bottom - next.bottom) > 2)
          { heights.push((cur.bottom + next.top) / 2 - rect.top); }
      }
    }
    heights.push(rect.bottom - rect.top);
  }
}

// Find a line map (mapping character offsets to text nodes) and a
// measurement cache for the given line number. (A line view might
// contain multiple lines when collapsed ranges are present.)
function mapFromLineView(lineView, line, lineN) {
  if (lineView.line == line)
    { return {map: lineView.measure.map, cache: lineView.measure.cache} }
  for (var i = 0; i < lineView.rest.length; i++)
    { if (lineView.rest[i] == line)
      { return {map: lineView.measure.maps[i], cache: lineView.measure.caches[i]} } }
  for (var i$1 = 0; i$1 < lineView.rest.length; i$1++)
    { if (lineNo(lineView.rest[i$1]) > lineN)
      { return {map: lineView.measure.maps[i$1], cache: lineView.measure.caches[i$1], before: true} } }
}

// Render a line into the hidden node display.externalMeasured. Used
// when measurement is needed for a line that's not in the viewport.
function updateExternalMeasurement(cm, line) {
  line = visualLine(line);
  var lineN = lineNo(line);
  var view = cm.display.externalMeasured = new LineView(cm.doc, line, lineN);
  view.lineN = lineN;
  var built = view.built = buildLineContent(cm, view);
  view.text = built.pre;
  removeChildrenAndAdd(cm.display.lineMeasure, built.pre);
  return view
}

// Get a {top, bottom, left, right} box (in line-local coordinates)
// for a given character.
function measureChar(cm, line, ch, bias) {
  return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias)
}

// Find a line view that corresponds to the given line number.
function findViewForLine(cm, lineN) {
  if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo)
    { return cm.display.view[findViewIndex(cm, lineN)] }
  var ext = cm.display.externalMeasured;
  if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size)
    { return ext }
}

// Measurement can be split in two steps, the set-up work that
// applies to the whole line, and the measurement of the actual
// character. Functions like coordsChar, that need to do a lot of
// measurements in a row, can thus ensure that the set-up work is
// only done once.
function prepareMeasureForLine(cm, line) {
  var lineN = lineNo(line);
  var view = findViewForLine(cm, lineN);
  if (view && !view.text) {
    view = null;
  } else if (view && view.changes) {
    updateLineForChanges(cm, view, lineN, getDimensions(cm));
    cm.curOp.forceUpdate = true;
  }
  if (!view)
    { view = updateExternalMeasurement(cm, line); }

  var info = mapFromLineView(view, line, lineN);
  return {
    line: line, view: view, rect: null,
    map: info.map, cache: info.cache, before: info.before,
    hasHeights: false
  }
}

// Given a prepared measurement object, measures the position of an
// actual character (or fetches it from the cache).
function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
  if (prepared.before) { ch = -1; }
  var key = ch + (bias || ""), found;
  if (prepared.cache.hasOwnProperty(key)) {
    found = prepared.cache[key];
  } else {
    if (!prepared.rect)
      { prepared.rect = prepared.view.text.getBoundingClientRect(); }
    if (!prepared.hasHeights) {
      ensureLineHeights(cm, prepared.view, prepared.rect);
      prepared.hasHeights = true;
    }
    found = measureCharInner(cm, prepared, ch, bias);
    if (!found.bogus) { prepared.cache[key] = found; }
  }
  return {left: found.left, right: found.right,
          top: varHeight ? found.rtop : found.top,
          bottom: varHeight ? found.rbottom : found.bottom}
}

var nullRect = {left: 0, right: 0, top: 0, bottom: 0};

function nodeAndOffsetInLineMap(map$$1, ch, bias) {
  var node, start, end, collapse, mStart, mEnd;
  // First, search the line map for the text node corresponding to,
  // or closest to, the target character.
  for (var i = 0; i < map$$1.length; i += 3) {
    mStart = map$$1[i];
    mEnd = map$$1[i + 1];
    if (ch < mStart) {
      start = 0; end = 1;
      collapse = "left";
    } else if (ch < mEnd) {
      start = ch - mStart;
      end = start + 1;
    } else if (i == map$$1.length - 3 || ch == mEnd && map$$1[i + 3] > ch) {
      end = mEnd - mStart;
      start = end - 1;
      if (ch >= mEnd) { collapse = "right"; }
    }
    if (start != null) {
      node = map$$1[i + 2];
      if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right"))
        { collapse = bias; }
      if (bias == "left" && start == 0)
        { while (i && map$$1[i - 2] == map$$1[i - 3] && map$$1[i - 1].insertLeft) {
          node = map$$1[(i -= 3) + 2];
          collapse = "left";
        } }
      if (bias == "right" && start == mEnd - mStart)
        { while (i < map$$1.length - 3 && map$$1[i + 3] == map$$1[i + 4] && !map$$1[i + 5].insertLeft) {
          node = map$$1[(i += 3) + 2];
          collapse = "right";
        } }
      break
    }
  }
  return {node: node, start: start, end: end, collapse: collapse, coverStart: mStart, coverEnd: mEnd}
}

function getUsefulRect(rects, bias) {
  var rect = nullRect;
  if (bias == "left") { for (var i = 0; i < rects.length; i++) {
    if ((rect = rects[i]).left != rect.right) { break }
  } } else { for (var i$1 = rects.length - 1; i$1 >= 0; i$1--) {
    if ((rect = rects[i$1]).left != rect.right) { break }
  } }
  return rect
}

function measureCharInner(cm, prepared, ch, bias) {
  var place = nodeAndOffsetInLineMap(prepared.map, ch, bias);
  var node = place.node, start = place.start, end = place.end, collapse = place.collapse;

  var rect;
  if (node.nodeType == 3) { // If it is a text node, use a range to retrieve the coordinates.
    for (var i$1 = 0; i$1 < 4; i$1++) { // Retry a maximum of 4 times when nonsense rectangles are returned
      while (start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start))) { --start; }
      while (place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end))) { ++end; }
      if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart)
        { rect = node.parentNode.getBoundingClientRect(); }
      else
        { rect = getUsefulRect(range(node, start, end).getClientRects(), bias); }
      if (rect.left || rect.right || start == 0) { break }
      end = start;
      start = start - 1;
      collapse = "right";
    }
    if (ie && ie_version < 11) { rect = maybeUpdateRectForZooming(cm.display.measure, rect); }
  } else { // If it is a widget, simply get the box for the whole widget.
    if (start > 0) { collapse = bias = "right"; }
    var rects;
    if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1)
      { rect = rects[bias == "right" ? rects.length - 1 : 0]; }
    else
      { rect = node.getBoundingClientRect(); }
  }
  if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
    var rSpan = node.parentNode.getClientRects()[0];
    if (rSpan)
      { rect = {left: rSpan.left, right: rSpan.left + charWidth(cm.display), top: rSpan.top, bottom: rSpan.bottom}; }
    else
      { rect = nullRect; }
  }

  var rtop = rect.top - prepared.rect.top, rbot = rect.bottom - prepared.rect.top;
  var mid = (rtop + rbot) / 2;
  var heights = prepared.view.measure.heights;
  var i = 0;
  for (; i < heights.length - 1; i++)
    { if (mid < heights[i]) { break } }
  var top = i ? heights[i - 1] : 0, bot = heights[i];
  var result = {left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
                right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
                top: top, bottom: bot};
  if (!rect.left && !rect.right) { result.bogus = true; }
  if (!cm.options.singleCursorHeightPerLine) { result.rtop = rtop; result.rbottom = rbot; }

  return result
}

// Work around problem with bounding client rects on ranges being
// returned incorrectly when zoomed on IE10 and below.
function maybeUpdateRectForZooming(measure, rect) {
  if (!window.screen || screen.logicalXDPI == null ||
      screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure))
    { return rect }
  var scaleX = screen.logicalXDPI / screen.deviceXDPI;
  var scaleY = screen.logicalYDPI / screen.deviceYDPI;
  return {left: rect.left * scaleX, right: rect.right * scaleX,
          top: rect.top * scaleY, bottom: rect.bottom * scaleY}
}

function clearLineMeasurementCacheFor(lineView) {
  if (lineView.measure) {
    lineView.measure.cache = {};
    lineView.measure.heights = null;
    if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
      { lineView.measure.caches[i] = {}; } }
  }
}

function clearLineMeasurementCache(cm) {
  cm.display.externalMeasure = null;
  removeChildren(cm.display.lineMeasure);
  for (var i = 0; i < cm.display.view.length; i++)
    { clearLineMeasurementCacheFor(cm.display.view[i]); }
}

function clearCaches(cm) {
  clearLineMeasurementCache(cm);
  cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null;
  if (!cm.options.lineWrapping) { cm.display.maxLineChanged = true; }
  cm.display.lineNumChars = null;
}

function pageScrollX() {
  // Work around https://bugs.chromium.org/p/chromium/issues/detail?id=489206
  // which causes page_Offset and bounding client rects to use
  // different reference viewports and invalidate our calculations.
  if (chrome && android) { return -(document.body.getBoundingClientRect().left - parseInt(getComputedStyle(document.body).marginLeft)) }
  return window.pageXOffset || (document.documentElement || document.body).scrollLeft
}
function pageScrollY() {
  if (chrome && android) { return -(document.body.getBoundingClientRect().top - parseInt(getComputedStyle(document.body).marginTop)) }
  return window.pageYOffset || (document.documentElement || document.body).scrollTop
}

function widgetTopHeight(lineObj) {
  var height = 0;
  if (lineObj.widgets) { for (var i = 0; i < lineObj.widgets.length; ++i) { if (lineObj.widgets[i].above)
    { height += widgetHeight(lineObj.widgets[i]); } } }
  return height
}

// Converts a {top, bottom, left, right} box from line-local
// coordinates into another coordinate system. Context may be one of
// "line", "div" (display.lineDiv), "local"./null (editor), "window",
// or "page".
function intoCoordSystem(cm, lineObj, rect, context, includeWidgets) {
  if (!includeWidgets) {
    var height = widgetTopHeight(lineObj);
    rect.top += height; rect.bottom += height;
  }
  if (context == "line") { return rect }
  if (!context) { context = "local"; }
  var yOff = heightAtLine(lineObj);
  if (context == "local") { yOff += paddingTop(cm.display); }
  else { yOff -= cm.display.viewOffset; }
  if (context == "page" || context == "window") {
    var lOff = cm.display.lineSpace.getBoundingClientRect();
    yOff += lOff.top + (context == "window" ? 0 : pageScrollY());
    var xOff = lOff.left + (context == "window" ? 0 : pageScrollX());
    rect.left += xOff; rect.right += xOff;
  }
  rect.top += yOff; rect.bottom += yOff;
  return rect
}

// Coverts a box from "div" coords to another coordinate system.
// Context may be "window", "page", "div", or "local"./null.
function fromCoordSystem(cm, coords, context) {
  if (context == "div") { return coords }
  var left = coords.left, top = coords.top;
  // First move into "page" coordinate system
  if (context == "page") {
    left -= pageScrollX();
    top -= pageScrollY();
  } else if (context == "local" || !context) {
    var localBox = cm.display.sizer.getBoundingClientRect();
    left += localBox.left;
    top += localBox.top;
  }

  var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect();
  return {left: left - lineSpaceBox.left, top: top - lineSpaceBox.top}
}

function charCoords(cm, pos, context, lineObj, bias) {
  if (!lineObj) { lineObj = getLine(cm.doc, pos.line); }
  return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context)
}

// Returns a box for a given cursor position, which may have an
// 'other' property containing the position of the secondary cursor
// on a bidi boundary.
// A cursor Pos(line, char, "before") is on the same visual line as `char - 1`
// and after `char - 1` in writing order of `char - 1`
// A cursor Pos(line, char, "after") is on the same visual line as `char`
// and before `char` in writing order of `char`
// Examples (upper-case letters are RTL, lower-case are LTR):
//     Pos(0, 1, ...)
//     before   after
// ab     a|b     a|b
// aB     a|B     aB|
// Ab     |Ab     A|b
// AB     B|A     B|A
// Every position after the last character on a line is considered to stick
// to the last character on the line.
function cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
  lineObj = lineObj || getLine(cm.doc, pos.line);
  if (!preparedMeasure) { preparedMeasure = prepareMeasureForLine(cm, lineObj); }
  function get(ch, right) {
    var m = measureCharPrepared(cm, preparedMeasure, ch, right ? "right" : "left", varHeight);
    if (right) { m.left = m.right; } else { m.right = m.left; }
    return intoCoordSystem(cm, lineObj, m, context)
  }
  var order = getOrder(lineObj, cm.doc.direction), ch = pos.ch, sticky = pos.sticky;
  if (ch >= lineObj.text.length) {
    ch = lineObj.text.length;
    sticky = "before";
  } else if (ch <= 0) {
    ch = 0;
    sticky = "after";
  }
  if (!order) { return get(sticky == "before" ? ch - 1 : ch, sticky == "before") }

  function getBidi(ch, partPos, invert) {
    var part = order[partPos], right = part.level == 1;
    return get(invert ? ch - 1 : ch, right != invert)
  }
  var partPos = getBidiPartAt(order, ch, sticky);
  var other = bidiOther;
  var val = getBidi(ch, partPos, sticky == "before");
  if (other != null) { val.other = getBidi(ch, other, sticky != "before"); }
  return val
}

// Used to cheaply estimate the coordinates for a position. Used for
// intermediate scroll updates.
function estimateCoords(cm, pos) {
  var left = 0;
  pos = clipPos(cm.doc, pos);
  if (!cm.options.lineWrapping) { left = charWidth(cm.display) * pos.ch; }
  var lineObj = getLine(cm.doc, pos.line);
  var top = heightAtLine(lineObj) + paddingTop(cm.display);
  return {left: left, right: left, top: top, bottom: top + lineObj.height}
}

// Positions returned by coordsChar contain some extra information.
// xRel is the relative x position of the input coordinates compared
// to the found position (so xRel > 0 means the coordinates are to
// the right of the character position, for example). When outside
// is true, that means the coordinates lie outside the line's
// vertical range.
function PosWithInfo(line, ch, sticky, outside, xRel) {
  var pos = Pos(line, ch, sticky);
  pos.xRel = xRel;
  if (outside) { pos.outside = true; }
  return pos
}

// Compute the character position closest to the given coordinates.
// Input must be lineSpace-local ("div" coordinate system).
function coordsChar(cm, x, y) {
  var doc = cm.doc;
  y += cm.display.viewOffset;
  if (y < 0) { return PosWithInfo(doc.first, 0, null, true, -1) }
  var lineN = lineAtHeight(doc, y), last = doc.first + doc.size - 1;
  if (lineN > last)
    { return PosWithInfo(doc.first + doc.size - 1, getLine(doc, last).text.length, null, true, 1) }
  if (x < 0) { x = 0; }

  var lineObj = getLine(doc, lineN);
  for (;;) {
    var found = coordsCharInner(cm, lineObj, lineN, x, y);
    var collapsed = collapsedSpanAround(lineObj, found.ch + (found.xRel > 0 ? 1 : 0));
    if (!collapsed) { return found }
    var rangeEnd = collapsed.find(1);
    if (rangeEnd.line == lineN) { return rangeEnd }
    lineObj = getLine(doc, lineN = rangeEnd.line);
  }
}

function wrappedLineExtent(cm, lineObj, preparedMeasure, y) {
  y -= widgetTopHeight(lineObj);
  var end = lineObj.text.length;
  var begin = findFirst(function (ch) { return measureCharPrepared(cm, preparedMeasure, ch - 1).bottom <= y; }, end, 0);
  end = findFirst(function (ch) { return measureCharPrepared(cm, preparedMeasure, ch).top > y; }, begin, end);
  return {begin: begin, end: end}
}

function wrappedLineExtentChar(cm, lineObj, preparedMeasure, target) {
  if (!preparedMeasure) { preparedMeasure = prepareMeasureForLine(cm, lineObj); }
  var targetTop = intoCoordSystem(cm, lineObj, measureCharPrepared(cm, preparedMeasure, target), "line").top;
  return wrappedLineExtent(cm, lineObj, preparedMeasure, targetTop)
}

// Returns true if the given side of a box is after the given
// coordinates, in top-to-bottom, left-to-right order.
function boxIsAfter(box, x, y, left) {
  return box.bottom <= y ? false : box.top > y ? true : (left ? box.left : box.right) > x
}

function coordsCharInner(cm, lineObj, lineNo$$1, x, y) {
  // Move y into line-local coordinate space
  y -= heightAtLine(lineObj);
  var preparedMeasure = prepareMeasureForLine(cm, lineObj);
  // When directly calling `measureCharPrepared`, we have to adjust
  // for the widgets at this line.
  var widgetHeight$$1 = widgetTopHeight(lineObj);
  var begin = 0, end = lineObj.text.length, ltr = true;

  var order = getOrder(lineObj, cm.doc.direction);
  // If the line isn't plain left-to-right text, first figure out
  // which bidi section the coordinates fall into.
  if (order) {
    var part = (cm.options.lineWrapping ? coordsBidiPartWrapped : coordsBidiPart)
                 (cm, lineObj, lineNo$$1, preparedMeasure, order, x, y);
    ltr = part.level != 1;
    // The awkward -1 offsets are needed because findFirst (called
    // on these below) will treat its first bound as inclusive,
    // second as exclusive, but we want to actually address the
    // characters in the part's range
    begin = ltr ? part.from : part.to - 1;
    end = ltr ? part.to : part.from - 1;
  }

  // A binary search to find the first character whose bounding box
  // starts after the coordinates. If we run across any whose box wrap
  // the coordinates, store that.
  var chAround = null, boxAround = null;
  var ch = findFirst(function (ch) {
    var box = measureCharPrepared(cm, preparedMeasure, ch);
    box.top += widgetHeight$$1; box.bottom += widgetHeight$$1;
    if (!boxIsAfter(box, x, y, false)) { return false }
    if (box.top <= y && box.left <= x) {
      chAround = ch;
      boxAround = box;
    }
    return true
  }, begin, end);

  var baseX, sticky, outside = false;
  // If a box around the coordinates was found, use that
  if (boxAround) {
    // Distinguish coordinates nearer to the left or right side of the box
    var atLeft = x - boxAround.left < boxAround.right - x, atStart = atLeft == ltr;
    ch = chAround + (atStart ? 0 : 1);
    sticky = atStart ? "after" : "before";
    baseX = atLeft ? boxAround.left : boxAround.right;
  } else {
    // (Adjust for extended bound, if necessary.)
    if (!ltr && (ch == end || ch == begin)) { ch++; }
    // To determine which side to associate with, get the box to the
    // left of the character and compare it's vertical position to the
    // coordinates
    sticky = ch == 0 ? "after" : ch == lineObj.text.length ? "before" :
      (measureCharPrepared(cm, preparedMeasure, ch - (ltr ? 1 : 0)).bottom + widgetHeight$$1 <= y) == ltr ?
      "after" : "before";
    // Now get accurate coordinates for this place, in order to get a
    // base X position
    var coords = cursorCoords(cm, Pos(lineNo$$1, ch, sticky), "line", lineObj, preparedMeasure);
    baseX = coords.left;
    outside = y < coords.top || y >= coords.bottom;
  }

  ch = skipExtendingChars(lineObj.text, ch, 1);
  return PosWithInfo(lineNo$$1, ch, sticky, outside, x - baseX)
}

function coordsBidiPart(cm, lineObj, lineNo$$1, preparedMeasure, order, x, y) {
  // Bidi parts are sorted left-to-right, and in a non-line-wrapping
  // situation, we can take this ordering to correspond to the visual
  // ordering. This finds the first part whose end is after the given
  // coordinates.
  var index = findFirst(function (i) {
    var part = order[i], ltr = part.level != 1;
    return boxIsAfter(cursorCoords(cm, Pos(lineNo$$1, ltr ? part.to : part.from, ltr ? "before" : "after"),
                                   "line", lineObj, preparedMeasure), x, y, true)
  }, 0, order.length - 1);
  var part = order[index];
  // If this isn't the first part, the part's start is also after
  // the coordinates, and the coordinates aren't on the same line as
  // that start, move one part back.
  if (index > 0) {
    var ltr = part.level != 1;
    var start = cursorCoords(cm, Pos(lineNo$$1, ltr ? part.from : part.to, ltr ? "after" : "before"),
                             "line", lineObj, preparedMeasure);
    if (boxIsAfter(start, x, y, true) && start.top > y)
      { part = order[index - 1]; }
  }
  return part
}

function coordsBidiPartWrapped(cm, lineObj, _lineNo, preparedMeasure, order, x, y) {
  // In a wrapped line, rtl text on wrapping boundaries can do things
  // that don't correspond to the ordering in our `order` array at
  // all, so a binary search doesn't work, and we want to return a
  // part that only spans one line so that the binary search in
  // coordsCharInner is safe. As such, we first find the extent of the
  // wrapped line, and then do a flat search in which we discard any
  // spans that aren't on the line.
  var ref = wrappedLineExtent(cm, lineObj, preparedMeasure, y);
  var begin = ref.begin;
  var end = ref.end;
  if (/\s/.test(lineObj.text.charAt(end - 1))) { end--; }
  var part = null, closestDist = null;
  for (var i = 0; i < order.length; i++) {
    var p = order[i];
    if (p.from >= end || p.to <= begin) { continue }
    var ltr = p.level != 1;
    var endX = measureCharPrepared(cm, preparedMeasure, ltr ? Math.min(end, p.to) - 1 : Math.max(begin, p.from)).right;
    // Weigh against spans ending before this, so that they are only
    // picked if nothing ends after
    var dist = endX < x ? x - endX + 1e9 : endX - x;
    if (!part || closestDist > dist) {
      part = p;
      closestDist = dist;
    }
  }
  if (!part) { part = order[order.length - 1]; }
  // Clip the part to the wrapped line.
  if (part.from < begin) { part = {from: begin, to: part.to, level: part.level}; }
  if (part.to > end) { part = {from: part.from, to: end, level: part.level}; }
  return part
}

var measureText;
// Compute the default text height.
function textHeight(display) {
  if (display.cachedTextHeight != null) { return display.cachedTextHeight }
  if (measureText == null) {
    measureText = elt("pre");
    // Measure a bunch of lines, for browsers that compute
    // fractional heights.
    for (var i = 0; i < 49; ++i) {
      measureText.appendChild(document.createTextNode("x"));
      measureText.appendChild(elt("br"));
    }
    measureText.appendChild(document.createTextNode("x"));
  }
  removeChildrenAndAdd(display.measure, measureText);
  var height = measureText.offsetHeight / 50;
  if (height > 3) { display.cachedTextHeight = height; }
  removeChildren(display.measure);
  return height || 1
}

// Compute the default character width.
function charWidth(display) {
  if (display.cachedCharWidth != null) { return display.cachedCharWidth }
  var anchor = elt("span", "xxxxxxxxxx");
  var pre = elt("pre", [anchor]);
  removeChildrenAndAdd(display.measure, pre);
  var rect = anchor.getBoundingClientRect(), width = (rect.right - rect.left) / 10;
  if (width > 2) { display.cachedCharWidth = width; }
  return width || 10
}

// Do a bulk-read of the DOM positions and sizes needed to draw the
// view, so that we don't interleave reading and writing to the DOM.
function getDimensions(cm) {
  var d = cm.display, left = {}, width = {};
  var gutterLeft = d.gutters.clientLeft;
  for (var n = d.gutters.firstChild, i = 0; n; n = n.nextSibling, ++i) {
    left[cm.options.gutters[i]] = n.offsetLeft + n.clientLeft + gutterLeft;
    width[cm.options.gutters[i]] = n.clientWidth;
  }
  return {fixedPos: compensateForHScroll(d),
          gutterTotalWidth: d.gutters.offsetWidth,
          gutterLeft: left,
          gutterWidth: width,
          wrapperWidth: d.wrapper.clientWidth}
}

// Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
// but using getBoundingClientRect to get a sub-pixel-accurate
// result.
function compensateForHScroll(display) {
  return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left
}

// Returns a function that estimates the height of a line, to use as
// first approximation until the line becomes visible (and is thus
// properly measurable).
function estimateHeight(cm) {
  var th = textHeight(cm.display), wrapping = cm.options.lineWrapping;
  var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3);
  return function (line) {
    if (lineIsHidden(cm.doc, line)) { return 0 }

    var widgetsHeight = 0;
    if (line.widgets) { for (var i = 0; i < line.widgets.length; i++) {
      if (line.widgets[i].height) { widgetsHeight += line.widgets[i].height; }
    } }

    if (wrapping)
      { return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th }
    else
      { return widgetsHeight + th }
  }
}

function estimateLineHeights(cm) {
  var doc = cm.doc, est = estimateHeight(cm);
  doc.iter(function (line) {
    var estHeight = est(line);
    if (estHeight != line.height) { updateLineHeight(line, estHeight); }
  });
}

// Given a mouse event, find the corresponding position. If liberal
// is false, it checks whether a gutter or scrollbar was clicked,
// and returns null if it was. forRect is used by rectangular
// selections, and tries to estimate a character position even for
// coordinates beyond the right of the text.
function posFromMouse(cm, e, liberal, forRect) {
  var display = cm.display;
  if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") { return null }

  var x, y, space = display.lineSpace.getBoundingClientRect();
  // Fails unpredictably on IE[67] when mouse is dragged around quickly.
  try { x = e.clientX - space.left; y = e.clientY - space.top; }
  catch (e) { return null }
  var coords = coordsChar(cm, x, y), line;
  if (forRect && coords.xRel == 1 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
    var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length;
    coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff));
  }
  return coords
}

// Find the view element corresponding to a given line. Return null
// when the line isn't visible.
function findViewIndex(cm, n) {
  if (n >= cm.display.viewTo) { return null }
  n -= cm.display.viewFrom;
  if (n < 0) { return null }
  var view = cm.display.view;
  for (var i = 0; i < view.length; i++) {
    n -= view[i].size;
    if (n < 0) { return i }
  }
}

function updateSelection(cm) {
  cm.display.input.showSelection(cm.display.input.prepareSelection());
}

function prepareSelection(cm, primary) {
  if ( primary === void 0 ) primary = true;

  var doc = cm.doc, result = {};
  var curFragment = result.cursors = document.createDocumentFragment();
  var selFragment = result.selection = document.createDocumentFragment();

  for (var i = 0; i < doc.sel.ranges.length; i++) {
    if (!primary && i == doc.sel.primIndex) { continue }
    var range$$1 = doc.sel.ranges[i];
    if (range$$1.from().line >= cm.display.viewTo || range$$1.to().line < cm.display.viewFrom) { continue }
    var collapsed = range$$1.empty();
    if (collapsed || cm.options.showCursorWhenSelecting)
      { drawSelectionCursor(cm, range$$1.head, curFragment); }
    if (!collapsed)
      { drawSelectionRange(cm, range$$1, selFragment); }
  }
  return result
}

// Draws a cursor for the given range
function drawSelectionCursor(cm, head, output) {
  var pos = cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine);

  var cursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor"));
  cursor.style.left = pos.left + "px";
  cursor.style.top = pos.top + "px";
  cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px";

  if (pos.other) {
    // Secondary cursor, shown when on a 'jump' in bi-directional text
    var otherCursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor CodeMirror-secondarycursor"));
    otherCursor.style.display = "";
    otherCursor.style.left = pos.other.left + "px";
    otherCursor.style.top = pos.other.top + "px";
    otherCursor.style.height = (pos.other.bottom - pos.other.top) * .85 + "px";
  }
}

function cmpCoords(a, b) { return a.top - b.top || a.left - b.left }

// Draws the given range as a highlighted selection
function drawSelectionRange(cm, range$$1, output) {
  var display = cm.display, doc = cm.doc;
  var fragment = document.createDocumentFragment();
  var padding = paddingH(cm.display), leftSide = padding.left;
  var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right;
  var docLTR = doc.direction == "ltr";

  function add(left, top, width, bottom) {
    if (top < 0) { top = 0; }
    top = Math.round(top);
    bottom = Math.round(bottom);
    fragment.appendChild(elt("div", null, "CodeMirror-selected", ("position: absolute; left: " + left + "px;\n                             top: " + top + "px; width: " + (width == null ? rightSide - left : width) + "px;\n                             height: " + (bottom - top) + "px")));
  }

  function drawForLine(line, fromArg, toArg) {
    var lineObj = getLine(doc, line);
    var lineLen = lineObj.text.length;
    var start, end;
    function coords(ch, bias) {
      return charCoords(cm, Pos(line, ch), "div", lineObj, bias)
    }

    function wrapX(pos, dir, side) {
      var extent = wrappedLineExtentChar(cm, lineObj, null, pos);
      var prop = (dir == "ltr") == (side == "after") ? "left" : "right";
      var ch = side == "after" ? extent.begin : extent.end - (/\s/.test(lineObj.text.charAt(extent.end - 1)) ? 2 : 1);
      return coords(ch, prop)[prop]
    }

    var order = getOrder(lineObj, doc.direction);
    iterateBidiSections(order, fromArg || 0, toArg == null ? lineLen : toArg, function (from, to, dir, i) {
      var ltr = dir == "ltr";
      var fromPos = coords(from, ltr ? "left" : "right");
      var toPos = coords(to - 1, ltr ? "right" : "left");

      var openStart = fromArg == null && from == 0, openEnd = toArg == null && to == lineLen;
      var first = i == 0, last = !order || i == order.length - 1;
      if (toPos.top - fromPos.top <= 3) { // Single line
        var openLeft = (docLTR ? openStart : openEnd) && first;
        var openRight = (docLTR ? openEnd : openStart) && last;
        var left = openLeft ? leftSide : (ltr ? fromPos : toPos).left;
        var right = openRight ? rightSide : (ltr ? toPos : fromPos).right;
        add(left, fromPos.top, right - left, fromPos.bottom);
      } else { // Multiple lines
        var topLeft, topRight, botLeft, botRight;
        if (ltr) {
          topLeft = docLTR && openStart && first ? leftSide : fromPos.left;
          topRight = docLTR ? rightSide : wrapX(from, dir, "before");
          botLeft = docLTR ? leftSide : wrapX(to, dir, "after");
          botRight = docLTR && openEnd && last ? rightSide : toPos.right;
        } else {
          topLeft = !docLTR ? leftSide : wrapX(from, dir, "before");
          topRight = !docLTR && openStart && first ? rightSide : fromPos.right;
          botLeft = !docLTR && openEnd && last ? leftSide : toPos.left;
          botRight = !docLTR ? rightSide : wrapX(to, dir, "after");
        }
        add(topLeft, fromPos.top, topRight - topLeft, fromPos.bottom);
        if (fromPos.bottom < toPos.top) { add(leftSide, fromPos.bottom, null, toPos.top); }
        add(botLeft, toPos.top, botRight - botLeft, toPos.bottom);
      }

      if (!start || cmpCoords(fromPos, start) < 0) { start = fromPos; }
      if (cmpCoords(toPos, start) < 0) { start = toPos; }
      if (!end || cmpCoords(fromPos, end) < 0) { end = fromPos; }
      if (cmpCoords(toPos, end) < 0) { end = toPos; }
    });
    return {start: start, end: end}
  }

  var sFrom = range$$1.from(), sTo = range$$1.to();
  if (sFrom.line == sTo.line) {
    drawForLine(sFrom.line, sFrom.ch, sTo.ch);
  } else {
    var fromLine = getLine(doc, sFrom.line), toLine = getLine(doc, sTo.line);
    var singleVLine = visualLine(fromLine) == visualLine(toLine);
    var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end;
    var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start;
    if (singleVLine) {
      if (leftEnd.top < rightStart.top - 2) {
        add(leftEnd.right, leftEnd.top, null, leftEnd.bottom);
        add(leftSide, rightStart.top, rightStart.left, rightStart.bottom);
      } else {
        add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom);
      }
    }
    if (leftEnd.bottom < rightStart.top)
      { add(leftSide, leftEnd.bottom, null, rightStart.top); }
  }

  output.appendChild(fragment);
}

// Cursor-blinking
function restartBlink(cm) {
  if (!cm.state.focused) { return }
  var display = cm.display;
  clearInterval(display.blinker);
  var on = true;
  display.cursorDiv.style.visibility = "";
  if (cm.options.cursorBlinkRate > 0)
    { display.blinker = setInterval(function () { return display.cursorDiv.style.visibility = (on = !on) ? "" : "hidden"; },
      cm.options.cursorBlinkRate); }
  else if (cm.options.cursorBlinkRate < 0)
    { display.cursorDiv.style.visibility = "hidden"; }
}

function ensureFocus(cm) {
  if (!cm.state.focused) { cm.display.input.focus(); onFocus(cm); }
}

function delayBlurEvent(cm) {
  cm.state.delayingBlurEvent = true;
  setTimeout(function () { if (cm.state.delayingBlurEvent) {
    cm.state.delayingBlurEvent = false;
    onBlur(cm);
  } }, 100);
}

function onFocus(cm, e) {
  if (cm.state.delayingBlurEvent) { cm.state.delayingBlurEvent = false; }

  if (cm.options.readOnly == "nocursor") { return }
  if (!cm.state.focused) {
    signal(cm, "focus", cm, e);
    cm.state.focused = true;
    addClass(cm.display.wrapper, "CodeMirror-focused");
    // This test prevents this from firing when a context
    // menu is closed (since the input reset would kill the
    // select-all detection hack)
    if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
      cm.display.input.reset();
      if (webkit) { setTimeout(function () { return cm.display.input.reset(true); }, 20); } // Issue #1730
    }
    cm.display.input.receivedFocus();
  }
  restartBlink(cm);
}
function onBlur(cm, e) {
  if (cm.state.delayingBlurEvent) { return }

  if (cm.state.focused) {
    signal(cm, "blur", cm, e);
    cm.state.focused = false;
    rmClass(cm.display.wrapper, "CodeMirror-focused");
  }
  clearInterval(cm.display.blinker);
  setTimeout(function () { if (!cm.state.focused) { cm.display.shift = false; } }, 150);
}

// Read the actual heights of the rendered lines, and update their
// stored heights to match.
function updateHeightsInViewport(cm) {
  var display = cm.display;
  var prevBottom = display.lineDiv.offsetTop;
  for (var i = 0; i < display.view.length; i++) {
    var cur = display.view[i], height = (void 0);
    if (cur.hidden) { continue }
    if (ie && ie_version < 8) {
      var bot = cur.node.offsetTop + cur.node.offsetHeight;
      height = bot - prevBottom;
      prevBottom = bot;
    } else {
      var box = cur.node.getBoundingClientRect();
      height = box.bottom - box.top;
    }
    var diff = cur.line.height - height;
    if (height < 2) { height = textHeight(display); }
    if (diff > .005 || diff < -.005) {
      updateLineHeight(cur.line, height);
      updateWidgetHeight(cur.line);
      if (cur.rest) { for (var j = 0; j < cur.rest.length; j++)
        { updateWidgetHeight(cur.rest[j]); } }
    }
  }
}

// Read and store the height of line widgets associated with the
// given line.
function updateWidgetHeight(line) {
  if (line.widgets) { for (var i = 0; i < line.widgets.length; ++i) {
    var w = line.widgets[i], parent = w.node.parentNode;
    if (parent) { w.height = parent.offsetHeight; }
  } }
}

// Compute the lines that are visible in a given viewport (defaults
// the the current scroll position). viewport may contain top,
// height, and ensure (see op.scrollToPos) properties.
function visibleLines(display, doc, viewport) {
  var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop;
  top = Math.floor(top - paddingTop(display));
  var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight;

  var from = lineAtHeight(doc, top), to = lineAtHeight(doc, bottom);
  // Ensure is a {from: {line, ch}, to: {line, ch}} object, and
  // forces those lines into the viewport (if possible).
  if (viewport && viewport.ensure) {
    var ensureFrom = viewport.ensure.from.line, ensureTo = viewport.ensure.to.line;
    if (ensureFrom < from) {
      from = ensureFrom;
      to = lineAtHeight(doc, heightAtLine(getLine(doc, ensureFrom)) + display.wrapper.clientHeight);
    } else if (Math.min(ensureTo, doc.lastLine()) >= to) {
      from = lineAtHeight(doc, heightAtLine(getLine(doc, ensureTo)) - display.wrapper.clientHeight);
      to = ensureTo;
    }
  }
  return {from: from, to: Math.max(to, from + 1)}
}

// Re-align line numbers and gutter marks to compensate for
// horizontal scrolling.
function alignHorizontally(cm) {
  var display = cm.display, view = display.view;
  if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) { return }
  var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft;
  var gutterW = display.gutters.offsetWidth, left = comp + "px";
  for (var i = 0; i < view.length; i++) { if (!view[i].hidden) {
    if (cm.options.fixedGutter) {
      if (view[i].gutter)
        { view[i].gutter.style.left = left; }
      if (view[i].gutterBackground)
        { view[i].gutterBackground.style.left = left; }
    }
    var align = view[i].alignable;
    if (align) { for (var j = 0; j < align.length; j++)
      { align[j].style.left = left; } }
  } }
  if (cm.options.fixedGutter)
    { display.gutters.style.left = (comp + gutterW) + "px"; }
}

// Used to ensure that the line number gutter is still the right
// size for the current document size. Returns true when an update
// is needed.
function maybeUpdateLineNumberWidth(cm) {
  if (!cm.options.lineNumbers) { return false }
  var doc = cm.doc, last = lineNumberFor(cm.options, doc.first + doc.size - 1), display = cm.display;
  if (last.length != display.lineNumChars) {
    var test = display.measure.appendChild(elt("div", [elt("div", last)],
                                               "CodeMirror-linenumber CodeMirror-gutter-elt"));
    var innerW = test.firstChild.offsetWidth, padding = test.offsetWidth - innerW;
    display.lineGutter.style.width = "";
    display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1;
    display.lineNumWidth = display.lineNumInnerWidth + padding;
    display.lineNumChars = display.lineNumInnerWidth ? last.length : -1;
    display.lineGutter.style.width = display.lineNumWidth + "px";
    updateGutterSpace(cm);
    return true
  }
  return false
}

// SCROLLING THINGS INTO VIEW

// If an editor sits on the top or bottom of the window, partially
// scrolled out of view, this ensures that the cursor is visible.
function maybeScrollWindow(cm, rect) {
  if (signalDOMEvent(cm, "scrollCursorIntoView")) { return }

  var display = cm.display, box = display.sizer.getBoundingClientRect(), doScroll = null;
  if (rect.top + box.top < 0) { doScroll = true; }
  else if (rect.bottom + box.top > (window.innerHeight || document.documentElement.clientHeight)) { doScroll = false; }
  if (doScroll != null && !phantom) {
    var scrollNode = elt("div", "\u200b", null, ("position: absolute;\n                         top: " + (rect.top - display.viewOffset - paddingTop(cm.display)) + "px;\n                         height: " + (rect.bottom - rect.top + scrollGap(cm) + display.barHeight) + "px;\n                         left: " + (rect.left) + "px; width: " + (Math.max(2, rect.right - rect.left)) + "px;"));
    cm.display.lineSpace.appendChild(scrollNode);
    scrollNode.scrollIntoView(doScroll);
    cm.display.lineSpace.removeChild(scrollNode);
  }
}

// Scroll a given position into view (immediately), verifying that
// it actually became visible (as line heights are accurately
// measured, the position of something may 'drift' during drawing).
function scrollPosIntoView(cm, pos, end, margin) {
  if (margin == null) { margin = 0; }
  var rect;
  if (!cm.options.lineWrapping && pos == end) {
    // Set pos and end to the cursor positions around the character pos sticks to
    // If pos.sticky == "before", that is around pos.ch - 1, otherwise around pos.ch
    // If pos == Pos(_, 0, "before"), pos and end are unchanged
    pos = pos.ch ? Pos(pos.line, pos.sticky == "before" ? pos.ch - 1 : pos.ch, "after") : pos;
    end = pos.sticky == "before" ? Pos(pos.line, pos.ch + 1, "before") : pos;
  }
  for (var limit = 0; limit < 5; limit++) {
    var changed = false;
    var coords = cursorCoords(cm, pos);
    var endCoords = !end || end == pos ? coords : cursorCoords(cm, end);
    rect = {left: Math.min(coords.left, endCoords.left),
            top: Math.min(coords.top, endCoords.top) - margin,
            right: Math.max(coords.left, endCoords.left),
            bottom: Math.max(coords.bottom, endCoords.bottom) + margin};
    var scrollPos = calculateScrollPos(cm, rect);
    var startTop = cm.doc.scrollTop, startLeft = cm.doc.scrollLeft;
    if (scrollPos.scrollTop != null) {
      updateScrollTop(cm, scrollPos.scrollTop);
      if (Math.abs(cm.doc.scrollTop - startTop) > 1) { changed = true; }
    }
    if (scrollPos.scrollLeft != null) {
      setScrollLeft(cm, scrollPos.scrollLeft);
      if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) { changed = true; }
    }
    if (!changed) { break }
  }
  return rect
}

// Scroll a given set of coordinates into view (immediately).
function scrollIntoView(cm, rect) {
  var scrollPos = calculateScrollPos(cm, rect);
  if (scrollPos.scrollTop != null) { updateScrollTop(cm, scrollPos.scrollTop); }
  if (scrollPos.scrollLeft != null) { setScrollLeft(cm, scrollPos.scrollLeft); }
}

// Calculate a new scroll position needed to scroll the given
// rectangle into view. Returns an object with scrollTop and
// scrollLeft properties. When these are undefined, the
// vertical/horizontal position does not need to be adjusted.
function calculateScrollPos(cm, rect) {
  var display = cm.display, snapMargin = textHeight(cm.display);
  if (rect.top < 0) { rect.top = 0; }
  var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop;
  var screen = displayHeight(cm), result = {};
  if (rect.bottom - rect.top > screen) { rect.bottom = rect.top + screen; }
  var docBottom = cm.doc.height + paddingVert(display);
  var atTop = rect.top < snapMargin, atBottom = rect.bottom > docBottom - snapMargin;
  if (rect.top < screentop) {
    result.scrollTop = atTop ? 0 : rect.top;
  } else if (rect.bottom > screentop + screen) {
    var newTop = Math.min(rect.top, (atBottom ? docBottom : rect.bottom) - screen);
    if (newTop != screentop) { result.scrollTop = newTop; }
  }

  var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft;
  var screenw = displayWidth(cm) - (cm.options.fixedGutter ? display.gutters.offsetWidth : 0);
  var tooWide = rect.right - rect.left > screenw;
  if (tooWide) { rect.right = rect.left + screenw; }
  if (rect.left < 10)
    { result.scrollLeft = 0; }
  else if (rect.left < screenleft)
    { result.scrollLeft = Math.max(0, rect.left - (tooWide ? 0 : 10)); }
  else if (rect.right > screenw + screenleft - 3)
    { result.scrollLeft = rect.right + (tooWide ? 0 : 10) - screenw; }
  return result
}

// Store a relative adjustment to the scroll position in the current
// operation (to be applied when the operation finishes).
function addToScrollTop(cm, top) {
  if (top == null) { return }
  resolveScrollToPos(cm);
  cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top;
}

// Make sure that at the end of the operation the current cursor is
// shown.
function ensureCursorVisible(cm) {
  resolveScrollToPos(cm);
  var cur = cm.getCursor();
  cm.curOp.scrollToPos = {from: cur, to: cur, margin: cm.options.cursorScrollMargin};
}

function scrollToCoords(cm, x, y) {
  if (x != null || y != null) { resolveScrollToPos(cm); }
  if (x != null) { cm.curOp.scrollLeft = x; }
  if (y != null) { cm.curOp.scrollTop = y; }
}

function scrollToRange(cm, range$$1) {
  resolveScrollToPos(cm);
  cm.curOp.scrollToPos = range$$1;
}

// When an operation has its scrollToPos property set, and another
// scroll action is applied before the end of the operation, this
// 'simulates' scrolling that position into view in a cheap way, so
// that the effect of intermediate scroll commands is not ignored.
function resolveScrollToPos(cm) {
  var range$$1 = cm.curOp.scrollToPos;
  if (range$$1) {
    cm.curOp.scrollToPos = null;
    var from = estimateCoords(cm, range$$1.from), to = estimateCoords(cm, range$$1.to);
    scrollToCoordsRange(cm, from, to, range$$1.margin);
  }
}

function scrollToCoordsRange(cm, from, to, margin) {
  var sPos = calculateScrollPos(cm, {
    left: Math.min(from.left, to.left),
    top: Math.min(from.top, to.top) - margin,
    right: Math.max(from.right, to.right),
    bottom: Math.max(from.bottom, to.bottom) + margin
  });
  scrollToCoords(cm, sPos.scrollLeft, sPos.scrollTop);
}

// Sync the scrollable area and scrollbars, ensure the viewport
// covers the visible area.
function updateScrollTop(cm, val) {
  if (Math.abs(cm.doc.scrollTop - val) < 2) { return }
  if (!gecko) { updateDisplaySimple(cm, {top: val}); }
  setScrollTop(cm, val, true);
  if (gecko) { updateDisplaySimple(cm); }
  startWorker(cm, 100);
}

function setScrollTop(cm, val, forceScroll) {
  val = Math.min(cm.display.scroller.scrollHeight - cm.display.scroller.clientHeight, val);
  if (cm.display.scroller.scrollTop == val && !forceScroll) { return }
  cm.doc.scrollTop = val;
  cm.display.scrollbars.setScrollTop(val);
  if (cm.display.scroller.scrollTop != val) { cm.display.scroller.scrollTop = val; }
}

// Sync scroller and scrollbar, ensure the gutter elements are
// aligned.
function setScrollLeft(cm, val, isScroller, forceScroll) {
  val = Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth);
  if ((isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) && !forceScroll) { return }
  cm.doc.scrollLeft = val;
  alignHorizontally(cm);
  if (cm.display.scroller.scrollLeft != val) { cm.display.scroller.scrollLeft = val; }
  cm.display.scrollbars.setScrollLeft(val);
}

// SCROLLBARS

// Prepare DOM reads needed to update the scrollbars. Done in one
// shot to minimize update/measure roundtrips.
function measureForScrollbars(cm) {
  var d = cm.display, gutterW = d.gutters.offsetWidth;
  var docH = Math.round(cm.doc.height + paddingVert(cm.display));
  return {
    clientHeight: d.scroller.clientHeight,
    viewHeight: d.wrapper.clientHeight,
    scrollWidth: d.scroller.scrollWidth, clientWidth: d.scroller.clientWidth,
    viewWidth: d.wrapper.clientWidth,
    barLeft: cm.options.fixedGutter ? gutterW : 0,
    docHeight: docH,
    scrollHeight: docH + scrollGap(cm) + d.barHeight,
    nativeBarWidth: d.nativeBarWidth,
    gutterWidth: gutterW
  }
}

var NativeScrollbars = function(place, scroll, cm) {
  this.cm = cm;
  var vert = this.vert = elt("div", [elt("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar");
  var horiz = this.horiz = elt("div", [elt("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar");
  vert.tabIndex = horiz.tabIndex = -1;
  place(vert); place(horiz);

  on(vert, "scroll", function () {
    if (vert.clientHeight) { scroll(vert.scrollTop, "vertical"); }
  });
  on(horiz, "scroll", function () {
    if (horiz.clientWidth) { scroll(horiz.scrollLeft, "horizontal"); }
  });

  this.checkedZeroWidth = false;
  // Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
  if (ie && ie_version < 8) { this.horiz.style.minHeight = this.vert.style.minWidth = "18px"; }
};

NativeScrollbars.prototype.update = function (measure) {
  var needsH = measure.scrollWidth > measure.clientWidth + 1;
  var needsV = measure.scrollHeight > measure.clientHeight + 1;
  var sWidth = measure.nativeBarWidth;

  if (needsV) {
    this.vert.style.display = "block";
    this.vert.style.bottom = needsH ? sWidth + "px" : "0";
    var totalHeight = measure.viewHeight - (needsH ? sWidth : 0);
    // A bug in IE8 can cause this value to be negative, so guard it.
    this.vert.firstChild.style.height =
      Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px";
  } else {
    this.vert.style.display = "";
    this.vert.firstChild.style.height = "0";
  }

  if (needsH) {
    this.horiz.style.display = "block";
    this.horiz.style.right = needsV ? sWidth + "px" : "0";
    this.horiz.style.left = measure.barLeft + "px";
    var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0);
    this.horiz.firstChild.style.width =
      Math.max(0, measure.scrollWidth - measure.clientWidth + totalWidth) + "px";
  } else {
    this.horiz.style.display = "";
    this.horiz.firstChild.style.width = "0";
  }

  if (!this.checkedZeroWidth && measure.clientHeight > 0) {
    if (sWidth == 0) { this.zeroWidthHack(); }
    this.checkedZeroWidth = true;
  }

  return {right: needsV ? sWidth : 0, bottom: needsH ? sWidth : 0}
};

NativeScrollbars.prototype.setScrollLeft = function (pos) {
  if (this.horiz.scrollLeft != pos) { this.horiz.scrollLeft = pos; }
  if (this.disableHoriz) { this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz"); }
};

NativeScrollbars.prototype.setScrollTop = function (pos) {
  if (this.vert.scrollTop != pos) { this.vert.scrollTop = pos; }
  if (this.disableVert) { this.enableZeroWidthBar(this.vert, this.disableVert, "vert"); }
};

NativeScrollbars.prototype.zeroWidthHack = function () {
  var w = mac && !mac_geMountainLion ? "12px" : "18px";
  this.horiz.style.height = this.vert.style.width = w;
  this.horiz.style.pointerEvents = this.vert.style.pointerEvents = "none";
  this.disableHoriz = new Delayed;
  this.disableVert = new Delayed;
};

NativeScrollbars.prototype.enableZeroWidthBar = function (bar, delay, type) {
  bar.style.pointerEvents = "auto";
  function maybeDisable() {
    // To find out whether the scrollbar is still visible, we
    // check whether the element under the pixel in the bottom
    // right corner of the scrollbar box is the scrollbar box
    // itself (when the bar is still visible) or its filler child
    // (when the bar is hidden). If it is still visible, we keep
    // it enabled, if it's hidden, we disable pointer events.
    var box = bar.getBoundingClientRect();
    var elt$$1 = type == "vert" ? document.elementFromPoint(box.right - 1, (box.top + box.bottom) / 2)
        : document.elementFromPoint((box.right + box.left) / 2, box.bottom - 1);
    if (elt$$1 != bar) { bar.style.pointerEvents = "none"; }
    else { delay.set(1000, maybeDisable); }
  }
  delay.set(1000, maybeDisable);
};

NativeScrollbars.prototype.clear = function () {
  var parent = this.horiz.parentNode;
  parent.removeChild(this.horiz);
  parent.removeChild(this.vert);
};

var NullScrollbars = function () {};

NullScrollbars.prototype.update = function () { return {bottom: 0, right: 0} };
NullScrollbars.prototype.setScrollLeft = function () {};
NullScrollbars.prototype.setScrollTop = function () {};
NullScrollbars.prototype.clear = function () {};

function updateScrollbars(cm, measure) {
  if (!measure) { measure = measureForScrollbars(cm); }
  var startWidth = cm.display.barWidth, startHeight = cm.display.barHeight;
  updateScrollbarsInner(cm, measure);
  for (var i = 0; i < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i++) {
    if (startWidth != cm.display.barWidth && cm.options.lineWrapping)
      { updateHeightsInViewport(cm); }
    updateScrollbarsInner(cm, measureForScrollbars(cm));
    startWidth = cm.display.barWidth; startHeight = cm.display.barHeight;
  }
}

// Re-synchronize the fake scrollbars with the actual size of the
// content.
function updateScrollbarsInner(cm, measure) {
  var d = cm.display;
  var sizes = d.scrollbars.update(measure);

  d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px";
  d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px";
  d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent";

  if (sizes.right && sizes.bottom) {
    d.scrollbarFiller.style.display = "block";
    d.scrollbarFiller.style.height = sizes.bottom + "px";
    d.scrollbarFiller.style.width = sizes.right + "px";
  } else { d.scrollbarFiller.style.display = ""; }
  if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
    d.gutterFiller.style.display = "block";
    d.gutterFiller.style.height = sizes.bottom + "px";
    d.gutterFiller.style.width = measure.gutterWidth + "px";
  } else { d.gutterFiller.style.display = ""; }
}

var scrollbarModel = {"native": NativeScrollbars, "null": NullScrollbars};

function initScrollbars(cm) {
  if (cm.display.scrollbars) {
    cm.display.scrollbars.clear();
    if (cm.display.scrollbars.addClass)
      { rmClass(cm.display.wrapper, cm.display.scrollbars.addClass); }
  }

  cm.display.scrollbars = new scrollbarModel[cm.options.scrollbarStyle](function (node) {
    cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller);
    // Prevent clicks in the scrollbars from killing focus
    on(node, "mousedown", function () {
      if (cm.state.focused) { setTimeout(function () { return cm.display.input.focus(); }, 0); }
    });
    node.setAttribute("cm-not-content", "true");
  }, function (pos, axis) {
    if (axis == "horizontal") { setScrollLeft(cm, pos); }
    else { updateScrollTop(cm, pos); }
  }, cm);
  if (cm.display.scrollbars.addClass)
    { addClass(cm.display.wrapper, cm.display.scrollbars.addClass); }
}

// Operations are used to wrap a series of changes to the editor
// state in such a way that each change won't have to update the
// cursor and display (which would be awkward, slow, and
// error-prone). Instead, display updates are batched and then all
// combined and executed at once.

var nextOpId = 0;
// Start a new operation.
function startOperation(cm) {
  cm.curOp = {
    cm: cm,
    viewChanged: false,      // Flag that indicates that lines might need to be redrawn
    startHeight: cm.doc.height, // Used to detect need to update scrollbar
    forceUpdate: false,      // Used to force a redraw
    updateInput: null,       // Whether to reset the input textarea
    typing: false,           // Whether this reset should be careful to leave existing text (for compositing)
    changeObjs: null,        // Accumulated changes, for firing change events
    cursorActivityHandlers: null, // Set of handlers to fire cursorActivity on
    cursorActivityCalled: 0, // Tracks which cursorActivity handlers have been called already
    selectionChanged: false, // Whether the selection needs to be redrawn
    updateMaxLine: false,    // Set when the widest line needs to be determined anew
    scrollLeft: null, scrollTop: null, // Intermediate scroll position, not pushed to DOM yet
    scrollToPos: null,       // Used to scroll to a specific position
    focus: false,
    id: ++nextOpId           // Unique ID
  };
  pushOperation(cm.curOp);
}

// Finish an operation, updating the display and signalling delayed events
function endOperation(cm) {
  var op = cm.curOp;
  finishOperation(op, function (group) {
    for (var i = 0; i < group.ops.length; i++)
      { group.ops[i].cm.curOp = null; }
    endOperations(group);
  });
}

// The DOM updates done when an operation finishes are batched so
// that the minimum number of relayouts are required.
function endOperations(group) {
  var ops = group.ops;
  for (var i = 0; i < ops.length; i++) // Read DOM
    { endOperation_R1(ops[i]); }
  for (var i$1 = 0; i$1 < ops.length; i$1++) // Write DOM (maybe)
    { endOperation_W1(ops[i$1]); }
  for (var i$2 = 0; i$2 < ops.length; i$2++) // Read DOM
    { endOperation_R2(ops[i$2]); }
  for (var i$3 = 0; i$3 < ops.length; i$3++) // Write DOM (maybe)
    { endOperation_W2(ops[i$3]); }
  for (var i$4 = 0; i$4 < ops.length; i$4++) // Read DOM
    { endOperation_finish(ops[i$4]); }
}

function endOperation_R1(op) {
  var cm = op.cm, display = cm.display;
  maybeClipScrollbars(cm);
  if (op.updateMaxLine) { findMaxLine(cm); }

  op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null ||
    op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom ||
                       op.scrollToPos.to.line >= display.viewTo) ||
    display.maxLineChanged && cm.options.lineWrapping;
  op.update = op.mustUpdate &&
    new DisplayUpdate(cm, op.mustUpdate && {top: op.scrollTop, ensure: op.scrollToPos}, op.forceUpdate);
}

function endOperation_W1(op) {
  op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update);
}

function endOperation_R2(op) {
  var cm = op.cm, display = cm.display;
  if (op.updatedDisplay) { updateHeightsInViewport(cm); }

  op.barMeasure = measureForScrollbars(cm);

  // If the max line changed since it was last measured, measure it,
  // and ensure the document's width matches it.
  // updateDisplay_W2 will use these properties to do the actual resizing
  if (display.maxLineChanged && !cm.options.lineWrapping) {
    op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3;
    cm.display.sizerWidth = op.adjustWidthTo;
    op.barMeasure.scrollWidth =
      Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth);
    op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm));
  }

  if (op.updatedDisplay || op.selectionChanged)
    { op.preparedSelection = display.input.prepareSelection(); }
}

function endOperation_W2(op) {
  var cm = op.cm;

  if (op.adjustWidthTo != null) {
    cm.display.sizer.style.minWidth = op.adjustWidthTo + "px";
    if (op.maxScrollLeft < cm.doc.scrollLeft)
      { setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true); }
    cm.display.maxLineChanged = false;
  }

  var takeFocus = op.focus && op.focus == activeElt();
  if (op.preparedSelection)
    { cm.display.input.showSelection(op.preparedSelection, takeFocus); }
  if (op.updatedDisplay || op.startHeight != cm.doc.height)
    { updateScrollbars(cm, op.barMeasure); }
  if (op.updatedDisplay)
    { setDocumentHeight(cm, op.barMeasure); }

  if (op.selectionChanged) { restartBlink(cm); }

  if (cm.state.focused && op.updateInput)
    { cm.display.input.reset(op.typing); }
  if (takeFocus) { ensureFocus(op.cm); }
}

function endOperation_finish(op) {
  var cm = op.cm, display = cm.display, doc = cm.doc;

  if (op.updatedDisplay) { postUpdateDisplay(cm, op.update); }

  // Abort mouse wheel delta measurement, when scrolling explicitly
  if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos))
    { display.wheelStartX = display.wheelStartY = null; }

  // Propagate the scroll position to the actual DOM scroller
  if (op.scrollTop != null) { setScrollTop(cm, op.scrollTop, op.forceScroll); }

  if (op.scrollLeft != null) { setScrollLeft(cm, op.scrollLeft, true, true); }
  // If we need to scroll a specific position into view, do so.
  if (op.scrollToPos) {
    var rect = scrollPosIntoView(cm, clipPos(doc, op.scrollToPos.from),
                                 clipPos(doc, op.scrollToPos.to), op.scrollToPos.margin);
    maybeScrollWindow(cm, rect);
  }

  // Fire events for markers that are hidden/unidden by editing or
  // undoing
  var hidden = op.maybeHiddenMarkers, unhidden = op.maybeUnhiddenMarkers;
  if (hidden) { for (var i = 0; i < hidden.length; ++i)
    { if (!hidden[i].lines.length) { signal(hidden[i], "hide"); } } }
  if (unhidden) { for (var i$1 = 0; i$1 < unhidden.length; ++i$1)
    { if (unhidden[i$1].lines.length) { signal(unhidden[i$1], "unhide"); } } }

  if (display.wrapper.offsetHeight)
    { doc.scrollTop = cm.display.scroller.scrollTop; }

  // Fire change events, and delayed event handlers
  if (op.changeObjs)
    { signal(cm, "changes", cm, op.changeObjs); }
  if (op.update)
    { op.update.finish(); }
}

// Run the given function in an operation
function runInOp(cm, f) {
  if (cm.curOp) { return f() }
  startOperation(cm);
  try { return f() }
  finally { endOperation(cm); }
}
// Wraps a function in an operation. Returns the wrapped function.
function operation(cm, f) {
  return function() {
    if (cm.curOp) { return f.apply(cm, arguments) }
    startOperation(cm);
    try { return f.apply(cm, arguments) }
    finally { endOperation(cm); }
  }
}
// Used to add methods to editor and doc instances, wrapping them in
// operations.
function methodOp(f) {
  return function() {
    if (this.curOp) { return f.apply(this, arguments) }
    startOperation(this);
    try { return f.apply(this, arguments) }
    finally { endOperation(this); }
  }
}
function docMethodOp(f) {
  return function() {
    var cm = this.cm;
    if (!cm || cm.curOp) { return f.apply(this, arguments) }
    startOperation(cm);
    try { return f.apply(this, arguments) }
    finally { endOperation(cm); }
  }
}

// Updates the display.view data structure for a given change to the
// document. From and to are in pre-change coordinates. Lendiff is
// the amount of lines added or subtracted by the change. This is
// used for changes that span multiple lines, or change the way
// lines are divided into visual lines. regLineChange (below)
// registers single-line changes.
function regChange(cm, from, to, lendiff) {
  if (from == null) { from = cm.doc.first; }
  if (to == null) { to = cm.doc.first + cm.doc.size; }
  if (!lendiff) { lendiff = 0; }

  var display = cm.display;
  if (lendiff && to < display.viewTo &&
      (display.updateLineNumbers == null || display.updateLineNumbers > from))
    { display.updateLineNumbers = from; }

  cm.curOp.viewChanged = true;

  if (from >= display.viewTo) { // Change after
    if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo)
      { resetView(cm); }
  } else if (to <= display.viewFrom) { // Change before
    if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) {
      resetView(cm);
    } else {
      display.viewFrom += lendiff;
      display.viewTo += lendiff;
    }
  } else if (from <= display.viewFrom && to >= display.viewTo) { // Full overlap
    resetView(cm);
  } else if (from <= display.viewFrom) { // Top overlap
    var cut = viewCuttingPoint(cm, to, to + lendiff, 1);
    if (cut) {
      display.view = display.view.slice(cut.index);
      display.viewFrom = cut.lineN;
      display.viewTo += lendiff;
    } else {
      resetView(cm);
    }
  } else if (to >= display.viewTo) { // Bottom overlap
    var cut$1 = viewCuttingPoint(cm, from, from, -1);
    if (cut$1) {
      display.view = display.view.slice(0, cut$1.index);
      display.viewTo = cut$1.lineN;
    } else {
      resetView(cm);
    }
  } else { // Gap in the middle
    var cutTop = viewCuttingPoint(cm, from, from, -1);
    var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1);
    if (cutTop && cutBot) {
      display.view = display.view.slice(0, cutTop.index)
        .concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN))
        .concat(display.view.slice(cutBot.index));
      display.viewTo += lendiff;
    } else {
      resetView(cm);
    }
  }

  var ext = display.externalMeasured;
  if (ext) {
    if (to < ext.lineN)
      { ext.lineN += lendiff; }
    else if (from < ext.lineN + ext.size)
      { display.externalMeasured = null; }
  }
}

// Register a change to a single line. Type must be one of "text",
// "gutter", "class", "widget"
function regLineChange(cm, line, type) {
  cm.curOp.viewChanged = true;
  var display = cm.display, ext = cm.display.externalMeasured;
  if (ext && line >= ext.lineN && line < ext.lineN + ext.size)
    { display.externalMeasured = null; }

  if (line < display.viewFrom || line >= display.viewTo) { return }
  var lineView = display.view[findViewIndex(cm, line)];
  if (lineView.node == null) { return }
  var arr = lineView.changes || (lineView.changes = []);
  if (indexOf(arr, type) == -1) { arr.push(type); }
}

// Clear the view.
function resetView(cm) {
  cm.display.viewFrom = cm.display.viewTo = cm.doc.first;
  cm.display.view = [];
  cm.display.viewOffset = 0;
}

function viewCuttingPoint(cm, oldN, newN, dir) {
  var index = findViewIndex(cm, oldN), diff, view = cm.display.view;
  if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size)
    { return {index: index, lineN: newN} }
  var n = cm.display.viewFrom;
  for (var i = 0; i < index; i++)
    { n += view[i].size; }
  if (n != oldN) {
    if (dir > 0) {
      if (index == view.length - 1) { return null }
      diff = (n + view[index].size) - oldN;
      index++;
    } else {
      diff = n - oldN;
    }
    oldN += diff; newN += diff;
  }
  while (visualLineNo(cm.doc, newN) != newN) {
    if (index == (dir < 0 ? 0 : view.length - 1)) { return null }
    newN += dir * view[index - (dir < 0 ? 1 : 0)].size;
    index += dir;
  }
  return {index: index, lineN: newN}
}

// Force the view to cover a given range, adding empty view element
// or clipping off existing ones as needed.
function adjustView(cm, from, to) {
  var display = cm.display, view = display.view;
  if (view.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
    display.view = buildViewArray(cm, from, to);
    display.viewFrom = from;
  } else {
    if (display.viewFrom > from)
      { display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view); }
    else if (display.viewFrom < from)
      { display.view = display.view.slice(findViewIndex(cm, from)); }
    display.viewFrom = from;
    if (display.viewTo < to)
      { display.view = display.view.concat(buildViewArray(cm, display.viewTo, to)); }
    else if (display.viewTo > to)
      { display.view = display.view.slice(0, findViewIndex(cm, to)); }
  }
  display.viewTo = to;
}

// Count the number of lines in the view whose DOM representation is
// out of date (or nonexistent).
function countDirtyView(cm) {
  var view = cm.display.view, dirty = 0;
  for (var i = 0; i < view.length; i++) {
    var lineView = view[i];
    if (!lineView.hidden && (!lineView.node || lineView.changes)) { ++dirty; }
  }
  return dirty
}

// HIGHLIGHT WORKER

function startWorker(cm, time) {
  if (cm.doc.highlightFrontier < cm.display.viewTo)
    { cm.state.highlight.set(time, bind(highlightWorker, cm)); }
}

function highlightWorker(cm) {
  var doc = cm.doc;
  if (doc.highlightFrontier >= cm.display.viewTo) { return }
  var end = +new Date + cm.options.workTime;
  var context = getContextBefore(cm, doc.highlightFrontier);
  var changedLines = [];

  doc.iter(context.line, Math.min(doc.first + doc.size, cm.display.viewTo + 500), function (line) {
    if (context.line >= cm.display.viewFrom) { // Visible
      var oldStyles = line.styles;
      var resetState = line.text.length > cm.options.maxHighlightLength ? copyState(doc.mode, context.state) : null;
      var highlighted = highlightLine(cm, line, context, true);
      if (resetState) { context.state = resetState; }
      line.styles = highlighted.styles;
      var oldCls = line.styleClasses, newCls = highlighted.classes;
      if (newCls) { line.styleClasses = newCls; }
      else if (oldCls) { line.styleClasses = null; }
      var ischange = !oldStyles || oldStyles.length != line.styles.length ||
        oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass);
      for (var i = 0; !ischange && i < oldStyles.length; ++i) { ischange = oldStyles[i] != line.styles[i]; }
      if (ischange) { changedLines.push(context.line); }
      line.stateAfter = context.save();
      context.nextLine();
    } else {
      if (line.text.length <= cm.options.maxHighlightLength)
        { processLine(cm, line.text, context); }
      line.stateAfter = context.line % 5 == 0 ? context.save() : null;
      context.nextLine();
    }
    if (+new Date > end) {
      startWorker(cm, cm.options.workDelay);
      return true
    }
  });
  doc.highlightFrontier = context.line;
  doc.modeFrontier = Math.max(doc.modeFrontier, context.line);
  if (changedLines.length) { runInOp(cm, function () {
    for (var i = 0; i < changedLines.length; i++)
      { regLineChange(cm, changedLines[i], "text"); }
  }); }
}

// DISPLAY DRAWING

var DisplayUpdate = function(cm, viewport, force) {
  var display = cm.display;

  this.viewport = viewport;
  // Store some values that we'll need later (but don't want to force a relayout for)
  this.visible = visibleLines(display, cm.doc, viewport);
  this.editorIsHidden = !display.wrapper.offsetWidth;
  this.wrapperHeight = display.wrapper.clientHeight;
  this.wrapperWidth = display.wrapper.clientWidth;
  this.oldDisplayWidth = displayWidth(cm);
  this.force = force;
  this.dims = getDimensions(cm);
  this.events = [];
};

DisplayUpdate.prototype.signal = function (emitter, type) {
  if (hasHandler(emitter, type))
    { this.events.push(arguments); }
};
DisplayUpdate.prototype.finish = function () {
    var this$1 = this;

  for (var i = 0; i < this.events.length; i++)
    { signal.apply(null, this$1.events[i]); }
};

function maybeClipScrollbars(cm) {
  var display = cm.display;
  if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
    display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth;
    display.heightForcer.style.height = scrollGap(cm) + "px";
    display.sizer.style.marginBottom = -display.nativeBarWidth + "px";
    display.sizer.style.borderRightWidth = scrollGap(cm) + "px";
    display.scrollbarsClipped = true;
  }
}

function selectionSnapshot(cm) {
  if (cm.hasFocus()) { return null }
  var active = activeElt();
  if (!active || !contains(cm.display.lineDiv, active)) { return null }
  var result = {activeElt: active};
  if (window.getSelection) {
    var sel = window.getSelection();
    if (sel.anchorNode && sel.extend && contains(cm.display.lineDiv, sel.anchorNode)) {
      result.anchorNode = sel.anchorNode;
      result.anchorOffset = sel.anchorOffset;
      result.focusNode = sel.focusNode;
      result.focusOffset = sel.focusOffset;
    }
  }
  return result
}

function restoreSelection(snapshot) {
  if (!snapshot || !snapshot.activeElt || snapshot.activeElt == activeElt()) { return }
  snapshot.activeElt.focus();
  if (snapshot.anchorNode && contains(document.body, snapshot.anchorNode) && contains(document.body, snapshot.focusNode)) {
    var sel = window.getSelection(), range$$1 = document.createRange();
    range$$1.setEnd(snapshot.anchorNode, snapshot.anchorOffset);
    range$$1.collapse(false);
    sel.removeAllRanges();
    sel.addRange(range$$1);
    sel.extend(snapshot.focusNode, snapshot.focusOffset);
  }
}

// Does the actual updating of the line display. Bails out
// (returning false) when there is nothing to be done and forced is
// false.
function updateDisplayIfNeeded(cm, update) {
  var display = cm.display, doc = cm.doc;

  if (update.editorIsHidden) {
    resetView(cm);
    return false
  }

  // Bail out if the visible area is already rendered and nothing changed.
  if (!update.force &&
      update.visible.from >= display.viewFrom && update.visible.to <= display.viewTo &&
      (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) &&
      display.renderedView == display.view && countDirtyView(cm) == 0)
    { return false }

  if (maybeUpdateLineNumberWidth(cm)) {
    resetView(cm);
    update.dims = getDimensions(cm);
  }

  // Compute a suitable new viewport (from & to)
  var end = doc.first + doc.size;
  var from = Math.max(update.visible.from - cm.options.viewportMargin, doc.first);
  var to = Math.min(end, update.visible.to + cm.options.viewportMargin);
  if (display.viewFrom < from && from - display.viewFrom < 20) { from = Math.max(doc.first, display.viewFrom); }
  if (display.viewTo > to && display.viewTo - to < 20) { to = Math.min(end, display.viewTo); }
  if (sawCollapsedSpans) {
    from = visualLineNo(cm.doc, from);
    to = visualLineEndNo(cm.doc, to);
  }

  var different = from != display.viewFrom || to != display.viewTo ||
    display.lastWrapHeight != update.wrapperHeight || display.lastWrapWidth != update.wrapperWidth;
  adjustView(cm, from, to);

  display.viewOffset = heightAtLine(getLine(cm.doc, display.viewFrom));
  // Position the mover div to align with the current scroll position
  cm.display.mover.style.top = display.viewOffset + "px";

  var toUpdate = countDirtyView(cm);
  if (!different && toUpdate == 0 && !update.force && display.renderedView == display.view &&
      (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo))
    { return false }

  // For big changes, we hide the enclosing element during the
  // update, since that speeds up the operations on most browsers.
  var selSnapshot = selectionSnapshot(cm);
  if (toUpdate > 4) { display.lineDiv.style.display = "none"; }
  patchDisplay(cm, display.updateLineNumbers, update.dims);
  if (toUpdate > 4) { display.lineDiv.style.display = ""; }
  display.renderedView = display.view;
  // There might have been a widget with a focused element that got
  // hidden or updated, if so re-focus it.
  restoreSelection(selSnapshot);

  // Prevent selection and cursors from interfering with the scroll
  // width and height.
  removeChildren(display.cursorDiv);
  removeChildren(display.selectionDiv);
  display.gutters.style.height = display.sizer.style.minHeight = 0;

  if (different) {
    display.lastWrapHeight = update.wrapperHeight;
    display.lastWrapWidth = update.wrapperWidth;
    startWorker(cm, 400);
  }

  display.updateLineNumbers = null;

  return true
}

function postUpdateDisplay(cm, update) {
  var viewport = update.viewport;

  for (var first = true;; first = false) {
    if (!first || !cm.options.lineWrapping || update.oldDisplayWidth == displayWidth(cm)) {
      // Clip forced viewport to actual scrollable area.
      if (viewport && viewport.top != null)
        { viewport = {top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top)}; }
      // Updated line heights might result in the drawn area not
      // actually covering the viewport. Keep looping until it does.
      update.visible = visibleLines(cm.display, cm.doc, viewport);
      if (update.visible.from >= cm.display.viewFrom && update.visible.to <= cm.display.viewTo)
        { break }
    }
    if (!updateDisplayIfNeeded(cm, update)) { break }
    updateHeightsInViewport(cm);
    var barMeasure = measureForScrollbars(cm);
    updateSelection(cm);
    updateScrollbars(cm, barMeasure);
    setDocumentHeight(cm, barMeasure);
    update.force = false;
  }

  update.signal(cm, "update", cm);
  if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
    update.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo);
    cm.display.reportedViewFrom = cm.display.viewFrom; cm.display.reportedViewTo = cm.display.viewTo;
  }
}

function updateDisplaySimple(cm, viewport) {
  var update = new DisplayUpdate(cm, viewport);
  if (updateDisplayIfNeeded(cm, update)) {
    updateHeightsInViewport(cm);
    postUpdateDisplay(cm, update);
    var barMeasure = measureForScrollbars(cm);
    updateSelection(cm);
    updateScrollbars(cm, barMeasure);
    setDocumentHeight(cm, barMeasure);
    update.finish();
  }
}

// Sync the actual display DOM structure with display.view, removing
// nodes for lines that are no longer in view, and creating the ones
// that are not there yet, and updating the ones that are out of
// date.
function patchDisplay(cm, updateNumbersFrom, dims) {
  var display = cm.display, lineNumbers = cm.options.lineNumbers;
  var container = display.lineDiv, cur = container.firstChild;

  function rm(node) {
    var next = node.nextSibling;
    // Works around a throw-scroll bug in OS X Webkit
    if (webkit && mac && cm.display.currentWheelTarget == node)
      { node.style.display = "none"; }
    else
      { node.parentNode.removeChild(node); }
    return next
  }

  var view = display.view, lineN = display.viewFrom;
  // Loop over the elements in the view, syncing cur (the DOM nodes
  // in display.lineDiv) with the view as we go.
  for (var i = 0; i < view.length; i++) {
    var lineView = view[i];
    if (lineView.hidden) {
    } else if (!lineView.node || lineView.node.parentNode != container) { // Not drawn yet
      var node = buildLineElement(cm, lineView, lineN, dims);
      container.insertBefore(node, cur);
    } else { // Already drawn
      while (cur != lineView.node) { cur = rm(cur); }
      var updateNumber = lineNumbers && updateNumbersFrom != null &&
        updateNumbersFrom <= lineN && lineView.lineNumber;
      if (lineView.changes) {
        if (indexOf(lineView.changes, "gutter") > -1) { updateNumber = false; }
        updateLineForChanges(cm, lineView, lineN, dims);
      }
      if (updateNumber) {
        removeChildren(lineView.lineNumber);
        lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)));
      }
      cur = lineView.node.nextSibling;
    }
    lineN += lineView.size;
  }
  while (cur) { cur = rm(cur); }
}

function updateGutterSpace(cm) {
  var width = cm.display.gutters.offsetWidth;
  cm.display.sizer.style.marginLeft = width + "px";
}

function setDocumentHeight(cm, measure) {
  cm.display.sizer.style.minHeight = measure.docHeight + "px";
  cm.display.heightForcer.style.top = measure.docHeight + "px";
  cm.display.gutters.style.height = (measure.docHeight + cm.display.barHeight + scrollGap(cm)) + "px";
}

// Rebuild the gutter elements, ensure the margin to the left of the
// code matches their width.
function updateGutters(cm) {
  var gutters = cm.display.gutters, specs = cm.options.gutters;
  removeChildren(gutters);
  var i = 0;
  for (; i < specs.length; ++i) {
    var gutterClass = specs[i];
    var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + gutterClass));
    if (gutterClass == "CodeMirror-linenumbers") {
      cm.display.lineGutter = gElt;
      gElt.style.width = (cm.display.lineNumWidth || 1) + "px";
    }
  }
  gutters.style.display = i ? "" : "none";
  updateGutterSpace(cm);
}

// Make sure the gutters options contains the element
// "CodeMirror-linenumbers" when the lineNumbers option is true.
function setGuttersForLineNumbers(options) {
  var found = indexOf(options.gutters, "CodeMirror-linenumbers");
  if (found == -1 && options.lineNumbers) {
    options.gutters = options.gutters.concat(["CodeMirror-linenumbers"]);
  } else if (found > -1 && !options.lineNumbers) {
    options.gutters = options.gutters.slice(0);
    options.gutters.splice(found, 1);
  }
}

// Since the delta values reported on mouse wheel events are
// unstandardized between browsers and even browser versions, and
// generally horribly unpredictable, this code starts by measuring
// the scroll effect that the first few mouse wheel events have,
// and, from that, detects the way it can convert deltas to pixel
// offsets afterwards.
//
// The reason we want to know the amount a wheel event will scroll
// is that it gives us a chance to update the display before the
// actual scrolling happens, reducing flickering.

var wheelSamples = 0;
var wheelPixelsPerUnit = null;
// Fill in a browser-detected starting value on browsers where we
// know one. These don't have to be accurate -- the result of them
// being wrong would just be a slight flicker on the first wheel
// scroll (if it is large enough).
if (ie) { wheelPixelsPerUnit = -.53; }
else if (gecko) { wheelPixelsPerUnit = 15; }
else if (chrome) { wheelPixelsPerUnit = -.7; }
else if (safari) { wheelPixelsPerUnit = -1/3; }

function wheelEventDelta(e) {
  var dx = e.wheelDeltaX, dy = e.wheelDeltaY;
  if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) { dx = e.detail; }
  if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) { dy = e.detail; }
  else if (dy == null) { dy = e.wheelDelta; }
  return {x: dx, y: dy}
}
function wheelEventPixels(e) {
  var delta = wheelEventDelta(e);
  delta.x *= wheelPixelsPerUnit;
  delta.y *= wheelPixelsPerUnit;
  return delta
}

function onScrollWheel(cm, e) {
  var delta = wheelEventDelta(e), dx = delta.x, dy = delta.y;

  var display = cm.display, scroll = display.scroller;
  // Quit if there's nothing to scroll here
  var canScrollX = scroll.scrollWidth > scroll.clientWidth;
  var canScrollY = scroll.scrollHeight > scroll.clientHeight;
  if (!(dx && canScrollX || dy && canScrollY)) { return }

  // Webkit browsers on OS X abort momentum scrolls when the target
  // of the scroll event is removed from the scrollable element.
  // This hack (see related code in patchDisplay) makes sure the
  // element is kept around.
  if (dy && mac && webkit) {
    outer: for (var cur = e.target, view = display.view; cur != scroll; cur = cur.parentNode) {
      for (var i = 0; i < view.length; i++) {
        if (view[i].node == cur) {
          cm.display.currentWheelTarget = cur;
          break outer
        }
      }
    }
  }

  // On some browsers, horizontal scrolling will cause redraws to
  // happen before the gutter has been realigned, causing it to
  // wriggle around in a most unseemly way. When we have an
  // estimated pixels/delta value, we just handle horizontal
  // scrolling entirely here. It'll be slightly off from native, but
  // better than glitching out.
  if (dx && !gecko && !presto && wheelPixelsPerUnit != null) {
    if (dy && canScrollY)
      { updateScrollTop(cm, Math.max(0, scroll.scrollTop + dy * wheelPixelsPerUnit)); }
    setScrollLeft(cm, Math.max(0, scroll.scrollLeft + dx * wheelPixelsPerUnit));
    // Only prevent default scrolling if vertical scrolling is
    // actually possible. Otherwise, it causes vertical scroll
    // jitter on OSX trackpads when deltaX is small and deltaY
    // is large (issue #3579)
    if (!dy || (dy && canScrollY))
      { e_preventDefault(e); }
    display.wheelStartX = null; // Abort measurement, if in progress
    return
  }

  // 'Project' the visible viewport to cover the area that is being
  // scrolled into view (if we know enough to estimate it).
  if (dy && wheelPixelsPerUnit != null) {
    var pixels = dy * wheelPixelsPerUnit;
    var top = cm.doc.scrollTop, bot = top + display.wrapper.clientHeight;
    if (pixels < 0) { top = Math.max(0, top + pixels - 50); }
    else { bot = Math.min(cm.doc.height, bot + pixels + 50); }
    updateDisplaySimple(cm, {top: top, bottom: bot});
  }

  if (wheelSamples < 20) {
    if (display.wheelStartX == null) {
      display.wheelStartX = scroll.scrollLeft; display.wheelStartY = scroll.scrollTop;
      display.wheelDX = dx; display.wheelDY = dy;
      setTimeout(function () {
        if (display.wheelStartX == null) { return }
        var movedX = scroll.scrollLeft - display.wheelStartX;
        var movedY = scroll.scrollTop - display.wheelStartY;
        var sample = (movedY && display.wheelDY && movedY / display.wheelDY) ||
          (movedX && display.wheelDX && movedX / display.wheelDX);
        display.wheelStartX = display.wheelStartY = null;
        if (!sample) { return }
        wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1);
        ++wheelSamples;
      }, 200);
    } else {
      display.wheelDX += dx; display.wheelDY += dy;
    }
  }
}

// Selection objects are immutable. A new one is created every time
// the selection changes. A selection is one or more non-overlapping
// (and non-touching) ranges, sorted, and an integer that indicates
// which one is the primary selection (the one that's scrolled into
// view, that getCursor returns, etc).
var Selection = function(ranges, primIndex) {
  this.ranges = ranges;
  this.primIndex = primIndex;
};

Selection.prototype.primary = function () { return this.ranges[this.primIndex] };

Selection.prototype.equals = function (other) {
    var this$1 = this;

  if (other == this) { return true }
  if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) { return false }
  for (var i = 0; i < this.ranges.length; i++) {
    var here = this$1.ranges[i], there = other.ranges[i];
    if (!equalCursorPos(here.anchor, there.anchor) || !equalCursorPos(here.head, there.head)) { return false }
  }
  return true
};

Selection.prototype.deepCopy = function () {
    var this$1 = this;

  var out = [];
  for (var i = 0; i < this.ranges.length; i++)
    { out[i] = new Range(copyPos(this$1.ranges[i].anchor), copyPos(this$1.ranges[i].head)); }
  return new Selection(out, this.primIndex)
};

Selection.prototype.somethingSelected = function () {
    var this$1 = this;

  for (var i = 0; i < this.ranges.length; i++)
    { if (!this$1.ranges[i].empty()) { return true } }
  return false
};

Selection.prototype.contains = function (pos, end) {
    var this$1 = this;

  if (!end) { end = pos; }
  for (var i = 0; i < this.ranges.length; i++) {
    var range = this$1.ranges[i];
    if (cmp(end, range.from()) >= 0 && cmp(pos, range.to()) <= 0)
      { return i }
  }
  return -1
};

var Range = function(anchor, head) {
  this.anchor = anchor; this.head = head;
};

Range.prototype.from = function () { return minPos(this.anchor, this.head) };
Range.prototype.to = function () { return maxPos(this.anchor, this.head) };
Range.prototype.empty = function () { return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch };

// Take an unsorted, potentially overlapping set of ranges, and
// build a selection out of it. 'Consumes' ranges array (modifying
// it).
function normalizeSelection(ranges, primIndex) {
  var prim = ranges[primIndex];
  ranges.sort(function (a, b) { return cmp(a.from(), b.from()); });
  primIndex = indexOf(ranges, prim);
  for (var i = 1; i < ranges.length; i++) {
    var cur = ranges[i], prev = ranges[i - 1];
    if (cmp(prev.to(), cur.from()) >= 0) {
      var from = minPos(prev.from(), cur.from()), to = maxPos(prev.to(), cur.to());
      var inv = prev.empty() ? cur.from() == cur.head : prev.from() == prev.head;
      if (i <= primIndex) { --primIndex; }
      ranges.splice(--i, 2, new Range(inv ? to : from, inv ? from : to));
    }
  }
  return new Selection(ranges, primIndex)
}

function simpleSelection(anchor, head) {
  return new Selection([new Range(anchor, head || anchor)], 0)
}

// Compute the position of the end of a change (its 'to' property
// refers to the pre-change end).
function changeEnd(change) {
  if (!change.text) { return change.to }
  return Pos(change.from.line + change.text.length - 1,
             lst(change.text).length + (change.text.length == 1 ? change.from.ch : 0))
}

// Adjust a position to refer to the post-change position of the
// same text, or the end of the change if the change covers it.
function adjustForChange(pos, change) {
  if (cmp(pos, change.from) < 0) { return pos }
  if (cmp(pos, change.to) <= 0) { return changeEnd(change) }

  var line = pos.line + change.text.length - (change.to.line - change.from.line) - 1, ch = pos.ch;
  if (pos.line == change.to.line) { ch += changeEnd(change).ch - change.to.ch; }
  return Pos(line, ch)
}

function computeSelAfterChange(doc, change) {
  var out = [];
  for (var i = 0; i < doc.sel.ranges.length; i++) {
    var range = doc.sel.ranges[i];
    out.push(new Range(adjustForChange(range.anchor, change),
                       adjustForChange(range.head, change)));
  }
  return normalizeSelection(out, doc.sel.primIndex)
}

function offsetPos(pos, old, nw) {
  if (pos.line == old.line)
    { return Pos(nw.line, pos.ch - old.ch + nw.ch) }
  else
    { return Pos(nw.line + (pos.line - old.line), pos.ch) }
}

// Used by replaceSelections to allow moving the selection to the
// start or around the replaced test. Hint may be "start" or "around".
function computeReplacedSel(doc, changes, hint) {
  var out = [];
  var oldPrev = Pos(doc.first, 0), newPrev = oldPrev;
  for (var i = 0; i < changes.length; i++) {
    var change = changes[i];
    var from = offsetPos(change.from, oldPrev, newPrev);
    var to = offsetPos(changeEnd(change), oldPrev, newPrev);
    oldPrev = change.to;
    newPrev = to;
    if (hint == "around") {
      var range = doc.sel.ranges[i], inv = cmp(range.head, range.anchor) < 0;
      out[i] = new Range(inv ? to : from, inv ? from : to);
    } else {
      out[i] = new Range(from, from);
    }
  }
  return new Selection(out, doc.sel.primIndex)
}

// Used to get the editor into a consistent state again when options change.

function loadMode(cm) {
  cm.doc.mode = getMode(cm.options, cm.doc.modeOption);
  resetModeState(cm);
}

function resetModeState(cm) {
  cm.doc.iter(function (line) {
    if (line.stateAfter) { line.stateAfter = null; }
    if (line.styles) { line.styles = null; }
  });
  cm.doc.modeFrontier = cm.doc.highlightFrontier = cm.doc.first;
  startWorker(cm, 100);
  cm.state.modeGen++;
  if (cm.curOp) { regChange(cm); }
}

// DOCUMENT DATA STRUCTURE

// By default, updates that start and end at the beginning of a line
// are treated specially, in order to make the association of line
// widgets and marker elements with the text behave more intuitive.
function isWholeLineUpdate(doc, change) {
  return change.from.ch == 0 && change.to.ch == 0 && lst(change.text) == "" &&
    (!doc.cm || doc.cm.options.wholeLineUpdateBefore)
}

// Perform a change on the document data structure.
function updateDoc(doc, change, markedSpans, estimateHeight$$1) {
  function spansFor(n) {return markedSpans ? markedSpans[n] : null}
  function update(line, text, spans) {
    updateLine(line, text, spans, estimateHeight$$1);
    signalLater(line, "change", line, change);
  }
  function linesFor(start, end) {
    var result = [];
    for (var i = start; i < end; ++i)
      { result.push(new Line(text[i], spansFor(i), estimateHeight$$1)); }
    return result
  }

  var from = change.from, to = change.to, text = change.text;
  var firstLine = getLine(doc, from.line), lastLine = getLine(doc, to.line);
  var lastText = lst(text), lastSpans = spansFor(text.length - 1), nlines = to.line - from.line;

  // Adjust the line structure
  if (change.full) {
    doc.insert(0, linesFor(0, text.length));
    doc.remove(text.length, doc.size - text.length);
  } else if (isWholeLineUpdate(doc, change)) {
    // This is a whole-line replace. Treated specially to make
    // sure line objects move the way they are supposed to.
    var added = linesFor(0, text.length - 1);
    update(lastLine, lastLine.text, lastSpans);
    if (nlines) { doc.remove(from.line, nlines); }
    if (added.length) { doc.insert(from.line, added); }
  } else if (firstLine == lastLine) {
    if (text.length == 1) {
      update(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans);
    } else {
      var added$1 = linesFor(1, text.length - 1);
      added$1.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight$$1));
      update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
      doc.insert(from.line + 1, added$1);
    }
  } else if (text.length == 1) {
    update(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0));
    doc.remove(from.line + 1, nlines);
  } else {
    update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
    update(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans);
    var added$2 = linesFor(1, text.length - 1);
    if (nlines > 1) { doc.remove(from.line + 1, nlines - 1); }
    doc.insert(from.line + 1, added$2);
  }

  signalLater(doc, "change", doc, change);
}

// Call f for all linked documents.
function linkedDocs(doc, f, sharedHistOnly) {
  function propagate(doc, skip, sharedHist) {
    if (doc.linked) { for (var i = 0; i < doc.linked.length; ++i) {
      var rel = doc.linked[i];
      if (rel.doc == skip) { continue }
      var shared = sharedHist && rel.sharedHist;
      if (sharedHistOnly && !shared) { continue }
      f(rel.doc, shared);
      propagate(rel.doc, doc, shared);
    } }
  }
  propagate(doc, null, true);
}

// Attach a document to an editor.
function attachDoc(cm, doc) {
  if (doc.cm) { throw new Error("This document is already in use.") }
  cm.doc = doc;
  doc.cm = cm;
  estimateLineHeights(cm);
  loadMode(cm);
  setDirectionClass(cm);
  if (!cm.options.lineWrapping) { findMaxLine(cm); }
  cm.options.mode = doc.modeOption;
  regChange(cm);
}

function setDirectionClass(cm) {
  (cm.doc.direction == "rtl" ? addClass : rmClass)(cm.display.lineDiv, "CodeMirror-rtl");
}

function directionChanged(cm) {
  runInOp(cm, function () {
    setDirectionClass(cm);
    regChange(cm);
  });
}

function History(startGen) {
  // Arrays of change events and selections. Doing something adds an
  // event to done and clears undo. Undoing moves events from done
  // to undone, redoing moves them in the other direction.
  this.done = []; this.undone = [];
  this.undoDepth = Infinity;
  // Used to track when changes can be merged into a single undo
  // event
  this.lastModTime = this.lastSelTime = 0;
  this.lastOp = this.lastSelOp = null;
  this.lastOrigin = this.lastSelOrigin = null;
  // Used by the isClean() method
  this.generation = this.maxGeneration = startGen || 1;
}

// Create a history change event from an updateDoc-style change
// object.
function historyChangeFromChange(doc, change) {
  var histChange = {from: copyPos(change.from), to: changeEnd(change), text: getBetween(doc, change.from, change.to)};
  attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
  linkedDocs(doc, function (doc) { return attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1); }, true);
  return histChange
}

// Pop all selection events off the end of a history array. Stop at
// a change event.
function clearSelectionEvents(array) {
  while (array.length) {
    var last = lst(array);
    if (last.ranges) { array.pop(); }
    else { break }
  }
}

// Find the top change event in the history. Pop off selection
// events that are in the way.
function lastChangeEvent(hist, force) {
  if (force) {
    clearSelectionEvents(hist.done);
    return lst(hist.done)
  } else if (hist.done.length && !lst(hist.done).ranges) {
    return lst(hist.done)
  } else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
    hist.done.pop();
    return lst(hist.done)
  }
}

// Register a change in the history. Merges changes that are within
// a single operation, or are close together with an origin that
// allows merging (starting with "+") into a single event.
function addChangeToHistory(doc, change, selAfter, opId) {
  var hist = doc.history;
  hist.undone.length = 0;
  var time = +new Date, cur;
  var last;

  if ((hist.lastOp == opId ||
       hist.lastOrigin == change.origin && change.origin &&
       ((change.origin.charAt(0) == "+" && hist.lastModTime > time - (doc.cm ? doc.cm.options.historyEventDelay : 500)) ||
        change.origin.charAt(0) == "*")) &&
      (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
    // Merge this change into the last event
    last = lst(cur.changes);
    if (cmp(change.from, change.to) == 0 && cmp(change.from, last.to) == 0) {
      // Optimized case for simple insertion -- don't want to add
      // new changesets for every character typed
      last.to = changeEnd(change);
    } else {
      // Add new sub-event
      cur.changes.push(historyChangeFromChange(doc, change));
    }
  } else {
    // Can not be merged, start a new event.
    var before = lst(hist.done);
    if (!before || !before.ranges)
      { pushSelectionToHistory(doc.sel, hist.done); }
    cur = {changes: [historyChangeFromChange(doc, change)],
           generation: hist.generation};
    hist.done.push(cur);
    while (hist.done.length > hist.undoDepth) {
      hist.done.shift();
      if (!hist.done[0].ranges) { hist.done.shift(); }
    }
  }
  hist.done.push(selAfter);
  hist.generation = ++hist.maxGeneration;
  hist.lastModTime = hist.lastSelTime = time;
  hist.lastOp = hist.lastSelOp = opId;
  hist.lastOrigin = hist.lastSelOrigin = change.origin;

  if (!last) { signal(doc, "historyAdded"); }
}

function selectionEventCanBeMerged(doc, origin, prev, sel) {
  var ch = origin.charAt(0);
  return ch == "*" ||
    ch == "+" &&
    prev.ranges.length == sel.ranges.length &&
    prev.somethingSelected() == sel.somethingSelected() &&
    new Date - doc.history.lastSelTime <= (doc.cm ? doc.cm.options.historyEventDelay : 500)
}

// Called whenever the selection changes, sets the new selection as
// the pending selection in the history, and pushes the old pending
// selection into the 'done' array when it was significantly
// different (in number of selected ranges, emptiness, or time).
function addSelectionToHistory(doc, sel, opId, options) {
  var hist = doc.history, origin = options && options.origin;

  // A new event is started when the previous origin does not match
  // the current, or the origins don't allow matching. Origins
  // starting with * are always merged, those starting with + are
  // merged when similar and close together in time.
  if (opId == hist.lastSelOp ||
      (origin && hist.lastSelOrigin == origin &&
       (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin ||
        selectionEventCanBeMerged(doc, origin, lst(hist.done), sel))))
    { hist.done[hist.done.length - 1] = sel; }
  else
    { pushSelectionToHistory(sel, hist.done); }

  hist.lastSelTime = +new Date;
  hist.lastSelOrigin = origin;
  hist.lastSelOp = opId;
  if (options && options.clearRedo !== false)
    { clearSelectionEvents(hist.undone); }
}

function pushSelectionToHistory(sel, dest) {
  var top = lst(dest);
  if (!(top && top.ranges && top.equals(sel)))
    { dest.push(sel); }
}

// Used to store marked span information in the history.
function attachLocalSpans(doc, change, from, to) {
  var existing = change["spans_" + doc.id], n = 0;
  doc.iter(Math.max(doc.first, from), Math.min(doc.first + doc.size, to), function (line) {
    if (line.markedSpans)
      { (existing || (existing = change["spans_" + doc.id] = {}))[n] = line.markedSpans; }
    ++n;
  });
}

// When un/re-doing restores text containing marked spans, those
// that have been explicitly cleared should not be restored.
function removeClearedSpans(spans) {
  if (!spans) { return null }
  var out;
  for (var i = 0; i < spans.length; ++i) {
    if (spans[i].marker.explicitlyCleared) { if (!out) { out = spans.slice(0, i); } }
    else if (out) { out.push(spans[i]); }
  }
  return !out ? spans : out.length ? out : null
}

// Retrieve and filter the old marked spans stored in a change event.
function getOldSpans(doc, change) {
  var found = change["spans_" + doc.id];
  if (!found) { return null }
  var nw = [];
  for (var i = 0; i < change.text.length; ++i)
    { nw.push(removeClearedSpans(found[i])); }
  return nw
}

// Used for un/re-doing changes from the history. Combines the
// result of computing the existing spans with the set of spans that
// existed in the history (so that deleting around a span and then
// undoing brings back the span).
function mergeOldSpans(doc, change) {
  var old = getOldSpans(doc, change);
  var stretched = stretchSpansOverChange(doc, change);
  if (!old) { return stretched }
  if (!stretched) { return old }

  for (var i = 0; i < old.length; ++i) {
    var oldCur = old[i], stretchCur = stretched[i];
    if (oldCur && stretchCur) {
      spans: for (var j = 0; j < stretchCur.length; ++j) {
        var span = stretchCur[j];
        for (var k = 0; k < oldCur.length; ++k)
          { if (oldCur[k].marker == span.marker) { continue spans } }
        oldCur.push(span);
      }
    } else if (stretchCur) {
      old[i] = stretchCur;
    }
  }
  return old
}

// Used both to provide a JSON-safe object in .getHistory, and, when
// detaching a document, to split the history in two
function copyHistoryArray(events, newGroup, instantiateSel) {
  var copy = [];
  for (var i = 0; i < events.length; ++i) {
    var event = events[i];
    if (event.ranges) {
      copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event);
      continue
    }
    var changes = event.changes, newChanges = [];
    copy.push({changes: newChanges});
    for (var j = 0; j < changes.length; ++j) {
      var change = changes[j], m = (void 0);
      newChanges.push({from: change.from, to: change.to, text: change.text});
      if (newGroup) { for (var prop in change) { if (m = prop.match(/^spans_(\d+)$/)) {
        if (indexOf(newGroup, Number(m[1])) > -1) {
          lst(newChanges)[prop] = change[prop];
          delete change[prop];
        }
      } } }
    }
  }
  return copy
}

// The 'scroll' parameter given to many of these indicated whether
// the new cursor position should be scrolled into view after
// modifying the selection.

// If shift is held or the extend flag is set, extends a range to
// include a given position (and optionally a second position).
// Otherwise, simply returns the range between the given positions.
// Used for cursor motion and such.
function extendRange(range, head, other, extend) {
  if (extend) {
    var anchor = range.anchor;
    if (other) {
      var posBefore = cmp(head, anchor) < 0;
      if (posBefore != (cmp(other, anchor) < 0)) {
        anchor = head;
        head = other;
      } else if (posBefore != (cmp(head, other) < 0)) {
        head = other;
      }
    }
    return new Range(anchor, head)
  } else {
    return new Range(other || head, head)
  }
}

// Extend the primary selection range, discard the rest.
function extendSelection(doc, head, other, options, extend) {
  if (extend == null) { extend = doc.cm && (doc.cm.display.shift || doc.extend); }
  setSelection(doc, new Selection([extendRange(doc.sel.primary(), head, other, extend)], 0), options);
}

// Extend all selections (pos is an array of selections with length
// equal the number of selections)
function extendSelections(doc, heads, options) {
  var out = [];
  var extend = doc.cm && (doc.cm.display.shift || doc.extend);
  for (var i = 0; i < doc.sel.ranges.length; i++)
    { out[i] = extendRange(doc.sel.ranges[i], heads[i], null, extend); }
  var newSel = normalizeSelection(out, doc.sel.primIndex);
  setSelection(doc, newSel, options);
}

// Updates a single range in the selection.
function replaceOneSelection(doc, i, range, options) {
  var ranges = doc.sel.ranges.slice(0);
  ranges[i] = range;
  setSelection(doc, normalizeSelection(ranges, doc.sel.primIndex), options);
}

// Reset the selection to a single range.
function setSimpleSelection(doc, anchor, head, options) {
  setSelection(doc, simpleSelection(anchor, head), options);
}

// Give beforeSelectionChange handlers a change to influence a
// selection update.
function filterSelectionChange(doc, sel, options) {
  var obj = {
    ranges: sel.ranges,
    update: function(ranges) {
      var this$1 = this;

      this.ranges = [];
      for (var i = 0; i < ranges.length; i++)
        { this$1.ranges[i] = new Range(clipPos(doc, ranges[i].anchor),
                                   clipPos(doc, ranges[i].head)); }
    },
    origin: options && options.origin
  };
  signal(doc, "beforeSelectionChange", doc, obj);
  if (doc.cm) { signal(doc.cm, "beforeSelectionChange", doc.cm, obj); }
  if (obj.ranges != sel.ranges) { return normalizeSelection(obj.ranges, obj.ranges.length - 1) }
  else { return sel }
}

function setSelectionReplaceHistory(doc, sel, options) {
  var done = doc.history.done, last = lst(done);
  if (last && last.ranges) {
    done[done.length - 1] = sel;
    setSelectionNoUndo(doc, sel, options);
  } else {
    setSelection(doc, sel, options);
  }
}

// Set a new selection.
function setSelection(doc, sel, options) {
  setSelectionNoUndo(doc, sel, options);
  addSelectionToHistory(doc, doc.sel, doc.cm ? doc.cm.curOp.id : NaN, options);
}

function setSelectionNoUndo(doc, sel, options) {
  if (hasHandler(doc, "beforeSelectionChange") || doc.cm && hasHandler(doc.cm, "beforeSelectionChange"))
    { sel = filterSelectionChange(doc, sel, options); }

  var bias = options && options.bias ||
    (cmp(sel.primary().head, doc.sel.primary().head) < 0 ? -1 : 1);
  setSelectionInner(doc, skipAtomicInSelection(doc, sel, bias, true));

  if (!(options && options.scroll === false) && doc.cm)
    { ensureCursorVisible(doc.cm); }
}

function setSelectionInner(doc, sel) {
  if (sel.equals(doc.sel)) { return }

  doc.sel = sel;

  if (doc.cm) {
    doc.cm.curOp.updateInput = doc.cm.curOp.selectionChanged = true;
    signalCursorActivity(doc.cm);
  }
  signalLater(doc, "cursorActivity", doc);
}

// Verify that the selection does not partially select any atomic
// marked ranges.
function reCheckSelection(doc) {
  setSelectionInner(doc, skipAtomicInSelection(doc, doc.sel, null, false));
}

// Return a selection that does not partially select any atomic
// ranges.
function skipAtomicInSelection(doc, sel, bias, mayClear) {
  var out;
  for (var i = 0; i < sel.ranges.length; i++) {
    var range = sel.ranges[i];
    var old = sel.ranges.length == doc.sel.ranges.length && doc.sel.ranges[i];
    var newAnchor = skipAtomic(doc, range.anchor, old && old.anchor, bias, mayClear);
    var newHead = skipAtomic(doc, range.head, old && old.head, bias, mayClear);
    if (out || newAnchor != range.anchor || newHead != range.head) {
      if (!out) { out = sel.ranges.slice(0, i); }
      out[i] = new Range(newAnchor, newHead);
    }
  }
  return out ? normalizeSelection(out, sel.primIndex) : sel
}

function skipAtomicInner(doc, pos, oldPos, dir, mayClear) {
  var line = getLine(doc, pos.line);
  if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
    var sp = line.markedSpans[i], m = sp.marker;
    if ((sp.from == null || (m.inclusiveLeft ? sp.from <= pos.ch : sp.from < pos.ch)) &&
        (sp.to == null || (m.inclusiveRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
      if (mayClear) {
        signal(m, "beforeCursorEnter");
        if (m.explicitlyCleared) {
          if (!line.markedSpans) { break }
          else {--i; continue}
        }
      }
      if (!m.atomic) { continue }

      if (oldPos) {
        var near = m.find(dir < 0 ? 1 : -1), diff = (void 0);
        if (dir < 0 ? m.inclusiveRight : m.inclusiveLeft)
          { near = movePos(doc, near, -dir, near && near.line == pos.line ? line : null); }
        if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0))
          { return skipAtomicInner(doc, near, pos, dir, mayClear) }
      }

      var far = m.find(dir < 0 ? -1 : 1);
      if (dir < 0 ? m.inclusiveLeft : m.inclusiveRight)
        { far = movePos(doc, far, dir, far.line == pos.line ? line : null); }
      return far ? skipAtomicInner(doc, far, pos, dir, mayClear) : null
    }
  } }
  return pos
}

// Ensure a given position is not inside an atomic range.
function skipAtomic(doc, pos, oldPos, bias, mayClear) {
  var dir = bias || 1;
  var found = skipAtomicInner(doc, pos, oldPos, dir, mayClear) ||
      (!mayClear && skipAtomicInner(doc, pos, oldPos, dir, true)) ||
      skipAtomicInner(doc, pos, oldPos, -dir, mayClear) ||
      (!mayClear && skipAtomicInner(doc, pos, oldPos, -dir, true));
  if (!found) {
    doc.cantEdit = true;
    return Pos(doc.first, 0)
  }
  return found
}

function movePos(doc, pos, dir, line) {
  if (dir < 0 && pos.ch == 0) {
    if (pos.line > doc.first) { return clipPos(doc, Pos(pos.line - 1)) }
    else { return null }
  } else if (dir > 0 && pos.ch == (line || getLine(doc, pos.line)).text.length) {
    if (pos.line < doc.first + doc.size - 1) { return Pos(pos.line + 1, 0) }
    else { return null }
  } else {
    return new Pos(pos.line, pos.ch + dir)
  }
}

function selectAll(cm) {
  cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll);
}

// UPDATING

// Allow "beforeChange" event handlers to influence a change
function filterChange(doc, change, update) {
  var obj = {
    canceled: false,
    from: change.from,
    to: change.to,
    text: change.text,
    origin: change.origin,
    cancel: function () { return obj.canceled = true; }
  };
  if (update) { obj.update = function (from, to, text, origin) {
    if (from) { obj.from = clipPos(doc, from); }
    if (to) { obj.to = clipPos(doc, to); }
    if (text) { obj.text = text; }
    if (origin !== undefined) { obj.origin = origin; }
  }; }
  signal(doc, "beforeChange", doc, obj);
  if (doc.cm) { signal(doc.cm, "beforeChange", doc.cm, obj); }

  if (obj.canceled) { return null }
  return {from: obj.from, to: obj.to, text: obj.text, origin: obj.origin}
}

// Apply a change to a document, and add it to the document's
// history, and propagating it to all linked documents.
function makeChange(doc, change, ignoreReadOnly) {
  if (doc.cm) {
    if (!doc.cm.curOp) { return operation(doc.cm, makeChange)(doc, change, ignoreReadOnly) }
    if (doc.cm.state.suppressEdits) { return }
  }

  if (hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")) {
    change = filterChange(doc, change, true);
    if (!change) { return }
  }

  // Possibly split or suppress the update based on the presence
  // of read-only spans in its range.
  var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc, change.from, change.to);
  if (split) {
    for (var i = split.length - 1; i >= 0; --i)
      { makeChangeInner(doc, {from: split[i].from, to: split[i].to, text: i ? [""] : change.text, origin: change.origin}); }
  } else {
    makeChangeInner(doc, change);
  }
}

function makeChangeInner(doc, change) {
  if (change.text.length == 1 && change.text[0] == "" && cmp(change.from, change.to) == 0) { return }
  var selAfter = computeSelAfterChange(doc, change);
  addChangeToHistory(doc, change, selAfter, doc.cm ? doc.cm.curOp.id : NaN);

  makeChangeSingleDoc(doc, change, selAfter, stretchSpansOverChange(doc, change));
  var rebased = [];

  linkedDocs(doc, function (doc, sharedHist) {
    if (!sharedHist && indexOf(rebased, doc.history) == -1) {
      rebaseHist(doc.history, change);
      rebased.push(doc.history);
    }
    makeChangeSingleDoc(doc, change, null, stretchSpansOverChange(doc, change));
  });
}

// Revert a change stored in a document's history.
function makeChangeFromHistory(doc, type, allowSelectionOnly) {
  var suppress = doc.cm && doc.cm.state.suppressEdits;
  if (suppress && !allowSelectionOnly) { return }

  var hist = doc.history, event, selAfter = doc.sel;
  var source = type == "undo" ? hist.done : hist.undone, dest = type == "undo" ? hist.undone : hist.done;

  // Verify that there is a useable event (so that ctrl-z won't
  // needlessly clear selection events)
  var i = 0;
  for (; i < source.length; i++) {
    event = source[i];
    if (allowSelectionOnly ? event.ranges && !event.equals(doc.sel) : !event.ranges)
      { break }
  }
  if (i == source.length) { return }
  hist.lastOrigin = hist.lastSelOrigin = null;

  for (;;) {
    event = source.pop();
    if (event.ranges) {
      pushSelectionToHistory(event, dest);
      if (allowSelectionOnly && !event.equals(doc.sel)) {
        setSelection(doc, event, {clearRedo: false});
        return
      }
      selAfter = event;
    } else if (suppress) {
      source.push(event);
      return
    } else { break }
  }

  // Build up a reverse change object to add to the opposite history
  // stack (redo when undoing, and vice versa).
  var antiChanges = [];
  pushSelectionToHistory(selAfter, dest);
  dest.push({changes: antiChanges, generation: hist.generation});
  hist.generation = event.generation || ++hist.maxGeneration;

  var filter = hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange");

  var loop = function ( i ) {
    var change = event.changes[i];
    change.origin = type;
    if (filter && !filterChange(doc, change, false)) {
      source.length = 0;
      return {}
    }

    antiChanges.push(historyChangeFromChange(doc, change));

    var after = i ? computeSelAfterChange(doc, change) : lst(source);
    makeChangeSingleDoc(doc, change, after, mergeOldSpans(doc, change));
    if (!i && doc.cm) { doc.cm.scrollIntoView({from: change.from, to: changeEnd(change)}); }
    var rebased = [];

    // Propagate to the linked documents
    linkedDocs(doc, function (doc, sharedHist) {
      if (!sharedHist && indexOf(rebased, doc.history) == -1) {
        rebaseHist(doc.history, change);
        rebased.push(doc.history);
      }
      makeChangeSingleDoc(doc, change, null, mergeOldSpans(doc, change));
    });
  };

  for (var i$1 = event.changes.length - 1; i$1 >= 0; --i$1) {
    var returned = loop( i$1 );

    if ( returned ) return returned.v;
  }
}

// Sub-views need their line numbers shifted when text is added
// above or below them in the parent document.
function shiftDoc(doc, distance) {
  if (distance == 0) { return }
  doc.first += distance;
  doc.sel = new Selection(map(doc.sel.ranges, function (range) { return new Range(
    Pos(range.anchor.line + distance, range.anchor.ch),
    Pos(range.head.line + distance, range.head.ch)
  ); }), doc.sel.primIndex);
  if (doc.cm) {
    regChange(doc.cm, doc.first, doc.first - distance, distance);
    for (var d = doc.cm.display, l = d.viewFrom; l < d.viewTo; l++)
      { regLineChange(doc.cm, l, "gutter"); }
  }
}

// More lower-level change function, handling only a single document
// (not linked ones).
function makeChangeSingleDoc(doc, change, selAfter, spans) {
  if (doc.cm && !doc.cm.curOp)
    { return operation(doc.cm, makeChangeSingleDoc)(doc, change, selAfter, spans) }

  if (change.to.line < doc.first) {
    shiftDoc(doc, change.text.length - 1 - (change.to.line - change.from.line));
    return
  }
  if (change.from.line > doc.lastLine()) { return }

  // Clip the change to the size of this doc
  if (change.from.line < doc.first) {
    var shift = change.text.length - 1 - (doc.first - change.from.line);
    shiftDoc(doc, shift);
    change = {from: Pos(doc.first, 0), to: Pos(change.to.line + shift, change.to.ch),
              text: [lst(change.text)], origin: change.origin};
  }
  var last = doc.lastLine();
  if (change.to.line > last) {
    change = {from: change.from, to: Pos(last, getLine(doc, last).text.length),
              text: [change.text[0]], origin: change.origin};
  }

  change.removed = getBetween(doc, change.from, change.to);

  if (!selAfter) { selAfter = computeSelAfterChange(doc, change); }
  if (doc.cm) { makeChangeSingleDocInEditor(doc.cm, change, spans); }
  else { updateDoc(doc, change, spans); }
  setSelectionNoUndo(doc, selAfter, sel_dontScroll);
}

// Handle the interaction of a change to a document with the editor
// that this document is part of.
function makeChangeSingleDocInEditor(cm, change, spans) {
  var doc = cm.doc, display = cm.display, from = change.from, to = change.to;

  var recomputeMaxLength = false, checkWidthStart = from.line;
  if (!cm.options.lineWrapping) {
    checkWidthStart = lineNo(visualLine(getLine(doc, from.line)));
    doc.iter(checkWidthStart, to.line + 1, function (line) {
      if (line == display.maxLine) {
        recomputeMaxLength = true;
        return true
      }
    });
  }

  if (doc.sel.contains(change.from, change.to) > -1)
    { signalCursorActivity(cm); }

  updateDoc(doc, change, spans, estimateHeight(cm));

  if (!cm.options.lineWrapping) {
    doc.iter(checkWidthStart, from.line + change.text.length, function (line) {
      var len = lineLength(line);
      if (len > display.maxLineLength) {
        display.maxLine = line;
        display.maxLineLength = len;
        display.maxLineChanged = true;
        recomputeMaxLength = false;
      }
    });
    if (recomputeMaxLength) { cm.curOp.updateMaxLine = true; }
  }

  retreatFrontier(doc, from.line);
  startWorker(cm, 400);

  var lendiff = change.text.length - (to.line - from.line) - 1;
  // Remember that these lines changed, for updating the display
  if (change.full)
    { regChange(cm); }
  else if (from.line == to.line && change.text.length == 1 && !isWholeLineUpdate(cm.doc, change))
    { regLineChange(cm, from.line, "text"); }
  else
    { regChange(cm, from.line, to.line + 1, lendiff); }

  var changesHandler = hasHandler(cm, "changes"), changeHandler = hasHandler(cm, "change");
  if (changeHandler || changesHandler) {
    var obj = {
      from: from, to: to,
      text: change.text,
      removed: change.removed,
      origin: change.origin
    };
    if (changeHandler) { signalLater(cm, "change", cm, obj); }
    if (changesHandler) { (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj); }
  }
  cm.display.selForContextMenu = null;
}

function replaceRange(doc, code, from, to, origin) {
  if (!to) { to = from; }
  if (cmp(to, from) < 0) { var assign;
    (assign = [to, from], from = assign[0], to = assign[1]); }
  if (typeof code == "string") { code = doc.splitLines(code); }
  makeChange(doc, {from: from, to: to, text: code, origin: origin});
}

// Rebasing/resetting history to deal with externally-sourced changes

function rebaseHistSelSingle(pos, from, to, diff) {
  if (to < pos.line) {
    pos.line += diff;
  } else if (from < pos.line) {
    pos.line = from;
    pos.ch = 0;
  }
}

// Tries to rebase an array of history events given a change in the
// document. If the change touches the same lines as the event, the
// event, and everything 'behind' it, is discarded. If the change is
// before the event, the event's positions are updated. Uses a
// copy-on-write scheme for the positions, to avoid having to
// reallocate them all on every rebase, but also avoid problems with
// shared position objects being unsafely updated.
function rebaseHistArray(array, from, to, diff) {
  for (var i = 0; i < array.length; ++i) {
    var sub = array[i], ok = true;
    if (sub.ranges) {
      if (!sub.copied) { sub = array[i] = sub.deepCopy(); sub.copied = true; }
      for (var j = 0; j < sub.ranges.length; j++) {
        rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff);
        rebaseHistSelSingle(sub.ranges[j].head, from, to, diff);
      }
      continue
    }
    for (var j$1 = 0; j$1 < sub.changes.length; ++j$1) {
      var cur = sub.changes[j$1];
      if (to < cur.from.line) {
        cur.from = Pos(cur.from.line + diff, cur.from.ch);
        cur.to = Pos(cur.to.line + diff, cur.to.ch);
      } else if (from <= cur.to.line) {
        ok = false;
        break
      }
    }
    if (!ok) {
      array.splice(0, i + 1);
      i = 0;
    }
  }
}

function rebaseHist(hist, change) {
  var from = change.from.line, to = change.to.line, diff = change.text.length - (to - from) - 1;
  rebaseHistArray(hist.done, from, to, diff);
  rebaseHistArray(hist.undone, from, to, diff);
}

// Utility for applying a change to a line by handle or number,
// returning the number and optionally registering the line as
// changed.
function changeLine(doc, handle, changeType, op) {
  var no = handle, line = handle;
  if (typeof handle == "number") { line = getLine(doc, clipLine(doc, handle)); }
  else { no = lineNo(handle); }
  if (no == null) { return null }
  if (op(line, no) && doc.cm) { regLineChange(doc.cm, no, changeType); }
  return line
}

// The document is represented as a BTree consisting of leaves, with
// chunk of lines in them, and branches, with up to ten leaves or
// other branch nodes below them. The top node is always a branch
// node, and is the document object itself (meaning it has
// additional methods and properties).
//
// All nodes have parent links. The tree is used both to go from
// line numbers to line objects, and to go from objects to numbers.
// It also indexes by height, and is used to convert between height
// and line object, and to find the total height of the document.
//
// See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html

function LeafChunk(lines) {
  var this$1 = this;

  this.lines = lines;
  this.parent = null;
  var height = 0;
  for (var i = 0; i < lines.length; ++i) {
    lines[i].parent = this$1;
    height += lines[i].height;
  }
  this.height = height;
}

LeafChunk.prototype = {
  chunkSize: function() { return this.lines.length },

  // Remove the n lines at offset 'at'.
  removeInner: function(at, n) {
    var this$1 = this;

    for (var i = at, e = at + n; i < e; ++i) {
      var line = this$1.lines[i];
      this$1.height -= line.height;
      cleanUpLine(line);
      signalLater(line, "delete");
    }
    this.lines.splice(at, n);
  },

  // Helper used to collapse a small branch into a single leaf.
  collapse: function(lines) {
    lines.push.apply(lines, this.lines);
  },

  // Insert the given array of lines at offset 'at', count them as
  // having the given height.
  insertInner: function(at, lines, height) {
    var this$1 = this;

    this.height += height;
    this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at));
    for (var i = 0; i < lines.length; ++i) { lines[i].parent = this$1; }
  },

  // Used to iterate over a part of the tree.
  iterN: function(at, n, op) {
    var this$1 = this;

    for (var e = at + n; at < e; ++at)
      { if (op(this$1.lines[at])) { return true } }
  }
};

function BranchChunk(children) {
  var this$1 = this;

  this.children = children;
  var size = 0, height = 0;
  for (var i = 0; i < children.length; ++i) {
    var ch = children[i];
    size += ch.chunkSize(); height += ch.height;
    ch.parent = this$1;
  }
  this.size = size;
  this.height = height;
  this.parent = null;
}

BranchChunk.prototype = {
  chunkSize: function() { return this.size },

  removeInner: function(at, n) {
    var this$1 = this;

    this.size -= n;
    for (var i = 0; i < this.children.length; ++i) {
      var child = this$1.children[i], sz = child.chunkSize();
      if (at < sz) {
        var rm = Math.min(n, sz - at), oldHeight = child.height;
        child.removeInner(at, rm);
        this$1.height -= oldHeight - child.height;
        if (sz == rm) { this$1.children.splice(i--, 1); child.parent = null; }
        if ((n -= rm) == 0) { break }
        at = 0;
      } else { at -= sz; }
    }
    // If the result is smaller than 25 lines, ensure that it is a
    // single leaf node.
    if (this.size - n < 25 &&
        (this.children.length > 1 || !(this.children[0] instanceof LeafChunk))) {
      var lines = [];
      this.collapse(lines);
      this.children = [new LeafChunk(lines)];
      this.children[0].parent = this;
    }
  },

  collapse: function(lines) {
    var this$1 = this;

    for (var i = 0; i < this.children.length; ++i) { this$1.children[i].collapse(lines); }
  },

  insertInner: function(at, lines, height) {
    var this$1 = this;

    this.size += lines.length;
    this.height += height;
    for (var i = 0; i < this.children.length; ++i) {
      var child = this$1.children[i], sz = child.chunkSize();
      if (at <= sz) {
        child.insertInner(at, lines, height);
        if (child.lines && child.lines.length > 50) {
          // To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
          // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
          var remaining = child.lines.length % 25 + 25;
          for (var pos = remaining; pos < child.lines.length;) {
            var leaf = new LeafChunk(child.lines.slice(pos, pos += 25));
            child.height -= leaf.height;
            this$1.children.splice(++i, 0, leaf);
            leaf.parent = this$1;
          }
          child.lines = child.lines.slice(0, remaining);
          this$1.maybeSpill();
        }
        break
      }
      at -= sz;
    }
  },

  // When a node has grown, check whether it should be split.
  maybeSpill: function() {
    if (this.children.length <= 10) { return }
    var me = this;
    do {
      var spilled = me.children.splice(me.children.length - 5, 5);
      var sibling = new BranchChunk(spilled);
      if (!me.parent) { // Become the parent node
        var copy = new BranchChunk(me.children);
        copy.parent = me;
        me.children = [copy, sibling];
        me = copy;
     } else {
        me.size -= sibling.size;
        me.height -= sibling.height;
        var myIndex = indexOf(me.parent.children, me);
        me.parent.children.splice(myIndex + 1, 0, sibling);
      }
      sibling.parent = me.parent;
    } while (me.children.length > 10)
    me.parent.maybeSpill();
  },

  iterN: function(at, n, op) {
    var this$1 = this;

    for (var i = 0; i < this.children.length; ++i) {
      var child = this$1.children[i], sz = child.chunkSize();
      if (at < sz) {
        var used = Math.min(n, sz - at);
        if (child.iterN(at, used, op)) { return true }
        if ((n -= used) == 0) { break }
        at = 0;
      } else { at -= sz; }
    }
  }
};

// Line widgets are block elements displayed above or below a line.

var LineWidget = function(doc, node, options) {
  var this$1 = this;

  if (options) { for (var opt in options) { if (options.hasOwnProperty(opt))
    { this$1[opt] = options[opt]; } } }
  this.doc = doc;
  this.node = node;
};

LineWidget.prototype.clear = function () {
    var this$1 = this;

  var cm = this.doc.cm, ws = this.line.widgets, line = this.line, no = lineNo(line);
  if (no == null || !ws) { return }
  for (var i = 0; i < ws.length; ++i) { if (ws[i] == this$1) { ws.splice(i--, 1); } }
  if (!ws.length) { line.widgets = null; }
  var height = widgetHeight(this);
  updateLineHeight(line, Math.max(0, line.height - height));
  if (cm) {
    runInOp(cm, function () {
      adjustScrollWhenAboveVisible(cm, line, -height);
      regLineChange(cm, no, "widget");
    });
    signalLater(cm, "lineWidgetCleared", cm, this, no);
  }
};

LineWidget.prototype.changed = function () {
    var this$1 = this;

  var oldH = this.height, cm = this.doc.cm, line = this.line;
  this.height = null;
  var diff = widgetHeight(this) - oldH;
  if (!diff) { return }
  updateLineHeight(line, line.height + diff);
  if (cm) {
    runInOp(cm, function () {
      cm.curOp.forceUpdate = true;
      adjustScrollWhenAboveVisible(cm, line, diff);
      signalLater(cm, "lineWidgetChanged", cm, this$1, lineNo(line));
    });
  }
};
eventMixin(LineWidget);

function adjustScrollWhenAboveVisible(cm, line, diff) {
  if (heightAtLine(line) < ((cm.curOp && cm.curOp.scrollTop) || cm.doc.scrollTop))
    { addToScrollTop(cm, diff); }
}

function addLineWidget(doc, handle, node, options) {
  var widget = new LineWidget(doc, node, options);
  var cm = doc.cm;
  if (cm && widget.noHScroll) { cm.display.alignWidgets = true; }
  changeLine(doc, handle, "widget", function (line) {
    var widgets = line.widgets || (line.widgets = []);
    if (widget.insertAt == null) { widgets.push(widget); }
    else { widgets.splice(Math.min(widgets.length - 1, Math.max(0, widget.insertAt)), 0, widget); }
    widget.line = line;
    if (cm && !lineIsHidden(doc, line)) {
      var aboveVisible = heightAtLine(line) < doc.scrollTop;
      updateLineHeight(line, line.height + widgetHeight(widget));
      if (aboveVisible) { addToScrollTop(cm, widget.height); }
      cm.curOp.forceUpdate = true;
    }
    return true
  });
  if (cm) { signalLater(cm, "lineWidgetAdded", cm, widget, typeof handle == "number" ? handle : lineNo(handle)); }
  return widget
}

// TEXTMARKERS

// Created with markText and setBookmark methods. A TextMarker is a
// handle that can be used to clear or find a marked position in the
// document. Line objects hold arrays (markedSpans) containing
// {from, to, marker} object pointing to such marker objects, and
// indicating that such a marker is present on that line. Multiple
// lines may point to the same marker when it spans across lines.
// The spans will have null for their from/to properties when the
// marker continues beyond the start/end of the line. Markers have
// links back to the lines they currently touch.

// Collapsed markers have unique ids, in order to be able to order
// them, which is needed for uniquely determining an outer marker
// when they overlap (they may nest, but not partially overlap).
var nextMarkerId = 0;

var TextMarker = function(doc, type) {
  this.lines = [];
  this.type = type;
  this.doc = doc;
  this.id = ++nextMarkerId;
};

// Clear the marker.
TextMarker.prototype.clear = function () {
    var this$1 = this;

  if (this.explicitlyCleared) { return }
  var cm = this.doc.cm, withOp = cm && !cm.curOp;
  if (withOp) { startOperation(cm); }
  if (hasHandler(this, "clear")) {
    var found = this.find();
    if (found) { signalLater(this, "clear", found.from, found.to); }
  }
  var min = null, max = null;
  for (var i = 0; i < this.lines.length; ++i) {
    var line = this$1.lines[i];
    var span = getMarkedSpanFor(line.markedSpans, this$1);
    if (cm && !this$1.collapsed) { regLineChange(cm, lineNo(line), "text"); }
    else if (cm) {
      if (span.to != null) { max = lineNo(line); }
      if (span.from != null) { min = lineNo(line); }
    }
    line.markedSpans = removeMarkedSpan(line.markedSpans, span);
    if (span.from == null && this$1.collapsed && !lineIsHidden(this$1.doc, line) && cm)
      { updateLineHeight(line, textHeight(cm.display)); }
  }
  if (cm && this.collapsed && !cm.options.lineWrapping) { for (var i$1 = 0; i$1 < this.lines.length; ++i$1) {
    var visual = visualLine(this$1.lines[i$1]), len = lineLength(visual);
    if (len > cm.display.maxLineLength) {
      cm.display.maxLine = visual;
      cm.display.maxLineLength = len;
      cm.display.maxLineChanged = true;
    }
  } }

  if (min != null && cm && this.collapsed) { regChange(cm, min, max + 1); }
  this.lines.length = 0;
  this.explicitlyCleared = true;
  if (this.atomic && this.doc.cantEdit) {
    this.doc.cantEdit = false;
    if (cm) { reCheckSelection(cm.doc); }
  }
  if (cm) { signalLater(cm, "markerCleared", cm, this, min, max); }
  if (withOp) { endOperation(cm); }
  if (this.parent) { this.parent.clear(); }
};

// Find the position of the marker in the document. Returns a {from,
// to} object by default. Side can be passed to get a specific side
// -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
// Pos objects returned contain a line object, rather than a line
// number (used to prevent looking up the same line twice).
TextMarker.prototype.find = function (side, lineObj) {
    var this$1 = this;

  if (side == null && this.type == "bookmark") { side = 1; }
  var from, to;
  for (var i = 0; i < this.lines.length; ++i) {
    var line = this$1.lines[i];
    var span = getMarkedSpanFor(line.markedSpans, this$1);
    if (span.from != null) {
      from = Pos(lineObj ? line : lineNo(line), span.from);
      if (side == -1) { return from }
    }
    if (span.to != null) {
      to = Pos(lineObj ? line : lineNo(line), span.to);
      if (side == 1) { return to }
    }
  }
  return from && {from: from, to: to}
};

// Signals that the marker's widget changed, and surrounding layout
// should be recomputed.
TextMarker.prototype.changed = function () {
    var this$1 = this;

  var pos = this.find(-1, true), widget = this, cm = this.doc.cm;
  if (!pos || !cm) { return }
  runInOp(cm, function () {
    var line = pos.line, lineN = lineNo(pos.line);
    var view = findViewForLine(cm, lineN);
    if (view) {
      clearLineMeasurementCacheFor(view);
      cm.curOp.selectionChanged = cm.curOp.forceUpdate = true;
    }
    cm.curOp.updateMaxLine = true;
    if (!lineIsHidden(widget.doc, line) && widget.height != null) {
      var oldHeight = widget.height;
      widget.height = null;
      var dHeight = widgetHeight(widget) - oldHeight;
      if (dHeight)
        { updateLineHeight(line, line.height + dHeight); }
    }
    signalLater(cm, "markerChanged", cm, this$1);
  });
};

TextMarker.prototype.attachLine = function (line) {
  if (!this.lines.length && this.doc.cm) {
    var op = this.doc.cm.curOp;
    if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1)
      { (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this); }
  }
  this.lines.push(line);
};

TextMarker.prototype.detachLine = function (line) {
  this.lines.splice(indexOf(this.lines, line), 1);
  if (!this.lines.length && this.doc.cm) {
    var op = this.doc.cm.curOp;(op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this);
  }
};
eventMixin(TextMarker);

// Create a marker, wire it up to the right lines, and
function markText(doc, from, to, options, type) {
  // Shared markers (across linked documents) are handled separately
  // (markTextShared will call out to this again, once per
  // document).
  if (options && options.shared) { return markTextShared(doc, from, to, options, type) }
  // Ensure we are in an operation.
  if (doc.cm && !doc.cm.curOp) { return operation(doc.cm, markText)(doc, from, to, options, type) }

  var marker = new TextMarker(doc, type), diff = cmp(from, to);
  if (options) { copyObj(options, marker, false); }
  // Don't connect empty markers unless clearWhenEmpty is false
  if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false)
    { return marker }
  if (marker.replacedWith) {
    // Showing up as a widget implies collapsed (widget replaces text)
    marker.collapsed = true;
    marker.widgetNode = eltP("span", [marker.replacedWith], "CodeMirror-widget");
    if (!options.handleMouseEvents) { marker.widgetNode.setAttribute("cm-ignore-events", "true"); }
    if (options.insertLeft) { marker.widgetNode.insertLeft = true; }
  }
  if (marker.collapsed) {
    if (conflictingCollapsedRange(doc, from.line, from, to, marker) ||
        from.line != to.line && conflictingCollapsedRange(doc, to.line, from, to, marker))
      { throw new Error("Inserting collapsed marker partially overlapping an existing one") }
    seeCollapsedSpans();
  }

  if (marker.addToHistory)
    { addChangeToHistory(doc, {from: from, to: to, origin: "markText"}, doc.sel, NaN); }

  var curLine = from.line, cm = doc.cm, updateMaxLine;
  doc.iter(curLine, to.line + 1, function (line) {
    if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine)
      { updateMaxLine = true; }
    if (marker.collapsed && curLine != from.line) { updateLineHeight(line, 0); }
    addMarkedSpan(line, new MarkedSpan(marker,
                                       curLine == from.line ? from.ch : null,
                                       curLine == to.line ? to.ch : null));
    ++curLine;
  });
  // lineIsHidden depends on the presence of the spans, so needs a second pass
  if (marker.collapsed) { doc.iter(from.line, to.line + 1, function (line) {
    if (lineIsHidden(doc, line)) { updateLineHeight(line, 0); }
  }); }

  if (marker.clearOnEnter) { on(marker, "beforeCursorEnter", function () { return marker.clear(); }); }

  if (marker.readOnly) {
    seeReadOnlySpans();
    if (doc.history.done.length || doc.history.undone.length)
      { doc.clearHistory(); }
  }
  if (marker.collapsed) {
    marker.id = ++nextMarkerId;
    marker.atomic = true;
  }
  if (cm) {
    // Sync editor state
    if (updateMaxLine) { cm.curOp.updateMaxLine = true; }
    if (marker.collapsed)
      { regChange(cm, from.line, to.line + 1); }
    else if (marker.className || marker.title || marker.startStyle || marker.endStyle || marker.css)
      { for (var i = from.line; i <= to.line; i++) { regLineChange(cm, i, "text"); } }
    if (marker.atomic) { reCheckSelection(cm.doc); }
    signalLater(cm, "markerAdded", cm, marker);
  }
  return marker
}

// SHARED TEXTMARKERS

// A shared marker spans multiple linked documents. It is
// implemented as a meta-marker-object controlling multiple normal
// markers.
var SharedTextMarker = function(markers, primary) {
  var this$1 = this;

  this.markers = markers;
  this.primary = primary;
  for (var i = 0; i < markers.length; ++i)
    { markers[i].parent = this$1; }
};

SharedTextMarker.prototype.clear = function () {
    var this$1 = this;

  if (this.explicitlyCleared) { return }
  this.explicitlyCleared = true;
  for (var i = 0; i < this.markers.length; ++i)
    { this$1.markers[i].clear(); }
  signalLater(this, "clear");
};

SharedTextMarker.prototype.find = function (side, lineObj) {
  return this.primary.find(side, lineObj)
};
eventMixin(SharedTextMarker);

function markTextShared(doc, from, to, options, type) {
  options = copyObj(options);
  options.shared = false;
  var markers = [markText(doc, from, to, options, type)], primary = markers[0];
  var widget = options.widgetNode;
  linkedDocs(doc, function (doc) {
    if (widget) { options.widgetNode = widget.cloneNode(true); }
    markers.push(markText(doc, clipPos(doc, from), clipPos(doc, to), options, type));
    for (var i = 0; i < doc.linked.length; ++i)
      { if (doc.linked[i].isParent) { return } }
    primary = lst(markers);
  });
  return new SharedTextMarker(markers, primary)
}

function findSharedMarkers(doc) {
  return doc.findMarks(Pos(doc.first, 0), doc.clipPos(Pos(doc.lastLine())), function (m) { return m.parent; })
}

function copySharedMarkers(doc, markers) {
  for (var i = 0; i < markers.length; i++) {
    var marker = markers[i], pos = marker.find();
    var mFrom = doc.clipPos(pos.from), mTo = doc.clipPos(pos.to);
    if (cmp(mFrom, mTo)) {
      var subMark = markText(doc, mFrom, mTo, marker.primary, marker.primary.type);
      marker.markers.push(subMark);
      subMark.parent = marker;
    }
  }
}

function detachSharedMarkers(markers) {
  var loop = function ( i ) {
    var marker = markers[i], linked = [marker.primary.doc];
    linkedDocs(marker.primary.doc, function (d) { return linked.push(d); });
    for (var j = 0; j < marker.markers.length; j++) {
      var subMarker = marker.markers[j];
      if (indexOf(linked, subMarker.doc) == -1) {
        subMarker.parent = null;
        marker.markers.splice(j--, 1);
      }
    }
  };

  for (var i = 0; i < markers.length; i++) loop( i );
}

var nextDocId = 0;
var Doc = function(text, mode, firstLine, lineSep, direction) {
  if (!(this instanceof Doc)) { return new Doc(text, mode, firstLine, lineSep, direction) }
  if (firstLine == null) { firstLine = 0; }

  BranchChunk.call(this, [new LeafChunk([new Line("", null)])]);
  this.first = firstLine;
  this.scrollTop = this.scrollLeft = 0;
  this.cantEdit = false;
  this.cleanGeneration = 1;
  this.modeFrontier = this.highlightFrontier = firstLine;
  var start = Pos(firstLine, 0);
  this.sel = simpleSelection(start);
  this.history = new History(null);
  this.id = ++nextDocId;
  this.modeOption = mode;
  this.lineSep = lineSep;
  this.direction = (direction == "rtl") ? "rtl" : "ltr";
  this.extend = false;

  if (typeof text == "string") { text = this.splitLines(text); }
  updateDoc(this, {from: start, to: start, text: text});
  setSelection(this, simpleSelection(start), sel_dontScroll);
};

Doc.prototype = createObj(BranchChunk.prototype, {
  constructor: Doc,
  // Iterate over the document. Supports two forms -- with only one
  // argument, it calls that for each line in the document. With
  // three, it iterates over the range given by the first two (with
  // the second being non-inclusive).
  iter: function(from, to, op) {
    if (op) { this.iterN(from - this.first, to - from, op); }
    else { this.iterN(this.first, this.first + this.size, from); }
  },

  // Non-public interface for adding and removing lines.
  insert: function(at, lines) {
    var height = 0;
    for (var i = 0; i < lines.length; ++i) { height += lines[i].height; }
    this.insertInner(at - this.first, lines, height);
  },
  remove: function(at, n) { this.removeInner(at - this.first, n); },

  // From here, the methods are part of the public interface. Most
  // are also available from CodeMirror (editor) instances.

  getValue: function(lineSep) {
    var lines = getLines(this, this.first, this.first + this.size);
    if (lineSep === false) { return lines }
    return lines.join(lineSep || this.lineSeparator())
  },
  setValue: docMethodOp(function(code) {
    var top = Pos(this.first, 0), last = this.first + this.size - 1;
    makeChange(this, {from: top, to: Pos(last, getLine(this, last).text.length),
                      text: this.splitLines(code), origin: "setValue", full: true}, true);
    if (this.cm) { scrollToCoords(this.cm, 0, 0); }
    setSelection(this, simpleSelection(top), sel_dontScroll);
  }),
  replaceRange: function(code, from, to, origin) {
    from = clipPos(this, from);
    to = to ? clipPos(this, to) : from;
    replaceRange(this, code, from, to, origin);
  },
  getRange: function(from, to, lineSep) {
    var lines = getBetween(this, clipPos(this, from), clipPos(this, to));
    if (lineSep === false) { return lines }
    return lines.join(lineSep || this.lineSeparator())
  },

  getLine: function(line) {var l = this.getLineHandle(line); return l && l.text},

  getLineHandle: function(line) {if (isLine(this, line)) { return getLine(this, line) }},
  getLineNumber: function(line) {return lineNo(line)},

  getLineHandleVisualStart: function(line) {
    if (typeof line == "number") { line = getLine(this, line); }
    return visualLine(line)
  },

  lineCount: function() {return this.size},
  firstLine: function() {return this.first},
  lastLine: function() {return this.first + this.size - 1},

  clipPos: function(pos) {return clipPos(this, pos)},

  getCursor: function(start) {
    var range$$1 = this.sel.primary(), pos;
    if (start == null || start == "head") { pos = range$$1.head; }
    else if (start == "anchor") { pos = range$$1.anchor; }
    else if (start == "end" || start == "to" || start === false) { pos = range$$1.to(); }
    else { pos = range$$1.from(); }
    return pos
  },
  listSelections: function() { return this.sel.ranges },
  somethingSelected: function() {return this.sel.somethingSelected()},

  setCursor: docMethodOp(function(line, ch, options) {
    setSimpleSelection(this, clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options);
  }),
  setSelection: docMethodOp(function(anchor, head, options) {
    setSimpleSelection(this, clipPos(this, anchor), clipPos(this, head || anchor), options);
  }),
  extendSelection: docMethodOp(function(head, other, options) {
    extendSelection(this, clipPos(this, head), other && clipPos(this, other), options);
  }),
  extendSelections: docMethodOp(function(heads, options) {
    extendSelections(this, clipPosArray(this, heads), options);
  }),
  extendSelectionsBy: docMethodOp(function(f, options) {
    var heads = map(this.sel.ranges, f);
    extendSelections(this, clipPosArray(this, heads), options);
  }),
  setSelections: docMethodOp(function(ranges, primary, options) {
    var this$1 = this;

    if (!ranges.length) { return }
    var out = [];
    for (var i = 0; i < ranges.length; i++)
      { out[i] = new Range(clipPos(this$1, ranges[i].anchor),
                         clipPos(this$1, ranges[i].head)); }
    if (primary == null) { primary = Math.min(ranges.length - 1, this.sel.primIndex); }
    setSelection(this, normalizeSelection(out, primary), options);
  }),
  addSelection: docMethodOp(function(anchor, head, options) {
    var ranges = this.sel.ranges.slice(0);
    ranges.push(new Range(clipPos(this, anchor), clipPos(this, head || anchor)));
    setSelection(this, normalizeSelection(ranges, ranges.length - 1), options);
  }),

  getSelection: function(lineSep) {
    var this$1 = this;

    var ranges = this.sel.ranges, lines;
    for (var i = 0; i < ranges.length; i++) {
      var sel = getBetween(this$1, ranges[i].from(), ranges[i].to());
      lines = lines ? lines.concat(sel) : sel;
    }
    if (lineSep === false) { return lines }
    else { return lines.join(lineSep || this.lineSeparator()) }
  },
  getSelections: function(lineSep) {
    var this$1 = this;

    var parts = [], ranges = this.sel.ranges;
    for (var i = 0; i < ranges.length; i++) {
      var sel = getBetween(this$1, ranges[i].from(), ranges[i].to());
      if (lineSep !== false) { sel = sel.join(lineSep || this$1.lineSeparator()); }
      parts[i] = sel;
    }
    return parts
  },
  replaceSelection: function(code, collapse, origin) {
    var dup = [];
    for (var i = 0; i < this.sel.ranges.length; i++)
      { dup[i] = code; }
    this.replaceSelections(dup, collapse, origin || "+input");
  },
  replaceSelections: docMethodOp(function(code, collapse, origin) {
    var this$1 = this;

    var changes = [], sel = this.sel;
    for (var i = 0; i < sel.ranges.length; i++) {
      var range$$1 = sel.ranges[i];
      changes[i] = {from: range$$1.from(), to: range$$1.to(), text: this$1.splitLines(code[i]), origin: origin};
    }
    var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse);
    for (var i$1 = changes.length - 1; i$1 >= 0; i$1--)
      { makeChange(this$1, changes[i$1]); }
    if (newSel) { setSelectionReplaceHistory(this, newSel); }
    else if (this.cm) { ensureCursorVisible(this.cm); }
  }),
  undo: docMethodOp(function() {makeChangeFromHistory(this, "undo");}),
  redo: docMethodOp(function() {makeChangeFromHistory(this, "redo");}),
  undoSelection: docMethodOp(function() {makeChangeFromHistory(this, "undo", true);}),
  redoSelection: docMethodOp(function() {makeChangeFromHistory(this, "redo", true);}),

  setExtending: function(val) {this.extend = val;},
  getExtending: function() {return this.extend},

  historySize: function() {
    var hist = this.history, done = 0, undone = 0;
    for (var i = 0; i < hist.done.length; i++) { if (!hist.done[i].ranges) { ++done; } }
    for (var i$1 = 0; i$1 < hist.undone.length; i$1++) { if (!hist.undone[i$1].ranges) { ++undone; } }
    return {undo: done, redo: undone}
  },
  clearHistory: function() {this.history = new History(this.history.maxGeneration);},

  markClean: function() {
    this.cleanGeneration = this.changeGeneration(true);
  },
  changeGeneration: function(forceSplit) {
    if (forceSplit)
      { this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null; }
    return this.history.generation
  },
  isClean: function (gen) {
    return this.history.generation == (gen || this.cleanGeneration)
  },

  getHistory: function() {
    return {done: copyHistoryArray(this.history.done),
            undone: copyHistoryArray(this.history.undone)}
  },
  setHistory: function(histData) {
    var hist = this.history = new History(this.history.maxGeneration);
    hist.done = copyHistoryArray(histData.done.slice(0), null, true);
    hist.undone = copyHistoryArray(histData.undone.slice(0), null, true);
  },

  setGutterMarker: docMethodOp(function(line, gutterID, value) {
    return changeLine(this, line, "gutter", function (line) {
      var markers = line.gutterMarkers || (line.gutterMarkers = {});
      markers[gutterID] = value;
      if (!value && isEmpty(markers)) { line.gutterMarkers = null; }
      return true
    })
  }),

  clearGutter: docMethodOp(function(gutterID) {
    var this$1 = this;

    this.iter(function (line) {
      if (line.gutterMarkers && line.gutterMarkers[gutterID]) {
        changeLine(this$1, line, "gutter", function () {
          line.gutterMarkers[gutterID] = null;
          if (isEmpty(line.gutterMarkers)) { line.gutterMarkers = null; }
          return true
        });
      }
    });
  }),

  lineInfo: function(line) {
    var n;
    if (typeof line == "number") {
      if (!isLine(this, line)) { return null }
      n = line;
      line = getLine(this, line);
      if (!line) { return null }
    } else {
      n = lineNo(line);
      if (n == null) { return null }
    }
    return {line: n, handle: line, text: line.text, gutterMarkers: line.gutterMarkers,
            textClass: line.textClass, bgClass: line.bgClass, wrapClass: line.wrapClass,
            widgets: line.widgets}
  },

  addLineClass: docMethodOp(function(handle, where, cls) {
    return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
      var prop = where == "text" ? "textClass"
               : where == "background" ? "bgClass"
               : where == "gutter" ? "gutterClass" : "wrapClass";
      if (!line[prop]) { line[prop] = cls; }
      else if (classTest(cls).test(line[prop])) { return false }
      else { line[prop] += " " + cls; }
      return true
    })
  }),
  removeLineClass: docMethodOp(function(handle, where, cls) {
    return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
      var prop = where == "text" ? "textClass"
               : where == "background" ? "bgClass"
               : where == "gutter" ? "gutterClass" : "wrapClass";
      var cur = line[prop];
      if (!cur) { return false }
      else if (cls == null) { line[prop] = null; }
      else {
        var found = cur.match(classTest(cls));
        if (!found) { return false }
        var end = found.index + found[0].length;
        line[prop] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null;
      }
      return true
    })
  }),

  addLineWidget: docMethodOp(function(handle, node, options) {
    return addLineWidget(this, handle, node, options)
  }),
  removeLineWidget: function(widget) { widget.clear(); },

  markText: function(from, to, options) {
    return markText(this, clipPos(this, from), clipPos(this, to), options, options && options.type || "range")
  },
  setBookmark: function(pos, options) {
    var realOpts = {replacedWith: options && (options.nodeType == null ? options.widget : options),
                    insertLeft: options && options.insertLeft,
                    clearWhenEmpty: false, shared: options && options.shared,
                    handleMouseEvents: options && options.handleMouseEvents};
    pos = clipPos(this, pos);
    return markText(this, pos, pos, realOpts, "bookmark")
  },
  findMarksAt: function(pos) {
    pos = clipPos(this, pos);
    var markers = [], spans = getLine(this, pos.line).markedSpans;
    if (spans) { for (var i = 0; i < spans.length; ++i) {
      var span = spans[i];
      if ((span.from == null || span.from <= pos.ch) &&
          (span.to == null || span.to >= pos.ch))
        { markers.push(span.marker.parent || span.marker); }
    } }
    return markers
  },
  findMarks: function(from, to, filter) {
    from = clipPos(this, from); to = clipPos(this, to);
    var found = [], lineNo$$1 = from.line;
    this.iter(from.line, to.line + 1, function (line) {
      var spans = line.markedSpans;
      if (spans) { for (var i = 0; i < spans.length; i++) {
        var span = spans[i];
        if (!(span.to != null && lineNo$$1 == from.line && from.ch >= span.to ||
              span.from == null && lineNo$$1 != from.line ||
              span.from != null && lineNo$$1 == to.line && span.from >= to.ch) &&
            (!filter || filter(span.marker)))
          { found.push(span.marker.parent || span.marker); }
      } }
      ++lineNo$$1;
    });
    return found
  },
  getAllMarks: function() {
    var markers = [];
    this.iter(function (line) {
      var sps = line.markedSpans;
      if (sps) { for (var i = 0; i < sps.length; ++i)
        { if (sps[i].from != null) { markers.push(sps[i].marker); } } }
    });
    return markers
  },

  posFromIndex: function(off) {
    var ch, lineNo$$1 = this.first, sepSize = this.lineSeparator().length;
    this.iter(function (line) {
      var sz = line.text.length + sepSize;
      if (sz > off) { ch = off; return true }
      off -= sz;
      ++lineNo$$1;
    });
    return clipPos(this, Pos(lineNo$$1, ch))
  },
  indexFromPos: function (coords) {
    coords = clipPos(this, coords);
    var index = coords.ch;
    if (coords.line < this.first || coords.ch < 0) { return 0 }
    var sepSize = this.lineSeparator().length;
    this.iter(this.first, coords.line, function (line) { // iter aborts when callback returns a truthy value
      index += line.text.length + sepSize;
    });
    return index
  },

  copy: function(copyHistory) {
    var doc = new Doc(getLines(this, this.first, this.first + this.size),
                      this.modeOption, this.first, this.lineSep, this.direction);
    doc.scrollTop = this.scrollTop; doc.scrollLeft = this.scrollLeft;
    doc.sel = this.sel;
    doc.extend = false;
    if (copyHistory) {
      doc.history.undoDepth = this.history.undoDepth;
      doc.setHistory(this.getHistory());
    }
    return doc
  },

  linkedDoc: function(options) {
    if (!options) { options = {}; }
    var from = this.first, to = this.first + this.size;
    if (options.from != null && options.from > from) { from = options.from; }
    if (options.to != null && options.to < to) { to = options.to; }
    var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep, this.direction);
    if (options.sharedHist) { copy.history = this.history
    ; }(this.linked || (this.linked = [])).push({doc: copy, sharedHist: options.sharedHist});
    copy.linked = [{doc: this, isParent: true, sharedHist: options.sharedHist}];
    copySharedMarkers(copy, findSharedMarkers(this));
    return copy
  },
  unlinkDoc: function(other) {
    var this$1 = this;

    if (other instanceof CodeMirror$1) { other = other.doc; }
    if (this.linked) { for (var i = 0; i < this.linked.length; ++i) {
      var link = this$1.linked[i];
      if (link.doc != other) { continue }
      this$1.linked.splice(i, 1);
      other.unlinkDoc(this$1);
      detachSharedMarkers(findSharedMarkers(this$1));
      break
    } }
    // If the histories were shared, split them again
    if (other.history == this.history) {
      var splitIds = [other.id];
      linkedDocs(other, function (doc) { return splitIds.push(doc.id); }, true);
      other.history = new History(null);
      other.history.done = copyHistoryArray(this.history.done, splitIds);
      other.history.undone = copyHistoryArray(this.history.undone, splitIds);
    }
  },
  iterLinkedDocs: function(f) {linkedDocs(this, f);},

  getMode: function() {return this.mode},
  getEditor: function() {return this.cm},

  splitLines: function(str) {
    if (this.lineSep) { return str.split(this.lineSep) }
    return splitLinesAuto(str)
  },
  lineSeparator: function() { return this.lineSep || "\n" },

  setDirection: docMethodOp(function (dir) {
    if (dir != "rtl") { dir = "ltr"; }
    if (dir == this.direction) { return }
    this.direction = dir;
    this.iter(function (line) { return line.order = null; });
    if (this.cm) { directionChanged(this.cm); }
  })
});

// Public alias.
Doc.prototype.eachLine = Doc.prototype.iter;

// Kludge to work around strange IE behavior where it'll sometimes
// re-fire a series of drag-related events right after the drop (#1551)
var lastDrop = 0;

function onDrop(e) {
  var cm = this;
  clearDragCursor(cm);
  if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e))
    { return }
  e_preventDefault(e);
  if (ie) { lastDrop = +new Date; }
  var pos = posFromMouse(cm, e, true), files = e.dataTransfer.files;
  if (!pos || cm.isReadOnly()) { return }
  // Might be a file drop, in which case we simply extract the text
  // and insert it.
  if (files && files.length && window.FileReader && window.File) {
    var n = files.length, text = Array(n), read = 0;
    var loadFile = function (file, i) {
      if (cm.options.allowDropFileTypes &&
          indexOf(cm.options.allowDropFileTypes, file.type) == -1)
        { return }

      var reader = new FileReader;
      reader.onload = operation(cm, function () {
        var content = reader.result;
        if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) { content = ""; }
        text[i] = content;
        if (++read == n) {
          pos = clipPos(cm.doc, pos);
          var change = {from: pos, to: pos,
                        text: cm.doc.splitLines(text.join(cm.doc.lineSeparator())),
                        origin: "paste"};
          makeChange(cm.doc, change);
          setSelectionReplaceHistory(cm.doc, simpleSelection(pos, changeEnd(change)));
        }
      });
      reader.readAsText(file);
    };
    for (var i = 0; i < n; ++i) { loadFile(files[i], i); }
  } else { // Normal drop
    // Don't do a replace if the drop happened inside of the selected text.
    if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
      cm.state.draggingText(e);
      // Ensure the editor is re-focused
      setTimeout(function () { return cm.display.input.focus(); }, 20);
      return
    }
    try {
      var text$1 = e.dataTransfer.getData("Text");
      if (text$1) {
        var selected;
        if (cm.state.draggingText && !cm.state.draggingText.copy)
          { selected = cm.listSelections(); }
        setSelectionNoUndo(cm.doc, simpleSelection(pos, pos));
        if (selected) { for (var i$1 = 0; i$1 < selected.length; ++i$1)
          { replaceRange(cm.doc, "", selected[i$1].anchor, selected[i$1].head, "drag"); } }
        cm.replaceSelection(text$1, "around", "paste");
        cm.display.input.focus();
      }
    }
    catch(e){}
  }
}

function onDragStart(cm, e) {
  if (ie && (!cm.state.draggingText || +new Date - lastDrop < 100)) { e_stop(e); return }
  if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) { return }

  e.dataTransfer.setData("Text", cm.getSelection());
  e.dataTransfer.effectAllowed = "copyMove";

  // Use dummy image instead of default browsers image.
  // Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
  if (e.dataTransfer.setDragImage && !safari) {
    var img = elt("img", null, null, "position: fixed; left: 0; top: 0;");
    img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
    if (presto) {
      img.width = img.height = 1;
      cm.display.wrapper.appendChild(img);
      // Force a relayout, or Opera won't use our image for some obscure reason
      img._top = img.offsetTop;
    }
    e.dataTransfer.setDragImage(img, 0, 0);
    if (presto) { img.parentNode.removeChild(img); }
  }
}

function onDragOver(cm, e) {
  var pos = posFromMouse(cm, e);
  if (!pos) { return }
  var frag = document.createDocumentFragment();
  drawSelectionCursor(cm, pos, frag);
  if (!cm.display.dragCursor) {
    cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors");
    cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv);
  }
  removeChildrenAndAdd(cm.display.dragCursor, frag);
}

function clearDragCursor(cm) {
  if (cm.display.dragCursor) {
    cm.display.lineSpace.removeChild(cm.display.dragCursor);
    cm.display.dragCursor = null;
  }
}

// These must be handled carefully, because naively registering a
// handler for each editor will cause the editors to never be
// garbage collected.

function forEachCodeMirror(f) {
  if (!document.getElementsByClassName) { return }
  var byClass = document.getElementsByClassName("CodeMirror");
  for (var i = 0; i < byClass.length; i++) {
    var cm = byClass[i].CodeMirror;
    if (cm) { f(cm); }
  }
}

var globalsRegistered = false;
function ensureGlobalHandlers() {
  if (globalsRegistered) { return }
  registerGlobalHandlers();
  globalsRegistered = true;
}
function registerGlobalHandlers() {
  // When the window resizes, we need to refresh active editors.
  var resizeTimer;
  on(window, "resize", function () {
    if (resizeTimer == null) { resizeTimer = setTimeout(function () {
      resizeTimer = null;
      forEachCodeMirror(onResize);
    }, 100); }
  });
  // When the window loses focus, we want to show the editor as blurred
  on(window, "blur", function () { return forEachCodeMirror(onBlur); });
}
// Called when the window resizes
function onResize(cm) {
  var d = cm.display;
  if (d.lastWrapHeight == d.wrapper.clientHeight && d.lastWrapWidth == d.wrapper.clientWidth)
    { return }
  // Might be a text scaling operation, clear size caches.
  d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
  d.scrollbarsClipped = false;
  cm.setSize();
}

var keyNames = {
  3: "Pause", 8: "Backspace", 9: "Tab", 13: "Enter", 16: "Shift", 17: "Ctrl", 18: "Alt",
  19: "Pause", 20: "CapsLock", 27: "Esc", 32: "Space", 33: "PageUp", 34: "PageDown", 35: "End",
  36: "Home", 37: "Left", 38: "Up", 39: "Right", 40: "Down", 44: "PrintScrn", 45: "Insert",
  46: "Delete", 59: ";", 61: "=", 91: "Mod", 92: "Mod", 93: "Mod",
  106: "*", 107: "=", 109: "-", 110: ".", 111: "/", 127: "Delete", 145: "ScrollLock",
  173: "-", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\",
  221: "]", 222: "'", 63232: "Up", 63233: "Down", 63234: "Left", 63235: "Right", 63272: "Delete",
  63273: "Home", 63275: "End", 63276: "PageUp", 63277: "PageDown", 63302: "Insert"
};

// Number keys
for (var i = 0; i < 10; i++) { keyNames[i + 48] = keyNames[i + 96] = String(i); }
// Alphabetic keys
for (var i$1 = 65; i$1 <= 90; i$1++) { keyNames[i$1] = String.fromCharCode(i$1); }
// Function keys
for (var i$2 = 1; i$2 <= 12; i$2++) { keyNames[i$2 + 111] = keyNames[i$2 + 63235] = "F" + i$2; }

var keyMap = {};

keyMap.basic = {
  "Left": "goCharLeft", "Right": "goCharRight", "Up": "goLineUp", "Down": "goLineDown",
  "End": "goLineEnd", "Home": "goLineStartSmart", "PageUp": "goPageUp", "PageDown": "goPageDown",
  "Delete": "delCharAfter", "Backspace": "delCharBefore", "Shift-Backspace": "delCharBefore",
  "Tab": "defaultTab", "Shift-Tab": "indentAuto",
  "Enter": "newlineAndIndent", "Insert": "toggleOverwrite",
  "Esc": "singleSelection"
};
// Note that the save and find-related commands aren't defined by
// default. User code or addons can define them. Unknown commands
// are simply ignored.
keyMap.pcDefault = {
  "Ctrl-A": "selectAll", "Ctrl-D": "deleteLine", "Ctrl-Z": "undo", "Shift-Ctrl-Z": "redo", "Ctrl-Y": "redo",
  "Ctrl-Home": "goDocStart", "Ctrl-End": "goDocEnd", "Ctrl-Up": "goLineUp", "Ctrl-Down": "goLineDown",
  "Ctrl-Left": "goGroupLeft", "Ctrl-Right": "goGroupRight", "Alt-Left": "goLineStart", "Alt-Right": "goLineEnd",
  "Ctrl-Backspace": "delGroupBefore", "Ctrl-Delete": "delGroupAfter", "Ctrl-S": "save", "Ctrl-F": "find",
  "Ctrl-G": "findNext", "Shift-Ctrl-G": "findPrev", "Shift-Ctrl-F": "replace", "Shift-Ctrl-R": "replaceAll",
  "Ctrl-[": "indentLess", "Ctrl-]": "indentMore",
  "Ctrl-U": "undoSelection", "Shift-Ctrl-U": "redoSelection", "Alt-U": "redoSelection",
  fallthrough: "basic"
};
// Very basic readline/emacs-style bindings, which are standard on Mac.
keyMap.emacsy = {
  "Ctrl-F": "goCharRight", "Ctrl-B": "goCharLeft", "Ctrl-P": "goLineUp", "Ctrl-N": "goLineDown",
  "Alt-F": "goWordRight", "Alt-B": "goWordLeft", "Ctrl-A": "goLineStart", "Ctrl-E": "goLineEnd",
  "Ctrl-V": "goPageDown", "Shift-Ctrl-V": "goPageUp", "Ctrl-D": "delCharAfter", "Ctrl-H": "delCharBefore",
  "Alt-D": "delWordAfter", "Alt-Backspace": "delWordBefore", "Ctrl-K": "killLine", "Ctrl-T": "transposeChars",
  "Ctrl-O": "openLine"
};
keyMap.macDefault = {
  "Cmd-A": "selectAll", "Cmd-D": "deleteLine", "Cmd-Z": "undo", "Shift-Cmd-Z": "redo", "Cmd-Y": "redo",
  "Cmd-Home": "goDocStart", "Cmd-Up": "goDocStart", "Cmd-End": "goDocEnd", "Cmd-Down": "goDocEnd", "Alt-Left": "goGroupLeft",
  "Alt-Right": "goGroupRight", "Cmd-Left": "goLineLeft", "Cmd-Right": "goLineRight", "Alt-Backspace": "delGroupBefore",
  "Ctrl-Alt-Backspace": "delGroupAfter", "Alt-Delete": "delGroupAfter", "Cmd-S": "save", "Cmd-F": "find",
  "Cmd-G": "findNext", "Shift-Cmd-G": "findPrev", "Cmd-Alt-F": "replace", "Shift-Cmd-Alt-F": "replaceAll",
  "Cmd-[": "indentLess", "Cmd-]": "indentMore", "Cmd-Backspace": "delWrappedLineLeft", "Cmd-Delete": "delWrappedLineRight",
  "Cmd-U": "undoSelection", "Shift-Cmd-U": "redoSelection", "Ctrl-Up": "goDocStart", "Ctrl-Down": "goDocEnd",
  fallthrough: ["basic", "emacsy"]
};
keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault;

// KEYMAP DISPATCH

function normalizeKeyName(name) {
  var parts = name.split(/-(?!$)/);
  name = parts[parts.length - 1];
  var alt, ctrl, shift, cmd;
  for (var i = 0; i < parts.length - 1; i++) {
    var mod = parts[i];
    if (/^(cmd|meta|m)$/i.test(mod)) { cmd = true; }
    else if (/^a(lt)?$/i.test(mod)) { alt = true; }
    else if (/^(c|ctrl|control)$/i.test(mod)) { ctrl = true; }
    else if (/^s(hift)?$/i.test(mod)) { shift = true; }
    else { throw new Error("Unrecognized modifier name: " + mod) }
  }
  if (alt) { name = "Alt-" + name; }
  if (ctrl) { name = "Ctrl-" + name; }
  if (cmd) { name = "Cmd-" + name; }
  if (shift) { name = "Shift-" + name; }
  return name
}

// This is a kludge to keep keymaps mostly working as raw objects
// (backwards compatibility) while at the same time support features
// like normalization and multi-stroke key bindings. It compiles a
// new normalized keymap, and then updates the old object to reflect
// this.
function normalizeKeyMap(keymap) {
  var copy = {};
  for (var keyname in keymap) { if (keymap.hasOwnProperty(keyname)) {
    var value = keymap[keyname];
    if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) { continue }
    if (value == "...") { delete keymap[keyname]; continue }

    var keys = map(keyname.split(" "), normalizeKeyName);
    for (var i = 0; i < keys.length; i++) {
      var val = (void 0), name = (void 0);
      if (i == keys.length - 1) {
        name = keys.join(" ");
        val = value;
      } else {
        name = keys.slice(0, i + 1).join(" ");
        val = "...";
      }
      var prev = copy[name];
      if (!prev) { copy[name] = val; }
      else if (prev != val) { throw new Error("Inconsistent bindings for " + name) }
    }
    delete keymap[keyname];
  } }
  for (var prop in copy) { keymap[prop] = copy[prop]; }
  return keymap
}

function lookupKey(key, map$$1, handle, context) {
  map$$1 = getKeyMap(map$$1);
  var found = map$$1.call ? map$$1.call(key, context) : map$$1[key];
  if (found === false) { return "nothing" }
  if (found === "...") { return "multi" }
  if (found != null && handle(found)) { return "handled" }

  if (map$$1.fallthrough) {
    if (Object.prototype.toString.call(map$$1.fallthrough) != "[object Array]")
      { return lookupKey(key, map$$1.fallthrough, handle, context) }
    for (var i = 0; i < map$$1.fallthrough.length; i++) {
      var result = lookupKey(key, map$$1.fallthrough[i], handle, context);
      if (result) { return result }
    }
  }
}

// Modifier key presses don't count as 'real' key presses for the
// purpose of keymap fallthrough.
function isModifierKey(value) {
  var name = typeof value == "string" ? value : keyNames[value.keyCode];
  return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod"
}

function addModifierNames(name, event, noShift) {
  var base = name;
  if (event.altKey && base != "Alt") { name = "Alt-" + name; }
  if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") { name = "Ctrl-" + name; }
  if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Cmd") { name = "Cmd-" + name; }
  if (!noShift && event.shiftKey && base != "Shift") { name = "Shift-" + name; }
  return name
}

// Look up the name of a key as indicated by an event object.
function keyName(event, noShift) {
  if (presto && event.keyCode == 34 && event["char"]) { return false }
  var name = keyNames[event.keyCode];
  if (name == null || event.altGraphKey) { return false }
  // Ctrl-ScrollLock has keyCode 3, same as Ctrl-Pause,
  // so we'll use event.code when available (Chrome 48+, FF 38+, Safari 10.1+)
  if (event.keyCode == 3 && event.code) { name = event.code; }
  return addModifierNames(name, event, noShift)
}

function getKeyMap(val) {
  return typeof val == "string" ? keyMap[val] : val
}

// Helper for deleting text near the selection(s), used to implement
// backspace, delete, and similar functionality.
function deleteNearSelection(cm, compute) {
  var ranges = cm.doc.sel.ranges, kill = [];
  // Build up a set of ranges to kill first, merging overlapping
  // ranges.
  for (var i = 0; i < ranges.length; i++) {
    var toKill = compute(ranges[i]);
    while (kill.length && cmp(toKill.from, lst(kill).to) <= 0) {
      var replaced = kill.pop();
      if (cmp(replaced.from, toKill.from) < 0) {
        toKill.from = replaced.from;
        break
      }
    }
    kill.push(toKill);
  }
  // Next, remove those actual ranges.
  runInOp(cm, function () {
    for (var i = kill.length - 1; i >= 0; i--)
      { replaceRange(cm.doc, "", kill[i].from, kill[i].to, "+delete"); }
    ensureCursorVisible(cm);
  });
}

function moveCharLogically(line, ch, dir) {
  var target = skipExtendingChars(line.text, ch + dir, dir);
  return target < 0 || target > line.text.length ? null : target
}

function moveLogically(line, start, dir) {
  var ch = moveCharLogically(line, start.ch, dir);
  return ch == null ? null : new Pos(start.line, ch, dir < 0 ? "after" : "before")
}

function endOfLine(visually, cm, lineObj, lineNo, dir) {
  if (visually) {
    var order = getOrder(lineObj, cm.doc.direction);
    if (order) {
      var part = dir < 0 ? lst(order) : order[0];
      var moveInStorageOrder = (dir < 0) == (part.level == 1);
      var sticky = moveInStorageOrder ? "after" : "before";
      var ch;
      // With a wrapped rtl chunk (possibly spanning multiple bidi parts),
      // it could be that the last bidi part is not on the last visual line,
      // since visual lines contain content order-consecutive chunks.
      // Thus, in rtl, we are looking for the first (content-order) character
      // in the rtl chunk that is on the last line (that is, the same line
      // as the last (content-order) character).
      if (part.level > 0 || cm.doc.direction == "rtl") {
        var prep = prepareMeasureForLine(cm, lineObj);
        ch = dir < 0 ? lineObj.text.length - 1 : 0;
        var targetTop = measureCharPrepared(cm, prep, ch).top;
        ch = findFirst(function (ch) { return measureCharPrepared(cm, prep, ch).top == targetTop; }, (dir < 0) == (part.level == 1) ? part.from : part.to - 1, ch);
        if (sticky == "before") { ch = moveCharLogically(lineObj, ch, 1); }
      } else { ch = dir < 0 ? part.to : part.from; }
      return new Pos(lineNo, ch, sticky)
    }
  }
  return new Pos(lineNo, dir < 0 ? lineObj.text.length : 0, dir < 0 ? "before" : "after")
}

function moveVisually(cm, line, start, dir) {
  var bidi = getOrder(line, cm.doc.direction);
  if (!bidi) { return moveLogically(line, start, dir) }
  if (start.ch >= line.text.length) {
    start.ch = line.text.length;
    start.sticky = "before";
  } else if (start.ch <= 0) {
    start.ch = 0;
    start.sticky = "after";
  }
  var partPos = getBidiPartAt(bidi, start.ch, start.sticky), part = bidi[partPos];
  if (cm.doc.direction == "ltr" && part.level % 2 == 0 && (dir > 0 ? part.to > start.ch : part.from < start.ch)) {
    // Case 1: We move within an ltr part in an ltr editor. Even with wrapped lines,
    // nothing interesting happens.
    return moveLogically(line, start, dir)
  }

  var mv = function (pos, dir) { return moveCharLogically(line, pos instanceof Pos ? pos.ch : pos, dir); };
  var prep;
  var getWrappedLineExtent = function (ch) {
    if (!cm.options.lineWrapping) { return {begin: 0, end: line.text.length} }
    prep = prep || prepareMeasureForLine(cm, line);
    return wrappedLineExtentChar(cm, line, prep, ch)
  };
  var wrappedLineExtent = getWrappedLineExtent(start.sticky == "before" ? mv(start, -1) : start.ch);

  if (cm.doc.direction == "rtl" || part.level == 1) {
    var moveInStorageOrder = (part.level == 1) == (dir < 0);
    var ch = mv(start, moveInStorageOrder ? 1 : -1);
    if (ch != null && (!moveInStorageOrder ? ch >= part.from && ch >= wrappedLineExtent.begin : ch <= part.to && ch <= wrappedLineExtent.end)) {
      // Case 2: We move within an rtl part or in an rtl editor on the same visual line
      var sticky = moveInStorageOrder ? "before" : "after";
      return new Pos(start.line, ch, sticky)
    }
  }

  // Case 3: Could not move within this bidi part in this visual line, so leave
  // the current bidi part

  var searchInVisualLine = function (partPos, dir, wrappedLineExtent) {
    var getRes = function (ch, moveInStorageOrder) { return moveInStorageOrder
      ? new Pos(start.line, mv(ch, 1), "before")
      : new Pos(start.line, ch, "after"); };

    for (; partPos >= 0 && partPos < bidi.length; partPos += dir) {
      var part = bidi[partPos];
      var moveInStorageOrder = (dir > 0) == (part.level != 1);
      var ch = moveInStorageOrder ? wrappedLineExtent.begin : mv(wrappedLineExtent.end, -1);
      if (part.from <= ch && ch < part.to) { return getRes(ch, moveInStorageOrder) }
      ch = moveInStorageOrder ? part.from : mv(part.to, -1);
      if (wrappedLineExtent.begin <= ch && ch < wrappedLineExtent.end) { return getRes(ch, moveInStorageOrder) }
    }
  };

  // Case 3a: Look for other bidi parts on the same visual line
  var res = searchInVisualLine(partPos + dir, dir, wrappedLineExtent);
  if (res) { return res }

  // Case 3b: Look for other bidi parts on the next visual line
  var nextCh = dir > 0 ? wrappedLineExtent.end : mv(wrappedLineExtent.begin, -1);
  if (nextCh != null && !(dir > 0 && nextCh == line.text.length)) {
    res = searchInVisualLine(dir > 0 ? 0 : bidi.length - 1, dir, getWrappedLineExtent(nextCh));
    if (res) { return res }
  }

  // Case 4: Nowhere to move
  return null
}

// Commands are parameter-less actions that can be performed on an
// editor, mostly used for keybindings.
var commands = {
  selectAll: selectAll,
  singleSelection: function (cm) { return cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll); },
  killLine: function (cm) { return deleteNearSelection(cm, function (range) {
    if (range.empty()) {
      var len = getLine(cm.doc, range.head.line).text.length;
      if (range.head.ch == len && range.head.line < cm.lastLine())
        { return {from: range.head, to: Pos(range.head.line + 1, 0)} }
      else
        { return {from: range.head, to: Pos(range.head.line, len)} }
    } else {
      return {from: range.from(), to: range.to()}
    }
  }); },
  deleteLine: function (cm) { return deleteNearSelection(cm, function (range) { return ({
    from: Pos(range.from().line, 0),
    to: clipPos(cm.doc, Pos(range.to().line + 1, 0))
  }); }); },
  delLineLeft: function (cm) { return deleteNearSelection(cm, function (range) { return ({
    from: Pos(range.from().line, 0), to: range.from()
  }); }); },
  delWrappedLineLeft: function (cm) { return deleteNearSelection(cm, function (range) {
    var top = cm.charCoords(range.head, "div").top + 5;
    var leftPos = cm.coordsChar({left: 0, top: top}, "div");
    return {from: leftPos, to: range.from()}
  }); },
  delWrappedLineRight: function (cm) { return deleteNearSelection(cm, function (range) {
    var top = cm.charCoords(range.head, "div").top + 5;
    var rightPos = cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div");
    return {from: range.from(), to: rightPos }
  }); },
  undo: function (cm) { return cm.undo(); },
  redo: function (cm) { return cm.redo(); },
  undoSelection: function (cm) { return cm.undoSelection(); },
  redoSelection: function (cm) { return cm.redoSelection(); },
  goDocStart: function (cm) { return cm.extendSelection(Pos(cm.firstLine(), 0)); },
  goDocEnd: function (cm) { return cm.extendSelection(Pos(cm.lastLine())); },
  goLineStart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStart(cm, range.head.line); },
    {origin: "+move", bias: 1}
  ); },
  goLineStartSmart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStartSmart(cm, range.head); },
    {origin: "+move", bias: 1}
  ); },
  goLineEnd: function (cm) { return cm.extendSelectionsBy(function (range) { return lineEnd(cm, range.head.line); },
    {origin: "+move", bias: -1}
  ); },
  goLineRight: function (cm) { return cm.extendSelectionsBy(function (range) {
    var top = cm.cursorCoords(range.head, "div").top + 5;
    return cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div")
  }, sel_move); },
  goLineLeft: function (cm) { return cm.extendSelectionsBy(function (range) {
    var top = cm.cursorCoords(range.head, "div").top + 5;
    return cm.coordsChar({left: 0, top: top}, "div")
  }, sel_move); },
  goLineLeftSmart: function (cm) { return cm.extendSelectionsBy(function (range) {
    var top = cm.cursorCoords(range.head, "div").top + 5;
    var pos = cm.coordsChar({left: 0, top: top}, "div");
    if (pos.ch < cm.getLine(pos.line).search(/\S/)) { return lineStartSmart(cm, range.head) }
    return pos
  }, sel_move); },
  goLineUp: function (cm) { return cm.moveV(-1, "line"); },
  goLineDown: function (cm) { return cm.moveV(1, "line"); },
  goPageUp: function (cm) { return cm.moveV(-1, "page"); },
  goPageDown: function (cm) { return cm.moveV(1, "page"); },
  goCharLeft: function (cm) { return cm.moveH(-1, "char"); },
  goCharRight: function (cm) { return cm.moveH(1, "char"); },
  goColumnLeft: function (cm) { return cm.moveH(-1, "column"); },
  goColumnRight: function (cm) { return cm.moveH(1, "column"); },
  goWordLeft: function (cm) { return cm.moveH(-1, "word"); },
  goGroupRight: function (cm) { return cm.moveH(1, "group"); },
  goGroupLeft: function (cm) { return cm.moveH(-1, "group"); },
  goWordRight: function (cm) { return cm.moveH(1, "word"); },
  delCharBefore: function (cm) { return cm.deleteH(-1, "char"); },
  delCharAfter: function (cm) { return cm.deleteH(1, "char"); },
  delWordBefore: function (cm) { return cm.deleteH(-1, "word"); },
  delWordAfter: function (cm) { return cm.deleteH(1, "word"); },
  delGroupBefore: function (cm) { return cm.deleteH(-1, "group"); },
  delGroupAfter: function (cm) { return cm.deleteH(1, "group"); },
  indentAuto: function (cm) { return cm.indentSelection("smart"); },
  indentMore: function (cm) { return cm.indentSelection("add"); },
  indentLess: function (cm) { return cm.indentSelection("subtract"); },
  insertTab: function (cm) { return cm.replaceSelection("\t"); },
  insertSoftTab: function (cm) {
    var spaces = [], ranges = cm.listSelections(), tabSize = cm.options.tabSize;
    for (var i = 0; i < ranges.length; i++) {
      var pos = ranges[i].from();
      var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize);
      spaces.push(spaceStr(tabSize - col % tabSize));
    }
    cm.replaceSelections(spaces);
  },
  defaultTab: function (cm) {
    if (cm.somethingSelected()) { cm.indentSelection("add"); }
    else { cm.execCommand("insertTab"); }
  },
  // Swap the two chars left and right of each selection's head.
  // Move cursor behind the two swapped characters afterwards.
  //
  // Doesn't consider line feeds a character.
  // Doesn't scan more than one line above to find a character.
  // Doesn't do anything on an empty line.
  // Doesn't do anything with non-empty selections.
  transposeChars: function (cm) { return runInOp(cm, function () {
    var ranges = cm.listSelections(), newSel = [];
    for (var i = 0; i < ranges.length; i++) {
      if (!ranges[i].empty()) { continue }
      var cur = ranges[i].head, line = getLine(cm.doc, cur.line).text;
      if (line) {
        if (cur.ch == line.length) { cur = new Pos(cur.line, cur.ch - 1); }
        if (cur.ch > 0) {
          cur = new Pos(cur.line, cur.ch + 1);
          cm.replaceRange(line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2),
                          Pos(cur.line, cur.ch - 2), cur, "+transpose");
        } else if (cur.line > cm.doc.first) {
          var prev = getLine(cm.doc, cur.line - 1).text;
          if (prev) {
            cur = new Pos(cur.line, 1);
            cm.replaceRange(line.charAt(0) + cm.doc.lineSeparator() +
                            prev.charAt(prev.length - 1),
                            Pos(cur.line - 1, prev.length - 1), cur, "+transpose");
          }
        }
      }
      newSel.push(new Range(cur, cur));
    }
    cm.setSelections(newSel);
  }); },
  newlineAndIndent: function (cm) { return runInOp(cm, function () {
    var sels = cm.listSelections();
    for (var i = sels.length - 1; i >= 0; i--)
      { cm.replaceRange(cm.doc.lineSeparator(), sels[i].anchor, sels[i].head, "+input"); }
    sels = cm.listSelections();
    for (var i$1 = 0; i$1 < sels.length; i$1++)
      { cm.indentLine(sels[i$1].from().line, null, true); }
    ensureCursorVisible(cm);
  }); },
  openLine: function (cm) { return cm.replaceSelection("\n", "start"); },
  toggleOverwrite: function (cm) { return cm.toggleOverwrite(); }
};


function lineStart(cm, lineN) {
  var line = getLine(cm.doc, lineN);
  var visual = visualLine(line);
  if (visual != line) { lineN = lineNo(visual); }
  return endOfLine(true, cm, visual, lineN, 1)
}
function lineEnd(cm, lineN) {
  var line = getLine(cm.doc, lineN);
  var visual = visualLineEnd(line);
  if (visual != line) { lineN = lineNo(visual); }
  return endOfLine(true, cm, line, lineN, -1)
}
function lineStartSmart(cm, pos) {
  var start = lineStart(cm, pos.line);
  var line = getLine(cm.doc, start.line);
  var order = getOrder(line, cm.doc.direction);
  if (!order || order[0].level == 0) {
    var firstNonWS = Math.max(0, line.text.search(/\S/));
    var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch;
    return Pos(start.line, inWS ? 0 : firstNonWS, start.sticky)
  }
  return start
}

// Run a handler that was bound to a key.
function doHandleBinding(cm, bound, dropShift) {
  if (typeof bound == "string") {
    bound = commands[bound];
    if (!bound) { return false }
  }
  // Ensure previous input has been read, so that the handler sees a
  // consistent view of the document
  cm.display.input.ensurePolled();
  var prevShift = cm.display.shift, done = false;
  try {
    if (cm.isReadOnly()) { cm.state.suppressEdits = true; }
    if (dropShift) { cm.display.shift = false; }
    done = bound(cm) != Pass;
  } finally {
    cm.display.shift = prevShift;
    cm.state.suppressEdits = false;
  }
  return done
}

function lookupKeyForEditor(cm, name, handle) {
  for (var i = 0; i < cm.state.keyMaps.length; i++) {
    var result = lookupKey(name, cm.state.keyMaps[i], handle, cm);
    if (result) { return result }
  }
  return (cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm))
    || lookupKey(name, cm.options.keyMap, handle, cm)
}

// Note that, despite the name, this function is also used to check
// for bound mouse clicks.

var stopSeq = new Delayed;

function dispatchKey(cm, name, e, handle) {
  var seq = cm.state.keySeq;
  if (seq) {
    if (isModifierKey(name)) { return "handled" }
    if (/\'$/.test(name))
      { cm.state.keySeq = null; }
    else
      { stopSeq.set(50, function () {
        if (cm.state.keySeq == seq) {
          cm.state.keySeq = null;
          cm.display.input.reset();
        }
      }); }
    if (dispatchKeyInner(cm, seq + " " + name, e, handle)) { return true }
  }
  return dispatchKeyInner(cm, name, e, handle)
}

function dispatchKeyInner(cm, name, e, handle) {
  var result = lookupKeyForEditor(cm, name, handle);

  if (result == "multi")
    { cm.state.keySeq = name; }
  if (result == "handled")
    { signalLater(cm, "keyHandled", cm, name, e); }

  if (result == "handled" || result == "multi") {
    e_preventDefault(e);
    restartBlink(cm);
  }

  return !!result
}

// Handle a key from the keydown event.
function handleKeyBinding(cm, e) {
  var name = keyName(e, true);
  if (!name) { return false }

  if (e.shiftKey && !cm.state.keySeq) {
    // First try to resolve full name (including 'Shift-'). Failing
    // that, see if there is a cursor-motion command (starting with
    // 'go') bound to the keyname without 'Shift-'.
    return dispatchKey(cm, "Shift-" + name, e, function (b) { return doHandleBinding(cm, b, true); })
        || dispatchKey(cm, name, e, function (b) {
             if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion)
               { return doHandleBinding(cm, b) }
           })
  } else {
    return dispatchKey(cm, name, e, function (b) { return doHandleBinding(cm, b); })
  }
}

// Handle a key from the keypress event
function handleCharBinding(cm, e, ch) {
  return dispatchKey(cm, "'" + ch + "'", e, function (b) { return doHandleBinding(cm, b, true); })
}

var lastStoppedKey = null;
function onKeyDown(e) {
  var cm = this;
  cm.curOp.focus = activeElt();
  if (signalDOMEvent(cm, e)) { return }
  // IE does strange things with escape.
  if (ie && ie_version < 11 && e.keyCode == 27) { e.returnValue = false; }
  var code = e.keyCode;
  cm.display.shift = code == 16 || e.shiftKey;
  var handled = handleKeyBinding(cm, e);
  if (presto) {
    lastStoppedKey = handled ? code : null;
    // Opera has no cut event... we try to at least catch the key combo
    if (!handled && code == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey))
      { cm.replaceSelection("", null, "cut"); }
  }

  // Turn mouse into crosshair when Alt is held on Mac.
  if (code == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className))
    { showCrossHair(cm); }
}

function showCrossHair(cm) {
  var lineDiv = cm.display.lineDiv;
  addClass(lineDiv, "CodeMirror-crosshair");

  function up(e) {
    if (e.keyCode == 18 || !e.altKey) {
      rmClass(lineDiv, "CodeMirror-crosshair");
      off(document, "keyup", up);
      off(document, "mouseover", up);
    }
  }
  on(document, "keyup", up);
  on(document, "mouseover", up);
}

function onKeyUp(e) {
  if (e.keyCode == 16) { this.doc.sel.shift = false; }
  signalDOMEvent(this, e);
}

function onKeyPress(e) {
  var cm = this;
  if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) { return }
  var keyCode = e.keyCode, charCode = e.charCode;
  if (presto && keyCode == lastStoppedKey) {lastStoppedKey = null; e_preventDefault(e); return}
  if ((presto && (!e.which || e.which < 10)) && handleKeyBinding(cm, e)) { return }
  var ch = String.fromCharCode(charCode == null ? keyCode : charCode);
  // Some browsers fire keypress events for backspace
  if (ch == "\x08") { return }
  if (handleCharBinding(cm, e, ch)) { return }
  cm.display.input.onKeyPress(e);
}

var DOUBLECLICK_DELAY = 400;

var PastClick = function(time, pos, button) {
  this.time = time;
  this.pos = pos;
  this.button = button;
};

PastClick.prototype.compare = function (time, pos, button) {
  return this.time + DOUBLECLICK_DELAY > time &&
    cmp(pos, this.pos) == 0 && button == this.button
};

var lastClick;
var lastDoubleClick;
function clickRepeat(pos, button) {
  var now = +new Date;
  if (lastDoubleClick && lastDoubleClick.compare(now, pos, button)) {
    lastClick = lastDoubleClick = null;
    return "triple"
  } else if (lastClick && lastClick.compare(now, pos, button)) {
    lastDoubleClick = new PastClick(now, pos, button);
    lastClick = null;
    return "double"
  } else {
    lastClick = new PastClick(now, pos, button);
    lastDoubleClick = null;
    return "single"
  }
}

// A mouse down can be a single click, double click, triple click,
// start of selection drag, start of text drag, new cursor
// (ctrl-click), rectangle drag (alt-drag), or xwin
// middle-click-paste. Or it might be a click on something we should
// not interfere with, such as a scrollbar or widget.
function onMouseDown(e) {
  var cm = this, display = cm.display;
  if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) { return }
  display.input.ensurePolled();
  display.shift = e.shiftKey;

  if (eventInWidget(display, e)) {
    if (!webkit) {
      // Briefly turn off draggability, to allow widgets to do
      // normal dragging things.
      display.scroller.draggable = false;
      setTimeout(function () { return display.scroller.draggable = true; }, 100);
    }
    return
  }
  if (clickInGutter(cm, e)) { return }
  var pos = posFromMouse(cm, e), button = e_button(e), repeat = pos ? clickRepeat(pos, button) : "single";
  window.focus();

  // #3261: make sure, that we're not starting a second selection
  if (button == 1 && cm.state.selectingText)
    { cm.state.selectingText(e); }

  if (pos && handleMappedButton(cm, button, pos, repeat, e)) { return }

  if (button == 1) {
    if (pos) { leftButtonDown(cm, pos, repeat, e); }
    else if (e_target(e) == display.scroller) { e_preventDefault(e); }
  } else if (button == 2) {
    if (pos) { extendSelection(cm.doc, pos); }
    setTimeout(function () { return display.input.focus(); }, 20);
  } else if (button == 3) {
    if (captureRightClick) { onContextMenu(cm, e); }
    else { delayBlurEvent(cm); }
  }
}

function handleMappedButton(cm, button, pos, repeat, event) {
  var name = "Click";
  if (repeat == "double") { name = "Double" + name; }
  else if (repeat == "triple") { name = "Triple" + name; }
  name = (button == 1 ? "Left" : button == 2 ? "Middle" : "Right") + name;

  return dispatchKey(cm,  addModifierNames(name, event), event, function (bound) {
    if (typeof bound == "string") { bound = commands[bound]; }
    if (!bound) { return false }
    var done = false;
    try {
      if (cm.isReadOnly()) { cm.state.suppressEdits = true; }
      done = bound(cm, pos) != Pass;
    } finally {
      cm.state.suppressEdits = false;
    }
    return done
  })
}

function configureMouse(cm, repeat, event) {
  var option = cm.getOption("configureMouse");
  var value = option ? option(cm, repeat, event) : {};
  if (value.unit == null) {
    var rect = chromeOS ? event.shiftKey && event.metaKey : event.altKey;
    value.unit = rect ? "rectangle" : repeat == "single" ? "char" : repeat == "double" ? "word" : "line";
  }
  if (value.extend == null || cm.doc.extend) { value.extend = cm.doc.extend || event.shiftKey; }
  if (value.addNew == null) { value.addNew = mac ? event.metaKey : event.ctrlKey; }
  if (value.moveOnDrag == null) { value.moveOnDrag = !(mac ? event.altKey : event.ctrlKey); }
  return value
}

function leftButtonDown(cm, pos, repeat, event) {
  if (ie) { setTimeout(bind(ensureFocus, cm), 0); }
  else { cm.curOp.focus = activeElt(); }

  var behavior = configureMouse(cm, repeat, event);

  var sel = cm.doc.sel, contained;
  if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() &&
      repeat == "single" && (contained = sel.contains(pos)) > -1 &&
      (cmp((contained = sel.ranges[contained]).from(), pos) < 0 || pos.xRel > 0) &&
      (cmp(contained.to(), pos) > 0 || pos.xRel < 0))
    { leftButtonStartDrag(cm, event, pos, behavior); }
  else
    { leftButtonSelect(cm, event, pos, behavior); }
}

// Start a text drag. When it ends, see if any dragging actually
// happen, and treat as a click if it didn't.
function leftButtonStartDrag(cm, event, pos, behavior) {
  var display = cm.display, moved = false;
  var dragEnd = operation(cm, function (e) {
    if (webkit) { display.scroller.draggable = false; }
    cm.state.draggingText = false;
    off(display.wrapper.ownerDocument, "mouseup", dragEnd);
    off(display.wrapper.ownerDocument, "mousemove", mouseMove);
    off(display.scroller, "dragstart", dragStart);
    off(display.scroller, "drop", dragEnd);
    if (!moved) {
      e_preventDefault(e);
      if (!behavior.addNew)
        { extendSelection(cm.doc, pos, null, null, behavior.extend); }
      // Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
      if (webkit || ie && ie_version == 9)
        { setTimeout(function () {display.wrapper.ownerDocument.body.focus(); display.input.focus();}, 20); }
      else
        { display.input.focus(); }
    }
  });
  var mouseMove = function(e2) {
    moved = moved || Math.abs(event.clientX - e2.clientX) + Math.abs(event.clientY - e2.clientY) >= 10;
  };
  var dragStart = function () { return moved = true; };
  // Let the drag handler handle this.
  if (webkit) { display.scroller.draggable = true; }
  cm.state.draggingText = dragEnd;
  dragEnd.copy = !behavior.moveOnDrag;
  // IE's approach to draggable
  if (display.scroller.dragDrop) { display.scroller.dragDrop(); }
  on(display.wrapper.ownerDocument, "mouseup", dragEnd);
  on(display.wrapper.ownerDocument, "mousemove", mouseMove);
  on(display.scroller, "dragstart", dragStart);
  on(display.scroller, "drop", dragEnd);

  delayBlurEvent(cm);
  setTimeout(function () { return display.input.focus(); }, 20);
}

function rangeForUnit(cm, pos, unit) {
  if (unit == "char") { return new Range(pos, pos) }
  if (unit == "word") { return cm.findWordAt(pos) }
  if (unit == "line") { return new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))) }
  var result = unit(cm, pos);
  return new Range(result.from, result.to)
}

// Normal selection, as opposed to text dragging.
function leftButtonSelect(cm, event, start, behavior) {
  var display = cm.display, doc = cm.doc;
  e_preventDefault(event);

  var ourRange, ourIndex, startSel = doc.sel, ranges = startSel.ranges;
  if (behavior.addNew && !behavior.extend) {
    ourIndex = doc.sel.contains(start);
    if (ourIndex > -1)
      { ourRange = ranges[ourIndex]; }
    else
      { ourRange = new Range(start, start); }
  } else {
    ourRange = doc.sel.primary();
    ourIndex = doc.sel.primIndex;
  }

  if (behavior.unit == "rectangle") {
    if (!behavior.addNew) { ourRange = new Range(start, start); }
    start = posFromMouse(cm, event, true, true);
    ourIndex = -1;
  } else {
    var range$$1 = rangeForUnit(cm, start, behavior.unit);
    if (behavior.extend)
      { ourRange = extendRange(ourRange, range$$1.anchor, range$$1.head, behavior.extend); }
    else
      { ourRange = range$$1; }
  }

  if (!behavior.addNew) {
    ourIndex = 0;
    setSelection(doc, new Selection([ourRange], 0), sel_mouse);
    startSel = doc.sel;
  } else if (ourIndex == -1) {
    ourIndex = ranges.length;
    setSelection(doc, normalizeSelection(ranges.concat([ourRange]), ourIndex),
                 {scroll: false, origin: "*mouse"});
  } else if (ranges.length > 1 && ranges[ourIndex].empty() && behavior.unit == "char" && !behavior.extend) {
    setSelection(doc, normalizeSelection(ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0),
                 {scroll: false, origin: "*mouse"});
    startSel = doc.sel;
  } else {
    replaceOneSelection(doc, ourIndex, ourRange, sel_mouse);
  }

  var lastPos = start;
  function extendTo(pos) {
    if (cmp(lastPos, pos) == 0) { return }
    lastPos = pos;

    if (behavior.unit == "rectangle") {
      var ranges = [], tabSize = cm.options.tabSize;
      var startCol = countColumn(getLine(doc, start.line).text, start.ch, tabSize);
      var posCol = countColumn(getLine(doc, pos.line).text, pos.ch, tabSize);
      var left = Math.min(startCol, posCol), right = Math.max(startCol, posCol);
      for (var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line));
           line <= end; line++) {
        var text = getLine(doc, line).text, leftPos = findColumn(text, left, tabSize);
        if (left == right)
          { ranges.push(new Range(Pos(line, leftPos), Pos(line, leftPos))); }
        else if (text.length > leftPos)
          { ranges.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize)))); }
      }
      if (!ranges.length) { ranges.push(new Range(start, start)); }
      setSelection(doc, normalizeSelection(startSel.ranges.slice(0, ourIndex).concat(ranges), ourIndex),
                   {origin: "*mouse", scroll: false});
      cm.scrollIntoView(pos);
    } else {
      var oldRange = ourRange;
      var range$$1 = rangeForUnit(cm, pos, behavior.unit);
      var anchor = oldRange.anchor, head;
      if (cmp(range$$1.anchor, anchor) > 0) {
        head = range$$1.head;
        anchor = minPos(oldRange.from(), range$$1.anchor);
      } else {
        head = range$$1.anchor;
        anchor = maxPos(oldRange.to(), range$$1.head);
      }
      var ranges$1 = startSel.ranges.slice(0);
      ranges$1[ourIndex] = bidiSimplify(cm, new Range(clipPos(doc, anchor), head));
      setSelection(doc, normalizeSelection(ranges$1, ourIndex), sel_mouse);
    }
  }

  var editorSize = display.wrapper.getBoundingClientRect();
  // Used to ensure timeout re-tries don't fire when another extend
  // happened in the meantime (clearTimeout isn't reliable -- at
  // least on Chrome, the timeouts still happen even when cleared,
  // if the clear happens after their scheduled firing time).
  var counter = 0;

  function extend(e) {
    var curCount = ++counter;
    var cur = posFromMouse(cm, e, true, behavior.unit == "rectangle");
    if (!cur) { return }
    if (cmp(cur, lastPos) != 0) {
      cm.curOp.focus = activeElt();
      extendTo(cur);
      var visible = visibleLines(display, doc);
      if (cur.line >= visible.to || cur.line < visible.from)
        { setTimeout(operation(cm, function () {if (counter == curCount) { extend(e); }}), 150); }
    } else {
      var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0;
      if (outside) { setTimeout(operation(cm, function () {
        if (counter != curCount) { return }
        display.scroller.scrollTop += outside;
        extend(e);
      }), 50); }
    }
  }

  function done(e) {
    cm.state.selectingText = false;
    counter = Infinity;
    e_preventDefault(e);
    display.input.focus();
    off(display.wrapper.ownerDocument, "mousemove", move);
    off(display.wrapper.ownerDocument, "mouseup", up);
    doc.history.lastSelOrigin = null;
  }

  var move = operation(cm, function (e) {
    if (e.buttons === 0 || !e_button(e)) { done(e); }
    else { extend(e); }
  });
  var up = operation(cm, done);
  cm.state.selectingText = up;
  on(display.wrapper.ownerDocument, "mousemove", move);
  on(display.wrapper.ownerDocument, "mouseup", up);
}

// Used when mouse-selecting to adjust the anchor to the proper side
// of a bidi jump depending on the visual position of the head.
function bidiSimplify(cm, range$$1) {
  var anchor = range$$1.anchor;
  var head = range$$1.head;
  var anchorLine = getLine(cm.doc, anchor.line);
  if (cmp(anchor, head) == 0 && anchor.sticky == head.sticky) { return range$$1 }
  var order = getOrder(anchorLine);
  if (!order) { return range$$1 }
  var index = getBidiPartAt(order, anchor.ch, anchor.sticky), part = order[index];
  if (part.from != anchor.ch && part.to != anchor.ch) { return range$$1 }
  var boundary = index + ((part.from == anchor.ch) == (part.level != 1) ? 0 : 1);
  if (boundary == 0 || boundary == order.length) { return range$$1 }

  // Compute the relative visual position of the head compared to the
  // anchor (<0 is to the left, >0 to the right)
  var leftSide;
  if (head.line != anchor.line) {
    leftSide = (head.line - anchor.line) * (cm.doc.direction == "ltr" ? 1 : -1) > 0;
  } else {
    var headIndex = getBidiPartAt(order, head.ch, head.sticky);
    var dir = headIndex - index || (head.ch - anchor.ch) * (part.level == 1 ? -1 : 1);
    if (headIndex == boundary - 1 || headIndex == boundary)
      { leftSide = dir < 0; }
    else
      { leftSide = dir > 0; }
  }

  var usePart = order[boundary + (leftSide ? -1 : 0)];
  var from = leftSide == (usePart.level == 1);
  var ch = from ? usePart.from : usePart.to, sticky = from ? "after" : "before";
  return anchor.ch == ch && anchor.sticky == sticky ? range$$1 : new Range(new Pos(anchor.line, ch, sticky), head)
}


// Determines whether an event happened in the gutter, and fires the
// handlers for the corresponding event.
function gutterEvent(cm, e, type, prevent) {
  var mX, mY;
  if (e.touches) {
    mX = e.touches[0].clientX;
    mY = e.touches[0].clientY;
  } else {
    try { mX = e.clientX; mY = e.clientY; }
    catch(e) { return false }
  }
  if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) { return false }
  if (prevent) { e_preventDefault(e); }

  var display = cm.display;
  var lineBox = display.lineDiv.getBoundingClientRect();

  if (mY > lineBox.bottom || !hasHandler(cm, type)) { return e_defaultPrevented(e) }
  mY -= lineBox.top - display.viewOffset;

  for (var i = 0; i < cm.options.gutters.length; ++i) {
    var g = display.gutters.childNodes[i];
    if (g && g.getBoundingClientRect().right >= mX) {
      var line = lineAtHeight(cm.doc, mY);
      var gutter = cm.options.gutters[i];
      signal(cm, type, cm, line, gutter, e);
      return e_defaultPrevented(e)
    }
  }
}

function clickInGutter(cm, e) {
  return gutterEvent(cm, e, "gutterClick", true)
}

// CONTEXT MENU HANDLING

// To make the context menu work, we need to briefly unhide the
// textarea (making it as unobtrusive as possible) to let the
// right-click take effect on it.
function onContextMenu(cm, e) {
  if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) { return }
  if (signalDOMEvent(cm, e, "contextmenu")) { return }
  cm.display.input.onContextMenu(e);
}

function contextMenuInGutter(cm, e) {
  if (!hasHandler(cm, "gutterContextMenu")) { return false }
  return gutterEvent(cm, e, "gutterContextMenu", false)
}

function themeChanged(cm) {
  cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") +
    cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-");
  clearCaches(cm);
}

var Init = {toString: function(){return "CodeMirror.Init"}};

var defaults = {};
var optionHandlers = {};

function defineOptions(CodeMirror) {
  var optionHandlers = CodeMirror.optionHandlers;

  function option(name, deflt, handle, notOnInit) {
    CodeMirror.defaults[name] = deflt;
    if (handle) { optionHandlers[name] =
      notOnInit ? function (cm, val, old) {if (old != Init) { handle(cm, val, old); }} : handle; }
  }

  CodeMirror.defineOption = option;

  // Passed to option handlers when there is no old value.
  CodeMirror.Init = Init;

  // These two are, on init, called from the constructor because they
  // have to be initialized before the editor can start at all.
  option("value", "", function (cm, val) { return cm.setValue(val); }, true);
  option("mode", null, function (cm, val) {
    cm.doc.modeOption = val;
    loadMode(cm);
  }, true);

  option("indentUnit", 2, loadMode, true);
  option("indentWithTabs", false);
  option("smartIndent", true);
  option("tabSize", 4, function (cm) {
    resetModeState(cm);
    clearCaches(cm);
    regChange(cm);
  }, true);

  option("lineSeparator", null, function (cm, val) {
    cm.doc.lineSep = val;
    if (!val) { return }
    var newBreaks = [], lineNo = cm.doc.first;
    cm.doc.iter(function (line) {
      for (var pos = 0;;) {
        var found = line.text.indexOf(val, pos);
        if (found == -1) { break }
        pos = found + val.length;
        newBreaks.push(Pos(lineNo, found));
      }
      lineNo++;
    });
    for (var i = newBreaks.length - 1; i >= 0; i--)
      { replaceRange(cm.doc, val, newBreaks[i], Pos(newBreaks[i].line, newBreaks[i].ch + val.length)); }
  });
  option("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b-\u200f\u2028\u2029\ufeff]/g, function (cm, val, old) {
    cm.state.specialChars = new RegExp(val.source + (val.test("\t") ? "" : "|\t"), "g");
    if (old != Init) { cm.refresh(); }
  });
  option("specialCharPlaceholder", defaultSpecialCharPlaceholder, function (cm) { return cm.refresh(); }, true);
  option("electricChars", true);
  option("inputStyle", mobile ? "contenteditable" : "textarea", function () {
    throw new Error("inputStyle can not (yet) be changed in a running editor") // FIXME
  }, true);
  option("spellcheck", false, function (cm, val) { return cm.getInputField().spellcheck = val; }, true);
  option("rtlMoveVisually", !windows);
  option("wholeLineUpdateBefore", true);

  option("theme", "default", function (cm) {
    themeChanged(cm);
    guttersChanged(cm);
  }, true);
  option("keyMap", "default", function (cm, val, old) {
    var next = getKeyMap(val);
    var prev = old != Init && getKeyMap(old);
    if (prev && prev.detach) { prev.detach(cm, next); }
    if (next.attach) { next.attach(cm, prev || null); }
  });
  option("extraKeys", null);
  option("configureMouse", null);

  option("lineWrapping", false, wrappingChanged, true);
  option("gutters", [], function (cm) {
    setGuttersForLineNumbers(cm.options);
    guttersChanged(cm);
  }, true);
  option("fixedGutter", true, function (cm, val) {
    cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0";
    cm.refresh();
  }, true);
  option("coverGutterNextToScrollbar", false, function (cm) { return updateScrollbars(cm); }, true);
  option("scrollbarStyle", "native", function (cm) {
    initScrollbars(cm);
    updateScrollbars(cm);
    cm.display.scrollbars.setScrollTop(cm.doc.scrollTop);
    cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft);
  }, true);
  option("lineNumbers", false, function (cm) {
    setGuttersForLineNumbers(cm.options);
    guttersChanged(cm);
  }, true);
  option("firstLineNumber", 1, guttersChanged, true);
  option("lineNumberFormatter", function (integer) { return integer; }, guttersChanged, true);
  option("showCursorWhenSelecting", false, updateSelection, true);

  option("resetSelectionOnContextMenu", true);
  option("lineWiseCopyCut", true);
  option("pasteLinesPerSelection", true);

  option("readOnly", false, function (cm, val) {
    if (val == "nocursor") {
      onBlur(cm);
      cm.display.input.blur();
    }
    cm.display.input.readOnlyChanged(val);
  });
  option("disableInput", false, function (cm, val) {if (!val) { cm.display.input.reset(); }}, true);
  option("dragDrop", true, dragDropChanged);
  option("allowDropFileTypes", null);

  option("cursorBlinkRate", 530);
  option("cursorScrollMargin", 0);
  option("cursorHeight", 1, updateSelection, true);
  option("singleCursorHeightPerLine", true, updateSelection, true);
  option("workTime", 100);
  option("workDelay", 100);
  option("flattenSpans", true, resetModeState, true);
  option("addModeClass", false, resetModeState, true);
  option("pollInterval", 100);
  option("undoDepth", 200, function (cm, val) { return cm.doc.history.undoDepth = val; });
  option("historyEventDelay", 1250);
  option("viewportMargin", 10, function (cm) { return cm.refresh(); }, true);
  option("maxHighlightLength", 10000, resetModeState, true);
  option("moveInputWithCursor", true, function (cm, val) {
    if (!val) { cm.display.input.resetPosition(); }
  });

  option("tabindex", null, function (cm, val) { return cm.display.input.getField().tabIndex = val || ""; });
  option("autofocus", null);
  option("direction", "ltr", function (cm, val) { return cm.doc.setDirection(val); }, true);
}

function guttersChanged(cm) {
  updateGutters(cm);
  regChange(cm);
  alignHorizontally(cm);
}

function dragDropChanged(cm, value, old) {
  var wasOn = old && old != Init;
  if (!value != !wasOn) {
    var funcs = cm.display.dragFunctions;
    var toggle = value ? on : off;
    toggle(cm.display.scroller, "dragstart", funcs.start);
    toggle(cm.display.scroller, "dragenter", funcs.enter);
    toggle(cm.display.scroller, "dragover", funcs.over);
    toggle(cm.display.scroller, "dragleave", funcs.leave);
    toggle(cm.display.scroller, "drop", funcs.drop);
  }
}

function wrappingChanged(cm) {
  if (cm.options.lineWrapping) {
    addClass(cm.display.wrapper, "CodeMirror-wrap");
    cm.display.sizer.style.minWidth = "";
    cm.display.sizerWidth = null;
  } else {
    rmClass(cm.display.wrapper, "CodeMirror-wrap");
    findMaxLine(cm);
  }
  estimateLineHeights(cm);
  regChange(cm);
  clearCaches(cm);
  setTimeout(function () { return updateScrollbars(cm); }, 100);
}

// A CodeMirror instance represents an editor. This is the object
// that user code is usually dealing with.

function CodeMirror$1(place, options) {
  var this$1 = this;

  if (!(this instanceof CodeMirror$1)) { return new CodeMirror$1(place, options) }

  this.options = options = options ? copyObj(options) : {};
  // Determine effective options based on given values and defaults.
  copyObj(defaults, options, false);
  setGuttersForLineNumbers(options);

  var doc = options.value;
  if (typeof doc == "string") { doc = new Doc(doc, options.mode, null, options.lineSeparator, options.direction); }
  this.doc = doc;

  var input = new CodeMirror$1.inputStyles[options.inputStyle](this);
  var display = this.display = new Display(place, doc, input);
  display.wrapper.CodeMirror = this;
  updateGutters(this);
  themeChanged(this);
  if (options.lineWrapping)
    { this.display.wrapper.className += " CodeMirror-wrap"; }
  initScrollbars(this);

  this.state = {
    keyMaps: [],  // stores maps added by addKeyMap
    overlays: [], // highlighting overlays, as added by addOverlay
    modeGen: 0,   // bumped when mode/overlay changes, used to invalidate highlighting info
    overwrite: false,
    delayingBlurEvent: false,
    focused: false,
    suppressEdits: false, // used to disable editing during key handlers when in readOnly mode
    pasteIncoming: false, cutIncoming: false, // help recognize paste/cut edits in input.poll
    selectingText: false,
    draggingText: false,
    highlight: new Delayed(), // stores highlight worker timeout
    keySeq: null,  // Unfinished key sequence
    specialChars: null
  };

  if (options.autofocus && !mobile) { display.input.focus(); }

  // Override magic textarea content restore that IE sometimes does
  // on our hidden textarea on reload
  if (ie && ie_version < 11) { setTimeout(function () { return this$1.display.input.reset(true); }, 20); }

  registerEventHandlers(this);
  ensureGlobalHandlers();

  startOperation(this);
  this.curOp.forceUpdate = true;
  attachDoc(this, doc);

  if ((options.autofocus && !mobile) || this.hasFocus())
    { setTimeout(bind(onFocus, this), 20); }
  else
    { onBlur(this); }

  for (var opt in optionHandlers) { if (optionHandlers.hasOwnProperty(opt))
    { optionHandlers[opt](this$1, options[opt], Init); } }
  maybeUpdateLineNumberWidth(this);
  if (options.finishInit) { options.finishInit(this); }
  for (var i = 0; i < initHooks.length; ++i) { initHooks[i](this$1); }
  endOperation(this);
  // Suppress optimizelegibility in Webkit, since it breaks text
  // measuring on line wrapping boundaries.
  if (webkit && options.lineWrapping &&
      getComputedStyle(display.lineDiv).textRendering == "optimizelegibility")
    { display.lineDiv.style.textRendering = "auto"; }
}

// The default configuration options.
CodeMirror$1.defaults = defaults;
// Functions to run when options are changed.
CodeMirror$1.optionHandlers = optionHandlers;

// Attach the necessary event handlers when initializing the editor
function registerEventHandlers(cm) {
  var d = cm.display;
  on(d.scroller, "mousedown", operation(cm, onMouseDown));
  // Older IE's will not fire a second mousedown for a double click
  if (ie && ie_version < 11)
    { on(d.scroller, "dblclick", operation(cm, function (e) {
      if (signalDOMEvent(cm, e)) { return }
      var pos = posFromMouse(cm, e);
      if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) { return }
      e_preventDefault(e);
      var word = cm.findWordAt(pos);
      extendSelection(cm.doc, word.anchor, word.head);
    })); }
  else
    { on(d.scroller, "dblclick", function (e) { return signalDOMEvent(cm, e) || e_preventDefault(e); }); }
  // Some browsers fire contextmenu *after* opening the menu, at
  // which point we can't mess with it anymore. Context menu is
  // handled in onMouseDown for these browsers.
  if (!captureRightClick) { on(d.scroller, "contextmenu", function (e) { return onContextMenu(cm, e); }); }

  // Used to suppress mouse event handling when a touch happens
  var touchFinished, prevTouch = {end: 0};
  function finishTouch() {
    if (d.activeTouch) {
      touchFinished = setTimeout(function () { return d.activeTouch = null; }, 1000);
      prevTouch = d.activeTouch;
      prevTouch.end = +new Date;
    }
  }
  function isMouseLikeTouchEvent(e) {
    if (e.touches.length != 1) { return false }
    var touch = e.touches[0];
    return touch.radiusX <= 1 && touch.radiusY <= 1
  }
  function farAway(touch, other) {
    if (other.left == null) { return true }
    var dx = other.left - touch.left, dy = other.top - touch.top;
    return dx * dx + dy * dy > 20 * 20
  }
  on(d.scroller, "touchstart", function (e) {
    if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e) && !clickInGutter(cm, e)) {
      d.input.ensurePolled();
      clearTimeout(touchFinished);
      var now = +new Date;
      d.activeTouch = {start: now, moved: false,
                       prev: now - prevTouch.end <= 300 ? prevTouch : null};
      if (e.touches.length == 1) {
        d.activeTouch.left = e.touches[0].pageX;
        d.activeTouch.top = e.touches[0].pageY;
      }
    }
  });
  on(d.scroller, "touchmove", function () {
    if (d.activeTouch) { d.activeTouch.moved = true; }
  });
  on(d.scroller, "touchend", function (e) {
    var touch = d.activeTouch;
    if (touch && !eventInWidget(d, e) && touch.left != null &&
        !touch.moved && new Date - touch.start < 300) {
      var pos = cm.coordsChar(d.activeTouch, "page"), range;
      if (!touch.prev || farAway(touch, touch.prev)) // Single tap
        { range = new Range(pos, pos); }
      else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) // Double tap
        { range = cm.findWordAt(pos); }
      else // Triple tap
        { range = new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))); }
      cm.setSelection(range.anchor, range.head);
      cm.focus();
      e_preventDefault(e);
    }
    finishTouch();
  });
  on(d.scroller, "touchcancel", finishTouch);

  // Sync scrolling between fake scrollbars and real scrollable
  // area, ensure viewport is updated when scrolling.
  on(d.scroller, "scroll", function () {
    if (d.scroller.clientHeight) {
      updateScrollTop(cm, d.scroller.scrollTop);
      setScrollLeft(cm, d.scroller.scrollLeft, true);
      signal(cm, "scroll", cm);
    }
  });

  // Listen to wheel events in order to try and update the viewport on time.
  on(d.scroller, "mousewheel", function (e) { return onScrollWheel(cm, e); });
  on(d.scroller, "DOMMouseScroll", function (e) { return onScrollWheel(cm, e); });

  // Prevent wrapper from ever scrolling
  on(d.wrapper, "scroll", function () { return d.wrapper.scrollTop = d.wrapper.scrollLeft = 0; });

  d.dragFunctions = {
    enter: function (e) {if (!signalDOMEvent(cm, e)) { e_stop(e); }},
    over: function (e) {if (!signalDOMEvent(cm, e)) { onDragOver(cm, e); e_stop(e); }},
    start: function (e) { return onDragStart(cm, e); },
    drop: operation(cm, onDrop),
    leave: function (e) {if (!signalDOMEvent(cm, e)) { clearDragCursor(cm); }}
  };

  var inp = d.input.getField();
  on(inp, "keyup", function (e) { return onKeyUp.call(cm, e); });
  on(inp, "keydown", operation(cm, onKeyDown));
  on(inp, "keypress", operation(cm, onKeyPress));
  on(inp, "focus", function (e) { return onFocus(cm, e); });
  on(inp, "blur", function (e) { return onBlur(cm, e); });
}

var initHooks = [];
CodeMirror$1.defineInitHook = function (f) { return initHooks.push(f); };

// Indent the given line. The how parameter can be "smart",
// "add"/null, "subtract", or "prev". When aggressive is false
// (typically set to true for forced single-line indents), empty
// lines are not indented, and places where the mode returns Pass
// are left alone.
function indentLine(cm, n, how, aggressive) {
  var doc = cm.doc, state;
  if (how == null) { how = "add"; }
  if (how == "smart") {
    // Fall back to "prev" when the mode doesn't have an indentation
    // method.
    if (!doc.mode.indent) { how = "prev"; }
    else { state = getContextBefore(cm, n).state; }
  }

  var tabSize = cm.options.tabSize;
  var line = getLine(doc, n), curSpace = countColumn(line.text, null, tabSize);
  if (line.stateAfter) { line.stateAfter = null; }
  var curSpaceString = line.text.match(/^\s*/)[0], indentation;
  if (!aggressive && !/\S/.test(line.text)) {
    indentation = 0;
    how = "not";
  } else if (how == "smart") {
    indentation = doc.mode.indent(state, line.text.slice(curSpaceString.length), line.text);
    if (indentation == Pass || indentation > 150) {
      if (!aggressive) { return }
      how = "prev";
    }
  }
  if (how == "prev") {
    if (n > doc.first) { indentation = countColumn(getLine(doc, n-1).text, null, tabSize); }
    else { indentation = 0; }
  } else if (how == "add") {
    indentation = curSpace + cm.options.indentUnit;
  } else if (how == "subtract") {
    indentation = curSpace - cm.options.indentUnit;
  } else if (typeof how == "number") {
    indentation = curSpace + how;
  }
  indentation = Math.max(0, indentation);

  var indentString = "", pos = 0;
  if (cm.options.indentWithTabs)
    { for (var i = Math.floor(indentation / tabSize); i; --i) {pos += tabSize; indentString += "\t";} }
  if (pos < indentation) { indentString += spaceStr(indentation - pos); }

  if (indentString != curSpaceString) {
    replaceRange(doc, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input");
    line.stateAfter = null;
    return true
  } else {
    // Ensure that, if the cursor was in the whitespace at the start
    // of the line, it is moved to the end of that space.
    for (var i$1 = 0; i$1 < doc.sel.ranges.length; i$1++) {
      var range = doc.sel.ranges[i$1];
      if (range.head.line == n && range.head.ch < curSpaceString.length) {
        var pos$1 = Pos(n, curSpaceString.length);
        replaceOneSelection(doc, i$1, new Range(pos$1, pos$1));
        break
      }
    }
  }
}

// This will be set to a {lineWise: bool, text: [string]} object, so
// that, when pasting, we know what kind of selections the copied
// text was made out of.
var lastCopied = null;

function setLastCopied(newLastCopied) {
  lastCopied = newLastCopied;
}

function applyTextInput(cm, inserted, deleted, sel, origin) {
  var doc = cm.doc;
  cm.display.shift = false;
  if (!sel) { sel = doc.sel; }

  var paste = cm.state.pasteIncoming || origin == "paste";
  var textLines = splitLinesAuto(inserted), multiPaste = null;
  // When pasting N lines into N selections, insert one line per selection
  if (paste && sel.ranges.length > 1) {
    if (lastCopied && lastCopied.text.join("\n") == inserted) {
      if (sel.ranges.length % lastCopied.text.length == 0) {
        multiPaste = [];
        for (var i = 0; i < lastCopied.text.length; i++)
          { multiPaste.push(doc.splitLines(lastCopied.text[i])); }
      }
    } else if (textLines.length == sel.ranges.length && cm.options.pasteLinesPerSelection) {
      multiPaste = map(textLines, function (l) { return [l]; });
    }
  }

  var updateInput;
  // Normal behavior is to insert the new text into every selection
  for (var i$1 = sel.ranges.length - 1; i$1 >= 0; i$1--) {
    var range$$1 = sel.ranges[i$1];
    var from = range$$1.from(), to = range$$1.to();
    if (range$$1.empty()) {
      if (deleted && deleted > 0) // Handle deletion
        { from = Pos(from.line, from.ch - deleted); }
      else if (cm.state.overwrite && !paste) // Handle overwrite
        { to = Pos(to.line, Math.min(getLine(doc, to.line).text.length, to.ch + lst(textLines).length)); }
      else if (lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == inserted)
        { from = to = Pos(from.line, 0); }
    }
    updateInput = cm.curOp.updateInput;
    var changeEvent = {from: from, to: to, text: multiPaste ? multiPaste[i$1 % multiPaste.length] : textLines,
                       origin: origin || (paste ? "paste" : cm.state.cutIncoming ? "cut" : "+input")};
    makeChange(cm.doc, changeEvent);
    signalLater(cm, "inputRead", cm, changeEvent);
  }
  if (inserted && !paste)
    { triggerElectric(cm, inserted); }

  ensureCursorVisible(cm);
  cm.curOp.updateInput = updateInput;
  cm.curOp.typing = true;
  cm.state.pasteIncoming = cm.state.cutIncoming = false;
}

function handlePaste(e, cm) {
  var pasted = e.clipboardData && e.clipboardData.getData("Text");
  if (pasted) {
    e.preventDefault();
    if (!cm.isReadOnly() && !cm.options.disableInput)
      { runInOp(cm, function () { return applyTextInput(cm, pasted, 0, null, "paste"); }); }
    return true
  }
}

function triggerElectric(cm, inserted) {
  // When an 'electric' character is inserted, immediately trigger a reindent
  if (!cm.options.electricChars || !cm.options.smartIndent) { return }
  var sel = cm.doc.sel;

  for (var i = sel.ranges.length - 1; i >= 0; i--) {
    var range$$1 = sel.ranges[i];
    if (range$$1.head.ch > 100 || (i && sel.ranges[i - 1].head.line == range$$1.head.line)) { continue }
    var mode = cm.getModeAt(range$$1.head);
    var indented = false;
    if (mode.electricChars) {
      for (var j = 0; j < mode.electricChars.length; j++)
        { if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
          indented = indentLine(cm, range$$1.head.line, "smart");
          break
        } }
    } else if (mode.electricInput) {
      if (mode.electricInput.test(getLine(cm.doc, range$$1.head.line).text.slice(0, range$$1.head.ch)))
        { indented = indentLine(cm, range$$1.head.line, "smart"); }
    }
    if (indented) { signalLater(cm, "electricInput", cm, range$$1.head.line); }
  }
}

function copyableRanges(cm) {
  var text = [], ranges = [];
  for (var i = 0; i < cm.doc.sel.ranges.length; i++) {
    var line = cm.doc.sel.ranges[i].head.line;
    var lineRange = {anchor: Pos(line, 0), head: Pos(line + 1, 0)};
    ranges.push(lineRange);
    text.push(cm.getRange(lineRange.anchor, lineRange.head));
  }
  return {text: text, ranges: ranges}
}

function disableBrowserMagic(field, spellcheck) {
  field.setAttribute("autocorrect", "off");
  field.setAttribute("autocapitalize", "off");
  field.setAttribute("spellcheck", !!spellcheck);
}

function hiddenTextarea() {
  var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; outline: none");
  var div = elt("div", [te], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
  // The textarea is kept positioned near the cursor to prevent the
  // fact that it'll be scrolled into view on input from scrolling
  // our fake cursor out of view. On webkit, when wrap=off, paste is
  // very slow. So make the area wide instead.
  if (webkit) { te.style.width = "1000px"; }
  else { te.setAttribute("wrap", "off"); }
  // If border: 0; -- iOS fails to open keyboard (issue #1287)
  if (ios) { te.style.border = "1px solid black"; }
  disableBrowserMagic(te);
  return div
}

// The publicly visible API. Note that methodOp(f) means
// 'wrap f in an operation, performed on its `this` parameter'.

// This is not the complete set of editor methods. Most of the
// methods defined on the Doc type are also injected into
// CodeMirror.prototype, for backwards compatibility and
// convenience.

var addEditorMethods = function(CodeMirror) {
  var optionHandlers = CodeMirror.optionHandlers;

  var helpers = CodeMirror.helpers = {};

  CodeMirror.prototype = {
    constructor: CodeMirror,
    focus: function(){window.focus(); this.display.input.focus();},

    setOption: function(option, value) {
      var options = this.options, old = options[option];
      if (options[option] == value && option != "mode") { return }
      options[option] = value;
      if (optionHandlers.hasOwnProperty(option))
        { operation(this, optionHandlers[option])(this, value, old); }
      signal(this, "optionChange", this, option);
    },

    getOption: function(option) {return this.options[option]},
    getDoc: function() {return this.doc},

    addKeyMap: function(map$$1, bottom) {
      this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map$$1));
    },
    removeKeyMap: function(map$$1) {
      var maps = this.state.keyMaps;
      for (var i = 0; i < maps.length; ++i)
        { if (maps[i] == map$$1 || maps[i].name == map$$1) {
          maps.splice(i, 1);
          return true
        } }
    },

    addOverlay: methodOp(function(spec, options) {
      var mode = spec.token ? spec : CodeMirror.getMode(this.options, spec);
      if (mode.startState) { throw new Error("Overlays may not be stateful.") }
      insertSorted(this.state.overlays,
                   {mode: mode, modeSpec: spec, opaque: options && options.opaque,
                    priority: (options && options.priority) || 0},
                   function (overlay) { return overlay.priority; });
      this.state.modeGen++;
      regChange(this);
    }),
    removeOverlay: methodOp(function(spec) {
      var this$1 = this;

      var overlays = this.state.overlays;
      for (var i = 0; i < overlays.length; ++i) {
        var cur = overlays[i].modeSpec;
        if (cur == spec || typeof spec == "string" && cur.name == spec) {
          overlays.splice(i, 1);
          this$1.state.modeGen++;
          regChange(this$1);
          return
        }
      }
    }),

    indentLine: methodOp(function(n, dir, aggressive) {
      if (typeof dir != "string" && typeof dir != "number") {
        if (dir == null) { dir = this.options.smartIndent ? "smart" : "prev"; }
        else { dir = dir ? "add" : "subtract"; }
      }
      if (isLine(this.doc, n)) { indentLine(this, n, dir, aggressive); }
    }),
    indentSelection: methodOp(function(how) {
      var this$1 = this;

      var ranges = this.doc.sel.ranges, end = -1;
      for (var i = 0; i < ranges.length; i++) {
        var range$$1 = ranges[i];
        if (!range$$1.empty()) {
          var from = range$$1.from(), to = range$$1.to();
          var start = Math.max(end, from.line);
          end = Math.min(this$1.lastLine(), to.line - (to.ch ? 0 : 1)) + 1;
          for (var j = start; j < end; ++j)
            { indentLine(this$1, j, how); }
          var newRanges = this$1.doc.sel.ranges;
          if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i].from().ch > 0)
            { replaceOneSelection(this$1.doc, i, new Range(from, newRanges[i].to()), sel_dontScroll); }
        } else if (range$$1.head.line > end) {
          indentLine(this$1, range$$1.head.line, how, true);
          end = range$$1.head.line;
          if (i == this$1.doc.sel.primIndex) { ensureCursorVisible(this$1); }
        }
      }
    }),

    // Fetch the parser token for a given character. Useful for hacks
    // that want to inspect the mode state (say, for completion).
    getTokenAt: function(pos, precise) {
      return takeToken(this, pos, precise)
    },

    getLineTokens: function(line, precise) {
      return takeToken(this, Pos(line), precise, true)
    },

    getTokenTypeAt: function(pos) {
      pos = clipPos(this.doc, pos);
      var styles = getLineStyles(this, getLine(this.doc, pos.line));
      var before = 0, after = (styles.length - 1) / 2, ch = pos.ch;
      var type;
      if (ch == 0) { type = styles[2]; }
      else { for (;;) {
        var mid = (before + after) >> 1;
        if ((mid ? styles[mid * 2 - 1] : 0) >= ch) { after = mid; }
        else if (styles[mid * 2 + 1] < ch) { before = mid + 1; }
        else { type = styles[mid * 2 + 2]; break }
      } }
      var cut = type ? type.indexOf("overlay ") : -1;
      return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1)
    },

    getModeAt: function(pos) {
      var mode = this.doc.mode;
      if (!mode.innerMode) { return mode }
      return CodeMirror.innerMode(mode, this.getTokenAt(pos).state).mode
    },

    getHelper: function(pos, type) {
      return this.getHelpers(pos, type)[0]
    },

    getHelpers: function(pos, type) {
      var this$1 = this;

      var found = [];
      if (!helpers.hasOwnProperty(type)) { return found }
      var help = helpers[type], mode = this.getModeAt(pos);
      if (typeof mode[type] == "string") {
        if (help[mode[type]]) { found.push(help[mode[type]]); }
      } else if (mode[type]) {
        for (var i = 0; i < mode[type].length; i++) {
          var val = help[mode[type][i]];
          if (val) { found.push(val); }
        }
      } else if (mode.helperType && help[mode.helperType]) {
        found.push(help[mode.helperType]);
      } else if (help[mode.name]) {
        found.push(help[mode.name]);
      }
      for (var i$1 = 0; i$1 < help._global.length; i$1++) {
        var cur = help._global[i$1];
        if (cur.pred(mode, this$1) && indexOf(found, cur.val) == -1)
          { found.push(cur.val); }
      }
      return found
    },

    getStateAfter: function(line, precise) {
      var doc = this.doc;
      line = clipLine(doc, line == null ? doc.first + doc.size - 1: line);
      return getContextBefore(this, line + 1, precise).state
    },

    cursorCoords: function(start, mode) {
      var pos, range$$1 = this.doc.sel.primary();
      if (start == null) { pos = range$$1.head; }
      else if (typeof start == "object") { pos = clipPos(this.doc, start); }
      else { pos = start ? range$$1.from() : range$$1.to(); }
      return cursorCoords(this, pos, mode || "page")
    },

    charCoords: function(pos, mode) {
      return charCoords(this, clipPos(this.doc, pos), mode || "page")
    },

    coordsChar: function(coords, mode) {
      coords = fromCoordSystem(this, coords, mode || "page");
      return coordsChar(this, coords.left, coords.top)
    },

    lineAtHeight: function(height, mode) {
      height = fromCoordSystem(this, {top: height, left: 0}, mode || "page").top;
      return lineAtHeight(this.doc, height + this.display.viewOffset)
    },
    heightAtLine: function(line, mode, includeWidgets) {
      var end = false, lineObj;
      if (typeof line == "number") {
        var last = this.doc.first + this.doc.size - 1;
        if (line < this.doc.first) { line = this.doc.first; }
        else if (line > last) { line = last; end = true; }
        lineObj = getLine(this.doc, line);
      } else {
        lineObj = line;
      }
      return intoCoordSystem(this, lineObj, {top: 0, left: 0}, mode || "page", includeWidgets || end).top +
        (end ? this.doc.height - heightAtLine(lineObj) : 0)
    },

    defaultTextHeight: function() { return textHeight(this.display) },
    defaultCharWidth: function() { return charWidth(this.display) },

    getViewport: function() { return {from: this.display.viewFrom, to: this.display.viewTo}},

    addWidget: function(pos, node, scroll, vert, horiz) {
      var display = this.display;
      pos = cursorCoords(this, clipPos(this.doc, pos));
      var top = pos.bottom, left = pos.left;
      node.style.position = "absolute";
      node.setAttribute("cm-ignore-events", "true");
      this.display.input.setUneditable(node);
      display.sizer.appendChild(node);
      if (vert == "over") {
        top = pos.top;
      } else if (vert == "above" || vert == "near") {
        var vspace = Math.max(display.wrapper.clientHeight, this.doc.height),
        hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth);
        // Default to positioning above (if specified and possible); otherwise default to positioning below
        if ((vert == 'above' || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight)
          { top = pos.top - node.offsetHeight; }
        else if (pos.bottom + node.offsetHeight <= vspace)
          { top = pos.bottom; }
        if (left + node.offsetWidth > hspace)
          { left = hspace - node.offsetWidth; }
      }
      node.style.top = top + "px";
      node.style.left = node.style.right = "";
      if (horiz == "right") {
        left = display.sizer.clientWidth - node.offsetWidth;
        node.style.right = "0px";
      } else {
        if (horiz == "left") { left = 0; }
        else if (horiz == "middle") { left = (display.sizer.clientWidth - node.offsetWidth) / 2; }
        node.style.left = left + "px";
      }
      if (scroll)
        { scrollIntoView(this, {left: left, top: top, right: left + node.offsetWidth, bottom: top + node.offsetHeight}); }
    },

    triggerOnKeyDown: methodOp(onKeyDown),
    triggerOnKeyPress: methodOp(onKeyPress),
    triggerOnKeyUp: onKeyUp,
    triggerOnMouseDown: methodOp(onMouseDown),

    execCommand: function(cmd) {
      if (commands.hasOwnProperty(cmd))
        { return commands[cmd].call(null, this) }
    },

    triggerElectric: methodOp(function(text) { triggerElectric(this, text); }),

    findPosH: function(from, amount, unit, visually) {
      var this$1 = this;

      var dir = 1;
      if (amount < 0) { dir = -1; amount = -amount; }
      var cur = clipPos(this.doc, from);
      for (var i = 0; i < amount; ++i) {
        cur = findPosH(this$1.doc, cur, dir, unit, visually);
        if (cur.hitSide) { break }
      }
      return cur
    },

    moveH: methodOp(function(dir, unit) {
      var this$1 = this;

      this.extendSelectionsBy(function (range$$1) {
        if (this$1.display.shift || this$1.doc.extend || range$$1.empty())
          { return findPosH(this$1.doc, range$$1.head, dir, unit, this$1.options.rtlMoveVisually) }
        else
          { return dir < 0 ? range$$1.from() : range$$1.to() }
      }, sel_move);
    }),

    deleteH: methodOp(function(dir, unit) {
      var sel = this.doc.sel, doc = this.doc;
      if (sel.somethingSelected())
        { doc.replaceSelection("", null, "+delete"); }
      else
        { deleteNearSelection(this, function (range$$1) {
          var other = findPosH(doc, range$$1.head, dir, unit, false);
          return dir < 0 ? {from: other, to: range$$1.head} : {from: range$$1.head, to: other}
        }); }
    }),

    findPosV: function(from, amount, unit, goalColumn) {
      var this$1 = this;

      var dir = 1, x = goalColumn;
      if (amount < 0) { dir = -1; amount = -amount; }
      var cur = clipPos(this.doc, from);
      for (var i = 0; i < amount; ++i) {
        var coords = cursorCoords(this$1, cur, "div");
        if (x == null) { x = coords.left; }
        else { coords.left = x; }
        cur = findPosV(this$1, coords, dir, unit);
        if (cur.hitSide) { break }
      }
      return cur
    },

    moveV: methodOp(function(dir, unit) {
      var this$1 = this;

      var doc = this.doc, goals = [];
      var collapse = !this.display.shift && !doc.extend && doc.sel.somethingSelected();
      doc.extendSelectionsBy(function (range$$1) {
        if (collapse)
          { return dir < 0 ? range$$1.from() : range$$1.to() }
        var headPos = cursorCoords(this$1, range$$1.head, "div");
        if (range$$1.goalColumn != null) { headPos.left = range$$1.goalColumn; }
        goals.push(headPos.left);
        var pos = findPosV(this$1, headPos, dir, unit);
        if (unit == "page" && range$$1 == doc.sel.primary())
          { addToScrollTop(this$1, charCoords(this$1, pos, "div").top - headPos.top); }
        return pos
      }, sel_move);
      if (goals.length) { for (var i = 0; i < doc.sel.ranges.length; i++)
        { doc.sel.ranges[i].goalColumn = goals[i]; } }
    }),

    // Find the word at the given position (as returned by coordsChar).
    findWordAt: function(pos) {
      var doc = this.doc, line = getLine(doc, pos.line).text;
      var start = pos.ch, end = pos.ch;
      if (line) {
        var helper = this.getHelper(pos, "wordChars");
        if ((pos.sticky == "before" || end == line.length) && start) { --start; } else { ++end; }
        var startChar = line.charAt(start);
        var check = isWordChar(startChar, helper)
          ? function (ch) { return isWordChar(ch, helper); }
          : /\s/.test(startChar) ? function (ch) { return /\s/.test(ch); }
          : function (ch) { return (!/\s/.test(ch) && !isWordChar(ch)); };
        while (start > 0 && check(line.charAt(start - 1))) { --start; }
        while (end < line.length && check(line.charAt(end))) { ++end; }
      }
      return new Range(Pos(pos.line, start), Pos(pos.line, end))
    },

    toggleOverwrite: function(value) {
      if (value != null && value == this.state.overwrite) { return }
      if (this.state.overwrite = !this.state.overwrite)
        { addClass(this.display.cursorDiv, "CodeMirror-overwrite"); }
      else
        { rmClass(this.display.cursorDiv, "CodeMirror-overwrite"); }

      signal(this, "overwriteToggle", this, this.state.overwrite);
    },
    hasFocus: function() { return this.display.input.getField() == activeElt() },
    isReadOnly: function() { return !!(this.options.readOnly || this.doc.cantEdit) },

    scrollTo: methodOp(function (x, y) { scrollToCoords(this, x, y); }),
    getScrollInfo: function() {
      var scroller = this.display.scroller;
      return {left: scroller.scrollLeft, top: scroller.scrollTop,
              height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
              width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
              clientHeight: displayHeight(this), clientWidth: displayWidth(this)}
    },

    scrollIntoView: methodOp(function(range$$1, margin) {
      if (range$$1 == null) {
        range$$1 = {from: this.doc.sel.primary().head, to: null};
        if (margin == null) { margin = this.options.cursorScrollMargin; }
      } else if (typeof range$$1 == "number") {
        range$$1 = {from: Pos(range$$1, 0), to: null};
      } else if (range$$1.from == null) {
        range$$1 = {from: range$$1, to: null};
      }
      if (!range$$1.to) { range$$1.to = range$$1.from; }
      range$$1.margin = margin || 0;

      if (range$$1.from.line != null) {
        scrollToRange(this, range$$1);
      } else {
        scrollToCoordsRange(this, range$$1.from, range$$1.to, range$$1.margin);
      }
    }),

    setSize: methodOp(function(width, height) {
      var this$1 = this;

      var interpret = function (val) { return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val; };
      if (width != null) { this.display.wrapper.style.width = interpret(width); }
      if (height != null) { this.display.wrapper.style.height = interpret(height); }
      if (this.options.lineWrapping) { clearLineMeasurementCache(this); }
      var lineNo$$1 = this.display.viewFrom;
      this.doc.iter(lineNo$$1, this.display.viewTo, function (line) {
        if (line.widgets) { for (var i = 0; i < line.widgets.length; i++)
          { if (line.widgets[i].noHScroll) { regLineChange(this$1, lineNo$$1, "widget"); break } } }
        ++lineNo$$1;
      });
      this.curOp.forceUpdate = true;
      signal(this, "refresh", this);
    }),

    operation: function(f){return runInOp(this, f)},
    startOperation: function(){return startOperation(this)},
    endOperation: function(){return endOperation(this)},

    refresh: methodOp(function() {
      var oldHeight = this.display.cachedTextHeight;
      regChange(this);
      this.curOp.forceUpdate = true;
      clearCaches(this);
      scrollToCoords(this, this.doc.scrollLeft, this.doc.scrollTop);
      updateGutterSpace(this);
      if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > .5)
        { estimateLineHeights(this); }
      signal(this, "refresh", this);
    }),

    swapDoc: methodOp(function(doc) {
      var old = this.doc;
      old.cm = null;
      attachDoc(this, doc);
      clearCaches(this);
      this.display.input.reset();
      scrollToCoords(this, doc.scrollLeft, doc.scrollTop);
      this.curOp.forceScroll = true;
      signalLater(this, "swapDoc", this, old);
      return old
    }),

    getInputField: function(){return this.display.input.getField()},
    getWrapperElement: function(){return this.display.wrapper},
    getScrollerElement: function(){return this.display.scroller},
    getGutterElement: function(){return this.display.gutters}
  };
  eventMixin(CodeMirror);

  CodeMirror.registerHelper = function(type, name, value) {
    if (!helpers.hasOwnProperty(type)) { helpers[type] = CodeMirror[type] = {_global: []}; }
    helpers[type][name] = value;
  };
  CodeMirror.registerGlobalHelper = function(type, name, predicate, value) {
    CodeMirror.registerHelper(type, name, value);
    helpers[type]._global.push({pred: predicate, val: value});
  };
};

// Used for horizontal relative motion. Dir is -1 or 1 (left or
// right), unit can be "char", "column" (like char, but doesn't
// cross line boundaries), "word" (across next word), or "group" (to
// the start of next group of word or non-word-non-whitespace
// chars). The visually param controls whether, in right-to-left
// text, direction 1 means to move towards the next index in the
// string, or towards the character to the right of the current
// position. The resulting position will have a hitSide=true
// property if it reached the end of the document.
function findPosH(doc, pos, dir, unit, visually) {
  var oldPos = pos;
  var origDir = dir;
  var lineObj = getLine(doc, pos.line);
  function findNextLine() {
    var l = pos.line + dir;
    if (l < doc.first || l >= doc.first + doc.size) { return false }
    pos = new Pos(l, pos.ch, pos.sticky);
    return lineObj = getLine(doc, l)
  }
  function moveOnce(boundToLine) {
    var next;
    if (visually) {
      next = moveVisually(doc.cm, lineObj, pos, dir);
    } else {
      next = moveLogically(lineObj, pos, dir);
    }
    if (next == null) {
      if (!boundToLine && findNextLine())
        { pos = endOfLine(visually, doc.cm, lineObj, pos.line, dir); }
      else
        { return false }
    } else {
      pos = next;
    }
    return true
  }

  if (unit == "char") {
    moveOnce();
  } else if (unit == "column") {
    moveOnce(true);
  } else if (unit == "word" || unit == "group") {
    var sawType = null, group = unit == "group";
    var helper = doc.cm && doc.cm.getHelper(pos, "wordChars");
    for (var first = true;; first = false) {
      if (dir < 0 && !moveOnce(!first)) { break }
      var cur = lineObj.text.charAt(pos.ch) || "\n";
      var type = isWordChar(cur, helper) ? "w"
        : group && cur == "\n" ? "n"
        : !group || /\s/.test(cur) ? null
        : "p";
      if (group && !first && !type) { type = "s"; }
      if (sawType && sawType != type) {
        if (dir < 0) {dir = 1; moveOnce(); pos.sticky = "after";}
        break
      }

      if (type) { sawType = type; }
      if (dir > 0 && !moveOnce(!first)) { break }
    }
  }
  var result = skipAtomic(doc, pos, oldPos, origDir, true);
  if (equalCursorPos(oldPos, result)) { result.hitSide = true; }
  return result
}

// For relative vertical movement. Dir may be -1 or 1. Unit can be
// "page" or "line". The resulting position will have a hitSide=true
// property if it reached the end of the document.
function findPosV(cm, pos, dir, unit) {
  var doc = cm.doc, x = pos.left, y;
  if (unit == "page") {
    var pageSize = Math.min(cm.display.wrapper.clientHeight, window.innerHeight || document.documentElement.clientHeight);
    var moveAmount = Math.max(pageSize - .5 * textHeight(cm.display), 3);
    y = (dir > 0 ? pos.bottom : pos.top) + dir * moveAmount;

  } else if (unit == "line") {
    y = dir > 0 ? pos.bottom + 3 : pos.top - 3;
  }
  var target;
  for (;;) {
    target = coordsChar(cm, x, y);
    if (!target.outside) { break }
    if (dir < 0 ? y <= 0 : y >= doc.height) { target.hitSide = true; break }
    y += dir * 5;
  }
  return target
}

// CONTENTEDITABLE INPUT STYLE

var ContentEditableInput = function(cm) {
  this.cm = cm;
  this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null;
  this.polling = new Delayed();
  this.composing = null;
  this.gracePeriod = false;
  this.readDOMTimeout = null;
};

ContentEditableInput.prototype.init = function (display) {
    var this$1 = this;

  var input = this, cm = input.cm;
  var div = input.div = display.lineDiv;
  disableBrowserMagic(div, cm.options.spellcheck);

  on(div, "paste", function (e) {
    if (signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }
    // IE doesn't fire input events, so we schedule a read for the pasted content in this way
    if (ie_version <= 11) { setTimeout(operation(cm, function () { return this$1.updateFromDOM(); }), 20); }
  });

  on(div, "compositionstart", function (e) {
    this$1.composing = {data: e.data, done: false};
  });
  on(div, "compositionupdate", function (e) {
    if (!this$1.composing) { this$1.composing = {data: e.data, done: false}; }
  });
  on(div, "compositionend", function (e) {
    if (this$1.composing) {
      if (e.data != this$1.composing.data) { this$1.readFromDOMSoon(); }
      this$1.composing.done = true;
    }
  });

  on(div, "touchstart", function () { return input.forceCompositionEnd(); });

  on(div, "input", function () {
    if (!this$1.composing) { this$1.readFromDOMSoon(); }
  });

  function onCopyCut(e) {
    if (signalDOMEvent(cm, e)) { return }
    if (cm.somethingSelected()) {
      setLastCopied({lineWise: false, text: cm.getSelections()});
      if (e.type == "cut") { cm.replaceSelection("", null, "cut"); }
    } else if (!cm.options.lineWiseCopyCut) {
      return
    } else {
      var ranges = copyableRanges(cm);
      setLastCopied({lineWise: true, text: ranges.text});
      if (e.type == "cut") {
        cm.operation(function () {
          cm.setSelections(ranges.ranges, 0, sel_dontScroll);
          cm.replaceSelection("", null, "cut");
        });
      }
    }
    if (e.clipboardData) {
      e.clipboardData.clearData();
      var content = lastCopied.text.join("\n");
      // iOS exposes the clipboard API, but seems to discard content inserted into it
      e.clipboardData.setData("Text", content);
      if (e.clipboardData.getData("Text") == content) {
        e.preventDefault();
        return
      }
    }
    // Old-fashioned briefly-focus-a-textarea hack
    var kludge = hiddenTextarea(), te = kludge.firstChild;
    cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild);
    te.value = lastCopied.text.join("\n");
    var hadFocus = document.activeElement;
    selectInput(te);
    setTimeout(function () {
      cm.display.lineSpace.removeChild(kludge);
      hadFocus.focus();
      if (hadFocus == div) { input.showPrimarySelection(); }
    }, 50);
  }
  on(div, "copy", onCopyCut);
  on(div, "cut", onCopyCut);
};

ContentEditableInput.prototype.prepareSelection = function () {
  var result = prepareSelection(this.cm, false);
  result.focus = this.cm.state.focused;
  return result
};

ContentEditableInput.prototype.showSelection = function (info, takeFocus) {
  if (!info || !this.cm.display.view.length) { return }
  if (info.focus || takeFocus) { this.showPrimarySelection(); }
  this.showMultipleSelections(info);
};

ContentEditableInput.prototype.getSelection = function () {
  return this.cm.display.wrapper.ownerDocument.getSelection()
};

ContentEditableInput.prototype.showPrimarySelection = function () {
  var sel = this.getSelection(), cm = this.cm, prim = cm.doc.sel.primary();
  var from = prim.from(), to = prim.to();

  if (cm.display.viewTo == cm.display.viewFrom || from.line >= cm.display.viewTo || to.line < cm.display.viewFrom) {
    sel.removeAllRanges();
    return
  }

  var curAnchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
  var curFocus = domToPos(cm, sel.focusNode, sel.focusOffset);
  if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad &&
      cmp(minPos(curAnchor, curFocus), from) == 0 &&
      cmp(maxPos(curAnchor, curFocus), to) == 0)
    { return }

  var view = cm.display.view;
  var start = (from.line >= cm.display.viewFrom && posToDOM(cm, from)) ||
      {node: view[0].measure.map[2], offset: 0};
  var end = to.line < cm.display.viewTo && posToDOM(cm, to);
  if (!end) {
    var measure = view[view.length - 1].measure;
    var map$$1 = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map;
    end = {node: map$$1[map$$1.length - 1], offset: map$$1[map$$1.length - 2] - map$$1[map$$1.length - 3]};
  }

  if (!start || !end) {
    sel.removeAllRanges();
    return
  }

  var old = sel.rangeCount && sel.getRangeAt(0), rng;
  try { rng = range(start.node, start.offset, end.offset, end.node); }
  catch(e) {} // Our model of the DOM might be outdated, in which case the range we try to set can be impossible
  if (rng) {
    if (!gecko && cm.state.focused) {
      sel.collapse(start.node, start.offset);
      if (!rng.collapsed) {
        sel.removeAllRanges();
        sel.addRange(rng);
      }
    } else {
      sel.removeAllRanges();
      sel.addRange(rng);
    }
    if (old && sel.anchorNode == null) { sel.addRange(old); }
    else if (gecko) { this.startGracePeriod(); }
  }
  this.rememberSelection();
};

ContentEditableInput.prototype.startGracePeriod = function () {
    var this$1 = this;

  clearTimeout(this.gracePeriod);
  this.gracePeriod = setTimeout(function () {
    this$1.gracePeriod = false;
    if (this$1.selectionChanged())
      { this$1.cm.operation(function () { return this$1.cm.curOp.selectionChanged = true; }); }
  }, 20);
};

ContentEditableInput.prototype.showMultipleSelections = function (info) {
  removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors);
  removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection);
};

ContentEditableInput.prototype.rememberSelection = function () {
  var sel = this.getSelection();
  this.lastAnchorNode = sel.anchorNode; this.lastAnchorOffset = sel.anchorOffset;
  this.lastFocusNode = sel.focusNode; this.lastFocusOffset = sel.focusOffset;
};

ContentEditableInput.prototype.selectionInEditor = function () {
  var sel = this.getSelection();
  if (!sel.rangeCount) { return false }
  var node = sel.getRangeAt(0).commonAncestorContainer;
  return contains(this.div, node)
};

ContentEditableInput.prototype.focus = function () {
  if (this.cm.options.readOnly != "nocursor") {
    if (!this.selectionInEditor())
      { this.showSelection(this.prepareSelection(), true); }
    this.div.focus();
  }
};
ContentEditableInput.prototype.blur = function () { this.div.blur(); };
ContentEditableInput.prototype.getField = function () { return this.div };

ContentEditableInput.prototype.supportsTouch = function () { return true };

ContentEditableInput.prototype.receivedFocus = function () {
  var input = this;
  if (this.selectionInEditor())
    { this.pollSelection(); }
  else
    { runInOp(this.cm, function () { return input.cm.curOp.selectionChanged = true; }); }

  function poll() {
    if (input.cm.state.focused) {
      input.pollSelection();
      input.polling.set(input.cm.options.pollInterval, poll);
    }
  }
  this.polling.set(this.cm.options.pollInterval, poll);
};

ContentEditableInput.prototype.selectionChanged = function () {
  var sel = this.getSelection();
  return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset ||
    sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset
};

ContentEditableInput.prototype.pollSelection = function () {
  if (this.readDOMTimeout != null || this.gracePeriod || !this.selectionChanged()) { return }
  var sel = this.getSelection(), cm = this.cm;
  // On Android Chrome (version 56, at least), backspacing into an
  // uneditable block element will put the cursor in that element,
  // and then, because it's not editable, hide the virtual keyboard.
  // Because Android doesn't allow us to actually detect backspace
  // presses in a sane way, this code checks for when that happens
  // and simulates a backspace press in this case.
  if (android && chrome && this.cm.options.gutters.length && isInGutter(sel.anchorNode)) {
    this.cm.triggerOnKeyDown({type: "keydown", keyCode: 8, preventDefault: Math.abs});
    this.blur();
    this.focus();
    return
  }
  if (this.composing) { return }
  this.rememberSelection();
  var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
  var head = domToPos(cm, sel.focusNode, sel.focusOffset);
  if (anchor && head) { runInOp(cm, function () {
    setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll);
    if (anchor.bad || head.bad) { cm.curOp.selectionChanged = true; }
  }); }
};

ContentEditableInput.prototype.pollContent = function () {
  if (this.readDOMTimeout != null) {
    clearTimeout(this.readDOMTimeout);
    this.readDOMTimeout = null;
  }

  var cm = this.cm, display = cm.display, sel = cm.doc.sel.primary();
  var from = sel.from(), to = sel.to();
  if (from.ch == 0 && from.line > cm.firstLine())
    { from = Pos(from.line - 1, getLine(cm.doc, from.line - 1).length); }
  if (to.ch == getLine(cm.doc, to.line).text.length && to.line < cm.lastLine())
    { to = Pos(to.line + 1, 0); }
  if (from.line < display.viewFrom || to.line > display.viewTo - 1) { return false }

  var fromIndex, fromLine, fromNode;
  if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
    fromLine = lineNo(display.view[0].line);
    fromNode = display.view[0].node;
  } else {
    fromLine = lineNo(display.view[fromIndex].line);
    fromNode = display.view[fromIndex - 1].node.nextSibling;
  }
  var toIndex = findViewIndex(cm, to.line);
  var toLine, toNode;
  if (toIndex == display.view.length - 1) {
    toLine = display.viewTo - 1;
    toNode = display.lineDiv.lastChild;
  } else {
    toLine = lineNo(display.view[toIndex + 1].line) - 1;
    toNode = display.view[toIndex + 1].node.previousSibling;
  }

  if (!fromNode) { return false }
  var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine));
  var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length));
  while (newText.length > 1 && oldText.length > 1) {
    if (lst(newText) == lst(oldText)) { newText.pop(); oldText.pop(); toLine--; }
    else if (newText[0] == oldText[0]) { newText.shift(); oldText.shift(); fromLine++; }
    else { break }
  }

  var cutFront = 0, cutEnd = 0;
  var newTop = newText[0], oldTop = oldText[0], maxCutFront = Math.min(newTop.length, oldTop.length);
  while (cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront))
    { ++cutFront; }
  var newBot = lst(newText), oldBot = lst(oldText);
  var maxCutEnd = Math.min(newBot.length - (newText.length == 1 ? cutFront : 0),
                           oldBot.length - (oldText.length == 1 ? cutFront : 0));
  while (cutEnd < maxCutEnd &&
         newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1))
    { ++cutEnd; }
  // Try to move start of change to start of selection if ambiguous
  if (newText.length == 1 && oldText.length == 1 && fromLine == from.line) {
    while (cutFront && cutFront > from.ch &&
           newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)) {
      cutFront--;
      cutEnd++;
    }
  }

  newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd).replace(/^\u200b+/, "");
  newText[0] = newText[0].slice(cutFront).replace(/\u200b+$/, "");

  var chFrom = Pos(fromLine, cutFront);
  var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0);
  if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
    replaceRange(cm.doc, newText, chFrom, chTo, "+input");
    return true
  }
};

ContentEditableInput.prototype.ensurePolled = function () {
  this.forceCompositionEnd();
};
ContentEditableInput.prototype.reset = function () {
  this.forceCompositionEnd();
};
ContentEditableInput.prototype.forceCompositionEnd = function () {
  if (!this.composing) { return }
  clearTimeout(this.readDOMTimeout);
  this.composing = null;
  this.updateFromDOM();
  this.div.blur();
  this.div.focus();
};
ContentEditableInput.prototype.readFromDOMSoon = function () {
    var this$1 = this;

  if (this.readDOMTimeout != null) { return }
  this.readDOMTimeout = setTimeout(function () {
    this$1.readDOMTimeout = null;
    if (this$1.composing) {
      if (this$1.composing.done) { this$1.composing = null; }
      else { return }
    }
    this$1.updateFromDOM();
  }, 80);
};

ContentEditableInput.prototype.updateFromDOM = function () {
    var this$1 = this;

  if (this.cm.isReadOnly() || !this.pollContent())
    { runInOp(this.cm, function () { return regChange(this$1.cm); }); }
};

ContentEditableInput.prototype.setUneditable = function (node) {
  node.contentEditable = "false";
};

ContentEditableInput.prototype.onKeyPress = function (e) {
  if (e.charCode == 0 || this.composing) { return }
  e.preventDefault();
  if (!this.cm.isReadOnly())
    { operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0); }
};

ContentEditableInput.prototype.readOnlyChanged = function (val) {
  this.div.contentEditable = String(val != "nocursor");
};

ContentEditableInput.prototype.onContextMenu = function () {};
ContentEditableInput.prototype.resetPosition = function () {};

ContentEditableInput.prototype.needsContentAttribute = true;

function posToDOM(cm, pos) {
  var view = findViewForLine(cm, pos.line);
  if (!view || view.hidden) { return null }
  var line = getLine(cm.doc, pos.line);
  var info = mapFromLineView(view, line, pos.line);

  var order = getOrder(line, cm.doc.direction), side = "left";
  if (order) {
    var partPos = getBidiPartAt(order, pos.ch);
    side = partPos % 2 ? "right" : "left";
  }
  var result = nodeAndOffsetInLineMap(info.map, pos.ch, side);
  result.offset = result.collapse == "right" ? result.end : result.start;
  return result
}

function isInGutter(node) {
  for (var scan = node; scan; scan = scan.parentNode)
    { if (/CodeMirror-gutter-wrapper/.test(scan.className)) { return true } }
  return false
}

function badPos(pos, bad) { if (bad) { pos.bad = true; } return pos }

function domTextBetween(cm, from, to, fromLine, toLine) {
  var text = "", closing = false, lineSep = cm.doc.lineSeparator(), extraLinebreak = false;
  function recognizeMarker(id) { return function (marker) { return marker.id == id; } }
  function close() {
    if (closing) {
      text += lineSep;
      if (extraLinebreak) { text += lineSep; }
      closing = extraLinebreak = false;
    }
  }
  function addText(str) {
    if (str) {
      close();
      text += str;
    }
  }
  function walk(node) {
    if (node.nodeType == 1) {
      var cmText = node.getAttribute("cm-text");
      if (cmText) {
        addText(cmText);
        return
      }
      var markerID = node.getAttribute("cm-marker"), range$$1;
      if (markerID) {
        var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID));
        if (found.length && (range$$1 = found[0].find(0)))
          { addText(getBetween(cm.doc, range$$1.from, range$$1.to).join(lineSep)); }
        return
      }
      if (node.getAttribute("contenteditable") == "false") { return }
      var isBlock = /^(pre|div|p|li|table|br)$/i.test(node.nodeName);
      if (!/^br$/i.test(node.nodeName) && node.textContent.length == 0) { return }

      if (isBlock) { close(); }
      for (var i = 0; i < node.childNodes.length; i++)
        { walk(node.childNodes[i]); }

      if (/^(pre|p)$/i.test(node.nodeName)) { extraLinebreak = true; }
      if (isBlock) { closing = true; }
    } else if (node.nodeType == 3) {
      addText(node.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
    }
  }
  for (;;) {
    walk(from);
    if (from == to) { break }
    from = from.nextSibling;
    extraLinebreak = false;
  }
  return text
}

function domToPos(cm, node, offset) {
  var lineNode;
  if (node == cm.display.lineDiv) {
    lineNode = cm.display.lineDiv.childNodes[offset];
    if (!lineNode) { return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true) }
    node = null; offset = 0;
  } else {
    for (lineNode = node;; lineNode = lineNode.parentNode) {
      if (!lineNode || lineNode == cm.display.lineDiv) { return null }
      if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) { break }
    }
  }
  for (var i = 0; i < cm.display.view.length; i++) {
    var lineView = cm.display.view[i];
    if (lineView.node == lineNode)
      { return locateNodeInLineView(lineView, node, offset) }
  }
}

function locateNodeInLineView(lineView, node, offset) {
  var wrapper = lineView.text.firstChild, bad = false;
  if (!node || !contains(wrapper, node)) { return badPos(Pos(lineNo(lineView.line), 0), true) }
  if (node == wrapper) {
    bad = true;
    node = wrapper.childNodes[offset];
    offset = 0;
    if (!node) {
      var line = lineView.rest ? lst(lineView.rest) : lineView.line;
      return badPos(Pos(lineNo(line), line.text.length), bad)
    }
  }

  var textNode = node.nodeType == 3 ? node : null, topNode = node;
  if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
    textNode = node.firstChild;
    if (offset) { offset = textNode.nodeValue.length; }
  }
  while (topNode.parentNode != wrapper) { topNode = topNode.parentNode; }
  var measure = lineView.measure, maps = measure.maps;

  function find(textNode, topNode, offset) {
    for (var i = -1; i < (maps ? maps.length : 0); i++) {
      var map$$1 = i < 0 ? measure.map : maps[i];
      for (var j = 0; j < map$$1.length; j += 3) {
        var curNode = map$$1[j + 2];
        if (curNode == textNode || curNode == topNode) {
          var line = lineNo(i < 0 ? lineView.line : lineView.rest[i]);
          var ch = map$$1[j] + offset;
          if (offset < 0 || curNode != textNode) { ch = map$$1[j + (offset ? 1 : 0)]; }
          return Pos(line, ch)
        }
      }
    }
  }
  var found = find(textNode, topNode, offset);
  if (found) { return badPos(found, bad) }

  // FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
  for (var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling) {
    found = find(after, after.firstChild, 0);
    if (found)
      { return badPos(Pos(found.line, found.ch - dist), bad) }
    else
      { dist += after.textContent.length; }
  }
  for (var before = topNode.previousSibling, dist$1 = offset; before; before = before.previousSibling) {
    found = find(before, before.firstChild, -1);
    if (found)
      { return badPos(Pos(found.line, found.ch + dist$1), bad) }
    else
      { dist$1 += before.textContent.length; }
  }
}

// TEXTAREA INPUT STYLE

var TextareaInput = function(cm) {
  this.cm = cm;
  // See input.poll and input.reset
  this.prevInput = "";

  // Flag that indicates whether we expect input to appear real soon
  // now (after some event like 'keypress' or 'input') and are
  // polling intensively.
  this.pollingFast = false;
  // Self-resetting timeout for the poller
  this.polling = new Delayed();
  // Used to work around IE issue with selection being forgotten when focus moves away from textarea
  this.hasSelection = false;
  this.composing = null;
};

TextareaInput.prototype.init = function (display) {
    var this$1 = this;

  var input = this, cm = this.cm;
  this.createField(display);
  var te = this.textarea;

  display.wrapper.insertBefore(this.wrapper, display.wrapper.firstChild);

  // Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
  if (ios) { te.style.width = "0px"; }

  on(te, "input", function () {
    if (ie && ie_version >= 9 && this$1.hasSelection) { this$1.hasSelection = null; }
    input.poll();
  });

  on(te, "paste", function (e) {
    if (signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }

    cm.state.pasteIncoming = true;
    input.fastPoll();
  });

  function prepareCopyCut(e) {
    if (signalDOMEvent(cm, e)) { return }
    if (cm.somethingSelected()) {
      setLastCopied({lineWise: false, text: cm.getSelections()});
    } else if (!cm.options.lineWiseCopyCut) {
      return
    } else {
      var ranges = copyableRanges(cm);
      setLastCopied({lineWise: true, text: ranges.text});
      if (e.type == "cut") {
        cm.setSelections(ranges.ranges, null, sel_dontScroll);
      } else {
        input.prevInput = "";
        te.value = ranges.text.join("\n");
        selectInput(te);
      }
    }
    if (e.type == "cut") { cm.state.cutIncoming = true; }
  }
  on(te, "cut", prepareCopyCut);
  on(te, "copy", prepareCopyCut);

  on(display.scroller, "paste", function (e) {
    if (eventInWidget(display, e) || signalDOMEvent(cm, e)) { return }
    cm.state.pasteIncoming = true;
    input.focus();
  });

  // Prevent normal selection in the editor (we handle our own)
  on(display.lineSpace, "selectstart", function (e) {
    if (!eventInWidget(display, e)) { e_preventDefault(e); }
  });

  on(te, "compositionstart", function () {
    var start = cm.getCursor("from");
    if (input.composing) { input.composing.range.clear(); }
    input.composing = {
      start: start,
      range: cm.markText(start, cm.getCursor("to"), {className: "CodeMirror-composing"})
    };
  });
  on(te, "compositionend", function () {
    if (input.composing) {
      input.poll();
      input.composing.range.clear();
      input.composing = null;
    }
  });
};

TextareaInput.prototype.createField = function (_display) {
  // Wraps and hides input textarea
  this.wrapper = hiddenTextarea();
  // The semihidden textarea that is focused when the editor is
  // focused, and receives input.
  this.textarea = this.wrapper.firstChild;
};

TextareaInput.prototype.prepareSelection = function () {
  // Redraw the selection and/or cursor
  var cm = this.cm, display = cm.display, doc = cm.doc;
  var result = prepareSelection(cm);

  // Move the hidden textarea near the cursor to prevent scrolling artifacts
  if (cm.options.moveInputWithCursor) {
    var headPos = cursorCoords(cm, doc.sel.primary().head, "div");
    var wrapOff = display.wrapper.getBoundingClientRect(), lineOff = display.lineDiv.getBoundingClientRect();
    result.teTop = Math.max(0, Math.min(display.wrapper.clientHeight - 10,
                                        headPos.top + lineOff.top - wrapOff.top));
    result.teLeft = Math.max(0, Math.min(display.wrapper.clientWidth - 10,
                                         headPos.left + lineOff.left - wrapOff.left));
  }

  return result
};

TextareaInput.prototype.showSelection = function (drawn) {
  var cm = this.cm, display = cm.display;
  removeChildrenAndAdd(display.cursorDiv, drawn.cursors);
  removeChildrenAndAdd(display.selectionDiv, drawn.selection);
  if (drawn.teTop != null) {
    this.wrapper.style.top = drawn.teTop + "px";
    this.wrapper.style.left = drawn.teLeft + "px";
  }
};

// Reset the input to correspond to the selection (or to be empty,
// when not typing and nothing is selected)
TextareaInput.prototype.reset = function (typing) {
  if (this.contextMenuPending || this.composing) { return }
  var cm = this.cm;
  if (cm.somethingSelected()) {
    this.prevInput = "";
    var content = cm.getSelection();
    this.textarea.value = content;
    if (cm.state.focused) { selectInput(this.textarea); }
    if (ie && ie_version >= 9) { this.hasSelection = content; }
  } else if (!typing) {
    this.prevInput = this.textarea.value = "";
    if (ie && ie_version >= 9) { this.hasSelection = null; }
  }
};

TextareaInput.prototype.getField = function () { return this.textarea };

TextareaInput.prototype.supportsTouch = function () { return false };

TextareaInput.prototype.focus = function () {
  if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt() != this.textarea)) {
    try { this.textarea.focus(); }
    catch (e) {} // IE8 will throw if the textarea is display: none or not in DOM
  }
};

TextareaInput.prototype.blur = function () { this.textarea.blur(); };

TextareaInput.prototype.resetPosition = function () {
  this.wrapper.style.top = this.wrapper.style.left = 0;
};

TextareaInput.prototype.receivedFocus = function () { this.slowPoll(); };

// Poll for input changes, using the normal rate of polling. This
// runs as long as the editor is focused.
TextareaInput.prototype.slowPoll = function () {
    var this$1 = this;

  if (this.pollingFast) { return }
  this.polling.set(this.cm.options.pollInterval, function () {
    this$1.poll();
    if (this$1.cm.state.focused) { this$1.slowPoll(); }
  });
};

// When an event has just come in that is likely to add or change
// something in the input textarea, we poll faster, to ensure that
// the change appears on the screen quickly.
TextareaInput.prototype.fastPoll = function () {
  var missed = false, input = this;
  input.pollingFast = true;
  function p() {
    var changed = input.poll();
    if (!changed && !missed) {missed = true; input.polling.set(60, p);}
    else {input.pollingFast = false; input.slowPoll();}
  }
  input.polling.set(20, p);
};

// Read input from the textarea, and update the document to match.
// When something is selected, it is present in the textarea, and
// selected (unless it is huge, in which case a placeholder is
// used). When nothing is selected, the cursor sits after previously
// seen text (can be empty), which is stored in prevInput (we must
// not reset the textarea when typing, because that breaks IME).
TextareaInput.prototype.poll = function () {
    var this$1 = this;

  var cm = this.cm, input = this.textarea, prevInput = this.prevInput;
  // Since this is called a *lot*, try to bail out as cheaply as
  // possible when it is clear that nothing happened. hasSelection
  // will be the case when there is a lot of text in the textarea,
  // in which case reading its value would be expensive.
  if (this.contextMenuPending || !cm.state.focused ||
      (hasSelection(input) && !prevInput && !this.composing) ||
      cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq)
    { return false }

  var text = input.value;
  // If nothing changed, bail.
  if (text == prevInput && !cm.somethingSelected()) { return false }
  // Work around nonsensical selection resetting in IE9/10, and
  // inexplicable appearance of private area unicode characters on
  // some key combos in Mac (#2689).
  if (ie && ie_version >= 9 && this.hasSelection === text ||
      mac && /[\uf700-\uf7ff]/.test(text)) {
    cm.display.input.reset();
    return false
  }

  if (cm.doc.sel == cm.display.selForContextMenu) {
    var first = text.charCodeAt(0);
    if (first == 0x200b && !prevInput) { prevInput = "\u200b"; }
    if (first == 0x21da) { this.reset(); return this.cm.execCommand("undo") }
  }
  // Find the part of the input that is actually new
  var same = 0, l = Math.min(prevInput.length, text.length);
  while (same < l && prevInput.charCodeAt(same) == text.charCodeAt(same)) { ++same; }

  runInOp(cm, function () {
    applyTextInput(cm, text.slice(same), prevInput.length - same,
                   null, this$1.composing ? "*compose" : null);

    // Don't leave long text in the textarea, since it makes further polling slow
    if (text.length > 1000 || text.indexOf("\n") > -1) { input.value = this$1.prevInput = ""; }
    else { this$1.prevInput = text; }

    if (this$1.composing) {
      this$1.composing.range.clear();
      this$1.composing.range = cm.markText(this$1.composing.start, cm.getCursor("to"),
                                         {className: "CodeMirror-composing"});
    }
  });
  return true
};

TextareaInput.prototype.ensurePolled = function () {
  if (this.pollingFast && this.poll()) { this.pollingFast = false; }
};

TextareaInput.prototype.onKeyPress = function () {
  if (ie && ie_version >= 9) { this.hasSelection = null; }
  this.fastPoll();
};

TextareaInput.prototype.onContextMenu = function (e) {
  var input = this, cm = input.cm, display = cm.display, te = input.textarea;
  var pos = posFromMouse(cm, e), scrollPos = display.scroller.scrollTop;
  if (!pos || presto) { return } // Opera is difficult.

  // Reset the current text selection only if the click is done outside of the selection
  // and 'resetSelectionOnContextMenu' option is true.
  var reset = cm.options.resetSelectionOnContextMenu;
  if (reset && cm.doc.sel.contains(pos) == -1)
    { operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll); }

  var oldCSS = te.style.cssText, oldWrapperCSS = input.wrapper.style.cssText;
  input.wrapper.style.cssText = "position: absolute";
  var wrapperBox = input.wrapper.getBoundingClientRect();
  te.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - wrapperBox.top - 5) + "px; left: " + (e.clientX - wrapperBox.left - 5) + "px;\n      z-index: 1000; background: " + (ie ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);";
  var oldScrollY;
  if (webkit) { oldScrollY = window.scrollY; } // Work around Chrome issue (#2712)
  display.input.focus();
  if (webkit) { window.scrollTo(null, oldScrollY); }
  display.input.reset();
  // Adds "Select all" to context menu in FF
  if (!cm.somethingSelected()) { te.value = input.prevInput = " "; }
  input.contextMenuPending = true;
  display.selForContextMenu = cm.doc.sel;
  clearTimeout(display.detectingSelectAll);

  // Select-all will be greyed out if there's nothing to select, so
  // this adds a zero-width space so that we can later check whether
  // it got selected.
  function prepareSelectAllHack() {
    if (te.selectionStart != null) {
      var selected = cm.somethingSelected();
      var extval = "\u200b" + (selected ? te.value : "");
      te.value = "\u21da"; // Used to catch context-menu undo
      te.value = extval;
      input.prevInput = selected ? "" : "\u200b";
      te.selectionStart = 1; te.selectionEnd = extval.length;
      // Re-set this, in case some other handler touched the
      // selection in the meantime.
      display.selForContextMenu = cm.doc.sel;
    }
  }
  function rehide() {
    input.contextMenuPending = false;
    input.wrapper.style.cssText = oldWrapperCSS;
    te.style.cssText = oldCSS;
    if (ie && ie_version < 9) { display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos); }

    // Try to detect the user choosing select-all
    if (te.selectionStart != null) {
      if (!ie || (ie && ie_version < 9)) { prepareSelectAllHack(); }
      var i = 0, poll = function () {
        if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 &&
            te.selectionEnd > 0 && input.prevInput == "\u200b") {
          operation(cm, selectAll)(cm);
        } else if (i++ < 10) {
          display.detectingSelectAll = setTimeout(poll, 500);
        } else {
          display.selForContextMenu = null;
          display.input.reset();
        }
      };
      display.detectingSelectAll = setTimeout(poll, 200);
    }
  }

  if (ie && ie_version >= 9) { prepareSelectAllHack(); }
  if (captureRightClick) {
    e_stop(e);
    var mouseup = function () {
      off(window, "mouseup", mouseup);
      setTimeout(rehide, 20);
    };
    on(window, "mouseup", mouseup);
  } else {
    setTimeout(rehide, 50);
  }
};

TextareaInput.prototype.readOnlyChanged = function (val) {
  if (!val) { this.reset(); }
  this.textarea.disabled = val == "nocursor";
};

TextareaInput.prototype.setUneditable = function () {};

TextareaInput.prototype.needsContentAttribute = false;

function fromTextArea(textarea, options) {
  options = options ? copyObj(options) : {};
  options.value = textarea.value;
  if (!options.tabindex && textarea.tabIndex)
    { options.tabindex = textarea.tabIndex; }
  if (!options.placeholder && textarea.placeholder)
    { options.placeholder = textarea.placeholder; }
  // Set autofocus to true if this textarea is focused, or if it has
  // autofocus and no other element is focused.
  if (options.autofocus == null) {
    var hasFocus = activeElt();
    options.autofocus = hasFocus == textarea ||
      textarea.getAttribute("autofocus") != null && hasFocus == document.body;
  }

  function save() {textarea.value = cm.getValue();}

  var realSubmit;
  if (textarea.form) {
    on(textarea.form, "submit", save);
    // Deplorable hack to make the submit method do the right thing.
    if (!options.leaveSubmitMethodAlone) {
      var form = textarea.form;
      realSubmit = form.submit;
      try {
        var wrappedSubmit = form.submit = function () {
          save();
          form.submit = realSubmit;
          form.submit();
          form.submit = wrappedSubmit;
        };
      } catch(e) {}
    }
  }

  options.finishInit = function (cm) {
    cm.save = save;
    cm.getTextArea = function () { return textarea; };
    cm.toTextArea = function () {
      cm.toTextArea = isNaN; // Prevent this from being ran twice
      save();
      textarea.parentNode.removeChild(cm.getWrapperElement());
      textarea.style.display = "";
      if (textarea.form) {
        off(textarea.form, "submit", save);
        if (typeof textarea.form.submit == "function")
          { textarea.form.submit = realSubmit; }
      }
    };
  };

  textarea.style.display = "none";
  var cm = CodeMirror$1(function (node) { return textarea.parentNode.insertBefore(node, textarea.nextSibling); },
    options);
  return cm
}

function addLegacyProps(CodeMirror) {
  CodeMirror.off = off;
  CodeMirror.on = on;
  CodeMirror.wheelEventPixels = wheelEventPixels;
  CodeMirror.Doc = Doc;
  CodeMirror.splitLines = splitLinesAuto;
  CodeMirror.countColumn = countColumn;
  CodeMirror.findColumn = findColumn;
  CodeMirror.isWordChar = isWordCharBasic;
  CodeMirror.Pass = Pass;
  CodeMirror.signal = signal;
  CodeMirror.Line = Line;
  CodeMirror.changeEnd = changeEnd;
  CodeMirror.scrollbarModel = scrollbarModel;
  CodeMirror.Pos = Pos;
  CodeMirror.cmpPos = cmp;
  CodeMirror.modes = modes;
  CodeMirror.mimeModes = mimeModes;
  CodeMirror.resolveMode = resolveMode;
  CodeMirror.getMode = getMode;
  CodeMirror.modeExtensions = modeExtensions;
  CodeMirror.extendMode = extendMode;
  CodeMirror.copyState = copyState;
  CodeMirror.startState = startState;
  CodeMirror.innerMode = innerMode;
  CodeMirror.commands = commands;
  CodeMirror.keyMap = keyMap;
  CodeMirror.keyName = keyName;
  CodeMirror.isModifierKey = isModifierKey;
  CodeMirror.lookupKey = lookupKey;
  CodeMirror.normalizeKeyMap = normalizeKeyMap;
  CodeMirror.StringStream = StringStream;
  CodeMirror.SharedTextMarker = SharedTextMarker;
  CodeMirror.TextMarker = TextMarker;
  CodeMirror.LineWidget = LineWidget;
  CodeMirror.e_preventDefault = e_preventDefault;
  CodeMirror.e_stopPropagation = e_stopPropagation;
  CodeMirror.e_stop = e_stop;
  CodeMirror.addClass = addClass;
  CodeMirror.contains = contains;
  CodeMirror.rmClass = rmClass;
  CodeMirror.keyNames = keyNames;
}

// EDITOR CONSTRUCTOR

defineOptions(CodeMirror$1);

addEditorMethods(CodeMirror$1);

// Set up methods on CodeMirror's prototype to redirect to the editor's document.
var dontDelegate = "iter insert remove copy getEditor constructor".split(" ");
for (var prop in Doc.prototype) { if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0)
  { CodeMirror$1.prototype[prop] = (function(method) {
    return function() {return method.apply(this.doc, arguments)}
  })(Doc.prototype[prop]); } }

eventMixin(Doc);

// INPUT HANDLING

CodeMirror$1.inputStyles = {"textarea": TextareaInput, "contenteditable": ContentEditableInput};

// MODE DEFINITION AND QUERYING

// Extra arguments are stored as the mode's dependencies, which is
// used by (legacy) mechanisms like loadmode.js to automatically
// load a mode. (Preferred mechanism is the require/define calls.)
CodeMirror$1.defineMode = function(name/*, mode, …*/) {
  if (!CodeMirror$1.defaults.mode && name != "null") { CodeMirror$1.defaults.mode = name; }
  defineMode.apply(this, arguments);
};

CodeMirror$1.defineMIME = defineMIME;

// Minimal default mode.
CodeMirror$1.defineMode("null", function () { return ({token: function (stream) { return stream.skipToEnd(); }}); });
CodeMirror$1.defineMIME("text/plain", "null");

// EXTENSIONS

CodeMirror$1.defineExtension = function (name, func) {
  CodeMirror$1.prototype[name] = func;
};
CodeMirror$1.defineDocExtension = function (name, func) {
  Doc.prototype[name] = func;
};

CodeMirror$1.fromTextArea = fromTextArea;

addLegacyProps(CodeMirror$1);

CodeMirror$1.version = "5.38.0";

return CodeMirror$1;

})));


/***/ }),
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(156);
var isObject = __webpack_require__(132);
var newPromiseCapability = __webpack_require__(449);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 660 */,
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(99);
var core = __webpack_require__(77);
var dP = __webpack_require__(141);
var DESCRIPTORS = __webpack_require__(158);
var SPECIES = __webpack_require__(104)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(156);
var aFunction = __webpack_require__(282);
var SPECIES = __webpack_require__(104)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(157);
var invoke = __webpack_require__(1467);
var html = __webpack_require__(647);
var cel = __webpack_require__(444);
var global = __webpack_require__(99);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(283)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(132);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(60);
var gOPD = __webpack_require__(112);
var ownKeys = __webpack_require__(476);
var toIObject = __webpack_require__(100);

module.exports = function define(target, mixin) {
  var keys = ownKeys(toIObject(mixin));
  var length = keys.length;
  var i = 0;
  var key;
  while (length > i) dP.f(target, key = keys[i++], gOPD.f(mixin, key));
  return target;
};


/***/ }),
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var path = __webpack_require__(689);
var invoke = __webpack_require__(468);
var aFunction = __webpack_require__(89);
module.exports = function (/* ...pargs */) {
  var fn = aFunction(this);
  var length = arguments.length;
  var pargs = new Array(length);
  var i = 0;
  var _ = path._;
  var holder = false;
  while (length > i) if ((pargs[i] = arguments[i++]) === _) holder = true;
  return function (/* ...args */) {
    var that = this;
    var aLen = arguments.length;
    var j = 0;
    var k = 0;
    var args;
    if (!holder && !aLen) return invoke(fn, pargs, that);
    args = pargs.slice();
    if (holder) for (;length > j; j++) if (args[j] === _) args[j] = arguments[k++];
    while (aLen > k) args.push(arguments[k++]);
    return invoke(fn, args, that);
  };
};


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(37);


/***/ }),
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(210);
var ITERATOR = __webpack_require__(54)('iterator');
var Iterators = __webpack_require__(211);
module.exports = __webpack_require__(82).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule BlockTree
 * @format
 * 
 */



var Immutable = __webpack_require__(45);

var emptyFunction = __webpack_require__(103);
var findRangesImmutable = __webpack_require__(300);

var List = Immutable.List,
    Repeat = Immutable.Repeat,
    Record = Immutable.Record;


var returnTrue = emptyFunction.thatReturnsTrue;

var FINGERPRINT_DELIMITER = '-';

var defaultLeafRange = {
  start: null,
  end: null
};

var LeafRange = Record(defaultLeafRange);

var defaultDecoratorRange = {
  start: null,
  end: null,
  decoratorKey: null,
  leaves: null
};

var DecoratorRange = Record(defaultDecoratorRange);

var BlockTree = {
  /**
   * Generate a block tree for a given ContentBlock/decorator pair.
   */
  generate: function generate(contentState, block, decorator) {
    var textLength = block.getLength();
    if (!textLength) {
      return List.of(new DecoratorRange({
        start: 0,
        end: 0,
        decoratorKey: null,
        leaves: List.of(new LeafRange({ start: 0, end: 0 }))
      }));
    }

    var leafSets = [];
    var decorations = decorator ? decorator.getDecorations(block, contentState) : List(Repeat(null, textLength));

    var chars = block.getCharacterList();

    findRangesImmutable(decorations, areEqual, returnTrue, function (start, end) {
      leafSets.push(new DecoratorRange({
        start: start,
        end: end,
        decoratorKey: decorations.get(start),
        leaves: generateLeaves(chars.slice(start, end).toList(), start)
      }));
    });

    return List(leafSets);
  },

  /**
   * Create a string representation of the given tree map. This allows us
   * to rapidly determine whether a tree has undergone a significant
   * structural change.
   */
  getFingerprint: function getFingerprint(tree) {
    return tree.map(function (leafSet) {
      var decoratorKey = leafSet.get('decoratorKey');
      var fingerprintString = decoratorKey !== null ? decoratorKey + '.' + (leafSet.get('end') - leafSet.get('start')) : '';
      return '' + fingerprintString + '.' + leafSet.get('leaves').size;
    }).join(FINGERPRINT_DELIMITER);
  }
};

/**
 * Generate LeafRange records for a given character list.
 */
function generateLeaves(characters, offset) {
  var leaves = [];
  var inlineStyles = characters.map(function (c) {
    return c.getStyle();
  }).toList();
  findRangesImmutable(inlineStyles, areEqual, returnTrue, function (start, end) {
    leaves.push(new LeafRange({
      start: start + offset,
      end: end + offset
    }));
  });
  return List(leaves);
}

function areEqual(a, b) {
  return a === b;
}

module.exports = BlockTree;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DefaultDraftInlineStyle
 * @format
 * 
 */



module.exports = {
  BOLD: {
    fontWeight: 'bold'
  },

  CODE: {
    fontFamily: 'monospace',
    wordWrap: 'break-word'
  },

  ITALIC: {
    fontStyle: 'italic'
  },

  STRIKETHROUGH: {
    textDecoration: 'line-through'
  },

  UNDERLINE: {
    textDecoration: 'underline'
  }
};

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorBlock.react
 * @format
 * 
 */



var _assign = __webpack_require__(36);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DraftEditorLeaf = __webpack_require__(1818);
var DraftOffsetKey = __webpack_require__(371);
var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(64);
var Scroll = __webpack_require__(836);
var Style = __webpack_require__(533);
var UnicodeBidi = __webpack_require__(837);
var UnicodeBidiDirection = __webpack_require__(534);

var cx = __webpack_require__(264);
var getElementPosition = __webpack_require__(2336);
var getScrollPosition = __webpack_require__(535);
var getViewportDimensions = __webpack_require__(2340);
var invariant = __webpack_require__(23);
var nullthrows = __webpack_require__(136);

var SCROLL_BUFFER = 10;

/**
 * Return whether a block overlaps with either edge of the `SelectionState`.
 */
var isBlockOnSelectionEdge = function isBlockOnSelectionEdge(selection, key) {
  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
};

/**
 * The default block renderer for a `DraftEditor` component.
 *
 * A `DraftEditorBlock` is able to render a given `ContentBlock` to its
 * appropriate decorator and inline style components.
 */

var DraftEditorBlock = function (_React$Component) {
  _inherits(DraftEditorBlock, _React$Component);

  function DraftEditorBlock() {
    _classCallCheck(this, DraftEditorBlock);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  DraftEditorBlock.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.block !== nextProps.block || this.props.tree !== nextProps.tree || this.props.direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection;
  };

  /**
   * When a block is mounted and overlaps the selection state, we need to make
   * sure that the cursor is visible to match native behavior. This may not
   * be the case if the user has pressed `RETURN` or pasted some content, since
   * programatically creating these new blocks and setting the DOM selection
   * will miss out on the browser natively scrolling to that position.
   *
   * To replicate native behavior, if the block overlaps the selection state
   * on mount, force the scroll position. Check the scroll state of the scroll
   * parent, and adjust it to align the entire block to the bottom of the
   * scroll parent.
   */


  DraftEditorBlock.prototype.componentDidMount = function componentDidMount() {
    var selection = this.props.selection;
    var endKey = selection.getEndKey();
    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
      return;
    }

    var blockNode = ReactDOM.findDOMNode(this);
    var scrollParent = Style.getScrollParent(blockNode);
    var scrollPosition = getScrollPosition(scrollParent);
    var scrollDelta = void 0;

    if (scrollParent === window) {
      var nodePosition = getElementPosition(blockNode);
      var nodeBottom = nodePosition.y + nodePosition.height;
      var viewportHeight = getViewportDimensions().height;
      scrollDelta = nodeBottom - viewportHeight;
      if (scrollDelta > 0) {
        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
      }
    } else {
      !(blockNode instanceof HTMLElement) ?  false ? invariant(false, 'blockNode is not an HTMLElement') : invariant(false) : void 0;
      var blockBottom = blockNode.offsetHeight + blockNode.offsetTop;
      var scrollBottom = scrollParent.offsetHeight + scrollPosition.y;
      scrollDelta = blockBottom - scrollBottom;
      if (scrollDelta > 0) {
        Scroll.setTop(scrollParent, Scroll.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
      }
    }
  };

  DraftEditorBlock.prototype._renderChildren = function _renderChildren() {
    var _this2 = this;

    var block = this.props.block;
    var blockKey = block.getKey();
    var text = block.getText();
    var lastLeafSet = this.props.tree.size - 1;
    var hasSelection = isBlockOnSelectionEdge(this.props.selection, blockKey);

    return this.props.tree.map(function (leafSet, ii) {
      var leavesForLeafSet = leafSet.get('leaves');
      var lastLeaf = leavesForLeafSet.size - 1;
      var leaves = leavesForLeafSet.map(function (leaf, jj) {
        var offsetKey = DraftOffsetKey.encode(blockKey, ii, jj);
        var start = leaf.get('start');
        var end = leaf.get('end');
        return React.createElement(DraftEditorLeaf, {
          key: offsetKey,
          offsetKey: offsetKey,
          block: block,
          start: start,
          selection: hasSelection ? _this2.props.selection : null,
          forceSelection: _this2.props.forceSelection,
          text: text.slice(start, end),
          styleSet: block.getInlineStyleAt(start),
          customStyleMap: _this2.props.customStyleMap,
          customStyleFn: _this2.props.customStyleFn,
          isLast: ii === lastLeafSet && jj === lastLeaf
        });
      }).toArray();

      var decoratorKey = leafSet.get('decoratorKey');
      if (decoratorKey == null) {
        return leaves;
      }

      if (!_this2.props.decorator) {
        return leaves;
      }

      var decorator = nullthrows(_this2.props.decorator);

      var DecoratorComponent = decorator.getComponentForKey(decoratorKey);
      if (!DecoratorComponent) {
        return leaves;
      }

      var decoratorProps = decorator.getPropsForKey(decoratorKey);
      var decoratorOffsetKey = DraftOffsetKey.encode(blockKey, ii, 0);
      var decoratedText = text.slice(leavesForLeafSet.first().get('start'), leavesForLeafSet.last().get('end'));

      // Resetting dir to the same value on a child node makes Chrome/Firefox
      // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/
      var dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), _this2.props.direction);

      return React.createElement(
        DecoratorComponent,
        _extends({}, decoratorProps, {
          contentState: _this2.props.contentState,
          decoratedText: decoratedText,
          dir: dir,
          key: decoratorOffsetKey,
          entityKey: block.getEntityAt(leafSet.get('start')),
          offsetKey: decoratorOffsetKey }),
        leaves
      );
    }).toArray();
  };

  DraftEditorBlock.prototype.render = function render() {
    var _props = this.props,
        direction = _props.direction,
        offsetKey = _props.offsetKey;

    var className = cx({
      'public/DraftStyleDefault/block': true,
      'public/DraftStyleDefault/ltr': direction === 'LTR',
      'public/DraftStyleDefault/rtl': direction === 'RTL'
    });

    return React.createElement(
      'div',
      { 'data-offset-key': offsetKey, className: className },
      this._renderChildren()
    );
  };

  return DraftEditorBlock;
}(React.Component);

module.exports = DraftEditorBlock;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEntityInstance
 * @legacyServerCallableInstance
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Immutable = __webpack_require__(45);

var Record = Immutable.Record;


var DraftEntityInstanceRecord = Record({
  type: 'TOKEN',
  mutability: 'IMMUTABLE',
  data: Object
});

/**
 * An instance of a document entity, consisting of a `type` and relevant
 * `data`, metadata about the entity.
 *
 * For instance, a "link" entity might provide a URI, and a "mention"
 * entity might provide the mentioned user's ID. These pieces of data
 * may be used when rendering the entity as part of a ContentBlock DOM
 * representation. For a link, the data would be used as an href for
 * the rendered anchor. For a mention, the ID could be used to retrieve
 * a hovercard.
 */

var DraftEntityInstance = function (_DraftEntityInstanceR) {
  _inherits(DraftEntityInstance, _DraftEntityInstanceR);

  function DraftEntityInstance() {
    _classCallCheck(this, DraftEntityInstance);

    return _possibleConstructorReturn(this, _DraftEntityInstanceR.apply(this, arguments));
  }

  DraftEntityInstance.prototype.getType = function getType() {
    return this.get('type');
  };

  DraftEntityInstance.prototype.getMutability = function getMutability() {
    return this.get('mutability');
  };

  DraftEntityInstance.prototype.getData = function getData() {
    return this.get('data');
  };

  return DraftEntityInstance;
}(DraftEntityInstanceRecord);

module.exports = DraftEntityInstance;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftRemovableWord
 * @format
 * 
 */



var TokenizeUtil = __webpack_require__(2328);

var punctuation = TokenizeUtil.getPunctuation();

// The apostrophe and curly single quotes behave in a curious way: when
// surrounded on both sides by word characters, they behave as word chars; when
// either neighbor is punctuation or an end of the string, they behave as
// punctuation.
var CHAMELEON_CHARS = '[\'\u2018\u2019]';

// Remove the underscore, which should count as part of the removable word. The
// "chameleon chars" also count as punctuation in this regex.
var WHITESPACE_AND_PUNCTUATION = '\\s|(?![_])' + punctuation;

var DELETE_STRING = '^' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)';
var DELETE_REGEX = new RegExp(DELETE_STRING);

var BACKSPACE_STRING = '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '$';
var BACKSPACE_REGEX = new RegExp(BACKSPACE_STRING);

function getRemovableWord(text, isBackward) {
  var matches = isBackward ? BACKSPACE_REGEX.exec(text) : DELETE_REGEX.exec(text);
  return matches ? matches[0] : text;
}

var DraftRemovableWord = {
  getBackward: function getBackward(text) {
    return getRemovableWord(text, true);
  },

  getForward: function getForward(text) {
    return getRemovableWord(text, false);
  }
};

module.exports = DraftRemovableWord;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftStringKey
 * @format
 * 
 */



var DraftStringKey = {
  stringify: function stringify(key) {
    return '_' + String(key);
  },

  unstringify: function unstringify(key) {
    return key.slice(1);
  }
};

module.exports = DraftStringKey;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule RichTextEditorUtil
 * @format
 * 
 */



var DraftModifier = __webpack_require__(107);
var EditorState = __webpack_require__(51);
var SelectionState = __webpack_require__(259);

var adjustBlockDepthForContentState = __webpack_require__(1828);
var nullthrows = __webpack_require__(136);

var RichTextEditorUtil = {
  currentBlockContainsLink: function currentBlockContainsLink(editorState) {
    var selection = editorState.getSelection();
    var contentState = editorState.getCurrentContent();
    var entityMap = contentState.getEntityMap();
    return contentState.getBlockForKey(selection.getAnchorKey()).getCharacterList().slice(selection.getStartOffset(), selection.getEndOffset()).some(function (v) {
      var entity = v.getEntity();
      return !!entity && entityMap.__get(entity).getType() === 'LINK';
    });
  },

  getCurrentBlockType: function getCurrentBlockType(editorState) {
    var selection = editorState.getSelection();
    return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
  },

  getDataObjectForLinkURL: function getDataObjectForLinkURL(uri) {
    return { url: uri.toString() };
  },

  handleKeyCommand: function handleKeyCommand(editorState, command) {
    switch (command) {
      case 'bold':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'BOLD');
      case 'italic':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'ITALIC');
      case 'underline':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'UNDERLINE');
      case 'code':
        return RichTextEditorUtil.toggleCode(editorState);
      case 'backspace':
      case 'backspace-word':
      case 'backspace-to-start-of-line':
        return RichTextEditorUtil.onBackspace(editorState);
      case 'delete':
      case 'delete-word':
      case 'delete-to-end-of-block':
        return RichTextEditorUtil.onDelete(editorState);
      default:
        // they may have custom editor commands; ignore those
        return null;
    }
  },

  insertSoftNewline: function insertSoftNewline(editorState) {
    var contentState = DraftModifier.insertText(editorState.getCurrentContent(), editorState.getSelection(), '\n', editorState.getCurrentInlineStyle(), null);

    var newEditorState = EditorState.push(editorState, contentState, 'insert-characters');

    return EditorState.forceSelection(newEditorState, contentState.getSelectionAfter());
  },

  /**
   * For collapsed selections at the start of styled blocks, backspace should
   * just remove the existing style.
   */
  onBackspace: function onBackspace(editorState) {
    var selection = editorState.getSelection();
    if (!selection.isCollapsed() || selection.getAnchorOffset() || selection.getFocusOffset()) {
      return null;
    }

    // First, try to remove a preceding atomic block.
    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var blockBefore = content.getBlockBefore(startKey);

    if (blockBefore && blockBefore.getType() === 'atomic') {
      var blockMap = content.getBlockMap()['delete'](blockBefore.getKey());
      var withoutAtomicBlock = content.merge({
        blockMap: blockMap,
        selectionAfter: selection
      });
      if (withoutAtomicBlock !== content) {
        return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
      }
    }

    // If that doesn't succeed, try to remove the current block style.
    var withoutBlockStyle = RichTextEditorUtil.tryToRemoveBlockStyle(editorState);

    if (withoutBlockStyle) {
      return EditorState.push(editorState, withoutBlockStyle, 'change-block-type');
    }

    return null;
  },

  onDelete: function onDelete(editorState) {
    var selection = editorState.getSelection();
    if (!selection.isCollapsed()) {
      return null;
    }

    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var block = content.getBlockForKey(startKey);
    var length = block.getLength();

    // The cursor is somewhere within the text. Behave normally.
    if (selection.getStartOffset() < length) {
      return null;
    }

    var blockAfter = content.getBlockAfter(startKey);

    if (!blockAfter || blockAfter.getType() !== 'atomic') {
      return null;
    }

    var atomicBlockTarget = selection.merge({
      focusKey: blockAfter.getKey(),
      focusOffset: blockAfter.getLength()
    });

    var withoutAtomicBlock = DraftModifier.removeRange(content, atomicBlockTarget, 'forward');

    if (withoutAtomicBlock !== content) {
      return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
    }

    return null;
  },

  onTab: function onTab(event, editorState, maxDepth) {
    var selection = editorState.getSelection();
    var key = selection.getAnchorKey();
    if (key !== selection.getFocusKey()) {
      return editorState;
    }

    var content = editorState.getCurrentContent();
    var block = content.getBlockForKey(key);
    var type = block.getType();
    if (type !== 'unordered-list-item' && type !== 'ordered-list-item') {
      return editorState;
    }

    event.preventDefault();

    // Only allow indenting one level beyond the block above, and only if
    // the block above is a list item as well.
    var blockAbove = content.getBlockBefore(key);
    if (!blockAbove) {
      return editorState;
    }

    var typeAbove = blockAbove.getType();
    if (typeAbove !== 'unordered-list-item' && typeAbove !== 'ordered-list-item') {
      return editorState;
    }

    var depth = block.getDepth();
    if (!event.shiftKey && depth === maxDepth) {
      return editorState;
    }

    maxDepth = Math.min(blockAbove.getDepth() + 1, maxDepth);

    var withAdjustment = adjustBlockDepthForContentState(content, selection, event.shiftKey ? -1 : 1, maxDepth);

    return EditorState.push(editorState, withAdjustment, 'adjust-depth');
  },

  toggleBlockType: function toggleBlockType(editorState, blockType) {
    var selection = editorState.getSelection();
    var startKey = selection.getStartKey();
    var endKey = selection.getEndKey();
    var content = editorState.getCurrentContent();
    var target = selection;

    // Triple-click can lead to a selection that includes offset 0 of the
    // following block. The `SelectionState` for this case is accurate, but
    // we should avoid toggling block type for the trailing block because it
    // is a confusing interaction.
    if (startKey !== endKey && selection.getEndOffset() === 0) {
      var blockBefore = nullthrows(content.getBlockBefore(endKey));
      endKey = blockBefore.getKey();
      target = target.merge({
        anchorKey: startKey,
        anchorOffset: selection.getStartOffset(),
        focusKey: endKey,
        focusOffset: blockBefore.getLength(),
        isBackward: false
      });
    }

    var hasAtomicBlock = content.getBlockMap().skipWhile(function (_, k) {
      return k !== startKey;
    }).reverse().skipWhile(function (_, k) {
      return k !== endKey;
    }).some(function (v) {
      return v.getType() === 'atomic';
    });

    if (hasAtomicBlock) {
      return editorState;
    }

    var typeToSet = content.getBlockForKey(startKey).getType() === blockType ? 'unstyled' : blockType;

    return EditorState.push(editorState, DraftModifier.setBlockType(content, target, typeToSet), 'change-block-type');
  },

  toggleCode: function toggleCode(editorState) {
    var selection = editorState.getSelection();
    var anchorKey = selection.getAnchorKey();
    var focusKey = selection.getFocusKey();

    if (selection.isCollapsed() || anchorKey !== focusKey) {
      return RichTextEditorUtil.toggleBlockType(editorState, 'code-block');
    }

    return RichTextEditorUtil.toggleInlineStyle(editorState, 'CODE');
  },

  /**
   * Toggle the specified inline style for the selection. If the
   * user's selection is collapsed, apply or remove the style for the
   * internal state. If it is not collapsed, apply the change directly
   * to the document state.
   */
  toggleInlineStyle: function toggleInlineStyle(editorState, inlineStyle) {
    var selection = editorState.getSelection();
    var currentStyle = editorState.getCurrentInlineStyle();

    // If the selection is collapsed, toggle the specified style on or off and
    // set the result as the new inline style override. This will then be
    // used as the inline style for the next character to be inserted.
    if (selection.isCollapsed()) {
      return EditorState.setInlineStyleOverride(editorState, currentStyle.has(inlineStyle) ? currentStyle.remove(inlineStyle) : currentStyle.add(inlineStyle));
    }

    // If characters are selected, immediately apply or remove the
    // inline style on the document state itself.
    var content = editorState.getCurrentContent();
    var newContent;

    // If the style is already present for the selection range, remove it.
    // Otherwise, apply it.
    if (currentStyle.has(inlineStyle)) {
      newContent = DraftModifier.removeInlineStyle(content, selection, inlineStyle);
    } else {
      newContent = DraftModifier.applyInlineStyle(content, selection, inlineStyle);
    }

    return EditorState.push(editorState, newContent, 'change-inline-style');
  },

  toggleLink: function toggleLink(editorState, targetSelection, entityKey) {
    var withoutLink = DraftModifier.applyEntity(editorState.getCurrentContent(), targetSelection, entityKey);

    return EditorState.push(editorState, withoutLink, 'apply-entity');
  },

  /**
   * When a collapsed cursor is at the start of the first styled block, or
   * an empty styled block, changes block to 'unstyled'. Returns null if
   * block or selection does not meet that criteria.
   */
  tryToRemoveBlockStyle: function tryToRemoveBlockStyle(editorState) {
    var selection = editorState.getSelection();
    var offset = selection.getAnchorOffset();
    if (selection.isCollapsed() && offset === 0) {
      var key = selection.getAnchorKey();
      var content = editorState.getCurrentContent();
      var block = content.getBlockForKey(key);

      var firstBlock = content.getFirstBlock();
      if (block.getLength() > 0 && block !== firstBlock) {
        return null;
      }

      var type = block.getType();
      var blockBefore = content.getBlockBefore(key);
      if (type === 'code-block' && blockBefore && blockBefore.getType() === 'code-block' && blockBefore.getLength() !== 0) {
        return null;
      }

      if (type !== 'unstyled') {
        return DraftModifier.setBlockType(content, selection, 'unstyled');
      }
    }
    return null;
  }
};

module.exports = RichTextEditorUtil;

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule convertFromHTMLToContentBlocks
 * @format
 * 
 */



var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _knownListItemDepthCl,
    _assign = __webpack_require__(36);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CharacterMetadata = __webpack_require__(117);
var ContentBlock = __webpack_require__(219);
var ContentBlockNode = __webpack_require__(122);
var DefaultDraftBlockRenderMap = __webpack_require__(504);
var DraftEntity = __webpack_require__(370);
var DraftFeatureFlags = __webpack_require__(190);
var Immutable = __webpack_require__(45);

var _require = __webpack_require__(45),
    Set = _require.Set;

var URI = __webpack_require__(2329);

var cx = __webpack_require__(264);
var generateRandomKey = __webpack_require__(167);
var getSafeBodyFromHTML = __webpack_require__(762);
var invariant = __webpack_require__(23);
var sanitizeDraftText = __webpack_require__(509);

var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;

var List = Immutable.List,
    OrderedSet = Immutable.OrderedSet;


var NBSP = '&nbsp;';
var SPACE = ' ';

// Arbitrary max indent
var MAX_DEPTH = 4;

// used for replacing characters in HTML
var REGEX_CR = new RegExp('\r', 'g');
var REGEX_LF = new RegExp('\n', 'g');
var REGEX_NBSP = new RegExp(NBSP, 'g');
var REGEX_CARRIAGE = new RegExp('&#13;?', 'g');
var REGEX_ZWS = new RegExp('&#8203;?', 'g');

// https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight
var boldValues = ['bold', 'bolder', '500', '600', '700', '800', '900'];
var notBoldValues = ['light', 'lighter', '100', '200', '300', '400'];

// Block tag flow is different because LIs do not have
// a deterministic style ;_;
var inlineTags = {
  b: 'BOLD',
  code: 'CODE',
  del: 'STRIKETHROUGH',
  em: 'ITALIC',
  i: 'ITALIC',
  s: 'STRIKETHROUGH',
  strike: 'STRIKETHROUGH',
  strong: 'BOLD',
  u: 'UNDERLINE'
};

var knownListItemDepthClasses = (_knownListItemDepthCl = {}, _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth0'), 0), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth1'), 1), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth2'), 2), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth3'), 3), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth4'), 4), _knownListItemDepthCl);

var anchorAttr = ['className', 'href', 'rel', 'target', 'title'];

var imgAttr = ['alt', 'className', 'height', 'src', 'width'];

var lastBlock = void 0;

var EMPTY_CHUNK = {
  text: '',
  inlines: [],
  entities: [],
  blocks: []
};

var EMPTY_BLOCK = {
  children: List(),
  depth: 0,
  key: '',
  type: ''
};

var getListBlockType = function getListBlockType(tag, lastList) {
  if (tag === 'li') {
    return lastList === 'ol' ? 'ordered-list-item' : 'unordered-list-item';
  }
  return null;
};

var getBlockMapSupportedTags = function getBlockMapSupportedTags(blockRenderMap) {
  var unstyledElement = blockRenderMap.get('unstyled').element;
  var tags = Set([]);

  blockRenderMap.forEach(function (draftBlock) {
    if (draftBlock.aliasedElements) {
      draftBlock.aliasedElements.forEach(function (tag) {
        tags = tags.add(tag);
      });
    }

    tags = tags.add(draftBlock.element);
  });

  return tags.filter(function (tag) {
    return tag && tag !== unstyledElement;
  }).toArray().sort();
};

// custom element conversions
var getMultiMatchedType = function getMultiMatchedType(tag, lastList, multiMatchExtractor) {
  for (var ii = 0; ii < multiMatchExtractor.length; ii++) {
    var matchType = multiMatchExtractor[ii](tag, lastList);
    if (matchType) {
      return matchType;
    }
  }
  return null;
};

var getBlockTypeForTag = function getBlockTypeForTag(tag, lastList, blockRenderMap) {
  var matchedTypes = blockRenderMap.filter(function (draftBlock) {
    return draftBlock.element === tag || draftBlock.wrapper === tag || draftBlock.aliasedElements && draftBlock.aliasedElements.some(function (alias) {
      return alias === tag;
    });
  }).keySeq().toSet().toArray().sort();

  // if we dont have any matched type, return unstyled
  // if we have one matched type return it
  // if we have multi matched types use the multi-match function to gather type
  switch (matchedTypes.length) {
    case 0:
      return 'unstyled';
    case 1:
      return matchedTypes[0];
    default:
      return getMultiMatchedType(tag, lastList, [getListBlockType]) || 'unstyled';
  }
};

var processInlineTag = function processInlineTag(tag, node, currentStyle) {
  var styleToCheck = inlineTags[tag];
  if (styleToCheck) {
    currentStyle = currentStyle.add(styleToCheck).toOrderedSet();
  } else if (node instanceof HTMLElement) {
    var htmlElement = node;
    currentStyle = currentStyle.withMutations(function (style) {
      var fontWeight = htmlElement.style.fontWeight;
      var fontStyle = htmlElement.style.fontStyle;
      var textDecoration = htmlElement.style.textDecoration;

      if (boldValues.indexOf(fontWeight) >= 0) {
        style.add('BOLD');
      } else if (notBoldValues.indexOf(fontWeight) >= 0) {
        style.remove('BOLD');
      }

      if (fontStyle === 'italic') {
        style.add('ITALIC');
      } else if (fontStyle === 'normal') {
        style.remove('ITALIC');
      }

      if (textDecoration === 'underline') {
        style.add('UNDERLINE');
      }
      if (textDecoration === 'line-through') {
        style.add('STRIKETHROUGH');
      }
      if (textDecoration === 'none') {
        style.remove('UNDERLINE');
        style.remove('STRIKETHROUGH');
      }
    }).toOrderedSet();
  }
  return currentStyle;
};

var joinChunks = function joinChunks(A, B, experimentalHasNestedBlocks) {
  // Sometimes two blocks will touch in the DOM and we need to strip the
  // extra delimiter to preserve niceness.
  var lastInA = A.text.slice(-1);
  var firstInB = B.text.slice(0, 1);

  if (lastInA === '\r' && firstInB === '\r' && !experimentalHasNestedBlocks) {
    A.text = A.text.slice(0, -1);
    A.inlines.pop();
    A.entities.pop();
    A.blocks.pop();
  }

  // Kill whitespace after blocks
  if (lastInA === '\r') {
    if (B.text === SPACE || B.text === '\n') {
      return A;
    } else if (firstInB === SPACE || firstInB === '\n') {
      B.text = B.text.slice(1);
      B.inlines.shift();
      B.entities.shift();
    }
  }

  return {
    text: A.text + B.text,
    inlines: A.inlines.concat(B.inlines),
    entities: A.entities.concat(B.entities),
    blocks: A.blocks.concat(B.blocks)
  };
};

/**
 * Check to see if we have anything like <p> <blockquote> <h1>... to create
 * block tags from. If we do, we can use those and ignore <div> tags. If we
 * don't, we can treat <div> tags as meaningful (unstyled) blocks.
 */
var containsSemanticBlockMarkup = function containsSemanticBlockMarkup(html, blockTags) {
  return blockTags.some(function (tag) {
    return html.indexOf('<' + tag) !== -1;
  });
};

var hasValidLinkText = function hasValidLinkText(link) {
  !(link instanceof HTMLAnchorElement) ?  false ? invariant(false, 'Link must be an HTMLAnchorElement.') : invariant(false) : void 0;
  var protocol = link.protocol;
  return protocol === 'http:' || protocol === 'https:' || protocol === 'mailto:';
};

var getWhitespaceChunk = function getWhitespaceChunk(inEntity) {
  var entities = new Array(1);
  if (inEntity) {
    entities[0] = inEntity;
  }
  return _extends({}, EMPTY_CHUNK, {
    text: SPACE,
    inlines: [OrderedSet()],
    entities: entities
  });
};

var getSoftNewlineChunk = function getSoftNewlineChunk() {
  return _extends({}, EMPTY_CHUNK, {
    text: '\n',
    inlines: [OrderedSet()],
    entities: new Array(1)
  });
};

var getChunkedBlock = function getChunkedBlock() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return _extends({}, EMPTY_BLOCK, props);
};

var getBlockDividerChunk = function getBlockDividerChunk(block, depth) {
  var parentKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return {
    text: '\r',
    inlines: [OrderedSet()],
    entities: new Array(1),
    blocks: [getChunkedBlock({
      parent: parentKey,
      key: generateRandomKey(),
      type: block,
      depth: Math.max(0, Math.min(MAX_DEPTH, depth))
    })]
  };
};

/**
 *  If we're pasting from one DraftEditor to another we can check to see if
 *  existing list item depth classes are being used and preserve this style
 */
var getListItemDepth = function getListItemDepth(node) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  Object.keys(knownListItemDepthClasses).some(function (depthClass) {
    if (node.classList.contains(depthClass)) {
      depth = knownListItemDepthClasses[depthClass];
    }
  });
  return depth;
};

var genFragment = function genFragment(entityMap, node, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, inEntity, parentKey) {
  var lastLastBlock = lastBlock;
  var nodeName = node.nodeName.toLowerCase();
  var newEntityMap = entityMap;
  var nextBlockType = 'unstyled';
  var newBlock = false;
  var inBlockType = inBlock && getBlockTypeForTag(inBlock, lastList, blockRenderMap);
  var chunk = _extends({}, EMPTY_CHUNK);
  var newChunk = null;
  var blockKey = void 0;

  // Base Case
  if (nodeName === '#text') {
    var _text = node.textContent;
    var nodeTextContent = _text.trim();

    // We should not create blocks for leading spaces that are
    // existing around ol/ul and their children list items
    if (lastList && nodeTextContent === '' && node.parentElement) {
      var parentNodeName = node.parentElement.nodeName.toLowerCase();
      if (parentNodeName === 'ol' || parentNodeName === 'ul') {
        return { chunk: _extends({}, EMPTY_CHUNK), entityMap: entityMap };
      }
    }

    if (nodeTextContent === '' && inBlock !== 'pre') {
      return { chunk: getWhitespaceChunk(inEntity), entityMap: entityMap };
    }
    if (inBlock !== 'pre') {
      // Can't use empty string because MSWord
      _text = _text.replace(REGEX_LF, SPACE);
    }

    // save the last block so we can use it later
    lastBlock = nodeName;

    return {
      chunk: {
        text: _text,
        inlines: Array(_text.length).fill(inlineStyle),
        entities: Array(_text.length).fill(inEntity),
        blocks: []
      },
      entityMap: entityMap
    };
  }

  // save the last block so we can use it later
  lastBlock = nodeName;

  // BR tags
  if (nodeName === 'br') {
    if (lastLastBlock === 'br' && (!inBlock || inBlockType === 'unstyled')) {
      return {
        chunk: getBlockDividerChunk('unstyled', depth, parentKey),
        entityMap: entityMap
      };
    }
    return { chunk: getSoftNewlineChunk(), entityMap: entityMap };
  }

  // IMG tags
  if (nodeName === 'img' && node instanceof HTMLImageElement && node.attributes.getNamedItem('src') && node.attributes.getNamedItem('src').value) {
    var image = node;
    var entityConfig = {};

    imgAttr.forEach(function (attr) {
      var imageAttribute = image.getAttribute(attr);
      if (imageAttribute) {
        entityConfig[attr] = imageAttribute;
      }
    });
    // Forcing this node to have children because otherwise no entity will be
    // created for this node.
    // The child text node cannot just have a space or return as content -
    // we strip those out.
    // See https://github.com/facebook/draft-js/issues/231 for some context.
    node.textContent = '\uD83D\uDCF7';

    // TODO: update this when we remove DraftEntity entirely
    inEntity = DraftEntity.__create('IMAGE', 'MUTABLE', entityConfig || {});
  }

  // Inline tags
  inlineStyle = processInlineTag(nodeName, node, inlineStyle);

  // Handle lists
  if (nodeName === 'ul' || nodeName === 'ol') {
    if (lastList) {
      depth += 1;
    }
    lastList = nodeName;
  }

  if (!experimentalTreeDataSupport && nodeName === 'li' && node instanceof HTMLElement) {
    depth = getListItemDepth(node, depth);
  }

  var blockType = getBlockTypeForTag(nodeName, lastList, blockRenderMap);
  var inListBlock = lastList && inBlock === 'li' && nodeName === 'li';
  var inBlockOrHasNestedBlocks = (!inBlock || experimentalTreeDataSupport) && blockTags.indexOf(nodeName) !== -1;

  // Block Tags
  if (inListBlock || inBlockOrHasNestedBlocks) {
    chunk = getBlockDividerChunk(blockType, depth, parentKey);
    blockKey = chunk.blocks[0].key;
    inBlock = nodeName;
    newBlock = !experimentalTreeDataSupport;
  }

  // this is required so that we can handle 'ul' and 'ol'
  if (inListBlock) {
    nextBlockType = lastList === 'ul' ? 'unordered-list-item' : 'ordered-list-item';
  }

  // Recurse through children
  var child = node.firstChild;
  if (child != null) {
    nodeName = child.nodeName.toLowerCase();
  }

  var entityId = null;

  while (child) {
    if (child instanceof HTMLAnchorElement && child.href && hasValidLinkText(child)) {
      (function () {
        var anchor = child;
        var entityConfig = {};

        anchorAttr.forEach(function (attr) {
          var anchorAttribute = anchor.getAttribute(attr);
          if (anchorAttribute) {
            entityConfig[attr] = anchorAttribute;
          }
        });

        entityConfig.url = new URI(anchor.href).toString();
        // TODO: update this when we remove DraftEntity completely
        entityId = DraftEntity.__create('LINK', 'MUTABLE', entityConfig || {});
      })();
    } else {
      entityId = undefined;
    }

    var _genFragment = genFragment(newEntityMap, child, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, entityId || inEntity, experimentalTreeDataSupport ? blockKey : null),
        generatedChunk = _genFragment.chunk,
        maybeUpdatedEntityMap = _genFragment.entityMap;

    newChunk = generatedChunk;
    newEntityMap = maybeUpdatedEntityMap;

    chunk = joinChunks(chunk, newChunk, experimentalTreeDataSupport);
    var sibling = child.nextSibling;

    // Put in a newline to break up blocks inside blocks
    if (!parentKey && sibling && blockTags.indexOf(nodeName) >= 0 && inBlock) {
      chunk = joinChunks(chunk, getSoftNewlineChunk());
    }
    if (sibling) {
      nodeName = sibling.nodeName.toLowerCase();
    }
    child = sibling;
  }

  if (newBlock) {
    chunk = joinChunks(chunk, getBlockDividerChunk(nextBlockType, depth, parentKey));
  }

  return { chunk: chunk, entityMap: newEntityMap };
};

var getChunkForHTML = function getChunkForHTML(html, DOMBuilder, blockRenderMap, entityMap) {
  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE).replace(REGEX_CARRIAGE, '').replace(REGEX_ZWS, '');

  var supportedBlockTags = getBlockMapSupportedTags(blockRenderMap);

  var safeBody = DOMBuilder(html);
  if (!safeBody) {
    return null;
  }
  lastBlock = null;

  // Sometimes we aren't dealing with content that contains nice semantic
  // tags. In this case, use divs to separate everything out into paragraphs
  // and hope for the best.
  var workingBlocks = containsSemanticBlockMarkup(html, supportedBlockTags) ? supportedBlockTags : ['div'];

  // Start with -1 block depth to offset the fact that we are passing in a fake
  // UL block to start with.
  var fragment = genFragment(entityMap, safeBody, OrderedSet(), 'ul', null, workingBlocks, -1, blockRenderMap);

  var chunk = fragment.chunk;
  var newEntityMap = fragment.entityMap;

  // join with previous block to prevent weirdness on paste
  if (chunk.text.indexOf('\r') === 0) {
    chunk = {
      text: chunk.text.slice(1),
      inlines: chunk.inlines.slice(1),
      entities: chunk.entities.slice(1),
      blocks: chunk.blocks
    };
  }

  // Kill block delimiter at the end
  if (chunk.text.slice(-1) === '\r') {
    chunk.text = chunk.text.slice(0, -1);
    chunk.inlines = chunk.inlines.slice(0, -1);
    chunk.entities = chunk.entities.slice(0, -1);
    chunk.blocks.pop();
  }

  // If we saw no block tags, put an unstyled one in
  if (chunk.blocks.length === 0) {
    chunk.blocks.push(_extends({}, EMPTY_CHUNK, {
      type: 'unstyled',
      depth: 0
    }));
  }

  // Sometimes we start with text that isn't in a block, which is then
  // followed by blocks. Need to fix up the blocks to add in
  // an unstyled block for this content
  if (chunk.text.split('\r').length === chunk.blocks.length + 1) {
    chunk.blocks.unshift({ type: 'unstyled', depth: 0 });
  }

  return { chunk: chunk, entityMap: newEntityMap };
};

var convertChunkToContentBlocks = function convertChunkToContentBlocks(chunk) {
  if (!chunk || !chunk.text || !Array.isArray(chunk.blocks)) {
    return null;
  }

  var initialState = {
    cacheRef: {},
    contentBlocks: []
  };

  var start = 0;

  var rawBlocks = chunk.blocks,
      rawInlines = chunk.inlines,
      rawEntities = chunk.entities;


  var BlockNodeRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;

  return chunk.text.split('\r').reduce(function (acc, textBlock, index) {
    // Make absolutely certain that our text is acceptable.
    textBlock = sanitizeDraftText(textBlock);

    var block = rawBlocks[index];
    var end = start + textBlock.length;
    var inlines = rawInlines.slice(start, end);
    var entities = rawEntities.slice(start, end);
    var characterList = List(inlines.map(function (style, index) {
      var data = { style: style, entity: null };
      if (entities[index]) {
        data.entity = entities[index];
      }
      return CharacterMetadata.create(data);
    }));
    start = end + 1;

    var depth = block.depth,
        type = block.type,
        parent = block.parent;


    var key = block.key || generateRandomKey();
    var parentTextNodeKey = null; // will be used to store container text nodes

    // childrens add themselves to their parents since we are iterating in order
    if (parent) {
      var parentIndex = acc.cacheRef[parent];
      var parentRecord = acc.contentBlocks[parentIndex];

      // if parent has text we need to split it into a separate unstyled element
      if (parentRecord.getChildKeys().isEmpty() && parentRecord.getText()) {
        var parentCharacterList = parentRecord.getCharacterList();
        var parentText = parentRecord.getText();
        parentTextNodeKey = generateRandomKey();

        var textNode = new ContentBlockNode({
          key: parentTextNodeKey,
          text: parentText,
          characterList: parentCharacterList,
          parent: parent,
          nextSibling: key
        });

        acc.contentBlocks.push(textNode);

        parentRecord = parentRecord.withMutations(function (block) {
          block.set('characterList', List()).set('text', '').set('children', parentRecord.children.push(textNode.getKey()));
        });
      }

      acc.contentBlocks[parentIndex] = parentRecord.set('children', parentRecord.children.push(key));
    }

    var blockNode = new BlockNodeRecord({
      key: key,
      parent: parent,
      type: type,
      depth: depth,
      text: textBlock,
      characterList: characterList,
      prevSibling: parentTextNodeKey || (index === 0 || rawBlocks[index - 1].parent !== parent ? null : rawBlocks[index - 1].key),
      nextSibling: index === rawBlocks.length - 1 || rawBlocks[index + 1].parent !== parent ? null : rawBlocks[index + 1].key
    });

    // insert node
    acc.contentBlocks.push(blockNode);

    // cache ref for building links
    acc.cacheRef[blockNode.key] = index;

    return acc;
  }, initialState).contentBlocks;
};

var convertFromHTMLtoContentBlocks = function convertFromHTMLtoContentBlocks(html) {
  var DOMBuilder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getSafeBodyFromHTML;
  var blockRenderMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DefaultDraftBlockRenderMap;

  // Be ABSOLUTELY SURE that the dom builder you pass here won't execute
  // arbitrary code in whatever environment you're running this in. For an
  // example of how we try to do this in-browser, see getSafeBodyFromHTML.

  // TODO: replace DraftEntity with an OrderedMap here
  var chunkData = getChunkForHTML(html, DOMBuilder, blockRenderMap, DraftEntity);

  if (chunkData == null) {
    return null;
  }

  var chunk = chunkData.chunk,
      entityMap = chunkData.entityMap;

  var contentBlocks = convertChunkToContentBlocks(chunk);

  return {
    contentBlocks: contentBlocks,
    entityMap: entityMap
  };
};

module.exports = convertFromHTMLtoContentBlocks;

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getDefaultKeyBinding
 * @format
 * 
 */



var KeyBindingUtil = __webpack_require__(505);
var Keys = __webpack_require__(532);
var UserAgent = __webpack_require__(148);

var isOSX = UserAgent.isPlatform('Mac OS X');
var isWindows = UserAgent.isPlatform('Windows');

// Firefox on OSX had a bug resulting in navigation instead of cursor movement.
// This bug was fixed in Firefox 29. Feature detection is virtually impossible
// so we just check the version number. See #342765.
var shouldFixFirefoxMovement = isOSX && UserAgent.isBrowser('Firefox < 29');

var hasCommandModifier = KeyBindingUtil.hasCommandModifier,
    isCtrlKeyCommand = KeyBindingUtil.isCtrlKeyCommand;


function shouldRemoveWord(e) {
  return isOSX && e.altKey || isCtrlKeyCommand(e);
}

/**
 * Get the appropriate undo/redo command for a Z key command.
 */
function getZCommand(e) {
  if (!hasCommandModifier(e)) {
    return null;
  }
  return e.shiftKey ? 'redo' : 'undo';
}

function getDeleteCommand(e) {
  // Allow default "cut" behavior for Windows on Shift + Delete.
  if (isWindows && e.shiftKey) {
    return null;
  }
  return shouldRemoveWord(e) ? 'delete-word' : 'delete';
}

function getBackspaceCommand(e) {
  if (hasCommandModifier(e) && isOSX) {
    return 'backspace-to-start-of-line';
  }
  return shouldRemoveWord(e) ? 'backspace-word' : 'backspace';
}

/**
 * Retrieve a bound key command for the given event.
 */
function getDefaultKeyBinding(e) {
  switch (e.keyCode) {
    case 66:
      // B
      return hasCommandModifier(e) ? 'bold' : null;
    case 68:
      // D
      return isCtrlKeyCommand(e) ? 'delete' : null;
    case 72:
      // H
      return isCtrlKeyCommand(e) ? 'backspace' : null;
    case 73:
      // I
      return hasCommandModifier(e) ? 'italic' : null;
    case 74:
      // J
      return hasCommandModifier(e) ? 'code' : null;
    case 75:
      // K
      return !isWindows && isCtrlKeyCommand(e) ? 'secondary-cut' : null;
    case 77:
      // M
      return isCtrlKeyCommand(e) ? 'split-block' : null;
    case 79:
      // O
      return isCtrlKeyCommand(e) ? 'split-block' : null;
    case 84:
      // T
      return isOSX && isCtrlKeyCommand(e) ? 'transpose-characters' : null;
    case 85:
      // U
      return hasCommandModifier(e) ? 'underline' : null;
    case 87:
      // W
      return isOSX && isCtrlKeyCommand(e) ? 'backspace-word' : null;
    case 89:
      // Y
      if (isCtrlKeyCommand(e)) {
        return isWindows ? 'redo' : 'secondary-paste';
      }
      return null;
    case 90:
      // Z
      return getZCommand(e) || null;
    case Keys.RETURN:
      return 'split-block';
    case Keys.DELETE:
      return getDeleteCommand(e);
    case Keys.BACKSPACE:
      return getBackspaceCommand(e);
    // LEFT/RIGHT handlers serve as a workaround for a Firefox bug.
    case Keys.LEFT:
      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-start-of-block' : null;
    case Keys.RIGHT:
      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-end-of-block' : null;
    default:
      return null;
  }
}

module.exports = getDefaultKeyBinding;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getDraftEditorSelectionWithNodes
 * @format
 * 
 */



var findAncestorOffsetKey = __webpack_require__(506);
var getSelectionOffsetKeyForNode = __webpack_require__(763);
var getUpdatedSelectionState = __webpack_require__(765);
var invariant = __webpack_require__(23);
var nullthrows = __webpack_require__(136);

/**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */
function getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset) {
  var anchorIsTextNode = anchorNode.nodeType === Node.TEXT_NODE;
  var focusIsTextNode = focusNode.nodeType === Node.TEXT_NODE;

  // If the selection range lies only on text nodes, the task is simple.
  // Find the nearest offset-aware elements and use the
  // offset values supplied by the selection range.
  if (anchorIsTextNode && focusIsTextNode) {
    return {
      selectionState: getUpdatedSelectionState(editorState, nullthrows(findAncestorOffsetKey(anchorNode)), anchorOffset, nullthrows(findAncestorOffsetKey(focusNode)), focusOffset),
      needsRecovery: false
    };
  }

  var anchorPoint = null;
  var focusPoint = null;
  var needsRecovery = true;

  // An element is selected. Convert this selection range into leaf offset
  // keys and offset values for consumption at the component level. This
  // is common in Firefox, where select-all and triple click behavior leads
  // to entire elements being selected.
  //
  // Note that we use the `needsRecovery` parameter in the callback here. This
  // is because when certain elements are selected, the behavior for subsequent
  // cursor movement (e.g. via arrow keys) is uncertain and may not match
  // expectations at the component level. For example, if an entire <div> is
  // selected and the user presses the right arrow, Firefox keeps the selection
  // on the <div>. If we allow subsequent keypresses to insert characters
  // natively, they will be inserted into a browser-created text node to the
  // right of that <div>. This is obviously undesirable.
  //
  // With the `needsRecovery` flag, we inform the caller that it is responsible
  // for manually setting the selection state on the rendered document to
  // ensure proper selection state maintenance.

  if (anchorIsTextNode) {
    anchorPoint = {
      key: nullthrows(findAncestorOffsetKey(anchorNode)),
      offset: anchorOffset
    };
    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
  } else if (focusIsTextNode) {
    focusPoint = {
      key: nullthrows(findAncestorOffsetKey(focusNode)),
      offset: focusOffset
    };
    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
  } else {
    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);

    // If the selection is collapsed on an empty block, don't force recovery.
    // This way, on arrow key selection changes, the browser can move the
    // cursor from a non-zero offset on one block, through empty blocks,
    // to a matching non-zero offset on other text blocks.
    if (anchorNode === focusNode && anchorOffset === focusOffset) {
      needsRecovery = !!anchorNode.firstChild && anchorNode.firstChild.nodeName !== 'BR';
    }
  }

  return {
    selectionState: getUpdatedSelectionState(editorState, anchorPoint.key, anchorPoint.offset, focusPoint.key, focusPoint.offset),
    needsRecovery: needsRecovery
  };
}

/**
 * Identify the first leaf descendant for the given node.
 */
function getFirstLeaf(node) {
  while (node.firstChild && (
  // data-blocks has no offset
  node.firstChild instanceof Element && node.firstChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.firstChild))) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Identify the last leaf descendant for the given node.
 */
function getLastLeaf(node) {
  while (node.lastChild && (
  // data-blocks has no offset
  node.lastChild instanceof Element && node.lastChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.lastChild))) {
    node = node.lastChild;
  }
  return node;
}

function getPointForNonTextNode(editorRoot, startNode, childOffset) {
  var node = startNode;
  var offsetKey = findAncestorOffsetKey(node);

  !(offsetKey != null || editorRoot && (editorRoot === node || editorRoot.firstChild === node)) ?  false ? invariant(false, 'Unknown node in selection range.') : invariant(false) : void 0;

  // If the editorRoot is the selection, step downward into the content
  // wrapper.
  if (editorRoot === node) {
    node = node.firstChild;
    !(node instanceof Element && node.getAttribute('data-contents') === 'true') ?  false ? invariant(false, 'Invalid DraftEditorContents structure.') : invariant(false) : void 0;
    if (childOffset > 0) {
      childOffset = node.childNodes.length;
    }
  }

  // If the child offset is zero and we have an offset key, we're done.
  // If there's no offset key because the entire editor is selected,
  // find the leftmost ("first") leaf in the tree and use that as the offset
  // key.
  if (childOffset === 0) {
    var key = null;
    if (offsetKey != null) {
      key = offsetKey;
    } else {
      var firstLeaf = getFirstLeaf(node);
      key = nullthrows(getSelectionOffsetKeyForNode(firstLeaf));
    }
    return { key: key, offset: 0 };
  }

  var nodeBeforeCursor = node.childNodes[childOffset - 1];
  var leafKey = null;
  var textLength = null;

  if (!getSelectionOffsetKeyForNode(nodeBeforeCursor)) {
    // Our target node may be a leaf or a text node, in which case we're
    // already where we want to be and can just use the child's length as
    // our offset.
    leafKey = nullthrows(offsetKey);
    textLength = getTextContentLength(nodeBeforeCursor);
  } else {
    // Otherwise, we'll look at the child to the left of the cursor and find
    // the last leaf node in its subtree.
    var lastLeaf = getLastLeaf(nodeBeforeCursor);
    leafKey = nullthrows(getSelectionOffsetKeyForNode(lastLeaf));
    textLength = getTextContentLength(lastLeaf);
  }

  return {
    key: leafKey,
    offset: textLength
  };
}

/**
 * Return the length of a node's textContent, regarding single newline
 * characters as zero-length. This allows us to avoid problems with identifying
 * the correct selection offset for empty blocks in IE, in which we
 * render newlines instead of break tags.
 */
function getTextContentLength(node) {
  var textContent = node.textContent;
  return textContent === '\n' ? 0 : textContent.length;
}

module.exports = getDraftEditorSelectionWithNodes;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getFragmentFromSelection
 * @format
 * 
 */



var getContentStateFragment = __webpack_require__(372);

function getFragmentFromSelection(editorState) {
  var selectionState = editorState.getSelection();

  if (selectionState.isCollapsed()) {
    return null;
  }

  return getContentStateFragment(editorState.getCurrentContent(), selectionState);
}

module.exports = getFragmentFromSelection;

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getNextDelimiterBlockKey
 * @format
 * 
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */

var ContentBlockNode = __webpack_require__(122);

var getNextDelimiterBlockKey = function getNextDelimiterBlockKey(block, blockMap) {
  var isExperimentalTreeBlock = block instanceof ContentBlockNode;

  if (!isExperimentalTreeBlock) {
    return null;
  }

  var nextSiblingKey = block.getNextSiblingKey();

  if (nextSiblingKey) {
    return nextSiblingKey;
  }

  var parent = block.getParentKey();

  if (!parent) {
    return null;
  }

  var nextNonDescendantBlock = blockMap.get(parent);
  while (nextNonDescendantBlock && !nextNonDescendantBlock.getNextSiblingKey()) {
    var parentKey = nextNonDescendantBlock.getParentKey();
    nextNonDescendantBlock = parentKey ? blockMap.get(parentKey) : null;
  }

  if (!nextNonDescendantBlock) {
    return null;
  }

  return nextNonDescendantBlock.getNextSiblingKey();
};

module.exports = getNextDelimiterBlockKey;

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getRangeClientRects
 * @format
 * 
 */



var UserAgent = __webpack_require__(148);

var invariant = __webpack_require__(23);

var isChrome = UserAgent.isBrowser('Chrome');

// In Chrome, the client rects will include the entire bounds of all nodes that
// begin (have a start tag) within the selection, even if the selection does
// not overlap the entire node. To resolve this, we split the range at each
// start tag and join the client rects together.
// https://code.google.com/p/chromium/issues/detail?id=324437
/* eslint-disable consistent-return */
function getRangeClientRectsChrome(range) {
  var tempRange = range.cloneRange();
  var clientRects = [];

  for (var ancestor = range.endContainer; ancestor != null; ancestor = ancestor.parentNode) {
    // If we've climbed up to the common ancestor, we can now use the
    // original start point and stop climbing the tree.
    var atCommonAncestor = ancestor === range.commonAncestorContainer;
    if (atCommonAncestor) {
      tempRange.setStart(range.startContainer, range.startOffset);
    } else {
      tempRange.setStart(tempRange.endContainer, 0);
    }
    var rects = Array.from(tempRange.getClientRects());
    clientRects.push(rects);
    if (atCommonAncestor) {
      var _ref;

      clientRects.reverse();
      return (_ref = []).concat.apply(_ref, clientRects);
    }
    tempRange.setEndBefore(ancestor);
  }

   true ?  false ? invariant(false, 'Found an unexpected detached subtree when getting range client rects.') : invariant(false) : void 0;
}
/* eslint-enable consistent-return */

/**
 * Like range.getClientRects() but normalizes for browser bugs.
 */
var getRangeClientRects = isChrome ? getRangeClientRectsChrome : function (range) {
  return Array.from(range.getClientRects());
};

module.exports = getRangeClientRects;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getSafeBodyFromHTML
 * @format
 * 
 */



var UserAgent = __webpack_require__(148);

var invariant = __webpack_require__(23);

var isOldIE = UserAgent.isBrowser('IE <= 9');

// Provides a dom node that will not execute scripts
// https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation.createHTMLDocument
// https://developer.mozilla.org/en-US/Add-ons/Code_snippets/HTML_to_DOM

function getSafeBodyFromHTML(html) {
  var doc;
  var root = null;
  // Provides a safe context
  if (!isOldIE && document.implementation && document.implementation.createHTMLDocument) {
    doc = document.implementation.createHTMLDocument('foo');
    !doc.documentElement ?  false ? invariant(false, 'Missing doc.documentElement') : invariant(false) : void 0;
    doc.documentElement.innerHTML = html;
    root = doc.getElementsByTagName('body')[0];
  }
  return root;
}

module.exports = getSafeBodyFromHTML;

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getSelectionOffsetKeyForNode
 * @format
 * 
 */



/**
 * Get offset key from a node or it's child nodes. Return the first offset key
 * found on the DOM tree of given node.
 */

function getSelectionOffsetKeyForNode(node) {
  if (node instanceof Element) {
    var offsetKey = node.getAttribute('data-offset-key');
    if (offsetKey) {
      return offsetKey;
    }
    for (var ii = 0; ii < node.childNodes.length; ii++) {
      var childOffsetKey = getSelectionOffsetKeyForNode(node.childNodes[ii]);
      if (childOffsetKey) {
        return childOffsetKey;
      }
    }
  }
  return null;
}

module.exports = getSelectionOffsetKeyForNode;

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getTextContentFromFiles
 * @format
 * 
 */



var invariant = __webpack_require__(23);

var TEXT_CLIPPING_REGEX = /\.textClipping$/;

var TEXT_TYPES = {
  'text/plain': true,
  'text/html': true,
  'text/rtf': true
};

// Somewhat arbitrary upper bound on text size. Let's not lock up the browser.
var TEXT_SIZE_UPPER_BOUND = 5000;

/**
 * Extract the text content from a file list.
 */
function getTextContentFromFiles(files, callback) {
  var readCount = 0;
  var results = [];
  files.forEach(function ( /*blob*/file) {
    readFile(file, function ( /*string*/text) {
      readCount++;
      text && results.push(text.slice(0, TEXT_SIZE_UPPER_BOUND));
      if (readCount == files.length) {
        callback(results.join('\r'));
      }
    });
  });
}

/**
 * todo isaac: Do work to turn html/rtf into a content fragment.
 */
function readFile(file, callback) {
  if (!global.FileReader || file.type && !(file.type in TEXT_TYPES)) {
    callback('');
    return;
  }

  if (file.type === '') {
    var contents = '';
    // Special-case text clippings, which have an empty type but include
    // `.textClipping` in the file name. `readAsText` results in an empty
    // string for text clippings, so we force the file name to serve
    // as the text value for the file.
    if (TEXT_CLIPPING_REGEX.test(file.name)) {
      contents = file.name.replace(TEXT_CLIPPING_REGEX, '');
    }
    callback(contents);
    return;
  }

  var reader = new FileReader();
  reader.onload = function () {
    var result = reader.result;
    !(typeof result === 'string') ?  false ? invariant(false, 'We should be calling "FileReader.readAsText" which returns a string') : invariant(false) : void 0;
    callback(result);
  };
  reader.onerror = function () {
    callback('');
  };
  reader.readAsText(file);
}

module.exports = getTextContentFromFiles;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74)))

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getUpdatedSelectionState
 * @format
 * 
 */



var DraftOffsetKey = __webpack_require__(371);

var nullthrows = __webpack_require__(136);

function getUpdatedSelectionState(editorState, anchorKey, anchorOffset, focusKey, focusOffset) {
  var selection = nullthrows(editorState.getSelection());
  if (false) {
    if (!anchorKey || !focusKey) {
      /*eslint-disable no-console */
      console.warn('Invalid selection state.', arguments, editorState.toJS());
      /*eslint-enable no-console */
      return selection;
    }
  }

  var anchorPath = DraftOffsetKey.decode(anchorKey);
  var anchorBlockKey = anchorPath.blockKey;
  var anchorLeaf = editorState.getBlockTree(anchorBlockKey).getIn([anchorPath.decoratorKey, 'leaves', anchorPath.leafKey]);

  var focusPath = DraftOffsetKey.decode(focusKey);
  var focusBlockKey = focusPath.blockKey;
  var focusLeaf = editorState.getBlockTree(focusBlockKey).getIn([focusPath.decoratorKey, 'leaves', focusPath.leafKey]);

  var anchorLeafStart = anchorLeaf.get('start');
  var focusLeafStart = focusLeaf.get('start');

  var anchorBlockOffset = anchorLeaf ? anchorLeafStart + anchorOffset : null;
  var focusBlockOffset = focusLeaf ? focusLeafStart + focusOffset : null;

  var areEqual = selection.getAnchorKey() === anchorBlockKey && selection.getAnchorOffset() === anchorBlockOffset && selection.getFocusKey() === focusBlockKey && selection.getFocusOffset() === focusBlockOffset;

  if (areEqual) {
    return selection;
  }

  var isBackward = false;
  if (anchorBlockKey === focusBlockKey) {
    var anchorLeafEnd = anchorLeaf.get('end');
    var focusLeafEnd = focusLeaf.get('end');
    if (focusLeafStart === anchorLeafStart && focusLeafEnd === anchorLeafEnd) {
      isBackward = focusOffset < anchorOffset;
    } else {
      isBackward = focusLeafStart < anchorLeafStart;
    }
  } else {
    var startKey = editorState.getCurrentContent().getBlockMap().keySeq().skipUntil(function (v) {
      return v === anchorBlockKey || v === focusBlockKey;
    }).first();
    isBackward = startKey === focusBlockKey;
  }

  return selection.merge({
    anchorKey: anchorBlockKey,
    anchorOffset: anchorBlockOffset,
    focusKey: focusBlockKey,
    focusOffset: focusBlockOffset,
    isBackward: isBackward
  });
}

module.exports = getUpdatedSelectionState;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule insertIntoList
 * @format
 * 
 */



/**
 * Maintain persistence for target list when appending and prepending.
 */
function insertIntoList(targetList, toInsert, offset) {
  if (offset === targetList.count()) {
    toInsert.forEach(function (c) {
      targetList = targetList.push(c);
    });
  } else if (offset === 0) {
    toInsert.reverse().forEach(function (c) {
      targetList = targetList.unshift(c);
    });
  } else {
    var head = targetList.slice(0, offset);
    var tail = targetList.slice(offset);
    targetList = head.concat(toInsert, tail).toList();
  }
  return targetList;
}

module.exports = insertIntoList;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isSelectionAtLeafStart
 * @format
 * 
 */



function isSelectionAtLeafStart(editorState) {
  var selection = editorState.getSelection();
  var anchorKey = selection.getAnchorKey();
  var blockTree = editorState.getBlockTree(anchorKey);
  var offset = selection.getStartOffset();

  var isAtStart = false;

  blockTree.some(function (leafSet) {
    if (offset === leafSet.get('start')) {
      isAtStart = true;
      return true;
    }

    if (offset < leafSet.get('end')) {
      return leafSet.get('leaves').some(function (leaf) {
        var leafStart = leaf.get('start');
        if (offset === leafStart) {
          isAtStart = true;
          return true;
        }

        return false;
      });
    }

    return false;
  });

  return isAtStart;
}

module.exports = isSelectionAtLeafStart;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule moveSelectionForward
 * @format
 * 
 */



/**
 * Given a collapsed selection, move the focus `maxDistance` forward within
 * the selected block. If the selection will go beyond the end of the block,
 * move focus to the start of the next block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */
function moveSelectionForward(editorState, maxDistance) {
  var selection = editorState.getSelection();
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();
  var content = editorState.getCurrentContent();

  var focusKey = key;
  var focusOffset;

  var block = content.getBlockForKey(key);

  if (maxDistance > block.getText().length - offset) {
    focusKey = content.getKeyAfter(key);
    focusOffset = 0;
  } else {
    focusOffset = offset + maxDistance;
  }

  return selection.merge({ focusKey: focusKey, focusOffset: focusOffset });
}

module.exports = moveSelectionForward;

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule randomizeBlockMapKeys
 * @format
 * 
 */



var ContentBlockNode = __webpack_require__(122);
var Immutable = __webpack_require__(45);

var generateRandomKey = __webpack_require__(167);

var OrderedMap = Immutable.OrderedMap;


var randomizeContentBlockNodeKeys = function randomizeContentBlockNodeKeys(blockMap) {
  var newKeysRef = {};

  // we keep track of root blocks in order to update subsequent sibling links
  var lastRootBlock = void 0;

  return OrderedMap(blockMap.withMutations(function (blockMapState) {
    blockMapState.forEach(function (block, index) {
      var oldKey = block.getKey();
      var nextKey = block.getNextSiblingKey();
      var prevKey = block.getPrevSiblingKey();
      var childrenKeys = block.getChildKeys();
      var parentKey = block.getParentKey();

      // new key that we will use to build linking
      var key = generateRandomKey();

      // we will add it here to re-use it later
      newKeysRef[oldKey] = key;

      if (nextKey) {
        var nextBlock = blockMapState.get(nextKey);
        if (nextBlock) {
          blockMapState.setIn([nextKey, 'prevSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'nextSibling'], null);
        }
      }

      if (prevKey) {
        var prevBlock = blockMapState.get(prevKey);
        if (prevBlock) {
          blockMapState.setIn([prevKey, 'nextSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'prevSibling'], null);
        }
      }

      if (parentKey && blockMapState.get(parentKey)) {
        var parentBlock = blockMapState.get(parentKey);
        var parentChildrenList = parentBlock.getChildKeys();
        blockMapState.setIn([parentKey, 'children'], parentChildrenList.set(parentChildrenList.indexOf(block.getKey()), key));
      } else {
        // blocks will then be treated as root block nodes
        blockMapState.setIn([oldKey, 'parent'], null);

        if (lastRootBlock) {
          blockMapState.setIn([lastRootBlock.getKey(), 'nextSibling'], key);
          blockMapState.setIn([oldKey, 'prevSibling'], newKeysRef[lastRootBlock.getKey()]);
        }

        lastRootBlock = blockMapState.get(oldKey);
      }

      childrenKeys.forEach(function (childKey) {
        var childBlock = blockMapState.get(childKey);
        if (childBlock) {
          blockMapState.setIn([childKey, 'parent'], key);
        } else {
          blockMapState.setIn([oldKey, 'children'], block.getChildKeys().filter(function (child) {
            return child !== childKey;
          }));
        }
      });
    });
  }).toArray().map(function (block) {
    return [newKeysRef[block.getKey()], block.set('key', newKeysRef[block.getKey()])];
  }));
};

var randomizeContentBlockKeys = function randomizeContentBlockKeys(blockMap) {
  return OrderedMap(blockMap.toArray().map(function (block) {
    var key = generateRandomKey();
    return [key, block.set('key', key)];
  }));
};

var randomizeBlockMapKeys = function randomizeBlockMapKeys(blockMap) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;

  if (!isTreeBasedBlockMap) {
    return randomizeContentBlockKeys(blockMap);
  }

  return randomizeContentBlockNodeKeys(blockMap);
};

module.exports = randomizeBlockMapKeys;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule removeEntitiesAtEdges
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(117);

var findRangesImmutable = __webpack_require__(300);
var invariant = __webpack_require__(23);

function removeEntitiesAtEdges(contentState, selectionState) {
  var blockMap = contentState.getBlockMap();
  var entityMap = contentState.getEntityMap();

  var updatedBlocks = {};

  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var startBlock = blockMap.get(startKey);
  var updatedStart = removeForBlock(entityMap, startBlock, startOffset);

  if (updatedStart !== startBlock) {
    updatedBlocks[startKey] = updatedStart;
  }

  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var endBlock = blockMap.get(endKey);
  if (startKey === endKey) {
    endBlock = updatedStart;
  }

  var updatedEnd = removeForBlock(entityMap, endBlock, endOffset);

  if (updatedEnd !== endBlock) {
    updatedBlocks[endKey] = updatedEnd;
  }

  if (!Object.keys(updatedBlocks).length) {
    return contentState.set('selectionAfter', selectionState);
  }

  return contentState.merge({
    blockMap: blockMap.merge(updatedBlocks),
    selectionAfter: selectionState
  });
}

function getRemovalRange(characters, key, offset) {
  var removalRange;
  findRangesImmutable(characters, function (a, b) {
    return a.getEntity() === b.getEntity();
  }, function (element) {
    return element.getEntity() === key;
  }, function (start, end) {
    if (start <= offset && end >= offset) {
      removalRange = { start: start, end: end };
    }
  });
  !(typeof removalRange === 'object') ?  false ? invariant(false, 'Removal range must exist within character list.') : invariant(false) : void 0;
  return removalRange;
}

function removeForBlock(entityMap, block, offset) {
  var chars = block.getCharacterList();
  var charBefore = offset > 0 ? chars.get(offset - 1) : undefined;
  var charAfter = offset < chars.count() ? chars.get(offset) : undefined;
  var entityBeforeCursor = charBefore ? charBefore.getEntity() : undefined;
  var entityAfterCursor = charAfter ? charAfter.getEntity() : undefined;

  if (entityAfterCursor && entityAfterCursor === entityBeforeCursor) {
    var entity = entityMap.__get(entityAfterCursor);
    if (entity.getMutability() !== 'MUTABLE') {
      var _getRemovalRange = getRemovalRange(chars, entityAfterCursor, offset),
          start = _getRemovalRange.start,
          end = _getRemovalRange.end;

      var current;
      while (start < end) {
        current = chars.get(start);
        chars = chars.set(start, CharacterMetadata.applyEntity(current, null));
        start++;
      }
      return block.set('characterList', chars);
    }
  }

  return block;
}

module.exports = removeEntitiesAtEdges;

/***/ }),
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"btn-link":"btn-link__13J3S","pinned":"pinned__gGsax","progress":"progress__eQv14","progressBar":"progressBar__3Wj_v"};

/***/ }),
/* 828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"red":"red__1awQ8","gray":"gray__szUkm","white":"white__KTgOm","checkbox":"checkbox__NGtOB"};

/***/ }),
/* 829 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__6YvVc","wrapper-nopadding":"wrapper-nopadding__2rrRW","loading":"loading__10cMc","error":"error__1cAV6","table-loading":"table-loading__1F-Ti","empty-val":"empty-val__2NUb5","panelheader-tools":"panelheader-tools__34yZw","propsPanels":"propsPanels__1-nWd","new":"new__ce9KG","marginLm":"marginLm__2ueSu","marginRm":"marginRm__1bHPf","fullWidth":"fullWidth__1Yuy2","fullHeight":"fullHeight__2B757","noData":"noData__1oE_u","sample":"sample__X6J3p","Identifier":"Identifier__1n_8v","Keyword":"Keyword__jtpZR","String":"String__2-ios","Punctuator":"Punctuator__M8pcN","LineComment":"LineComment__7RDoX","BlockComment":"BlockComment__1FXR9","Numeric":"Numeric__dgRJf"};

/***/ }),
/* 830 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__W4TY-","wrapper-nopadding":"wrapper-nopadding__1fgA-","loading":"loading__1aWFv","error":"error__2HJxK","table-loading":"table-loading__3VULf","empty-val":"empty-val__2JxiE","panelheader-tools":"panelheader-tools__LYmCA","propsPanels":"propsPanels__3Ge43","new":"new__HAfdt","marginLm":"marginLm__3KThf","marginRm":"marginRm__gWR-9","fullWidth":"fullWidth__2JS7A","fullHeight":"fullHeight__2y8PL","noData":"noData__XcAxe","compact":"compact__3cabo","dataTable":"dataTable__CkG4P","pager":"pager__22Tym","marinRight":"marinRight__xTaTX"};

/***/ }),
/* 831 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3T4nV","wrapper-nopadding":"wrapper-nopadding__2lVpF","loading":"loading__2xfDn","error":"error__3THro","table-loading":"table-loading__3Z9MY","empty-val":"empty-val__17ws-","panelheader-tools":"panelheader-tools__1EzGv","propsPanels":"propsPanels__321PQ","new":"new__3ooMo","marginLm":"marginLm__3uTE0","marginRm":"marginRm__38RTg","fullWidth":"fullWidth__1BrI6","fullHeight":"fullHeight__3RoxS","noData":"noData__1E_37","helpdoc":"helpdoc__1SAGz","dropzone":"dropzone__1Bfaj","dropzone-active":"dropzone-active__3kLlC","f-checkbox":"f-checkbox__3VjGW","preview":"preview__3pneD","submit":"submit__2p0Sa","tips":"tips__1PoGx","result-notimport":"result-notimport__3fbKS","result-succ":"result-succ__tUwnx","result-fail":"result-fail__2ZdI2","result-summary":"result-summary__31QC7","tools":"tools__w9ryW","missing":"missing__22FRt","invalid":"invalid__1ox7j"};

/***/ }),
/* 832 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__VH5pY","wrapper-nopadding":"wrapper-nopadding__1U1KX","loading":"loading__2nll6","error":"error__2S8Bg","table-loading":"table-loading__xIhYy","empty-val":"empty-val__1ECKw","panelheader-tools":"panelheader-tools__2jpsd","propsPanels":"propsPanels__3T08x","new":"new__1zDeb","marginLm":"marginLm__hYB35","marginRm":"marginRm__1hc92","fullWidth":"fullWidth__1ax0s","fullHeight":"fullHeight__1QF6T","noData":"noData__2feGs"};

/***/ }),
/* 833 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var PhotosMimeType = __webpack_require__(2327);

var createArrayFromMixed = __webpack_require__(839);
var emptyFunction = __webpack_require__(103);

var CR_LF_REGEX = new RegExp('\r\n', 'g');
var LF_ONLY = '\n';

var RICH_TEXT_TYPES = {
  'text/rtf': 1,
  'text/html': 1
};

/**
 * If DataTransferItem is a file then return the Blob of data.
 *
 * @param {object} item
 * @return {?blob}
 */
function getFileFromDataTransfer(item) {
  if (item.kind == 'file') {
    return item.getAsFile();
  }
}

var DataTransfer = function () {
  /**
   * @param {object} data
   */
  function DataTransfer(data) {
    _classCallCheck(this, DataTransfer);

    this.data = data;

    // Types could be DOMStringList or array
    this.types = data.types ? createArrayFromMixed(data.types) : [];
  }

  /**
   * Is this likely to be a rich text data transfer?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.isRichText = function isRichText() {
    // If HTML is available, treat this data as rich text. This way, we avoid
    // using a pasted image if it is packaged with HTML -- this may occur with
    // pastes from MS Word, for example.  However this is only rich text if
    // there's accompanying text.
    if (this.getHTML() && this.getText()) {
      return true;
    }

    // When an image is copied from a preview window, you end up with two
    // DataTransferItems one of which is a file's metadata as text.  Skip those.
    if (this.isImage()) {
      return false;
    }

    return this.types.some(function (type) {
      return RICH_TEXT_TYPES[type];
    });
  };

  /**
   * Get raw text.
   *
   * @return {?string}
   */


  DataTransfer.prototype.getText = function getText() {
    var text;
    if (this.data.getData) {
      if (!this.types.length) {
        text = this.data.getData('Text');
      } else if (this.types.indexOf('text/plain') != -1) {
        text = this.data.getData('text/plain');
      }
    }
    return text ? text.replace(CR_LF_REGEX, LF_ONLY) : null;
  };

  /**
   * Get HTML paste data
   *
   * @return {?string}
   */


  DataTransfer.prototype.getHTML = function getHTML() {
    if (this.data.getData) {
      if (!this.types.length) {
        return this.data.getData('Text');
      } else if (this.types.indexOf('text/html') != -1) {
        return this.data.getData('text/html');
      }
    }
  };

  /**
   * Is this a link data transfer?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.isLink = function isLink() {
    return this.types.some(function (type) {
      return type.indexOf('Url') != -1 || type.indexOf('text/uri-list') != -1 || type.indexOf('text/x-moz-url');
    });
  };

  /**
   * Get a link url.
   *
   * @return {?string}
   */


  DataTransfer.prototype.getLink = function getLink() {
    if (this.data.getData) {
      if (this.types.indexOf('text/x-moz-url') != -1) {
        var url = this.data.getData('text/x-moz-url').split('\n');
        return url[0];
      }
      return this.types.indexOf('text/uri-list') != -1 ? this.data.getData('text/uri-list') : this.data.getData('url');
    }

    return null;
  };

  /**
   * Is this an image data transfer?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.isImage = function isImage() {
    var isImage = this.types.some(function (type) {
      // Firefox will have a type of application/x-moz-file for images during
      // dragging
      return type.indexOf('application/x-moz-file') != -1;
    });

    if (isImage) {
      return true;
    }

    var items = this.getFiles();
    for (var i = 0; i < items.length; i++) {
      var type = items[i].type;
      if (!PhotosMimeType.isImage(type)) {
        return false;
      }
    }

    return true;
  };

  DataTransfer.prototype.getCount = function getCount() {
    if (this.data.hasOwnProperty('items')) {
      return this.data.items.length;
    } else if (this.data.hasOwnProperty('mozItemCount')) {
      return this.data.mozItemCount;
    } else if (this.data.files) {
      return this.data.files.length;
    }
    return null;
  };

  /**
   * Get files.
   *
   * @return {array}
   */


  DataTransfer.prototype.getFiles = function getFiles() {
    if (this.data.items) {
      // createArrayFromMixed doesn't properly handle DataTransferItemLists.
      return Array.prototype.slice.call(this.data.items).map(getFileFromDataTransfer).filter(emptyFunction.thatReturnsArgument);
    } else if (this.data.files) {
      return Array.prototype.slice.call(this.data.files);
    } else {
      return [];
    }
  };

  /**
   * Are there any files to fetch?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.hasFiles = function hasFiles() {
    return this.getFiles().length > 0;
  };

  return DataTransfer;
}();

module.exports = DataTransfer;

/***/ }),
/* 835 */,
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * @param {DOMElement} element
 * @param {DOMDocument} doc
 * @return {boolean}
 */
function _isViewportScrollElement(element, doc) {
  return !!doc && (element === doc.documentElement || element === doc.body);
}

/**
 * Scroll Module. This class contains 4 simple static functions
 * to be used to access Element.scrollTop/scrollLeft properties.
 * To solve the inconsistencies between browsers when either
 * document.body or document.documentElement is supplied,
 * below logic will be used to alleviate the issue:
 *
 * 1. If 'element' is either 'document.body' or 'document.documentElement,
 *    get whichever element's 'scroll{Top,Left}' is larger.
 * 2. If 'element' is either 'document.body' or 'document.documentElement',
 *    set the 'scroll{Top,Left}' on both elements.
 */

var Scroll = {
  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getTop: function getTop(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ?
    // In practice, they will either both have the same value,
    // or one will be zero and the other will be the scroll position
    // of the viewport. So we can use `X || Y` instead of `Math.max(X, Y)`
    doc.body.scrollTop || doc.documentElement.scrollTop : element.scrollTop;
  },

  /**
   * @param {DOMElement} element
   * @param {number} newTop
   */
  setTop: function setTop(element, newTop) {
    var doc = element.ownerDocument;
    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollTop = doc.documentElement.scrollTop = newTop;
    } else {
      element.scrollTop = newTop;
    }
  },

  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getLeft: function getLeft(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ? doc.body.scrollLeft || doc.documentElement.scrollLeft : element.scrollLeft;
  },

  /**
   * @param {DOMElement} element
   * @param {number} newLeft
   */
  setLeft: function setLeft(element, newLeft) {
    var doc = element.ownerDocument;
    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollLeft = doc.documentElement.scrollLeft = newLeft;
    } else {
      element.scrollLeft = newLeft;
    }
  }
};

module.exports = Scroll;

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Basic (stateless) API for text direction detection
 *
 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */



var UnicodeBidiDirection = __webpack_require__(534);

var invariant = __webpack_require__(23);

/**
 * RegExp ranges of characters with a *Strong* Bidi_Class value.
 *
 * Data is based on DerivedBidiClass.txt in UCD version 7.0.0.
 *
 * NOTE: For performance reasons, we only support Unicode's
 *       Basic Multilingual Plane (BMP) for now.
 */
var RANGE_BY_BIDI_TYPE = {

  L: 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u01BA\u01BB' + '\u01BC-\u01BF\u01C0-\u01C3\u01C4-\u0293\u0294\u0295-\u02AF\u02B0-\u02B8' + '\u02BB-\u02C1\u02D0-\u02D1\u02E0-\u02E4\u02EE\u0370-\u0373\u0376-\u0377' + '\u037A\u037B-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1' + '\u03A3-\u03F5\u03F7-\u0481\u0482\u048A-\u052F\u0531-\u0556\u0559' + '\u055A-\u055F\u0561-\u0587\u0589\u0903\u0904-\u0939\u093B\u093D' + '\u093E-\u0940\u0949-\u094C\u094E-\u094F\u0950\u0958-\u0961\u0964-\u0965' + '\u0966-\u096F\u0970\u0971\u0972-\u0980\u0982-\u0983\u0985-\u098C' + '\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD' + '\u09BE-\u09C0\u09C7-\u09C8\u09CB-\u09CC\u09CE\u09D7\u09DC-\u09DD' + '\u09DF-\u09E1\u09E6-\u09EF\u09F0-\u09F1\u09F4-\u09F9\u09FA\u0A03' + '\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33' + '\u0A35-\u0A36\u0A38-\u0A39\u0A3E-\u0A40\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F' + '\u0A72-\u0A74\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0' + '\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0ABE-\u0AC0\u0AC9\u0ACB-\u0ACC\u0AD0' + '\u0AE0-\u0AE1\u0AE6-\u0AEF\u0AF0\u0B02-\u0B03\u0B05-\u0B0C\u0B0F-\u0B10' + '\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B3E\u0B40' + '\u0B47-\u0B48\u0B4B-\u0B4C\u0B57\u0B5C-\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F' + '\u0B70\u0B71\u0B72-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95' + '\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9' + '\u0BBE-\u0BBF\u0BC1-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7' + '\u0BE6-\u0BEF\u0BF0-\u0BF2\u0C01-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10' + '\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C41-\u0C44\u0C58-\u0C59\u0C60-\u0C61' + '\u0C66-\u0C6F\u0C7F\u0C82-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8' + '\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CBE\u0CBF\u0CC0-\u0CC4\u0CC6' + '\u0CC7-\u0CC8\u0CCA-\u0CCB\u0CD5-\u0CD6\u0CDE\u0CE0-\u0CE1\u0CE6-\u0CEF' + '\u0CF1-\u0CF2\u0D02-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D' + '\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D60-\u0D61' + '\u0D66-\u0D6F\u0D70-\u0D75\u0D79\u0D7A-\u0D7F\u0D82-\u0D83\u0D85-\u0D96' + '\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD1\u0DD8-\u0DDF' + '\u0DE6-\u0DEF\u0DF2-\u0DF3\u0DF4\u0E01-\u0E30\u0E32-\u0E33\u0E40-\u0E45' + '\u0E46\u0E4F\u0E50-\u0E59\u0E5A-\u0E5B\u0E81-\u0E82\u0E84\u0E87-\u0E88' + '\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7' + '\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6' + '\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F01-\u0F03\u0F04-\u0F12\u0F13\u0F14' + '\u0F15-\u0F17\u0F1A-\u0F1F\u0F20-\u0F29\u0F2A-\u0F33\u0F34\u0F36\u0F38' + '\u0F3E-\u0F3F\u0F40-\u0F47\u0F49-\u0F6C\u0F7F\u0F85\u0F88-\u0F8C' + '\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FCF\u0FD0-\u0FD4\u0FD5-\u0FD8' + '\u0FD9-\u0FDA\u1000-\u102A\u102B-\u102C\u1031\u1038\u103B-\u103C\u103F' + '\u1040-\u1049\u104A-\u104F\u1050-\u1055\u1056-\u1057\u105A-\u105D\u1061' + '\u1062-\u1064\u1065-\u1066\u1067-\u106D\u106E-\u1070\u1075-\u1081' + '\u1083-\u1084\u1087-\u108C\u108E\u108F\u1090-\u1099\u109A-\u109C' + '\u109E-\u109F\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FB\u10FC' + '\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288' + '\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5' + '\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1360-\u1368' + '\u1369-\u137C\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166D-\u166E' + '\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EB-\u16ED\u16EE-\u16F0' + '\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1735-\u1736' + '\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17B6\u17BE-\u17C5' + '\u17C7-\u17C8\u17D4-\u17D6\u17D7\u17D8-\u17DA\u17DC\u17E0-\u17E9' + '\u1810-\u1819\u1820-\u1842\u1843\u1844-\u1877\u1880-\u18A8\u18AA' + '\u18B0-\u18F5\u1900-\u191E\u1923-\u1926\u1929-\u192B\u1930-\u1931' + '\u1933-\u1938\u1946-\u194F\u1950-\u196D\u1970-\u1974\u1980-\u19AB' + '\u19B0-\u19C0\u19C1-\u19C7\u19C8-\u19C9\u19D0-\u19D9\u19DA\u1A00-\u1A16' + '\u1A19-\u1A1A\u1A1E-\u1A1F\u1A20-\u1A54\u1A55\u1A57\u1A61\u1A63-\u1A64' + '\u1A6D-\u1A72\u1A80-\u1A89\u1A90-\u1A99\u1AA0-\u1AA6\u1AA7\u1AA8-\u1AAD' + '\u1B04\u1B05-\u1B33\u1B35\u1B3B\u1B3D-\u1B41\u1B43-\u1B44\u1B45-\u1B4B' + '\u1B50-\u1B59\u1B5A-\u1B60\u1B61-\u1B6A\u1B74-\u1B7C\u1B82\u1B83-\u1BA0' + '\u1BA1\u1BA6-\u1BA7\u1BAA\u1BAE-\u1BAF\u1BB0-\u1BB9\u1BBA-\u1BE5\u1BE7' + '\u1BEA-\u1BEC\u1BEE\u1BF2-\u1BF3\u1BFC-\u1BFF\u1C00-\u1C23\u1C24-\u1C2B' + '\u1C34-\u1C35\u1C3B-\u1C3F\u1C40-\u1C49\u1C4D-\u1C4F\u1C50-\u1C59' + '\u1C5A-\u1C77\u1C78-\u1C7D\u1C7E-\u1C7F\u1CC0-\u1CC7\u1CD3\u1CE1' + '\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF2-\u1CF3\u1CF5-\u1CF6\u1D00-\u1D2B' + '\u1D2C-\u1D6A\u1D6B-\u1D77\u1D78\u1D79-\u1D9A\u1D9B-\u1DBF\u1E00-\u1F15' + '\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D' + '\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC' + '\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200E' + '\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D' + '\u2124\u2126\u2128\u212A-\u212D\u212F-\u2134\u2135-\u2138\u2139' + '\u213C-\u213F\u2145-\u2149\u214E\u214F\u2160-\u2182\u2183-\u2184' + '\u2185-\u2188\u2336-\u237A\u2395\u249C-\u24E9\u26AC\u2800-\u28FF' + '\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2C7B\u2C7C-\u2C7D\u2C7E-\u2CE4' + '\u2CEB-\u2CEE\u2CF2-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F' + '\u2D70\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE' + '\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005\u3006\u3007' + '\u3021-\u3029\u302E-\u302F\u3031-\u3035\u3038-\u303A\u303B\u303C' + '\u3041-\u3096\u309D-\u309E\u309F\u30A1-\u30FA\u30FC-\u30FE\u30FF' + '\u3105-\u312D\u3131-\u318E\u3190-\u3191\u3192-\u3195\u3196-\u319F' + '\u31A0-\u31BA\u31F0-\u31FF\u3200-\u321C\u3220-\u3229\u322A-\u3247' + '\u3248-\u324F\u3260-\u327B\u327F\u3280-\u3289\u328A-\u32B0\u32C0-\u32CB' + '\u32D0-\u32FE\u3300-\u3376\u337B-\u33DD\u33E0-\u33FE\u3400-\u4DB5' + '\u4E00-\u9FCC\uA000-\uA014\uA015\uA016-\uA48C\uA4D0-\uA4F7\uA4F8-\uA4FD' + '\uA4FE-\uA4FF\uA500-\uA60B\uA60C\uA610-\uA61F\uA620-\uA629\uA62A-\uA62B' + '\uA640-\uA66D\uA66E\uA680-\uA69B\uA69C-\uA69D\uA6A0-\uA6E5\uA6E6-\uA6EF' + '\uA6F2-\uA6F7\uA722-\uA76F\uA770\uA771-\uA787\uA789-\uA78A\uA78B-\uA78E' + '\uA790-\uA7AD\uA7B0-\uA7B1\uA7F7\uA7F8-\uA7F9\uA7FA\uA7FB-\uA801' + '\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA823-\uA824\uA827\uA830-\uA835' + '\uA836-\uA837\uA840-\uA873\uA880-\uA881\uA882-\uA8B3\uA8B4-\uA8C3' + '\uA8CE-\uA8CF\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8F8-\uA8FA\uA8FB\uA900-\uA909' + '\uA90A-\uA925\uA92E-\uA92F\uA930-\uA946\uA952-\uA953\uA95F\uA960-\uA97C' + '\uA983\uA984-\uA9B2\uA9B4-\uA9B5\uA9BA-\uA9BB\uA9BD-\uA9C0\uA9C1-\uA9CD' + '\uA9CF\uA9D0-\uA9D9\uA9DE-\uA9DF\uA9E0-\uA9E4\uA9E6\uA9E7-\uA9EF' + '\uA9F0-\uA9F9\uA9FA-\uA9FE\uAA00-\uAA28\uAA2F-\uAA30\uAA33-\uAA34' + '\uAA40-\uAA42\uAA44-\uAA4B\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F\uAA60-\uAA6F' + '\uAA70\uAA71-\uAA76\uAA77-\uAA79\uAA7A\uAA7B\uAA7D\uAA7E-\uAAAF\uAAB1' + '\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADC\uAADD\uAADE-\uAADF' + '\uAAE0-\uAAEA\uAAEB\uAAEE-\uAAEF\uAAF0-\uAAF1\uAAF2\uAAF3-\uAAF4\uAAF5' + '\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E' + '\uAB30-\uAB5A\uAB5B\uAB5C-\uAB5F\uAB64-\uAB65\uABC0-\uABE2\uABE3-\uABE4' + '\uABE6-\uABE7\uABE9-\uABEA\uABEB\uABEC\uABF0-\uABF9\uAC00-\uD7A3' + '\uD7B0-\uD7C6\uD7CB-\uD7FB\uE000-\uF8FF\uF900-\uFA6D\uFA70-\uFAD9' + '\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFF6F\uFF70' + '\uFF71-\uFF9D\uFF9E-\uFF9F\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF' + '\uFFD2-\uFFD7\uFFDA-\uFFDC',

  R: '\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05D0-\u05EA\u05EB-\u05EF' + '\u05F0-\u05F2\u05F3-\u05F4\u05F5-\u05FF\u07C0-\u07C9\u07CA-\u07EA' + '\u07F4-\u07F5\u07FA\u07FB-\u07FF\u0800-\u0815\u081A\u0824\u0828' + '\u082E-\u082F\u0830-\u083E\u083F\u0840-\u0858\u085C-\u085D\u085E' + '\u085F-\u089F\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB37\uFB38-\uFB3C' + '\uFB3D\uFB3E\uFB3F\uFB40-\uFB41\uFB42\uFB43-\uFB44\uFB45\uFB46-\uFB4F',

  AL: '\u0608\u060B\u060D\u061B\u061C\u061D\u061E-\u061F\u0620-\u063F\u0640' + '\u0641-\u064A\u066D\u066E-\u066F\u0671-\u06D3\u06D4\u06D5\u06E5-\u06E6' + '\u06EE-\u06EF\u06FA-\u06FC\u06FD-\u06FE\u06FF\u0700-\u070D\u070E\u070F' + '\u0710\u0712-\u072F\u074B-\u074C\u074D-\u07A5\u07B1\u07B2-\u07BF' + '\u08A0-\u08B2\u08B3-\u08E3\uFB50-\uFBB1\uFBB2-\uFBC1\uFBC2-\uFBD2' + '\uFBD3-\uFD3D\uFD40-\uFD4F\uFD50-\uFD8F\uFD90-\uFD91\uFD92-\uFDC7' + '\uFDC8-\uFDCF\uFDF0-\uFDFB\uFDFC\uFDFE-\uFDFF\uFE70-\uFE74\uFE75' + '\uFE76-\uFEFC\uFEFD-\uFEFE'

};

var REGEX_STRONG = new RegExp('[' + RANGE_BY_BIDI_TYPE.L + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');

var REGEX_RTL = new RegExp('[' + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');

/**
 * Returns the first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     A character with strong bidi direction, or null if not found
 */
function firstStrongChar(str) {
  var match = REGEX_STRONG.exec(str);
  return match == null ? null : match[0];
}

/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     The resolved direction
 */
function firstStrongCharDir(str) {
  var strongChar = firstStrongChar(str);
  if (strongChar == null) {
    return UnicodeBidiDirection.NEUTRAL;
  }
  return REGEX_RTL.exec(strongChar) ? UnicodeBidiDirection.RTL : UnicodeBidiDirection.LTR;
}

/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str       A text block; e.g. paragraph, table cell, tag
 * @param fallback  Fallback direction, used if no strong direction detected
 *                  for the block (default = NEUTRAL)
 * @return          The resolved direction
 */
function resolveBlockDir(str, fallback) {
  fallback = fallback || UnicodeBidiDirection.NEUTRAL;
  if (!str.length) {
    return fallback;
  }
  var blockDir = firstStrongCharDir(str);
  return blockDir === UnicodeBidiDirection.NEUTRAL ? fallback : blockDir;
}

/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * NOTE: This function is similar to resolveBlockDir(), but uses the global
 * direction as the fallback, so it *always* returns a Strong direction,
 * making it useful for integration in places that you need to make the final
 * decision, like setting some CSS class.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                The resolved Strong direction
 */
function getDirection(str, strongFallback) {
  if (!strongFallback) {
    strongFallback = UnicodeBidiDirection.getGlobalDir();
  }
  !UnicodeBidiDirection.isStrong(strongFallback) ?  false ? invariant(false, 'Fallback direction must be a strong direction') : invariant(false) : void 0;
  return resolveBlockDir(str, strongFallback);
}

/**
 * Returns true if getDirection(arguments...) returns LTR.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is LTR
 */
function isDirectionLTR(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection.LTR;
}

/**
 * Returns true if getDirection(arguments...) returns RTL.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is RTL
 */
function isDirectionRTL(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection.RTL;
}

var UnicodeBidi = {
  firstStrongChar: firstStrongChar,
  firstStrongCharDir: firstStrongCharDir,
  resolveBlockDir: resolveBlockDir,
  getDirection: getDirection,
  isDirectionLTR: isDirectionLTR,
  isDirectionRTL: isDirectionRTL
};

module.exports = UnicodeBidi;

/***/ }),
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(68);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(540);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(195);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(2527);

var _runTransitionHook = __webpack_require__(540);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(265);

var _PathUtils = __webpack_require__(195);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery,
        parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(2378)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(2852);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!this.json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(2402);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(233),
    root = __webpack_require__(149);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(546),
    setCacheAdd = __webpack_require__(2483),
    setCacheHas = __webpack_require__(2484);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(149);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(865),
    isArguments = __webpack_require__(318),
    isArray = __webpack_require__(80),
    isBuffer = __webpack_require__(401),
    isIndex = __webpack_require__(553),
    isTypedArray = __webpack_require__(404);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 856 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 857 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(313),
    eq = __webpack_require__(316);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(313),
    eq = __webpack_require__(316);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 860 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(2448);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(869),
    toKey = __webpack_require__(400);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(315),
    nativeKeys = __webpack_require__(2479);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 864 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 865 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 866 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 867 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(234);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(80),
    isKey = __webpack_require__(554),
    stringToPath = __webpack_require__(2493),
    toString = __webpack_require__(197);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(394);

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsEndIndex;


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(394);

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsStartIndex;


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(406),
    toNumber = __webpack_require__(894),
    toString = __webpack_require__(197);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */
function createRound(methodName) {
  var func = Math[methodName];
  return function(number, precision) {
    number = toNumber(number);
    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
    if (precision) {
      // Shift with exponential notation to avoid floating-point issues.
      // See [MDN](https://mdn.io/round#Examples) for more details.
      var pair = (toString(number) + 'e').split('e'),
          value = func(pair[0] + 'e' + (+pair[1] + precision));

      pair = (toString(value) + 'e').split('e');
      return +(pair[0] + 'e' + (+pair[1] - precision));
    }
    return func(number);
  };
}

module.exports = createRound;


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(233);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(853),
    arraySome = __webpack_require__(857),
    cacheHas = __webpack_require__(867);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74)))

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(883);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(2405),
    Map = __webpack_require__(545),
    Promise = __webpack_require__(2407),
    Set = __webpack_require__(852),
    WeakMap = __webpack_require__(2408),
    baseGetTag = __webpack_require__(169),
    toSource = __webpack_require__(885);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(869),
    isArguments = __webpack_require__(318),
    isArray = __webpack_require__(80),
    isIndex = __webpack_require__(553),
    isLength = __webpack_require__(557),
    toKey = __webpack_require__(400);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 879 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(118);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 881 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(875);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(328)(module)))

/***/ }),
/* 883 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 884 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  return key == '__proto__'
    ? undefined
    : object[key];
}

module.exports = safeGet;


/***/ }),
/* 885 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(859),
    copyObject = __webpack_require__(551),
    createAssigner = __webpack_require__(552),
    isArrayLike = __webpack_require__(150),
    isPrototype = __webpack_require__(315),
    keys = __webpack_require__(268);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

var createRound = __webpack_require__(872);

/**
 * Computes `number` rounded up to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round up.
 * @param {number} [precision=0] The precision to round up to.
 * @returns {number} Returns the rounded up number.
 * @example
 *
 * _.ceil(4.006);
 * // => 5
 *
 * _.ceil(6.004, 2);
 * // => 6.01
 *
 * _.ceil(6040, -2);
 * // => 6100
 */
var ceil = createRound('ceil');

module.exports = ceil;


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEvery = __webpack_require__(2411),
    baseEvery = __webpack_require__(2417),
    baseIteratee = __webpack_require__(196),
    isArray = __webpack_require__(80),
    isIterateeCall = __webpack_require__(397);

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = every;


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(548),
    baseFilter = __webpack_require__(2418),
    baseIteratee = __webpack_require__(196),
    isArray = __webpack_require__(80);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(2410),
    baseEach = __webpack_require__(314),
    castFunction = __webpack_require__(868),
    isArray = __webpack_require__(80);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(393),
    castFunction = __webpack_require__(868);

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && baseForOwn(object, castFunction(iteratee));
}

module.exports = forOwn;


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(394),
    isArrayLike = __webpack_require__(150),
    isString = __webpack_require__(267),
    toInteger = __webpack_require__(406),
    values = __webpack_require__(2521);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(549);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(118),
    isSymbol = __webpack_require__(319);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(266),
    castSlice = __webpack_require__(395),
    charsEndIndex = __webpack_require__(870),
    stringToArray = __webpack_require__(399),
    toString = __webpack_require__(197);

/** Used to match leading and trailing whitespace. */
var reTrimEnd = /\s+$/;

/**
 * Removes trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimEnd('  abc  ');
 * // => '  abc'
 *
 * _.trimEnd('-_-abc-_-', '_-');
 * // => '-_-abc'
 */
function trimEnd(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrimEnd, '');
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

  return castSlice(strSymbols, 0, end).join('');
}

module.exports = trimEnd;


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(266),
    castSlice = __webpack_require__(395),
    charsStartIndex = __webpack_require__(871),
    stringToArray = __webpack_require__(399),
    toString = __webpack_require__(197);

/** Used to match leading and trailing whitespace. */
var reTrimStart = /^\s+/;

/**
 * Removes leading whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimStart('  abc  ');
 * // => 'abc  '
 *
 * _.trimStart('-_-abc-_-', '_-');
 * // => 'abc-_-'
 */
function trimStart(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrimStart, '');
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      start = charsStartIndex(strSymbols, stringToArray(chars));

  return castSlice(strSymbols, start).join('');
}

module.exports = trimStart;


/***/ }),
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ValidComponentChildren = exports.createChainedFunction = exports.bootstrapUtils = undefined;

var _bootstrapUtils2 = __webpack_require__(2593);

var _bootstrapUtils = _interopRequireWildcard(_bootstrapUtils2);

var _createChainedFunction2 = __webpack_require__(2594);

var _createChainedFunction3 = _interopRequireDefault(_createChainedFunction2);

var _ValidComponentChildren2 = __webpack_require__(2592);

var _ValidComponentChildren3 = _interopRequireDefault(_ValidComponentChildren2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

exports.bootstrapUtils = _bootstrapUtils;
exports.createChainedFunction = _createChainedFunction3['default'];
exports.ValidComponentChildren = _ValidComponentChildren3['default'];

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isObject2 = __webpack_require__(118);

var _isObject3 = _interopRequireDefault(_isObject2);

var _isArray2 = __webpack_require__(80);

var _isArray3 = _interopRequireDefault(_isArray2);

var _forEach2 = __webpack_require__(890);

var _forEach3 = _interopRequireDefault(_forEach2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _objectUnfreeze = __webpack_require__(2523);

var _objectUnfreeze2 = _interopRequireDefault(_objectUnfreeze);

var _isIterable = __webpack_require__(2599);

var _isIterable2 = _interopRequireDefault(_isIterable);

var _parseStyleName = __webpack_require__(2601);

var _parseStyleName2 = _interopRequireDefault(_parseStyleName);

var _generateAppendClassName = __webpack_require__(2598);

var _generateAppendClassName2 = _interopRequireDefault(_generateAppendClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var linkArray = function linkArray(array, styles, configuration) {
  (0, _forEach3.default)(array, function (value, index) {
    if (_react2.default.isValidElement(value)) {
      // eslint-disable-next-line no-use-before-define
      array[index] = linkElement(_react2.default.Children.only(value), styles, configuration);
    } else if ((0, _isArray3.default)(value)) {
      array[index] = linkArray(value, styles, configuration);
    }
  });

  return array;
};

var linkElement = function linkElement(element, styles, configuration) {
  var appendClassName = void 0;
  var elementShallowCopy = void 0;

  elementShallowCopy = element;

  if (Array.isArray(elementShallowCopy)) {
    return elementShallowCopy.map(function (arrayElement) {
      return linkElement(arrayElement, styles, configuration);
    });
  }

  var elementIsFrozen = Object.isFrozen && Object.isFrozen(elementShallowCopy);
  var propsFrozen = Object.isFrozen && Object.isFrozen(elementShallowCopy.props);
  var propsNotExtensible = Object.isExtensible && !Object.isExtensible(elementShallowCopy.props);

  if (elementIsFrozen) {
    // https://github.com/facebook/react/blob/v0.13.3/src/classic/element/ReactElement.js#L131
    elementShallowCopy = (0, _objectUnfreeze2.default)(elementShallowCopy);
    elementShallowCopy.props = (0, _objectUnfreeze2.default)(elementShallowCopy.props);
  } else if (propsFrozen || propsNotExtensible) {
    elementShallowCopy.props = (0, _objectUnfreeze2.default)(elementShallowCopy.props);
  }

  var styleNames = (0, _parseStyleName2.default)(elementShallowCopy.props.styleName || '', configuration.allowMultiple);

  var _elementShallowCopy$p = elementShallowCopy.props,
      children = _elementShallowCopy$p.children,
      restProps = _objectWithoutProperties(_elementShallowCopy$p, ['children']);

  if (_react2.default.isValidElement(children)) {
    elementShallowCopy.props.children = linkElement(_react2.default.Children.only(children), styles, configuration);
  } else if ((0, _isArray3.default)(children) || (0, _isIterable2.default)(children)) {
    elementShallowCopy.props.children = _react2.default.Children.map(children, function (node) {
      if (_react2.default.isValidElement(node)) {
        // eslint-disable-next-line no-use-before-define
        return linkElement(_react2.default.Children.only(node), styles, configuration);
      } else {
        return node;
      }
    });
  }

  (0, _forEach3.default)(restProps, function (propValue, propName) {
    if (_react2.default.isValidElement(propValue)) {
      elementShallowCopy.props[propName] = linkElement(_react2.default.Children.only(propValue), styles, configuration);
    } else if ((0, _isArray3.default)(propValue)) {
      elementShallowCopy.props[propName] = linkArray(propValue, styles, configuration);
    }
  });

  if (styleNames.length) {
    appendClassName = (0, _generateAppendClassName2.default)(styles, styleNames, configuration.handleNotFoundStyleName);

    if (appendClassName) {
      if (elementShallowCopy.props.className) {
        appendClassName = elementShallowCopy.props.className + ' ' + appendClassName;
      }

      elementShallowCopy.props.className = appendClassName;
    }
  }

  delete elementShallowCopy.props.styleName;

  if (elementIsFrozen) {
    Object.freeze(elementShallowCopy.props);
    Object.freeze(elementShallowCopy);
  } else if (propsFrozen) {
    Object.freeze(elementShallowCopy.props);
  }

  if (propsNotExtensible) {
    Object.preventExtensions(elementShallowCopy.props);
  }

  return elementShallowCopy;
};

/**
 * @param {ReactElement} element
 * @param {Object} styles CSS modules class map.
 * @param {CSSModules~Options} configuration
 */

exports.default = function (element) {
  var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var configuration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  // @see https://github.com/gajus/react-css-modules/pull/30
  if (!(0, _isObject3.default)(element)) {
    return element;
  }

  return linkElement(element, styles, configuration);
};

module.exports = exports['default'];

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (version) {
  var major = version.split('.')[0];

  return parseInt(major, 10) < 15 ? _react2.default.createElement('noscript') : null;
};

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactRedux = __webpack_require__(9);

var _reactIntl = __webpack_require__(5);

function defaultSelector(state) {
  return state.intl;
}

var mapStateToProps = function mapStateToProps(state, _ref) {
  var _ref$intlSelector = _ref.intlSelector,
      intlSelector = _ref$intlSelector === undefined ? defaultSelector : _ref$intlSelector;

  var intl = intlSelector(state);
  return _extends({}, intl, {
    key: intl.locale
  });
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_reactIntl.IntlProvider);

/***/ }),
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Rangeslider = __webpack_require__(2680);

var _Rangeslider2 = _interopRequireDefault(_Rangeslider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Rangeslider2.default;

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(2691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(2689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(1074);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(1075);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(588);



function verifyPlainObject(value, displayName, methodName) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropTypes__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(590);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 */
var Link = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Link',

  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["b" /* ContextSubscriber */])('router')],

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4__PropTypes__["a" /* routerShape */]
  },

  propTypes: {
    to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"]]),
    activeStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    activeClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    onlyActiveOnIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"].isRequired,
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
    target: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"]
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ?  false ? invariant(false, '<Link>s rendered outside of a router context cannot navigate.') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (!to) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PatternUtils__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(326);







/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */
var Redirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Redirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__RouteUtils__["c" /* createRouteFromReactElement */])(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["c" /* formatPattern */])(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["c" /* formatPattern */])(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    from: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"], // Alias for path
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Redirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = assignRouterState;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMemoryHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__ = __webpack_require__(2355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__);




function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default()(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
  return history;
}

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__ = __webpack_require__(1085);


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function createRouterHistory(createHistory) {
  var history = void 0;
  if (canUseDOM) history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__useRouterHistory__["a" /* default */])(createHistory)();
  return history;
}

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransitionManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__ = __webpack_require__(2702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__ = __webpack_require__(2699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isActive__ = __webpack_require__(2706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getComponents__ = __webpack_require__(2703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchRoutes__ = __webpack_require__(2708);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  var _getTransitionUtils = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["a" /* default */])(),
      runEnterHooks = _getTransitionUtils.runEnterHooks,
      runChangeHooks = _getTransitionUtils.runChangeHooks,
      runLeaveHooks = _getTransitionUtils.runLeaveHooks;

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)


  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isActive__["a" /* default */])(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    runLeaveHooks(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getComponents__["a" /* default */])(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? warning(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);



function useRouterHistory(createHistory) {
  return function (options) {
    var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
    return history;
  };
}

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION_TYPE_DELIMITER; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isString__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_toString__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_toString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_toString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isSymbol__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isSymbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isSymbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);







var ACTION_TYPE_DELIMITER = '||';

function isValidActionType(actionType) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_isString___default()(actionType) || __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(actionType) || __WEBPACK_IMPORTED_MODULE_4_lodash_isSymbol___default()(actionType);
}

function isValidActionTypes(actionTypes) {
  if (__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(actionTypes)) {
    return false;
  }
  return actionTypes.every(isValidActionType);
}

function combineActions() {
  for (var _len = arguments.length, actionsTypes = Array(_len), _key = 0; _key < _len; _key++) {
    actionsTypes[_key] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(isValidActionTypes(actionsTypes), 'Expected action types to be strings, symbols, or action creators');
  var combinedActionType = actionsTypes.map(__WEBPACK_IMPORTED_MODULE_3_lodash_toString___default.a).join(ACTION_TYPE_DELIMITER);
  return { toString: function toString() {
      return combinedActionType;
    } };
}

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_identity__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isUndefined__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNull__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_invariant__);






function createAction(type) {
  var payloadCreator = arguments.length <= 1 || arguments[1] === undefined ? __WEBPACK_IMPORTED_MODULE_0_lodash_identity___default.a : arguments[1];
  var metaCreator = arguments[2];

  __WEBPACK_IMPORTED_MODULE_4_invariant___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(payloadCreator) || __WEBPACK_IMPORTED_MODULE_3_lodash_isNull___default()(payloadCreator), 'Expected payloadCreator to be a function, undefined or null');

  var finalPayloadCreator = __WEBPACK_IMPORTED_MODULE_3_lodash_isNull___default()(payloadCreator) ? __WEBPACK_IMPORTED_MODULE_0_lodash_identity___default.a : payloadCreator;

  var actionCreator = function actionCreator() {
    var hasError = (arguments.length <= 0 ? undefined : arguments[0]) instanceof Error;

    var action = {
      type: type
    };

    var payload = hasError ? arguments.length <= 0 ? undefined : arguments[0] : finalPayloadCreator.apply(undefined, arguments);
    if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isUndefined___default()(payload)) {
      action.payload = payload;
    }

    if (hasError || payload instanceof Error) {
      // Handle FSA errors where the payload is an Error object. Set error.
      action.error = true;
    }

    if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(metaCreator)) {
      action.meta = metaCreator.apply(undefined, arguments);
    }

    return action;
  };

  actionCreator.toString = function () {
    return type.toString();
  };

  return actionCreator;
}

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isPlainObject__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isPlainObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isPlainObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_identity__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isUndefined__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_includes__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__combineActions__ = __webpack_require__(1092);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();










function handleAction(actionType) {
  var reducer = arguments.length <= 1 || arguments[1] === undefined ? __WEBPACK_IMPORTED_MODULE_2_lodash_identity___default.a : arguments[1];
  var defaultState = arguments[2];

  var actionTypes = actionType.toString().split(__WEBPACK_IMPORTED_MODULE_7__combineActions__["a" /* ACTION_TYPE_DELIMITER */]);
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(!__WEBPACK_IMPORTED_MODULE_4_lodash_isUndefined___default()(defaultState), 'defaultState for reducer handling ' + actionTypes.join(', ') + ' should be defined');
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(reducer) || __WEBPACK_IMPORTED_MODULE_1_lodash_isPlainObject___default()(reducer), 'Expected reducer to be a function or object with next and throw reducers');

  var _ref = __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(reducer) ? [reducer, reducer] : [reducer.next, reducer.throw].map(function (aReducer) {
    return __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(aReducer) ? __WEBPACK_IMPORTED_MODULE_2_lodash_identity___default.a : aReducer;
  });

  var _ref2 = _slicedToArray(_ref, 2);

  var nextReducer = _ref2[0];
  var throwReducer = _ref2[1];


  return function () {
    var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
    var action = arguments[1];
    var type = action.type;

    if (!type || !__WEBPACK_IMPORTED_MODULE_5_lodash_includes___default()(actionTypes, type.toString())) {
      return state;
    }

    return (action.error === true ? throwReducer : nextReducer)(state, action);
  };
}

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(2752);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/779e6fab5971d4d6c72b1605385030b1.svg";

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTA3NDQ0NDI3MTgxIiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjM1MjAiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTIzNy43ODEgNTIxLjg0N2MwIDE1NS4zMjggMTI1LjkxOSAyODEuMjQ3IDI4MS4yNDcgMjgxLjI0N3MyODEuMjQ3LTEyNS45MTkgMjgxLjI0Ny0yODEuMjQ3YzAtMTU1LjMyOC0xMjUuOTE5LTI4MS4yNDctMjgxLjI0Ny0yODEuMjQ3LTE1NS4zMjggMC0yODEuMjQ3IDEyNS45MTktMjgxLjI0NyAyODEuMjQ3eiIgZmlsbD0iIzFhZmEyOSIgcC1pZD0iMzUyMSI+PC9wYXRoPjwvc3ZnPg=="

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTA3NDQ0NDI3MTgxIiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjM1MjAiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTIzNy43ODEgNTIxLjg0N2MwIDE1NS4zMjggMTI1LjkxOSAyODEuMjQ3IDI4MS4yNDcgMjgxLjI0N3MyODEuMjQ3LTEyNS45MTkgMjgxLjI0Ny0yODEuMjQ3YzAtMTU1LjMyOC0xMjUuOTE5LTI4MS4yNDctMjgxLjI0Ny0yODEuMjQ3LTE1NS4zMjggMC0yODEuMjQ3IDEyNS45MTktMjgxLjI0NyAyODEuMjQ3eiIgZmlsbD0iIzEzMjI3YSIgcC1pZD0iMzUyMSI+PC9wYXRoPjwvc3ZnPg=="

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTA3NDQ0NDI3MTgxIiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjM1MjAiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTIzNy43ODEgNTIxLjg0N2MwIDE1NS4zMjggMTI1LjkxOSAyODEuMjQ3IDI4MS4yNDcgMjgxLjI0N3MyODEuMjQ3LTEyNS45MTkgMjgxLjI0Ny0yODEuMjQ3YzAtMTU1LjMyOC0xMjUuOTE5LTI4MS4yNDctMjgxLjI0Ny0yODEuMjQ3LTE1NS4zMjggMC0yODEuMjQ3IDEyNS45MTktMjgxLjI0NyAyODEuMjQ3eiIgZmlsbD0iI2YxOGQyOSIgcC1pZD0iMzUyMSI+PC9wYXRoPjwvc3ZnPg=="

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTA3NDQ0NDI3MTgxIiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjM1MjAiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTIzNy43ODEgNTIxLjg0N2MwIDE1NS4zMjggMTI1LjkxOSAyODEuMjQ3IDI4MS4yNDcgMjgxLjI0N3MyODEuMjQ3LTEyNS45MTkgMjgxLjI0Ny0yODEuMjQ3YzAtMTU1LjMyOC0xMjUuOTE5LTI4MS4yNDctMjgxLjI0Ny0yODEuMjQ3LTE1NS4zMjggMC0yODEuMjQ3IDEyNS45MTktMjgxLjI0NyAyODEuMjQ3eiIgZmlsbD0iI2Q4MWUwNiIgcC1pZD0iMzUyMSI+PC9wYXRoPjwvc3ZnPg=="

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTA3NDQ0NDI3MTgxIiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjM1MjAiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTIzNy43ODEgNTIxLjg0N2MwIDE1NS4zMjggMTI1LjkxOSAyODEuMjQ3IDI4MS4yNDcgMjgxLjI0N3MyODEuMjQ3LTEyNS45MTkgMjgxLjI0Ny0yODEuMjQ3YzAtMTU1LjMyOC0xMjUuOTE5LTI4MS4yNDctMjgxLjI0Ny0yODEuMjQ3LTE1NS4zMjggMC0yODEuMjQ3IDEyNS45MTktMjgxLjI0NyAyODEuMjQ3eiIgZmlsbD0iI2Y0ZWEyYSIgcC1pZD0iMzUyMSI+PC9wYXRoPjwvc3ZnPg=="

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.10.0
var adjacency_graphs;

adjacency_graphs = {
  qwerty: {
    "!": ["`~", null, null, "2@", "qQ", null],
    "\"": [";:", "[{", "]}", null, null, "/?"],
    "#": ["2@", null, null, "4$", "eE", "wW"],
    "$": ["3#", null, null, "5%", "rR", "eE"],
    "%": ["4$", null, null, "6^", "tT", "rR"],
    "&": ["6^", null, null, "8*", "uU", "yY"],
    "'": [";:", "[{", "]}", null, null, "/?"],
    "(": ["8*", null, null, "0)", "oO", "iI"],
    ")": ["9(", null, null, "-_", "pP", "oO"],
    "*": ["7&", null, null, "9(", "iI", "uU"],
    "+": ["-_", null, null, null, "]}", "[{"],
    ",": ["mM", "kK", "lL", ".>", null, null],
    "-": ["0)", null, null, "=+", "[{", "pP"],
    ".": [",<", "lL", ";:", "/?", null, null],
    "/": [".>", ";:", "'\"", null, null, null],
    "0": ["9(", null, null, "-_", "pP", "oO"],
    "1": ["`~", null, null, "2@", "qQ", null],
    "2": ["1!", null, null, "3#", "wW", "qQ"],
    "3": ["2@", null, null, "4$", "eE", "wW"],
    "4": ["3#", null, null, "5%", "rR", "eE"],
    "5": ["4$", null, null, "6^", "tT", "rR"],
    "6": ["5%", null, null, "7&", "yY", "tT"],
    "7": ["6^", null, null, "8*", "uU", "yY"],
    "8": ["7&", null, null, "9(", "iI", "uU"],
    "9": ["8*", null, null, "0)", "oO", "iI"],
    ":": ["lL", "pP", "[{", "'\"", "/?", ".>"],
    ";": ["lL", "pP", "[{", "'\"", "/?", ".>"],
    "<": ["mM", "kK", "lL", ".>", null, null],
    "=": ["-_", null, null, null, "]}", "[{"],
    ">": [",<", "lL", ";:", "/?", null, null],
    "?": [".>", ";:", "'\"", null, null, null],
    "@": ["1!", null, null, "3#", "wW", "qQ"],
    "A": [null, "qQ", "wW", "sS", "zZ", null],
    "B": ["vV", "gG", "hH", "nN", null, null],
    "C": ["xX", "dD", "fF", "vV", null, null],
    "D": ["sS", "eE", "rR", "fF", "cC", "xX"],
    "E": ["wW", "3#", "4$", "rR", "dD", "sS"],
    "F": ["dD", "rR", "tT", "gG", "vV", "cC"],
    "G": ["fF", "tT", "yY", "hH", "bB", "vV"],
    "H": ["gG", "yY", "uU", "jJ", "nN", "bB"],
    "I": ["uU", "8*", "9(", "oO", "kK", "jJ"],
    "J": ["hH", "uU", "iI", "kK", "mM", "nN"],
    "K": ["jJ", "iI", "oO", "lL", ",<", "mM"],
    "L": ["kK", "oO", "pP", ";:", ".>", ",<"],
    "M": ["nN", "jJ", "kK", ",<", null, null],
    "N": ["bB", "hH", "jJ", "mM", null, null],
    "O": ["iI", "9(", "0)", "pP", "lL", "kK"],
    "P": ["oO", "0)", "-_", "[{", ";:", "lL"],
    "Q": [null, "1!", "2@", "wW", "aA", null],
    "R": ["eE", "4$", "5%", "tT", "fF", "dD"],
    "S": ["aA", "wW", "eE", "dD", "xX", "zZ"],
    "T": ["rR", "5%", "6^", "yY", "gG", "fF"],
    "U": ["yY", "7&", "8*", "iI", "jJ", "hH"],
    "V": ["cC", "fF", "gG", "bB", null, null],
    "W": ["qQ", "2@", "3#", "eE", "sS", "aA"],
    "X": ["zZ", "sS", "dD", "cC", null, null],
    "Y": ["tT", "6^", "7&", "uU", "hH", "gG"],
    "Z": [null, "aA", "sS", "xX", null, null],
    "[": ["pP", "-_", "=+", "]}", "'\"", ";:"],
    "\\": ["]}", null, null, null, null, null],
    "]": ["[{", "=+", null, "\\|", null, "'\""],
    "^": ["5%", null, null, "7&", "yY", "tT"],
    "_": ["0)", null, null, "=+", "[{", "pP"],
    "`": [null, null, null, "1!", null, null],
    "a": [null, "qQ", "wW", "sS", "zZ", null],
    "b": ["vV", "gG", "hH", "nN", null, null],
    "c": ["xX", "dD", "fF", "vV", null, null],
    "d": ["sS", "eE", "rR", "fF", "cC", "xX"],
    "e": ["wW", "3#", "4$", "rR", "dD", "sS"],
    "f": ["dD", "rR", "tT", "gG", "vV", "cC"],
    "g": ["fF", "tT", "yY", "hH", "bB", "vV"],
    "h": ["gG", "yY", "uU", "jJ", "nN", "bB"],
    "i": ["uU", "8*", "9(", "oO", "kK", "jJ"],
    "j": ["hH", "uU", "iI", "kK", "mM", "nN"],
    "k": ["jJ", "iI", "oO", "lL", ",<", "mM"],
    "l": ["kK", "oO", "pP", ";:", ".>", ",<"],
    "m": ["nN", "jJ", "kK", ",<", null, null],
    "n": ["bB", "hH", "jJ", "mM", null, null],
    "o": ["iI", "9(", "0)", "pP", "lL", "kK"],
    "p": ["oO", "0)", "-_", "[{", ";:", "lL"],
    "q": [null, "1!", "2@", "wW", "aA", null],
    "r": ["eE", "4$", "5%", "tT", "fF", "dD"],
    "s": ["aA", "wW", "eE", "dD", "xX", "zZ"],
    "t": ["rR", "5%", "6^", "yY", "gG", "fF"],
    "u": ["yY", "7&", "8*", "iI", "jJ", "hH"],
    "v": ["cC", "fF", "gG", "bB", null, null],
    "w": ["qQ", "2@", "3#", "eE", "sS", "aA"],
    "x": ["zZ", "sS", "dD", "cC", null, null],
    "y": ["tT", "6^", "7&", "uU", "hH", "gG"],
    "z": [null, "aA", "sS", "xX", null, null],
    "{": ["pP", "-_", "=+", "]}", "'\"", ";:"],
    "|": ["]}", null, null, null, null, null],
    "}": ["[{", "=+", null, "\\|", null, "'\""],
    "~": [null, null, null, "1!", null, null]
  },
  dvorak: {
    "!": ["`~", null, null, "2@", "'\"", null],
    "\"": [null, "1!", "2@", ",<", "aA", null],
    "#": ["2@", null, null, "4$", ".>", ",<"],
    "$": ["3#", null, null, "5%", "pP", ".>"],
    "%": ["4$", null, null, "6^", "yY", "pP"],
    "&": ["6^", null, null, "8*", "gG", "fF"],
    "'": [null, "1!", "2@", ",<", "aA", null],
    "(": ["8*", null, null, "0)", "rR", "cC"],
    ")": ["9(", null, null, "[{", "lL", "rR"],
    "*": ["7&", null, null, "9(", "cC", "gG"],
    "+": ["/?", "]}", null, "\\|", null, "-_"],
    ",": ["'\"", "2@", "3#", ".>", "oO", "aA"],
    "-": ["sS", "/?", "=+", null, null, "zZ"],
    ".": [",<", "3#", "4$", "pP", "eE", "oO"],
    "/": ["lL", "[{", "]}", "=+", "-_", "sS"],
    "0": ["9(", null, null, "[{", "lL", "rR"],
    "1": ["`~", null, null, "2@", "'\"", null],
    "2": ["1!", null, null, "3#", ",<", "'\""],
    "3": ["2@", null, null, "4$", ".>", ",<"],
    "4": ["3#", null, null, "5%", "pP", ".>"],
    "5": ["4$", null, null, "6^", "yY", "pP"],
    "6": ["5%", null, null, "7&", "fF", "yY"],
    "7": ["6^", null, null, "8*", "gG", "fF"],
    "8": ["7&", null, null, "9(", "cC", "gG"],
    "9": ["8*", null, null, "0)", "rR", "cC"],
    ":": [null, "aA", "oO", "qQ", null, null],
    ";": [null, "aA", "oO", "qQ", null, null],
    "<": ["'\"", "2@", "3#", ".>", "oO", "aA"],
    "=": ["/?", "]}", null, "\\|", null, "-_"],
    ">": [",<", "3#", "4$", "pP", "eE", "oO"],
    "?": ["lL", "[{", "]}", "=+", "-_", "sS"],
    "@": ["1!", null, null, "3#", ",<", "'\""],
    "A": [null, "'\"", ",<", "oO", ";:", null],
    "B": ["xX", "dD", "hH", "mM", null, null],
    "C": ["gG", "8*", "9(", "rR", "tT", "hH"],
    "D": ["iI", "fF", "gG", "hH", "bB", "xX"],
    "E": ["oO", ".>", "pP", "uU", "jJ", "qQ"],
    "F": ["yY", "6^", "7&", "gG", "dD", "iI"],
    "G": ["fF", "7&", "8*", "cC", "hH", "dD"],
    "H": ["dD", "gG", "cC", "tT", "mM", "bB"],
    "I": ["uU", "yY", "fF", "dD", "xX", "kK"],
    "J": ["qQ", "eE", "uU", "kK", null, null],
    "K": ["jJ", "uU", "iI", "xX", null, null],
    "L": ["rR", "0)", "[{", "/?", "sS", "nN"],
    "M": ["bB", "hH", "tT", "wW", null, null],
    "N": ["tT", "rR", "lL", "sS", "vV", "wW"],
    "O": ["aA", ",<", ".>", "eE", "qQ", ";:"],
    "P": [".>", "4$", "5%", "yY", "uU", "eE"],
    "Q": [";:", "oO", "eE", "jJ", null, null],
    "R": ["cC", "9(", "0)", "lL", "nN", "tT"],
    "S": ["nN", "lL", "/?", "-_", "zZ", "vV"],
    "T": ["hH", "cC", "rR", "nN", "wW", "mM"],
    "U": ["eE", "pP", "yY", "iI", "kK", "jJ"],
    "V": ["wW", "nN", "sS", "zZ", null, null],
    "W": ["mM", "tT", "nN", "vV", null, null],
    "X": ["kK", "iI", "dD", "bB", null, null],
    "Y": ["pP", "5%", "6^", "fF", "iI", "uU"],
    "Z": ["vV", "sS", "-_", null, null, null],
    "[": ["0)", null, null, "]}", "/?", "lL"],
    "\\": ["=+", null, null, null, null, null],
    "]": ["[{", null, null, null, "=+", "/?"],
    "^": ["5%", null, null, "7&", "fF", "yY"],
    "_": ["sS", "/?", "=+", null, null, "zZ"],
    "`": [null, null, null, "1!", null, null],
    "a": [null, "'\"", ",<", "oO", ";:", null],
    "b": ["xX", "dD", "hH", "mM", null, null],
    "c": ["gG", "8*", "9(", "rR", "tT", "hH"],
    "d": ["iI", "fF", "gG", "hH", "bB", "xX"],
    "e": ["oO", ".>", "pP", "uU", "jJ", "qQ"],
    "f": ["yY", "6^", "7&", "gG", "dD", "iI"],
    "g": ["fF", "7&", "8*", "cC", "hH", "dD"],
    "h": ["dD", "gG", "cC", "tT", "mM", "bB"],
    "i": ["uU", "yY", "fF", "dD", "xX", "kK"],
    "j": ["qQ", "eE", "uU", "kK", null, null],
    "k": ["jJ", "uU", "iI", "xX", null, null],
    "l": ["rR", "0)", "[{", "/?", "sS", "nN"],
    "m": ["bB", "hH", "tT", "wW", null, null],
    "n": ["tT", "rR", "lL", "sS", "vV", "wW"],
    "o": ["aA", ",<", ".>", "eE", "qQ", ";:"],
    "p": [".>", "4$", "5%", "yY", "uU", "eE"],
    "q": [";:", "oO", "eE", "jJ", null, null],
    "r": ["cC", "9(", "0)", "lL", "nN", "tT"],
    "s": ["nN", "lL", "/?", "-_", "zZ", "vV"],
    "t": ["hH", "cC", "rR", "nN", "wW", "mM"],
    "u": ["eE", "pP", "yY", "iI", "kK", "jJ"],
    "v": ["wW", "nN", "sS", "zZ", null, null],
    "w": ["mM", "tT", "nN", "vV", null, null],
    "x": ["kK", "iI", "dD", "bB", null, null],
    "y": ["pP", "5%", "6^", "fF", "iI", "uU"],
    "z": ["vV", "sS", "-_", null, null, null],
    "{": ["0)", null, null, "]}", "/?", "lL"],
    "|": ["=+", null, null, null, null, null],
    "}": ["[{", null, null, null, "=+", "/?"],
    "~": [null, null, null, "1!", null, null]
  },
  keypad: {
    "*": ["/", null, null, null, "-", "+", "9", "8"],
    "+": ["9", "*", "-", null, null, null, null, "6"],
    "-": ["*", null, null, null, null, null, "+", "9"],
    ".": ["0", "2", "3", null, null, null, null, null],
    "/": [null, null, null, null, "*", "9", "8", "7"],
    "0": [null, "1", "2", "3", ".", null, null, null],
    "1": [null, null, "4", "5", "2", "0", null, null],
    "2": ["1", "4", "5", "6", "3", ".", "0", null],
    "3": ["2", "5", "6", null, null, null, ".", "0"],
    "4": [null, null, "7", "8", "5", "2", "1", null],
    "5": ["4", "7", "8", "9", "6", "3", "2", "1"],
    "6": ["5", "8", "9", "+", null, null, "3", "2"],
    "7": [null, null, null, "/", "8", "5", "4", null],
    "8": ["7", null, "/", "*", "9", "6", "5", "4"],
    "9": ["8", "/", "*", "-", "+", null, "6", "5"]
  },
  mac_keypad: {
    "*": ["/", null, null, null, null, null, "-", "9"],
    "+": ["6", "9", "-", null, null, null, null, "3"],
    "-": ["9", "/", "*", null, null, null, "+", "6"],
    ".": ["0", "2", "3", null, null, null, null, null],
    "/": ["=", null, null, null, "*", "-", "9", "8"],
    "0": [null, "1", "2", "3", ".", null, null, null],
    "1": [null, null, "4", "5", "2", "0", null, null],
    "2": ["1", "4", "5", "6", "3", ".", "0", null],
    "3": ["2", "5", "6", "+", null, null, ".", "0"],
    "4": [null, null, "7", "8", "5", "2", "1", null],
    "5": ["4", "7", "8", "9", "6", "3", "2", "1"],
    "6": ["5", "8", "9", "-", "+", null, "3", "2"],
    "7": [null, null, null, "=", "8", "5", "4", null],
    "8": ["7", null, "=", "/", "9", "6", "5", "4"],
    "9": ["8", "=", "/", "*", "-", "+", "6", "5"],
    "=": [null, null, null, null, "/", "9", "8", "7"]
  }
};

module.exports = adjacency_graphs;

//# sourceMappingURL=adjacency_graphs.js.map


/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl_redux__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_intl_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Routes__ = __webpack_require__(1392);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);






var propTypes = {
  store: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.any.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.any.isRequired
};

var Root = function Root(props) {
  var store = props.store,
      history = props.history;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_redux__["Provider"],
    { store: store, key: "provider" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_intl_redux__["IntlProvider"],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Routes__["a" /* default */], { history: history })
    )
  );
};

Root.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Root);

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

__webpack_require__(2117);
__webpack_require__(2116);
__webpack_require__(1439);
__webpack_require__(2118);
__webpack_require__(2347);
__webpack_require__(1443);
__webpack_require__(1440);
__webpack_require__(1442);

if (!Array.prototype.includes) {
  Array.prototype.includes = function (searchElement /*, fromIndex*/) {
    'use strict';

    var O = Object(this);
    var len = parseInt(O.length, 10) || 0;
    if (len === 0) {
      return false;
    }
    var n = parseInt(arguments[1], 10) || 0;
    var k;
    if (n >= 0) {
      k = n;
    } else {
      k = len + n;
      if (k < 0) {
        k = 0;
      }
    }
    var currentElement;
    var searchIsNaN = isNaN(searchElement);
    while (k < len) {
      currentElement = O[k];
      // SameValueZero algorithm has to treat NaN as equal to itself, but
      // NaN === NaN is false, so check explicitly
      // SameValueZero treats 0 and -0 as equal, as does ===, so we're fine there
      if (searchElement === currentElement || searchIsNaN && isNaN(currentElement)) {
        return true;
      }
      k++;
    }
    return false;
  };
}

if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default.a) {
  Object.keys = function () {
    'use strict';

    var hasOwnProperty = Object.prototype.hasOwnProperty,
        hasDontEnumBug = !{ toString: null }.propertyIsEnumerable('toString'),
        dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'],
        dontEnumsLength = dontEnums.length;

    return function (obj) {
      if ((typeof obj === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj)) !== 'object' && (typeof obj !== 'function' || obj === null)) {
        throw new TypeError('Object.keys called on non-object');
      }

      var result = [],
          prop,
          i;

      for (prop in obj) {
        if (hasOwnProperty.call(obj, prop)) {
          result.push(prop);
        }
      }

      if (hasDontEnumBug) {
        for (i = 0; i < dontEnumsLength; i++) {
          if (hasOwnProperty.call(obj, dontEnums[i])) {
            result.push(dontEnums[i]);
          }
        }
      }
      return result;
    };
  }();
}

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl_redux__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_intl_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_thunk__ = __webpack_require__(2734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__middleware_api__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__intlState__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__authState__ = __webpack_require__(1423);

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);










var rootReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* combineReducers */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_6__reducers__["a" /* default */], {
  routing: __WEBPACK_IMPORTED_MODULE_2_react_router_redux__["routerReducer"],
  intl: __WEBPACK_IMPORTED_MODULE_3_react_intl_redux__["intlReducer"]
}));

/* harmony default export */ __webpack_exports__["a"] = (function (history, preloadedState) {
  var router = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["routerMiddleware"])(history);
  var preload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, preloadedState, {
    intl: __WEBPACK_IMPORTED_MODULE_7__intlState__["a" /* default */],
    auth: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__authState__["a" /* default */])()
  });
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* createStore */])(rootReducer, preload, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux__["d" /* applyMiddleware */])(router, __WEBPACK_IMPORTED_MODULE_4_redux_thunk__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__middleware_api__["a" /* default */]));
});

/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IEVer;
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

function IEVer() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.includes('msie')) {
    return parseInt(ua.split('msie')[1], 10);
  }
  return 0;
}

/***/ }),
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2668)


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.RedBoxError = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(64);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _style = __webpack_require__(2728);

var _style2 = _interopRequireDefault(_style);

var _errorStackParser = __webpack_require__(2115);

var _errorStackParser2 = _interopRequireDefault(_errorStackParser);

var _objectAssign = __webpack_require__(36);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _lib = __webpack_require__(2727);

var _sourcemappedStacktrace = __webpack_require__(2742);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RedBoxError = exports.RedBoxError = function (_get__2) {
  _inherits(RedBoxError, _get__2);

  function RedBoxError(props) {
    _classCallCheck(this, RedBoxError);

    var _this = _possibleConstructorReturn(this, (RedBoxError.__proto__ || Object.getPrototypeOf(RedBoxError)).call(this, props));

    _this.state = {
      error: null,
      mapped: false
    };

    _this.mapOnConstruction(props.error);
    return _this;
  }

  // State is used to store the error mapped to the source map.


  _createClass(RedBoxError, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.state.mapped) this.mapError(this.props.error);
    }

    // Try to map the error when the component gets constructed, this is possible
    // in some cases like evals.

  }, {
    key: 'mapOnConstruction',
    value: function mapOnConstruction(error) {
      var stackLines = error.stack.split('\n');

      // There's no stack, only the error message.
      if (stackLines.length < 2) {
        this.state = { error: error, mapped: true };
        return;
      }

      // Using the “eval” setting on webpack already gives the correct location.
      var isWebpackEval = stackLines[1].search(/\(webpack:\/{3}/) !== -1;
      if (isWebpackEval) {
        // No changes are needed here.
        this.state = { error: error, mapped: true };
        return;
      }

      // Other eval follow a specific pattern and can be easily parsed.
      var isEval = stackLines[1].search(/\(eval at/) !== -1;
      if (!isEval) {
        // mapping will be deferred until `componentDidMount`
        this.state = { error: error, mapped: false };
        return;
      }

      // The first line is the error message.
      var fixedLines = [stackLines.shift()];
      // The rest needs to be fixed.
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = stackLines[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var stackLine = _step.value;

          var evalStackLine = stackLine.match(/(.+)\(eval at (.+) \(.+?\), .+(\:[0-9]+\:[0-9]+)\)/);
          if (evalStackLine) {
            var _evalStackLine = _slicedToArray(evalStackLine, 4),
                atSomething = _evalStackLine[1],
                file = _evalStackLine[2],
                rowColumn = _evalStackLine[3];

            fixedLines.push(atSomething + ' (' + file + rowColumn + ')');
          } else {
            // TODO: When stack frames of different types are detected, try to load the additional source maps
            fixedLines.push(stackLine);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      error.stack = fixedLines.join('\n');
      this.state = { error: error, mapped: true };
    }
  }, {
    key: 'mapError',
    value: function mapError(error) {
      var _this2 = this;

      _get__('mapStackTrace')(error.stack, function (mappedStack) {
        error.stack = mappedStack.join('\n');
        _this2.setState({ error: error, mapped: true });
      });
    }
  }, {
    key: 'renderFrames',
    value: function renderFrames(frames) {
      var _props = this.props,
          filename = _props.filename,
          editorScheme = _props.editorScheme,
          useLines = _props.useLines,
          useColumns = _props.useColumns;

      var _get__3 = _get__('assign')({}, _get__('style'), this.props.style),
          frame = _get__3.frame,
          file = _get__3.file,
          linkToFile = _get__3.linkToFile;

      return frames.map(function (f, index) {
        var text = void 0;
        var url = void 0;

        if (index === 0 && filename && !_get__('isFilenameAbsolute')(f.fileName)) {
          url = _get__('makeUrl')(filename, editorScheme);
          text = _get__('makeLinkText')(filename);
        } else {
          var lines = useLines ? f.lineNumber : null;
          var columns = useColumns ? f.columnNumber : null;
          url = _get__('makeUrl')(f.fileName, editorScheme, lines, columns);
          text = _get__('makeLinkText')(f.fileName, lines, columns);
        }

        return _get__('React').createElement(
          'div',
          { style: frame, key: index },
          _get__('React').createElement(
            'div',
            null,
            f.functionName
          ),
          _get__('React').createElement(
            'div',
            { style: file },
            _get__('React').createElement(
              'a',
              { href: url, style: linkToFile },
              text
            )
          )
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      // The error is received as a property to initialize state.error, which may
      // be updated when it is mapped to the source map.
      var error = this.state.error;
      var className = this.props.className;

      var _get__4 = _get__('assign')({}, _get__('style'), this.props.style),
          redbox = _get__4.redbox,
          message = _get__4.message,
          stack = _get__4.stack,
          frame = _get__4.frame;

      var frames = void 0;
      var parseError = void 0;
      try {
        frames = _get__('ErrorStackParser').parse(error);
      } catch (e) {
        parseError = new Error('Failed to parse stack trace. Stack trace information unavailable.');
      }

      if (parseError) {
        frames = _get__('React').createElement(
          'div',
          { style: frame, key: 0 },
          _get__('React').createElement(
            'div',
            null,
            parseError.message
          )
        );
      } else {
        frames = this.renderFrames(frames);
      }

      return _get__('React').createElement(
        'div',
        { style: redbox, className: className },
        _get__('React').createElement(
          'div',
          { style: message },
          error.name,
          ': ',
          error.message
        ),
        _get__('React').createElement(
          'div',
          { style: stack },
          frames
        )
      );
    }
  }]);

  return RedBoxError;
}(_get__('Component'));

// "Portal" component for actual RedBoxError component to
// render to (directly under body). Prevents bugs as in #27.


RedBoxError.propTypes = {
  error: _get__('PropTypes').instanceOf(Error).isRequired,
  filename: _get__('PropTypes').string,
  editorScheme: _get__('PropTypes').string,
  useLines: _get__('PropTypes').bool,
  useColumns: _get__('PropTypes').bool,
  style: _get__('PropTypes').object,
  className: _get__('PropTypes').string
};
RedBoxError.displayName = 'RedBoxError';
RedBoxError.defaultProps = {
  useLines: true,
  useColumns: true };

var RedBox = function (_get__5) {
  _inherits(RedBox, _get__5);

  function RedBox() {
    _classCallCheck(this, RedBox);

    return _possibleConstructorReturn(this, (RedBox.__proto__ || Object.getPrototypeOf(RedBox)).apply(this, arguments));
  }

  _createClass(RedBox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.el = document.createElement('div');
      document.body.appendChild(this.el);
      this.renderRedBoxError();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.renderRedBoxError();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _get__('ReactDOM').unmountComponentAtNode(this.el);
      document.body.removeChild(this.el);
      this.el = null;
    }
  }, {
    key: 'renderRedBoxError',
    value: function renderRedBoxError() {
      _get__('ReactDOM').render(_get__('React').createElement(_get__('RedBoxError'), this.props), this.el);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return RedBox;
}(_get__('Component'));

RedBox.propTypes = {
  error: _get__('PropTypes').instanceOf(Error).isRequired
};
RedBox.displayName = 'RedBox';
exports.default = RedBox;

var _RewiredData__ = Object.create(null);

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  if (_RewiredData__ === undefined || _RewiredData__[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = _RewiredData__[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'PropTypes':
      return _propTypes2.default;

    case 'mapStackTrace':
      return _sourcemappedStacktrace.mapStackTrace;

    case 'assign':
      return _objectAssign2.default;

    case 'style':
      return _style2.default;

    case 'isFilenameAbsolute':
      return _lib.isFilenameAbsolute;

    case 'makeUrl':
      return _lib.makeUrl;

    case 'makeLinkText':
      return _lib.makeLinkText;

    case 'ErrorStackParser':
      return _errorStackParser2.default;

    case 'Component':
      return _react.Component;

    case 'ReactDOM':
      return _reactDom2.default;

    case 'React':
      return _react2.default;

    case 'RedBoxError':
      return RedBoxError;
  }

  return undefined;
}

function _assign__(variableName, value) {
  if (_RewiredData__ === undefined || _RewiredData__[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return _RewiredData__[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      _RewiredData__[name] = variableName[name];
    });
  } else {
    if (value === undefined) {
      _RewiredData__[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      _RewiredData__[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  delete _RewiredData__[variableName];
}

function _with__(object) {
  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      _RewiredData__[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = _RewiredData__[variableName];
      _RewiredData__[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset).catch(reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof RedBox === 'undefined' ? 'undefined' : _typeof(RedBox);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(RedBox, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(RedBox)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseAPIError;
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

var wellDefinedErrors = ['BADPASSWORD', 'BADACCOUNT', 'ACCINACTIVE', 'BADTOKEN'];

function parseAPIError(error) {
  // well-defined errors
  var code = error._code || error.error;
  var message = error._message || error.message;
  var defined = wellDefinedErrors.filter(function (c) {
    return c === code;
  });
  if (defined.length > 0) {
    return {
      code: defined[0],
      message: message,
      origin: error
    };
  }

  // ill-defined errors, need some tweaks :p
  switch (code) {
    case 'TypeError':
      if (message === 'Failed to fetch') {
        return {
          code: 'FETCHFAILED',
          message: message,
          origin: error
        };
      }
      break;
    default:
      break;
  }
  return {
    code: code || 'UNKNOWN',
    message: message,
    origin: error
  };
}

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export listApplication */
/* unused harmony export getApplication */
/* unused harmony export editApplication */
/* unused harmony export addApplication */
/* unused harmony export delApplication */
/* unused harmony export getApplicationOnQuery */
/* unused harmony export getApplicationsCount */
/* harmony export (immutable) */ __webpack_exports__["a"] = getAppTokenList;
/* unused harmony export addAppToken */
/* unused harmony export deleteAppToken */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(240);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



function listApplication(mark, pageSize, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/applications?access_token=&count', {
    mark: mark,
    pageSize: pageSize
  }, {}, callback);
}

function getApplication(id, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/applications/' + id, {}, {}, callback);
}

function editApplication(id, name, target, token, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('put', '/lora/applications/' + id, {}, {
    name: name,
    target: target,
    token: token
  }, callback);
}

function addApplication(name, appeui, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('post', '/lora/applications', {}, {
    name: name,
    appeui: appeui
  }, callback);
}

function delApplication(id, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('del', '/lora/applications/' + id, {}, {}, callback);
}

function getApplicationOnQuery(args, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/applications', args, {}, callback);
}

function getApplicationsCount(callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/lora/applications/count', {}, {}, callback);
}

function getAppTokenList(appId, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('get', '/tokens', { bind: appId }, {}, callback);
}

function addAppToken(appId, name, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('post', '/tokens', {}, {
    bind: appId,
    name: name
  }, callback);
}

function deleteAppToken(id, callback) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])('del', '/tokens/' + id, {}, {}, callback);
}

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

module.exports = {
  cloud: "\n\
    __                 ________                _          ________                __\n\
   / /___  _________ _/ ____/ /___ _      __  (_)___     / ____/ /___  __  ______/ /\n\
  / / __ \\/ ___/ __ `/ /_  / / __ \\ | /| / / / / __ \\   / /   / / __ \\/ / / / __  / \n\
 / / /_/ / /  / /_/ / __/ / / /_/ / |/ |/ / / / /_/ /  / /___/ / /_/ / /_/ / /_/ /  \n\
/_/\\____/_/   \\__,_/_/   /_/\\____/|__/|__(_)_/\\____/   \\____/_/\\____/\\__,_/\\__,_/   ",
  cube: "\n\
    __                 ________                _          ______      __       \n\
   / /___  _________ _/ ____/ /___ _      __  (_)___     / ____/_  __/ /_  ___ \n\
  / / __ \\/ ___/ __ `/ /_  / / __ \\ | /| / / / / __ \\   / /   / / / / __ \\/ _ \n\
 / / /_/ / /  / /_/ / __/ / / /_/ / |/ |/ / / / /_/ /  / /___/ /_/ / /_/ /  __/\n\
/_/\\____/_/   \\__,_/_/   /_/\\____/|__/|__(_)_/\\____/   \\____/\\__,_/_.___/\\___/ ",
  devCloud: "\n\
 ________________________________\n\
< Hi, developer! UR in the cloud!>\n\
 --------------------------------\n\
        \\   ^__^\n\
         \\  (oo)\\_______\n\
            (__)\\       )\\/\\\n\
                ||----w |\n\
                ||     ||",
  devCube: "\n\
 ______________________\n\
< Cube! Cube!! Cube!!! >\n\
 ----------------------\n\
        \\   ^__^\n\
         \\  ($$)\\_______\n\
            (__)\\       )\\/\\\n\
                ||----w |\n\
                ||     ||"
};

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_TablePager__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_scss__ = __webpack_require__(2130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  onSuccess: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  showModal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  disableCheck: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array.isRequired
};

var GatewayModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(GatewayModal, _React$Component);

  function GatewayModal(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GatewayModal);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      list: [],
      checked: [],
      showModal: props.showModal,
      mark: 0,
      more: false,
      reset: 0
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, '');
    _this.mark = 0;
    return _this;
  }

  GatewayModal.prototype.componentWillMount = function componentWillMount() {
    this.loadGateways();
  };

  GatewayModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var showModal = nextProps.showModal,
        disableCheck = nextProps.disableCheck;

    if (showModal !== this.props.showModal) {
      this.setState({ showModal: showModal, disableCheck: disableCheck });
      if (showModal) {
        this.loadGateways();
      }
    }
  };

  GatewayModal.prototype.getStatus = function getStatus(gw) {
    var disconnected = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "span",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-circle-o " + __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.disconnected }),
      ' ',
      this.intlMsg.msg('selectgateway.disconnected')
    );
    var connected = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "span",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-circle " + __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.connected }),
      ' ',
      this.intlMsg.msg('selectgateway.connected')
    );

    if (_.isNil(gw.lastOn)) {
      return disconnected;
    }
    if (_.isNil(gw.lastOff)) {
      return connected;
    }
    var onts = new Date(gw.lastOn).valueOf();
    var offts = new Date(gw.lastOff).valueOf();
    if (onts > offts) {
      return connected;
    }
    return disconnected;
  };

  GatewayModal.prototype.loadGateways = function loadGateways() {
    var _this2 = this;

    this.setState({ status: 'loading' });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__api_callAPI__["a" /* default */])({
      endpoint: '/lora/gateways',
      query: {
        mark: this.mark,
        sort: '-lastOn'
      }
    }).then(function (res) {
      _this2.setState({
        list: res.list,
        more: res.more,
        mark: res.mark,
        status: 'success'
      });
    }).catch(function () {});
  };

  GatewayModal.prototype.allChecked = function allChecked() {
    var _state = this.state,
        list = _state.list,
        checked = _state.checked;

    return list.length > 0 && list.length === checked.length;
  };

  GatewayModal.prototype.handleToggleCheckAll = function handleToggleCheckAll() {
    this.setState({
      checked: this.allChecked() ? [] : this.state.list
    });
  };

  GatewayModal.prototype.isChecked = function isChecked(d) {
    return _.some(this.state.checked, { id: d.id });
  };

  GatewayModal.prototype.isDisabled = function isDisabled(d) {
    return _.some(this.state.disableCheck, { id: d.id });
  };

  GatewayModal.prototype.toggleCheck = function toggleCheck(d) {
    var checked = this.state.checked;
    if (this.isChecked(d)) {
      this.setState({
        checked: _.filter(checked, function (a) {
          return a.id !== d.id;
        })
      });
    } else {
      checked.push(d);
      this.setState({ checked: checked });
    }
  };

  GatewayModal.prototype.handlePrevPage = function handlePrevPage(mark) {
    this.mark = mark;
    this.loadGateways();
  };

  GatewayModal.prototype.handleNextPage = function handleNextPage(mark) {
    this.mark = mark;
    this.loadGateways();
  };

  GatewayModal.prototype.handleAdd = function handleAdd() {
    var checked = this.state.checked;

    this.props.onSuccess(checked);
    this.setState({ reset: new Date(), checked: [], mark: 0 });
    this.mark = 0;
  };

  GatewayModal.prototype.render = function render() {
    var _this3 = this;

    var _state2 = this.state,
        showModal = _state2.showModal,
        list = _state2.list,
        mark = _state2.mark,
        more = _state2.more,
        reset = _state2.reset,
        status = _state2.status;
    var _onHide = this.props.onHide;

    var rows = _.map(list, function (item) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        { key: item.id },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          { className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.checkbox },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Checkbox__["a" /* default */], {
            id: item.id,
            checked: _this3.isChecked(item),
            onChange: function onChange() {
              return _this3.toggleCheck(item);
            },
            disabled: _this3.isDisabled(item)
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          item.name
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          item.mac
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          _this3.getStatus(item)
        )
      );
    });
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"],
      {
        show: showModal,
        onHide: function onHide() {
          _this3.setState({ checked: [] });
          _onHide();
        },
        bsClass: "aisz-modal-light"
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        this.intlMsg.msg('selectgateway.title')
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Table"],
          {
            className: "aisz-table-light",
            bordered: true,
            responsive: true
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("th", { className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.checkbox }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('selectgateway.name')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('selectgateway.mac')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('selectgateway.status')
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tbody",
            null,
            rows
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "clearfix" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
            {
              bsStyle: "aisz-success",
              onClick: function onClick() {
                return _this3.handleAdd();
              }
            },
            this.intlMsg.msg('selectgateway.confirm')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
          { "if": list.length > 0 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: "pull-right" },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_TablePager__["a" /* default */], {
              status: status,
              mark: mark,
              more: more,
              reset: reset,
              onPrev: function onPrev(m) {
                return _this3.handlePrevPage(m);
              },
              onNext: function onNext(m) {
                return _this3.handleNextPage(m);
              }
            })
          )
        )
      )
    );
  };

  return GatewayModal;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

GatewayModal.propTypes = propTypes;

var mapDispatchToProps = {};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(GatewayModal)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var propTypes = {
  val: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any,
  formatter: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func
};

var LoadingVal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(LoadingVal, _React$Component);

  function LoadingVal(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LoadingVal);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      val: _this.props.val
    };
    return _this;
  }

  LoadingVal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.val !== this.props.val) {
      this.setState({
        val: nextProps.val
      });
    }
  };

  LoadingVal.prototype.render = function render() {
    var val = this.state.val;

    if (__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(val)) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" });
    }
    if (this.props.formatter) {
      val = this.props.formatter(val);
    }
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "span",
      null,
      val
    );
  };

  return LoadingVal;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

LoadingVal.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (LoadingVal);

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var LocaleMsg = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(LocaleMsg, _React$Component);

  function LocaleMsg() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LocaleMsg);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  LocaleMsg.prototype.render = function render() {
    var _props = this.props,
        id = _props.id,
        intl = _props.intl;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "span",
      null,
      intl.formatMessage({ id: id, defaultMessage: id })
    );
  };

  return LocaleMsg;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

LocaleMsg.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function () {
  return {};
}, {})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(LocaleMsg)));

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_set_minutes__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_set_minutes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_set_minutes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_set_hours__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_set_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_set_hours__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_add_hours__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_add_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_add_hours__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_scss__ = __webpack_require__(2135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var propTypes = {
  date: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(Date),
  onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};

var defaultProps = {
  date: new Date()
};

var MomentSelect = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(MomentSelect, _React$Component);

  function MomentSelect(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MomentSelect);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    var hour = props.date.getHours();
    _this.state = {
      timezoom: Number(hour) > 11 ? 'pm' : 'am',
      date: props.date,
      hour: hour,
      minute: '00'
    };
    _this.minute = 0;
    _this.hour = hour;
    _this.day = props.date.getDate();
    return _this;
  }

  MomentSelect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var date = nextProps.date;

    if (!_.isEqual(date, this.props.date)) {
      this.setState({ date: date });
    }
  };

  MomentSelect.prototype.handleAddHour = function handleAddHour() {
    var hour = Number(this.hour) + 1;
    this.handleChangeTime(this.minute, hour);
  };

  MomentSelect.prototype.handleDecreaseHour = function handleDecreaseHour() {
    var hour = Number(this.hour) - 1;
    this.handleChangeTime(this.minute, hour);
  };

  MomentSelect.prototype.handleChangeHour = function handleChangeHour(e) {
    var hour = _.trim(e.target.value);
    if (hour !== '') {
      hour = Number(hour);
      if (!_.isInteger(hour) || !_.inRange(hour, 0, 24)) {
        hour = this.hour;
      }
      this.handleChangeTime(this.minute, hour);
    } else if (hour === '') {
      this.setState({ hour: '' });
    }
  };

  MomentSelect.prototype.handleAddMinute = function handleAddMinute() {
    var minute = Number(this.minute) + 15;
    this.handleChangeTime(minute, this.hour);
  };

  MomentSelect.prototype.handleDecreaseMinute = function handleDecreaseMinute() {
    var minute = Number(this.minute) - 15;
    this.handleChangeTime(minute, this.hour);
  };

  MomentSelect.prototype.handleChangeMinute = function handleChangeMinute(e) {
    var minute = _.trim(e.target.value);
    if (minute !== '') {
      minute = Number(minute);
      if (!_.isInteger(minute) || !_.inRange(minute, 0, 60)) {
        minute = this.minute;
      }
      this.handleChangeTime(minute, this.hour);
    } else if (minute === '') {
      this.setState({ minute: '' });
    }
  };

  MomentSelect.prototype.handleChangeTime = function handleChangeTime(m, h) {
    var date = this.state.date;

    var minute = m;
    var hour = h;

    if (minute >= 60) {
      minute -= 60;
      hour += 1;
    } else if (minute < 0) {
      minute += 60;
      hour -= 1;
    }

    date = __WEBPACK_IMPORTED_MODULE_8_date_fns_set_minutes___default()(date, minute);
    date = __WEBPACK_IMPORTED_MODULE_9_date_fns_set_hours___default()(date, 0);
    date = __WEBPACK_IMPORTED_MODULE_10_date_fns_add_hours___default()(date, hour);

    hour = date.getHours();

    this.minute = minute;
    this.hour = hour;
    this.setState({ minute: minute, hour: hour, date: date });
    this.props.onSelect(date);
  };

  MomentSelect.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        hour = _state.hour,
        minute = _state.minute;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { styleName: "moment" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { styleName: "items" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_react_router__["f" /* Link */],
          { onClick: function onClick() {
              return _this2.handleAddHour();
            } },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicon glyphicon-chevron-up" })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["FormControl"], {
          bsClass: "aisz-form-control-f",
          type: "number",
          value: hour,
          onChange: function onChange(e) {
            return _this2.handleChangeHour(e);
          }
        }),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_react_router__["f" /* Link */],
          { onClick: function onClick() {
              return _this2.handleDecreaseHour();
            } },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicon glyphicon-chevron-down" })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { styleName: "items" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_react_router__["f" /* Link */],
          { onClick: function onClick() {
              return _this2.handleAddMinute();
            } },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicon glyphicon-chevron-up" })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["FormControl"], {
          bsClass: "aisz-form-control-f",
          type: "number",
          value: minute,
          onChange: function onChange(e) {
            return _this2.handleChangeMinute(e);
          }
        }),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_react_router__["f" /* Link */],
          { onClick: function onClick() {
              return _this2.handleDecreaseMinute();
            } },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicon glyphicon-chevron-down" })
        )
      )
    );
  };

  return MomentSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

MomentSelect.propTypes = propTypes;
MomentSelect.defaultProps = defaultProps;

var mapStateToProps = function mapStateToProps(state) {
  return {
    locale: state.intl.locale
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_7_react_css_modules___default()(MomentSelect, __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a, { allowMultiple: true }))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SearchSelector__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_main_scss__ = __webpack_require__(2143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_main_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var propTypes = {
  fields: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.array.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  labelCols: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.number.isRequired,
  controlCols: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.number.isRequired,
  buttonLabel: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  successButtonLabel: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any,
  errorButtonLabel: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any,
  submitError: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any,
  submitStatus: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string,
  onClearStatus: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func,
  onChange: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func
};

var RichForm = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(RichForm, _React$Component);

  function RichForm(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RichForm);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    var data = {};
    _this.props.fields.forEach(function (f) {
      if (!_.isNil(f.value)) {
        data[f.id] = f.value;
      }
    });
    _this.state = {
      data: data,
      errors: {},
      submitError: props.submitError,
      submitted: false
    };

    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleFieldChange = _this.handleFieldChange.bind(_this);
    _this.checkField = _this.checkField.bind(_this);
    _this.inputRefs = {};
    return _this;
  }

  RichForm.prototype.componentDidMount = function componentDidMount() {
    this.mounted = true;
  };

  RichForm.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _state = this.state,
        submitStatus = _state.submitStatus,
        submitError = _state.submitError;

    if (!_.isEqual(nextProps.submitError, submitError) || !_.isEqual(nextProps.submitStatus, submitStatus)) {
      this.setState({
        submitError: nextProps.submitError,
        submitStatus: nextProps.submitStatus
      });
    }

    if (nextProps.submitStatus === 'error' && nextProps.submitError) {
      this.setState({
        showErrorTips: true
      });
    }

    var fids = _.map(this.props.fields, 'id');
    var nextFids = _.map(nextProps.fields, 'id');
    if (!_.isEqual(fids, nextFids)) {
      var data = {};
      nextProps.fields.forEach(function (f) {
        if (!_.isNil(f.value)) {
          data[f.id] = f.value;
        }
      });
      this.setState({ data: data });
    }

    if (!_.isEqual(nextProps.fields, this.props.fields)) {
      this.setState({ fields: nextProps.fields });
    }
  };

  RichForm.prototype.componentWillUpdate = function componentWillUpdate() {
    var _state2 = this.state,
        _state2$submitStatus = _state2.submitStatus,
        submitStatus = _state2$submitStatus === undefined ? '' : _state2$submitStatus,
        _state2$showErrorTips = _state2.showErrorTips,
        showErrorTips = _state2$showErrorTips === undefined ? false : _state2$showErrorTips;


    if (submitStatus !== '' && this.statusTimeout) {
      clearTimeout(this.statusTimeout);
    }
    if (showErrorTips && this.tipsTimeout) {
      clearTimeout(this.tipsTimeout);
    }
  };

  RichForm.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var _state3 = this.state,
        _state3$submitStatus = _state3.submitStatus,
        submitStatus = _state3$submitStatus === undefined ? '' : _state3$submitStatus,
        _state3$showErrorTips = _state3.showErrorTips,
        showErrorTips = _state3$showErrorTips === undefined ? false : _state3$showErrorTips;
    var onClearStatus = this.props.onClearStatus;


    if (submitStatus !== '') {
      this.statusTimeout = setTimeout(function () {
        if (_this2.mounted) {
          _this2.setState({ submitStatus: '' });
          if (onClearStatus) {
            onClearStatus();
          }
        }
      }, 1500);
    }
    if (showErrorTips) {
      this.tipsTimeout = setTimeout(function () {
        if (_this2.mounted) {
          _this2.setState({ showErrorTips: false });
        }
      }, 3000);
    }

    if (this.inputRef) {
      this.inputRef.setSelectionRange(this.cursorPos, this.cursorPos);
    }
  };

  RichForm.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  RichForm.prototype.handleSubmit = function handleSubmit(e) {
    var _this3 = this;

    e.preventDefault();

    var valid = true;
    var errors = this.state.errors;
    var _props = this.props,
        fields = _props.fields,
        onSubmit = _props.onSubmit;


    fields.forEach(function (f) {
      var result = _this3.checkField(f);
      valid = valid && result.valid;
      if (!result.valid) {
        errors[f.id] = result.errmsg;
      }
    });

    this.setState({
      errors: errors,
      submitted: true
    });

    if (valid && onSubmit) {
      onSubmit(this.state.data);
    }
  };

  RichForm.prototype.checkField = function checkField(field, value) {
    var data = this.state.data;

    if (_.isUndefined(value)) {
      value = data[field.id];
    }
    if (field.validator) {
      return field.validator(value);
    }
    return {
      valid: true
    };
  };

  RichForm.prototype.handleFieldChange = function handleFieldChange(field, value, e) {
    var _state4 = this.state,
        data = _state4.data,
        errors = _state4.errors,
        submitted = _state4.submitted;


    this.cursorPos = null;
    this.inputRef = null;

    if (field.formatter) {
      data[field.id] = field.formatter(value, data[field.id]);

      // update input cursor position
      if (e) {
        this.cursorPos = e.target.selectionEnd;
        this.inputRef = this.inputRefs[field.id];
        if (value.length === this.cursorPos) {
          this.cursorPos = data[field.id].length;
        }
      }
    } else {
      data[field.id] = value;
    }

    if (field.onChange) {
      field.onChange(data[field.id]);
    }

    if (submitted) {
      var result = this.checkField(field, data[field.id]);
      if (result.valid) {
        errors[field.id] = null;
      } else {
        errors[field.id] = result.errmsg;
      }
    }
    this.setState({
      data: data,
      errors: errors,
      submitStatus: '',
      showErrorTips: false
    });

    var onChange = this.props.onChange;


    if (onChange) {
      onChange(data);
    }
  };

  RichForm.prototype.renderErrorTips = function renderErrorTips(msg) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { styleName: "errortips-wrapper" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { styleName: "errortips" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-exclamation-circle" }),
        ' ',
        msg
      )
    );
  };

  RichForm.prototype.renderField = function renderField(field) {
    var _this4 = this;

    var _state5 = this.state,
        data = _state5.data,
        errors = _state5.errors;


    var control = void 0;
    if (field.type === 'search-selector') {
      control = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SearchSelector__["a" /* default */], {
          options: field.options,
          placeholder: field.placeholder,
          onChange: function onChange(value) {
            return _this4.handleFieldChange(field, value);
          }
        })
      );
    } else {
      control = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { styleName: "labeled-input" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
          bsClass: "aisz-form-control-f",
          placeholder: field.placeholder,
          value: data[field.id] || '',
          onChange: function onChange(e) {
            return _this4.handleFieldChange(field, e.target.value, e);
          },
          inputRef: function inputRef(ref) {
            _this4.inputRefs[field.id] = ref;
          }
        }),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { styleName: "input-label" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__RichLabel__["a" /* default */], { content: field.inputLabel || '' })
        )
      );
    }

    var errorTips = void 0;
    if (errors[field.id]) {
      errorTips = this.renderErrorTips(errors[field.id]);
    }

    var helpBlock = void 0;
    if (field.help) {
      helpBlock = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["HelpBlock"],
        { styleName: "field-help" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-info-circle" }),
        ' ',
        field.help
      );
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
      {
        key: field.id,
        validationState: this.state.errors[field.id] ? 'error' : undefined
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
        { md: field.labelCols },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
          { bsClass: "aisz-control-label" },
          field.label,
          ' ',
          field.required && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicon glyphicon-asterisk" })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
        { md: field.controlCols },
        control,
        errorTips,
        helpBlock
      )
    );
  };

  RichForm.prototype.render = function render() {
    var _this5 = this;

    var _state6 = this.state,
        submitError = _state6.submitError,
        _state6$submitStatus = _state6.submitStatus,
        submitStatus = _state6$submitStatus === undefined ? '' : _state6$submitStatus,
        _state6$showErrorTips = _state6.showErrorTips,
        showErrorTips = _state6$showErrorTips === undefined ? false : _state6$showErrorTips;
    var _props2 = this.props,
        labelCols = _props2.labelCols,
        controlCols = _props2.controlCols,
        buttonLabel = _props2.buttonLabel,
        successButtonLabel = _props2.successButtonLabel,
        errorButtonLabel = _props2.errorButtonLabel;


    var btnLabel = buttonLabel;
    if (submitStatus === 'success') {
      btnLabel = successButtonLabel || buttonLabel;
    } else if (submitStatus === 'error') {
      btnLabel = errorButtonLabel || buttonLabel;
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { styleName: "rich-form" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Form"],
        {
          horizontal: true,
          onSubmit: function onSubmit(e) {
            return _this5.handleSubmit(e);
          }
        },
        this.props.fields.map(function (f) {
          f.labelCols = _this5.props.labelCols;
          f.controlCols = _this5.props.controlCols;
          return _this5.renderField(f);
        }),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
            {
              mdOffset: this.props.labelCols,
              md: this.props.controlCols
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              { styleName: "submit " + submitStatus },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
                {
                  bsStyle: "aisz-primary",
                  type: "submit"
                },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "span",
                  { styleName: "btn-label" },
                  btnLabel
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
            { mdOffset: labelCols, md: controlCols },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Collapse"],
              { "in": showErrorTips },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "div",
                  { styleName: "errtips" },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-exclamation-sign" }),
                  ' ',
                  submitError
                )
              )
            )
          )
        )
      )
    );
  };

  return RichForm;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

RichForm.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(function () {
  return {};
}, {})(__WEBPACK_IMPORTED_MODULE_4_react_css_modules___default()(RichForm, __WEBPACK_IMPORTED_MODULE_9__styles_main_scss___default.a, { allowMultiple: true })));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss__ = __webpack_require__(2148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_scss__);





/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var defaultProps = {
  className: 'aisz-form-control',
  value: '',
  children: null,
  onChange: function onChange() {},
  placeholder: null,
  options: []
};

var propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string,
  value: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.any,
  children: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.any,
  onChange: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func,
  placeholder: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string,
  options: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.array
};

var SearchSelMultiple = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SearchSelMultiple, _React$Component);

  function SearchSelMultiple(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SearchSelMultiple);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    var options = props.options;
    if (!options) {
      options = __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.map(props.children, function (c) {
        return {
          value: c.props.value,
          label: String(c.props.children)
        };
      });
    }
    _this.selectValue = [props.value];
    _this.options = options.map(function (opt) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, opt, {
        active: _.includes(_this.selectValue, props.value)
      });
    });

    _this.state = {
      value: props.value
    };
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleSelectOption = _this.handleSelectOption.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  SearchSelMultiple.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var value = nextProps.value,
        options = nextProps.options;

    if (value !== this.props.value) {
      this.setState({ value: value });
    }
    if (options !== this.props.options) {
      this.options = options;
    }
  };

  SearchSelMultiple.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  };

  SearchSelMultiple.prototype.handleInputChange = function handleInputChange(e) {
    var _this2 = this;

    var inputLabel = e.target.value;
    var options = void 0;
    if (inputLabel === '') {
      // options = this.options;
      options = this.options.map(function (o) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, o, {
          active: _.includes(_this2.selectValue, o.value)
        });
      });
    } else {
      options = this.options.filter(function (opt) {
        return String(opt.label).toUpperCase().indexOf(inputLabel.toUpperCase()) >= 0;
      });
      options = options.map(function (o) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, o, {
          active: _.includes(_this2.selectValue, o.value)
        });
      });
    }

    this.setState({
      inputLabel: inputLabel,
      options: options,
      open: true
    });
  };

  SearchSelMultiple.prototype.handleSelectOption = function handleSelectOption(opt) {
    var _this3 = this;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    if (_.includes(this.selectValue, opt.value)) {
      this.selectValue = _.filter(this.selectValue, function (s) {
        return s !== opt.value;
      });
    } else {
      this.selectValue = _.concat(this.selectValue, [opt.value]);
    }
    this.selectValue = _.filter(this.selectValue, function (s) {
      return !_.isNil(s) && s !== '';
    });
    this.setState({
      value: this.selectValue[0],
      options: this.options.map(function (o) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, o, {
          active: _.includes(_this3.selectValue, o.value)
        });
      })
      // open: false,
    });
    if (this.iptRef) {
      this.iptRef.focus();
    }

    var onChange = this.props.onChange;

    if (onChange) {
      onChange(this.selectValue);
    }
  };

  SearchSelMultiple.prototype.handleFocus = function handleFocus() {
    var _this4 = this;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.setState({
      options: this.options.map(function (opt) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, opt, {
          active: _.includes(_this4.selectValue, opt.value)
        });
      }),
      inputLabel: '',
      open: true
    });
  };

  SearchSelMultiple.prototype.handleBlur = function handleBlur() {
    var _this5 = this;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(function () {
      return _this5.setState({ open: false });
    }, 300);
  };

  SearchSelMultiple.prototype.handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Enter') {
      var _state = this.state,
          open = _state.open,
          _state$options = _state.options,
          options = _state$options === undefined ? [] : _state$options;

      if (open && options[0]) {
        this.handleSelectOption(options[0]);
      }
    }
  };

  SearchSelMultiple.prototype.render = function render() {
    var _this6 = this;

    var _props = this.props,
        children = _props.children,
        _props$className = _props.className,
        className = _props$className === undefined ? 'aisz-form-control' : _props$className,
        placeholder = _props.placeholder,
        s = _props.styles,
        v = _props.value,
        o = _props.options,
        rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ["children", "className", "placeholder", "styles", "value", "options"]);

    var _state2 = this.state,
        value = _state2.value,
        _state2$options = _state2.options,
        options = _state2$options === undefined ? [] : _state2$options,
        _state2$open = _state2.open,
        open = _state2$open === undefined ? false : _state2$open;
    var _state$inputLabel = this.state.inputLabel,
        inputLabel = _state$inputLabel === undefined ? '' : _state$inputLabel;


    if (!open) {
      var currOpt = this.options.find(function (opt) {
        return opt.value === value;
      });
      if (currOpt) {
        inputLabel = currOpt.label;
      }
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.select + " " + (open ? __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.open : '') + " select" },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "select",
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rest, { value: value || '' }),
        children
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("input", {
        className: className,
        value: inputLabel,
        onChange: this.handleInputChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onKeyDown: this.handleKeyDown,
        placeholder: placeholder,
        ref: function ref(r) {
          _this6.iptRef = r;
        }
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.dropdown },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "ul",
          null,
          options.map(function (opt, idx) {
            var label = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "span",
              null,
              opt.label
            );
            if (opt.formatter) {
              label = opt.formatter(opt.label);
            }
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "li",
              {
                className: (opt.active ? __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.active : '') + " " + (idx === 0 ? __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.hover : ''),
                key: opt.value,
                style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, opt.style)
              },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
                { onClick: function onClick() {
                    return _this6.handleSelectOption(opt);
                  } },
                label,
                opt.active && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-check" })
              )
            );
          })
        )
      )
    );
  };

  return SearchSelMultiple;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

SearchSelMultiple.defaultProps = defaultProps;
SearchSelMultiple.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (SearchSelMultiple);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_TablePager__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_SearchInput__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_scss__ = __webpack_require__(2150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);














var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  checked: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array.isRequired,
  onSuccess: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  showModal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired
};

var SelectGatewayModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(SelectGatewayModal, _React$Component);

  SelectGatewayModal.getQ = function getQ(search) {
    if (search) {
      var s = search.replace(/[-:]/g, '');
      return "or,name:*" + s + "*,platform:*" + s + "*,id:*" + s + "*,city:*" + s + "*,area:*" + s + "*,version:*" + s + "*,band:*" + s + "*";
    }
    return null;
  };

  function SelectGatewayModal(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SelectGatewayModal);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      list: [],
      checked: props.checked,
      showModal: props.showModal,
      mark: 0,
      more: false,
      reset: 0
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__["a" /* default */](props.intl, '');
    _this.mark = 0;
    _this.q = '';
    return _this;
  }

  SelectGatewayModal.prototype.componentWillMount = function componentWillMount() {
    this.loadGateways();
  };

  SelectGatewayModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var showModal = nextProps.showModal,
        checked = nextProps.checked;

    if (showModal !== this.props.showModal) {
      this.setState({ showModal: showModal });
      if (showModal) {
        this.loadGateways();
      }
    }
    if (_.isEqual(checked, this.props.checked)) {
      this.setState({ checked: checked });
    }
  };

  SelectGatewayModal.prototype.getStatus = function getStatus(gw) {
    var disconnected = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "span",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-circle-o " + __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.disconnected }),
      ' ',
      this.intlMsg.globalMsg('selectgateway.disconnected')
    );
    var connected = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "span",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-circle " + __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.connected }),
      ' ',
      this.intlMsg.globalMsg('selectgateway.connected')
    );

    if (_.isNil(gw.lastOn)) {
      return disconnected;
    }
    if (_.isNil(gw.lastOff)) {
      return connected;
    }
    var onts = new Date(gw.lastOn).valueOf();
    var offts = new Date(gw.lastOff).valueOf();
    if (onts > offts) {
      return connected;
    }
    return disconnected;
  };

  SelectGatewayModal.prototype.loadGateways = function loadGateways() {
    var _this2 = this;

    this.setState({ status: 'loading' });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__api_callAPI__["a" /* default */])({
      endpoint: '/lora/gateways',
      query: {
        mark: this.mark,
        sort: '-lastOn',
        q: this.q
      }
    }).then(function (res) {
      _this2.setState({
        list: res.list,
        more: res.more,
        mark: res.mark,
        status: 'success'
      });
    }).catch(function () {});
  };

  SelectGatewayModal.prototype.handleSearch = function handleSearch(e) {
    var _this3 = this;

    var search = _.trimStart(e.target.value);
    this.search = search;
    this.mark = '';
    this.q = SelectGatewayModal.getQ(search);
    this.setState({ search: search });

    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    this.searchTimeout = setTimeout(function () {
      _this3.loadGateways();
    }, 500);
  };

  SelectGatewayModal.prototype.isChecked = function isChecked(d) {
    var checked = this.state.checked;

    return _.some(checked, { id: d.id });
  };

  SelectGatewayModal.prototype.toggleCheck = function toggleCheck(d) {
    var checked = this.state.checked;

    if (this.isChecked(d)) {
      checked = _.filter(checked, function (c) {
        return c.id !== d.id;
      });
    } else {
      checked = _.concat(checked, [d]);
    }
    this.setState({ checked: checked });
  };

  SelectGatewayModal.prototype.handlePrevPage = function handlePrevPage(mark) {
    this.mark = mark;
    this.loadGateways();
  };

  SelectGatewayModal.prototype.handleNextPage = function handleNextPage(mark) {
    this.mark = mark;
    this.loadGateways();
  };

  SelectGatewayModal.prototype.handleAdd = function handleAdd() {
    var checked = this.state.checked;

    this.props.onSuccess(checked);
    this.setState({ reset: new Date(), checked: [], mark: 0 });
    this.mark = 0;
  };

  SelectGatewayModal.prototype.render = function render() {
    var _this4 = this;

    var _state = this.state,
        showModal = _state.showModal,
        list = _state.list,
        mark = _state.mark,
        more = _state.more,
        reset = _state.reset,
        status = _state.status,
        _state$search = _state.search,
        search = _state$search === undefined ? '' : _state$search;
    var _onHide = this.props.onHide;

    var rows = _.map(list, function (item) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        { key: item.id },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.checkbox },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Checkbox__["a" /* default */], {
            id: item.id,
            checked: _this4.isChecked(item),
            onChange: function onChange() {
              return _this4.toggleCheck(item);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          item.name
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          _this4.getStatus(item)
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          item.lng === 'undefined' ? '' : item.lng || ''
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          item.lat === 'undefined' ? '' : item.lat || ''
        )
      );
    });
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"],
      {
        show: showModal,
        onHide: function onHide() {
          _this4.setState({ checked: [] });
          _onHide();
        },
        bsClass: "aisz-modal-light"
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Header,
        { closeButton: true, className: "clearfix" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_SearchInput__["a" /* default */], {
            placeholder: this.intlMsg.globalMsg('selectgateway.search.placeholder'),
            value: search,
            onChange: function onChange(e) {
              return _this4.handleSearch(e);
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Table"],
          {
            className: "aisz-table-light",
            bordered: true,
            responsive: true
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("th", null),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.globalMsg('selectgateway.name')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.globalMsg('selectgateway.status')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.globalMsg('selectgateway.lng')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.globalMsg('selectgateway.lat')
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tbody",
            null,
            rows
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.tips },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["HelpBlock"],
            { className: "aisz-help-block " + __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.flex },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-info-circle" }),
            "\xA0",
            this.intlMsg.msg('selectgateway.tips')
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
            { "if": list.length > 0 },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_TablePager__["a" /* default */], {
                status: status,
                mark: mark,
                more: more,
                reset: reset,
                onPrev: function onPrev(m) {
                  return _this4.handlePrevPage(m);
                },
                onNext: function onNext(m) {
                  return _this4.handleNextPage(m);
                }
              })
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Footer,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-success",
            className: "pull-right",
            onClick: function onClick() {
              return _this4.handleAdd();
            }
          },
          this.intlMsg.globalMsg('selectgateway.confirm')
        )
      )
    );
  };

  return SelectGatewayModal;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

SelectGatewayModal.propTypes = propTypes;

var mapDispatchToProps = {};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(SelectGatewayModal)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_is_valid__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_is_valid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_is_valid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_set_minutes__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_set_minutes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_set_minutes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_MomentSelect__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss__ = __webpack_require__(2158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);












var propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  date: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(Date)
};

var defaultProps = {
  date: new Date()
};

var TimePicker = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(TimePicker, _React$Component);

  function TimePicker(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TimePicker);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      date: __WEBPACK_IMPORTED_MODULE_8_date_fns_set_minutes___default()(props.date, '0')
    };
    _this.id = "timepiacker_" + Number(Math.random() * 10000).toFixed(0);
    _this.handleInputFocus = _this.handleInputFocus.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleInputBlur = _this.handleInputBlur.bind(_this);
    _this.handleOnSelect = _this.handleOnSelect.bind(_this);
    _this.clickToBlur = _this.clickToBlur.bind(_this);
    _this.inputChanged = false;
    return _this;
  }

  TimePicker.prototype.componentDidMount = function componentDidMount() {
    $('body').click(this.clickToBlur);
  };

  TimePicker.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var date = nextProps.date;

    if (!_.isEqual(date, this.props.date)) {
      this.setState({ date: date });
    }
  };

  TimePicker.prototype.componentWillUnmount = function componentWillUnmount() {
    $('body').off('click', this.clickToBlur);
  };

  TimePicker.prototype.clickToBlur = function clickToBlur(e) {
    var _this2 = this;

    var blurred = true;
    $(e.target).parents().each(function (idx, elem) {
      if (elem.id === _this2.id) {
        blurred = false;
      }
    });
    if (blurred) {
      this.setState({ showOverlay: false });
      this.props.onSelect(this.state.date);
    }
  };

  TimePicker.prototype.handleInputFocus = function handleInputFocus() {
    this.setState({ showOverlay: true });
  };

  TimePicker.prototype.handleInputChange = function handleInputChange(e) {
    var value = e.target.value.trim();
    this.setState({ value: value });
    var date = new Date(value);
    if (__WEBPACK_IMPORTED_MODULE_7_date_fns_is_valid___default()(date)) {
      this.inputChanged = true;
      this.setState({ date: date });
    }
  };

  TimePicker.prototype.handleInputBlur = function handleInputBlur() {
    if (this.inputChanged) {
      var onSelect = this.props.onSelect;
      var date = this.state.date;

      this.inputChanged = false;
      onSelect(date);
    }
  };

  TimePicker.prototype.handleOnSelect = function handleOnSelect(date) {
    this.setState({ date: date });
  };

  TimePicker.prototype.render = function render() {
    var _state = this.state,
        _state$showOverlay = _state.showOverlay,
        showOverlay = _state$showOverlay === undefined ? false : _state$showOverlay,
        date = _state.date;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { id: this.id, styleName: "timepicker" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
        bsClass: "aisz-form-control-f",
        type: "text",
        value: __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(date, 'HH:mm'),
        onFocus: this.handleInputFocus,
        onBlur: this.handleInputBlur,
        onChange: this.handleInputChange
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__components_ShowIf__["a" /* default */],
        { "if": showOverlay },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "overlay" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { styleName: "container" },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_MomentSelect__["a" /* default */], {
              date: date,
              onSelect: this.handleOnSelect
            })
          )
        )
      )
    );
  };

  return TimePicker;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

TimePicker.propTypes = propTypes;
TimePicker.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5_react_css_modules___default()(TimePicker, __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a, { allowMultiple: true }));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var propTypes = {
  showModal: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  text: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,
  header: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired
};

var WarningModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(WarningModal, _React$Component);

  function WarningModal(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, WarningModal);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      showModal: props.showModal
    };
    return _this;
  }

  WarningModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var showModal = nextProps.showModal;

    if (showModal !== this.props.showModal) {
      this.setState({ showModal: showModal });
    }
  };

  WarningModal.prototype.render = function render() {
    var showModal = this.state.showModal;
    var _props = this.props,
        _onHide = _props.onHide,
        text = _props.text,
        header = _props.header;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Modal"],
      {
        show: showModal,
        bsClass: "aisz-modal-warning",
        onHide: function onHide() {
          return _onHide();
        },
        backdrop: "static"
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        header
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Modal"].Body,
        { className: "text-center" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "p",
          null,
          text
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Button"],
          { bsStyle: "aisz-warning", onClick: _onHide },
          "\u786E\u5B9A"
        )
      )
    );
  };

  return WarningModal;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

WarningModal.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (WarningModal);

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_PropsPanel__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_PageLoading__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_PageError__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loraactions_account__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loraactions_org__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lorautils_api_status__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_loracfg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss__ = __webpack_require__(2160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.any.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  orgBasic: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  accountBasic: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  accountUpdated: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  updateAccount: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  updateOrg: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  orgUpdated: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  getAccountBasic: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  getOrgBasic: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  plan: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired
};

var InfoView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(InfoView, _React$Component);

  function InfoView(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, InfoView);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      plan: props.plan,
      orgBasic: props.orgBasic,
      accountBasic: props.accountBasic,
      accountUpdated: props.accountUpdated
    };
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_17_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'accountcenter.infoview');
    return _this;
  }

  InfoView.prototype.componentWillMount = function componentWillMount() {
    var getAccountBasic = this.props.getAccountBasic;

    getAccountBasic();
  };

  InfoView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var orgBasic = nextProps.orgBasic,
        accountBasic = nextProps.accountBasic,
        accountUpdated = nextProps.accountUpdated,
        plan = nextProps.plan,
        orgUpdated = nextProps.orgUpdated,
        getOrgBasic = nextProps.getOrgBasic,
        getAccountBasic = nextProps.getAccountBasic;


    if (orgBasic !== this.props.orgBasic) {
      this.setState({ orgBasic: orgBasic });
    }
    if (accountBasic !== this.props.accountBasic) {
      this.setState({ accountBasic: accountBasic });
    }
    if (orgUpdated !== this.props.orgUpdated) {
      if (orgUpdated.status === 'success') {
        getOrgBasic();
      }
    }
    if (accountUpdated !== this.props.accountUpdated) {
      if (accountUpdated.status === 'success') {
        getAccountBasic();
      }
    }
    if (plan !== this.props.plan) {
      this.setState({ plan: plan });
    }
  };

  InfoView.prototype.handleSubmit = function handleSubmit(data, dirtyIds) {
    if (dirtyIds.length === 0) {
      return true;
    }

    var _props = this.props,
        updateAccount = _props.updateAccount,
        updateOrg = _props.updateOrg;

    var company = data.company,
        accountData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(data, ["company"]);

    if (dirtyIds.includes('company')) {
      updateOrg({ company: company });
    }
    if (!dirtyIds.includes('company') || dirtyIds.length > 2) {
      updateAccount(accountData);
    }

    return true;
  };

  InfoView.prototype.renderBasic = function renderBasic() {
    var _state = this.state,
        accountBasic = _state.accountBasic,
        orgBasic = _state.orgBasic,
        _state$editBasic = _state.editBasic,
        editBasic = _state$editBasic === undefined ? false : _state$editBasic;
    var _accountBasic$data = accountBasic.data;
    _accountBasic$data = _accountBasic$data === undefined ? {} : _accountBasic$data;
    var name = _accountBasic$data.name,
        tel = _accountBasic$data.tel,
        email = _accountBasic$data.email;
    var company = orgBasic.data.company;


    var data = {
      name: name,
      tel: tel,
      email: email,
      company: company,
      login: email
    };

    var properties = [{
      id: 'login',
      name: this.intlMsg.msg('basic.login'),
      readOnly: true
    }, {
      id: 'name',
      name: this.intlMsg.msg('basic.name')
    }, {
      id: 'tel',
      name: this.intlMsg.msg('basic.telephone')
    }, {
      id: 'email',
      name: this.intlMsg.msg('basic.email'),
      readOnly: true
    }, {
      id: 'company',
      name: this.intlMsg.msg('basic.company')
    }];

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_PropsPanel__["a" /* default */], {
      title: this.intlMsg.msg('basic.title'),
      properties: properties,
      data: data,
      onSubmit: this.handleSubmit,
      edit: editBasic,
      show: {
        display: {
          email: __WEBPACK_IMPORTED_MODULE_19_loracfg__["a" /* default */].profile === 'cloud'
        },
        edit: {
          email: __WEBPACK_IMPORTED_MODULE_19_loracfg__["a" /* default */].profile === 'cloud'
        }
      }
    });
  };

  InfoView.prototype.renderQuota = function renderQuota() {
    var orgBasic = this.state.orgBasic.data;
    var lrappnum = orgBasic.lrappnum,
        lrgatewaynum = orgBasic.lrgatewaynum,
        lrnodenum = orgBasic.lrnodenum;

    var data = {
      lrappnum: lrappnum,
      lrgatewaynum: lrgatewaynum,
      lrnodenum: lrnodenum
    };

    var properties = [{
      id: 'lrappnum',
      name: this.intlMsg.msg('quota.lrappnum'),
      readOnly: true
    }, {
      id: 'lrgatewaynum',
      name: this.intlMsg.msg('quota.lrgatewaynum'),
      readOnly: true
    }, {
      id: 'lrnodenum',
      name: this.intlMsg.msg('quota.lrnodenum'),
      readOnly: true
    }];

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_PropsPanel__["a" /* default */], {
      readOnly: true,
      title: this.intlMsg.msg('quota.title'),
      properties: properties,
      data: data
    });
  };

  InfoView.prototype.renderBilling = function renderBilling() {
    var _this2 = this;

    var pushState = this.props.pushState;
    var plan = this.state.plan;
    var _plan$data = plan.data,
        balance = _plan$data.balance,
        billday = _plan$data.billday,
        tier = _plan$data.tier;


    var data = {
      balance: balance,
      billday: billday,
      tier: tier
    };
    var properties = [{
      id: 'tier',
      name: this.intlMsg.msg('plan.tier'),
      formatter: function formatter(x) {
        if (x === 1) {
          return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "span",
            null,
            _this2.intlMsg.msg('plan.trialuser'),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
              {
                bsStyle: "aisz-link-warning",
                className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.action,
                onClick: function onClick() {
                  return pushState('/billing/plans');
                }
              },
              _this2.intlMsg.msg('plan.upgrade')
            )
          );
        } else if (x === 2) {
          return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "span",
            null,
            _this2.intlMsg.msg('plan.svcpackuser'),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
              {
                bsStyle: "aisz-link-warning",
                className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.action,
                onClick: function onClick() {
                  return pushState('/billing/plans');
                }
              },
              _this2.intlMsg.msg('plan.upgrade')
            )
          );
        } else if (x === 3) {
          return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "span",
            null,
            _this2.intlMsg.msg('plan.commuser')
          );
        }
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-question" });
      }
    }, {
      id: 'balance',
      name: this.intlMsg.msg('plan.balance'),
      formatter: function formatter(x) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "span",
          null,
          x,
          " ",
          _this2.intlMsg.msg('plan.rmbyuan'),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
            {
              bsStyle: "aisz-link",
              className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.action,
              onClick: function onClick() {
                return pushState('/billing/recharge');
              }
            },
            _this2.intlMsg.msg('plan.recharge')
          )
        );
      }
    }, {
      id: 'billday',
      name: this.intlMsg.msg('plan.billday')
    }];

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_PropsPanel__["a" /* default */], {
      readOnly: true,
      title: this.intlMsg.msg('plan.title'),
      properties: properties,
      data: data,
      show: { billday: billday > 0 }
    });
  };

  InfoView.prototype.renderContent = function renderContent() {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.content },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "ul",
        { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.propslist },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "li",
          null,
          " ",
          this.renderBasic(),
          " "
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "li",
          null,
          " ",
          this.renderQuota(),
          " "
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__["a" /* default */],
          { "if": __WEBPACK_IMPORTED_MODULE_19_loracfg__["a" /* default */].profile === 'cloud' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "li",
            null,
            " ",
            this.renderBilling(),
            " "
          )
        )
      )
    );
  };

  InfoView.prototype.render = function render() {
    var _state2 = this.state,
        accountBasic = _state2.accountBasic,
        orgBasic = _state2.orgBasic,
        plan = _state2.plan;


    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_lorautils_api_status__["b" /* somePending */])(accountBasic, orgBasic, plan)) {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_PageLoading__["a" /* default */], null);
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_lorautils_api_status__["c" /* someFailure */])(accountBasic, orgBasic, plan)) {
      var failure = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_lorautils_api_status__["d" /* findFailure */])(accountBasic, orgBasic, plan);
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_PageError__["a" /* default */], { title: this.intlMsg.errorMsg(failure.error.code) });
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_lorautils_api_status__["a" /* allSuccess */])(accountBasic, orgBasic, plan)) {
      return this.renderContent();
    }

    return null;
  };

  return InfoView;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

InfoView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    plan: state.billing.plan,
    orgBasic: state.org.basic,
    accountBasic: state.account.basic,
    accountUpdated: state.account.updateBasic,
    orgUpdated: state.org.updateBasic
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["routerActions"].push,
  getAccountBasic: __WEBPACK_IMPORTED_MODULE_15_loraactions_account__["a" /* default */].basic,
  updateAccount: __WEBPACK_IMPORTED_MODULE_15_loraactions_account__["a" /* default */].updateBasic,
  updateOrg: __WEBPACK_IMPORTED_MODULE_16_loraactions_org__["a" /* default */].updateBasic,
  getOrgBasic: __WEBPACK_IMPORTED_MODULE_16_loraactions_org__["a" /* default */].basic
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_6_react_css_modules___default()(InfoView, __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a, { allowMultiple: true }))));

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_Editable__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loraapi_token__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_scss__ = __webpack_require__(2161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var TableList = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(TableList, _React$Component);

  function TableList(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TableList);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      list: props.list,
      editName: false,
      editData: { name: props.list.name, id: props.list.token },
      ainimation: false,
      errors: __WEBPACK_IMPORTED_MODULE_10_lorautils_errors_ErrorSet__["a" /* default */].createEmpty().add('FE_EMPTY', 'green.min').add('FE_EMPTY', 'green.max').add('FE_EMPTY', 'yellow.min').add('FE_EMPTY', 'yellow.max').add('FE_EMPTY', 'red.min').add('FE_EMPTY', 'red.max')
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'accountcenter.manageview');
    _this.handleEditName = _this.handleEditName.bind(_this);
    _this.handleChangeName = _this.handleChangeName.bind(_this);
    _this.handleSubmitName = _this.handleSubmitName.bind(_this);
    _this.handleDelete = _this.handleDelete.bind(_this);
    _this.handleCancelEdit = _this.handleCancelEdit.bind(_this);
    return _this;
  }

  TableList.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var list = nextProps.list;

    if (list !== this.props.list) {
      this.setState({ list: list });
    }
  };

  TableList.prototype.handleEditName = function handleEditName() {
    var _state = this.state,
        name = _state.list.name,
        id = _state.editData.id;

    this.setState({ editName: true, editData: { name: name, id: id } });
  };

  TableList.prototype.handleCancelEdit = function handleCancelEdit() {
    var _state2 = this.state,
        name = _state2.list.name,
        id = _state2.editData.id,
        errors = _state2.errors;

    this.setState({ editName: false, editData: { name: name, id: id }, errors: errors.remove('name') });
  };

  TableList.prototype.handleChangeName = function handleChangeName(data) {
    var errors = this.state.errors;

    this.setState({ editData: data, errors: errors.remove('name') });
  };

  TableList.prototype.handleSubmitName = function handleSubmitName() {
    var _this2 = this;

    var _state3 = this.state,
        _state3$editData = _state3.editData,
        id = _state3$editData.id,
        name = _state3$editData.name,
        list = _state3.list,
        errors = _state3.errors;

    if (_.trim(name).length !== 0) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_loraapi_token__["d" /* editToken */])(id, name).then(function () {
        _this2.setState({ editName: false, list: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(list, { name: name }) });
      }).catch(function () {});
    } else {
      this.setState({ errors: errors.add('FE_EMPTY', 'name') });
    }
  };

  TableList.prototype.handleDelete = function handleDelete() {
    var onHandleDelete = this.props.onHandleDelete;
    var _state$list = this.state.list,
        token = _state$list.token,
        name = _state$list.name;

    onHandleDelete(token, name);
  };

  TableList.prototype.render = function render() {
    var _state4 = this.state,
        list = _state4.list,
        editName = _state4.editName,
        _state4$editData = _state4.editData,
        editData = _state4$editData === undefined ? {} : _state4$editData,
        errors = _state4.errors;
    var showAnimation = this.props.showAnimation;

    var editTp = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Tooltip"],
      { id: "tooltip-ed" },
      this.intlMsg.msg('tablecolumn.edit')
    );
    var editTpDelete = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Tooltip"],
      { id: "tooltip-ed" },
      this.intlMsg.msg('tablecolumn.delete')
    );
    var animation = this.props.index === 0 && showAnimation ? "animated slideInLeft " + __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a['newly-created'] : '';
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "tr",
      { className: animation },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Editable__["a" /* default */], {
          id: "name",
          edit: editName,
          data: editData,
          value: list.name,
          onChange: this.handleChangeName,
          formatter: function formatter() {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "span",
              null,
              list.name
            );
          },
          error: this.intlMsg.errorMsg(errors.get('name')),
          errorPlacement: 'top'
        }),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__["a" /* default */],
          { "if": !editName },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["OverlayTrigger"],
            { placement: "top", overlay: editTp },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_router__["f" /* Link */],
              { onClick: this.handleEditName, className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.edit },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-pencil " + __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.gray })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__["a" /* default */],
          { "if": editName },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.actions },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_router__["f" /* Link */],
              { onClick: this.handleSubmitName, className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.ok },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-ok" })
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_router__["f" /* Link */],
              { onClick: this.handleCancelEdit, className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.cancel },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-remove" })
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "td",
        null,
        list.token
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "td",
        null,
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_date_fns__["format"])(list.createdAt, 'YYYY-MM-DD HH:mm:ss')
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["OverlayTrigger"],
          { placement: "top", overlay: editTpDelete },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_router__["f" /* Link */],
            {
              className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.edit,
              onClick: this.handleDelete
            },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "halflings halflings-trash " + __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.deleteIcon + " " + __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.icon })
          )
        )
      )
    );
  };

  return TableList;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

TableList.propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  list: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  index: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.number.isRequired,
  onHandleDelete: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  showAnimation: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.bool
};

TableList.defaultProps = {
  showAnimation: false
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(TableList));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loraapi_token__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TableList__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_scss__ = __webpack_require__(2162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);











var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired
};

var AccountCenter = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(AccountCenter, _React$Component);

  function AccountCenter(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AccountCenter);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      lists: [],
      showDeleteModal: false,
      deleteObj: { id: '', name: '' },
      showAddTokenModal: false,
      newToken: '',
      editName: false,
      showAnimation: false,
      addErr: false,
      deleteErr: false,
      addEmpty: false
    };

    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'accountcenter.manageview');
    _this.handleDeleteModal = _this.handleDeleteModal.bind(_this);
    _this.handleDeleteToken = _this.handleDeleteToken.bind(_this);
    _this.handleNewTokenChange = _this.handleNewTokenChange.bind(_this);
    _this.handleAddToken = _this.handleAddToken.bind(_this);
    _this.handleEditName = _this.handleEditName.bind(_this);
    return _this;
  }

  AccountCenter.prototype.componentWillMount = function componentWillMount() {
    this.loadTokenList();
  };

  AccountCenter.prototype.loadTokenList = function loadTokenList() {
    var _this2 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_loraapi_token__["a" /* getTokenList */])({ pageSize: 100 }).then(function (res) {
      var lists = _.sortBy(res.list, function (l) {
        return l.createdAt;
      }).reverse();
      _this2.setState({ lists: lists });
    }).catch(function () {});
  };

  AccountCenter.prototype.handleDeleteModal = function handleDeleteModal(id, name) {
    this.setState({ showDeleteModal: true, deleteErr: false, deleteObj: { id: id, name: name } });
  };

  AccountCenter.prototype.handleDeleteToken = function handleDeleteToken() {
    var _this3 = this;

    var _state = this.state,
        id = _state.deleteObj.id,
        lists = _state.lists;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_loraapi_token__["b" /* deleteToken */])(id).then(function () {
      var newLists = _.filter(lists, function (list) {
        return list.token !== id;
      });
      _this3.setState({ lists: newLists, showDeleteModal: false });
    }).catch(function (err) {
      var code = err.code === 'GENERALERROR' ? 'GENERALERROR' : 'COMMONERR';
      _this3.setState({ deleteErr: code });
    });
  };

  AccountCenter.prototype.handleNewTokenChange = function handleNewTokenChange(e) {
    var newToken = e.target.value;
    this.setState({ newToken: newToken });
    if (_.trim(newToken).length !== 0) {
      this.setState({ addEmpty: false });
    }
  };

  AccountCenter.prototype.handleAddToken = function handleAddToken() {
    var _this4 = this;

    var _state2 = this.state,
        newToken = _state2.newToken,
        lists = _state2.lists;

    if (_.trim(newToken).length !== 0) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_loraapi_token__["c" /* addtoken */])(newToken).then(function (res) {
        lists.unshift(res);
        _this4.setState({ newToken: '', showAddTokenModal: false, lists: lists, showAnimation: true });
        _.delay(function () {
          _this4.setState({ showAnimation: false });
        }, 500);
      }).catch(function () {
        _this4.setState({ addErr: true });
      });
    } else {
      this.setState({ addEmpty: true });
      this.tokenInput.focus();
    }
  };

  AccountCenter.prototype.handleEditName = function handleEditName() {
    this.setState({ editName: true });
  };

  AccountCenter.prototype.render = function render() {
    var _this5 = this;

    var _state3 = this.state,
        lists = _state3.lists,
        showDeleteModal = _state3.showDeleteModal,
        deleteObj = _state3.deleteObj,
        showAddTokenModal = _state3.showAddTokenModal,
        newToken = _state3.newToken,
        showAnimation = _state3.showAnimation,
        addErr = _state3.addErr,
        deleteErr = _state3.deleteErr,
        addEmpty = _state3.addEmpty;

    var content = lists.map(function (list, index) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TableList__["a" /* default */], {
        key: list.token,
        list: list,
        index: index,
        showAnimation: showAnimation,
        onHandleDelete: _this5.handleDeleteModal
      });
    });
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.tokenContainer },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.mTL },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.mRL },
          this.intlMsg.msg('title.token')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
            {
              bsStyle: "aisz-success",
              onClick: function onClick() {
                return _this5.setState({
                  showAddTokenModal: true,
                  addErr: false,
                  addEmpty: false
                });
              }
            },
            "Token\xA0",
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-plus" })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Table"],
        { className: "aisz-table-light", striped: true, hover: true, bordered: true, responsive: true },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('tablecolumn.name')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              "Token"
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('tablecolumn.createtime')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('tablecolumn.operation')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "tbody",
          null,
          content
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"],
        {
          bsClass: "aisz-modal-danger",
          show: showDeleteModal,
          onHide: function onHide() {
            return _this5.setState({ showDeleteModal: false });
          }
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Header,
          { closeButton: true },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: "text-center" },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle", "aria-hidden": "true" }),
            "\xA0",
            this.intlMsg.msg('deletetip.deletetoken')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_loracoms_ShowIf__["a" /* default */],
            { "if": deleteErr === false },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              { className: "text-center" },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "p",
                null,
                this.intlMsg.msg('deletetip.confirmdelete'),
                "\xA0",
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "strong",
                  null,
                  deleteObj.name,
                  "(",
                  deleteObj.id,
                  ")"
                ),
                " ?"
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
                  {
                    bsStyle: "aisz-warning",
                    onClick: function onClick() {
                      return _this5.setState({ showDeleteModal: false });
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-repeat", "aria-hidden": "true" }),
                  "\xA0",
                  this.intlMsg.msg('cancel', 'lora.button')
                ),
                "\xA0",
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
                  {
                    bsStyle: "aisz-danger",
                    onClick: this.handleDeleteToken
                  },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-trash-o", "aria-hidden": "true" }),
                  "\xA0",
                  this.intlMsg.msg('confirm', 'lora.button')
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_loracoms_ShowIf__["a" /* default */],
            { "if": deleteErr === 'GENERALERROR' },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "p",
              { className: "text-danger text-center" },
              this.intlMsg.msg('deletetokentip')
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_loracoms_ShowIf__["a" /* default */],
            { "if": deleteErr === 'COMMONERR' },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "p",
              { className: "text-danger text-center" },
              this.intlMsg.msg('deletetokentipcommon')
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"],
        {
          bsClass: "aisz-modal-light",
          backdrop: "static",
          show: showAddTokenModal,
          onHide: function onHide() {
            return _this5.setState({ showAddTokenModal: false });
          }
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Header,
          { closeButton: true },
          this.intlMsg.msg('addmodaltip')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_loracoms_ShowIf__["a" /* default */],
            { "if": !addErr },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Form"],
              { horizontal: true },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["FormGroup"],
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["ControlLabel"],
                    { bsClass: "aisz-control-label" },
                    this.intlMsg.msg('label.name'),
                    "\xA0*"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["FormControl"], {
                    value: newToken,
                    bsClass: "aisz-form-control-f",
                    placeholder: this.intlMsg.msg('placeholder.token.name'),
                    onChange: this.handleNewTokenChange,
                    inputRef: function inputRef(ref) {
                      _this5.tokenInput = ref;
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_ControlTips__["a" /* default */], {
                    show: addEmpty,
                    message: this.intlMsg.msg('E.FE_EMPTY'),
                    azStyle: "danger",
                    placement: "right"
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["FormGroup"],
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
                  { md: 6, mdOffset: 3 },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
                    {
                      bsStyle: "aisz-primary",
                      className: __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.fullWidth,
                      onClick: this.handleAddToken
                    },
                    this.intlMsg.msg('button.createtoken')
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_loracoms_ShowIf__["a" /* default */],
            { "if": addErr },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "p",
              { className: "text-danger text-center" },
              this.intlMsg.msg('modaltitle')
            )
          )
        )
      )
    );
  };

  return AccountCenter;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

AccountCenter.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(AccountCenter));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loraactions_account__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_scss__ = __webpack_require__(2163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);














var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  changed: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  changePassword: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired
};

var SecurityView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(SecurityView, _React$Component);

  function SecurityView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SecurityView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      errors: new __WEBPACK_IMPORTED_MODULE_13_lorautils_errors_ErrorSet__["a" /* default */]().add('FE_EMPTY', 'oldpwd').add('FE_EMPTY', 'newpwd').add('FE_EMPTY', 'newpwd2'),
      changeSubmitted: false
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'accountcenter.securityview');
    _this.handleSubmitPassword = _this.handleSubmitPassword.bind(_this);
    _this.handleChangeOldPassword = _this.handleChangeOldPassword.bind(_this);
    _this.handleChangeNewPassword = _this.handleChangeNewPassword.bind(_this);
    _this.handleChangeNewPassword2 = _this.handleChangeNewPassword2.bind(_this);
    return _this;
  }

  SecurityView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var changed = nextProps.changed;


    if (changed !== this.props.changed) {
      this.setState({ changedStatus: changed.status });
      if (changed.status === 'success') {
        this.setState({
          oldPassword: '',
          newPassword: '',
          newPassword2: '',
          changeSubmitted: false,
          errors: new __WEBPACK_IMPORTED_MODULE_13_lorautils_errors_ErrorSet__["a" /* default */]().add('FE_EMPTY', 'oldpwd').add('FE_EMPTY', 'newpwd').add('FE_EMPTY', 'newpwd2')
        });
      }
      if (changed.status === 'failure') {
        var errors = this.state.errors;

        this.setState({
          errors: errors.add(changed.error.code, 'submit')
        });
        var that = this;
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(function () {
          that.setState({ errors: errors.remove('submit') });
        }, 3000);
      }
    }
  };

  SecurityView.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.timout) {
      clearTimeout(this.timeout);
    }
  };

  SecurityView.prototype.handleSubmitPassword = function handleSubmitPassword(e) {
    e.preventDefault();

    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.setState({
      changeSubmitted: true
    });

    var _state = this.state,
        _state$oldPassword = _state.oldPassword,
        oldPassword = _state$oldPassword === undefined ? '' : _state$oldPassword,
        _state$newPassword = _state.newPassword,
        newPassword = _state$newPassword === undefined ? '' : _state$newPassword,
        _state$newPassword2 = _state.newPassword2,
        newPassword2 = _state$newPassword2 === undefined ? '' : _state$newPassword2;


    var errors = new __WEBPACK_IMPORTED_MODULE_13_lorautils_errors_ErrorSet__["a" /* default */]();

    if (oldPassword === '') {
      errors = errors.add('FE_EMPTY', 'oldpwd');
    }
    if (newPassword === '') {
      errors = errors.add('FE_EMPTY', 'newpwd');
    }
    if (newPassword2 === '') {
      errors = errors.add('FE_EMPTY', 'newpwd2');
    }
    if (newPassword !== newPassword2) {
      errors = errors.add('FE_NOTSAME', 'newpwd2').add('FE_NOTSAME', 'newpwd');
    }
    if (newPassword.length < 6) {
      errors = errors.add('FE_TOOSHORT', 'newpwd');
    }
    if (oldPassword === newPassword) {
      errors = errors.add('FE_NOTCHANGED', 'newpwd');
    }

    this.setState({ errors: errors });

    if (!errors.isEmpty()) {
      return;
    }

    var changePassword = this.props.changePassword;

    changePassword(oldPassword, newPassword);
  };

  SecurityView.prototype.handleChangeOldPassword = function handleChangeOldPassword(e) {
    var errors = this.state.errors;


    var oldPassword = e.target.value.trim();
    this.setState({ oldPassword: oldPassword });
    if (oldPassword === '') {
      this.setState({
        errors: errors.add('FE_EMPTY', 'oldpwd')
      });
    } else {
      this.setState({
        errors: errors.remove('oldpwd')
      });
    }
  };

  SecurityView.prototype.handleChangeNewPassword = function handleChangeNewPassword(e) {
    var errors = this.state.errors;


    var newPassword = e.target.value.trim();
    this.setState({ newPassword: newPassword });
    if (newPassword === '') {
      this.setState({
        errors: errors.remove('newpwd2').add('FE_EMPTY', 'newpwd')
      });
    } else {
      this.setState({
        errors: errors.remove('newpwd').remove('newpwd2')
      });
    }
  };

  SecurityView.prototype.handleChangeNewPassword2 = function handleChangeNewPassword2(e) {
    var errors = this.state.errors;


    var newPassword2 = e.target.value.trim();
    this.setState({ newPassword2: newPassword2 });
    if (newPassword2 === '') {
      this.setState({
        errors: errors.remove('newpwd').add('FE_EMPTY', 'newpwd2')
      });
    } else {
      this.setState({
        errors: errors.remove('newpwd').remove('newpwd2')
      });
    }
  };

  SecurityView.prototype.renderChangePassword = function renderChangePassword() {
    var _this2 = this;

    var _state2 = this.state,
        _state2$oldPassword = _state2.oldPassword,
        oldPassword = _state2$oldPassword === undefined ? '' : _state2$oldPassword,
        _state2$newPassword = _state2.newPassword,
        newPassword = _state2$newPassword === undefined ? '' : _state2$newPassword,
        _state2$newPassword2 = _state2.newPassword2,
        newPassword2 = _state2$newPassword2 === undefined ? '' : _state2$newPassword2,
        errors = _state2.errors,
        _state2$changeSubmitt = _state2.changeSubmitted,
        changeSubmitted = _state2$changeSubmitt === undefined ? false : _state2$changeSubmitt,
        _state2$changedStatus = _state2.changedStatus,
        changedStatus = _state2$changedStatus === undefined ? '' : _state2$changedStatus;


    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Panel"],
      {
        bsStyle: "aisz-white",
        header: this.intlMsg.msg('changepwd.title'),
        className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.chpwd
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Form"],
        { onSubmit: this.handleSubmitPassword },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
            { className: "aisz-control-label" },
            this.intlMsg.msg('changepwd.oldpwd')
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            type: "password",
            value: oldPassword,
            onChange: this.handleChangeOldPassword
          }),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: errors.has('oldpwd') && changeSubmitted,
            message: this.intlMsg.errorMsg(errors.get('oldpwd')),
            azStyle: "danger"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
            { className: "aisz-control-label" },
            this.intlMsg.msg('changepwd.newpwd')
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            type: "password",
            value: newPassword,
            onChange: this.handleChangeNewPassword
          }),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: errors.has('newpwd') && changeSubmitted,
            message: this.intlMsg.errorMsg(errors.get('newpwd')),
            azStyle: "danger"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
            { className: "aisz-control-label" },
            this.intlMsg.msg('changepwd.newpwd.repeat')
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            type: "password",
            value: newPassword2,
            onChange: this.handleChangeNewPassword2
          }),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: errors.has('newpwd2') && changeSubmitted,
            message: this.intlMsg.errorMsg(errors.get('newpwd2')),
            azStyle: "danger"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.submit },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_RichButton__["a" /* default */], {
              status: changedStatus,
              states: [{
                status: 'default',
                label: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  null,
                  this.intlMsg.msg('changepwd.submit'),
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-ok" })
                ),
                type: 'submit'
              }, {
                status: 'success',
                label: this.intlMsg.msg('changepwd.success'),
                style: 'success',
                timer: function timer() {
                  return _this2.setState({ changedStatus: '' });
                }
              }, {
                status: 'failure',
                label: this.intlMsg.msg('changepwd.failure'),
                style: 'danger',
                timer: function timer() {
                  return _this2.setState({ changedStatus: '' });
                }
              }]
            })
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_FormBlock__["a" /* default */], {
            show: errors.has('submit'),
            message: this.intlMsg.errorMsg(errors.get('submit')),
            azStyle: "danger"
          })
        )
      )
    );
  };

  SecurityView.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.content },
      this.renderChangePassword()
    );
  };

  return SecurityView;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

SecurityView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    changed: state.account.changePassword
  };
};

var mapDispatchToProps = {
  changePassword: __WEBPACK_IMPORTED_MODULE_11_loraactions_account__["a" /* default */].changePassword
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(SecurityView)));

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_SideBar__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_SidebarContainer__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_scss__ = __webpack_require__(2164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);










var defaultProps = {
  children: null
};

var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var AccountCenter = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(AccountCenter, _React$Component);

  function AccountCenter(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AccountCenter);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      view: 'info',
      detail: {}
    };

    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'accountcenter');
    return _this;
  }

  AccountCenter.prototype.renderSideBar = function renderSideBar() {
    var _this2 = this;

    var view = this.state.view;
    var pushState = this.props.pushState;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_SideBar__["a" /* default */], {
      height: window.innerHeight,
      title: this.intlMsg.msg('title'),
      menuItems: [{
        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "glyphicons glyphicons-vcard" }),
        text: this.intlMsg.msg('info'),
        onClick: function onClick() {
          _this2.setState({ view: 'info' });
          pushState('/accountcenter/info');
        },
        active: view === 'info'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-lock" }),
        text: this.intlMsg.msg('security'),
        onClick: function onClick() {
          _this2.setState({ view: 'security' });
          pushState('/accountcenter/security');
        },
        active: view === 'security'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-keys" }),
        text: this.intlMsg.msg('tokenmanagement'),
        onClick: function onClick() {
          _this2.setState({ view: 'management' });
          pushState('/accountcenter/token');
        },
        active: view === 'management'
      }]
    });
  };

  AccountCenter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      this.renderSideBar(),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_loracoms_SidebarContainer__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.view },
          this.props.children
        )
      )
    );
  };

  return AccountCenter;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

AccountCenter.propTypes = propTypes;
AccountCenter.defaultProps = defaultProps;

var mapDisPatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["push"]
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(null, mapDisPatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(AccountCenter)));

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_loraactions_loracube__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loracoms_PageLoading__ = __webpack_require__(76);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);






var defaultProps = {
  children: null,
  activated: false
};

var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.node,
  activate: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  getActivate: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var ActivationLatch = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ActivationLatch, _React$Component);

  function ActivationLatch(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ActivationLatch);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      activate: props.activate
    };
    return _this;
  }

  ActivationLatch.prototype.componentWillMount = function componentWillMount() {
    var getActivate = this.props.getActivate;

    getActivate();
  };

  ActivationLatch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var activate = nextProps.activate;

    if (activate !== this.props.activate) {
      this.setState({ activate: activate });
    }
  };

  ActivationLatch.prototype.render = function render() {
    var activate = this.state.activate;

    if (activate.status !== 'success') {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_loracoms_PageLoading__["a" /* default */], null);
    }

    var protocol = window.location.protocol;
    var hostname = window.location.hostname;

    var status = activate.data.status;

    if (status !== 'activated') {
      window.location = protocol + "//" + hostname + ":8080";
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      this.props.children
    );
  };

  return ActivationLatch;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ActivationLatch.defaultProps = defaultProps;
ActivationLatch.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    activate: state.loracube.getActivate,
    hostname: ownProps.location.hostname,
    location: ownProps.location
  };
};

var mapDispatchToProps = {
  getActivate: __WEBPACK_IMPORTED_MODULE_5_loraactions_loracube__["a" /* default */].getActivate
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(ActivationLatch));

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEqual__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNil__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_HideIf__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracfg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__LangSwitcher__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__UserDropdown__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss__ = __webpack_require__(2165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_logo_inverse_svg__ = __webpack_require__(2768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_logo_inverse_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__images_logo_inverse_svg__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

















var kHideMenuPaths = ['/login', '/register', '/lostpassword', '/password_reset', '/register_success'];

var propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.func.isRequired,
  menus: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.array.isRequired,
  pathname: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.string.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.any.isRequired,
  basic: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.object.isRequired,
  authed: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.bool.isRequired
};

var ConsoleNavbar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ConsoleNavbar, _React$Component);

  ConsoleNavbar.shouldHideMenus = function shouldHideMenus(pathname) {
    var pn = "/" + pathname.split('/')[1];
    return kHideMenuPaths.includes(pn);
  };

  function ConsoleNavbar(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ConsoleNavbar);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      menus: props.menus,
      activeMenu: _this.activeMenu(),
      expanded: false,
      basic: props.basic,
      transparent: false,
      pathname: props.pathname
    };
    _this.handleGotoHome = _this.handleGotoHome.bind(_this);
    return _this;
  }

  ConsoleNavbar.prototype.componentWillMount = function componentWillMount() {
    this.setState({
      activeMenu: this.activeMenu(),
      transparent: this.transparent()
    });
  };

  ConsoleNavbar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var menus = nextProps.menus,
        pathname = nextProps.pathname,
        basic = nextProps.basic,
        authed = nextProps.authed;

    if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default()(menus, this.props.menus)) {
      this.setState({ menus: menus });
    }
    if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default()(pathname, this.props.pathname)) {
      this.setState({ pathname: pathname });
    }
    if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default()(basic, this.props.basic)) {
      this.setState({ basic: basic });
    }
    if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default()(authed, this.props.authed)) {
      this.setState({ authed: authed });
    }

    this.setState({
      activeMenu: this.activeMenu(nextProps),
      transparent: this.transparent(nextProps)
    });
  };

  ConsoleNavbar.prototype.activeMenu = function activeMenu(props) {
    var _ref = props || this.props,
        pathname = _ref.pathname,
        menus = _ref.menus;

    pathname = "/" + pathname.split('/')[1];
    menus = _.filter(menus, function (m) {
      return !m.static;
    });
    var idx = _.findIndex(menus, { link: pathname });
    return idx;
  };

  ConsoleNavbar.prototype.transparent = function transparent(props) {
    var _ref2 = props || this.props,
        pathname = _ref2.pathname;

    return ConsoleNavbar.shouldHideMenus(pathname);
  };

  ConsoleNavbar.prototype.handleGotoHome = function handleGotoHome() {
    var locale = this.props.intl.locale;

    window.location = "/?locale=" + locale;
  };

  ConsoleNavbar.prototype.renderSignup = function renderSignup() {
    var _this2 = this;

    return [__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["NavItem"],
      {
        key: 1,
        onSelect: function onSelect() {
          _this2.props.push('/login');
          _this2.setState({ expanded: false });
        }
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], { id: "common.login" }),
      ' ',
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("i", { className: "fa fa-fw fa-sign-in", "aria-hidden": "true" })
    ), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_12_loracoms_HideIf__["a" /* default */],
      { "if": "profile:cube", key: 2 },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["NavItem"],
        {
          onSelect: function onSelect() {
            _this2.props.push('/register');
            _this2.setState({ expanded: false });
          }
        },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], { id: "common.register" }),
        ' ',
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("i", { className: "fa fa-fw fa-user-plus", "aria-hidden": "true" })
      )
    )];
  };

  ConsoleNavbar.prototype.renderRightMenu = function renderRightMenu() {
    var _this3 = this;

    var basic = this.state.basic;
    var pathname = this.state.pathname;


    var showUser = true;
    if (__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(basic.data) || pathname === '/login' || pathname === '/register' || pathname === '/lostpassword') {
      showUser = false;
    }

    if (showUser) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__UserDropdown__["a" /* default */], { onSelect: function onSelect() {
          return _this3.setState({ expanded: false });
        } });
    }
    return this.renderSignup();
  };

  ConsoleNavbar.prototype.render = function render() {
    var _this4 = this;

    var _state = this.state,
        menus = _state.menus,
        pathname = _state.pathname,
        transparent = _state.transparent;

    var navItems = menus.map(function (m, idx) {
      var onSelAction = void 0;
      if (m.static) {
        onSelAction = function onSelAction() {
          return window.open(m.link);
        };
      } else {
        onSelAction = function onSelAction() {
          return _this4.props.push(m.link);
        };
      }
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["NavItem"],
        {
          key: idx,
          eventKey: idx,
          onSelect: function onSelect(ek) {
            if (m.static) {
              _this4.setState({
                expanded: false
              });
            } else {
              _this4.setState({
                activeMenu: ek,
                expanded: false
              });
            }
            onSelAction();
          }
        },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "span",
          { styleName: "menu-item " + (m.beta ? 'beta' : '') },
          m.name
        )
      );
    });

    var hideMenus = ConsoleNavbar.shouldHideMenus(pathname);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      "div",
      { styleName: "navbar-wrapper " + (transparent ? 'navbar-transparent' : '') },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Navbar"],
        {
          bsStyle: "aisz-transparent",
          expanded: this.state.expanded,
          onToggle: function onToggle() {
            return _this4.setState({
              expanded: !_this4.state.expanded
            });
          },
          fixedTop: true
        },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Navbar"].Header,
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Navbar"].Brand,
            null,
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "div",
              { styleName: "navbar-logo" },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_router__["f" /* Link */],
                { onClick: this.handleGotoHome },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("img", { alt: "", src: __WEBPACK_IMPORTED_MODULE_17__images_logo_inverse_svg___default.a, className: "img-responsive" })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "div",
              { styleName: "navbar-brand-text" },
              "loraFlow"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Navbar"].Toggle, null)
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Navbar"].Collapse,
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12_loracoms_HideIf__["a" /* default */],
            { "if": hideMenus },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Nav"],
              { activeKey: this.state.activeMenu },
              navItems
            )
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12_loracoms_HideIf__["a" /* default */],
            { "if": __WEBPACK_IMPORTED_MODULE_13_loracfg__["a" /* default */].profile === 'cube' || !_.isNil(__WEBPACK_IMPORTED_MODULE_13_loracfg__["a" /* default */].language) },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Nav"],
              { pullRight: true },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__LangSwitcher__["a" /* default */], null)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Nav"],
            { pullRight: true },
            this.renderRightMenu()
          )
        )
      )
    );
  };

  return ConsoleNavbar;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ConsoleNavbar.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    authed: state.auth.authed,
    basic: state.account.basic
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    push: function push() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_9_react_router_redux__["push"].apply(undefined, arguments));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_3_react_css_modules___default()(ConsoleNavbar, __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a, { allowMultiple: true }))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl_redux__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_intl_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_cn_svg__ = __webpack_require__(2769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_cn_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_cn_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_gb_svg__ = __webpack_require__(2770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_gb_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_gb_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_main_scss__ = __webpack_require__(2166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_main_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);














var propTypes = {
  locale: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  updateIntl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired
};

var LangSwitcher = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(LangSwitcher, _React$Component);

  LangSwitcher.getFlagIcon = function getFlagIcon(languageId) {
    switch (languageId) {
      case 'zh':
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_11__images_cn_svg___default.a, alt: "" }),
          ' 简体中文'
        );
      case 'en':
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_12__images_gb_svg___default.a, alt: "" }),
          ' English'
        );
      default:
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_11__images_cn_svg___default.a, alt: "" }),
          ' 简体中文'
        );
    }
  };

  function LangSwitcher(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LangSwitcher);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      language: props.locale || 'zh'
    };
    _this.handleChangeLanguage = _this.handleChangeLanguage.bind(_this);
    return _this;
  }

  LangSwitcher.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var locale = nextProps.locale;

    if (locale !== this.props.locale) {
      this.setState({ language: locale });
    }
  };

  LangSwitcher.prototype.handleChangeLanguage = function handleChangeLanguage(languageId) {
    this.setState({
      language: languageId
    });
    this.props.updateIntl({
      locale: languageId,
      messages: __WEBPACK_IMPORTED_MODULE_10__i18n__["a" /* default */][languageId]
    });
    localStorage.setItem('language', languageId);
    $('html, body').css({
      overflow: 'auto',
      height: 'auto'
    });
  };

  LangSwitcher.prototype.render = function render() {
    var _this2 = this;

    var language = this.state.language;

    var title = LangSwitcher.getFlagIcon(language);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["NavDropdown"],
      {
        id: "lang-switcher",
        noCaret: true,
        pullRight: true,
        title: title,
        key: 1
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["MenuItem"],
        { eventKey: "1", onClick: function onClick() {
            return _this2.handleChangeLanguage('zh');
          } },
        LangSwitcher.getFlagIcon('zh')
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["MenuItem"],
        { eventKey: "2", onClick: function onClick() {
            return _this2.handleChangeLanguage('en');
          } },
        LangSwitcher.getFlagIcon('en')
      )
    );
  };

  return LangSwitcher;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

LangSwitcher.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    locale: state.intl.locale
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push,
  updateIntl: __WEBPACK_IMPORTED_MODULE_8_react_intl_redux__["updateIntl"]
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(LangSwitcher, __WEBPACK_IMPORTED_MODULE_13__styles_main_scss___default.a)));

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isEqual__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_HideIf__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loraactions_auth__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_trial_user_svg__ = __webpack_require__(2776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_trial_user_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_trial_user_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_trial_user_expired_svg__ = __webpack_require__(2775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_trial_user_expired_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_trial_user_expired_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_svcpkg_user_svg__ = __webpack_require__(2774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_svcpkg_user_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_svcpkg_user_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_svcpkg_user_expired_svg__ = __webpack_require__(2773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_svcpkg_user_expired_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__images_svcpkg_user_expired_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_comm_user_svg__ = __webpack_require__(2772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_comm_user_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__images_comm_user_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_comm_user_expired_svg__ = __webpack_require__(2771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_comm_user_expired_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__images_comm_user_expired_svg__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  push: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  logout: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  basic: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  plan: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};

var UserDropdown = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(UserDropdown, _React$Component);

  function UserDropdown(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, UserDropdown);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      basic: props.basic,
      plan: props.plan
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'common');
    _this.handleLogout = _this.handleLogout.bind(_this);
    _this.handleGotoAccountCenter = _this.handleGotoAccountCenter.bind(_this);
    _this.handleGotoBillingPlans = _this.handleGotoBillingPlans.bind(_this);
    return _this;
  }

  UserDropdown.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var basic = nextProps.basic,
        plan = nextProps.plan;

    if (!__WEBPACK_IMPORTED_MODULE_9_lodash_isEqual___default()(basic, this.props.basic)) {
      this.setState({ basic: basic });
    }
    if (!__WEBPACK_IMPORTED_MODULE_9_lodash_isEqual___default()(plan, this.props.plan)) {
      this.setState({ plan: plan });
    }
  };

  UserDropdown.prototype.handleGotoAccountCenter = function handleGotoAccountCenter() {
    this.props.push('/accountcenter');
    this.props.onSelect();
  };

  UserDropdown.prototype.handleGotoBillingPlans = function handleGotoBillingPlans() {
    this.props.push('/billing');
    this.props.onSelect();
  };

  UserDropdown.prototype.handleLogout = function handleLogout() {
    sessionStorage.removeItem('roadtest');
    this.props.logout();
    this.props.onSelect();
  };

  UserDropdown.prototype.renderUserIcon = function renderUserIcon() {
    var planData = this.state.plan.data;

    switch (planData.tier) {
      case 1:
        return planData.expired ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_14__images_trial_user_expired_svg___default.a, alt: "" }) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_13__images_trial_user_svg___default.a, alt: "" });
      case 2:
        return planData.expired ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_16__images_svcpkg_user_expired_svg___default.a, alt: "" }) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_15__images_svcpkg_user_svg___default.a, alt: "" });
      case 3:
        return planData.expired ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_18__images_comm_user_expired_svg___default.a, alt: "" }) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_17__images_comm_user_svg___default.a, alt: "" });
      default:
        return planData.expired ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_14__images_trial_user_expired_svg___default.a, alt: "" }) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_13__images_trial_user_svg___default.a, alt: "" });
    }
  };

  UserDropdown.prototype.render = function render() {
    var _state = this.state,
        planData = _state.plan.data,
        basicData = _state.basic.data;


    if (!planData || !basicData) {
      return null;
    }

    var title = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "span",
      null,
      this.renderUserIcon(),
      ' ',
      basicData.name
    );
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["NavDropdown"],
      {
        id: "nav-dropdown",
        pullRight: true,
        eventKey: 6,
        title: title
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["MenuItem"],
        { eventKey: "6.1", onClick: this.handleGotoAccountCenter },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-user" }),
        this.intlMsg.msg('accountmanage')
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_loracoms_HideIf__["a" /* default */],
        { "if": "profile:cube" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["MenuItem"],
          { eventKey: "6.2", onClick: this.handleGotoBillingPlans },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-usd" }),
          this.intlMsg.msg('accountupgrade')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["MenuItem"], { divider: true }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["MenuItem"],
        { eventKey: "6.3", onClick: this.handleLogout },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-log-out" }),
        this.intlMsg.msg('exit')
      )
    );
  };

  return UserDropdown;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

UserDropdown.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    basic: state.account.basic,
    plan: state.billing.plan
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    logout: function logout() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_11_loraactions_auth__["a" /* default */].revoke());
    },
    push: function push() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__["push"].apply(undefined, arguments));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(UserDropdown)));

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl_redux__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_intl_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_fastclick__ = __webpack_require__(2326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorai18n__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracfg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__coms_ConsoleNavbar__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_main_scss__ = __webpack_require__(2167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_main_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);
















var defaultProps = {
  locale: localStorage.getItem('language') || 'zh'
};

var propTypes = {
  updateIntl: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  pathname: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,
  push: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  locale: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node.isRequired
};

var App = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(App, _React$Component);

  function App(props, context) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, App);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.state = {
      menus: _this.menus(),
      pathname: props.pathname
    };
    return _this;
  }

  App.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        locale = _props.locale,
        pathname = _props.pathname,
        intl = _props.intl;

    var lc = intl.locale || locale || 'zh';
    this.props.updateIntl({
      locale: lc,
      messages: __WEBPACK_IMPORTED_MODULE_11_lorai18n__["a" /* default */][lc]
    });
    try {
      localStorage.setItem('language', lc);
    } catch (e) {
      // do nothing
    }
    this.props.push(pathname, {});
  };

  App.prototype.componentDidMount = function componentDidMount() {
    __WEBPACK_IMPORTED_MODULE_9_fastclick___default.a.attach(document.body);
  };

  App.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.pathname !== this.props.pathname) {
      this.setState({
        pathname: nextProps.pathname
      });
    }
  };

  App.prototype.menus = function menus() {
    var locale = this.props.intl.locale;
    var menus = [{
      link: '/overview',
      name: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], { id: "lora.nav.overview" })
    }, {
      link: '/gateway',
      name: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], { id: "lora.nav.gateway" })
    }, {
      link: '/application',
      name: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], { id: "lora.nav.application" })
    }, {
      link: '/network',
      name: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], { id: "lora.nav.network" })
    }, {
      link: "/static/docs/" + locale + "/index.html",
      static: true,
      name: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], { id: "lora.nav.documentation" })
    }];

    if (__WEBPACK_IMPORTED_MODULE_12_loracfg__["a" /* default */].profile === 'cube') {
      menus = _.filter(menus, function (m) {
        return m.link !== '/billing';
      });
    }
    return menus;
  };

  App.prototype.render = function render() {
    var _state = this.state,
        pathname = _state.pathname,
        menus = _state.menus;


    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { styleName: "app" },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__coms_ConsoleNavbar__["a" /* default */], {
        menus: menus,
        pathname: pathname
      }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { styleName: "app-body", style: { minHeight: window.innerHeight } },
        this.props.children
      )
    );
  };

  return App;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

App.propTypes = propTypes;
App.defaultProps = defaultProps;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    pathname: ownProps.location.pathname,
    locale: ownProps.location.query.locale
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateIntl: __WEBPACK_IMPORTED_MODULE_8_react_intl_redux__["updateIntl"],
    push: function push() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__["push"].apply(undefined, arguments));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_13_react_css_modules___default()(App, __WEBPACK_IMPORTED_MODULE_15__styles_main_scss___default.a))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_scss__ = __webpack_require__(2168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  show: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool.isRequired,
  onOOQ: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  onAdded: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var AddAppModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(AddAppModal, _React$Component);

  function AddAppModal(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AddAppModal);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      show: props.show,
      errors: __WEBPACK_IMPORTED_MODULE_10_lorautils_errors_ErrorSet__["a" /* default */].createEmpty().add('FE_EMPTY', 'name').add('FE_EMPTY', 'appeui')
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'application.addapp');
    _this.handleChangeName = _this.handleChangeName.bind(_this);
    _this.handleChangeAppEUI = _this.handleChangeAppEUI.bind(_this);
    _this.handleRandomAppEUI = _this.handleRandomAppEUI.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleHide = _this.handleHide.bind(_this);
    return _this;
  }

  AddAppModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var show = nextProps.show;

    if (show !== this.props.show) {
      this.setState({ show: show });
    }
  };

  AddAppModal.prototype.componentDidUpdate = function componentDidUpdate() {
    var appeuiCurPos = this.state.appeuiCurPos;

    if (appeuiCurPos) {
      this.appeuiRef.setSelectionRange(appeuiCurPos, appeuiCurPos);
    }
  };

  AddAppModal.prototype.reset = function reset() {
    this.setState({
      status: '',
      name: '',
      appeui: '',
      appeuiCurPos: null,
      submitted: false,
      errors: __WEBPACK_IMPORTED_MODULE_10_lorautils_errors_ErrorSet__["a" /* default */].createEmpty().add('FE_EMPTY', 'name').add('FE_EMPTY', 'appeui')
    });
  };

  AddAppModal.prototype.handleChangeName = function handleChangeName(e) {
    var name = e.target.value;
    this.setState({ name: name });

    var errors = this.state.errors;


    if (name === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'name') });
    } else {
      this.setState({ errors: errors.remove('name') });
    }
  };

  AddAppModal.prototype.handleChangeAppEUI = function handleChangeAppEUI(e) {
    var _state = this.state,
        appeui = _state.appeui,
        appeuiCurPos = _state.appeuiCurPos;

    appeui = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lorautils_IdUtils__["i" /* formatAppEUIInput */])(e.target.value, appeui);
    appeuiCurPos = e.target.selectionEnd;
    if (e.target.value.length === appeuiCurPos) {
      appeuiCurPos = appeui.length;
    }
    this.setState({ appeui: appeui, appeuiCurPos: appeuiCurPos });

    var errors = this.state.errors;

    if (appeui === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'appeui') });
    } else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lorautils_IdUtils__["j" /* isValidAppEUI */])(appeui)) {
      this.setState({ errors: errors.add('FE_INVALID', 'appeui') });
    } else {
      this.setState({ errors: errors.remove('appeui') });
    }
  };

  AddAppModal.prototype.handleRandomAppEUI = function handleRandomAppEUI() {
    var appeui = _.map(_.range(18), function () {
      return _.sample('ABCDEF0123456789');
    }).join('');
    this.setState({
      appeui: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lorautils_IdUtils__["d" /* normalizeAppEUI */])(appeui),
      errors: this.state.errors.remove('appeui')
    });
  };

  AddAppModal.prototype.handleHide = function handleHide() {
    var onHide = this.props.onHide;

    this.reset();
    onHide();
  };

  AddAppModal.prototype.handleSubmit = function handleSubmit(e) {
    var _this2 = this;

    e.preventDefault();

    this.setState({ submitted: true });

    var _props = this.props,
        onOOQ = _props.onOOQ,
        onAdded = _props.onAdded;
    var _state2 = this.state,
        name = _state2.name,
        appeui = _state2.appeui,
        errors = _state2.errors;

    errors = errors.remove('submit');
    if (!errors.isEmpty()) {
      return;
    }

    name = name.trim();
    appeui = appeui.replace(/[:-]/g, '');

    this.setState({ status: 'pending' });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lorautils_api__["a" /* callAPI */])({
      endpoint: '/lora/applications',
      body: {
        name: name,
        appeui: appeui
      },
      method: 'POST'
    }).then(function () {
      _this2.setState({
        status: 'success'
      });
      _.delay(function () {
        _this2.reset();
        onAdded();
      }, 500);
    }).catch(function (error) {
      _this2.setState({ status: 'failure' });
      if (error.code === 'QUOTA') {
        onOOQ();
      } else {
        _this2.setState({
          errors: errors.add(error.code, 'submit'),
          status: 'failure'
        });
        _.delay(function () {
          _this2.setState({
            status: '',
            errors: _this2.state.errors.remove('submit')
          });
        }, 1500);
      }
    });
  };

  AddAppModal.prototype.render = function render() {
    var _this3 = this;

    var _state3 = this.state,
        _state3$show = _state3.show,
        show = _state3$show === undefined ? false : _state3$show,
        _state3$name = _state3.name,
        name = _state3$name === undefined ? '' : _state3$name,
        _state3$appeui = _state3.appeui,
        appeui = _state3$appeui === undefined ? '' : _state3$appeui,
        _state3$status = _state3.status,
        status = _state3$status === undefined ? '' : _state3$status,
        errors = _state3.errors,
        _state3$submitted = _state3.submitted,
        submitted = _state3$submitted === undefined ? false : _state3$submitted;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-light",
        backdrop: "static",
        show: show,
        onHide: this.handleHide
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        this.intlMsg.msg('header')
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Form"],
          { horizontal: true, onSubmit: this.handleSubmit },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["FormGroup"],
            { validationState: submitted && errors.has('name') ? 'error' : undefined },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                this.intlMsg.msg('appname.label')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["FormControl"], {
                bsClass: "aisz-form-control-f",
                placeholder: this.intlMsg.msg('appname.placeholder'),
                value: name,
                onChange: this.handleChangeName
              }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_loracoms_ControlTips__["a" /* default */], {
                message: this.intlMsg.errorMsg(errors.get('name')),
                show: submitted && errors.has('name'),
                azStyle: "danger"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["FormGroup"],
            { validationState: submitted && errors.has('appeui') ? 'error' : undefined },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                this.intlMsg.msg('appeui.label')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["FormControl"], {
                bsClass: "aisz-form-control-f",
                placeholder: "01-23-45-67-89-AB-CD-EF",
                value: appeui,
                onChange: this.handleChangeAppEUI,
                onBlur: function onBlur() {
                  _this3.setState({ appeuiCurPos: null });
                },
                inputRef: function inputRef(ref) {
                  _this3.appeuiRef = ref;
                }
              }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_loracoms_ControlTips__["a" /* default */], {
                message: this.intlMsg.errorMsg(errors.get('appeui')),
                show: submitted && errors.has('appeui'),
                azStyle: "danger"
              }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.random },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
                  {
                    bsStyle: "aisz-link",
                    onClick: this.handleRandomAppEUI
                  },
                  this.intlMsg.msg('random')
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
              { mdOffset: 3, md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.submit },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_RichButton__["a" /* default */], {
                  status: status,
                  states: [{
                    status: 'default',
                    label: this.intlMsg.msg('submit'),
                    style: 'primary',
                    type: 'submit'
                  }, {
                    status: 'pending',
                    label: this.intlMsg.msg('submit.pending'),
                    style: 'primary'
                  }, {
                    status: 'success',
                    label: this.intlMsg.msg('submit.success'),
                    style: 'success'
                  }, {
                    status: 'failure',
                    label: this.intlMsg.msg('submit.failure'),
                    style: 'danger'
                  }]
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
              { mdOffset: 3, md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_FormBlock__["a" /* default */], {
                message: this.intlMsg.errorMsg(errors.get('submit')),
                show: errors.has('submit'),
                azStyle: "danger"
              })
            )
          )
        )
      )
    );
  };

  return AddAppModal;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

AddAppModal.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(AddAppModal));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_HideIf__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);










var defaultProps = {
  show: false
};

var propTypes = {
  plan: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  show: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool
};

var AppOOQModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(AppOOQModal, _React$Component);

  function AppOOQModal(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AppOOQModal);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      plan: props.plan,
      show: props.show
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'application');
    return _this;
  }

  AppOOQModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var plan = nextProps.plan,
        show = nextProps.show;

    if (plan !== this.props.plan) {
      this.setState({ plan: plan });
    }
    if (show !== this.props.show) {
      this.setState({ show: show });
    }
  };

  AppOOQModal.prototype.render = function render() {
    var _props = this.props,
        pushState = _props.pushState,
        onHide = _props.onHide;
    var _state = this.state,
        plan = _state.plan,
        show = _state.show;

    var tier = 3;

    if (plan.status === 'success') {
      tier = plan.data.tier;
    }

    var body = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_loracoms_HideIf__["a" /* default */],
        { "if": "profile:cube" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_loracoms_ShowIf__["a" /* default */],
            { "if": tier < 3 },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "p",
                null,
                this.intlMsg.msg('addapp.error.outofquota.undercomm')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
                {
                  bsStyle: "aisz-primary",
                  onClick: function onClick() {
                    return pushState('/billing/plans');
                  }
                },
                this.intlMsg.msg('addapp.upgrade.btn'),
                ' ',
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-arrow-circle-o-right" })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_loracoms_ShowIf__["a" /* default */],
            { "if": tier === 3 },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "p",
                null,
                this.intlMsg.msg('addapp.error.outofquota.comm')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "a",
                { href: "mailto:support@aisenz.com" },
                "support@aisenz.com"
              )
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_loracoms_ShowIf__["a" /* default */],
        { "if": "profile:cube" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "p",
            null,
            this.intlMsg.msg('addapp.error.outofquota.cube')
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "a",
            { href: "mailto:support@aisenz.com" },
            "support@aisenz.com"
          )
        )
      )
    );

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-warning",
        show: show,
        onHide: onHide
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle" }),
          ' ',
          this.intlMsg.msg('addapp.error.modalheader')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "text-center" },
          body
        )
      )
    );
  };

  return AppOOQModal;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

AppOOQModal.defaultProps = defaultProps;
AppOOQModal.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    plan: state.billing.plan
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(AppOOQModal)));

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_immutable__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_Copy__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_InlineSelect__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_loraapi_lora_application__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lorautils_checkers_numbers__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lorautils_DateTimeUtils__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__styles_scss__ = __webpack_require__(2169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

























var kEncodingOpts = [{
  label: 'HEX',
  value: 'hex'
}, {
  label: 'TEXT',
  value: 'text'
}];

var defaultProps = {
  data: [],
  wsFeedback: null,
  wsSocket: null
};

var propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.array,
  intl: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  wsStatus: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired,
  wsType: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired,
  wsSocket: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object,
  url: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  wsFeedback: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.any,
  resetFeedback: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired
};

var DetailView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DetailView, _React$Component);

  function DetailView(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DetailView);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_19_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'appdebug.detailview');
    _this.state = {
      tokens: [],
      dataList: props.data || [],
      wsStatus: props.wsStatus,
      wsSocket: props.wsSocket,
      wsType: props.wsType,
      wsFeedback: props.wsFeedback,
      url: props.url,
      errors: __WEBPACK_IMPORTED_MODULE_18_lorautils_errors_ErrorSet__["a" /* default */].createEmpty().add('FE_EMPTY', 'deveui').add('FE_EMPTY', 'fport').add('FE_EMPTY', 'data'),
      touched: new __WEBPACK_IMPORTED_MODULE_10_immutable__["Set"](),
      encoding: 'hex'
    };
    return _this;
  }

  DetailView.prototype.componentDidMount = function componentDidMount() {
    this.getApiInfo();
  };

  DetailView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var data = nextProps.data,
        wsStatus = nextProps.wsStatus,
        wsSocket = nextProps.wsSocket,
        wsType = nextProps.wsType,
        url = nextProps.url,
        wsFeedback = nextProps.wsFeedback;

    if (data !== this.props.data) {
      this.setState({ dataList: data });
    }
    if (wsStatus !== this.props.wsStatus) {
      this.setState({ wsStatus: wsStatus });
    }
    if (wsSocket !== this.props.wsSocket) {
      this.setState({ wsSocket: wsSocket });
    }
    if (wsType !== this.props.wsType) {
      this.setState({ wsType: wsType });
    }
    if (url !== this.props.url) {
      this.setState({ url: url });
    }
    if (wsFeedback !== this.props.wsFeedback) {
      this.setState({ wsFeedback: wsFeedback });
    }
  };

  DetailView.prototype.getApiInfo = function getApiInfo() {
    var _this2 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_loraapi_lora_application__["a" /* getAppTokenList */])(this.props.appId).then(function (res) {
      var tokens = res.body.list.map(function (t) {
        var tk = t;
        tk.note = JSON.parse(t.aux || '{}').note;
        return tk;
      });
      _this2.setState({ tokens: tokens });
    });
  };

  DetailView.prototype.getFeedbackError = function getFeedbackError() {
    var wsFeedback = this.state.wsFeedback;

    if (_.isNil(wsFeedback)) {
      return null;
    }
    return wsFeedback.error;
  };

  DetailView.prototype.hasFeedbackError = function hasFeedbackError() {
    var wsFeedback = this.state.wsFeedback;

    if (_.isNil(wsFeedback)) {
      return false;
    }
    return _.has(wsFeedback, 'error') && wsFeedback.error !== '';
  };

  DetailView.prototype.isFeedbackSuccess = function isFeedbackSuccess() {
    var wsFeedback = this.state.wsFeedback;

    if (_.isNil(wsFeedback)) {
      return false;
    }
    return !_.has(wsFeedback, 'error');
  };

  DetailView.prototype.handleSendData = function handleSendData() {
    var _this3 = this;

    var _state = this.state,
        wsSocket = _state.wsSocket,
        wsType = _state.wsType,
        url = _state.url,
        _state$deveui = _state.deveui,
        deveui = _state$deveui === undefined ? '' : _state$deveui,
        _state$fport = _state.fport,
        fport = _state$fport === undefined ? '' : _state$fport,
        _state$data = _state.data,
        data = _state$data === undefined ? '' : _state$data,
        _state$encoding = _state.encoding,
        encoding = _state$encoding === undefined ? 'text' : _state$encoding,
        touched = _state.touched;
    var errors = this.state.errors;


    this.props.resetFeedback();

    this.setState({
      touched: touched.add('deveui').add('fport').add('data')
    });

    errors = errors.remove('submit');
    this.setState({ errors: errors });

    if (!errors.isEmpty()) {
      return;
    }

    var sendData = {
      deveui: deveui.replace(/[-:]/g, ''),
      fport: parseInt(fport, 10),
      data: data,
      encoding: encoding
    };

    if (wsType === 'ws') {
      if (wsSocket) {
        wsSocket.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sendData) + "\n");
      }
    } else {
      this.setState({ sendStatus: 'loading' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_lorautils_api__["a" /* callAPI */])({
        endpoint: url,
        body: sendData,
        method: 'POST'
      }).then(function () {
        _this3.setState({ sendStatus: 'success' });
      }).catch(function (error) {
        _this3.setState({
          errors: errors.add(error.code, 'submit')
        });
      });
    }
  };

  DetailView.prototype.handleChange = function handleChange(v, id) {
    var _setState;

    this.setState((_setState = {}, _setState[id] = v, _setState));

    var errors = this.state.errors;

    if (id === 'deveui') {
      if (v === '') {
        this.setState({ errors: errors.add('FE_EMPTY', 'deveui') });
      } else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_lorautils_IdUtils__["c" /* isValidDevEUI */])(v)) {
        this.setState({ errors: errors.add('FE_INVALIDFMT', 'deveui') });
      } else {
        this.setState({ errors: errors.remove('deveui') });
      }
    } else if (id === 'fport') {
      if (v === '') {
        this.setState({ errors: errors.add('FE_EMPTY', 'fport') });
      } else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_lorautils_checkers_numbers__["b" /* isInteger */])(v, { min: 1, max: 255 })) {
        this.setState({ errors: errors.add('FE_INVALIDPORT', 'fport') });
      } else {
        this.setState({ errors: errors.remove('fport') });
      }
    } else if (id === 'data') {
      var _state$encoding2 = this.state.encoding,
          encoding = _state$encoding2 === undefined ? 'hex' : _state$encoding2;

      if (v === '') {
        this.setState({ errors: errors.add('FE_EMPTY', 'data') });
      } else if (encoding === 'hex' && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_lorautils_checkers_numbers__["c" /* isHexString */])(v, { pair: true })) {
        this.setState({ errors: errors.add('FE_INVALIDHEX', 'data') });
      } else {
        this.setState({ errors: errors.remove('data') });
      }
    }
  };

  DetailView.prototype.renderSendData = function renderSendData() {
    var _this4 = this;

    var _state2 = this.state,
        errors = _state2.errors,
        touched = _state2.touched,
        sendStatus = _state2.sendStatus,
        _state2$deveui = _state2.deveui,
        deveui = _state2$deveui === undefined ? '' : _state2$deveui,
        _state2$fport = _state2.fport,
        fport = _state2$fport === undefined ? '' : _state2$fport,
        _state2$encoding = _state2.encoding,
        encoding = _state2$encoding === undefined ? 'hex' : _state2$encoding,
        _state2$data = _state2.data,
        data = _state2$data === undefined ? '' : _state2$data;


    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Form"],
      { horizontal: true },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            "DevEUI"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 8 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            placeholder: "01-23-45-67-89-AB-CD-EF",
            value: deveui,
            onChange: function onChange(e) {
              return _this4.handleChange(e.target.value, 'deveui');
            },
            onBlur: function onBlur() {
              _this4.setState({ touched: touched.add('deveui') });
            }
          }),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_ControlTips__["a" /* default */], {
            message: this.intlMsg.errorMsg(errors.get('deveui')),
            show: errors.has('deveui') && touched.has('deveui'),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            this.intlMsg.msg('label.fport')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 8 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            placeholder: this.intlMsg.msg('placeholder.fport'),
            value: fport,
            onChange: function onChange(e) {
              return _this4.handleChange(e.target.value, 'fport');
            },
            onBlur: function onBlur() {
              _this4.setState({ touched: touched.add('fport') });
            }
          }),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_ControlTips__["a" /* default */], {
            message: this.intlMsg.errorMsg(errors.get('fport')),
            show: errors.has('fport') && touched.has('fport'),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            this.intlMsg.msg('label.encoding')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 8 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_InlineSelect__["a" /* default */], {
            values: [encoding],
            options: kEncodingOpts,
            onChange: function onChange(dts) {
              return _this4.handleChange(dts[0], 'encoding');
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            this.intlMsg.msg('label.content')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 8 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            placeholder: this.intlMsg.msg("placeholder.data." + encoding),
            componentClass: "textarea",
            value: data,
            onChange: function onChange(e) {
              return _this4.handleChange(e.target.value, 'data');
            },
            onBlur: function onBlur() {
              _this4.setState({ touched: touched.add('data') });
            }
          }),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_ControlTips__["a" /* default */], {
            message: this.intlMsg.errorMsg(errors.get('data')),
            show: errors.has('data') && touched.has('data'),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { mdOffset: 2, md: 8 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_RichButton__["a" /* default */], {
            status: sendStatus,
            states: [{
              status: 'default',
              label: this.intlMsg.msg('button.send'),
              style: 'primary',
              onClick: function onClick() {
                return _this4.handleSendData();
              }
            }, {
              status: 'pending',
              label: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "span",
                null,
                this.intlMsg.msg('button.sending'),
                ' ',
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" })
              ),
              style: 'primary',
              onClick: function onClick() {}
            }, {
              status: 'success',
              label: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "span",
                null,
                this.intlMsg.msg('button.send.success'),
                ' ',
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-check-circle" })
              ),
              style: 'success',
              timer: function timer() {
                _this4.setState({ sendStatus: '' });
              }
            }, {
              status: 'failure',
              label: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "span",
                null,
                this.intlMsg.msg('button.send.failure'),
                ' ',
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-check-circle" })
              ),
              style: 'danger',
              timer: function timer() {
                _this4.setState({ sendStatus: '' });
              }
            }]
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { mdOffset: 2, md: 8 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_FormBlock__["a" /* default */], {
            show: errors.has('submit'),
            message: this.intlMsg.errorMsg(errors.get('submit')),
            azStyle: "danger",
            closeButton: true,
            onHide: function onHide() {
              _this4.setState({ errors: errors.remove('submit') });
            }
          }),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_FormBlock__["a" /* default */], {
            show: this.hasFeedbackError(),
            message: this.getFeedbackError(),
            azStyle: "danger",
            closeButton: true,
            onHide: function onHide() {
              _this4.props.resetFeedback();
            }
          }),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_FormBlock__["a" /* default */], {
            show: this.isFeedbackSuccess(),
            message: this.intlMsg.msg('feedback.success'),
            azStyle: "success",
            closeButton: true,
            onHide: function onHide() {
              _this4.props.resetFeedback();
            }
          })
        )
      )
    );
  };

  DetailView.prototype.renderDetail = function renderDetail() {
    var _props = this.props,
        url = _props.url,
        appId = _props.appId;
    var tokens = this.state.tokens;

    var debugType = '';
    var token = '';
    if (url !== '') {
      debugType = url.split(':')[0];
      token = url.split('&')[1].split('=')[1];
    }
    var apiInfo = {};
    tokens.forEach(function (item) {
      if (item.token === token) {
        apiInfo.name = item.name;
        apiInfo.note = item.note;
      }
    });
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_25__styles_scss___default.a.props },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_25__styles_scss___default.a.title },
        this.intlMsg.msg('props.title')
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "ul",
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_25__styles_scss___default.a.label },
            this.intlMsg.msg('props.name')
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_25__styles_scss___default.a.value },
            apiInfo.name
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_25__styles_scss___default.a.label },
            this.intlMsg.msg('props.apitype')
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_25__styles_scss___default.a.value },
            debugType
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_25__styles_scss___default.a.label },
            this.intlMsg.msg('props.remark')
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_25__styles_scss___default.a.value },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Nvl__["a" /* default */], { val: apiInfo.note })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_25__styles_scss___default.a.label },
            "APPEUI"
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_25__styles_scss___default.a.value },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_lorautils_IdUtils__["d" /* normalizeAppEUI */])(appId)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_25__styles_scss___default.a.label },
            "Token"
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_25__styles_scss___default.a.value },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Nvl__["a" /* default */], { val: token })
          )
        )
      )
    );
  };

  DetailView.prototype.renderToolbar = function renderToolbar() {
    var _props2 = this.props,
        appId = _props2.appId,
        pushState = _props2.pushState;

    var breadcrumb = [{
      content: this.intlMsg.msg('nav.api'),
      onClick: function onClick() {
        return pushState("/application/" + appId + "/api");
      }
    }, {
      content: this.intlMsg.msg('breadcrumb.detail'),
      active: true
    }];
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  DetailView.prototype.renderWsStatus = function renderWsStatus() {
    var wsStatus = this.state.wsStatus;

    if (wsStatus === 'connected') {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-refresh fa-spin text-success" });
    } else if (wsStatus === 'closed') {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "i",
        { className: "fa fa-exclamation-circle text-warning" },
        ' ',
        this.intlMsg.msg('wsstatus.closed')
      );
    } else if (wsStatus === 'reconnecting') {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "i",
        { className: "fa fa-exclamation-circle text-warning" },
        ' ',
        this.intlMsg.msg('wsstatus.reconnecting')
      );
    }
    return null;
  };

  DetailView.prototype.renderDataTable = function renderDataTable() {
    var wsType = this.props.wsType;
    var dataList = this.state.dataList;


    var header = void 0;
    if (wsType === 'ws') {
      header = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "span",
        null,
        this.intlMsg.msg('table.wstitle'),
        ' ',
        this.renderWsStatus()
      );
    } else {
      header = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "span",
        null,
        this.intlMsg.msg('table.httptitle'),
        ' ',
        this.renderWsStatus()
      );
    }

    var rows = dataList.map(function (item) {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "tr",
        { key: item.deveui + "-" + item.fcnt + "-" + item.gateway },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24_lorautils_DateTimeUtils__["a" /* compactFormat */])(item.$time)
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_lorautils_IdUtils__["a" /* normalizeDevEUI */])(item.deveui),
          ' ',
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_Copy__["a" /* default */], { id: "copy-" + item.deveui + "-" + item.fcnt + "-" + item.gateway, text: item.deveui })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          item.frequency
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          item.bandwidth
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          item.coderate
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          item.spreadfactor
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          item.lorasnr
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          item.fport
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          item.rssi
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          item.fcnt
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          item.data
        )
      );
    });

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: header },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Table"],
        { className: "aisz-table-light " + __WEBPACK_IMPORTED_MODULE_25__styles_scss___default.a.datatable, striped: true, hover: true, bordered: true, responsive: true },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('data.title')
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              "DevEUI"
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              " ",
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-wifi" }),
              ' ',
              " ",
              this.intlMsg.msg('data.frequency'),
              " "
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              " ",
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-wifi" }),
              ' ',
              " ",
              this.intlMsg.msg('data.bandwidth'),
              " "
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              " ",
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-wifi" }),
              ' ',
              " ",
              this.intlMsg.msg('data.coderate'),
              " "
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              " ",
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-wifi" }),
              ' ',
              "SF "
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              " ",
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-wifi" }),
              ' ',
              "SNR "
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              " ",
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-envelope" }),
              ' ',
              "FPort "
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              " ",
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-wifi" }),
              ' ',
              "RSSI "
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              " ",
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-wifi" }),
              ' ',
              " ",
              this.intlMsg.msg('data.fcnt'),
              " "
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              " ",
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-envelope" }),
              ' ',
              " ",
              this.intlMsg.msg('data.data'),
              " "
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "tbody",
          null,
          rows
        )
      )
    );
  };

  DetailView.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 12 },
          this.renderToolbar()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Panel"],
            { bsStyle: "aisz-white" },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
              null,
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
                { md: 5 },
                this.renderDetail()
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
                { md: 7 },
                this.renderSendData()
              )
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 12 },
          this.renderDataTable()
        )
      )
    );
  };

  return DetailView;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

DetailView.defaultProps = defaultProps;
DetailView.propTypes = propTypes;

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(DetailView)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_codemirror_mode_javascript_javascript__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_codemirror_mode_javascript_javascript___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_codemirror_mode_javascript_javascript__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_codemirror_theme_dracula_css__ = __webpack_require__(2324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_codemirror_theme_dracula_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_codemirror_theme_dracula_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_codemirror__ = __webpack_require__(2595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_codemirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_codemirror__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_CollapseToggle__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loracoms_LineChart__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loracoms_PanelToolbar__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_loracoms_Select__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lorautils_DateTimeUtils__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__func_parser__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__coms_Codemirror_codemirror_css__ = __webpack_require__(2325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__coms_Codemirror_codemirror_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__coms_Codemirror_codemirror_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__styles_scss__ = __webpack_require__(2170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

























var kHelp = '/*\n' + 'Define your custom javascript data decoder here.\n' + '  The following variables are available: \n' + '  data     : hex string of the data\n' + '  hex      : array of bytes represented as string of 2 hex digits\n' + '  bin      : array of bytes represented as integers\n' + '  appeui   : application EUI\n' + '  deveui   : device EUI\n' + '  fport    : message port field\n' + '  Last line of your script will be printed to the data payload column.\n\n' + 'For instance, RXHF RHF1S001 data can be parsed like:\n\n' + '  var temperature = Number((bin[2]*256+bin[1]) * 0.00268 - 46.85).toFixed(2);\n' + '  var humidity=Number(bin[3] * 0.49-6).toFixed(2);\n' + '  ["T="+temperature+"˚C", "H="+humidity+"%"].join("  ")\n' + '  var obj={\n' + '              "T(˚C)": temperature,\n' + '              "H(%)": humidity,\n' + '              "length": data.length\n' + '           };\n' + '  JSON.stringify(obj);*/\n' + 'data;';

var defaultProps = {};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.object.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.string.isRequired,
  wsStatus: __WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.string.isRequired,
  wsType: __WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.string.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.func.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.array.isRequired,
  onSaveParser: __WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.func.isRequired
};

var ParserView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ParserView, _React$Component);

  function ParserView(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ParserView);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    var deveui = void 0;
    var fport = void 0;
    if (props.data && props.data.length > 0) {
      deveui = props.data[0].deveui;
      fport = props.data[0].fport;
    }
    _this.state = {
      wsStatus: props.wsStatus,
      wsType: props.wsType,
      scripts: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__func_parser__["a" /* loadParserWithApp */])(props.appId) || kHelp,
      parserErr: '',
      dataList: props.data || [],
      showParser: true,
      showLineChartStatus: false,
      submitStatus: '',
      deveui: deveui,
      fport: fport
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_22_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'appdebug');
    _this.handleSaveScript = _this.handleSaveScript.bind(_this);
    return _this;
  }

  ParserView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var data = nextProps.data,
        wsStatus = nextProps.wsStatus,
        wsType = nextProps.wsType;

    if (data !== this.props.data) {
      this.setState({ dataList: data });
      var _state = this.state,
          _state$deveui = _state.deveui,
          deveui = _state$deveui === undefined ? '' : _state$deveui,
          _state$fport = _state.fport,
          fport = _state$fport === undefined ? '' : _state$fport;

      if (deveui === '' || fport === '') {
        if (data && data.length > 0) {
          deveui = data[0].deveui;
          fport = data[0].fport;
        }
        this.setState({ deveui: deveui, fport: fport });
      }
    }
    if (wsStatus !== this.props.wsStatus) {
      this.setState({ wsStatus: wsStatus });
    }
    if (wsType !== this.props.wsType) {
      this.setState({ wsType: wsType });
    }
  };

  ParserView.prototype.codeChange = function codeChange(code) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__func_parser__["c" /* syntaxCheck */])(code)) {
      this.setState({ scripts: code, parserErr: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__func_parser__["c" /* syntaxCheck */])(code) });
    } else {
      this.setState({ scripts: code, parserErr: '' });
    }
  };

  ParserView.prototype.handleSaveScript = function handleSaveScript() {
    var appId = this.props.appId;
    var scripts = this.state.scripts;

    this.setState({ submitStatus: 'loading' });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__func_parser__["d" /* saveParserWithApp */])(appId, scripts);
    this.props.onSaveParser(scripts);
    this.setState({ submitStatus: 'success' });
  };

  ParserView.prototype.deveuiOptions = function deveuiOptions() {
    var _state$dataList = this.state.dataList,
        dataList = _state$dataList === undefined ? [] : _state$dataList;

    return _.map(dataList, function (item) {
      return {
        label: item.deveui,
        value: item.deveui
      };
    });
  };

  ParserView.prototype.fPortOptions = function fPortOptions(deveui) {
    var _state$dataList2 = this.state.dataList,
        dataList = _state$dataList2 === undefined ? [] : _state$dataList2;

    return _.map(_.filter(dataList, function (item) {
      return item.deveui === deveui;
    }), function (item) {
      return {
        label: item.fport,
        value: item.fport
      };
    });
  };

  ParserView.prototype.renderParser = function renderParser() {
    var _this2 = this;

    var _state2 = this.state,
        scripts = _state2.scripts,
        parserErr = _state2.parserErr,
        _state2$parserExpande = _state2.parserExpanded,
        parserExpanded = _state2$parserExpande === undefined ? true : _state2$parserExpande,
        submitStatus = _state2.submitStatus;


    var header = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      "div",
      null,
      this.intlMsg.msg('detailview.parser'),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        "ul",
        { className: "icontools" },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_CollapseToggle__["a" /* default */], {
            expanded: parserExpanded,
            onChange: function onChange(v) {
              return _this2.setState({ parserExpanded: v });
            }
          })
        )
      )
    );

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
        {
          bsStyle: "aisz-white",
          header: header,
          collapsible: true,
          expanded: parserExpanded
        },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_codemirror___default.a, {
          value: scripts,
          onChange: function onChange(code) {
            return _this2.codeChange(code);
          },
          options: { lineNumbers: true, mode: 'javascript', theme: 'dracula' }
        }),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_25__styles_scss___default.a.submit },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_RichButton__["a" /* default */], {
            status: submitStatus,
            states: [{
              status: 'default',
              label: this.intlMsg.msg('parserview.savescript'),
              onClick: this.handleSaveScript
            }, {
              status: 'loading',
              label: __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                "span",
                null,
                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" }),
                ' ',
                this.intlMsg.msg('parserview.savescript.pending')
              ),
              onClick: function onClick() {}
            }, {
              status: 'success',
              label: __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                "span",
                null,
                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("i", { className: "fa fa-check-circle" }),
                ' ',
                this.intlMsg.msg('parserview.savescript.success')
              ),
              style: 'success',
              onClick: function onClick() {},
              timer: function timer() {
                _this2.setState({ submitStatus: '' });
              }
            }]
          })
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          "div",
          null,
          parserErr
        )
      )
    );
  };

  ParserView.prototype.renderWsStatus = function renderWsStatus() {
    var wsStatus = this.state.wsStatus;

    if (wsStatus === 'connected') {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("i", { className: "fa fa-refresh fa-spin text-success" });
    } else if (wsStatus === 'closed') {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        "i",
        { className: "fa fa-exclamation-circle text-warning" },
        ' ',
        this.intlMsg.msg('detailview.wsstatus.closed')
      );
    } else if (wsStatus === 'reconnecting') {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        "i",
        { className: "fa fa-exclamation-circle text-warning" },
        ' ',
        this.intlMsg.msg('detailview.wsstatus.reconnecting')
      );
    }
    return null;
  };

  ParserView.prototype.renderDataTable = function renderDataTable() {
    var _this3 = this;

    var wsType = this.props.wsType;
    var _state3 = this.state,
        dataList = _state3.dataList,
        _state3$dataExpanded = _state3.dataExpanded,
        dataExpanded = _state3$dataExpanded === undefined ? true : _state3$dataExpanded;

    var header = void 0;
    if (wsType === 'ws') {
      header = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        "div",
        null,
        this.intlMsg.msg('detailview.table.wstitle'),
        ' ',
        this.renderWsStatus(),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          "ul",
          { className: "icontools" },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            "li",
            null,
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_CollapseToggle__["a" /* default */], {
              expanded: dataExpanded,
              onChange: function onChange(v) {
                return _this3.setState({ dataExpanded: v });
              }
            })
          )
        )
      );
    } else {
      header = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        "div",
        null,
        this.intlMsg.msg('detailview.table.httptitle'),
        ' ',
        this.renderWsStatus(),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          "ul",
          { className: "icontools" },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            "li",
            null,
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_CollapseToggle__["a" /* default */], {
              expanded: dataExpanded,
              onChange: function onChange(v) {
                return _this3.setState({ dataExpanded: v });
              }
            })
          )
        )
      );
    }

    var rows = _.sortBy(dataList, function (d) {
      return -d.$time;
    }).map(function (item, index) {
      var parsed = {};
      try {
        parsed = JSON.parse(item.data || '{}');
      } catch (e) {
        parsed = {};
      }
      if (!_.isEmpty(parsed)) {
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          "tr",
          { key: index },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            "td",
            null,
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_lorautils_DateTimeUtils__["a" /* compactFormat */])(item.$time)
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            "td",
            null,
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_lorautils_IdUtils__["a" /* normalizeDevEUI */])(item.deveui)
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            "td",
            null,
            item.data
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            "td",
            null,
            item.fport
          )
        );
      }
      return null;
    });

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
      {
        bsStyle: "aisz-white",
        header: header,
        collapsible: true,
        expanded: dataExpanded
      },
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Table"],
        { className: "aisz-table-light", striped: true, hover: true, bordered: true, responsive: true },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('detailview.data.title')
            ),
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              "th",
              null,
              "DevEUI"
            ),
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              "th",
              null,
              __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("i", { className: "fa fa-envelope", "aria-hidden": "true" }),
              ' ',
              this.intlMsg.msg('detailview.data.data')
            ),
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              "th",
              null,
              "fPort"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          "tbody",
          null,
          rows
        )
      )
    );
  };

  ParserView.prototype.renderCharts = function renderCharts() {
    var _this4 = this;

    var _state4 = this.state,
        _state4$deveui = _state4.deveui,
        deveui = _state4$deveui === undefined ? '' : _state4$deveui,
        _state4$fport = _state4.fport,
        fport = _state4$fport === undefined ? '' : _state4$fport,
        _state4$chartsExpande = _state4.chartsExpanded,
        chartsExpanded = _state4$chartsExpande === undefined ? {} : _state4$chartsExpande,
        _state4$chartsResizes = _state4.chartsResizes,
        chartsResizes = _state4$chartsResizes === undefined ? {} : _state4$chartsResizes;
    var _state$dataList3 = this.state.dataList,
        dataList = _state$dataList3 === undefined ? [] : _state$dataList3;

    dataList = _.sortBy(dataList, '$time');
    dataList = _.filter(dataList, function (item) {
      return (deveui === '' || item.deveui === deveui) && (fport === '' || item.fport === fport);
    });
    dataList = _.filter(dataList, function (item) {
      var parsed = {};
      try {
        parsed = JSON.parse(item.data || '{}');
      } catch (e) {
        parsed = {};
      }
      return !_.isEmpty(parsed);
    });
    dataList = _.map(dataList, function (item) {
      var parsed = {};
      try {
        parsed = JSON.parse(item.data || '{}');
      } catch (e) {
        parsed = {};
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
        parsed: parsed
      });
    });

    var metrics = _.uniq(_.flatMap(dataList, function (item) {
      return _.keys(item.parsed);
    }));
    var categories = _.map(dataList, function (item) {
      return __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(item.$time, 'YYYY-MM-DD HH:mm:ss');
    });

    if (metrics.length === 0) {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
        { bsStyle: "aisz-white" },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_25__styles_scss___default.a.noMetrics },
          this.intlMsg.msg('parserview.nometrics'),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_25__styles_scss___default.a.guide },
            this.intlMsg.msg('parserview.nometrics.desc')
          )
        )
      );
    }

    return metrics.map(function (metric) {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
        {
          bsStyle: "aisz-white",
          header: __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            "div",
            null,
            metric,
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              "ul",
              { className: "icontools" },
              __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_CollapseToggle__["a" /* default */], {
                  expanded: _.has(chartsExpanded, metric) ? chartsExpanded[metric] : true,
                  onChange: function onChange(v) {
                    var _extends2;

                    return _this4.setState({
                      chartsExpanded: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, chartsExpanded, (_extends2 = {}, _extends2[metric] = v, _extends2))
                    });
                  }
                })
              )
            )
          ),
          key: metric,
          collapsible: true,
          expanded: _.has(chartsExpanded, metric) ? chartsExpanded[metric] : true,
          onEntered: function onEntered() {
            var _extends3;

            _this4.setState({
              chartsResizes: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, chartsResizes, (_extends3 = {}, _extends3[metric] = Math.random(), _extends3))
            });
          }
        },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_LineChart__["a" /* default */], {
          yAxis: [{
            name: metric,
            splitNumber: 5
          }],
          xAxis: {
            axisTick: {
              alignWithLabel: true
            },
            boundaryGap: true
          },
          series: [{
            data: dataList.map(function (item) {
              return item.parsed[metric];
            }),
            name: metric,
            yAxisIndex: 0
          }],
          categories: categories,
          dataZoom: [{
            type: 'slider',
            fillerColor: 'rgba(228, 241, 254, 0.4)',
            dataBackground: {
              lineStyle: {
                width: 0
              },
              areaStyle: {
                color: 'rgba(107, 185, 240, 0.8)'
              }
            }
          }],
          resize: chartsResizes[metric]
        })
      );
    });
  };

  ParserView.prototype.renderToolbar = function renderToolbar() {
    var _this5 = this;

    var breadcrumb = [{
      content: this.intlMsg.msg('detailview.nav.api'),
      onClick: function onClick() {
        return _this5.props.pushState("/application/" + _this5.props.appId + "/api");
      }
    }, {
      content: this.intlMsg.msg('parserview.breadcrumb.title'),
      active: true
    }];
    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  ParserView.prototype.render = function render() {
    var _this6 = this;

    var _state5 = this.state,
        _state5$deveui = _state5.deveui,
        deveui = _state5$deveui === undefined ? '' : _state5$deveui,
        _state5$fport = _state5.fport,
        fport = _state5$fport === undefined ? '' : _state5$fport;

    var devSelect = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_loracoms_Select__["a" /* default */], {
      value: deveui,
      options: this.deveuiOptions(),
      onChange: function onChange(v) {
        return _this6.setState({ deveui: v });
      }
    });
    var fportSelect = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_loracoms_Select__["a" /* default */], {
      value: fport,
      options: this.fPortOptions(deveui),
      onChange: function onChange(v) {
        return _this6.setState({ fport: v });
      }
    });

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 12 },
          this.renderToolbar()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 12 },
          this.renderParser()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 12 },
          this.renderDataTable()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_PanelToolbar__["a" /* default */], {
            tools: [__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"],
              { className: "aisz-control-label" },
              "DevEUI"
            ), devSelect, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"],
              { className: "aisz-control-label" },
              "fPort"
            ), fportSelect]
          }),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_25__styles_scss___default.a.charts },
            this.renderCharts()
          )
        )
      )
    );
  };

  return ParserView;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

ParserView.defaultProps = defaultProps;
ParserView.propTypes = propTypes;

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_12_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_intl__["injectIntl"])(ParserView)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_SideBar__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_SidebarContainer__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__coms_DetailView__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__coms_ParserView__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__func_parser__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__func_url__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_scss__ = __webpack_require__(2171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);
















function getType(url) {
  var type = url.split(':')[0];
  if (type === 'wss') {
    return 'ws';
  }
  if (type === 'https') {
    return 'http';
  }
  return type;
}

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.any.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired
};

var AppDebug = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AppDebug, _React$Component);

  function AppDebug(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AppDebug);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.type = '';
    _this.url = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__func_url__["a" /* getUrl */])() || '';
    _this.type = getType(_this.url) || '';
    _this.httpUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__func_url__["b" /* getHttpUrl */])() || '';
    _this.parser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__func_parser__["a" /* loadParserWithApp */])(props.appId);
    _this.state = {
      view: 'detail',
      data: [],
      feedback: null,
      wsStatus: ''
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'appdebug');
    return _this;
  }

  AppDebug.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.mounted = true;
    if (this.type === 'ws') {
      this.connectToWebSocket();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lorautils_api__["a" /* callAPI */])({
        endpoint: this.httpUrl,
        query: {
          limit: 1
        }
      }).then(function (data) {
        return _this2.setState({
          data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__func_parser__["b" /* transform */])(_this2.parser, data.list).map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
              frequency: item.frequency / 1000000,
              lorasnr: item.lorasnr.toFixed(1)
            });
          })
        });
      });
    } else {
      var fetchData = function fetchData() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lorautils_api__["a" /* callAPI */])({
          endpoint: _this2.httpUrl,
          query: {
            limit: 20
          }
        }).then(function (data) {
          return _this2.setState({
            data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__func_parser__["b" /* transform */])(_this2.parser, data.list).map(function (item) {
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
                frequency: item.frequency / 1000000,
                lorasnr: item.lorasnr.toFixed(1)
              });
            })
          });
        });
      };
      this.intervalId = setInterval(fetchData, 10000);
      fetchData();
    }
  };

  AppDebug.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
    if (this.wsSocket) {
      this.wsSocket.close();
      this.wsSocket = null;
    }
    if (this.connectTimeout) {
      window.clearTimeout(this.connectTimeout);
      this.connectTimeout = null;
    }
    if (this.intervalId) {
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }
  };

  AppDebug.prototype.connectToWebSocket = function connectToWebSocket() {
    var _this3 = this;

    this.wsSocket = new WebSocket(this.url + "&feedback");
    this.wsSocket.onopen = function () {
      _this3.setState({ wsStatus: 'connected' });
    };
    this.wsSocket.onmessage = function (event) {
      _this3.handleEvent(event);
    };
    this.wsSocket.onclose = function () {
      if (_this3.mounted) {
        _this3.setState({ wsStatus: 'closed' });
        // reconnect after 2 seconds
        _this3.connectTimeout = window.setTimeout(function () {
          _this3.setState({ wsStatus: 'reconnecting' });
          _this3.connectToWebSocket();
        }, 2000);
      }
    };
  };

  AppDebug.prototype.handleEvent = function handleEvent(event) {
    var evtData = JSON.parse(event.data);
    if (evtData.feedback) {
      this.setState({ feedback: evtData });
    } else {
      var data = this.state.data;
      var payload = JSON.parse(evtData.payload);
      payload.frequency /= 1000000;
      payload.lorasnr = payload.lorasnr.toFixed(1);
      data = [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payload, { $time: Date.now() })].concat(data);
      data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__func_parser__["b" /* transform */])(this.parser, data);
      this.setState({ data: data });
    }
  };

  AppDebug.prototype.handleParserChange = function handleParserChange(parser) {
    this.parser = parser;
    var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__func_parser__["b" /* transform */])(parser, this.state.data);
    this.setState({ data: data });
  };

  AppDebug.prototype.renderSideBar = function renderSideBar() {
    var _this4 = this;

    var _state$view = this.state.view,
        view = _state$view === undefined ? 'detail' : _state$view;

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_SideBar__["a" /* default */], {
      height: window.innerHeight,
      title: this.intlMsg.msg('sidebar.title'),
      menuItems: [{
        icon: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "glyphicons glyphicons-blackboard" }),
        text: this.intlMsg.msg('sidebar.detail'),
        onClick: function onClick() {
          return _this4.setState({ view: 'detail' });
        },
        active: view === 'detail'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "glyphicons glyphicons-stethoscope" }),
        text: this.intlMsg.msg('sidebar.parsedata'),
        onClick: function onClick() {
          return _this4.setState({ view: 'parser' });
        },
        active: view === 'parser'
      }]
    });
  };

  AppDebug.prototype.renderView = function renderView() {
    var _this5 = this;

    var appId = this.props.appId;
    var _state = this.state,
        _state$data = _state.data,
        data = _state$data === undefined ? [] : _state$data,
        _state$view2 = _state.view,
        view = _state$view2 === undefined ? 'detail' : _state$view2,
        wsStatus = _state.wsStatus,
        feedback = _state.feedback;

    if (view === 'detail') {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__coms_DetailView__["a" /* default */], {
        data: data,
        appId: appId,
        url: this.url,
        wsType: this.type,
        wsSocket: this.wsSocket,
        wsStatus: wsStatus,
        wsFeedback: feedback,
        resetFeedback: function resetFeedback() {
          _this5.setState({ feedback: null });
        }
      });
    } else if (view === 'parser') {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__coms_ParserView__["a" /* default */], {
        data: data,
        wsType: this.type,
        appId: appId,
        wsStatus: wsStatus,
        onSaveParser: function onSaveParser(parser) {
          _this5.handleParserChange(parser);
        }
      });
    }
    return null;
  };

  AppDebug.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      null,
      this.renderSideBar(),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_loracoms_SidebarContainer__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.view },
          this.renderView()
        )
      )
    );
  };

  return AppDebug;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

AppDebug.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    appId: ownProps.params.id
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_8_react_css_modules___default()(AppDebug, __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a, { allowMultiple: true }))));

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_draft_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_Copy__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_Editable__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__AppDebug_func_url__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss__ = __webpack_require__(2172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__styles_scss__);





/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);


















var propTypes = {
  token: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.any.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  onDelete: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired
};

var PullInterfaceRow = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PullInterfaceRow, _React$Component);

  function PullInterfaceRow(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PullInterfaceRow);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      token: props.token,
      noteState: __WEBPACK_IMPORTED_MODULE_11_draft_js__["EditorState"].createEmpty(),
      errors: __WEBPACK_IMPORTED_MODULE_18_lorautils_errors_ErrorSet__["a" /* default */].createEmpty()
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_16_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.apiview');
    _this.handleChangeName = _this.handleChangeName.bind(_this);
    _this.handleEditName = _this.handleEditName.bind(_this);
    _this.handleSubmitName = _this.handleSubmitName.bind(_this);
    _this.handleEditNote = _this.handleEditNote.bind(_this);
    _this.handleChangeNote = _this.handleChangeNote.bind(_this);
    _this.handleSubmitNote = _this.handleSubmitNote.bind(_this);
    _this.handleClickUrl = _this.handleClickUrl.bind(_this);
    return _this;
  }

  PullInterfaceRow.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var token = nextProps.token;

    if (token !== this.props.token) {
      this.setState({ token: token });
    }
  };

  PullInterfaceRow.prototype.handleChangeName = function handleChangeName(data, id) {
    this.setState({ editData: data });

    var errors = this.state.errors;


    if (id === 'name') {
      if (data.name === '') {
        this.setState({ errors: errors.add('FE_EMPTY', 'name') });
      } else {
        this.setState({ errors: errors.remove('name') });
      }
    }
  };

  PullInterfaceRow.prototype.handleEditName = function handleEditName() {
    var _state = this.state,
        token = _state.token,
        _state$editData = _state.editData,
        editData = _state$editData === undefined ? {} : _state$editData,
        errors = _state.errors;


    this.setState({
      editName: true,
      editData: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, editData, {
        name: token.name
      }),
      errors: errors.remove('name')
    });
  };

  PullInterfaceRow.prototype.handleSubmitName = function handleSubmitName() {
    var _this2 = this;

    var _state2 = this.state,
        editData = _state2.editData,
        errors = _state2.errors,
        token = _state2.token;


    if (errors.has('name')) {
      return;
    }
    if (_.trim(editData.name).length === 0) {
      this.setState({ errors: errors.add('FE_EMPTY', 'name') });
      return;
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_lorautils_api__["a" /* callAPI */])({
      endpoint: "/tokens/" + token.token,
      body: { name: editData.name },
      method: 'PUT'
    }).then(function () {
      _this2.setState({
        token: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, token, {
          name: editData.name,
          displayName: editData.name
        }),
        editName: false
      });
    }).catch(function (error) {
      _this2.setState({
        errors: errors.add(error.code, 'name')
      });
    });
  };

  PullInterfaceRow.prototype.handleEditNote = function handleEditNote() {
    var token = this.state.token;
    var _token$note = token.note,
        note = _token$note === undefined ? '' : _token$note;

    this.setState({
      noteState: __WEBPACK_IMPORTED_MODULE_11_draft_js__["EditorState"].createWithContent(__WEBPACK_IMPORTED_MODULE_11_draft_js__["ContentState"].createFromText(note)),
      editNote: true
    });
  };

  PullInterfaceRow.prototype.handleChangeNote = function handleChangeNote(noteState) {
    this.setState({ noteState: noteState });
  };

  PullInterfaceRow.prototype.handleSubmitNote = function handleSubmitNote() {
    var _this3 = this;

    var _state3 = this.state,
        noteState = _state3.noteState,
        token = _state3.token;

    var note = noteState.getCurrentContent().getPlainText();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_lorautils_api__["a" /* callAPI */])({
      endpoint: "/tokens/" + token.token,
      body: { aux: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ note: note }) },
      method: 'PUT'
    }).then(function () {
      _this3.setState({
        token: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, token, {
          note: note
        }),
        editNote: false
      });
    }).catch(function () {});
  };

  PullInterfaceRow.prototype.handleClickUrl = function handleClickUrl(url, httpUrl) {
    var _props = this.props,
        appId = _props.appId,
        pushState = _props.pushState;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__AppDebug_func_url__["c" /* setUrl */])(url);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__AppDebug_func_url__["d" /* setHttpUrl */])(httpUrl);
    pushState("/application/" + appId + "/debug");
  };

  PullInterfaceRow.prototype.render = function render() {
    var _this4 = this;

    var onDelete = this.props.onDelete;
    var _state4 = this.state,
        token = _state4.token,
        _state4$editName = _state4.editName,
        editName = _state4$editName === undefined ? false : _state4$editName,
        _state4$editNote = _state4.editNote,
        editNote = _state4$editNote === undefined ? false : _state4$editNote,
        _state4$editData = _state4.editData,
        editData = _state4$editData === undefined ? {} : _state4$editData,
        noteState = _state4.noteState,
        errors = _state4.errors;


    var editTp = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Tooltip"],
      { id: "tooltip-ed" },
      this.intlMsg.msg('tooltip.edit', 'lora')
    );
    var debugTp = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Tooltip"],
      { id: "tooltip-debug" },
      this.intlMsg.msg('tooltip.debug')
    );
    var tokenTp = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Tooltip"],
      { id: "tooltip-token" },
      "Token"
    );

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      { className: "clearfix " + __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.posR + " " + __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.noWrap + " " + __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.flexContainer },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { className: "" + __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.flex2 },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.name },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Editable__["a" /* default */], {
            id: "name",
            edit: editName,
            data: editData,
            value: token.name,
            onChange: this.handleChangeName,
            formatter: function formatter() {
              return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "span",
                null,
                token.displayName
              );
            },
            error: this.intlMsg.errorMsg(errors.get('name')),
            errorPlacement: 'top'
          }),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
            { "if": !editName },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "span",
              { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.actions },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["OverlayTrigger"],
                { placement: "top", overlay: editTp },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
                  { onClick: this.handleEditName, className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.edit },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "halflings halflings-pencil" })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
            { "if": editName },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "span",
              { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.actions },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
                { onClick: this.handleSubmitName, className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.ok },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "halflings halflings-ok" })
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
                { onClick: function onClick() {
                    return _this4.setState({ editName: false });
                  }, className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.cancel },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "halflings halflings-remove" })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.token },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["OverlayTrigger"],
            { placement: "top", overlay: tokenTp },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "halflings halflings-key" })
          ),
          ' ',
          token.token,
          ' ',
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Copy__["a" /* default */], { id: "copy-token-" + token.token, text: token.token })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.note },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Editable__["a" /* default */], {
            id: "note",
            edit: editNote,
            value: token.note,
            formatter: function formatter(x) {
              if (x === '' || _.isNil(x)) {
                return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
                  { onClick: _this4.handleEditNote },
                  _this4.intlMsg.msg('noteedit.link')
                );
              }
              return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "span",
                null,
                x
              );
            },
            onChange: this.handleChangeName,
            control: {
              type: 'external',
              external: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_draft_js__["Editor"], {
                editorState: noteState,
                onChange: this.handleChangeNote
              })
            }
          }),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
            { "if": !editNote && token.note !== '' && !_.isNil(token.note) },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "span",
              { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.actions },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["OverlayTrigger"],
                { placement: "top", overlay: editTp },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
                  { onClick: this.handleEditNote },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "halflings halflings-pencil" })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
            { "if": editNote },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.actions },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
                { onClick: this.handleSubmitNote, className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.ok },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "halflings halflings-ok" })
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
                { onClick: function onClick() {
                    return _this4.setState({ editNote: false });
                  }, className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.cancel },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "halflings halflings-remove" })
              )
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.url + " " + __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.flex2 },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_RichLabel__["a" /* default */], { content: "WebSocket" }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.tools },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["OverlayTrigger"],
            { placement: "top", overlay: debugTp },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
              { onClick: function onClick() {
                  return _this4.handleClickUrl(token.wsurl, token.httpurl);
                } },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "halflings halflings-wrench" })
            )
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Copy__["a" /* default */], { id: "copy-wsurl-" + token.token, text: token.wsurl })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.urlLink },
          token.wsurl
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.url + " " + __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.flex2 + " " + __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.borderRight },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_RichLabel__["a" /* default */], { content: "HTTP" }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.tools },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["OverlayTrigger"],
            { placement: "top", overlay: debugTp },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
              { onClick: function onClick() {
                  return _this4.handleClickUrl(token.httpurl, token.httpurl);
                } },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "halflings halflings-wrench" })
            )
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Copy__["a" /* default */], { id: "copy-httpurl-" + token.token, text: token.httpurl })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.urlLink },
          token.httpurl
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.delete + " " + __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.flex1 },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-link-danger",
            onClick: onDelete,
            className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.deleteBtn
          },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "glyphicons glyphicons-bin" }),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("br", null),
          this.intlMsg.msg('apidel.btn')
        )
      )
    );
  };

  return PullInterfaceRow;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PullInterfaceRow.propTypes = propTypes;

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_9_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(PullInterfaceRow)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_PanelToolbar__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_TablePager__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loraactions_app__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PullInterfaceRow__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__selectors__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss__ = __webpack_require__(2173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);
















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  getTokens: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  tokens: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var PullInterfaces = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PullInterfaces, _React$Component);

  function PullInterfaces(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PullInterfaces);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    var _props$tokens = props.tokens,
        _props$tokens$data = _props$tokens.data;
    _props$tokens$data = _props$tokens$data === undefined ? {} : _props$tokens$data;
    var _props$tokens$data$li = _props$tokens$data.list,
        tokens = _props$tokens$data$li === undefined ? [] : _props$tokens$data$li,
        _props$tokens$data$ma = _props$tokens$data.mark,
        mark = _props$tokens$data$ma === undefined ? '' : _props$tokens$data$ma,
        _props$tokens$data$mo = _props$tokens$data.more,
        more = _props$tokens$data$mo === undefined ? false : _props$tokens$data$mo,
        _props$tokens$status = _props$tokens.status,
        status = _props$tokens$status === undefined ? '' : _props$tokens$status;

    _this.state = {
      errors: __WEBPACK_IMPORTED_MODULE_10_lorautils_errors_ErrorSet__["a" /* default */].createEmpty(),
      tokens: tokens,
      status: status,
      mark: mark,
      more: more
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.apiview');
    _this.handleAdd = _this.handleAdd.bind(_this);
    _this.handleDelete = _this.handleDelete.bind(_this);
    _this.handleChangeMark = _this.handleChangeMark.bind(_this);
    return _this;
  }

  PullInterfaces.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        getTokens = _props.getTokens,
        appId = _props.appId;

    getTokens(appId);
  };

  PullInterfaces.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var tokens = nextProps.tokens;

    if (tokens !== this.props.tokens) {
      var _tokens$data = tokens.data;
      _tokens$data = _tokens$data === undefined ? {} : _tokens$data;
      var _tokens$data$mark = _tokens$data.mark,
          mark = _tokens$data$mark === undefined ? '' : _tokens$data$mark,
          _tokens$data$more = _tokens$data.more,
          more = _tokens$data$more === undefined ? false : _tokens$data$more,
          status = tokens.status;

      this.setState({ status: status, mark: mark, more: more });
      if (status === 'success') {
        this.setState({ tokens: tokens.data.list });
      }
    }
  };

  PullInterfaces.prototype.handleAdd = function handleAdd() {
    var _this2 = this;

    var _props2 = this.props,
        appId = _props2.appId,
        getTokens = _props2.getTokens;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lorautils_api__["a" /* callAPI */])({
      endpoint: 'tokens',
      body: {
        bind: appId
      },
      method: 'POST'
    }).then(function () {
      _this2.setState({ reset: Math.random() });
      getTokens(appId);
    }).catch(function (error) {
      _this2.setState({ addError: error.code });
    });
  };

  PullInterfaces.prototype.handleDelete = function handleDelete(token) {
    var _this3 = this;

    var _props3 = this.props,
        getTokens = _props3.getTokens,
        appId = _props3.appId;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lorautils_api__["a" /* callAPI */])({
      endpoint: "/tokens/" + token.token,
      method: 'DELETE'
    }).then(function () {
      _this3.setState({ reset: Math.random() });
      getTokens(appId);
    }).catch(function () {});
  };

  PullInterfaces.prototype.handleChangeMark = function handleChangeMark(mark) {
    var _props4 = this.props,
        getTokens = _props4.getTokens,
        appId = _props4.appId;

    getTokens(appId, { mark: mark });
  };

  PullInterfaces.prototype.render = function render() {
    var _this4 = this;

    var appId = this.props.appId;
    var _state = this.state,
        _state$mark = _state.mark,
        mark = _state$mark === undefined ? '' : _state$mark,
        _state$more = _state.more,
        more = _state$more === undefined ? false : _state$more,
        _state$reset = _state.reset,
        reset = _state$reset === undefined ? 0 : _state$reset,
        _state$status = _state.status,
        status = _state$status === undefined ? '' : _state$status,
        tokens = _state.tokens;


    var addButton = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
      {
        bsStyle: "aisz-success",
        bsSize: "small",
        onClick: this.handleAdd
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-plus" }),
      ' ',
      this.intlMsg.msg('newtoken.btn')
    );

    var trs = tokens.map(function (token, index) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__PullInterfaceRow__["a" /* default */], {
        key: token.token,
        index: index,
        token: token,
        appId: appId,
        onDelete: function onDelete() {
          return _this4.handleDelete(token);
        }
      });
    });

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: this.intlMsg.msg('tokens.panelheader') },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_PanelToolbar__["a" /* default */], { tools: [addButton] }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
        { "if": trs.length > 0 },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.tokens },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.interfaceContainer },
            trs
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.pager },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_TablePager__["a" /* default */], {
              mark: mark,
              more: more,
              reset: reset,
              status: status,
              onNext: this.handleChangeMark,
              onPrev: this.handleChangeMark
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
        { "if": trs.length === 0 },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.noTokens },
          this.intlMsg.msg('notokens')
        )
      )
    );
  };

  return PullInterfaces;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__selectors__["a" /* tokensSelector */])(ownProps.appId)(state)
  };
};

var mapDispatchToProps = {
  getTokens: __WEBPACK_IMPORTED_MODULE_13_loraactions_app__["a" /* default */].getTokens
};

PullInterfaces.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(PullInterfaces)));

/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tokensSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loracfg__ = __webpack_require__(65);

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var wsUrl = function wsUrl(appId, token) {
  var _document$location = document.location,
      protocol = _document$location.protocol,
      hostname = _document$location.hostname;

  var path = __WEBPACK_IMPORTED_MODULE_2_loracfg__["a" /* default */].wsBase;
  if (!path.startsWith('ws')) {
    // for production
    if (protocol === 'https:') {
      path = "wss://" + hostname + path;
    } else {
      path = "ws://" + hostname + path;
    }
  }
  return path + "/application/ws?appeui=" + appId + "&token=" + token + "&order=desc";
};

var httpUrl = function httpUrl(appId, token) {
  var _document$location2 = document.location,
      protocol = _document$location2.protocol,
      hostname = _document$location2.hostname;

  var path = __WEBPACK_IMPORTED_MODULE_2_loracfg__["a" /* default */].apiBase;
  if (!path.startsWith('http')) {
    // for production
    if (protocol === 'https:') {
      path = "https://" + hostname + path;
    } else {
      path = "http://" + hostname + path;
    }
  }
  return path + "/application/data?appeui=" + appId + "&token=" + token + "&order=desc";
};

var tokensSelector = function tokensSelector(appId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(function (state) {
    return state.app.getTokens;
  }, function (tokens) {
    if (tokens.status !== 'success') {
      return tokens;
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, tokens, {
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, tokens.data, {
        list: tokens.data.list.map(function (token) {
          var displayName = token.name;
          if (displayName === token.token) {
            displayName = token.name.substr(0, 5) + "..." + token.name.substr(token.name.length - 5);
          }
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, token, {
            displayName: displayName,
            wsurl: wsUrl(appId, token.token),
            httpurl: httpUrl(appId, token.token),
            note: JSON.parse(token.aux || '{}').note
          });
        })
      })
    });
  });
};

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_HideIf__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_Checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_Editable__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_AutoColor__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_loracfg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_loraactions_app__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_scss__ = __webpack_require__(2174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__styles_scss__);






/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);


















var kTargets = [{
  label: 'none',
  value: ''
}, {
  label: 'HTTP Post',
  value: 'post'
}, {
  label: 'mqtt',
  value: 'mqtt'
}];

if (__WEBPACK_IMPORTED_MODULE_19_loracfg__["a" /* default */].profile === 'cloud') {
  kTargets.push({
    label: 'senzFlow',
    value: 'senzflow'
  });
}

function parseToken(token) {
  var _JSON$parse = JSON.parse(token || '{}'),
      serverUrl = _JSON$parse.s,
      topic = _JSON$parse.t,
      clientId = _JSON$parse.c,
      password = _JSON$parse.p,
      e = _JSON$parse.e;

  var _JSON$parse2 = JSON.parse(token || '{}'),
      pushUrl = _JSON$parse2.u,
      username = _JSON$parse2.u;

  if (!_.isNil(topic) && topic !== '') {
    pushUrl = '';
  } else {
    username = '';
  }
  var appDataOnly = e === 'hex';
  return {
    pushUrl: pushUrl,
    appDataOnly: appDataOnly,
    serverUrl: serverUrl,
    topic: topic,
    clientId: clientId,
    username: username,
    password: password
  };
}

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.object.isRequired,
  appState: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.object.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.string.isRequired,
  getApp: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.func.isRequired,
  updateApp: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.func.isRequired,
  updateState: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.object.isRequired
};

var PushInterface = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(PushInterface, _React$Component);

  function PushInterface(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, PushInterface);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    var _props$appState$data = props.appState.data;
    _props$appState$data = _props$appState$data === undefined ? {} : _props$appState$data;
    var target = _props$appState$data.target,
        token = _props$appState$data.token;

    _this.state = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
      target: target
    }, parseToken(token), {
      editing: false,
      editData: {},
      errors: __WEBPACK_IMPORTED_MODULE_17_lorautils_errors_ErrorSet__["a" /* default */].createEmpty(),
      touched: new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a()
    });
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_18_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.apiview.pushinterface');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleEnableEdit = _this.handleEnableEdit.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  PushInterface.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var appState = nextProps.appState,
        updateState = nextProps.updateState;

    if (appState !== this.props.appState) {
      this.setState({ appState: appState });
      if (appState.status === 'success') {
        var _appState$data = appState.data,
            target = _appState$data.target,
            token = _appState$data.token;

        this.setState(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
          target: target
        }, parseToken(token)));
      }
    }
    if (updateState !== this.props.updateState) {
      if (updateState.status === 'success') {
        var _props = this.props,
            getApp = _props.getApp,
            appId = _props.appId;

        getApp(appId).then(function () {
          _this2.setState({ editing: false });
        }).catch(function () {
          _this2.setState({ editing: false });
        });
      } else if (updateState.status === 'failure') {
        var errors = this.state.errors;

        this.setState({
          errors: errors.add(updateState.error.code, 'submit')
        });
      }
    }
  };

  PushInterface.prototype.handleEnableEdit = function handleEnableEdit() {
    var _state = this.state,
        target = _state.target,
        pushUrl = _state.pushUrl,
        appDataOnly = _state.appDataOnly,
        serverUrl = _state.serverUrl,
        topic = _state.topic,
        clientId = _state.clientId,
        username = _state.username,
        password = _state.password;
    var errors = this.state.errors;

    if (target === 'post' && (pushUrl === '' || _.isNil(pushUrl))) {
      errors = errors.add('FE_EMPTY', 'pushurl');
    }
    if (target === 'mqtt' && (topic === '' || _.isNil(topic))) {
      errors = errors.add('FE_EMPTY', 'topic');
    }
    if (target === 'mqtt' && (serverUrl === '' || _.isNil(serverUrl))) {
      errors = errors.add('FE_EMPTY', 'serverUrl');
    }

    errors = errors.remove('submit');

    this.setState({
      editing: true,
      editData: {
        target: target,
        pushUrl: pushUrl,
        appDataOnly: appDataOnly,
        serverUrl: serverUrl,
        topic: topic,
        clientId: clientId,
        username: username,
        password: password
      },
      errors: errors
    });
  };

  PushInterface.prototype.touchAll = function touchAll() {
    var _state2 = this.state,
        editData = _state2.editData,
        touched = _state2.touched;

    if (editData.target === 'post') {
      touched.add('pushurl');
    } else if (editData.target === 'mqtt') {
      touched.add('topic').add('serverUrl');
    }
    this.setState({ touched: touched });
  };

  PushInterface.prototype.handleSubmit = function handleSubmit(e) {
    e.preventDefault();

    var _props2 = this.props,
        appId = _props2.appId,
        updateApp = _props2.updateApp;
    var _state$editData = this.state.editData,
        editData = _state$editData === undefined ? {} : _state$editData;
    var target = editData.target,
        pushUrl = editData.pushUrl,
        appDataOnly = editData.appDataOnly,
        serverUrl = editData.serverUrl,
        topic = editData.topic,
        clientId = editData.clientId,
        username = editData.username,
        password = editData.password;
    var errors = this.state.errors;

    errors = errors.remove('submit');
    this.setState({ errors: errors });

    this.touchAll();
    if (!errors.isEmpty()) {
      return;
    }

    if (target === 'post') {
      var token = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        u: pushUrl,
        e: appDataOnly ? 'hex' : 'json'
      });
      updateApp(appId, { target: target, token: token });
    } else if (target === 'mqtt') {
      var _token = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        s: serverUrl,
        t: topic,
        c: !_.isNil(clientId) && clientId !== '' ? clientId : 'loraflow.io',
        u: !_.isNil(username) ? username : '',
        p: !_.isNil(password) ? password : ''
      });
      updateApp(appId, { target: target, token: _token });
    } else {
      updateApp(appId, { target: target });
    }
  };

  PushInterface.prototype.handleChange = function handleChange(editData) {
    this.setState({
      editData: editData,
      touched: new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a()
    });

    var errors = this.state.errors;

    errors = errors.remove('submit');
    if (editData.target === 'post' && (editData.pushUrl === '' || _.isNil(editData.pushUrl))) {
      errors = errors.add('FE_EMPTY', 'pushurl');
      this.setState({ errors: errors });
    } else {
      errors = errors.remove('pushurl');
      this.setState({ errors: errors });
    }

    if (editData.target === 'mqtt' && (editData.topic === '' || _.isNil(editData.topic))) {
      errors = errors.add('FE_EMPTY', 'topic');
      this.setState({ errors: errors });
    } else {
      errors = errors.remove('topic');
      this.setState({ errors: errors });
    }

    if (editData.target === 'mqtt' && (editData.serverUrl === '' || _.isNil(editData.serverUrl))) {
      errors = errors.add('FE_EMPTY', 'serverUrl');
      this.setState({ errors: errors });
    } else {
      errors = errors.remove('serverUrl');
      this.setState({ errors: errors });
    }
  };

  PushInterface.prototype.render = function render() {
    var _this3 = this;

    var _state3 = this.state,
        _state3$editing = _state3.editing,
        editing = _state3$editing === undefined ? false : _state3$editing,
        _state3$editData = _state3.editData,
        editData = _state3$editData === undefined ? {} : _state3$editData,
        errors = _state3.errors,
        touched = _state3.touched;
    var _state4 = this.state,
        target = _state4.target,
        pushUrl = _state4.pushUrl,
        appDataOnly = _state4.appDataOnly,
        serverUrl = _state4.serverUrl,
        topic = _state4.topic,
        clientId = _state4.clientId,
        username = _state4.username,
        password = _state4.password;

    if (editing) {
      target = editData.target;
      pushUrl = editData.pushUrl;
      appDataOnly = editData.appDataOnly;
      serverUrl = editData.serverUrl;
      topic = editData.topic;
      clientId = editData.clientId;
      username = editData.username;
      password = editData.password;
    }

    if (_.isNil(clientId) || clientId === '') {
      editData.clientId = 'loraflow.io';
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Row"],
      null,
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
        { md: 5 },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Form"],
          { horizontal: true, className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.pushForm },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["ControlLabel"],
                { className: "aisz-control-label" },
                this.intlMsg.msg('label')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_Editable__["a" /* default */], {
                edit: editing,
                id: "target",
                value: target,
                data: editData,
                control: {
                  type: 'select',
                  options: kTargets
                },
                formatter: function formatter(x) {
                  var targetOpt = kTargets.find(function (t) {
                    return t.value === (x || '');
                  });
                  var label = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" });
                  if (targetOpt) {
                    label = targetOpt.label;
                  }
                  return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormControl"].Static,
                    null,
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_15_loracoms_AutoColor__["a" /* default */],
                      { content: x, inverse: true },
                      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("i", { className: "fa fa-circle" }),
                      ' '
                    ),
                    label
                  );
                },
                onChange: this.handleChange
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__["a" /* default */],
            { "if": target === 'post' || editData.target === 'post' },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormGroup"],
              { validationState: errors.has('pushurl') && touched.has('pushurl') ? 'error' : undefined },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["ControlLabel"],
                  { className: "aisz-control-label" },
                  "URL"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 6 },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_Editable__["a" /* default */], {
                  edit: editing,
                  id: "pushUrl",
                  value: pushUrl,
                  data: editData,
                  control: { className: "aisz-form-control " + __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.urlInput },
                  formatter: function formatter(x) {
                    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormControl"].Static,
                      null,
                      x
                    );
                  },
                  onChange: this.handleChange
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__["a" /* default */],
            { "if": target === 'post' || editData.target === 'post' },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormGroup"],
              null,
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["ControlLabel"],
                  { className: "aisz-control-label" },
                  this.intlMsg.msg('appdataonly.checkbox')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 6 },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.chkbox },
                  __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Checkbox__["a" /* default */], {
                    id: "appDataOnly",
                    checked: appDataOnly,
                    onChange: function onChange(checked) {
                      _this3.setState({
                        editData: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, editData, {
                          appDataOnly: checked
                        })
                      });
                    },
                    disabled: !editing
                  })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__["a" /* default */],
            { "if": target === 'mqtt' || editData.target === 'mqtt' },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormGroup"],
              { validationState: errors.has('serverUrl') && touched.has('serverUrl') ? 'error' : undefined },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["ControlLabel"],
                  { className: "aisz-control-label" },
                  "URL *"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 6 },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_Editable__["a" /* default */], {
                  edit: editing,
                  id: "serverUrl",
                  value: serverUrl,
                  data: editData,
                  control: { className: "aisz-form-control " + __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.urlInput },
                  formatter: function formatter(x) {
                    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormControl"].Static,
                      null,
                      x
                    );
                  },
                  onChange: this.handleChange
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__["a" /* default */],
            { "if": target === 'mqtt' || editData.target === 'mqtt' },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormGroup"],
              { validationState: errors.has('topic') && touched.has('topic') ? 'error' : undefined },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["ControlLabel"],
                  { className: "aisz-control-label" },
                  "Topic *"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 6 },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_Editable__["a" /* default */], {
                  edit: editing,
                  id: "topic",
                  value: topic,
                  data: editData,
                  control: { className: "aisz-form-control " + __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.urlInput },
                  formatter: function formatter(x) {
                    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormControl"].Static,
                      null,
                      x
                    );
                  },
                  onChange: this.handleChange
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__["a" /* default */],
            { "if": target === 'mqtt' || editData.target === 'mqtt' },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormGroup"],
              null,
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["ControlLabel"],
                  { className: "aisz-control-label" },
                  "Client ID"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 6 },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_Editable__["a" /* default */], {
                  edit: editing,
                  id: "clientId",
                  value: clientId,
                  data: editData,
                  control: { className: "aisz-form-control " + __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.urlInput },
                  formatter: function formatter(x) {
                    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormControl"].Static,
                      null,
                      x
                    );
                  },
                  onChange: this.handleChange
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__["a" /* default */],
            { "if": target === 'mqtt' || editData.target === 'mqtt' },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormGroup"],
              null,
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["ControlLabel"],
                  { className: "aisz-control-label" },
                  "Username"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 6 },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_Editable__["a" /* default */], {
                  edit: editing,
                  id: "username",
                  value: username,
                  data: editData,
                  control: { className: "aisz-form-control " + __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.urlInput },
                  formatter: function formatter(x) {
                    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormControl"].Static,
                      null,
                      x
                    );
                  },
                  onChange: this.handleChange
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__["a" /* default */],
            { "if": target === 'mqtt' || editData.target === 'mqtt' },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormGroup"],
              null,
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["ControlLabel"],
                  { className: "aisz-control-label" },
                  "Password"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 6 },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_Editable__["a" /* default */], {
                  edit: editing,
                  id: "password",
                  value: password,
                  data: editData,
                  control: { className: "aisz-form-control " + __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.urlInput },
                  formatter: function formatter(x) {
                    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormControl"].Static,
                      null,
                      x
                    );
                  },
                  onChange: this.handleChange
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
              { mdOffset: 3, md: 12 },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__["a" /* default */],
                { "if": editing },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
                    {
                      bsStyle: "aisz-warning",
                      onClick: function onClick() {
                        _this3.setState({ editing: false, editData: {} });
                      }
                    },
                    this.intlMsg.msg('cancel.btn'),
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("i", { className: "fa fa-times", "aria-hidden": "true" })
                  ),
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
                    { bsStyle: "aisz-primary", onClick: this.handleSubmit },
                    this.intlMsg.msg('save.btn'),
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("i", { className: "fa fa-check", "aria-hidden": "true" })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_12_loracoms_HideIf__["a" /* default */],
                { "if": editing },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
                  { bsStyle: "aisz-primary", onClick: this.handleEnableEdit },
                  this.intlMsg.msg('edit.btn'),
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("i", { className: "fa fa-pencil-square-o", "aria-hidden": "true" })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.submitError },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_FormBlock__["a" /* default */], {
                  show: errors.has('submit'),
                  message: this.intlMsg.errorMsg(errors.get('submit')),
                  azStyle: "danger"
                })
              )
            )
          )
        )
      )
    );
  };

  return PushInterface;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

PushInterface.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    planState: state.billing.plan,
    appState: state.app.getApp,
    updateState: state.app.updateApp
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["routerActions"].push,
  getApp: __WEBPACK_IMPORTED_MODULE_20_loraactions_app__["a" /* default */].getApp,
  updateApp: __WEBPACK_IMPORTED_MODULE_20_loraactions_app__["a" /* default */].updateApp
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"])(PushInterface)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_PageLoading__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_PageNoPerm__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__coms_PushInterface__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__coms_PullInterfaces__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_scss__ = __webpack_require__(2175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);


















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  planState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  appState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired
};

var APIView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(APIView, _React$Component);

  function APIView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, APIView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      appState: props.appState,
      planState: props.planState,
      showHelp: false,
      tokens: []
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_14_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.apiview');
    return _this;
  }

  APIView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var planState = nextProps.planState,
        appState = nextProps.appState;

    if (planState !== this.props.planState) {
      this.setState({ planState: planState });
    }
    if (appState !== this.props.appState) {
      this.setState({ appState: appState });
    }
  };

  APIView.prototype.renderPushEditForm = function renderPushEditForm() {
    var appId = this.props.appId;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: this.intlMsg.msg('pushinterface.header') },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__coms_PushInterface__["a" /* default */], { appId: appId })
    );
  };

  APIView.prototype.renderHelpWell = function renderHelpWell() {
    var locale = this.props.intl.locale;
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Well"],
      { bsClass: "aisz-well-light" },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "p",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], { id: "applicationdetail.apiview.help.content1" })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "p",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], { id: "applicationdetail.apiview.help.content2" }),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], { id: "applicationdetail.apiview.help.content3" }),
          ' ',
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_router__["f" /* Link */],
            { onClick: function onClick() {
                return window.open("/static/docs/" + locale + "/Application.html");
              } },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-book", "aria-hidden": "true" }),
            ' ',
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], { id: "applicationdetail.apiview.help.content3.link" })
          )
        )
      )
    );
  };

  APIView.prototype.renderToolbar = function renderToolbar() {
    var _this2 = this;

    var pushState = this.props.pushState;
    var appState = this.state.appState;
    var status = appState.status,
        _appState$data = appState.data;
    _appState$data = _appState$data === undefined ? {} : _appState$data;
    var name = _appState$data.name;


    var breadcrumb = [{
      onClick: function onClick() {
        return pushState('/application');
      },
      content: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], { id: "application.breadcrumb.application" })
    }, {
      content: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "span",
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Nvl__["a" /* default */], { val: name, status: status }),
        ' ',
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          { style: { marginLeft: '10px' } },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_router__["f" /* Link */],
            { onClick: function onClick() {
                return _this2.setState({ showHelp: !_this2.state.showHelp });
              } },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-question-sign" }),
            ' ',
            this.intlMsg.msg('showhelp.btn')
          )
        )
      ),
      active: true
    }];
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  APIView.prototype.renderAddErrModal = function renderAddErrModal() {
    var _this3 = this;

    var addErr = this.state.addErr;

    var content = null;

    switch (addErr) {
      case 'QUOTA':
        content = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          null,
          this.intlMsg.msg('apis.adderr.quota'),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_router__["f" /* Link */],
            { href: "mailto:support@aisenz.com" },
            "support@aisenz.com"
          )
        );
        break;
      default:
        content = this.intlMsg.msg('apis.adderr.general');
        break;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"],
      {
        show: !_.isNil(this.state.addErr),
        bsClass: "aisz-modal-warning",
        onHide: function onHide() {
          return _this3.setState({ addErr: null });
        }
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-warning-sign" }),
          ' ',
          this.intlMsg.msg('apis.adderr.modalheader')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "text-center" },
          content
        )
      )
    );
  };

  APIView.prototype.renderContent = function renderContent() {
    var appId = this.props.appId;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 12 },
          this.renderToolbar()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Collapse"],
        { "in": this.state.showHelp },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
            { md: 12 },
            this.renderHelpWell()
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__coms_PullInterfaces__["a" /* default */], { appId: appId })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 12 },
          this.renderPushEditForm()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        null,
        this.renderAddErrModal()
      )
    );
  };

  APIView.prototype.render = function render() {
    var planState = this.state.planState;

    if (planState.status !== 'success') {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_PageLoading__["a" /* default */], null);
    }
    if (planState.data.tier === 1) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_PageNoPerm__["a" /* default */], null);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      null,
      this.renderContent()
    );
  };

  return APIView;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

APIView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    planState: state.billing.plan,
    appId: ownProps.params.id,
    appState: state.app.getApp
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_7_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(APIView)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_startsWith__ = __webpack_require__(2513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_startsWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_startsWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_dropzone__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_papaparse__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_papaparse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loracoms_HideIf__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_loracoms_InlineSelect__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_loracoms_Checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_loraactions_usage__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_loraapi_lora_device__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__styles_scss__ = __webpack_require__(2176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__styles_scss__);





/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);























var kEncodingOptions = [{
  label: "UTF-8",
  value: "UTF-8"
}, {
  label: "GBK",
  value: "GBK"
}];

var kInnerFields = ["valid", "idx", "error", "result", "missings"];

var kRequiredFields = ["deveui", "band"];

var validateFields = {
  vendor: function vendor(v) {
    return _.inRange(v, 0, 256) && _.isInteger(v);
  },
  vendorver: function vendorver(v) {
    return _.inRange(v, 0, 256) && _.isInteger(v);
  },
  rx2freq: function rx2freq(v) {
    return _.inRange(v * 100, 100000, 1.67 * Math.pow(10, 9)) || v === 0;
  }
};

var defaultProps = {
  app: {},
  basic: {},
  plan: {},
  usage: {}
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.any.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.func.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.string.isRequired,
  app: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.object,
  basic: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.object,
  plan: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.object,
  usage: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.object,
  getNodesUsage: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.func.isRequired
};

var BatchImport = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(BatchImport, _React$Component);

  BatchImport.renderABPZhHelp = function renderABPZhHelp() {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      "tbody",
      null,
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "deveui"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "16\u4F4D16\u8FDB\u5236"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u5FC5\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u7EC8\u7AEFEUI"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "devaddr"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "8\u4F4D16\u8FDB\u5236"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u5FC5\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u7EC8\u7AEFLoRaWAN\u5730\u5740"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "nwkskey"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "32\u4F4D16\u8FDB\u5236"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u5FC5\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            null,
            "N"
          ),
          "et",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            null,
            "w"
          ),
          "or",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            null,
            "k"
          ),
          " ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            null,
            "S"
          ),
          "ession ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            null,
            "Key"
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "appskey"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "32\u4F4D16\u8FDB\u5236"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u5FC5\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            null,
            "App"
          ),
          " ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            null,
            "S"
          ),
          "ession ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            null,
            "Key"
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "band ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
            "\u65B0\u589E!"
          ),
          " "
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "ul",
            { className: "list-unstyled" },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "CN470"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "US902"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "AU915"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "EU863"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "EU868SEMTECH"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "CN470PREQUEL"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "AS923"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u5FC5\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "ISM\u9891\u6BB5"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "vendor ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
            "\u65B0\u589E!"
          ),
          " "
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u6574\u6570"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u5382\u5546ID\uFF0C\u8303\u56F40~255"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "vendorver ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
            "\u65B0\u589E!"
          ),
          " "
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u6574\u6570"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u5382\u5546\u7248\u672C\uFF0C\u8303\u56F40~255"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "city"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u57CE\u5E02"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "area"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u533A\u57DF"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "address"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u5177\u4F53\u7684\u5730\u5740"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "lng"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u7ECF\u5EA6(-180.000000 ~ +180.000000)"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "lat"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u7EAC\u5EA6(-90.000000 ~ +90.000000)"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "class"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u7EC8\u7AEF\u7C7B\u578B\uFF0CA"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "lwanver"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u534F\u8BAE\u7248\u672C, LoRaWAN1.0.1"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "rxwindow"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "number"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u4E0B\u884C\u94FE\u8DEFRX\u7A97\u53E3\u9009\u62E9 \u53D6\u503C 1\u62162\u4EE3\u8868RX1\u6216RX2"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "name"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u8BBE\u5907\u540D\u79F0"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "type"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u524D\u7AEFapp\u89E3\u91CA\uFF0C\u6E29\u6E7F\u5EA6\u4F20\u611F\u5668"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "rx2dr"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "number"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "rx2\u901F\u7387"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "rx2freq"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "number"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "rx2\u9891\u70B9, \u5355\u4F4DHZ/100"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          { colSpan: 4 },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "h4",
            null,
            "\u5BFC\u5165csv\u6587\u4EF6\u5185\u5BB9\u793A\u4F8B"
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "code",
            null,
            "deveui,devaddr,nwkskey,appskey,",
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "strong",
              { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
              "band"
            ),
            ", city,area,address,lng,lat,class,lwanver,name,type,rxwindow,rx2dr,rx2freq,vendor,vendorver",
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("br", null),
            "9876987423569874,11169874, 13569874235698742356987423569874,13569874235698742356987423569874,",
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "strong",
              { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
              "CN470"
            ),
            ", \u6DF1\u5733,\u5357\u5C71,\u79D1\u6280\u56ED,23,25,A,LoRaWAN1.0.1,Temp_Humi03,\u6E29\u6E7F\u5EA6\u4F20\u611F\u5668,1,1,4793000,0,0"
          )
        )
      )
    );
  };

  BatchImport.renderABPEnHelp = function renderABPEnHelp() {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      "tbody",
      null,
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "deveui"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Hexadecimal string of length 16"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Mandatory"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "DevEUI"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "devaddr"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Hexadecimal string of length 8"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Mandatory"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Device LoRaWAN Address"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "nwkskey"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Hexadecimal strong length 32"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Mandatory"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            null,
            "N"
          ),
          "et",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            null,
            "w"
          ),
          "or",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            null,
            "k"
          ),
          " ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            null,
            "S"
          ),
          "ession ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            null,
            "Key"
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "appskey"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Hexadecimal string of length 32"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Mandatory"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            null,
            "App"
          ),
          " ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            null,
            "S"
          ),
          "ession ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            null,
            "Key"
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "band ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
            "New!"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "ul",
            { className: "list-unstyled" },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "CN470"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "US902"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "AU915"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "EU863"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "EU868SEMTECH"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "CN470PREQUEL"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "AS923"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Mandatory"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "ISM Band"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "vendor ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
            "New!"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "integer"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Vendor ID,Ranges 0~255"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "vendorver ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
            "New!"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "integer"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Vendor version,Ranges 0~255"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "city"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "city"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "area"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optioanl"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "area"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "address"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "address"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "lng"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "logitude(-180.000000 ~ +180.000000)"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "lat"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "latitude(-90.000000 ~ +90.000000)"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "class"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "LoRaWAN class A"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "lwanver"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "LoRaWAN version, LoRaWAN 1.0.1"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "rxwindow"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "number"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "RX window selection"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "name"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Device name"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "type"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Temperature and humidity sensor"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "rx2dr"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "number"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "RX2DR"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "rx2freq"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "number"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "RX2 Frequency, In HZ/100"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          { colSpan: 4 },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "h4",
            null,
            "Example CSV File"
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "code",
            null,
            "deveui,devaddr,nwkskey,appskey,",
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "strong",
              { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
              "band"
            ),
            ",city,area,address, lng,lat,class,lwanver,name,type,rxwindow,rx2dr,rx2freq,vendor,vendorver",
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("br", null),
            "9876987423569874,11169874,13569874235698742356987423569874, 13569874235698742356987423569874,",
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "strong",
              { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
              "CN470"
            ),
            ", Shenzhen,Nanshan,HiTechPark,23,25,A,LoRaWAN1.0.1, Temp_Humi03,TemperatureHumiditySensor,1,1,4793000,0,0"
          )
        )
      )
    );
  };

  BatchImport.renderOTAAZhHelp = function renderOTAAZhHelp() {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      "tbody",
      null,
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "deveui"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "16\u4F4D16\u8FDB\u5236"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u5FC5\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u7EC8\u7AEFEUI"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "appkey"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "32\u4F4D16\u8FDB\u5236"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u5FC5\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            null,
            "App"
          ),
          " ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            null,
            "Key"
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "band ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
            "\u65B0\u589E!"
          ),
          " "
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "ul",
            { className: "list-unstyled" },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "CN470"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "US902"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "AU915"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "EU863"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "EU868SEMTECH"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "CN470PREQUEL"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "AS923"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u5FC5\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "ISM\u9891\u6BB5"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "vendor ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
            "\u65B0\u589E!"
          ),
          " "
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u6574\u6570"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u5382\u5546ID\uFF0C\u8303\u56F40~255"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "vendorver ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
            "\u65B0\u589E!"
          ),
          " "
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u6574\u6570"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u5382\u5546\u7248\u672C\uFF0C\u8303\u56F40~255"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "city"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u57CE\u5E02"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "area"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u533A\u57DF"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "address"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u5177\u4F53\u7684\u5730\u5740"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "lng"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u7ECF\u5EA6(-180.000000 ~ +180.000000)"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "lat"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u7EAC\u5EA6(-90.000000 ~ +90.000000)"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "class"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u7EC8\u7AEF\u7C7B\u578B, A"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "lwanver"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u534F\u8BAE\u7248\u672C, LoRaWAN 1.0.1"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "rxwindow"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "number"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u4E0B\u884C\u94FE\u8DEFRX\u7A97\u53E3\u9009\u62E9 \u53D6\u503C 1\u62162\u4EE3\u8868RX1\u6216RX2"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "name"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u8BBE\u5907\u540D\u79F0"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "type"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u524D\u7AEFapp\u89E3\u91CA\uFF0C\u6E29\u6E7F\u5EA6\u4F20\u611F\u5668"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "rx2dr"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "number"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "rx2\u901F\u7387"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "rx2freq"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "number"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "\u53EF\u9009"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "rx2\u9891\u70B9, \u5355\u4F4DHZ/100"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          { colSpan: 4 },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "h4",
            null,
            "\u5BFC\u5165csv\u6587\u4EF6\u5185\u5BB9\u793A\u4F8B"
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "code",
            null,
            "deveui,appkey,",
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "strong",
              { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
              "band"
            ),
            ", city,area,address,lng,lat,class,lwanver,name,type,rxwindow,rx2dr,rx2freq,vendor,vendorver",
            " ",
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("br", null),
            "1234567812345678,12345678123456781234567812345678,",
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "strogn",
              { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
              "CN470"
            ),
            ", \u6DF1\u5733,\u5357\u5C71,\u79D1\u6280\u56ED,23,25,A,LoRaWAN1.0.1,Temp_Humi03,\u6E29\u6E7F\u5EA6\u4F20\u611F\u5668,1,1,4793000,0,0"
          )
        )
      )
    );
  };

  BatchImport.renderOTAAEnHelp = function renderOTAAEnHelp() {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      "tbody",
      null,
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "deveui"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Hexadecimal string of length 16"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Mandatory"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "DevEUI"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "appkey"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Hexadecimal string of length 32"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Mandatory"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            null,
            "App"
          ),
          " ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            null,
            "Key"
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "band ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
            "New!"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "ul",
            { className: "list-unstyled" },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "CN470"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "US902"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "AU915"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "EU863"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "EU868SEMTECH"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "CN470PREQUEL"
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "li",
              null,
              "AS923"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Mandatory"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "ISM Band"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "vendor ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
            "New!"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "integer"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Vendor ID,Ranges 0~255"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "vendorver ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "strong",
            { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
            "New!"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "integer"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Vendor version,Ranges 0~255"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "city"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "city"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "area"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "area"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "address"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "address"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "lng"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "logitude(-180.000000 ~ +180.000000)"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "lat"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "latitude(-90.000000 ~ +90.000000)"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "class"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "LoRaWAN class A"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "lwanver"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "LoRaWAN version, LoRaWAN 1.0.1"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "rxwindow"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "number"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "RX window selection"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "name"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Device name"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "type"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "string"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "app\u89E3\u91CA\uFF0C\u6E29\u6E7F\u5EA6\u4F20\u611F\u5668"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "rx2dr"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "number"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "RX2DR"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "rx2freq"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "number"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "Optional"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          "RX2 Frequency, In HZ/100"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          { colSpan: 4 },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "h4",
            null,
            "Example CSV File"
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "code",
            null,
            "deveui,appkey,",
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "strong",
              { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
              "band"
            ),
            ", city,area,address,lng,lat,class,lwanver,name,type,rxwindow,rx2dr,rx2freq,vendor,vendorver",
            " ",
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("br", null),
            "1234567812345678,12345678123456781234567812345678,",
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "strong",
              { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.new },
              "CN470"
            ),
            ", Shenzhen,Nanshan,HiTechPark,23,25,A, LoRaWAN1.0.1,Temp_Humi03,TemperatureHumiditySensor,1,1,4793000,0,0"
          )
        )
      )
    );
  };

  BatchImport.norm = function norm(rows) {
    var normedRows = _.filter(rows, function (r) {
      return r.deveui.trim().length > 0;
    });
    normedRows = _.map(normedRows, function (r, idx) {
      var row = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, r);
      row.idx = idx;
      row.missings = _.filter(kRequiredFields, function (f) {
        return !_.has(row, f) || _.isNil(row[f]) || row[f].trim() === "";
      });
      row.valid = row.missings.length === 0;
      row.error = null;
      row = _.mapKeys(row, function (value, key) {
        return key.toLowerCase();
      });
      return row;
    });
    return normedRows;
  };

  function BatchImport(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, BatchImport);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      app: props.app,
      basic: props.basic,
      plan: props.plan,
      usage: props.usage,
      activeKey: 1,
      view: "dropzone",
      encoding: "UTF-8"
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_21_lorautils_intl_IntlMsg__["a" /* default */](props.intl, "applicationdetail.batchimport");
    _this.handleDrop = _this.handleDrop.bind(_this);
    _this.handleReImport = _this.handleReImport.bind(_this);
    _this.handleChangeEncoding = _this.handleChangeEncoding.bind(_this);
    _this.handleSubmitImport = _this.handleSubmitImport.bind(_this);
    _this.toggleCheck = _this.toggleCheck.bind(_this);
    _this.toggleCheckAll = _this.toggleCheckAll.bind(_this);
    _this.handleSelectHelp = _this.handleSelectHelp.bind(_this);
    return _this;
  }

  BatchImport.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var app = nextProps.app,
        basic = nextProps.basic,
        plan = nextProps.plan,
        usage = nextProps.usage;

    if (app !== this.props.app) {
      this.setState({ app: app });
    }
    if (basic !== this.props.basic) {
      this.setState({ basic: basic });
    }
    if (plan !== this.props.plan) {
      this.setState({ plan: plan });
    }
    if (usage !== this.props.usage) {
      this.setState({ usage: usage });
    }
  };

  BatchImport.prototype.cleanse = function cleanse(rows) {
    var _this2 = this;

    return _.map(rows, function (r) {
      r.lastact = 0;
      var nr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, r, { deveui: r.deveui.trim() });
      if (_.has(nr, "rxwindow")) {
        nr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, nr, { rxwindow: Number(r.rxwindow) });
      }
      if (_.has(nr, "devaddr")) {
        nr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, nr, { devaddr: nr.devaddr.trim() });
      }
      if (_.has(nr, "nwkskey")) {
        nr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, nr, { nwkskey: nr.nwkskey.trim() });
      }
      if (_.has(nr, "appskey")) {
        nr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, nr, { appskey: nr.appskey.trim() });
      }
      if (_.has(nr, "appkey")) {
        nr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, nr, { appkey: nr.appkey.trim() });
      }
      if (_.has(nr, "rx2dr")) {
        nr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, nr, { rx2dr: Number(r.rx2dr) });
      }
      if (_.has(nr, "rx2freq")) {
        nr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, nr, { rx2freq: Number(r.rx2freq) });
      }
      if (_.has(nr, "vendor")) {
        nr.vendor = Number(r.vendor);
      }
      if (_.has(nr, "vendorver")) {
        nr.vendorver = Number(r.vendorver);
      }
      var canSubmit = true;
      _.forEach(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(validateFields), function (f) {
        if (_.has(nr, f) && nr[f] && !validateFields[f](nr[f])) {
          nr.error = true;
          canSubmit = false;
        }
      });
      _this2.setState({ canSubmit: canSubmit });
      return nr;
    });
  };

  BatchImport.prototype.handleDrop = function handleDrop(acceptedFiles) {
    if (acceptedFiles.length > 0) {
      this.setState({ file: acceptedFiles[0] });
      this.prepareFile({ file: acceptedFiles[0] });
    }
  };

  BatchImport.prototype.appName = function appName() {
    var appId = this.props.appId;
    var app = this.state.app;

    if (app.status === "success") {
      return app.data.name || appId;
    }
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" });
  };

  BatchImport.prototype.handleSelectHelp = function handleSelectHelp(activeKey) {
    this.setState({ activeKey: activeKey });
  };

  BatchImport.prototype.prepareFile = function prepareFile(options) {
    var _this3 = this;

    var _options$file = options.file,
        file = _options$file === undefined ? this.state.file : _options$file,
        _options$encoding = options.encoding,
        encoding = _options$encoding === undefined ? this.state.encoding : _options$encoding;

    if (!file) {
      return;
    }

    var that = this;
    __WEBPACK_IMPORTED_MODULE_14_papaparse___default.a.parse(file, {
      complete: function complete(result) {
        var rows = BatchImport.norm(result.data);
        // rows = _.filter(rows, { valid: true });
        rows = _this3.cleanse(rows);
        that.setState({
          rows: rows,
          checkedRows: _.filter(rows, "valid"),
          view: "preview"
        });
      },
      header: true,
      encoding: encoding
    });
  };

  BatchImport.prototype.handleChangeEncoding = function handleChangeEncoding(encoding) {
    this.setState({ encoding: encoding });
    this.prepareFile({ encoding: encoding });
  };

  BatchImport.prototype.handleSubmitImport = function handleSubmitImport() {
    var _this4 = this;

    var appId = this.props.appId;
    var _state = this.state,
        checkedRows = _state.checkedRows,
        _state$basic$data = _state.basic.data;
    _state$basic$data = _state$basic$data === undefined ? {} : _state$basic$data;
    var lrnodenum = _state$basic$data.lrnodenum,
        _state$usage$nodes = _state.usage.nodes,
        ncnts = _state$usage$nodes === undefined ? 0 : _state$usage$nodes,
        _state$canSubmit = _state.canSubmit,
        canSubmit = _state$canSubmit === undefined ? true : _state$canSubmit;

    var rows = this.state.rows;
    if (!canSubmit) {
      return;
    }

    if (ncnts + checkedRows.length > lrnodenum) {
      this.setState({ error: "ooq" });
      return;
    }

    // !!! Oh yeah, we can do the batch import !!!!
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_loraapi_lora_device__["g" /* importBatch */])({ list: checkedRows }, appId).then(function (resp) {
      _.forEach(_.zip(checkedRows, resp.body.list), function (p) {
        var idx = p[0].idx;
        rows = _.map(rows, function (r) {
          if (r.idx === idx) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, r, { result: p[1] });
          }
          return r;
        });
      });
      _this4.setState({
        rows: rows,
        view: "result"
      });
    }).catch(function (reason) {
      var code = "UNKNOWN";
      if (reason && reason.body) {
        code = reason.body._code; // eslint-disable-line
      }
      if (code === "DEVADDRUNAVAIL") {
        _this4.setState({ error: "DEVADDRUNAVAIL" });
      }
      if (code === "QUOTA") {
        _this4.setState({ error: "ooq" });
      }
    });
  };

  BatchImport.prototype.handleReImport = function handleReImport() {
    var getNodesUsage = this.props.getNodesUsage;

    getNodesUsage();
    this.setState({
      view: "dropzone",
      file: null
    });
  };

  BatchImport.prototype.toggleCheck = function toggleCheck(row) {
    var checkedRows = this.state.checkedRows;

    if (_.some(checkedRows, { idx: row.idx })) {
      this.setState({
        checkedRows: _.filter(checkedRows, function (r) {
          return r.idx !== row.idx;
        })
      });
    } else {
      checkedRows.push(row);
      this.setState({ checkedRows: checkedRows });
    }
  };

  BatchImport.prototype.toggleCheckAll = function toggleCheckAll() {
    var _state2 = this.state,
        rows = _state2.rows,
        checkedRows = _state2.checkedRows;

    var validRows = _.filter(rows, "valid");
    if (validRows.length === checkedRows.length) {
      this.setState({ checkedRows: [] });
    } else {
      this.setState({ checkedRows: validRows });
    }
  };

  BatchImport.prototype.parseResultError = function parseResultError(x) {
    if (__WEBPACK_IMPORTED_MODULE_7_lodash_startsWith___default()(x, "DEVEUIUNAVAIL")) {
      return this.intlMsg.errorMsg("DEVEUIUNAVAIL");
    } else if (__WEBPACK_IMPORTED_MODULE_7_lodash_startsWith___default()(x, "BADDEVEUI")) {
      return this.intlMsg.errorMsg("BADDEVEUI");
    } else if (__WEBPACK_IMPORTED_MODULE_7_lodash_startsWith___default()(x, "DEVEUICONFLICT")) {
      return this.intlMsg.errorMsg("DEVEUICONFLICT");
    } else if (__WEBPACK_IMPORTED_MODULE_7_lodash_startsWith___default()(x, "BANDUNKNOWN")) {
      return this.intlMsg.errorMsg("BANDUNKNOWN");
    } else if (__WEBPACK_IMPORTED_MODULE_7_lodash_startsWith___default()(x, "DEVADDRUNAVAIL")) {
      return this.intlMsg.errorMsg("DEVADDRUNAVAIL");
    }
    return this.intlMsg.msg("result.fail") + ": " + x;
  };

  BatchImport.prototype.renderTools = function renderTools() {
    var _this5 = this;

    var encoding = this.state.encoding;

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.tools },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_loracoms_InlineSelect__["a" /* default */], {
        options: kEncodingOptions,
        onChange: function onChange(xs) {
          return _this5.handleChangeEncoding(xs[0]);
        },
        values: [encoding]
      })
    );
  };

  BatchImport.prototype.renderDropzone = function renderDropzone() {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      "div",
      null,
      this.renderTools(),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13_react_dropzone___default.a,
        {
          className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.dropzone,
          activeClassName: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a["dropzone-active"],
          onDrop: this.handleDrop
        },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "div",
          { className: "text-center" },
          this.intlMsg.msg("dropzone.text")
        )
      )
    );
  };

  BatchImport.prototype.renderPreview = function renderPreview() {
    var _this6 = this;

    var _state3 = this.state,
        basic = _state3.basic,
        _state3$usage$nodes = _state3.usage.nodes,
        ncnts = _state3$usage$nodes === undefined ? 0 : _state3$usage$nodes,
        _state3$canSubmit = _state3.canSubmit,
        canSubmit = _state3$canSubmit === undefined ? true : _state3$canSubmit;

    if (basic.status !== "success") {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "div",
        { styleName: "table-loading" },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin fa-3x" })
      );
    }

    var _state4 = this.state,
        rows = _state4.rows,
        checkedRows = _state4.checkedRows;

    var headers = _.union(_.flatten(_.map(rows, function (r) {
      return _.keys(r);
    })));
    headers = _.filter(headers, function (h) {
      return !kInnerFields.includes(h) && !kRequiredFields.includes(h);
    });
    headers = _.concat(kRequiredFields, headers);

    var ths = headers.map(function (h) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "th",
        { key: h, style: { whiteSpace: "nowrap" } },
        h
      );
    });
    var trs = rows.map(function (r) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        { key: r.deveui, styleName: r.error ? "result-fail" : "" },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          { styleName: "f-checkbox" },
          r.error ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("i", { className: "fa fa-times" }) : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_loracoms_Checkbox__["a" /* default */], {
            id: r.deveui,
            checked: _.some(checkedRows, { idx: r.idx }),
            onChange: function onChange() {
              return _this6.toggleCheck(r);
            },
            disabled: !r.valid
          })
        ),
        headers.map(function (h) {
          var c = void 0;
          var sty = "";
          if (r.missings.includes(h)) {
            c = _this6.intlMsg.msg("preview.required");
          } else if (_.has(validateFields, h) && !validateFields[h](r[h])) {
            c = _this6.intlMsg.msg("preview.invalidvalue") + ": " + r[h];
            sty = "invalid";
          } else {
            c = r[h];
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "td",
            {
              key: r.deveui + "-" + h,
              className: r.missings.includes(h) ? __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.missing : "",
              style: { whiteSpace: "nowrap" },
              styleName: sty
            },
            c
          );
        })
      );
    });

    var lrnodenum = basic.data.lrnodenum;


    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      "div",
      { styleName: "preview" },
      this.renderTools(),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Table"],
        { className: "aisz-table-light", striped: true, responsive: true, bordered: true, hover: true },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "th",
              { styleName: "f-checkbox" },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_loracoms_Checkbox__["a" /* default */], {
                id: "all",
                checked: _.filter(rows, "valid").length === checkedRows.length,
                onChange: this.toggleCheckAll
              })
            ),
            ths
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "tbody",
          null,
          trs
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "div",
        { styleName: "tips" },
        this.intlMsg.msg("preview.canimport.tips.desc1"),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "strong",
          null,
          lrnodenum
        ),
        this.intlMsg.msg("preview.canimport.tips.desc2"),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "strong",
          null,
          ncnts
        ),
        this.intlMsg.msg("preview.canimport.tips.desc3"),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "strong",
          null,
          lrnodenum - ncnts
        ),
        this.intlMsg.msg("preview.canimport.tips.desc4")
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "div",
        { styleName: "submit" },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-warning",
            onClick: function onClick() {
              return _this6.setState({ view: "dropzone" });
            }
          },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("i", { className: "fa fa-repeat" }),
          " ",
          this.intlMsg.msg("preview.cancel.btn")
        ),
        " ",
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-primary",
            onClick: this.handleSubmitImport,
            disabled: checkedRows.length === 0 || !canSubmit
          },
          this.intlMsg.msg("preview.import.btn.seg1"),
          " ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Badge"],
            { bsClass: "aisz-badge-primary-i" },
            checkedRows.length
          ),
          " ",
          this.intlMsg.msg("preview.import.btn.seg2"),
          " ",
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("i", { className: "fa fa-arrow-circle-o-right" })
        )
      )
    );
  };

  BatchImport.prototype.renderResult = function renderResult() {
    var _this7 = this;

    var appId = this.props.appId;
    var rows = this.state.rows;

    var headers = _.union(_.flatten(_.map(rows, function (r) {
      return _.keys(r);
    })));
    headers = _.filter(headers, function (h) {
      return !kInnerFields.includes(h);
    });
    var ths = headers.map(function (h, i) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "th",
        { key: i, style: { whiteSpace: "nowrap" } },
        h
      );
    }); // eslint-disable-line
    var trs = rows.map(function (r, i) {
      var status = "notimport";
      var icon = void 0;
      var msg = _this7.intlMsg.msg("result.notimport");
      if (_.has(r, "result")) {
        status = r.result === "OK" ? "succ" : "fail";
        if (status === "succ") {
          icon = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("i", { className: "fa fa-check" });
          msg = _this7.intlMsg.msg("result.succ");
        } else {
          icon = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("i", { className: "fa fa-times" });
          msg = _this7.parseResultError(r.result, r);
        }
      }
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        { key: String(i), styleName: "result-" + status },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          { style: { whiteSpace: "nowrap" } },
          icon
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          { style: { whiteSpace: "nowrap" } },
          msg
        ),
        headers.map(function (h, idx) {
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "td",
            { key: idx, style: { whiteSpace: "nowrap" } },
            r[h]
          ) // eslint-disable-line
          ;
        })
      );
    });

    var succCount = _.filter(rows, function (r) {
      return _.has(r, "result") && r.result === "OK";
    }).length;
    var failCount = _.filter(rows, function (r) {
      return _.has(r, "result") && r.result !== "OK";
    }).length;

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Table"],
        { className: "aisz-table-light", responsive: true, bordered: true },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg("result.thead.status")
            ),
            ths
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "tbody",
          null,
          trs
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "div",
        { styleName: "result-summary" },
        this.intlMsg.msg("result.summary.seg1"),
        ": ",
        succCount,
        ", ",
        this.intlMsg.msg("result.summary.seg2"),
        ": ",
        failCount,
        ",",
        " ",
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_router__["f" /* Link */],
          { onClick: this.handleReImport },
          this.intlMsg.msg("result.summary.reimport")
        ),
        " ",
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_router__["f" /* Link */],
          {
            onClick: function onClick() {
              return _this7.props.pushState("/application/" + appId + "/detail");
            }
          },
          this.intlMsg.msg("result.summary.back")
        )
      )
    );
  };

  BatchImport.prototype.renderHelp = function renderHelp() {
    if (this.state.activeKey === 1) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "div",
        { styleName: "helpdoc" },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Table"],
          { className: "aisz-table-light", responsive: true, hover: true },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg("help.abp.thead.fieldname")
              ),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg("help.abp.thead.length")
              ),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg("help.abp.thead.mandatory")
              ),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg("help.abp.thead.remark")
              )
            )
          ),
          this.props.intl.locale === "zh" ? BatchImport.renderABPZhHelp() : BatchImport.renderABPEnHelp()
        )
      );
    }
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      "div",
      { styleName: "helpdoc" },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Table"],
        { className: "aisz-table-light", responsive: true, hover: true },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg("help.abp.thead.fieldname")
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg("help.abp.thead.length")
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg("help.abp.thead.mandatory")
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg("help.abp.thead.remark")
            )
          )
        ),
        this.props.intl.locale === "zh" ? BatchImport.renderOTAAZhHelp() : BatchImport.renderOTAAEnHelp()
      )
    );
  };

  BatchImport.prototype.renderErrorModal = function renderErrorModal() {
    var _this8 = this;

    var _state5 = this.state,
        error = _state5.error,
        plan = _state5.plan;

    var errorContent = null;
    if (error === "ooq") {
      if (plan.status !== "success") {
        errorContent = this.intlMsg.msg("device.err.outofquota", "lora");
      } else {
        errorContent = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_18_loracoms_HideIf__["a" /* default */],
            { "if": "profile:cube" },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
                { "if": plan.data.tier < 3 },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    "p",
                    null,
                    this.intlMsg.msg("err.outofquota.undercomm")
                  ),
                  __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Button"],
                    {
                      bsStyle: "aisz-primary",
                      onClick: function onClick() {
                        return _this8.props.pushState("/billing/plans");
                      }
                    },
                    this.intlMsg.msg("upgrade.btn"),
                    " ",
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("i", { className: "fa fa-arrow-circle-o-right" })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
                { "if": plan.data.tier === 3 },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  "div",
                  null,
                  this.intlMsg.msg("err.outofquota.comm"),
                  __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("br", null),
                  __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    "a",
                    { href: "mailto:support@aisenz.com" },
                    "support@aisenz.com"
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
            { "if": "profile:cube" },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "div",
              null,
              this.intlMsg.msg("err.outofquota.cube"),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("br", null),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                "a",
                { href: "mailto:support@aisenz.com" },
                "support@aisenz.com"
              )
            )
          )
        );
      }
    } else if (error === "DEVADDRUNAVAIL") {
      errorContent = this.intlMsg.msg("E.DEVADDRUNAVAIL");
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-warning",
        show: !_.isNil(this.state.error),
        onHide: function onHide() {
          return _this8.setState({ error: null });
        }
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "div",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle" }),
          " ",
          this.intlMsg.msg("err.modalheader")
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "div",
          { className: "text-center" },
          errorContent
        )
      )
    );
  };

  BatchImport.prototype.render = function render() {
    var _this9 = this;

    var appId = this.props.appId;

    var breadcrumb = [{
      content: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], { id: "application.breadcrumb.application" }),
      onClick: function onClick() {
        return _this9.props.pushState("/application");
      }
    }, {
      content: this.appName(),
      onClick: function onClick() {
        return _this9.props.pushState("/application/" + appId + "/detail");
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], { id: "applicationdetail.batchimport.breadcrumb" }),
      active: true
    }];

    var helpHeader = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      "span",
      null,
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("i", { className: "fa fa-book" }),
      " ",
      this.intlMsg.msg("help.panelheader")
    );

    var _state6 = this.state,
        view = _state6.view,
        activeKey = _state6.activeKey;


    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Grid"],
        { fluid: true },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Panel"],
              { bsStyle: "aisz-white" },
              view === "dropzone" && this.renderDropzone(),
              view === "preview" && this.renderPreview(),
              view === "result" && this.renderResult()
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Panel"],
              { bsStyle: "aisz-white", header: helpHeader },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Nav"],
                {
                  bsStyle: "aisz-pills",
                  activeKey: activeKey,
                  onSelect: this.handleSelectHelp
                },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["NavItem"],
                  { eventKey: 1, onClick: function onClick() {} },
                  this.intlMsg.msg("help.abp")
                ),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["NavItem"],
                  { eventKey: 2, onClick: function onClick() {} },
                  this.intlMsg.msg("help.otaa")
                )
              ),
              this.renderHelp()
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "div",
        null,
        this.renderErrorModal()
      )
    );
  };

  return BatchImport;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

BatchImport.defaultProps = defaultProps;
BatchImport.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    basic: state.org.basic,
    plan: state.billing.plan,
    usage: state.usage,
    app: state.app.getApp,
    appId: ownProps.params.id
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_9_react_router_redux__["routerActions"].push,
  getNodesUsage: __WEBPACK_IMPORTED_MODULE_22_loraactions_usage__["a" /* default */].nodes
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_15_react_css_modules___default()(BatchImport, __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a, { allowMultiple: true }))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_Select__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_Checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loraactions_enums__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lorautils_api_selector__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lorautils_checkers_numbers__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_scss__ = __webpack_require__(2177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__styles_scss__);





/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  bandsOpts: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array.isRequired,
  showModal: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  getBands: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
  onSuccess: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired
};

var kInitialErrs = __WEBPACK_IMPORTED_MODULE_17_lorautils_errors_ErrorSet__["a" /* default */].createEmpty().add('FE_EMPTY', 'band').add('FE_EMPTY', 'rx2dr').add('FE_EMPTY', 'rx2freq').add('FE_EMPTY', 'name').add('FE_EMPTY', 'devaddr').add('FE_EMPTY', 'appskey').add('FE_EMPTY', 'nwkskey');

var kRX2DROptions = _.range(16).map(function (v) {
  return {
    value: v,
    label: String(v)
  };
});

var AddAddress = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AddAddress, _React$Component);

  function AddAddress(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AddAddress);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      showModal: props.showModal,
      name: '',
      bandsOpts: [],
      errors: kInitialErrs,
      submitted: false,
      isNew: true
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_16_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.broadcast');
    _this.handleChangeName = _this.handleChangeName.bind(_this);
    return _this;
  }

  AddAddress.prototype.componentWillMount = function componentWillMount() {
    this.props.getBands();
  };

  AddAddress.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var showModal = nextProps.showModal,
        bandsOpts = nextProps.bandsOpts;

    if (showModal !== this.props.showModal) {
      this.setState({ showModal: showModal });
    }
    this.setState({ bandsOpts: bandsOpts });
  };

  AddAddress.prototype.checkKeys = function checkKeys(key, val) {
    var errors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.state.errors;

    if (val.length === 0) {
      return errors.add('FE_EMPTY', key);
    } else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_lorautils_checkers_numbers__["c" /* isHexString */])(val, { len: 32 })) {
      return errors.add('FE_INVALIDAPPKEY', key, { message: this.intlMsg.errorMsg('FE_INVALIDAPPKEY') });
    }
    return errors.remove(key);
  };

  AddAddress.prototype.checkRX2Freq = function checkRX2Freq(val) {
    var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.errors;

    if (!/^[0-9]+(\.[0-9]+)?$/.test(val)) {
      return errors.add('FE_INVALIDNUM', 'rx2freq', { message: this.intlMsg.errorMsg('FE_INVALIDNUM') });
    }
    if (!/^[0-9]+(\.[0-9]{0,4})?$/.test(val)) {
      return errors.add('FE_PREC4', 'rx2freq', { message: this.intlMsg.errorMsg('FE_PREC4') });
    }
    if (Number(val) < 100 || Number(val) > 16700) {
      return errors.add('FE_OUTOFRANGE', 'rx2freq', { message: this.intlMsg.errorMsg('FE_OUTOFRANGE') });
    }
    return errors.remove('rx2freq');
  };

  AddAddress.prototype.handleOnHide = function handleOnHide() {
    this.props.onHide();
    this.setState({
      name: '',
      band: '',
      rx2dr: '',
      rx2freq: '',
      submitted: false,
      devaddr: '',
      appskey: '',
      nwkskey: '',
      isNew: true,
      errors: kInitialErrs
    });
  };

  AddAddress.prototype.handleChangeName = function handleChangeName(e) {
    var errors = this.state.errors;

    var name = _.trim(e.target.value);
    errors = name.length === 0 ? errors.add('FE_EMPTY', 'name') : errors.remove('name');
    this.setState({ errors: errors, name: name });
  };

  AddAddress.prototype.handleChangeSelect = function handleChangeSelect(key, value) {
    var _setState;

    var errors = this.state.errors;

    this.setState((_setState = {}, _setState[key] = value, _setState.errors = errors.remove(key), _setState));
  };

  AddAddress.prototype.handleChangeFreq = function handleChangeFreq(e) {
    var rx2freq = _.trim(e.target.value);
    var errors = this.state.errors;

    errors = this.checkRX2Freq(rx2freq, errors);
    this.setState({ rx2freq: rx2freq, errors: errors });
  };

  AddAddress.prototype.handleChangeAddr = function handleChangeAddr(e) {
    var errors = this.state.errors;

    var devaddr = _.trim(e.target.value);
    devaddr = devaddr.replace(/[:-]/g, '');
    if (devaddr.length !== 8 && devaddr.length !== 0) {
      this.setState({ errors: errors.add('FE_INVALIDADDR', 'devaddr') });
    } else if (devaddr.length === 0) {
      this.setState({ errors: errors.add('FE_EMPTY', 'devaddr') });
    } else {
      this.setState({ errors: errors.remove('devaddr') });
    }
    this.setState({ devaddr: devaddr });
  };

  AddAddress.prototype.handleChangeKeys = function handleChangeKeys(key, e) {
    var _setState2;

    var val = _.trim(e.target.value);
    var errors = this.state.errors;

    errors = this.checkKeys(key, val, errors);
    this.setState((_setState2 = { errors: errors }, _setState2[key] = val, _setState2));
  };

  AddAddress.prototype.handleChangeType = function handleChangeType() {
    var isNew = this.state.isNew;

    isNew = !isNew;
    this.setState({ isNew: isNew });
  };

  AddAddress.prototype.handleOnConfirm = function handleOnConfirm() {
    var _this2 = this;

    var _state = this.state,
        isNew = _state.isNew,
        name = _state.name,
        band = _state.band,
        rx2dr = _state.rx2dr,
        rx2freq = _state.rx2freq,
        _state$devaddr = _state.devaddr,
        devaddr = _state$devaddr === undefined ? '' : _state$devaddr,
        _state$appskey = _state.appskey,
        appskey = _state$appskey === undefined ? '' : _state$appskey,
        _state$nwkskey = _state.nwkskey,
        nwkskey = _state$nwkskey === undefined ? '' : _state$nwkskey;
    var errors = this.state.errors;
    var _props = this.props,
        appId = _props.appId,
        onSuccess = _props.onSuccess;


    this.setState({ submitted: true });
    var param = { name: name, band: band, rx2dr: rx2dr, rx2freq: Number(rx2freq) * 10000 };
    if (!isNew) {
      param = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, param, { appskey: appskey, nwkskey: nwkskey, devaddr: devaddr });
    } else {
      errors = errors.remove('devaddr').remove('appskey').remove('nwkskey');
    }

    if (!errors.isEmpty()) {
      return;
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__api_callAPI__["a" /* default */])({
      endpoint: "/lora/apps/" + appId + "/broadcasts",
      method: 'POST',
      body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, param)
    }).then(function (res) {
      onSuccess(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, res, { isNew: true }));
      _this2.handleOnHide();
    }).catch(function (err) {
      _this2.setState({ errors: errors.add(err.code, 'submit') });
    });
  };

  AddAddress.prototype.render = function render() {
    var _this3 = this;

    var _state2 = this.state,
        showModal = _state2.showModal,
        _state2$name = _state2.name,
        name = _state2$name === undefined ? '' : _state2$name,
        bandsOpts = _state2.bandsOpts,
        errors = _state2.errors,
        submitted = _state2.submitted,
        _state2$rx2freq = _state2.rx2freq,
        rx2freq = _state2$rx2freq === undefined ? '' : _state2$rx2freq,
        _state2$devaddr = _state2.devaddr,
        devaddr = _state2$devaddr === undefined ? '' : _state2$devaddr,
        isNew = _state2.isNew,
        _state2$appskey = _state2.appskey,
        appskey = _state2$appskey === undefined ? '' : _state2$appskey,
        _state2$nwkskey = _state2.nwkskey,
        nwkskey = _state2$nwkskey === undefined ? '' : _state2$nwkskey;

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"],
      {
        show: showModal,
        onHide: function onHide() {
          return _this3.handleOnHide();
        },
        bsClass: "aisz-modal-light"
      },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        this.intlMsg.msg('addressmodal.header'),
        this.intlMsg.msg('addr.quato')
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Form"],
          { horizontal: true },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormGroup"],
            { className: "clearfix" },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
              { md: 9, className: "clearfix" },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "span",
                { className: "pull-right " + __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.marginLm },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Checkbox__["a" /* default */], {
                  id: "inport-addr",
                  checked: !isNew,
                  onChange: function onChange() {
                    return _this3.handleChangeType();
                  }
                }),
                "\xA0",
                this.intlMsg.msg('add.import')
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "span",
                { className: "pull-right " + __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.marginLm },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Checkbox__["a" /* default */], {
                  id: "new-addr",
                  checked: isNew,
                  onChange: function onChange() {
                    return _this3.handleChangeType();
                  }
                }),
                "\xA0",
                this.intlMsg.msg('add.new')
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                this.intlMsg.msg('label.name'),
                "\xA0*"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormControl"], {
                value: name,
                bsClass: "aisz-form-control-f",
                placeholder: this.intlMsg.msg('add.placeholder'),
                onChange: this.handleChangeName
              }),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_ControlTips__["a" /* default */], {
                show: errors.has('name') && submitted,
                message: this.intlMsg.errorMsg(errors.get('name')),
                azStyle: "danger",
                placement: "right"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
            { "if": !isNew },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormGroup"],
                null,
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["ControlLabel"],
                    { bsClass: "aisz-control-label" },
                    this.intlMsg.msg('send.addr'),
                    "\xA0*"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormControl"], {
                    value: devaddr,
                    bsClass: "aisz-form-control-f",
                    placeholder: this.intlMsg.msg('addr.placeholder'),
                    onChange: function onChange(e) {
                      return _this3.handleChangeAddr(e);
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_ControlTips__["a" /* default */], {
                    show: errors.has('devaddr') && submitted,
                    message: this.intlMsg.errorMsg(errors.get('devaddr')),
                    azStyle: "danger",
                    placement: "right"
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormGroup"],
                null,
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["ControlLabel"],
                    { bsClass: "aisz-control-label" },
                    this.intlMsg.msg('addrlist.appskey'),
                    "\xA0*"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormControl"], {
                    value: appskey,
                    bsClass: "aisz-form-control-f",
                    onChange: function onChange(e) {
                      return _this3.handleChangeKeys('appskey', e);
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_ControlTips__["a" /* default */], {
                    show: errors.has('appskey') && submitted,
                    message: this.intlMsg.errorMsg(errors.get('appskey')),
                    azStyle: "danger",
                    placement: "right"
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormGroup"],
                null,
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["ControlLabel"],
                    { bsClass: "aisz-control-label" },
                    this.intlMsg.msg('addrlist.nwkskey'),
                    "\xA0*"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormControl"], {
                    value: nwkskey,
                    bsClass: "aisz-form-control-f",
                    onChange: function onChange(e) {
                      return _this3.handleChangeKeys('nwkskey', e);
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_ControlTips__["a" /* default */], {
                    show: errors.has('nwkskey') && submitted,
                    message: this.intlMsg.errorMsg(errors.get('nwkskey')),
                    azStyle: "danger",
                    placement: "right"
                  })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                this.intlMsg.msg('addressmodal.band'),
                "\xA0*"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Select__["a" /* default */], {
                options: bandsOpts,
                onChange: function onChange(band) {
                  return _this3.handleChangeSelect('band', band);
                }
              }),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_ControlTips__["a" /* default */], {
                show: errors.has('band') && submitted,
                message: this.intlMsg.errorMsg(errors.get('band')),
                azStyle: "danger",
                placement: "right"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                "RX2DR\xA0*"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Select__["a" /* default */], {
                options: kRX2DROptions,
                onChange: function onChange(rx2dr) {
                  return _this3.handleChangeSelect('rx2dr', rx2dr);
                }
              }),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_ControlTips__["a" /* default */], {
                show: errors.has('rx2dr') && submitted,
                message: this.intlMsg.errorMsg(errors.get('rx2dr')),
                azStyle: "danger",
                placement: "right"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                "RX2 Frequency\xA0*"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormControl"], {
                value: rx2freq,
                bsClass: "aisz-form-control-f",
                onChange: function onChange(e) {
                  return _this3.handleChangeFreq(e);
                }
              }),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_ControlTips__["a" /* default */], {
                show: errors.has('rx2freq') && submitted,
                message: this.intlMsg.errorMsg(errors.get('rx2freq')),
                azStyle: "danger",
                placement: "right"
              })
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
              { md: 2, className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.unit },
              "MHz"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
              { md: 6, mdOffset: 3 },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Button"],
                {
                  bsStyle: "aisz-primary",
                  className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.fullWidth,
                  onClick: function onClick() {
                    return _this3.handleOnConfirm();
                  }
                },
                this.intlMsg.msg('add.confirm')
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
              { md: 6, mdOffset: 3 },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_FormBlock__["a" /* default */], {
                show: errors.has('submit'),
                azStyle: "danger",
                message: this.intlMsg.errorMsg(errors.get('submit'))
              })
            )
          )
        )
      )
    );
  };

  return AddAddress;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

AddAddress.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    bandsOpts: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_lorautils_api_selector__["a" /* enumsToOptions */])('bands', state)
  };
};

var mapDispatchToProps = {
  getBands: __WEBPACK_IMPORTED_MODULE_15_loraactions_enums__["a" /* default */].bands
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(AddAddress)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_TablePager__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_scss__ = __webpack_require__(2178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  onSuccess: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  showModal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  checked: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array
};

var defaultProps = {
  checked: []
};

var GatewayModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(GatewayModal, _React$Component);

  function GatewayModal(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GatewayModal);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      list: [],
      checked: props.checked,
      showModal: props.showModal,
      mark: 0,
      more: false,
      reset: 0
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.broadcast');
    _this.mark = 0;
    return _this;
  }

  GatewayModal.prototype.componentWillMount = function componentWillMount() {
    this.loadGateways();
  };

  GatewayModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var showModal = nextProps.showModal,
        checked = nextProps.checked;

    if (showModal !== this.props.showModal) {
      this.setState({ showModal: showModal });
      if (showModal) {
        this.loadGateways();
      }
    }
    if (checked !== this.checked) {
      this.setState({ checked: checked });
    }
  };

  GatewayModal.prototype.getStatus = function getStatus(gw) {
    var disconnected = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "span",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-circle-o " + __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.disconnected }),
      ' ',
      this.intlMsg.msg('gateway.disconnected')
    );
    var connected = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "span",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-circle " + __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.connected }),
      ' ',
      this.intlMsg.msg('gateway.connected')
    );

    if (_.isNil(gw.lastOn)) {
      return disconnected;
    }
    if (_.isNil(gw.lastOff)) {
      return connected;
    }
    var onts = new Date(gw.lastOn).valueOf();
    var offts = new Date(gw.lastOff).valueOf();
    if (onts > offts) {
      return connected;
    }
    return disconnected;
  };

  GatewayModal.prototype.loadGateways = function loadGateways() {
    var _this2 = this;

    this.setState({ status: 'loading' });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__api_callAPI__["a" /* default */])({
      endpoint: '/lora/gateways',
      query: {
        mark: this.mark,
        sort: '-lastOn'
      }
    }).then(function (res) {
      _this2.setState({
        list: res.list,
        more: res.more,
        mark: res.mark,
        status: 'success'
      });
    }).catch(function () {});
  };

  GatewayModal.prototype.isChecked = function isChecked(d) {
    return _.some(this.state.checked, { id: d.id });
  };

  GatewayModal.prototype.isDisabled = function isDisabled(d) {
    return _.some(this.state.disableCheck, { id: d.id });
  };

  GatewayModal.prototype.toggleCheck = function toggleCheck(d) {
    var checked = this.state.checked;
    if (this.isChecked(d)) {
      this.setState({
        checked: _.filter(checked, function (a) {
          return a.id !== d.id;
        })
      });
    } else {
      checked.push(d);
      this.setState({ checked: checked });
    }
  };

  GatewayModal.prototype.handlePrevPage = function handlePrevPage(mark) {
    this.mark = mark;
    this.loadGateways();
  };

  GatewayModal.prototype.handleNextPage = function handleNextPage(mark) {
    this.mark = mark;
    this.loadGateways();
  };

  GatewayModal.prototype.handleAdd = function handleAdd() {
    var checked = this.state.checked;

    this.props.onSuccess(checked);
    this.setState({ reset: new Date(), mark: 0 });
    this.mark = 0;
  };

  GatewayModal.prototype.handleOnHide = function handleOnHide() {
    this.setState({ checked: [], reset: new Date(), mark: 0 });
    this.mark = 0;
    this.props.onHide();
  };

  GatewayModal.prototype.render = function render() {
    var _this3 = this;

    var _state = this.state,
        showModal = _state.showModal,
        list = _state.list,
        mark = _state.mark,
        more = _state.more,
        reset = _state.reset,
        status = _state.status;

    var rows = _.map(list, function (item) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        { key: item.id },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          { className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.checkbox },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Checkbox__["a" /* default */], {
            id: item.id,
            checked: _this3.isChecked(item),
            onChange: function onChange() {
              return _this3.toggleCheck(item);
            },
            disabled: _this3.isDisabled(item)
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          item.name
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          item.mac
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          _this3.getStatus(item)
        )
      );
    });
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"],
      {
        show: showModal,
        onHide: function onHide() {
          return _this3.handleOnHide();
        },
        bsClass: "aisz-modal-light"
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        this.intlMsg.msg('gateway.header')
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Table"],
          {
            className: "aisz-table-light",
            bordered: true,
            responsive: true
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("th", null),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('gateway.name')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('gateway.mac')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('gateway.connection')
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tbody",
            null,
            rows
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "clearfix" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
            {
              bsStyle: "aisz-success",
              onClick: function onClick() {
                return _this3.handleAdd();
              }
            },
            this.intlMsg.msg('gateway.confirm')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
          { "if": list.length > 0 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: "pull-right" },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_TablePager__["a" /* default */], {
              status: status,
              mark: mark,
              more: more,
              reset: reset,
              onPrev: function onPrev(m) {
                return _this3.handlePrevPage(m);
              },
              onNext: function onNext(m) {
                return _this3.handleNextPage(m);
              }
            })
          )
        )
      )
    );
  };

  return GatewayModal;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

GatewayModal.propTypes = propTypes;
GatewayModal.defaultProps = defaultProps;

var mapDispatchToProps = {};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(GatewayModal)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_DeleteModal__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_Refresher__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_Copy__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loraactions_broadcast__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__EditAddress__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AddAddress__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss__ = __webpack_require__(2179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);


















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,
  getBroadcast: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  broadcastState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};

var AddrList = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AddrList, _React$Component);

  function AddrList(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AddrList);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      list: [],
      deleteAddr: {},
      showDeleteModal: false
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_14_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.broadcast');
    return _this;
  }

  AddrList.prototype.componentWillMount = function componentWillMount() {
    this.loadBrdcstAddr();
  };

  AddrList.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _nextProps$broadcastS = nextProps.broadcastState,
        data = _nextProps$broadcastS.data,
        status = _nextProps$broadcastS.status;

    if (data) {
      this.setState({
        list: _.map(data.list, function (l) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, l, { isNew: false });
        }),
        status: status
      });
    }
  };

  AddrList.prototype.loadBrdcstAddr = function loadBrdcstAddr() {
    this.setState({ status: 'pending' });
    var _props = this.props,
        appId = _props.appId,
        getBroadcast = _props.getBroadcast;

    getBroadcast(appId);
  };

  AddrList.prototype.handleReload = function handleReload() {
    this.loadBrdcstAddr();
  };

  AddrList.prototype.handleAdd = function handleAdd(b) {
    var list = this.state.list;

    this.setState({ list: _.concat(b, list) });
  };

  AddrList.prototype.handleEdit = function handleEdit() {
    this.loadBrdcstAddr();
  };

  AddrList.prototype.handleDelete = function handleDelete() {
    var _this2 = this;

    var _state = this.state,
        deleteAddr = _state.deleteAddr,
        list = _state.list;
    var appId = this.props.appId;

    if (deleteAddr.devaddr) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__api_callAPI__["a" /* default */])({
        endpoint: "/lora/apps/" + appId + "/broadcasts/" + deleteAddr.devaddr,
        method: 'DELETE'
      }).then(function () {
        _this2.setState({
          list: _.filter(list, function (l) {
            return l.devaddr !== deleteAddr.devaddr;
          }),
          showDeleteModal: false
        });
      }).catch(function () {});
    }
  };

  AddrList.prototype.renderRows = function renderRows(list) {
    var _this3 = this;

    var tooltip1 = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Tooltip"],
      { id: "deleteaddr" },
      this.intlMsg.msg('addrlist.delete')
    );
    var tooltip2 = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Tooltip"],
      { id: "editaddr" },
      this.intlMsg.msg('addrlist.edit')
    );
    return _.map(list, function (l) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "tr",
        {
          key: l.devaddr,
          className: l.isNew ? __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.new : ''
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          l.name
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          l.devaddr,
          "\xA0",
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Copy__["a" /* default */], { id: "copy-devaddr-" + l.devaddr, text: l.devaddr })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          l.appskey ? l.appskey.substring(0, 6) + "..." : '',
          "\xA0",
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Copy__["a" /* default */], { id: "copy-" + l.appskey, text: l.appskey })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          l.nwkskey ? l.nwkskey.substring(0, 6) + "..." : '',
          "\xA0",
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Copy__["a" /* default */], { id: "copy-" + l.nwkskey, text: l.nwkskey })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          l.band
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          l.rx2dr
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          !_.isNil(l.rx2freq) ? Number(l.rx2freq / 10000).toFixed(4) : l.rx2freq
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          l.fcntdown
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["OverlayTrigger"],
            { placement: "top", overlay: tooltip1 },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_router__["f" /* Link */],
              {
                className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.delete,
                onClick: function onClick() {
                  _this3.setState({ showDeleteModal: true, deleteAddr: l });
                }
              },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-trash" })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["OverlayTrigger"],
            { placement: "top", overlay: tooltip2 },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_router__["f" /* Link */],
              {
                onClick: function onClick() {
                  _this3.setState({ showEditModal: true, editObj: l });
                }
              },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-pencil " + __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.edit })
            )
          )
        )
      );
    });
  };

  AddrList.prototype.render = function render() {
    var _this4 = this;

    var _state2 = this.state,
        list = _state2.list,
        deleteAddr = _state2.deleteAddr,
        _state2$editObj = _state2.editObj,
        editObj = _state2$editObj === undefined ? {} : _state2$editObj,
        _state2$status = _state2.status,
        status = _state2$status === undefined ? 'idle' : _state2$status,
        showDeleteModal = _state2.showDeleteModal,
        _state2$showModal = _state2.showModal,
        showModal = _state2$showModal === undefined ? false : _state2$showModal,
        _state2$showEditModal = _state2.showEditModal,
        showEditModal = _state2$showEditModal === undefined ? false : _state2$showEditModal;
    var appId = this.props.appId;

    var header = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      null,
      this.intlMsg.msg('addrlist.header'),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Button"],
        {
          bsStyle: "aisz-success",
          onClick: function onClick() {
            return _this4.setState({ showModal: true });
          },
          className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.marginLm
        },
        this.intlMsg.msg('addrlist.address'),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicon glyphicon-plus " + __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.marginLm })
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "pull-right " + __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.gray },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Refresher__["a" /* default */], {
          onReload: function onReload() {
            return _this4.handleReload();
          },
          reloading: status === 'pending'
        })
      )
    );
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.fullHeight },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Panel"],
        {
          bsStyle: "aisz-white",
          header: header,
          className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.fullHeight
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Table"],
          {
            className: "aisz-table-light",
            bordered: true,
            responsive: true
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('addrlist.name')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('addrlist.address')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('addrlist.appskey')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('addrlist.nwkskey')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('addrlist.band')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                "RX2DR"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                "RX2 Frequency"
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('addrlist.fcntdown')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('addrlist.operation')
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "tbody",
            null,
            this.renderRows(list)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__["a" /* default */],
          { "if": list.length === 0 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.noData },
            this.intlMsg.msg('addrlist.nodata')
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__AddAddress__["a" /* default */], {
        showModal: showModal,
        appId: appId,
        onHide: function onHide() {
          return _this4.setState({ showModal: false });
        },
        onSuccess: function onSuccess(b) {
          return _this4.handleAdd(b);
        }
      }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__EditAddress__["a" /* default */], {
        showModal: showEditModal,
        appId: appId,
        onHide: function onHide() {
          return _this4.setState({ showEditModal: false });
        },
        onSuccess: function onSuccess() {
          return _this4.handleEdit();
        },
        data: editObj
      }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_DeleteModal__["a" /* default */], {
        showModal: showDeleteModal,
        headerText: "\u5220\u9664\u5E7F\u64AD\u5730\u5740",
        text: "\u786E\u8BA4\u5220\u9664\u5E7F\u64AD\u5730\u5740" + deleteAddr.name + "(" + deleteAddr.devaddr + ")?",
        onCancel: function onCancel() {
          return _this4.setState({ showDeleteModal: false });
        },
        onConfirm: function onConfirm() {
          return _this4.handleDelete();
        }
      })
    );
  };

  return AddrList;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AddrList.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    broadcastState: state.broadcast.getBroadcast
  };
};

var mapDispatchToProps = {
  getBroadcast: __WEBPACK_IMPORTED_MODULE_15_loraactions_broadcast__["a" /* default */].getBroadcast
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(AddrList)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_Select__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loraactions_enums__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_api_selector__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lorautils_checkers_numbers__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss__ = __webpack_require__(2180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);
















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  bandsOpts: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array.isRequired,
  showModal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  getBands: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  onSuccess: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};

var kRX2DROptions = _.range(16).map(function (v) {
  return {
    value: v,
    label: String(v)
  };
});

var AddModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(AddModal, _React$Component);

  function AddModal(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AddModal);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      showModal: props.showModal,
      bandsOpts: [],
      errors: __WEBPACK_IMPORTED_MODULE_12_lorautils_errors_ErrorSet__["a" /* default */].createEmpty(),
      submitted: false
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.broadcast');
    _this.handleChangeName = _this.handleChangeName.bind(_this);
    return _this;
  }

  AddModal.prototype.componentWillMount = function componentWillMount() {
    this.props.getBands();
  };

  AddModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var showModal = nextProps.showModal,
        bandsOpts = nextProps.bandsOpts,
        data = nextProps.data;

    if (showModal !== this.props.showModal) {
      this.setState({ showModal: showModal });
    }
    if (data !== this.props.data) {
      var name = data.name,
          band = data.band,
          rx2dr = data.rx2dr,
          rx2freq = data.rx2freq,
          appskey = data.appskey,
          nwkskey = data.nwkskey,
          fcntdown = data.fcntdown;

      this.setState({
        name: name,
        band: band,
        rx2dr: rx2dr,
        rx2freq: !_.isNil(rx2freq) ? Number(rx2freq / 10000).toFixed(4) : rx2freq,
        appskey: appskey,
        nwkskey: nwkskey,
        fcntdown: fcntdown
      });
    }
    this.setState({ bandsOpts: bandsOpts });
  };

  AddModal.prototype.checkKeys = function checkKeys(key, val) {
    var errors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.state.errors;

    if (val.length === 0) {
      return errors.add('FE_EMPTY', key);
    } else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lorautils_checkers_numbers__["c" /* isHexString */])(val, { len: 32 })) {
      return errors.add('FE_INVALIDAPPKEY', key, { message: this.intlMsg.errorMsg('FE_INVALIDAPPKEY') });
    }
    return errors.remove(key);
  };

  AddModal.prototype.checkRX2Freq = function checkRX2Freq(val) {
    var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.errors;

    if (!/^[0-9]+(\.[0-9]+)?$/.test(val)) {
      return errors.add('FE_INVALIDNUM', 'rx2freq', { message: this.intlMsg.errorMsg('FE_INVALIDNUM') });
    }
    if (!/^[0-9]+(\.[0-9]{0,4})?$/.test(val)) {
      return errors.add('FE_PREC4', 'rx2freq', { message: this.intlMsg.errorMsg('FE_PREC4') });
    }
    if (Number(val) < 100 || Number(val) > 16700) {
      return errors.add('FE_OUTOFRANGE', 'rx2freq', { message: this.intlMsg.errorMsg('FE_OUTOFRANGE') });
    }
    return errors.remove('rx2freq');
  };

  AddModal.prototype.handleOnHide = function handleOnHide() {
    this.props.onHide();
    this.setState({
      submitted: false,
      errors: new __WEBPACK_IMPORTED_MODULE_12_lorautils_errors_ErrorSet__["a" /* default */]()
    });
  };

  AddModal.prototype.handleChangeName = function handleChangeName(e) {
    var errors = this.state.errors;

    var name = _.trim(e.target.value);
    errors = name.length === 0 ? errors.add('FE_EMPTY', 'name') : errors.remove('name');
    this.setState({ errors: errors, name: name });
  };

  AddModal.prototype.handleChangeSelect = function handleChangeSelect(key, value) {
    var _setState;

    var errors = this.state.errors;

    this.setState((_setState = {}, _setState[key] = value, _setState.errors = errors.remove(key), _setState));
  };

  AddModal.prototype.handleChangeKeys = function handleChangeKeys(key, e) {
    var _setState2;

    var val = _.trim(e.target.value);
    var errors = this.state.errors;

    errors = this.checkKeys(key, val, errors);
    this.setState((_setState2 = { errors: errors }, _setState2[key] = val, _setState2));
  };

  AddModal.prototype.handleChangeFreq = function handleChangeFreq(e) {
    var rx2freq = _.trim(e.target.value);
    var errors = this.state.errors;

    errors = this.checkRX2Freq(rx2freq, errors);
    this.setState({ rx2freq: rx2freq, errors: errors });
  };

  AddModal.prototype.handleChangeFcntdown = function handleChangeFcntdown(e) {
    var errors = this.state.errors;

    var fcntdown = _.trim(e.target.value);
    if (fcntdown.length === 0 || fcntdown.indexOf('-') > -1 || !_.isInteger(Number(fcntdown))) {
      this.setState({ errors: errors.add('FE_INVALIDFCNT', 'fcntdown') });
    } else {
      this.setState({ errors: errors.remove('fcntdown') });
    }
    this.setState({ fcntdown: fcntdown });
  };

  AddModal.prototype.handleOnConfirm = function handleOnConfirm() {
    var _this2 = this;

    var _state = this.state,
        name = _state.name,
        errors = _state.errors,
        band = _state.band,
        rx2dr = _state.rx2dr,
        rx2freq = _state.rx2freq,
        appskey = _state.appskey,
        nwkskey = _state.nwkskey,
        fcntdown = _state.fcntdown;
    var _props = this.props,
        appId = _props.appId,
        onSuccess = _props.onSuccess,
        data = _props.data;


    this.setState({ submitted: true });

    if (!errors.isEmpty()) {
      return;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__api_callAPI__["a" /* default */])({
      endpoint: "/lora/apps/" + appId + "/broadcasts/" + data.devaddr,
      method: 'PUT',
      body: {
        appskey: appskey,
        nwkskey: nwkskey,
        name: name,
        band: band,
        fcntdown: Number(fcntdown),
        rx2dr: rx2dr,
        rx2freq: Number(rx2freq) * 10000
      }
    }).then(function () {
      onSuccess();
      _this2.handleOnHide();
    }).catch(function () {});
  };

  AddModal.prototype.render = function render() {
    var _this3 = this;

    var _state2 = this.state,
        showModal = _state2.showModal,
        bandsOpts = _state2.bandsOpts,
        errors = _state2.errors,
        submitted = _state2.submitted,
        _state2$name = _state2.name,
        name = _state2$name === undefined ? '' : _state2$name,
        _state2$band = _state2.band,
        band = _state2$band === undefined ? '' : _state2$band,
        _state2$rx2dr = _state2.rx2dr,
        rx2dr = _state2$rx2dr === undefined ? '' : _state2$rx2dr,
        _state2$rx2freq = _state2.rx2freq,
        rx2freq = _state2$rx2freq === undefined ? '' : _state2$rx2freq,
        _state2$appskey = _state2.appskey,
        appskey = _state2$appskey === undefined ? '' : _state2$appskey,
        _state2$nwkskey = _state2.nwkskey,
        nwkskey = _state2$nwkskey === undefined ? '' : _state2$nwkskey,
        _state2$fcntdown = _state2.fcntdown,
        fcntdown = _state2$fcntdown === undefined ? '' : _state2$fcntdown;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"],
      {
        show: showModal,
        onHide: function onHide() {
          return _this3.handleOnHide();
        },
        bsClass: "aisz-modal-light"
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        this.intlMsg.msg('editmodal.header')
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Form"],
          { horizontal: true },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                this.intlMsg.msg('label.name'),
                "\xA0*"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormControl"], {
                value: name,
                bsClass: "aisz-form-control-f",
                placeholder: this.intlMsg.msg('add.placeholder'),
                onChange: this.handleChangeName
              }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_ControlTips__["a" /* default */], {
                show: errors.has('name') && submitted,
                message: this.intlMsg.errorMsg(errors.get('name')),
                azStyle: "danger",
                placement: "right"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                this.intlMsg.msg('addrlist.fcntdown'),
                "\xA0*"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormControl"], {
                type: "number",
                value: fcntdown,
                bsClass: "aisz-form-control-f",
                onChange: function onChange(e) {
                  return _this3.handleChangeFcntdown(e);
                }
              }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_ControlTips__["a" /* default */], {
                show: errors.has('fcntdown') && submitted,
                message: this.intlMsg.errorMsg(errors.get('fcntdown')),
                azStyle: "danger",
                placement: "right"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                this.intlMsg.msg('addressmodal.band'),
                "\xA0*"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Select__["a" /* default */], {
                value: band,
                options: bandsOpts,
                onChange: function onChange(va) {
                  return _this3.handleChangeSelect('band', va);
                }
              }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_ControlTips__["a" /* default */], {
                show: errors.has('band') && submitted,
                message: this.intlMsg.errorMsg(errors.get('band')),
                azStyle: "danger",
                placement: "right"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                "RX2DR\xA0*"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Select__["a" /* default */], {
                value: rx2dr,
                options: kRX2DROptions,
                onChange: function onChange(v) {
                  return _this3.handleChangeSelect('rx2dr', v);
                }
              }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_ControlTips__["a" /* default */], {
                show: errors.has('rx2dr') && submitted,
                message: this.intlMsg.errorMsg(errors.get('rx2dr')),
                azStyle: "danger",
                placement: "right"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                "RX2 Frequency\xA0*"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormControl"], {
                value: rx2freq,
                bsClass: "aisz-form-control-f",
                placeholder: "RX2 Frequency",
                onChange: function onChange(e) {
                  return _this3.handleChangeFreq(e);
                }
              }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_ControlTips__["a" /* default */], {
                show: errors.has('rx2freq') && submitted,
                message: this.intlMsg.errorMsg(errors.get('rx2freq')),
                azStyle: "danger",
                placement: "right"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                this.intlMsg.msg('addrlist.appskey'),
                "\xA0*"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormControl"], {
                value: appskey,
                bsClass: "aisz-form-control-f",
                placeholder: "s",
                onChange: function onChange(e) {
                  return _this3.handleChangeKeys('appskey', e);
                }
              }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_ControlTips__["a" /* default */], {
                show: errors.has('appskey') && submitted,
                message: this.intlMsg.errorMsg(errors.get('appskey')),
                azStyle: "danger",
                placement: "right"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                this.intlMsg.msg('addrlist.nwkskey'),
                "\xA0*"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormControl"], {
                value: nwkskey,
                bsClass: "aisz-form-control-f",
                placeholder: "s",
                onChange: function onChange(e) {
                  return _this3.handleChangeKeys('nwkskey', e);
                }
              }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_ControlTips__["a" /* default */], {
                show: errors.has('nwkskey') && submitted,
                message: this.intlMsg.errorMsg(errors.get('nwkskey')),
                azStyle: "danger",
                placement: "right"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 6, mdOffset: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
                {
                  bsStyle: "aisz-primary",
                  className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.fullWidth,
                  onClick: function onClick() {
                    return _this3.handleOnConfirm();
                  }
                },
                this.intlMsg.msg('add.confirm')
              )
            )
          )
        )
      )
    );
  };

  return AddModal;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

AddModal.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    bandsOpts: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_api_selector__["a" /* enumsToOptions */])('bands', state)
  };
};

var mapDispatchToProps = {
  getBands: __WEBPACK_IMPORTED_MODULE_10_loraactions_enums__["a" /* default */].bands
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(AddModal)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_scss__ = __webpack_require__(2181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);










var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  list: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array.isRequired,
  fail: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,
  showModal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired
};

var defaultProps = {
  fail: []
};

var GatewayList = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(GatewayList, _React$Component);

  function GatewayList(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GatewayList);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      list: props.list,
      showModal: props.showModal,
      fail: props.fail
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.broadcast');
    return _this;
  }

  GatewayList.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var list = nextProps.list,
        showModal = nextProps.showModal,
        fail = nextProps.fail;

    if (showModal !== this.props.showModal) {
      this.setState({ showModal: showModal });
    }
    if (list !== this.props.list) {
      this.setState({ list: list });
    }
    if (!_.isEqual(fail, this.props.fail)) {
      this.setState({ fail: fail });
    }
  };

  GatewayList.prototype.render = function render() {
    var _state = this.state,
        showModal = _state.showModal,
        list = _state.list,
        fail = _state.fail;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"],
      {
        show: showModal,
        onHide: this.props.onHide,
        bsClass: "aisz-modal-light"
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        this.intlMsg.msg('logs.gateway')
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Body,
        { className: "clearfix " + __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.lists },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.success },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.successTitle },
            this.intlMsg.msg('logs.success')
          ),
          _.map(list, function (l) {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              { key: l, className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.cols },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
                { to: "/gateway/detail/" + l },
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lorautils_IdUtils__["a" /* normalizeDevEUI */])(l)
              )
            );
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.fail },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.title },
            this.intlMsg.msg('logs.fail')
          ),
          _.map(fail, function (f) {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              { key: f, className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.cols },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
                { to: "/gateway/detail/" + f },
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lorautils_IdUtils__["a" /* normalizeDevEUI */])(f)
              )
            );
          })
        )
      )
    );
  };

  return GatewayList;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

GatewayList.propTypes = propTypes;
GatewayList.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(GatewayList));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_difference_in_seconds__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_difference_in_seconds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_difference_in_seconds__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_Refresher__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_PanelToolbar__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_TablePager__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_SearchInput__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__GatewayList__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss__ = __webpack_require__(2182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




















var isNew = function isNew(time) {
  return __WEBPACK_IMPORTED_MODULE_10_date_fns_difference_in_seconds___default()(new Date(), time) < 10;
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired
};

var Logs = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Logs, _React$Component);

  function Logs(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Logs);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      list: []
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_16_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.broadcast');
    _this.handleChangeMark = _this.handleChangeMark.bind(_this);
    _this.handleSearch = _this.handleSearch.bind(_this);
    _this.mark = 0;
    _this.q = null;
    return _this;
  }

  Logs.prototype.componentWillMount = function componentWillMount() {
    this.loadLogs();
  };

  Logs.prototype.loadLogs = function loadLogs() {
    var _this2 = this;

    this.setState({ status: 'pending' });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__api_callAPI__["a" /* default */])({
      endpoint: "/lora/apps/" + this.props.appId + "/broadcastmsgs",
      method: 'GET',
      query: {
        limit: 10,
        offset: this.mark,
        devaddr: this.q
      }
    }).then(function (res) {
      var list = res.list,
          more = res.more,
          mark = res.mark;

      _this2.setState({ list: list, mark: mark, more: more, status: 'success' });
      _this2.mark = res.mark;
    }).catch(function () {
      _this2.setState({ status: 'failure' });
    });
  };

  Logs.prototype.handleReload = function handleReload() {
    this.mark = 0;
    this.setState({ reset: new Date() });
    this.loadLogs();
  };

  Logs.prototype.handleSearch = function handleSearch(e) {
    var search = e.target.value;
    search = search.replace(/[:-]/g, '');
    this.setState({
      search: search,
      reset: new Date()
    });
    this.mark = 0;
    this.q = search.length > 0 ? search : null;
    this.loadLogs();
  };

  Logs.prototype.handleChangeMark = function handleChangeMark(mark) {
    this.mark = mark;
    this.loadLogs();
  };

  Logs.prototype.handleShowGateway = function handleShowGateway(gateways, failGateway) {
    this.setState({ gateways: gateways, failGateway: failGateway, showModal: true });
  };

  Logs.prototype.render = function render() {
    var _this3 = this;

    var _state = this.state,
        list = _state.list,
        _state$status = _state.status,
        status = _state$status === undefined ? 'idle' : _state$status,
        _state$mark = _state.mark,
        mark = _state$mark === undefined ? 0 : _state$mark,
        _state$more = _state.more,
        more = _state$more === undefined ? false : _state$more,
        _state$reset = _state.reset,
        reset = _state$reset === undefined ? 0 : _state$reset,
        _state$search = _state.search,
        search = _state$search === undefined ? '' : _state$search,
        _state$gateways = _state.gateways,
        gateways = _state$gateways === undefined ? [] : _state$gateways,
        _state$failGateway = _state.failGateway,
        failGateway = _state$failGateway === undefined ? [] : _state$failGateway,
        _state$showModal = _state.showModal,
        showModal = _state$showModal === undefined ? false : _state$showModal;

    var rows = _.map(list, function (l) {
      var gwcontent = void 0;
      var total = l.success.length + l.fail.length;
      if (l.success.length <= 1 && total <= 1) {
        var gw = void 0;
        var link = void 0;
        if (l.success[0]) {
          gw = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "span",
            null,
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_lorautils_IdUtils__["a" /* normalizeDevEUI */])(l.success[0])
          );
          link = l.success[0];
        } else if (l.fail[0]) {
          gw = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.failgateway },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_lorautils_IdUtils__["a" /* normalizeDevEUI */])(l.fail[0])
          );
          link = l.fail[0];
        }
        gwcontent = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
          { to: "/gateway/detail/" + link },
          gw
        );
      } else if (total > 1) {
        gwcontent = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
          {
            onClick: function onClick() {
              return _this3.handleShowGateway(l.success, l.fail);
            }
          },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_lorautils_IdUtils__["a" /* normalizeDevEUI */])(l.success[0] || l.fail[0]),
          " ..."
        );
      } else {
        gwcontent = '';
      }
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        {
          key: l.time + "-" + l.devaddr,
          className: isNew(l.time) ? __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.new : ''
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_8_date_fns_format___default()(l.time, 'MM-DD HH:mm:ss')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          gwcontent
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          l.devaddr.toLocaleLowerCase()
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          l.fport
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          l.encoding
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          l.data
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          l.fcntdown
        )
      );
    });
    var tools = [__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_SearchInput__["a" /* default */], {
      onChange: this.handleSearch,
      value: search,
      placeholder: this.intlMsg.msg('logs.search.placeholder')
    })];
    var header = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: "clerfix" },
      this.intlMsg.msg('logs.header'),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: "pull-right " + __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.gray },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_Refresher__["a" /* default */], {
          onReload: function onReload() {
            return _this3.handleReload();
          },
          reloading: status === 'pending'
        })
      )
    );
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Panel"],
      {
        bsStyle: "aisz-white",
        header: header
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_PanelToolbar__["a" /* default */], { tools: tools }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Table"],
        {
          className: "aisz-table-light",
          bordered: true,
          responsive: true
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('logs.time')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('logs.gateway')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('logs.address')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('logs.port')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('logs.encoding')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('logs.data')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('addrlist.fcntdown')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "tbody",
          null,
          rows
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_15_loracoms_ShowIf__["a" /* default */],
        { "if": list.length === 0 },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.noData },
          this.intlMsg.msg('addrlist.nodata')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: "pull-right" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_TablePager__["a" /* default */], {
          status: status,
          mark: mark,
          more: more,
          onPrev: this.handleChangeMark,
          onNext: this.handleChangeMark,
          reset: reset
        })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__GatewayList__["a" /* default */], {
        showModal: showModal,
        list: gateways,
        onHide: function onHide() {
          return _this3.setState({ showModal: false });
        },
        fail: failGateway
      })
    );
  };

  return Logs;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Logs.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(null, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(Logs)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_SelectPills__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lorautils_checkers_numbers__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__AddGateway__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss__ = __webpack_require__(2183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);


















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired
};

var EncodingOptions = [{
  name: 'HEX',
  value: 'hex',
  active: true
}, {
  name: 'TEXT',
  value: 'text'
}];

var SendBroadcast = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(SendBroadcast, _React$Component);

  function SendBroadcast(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SendBroadcast);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      showDeleteModal: false,
      encoding: 'hex',
      gateway: [],
      errors: new __WEBPACK_IMPORTED_MODULE_13_lorautils_errors_ErrorSet__["a" /* default */]().add('FE_EMPTY', 'port').add('FE_EMPTY', 'data').add('FE_EMPTY', 'devaddr')
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_14_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.broadcast');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }

  SendBroadcast.prototype.checkPort = function checkPort(port) {
    var errors = this.state.errors;


    if (_.isNil(port) || port === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'port') });
      return false;
    }

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lorautils_checkers_numbers__["b" /* isInteger */])(port, { min: 1, max: 223 })) {
      this.setState({ errors: errors.add('FE_INVALIDPORT', 'port') });
      return false;
    }

    this.setState({ errors: errors.remove('port') });
    return true;
  };

  SendBroadcast.prototype.checkData = function checkData(data, encoding) {
    var errors = this.state.errors;


    if (_.isNil(data) || data === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'data') });
      return false;
    }

    if (encoding === 'hex') {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lorautils_checkers_numbers__["c" /* isHexString */])(data, { pair: true })) {
        this.setState({ errors: errors.add('FE_INVALIDHEX', 'data') });
        return false;
      }
    }

    this.setState({ errors: errors.remove('data') });
    return true;
  };

  SendBroadcast.prototype.handleChangePort = function handleChangePort(e) {
    var port = e.target.value.trim();
    this.setState({ port: port });
    this.checkPort(port);
  };

  SendBroadcast.prototype.handleChangeEncoding = function handleChangeEncoding(encoding) {
    this.setState({ encoding: encoding });

    var data = this.state.data;

    this.checkData(data, encoding);
  };

  SendBroadcast.prototype.handleChangeData = function handleChangeData(e) {
    var data = e.target.value;
    this.setState({ data: data });

    var encoding = this.state.encoding;

    this.checkData(data, encoding);
  };

  SendBroadcast.prototype.handleChangeDevaddr = function handleChangeDevaddr(e) {
    var errors = this.state.errors;

    var devaddr = _.trim(e.target.value);
    devaddr = devaddr.replace(/:|-/g, '');
    if (devaddr.length === 0) {
      this.setState({ errors: errors.add('FE_EMPTY', 'devaddr') });
    } else {
      this.setState({ errors: errors.remove('devaddr') });
    }
    this.setState({ devaddr: devaddr });
  };

  SendBroadcast.prototype.handleOnChgGateway = function handleOnChgGateway(gateway) {
    var gatewayLabels = '';
    if (gateway.length) {
      gatewayLabels = gateway.length === 1 ? gateway[0].id : gateway[0].id + "...";
    }
    this.setState({ gateway: gateway, showModal: false, gatewayLabels: gatewayLabels });
  };

  SendBroadcast.prototype.handleSubmit = function handleSubmit(e) {
    var _this2 = this;

    e.preventDefault();
    var _state = this.state,
        data = _state.data,
        devaddr = _state.devaddr,
        port = _state.port,
        gateway = _state.gateway,
        encoding = _state.encoding;
    var errors = this.state.errors;

    this.setState({ submitted: true });
    errors = errors.remove('submit');
    if (!errors.isEmpty()) {
      return;
    }
    this.setState({ sentStatus: 'pending' });
    var gws = _.map(gateway, function (gw) {
      return gw.id;
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__api_callAPI__["a" /* default */])({
      endpoint: "/lora/apps/" + this.props.appId + "/broadcastmsgs",
      method: 'POST',
      body: {
        devaddr: devaddr,
        gateways: gws,
        data: data,
        encoding: encoding,
        fport: Number(port)
      }
    }).then(function () {
      _this2.setState({ sentStatus: 'success' });
    }).catch(function (err) {
      _this2.setState({ sentStatus: 'failure', errors: errors.add(err.code, 'submit') });
    });
  };

  SendBroadcast.prototype.render = function render() {
    var _this3 = this;

    var _state2 = this.state,
        _state2$port = _state2.port,
        port = _state2$port === undefined ? '' : _state2$port,
        _state2$data = _state2.data,
        data = _state2$data === undefined ? '' : _state2$data,
        _state2$devaddr = _state2.devaddr,
        devaddr = _state2$devaddr === undefined ? '' : _state2$devaddr,
        _state2$submitted = _state2.submitted,
        submitted = _state2$submitted === undefined ? false : _state2$submitted,
        errors = _state2.errors,
        encoding = _state2.encoding,
        _state2$showModal = _state2.showModal,
        showModal = _state2$showModal === undefined ? false : _state2$showModal,
        _state2$sentStatus = _state2.sentStatus,
        sentStatus = _state2$sentStatus === undefined ? '' : _state2$sentStatus,
        _state2$gateway = _state2.gateway,
        gateway = _state2$gateway === undefined ? [] : _state2$gateway,
        _state2$gatewayLabels = _state2.gatewayLabels,
        gatewayLabels = _state2$gatewayLabels === undefined ? '' : _state2$gatewayLabels;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.fullHeight },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
        {
          bsStyle: "aisz-white",
          className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.fullHeight + " " + __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.noMgnB,
          header: this.intlMsg.msg('send.header')
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Form"],
          {
            horizontal: true,
            onSubmit: this.handleSubmit
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                this.intlMsg.msg('send.addr')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormControl"], {
                value: devaddr,
                bsClass: "aisz-form-control-f",
                placeholder: this.intlMsg.msg('send.addr.placeholder'),
                onChange: function onChange(e) {
                  return _this3.handleChangeDevaddr(e);
                }
              }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
                show: errors.has('devaddr') && submitted,
                message: this.intlMsg.errorMsg(errors.get('devaddr')),
                azStyle: "danger",
                placement: "right"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                this.intlMsg.msg('send.port')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormControl"], {
                value: port,
                bsClass: "aisz-form-control-f",
                placeholder: this.intlMsg.msg('send.port.placeholder'),
                onChange: function onChange(e) {
                  return _this3.handleChangePort(e);
                }
              }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
                show: errors.has('port') && submitted,
                message: this.intlMsg.errorMsg(errors.get('port')),
                azStyle: "danger",
                placement: "right"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                this.intlMsg.msg('send.encoding')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_SelectPills__["a" /* default */], {
                options: EncodingOptions,
                value: encoding,
                onChange: function onChange(selected) {
                  return _this3.handleChangeEncoding(selected[0]);
                }
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                this.intlMsg.msg('send.data')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormControl"], {
                value: data,
                bsClass: "aisz-form-control-f",
                placeholder: "Hex",
                onChange: function onChange(e) {
                  return _this3.handleChangeData(e);
                }
              }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
                show: errors.has('data') && submitted,
                message: this.intlMsg.errorMsg(errors.get('data')),
                azStyle: "danger",
                placement: "right"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                this.intlMsg.msg('send.gateway')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormControl"], {
                value: gatewayLabels,
                bsClass: "aisz-form-control-f",
                className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.black,
                disabled: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                {
                  className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.add,
                  onClick: function onClick() {
                    return _this3.setState({ showModal: true });
                  }
                },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicon glyphicon-plus" })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: 9, mdOffset: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_RichButton__["a" /* default */], {
                status: sentStatus,
                states: [{
                  status: 'default',
                  label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "span",
                    null,
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-send" }),
                    ' ',
                    this.intlMsg.msg('send')
                  ),
                  type: 'submit'
                }, {
                  status: 'pending',
                  style: 'info',
                  label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "span",
                    null,
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" }),
                    ' ',
                    this.intlMsg.msg('sending')
                  )
                }, {
                  status: 'success',
                  style: 'success',
                  label: this.intlMsg.msg('sendsuccess'),
                  timer: function timer() {
                    return _this3.setState({ sentStatus: '' });
                  }
                }, {
                  status: 'failure',
                  style: 'danger',
                  label: this.intlMsg.msg('sendfailure'),
                  timer: function timer() {
                    return _this3.setState({ sentStatus: '' });
                  }
                }]
              }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_12_loracoms_ShowIf__["a" /* default */],
                { "if": sentStatus === 'failure' },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "span",
                  { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.err },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-exclamation-circle" }),
                  "\xA0",
                  this.intlMsg.errorMsg(errors.get('submit'))
                )
              )
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__AddGateway__["a" /* default */], {
        showModal: showModal,
        onHide: function onHide() {
          return _this3.setState({ showModal: false });
        },
        onSuccess: function onSuccess(gw) {
          return _this3.handleOnChgGateway(gw);
        },
        checked: gateway
      })
    );
  };

  return SendBroadcast;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

SendBroadcast.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(null, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(SendBroadcast)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_PageLoading__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_PageNoPerm__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__coms_SendBroadcast__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__coms_AddrList__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__coms_Logs__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_scss__ = __webpack_require__(2184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  app: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  plan: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired
};

var BroadcastView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(BroadcastView, _React$Component);

  function BroadcastView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, BroadcastView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      app: props.app,
      plan: props.plan
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.broadcast');
    return _this;
  }

  BroadcastView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var app = nextProps.app,
        plan = nextProps.plan;

    this.setState({ app: app });
    if (!_.isEqual(plan, this.props.plan)) {
      this.setState({ plan: plan });
    }
  };

  BroadcastView.prototype.render = function render() {
    var _this2 = this;

    var appId = this.props.appId;
    var _state = this.state,
        app = _state.app,
        _state$plan = _state.plan,
        _state$plan$data = _state$plan.data;
    _state$plan$data = _state$plan$data === undefined ? {} : _state$plan$data;
    var tier = _state$plan$data.tier,
        status = _state$plan.status;
    var _app$data = app.data,
        data = _app$data === undefined ? {} : _app$data;


    var breadcrumb = [{
      onClick: function onClick() {
        return _this2.props.pushState('/application');
      },
      content: this.intlMsg.msg('breadcrumb.application', 'application')
    }, {
      content: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Nvl__["a" /* default */], { val: data.name, status: app.status }),
      active: true
    }];

    if (status === 'pending') {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_PageLoading__["a" /* default */], null);
    }
    if (tier === 1) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_PageNoPerm__["a" /* default */], null);
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Grid"],
        { fluid: true },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
          { className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.container },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__coms_SendBroadcast__["a" /* default */], { appId: appId })
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
            { md: 8 },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__coms_AddrList__["a" /* default */], { appId: appId })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__coms_Logs__["a" /* default */], { appId: appId })
          )
        )
      )
    );
  };

  return BroadcastView;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

BroadcastView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    app: state.app.getApp,
    plan: state.billing.plan,
    appId: ownProps.params.id
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(BroadcastView)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_DeleteModal__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DeviceMap__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss__ = __webpack_require__(2185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

















var BoardList = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(BoardList, _React$Component);

  function BoardList(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, BoardList);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      animation: false,
      boards: props.boards,
      showModal: false
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.dashboard');
    _this.confirmDelete = _this.confirmDelete.bind(_this);
    return _this;
  }

  BoardList.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var boards = nextProps.boards;

    if (boards !== this.props.boards) {
      this.setState({ boards: boards });
      _.delay(function () {
        _this2.setState({ animation: true });
      }, 10);
    }
  };

  BoardList.prototype.handleShowModal = function handleShowModal(e, id) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ deleteId: id, showModal: true });
  };

  BoardList.prototype.confirmDelete = function confirmDelete() {
    var _this3 = this;

    var _state = this.state,
        deleteId = _state.deleteId,
        boards = _state.boards;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__api_callAPI__["a" /* default */])({ endpoint: "/lora/dashboards/" + deleteId, method: 'DELETE' }).then(function () {
      _this3.setState({
        boards: _.filter(boards, function (item) {
          return item.id !== deleteId;
        }),
        showModal: false
      });
    }).catch(function () {});
  };

  BoardList.prototype.render = function render() {
    var _this4 = this;

    var _props = this.props,
        pushState = _props.pushState,
        appId = _props.appId;
    var _state2 = this.state,
        boards = _state2.boards,
        animation = _state2.animation,
        showModal = _state2.showModal;

    var innerWidth = window.innerWidth;
    var containerHeight = Math.ceil(boards.length / 3) * 280;
    var boardItems = boards.map(function (item, index) {
      var style = {};
      var xF = innerWidth > 768 ? Math.floor(index % 3) * 100 : 0;
      var yF = innerWidth > 768 ? Math.floor(index / 3) * 100 : index * 100;
      var icons = void 0;
      var iconLength = void 0;
      var width = innerWidth > 768 ? '33.33%' : '100%';
      if (animation) {
        style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, style, { transform: "translate(" + xF + "%," + yF + "%)", width: width, height: '280px' });
        iconLength = JSON.parse(item.ext).charts.length;
        if (iconLength > 6) {
          iconLength = 6;
        }
        icons = _.map(new Array(iconLength), function (val, idx) {
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "span",
            { key: idx },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", { styleName: "icon" + _.random(1, 8), alt: "" })
          );
        });
      }
      var info = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        {
          styleName: "db-info"
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "p",
          null,
          item.name
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "p",
          { styleName: "gray" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "span",
            { styleName: "font-sm" },
            __WEBPACK_IMPORTED_MODULE_12_date_fns_format___default()(item.createdAt, 'YYYY-MM-DD')
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "span",
            { className: "pull-right" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["f" /* Link */], {
              className: "fa fa-trash-o",
              styleName: "delete",
              onClick: function onClick(e) {
                return _this4.handleShowModal(e, item.id);
              }
            })
          )
        )
      );
      if (item.type === 'SINGLE') {
        if (iconLength === 1) {
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { // eslint-disable-line
              styleName: "boardItem",
              key: item.id,
              onClick: function onClick() {
                return pushState("/application/" + appId + "/dashboard/basic/" + item.id);
              },
              style: style
            },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { styleName: "border" },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                {
                  styleName: "db-preview",
                  className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.previewone
                },
                icons
              ),
              info
            )
          );
        } else if (iconLength === 2) {
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { // eslint-disable-line
              styleName: "boardItem",
              key: item.id,
              onClick: function onClick() {
                return pushState("/application/" + appId + "/dashboard/basic/" + item.id);
              },
              style: style
            },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { styleName: "border" },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                {
                  styleName: "db-preview",
                  className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.previewtwo
                },
                icons
              ),
              info
            )
          );
        } else if (iconLength > 2) {
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { // eslint-disable-line
              styleName: "boardItem",
              key: item.id,
              onClick: function onClick() {
                return pushState("/application/" + appId + "/dashboard/basic/" + item.id);
              },
              style: style
            },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { styleName: "border" },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                {
                  styleName: "db-preview",
                  className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.previewmore
                },
                icons
              ),
              info
            )
          );
        }
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { // eslint-disable-line
          styleName: "boardItem",
          key: item.id,
          style: style,
          onClick: function onClick() {
            return pushState("/application/" + appId + "/dashboard/map/" + item.id);
          }
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { styleName: "border" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            {
              styleName: "db-preview no-padding"
            },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__DeviceMap__["a" /* default */], { appId: appId, type: "preview", dashId: item.id })
          ),
          info
        )
      );
    });

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Grid"],
      { fluid: true, style: { height: containerHeight + "px" } },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Row"],
        { styleName: "itemLayout", className: "clearfix" },
        boardItems
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_DeleteModal__["a" /* default */], {
        showModal: showModal,
        onConfirm: this.confirmDelete,
        onCancel: function onCancel() {
          return _this4.setState({ showModal: false });
        },
        headerText: this.intlMsg.msg('delete.dashboard'),
        text: this.intlMsg.msg('delete.confirm')
      }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_15_loracoms_ShowIf__["a" /* default */],
        { "if": boards.length === 0 },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.nodashboard },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "h3",
            null,
            this.intlMsg.msg('nodashboard')
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.desc },
            this.intlMsg.msg('nodashboard.desc')
          )
        )
      )
    );
  };

  return BoardList;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_10_react_router_redux__["routerActions"].push
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  boards: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array.isRequired
};

BoardList.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_7_react_css_modules___default()(BoardList, __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a, { allowMultiple: true }))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loraactions_app__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loraactions_dashboard__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Chart__ = __webpack_require__(614);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);














var propTypes = {
  pushState: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  getDashboard: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  getApp: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  appState: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  dashboardState: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  dps: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  dashId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired
};

var ChartDetail = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ChartDetail, _React$Component);

  function ChartDetail(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ChartDetail);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      appState: props.appState,
      dashboardState: props.dashboardState,
      dps: props.dps,
      dpsNew: []
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.dashboard');
    return _this;
  }

  ChartDetail.prototype.componentWillMount = function componentWillMount() {
    var _state = this.state,
        data = _state.dashboardState.data,
        appState = _state.appState,
        dps = _state.dps;

    var dpsNew = _.split(dps, ',');
    this.setState({ dps: dpsNew });
    var _props = this.props,
        getDashboard = _props.getDashboard,
        dashId = _props.dashId,
        appId = _props.appId,
        getApp = _props.getApp;

    if (!data) {
      getDashboard(dashId);
    }
    if (!appState.data) {
      getApp(appId);
    }
  };

  ChartDetail.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var appState = nextProps.appState,
        dashboardState = nextProps.dashboardState;

    if (appState !== this.props.appState) {
      this.setState({ appState: appState });
    }
    if (dashboardState !== this.props.dashboardState) {
      this.setState({ dashboardState: dashboardState });
    }
  };

  ChartDetail.prototype.render = function render() {
    var _props2 = this.props,
        pushState = _props2.pushState,
        dashId = _props2.dashId,
        appId = _props2.appId;
    var _state2 = this.state,
        _state2$appState = _state2.appState,
        status = _state2$appState.status,
        data = _state2$appState.data,
        dashboardState = _state2.dashboardState,
        dps = _state2.dps;

    var dpsNew = [];
    if (_.isArray(dps)) {
      dpsNew = dps;
    } else {
      dpsNew = [dps];
    }
    if (dashboardState.data && data) {
      var breadcrumb = [{
        content: this.intlMsg.globalMsg('application.breadcrumb.application'),
        onClick: function onClick() {
          return pushState('/application');
        }
      }, {
        content: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Nvl__["a" /* default */], { status: status, val: data.name }),
        onClick: function onClick() {
          return pushState("/application/" + data.id);
        }
      }, {
        content: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Nvl__["a" /* default */], {
          status: dashboardState.status,
          val: dashboardState.data.name.length === 0 ? dashboardState.data.id : dashboardState.data.name
        }),
        onClick: function onClick() {
          return pushState("/application/" + data.id + "/dashboard/basic/" + dashboardState.data.id);
        }
      }];
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Grid"],
        { fluid: true },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Chart__["a" /* default */], {
          dps: dpsNew,
          dpsShow: [{ data: dpsNew }]
          // gridTop={30}
          , dashId: dashId,
          appId: appId
        })
      );
    }
    return null;
  };

  return ChartDetail;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    appState: state.app.getApp,
    time: state.dashboard.getTimes,
    dashboardState: state.dashboard.getDashboard,
    dps: ownProps.params.dps,
    dashId: ownProps.params.dashid,
    appId: ownProps.params.id
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["routerActions"].push,
  getDashboard: __WEBPACK_IMPORTED_MODULE_13_loraactions_dashboard__["a" /* default */].getDashboard,
  getApp: __WEBPACK_IMPORTED_MODULE_12_loraactions_app__["a" /* default */].getApp
};

ChartDetail.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(ChartDetail)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loraactions_dashboard__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Chart__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_scss__ = __webpack_require__(2187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_scss__);






/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);












var propTypes = {
  appState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired,
  dashboardState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
  getDeveui: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
  dashId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  onDeleteSuc: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
};

var defaultProps = {
  reset: 0
};

var Charts = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Charts, _React$Component);

  function Charts(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Charts);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      animation: false,
      appState: props.appState,
      ext: { charts: [] },
      status: 'pending',
      dashboardState: props.dashboardState
    };
    return _this;
  }

  Charts.prototype.componentWillMount = function componentWillMount() {
    this.loadDetail();
  };

  Charts.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var appState = nextProps.appState,
        dashboardState = nextProps.dashboardState,
        reset = nextProps.reset;

    if (appState !== this.props.appState) {
      this.setState({ appState: appState });
    }
    if (dashboardState !== this.props.dashboardState) {
      this.setState({ dashboardState: dashboardState });
    }
    if (reset !== this.props.reset) {
      this.loadDetail();
    }
  };

  Charts.prototype.loadDetail = function loadDetail() {
    var _this2 = this;

    var _props = this.props,
        dashId = _props.dashId,
        getDeveui = _props.getDeveui;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__api_callAPI__["a" /* default */])({ endpoint: "/lora/dashboards/" + dashId, method: 'get' }).then(function (res) {
      var ext = JSON.parse(res.ext);
      _this2.setState({ ext: ext });
      getDeveui(ext.deveui);
      _.delay(function () {
        _this2.setState({ animation: true });
      }, 10);
    }).catch(function () {});
  };

  Charts.prototype.handleDeleteDps = function handleDeleteDps(e, dps) {
    var _this3 = this;

    e.stopPropagation();
    e.preventDefault();
    var id = this.state.dashboardState.data.id;
    var ext = this.state.ext;

    var charts = _.filter(ext.charts, function (item) {
      return item.type !== dps;
    });
    ext = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, ext, { charts: charts });
    var param = {
      endpoint: "/lora/dashboards/" + id,
      method: 'PUT',
      body: {
        ext: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(ext)
      }
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__api_callAPI__["a" /* default */])(param).then(function () {
      _this3.setState({ ext: ext });
      _this3.props.onDeleteSuc(ext, dps);
    }).catch(function () {});
  };

  Charts.prototype.render = function render() {
    var _this4 = this;

    var _state = this.state,
        animation = _state.animation,
        data = _state.appState.data,
        ext = _state.ext;

    if (ext.charts.length === 0 && !data) {
      return null;
    }
    var _props2 = this.props,
        pushState = _props2.pushState,
        dashId = _props2.dashId;

    var height = Math.ceil(ext.charts.length / 3) * 260;
    var innerWidth = window.innerWidth;
    var charts = ext.charts.map(function (item, index) {
      var style = {};
      var xF = innerWidth > 768 ? Math.floor(index % 3) * 100 : 0;
      var yF = innerWidth > 768 ? Math.floor(index / 3) * 100 : index * 100;
      var width = innerWidth > 768 ? '33.33%' : '100%';
      var dpsType = void 0;
      if (_.isArray(item.type)) {
        dpsType = item.type;
      } else {
        dpsType = [item.type];
      }
      var dpsShow = dpsType;
      if (dpsType.length > 3) {
        dpsShow = [];
        _.times(3, function (n) {
          dpsShow.push(dpsType[n]);
        });
      }
      // let gridTop = 0;
      // _.map(dpsTypeShow, () => {
      //   const dataShow = [];
      //   let n = 0;
      //   if (dpsTypeShow.length > 3) {
      //     n = 3;
      //     _.times(n, () => {
      //       dataShow.push(dpsTypeShow[0]);
      //       dpsTypeShow = _.filter(dpsTypeShow, t => (t !== dpsTypeShow[0]));
      //     });
      //   } else {
      //     n = dpsTypeShow.length;
      //     _.times(n, () => {
      //       dataShow.push(dpsTypeShow[0]);
      //       dpsTypeShow = _.filter(dpsTypeShow, t => (t !== dpsTypeShow[0]));
      //     });
      //   }
      //   dpsShow.push({ data: dataShow });
      // });
      // if (dpsShow.length !== 1) {
      //   _.times(dpsShow.length, (p) => {
      //     const topVal = p * 10;
      //     dpsShow[p].top = _.concat(topVal, '%').join('');
      //   });
      //   const topgrid = ((_.ceil(dpsShow.length / 3) - 2) * 10) + 25;
      //   gridTop = _.concat(topgrid, '%').join('');
      // } else {
      //   gridTop = 30;
      // }
      if (animation) {
        style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, style, { transform: "translate(" + xF + "%," + yF + "%)", width: width, height: '260px' });
      }
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_react_router__["f" /* Link */],
        {
          key: item.type + "-" + String(index),
          className: "clearfix",
          styleName: "boardItem",
          style: style,
          onClick: function onClick() {
            return pushState("/application/" + data.id + "/dashboard/" + dashId + "/" + item.type);
          }
        },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "p",
          { className: "clearfix", styleName: "chart-title" },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("span", { // eslint-disable-line
            className: "fa fa-trash-o pull-right",
            styleName: "delete",
            onClick: function onClick(e) {
              return _this4.handleDeleteDps(e, item.type);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Chart__["a" /* default */], {
          dps: dpsType,
          dpsShow: [{ data: dpsShow }]
          // gridTop={30}
          , showPanel: false,
          dashId: dashId,
          appId: data.id
        })
      );
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      "div",
      { styleName: "itemLayout", style: { height: height + "px" } },
      charts
    );
  };

  return Charts;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Charts.propTypes = propTypes;
Charts.defaultProps = defaultProps;

var mapStateToProps = function mapStateToProps(state) {
  return {
    appState: state.app.getApp,
    dashboardState: state.dashboard.getDashboard
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_10_react_router_redux__["routerActions"].push,
  getDeveui: __WEBPACK_IMPORTED_MODULE_12_loraactions_dashboard__["a" /* default */].getDeveui
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_8_react_css_modules___default()(Charts, __WEBPACK_IMPORTED_MODULE_15__styles_scss___default.a, { allowMultiple: true })));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_zip__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_zip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_zip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_map__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_green_svg__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_green_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_green_svg__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);












var defaultProps = {
  onZoom: function onZoom() {},
  onDrag: function onDrag() {}
};

var propTypes = {
  devices: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array.isRequired,
  dashId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any.isRequired,
  onZoom: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onDrag: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};

var MapMask = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(MapMask, _React$Component);

  function MapMask(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MapMask);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.markers = [];
    _this.listeners = [];
    _this.devices = props.devices;
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.map');
    return _this;
  }

  MapMask.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var tries = 0;
    var init = function init() {
      try {
        _this2.initMap();
        _this2.updateData();
      } catch (e) {
        if (tries < 10) {
          tries += 1;
          setTimeout(init, 1000);
        }
      }
    };
    init();
  };

  MapMask.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var devices = nextProps.devices;

    if (devices !== this.props.devices) {
      this.devices = devices;
      if (this.map) {
        this.map.clearOverlays();
        this.updateData();
      }
    }
  };

  MapMask.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_8_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_7_lodash_zip___default()(this.markers, this.listeners), function (_ref) {
      var marker = _ref[0],
          listener = _ref[1];

      marker.removeEventListener('click', listener);
    });
    $('#devicemap').empty();
  };

  MapMask.prototype.initMap = function initMap() {
    var _this3 = this;

    this.map = new BMap.Map(this.props.dashId);
    this.map.setMapStyle({ features: [] });
    this.map.setMaxZoom(16);
    this.map.setMinZoom(2);
    this.map.enableScrollWheelZoom();
    this.map.removeControl(this.navControl);
    this.map.removeControl(this.scaleControl);
    // eslint-disable-next-line
    this.navControl = new BMap.NavigationControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });
    // eslint-disable-next-line
    this.scaleControl = new BMap.ScaleControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });

    this.map.addControl(this.navControl);
    this.map.addControl(this.scaleControl);
    this.map.addEventListener('zoomend', function () {
      return _this3.props.onZoom(_this3.map);
    });
    this.map.addEventListener('dragend', function () {
      return _this3.props.onDrag(_this3.map);
    });
  };

  MapMask.prototype.updateData = function updateData() {
    var _this4 = this;

    this.devices = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lorautils_map__["e" /* transform */])(this.devices);
    this.devices.forEach(function (obj) {
      _this4.addMarker(obj);
    });

    var points = this.devices.map(function (x) {
      return x.point;
    });
    if (points.length === 1) {
      this.map.centerAndZoom(points[0], 16);
    } else if (points.length > 0) {
      // decide max span with at most 100 points
      var _getCenterAndZoom = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lorautils_map__["a" /* getCenterAndZoom */])(points.slice(0, 100)),
          center = _getCenterAndZoom[0],
          zoom = _getCenterAndZoom[1];

      this.map.centerAndZoom(center, zoom);
    } else {
      this.map.centerAndZoom('深圳', 1);
    }
  };

  MapMask.prototype.addMarker = function addMarker(item) {
    var icon = new BMap.Icon(__WEBPACK_IMPORTED_MODULE_12__images_green_svg___default.a, new BMap.Size(20, 20));
    var marker = new BMap.Marker(item.point, { icon: icon });
    this.map.addOverlay(marker);
    this.markers.push(marker);
  };

  MapMask.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", { id: this.props.dashId, style: { height: '100%', width: '100%' } });
  };

  return MapMask;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

MapMask.defaultProps = defaultProps;
MapMask.propTypes = propTypes;

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"])(MapMask)));

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loraactions_dashboard__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DetailHeader__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__TimeSelect__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DvcssModal__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__EditName__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__RefreshBtn__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__DeviceMap__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__DpsModal__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_scss__ = __webpack_require__(2190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__styles_scss__);





/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




















var kLoops = 100;
var kInterval = 6;

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  dashId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
  dashboardData: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  appState: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
  getDashboard: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  getDps: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  getDeveui: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  getRefreshCount: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired
};

var SingleDetail = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SingleDetail, _React$Component);

  function SingleDetail(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SingleDetail);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      dashboardData: props.dashboardData,
      appState: props.appState,
      checkedId: []
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.dashboard');
    _this.handleOperation = _this.handleOperation.bind(_this);
    _this.handleOnConfirmDps = _this.handleOnConfirmDps.bind(_this);
    _this.handleRefresh = _this.handleRefresh.bind(_this);
    _this.refresh = 0;
    return _this;
  }

  SingleDetail.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        dashId = _props.dashId,
        getDashboard = _props.getDashboard;

    getDashboard(dashId);
  };

  SingleDetail.prototype.componentDidMount = function componentDidMount() {
    this.calMapHeight();
  };

  SingleDetail.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var dashboardData = nextProps.dashboardData,
        appState = nextProps.appState;

    if (dashboardData !== this.props.dashboardData) {
      var status = dashboardData.status,
          data = dashboardData.data;

      if (status === 'success' && data) {
        this.handleData(dashboardData);
      }
    }
    if (appState !== this.props.appState) {
      this.setState({ appState: appState });
    }
  };

  SingleDetail.prototype.componentWillUnmount = function componentWillUnmount() {
    this.refresh = 0;
  };

  SingleDetail.prototype.calMapHeight = function calMapHeight() {
    var _this2 = this;

    var timer = 0;
    var mapHeight = void 0;
    if (timer < 5 && !mapHeight) {
      if (this.container) {
        mapHeight = window.innerHeight - this.container.offsetHeight - 100;
        this.setState({ mapHeight: mapHeight });
      } else {
        timer += 1;
        setTimeout(function () {
          _this2.calMapHeight();
        }, 1000);
      }
    }
  };

  SingleDetail.prototype.handleData = function handleData(dashboardData) {
    var _this3 = this;

    var ext = dashboardData.data.ext;

    var checkedIds = JSON.parse(ext).deveui;
    this.setState({
      checkedIds: checkedIds,
      dps: _.map(JSON.parse(ext).charts, function (item) {
        return item.type;
      }),
      dashboardData: dashboardData
    }, function () {
      _this3.props.getDps(_this3.state.dps);
    });
  };

  SingleDetail.prototype.handleOperation = function handleOperation() {
    var d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var deveui = arguments[1];
    var _props2 = this.props,
        dashId = _props2.dashId,
        getDeveui = _props2.getDeveui;
    var ext = this.state.dashboardData.data.ext;

    ext = JSON.parse(ext);
    ext = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, ext, { deveui: deveui });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__api_callAPI__["a" /* default */])({
      endpoint: "/lora/dashboards/" + dashId,
      method: 'PUT',
      body: { ext: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ext) }
    }).then(function () {}).catch(function () {});
    getDeveui(deveui);
    this.setState({ checkedIds: deveui });
  };

  SingleDetail.prototype.handleOnConfirmDps = function handleOnConfirmDps(dps) {
    var checkedIds = this.state.checkedIds;
    var ext = this.state.dashboardData.data.ext;

    ext = JSON.parse(ext);
    var dpsNew = _.split(dps, ',');
    dpsNew = _.filter(dpsNew, function (dp) {
      return dp !== '';
    });
    var charts = _.map(dpsNew, function (item) {
      return { type: item };
    });
    charts = _.concat(ext.charts, charts);
    ext = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, ext, { deveui: checkedIds, charts: charts });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__api_callAPI__["a" /* default */])({
      endpoint: "/lora/dashboards/" + this.props.dashId,
      method: 'PUT',
      body: { ext: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ext) }
    }).then(function () {}).catch(function () {});
    this.setState({ showDpsModal: false, reset: new Date() });
    dpsNew = _.concat(this.state.dps, dpsNew);
    dpsNew = _.uniq(dpsNew);
    this.props.getDps(dpsNew);
  };

  SingleDetail.prototype.handleRefresh = function handleRefresh() {
    var _this4 = this;

    if (this.refresh === kLoops + 1) {
      this.refresh = 0;
      this.setState({ selectDisabled: false });
    } else {
      this.props.getRefreshCount(this.refresh);
      this.setState({ isRefreshing: true });
      this.refresh += 1;
      _.delay(function () {
        _this4.setState({ isRefreshing: false });
      }, 1000);
      this.setState({ selectDisabled: true });
    }
  };

  SingleDetail.prototype.handleOneClick = function handleOneClick() {
    this.refresh = 0;
    this.setState({ selectDisabled: false });
  };

  SingleDetail.prototype.handleOnHideDps = function handleOnHideDps() {
    this.setState({ showDpsModal: false });
  };

  SingleDetail.prototype.render = function render() {
    var _this5 = this;

    var _props3 = this.props,
        appId = _props3.appId,
        dashId = _props3.dashId;
    var _state = this.state,
        data = _state.dashboardData.data,
        _state$showDpsModal = _state.showDpsModal,
        showDpsModal = _state$showDpsModal === undefined ? false : _state$showDpsModal,
        _state$showDeviceModa = _state.showDeviceModal,
        showDeviceModal = _state$showDeviceModa === undefined ? false : _state$showDeviceModa,
        _state$isRefreshing = _state.isRefreshing,
        isRefreshing = _state$isRefreshing === undefined ? false : _state$isRefreshing,
        _state$checkedIds = _state.checkedIds,
        checkedIds = _state$checkedIds === undefined ? [] : _state$checkedIds,
        mapHeight = _state.mapHeight;
    // let { dps } = this.state;

    if (!data) {
      return null;
    }
    // dps = dps || _.map(JSON.parse(data.ext).charts, item => item.type);
    var header = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      { className: "clearfix " + __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.leftTool },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "span",
        { className: "pull-left" },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__EditName__["a" /* default */], { name: data.name, dashId: dashId })
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { className: "pull-right" },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-success-b",
            className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.marginRm,
            onClick: function onClick() {
              return _this5.setState({ showDpsModal: true });
            }
          },
          this.intlMsg.msg('add.dpschart')
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-primary-b",
            onClick: function onClick() {
              return _this5.setState({ showDeviceModal: true });
            }
          },
          this.intlMsg.msg('adddevice')
        )
      )
    );

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      { ref: function ref(input) {
          _this5.container = input;
        } },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__DetailHeader__["a" /* default */], { dash: data }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Grid"],
        { fluid: true },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Panel"],
            { bsStyle: "aisz-white", header: header, styleName: "add-panel" },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Row"],
              null,
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Col"],
                { md: 11 },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  "span",
                  { className: "pull-left" },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__TimeSelect__["a" /* default */], null)
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Col"],
                { md: 1, className: "text-right", styleName: "refresh" },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__RefreshBtn__["a" /* default */], {
                  loops: kLoops,
                  interval: kInterval,
                  reloading: isRefreshing,
                  onReload: this.handleRefresh,
                  onOneClick: function onOneClick() {
                    return _this5.handleOneClick();
                  }
                })
              )
            )
          ),
          mapHeight && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            { style: { height: mapHeight } },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__DeviceMap__["a" /* default */], { appId: appId, type: "detail", dashId: dashId })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__DpsModal__["a" /* default */], {
          showModal: showDpsModal
          // dps={dps}
          , appId: appId,
          onConfirm: this.handleOnConfirmDps,
          onHide: function onHide() {
            return _this5.handleOnHideDps();
          }
        }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__DvcssModal__["a" /* default */], {
          appId: appId,
          showModal: showDeviceModal,
          onChoose: this.handleOperation,
          onHide: function onHide() {
            return _this5.setState({ showDeviceModal: false });
          },
          checkedIds: checkedIds
        })
      )
    );
  };

  return SingleDetail;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    appState: state.app.getApp,
    dashId: ownProps.params.dashid,
    appId: ownProps.params.id,
    dashboardData: state.dashboard.getDashboard,
    time: state.dashboard.getTimes
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["routerActions"].push,
  getDashboard: __WEBPACK_IMPORTED_MODULE_13_loraactions_dashboard__["a" /* default */].getDashboard,
  getDps: __WEBPACK_IMPORTED_MODULE_13_loraactions_dashboard__["a" /* default */].getDps,
  getDeveui: __WEBPACK_IMPORTED_MODULE_13_loraactions_dashboard__["a" /* default */].getDeveui,
  getRefreshCount: __WEBPACK_IMPORTED_MODULE_13_loraactions_dashboard__["a" /* default */].getRefreshCount
};

SingleDetail.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_7_react_css_modules___default()(SingleDetail, __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_echarts__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_zip__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_zip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_zip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loraactions_dashboard__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loraimages_chart_loading_gif__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loraimages_chart_loading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_loraimages_chart_loading_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lorautils_map__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_green_svg__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_green_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__images_green_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__style_scss__ = __webpack_require__(2191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__style_scss__);





/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



















var defaultProps = {
  onZoom: function onZoom() {},
  onDrag: function onDrag() {}
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  time: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  devices: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array.isRequired,
  dps: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
  dashId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  getDeveui: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  refreshState: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number.isRequired,
  onZoom: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDrag: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};

var kOption = {
  tooltip: {
    trigger: 'axis',
    formatter: '{b} <br/>{a} : {c}'
  },
  xAxis: {
    type: 'category',
    name: 'x',
    splitLine: { show: false }
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  },
  yAxis: {
    type: 'value',
    name: 'y'
  },
  series: [],
  color: ['#1BBC9B']
};

var MultipleMap = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MultipleMap, _React$Component);

  function MultipleMap(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MultipleMap);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      dps: props.dps.split(',')
    };
    _this.initDom = false;
    _this.markers = [];
    _this.listeners = [];
    _this.devices = props.devices;
    _this.time = props.time;
    _this.chartObj = {};
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_15_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.dashboard');
    return _this;
  }

  MultipleMap.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var tries = 0;
    var init = function init() {
      try {
        _this2.initMap();
        _this2.updateData();
      } catch (e) {
        if (tries < 10) {
          tries += 1;
          setTimeout(init, 1000);
        }
      }
    };
    init();
    this.kName = {
      rssi: 'RSSI',
      drops: "" + this.intlMsg.msg('map.drops'),
      snr: 'SNR'
    };
  };

  MultipleMap.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var devices = nextProps.devices,
        dps = nextProps.dps,
        time = nextProps.time,
        refreshState = nextProps.refreshState;

    if (devices !== this.props.devices) {
      this.devices = devices;
      if (this.map) {
        this.map.clearOverlays();
        this.updateData();
      }
    }
    if (time !== this.props.time) {
      this.time = time;
      if (this.initDom) {
        this.chartObj = {};
        this.initCharts();
        this.loadStats();
      }
    }
    if (refreshState !== this.props.refreshState && refreshState !== 0) {
      if (this.initDom) {
        this.initCharts('refresh');
        this.loadStats('refresh');
      }
    }
    this.setState({ dps: dps.split(',') });
  };

  MultipleMap.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_11_lodash_zip___default()(this.markers, this.listeners), function (_ref) {
      var marker = _ref[0],
          listener = _ref[1];

      marker.removeEventListener('click', listener);
    });
    $('#mapdetail').empty();
    this.chartObj = null;
  };

  MultipleMap.prototype.handleData = function handleData(domId, dps, anyType) {
    var _this3 = this;

    var domPrt = $("#" + domId).parent();
    if (!anyType) {
      domPrt.next('.load').css('display', 'inline-block');
      domPrt.css('display', 'none');
      domPrt.next().next('.empty').css('display', 'none');
    } else {
      domPrt.next().next('.empty').css('display', 'none');
      domPrt.css('display', 'inline-block');
    }
    this.loadData(this.currentId, dps, anyType).then(function (res) {
      domPrt.next('.load').css('display', 'none');
      var categories = [];
      var list = res.list.reverse();
      if (list.length === 0 && !anyType) {
        domPrt.next().next('.empty').css('display', 'inline-block');
      } else {
        var option = void 0;
        var data = _.map(list, function (l) {
          categories.push(__WEBPACK_IMPORTED_MODULE_14_date_fns_format___default()(l.timestamp, 'DD/MM HH:mm:ss'));
          return l.metrics[dps];
        });
        if (anyType) {
          var originOption = _this3.chartObj[domId].getOption() || kOption;
          option = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, originOption, {
            series: [{ name: dps, type: 'line', data: data }],
            xAxis: { data: categories }
          });
        } else {
          option = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, kOption, {
            xAxis: { data: categories },
            yAxis: { name: dps },
            series: [{ name: dps, type: 'line', data: data }]
          });
        }
        _this3.chartObj[domId].setOption(option);
        domPrt.css('display', 'inline-block');
      }
      _.delay(function () {
        var height = Math.ceil($('.BMap_bubble_content').parent().height() - 44);
        $('.dl-horizontal').css({ height: height + "px", overflowY: 'auto' });
      }, 100);
    }).catch(function () {});
  };

  MultipleMap.prototype.loadData = function loadData(item, dps, anyType) {
    var from = this.time.from;

    var to = anyType ? new Date() : this.time.to;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__api_callAPI__["a" /* default */])({ endpoint: '/lora/timeseries',
      method: 'POST',
      body: { nodeid: item, dps: [dps], from: from, to: to, limit: 1000 }
    });
  };

  MultipleMap.prototype.loadStats = function loadStats(refresh) {
    var _this4 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__api_callAPI__["a" /* default */])({
      endpoint: "/lora/nodes/" + this.currentId + "/rxqos?download"
    }).then(function (data) {
      _this4.handleRxqos(data, refresh);
    });
  };

  MultipleMap.prototype.handleRxqos = function handleRxqos(data, refresh) {
    var _this5 = this;

    var obj = { drops: [], snr: [], rssi: [] };
    var slots = [];
    try {
      data.list.reverse().forEach(function (item) {
        slots.push(__WEBPACK_IMPORTED_MODULE_14_date_fns_format___default()(item.$time, 'MM-DD HH:mm:ss'));
        obj.drops.push(item.drops);
        obj.snr.push(item.lorasnr);
        obj.rssi.push(item.rssi);
      });
    } catch (err) {
      // nothing to do err
    }
    ['drops', 'rssi', 'snr'].forEach(function (item) {
      var dom = document.querySelector("." + item);
      var parent = $(dom).parent();
      var id = dom.getAttribute('id');
      parent.next('.load').css('display', 'none');
      if (data.list.length === 0) {
        if (refresh) {
          parent.next().next('.empty').css('display', 'none');
          parent.css('display', 'inline-block');
        } else {
          parent.next().next('.empty').css('display', 'inline-block');
        }
      } else {
        var originOption = _this5.chartObj[id].getOption() || kOption;
        var option = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, originOption, {
          yAxis: { name: _this5.kName[item] },
          xAxis: { data: slots },
          series: [{
            name: _this5.kName[item],
            type: 'line',
            data: obj[item],
            areaStyle: {
              normal: {
                opacity: 0.1
              }
            }
          }]
        });
        _this5.chartObj[id].setOption(option);
        parent.css('display', 'inline-block');
      }
    });
  };

  MultipleMap.prototype.initMap = function initMap() {
    var _this6 = this;

    this.map = new BMap.Map('mapdetail');
    this.map.setMapStyle({ features: [] });
    this.map.setMaxZoom(16);
    this.map.setMinZoom(2);
    this.map.enableScrollWheelZoom();
    this.map.removeControl(this.navControl);
    this.map.removeControl(this.scaleControl);
    // eslint-disable-next-line
    this.navControl = new BMap.NavigationControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });
    // eslint-disable-next-line
    this.scaleControl = new BMap.ScaleControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });

    this.map.addControl(this.navControl);
    this.map.addControl(this.scaleControl);
    this.map.addEventListener('zoomend', function () {
      return _this6.props.onZoom(_this6.map);
    });
    this.map.addEventListener('dragend', function () {
      return _this6.props.onDrag(_this6.map);
    });
  };

  MultipleMap.prototype.updateData = function updateData() {
    var _this7 = this;

    this.devices = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_lorautils_map__["e" /* transform */])(this.devices);
    this.devices.forEach(function (obj) {
      _this7.addMarker(obj);
    });

    var points = this.devices.map(function (x) {
      return x.point;
    });
    if (points.length === 1) {
      this.map.centerAndZoom(points[0], 16);
    } else if (points.length > 0) {
      // decide max span with at most 100 points
      var _getCenterAndZoom = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_lorautils_map__["a" /* getCenterAndZoom */])(points.slice(0, 100)),
          center = _getCenterAndZoom[0],
          zoom = _getCenterAndZoom[1];

      this.map.centerAndZoom(center, zoom);
    } else {
      this.map.centerAndZoom('深圳', 1);
    }
  };

  MultipleMap.prototype.addMarker = function addMarker(item) {
    var _this8 = this;

    var opts = {
      title: '',
      width: 680,
      enableMessage: true
    };

    var _props = this.props,
        pushState = _props.pushState,
        dashId = _props.dashId,
        getDeveui = _props.getDeveui;

    var that = this;
    var openInfo = function openInfo() {
      that.initDom = false;
      var info = that.info(item);
      var infoWin = new BMap.InfoWindow(info, opts);
      _this8.map.openInfoWindow(infoWin, item.point);
      setTimeout(function () {
        $('#infowin').click(function () {
          pushState("/application/" + item.appeui + "/devices/" + item.id);
        });
        $('.map-zoom').click(function (e) {
          getDeveui([item.id]);
          var dps = e.target.getAttribute('data-dps');
          pushState("/application/" + item.appeui + "/dashboard/" + dashId + "/" + dps);
        });
        _this8.currentId = item.id;
        _this8.chartsDOM = document.querySelectorAll('.charts');
        _this8.chartObj = {};
        that.initDom = true;
        that.initCharts();
        _this8.loadStats();
      }, 300);
    };

    var icon = new BMap.Icon(__WEBPACK_IMPORTED_MODULE_20__images_green_svg___default.a, new BMap.Size(20, 20));
    var marker = new BMap.Marker(item.point, { icon: icon });
    marker.addEventListener('click', openInfo);
    this.map.addOverlay(marker);
    this.markers.push(marker);
    this.listeners.push(openInfo);
  };

  MultipleMap.prototype.info = function info(obj) {
    var _this9 = this;

    var charts = '';
    var style = 'width:300px;height:170px;text-align: center;margin:0 10px 10px;border:1px solid #efefef;';
    var renderDom = function renderDom(item, index) {
      return "<div style=\"" + style + " display: none;position: relative;\">\n          <i class=\"fa fa-expand pull-right map-zoom\" data-dps=\"" + item + "\"></i>\n          <div id=\"chart" + index + "\" style=\"width:300px;height:170px;\" class=\"" + item + " charts pull-left\" data-dps=\"" + item + "\">\n          </div>\n        </div>\n        <div\n         style=\"" + style + " padding-top:20px;\" class=\"load pull-left\">\n         <img src=\"" + __WEBPACK_IMPORTED_MODULE_18_loraimages_chart_loading_gif___default.a + "\" />\n        </div>\n        <div style=\"" + style + " display: none;\" class=\"empty pull-left\">\n          <p class=\"text-left\"\n           style=\"margin-bottom:0;margin-left:10px;margin-top:10px;font-size:14px;font-weight:normal;\">\n            " + (_this9.kName[item] || item) + "\n          </p>\n          <p style=\"line-height:120px;font-size:20px;color:#dadfe1;\">" + _this9.intlMsg.msg('chart.nodata') + "</p>\n        </div>\n    ";
    };
    this.state.dps.forEach(function (item, index) {
      charts += renderDom(item, index);
    });
    ['drops', 'snr', 'rssi'].forEach(function (it, idx) {
      var leng = _this9.state.dps.length;
      charts += renderDom(it, idx + leng);
    });
    return "\n<div>\n  <h4 style=\"font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, PingFang SC, Source Han Sans CN, Hiragino Sans GB, Microsoft YaHei, WenQuanYi Micro Hei, sans-serif; font-weight: 300; font-size: 14px;\">\n    " + obj.name + "&nbsp;<a id=\"infowin\">" + obj.id + "</a>\n  </h4>\n  <dl class=\"dl-horizontal clearfix\" style=\"font-size: 12px; padding: 15px 5px; border-radius: 2px; border: 1px solid #efefef;\">\n    " + charts + "\n  </dl>\n</div>\n";
  };

  MultipleMap.prototype.initCharts = function initCharts(anyType) {
    var _this10 = this;

    $('.dl-horizontal').css({ overflowY: 'hidden' });
    this.chartsDOM.forEach(function (item) {
      var id = item.getAttribute('id');
      var dps = item.getAttribute('data-dps');
      _this10.chartObj[id] = _this10.chartObj[id] ? _this10.chartObj[id] : __WEBPACK_IMPORTED_MODULE_7_echarts_lib_echarts___default.a.init(document.getElementById(id));
      if (dps !== 'drops' && dps !== 'snr' && dps !== 'rssi') {
        _this10.handleData(id, dps, anyType);
      }
    });
  };

  MultipleMap.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { id: "mapdetail", style: { height: '100%', width: '100%' } });
  };

  return MultipleMap;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

MultipleMap.defaultProps = defaultProps;
MultipleMap.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    dps: state.dashboard.getDps,
    time: state.dashboard.getTimes,
    refreshState: state.dashboard.getRefreshCount
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_10_react_router_redux__["routerActions"].push,
  getDeveui: __WEBPACK_IMPORTED_MODULE_16_loraactions_dashboard__["a" /* default */].getDeveui
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_8_react_css_modules___default()(MultipleMap, __WEBPACK_IMPORTED_MODULE_21__style_scss___default.a, { allowMultiple: true }))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_InlineSelect__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DeviceModal__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__DvcssModal__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__DpsModal__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_scss__ = __webpack_require__(2192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





















var propTypes = {
  appId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  appState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};

var NewDashboard = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NewDashboard, _React$Component);

  function NewDashboard(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, NewDashboard);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      appState: props.appState,
      dps: [],
      checked: [],
      by: 'single',
      errors: new __WEBPACK_IMPORTED_MODULE_17_lorautils_errors_ErrorSet__["a" /* default */]().add('FE_EMPTY', 'name')
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.dashboard');
    return _this;
  }

  NewDashboard.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var appState = nextProps.appState;

    this.setState({ appState: appState });
  };

  NewDashboard.prototype.handleChangeDps = function handleChangeDps(dps, modalType) {
    var dpsArr = _.split(dps, ',');
    dpsArr = _.filter(dpsArr, function (d) {
      return d !== '';
    });
    this.setState({ dps: dpsArr, modalType: modalType });
  };

  NewDashboard.prototype.handleAdd = function handleAdd() {
    this.setState({ showWarning: false });
    var _props = this.props,
        appId = _props.appId,
        pushState = _props.pushState;
    var _state = this.state,
        checked = _state.checked,
        name = _state.name,
        by = _state.by,
        dps = _state.dps,
        modalType = _state.modalType;

    _.remove(dps, function (d) {
      return d === 'lat' || d === 'lng';
    });

    var charts = [];
    if (by === 'single') {
      if (modalType === 'single') {
        charts = _.map(dps, function (item) {
          return { type: item };
        });
      } else if (modalType === 'merge') {
        charts = [{ type: dps }];
      }
    } else if (by === 'multiple') {
      charts = _.map(dps, function (item) {
        return { type: item };
      });
      charts = _.concat(charts, [{ type: 'lat' }, { type: 'lng' }]);
    }

    var deveui = _.map(checked, function (c) {
      return c.id;
    });
    var ext = { charts: charts, deveui: deveui };

    if (deveui.length === 0 || charts.length === 0) {
      this.setState({ showWarning: true });
      return;
    }
    var param = {
      endpoint: '/lora/dashboards',
      method: 'post',
      body: {
        name: name,
        type: by.toUpperCase(),
        appeui: appId,
        ext: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ext)
      }
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__api_callAPI__["a" /* default */])(param).then(function () {
      pushState("/application/" + appId + "/dashboard");
    }).catch(function () {});
  };

  NewDashboard.prototype.handleChangeName = function handleChangeName(e) {
    var name = _.trim(e.target.value);
    this.setState({ name: name });
  };

  NewDashboard.prototype.handleChangeBy = function handleChangeBy(by) {
    this.setState({ by: by, checked: [] });
  };

  NewDashboard.prototype.handleChangeDevice = function handleChangeDevice(checked) {
    this.setState({ checked: checked });
  };

  NewDashboard.prototype.renderToolbar = function renderToolbar() {
    var _props2 = this.props,
        pushState = _props2.pushState,
        appId = _props2.appId;
    var appState = this.state.appState;
    var status = appState.status,
        _appState$data = appState.data;
    _appState$data = _appState$data === undefined ? {} : _appState$data;
    var name = _appState$data.name;

    var breadcrumb = [{
      content: this.intlMsg.globalMsg('application.breadcrumb.application'),
      onClick: function onClick() {
        return pushState('/application');
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_Nvl__["a" /* default */], { status: status, val: name }),
      onClick: function onClick() {
        return pushState("/application/" + appId + "/dashboard");
      }
    }, {
      content: this.intlMsg.msg('adddashboard.add'),
      active: true
    }];
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  NewDashboard.prototype.render = function render() {
    var _this2 = this;

    var _state2 = this.state,
        checked = _state2.checked,
        dps = _state2.dps,
        _state2$name = _state2.name,
        name = _state2$name === undefined ? '' : _state2$name,
        errors = _state2.errors,
        _state2$by = _state2.by,
        by = _state2$by === undefined ? 'single' : _state2$by,
        _state2$submitted = _state2.submitted,
        submitted = _state2$submitted === undefined ? false : _state2$submitted,
        _state2$showWarning = _state2.showWarning,
        showWarning = _state2$showWarning === undefined ? false : _state2$showWarning,
        _state2$showDeviceMod = _state2.showDeviceModal,
        showDeviceModal = _state2$showDeviceMod === undefined ? false : _state2$showDeviceMod,
        _state2$showDpsModal = _state2.showDpsModal,
        showDpsModal = _state2$showDpsModal === undefined ? false : _state2$showDpsModal;


    var height = window.innerHeight - 200;
    var appId = this.props.appId;

    var deviceName = _.map(checked, function (device) {
      return device.name;
    }).join(', ');

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Grid"],
        { fluid: true },
        this.renderToolbar(),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Panel"],
          { bsStyle: "aisz-white", style: { height: height } },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Form"],
            { horizontal: true },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormGroup"],
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 2 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["ControlLabel"],
                  { bsClass: "aisz-control-label" },
                  this.intlMsg.msg('addmodal.name')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 4 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormControl"], {
                  value: name,
                  bsClass: "aisz-form-control-f",
                  placeholder: this.intlMsg.msg('adddashboard.add.placeholder'),
                  onChange: function onChange(e) {
                    return _this2.handleChangeName(e);
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_ControlTips__["a" /* default */], {
                  show: errors.has('name') && submitted,
                  message: this.intlMsg.errorMsg(errors.get('name')),
                  azStyle: "danger",
                  placement: "right"
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormGroup"],
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 2 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["ControlLabel"],
                  { bsClass: "aisz-control-label" },
                  this.intlMsg.msg('adddashboard.add.mode')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 4 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_InlineSelect__["a" /* default */], {
                  bsStyle: "aisz-primary",
                  options: [{
                    label: this.intlMsg.msg('new.singlemode'),
                    value: 'single'
                  }, {
                    label: this.intlMsg.msg('new.mapmode'),
                    value: 'multiple'
                  }],
                  values: [by],
                  onChange: function onChange(selected) {
                    return _this2.handleChangeBy(selected[0]);
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["HelpBlock"],
                  { styleName: "help" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-info-circle" }),
                  "\xA0",
                  this.intlMsg.msg("adddashboard.add." + by)
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormGroup"],
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 2 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["ControlLabel"],
                  { bsClass: "aisz-control-label" },
                  this.intlMsg.msg('adddashboard.add.device')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 4 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormControl"], {
                  value: deviceName,
                  bsClass: "aisz-form-control-f",
                  disabled: true,
                  styleName: "black"
                }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_ControlTips__["a" /* default */], {
                  show: errors.has('name') && submitted,
                  message: this.intlMsg.errorMsg(errors.get('name')),
                  azStyle: "danger",
                  placement: "right"
                })
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 2 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
                  {
                    bsStyle: "aisz-success",
                    onClick: function onClick() {
                      return _this2.setState({ showDeviceModal: true });
                    }
                  },
                  this.intlMsg.msg('adddashboard.add.select')
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormGroup"],
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 2 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["ControlLabel"],
                  { bsClass: "aisz-control-label" },
                  this.intlMsg.msg('adddashboard.add.datapoint')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 4 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormControl"], {
                  value: dps.join(', '),
                  bsClass: "aisz-form-control-f",
                  disabled: true,
                  styleName: "black"
                }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_ControlTips__["a" /* default */], {
                  show: errors.has('name') && submitted,
                  message: this.intlMsg.errorMsg(errors.get('name')),
                  azStyle: "danger",
                  placement: "right"
                })
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { md: 2 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
                  {
                    bsStyle: "aisz-success",
                    onClick: function onClick() {
                      return _this2.setState({ showDpsModal: true });
                    }
                  },
                  this.intlMsg.msg('adddashboard.add.select')
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_16_loracoms_ShowIf__["a" /* default */],
              { "if": showWarning },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormGroup"],
                { styleName: "red" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                  { md: 6, mdOffset: 3 },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-exclamation-circle" }),
                  "\xA0",
                  this.intlMsg.msg('add.warning')
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormGroup"],
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
                { mdOffset: 2, md: 4 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
                  {
                    bsStyle: "aisz-primary",
                    onClick: function onClick() {
                      return _this2.handleAdd();
                    },
                    className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.fullWidth
                  },
                  this.intlMsg.msg('confirm')
                )
              )
            )
          )
        )
      ),
      by !== 'multiple' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__DeviceModal__["a" /* default */], {
        appId: appId,
        showModal: showDeviceModal,
        onChoose: function onChoose(d) {
          return _this2.handleChangeDevice(d);
        },
        onHide: function onHide() {
          return _this2.setState({ showDeviceModal: false });
        }
      }),
      by === 'multiple' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__DvcssModal__["a" /* default */], {
        appId: appId,
        showModal: showDeviceModal,
        onChoose: function onChoose(d) {
          return _this2.handleChangeDevice(d);
        },
        onHide: function onHide() {
          return _this2.setState({ showDeviceModal: false });
        }
      }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__DpsModal__["a" /* default */], {
        appId: appId,
        showModal: showDpsModal,
        onHide: function onHide() {
          return _this2.setState({ showDpsModal: false });
        },
        onConfirm: function onConfirm(ds, modalType) {
          return _this2.handleChangeDps(ds, modalType);
        }
      })
    );
  };

  return NewDashboard;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

NewDashboard.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    appId: ownProps.params.id,
    appState: state.app.getApp
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_9_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_6_react_css_modules___default()(NewDashboard, __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a, { allowMultiple: true }))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loraactions_dashboard__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__DetailHeader__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__TimeSelect__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DeviceModal__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__EditName__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__RefreshBtn__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Charts__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__DpsModal__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__styles_scss__ = __webpack_require__(2193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__styles_scss__);





/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





















var kLoops = 100;
var kInterval = 6;

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  dashId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
  dashboardData: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  appState: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
  getDashboard: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  getDps: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  getDeveui: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  getRefreshCount: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  deveuis: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array.isRequired
};

var SingleDetail = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SingleDetail, _React$Component);

  function SingleDetail(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SingleDetail);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      dashboardData: props.dashboardData,
      appState: props.appState,
      checkedId: [],
      extNew: { charts: [], deveui: [] }
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.dashboard');
    _this.handleOperation = _this.handleOperation.bind(_this);
    _this.handleOnConfirmDps = _this.handleOnConfirmDps.bind(_this);
    _this.handleRefresh = _this.handleRefresh.bind(_this);
    _this.refresh = 0;
    return _this;
  }

  SingleDetail.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        dashId = _props.dashId,
        getDashboard = _props.getDashboard;

    getDashboard(dashId);
  };

  SingleDetail.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var dashboardData = nextProps.dashboardData,
        appState = nextProps.appState,
        deveuis = nextProps.deveuis;

    if (dashboardData !== this.props.dashboardData) {
      var status = dashboardData.status,
          data = dashboardData.data;

      if (status === 'success' && data) {
        this.handleData(dashboardData);
      }
    }
    if (appState !== this.props.appState) {
      this.setState({ appState: appState });
    }
    if (deveuis !== this.props.deveuis) {
      this.deveuis = deveuis;
    }
  };

  SingleDetail.prototype.componentWillUnmount = function componentWillUnmount() {
    this.refresh = 0;
  };

  SingleDetail.prototype.handleData = function handleData(dashboardData) {
    var _this2 = this;

    var ext = dashboardData.data.ext;

    var checkedId = JSON.parse(ext).deveui;
    this.deveuis = checkedId;
    var dpsAll = [];
    var dpspart = [];
    dpsAll = _.map(JSON.parse(ext).charts, function (item) {
      if (_.isArray(item.type)) {
        _.map(item.type, function (i) {
          dpspart.push(i);
        });
      }
      return item.type;
    });
    _.map(dpspart, function (d) {
      return dpsAll.push(d);
    });
    dpsAll = _.filter(dpsAll, function (dAll) {
      return !_.isArray(dAll);
    });
    this.setState({
      checkedId: checkedId,
      dps: dpsAll,
      dashboardData: dashboardData,
      extNew: JSON.parse(ext)
    }, function () {
      _this2.props.getDps(_this2.state.dps);
    });
  };

  SingleDetail.prototype.handleOperation = function handleOperation() {
    var d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var deveui = arguments[1];
    var ext = this.state.dashboardData.data.ext;

    ext = JSON.parse(ext);
    ext = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, ext, { deveui: deveui });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__api_callAPI__["a" /* default */])({
      endpoint: "/lora/dashboards/" + this.props.dashId,
      method: 'PUT',
      body: {
        ext: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ext)
      }
    }).then(function () {}).catch(function () {});
    this.props.getDeveui(deveui);
    this.setState({ checkedId: deveui });
  };

  SingleDetail.prototype.handleDelSuc = function handleDelSuc(e, d) {
    this.setState({ extNew: e });
    var dps = this.state.dps;

    if (_.isArray(d)) {
      dps = _.difference(dps, d);
    } else {
      dps = _.filter(dps, function (item) {
        return item !== d;
      });
    }
    this.setState({ dps: dps });
  };

  SingleDetail.prototype.handleOnConfirmDps = function handleOnConfirmDps(dpsNew, modalType) {
    var ext = this.state.dashboardData.data.ext;
    var extNew = this.state.extNew;

    ext = JSON.parse(ext);
    var addCharts = void 0;
    var charts = extNew.charts;
    var dpsNewTwo = _.split(dpsNew, ',');
    dpsNewTwo = _.filter(dpsNewTwo, function (dp) {
      return dp !== '';
    });
    _.remove(dpsNewTwo, function (d) {
      return d === 'lat' || d === 'lng';
    });
    if (modalType === 'single') {
      addCharts = _.map(dpsNewTwo, function (item) {
        return { type: item };
      });
      charts = _.concat(charts, addCharts);
      charts = _.uniqWith(charts, _.isEqual);
    } else if (modalType === 'merge') {
      addCharts = { type: dpsNewTwo };
      charts = _.concat(charts, addCharts);
      charts = _.uniqWith(charts, _.isEqual);
    }
    ext = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, ext, { deveui: this.deveuis, charts: charts });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__api_callAPI__["a" /* default */])({
      endpoint: "/lora/dashboards/" + this.props.dashId,
      method: 'PUT',
      body: {
        ext: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ext)
      }
    }).then(function () {}).catch(function () {});
    this.setState({
      showDpsModal: false,
      reset: new Date(),
      modalType: modalType,
      extNew: ext
    });
    this.props.getDps(dpsNewTwo);
  };

  SingleDetail.prototype.handleRefresh = function handleRefresh() {
    var _this3 = this;

    if (this.refresh === kLoops + 1) {
      this.refresh = 0;
      this.setState({ selectDisabled: false });
    } else {
      this.props.getRefreshCount(this.refresh);
      this.setState({ isRefreshing: true });
      this.refresh += 1;
      _.delay(function () {
        _this3.setState({ isRefreshing: false });
      }, 1000);
      this.setState({ selectDisabled: true });
    }
  };

  SingleDetail.prototype.handleOneClick = function handleOneClick() {
    this.refresh = 0;
    this.setState({ selectDisabled: false });
  };

  SingleDetail.prototype.handleOnHideDps = function handleOnHideDps() {
    this.setState({ showDpsModal: false });
  };

  SingleDetail.prototype.render = function render() {
    var _this4 = this;

    var _props2 = this.props,
        appId = _props2.appId,
        dashId = _props2.dashId;
    var _state = this.state,
        _state$reset = _state.reset,
        reset = _state$reset === undefined ? 0 : _state$reset,
        data = _state.dashboardData.data,
        _state$showDpsModal = _state.showDpsModal,
        showDpsModal = _state$showDpsModal === undefined ? false : _state$showDpsModal,
        _state$showDeviceModa = _state.showDeviceModal,
        showDeviceModal = _state$showDeviceModa === undefined ? false : _state$showDeviceModa,
        _state$isRefreshing = _state.isRefreshing,
        isRefreshing = _state$isRefreshing === undefined ? false : _state$isRefreshing,
        checkedId = _state.checkedId;
    // let { dps } = this.state;

    if (!data) {
      return null;
    }
    // dps = dps || _.map(JSON.parse(data.ext).charts, item => item.type);
    // dps = _.filter(dps, d => (d !== ''));
    // dps = _.join(dps, ',');
    var deveui = JSON.parse(data.ext).deveui;
    var header = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      { className: "clearfix " + __WEBPACK_IMPORTED_MODULE_23__styles_scss___default.a.leftTool },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "span",
        { className: "pull-left" },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__EditName__["a" /* default */], { name: data.name, dashId: dashId })
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_react_router__["f" /* Link */],
        {
          to: "/application/" + this.props.appId + "/devices/" + checkedId[0],
          className: __WEBPACK_IMPORTED_MODULE_23__styles_scss___default.a.device
        },
        checkedId[0]
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { className: "pull-right" },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-success-b",
            className: __WEBPACK_IMPORTED_MODULE_23__styles_scss___default.a.marginRm,
            onClick: function onClick() {
              return _this4.setState({ showDpsModal: true });
            }
          },
          this.intlMsg.msg('add.dpschart')
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-primary-b",
            onClick: function onClick() {
              return _this4.setState({ showDeviceModal: true });
            }
          },
          this.intlMsg.msg('changedevice')
        )
      )
    );
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      { ref: function ref(input) {
          _this4.container = input;
        } },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__DetailHeader__["a" /* default */], { dash: data }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Grid"],
        { fluid: true },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Panel"],
            { bsStyle: "aisz-white", header: header, styleName: "add-panel" },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Row"],
              null,
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Col"],
                { md: 11 },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  "span",
                  { className: "pull-left" },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__TimeSelect__["a" /* default */], null)
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Col"],
                { md: 1, className: "text-right", styleName: "refresh" },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__RefreshBtn__["a" /* default */], {
                  loops: kLoops,
                  interval: kInterval,
                  reloading: isRefreshing,
                  onReload: this.handleRefresh,
                  onOneClick: function onOneClick() {
                    return _this4.handleOneClick();
                  }
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Charts__["a" /* default */], {
            dashId: dashId,
            reset: reset,
            appId: appId,
            onDeleteSuc: function onDeleteSuc(e, d) {
              return _this4.handleDelSuc(e, d);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__DpsModal__["a" /* default */], {
          showModal: showDpsModal
          // dps={dps}
          , appId: appId,
          onConfirm: this.handleOnConfirmDps,
          onHide: function onHide() {
            return _this4.handleOnHideDps();
          }
        }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__DeviceModal__["a" /* default */], {
          appId: appId,
          showModal: showDeviceModal,
          onChoose: this.handleOperation,
          onHide: function onHide() {
            return _this4.setState({ showDeviceModal: false });
          },
          checkedId: deveui
        })
      )
    );
  };

  return SingleDetail;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    appState: state.app.getApp,
    dashId: ownProps.params.dashid,
    appId: ownProps.params.id,
    dashboardData: state.dashboard.getDashboard,
    time: state.dashboard.getTimes,
    deveuis: state.dashboard.getDeveui
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["routerActions"].push,
  getDashboard: __WEBPACK_IMPORTED_MODULE_14_loraactions_dashboard__["a" /* default */].getDashboard,
  getDps: __WEBPACK_IMPORTED_MODULE_14_loraactions_dashboard__["a" /* default */].getDps,
  getDeveui: __WEBPACK_IMPORTED_MODULE_14_loraactions_dashboard__["a" /* default */].getDeveui,
  getRefreshCount: __WEBPACK_IMPORTED_MODULE_14_loraactions_dashboard__["a" /* default */].getRefreshCount
};

SingleDetail.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_7_react_css_modules___default()(SingleDetail, __WEBPACK_IMPORTED_MODULE_23__styles_scss___default.a))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_PageLoading__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_PageNoPerm__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__coms_BoardList__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_scss__ = __webpack_require__(2195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,
  appState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  planState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var DashBoard = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DashBoard, _React$Component);

  function DashBoard(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DashBoard);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      dashboards: [],
      showModal: false,
      deviceIds: [],
      appState: props.appState,
      planState: props.planState
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_14_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.dashboard');
    return _this;
  }

  DashBoard.prototype.componentWillMount = function componentWillMount() {
    this.loadDashboards();
  };

  DashBoard.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var appState = nextProps.appState,
        planState = nextProps.planState;

    if (appState !== this.props.appState) {
      this.setState({ appState: appState });
    }
    if (!_.isEqual(planState, this.props.planState)) {
      this.setState({ planState: planState });
    }
  };

  DashBoard.prototype.loadDashboards = function loadDashboards() {
    var _this2 = this;

    var appId = this.props.appId;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__api_callAPI__["a" /* default */])({ endpoint: '/lora/dashboards', method: 'GET', query: { appeui: appId } }).then(function (res) {
      _this2.setState({ dashboards: res.list });
    }).catch(function () {});
  };

  DashBoard.prototype.renderToolbar = function renderToolbar() {
    var _props = this.props,
        pushState = _props.pushState,
        appId = _props.appId;
    var appState = this.state.appState;
    var status = appState.status,
        _appState$data = appState.data;
    _appState$data = _appState$data === undefined ? {} : _appState$data;
    var name = _appState$data.name;

    var addButton = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "span",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Button"],
        {
          bsStyle: "aisz-success",
          onClick: function onClick() {
            return pushState("/application/" + appId + "/dashboard/add");
          }
        },
        this.intlMsg.msg('adddashboard'),
        ' ',
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-plus" })
      )
    );

    var breadcrumb = [{
      content: this.intlMsg.globalMsg('application.breadcrumb.application'),
      onClick: function onClick() {
        return pushState('/application');
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Nvl__["a" /* default */], { status: status, val: name }),
      active: true
    }];
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb, rightTools: [{ input: addButton }] });
  };

  DashBoard.prototype.render = function render() {
    var appId = this.props.appId;
    var _state = this.state,
        dashboards = _state.dashboards,
        appState = _state.appState,
        _state$planState = _state.planState,
        _state$planState$data = _state$planState.data,
        data = _state$planState$data === undefined ? {} : _state$planState$data,
        status = _state$planState.status;

    if (status === 'pending' || !appState.data) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_PageLoading__["a" /* default */], null);
    }
    if (data.tier === 1) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_PageNoPerm__["a" /* default */], null);
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Grid"],
        { fluid: true },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
            { md: 12 },
            this.renderToolbar()
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__coms_BoardList__["a" /* default */], { appId: appId, boards: dashboards })
          )
        )
      )
    );
  };

  return DashBoard;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    appId: ownProps.params.id,
    appState: state.app.getApp,
    planState: state.billing.plan
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["routerActions"].push
};

DashBoard.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_4_react_css_modules___default()(DashBoard, __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a, { allowMultiple: true }))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_lib_utils__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_lib_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap_lib_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TimeRangeButton__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__NewGroupByButton__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NewFilterButton__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__NewSeriesButton__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__GroupByTimeButton__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DeviceSerieButton__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__GroupByFuncButton__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DeviceFilter__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__constants__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__buttons_scss__ = __webpack_require__(2200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__buttons_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__buttons_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_scss__ = __webpack_require__(2196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





















__WEBPACK_IMPORTED_MODULE_10_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Button"], 'aisz-new-cond');
__WEBPACK_IMPORTED_MODULE_10_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["SplitButton"], 'aisz-new-cond');
__WEBPACK_IMPORTED_MODULE_10_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["DropdownButton"], 'aisz-new-cond');
__WEBPACK_IMPORTED_MODULE_10_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Button"], 'aisz-time-range');
__WEBPACK_IMPORTED_MODULE_10_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["DropdownButton"], 'aisz-time-range');
__WEBPACK_IMPORTED_MODULE_10_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Button"], 'aisz-time');
__WEBPACK_IMPORTED_MODULE_10_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["DropdownButton"], 'aisz-time');
__WEBPACK_IMPORTED_MODULE_10_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Button"], 'aisz-device');
__WEBPACK_IMPORTED_MODULE_10_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["DropdownButton"], 'aisz-func');
__WEBPACK_IMPORTED_MODULE_10_react_bootstrap_lib_utils__["bootstrapUtils"].addStyle(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Button"], 'aisz-func');

var propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  locale: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired
};

var Conditions = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Conditions, _React$Component);

  function Conditions(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Conditions);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      data: props.data
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.parseview.dptrend');
    _this.handleChangeTimeRange = _this.handleChangeTimeRange.bind(_this);
    _this.handleAddGroupByDim = _this.handleAddGroupByDim.bind(_this);
    _this.handleAddFilter = _this.handleAddFilter.bind(_this);
    _this.handleRemoveGroupByDim = _this.handleRemoveGroupByDim.bind(_this);
    _this.handleChangeGroupByFunc = _this.handleChangeGroupByFunc.bind(_this);
    _this.handleAddSeries = _this.handleAddSeries.bind(_this);
    return _this;
  }

  Conditions.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var data = nextProps.data;

    if (data !== this.props.data) {
      this.setState({ data: data });
    }
  };

  Conditions.prototype.handleChangeTimeRange = function handleChangeTimeRange(timeRange) {
    var data = this.state.data;

    this.props.onChange(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
      timeRange: timeRange
    }));
  };

  Conditions.prototype.handleAddGroupByDim = function handleAddGroupByDim(dim) {
    var data = this.state.data;
    var _data$groupBy = data.groupBy,
        groupBy = _data$groupBy === undefined ? {} : _data$groupBy;
    var _groupBy$dims = groupBy.dims,
        dims = _groupBy$dims === undefined ? [] : _groupBy$dims;

    if (_.some(dims, function (gb) {
      return gb.type === dim;
    })) {
      return;
    }
    this.props.onChange(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
      groupBy: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, groupBy, {
        dims: _.union(dims, [{
          type: dim,
          value: __WEBPACK_IMPORTED_MODULE_20__constants__["h" /* kGroupOneMin */]
        }])
      })
    }));
  };

  Conditions.prototype.handleChangeGroupByDim = function handleChangeGroupByDim(dim) {
    var data = this.state.data;
    var _data$groupBy2 = data.groupBy,
        groupBy = _data$groupBy2 === undefined ? {} : _data$groupBy2;
    var _groupBy$dims2 = groupBy.dims,
        dims = _groupBy$dims2 === undefined ? [] : _groupBy$dims2;

    this.props.onChange(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
      groupBy: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, groupBy, {
        dims: dims.map(function (d) {
          if (d.type === dim.type) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, d, dim);
          }
          return d;
        })
      })
    }));
  };

  Conditions.prototype.handleRemoveGroupByDim = function handleRemoveGroupByDim(type) {
    var data = this.state.data;
    var _data$groupBy3 = data.groupBy,
        groupBy = _data$groupBy3 === undefined ? {} : _data$groupBy3;
    var _groupBy$dims3 = groupBy.dims,
        dims = _groupBy$dims3 === undefined ? [] : _groupBy$dims3;

    this.props.onChange(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
      groupBy: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, groupBy, {
        dims: dims.filter(function (d) {
          return d.type !== type;
        })
      })
    }));
  };

  Conditions.prototype.handleChangeGroupByFunc = function handleChangeGroupByFunc(func) {
    var data = this.state.data;
    var _data$groupBy4 = data.groupBy,
        groupBy = _data$groupBy4 === undefined ? {} : _data$groupBy4;

    this.props.onChange(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
      groupBy: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, groupBy, {
        func: func
      })
    }));
  };

  Conditions.prototype.handleAddFilter = function handleAddFilter(filter) {
    var data = this.state.data;
    var _data$filters = data.filters,
        filters = _data$filters === undefined ? [] : _data$filters;

    this.props.onChange(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
      filters: _.union(filters, [{
        type: filter,
        id: Math.random() * 1000000
      }])
    }));
  };

  Conditions.prototype.handleRemoveFilter = function handleRemoveFilter(id) {
    var data = this.state.data;
    var _data$filters2 = data.filters,
        filters = _data$filters2 === undefined ? [] : _data$filters2;

    this.props.onChange(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
      filters: _.filter(filters, function (f) {
        return f.id !== id;
      })
    }));
  };

  Conditions.prototype.handleChangeFilter = function handleChangeFilter(filter) {
    var data = this.state.data;
    var _data$filters3 = data.filters,
        filters = _data$filters3 === undefined ? [] : _data$filters3;

    this.props.onChange(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
      filters: filters.map(function (f) {
        if (f.id === filter.id) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, f, filter);
        }
        return f;
      })
    }));
  };

  Conditions.prototype.handleAddSeries = function handleAddSeries(serie) {
    var data = this.state.data;
    var _data$series = data.series,
        series = _data$series === undefined ? [] : _data$series;

    this.props.onChange(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
      series: _.union(series, [serie])
    }));
  };

  Conditions.prototype.handleRemoveSeries = function handleRemoveSeries(serie) {
    var data = this.state.data;
    var _data$series2 = data.series,
        series = _data$series2 === undefined ? [] : _data$series2;

    this.props.onChange(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
      series: series.filter(function (s) {
        return s !== serie;
      })
    }));
  };

  Conditions.prototype.render = function render() {
    var _this2 = this;

    var locale = this.props.locale;
    var _state = this.state,
        _state$data = _state.data,
        timeRange = _state$data.timeRange,
        _state$data$groupBy = _state$data.groupBy,
        _state$data$groupBy$d = _state$data$groupBy.dims,
        groupBys = _state$data$groupBy$d === undefined ? [] : _state$data$groupBy$d,
        _state$data$groupBy$f = _state$data$groupBy.func,
        groupByFunc = _state$data$groupBy$f === undefined ? __WEBPACK_IMPORTED_MODULE_20__constants__["b" /* kGroupFuncSum */] : _state$data$groupBy$f,
        _state$data$filters = _state$data.filters,
        filters = _state$data$filters === undefined ? [] : _state$data$filters,
        _state$data$series = _state$data.series,
        series = _state$data$series === undefined ? [] : _state$data$series,
        _state$expand = _state.expand,
        expand = _state$expand === undefined ? true : _state$expand;


    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.conds + " " + (expand ? '' : __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.collapsed) },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Collapse"],
        { "in": expand },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.condGroup },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "span",
              { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.label + " " + __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a[locale] },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-calendar-o fa-fw", "aria-hidden": "true" }),
              ' ',
              this.intlMsg.msg('timerange')
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__TimeRangeButton__["a" /* default */], {
              value: timeRange,
              onSelect: this.handleChangeTimeRange
            })
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.condGroup },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "span",
              { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.label + " " + __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a[locale] },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-sitemap fa-fw", "aria-hidden": "true" }),
              ' ',
              this.intlMsg.msg('groupbys')
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.condBlock },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.condBlockRow },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
                  { "if": groupBys.length > 0 },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.label + " " + __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.sub + " " + __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a[locale] },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-angle-right" }),
                    ' ',
                    this.intlMsg.msg('groupbys.dimension')
                  )
                ),
                groupBys.map(function (gb) {
                  if (gb.type === __WEBPACK_IMPORTED_MODULE_20__constants__["g" /* kGroupByTime */]) {
                    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__GroupByTimeButton__["a" /* default */], {
                      key: gb.type,
                      value: gb.value,
                      onSelect: function onSelect(value) {
                        _this2.handleChangeGroupByDim({ type: gb.type, value: value });
                      },
                      onDelete: function onDelete() {
                        return _this2.handleRemoveGroupByDim(gb.type);
                      }
                    });
                  }
                  return null;
                })
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.condBlockRow },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
                  { "if": groupBys.length > 0 },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.label + " " + __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.sub + " " + __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a[locale] },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-angle-right" }),
                    ' ',
                    this.intlMsg.msg('groupbys.function')
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
                  { "if": groupBys.length > 0 },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__GroupByFuncButton__["a" /* default */], {
                    id: "group-by-func",
                    value: groupByFunc,
                    onSelect: this.handleChangeGroupByFunc
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__NewGroupByButton__["a" /* default */], { onSelect: this.handleAddGroupByDim })
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.condGroup },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "span",
              { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.label + " " + __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a[locale] },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-filter fa-fw", "aria-hidden": "true" }),
              ' ',
              this.intlMsg.msg('filters')
            ),
            filters.map(function (filter) {
              if (filter.type === __WEBPACK_IMPORTED_MODULE_20__constants__["e" /* kDeviceFilter */]) {
                return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__DeviceFilter__["a" /* default */], {
                  key: filter.id,
                  value: filter.value,
                  onDelete: function onDelete() {
                    return _this2.handleRemoveFilter(filter.id);
                  },
                  onChange: function onChange(e) {
                    _this2.handleChangeFilter({
                      id: filter.id,
                      value: e.target.value
                    });
                  }
                });
              }
              return null;
            }),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__NewFilterButton__["a" /* default */], { onSelect: this.handleAddFilter })
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.condGroup },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "span",
              { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.label + " " + __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a[locale] },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-bars fa-fw", "aria-hidden": "true" }),
              ' ',
              this.intlMsg.msg('series')
            ),
            series.map(function (serie) {
              if (serie === __WEBPACK_IMPORTED_MODULE_20__constants__["f" /* kSeriesDevice */]) {
                return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__DeviceSerieButton__["a" /* default */], {
                  key: serie,
                  onDelete: function onDelete() {
                    return _this2.handleRemoveSeries(serie);
                  }
                });
              }
              return null;
            }),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__NewSeriesButton__["a" /* default */], { onSelect: this.handleAddSeries })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.toggle },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
          { onClick: function onClick() {
              return _this2.setState({ expand: !expand });
            } },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
            { "if": expand },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-angle-double-up" })
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
            { "if": !expand },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-angle-double-down" })
          )
        )
      )
    );
  };

  return Conditions;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Conditions.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    locale: state.intl.locale
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(Conditions)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss__ = __webpack_require__(2197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







var defaultProps = {
  value: ''
};

var propTypes = {
  onDelete: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string
};

var DeviceFilter = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeviceFilter, _React$Component);

  function DeviceFilter(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeviceFilter);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      value: props.value
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.parseview.dptrend.devicefilter');
    return _this;
  }

  DeviceFilter.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var value = nextProps.value;

    if (value !== this.props.value) {
      this.setState({ value: value });
    }
  };

  DeviceFilter.prototype.render = function render() {
    var _props = this.props,
        onDelete = _props.onDelete,
        onChange = _props.onChange;
    var value = this.state.value;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.filter },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "span",
        { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.label },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-hdd-o" })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["FormControl"], {
        placeholder: this.intlMsg.msg('placeholder'),
        value: value,
        onChange: onChange
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
        {
          bsStyle: "aisz-device",
          className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.closeBtn,
          onClick: onDelete
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-times" })
      )
    );
  };

  return DeviceFilter;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DeviceFilter.defaultProps = defaultProps;
DeviceFilter.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(DeviceFilter));

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss__ = __webpack_require__(2198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







var propTypes = {
  onDelete: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired
};

var DeviceSerieButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeviceSerieButton, _React$Component);

  function DeviceSerieButton(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeviceSerieButton);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {};
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.parseview.dptrend.deviceserie');
    return _this;
  }

  DeviceSerieButton.prototype.render = function render() {
    var onDelete = this.props.onDelete;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.btnGroup },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
        {
          id: "group-by",
          bsStyle: "aisz-device"
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-hdd-o", "aria-hidden": "true" }),
        ' ',
        this.intlMsg.msg('label')
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
        {
          bsStyle: "aisz-device",
          className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.closeBtn,
          onClick: onDelete
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-times" })
      )
    );
  };

  return DeviceSerieButton;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DeviceSerieButton.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(DeviceSerieButton));

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(176);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







var propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  onSelect: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired
};

var GroupByFuncButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(GroupByFuncButton, _React$Component);

  function GroupByFuncButton(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GroupByFuncButton);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      value: props.value
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.parseview.dptrend.groupbys.funcs');
    return _this;
  }

  GroupByFuncButton.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var value = nextProps.value;

    if (value !== this.props.value) {
      this.setState({ value: value });
    }
  };

  GroupByFuncButton.prototype.render = function render() {
    var _this2 = this;

    var onSelect = this.props.onSelect;
    var value = this.state.value;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["DropdownButton"],
      {
        id: "group-by-func",
        bsStyle: "aisz-func",
        title: this.intlMsg.msg(value),
        onSelect: onSelect,
        pullRight: true
      },
      __WEBPACK_IMPORTED_MODULE_7__constants__["q" /* kGroupFuncTypes */].map(function (func) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
          { key: func, eventKey: func },
          _this2.intlMsg.msg(func)
        );
      })
    );
  };

  return GroupByFuncButton;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

GroupByFuncButton.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(GroupByFuncButton));

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss__ = __webpack_require__(2199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);








var propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  onDelete: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired
};

var GroupByTimeButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(GroupByTimeButton, _React$Component);

  function GroupByTimeButton(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GroupByTimeButton);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      value: props.value
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.parseview.dptrend.groupbytime');
    return _this;
  }

  GroupByTimeButton.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var value = nextProps.value;

    if (value !== this.props.value) {
      this.setState({ value: value });
    }
  };

  GroupByTimeButton.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        onSelect = _props.onSelect,
        onDelete = _props.onDelete;
    var value = this.state.value;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.btnGroup },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["DropdownButton"],
        {
          id: "group-by",
          bsStyle: "aisz-time",
          title: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "span",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-clock-o", "aria-hidden": "true" }),
            ' ',
            this.intlMsg.msg(value)
          ),
          onSelect: onSelect,
          pullRight: true
        },
        __WEBPACK_IMPORTED_MODULE_7__constants__["r" /* kGroupTimes */].map(function (type) {
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
            { key: type, eventKey: type },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-clock-o", "aria-hidden": "true" }),
            ' ',
            _this2.intlMsg.msg(type)
          );
        })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
        {
          bsStyle: "aisz-time",
          className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.closeBtn,
          onClick: onDelete
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-times" })
      )
    );
  };

  return GroupByTimeButton;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

GroupByTimeButton.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(GroupByTimeButton));

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(176);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







var propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.any.isRequired
};

var NewFilterButton = function NewFilterButton(props) {
  var onSelect = props.onSelect;

  var intlMsg = new __WEBPACK_IMPORTED_MODULE_3_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.parseview.dptrend.filters');

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["DropdownButton"],
    {
      id: "group-by",
      bsStyle: "aisz-new-cond",
      title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-plus-circle", "aria-hidden": "true" }),
        ' ',
        intlMsg.msg('new')
      ),
      onSelect: onSelect,
      pullRight: true
    },
    __WEBPACK_IMPORTED_MODULE_4__constants__["o" /* kFilterTypes */].map(function (type) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["MenuItem"],
        { key: type, eventKey: type },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-plus-circle", "aria-hidden": "true" }),
        ' ',
        intlMsg.msg(type)
      );
    })
  );
};

NewFilterButton.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_intl__["injectIntl"])(NewFilterButton));

/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(176);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







var propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.any.isRequired
};

var NewGroupByButton = function NewGroupByButton(props) {
  var onSelect = props.onSelect;

  var intlMsg = new __WEBPACK_IMPORTED_MODULE_3_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.parseview.dptrend.groupbys');

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["DropdownButton"],
    {
      id: "group-by",
      bsStyle: "aisz-new-cond",
      title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-plus-circle", "aria-hidden": "true" }),
        ' ',
        intlMsg.msg('new')
      ),
      onSelect: onSelect,
      pullRight: true
    },
    __WEBPACK_IMPORTED_MODULE_4__constants__["p" /* kGroupByTypes */].map(function (type) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["MenuItem"],
        { key: type, eventKey: type },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-plus-circle", "aria-hidden": "true" }),
        ' ',
        intlMsg.msg(type)
      );
    })
  );
};

NewGroupByButton.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_intl__["injectIntl"])(NewGroupByButton));

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(176);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







var propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.any.isRequired
};

var NewSeriesButton = function NewSeriesButton(props) {
  var onSelect = props.onSelect;

  var intlMsg = new __WEBPACK_IMPORTED_MODULE_3_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.parseview.dptrend.series');

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["DropdownButton"],
    {
      id: "group-by",
      bsStyle: "aisz-new-cond",
      title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-plus-circle", "aria-hidden": "true" }),
        ' ',
        intlMsg.msg('new')
      ),
      onSelect: onSelect,
      pullRight: true
    },
    __WEBPACK_IMPORTED_MODULE_4__constants__["n" /* kSeriesTypes */].map(function (type) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["MenuItem"],
        { key: type, eventKey: type },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-plus-circle", "aria-hidden": "true" }),
        ' ',
        intlMsg.msg(type)
      );
    })
  );
};

NewSeriesButton.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_intl__["injectIntl"])(NewSeriesButton));

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(176);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







var propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  onSelect: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired
};

var TimeRangeButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(TimeRangeButton, _React$Component);

  function TimeRangeButton(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TimeRangeButton);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      value: props.value
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.parseview.dptrend.timeranges');
    return _this;
  }

  TimeRangeButton.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var value = nextProps.value;

    if (value !== this.props.value) {
      this.setState({ value: value });
    }
  };

  TimeRangeButton.prototype.render = function render() {
    var _this2 = this;

    var onSelect = this.props.onSelect;
    var value = this.state.value;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["DropdownButton"],
      {
        id: "time-range",
        bsStyle: "aisz-time-range",
        title: this.intlMsg.msg(value),
        onSelect: onSelect,
        pullRight: true
      },
      __WEBPACK_IMPORTED_MODULE_7__constants__["s" /* kTimeRanges */].map(function (tr) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
          { key: tr, eventKey: tr },
          _this2.intlMsg.msg(tr)
        );
      })
    );
  };

  return TimeRangeButton;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

TimeRangeButton.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(TimeRangeButton));

/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_sub_hours__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_sub_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_sub_hours__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_sub_days__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_sub_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_sub_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_sub_months__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_sub_months___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns_sub_months__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_set_milliseconds__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_set_milliseconds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_date_fns_set_milliseconds__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_set_seconds__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_set_seconds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_date_fns_set_seconds__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_set_minutes__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_set_minutes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_date_fns_set_minutes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_get_minutes__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_get_minutes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_date_fns_get_minutes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_add_hours__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_add_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_date_fns_add_hours__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_date_fns_is_equal__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_date_fns_is_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_date_fns_is_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_date_fns_start_of_hour__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_date_fns_start_of_hour___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_date_fns_start_of_hour__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_loracoms_Refresher__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_loracoms_LineChart__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__coms_Conditions__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__styles_scss__ = __webpack_require__(2201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__constants__ = __webpack_require__(176);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



























var propTypes = {
  appId: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  dpId: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  appState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired
};

var DataPointTrend = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DataPointTrend, _React$Component);

  function DataPointTrend(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DataPointTrend);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.conditions = {
      timeRange: __WEBPACK_IMPORTED_MODULE_28__constants__["a" /* kLastDay */],
      groupBy: {
        dims: [],
        func: __WEBPACK_IMPORTED_MODULE_28__constants__["b" /* kGroupFuncSum */]
      },
      filters: []
    };
    _this.state = {
      appState: props.appState,
      conditions: _this.conditions,
      status: ''
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_20_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.parseview.dptrend');
    _this.handleChangeConditions = _this.handleChangeConditions.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    return _this;
  }

  DataPointTrend.prototype.componentWillMount = function componentWillMount() {
    this.loadData();
  };

  DataPointTrend.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var appState = nextProps.appState;

    if (appState !== this.props.appState) {
      this.setState({ appState: appState });
    }
  };

  DataPointTrend.prototype.getFrom = function getFrom() {
    var timeRange = this.conditions.timeRange;

    var now = new Date();
    switch (timeRange) {
      case __WEBPACK_IMPORTED_MODULE_28__constants__["c" /* kLastHour */]:
        return __WEBPACK_IMPORTED_MODULE_9_date_fns_sub_hours___default()(now, 1);
      case __WEBPACK_IMPORTED_MODULE_28__constants__["a" /* kLastDay */]:
        return __WEBPACK_IMPORTED_MODULE_10_date_fns_sub_days___default()(now, 1);
      case __WEBPACK_IMPORTED_MODULE_28__constants__["d" /* kLastMonth */]:
        return __WEBPACK_IMPORTED_MODULE_11_date_fns_sub_months___default()(now, 1);
      default:
        return __WEBPACK_IMPORTED_MODULE_9_date_fns_sub_hours___default()(now, 1);
    }
  };

  DataPointTrend.prototype.loadData = function loadData() {
    var _this2 = this;

    var _props = this.props,
        appId = _props.appId,
        dpId = _props.dpId;

    this.setState({ status: 'pending' });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_lorautils_api__["a" /* callAPI */])({
      endpoint: '/lora/timeseries',
      method: 'POST',
      body: {
        appid: appId,
        dps: [dpId],
        from: this.getFrom(),
        limit: 1000
      }
    }).then(function (data) {
      _this2.data = data;
      _this2.setState({
        chartData: _this2.toChartData(data),
        status: 'success'
      });
    }).catch(function () {
      _this2.setState({
        status: 'failure'
      });
    });
  };

  DataPointTrend.prototype.toChartData = function toChartData() {
    var _this3 = this;

    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { list: [] };
    var dpId = this.props.dpId;
    var _conditions$filters = this.conditions.filters,
        filters = _conditions$filters === undefined ? [] : _conditions$filters;

    filters = filters.filter(function (f) {
      return f.value && f.value.length > 0;
    });

    // normalize
    var list = data.list.map(function (l) {
      return {
        timestamp: l.timestamp,
        value: l.metrics[dpId],
        deveui: l.nodeid
      };
    });
    list = _.sortBy(list, ['timestamp']);

    // filter
    if (filters.length > 0) {
      list = list.filter(function (d) {
        return _.some(filters, function (f) {
          if (f.type === __WEBPACK_IMPORTED_MODULE_28__constants__["e" /* kDeviceFilter */]) {
            return d.deveui.indexOf(f.value.trim().toLowerCase().replace(/[-:]/g, '')) >= 0;
          }
          return true;
        });
      });
    }

    var _conditions$series = this.conditions.series,
        series = _conditions$series === undefined ? [] : _conditions$series;

    var seriesList = void 0;

    // to sereis
    if (series.includes(__WEBPACK_IMPORTED_MODULE_28__constants__["f" /* kSeriesDevice */])) {
      var devices = list.reduce(function (acc, l) {
        return _.union(acc, [l.deveui]);
      }, []);
      seriesList = devices.map(function (device) {
        return {
          name: device,
          list: list.map(function (l) {
            if (l.deveui === device) {
              return l;
            }
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, l, {
              value: null
            });
          })
        };
      });
    } else {
      seriesList = [{
        name: dpId,
        list: list
      }];
    }

    // group
    seriesList = seriesList.map(function (serie) {
      var nli = [].concat(serie.list);
      if (nli.length > 1) {
        var _conditions$groupBy = _this3.conditions.groupBy,
            groupBy = _conditions$groupBy === undefined ? {} : _conditions$groupBy;
        var _groupBy$dims = groupBy.dims,
            dims = _groupBy$dims === undefined ? [] : _groupBy$dims,
            _groupBy$func = groupBy.func,
            func = _groupBy$func === undefined ? __WEBPACK_IMPORTED_MODULE_28__constants__["b" /* kGroupFuncSum */] : _groupBy$func;

        if (dims.length > 0) {
          var timeDim = dims.find(function (d) {
            return d.type === __WEBPACK_IMPORTED_MODULE_28__constants__["g" /* kGroupByTime */];
          });
          if (timeDim) {
            nli = nli.map(function (l) {
              var groupKey = void 0;
              if (timeDim.value === __WEBPACK_IMPORTED_MODULE_28__constants__["h" /* kGroupOneMin */]) {
                groupKey = __WEBPACK_IMPORTED_MODULE_13_date_fns_set_seconds___default()(__WEBPACK_IMPORTED_MODULE_12_date_fns_set_milliseconds___default()(l.timestamp, 0), 0);
              } else if (timeDim.value === __WEBPACK_IMPORTED_MODULE_28__constants__["i" /* kGroupTenMin */]) {
                groupKey = __WEBPACK_IMPORTED_MODULE_14_date_fns_set_minutes___default()(__WEBPACK_IMPORTED_MODULE_13_date_fns_set_seconds___default()(__WEBPACK_IMPORTED_MODULE_12_date_fns_set_milliseconds___default()(l.timestamp, 0), 0), Math.ceil(__WEBPACK_IMPORTED_MODULE_15_date_fns_get_minutes___default()(l.timestamp) / 10) * 10);
              } else if (timeDim.value === __WEBPACK_IMPORTED_MODULE_28__constants__["j" /* kGroupOneHour */]) {
                if (__WEBPACK_IMPORTED_MODULE_17_date_fns_is_equal___default()(l.timestamp, __WEBPACK_IMPORTED_MODULE_18_date_fns_start_of_hour___default()(l.timestamp))) {
                  groupKey = new Date(l.timestamp);
                } else {
                  groupKey = __WEBPACK_IMPORTED_MODULE_16_date_fns_add_hours___default()(__WEBPACK_IMPORTED_MODULE_14_date_fns_set_minutes___default()(__WEBPACK_IMPORTED_MODULE_13_date_fns_set_seconds___default()(__WEBPACK_IMPORTED_MODULE_12_date_fns_set_milliseconds___default()(l.timestamp, 0), 0), 0), 1);
                }
              }
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, l, { timestamp: groupKey });
            });
            var grped = _.groupBy(nli, 'timestamp');
            nli = _.map(grped, function (items, timestamp) {
              var values = _.map(items.filter(function (it) {
                return !_.isNil(it.value);
              }), function (item) {
                return Number(item.value);
              });
              var value = void 0;
              switch (func) {
                case __WEBPACK_IMPORTED_MODULE_28__constants__["b" /* kGroupFuncSum */]:
                  value = _.sum(values);
                  break;
                case __WEBPACK_IMPORTED_MODULE_28__constants__["k" /* kGroupFuncAvg */]:
                  value = _.sum(values) / values.length;
                  break;
                case __WEBPACK_IMPORTED_MODULE_28__constants__["l" /* kGroupFuncMax */]:
                  value = _.max(values);
                  break;
                case __WEBPACK_IMPORTED_MODULE_28__constants__["m" /* kGroupFuncMin */]:
                  value = _.min(values);
                  break;
                default:
                  break;
              }
              return {
                value: Number(value).toFixed(6),
                timestamp: timestamp
              };
            });
            nli = _.sortBy(nli, [function (x) {
              return __WEBPACK_IMPORTED_MODULE_19_date_fns_format___default()(x.timestamp, 'YYYY-MM-DD HH:mm:ss');
            }]);
          }
        }
      }
      return {
        name: serie.name,
        list: nli
      };
    });

    var categories = [];
    if (seriesList.length > 0 && seriesList[0].list.length > 0) {
      categories = seriesList[0].list.map(function (l) {
        return __WEBPACK_IMPORTED_MODULE_19_date_fns_format___default()(l.timestamp, 'YYYY-MM-DD HH:mm:ss');
      });
    }

    return {
      series: seriesList.map(function (li) {
        return {
          name: li.name,
          data: li.list.map(function (d) {
            return d.value;
          }),
          connectNulls: true
        };
      }),
      categories: categories
    };
  };

  DataPointTrend.prototype.handleChangeConditions = function handleChangeConditions(conditions) {
    this.setState({ conditions: conditions });
    if (this.conditions.timeRange !== conditions.timeRange) {
      this.conditions = conditions;
      this.loadData();
    } else {
      this.conditions = conditions;
      this.setState({
        chartData: this.toChartData(this.data)
      });
    }
  };

  DataPointTrend.prototype.render = function render() {
    var _props2 = this.props,
        appId = _props2.appId,
        dpId = _props2.dpId,
        pushState = _props2.pushState;
    var _state = this.state,
        conditions = _state.conditions,
        _state$chartData = _state.chartData,
        chartData = _state$chartData === undefined ? {} : _state$chartData,
        status = _state.status,
        appState = _state.appState;
    var appStatus = appState.status,
        _appState$data = appState.data;
    _appState$data = _appState$data === undefined ? {} : _appState$data;
    var appName = _appState$data.name;
    var _chartData$series = chartData.series,
        series = _chartData$series === undefined ? [] : _chartData$series,
        _chartData$categories = chartData.categories,
        categories = _chartData$categories === undefined ? [] : _chartData$categories;

    var breadcrumb = [{
      content: this.intlMsg.msg('breadcrumb.application', 'application'),
      onClick: function onClick() {
        return pushState('/application');
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_loracoms_Nvl__["a" /* default */], { status: appStatus, val: appName }),
      onClick: function onClick() {
        return pushState("/application/" + appId + "/dps");
      }
    }, {
      content: dpId,
      active: true
    }];
    var header = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "ul",
        { className: "icontools" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_loracoms_Refresher__["a" /* default */], {
            onReload: this.loadData,
            reloading: status === 'pending'
          })
        )
      )
    );

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_27__styles_scss___default.a.trend },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__coms_Conditions__["a" /* default */], {
        data: conditions,
        onChange: this.handleChangeConditions
      }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Panel"],
        { bsStyle: "aisz-white", header: header },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_27__styles_scss___default.a.chart },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_loracoms_LineChart__["a" /* default */], {
            series: series,
            categories: categories,
            xAixs: {
              type: 'time',
              axisLabel: {
                formatter: function formatter(x) {
                  return __WEBPACK_IMPORTED_MODULE_19_date_fns_format___default()(x, 'YYYY-MM-DD HH:mm:ss');
                }
              }
            }
          })
        )
      )
    );
  };

  return DataPointTrend;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    appId: ownProps.params.id,
    dpId: ownProps.params.dpId,
    appState: state.app.getApp
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["routerActions"].push
};

DataPointTrend.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(DataPointTrend)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_sub_hours__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_sub_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_sub_hours__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_Editable__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_AutoColor__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_LineChart__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss__ = __webpack_require__(2202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired
};

var DataPoints = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DataPoints, _React$Component);

  function DataPoints(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DataPoints);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {};
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_17_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.parseview.datapoints');
    _this.handleChangeDesc = _this.handleChangeDesc.bind(_this);
    _this.handleSubmitDesc = _this.handleSubmitDesc.bind(_this);
    return _this;
  }

  DataPoints.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var appId = this.props.appId;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lorautils_api__["a" /* callAPI */])({
      endpoint: '/lora/dps',
      query: {
        appid: appId
      }
    }).then(function (data) {
      _this2.setState({
        dataPoints: data.list,
        status: 'success'
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lorautils_api__["a" /* callAPI */])({
        endpoint: '/lora/timeseries',
        method: 'POST',
        body: {
          appid: appId,
          dps: data.list.map(function (dp) {
            return dp.id;
          }),
          from: __WEBPACK_IMPORTED_MODULE_9_date_fns_sub_hours___default()(new Date(), 1),
          limit: 1000
        }
      }).then(function (tsData) {
        tsData.list.reverse();
        _this2.setState({
          timeSeries: tsData.list,
          categories: _.map(tsData.list, 'timestamp')
        });
      }).catch(function () {});
    }).catch(function () {
      _this2.setState({ status: 'failure' });
    });
  };

  DataPoints.prototype.getSeries = function getSeries(id) {
    var _state$timeSeries = this.state.timeSeries,
        timeSeries = _state$timeSeries === undefined ? [] : _state$timeSeries;

    var data = timeSeries.map(function (item) {
      if (!_.isNil(item.metrics[id])) {
        return item.metrics[id];
      }
      return '-';
    });
    return { data: data };
  };

  DataPoints.prototype.handleChangeDesc = function handleChangeDesc(data) {
    this.setState({ editDescData: data });
  };

  DataPoints.prototype.handleSubmitDesc = function handleSubmitDesc() {
    var _this3 = this;

    var appId = this.props.appId;
    var _state = this.state,
        id = _state.editDesc,
        editDescData = _state.editDescData,
        dataPoints = _state.dataPoints;

    if (!_.isNil(id)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lorautils_api__["a" /* callAPI */])({
        endpoint: '/lora/dps',
        body: {
          id: id,
          desc: editDescData[id],
          appid: appId
        },
        method: 'PUT'
      }).then(function () {
        _this3.setState({
          dataPoints: dataPoints.map(function (dp) {
            if (dp.id === id) {
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, dp, { desc: editDescData[id] });
            }
            return dp;
          })
        });
      }).catch(function () {});
    }
    this.setState({ editDesc: '' });
  };

  DataPoints.prototype.render = function render() {
    var _this4 = this;

    var _props = this.props,
        pushState = _props.pushState,
        appId = _props.appId;
    var _state2 = this.state,
        _state2$dataPoints = _state2.dataPoints,
        dataPoints = _state2$dataPoints === undefined ? [] : _state2$dataPoints,
        _state2$status = _state2.status,
        status = _state2$status === undefined ? 'pending' : _state2$status,
        _state2$editDesc = _state2.editDesc,
        editDesc = _state2$editDesc === undefined ? '' : _state2$editDesc,
        _state2$editDescData = _state2.editDescData,
        editDescData = _state2$editDescData === undefined ? {} : _state2$editDescData,
        _state2$categories = _state2.categories,
        categories = _state2$categories === undefined ? [] : _state2$categories;

    if (status === 'pending') {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.loading },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin fa-3x" })
      );
    }
    if (dataPoints.length === 0) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "text-center" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.noData },
          this.intlMsg.msg('nodps')
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.guide },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "p",
            null,
            this.intlMsg.msg('how')
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "ol",
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "li",
              null,
              this.intlMsg.msg('how.tx')
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "li",
              null,
              this.intlMsg.msg('how.parse.prefix'),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                { onClick: function onClick() {
                    return pushState("/application/" + appId + "/parse");
                  } },
                this.intlMsg.msg('how.parse.parser')
              ),
              this.intlMsg.msg('how.parse.postfix')
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "li",
              null,
              this.intlMsg.msg('how.dps')
            )
          )
        )
      );
    }

    var dps = dataPoints.map(function (dp) {
      var series = _this4.getSeries(dp.id);
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { key: dp.id, className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.dp + " " + __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a[dp.type] },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.block },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
            { onClick: function onClick() {
                return pushState("/application/" + appId + "/dps/" + dp.id + "/trend");
              } },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { className: "text-center" },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_15_loracoms_AutoColor__["a" /* default */],
                { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.circle, content: dp.id },
                dp.id[0]
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "text-center" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_RichLabel__["a" /* default */], { content: dp.type, inverse: true })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.block + " " + __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.basic },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.id },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
              { onClick: function onClick() {
                  return pushState("/application/" + appId + "/dps/" + dp.id + "/trend");
                } },
              dp.id
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
              {
                className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.trendLink,
                onClick: function onClick() {
                  return pushState("/application/" + appId + "/dps/" + dp.id + "/trend");
                }
              },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-line-chart" })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.desc },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Editable__["a" /* default */], {
              id: dp.id,
              value: dp.desc,
              data: editDescData,
              edit: editDesc === dp.id,
              onChange: _this4.handleChangeDesc,
              formatter: function formatter(x) {
                if (x === '' || _.isNil(x)) {
                  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                    {
                      onClick: function onClick() {
                        _this4.setState({ editDesc: dp.id });
                      },
                      className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.clickToEdit
                    },
                    _this4.intlMsg.msg('clicktoedit')
                  );
                }
                return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  null,
                  x
                );
              }
            }),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
              { "if": dp.desc !== '' && !_.isNil(dp.desc) && editDesc !== dp.id },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                {
                  className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.edit,
                  onClick: function onClick() {
                    var _editDescData;

                    return _this4.setState({
                      editDesc: dp.id,
                      editDescData: (_editDescData = {}, _editDescData[dp.id] = dp.desc, _editDescData)
                    });
                  }
                },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-pencil" })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
              { "if": editDesc === dp.id },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "span",
                { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.submit },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                  {
                    className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.ok,
                    onClick: _this4.handleSubmitDesc
                  },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-ok" })
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                  { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.cancel, onClick: function onClick() {
                      return _this4.setState({ editDesc: '' });
                    } },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-remove" })
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.block + " " + __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.trend },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_LineChart__["a" /* default */], {
            series: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, series, {
              areaStyle: {
                normal: {
                  opacity: 0
                }
              },
              showAllSymbol: true
            })],
            categories: categories,
            height: 74,
            xAxis: { show: false },
            yAxis: { show: false },
            grid: {
              left: 10,
              top: 10,
              right: 0,
              bottom: 20
            },
            tooltip: {
              formatter: function formatter(params) {
                return __WEBPACK_IMPORTED_MODULE_10_date_fns_format___default()(params[0].name, 'YYYY-MM-DD HH:mm:ss') + "<br/>" + dp.id + ": " + params[0].value;
              }
            }
          })
        )
      );
    });

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.container },
      dps
    );
  };

  return DataPoints;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["routerActions"].push
};

DataPoints.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(DataPoints)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_PageLoading__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_PageNoPerm__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__coms_DataPoints__ = __webpack_require__(1195);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var propTypes = {
  appId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  appState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  planState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var DataPointsView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DataPointsView, _React$Component);

  function DataPointsView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DataPointsView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      appState: props.appState,
      planState: props.planState
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.datapointsview');
    return _this;
  }

  DataPointsView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var appState = nextProps.appState,
        planState = nextProps.planState;

    if (appState !== this.props.appState) {
      this.setState({ appState: appState });
    }
    if (planState !== this.props.planState) {
      this.setState({ planState: planState });
    }
  };

  DataPointsView.prototype.render = function render() {
    var _props = this.props,
        appId = _props.appId,
        pushState = _props.pushState;
    var _state = this.state,
        _state$appState = _state.appState,
        _state$appState$statu = _state$appState.status,
        status = _state$appState$statu === undefined ? '' : _state$appState$statu,
        _state$appState$data = _state$appState.data;
    _state$appState$data = _state$appState$data === undefined ? {} : _state$appState$data;
    var _state$appState$data$ = _state$appState$data.name,
        name = _state$appState$data$ === undefined ? '' : _state$appState$data$,
        planState = _state.planState;


    if (planState.status === 'pending') {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_PageLoading__["a" /* default */], null);
    }
    if (planState.data.tier === 1) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_PageNoPerm__["a" /* default */], null);
    }

    var breadcrumb = [{
      content: this.intlMsg.msg('breadcrumb.application', 'application'),
      onClick: function onClick() {
        return pushState('/application');
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Nvl__["a" /* default */], { status: status, val: name }),
      active: true
    }];
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__coms_DataPoints__["a" /* default */], { appId: appId })
        )
      )
    );
  };

  return DataPointsView;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DataPointsView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    appId: ownProps.params.id,
    appState: state.app.getApp,
    planState: state.billing.plan
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_7_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(DataPointsView)));

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_Copy__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_Editable__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loraactions_app__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_loraactions_datapoint__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_loraactions_flow__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_loraactions_parser__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__DeleteAppModal__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__DeleteErrorModal__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__styles_scss__ = __webpack_require__(2203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);
























var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  app: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  updateApp: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  updated: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  countDevices: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  countDataPoints: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  countFlows: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  countParsers: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  devCntState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  dpCntState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  flowCntState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  parserCntState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getApp: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var AppProps = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(AppProps, _React$Component);

  function AppProps(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AppProps);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      app: props.app,
      devCntState: props.devCntState,
      dpCntState: props.dpCntState,
      flowCntState: props.flowCntState,
      parserCntState: props.parserCntState,
      errors: new __WEBPACK_IMPORTED_MODULE_16_lorautils_errors_ErrorSet__["a" /* default */]()
    };
    _this.handleSubmitName = _this.handleSubmitName.bind(_this);
    _this.handleEditName = _this.handleEditName.bind(_this);
    _this.handleChangeName = _this.handleChangeName.bind(_this);
    _this.handleDelete = _this.handleDelete.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_15_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.detailview.appprops');
    return _this;
  }

  AppProps.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        appId = _props.appId,
        countDevices = _props.countDevices,
        countDataPoints = _props.countDataPoints,
        countFlows = _props.countFlows,
        countParsers = _props.countParsers;

    countDevices({ app: appId });
    countDataPoints({ app: appId });
    countFlows({ app: appId });
    countParsers({ app: appId });
  };

  AppProps.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var app = nextProps.app,
        updated = nextProps.updated,
        devCntState = nextProps.devCntState,
        dpCntState = nextProps.dpCntState,
        flowCntState = nextProps.flowCntState,
        parserCntState = nextProps.parserCntState;

    this.setState({ app: app });

    if (updated !== this.props.updated) {
      if (updated.status === 'success') {
        var appId = nextProps.appId,
            getApp = nextProps.getApp;

        getApp(appId);
      }
    }

    if (devCntState !== this.props.devCntState) {
      this.setState({ devCntState: devCntState });
    }
    if (dpCntState !== this.props.dpCntState) {
      this.setState({ dpCntState: dpCntState });
    }
    if (flowCntState !== this.props.flowCntState) {
      this.setState({ flowCntState: flowCntState });
    }
    if (parserCntState !== this.props.parserCntState) {
      this.setState({ parserCntState: parserCntState });
    }
  };

  AppProps.prototype.handleSubmitName = function handleSubmitName() {
    var _props2 = this.props,
        appId = _props2.appId,
        updateApp = _props2.updateApp;
    var _state = this.state,
        name = _state.editData.name,
        errors = _state.errors;

    if (_.trim(name).length !== 0) {
      updateApp(appId, { name: name });
      this.setState({ editName: false });
    } else {
      this.setState({ errors: errors.add('FE_EMPTY', 'name') });
    }
  };

  AppProps.prototype.handleEditName = function handleEditName() {
    var _state$app$data = this.state.app.data,
        data = _state$app$data === undefined ? {} : _state$app$data;

    this.setState({
      editName: true,
      editData: { name: data.name }
    });
  };

  AppProps.prototype.handleChangeName = function handleChangeName(data) {
    var errors = this.state.errors;

    this.setState({ editData: data, errors: errors.remove('name') });
  };

  AppProps.prototype.handleDelete = function handleDelete() {
    var _state2 = this.state,
        devCntState = _state2.devCntState,
        errors = _state2.errors;

    if (devCntState.status !== 'success') {
      return;
    }

    if (devCntState.data.count === 0) {
      this.setState({ showDelete: true });
    } else {
      this.setState({
        errors: errors.add('FE_DEVICESEXIST', 'delete')
      });
    }
  };

  AppProps.prototype.render = function render() {
    var _this2 = this;

    var _props3 = this.props,
        appId = _props3.appId,
        pushState = _props3.pushState;
    var _state3 = this.state,
        app = _state3.app,
        _state3$editName = _state3.editName,
        editName = _state3$editName === undefined ? false : _state3$editName,
        _state3$editData = _state3.editData,
        editData = _state3$editData === undefined ? {} : _state3$editData,
        _state3$devCntState = _state3.devCntState,
        devCountStatus = _state3$devCntState.status,
        _state3$devCntState$d = _state3$devCntState.data;
    _state3$devCntState$d = _state3$devCntState$d === undefined ? {} : _state3$devCntState$d;
    var devCount = _state3$devCntState$d.count,
        _state3$dpCntState = _state3.dpCntState,
        dpCountStatus = _state3$dpCntState.status,
        _state3$dpCntState$da = _state3$dpCntState.data;
    _state3$dpCntState$da = _state3$dpCntState$da === undefined ? {} : _state3$dpCntState$da;
    var dpCount = _state3$dpCntState$da.count,
        _state3$flowCntState = _state3.flowCntState,
        flowCountStatus = _state3$flowCntState.status,
        _state3$flowCntState$ = _state3$flowCntState.data;
    _state3$flowCntState$ = _state3$flowCntState$ === undefined ? {} : _state3$flowCntState$;
    var flowCount = _state3$flowCntState$.count,
        _state3$parserCntStat = _state3.parserCntState,
        parserCountStatus = _state3$parserCntStat.status,
        _state3$parserCntStat2 = _state3$parserCntStat.data;
    _state3$parserCntStat2 = _state3$parserCntStat2 === undefined ? {} : _state3$parserCntStat2;
    var parserCount = _state3$parserCntStat2.count,
        _state3$showDelete = _state3.showDelete,
        showDelete = _state3$showDelete === undefined ? false : _state3$showDelete,
        errors = _state3.errors;
    var _app$data = app.data,
        data = _app$data === undefined ? {} : _app$data;


    var devCntHeader = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: "text-center" },
      this.intlMsg.msg('devicecount')
    );
    var dpCntHeader = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: "text-center" },
      this.intlMsg.msg('dpcount')
    );
    var flowCntHeader = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: "text-center" },
      this.intlMsg.msg('flowcount')
    );
    var parserCntHeader = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: "text-center" },
      this.intlMsg.msg('parsercount')
    );

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.container },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Panel"],
          {
            bsStyle: "aisz-white",
            header: this.intlMsg.msg('title'),
            className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.basic
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.content },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.name },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Editable__["a" /* default */], {
                id: "name",
                edit: editName,
                value: data.name,
                data: editData,
                onChange: this.handleChangeName,
                formatter: function formatter(x) {
                  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Nvl__["a" /* default */], { val: x, status: app.status });
                },
                error: this.intlMsg.errorMsg(errors.get('name')),
                errorPlacement: 'top'
              }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_13_loracoms_ShowIf__["a" /* default */],
                { "if": editName },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "ul",
                  { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.buttons },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "li",
                    null,
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Button"],
                      {
                        bsStyle: "aisz-link-success",
                        onClick: this.handleSubmitName
                      },
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-ok" })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "li",
                    null,
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Button"],
                      {
                        bsStyle: "aisz-link-warning",
                        onClick: function onClick() {
                          return _this2.setState({ editName: false, errors: errors.remove('name') });
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-remove" })
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_13_loracoms_ShowIf__["a" /* default */],
                { "if": !editName },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
                  {
                    className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.edit,
                    onClick: this.handleEditName
                  },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicon glyphicon-pencil" })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "ul",
              { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.props },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "span",
                  { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.label },
                  "APPEUI"
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Nvl__["a" /* default */], { val: data.appeui, status: app.status, formatter: __WEBPACK_IMPORTED_MODULE_14_lorautils_IdUtils__["d" /* normalizeAppEUI */] }),
                ' ',
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_Copy__["a" /* default */], { id: "appeui", text: data.appeui })
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "span",
                  { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.label },
                  this.intlMsg.msg('createtime')
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Nvl__["a" /* default */], {
                  val: data.createdAt,
                  status: app.status,
                  formatter: function formatter(x) {
                    return __WEBPACK_IMPORTED_MODULE_4_date_fns_format___default()(x, 'YYYY-MM-DD HH:mm:ss');
                  }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.delete },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Button"],
                { bsStyle: "aisz-danger-b", onClick: this.handleDelete },
                this.intlMsg.msg('delete'),
                ' ',
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-trash" })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Panel"],
          {
            bsStyle: "aisz-info",
            header: devCntHeader,
            className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.count
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Nvl__["a" /* default */], { val: devCount, status: devCountStatus })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13_loracoms_ShowIf__["a" /* default */],
          { "if": "profile:cloud" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Panel"],
            {
              bsStyle: "aisz-info",
              header: parserCntHeader,
              className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.count
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
              { onClick: function onClick() {
                  return pushState("/application/" + appId + "/parse");
                } },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Nvl__["a" /* default */], { val: parserCount, status: parserCountStatus })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13_loracoms_ShowIf__["a" /* default */],
          { "if": "profile:cloud" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Panel"],
            {
              bsStyle: "aisz-info",
              header: dpCntHeader,
              className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.count
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
              { onClick: function onClick() {
                  return pushState("/application/" + appId + "/dps");
                } },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Nvl__["a" /* default */], { val: dpCount, status: dpCountStatus })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13_loracoms_ShowIf__["a" /* default */],
          { "if": "profile:cloud" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Panel"],
            {
              bsStyle: "aisz-info",
              header: flowCntHeader,
              className: __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a.count
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
              { onClick: function onClick() {
                  return pushState("/application/" + appId + "/flows");
                } },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Nvl__["a" /* default */], { val: flowCount, status: flowCountStatus })
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__DeleteAppModal__["a" /* default */], {
        show: showDelete,
        appId: appId,
        onHide: function onHide() {
          return _this2.setState({ showDelete: false });
        }
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__DeleteErrorModal__["a" /* default */], {
        error: errors.getCode('delete'),
        onHide: function onHide() {
          return _this2.setState({ errors: errors.remove('delete') });
        }
      })
    );
  };

  return AppProps;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

AppProps.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    app: state.app.getApp,
    updated: state.app.updateApp,
    devCntState: state.device.countDevices,
    dpCntState: state.datapoint.countDataPoints,
    flowCntState: state.flow.countFlows,
    parserCntState: state.parser.countParsers
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["routerActions"].push,
  updateApp: __WEBPACK_IMPORTED_MODULE_17_loraactions_app__["a" /* default */].updateApp,
  getApp: __WEBPACK_IMPORTED_MODULE_17_loraactions_app__["a" /* default */].getApp,
  countDevices: __WEBPACK_IMPORTED_MODULE_18_loraactions_device__["a" /* default */].countDevices,
  countDataPoints: __WEBPACK_IMPORTED_MODULE_19_loraactions_datapoint__["a" /* default */].countDataPoints,
  countFlows: __WEBPACK_IMPORTED_MODULE_20_loraactions_flow__["a" /* default */].countFlows,
  countParsers: __WEBPACK_IMPORTED_MODULE_21_loraactions_parser__["a" /* default */].countParsers
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(AppProps)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loraactions_app__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loraactions_usage__ = __webpack_require__(155);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);










var defaultProps = {
  show: false,
  error: null
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  deleteApp: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  app: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  deleted: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  show: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool
};

var DeleteAppModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeleteAppModal, _React$Component);

  function DeleteAppModal(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeleteAppModal);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      app: props.app,
      show: props.show
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.detailview.delete');
    _this.handleDelete = _this.handleDelete.bind(_this);
    return _this;
  }

  DeleteAppModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var app = nextProps.app,
        deleted = nextProps.deleted,
        show = nextProps.show,
        getAppsUsage = nextProps.getAppsUsage;

    if (app !== this.props.app) {
      this.setState({ app: app });
    }
    if (deleted !== this.props.deleted) {
      if (deleted.status === 'success') {
        getAppsUsage();
        nextProps.pushState('/application');
      }
    }
    if (show !== this.props.show) {
      this.setState({ show: show });
    }
  };

  DeleteAppModal.prototype.handleDelete = function handleDelete() {
    var _props = this.props,
        appId = _props.appId,
        deleteApp = _props.deleteApp;

    deleteApp(appId);
  };

  DeleteAppModal.prototype.render = function render() {
    var _props2 = this.props,
        appId = _props2.appId,
        onHide = _props2.onHide;
    var _state = this.state,
        _state$app$data = _state.app.data,
        data = _state$app$data === undefined ? {} : _state$app$data,
        show = _state.show;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-danger",
        show: show,
        onHide: onHide
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "text-center" },
          this.intlMsg.msg('modalheader')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "p",
            null,
            this.intlMsg.msg('modalcontent'),
            ' ',
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "strong",
              null,
              data.name,
              "(",
              appId,
              ")"
            ),
            " ?"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
            { bsStyle: "aisz-warning", onClick: onHide },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-repeat" }),
            ' ',
            this.intlMsg.msg('cancelbtn')
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
            { bsStyle: "aisz-danger", onClick: this.handleDelete },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-trash-o" }),
            ' ',
            this.intlMsg.msg('confirmbtn')
          )
        )
      )
    );
  };

  return DeleteAppModal;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DeleteAppModal.defaultProps = defaultProps;
DeleteAppModal.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    deleted: state.app.deleteApp,
    app: state.app.getApp
  };
};

var mapDispatchToProps = {
  deleteApp: __WEBPACK_IMPORTED_MODULE_9_loraactions_app__["a" /* default */].deleteApp,
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push,
  getAppsUsage: __WEBPACK_IMPORTED_MODULE_10_loraactions_usage__["a" /* default */].apps
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(DeleteAppModal)));

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__ = __webpack_require__(7);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);






var defaultProps = {
  error: null
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  error: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string,
  onHide: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var DeleteErrorModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeleteErrorModal, _React$Component);

  function DeleteErrorModal(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeleteErrorModal);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      error: props.error
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.detailview.delete');
    return _this;
  }

  DeleteErrorModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var error = nextProps.error;

    if (error !== this.props.error) {
      this.setState({ error: error });
    }
  };

  DeleteErrorModal.prototype.render = function render() {
    var onHide = this.props.onHide;
    var error = this.state.error;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-warning",
        show: !_.isNil(error),
        onHide: onHide
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle" }),
          ' ',
          this.intlMsg.msg('error.modalheader')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "text-center" },
          this.intlMsg.errorMsg(error)
        )
      )
    );
  };

  return DeleteErrorModal;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DeleteErrorModal.defaultProps = defaultProps;
DeleteErrorModal.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(DeleteErrorModal));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_difference_in_seconds__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_difference_in_seconds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_difference_in_seconds__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_Checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_SearchFlag__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_SearchInput__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loracoms_SortBtn__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loracoms_TablePagers__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_loracoms_LoadingTable__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_loracoms_PanelToolbar__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_loracoms_Link__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_loraactions_usage__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_loraactions_org__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_loraactions_enums__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lorautils_api_selector__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_loraapi_lora_device__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_lorautils_csvdl__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_lorautils_pagerUtil__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ImportABPModal__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ImportOTAAModal__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__DeviceOOQModal__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_loracoms_PageSizer__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__styles_scss__ = __webpack_require__(2204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_lorautils_DateTimeUtils__ = __webpack_require__(139);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







































var kNotReady = "not-ready";
var kOOQ = "ooq";
var kOk = "ok";
var kRouterAction = ["REPLACE", "POP"];
var kMarksKey = "appDevMarks";
var kDlKeys = ["deveui", "devaddr", "nwkskey", "appskey", "appkey", "band", "city", "area", "address", "lng", "lat", "lastact", "class", "lwanver", "name", "type", "rxwindow", "rx2dr", "rx2freq", "vendor", "vendorver"];

function isNewDevice(device) {
  return __WEBPACK_IMPORTED_MODULE_7_date_fns_difference_in_seconds___default()(new Date(), device.createdAt) < 10;
}

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.any.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired,
  plan: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  getNodesUsage: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  getOrgBasic: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  basic: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  usage: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  countDevices: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  getBands: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  bandOpts: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.array.isRequired,
  routerAction: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired
};

var DeviceList = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DeviceList, _React$Component);

  function DeviceList(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DeviceList);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      basic: props.basic,
      plan: props.plan,
      usage: props.usage,
      devices: [],
      checked: [],
      status: "idle",
      initialLoad: "pending",
      deleting: false,
      bandOpts: props.bandOpts,
      sort: "-ctime",
      limit: 20
    };
    _this.deleteQueue = [];
    _this.loadList = [];
    _this.mark = 0;
    _this.page = 0;
    _this.handleChangeMark = _this.handleChangeMark.bind(_this);
    _this.handleSearch = _this.handleSearch.bind(_this);
    _this.handleToggleCheckAll = _this.handleToggleCheckAll.bind(_this);
    _this.handleAutoGen = _this.handleAutoGen.bind(_this);
    _this.handleDelete = _this.handleDelete.bind(_this);
    _this.handleAdded = _this.handleAdded.bind(_this);
    _this.handleExportAll = _this.handleExportAll.bind(_this);
    _this.handleChangePageSize = _this.handleChangePageSize.bind(_this);
    _this.handleSort = _this.handleSort.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_23_lorautils_intl_IntlMsg__["a" /* default */](props.intl, "applicationdetail.detailview.devicelist");
    return _this;
  }

  DeviceList.prototype.componentWillMount = function componentWillMount() {
    var getBands = this.props.getBands;

    getBands();
  };

  DeviceList.prototype.componentDidMount = function componentDidMount() {
    this.loadDevices();
  };

  DeviceList.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var plan = nextProps.plan,
        basic = nextProps.basic,
        usage = nextProps.usage,
        bandOpts = nextProps.bandOpts;

    if (plan !== this.props.plan) {
      this.setState({ plan: plan });
    }
    if (basic !== this.props.basic) {
      this.setState({ basic: basic });
    }
    if (usage !== this.props.usage) {
      this.setState({ usage: usage });
    }
    if (bandOpts !== this.props.bandOpts) {
      this.setState({ bandOpts: bandOpts });
    }
  };

  //改变页面显示数量


  DeviceList.prototype.handleChangePageSize = function handleChangePageSize(length) {
    this.setState({ limit: length });
    this.mark = 0;
    this.loadDevices(length);
  };

  //翻页


  DeviceList.prototype.handleChangeMark = function handleChangeMark(flag) {
    var limit = this.state.limit;

    if (flag) {
      //下一页
      this.mark += limit;
    } else {
      //上一页
      this.mark -= limit;
      this.mark = this.mark < 0 ? 0 : this.mark;
    }
    this.loadDevices();
  };

  DeviceList.prototype.loadDevices = function loadDevices(length) {
    var _this2 = this;

    var appId = this.props.appId;
    var sort = this.state.sort;
    var limit = this.state.limit;


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29_lorautils_api__["a" /* callAPI */])({
      endpoint: "/lora/nodes",
      query: {
        app: appId,
        sort: sort,
        limit: length || limit,
        q: this.q,
        mark: this.mark
      }
    }).then(function (data) {
      var list = data.list,
          more = data.more;

      _this2.setState({
        devices: list,
        checked: [],
        status: "success",
        initialLoad: "success",
        more: more
      });
    }).catch(function () {
      _this2.setState({
        status: "failure",
        initialLoad: "failure"
      });
    });
  };

  DeviceList.prototype.handleSearch = function handleSearch(e) {
    var search = e.target.value;
    this.setState({
      search: search
    });
    this.mark = 0;

    if (search.length > 0) {
      var s = search.replace(/[:-]/g, "");
      this.q = "or,name:*" + s + "*,deveui:*" + s + "*,devaddr:*" + s + "*,appIdeui:" + s + "*,city:*" + s + "*,area:*" + s + "*,band:*" + s + "*";
      this.loadDevices();
    } else {
      this.q = null;
      this.loadDevices();
    }
  };

  DeviceList.prototype.allChecked = function allChecked() {
    var _state = this.state,
        devices = _state.devices,
        checked = _state.checked;

    return devices.length > 0 && devices.length === checked.length;
  };

  DeviceList.prototype.isChecked = function isChecked(d) {
    return _.some(this.state.checked, { deveui: d.deveui });
  };

  DeviceList.prototype.toggleCheck = function toggleCheck(d) {
    var checked = this.state.checked;
    if (this.isChecked(d)) {
      this.setState({
        checked: _.filter(checked, function (a) {
          return a.deveui !== d.deveui;
        })
      });
    } else {
      checked.push(d);
      this.setState({ checked: checked });
    }
  };

  DeviceList.prototype.handleToggleCheckAll = function handleToggleCheckAll() {
    this.setState({
      checked: this.allChecked() ? [] : this.state.devices
    });
  };

  DeviceList.prototype.checkOOQ = function checkOOQ() {
    var _state2 = this.state,
        basic = _state2.basic,
        usage = _state2.usage;

    if (!basic.status === "success" || usage.pendings.includes("nodes")) {
      return kNotReady;
    }

    var lrnodenum = basic.data.lrnodenum;

    if (usage.nodes >= lrnodenum) {
      return kOOQ;
    }

    return kOk;
  };

  DeviceList.prototype.handleAutoGen = function handleAutoGen(band) {
    var _this3 = this;

    var ooqCheck = this.checkOOQ();
    if (ooqCheck === kNotReady) {
      return;
    }
    if (ooqCheck === kOOQ) {
      this.setState({ error: "QUOTA" });
      return;
    }

    this.setState({ error: null });
    var appId = this.props.appId;

    var rand = function rand(length) {
      return _.map(_.range(length), function () {
        return _.sample("ABCDEF0123456789");
      }).join("");
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30_loraapi_lora_device__["j" /* addOTAA */])(appId, rand(16), rand(32), band).then(function () {
      _this3.handleAdded();
    }).catch(function (err) {
      _this3.setState({ error: err.errcode });
    });
  };

  DeviceList.prototype.handleDelete = function handleDelete() {
    var _this4 = this;

    var _state$checked = this.state.checked,
        checked = _state$checked === undefined ? [] : _state$checked;

    // tag 'deleting' status to devices

    var _state$devices = this.state.devices,
        devices = _state$devices === undefined ? [] : _state$devices;

    devices = devices.map(function (dev) {
      if (_.findIndex(checked, function (d) {
        return d.id === dev.id;
      }) >= 0) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, dev, {
          deleting: true
        });
      }
      return dev;
    });
    this.setState({
      deleting: true,
      devices: devices
    });
    this.mark = 0;

    var _props = this.props,
        appId = _props.appId,
        getNodesUsage = _props.getNodesUsage,
        getOrgBasic = _props.getOrgBasic,
        countDevices = _props.countDevices;


    var deleteDone = function deleteDone() {
      _this4.loadDevices();
      getOrgBasic();
      getNodesUsage();
      countDevices({ app: appId });
      _this4.setState({ deleting: false });
    };

    this.deleteQueue = _.concat(this.deleteQueue, checked);

    // delete device one by one
    // cannot delete concurrently due to a backend bug
    var delFunc = function delFunc() {
      if (_this4.deleteQueue.length > 0) {
        var dev = _this4.deleteQueue.pop();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29_lorautils_api__["a" /* callAPI */])({
          endpoint: "/lora/nodes/" + dev.id,
          method: "DELETE"
        }).then(function () {
          _.find(devices, function (d) {
            return d.id === dev.id;
          }).deleted = true;
          _this4.setState({ devices: devices });
          delFunc();
        }).catch(function () {
          _.find(devices, function (d) {
            return d.id === dev.id;
          }).deleting = false;
          _this4.setState({ devices: devices });
          delFunc();
        });
      } else {
        deleteDone();
      }
    };

    delFunc();
  };

  DeviceList.prototype.handleAdded = function handleAdded() {
    var _props2 = this.props,
        appId = _props2.appId,
        getOrgBasic = _props2.getOrgBasic,
        getNodesUsage = _props2.getNodesUsage,
        countDevices = _props2.countDevices;


    this.setState({
      showImport: false
    });
    this.mark = 0;

    getOrgBasic();
    getNodesUsage();
    countDevices({ app: appId });
    this.loadDevices();
  };

  DeviceList.prototype.handleImport = function handleImport(type) {
    var ooqCheck = this.checkOOQ();
    if (ooqCheck === kNotReady) {
      return;
    }
    if (ooqCheck === kOOQ) {
      this.setState({ error: "QUOTA" });
      return;
    }
    this.setState({ error: null });

    var _props3 = this.props,
        appId = _props3.appId,
        pushState = _props3.pushState;

    this.importType = type;
    this.setState({
      showImport: true
    });

    this.type = type;
    if (type === "abp" || type === "otaa") {
      this.setState({ showImport: true });
    } else if (type === "batch") {
      pushState("/application/" + appId + "/batchimp");
    }
  };

  DeviceList.prototype.handleExportAll = function handleExportAll() {
    var _this5 = this;

    var appId = this.props.appId;

    this.loadList = [];
    var limit = 999;

    var downloadFun = function downloadFun() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29_lorautils_api__["a" /* callAPI */])({
        endpoint: "/lora/nodes",
        query: {
          app: appId,
          sort: "-ctime",
          limit: limit,
          mark: _this5.page
        }
      }).then(function (data) {
        _this5.loadList = [].concat(_this5.loadList, data.list);
        _this5.page += limit;
        if (data.more) {
          downloadFun();
        } else {
          _this5.loadList.forEach(function (item) {
            item.lastact = item.lastact ? __WEBPACK_IMPORTED_MODULE_6_date_fns_format___default()(item.lastact * 1000, "YYYY/MM/DD HH:mm:ss") : "";
          });
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32_lorautils_csvdl__["a" /* default */])(_this5.loadList, appId + "_" + __WEBPACK_IMPORTED_MODULE_6_date_fns_format___default()(new Date(), "YYYYMMDDHHmmss") + ".csv", kDlKeys);
          _this5.page = 0;
          return;
        }
      }).catch(function () {});
    };
    downloadFun();
    return;
  };

  DeviceList.prototype.handleSort = function handleSort(sort) {
    var _this6 = this;

    this.mark = 0;
    this.setState({ sort: sort }, function () {
      _this6.loadDevices();
    });
  };

  DeviceList.prototype.renderDevices = function renderDevices() {
    var _this7 = this;

    var appId = this.props.appId;
    var _state3 = this.state,
        _state3$status = _state3.status,
        status = _state3$status === undefined ? "" : _state3$status,
        _state3$more = _state3.more,
        more = _state3$more === undefined ? false : _state3$more,
        sort = _state3.sort,
        _state3$devices = _state3.devices,
        devices = _state3$devices === undefined ? [] : _state3$devices,
        initialLoad = _state3.initialLoad,
        showSearchable = _state3.showSearchable,
        usage = _state3.usage,
        limit = _state3.limit;


    var thead = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "thead",
      null,
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          { className: __WEBPACK_IMPORTED_MODULE_38__styles_scss___default.a.checkbox },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Checkbox__["a" /* default */], {
            id: "all",
            checked: this.allChecked(),
            onChange: function onChange(e) {
              return _this7.handleToggleCheckAll(e);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg("thead.name"),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_SearchFlag__["a" /* default */], { show: showSearchable }),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_SortBtn__["a" /* default */], {
            iconType: "alpha",
            handleSort: this.handleSort,
            data: devices,
            sortName: "name",
            highLight: sort.indexOf("name") > -1
          })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          "DevEUI",
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_SearchFlag__["a" /* default */], { show: showSearchable }),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_SortBtn__["a" /* default */], {
            iconType: "alpha",
            handleSort: this.handleSort,
            sortName: "deveui",
            highLight: sort.indexOf("deveui") > -1
          })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          "DevAddr",
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_SearchFlag__["a" /* default */], { show: showSearchable }),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_SortBtn__["a" /* default */], {
            iconType: "alpha",
            handleSort: this.handleSort,
            sortName: "devaddr",
            highLight: sort.indexOf("devaddr") > -1
          })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg("thead.city"),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_SearchFlag__["a" /* default */], { show: showSearchable })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg("thead.area"),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_SearchFlag__["a" /* default */], { show: showSearchable })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg("thead.type")
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          " ",
          this.intlMsg.msg("thead.band"),
          " "
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg("thead.status"),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_SortBtn__["a" /* default */], {
            iconType: "number",
            handleSort: this.handleSort,
            sortName: "lastact",
            ascSort: false,
            highLight: sort.indexOf("lastact") > -1
          })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg("thead.createtime"),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_SortBtn__["a" /* default */], {
            iconType: "number",
            handleSort: this.handleSort,
            sortName: "ctime",
            ascSort: false,
            highLight: sort.indexOf("ctime") > -1
          })
        )
      )
    );

    if (initialLoad === "pending") {
      var _usage$nodes = usage.nodes,
          nodes = _usage$nodes === undefined ? 1 : _usage$nodes;

      var _rows = Math.max(1, Math.min(nodes, 10));
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_19_loracoms_LoadingTable__["a" /* default */],
        {
          className: "aisz-table-light",
          striped: true,
          bordered: true,
          rows: _rows,
          cols: 10
        },
        thead
      );
    }

    var pager = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_TablePagers__["a" /* default */], {
      status: status,
      mark: this.mark,
      more: more,
      change: this.handleChangeMark
    });
    var rows = devices.map(function (d) {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "tr",
        {
          key: d.deveui,
          className: "\n          " + (isNewDevice(d) ? __WEBPACK_IMPORTED_MODULE_38__styles_scss___default.a.newDevice : "") + "\n          " + (d.deleting ? __WEBPACK_IMPORTED_MODULE_38__styles_scss___default.a.deleting : "") + "\n          " + (d.deleted ? __WEBPACK_IMPORTED_MODULE_38__styles_scss___default.a.deleted : "") + "\n        "
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          { className: __WEBPACK_IMPORTED_MODULE_38__styles_scss___default.a.checkbox },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Checkbox__["a" /* default */], {
            id: d.deveui,
            checked: _this7.isChecked(d),
            onChange: function onChange() {
              return _this7.toggleCheck(d);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          d.name
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_22_loracoms_Link__["a" /* default */],
            { to: "/application/" + appId + "/devices/" + d.id },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31_lorautils_IdUtils__["a" /* normalizeDevEUI */])(d.deveui)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31_lorautils_IdUtils__["e" /* normalizeDevAddr */])(d.devaddr)
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          d.city
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          d.area
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          d.type
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_loracoms_RichLabel__["a" /* default */], { content: d.band })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Nvl__["a" /* default */], {
            val: d.lastact,
            formatter: function formatter(x) {
              return x && __WEBPACK_IMPORTED_MODULE_6_date_fns_format___default()(x * 1000, "YYYY-MM-DD HH:mm:ss") || "";
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Nvl__["a" /* default */], {
            val: d.createdAt,
            formatter: function formatter(x) {
              return __WEBPACK_IMPORTED_MODULE_6_date_fns_format___default()(x, "YYYY-MM-DD HH:mm:ss");
            }
          })
        )
      );
    });

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_38__styles_scss___default.a.devices },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Table"],
        {
          className: "aisz-table-light " + __WEBPACK_IMPORTED_MODULE_38__styles_scss___default.a.deviceList,
          striped: true,
          hover: true,
          bordered: true,
          responsive: true
        },
        thead,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "tbody",
          null,
          rows
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_16_loracoms_ShowIf__["a" /* default */],
        { "if": devices.length > 0 },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_38__styles_scss___default.a.pager },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37_loracoms_PageSizer__["a" /* default */], {
              pageSize: limit,
              onChange: this.handleChangePageSize,
              options: [20, 100, 500]
            })
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_38__styles_scss___default.a.pagers },
            pager
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_16_loracoms_ShowIf__["a" /* default */],
        { "if": devices.length === 0 },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_38__styles_scss___default.a.noDevice },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "h3",
            null,
            this.intlMsg.msg("nodevice")
          )
        )
      )
    );
  };

  DeviceList.prototype.render = function render() {
    var _this8 = this;

    var _state4 = this.state,
        _state4$search = _state4.search,
        search = _state4$search === undefined ? "" : _state4$search,
        bandOpts = _state4.bandOpts;

    var gen = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["DropdownButton"],
      {
        id: "gen-devices",
        bsStyle: "aisz-success-b",
        title: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-random" }),
          " ",
          this.intlMsg.msg("gendev")
        )
      },
      bandOpts.map(function (bandOpt) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["MenuItem"],
          {
            key: bandOpt.label,
            eventKey: bandOpt.label,
            onClick: function onClick() {
              return _this8.handleAutoGen(bandOpt.label);
            }
          },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_loracoms_RichLabel__["a" /* default */], {
            content: bandOpt.label,
            enums: function enums() {
              return {
                translate: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-circle" })
              };
            },
            inverse: true
          }),
          _this8.intlMsg.msg("gendev.band"),
          " ",
          bandOpt.label
        );
      })
    );
    var imp = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["DropdownButton"],
      {
        id: "imp-device",
        bsStyle: "aisz-success",
        title: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-arrow-circle-right" }),
          " ",
          this.intlMsg.msg("impdev")
        )
      },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["MenuItem"],
        { eventKey: "2", onClick: function onClick() {
            return _this8.handleImport("abp");
          } },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-angle-right fa-fw" }),
        " ",
        this.intlMsg.msg("importabp")
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["MenuItem"],
        { eventKey: "3", onClick: function onClick() {
            return _this8.handleImport("otaa");
          } },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-angle-right fa-fw" }),
        " ",
        this.intlMsg.msg("importotaa")
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["MenuItem"],
        { eventKey: "4", onClick: function onClick() {
            return _this8.handleImport("batch");
          } },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-angle-double-right fa-fw" }),
        " ",
        this.intlMsg.msg("batchimport")
      )
    );
    var del = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Button"],
      {
        bsStyle: "aisz-danger-b",
        onClick: this.handleDelete,
        disabled: _.isEmpty(this.state.checked) || this.state.deleting
      },
      this.state.deleting ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" }) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-trash-o" }),
      " ",
      this.intlMsg.msg("deldev")
    );
    var searchInput = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_SearchInput__["a" /* default */], {
      onChange: this.handleSearch,
      value: search,
      placeholder: this.intlMsg.msg("search.placeholder"),
      onFocus: function onFocus() {
        return _this8.setState({ showSearchable: true });
      },
      onBlur: function onBlur() {
        return _this8.setState({ showSearchable: false });
      }
    });
    var exp = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Button"],
      { bsStyle: "aisz-info-b", onClick: this.handleExportAll },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-download" }),
      " ",
      this.intlMsg.msg("expalldev")
    );
    var tools = [searchInput, imp, gen, exp, del];

    var appId = this.props.appId;
    var _state5 = this.state,
        showImport = _state5.showImport,
        error = _state5.error;


    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: this.intlMsg.msg("title") },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_loracoms_PanelToolbar__["a" /* default */], { tools: tools }),
      this.renderDevices(),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__DeviceOOQModal__["a" /* default */], {
          show: error === "QUOTA",
          onHide: function onHide() {
            _this8.setState({ error: null });
          }
        }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__ImportOTAAModal__["a" /* default */], {
          show: showImport && this.importType === "otaa",
          onHide: function onHide() {
            return _this8.setState({ showImport: false });
          },
          onSucc: this.handleAdded,
          onOOQ: function onOOQ() {
            _this8.setState({ error: "QUOTA" });
          },
          appeui: appId
        }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__ImportABPModal__["a" /* default */], {
          show: showImport && this.importType === "abp",
          onHide: function onHide() {
            return _this8.setState({ showImport: false });
          },
          onSucc: this.handleAdded,
          onOOQ: function onOOQ() {
            _this8.setState({ error: "QUOTA" });
          },
          appeui: appId
        })
      )
    );
  };

  return DeviceList;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

DeviceList.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    plan: state.billing.plan,
    basic: state.org.basic,
    usage: state.usage,
    bandOpts: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28_lorautils_api_selector__["a" /* enumsToOptions */])("bands", state)
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_9_react_router_redux__["routerActions"].push,
  getNodesUsage: __WEBPACK_IMPORTED_MODULE_24_loraactions_usage__["a" /* default */].nodes,
  getOrgBasic: __WEBPACK_IMPORTED_MODULE_25_loraactions_org__["a" /* default */].basic,
  countDevices: __WEBPACK_IMPORTED_MODULE_26_loraactions_device__["a" /* default */].countDevices,
  getBands: __WEBPACK_IMPORTED_MODULE_27_loraactions_enums__["a" /* default */].bands
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_intl__["injectIntl"])(DeviceList)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_HideIf__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);










var defaultProps = {
  show: false,
  onHide: function onHide() {},
  plan: {}
};

var propTypes = {
  onHide: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func,
  show: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool,
  plan: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var DeviceOOQModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeviceOOQModal, _React$Component);

  function DeviceOOQModal(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeviceOOQModal);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      show: props.show,
      plan: props.plan
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.detailview.devicelist');
    return _this;
  }

  DeviceOOQModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var show = nextProps.show,
        plan = nextProps.plan;

    if (show !== this.props.show) {
      this.setState({ show: show });
    }
    if (plan !== this.props.plan) {
      this.setState({ plan: plan });
    }
  };

  DeviceOOQModal.prototype.render = function render() {
    var _props = this.props,
        onHide = _props.onHide,
        pushState = _props.pushState;
    var _state = this.state,
        show = _state.show,
        _state$plan = _state.plan,
        plan = _state$plan === undefined ? {} : _state$plan;
    var _plan$data = plan.data;
    _plan$data = _plan$data === undefined ? {} : _plan$data;
    var _plan$data$tier = _plan$data.tier,
        tier = _plan$data$tier === undefined ? 3 : _plan$data$tier;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-warning",
        show: show,
        onHide: onHide
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle" }),
          ' ',
          this.intlMsg.msg('adderr.header')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_loracoms_HideIf__["a" /* default */],
          { "if": "profile:cube" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_loracoms_ShowIf__["a" /* default */],
            { "if": tier < 3 },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              { className: "text-center" },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "p",
                null,
                " ",
                this.intlMsg.msg('adderr.ooq.undercomm'),
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
                {
                  bsStyle: "aisz-primary-o",
                  bsSize: "small",
                  onClick: function onClick() {
                    return pushState('/billing/plans');
                  }
                },
                this.intlMsg.msg('adderr.upgrade.btn'),
                ' ',
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-arrow-circle-o-right" })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_loracoms_HideIf__["a" /* default */],
          { "if": "profile:cube" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_loracoms_ShowIf__["a" /* default */],
            { "if": tier === 3 },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              { className: "text-center" },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "p",
                null,
                this.intlMsg.msg('adderr.ooq.comm')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "a",
                { href: "mailto:support@aisenz.com" },
                "support@aisenz.com"
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_loracoms_ShowIf__["a" /* default */],
          { "if": "profile:cube" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: "text-center" },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "p",
              null,
              this.intlMsg.msg('adderr.ooq.cube')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "a",
              { href: "mailto:support@aisenz.com" },
              "support@aisenz.com"
            )
          )
        )
      )
    );
  };

  return DeviceOOQModal;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DeviceOOQModal.defaultProps = defaultProps;
DeviceOOQModal.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    plan: state.billing.plan
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(DeviceOOQModal)));

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loraactions_gateway__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_DeleteModal__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_GatewayModal__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss__ = __webpack_require__(2205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any.isRequired,
  getAppGateway: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  gatewayState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired
};

var GatewayList = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(GatewayList, _React$Component);

  function GatewayList(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GatewayList);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      list: [],
      checked: [],
      showModal: false
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.gatewayview');
    return _this;
  }

  GatewayList.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        appId = _props.appId,
        getAppGateway = _props.getAppGateway;

    getAppGateway(appId);
  };

  GatewayList.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var data = nextProps.gatewayState.data;

    if (data) {
      var list = _.map(data.list, function (l) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, l, { isNew: false, status: _this2.getStatus(l)
        });
      });
      list = _.sortBy(list, function (li) {
        return li.status.connected;
      }).reverse();
      this.setState({ list: list });
    }
  };

  GatewayList.prototype.componentWillUnmount = function componentWillUnmount() {
    this.isNew = false;
  };

  GatewayList.prototype.getStatus = function getStatus(gw) {
    var disconnected = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "span",
      null,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-circle-o " + __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.disconnected }),
      ' ',
      this.intlMsg.msg('status.disconnected')
    );
    var connected = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "span",
      null,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-circle " + __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.connected }),
      ' ',
      this.intlMsg.msg('status.connected')
    );

    if (_.isNil(gw.lastOn)) {
      return { connected: false, content: disconnected };
    }
    if (_.isNil(gw.lastOff)) {
      return { connected: true, content: connected };
    }
    var onts = new Date(gw.lastOn).valueOf();
    var offts = new Date(gw.lastOff).valueOf();
    if (onts > offts) {
      return { connected: true, content: connected };
    }
    return { connected: false, content: disconnected };
  };

  GatewayList.prototype.handleOnSuccess = function handleOnSuccess(gateway) {
    var _this3 = this;

    var appId = this.props.appId;

    var gws = _.map(gateway, function (gw) {
      return gw.id;
    });
    if (gws.length) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__api_callAPI__["a" /* default */])({
        endpoint: "/lora/apps/" + appId + "/gws",
        method: 'POST',
        body: gws
      }).then(function () {
        var list = _this3.state.list;

        list = _.concat(_.map(gateway, function (gw) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, gw, { isNew: true, status: _this3.getStatus(gw) });
        }), list);
        _this3.setState({ list: list });
      }).catch(function () {});
    }
    this.setState({ showModal: false });
  };

  GatewayList.prototype.handleDeleteGateway = function handleDeleteGateway() {
    var _this4 = this;

    var _state = this.state,
        _state$deleteGateway = _state.deleteGateway,
        deleteGateway = _state$deleteGateway === undefined ? {} : _state$deleteGateway,
        list = _state.list;

    if (deleteGateway.id) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__api_callAPI__["a" /* default */])({
        endpoint: "/lora/apps/" + this.props.appId + "/gws/" + deleteGateway.id,
        method: 'DELETE'
      }).then(function () {
        _this4.setState({
          list: _.filter(list, function (l) {
            return l.id !== deleteGateway.id;
          }),
          showDeleteModal: false
        });
      }).catch(function () {});
    }
  };

  GatewayList.prototype.render = function render() {
    var _this5 = this;

    var _state2 = this.state,
        showModal = _state2.showModal,
        list = _state2.list,
        _state2$showDeleteMod = _state2.showDeleteModal,
        showDeleteModal = _state2$showDeleteMod === undefined ? false : _state2$showDeleteMod,
        _state2$deleteGateway = _state2.deleteGateway,
        deleteGateway = _state2$deleteGateway === undefined ? {} : _state2$deleteGateway,
        _state2$showHelp = _state2.showHelp,
        showHelp = _state2$showHelp === undefined ? false : _state2$showHelp;
    var appId = this.props.appId;

    var header = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      null,
      this.intlMsg.msg('gatewaylist.header'),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Button"],
        {
          bsStyle: "aisz-success",
          onClick: function onClick() {
            return _this5.setState({ showModal: true });
          },
          className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.marginLm
        },
        this.intlMsg.msg('gatewaylist.chose')
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */], {
        className: "glyphicons glyphicons-question-sign " + __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.help,
        onClick: function onClick() {
          return _this5.setState({ showHelp: !showHelp });
        }
      })
    );
    var tooltip = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Tooltip"],
      { id: "tooltip-delete" },
      this.intlMsg.msg('gatewaylist.delete')
    );
    var rows = _.map(list, function (l) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "tr",
        { key: l.id, className: l.isNew ? __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.new : '' },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          l.name
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
            { to: "/gateway/detail/" + l.id },
            l.mac
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          l.status.content
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          l.city
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          l.area
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["OverlayTrigger"],
            { placement: "top", overlay: tooltip },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
              {
                className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.delete,
                onClick: function onClick() {
                  _this5.setState({
                    showDeleteModal: true,
                    deleteGateway: l
                  });
                }
              },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-trash" })
            )
          )
        )
      );
    });
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Panel"],
        {
          bsStyle: "aisz-white",
          header: header
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Collapse"],
          { "in": showHelp },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Well"],
            { bsClass: "aisz-well-light" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                this.intlMsg.msg('gatewaylist.help0')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "ul",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "li",
                  null,
                  this.intlMsg.msg('gatewaylist.help1')
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "li",
                  null,
                  this.intlMsg.msg('gatewaylist.help2')
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "li",
                  null,
                  this.intlMsg.msg('gatewaylist.help3')
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "li",
                  null,
                  this.intlMsg.msg('gatewaylist.help4')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "p",
                null,
                this.intlMsg.msg('gatewaylist.help5')
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Table"],
          {
            className: "aisz-table-light",
            striped: true,
            hover: true,
            bordered: true,
            responsive: true
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('gatewaylist.name')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('gatewaylist.mac')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('gatewaylist.connect')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('gatewaylist.city')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('gatewaylist.area')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                { className: "text-center" },
                this.intlMsg.msg('gatewaylist.operation')
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "tbody",
            null,
            rows
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
          { "if": list.length === 0 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.noData },
            this.intlMsg.msg('gatewaylist.nodata')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_GatewayModal__["a" /* default */], {
          appId: appId,
          showModal: showModal,
          onHide: function onHide() {
            return _this5.setState({ showModal: false });
          },
          onSuccess: function onSuccess(gw) {
            return _this5.handleOnSuccess(gw);
          },
          disableCheck: list
        }),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_DeleteModal__["a" /* default */], {
          showModal: showDeleteModal,
          onCancel: function onCancel() {
            return _this5.setState({ showDeleteModal: false });
          },
          onConfirm: function onConfirm() {
            return _this5.handleDeleteGateway();
          },
          headerText: this.intlMsg.msg('gatewaylist.delheader'),
          text: "" + this.intlMsg.msg('gatewaylist.deltext') + deleteGateway.name + "(" + deleteGateway.id + ")?"
        })
      )
    );
  };

  return GatewayList;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

GatewayList.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    gatewayState: state.gateway.getAppGateway
  };
};

var mapDispatchToProps = {
  getAppGateway: __WEBPACK_IMPORTED_MODULE_10_loraactions_gateway__["a" /* default */].getAppGateway
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(GatewayList)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Select__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loraapi_lora_device__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lorautils_checkers_numbers__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lorautils_api_selector__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss__ = __webpack_require__(2206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);


















var defaultProps = {
  show: false
};
var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  appeui: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  onSucc: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  onOOQ: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  bandOpts: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.array.isRequired,
  show: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.bool
};

var ImportABPModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ImportABPModal, _React$Component);

  function ImportABPModal(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ImportABPModal);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      show: props.show,
      appeui: props.appeui,
      bandOpts: props.bandOpts,
      errors: __WEBPACK_IMPORTED_MODULE_16_lorautils_errors_ErrorSet__["a" /* default */].createEmpty().add('FE_EMPTY', 'deveui').add('FE_EMPTY', 'devaddr').add('FE_EMPTY', 'nwkskey').add('FE_EMPTY', 'appskey').add('FE_EMPTY', 'band')
    };
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleHide = _this.handleHide.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_15_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.detailview.devicelist.importabp');
    _this.handleChangeDevEUI = _this.handleChangeDevEUI.bind(_this);
    _this.handleChangeDevAddr = _this.handleChangeDevAddr.bind(_this);
    _this.handleChangeNwkSKey = _this.handleChangeNwkSKey.bind(_this);
    _this.handleChangeAppSKey = _this.handleChangeAppSKey.bind(_this);
    _this.handleChangeBand = _this.handleChangeBand.bind(_this);
    return _this;
  }

  ImportABPModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var show = nextProps.show,
        bandOpts = nextProps.bandOpts;

    if (show !== this.props.show) {
      this.setState({ show: show });
      if (show) {
        this.reset();
      }
    }
    if (bandOpts !== this.props.bandOpts) {
      this.setState({ bandOpts: bandOpts });
    }
  };

  ImportABPModal.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    if (!_.isNil(this.cursorPos) && this.activeInput) {
      _.delay(function () {
        return _this2.activeInput.setSelectionRange(_this2.cursorPos, _this2.cursorPos);
      }, 50);
    }
  };

  ImportABPModal.prototype.reset = function reset() {
    this.setState({
      status: '',
      errors: __WEBPACK_IMPORTED_MODULE_16_lorautils_errors_ErrorSet__["a" /* default */].createEmpty().add('FE_EMPTY', 'deveui').add('FE_EMPTY', 'devaddr').add('FE_EMPTY', 'nwkskey').add('FE_EMPTY', 'appskey').add('FE_EMPTY', 'band'),
      deveui: '',
      devaddr: '',
      nwkskey: '',
      appskey: '',
      band: '',
      submitted: false
    });
  };

  ImportABPModal.prototype.handleChangeDevEUI = function handleChangeDevEUI(e) {
    var deveui = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_lorautils_IdUtils__["f" /* formatDevEUIInput */])(e.target.value, this.state.deveui);
    this.cursorPos = e.target.selectionEnd;
    if (e.target.value.length === this.cursorPos) {
      this.cursorPos = deveui.length;
    }
    this.setState({ deveui: deveui });

    var errors = this.state.errors;

    if (deveui.trim() === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'deveui') });
    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_lorautils_IdUtils__["c" /* isValidDevEUI */])(deveui)) {
      this.setState({ errors: errors.remove('deveui') });
    } else {
      this.setState({ errors: errors.add('FE_INVALIDFORMAT', 'deveui') });
    }
  };

  ImportABPModal.prototype.handleChangeDevAddr = function handleChangeDevAddr(e) {
    var devaddr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_lorautils_IdUtils__["g" /* formatDevAddrInput */])(e.target.value, this.state.devaddr);
    this.cursorPos = e.target.selectionEnd;
    if (e.target.value.length === this.cursorPos) {
      this.cursorPos = devaddr.length;
    }
    this.setState({ devaddr: devaddr });

    var errors = this.state.errors;

    if (devaddr.trim() === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'devaddr') });
    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_lorautils_IdUtils__["h" /* isValidDevAddr */])(devaddr)) {
      this.setState({ errors: errors.remove('devaddr') });
    } else {
      this.setState({ errors: errors.add('FE_INVALIDFORMAT', 'devaddr') });
    }
  };

  ImportABPModal.prototype.handleChangeNwkSKey = function handleChangeNwkSKey(e) {
    var nwkskey = e.target.value;
    this.setState({ nwkskey: nwkskey });

    var errors = this.state.errors;

    if (nwkskey === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'nwkskey') });
    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_lorautils_checkers_numbers__["c" /* isHexString */])(nwkskey, { len: 32 })) {
      this.setState({ errors: errors.remove('nwkskey') });
    } else {
      this.setState({ errors: errors.add('FE_INVALIDFORMAT', 'nwkskey') });
    }
  };

  ImportABPModal.prototype.handleChangeAppSKey = function handleChangeAppSKey(e) {
    var appskey = e.target.value;
    this.setState({ appskey: appskey });

    var errors = this.state.errors;

    if (appskey === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'appskey') });
    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_lorautils_checkers_numbers__["c" /* isHexString */])(appskey, { len: 32 })) {
      this.setState({ errors: errors.remove('appskey') });
    } else {
      this.setState({ errors: errors.add('FE_INVALIDFORMAT', 'appskey') });
    }
  };

  ImportABPModal.prototype.handleChangeBand = function handleChangeBand(band) {
    var errors = this.state.errors;

    this.setState({ band: band, errors: errors.remove('band') });
  };

  ImportABPModal.prototype.handleSubmit = function handleSubmit(e) {
    var _this3 = this;

    e.preventDefault();
    this.setState({ submitted: true });

    var errors = this.state.errors;

    errors = errors.remove('submit');
    if (!errors.isEmpty()) {
      return;
    }

    var _props = this.props,
        onSucc = _props.onSucc,
        onOOQ = _props.onOOQ,
        appeui = _props.appeui;
    var _state = this.state,
        devaddr = _state.devaddr,
        nwkskey = _state.nwkskey,
        appskey = _state.appskey,
        deveui = _state.deveui,
        band = _state.band;

    var norm = function norm(x) {
      return x.toUpperCase().replace(/[:-]/g, '');
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_loraapi_lora_device__["k" /* importABP */])(norm(devaddr), norm(nwkskey), norm(appskey), norm(deveui), appeui, band).then(function () {
      _this3.setState({ status: 'success' });
      onSucc();
    }).catch(function (err) {
      var code = err.errcode;
      if (code === 'QUOTA') {
        onOOQ();
      } else {
        _this3.setState({
          status: 'failure',
          errors: errors.add(code, 'submit')
        });
        _.delay(function () {
          return _this3.setState({ status: '' });
        }, 1500);
      }
    });
  };

  ImportABPModal.prototype.handleHide = function handleHide() {
    this.props.onHide();
  };

  ImportABPModal.prototype.render = function render() {
    var _this4 = this;

    var _state2 = this.state,
        _state2$deveui = _state2.deveui,
        deveui = _state2$deveui === undefined ? '' : _state2$deveui,
        _state2$devaddr = _state2.devaddr,
        devaddr = _state2$devaddr === undefined ? '' : _state2$devaddr,
        _state2$nwkskey = _state2.nwkskey,
        nwkskey = _state2$nwkskey === undefined ? '' : _state2$nwkskey,
        _state2$appskey = _state2.appskey,
        appskey = _state2$appskey === undefined ? '' : _state2$appskey,
        _state2$band = _state2.band,
        band = _state2$band === undefined ? '' : _state2$band,
        bandOpts = _state2.bandOpts,
        _state2$status = _state2.status,
        status = _state2$status === undefined ? '' : _state2$status,
        errors = _state2.errors,
        _state2$submitted = _state2.submitted,
        submitted = _state2$submitted === undefined ? false : _state2$submitted;


    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"],
      {
        bsSize: "large",
        bsClass: "aisz-modal-light",
        backdrop: "static",
        show: this.state.show,
        onHide: this.handleHide
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "text-center" },
          this.intlMsg.msg('modalheader')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.modalform },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Form"],
            { horizontal: true, onSubmit: this.handleSubmit },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
              { validationState: submitted && errors.has('deveui') ? 'error' : undefined },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                  { className: "aisz-control-label" },
                  "DevEUI"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                { md: 7 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormControl"], {
                  value: deveui,
                  className: "aisz-form-control-f",
                  placeholder: "01-23-45-67-89-AB-CD-EF",
                  onChange: this.handleChangeDevEUI,
                  inputRef: function inputRef(ref) {
                    _this4.deveuiInputRef = ref;
                  },
                  onFocus: function onFocus() {
                    _this4.activeInput = _this4.deveuiInputRef;
                  },
                  onBlur: function onBlur() {
                    _this4.cursorPos = null;
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_ControlTips__["a" /* default */], {
                  message: this.intlMsg.errorMsg(errors.get('deveui')),
                  show: submitted && errors.has('deveui'),
                  azStyle: "danger"
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
              { validationState: submitted && errors.has('devaddr') ? 'error' : undefined },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                  { className: "aisz-control-label" },
                  "DevAddr"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                { md: 7 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormControl"], {
                  value: devaddr,
                  className: "aisz-form-control-f",
                  placeholder: "01-23-45-67",
                  onChange: this.handleChangeDevAddr,
                  inputRef: function inputRef(ref) {
                    _this4.devaddrInputRef = ref;
                  },
                  onFocus: function onFocus() {
                    _this4.activeInput = _this4.devaddrInputRef;
                  },
                  onBlur: function onBlur() {
                    _this4.cursorPos = null;
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_ControlTips__["a" /* default */], {
                  message: this.intlMsg.errorMsg(errors.get('devaddr')),
                  show: submitted && errors.has('devaddr'),
                  azStyle: "danger"
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
              { validationState: submitted && errors.has('nwkskey') ? 'error' : undefined },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                  { className: "aisz-control-label" },
                  "NwkSKey"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                { md: 7 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormControl"], {
                  value: nwkskey,
                  className: "aisz-form-control-f",
                  placeholder: "0123456789ABCDEF0123456789ABCDEF",
                  onChange: this.handleChangeNwkSKey
                }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_ControlTips__["a" /* default */], {
                  message: this.intlMsg.errorMsg(errors.get('nwkskey')),
                  show: submitted && errors.has('nwkskey'),
                  azStyle: "danger"
                }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["HelpBlock"],
                  { className: "aisz-help-block" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-info-circle" }),
                  ' ',
                  this.intlMsg.msg('vendorprovide')
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
              { validationState: submitted && errors.has('appskey') ? 'error' : undefined },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                  { className: "aisz-control-label" },
                  "AppSKey"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                { md: 7 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormControl"], {
                  value: appskey,
                  className: "aisz-form-control-f",
                  placeholder: "0123456789ABCDEF0123456789ABCDEF",
                  onChange: this.handleChangeAppSKey
                }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_ControlTips__["a" /* default */], {
                  message: this.intlMsg.errorMsg(errors.get('appskey')),
                  show: submitted && errors.has('appskey'),
                  azStyle: "danger"
                }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["HelpBlock"],
                  { className: "aisz-help-block" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-info-circle" }),
                  ' ',
                  this.intlMsg.msg('vendorprovide')
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
              { validationState: submitted && errors.has('band') ? 'error' : undefined },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                  { className: "aisz-control-label" },
                  this.intlMsg.msg('band')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                { md: 7 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Select__["a" /* default */], {
                  value: band,
                  placeholder: this.intlMsg.msg('band.placeholder'),
                  className: "aisz-form-control-f",
                  options: bandOpts,
                  onChange: this.handleChangeBand
                }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_ControlTips__["a" /* default */], {
                  message: this.intlMsg.errorMsg(errors.get('band')),
                  show: submitted && errors.has('band'),
                  azStyle: "danger"
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                { mdOffset: 3, md: 7, className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.submit },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_RichButton__["a" /* default */], {
                  status: status,
                  states: [{
                    status: 'default',
                    label: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-arrow-circle-right" }),
                      ' ',
                      this.intlMsg.msg('submit')
                    ),
                    style: 'primary',
                    type: 'submit'
                  }, {
                    status: 'success',
                    label: this.intlMsg.msg('submit.success'),
                    style: 'success'
                  }, {
                    status: 'failure',
                    label: this.intlMsg.msg('submit.failure'),
                    style: 'danger'
                  }]
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                { mdOffset: 3, md: 7 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_FormBlock__["a" /* default */], {
                  show: submitted && errors.has('submit'),
                  message: this.intlMsg.errorMsg(errors.get('submit')),
                  azStyle: "danger"
                })
              )
            )
          )
        )
      )
    );
  };

  return ImportABPModal;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ImportABPModal.defaultProps = defaultProps;
ImportABPModal.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    bandOpts: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_lorautils_api_selector__["a" /* enumsToOptions */])('bands', state).map(function (opt) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, opt, { formatter: function formatter(x) {
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_RichLabel__["a" /* default */], { content: x });
        } });
    })
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(ImportABPModal)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_Select__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lorautils_checkers_numbers__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lorautils_api_selector__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss__ = __webpack_require__(2207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);


















var defaultProps = {
  show: false
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  appeui: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  onSucc: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  onOOQ: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  bandOpts: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.array.isRequired,
  show: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.bool
};

var ImportOTAAModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ImportOTAAModal, _React$Component);

  ImportOTAAModal.initErrors = function initErrors() {
    return __WEBPACK_IMPORTED_MODULE_12_lorautils_errors_ErrorSet__["a" /* default */].createEmpty().add('FE_EMPTY', 'deveui').add('FE_EMPTY', 'appkey').add('FE_EMPTY', 'band');
  };

  function ImportOTAAModal(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ImportOTAAModal);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      show: props.show,
      appeui: props.appeui,
      bandOpts: props.bandOpts,
      errors: ImportOTAAModal.initErrors()
    };
    _this.handleChangeBand = _this.handleChangeBand.bind(_this);
    _this.handleChangeDevEUI = _this.handleChangeDevEUI.bind(_this);
    _this.handleChangeAppKey = _this.handleChangeAppKey.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleHide = _this.handleHide.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_16_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.detailview.devicelist.importotaa');
    return _this;
  }

  ImportOTAAModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var bandOpts = nextProps.bandOpts,
        show = nextProps.show;

    if (show !== this.props.show) {
      this.setState({ show: show });
    }
    if (bandOpts !== this.props.bandOpts) {
      this.setState({ bandOpts: bandOpts });
    }
  };

  ImportOTAAModal.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    if (!_.isNil(this.cursorPos) && this.activeInput) {
      _.delay(function () {
        return _this2.activeInput.setSelectionRange(_this2.cursorPos, _this2.cursorPos);
      }, 50);
    }
  };

  ImportOTAAModal.prototype.reset = function reset() {
    this.setState({
      submitted: false,
      deveui: '',
      appkey: '',
      band: '',
      status: '',
      errors: ImportOTAAModal.initErrors()
    });
  };

  ImportOTAAModal.prototype.handleChangeDevEUI = function handleChangeDevEUI(e) {
    var _state$deveui = this.state.deveui,
        deveui = _state$deveui === undefined ? '' : _state$deveui;

    deveui = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_lorautils_IdUtils__["f" /* formatDevEUIInput */])(e.target.value.trim(), deveui);
    this.setState({ deveui: deveui });

    this.cursorPos = e.target.selectionEnd;
    if (e.target.value.length === this.cursorPos) {
      this.cursorPos = deveui.length;
    }

    var errors = this.state.errors;

    if (deveui === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'deveui') });
    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_lorautils_IdUtils__["c" /* isValidDevEUI */])(deveui)) {
      this.setState({ errors: errors.remove('deveui') });
    } else {
      this.setState({ errors: errors.add('FE_INVALIDFORMAT', 'deveui') });
    }
  };

  ImportOTAAModal.prototype.handleChangeAppKey = function handleChangeAppKey(e) {
    var appkey = e.target.value.trim();
    this.setState({ appkey: appkey });

    var errors = this.state.errors;


    if (appkey === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'appkey') });
    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lorautils_checkers_numbers__["c" /* isHexString */])(appkey, { len: 32 })) {
      this.setState({ errors: errors.remove('appkey') });
    } else {
      this.setState({ errors: errors.add('FE_INVALIDFORMAT', 'appkey') });
    }
  };

  ImportOTAAModal.prototype.handleChangeBand = function handleChangeBand(band) {
    var errors = this.state.errors;

    this.setState({ band: band, errors: errors.remove('band') });
  };

  ImportOTAAModal.prototype.handleSubmit = function handleSubmit(e) {
    var _this3 = this;

    e.preventDefault();
    this.setState({ submitted: true });

    var errors = this.state.errors;

    errors = errors.remove('submit');
    if (!errors.isEmpty()) {
      return;
    }

    var _props = this.props,
        onSucc = _props.onSucc,
        onOOQ = _props.onOOQ,
        appeui = _props.appeui;
    var _state = this.state,
        deveui = _state.deveui,
        appkey = _state.appkey,
        band = _state.band;


    var noSeps = function noSeps(x) {
      return x.toUpperCase().replace(/[:-]/g, '');
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_api__["a" /* callAPI */])({
      endpoint: '/lora/nodes',
      method: 'POST',
      body: {
        deveui: noSeps(deveui),
        appkey: noSeps(appkey),
        appeui: noSeps(appeui),
        fcntbits: 32,
        band: band
      }
    }).then(function () {
      _this3.setState({
        status: 'success',
        errors: errors.remove('submit')
      });
      _.delay(function () {
        onSucc();
        _this3.reset();
      }, 500);
    }).catch(function (error) {
      if (error.code === 'QUOTA') {
        onOOQ();
      } else {
        _this3.setState({
          status: 'error',
          errors: errors.add(error.code, 'submit')
        });
      }
    });
  };

  ImportOTAAModal.prototype.handleHide = function handleHide() {
    this.reset();
    this.props.onHide();
  };

  ImportOTAAModal.prototype.render = function render() {
    var _this4 = this;

    var _state2 = this.state,
        show = _state2.show,
        _state2$status = _state2.status,
        status = _state2$status === undefined ? '' : _state2$status,
        _state2$deveui = _state2.deveui,
        deveui = _state2$deveui === undefined ? '' : _state2$deveui,
        _state2$appkey = _state2.appkey,
        appkey = _state2$appkey === undefined ? '' : _state2$appkey,
        _state2$band = _state2.band,
        band = _state2$band === undefined ? '' : _state2$band,
        _state2$bandOpts = _state2.bandOpts,
        bandOpts = _state2$bandOpts === undefined ? [] : _state2$bandOpts,
        _state2$submitted = _state2.submitted,
        submitted = _state2$submitted === undefined ? false : _state2$submitted,
        errors = _state2.errors;


    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"],
      {
        bsSize: "large",
        bsClass: "aisz-modal-light",
        backdrop: "static",
        show: show,
        onHide: this.handleHide
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "text-center" },
          this.intlMsg.msg('modalheader')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.modalform },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Form"],
            { horizontal: true, onSubmit: this.handleSubmit },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
              { validationState: submitted && errors.has('deveui') ? 'error' : undefined },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                  { className: "aisz-control-label" },
                  "DevEUI"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                { md: 7 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormControl"], {
                  value: deveui,
                  className: "aisz-form-control-f",
                  placeholder: "01-23-45-67-89-AB-CD-EF",
                  onChange: this.handleChangeDevEUI,
                  inputRef: function inputRef(ref) {
                    _this4.deveuiInputRef = ref;
                  },
                  onFocus: function onFocus() {
                    _this4.activeInput = _this4.deveuiInputRef;
                  },
                  onBlur: function onBlur() {
                    _this4.cursorPos = null;
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_ControlTips__["a" /* default */], {
                  show: submitted && errors.has('deveui'),
                  message: this.intlMsg.errorMsg(errors.get('deveui')),
                  azStyle: "danger"
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
              { validationState: submitted && errors.has('appkey') ? 'error' : undefined },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                  { className: "aisz-control-label" },
                  "AppKey"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                { md: 7 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormControl"], {
                  value: appkey,
                  className: "aisz-form-control-f",
                  placeholder: "0123456789ABCDEF0123456789ABCDEF",
                  onChange: this.handleChangeAppKey
                }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_ControlTips__["a" /* default */], {
                  show: submitted && errors.has('appkey'),
                  message: this.intlMsg.errorMsg(errors.get('appkey')),
                  azStyle: "danger"
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
              { validationState: submitted && errors.has('band') ? 'error' : undefined },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                  { className: "aisz-control-label" },
                  this.intlMsg.msg('band')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                { md: 7 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Select__["a" /* default */], {
                  value: band,
                  className: "aisz-form-control-f",
                  placeholder: this.intlMsg.msg('band.placeholder'),
                  onChange: this.handleChangeBand,
                  options: bandOpts
                }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_ControlTips__["a" /* default */], {
                  show: submitted && errors.has('band'),
                  message: this.intlMsg.errorMsg(errors.get('band')),
                  azStyle: "danger"
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                { mdOffset: 3, md: 7 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.submit },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_RichButton__["a" /* default */], {
                    status: status,
                    states: [{
                      status: 'default',
                      label: this.intlMsg.msg('submit'),
                      type: 'submit',
                      style: 'primary'
                    }, {
                      status: 'pending',
                      label: this.intlMsg.msg('submit.pending'),
                      type: 'submit',
                      style: 'primary'
                    }, {
                      status: 'success',
                      label: this.intlMsg.msg('submit.success'),
                      style: 'success',
                      timer: function timer() {
                        _this4.setState({ status: '' });
                      }
                    }, {
                      status: 'failure',
                      label: this.intlMsg.msg('submit.failure'),
                      style: 'danger',
                      timer: function timer() {
                        _this4.setState({ status: '' });
                      }
                    }]
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                { mdOffset: 3, md: 7 },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_FormBlock__["a" /* default */], {
                  show: errors.has('submit'),
                  message: this.intlMsg.errorMsg(errors.get('submit')),
                  azStyle: "danger"
                })
              )
            )
          )
        )
      )
    );
  };

  return ImportOTAAModal;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ImportOTAAModal.defaultProps = defaultProps;
ImportOTAAModal.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    bandOpts: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_lorautils_api_selector__["a" /* enumsToOptions */])('bands', state).map(function (opt) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, opt, { formatter: function formatter(x) {
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_RichLabel__["a" /* default */], { content: x });
        } });
    })
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(ImportOTAAModal)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__coms_DeviceList__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__coms_GatewayList__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__coms_AppProps__ = __webpack_require__(1197);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  app: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  routerAction: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired
};

var DetailView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DetailView, _React$Component);

  function DetailView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DetailView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      app: props.app
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.detailview');
    return _this;
  }

  DetailView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var app = nextProps.app;

    this.setState({ app: app });
  };

  DetailView.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        appId = _props.appId,
        routerAction = _props.routerAction;
    var app = this.state.app;
    var _app$data = app.data,
        data = _app$data === undefined ? {} : _app$data;


    var breadcrumb = [{
      onClick: function onClick() {
        return _this2.props.pushState('/application');
      },
      content: this.intlMsg.msg('breadcrumb.application', 'application')
    }, {
      content: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Nvl__["a" /* default */], { val: data.name, status: app.status }),
      active: true
    }];

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Grid"],
        { fluid: true },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__coms_AppProps__["a" /* default */], { appId: appId })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__coms_DeviceList__["a" /* default */], { appId: appId, routerAction: routerAction })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__coms_GatewayList__["a" /* default */], { appId: appId })
          )
        )
      )
    );
  };

  return DetailView;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

DetailView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    app: state.app.getApp,
    appId: ownProps.params.id,
    routerAction: ownProps.location.action
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(DetailView)));

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_day__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_add_days__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns_add_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_is_after__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_is_after___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_date_fns_is_after__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_is_before__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_is_before___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_date_fns_is_before__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_min__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_date_fns_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracfg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loracoms_DatePicker__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_loracoms_InlineSelect__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lorautils_Validators__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lorautils_cookies_auth__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_loraapi_lora_device__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__styles_main_scss__ = __webpack_require__(2208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__styles_main_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

























var propTypes = {
  app: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired
};

var ExportView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ExportView, _React$Component);

  ExportView.handleDisableDate = function handleDisableDate(d, from) {
    return __WEBPACK_IMPORTED_MODULE_12_date_fns_is_after___default()(d, __WEBPACK_IMPORTED_MODULE_14_date_fns_min___default()(__WEBPACK_IMPORTED_MODULE_11_date_fns_add_days___default()(from, 7), new Date())) || __WEBPACK_IMPORTED_MODULE_13_date_fns_is_before___default()(d, from);
  };

  function ExportView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ExportView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      app: props.app,
      from: __WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day___default()(new Date()),
      to: __WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_day___default()(new Date()),
      format: 'csv',
      exportType: 'all',
      deveui: null,
      errTips: null,
      devList: []
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_21_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.exportview');
    _this.handleChangeDev = _this.handleChangeDev.bind(_this);
    _this.handleExport = _this.handleExport.bind(_this);
    return _this;
  }

  // componentDidMount() {
  //   this.loadDevices();
  // }

  ExportView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var app = nextProps.app;

    if (app !== this.props.app) {
      this.setState({ app: app });
    }
  };

  ExportView.prototype.loadDevices = function loadDevices(s, errTip) {
    var _this2 = this;

    var appId = this.props.appId;

    var args = {
      app: appId,
      pageSize: 1000,
      limit: 1000,
      q: "deveui:*" + s + "*"
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24_loraapi_lora_device__["h" /* getDeviceList */])(args).then(function (resp) {
      var dev = resp.body.list;
      if (!_.isNil(dev) && dev.length > 0) {
        _this2.setState({
          errTips: null,
          deveui: s
        });
      } else {
        _this2.setState({
          errTips: errTip(_this2.intlMsg.msg('deverrtips')),
          deveui: s
        });
      }
      // this.setState({
      //   devList: resp.body.list,
      // });
    });
  };

  ExportView.prototype.searchDevice = function searchDevice(s, errTip) {
    this.loadDevices(s, errTip);
  };

  ExportView.prototype.checkDeveui = function checkDeveui(arr, v) {
    var result = false;
    if (arr.length === 0) {
      result = false;
    } else {
      arr.forEach(function (item) {
        if (item.deveui === v) {
          result = true;
        }
      });
    }
    return result;
  };

  ExportView.prototype.exportLink = function exportLink() {
    var appId = this.props.appId;
    var _state = this.state,
        exportType = _state.exportType,
        deveui = _state.deveui;

    var devEUI = '';
    if (exportType === 'all') {
      this.setState({
        deveui: null
      });
    } else if (exportType === 'one') {
      devEUI = "&node=" + deveui;
    }
    return __WEBPACK_IMPORTED_MODULE_16_loracfg__["a" /* default */].apiBase + '/application/download?appeui=' + appId + devEUI + '&start=' + this.state.from.valueOf() + '&end=' + this.state.to.valueOf() + '&encoding=' + this.state.format + '&access_token=' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_lorautils_cookies_auth__["b" /* getTokenCookies */])();
  };

  ExportView.prototype.handleExport = function handleExport() {
    window.location = this.exportLink();
  };

  ExportView.prototype.handleChangeDev = function handleChangeDev(v) {
    var errTip = function errTip(msg) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { styleName: "errtip-mes" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle" }),
        ' ',
        msg
      );
    };
    var valid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_lorautils_Validators__["f" /* hexValidator */])(16);
    if (valid(v).valid) {
      this.searchDevice(v, errTip);
    } else {
      this.setState({
        errTips: errTip(valid(v).errmsg),
        deveui: v
      });
    }
  };

  ExportView.prototype.formatDeveui = function formatDeveui(value) {
    if (value.indexOf('-') !== -1 || value.indexOf(':') !== -1) {
      return value.split(':').join('').split('-').join('');
    }
    return value;
  };

  ExportView.prototype.render = function render() {
    var _this3 = this;

    var pushState = this.props.pushState;
    var _state2 = this.state,
        app = _state2.app,
        format = _state2.format,
        _state2$from = _state2.from,
        from = _state2$from === undefined ? new Date() : _state2$from,
        _state2$to = _state2.to,
        to = _state2$to === undefined ? new Date() : _state2$to;
    var _app$data = app.data,
        appData = _app$data === undefined ? {} : _app$data;


    var breadcrumb = [{
      content: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], { id: "application.breadcrumb.application" }),
      onClick: function onClick() {
        return pushState('/application');
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_loracoms_Nvl__["a" /* default */], { val: appData.name, status: app.status }),
      active: true
    }];

    var _state3 = this.state,
        errTips = _state3.errTips,
        exportType = _state3.exportType,
        deveui = _state3.deveui;

    var devValid = false;
    if (exportType !== 'all') {
      if (errTips !== null || deveui === null) {
        devValid = true;
      }
    }
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
            { bsStyle: "aisz-white", header: this.intlMsg.msg('panelheader') },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Form"],
              { horizontal: true },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                  { md: 1 },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"],
                    { className: "aisz-control-label" },
                    this.intlMsg.msg('exporttype.label')
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                  { md: 8 },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_loracoms_InlineSelect__["a" /* default */], {
                    options: [{
                      label: this.intlMsg.msg('exporttype.optionall'),
                      value: 'all'
                    }, {
                      label: this.intlMsg.msg('exporttype.optionone'),
                      value: 'one'
                    }],
                    values: [exportType],
                    onChange: function onChange(selected) {
                      _this3.setState({
                        exportType: selected[0],
                        errTips: null,
                        deveui: null
                      });
                    }
                  })
                )
              ),
              this.state.exportType === 'one' ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                  { md: 1 },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"],
                    { className: "aisz-control-label" },
                    this.intlMsg.msg('choosedev.label')
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "div",
                    { styleName: "export-data" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormControl"], {
                      className: "aisz-form-control",
                      placeholder: this.intlMsg.msg('choosedev.placeholder'),
                      onChange: function onChange(e) {
                        return _this3.handleChangeDev(_this3.formatDeveui(e.target.value));
                      }
                    }),
                    errTips
                  )
                )
              ) : null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                  { md: 1 },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"],
                    { className: "aisz-control-label" },
                    this.intlMsg.msg('timerange.label')
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_DatePicker__["a" /* default */], {
                    date: from,
                    onSelect: function onSelect(date) {
                      _this3.setState({ from: __WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day___default()(date), to: __WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_day___default()(date) });
                    }
                  }),
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_DatePicker__["a" /* default */], {
                    date: to,
                    disabled: function disabled(d) {
                      return ExportView.handleDisableDate(d, from);
                    },
                    onSelect: function onSelect(date) {
                      _this3.setState({ to: __WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_day___default()(date) });
                    }
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                  { md: 1 },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"],
                    { className: "aisz-control-label" },
                    this.intlMsg.msg('format.label')
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_loracoms_InlineSelect__["a" /* default */], {
                    options: [{
                      label: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "span",
                        null,
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "filetypes filetypes-csv" }),
                        ' ',
                        "CSV"
                      ),
                      value: 'csv',
                      active: true
                    }, {
                      label: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "span",
                        null,
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "filetypes filetypes-json" }),
                        ' ',
                        "JSON"
                      ),
                      value: 'json'
                    }],
                    values: [format],
                    onChange: function onChange(selected) {
                      return _this3.setState({ format: selected[0] });
                    }
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                  { mdOffset: 1, md: 4 },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Button"],
                    {
                      bsStyle: "aisz-primary",
                      disabled: !this.state.from || !this.state.to || devValid,
                      onClick: this.handleExport
                    },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], { id: "applicationdetail.exportview.export.btn" }),
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-download", "aria-hidden": "true" })
                  )
                )
              )
            )
          )
        )
      )
    );
  };

  return ExportView;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ExportView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    appId: ownProps.params.id,
    app: state.app.getApp
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_15_react_css_modules___default()(ExportView, __WEBPACK_IMPORTED_MODULE_25__styles_main_scss___default.a, { allowMultiple: true }))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_draft_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AddFlowHelp__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss__ = __webpack_require__(2209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



















var kMaxNameLen = 128;

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  appState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var AddFlow = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(AddFlow, _React$Component);

  function AddFlow(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AddFlow);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      descState: __WEBPACK_IMPORTED_MODULE_7_draft_js__["EditorState"].createEmpty(),
      scriptState: __WEBPACK_IMPORTED_MODULE_7_draft_js__["EditorState"].createEmpty(),
      errors: __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__["a" /* default */].createEmpty().add('FE_EMPTY', 'name').add('FE_EMPTY', 'script'),
      appState: props.appState
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.flowsview.addflow');
    _this.handleChangeName = _this.handleChangeName.bind(_this);
    _this.handleChangeDesc = _this.handleChangeDesc.bind(_this);
    _this.handleChangeScript = _this.handleChangeScript.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }

  AddFlow.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var appState = nextProps.appState;

    if (appState !== this.props.appState) {
      this.setState({ appState: appState });
    }
  };

  AddFlow.prototype.handleChangeName = function handleChangeName(e) {
    var name = e.target.value;
    this.setState({ name: name });

    var errors = this.state.errors;

    if (name === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'name') });
    } else if (name.length > kMaxNameLen) {
      this.setState({ errors: errors.add('FE_TOOLONG', 'name') });
    } else {
      this.setState({ errors: errors.remove('name') });
    }
  };

  AddFlow.prototype.handleChangeDesc = function handleChangeDesc(descState) {
    this.setState({ descState: descState });
  };

  AddFlow.prototype.handleChangeScript = function handleChangeScript(scriptState) {
    this.setState({ scriptState: scriptState });

    var errors = this.state.errors;

    if (scriptState.getCurrentContent().hasText()) {
      this.setState({ errors: errors.remove('script') });
    } else {
      this.setState({ errors: errors.add('FE_EMPTY', 'script') });
    }
  };

  AddFlow.prototype.handleSubmit = function handleSubmit(e) {
    var _this2 = this;

    e.preventDefault();
    this.setState({ submitted: true });

    var errors = this.state.errors;

    errors = errors.remove('submit');
    if (!errors.isEmpty()) {
      return;
    }

    var _props = this.props,
        appId = _props.appId,
        pushState = _props.pushState;
    var _state = this.state,
        name = _state.name,
        descState = _state.descState,
        scriptState = _state.scriptState;


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lorautils_api__["a" /* callAPI */])({
      endpoint: '/lora/flows',
      body: {
        name: name,
        desc: descState.getCurrentContent().getPlainText(),
        script: scriptState.getCurrentContent().getPlainText(),
        appid: appId
      },
      method: 'POST'
    }).then(function () {
      _this2.setState({
        status: 'success',
        errors: errors.remove('submit')
      });
      _.delay(function () {
        return pushState("/application/" + appId + "/flows");
      }, 100);
    }).catch(function (error) {
      _this2.setState({
        status: 'failure',
        errors: errors.add(error.code, 'submit')
      });
    });
  };

  AddFlow.prototype.renderToolbar = function renderToolbar() {
    var _props2 = this.props,
        pushState = _props2.pushState,
        appId = _props2.appId;
    var appState = this.state.appState;
    var status = appState.status,
        _appState$data = appState.data;
    _appState$data = _appState$data === undefined ? {} : _appState$data;
    var _appState$data$name = _appState$data.name,
        name = _appState$data$name === undefined ? '' : _appState$data$name;

    var breadcrumb = [{
      content: this.intlMsg.globalMsg('application.breadcrumb.application'),
      onClick: function onClick() {
        return pushState('/application');
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_Nvl__["a" /* default */], { val: name, status: status }),
      onClick: function onClick() {
        return pushState("/application/" + appId + "/flows");
      }
    }, {
      content: this.intlMsg.msg('breadcrumb'),
      active: true
    }];

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  AddFlow.prototype.render = function render() {
    var _this3 = this;

    var _state2 = this.state,
        _state2$name = _state2.name,
        name = _state2$name === undefined ? '' : _state2$name,
        descState = _state2.descState,
        scriptState = _state2.scriptState,
        _state2$highlight = _state2.highlight,
        highlight = _state2$highlight === undefined ? false : _state2$highlight,
        _state2$status = _state2.status,
        status = _state2$status === undefined ? '' : _state2$status,
        _state2$submitted = _state2.submitted,
        submitted = _state2$submitted === undefined ? false : _state2$submitted,
        errors = _state2.errors;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 12 },
          this.renderToolbar()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Panel"],
            {
              bsStyle: "aisz-info",
              header: this.intlMsg.msg('header')
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Form"],
              { horizontal: true, onSubmit: this.handleSubmit },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
                { validationState: submitted && errors.has('name') ? 'error' : undefined },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
                    { bsClass: "aisz-control-label" },
                    this.intlMsg.msg('name')
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
                  { md: 8 },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
                    bsClass: "aisz-form-control-f",
                    value: name,
                    onChange: this.handleChangeName
                  }),
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_ControlTips__["a" /* default */], {
                    show: submitted && errors.has('name'),
                    message: this.intlMsg.errorMsg(errors.get('name')),
                    azStyle: "danger"
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
                    { bsClass: "aisz-control-label" },
                    this.intlMsg.msg('desc')
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
                  { md: 8 },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "div",
                    { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.editor },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_draft_js__["Editor"], {
                      editorState: descState,
                      onChange: this.handleChangeDesc
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
                { validationState: submitted && errors.has('script') ? 'error' : undefined },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
                    { bsClass: "aisz-control-label" },
                    this.intlMsg.msg('script'),
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_8_react_router__["f" /* Link */],
                      {
                        className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.helpIcon,
                        onClick: function onClick() {
                          _this3.setState({ highlight: true });
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-question-circle" })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
                  { md: 8 },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "div",
                    { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.editor + " " + __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.scriptEditor },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_draft_js__["Editor"], {
                      editorState: scriptState,
                      onChange: this.handleChangeScript
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_ControlTips__["a" /* default */], {
                    show: submitted && errors.has('script'),
                    message: this.intlMsg.errorMsg(errors.get('script')),
                    azStyle: "danger"
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
                  { mdOffset: 2, md: 8 },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "div",
                    { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.submit },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_RichButton__["a" /* default */], {
                      status: status,
                      states: [{
                        status: 'default',
                        label: this.intlMsg.msg('submit'),
                        style: 'primary',
                        type: 'submit'
                      }, {
                        status: 'success',
                        label: this.intlMsg.msg('submit.success'),
                        style: 'success',
                        timer: function timer() {
                          _this3.setState({ status: '' });
                        }
                      }, {
                        status: 'failure',
                        label: this.intlMsg.msg('submit.failure'),
                        style: 'danger',
                        timer: function timer() {
                          _this3.setState({ status: '' });
                        }
                      }]
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
                  { mdOffset: 2, md: 8 },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_FormBlock__["a" /* default */], {
                    show: errors.has('submit'),
                    message: this.intlMsg.errorMsg(errors.get('submit')),
                    azStyle: "danger"
                  })
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__AddFlowHelp__["a" /* default */], {
            highlight: highlight,
            onHighlightExited: function onHighlightExited() {
              _this3.setState({ highlight: false });
            }
          })
        )
      )
    );
  };

  return AddFlow;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

AddFlow.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    appState: state.app.getApp,
    appId: ownProps.params.id
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_9_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(AddFlow)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss__ = __webpack_require__(2211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);








var defaultProps = {
  show: false
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  show: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  onDeleted: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  flow: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var DeleteFlowModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeleteFlowModal, _React$Component);

  function DeleteFlowModal(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeleteFlowModal);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      show: props.show,
      flow: props.flow
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.flowsview.flows.delete');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }

  DeleteFlowModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var show = nextProps.show,
        flow = nextProps.flow;

    if (show !== this.props.show) {
      this.setState({ show: show });
    }
    if (flow !== this.props.flow) {
      this.setState({ flow: flow });
    }
  };

  DeleteFlowModal.prototype.handleSubmit = function handleSubmit() {
    var onDeleted = this.props.onDeleted;
    var flow = this.state.flow;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lorautils_api__["a" /* callAPI */])({
      endpoint: "/lora/flows/" + flow.id,
      method: 'DELETE'
    }).then(function () {
      onDeleted();
    }).catch(function () {});
  };

  DeleteFlowModal.prototype.render = function render() {
    var onHide = this.props.onHide;
    var _state = this.state,
        show = _state.show,
        flow = _state.flow;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"],
      { bsClass: "aisz-modal-danger", show: show, onHide: onHide },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle" }),
          ' ',
          this.intlMsg.msg('header')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.body },
          this.intlMsg.msg('rusure'),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.name },
            flow.name
          ),
          "?"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Footer,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.buttons },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
            { bsStyle: "aisz-warning", onClick: onHide },
            this.intlMsg.msg('cancel')
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
            { bsStyle: "aisz-danger", onClick: this.handleSubmit },
            this.intlMsg.msg('submit')
          )
        )
      )
    );
  };

  return DeleteFlowModal;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DeleteFlowModal.propTypes = propTypes;
DeleteFlowModal.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(DeleteFlowModal));

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_draft_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_Editable__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_AutoColor__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loraactions_flow__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DeleteFlowModal__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__AddFlowHelp__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss__ = __webpack_require__(2212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



















var kKeywords = ['info', 'warn', 'error', 'success', 'repeat', 'window', 'sum', 'avg', 'max', 'min', 'count'];

var propTypes = {
  flow: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  getFlows: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired
};

var Flow = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Flow, _React$Component);

  function Flow(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Flow);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      flow: props.flow,
      scriptState: __WEBPACK_IMPORTED_MODULE_9_draft_js__["EditorState"].createEmpty(),
      errors: __WEBPACK_IMPORTED_MODULE_15_lorautils_errors_ErrorSet__["a" /* default */].createEmpty()
    };
    _this.handleEdit = _this.handleEdit.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleEditScript = _this.handleEditScript.bind(_this);
    _this.handleChangeScript = _this.handleChangeScript.bind(_this);
    _this.handleSubmitScript = _this.handleSubmitScript.bind(_this);
    _this.handleDeleted = _this.handleDeleted.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_16_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.flowsview.flows');
    return _this;
  }

  Flow.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var flow = nextProps.flow;

    if (flow !== this.props.flow) {
      this.setState({ flow: flow });
    }
  };

  Flow.prototype.handleEdit = function handleEdit() {
    var _state = this.state,
        flow = _state.flow,
        errors = _state.errors;

    this.setState({
      edit: true,
      editData: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, flow),
      errors: errors.remove('name')
    });
    this.dirtyIds = [];
  };

  Flow.prototype.handleChange = function handleChange(editData, id) {
    this.setState({ editData: editData });
    this.dirtyIds.push(id);

    if (id === 'name') {
      var errors = this.state.errors;

      if (editData.name === '') {
        this.setState({ errors: errors.add('FE_EMPTY', 'name') });
      } else {
        this.setState({ errors: errors.remove('name') });
      }
    }
  };

  Flow.prototype.handleSubmit = function handleSubmit() {
    var _this2 = this;

    var _state2 = this.state,
        editData = _state2.editData,
        flow = _state2.flow,
        errors = _state2.errors;

    if (errors.has('name')) {
      return;
    }

    var changeData = _.fromPairs(_.filter(_.toPairs(editData), function (p) {
      return _this2.dirtyIds.includes(p[0]);
    }));

    if (!_.isEmpty(changeData)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_lorautils_api__["a" /* callAPI */])({
        endpoint: "/lora/flows/" + flow.id,
        body: changeData,
        method: 'PUT'
      }).then(function () {
        _this2.setState({
          edit: false,
          flow: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, flow, changeData)
        });
      }).catch(function (error) {
        _this2.setState({ errors: errors.add(error.code, 'submitBasic') });
      });
    } else {
      this.setState({ edit: false });
    }
  };

  Flow.prototype.handleEditScript = function handleEditScript() {
    var _state3 = this.state,
        flow = _state3.flow,
        errors = _state3.errors;

    this.setState({
      editScript: true,
      showHelp: false,
      scriptState: __WEBPACK_IMPORTED_MODULE_9_draft_js__["EditorState"].createWithContent(__WEBPACK_IMPORTED_MODULE_9_draft_js__["ContentState"].createFromText(flow.script)),
      errors: errors.remove('script')
    });
  };

  Flow.prototype.handleChangeScript = function handleChangeScript(scriptState) {
    this.setState({ scriptState: scriptState });

    var errors = this.state.errors;

    if (scriptState.getCurrentContent().getPlainText().trim() === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'script') });
    } else {
      this.setState({ errors: errors.remove('script') });
    }
  };

  Flow.prototype.handleSubmitScript = function handleSubmitScript() {
    var _this3 = this;

    var _state4 = this.state,
        scriptState = _state4.scriptState,
        flow = _state4.flow,
        errors = _state4.errors;

    if (errors.has('script')) {
      return;
    }

    var script = scriptState.getCurrentContent().getPlainText();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_lorautils_api__["a" /* callAPI */])({
      endpoint: "/lora/flows/" + flow.id,
      body: { script: script },
      method: 'PUT'
    }).then(function () {
      _this3.setState({
        editScript: false,
        flow: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, flow, {
          script: script
        }),
        errors: errors.remove('submitScript')
      });
    }).catch(function (error) {
      _this3.setState({
        errors: errors.add(error.code, 'submitScript')
      });
    });
  };

  Flow.prototype.handleDeleted = function handleDeleted() {
    var _props = this.props,
        getFlows = _props.getFlows,
        appId = _props.appId;

    getFlows(appId);
  };

  Flow.prototype.render = function render() {
    var _this4 = this;

    var _state5 = this.state,
        flow = _state5.flow,
        _state5$edit = _state5.edit,
        edit = _state5$edit === undefined ? false : _state5$edit,
        _state5$editData = _state5.editData,
        editData = _state5$editData === undefined ? {} : _state5$editData,
        _state5$editScript = _state5.editScript,
        editScript = _state5$editScript === undefined ? false : _state5$editScript,
        _state5$editScriptDat = _state5.editScriptData,
        editScriptData = _state5$editScriptDat === undefined ? {} : _state5$editScriptDat,
        scriptState = _state5.scriptState,
        _state5$showHelp = _state5.showHelp,
        showHelp = _state5$showHelp === undefined ? false : _state5$showHelp,
        errors = _state5.errors,
        _state5$showDelete = _state5.showDelete,
        showDelete = _state5$showDelete === undefined ? false : _state5$showDelete;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.container },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.flow },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.block + " " + __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.basic },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.name },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_Editable__["a" /* default */], {
              id: "name",
              value: flow.name,
              edit: edit,
              data: editData,
              error: this.intlMsg.errorMsg(errors.get('name')),
              onChange: this.handleChange
            })
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.desc },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_Editable__["a" /* default */], {
              id: "desc",
              value: flow.desc,
              edit: edit,
              data: editData,
              onChange: this.handleChange
            })
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_loracoms_ShowIf__["a" /* default */],
            { "if": !edit },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.actions },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_router__["f" /* Link */],
                {
                  className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.delete,
                  onClick: function onClick() {
                    return _this4.setState({ showDelete: true });
                  }
                },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-remove-sign" })
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_router__["f" /* Link */],
                {
                  className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.edit,
                  onClick: this.handleEdit
                },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-pencil" })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_loracoms_ShowIf__["a" /* default */],
            { "if": edit },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.actions },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_router__["f" /* Link */],
                { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.ok, onClick: this.handleSubmit },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-ok" })
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_router__["f" /* Link */],
                { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.cancel, onClick: function onClick() {
                    return _this4.setState({ edit: false });
                  } },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-remove" })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.block + " " + __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.rule + " " + (errors.has('script') ? __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.hasError : '') },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_Editable__["a" /* default */], {
            id: "script",
            edit: editScript,
            data: editScriptData,
            value: flow.script,
            formatter: function formatter(x) {
              return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                null,
                _.flatMap(x.split('|'), function (expr, idx) {
                  if (idx === 0) {
                    return [__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_12_loracoms_AutoColor__["a" /* default */],
                      {
                        key: "e-" + idx,
                        className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.source + " " + (expr.trim().length === 1 ? __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.circle : ''),
                        content: expr.trim()
                      },
                      expr
                    )];
                  }
                  var firstKw = expr.trim().split(' ')[0].toLowerCase();
                  if (!kKeywords.includes(firstKw)) {
                    firstKw = null;
                  }
                  return [__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { key: "s-" + idx, className: " fa fa-long-arrow-right " + __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.arrow + " " }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    {
                      key: "e-" + idx,
                      className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.expr + " " + (_.isNil(firstKw) ? '' : __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a[firstKw])
                    },
                    expr
                  )];
                })
              );
            },
            control: {
              type: 'external',
              external: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_draft_js__["Editor"], {
                editorState: scriptState,
                onChange: this.handleChangeScript
              })
            }
          }),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_loracoms_ShowIf__["a" /* default */],
            { "if": !editScript },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.actions },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_router__["f" /* Link */],
                {
                  className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.edit,
                  onClick: this.handleEditScript
                },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-pencil" })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_loracoms_ShowIf__["a" /* default */],
            { "if": editScript },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.actions },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_router__["f" /* Link */],
                {
                  className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.help,
                  onClick: function onClick() {
                    _this4.setState({ showHelp: !showHelp });
                  }
                },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-question-sign" })
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_router__["f" /* Link */],
                { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.ok, onClick: this.handleSubmitScript },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-ok" })
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_router__["f" /* Link */],
                {
                  className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.cancel,
                  onClick: function onClick() {
                    _this4.setState({
                      editScript: false,
                      errors: errors.remove('submitScript')
                    });
                  }
                },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-remove" })
              )
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_FormBlock__["a" /* default */], {
        show: editScript && errors.has('submitScript'),
        message: this.intlMsg.errorMsg(errors.get('submitScript')),
        azStyle: "danger"
      }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Collapse"],
        { "in": showHelp && editScript },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.helpDoc },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__AddFlowHelp__["a" /* default */], null)
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__DeleteFlowModal__["a" /* default */], {
        show: showDelete,
        flow: flow,
        onHide: function onHide() {
          _this4.setState({ showDelete: false });
        },
        onDeleted: this.handleDeleted
      })
    );
  };

  return Flow;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Flow.propTypes = propTypes;

var mapDispatchToProps = {
  getFlows: __WEBPACK_IMPORTED_MODULE_17_loraactions_flow__["a" /* default */].getFlows
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(Flow)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loraactions_flow__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_PageLoading__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Flow__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_scss__ = __webpack_require__(2213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);











var propTypes = {
  appId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  flowsState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  getFlows: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var Flows = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Flows, _React$Component);

  function Flows(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Flows);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    var _props$flowsState$dat = props.flowsState.data;
    _props$flowsState$dat = _props$flowsState$dat === undefined ? {} : _props$flowsState$dat;
    var _props$flowsState$dat2 = _props$flowsState$dat.flows,
        flows = _props$flowsState$dat2 === undefined ? [] : _props$flowsState$dat2;

    _this.state = {
      flows: flows,
      flowsState: props.flowsState
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.flowsview.flows');
    return _this;
  }

  Flows.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        appId = _props.appId,
        getFlows = _props.getFlows;

    getFlows(appId);
  };

  Flows.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var flowsState = nextProps.flowsState;

    if (flowsState !== this.props.flowsState) {
      this.setState({ flowsState: flowsState });
      if (flowsState.status === 'success') {
        this.setState({ flows: flowsState.data.list });
      }
    }
  };

  Flows.prototype.render = function render() {
    var appId = this.props.appId;
    var _state = this.state,
        flowsState = _state.flowsState,
        flows = _state.flows;

    if (flowsState.status === 'pending') {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_PageLoading__["a" /* default */], null);
    }
    flows.sort(function (flowA, flowB) {
      return flowA.name > flowB.name ? 1 : flowA.name < flowB.name ? -1 : 0;
    });
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.flows },
        flows.map(function (flow) {
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Flow__["a" /* default */], { key: flow.id, flow: flow, appId: appId });
        })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_loracoms_ShowIf__["a" /* default */],
        { "if": flows.length === 0 },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.noflow },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "h3",
            null,
            this.intlMsg.msg('noflow')
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.desc },
            this.intlMsg.msg('desc')
          )
        )
      )
    );
  };

  return Flows;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Flows.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    flowsState: state.flow.getFlows
  };
};

var mapDispatchToProps = {
  getFlows: __WEBPACK_IMPORTED_MODULE_6_loraactions_flow__["a" /* default */].getFlows
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(Flows)));

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_PageLoading__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_PageNoPerm__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__coms_Flows__ = __webpack_require__(1210);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var propTypes = {
  appState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  planState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var FlowsView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(FlowsView, _React$Component);

  function FlowsView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FlowsView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      appState: props.appState,
      planState: props.planState
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.flowsview');
    return _this;
  }

  FlowsView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var appState = nextProps.appState,
        planState = nextProps.planState;

    if (appState !== this.props.appState) {
      this.setState({ appState: appState });
    }
    if (planState !== this.props.planState) {
      this.setState({ planState: planState });
    }
  };

  FlowsView.prototype.renderToolbar = function renderToolbar() {
    var _props = this.props,
        pushState = _props.pushState,
        appId = _props.appId;
    var appState = this.state.appState;
    var status = appState.status,
        _appState$data = appState.data;
    _appState$data = _appState$data === undefined ? {} : _appState$data;
    var name = _appState$data.name;


    var addButton = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
      { bsStyle: "aisz-success", onClick: function onClick() {
          return pushState("/application/" + appId + "/flows/add");
        } },
      this.intlMsg.msg('add'),
      ' ',
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-plus" })
    );

    var breadcrumb = [{
      content: this.intlMsg.globalMsg('application.breadcrumb.application'),
      onClick: function onClick() {
        return pushState('/application');
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Nvl__["a" /* default */], { status: status, val: name }),
      active: true
    }];

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb, rightTools: [{ input: addButton }] });
  };

  FlowsView.prototype.render = function render() {
    var appId = this.props.appId;
    var planState = this.state.planState;

    if (planState.status === 'pending') {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_PageLoading__["a" /* default */], null);
    }
    if (planState.data.tier === 1) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_PageNoPerm__["a" /* default */], null);
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
          { md: 12 },
          this.renderToolbar()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__coms_Flows__["a" /* default */], { appId: appId })
        )
      )
    );
  };

  return FlowsView;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

FlowsView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    appState: state.app.getApp,
    appId: ownProps.params.id,
    planState: state.billing.plan
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_4_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(FlowsView)));

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_day__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_end_of_day__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_end_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_end_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_sub_days__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_sub_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_sub_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_add_days__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_add_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_is_after__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_is_after___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns_is_after__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_is_before__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_is_before___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_date_fns_is_before__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_min__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_date_fns_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_loracoms_PageSizer__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_loracoms_PanelToolbar__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_loracoms_DatePicker__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_loraapi_lora_device__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__styles_scss__ = __webpack_require__(2214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




























var defaultFrom = function defaultFrom() {
  return __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_day___default()(__WEBPACK_IMPORTED_MODULE_9_date_fns_sub_days___default()(new Date(), 7));
};
var defaultTo = function defaultTo() {
  return __WEBPACK_IMPORTED_MODULE_7_date_fns_end_of_day___default()(new Date());
};

var propTypes = {
  appId: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired,
  app: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired
};

var kLimit = 10;

var LogView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LogView, _React$Component);

  LogView.handleDisableDate = function handleDisableDate(d, from) {
    return __WEBPACK_IMPORTED_MODULE_11_date_fns_is_after___default()(d, __WEBPACK_IMPORTED_MODULE_13_date_fns_min___default()(__WEBPACK_IMPORTED_MODULE_10_date_fns_add_days___default()(from, 7), new Date())) || __WEBPACK_IMPORTED_MODULE_12_date_fns_is_before___default()(d, from);
  };

  function LogView(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LogView);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      app: props.app,
      list: [],
      pageSize: kLimit,
      from: defaultFrom(),
      to: defaultTo(),
      mark: 0
    };
    _this.handleChangePageSize = _this.handleChangePageSize.bind(_this);
    _this.handleChangeFrom = _this.handleChangeFrom.bind(_this);
    _this.handleChangeTo = _this.handleChangeTo.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_27_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.logview');
    _this.limit = kLimit;
    _this.from = defaultFrom();
    _this.to = defaultTo();
    return _this;
  }

  LogView.prototype.componentDidMount = function componentDidMount() {
    this.loadLogs();
  };

  LogView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var app = nextProps.app;

    if (app !== this.props.app) {
      this.setState({ app: app });
    }
  };

  LogView.prototype.loadLogs = function loadLogs() {
    var _this2 = this;

    var appId = this.props.appId;

    var params = {
      order: 'desc',
      after: this.from.valueOf(),
      before: this.to.valueOf(),
      limit: this.limit,
      mark: this.mark
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_loraapi_lora_device__["i" /* getAppLogs */])(appId, params).then(function (resp) {
      var res = resp.body;
      _this2.setState({ list: res.list, more: res.more, mark: _this2.mark, status: 'success' });
    }).catch(function () {});
  };

  LogView.prototype.handleChangePageSize = function handleChangePageSize(ps) {
    this.limit = ps;
    this.setState({ pageSize: ps });
    this.loadLogs();
  };

  LogView.prototype.handleChangeFrom = function handleChangeFrom(d) {
    var from = __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_day___default()(d);
    this.setState({ from: from, to: __WEBPACK_IMPORTED_MODULE_7_date_fns_end_of_day___default()(d) });
    this.from = from;
    this.loadLogs();
  };

  LogView.prototype.handleChangeTo = function handleChangeTo(d) {
    var to = __WEBPACK_IMPORTED_MODULE_7_date_fns_end_of_day___default()(d);
    this.setState({ to: to });
    this.to = to;
    this.loadLogs();
  };

  LogView.prototype.render = function render() {
    var pushState = this.props.pushState;
    var _state = this.state,
        _state$from = _state.from,
        from = _state$from === undefined ? defaultFrom() : _state$from,
        _state$to = _state.to,
        to = _state$to === undefined ? defaultTo() : _state$to,
        pageSize = _state.pageSize,
        app = _state.app;
    var _app$data = app.data,
        appData = _app$data === undefined ? {} : _app$data;


    var breadcrumb = [{
      content: this.intlMsg.msg('application', 'application.breadcrumb'),
      onClick: function onClick() {
        return pushState('/application');
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_loracoms_Nvl__["a" /* default */], { val: appData.name, status: app.status }),
      active: true
    }];

    var fromPicker = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_loracoms_DatePicker__["a" /* default */], { date: from, onSelect: this.handleChangeFrom });
    var toPicker = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_loracoms_DatePicker__["a" /* default */], {
      date: to,
      onSelect: this.handleChangeTo,
      disabled: function disabled(d) {
        return LogView.handleDisableDate(d, from);
      }
    });

    var LogLevels = {
      error: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_18_react_bootstrap__["Label"],
        { bsStyle: "danger" },
        "ERROR"
      ),
      info: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_18_react_bootstrap__["Label"],
        { bsStyle: "info" },
        "INFO"
      ),
      warn: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_18_react_bootstrap__["Label"],
        { bsStyle: "warning" },
        "WARN"
      ),
      debug: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_18_react_bootstrap__["Label"],
        { bsStyle: "default" },
        "DEBUG"
      )
    };

    var trs = this.state.list.map(function (l, idx) {
      var info = l.info || {};
      var infos = _.map(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(info), function (k) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.parsed },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.key },
            k
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.value },
            info[k]
          )
        );
      });

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "tr",
        { key: String(idx) },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.loglevel },
          LogLevels[l.cat]
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_8_date_fns_format___default()(l.$time, 'YYYY-MM-DD HH:mm:ss')
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_loracoms_RichLabel__["a" /* default */], { content: l.code })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_15_react_router__["f" /* Link */],
            {
              onClick: function onClick() {
                return pushState("/application/" + appData.id + "/devices/" + l.deveui);
              }
            },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_lorautils_IdUtils__["a" /* normalizeDevEUI */])(l.deveui)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          infos
        )
      );
    });

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_18_react_bootstrap__["Grid"],
        { fluid: true },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_18_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_18_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_18_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_18_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_18_react_bootstrap__["Panel"],
              { bsStyle: "aisz-white", header: this.intlMsg.msg('panelheader') },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_loracoms_PanelToolbar__["a" /* default */], { tools: [fromPicker, toPicker] }),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_18_react_bootstrap__["Table"],
                { className: "aisz-table-light", striped: true, hover: true, bordered: true, responsive: true },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  "thead",
                  null,
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "th",
                      { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.loglevel },
                      this.intlMsg.msg('thead.loglevel')
                    ),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "th",
                      null,
                      " ",
                      this.intlMsg.msg('thead.time'),
                      " "
                    ),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "th",
                      null,
                      " ",
                      this.intlMsg.msg('thead.code'),
                      " "
                    ),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "th",
                      null,
                      "DevEUI"
                    ),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "th",
                      null,
                      " ",
                      this.intlMsg.msg('thead.remark'),
                      " "
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  "tbody",
                  null,
                  trs
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.pager + " clearfix" },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_loracoms_PageSizer__["a" /* default */], {
                  pageSize: pageSize,
                  onChange: this.handleChangePageSize,
                  options: [10, 20, 50, 100]
                })
              )
            )
          )
        )
      )
    );
  };

  return LogView;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

LogView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    appId: ownProps.params.id,
    app: state.app.getApp
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_16_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_react_intl__["injectIntl"])(LogView)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_draft_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_draft_js_dist_Draft_css__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_draft_js_dist_Draft_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_draft_js_dist_Draft_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_esprima__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_esprima___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_esprima__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_immutable__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loraactions_parser__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Line__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_scss__ = __webpack_require__(2215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);
















var kIndent = 2;
var kIndentSpaces = '  ';
var kCodeBlock = "{\n  appeui: '8507727d09eb0001',\n  data: '00de0a6325',\n  deveui: 'e7b396ee3d921128',\n  fport: 119\n}";

var kBaseCode = "var data= payload.data;\nvar appeui = payload.appeui;\nvar deveui =payload.deveui;\nvar fport = payload.fport;\nvar bin = [];\nvar hex = [];\nvar __str__ = data;\nwhile (__str__.length >= 2) {\nvar value = __str__.substring(0, 2);\nbin.push(parseInt(value, 16));\nhex.push(value);\n__str__ = __str__.substring(2, __str__.length);\n};";

var blockRenderMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_immutable__["Map"])({
  unstyled: {
    element: 'pre'
  }
});

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any.isRequired,
  parserState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  getDebugResult: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
};

var HighlightDecorator = function () {
  function HighlightDecorator() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, HighlightDecorator);
  }

  HighlightDecorator.prototype.getDecorations = function getDecorations(block) {
    var text = block.getText();
    var decorations = Array(text.length).fill(null);
    var blockKey = block.getKey();
    try {
      var tokens = __WEBPACK_IMPORTED_MODULE_10_esprima___default.a.tokenize(text, { range: true, comment: true });
      tokens.forEach(function (token) {
        var _token$range = token.range,
            start = _token$range[0],
            end = _token$range[1];

        _.range(start, end).forEach(function (idx) {
          decorations[idx] = blockKey + "." + start + "." + token.type.toLowerCase();
        });
      });
    } catch (e) {
      // do nothing
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_immutable__["List"])(decorations);
  };

  HighlightDecorator.prototype.getComponentForKey = function getComponentForKey(key) {
    var type = key.split('.')[2];
    return function (props) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "span",
        { className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a[type] },
        props.children
      );
    };
  };

  HighlightDecorator.prototype.getPropsForKey = function getPropsForKey(key) {
    return {};
  };

  return HighlightDecorator;
}();

var findReturns = function findReturns(stmt) {
  if (_.isNil(stmt)) {
    return [];
  }
  if (stmt.type === 'ReturnStatement') {
    return [stmt];
  }
  if (stmt.type === 'IfStatement') {
    return [].concat(findReturns(stmt.consequent), findReturns(stmt.alternate));
  }
  if (stmt.type === 'BlockStatement') {
    return _.flatMap(stmt.body, findReturns);
  }
  return [];
};

var findDataPointsForName = function findDataPointsForName(name, stmt) {
  if (_.isNil(stmt)) {
    return [];
  }

  if (stmt.type === 'VariableDeclaration') {
    var decls = stmt.declarations.filter(function (decl) {
      return decl.id.name === name;
    });
    if (decls.length > 0) {
      var init = decls[0].init;
      if (init && init.type === 'ObjectExpression') {
        return init.properties.map(function (p) {
          return p.key.name;
        });
      }
    }
    return [];
  } else if (stmt.type === 'ExpressionStatement') {
    var expr = stmt.expression;
    if (expr.type === 'AssignmentExpression') {
      if (expr.left.type === 'Identifier' && expr.left.name === name && expr.right.type === 'ObjectExpression') {
        return expr.right.properties.map(function (p) {
          return p.key.name;
        });
      }
    }
    return [];
  } else if (stmt.type === 'IfStatement') {
    return _.union(findDataPointsForName(name, stmt.consequent), findDataPointsForName(name, stmt.alternate));
  } else if (stmt.type === 'BlockStatement') {
    return _.reduce(stmt.body.map(function (s) {
      return findDataPointsForName(name, s);
    }), function (accDps, dps) {
      return _.union(accDps, dps);
    }, []);
  }
  return [];
};

var findDataPoints = function findDataPoints(returnStmt, stmts) {
  if (_.isNil(returnStmt.argument)) {
    return [];
  }
  if (returnStmt.argument.type === 'Literal') {
    return [];
  }
  if (returnStmt.argument.type === 'ObjectExpression') {
    return returnStmt.argument.properties.map(function (p) {
      return p.key.name;
    });
  }
  if (returnStmt.argument.type === 'Identifier') {
    var name = returnStmt.argument.name;
    var dpsArr = stmts.map(function (stmt) {
      return findDataPointsForName(name, stmt);
    });
    return _.reduce(dpsArr, function (accDps, dps) {
      return _.union(accDps, dps);
    }, []);
  }
  return [];
};

var blockRendererFn = function blockRendererFn(contentBlock) {
  var type = contentBlock.getType();
  switch (type) {
    default:
      return { component: __WEBPACK_IMPORTED_MODULE_16__Line__["a" /* default */], editable: true };
  }
};

var Debug = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Debug, _React$Component);

  function Debug(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Debug);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      editorState: __WEBPACK_IMPORTED_MODULE_8_draft_js__["EditorState"].createWithContent(__WEBPACK_IMPORTED_MODULE_8_draft_js__["ContentState"].createFromText(kCodeBlock, /[\r\n]/), new HighlightDecorator()),
      errors: __WEBPACK_IMPORTED_MODULE_14_lorautils_errors_ErrorSet__["a" /* default */].createEmpty()
    };
    _this.onChange = _this.onChange.bind(_this);
    _this.onTab = _this.onTab.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.indentBlocks = _this.indentBlocks.bind(_this);
    _this.unindentBlocks = _this.unindentBlocks.bind(_this);
    _this.indentFocus = _this.indentFocus.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.parseview.parsers.debug');
    return _this;
  }

  Debug.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var parserState = nextProps.parserState;

    this.setState({ parserState: parserState });
  };

  Debug.prototype.onChange = function onChange(editorState) {
    this.setState({ editorState: editorState });
    var lastChangeType = editorState.getLastChangeType();
    if (lastChangeType === 'split-block') {
      this.indentFocus(editorState);
    }
  };

  Debug.prototype.onTab = function onTab(e) {
    e.preventDefault();
    var editorState = this.state.editorState;

    var selectionState = editorState.getSelection();
    var startKey = selectionState.getStartKey();
    var endKey = selectionState.getEndKey();
    var contentState = editorState.getCurrentContent();
    var blockMap = contentState.getBlockMap().skipUntil(function (_, k) {
      return k === startKey;
    }).takeUntil(function (_, k) {
      return k === contentState.getKeyAfter(endKey);
    });
    if (e.shiftKey) {
      this.unindentBlocks(editorState, contentState, selectionState, blockMap);
    } else {
      this.indentBlocks(editorState, contentState, selectionState, blockMap);
    }
  };

  Debug.prototype.indentBlocks = function indentBlocks(editorState, contentState, selectionState, blockMap) {
    var indentContent = blockMap.reduce(function (content, block) {
      var selection = __WEBPACK_IMPORTED_MODULE_8_draft_js__["SelectionState"].createEmpty(block.getKey());
      return __WEBPACK_IMPORTED_MODULE_8_draft_js__["Modifier"].insertText(content, selection, kIndentSpaces);
    }, contentState);
    var shiftSelection = selectionState.merge({
      anchorOffset: selectionState.getAnchorOffset() + kIndent,
      focusOffset: selectionState.getFocusOffset() + kIndent
    });
    this.onChange(__WEBPACK_IMPORTED_MODULE_8_draft_js__["EditorState"].forceSelection(__WEBPACK_IMPORTED_MODULE_8_draft_js__["EditorState"].push(editorState, indentContent, 'insert-characters'), shiftSelection));
  };

  Debug.prototype.unindentBlocks = function unindentBlocks(editorState, contentState, selectionState, blockMap) {
    var indentContent = blockMap.reduce(function (content, block) {
      var selection = __WEBPACK_IMPORTED_MODULE_8_draft_js__["SelectionState"].createEmpty(block.getKey()).merge({
        anchorOffset: 0,
        focusOffset: kIndent
      });
      return __WEBPACK_IMPORTED_MODULE_8_draft_js__["Modifier"].replaceText(content, selection, _.trimStart(block.getText().substr(0, kIndent)));
    }, contentState);
    var anchorOffset = selectionState.getAnchorOffset();
    var focusOffset = selectionState.getFocusOffset();
    var shiftSelection = selectionState.merge({
      anchorOffset: anchorOffset < kIndent ? 0 : anchorOffset - kIndent,
      focusOffset: focusOffset < kIndent ? 0 : focusOffset - kIndent
    });
    this.onChange(__WEBPACK_IMPORTED_MODULE_8_draft_js__["EditorState"].forceSelection(__WEBPACK_IMPORTED_MODULE_8_draft_js__["EditorState"].push(editorState, indentContent, 'delete-character'), shiftSelection));
  };

  Debug.prototype.indentFocus = function indentFocus(editorState) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();
    var focusKey = selectionState.getFocusKey();
    var beforeKey = contentState.getKeyBefore(focusKey);
    if (beforeKey) {
      var beforeBlock = contentState.getBlockForKey(beforeKey);
      var indentLevel = 0;
      if (_.endsWith(_.trimEnd(beforeBlock.getText()), '{')) {
        indentLevel += 1;
      }
      var match = beforeBlock.getText().match(/^\s+/);
      if (match) {
        indentLevel += Math.ceil(match[0].length / kIndent);
      }
      if (indentLevel > 0) {
        var indentSpaces = _.range(indentLevel).map(function () {
          return kIndentSpaces;
        }).join('');
        var indentSelection = selectionState.merge({
          anchorOffset: selectionState.getAnchorOffset() + indentSpaces.length,
          focusOffset: selectionState.getFocusOffset() + indentSpaces.length
        });
        this.onChange(__WEBPACK_IMPORTED_MODULE_8_draft_js__["EditorState"].forceSelection(__WEBPACK_IMPORTED_MODULE_8_draft_js__["EditorState"].push(editorState, __WEBPACK_IMPORTED_MODULE_8_draft_js__["Modifier"].insertText(contentState, selectionState, indentSpaces), 'insert-characters'), indentSelection));
      }
    }
  };

  Debug.prototype.handleSubmit = function handleSubmit() {
    var _state = this.state,
        editorState = _state.editorState,
        parserState = _state.parserState;
    var errors = this.state.errors;


    errors = errors.remove('submit');
    this.setState({ errors: errors, errTip: '', submitStatus: 'pending' });

    // check debug code
    var code = editorState.getCurrentContent().getPlainText();
    try {
      __WEBPACK_IMPORTED_MODULE_10_esprima___default.a.parse("function x() { var payload = " + code + " }");
    } catch (e) {
      if (e.lineNumber > 0) {
        this.setState({ lineNumber: e.lineNumber, errDesc: e.description });
      }
      this.setState({
        errors: errors.add('FE_DEBUG_SYNTAXINVALID', 'submit'),
        submitStatus: 'failure'
      });
      return;
    }

    // check parser code
    var result = {};
    var script = '';
    var parsed = void 0;
    if (typeof parserState === 'string') {
      script = parserState;
    } else if ((typeof parserState === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(parserState)) === 'object') {
      try {
        script = parserState.getCurrentContent().getPlainText();
      } catch (err) {
        // TO DO
      }
    }
    try {
      parsed = __WEBPACK_IMPORTED_MODULE_10_esprima___default.a.parse("function x() { " + script + " }");
    } catch (e) {
      if (e.lineNumber > 0) {
        this.setState({ lineNumber: e.lineNumber, errDesc: e.description });
      }
      this.setState({
        errors: errors.add('FE_PARSER_SYNTAXINVALID', 'submit'),
        submitStatus: 'failure'
      });
      return;
    }

    if (script.indexOf('_config_') <= -1) {
      try {
        var evalCode = new Function("var payload = " + code + ";" + kBaseCode + script);
        result = evalCode() || null;
      } catch (e) {
        var reg = new RegExp(/<anonymous>:(\d)*:/, 'g');
        var stack = reg.exec(e.stack);
        var errLine = Number(stack[0].split(':')[1]);
        this.setState({
          errors: errors.add('FE_DEBUG_FAILURE', 'submit'),
          errTip: e.message + ": " + (errLine - 2),
          submitStatus: 'failure',
          lineNumber: 0
        });
        return;
      }
    }

    var statements = parsed.body[0].body.body;
    if (statements.length === 0) {
      this.setState({
        errors: errors.add('FE_RETMISSING', 'submit'),
        submitStatus: 'failure'
      });
      return;
    }

    var returnStmts = _.flatMap(statements, findReturns);
    if (returnStmts.length === 0) {
      this.setState({
        errors: errors.add('FE_RETMISSING', 'submit'),
        submitStatus: 'failure'
      });
      return;
    }

    this.props.getDebugResult(result);
    var dataPoints = _.reduce(_.map(returnStmts, function (x) {
      return findDataPoints(x, statements);
    }), function (acc, dps) {
      return _.union(acc, dps);
    }, []);

    this.setState({
      dataPoints: dataPoints,
      submitStatus: 'success'
    });
  };

  Debug.prototype.render = function render() {
    var _this2 = this;

    var _state2 = this.state,
        editorState = _state2.editorState,
        errors = _state2.errors,
        _state2$submitStatus = _state2.submitStatus,
        submitStatus = _state2$submitStatus === undefined ? '' : _state2$submitStatus,
        _state2$lineNumber = _state2.lineNumber,
        lineNumber = _state2$lineNumber === undefined ? 0 : _state2$lineNumber,
        _state2$errDesc = _state2.errDesc,
        errDesc = _state2$errDesc === undefined ? '' : _state2$errDesc,
        _state2$errTip = _state2.errTip,
        errTip = _state2$errTip === undefined ? '' : _state2$errTip;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.editor },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_draft_js__["Editor"], {
        blockRenderMap: blockRenderMap,
        blockStyleFn: function blockStyleFn() {
          return __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.codeBlock;
        },
        editorState: editorState,
        onChange: this.onChange,
        onTab: this.onTab,
        ref: function ref(_ref) {
          _this2.editorRef = _ref;
        },
        blockRendererFn: blockRendererFn
      }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.submitBar },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.submitError + " " + (errors.has('submit') ? __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.show : '') },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-warning-sign" }),
          ' ',
          errTip === '' && this.intlMsg.errorMsg(errors.get('submit')),
          errTip !== '' && errTip,
          lineNumber !== 0 && "(" + this.intlMsg.msg('line0') + " " + lineNumber + " " + this.intlMsg.msg('line1') + " " + errDesc + " )"
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_RichButton__["a" /* default */], {
          status: submitStatus,
          states: [{
            status: 'default',
            label: 'debug',
            style: 'primary',
            onClick: this.handleSubmit
          }, {
            status: 'success',
            label: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "span",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-tick" }),
              ' ',
              "Ok"
            ),
            style: 'success',
            timer: function timer() {
              return _this2.setState({ submitStatus: '' });
            }
          }, {
            status: 'failure',
            label: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "span",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-warning-sign" }),
              ' ',
              this.intlMsg.msg('failure')
            ),
            style: 'danger',
            timer: function timer() {
              return _this2.setState({ submitStatus: '' });
            }
          }, {
            status: 'pending',
            label: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "span",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" }),
              ' ',
              "debug"
            ),
            style: 'info'
          }]
        })
      )
    );
  };

  return Debug;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Debug.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    parserState: state.parser.getParserCode
  };
};

var mapDispatchToProps = {
  getDebugResult: __WEBPACK_IMPORTED_MODULE_12_loraactions_parser__["b" /* getDebugResult */]
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(Debug)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Highlight__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss__ = __webpack_require__(2216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







var propTypes = {
  debugResult: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};

var kSampleCode = "\n//   Return value will show in here.\n";

var kResult = "/*\n{\n  result1: 100,\n  result2: 300\n}\n*/";

var DebugSample = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DebugSample, _React$Component);

  function DebugSample(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DebugSample);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      debugResult: "" + kSampleCode + kResult
    };
    return _this;
  }

  DebugSample.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var debugResult = nextProps.debugResult;

    try {
      debugResult = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(debugResult);
    } catch (err) {
      debugResult = 'none value returned';
    }
    this.setState({ debugResult: "" + kSampleCode + debugResult });
  };

  DebugSample.prototype.render = function render() {
    var debugResult = this.state.debugResult;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.sample },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "pre",
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "code",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Highlight__["a" /* default */], { code: debugResult })
        )
      )
    );
  };

  return DebugSample;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

DebugSample.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    debugResult: state.parser.getDebugResult
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps, null)(DebugSample));

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ParserAddModal__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss__ = __webpack_require__(2217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);








var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired
};

var ParserAddCard = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ParserAddCard, _React$Component);

  function ParserAddCard(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ParserAddCard);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {};
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.parseview.parsers');
    return _this;
  }

  ParserAddCard.prototype.render = function render() {
    var _this2 = this;

    var appId = this.props.appId;
    var _state$showAdd = this.state.showAdd,
        showAdd = _state$showAdd === undefined ? false : _state$showAdd;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_router__["f" /* Link */],
        { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.card, onClick: function onClick() {
            return _this2.setState({ showAdd: true });
          } },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-plus" }),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("br", null),
        this.intlMsg.msg('add')
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ParserAddModal__["a" /* default */], {
        appId: appId,
        show: showAdd,
        onHide: function onHide() {
          return _this2.setState({ showAdd: false });
        }
      })
    );
  };

  return ParserAddCard;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ParserAddCard.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(ParserAddCard));

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_draft_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_draft_js_dist_Draft_css__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_draft_js_dist_Draft_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_draft_js_dist_Draft_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_scss__ = __webpack_require__(2218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  show: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var ParserAddModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ParserAddModal, _React$Component);

  function ParserAddModal(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ParserAddModal);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      editorState: __WEBPACK_IMPORTED_MODULE_8_draft_js__["EditorState"].createEmpty(),
      show: props.show,
      errors: __WEBPACK_IMPORTED_MODULE_13_lorautils_errors_ErrorSet__["a" /* default */].createEmpty().add('FE_EMPTY', 'name')
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.parseview.parsers.add');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleChangeDesc = _this.handleChangeDesc.bind(_this);
    _this.handleChangeName = _this.handleChangeName.bind(_this);
    return _this;
  }

  ParserAddModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var show = nextProps.show;

    if (show !== this.props.show) {
      this.setState({ show: show });
    }
  };

  ParserAddModal.prototype.handleSubmit = function handleSubmit(e) {
    var _this2 = this;

    e.preventDefault();
    this.setState({ submitted: true });

    var appId = this.props.appId;
    var _state = this.state,
        errors = _state.errors,
        name = _state.name,
        editorState = _state.editorState;


    if (!errors.isEmpty()) {
      return;
    }

    this.setState({ addStatus: 'pending' });

    var desc = editorState.getCurrentContent().getPlainText();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_lorautils_api__["a" /* callAPI */])({
      endpoint: '/lora/parsers',
      method: 'POST',
      body: {
        type: 'parser',
        name: name,
        desc: desc,
        appid: appId,
        parser: {
          script: ''
        }
      }
    }).then(function (data) {
      _this2.setState({
        addStatus: 'success',
        parserId: data.id
      });
    }).catch(function () {
      _this2.setState({
        addStatus: 'failure'
      });
    });
  };

  ParserAddModal.prototype.handleChangeName = function handleChangeName(e) {
    var name = e.target.value.trim();
    var errors = this.state.errors;

    if (name === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'name'), name: name });
    } else {
      this.setState({ errors: errors.remove('name'), name: name });
    }
  };

  ParserAddModal.prototype.handleChangeDesc = function handleChangeDesc(editorState) {
    this.setState({ editorState: editorState });
  };

  ParserAddModal.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        onHide = _props.onHide,
        pushState = _props.pushState,
        appId = _props.appId;
    var _state2 = this.state,
        editorState = _state2.editorState,
        _state2$show = _state2.show,
        show = _state2$show === undefined ? false : _state2$show,
        _state2$name = _state2.name,
        name = _state2$name === undefined ? '' : _state2$name,
        _state2$submitted = _state2.submitted,
        submitted = _state2$submitted === undefined ? false : _state2$submitted,
        errors = _state2.errors,
        _state2$addStatus = _state2.addStatus,
        addStatus = _state2$addStatus === undefined ? '' : _state2$addStatus,
        _state2$parserId = _state2.parserId,
        parserId = _state2$parserId === undefined ? '' : _state2$parserId;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"],
      { bsClass: "aisz-modal-light", show: show, onHide: onHide },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        this.intlMsg.msg('modalheader')
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Form"],
          { onSubmit: this.handleSubmit, horizontal: true },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
            { validationState: submitted && errors.has('name') ? 'error' : undefined },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                { className: "aisz-control-label" },
                this.intlMsg.msg('name')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormControl"], {
                className: "aisz-form-control",
                value: name,
                onChange: this.handleChangeName
              }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_ControlTips__["a" /* default */], {
                show: submitted && errors.has('name'),
                message: this.intlMsg.errorMsg(errors.get('name')),
                azStyle: "danger"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                { className: "aisz-control-label" },
                this.intlMsg.msg('desc')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_draft_js__["Editor"], {
                editorState: editorState,
                onChange: this.handleChangeDesc,
                blockStyleFn: function blockStyleFn() {
                  return __WEBPACK_IMPORTED_MODULE_15__styles_scss___default.a.desc;
                }
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { mdOffset: 3, md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_15__styles_scss___default.a.submit },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_RichButton__["a" /* default */], {
                  status: addStatus,
                  states: [{
                    status: 'default',
                    style: 'primary',
                    label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "span",
                      null,
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-plus" }),
                      ' ',
                      this.intlMsg.msg('submit')
                    ),
                    type: 'submit'
                  }, {
                    status: 'pending',
                    style: 'info',
                    label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "span",
                      null,
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" }),
                      ' ',
                      this.intlMsg.msg('submitting')
                    )
                  }, {
                    status: 'success',
                    style: 'success',
                    label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "span",
                      null,
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-tick" }),
                      ' ',
                      this.intlMsg.msg('submitsucc')
                    ),
                    timer: function timer() {
                      return pushState("/application/" + appId + "/parse/" + parserId);
                    },
                    delay: 500
                  }, {
                    status: 'failure',
                    style: 'danger',
                    label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "span",
                      null,
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-warning-sign" }),
                      ' ',
                      this.intlMsg.msg('submitfail')
                    ),
                    timer: function timer() {
                      return _this3.setState({ addStatus: '' });
                    },
                    delay: 500
                  }]
                })
              )
            )
          )
        )
      )
    );
  };

  return ParserAddModal;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ParserAddModal.propTypes = propTypes;

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_5_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(ParserAddModal)));

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_draft_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Editable__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ParserDelModal__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss__ = __webpack_require__(2219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);















var propTypes = {
  parser: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired
};

var ParserCard = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ParserCard, _React$Component);

  function ParserCard(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ParserCard);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      parser: props.parser,
      errors: __WEBPACK_IMPORTED_MODULE_12_lorautils_errors_ErrorSet__["a" /* default */].createEmpty(),
      descState: __WEBPACK_IMPORTED_MODULE_9_draft_js__["EditorState"].createEmpty()
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_14_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.parseview.parsers');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleEdit = _this.handleEdit.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleChangeDesc = _this.handleChangeDesc.bind(_this);
    return _this;
  }

  ParserCard.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var parser = nextProps.parser;

    if (parser !== this.props.parser) {
      this.setState({ parser: parser });
    }
  };

  ParserCard.prototype.handleChange = function handleChange(editData, id) {
    var errors = this.state.errors;

    this.setState({ editData: editData });
    if (id === 'name') {
      if (editData.name === '') {
        this.setState({
          errors: errors.add('FE_EMPTY', 'name')
        });
      } else {
        this.setState({
          errors: errors.remove('name')
        });
      }
    }
  };

  ParserCard.prototype.handleChangeDesc = function handleChangeDesc(descState) {
    this.setState({ descState: descState });
  };

  ParserCard.prototype.handleEdit = function handleEdit() {
    var _state = this.state,
        _state$parser = _state.parser,
        name = _state$parser.name,
        desc = _state$parser.desc,
        errors = _state.errors;

    this.setState({
      edit: true,
      editData: { name: name },
      descState: __WEBPACK_IMPORTED_MODULE_9_draft_js__["EditorState"].createWithContent(__WEBPACK_IMPORTED_MODULE_9_draft_js__["ContentState"].createFromText(desc)),
      errors: errors.remove('name')
    });
  };

  ParserCard.prototype.handleSubmit = function handleSubmit() {
    var _this2 = this;

    var _state2 = this.state,
        name = _state2.editData.name,
        descState = _state2.descState,
        errors = _state2.errors,
        parser = _state2.parser;

    if (errors.has('name')) {
      return;
    }

    var desc = descState.getCurrentContent().getPlainText();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_api__["a" /* callAPI */])({
      endpoint: "/lora/parsers/" + parser.id,
      body: { name: name, desc: desc },
      method: 'PUT'
    }).then(function () {
      _this2.setState({
        parser: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, parser, {
          name: name,
          desc: desc
        }),
        edit: false
      });
    }).catch(function (error) {
      _this2.setState({
        errors: errors.add(error.code, 'name')
      });
    });
  };

  ParserCard.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        pushState = _props.pushState,
        appId = _props.appId;
    var _state3 = this.state,
        parser = _state3.parser,
        _state3$showDelete = _state3.showDelete,
        showDelete = _state3$showDelete === undefined ? false : _state3$showDelete,
        _state3$edit = _state3.edit,
        edit = _state3$edit === undefined ? false : _state3$edit,
        _state3$editData = _state3.editData,
        editData = _state3$editData === undefined ? {} : _state3$editData,
        errors = _state3.errors,
        descState = _state3.descState;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.card },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.name },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Editable__["a" /* default */], {
          id: "name",
          edit: edit,
          value: parser.name,
          data: editData,
          formatter: function formatter(x) {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
              { onClick: function onClick() {
                  return pushState("/application/" + appId + "/parse/" + parser.id);
                } },
              x
            );
          },
          onChange: this.handleChange,
          error: this.intlMsg.errorMsg(errors.get('name'))
        })
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.desc },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Editable__["a" /* default */], {
          id: "desc",
          edit: edit,
          value: parser.desc,
          data: editData,
          control: {
            type: 'external',
            external: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.descEditor },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_draft_js__["Editor"], {
                editorState: descState,
                onChange: this.handleChangeDesc
              })
            )
          },
          formatter: function formatter(x) {
            if (x.length < 40) {
              return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "span",
                null,
                x
              );
            }
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "span",
              null,
              x.substring(0, 40) + "..."
            );
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__["a" /* default */],
        { "if": !edit },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.actions },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
            {
              className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.delete,
              onClick: function onClick() {
                return _this3.setState({ showDelete: true });
              }
            },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-remove-sign" })
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
            {
              className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.edit,
              onClick: this.handleEdit
            },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-pencil" })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__["a" /* default */],
        { "if": edit },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.actions },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
            { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.ok, onClick: this.handleSubmit },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-ok" })
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
            { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.cancel, onClick: function onClick() {
                return _this3.setState({ edit: false });
              } },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-remove" })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ParserDelModal__["a" /* default */], {
        appId: appId,
        parser: parser,
        show: showDelete,
        onHide: function onHide() {
          return _this3.setState({ showDelete: false });
        }
      })
    );
  };

  return ParserCard;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ParserCard.propTypes = propTypes;

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(ParserCard)));

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_Refresher__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_scss__ = __webpack_require__(2220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  parserId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired
};

var ParserData = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ParserData, _React$Component);

  function ParserData(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ParserData);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {};
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.parseview.parsers.data');
    _this.handleReload = _this.handleReload.bind(_this);
    return _this;
  }

  ParserData.prototype.componentWillMount = function componentWillMount() {
    this.loadData();
  };

  ParserData.prototype.loadData = function loadData() {
    var _this2 = this;

    var parserId = this.props.parserId;

    this.setState({ status: 'pending' });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lorautils_api__["a" /* callAPI */])({
      endpoint: '/lora/timeseries',
      body: { parser: parserId },
      method: 'POST'
    }).then(function (data) {
      _this2.setState({
        timeSeries: data.list,
        status: 'success'
      });
    }).catch(function () {
      _this2.setState({
        status: 'failure'
      });
    });
  };

  ParserData.prototype.handleReload = function handleReload() {
    this.loadData();
  };

  ParserData.prototype.render = function render() {
    var _props = this.props,
        pushState = _props.pushState,
        appId = _props.appId;
    var _state = this.state,
        _state$timeSeries = _state.timeSeries,
        timeSeries = _state$timeSeries === undefined ? [] : _state$timeSeries,
        _state$status = _state.status,
        status = _state$status === undefined ? 'pending' : _state$status;


    var dataPoints = _.uniq(_.flatMap(timeSeries, function (ts) {
      return _.keys(ts.metrics);
    }));
    var ths = dataPoints.map(function (dp) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "th",
        { key: dp },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
          { onClick: function onClick() {
              return pushState("/application/" + appId + "/dps/" + dp + "/trend");
            } },
          dp
        )
      );
    });
    var trs = timeSeries.map(function (ts, idx) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        { key: String(idx) },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(ts.timestamp, 'YYYY-MM-DD HH:mm:ss')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
            { onClick: function onClick() {
                return pushState("/application/" + appId + "/devices/" + ts.nodeid);
              } },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lorautils_IdUtils__["a" /* normalizeDevEUI */])(ts.nodeid)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_Nvl__["a" /* default */], {
            val: ts.name,
            formatter: function formatter(v) {
              return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                { onClick: function onClick() {
                    return pushState("/application/" + appId + "/devices/" + ts.nodeid);
                  } },
                v
              );
            }
          })
        ),
        dataPoints.map(function (dp) {
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            { key: dp },
            ts.metrics[dp]
          );
        })
      );
    });

    var header = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "span",
        null,
        this.intlMsg.msg('header')
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "ul",
        { className: "icontools" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Refresher__["a" /* default */], {
            onReload: this.handleReload,
            reloading: status === 'pending'
          })
        )
      )
    );

    if (timeSeries.length === 0) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Panel"],
        { bsStyle: "aisz-white", header: header },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_15__styles_scss___default.a.noData },
          this.intlMsg.msg('nodata')
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: header, className: "parsedDataMaxHeight" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Table"],
        { className: "aisz-table-light", striped: true, bordered: true, hover: true, responsive: true },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('thead.time')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              "DevEUI"
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('thead.name')
            ),
            ths
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "tbody",
          null,
          trs
        )
      )
    );
  };

  return ParserData;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ParserData.propTypes = propTypes;

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(ParserData)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loraactions_parser__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_scss__ = __webpack_require__(2221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);











var propTypes = {
  show: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  parser: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  getParsers: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var ParserDelModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ParserDelModal, _React$Component);

  function ParserDelModal(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ParserDelModal);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      show: props.show,
      parser: props.parser
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.parseview.parsers.delete');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleSuccess = _this.handleSuccess.bind(_this);
    return _this;
  }

  ParserDelModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var show = nextProps.show,
        parser = nextProps.parser;

    if (show !== this.props.show) {
      this.setState({ show: show });
    }
    if (parser !== this.props.parser) {
      this.setState({ parser: parser });
    }
  };

  ParserDelModal.prototype.handleSubmit = function handleSubmit() {
    var _this2 = this;

    var parser = this.state.parser;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lorautils_api__["a" /* callAPI */])({
      endpoint: "/lora/parsers/" + parser.id,
      method: 'DELETE'
    }).then(function () {
      _this2.setState({ deleteStatus: 'success' });
    }).catch(function () {
      _this2.setState({ deleteStatus: 'failure' });
    });
  };

  ParserDelModal.prototype.handleSuccess = function handleSuccess() {
    var _props = this.props,
        appId = _props.appId,
        getParsers = _props.getParsers,
        onHide = _props.onHide;

    getParsers({ appid: appId });
    onHide();
  };

  ParserDelModal.prototype.render = function render() {
    var onHide = this.props.onHide;
    var _state = this.state,
        show = _state.show,
        parser = _state.parser,
        _state$deleteStatus = _state.deleteStatus,
        deleteStatus = _state$deleteStatus === undefined ? '' : _state$deleteStatus;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"],
      { bsClass: "aisz-modal-danger", show: show, onHide: onHide },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        this.intlMsg.msg('modalheader')
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "text-center" },
          this.intlMsg.msg('modalbody'),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.name },
            parser.name
          ),
          "?",
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.buttons },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
              { bsStyle: "aisz-warning", onClick: onHide },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-repeat" }),
              ' ',
              this.intlMsg.msg('cancel')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__["a" /* default */], {
              status: deleteStatus,
              states: [{
                status: 'default',
                style: 'danger',
                label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "span",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-remove" }),
                  ' ',
                  this.intlMsg.msg('submit')
                ),
                onClick: this.handleSubmit
              }, {
                status: 'pending',
                style: 'info',
                label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "span",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" }),
                  ' ',
                  this.intlMsg.msg('submitting')
                )
              }, {
                status: 'success',
                style: 'success',
                label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "span",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-tick" }),
                  ' ',
                  this.intlMsg.msg('submitsucc')
                ),
                timer: this.handleSuccess,
                delay: 500
              }]
            })
          )
        )
      )
    );
  };

  return ParserDelModal;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var mapDispatchToProps = {
  getParsers: __WEBPACK_IMPORTED_MODULE_9_loraactions_parser__["a" /* default */].getParsers
};

ParserDelModal.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(ParserDelModal)));

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loraactions_parser__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Debug__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DebugSample__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ScriptEditor__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ScriptSample__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ParserData__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss__ = __webpack_require__(2222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




// import { Link } from 'react-router';




// import Checkbox from 'loracoms/Checkbox';
// import ShowIf from 'loracoms/ShowIf';










var propTypes = {
  app: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  parser: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  parserId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  getParser: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var ParserDetail = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ParserDetail, _React$Component);

  function ParserDetail(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ParserDetail);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      app: props.app,
      parser: props.parser
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.parseview.parserdetail');
    return _this;
  }

  ParserDetail.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        parserId = _props.parserId,
        getParser = _props.getParser;

    getParser(parserId);
  };

  ParserDetail.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var app = nextProps.app,
        parser = nextProps.parser;

    if (app !== this.props.app) {
      this.setState({ app: app });
    }
    if (parser !== this.props.parser) {
      var isConfig = false;
      var output = 'dps';
      if (parser.data) {
        var _parser$data$parser = parser.data.parser,
            requestconfig = _parser$data$parser.requestconfig,
            outputschema = _parser$data$parser.outputschema;

        isConfig = requestconfig;
        output = outputschema || 'dp';
      }
      this.setState({ parser: parser, isConfig: isConfig, output: output });
    }
  };

  ParserDetail.prototype.handleChangeOutputSchema = function handleChangeOutputSchema(outputschema) {
    var _this2 = this;

    this.setState({ output: outputschema }, function () {
      _this2.handleUpdateConfig({ outputschema: outputschema });
    });
  };

  ParserDetail.prototype.handleChangeConfig = function handleChangeConfig(requestconfig) {
    var _this3 = this;

    this.setState({ isConfig: requestconfig }, function () {
      _this3.handleUpdateConfig({ requestconfig: requestconfig });
    });
  };

  ParserDetail.prototype.handleUpdateConfig = function handleUpdateConfig(parser) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__api_callAPI__["a" /* default */])({
      endpoint: "/lora/parsers/" + this.props.parserId,
      method: 'PUT',
      body: { parser: parser }
    }).then(function () {}).catch(function () {});
  };

  ParserDetail.prototype.renderToolbar = function renderToolbar() {
    var _props2 = this.props,
        pushState = _props2.pushState,
        appId = _props2.appId;
    var _state = this.state,
        app = _state.app,
        parser = _state.parser;
    var _app$data = app.data,
        appData = _app$data === undefined ? {} : _app$data;
    var _parser$data = parser.data,
        parserData = _parser$data === undefined ? {} : _parser$data;


    var breadcrumb = [{
      onClick: function onClick() {
        return pushState('/application');
      },
      content: this.intlMsg.msg('breadcrumb.application', 'application')
    }, {
      content: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Nvl__["a" /* default */], { val: appData.name, status: app.status }),
      onClick: function onClick() {
        return pushState("/application/" + appId + "/parse");
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Nvl__["a" /* default */], { val: parserData.name, status: parser.status }),
      active: true
    }];

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  ParserDetail.prototype.render = function render() {
    var _props3 = this.props,
        parserId = _props3.parserId,
        appId = _props3.appId;
    // const {
    // isConfig = false,
    // output = 'dp',
    // showOption = false,
    // } = this.state;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
          { md: 12 },
          this.renderToolbar()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
          { md: 7 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ScriptEditor__["a" /* default */], { parserId: parserId })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
          { md: 5, className: "collapse-left" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Tab"].Container,
            { id: "helpTabs", defaultActiveKey: "sample" },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
              { className: "clearfix" },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                { sm: 12 },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Nav"],
                  { bsStyle: "aisz-tabs" },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["NavItem"],
                    { eventKey: "sample" },
                    this.intlMsg.msg('helptabs.sample')
                  ),
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["NavItem"],
                    { eventKey: "debug" },
                    "debug"
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                { sm: 12 },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Tab"].Content,
                  { animation: true },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Tab"].Pane,
                    { eventKey: "sample" },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "div",
                      { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.tab },
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ScriptSample__["a" /* default */], null)
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Tab"].Pane,
                    { eventKey: "debug" },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "div",
                      { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.tabBase },
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__DebugSample__["a" /* default */], null),
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Debug__["a" /* default */], null)
                    )
                  )
                )
              )
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.data },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ParserData__["a" /* default */], { appId: appId, parserId: parserId })
          )
        )
      )
    );
  };

  return ParserDetail;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ParserDetail.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    appId: ownProps.params.id,
    parserId: ownProps.params.parserId,
    app: state.app.getApp,
    parser: state.parser.getParser
  };
};
var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push,
  getParser: __WEBPACK_IMPORTED_MODULE_11_loraactions_parser__["a" /* default */].getParser
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(ParserDetail)));

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_scss__ = __webpack_require__(2223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_scss__);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var ParserLoadingCard = function ParserLoadingCard() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: __WEBPACK_IMPORTED_MODULE_1__styles_scss___default.a.card },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin fa-3x" })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ParserLoadingCard);

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loraactions_parser__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ParserCard__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ParserAddCard__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ParserLoadingCard__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_scss__ = __webpack_require__(2224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);











var propTypes = {
  parsers: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  getParsers: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var Parsers = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Parsers, _React$Component);

  function Parsers(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Parsers);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      parsers: props.parsers
    };
    return _this;
  }

  Parsers.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        appId = _props.appId,
        getParsers = _props.getParsers;

    getParsers({ appid: appId });
  };

  Parsers.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var parsers = nextProps.parsers;

    if (parsers !== this.props.parsers) {
      this.setState({ parsers: parsers });
    }
  };

  Parsers.prototype.render = function render() {
    var appId = this.props.appId;
    var parsers = this.state.parsers;


    var parserCards = void 0;

    if (parsers.status === 'success') {
      parserCards = parsers.data.list.map(function (p) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { key: p.id, md: 3, className: "collapse-left" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ParserCard__["a" /* default */], { parser: p, appId: appId })
        );
      });
    } else if (parsers.status === 'pending') {
      parserCards = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
        { md: 3, className: "collapse-left" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ParserLoadingCard__["a" /* default */], null)
      );
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.parsers },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Grid"],
        { fluid: true },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Row"],
          null,
          parserCards,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
            { md: 3, className: "collapse-left" },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ParserAddCard__["a" /* default */], { appId: appId })
          )
        )
      )
    );
  };

  return Parsers;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Parsers.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    parsers: state.parser.getParsers
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_5_react_router_redux__["routerActions"].push,
  getParsers: __WEBPACK_IMPORTED_MODULE_7_loraactions_parser__["a" /* default */].getParsers
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(Parsers));

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_draft_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_draft_js_dist_Draft_css__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_draft_js_dist_Draft_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_draft_js_dist_Draft_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_clipboard__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_esprima__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_esprima___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_esprima__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_immutable__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_js_beautify__ = __webpack_require__(2385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_js_beautify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_js_beautify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loracoms_Flash__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loraactions_parser__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Line__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss__ = __webpack_require__(2225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




















var kIndent = 2;
var kIndentSpaces = '  ';
var kCodeBlock = "var fport=119;\nvar bin = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];\nvar data = '1122334455667788';\nvar appeui = '121212';\nvar deveui ='3434';\nvar hex = [1,1,1,1,1,1,1,11,1];\n";

var blockRenderMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_immutable__["Map"])({
  unstyled: {
    element: 'pre'
  }
});

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  parserId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  parser: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  getParserCode: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var HighlightDecorator = function () {
  function HighlightDecorator() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, HighlightDecorator);
  }

  HighlightDecorator.prototype.getDecorations = function getDecorations(block) {
    var text = block.getText();
    var decorations = Array(text.length).fill(null);
    var blockKey = block.getKey();
    try {
      var tokens = __WEBPACK_IMPORTED_MODULE_10_esprima___default.a.tokenize(text, { range: true, comment: true });
      tokens.forEach(function (token) {
        var _token$range = token.range,
            start = _token$range[0],
            end = _token$range[1];

        _.range(start, end).forEach(function (idx) {
          decorations[idx] = blockKey + "." + start + "." + token.type.toLowerCase();
        });
      });
    } catch (e) {
      // do nothing
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_immutable__["List"])(decorations);
  };

  HighlightDecorator.prototype.getComponentForKey = function getComponentForKey(key) {
    var type = key.split('.')[2];
    return function (props) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "span",
        { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a[type] },
        props.children
      );
    };
  };

  HighlightDecorator.prototype.getPropsForKey = function getPropsForKey(key) {
    return {};
  };

  return HighlightDecorator;
}();

var findReturns = function findReturns(stmt) {
  if (_.isNil(stmt)) {
    return [];
  }
  if (stmt.type === 'ReturnStatement') {
    return [stmt];
  }
  if (stmt.type === 'IfStatement') {
    return [].concat(findReturns(stmt.consequent), findReturns(stmt.alternate));
  }
  if (stmt.type === 'BlockStatement') {
    return _.flatMap(stmt.body, findReturns);
  }
  return [];
};

var findDataPointsForName = function findDataPointsForName(name, stmt) {
  if (_.isNil(stmt)) {
    return [];
  }

  if (stmt.type === 'VariableDeclaration') {
    var decls = stmt.declarations.filter(function (decl) {
      return decl.id.name === name;
    });
    if (decls.length > 0) {
      var init = decls[0].init;
      if (init && init.type === 'ObjectExpression') {
        return init.properties.map(function (p) {
          return p.key.name;
        });
      }
    }
    return [];
  } else if (stmt.type === 'ExpressionStatement') {
    var expr = stmt.expression;
    if (expr.type === 'AssignmentExpression') {
      if (expr.left.type === 'Identifier' && expr.left.name === name && expr.right.type === 'ObjectExpression') {
        return expr.right.properties.map(function (p) {
          return p.key.name;
        });
      }
    }
    return [];
  } else if (stmt.type === 'IfStatement') {
    return _.union(findDataPointsForName(name, stmt.consequent), findDataPointsForName(name, stmt.alternate));
  } else if (stmt.type === 'BlockStatement') {
    return _.reduce(stmt.body.map(function (s) {
      return findDataPointsForName(name, s);
    }), function (accDps, dps) {
      return _.union(accDps, dps);
    }, []);
  }
  return [];
};

var findDataPoints = function findDataPoints(returnStmt, stmts) {
  if (_.isNil(returnStmt.argument)) {
    return [];
  }
  if (returnStmt.argument.type === 'Literal') {
    return [];
  }
  if (returnStmt.argument.type === 'ObjectExpression') {
    return returnStmt.argument.properties.map(function (p) {
      return p.key.name;
    });
  }
  if (returnStmt.argument.type === 'Identifier') {
    var name = returnStmt.argument.name;
    var dpsArr = stmts.map(function (stmt) {
      return findDataPointsForName(name, stmt);
    });
    return _.reduce(dpsArr, function (accDps, dps) {
      return _.union(accDps, dps);
    }, []);
  }
  return [];
};

var blockRendererFn = function blockRendererFn(contentBlock) {
  var type = contentBlock.getType();
  switch (type) {
    default:
      return { component: __WEBPACK_IMPORTED_MODULE_19__Line__["a" /* default */], editable: true };
  }
};

var ScriptEditor = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_inherits___default()(ScriptEditor, _React$Component);

  function ScriptEditor(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ScriptEditor);

    var _this = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    var _props$parser$data = props.parser.data;
    _props$parser$data = _props$parser$data === undefined ? {} : _props$parser$data;
    var _props$parser$data$pa = _props$parser$data.parser;
    _props$parser$data$pa = _props$parser$data$pa === undefined ? {} : _props$parser$data$pa;
    var _props$parser$data$pa2 = _props$parser$data$pa.script,
        script = _props$parser$data$pa2 === undefined ? '' : _props$parser$data$pa2;

    _this.state = {
      editorState: __WEBPACK_IMPORTED_MODULE_7_draft_js__["EditorState"].createWithContent(__WEBPACK_IMPORTED_MODULE_7_draft_js__["ContentState"].createFromText(script, /[\r\n]/), new HighlightDecorator()),
      errors: __WEBPACK_IMPORTED_MODULE_14_lorautils_errors_ErrorSet__["a" /* default */].createEmpty()
    };
    _this.onChange = _this.onChange.bind(_this);
    _this.onTab = _this.onTab.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.indentBlocks = _this.indentBlocks.bind(_this);
    _this.unindentBlocks = _this.unindentBlocks.bind(_this);
    _this.indentFocus = _this.indentFocus.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.parseview.parsers.scripteditor');
    var copy = new __WEBPACK_IMPORTED_MODULE_9_clipboard___default.a('#copy');
    var that = _this;
    copy.on('success', function () {
      that.setState({ copied: true });
    });
    return _this;
  }

  ScriptEditor.prototype.componentWillMount = function componentWillMount() {
    var _props$parser$data2 = this.props.parser.data;
    _props$parser$data2 = _props$parser$data2 === undefined ? {} : _props$parser$data2;
    var _props$parser$data2$p = _props$parser$data2.parser;
    _props$parser$data2$p = _props$parser$data2$p === undefined ? {} : _props$parser$data2$p;
    var _props$parser$data2$p2 = _props$parser$data2$p.script,
        script = _props$parser$data2$p2 === undefined ? '' : _props$parser$data2$p2;

    this.props.getParserCode(script);
  };

  ScriptEditor.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var parser = nextProps.parser;

    if (parser !== this.props.parser) {
      var _parser$data = parser.data;
      _parser$data = _parser$data === undefined ? {} : _parser$data;
      var _parser$data$parser = _parser$data.parser;
      _parser$data$parser = _parser$data$parser === undefined ? {} : _parser$data$parser;
      var _parser$data$parser$s = _parser$data$parser.script,
          script = _parser$data$parser$s === undefined ? '' : _parser$data$parser$s;

      this.setState({
        editorState: __WEBPACK_IMPORTED_MODULE_7_draft_js__["EditorState"].createWithContent(__WEBPACK_IMPORTED_MODULE_7_draft_js__["ContentState"].createFromText(script), new HighlightDecorator())
      });
      this.props.getParserCode(script);
    }
  };

  ScriptEditor.prototype.onChange = function onChange(editorState) {
    this.setState({ editorState: editorState });
    var lastChangeType = editorState.getLastChangeType();
    if (lastChangeType === 'split-block') {
      this.indentFocus(editorState);
    }
    this.props.getParserCode(editorState);
  };

  ScriptEditor.prototype.onTab = function onTab(e) {
    e.preventDefault();
    var editorState = this.state.editorState;

    var selectionState = editorState.getSelection();
    var startKey = selectionState.getStartKey();
    var endKey = selectionState.getEndKey();
    var contentState = editorState.getCurrentContent();
    var blockMap = contentState.getBlockMap().skipUntil(function (_, k) {
      return k === startKey;
    }).takeUntil(function (_, k) {
      return k === contentState.getKeyAfter(endKey);
    });
    if (e.shiftKey) {
      this.unindentBlocks(editorState, contentState, selectionState, blockMap);
    } else {
      this.indentBlocks(editorState, contentState, selectionState, blockMap);
    }
  };

  ScriptEditor.prototype.indentBlocks = function indentBlocks(editorState, contentState, selectionState, blockMap) {
    var indentContent = blockMap.reduce(function (content, block) {
      var selection = __WEBPACK_IMPORTED_MODULE_7_draft_js__["SelectionState"].createEmpty(block.getKey());
      return __WEBPACK_IMPORTED_MODULE_7_draft_js__["Modifier"].insertText(content, selection, kIndentSpaces);
    }, contentState);
    var shiftSelection = selectionState.merge({
      anchorOffset: selectionState.getAnchorOffset() + kIndent,
      focusOffset: selectionState.getFocusOffset() + kIndent
    });
    this.onChange(__WEBPACK_IMPORTED_MODULE_7_draft_js__["EditorState"].forceSelection(__WEBPACK_IMPORTED_MODULE_7_draft_js__["EditorState"].push(editorState, indentContent, 'insert-characters'), shiftSelection));
  };

  ScriptEditor.prototype.unindentBlocks = function unindentBlocks(editorState, contentState, selectionState, blockMap) {
    var indentContent = blockMap.reduce(function (content, block) {
      var selection = __WEBPACK_IMPORTED_MODULE_7_draft_js__["SelectionState"].createEmpty(block.getKey()).merge({
        anchorOffset: 0,
        focusOffset: kIndent
      });
      return __WEBPACK_IMPORTED_MODULE_7_draft_js__["Modifier"].replaceText(content, selection, _.trimStart(block.getText().substr(0, kIndent)));
    }, contentState);
    var anchorOffset = selectionState.getAnchorOffset();
    var focusOffset = selectionState.getFocusOffset();
    var shiftSelection = selectionState.merge({
      anchorOffset: anchorOffset < kIndent ? 0 : anchorOffset - kIndent,
      focusOffset: focusOffset < kIndent ? 0 : focusOffset - kIndent
    });
    this.onChange(__WEBPACK_IMPORTED_MODULE_7_draft_js__["EditorState"].forceSelection(__WEBPACK_IMPORTED_MODULE_7_draft_js__["EditorState"].push(editorState, indentContent, 'delete-character'), shiftSelection));
  };

  ScriptEditor.prototype.indentFocus = function indentFocus(editorState) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();
    var focusKey = selectionState.getFocusKey();
    var beforeKey = contentState.getKeyBefore(focusKey);
    if (beforeKey) {
      var beforeBlock = contentState.getBlockForKey(beforeKey);
      var indentLevel = 0;
      if (_.endsWith(_.trimEnd(beforeBlock.getText()), '{')) {
        indentLevel += 1;
      }
      var match = beforeBlock.getText().match(/^\s+/);
      if (match) {
        indentLevel += Math.ceil(match[0].length / kIndent);
      }
      if (indentLevel > 0) {
        var indentSpaces = _.range(indentLevel).map(function () {
          return kIndentSpaces;
        }).join('');
        var indentSelection = selectionState.merge({
          anchorOffset: selectionState.getAnchorOffset() + indentSpaces.length,
          focusOffset: selectionState.getFocusOffset() + indentSpaces.length
        });
        this.onChange(__WEBPACK_IMPORTED_MODULE_7_draft_js__["EditorState"].forceSelection(__WEBPACK_IMPORTED_MODULE_7_draft_js__["EditorState"].push(editorState, __WEBPACK_IMPORTED_MODULE_7_draft_js__["Modifier"].insertText(contentState, selectionState, indentSpaces), 'insert-characters'), indentSelection));
      }
    }
  };

  ScriptEditor.prototype.handleBeauty = function handleBeauty() {
    var editorState = this.state.editorState;

    var code = editorState.getCurrentContent().getPlainText();
    code = __WEBPACK_IMPORTED_MODULE_12_js_beautify___default.a.js_beautify(code);
    this.setState({
      editorState: __WEBPACK_IMPORTED_MODULE_7_draft_js__["EditorState"].createWithContent(__WEBPACK_IMPORTED_MODULE_7_draft_js__["ContentState"].createFromText(code, /[\r\n]/), new HighlightDecorator())
    });
  };

  ScriptEditor.prototype.handleSubmit = function handleSubmit() {
    var _this2 = this;

    var parserId = this.props.parserId;
    var editorState = this.state.editorState;
    var errors = this.state.errors;


    errors = errors.remove('submit');
    this.setState({ errors: errors, errTip: '' });
    var code = editorState.getCurrentContent().getPlainText();
    var parsed = void 0;
    try {
      parsed = __WEBPACK_IMPORTED_MODULE_10_esprima___default.a.parse("function x() { " + code + " }");
    } catch (e) {
      if (e.lineNumber > 0) {
        this.setState({ lineNumber: e.lineNumber, errDesc: e.description });
      }
      this.setState({
        errors: errors.add('FE_SYNTAXINVALID', 'submit')
      });
      return;
    }
    if (code.indexOf('_config_') <= -1) {
      try {
        var evalCode = new Function("" + kCodeBlock + code);
        evalCode();
      } catch (e) {
        var reg = new RegExp(/<anonymous>:(\d)*:/, 'g');
        var stack = reg.exec(e.stack);
        var errLine = Number(stack[0].split(':')[1]);
        this.setState({
          errors: errors.add('FE_SYNTAXINVALID', 'submit'),
          errTip: e.message + ": " + (errLine - 2)
        });
        return;
      }
    }
    var statements = parsed.body[0].body.body;
    if (statements.length === 0) {
      this.setState({
        errors: errors.add('FE_RETMISSING', 'submit')
      });
      return;
    }

    var returnStmts = _.flatMap(statements, findReturns);
    if (returnStmts.length === 0) {
      this.setState({
        errors: errors.add('FE_RETMISSING', 'submit')
      });
      return;
    }

    var dataPoints = _.reduce(_.map(returnStmts, function (x) {
      return findDataPoints(x, statements);
    }), function (acc, dps) {
      return _.union(acc, dps);
    }, []);

    this.setState({
      submitStatus: 'pending',
      dataPoints: dataPoints
    });
    // save the scripts
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lorautils_api__["a" /* callAPI */])({
      endpoint: "/lora/parsers/" + parserId,
      method: 'PUT',
      body: {
        parser: { script: code }
      }
    }).then(function () {
      _this2.setState({
        errors: errors.remove('submit'),
        submitStatus: 'success'
      });
    }).catch(function (error) {
      _this2.setState({
        errors: errors.add(error.code, 'submit'),
        submitStatus: 'failure'
      });
    });
  };

  ScriptEditor.prototype.render = function render() {
    var _this3 = this;

    var _state = this.state,
        editorState = _state.editorState,
        errors = _state.errors,
        _state$submitStatus = _state.submitStatus,
        submitStatus = _state$submitStatus === undefined ? '' : _state$submitStatus,
        _state$lineNumber = _state.lineNumber,
        lineNumber = _state$lineNumber === undefined ? 0 : _state$lineNumber,
        _state$errDesc = _state.errDesc,
        errDesc = _state$errDesc === undefined ? '' : _state$errDesc,
        _state$errTip = _state.errTip,
        errTip = _state$errTip === undefined ? '' : _state$errTip,
        _state$copied = _state.copied,
        copied = _state$copied === undefined ? false : _state$copied;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.editor },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_draft_js__["Editor"], {
        blockRenderMap: blockRenderMap,
        blockStyleFn: function blockStyleFn() {
          return __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.codeBlock;
        },
        editorState: editorState,
        onChange: this.onChange,
        onTab: this.onTab,
        ref: function ref(_ref) {
          _this3.editorRef = _ref;
        },
        blockRendererFn: blockRendererFn
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.submitBar },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.submitError + " " + (errors.has('submit') ? __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.show : '') },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-warning-sign" }),
          ' ',
          errTip === '' && this.intlMsg.errorMsg(errors.get('submit')),
          errTip !== '' && errTip,
          lineNumber !== 0 && "(" + this.intlMsg.msg('line0') + " " + lineNumber + " " + this.intlMsg.msg('line1') + " " + errDesc + " )"
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
            {
              bsStyle: "aisz-primary",
              className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.copy,
              onClick: function onClick() {
                return _this3.handleBeauty();
              }
            },
            this.intlMsg.msg('beauty')
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
            {
              bsStyle: "aisz-primary",
              className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.copy,
              id: "copy",
              "data-clipboard-text": editorState.getCurrentContent().getPlainText()
            },
            this.intlMsg.msg('copy')
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_Flash__["a" /* default */], {
            show: copied,
            message: this.intlMsg.msg('copid'),
            onHide: function onHide() {
              return _this3.setState({ copied: false });
            },
            azStyle: "success"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_RichButton__["a" /* default */], {
          status: submitStatus,
          states: [{
            status: 'default',
            label: this.intlMsg.msg('submit'),
            style: 'primary',
            onClick: this.handleSubmit
          }, {
            status: 'success',
            label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "span",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-tick" }),
              ' ',
              this.intlMsg.msg('submitsucc')
            ),
            style: 'success',
            timer: function timer() {
              return _this3.setState({ submitStatus: '' });
            }
          }, {
            status: 'failure',
            label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "span",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-warning-sign" }),
              ' ',
              this.intlMsg.msg('submitfailure')
            ),
            style: 'danger',
            timer: function timer() {
              return _this3.setState({ submitStatus: '' });
            }
          }, {
            status: 'pending',
            label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "span",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" }),
              ' ',
              this.intlMsg.msg('submitting')
            ),
            style: 'info'
          }]
        })
      )
    );
  };

  return ScriptEditor;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ScriptEditor.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    parser: state.parser.getParser
  };
};

var mapDispatchToProps = {
  getParserCode: __WEBPACK_IMPORTED_MODULE_18_loraactions_parser__["c" /* getParserCode */]
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(ScriptEditor)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Highlight__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var kSampleCode = "/*\n  Parser code sample.\n\n  The following variables are available:\n  data     : hex string of the data\n  hex      : array of bytes represented as string of 2 hex digits\n  bin      : array of bytes represented as integers\n  appeui   : application EUI\n  deveui   : device EUI\n  fport    : message port field\n*/\n\nvar temperature =\n  Number((bin[2] * 256 + bin[1]) * 0.00268 - 46.85).toFixed(2);\nvar humidity =\n  Number(bin[3] * 0.49 - 6).toFixed(2);\nreturn {\n  T: temperature,\n  H: humidity,\n  length: data.length\n};\n";

var ScriptSample = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ScriptSample, _React$Component);

  function ScriptSample(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ScriptSample);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {};
    return _this;
  }

  ScriptSample.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.sample },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "pre",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "code",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Highlight__["a" /* default */], { code: kSampleCode })
        )
      )
    );
  };

  return ScriptSample;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ScriptSample);

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_PageLoading__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_PageNoPerm__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__coms_Parsers__ = __webpack_require__(1222);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  app: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  planState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var ParseView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ParseView, _React$Component);

  function ParseView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ParseView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      app: props.app,
      planState: props.planState
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.parseview');
    return _this;
  }

  ParseView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var app = nextProps.app,
        planState = nextProps.planState;

    if (app !== this.props.app) {
      this.setState({ app: app });
    }
    if (planState !== this.props.planState) {
      this.setState({ planState: planState });
    }
  };

  ParseView.prototype.renderToolbar = function renderToolbar() {
    var _this2 = this;

    var app = this.state.app;
    var _app$data = app.data,
        data = _app$data === undefined ? {} : _app$data;


    var breadcrumb = [{
      onClick: function onClick() {
        return _this2.props.pushState('/application');
      },
      content: this.intlMsg.msg('breadcrumb.application', 'application')
    }, {
      content: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_Nvl__["a" /* default */], { val: data.name, status: app.status }),
      active: true
    }];

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  ParseView.prototype.render = function render() {
    var planState = this.state.planState;
    var appId = this.props.appId;


    if (planState.status === 'pending') {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_PageLoading__["a" /* default */], null);
    }
    if (planState.data.tier === 1) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_PageNoPerm__["a" /* default */], null);
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
          { md: 12 },
          this.renderToolbar()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__coms_Parsers__["a" /* default */], { appId: appId })
        )
      )
    );
  };

  return ParseView;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ParseView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    appId: ownProps.params.id,
    app: state.app.getApp,
    planState: state.billing.plan
  };
};
var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_5_react_router_redux__["routerActions"].push
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(ParseView)));

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_SideBar__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_SidebarContainer__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loraactions_app__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracfg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss__ = __webpack_require__(2226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);












var defaultProps = {
  view: 'detail'
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  getApp: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  view: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string,
  children: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.node.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  plan: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var ApplicationDetail = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ApplicationDetail, _React$Component);

  function ApplicationDetail(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ApplicationDetail);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      view: props.view,
      showToken: false,
      plan: props.plan
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail');
    return _this;
  }

  ApplicationDetail.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        appId = _props.appId,
        getApp = _props.getApp;

    getApp(appId);
  };

  ApplicationDetail.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var view = nextProps.view,
        plan = nextProps.plan;

    if (view !== this.props.view) {
      this.setState({ view: view });
    }
    if (plan !== this.props.plan) {
      this.setState({ plan: plan });
    }
  };

  ApplicationDetail.prototype.renderSideBar = function renderSideBar() {
    var _props2 = this.props,
        pushState = _props2.pushState,
        appId = _props2.appId;
    var _state$view = this.state.view,
        view = _state$view === undefined ? 'detail' : _state$view;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_SideBar__["a" /* default */], {
      height: window.innerHeight,
      title: this.intlMsg.msg('sidebar.title'),
      menuItems: [{
        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-blackboard" }),
        text: this.intlMsg.msg('menu.detail'),
        onClick: function onClick() {
          return pushState("/application/" + appId + "/detail");
        },
        active: view === 'detail' || view === ''
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-electrical-plug" }),
        text: this.intlMsg.msg('menu.api'),
        onClick: function onClick() {
          return pushState("/application/" + appId + "/api");
        },
        active: view === 'api'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-notes-2" }),
        text: this.intlMsg.msg('menu.log'),
        onClick: function onClick() {
          return pushState("/application/" + appId + "/log");
        },
        active: view === 'log'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-cloud-download" }),
        text: this.intlMsg.msg('menu.export'),
        onClick: function onClick() {
          return pushState("/application/" + appId + "/export");
        },
        active: view === 'export'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-sort" }),
        text: this.intlMsg.msg('menu.parse'),
        onClick: function onClick() {
          return pushState("/application/" + appId + "/parse");
        },
        active: view === 'parse'
        // show: config.profile === 'cloud',
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-show-thumbnails" }),
        text: this.intlMsg.msg('menu.dps'),
        onClick: function onClick() {
          return pushState("/application/" + appId + "/dps");
        },
        active: view === 'dps',
        show: __WEBPACK_IMPORTED_MODULE_11_loracfg__["a" /* default */].profile === 'cloud'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-electricity" }),
        text: this.intlMsg.msg('menu.flows'),
        onClick: function onClick() {
          return pushState("/application/" + appId + "/flows");
        },
        active: view === 'flows',
        show: __WEBPACK_IMPORTED_MODULE_11_loracfg__["a" /* default */].profile === 'cloud'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-volume-up" }),
        text: this.intlMsg.msg('menu.broadcast'),
        onClick: function onClick() {
          return pushState("/application/" + appId + "/broadcast");
        },
        active: view === 'broadcast'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-dashboard" }),
        text: this.intlMsg.msg('menu.dashboard'),
        onClick: function onClick() {
          return pushState("/application/" + appId + "/dashboard");
        },
        active: view === 'dashboard'
      }]
    });
  };

  ApplicationDetail.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      this.renderSideBar(),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_loracoms_SidebarContainer__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.view },
          this.props.children
        )
      )
    );
  };

  return ApplicationDetail;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ApplicationDetail.defaultProps = defaultProps;
ApplicationDetail.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    appId: ownProps.params.id,
    view: ownProps.location.pathname.split('/')[3] || '',
    plan: state.billing.plan
  };
};

var mapDispatchToProps = {
  getApp: __WEBPACK_IMPORTED_MODULE_9_loraactions_app__["a" /* default */].getApp,
  pushState: __WEBPACK_IMPORTED_MODULE_5_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(ApplicationDetail)));

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_SearchFlag__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_TablePager__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_SortBtn__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_LoadingTable__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loraactions_app__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss__ = __webpack_require__(2227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);


















var defaultProps = {
  searching: false,
  searchText: '',
  count: 1
};

var propTypes = {
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  searching: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool,
  searchText: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string,
  apps: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  getApps: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  count: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.number
};
var searchTxt = '';

var ApplicationList = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ApplicationList, _React$Component);

  ApplicationList.q = function q(s) {
    var q = s.replace(/[:-]/g, '');
    return "or,APPEUI:*" + q + "*,name:*" + q + "*";
  };

  function ApplicationList(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ApplicationList);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      count: props.count,
      searching: props.searching,
      apps: props.apps,
      sort: '',
      initialStatus: 'pending'
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_16_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'application');
    _this.handlePaging = _this.handlePaging.bind(_this);
    _this.handleSort = _this.handleSort.bind(_this);
    return _this;
  }

  ApplicationList.prototype.componentWillMount = function componentWillMount() {
    var getApps = this.props.getApps;

    getApps({ count: true, tkcnt: true, pageSize: 20 });
  };

  ApplicationList.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var searching = nextProps.searching,
        searchText = nextProps.searchText,
        apps = nextProps.apps,
        count = nextProps.count;

    if (searching !== this.props.searching) {
      this.setState({ searching: searching });
    }
    if (searchText !== this.props.searchText) {
      this.setState({ reset: Math.random() });
      var getApps = this.props.getApps;
      var sort = this.state.sort;

      if (searchText !== '') {
        this.q = ApplicationList.q(searchText);
        searchTxt = this.q;
        getApps({ q: this.q, count: true, tkcnt: true, sort: sort, pageSize: 20 });
      } else {
        this.q = null;
        searchTxt = '';
        getApps({ count: true, tkcnt: true, sort: sort, pageSize: 20 });
      }
    }
    if (apps !== this.props.apps) {
      this.setState({ apps: apps });
      if (apps.status === 'success') {
        var _apps$data = apps.data,
            more = _apps$data.more,
            mark = _apps$data.mark,
            list = _apps$data.list,
            status = apps.status;

        this.setState({ initialStatus: status, more: more, mark: mark, list: list });
      } else if (apps.status === 'failure') {
        this.setState({ initialStatus: apps.status });
      }
    }
    if (count !== this.props.count) {
      this.setState({ count: count });
    }
  };

  ApplicationList.prototype.handlePaging = function handlePaging(mark) {
    var getApps = this.props.getApps;
    var sort = this.state.sort;

    getApps({ mark: mark, q: this.q, count: true, tkcnt: true, sort: sort, pageSize: 20 });
  };

  ApplicationList.prototype.handleSort = function handleSort(sort) {
    var getApps = this.props.getApps;

    this.setState({ sort: sort, reset: Math.random() }, function () {
      getApps({ q: searchTxt, count: true, tkcnt: true, sort: sort, mark: '', pageSize: 20 });
    });
  };

  ApplicationList.prototype.render = function render() {
    var pushState = this.props.pushState;
    var _state = this.state,
        _state$searching = _state.searching,
        searching = _state$searching === undefined ? false : _state$searching,
        apps = _state.apps,
        reset = _state.reset,
        sort = _state.sort,
        initialStatus = _state.initialStatus,
        _state$mark = _state.mark,
        mark = _state$mark === undefined ? '' : _state$mark,
        _state$list = _state.list,
        list = _state$list === undefined ? [] : _state$list,
        _state$more = _state.more,
        more = _state$more === undefined ? false : _state$more;


    var header = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "span",
        null,
        this.intlMsg.msg('app.panelheader')
      )
    );

    var thead = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "thead",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('app.fields.name'),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_SearchFlag__["a" /* default */], { show: searching }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_SortBtn__["a" /* default */], {
            sortName: "name",
            handleSort: this.handleSort,
            highLight: sort.indexOf('name') > -1
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          "APPEUI",
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_SearchFlag__["a" /* default */], { show: searching }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_SortBtn__["a" /* default */], {
            sortName: "appeui",
            handleSort: this.handleSort,
            highLight: sort.indexOf('appeui') > -1
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('app.fields.devicenum')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('app.fields.tokennum')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('app.fields.target')
        )
      )
    );

    var trs = list.map(function (a) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        { key: a.id },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
            { onClick: function onClick() {
                return pushState("/application/" + a.id);
              } },
            a.name
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
            { onClick: function onClick() {
                return pushState("/application/" + a.id);
              } },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lorautils_IdUtils__["d" /* normalizeAppEUI */])(a.appeui)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          apps.data && apps.data.nodeCounts[a.id]
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
            { onClick: function onClick() {
                return pushState("/application/" + a.id + "/api");
              } },
            apps.data && apps.data.tokenCounts[a.id]
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_RichLabel__["a" /* default */], { content: a.target })
        )
      );
    });

    if (initialStatus === 'pending') {
      var _state$count = this.state.count,
          count = _state$count === undefined ? 1 : _state$count;

      var rows = Math.max(1, Math.min(10, count));
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
        { bsStyle: "aisz-white", header: header },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14_loracoms_LoadingTable__["a" /* default */],
          {
            cols: 5,
            rows: rows,
            className: "aisz-table-light",
            striped: true,
            bordered: true,
            responsive: true
          },
          thead
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: header },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Table"],
        { className: "aisz-table-light", striped: true, hover: true, bordered: true, responsive: true },
        thead,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "tbody",
          null,
          trs
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_loracoms_ShowIf__["a" /* default */],
        { "if": list.length > 0 },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.pager },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_TablePager__["a" /* default */], {
            status: apps.status,
            mark: mark,
            more: more,
            reset: reset,
            onPrev: this.handlePaging,
            onNext: this.handlePaging
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_loracoms_ShowIf__["a" /* default */],
        { "if": list.length === 0 },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.noapp },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "h3",
            null,
            this.intlMsg.msg('noapp')
          )
        )
      )
    );
  };

  return ApplicationList;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ApplicationList.defaultProps = defaultProps;
ApplicationList.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    apps: state.app.getApps,
    count: state.usage.apps
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_7_react_router_redux__["routerActions"].push,
  getApps: __WEBPACK_IMPORTED_MODULE_17_loraactions_app__["a" /* default */].getApps
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(ApplicationList)));

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_LineChart__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss__ = __webpack_require__(2228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);











var kFormat = { en: 'DD/MM/YYYY HH:mm:ss', zh: 'YYYY-MM-DD HH:mm:ss' };
var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_6_react_intl__["intlShape"].isRequired,
  adr: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};
var kSeries = {
  smoth: true,
  symbolSize: 0,
  areaStyle: {
    normal: {
      opacity: 0
    }
  }
};

var kDR = { symbolSize: 10, yAxisIndex: 1, showAllSymbol: true };
var formatNum = function formatNum() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return Number(n.toFixed(2));
};

var DynamicChart = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DynamicChart, _React$Component);

  function DynamicChart(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DynamicChart);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      adr: props.adr
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.adrview.marginrate');
    return _this;
  }

  DynamicChart.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var adr = nextProps.adr;

    if (!_.isEqual(adr, this.props.adr)) {
      this.setState({ adr: adr });
    }
  };

  DynamicChart.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        _state$adr = _state.adr,
        disabled = _state$adr.disabled,
        history = _state$adr.history,
        current = _state$adr.current,
        _state$adr$margin = _state$adr.margin,
        margin = _state$adr$margin === undefined ? 0 : _state$adr$margin,
        _state$view = _state.view,
        view = _state$view === undefined ? 'DR' : _state$view;
    var locale = this.props.intl.locale;

    var categories = [];
    var range = [];
    var drLine = [];
    var power = [];
    var marginLine = [];
    var target = [];
    _.forEach(history, function (h) {
      categories.push(__WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(h.timestamp, kFormat[locale]));
      range.push((formatNum(h.range) + formatNum(h.target)).toFixed(2));
      drLine.push(formatNum(h.dr));
      power.push(formatNum(h.power));
      marginLine.push(formatNum(h.margin));
      target.push(formatNum(h.target));
    });
    categories.push(this.intlMsg.msg('latest'));
    range.push(formatNum(target[target.length - 1] + current.range));
    drLine.push(formatNum(current.dr));
    power.push(formatNum(current.power));
    marginLine.push(formatNum(current.margin));
    target.push(formatNum(margin || target[target.length - 1]));

    if (!history.length && disabled) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.noData },
        this.intlMsg.msg('nodata')
      );
    }

    if (!history.length && !disabled) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.noData },
        this.intlMsg.msg('start')
      );
    }

    var series = [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, kSeries, { name: 'Real', data: marginLine }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, kSeries, { name: 'High', data: range, areaStyle: { normal: { opacity: 0.2 } } }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, kSeries, { name: 'Low', data: target, areaStyle: { normal: { opacity: 0.2 } } })];
    var legend = { top: 30, data: ['Real', 'High', 'Low'] };
    if (view === 'DR') {
      series.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, kSeries, kDR, { name: 'DR', data: drLine }));
      legend.data.push('DR');
    } else {
      series.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, kSeries, kDR, { name: 'Power', data: power }));
      legend.data.push('Power');
    }
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.container },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
        {
          className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.switcher,
          onClick: function onClick() {
            return _this2.setState({ view: view === 'DR' ? 'Power' : 'DR' });
          }
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-hand-o-right" }),
        "\xA0",
        view === 'DR' ? 'Power' : 'DR'
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_LineChart__["a" /* default */], {
        title: {
          text: this.intlMsg.msg('title'),
          left: 'center',
          textStyle: { fontWeight: 300, fontSize: 14 }
        },
        categories: categories,
        series: series,
        legend: legend,
        colors: ['#36d7b7', '#85d4e3', '#f22400', '#e3d200', '#e3d200'],
        yAxis: [{ type: 'value', name: 'Margin (dB)', min: 0, max: 40 }, {
          type: 'value',
          name: view,
          min: 0,
          max: _.max(_.concat(view === 'DR' ? drLine : power, [5]))
        }]
      }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["HelpBlock"],
        { className: "aisz-help-block" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-info-circle" }),
        "\xA0 Real: ",
        this.intlMsg.msg('real')
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["HelpBlock"],
        { className: "aisz-help-block" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-info-circle" }),
        "\xA0 [ Low, High ]: ",
        this.intlMsg.msg('range')
      )
    );
  };

  return DynamicChart;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

DynamicChart.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(DynamicChart));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_Refresher__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ParsedDataTrend__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss__ = __webpack_require__(2230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);
















var propTypes = {
  load: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any.isRequired,
  deveui: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  markState: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired
  // appId: PropTypes.string.isRequired,
};

var ParsedData = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ParsedData, _React$Component);

  function ParsedData(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ParsedData);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      metrics: '',
      status: 'pending'
    };
    _this.mark = props.markState.mark || {};
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.parseview.parsers.data');
    _this.handleReload = _this.handleReload.bind(_this);
    return _this;
  }

  ParsedData.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var markState = nextProps.markState,
        load = nextProps.load;

    if (!_.isEqual(markState, this.props.markState)) {
      this.mark = markState.mark;
    }
    if (load) {
      this.loadData();
    }
  };

  ParsedData.prototype.loadData = function loadData() {
    var _this2 = this;

    var deveui = this.props.deveui;

    this.setState({ status: 'pending' });
    var _mark = this.mark,
        from = _mark.from,
        to = _mark.to;

    if (_.isNil(from) || _.isNil(to)) {
      this.setState({ timeSeries: [], status: 'success' });
      return;
    }
    from = new Date(from);
    to = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["addSeconds"])(new Date(to), 5);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lorautils_api__["a" /* callAPI */])({
      endpoint: '/lora/timeseries',
      body: {
        nodeid: deveui,
        limit: 20,
        dir: 'up',
        from: from,
        to: to
      },
      method: 'POST'
    }).then(function (data) {
      _this2.setState({
        timeSeries: data.list,
        status: 'success'
      });
    }).catch(function () {
      _this2.setState({
        status: 'failure'
      });
    });
  };

  ParsedData.prototype.handleReload = function handleReload() {
    this.loadData();
  };

  ParsedData.prototype.render = function render() {
    var _this3 = this;

    var _state = this.state,
        _state$timeSeries = _state.timeSeries,
        timeSeries = _state$timeSeries === undefined ? [] : _state$timeSeries,
        _state$status = _state.status,
        status = _state$status === undefined ? 'pending' : _state$status,
        metrics = _state.metrics;


    var dataPoints = _.uniq(_.flatMap(timeSeries, function (ts) {
      return _.keys(ts.metrics);
    }));
    var ths = dataPoints.map(function (dp) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "th",
        { key: dp },
        dp,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */], {
          className: "fa fa-line-chart " + __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.graph,
          onClick: function onClick() {
            return _this3.setState({ metrics: dp });
          }
        })
      );
    });
    var trs = timeSeries.map(function (ts, idx) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        { key: String(idx) },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["format"])(ts.timestamp, 'YYYY-MM-DD HH:mm:ss')
        ),
        dataPoints.map(function (dp) {
          var dpValue = ts.metrics[dp];
          if (dpValue) {
            var pointer = dpValue.indexOf('.');
            var val = dpValue;
            if (pointer > -1) {
              val = dpValue.substring(pointer + 1).length > 4 ? Number(dpValue).toFixed(4) : dpValue;
            }
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "td",
              { key: dp },
              val
            );
          }
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            { key: dp },
            dpValue
          );
        })
      );
    });
    var tooltip = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Tooltip"],
      { id: "tooltip" },
      this.intlMsg.msg('back')
    );
    var header = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "ul",
        { className: "icontools" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Refresher__["a" /* default */], {
            onReload: this.handleReload,
            reloading: status === 'pending'
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
          { "if": metrics.length !== 0 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["OverlayTrigger"],
              { placement: "top", overlay: tooltip },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */], {
                className: "glyphicons glyphicons-step-backward " + __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.gray,
                onClick: function onClick() {
                  return _this3.setState({ metrics: '' });
                }
              })
            )
          )
        )
      )
    );

    if (status === 'pending') {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.load },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin fa-5x" })
      );
    } else if (status === 'failure') {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.timeout },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-info-circle" }),
        "\xA0",
        this.intlMsg.msg('failure')
      );
    } else if (timeSeries.length === 0 && status === 'success') {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
        { bsStyle: "aisz-white", header: header },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.noData },
          this.intlMsg.msg('nodata01')
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: header, className: "parsedDataMaxHeight" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
        { "if": metrics.length === 0 },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Table"],
          { className: "aisz-table-light", striped: true, bordered: true, hover: true, responsive: true },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('thead.time')
              ),
              ths
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tbody",
            null,
            trs
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
        { "if": metrics.length !== 0 },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ParsedDataTrend__["a" /* default */], { list: timeSeries, metrics: metrics, dataPoints: dataPoints })
      )
    );
  };

  return ParsedData;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ParsedData.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    markState: state.mark
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_9_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(ParsedData)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_LineChart__ = __webpack_require__(97);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);






var ParsedDataTrend = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ParsedDataTrend, _React$Component);

  function ParsedDataTrend(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ParsedDataTrend);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      list: props.list,
      metrics: props.metrics,
      series: null
    };
    return _this;
  }

  ParsedDataTrend.prototype.componentWillMount = function componentWillMount() {
    this.setState({ series: this.handleSeries(this.state.list) });
  };

  ParsedDataTrend.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var list = nextProps.list,
        metrics = nextProps.metrics,
        dataPoints = nextProps.dataPoints;

    if (list !== this.props.list) {
      this.setState({ list: list, series: this.handleSeries(list) });
    }
    if (metrics !== this.props.metrics) {
      this.setState({ metrics: metrics });
    }
    if (dataPoints !== this.props.dataPoints) {
      this.setState({ list: list, series: this.handleSeries(list) });
    }
  };

  ParsedDataTrend.prototype.handleSeries = function handleSeries(l) {
    var list = l.reverse();
    if (Date.parse(l[0].timestamp) > Date.parse(l[l.length - 1].timestamp)) {
      list = l.reverse();
    }
    var obj = { categories: [], series: {} };
    var dataPoints = this.props.dataPoints;

    dataPoints.forEach(function (key) {
      obj.series[key] = { name: key, data: [], yAxisIndex: 0 };
    });
    var handleMetrics = function handleMetrics(arr) {
      dataPoints.forEach(function (key) {
        obj.series[key].data.push(arr[key]);
      });
    };
    list.forEach(function (item) {
      handleMetrics(item.metrics);
      obj.categories.push(__WEBPACK_IMPORTED_MODULE_6_date_fns_format___default()(item.timestamp, 'DD/MM HH:mm:ss'));
    });
    return obj;
  };

  ParsedDataTrend.prototype.render = function render() {
    var _state = this.state,
        metrics = _state.metrics,
        series = _state.series;

    var originData = series.series[metrics];
    var categories = series.categories;
    var validData = [];
    var validTime = [];
    originData.data.forEach(function (item, index) {
      if (item) {
        validData.push(item);
        validTime.push(categories[index]);
      }
    });
    var newData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, originData, { data: validData });
    if (series) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_LineChart__["a" /* default */], {
          yAxis: [{
            name: metrics,
            splitNumber: 5
          }],
          xAxis: {
            axisTick: {
              alignWithLabel: true
            },
            boundaryGap: true
          },
          series: [newData],
          categories: validTime,
          grid: {
            left: 60,
            top: 30,
            right: 30,
            bottom: 60
          }
        })
      );
    }
    return null;
  };

  return ParsedDataTrend;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ParsedDataTrend.propTypes = {
  list: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array.isRequired, //eslint-disable-line
  metrics: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,
  dataPoints: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array.isRequired //eslint-disable-line
};

/* harmony default export */ __webpack_exports__["a"] = (ParsedDataTrend);

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_Editable__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_Refresher__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lorautils_checkers_numbers__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss__ = __webpack_require__(2231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);
















var kFcntBitsOptions = [{
  value: 16,
  label: '16'
}, {
  value: 32,
  label: '32'
}];

var propTypes = {
  device: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  getDevice: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  updated: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  updateDevice: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var ResetSeq = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ResetSeq, _React$Component);

  function ResetSeq(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ResetSeq);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      device: props.device,
      errors: new __WEBPACK_IMPORTED_MODULE_14_lorautils_errors_ErrorSet__["a" /* default */]()
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.datatoolview.resetseq');
    _this.handleEditDown = _this.handleEditDown.bind(_this);
    _this.handleEditBits = _this.handleEditBits.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmitBits = _this.handleSubmitBits.bind(_this);
    _this.handleSubmitDown = _this.handleSubmitDown.bind(_this);
    _this.handleResetUp = _this.handleResetUp.bind(_this);
    _this.handleReloadSeq = _this.handleReloadSeq.bind(_this);
    return _this;
  }

  ResetSeq.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var device = nextProps.device,
        updated = nextProps.updated;

    if (device !== this.props.device) {
      this.setState({ device: device });
    }
    if (updated !== this.props.updated) {
      if (updated.status === 'success') {
        var _props = this.props,
            deviceId = _props.deviceId,
            getDevice = _props.getDevice;

        getDevice(deviceId);
      } else if (updated.status === 'failure') {
        var errors = this.state.errors;

        this.setState({
          errors: errors.add(updated.error.code, 'submit')
        });
        var that = this;
        this.timeout = setTimeout(function () {
          that.setState({ errors: errors.remove('submit') });
        }, 3000);
      }
    }
  };

  ResetSeq.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  };

  ResetSeq.prototype.handleEditDown = function handleEditDown() {
    var device = this.state.device;

    this.setState({
      editDown: true,
      editBits: false,
      editData: device.data
    });
  };

  ResetSeq.prototype.handleEditBits = function handleEditBits() {
    var device = this.state.device;

    this.setState({
      editBits: true,
      editDown: false,
      editData: device.data
    });
  };

  ResetSeq.prototype.handleSubmitBits = function handleSubmitBits() {
    var _props2 = this.props,
        deviceId = _props2.deviceId,
        updateDevice = _props2.updateDevice;
    var editData = this.state.editData;
    var fcntbits = editData.fcntbits;


    updateDevice(deviceId, { fcntbits: Number(fcntbits) });
    this.setState({ editBits: false });
  };

  ResetSeq.prototype.checkDown = function checkDown(v) {
    var errors = this.state.errors;

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lorautils_checkers_numbers__["b" /* isInteger */])(v, { min: 0, max: 4294967295 })) {
      this.setState({
        errors: errors.add('FE_INVALIDFCNTDOWN', 'fcntdown')
      });
      return false;
    }
    this.setState({
      errors: errors.remove('fcntdown')
    });
    return true;
  };

  ResetSeq.prototype.handleSubmitDown = function handleSubmitDown() {
    var _props3 = this.props,
        deviceId = _props3.deviceId,
        updateDevice = _props3.updateDevice;
    var editData = this.state.editData;
    var fcntdown = editData.fcntdown;


    if (!this.checkDown(fcntdown)) {
      return;
    }
    updateDevice(deviceId, { fcntdown: Number(fcntdown) });
    this.setState({ editDown: false });
  };

  ResetSeq.prototype.handleResetUp = function handleResetUp() {
    var _props4 = this.props,
        deviceId = _props4.deviceId,
        updateDevice = _props4.updateDevice;

    updateDevice(deviceId, { fcntup: 4294967295 });
  };

  ResetSeq.prototype.handleChange = function handleChange(data, id) {
    if (id === 'fcntdown') {
      this.checkDown(data.fcntdown);
    }
    this.setState({ editData: data });
  };

  ResetSeq.prototype.handleReloadSeq = function handleReloadSeq() {
    var _props5 = this.props,
        deviceId = _props5.deviceId,
        getDevice = _props5.getDevice;

    getDevice(deviceId);
  };

  ResetSeq.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        _state$device = _state.device,
        device = _state$device === undefined ? {} : _state$device,
        _state$editData = _state.editData,
        editData = _state$editData === undefined ? {} : _state$editData,
        _state$editDown = _state.editDown,
        editDown = _state$editDown === undefined ? false : _state$editDown,
        _state$editBits = _state.editBits,
        editBits = _state$editBits === undefined ? false : _state$editBits,
        errors = _state.errors;
    var _device$data = device.data;
    _device$data = _device$data === undefined ? {} : _device$data;
    var fcntbits = _device$data.fcntbits,
        fcntdown = _device$data.fcntdown,
        fcntup = _device$data.fcntup,
        status = device.status;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Row"],
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Form"],
          { horizontal: true },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
                { className: "aisz-control-label" },
                this.intlMsg.msg('fcntup')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"].Static,
                null,
                fcntup === 4294967295 ? this.intlMsg.msg('reseted') : fcntup
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
                { bsStyle: "aisz-link-warning", onClick: this.handleResetUp },
                this.intlMsg.msg('reset')
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
                { className: "aisz-control-label" },
                this.intlMsg.msg('fcntdown')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Editable__["a" /* default */], {
                id: "fcntdown",
                value: fcntdown,
                edit: editDown,
                data: editData,
                formatter: function formatter(x) {
                  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"].Static,
                    null,
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_Nvl__["a" /* default */], { val: x, nul: "empty", status: status })
                  );
                },
                onChange: this.handleChange
              }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_loracoms_ShowIf__["a" /* default */],
                { "if": !editDown },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
                  { bsStyle: "aisz-link", onClick: this.handleEditDown },
                  this.intlMsg.msg('edit'),
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-pencil" })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_loracoms_ShowIf__["a" /* default */],
                { "if": editDown },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "ul",
                  { className: "list-inline " + __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.buttons },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "li",
                    null,
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
                      {
                        bsStyle: "aisz-link-warning",
                        onClick: function onClick() {
                          return _this2.setState({ editDown: false });
                        }
                      },
                      this.intlMsg.msg('cancel'),
                      ' ',
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-remove" })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "li",
                    null,
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
                      {
                        bsStyle: "aisz-link-success",
                        onClick: this.handleSubmitDown
                      },
                      this.intlMsg.msg('ok'),
                      ' ',
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-ok" })
                    )
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
                { className: "aisz-control-label" },
                this.intlMsg.msg('fcntbits')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Editable__["a" /* default */], {
                id: "fcntbits",
                value: fcntbits,
                edit: editBits,
                data: editData,
                control: {
                  type: 'select',
                  options: kFcntBitsOptions
                },
                formatter: function formatter(x) {
                  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"].Static,
                    null,
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_Nvl__["a" /* default */], { val: x, nul: "empty", status: status })
                  );
                },
                onChange: this.handleChange
              }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_loracoms_ShowIf__["a" /* default */],
                { "if": !editBits },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
                  { bsStyle: "aisz-link", onClick: this.handleEditBits },
                  this.intlMsg.msg('edit'),
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-pencil" })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_loracoms_ShowIf__["a" /* default */],
                { "if": editBits },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "ul",
                  { className: "list-inline " + __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.buttons },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "li",
                    null,
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
                      {
                        bsStyle: "aisz-link-warning",
                        onClick: function onClick() {
                          return _this2.setState({ editBits: false });
                        }
                      },
                      this.intlMsg.msg('cancel'),
                      ' ',
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-remove" })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "li",
                    null,
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
                      {
                        bsStyle: "aisz-link-success",
                        onClick: this.handleSubmitBits
                      },
                      this.intlMsg.msg('ok'),
                      ' ',
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-ok" })
                    )
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
              { mdOffset: 3, md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_FormBlock__["a" /* default */], {
                message: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "span",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-warning-sign" }),
                  ' ',
                  this.intlMsg.errorMsg(errors.get('submit'))
                ),
                azStyle: "danger",
                show: errors.has('submit')
              })
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
        { md: 6, className: "text-right " + __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.refresher },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_Refresher__["a" /* default */], {
          onReload: this.handleReloadSeq,
          reloading: status === 'pending'
        })
      )
    );
  };

  return ResetSeq;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ResetSeq.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    device: state.device.getDevice,
    updated: state.device.updateDevice
  };
};

var mapDispatchToProps = {
  getDevice: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].getDevice,
  updateDevice: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].updateDevice
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(ResetSeq)));

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isNil__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_Refresher__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_SelectPills__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss__ = __webpack_require__(2232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);


















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  txSize: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  sendData: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  flushTx: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getTxSize: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  sent: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  flushed: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var EncodingOptions = [{
  name: 'HEX',
  value: 'hex',
  active: true
}, {
  name: 'TEXT',
  value: 'text'
}];

var SendData = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(SendData, _React$Component);

  function SendData(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SendData);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      txSize: props.txSize,
      encoding: 'hex',
      errors: new __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__["a" /* default */]().add('FE_EMPTY', 'port').add('FE_EMPTY', 'data')
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.datatoolview.senddata');
    _this.handleChangePort = _this.handleChangePort.bind(_this);
    _this.handleChangeEncoding = _this.handleChangeEncoding.bind(_this);
    _this.handleChangeData = _this.handleChangeData.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleFlushTx = _this.handleFlushTx.bind(_this);
    _this.handleReloadTxSize = _this.handleReloadTxSize.bind(_this);
    return _this;
  }

  SendData.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        getTxSize = _props.getTxSize,
        deviceId = _props.deviceId;

    getTxSize(deviceId);
  };

  SendData.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var txSize = nextProps.txSize,
        sent = nextProps.sent,
        flushed = nextProps.flushed;

    if (txSize !== this.props.txSize) {
      this.setState({ txSize: txSize });
    }
    if (sent !== this.props.sent) {
      this.setState({ sentStatus: sent.status });
      if (sent.status === 'success') {
        var _props2 = this.props,
            getTxSize = _props2.getTxSize,
            deviceId = _props2.deviceId;

        getTxSize(deviceId);
      }
    }
    if (flushed !== this.props.flushed) {
      this.setState({ flushStatus: flushed.status });
      if (flushed.status === 'success') {
        var _props3 = this.props,
            _getTxSize = _props3.getTxSize,
            _deviceId = _props3.deviceId;

        _getTxSize(_deviceId);
      }
    }
  };

  SendData.prototype.checkPort = function checkPort(port) {
    var errors = this.state.errors;


    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default()(port) || port === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'port') });
      return false;
    }

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["b" /* isInteger */])(port, { min: 1, max: 223 })) {
      this.setState({ errors: errors.add('FE_INVALIDPORT', 'port') });
      return false;
    }

    this.setState({ errors: errors.remove('port') });
    return true;
  };

  SendData.prototype.checkData = function checkData(data, encoding) {
    var errors = this.state.errors;


    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default()(data) || data === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'data') });
      return false;
    }

    if (encoding === 'hex') {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["c" /* isHexString */])(data, { pair: true })) {
        this.setState({ errors: errors.add('FE_INVALIDHEX', 'data') });
        return false;
      }
    }

    this.setState({ errors: errors.remove('data') });
    return true;
  };

  SendData.prototype.handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });

    var errors = this.state.errors;

    if (!errors.isEmpty()) {
      return;
    }

    var _props4 = this.props,
        deviceId = _props4.deviceId,
        sendData = _props4.sendData;
    var _state = this.state,
        port = _state.port,
        data = _state.data,
        encoding = _state.encoding;

    sendData(deviceId, Number(port), data, encoding);
  };

  SendData.prototype.handleFlushTx = function handleFlushTx() {
    var _props5 = this.props,
        deviceId = _props5.deviceId,
        flushTx = _props5.flushTx;

    flushTx(deviceId);
  };

  SendData.prototype.handleChangePort = function handleChangePort(e) {
    var port = e.target.value.trim();
    this.setState({ port: port });
    this.checkPort(port);
  };

  SendData.prototype.handleChangeEncoding = function handleChangeEncoding(encoding) {
    this.setState({ encoding: encoding });

    var data = this.state.data;

    this.checkData(data, encoding);
  };

  SendData.prototype.handleChangeData = function handleChangeData(e) {
    var data = e.target.value;
    this.setState({ data: data });

    var encoding = this.state.encoding;

    this.checkData(data, encoding);
  };

  SendData.prototype.handleReloadTxSize = function handleReloadTxSize() {
    var _props6 = this.props,
        getTxSize = _props6.getTxSize,
        deviceId = _props6.deviceId;

    getTxSize(deviceId);
  };

  SendData.prototype.render = function render() {
    var _this2 = this;

    var _state2 = this.state,
        _state2$port = _state2.port,
        port = _state2$port === undefined ? '' : _state2$port,
        encoding = _state2.encoding,
        _state2$data = _state2.data,
        data = _state2$data === undefined ? '' : _state2$data,
        txSize = _state2.txSize,
        errors = _state2.errors,
        _state2$submitted = _state2.submitted,
        submitted = _state2$submitted === undefined ? false : _state2$submitted,
        _state2$sentStatus = _state2.sentStatus,
        sentStatus = _state2$sentStatus === undefined ? '' : _state2$sentStatus,
        _state2$flushStatus = _state2.flushStatus,
        flushStatus = _state2$flushStatus === undefined ? '' : _state2$flushStatus;
    var _txSize$data = txSize.data;
    _txSize$data = _txSize$data === undefined ? {} : _txSize$data;
    var size = _txSize$data.size;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
        { md: 8 },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.sendForm },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Form"],
            {
              horizontal: true,
              onSubmit: this.handleSubmit
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"],
                  { className: "aisz-control-label" },
                  this.intlMsg.msg('port')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                { md: 6 },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormControl"], {
                  bsClass: "aisz-form-control-f",
                  value: port,
                  onChange: this.handleChangePort,
                  placeholder: this.intlMsg.msg('port.placeholder')
                }),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_ControlTips__["a" /* default */], {
                  show: errors.has('port') && submitted,
                  message: this.intlMsg.errorMsg(errors.get('port')),
                  azStyle: "danger"
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"],
                  { className: "aisz-control-label" },
                  this.intlMsg.msg('encoding')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                { md: 6 },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_SelectPills__["a" /* default */], {
                  options: EncodingOptions,
                  value: encoding,
                  onChange: function onChange(selected) {
                    return _this2.handleChangeEncoding(selected[0]);
                  }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"],
                  { className: "aisz-control-label" },
                  this.intlMsg.msg('data')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                { md: 6 },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormControl"], {
                  bsClass: "aisz-form-control-f",
                  value: data,
                  onChange: this.handleChangeData,
                  placeholder: this.intlMsg.msg("data.placeholder." + encoding)
                }),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_ControlTips__["a" /* default */], {
                  show: errors.has('data') && submitted,
                  message: this.intlMsg.errorMsg(errors.get('data')),
                  azStyle: "danger"
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                { mdOffset: 3, md: 6 },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_RichButton__["a" /* default */], {
                  status: sentStatus,
                  states: [{
                    status: 'default',
                    label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "span",
                      null,
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-send" }),
                      ' ',
                      this.intlMsg.msg('send')
                    ),
                    type: 'submit'
                  }, {
                    status: 'pending',
                    style: 'info',
                    label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "span",
                      null,
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" }),
                      ' ',
                      this.intlMsg.msg('sending')
                    )
                  }, {
                    status: 'success',
                    style: 'success',
                    label: this.intlMsg.msg('sendsuccess'),
                    timer: function timer() {
                      return _this2.setState({ sentStatus: '' });
                    }
                  }, {
                    status: 'failure',
                    style: 'danger',
                    label: this.intlMsg.msg('sendfailure'),
                    timer: function timer() {
                      return _this2.setState({ sentStatus: '' });
                    }
                  }]
                })
              )
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.txSize },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.label + " " + __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.marginRightO },
            this.intlMsg.msg('txsize'),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "span",
              { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.refresher },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Refresher__["a" /* default */], {
                onReload: this.handleReloadTxSize,
                reloading: txSize.status === 'pending'
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.value + " " + __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.marginRight },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_Nvl__["a" /* default */], { val: size, status: txSize.status })
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.marginRight },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_RichButton__["a" /* default */], {
              status: flushStatus,
              states: [{
                status: 'default',
                style: 'link-warning',
                label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "span",
                  null,
                  this.intlMsg.msg('flushtx')
                ),
                onClick: this.handleFlushTx
              }, {
                status: 'pending',
                style: 'link-default',
                label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "span",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" }),
                  ' ',
                  this.intlMsg.msg('flushing')
                )
              }]
            })
          )
        )
      )
    );
  };

  return SendData;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

SendData.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    txSize: state.device.getTxSize,
    sent: state.device.sendDeviceData,
    flushed: state.device.flushTx
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push,
  getTxSize: __WEBPACK_IMPORTED_MODULE_9_loraactions_device__["a" /* default */].getTxSize,
  sendData: __WEBPACK_IMPORTED_MODULE_9_loraactions_device__["a" /* default */].sendDeviceData,
  flushTx: __WEBPACK_IMPORTED_MODULE_9_loraactions_device__["a" /* default */].flushTx
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(SendData)));

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aisztheme_sass_animate_scss__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aisztheme_sass_animate_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_aisztheme_sass_animate_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_LoadingVal__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_PageLoading__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loraactions_usage__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loraapi_lora_device__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DeviceBriefPktTrend__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DeviceBriefData__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__DeviceProps__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_scss__ = __webpack_require__(2234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);






















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.any.isRequired,
  device: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  basic: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  delResult: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  getNodesUsage: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  appState: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  replaceState: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired
};

var DetailView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DetailView, _React$Component);

  function DetailView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DetailView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.detailview');
    _this.state = {
      device: props.device,
      basic: props.basic,
      appState: props.appState,
      latestData: [],
      dataDir: 'up',
      coordinate: props.device.lat + "," + props.device.lng,
      coordinateError: null,
      sendStatus: {},
      noExist: false
    };
    _this.handleDelete = _this.handleDelete.bind(_this);
    return _this;
  }

  DetailView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var device = nextProps.device,
        basic = nextProps.basic,
        delResult = nextProps.delResult,
        appId = nextProps.appId,
        pushState = nextProps.pushState,
        appState = nextProps.appState;

    if (device !== this.props.device) {
      this.setState({
        device: device,
        coordinate: device.lat + ", " + device.lng
      });
      var status = device.status,
          _device$error = device.error;
      _device$error = _device$error === undefined ? {} : _device$error;
      var code = _device$error.code;

      if (status === 'failure' && code === 'NOTFOUND') {
        this.setState({ noExist: true });
      }
    }
    if (basic !== this.props.basic) {
      this.setState({ basic: basic });
    }
    if (appState !== this.props.appState) {
      this.setState({ appState: appState });
    }
    if (delResult !== this.props.delResult) {
      if (delResult.status === 'success') {
        pushState("/application/" + appId);
      }
    }
  };

  DetailView.prototype.detail = function detail(key) {
    var device = this.state.device;
    var status = device.status,
        data = device.data;

    if (status === 'success') {
      return data[key];
    }
    if (status === 'failure') {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle" });
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" });
  };

  DetailView.prototype.handleDelete = function handleDelete() {
    var _this2 = this;

    var getNodesUsage = this.props.getNodesUsage;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_loraapi_lora_device__["d" /* delDevice */])(this.props.deviceId).then(function () {
      getNodesUsage();
      _this2.props.pushState("/application/" + _this2.props.appId);
    });
  };

  DetailView.prototype.renderDeleteModal = function renderDeleteModal() {
    var _this3 = this;

    var deviceId = this.props.deviceId;
    var _state$device$data = this.state.device.data;
    _state$device$data = _state$device$data === undefined ? {} : _state$device$data;
    var name = _state$device$data.name;


    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-danger",
        show: this.state.showDelete,
        onHide: function onHide() {
          return _this3.setState({ showDelete: false });
        }
      },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle", "aria-hidden": "true" }),
          ' ',
          this.intlMsg.msg('delete.modalheader')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "p",
            null,
            this.intlMsg.msg('delete.confirm'),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "strong",
              null,
              name,
              "(",
              deviceId,
              ")"
            ),
            " ?"
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
              {
                bsStyle: "aisz-warning",
                onClick: function onClick() {
                  return _this3.setState({ showDelete: false });
                }
              },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-repeat", "aria-hidden": "true" }),
              ' ',
              this.intlMsg.msg('delete.cancelbtn')
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
              { bsStyle: "aisz-danger", onClick: this.handleDelete },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-trash-o", "aria-hidden": "true" }),
              ' ',
              this.intlMsg.msg('delete.confirmbtn')
            )
          )
        )
      )
    );
  };

  DetailView.prototype.renderToolbar = function renderToolbar() {
    var _this4 = this;

    var appId = this.props.appId;
    var _state = this.state,
        device = _state.device,
        appState = _state.appState;
    var status = device.status,
        _device$data = device.data;
    _device$data = _device$data === undefined ? {} : _device$data;
    var name = _device$data.name,
        deveui = _device$data.deveui;
    var appStatus = appState.status,
        _appState$data = appState.data;
    _appState$data = _appState$data === undefined ? {} : _appState$data;
    var appName = _appState$data.name;


    var devName = void 0;
    if (name === '') {
      devName = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_LoadingVal__["a" /* default */], { val: deveui, formatter: __WEBPACK_IMPORTED_MODULE_17_lorautils_IdUtils__["a" /* normalizeDevEUI */], status: status });
    } else {
      devName = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_LoadingVal__["a" /* default */], { val: name, status: status });
    }

    var breadcrumb = [{
      content: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], { id: "application.breadcrumb.application" }),
      onClick: function onClick() {
        return _this4.props.pushState('/application');
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_LoadingVal__["a" /* default */], { val: appName, status: appStatus }),
      onClick: function onClick() {
        return _this4.props.replaceState("/application/" + appId);
      }
    }, {
      content: devName,
      active: true
    }];

    var rightTools = [{
      type: 'buttons',
      buttons: [__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
        { bsStyle: "aisz-danger", onClick: function onClick() {
            return _this4.setState({ showDelete: true });
          } },
        this.intlMsg.msg('delete.btn'),
        ' ',
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-trash-o", "aria-hidden": "true" })
      )]
    }];

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb, rightTools: rightTools });
  };

  DetailView.prototype.render = function render() {
    var _props = this.props,
        deviceId = _props.deviceId,
        appId = _props.appId;
    var _state2 = this.state,
        basic = _state2.basic,
        noExist = _state2.noExist;

    if (basic.status !== 'success') {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_PageLoading__["a" /* default */], null);
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Grid"],
        { fluid: true },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
            { md: 12 },
            this.renderToolbar()
          )
        ),
        noExist && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.noDevice },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "h3",
            null,
            this.intlMsg.msg('nodevice')
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.desc },
            this.intlMsg.msg('nodevice.tips')
          )
        ),
        !noExist && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
            { md: 8, className: "collapse-right" },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__DeviceBriefPktTrend__["a" /* default */], { appId: appId, deviceId: deviceId }),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__DeviceBriefData__["a" /* default */], { appId: appId, deviceId: deviceId })
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__DeviceProps__["a" /* default */], { deviceId: deviceId })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        null,
        this.renderDeleteModal()
      )
    );
  };

  return DetailView;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

DetailView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    device: state.device.getDevice || {},
    basic: state.org.basic || {},
    delResult: state.device.deleteDevice,
    appId: ownProps.params.appId,
    deviceId: ownProps.params.deviceId,
    path: ownProps.location.pathname,
    appState: state.app.getApp
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["routerActions"].push,
  replaceState: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["routerActions"].replace,
  getDevice: __WEBPACK_IMPORTED_MODULE_14_loraactions_device__["a" /* default */].getDevice,
  deleteDevice: __WEBPACK_IMPORTED_MODULE_14_loraactions_device__["a" /* default */].deleteDevice,
  getNodesUsage: __WEBPACK_IMPORTED_MODULE_15_loraactions_usage__["a" /* default */].nodes
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"])(DetailView)));

/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_difference_in_seconds__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_difference_in_seconds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_difference_in_seconds__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_DetailEye__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Refresher__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_CollapseToggle__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_DataDirSwitch__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_PanelToolbar__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_Link__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lorautils_DateTimeUtils__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss__ = __webpack_require__(2235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




















function isNew(time) {
  return __WEBPACK_IMPORTED_MODULE_8_date_fns_difference_in_seconds___default()(new Date(), time) < 10;
}

var propTypes = {
  appId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  getDeviceData: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  deviceData: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var DeviceBriefData = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeviceBriefData, _React$Component);

  function DeviceBriefData(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeviceBriefData);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      deviceData: props.deviceData
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_17_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.detailview');
    _this.loadData = _this.loadData.bind(_this);
    _this.handleChangeDataDir = _this.handleChangeDataDir.bind(_this);
    return _this;
  }

  DeviceBriefData.prototype.componentWillMount = function componentWillMount() {
    this.loadData();
  };

  DeviceBriefData.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var deviceData = nextProps.deviceData;

    if (deviceData !== this.props.deviceData) {
      this.setState({ deviceData: deviceData });
      if (deviceData.status === 'success') {
        this.setState({ dataList: deviceData.data.list });
      }
    }
  };

  DeviceBriefData.prototype.loadData = function loadData() {
    var _props = this.props,
        deviceId = _props.deviceId,
        getDeviceData = _props.getDeviceData;
    var dataDir = this.state.dataDir;

    getDeviceData(deviceId, { dir: dataDir, limit: 20 });
  };

  DeviceBriefData.prototype.handleChangeDataDir = function handleChangeDataDir(dir) {
    if (this.state.dataDir === dir) {
      return;
    }
    this.setState({ dataDir: dir });
    var _props2 = this.props,
        getDeviceData = _props2.getDeviceData,
        deviceId = _props2.deviceId;

    getDeviceData(deviceId, { dir: dir, limit: 20 });
  };

  DeviceBriefData.prototype.render = function render() {
    var _this2 = this;

    var _props3 = this.props,
        appId = _props3.appId,
        deviceId = _props3.deviceId,
        pushState = _props3.pushState;
    var _state = this.state,
        deviceData = _state.deviceData,
        _state$dataList = _state.dataList,
        dataList = _state$dataList === undefined ? [] : _state$dataList,
        _state$expanded = _state.expanded,
        expanded = _state$expanded === undefined ? true : _state$expanded;


    var header = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      this.intlMsg.msg('latestdata.header'),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "ul",
        { className: "icontools" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_DetailEye__["a" /* default */], { onClick: function onClick() {
              return pushState("/application/" + appId + "/devices/" + deviceId + "/datatool");
            } })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Refresher__["a" /* default */], {
            onReload: this.loadData,
            reloading: deviceData.status === 'pending'
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_CollapseToggle__["a" /* default */], {
            expanded: expanded,
            onChange: function onChange(v) {
              return _this2.setState({ expanded: v });
            }
          })
        )
      )
    );

    var dataDirSwitch = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_DataDirSwitch__["a" /* default */], { onChange: this.handleChangeDataDir });

    var rows = dataList.map(function (d) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        { key: d.$time + "-" + d.gateway + "-" + d.fcnt, className: isNew(d.$time) ? __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.new : '' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lorautils_DateTimeUtils__["a" /* compactFormat */])(d.$time)
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_15_loracoms_Link__["a" /* default */],
            { to: "/application/" + d.appeui.split('-').join('').toLocaleLowerCase() },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_lorautils_IdUtils__["d" /* normalizeAppEUI */])(d.appeui)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_15_loracoms_Link__["a" /* default */],
            { to: "/gateway/detail/" + d.gateway.split('-').join('').toLocaleLowerCase() },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_lorautils_IdUtils__["b" /* normalizeMac */])(d.gateway)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_15_loracoms_Link__["a" /* default */],
            { to: "/gateway/detail/" + d.gateway.split('-').join('').toLocaleLowerCase() },
            d.name
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_RichLabel__["a" /* default */], {
            content: d.mtype,
            translateMap: {
              UnconfirmedDataUp: _this2.intlMsg.msg('unconfirmeddataup'),
              UnconfirmedDataDown: _this2.intlMsg.msg('unconfirmeddatadown'),
              ConfirmedDataUp: _this2.intlMsg.msg('confirmeddataup'),
              ConfirmedDataDown: _this2.intlMsg.msg('confirmeddatadown'),
              JoinRequest: _this2.intlMsg.msg('joinrequest'),
              JoinAccept: _this2.intlMsg.msg('joinaccept'),
              RFU: _this2.intlMsg.msg('rfu'),
              Proprietary: _this2.intlMsg.msg('proprietary')
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          d.fcnt
        )
      );
    });

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: header, collapsible: true, expanded: expanded },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_PanelToolbar__["a" /* default */], { tools: [dataDirSwitch] }),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Table"],
          {
            className: "aisz-table-light " + __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.dataTable,
            striped: true,
            hover: true,
            bordered: true,
            responsive: true
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                " ",
                this.intlMsg.msg('data.field.time', 'lora'),
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                " AppEUI "
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                " ",
                this.intlMsg.msg('data.field.gateway', 'lora'),
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                " ",
                this.intlMsg.msg('data.field.gwname', 'lora'),
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                " ",
                this.intlMsg.msg('data.field.msgtype', 'lora'),
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                " ",
                this.intlMsg.msg('data.field.frameno', 'lora'),
                " "
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tbody",
            null,
            rows
          )
        )
      )
    );
  };

  return DeviceBriefData;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DeviceBriefData.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    deviceData: state.device.getDeviceData || {}
  };
};

var mapDispatchToProps = {
  getDeviceData: __WEBPACK_IMPORTED_MODULE_19_loraactions_device__["a" /* default */].getDeviceData,
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(DeviceBriefData)));

/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_LineChart__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_DetailEye__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Refresher__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_CollapseToggle__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_add_hours__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_add_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_date_fns_add_hours__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_sub_days__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_sub_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_date_fns_sub_days__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);
















var propTypes = {
  appId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired
};

var DeviceBriefPktTrend = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeviceBriefPktTrend, _React$Component);

  function DeviceBriefPktTrend(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeviceBriefPktTrend);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.detailview');
    _this.state = {
      series: {
        rxpks: {
          name: _this.intlMsg.msg('series.packets'),
          data: [],
          yAxisIndex: 0
        },
        categories: []
      }
    };
    _this.loadData = _this.loadData.bind(_this);
    return _this;
  }

  DeviceBriefPktTrend.prototype.componentWillMount = function componentWillMount() {
    this.loadData();
  };

  DeviceBriefPktTrend.prototype.loadData = function loadData() {
    var _this2 = this;

    var deviceId = this.props.deviceId;

    var from = __WEBPACK_IMPORTED_MODULE_14_date_fns_format___default()(__WEBPACK_IMPORTED_MODULE_16_date_fns_sub_days___default()(new Date(), 7), 'YYYYMMDDHH');
    var to = __WEBPACK_IMPORTED_MODULE_14_date_fns_format___default()(__WEBPACK_IMPORTED_MODULE_15_date_fns_add_hours___default()(new Date(), 1), 'YYYYMMDDHH');

    this.setState({ reloading: true });

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_api__["a" /* callAPI */])({
      endpoint: "/lora/nodes/" + deviceId + "/stats?from=" + from + "&to=" + to
    }).then(function (data) {
      var rxpks = [];
      var slots = [];
      data.list.forEach(function (item) {
        var s = item.slot.toString();
        var slot = s.slice(6, 8) + "/" + s.slice(4, 6) + " " + s.slice(8, 10) + ":00";
        slots.push(slot);
        rxpks.push(item.rxpkt);
      });
      var series = _.extend({}, _this2.state.series);
      series.rxpks.data = rxpks;
      series.categories = slots;
      _this2.setState({ series: series, reloading: false });
    }).catch(function () {});
  };

  DeviceBriefPktTrend.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        appId = _props.appId,
        deviceId = _props.deviceId,
        pushState = _props.pushState;
    var _state = this.state,
        _state$reloading = _state.reloading,
        reloading = _state$reloading === undefined ? false : _state$reloading,
        series = _state.series,
        _state$expanded = _state.expanded,
        expanded = _state$expanded === undefined ? true : _state$expanded,
        _state$resizeTrigger = _state.resizeTrigger,
        resizeTrigger = _state$resizeTrigger === undefined ? 0 : _state$resizeTrigger;

    var header = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      this.intlMsg.msg('devicestatus'),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "ul",
        { className: "icontools" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_DetailEye__["a" /* default */], { onClick: function onClick() {
              return pushState("/application/" + appId + "/devices/" + deviceId + "/stat");
            } })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Refresher__["a" /* default */], {
            reloading: reloading,
            onReload: this.loadData
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_CollapseToggle__["a" /* default */], {
            expanded: expanded,
            onChange: function onChange(v) {
              _this3.setState({ expanded: v });
            }
          })
        )
      )
    );

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Panel"],
      {
        bsStyle: "aisz-white",
        header: header,
        collapsible: true,
        expanded: expanded,
        onEntered: function onEntered() {
          _this3.setState({ resizeTrigger: Math.random() });
        }
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_LineChart__["a" /* default */], {
        yAxis: [{
          name: this.intlMsg.msg('series.packets'),
          splitNumber: 5
        }],
        xAxis: {
          axisTick: {
            alignWithLabel: true
          },
          boundaryGap: true
        },
        grid: {
          left: 60,
          top: 30,
          right: 30,
          bottom: 30
        },
        series: [series.rxpks],
        categories: series.categories,
        resizeTrigger: resizeTrigger
      })
    );
  };

  return DeviceBriefPktTrend;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DeviceBriefPktTrend.propTypes = propTypes;

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_7_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(DeviceBriefPktTrend)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loracoms_Refresher__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_CollapseToggle__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_LineChart__ = __webpack_require__(97);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  series: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  reloading: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool.isRequired,
  onReload: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var DeviceDropPktsTrend = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeviceDropPktsTrend, _React$Component);

  function DeviceDropPktsTrend(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeviceDropPktsTrend);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.statview');
    _this.state = {
      series: props.series,
      reloading: props.reloading
    };
    return _this;
  }

  DeviceDropPktsTrend.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var series = nextProps.series,
        reloading = nextProps.reloading;

    if (series !== this.props.series) {
      this.setState({ series: series });
    }
    if (reloading !== this.props.reloading) {
      this.setState({ reloading: reloading });
    }
  };

  DeviceDropPktsTrend.prototype.render = function render() {
    var _this2 = this;

    var onReload = this.props.onReload;
    var _state = this.state,
        series = _state.series,
        reloading = _state.reloading,
        _state$expanded = _state.expanded,
        expanded = _state$expanded === undefined ? true : _state$expanded,
        _state$resize = _state.resize,
        resize = _state$resize === undefined ? 0 : _state$resize;


    var header = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      this.intlMsg.msg('series.droppedpackets'),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "ul",
        { className: "icontools" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_loracoms_Refresher__["a" /* default */], {
            onReload: onReload,
            reloading: reloading
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_CollapseToggle__["a" /* default */], {
            expanded: expanded,
            onChange: function onChange(v) {
              _this2.setState({ expanded: v });
            }
          })
        )
      )
    );

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Panel"],
      {
        bsStyle: "aisz-white",
        header: header,
        collapsible: true,
        expanded: expanded,
        onEntered: function onEntered() {
          _this2.setState({ resize: Math.random() });
        }
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_LineChart__["a" /* default */], {
        yAxis: [{
          name: this.intlMsg.msg('series.droppedpackets'),
          splitNumber: 5
        }],
        xAxis: {
          axisTick: {
            alignWithLabel: true
          },
          boundaryGap: true
        },
        series: [series.drops],
        categories: series.categories,
        dataZoom: [{
          type: 'slider',
          fillerColor: 'rgba(228, 241, 254, 0.4)',
          dataBackground: {
            lineStyle: {
              width: 0
            },
            areaStyle: {
              color: 'rgba(107, 185, 240, 0.8)'
            }
          }
        }],
        grid: {
          left: 60,
          top: 30,
          right: 30,
          bottom: 60
        },
        colorShift: 1,
        resize: resize
      })
    );
  };

  return DeviceDropPktsTrend;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DeviceDropPktsTrend.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(DeviceDropPktsTrend));

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_start_of_day__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_start_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns_start_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_end_of_day__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_end_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_date_fns_end_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_sub_days__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_sub_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_date_fns_sub_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_add_days__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_date_fns_add_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_is_after__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_is_after___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_date_fns_is_after__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_date_fns_is_before__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_date_fns_is_before___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_date_fns_is_before__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_date_fns_min__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_date_fns_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_date_fns_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_loracoms_DatePicker__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_loracoms_PageSizer__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_loracoms_PanelToolbar__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__styles_scss__ = __webpack_require__(2237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



























var defaultFrom = function defaultFrom() {
  return __WEBPACK_IMPORTED_MODULE_11_date_fns_start_of_day___default()(__WEBPACK_IMPORTED_MODULE_14_date_fns_sub_days___default()(new Date(), 7));
};
var defaultTo = function defaultTo() {
  return __WEBPACK_IMPORTED_MODULE_12_date_fns_end_of_day___default()(new Date());
};
var kLimit = 10;

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,
  deviceState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,
  appState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  replaceState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
};

var DeviceLogs = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DeviceLogs, _React$Component);

  DeviceLogs.handleDisableDate = function handleDisableDate(d, from) {
    return __WEBPACK_IMPORTED_MODULE_16_date_fns_is_after___default()(d, __WEBPACK_IMPORTED_MODULE_18_date_fns_min___default()(__WEBPACK_IMPORTED_MODULE_15_date_fns_add_days___default()(from, 7), new Date())) || __WEBPACK_IMPORTED_MODULE_17_date_fns_is_before___default()(d, from);
  };

  function DeviceLogs(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DeviceLogs);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      deviceState: props.deviceState,
      appState: props.appState,
      pageSize: kLimit,
      mark: 0
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_25_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.devicelog');
    _this.handleChangePageSize = _this.handleChangePageSize.bind(_this);
    _this.handleChangeFrom = _this.handleChangeFrom.bind(_this);
    _this.handleChangeTo = _this.handleChangeTo.bind(_this);
    _this.limit = kLimit;
    _this.from = defaultFrom();
    _this.to = defaultTo();
    return _this;
  }

  DeviceLogs.prototype.componentWillMount = function componentWillMount() {
    this.loadLogs();
  };

  DeviceLogs.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var deviceState = nextProps.deviceState,
        appState = nextProps.appState;

    if (deviceState !== this.props.deviceState) {
      this.setState({ deviceState: deviceState });
    }
    if (appState !== this.props.appState) {
      this.setState({ appState: appState });
    }
  };

  DeviceLogs.prototype.loadLogs = function loadLogs() {
    var _this2 = this;

    var _props = this.props,
        appId = _props.appId,
        deviceId = _props.deviceId;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__api_callAPI__["a" /* default */])({
      endpoint: "/lora/applications/" + appId + "/logs",
      query: {
        order: 'desc',
        after: this.from.valueOf(),
        before: this.to.valueOf(),
        limit: this.limit,
        deveui: deviceId
      }
    }).then(function (res) {
      var list = res.list,
          more = res.more;

      _this2.setState({ list: list, more: more });
    }).catch(function () {});
  };

  DeviceLogs.prototype.handleChangePageSize = function handleChangePageSize(ps) {
    this.limit = ps;
    this.setState({ pageSize: ps });
    this.loadLogs();
  };

  DeviceLogs.prototype.handleChangeFrom = function handleChangeFrom(d) {
    var from = __WEBPACK_IMPORTED_MODULE_11_date_fns_start_of_day___default()(d);
    var to = __WEBPACK_IMPORTED_MODULE_12_date_fns_end_of_day___default()(d);
    this.setState({ from: from, to: to });
    this.from = from;
    this.to = to;
    this.loadLogs();
  };

  DeviceLogs.prototype.handleChangeTo = function handleChangeTo(d) {
    var to = __WEBPACK_IMPORTED_MODULE_12_date_fns_end_of_day___default()(d);
    this.setState({ to: to });
    this.to = to;
    this.loadLogs();
  };

  DeviceLogs.prototype.renderToolbar = function renderToolbar() {
    var _props2 = this.props,
        pushState = _props2.pushState,
        appId = _props2.appId,
        deviceId = _props2.deviceId,
        replaceState = _props2.replaceState;
    var _state = this.state,
        _state$deviceState = _state.deviceState,
        _state$deviceState$da = _state$deviceState.data;
    _state$deviceState$da = _state$deviceState$da === undefined ? {} : _state$deviceState$da;
    var name = _state$deviceState$da.name,
        status = _state$deviceState.status,
        _state$appState = _state.appState,
        _state$appState$data = _state$appState.data;
    _state$appState$data = _state$appState$data === undefined ? {} : _state$appState$data;
    var appName = _state$appState$data.name,
        appStatus = _state$appState.status;

    var breadcrumb = [{
      content: this.intlMsg.msg('breadcrumb.application', 'application'),
      onClick: function onClick() {
        return pushState('/application');
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_loracoms_Nvl__["a" /* default */], { val: appName, status: appStatus }),
      onClick: function onClick() {
        return replaceState("/application/" + appId);
      }
    }, {
      content: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_loracoms_Nvl__["a" /* default */], { val: name || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_lorautils_IdUtils__["a" /* normalizeDevEUI */])(deviceId), status: status }),
      active: true
    }];
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  DeviceLogs.prototype.renderContent = function renderContent() {
    var pushState = this.props.pushState;
    var _state2 = this.state,
        _state2$list = _state2.list,
        list = _state2$list === undefined ? [] : _state2$list,
        _state2$appState$data = _state2.appState.data,
        data = _state2$appState$data === undefined ? {} : _state2$appState$data,
        _state2$from = _state2.from,
        from = _state2$from === undefined ? defaultFrom() : _state2$from,
        _state2$to = _state2.to,
        to = _state2$to === undefined ? defaultTo() : _state2$to,
        pageSize = _state2.pageSize;

    var fromPicker = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_loracoms_DatePicker__["a" /* default */], { date: from, onSelect: this.handleChangeFrom });
    var toPicker = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_loracoms_DatePicker__["a" /* default */], {
      date: to,
      onSelect: this.handleChangeTo,
      disabled: function disabled(d) {
        return DeviceLogs.handleDisableDate(d, from);
      }
    });

    var LogLevels = {
      error: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Label"],
        { bsStyle: "danger" },
        "ERROR"
      ),
      info: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Label"],
        { bsStyle: "info" },
        "INFO"
      ),
      warn: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Label"],
        { bsStyle: "warning" },
        "WARN"
      ),
      debug: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Label"],
        { bsStyle: "default" },
        "DEBUG"
      )
    };
    var trs = list.map(function (l, idx) {
      var info = l.info || {};
      var infos = _.map(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(info), function (k) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.parsed, key: k },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.key },
            k
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.value },
            info[k]
          )
        );
      });

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "tr",
        { key: String(idx) },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.loglevel },
          LogLevels[l.cat]
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_13_date_fns_format___default()(l.$time, 'YYYY-MM-DD HH:mm:ss')
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_loracoms_RichLabel__["a" /* default */], { content: l.code })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
            {
              onClick: function onClick() {
                return pushState("/application/" + data.id + "/devices/" + l.deveui);
              }
            },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_lorautils_IdUtils__["a" /* normalizeDevEUI */])(l.deveui)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          infos
        )
      );
    });

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: this.intlMsg.msg('header') },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_loracoms_PanelToolbar__["a" /* default */], { tools: [fromPicker, toPicker] }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Table"],
        { className: "aisz-table-light", striped: true, hover: true, bordered: true, responsive: true },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "th",
              { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.loglevel },
              this.intlMsg.msg('thead.loglevel')
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "th",
              null,
              " ",
              this.intlMsg.msg('thead.time'),
              " "
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "th",
              null,
              " ",
              this.intlMsg.msg('thead.code'),
              " "
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "th",
              null,
              "DevEUI"
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('thead.remark'),
              " "
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "tbody",
          null,
          trs
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.pager + " clearfix" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_loracoms_PageSizer__["a" /* default */], {
          pageSize: pageSize,
          onChange: this.handleChangePageSize,
          options: [10, 20, 50, 100]
        })
      )
    );
  };

  DeviceLogs.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
          { md: 12 },
          this.renderToolbar()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
          { md: 12 },
          this.renderContent()
        )
      )
    );
  };

  return DeviceLogs;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

DeviceLogs.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    deviceState: state.device.getDevice || {},
    appState: state.app.getApp || {},
    deviceId: ownProps.params.deviceId,
    appId: ownProps.params.appId
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["routerActions"].push,
  replaceState: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["routerActions"].replace
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"])(DeviceLogs)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_sub_days__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_sub_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_sub_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_add_hours__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_add_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_add_hours__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_add_days__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_add_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_add_months__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_add_months___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_add_months__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_start_of_day__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_start_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns_start_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_end_of_day__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_end_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_date_fns_end_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_is_after__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_is_after___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_date_fns_is_after__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_is_before__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_is_before___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_date_fns_is_before__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_min__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_date_fns_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loracoms_LineChart__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loracoms_DatePicker__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_loracoms_PanelToolbar__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_loracoms_InlineSelect__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_loracoms_Refresher__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_loracoms_CollapseToggle__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lorautils_intl_IntlMsg__ = __webpack_require__(7);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);























var defaultFrom = function defaultFrom() {
  return __WEBPACK_IMPORTED_MODULE_11_date_fns_start_of_day___default()(__WEBPACK_IMPORTED_MODULE_7_date_fns_sub_days___default()(new Date(), 1));
};
var defaultTo = function defaultTo() {
  return __WEBPACK_IMPORTED_MODULE_12_date_fns_end_of_day___default()(new Date());
};

var propTypes = {
  deviceId: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired
};

var DevicePktsTrend = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DevicePktsTrend, _React$Component);

  DevicePktsTrend.handleDisableDate = function handleDisableDate(d, from) {
    return __WEBPACK_IMPORTED_MODULE_14_date_fns_is_after___default()(d, __WEBPACK_IMPORTED_MODULE_16_date_fns_min___default()(__WEBPACK_IMPORTED_MODULE_9_date_fns_add_days___default()(from, 7), new Date())) || __WEBPACK_IMPORTED_MODULE_15_date_fns_is_before___default()(d, from);
  };

  function DevicePktsTrend(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DevicePktsTrend);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_24_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.statview');
    _this.state = {
      from: defaultFrom(),
      to: defaultTo(),
      by: 'hour',
      series: {
        rxpks: {
          name: _this.intlMsg.msg('series.packets'),
          data: [],
          yAxisIndex: 0
        },
        categories: []
      }
    };
    _this.handleChangeBy = _this.handleChangeBy.bind(_this);
    _this.handleChangeFrom = _this.handleChangeFrom.bind(_this);
    _this.handleChangeTo = _this.handleChangeTo.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    return _this;
  }

  DevicePktsTrend.prototype.componentWillMount = function componentWillMount() {
    this.loadData();
  };

  DevicePktsTrend.prototype.loadData = function loadData() {
    var _this2 = this;

    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _state = this.state,
        from = _state.from,
        to = _state.to,
        by = _state.by;

    var _by$args = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ by: by }, args),
        argBy = _by$args.by;

    var _from$to$args = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ from: from, to: to }, args),
        argTo = _from$to$args.to,
        argFrom = _from$to$args.from;

    switch (argBy) {
      case 'hour':
        argFrom = __WEBPACK_IMPORTED_MODULE_13_date_fns_format___default()(argFrom, 'YYYYMMDDHH');
        argTo = __WEBPACK_IMPORTED_MODULE_13_date_fns_format___default()(__WEBPACK_IMPORTED_MODULE_8_date_fns_add_hours___default()(argTo, 1), 'YYYYMMDDHH');
        break;
      case 'day':
        argFrom = __WEBPACK_IMPORTED_MODULE_13_date_fns_format___default()(argFrom, 'YYYYMMDD');
        argTo = __WEBPACK_IMPORTED_MODULE_13_date_fns_format___default()(__WEBPACK_IMPORTED_MODULE_9_date_fns_add_days___default()(argTo, 1), 'YYYYMMDD');
        break;
      case 'month':
        argFrom = __WEBPACK_IMPORTED_MODULE_13_date_fns_format___default()(argFrom, 'YYYYMM');
        argTo = __WEBPACK_IMPORTED_MODULE_13_date_fns_format___default()(__WEBPACK_IMPORTED_MODULE_10_date_fns_add_months___default()(argTo, 1), 'YYYYMM');
        break;
      default:
        break;
    }

    this.setState({ reloading: true });

    var deviceId = this.props.deviceId;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_lorautils_api__["a" /* callAPI */])({
      endpoint: "/lora/nodes/" + deviceId + "/stats?from=" + argFrom + "&to=" + argTo
    }).then(function (data) {
      var list = data.list;
      var rxpks = [];
      var slots = [];

      var formatSlot = function formatSlot(slot) {
        var s = String(slot);
        switch (argBy) {
          case 'hour':
            return s.slice(4, 6) + "-" + s.slice(6, 8) + " " + s.slice(8, 10) + ":00";
          case 'day':
            return s.slice(0, 4) + "-" + s.slice(4, 6) + "-" + s.slice(6, 8);
          case 'month':
            return s.slice(0, 4) + "-" + s.slice(4, 6);
          default:
            return s;
        }
      };

      list.forEach(function (l) {
        slots.push(formatSlot(l.slot));
        rxpks.push(l.rxpkt);
      });

      var series = _this2.state.series;

      series.rxpks.data = rxpks;
      series.categories = slots;
      _this2.setState({
        series: series,
        reloading: false
      });
    }).catch(function () {});
  };

  DevicePktsTrend.prototype.handleChangeBy = function handleChangeBy(by) {
    this.setState({ by: by });
    this.loadData({ by: by });
  };

  DevicePktsTrend.prototype.handleChangeFrom = function handleChangeFrom(from) {
    var to = __WEBPACK_IMPORTED_MODULE_12_date_fns_end_of_day___default()(from);
    this.setState({ from: from, to: to });
    this.loadData({ from: from, to: to });
  };

  DevicePktsTrend.prototype.handleChangeTo = function handleChangeTo(to) {
    this.setState({ to: to });
    this.loadData({ to: to });
  };

  DevicePktsTrend.prototype.renderToolbar = function renderToolbar() {
    var _this3 = this;

    var _state2 = this.state,
        from = _state2.from,
        to = _state2.to,
        by = _state2.by;

    var fromDatePicker = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_DatePicker__["a" /* default */], { date: from, onSelect: this.handleChangeFrom });
    var toDatePicker = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_DatePicker__["a" /* default */], {
      date: to,
      onSelect: this.handleChangeTo,
      disabled: function disabled(d) {
        return DevicePktsTrend.handleDisableDate(d, from);
      }
    });
    var timeBy = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_loracoms_InlineSelect__["a" /* default */], {
      values: [by],
      options: [{
        label: this.intlMsg.msg('button.hour'),
        value: 'hour',
        active: true
      }, {
        label: this.intlMsg.msg('button.day'),
        value: 'day'
      }],
      bsStyle: "aisz-primary",
      onChange: function onChange(selected) {
        return _this3.handleChangeBy(selected[0]);
      }
    });

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_loracoms_PanelToolbar__["a" /* default */], { tools: [fromDatePicker, toDatePicker, timeBy] });
  };

  DevicePktsTrend.prototype.render = function render() {
    var _this4 = this;

    var _state3 = this.state,
        reloading = _state3.reloading,
        _state3$expanded = _state3.expanded,
        expanded = _state3$expanded === undefined ? true : _state3$expanded,
        _state3$resize = _state3.resize,
        resize = _state3$resize === undefined ? 0 : _state3$resize,
        series = _state3.series;


    var header = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      null,
      this.intlMsg.msg('devicestatus'),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "ul",
        { className: "icontools" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_loracoms_Refresher__["a" /* default */], {
            onReload: this.loadData,
            reloading: reloading
          })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_loracoms_CollapseToggle__["a" /* default */], {
            expanded: expanded,
            onChange: function onChange(v) {
              return _this4.setState({ expanded: v });
            }
          })
        )
      )
    );

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Panel"],
      {
        bsStyle: "aisz-white",
        header: header,
        collapsible: true,
        expanded: expanded,
        onEntered: function onEntered() {
          return _this4.setState({ resize: Math.random() });
        }
      },
      this.renderToolbar(),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_LineChart__["a" /* default */], {
        yAxis: [{
          name: this.intlMsg.msg('series.packets'),
          splitNumber: 5
        }],
        xAxis: {
          axisTick: {
            alignWithLabel: true
          },
          boundaryGap: true
        },
        series: [series.rxpks],
        categories: series.categories,
        dataZoom: [{
          type: 'slider',
          fillerColor: 'rgba(228, 241, 254, 0.4)',
          dataBackground: {
            lineStyle: {
              width: 0
            },
            areaStyle: {
              color: 'rgba(107, 185, 240, 0.8)'
            }
          }
        }],
        grid: {
          left: 60,
          top: 30,
          right: 30,
          bottom: 60
        },
        resize: resize
      })
    );
  };

  return DevicePktsTrend;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

DevicePktsTrend.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(DevicePktsTrend));

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isNil__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loraactions_enums__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_PropsPanel__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lorautils_api_selector__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lorautils_checkers_numbers__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__MapOverlay__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_scss__ = __webpack_require__(2238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);






















var kNonEmptyIds = ['name', 'appkey'];

var kRxWindowOptions = [{ value: 1, label: 'RX1' }, { value: 2, label: 'RX2' }];

var kRX1DROffsetOptions = _.range(8).map(function (v) {
  return {
    value: v,
    label: String(v)
  };
});

var kRXDelayOptions = _.range(16).map(function (v) {
  return {
    value: v,
    label: String(v)
  };
});

var kRX2DROptions = _.range(16).map(function (v) {
  return {
    value: v,
    label: String(v)
  };
});

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  device: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  getLwanvers: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getNodetypes: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  lwanversOpts: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.array.isRequired,
  nodetypesOpts: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.array.isRequired,
  updateDevice: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  update: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  getDevice: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getBands: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getVendors: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  bandsOpts: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.array.isRequired,
  vendorOptsShow: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.array.isRequired,
  vendorOpts: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var DeviceProps = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeviceProps, _React$Component);

  function DeviceProps(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeviceProps);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      device: props.device,
      errors: new __WEBPACK_IMPORTED_MODULE_20_lorautils_errors_ErrorSet__["a" /* default */](),
      vendorOpts: props.vendorOpts
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_19_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.detailview');
    _this.handleCancel = _this.handleCancel.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleSubmitLocation = _this.handleSubmitLocation.bind(_this);
    return _this;
  }

  DeviceProps.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        getLwanvers = _props.getLwanvers,
        getNodetypes = _props.getNodetypes,
        getBands = _props.getBands,
        getVendors = _props.getVendors;

    getLwanvers();
    getNodetypes();
    getBands();
    getVendors();
  };

  DeviceProps.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var device = nextProps.device,
        lwanversOpts = nextProps.lwanversOpts,
        nodetypesOpts = nextProps.nodetypesOpts,
        bandsOpts = nextProps.bandsOpts,
        vendorOptsShow = nextProps.vendorOptsShow,
        vendorOpts = nextProps.vendorOpts,
        update = nextProps.update;

    if (device !== this.props.device) {
      this.setState({ device: device });
    }
    if (lwanversOpts !== this.props.lwanversOpts) {
      this.setState({ lwanversOpts: lwanversOpts });
    }
    if (nodetypesOpts !== this.props.nodetypesOpts) {
      this.setState({ nodetypesOpts: nodetypesOpts });
    }
    if (bandsOpts !== this.props.bandsOpts) {
      this.setState({ bandsOpts: bandsOpts });
    }
    if (vendorOptsShow !== this.props.vendorOptsShow) {
      this.setState({ vendorOptsShow: vendorOptsShow });
    }
    if (vendorOpts !== this.props.vendorOpts) {
      this.setState({ vendorOpts: vendorOpts });
    }
    if (update !== this.props.update) {
      if (update.status === 'success') {
        var _props2 = this.props,
            getDevice = _props2.getDevice,
            deviceId = _props2.deviceId;

        getDevice(deviceId);
      }
      if (update.status === 'failure') {
        if (update.error.code === 'BADFREQUENCY' || update.error.code === 'BADDATARATE') {
          var errors = this.state.errors;

          this.setState({ errors: errors.add(update.error.code, 'submitLora') });
        }
      }
    }
  };

  DeviceProps.prototype.battery = function battery() {
    var _props$device$data = this.props.device.data;
    _props$device$data = _props$device$data === undefined ? {} : _props$device$data;
    var battery = _props$device$data.battery;

    if (battery === undefined) {
      return this.intlMsg.msg('value.batterystatuserr');
    } else if (battery === 0) {
      return this.intlMsg.msg('value.power');
    } else if (battery === 255) {
      return this.intlMsg.msg('value.unknown');
    }

    var percent = (battery / 2.54).toFixed(1);
    var icon = void 0;
    if (percent >= 99) {
      icon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-battery-full text-success" });
    } else if (percent >= 75) {
      icon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-battery-75" });
    } else if (percent >= 50) {
      icon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-battery-50" });
    } else if (percent >= 25) {
      icon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-battery-25 text-warning" });
    } else {
      icon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-battery-10 text-danger" });
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "span",
      null,
      percent + "%",
      ' ',
      icon
    );
  };

  DeviceProps.prototype.lastact = function lastact() {
    var _props$device$data2 = this.props.device.data;
    _props$device$data2 = _props$device$data2 === undefined ? {} : _props$device$data2;
    var lastact = _props$device$data2.lastact,
        lastDataUp = _props$device$data2.lastDataUp,
        lastStatusAns = _props$device$data2.lastStatusAns,
        lastStatusReq = _props$device$data2.lastStatusReq;

    if (lastact > 0 || lastDataUp > 0 || lastStatusAns > 0 || lastStatusReq > 0) {
      return this.intlMsg.msg('result.active');
    }
    return this.intlMsg.msg('result.unactive');
  };

  DeviceProps.prototype.checkNotEmpty = function checkNotEmpty(val, id) {
    var errors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.state.errors;

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default()(val) || __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default()(val)) {
      return errors.add('FE_EMPTY', id, { message: this.intlMsg.errorMsg('FE_EMPTY', 'lora') });
    }
    return errors.remove(id);
  };

  DeviceProps.prototype.checkVendorver = function checkVendorver(val) {
    var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.errors;

    var regVen = new RegExp('^([1-9]|[1-9][0-9]|1\\d\\d|2[0-4]\\d|25[0-5])$');
    if (val !== '') {
      if (!regVen.test(val)) {
        return errors.add('FE_iptNumRange', 'vendorver', { message: this.intlMsg.errorMsg('FE_iptNumRange') });
      }
    }
    return errors.remove('vendorver');
  };

  DeviceProps.prototype.checkAppKey = function checkAppKey(val) {
    var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.errors;

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_lorautils_checkers_numbers__["c" /* isHexString */])(val, { len: 32 })) {
      return errors.add('FE_INVALIDAPPKEY', 'appkey', { message: this.intlMsg.errorMsg('FE_INVALIDAPPKEY') });
    }
    return errors.remove('appkey');
  };

  DeviceProps.prototype.checkRX2Freq = function checkRX2Freq(val) {
    var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.errors;

    if (!/^[0-9]+(\.[0-9]+)?$/.test(val)) {
      return errors.add('FE_INVALIDNUM', 'rx2freq', { message: this.intlMsg.errorMsg('FE_INVALIDNUM') });
    }
    if (!/^[0-9]+(\.[0-9]{0,4})?$/.test(val)) {
      return errors.add('FE_PREC4', 'rx2freq', { message: this.intlMsg.errorMsg('FE_PREC4') });
    }
    if (Number(val) < 100 || Number(val) > 16700) {
      return errors.add('FE_OUTOFRANGE', 'rx2freq', { message: this.intlMsg.errorMsg('FE_OUTOFRANGE') });
    }
    return errors.remove('rx2freq');
  };

  DeviceProps.prototype.handleChange = function handleChange(data, id) {
    var val = data[id];
    var errors = this.state.errors;


    if (kNonEmptyIds.includes(id)) {
      errors = this.checkNotEmpty(val, id);
    }
    if (id === 'appkey') {
      errors = this.checkAppKey(data.appkey);
    }
    if (id === 'rx2freq') {
      errors = this.checkRX2Freq(val, errors);
    }
    if (id === 'vendorver') {
      errors = this.checkVendorver(val, errors);
    }
    this.setState({ errors: errors });
  };

  DeviceProps.prototype.handleCancel = function handleCancel(ids) {
    var errors = this.state.errors;

    ids.forEach(function (id) {
      errors = errors.remove(id);
    });
    this.setState({ errors: errors, editAuth: null });
  };

  DeviceProps.prototype.handleSubmit = function handleSubmit(data, dirtyIds) {
    if (__WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default()(dirtyIds)) {
      return true;
    }

    var errors = this.state.errors;

    errors = errors.remove('submitLora');
    this.setState({ errors: errors });

    if (!errors.isEmpty()) {
      return false;
    }

    var udata = _.fromPairs(_.filter(_.toPairs(data), function (p) {
      return dirtyIds.includes(p[0]);
    }));

    if (udata.rxwindow) {
      udata.rxwindow = Number(udata.rxwindow);
    }
    if (udata.appkey) {
      udata.appkey = udata.appkey.split(/[:-]/).join('');
    }
    if (udata.rx2freq) {
      udata.rx2freq = Number(udata.rx2freq) * 10000;
    }
    if (udata.band === '') {
      udata.band = null;
    }
    if (udata.vendor) {
      var vendorOpts = this.state.vendorOpts;

      var currentVen = _.filter(vendorOpts.data.list, function (ven) {
        return ven.name === udata.vendor;
      });
      if (currentVen.length !== 0) {
        udata.vendor = Number(currentVen[0].id);
      }
    }
    if (udata.vendorver !== '') {
      udata.vendorver = Number(udata.vendorver);
    } else {
      udata.vendorver = 0;
    }

    var _props3 = this.props,
        updateDevice = _props3.updateDevice,
        deviceId = _props3.deviceId;

    updateDevice(deviceId, udata);
    return true;
  };

  DeviceProps.prototype.handleSubmitLocation = function handleSubmitLocation(point) {
    var _props4 = this.props,
        updateDevice = _props4.updateDevice,
        deviceId = _props4.deviceId;

    updateDevice(deviceId, {
      lng: String(point.lng),
      lat: String(point.lat)
    });
  };

  DeviceProps.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        device = _state.device,
        lwanversOpts = _state.lwanversOpts,
        nodetypesOpts = _state.nodetypesOpts,
        bandsOpts = _state.bandsOpts,
        vendorOptsShow = _state.vendorOptsShow,
        vendorOpts = _state.vendorOpts,
        errors = _state.errors,
        _state$showMap = _state.showMap,
        showMap = _state$showMap === undefined ? false : _state$showMap;
    var _device$data = device.data;
    _device$data = _device$data === undefined ? {} : _device$data;
    var name = _device$data.name,
        deveui = _device$data.deveui,
        devaddr = _device$data.devaddr,
        devid = _device$data.devid,
        type = _device$data.type,
        lastDataUp = _device$data.lastDataUp,
        city = _device$data.city,
        area = _device$data.area,
        address = _device$data.address,
        lwanver = _device$data.lwanver,
        rxwindow = _device$data.rxwindow,
        appkey = _device$data.appkey,
        appskey = _device$data.appskey,
        nwkskey = _device$data.nwkskey,
        lat = _device$data.lat,
        lng = _device$data.lng,
        rx1droffset = _device$data.rx1droffset,
        rxdelay = _device$data.rxdelay,
        rx2freq = _device$data.rx2freq,
        rx2dr = _device$data.rx2dr,
        band = _device$data.band,
        status = device.status;
    var _device$data2 = device.data;
    _device$data2 = _device$data2 === undefined ? {} : _device$data2;
    var vendor = _device$data2.vendor,
        vendorver = _device$data2.vendorver;


    if (vendor === 0) {
      vendor = '未定义';
    } else if (vendorOpts.status === 'success') {
      var currentVen = _.filter(vendorOpts.data.list, function (ven) {
        return Number(ven.id) === vendor;
      });
      if (currentVen.length !== 0) {
        vendor = currentVen[0].name;
      } else {
        vendor = '未定义';
      }
    }

    if (vendorver !== 0) {
      vendorver = _.join(_.concat('版本', vendorver), '');
    } else {
      vendorver = '';
    }

    var deviceBasic = {
      name: name,
      deveui: deveui,
      devaddr: devaddr,
      devid: devid,
      type: type,
      band: band,
      vendor: vendor,
      vendorver: vendorver
    };
    var deviceStatus = {
      battery: this.battery(),
      lastact: this.lastact(),
      lastDataUp: lastDataUp
    };
    var deviceLocation = {
      city: city,
      area: area,
      address: address,
      lat: lat,
      lng: lng
    };
    var deviceLora = {
      class: device.data ? device.data.class : null,
      lwanver: lwanver,
      rxwindow: rxwindow === 0 ? 1 : rxwindow,
      rx1droffset: rx1droffset,
      rxdelay: rxdelay,
      rx2freq: !_.isNil(rx2freq) ? Number(rx2freq / 10000).toFixed(4) : rx2freq,
      rx2dr: rx2dr
    };
    var deviceKeys = {
      appkey: appkey,
      appskey: appskey,
      nwkskey: nwkskey
    };

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.propsPanels },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_PropsPanel__["a" /* default */], {
        title: this.intlMsg.msg('deviceproperty'),
        data: deviceBasic,
        errors: errors,
        status: status,
        properties: [{
          id: 'name',
          name: this.intlMsg.msg('props.name')
        }, {
          id: 'deveui',
          name: this.intlMsg.msg('label.deveui'),
          readOnly: true,
          copy: function copy() {
            return deveui;
          },
          formatter: function formatter(x) {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Nvl__["a" /* default */], { val: x, formatter: __WEBPACK_IMPORTED_MODULE_17_lorautils_IdUtils__["a" /* normalizeDevEUI */], nul: "empty" });
          }
        }, {
          id: 'devaddr',
          name: this.intlMsg.msg('label.devaddr'),
          readOnly: true,
          copy: function copy() {
            return devaddr;
          },
          formatter: function formatter(x) {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Nvl__["a" /* default */], { val: x, formatter: __WEBPACK_IMPORTED_MODULE_17_lorautils_IdUtils__["e" /* normalizeDevAddr */], nul: "empty" });
          }
        }, {
          id: 'type',
          name: this.intlMsg.msg('label.devtype'),
          control: {
            type: 'select',
            options: nodetypesOpts
          }
        }, {
          id: 'band',
          name: this.intlMsg.msg('label.band'),
          formatter: function formatter(x) {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_RichLabel__["a" /* default */], { content: x });
          },
          control: {
            type: 'select',
            options: bandsOpts
          }
        }, {
          id: 'vendor',
          name: this.intlMsg.msg('label.vendor'),
          control: {
            type: 'select',
            options: vendorOptsShow
          }
        }, {
          id: 'vendorver',
          name: this.intlMsg.msg('label.vendorver')
        }, {
          id: 'devid',
          name: this.intlMsg.msg('label.devid')
        }],
        onCancel: this.handleCancel,
        onChange: this.handleChange,
        onSubmit: this.handleSubmit
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_PropsPanel__["a" /* default */], {
        title: this.intlMsg.msg('propspanel.status'),
        readOnly: true,
        data: deviceStatus,
        status: status,
        properties: [{
          id: 'battery',
          name: this.intlMsg.msg('label.batterystatus')
        }, {
          id: 'lastact',
          name: this.intlMsg.msg('label.lastactstatus')
        }, {
          id: 'lastDataUp',
          name: this.intlMsg.msg('label.lastdataup'),
          formatter: function formatter(x) {
            if (x) {
              return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "span",
                null,
                __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(x * 1000, 'YYYY-MM-DD HH:mm:ss')
              );
            }
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Nvl__["a" /* default */], null);
          }
        }]
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_PropsPanel__["a" /* default */], {
        title: this.intlMsg.msg('location.title'),
        data: deviceLocation,
        status: status,
        errors: errors,
        properties: [{
          id: 'city',
          name: this.intlMsg.msg('location.city')
        }, {
          id: 'area',
          name: this.intlMsg.msg('location.area')
        }, {
          id: 'address',
          name: this.intlMsg.msg('location.address')
        }, {
          id: 'coordinate',
          name: this.intlMsg.msg('location.coordinate'),
          control: {
            type: 'external',
            external: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_router__["f" /* Link */],
              { onClick: function onClick() {
                  return _this2.setState({ showMap: true });
                } },
              this.intlMsg.msg('location.editcoordinate'),
              ' ',
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-map-o" })
            )
          },
          formatter: function formatter() {
            var _lng$lat = { lng: lng, lat: lat },
                _lng$lat$lng = _lng$lat.lng,
                longitude = _lng$lat$lng === undefined ? '' : _lng$lat$lng,
                _lng$lat$lat = _lng$lat.lat,
                latitude = _lng$lat$lat === undefined ? '' : _lng$lat$lat;

            if (latitude !== '' && longitude !== '') {
              return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "span",
                null,
                "(" + longitude + "," + latitude + ")",
                ' ',
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_router__["f" /* Link */],
                  { onClick: function onClick() {
                      return _this2.setState({ showMap: true });
                    } },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-map-o" })
                )
              );
            }
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_router__["f" /* Link */],
              { onClick: function onClick() {
                  return _this2.setState({ showMap: true });
                } },
              _this2.intlMsg.msg('location.editcoordinate'),
              ' ',
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-map-o" })
            );
          }
        }],
        onCancel: this.handleCancel,
        onChange: this.handleChange,
        onSubmit: this.handleSubmit
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_loracoms_PropsPanel__["a" /* default */],
        {
          title: this.intlMsg.msg('panelhead.lorawan'),
          data: deviceLora,
          status: status,
          errors: errors,
          properties: [{
            id: 'class',
            name: this.intlMsg.msg('label.clazz'),
            control: {
              type: 'select',
              options: [{
                value: null,
                label: this.intlMsg.msg('class.default'),
                style: { color: '#DADFE1' }
              }, { value: 'A', label: 'A' }, { value: 'C', label: 'C' }]
            }
          }, {
            id: 'lwanver',
            name: this.intlMsg.msg('label.lwanver'),
            control: {
              type: 'select',
              options: lwanversOpts
            }
          }, {
            id: 'rxwindow',
            name: 'RxWindow',
            control: {
              type: 'select',
              options: kRxWindowOptions
            },
            formatter: function formatter(x) {
              var opt = kRxWindowOptions.find(function (o) {
                return o.value === x;
              });
              if (opt) {
                return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_RichLabel__["a" /* default */], { content: opt.label });
              }
              return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Nvl__["a" /* default */], null);
            }
          }, {
            id: 'rx1droffset',
            name: 'RX1DROffset',
            control: {
              type: 'select',
              options: kRX1DROffsetOptions
            }
          }, {
            id: 'rxdelay',
            name: 'RXDelay',
            control: {
              type: 'select',
              options: kRXDelayOptions
            }
          }, {
            id: 'rx2dr',
            name: 'RX2DR',
            control: {
              type: 'select',
              options: kRX2DROptions
            }
          }, {
            id: 'rx2freq',
            name: 'RX2 Frequency',
            unit: 'MHz'
          }],
          onCancel: this.handleCancel,
          onChange: this.handleChange,
          onSubmit: this.handleSubmit,
          onEdit: function onEdit() {
            _this2.setState({ errors: errors.remove('submitLora') });
          }
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_22__styles_scss___default.a.errorBlock },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_FormBlock__["a" /* default */], {
            show: errors.has('submitLora'),
            message: this.intlMsg.errorMsg(errors.get('submitLora')),
            azStyle: "danger",
            closeButton: true,
            onHide: function onHide() {
              _this2.setState({ errors: errors.remove('submitLora') });
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_PropsPanel__["a" /* default */], {
        title: "LoRaWAN AES128 Keys",
        data: deviceKeys,
        status: status,
        errors: errors,
        properties: [{
          id: 'appkey',
          validator: this.appkeyValid,
          name: 'AppKey',
          copy: function copy() {
            return appkey;
          },
          formatter: function formatter(x) {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Nvl__["a" /* default */], { val: (x ? x.slice(0, 6) : x) + "...", nul: "empty" });
          }
        }, {
          id: 'nwkskey',
          name: 'NwkSKey',
          readOnly: true,
          copy: function copy() {
            return nwkskey;
          },
          formatter: function formatter(x) {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Nvl__["a" /* default */], { val: (x ? x.slice(0, 6) : x) + "...", nul: "empty" });
          }
        }, {
          id: 'appskey',
          name: 'AppSKey',
          readOnly: true,
          copy: function copy() {
            return appskey;
          },
          formatter: function formatter(x) {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Nvl__["a" /* default */], { val: (x ? x.slice(0, 6) : x) + "...", nul: "empty" });
          }
        }],
        onCancel: this.handleCancel,
        onChange: this.handleChange,
        onSubmit: this.handleSubmit
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__MapOverlay__["a" /* default */], {
        devices: [device.data],
        show: showMap,
        onHide: function onHide() {
          return _this2.setState({ showMap: false });
        },
        onSave: this.handleSubmitLocation
      })
    );
  };

  return DeviceProps;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DeviceProps.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    device: state.device.getDevice || {},
    update: state.device.updateDevice,
    lwanversOpts: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lorautils_api_selector__["a" /* enumsToOptions */])('lwanvers', state),
    nodetypesOpts: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lorautils_api_selector__["a" /* enumsToOptions */])('nodetypes', state),
    bandsOpts: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lorautils_api_selector__["a" /* enumsToOptions */])('bands', state),
    vendorOptsShow: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lorautils_api_selector__["a" /* enumsToOptions */])('vendors', state),
    vendorOpts: state.enums.vendors
  };
};

var mapDispatchToProps = {
  getDevice: __WEBPACK_IMPORTED_MODULE_11_loraactions_device__["a" /* default */].getDevice,
  updateDevice: __WEBPACK_IMPORTED_MODULE_11_loraactions_device__["a" /* default */].updateDevice,
  getLwanvers: __WEBPACK_IMPORTED_MODULE_10_loraactions_enums__["a" /* default */].lwanvers,
  getNodetypes: __WEBPACK_IMPORTED_MODULE_10_loraactions_enums__["a" /* default */].nodetypes,
  getBands: __WEBPACK_IMPORTED_MODULE_10_loraactions_enums__["a" /* default */].bands,
  getVendors: __WEBPACK_IMPORTED_MODULE_10_loraactions_enums__["a" /* default */].vendors
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(DeviceProps)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loracoms_Refresher__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_CollapseToggle__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_LineChart__ = __webpack_require__(97);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  series: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  reloading: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool.isRequired,
  onReload: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var DeviceRSSITrend = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeviceRSSITrend, _React$Component);

  function DeviceRSSITrend(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeviceRSSITrend);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.statview');
    _this.state = {
      series: props.series,
      reloading: props.reloading
    };
    return _this;
  }

  DeviceRSSITrend.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var series = nextProps.series,
        reloading = nextProps.reloading;

    if (series !== this.props.series) {
      this.setState({ series: series });
    }
    if (reloading !== this.props.reloading) {
      this.setState({ reloading: reloading });
    }
  };

  DeviceRSSITrend.prototype.render = function render() {
    var _this2 = this;

    var onReload = this.props.onReload;
    var _state = this.state,
        series = _state.series,
        reloading = _state.reloading,
        _state$expanded = _state.expanded,
        expanded = _state$expanded === undefined ? true : _state$expanded,
        _state$resize = _state.resize,
        resize = _state$resize === undefined ? 0 : _state$resize;


    var header = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      "RSSI",
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "ul",
        { className: "icontools" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_loracoms_Refresher__["a" /* default */], {
            onReload: onReload,
            reloading: reloading
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_CollapseToggle__["a" /* default */], {
            expanded: expanded,
            onChange: function onChange(v) {
              _this2.setState({ expanded: v });
            }
          })
        )
      )
    );

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Panel"],
      {
        bsStyle: "aisz-white",
        header: header,
        collapsible: true,
        expanded: expanded,
        onEntered: function onEntered() {
          _this2.setState({ resize: Math.random() });
        }
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_LineChart__["a" /* default */], {
        yAxis: [{
          name: 'RSSI',
          splitNumber: 5
        }],
        xAxis: {
          axisTick: {
            alignWithLabel: true
          },
          boundaryGap: true
        },
        series: [series.rssi],
        categories: series.categories,
        dataZoom: [{
          type: 'slider',
          fillerColor: 'rgba(228, 241, 254, 0.4)',
          dataBackground: {
            lineStyle: { width: 0 },
            areaStyle: { color: 'rgba(107, 185, 240, 0.8)' }
          }
        }],
        grid: {
          left: 60,
          top: 30,
          right: 30,
          bottom: 60
        },
        colorShift: 3,
        resize: resize
      })
    );
  };

  return DeviceRSSITrend;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DeviceRSSITrend.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(DeviceRSSITrend));

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loracoms_Refresher__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_CollapseToggle__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_LineChart__ = __webpack_require__(97);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  series: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  reloading: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool.isRequired,
  onReload: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var DeviceSNRTrend = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeviceSNRTrend, _React$Component);

  function DeviceSNRTrend(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeviceSNRTrend);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.statview');
    _this.state = {
      series: props.series,
      reloading: props.reloading
    };
    return _this;
  }

  DeviceSNRTrend.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var series = nextProps.series,
        reloading = nextProps.reloading;

    if (series !== this.props.series) {
      this.setState({ series: series });
    }
    if (reloading !== this.props.reloading) {
      this.setState({ reloading: reloading });
    }
  };

  DeviceSNRTrend.prototype.render = function render() {
    var _this2 = this;

    var onReload = this.props.onReload;
    var _state = this.state,
        series = _state.series,
        reloading = _state.reloading,
        _state$expanded = _state.expanded,
        expanded = _state$expanded === undefined ? true : _state$expanded,
        _state$resize = _state.resize,
        resize = _state$resize === undefined ? 0 : _state$resize;


    var header = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      "SNR",
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "ul",
        { className: "icontools" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_loracoms_Refresher__["a" /* default */], {
            onReload: onReload,
            reloading: reloading
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_CollapseToggle__["a" /* default */], {
            expanded: expanded,
            onChange: function onChange(v) {
              _this2.setState({ expanded: v });
            }
          })
        )
      )
    );

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Panel"],
      {
        bsStyle: "aisz-white",
        header: header,
        collapsible: true,
        expanded: expanded,
        onEntered: function onEntered() {
          _this2.setState({ resize: Math.random() });
        }
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_LineChart__["a" /* default */], {
        yAxis: [{
          name: 'SNR',
          splitNumber: 5
        }],
        xAxis: {
          axisTick: { alignWithLabel: true },
          boundaryGap: true
        },
        series: [series.snr],
        categories: series.categories,
        dataZoom: [{
          type: 'slider',
          fillerColor: 'rgba(228, 241, 254, 0.4)',
          dataBackground: {
            lineStyle: { width: 0 },
            areaStyle: { color: 'rgba(107, 185, 240, 0.8)' }
          }
        }],
        tooltip: {
          formatter: function formatter(params) {
            var dataLines = params.map(function (p) {
              return "<span style=\"display: inline-block; background: " + p.color + "; width: 9px; height: 9px; border-radius: 100%;\"></span> " + p.seriesName + " : " + (_.isNil(p.value) ? '-' : Number(p.value).toFixed(1));
            }).join('<br />');
            return params[0].name + "<br />" + dataLines;
          }
        },
        grid: {
          left: 60,
          top: 30,
          right: 30,
          bottom: 60
        },
        colorShift: 2,
        resize: resize
      })
    );
  };

  return DeviceSNRTrend;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DeviceSNRTrend.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(DeviceSNRTrend));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_main_scss__ = __webpack_require__(2239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_main_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







var propTypes = {
  options: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.array.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var RingSwitcher = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(RingSwitcher, _React$Component);

  function RingSwitcher(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RingSwitcher);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    var active = 0;
    props.options.forEach(function (opt, idx) {
      if (opt.active) {
        active = idx;
      }
    });
    _this.state = {
      active: active
    };
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  RingSwitcher.prototype.handleClick = function handleClick() {
    var _props = this.props,
        options = _props.options,
        onChange = _props.onChange;
    var active = this.state.active;

    active = (active + 1) % options.length;
    onChange(options[active].value);
    this.setState({
      active: active
    });
  };

  RingSwitcher.prototype.render = function render() {
    var _this2 = this;

    var options = this.props.options;
    var active = this.state.active;

    var opts = options.map(function (opt, idx) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_loracoms_ShowIf__["a" /* default */],
        { "if": idx === active, key: idx },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "a",
          { onClick: _this2.handleClick },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loracoms_RichLabel__["a" /* default */], { content: opt.label })
        )
      );
    });
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { styleName: "ring-switcher" },
      " ",
      opts,
      " "
    );
  };

  return RingSwitcher;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

RingSwitcher.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6_react_css_modules___default()(RingSwitcher, __WEBPACK_IMPORTED_MODULE_7__styles_main_scss___default.a, { allowMultiple: true }));

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__ = __webpack_require__(62);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  sendCmd: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  sent: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var AddBroadcastReq = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(AddBroadcastReq, _React$Component);

  function AddBroadcastReq(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AddBroadcastReq);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      errors: new __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__["a" /* default */]().add('FE_EMPTY', 'devaddr').add('FE_EMPTY', 'nwkskey').add('FE_EMPTY', 'appskey'),
      appskey: '',
      nwkskey: ''
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.macview');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }

  AddBroadcastReq.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var sent = nextProps.sent;

    this.setState({ sentStatus: sent.status });
  };

  AddBroadcastReq.prototype.checkAddr = function checkAddr(key, val) {
    var errors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.state.errors;

    if (val.length === 0) {
      return errors.add('FE_EMPTY', key);
    } else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["c" /* isHexString */])(val, { len: 8 })) {
      return errors.add('FE_INVALIDADDR', key, { message: this.intlMsg.errorMsg('FE_INVALIDADDR') });
    }
    return errors.remove(key);
  };

  AddBroadcastReq.prototype.handleChangeDevaddr = function handleChangeDevaddr(e) {
    var val = _.trim(e.target.value);
    val = val.replace(/:|-/g, '');
    var errors = this.state.errors;

    errors = this.checkAddr('devaddr', val, errors);
    this.setState({ errors: errors, devaddr: val });
  };

  AddBroadcastReq.prototype.checkKeys = function checkKeys(key, val) {
    var errors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.state.errors;

    if (val.length === 0) {
      return errors.add('FE_EMPTY', key);
    } else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["c" /* isHexString */])(val, { len: 32 })) {
      return errors.add('FE_INVALIDAPPKEY', key, { message: this.intlMsg.errorMsg('FE_INVALIDAPPKEY') });
    }
    return errors.remove(key);
  };

  AddBroadcastReq.prototype.handleChangeKeys = function handleChangeKeys(key, e) {
    var _setState;

    var val = _.trim(e.target.value);
    var errors = this.state.errors;

    errors = this.checkKeys(key, val, errors);
    this.setState((_setState = { errors: errors }, _setState[key] = val, _setState));
  };

  AddBroadcastReq.prototype.handleSubmit = function handleSubmit(e) {
    this.setState({ submitted: true });
    e.preventDefault();

    var errors = this.state.errors;

    if (!errors.isEmpty()) {
      return;
    }

    var _props = this.props,
        deviceId = _props.deviceId,
        sendCmd = _props.sendCmd;
    var _state = this.state,
        devaddr = _state.devaddr,
        nwkskey = _state.nwkskey,
        appskey = _state.appskey;

    sendCmd(deviceId, {
      devaddr: devaddr,
      nwkskey: nwkskey,
      appskey: appskey
    });
  };

  AddBroadcastReq.prototype.render = function render() {
    var _this2 = this;

    var _state2 = this.state,
        _state2$sentStatus = _state2.sentStatus,
        sentStatus = _state2$sentStatus === undefined ? '' : _state2$sentStatus,
        _state2$devaddr = _state2.devaddr,
        devaddr = _state2$devaddr === undefined ? '' : _state2$devaddr,
        _state2$nwkskey = _state2.nwkskey,
        nwkskey = _state2$nwkskey === undefined ? '' : _state2$nwkskey,
        _state2$appskey = _state2.appskey,
        appskey = _state2$appskey === undefined ? '' : _state2$appskey,
        errors = _state2.errors,
        _state2$submitted = _state2.submitted,
        submitted = _state2$submitted === undefined ? false : _state2$submitted;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Form"],
      { horizontal: true, onSubmit: this.handleSubmit },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('devaddr') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            this.intlMsg.msg('addbroadcastreq.address')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: devaddr,
            placeholder: this.intlMsg.msg('addbroadcastreq.devaddr.placeholder'),
            onChange: function onChange(e) {
              return _this2.handleChangeDevaddr(e);
            }
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('devaddr'),
            message: this.intlMsg.errorMsg(errors.get('devaddr')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('appskey') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            this.intlMsg.msg('addbroadcastreq.appskey.label')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: appskey,
            placeholder: this.intlMsg.msg('addbroadcastreq.keys.placeholder'),
            onChange: function onChange(e) {
              return _this2.handleChangeKeys('appskey', e);
            }
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('appskey'),
            message: this.intlMsg.errorMsg(errors.get('appskey')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('nwkskey') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            this.intlMsg.msg('addbroadcastreq.nwskey.label')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: nwkskey,
            placeholder: this.intlMsg.msg('addbroadcastreq.keys.placeholder'),
            onChange: function onChange(e) {
              return _this2.handleChangeKeys('nwkskey', e);
            }
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('nwkskey'),
            message: this.intlMsg.errorMsg(errors.get('nwkskey')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__["a" /* default */], {
            status: sentStatus,
            states: [{
              status: 'default',
              label: this.intlMsg.msg('submit'),
              style: 'primary',
              type: 'submit'
            }, {
              status: 'success',
              label: this.intlMsg.msg('submit.success'),
              style: 'success',
              timer: function timer() {
                return _this2.setState({ sentStatus: '' });
              }
            }, {
              status: 'failure',
              label: this.intlMsg.msg('submit.failure'),
              style: 'danger',
              timer: function timer() {
                return _this2.setState({ sentStatus: '' });
              }
            }]
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__["a" /* default */], {
            show: errors.has('submit'),
            message: this.intlMsg.errorMsg(errors.get('submit')),
            azStyle: "danger"
          })
        )
      )
    );
  };

  return AddBroadcastReq;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

AddBroadcastReq.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    sent: state.device.sendAddBroadcastReq
  };
};

var mapDispatchToProps = {
  sendCmd: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].sendAddBroadcastReq
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(AddBroadcastReq)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__ = __webpack_require__(62);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  sendCmd: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  sent: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var AddBroadcastReqV2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(AddBroadcastReqV2, _React$Component);

  function AddBroadcastReqV2(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AddBroadcastReqV2);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      errors: new __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__["a" /* default */]().add('FE_EMPTY', 'devaddr').add('FE_EMPTY', 'nwkskey').add('FE_EMPTY', 'appskey').add('FE_EMPTY', 'fcnt'),
      appskey: '',
      nwkskey: ''
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.macview');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }

  AddBroadcastReqV2.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var sent = nextProps.sent;

    this.setState({ sentStatus: sent.status });
    if (sent.error) {
      var _sent$error = sent.error,
          code = _sent$error.code,
          _sent$error$message = _sent$error.message,
          message = _sent$error$message === undefined ? '' : _sent$error$message;

      this.setState({
        errors: this.state.errors.add(code + "_" + message.toUpperCase(), 'submit')
      });
    }
  };

  AddBroadcastReqV2.prototype.checkAddr = function checkAddr(key, val) {
    var errors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.state.errors;

    if (val.length === 0) {
      return errors.add('FE_EMPTY', key);
    } else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["c" /* isHexString */])(val, { len: 8 })) {
      return errors.add('FE_INVALIDADDR', key, { message: this.intlMsg.errorMsg('FE_INVALIDADDR') });
    }
    return errors.remove(key);
  };

  AddBroadcastReqV2.prototype.handleChangeDevaddr = function handleChangeDevaddr(e) {
    var val = _.trim(e.target.value);
    val = val.replace(/:|-/g, '');
    var errors = this.state.errors;

    errors = this.checkAddr('devaddr', val, errors);
    this.setState({ errors: errors, devaddr: val });
  };

  AddBroadcastReqV2.prototype.checkKeys = function checkKeys(key, val) {
    var errors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.state.errors;

    if (val.length === 0) {
      return errors.add('FE_EMPTY', key);
    } else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["c" /* isHexString */])(val, { len: 32 })) {
      return errors.add('FE_INVALIDAPPKEY', key, { message: this.intlMsg.errorMsg('FE_INVALIDAPPKEY') });
    }
    return errors.remove(key);
  };

  AddBroadcastReqV2.prototype.handleChangeKeys = function handleChangeKeys(key, e) {
    var _setState;

    var val = _.trim(e.target.value);
    var errors = this.state.errors;

    errors = this.checkKeys(key, val, errors);
    this.setState((_setState = { errors: errors }, _setState[key] = val, _setState));
  };

  AddBroadcastReqV2.prototype.handleChangeFcnt = function handleChangeFcnt(e) {
    var errors = this.state.errors;

    var fcnt = _.trim(e.target.value);
    if (fcnt.length === 0) {
      errors = errors.add('FE_EMPTY', 'fcnt');
    } else if (!_.isInteger(Number(fcnt))) {
      errors = errors.add('INVALID_FCNT', 'fcnt');
    } else {
      errors = errors.remove('fcnt');
    }
    this.setState({ errors: errors, fcnt: fcnt });
  };

  AddBroadcastReqV2.prototype.handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    var errors = this.state.errors;

    errors = errors.remove('submit');
    this.setState({ submitted: true, errors: errors });

    if (!errors.isEmpty()) {
      return;
    }

    var _props = this.props,
        deviceId = _props.deviceId,
        sendCmd = _props.sendCmd;
    var _state = this.state,
        devaddr = _state.devaddr,
        nwkskey = _state.nwkskey,
        appskey = _state.appskey,
        fcnt = _state.fcnt;

    sendCmd(deviceId, {
      devaddr: devaddr,
      nwkskey: nwkskey,
      appskey: appskey,
      fcnt: Number(fcnt)
    });
  };

  AddBroadcastReqV2.prototype.render = function render() {
    var _this2 = this;

    var _state2 = this.state,
        _state2$sentStatus = _state2.sentStatus,
        sentStatus = _state2$sentStatus === undefined ? '' : _state2$sentStatus,
        _state2$devaddr = _state2.devaddr,
        devaddr = _state2$devaddr === undefined ? '' : _state2$devaddr,
        _state2$nwkskey = _state2.nwkskey,
        nwkskey = _state2$nwkskey === undefined ? '' : _state2$nwkskey,
        _state2$appskey = _state2.appskey,
        appskey = _state2$appskey === undefined ? '' : _state2$appskey,
        errors = _state2.errors,
        _state2$submitted = _state2.submitted,
        submitted = _state2$submitted === undefined ? false : _state2$submitted,
        _state2$fcnt = _state2.fcnt,
        fcnt = _state2$fcnt === undefined ? '' : _state2$fcnt;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Form"],
      { horizontal: true, onSubmit: this.handleSubmit },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('devaddr') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            this.intlMsg.msg('addbroadcastreq.address')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: devaddr,
            placeholder: this.intlMsg.msg('addbroadcastreq.devaddr.placeholder'),
            onChange: function onChange(e) {
              return _this2.handleChangeDevaddr(e);
            }
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('devaddr'),
            message: this.intlMsg.errorMsg(errors.get('devaddr')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('appskey') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            this.intlMsg.msg('addbroadcastreq.appskey.label')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: appskey,
            placeholder: this.intlMsg.msg('addbroadcastreq.keys.placeholder'),
            onChange: function onChange(e) {
              return _this2.handleChangeKeys('appskey', e);
            }
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('appskey'),
            message: this.intlMsg.errorMsg(errors.get('appskey')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('nwkskey') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            this.intlMsg.msg('addbroadcastreq.nwskey.label')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: nwkskey,
            placeholder: this.intlMsg.msg('addbroadcastreq.keys.placeholder'),
            onChange: function onChange(e) {
              return _this2.handleChangeKeys('nwkskey', e);
            }
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('nwkskey'),
            message: this.intlMsg.errorMsg(errors.get('nwkskey')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('fcnt') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            this.intlMsg.msg('addbroadcastreq.fcnt')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: fcnt,
            onChange: function onChange(e) {
              return _this2.handleChangeFcnt(e);
            }
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('fcnt'),
            message: this.intlMsg.errorMsg(errors.get('fcnt')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__["a" /* default */], {
            status: sentStatus,
            states: [{
              status: 'default',
              label: this.intlMsg.msg('submit'),
              style: 'primary',
              type: 'submit'
            }, {
              status: 'success',
              label: this.intlMsg.msg('submit.success'),
              style: 'success',
              timer: function timer() {
                return _this2.setState({ sentStatus: '' });
              }
            }, {
              status: 'failure',
              label: this.intlMsg.msg('submit.failure'),
              style: 'danger',
              timer: function timer() {
                return _this2.setState({ sentStatus: '' });
              }
            }]
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__["a" /* default */], {
            show: errors.has('submit'),
            message: this.intlMsg.errorMsg(errors.get('submit')),
            azStyle: "danger"
          })
        )
      )
    );
  };

  return AddBroadcastReqV2;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

AddBroadcastReqV2.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    sent: state.device.sendAddBroadcastReqV2
  };
};

var mapDispatchToProps = {
  sendCmd: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].sendAddBroadcastReqV2
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(AddBroadcastReqV2)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loraactions_device__ = __webpack_require__(43);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);











var propTypes = {
  sent: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  sendCmd: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getTxSize: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getMacLog: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var DevStatusReq = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DevStatusReq, _React$Component);

  function DevStatusReq(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DevStatusReq);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      errors: new __WEBPACK_IMPORTED_MODULE_10_lorautils_errors_ErrorSet__["a" /* default */]()
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.macview');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }

  DevStatusReq.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var sent = nextProps.sent;
    var errors = this.state.errors;


    if (sent !== this.props.sent) {
      this.setState({ sentStatus: sent.status });
      if (sent.status === 'failure') {
        errors = errors.add(sent.error.code, 'submit');
        this.setState({ errors: errors });
      }
      if (sent.status === 'success') {
        var getTxSize = nextProps.getTxSize,
            getMacLog = nextProps.getMacLog,
            deviceId = nextProps.deviceId;

        getTxSize(deviceId);
        getMacLog(deviceId);
      }
    }
  };

  DevStatusReq.prototype.handleSubmit = function handleSubmit(e) {
    e.preventDefault();

    var errors = this.state.errors;

    if (!errors.isEmpty()) {
      return;
    }

    var _props = this.props,
        deviceId = _props.deviceId,
        sendCmd = _props.sendCmd;
    var maxdc = this.state.maxdc;

    sendCmd(deviceId, { maxdc: maxdc });
  };

  DevStatusReq.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        _state$sentStatus = _state.sentStatus,
        sentStatus = _state$sentStatus === undefined ? '' : _state$sentStatus,
        errors = _state.errors;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Form"],
      { horizontal: true, onSubmit: this.handleSubmit },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__["a" /* default */], {
            status: sentStatus,
            states: [{
              status: 'default',
              label: this.intlMsg.msg('submit'),
              style: 'primary',
              type: 'submit'
            }, {
              status: 'success',
              label: this.intlMsg.msg('submit.success'),
              style: 'success',
              timer: function timer() {
                return _this2.setState({ sentStatus: '' });
              }
            }, {
              status: 'failure',
              label: this.intlMsg.msg('submit.failure'),
              style: 'danger',
              timer: function timer() {
                return _this2.setState({ sentStatus: '' });
              }
            }]
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__["a" /* default */], {
            show: errors.has('submit'),
            message: this.intlMsg.errorMsg(errors.get('submit')),
            azStyle: "danger"
          })
        )
      )
    );
  };

  return DevStatusReq;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DevStatusReq.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    sent: state.device.sendDevStatusReq
  };
};

var mapDispatchToProps = {
  sendCmd: __WEBPACK_IMPORTED_MODULE_11_loraactions_device__["a" /* default */].sendDevStatusReq,
  getTxSize: __WEBPACK_IMPORTED_MODULE_11_loraactions_device__["a" /* default */].getMacTxSize,
  getMacLog: __WEBPACK_IMPORTED_MODULE_11_loraactions_device__["a" /* default */].getMacLog
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(DevStatusReq)));

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__ = __webpack_require__(62);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var kTargetPatterns = [{
  pattern: /.*freq.*/i,
  target: 'freq'
}];

var guessTarget = function guessTarget(message) {
  var hit = _.find(kTargetPatterns, function (p) {
    return p.pattern.test(message);
  });
  if (hit) {
    return hit.target;
  }
  return 'submit';
};

var propTypes = {
  sent: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  sendCmd: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getTxSize: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getMacLog: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var DlChannelReq = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DlChannelReq, _React$Component);

  function DlChannelReq(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DlChannelReq);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      errors: new __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__["a" /* default */]().add('FE_EMPTY', 'chindex').add('FE_EMPTY', 'freq')
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.macview');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleChangeChIndex = _this.handleChangeChIndex.bind(_this);
    _this.handleChangeFreq = _this.handleChangeFreq.bind(_this);
    return _this;
  }

  DlChannelReq.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var sent = nextProps.sent;
    var errors = this.state.errors;


    if (sent !== this.props.sent) {
      this.setState({ sentStatus: sent.status });
      if (sent.status === 'failure') {
        errors = errors.add(sent.error.code, guessTarget(sent.error.message));
        this.setState({ errors: errors });
        _.delay(function () {
          _this2.setState({
            errors: _this2.state.errors.remove('submit')
          });
        }, 3000);
      }
      if (sent.status === 'success') {
        var getTxSize = nextProps.getTxSize,
            getMacLog = nextProps.getMacLog,
            deviceId = nextProps.deviceId;

        getTxSize(deviceId);
        getMacLog(deviceId);
      }
    }
  };

  DlChannelReq.prototype.handleChangeChIndex = function handleChangeChIndex(e) {
    var chindex = e.target.value.trim();
    this.setState({ chindex: chindex });

    var errors = this.state.errors;


    if (chindex === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'chindex') });
      return;
    }
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["b" /* isInteger */])(chindex, { min: 0, max: 15 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'chindex') });
      return;
    }
    this.setState({ errors: errors.remove('chindex') });
  };

  DlChannelReq.prototype.handleChangeFreq = function handleChangeFreq(e) {
    var freq = e.target.value.trim();
    this.setState({ freq: freq });

    var errors = this.state.errors;


    if (freq === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'freq') });
      return;
    }
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["b" /* isInteger */])(freq)) {
      this.setState({ errors: errors.add('FE_INVALID', 'freq') });
      return;
    }
    this.setState({ errors: errors.remove('freq') });
  };

  DlChannelReq.prototype.handleSubmit = function handleSubmit(e) {
    this.setState({ submitted: true });
    e.preventDefault();

    var errors = this.state.errors;

    if (!errors.isEmpty()) {
      return;
    }

    var _props = this.props,
        deviceId = _props.deviceId,
        sendCmd = _props.sendCmd;
    var _state = this.state,
        chindex = _state.chindex,
        freq = _state.freq;

    sendCmd(deviceId, { chindex: chindex, freq: freq });
  };

  DlChannelReq.prototype.render = function render() {
    var _this3 = this;

    var _state2 = this.state,
        _state2$sentStatus = _state2.sentStatus,
        sentStatus = _state2$sentStatus === undefined ? '' : _state2$sentStatus,
        _state2$chindex = _state2.chindex,
        chindex = _state2$chindex === undefined ? '' : _state2$chindex,
        _state2$freq = _state2.freq,
        freq = _state2$freq === undefined ? '' : _state2$freq,
        errors = _state2.errors,
        _state2$submitted = _state2.submitted,
        submitted = _state2$submitted === undefined ? false : _state2$submitted;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Form"],
      { horizontal: true, onSubmit: this.handleSubmit },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('chindex') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            "ChIndex"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: chindex,
            placeholder: this.intlMsg.msg('dlchannelreq.chindex.placeholder'),
            onChange: this.handleChangeChIndex
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('chindex'),
            message: this.intlMsg.errorMsg(errors.get('chindex')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('freq') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            "Frequency"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: freq,
            placeholder: this.intlMsg.msg('dlchannelreq.freq.placeholder'),
            onChange: this.handleChangeFreq
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('freq'),
            message: this.intlMsg.errorMsg(errors.get('freq')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__["a" /* default */], {
            status: sentStatus,
            states: [{
              status: 'default',
              label: this.intlMsg.msg('submit'),
              style: 'primary',
              type: 'submit'
            }, {
              status: 'success',
              label: this.intlMsg.msg('submit.success'),
              style: 'success',
              timer: function timer() {
                return _this3.setState({ sentStatus: '' });
              }
            }, {
              status: 'failure',
              label: this.intlMsg.msg('submit.failure'),
              style: 'danger',
              timer: function timer() {
                return _this3.setState({ sentStatus: '' });
              }
            }]
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__["a" /* default */], {
            show: errors.has('submit'),
            message: this.intlMsg.errorMsg(errors.get('submit')),
            azStyle: "danger"
          })
        )
      )
    );
  };

  return DlChannelReq;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DlChannelReq.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    sent: state.device.sendDlChannelReq
  };
};

var mapDispatchToProps = {
  sendCmd: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].sendDlChannelReq,
  getTxSize: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].getMacTxSize,
  getMacLog: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].getMacLog
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(DlChannelReq)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__ = __webpack_require__(62);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var propTypes = {
  sent: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  sendCmd: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getTxSize: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getMacLog: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var DutyCycleReq = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DutyCycleReq, _React$Component);

  function DutyCycleReq(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DutyCycleReq);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      errors: new __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__["a" /* default */]().add('FE_EMPTY', 'maxdc')
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.macview');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleChangeMaxdc = _this.handleChangeMaxdc.bind(_this);
    return _this;
  }

  DutyCycleReq.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var sent = nextProps.sent;
    var errors = this.state.errors;


    if (sent !== this.props.sent) {
      this.setState({ sentStatus: sent.status });
      if (sent.status === 'failure') {
        errors = errors.add(sent.error.code, 'submit');
        this.setState({ errors: errors });
      }
      if (sent.status === 'success') {
        var getTxSize = nextProps.getTxSize,
            getMacLog = nextProps.getMacLog,
            deviceId = nextProps.deviceId;

        getTxSize(deviceId);
        getMacLog(deviceId);
      }
    }
  };

  DutyCycleReq.prototype.handleChangeMaxdc = function handleChangeMaxdc(e) {
    var maxdc = e.target.value.trim();
    this.setState({ maxdc: maxdc });

    var errors = this.state.errors;


    if (maxdc === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'maxdc') });
      return;
    }
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["b" /* isInteger */])(maxdc, { min: 0, max: 15 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'maxdc') });
      return;
    }
    this.setState({ errors: errors.remove('maxdc') });
  };

  DutyCycleReq.prototype.handleSubmit = function handleSubmit(e) {
    this.setState({ submitted: true });
    e.preventDefault();

    var errors = this.state.errors;

    if (!errors.isEmpty()) {
      return;
    }

    var _props = this.props,
        deviceId = _props.deviceId,
        sendCmd = _props.sendCmd;
    var maxdc = this.state.maxdc;

    sendCmd(deviceId, { maxdc: maxdc });
  };

  DutyCycleReq.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        _state$sentStatus = _state.sentStatus,
        sentStatus = _state$sentStatus === undefined ? '' : _state$sentStatus,
        _state$maxdc = _state.maxdc,
        maxdc = _state$maxdc === undefined ? '' : _state$maxdc,
        errors = _state.errors,
        _state$submitted = _state.submitted,
        submitted = _state$submitted === undefined ? false : _state$submitted;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Form"],
      { horizontal: true, onSubmit: this.handleSubmit },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('maxdc') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            "MaxDutyCycle"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: maxdc,
            placeholder: this.intlMsg.msg('dutycyclereq.maxdc.placeholder'),
            onChange: this.handleChangeMaxdc
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('maxdc'),
            message: this.intlMsg.errorMsg(errors.get('maxdc')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__["a" /* default */], {
            status: sentStatus,
            states: [{
              status: 'default',
              label: this.intlMsg.msg('submit'),
              style: 'primary',
              type: 'submit'
            }, {
              status: 'success',
              label: this.intlMsg.msg('submit.success'),
              style: 'success',
              timer: function timer() {
                return _this2.setState({ sentStatus: '' });
              }
            }, {
              status: 'failure',
              label: this.intlMsg.msg('submit.failure'),
              style: 'danger',
              timer: function timer() {
                return _this2.setState({ sentStatus: '' });
              }
            }]
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__["a" /* default */], {
            show: errors.has('submit'),
            message: this.intlMsg.errorMsg(errors.get('submit')),
            azStyle: "danger"
          })
        )
      )
    );
  };

  return DutyCycleReq;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DutyCycleReq.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    sent: state.device.sendDutyCycleReq
  };
};

var mapDispatchToProps = {
  sendCmd: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].sendDutyCycleReq,
  getTxSize: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].getMacTxSize,
  getMacLog: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].getMacLog
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(DutyCycleReq)));

/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__ = __webpack_require__(62);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var propTypes = {
  sent: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  sendCmd: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getTxSize: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getMacLog: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var LinkADRReq = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(LinkADRReq, _React$Component);

  function LinkADRReq(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LinkADRReq);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      errors: new __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__["a" /* default */]().add('FE_EMPTY', 'datarate').add('FE_EMPTY', 'txpower').add('FE_EMPTY', 'chmask').add('FE_EMPTY', 'chmaskcntl').add('FE_EMPTY', 'nbtrans')
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.macview');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleChangeDataRate = _this.handleChangeDataRate.bind(_this);
    _this.handleChangeTxPower = _this.handleChangeTxPower.bind(_this);
    _this.handleChangeChMask = _this.handleChangeChMask.bind(_this);
    _this.handleChangeChMaskCntl = _this.handleChangeChMaskCntl.bind(_this);
    _this.handleChangeNbtrans = _this.handleChangeNbtrans.bind(_this);
    return _this;
  }

  LinkADRReq.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var sent = nextProps.sent;
    var errors = this.state.errors;


    if (sent !== this.props.sent) {
      this.setState({ sentStatus: sent.status });
      if (sent.status === 'failure') {
        errors = errors.add(sent.error.code, 'submit');
        this.setState({ errors: errors });
      }
      if (sent.status === 'success') {
        var getTxSize = nextProps.getTxSize,
            getMacLog = nextProps.getMacLog,
            deviceId = nextProps.deviceId;

        getTxSize(deviceId);
        getMacLog(deviceId);
      }
    }
  };

  LinkADRReq.prototype.handleChangeDataRate = function handleChangeDataRate(e) {
    var datarate = e.target.value.trim();
    this.setState({ datarate: datarate });

    var errors = this.state.errors;


    if (datarate === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'datarate') });
      return;
    }
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["b" /* isInteger */])(datarate, { min: 0, max: 15 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'datarate') });
      return;
    }
    this.setState({ errors: errors.remove('datarate') });
  };

  LinkADRReq.prototype.handleChangeTxPower = function handleChangeTxPower(e) {
    var txpower = e.target.value.trim();
    this.setState({ txpower: txpower });

    var errors = this.state.errors;


    if (txpower === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'txpower') });
      return;
    }
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["b" /* isInteger */])(txpower, { min: 0, max: 15 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'txpower') });
      return;
    }
    this.setState({ errors: errors.remove('txpower') });
  };

  LinkADRReq.prototype.handleChangeChMask = function handleChangeChMask(e) {
    var chmask = e.target.value.trim();
    this.setState({ chmask: chmask });

    var errors = this.state.errors;


    if (chmask === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'chmask') });
      return;
    }
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["b" /* isInteger */])(chmask, { min: 0, max: 65535 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'chmask') });
      return;
    }
    this.setState({ errors: errors.remove('chmask') });
  };

  LinkADRReq.prototype.handleChangeChMaskCntl = function handleChangeChMaskCntl(e) {
    var chmaskcntl = e.target.value.trim();
    this.setState({ chmaskcntl: chmaskcntl });

    var errors = this.state.errors;


    if (chmaskcntl === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'chmaskcntl') });
      return;
    }
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["b" /* isInteger */])(chmaskcntl, { min: 0, max: 7 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'chmaskcntl') });
      return;
    }
    this.setState({ errors: errors.remove('chmaskcntl') });
  };

  LinkADRReq.prototype.handleChangeNbtrans = function handleChangeNbtrans(e) {
    var nbtrans = e.target.value.trim();
    this.setState({ nbtrans: nbtrans });

    var errors = this.state.errors;


    if (nbtrans === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'nbtrans') });
      return;
    }
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["b" /* isInteger */])(nbtrans, { min: 0, max: 15 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'nbtrans') });
      return;
    }
    this.setState({ errors: errors.remove('nbtrans') });
  };

  LinkADRReq.prototype.handleSubmit = function handleSubmit(e) {
    this.setState({ submitted: true });
    e.preventDefault();

    var errors = this.state.errors;

    if (!errors.isEmpty()) {
      return;
    }

    var _props = this.props,
        deviceId = _props.deviceId,
        sendCmd = _props.sendCmd;
    var _state = this.state,
        datarate = _state.datarate,
        txpower = _state.txpower,
        chmask = _state.chmask,
        chmaskcntl = _state.chmaskcntl,
        nbtrans = _state.nbtrans;

    sendCmd(deviceId, {
      datarate: datarate,
      txpower: txpower,
      chmask: chmask,
      chmaskcntl: chmaskcntl,
      nbtrans: nbtrans
    });
  };

  LinkADRReq.prototype.render = function render() {
    var _this2 = this;

    var _state2 = this.state,
        _state2$sentStatus = _state2.sentStatus,
        sentStatus = _state2$sentStatus === undefined ? '' : _state2$sentStatus,
        _state2$datarate = _state2.datarate,
        datarate = _state2$datarate === undefined ? '' : _state2$datarate,
        _state2$txpower = _state2.txpower,
        txpower = _state2$txpower === undefined ? '' : _state2$txpower,
        _state2$chmask = _state2.chmask,
        chmask = _state2$chmask === undefined ? '' : _state2$chmask,
        _state2$chmaskcntl = _state2.chmaskcntl,
        chmaskcntl = _state2$chmaskcntl === undefined ? '' : _state2$chmaskcntl,
        _state2$nbtrans = _state2.nbtrans,
        nbtrans = _state2$nbtrans === undefined ? '' : _state2$nbtrans,
        errors = _state2.errors,
        _state2$submitted = _state2.submitted,
        submitted = _state2$submitted === undefined ? false : _state2$submitted;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Form"],
      { horizontal: true, onSubmit: this.handleSubmit },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('datarate') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            "DataRate"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: datarate,
            placeholder: this.intlMsg.msg('linkadrreq.datarate.placeholder'),
            onChange: this.handleChangeDataRate
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('datarate'),
            message: this.intlMsg.errorMsg(errors.get('datarate')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('txpower') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            "TX Power"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: txpower,
            placeholder: this.intlMsg.msg('linkadrreq.txpower.placeholder'),
            onChange: this.handleChangeTxPower
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('txpower'),
            message: this.intlMsg.errorMsg(errors.get('txpower')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('chmask') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            "ChMask"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: chmask,
            placeholder: this.intlMsg.msg('linkadrreq.chmask.placeholder'),
            onChange: this.handleChangeChMask
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('chmask'),
            message: this.intlMsg.errorMsg(errors.get('chmask')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('chmaskcntl') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            "ChMaskCntl"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: chmaskcntl,
            placeholder: this.intlMsg.msg('linkadrreq.chmaskcntl.placeholder'),
            onChange: this.handleChangeChMaskCntl
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('chmaskcntl'),
            message: this.intlMsg.errorMsg(errors.get('chmaskcntl')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('nbtrans') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            "NbTrans"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: nbtrans,
            placeholder: this.intlMsg.msg('linkadrreq.nbtrans.placeholder'),
            onChange: this.handleChangeNbtrans
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('nbtrans'),
            message: this.intlMsg.errorMsg(errors.get('nbtrans')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__["a" /* default */], {
            status: sentStatus,
            states: [{
              status: 'default',
              label: this.intlMsg.msg('submit'),
              style: 'primary',
              type: 'submit'
            }, {
              status: 'success',
              label: this.intlMsg.msg('submit.success'),
              style: 'success',
              timer: function timer() {
                return _this2.setState({ sentStatus: '' });
              }
            }, {
              status: 'failure',
              label: this.intlMsg.msg('submit.failure'),
              style: 'danger',
              timer: function timer() {
                return _this2.setState({ sentStatus: '' });
              }
            }]
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__["a" /* default */], {
            show: errors.has('submit'),
            message: this.intlMsg.errorMsg(errors.get('submit')),
            azStyle: "danger"
          })
        )
      )
    );
  };

  return LinkADRReq;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

LinkADRReq.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    sent: state.device.sendLinkADRReq
  };
};

var mapDispatchToProps = {
  sendCmd: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].sendLinkADRReq,
  getTxSize: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].getMacTxSize,
  getMacLog: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].getMacLog
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(LinkADRReq)));

/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_scss__ = __webpack_require__(2241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);






var kEnHelps = {
  RXParamSetupReq: 'Sets the reception slots parameters.',
  TXParamSetupReq: 'Used by the network server to set the maximum allowed dwell time and Max EIRP of end-device, based on local regulations',
  DevStatusReq: 'Requests the status of the end-device.',
  NewChannelReq: 'Creates or modifies the definition of a radio channel.',
  RXTimingSetupReq: 'Sets the timing of the of the reception slots',
  LinkADRReq: 'Requests the end-device to change data rate, transmit power, repetition rate or channel.',
  DutyCycleReq: 'Sets the maximum aggregated transmit duty-cycle of a device.',
  DLChannelReq: 'Modifies the definition of a downlink RX1 radio channel by shifting the downlink frequency from the uplink frequencies (i.e. creating an asymmetric channel)',
  UpdChPlanReq: 'Send channel plan to the device(AISenz Inc. exclusive command, required AISenz module supported)',
  AddBroadcastReq: 'Add Broadcast(AISenz Inc. exclusive command, required AISenz module supported)',
  RemoveBroadcastReq: 'Remove Broadcast(AISenz Inc. exclusive command, required AISenz module supported)',
  UpdChPlanReqV2: 'Applies to 3.0.0 and later versions',
  AddBroadcastReqV2: 'Applies to 3.0.0 and later versions',
  RemoveBroadcastReqV2: 'Applies to 3.0.0 and later versions'
};

var kZhHelps = {
  RXParamSetupReq: '设置接收窗口参数。',
  TXParamSetupReq: '用于 network server 设置终端设备的最大允许驻留时间和最大EIRP, 基于当地的管制',
  DevStatusReq: '请求终端设备的状态。',
  NewChannelReq: '创建或修改无线信道的定义。',
  RXTimingSetupReq: '设置接收窗口的时机。',
  LinkADRReq: '请求终端设备修改速率、传输功率、重发速率或信道。',
  DutyCycleReq: '设置设备的最大聚合发射占空比。',
  DLChannelReq: '通过从上行链路频点平移到下行链路频点（譬如创建一个非对称信道）来修改一个下行RX1无线信道的定义',
  UpdChPlanReq: '向设备发送信道计划（艾森智能专属命令，需艾森模组支持）',
  AddBroadcastReq: '添加广播（艾森智能专属命令，需艾森模组支持）',
  RemoveBroadcastReq: '删除广播（艾森智能专属命令，需艾森模组支持）',
  UpdChPlanReqV2: '适用于3.0.0以后的版本',
  AddBroadcastReqV2: '适用于3.0.0以后的版本',
  RemoveBroadcastReqV2: '适用于3.0.0以后的版本'
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  command: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired
};

var MacHelp = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(MacHelp, _React$Component);

  function MacHelp(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MacHelp);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      command: props.command
    };
    return _this;
  }

  MacHelp.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var command = nextProps.command;

    if (command !== this.props.command) {
      this.setState({ command: command });
    }
  };

  MacHelp.prototype.render = function render() {
    var locale = this.props.intl.locale;
    var command = this.state.command;

    var helpDict = kEnHelps;
    if (locale === 'zh') {
      helpDict = kZhHelps;
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.help },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default.a,
        {
          transitionName: {
            appear: __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.appear,
            appearActive: __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.appearActive,
            enter: __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.enter,
            enterActive: __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.enterActive
          },
          transitionAppear: true,
          transitionAppearTimeout: 1000,
          transitionEnterTimeout: 1000,
          transitionLeave: false
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "span",
          { key: command },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-info-circle" }),
          ' ',
          helpDict[command]
        )
      )
    );
  };

  return MacHelp;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

MacHelp.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(MacHelp));

/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_sub_days__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_sub_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_sub_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_start_of_day__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_start_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_start_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_day__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_add_days__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_add_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_is_after__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_is_after___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_is_after__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_is_before__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_is_before___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns_is_before__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_min__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_date_fns_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loracoms_DatePicker__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_loracoms_PageSizer__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_loracoms_PanelToolbar__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_loracoms_Refresher__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_loracoms_CollapseToggle__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__styles_scss__ = __webpack_require__(2242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);


























function defaultFrom() {
  return __WEBPACK_IMPORTED_MODULE_7_date_fns_start_of_day___default()(__WEBPACK_IMPORTED_MODULE_6_date_fns_sub_days___default()(new Date(), 1));
}

function defaultTo() {
  return __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_day___default()(new Date());
}

var kCommandLabelEnum = [{
  content: 'RXParamSetupReq',
  theme: 'blue'
}, {
  content: 'RXParamSetupAns',
  theme: 'blue'
}, {
  content: 'DutyCycleReq',
  theme: 'red'
}, {
  content: 'DutyCycleAns',
  theme: 'red'
}, {
  content: 'DevStatusReq',
  theme: 'yellow'
}, {
  content: 'DevStatusAns',
  theme: 'yellow'
}, {
  content: 'LinkADRReq',
  theme: 'green'
}, {
  content: 'LinkADRAns',
  theme: 'green'
}, {
  content: 'RXTimingSetupReq',
  theme: 'blue'
}, {
  content: 'RXTimingSetupAns',
  theme: 'blue'
}, {
  content: 'NewChannelReq',
  theme: 'red'
}, {
  content: 'NewChannelAns',
  theme: 'red'
}];

var kFixedKeys = ['$time', 'appeui', 'args', 'deveui', 'name', 'org'];

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  getMacLog: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  macLog: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired
};

var MacLog = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(MacLog, _React$Component);

  MacLog.handleDisableDate = function handleDisableDate(d, from) {
    return __WEBPACK_IMPORTED_MODULE_10_date_fns_is_after___default()(d, __WEBPACK_IMPORTED_MODULE_12_date_fns_min___default()(__WEBPACK_IMPORTED_MODULE_9_date_fns_add_days___default()(from, 7), new Date())) || __WEBPACK_IMPORTED_MODULE_11_date_fns_is_before___default()(d, from);
  };

  function MacLog(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MacLog);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      macLog: props.macLog,
      pageSize: 10
    };
    _this.handleChangePageSize = _this.handleChangePageSize.bind(_this);
    _this.handleChangeFrom = _this.handleChangeFrom.bind(_this);
    _this.handleChangeTo = _this.handleChangeTo.bind(_this);
    _this.handleReload = _this.handleReload.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_23_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.macview.maclog');
    return _this;
  }

  MacLog.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        deviceId = _props.deviceId,
        getMacLog = _props.getMacLog;
    var _state = this.state,
        _state$from = _state.from,
        from = _state$from === undefined ? defaultFrom() : _state$from,
        _state$to = _state.to,
        to = _state$to === undefined ? defaultTo() : _state$to,
        pageSize = _state.pageSize;


    getMacLog(deviceId, {
      after: from.valueOf(),
      before: to.valueOf(),
      limit: pageSize
    });
  };

  MacLog.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var macLog = nextProps.macLog;

    if (macLog !== this.props.macLog) {
      this.setState({ macLog: macLog });
      if (macLog.status === 'success') {
        this.setState({
          list: macLog.data.list
        });
      }
    }
  };

  MacLog.prototype.handleChangePageSize = function handleChangePageSize(pageSize) {
    this.setState({ pageSize: pageSize });

    var _props2 = this.props,
        getMacLog = _props2.getMacLog,
        deviceId = _props2.deviceId;
    var _state2 = this.state,
        _state2$from = _state2.from,
        from = _state2$from === undefined ? defaultFrom() : _state2$from,
        _state2$to = _state2.to,
        to = _state2$to === undefined ? defaultTo() : _state2$to;

    getMacLog(deviceId, {
      after: from.valueOf(),
      before: to.valueOf(),
      limit: pageSize
    });
  };

  MacLog.prototype.handleChangeFrom = function handleChangeFrom(from) {
    var to = __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_day___default()(from);
    this.setState({ from: __WEBPACK_IMPORTED_MODULE_7_date_fns_start_of_day___default()(from), to: to });
    var _props3 = this.props,
        getMacLog = _props3.getMacLog,
        deviceId = _props3.deviceId;
    var pageSize = this.state.pageSize;

    getMacLog(deviceId, {
      after: __WEBPACK_IMPORTED_MODULE_7_date_fns_start_of_day___default()(from).valueOf(),
      before: to.valueOf(),
      limit: pageSize
    });
  };

  MacLog.prototype.handleChangeTo = function handleChangeTo(to) {
    this.setState({ to: __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_day___default()(to) });
    var _props4 = this.props,
        getMacLog = _props4.getMacLog,
        deviceId = _props4.deviceId;
    var _state3 = this.state,
        pageSize = _state3.pageSize,
        _state3$from = _state3.from,
        from = _state3$from === undefined ? defaultFrom() : _state3$from;

    getMacLog(deviceId, {
      after: from.valueOf(),
      before: __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_day___default()(to).valueOf(),
      limit: pageSize
    });
  };

  MacLog.prototype.handleReload = function handleReload() {
    var _props5 = this.props,
        getMacLog = _props5.getMacLog,
        deviceId = _props5.deviceId;
    var _state4 = this.state,
        _state4$from = _state4.from,
        from = _state4$from === undefined ? defaultFrom() : _state4$from,
        _state4$to = _state4.to,
        to = _state4$to === undefined ? defaultTo() : _state4$to,
        pageSize = _state4.pageSize;

    getMacLog(deviceId, {
      after: from.valueOf(),
      before: to.valueOf(),
      limit: pageSize
    });
  };

  MacLog.prototype.render = function render() {
    var _this2 = this;

    var _state5 = this.state,
        pageSize = _state5.pageSize,
        macLog = _state5.macLog,
        _state5$expanded = _state5.expanded,
        expanded = _state5$expanded === undefined ? true : _state5$expanded,
        _state5$from = _state5.from,
        from = _state5$from === undefined ? defaultFrom() : _state5$from,
        _state5$to = _state5.to,
        to = _state5$to === undefined ? defaultTo() : _state5$to;


    var header = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      null,
      this.intlMsg.msg('maclog'),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "ul",
        { className: "icontools" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_loracoms_Refresher__["a" /* default */], {
            onReload: this.handleReload,
            reloading: macLog.status === 'pending'
          })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_loracoms_CollapseToggle__["a" /* default */], {
            expanded: expanded,
            onChange: function onChange(v) {
              _this2.setState({ expanded: v });
            }
          })
        )
      )
    );

    var fromPicker = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_DatePicker__["a" /* default */], {
      date: from,
      onSelect: this.handleChangeFrom
    });
    var toPicker = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_DatePicker__["a" /* default */], {
      date: to,
      onSelect: this.handleChangeTo,
      disabled: function disabled(d) {
        return MacLog.handleDisableDate(d, from);
      }
    });

    var _state$list = this.state.list,
        list = _state$list === undefined ? [] : _state$list;

    var extraKeys = _.uniq(_.flatMap(list, function (r) {
      var _ref;

      return (_ref = _).without.apply(_ref, [_.keys(r)].concat(kFixedKeys));
    }));

    var rows = list.map(function (r, idx) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "tr",
        { key: r.$time + "-" + r.name + "-" + idx },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_5_date_fns_format___default()(r.$time, 'YYYY-MM-DD HH:mm:ss')
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_RichLabel__["a" /* default */], { content: r.name, enums: kCommandLabelEnum })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "ul",
            { className: __WEBPACK_IMPORTED_MODULE_25__styles_scss___default.a.parameter },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "li",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "span",
                { className: __WEBPACK_IMPORTED_MODULE_25__styles_scss___default.a.raw },
                _.toUpper(r.args)
              )
            ),
            extraKeys.map(function (k) {
              if (_.has(r, k)) {
                return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "li",
                  { key: k },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: __WEBPACK_IMPORTED_MODULE_25__styles_scss___default.a.parsed },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: __WEBPACK_IMPORTED_MODULE_25__styles_scss___default.a.key },
                      k
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "span",
                      { className: __WEBPACK_IMPORTED_MODULE_25__styles_scss___default.a.value },
                      String(r[k])
                    )
                  )
                );
              }
              return null;
            })
          )
        )
      );
    });

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_16_react_bootstrap__["Panel"],
      {
        bsStyle: "aisz-white",
        header: header,
        collapsible: true,
        expanded: expanded
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_loracoms_PanelToolbar__["a" /* default */], { tools: [fromPicker, toPicker] }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_16_react_bootstrap__["Table"],
        { className: "aisz-table-light", striped: true, hover: true, bordered: true, responsive: true },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('time')
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('maccommand')
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('parameter')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "tbody",
          null,
          rows
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: "pull-right" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_loracoms_PageSizer__["a" /* default */], {
          pageSize: pageSize,
          onChange: this.handleChangePageSize,
          options: [10, 20, 50, 100, 500]
        })
      )
    );
  };

  return MacLog;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

MacLog.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    macLog: state.device.getMacLog
  };
};

var mapDispatchToProps = {
  getMacLog: __WEBPACK_IMPORTED_MODULE_24_loraactions_device__["a" /* default */].getMacLog,
  pushState: __WEBPACK_IMPORTED_MODULE_13_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_react_intl__["injectIntl"])(MacLog)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__ = __webpack_require__(62);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var kTargetPatterns = [{
  pattern: /.*freq.*/i,
  target: 'freq'
}, {
  pattern: /.*MinDR.*/i,
  target: 'mindr'
}, {
  pattern: /.*MaxDR.*/i,
  target: 'maxdr'
}];

var guessTarget = function guessTarget(message) {
  var hit = _.find(kTargetPatterns, function (p) {
    return p.pattern.test(message);
  });
  if (hit) {
    return hit.target;
  }
  return 'submit';
};

var propTypes = {
  sent: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  sendCmd: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getTxSize: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getMacLog: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var NewChannelReq = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(NewChannelReq, _React$Component);

  function NewChannelReq(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NewChannelReq);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      errors: new __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__["a" /* default */]().add('FE_EMPTY', 'chindex').add('FE_EMPTY', 'freq').add('FE_EMPTY', 'mindr').add('FE_EMPTY', 'maxdr')
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.macview');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleChangeChIndex = _this.handleChangeChIndex.bind(_this);
    _this.handleChangeFreq = _this.handleChangeFreq.bind(_this);
    _this.handleChangeMinDR = _this.handleChangeMinDR.bind(_this);
    _this.handleChangeMaxDR = _this.handleChangeMaxDR.bind(_this);
    return _this;
  }

  NewChannelReq.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var sent = nextProps.sent;
    var errors = this.state.errors;


    if (sent !== this.props.sent) {
      this.setState({ sentStatus: sent.status });
      if (sent.status === 'failure') {
        errors = errors.add(sent.error.code, guessTarget(sent.error.message));
        this.setState({ errors: errors });
      }
      if (sent.status === 'success') {
        var getTxSize = nextProps.getTxSize,
            getMacLog = nextProps.getMacLog,
            deviceId = nextProps.deviceId;

        getTxSize(deviceId);
        getMacLog(deviceId);
      }
    }
  };

  NewChannelReq.prototype.handleChangeChIndex = function handleChangeChIndex(e) {
    var chindex = e.target.value.trim();
    this.setState({ chindex: chindex });

    var errors = this.state.errors;


    if (chindex === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'chindex') });
      return;
    }
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["b" /* isInteger */])(chindex, { min: 0, max: 15 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'chindex') });
      return;
    }
    this.setState({ errors: errors.remove('chindex') });
  };

  NewChannelReq.prototype.handleChangeFreq = function handleChangeFreq(e) {
    var freq = e.target.value.trim();
    this.setState({ freq: freq });

    var errors = this.state.errors;


    if (freq === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'freq') });
      return;
    }
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["b" /* isInteger */])(freq, { min: 1000000, max: 1670000000 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'freq') });
      return;
    }
    this.setState({ errors: errors.remove('freq') });
  };

  NewChannelReq.prototype.handleChangeMinDR = function handleChangeMinDR(e) {
    var mindr = e.target.value.trim();
    var errors = this.state.errors;


    if (mindr === '') {
      this.setState({
        mindr: mindr,
        errors: errors.add('FE_EMPTY', 'mindr')
      });
    }
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["b" /* isInteger */])(mindr, { min: 0, max: 65535 })) {
      this.setState({
        mindr: mindr,
        errors: errors.add('FE_INVALID', 'mindr')
      });
    } else {
      this.setState({
        mindr: mindr,
        errors: errors.remove('mindr')
      });
    }
  };

  NewChannelReq.prototype.handleChangeMaxDR = function handleChangeMaxDR(e) {
    var maxdr = e.target.value.trim();
    var errors = this.state.errors;

    if (maxdr === '') {
      this.setState({
        maxdr: maxdr,
        errors: errors.add('FE_EMPTY', 'maxdr')
      });
    } else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["b" /* isInteger */])(maxdr, { min: 0, max: 7 })) {
      this.setState({
        maxdr: maxdr,
        errors: errors.add('FE_INVALID', 'maxdr')
      });
    } else {
      this.setState({
        maxdr: maxdr,
        errors: errors.remove('maxdr')
      });
    }
  };

  NewChannelReq.prototype.handleSubmit = function handleSubmit(e) {
    this.setState({ submitted: true });
    e.preventDefault();

    var errors = this.state.errors;

    if (!errors.isEmpty()) {
      return;
    }

    var _props = this.props,
        deviceId = _props.deviceId,
        sendCmd = _props.sendCmd;
    var _state = this.state,
        chindex = _state.chindex,
        freq = _state.freq,
        mindr = _state.mindr,
        maxdr = _state.maxdr;

    sendCmd(deviceId, {
      chindex: chindex,
      freq: freq,
      mindr: mindr,
      maxdr: maxdr
    });
  };

  NewChannelReq.prototype.render = function render() {
    var _this2 = this;

    var _state2 = this.state,
        _state2$sentStatus = _state2.sentStatus,
        sentStatus = _state2$sentStatus === undefined ? '' : _state2$sentStatus,
        _state2$chindex = _state2.chindex,
        chindex = _state2$chindex === undefined ? '' : _state2$chindex,
        _state2$freq = _state2.freq,
        freq = _state2$freq === undefined ? '' : _state2$freq,
        _state2$mindr = _state2.mindr,
        mindr = _state2$mindr === undefined ? '' : _state2$mindr,
        _state2$maxdr = _state2.maxdr,
        maxdr = _state2$maxdr === undefined ? '' : _state2$maxdr,
        errors = _state2.errors,
        _state2$submitted = _state2.submitted,
        submitted = _state2$submitted === undefined ? false : _state2$submitted;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Form"],
      { horizontal: true, onSubmit: this.handleSubmit },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('chindex') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            "Channel ID"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: chindex,
            placeholder: this.intlMsg.msg('newchannelreq.chindex.placeholder'),
            onChange: this.handleChangeChIndex
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('chindex'),
            message: this.intlMsg.errorMsg(errors.get('chindex')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('freq') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            "Frequency"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: freq,
            placeholder: this.intlMsg.msg('newchannelreq.freq.placeholder'),
            onChange: this.handleChangeFreq
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('freq'),
            message: this.intlMsg.errorMsg(errors.get('freq')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('mindr') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            "Min DR"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: mindr,
            placeholder: this.intlMsg.msg('newchannelreq.mindr.placeholder'),
            onChange: this.handleChangeMinDR
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('mindr'),
            message: this.intlMsg.errorMsg(errors.get('mindr')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('maxdr') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            "Max DR"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: maxdr,
            placeholder: this.intlMsg.msg('newchannelreq.maxdr.placeholder'),
            onChange: this.handleChangeMaxDR
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('maxdr'),
            message: this.intlMsg.errorMsg(errors.get('maxdr')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__["a" /* default */], {
            status: sentStatus,
            states: [{
              status: 'default',
              label: this.intlMsg.msg('submit'),
              style: 'primary',
              type: 'submit'
            }, {
              status: 'success',
              label: this.intlMsg.msg('submit.success'),
              style: 'success',
              timer: function timer() {
                return _this2.setState({ sentStatus: '' });
              }
            }, {
              status: 'failure',
              label: this.intlMsg.msg('submit.failure'),
              style: 'danger',
              timer: function timer() {
                _this2.setState({
                  sentStatus: '',
                  errors: _this2.state.errors.remove('submit')
                });
              }
            }]
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__["a" /* default */], {
            show: errors.has('submit'),
            message: this.intlMsg.errorMsg(errors.get('submit')),
            azStyle: "danger"
          })
        )
      )
    );
  };

  return NewChannelReq;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

NewChannelReq.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    sent: state.device.sendNewChannelReq
  };
};

var mapDispatchToProps = {
  sendCmd: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].sendNewChannelReq,
  getTxSize: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].getMacTxSize,
  getMacLog: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].getMacLog
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(NewChannelReq)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__ = __webpack_require__(62);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  sendCmd: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  sent: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var RemoveBroadcastReq = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(RemoveBroadcastReq, _React$Component);

  function RemoveBroadcastReq(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RemoveBroadcastReq);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      errors: new __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__["a" /* default */]().add('FE_EMPTY', 'devaddr')
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.macview');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }

  RemoveBroadcastReq.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var sent = nextProps.sent;

    this.setState({ sentStatus: sent.status });
  };

  RemoveBroadcastReq.prototype.checkAddr = function checkAddr(key, val) {
    var errors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.state.errors;

    if (val.length === 0) {
      return errors.add('FE_EMPTY', key);
    } else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["c" /* isHexString */])(val, { len: 8 })) {
      return errors.add('FE_INVALIDADDR', key, { message: this.intlMsg.errorMsg('FE_INVALIDADDR') });
    }
    return errors.remove(key);
  };

  RemoveBroadcastReq.prototype.handleChangeDevaddr = function handleChangeDevaddr(e) {
    var val = _.trim(e.target.value);
    val = val.replace(/:|-/g, '');
    var errors = this.state.errors;

    errors = this.checkAddr('devaddr', val, errors);
    this.setState({ errors: errors, devaddr: val });
  };

  RemoveBroadcastReq.prototype.handleSubmit = function handleSubmit(e) {
    this.setState({ submitted: true });
    e.preventDefault();

    var _state = this.state,
        errors = _state.errors,
        devaddr = _state.devaddr;

    if (!errors.isEmpty()) {
      return;
    }

    var _props = this.props,
        deviceId = _props.deviceId,
        sendCmd = _props.sendCmd;

    sendCmd(deviceId, {
      devaddr: devaddr
    });
  };

  RemoveBroadcastReq.prototype.render = function render() {
    var _this2 = this;

    var _state2 = this.state,
        _state2$sentStatus = _state2.sentStatus,
        sentStatus = _state2$sentStatus === undefined ? '' : _state2$sentStatus,
        _state2$devaddr = _state2.devaddr,
        devaddr = _state2$devaddr === undefined ? '' : _state2$devaddr,
        errors = _state2.errors,
        _state2$submitted = _state2.submitted,
        submitted = _state2$submitted === undefined ? false : _state2$submitted;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Form"],
      { horizontal: true, onSubmit: this.handleSubmit },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('devaddr') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            this.intlMsg.msg('addbroadcastreq.address.label')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: devaddr,
            placeholder: this.intlMsg.msg('addbroadcastreq.devaddr.placeholder'),
            onChange: function onChange(e) {
              return _this2.handleChangeDevaddr(e);
            }
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('devaddr'),
            message: this.intlMsg.errorMsg(errors.get('devaddr')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__["a" /* default */], {
            status: sentStatus,
            states: [{
              status: 'default',
              label: this.intlMsg.msg('submit'),
              style: 'primary',
              type: 'submit'
            }, {
              status: 'success',
              label: this.intlMsg.msg('submit.success'),
              style: 'success',
              timer: function timer() {
                return _this2.setState({ sentStatus: '' });
              }
            }, {
              status: 'failure',
              label: this.intlMsg.msg('submit.failure'),
              style: 'danger',
              timer: function timer() {
                return _this2.setState({ sentStatus: '' });
              }
            }]
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__["a" /* default */], {
            show: errors.has('submit'),
            message: this.intlMsg.errorMsg(errors.get('submit')),
            azStyle: "danger"
          })
        )
      )
    );
  };

  return RemoveBroadcastReq;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

RemoveBroadcastReq.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    sent: state.device.RemoveBroadcastReq
  };
};

var mapDispatchToProps = {
  sendCmd: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].RemoveBroadcastReq
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(RemoveBroadcastReq)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__ = __webpack_require__(62);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  sendCmd: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  sent: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var RemoveBroadcastReqV2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(RemoveBroadcastReqV2, _React$Component);

  function RemoveBroadcastReqV2(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RemoveBroadcastReqV2);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      errors: new __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__["a" /* default */]().add('FE_EMPTY', 'devaddr')
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.macview');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }

  RemoveBroadcastReqV2.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var sent = nextProps.sent;

    this.setState({ sentStatus: sent.status });
  };

  RemoveBroadcastReqV2.prototype.checkAddr = function checkAddr(key, val) {
    var errors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.state.errors;

    if (val.length === 0) {
      return errors.add('FE_EMPTY', key);
    } else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["c" /* isHexString */])(val, { len: 8 })) {
      return errors.add('FE_INVALIDADDR', key, { message: this.intlMsg.errorMsg('FE_INVALIDADDR') });
    }
    return errors.remove(key);
  };

  RemoveBroadcastReqV2.prototype.handleChangeDevaddr = function handleChangeDevaddr(e) {
    var val = _.trim(e.target.value);
    val = val.replace(/:|-/g, '');
    var errors = this.state.errors;

    errors = this.checkAddr('devaddr', val, errors);
    this.setState({ errors: errors, devaddr: val });
  };

  RemoveBroadcastReqV2.prototype.handleSubmit = function handleSubmit(e) {
    this.setState({ submitted: true });
    e.preventDefault();

    var _state = this.state,
        errors = _state.errors,
        devaddr = _state.devaddr;

    if (!errors.isEmpty()) {
      return;
    }

    var _props = this.props,
        deviceId = _props.deviceId,
        sendCmd = _props.sendCmd;

    sendCmd(deviceId, {
      devaddr: devaddr
    });
  };

  RemoveBroadcastReqV2.prototype.render = function render() {
    var _this2 = this;

    var _state2 = this.state,
        _state2$sentStatus = _state2.sentStatus,
        sentStatus = _state2$sentStatus === undefined ? '' : _state2$sentStatus,
        _state2$devaddr = _state2.devaddr,
        devaddr = _state2$devaddr === undefined ? '' : _state2$devaddr,
        errors = _state2.errors,
        _state2$submitted = _state2.submitted,
        submitted = _state2$submitted === undefined ? false : _state2$submitted;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Form"],
      { horizontal: true, onSubmit: this.handleSubmit },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('devaddr') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            this.intlMsg.msg('addbroadcastreq.address.label')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: devaddr,
            placeholder: this.intlMsg.msg('addbroadcastreq.devaddr.placeholder'),
            onChange: function onChange(e) {
              return _this2.handleChangeDevaddr(e);
            }
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('devaddr'),
            message: this.intlMsg.errorMsg(errors.get('devaddr')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__["a" /* default */], {
            status: sentStatus,
            states: [{
              status: 'default',
              label: this.intlMsg.msg('submit'),
              style: 'primary',
              type: 'submit'
            }, {
              status: 'success',
              label: this.intlMsg.msg('submit.success'),
              style: 'success',
              timer: function timer() {
                return _this2.setState({ sentStatus: '' });
              }
            }, {
              status: 'failure',
              label: this.intlMsg.msg('submit.failure'),
              style: 'danger',
              timer: function timer() {
                return _this2.setState({ sentStatus: '' });
              }
            }]
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__["a" /* default */], {
            show: errors.has('submit'),
            message: this.intlMsg.errorMsg(errors.get('submit')),
            azStyle: "danger"
          })
        )
      )
    );
  };

  return RemoveBroadcastReqV2;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

RemoveBroadcastReqV2.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    sent: state.device.RemoveBroadcastReqV2
  };
};

var mapDispatchToProps = {
  sendCmd: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].RemoveBroadcastReqV2
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(RemoveBroadcastReqV2)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__ = __webpack_require__(62);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var kTargetPatterns = [{
  pattern: /.*freq.*/i,
  target: 'frequency'
}];

var guessTarget = function guessTarget(message) {
  var hit = _.find(kTargetPatterns, function (p) {
    return p.pattern.test(message);
  });
  if (hit) {
    return hit.target;
  }
  return 'submit';
};

var propTypes = {
  params: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  sent: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  getParams: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  sendCmd: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getTxSize: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getMacLog: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var RxParamSetupReq = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(RxParamSetupReq, _React$Component);

  function RxParamSetupReq(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RxParamSetupReq);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      errors: new __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__["a" /* default */]().add('FE_EMPTY', 'rx1droffset').add('FE_EMPTY', 'rx2dr').add('FE_EMPTY', 'frequency')
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.macview');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleChangeRx1DROffset = _this.handleChangeRx1DROffset.bind(_this);
    _this.handleChangeRx2DR = _this.handleChangeRx2DR.bind(_this);
    _this.handleChangeFrequency = _this.handleChangeFrequency.bind(_this);
    return _this;
  }

  RxParamSetupReq.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        deviceId = _props.deviceId,
        getParams = _props.getParams;

    getParams(deviceId);
  };

  RxParamSetupReq.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var params = nextProps.params,
        sent = nextProps.sent;
    var errors = this.state.errors;


    if (params !== this.props.params) {
      if (params.status === 'success') {
        var _params$data = params.data,
            _params$data$rx1droff = _params$data.rx1droffset,
            rx1droffset = _params$data$rx1droff === undefined ? '' : _params$data$rx1droff,
            _params$data$rx2dr = _params$data.rx2dr,
            rx2dr = _params$data$rx2dr === undefined ? '' : _params$data$rx2dr,
            _params$data$frequenc = _params$data.frequency,
            frequency = _params$data$frequenc === undefined ? '' : _params$data$frequenc;

        this.setState({
          rx1droffset: rx1droffset,
          rx2dr: rx2dr,
          frequency: frequency
        });

        if (String(rx1droffset) !== '') {
          errors = errors.remove('rx1droffset');
        }
        if (String(rx2dr) !== '') {
          errors = errors.remove('rx2dr');
        }
        if (String(frequency) !== '') {
          errors = errors.remove('frequency');
        }
        this.setState({ errors: errors });
      }
    }
    if (sent !== this.props.sent) {
      this.setState({ sentStatus: sent.status });
      if (sent.status === 'success') {
        var _props2 = this.props,
            deviceId = _props2.deviceId,
            getTxSize = _props2.getTxSize,
            getMacLog = _props2.getMacLog;

        getTxSize(deviceId);
        getMacLog(deviceId);
      } else if (sent.status === 'failure') {
        errors = errors.add(sent.error.code, guessTarget(sent.error.message));
        this.setState({ errors: errors });
      }
    }
  };

  RxParamSetupReq.prototype.handleChangeRx1DROffset = function handleChangeRx1DROffset(e) {
    var rx1droffset = e.target.value.trim();
    this.setState({ rx1droffset: rx1droffset });

    var errors = this.state.errors;


    if (rx1droffset === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'rx1droffset') });
      return;
    }
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["b" /* isInteger */])(rx1droffset, { min: 0, max: 5 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'rx1droffset') });
      return;
    }
    this.setState({ errors: errors.remove('rx1droffset') });
  };

  RxParamSetupReq.prototype.handleChangeRx2DR = function handleChangeRx2DR(e) {
    var rx2dr = e.target.value.trim();
    this.setState({ rx2dr: rx2dr });

    var errors = this.state.errors;


    if (rx2dr === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'rx2dr') });
      return;
    }
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["b" /* isInteger */])(rx2dr, { min: 0, max: 13 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'rx2dr') });
      return;
    }
    this.setState({ errors: errors.remove('rx2dr') });
  };

  RxParamSetupReq.prototype.handleChangeFrequency = function handleChangeFrequency(e) {
    var frequency = e.target.value.trim();
    this.setState({ frequency: frequency });

    var errors = this.state.errors;


    if (frequency === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'frequency') });
      return;
    }
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["b" /* isInteger */])(frequency, { min: 1000000, max: 1670000000 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'frequency') });
      return;
    }
    this.setState({ errors: errors.remove('frequency') });
  };

  RxParamSetupReq.prototype.handleSubmit = function handleSubmit(e) {
    this.setState({ submitted: true });
    e.preventDefault();

    var errors = this.state.errors;

    if (!errors.isEmpty()) {
      return;
    }

    var _props3 = this.props,
        deviceId = _props3.deviceId,
        sendCmd = _props3.sendCmd;
    var _state = this.state,
        rx1droffset = _state.rx1droffset,
        rx2dr = _state.rx2dr,
        frequency = _state.frequency;

    sendCmd(deviceId, {
      rx1droffset: rx1droffset,
      rx2dr: rx2dr,
      frequency: frequency
    });
  };

  RxParamSetupReq.prototype.render = function render() {
    var _this2 = this;

    var _state2 = this.state,
        _state2$sentStatus = _state2.sentStatus,
        sentStatus = _state2$sentStatus === undefined ? '' : _state2$sentStatus,
        _state2$rx1droffset = _state2.rx1droffset,
        rx1droffset = _state2$rx1droffset === undefined ? '' : _state2$rx1droffset,
        _state2$rx2dr = _state2.rx2dr,
        rx2dr = _state2$rx2dr === undefined ? '' : _state2$rx2dr,
        _state2$frequency = _state2.frequency,
        frequency = _state2$frequency === undefined ? '' : _state2$frequency,
        errors = _state2.errors,
        _state2$submitted = _state2.submitted,
        submitted = _state2$submitted === undefined ? false : _state2$submitted;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Form"],
      { horizontal: true, onSubmit: this.handleSubmit },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('rx1droffset') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            "RX1 DRoffset"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: rx1droffset,
            placeholder: this.intlMsg.msg('rxparamsetupreq.rx1droffset.placeholder'),
            onChange: this.handleChangeRx1DROffset
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('rx1droffset'),
            message: this.intlMsg.errorMsg(errors.get('rx1droffset')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('rx2dr') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            "RX2 DR"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: rx2dr,
            placeholder: this.intlMsg.msg('rxparamsetupreq.rx2dr.placeholder'),
            onChange: this.handleChangeRx2DR
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('rx2dr'),
            message: this.intlMsg.errorMsg(errors.get('rx2dr')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('frequency') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            "RX2 Frequency"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: frequency,
            placeholder: this.intlMsg.msg('rxparamsetupreq.rx2freq.placeholder'),
            onChange: this.handleChangeFrequency
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('frequency'),
            message: this.intlMsg.errorMsg(errors.get('frequency')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__["a" /* default */], {
            status: sentStatus,
            states: [{
              status: 'default',
              label: this.intlMsg.msg('submit'),
              style: 'primary',
              type: 'submit'
            }, {
              status: 'success',
              label: this.intlMsg.msg('submit.success'),
              style: 'success',
              timer: function timer() {
                return _this2.setState({ sentStatus: '' });
              }
            }, {
              status: 'failure',
              label: this.intlMsg.msg('submit.failure'),
              style: 'danger',
              timer: function timer() {
                return _this2.setState({ sentStatus: '' });
              }
            }]
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__["a" /* default */], {
            show: errors.has('submit'),
            message: this.intlMsg.errorMsg(errors.get('submit')),
            azStyle: "danger"
          })
        )
      )
    );
  };

  return RxParamSetupReq;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

RxParamSetupReq.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    params: state.device.getRxParamSetupReq,
    sent: state.device.sendRxParamSetupReq
  };
};

var mapDispatchToProps = {
  getParams: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].getRxParamSetupReq,
  sendCmd: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].sendRxParamSetupReq,
  getTxSize: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].getMacTxSize,
  getMacLog: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].getMacLog
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(RxParamSetupReq)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__ = __webpack_require__(62);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var propTypes = {
  params: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  sent: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  getParams: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  sendCmd: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getTxSize: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getMacLog: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var RxTimingSetupReq = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(RxTimingSetupReq, _React$Component);

  function RxTimingSetupReq(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RxTimingSetupReq);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      errors: new __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__["a" /* default */]().add('FE_EMPTY', 'delay')
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.macview');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleChangeDelay = _this.handleChangeDelay.bind(_this);
    return _this;
  }

  RxTimingSetupReq.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        deviceId = _props.deviceId,
        getParams = _props.getParams;

    getParams(deviceId);
  };

  RxTimingSetupReq.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var params = nextProps.params,
        sent = nextProps.sent;
    var errors = this.state.errors;


    if (params !== this.props.params) {
      if (params.status === 'success') {
        var delay = params.data.delay;

        this.setState({ delay: delay });

        if (delay !== '') {
          errors = errors.remove('delay');
        }
        this.setState({ errors: errors });
      }
    }
    if (sent !== this.props.sent) {
      this.setState({ sentStatus: sent.status });
      if (sent.status === 'success') {
        var _props2 = this.props,
            deviceId = _props2.deviceId,
            getTxSize = _props2.getTxSize,
            getMacLog = _props2.getMacLog;

        getTxSize(deviceId);
        getMacLog(deviceId);
      } else if (sent.status === 'failure') {
        errors = errors.add(sent.error.code, 'submit');
        this.setState({ errors: errors });
      }
    }
  };

  RxTimingSetupReq.prototype.handleChangeDelay = function handleChangeDelay(e) {
    var delay = e.target.value.trim();
    this.setState({ delay: delay });

    var errors = this.state.errors;


    if (delay === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'delay') });
      return;
    }
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["b" /* isInteger */])(delay, { min: 0, max: 15 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'delay') });
      return;
    }
    this.setState({ errors: errors.remove('delay') });
  };

  RxTimingSetupReq.prototype.handleSubmit = function handleSubmit(e) {
    this.setState({ submitted: true });
    e.preventDefault();

    var errors = this.state.errors;

    if (!errors.isEmpty()) {
      return;
    }

    var _props3 = this.props,
        deviceId = _props3.deviceId,
        sendCmd = _props3.sendCmd;
    var delay = this.state.delay;

    sendCmd(deviceId, { delay: delay });
  };

  RxTimingSetupReq.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        _state$sentStatus = _state.sentStatus,
        sentStatus = _state$sentStatus === undefined ? '' : _state$sentStatus,
        _state$delay = _state.delay,
        delay = _state$delay === undefined ? '' : _state$delay,
        errors = _state.errors,
        _state$submitted = _state.submitted,
        submitted = _state$submitted === undefined ? false : _state$submitted;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Form"],
      { horizontal: true, onSubmit: this.handleSubmit },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('delay') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            "Delay"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: delay,
            placeholder: this.intlMsg.msg('rxtimingsetupreq.delay.placeholder'),
            onChange: this.handleChangeDelay
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('delay'),
            message: this.intlMsg.errorMsg(errors.get('delay')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__["a" /* default */], {
            status: sentStatus,
            states: [{
              status: 'default',
              label: this.intlMsg.msg('submit'),
              style: 'primary',
              type: 'submit'
            }, {
              status: 'success',
              label: this.intlMsg.msg('submit.success'),
              style: 'success',
              timer: function timer() {
                return _this2.setState({ sentStatus: '' });
              }
            }, {
              status: 'failure',
              label: this.intlMsg.msg('submit.failure'),
              style: 'danger',
              timer: function timer() {
                return _this2.setState({ sentStatus: '' });
              }
            }]
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__["a" /* default */], {
            show: errors.has('submit'),
            message: this.intlMsg.errorMsg(errors.get('submit')),
            azStyle: "danger"
          })
        )
      )
    );
  };

  return RxTimingSetupReq;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

RxTimingSetupReq.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    params: state.device.getRxTimingSetupReq,
    sent: state.device.sendRxTimingSetupReq
  };
};

var mapDispatchToProps = {
  getParams: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].getRxTimingSetupReq,
  sendCmd: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].sendRxTimingSetupReq,
  getTxSize: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].getMacTxSize,
  getMacLog: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].getMacLog
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(RxTimingSetupReq)));

/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__ = __webpack_require__(62);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var propTypes = {
  sent: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  sendCmd: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getTxSize: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getMacLog: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var TxParamSetupReq = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(TxParamSetupReq, _React$Component);

  function TxParamSetupReq(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TxParamSetupReq);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      errors: new __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__["a" /* default */]().add('FE_EMPTY', 'maxeirp').add('FE_EMPTY', 'uldwelltime').add('FE_EMPTY', 'dldwelltime')
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.macview');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleChangeMaxeirp = _this.handleChangeMaxeirp.bind(_this);
    _this.handleChangeULDwellTime = _this.handleChangeULDwellTime.bind(_this);
    _this.handleChangeDLDwellTime = _this.handleChangeDLDwellTime.bind(_this);
    return _this;
  }

  TxParamSetupReq.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var sent = nextProps.sent;
    var errors = this.state.errors;


    if (sent !== this.props.sent) {
      this.setState({ sentStatus: sent.status });
      if (sent.status === 'success') {
        var _props = this.props,
            deviceId = _props.deviceId,
            getTxSize = _props.getTxSize,
            getMacLog = _props.getMacLog;

        getTxSize(deviceId);
        getMacLog(deviceId);
      } else if (sent.status === 'failure') {
        errors = errors.add(sent.error.code, 'submit');
        this.setState({ errors: errors });
      }
    }
  };

  TxParamSetupReq.prototype.handleChangeMaxeirp = function handleChangeMaxeirp(e) {
    var maxeirp = e.target.value.trim();
    this.setState({ maxeirp: maxeirp });

    var errors = this.state.errors;


    if (maxeirp === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'maxeirp') });
      return;
    }
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["b" /* isInteger */])(maxeirp, { min: 0, max: 15 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'maxeirp') });
      return;
    }
    this.setState({ errors: errors.remove('maxeirp') });
  };

  TxParamSetupReq.prototype.handleChangeULDwellTime = function handleChangeULDwellTime(e) {
    var uldwelltime = e.target.value.trim();
    this.setState({ uldwelltime: uldwelltime });

    var errors = this.state.errors;


    if (uldwelltime === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'uldwelltime') });
      return;
    }
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["b" /* isInteger */])(uldwelltime, { min: 0, max: 1 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'uldwelltime') });
      return;
    }
    this.setState({ errors: errors.remove('uldwelltime') });
  };

  TxParamSetupReq.prototype.handleChangeDLDwellTime = function handleChangeDLDwellTime(e) {
    var dldwelltime = e.target.value.trim();
    this.setState({ dldwelltime: dldwelltime });

    var errors = this.state.errors;


    if (dldwelltime === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'dldwelltime') });
      return;
    }
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_checkers_numbers__["b" /* isInteger */])(dldwelltime, { min: 0, max: 1 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'dldwelltime') });
      return;
    }
    this.setState({ errors: errors.remove('dldwelltime') });
  };

  TxParamSetupReq.prototype.handleSubmit = function handleSubmit(e) {
    this.setState({ submitted: true });
    e.preventDefault();

    var errors = this.state.errors;

    if (!errors.isEmpty()) {
      return;
    }

    var _props2 = this.props,
        deviceId = _props2.deviceId,
        sendCmd = _props2.sendCmd;
    var _state = this.state,
        maxeirp = _state.maxeirp,
        uldwelltime = _state.uldwelltime,
        dldwelltime = _state.dldwelltime;

    sendCmd(deviceId, {
      maxeirp: maxeirp,
      uldwelltime: uldwelltime,
      dldwelltime: dldwelltime
    });
  };

  TxParamSetupReq.prototype.render = function render() {
    var _this2 = this;

    var _state2 = this.state,
        _state2$sentStatus = _state2.sentStatus,
        sentStatus = _state2$sentStatus === undefined ? '' : _state2$sentStatus,
        _state2$maxeirp = _state2.maxeirp,
        maxeirp = _state2$maxeirp === undefined ? '' : _state2$maxeirp,
        _state2$uldwelltime = _state2.uldwelltime,
        uldwelltime = _state2$uldwelltime === undefined ? '' : _state2$uldwelltime,
        _state2$dldwelltime = _state2.dldwelltime,
        dldwelltime = _state2$dldwelltime === undefined ? '' : _state2$dldwelltime,
        errors = _state2.errors,
        _state2$submitted = _state2.submitted,
        submitted = _state2$submitted === undefined ? false : _state2$submitted;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Form"],
      { horizontal: true, onSubmit: this.handleSubmit },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('maxeirp') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            this.intlMsg.msg('txparamsetupreq.maxeirp')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: maxeirp,
            placeholder: this.intlMsg.msg('txparamsetupreq.maxeirp.placeholder'),
            onChange: this.handleChangeMaxeirp
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('maxeirp'),
            message: this.intlMsg.errorMsg(errors.get('maxeirp')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('uldwelltime') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            "UpLink DwellTime"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: uldwelltime,
            placeholder: this.intlMsg.msg('txparamsetupreq.uldwelltime.placeholder'),
            onChange: this.handleChangeULDwellTime
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('uldwelltime'),
            message: this.intlMsg.errorMsg(errors.get('uldwelltime')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('dldwelltime') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            "DownLink DwellTime"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            value: dldwelltime,
            placeholder: this.intlMsg.msg('txparamsetupreq.dldwelltime.placeholder'),
            onChange: this.handleChangeDLDwellTime
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('dldwelltime'),
            message: this.intlMsg.errorMsg(errors.get('dldwelltime')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__["a" /* default */], {
            status: sentStatus,
            states: [{
              status: 'default',
              label: this.intlMsg.msg('submit'),
              style: 'primary',
              type: 'submit'
            }, {
              status: 'success',
              label: this.intlMsg.msg('submit.success'),
              style: 'success',
              timer: function timer() {
                return _this2.setState({ sentStatus: '' });
              }
            }, {
              status: 'failure',
              label: this.intlMsg.msg('submit.failure'),
              style: 'danger',
              timer: function timer() {
                return _this2.setState({ sentStatus: '' });
              }
            }]
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__["a" /* default */], {
            show: errors.has('submit'),
            message: this.intlMsg.errorMsg(errors.get('submit')),
            azStyle: "danger"
          })
        )
      )
    );
  };

  return TxParamSetupReq;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

TxParamSetupReq.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    sent: state.device.sendTxParamSetupReq
  };
};

var mapDispatchToProps = {
  sendCmd: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].sendTxParamSetupReq,
  getTxSize: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].getMacTxSize,
  getMacLog: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].getMacLog
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(TxParamSetupReq)));

/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Select__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loraactions_chplan__ = __webpack_require__(202);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  sendCmd: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  sendState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  getChannelPlans: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  channelPlansState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  getTxSize: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getMacLog: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var UpdChPlanReq = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(UpdChPlanReq, _React$Component);

  function UpdChPlanReq(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, UpdChPlanReq);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      errors: __WEBPACK_IMPORTED_MODULE_13_lorautils_errors_ErrorSet__["a" /* default */].createEmpty().add('FE_EMPTY', 'chplan'),
      channelPlansState: props.channelPlansState
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.macview');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleChangeChPlan = _this.handleChangeChPlan.bind(_this);
    return _this;
  }

  UpdChPlanReq.prototype.componentWillMount = function componentWillMount() {
    var getChannelPlans = this.props.getChannelPlans;

    getChannelPlans();
  };

  UpdChPlanReq.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var sendState = nextProps.sendState,
        channelPlansState = nextProps.channelPlansState;


    if (sendState !== this.props.sendState) {
      this.setState({ sendStatus: sendState.status });
      if (sendState.status === 'success') {
        var _props = this.props,
            deviceId = _props.deviceId,
            getTxSize = _props.getTxSize,
            getMacLog = _props.getMacLog;

        getTxSize(deviceId);
        getMacLog(deviceId);
      } else if (sendState.status === 'failure') {
        var errors = this.state.errors;

        this.setState({ errors: errors.add(sendState.error.code, 'submit') });
      }
      _.delay(function () {
        _this2.setState({ sendStatus: '' });
      }, 1500);
    }
    if (channelPlansState !== this.props.channelPlansState) {
      this.setState({ channelPlansState: channelPlansState });
    }
  };

  UpdChPlanReq.prototype.handleChangeChPlan = function handleChangeChPlan(chplan) {
    this.setState({ chplan: chplan });
    var errors = this.state.errors;

    this.setState({ errors: errors.remove('chplan') });
  };

  UpdChPlanReq.prototype.handleSubmit = function handleSubmit(e) {
    this.setState({ submitted: true });
    e.preventDefault();

    var errors = this.state.errors;

    if (!errors.isEmpty()) {
      return;
    }

    var _props2 = this.props,
        deviceId = _props2.deviceId,
        sendCmd = _props2.sendCmd;
    var chplan = this.state.chplan;

    sendCmd(deviceId, { cpid: chplan });
  };

  UpdChPlanReq.prototype.render = function render() {
    var _this3 = this;

    var _state = this.state,
        _state$chplan = _state.chplan,
        chplan = _state$chplan === undefined ? '' : _state$chplan,
        errors = _state.errors,
        _state$submitted = _state.submitted,
        submitted = _state$submitted === undefined ? false : _state$submitted,
        _state$sendStatus = _state.sendStatus,
        sendStatus = _state$sendStatus === undefined ? '' : _state$sendStatus,
        channelPlansState = _state.channelPlansState;
    var _channelPlansState$da = channelPlansState.data;
    _channelPlansState$da = _channelPlansState$da === undefined ? {} : _channelPlansState$da;
    var _channelPlansState$da2 = _channelPlansState$da.list,
        chplans = _channelPlansState$da2 === undefined ? [] : _channelPlansState$da2;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Form"],
      { horizontal: true, onSubmit: this.handleSubmit },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('chplan') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            this.intlMsg.msg('updchplanreq.chplan')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Select__["a" /* default */], {
            options: chplans.map(function (cp) {
              return {
                label: cp.name,
                value: cp.id,
                formatter: function formatter() {
                  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "span",
                    null,
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_RichLabel__["a" /* default */], { content: cp.band }),
                    " ",
                    cp.name
                  );
                }
              };
            }),
            placeholder: this.intlMsg.msg('updchplanreq.chplan.placeholder'),
            value: chplan,
            onChange: this.handleChangeChPlan
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('chplan'),
            message: this.intlMsg.errorMsg(errors.get('chplan')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__["a" /* default */], {
            status: sendStatus,
            states: [{
              status: 'default',
              label: this.intlMsg.msg('submit'),
              style: 'primary',
              type: 'submit'
            }, {
              status: 'success',
              label: this.intlMsg.msg('submit.success'),
              style: 'success',
              timer: function timer() {
                return _this3.setState({ sentStatus: '' });
              }
            }, {
              status: 'failure',
              label: this.intlMsg.msg('submit.failure'),
              style: 'danger',
              timer: function timer() {
                return _this3.setState({ sentStatus: '' });
              }
            }]
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__["a" /* default */], {
            show: errors.has('submit'),
            message: this.intlMsg.errorMsg(errors.get('submit')),
            azStyle: "danger",
            closeButton: true
          })
        )
      )
    );
  };

  return UpdChPlanReq;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

UpdChPlanReq.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    sendState: state.device.sendUpdChPlanReq,
    channelPlansState: state.chplan.getChannelPlans
  };
};

var mapDispatchToProps = {
  sendCmd: __WEBPACK_IMPORTED_MODULE_14_loraactions_device__["a" /* default */].sendUpdChPlanReq,
  getChannelPlans: __WEBPACK_IMPORTED_MODULE_15_loraactions_chplan__["a" /* default */].getChannelPlans,
  getTxSize: __WEBPACK_IMPORTED_MODULE_14_loraactions_device__["a" /* default */].getMacTxSize,
  getMacLog: __WEBPACK_IMPORTED_MODULE_14_loraactions_device__["a" /* default */].getMacLog
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(UpdChPlanReq)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Select__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loraactions_chplan__ = __webpack_require__(202);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  sendCmd: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  sendState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  getChannelPlans: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  channelPlansState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  getTxSize: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getMacLog: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var UpdChPlanReq2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(UpdChPlanReq2, _React$Component);

  function UpdChPlanReq2(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, UpdChPlanReq2);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      errors: __WEBPACK_IMPORTED_MODULE_13_lorautils_errors_ErrorSet__["a" /* default */].createEmpty().add('FE_EMPTY', 'chplan'),
      channelPlansState: props.channelPlansState
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.macview');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleChangeChPlan = _this.handleChangeChPlan.bind(_this);
    return _this;
  }

  UpdChPlanReq2.prototype.componentWillMount = function componentWillMount() {
    var getChannelPlans = this.props.getChannelPlans;

    getChannelPlans();
  };

  UpdChPlanReq2.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var sendState = nextProps.sendState,
        channelPlansState = nextProps.channelPlansState;


    if (sendState !== this.props.sendState) {
      this.setState({ sendStatus: sendState.status });
      if (sendState.status === 'success') {
        var _props = this.props,
            deviceId = _props.deviceId,
            getTxSize = _props.getTxSize,
            getMacLog = _props.getMacLog;

        getTxSize(deviceId);
        getMacLog(deviceId);
      } else if (sendState.status === 'failure') {
        var errors = this.state.errors;

        this.setState({ errors: errors.add(sendState.error.code, 'submit') });
      }
      _.delay(function () {
        _this2.setState({ sendStatus: '' });
      }, 1500);
    }
    if (channelPlansState !== this.props.channelPlansState) {
      this.setState({ channelPlansState: channelPlansState });
    }
  };

  UpdChPlanReq2.prototype.handleChangeChPlan = function handleChangeChPlan(chplan) {
    this.setState({ chplan: chplan });
    var errors = this.state.errors;

    this.setState({ errors: errors.remove('chplan') });
  };

  UpdChPlanReq2.prototype.handleSubmit = function handleSubmit(e) {
    this.setState({ submitted: true });
    e.preventDefault();

    var errors = this.state.errors;

    if (!errors.isEmpty()) {
      return;
    }

    var _props2 = this.props,
        deviceId = _props2.deviceId,
        sendCmd = _props2.sendCmd;
    var chplan = this.state.chplan;

    sendCmd(deviceId, { cpid: chplan });
  };

  UpdChPlanReq2.prototype.render = function render() {
    var _this3 = this;

    var _state = this.state,
        _state$chplan = _state.chplan,
        chplan = _state$chplan === undefined ? '' : _state$chplan,
        errors = _state.errors,
        _state$submitted = _state.submitted,
        submitted = _state$submitted === undefined ? false : _state$submitted,
        _state$sendStatus = _state.sendStatus,
        sendStatus = _state$sendStatus === undefined ? '' : _state$sendStatus,
        channelPlansState = _state.channelPlansState;
    var _channelPlansState$da = channelPlansState.data;
    _channelPlansState$da = _channelPlansState$da === undefined ? {} : _channelPlansState$da;
    var _channelPlansState$da2 = _channelPlansState$da.list,
        chplans = _channelPlansState$da2 === undefined ? [] : _channelPlansState$da2;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Form"],
      { horizontal: true, onSubmit: this.handleSubmit },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('chplan') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            this.intlMsg.msg('updchplanreq.chplan')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Select__["a" /* default */], {
            options: chplans.map(function (cp) {
              return {
                label: cp.name,
                value: cp.id,
                formatter: function formatter() {
                  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "span",
                    null,
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_RichLabel__["a" /* default */], { content: cp.band }),
                    " ",
                    cp.name
                  );
                }
              };
            }),
            placeholder: this.intlMsg.msg('updchplanreq.chplan.placeholder'),
            value: chplan,
            onChange: this.handleChangeChPlan
          }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('chplan'),
            message: this.intlMsg.errorMsg(errors.get('chplan')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_RichButton__["a" /* default */], {
            status: sendStatus,
            states: [{
              status: 'default',
              label: this.intlMsg.msg('submit'),
              style: 'primary',
              type: 'submit'
            }, {
              status: 'success',
              label: this.intlMsg.msg('submit.success'),
              style: 'success',
              timer: function timer() {
                return _this3.setState({ sentStatus: '' });
              }
            }, {
              status: 'failure',
              label: this.intlMsg.msg('submit.failure'),
              style: 'danger',
              timer: function timer() {
                return _this3.setState({ sentStatus: '' });
              }
            }]
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 3, md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_FormBlock__["a" /* default */], {
            show: errors.has('submit'),
            message: this.intlMsg.errorMsg(errors.get('submit')),
            azStyle: "danger",
            closeButton: true
          })
        )
      )
    );
  };

  return UpdChPlanReq2;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

UpdChPlanReq2.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    sendState: state.device.sendUpdChPlanReq2,
    channelPlansState: state.chplan.getChannelPlans
  };
};

var mapDispatchToProps = {
  sendCmd: __WEBPACK_IMPORTED_MODULE_14_loraactions_device__["a" /* default */].sendUpdChPlanReq2,
  getChannelPlans: __WEBPACK_IMPORTED_MODULE_15_loraactions_chplan__["a" /* default */].getChannelPlans,
  getTxSize: __WEBPACK_IMPORTED_MODULE_14_loraactions_device__["a" /* default */].getMacTxSize,
  getMacLog: __WEBPACK_IMPORTED_MODULE_14_loraactions_device__["a" /* default */].getMacLog
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(UpdChPlanReq2)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_DeviceMap__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_HideIf__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_MapPicker__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_SearchInput__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_scss__ = __webpack_require__(2244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);














var defaultProps = {
  show: false,
  onSave: function onSave() {},
  search: ''
};

var propTypes = {
  devices: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.array.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  show: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  onSave: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func,
  search: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any
};

var MapOverlay = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(MapOverlay, _React$Component);

  function MapOverlay(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MapOverlay);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      devices: props.devices,
      center: props.devices[0],
      zoom: _.isNil(props.devices[0]) ? 11 : 16,
      show: props.show,
      view: 'view',
      search: props.search
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'mapoverlay');
    _this.handlePickPoint = _this.handlePickPoint.bind(_this);
    _this.handleSaveLocation = _this.handleSaveLocation.bind(_this);
    _this.handleHide = _this.handleHide.bind(_this);
    return _this;
  }

  MapOverlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var devices = nextProps.devices,
        show = nextProps.show;

    if (devices !== this.props.devices) {
      this.setState({ devices: devices });
    }
    if (show !== this.props.show) {
      this.setState({ show: show });
    }
  };

  MapOverlay.prototype.handlePickPoint = function handlePickPoint(point) {
    this.setState({ point: point });
  };

  MapOverlay.prototype.handleSaveLocation = function handleSaveLocation() {
    var point = this.state.point;

    this.props.onSave(point);
    this.handleHide();
  };

  MapOverlay.prototype.handleHide = function handleHide() {
    this.setState({ view: 'view' });
    this.props.onHide();
  };

  MapOverlay.prototype.handleOnChange = function handleOnChange(e) {
    var search = _.trim(e.target.value);
    this.setState({ search: search });
  };

  MapOverlay.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        devices = _state.devices,
        _state$show = _state.show,
        show = _state$show === undefined ? false : _state$show,
        _state$view = _state.view,
        view = _state$view === undefined ? 'view' : _state$view,
        _state$point = _state.point,
        point = _state$point === undefined ? {} : _state$point,
        center = _state.center,
        zoom = _state.zoom,
        search = _state.search;


    if (!show) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.overlay },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.closeButton + " " + __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.mapButton },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
          { bsStyle: "aisz-link-default", onClick: this.handleHide },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-remove drop" })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.mapMarker + " " + __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.mapButton },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
          { bsStyle: "aisz-link-default", onClick: function onClick() {
              _this2.setState({ view: 'edit' });
            } },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-nearby-circle drop" }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_loracoms_HideIf__["a" /* default */],
            { "if": view === 'edit' && !_.isEmpty(point) },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "span",
              { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.buttonText },
              this.intlMsg.msg('edit')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
          { "if": view === 'edit' && !_.isEmpty(point) },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.point },
            "(" + point.lng + "," + point.lat + ")"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
          { "if": view === 'edit' && !_.isEmpty(point) },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
            { bsStyle: "aisz-primary", onClick: this.handleSaveLocation },
            this.intlMsg.msg('submit')
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
        { "if": view === 'view' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_DeviceMap__["a" /* default */], {
          devices: devices,
          onZoom: function onZoom(map) {
            _this2.setState({
              center: map.getCenter(),
              zoom: map.getZoom()
            });
          },
          onDrag: function onDrag(map) {
            _this2.setState({
              center: map.getCenter()
            });
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
        { "if": view === 'edit' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "pull-right " + __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.searchinput },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_SearchInput__["a" /* default */], {
            value: search,
            onChange: function onChange(e) {
              return _this2.handleOnChange(e);
            },
            placeholder: "search"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
        { "if": view === 'edit' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_MapPicker__["a" /* default */], {
          point: center,
          zoom: zoom,
          onPick: this.handlePickPoint,
          search: search
        })
      )
    );
  };

  return MapOverlay;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

MapOverlay.defaultProps = defaultProps;
MapOverlay.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    gateway: state.gateway.gateway
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_5_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(MapOverlay)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_Select__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss__ = __webpack_require__(2245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);












var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  onSuccess: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  showModal: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,
  gateway: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired
};

var _formatter = function _formatter(gw) {
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    "span",
    null,
    gw.name,
    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "span",
      { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.infos },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "span",
        { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.info },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-angle-left" }),
        "ID: ",
        gw.id,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-angle-right" })
      )
    )
  );
};

var AddModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(AddModal, _React$Component);

  function AddModal(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AddModal);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      showModal: props.showModal,
      gateway: props.gateway
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.topoview');
    _this.handleOnChange = _this.handleOnChange.bind(_this);
    return _this;
  }

  AddModal.prototype.componentWillMount = function componentWillMount() {
    this.loadGateways();
  };

  AddModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var showModal = nextProps.showModal,
        gateway = nextProps.gateway;

    if (showModal !== this.props.showModal) {
      this.setState({ showModal: showModal });
    }
    this.setState({ gateway: gateway });
  };

  AddModal.prototype.loadGateways = function loadGateways() {
    var _this2 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__api_callAPI__["a" /* default */])({
      endpoint: '/lora/gateways',
      query: {
        mark: 0,
        limit: 1000,
        sort: '-lastOn'
      }
    }).then(function (res) {
      var list = res.list;

      var options = _.map(list, function (l) {
        return {
          label: l.name,
          value: l.id,
          formatter: function formatter() {
            return _formatter(l);
          }
        };
      });
      _this2.setState({ options: options });
    }).catch(function () {});
  };

  AddModal.prototype.handleOnChange = function handleOnChange(gateway) {
    this.setState({ gateway: gateway });
  };

  AddModal.prototype.handleOnConfirm = function handleOnConfirm() {
    var _this3 = this;

    var _state$gateway = this.state.gateway,
        gateway = _state$gateway === undefined ? '' : _state$gateway;

    if (gateway.length === 0) {
      this.setState({ empty: true });
      return;
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__api_callAPI__["a" /* default */])({
      endpoint: "/lora/nodes/" + this.props.deviceId + "/deflink",
      method: 'POST',
      body: { gateway: gateway }
    }).then(function () {
      _this3.props.onSuccess(gateway);
    }).catch(function (err) {
      _this3.setState({ error: err.code });
    });
  };

  AddModal.prototype.handleError = function handleError() {
    var _this4 = this;

    _.delay(function () {
      _this4.setState({ error: null });
    }, 3 * 1000);
  };

  AddModal.prototype.render = function render() {
    var _this5 = this;

    var _state = this.state,
        showModal = _state.showModal,
        _state$empty = _state.empty,
        empty = _state$empty === undefined ? false : _state$empty,
        gateway = _state.gateway,
        _state$error = _state.error,
        error = _state$error === undefined ? null : _state$error,
        _state$options = _state.options,
        options = _state$options === undefined ? [] : _state$options;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Modal"],
      {
        show: showModal,
        bsClass: "aisz-modal-light",
        onHide: function onHide() {
          _this5.setState({ gateway: '', empty: false, error: null });
          _this5.props.onHide();
        },
        backdrop: "static"
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Modal"].Header, { closeButton: true }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Form"],
          { horizontal: true },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["FormGroup"],
            { controlId: "formHorizontalEmail", className: "clearfix" },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "span",
                { className: "aisz-control-label " + __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.inline },
                this.intlMsg.msg('deflink.gatewayid'),
                " *"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Col"],
              { md: 7 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Select__["a" /* default */], {
                options: options,
                value: gateway,
                onChange: this.handleOnChange
              }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_ControlTips__["a" /* default */], {
                show: empty,
                message: this.intlMsg.msg('deflink.empty'),
                azStyle: "danger"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Col"],
              { md: 7, mdOffset: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Button"],
                {
                  bsStyle: "aisz-primary",
                  onClick: function onClick() {
                    return _this5.handleOnConfirm();
                  },
                  className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.fullWidth
                },
                this.intlMsg.msg('deflink.confirm')
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Col"],
              { md: 7, mdOffset: 3 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_FormBlock__["a" /* default */], {
                azStyle: "danger",
                show: error !== null,
                onHide: function onHide() {
                  return _this5.handleError();
                },
                message: this.intlMsg.errorMsg(error)
              })
            )
          )
        )
      )
    );
  };

  return AddModal;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

AddModal.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(AddModal));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_DeleteModal__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AddModal__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss__ = __webpack_require__(2246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);
















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  getDefLinks: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  linkState: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired
};

var DefLink = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DefLink, _React$Component);

  function DefLink(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DefLink);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      linkState: props.linkState
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail.topoview');
    return _this;
  }

  DefLink.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        deviceId = _props.deviceId,
        getDefLinks = _props.getDefLinks;

    getDefLinks(deviceId);
  };

  DefLink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var linkState = nextProps.linkState;

    if (linkState !== this.props.linkState) {
      this.setState({ linkState: linkState });
      if (linkState.data && linkState.data.gateway) {
        this.loadGatewayDetail(linkState.data.gateway);
      }
    }
  };

  DefLink.prototype.loadGatewayDetail = function loadGatewayDetail(gateway) {
    var _this2 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__api_callAPI__["a" /* default */])({ endpoint: "lora/gateways/" + gateway }).then(function (res) {
      _this2.setState({ gatewayName: res.name });
    }).catch(function () {});
  };

  DefLink.prototype.handleOnsuccess = function handleOnsuccess(gateway) {
    var _props2 = this.props,
        deviceId = _props2.deviceId,
        getDefLinks = _props2.getDefLinks;
    var data = this.state.linkState.data;

    if (data.gateway !== gateway) {
      getDefLinks(deviceId);
    }
    this.setState({ showModal: false });
  };

  DefLink.prototype.handleOnDelete = function handleOnDelete() {
    var _this3 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__api_callAPI__["a" /* default */])({
      endpoint: "/lora/nodes/" + this.props.deviceId + "/deflink",
      method: 'DELETE'
    }).then(function () {
      var _props3 = _this3.props,
          deviceId = _props3.deviceId,
          getDefLinks = _props3.getDefLinks;

      getDefLinks(deviceId);
      _this3.setState({ showDeleteModal: false });
    }).catch(function () {});
  };

  DefLink.prototype.render = function render() {
    var _this4 = this;

    var _state = this.state,
        data = _state.linkState.data,
        _state$showModal = _state.showModal,
        showModal = _state$showModal === undefined ? false : _state$showModal,
        _state$showDeleteModa = _state.showDeleteModal,
        showDeleteModal = _state$showDeleteModa === undefined ? false : _state$showDeleteModa,
        _state$gatewayName = _state.gatewayName,
        gatewayName = _state$gatewayName === undefined ? '' : _state$gatewayName;

    if (!data) {
      return null;
    }
    var header = data.gateway.length === 0 ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      this.intlMsg.msg('deflink.downlink'),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Button"],
        {
          className: "btn-aisz-success " + __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.marginLm,
          onClick: function onClick() {
            return _this4.setState({ showModal: true });
          }
        },
        this.intlMsg.msg('deflink.add'),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicon glyphicon-plus" })
      )
    ) : this.intlMsg.msg('deflink.downlink');
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: header },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__["a" /* default */],
        { "if": data.gateway.length > 0 },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.gatewayName },
            gatewayName
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
              {
                className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.gateway,
                to: "/gateway/detail/" + data.gateway
              },
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_IdUtils__["a" /* normalizeDevEUI */])(data.gateway)
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
              {
                className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.edit,
                onClick: function onClick() {
                  return _this4.setState({ showModal: true });
                }
              },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicon glyphicon-pencil" })
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
              {
                className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.delete,
                onClick: function onClick() {
                  return _this4.setState({ showDeleteModal: true });
                }
              },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-trash" })
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__AddModal__["a" /* default */], {
        showModal: showModal,
        deviceId: this.props.deviceId,
        onHide: function onHide() {
          return _this4.setState({ showModal: false });
        },
        onSuccess: function onSuccess(g) {
          return _this4.handleOnsuccess(g);
        },
        gateway: data.gateway
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_DeleteModal__["a" /* default */], {
        showModal: showDeleteModal,
        headerText: this.intlMsg.msg('deflink.delete'),
        text: this.intlMsg.msg('deflink.deletetip') + "(" + data.gateway + ")?",
        onConfirm: function onConfirm() {
          return _this4.handleOnDelete();
        },
        onCancel: function onCancel() {
          return _this4.setState({ showDeleteModal: false });
        }
      })
    );
  };

  return DefLink;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DefLink.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    linkState: state.device.getDefLinks || {}
  };
};

var mapDispatchToProps = {
  getDefLinks: __WEBPACK_IMPORTED_MODULE_9_loraactions_device__["a" /* default */].getDefLinks
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(DefLink)));

/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_SideBar__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_SidebarContainer__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loraapi_lora_device__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loraactions_app__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__coms_StatView__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__coms_MacView__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__coms_LRAPView__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__coms_ADRView__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__coms_DataToolView__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__coms_TopoView__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss__ = __webpack_require__(2248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





















var propTypes = {
  view: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  getDevice: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  deviceId: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.node.isRequired,
  getApp: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired
};

var defaultProps = {};

var DeviceDetail = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeviceDetail, _React$Component);

  function DeviceDetail(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeviceDetail);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      view: props.view,
      detail: {},
      showToken: false,
      devTypes: [],
      lwanvers: []
    };

    _this.refreshMac = _this.refreshMac.bind(_this);
    _this.refreshDetail = _this.refreshDetail.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'devicedetail');
    return _this;
  }

  DeviceDetail.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        getDevice = _props.getDevice,
        deviceId = _props.deviceId,
        getApp = _props.getApp,
        appId = _props.appId;

    getDevice(deviceId);
    getApp(appId);
  };

  DeviceDetail.prototype.componentDidMount = function componentDidMount() {
    this.refreshDetail();
  };

  DeviceDetail.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var view = nextProps.view;

    if (view !== this.props.view) {
      this.setState({ view: view });
    }
  };

  DeviceDetail.prototype.refreshDetail = function refreshDetail(cb) {
    var _this2 = this;

    var deviceId = this.props.deviceId;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_loraapi_lora_device__["e" /* getDeviceDetail */])(deviceId).then(function (res) {
      _this2.setState({
        detail: res.body
      });
      if (cb) {
        cb();
      }
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_loraapi_lora_device__["f" /* getDataSize */])(deviceId).then(function (res) {
      _this2.setState({
        size: res.body.size
      });
    });
  };

  DeviceDetail.prototype.refreshMac = function refreshMac(cb) {
    this.refreshDetail(cb);
    this.setState({
      view: 'mac'
    });
  };

  DeviceDetail.prototype.renderSideBar = function renderSideBar() {
    var _props2 = this.props,
        pushState = _props2.pushState,
        appId = _props2.appId,
        deviceId = _props2.deviceId;
    var view = this.state.view;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_SideBar__["a" /* default */], {
      height: window.innerHeight,
      title: this.intlMsg.msg('sidebar.title'),
      menuItems: [{
        icon: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-blackboard" }),
        text: this.intlMsg.msg('sidebar.menu.detail'),
        onClick: function onClick() {
          return pushState("/application/" + appId + "/devices/" + deviceId);
        },
        active: view === 'detail'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-pie-chart" }),
        text: this.intlMsg.msg('sidebar.menu.stat'),
        onClick: function onClick() {
          return pushState("/application/" + appId + "/devices/" + deviceId + "/stat");
        },
        active: view === 'stat'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-transfer rotate270" }),
        text: this.intlMsg.msg('sidebar.menu.datatool'),
        onClick: function onClick() {
          return pushState("/application/" + appId + "/devices/" + deviceId + "/datatool");
        },
        active: view === 'datatool'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-notes-2" }),
        text: this.intlMsg.msg('sidebar.menu.devicelog'),
        onClick: function onClick() {
          return pushState("/application/" + appId + "/devices/" + deviceId + "/logs");
        },
        active: view === 'logs'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-arrow-down" }),
        text: this.intlMsg.msg('sidebar.menu.maccommand'),
        onClick: function onClick() {
          return pushState("/application/" + appId + "/devices/" + deviceId + "/mac");
        },
        active: view === 'mac'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-microchip", "aria-hidden": "true" }),
        text: this.intlMsg.msg('sidebar.menu.lrap'),
        onClick: function onClick() {
          return pushState("/application/" + appId + "/devices/" + deviceId + "/lrap");
        },
        active: view === 'lrap'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-voice" }),
        text: 'ADR',
        onClick: function onClick() {
          return pushState("/application/" + appId + "/devices/" + deviceId + "/adr");
        },
        active: view === 'adr'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-vector-path-polygon" }),
        text: this.intlMsg.msg('sidebar.menu.topo'),
        onClick: function onClick() {
          return pushState("/application/" + appId + "/devices/" + deviceId + "/topo");
        },
        active: view === 'topo'
      }]
    });
  };

  DeviceDetail.prototype.renderView = function renderView() {
    var _props3 = this.props,
        appId = _props3.appId,
        deviceId = _props3.deviceId;
    var _state = this.state,
        detail = _state.detail,
        view = _state.view,
        appName = _state.appName;


    if (view === 'stat') {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__coms_StatView__["a" /* default */], {
        detail: detail,
        appId: appId,
        appName: appName || appId,
        deviceId: deviceId
      });
    } else if (view === 'mac') {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__coms_MacView__["a" /* default */], {
        detail: detail,
        appId: appId,
        appName: appName || appId,
        deviceId: deviceId,
        refreshDetail: this.refreshMac
      });
    } else if (view === 'lrap') {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__coms_LRAPView__["a" /* default */], {
        detail: detail,
        appId: appId,
        appName: appName || appId,
        deviceId: deviceId,
        refreshDetail: this.refreshDetail
      });
    } else if (view === 'adr') {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__coms_ADRView__["a" /* default */], {
        appId: appId,
        appName: appName || appId,
        deviceId: deviceId
      });
    } else if (view === 'datatool') {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__coms_DataToolView__["a" /* default */], {
        appId: appId,
        appName: appName || appId,
        deviceId: deviceId
      });
    } else if (view === 'topo') {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__coms_TopoView__["a" /* default */], {
        appId: appId,
        appName: appName || appId,
        deviceId: deviceId
      });
    }
    return null;
  };

  DeviceDetail.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      null,
      this.renderSideBar(),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_loracoms_SidebarContainer__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.view },
          this.props.children
        )
      )
    );
  };

  return DeviceDetail;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

DeviceDetail.defaultProps = defaultProps;
DeviceDetail.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    view: ownProps.location.pathname.split('/')[5] || 'detail',
    deviceId: ownProps.params.deviceId,
    appId: ownProps.params.appId
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push,
  getDevice: __WEBPACK_IMPORTED_MODULE_12_loraactions_device__["a" /* default */].getDevice,
  getApp: __WEBPACK_IMPORTED_MODULE_13_loraactions_app__["a" /* default */].getApp
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(DeviceDetail)));

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_SearchInput__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loraactions_app__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loraactions_usage__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__coms_AppOOQModal__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__coms_AddAppModal__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__coms_ApplicationList__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_main_scss__ = __webpack_require__(2249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_main_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  getApps: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  getAppsUsage: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  orgBasic: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  usage: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired
};

var Application = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Application, _React$Component);

  function Application(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Application);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      appList: [],
      count: '',
      search: '',
      status: 'idle',
      mark: '',
      more: false,
      orgBasic: props.orgBasic,
      usage: props.usage
    };
    _this.handleAddApp = _this.handleAddApp.bind(_this);
    _this.handleAdded = _this.handleAdded.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'application');
    return _this;
  }

  Application.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var orgBasic = nextProps.orgBasic,
        usage = nextProps.usage;

    if (orgBasic !== this.props.orgBasic) {
      this.setState({ orgBasic: orgBasic });
    }
    if (usage !== this.props.usage) {
      this.setState({ usage: usage });
    }
  };

  Application.prototype.handleAddApp = function handleAddApp() {
    var _state = this.state,
        orgBasic = _state.orgBasic,
        usage = _state.usage;

    if (orgBasic.status !== 'success' || usage.pendings.includes('apps')) {
      return;
    }

    if (usage.apps >= orgBasic.data.lrappnum) {
      this.setState({ showOOQ: true });
    } else {
      this.setState({ showAdd: true });
    }
  };

  Application.prototype.handleAdded = function handleAdded() {
    this.setState({ showAdd: false });
    var _props = this.props,
        getAppsUsage = _props.getAppsUsage,
        getApps = _props.getApps;

    getAppsUsage();
    getApps({ count: true, tkcnt: true });
  };

  Application.prototype.render = function render() {
    var _this2 = this;

    var _state2 = this.state,
        _state2$searching = _state2.searching,
        searching = _state2$searching === undefined ? false : _state2$searching,
        _state2$search = _state2.search,
        search = _state2$search === undefined ? '' : _state2$search,
        _state2$showOOQ = _state2.showOOQ,
        showOOQ = _state2$showOOQ === undefined ? false : _state2$showOOQ,
        _state2$showAdd = _state2.showAdd,
        showAdd = _state2$showAdd === undefined ? false : _state2$showAdd;


    var brandTools = [{
      type: 'buttons',
      buttons: [__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
        { bsStyle: "aisz-success", onClick: this.handleAddApp },
        this.intlMsg.msg('addapp.btn'),
        ' ',
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicon glyphicon-plus", "aria-hidden": "true" })
      )]
    }];
    var rightTools = [{
      type: 'search',
      searchInput: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_SearchInput__["a" /* default */], {
        autoFocus: true,
        placeholder: this.intlMsg.msg('app.search.placeholder'),
        value: search,
        onChange: function onChange(e) {
          return _this2.setState({ search: e.target.value });
        },
        onFocus: function onFocus() {
          return _this2.setState({ searching: true });
        },
        onBlur: function onBlur() {
          return _this2.setState({ searching: false });
        }
      })
    }];

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_17__styles_main_scss___default.a.wrapper, style: { minHeight: window.innerHeight - 50 } },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__["a" /* default */], {
          brandIcon: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-menu-hamburger" }),
          leftTools: brandTools,
          rightTools: rightTools
        })
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__coms_ApplicationList__["a" /* default */], { searching: searching, searchText: search }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__coms_AddAppModal__["a" /* default */], {
          show: showAdd,
          onHide: function onHide() {
            return _this2.setState({ showAdd: false });
          },
          onAdded: this.handleAdded,
          onOOQ: function onOOQ() {
            return _this2.setState({ showAdd: false, showOOQ: true });
          }
        }),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__coms_AppOOQModal__["a" /* default */], {
          show: showOOQ,
          onHide: function onHide() {
            return _this2.setState({ showOOQ: false });
          }
        })
      )
    );
  };

  return Application;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Application.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    orgBasic: state.org.basic,
    usage: state.usage
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_7_react_router_redux__["routerActions"].push,
  getApps: __WEBPACK_IMPORTED_MODULE_11_loraactions_app__["a" /* default */].getApps,
  getAppsUsage: __WEBPACK_IMPORTED_MODULE_12_loraactions_usage__["a" /* default */].apps
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(Application)));

/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loraactions_account__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loraactions_org__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loraactions_usage__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loraactions_billing__ = __webpack_require__(336);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);










var defaultProps = {
  children: null,
  authed: false
};

var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any,
  authed: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool,
  gotoLogin: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getAccountBasic: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getOrgBasic: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getGatewaysUsage: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getAppsUsage: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getNodesUsage: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getPlan: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var AuthLatch = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(AuthLatch, _React$Component);

  function AuthLatch(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AuthLatch);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {};
    return _this;
  }

  AuthLatch.prototype.componentWillMount = function componentWillMount() {
    this.checkAuth();
    this.loadGlobalInfos();
  };

  AuthLatch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.checkAuth(nextProps);
    if (nextProps.authed && !this.props.authed) {
      this.loadGlobalInfos();
    }
  };

  AuthLatch.prototype.checkAuth = function checkAuth() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
    var authed = props.authed;
    var gotoLogin = this.props.gotoLogin;

    if (!authed) {
      gotoLogin();
    }
  };

  AuthLatch.prototype.loadGlobalInfos = function loadGlobalInfos() {
    var _props = this.props,
        authed = _props.authed,
        getAccountBasic = _props.getAccountBasic,
        getOrgBasic = _props.getOrgBasic,
        getGatewaysUsage = _props.getGatewaysUsage,
        getAppsUsage = _props.getAppsUsage,
        getNodesUsage = _props.getNodesUsage,
        getPlan = _props.getPlan;

    if (authed) {
      getAccountBasic();
      getOrgBasic();
      getGatewaysUsage();
      getAppsUsage();
      getNodesUsage();
      getPlan();
    }
  };

  AuthLatch.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      this.props.children
    );
  };

  return AuthLatch;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

AuthLatch.defaultProps = defaultProps;
AuthLatch.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    authed: state.auth.authed
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    gotoLogin: function gotoLogin() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__["replace"])('/login'));
    },
    getAccountBasic: function getAccountBasic() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6_loraactions_account__["a" /* default */].basic());
    },
    getOrgBasic: function getOrgBasic() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_7_loraactions_org__["a" /* default */].basic());
    },
    getAppsUsage: function getAppsUsage() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_8_loraactions_usage__["a" /* default */].apps());
    },
    getGatewaysUsage: function getGatewaysUsage() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_8_loraactions_usage__["a" /* default */].gateways());
    },
    getNodesUsage: function getNodesUsage() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_8_loraactions_usage__["a" /* default */].nodes());
    },
    getPlan: function getPlan() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_9_loraactions_billing__["a" /* default */].plan());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(AuthLatch));

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_sub_months__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_sub_months___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_sub_months__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_add_days__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_date_fns_add_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_PanelToolbar__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_DatePicker__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loracoms_InlineSelect__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_scss__ = __webpack_require__(2250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





















var defaultFrom = function defaultFrom() {
  return __WEBPACK_IMPORTED_MODULE_10_date_fns_sub_months___default()(new Date(), 1);
};
var defaultTo = function defaultTo() {
  return new Date();
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.any.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  plan: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired
};

var Balogs = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Balogs, _React$Component);

  function Balogs(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Balogs);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.from = defaultFrom();
    _this.to = defaultTo();
    _this.state = {
      plan: props.plan,
      balogs: [],
      filter: 'all',
      from: _this.from,
      to: _this.to
    };
    _this.handleSelectFrom = _this.handleSelectFrom.bind(_this);
    _this.handleSelectTo = _this.handleSelectTo.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_20_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'billing.balogs');
    return _this;
  }

  Balogs.prototype.componentDidMount = function componentDidMount() {
    this.loadBalogs();
  };

  Balogs.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var plan = nextProps.plan;

    if (plan !== this.props.plan) {
      this.setState({ plan: plan });
    }
  };

  Balogs.prototype.handleSelectFrom = function handleSelectFrom(from) {
    this.setState({ from: from });
    this.from = from;
    this.loadBalogs();
  };

  Balogs.prototype.handleSelectTo = function handleSelectTo(to) {
    this.setState({ to: to });
    this.to = to;
    this.loadBalogs();
  };

  Balogs.prototype.loadBalogs = function loadBalogs() {
    var _this2 = this;

    var _ref = [this.from, this.to],
        from = _ref[0],
        to = _ref[1];

    from = __WEBPACK_IMPORTED_MODULE_11_date_fns_format___default()(from, 'YYYYMMDD');
    to = __WEBPACK_IMPORTED_MODULE_11_date_fns_format___default()(__WEBPACK_IMPORTED_MODULE_12_date_fns_add_days___default()(to, 1), 'YYYYMMDD');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_lorautils_api__["a" /* callAPI */])({
      endpoint: '/accounting/balogs',
      query: {
        df: from,
        dt: to,
        pageSize: 1000
      }
    }).then(function (data) {
      var balogs = data.list;
      balogs = _.sortBy(balogs, function (b) {
        return -new Date(b.time).valueOf();
      });
      balogs = _.map(balogs, function (b) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, b, {
          time: __WEBPACK_IMPORTED_MODULE_11_date_fns_format___default()(b.time, 'YYYY-MM-DD HH:mm:ss')
        });
      });
      _this2.setState({ balogs: balogs });
    }).catch(function () {});
  };

  Balogs.prototype.renderBalance = function renderBalance() {
    var pushState = this.props.pushState;
    var _state$plan = this.state.plan,
        _state$plan$data = _state$plan.data;
    _state$plan$data = _state$plan$data === undefined ? {} : _state$plan$data;
    var balance = _state$plan$data.balance,
        status = _state$plan.status;


    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.balance },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "span",
        { className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.label },
        this.intlMsg.msg('balance.lbl'),
        ":"
      ),
      ' ',
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_Nvl__["a" /* default */], { val: balance, status: status }),
      ' ',
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "span",
        { className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.label },
        this.intlMsg.msg('balance.unit')
      ),
      ' ',
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "span",
        { className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.recharge },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-primary",
            onClick: function onClick() {
              return pushState('/billing/recharge');
            }
          },
          this.intlMsg.msg('balance.recharge.btn')
        )
      )
    );
  };

  Balogs.prototype.renderBalogs = function renderBalogs() {
    var _this3 = this;

    var _state = this.state,
        _state$filter = _state.filter,
        filter = _state$filter === undefined ? 'all' : _state$filter,
        _state$from = _state.from,
        from = _state$from === undefined ? defaultFrom() : _state$from,
        _state$to = _state.to,
        to = _state$to === undefined ? defaultTo() : _state$to;
    var balogs = this.state.balogs;


    balogs = _.filter(balogs, function (b) {
      switch (filter) {
        case 'all':
          return true;
        case 'recharge':
          return b.amount > 0;
        default:
          return b.amount <= 0;
      }
    });

    var rows = balogs.map(function (b) {
      var t = null;
      if (b.amount > 0) {
        t = 'recharge';
      } else {
        t = 'expense';
      }
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "tr",
        { key: b.id },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_RichLabel__["a" /* default */], {
            content: t,
            translateMap: {
              recharge: _this3.intlMsg.msg('types.recharge'),
              expense: _this3.intlMsg.msg('types.expense')
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          b.time
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          b.amount
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          b.snapshot
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("td", null),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          b.cause
        )
      );
    });

    var fromDatePicker = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_DatePicker__["a" /* default */], { date: from, onSelect: this.handleSelectFrom });
    var toDatePicker = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_DatePicker__["a" /* default */], { date: to, onSelect: this.handleSelectTo });
    var filters = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_InlineSelect__["a" /* default */], {
      options: [{
        label: this.intlMsg.msg('types.options.all'),
        value: 'all',
        active: true
      }, {
        label: this.intlMsg.msg('types.options.recharge'),
        value: 'recharge'
      }, {
        label: this.intlMsg.msg('types.options.expense'),
        value: 'expense'
      }],
      values: [filter],
      onChange: function onChange(values) {
        return _this3.setState({ filter: values[0] });
      }
    });

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.balogs },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_PanelToolbar__["a" /* default */], { tools: [fromDatePicker, toDatePicker, filters] }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Table"],
        {
          className: "aisz-table-light",
          bordered: true,
          striped: true,
          hover: true,
          responsive: true
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('table.header.type')
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('table.header.time')
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('table.header.amount')
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('table.header.balance')
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('table.header.ref')
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('table.header.remark')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "tbody",
          null,
          rows
        )
      )
    );
  };

  Balogs.prototype.renderToolbar = function renderToolbar() {
    var _this4 = this;

    var breadcrumb = [{
      content: this.intlMsg.msg('billing', 'billing.breadcrumb'),
      onClick: function onClick() {
        return _this4.props.pushState('/billing');
      }
    }, {
      content: this.intlMsg.msg('balogs', 'billing.breadcrumb'),
      active: true
    }];
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  Balogs.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.wrapper },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        null,
        this.renderToolbar()
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Panel"],
          { bsStyle: "aisz-white" },
          this.renderBalance(),
          this.renderBalogs()
        )
      )
    );
  };

  return Balogs;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Balogs.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    plan: state.billing.plan
  };
};
var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_7_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(Balogs)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, moment) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_TablePager__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loraapi_Billing__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_main_scss__ = __webpack_require__(2251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_main_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_7_react_intl__["intlShape"].isRequired,
  location: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
};

var BillDetail = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(BillDetail, _React$Component);

  function BillDetail(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, BillDetail);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      more: false,
      mark: '',
      status: 'idle'
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_15_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'billing');
    _this.handleNext = _this.handleNext.bind(_this);
    _this.handlePrev = _this.handlePrev.bind(_this);
    return _this;
  }

  BillDetail.prototype.componentDidMount = function componentDidMount() {
    this.loadBill();
    this.loadCDRs();
  };

  BillDetail.prototype.intlMsg = function intlMsg(id) {
    return this.props.intl.formatMessage({
      id: "billing.billdetail." + id,
      defaultMessage: "billing.billdetail." + id
    });
  };

  BillDetail.prototype.loadBill = function loadBill() {
    var _this2 = this;

    var billid = this.props.location.query.id;
    if (billid) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_loraapi_Billing__["c" /* getBill */])(billid).then(function (resp) {
        _this2.setState({ bill: resp.body });
      }).catch(function () {});
    }
  };

  BillDetail.prototype.loadCDRs = function loadCDRs() {
    var _this3 = this;

    var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var args = _.extend({
      mark: this.state.mark,
      pageSize: 20
    }, a);
    var billid = this.props.location.query.id;

    if (billid) {
      this.setState({ status: 'loading' });

      var locale = this.props.intl.locale === 'zh' ? 'zh-CN' : 'en';
      moment.locale(locale);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_loraapi_Billing__["d" /* getCdrs */])(billid, args).then(function (resp) {
        var cdrs = resp.body.list.map(function (c) {
          var status = null;
          var duration = null;
          if (_.isNil(c.dtime)) {
            status = 'inuse';
            duration = moment() - moment(c.ctime);
          } else {
            status = 'deleted';
            duration = moment(c.dtime) - moment(c.ctime);
          }
          var ctime = moment(c.ctime).format('YY-MM-DD HH:mm:ss'); // eslint-disable-line
          var dtime = _.isNil(c.dtime) ? // eslint-disable-line
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "span",
            { styleName: "empty-val" },
            _this3.props.intl.formatMessage({
              id: 'lora.emptyval',
              defaultMessage: 'lora.emptyval'
            })
          ) : moment(c.dtime).format('YY-MM-DD HH:mm:ss');

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, c, { status: status, duration: duration, ctime: ctime, dtime: dtime });
        });
        _this3.setState({
          cdrs: cdrs,
          mark: resp.body.mark,
          more: resp.body.more,
          status: 'success'
        });
      }).catch(function () {
        _this3.setState({ status: 'failure' });
      });
    }
  };

  BillDetail.prototype.handleNext = function handleNext(mark) {
    this.loadCDRs({ mark: mark });
  };

  BillDetail.prototype.handlePrev = function handlePrev(mark) {
    this.loadCDRs({ mark: mark });
  };

  BillDetail.prototype.renderBillInfo = function renderBillInfo() {
    var bill = this.state.bill;


    if (bill) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { styleName: "bill-info" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "h5",
          null,
          bill.period,
          " \u8D26\u5355\u8BE6\u60C5"
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "ul",
          { className: "list-inline" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "li",
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "span",
              { styleName: "sub" },
              this.intlMsg.msg('billdetail.billid.lbl'),
              bill.id
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "li",
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "span",
              { styleName: "sub" },
              this.intlMsg.msg('billdetail.billtime.lbl'),
              moment(bill.createdAt).format('YY-MM-DD HH:mm')
            )
          )
        ),
        this.intlMsg.msg('billdetail.billinfo.desc1'),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          { styleName: "val" },
          bill.charge
        ),
        this.intlMsg.msg('billdetail.billinfo.desc2'),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          { styleName: "val" },
          bill.vol
        ),
        this.intlMsg.msg('billdetail.billinfo.desc3')
      );
    }
    return null;
  };

  BillDetail.prototype.renderToolbar = function renderToolbar() {
    var _this4 = this;

    var breadcrumb = [{
      content: this.intlMsg.msg('breadcrumb.billing'),
      onClick: function onClick() {
        return _this4.props.pushState('/billing');
      }
    }, {
      content: this.intlMsg.msg('breadcrumb.billlogs'),
      onClick: function onClick() {
        return _this4.props.pushState('/billing/billlogs');
      }
    }, {
      content: this.intlMsg.msg('breadcrumb.billdetail'),
      active: true
    }];

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  BillDetail.prototype.renderCDRsTable = function renderCDRsTable() {
    var _this5 = this;

    var cdrs = this.state.cdrs;


    if (_.isNil(cdrs)) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { styleName: "table-loading" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin fa-3x" })
      );
    }

    var rows = cdrs.map(function (c) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "tr",
        { key: c.rid },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          c.rid
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_RichLabel__["a" /* default */], {
            content: c.status,
            translateMap: {
              inuse: _this5.intlMsg.msg('billdetail.status.inuse'),
              deleted: _this5.intlMsg.msg('billdetail.status.deleted')
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          c.duration
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          c.ctime
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          c.dtime
        )
      );
    });

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { styleName: "detail-table-wrapper" },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { styleName: "detail-table" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Table"],
          {
            className: "aisz-table-light",
            bordered: true,
            striped: true,
            hover: true,
            responsive: true
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('billdetail.table.header.rid')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('billdetail.table.header.status')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('billdetail.table.header.uptime')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('billdetail.table.header.ctime')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('billdetail.table.header.dtime')
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "tbody",
            null,
            rows
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_TablePager__["a" /* default */], {
        pullRight: true,
        status: this.state.status,
        mark: this.state.mark,
        more: this.state.more,
        onNext: this.handleNext,
        onPrev: this.handlePrev
      })
    );
  };

  BillDetail.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { styleName: "wrapper" },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        null,
        this.renderToolbar()
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Panel"],
          { bsStyle: "aisz-white" },
          this.renderBillInfo(),
          this.renderCDRsTable()
        )
      )
    );
  };

  return BillDetail;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

BillDetail.propTypes = propTypes;

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_9_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_8_react_css_modules___default()(BillDetail, __WEBPACK_IMPORTED_MODULE_16__styles_main_scss___default.a, { allowMultiple: true }))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11), __webpack_require__(14)))

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, moment) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loraapi_Billing__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_main_scss__ = __webpack_require__(2252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_main_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);














var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_7_react_intl__["intlShape"].isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
};

var BillLogs = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(BillLogs, _React$Component);

  function BillLogs(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, BillLogs);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {};
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'billing');
    return _this;
  }

  BillLogs.prototype.componentDidMount = function componentDidMount() {
    this.loadBills();
  };

  BillLogs.prototype.loadBills = function loadBills(a) {
    var _this2 = this;

    var args = _.extend({
      from: this.state.from || moment().subtract(36, 'months'),
      to: this.state.to || moment()
    }, a);

    var from = args.from,
        to = args.to;

    from = from.format('YYYYMM01');
    to = to.add(1, 'months').format('YYYYMM01');

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_loraapi_Billing__["e" /* getBills */])(from, to).then(function (resp) {
      var bills = resp.body.list.map(function (b) {
        var price = _.round(b.price, 2);
        var charge = _.round(b.charge, 2);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, b, { price: price, charge: charge });
      });
      _this2.setState({ bills: bills });
    }).catch(function () {});
  };

  BillLogs.prototype.renderToolbar = function renderToolbar() {
    var _this3 = this;

    var breadcrumb = [{
      content: this.intlMsg.msg('breadcrumb.billing'),
      onClick: function onClick() {
        return _this3.props.pushState('/billing');
      }
    }, {
      content: this.intlMsg.msg('breadcrumb.billlogs'),
      active: true
    }];
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  BillLogs.prototype.renderBillsTable = function renderBillsTable() {
    var _this4 = this;

    var bills = this.state.bills;

    if (_.isNil(bills)) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { styleName: "table-loading" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin fa-3x", "aria-hidden": "true" })
      );
    }

    var rows = bills.map(function (b) {
      var status = null;

      if (b.charge >= 0 && b.payment) {
        status = 'paid';
      } else {
        status = 'unpaid';
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "tr",
        { key: b.id },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          b.id
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          b.period
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_RichLabel__["a" /* default */], {
            content: "nodefee",
            translateMap: {
              nodefee: _this4.intlMsg.msg('billlogs.table.feetypes.nodefee')
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          "\xA5",
          b.charge
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_RichLabel__["a" /* default */], {
            content: status,
            translateMap: {
              paid: _this4.intlMsg.msg('billlogs.table.paystatus.paid'),
              unpaid: _this4.intlMsg.msg('billlogs.table.paystatus.unpaid')
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "a",
            { // eslint-disable-line
              onClick: function onClick() {
                return _this4.props.pushState("/billing/billdetail?id=" + b.id);
              }
            },
            _this4.intlMsg.msg('billlogs.table.detail.link')
          )
        )
      );
    });

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Table"],
      {
        className: "aisz-table-light",
        striped: true,
        bordered: true,
        hover: true,
        responsive: true
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "thead",
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "th",
            null,
            this.intlMsg.msg('billlogs.table.header.billno')
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "th",
            null,
            this.intlMsg.msg('billlogs.table.header.billperiod')
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "th",
            null,
            this.intlMsg.msg('billlogs.table.header.servicetype')
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "th",
            null,
            this.intlMsg.msg('billlogs.table.header.totalfee')
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "th",
            null,
            this.intlMsg.msg('billlogs.table.header.paystatus')
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "th",
            null,
            this.intlMsg.msg('billlogs.table.header.actions')
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "tbody",
        null,
        rows
      )
    );
  };

  BillLogs.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { styleName: "wrapper" },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        null,
        this.renderToolbar()
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Panel"],
        { bsStyle: "aisz-white", header: this.intlMsg.msg('billlogs.panel.header') },
        this.renderBillsTable()
      )
    );
  };

  return BillLogs;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

BillLogs.propTypes = propTypes;

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_9_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_8_react_css_modules___default()(BillLogs, __WEBPACK_IMPORTED_MODULE_15__styles_main_scss___default.a, { allowMultiple: true }))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11), __webpack_require__(14)))

/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loraapi_Billing__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_ActionButton__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_PageLoading__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loraactions_billing__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loraactions_org__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__selectors__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss__ = __webpack_require__(2253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__images_alipay_png__ = __webpack_require__(2806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__images_alipay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__images_alipay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__images_wechatpay_340x120_zh_svg__ = __webpack_require__(2780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__images_wechatpay_340x120_zh_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__images_wechatpay_340x120_zh_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__images_wechatpay_340x120_en_svg__ = __webpack_require__(2779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__images_wechatpay_340x120_en_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__images_wechatpay_340x120_en_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__images_wechatpay_phone_png__ = __webpack_require__(2807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__images_wechatpay_phone_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__images_wechatpay_phone_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__images_alipay_icon_svg__ = __webpack_require__(2777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__images_alipay_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__images_alipay_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__images_recharge_svg__ = __webpack_require__(2778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__images_recharge_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__images_recharge_svg__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



























var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  plan: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  getBalog: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  billPaid: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.bool.isRequired,
  getBasic: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  getPlan: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  locale: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired
};

var Recharge = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Recharge, _React$Component);

  function Recharge(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Recharge);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      plan: props.plan,
      billPaid: props.billPaid,
      locale: props.locale,
      errSeen: false,
      amount: '',
      method: 'alipay',
      status: 'ready',
      valid: true,
      view: 'main',
      remaining: 120,
      showRechgCardModal: false,
      rechgCardStatus: ''
    };

    _this.handleChangeAmount = _this.handleChangeAmount.bind(_this);
    _this.handleChangeMethod = _this.handleChangeMethod.bind(_this);
    _this.handleAlipayCharge = _this.handleAlipayCharge.bind(_this);
    _this.handleWechatCharge = _this.handleWechatCharge.bind(_this);
    _this.handleSubmitRecharge = _this.handleSubmitRecharge.bind(_this);
    _this.handleReloadWechatCharge = _this.handleReloadWechatCharge.bind(_this);
    _this.rechgAgain = _this.rechgAgain.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_16_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'billing.recharge');
    return _this;
  }

  Recharge.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var plan = nextProps.plan,
        billPaid = nextProps.billPaid,
        locale = nextProps.locale;

    if (plan !== this.props.plan) {
      this.setState({ plan: plan });
    }
    if (locale !== this.props.locale) {
      this.setState({ locale: locale });
    }

    if (billPaid) {
      this.setState({ billPaid: billPaid });
    }
  };

  Recharge.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.watchTimeout) {
      clearTimeout(this.watchTimeout);
    }
    if (this.countDownTimeout) {
      clearTimeout(this.countDownTimeout);
    }
    var billPaid = this.state.billPaid;

    if (billPaid) {
      var _props = this.props,
          getBasic = _props.getBasic,
          getPlan = _props.getPlan;

      getBasic();
      getPlan();
    }
  };

  Recharge.prototype.validateAmount = function validateAmount(amount) {
    var _state = this.state,
        plan = _state.plan.data,
        method = _state.method;

    if (method === 'rechgcard') {
      return true;
    }
    var valid = true;
    var error = null;
    if (amount.length === '') {
      valid = false;
      error = this.intlMsg.msg('errmsg.absent');
    } else if (amount.search(/^\d+(\.\d{0,2})?$/)) {
      valid = false;
      error = this.intlMsg.msg('errmsg.malformed');
    } else if (+amount <= 0) {
      valid = false;
      error = this.intlMsg.msg('errmsg.negative');
    } else if (+amount >= 100000) {
      valid = false;
      error = this.intlMsg.msg('errmsg.toolarge');
    } else if (plan.tier !== 3 && +amount < 200) {
      valid = false;
      error = this.intlMsg.msg('errmsg.toolow');
    }
    this.setState({
      valid: valid,
      error: error
    });
    if (!valid) {
      this.setState({
        errSeen: true
      });
    }
    return valid;
  };

  Recharge.prototype.handleChangeAmount = function handleChangeAmount(e) {
    var amount = _.trim(e.target.value);
    if (this.state.errSeen) {
      this.validateAmount(amount);
    }
    this.setState({ amount: amount });
  };

  Recharge.prototype.handleSubmitRecharge = function handleSubmitRecharge(e) {
    var _this2 = this;

    e.preventDefault();
    var method = this.state.method;
    var amount = this.state.amount;

    if (method === 'rechgcard') {
      if (amount.length === 0) {
        return;
      }
      this.setState({ showRechgCardModal: true, rechgCardStatus: 'rechging' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_loraapi_Billing__["a" /* rechgCard */])(amount).then(function () {
        _this2.setState({ rechgCardStatus: 'success', billPaid: true });
      }).catch(function (err) {
        if (err.errmsg) {
          _this2.setState({ rechgCardStatus: err.errmsg });
        }
      });
    } else {
      if (!this.validateAmount(amount)) {
        return;
      }

      this.setState({ status: 'loading', billPaid: false });

      if (method === 'alipay') {
        this.setState({
          showConfirmModal: true
        });
        this.newWindow = window.open(window.location.origin + "/static/loading.html", '_blank');
      }

      amount = Number(amount);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_loraapi_Billing__["b" /* createCharge */])('recharge', method, amount, null).then(function (resp) {
        if (method === 'alipay') {
          _this2.handleAlipayCharge(resp.body);
        } else if (method === 'wechat') {
          _this2.handleWechatCharge(resp.body);
        }
      }).catch(function () {
        _this2.setState({
          status: 'failed'
        });
      });
    }
  };

  Recharge.prototype.handleAlipayCharge = function handleAlipayCharge(charge) {
    var params = $.param(charge);
    this.setState({
      status: 'ready'
    });
    var url = "https://mapi.alipay.com/gateway.do?" + params;
    this.newWindow.location.href = url;
  };

  Recharge.prototype.startWatchBill = function startWatchBill(billId) {
    var getBalog = this.props.getBalog;

    var that = this;

    var g = function g() {
      getBalog(billId);
      var _that$state = that.state,
          billPaid = _that$state.billPaid,
          remaining = _that$state.remaining;

      if (remaining > 0 && !billPaid) {
        that.watchTimeout = setTimeout(g, 3000);
      }
    };

    this.watchTimeout = setTimeout(g, 3000);
  };

  Recharge.prototype.startCountDown = function startCountDown() {
    var _this3 = this;

    var that = this;
    var g = function g() {
      var _that$state2 = that.state,
          remaining = _that$state2.remaining,
          billPaid = _that$state2.billPaid;

      if (remaining > 0 && !billPaid) {
        that.setState({ remaining: remaining - 1 });
        _this3.countDownTimeout = setTimeout(g, 1000);
      }
    };
    this.countDownTimeout = setTimeout(g, 1000);
  };

  Recharge.prototype.handleWechatCharge = function handleWechatCharge(charge) {
    var retCode = charge.return_code;
    var resCode = charge.result_code;
    var qrCode = charge.qr_code;
    if (retCode === 'SUCCESS' || resCode === 'SUCCESS') {
      this.setState({
        view: 'wechatpay',
        qrCode: qrCode,
        charge: charge,
        status: 'ready',
        remaining: 120
      });
      this.startWatchBill(charge.bill_id);
      this.startCountDown();
    } else {
      this.setState({
        status: 'failed'
      });
    }
  };

  Recharge.prototype.handleReloadWechatCharge = function handleReloadWechatCharge() {
    var charge = this.state.charge;

    this.handleWechatCharge(charge);
  };

  Recharge.prototype.handleChangeMethod = function handleChangeMethod(method) {
    this.setState({ method: method });
    if (method === 'rechgcard') {
      this.setState({ valid: true, amount: '' });
    }
  };

  Recharge.prototype.rechgAgain = function rechgAgain() {
    this.setState({ showRechgCardModal: false, amount: '' });
  };

  Recharge.prototype.renderToolbar = function renderToolbar() {
    var _this4 = this;

    var view = this.state.view;

    var breadcrumb = void 0;
    if (view === 'main') {
      breadcrumb = [{
        content: this.intlMsg.msg('billing', 'billing.breadcrumb'),
        onClick: function onClick() {
          return _this4.props.pushState('/billing');
        }
      }, {
        content: this.intlMsg.msg('recharge', 'billing.breadcrumb'),
        active: true
      }];
    } else {
      breadcrumb = [{
        content: this.intlMsg.msg('billing', 'billing.breadcrumb'),
        onClick: function onClick() {
          return _this4.props.pushState('/billing');
        }
      }, {
        content: this.intlMsg.msg('recharge', 'billing.breadcrumb'),
        onClick: function onClick() {
          return _this4.setState({ view: 'main' });
        }
      }, {
        content: this.intlMsg.msg('recharge.wechat', 'billing.breadcrumb'),
        active: true
      }];
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  Recharge.prototype.renderMainView = function renderMainView() {
    var _this5 = this;

    var _state2 = this.state,
        error = _state2.error,
        valid = _state2.valid,
        method = _state2.method,
        amount = _state2.amount;

    var errmsg = null;
    if (!valid) {
      errmsg = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { styleName: "error" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle", "aria-hidden": "true" }),
        ' ',
        error
      );
    }

    var icon = void 0;
    var loadingLabel = void 0;
    var placeholder = void 0;
    if (method === 'alipay') {
      icon = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_25__images_alipay_icon_svg___default.a, alt: "" });
      loadingLabel = this.intlMsg.msg('form.alipay.redirecting');
      placeholder = this.intlMsg.msg('form.placeholder');
    } else if (method === 'wechat') {
      icon = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-weixin" });
      loadingLabel = this.intlMsg.msg('form.wechat.loading');
      placeholder = this.intlMsg.msg('form.placeholder');
    } else if (method === 'rechgcard') {
      icon = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-credit-card" });
      placeholder = this.intlMsg.msg('form.placeholdercard');
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        null,
        this.renderToolbar()
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Panel"],
        { bsStyle: "aisz-white" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { styleName: "methods" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "ul",
            { className: "list-inline" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "li",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                {
                  styleName: "method " + (method === 'alipay' ? 'active' : ''),
                  onClick: function onClick() {
                    return _this5.handleChangeMethod('alipay');
                  }
                },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", { alt: "AliPay", src: __WEBPACK_IMPORTED_MODULE_21__images_alipay_png___default.a, className: "img-responsive" })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "li",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                {
                  styleName: "method " + (method === 'wechat' ? 'active' : ''),
                  onClick: function onClick() {
                    return _this5.handleChangeMethod('wechat');
                  }
                },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", { alt: "WeChat Pay", src: this.props.intl.locale === 'zh' ? __WEBPACK_IMPORTED_MODULE_22__images_wechatpay_340x120_zh_svg___default.a : __WEBPACK_IMPORTED_MODULE_23__images_wechatpay_340x120_en_svg___default.a, className: "img-responsive" })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "li",
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                {
                  styleName: "method " + (method === 'rechgcard' ? 'active' : '') + " widthAuto clearLine",
                  onClick: function onClick() {
                    return _this5.handleChangeMethod('rechgcard');
                  }
                },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", {
                  alt: "Recharge Card",
                  src: __WEBPACK_IMPORTED_MODULE_26__images_recharge_svg___default.a,
                  className: "img-responsive",
                  styleName: "inline"
                }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { styleName: "cardTxt clearLine" },
                  "\xA0",
                  this.intlMsg.msg('types.card')
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { styleName: "recharge-form" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Form"],
            { inline: true, onSubmit: this.handleSubmitRecharge },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormGroup"],
              { validationState: valid ? undefined : 'error' },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormControl"], {
                bsClass: "aisz-form-control",
                placeholder: placeholder,
                value: amount,
                onChange: this.handleChangeAmount
              })
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormGroup"],
              null,
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_ActionButton__["a" /* default */], {
                type: "submit",
                icon: icon,
                label: this.intlMsg.msg('form.submit.btn'),
                loadingLabel: loadingLabel,
                failedLabel: this.intlMsg.msg('form.err.submiterr'),
                status: this.state.status,
                onStatusReset: function onStatusReset() {
                  return _this5.setState({ status: 'ready' });
                },
                disabled: !valid
              })
            )
          ),
          errmsg
        )
      )
    );
  };

  Recharge.prototype.renderQrCode = function renderQrCode() {
    var _state3 = this.state,
        qrCode = _state3.qrCode,
        remaining = _state3.remaining,
        billPaid = _state3.billPaid;


    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { styleName: "qrcode" },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", { src: "data:image/png;base64," + qrCode, alt: "", className: "img-responsive" }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_15_loracoms_ShowIf__["a" /* default */],
        { "if": remaining <= 0 },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { styleName: "result expired" },
          this.intlMsg.msg('wechat.qrcode.expired'),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
            {
              bsStyle: "aisz-link",
              onClick: this.handleReloadWechatCharge
            },
            this.intlMsg.msg('wechat.qrcode.refresh'),
            ' ',
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-refresh" })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_15_loracoms_ShowIf__["a" /* default */],
        { "if": billPaid },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { styleName: "result success" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-tick" }),
          ' ',
          this.intlMsg.msg('wechat.qrcode.success')
        )
      )
    );
  };

  Recharge.prototype.renderCountDown = function renderCountDown() {
    var _state4 = this.state,
        remaining = _state4.remaining,
        billPaid = _state4.billPaid;

    if (remaining <= 0 || billPaid) {
      return null;
    }
    var miniutes = Math.floor(remaining / 60);
    var seconds = remaining % 60;
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { styleName: "countdown" },
      this.intlMsg.msg('wechat.countdown.text1'),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "span",
        { styleName: "remaining" },
        miniutes + ":" + seconds
      ),
      this.intlMsg.msg('wechat.countdown.text2')
    );
  };

  Recharge.prototype.renderWechatPayView = function renderWechatPayView() {
    var charge = this.state.charge;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        null,
        this.renderToolbar()
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { styleName: "bill-info" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "ul",
          { className: "list-inline" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "li",
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "span",
              { styleName: "label" },
              this.intlMsg.msg('wechat.billid')
            ),
            charge.bill_id
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "li",
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "span",
              { styleName: "label" },
              this.intlMsg.msg('wechat.amount')
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "strong",
              null,
              charge.amount
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Panel"],
        { bsStyle: "aisz-white" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { styleName: "wechat" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { styleName: "scan" },
              this.renderQrCode(),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { styleName: "footer" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-qrcode" }),
                ' ',
                this.intlMsg.msg('wechat.scancode')
              ),
              this.renderCountDown()
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { styleName: "scanillu" },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_24__images_wechatpay_phone_png___default.a, alt: "", className: "img-responsive" })
            )
          )
        )
      )
    );
  };

  Recharge.prototype.renderConfirmModal = function renderConfirmModal() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-light",
        show: this.state.showConfirmModal,
        backdrop: "static",
        onHide: function onHide() {
          return _this6.setState({ showConfirmModal: false });
        }
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        this.intlMsg.msg('confirmmodal.header')
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "p",
            null,
            this.intlMsg.msg('confirmmodal.body')
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
            {
              bsStyle: "aisz-primary",
              onClick: function onClick() {
                return _this6.setState({ showConfirmModal: false });
              }
            },
            this.intlMsg.msg('confirmmodal.button.redo'),
            ' ',
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-repeat" })
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
            {
              bsStyle: "aisz-success",
              onClick: function onClick() {
                return _this6.props.pushState('/billing');
              }
            },
            this.intlMsg.msg('confirmmodal.button.complete'),
            ' ',
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-tick" })
          )
        )
      )
    );
  };

  Recharge.prototype.render = function render() {
    var _this7 = this;

    var _state5 = this.state,
        plan = _state5.plan,
        view = _state5.view;

    var content = null;

    if (plan.status !== 'success') {
      content = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_PageLoading__["a" /* default */], null);
    } else if (view === 'main') {
      content = this.renderMainView();
    } else if (view === 'wechatpay') {
      content = this.renderWechatPayView();
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { styleName: "wrapper" },
      content,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        null,
        this.renderConfirmModal()
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"],
        {
          bsClass: "aisz-modal-light",
          show: this.state.showRechgCardModal,
          backdrop: "static",
          onHide: function onHide() {
            return _this7.setState({ showRechgCardModal: false });
          }
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"].Dialog,
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "clearfix " + __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.cancelHeader },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */], {
              className: "fa fa-times pull-right",
              onClick: this.rechgAgain
            })
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"].Body,
            { className: "text-center" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_15_loracoms_ShowIf__["a" /* default */],
              { "if": this.state.rechgCardStatus === 'rechging' },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-spin fa-spinner fa-3x", styleName: "cardLoading" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "p",
                  { styleName: "cardLoading" },
                  this.intlMsg.msg('rechgcard.rechging')
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_15_loracoms_ShowIf__["a" /* default */],
              { "if": this.state.rechgCardStatus === 'success' },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-check fa-3x text-success" }),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "p",
                    { styleName: "cardTxt" },
                    this.intlMsg.msg('confirmmodal.button.complete')
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
                    {
                      bsStyle: "aisz-primary",
                      onClick: this.rechgAgain
                    },
                    this.intlMsg.msg('rechgcard.continue'),
                    "\xA0",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-repeat" })
                  ),
                  "\xA0",
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
                    {
                      bsStyle: "aisz-success",
                      onClick: function onClick() {
                        return _this7.props.pushState('/billing');
                      }
                    },
                    this.intlMsg.msg('rechgcard.complete'),
                    "\xA0",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-tick" })
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_15_loracoms_ShowIf__["a" /* default */],
              { "if": this.state.rechgCardStatus !== 'success' },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-exclamation-circle fa-3x text-danger" }),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_15_loracoms_ShowIf__["a" /* default */],
                  { "if": this.state.rechgCardStatus === 'Invalid RchgCard ID' },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "p",
                    { styleName: "cardTxt" },
                    this.intlMsg.msg('rechgcard.errcode')
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_15_loracoms_ShowIf__["a" /* default */],
                  { "if": this.state.rechgCardStatus === 'Applied' },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "p",
                    { styleName: "cardTxt" },
                    this.intlMsg.msg('rechgcard.errcodeused')
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_15_loracoms_ShowIf__["a" /* default */],
                  { "if": this.state.rechgCardStatus === 'ErrExpired' },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "p",
                    { styleName: "cardTxt" },
                    this.intlMsg.msg('rechgcard.errexpired')
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
                    {
                      bsStyle: "aisz-primary",
                      onClick: this.rechgAgain
                    },
                    this.intlMsg.msg('rechgcard.tryagain'),
                    "\xA0",
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-repeat" })
                  )
                )
              )
            )
          )
        )
      )
    );
  };

  return Recharge;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Recharge.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    plan: state.billing.plan,
    billPaid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__selectors__["a" /* billPaidSelector */])(state),
    locale: state.intl.locale
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["routerActions"].push,
  getBalog: __WEBPACK_IMPORTED_MODULE_17_loraactions_billing__["a" /* default */].getBalog,
  getBasic: __WEBPACK_IMPORTED_MODULE_18_loraactions_org__["a" /* default */].basic,
  getPlan: __WEBPACK_IMPORTED_MODULE_17_loraactions_billing__["a" /* default */].plan
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_5_react_css_modules___default()(Recharge, __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a, { allowMultiple: true }))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return billPaidSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var balogSelector = function balogSelector(state) {
  return state.billing.getBalog;
};
var billPaidSelector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(balogSelector, function (balog) {
  if (balog.status !== 'success') {
    return false;
  }
  if (__WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default()(balog.data)) {
    return false;
  }
  return true;
});

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_LineChart__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loraapi_Billing__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PayStrategy__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_main_scss__ = __webpack_require__(2254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_user_svg__ = __webpack_require__(2781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_user_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_user_svg__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  orgBasic: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  accountBasic: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  plan: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired
};

var CommercialView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(CommercialView, _React$Component);

  function CommercialView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CommercialView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      orgBasic: props.orgBasic,
      accountBasic: props.accountBasic,
      plan: props.plan,
      series: {
        categories: [],
        costs: {
          name: _this.intlMsg('chart.series.costs'),
          data: [],
          yAxisIndex: 0
        },
        nodes: {
          name: _this.intlMsg('chart.series.nodes'),
          data: [],
          yAxisIndex: 1
        }
      }
    };
    return _this;
  }

  CommercialView.prototype.componentDidMount = function componentDidMount() {
    this.loadBills();
  };

  CommercialView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var orgBasic = nextProps.orgBasic,
        accountBasic = nextProps.accountBasic,
        plan = nextProps.plan;

    if (orgBasic !== this.props.orgBasic) {
      this.setState({ orgBasic: orgBasic });
    }
    if (accountBasic !== this.props.accountBasic) {
      this.setState({ accountBasic: accountBasic });
    }
    if (plan !== this.props.plan) {
      this.setState({ plan: plan });
    }
  };

  CommercialView.prototype.loadBills = function loadBills() {
    var _this2 = this;

    var to = moment().add(1, 'months').format('YYYYMM01');
    var from = moment().subtract(11, 'months').format('YYYYMM01');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_loraapi_Billing__["e" /* getBills */])(from, to).then(function (resp) {
      // list last 12 months bills, if absent, pad with zero
      var t = moment().subtract(11, 'months');
      var eom = moment().format('YYYYMM');
      var periods = [];
      while (t.format('YYYYMM') <= eom) {
        periods.push(t.format('YYYYMM'));
        t = t.add(1, 'months');
      }
      var bills = _.sortBy(resp.body.list, 'period');
      var charges = periods.map(function (p) {
        var bill = _.find(bills, function (b) {
          return b.period === p;
        });
        if (_.isNil(bill)) {
          return 0;
        }
        return _.round(bill.charge, 2);
      });
      var vols = periods.map(function (p) {
        var bill = _.find(bills, function (b) {
          return b.period === p;
        });
        if (_.isNil(bill)) {
          return 0;
        }
        return bill.vol;
      });
      _this2.setState({
        series: {
          categories: periods,
          costs: {
            name: _this2.intlMsg('chart.series.costs'),
            data: charges,
            yAxisIndex: 0
          },
          nodes: {
            name: _this2.intlMsg('chart.series.nodes'),
            data: vols,
            yAxisIndex: 1
          }
        }
      });
    });
  };

  CommercialView.prototype.intlMsg = function intlMsg(id) {
    return this.props.intl.formatMessage({
      id: "billing.commercialview." + id,
      defaultMessage: "billing.commercialview." + id
    });
  };

  CommercialView.prototype.billday = function billday(d) {
    if (this.props.intl.locale === 'zh') {
      return d;
    }
    switch (d) {
      case 1:
        return '1st';
      case 2:
        return '2nd';
      case 3:
        return '3rd';
      default:
        return d + "th";
    }
  };

  CommercialView.prototype.renderInfoPanel = function renderInfoPanel() {
    var _this3 = this;

    var _state = this.state,
        orgBasic = _state.orgBasic,
        plan = _state.plan;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white" },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { styleName: "bills-info" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { styleName: "content-card" },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h5",
                { styleName: "bold-title" },
                this.intlMsg('bills.lbl')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "span",
                { styleName: "billday" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  null,
                  this.intlMsg('bills.billday.desc.prefix')
                ),
                ' ',
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { styleName: "billday-val" },
                  this.billday(plan.billday)
                ),
                ' ',
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  null,
                  this.intlMsg('bills.billday.desc.postfix')
                )
              ),
              ' ',
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { styleName: "bill-help" },
                this.intlMsg('bills.billhelp.desc1')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
                {
                  bsStyle: "aisz-primary-b",
                  onClick: function onClick() {
                    return _this3.props.pushState('/billing/billlogs');
                  }
                },
                this.intlMsg('bills.billlog.btn'),
                ' ',
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-file-text-o" })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "h5",
            { styleName: "bold-title extra-pd" },
            this.intlMsg('paystrategy')
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { styleName: "extra-pd" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__PayStrategy__["a" /* default */], null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { styleName: "basic-info" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { styleName: "content-card" },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "h5",
                { styleName: "bold-title" },
                this.intlMsg('balance.lbl')
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                { styleName: "balance" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { styleName: "balance-val" },
                  orgBasic.balance
                ),
                ' ',
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  null,
                  " ",
                  this.intlMsg('balance.unit'),
                  " "
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "ul",
                  { className: "list-inline" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "li",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
                      {
                        bsStyle: "aisz-primary",
                        onClick: function onClick() {
                          return _this3.props.pushState('/billing/recharge');
                        }
                      },
                      this.intlMsg('recharge.btn')
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "li",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
                      {
                        bsStyle: "aisz-link",
                        onClick: function onClick() {
                          return _this3.props.pushState('/billing/balogs');
                        }
                      },
                      this.intlMsg('balance.logs.link')
                    )
                  )
                )
              )
            )
          )
        )
      )
    );
  };

  CommercialView.prototype.renderChartPanel = function renderChartPanel() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white" },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_LineChart__["a" /* default */], {
        height: 360,
        yAxis: [{
          name: this.intlMsg('chart.yaxis.costs')
        }, {
          name: this.intlMsg('chart.yaxis.nodes'),
          splitLine: {
            show: false
          }
        }],
        legend: {
          data: [this.intlMsg('chart.series.costs'), this.intlMsg('chart.series.nodes')]
        },
        series: [this.state.series.costs, this.state.series.nodes],
        categories: this.state.series.categories
      })
    );
  };

  CommercialView.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      null,
      this.renderInfoPanel(),
      this.renderChartPanel()
    );
  };

  return CommercialView;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

CommercialView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    orgBasic: state.org.basic.data || {},
    accountBasic: state.account.basic.data || {},
    plan: state.billing.plan.data || {}
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_9_react_css_modules___default()(CommercialView, __WEBPACK_IMPORTED_MODULE_13__styles_main_scss___default.a, { allowMultiple: true }))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14), __webpack_require__(11)))

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_ActionButton__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loraapi_Billing__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loraactions_billing__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loraactions_org__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PayStrategy__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_main_scss__ = __webpack_require__(2256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_svcpkg_svg__ = __webpack_require__(2783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_svcpkg_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__images_svcpkg_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_svcpkg_user_svg__ = __webpack_require__(2782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_svcpkg_user_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__images_svcpkg_user_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_upgrade_svg__ = __webpack_require__(2784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_upgrade_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__images_upgrade_svg__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



















var propTypes = {
  plan: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  getOrgBasic: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getPlan: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var UnderCommercialView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(UnderCommercialView, _React$Component);

  function UnderCommercialView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, UnderCommercialView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      plan: props.plan,
      acctCode: '',
      acctCodeStatus: 'ready'
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'billing.undercommercial');
    _this.handleActivate = _this.handleActivate.bind(_this);
    return _this;
  }

  UnderCommercialView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var plan = nextProps.plan;

    if (plan !== this.props.plan) {
      this.setState({ plan: plan });
    }
  };

  UnderCommercialView.prototype.handleActivate = function handleActivate(e) {
    var _this2 = this;

    e.preventDefault();

    var _props = this.props,
        getOrgBasic = _props.getOrgBasic,
        getPlan = _props.getPlan;
    var acctCode = this.state.acctCode;

    if (acctCode.length > 0) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_loraapi_Billing__["f" /* applyAcctCode */])(acctCode).then(function () {
        _this2.setState({ acctCodeStatus: 'success' });
        setTimeout(function () {
          getOrgBasic();
          getPlan();
        }, 1000);
      }).catch(function () {
        _this2.setState({ acctCodeStatus: 'failed' });
      });
    }
  };

  UnderCommercialView.prototype.renderSvcPkg = function renderSvcPkg() {
    var plan = this.state.plan;

    if (plan.tier === 1) {
      return this.renderSvcPkgUp();
    }
    return this.renderSvcPkgUser();
  };

  UnderCommercialView.prototype.renderSvcPkgUp = function renderSvcPkgUp() {
    var _this3 = this;

    var header = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "span",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_17__images_svcpkg_svg___default.a, alt: "" }),
      ' ',
      this.intlMsg.msg('acctcode.toactive.panelheader')
    );

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { styleName: "svc-pkg" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Panel"],
        { bsStyle: "aisz-white", header: header },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { styleName: "svc-pkg-desc" },
          this.intlMsg.msg('acctcode.toactive.desc1'),
          " ",
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "h3",
            null,
            this.intlMsg.msg('acctcode.toactive.desc2')
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
            {
              bsStyle: "aisz-primary-ob",
              onClick: function onClick() {
                window.location = '/public/prd/acct-code';
              }
            },
            this.intlMsg.msg('acctcode.toactive.btn'),
            ' ',
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-arrow-circle-o-right" })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { styleName: "svc-pkg-form" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "h3",
            null,
            this.intlMsg.msg('acctcode.form.title')
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Form"],
            { inline: true, onSubmit: this.handleActivate },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormControl"], {
                bsClass: "aisz-form-control",
                placeholder: this.intlMsg.msg('acctcode.form.placeholder'),
                value: this.state.acctCode,
                onChange: function onChange(e) {
                  return _this3.setState({ acctCode: e.target.value.trim() });
                }
              })
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_ActionButton__["a" /* default */], {
                icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-bolt", "aria-hidden": "true" }),
                label: this.intlMsg.msg('acctcode.form.activate.btn'),
                successLabel: this.intlMsg.msg('acctcode.form.activate.success'),
                failedLabel: this.intlMsg.msg('acctcode.form.activate.failed'),
                type: "submit",
                status: this.state.acctCodeStatus,
                onStatusReset: function onStatusReset() {
                  return _this3.setState({ acctCodeStatus: 'ready' });
                }
              })
            )
          )
        )
      )
    );
  };

  UnderCommercialView.prototype.renderSvcPkgUser = function renderSvcPkgUser() {
    var plan = this.state.plan;

    var header = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "span",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_18__images_svcpkg_user_svg___default.a, alt: "" }),
      ' ',
      this.intlMsg.msg('acctcode.activated.panelheader')
    );
    var remainingStyle = '';
    var remainingTips = null;
    if (plan.remaining <= 30) {
      remainingStyle = 'remaining-urgent';
      remainingTips = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "span",
        { styleName: "remaining-tips" },
        this.intlMsg.msg('acctcode.activated.svcexpire.remain.tips')
      );
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { styleName: "svc-pkg" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Panel"],
        { bsStyle: "aisz-white", header: header },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { styleName: "svc-pkg-desc" },
          this.intlMsg.msg('acctcode.activated.desc1'),
          " ",
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "ul",
            { className: "list-unstyled" },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "li",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "label",
                null,
                " ",
                this.intlMsg.msg('acctcode.activated.svcexpire.remain.lbl'),
                " "
              ),
              ' ',
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "span",
                { styleName: remainingStyle },
                plan.remaining
              ),
              ' ',
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "label",
                null,
                " ",
                this.intlMsg.msg('acctcode.activated.svcexpire.remain.unit'),
                " "
              )
            )
          ),
          remainingTips
        )
      )
    );
  };

  UnderCommercialView.prototype.renderCommUp = function renderCommUp() {
    var _this4 = this;

    var header = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "span",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_19__images_upgrade_svg___default.a, alt: "" }),
      ' ',
      this.intlMsg.msg('commup.panelheader')
    );
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { styleName: "comm-up" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Panel"],
        { bsStyle: "aisz-white", header: header },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { styleName: "comm-up-desc" },
          this.intlMsg.msg('commup.desc1'),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { styleName: "sub" },
            this.intlMsg.msg('commup.desc2')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
          { bsStyle: "aisz-primary-o", onClick: function onClick() {
              return _this4.props.pushState('/billing/recharge?amount=200');
            } },
          this.intlMsg.msg('recharge.btn'),
          ' ',
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-level-up", "aria-hidden": "true" })
        )
      )
    );
  };

  UnderCommercialView.prototype.renderPay = function renderPay() {
    var header = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "span",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_19__images_upgrade_svg___default.a, alt: "" }),
      ' ',
      this.intlMsg.msg('pay.panelheader')
    );
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { styleName: "comm-up" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Panel"],
        { bsStyle: "aisz-white", header: header },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { styleName: "comm-up-desc" },
          this.intlMsg.msg('pay.title')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__PayStrategy__["a" /* default */], null)
      )
    );
  };

  UnderCommercialView.prototype.render = function render() {
    var plan = this.state.plan;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { styleName: "wrapper" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Grid"],
        { fluid: true },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
              { "if": plan.tier === 1 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "div",
                { styleName: "heading" },
                this.intlMsg.msg('options.heading')
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
          null,
          this.renderCommUp()
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
          null,
          this.renderSvcPkg()
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
          null,
          this.renderPay()
        )
      )
    );
  };

  return UnderCommercialView;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

UnderCommercialView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    plan: state.billing.plan.data || {}
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_5_react_router_redux__["routerActions"].push,
  getPlan: __WEBPACK_IMPORTED_MODULE_13_loraactions_billing__["a" /* default */].plan,
  getOrgBasic: __WEBPACK_IMPORTED_MODULE_14_loraactions_org__["a" /* default */].basic
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_11_react_css_modules___default()(UnderCommercialView, __WEBPACK_IMPORTED_MODULE_16__styles_main_scss___default.a, { allowMultiple: true }))));

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_animate_css_animate_min_css__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_animate_css_animate_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_animate_css_animate_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_PageLoading__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_api_status__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__coms_UnderCommercialView__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__coms_CommercialView__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_main_scss__ = __webpack_require__(2257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_main_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);
















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.any.isRequired,
  plan: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.object.isRequired,
  basic: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.object.isRequired
};

var Billing = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Billing, _React$Component);

  function Billing(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Billing);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      bills: [],
      plan: props.plan,
      basic: props.basic
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'billing');
    return _this;
  }

  Billing.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var plan = nextProps.plan,
        basic = nextProps.basic;

    if (plan !== this.props.plan) {
      this.setState({ plan: plan });
    }
    if (basic !== this.props.basic) {
      this.setState({ basic: basic });
    }
  };

  Billing.prototype.renderToolbar = function renderToolbar() {
    var breadcrumb = [{
      content: this.intlMsg.msg('breadcrumb.billing'),
      active: true
    }];
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  Billing.prototype.renderExpire = function renderExpire() {
    var planData = this.state.plan.data;

    if (planData.expired) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "div",
        { styleName: "expired-notify-wrapper" },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "div",
          { styleName: "expired-notify", className: "animated fadeInDown" },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("i", { className: "fa fa-exclamation-circle" }),
          ' ',
          this.intlMsg.msg('expired.notify')
        )
      );
    }
    return null;
  };

  Billing.prototype.render = function render() {
    var _state = this.state,
        plan = _state.plan,
        basic = _state.basic;

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lorautils_api_status__["a" /* allSuccess */])(plan, basic)) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_PageLoading__["a" /* default */], null);
    }
    var content = null;
    if (plan.data.tier === 3) {
      content = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__coms_CommercialView__["a" /* default */], null);
    } else {
      content = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__coms_UnderCommercialView__["a" /* default */], null);
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      "div",
      null,
      this.renderExpire(),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "div",
        { styleName: "wrapper", style: { minHeight: window.innerHeight - 50 } },
        content
      )
    );
  };

  return Billing;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Billing.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    plan: state.billing.plan,
    basic: state.org.basic
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_5_react_css_modules___default()(Billing, __WEBPACK_IMPORTED_MODULE_15__styles_main_scss___default.a))));

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNil__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracfg__ = __webpack_require__(65);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any,
  plan: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object
};

var ExpireLatch = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ExpireLatch, _React$Component);

  function ExpireLatch() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ExpireLatch);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ExpireLatch.prototype.componentWillMount = function componentWillMount() {
    this.checkExpire();
  };

  ExpireLatch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var plan = nextProps.plan;

    if (!__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(plan, this.props.plan)) {
      this.setState({ plan: plan });
    }
    this.checkExpire(nextProps);
  };

  ExpireLatch.prototype.checkExpire = function checkExpire() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

    if (__WEBPACK_IMPORTED_MODULE_7_loracfg__["a" /* default */].profile === 'cube') {
      return;
    }
    var _props$plan$data = props.plan.data,
        planData = _props$plan$data === undefined ? {} : _props$plan$data,
        gotoBilling = props.gotoBilling;

    if (planData.expired) {
      gotoBilling();
    }
  };

  ExpireLatch.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      this.props.children
    );
  };

  return ExpireLatch;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ExpireLatch.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    plan: state.billing.plan
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    gotoBilling: function gotoBilling() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__["push"])('/billing'));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(ExpireLatch));

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_animate_css_animate_css__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_animate_css_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_animate_css_animate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNil__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_SearchSelector__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loraactions_enums__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_loraactions_gateway__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_loraactions_usage__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_main_scss__ = __webpack_require__(2258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__styles_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selectors__ = __webpack_require__(1275);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);
























var propTypes = {
  addGateway: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  addResult: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  getPlatforms: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.any.isRequired,
  platOpts: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.array.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  getGatewayUsage: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired
};

var GatewayAdd = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(GatewayAdd, _React$Component);

  function GatewayAdd(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GatewayAdd);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      platOpts: props.platOpts,
      formStatus: 'ready',
      errors: new __WEBPACK_IMPORTED_MODULE_17_lorautils_errors_ErrorSet__["a" /* default */]().add('FE_EMPTY', 'plat').add('FE_EMPTY', 'name').add('FE_EMPTY', 'mac')
    };
    _this.handleChangePlat = _this.handleChangePlat.bind(_this);
    _this.handleChangeName = _this.handleChangeName.bind(_this);
    _this.handleChangeMac = _this.handleChangeMac.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_16_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaydetail.gatewayadd');
    return _this;
  }

  GatewayAdd.prototype.componentWillMount = function componentWillMount() {
    this.props.getPlatforms();
  };

  GatewayAdd.prototype.componentDidMount = function componentDidMount() {
    this.mounted = true;
  };

  GatewayAdd.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var platOpts = nextProps.platOpts,
        addResult = nextProps.addResult;

    if (platOpts !== this.props.platOpts) {
      this.setState({ platOpts: platOpts });
    }
    if (addResult !== this.props.addResult) {
      this.setState({ addStatus: addResult.status });
      if (addResult.status === 'failure') {
        var code = addResult.error.code;
        var errors = this.state.errors;

        errors = errors.add(code, 'submit');
        this.setState({ errors: errors });
        if (code === 'MACADDRUNAVAIL') {
          errors = errors.add(code, 'mac');
          this.setState({ errors: errors });
        }
      } else if (addResult.status === 'success') {
        var pushState = nextProps.pushState,
            getGatewayUsage = nextProps.getGatewayUsage;

        getGatewayUsage();
        setTimeout(function () {
          return pushState('/gateway');
        }, 500);
      }
    }
  };

  GatewayAdd.prototype.componentDidUpdate = function componentDidUpdate() {
    var macCurPos = this.state.macCurPos;

    if (macCurPos) {
      this.macInputRef.setSelectionRange(macCurPos, macCurPos);
    }
  };

  GatewayAdd.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  GatewayAdd.prototype.addEmptyError = function addEmptyError(target) {
    var errors = this.state.errors;

    this.setState({
      errors: errors.add('FE_EMPTY', target)
    });
  };

  GatewayAdd.prototype.removeError = function removeError(target) {
    var errors = this.state.errors;

    this.setState({
      errors: errors.remove(target)
    });
  };

  GatewayAdd.prototype.handleChangePlat = function handleChangePlat(plat) {
    this.setState({ plat: plat });
    if (plat === '') {
      this.addEmptyError('plat');
    } else {
      this.removeError('plat');
    }
  };

  GatewayAdd.prototype.handleChangeName = function handleChangeName(e) {
    var name = e.target.value;
    this.setState({ name: name });
    if (name === '') {
      this.addEmptyError('name');
    } else {
      this.removeError('name');
    }
  };

  GatewayAdd.prototype.handleChangeMac = function handleChangeMac(e) {
    var _state = this.state,
        mac = _state.mac,
        macCurPos = _state.macCurPos;

    macCurPos = e.target.selectionEnd;
    mac = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_lorautils_IdUtils__["k" /* formatMacInput */])(e.target.value, mac);
    if (e.target.value.length === macCurPos) {
      // stick cursor to end
      macCurPos = mac.length;
    }
    this.setState({
      mac: mac,
      macCurPos: macCurPos
    });

    var errors = this.state.errors;


    if (mac === '') {
      this.addEmptyError('mac');
    } else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_lorautils_IdUtils__["l" /* isValidMac */])(mac)) {
      this.setState({
        errors: errors.add('FE_MACINVALID', 'mac')
      });
    } else {
      this.removeError('mac');
    }
  };

  GatewayAdd.prototype.handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    this.setState({
      showErrors: true
    });

    var errors = this.state.errors;

    errors = errors.remove('submit');
    this.setState({
      errors: errors,
      formStatus: 'loading'
    });

    if (!errors.isEmpty()) {
      return;
    }

    var addGateway = this.props.addGateway;
    var _state2 = this.state,
        _state2$mac = _state2.mac,
        mac = _state2$mac === undefined ? '' : _state2$mac,
        _state2$name = _state2.name,
        name = _state2$name === undefined ? '' : _state2$name,
        _state2$city = _state2.city,
        city = _state2$city === undefined ? '' : _state2$city,
        _state2$area = _state2.area,
        area = _state2$area === undefined ? '' : _state2$area,
        _state2$address = _state2.address,
        address = _state2$address === undefined ? '' : _state2$address,
        _state2$lat = _state2.lat,
        lat = _state2$lat === undefined ? '' : _state2$lat,
        _state2$lng = _state2.lng,
        lng = _state2$lng === undefined ? '' : _state2$lng,
        _state2$plat = _state2.plat,
        platform = _state2$plat === undefined ? '' : _state2$plat;


    addGateway({
      mac: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_lorautils_IdUtils__["b" /* normalizeMac */])(mac),
      name: name,
      city: city,
      area: area,
      address: address,
      lat: lat,
      lng: lng,
      platform: platform
    });
  };

  GatewayAdd.prototype.renderErrorTips = function renderErrorTips(target) {
    var _state3 = this.state,
        errors = _state3.errors,
        _state3$showErrors = _state3.showErrors,
        showErrors = _state3$showErrors === undefined ? false : _state3$showErrors;

    var error = errors.get(target);
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_ControlTips__["a" /* default */], {
      show: showErrors && !__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(error),
      message: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "span",
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "halflings halflings-warning-sign" }),
        "\xA0",
        this.intlMsg.errorMsg(error)
      ),
      azStyle: "danger"
    });
  };

  GatewayAdd.prototype.render = function render() {
    var _this2 = this;

    var _state4 = this.state,
        platOpts = _state4.platOpts,
        _state4$showErrors = _state4.showErrors,
        showErrors = _state4$showErrors === undefined ? false : _state4$showErrors,
        errors = _state4.errors,
        _state4$name = _state4.name,
        name = _state4$name === undefined ? '' : _state4$name,
        _state4$mac = _state4.mac,
        mac = _state4$mac === undefined ? '' : _state4$mac,
        _state4$city = _state4.city,
        city = _state4$city === undefined ? '' : _state4$city,
        _state4$area = _state4.area,
        area = _state4$area === undefined ? '' : _state4$area,
        _state4$address = _state4.address,
        address = _state4$address === undefined ? '' : _state4$address,
        _state4$addStatus = _state4.addStatus,
        addStatus = _state4$addStatus === undefined ? '' : _state4$addStatus;

    var that = this;

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      { styleName: "wrapper", style: { minHeight: window.innerHeight } },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { styleName: "breadcrumbs" },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Breadcrumb"],
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Breadcrumb"].Item,
            { onClick: function onClick() {
                return _this2.props.pushState('/gateway');
              } },
            this.intlMsg.msg('breadcrumbs.gateways', 'gatewaydetail')
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Breadcrumb"].Item,
            { active: true },
            this.intlMsg.msg('breadcrumbs.gatewayadd', 'gatewaydetail')
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { styleName: "content" },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { styleName: "form-wrapper" },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Panel"],
            { bsStyle: "aisz-white" },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Form"],
              { onSubmit: this.handleSubmit },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
                { validationState: errors.has('plat') && showErrors ? 'error' : undefined },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                  null,
                  this.intlMsg.msg('field.platform'),
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "glyphicon glyphicon-asterisk" })
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_SearchSelector__["a" /* default */], {
                  className: "aisz-form-control-f",
                  options: platOpts,
                  onChange: this.handleChangePlat
                }),
                this.renderErrorTips('plat'),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["HelpBlock"],
                  { styleName: "field-explain" },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-info-circle" }),
                  ' ',
                  this.intlMsg.msg('field.platform.explain')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
                { validationState: errors.has('name') && showErrors ? 'error' : undefined },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                  null,
                  this.intlMsg.msg('field.name'),
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "glyphicon glyphicon-asterisk", "aria-hidden": "true" })
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormControl"], {
                  bsClass: "aisz-form-control-f",
                  value: name,
                  onChange: this.handleChangeName
                }),
                this.renderErrorTips('name')
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
                { validationState: errors.has('mac') && showErrors ? 'error' : undefined },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                  null,
                  this.intlMsg.msg('field.mac'),
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "glyphicon glyphicon-asterisk", "aria-hidden": "true" })
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormControl"], {
                  inputRef: function inputRef(ref) {
                    _this2.macInputRef = ref;
                  },
                  bsClass: "aisz-form-control-f",
                  placeholder: "12-34-56-78-90-AB",
                  value: mac,
                  onChange: this.handleChangeMac,
                  onBlur: function onBlur() {
                    return _this2.setState({ macCurPos: null });
                  }
                }),
                this.renderErrorTips('mac'),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["HelpBlock"],
                  { styleName: "field-explain" },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-info-circle", "aria-hidden": "true" }),
                  ' ',
                  this.intlMsg.msg('field.mac.explain')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { styleName: "form-divider" }),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "div",
                { styleName: "optional-fields" },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["HelpBlock"],
                  { styleName: "field-explain" },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-info-circle", "aria-hidden": "true" }),
                  ' ',
                  this.intlMsg.msg('fieldgroups.location.explain')
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
                  null,
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                    null,
                    " ",
                    this.intlMsg.msg('field.city'),
                    " "
                  ),
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormControl"], {
                    bsClass: "aisz-form-control-f",
                    value: city,
                    onChange: function onChange(e) {
                      return _this2.setState({ city: e.target.value.trim() });
                    }
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
                  null,
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                    null,
                    " ",
                    this.intlMsg.msg('field.area'),
                    " "
                  ),
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormControl"], {
                    bsClass: "aisz-form-control-f",
                    value: area,
                    onChange: function onChange(e) {
                      return _this2.setState({ area: e.target.value.trim() });
                    }
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
                  null,
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                    null,
                    this.intlMsg.msg('field.addr')
                  ),
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormControl"], {
                    bsClass: "aisz-form-control-f",
                    value: address,
                    onChange: function onChange(e) {
                      return _this2.setState({ address: e.target.value.trim() });
                    }
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
                null,
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_FormBlock__["a" /* default */], {
                  show: errors.has('submit'),
                  message: this.intlMsg.errorMsg(errors.get('submit')),
                  azStyle: "danger"
                })
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
                { className: "text-center" },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_RichButton__["a" /* default */], {
                  status: addStatus,
                  states: [{
                    status: '',
                    style: 'info',
                    label: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "span",
                      null,
                      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "halflings halflings-ok" }),
                      " ",
                      this.intlMsg.msg('button.submit')
                    ),
                    type: 'submit'
                  }, {
                    status: 'pending',
                    style: 'info',
                    label: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "span",
                      null,
                      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" }),
                      " ",
                      this.intlMsg.msg('button.pending')
                    )
                  }, {
                    status: 'success',
                    style: 'success',
                    label: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "span",
                      null,
                      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "halflings halflings-ok" }),
                      " ",
                      this.intlMsg.msg('button.succ')
                    ),
                    timer: function timer() {
                      if (that.mounted) {
                        _this2.setState({ addStatus: '' });
                      }
                    }
                  }, {
                    status: 'failure',
                    style: 'danger',
                    label: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "span",
                      null,
                      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "halflings halflings-exclamation-sign" }),
                      " ",
                      this.intlMsg.msg('button.fail')
                    ),
                    timer: function timer() {
                      if (that.mounted) {
                        _this2.setState({
                          addStatus: '',
                          errors: that.state.errors.remove('submit')
                        });
                      }
                    }
                  }]
                })
              )
            )
          )
        )
      )
    );
  };

  return GatewayAdd;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

GatewayAdd.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    platOpts: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__selectors__["a" /* platOptsSelector */])(state),
    addResult: state.gateway.addGateway
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_9_react_router_redux__["routerActions"].push,
  getPlatforms: __WEBPACK_IMPORTED_MODULE_18_loraactions_enums__["a" /* default */].platforms,
  addGateway: __WEBPACK_IMPORTED_MODULE_19_loraactions_gateway__["a" /* default */].addGateway,
  getGatewayUsage: __WEBPACK_IMPORTED_MODULE_20_loraactions_usage__["a" /* default */].gateways
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_10_react_css_modules___default()(GatewayAdd, __WEBPACK_IMPORTED_MODULE_22__styles_main_scss___default.a, { allowMultiple: true }))));

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return platOptsSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



var platformsSelector = function platformsSelector(state) {
  return state.enums.platforms;
};

var platOptsSelector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(platformsSelector, function (platforms) {
  var status = platforms.status;

  if (status === 'success') {
    return platforms.data.list.map(function (l) {
      return {
        label: l.name,
        value: l.name
      };
    });
  }
  return [];
});

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_difference_in_seconds__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_difference_in_seconds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_difference_in_seconds__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loraactions_gateway__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Refresher__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_DetailEye__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_DataDirSwitch__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_CollapseToggle__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_PanelToolbar__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_Link__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lorautils_DateTimeUtils__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss__ = __webpack_require__(2259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




















function isNew(time) {
  return __WEBPACK_IMPORTED_MODULE_8_date_fns_difference_in_seconds___default()(new Date(), time) < 10;
}

var propTypes = {
  getGatewayData: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  gatewayData: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  gatewayId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired
};

var BriefGatewayData = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(BriefGatewayData, _React$Component);

  function BriefGatewayData(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, BriefGatewayData);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      gatewayData: props.gatewayData,
      dir: 'up'
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_17_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaydetail.detailview');
    _this.handleChangeDir = _this.handleChangeDir.bind(_this);
    return _this;
  }

  BriefGatewayData.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        getGatewayData = _props.getGatewayData,
        gatewayId = _props.gatewayId;
    var dir = this.state.dir;

    getGatewayData(gatewayId, { dir: dir, limit: 20 });
  };

  BriefGatewayData.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var gatewayData = nextProps.gatewayData;


    if (gatewayData !== this.props.gatewayData) {
      this.setState({ gatewayData: gatewayData });
      if (gatewayData.status === 'success') {
        this.setState({ dataList: gatewayData.data.list });
      }
    }
  };

  BriefGatewayData.prototype.handleChangeDir = function handleChangeDir(dir) {
    if (this.state.dir === dir) {
      return;
    }
    this.setState({ dir: dir });

    var _props2 = this.props,
        gatewayId = _props2.gatewayId,
        getGatewayData = _props2.getGatewayData;

    getGatewayData(gatewayId, { dir: dir, limit: 20 });
  };

  BriefGatewayData.prototype.render = function render() {
    var _this2 = this;

    var _props3 = this.props,
        gatewayId = _props3.gatewayId,
        pushState = _props3.pushState,
        getGatewayData = _props3.getGatewayData;
    var _state = this.state,
        gatewayData = _state.gatewayData,
        dir = _state.dir,
        _state$dataList = _state.dataList,
        dataList = _state$dataList === undefined ? [] : _state$dataList,
        _state$expanded = _state.expanded,
        expanded = _state$expanded === undefined ? true : _state$expanded;
    var status = gatewayData.status;


    var header = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      this.intlMsg.msg('latestdata.header'),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "ul",
        { className: "icontools" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_DetailEye__["a" /* default */], { onClick: function onClick() {
              return pushState("/gateway/detail/" + gatewayId + "/datamsg");
            } })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Refresher__["a" /* default */], {
            reloading: status === 'pending',
            onReload: function onReload() {
              return getGatewayData(gatewayId, { dir: dir, limit: 20 });
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_CollapseToggle__["a" /* default */], {
            expanded: expanded,
            onChange: function onChange(v) {
              _this2.setState({ expanded: v });
            }
          })
        )
      )
    );

    var dataDirSwitch = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_DataDirSwitch__["a" /* default */], { onChange: this.handleChangeDir });

    var rows = dataList.map(function (d) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        { key: d.$time + "-" + d.deveui + "-" + d.fcnt, className: isNew(d.$time) ? __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.new : '' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.compact },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_lorautils_DateTimeUtils__["a" /* compactFormat */])(d.$time)
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.compact },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_16_loracoms_Link__["a" /* default */],
            { to: "/application/" + d.appeui },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_lorautils_IdUtils__["d" /* normalizeAppEUI */])(d.appeui)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.compact },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_16_loracoms_Link__["a" /* default */],
            { to: "/application/" + d.appeui + "/devices/" + d.deveui },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_lorautils_IdUtils__["a" /* normalizeDevEUI */])(d.deveui)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_16_loracoms_Link__["a" /* default */],
            { to: "/application/" + d.appeui + "/devices/" + d.deveui },
            d.name
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_RichLabel__["a" /* default */], {
            content: d.mtype,
            translateMap: {
              UnconfirmedDataUp: _this2.intlMsg.msg('unconfirmeddataup'),
              UnconfirmedDataDown: _this2.intlMsg.msg('unconfirmeddatadown'),
              ConfirmedDataUp: _this2.intlMsg.msg('confirmeddataup'),
              ConfirmedDataDown: _this2.intlMsg.msg('confirmeddatadown'),
              JoinRequest: _this2.intlMsg.msg('joinrequest'),
              JoinAccept: _this2.intlMsg.msg('joinaccept'),
              RFU: _this2.intlMsg.msg('rfu'),
              Proprietary: _this2.intlMsg.msg('proprietary')
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          d.fcnt
        )
      );
    });

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: header, collapsible: true, expanded: expanded },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_PanelToolbar__["a" /* default */], { tools: [dataDirSwitch] }),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Table"],
          { className: "aisz-table-light " + __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.dataTable, striped: true, hover: true, bordered: true, responsive: true },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                " ",
                this.intlMsg.msg('data.field.time', 'lora'),
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                " AppEUI "
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                " DevEUI "
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                " ",
                this.intlMsg.msg('data.field.devname', 'lora')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                " ",
                this.intlMsg.msg('data.field.msgtype', 'lora'),
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                " ",
                this.intlMsg.msg('data.field.frameno', 'lora'),
                " "
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tbody",
            null,
            rows
          )
        )
      )
    );
  };

  return BriefGatewayData;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

BriefGatewayData.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    gatewayData: state.gateway.gatewayData
  };
};

var mapDispatchToProps = {
  getGatewayData: __WEBPACK_IMPORTED_MODULE_9_loraactions_gateway__["a" /* default */].gatewayData,
  pushState: __WEBPACK_IMPORTED_MODULE_5_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(BriefGatewayData)));

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loraactions_gateway__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_scss__ = __webpack_require__(2260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__selectors__ = __webpack_require__(1278);





/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.any.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.func.isRequired,
  getGatewayConf: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.func.isRequired,
  gatewayId: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.string.isRequired,
  gatewayConf: __WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.object
};

var defaultProps = {
  gatewayConf: {}
};

var ConfView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ConfView, _React$Component);

  function ConfView(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ConfView);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      gatewayConf: props.gatewayConf
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_14_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaydetail.detailview.band');
    return _this;
  }

  ConfView.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        getGatewayConf = _props.getGatewayConf,
        gatewayId = _props.gatewayId;

    getGatewayConf(gatewayId);
  };

  ConfView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var gatewayConf = nextProps.gatewayConf;

    if (gatewayConf !== this.props.gatewayConf) {
      this.setState({ gatewayConf: gatewayConf });
    }
  };

  ConfView.prototype.computeFreq = function computeFreq(obj) {
    var radioArr = [];
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).forEach(function (item) {
      var config = obj[item];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(config).forEach(function (c) {
        if (c.indexOf('radio') !== -1) {
          var itemIndex = c.split('_')[1];
          radioArr[itemIndex] = config[c].freq;
        }
      });
    });
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).forEach(function (item) {
      var config = obj[item];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(config).forEach(function (c) {
        if (c.indexOf('chan_multiSF') !== -1) {
          config[c].freq = config[c].if + radioArr[config[c].radio];
        }
      });
    });
    return obj;
  };

  ConfView.prototype.subPropertyHaveObj = function subPropertyHaveObj(obj) {
    var check = false;
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).forEach(function (item) {
      if (_.isPlainObject(obj[item])) {
        check = true;
      }
    });
    return check;
  };

  ConfView.prototype.rederTrs = function rederTrs(arr) {
    var value = function value(v) {
      if (v === true) {
        return 'true';
      } else if (v === false) {
        return 'false';
      }
      return v;
    };
    var result = arr.map(function (item) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "li",
        { key: item.label },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_15__styles_scss___default.a['prop-name'] },
          item.label
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_15__styles_scss___default.a['prop-value'] },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "span",
            null,
            value(item.value)
          )
        )
      );
    });
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      "ul",
      { styleName: "props-list" },
      result
    );
  };

  ConfView.prototype.splitObj = function splitObj(obj, pro) {
    var _this2 = this;

    var propertyLeft = {};
    var propertyRight = {};
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).forEach(function (item) {
      if (_this2.subPropertyHaveObj(obj[item])) {
        var config = obj[item];
        propertyLeft[item] = {};
        propertyRight[item] = {};
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(config).forEach(function (c) {
          if (c === 'lbt_cfg') {
            return;
          }
          if (c.indexOf(pro) === -1) {
            propertyLeft[item][c] = config[c];
          } else {
            propertyRight[item][c] = config[c];
          }
        });
      }
    });
    return {
      leftObj: this.computeFreq(propertyLeft),
      rightObj: propertyRight
    };
  };

  ConfView.prototype.renderConfig = function renderConfig(detail) {
    var _this3 = this;

    var data = [];
    var value = function value(v) {
      if (v === true) {
        return 'true';
      } else if (v === false) {
        return 'false';
      }
      return v;
    };
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(detail).forEach(function (item) {
      if (_this3.subPropertyHaveObj(detail[item])) {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(detail[item]) === 'object') {
          var config = detail[item];
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(config).forEach(function (c) {
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(config[c]) === 'object') {
              var configMin = config[c];
              var dataMin = [];
              __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(configMin).forEach(function (m) {
                dataMin.push({
                  label: m,
                  value: configMin[m]
                });
              });
              data.push({
                label: c,
                value: dataMin
              });
            } else {
              data.push({
                label: c,
                value: config[c]
              });
            }
          });
        }
      }
    });
    var dataList = data;
    var trs = dataList.map(function (item, index) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tr",
        { key: item.label + "-" + index },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          item.label
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "td",
          null,
          _.isArray(item.value) ? _this3.rederTrs(item.value) : value(item.value)
        )
      );
    });
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Table"],
      {
        className: "aisz-table-light",
        striped: true,
        hover: true,
        bordered: true,
        responsive: true
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "tbody",
        null,
        trs
      )
    );
  };

  ConfView.prototype.renderToolbar = function renderToolbar() {
    var _this4 = this;

    var breadcrumb = [{
      content: this.intlMsg.msg('breadcrumbs.gateways', 'gatewaydetail'),
      onClick: function onClick() {
        return _this4.props.pushState('/gateway');
      }
    }, {
      content: this.intlMsg.msg('nav'),
      active: true
    }];

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  ConfView.prototype.render = function render() {
    var _this5 = this;

    var gatewayConf = this.state.gatewayConf;

    var title = '';
    _.map(gatewayConf, function (key, value) {
      if (_this5.subPropertyHaveObj(value)) {
        title = key;
      }
    });

    var content = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
          { md: 12 },
          this.renderToolbar()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_15__styles_scss___default.a['props-panel'] },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Panel"],
              { bsStyle: "aisz-white", header: title },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
                null,
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                  { md: 6 },
                  this.renderConfig(this.splitObj(gatewayConf, 'tx').leftObj)
                ),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
                  { md: 6 },
                  this.renderConfig(this.splitObj(gatewayConf, 'tx').rightObj)
                )
              )
            )
          )
        )
      )
    );

    if (_.isEmpty(gatewayConf)) {
      content = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Grid"],
        { fluid: true },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
            { md: 12 },
            this.renderToolbar()
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
            { mdOffset: 4, md: 4 },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_15__styles_scss___default.a.unkownTips },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("span", { className: "glyphicons glyphicons-exclamation-sign" }),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                "h1",
                null,
                this.intlMsg.msg('unkowntips')
              ),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                "ul",
                { className: "list-unstyled" },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  "li",
                  null,
                  __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("span", { className: "halflings halflings-hand-right" }),
                  ' ',
                  this.intlMsg.msg('unkowntips.reason1')
                ),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  "li",
                  null,
                  __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("span", { className: "halflings halflings-hand-right" }),
                  ' ',
                  this.intlMsg.msg('unkowntips.reason2')
                ),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  "li",
                  null,
                  __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("span", { className: "halflings halflings-hand-right" }),
                  ' ',
                  this.intlMsg.msg('unkowntips.reason3')
                )
              )
            )
          )
        )
      );
    }
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      "div",
      null,
      content
    );
  };

  return ConfView;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ConfView.propTypes = propTypes;
ConfView.defaultProps = defaultProps;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    gatewayConf: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__selectors__["a" /* confSelector */])(state),
    gatewayId: ownProps.params.id
  };
};

var mapDispatchToProps = {
  getGatewayConf: __WEBPACK_IMPORTED_MODULE_13_loraactions_gateway__["a" /* default */].gatewayConf,
  pushState: __WEBPACK_IMPORTED_MODULE_9_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_11_react_css_modules___default()(ConfView, __WEBPACK_IMPORTED_MODULE_15__styles_scss___default.a, { allowMultiple: true }))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return confSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



var gatewayConfSelector = function gatewayConfSelector(state) {
  return state.gateway.gatewayConf;
};

function stripComment() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var result = str.replace(/\/\*[^*]*\*\//g, '\n').replace(/(?:^|\n|\r)\s*\/\/.*(?:\r|\n|$)/g, '\n');
  return result;
}

var confSelector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(gatewayConfSelector, function (gatewayConf) {
  var status = gatewayConf.status,
      data = gatewayConf.data;

  if (status === 'success') {
    return JSON.parse(stripComment(data.result));
  }
  return {};
});

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__GatewayData__ = __webpack_require__(1283);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);












var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  gatewayId: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  gateway: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired
};

var StatView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(StatView, _React$Component);

  function StatView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, StatView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      gateway: props.gateway
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaydetail.datamsgview');
    return _this;
  }

  StatView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var gateway = nextProps.gateway;

    if (gateway !== this.props.gateway) {
      this.setState({ gateway: gateway });
    }
  };

  StatView.prototype.renderToolbar = function renderToolbar() {
    var _this2 = this;

    var gateway = this.state.gateway;

    var breadcrumb = [{
      content: this.intlMsg.msg('breadcrumbs.gateways', 'gatewaydetail'),
      onClick: function onClick() {
        return _this2.props.pushState('/gateway');
      }
    }, {
      content: gateway.name,
      active: true
    }];

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  StatView.prototype.render = function render() {
    var gatewayId = this.props.gatewayId;


    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Grid"],
      { fluid: true },
      this.renderToolbar(),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__GatewayData__["a" /* default */], { gatewayId: gatewayId })
    );
  };

  return StatView;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

StatView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    gateway: state.gateway.gateway.data || {},
    gatewayId: ownProps.params.id
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(StatView)));

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aisztheme_sass_animate_scss__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aisztheme_sass_animate_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_aisztheme_sass_animate_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loraapi_lora_gateway__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loraactions_usage__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_LineChart__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_ActionButton__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_Refresher__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loracoms_DetailEye__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loracoms_CollapseToggle__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_loraactions_gateway__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__GatewayProps__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__BriefGatewayData__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__styles_scss__ = __webpack_require__(2261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);


























var messages = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_intl__["defineMessages"])({
  breadcrumbGateways: {
    "id": "gatewaydetail.breadcrumbs.gateways",
    "defaultMessage": "\u6211\u7684\u7F51\u5173"
  },
  chartAxisPkts: {
    "id": "gatewaydetail.statschart.axis.pkts",
    "defaultMessage": "gatewaydetail.statschart.axis.pkts"
  },
  chartAxisLatency: {
    "id": "gatewaydetail.statschart.axis.latency",
    "defaultMessage": "gatewaydetail.statschart.axis.latency"
  },
  chartPkts: {
    "id": "gatewaydetail.statschart.series.pkts",
    "defaultMessage": "gatewaydetail.statschart.series.pkts"
  },
  chartLatency: {
    "id": "gatewaydetail.statschart.series.latency",
    "defaultMessage": "gatewaydetail.statschart.series.latency"
  }
});

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.any.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  gatewayId: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired,
  gateway: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  deleteGateway: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  deleteResult: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  resetDeleteGateway: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  getGateway: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  getGatewaysUsage: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired
};

var DetailView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DetailView, _React$Component);

  function DetailView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DetailView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      gateway: props.gateway,
      deleteResult: props.deleteResult,
      statSeries: {
        rxpks: {
          name: _this.props.intl.formatMessage(messages.chartPkts),
          data: [],
          yAxisIndex: 0
        },
        ltncs: {
          name: _this.props.intl.formatMessage(messages.chartLatency),
          data: [],
          yAxisIndex: 1
        },
        categories: []
      },
      pingStatus: 'ready',
      resetStatus: 'ready',
      upgradeStatus: 'ready',
      comUpgradeStatus: ''
    };
    _this.handleReloadStats = _this.handleReloadStats.bind(_this);
    _this.handleDeleteConfirm = _this.handleDeleteConfirm.bind(_this);
    _this.handlePingGateway = _this.handlePingGateway.bind(_this);
    _this.handleResetGateway = _this.handleResetGateway.bind(_this);
    _this.handleSDKupgrade = _this.handleSDKupgrade.bind(_this);
    _this.handleSDKUpgradeSta = _this.handleSDKUpgradeSta.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_21_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaydetail.detailview');
    return _this;
  }

  DetailView.prototype.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.loadStats();
  };

  DetailView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var gateway = nextProps.gateway,
        deleteResult = nextProps.deleteResult,
        getGatewaysUsage = nextProps.getGatewaysUsage;


    if (gateway !== this.props.gateway) {
      this.setState({ gateway: gateway });
    }
    if (deleteResult !== this.props.deleteResult) {
      this.setState({ deleteResult: deleteResult });
      if (deleteResult.status === 'success') {
        getGatewaysUsage();
      }
    }
  };

  DetailView.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
    var resetDeleteGateway = this.props.resetDeleteGateway;

    resetDeleteGateway();

    if (this.pingTimeout) {
      clearTimeout(this.pingTimeout);
    }
    if (this.resetTimeout) {
      clearTimeout(this.resetTimeout);
    }
    if (this.upgradeTimeout) {
      clearTimeout(this.upgradeTimeout);
    }
  };

  DetailView.prototype.loadStats = function loadStats(cb) {
    var _this2 = this;

    var gatewayId = this.props.gatewayId;

    var from = moment().subtract(7, 'days').format('YYYYMMDDHH');
    var to = moment().add(1, 'hours').format('YYYYMMDDHH');
    var formatSlot = function formatSlot(s) {
      var str = String(s);
      return str.slice(6, 8) + "/" + str.slice(4, 6) + " " + str.slice(8, 10) + ":00";
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_loraapi_lora_gateway__["c" /* gatewayStats */])(gatewayId, from, to).then(function (res) {
      var rxpks = [];
      var ltncs = [];
      var slots = [];
      res.body.list.forEach(function (item) {
        slots.push(formatSlot(item.slot));
        rxpks.push(item.rxpkt);
        ltncs.push(item.latency);
      });

      var statSeries = _.extend({}, _this2.state.statSeries);
      statSeries.rxpks.data = rxpks;
      statSeries.ltncs.data = ltncs;
      statSeries.categories = slots;
      if (_this2.mounted) {
        _this2.setState({
          statSeries: statSeries
        });
      }

      if (cb) {
        cb();
      }
    }).catch(function () {
      if (cb) {
        cb();
      }
    });
  };

  DetailView.prototype.handleReloadStats = function handleReloadStats() {
    var _this3 = this;

    this.setState({
      statReloading: true
    });

    this.loadStats(function () {
      _this3.setState({
        statReloading: false
      });
    });
  };

  DetailView.prototype.handlePingGateway = function handlePingGateway() {
    var _this4 = this;

    var _props = this.props,
        getGateway = _props.getGateway,
        gatewayId = _props.gatewayId;

    this.setState({
      pingStatus: 'loading'
    });

    if (this.pingTimeout) {
      clearTimeout(this.pingTimeout);
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_loraapi_lora_gateway__["d" /* gatewayPing */])(gatewayId).then(function () {
      if (_this4.mounted) {
        _this4.setState({
          pingStatus: 'success'
        });
        _this4.pingTimeout = setTimeout(function () {
          getGateway(gatewayId);
        }, 3000);
      }
    }).catch(function () {
      if (_this4.mounted) {
        _this4.setState({
          pingStatus: 'failed'
        });
        _this4.pingTimeout = setTimeout(function () {
          getGateway(gatewayId);
        }, 3000);
      }
    });
  };

  DetailView.prototype.handleResetGateway = function handleResetGateway() {
    var _this5 = this;

    var _props2 = this.props,
        gatewayId = _props2.gatewayId,
        getGateway = _props2.getGateway;

    this.setState({
      resetStatus: 'loading'
    });

    if (this.resetTimeout) {
      clearTimeout(this.resetTimeout);
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_loraapi_lora_gateway__["e" /* gatewayReset */])(gatewayId).then(function () {
      if (_this5.mounted) {
        _this5.setState({
          resetStatus: 'success'
        });
        _this5.resetTimeout = setTimeout(function () {
          getGateway(gatewayId);
        }, 3000);
      }
    }).catch(function () {
      if (_this5.mounted) {
        _this5.setState({
          resetStatus: 'failed'
        });
        _this5.resetTimeout = setTimeout(function () {
          getGateway(gatewayId);
        }, 3000);
      }
    });
  };

  DetailView.prototype.handleSDKupgrade = function handleSDKupgrade() {
    var _this6 = this;

    var _props3 = this.props,
        gatewayId = _props3.gatewayId,
        getGateway = _props3.getGateway;

    this.setState({
      upgradeStatus: 'loading'
    });

    if (this.upgradeTimeout) {
      clearTimeout(this.upgradeTimeout);
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_loraapi_lora_gateway__["f" /* gatewayUpgradeSDK */])(gatewayId).then(function (res) {
      if (_this6.mounted) {
        var _res$body = res.body,
            supported = _res$body.supported,
            suggested = _res$body.suggested,
            srcver = _res$body.srcver,
            dstver = _res$body.dstver;

        _this6.setState({ upgradeStatus: 'success', srcver: srcver, dstver: dstver });
        if (!supported) {
          _this6.setState({
            showSDKupgradeTip: true,
            tipWord: _this6.intlMsg.msg('NoSupportUpSDK'),
            upgradeStatus: 'ready'
          });
        } else if (supported) {
          if (suggested) {
            _this6.setState({
              showSDKupgrade: true,
              upgradeStatus: 'ready',
              upgradeStatusSta: 'ready'
            });
          } else if (!suggested) {
            _this6.setState({
              showSDKupgradeTip: true,
              tipWord: _this6.intlMsg.msg('NoUpgradeSDK'),
              upgradeStatus: 'ready'
            });
          }
        }
      }
    }).catch(function () {
      if (_this6.mounted) {
        _this6.setState({
          upgradeStatus: 'failed'
        });
        _this6.upgradeTimeout = setTimeout(function () {
          getGateway(gatewayId);
        }, 3000);
      }
    });
  };

  DetailView.prototype.handleSDKUpgradeSta = function handleSDKUpgradeSta() {
    var _this7 = this;

    var gatewayId = this.props.gatewayId;


    this.setState({
      upgradeStatusSta: 'loading',
      cancelDis: 'disabled',
      backdr: 'static'
    });

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_loraapi_lora_gateway__["g" /* gatewayUpgradeSDKCom */])(gatewayId).then(function () {
      _this7.setState({
        showSDKupgrade: false,
        showSDKupgradeTip: true,
        tipWord: _this7.intlMsg.msg('upgradeSDKSuccTips'),
        upgradeStatusSta: 'ready',
        cancelDis: '',
        backdr: true
      });
    }).catch(function () {
      _this7.setState({
        upgradeStatusSta: 'failed',
        cancelDis: '',
        backdr: true
      });
    });
  };

  DetailView.prototype.handleDeleteConfirm = function handleDeleteConfirm() {
    var _props4 = this.props,
        gatewayId = _props4.gatewayId,
        deleteGateway = _props4.deleteGateway;

    deleteGateway(gatewayId);
  };

  DetailView.prototype.renderSDKupgradeTipModal = function renderSDKupgradeTipModal() {
    var _this8 = this;

    var _state = this.state,
        _state$gateway = _state.gateway,
        gateway = _state$gateway === undefined ? {} : _state$gateway,
        _state$tipWord = _state.tipWord,
        tipWord = _state$tipWord === undefined ? '' : _state$tipWord;
    var name = gateway.name,
        id = gateway.id;


    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-danger",
        show: this.state.showSDKupgradeTip,
        onHide: function onHide() {
          return _this8.setState({ showSDKupgradeTip: false });
        }
      },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-upload" }),
          ' ',
          this.intlMsg.msg('upgradeSDK')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "p",
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "strong",
              null,
              name
            ),
            " (",
            id,
            ")",
            ' ',
            tipWord
          )
        )
      )
    );
  };

  DetailView.prototype.renderSDKupgradeModal = function renderSDKupgradeModal() {
    var _this9 = this;

    var _state2 = this.state,
        _state2$gateway = _state2.gateway,
        gateway = _state2$gateway === undefined ? {} : _state2$gateway,
        showSDKupgrade = _state2.showSDKupgrade,
        _state2$upgradeStatus = _state2.upgradeStatusSta,
        upgradeStatusSta = _state2$upgradeStatus === undefined ? 'ready' : _state2$upgradeStatus,
        _state2$cancelDis = _state2.cancelDis,
        cancelDis = _state2$cancelDis === undefined ? '' : _state2$cancelDis,
        _state2$backdr = _state2.backdr,
        backdr = _state2$backdr === undefined ? true : _state2$backdr,
        _state2$srcver = _state2.srcver,
        srcver = _state2$srcver === undefined ? '' : _state2$srcver,
        _state2$dstver = _state2.dstver,
        dstver = _state2$dstver === undefined ? '' : _state2$dstver;
    var name = gateway.name,
        id = gateway.id;


    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-danger",
        show: showSDKupgrade,
        onHide: function onHide() {
          return _this9.setState({ showSDKupgrade: false });
        },
        backdrop: backdr
      },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Header,
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-upload" }),
          ' ',
          this.intlMsg.msg('upgradeSDK')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "p",
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "strong",
              null,
              name
            ),
            " (",
            id,
            ")",
            ' ',
            this.intlMsg.msg('sugUpgrade')
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "p",
            null,
            this.intlMsg.msg('newVer'),
            '： ',
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "strong",
              null,
              dstver
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "p",
            null,
            this.intlMsg.msg('currentVer'),
            '： ',
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "strong",
              null,
              srcver
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
              {
                bsStyle: "aisz-warning",
                onClick: function onClick() {
                  return _this9.setState({ showSDKupgrade: false });
                },
                disabled: cancelDis
              },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-repeat" }),
              ' ',
              this.intlMsg.msg('upgrade.cancelbtn')
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_ActionButton__["a" /* default */], {
              onClick: this.handleSDKUpgradeSta,
              status: upgradeStatusSta,
              onStatusReset: function onStatusReset() {
                return _this9.setState({ upgradeStatus: 'ready' });
              },
              icon: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-upload" }),
              label: this.intlMsg.msg('upgradeSDKDur'),
              loadingLabel: this.intlMsg.msg('upgradeSDKDur'),
              failedLabel: this.intlMsg.msg('upgradeSDKfail')
            })
          )
        )
      )
    );
  };

  DetailView.prototype.renderDeleteModal = function renderDeleteModal() {
    var _this10 = this;

    var pushState = this.props.pushState;
    var _state3 = this.state,
        _state3$gateway = _state3.gateway,
        gateway = _state3$gateway === undefined ? {} : _state3$gateway,
        _state3$deleteResult = _state3.deleteResult,
        deleteResult = _state3$deleteResult === undefined ? {} : _state3$deleteResult;
    var _deleteResult$status = deleteResult.status,
        deleteStatus = _deleteResult$status === undefined ? '' : _deleteResult$status;
    var name = gateway.name,
        id = gateway.id;


    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-danger",
        show: this.state.showDeleteModal,
        onHide: function onHide() {
          return _this10.setState({ showDeleteModal: false });
        }
      },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle" }),
          ' ',
          this.intlMsg.msg('delete.modalheader')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "p",
            null,
            this.intlMsg.msg('delete.modalcontent'),
            ' ',
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "strong",
              null,
              name
            ),
            " (",
            id,
            ") ?"
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
              {
                bsStyle: "aisz-warning",
                onClick: function onClick() {
                  return _this10.setState({ showDeleteModal: false });
                }
              },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-repeat" }),
              ' ',
              this.intlMsg.msg('delete.cancelbtn')
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_RichButton__["a" /* default */], {
              status: deleteStatus,
              states: [{
                status: '',
                label: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  "span",
                  null,
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-trash-o" }),
                  ' ',
                  this.intlMsg.msg('delete.confirmbtn')
                ),
                style: 'danger',
                onClick: this.handleDeleteConfirm
              }, {
                status: 'request',
                label: this.intlMsg.msg('delete.deleting'),
                style: 'info'
              }, {
                status: 'pending',
                label: this.intlMsg.msg('delete.deleting'),
                style: 'info'
              }, {
                status: 'success',
                label: this.intlMsg.msg('delete.success'),
                style: 'success',
                timer: function timer() {
                  return pushState('/gateway');
                },
                delay: 500
              }, {
                status: 'failure',
                label: this.intlMsg.msg('delete.failure'),
                style: 'danger'
              }]
            })
          )
        )
      )
    );
  };

  DetailView.prototype.renderToolbar = function renderToolbar() {
    var _this11 = this;

    var pushState = this.props.pushState;
    var _state$gateway2 = this.state.gateway;
    _state$gateway2 = _state$gateway2 === undefined ? {} : _state$gateway2;
    var name = _state$gateway2.name;
    var upgradeStatus = this.state.upgradeStatus;


    var breadcrumb = [{
      content: this.props.intl.formatMessage(messages.breadcrumbGateways),
      onClick: function onClick() {
        return pushState('/gateway');
      }
    }, {
      content: name,
      active: true
    }];

    var rightTools = [{
      type: 'buttons',
      buttons: [__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_ActionButton__["a" /* default */], {
        onClick: this.handlePingGateway,
        status: this.state.pingStatus,
        onStatusReset: function onStatusReset() {
          return _this11.setState({ pingStatus: 'ready' });
        },
        icon: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-heartbeat" }),
        label: this.intlMsg.msg('ping'),
        successLabel: this.intlMsg.msg('pingsucc'),
        failedLabel: this.intlMsg.msg('pingfail')
      }), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_ActionButton__["a" /* default */], {
        onClick: this.handleResetGateway,
        status: this.state.resetStatus,
        onStatusReset: function onStatusReset() {
          return _this11.setState({ resetStatus: 'ready' });
        },
        icon: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-repeat" }),
        label: this.intlMsg.msg('restart'),
        successLabel: this.intlMsg.msg('restartsucc'),
        failedLabel: this.intlMsg.msg('restartfail')
      }), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_ActionButton__["a" /* default */], {
        onClick: this.handleSDKupgrade,
        status: upgradeStatus,
        onStatusReset: function onStatusReset() {
          return _this11.setState({ upgradeStatus: 'ready' });
        },
        icon: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-upload" }),
        label: this.intlMsg.msg('upgradeSDK'),
        loadingLabel: this.intlMsg.msg('upgradeSDK'),
        failedLabel: this.intlMsg.msg('upgradeSDKfail')
      }), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
        {
          bsStyle: "aisz-danger",
          onClick: function onClick() {
            return _this11.setState({ showDeleteModal: true });
          }
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-trash-o" }),
        ' ',
        this.intlMsg.msg('delete')
      )]
    }];

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb, rightTools: rightTools });
  };

  DetailView.prototype.renderChartPanel = function renderChartPanel() {
    var _this12 = this;

    var _props5 = this.props,
        gatewayId = _props5.gatewayId,
        pushState = _props5.pushState;
    var _state4 = this.state,
        statReloading = _state4.statReloading,
        _state4$chartPanelExp = _state4.chartPanelExpanded,
        chartPanelExpanded = _state4$chartPanelExp === undefined ? true : _state4$chartPanelExp,
        _state4$resizeTrigger = _state4.resizeTrigger,
        resizeTrigger = _state4$resizeTrigger === undefined ? 0 : _state4$resizeTrigger;

    var chartPanelHeader = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "span",
        null,
        this.intlMsg.msg('panel.header.gwstat')
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "ul",
        { className: "icontools" },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_DetailEye__["a" /* default */], { onClick: function onClick() {
              return pushState("/gateway/detail/" + gatewayId + "/stat");
            } })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_Refresher__["a" /* default */], { reloading: statReloading, onReload: this.handleReloadStats })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_CollapseToggle__["a" /* default */], {
            expanded: chartPanelExpanded,
            onChange: function onChange(expanded) {
              _this12.setState({ chartPanelExpanded: expanded });
            }
          })
        )
      )
    );

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Panel"],
      {
        bsStyle: "aisz-white",
        header: chartPanelHeader,
        collapsible: true,
        expanded: chartPanelExpanded,
        onEntered: function onEntered() {
          _this12.setState({ resizeTrigger: Math.random() });
        }
      },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_LineChart__["a" /* default */], {
        yAxis: [{
          name: this.props.intl.formatMessage(messages.chartAxisPkts),
          splitNumber: 5
        }, {
          name: this.props.intl.formatMessage(messages.chartAxisLatency),
          splitLine: {
            show: false
          }
        }],
        xAxis: {
          axisTick: {
            alignWithLabel: true
          },
          boundaryGap: true
        },
        legend: {
          data: [this.props.intl.formatMessage(messages.chartPkts), this.props.intl.formatMessage(messages.chartLatency)]
        },
        grid: {
          left: 60,
          top: 30,
          right: 60,
          bottom: 30
        },
        series: [this.state.statSeries.rxpks, this.state.statSeries.ltncs],
        categories: this.state.statSeries.categories,
        resizeTrigger: resizeTrigger
      })
    );
  };

  DetailView.prototype.render = function render() {
    var gatewayId = this.props.gatewayId;
    var gateway = this.state.gateway;


    var content = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
          { md: 12 },
          this.renderToolbar()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
          { md: 8, className: "collapse-right" },
          this.renderChartPanel(),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__BriefGatewayData__["a" /* default */], { gatewayId: gatewayId })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__GatewayProps__["a" /* default */], {
            gatewayId: gatewayId,
            gateway: gateway
          })
        )
      )
    );
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      null,
      content,
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        null,
        this.renderDeleteModal(),
        this.renderSDKupgradeTipModal(),
        this.renderSDKupgradeModal()
      )
    );
  };

  return DetailView;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

DetailView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    gateway: state.gateway.gateway.data || {},
    deleteResult: state.gateway.deleteGateway || {},
    gatewayId: ownProps.params.id
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_9_react_router_redux__["routerActions"].push,
  getGateway: __WEBPACK_IMPORTED_MODULE_20_loraactions_gateway__["a" /* default */].gateway,
  deleteGateway: __WEBPACK_IMPORTED_MODULE_20_loraactions_gateway__["a" /* default */].deleteGateway,
  resetDeleteGateway: __WEBPACK_IMPORTED_MODULE_20_loraactions_gateway__["a" /* default */].resetDeleteGateway,
  getGatewaysUsage: __WEBPACK_IMPORTED_MODULE_12_loraactions_usage__["a" /* default */].gateways
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_6_react_css_modules___default()(DetailView, __WEBPACK_IMPORTED_MODULE_24__styles_scss___default.a, { allowMultiple: true }))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14), __webpack_require__(11)))

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_difference_in_seconds__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_difference_in_seconds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_difference_in_seconds__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_sub_days__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_sub_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_sub_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_day__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_add_days__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns_add_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_is_after__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_is_after___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_date_fns_is_after__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_is_before__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_is_before___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_date_fns_is_before__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_min__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_date_fns_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loraactions_gateway__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_Refresher__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loracoms_DataDirSwitch__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loracoms_DatePicker__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_loracoms_InlineSelect__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_loracoms_TablePager__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_loracoms_PanelToolbar__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_loracoms_Link__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lorautils_DateTimeUtils__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__styles_scss__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




























function defaultFrom() {
  return __WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day___default()(__WEBPACK_IMPORTED_MODULE_8_date_fns_sub_days___default()(new Date(), 1));
}

function defaultTo() {
  return __WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_day___default()(new Date());
}

function isNew(time) {
  return __WEBPACK_IMPORTED_MODULE_6_date_fns_difference_in_seconds___default()(new Date(), time) < 10;
}

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  getGatewayData: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  gatewayId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  gatewayData: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var CloudGtw = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(CloudGtw, _React$Component);

  CloudGtw.handleDisableDate = function handleDisableDate(d, from) {
    return __WEBPACK_IMPORTED_MODULE_12_date_fns_is_after___default()(d, __WEBPACK_IMPORTED_MODULE_14_date_fns_min___default()(__WEBPACK_IMPORTED_MODULE_11_date_fns_add_days___default()(from, 7), new Date())) || __WEBPACK_IMPORTED_MODULE_13_date_fns_is_before___default()(d, from);
  };

  function CloudGtw(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CloudGtw);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      gatewayData: props.gatewayData,
      dir: 'up',
      fields: ['radio'],
      from: defaultFrom(),
      to: defaultTo()
    };
    _this.handleToggleFields = _this.handleToggleFields.bind(_this);
    _this.handleChangeFrom = _this.handleChangeFrom.bind(_this);
    _this.handleChangeTo = _this.handleChangeTo.bind(_this);
    _this.handleChangeDir = _this.handleChangeDir.bind(_this);
    _this.handleReload = _this.handleReload.bind(_this);
    _this.handleChangeMark = _this.handleChangeMark.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_21_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaydetail.statview');
    return _this;
  }

  CloudGtw.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        getGatewayData = _props.getGatewayData,
        gatewayId = _props.gatewayId;
    var _state = this.state,
        dir = _state.dir,
        from = _state.from,
        to = _state.to;

    getGatewayData(gatewayId, {
      dir: dir,
      limit: 20,
      start: from.valueOf(),
      end: to.valueOf()
    });
  };

  CloudGtw.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var gatewayData = nextProps.gatewayData;

    if (gatewayData !== this.props.gatewayData) {
      this.setState({ gatewayData: gatewayData });
      if (gatewayData.status === 'success') {
        this.setState({ dataList: gatewayData.data.list });
      }
    }
  };

  CloudGtw.prototype.handleChangeDir = function handleChangeDir(dir) {
    this.setState({
      dir: dir,
      reset: Math.random()
    });

    var _props2 = this.props,
        getGatewayData = _props2.getGatewayData,
        gatewayId = _props2.gatewayId;
    var _state2 = this.state,
        _state2$from = _state2.from,
        from = _state2$from === undefined ? defaultFrom() : _state2$from,
        _state2$to = _state2.to,
        to = _state2$to === undefined ? defaultTo() : _state2$to;

    getGatewayData(gatewayId, {
      dir: dir,
      limit: 20,
      start: from.valueOf(),
      end: to.valueOf()
    });
  };

  CloudGtw.prototype.handleToggleFields = function handleToggleFields(fields) {
    this.setState({ fields: fields });
  };

  CloudGtw.prototype.handleReload = function handleReload() {
    this.setState({ reset: Math.random() });
    var _props3 = this.props,
        getGatewayData = _props3.getGatewayData,
        gatewayId = _props3.gatewayId;
    var dir = this.state.dir;
    var _state3 = this.state,
        from = _state3.from,
        to = _state3.to;
    // 当刷新时，将选择框时间置为最新的时间

    from = defaultFrom();
    to = defaultTo();
    this.setState({ from: from, to: to });
    getGatewayData(gatewayId, {
      dir: dir,
      limit: 20,
      start: from.valueOf(),
      end: to.valueOf()
    });
  };

  CloudGtw.prototype.handleChangeFrom = function handleChangeFrom(from) {
    var to = __WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_day___default()(from);
    this.setState({ from: __WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day___default()(from), to: to, reset: Math.random() });
    var _props4 = this.props,
        getGatewayData = _props4.getGatewayData,
        gatewayId = _props4.gatewayId;
    var dir = this.state.dir;

    getGatewayData(gatewayId, {
      dir: dir,
      limit: 20,
      start: __WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day___default()(from).valueOf(),
      end: to.valueOf()
    });
  };

  CloudGtw.prototype.handleChangeTo = function handleChangeTo(to) {
    this.setState({ to: __WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_day___default()(to), reset: Math.random() });
    var _props5 = this.props,
        getGatewayData = _props5.getGatewayData,
        gatewayId = _props5.gatewayId;
    var _state4 = this.state,
        dir = _state4.dir,
        _state4$from = _state4.from,
        from = _state4$from === undefined ? defaultFrom() : _state4$from;

    getGatewayData(gatewayId, {
      dir: dir,
      limit: 20,
      start: from.valueOf(),
      end: __WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_day___default()(to).valueOf()
    });
  };

  CloudGtw.prototype.handleChangeMark = function handleChangeMark() {
    var mark = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var _props6 = this.props,
        gatewayId = _props6.gatewayId,
        getGatewayData = _props6.getGatewayData;
    var _state5 = this.state,
        dir = _state5.dir,
        _state5$from = _state5.from,
        from = _state5$from === undefined ? defaultFrom() : _state5$from,
        _state5$to = _state5.to,
        to = _state5$to === undefined ? defaultTo() : _state5$to;


    getGatewayData(gatewayId, {
      dir: dir,
      limit: 20,
      start: from.valueOf(),
      end: to.valueOf(),
      mark: mark
    });
  };

  CloudGtw.prototype.renderPanelToolbar = function renderPanelToolbar() {
    var _state6 = this.state,
        fields = _state6.fields,
        from = _state6.from,
        to = _state6.to;

    var tools = [__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_DatePicker__["a" /* default */], {
      date: from,
      onSelect: this.handleChangeFrom
    }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_DatePicker__["a" /* default */], {
      date: to,
      onSelect: this.handleChangeTo,
      disabled: function disabled(d) {
        return CloudGtw.handleDisableDate(d, from);
      }
    }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_DataDirSwitch__["a" /* default */], { onChange: this.handleChangeDir }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_loracoms_InlineSelect__["a" /* default */], {
      options: [{
        label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-wifi" }),
          this.intlMsg.msg('fields.spills.radio')
        ),
        value: 'radio',
        active: true
      }, {
        label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
          this.intlMsg.msg('fields.spills.datamsg')
        ),
        value: 'datamsg'
      }],
      multiple: true,
      values: fields,
      onChange: this.handleToggleFields
    })];
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_loracoms_PanelToolbar__["a" /* default */], { tools: tools });
  };

  CloudGtw.prototype.render = function render() {
    var _this2 = this;

    var gatewayData = this.state.gatewayData;

    var header = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      this.intlMsg.msg('data.header'),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "ul",
        { className: "icontools" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_Refresher__["a" /* default */], {
            onReload: this.handleReload,
            reloading: gatewayData.status === 'pending'
          })
        )
      )
    );

    var _state7 = this.state,
        _state7$dataList = _state7.dataList,
        dataList = _state7$dataList === undefined ? [] : _state7$dataList,
        _state7$fields = _state7.fields,
        fields = _state7$fields === undefined ? [] : _state7$fields,
        _state7$collapseAPPEU = _state7.collapseAPPEUI,
        collapseAPPEUI = _state7$collapseAPPEU === undefined ? false : _state7$collapseAPPEU,
        _state7$collapseDEVEU = _state7.collapseDEVEUI,
        collapseDEVEUI = _state7$collapseDEVEU === undefined ? false : _state7$collapseDEVEU,
        dir = _state7.dir;

    var showRadioFields = fields.includes('radio');
    var showDataFields = fields.includes('datamsg');

    var rows = dataList.map(function (d) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        { key: d.$time + "-" + d.deveui + "-" + d.fcnt, className: isNew(d.$time) ? __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.new : '' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.compact },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_lorautils_DateTimeUtils__["a" /* compactFormat */])(d.$time)
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.compact },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_25_loracoms_Link__["a" /* default */],
            { to: "/application/" + d.appeui },
            collapseAPPEUI ? "..." + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_lorautils_IdUtils__["d" /* normalizeAppEUI */])(d.appeui).substr(-5) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_lorautils_IdUtils__["d" /* normalizeAppEUI */])(d.appeui)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.compact },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_25_loracoms_Link__["a" /* default */],
            { to: "/application/" + d.appeui + "/devices/" + d.deveui },
            collapseDEVEUI ? "..." + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_lorautils_IdUtils__["a" /* normalizeDevEUI */])(d.deveui).substr(-5) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_lorautils_IdUtils__["a" /* normalizeDevEUI */])(d.deveui)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_25_loracoms_Link__["a" /* default */],
            { to: "/application/" + d.appeui + "/devices/" + d.deveui },
            d.name
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
          { "if": showRadioFields && dir === 'up' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.channel,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
          { "if": showRadioFields },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.frequency / 1000000,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
          { "if": showRadioFields },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.bandwidth + " | " + d.coderate,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
          { "if": showRadioFields },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.spreadfactor,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
          { "if": showRadioFields && dir === 'up' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            d.lorasnr && Number(d.lorasnr).toFixed(1)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
          { "if": showRadioFields && dir === 'up' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.rssi,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_loracoms_RichLabel__["a" /* default */], {
            content: d.mtype,
            translateMap: {
              UnconfirmedDataUp: _this2.intlMsg.msg('unconfirmeddataup'),
              UnconfirmedDataDown: _this2.intlMsg.msg('unconfirmeddatadown'),
              ConfirmedDataUp: _this2.intlMsg.msg('confirmeddataup'),
              ConfirmedDataDown: _this2.intlMsg.msg('confirmeddatadown'),
              JoinRequest: _this2.intlMsg.msg('joinrequest'),
              JoinAccept: _this2.intlMsg.msg('joinaccept'),
              RFU: _this2.intlMsg.msg('rfu'),
              Proprietary: _this2.intlMsg.msg('proprietary')
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          d.fcnt
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
          { "if": showDataFields },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.fport,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
          { "if": showDataFields },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.fctrl,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
          { "if": showDataFields },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.fopts,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
          { "if": showDataFields && dir === 'up' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.size,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
          { "if": showDataFields },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.data,
            " "
          )
        )
      );
    });

    var _state8 = this.state,
        _state8$gatewayData = _state8.gatewayData,
        status = _state8$gatewayData.status,
        _state8$gatewayData$d = _state8$gatewayData.data;
    _state8$gatewayData$d = _state8$gatewayData$d === undefined ? {} : _state8$gatewayData$d;
    var mark = _state8$gatewayData$d.mark,
        more = _state8$gatewayData$d.more,
        reset = _state8.reset;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: header },
      this.renderPanelToolbar(),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.dataTable },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Table"],
          { className: "aisz-table-light", striped: true, hover: true, bordered: true, responsive: true },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('data.field.time', 'lora')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                "AppEUI",
                ' ',
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                  { "if": collapseAPPEUI },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_25_loracoms_Link__["a" /* default */],
                    { onClick: function onClick() {
                        return _this2.setState({ collapseAPPEUI: false });
                      } },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-resize-full" })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                  { "if": !collapseAPPEUI },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_25_loracoms_Link__["a" /* default */],
                    { onClick: function onClick() {
                        return _this2.setState({ collapseAPPEUI: true });
                      } },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-resize-small" })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                "DevEUI",
                ' ',
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                  { "if": collapseDEVEUI },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_25_loracoms_Link__["a" /* default */],
                    { onClick: function onClick() {
                        return _this2.setState({ collapseDEVEUI: false });
                      } },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-resize-full" })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                  { "if": !collapseDEVEUI },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_25_loracoms_Link__["a" /* default */],
                    { onClick: function onClick() {
                        return _this2.setState({ collapseDEVEUI: true });
                      } },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-resize-small" })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('data.field.devname', 'lora')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                { "if": showRadioFields && dir === 'up' },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-wifi" }),
                  ' ',
                  this.intlMsg.msg('data.field.channel', 'lora')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                { "if": showRadioFields },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-wifi" }),
                  ' ',
                  this.intlMsg.msg('data.field.frequency', 'lora')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                { "if": showRadioFields },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-wifi" }),
                  ' ',
                  this.intlMsg.msg('data.field.bandwidth', 'lora')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                { "if": showRadioFields },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-wifi" }),
                  ' ',
                  "SF"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                { "if": showRadioFields && dir === 'up' },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-wifi" }),
                  ' ',
                  "SNR"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                { "if": showRadioFields && dir === 'up' },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-wifi" }),
                  ' ',
                  "RSSI"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                " ",
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
                ' ',
                this.intlMsg.msg('data.field.msgtype', 'lora'),
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                " ",
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
                ' ',
                this.intlMsg.msg('data.field.frameno', 'lora'),
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                { "if": showDataFields },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  " ",
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
                  ' ',
                  "FPort "
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                { "if": showDataFields },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  " ",
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
                  ' ',
                  "FCtrl "
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                { "if": showDataFields },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  " ",
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
                  ' ',
                  "FOpts "
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                { "if": showDataFields && dir === 'up' },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
                  ' ',
                  this.intlMsg.msg('data.field.size', 'lora')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                { "if": showDataFields },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
                  ' ',
                  this.intlMsg.msg('data.field.data', 'lora')
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tbody",
            null,
            rows
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.pager },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_loracoms_TablePager__["a" /* default */], {
            status: status,
            mark: mark,
            more: more,
            onNext: this.handleChangeMark,
            onPrev: this.handleChangeMark,
            reset: reset
          })
        )
      )
    );
  };

  return CloudGtw;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

CloudGtw.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    gatewayData: state.gateway.gatewayData,
    gateway: state.gateway.gateway.data || {}
  };
};

var mapDispatchToProps = {
  getGatewayData: __WEBPACK_IMPORTED_MODULE_15_loraactions_gateway__["a" /* default */].gatewayData
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(CloudGtw)));

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_difference_in_seconds__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_difference_in_seconds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_difference_in_seconds__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_day__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_add_days__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns_add_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_is_after__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_is_after___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_date_fns_is_after__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_is_before__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_is_before___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_date_fns_is_before__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_min__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_date_fns_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loraactions_gateway__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_Refresher__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loracoms_DataDirSwitch__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loracoms_DateTimePicker__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_loracoms_InlineSelect__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_loracoms_TablePager__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_loracoms_PanelToolbar__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_loracoms_Link__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lorautils_DateTimeUtils__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__styles_scss__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




























function defaultFrom() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["subDays"])(new Date(), 1);
}

function defaultTo() {
  return new Date();
}

function isNew(time) {
  return __WEBPACK_IMPORTED_MODULE_6_date_fns_difference_in_seconds___default()(new Date(), time) < 10;
}

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  getGatewayData: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  gatewayId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  gatewayData: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var CubeGtw = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(CubeGtw, _React$Component);

  CubeGtw.handleDisableDate = function handleDisableDate(d, from) {
    return __WEBPACK_IMPORTED_MODULE_12_date_fns_is_after___default()(d, __WEBPACK_IMPORTED_MODULE_14_date_fns_min___default()(__WEBPACK_IMPORTED_MODULE_11_date_fns_add_days___default()(from, 7), new Date())) || __WEBPACK_IMPORTED_MODULE_13_date_fns_is_before___default()(d, __WEBPACK_IMPORTED_MODULE_11_date_fns_add_days___default()(from, -1));
  };

  function CubeGtw(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CubeGtw);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      gatewayData: props.gatewayData,
      dir: 'up',
      fields: ['radio'],
      from: defaultFrom(),
      to: defaultTo()
    };
    _this.handleToggleFields = _this.handleToggleFields.bind(_this);
    _this.handleChangeFrom = _this.handleChangeFrom.bind(_this);
    _this.handleChangeTo = _this.handleChangeTo.bind(_this);
    _this.handleChangeDir = _this.handleChangeDir.bind(_this);
    _this.handleReload = _this.handleReload.bind(_this);
    _this.handleChangeMark = _this.handleChangeMark.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_21_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaydetail.statview');
    return _this;
  }

  CubeGtw.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        getGatewayData = _props.getGatewayData,
        gatewayId = _props.gatewayId;
    var _state = this.state,
        dir = _state.dir,
        from = _state.from,
        to = _state.to;

    getGatewayData(gatewayId, {
      dir: dir,
      limit: 20,
      start: from.valueOf(),
      end: to.valueOf()
    });
  };

  CubeGtw.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var gatewayData = nextProps.gatewayData;

    if (gatewayData !== this.props.gatewayData) {
      this.setState({ gatewayData: gatewayData });
      if (gatewayData.status === 'success') {
        this.setState({ dataList: gatewayData.data.list });
      }
    }
  };

  CubeGtw.prototype.handleChangeDir = function handleChangeDir(dir) {
    this.setState({
      dir: dir,
      reset: Math.random()
    });

    var _props2 = this.props,
        getGatewayData = _props2.getGatewayData,
        gatewayId = _props2.gatewayId;
    var _state2 = this.state,
        _state2$from = _state2.from,
        from = _state2$from === undefined ? defaultFrom() : _state2$from,
        _state2$to = _state2.to,
        to = _state2$to === undefined ? defaultTo() : _state2$to;

    getGatewayData(gatewayId, {
      dir: dir,
      limit: 20,
      start: from.valueOf(),
      end: this.caculaTo(to).valueOf()
    });
  };

  CubeGtw.prototype.handleToggleFields = function handleToggleFields(fields) {
    this.setState({ fields: fields });
  };

  CubeGtw.prototype.handleReload = function handleReload() {
    this.setState({ reset: Math.random() });
    var _props3 = this.props,
        getGatewayData = _props3.getGatewayData,
        gatewayId = _props3.gatewayId;
    var dir = this.state.dir;
    var _state3 = this.state,
        from = _state3.from,
        to = _state3.to;
    // 刷新时将时间置为最新时间

    from = defaultFrom();
    to = defaultTo();
    this.setState({ from: from, to: to });
    getGatewayData(gatewayId, {
      dir: dir,
      limit: 20,
      start: from.valueOf(),
      end: this.caculaTo(to).valueOf()
    });
  };

  CubeGtw.prototype.handleChangeFrom = function handleChangeFrom(from) {
    var to = this.state.to;

    if (from.valueOf() > to.valueOf()) {
      to = from;
    }
    this.setState({ from: from, to: to, reset: Math.random() });
    var _props4 = this.props,
        getGatewayData = _props4.getGatewayData,
        gatewayId = _props4.gatewayId;
    var dir = this.state.dir;

    getGatewayData(gatewayId, {
      dir: dir,
      limit: 20,
      start: from.valueOf(),
      end: to.valueOf()
    });
  };

  CubeGtw.prototype.handleChangeTo = function handleChangeTo(to) {
    this.setState({ to: to, reset: Math.random() });
    var _props5 = this.props,
        getGatewayData = _props5.getGatewayData,
        gatewayId = _props5.gatewayId;
    var _state4 = this.state,
        dir = _state4.dir,
        _state4$from = _state4.from,
        from = _state4$from === undefined ? defaultFrom() : _state4$from;

    getGatewayData(gatewayId, {
      dir: dir,
      limit: 20,
      start: from.valueOf(),
      end: this.caculaTo(to).valueOf()
    });
  };

  CubeGtw.prototype.caculaTo = function caculaTo(to) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["addMinutes"])(to, 1);
  };

  CubeGtw.prototype.handleChangeMark = function handleChangeMark() {
    var mark = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var _props6 = this.props,
        gatewayId = _props6.gatewayId,
        getGatewayData = _props6.getGatewayData;
    var _state5 = this.state,
        dir = _state5.dir,
        _state5$from = _state5.from,
        from = _state5$from === undefined ? defaultFrom() : _state5$from,
        _state5$to = _state5.to,
        to = _state5$to === undefined ? defaultTo() : _state5$to;


    getGatewayData(gatewayId, {
      dir: dir,
      limit: 20,
      start: from.valueOf(),
      end: this.caculaTo(to).valueOf(),
      mark: mark
    });
  };

  CubeGtw.prototype.renderPanelToolbar = function renderPanelToolbar() {
    var _state6 = this.state,
        fields = _state6.fields,
        from = _state6.from,
        to = _state6.to;

    var tools = [__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_DateTimePicker__["a" /* default */], {
      date: from,
      closeOnSelect: false,
      onSelect: this.handleChangeFrom
    }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_DateTimePicker__["a" /* default */], {
      date: to,
      closeOnSelect: false,
      onSelect: this.handleChangeTo,
      disabled: function disabled(d) {
        return CubeGtw.handleDisableDate(d, from);
      }
    }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_DataDirSwitch__["a" /* default */], { onChange: this.handleChangeDir }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_loracoms_InlineSelect__["a" /* default */], {
      options: [{
        label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-wifi" }),
          this.intlMsg.msg('fields.spills.radio')
        ),
        value: 'radio',
        active: true
      }, {
        label: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
          this.intlMsg.msg('fields.spills.datamsg')
        ),
        value: 'datamsg'
      }],
      multiple: true,
      values: fields,
      onChange: this.handleToggleFields
    })];
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_loracoms_PanelToolbar__["a" /* default */], { tools: tools });
  };

  CubeGtw.prototype.render = function render() {
    var _this2 = this;

    var gatewayData = this.state.gatewayData;

    var header = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      this.intlMsg.msg('data.header'),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "ul",
        { className: "icontools" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_Refresher__["a" /* default */], {
            onReload: this.handleReload,
            reloading: gatewayData.status === 'pending'
          })
        )
      )
    );

    var _state7 = this.state,
        _state7$dataList = _state7.dataList,
        dataList = _state7$dataList === undefined ? [] : _state7$dataList,
        _state7$fields = _state7.fields,
        fields = _state7$fields === undefined ? [] : _state7$fields,
        _state7$collapseAPPEU = _state7.collapseAPPEUI,
        collapseAPPEUI = _state7$collapseAPPEU === undefined ? false : _state7$collapseAPPEU,
        _state7$collapseDEVEU = _state7.collapseDEVEUI,
        collapseDEVEUI = _state7$collapseDEVEU === undefined ? false : _state7$collapseDEVEU,
        dir = _state7.dir;

    var showRadioFields = fields.includes('radio');
    var showDataFields = fields.includes('datamsg');

    var rows = dataList.map(function (d) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        { key: d.$time + "-" + d.deveui + "-" + d.fcnt, className: isNew(d.$time) ? __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.new : '' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.compact },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_lorautils_DateTimeUtils__["a" /* compactFormat */])(d.$time)
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.compact },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_25_loracoms_Link__["a" /* default */],
            { to: "/application/" + d.appeui },
            collapseAPPEUI ? "..." + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_lorautils_IdUtils__["d" /* normalizeAppEUI */])(d.appeui).substr(-5) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_lorautils_IdUtils__["d" /* normalizeAppEUI */])(d.appeui)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.compact },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_25_loracoms_Link__["a" /* default */],
            { to: "/application/" + d.appeui + "/devices/" + d.deveui },
            collapseDEVEUI ? "..." + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_lorautils_IdUtils__["a" /* normalizeDevEUI */])(d.deveui).substr(-5) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_lorautils_IdUtils__["a" /* normalizeDevEUI */])(d.deveui)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_25_loracoms_Link__["a" /* default */],
            { to: "/application/" + d.appeui + "/devices/" + d.deveui },
            d.name
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
          { "if": showRadioFields && dir === 'up' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.channel,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
          { "if": showRadioFields },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.frequency / 1000000,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
          { "if": showRadioFields },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.bandwidth + " | " + d.coderate,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
          { "if": showRadioFields },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.spreadfactor,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
          { "if": showRadioFields && dir === 'up' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            d.lorasnr && Number(d.lorasnr).toFixed(1)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
          { "if": showRadioFields && dir === 'up' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.rssi,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_loracoms_RichLabel__["a" /* default */], {
            content: d.mtype,
            translateMap: {
              UnconfirmedDataUp: _this2.intlMsg.msg('unconfirmeddataup'),
              UnconfirmedDataDown: _this2.intlMsg.msg('unconfirmeddatadown'),
              ConfirmedDataUp: _this2.intlMsg.msg('confirmeddataup'),
              ConfirmedDataDown: _this2.intlMsg.msg('confirmeddatadown'),
              JoinRequest: _this2.intlMsg.msg('joinrequest'),
              JoinAccept: _this2.intlMsg.msg('joinaccept'),
              RFU: _this2.intlMsg.msg('rfu'),
              Proprietary: _this2.intlMsg.msg('proprietary')
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          d.fcnt
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
          { "if": showDataFields },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.fport,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
          { "if": showDataFields },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.fctrl,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
          { "if": showDataFields },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.fopts,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
          { "if": showDataFields && dir === 'up' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.size,
            " "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
          { "if": showDataFields },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "td",
            null,
            " ",
            d.data,
            " "
          )
        )
      );
    });

    var _state8 = this.state,
        _state8$gatewayData = _state8.gatewayData,
        status = _state8$gatewayData.status,
        _state8$gatewayData$d = _state8$gatewayData.data;
    _state8$gatewayData$d = _state8$gatewayData$d === undefined ? {} : _state8$gatewayData$d;
    var mark = _state8$gatewayData$d.mark,
        more = _state8$gatewayData$d.more,
        reset = _state8.reset;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: header },
      this.renderPanelToolbar(),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.dataTable },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Table"],
          { className: "aisz-table-light", striped: true, hover: true, bordered: true, responsive: true },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('data.field.time', 'lora')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                "AppEUI",
                ' ',
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                  { "if": collapseAPPEUI },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_25_loracoms_Link__["a" /* default */],
                    { onClick: function onClick() {
                        return _this2.setState({ collapseAPPEUI: false });
                      } },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-resize-full" })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                  { "if": !collapseAPPEUI },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_25_loracoms_Link__["a" /* default */],
                    { onClick: function onClick() {
                        return _this2.setState({ collapseAPPEUI: true });
                      } },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-resize-small" })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                "DevEUI",
                ' ',
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                  { "if": collapseDEVEUI },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_25_loracoms_Link__["a" /* default */],
                    { onClick: function onClick() {
                        return _this2.setState({ collapseDEVEUI: false });
                      } },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-resize-full" })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                  { "if": !collapseDEVEUI },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_25_loracoms_Link__["a" /* default */],
                    { onClick: function onClick() {
                        return _this2.setState({ collapseDEVEUI: true });
                      } },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-resize-small" })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('data.field.devname', 'lora')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                { "if": showRadioFields && dir === 'up' },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-wifi" }),
                  ' ',
                  this.intlMsg.msg('data.field.channel', 'lora')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                { "if": showRadioFields },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-wifi" }),
                  ' ',
                  this.intlMsg.msg('data.field.frequency', 'lora')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                { "if": showRadioFields },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-wifi" }),
                  ' ',
                  this.intlMsg.msg('data.field.bandwidth', 'lora')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                { "if": showRadioFields },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-wifi" }),
                  ' ',
                  "SF"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                { "if": showRadioFields && dir === 'up' },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-wifi" }),
                  ' ',
                  "SNR"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                { "if": showRadioFields && dir === 'up' },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-wifi" }),
                  ' ',
                  "RSSI"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                " ",
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
                ' ',
                this.intlMsg.msg('data.field.msgtype', 'lora'),
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                " ",
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
                ' ',
                this.intlMsg.msg('data.field.frameno', 'lora'),
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                { "if": showDataFields },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  " ",
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
                  ' ',
                  "FPort "
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                { "if": showDataFields },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  " ",
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
                  ' ',
                  "FCtrl "
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                { "if": showDataFields },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  " ",
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
                  ' ',
                  "FOpts "
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                { "if": showDataFields && dir === 'up' },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
                  ' ',
                  this.intlMsg.msg('data.field.size', 'lora')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22_loracoms_ShowIf__["a" /* default */],
                { "if": showDataFields },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-envelope" }),
                  ' ',
                  this.intlMsg.msg('data.field.data', 'lora')
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tbody",
            null,
            rows
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_28__styles_scss___default.a.pager },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_loracoms_TablePager__["a" /* default */], {
            status: status,
            mark: mark,
            more: more,
            onNext: this.handleChangeMark,
            onPrev: this.handleChangeMark,
            reset: reset
          })
        )
      )
    );
  };

  return CubeGtw;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

CubeGtw.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    gatewayData: state.gateway.gatewayData,
    gateway: state.gateway.gateway.data || {}
  };
};

var mapDispatchToProps = {
  getGatewayData: __WEBPACK_IMPORTED_MODULE_15_loraactions_gateway__["a" /* default */].gatewayData
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(CubeGtw)));

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loracfg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CubeGtw__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CloudGtw__ = __webpack_require__(1281);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);






var propTypes = {
  gatewayId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired
};

var GatewayData = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(GatewayData, _React$Component);

  function GatewayData(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GatewayData);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {};
    return _this;
  }

  GatewayData.prototype.render = function render() {
    var gatewayId = this.props.gatewayId;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_4_loracfg__["a" /* default */].profile === 'cube' && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CubeGtw__["a" /* default */], { gatewayId: gatewayId }),
      __WEBPACK_IMPORTED_MODULE_4_loracfg__["a" /* default */].profile === 'cloud' && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CloudGtw__["a" /* default */], { gatewayId: gatewayId })
    );
  };

  return GatewayData;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

GatewayData.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (GatewayData);

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loracoms_PieChart__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss__ = __webpack_require__(2262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__selectors__ = __webpack_require__(177);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









function toSeries(sfData) {
  var sum = _.sum(_.values(sfData));
  return {
    label: {
      normal: {
        formatter: function formatter(params) {
          return Number(params.value / sum * 100).toFixed(2) + "%";
        },
        fontSize: 10
      },
      emphasis: {
        formatter: function formatter(params) {
          return "" + Number(params.name / 1000000).toFixed(1);
        }
      }
    },
    data: _.map(sfData, function (value, name) {
      return {
        name: name,
        value: value,
        label: {
          normal: {
            position: value / sum < 0.1 ? 'outside' : 'inside'
          }
        },
        labelLine: {
          normal: {
            length: 5,
            length2: 5
          }
        }
      };
    })
  };
}

var defaultProps = {
  resize: 0
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  sfData: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  resize: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.number
};

var GatewayFreqPie = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(GatewayFreqPie, _React$Component);

  function GatewayFreqPie(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GatewayFreqPie);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      sfData: props.sfData,
      resize: props.resize
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaydetail.statschart');
    return _this;
  }

  GatewayFreqPie.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var sfData = nextProps.sfData,
        resize = nextProps.resize;

    if (sfData !== this.props.sfData) {
      this.setState({ sfData: sfData });
    }
    if (resize !== this.props.resize) {
      this.setState({ resize: resize });
    }
  };

  GatewayFreqPie.prototype.render = function render() {
    var _state = this.state,
        sfData = _state.sfData,
        resize = _state.resize;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.chart },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_loracoms_PieChart__["a" /* default */], { series: [toSeries(sfData)], resize: resize })
    );
  };

  return GatewayFreqPie;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

GatewayFreqPie.defaultProps = defaultProps;
GatewayFreqPie.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    sfData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__selectors__["c" /* toDistrPieData */])('freq')(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(GatewayFreqPie)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loracoms_BarChart__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss__ = __webpack_require__(2263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__selectors__ = __webpack_require__(177);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var defaultProps = {
  resize: 0
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  option: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  resize: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.number
};

var GatewayFreqTrend = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(GatewayFreqTrend, _React$Component);

  function GatewayFreqTrend(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GatewayFreqTrend);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      option: props.option,
      resize: props.resize
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaydetail.statschart');
    return _this;
  }

  GatewayFreqTrend.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var option = nextProps.option,
        resize = nextProps.resize;

    if (option !== this.props.option) {
      this.setState({ option: option });
    }
    if (resize !== this.props.resize) {
      this.setState({ resize: resize });
    }
  };

  GatewayFreqTrend.prototype.render = function render() {
    var _state = this.state,
        option = _state.option,
        _state$resize = _state.resize,
        resize = _state$resize === undefined ? 0 : _state$resize;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.chart },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_loracoms_BarChart__["a" /* default */], {
        yAxis: {
          name: this.intlMsg.msg('axis.pkts'),
          splitNumber: 5
        },
        xAxis: {
          axisTick: { interval: 0 },
          splitArea: {
            show: true,
            interval: 0,
            areaStyle: { color: ['rgba(218, 223, 225, 0.2)', '#FFFFFF'] }
          }
        },
        legend: {
          data: option.legend,
          formatter: function formatter(x) {
            return Number(x / 1000000).toFixed(1);
          }
        },
        tooltip: {
          formatter: function formatter(params) {
            var dataLines = params.map(function (p) {
              return "<span style=\"display: inline-block; background: " + p.color + "; width: 9px; height: 9px; border-radius: 100%;\"></span> " + Number(p.seriesName / 1000000).toFixed(1) + " : " + p.value;
            }).join('<br />');
            return params[0].name + "<br />" + dataLines;
          }
        },
        dataZoom: [{
          fillerColor: 'rgba(228, 241, 254, 0.4)',
          dataBackground: {
            lineStyle: {
              width: 0
            },
            areaStyle: {
              color: 'rgba(107, 185, 240, 0.8)'
            }
          }
        }],
        grid: {
          left: 60,
          top: 30,
          right: 30,
          bottom: 60
        },
        series: option.series,
        categories: option.categories,
        resize: resize
      })
    );
  };

  return GatewayFreqTrend;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

GatewayFreqTrend.defaultProps = defaultProps;
GatewayFreqTrend.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    option: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__selectors__["d" /* toDistrTrendOption */])('freq')(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(GatewayFreqTrend)));

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_sub_days__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_sub_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns_sub_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_sub_hours__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_sub_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_sub_hours__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_sub_months__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_sub_months___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_sub_months__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_add_hours__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_add_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_add_hours__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_add_days__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_add_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_add_months__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_add_months___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_add_months__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_start_of_day__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_start_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns_start_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_start_of_hour__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_start_of_hour___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_date_fns_start_of_hour__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_start_of_month__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_start_of_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_date_fns_start_of_month__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_end_of_hour__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_end_of_hour___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_date_fns_end_of_hour__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_end_of_day__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_end_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_date_fns_end_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_is_after__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_is_after___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_date_fns_is_after__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_date_fns_is_before__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_date_fns_is_before___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_date_fns_is_before__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_date_fns_min__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_date_fns_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_date_fns_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_date_fns_end_of_month__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_date_fns_end_of_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_date_fns_end_of_month__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_loracoms_Refresher__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_loracoms_InlineSelect__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_loracoms_DatePicker__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_loracoms_CollapseToggle__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_loraactions_gateway__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__GatewayPktTrend__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__GatewaySFTrend__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__GatewayFreqTrend__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__GatewayPktPie__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__GatewaySFPie__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__GatewayFreqPie__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__styles_scss__ = __webpack_require__(2264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





































function addOne(t, by) {
  switch (by) {
    case 'YYYYMMDDHH':
      return __WEBPACK_IMPORTED_MODULE_8_date_fns_add_hours___default()(t, 1);
    case 'YYYYMMDD':
      return __WEBPACK_IMPORTED_MODULE_9_date_fns_add_days___default()(t, 1);
    case 'YYYYMM':
      return __WEBPACK_IMPORTED_MODULE_10_date_fns_add_months___default()(t, 1);
    default:
      return t;
  }
}

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  gatewayId: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  getGatewayPktStats: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  getGatewaySFStats: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  getGatewayFreqStats: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  pktStats: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  sfStats: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  freqStats: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired
};

var GatewayPacketStat = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(GatewayPacketStat, _React$Component);

  GatewayPacketStat.handleDisableDate = function handleDisableDate(d, from) {
    return __WEBPACK_IMPORTED_MODULE_16_date_fns_is_after___default()(d, __WEBPACK_IMPORTED_MODULE_18_date_fns_min___default()(__WEBPACK_IMPORTED_MODULE_9_date_fns_add_days___default()(from, 7), new Date())) || __WEBPACK_IMPORTED_MODULE_17_date_fns_is_before___default()(d, from);
  };

  function GatewayPacketStat(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GatewayPacketStat);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      pktStats: props.pktStats,
      sfStats: props.sfStats,
      freqStats: props.freqStats,
      by: 'YYYYMMDDHH',
      from: __WEBPACK_IMPORTED_MODULE_11_date_fns_start_of_day___default()(new Date()),
      to: __WEBPACK_IMPORTED_MODULE_15_date_fns_end_of_day___default()(new Date())
    };
    _this.handleChangeFrom = _this.handleChangeFrom.bind(_this);
    _this.handleChangeTo = _this.handleChangeTo.bind(_this);
    _this.loadPkts = _this.loadPkts.bind(_this);
    _this.loadSF = _this.loadSF.bind(_this);
    _this.loadFreq = _this.loadFreq.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_30_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaydetail.statview');
    return _this;
  }

  GatewayPacketStat.prototype.componentWillMount = function componentWillMount() {
    this.loadPkts();
    this.loadSF();
    this.loadFreq();
  };

  GatewayPacketStat.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var pktStats = nextProps.pktStats,
        sfStats = nextProps.sfStats,
        freqStats = nextProps.freqStats;

    if (pktStats !== this.props.pktStats) {
      this.setState({ pktStats: pktStats });
    }
    if (sfStats !== this.props.sfStats) {
      this.setState({ sfStats: sfStats });
    }
    if (freqStats !== this.props.freqStats) {
      this.setState({ freqStats: freqStats });
    }
  };

  GatewayPacketStat.prototype.defaultFrom = function defaultFrom() {
    var by = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.by;

    switch (by) {
      case 'YYYYMMDDHH':
        return __WEBPACK_IMPORTED_MODULE_12_date_fns_start_of_hour___default()(__WEBPACK_IMPORTED_MODULE_6_date_fns_sub_hours___default()(new Date(), 24));
      case 'YYYYMMDD':
        return __WEBPACK_IMPORTED_MODULE_11_date_fns_start_of_day___default()(__WEBPACK_IMPORTED_MODULE_5_date_fns_sub_days___default()(new Date(), 7));
      case 'YYYYMM':
        return __WEBPACK_IMPORTED_MODULE_13_date_fns_start_of_month___default()(__WEBPACK_IMPORTED_MODULE_7_date_fns_sub_months___default()(new Date(), 6));
      default:
        return __WEBPACK_IMPORTED_MODULE_12_date_fns_start_of_hour___default()(__WEBPACK_IMPORTED_MODULE_6_date_fns_sub_hours___default()(new Date(), 24));
    }
  };

  GatewayPacketStat.prototype.defaultTo = function defaultTo() {
    var by = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.by;

    switch (by) {
      case 'YYYYMMDDHH':
        return __WEBPACK_IMPORTED_MODULE_14_date_fns_end_of_hour___default()(new Date());
      case 'YYYYMMDD':
        return __WEBPACK_IMPORTED_MODULE_15_date_fns_end_of_day___default()(new Date());
      case 'YYYYMM':
        return __WEBPACK_IMPORTED_MODULE_19_date_fns_end_of_month___default()(new Date());
      default:
        return __WEBPACK_IMPORTED_MODULE_14_date_fns_end_of_hour___default()(new Date());
    }
  };

  GatewayPacketStat.prototype.loadStats = function loadStats(func) {
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var gatewayId = this.props.gatewayId;

    var nargs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      from: this.state.from,
      to: this.state.to,
      by: this.state.by
    }, args);
    var by = nargs.by,
        _nargs$from = nargs.from,
        from = _nargs$from === undefined ? this.defaultFrom(by) : _nargs$from;
    var _nargs$to = nargs.to,
        to = _nargs$to === undefined ? this.defaultTo(by) : _nargs$to;

    to = addOne(to, by);
    func(gatewayId, {
      from: __WEBPACK_IMPORTED_MODULE_20_date_fns_format___default()(from, by),
      to: __WEBPACK_IMPORTED_MODULE_20_date_fns_format___default()(to, by)
    });
  };

  GatewayPacketStat.prototype.loadPkts = function loadPkts() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var getGatewayPktStats = this.props.getGatewayPktStats;

    this.loadStats(getGatewayPktStats, args);
  };

  GatewayPacketStat.prototype.loadSF = function loadSF() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var getGatewaySFStats = this.props.getGatewaySFStats;

    this.loadStats(getGatewaySFStats, args);
  };

  GatewayPacketStat.prototype.loadFreq = function loadFreq() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var getGatewayFreqStats = this.props.getGatewayFreqStats;

    this.loadStats(getGatewayFreqStats, args);
  };

  GatewayPacketStat.prototype.handleChangeFrom = function handleChangeFrom(from) {
    var sod = __WEBPACK_IMPORTED_MODULE_11_date_fns_start_of_day___default()(from);
    var to = __WEBPACK_IMPORTED_MODULE_15_date_fns_end_of_day___default()(from);
    this.setState({ from: sod, to: to });
    this.loadPkts({ from: sod, to: to });
    this.loadSF({ from: sod, to: to });
    this.loadFreq({ from: sod, to: to });
  };

  GatewayPacketStat.prototype.handleChangeTo = function handleChangeTo(to) {
    var eod = __WEBPACK_IMPORTED_MODULE_15_date_fns_end_of_day___default()(to);
    this.setState({ to: eod });
    this.loadPkts({ to: eod });
    this.loadSF({ to: eod });
    this.loadFreq({ to: eod });
  };

  GatewayPacketStat.prototype.handleChangeBy = function handleChangeBy(by) {
    this.setState({ by: by });
    this.loadPkts({ by: by });
    this.loadSF({ by: by });
    this.loadFreq({ by: by });
  };

  GatewayPacketStat.prototype.renderToolbar = function renderToolbar() {
    var _this2 = this;

    var _state = this.state,
        by = _state.by,
        _state$from = _state.from,
        from = _state$from === undefined ? this.defaultFrom(by) : _state$from,
        _state$to = _state.to,
        to = _state$to === undefined ? this.defaultTo(by) : _state$to;

    var icon = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-filter" });
    var leftTools = [{
      input: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_loracoms_DatePicker__["a" /* default */], {
        date: from,
        onSelect: this.handleChangeFrom
      })
    }, {
      input: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_loracoms_DatePicker__["a" /* default */], {
        date: to,
        onSelect: this.handleChangeTo,
        disabled: function disabled(d) {
          return GatewayPacketStat.handleDisableDate(d, from);
        }
      })
    }, {
      input: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_loracoms_InlineSelect__["a" /* default */], {
        bsStyle: "aisz-primary",
        options: [{
          label: this.intlMsg.msg('toolbar.bytime.hours'),
          value: 'YYYYMMDDHH',
          active: true
        }, {
          label: this.intlMsg.msg('toolbar.bytime.days'),
          value: 'YYYYMMDD'
        }],
        values: [by],
        onChange: function onChange(selected) {
          return _this2.handleChangeBy(selected[0]);
        }
      })
    }];

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_loracoms_Toolbar__["a" /* default */], { brandIcon: icon, leftTools: leftTools });
  };

  GatewayPacketStat.prototype.renderPktStats = function renderPktStats() {
    var _this3 = this;

    var _state2 = this.state,
        status = _state2.pktStats.status,
        _state2$pktExpanded = _state2.pktExpanded,
        pktExpanded = _state2$pktExpanded === undefined ? true : _state2$pktExpanded,
        _state2$pktResize = _state2.pktResize,
        pktResize = _state2$pktResize === undefined ? 0 : _state2$pktResize;

    var header = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "span",
        null,
        this.intlMsg.msg('packetstat.packets')
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "ul",
        { className: "icontools" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_loracoms_Refresher__["a" /* default */], {
            onReload: this.loadPkts,
            reloading: status === 'pending'
          })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_loracoms_CollapseToggle__["a" /* default */], {
            expanded: pktExpanded,
            onChange: function onChange(v) {
              _this3.setState({ pktExpanded: v });
            }
          })
        )
      )
    );

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_24_react_bootstrap__["Panel"],
      {
        bsStyle: "aisz-white",
        header: header,
        collapsible: true,
        expanded: pktExpanded,
        onEntered: function onEntered() {
          _this3.setState({ pktResize: Math.random() });
        }
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_24_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_24_react_bootstrap__["Col"],
          { md: 9, className: "collapse-right" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__GatewayPktTrend__["a" /* default */], { resize: pktResize })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_24_react_bootstrap__["Col"],
          { md: 3, className: "collapse-left" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__GatewayPktPie__["a" /* default */], { resize: pktResize })
        )
      )
    );
  };

  GatewayPacketStat.prototype.renderSFStats = function renderSFStats() {
    var _this4 = this;

    var _state3 = this.state,
        status = _state3.sfStats.status,
        _state3$sfExpanded = _state3.sfExpanded,
        sfExpanded = _state3$sfExpanded === undefined ? true : _state3$sfExpanded,
        _state3$sfResize = _state3.sfResize,
        sfResize = _state3$sfResize === undefined ? 0 : _state3$sfResize;

    var header = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      null,
      this.intlMsg.msg('packetstat.bysf'),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "ul",
        { className: "icontools" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_loracoms_Refresher__["a" /* default */], {
            onReload: this.loadSF,
            reloading: status === 'pending'
          })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_loracoms_CollapseToggle__["a" /* default */], {
            expanded: sfExpanded,
            onChange: function onChange(v) {
              _this4.setState({ sfExpanded: v });
            }
          })
        )
      )
    );

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_24_react_bootstrap__["Panel"],
      {
        bsStyle: "aisz-white",
        header: header,
        collapsible: true,
        expanded: sfExpanded,
        onEntered: function onEntered() {
          _this4.setState({ sfResize: Math.random() });
        }
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_24_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_24_react_bootstrap__["Col"],
          { md: 9, className: "collapse-right" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__GatewaySFTrend__["a" /* default */], { resize: sfResize })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_24_react_bootstrap__["Col"],
          { md: 3, className: "collapse-left" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__GatewaySFPie__["a" /* default */], { resize: sfResize })
        )
      )
    );
  };

  GatewayPacketStat.prototype.renderFreqStats = function renderFreqStats() {
    var _this5 = this;

    var _state4 = this.state,
        status = _state4.freqStats.status,
        _state4$freqExpanded = _state4.freqExpanded,
        freqExpanded = _state4$freqExpanded === undefined ? true : _state4$freqExpanded,
        _state4$freqResize = _state4.freqResize,
        freqResize = _state4$freqResize === undefined ? 0 : _state4$freqResize;

    var header = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      null,
      this.intlMsg.msg('packetstat.byfreq'),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "ul",
        { className: "icontools" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_loracoms_Refresher__["a" /* default */], {
            onReload: this.loadFreq,
            reloading: status === 'pending'
          })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_loracoms_CollapseToggle__["a" /* default */], {
            expanded: freqExpanded,
            onChange: function onChange(v) {
              _this5.setState({ freqExpanded: v });
            }
          })
        )
      )
    );

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_24_react_bootstrap__["Panel"],
      {
        bsStyle: "aisz-white",
        header: header,
        collapsible: true,
        expanded: freqExpanded,
        onEntered: function onEntered() {
          _this5.setState({ freqResize: Math.random() });
        }
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_24_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_24_react_bootstrap__["Col"],
          { md: 9, className: "collapse-right" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__GatewayFreqTrend__["a" /* default */], { resize: freqResize })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_24_react_bootstrap__["Col"],
          { md: 3, className: "collapse-left" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__GatewayFreqPie__["a" /* default */], { resize: freqResize })
        )
      )
    );
  };

  GatewayPacketStat.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_38__styles_scss___default.a.packets },
      this.renderToolbar(),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "ul",
        { className: __WEBPACK_IMPORTED_MODULE_38__styles_scss___default.a.panels },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "li",
          null,
          this.renderPktStats()
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "li",
          null,
          this.renderSFStats()
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "li",
          null,
          this.renderFreqStats()
        )
      )
    );
  };

  return GatewayPacketStat;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

GatewayPacketStat.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    pktStats: state.gateway.getGatewayPktStats,
    sfStats: state.gateway.getGatewaySFStats,
    freqStats: state.gateway.getGatewayFreqStats
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_22_react_router_redux__["routerActions"].push,
  getGatewayPktStats: __WEBPACK_IMPORTED_MODULE_31_loraactions_gateway__["a" /* default */].getGatewayPktStats,
  getGatewaySFStats: __WEBPACK_IMPORTED_MODULE_31_loraactions_gateway__["a" /* default */].getGatewaySFStats,
  getGatewayFreqStats: __WEBPACK_IMPORTED_MODULE_31_loraactions_gateway__["a" /* default */].getGatewayFreqStats,
  getGatewayTOAStats: __WEBPACK_IMPORTED_MODULE_31_loraactions_gateway__["a" /* default */].getGatewayTOAStats
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_react_intl__["injectIntl"])(GatewayPacketStat)));

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loracoms_PieChart__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss__ = __webpack_require__(2265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__selectors__ = __webpack_require__(177);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var defaultProps = {
  resize: 0
};

var propTypes = {
  pktData: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  resize: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.number
};

var GatewayPktPie = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(GatewayPktPie, _React$Component);

  function GatewayPktPie(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GatewayPktPie);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      pktData: props.pktData,
      resize: props.resize
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaydetail.statschart');
    return _this;
  }

  GatewayPktPie.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var pktData = nextProps.pktData,
        resize = nextProps.resize;

    if (pktData !== this.props.pktData) {
      this.setState({ pktData: pktData });
    }
    if (resize !== this.props.resize) {
      this.setState({ resize: resize });
    }
  };

  GatewayPktPie.prototype.toSeries = function toSeries(pktData) {
    return {
      label: {
        normal: {
          formatter: '{b}\n{d}%'
        },
        emphasis: {
          formatter: '{b}\n{d}%'
        }
      },
      data: [{
        name: this.intlMsg.msg('series.pktsun'),
        value: pktData.pktsun,
        itemStyle: {
          normal: {
            color: '#F7CA18'
          }
        },
        label: {
          normal: {
            position: pktData.pktsun / pktData.pkts < 0.1 ? 'outside' : 'inside'
          }
        },
        labelLine: {
          normal: {
            length: 5,
            length2: 5
          }
        }
      }, {
        name: this.intlMsg.msg('series.pktsau'),
        value: pktData.pktsau,
        itemStyle: {
          normal: {
            color: '#00B16A'
          }
        },
        label: {
          normal: {
            position: pktData.pktsau / pktData.pkts < 0.1 ? 'outside' : 'inside'
          }
        }
      }]
    };
  };

  GatewayPktPie.prototype.render = function render() {
    var _state = this.state,
        pktData = _state.pktData,
        resize = _state.resize;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.chart },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_loracoms_PieChart__["a" /* default */], { series: [this.toSeries(pktData)], resize: resize })
    );
  };

  return GatewayPktPie;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

GatewayPktPie.defaultProps = defaultProps;
GatewayPktPie.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    pktData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__selectors__["e" /* toPktPieData */])(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(GatewayPktPie)));

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loracoms_LineChart__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss__ = __webpack_require__(2266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);








var defaultProps = {
  resize: 0
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  pktStats: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  resize: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.number
};

function formatSlot(slot) {
  var s = String(slot);
  if (s.length >= 10) {
    return s.slice(6, 8) + "/" + s.slice(4, 6) + " " + s.slice(8, 10) + ":00";
  } else if (s.length >= 8) {
    return s.slice(6, 8) + "/" + s.slice(4, 6);
  }
  return s.slice(4, 6);
}

var GatewayPktTrend = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(GatewayPktTrend, _React$Component);

  function GatewayPktTrend(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GatewayPktTrend);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaydetail.statschart');
    _this.state = {
      series: {
        rxpkt: {
          name: _this.intlMsg.msg('series.pkts'),
          data: [],
          yAxisIndex: 0
        },
        rxpktau: {
          name: _this.intlMsg.msg('series.pktsau'),
          data: [],
          yAxisIndex: 0
        },
        rxpktun: {
          name: _this.intlMsg.msg('series.pktsun'),
          data: [],
          yAxisIndex: 0
        },
        ltncs: {
          name: _this.intlMsg.msg('series.latency'),
          data: [],
          yAxisIndex: 1
        },
        categories: []
      },
      resize: props.resize
    };
    return _this;
  }

  GatewayPktTrend.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var pktStats = nextProps.pktStats,
        resize = nextProps.resize;

    if (pktStats !== this.props.pktStats) {
      if (pktStats.status === 'success') {
        var data = pktStats.data;

        var rxpkt = [];
        var rxpktau = [];
        var rxpktun = [];
        var ltncs = [];
        var slots = [];
        data.list.forEach(function (item) {
          slots.push(formatSlot(item.slot));
          rxpkt.push(item.rxpkt);
          rxpktun.push(item.rxpktun);
          rxpktau.push(item.rxpkt - item.rxpktun);
          ltncs.push(item.latency);
        });

        var series = this.state.series;

        series.rxpkt.data = rxpkt;
        series.rxpktau.data = rxpktau;
        series.rxpktun.data = rxpktun;
        series.ltncs.data = ltncs;
        series.categories = slots;
        this.setState({ series: series });
      }
    }
    if (resize !== this.props.resize) {
      this.setState({ resize: resize });
    }
  };

  GatewayPktTrend.prototype.render = function render() {
    var _state = this.state,
        series = _state.series,
        resize = _state.resize;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.chart },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_loracoms_LineChart__["a" /* default */], {
        yAxis: [{
          name: this.intlMsg.msg('axis.pkts'),
          splitNumber: 5
        }, {
          name: this.intlMsg.msg('axis.latency'),
          splitLine: { show: false }
        }],
        legend: {
          data: [this.intlMsg.msg('series.pkts'), this.intlMsg.msg('series.pktsau'), this.intlMsg.msg('series.pktsun'), this.intlMsg.msg('series.latency')]
        },
        series: [series.rxpkt, series.rxpktau, series.rxpktun, series.ltncs],
        categories: series.categories,
        dataZoom: [{
          type: 'slider',
          fillerColor: 'rgba(228, 241, 254, 0.4)',
          dataBackground: {
            lineStyle: { width: 0 },
            areaStyle: { color: 'rgba(107, 185, 240, 0.8)' }
          }
        }],
        grid: {
          left: 60,
          top: 30,
          right: 30,
          bottom: 60
        },
        resize: resize
      })
    );
  };

  return GatewayPktTrend;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

GatewayPktTrend.defaultProps = defaultProps;
GatewayPktTrend.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    pktStats: state.gateway.getGatewayPktStats
  };
};

var mapDispatchToProps = {};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(GatewayPktTrend)));

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNil__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_PropsPanel__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loraactions_gateway__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loraactions_enums__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loraactions_token__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lorautils_DateTimeUtils__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lorautils_cookies_auth__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lorautils_api_selector__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_loraactions_chplan__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__styles_scss__ = __webpack_require__(2267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__MapOverlay__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__selectors__ = __webpack_require__(1290);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



























var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  gatewayId: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  gateway: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  gatewayData: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  platOpts: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.array.isRequired,
  tokenOpts: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.array.isRequired,
  getPlatforms: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  updateGateway: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  getGateway: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  update: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  getTokens: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  getChannelPlans: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  channelPlans: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired
};

var kNonEmptyIds = ['name', 'platform', 'auth', 'lat', 'lng'];

var GatewayProps = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(GatewayProps, _React$Component);

  function GatewayProps(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GatewayProps);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      gateway: props.gateway,
      gatewayData: props.gatewayData,
      platOpts: props.platOpts,
      tokenOpts: props.tokenOpts,
      channelPlans: props.channelPlans,
      update: props.update,
      errors: new __WEBPACK_IMPORTED_MODULE_23_lorautils_errors_ErrorSet__["a" /* default */]()
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_21_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaydetail.detailview');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleSubmitLocation = _this.handleSubmitLocation.bind(_this);
    _this.handleSubmitToken = _this.handleSubmitToken.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleCancel = _this.handleCancel.bind(_this);
    _this.flushCp = _this.flushCp.bind(_this);
    _this.loadTxPowerOpts = _this.loadTxPowerOpts.bind(_this);
    return _this;
  }

  GatewayProps.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        getPlatforms = _props.getPlatforms,
        getTokens = _props.getTokens,
        getChannelPlans = _props.getChannelPlans;

    getPlatforms();
    getTokens({ pageSize: 1000 });
    getChannelPlans({ limit: 1000 });
  };

  GatewayProps.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var gateway = nextProps.gateway,
        platOpts = nextProps.platOpts,
        tokenOpts = nextProps.tokenOpts,
        gatewayData = nextProps.gatewayData,
        update = nextProps.update,
        channelPlans = nextProps.channelPlans;

    if (gateway !== this.props.gateway) {
      this.setState({ gateway: gateway });
    }
    if (platOpts !== this.props.platOpts) {
      this.setState({ platOpts: platOpts });
    }
    if (tokenOpts !== this.props.tokenOpts) {
      this.setState({ tokenOpts: tokenOpts });
    }
    if (gatewayData !== this.props.gatewayData) {
      this.setState({ gatewayData: gatewayData });
    }
    if (update !== this.props.update) {
      this.setState({ update: update });
      if (update.status === 'success') {
        var getGateway = nextProps.getGateway,
            gatewayId = nextProps.gatewayId;

        getGateway(gatewayId);
      }
    }
    if (channelPlans !== this.props.channelPlans) {
      this.setState({ channelPlans: channelPlans });
    }
  };

  GatewayProps.prototype.chplanOpts = function chplanOpts() {
    var channelPlans = this.state.channelPlans;

    if (channelPlans.status !== 'success') {
      return [];
    }
    return channelPlans.data.list.map(function (item) {
      return {
        label: item.name,
        value: item.id
      };
    });
  };

  GatewayProps.prototype.loadTxPowerOpts = function loadTxPowerOpts() {
    var _this2 = this;

    var gatewayId = this.props.gatewayId;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_lorautils_api__["a" /* callAPI */])({
      endpoint: "/lora/gateways/" + gatewayId + "/txpower",
      method: 'GET'
    }).then(function (data) {
      _this2.setState({ txpowerOpts: data.list.map(function (v) {
          return { value: v, label: v };
        }) });
    }).catch(function () {});
  };

  GatewayProps.prototype.status = function status() {
    var disconnected = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "span",
      null,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-circle-o", style: { color: '#EF4836' } }),
      ' ',
      this.intlMsg.msg('netstatus.status.disconnected')
    );
    var connected = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "span",
      null,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-circle", style: { color: '#00B16A' } }),
      ' ',
      this.intlMsg.msg('netstatus.status.connected')
    );

    var gateway = this.state.gateway;
    var status = gateway.status;

    if (status !== 'success') {
      return disconnected;
    }

    var _gateway$data = gateway.data,
        lastOn = _gateway$data.lastOn,
        lastOff = _gateway$data.lastOff;


    if (__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(lastOn)) {
      return disconnected;
    }
    if (__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(lastOff)) {
      return connected;
    }

    var onts = moment(lastOn).valueOf();
    var offts = moment(lastOff).valueOf();
    if (onts > offts) {
      return connected;
    }
    return disconnected;
  };

  GatewayProps.prototype.lastpacket = function lastpacket() {
    var _state$gatewayData = this.state.gatewayData,
        status = _state$gatewayData.status,
        data = _state$gatewayData.data;

    if (status === 'pending' || status === 'request') {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" });
    }
    if (status === 'success') {
      var list = data.list;

      if (list.length > 0) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_lorautils_DateTimeUtils__["a" /* compactFormat */])(list[0].$time);
      }
    }
    return undefined;
  };

  GatewayProps.prototype.checkNotEmpty = function checkNotEmpty(val, id) {
    var errors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.state.errors;

    if (__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(val) || __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty___default()(val)) {
      return errors.add('FE_EMPTY', id, { message: this.intlMsg.errorMsg('FE_EMPTY', 'lora') });
    }
    return errors.remove(id);
  };

  GatewayProps.prototype.handleChange = function handleChange(data, id) {
    var val = data[id];
    var errors = this.state.errors;

    if (kNonEmptyIds.includes(id)) {
      errors = this.checkNotEmpty(val, id, errors);
    }
    this.setState({ errors: errors });

    if (id === 'auth') {
      this.setState({ editAuth: val });
    }
  };

  GatewayProps.prototype.handleCancel = function handleCancel(ids) {
    var errors = this.state.errors;

    ids.forEach(function (id) {
      errors = errors.remove(id);
    });
    this.setState({ errors: errors, editAuth: null });
  };

  GatewayProps.prototype.flushCp = function flushCp() {
    var _this3 = this;

    var gatewayId = this.props.gatewayId;
    var errors = this.state.errors;

    errors = errors.remove('flushcp');
    this.setState({ cpFlushStatus: 'pending', errors: errors });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_lorautils_api__["a" /* callAPI */])({
      endpoint: "/lora/gateways/" + gatewayId + "/flushcp",
      method: 'POST'
    }).then(function () {
      _this3.setState({ cpFlushStatus: 'success' });
    }).catch(function (error) {
      _this3.setState({
        cpFlushStatus: 'failure',
        errors: errors.add(error.code, 'flushcp')
      });
    });
  };

  GatewayProps.prototype.handleSubmit = function handleSubmit(data, dirtyIds) {
    var _this4 = this;

    var gatewayId = this.props.gatewayId;


    if (__WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty___default()(dirtyIds)) {
      return true;
    }

    var errors = this.state.errors;

    errors = errors.remove('flushcp');
    if (!errors.isEmpty()) {
      return false;
    }

    if (dirtyIds.includes('chplan')) {
      if (!_.isNil(data.chplan) && data.chplan.startsWith('unbind-')) {
        var planId = data.chplan.split('-')[1];
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_lorautils_api__["a" /* callAPI */])({
          endpoint: "/lora/chplans/" + planId + "/unbind",
          query: {
            gw: gatewayId
          },
          method: 'POST'
        });
        this.setState({ errors: errors.remove('flushcp') });
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_lorautils_api__["a" /* callAPI */])({
          endpoint: "/lora/chplans/" + data.chplan + "/bind",
          query: { gw: gatewayId },
          method: 'POST'
        }).then(function () {
          _this4.flushCp();
        }).catch(function () {});
      }
    }

    var updateGateway = this.props.updateGateway;

    var udata = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data);

    if (!__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(udata.txpower)) {
      udata.txpower = +udata.txpower;
    }
    updateGateway(gatewayId, udata).then(function () {}).catch(function () {});
    return true;
  };

  GatewayProps.prototype.handleSubmitLocation = function handleSubmitLocation(point) {
    var _props2 = this.props,
        gatewayId = _props2.gatewayId,
        updateGateway = _props2.updateGateway;

    updateGateway(gatewayId, {
      lng: String(point.lng),
      lat: String(point.lat),
      alt: point.alt,
      address: point.address,
      area: point.area,
      city: point.city,
      gpssrc: 'baidu'
    });
    return true;
  };

  GatewayProps.prototype.handleSubmitToken = function handleSubmitToken(data) {
    var _this5 = this;

    var _props3 = this.props,
        getGateway = _props3.getGateway,
        gatewayId = _props3.gatewayId;
    var errors = this.state.errors;
    var token = data.token;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_lorautils_api__["a" /* callAPI */])({
      endpoint: "/lora/gateways/" + gatewayId + "/token",
      method: 'POST',
      query: {
        token: _.isNil(token) ? '' : token
      }
    }).then(function () {
      getGateway(gatewayId);
    }).catch(function (error) {
      _this5.setState({ errors: errors.add(error.code, 'token') });
    });
    return true;
  };

  GatewayProps.prototype.render = function render() {
    var _this6 = this;

    var _props4 = this.props,
        gatewayId = _props4.gatewayId,
        pushState = _props4.pushState;
    var _state = this.state,
        _state$gateway = _state.gateway,
        status = _state$gateway.status,
        _state$gateway$data = _state$gateway.data,
        gateway = _state$gateway$data === undefined ? {} : _state$gateway$data,
        platOpts = _state.platOpts,
        tokenOpts = _state.tokenOpts,
        errors = _state.errors,
        _state$showMap = _state.showMap,
        showMap = _state$showMap === undefined ? false : _state$showMap,
        channelPlans = _state.channelPlans,
        _state$cpFlushStatus = _state.cpFlushStatus,
        cpFlushStatus = _state$cpFlushStatus === undefined ? '' : _state$cpFlushStatus,
        _state$txpowerOpts = _state.txpowerOpts,
        txpowerOpts = _state$txpowerOpts === undefined ? [] : _state$txpowerOpts;
    var name = gateway.name,
        id = gateway.id,
        mac = gateway.mac,
        platform = gateway.platform,
        ip = gateway.ip,
        latency = gateway.latency,
        lastOn = gateway.lastOn,
        version = gateway.version,
        city = gateway.city,
        area = gateway.area,
        address = gateway.address,
        txpower = gateway.txpower,
        token = gateway.token,
        lat = gateway.lat,
        lng = gateway.lng,
        alt = gateway.alt,
        chplan = gateway.chplan;


    var basic = {
      name: name,
      id: id,
      mac: mac,
      platform: platform,
      ip: ip
    };
    var netStatus = {
      status: this.status(),
      latency: latency,
      lastOn: lastOn ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_lorautils_DateTimeUtils__["a" /* compactFormat */])(lastOn) : undefined,
      lastpacket: this.lastpacket()
    };
    var sdk = {
      version: version,
      sdkdl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "a",
        { href: "/v1/lora/gateways/" + gatewayId + "/sdk?access_token=" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_lorautils_cookies_auth__["b" /* getTokenCookies */])() },
        this.intlMsg.msg('sdk.dl'),
        ' ',
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-download-alt" })
      ),
      sdkdoc: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_router__["f" /* Link */],
        { onClick: function onClick() {
            return window.open('/static/docs/zh/gateway/SDKInstall.html');
          } },
        this.intlMsg.msg('sdk.view'),
        ' ',
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-eye-open" })
      )
    };
    var location = {
      city: city,
      area: area,
      address: address,
      lat: lat,
      lng: lng,
      alt: alt
    };
    var loraParams = {
      txpower: txpower,
      chplan: chplan
    };
    var authData = {
      token: token
    };

    var authTitle = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { className: "pull-left" },
      this.intlMsg.msg('auth.title'),
      " \xA0",
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["OverlayTrigger"],
        {
          placement: "top",
          overlay: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Tooltip"],
            { id: "token" },
            this.intlMsg.msg('tokenmanage')
          )
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_router__["f" /* Link */],
          { onClick: function onClick() {
              return pushState('/accountcenter/token');
            } },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-keys" })
        )
      )
    );

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_26__styles_scss___default.a.propsPanels },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_PropsPanel__["a" /* default */], {
        title: this.intlMsg.msg('properties.title'),
        data: basic,
        status: status,
        errors: errors,
        properties: [{
          id: 'name',
          name: this.intlMsg.msg('properties.name')
        }, {
          id: 'id',
          name: this.intlMsg.msg('properties.id'),
          readOnly: true
        }, {
          id: 'mac',
          name: this.intlMsg.msg('properties.mac'),
          readOnly: true,
          copy: function copy(v) {
            if (v && v.replace) {
              return v.replace(/-/g, '');
            }
            return v;
          }
        }, {
          id: 'platform',
          name: this.intlMsg.msg('properties.platform'),
          control: {
            type: 'select',
            options: platOpts
          }
        }, {
          id: 'ip',
          name: this.intlMsg.msg('properties.ip'),
          readOnly: true
        }],
        onChange: this.handleChange,
        onCancel: this.handleCancel,
        onSubmit: this.handleSubmit
      }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_PropsPanel__["a" /* default */], {
        title: this.intlMsg.msg('netstatus.title'),
        readOnly: true,
        data: netStatus,
        status: status,
        properties: [{
          id: 'status',
          name: this.intlMsg.msg('netstatus.status')
        }, {
          id: 'latency',
          name: this.intlMsg.msg('netstatus.latency'),
          unit: 'ms'
        }, {
          id: 'lastOn',
          name: this.intlMsg.msg('netstatus.laston')
        }, {
          id: 'lastpacket',
          name: this.intlMsg.msg('netstatus.lastpacket')
        }]
      }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_PropsPanel__["a" /* default */], {
        title: "SDK",
        readOnly: true,
        data: sdk,
        status: status,
        properties: [{
          id: 'version',
          value: version,
          name: this.intlMsg.msg('sdk.version')
        }, {
          id: 'sdkdl',
          name: this.intlMsg.msg('sdk.sdkdl')
        }, {
          id: 'sdkdoc',
          name: this.intlMsg.msg('sdk.docdl')
        }]
      }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_loracoms_PropsPanel__["a" /* default */],
        {
          title: this.intlMsg.msg('loraparams.title'),
          data: loraParams,
          status: status,
          onEdit: this.loadTxPowerOpts,
          properties: [{
            id: 'txpower',
            name: 'TX Power',
            unit: 'dBm',
            control: {
              type: 'select',
              options: txpowerOpts
            }
          }, {
            id: 'chplan',
            name: this.intlMsg.msg('chplan'),
            control: {
              type: 'select',
              options: [{
                label: this.intlMsg.msg('chplan.unbind'),
                value: "unbind-" + chplan,
                style: {
                  color: '#BDC3C7'
                }
              }].concat(this.chplanOpts())
            },
            formatter: function formatter(x) {
              return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Nvl__["a" /* default */], {
                status: channelPlans.status,
                val: x,
                formatter: function formatter(y) {
                  var _channelPlans$data = channelPlans.data;
                  _channelPlans$data = _channelPlans$data === undefined ? {} : _channelPlans$data;
                  var _channelPlans$data$li = _channelPlans$data.list,
                      list = _channelPlans$data$li === undefined ? [] : _channelPlans$data$li;

                  var plan = list.find(function (p) {
                    return p.id === y;
                  });
                  if (plan) {
                    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "div",
                      null,
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_8_react_router__["f" /* Link */],
                        { onClick: function onClick() {
                            return pushState("/network/chplans/" + plan.id);
                          } },
                        plan.name
                      ),
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                        "span",
                        { className: __WEBPACK_IMPORTED_MODULE_26__styles_scss___default.a.flushcp },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
                          { "if": cpFlushStatus === '' },
                          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_react_router__["f" /* Link */],
                            { onClick: _this6.flushCp },
                            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-cloud-download" }),
                            ' ',
                            _this6.intlMsg.msg('chplan.flush')
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
                          { "if": cpFlushStatus === 'pending' },
                          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" })
                        ),
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
                          { "if": cpFlushStatus === 'success' },
                          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-check-circle text-success" })
                        ),
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
                          { "if": cpFlushStatus === 'failure' },
                          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_react_router__["f" /* Link */],
                            { onClick: _this6.flushCp, className: "text-danger" },
                            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle text-danger" }),
                            ' ',
                            _this6.intlMsg.msg('chplan.flush.failure')
                          )
                        )
                      )
                    );
                  }
                  return null;
                }
              });
            }
          }],
          onCancel: this.handleCancel,
          onChange: this.handleChange,
          onSubmit: this.handleSubmit
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_26__styles_scss___default.a.errorBlock },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_FormBlock__["a" /* default */], {
            show: errors.has('flushcp'),
            message: this.intlMsg.errorMsg(errors.get('flushcp')),
            azStyle: "danger",
            closeButton: true,
            onHide: function onHide() {
              _this6.setState({ errors: errors.remove('flushcp') });
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_loracoms_PropsPanel__["a" /* default */],
        {
          title: authTitle,
          data: authData,
          status: status,
          errors: errors,
          properties: [{
            id: 'token',
            name: 'Token',
            control: {
              type: 'select',
              options: _.concat({
                label: this.intlMsg.msg('noauth'),
                value: null,
                formatter: function formatter(x) {
                  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    { className: __WEBPACK_IMPORTED_MODULE_26__styles_scss___default.a.noauth },
                    x
                  );
                }
              }, tokenOpts)
            },
            formatter: function formatter(x) {
              var tokenOpt = tokenOpts.find(function (opt) {
                return opt.value === x;
              });
              if (tokenOpt) {
                return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  null,
                  tokenOpt.label
                );
              }
              return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Nvl__["a" /* default */], { nul: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: __WEBPACK_IMPORTED_MODULE_26__styles_scss___default.a.noauth },
                  _this6.intlMsg.msg('noauth')
                ) });
            }
          }],
          onCancel: this.handleCancel,
          onChange: this.handleChange,
          onSubmit: this.handleSubmitToken
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_FormBlock__["a" /* default */], {
          show: errors.has('token'),
          message: this.intlMsg.errorMsg(errors.get('token')),
          azStyle: "danger",
          closeButton: true,
          onHide: function onHide() {
            _this6.setState({ errors: errors.remove('token') });
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__MapOverlay__["a" /* default */], {
        gateways: [gateway],
        show: showMap,
        onHide: function onHide() {
          return _this6.setState({ showMap: false });
        },
        onSave: this.handleSubmitLocation
      })
    );
  };

  return GatewayProps;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

GatewayProps.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    gateway: state.gateway.gateway || {},
    gatewayData: state.gateway.gatewayData || {},
    platOpts: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_lorautils_api_selector__["a" /* enumsToOptions */])('platforms', state),
    tokenOpts: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__selectors__["a" /* tokenOptionsSelector */])(state),
    update: state.gateway.updateGateway,
    channelPlans: state.chplan.getChannelPlans
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_9_react_router_redux__["routerActions"].push,
  getGateway: __WEBPACK_IMPORTED_MODULE_16_loraactions_gateway__["a" /* default */].gateway,
  updateGateway: __WEBPACK_IMPORTED_MODULE_16_loraactions_gateway__["a" /* default */].updateGateway,
  getPlatforms: __WEBPACK_IMPORTED_MODULE_17_loraactions_enums__["a" /* default */].platforms,
  getTokens: __WEBPACK_IMPORTED_MODULE_18_loraactions_token__["a" /* default */].getTokens,
  getChannelPlans: __WEBPACK_IMPORTED_MODULE_24_loraactions_chplan__["a" /* default */].getChannelPlans
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_intl__["injectIntl"])(GatewayProps)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14), __webpack_require__(11)))

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tokenOptionsSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



var tokensSelector = function tokensSelector(state) {
  return state.token.getTokens;
};
var tokenOptionsSelector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(tokensSelector, function (tokens) {
  if (tokens.status !== 'success') {
    return [];
  }
  return tokens.data.list.map(function (t) {
    return { label: t.name, value: t.token };
  });
});

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loracoms_PieChart__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss__ = __webpack_require__(2268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__selectors__ = __webpack_require__(177);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









function toSeries(sfData) {
  var sum = _.sum(_.values(sfData));
  return {
    label: {
      normal: {
        formatter: '{b}: {d}%'
      },
      emphasis: {
        formatter: '{b}: {d}%'
      }
    },
    data: _.map(sfData, function (value, name) {
      return {
        name: name,
        value: value,
        label: {
          normal: {
            position: value / sum < 0.1 ? 'outside' : 'inside',
            fontSize: 10
          }
        },
        labelLine: {
          normal: {
            length: 5,
            length2: 5
          }
        }
      };
    })
  };
}

var defaultProps = {
  resize: 0
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  sfData: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  resize: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.number
};

var GatewaySFPie = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(GatewaySFPie, _React$Component);

  function GatewaySFPie(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GatewaySFPie);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      sfData: props.sfData,
      resize: props.resize
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaydetail.statschart');
    return _this;
  }

  GatewaySFPie.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var sfData = nextProps.sfData,
        resize = nextProps.resize;

    if (sfData !== this.props.sfData) {
      this.setState({ sfData: sfData });
    }
    if (resize !== this.props.resize) {
      this.setState({ resize: resize });
    }
  };

  GatewaySFPie.prototype.render = function render() {
    var _state = this.state,
        sfData = _state.sfData,
        _state$resize = _state.resize,
        resize = _state$resize === undefined ? 0 : _state$resize;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.chart },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_loracoms_PieChart__["a" /* default */], { series: [toSeries(sfData)], resize: resize })
    );
  };

  return GatewaySFPie;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

GatewaySFPie.defaultProps = defaultProps;
GatewaySFPie.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    sfData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__selectors__["c" /* toDistrPieData */])('sf')(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(GatewaySFPie)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loracoms_BarChart__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss__ = __webpack_require__(2269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__selectors__ = __webpack_require__(177);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var defaultProps = {
  resize: 0
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  option: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  resize: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.number
};

var GatewaySFTrend = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(GatewaySFTrend, _React$Component);

  function GatewaySFTrend(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GatewaySFTrend);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      option: props.option,
      resize: props.resize
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaydetail.statschart');
    return _this;
  }

  GatewaySFTrend.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var option = nextProps.option,
        resize = nextProps.resize;

    if (option !== this.props.option) {
      this.setState({ option: option });
    }
    if (resize !== this.props.resize) {
      this.setState({ resize: resize });
    }
  };

  GatewaySFTrend.prototype.render = function render() {
    var _state = this.state,
        option = _state.option,
        resize = _state.resize;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.chart },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_loracoms_BarChart__["a" /* default */], {
        yAxis: {
          name: this.intlMsg.msg('axis.pkts'),
          splitNumber: 5
        },
        xAxis: {
          axisTick: { interval: 0 },
          splitArea: {
            show: true,
            interval: 0,
            areaStyle: { color: ['rgba(218, 223, 225, 0.2)', '#FFFFFF'] }
          }
        },
        legend: {
          data: option.legend
        },
        dataZoom: [{
          fillerColor: 'rgba(228, 241, 254, 0.4)',
          dataBackground: {
            lineStyle: {
              width: 0
            },
            areaStyle: {
              color: 'rgba(107, 185, 240, 0.8)'
            }
          }
        }],
        grid: {
          left: 60,
          top: 30,
          right: 30,
          bottom: 60
        },
        series: option.series,
        categories: option.categories,
        resize: resize
      })
    );
  };

  return GatewaySFTrend;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

GatewaySFTrend.defaultProps = defaultProps;
GatewaySFTrend.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    option: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__selectors__["d" /* toDistrTrendOption */])('sf')(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(GatewaySFTrend)));

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_BarChart__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss__ = __webpack_require__(2270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__selectors__ = __webpack_require__(177);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  option: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  unitDuration: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.number.isRequired,
  resize: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.number.isRequired
};

var GatewayTOARatioUplinkTrend = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(GatewayTOARatioUplinkTrend, _React$Component);

  function GatewayTOARatioUplinkTrend(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GatewayTOARatioUplinkTrend);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      option: props.option,
      unitDuration: props.unitDuration,
      resize: props.resize
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaydetail.statschart');
    return _this;
  }

  GatewayTOARatioUplinkTrend.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var option = nextProps.option,
        unitDuration = nextProps.unitDuration,
        resize = nextProps.resize;

    if (option !== this.props.option) {
      this.setState({ option: option });
    }
    if (unitDuration !== this.props.unitDuration) {
      this.setState({ unitDuration: unitDuration });
    }
    if (resize !== this.props.resize) {
      this.setState({ resize: resize });
    }
  };

  GatewayTOARatioUplinkTrend.prototype.render = function render() {
    var unitDuration = this.props.unitDuration;
    var resize = this.state.resize;
    var option = this.state.option;

    option = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, option, {
      series: option.series.map(function (serie) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, serie, {
          data: serie.data.map(function (d) {
            return d / unitDuration * 100;
          })
        });
      })
    });

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.chart },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_BarChart__["a" /* default */], {
        yAxis: {
          name: this.intlMsg.msg('axis.ratio'),
          splitNumber: 5,
          min: 0,
          axisLabel: {
            formatter: function formatter(x) {
              return Number(x).toFixed(3) + "%";
            }
          }
        },
        xAxis: {
          axisTick: { interval: 0 },
          splitArea: {
            show: true,
            interval: 0,
            areaStyle: { color: ['rgba(218, 223, 225, 0.2)', '#FFFFFF'] }
          }
        },
        legend: {
          data: option.legend,
          formatter: function formatter(x) {
            return Number(x / 1000000).toFixed(1);
          }
        },
        tooltip: {
          formatter: function formatter(params) {
            var dataLines = params.map(function (p) {
              return "<span style=\"display: inline-block; background: " + p.color + "; width: 9px; height: 9px; border-radius: 100%;\"></span> " + Number(p.seriesName / 1000000).toFixed(1) + " : " + Number(p.value).toFixed(3) + "%";
            }).join('<br />');
            return params[0].name + "<br />" + dataLines;
          }
        },
        dataZoom: [{
          fillerColor: 'rgba(228, 241, 254, 0.4)',
          dataBackground: {
            lineStyle: {
              width: 0
            },
            areaStyle: {
              color: 'rgba(107, 185, 240, 0.8)'
            }
          }
        }],
        grid: {
          left: 60,
          top: 30,
          right: 30,
          bottom: 60
        },
        series: option.series,
        categories: option.categories,
        resize: resize
      })
    );
  };

  return GatewayTOARatioUplinkTrend;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

GatewayTOARatioUplinkTrend.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    option: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__selectors__["b" /* toTOAUplinkTrendSeries */])(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(GatewayTOARatioUplinkTrend)));

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_sub_days__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_sub_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_sub_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_sub_hours__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_sub_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns_sub_hours__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_add_minutes__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_add_minutes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_add_minutes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_add_hours__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_add_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_add_hours__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_add_days__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_add_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_hour__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_hour___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_hour__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_hour__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_hour___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_hour__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_end_of_day__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_end_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_date_fns_end_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_is_after__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_is_after___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_date_fns_is_after__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_is_before__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_is_before___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_date_fns_is_before__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_min__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_date_fns_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_loracoms_Refresher__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_loracoms_InlineSelect__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_loracoms_CollapseToggle__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_loracoms_DatePicker__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_loraactions_gateway__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__GatewayTOAUplinkTrend__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__GatewayTOARatioUplinkTrend__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__GatewayTOAUplinkPie__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__styles_scss__ = __webpack_require__(2271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);
































var kUnitDuration = {
  YYYYMMDDHHmm: 600000,
  YYYYMMDDHH: 3600000,
  YYYYMMDD: 86400000
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  gatewayId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  getGatewayTOAStats: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  toaStats: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var GatewayTOAStat = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(GatewayTOAStat, _React$Component);

  GatewayTOAStat.handleDisableDate = function handleDisableDate(d, from) {
    return __WEBPACK_IMPORTED_MODULE_14_date_fns_is_after___default()(d, __WEBPACK_IMPORTED_MODULE_16_date_fns_min___default()(__WEBPACK_IMPORTED_MODULE_8_date_fns_add_days___default()(from, 7), new Date())) || __WEBPACK_IMPORTED_MODULE_15_date_fns_is_before___default()(d, from);
  };

  GatewayTOAStat.addOne = function addOne(t, by) {
    switch (by) {
      case 'YYYYMMDDHHmm':
        return __WEBPACK_IMPORTED_MODULE_6_date_fns_add_minutes___default()(t, 1);
      case 'YYYYMMDDHH':
        return __WEBPACK_IMPORTED_MODULE_7_date_fns_add_hours___default()(t, 1);
      case 'YYYYMMDD':
        return __WEBPACK_IMPORTED_MODULE_8_date_fns_add_days___default()(t, 1);
      default:
        return t;
    }
  };

  function GatewayTOAStat(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GatewayTOAStat);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      toaStats: props.toaStats,
      by: 'YYYYMMDDHHmm',
      dataView: 'ratio'
    };
    _this.handleChangeFrom = _this.handleChangeFrom.bind(_this);
    _this.handleChangeTo = _this.handleChangeTo.bind(_this);
    _this.handleReload = _this.handleReload.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_27_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaydetail.statview');
    return _this;
  }

  GatewayTOAStat.prototype.componentWillMount = function componentWillMount() {
    this.loadTOA();
  };

  GatewayTOAStat.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var toaStats = nextProps.toaStats;

    if (toaStats !== this.props.toaStats) {
      this.setState({ toaStats: toaStats });
    }
  };

  GatewayTOAStat.prototype.defaultFrom = function defaultFrom() {
    var by = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.by;

    switch (by) {
      case 'YYYYMMDDHHmm':
        return __WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_hour___default()(__WEBPACK_IMPORTED_MODULE_5_date_fns_sub_hours___default()(new Date(), 6));
      case 'YYYYMMDDHH':
        return __WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_hour___default()(__WEBPACK_IMPORTED_MODULE_5_date_fns_sub_hours___default()(new Date(), 24));
      case 'YYYYMMDD':
        return __WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day___default()(__WEBPACK_IMPORTED_MODULE_4_date_fns_sub_days___default()(new Date(), 7));
      default:
        return __WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_hour___default()(__WEBPACK_IMPORTED_MODULE_5_date_fns_sub_hours___default()(new Date(), 24));
    }
  };

  GatewayTOAStat.prototype.defaultTo = function defaultTo() {
    var by = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.by;

    switch (by) {
      case 'YYYYMMDDHHmm':
      case 'YYYYMMDDHH':
        return __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_hour___default()(new Date());
      case 'YYYYMMDD':
        return __WEBPACK_IMPORTED_MODULE_12_date_fns_end_of_day___default()(new Date());
      default:
        return __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_hour___default()(new Date());
    }
  };

  GatewayTOAStat.prototype.loadTOA = function loadTOA() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var getGatewayTOAStats = this.props.getGatewayTOAStats;
    var gatewayId = this.props.gatewayId;
    var _args$by = args.by,
        by = _args$by === undefined ? this.state.by : _args$by,
        _args$from = args.from,
        from = _args$from === undefined ? this.state.from || this.defaultFrom(by) : _args$from;
    var _args$to = args.to,
        to = _args$to === undefined ? this.state.to || this.defaultTo(by) : _args$to;

    to = GatewayTOAStat.addOne(to, by);
    getGatewayTOAStats(gatewayId, {
      from: __WEBPACK_IMPORTED_MODULE_13_date_fns_format___default()(from, by),
      to: __WEBPACK_IMPORTED_MODULE_13_date_fns_format___default()(to, by)
    });
  };

  GatewayTOAStat.prototype.handleChangeFrom = function handleChangeFrom(from) {
    var to = __WEBPACK_IMPORTED_MODULE_12_date_fns_end_of_day___default()(from);
    var sod = __WEBPACK_IMPORTED_MODULE_9_date_fns_start_of_day___default()(from);
    this.setState({ from: sod, to: to });
    this.loadTOA({ from: sod, to: to });
  };

  GatewayTOAStat.prototype.handleChangeTo = function handleChangeTo(to) {
    var eod = __WEBPACK_IMPORTED_MODULE_12_date_fns_end_of_day___default()(to);
    this.setState({ to: eod });
    this.loadTOA({ to: eod });
  };

  GatewayTOAStat.prototype.handleChangeBy = function handleChangeBy(by) {
    this.setState({ by: by });
    this.loadTOA({ by: by });
  };

  GatewayTOAStat.prototype.handleChangeDataView = function handleChangeDataView(dataView) {
    this.setState({ dataView: dataView });
  };

  GatewayTOAStat.prototype.handleReload = function handleReload() {
    this.loadTOA();
  };

  GatewayTOAStat.prototype.renderTOAStats = function renderTOAStats() {
    var _this2 = this;

    var _state = this.state,
        status = _state.toaStats.status,
        by = _state.by,
        dataView = _state.dataView,
        _state$expanded = _state.expanded,
        expanded = _state$expanded === undefined ? true : _state$expanded,
        _state$resize = _state.resize,
        resize = _state$resize === undefined ? 0 : _state$resize;

    var header = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "span",
        null,
        this.intlMsg.msg('toastat.byfreq.uplink')
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "ul",
        { className: "icontools" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_loracoms_Refresher__["a" /* default */], {
            onReload: this.handleReload,
            reloading: status === 'pending'
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_loracoms_CollapseToggle__["a" /* default */], {
            expanded: expanded,
            onChange: function onChange(v) {
              _this2.setState({ expanded: v });
            }
          })
        )
      )
    );

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_20_react_bootstrap__["Panel"],
      {
        bsStyle: "aisz-white",
        header: header,
        collapsible: true,
        expanded: expanded,
        onEntered: function onEntered() {
          _this2.setState({ resize: Math.random() });
        }
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_20_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_20_react_bootstrap__["Col"],
          { md: 9, className: "collapse-right" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_24_loracoms_ShowIf__["a" /* default */],
            { "if": dataView === 'ratio' },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__GatewayTOARatioUplinkTrend__["a" /* default */], {
              unitDuration: kUnitDuration[by],
              resize: resize
            })
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_24_loracoms_ShowIf__["a" /* default */],
            { "if": dataView === 'ms' },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__GatewayTOAUplinkTrend__["a" /* default */], { resize: resize })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_20_react_bootstrap__["Col"],
          { md: 3, className: "collapse-left" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__GatewayTOAUplinkPie__["a" /* default */], { resize: resize })
        )
      )
    );
  };

  GatewayTOAStat.prototype.renderToolbar = function renderToolbar() {
    var _this3 = this;

    var _state2 = this.state,
        by = _state2.by,
        dataView = _state2.dataView,
        _state2$from = _state2.from,
        from = _state2$from === undefined ? this.defaultFrom(by) : _state2$from,
        _state2$to = _state2.to,
        to = _state2$to === undefined ? this.defaultTo(by) : _state2$to;

    var icon = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-filter" });
    var leftTools = [{
      input: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_loracoms_DatePicker__["a" /* default */], { date: from, onSelect: this.handleChangeFrom })
    }, {
      input: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_loracoms_DatePicker__["a" /* default */], {
        date: to,
        onSelect: this.handleChangeTo,
        disabled: function disabled(d) {
          return GatewayTOAStat.handleDisableDate(d, from);
        }
      })
    }, {
      input: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_loracoms_InlineSelect__["a" /* default */], {
        bsStyle: "aisz-primary",
        options: [{
          label: this.intlMsg.msg('toolbar.bytime.minutes'),
          value: 'YYYYMMDDHHmm',
          active: true
        }, {
          label: this.intlMsg.msg('toolbar.bytime.hours'),
          value: 'YYYYMMDDHH'
        }, {
          label: this.intlMsg.msg('toolbar.bytime.days'),
          value: 'YYYYMMDD'
        }],
        values: [by],
        onChange: function onChange(selected) {
          return _this3.handleChangeBy(selected[0]);
        }
      })
    }, {
      input: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_loracoms_InlineSelect__["a" /* default */], {
        bsStyle: "aisz-primary",
        options: [{
          label: this.intlMsg.msg('toolbar.dataview.ratio'),
          value: 'ratio',
          active: true
        }, {
          label: this.intlMsg.msg('toolbar.dataview.ms'),
          value: 'ms'
        }],
        values: [dataView],
        onChange: function onChange(selected) {
          return _this3.handleChangeDataView(selected[0]);
        }
      })
    }];

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_loracoms_Toolbar__["a" /* default */], { brandIcon: icon, leftTools: leftTools });
  };

  GatewayTOAStat.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_32__styles_scss___default.a.ota },
      this.renderToolbar(),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "ul",
        { className: __WEBPACK_IMPORTED_MODULE_32__styles_scss___default.a.panels },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          null,
          this.renderTOAStats()
        )
      )
    );
  };

  return GatewayTOAStat;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

GatewayTOAStat.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    toaStats: state.gateway.getGatewayTOAStats
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_18_react_router_redux__["routerActions"].push,
  getGatewayTOAStats: __WEBPACK_IMPORTED_MODULE_28_loraactions_gateway__["a" /* default */].getGatewayTOAStats
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_react_intl__["injectIntl"])(GatewayTOAStat)));

/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loracoms_PieChart__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss__ = __webpack_require__(2272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__selectors__ = __webpack_require__(177);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









function toSeries(pieData) {
  var sum = _.sum(_.values(pieData));
  return {
    label: {
      normal: {
        formatter: function formatter(params) {
          return Number(params.value / sum * 100).toFixed(2) + "%";
        },
        fontSize: 10
      },
      emphasis: {
        formatter: function formatter(params) {
          return "" + Number(params.name / 1000000).toFixed(1);
        }
      }
    },
    data: _.map(pieData, function (value, name) {
      return {
        name: name,
        value: value,
        label: {
          normal: {
            position: value / sum < 0.1 ? 'outside' : 'inside',
            fontSize: 10
          }
        },
        labelLine: {
          normal: {
            length: 5,
            length2: 5
          }
        }
      };
    })
  };
}

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  pieData: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  resize: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.number.isRequired
};

var GatewayTOAUplinkPie = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(GatewayTOAUplinkPie, _React$Component);

  function GatewayTOAUplinkPie(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GatewayTOAUplinkPie);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      pieData: props.pieData,
      resize: props.resize
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaydetail.statschart');
    return _this;
  }

  GatewayTOAUplinkPie.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var pieData = nextProps.pieData,
        resize = nextProps.resize;

    if (pieData !== this.props.pieData) {
      this.setState({ pieData: pieData });
    }
    if (resize !== this.props.resize) {
      this.setState({ resize: resize });
    }
  };

  GatewayTOAUplinkPie.prototype.render = function render() {
    var _state = this.state,
        pieData = _state.pieData,
        resize = _state.resize;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.chart },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_loracoms_PieChart__["a" /* default */], {
        series: [toSeries(pieData)],
        resize: resize
      })
    );
  };

  return GatewayTOAUplinkPie;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

GatewayTOAUplinkPie.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    pieData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__selectors__["a" /* toTOAUplinkPieData */])(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(GatewayTOAUplinkPie)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loracoms_BarChart__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss__ = __webpack_require__(2273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__selectors__ = __webpack_require__(177);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  option: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  resize: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.number.isRequired
};

var GatewayTOAUplinkTrend = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(GatewayTOAUplinkTrend, _React$Component);

  function GatewayTOAUplinkTrend(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GatewayTOAUplinkTrend);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      option: props.option,
      resize: props.resize
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaydetail.statschart');
    return _this;
  }

  GatewayTOAUplinkTrend.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var option = nextProps.option,
        resize = nextProps.resize;

    if (option !== this.props.option) {
      this.setState({ option: option });
    }
    if (resize !== this.props.resize) {
      this.setState({ resize: resize });
    }
  };

  GatewayTOAUplinkTrend.prototype.render = function render() {
    var _state = this.state,
        option = _state.option,
        resize = _state.resize;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.chart },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_loracoms_BarChart__["a" /* default */], {
        yAxis: {
          name: this.intlMsg.msg('axis.ms'),
          splitNumber: 5
        },
        xAxis: {
          axisTick: { interval: 0 },
          splitArea: {
            show: true,
            interval: 0,
            areaStyle: { color: ['rgba(218, 223, 225, 0.2)', '#FFFFFF'] }
          }
        },
        legend: {
          data: option.legend,
          formatter: function formatter(x) {
            return Number(x / 1000000).toFixed(1);
          }
        },
        tooltip: {
          formatter: function formatter(params) {
            var dataLines = params.map(function (p) {
              return "<span style=\"display: inline-block; background: " + p.color + "; width: 9px; height: 9px; border-radius: 100%;\"></span> " + Number(p.seriesName / 1000000).toFixed(1) + " : " + p.value;
            }).join('<br />');
            return params[0].name + "<br />" + dataLines;
          }
        },
        dataZoom: [{
          fillerColor: 'rgba(228, 241, 254, 0.4)',
          dataBackground: {
            lineStyle: {
              width: 0
            },
            areaStyle: {
              color: 'rgba(107, 185, 240, 0.8)'
            }
          }
        }],
        grid: {
          left: 60,
          top: 30,
          right: 30,
          bottom: 60
        },
        series: option.series,
        categories: option.categories,
        resize: resize
      })
    );
  };

  return GatewayTOAUplinkTrend;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

GatewayTOAUplinkTrend.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    option: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__selectors__["b" /* toTOAUplinkTrendSeries */])(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(GatewayTOAUplinkTrend)));

/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__GatewayLog__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_main_scss__ = __webpack_require__(2274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_main_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);












var defaultProps = {
  gateway: {}
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  gatewayId: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  gateway: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var LogView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(LogView, _React$Component);

  function LogView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LogView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      gateway: props.gateway
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaydetail.logview');
    return _this;
  }

  LogView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var gateway = nextProps.gateway;

    if (gateway !== this.props.gateway) {
      this.setState({ gateway: gateway });
    }
  };

  LogView.prototype.renderToolbar = function renderToolbar() {
    var _this2 = this;

    var gateway = this.state.gateway;

    var breadcrumb = [{
      content: this.intlMsg.msg('breadcrumbs.gateways', 'gatewaydetail'),
      onClick: function onClick() {
        return _this2.props.pushState('/gateway');
      }
    }, {
      content: gateway.name,
      active: true
    }];

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  LogView.prototype.render = function render() {
    var gatewayId = this.props.gatewayId;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Grid"],
        { fluid: true },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
            { md: 12 },
            this.renderToolbar()
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__GatewayLog__["a" /* default */], { gatewayId: gatewayId })
          )
        )
      )
    );
  };

  return LogView;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

LogView.defaultProps = defaultProps;
LogView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    gateway: state.gateway.gateway.data,
    gatewayId: ownProps.params.id
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(LogView)));

/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__GatewayPacketStat__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__GatewayTOAStat__ = __webpack_require__(1294);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  gatewayId: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  gateway: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired
};

var StatView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(StatView, _React$Component);

  function StatView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, StatView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      gateway: props.gateway,
      by: 'YYYYMMDDHH'
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaydetail.statview');
    return _this;
  }

  StatView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var gateway = nextProps.gateway;

    if (gateway !== this.props.gateway) {
      this.setState({ gateway: gateway });
    }
  };

  StatView.prototype.renderToolbar = function renderToolbar() {
    var _this2 = this;

    var gateway = this.state.gateway;

    var breadcrumb = [{
      content: this.intlMsg.msg('breadcrumbs.gateways', 'gatewaydetail'),
      onClick: function onClick() {
        return _this2.props.pushState('/gateway');
      }
    }, {
      content: gateway.name,
      active: true
    }];

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  StatView.prototype.render = function render() {
    var gatewayId = this.props.gatewayId;


    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Grid"],
      { fluid: true },
      this.renderToolbar(),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__GatewayPacketStat__["a" /* default */], { gatewayId: gatewayId }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__GatewayTOAStat__["a" /* default */], { gatewayId: gatewayId })
    );
  };

  return StatView;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

StatView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    gateway: state.gateway.gateway.data || {},
    gatewayId: ownProps.params.id
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(StatView)));

/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loraactions_gateway__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_SideBar__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_SidebarContainer__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_scss__ = __webpack_require__(2275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var defaultProps = {
  view: ''
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  gatewayId: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  getGateway: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  gateway: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  resetGetGateway: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.node.isRequired,
  view: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string
};

var GatewayDetail = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(GatewayDetail, _React$Component);

  function GatewayDetail(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GatewayDetail);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      gateway: props.gateway,
      view: props.view
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaydetail');
    return _this;
  }

  GatewayDetail.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        gatewayId = _props.gatewayId,
        getGateway = _props.getGateway;

    getGateway(gatewayId);
  };

  GatewayDetail.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var gateway = nextProps.gateway,
        view = nextProps.view;

    if (gateway !== this.props.gateway) {
      this.setState({ gateway: gateway });
    }
    if (view !== this.props.view) {
      this.setState({ view: view });
    }
  };

  GatewayDetail.prototype.componentWillUnmount = function componentWillUnmount() {
    var resetGetGateway = this.props.resetGetGateway;

    resetGetGateway();
  };

  GatewayDetail.prototype.renderSideBar = function renderSideBar() {
    var _props2 = this.props,
        pushState = _props2.pushState,
        gatewayId = _props2.gatewayId;
    var view = this.state.view;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_SideBar__["a" /* default */], {
      height: window.innerHeight,
      title: this.intlMsg.msg('sidebar.title'),
      menuItems: [{
        icon: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-blackboard" }),
        text: this.intlMsg.msg('menu.detail'),
        onClick: function onClick() {
          return pushState("/gateway/detail/" + gatewayId);
        },
        active: view === ''
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-pie-chart" }),
        text: this.intlMsg.msg('menu.stat'),
        onClick: function onClick() {
          return pushState("/gateway/detail/" + gatewayId + "/stat");
        },
        active: view === 'stat'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-transfer rotate270" }),
        text: this.intlMsg.msg('menu.datamsg'),
        onClick: function onClick() {
          return pushState("/gateway/detail/" + gatewayId + "/datamsg");
        },
        active: view === 'datamsg'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-wrench" }),
        text: this.intlMsg.msg('menu.conf'),
        onClick: function onClick() {
          return pushState("/gateway/detail/" + gatewayId + "/conf");
        },
        active: view === 'conf'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-notes-2" }),
        text: this.intlMsg.msg('menu.log'),
        onClick: function onClick() {
          return pushState("/gateway/detail/" + gatewayId + "/log");
        },
        active: view === 'log'
      }]
    });
  };

  GatewayDetail.prototype.renderError = function renderError() {
    var _this2 = this;

    var gateway = this.state.gateway;
    var code = gateway.error.code;


    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.error },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "h5",
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-alert" })
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "h5",
        null,
        this.intlMsg.errorMsg(code)
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Button"],
        {
          bsStyle: "link",
          onClick: function onClick() {
            return _this2.props.pushState('/gateway');
          }
        },
        this.intlMsg.msg('error.goback')
      )
    );
  };

  GatewayDetail.prototype.render = function render() {
    var gateway = this.state.gateway;
    var status = gateway.status;


    if (status === 'failure') {
      return this.renderError();
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a['wrapper-nopadding'] },
      this.renderSideBar(),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_loracoms_SidebarContainer__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.view },
          this.props.children
        )
      )
    );
  };

  return GatewayDetail;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

GatewayDetail.defaultProps = defaultProps;
GatewayDetail.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    gatewayId: ownProps.params.id,
    gateway: state.gateway.gateway,
    view: ownProps.location.pathname.split('/')[4] || ''
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push,
  getGateway: __WEBPACK_IMPORTED_MODULE_9_loraactions_gateway__["a" /* default */].gateway,
  resetGetGateway: __WEBPACK_IMPORTED_MODULE_9_loraactions_gateway__["a" /* default */].resetGetGateway
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_3_react_css_modules___default()(GatewayDetail, __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a, { allowMultiple: true }))));

/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, moment) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_TablePager__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_SearchFlag__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_SortBtn__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_Link__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_LoadingTable__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loraactions_gateway__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__MapOverlay__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss__ = __webpack_require__(2276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);


















var kLimit = 20;
var defaultProps = {
  search: null,
  showSearchFlag: false,
  count: 1
};

var propTypes = {
  search: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string,
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  showSearchFlag: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.bool,
  count: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.number,
  updateGateway: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  updateState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired
};

var GatewayList = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(GatewayList, _React$Component);

  GatewayList.getQ = function getQ(search) {
    if (search) {
      var s = search.replace(/[-:]/g, '');
      return "or,name:*" + search + "*,platform:*" + s + "*,id:*" + s + "*,city:*" + s + "*,area:*" + s + "*,version:*" + s + "*,band:*" + s + "*";
    }
    return null;
  };

  function GatewayList(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GatewayList);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      showSearchFlag: props.showSearchFlag,
      updateState: props.updateGateway,
      count: props.count,
      list: [],
      initialStatus: 'pending',
      mark: '',
      more: false,
      sort: '-lastOn'
    };
    _this.mark = '';
    _this.q = '';
    _this.handleNextPage = _this.handleNextPage.bind(_this);
    _this.handlePrevPage = _this.handlePrevPage.bind(_this);
    _this.handleShowMap = _this.handleShowMap.bind(_this);
    _this.handleSort = _this.handleSort.bind(_this);
    _this.loadGatewayList = _this.loadGatewayList.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_16_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gatewaydetail.detailview.gatewaylist');
    return _this;
  }

  GatewayList.prototype.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.loadGatewayList();
  };

  GatewayList.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var search = nextProps.search,
        showSearchFlag = nextProps.showSearchFlag,
        count = nextProps.count,
        updateState = nextProps.updateState;


    if (search !== this.props.search) {
      this.setState({ reset: Date.parse(new Date()) });
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.q = GatewayList.getQ(search);
      this.mark = '';
      this.searchTimeout = setTimeout(function () {
        _this2.loadGatewayList();
      }, 500);
    }
    if (showSearchFlag !== this.props.showSearchFlag) {
      this.setState({ showSearchFlag: showSearchFlag });
    }
    if (count !== this.props.count) {
      this.setState({ count: count });
    }
    if (updateState !== this.props.updateState) {
      this.setState({ updateState: updateState });
      if (updateState.status === 'success') {
        this.loadGatewayList();
      }
    }
  };

  GatewayList.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  GatewayList.prototype.getStatus = function getStatus(gw) {
    var disconnected = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "span",
      null,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-circle-o " + __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.disconnected }),
      ' ',
      this.intlMsg.msg('disconnected')
    );
    var connected = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "span",
      null,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-circle " + __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.connected }),
      ' ',
      this.intlMsg.msg('connected')
    );

    if (_.isNil(gw.lastOn)) {
      return disconnected;
    }
    if (_.isNil(gw.lastOff)) {
      return connected;
    }
    var onts = moment(gw.lastOn).valueOf();
    var offts = moment(gw.lastOff).valueOf();
    if (onts > offts) {
      return connected;
    }
    return disconnected;
  };

  GatewayList.prototype.loadGatewayList = function loadGatewayList() {
    var _this3 = this;

    var sort = this.state.sort;

    this.setState({ status: 'loading' });

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lorautils_api__["a" /* callAPI */])({
      endpoint: '/lora/gateways',
      query: {
        q: this.q,
        mark: this.mark,
        sort: sort,
        limit: kLimit
      }
    }).then(function (data) {
      var list = data.list.map(function (l) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, l, {
          status: _this3.getStatus(l)
        });
      });
      if (_this3.mounted) {
        _this3.setState({
          initialStatus: 'success',
          status: 'success',
          list: list,
          more: data.more,
          mark: data.mark
        });
      }
    }).catch(function () {
      _this3.setState({
        status: 'failure',
        initialStatus: 'failure'
      });
    });
  };

  GatewayList.prototype.handlePrevPage = function handlePrevPage(mark) {
    this.mark = mark;
    this.loadGatewayList();
  };

  GatewayList.prototype.handleNextPage = function handleNextPage(mark) {
    this.mark = mark;
    this.loadGatewayList();
  };

  GatewayList.prototype.handleShowMap = function handleShowMap(gateway) {
    this.setState({
      gateway: gateway,
      showMap: true
    });
  };

  GatewayList.prototype.handleSort = function handleSort(sort) {
    var _this4 = this;

    this.setState({ sort: sort, mark: '', reset: Math.random() }, function () {
      _this4.loadGatewayList({});
    });
  };

  GatewayList.prototype.handleSaveLocation = function handleSaveLocation(id, point) {
    var updateGateway = this.props.updateGateway;

    updateGateway(id, {
      lng: String(point.lng),
      lat: String(point.lat)
    });
  };

  GatewayList.prototype.render = function render() {
    var _this5 = this;

    var _state = this.state,
        list = _state.list,
        showSearchFlag = _state.showSearchFlag,
        _state$showMap = _state.showMap,
        showMap = _state$showMap === undefined ? false : _state$showMap,
        _state$gateway = _state.gateway,
        gateway = _state$gateway === undefined ? {} : _state$gateway,
        sort = _state.sort,
        initialStatus = _state.initialStatus;


    var thead = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "thead",
      null,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('name', 'gateway'),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_SearchFlag__["a" /* default */], { show: showSearchFlag }),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_SortBtn__["a" /* default */], {
            sortName: "name",
            handleSort: this.handleSort,
            highLight: sort.indexOf('name') > -1
          })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('mac', 'gateway'),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_SearchFlag__["a" /* default */], { show: showSearchFlag }),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_SortBtn__["a" /* default */], {
            sortName: "mac",
            handleSort: this.handleSort,
            highLight: sort.indexOf('mac') > -1
          })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "th",
          null,
          " ",
          this.intlMsg.msg('status', 'gateway'),
          " "
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('platform', 'gateway'),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_SearchFlag__["a" /* default */], { show: showSearchFlag }),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_SortBtn__["a" /* default */], {
            sortName: "platform",
            handleSort: this.handleSort,
            highLight: sort.indexOf('platform') > -1
          })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('area', 'gateway'),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_SearchFlag__["a" /* default */], { show: showSearchFlag })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('address', 'gateway'),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_SearchFlag__["a" /* default */], { show: showSearchFlag })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('version', 'gateway'),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_SearchFlag__["a" /* default */], { show: showSearchFlag }),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_SortBtn__["a" /* default */], {
            sortName: "version",
            handleSort: this.handleSort,
            highLight: sort.indexOf('version') > -1
          })
        )
      )
    );

    if (initialStatus === 'pending') {
      var _state$count = this.state.count,
          count = _state$count === undefined ? 1 : _state$count;

      var rows = Math.max(1, Math.min(count, 10));
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Panel"],
        { bsStyle: "aisz-white", header: this.intlMsg.msg('header') },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_15_loracoms_LoadingTable__["a" /* default */],
          {
            cols: 8,
            rows: rows,
            className: "aisz-table-light",
            striped: true,
            bordered: true,
            responsive: true
          },
          thead
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: this.intlMsg.msg('header') },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Table"],
        { className: "aisz-table-light", striped: true, hover: true, bordered: true, responsive: true },
        thead,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "tbody",
          null,
          list.map(function (r) {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "tr",
              { key: r.id },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_14_loracoms_Link__["a" /* default */],
                  { to: "/gateway/detail/" + r.id },
                  r.name
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_14_loracoms_Link__["a" /* default */],
                  { to: "/gateway/detail/" + r.id },
                  r.mac
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                null,
                r.status
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                null,
                r.platform
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                null,
                r.city
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                null,
                r.area
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                null,
                " ",
                r.version,
                " "
              )
            );
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_loracoms_ShowIf__["a" /* default */],
        { "if": list.length > 0 },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.pager + " " + __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.marginT },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_TablePager__["a" /* default */], {
            status: this.state.status,
            mark: this.state.mark,
            more: this.state.more,
            reset: this.state.reset,
            onPrev: function onPrev(m) {
              return _this5.handlePrevPage(m);
            },
            onNext: function onNext(m) {
              return _this5.handleNextPage(m);
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_loracoms_ShowIf__["a" /* default */],
        { "if": list.length === 0 },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.noGateway },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "h3",
            null,
            this.intlMsg.msg('nogateway')
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_loracoms_Link__["a" /* default */],
            { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.buy, onClick: function onClick() {
                return window.open('https://shop182693444.taobao.com/category-1275674413.htm');
              } },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-shopping-cart" }),
            ' ',
            this.intlMsg.msg('buygateway')
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__MapOverlay__["a" /* default */], {
        show: showMap,
        gateways: [gateway],
        onHide: function onHide() {
          return _this5.setState({ showMap: false });
        },
        onSave: function onSave(point) {
          return _this5.handleSaveLocation(gateway.id, point);
        }
      })
    );
  };

  return GatewayList;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

GatewayList.defaultProps = defaultProps;
GatewayList.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    count: state.usage.gateways,
    updateState: state.gateway.updateGateway
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push,
  updateGateway: __WEBPACK_IMPORTED_MODULE_17_loraactions_gateway__["a" /* default */].updateGateway
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(GatewayList)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11), __webpack_require__(14)))

/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_GatewayMap__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_scss__ = __webpack_require__(2278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);












var defaultProps = {
  search: ''
};

var propTypes = {
  search: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string,
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired
};

var Map = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Map, _React$Component);

  Map.getQ = function getQ(s) {
    if (s !== '') {
      return "or,id:*" + s + "*,name:*" + s + "*,platform:*" + s + "*,mac:*" + s + "*,city:*" + s + "*,area:*" + s + "*,version:*" + s + "*";
    }
    return null;
  };

  function Map(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Map);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = { gateways: [] };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gateway.map');
    return _this;
  }

  Map.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lorautils_api__["a" /* callAPI */])({
      endpoint: '/lora/gateways',
      query: { limit: 100 }
    }).then(function (data) {
      _this2.setState({ gateways: data.list });
    }).catch(function () {});
  };

  Map.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    var search = nextProps.search;

    if (search !== this.props.search) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lorautils_api__["a" /* callAPI */])({
          endpoint: '/lora/gateways',
          query: { limit: 100, q: Map.getQ(search) }
        }).then(function (data) {
          _this3.setState({ gateways: data.list });
        }).catch(function () {});
      }, 500);
    }
  };

  Map.prototype.render = function render() {
    var gateways = this.state.gateways;


    if (_.isEmpty(gateways)) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.noGateway },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "h3",
          null,
          this.intlMsg.msg('nogateway')
        )
      );
    }
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.map },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_GatewayMap__["a" /* default */], { gateways: gateways })
    );
  };

  return Map;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Map.defaultProps = defaultProps;
Map.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(function () {
  return {};
}, {
  pushState: __WEBPACK_IMPORTED_MODULE_5_react_router_redux__["routerActions"].push
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(Map)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNil__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_HideIf__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_SearchInput__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss__ = __webpack_require__(2280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_list_svg__ = __webpack_require__(2785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_list_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__images_list_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_map_svg__ = __webpack_require__(2787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_map_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__images_map_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_log_svg__ = __webpack_require__(2786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_log_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__images_log_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__coms_GatewayList__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__coms_Map__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__coms_GatewayLog__ = __webpack_require__(632);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);
























var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.any.isRequired,
  plan: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  basic: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  usage: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  gotoBilling: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  gotoGatewayAdd: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired
};

var Gateway = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Gateway, _React$Component);

  function Gateway(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Gateway);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      plan: props.plan,
      basic: props.basic,
      usage: props.usage,
      view: 'list'
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_15_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'gateway');
    _this.handleCreateGateway = _this.handleCreateGateway.bind(_this);
    return _this;
  }

  Gateway.prototype.componentDidMount = function componentDidMount() {
    this.mounted = true;
  };

  Gateway.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var plan = nextProps.plan,
        basic = nextProps.basic,
        usage = nextProps.usage;

    if (plan !== this.props.plan) {
      this.setState({ plan: plan });
    }
    if (basic !== this.props.basic) {
      this.setState({ basic: basic });
    }
    if (usage !== this.props.usage) {
      this.setState({ usage: usage });
    }
  };

  Gateway.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  Gateway.prototype.handleCreateGateway = function handleCreateGateway() {
    var gotoGatewayAdd = this.props.gotoGatewayAdd;
    var _state = this.state,
        usage = _state.usage,
        basicData = _state.basic.data;

    if (usage.gateways >= basicData.lrgatewaynum) {
      // out of quota
      this.setState({
        addError: 'ooq'
      });
      return;
    }

    gotoGatewayAdd();
  };

  Gateway.prototype.renderAddErrorModal = function renderAddErrorModal() {
    var _this2 = this;

    var gotoBilling = this.props.gotoBilling;
    var _state2 = this.state,
        addError = _state2.addError,
        planData = _state2.plan.data;


    if (addError === 'ooq') {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"],
        {
          bsClass: "aisz-modal-warning",
          show: !__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(this.state.addError),
          onHide: function onHide() {
            return _this2.setState({ addError: null });
          }
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Header,
          { closeButton: true },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            { className: "text-center" },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle", "aria-hidden": "true" }),
            ' ',
            this.intlMsg.msg('addgateway.adderr.modalheader')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12_loracoms_HideIf__["a" /* default */],
            { "if": "profile:cube" },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "span",
              null,
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
                { "if": planData.tier < 3 },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  "div",
                  { className: "text-center" },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    "p",
                    null,
                    this.intlMsg.msg('addgateway.adderr.outofquota.undercomm')
                  ),
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
                    {
                      bsStyle: "aisz-primary",
                      onClick: gotoBilling
                    },
                    this.intlMsg.msg('addgateway.adderr.upgrade'),
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-arrow-circle-o-right", "aria-hidden": "true" })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
                { "if": planData.tier === 3 },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  "div",
                  { className: "text-center" },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    "p",
                    null,
                    this.intlMsg.msg('addgateway.adderr.outofquota.comm')
                  ),
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    "a",
                    { href: "mailto:support@aisenz.com" },
                    "support@aisenz.com"
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
            { "if": "profile:cube" },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "div",
              { className: "text-center" },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "p",
                null,
                this.intlMsg.msg('addgateway.adderr.outofquota.cube')
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "a",
                { href: "mailto:support@aisenz.com" },
                "support@aisenz.com"
              )
            )
          )
        )
      );
    }

    return null;
  };

  Gateway.prototype.renderContent = function renderContent() {
    var _state3 = this.state,
        view = _state3.view,
        listSearch = _state3.listSearch,
        gwlist = _state3.gwlist,
        mapSearch = _state3.mapSearch,
        _state3$showSearchFla = _state3.showSearchFlag,
        showSearchFlag = _state3$showSearchFla === undefined ? false : _state3$showSearchFla;


    if (view === 'list') {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__coms_GatewayList__["a" /* default */], { search: listSearch, showSearchFlag: showSearchFlag });
    } else if (view === 'map') {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__coms_Map__["a" /* default */], { gwlist: gwlist, search: mapSearch });
    } else if (view === 'log') {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__coms_GatewayLog__["a" /* default */], null);
    }
    return null;
  };

  Gateway.prototype.renderToolbar = function renderToolbar() {
    var _this3 = this;

    var _state4 = this.state,
        view = _state4.view,
        _state4$listSearch = _state4.listSearch,
        listSearch = _state4$listSearch === undefined ? '' : _state4$listSearch,
        _state4$mapSearch = _state4.mapSearch,
        mapSearch = _state4$mapSearch === undefined ? '' : _state4$mapSearch;


    if (view === 'list') {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Navbar"].Form,
        { pullRight: true },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_SearchInput__["a" /* default */], {
          autoFocus: true,
          placeholder: this.intlMsg.msg('list.search.placeholder'),
          value: listSearch,
          onChange: function onChange(e) {
            return _this3.setState({ listSearch: e.target.value.trim() });
          },
          onFocus: function onFocus() {
            return _this3.setState({ showSearchFlag: true });
          },
          onBlur: function onBlur() {
            return _this3.setState({ showSearchFlag: false });
          }
        })
      );
    } else if (view === 'map') {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Navbar"].Form,
        { pullRight: true },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_SearchInput__["a" /* default */], {
          value: mapSearch,
          placeholder: this.intlMsg.msg('map.search.placeholder'),
          onChange: function onChange(e) {
            return _this3.setState({ mapSearch: e.target.value.trim() });
          }
        })
      );
    }
    return null;
  };

  Gateway.prototype.render = function render() {
    var _this4 = this;

    var view = this.state.view;

    var tpList = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Tooltip"],
      { id: "tplist" },
      " ",
      this.intlMsg.msg('tooltip.list'),
      " "
    );
    // const tpMap = <Tooltip id="tpmap"> {this.intlMsg.msg('tooltip.map')} </Tooltip>;
    var tpLog = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Tooltip"],
      { id: "tplog" },
      " ",
      this.intlMsg.msg('tooltip.log'),
      " "
    );

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      { styleName: "wrapper", style: { minHeight: window.innerHeight - 50 } },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { styleName: "toolbar" },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Navbar"],
          { collapseOnSelect: true, bsStyle: "aisz-white" },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Navbar"].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Navbar"].Brand,
              null,
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "halflings halflings-menu-hamburger " + __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.brandIcon })
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Navbar"].Form,
              null,
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
                { bsStyle: "aisz-success", onClick: this.handleCreateGateway },
                this.intlMsg.msg('gateway'),
                ' ',
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "glyphicon glyphicon-plus" })
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "div",
                { styleName: "view-opts" },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["OverlayTrigger"],
                  { overlay: tpList, placement: "top" },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_react_router__["f" /* Link */],
                    {
                      styleName: "view-opt " + (view === 'list' ? ' active' : ''),
                      onClick: function onClick() {
                        return _this4.setState({ view: 'list' });
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_17__images_list_svg___default.a, alt: "" })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["OverlayTrigger"],
                  { overlay: tpLog, placement: "top" },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_react_router__["f" /* Link */],
                    {
                      styleName: "view-opt " + (view === 'log' ? ' active' : ''),
                      onClick: function onClick() {
                        return _this4.setState({ view: 'log' });
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_19__images_log_svg___default.a, alt: "" })
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Navbar"].Toggle,
              null,
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-caret-down" })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Navbar"].Collapse,
            null,
            this.renderToolbar()
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { styleName: "content" },
        this.renderContent()
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        null,
        this.renderAddErrorModal()
      )
    );
  };

  return Gateway;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Gateway.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    plan: state.billing.plan,
    basic: state.org.basic,
    usage: state.usage
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    gotoGatewayAdd: function gotoGatewayAdd() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_router_redux__["push"])('/gateway/add'));
    },
    gotoBilling: function gotoBilling() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_router_redux__["push"])('/billing/plans'));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_4_react_css_modules___default()(Gateway, __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a, { allowMultiple: true }))));

/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_animate_css_animate_min_css__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_animate_css_animate_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_animate_css_animate_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_isNil__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_HideIf__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loraactions_auth__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loraactions_account__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss__ = __webpack_require__(2281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




















var propTypes = {
  login: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  logout: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  reactivate: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
  authed: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.bool.isRequired,
  gotoOverview: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  gotoRegister: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  gotoLostPassword: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  reactivated: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired
};

var Login = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Login, _React$Component);

  function Login(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Login);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      username: '',
      password: '',
      reactivated: props.reactivated
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_18_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'login');
    _this.handleReactivate = _this.handleReactivate.bind(_this);
    return _this;
  }

  Login.prototype.componentWillMount = function componentWillMount() {
    var logout = this.props.logout;

    logout();
  };

  Login.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var authed = nextProps.authed,
        auth = nextProps.auth,
        gotoOverview = nextProps.gotoOverview,
        reactivated = nextProps.reactivated;

    if (authed) {
      gotoOverview();
    }

    if (auth.error) {
      this.setState({
        error: auth.error
      });
      if (auth.error.code === 'ACCINACTIVE') {
        this.setState({ showReactivate: true });
      }
    }

    if (reactivated !== this.props.reactivated) {
      this.setState({ reactivated: reactivated });
    }
  };

  Login.prototype.check = function check() {
    var _state = this.state,
        username = _state.username,
        password = _state.password;

    if (username === '') {
      this.setState({
        error: 'FE_EMAILEMPTY'
      });
      return false;
    }
    if (password === '') {
      this.setState({
        error: 'FE_PASSWORDEMPTY'
      });
      return false;
    }
    return true;
  };

  Login.prototype.handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    this.setState({
      error: null,
      reactivated: {}
    });
    if (!this.check()) {
      return;
    }

    var login = this.props.login;
    var _state2 = this.state,
        username = _state2.username,
        password = _state2.password;

    login(username, password);
  };

  Login.prototype.handleReactivate = function handleReactivate() {
    var reactivate = this.props.reactivate;
    var username = this.state.username;

    reactivate(username);
  };

  Login.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        gotoRegister = _props.gotoRegister,
        gotoLostPassword = _props.gotoLostPassword;
    var _state3 = this.state,
        error = _state3.error,
        username = _state3.username,
        password = _state3.password,
        reactivated = _state3.reactivated,
        _state3$showReactivat = _state3.showReactivate,
        showReactivate = _state3$showReactivat === undefined ? false : _state3$showReactivat;


    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      { styleName: "wrapper", style: { minHeight: window.innerHeight } },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        {
          styleName: "login",
          className: "animated " + (error ? 'shake' : '')
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "h1",
          null,
          " ",
          this.intlMsg.msg('title'),
          " "
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Form"],
          { onSubmit: function onSubmit(e) {
              return _this2.handleSubmit(e);
            } },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["FormGroup"],
            { validationState: error ? 'error' : undefined },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["InputGroup"],
              { bsClass: "aisz-input-group aisz-input-group-o" },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["InputGroup"].Addon,
                null,
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-user" })
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["FormControl"], {
                autoFocus: true,
                bsClass: "aisz-form-control-o",
                type: "text",
                placeholder: this.intlMsg.msg('email.placeholder'),
                value: username,
                onChange: function onChange(e) {
                  return _this2.setState({
                    username: e.target.value,
                    inactive: false,
                    error: null
                  });
                }
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["FormGroup"],
            { validationState: error ? 'error' : undefined },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["InputGroup"],
              { bsClass: "aisz-input-group aisz-input-group-o" },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["InputGroup"].Addon,
                null,
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-unlock-alt" })
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["FormControl"], {
                bsClass: "aisz-form-control-o",
                type: "password",
                placeholder: this.intlMsg.msg('password.placeholder'),
                value: password,
                onChange: function onChange(e) {
                  return _this2.setState({ password: e.target.value });
                }
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Collapse"],
            { "in": !__WEBPACK_IMPORTED_MODULE_11_lodash_isNil___default()(error) },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["FormGroup"],
              null,
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "div",
                { className: "text-center", styleName: "login-error" },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "halflings halflings-warning-sign" }),
                ' ',
                this.intlMsg.errorMsg(error)
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_14_loracoms_ShowIf__["a" /* default */],
                { "if": showReactivate },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_13_loracoms_HideIf__["a" /* default */],
                  { "if": "profile:cube" },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    "div",
                    { className: "text-center" },
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_RichButton__["a" /* default */], {
                      status: reactivated.status || '',
                      states: [{
                        status: 'default',
                        label: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                          "span",
                          null,
                          this.intlMsg.msg('reactivate')
                        ),
                        style: 'link',
                        onClick: this.handleReactivate
                      }, {
                        status: 'success',
                        label: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                          "span",
                          null,
                          this.intlMsg.msg('reactivate.success')
                        ),
                        style: 'link-success'
                      }, {
                        status: 'failure',
                        label: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                          "span",
                          null,
                          this.intlMsg.msg('reactivate.failure')
                        ),
                        style: 'link-danger',
                        onClick: this.handleReactivate
                      }, {
                        status: 'pending',
                        style: 'link-default',
                        label: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                          "span",
                          null,
                          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" }),
                          ' ',
                          this.intlMsg.msg('reactivate.pending')
                        )
                      }]
                    })
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Button"],
              { bsStyle: "aisz-primary-o", bsSize: "large", type: "submit" },
              this.intlMsg.msg('button'),
              ' ',
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "halflings halflings-log-in" })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13_loracoms_HideIf__["a" /* default */],
          { "if": "profile:cube" },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            { styleName: "login-links" },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "div",
              { styleName: "links" },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_router__["f" /* Link */],
                { onClick: gotoRegister },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], { id: "login.signup" })
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_router__["f" /* Link */],
                { onClick: gotoLostPassword },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], { id: "login.forgetpwd" })
              )
            )
          )
        )
      )
    );
  };

  return Login;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Login.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    authed: state.auth.authed,
    auth: state.auth,
    reactivated: state.account.reactivate
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    logout: function logout() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_16_loraactions_auth__["a" /* default */].revoke());
    },
    login: function login(username, password) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_16_loraactions_auth__["a" /* default */].token(username, password));
    },
    reactivate: function reactivate(email) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_17_loraactions_account__["a" /* default */].reactivate(email));
    },
    gotoOverview: function gotoOverview() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__["push"])('/overview'));
    },
    gotoRegister: function gotoRegister() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__["push"])('/register?ref=lora'));
    },
    gotoLostPassword: function gotoLostPassword() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__["push"])('/lostpassword?ref=lora'));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_6_react_css_modules___default()(Login, __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a, { allowMultiple: true }))));

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNil__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loraactions_register__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loraactions_account__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss__ = __webpack_require__(2282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_check_svg__ = __webpack_require__(2788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__images_check_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__emaillinks_json__ = __webpack_require__(2391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__emaillinks_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__emaillinks_json__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);






















var kEmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  getCaptcha: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  captcha: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  forgetPassword: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  forgetSent: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired
};

var LostPassword = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(LostPassword, _React$Component);

  function LostPassword(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LostPassword);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      captcha: props.captcha,
      errors: new __WEBPACK_IMPORTED_MODULE_18_lorautils_errors_ErrorSet__["a" /* default */]().add('FE_EMPTY', 'email').add('FE_EMPTY', 'vcode'),
      submitted: false
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_17_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'lostpassword');
    _this.handleReloadCaptcha = _this.handleReloadCaptcha.bind(_this);
    _this.handleChangeEmail = _this.handleChangeEmail.bind(_this);
    _this.handleChangeVerifyCode = _this.handleChangeVerifyCode.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.gotoEmailLogin = _this.gotoEmailLogin.bind(_this);
    return _this;
  }

  LostPassword.prototype.componentWillMount = function componentWillMount() {
    var getCaptcha = this.props.getCaptcha;

    getCaptcha();
  };

  LostPassword.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var captcha = nextProps.captcha,
        forgetSent = nextProps.forgetSent;

    if (captcha !== this.props.captcha) {
      this.setState({ captcha: captcha });
    }
    if (forgetSent !== this.props.forgetSent) {
      this.setState({ submitStatus: forgetSent.status });
      var status = forgetSent.status;

      if (status === 'failure') {
        var errors = this.state.errors;

        this.setState({
          errors: errors.add(forgetSent.error.code, 'submit')
        });
      }

      var getCaptcha = nextProps.getCaptcha;

      getCaptcha();
    }
  };

  LostPassword.prototype.handleReloadCaptcha = function handleReloadCaptcha() {
    var getCaptcha = this.props.getCaptcha;

    getCaptcha();
  };

  LostPassword.prototype.checkEmail = function checkEmail(v) {
    var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.errors;

    if (__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(v) || v === '') {
      return errors.add('FE_EMPTY', 'email');
    } else if (!kEmailRegex.test(v)) {
      return errors.add('FE_INVALIDEMAIL', 'email');
    }
    return errors.remove('email');
  };

  LostPassword.prototype.handleChangeEmail = function handleChangeEmail(e) {
    var email = e.target.value.trim();
    this.setState({
      email: email,
      errors: this.checkEmail(email)
    });
  };

  LostPassword.prototype.checkVerifyCode = function checkVerifyCode(v) {
    var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.errors;

    if (__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(v) || v === '') {
      return errors.add('FE_EMPTY', 'vcode');
    }
    return errors.remove('vcode');
  };

  LostPassword.prototype.handleChangeVerifyCode = function handleChangeVerifyCode(e) {
    var verifyCode = e.target.value.trim();
    this.setState({
      verifyCode: verifyCode,
      errors: this.checkVerifyCode(verifyCode)
    });
  };

  LostPassword.prototype.handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });

    var captcha = this.state.captcha;

    if (captcha.status !== 'success') {
      return;
    }

    var errors = this.state.errors;

    errors = errors.remove('submit');
    this.setState({ errors: errors });
    if (!errors.isEmpty()) {
      return;
    }

    var forgetPassword = this.props.forgetPassword;
    var key = captcha.data.key;
    var _state = this.state,
        email = _state.email,
        verifyCode = _state.verifyCode;

    forgetPassword(email, key, verifyCode, 'lora');
  };

  LostPassword.prototype.gotoEmailLogin = function gotoEmailLogin() {
    var links = __WEBPACK_IMPORTED_MODULE_21__emaillinks_json___default.a.links;
    var domain = _.split(this.state.email, '@')[1];
    var matches = _.filter(links, function (lk) {
      return lk.domain === domain;
    });
    if (matches.length > 0) {
      window.open("http://" + matches[0].link);
    }
  };

  LostPassword.prototype.renderForm = function renderForm() {
    var _this2 = this;

    var _state2 = this.state,
        captcha = _state2.captcha,
        _state2$submitStatus = _state2.submitStatus,
        submitStatus = _state2$submitStatus === undefined ? '' : _state2$submitStatus,
        errors = _state2.errors,
        submitted = _state2.submitted;

    var captchaNode = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Nvl__["a" /* default */], null);
    if (captcha.status === 'success') {
      captchaNode = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
        { onClick: this.handleReloadCaptcha },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", { alt: "", src: captcha.data.src })
      );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "h1",
        null,
        this.intlMsg.msg('title')
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { styleName: "wrapper-form" },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
            { bsStyle: "aisz-white" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { styleName: "form-wrapper" },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Form"],
                { horizontal: true, onSubmit: this.handleSubmit },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
                  { validationState: submitted && errors.has('email') ? 'error' : undefined },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                    { md: 3, componentClass: __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"] },
                    this.intlMsg.msg('email')
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                    { md: 6 },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormControl"], {
                      bsClass: "aisz-form-control-f",
                      placeholder: this.intlMsg.msg('email.placeholder'),
                      onChange: this.handleChangeEmail
                    }),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_ControlTips__["a" /* default */], {
                      show: submitted && errors.has('email'),
                      message: this.intlMsg.errorMsg(errors.get('email')),
                      azStyle: "danger"
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
                  { validationState: submitted && errors.has('vcode') ? 'error' : undefined },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                    { md: 3, componentClass: __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"] },
                    this.intlMsg.msg('verifycode')
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                    { md: 3 },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormControl"], {
                      bsClass: "aisz-form-control-f",
                      onChange: this.handleChangeVerifyCode
                    }),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_ControlTips__["a" /* default */], {
                      show: submitted && errors.has('vcode'),
                      message: this.intlMsg.errorMsg(errors.get('vcode')),
                      azStyle: "danger"
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                    { md: 3 },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "div",
                      { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.captcha },
                      captchaNode
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                    { mdOffset: 3, md: 6 },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                      "div",
                      { styleName: "submit" },
                      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_RichButton__["a" /* default */], {
                        status: submitStatus,
                        states: [{
                          status: 'default',
                          label: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                            "span",
                            null,
                            this.intlMsg.msg('submit')
                          ),
                          type: 'submit'
                        }, {
                          status: 'pending',
                          label: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                            "span",
                            null,
                            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" }),
                            ' ',
                            this.intlMsg.msg('submit.pending')
                          ),
                          style: 'info'
                        }, {
                          status: 'success',
                          label: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                            "span",
                            null,
                            this.intlMsg.msg('submit.success')
                          ),
                          timer: function timer() {
                            return _this2.setState({ submitStatus: '' });
                          },
                          style: 'success'
                        }, {
                          status: 'failure',
                          label: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                            "span",
                            null,
                            this.intlMsg.msg('submit.failure')
                          ),
                          timer: function timer() {
                            return _this2.setState({ submitStatus: '' });
                          },
                          style: 'danger'
                        }]
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_FormBlock__["a" /* default */], {
                      azStyle: "danger",
                      show: errors.has('submit'),
                      message: this.intlMsg.errorMsg(errors.get('submit'))
                    })
                  )
                )
              )
            )
          )
        )
      )
    );
  };

  LostPassword.prototype.renderSuccess = function renderSuccess() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { styleName: "regres" },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { styleName: "regres-body" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "h1",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "span",
            { styleName: "regres-img" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", { alt: "", src: __WEBPACK_IMPORTED_MODULE_20__images_check_svg___default.a, className: "img-responsive" })
          ),
          this.intlMsg.msg('success.h1')
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "p",
          null,
          this.intlMsg.msg('success.p1'),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
            { onClick: this.gotoEmailLogin },
            this.state.email
          ),
          this.intlMsg.msg('success.p2')
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Button"],
          { bsStyle: "aisz-primary", onClick: this.gotoEmailLogin },
          this.intlMsg.msg('success.btn'),
          ' ',
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-external-link" })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { styleName: "regres-footer" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "h3",
          null,
          this.intlMsg.msg('success.footer.h3')
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "ul",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "li",
            null,
            this.intlMsg.msg('success.footer.li1')
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "li",
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
              { onClick: function onClick() {
                  return _this3.setState({ submitStatus: '', email: '', verifyCode: '' });
                } },
              this.intlMsg.msg('success.footer.li2.txt1')
            ),
            this.intlMsg.msg('success.footer.li2.txt2')
          )
        )
      )
    );
  };

  LostPassword.prototype.render = function render() {
    var submitStatus = this.state.submitStatus;

    var content = this.renderForm();
    if (submitStatus === 'success') {
      content = this.renderSuccess();
    }
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { styleName: "wrapper", style: { minHeight: window.innerHeight } },
      content
    );
  };

  return LostPassword;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

LostPassword.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    captcha: state.register.captcha,
    forgetSent: state.account.forgetPassword
  };
};

var mapDispatchToProps = {
  getCaptcha: __WEBPACK_IMPORTED_MODULE_15_loraactions_register__["a" /* default */].captcha,
  forgetPassword: __WEBPACK_IMPORTED_MODULE_16_loraactions_account__["a" /* default */].forgetPassword
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_5_react_css_modules___default()(LostPassword, __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_SelectPills__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_PageLoading__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_PageNoPerm__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_PageError__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loraactions_adr__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_scss__ = __webpack_require__(2283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);














var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  getAdr: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  adr: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  basic: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  applyAdr: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  unapplyAdr: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  apply: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  unapply: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var ADRView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ADRView, _React$Component);

  function ADRView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ADRView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      basic: props.basic,
      adr: props.adr,
      errors: new __WEBPACK_IMPORTED_MODULE_13_lorautils_errors_ErrorSet__["a" /* default */]()
    };
    _this.handleToggleAdr = _this.handleToggleAdr.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.adrview');
    return _this;
  }

  ADRView.prototype.componentWillMount = function componentWillMount() {
    var getAdr = this.props.getAdr;

    getAdr();
  };

  ADRView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var basic = nextProps.basic,
        adr = nextProps.adr,
        apply = nextProps.apply,
        unapply = nextProps.unapply,
        getAdr = nextProps.getAdr;

    if (basic !== this.props.basic) {
      this.setState({ basic: basic });
    }
    if (adr !== this.props.adr) {
      this.setState({ adr: adr });
    }

    var errors = this.state.errors;

    if (apply !== this.props.apply) {
      if (apply.status === 'success' || apply.status === 'failure') {
        getAdr();
      }
      if (apply.status === 'failure') {
        this.setState({
          errors: errors.add(apply.error.code, 'switch')
        });
      } else {
        this.setState({
          errors: errors.remove('switch')
        });
      }
    }
    if (unapply !== this.props.unapply) {
      if (unapply.status === 'success' || unapply.status === 'failure') {
        getAdr();
      }
      if (unapply.status === 'failure') {
        this.setState({
          errors: errors.add(unapply.error.code, 'switch')
        });
      } else {
        this.setState({
          errors: errors.remove('switch')
        });
      }
    }
  };

  ADRView.prototype.handleToggleAdr = function handleToggleAdr(selected) {
    var _props = this.props,
        unapplyAdr = _props.unapplyAdr,
        applyAdr = _props.applyAdr;

    var enabled = selected === 'on';
    if (enabled) {
      applyAdr();
    } else {
      unapplyAdr();
    }
  };

  ADRView.prototype.renderAdrSwitch = function renderAdrSwitch() {
    var _this2 = this;

    var adr = this.state.adr;

    if (adr.status === 'success') {
      var options = [{ name: this.intlMsg.msg('switch.on'), value: 'on', active: adr.data.enabled }, { name: this.intlMsg.msg('switch.off'), value: 'off', active: !adr.data.enabled }];
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_SelectPills__["a" /* default */], {
        options: options,
        onChange: function onChange(selected) {
          return _this2.handleToggleAdr(selected[0]);
        }
      });
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" });
  };

  ADRView.prototype.renderHelpDoc = function renderHelpDoc() {
    var intl = this.props.intl;

    if (intl.locale === 'zh') {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.helpDoc },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "p",
          null,
          "ADR(\u81EA\u9002\u5E94\u6570\u636E\u901F\u7387)\u662F\u4E00\u79CD\u901A\u8FC7\u52A8\u6001\u8C03\u6574\u7EC8\u7AEF\u901F\u7387\u548C\u529F\u7387\u6765\u4F18\u5316\u7F51\u7EDC\u5BB9\u91CF\u548C\u8BBE\u5907\u7535\u6C60\u5BFF\u547D\u7684\u65B9\u6CD5\u3002"
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "p",
          null,
          "\u4F8B\u5982\uFF0C\u9760\u8FD1\u7F51\u5173\u7684\u8282\u70B9\u4F1A\u4F7F\u7528\u4E00\u4E2A\u8F83\u9AD8\u7684\u6570\u636E\u901F\u7387\uFF08\u8F83\u77ED\u7684\u4F20\u8F93\u65F6\u95F4\uFF09\u548C\u4E00\u4E2A\u8F83\u4F4E\u7684\u8F93\u51FA\u529F\u7387\u3002\u53EA\u6709\u5728\u94FE\u8DEF\u9884\u7B97 \u8FB9\u7F18\u7684\u8282\u70B9\uFF0C\u624D\u4F7F\u7528\u6700\u4F4E\u7684\u6570\u636E\u4F20\u8F93\u901F\u7387\u548C\u6700\u9AD8\u7684\u4F20\u8F93\u529F\u7387\u3002"
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "p",
          null,
          "ADR\u53EF\u4EE5\u9002\u5E94\u7F51\u7EDC\u67B6\u6784\u7684\u53D8\u5316\uFF0C\u652F\u6301\u591A\u53D8\u7684\u8DEF\u5F84\u635F\u8017\u3002LoRa\u7F51\u7EDC\u67B6\u6784\u4E3A\u6BCF\u4E2A\u5B9E\u73B0\u4E86ADR\u7684\u7EC8\u7AEF\u8BBE\u5907\u7BA1\u7406\u6570\u636E\u901F\u7387 \u548CRF\u8F93\u51FA\uFF0C\u8FDB\u800C\u6700\u5927\u5316\u7EC8\u7AEF\u8BBE\u5907\u7684\u7535\u6C60\u5BFF\u547D\u548C\u603B\u4F53\u7F51\u7EDC\u5BB9\u91CF\u3002"
        )
      );
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.helpDoc },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "p",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "strong",
          null,
          "A"
        ),
        "daptive ",
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "strong",
          null,
          "D"
        ),
        "ata ",
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "strong",
          null,
          "R"
        ),
        "ate is a method where the actual data rate is adjusted to ensure reliable packet delivery, optimal network performance, and scale for capacity."
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "p",
        null,
        "For example, nodes close to the gateway will use a higher data rate (shorter time on air) and a lower output power. Only nodes that are at the very edge of the link budget will use the lowest data rate and highest output power."
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "p",
        null,
        "The ADR method can accommodate changes in the network infrastructure and support varying path loss.\xA0To maximize both battery life of end\u2010devices and overall network capacity, the LoRa network infrastructure manages the data rate and RF output for each end\u2010device individually by implementing ADR."
      )
    );
  };

  ADRView.prototype.renderContent = function renderContent() {
    var errors = this.state.errors;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Panel"],
            { bsStyle: "aisz-white" },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Row"],
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
                { md: 12 },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.switch },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "span",
                    { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.label },
                    "ADR"
                  ),
                  this.renderAdrSwitch(),
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "span",
                    { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.errorTips },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Collapse"],
                      { "in": errors.has('switch'), dimension: "width" },
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                        "div",
                        null,
                        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-alert" }),
                        ' ',
                        this.intlMsg.errorMsg(errors.get('switch'))
                      )
                    )
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Row"],
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
                { md: 6 },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.tips },
                  this.intlMsg.msg('tips.title'),
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "ul",
                    null,
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "li",
                      null,
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-hand-right" }),
                      ' ',
                      this.intlMsg.msg('tips1')
                    ),
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "li",
                      null,
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-hand-right" }),
                      ' ',
                      this.intlMsg.msg('tips2')
                    ),
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "li",
                      null,
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-hand-right" }),
                      ' ',
                      this.intlMsg.msg('tips3')
                    )
                  )
                ),
                this.renderHelpDoc()
              )
            )
          )
        )
      )
    );
  };

  ADRView.prototype.render = function render() {
    var basic = this.props.basic;

    if (basic.status === 'success') {
      if (basic.tier === 1) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_PageNoPerm__["a" /* default */], null);
      }
      return this.renderContent();
    }
    if (basic.status === 'request' || basic.status === 'pending') {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_PageLoading__["a" /* default */], null);
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_PageError__["a" /* default */], null);
  };

  return ADRView;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ADRView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    basic: state.org.basic,
    adr: state.adr.getAdr,
    apply: state.adr.applyAdr,
    unapply: state.adr.unapplyAdr
  };
};

var mapDispatchToProps = {
  getAdr: __WEBPACK_IMPORTED_MODULE_11_loraactions_adr__["a" /* default */].getAdr,
  applyAdr: __WEBPACK_IMPORTED_MODULE_11_loraactions_adr__["a" /* default */].applyAdr,
  unapplyAdr: __WEBPACK_IMPORTED_MODULE_11_loraactions_adr__["a" /* default */].unapplyAdr
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(ADRView)));

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_rangeslider_lib_index_css__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_rangeslider_lib_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_rangeslider_lib_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_rangeslider__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_rangeslider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_rangeslider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_scss__ = __webpack_require__(2284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);











var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired
};

var CapacityCalculationView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(CapacityCalculationView, _React$Component);

  function CapacityCalculationView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CapacityCalculationView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      packetRatePerHour: 1.0,
      spreadFactor: 7,
      payload: 40,
      channel: 8,
      calculation: false
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.CapacityCalculationView');
    return _this;
  }

  CapacityCalculationView.prototype.componentDidMount = function componentDidMount() {
    this.doCalculation();
  };

  CapacityCalculationView.prototype.handleOnChange = function handleOnChange(value, key) {
    if (!this.state.calculation) {
      var d = {};
      var v = value;
      if (key === 'packetRatePerHour') {
        v = parseFloat(value).toFixed(1);
      }
      d[key] = v;
      this.setState(d);
      this.doCalculation();
    }
  };

  CapacityCalculationView.prototype.doCalculation = function doCalculation() {
    var _this2 = this;

    var _state = this.state,
        packetRatePerHour = _state.packetRatePerHour,
        spreadFactor = _state.spreadFactor,
        payload = _state.payload,
        channel = _state.channel,
        calculation = _state.calculation;

    if (!calculation) {
      this.setState({
        calculation: true
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lorautils_api__["a" /* callAPI */])({
        endpoint: '/na/network_capacity_calculation',
        query: {
          packet_hourly_rate: packetRatePerHour,
          spead_factor: spreadFactor,
          payload: payload,
          channel_number: channel
        }
      }).then(function (data) {
        _this2.setState({
          distance: data,
          calculation: false
        });
      });
    }
  };

  CapacityCalculationView.prototype.renderToolbar = function renderToolbar() {
    var title = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      this.intlMsg.msg('title')
    );
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Toolbar__["a" /* default */], {
      brandTitle: title
    });
  };

  CapacityCalculationView.prototype.renderSilider = function renderSilider(value, name, min, max, unit, step) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
          { md: 12 },
          this.intlMsg.msg(name),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: "pull-right" },
            this.state[name],
            "\xA0",
            unit
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_rangeslider___default.a, {
        className: __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.slider,
        min: min,
        max: max,
        value: value,
        step: step,
        format: function format(p) {
          return p + unit;
        },
        onChange: function onChange(e) {
          return _this3.handleOnChange(e, name);
        },
        onChangeComplete: function onChangeComplete() {
          _this3.doCalculation();
        }
      })
    );
  };

  CapacityCalculationView.prototype.render = function render() {
    var _state2 = this.state,
        packetRatePerHour = _state2.packetRatePerHour,
        spreadFactor = _state2.spreadFactor,
        payload = _state2.payload,
        channel = _state2.channel,
        distance = _state2.distance;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
          { md: 12 },
          this.renderToolbar()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Panel"],
            { bsStyle: "aisz-white", header: '' },
            this.renderSilider(packetRatePerHour, 'packetRatePerHour', 0.1, 60, '', 0.1),
            this.renderSilider(spreadFactor, 'spreadFactor', 7, 12, '', 1),
            this.renderSilider(payload, 'payload', 0, 255, 'Bytes', 1),
            this.renderSilider(channel, 'channel', 1, 32, '', 1)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Panel"],
            { bsStyle: "aisz-white", header: '' },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Row"],
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
                { md: 12 },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "h3",
                  null,
                  this.intlMsg.msg('description.heading'),
                  "\xA0"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Row"],
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
                { md: 12 },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.distanceText },
                  distance,
                  "\xA0"
                )
              )
            )
          )
        )
      )
    );
  };

  return CapacityCalculationView;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

CapacityCalculationView.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(CapacityCalculationView));

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_LineChart__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_BarChart__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_LoadingTable__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_InlineSelect__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_SortBtn__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loraimages_chart_loading_gif__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loraimages_chart_loading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_loraimages_chart_loading_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss__ = __webpack_require__(2285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

















var kPending = 'pending';
var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.any.isRequired
};

var CapacityView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(CapacityView, _React$Component);

  function CapacityView(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CapacityView);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      loadData: [],
      freqData: [],
      tableData: [],
      redundancyData: [],
      networkStatus: kPending,
      freqStatus: kPending,
      listStatus: kPending,
      queryHours: 24,
      sortKey: 'deveui'
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.capacityview');
    return _this;
  }

  CapacityView.prototype.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.loadNetworkAnalysisList();
  };

  CapacityView.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  CapacityView.prototype.loadNetworkAnalysisList = function loadNetworkAnalysisList() {
    var _this2 = this;

    this.setState({
      networkStatus: kPending,
      listStatus: kPending,
      freqStatus: kPending
    });

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lorautils_api__["a" /* callAPI */])({
      endpoint: '/na/network_load_summary',
      query: {
        hours: this.state.queryHours
      }
    }).then(function (data) {
      if (_this2.mounted) {
        _this2.setState({
          networkStatus: 'success',
          loadData: data || []
        });
      }
    }).catch(function () {
      _this2.setState({
        networkStatus: 'failure'
      });
    });

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lorautils_api__["a" /* callAPI */])({
      endpoint: '/na/frequency_load_summary',
      query: {
        hours: this.state.queryHours
      }
    }).then(function (data) {
      if (_this2.mounted) {
        _this2.setState({
          freqStatus: 'success',
          freqData: data || []
        });
      }
    }).catch(function () {
      _this2.setState({
        freqStatus: 'failure'
      });
    });

    var a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lorautils_api__["a" /* callAPI */])({
      endpoint: '/na/device_packet_redundancy_summary',
      query: {
        hours: this.state.queryHours
      }
    });
    var b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lorautils_api__["a" /* callAPI */])({
      endpoint: '/na/device_interval_summary',
      query: {
        hours: this.state.queryHours
      }
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([a, b]).then(function (res) {
      _this2.setState({
        redundancyData: res[0] || [],
        tableData: res[1] || [],
        listStatus: 'success'
      });
    }).catch(function () {
      _this2.setState({ listStatus: 'failure' });
    });
  };

  CapacityView.prototype.handleSort = function handleSort(sort) {
    var tableData = this.state.tableData || [];
    var sortOrder = true;
    var sortKey = '';
    if (sort.startsWith('-')) {
      sortOrder = true;
      sortKey = sort.substr(1);
    } else {
      sortOrder = false;
      sortKey = sort;
    }
    if (sortKey.endsWith('percentile')) {
      tableData.sort(function (a, b) {
        if (sortOrder) {
          return a[sortKey][1] >= b[sortKey][1];
        }
        return a[sortKey][1] <= b[sortKey][1];
      });
    } else {
      tableData.sort(function (a, b) {
        if (sortOrder) {
          return a[sortKey] >= b[sortKey];
        }
        return a[sortKey] <= b[sortKey];
      });
    }

    this.setState({
      tableData: tableData,
      sortKey: sortKey
    });
  };

  CapacityView.prototype.render = function render() {
    var _this3 = this;

    var _state = this.state,
        _state$sortKey = _state.sortKey,
        sortKey = _state$sortKey === undefined ? null : _state$sortKey,
        networkStatus = _state.networkStatus,
        freqStatus = _state.freqStatus,
        listStatus = _state.listStatus,
        _state$tableData = _state.tableData,
        tableData = _state$tableData === undefined ? [] : _state$tableData,
        _state$loadData = _state.loadData,
        loadData = _state$loadData === undefined ? [] : _state$loadData,
        _state$freqData = _state.freqData,
        freqData = _state$freqData === undefined ? [] : _state$freqData,
        _state$redundancyData = _state.redundancyData,
        redundancyData = _state$redundancyData === undefined ? [] : _state$redundancyData;

    var redundancyDict = {};
    for (var i = 0; i < redundancyData.length; i += 1) {
      var row = redundancyData[i];
      redundancyDict[row.deveui] = row.rate;
    }
    var loadDataCategory = [];
    var GDataValues = [];
    var SDataValues = [];
    var LDataValues = [];
    var tableDataWithRedudancy = [];
    for (var _i = 0; _i < loadData.length; _i += 1) {
      loadDataCategory.push(__WEBPACK_IMPORTED_MODULE_6_moment___default()(loadData[_i].hours).format('MM/DD HH:00'));
      SDataValues.push(loadData[_i].S.toFixed(3));
      LDataValues.push((loadData[_i].L.toFixed(3) * 100).toFixed(3));
      GDataValues.push(loadData[_i].G.toFixed(3));
    }
    var freqDataCategory = [];
    var freqDataValues = [];
    for (var _i2 = 0; _i2 < freqData.length; _i2 += 1) {
      freqDataCategory.push(freqData[_i2].frequency);
      freqDataValues.push(freqData[_i2].load.toFixed(3));
    }
    for (var _i3 = 0; _i3 < tableData.length; _i3 += 1) {
      var _row = tableData[_i3];
      _row.rate = (redundancyDict[_row.eui] * 100).toFixed(1);
      tableDataWithRedudancy.push(_row);
    }
    var thead = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "thead",
      null,
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.name'),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_SortBtn__["a" /* default */], {
            sortName: "name",
            highLight: sortKey === 'name',
            handleSort: function handleSort(s) {
              return _this3.handleSort(s);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.deveui'),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_SortBtn__["a" /* default */], {
            sortName: "eui",
            highLight: sortKey === 'eui',
            handleSort: function handleSort(s) {
              return _this3.handleSort(s);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.interval_median'),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_SortBtn__["a" /* default */], {
            sortName: "interval_percentile",
            highLight: sortKey === 'interval_percentile',
            handleSort: function handleSort(s) {
              return _this3.handleSort(s);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.interval_percentile')
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.toa_median'),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_SortBtn__["a" /* default */], {
            sortName: "toa_percentile",
            highLight: sortKey === 'toa_percentile',
            handleSort: function handleSort(s) {
              return _this3.handleSort(s);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.toa_percentile')
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.total_toa'),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_SortBtn__["a" /* default */], {
            sortName: "total_toa",
            highLight: sortKey === 'total_toa',
            handleSort: function handleSort(s) {
              return _this3.handleSort(s);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.rate'),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_SortBtn__["a" /* default */], {
            sortName: "rate",
            highLight: sortKey === 'rate',
            handleSort: function handleSort(s) {
              return _this3.handleSort(s);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.total'),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_SortBtn__["a" /* default */], {
            sortName: "total",
            highLight: sortKey === 'total',
            handleSort: function handleSort(s) {
              return _this3.handleSort(s);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.last_ts'),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_SortBtn__["a" /* default */], {
            sortName: "last_ts",
            highLight: sortKey === 'last_ts',
            handleSort: function handleSort(s) {
              return _this3.handleSort(s);
            }
          })
        )
      )
    );

    var hoursStr = this.intlMsg.msg('hours');
    var rightTools = [{
      type: 'buttons',
      buttons: [__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_InlineSelect__["a" /* default */], {
        options: [{
          label: "1 " + hoursStr,
          value: 1
        }, {
          label: "6 " + hoursStr,
          value: 6
        }, {
          label: "12 " + hoursStr,
          value: 12
        }, {
          label: "24 " + hoursStr,
          value: 24
        }, {
          label: "72 " + hoursStr,
          value: 72
        }],
        values: [this.state.queryHours],
        onChange: function onChange(selected) {
          _this3.setState({
            queryHours: selected[0]
          }, function () {
            _this3.loadNetworkAnalysisList();
          });
        }
      })]
    }];

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Toolbar__["a" /* default */], {
            brandTitle: this.intlMsg.msg('title'),
            rightTools: rightTools
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
            {
              className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.panel,
              bsStyle: "aisz-white",
              header: this.intlMsg.msg('loadBarChartHeader')
            },
            networkStatus === kPending && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.loading },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_17_loraimages_chart_loading_gif___default.a, alt: "" })
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_LineChart__["a" /* default */], {
              series: [{
                name: this.intlMsg.msg('LoadG'),
                data: GDataValues,
                yAxisIndex: 0,
                type: 'line'
              }, {
                name: this.intlMsg.msg('LoadS'),
                data: SDataValues,
                yAxisIndex: 0,
                type: 'line'
              }, {
                name: this.intlMsg.msg('Loss'),
                data: LDataValues,
                type: 'bar',
                yAxisIndex: 1
              }],
              legend: {
                data: [this.intlMsg.msg('LoadG'), this.intlMsg.msg('LoadS'), this.intlMsg.msg('Loss')]
              },
              yAxis: [{
                type: 'value',
                name: this.intlMsg.msg('Load'),
                scale: true
              }, {
                type: 'value',
                name: this.intlMsg.msg('Loss'),
                scale: true
              }],
              categories: loadDataCategory
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
            {
              className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.panel,
              bsStyle: "aisz-white",
              header: this.intlMsg.msg('freqBarChartHeader')
            },
            freqStatus === kPending && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.loading },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_17_loraimages_chart_loading_gif___default.a, alt: "" })
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_BarChart__["a" /* default */], {
              series: [{
                data: freqDataValues,
                name: this.intlMsg.msg('Load'),
                yAxisIndex: 0,
                type: 'bar'
              }],
              yAxis: [{
                type: 'value',
                name: this.intlMsg.msg('Load'),
                scale: true
              }],
              categories: freqDataCategory
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
            {
              bsStyle: "aisz-white",
              header: this.intlMsg.msg('tableHeader'),
              className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.overflowPanel
            },
            listStatus === 'success' && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Table"],
              { className: "aisz-table-light", striped: true, hover: true, bordered: true, responsive: true },
              thead,
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "tbody",
                null,
                tableDataWithRedudancy.map(function (r, idx) {
                  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    "tr",
                    { key: String(idx) },
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "td",
                      null,
                      r.name
                    ),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "td",
                      null,
                      r.eui
                    ),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "td",
                      null,
                      r.interval_percentile[1].toFixed(0)
                    ),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "td",
                      null,
                      r.interval_percentile[0].toFixed(0),
                      "\xA0-\xA0",
                      r.interval_percentile[2].toFixed(0)
                    ),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "td",
                      null,
                      r.toa_percentile[1].toFixed(0)
                    ),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "td",
                      null,
                      r.toa_percentile[0].toFixed(0),
                      "\xA0-\xA0",
                      r.toa_percentile[2].toFixed(0)
                    ),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "td",
                      null,
                      r.total_toa
                    ),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "td",
                      null,
                      r.rate
                    ),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "td",
                      null,
                      r.total
                    ),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_6_moment___default.a.unix(r.last_ts / 1000).format('YY-MM-DD HH:mm:ss')
                    )
                  );
                })
              )
            ),
            listStatus === kPending && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_14_loracoms_LoadingTable__["a" /* default */],
              { className: "aisz-table-light", cols: 10, rows: 1 },
              thead
            )
          )
        )
      )
    );
  };

  return CapacityView;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

CapacityView.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(CapacityView));

/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_Select__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_checkers_numbers__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_scss__ = __webpack_require__(2286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);












var kFreqRange = {
  EU863: {
    min: 863,
    max: 870
  },
  CN470PREQUEL: {
    min: 470,
    max: 510
  },
  EU868SEMTECH: {
    min: 863,
    max: 870
  },
  AS923: {
    min: 915,
    max: 928
  }
};

var kTypeOptions = [{
  label: 'LoRa',
  value: 'lora'
}, {
  label: 'FSK',
  value: 'fsk'
}];

var getTypeOpts = function getTypeOpts(dataRates) {
  if (_.isNil(dataRates) || _.isEmpty(dataRates)) {
    return kTypeOptions;
  }
  var types = _.toPairs(dataRates).filter(function (p) {
    return p[1].length > 0;
  }).map(function (p) {
    return p[0];
  });
  return kTypeOptions.filter(function (opt) {
    return types.includes(opt.value);
  });
};

var dataRateLabels = {
  fsk: function fsk(dr) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "span",
      null,
      dr.dr,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "span",
        { className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.infos },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.info },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-angle-left" }),
          "bit rate: ",
          dr.bitrate,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-angle-right" })
        )
      )
    );
  },
  lora: function lora(dr) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "span",
      null,
      dr.dr,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "span",
        { className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.infos },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.info },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-angle-left" }),
          "band width: ",
          dr.bandwidth,
          "k",
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-angle-right" })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.info },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-angle-left" }),
          "SF: ",
          dr.sf,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-angle-right" })
        )
      )
    );
  }
};

var propTypes = {
  dataRates: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  band: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  channels: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.array.isRequired,
  onAdd: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired
};

var AddChannelForm = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AddChannelForm, _React$Component);

  function AddChannelForm(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AddChannelForm);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      band: props.band,
      dataRates: props.dataRates,
      channels: props.channels,
      errors: __WEBPACK_IMPORTED_MODULE_10_lorautils_errors_ErrorSet__["a" /* default */].createEmpty().add('FE_EMPTY', 'freq').add('FE_EMPTY', 'mindr').add('FE_EMPTY', 'maxdr')
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.channelview.add.free');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleChangeFreq = _this.handleChangeFreq.bind(_this);
    _this.handleChangeMinDR = _this.handleChangeMinDR.bind(_this);
    _this.handleChangeMaxDR = _this.handleChangeMaxDR.bind(_this);
    return _this;
  }

  AddChannelForm.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var band = nextProps.band,
        dataRates = nextProps.dataRates,
        channels = nextProps.channels;

    if (band !== this.props.band) {
      this.setState({ band: band });
    }
    if (dataRates !== this.props.dataRates) {
      this.setState({ dataRates: dataRates });
    }
    if (channels !== this.props.channels) {
      this.setState({ channels: channels });
      var _state = this.state,
          errors = _state.errors,
          _state$freq = _state.freq,
          freq = _state$freq === undefined ? '' : _state$freq;

      if (freq !== '' && channels.findIndex(function (ch) {
        return ch.freq === freq * 1000000;
      }) < 0 && errors.getCode('freq') === 'FE_DUPFREQ') {
        this.setState({ errors: errors.remove('freq') });
      }
    }
  };

  AddChannelForm.prototype.handleChangeFreq = function handleChangeFreq(e) {
    var freq = e.target.value.trim();
    var _state2 = this.state,
        errors = _state2.errors,
        band = _state2.band,
        _state2$channels = _state2.channels,
        channels = _state2$channels === undefined ? [] : _state2$channels;


    this.setState({ freq: freq });

    if (freq === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'freq') });
    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lorautils_checkers_numbers__["a" /* isNumber */])(freq, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, kFreqRange[band], { points: { max: 4 } }))) {
      if (channels.findIndex(function (ch) {
        return ch.freq === freq * 1000000;
      }) >= 0) {
        this.setState({ errors: errors.add('FE_DUPFREQ', 'freq') });
      } else {
        this.setState({ errors: errors.remove('freq') });
      }
    } else {
      this.setState({ errors: errors.add('FE_INVALIDFREQ', 'freq') });
    }
  };

  AddChannelForm.prototype.handleChangeMinDR = function handleChangeMinDR(mindr) {
    var _state3 = this.state,
        maxdr = _state3.maxdr,
        errors = _state3.errors;

    this.setState({ mindr: mindr });

    if (!_.isNil(maxdr)) {
      if (maxdr < mindr) {
        this.setState({
          errors: errors.add('FE_MINGTMAX', 'mindr').add('FE_MINGTMAX', 'maxdr')
        });
      } else {
        this.setState({
          errors: errors.remove('mindr').remove('maxdr')
        });
      }
    } else {
      this.setState({
        errors: errors.remove('mindr')
      });
    }
  };

  AddChannelForm.prototype.handleChangeMaxDR = function handleChangeMaxDR(maxdr) {
    var _state4 = this.state,
        mindr = _state4.mindr,
        errors = _state4.errors;

    this.setState({ maxdr: maxdr });

    if (!_.isNil(mindr)) {
      if (maxdr < mindr) {
        this.setState({
          errors: errors.add('FE_MINGTMAX', 'mindr').add('FE_MINGTMAX', 'maxdr')
        });
      } else {
        this.setState({
          errors: errors.remove('mindr').remove('maxdr')
        });
      }
    } else {
      this.setState({
        errors: errors.remove('maxdr')
      });
    }
  };

  AddChannelForm.prototype.handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });

    var onAdd = this.props.onAdd;
    var _state5 = this.state,
        freq = _state5.freq,
        mindr = _state5.mindr,
        maxdr = _state5.maxdr,
        channels = _state5.channels;
    var errors = this.state.errors;


    if (channels.findIndex(function (ch) {
      return ch.freq === freq * 1000000;
    }) >= 0) {
      errors = errors.add('FE_DUPFREQ', 'freq');
      this.setState({ errors: errors });
    }

    if (!errors.isEmpty()) {
      return;
    }

    onAdd({
      freq: freq * 1000000,
      mindr: mindr,
      maxdr: maxdr
    });
  };

  AddChannelForm.prototype.render = function render() {
    var _this2 = this;

    var _state6 = this.state,
        _state6$freq = _state6.freq,
        freq = _state6$freq === undefined ? '' : _state6$freq,
        _state6$dataRates = _state6.dataRates,
        dataRates = _state6$dataRates === undefined ? {} : _state6$dataRates,
        _state6$type = _state6.type,
        type = _state6$type === undefined ? 'lora' : _state6$type,
        _state6$band = _state6.band,
        band = _state6$band === undefined ? '' : _state6$band,
        errors = _state6.errors,
        _state6$submitted = _state6.submitted,
        submitted = _state6$submitted === undefined ? false : _state6$submitted;
    var _state7 = this.state,
        minDr = _state7.minDr,
        maxDr = _state7.maxDr;

    var _ref = kFreqRange[band] || {},
        _ref$min = _ref.min,
        minRange = _ref$min === undefined ? 0 : _ref$min,
        _ref$max = _ref.max,
        maxRange = _ref$max === undefined ? 0 : _ref$max;

    var drs = dataRates[type] || [];

    if (_.isNil(minDr)) {
      minDr = drs[0];
    }
    if (_.isNil(maxDr)) {
      maxDr = drs[0];
    }

    var drOpts = drs.map(function (dr) {
      return {
        label: dr.dr,
        value: dr.dr,
        formatter: function formatter() {
          return dataRateLabels[type](dr);
        }
      };
    });

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Form"],
      {
        className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.form,
        horizontal: true,
        onSubmit: this.handleSubmit
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('freq') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { className: "aisz-control-label" },
            this.intlMsg.msg('freq')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 8 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
            bsClass: "aisz-form-control-f",
            placeholder: minRange + "MHz ~ " + maxRange + "MHz",
            value: freq,
            onChange: this.handleChangeFreq
          }),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('freq'),
            message: this.intlMsg.errorMsg(errors.get('freq')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { className: "aisz-control-label" },
            this.intlMsg.msg('type')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 8 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_Select__["a" /* default */], {
            value: type,
            options: getTypeOpts(dataRates),
            onChange: function onChange(v) {
              _this2.setState({ type: v });
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('mindr') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { className: "aisz-control-label" },
            "Min DR"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 8 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_Select__["a" /* default */], {
            options: drOpts,
            value: minDr,
            onChange: this.handleChangeMinDR
          }),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('mindr'),
            message: this.intlMsg.errorMsg(errors.get('mindr')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('maxdr') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["ControlLabel"],
            { className: "aisz-control-label" },
            "Max DR"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { md: 8 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_Select__["a" /* default */], {
            options: drOpts,
            value: maxDr,
            onChange: this.handleChangeMaxDR
          }),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('maxdr'),
            message: this.intlMsg.errorMsg(errors.get('maxdr')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
          { mdOffset: 2, md: 8 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.submit },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
              {
                bsStyle: "aisz-primary",
                type: "submit"
              },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "halflings halflings-plus" }),
              ' ',
              this.intlMsg.msg('addch')
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_FormBlock__["a" /* default */], {
            show: submitted && errors.has('submit'),
            message: this.intlMsg.errorMsg(errors.get('submit')),
            azStyle: "danger"
          })
        )
      )
    );
  };

  return AddChannelForm;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AddChannelForm.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(AddChannelForm));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_Select__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lorautils_api_selector__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loraactions_enums__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__FixedChannels__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ChannelsDraft__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__AddChannelForm__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__styles_scss__ = __webpack_require__(2287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);























var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.any.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  bandOpts: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.array.isRequired,
  getBands: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired
};

var AddChannelPlan = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AddChannelPlan, _React$Component);

  function AddChannelPlan(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AddChannelPlan);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.band = 'CN470';
    _this.state = {
      bandOpts: props.bandOpts,
      band: _this.band,
      errors: __WEBPACK_IMPORTED_MODULE_19_lorautils_errors_ErrorSet__["a" /* default */].createEmpty().add('FE_EMPTY', 'name'),
      channelType: 'lora',
      channels: [],
      selected: []
    };
    _this.queue = 0;
    _this.show = null;
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_15_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.channelview.add');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleEditDr = _this.handleEditDr.bind(_this);
    _this.handleAddChannel = _this.handleAddChannel.bind(_this);
    _this.handleChangeName = _this.handleChangeName.bind(_this);
    _this.handleChangeBand = _this.handleChangeBand.bind(_this);
    _this.handleDeleteChannel = _this.handleDeleteChannel.bind(_this);
    return _this;
  }

  AddChannelPlan.prototype.componentWillMount = function componentWillMount() {
    this.loadChannelDefines();
    this.loadDataRates();
    var getBands = this.props.getBands;

    getBands();
  };

  AddChannelPlan.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var bandOpts = nextProps.bandOpts;

    if (bandOpts !== this.props.bandOpts) {
      this.setState({ bandOpts: bandOpts });
    }
  };

  AddChannelPlan.prototype.loadChannelDefines = function loadChannelDefines() {
    var _this2 = this;

    if (!_.isNil(this.band)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lorautils_api__["a" /* callAPI */])({
        endpoint: "/lora/band/" + this.band + "/channeldefines"
      }).then(function (data) {
        _this2.setState({
          mode: data.mode,
          channels: data.channels,
          reserved: data.reserved || []
        });
      }).catch(function () {});
    }
  };

  AddChannelPlan.prototype.loadDataRates = function loadDataRates() {
    var _this3 = this;

    if (!_.isNil(this.band)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lorautils_api__["a" /* callAPI */])({
        endpoint: "/lora/band/" + this.band + "/datarates"
      }).then(function (data) {
        _this3.setState({ dataRates: data });
      }).catch(function () {});
    }
  };

  AddChannelPlan.prototype.handleChangeName = function handleChangeName(e) {
    var errors = this.state.errors;

    var name = e.target.value;
    if (name.trim() === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'name') });
    } else {
      this.setState({ errors: errors.remove('name') });
    }
    this.setState({ name: name });
  };

  AddChannelPlan.prototype.handleChangeBand = function handleChangeBand(band) {
    this.setState({ band: band });
    if (band !== this.band) {
      this.setState({ selected: [], mode: '' });
    }
    this.band = band;
    this.loadChannelDefines();
    this.loadDataRates();
  };

  AddChannelPlan.prototype.handleAddChannel = function handleAddChannel(channel) {
    var _state = this.state,
        _state$selected = _state.selected,
        selected = _state$selected === undefined ? [] : _state$selected,
        _state$reserved = _state.reserved,
        reserved = _state$reserved === undefined ? [] : _state$reserved;

    var newChannel = channel;
    if (!_.has(newChannel, 'id')) {
      newChannel = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, newChannel, {
        id: reserved.length + selected.length
      });
    }
    this.setState({
      selected: _.concat(selected, newChannel)
    });
  };

  AddChannelPlan.prototype.handleDeleteChannel = function handleDeleteChannel(channel) {
    var selected = this.state.selected;

    this.setState({ selected: selected.filter(function (ch) {
        return ch.id !== channel.id;
      }) });
  };

  AddChannelPlan.prototype.handleSubmit = function handleSubmit() {
    var _this4 = this;

    this.setState({ submitted: true });

    var errors = this.state.errors;

    errors = errors.remove('submit');

    if (!errors.isEmpty()) {
      return;
    }

    var pushState = this.props.pushState;
    var _state2 = this.state,
        name = _state2.name,
        band = _state2.band,
        _state2$selected = _state2.selected,
        selected = _state2$selected === undefined ? [] : _state2$selected,
        _state2$reserved = _state2.reserved,
        reserved = _state2$reserved === undefined ? [] : _state2$reserved;

    var channels = _.concat(reserved, selected);
    if (channels.length === 0) {
      this.setState({ errors: errors.add('FE_CHANNEL.EMPTY', 'submit') });
      return;
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lorautils_api__["a" /* callAPI */])({
      endpoint: '/lora/chplans',
      method: 'POST',
      body: {
        name: name,
        band: band,
        channels: channels
      }
    }).then(function () {
      pushState('/network/chplans');
    }).catch(function (error) {
      _this4.setState({ errors: errors.add(error.code, 'submit') });
    });
  };

  AddChannelPlan.prototype.handleEditDr = function handleEditDr(ch) {
    var _state3 = this.state,
        selected = _state3.selected,
        _state3$reserved = _state3.reserved,
        reserved = _state3$reserved === undefined ? [] : _state3$reserved;

    var selectedIndex = _.findIndex(selected, function (s) {
      return s.id === ch.id;
    });
    var reservedIndex = _.findIndex(reserved, function (r) {
      return r.id === ch.id;
    });
    if (selected.length && selectedIndex > -1) {
      selected[selectedIndex] = ch;
    } else if (reserved.length && reservedIndex > -1) {
      reserved[reservedIndex] = ch;
    }
    this.setState({ selected: selected, reserved: reserved });
  };

  AddChannelPlan.prototype.renderAddForm = function renderAddForm() {
    var _state4 = this.state,
        band = _state4.band,
        bandOpts = _state4.bandOpts,
        errors = _state4.errors,
        _state4$submitted = _state4.submitted,
        submitted = _state4$submitted === undefined ? false : _state4$submitted;


    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Form"],
      { horizontal: true, className: __WEBPACK_IMPORTED_MODULE_23__styles_scss___default.a.basicForm },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
        { validationState: submitted && errors.has('name') ? 'error' : undefined },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            this.intlMsg.msg('name')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 8 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormControl"], {
            autoFocus: true,
            bsClass: "aisz-form-control-f",
            placeholder: this.intlMsg.msg('name.placeholder'),
            onChange: this.handleChangeName
          }),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["HelpBlock"],
            { className: "aisz-help-block" },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-info-circle" }),
            "\xA0",
            this.intlMsg.msg('nametip')
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_ControlTips__["a" /* default */], {
            show: submitted && errors.has('name'),
            message: this.intlMsg.errorMsg(errors.get('name')),
            azStyle: "danger"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"],
            { bsClass: "aisz-control-label" },
            this.intlMsg.msg('band')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 8 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Select__["a" /* default */], {
            value: band,
            options: bandOpts,
            onChange: this.handleChangeBand
          })
        )
      )
    );
  };

  AddChannelPlan.prototype.renderAddChannel = function renderAddChannel() {
    var _state5 = this.state,
        _state5$mode = _state5.mode,
        mode = _state5$mode === undefined ? '' : _state5$mode,
        band = _state5.band,
        _state5$selected = _state5.selected,
        selected = _state5$selected === undefined ? [] : _state5$selected,
        _state5$channels = _state5.channels,
        channels = _state5$channels === undefined ? [] : _state5$channels,
        _state5$reserved = _state5.reserved,
        reserved = _state5$reserved === undefined ? [] : _state5$reserved,
        _state5$dataRates = _state5.dataRates,
        dataRates = _state5$dataRates === undefined ? {} : _state5$dataRates;

    if (mode === '') {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_23__styles_scss___default.a.loading },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin fa-5x" })
      );
    } else if (mode === 'fixed') {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__FixedChannels__["a" /* default */], {
        band: band,
        selected: selected,
        channels: channels,
        onSelect: this.handleAddChannel,
        onUnselect: this.handleDeleteChannel,
        maxSelected: 16
      });
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__AddChannelForm__["a" /* default */], {
      band: band,
      dataRates: dataRates,
      channels: _.concat(selected, reserved),
      onAdd: this.handleAddChannel
    });
  };

  AddChannelPlan.prototype.renderToolbar = function renderToolbar() {
    var pushState = this.props.pushState;

    var breadcrumb = [{
      content: this.intlMsg.msg('firstnav'),
      onClick: function onClick() {
        return pushState('/network/chplans');
      }
    }, {
      content: this.intlMsg.msg('secondnav'),
      active: true
    }];
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  AddChannelPlan.prototype.render = function render() {
    var _state6 = this.state,
        _state6$selected = _state6.selected,
        selected = _state6$selected === undefined ? [] : _state6$selected,
        _state6$reserved = _state6.reserved,
        reserved = _state6$reserved === undefined ? [] : _state6$reserved,
        _state6$dataRates = _state6.dataRates,
        dataRates = _state6$dataRates === undefined ? {} : _state6$dataRates,
        errors = _state6.errors,
        _state6$submitted = _state6.submitted,
        submitted = _state6$submitted === undefined ? false : _state6$submitted;


    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 12 },
          this.renderToolbar()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
            { bsStyle: "aisz-white", header: this.intlMsg.msg('panelheader') },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
              null,
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                { md: 7 },
                this.renderAddForm()
              )
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
              null,
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                { md: 12 },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_23__styles_scss___default.a.addChannel },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
                    null,
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                      { md: 7 },
                      this.renderAddChannel()
                    ),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                      { md: 5 },
                      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ChannelsDraft__["a" /* default */], {
                        reserved: reserved,
                        channels: selected,
                        dataRates: dataRates,
                        maxChannels: 16,
                        onDelete: this.handleDeleteChannel,
                        onEdit: this.handleEditDr
                      })
                    )
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
              null,
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                { md: 12 },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_23__styles_scss___default.a.submit },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Button"],
                    {
                      bsStyle: "aisz-success",
                      onClick: this.handleSubmit
                    },
                    this.intlMsg.msg('submit')
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_23__styles_scss___default.a.submitTips },
                  __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_FormBlock__["a" /* default */], {
                    show: submitted && errors.has('submit'),
                    message: this.intlMsg.errorMsg(errors.get('submit')),
                    azStyle: "danger"
                  })
                )
              )
            )
          )
        )
      )
    );
  };

  return AddChannelPlan;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

AddChannelPlan.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    bandOpts: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_lorautils_api_selector__["a" /* enumsToOptions */])('bands', state).map(function (opt) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, opt, { formatter: function formatter(x) {
          return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_RichLabel__["a" /* default */], { content: x });
        } });
    })
  };
};

var dispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push,
  getBands: __WEBPACK_IMPORTED_MODULE_18_loraactions_enums__["a" /* default */].bands
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps, dispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"])(AddChannelPlan)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__ = __webpack_require__(7);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var defaultProps = {
  reserved: []
};
var propTypes = {
  channelPlan: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  datarates: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  reserved: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.array
};

var ChannelList = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ChannelList, _React$Component);

  function ChannelList(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ChannelList);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      channelPlan: _this.props.channelPlan,
      reserved: _this.props.reserved,
      datarates: _this.props.datarates
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.banddetail.detailview');
    return _this;
  }

  ChannelList.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var channelPlan = nextProps.channelPlan,
        reserved = nextProps.reserved,
        datarates = nextProps.datarates;

    if (channelPlan !== this.props.channelPlan) {
      this.setState({ channelPlan: channelPlan });
    }
    if (reserved !== this.props.reserved) {
      this.setState({ reserved: reserved });
    }
    if (datarates !== this.props.datarates) {
      this.setState({ datarates: datarates });
    }
  };

  ChannelList.prototype.isReserved = function isReserved(channel) {
    var reserved = this.state.reserved;

    return _.some(reserved, function (rsrv) {
      return rsrv.id === channel.id;
    });
  };

  ChannelList.prototype.reservedEnums = function reservedEnums() {
    return [{
      content: 'true',
      translate: this.intlMsg.msg('tabletd.reservedchannel'),
      theme: 'yellow'
    }, {
      content: 'false',
      translate: this.intlMsg.msg('tabletd.freechannel'),
      theme: 'blue'
    }];
  };

  ChannelList.prototype.render = function render() {
    var _this2 = this;

    var channels = [];
    if (this.state.channelPlan.channels) {
      channels = this.state.channelPlan.channels;
    }

    var isDRInArr = function isDRInArr(dr) {
      var datarates = _this2.state.datarates;

      var hasDR = false;
      datarates.lora.forEach(function (item) {
        if (item.dr === dr) {
          hasDR = true;
        }
      });
      return hasDR;
    };

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: this.intlMsg.msg('panelhead.channellist') },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Table"],
        { className: "aisz-table-light", striped: true, hover: true, bordered: true, responsive: true },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('tableth.channelid')
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('tableth.define')
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('tableth.type')
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "th",
              null,
              "Frequence(MHZ)"
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "th",
              null,
              "Min DR"
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "th",
              null,
              "Max DR"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "tbody",
          null,
          _.sortBy(channels, 'id').map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "tr",
              { key: item.id },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                null,
                item.id
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_RichLabel__["a" /* default */], {
                  content: String(_this2.isReserved(item)),
                  enums: _this2.reservedEnums()
                })
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                null,
                isDRInArr(item.mindr) ? 'LoRa' : 'FSK'
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                null,
                item.freq / 1000000
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                null,
                item.mindr
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                null,
                item.maxdr
              )
            );
          })
        )
      )
    );
  };

  return ChannelList;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ChannelList.defaultProps = defaultProps;
ChannelList.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(ChannelList));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loraactions_chplan__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_PageLoading__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_api_status__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__coms_ChannelList__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__DeleteChannelPlanModal__ = __webpack_require__(1315);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);
















var propTypes = {
  channelPlan: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string.isRequired,
  getChannelPlan: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  getChannelDefines: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  getDataRates: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  chDefs: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  dataRates: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired
};

var ChannelPlanDetail = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ChannelPlanDetail, _React$Component);

  function ChannelPlanDetail(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ChannelPlanDetail);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      channelPlan: props.channelPlan,
      chDefs: props.chDefs,
      dataRates: props.dataRates
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_14_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.banddetail.detailview');
    return _this;
  }

  ChannelPlanDetail.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        id = _props.id,
        getChannelPlan = _props.getChannelPlan;

    getChannelPlan(id);
  };

  ChannelPlanDetail.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var channelPlan = nextProps.channelPlan,
        chDefs = nextProps.chDefs,
        dataRates = nextProps.dataRates;

    if (channelPlan !== this.props.channelPlan) {
      this.setState({ channelPlan: channelPlan });
      if (channelPlan.status === 'success') {
        var band = channelPlan.data.band;
        var _props2 = this.props,
            getChannelDefines = _props2.getChannelDefines,
            getDataRates = _props2.getDataRates;

        getChannelDefines(band);
        getDataRates(band);
      }
    }
    if (chDefs !== this.props.chDefs) {
      this.setState({ chDefs: chDefs });
    }
    if (dataRates !== this.props.dataRates) {
      this.setState({ dataRates: dataRates });
    }
  };

  ChannelPlanDetail.prototype.renderToolbar = function renderToolbar() {
    var _this2 = this;

    var pushState = this.props.pushState;
    var _state$channelPlan = this.state.channelPlan,
        status = _state$channelPlan.status,
        _state$channelPlan$da = _state$channelPlan.data;
    _state$channelPlan$da = _state$channelPlan$da === undefined ? {} : _state$channelPlan$da;
    var name = _state$channelPlan$da.name;


    var breadcrumb = [{
      onClick: function onClick() {
        return pushState('/network/chplans');
      },
      content: this.intlMsg.msg('toolbar.firstnav')
    }, {
      content: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Nvl__["a" /* default */], { val: name, status: status }),
      active: true
    }];
    var delBtn = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Button"],
      { bsStyle: "aisz-danger", onClick: function onClick() {
          return _this2.setState({ showDelete: true });
        } },
      this.intlMsg.msg('deletebtn')
    );
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Toolbar__["a" /* default */], {
      breadcrumb: breadcrumb,
      rightTools: [{ input: delBtn }]
    });
  };

  ChannelPlanDetail.prototype.render = function render() {
    var _this3 = this;

    var _state = this.state,
        channelPlan = _state.channelPlan,
        chDefs = _state.chDefs,
        dataRates = _state.dataRates,
        _state$showDelete = _state.showDelete,
        showDelete = _state$showDelete === undefined ? false : _state$showDelete;

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_api_status__["a" /* allSuccess */])(channelPlan, chDefs, dataRates)) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_PageLoading__["a" /* default */], null);
    }

    var _chDefs$data$reserved = chDefs.data.reserved,
        reserved = _chDefs$data$reserved === undefined ? [] : _chDefs$data$reserved;


    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 12 },
          this.renderToolbar()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__coms_ChannelList__["a" /* default */], {
            channelPlan: channelPlan.data,
            reserved: reserved,
            datarates: dataRates.data
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__DeleteChannelPlanModal__["a" /* default */], {
        show: showDelete,
        channelPlan: channelPlan.data,
        onHide: function onHide() {
          return _this3.setState({ showDelete: false });
        }
      })
    );
  };

  return ChannelPlanDetail;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ChannelPlanDetail.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.params.id,
    channelPlan: state.chplan.getChannelPlan,
    chDefs: state.chplan.getChannelDefines,
    dataRates: state.chplan.getDataRates
  };
};

var mapDispatchToProps = {
  getChannelPlan: __WEBPACK_IMPORTED_MODULE_10_loraactions_chplan__["a" /* default */].getChannelPlan,
  getChannelDefines: __WEBPACK_IMPORTED_MODULE_10_loraactions_chplan__["a" /* default */].getChannelDefines,
  getDataRates: __WEBPACK_IMPORTED_MODULE_10_loraactions_chplan__["a" /* default */].getDataRates,
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(ChannelPlanDetail)));

/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_Editable__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__FreqSpectrum__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss__ = __webpack_require__(2288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



















var propTypes = {
  pushState: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,
  plan: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object.isRequired
};

var ChannelPlanBrief = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ChannelPlanBrief, _React$Component);

  function ChannelPlanBrief(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ChannelPlanBrief);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      plan: props.plan,
      errors: new __WEBPACK_IMPORTED_MODULE_17_lorautils_errors_ErrorSet__["a" /* default */]()
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_16_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.channelview');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }

  ChannelPlanBrief.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var plan = nextProps.plan;

    if (plan !== this.props.plan) {
      this.setState({ plan: plan });
    }
  };

  ChannelPlanBrief.prototype.handleSubmit = function handleSubmit() {
    var _this2 = this;

    var _state = this.state,
        name = _state.editData.name,
        plan = _state.plan,
        errors = _state.errors;

    if (_.trim(name).length !== 0) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lorautils_api__["a" /* callAPI */])({
        method: 'PUT',
        endpoint: "/lora/chplans/" + plan.id,
        body: { name: name }
      }).then(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lorautils_api__["a" /* callAPI */])({
          endpoint: "/lora/chplans/" + plan.id
        }).then(function (resp) {
          _this2.setState({ plan: resp });
        }).catch(function () {});
      }).catch(function () {});
      this.setState({ edit: false });
    } else {
      this.setState({ errors: errors.add('FE_EMPTY', 'name') });
    }
  };

  ChannelPlanBrief.prototype.handleOnChange = function handleOnChange(d) {
    var errors = this.state.errors;

    this.setState({ editData: d, errors: errors.remove('name') });
  };

  ChannelPlanBrief.prototype.render = function render() {
    var _this3 = this;

    var pushState = this.props.pushState;
    var _state2 = this.state,
        plan = _state2.plan,
        _state2$edit = _state2.edit,
        edit = _state2$edit === undefined ? false : _state2$edit,
        _state2$editData = _state2.editData,
        editData = _state2$editData === undefined ? { name: plan.name } : _state2$editData,
        errors = _state2.errors;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.chplan },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
        { bsStyle: "aisz-white" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.band },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_RichLabel__["a" /* default */], { content: plan.band })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.content },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.name },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_Editable__["a" /* default */], {
                  edit: edit,
                  value: plan.name,
                  data: editData,
                  id: "name",
                  onChange: function onChange(d) {
                    return _this3.handleOnChange(d);
                  },
                  error: this.intlMsg.errorMsg(errors.get('name')),
                  errorPlacement: 'top',
                  formatter: function formatter(x) {
                    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
                      { onClick: function onClick() {
                          return pushState("/network/chplans/" + plan.id);
                        } },
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_Nvl__["a" /* default */], { val: x })
                    );
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "span",
                  { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.edit },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_13_loracoms_ShowIf__["a" /* default */],
                    { "if": !edit },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
                      {
                        onClick: function onClick() {
                          return _this3.setState({
                            edit: true,
                            editData: { name: plan.name }
                          });
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-pencil" })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_13_loracoms_ShowIf__["a" /* default */],
                    { "if": edit },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "ul",
                      { className: "list-inline" },
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                        "li",
                        null,
                        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
                          { onClick: this.handleSubmit },
                          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-ok text-success" })
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                        "li",
                        null,
                        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
                          {
                            onClick: function onClick() {
                              return _this3.setState({
                                edit: false,
                                editData: undefined,
                                errors: errors.remove('name')
                              });
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-remove text-warning" })
                        )
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.channels },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "span",
                  { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.label },
                  this.intlMsg.msg('channelnumber')
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "span",
                  { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.value },
                  plan.channels.length
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.createTime },
                __WEBPACK_IMPORTED_MODULE_10_date_fns_format___default()(plan.createdAt, 'YYYY-MM-DD HH:mm:ss')
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
            { md: 8 },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__FreqSpectrum__["a" /* default */], { plan: plan })
          )
        )
      )
    );
  };

  return ChannelPlanBrief;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ChannelPlanBrief.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(null, {
  pushState: __WEBPACK_IMPORTED_MODULE_5_react_router_redux__["routerActions"].push
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(ChannelPlanBrief)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loraactions_chplan__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__coms_ChannelPlanBrief__ = __webpack_require__(1312);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);











var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  channelPlans: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  getChannelPlans: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var ChannelPlans = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ChannelPlans, _React$Component);

  function ChannelPlans(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ChannelPlans);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      channelPlans: props.channelPlans
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.bandview');
    return _this;
  }

  ChannelPlans.prototype.componentWillMount = function componentWillMount() {
    var getChannelPlans = this.props.getChannelPlans;

    getChannelPlans();
  };

  ChannelPlans.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var channelPlans = nextProps.channelPlans;

    if (channelPlans !== this.props.channelPlans) {
      this.setState({ channelPlans: channelPlans });
    }
  };

  ChannelPlans.prototype.renderToolbar = function renderToolbar() {
    var pushState = this.props.pushState;

    var addBtn = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
      { bsStyle: "aisz-success", onClick: function onClick() {
          return pushState('/network/chplans/add');
        } },
      this.intlMsg.msg('addplan'),
      ' ',
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-plus" })
    );
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_Toolbar__["a" /* default */], {
      brandTitle: this.intlMsg.msg('title'),
      rightTools: [{ input: addBtn }]
    });
  };

  ChannelPlans.prototype.render = function render() {
    var channelPlans = this.state.channelPlans;


    var list = [];
    if (channelPlans.status === 'success') {
      list = channelPlans.data.list;
    }

    var plans = list.map(function (p) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__coms_ChannelPlanBrief__["a" /* default */], { key: p.id, plan: p });
    });

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
          { md: 12 },
          this.renderToolbar()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        null,
        plans
      )
    );
  };

  return ChannelPlans;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ChannelPlans.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    channelPlans: state.chplan.getChannelPlans
  };
};

var mapDispatchToProps = {
  getChannelPlans: __WEBPACK_IMPORTED_MODULE_9_loraactions_chplan__["a" /* default */].getChannelPlans,
  pushState: __WEBPACK_IMPORTED_MODULE_5_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(ChannelPlans)));

/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EditDRModal__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss__ = __webpack_require__(2289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);












var propTypes = {
  channels: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.array.isRequired,
  reserved: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.array.isRequired,
  dataRates: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  maxChannels: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.number.isRequired,
  onDelete: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  onEdit: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var ChannelsDraft = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ChannelsDraft, _React$Component);

  function ChannelsDraft(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ChannelsDraft);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      channels: props.channels,
      reserved: props.reserved,
      dataRates: props.dataRates,
      maxChannels: props.maxChannels
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.channelview.add.channels');
    _this.handleEditDR = _this.handleEditDR.bind(_this);
    return _this;
  }

  ChannelsDraft.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var channels = nextProps.channels,
        reserved = nextProps.reserved,
        dataRates = nextProps.dataRates;

    if (channels !== this.props.channels) {
      this.setState({ channels: channels });
    }
    if (reserved !== this.props.reserved) {
      this.setState({ reserved: reserved });
    }
    if (dataRates !== this.props.dataRates) {
      this.setState({ dataRates: dataRates });
    }
  };

  ChannelsDraft.prototype.typeOfChannel = function typeOfChannel(channel) {
    var _state$dataRates = this.state.dataRates;
    _state$dataRates = _state$dataRates === undefined ? {} : _state$dataRates;
    var _state$dataRates$lora = _state$dataRates.lora,
        lora = _state$dataRates$lora === undefined ? [] : _state$dataRates$lora;

    if (lora.findIndex(function (dr) {
      return dr.dr === channel.mindr;
    }) >= 0) {
      return 'LoRa';
    }
    return 'FSK';
  };

  ChannelsDraft.prototype.handleEditDR = function handleEditDR(ch) {
    this.props.onEdit(ch);
  };

  ChannelsDraft.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        maxChannels = _props.maxChannels,
        onDelete = _props.onDelete;
    var _state = this.state,
        channels = _state.channels,
        reserved = _state.reserved,
        dataRates = _state.dataRates,
        _state$showEditModal = _state.showEditModal,
        showEditModal = _state$showEditModal === undefined ? false : _state$showEditModal,
        _state$editChannel = _state.editChannel,
        editChannel = _state$editChannel === undefined ? {} : _state$editChannel;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.header },
        this.intlMsg.msg('header')
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Table"],
        {
          className: "aisz-table-light " + (channels.length === maxChannels ? __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.full : ''),
          bordered: true,
          responsive: true
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.idx },
              "#"
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('id')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('type')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('freq')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              "Min DR"
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              "Max DR"
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('delete')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('edit')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "tbody",
          null,
          reserved.map(function (ch, idx) {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "tr",
              { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.reserved, key: ch.id },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.idx },
                "#",
                idx + 1
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                ch.id
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_RichLabel__["a" /* default */], { content: _this2.typeOfChannel(ch) })
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                ch.freq / 1000000
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                ch.mindr
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                ch.maxdr
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                " ",
                _this2.intlMsg.msg('reserved'),
                " "
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                  {
                    onClick: function onClick() {
                      return _this2.setState({
                        showEditModal: true,
                        editChannel: ch
                      });
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicon glyphicon-pencil" })
                )
              )
            );
          }),
          channels.map(function (ch, idx) {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "tr",
              { key: ch.id },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.idx },
                "#",
                idx + 1
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                ch.id
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_RichLabel__["a" /* default */], { content: _this2.typeOfChannel(ch) })
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                ch.freq / 1000000
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                ch.mindr
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                ch.maxdr
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                  { onClick: function onClick() {
                      return onDelete(ch);
                    } },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-remove text-danger" })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                  {
                    onClick: function onClick() {
                      return _this2.setState({
                        showEditModal: true,
                        editChannel: ch
                      });
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicon glyphicon-pencil" })
                )
              )
            );
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
        { "if": channels.length === 0 },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.placeholder },
          this.intlMsg.msg('selecttips'),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-hand-o-left " + __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.pointer })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__EditDRModal__["a" /* default */], {
        show: showEditModal,
        onHide: function onHide() {
          return _this2.setState({ showEditModal: false });
        },
        channel: editChannel,
        dataRates: dataRates,
        onEdit: this.handleEditDR
      })
    );
  };

  return ChannelsDraft;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ChannelsDraft.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(ChannelsDraft));

/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isNil__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loraactions_chplan__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_scss__ = __webpack_require__(2290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);











var defaultProps = {
  show: false
};
var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  show: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.bool,
  onHide: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  channelPlan: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  deleteChannelPlan: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  deleted: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var DeleteChannelPlanModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeleteChannelPlanModal, _React$Component);

  function DeleteChannelPlanModal(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeleteChannelPlanModal);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      show: props.show,
      channelPlan: props.channelPlan
    };
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.banddetail.deletemodal');
    return _this;
  }

  DeleteChannelPlanModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var show = nextProps.show,
        deleted = nextProps.deleted;

    if (show !== this.props.show) {
      this.setState({ show: show });
    }
    if (deleted !== this.props.deleted) {
      if (deleted.status === 'success') {
        var pushState = this.props.pushState;

        pushState('/network/chplans');
      } else if (deleted.status === 'failure') {
        this.setState({ error: deleted.error.code });
      }
    }
  };

  DeleteChannelPlanModal.prototype.handleSubmit = function handleSubmit() {
    var deleteChannelPlan = this.props.deleteChannelPlan;
    var id = this.state.channelPlan.id;

    deleteChannelPlan(id);
  };

  DeleteChannelPlanModal.prototype.render = function render() {
    var _props = this.props,
        onHide = _props.onHide,
        channelPlan = _props.channelPlan;
    var _state = this.state,
        show = _state.show,
        error = _state.error;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-danger",
        show: show,
        onHide: onHide
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle", "aria-hidden": "true" }),
          ' ',
          this.intlMsg.msg('title')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "p",
            null,
            this.intlMsg.msg('title'),
            ' ',
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "strong",
              null,
              channelPlan.name,
              "(",
              channelPlan.id,
              ")"
            ),
            " ?"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Button"],
            {
              bsStyle: "aisz-warning",
              onClick: onHide
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-repeat", "aria-hidden": "true" }),
            ' ',
            this.intlMsg.msg('cancel')
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Button"],
            {
              bsStyle: "aisz-danger",
              onClick: this.handleSubmit
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-trash-o", "aria-hidden": "true" }),
            ' ',
            this.intlMsg.msg('confirm')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Collapse"],
          { "in": !__WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default()(error) },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.errorblock },
              this.intlMsg.errorMsg(error)
            )
          )
        )
      )
    );
  };

  return DeleteChannelPlanModal;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DeleteChannelPlanModal.defaultProps = defaultProps;
DeleteChannelPlanModal.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    deleted: state.chplan.deleteChannelPlan
  };
};
var mapDispatchToProps = {
  deleteChannelPlan: __WEBPACK_IMPORTED_MODULE_10_loraactions_chplan__["a" /* default */].deleteChannelPlan,
  pushState: __WEBPACK_IMPORTED_MODULE_7_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(DeleteChannelPlanModal)));

/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_Select__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss__ = __webpack_require__(2291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);











var dataRateLabels = {
  fsk: function fsk(dr) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "span",
      null,
      dr.dr,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "span",
        { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.infos },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.info },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-angle-left" }),
          "bit rate: ",
          dr.bitrate,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-angle-right" })
        )
      )
    );
  },
  lora: function lora(dr) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "span",
      null,
      dr.dr,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "span",
        { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.infos },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.info },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-angle-left" }),
          "band width: ",
          dr.bandwidth,
          "k",
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-angle-right" })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.info },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-angle-left" }),
          "SF: ",
          dr.sf,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-angle-right" })
        )
      )
    );
  }
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_6_react_intl__["intlShape"].isRequired,
  show: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  onEdit: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  channel: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  dataRates: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};

var EditDRModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(EditDRModal, _React$Component);

  function EditDRModal(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, EditDRModal);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      channel: props.channel,
      show: props.show,
      submitted: false,
      errors: __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__["a" /* default */].createEmpty()
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.channelview.editdr');
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.renderOptions = _this.renderOptions.bind(_this);
    _this.handleChangeMinDR = _this.handleChangeMinDR.bind(_this);
    _this.handleChangeMaxDR = _this.handleChangeMaxDR.bind(_this);
    return _this;
  }

  EditDRModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var show = nextProps.show,
        dataRates = nextProps.dataRates,
        channel = nextProps.channel;

    if (show !== this.props.show) {
      this.setState({ show: show });
    }
    if (dataRates !== this.props.dataRates) {
      this.setState({ dataRates: dataRates });
    }
    this.setState({ channel: channel, mindr: channel.mindr, maxdr: channel.maxdr });
  };

  EditDRModal.prototype.handleChangeMinDR = function handleChangeMinDR(mindr) {
    var _state = this.state,
        maxdr = _state.maxdr,
        errors = _state.errors;

    this.setState({ mindr: mindr });

    if (!_.isNil(maxdr)) {
      if (maxdr < mindr) {
        this.setState({
          errors: errors.add('FE_MINGTMAX', 'mindr').add('FE_MINGTMAX', 'maxdr')
        });
      } else {
        this.setState({
          errors: errors.remove('mindr').remove('maxdr')
        });
      }
    } else {
      this.setState({
        errors: errors.remove('mindr')
      });
    }
  };

  EditDRModal.prototype.handleChangeMaxDR = function handleChangeMaxDR(maxdr) {
    var _state2 = this.state,
        mindr = _state2.mindr,
        errors = _state2.errors;

    this.setState({ maxdr: maxdr });

    if (!_.isNil(mindr)) {
      if (maxdr < mindr) {
        this.setState({
          errors: errors.add('FE_MINGTMAX', 'mindr').add('FE_MINGTMAX', 'maxdr')
        });
      } else {
        this.setState({
          errors: errors.remove('mindr').remove('maxdr')
        });
      }
    } else {
      this.setState({
        errors: errors.remove('maxdr')
      });
    }
  };

  EditDRModal.prototype.handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });

    var _state3 = this.state,
        channel = _state3.channel,
        errors = _state3.errors;
    var _state4 = this.state,
        _state4$mindr = _state4.mindr,
        mindr = _state4$mindr === undefined ? channel.mindr : _state4$mindr,
        _state4$maxdr = _state4.maxdr,
        maxdr = _state4$maxdr === undefined ? channel.maxdr : _state4$maxdr;
    var onEdit = this.props.onEdit;


    if (!errors.isEmpty()) {
      return;
    }
    this.handleOnHide();
    onEdit(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, channel, { mindr: mindr, maxdr: maxdr }));
  };

  EditDRModal.prototype.handleOnHide = function handleOnHide() {
    this.setState({ submitted: false });
    this.props.onHide();
  };

  EditDRModal.prototype.renderOptions = function renderOptions(channel) {
    var _state$dataRates = this.state.dataRates;
    _state$dataRates = _state$dataRates === undefined ? {} : _state$dataRates;
    var _state$dataRates$lora = _state$dataRates.lora,
        lora = _state$dataRates$lora === undefined ? [] : _state$dataRates$lora,
        _state$dataRates$fsk = _state$dataRates.fsk,
        fsk = _state$dataRates$fsk === undefined ? [] : _state$dataRates$fsk;

    var drs = void 0;
    var type = void 0;
    if (lora.findIndex(function (l) {
      return l.dr === channel.mindr;
    }) >= 0) {
      type = 'lora';
      drs = lora;
    } else {
      type = 'fsk';
      drs = fsk;
    }
    var drOpts = drs.map(function (dr) {
      return {
        label: dr.dr,
        value: dr.dr,
        formatter: function formatter() {
          return dataRateLabels[type](dr);
        }
      };
    });
    return drOpts || [];
  };

  EditDRModal.prototype.render = function render() {
    var _this2 = this;

    var _state5 = this.state,
        show = _state5.show,
        channel = _state5.channel,
        errors = _state5.errors,
        submitted = _state5.submitted,
        mindr = _state5.mindr,
        maxdr = _state5.maxdr;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-light",
        backdrop: "static",
        show: show,
        onHide: function onHide() {
          return _this2.handleOnHide();
        }
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        this.intlMsg.msg('header')
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Form"],
          { horizontal: true, onSubmit: this.handleSubmit },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                this.intlMsg.msg('mindr'),
                "\xA0*"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_Select__["a" /* default */], {
                value: mindr,
                options: this.renderOptions(channel),
                onChange: function onChange(s) {
                  return _this2.handleChangeMinDR(s);
                }
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
                show: submitted && errors.has('mindr'),
                message: this.intlMsg.errorMsg(errors.get('mindr')),
                azStyle: "danger"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                this.intlMsg.msg('maxdr'),
                "\xA0*"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_Select__["a" /* default */], {
                value: maxdr,
                options: this.renderOptions(channel),
                onChange: function onChange(s) {
                  return _this2.handleChangeMaxDR(s);
                }
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
                show: submitted && errors.has('maxdr'),
                message: this.intlMsg.errorMsg(errors.get('maxdr')),
                azStyle: "danger"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 6, mdOffset: 3 },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
                {
                  bsStyle: "aisz-primary",
                  className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.fullWidth,
                  type: "submit"
                },
                this.intlMsg.msg('button.confirm')
              )
            )
          )
        )
      )
    );
  };

  return EditDRModal;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

EditDRModal.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(EditDRModal));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss__ = __webpack_require__(2292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var propTypes = {
  band: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  onSelect: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  onUnselect: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  selected: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.array.isRequired,
  channels: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.array.isRequired,
  maxSelected: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.number.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired
};

var FixedChannels = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(FixedChannels, _React$Component);

  function FixedChannels(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FixedChannels);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.band = props.band;
    _this.state = {
      band: props.band,
      channels: props.channels,
      selected: props.selected
    };
    _this.handleClick = _this.handleClick.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.channelview.add.fixed');
    return _this;
  }

  FixedChannels.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var band = nextProps.band,
        selected = nextProps.selected,
        channels = nextProps.channels;

    if (band !== this.props.band) {
      this.band = band;
      this.setState({ band: band });
    }
    if (selected !== this.props.selected) {
      this.setState({ selected: selected });
    }
    if (channels !== this.props.channels) {
      this.setState({ channels: channels });
    }
  };

  FixedChannels.prototype.handleClick = function handleClick(channel) {
    var _props = this.props,
        onSelect = _props.onSelect,
        onUnselect = _props.onUnselect,
        maxSelected = _props.maxSelected;
    var _state$selected = this.state.selected,
        selected = _state$selected === undefined ? [] : _state$selected;

    var index = selected.findIndex(function (ch) {
      return ch.id === channel.id;
    });
    if (index >= 0) {
      onUnselect(channel);
    } else if (selected.length < maxSelected) {
      onSelect(channel);
    }
  };

  FixedChannels.prototype.render = function render() {
    var _this2 = this;

    var maxSelected = this.props.maxSelected;
    var _state = this.state,
        _state$band = _state.band,
        band = _state$band === undefined ? '' : _state$band,
        _state$channels = _state.channels,
        channels = _state$channels === undefined ? [] : _state$channels,
        _state$selected2 = _state.selected,
        selected = _state$selected2 === undefined ? [] : _state$selected2;


    var detail = function detail(channel) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Tooltip"],
        { id: "tooltip" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.detail },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.label },
            "Frequence"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.value },
            channel.freq / 1000000 + "MHZ"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.detail },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.label },
            "Min DR"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.value },
            channel.mindr
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.detail },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.label },
            "Max DR"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.value },
            channel.maxdr
          )
        )
      );
    };
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.container },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.notes },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "ul",
          { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.legends },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.icon + " " + __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.available }),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "span",
              { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.label },
              this.intlMsg.msg('available')
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_loracoms_ShowIf__["a" /* default */],
            { "if": band === 'CN470' },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "li",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.icon + " " + __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.restrict }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "span",
                { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.label },
                this.intlMsg.msg('restrict')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "span",
                { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.ref },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-asterisk" })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.icon + " " + __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.selected }),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_loracoms_ShowIf__["a" /* default */],
              { "if": band === 'CN470' },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.icon + " " + __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.selectedAlt })
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "span",
              { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.label },
              this.intlMsg.msg('selected')
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.icon + " " + __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.full }),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "span",
              { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.label },
              this.intlMsg.msg('full')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_loracoms_ShowIf__["a" /* default */],
          { "if": band === 'CN470' },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.caution },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-asterisk" }),
            ' ',
            this.intlMsg.msg('restrict.caution')
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "ul",
        { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.channels },
        channels.map(function (channel) {
          var selIndex = selected.findIndex(function (ch) {
            return ch.id === channel.id;
          });
          var restrict = band === 'CN470' && (_.inRange(channel.id, 6, 39) || _.inRange(channel.id, 45, 78));
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            {
              key: channel.id,
              className: ("\n                  " + __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.box + "\n                  " + (selIndex >= 0 ? __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.selected : '') + "\n                  " + (selected.length >= maxSelected ? __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.full : '') + "\n                  " + (restrict ? __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.restrict : '') + "\n                ").replace(/\n/g, ' ')
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_loracoms_ShowIf__["a" /* default */],
              { "if": selIndex >= 0 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.idx },
                selIndex + 1
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["OverlayTrigger"],
              { placement: "top", overlay: detail(channel) },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_router__["f" /* Link */],
                { onClick: function onClick() {
                    return _this2.handleClick(channel);
                  } },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.freq },
                  channel.freq / 1000000
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.id },
                  channel.id
                )
              )
            )
          );
        })
      )
    );
  };

  return FixedChannels;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

FixedChannels.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(FixedChannels));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss__ = __webpack_require__(2293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var kFreqRange = {
  CN470: {
    min: 470,
    max: 490
  },
  US902: {
    min: 902,
    max: 915
  },
  AU915: {
    min: 915,
    max: 928
  },
  EU863: {
    min: 863,
    max: 870
  },
  CN470PREQUEL: {
    min: 470,
    max: 510
  },
  EU868SEMTECH: {
    min: 863,
    max: 870
  },
  AS923: {
    min: 915,
    max: 928
  }
};

var propTypes = {
  plan: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var FreqSpectrum = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(FreqSpectrum, _React$Component);

  function FreqSpectrum(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FreqSpectrum);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      plan: props.plan
    };
    return _this;
  }

  FreqSpectrum.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var plan = nextProps.plan;

    if (plan !== this.props.plan) {
      this.setState({ plan: plan });
    }
  };

  FreqSpectrum.prototype.render = function render() {
    var _state$plan = this.state.plan,
        plan = _state$plan === undefined ? {} : _state$plan;
    var _plan$band = plan.band,
        band = _plan$band === undefined ? '' : _plan$band,
        _plan$channels = plan.channels,
        channels = _plan$channels === undefined ? [] : _plan$channels;


    if (band === '') {
      return null;
    }

    var freqRange = kFreqRange[band];
    if (_.isNil(freqRange)) return null;
    var bandWidth = freqRange.max - freqRange.min;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.spectrum },
      channels.map(function (ch) {
        var tooltip = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Tooltip"],
          { id: plan.id + "-" + ch.id },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.tooltip },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "span",
                { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.label },
                "ID"
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "span",
                { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.value },
                ch.id
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "span",
                { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.label },
                "Frequency"
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "span",
                { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.value },
                ch.freq / 1000000,
                "MHz"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "span",
                { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.label },
                "MinDR"
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "span",
                { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.value },
                ch.mindr
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "span",
                { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.label },
                "MaxDR"
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "span",
                { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.value },
                ch.maxdr
              )
            )
          )
        );
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["OverlayTrigger"],
          { key: ch.id, placement: "top", overlay: tooltip },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
            className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.freq,
            style: {
              width: 0.125 / bandWidth * 100 + "%",
              left: (ch.freq / 1000000 - freqRange.min) / bandWidth * 100 + "%"
            }
          })
        );
      })
    );
  };

  return FreqSpectrum;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

FreqSpectrum.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (FreqSpectrum);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_PageLoading__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_PageNoPerm__ = __webpack_require__(131);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);








var propTypes = {
  plan: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.node.isRequired
};

var ChannelView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ChannelView, _React$Component);

  function ChannelView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ChannelView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      plan: props.plan
    };
    return _this;
  }

  ChannelView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var plan = nextProps.plan;

    if (plan !== this.props.plan) {
      this.setState({ plan: plan });
    }
  };

  ChannelView.prototype.render = function render() {
    var plan = this.state.plan;

    if (plan.status !== 'success') {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_PageLoading__["a" /* default */], null);
    }
    if (plan.tier === 1) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_PageNoPerm__["a" /* default */], null);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      null,
      this.props.children
    );
  };

  return ChannelView;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ChannelView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    plan: state.billing.plan
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(ChannelView)));

/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_mapKeys__ = __webpack_require__(2505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_mapKeys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_mapKeys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PieChart__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss__ = __webpack_require__(2294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









function toSeries(seriesData) {
  var sum = _.sum(_.values(seriesData));
  return {
    label: {
      normal: {
        formatter: function formatter(params) {
          return params.name;
        },
        fontSize: 10
      },
      emphasis: {
        formatter: function formatter(params) {
          return params.name;
        }
      }
    },
    data: _.map(seriesData, function (value, name) {
      return {
        name: name,
        value: value,
        label: {
          normal: {
            position: value / sum < 0.1 ? 'outside' : 'inside'
          }
        },
        labelLine: {
          normal: {
            length: 5,
            length2: 5
          }
        }
      };
    })
  };
}

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  seriesData: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  keyName: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired
};

var GatewayPie = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(GatewayPie, _React$Component);

  function GatewayPie(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GatewayPie);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.analytics.gateway.pie');
    return _this;
  }

  GatewayPie.prototype.render = function render() {
    var _this2 = this;

    var keyName = this.props.keyName;
    var seriesData = this.props.seriesData;

    seriesData = __WEBPACK_IMPORTED_MODULE_6_lodash_mapKeys___default()(seriesData, function (value, key) {
      return _this2.intlMsg.msg(keyName + "." + key);
    });
    var title = {
      text: this.intlMsg.msg("title." + keyName),
      x: 'center',
      y: 'bottom',
      textStyle: {
        fontSize: 16,
        fontWeight: 400
      }
    };
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.chart },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PieChart__["a" /* default */], { title: title, series: [toSeries(seriesData)] })
    );
  };

  return GatewayPie;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

GatewayPie.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(function () {
  return {};
}, {})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(GatewayPie)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_pie__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_pie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_pie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_tooltip__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_title__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_legend__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_grid__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_dataZoom__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_dataZoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_dataZoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_echarts_lib_echarts__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_merge__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_isString__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_scss__ = __webpack_require__(2295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);














var defaultProps = {
  legend: [],
  title: ''
};

var defaultTitle = {
  textStyle: {
    fontSize: 14,
    fontWeight: 300
  },
  textBaseline: 'bottom'
};

var propTypes = {
  series: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.array.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any,
  legend: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any
};

var defaultSeries = {
  label: {
    normal: {
      textStyle: {
        fontWeight: 300
      }
    }
  },
  radius: [0, '60%']
};

var PieChart = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PieChart, _React$Component);

  function PieChart(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PieChart);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      series: props.series,
      legend: props.legend
    };
    return _this;
  }

  PieChart.prototype.componentDidMount = function componentDidMount() {
    this.echart = this.initChart();
    $(this.chartRef).height($(this.wrapperRef).height());
    this.echart.resize();
    $(window).resize(this.resizeChart);
  };

  PieChart.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var series = nextProps.series,
        legend = nextProps.legend;

    if (series !== this.props.series) {
      this.setState({
        series: nextProps.series,
        legend: nextProps.legend
      });
      this.updateChart(series, legend);
    }
    this.resizeChart();
  };

  PieChart.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_11_echarts_lib_echarts___default.a.dispose($(this.chartRef));
    $(window).off('resize', this.resizeChart);
  };

  PieChart.prototype.resizeChart = function resizeChart() {
    var width = $(this.wrapperRef).width();
    var height = $(this.wrapperRef).height();
    if (height !== this.height) {
      $(this.chartRef).height(height);
      if (this.echart) {
        this.echart.resize();
      }
    } else if (width !== this.width) {
      if (this.echart) {
        this.echart.resize();
      }
    }
    this.width = width;
    this.height = height;
  };

  PieChart.prototype.updateChart = function updateChart(nextSeries, nextLegend) {
    var series = nextSeries.map(function (s) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, s, { type: 'pie' });
    });
    var legend = nextLegend || [];
    var option = { series: series, legend: legend };
    this.echart.setOption(option);
    this.echart.resize();
  };

  PieChart.prototype.initChart = function initChart() {
    var echart = __WEBPACK_IMPORTED_MODULE_11_echarts_lib_echarts___default.a.init(this.chartRef);
    var series = this.state.series.map(function (s) {
      return __WEBPACK_IMPORTED_MODULE_12_lodash_merge___default()({}, defaultSeries, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, s, {
        type: 'pie'
      }));
    });

    var legend = this.props.legend;
    var title = this.props.title;

    if (__WEBPACK_IMPORTED_MODULE_13_lodash_isString___default()(title)) {
      title = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultTitle, {
        text: title
      });
    }
    var option = {
      title: title,
      legend: legend,
      series: series,
      tooltip: {
        trigger: 'item',
        formatter: '{b} : {c} ({d}%)'
      },
      color: PieChart.colors
    };
    echart.setOption(option);
    return echart;
  };

  PieChart.prototype.render = function render() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_15__styles_scss___default.a.wrapper,
        ref: function ref(_ref2) {
          _this2.wrapperRef = _ref2;
        }
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_15__styles_scss___default.a.chart, ref: function ref(_ref) {
          _this2.chartRef = _ref;
        } })
    );
  };

  return PieChart;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

PieChart.colors = ['#22A7F0', '#00B16A', '#F7CA18', '#F9690E', '#EF4836', '#DB0A5B', '#663399', '#BF55EC', '#446CB3', '#336E7B', '#1BBC9B'];
PieChart.propTypes = propTypes;
PieChart.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_react_redux__["connect"])(function (state) {
  return {
    collapsed: state.sidebar.collapsed
  };
})(PieChart));

/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_scss__ = __webpack_require__(2296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var propTypes = {
  keyName: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  sortName: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  sortOrder: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  handleSortChange: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var SortFlag = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(SortFlag, _React$Component);

  function SortFlag() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SortFlag);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  SortFlag.prototype.handleClick = function handleClick(sortOrder) {
    var keyName = this.props.keyName;

    this.props.handleSortChange({ sortName: keyName, sortOrder: sortOrder });
  };

  SortFlag.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        sortName = _props.sortName,
        sortOrder = _props.sortOrder,
        keyName = _props.keyName;

    if (sortName === keyName) {
      if (sortOrder === 'desc') {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "span",
          { onClick: function onClick() {
              return _this2.handleClick('asc');
            } },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "fa fa-caret-down " + __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.flag + " " + __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.select }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "fa fa-caret-up " + __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.flag + "  " + __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.hidden })
        );
      }

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "span",
        { onClick: function onClick() {
            return _this2.handleClick('desc');
          } },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "fa fa-caret-up " + __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.flag + "  " + __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.select }),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "fa fa-caret-down " + __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.flag + " " + __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.hidden })
      );
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "span",
      { onClick: function onClick() {
          return _this2.handleClick('desc');
        } },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "fa fa-caret-down " + __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.flag }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "fa fa-caret-up " + __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.flag })
    );
  };

  return SortFlag;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

SortFlag.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (SortFlag);

/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loraapi_lora_network__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__coms_GatewayPie__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__coms_SortFlag__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss__ = __webpack_require__(2297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.any.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired
};

var GatewayView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(GatewayView, _React$Component);

  function GatewayView(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GatewayView);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      gateways: [],
      nodes: [],
      selectGatewayId: '',
      gatewaySort: { sortName: '', sortOrder: '' },
      nodeSort: { sortName: '', sortOrder: '' },
      distribution: {},
      showHelp: false
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.analytics.gateway');
    _this.flowRange = _this.flowRange.bind(_this);
    return _this;
  }

  GatewayView.prototype.componentDidMount = function componentDidMount() {
    this.loadGateway('flow', 'desc', true, { gatewaySort: { sortName: 'flow', sortOrder: 'desc' } });
  };

  GatewayView.prototype.flowRange = function flowRange(flow) {
    var base = 1024 * 1024;
    if (flow < base) {
      return 1;
    } else if (flow >= base && flow < 10 * base) {
      return 2;
    }
    return 3;
  };

  GatewayView.prototype.toaRange = function toaRange(toa) {
    if (toa < 60 * 1000) {
      return 1;
    } else if (toa >= 60 * 1000 && toa < 60 * 60 * 1000) {
      return 2;
    }
    return 3;
  };

  GatewayView.prototype.invalidRange = function invalidRange(invalidPre) {
    if (invalidPre < 10) {
      return 1;
    } else if (invalidPre >= 10 && invalidPre < 30) {
      return 2;
    } else if (invalidPre >= 30 && invalidPre < 60) {
      return 3;
    } else if (invalidPre >= 60 && invalidPre < 90) {
      return 4;
    }
    return 5;
  };

  GatewayView.prototype.parserDistribution = function parserDistribution() {
    var _this2 = this;

    var gateways = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var toaDistri = { 1: 0, 2: 0, 3: 0 };
    var flowDistri = { 1: 0, 2: 0, 3: 0 };
    var invalidDistri = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    gateways.forEach(function (gateway) {
      var flowKey = _this2.flowRange(gateway.flow);
      flowDistri[flowKey] = flowDistri[flowKey] + 1;

      var toaKey = _this2.toaRange(gateway.toa);
      toaDistri[toaKey] = toaDistri[toaKey] + 1;

      var invalidKey = _this2.invalidRange(gateway.invalid_pre);
      invalidDistri[invalidKey] = invalidDistri[invalidKey] + 1;
    });
    return { toa: toaDistri, flow: flowDistri, invalid: invalidDistri };
  };

  GatewayView.prototype.loadGateway = function loadGateway(sortName, sortOrder) {
    var _this3 = this;

    var cascade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var state = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_loraapi_lora_network__["b" /* getGatewayStatus */])(sortName, sortOrder).then(function (res) {
      var list = res.body.list;
      if (list.length > 0) {
        var distri = _this3.parserDistribution(list);
        if (cascade) {
          _this3.loadGatewayNode(list[0].gateway, 'flow', 'desc', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            distribution: distri,
            gateways: res.body.list,
            selectGatewayId: list[0].gateway,
            nodeSort: { sortName: 'flow', sortOrder: 'desc' }
          }, state));
        } else {
          _this3.setState(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ distribution: distri, gateways: res.body.list }, state));
        }
      }
    });
  };

  GatewayView.prototype.loadGatewayNode = function loadGatewayNode(gateway, sortName, sortOrder) {
    var _this4 = this;

    var state = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_loraapi_lora_network__["c" /* getGatewayNodeStatus */])(gateway, sortName, sortOrder).then(function (res) {
      _this4.setState(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ nodes: res.body.list, selectGatewayId: gateway }, state));
    });
  };

  GatewayView.prototype.fixedNumber = function fixedNumber(value) {
    return Number(value).toFixed(2);
  };

  GatewayView.prototype.handleGatewayChange = function handleGatewayChange(gatewayId) {
    this.loadGatewayNode(gatewayId, 'flow', 'desc', { nodeSort: { sortName: 'flow', sortOrder: 'desc' } });
  };

  GatewayView.prototype.handleGatewaySortChange = function handleGatewaySortChange(sortInfo) {
    this.loadGateway(sortInfo.sortName, sortInfo.sortOrder, false, { gatewaySort: sortInfo });
  };

  GatewayView.prototype.handleNodeSortChange = function handleNodeSortChange(sortInfo) {
    this.loadGatewayNode(this.state.selectGatewayId, sortInfo.sortName, sortInfo.sortOrder, { nodeSort: sortInfo });
  };

  GatewayView.prototype.renderGateway = function renderGateway() {
    var _this5 = this;

    var _state = this.state,
        gateways = _state.gateways,
        gatewaySort = _state.gatewaySort,
        selectGatewayId = _state.selectGatewayId;

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: this.intlMsg.msg('rank.gateway') },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Table"],
        { className: "aisz-table-light", bordered: true, responsive: true },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('rank')
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              " ",
              this.intlMsg.msg('gateway'),
              " "
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('flow') + "(Byte)",
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__coms_SortFlag__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                keyName: "flow",
                handleSortChange: function handleSortChange(data) {
                  return _this5.handleGatewaySortChange(data);
                } }, gatewaySort))
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('toa') + "(ms)",
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__coms_SortFlag__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ keyName: "toa", handleSortChange: function handleSortChange(data) {
                  return _this5.handleGatewaySortChange(data);
                } }, gatewaySort))
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('invalid_pre') + "(%)",
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__coms_SortFlag__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                keyName: "invalid_pre",
                handleSortChange: function handleSortChange(data) {
                  return _this5.handleGatewaySortChange(data);
                } }, gatewaySort))
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "tbody",
          null,
          gateways.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "tr",
              {
                key: index, onClick: function onClick() {
                  return _this5.handleGatewayChange(item.gateway);
                },
                className: "" + (item.gateway === selectGatewayId ? __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.select : '')
              },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                index + 1
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  "a",
                  { onClick: function onClick() {
                      return _this5.props.pushState("/gateway/detail/" + item.gateway);
                    } },
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lorautils_IdUtils__["a" /* normalizeDevEUI */])(item.gateway)
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                item.flow
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                item.toa
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                _this5.fixedNumber(item.invalid_pre)
              )
            );
          })
        )
      )
    );
  };

  GatewayView.prototype.renderNodes = function renderNodes() {
    var _this6 = this;

    var _state2 = this.state,
        _state2$nodes = _state2.nodes,
        nodes = _state2$nodes === undefined ? [] : _state2$nodes,
        nodeSort = _state2.nodeSort,
        selectGatewayId = _state2.selectGatewayId;

    var header = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      null,
      this.intlMsg.msg('rank.node'),
      "(",
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "span",
        { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.selectId },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lorautils_IdUtils__["a" /* normalizeDevEUI */])(selectGatewayId)
      ),
      ")"
    );
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: header },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Table"],
        { className: "aisz-table-light", striped: true, bordered: true, responsive: true },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('rank')
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              " ",
              this.intlMsg.msg('node'),
              " "
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('flow') + "(Byte)",
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__coms_SortFlag__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                keyName: "flow",
                handleSortChange: function handleSortChange(data) {
                  return _this6.handleNodeSortChange(data);
                } }, nodeSort))
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('toa') + "(ms)",
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__coms_SortFlag__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                keyName: "toa",
                handleSortChange: function handleSortChange(data) {
                  return _this6.handleNodeSortChange(data);
                } }, nodeSort))
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('invalid_pre') + "(%)",
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__coms_SortFlag__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                keyName: "invalid_pre",
                handleSortChange: function handleSortChange(data) {
                  return _this6.handleNodeSortChange(data);
                } }, nodeSort))
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "tbody",
          null,
          nodes.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "tr",
              { key: index },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                index + 1
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  "a",
                  { onClick: function onClick() {
                      return _this6.props.pushState("/application/" + item.appeui + "/devices/" + item.deveui);
                    } },
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lorautils_IdUtils__["a" /* normalizeDevEUI */])(item.deveui)
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                item.flow
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                item.toa
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                _this6.fixedNumber(item.invalid_pre)
              )
            );
          })
        )
      )
    );
  };

  GatewayView.prototype.renderGlobal = function renderGlobal() {
    var distribution = this.state.distribution;

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white" },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__coms_GatewayPie__["a" /* default */], { keyName: "flow", title: '网关分布(按流量)', seriesData: distribution.flow || {} })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__coms_GatewayPie__["a" /* default */], { keyName: "invalid_pre", title: '网关分布(按冗余度)', seriesData: distribution.invalid || {} })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__coms_GatewayPie__["a" /* default */], { keyName: "toa", title: '网关分布(按TOA)', seriesData: distribution.toa || {} })
        )
      )
    );
  };

  GatewayView.prototype.renderToolbar = function renderToolbar() {
    var _this7 = this;

    var title = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      null,
      this.intlMsg.msg('title'),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", {
        onClick: function onClick() {
          _this7.setState({ showHelp: !_this7.state.showHelp });
        }, className: "glyphicons glyphicons-question-sign " + __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.help
      })
    );
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_Toolbar__["a" /* default */], {
      brandTitle: title
    });
  };

  GatewayView.prototype.renderHelpWell = function renderHelpWell() {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Well"],
      { bsClass: "aisz-well-light" },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "p",
          null,
          this.intlMsg.msg('total.help')
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "p",
          null,
          this.intlMsg.msg('flow.help')
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "p",
          null,
          this.intlMsg.msg('toa.help')
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "p",
          null,
          this.intlMsg.msg('invalid_pre.help')
        )
      )
    );
  };

  GatewayView.prototype.render = function render() {
    var _state3 = this.state,
        gateways = _state3.gateways,
        distribution = _state3.distribution;

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 12 },
          this.renderToolbar()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Collapse"],
        { "in": this.state.showHelp },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
            { md: 12 },
            this.renderHelpWell()
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 12 },
          gateways.length > 0 && this.renderGlobal()
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 6 },
          this.renderGateway()
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 6 },
          this.renderNodes()
        )
      )
    );
  };

  return GatewayView;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

GatewayView.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(function () {
  return {};
}, { pushState: __WEBPACK_IMPORTED_MODULE_7_react_router_redux__["routerActions"].push })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(GatewayView)));

/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_main_scss__ = __webpack_require__(2298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_main_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any,
  getData: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func,
  keyName: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string,
  valueName: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string,
  valueTitleComponent: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any,
  valueItem: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.string,
  withPanel: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.bool,
  formatKey: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func,
  formatValue: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func,
  onClickKey: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func
};

var Rank = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Rank, _React$Component);

  function Rank(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Rank);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      data: _this.props.data || [],
      showHelpDoc: false
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__["a" /* default */](props.intl, _this.props.namespace);
    return _this;
  }

  Rank.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (this.props.getData) {
      this.props.getData(null).then(function (res) {
        _this2.setState({ data: res.body.list });
      });
    }
  };

  Rank.prototype.render = function render() {
    var _this3 = this;

    var items = this.state.data;
    var element = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { styleName: "rank" },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { styleName: "list-tt" },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          { styleName: "tt-index" },
          this.intlMsg.msg('rank')
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          { styleName: "tt-key" },
          this.intlMsg.msg(this.props.keyName)
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          { styleName: "tt-value" },
          this.props.valueTitleComponent || this.intlMsg.msg(this.props.valueName)
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "ul",
        { styleName: "item-list" },
        items.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "li",
            { key: index },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "div",
              { styleName: "item-hd" },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "span",
                { styleName: "item-index" },
                index + 1
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "span",
                { styleName: "item-key" },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "a",
                  { onClick: function onClick() {
                      return _this3.props.onClickKey(item);
                    } },
                  _this3.props.formatKey(item[_this3.props.keyName])
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "span",
                { styleName: "item-value" },
                _this3.props.formatValue(item[_this3.props.valueItem || _this3.props.valueName])
              )
            )
          );
        })
      )
    );
    if (this.props.withPanel) {
      var helpTooltip = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Tooltip"],
        { id: "tooltip-help" },
        this.intlMsg.msg(this.props.valueName + ".help")
      );
      var header = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          null,
          this.intlMsg.msg(this.props.valueName)
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["OverlayTrigger"],
          { trigger: "click", rootClose: true, placement: "right", overlay: helpTooltip },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-question-sign" })
        )
      );
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Panel"],
        { bsStyle: "aisz-white", header: header },
        element
      );
    }
    return element;
  };

  return Rank;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Rank.defaultProps = {
  formatKey: function formatKey(key) {
    return key;
  },
  formatValue: function formatValue(value) {
    return value;
  }
};

Rank.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_7_react_css_modules___default()(Rank, __WEBPACK_IMPORTED_MODULE_9__styles_main_scss___default.a, { allowMultiple: true })));

/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loraapi_lora_network__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__coms_Rank__ = __webpack_require__(1324);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);












var NodeView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NodeView, _React$Component);

  function NodeView(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, NodeView);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {};
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.analytics.node');
    return _this;
  }

  NodeView.prototype.fixedNumber = function fixedNumber(value) {
    return Number(value).toFixed(2);
  };

  NodeView.prototype.render = function render() {
    var _this2 = this;

    var shareProps = {
      namespace: 'network.analytics.node',
      onClickKey: function onClickKey(item) {
        _this2.props.pushState("/application/" + item.appeui + "/devices/" + item.deveui);
      },
      formatKey: function formatKey(key) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lorautils_IdUtils__["a" /* normalizeDevEUI */])(key);
      }
    };
    var helpTooltip = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Tooltip"],
      { id: "tooltip-help" },
      this.intlMsg.msg('rssi.help')
    );
    var header = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "span",
        null,
        this.intlMsg.msg('rssi')
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["OverlayTrigger"],
        { trigger: "click", rootClose: true, placement: "right", overlay: helpTooltip },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: "glyphicons glyphicons-question-sign" })
      )
    );

    var renderRssi = function renderRssi(sfIndex, className) {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
        { md: 4, className: className },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__coms_Rank__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          keyName: "deveui", valueName: "rssi", valueItem: "rssi_" + sfIndex,
          valueTitleComponent: "RSSI(SF" + sfIndex + ")",
          getData: function getData(order) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_loraapi_lora_network__["a" /* getNodeStatus */])("rssi_" + sfIndex, order || 'asc');
          }
        }, shareProps, {
          formatValue: function formatValue(value) {
            return _this2.fixedNumber(value);
          }
        }))
      );
    };
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__coms_Rank__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            withPanel: true, keyName: "deveui", valueName: "loss_pre", getData: function getData(order) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_loraapi_lora_network__["a" /* getNodeStatus */])('loss_pre', order || 'desc');
            }
          }, shareProps, {
            formatValue: function formatValue(value) {
              return _this2.fixedNumber(value) + "%";
            }
          }))
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 4, className: "collapse-left" },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__coms_Rank__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            withPanel: true, keyName: "deveui", valueName: "snr", getData: function getData(order) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_loraapi_lora_network__["a" /* getNodeStatus */])('snr', order || 'asc');
            }
          }, shareProps, {
            formatValue: function formatValue(value) {
              return _this2.fixedNumber(value);
            }
          }))
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 4, className: "collapse-left" },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__coms_Rank__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            withPanel: true, keyName: "deveui", valueName: "toa", getData: function getData(order) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_loraapi_lora_network__["a" /* getNodeStatus */])('toa', order || 'desc');
            }
          }, shareProps, {
            formatValue: function formatValue(value) {
              return value + "ms";
            }
          }))
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Panel"],
            { bsStyle: "aisz-white", header: header },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
              null,
              renderRssi(7),
              renderRssi(8, 'collapse-left'),
              renderRssi(9, 'collapse-left'),
              renderRssi(10),
              renderRssi(11, 'collapse-left'),
              renderRssi(12, 'collapse-left')
            )
          )
        )
      )
    );
  };

  return NodeView;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

NodeView.propTypes = {
  pushState: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(function () {
  return {};
}, { pushState: __WEBPACK_IMPORTED_MODULE_7_react_router_redux__["routerActions"].push })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(NodeView)));

/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_InlineSelect__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_ScatterChart__ = __webpack_require__(610);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.any.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.any.isRequired
};

var DeviceQualityView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DeviceQualityView, _React$Component);

  function DeviceQualityView(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DeviceQualityView);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.qualityView');
    _this.state = {
      signalDataList: null,
      lossDataList: null,
      initialStatus: 'pending',
      queryHours: 6
    };
    return _this;
  }

  DeviceQualityView.prototype.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.loadDeviceAnalysisList();
  };

  DeviceQualityView.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  DeviceQualityView.prototype.loadDeviceAnalysisList = function loadDeviceAnalysisList() {
    var _this2 = this;

    this.setState({ initialStatus: 'loading' });

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_api__["a" /* callAPI */])({
      endpoint: '/na/device_signal',
      query: {
        start_time: moment().subtract(this.state.queryHours, 'hours').unix(),
        end_time: moment().unix(),
        deveui: this.props.id
      }
    }).then(function (data) {
      if (_this2.mounted) {
        _this2.setState({
          initialStatus: 'success',
          signalDataList: data
        });
      }
    }).catch(function () {
      _this2.setState({
        initialStatus: 'failure'
      });
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_api__["a" /* callAPI */])({
      endpoint: '/na/device_packet_loss',
      query: {
        start_time: moment().subtract(this.state.queryHours, 'hours').unix(),
        end_time: moment().unix(),
        deveui: this.props.id
      }
    }).then(function (data) {
      if (_this2.mounted) {
        _this2.setState({
          initialStatus: 'success',
          lossDataList: data
        });
      }
    }).catch(function () {
      _this2.setState({
        initialStatus: 'failure'
      });
    });
  };

  DeviceQualityView.prototype.render = function render() {
    var _this3 = this;

    var id = this.props.id;

    var breadcrumb = [{
      content: this.intlMsg.msg('title'),
      onClick: function onClick() {
        return _this3.props.pushState('/network/quality');
      }
    }, {
      content: id,
      active: true
    }];
    var signalDataList = this.state.signalDataList || [];
    var signalSNRScatterData = [];
    var signalRSSIScatterData = [];
    var frequencyDict = {};
    if (signalDataList.length !== 0) {
      for (var i = 0; i < signalDataList.length; i += 1) {
        var row = [moment.unix(signalDataList[i].ts / 1000).format('YYYY/MM/DD HH:mm'), signalDataList[i].lorasnr, signalDataList[i].rssi, String(signalDataList[i].frequency)];
        frequencyDict[String(signalDataList[i].frequency)] = '';
        signalSNRScatterData.push(row);
        row = [moment.unix(signalDataList[i].ts / 1000).format('YYYY/MM/DD HH:mm'), signalDataList[i].rssi, signalDataList[i].lorasnr, String(signalDataList[i].frequency)];
        signalRSSIScatterData.push(row);
      }
    }
    var frequencyList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(frequencyDict);
    var lossDataList = this.state.lossDataList || [];
    var lossScatterData = [];
    if (lossDataList.length !== 0) {
      for (var _i = 0; _i < lossDataList.length; _i += 1) {
        var _row = [moment.unix(lossDataList[_i].ts / 1000).format('YYYY/MM/DD HH:mm'), lossDataList[_i].lost];
        lossScatterData.push(_row);
      }
    }
    var hoursStr = this.intlMsg.msg('hours');
    var rightTools = [{
      type: 'buttons',
      buttons: [__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_InlineSelect__["a" /* default */], {
        options: [{
          label: '1 ' + hoursStr,
          value: 1
        }, {
          label: '6 ' + hoursStr,
          value: 6
        }, {
          label: '12 ' + hoursStr,
          value: 12
        }, {
          label: '24 ' + hoursStr,
          value: 24
        }, {
          label: '72 ' + hoursStr,
          value: 72
        }],
        values: [this.state.queryHours],
        onChange: function onChange(selected) {
          _this3.setState({
            queryHours: selected[0]
          }, function () {
            _this3.loadDeviceAnalysisList();
          });
        }
      })]
    }];
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb, rightTools: rightTools })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
            { bsStyle: "aisz-white", header: 'SNR' },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_ScatterChart__["a" /* default */], {
              series: [{
                type: 'scatter',
                data: signalSNRScatterData
              }],
              tooltip: {
                formatter: function formatter(obj) {
                  return 'Time: ' + obj.data[0] + '<br>' + 'RSSI: ' + obj.data[1] + '<br>' + 'SNR: ' + obj.data[2] + '<br>' + 'Frequency: ' + obj.data[3] + '<br>';
                }
              },
              dataZoom: [{
                show: true,
                realtime: true,
                start: 0,
                end: 100
              }, {
                type: 'inside',
                realtime: true,
                start: 0,
                end: 100
              }],
              grid: {
                left: 50,
                top: 50,
                right: 40
              },
              xAxis: {
                type: 'time',
                splitLine: {
                  lineStyle: {
                    type: 'dashed'
                  }
                }
              },
              yAxis: {
                name: 'SNR',
                splitLine: {
                  lineStyle: {
                    type: 'dashed'
                  }
                }
              },
              visualMap: [{
                orient: 'horizontal',
                align: 'left',
                top: 0,
                categories: frequencyList,
                dimension: 3,
                inRange: {
                  color: ['#313695', '#4575b4', '#74add1', '#abd9e9', '#e0f3f8', '#ffffbf', '#fee090', '#fdae61', '#f46d43', '#d73027', '#a50026']
                }
              }]
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
            { bsStyle: "aisz-white", header: 'RSSI' },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_ScatterChart__["a" /* default */], {
              series: [{
                type: 'scatter',
                data: signalRSSIScatterData
              }],
              tooltip: {
                formatter: function formatter(obj) {
                  return 'Time: ' + obj.data[0] + '<br>' + 'RSSI: ' + obj.data[1] + '<br>' + 'SNR: ' + obj.data[2] + '<br>' + 'Frequency: ' + obj.data[3] + '<br>';
                }
              },
              dataZoom: [{
                show: true,
                realtime: true,
                start: 0,
                end: 100
              }, {
                type: 'inside',
                realtime: true,
                start: 0,
                end: 100
              }],
              grid: {
                left: 50,
                top: 50,
                right: 40
              },
              xAxis: {
                type: 'time',

                splitLine: {
                  lineStyle: {
                    type: 'dashed'
                  }
                }
              },
              yAxis: {
                name: 'SNR',

                splitLine: {
                  lineStyle: {
                    type: 'dashed'
                  }
                }
              },
              visualMap: [{
                orient: 'horizontal',
                align: 'left',
                top: 0,
                categories: frequencyList,
                dimension: 3,
                inRange: {
                  color: ['#313695', '#4575b4', '#74add1', '#abd9e9', '#e0f3f8', '#ffffbf', '#fee090', '#fdae61', '#f46d43', '#d73027', '#a50026']
                }
              }]
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
            { bsStyle: "aisz-white", header: this.intlMsg.msg('loss') },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_ScatterChart__["a" /* default */], {
              series: [{
                type: 'scatter',
                data: lossScatterData
              }],
              tooltip: {
                formatter: function formatter(obj) {
                  return 'Time: ' + obj.data[0] + '<br>' + 'Lost: ' + obj.data[1] + '<br>';
                }
              },
              dataZoom: [{
                show: true,
                realtime: true,
                start: 0,
                end: 100
              }, {
                type: 'inside',
                realtime: true,
                start: 0,
                end: 100
              }],
              grid: {
                left: 50,
                top: 30,
                right: 40
              },
              xAxis: {
                type: 'time',
                splitLine: {
                  lineStyle: {
                    type: 'dashed'
                  }
                }
              },
              yAxis: {
                name: 'Loss',
                splitLine: {
                  lineStyle: {
                    type: 'dashed'
                  }
                }
              },
              visualMap: []
            })
          )
        )
      )
    );
  };

  return DeviceQualityView;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

DeviceQualityView.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    id: props.params.id
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps, { pushState: __WEBPACK_IMPORTED_MODULE_11_react_router_redux__["routerActions"].push })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(DeviceQualityView)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_LoadingTable__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_ScatterChart__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_HeatmapChart__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_InlineSelect__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loraimages_chart_loading_gif__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loraimages_chart_loading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_loraimages_chart_loading_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loracoms_SortBtn__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss__ = __webpack_require__(2299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var QualityDeail = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(QualityDeail, _React$Component);

  function QualityDeail(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, QualityDeail);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      heatmapData: [],
      deviceList: [],
      queryHours: 6,
      sortKey: 'deveui',
      listStatus: 'pending',
      heatStatus: 'pending'
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.qualityView');
    return _this;
  }

  QualityDeail.prototype.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.loadNetworkAnalysisList();
  };

  QualityDeail.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  QualityDeail.prototype.loadNetworkAnalysisList = function loadNetworkAnalysisList() {
    var _this2 = this;

    this.setState({ listStatus: 'pending', heatStatus: 'pending' });

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lorautils_api__["a" /* callAPI */])({
      endpoint: '/na/device_quality_summary',
      query: {
        hours: this.state.queryHours
      }
    }).then(function (data) {
      if (_this2.mounted) {
        _this2.setState({
          listStatus: 'success',
          deviceList: data
        });
      }
    }).catch(function () {
      _this2.setState({
        listStatus: 'failure'
      });
    });

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lorautils_api__["a" /* callAPI */])({
      endpoint: '/na/packet_quality_summary',
      query: {
        hours: this.state.queryHours,
        heatmap: 1
      }
    }).then(function (data) {
      if (_this2.mounted) {
        _this2.setState({
          heatStatus: 'success',
          heatmapData: data
        });
      }
    }).catch(function () {
      _this2.setState({
        heatStatus: 'failure'
      });
    });
  };

  QualityDeail.prototype.handleSort = function handleSort(sort) {
    var deviceList = this.state.deviceList || [];
    var sortOrder = true;
    var sortKey = '';
    if (sort.startsWith('-')) {
      sortOrder = true;
      sortKey = sort.substr(1);
    } else {
      sortOrder = false;
      sortKey = sort;
    }
    deviceList.sort(function (a, b) {
      if (sortOrder) {
        return a[sortKey] >= b[sortKey];
      }
      return a[sortKey] <= b[sortKey];
    });
    this.setState({
      deviceList: deviceList,
      sortKey: sortKey
    });
  };

  QualityDeail.prototype.render = function render() {
    var _this3 = this;

    var pushState = this.props.pushState;
    var _state = this.state,
        heatmapData = _state.heatmapData,
        deviceList = _state.deviceList,
        listStatus = _state.listStatus,
        heatStatus = _state.heatStatus;

    var sortKey = this.state.sortKey || null;
    var heatmapX = [];
    var heatmapY = [];
    var heatmapList = [];
    var scatterData = [];

    if (deviceList.length !== 0) {
      for (var i = 0; i < deviceList.length; i += 1) {
        var row = [deviceList[i].rssi_avg.toFixed(2), deviceList[i].lorasnr_avg.toFixed(2), deviceList[i].packet_loss_rate.toFixed(2), String(deviceList[i].deveui)];
        scatterData.push(row);
      }
    }
    if (heatmapData.length !== 0) {
      heatmapData.xedges.forEach(function (e) {
        heatmapX.push(String(e.toFixed(1)));
      });
      heatmapData.yedges.forEach(function (e) {
        heatmapY.push(String(e.toFixed(1)));
      });
      heatmapList = heatmapData.heatmap_list;
    }
    var thead = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "thead",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.name'),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_SortBtn__["a" /* default */], {
            sortName: "name",
            highLight: sortKey === 'name',
            handleSort: function handleSort(s) {
              return _this3.handleSort(s);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.deveui'),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_SortBtn__["a" /* default */], {
            sortName: "deveui",
            highLight: sortKey === 'deveui',
            handleSort: function handleSort(s) {
              return _this3.handleSort(s);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.snrAvg'),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_SortBtn__["a" /* default */], {
            sortName: "lorasnr_avg",
            highLight: sortKey === 'lorasnr_avg',
            handleSort: function handleSort(s) {
              return _this3.handleSort(s);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.snrStd'),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_SortBtn__["a" /* default */], {
            sortName: "lorasnr_stddev",
            highLight: sortKey === 'lorasnr_stddev',
            handleSort: function handleSort(s) {
              return _this3.handleSort(s);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.rssiAvg'),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_SortBtn__["a" /* default */], {
            sortName: "rssi_avg",
            highLight: sortKey === 'rssi_avg',
            handleSort: function handleSort(s) {
              return _this3.handleSort(s);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.rssiStd'),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_SortBtn__["a" /* default */], {
            sortName: "rssi_stddev",
            highLight: sortKey === 'rssi_stddev',
            handleSort: function handleSort(s) {
              return _this3.handleSort(s);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.upPacketCount'),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_SortBtn__["a" /* default */], {
            sortName: "packet_total",
            highLight: sortKey === 'packet_total',
            handleSort: function handleSort(s) {
              return _this3.handleSort(s);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.packetLossRate'),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_SortBtn__["a" /* default */], {
            sortName: "packet_loss_rate",
            highLight: sortKey === 'packet_loss_rate',
            handleSort: function handleSort(s) {
              return _this3.handleSort(s);
            }
          })
        )
      )
    );
    var hoursStr = this.intlMsg.msg('hours');
    var rightTools = [{
      type: 'buttons',
      buttons: [__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_InlineSelect__["a" /* default */], {
        options: [{
          label: "1 " + hoursStr,
          value: 1
        }, {
          label: "6 " + hoursStr,
          value: 6
        }, {
          label: "12 " + hoursStr,
          value: 12
        }, {
          label: "24 " + hoursStr,
          value: 24
        }, {
          label: "72 " + hoursStr,
          value: 72
        }],
        values: [this.state.queryHours],
        onChange: function onChange(selected) {
          _this3.setState({
            queryHours: selected[0]
          }, function () {
            _this3.loadNetworkAnalysisList();
          });
        }
      })]
    }];
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Toolbar__["a" /* default */], {
            brandTitle: this.intlMsg.msg('title'),
            rightTools: rightTools
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
            {
              bsStyle: "aisz-white",
              header: this.intlMsg.msg('deviceScatterHeader'),
              className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.panel
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12_loracoms_ShowIf__["a" /* default */],
              { "if": listStatus === 'pending' },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.loading },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_17_loraimages_chart_loading_gif___default.a, alt: "" })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_ScatterChart__["a" /* default */], {
              series: [{
                type: 'scatter',
                data: scatterData
              }],
              tooltip: {
                formatter: function formatter(obj) {
                  return "DevEUI: '" + obj.data[3] + "<br />\n                            " + _this3.intlMsg.msg('average') + "RSSI: " + obj.data[0] + "<br />\n                            " + _this3.intlMsg.msg('average') + "SNR: " + obj.data[1] + "<br />\n                            " + _this3.intlMsg.msg('loss') + ": " + obj.data[2] + "<br />";
                }
              },
              grid: {
                left: 50,
                top: 30,
                right: 40
              },
              xAxis: {
                name: 'RSSI',
                scale: true,
                splitLine: {
                  lineStyle: {
                    type: 'dashed'
                  }
                }
              },
              yAxis: {
                name: 'SNR',
                scale: true,
                splitLine: {
                  lineStyle: {
                    type: 'dashed'
                  }
                }
              },
              visualMap: [{
                orient: 'horizontal',
                align: 'left',
                dimension: 2,
                text: [this.intlMsg.msg('loss')],
                min: 0,
                max: 1,
                calculable: true,
                inRange: {
                  color: ['#50a3ba', '#eac736', '#d94e5d']
                }
              }]
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
            {
              bsStyle: "aisz-white",
              header: this.intlMsg.msg('packetHeatmapHeader'),
              className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.panel
            },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12_loracoms_ShowIf__["a" /* default */],
              { "if": heatStatus === 'pending' },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.loading },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_17_loraimages_chart_loading_gif___default.a, alt: "" })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_HeatmapChart__["a" /* default */], {
              tooltip: {
                formatter: function formatter() {
                  return '';
                }
              },
              series: [{
                type: 'heatmap',
                data: heatmapList,
                itemStyle: {
                  emphasis: {
                    borderColor: '#333',
                    borderWidth: 1
                  }
                },
                progressive: 1000,
                animation: false
              }],
              xAxis: {
                name: 'RSSI',
                type: 'category',
                data: heatmapX
              },
              yAxis: {
                name: 'SNR',
                type: 'category',
                data: heatmapY
              },
              visualMap: {
                text: [this.intlMsg.msg('density')],
                orient: 'horizontal',
                align: 'left',
                min: 0,
                max: 10,
                calculable: true,
                realtime: false,
                inRange: {
                  color: ['#313695', '#4575b4', '#74add1', '#abd9e9', '#e0f3f8', '#ffffbf', '#fee090', '#fdae61', '#f46d43', '#d73027', '#a50026']
                }
              },
              grid: {
                left: 50,
                top: 30,
                right: 40
              }
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
            {
              className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.overflowPanel,
              bsStyle: "aisz-white",
              header: this.intlMsg.msg('deviceListHeader')
            },
            listStatus === 'success' && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Table"],
              { className: "aisz-table-light", striped: true, hover: true, bordered: true, responsive: true },
              thead,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "tbody",
                null,
                deviceList.map(function (r, idx) {
                  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "tr",
                    { key: String(idx) },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "td",
                      null,
                      r.name
                    ),
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
                        { onClick: function onClick() {
                            return pushState("/network/quality/" + r.deveui);
                          } },
                        r.deveui
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "td",
                      null,
                      r.lorasnr_avg.toFixed(2)
                    ),
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "td",
                      null,
                      r.lorasnr_stddev.toFixed(2)
                    ),
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "td",
                      null,
                      r.rssi_avg.toFixed(2)
                    ),
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "td",
                      null,
                      r.rssi_stddev.toFixed(2)
                    ),
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "td",
                      null,
                      r.packet_lost,
                      " / ",
                      r.packet_total
                    ),
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "td",
                      null,
                      (r.packet_loss_rate * 100).toFixed(2),
                      "%"
                    )
                  );
                })
              )
            ),
            listStatus === 'pending' && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_loracoms_LoadingTable__["a" /* default */],
              { rows: 1, cols: 8, className: "aisz-table-light" },
              thead
            )
          )
        )
      )
    );
  };

  return QualityDeail;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

QualityDeail.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function () {
  return {};
}, { pushState: __WEBPACK_IMPORTED_MODULE_5_react_router_redux__["routerActions"].push })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(QualityDeail)));

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.node.isRequired
};

var QualityView = function QualityView(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    props.children
  );
};

QualityView.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (QualityView);

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_checkers_numbers__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_scss__ = __webpack_require__(2300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);











var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_react_intl__["intlShape"].isRequired,
  radius: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,
  showModal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  onConfirm: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};

var CoverageModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(CoverageModal, _React$Component);

  function CoverageModal(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CoverageModal);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      radius: props.radius,
      showModal: props.showModal,
      error: false
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.roadtest');
    _this.handleOnChange = _this.handleOnChange.bind(_this);
    return _this;
  }

  CoverageModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var showModal = nextProps.showModal,
        radius = nextProps.radius;

    if (showModal !== this.props.showModal) {
      this.setState({ showModal: showModal });
    }
    if (radius !== this.props.radius) {
      this.setState({ radius: radius });
    }
  };

  CoverageModal.prototype.handleOnChange = function handleOnChange(e) {
    var radius = _.trim(e.target.value);
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lorautils_checkers_numbers__["a" /* isNumber */])(radius)) {
      this.setState({ error: true });
    } else {
      this.setState({ error: false });
    }
    this.setState({ radius: radius });
  };

  CoverageModal.prototype.handleSubmit = function handleSubmit() {
    var _state = this.state,
        radius = _state.radius,
        error = _state.error;

    if (error) {
      return;
    }
    var _props = this.props,
        onHide = _props.onHide,
        onConfirm = _props.onConfirm;

    onConfirm(Number(radius));
    onHide();
  };

  CoverageModal.prototype.render = function render() {
    var _this2 = this;

    var _state2 = this.state,
        showModal = _state2.showModal,
        radius = _state2.radius,
        error = _state2.error;
    var onHide = this.props.onHide;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"],
      {
        show: showModal,
        bsClass: "aisz-modal-light"
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Header,
        { closeButton: true, onHide: onHide },
        this.intlMsg.msg('header.radius')
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Form"],
          { horizontal: true },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 3, className: __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.label },
              this.intlMsg.msg('radius.name')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["FormControl"], {
                value: radius,
                type: "number",
                placeholder: "radius",
                bsClass: "aisz-form-control-f",
                onChange: this.handleOnChange
              }),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_ControlTips__["a" /* default */], {
                show: error,
                message: this.intlMsg.msg('radius.invalid'),
                azStyle: "danger",
                placement: "top"
              })
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
              { md: 1, className: __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.label },
              "km"
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Footer,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-success",
            onClick: function onClick() {
              return _this2.handleSubmit();
            }
          },
          this.intlMsg.msg('radius.confirm')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-default",
            onClick: onHide,
            className: __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.white
          },
          this.intlMsg.msg('radius.cancel')
        )
      )
    );
  };

  return CoverageModal;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

CoverageModal.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(null, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(CoverageModal)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_SearchInput__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_TablePager__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_Checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loraactions_dashboard__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss__ = __webpack_require__(2301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);


















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  showModal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  checked: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array.isRequired
};

var defaultProps = {
  checked: []
};

var DeviceModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeviceModal, _React$Component);

  function DeviceModal(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeviceModal);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      showModal: props.showModal,
      lists: [],
      reset: 0,
      status: 'idle',
      checked: props.checked
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.dashboard');
    _this.handleSearch = _this.handleSearch.bind(_this);
    _this.handleCancel = _this.handleCancel.bind(_this);
    _this.handleChangeMark = _this.handleChangeMark.bind(_this);
    _this.mark = '';
    _this.q = null;
    return _this;
  }

  DeviceModal.prototype.componentWillMount = function componentWillMount() {
    var checked = JSON.parse(sessionStorage.getItem('device'));
    if (checked) {
      this.setState({ checked: checked });
    }
    this.loadData();
  };

  DeviceModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var showModal = nextProps.showModal;

    if (showModal !== this.props.showModal) {
      this.setState({ showModal: showModal });
      if (showModal) {
        this.loadData();
      }
    }
  };

  DeviceModal.prototype.componentWillUnmount = function componentWillUnmount() {
    this.loadData = null;
  };

  DeviceModal.prototype.loadData = function loadData() {
    var _this2 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lorautils_api__["a" /* callAPI */])({
      endpoint: '/lora/nodes',
      query: {
        q: this.q,
        mark: this.mark,
        limit: 10
      }
    }).then(function (data) {
      var list = data.list,
          more = data.more,
          mark = data.mark;

      _this2.setState({
        lists: list,
        status: 'success',
        more: more,
        mark: mark,
        noData: list.length === 0
      });
    }).catch(function () {
      _this2.setState({
        status: 'failure'
      });
    });
  };

  DeviceModal.prototype.isChecked = function isChecked(d) {
    var checked = this.state.checked;

    return _.some(checked, { id: d.id });
  };

  DeviceModal.prototype.toggleCheck = function toggleCheck(d) {
    var checked = this.state.checked;

    if (this.isChecked(d)) {
      checked = _.filter(checked, function (c) {
        return c.id !== d.id;
      });
    } else {
      checked = _.concat(checked, [d]);
    }
    this.setState({ checked: checked });
  };

  DeviceModal.prototype.handleSearch = function handleSearch(e) {
    var search = e.target.value;
    this.setState({
      search: search,
      reset: new Date()
    });
    this.mark = '';

    if (search.length > 0) {
      var s = search.replace(/[:-]/g, '');
      this.q = "or,name:*" + s + "*,deveui:*" + s + "*,devaddr:*" + s + "*,appIdeui:" + s + "*,city:*" + s + "*,area:*" + s + "*,band:*" + s + "*";
      this.loadData();
    } else {
      this.q = null;
      this.loadData();
    }
  };

  DeviceModal.prototype.handleSubmit = function handleSubmit() {
    var _props = this.props,
        onHide = _props.onHide,
        onSelect = _props.onSelect;
    var checked = this.state.checked;

    onHide();
    onSelect(checked);

    this.mark = '';
    this.q = null;
    this.setState({ search: '', reset: new Date() });
  };

  DeviceModal.prototype.handleChangeMark = function handleChangeMark(mark) {
    this.mark = mark;
    this.loadData();
  };

  DeviceModal.prototype.handleCancel = function handleCancel() {
    this.mark = '';
    this.q = null;
    this.setState({ search: '', reset: new Date(), checked: [] });
    this.props.onHide();
  };

  DeviceModal.prototype.render = function render() {
    var _this3 = this;

    var _state = this.state,
        showModal = _state.showModal,
        _state$search = _state.search,
        search = _state$search === undefined ? '' : _state$search,
        _state$mark = _state.mark,
        mark = _state$mark === undefined ? '' : _state$mark,
        _state$more = _state.more,
        more = _state$more === undefined ? false : _state$more,
        reset = _state.reset,
        status = _state.status,
        lists = _state.lists,
        _state$noData = _state.noData,
        noData = _state$noData === undefined ? false : _state$noData;

    var rows = _.map(lists, function (item) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        { key: item.id },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.checkbox },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_Checkbox__["a" /* default */], {
              id: item.id,
              checked: _this3.isChecked(item),
              onChange: function onChange() {
                return _this3.toggleCheck(item);
              }
            }),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("label", { htmlFor: item.id })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          item.name
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_lorautils_IdUtils__["a" /* normalizeDevEUI */])(item.deveui)
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_10_date_fns_format___default()(item.createdAt, 'YYYY-MM-DD HH:mm:ss')
        )
      );
    });
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"],
      {
        show: showModal,
        bsClass: "aisz-modal-light",
        onHide: this.handleCancel
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_SearchInput__["a" /* default */], {
          onChange: this.handleSearch,
          value: search,
          placeholder: this.intlMsg.msg('search.placeholder')
        })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Body,
        { className: "clearfix", styleName: "modalbody" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Table"],
          {
            className: "aisz-table-light", striped: true, hover: true, bordered: true, responsive: true
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("th", null),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('addmodal.name')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('addmodal.deveui')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('addmodal.createdAt')
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tbody",
            null,
            rows
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_15_loracoms_ShowIf__["a" /* default */],
          { "if": noData },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: "text-center" },
            this.intlMsg.msg('adddevice.nodata')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "pull-right" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_TablePager__["a" /* default */], {
            status: status,
            mark: mark,
            more: more,
            onPrev: this.handleChangeMark,
            onNext: this.handleChangeMark,
            reset: reset
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Footer,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-success",
            onClick: function onClick() {
              return _this3.handleSubmit();
            }
          },
          this.intlMsg.msg('confirm')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-default",
            onClick: this.handleCancel,
            className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.white
          },
          this.intlMsg.msg('cancel')
        )
      )
    );
  };

  return DeviceModal;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DeviceModal.propTypes = propTypes;
DeviceModal.defaultProps = defaultProps;

var mapDispatchToProps = {
  getDeveui: __WEBPACK_IMPORTED_MODULE_16_loraactions_dashboard__["a" /* default */].getDeveui
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_6_react_css_modules___default()(DeviceModal, __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a, { allowMultiple: true }))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_InlineSelect__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loraactions_roadtest__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_green_svg__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_green_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__images_green_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_red_svg__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_red_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__images_red_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_yellow_svg__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_yellow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__images_yellow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__images_orange_svg__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__images_orange_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__images_orange_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__images_higher_svg__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__images_higher_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__images_higher_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__styles_scss__ = __webpack_require__(2302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__styles_scss__);







/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object.isRequired,
  showGpsModal: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
  getGpsColor: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
  colorState: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object.isRequired
};

var kDps = ['snr', 'rssi'];

var GpsColor = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(GpsColor, _React$Component);

  function GpsColor(props) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, GpsColor);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    var _props$colorState = props.colorState,
        green = _props$colorState.green,
        yellow = _props$colorState.yellow,
        red = _props$colorState.red,
        type = _props$colorState.type;

    _this.state = {
      showGpsModal: props.showGpsModal,
      touched: new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(),
      by: type,
      errors: __WEBPACK_IMPORTED_MODULE_16_lorautils_errors_ErrorSet__["a" /* default */].createEmpty(),
      green: green,
      yellow: yellow,
      red: red
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.dashboard');
    _this.handleSession = _this.handleSession.bind(_this);
    return _this;
  }

  GpsColor.prototype.componentWillMount = function componentWillMount() {
    this.handleValue();
  };

  GpsColor.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var showGpsModal = nextProps.showGpsModal;

    if (showGpsModal !== this.props.showGpsModal) {
      this.setState({ showGpsModal: showGpsModal });
    }
  };

  GpsColor.prototype.handleValue = function handleValue() {
    var _ref = JSON.parse(sessionStorage.getItem('roadtest')) || {},
        icon = _ref.icon;

    var defaultValue = { min: null, max: null };

    if (icon) {
      this.props.getGpsColor(icon);
      var green = icon.green || defaultValue;
      var yellow = icon.yellow || defaultValue;
      var red = icon.red || defaultValue;
      var by = icon.type || kDps[0];
      this.setState({ green: green,
        yellow: yellow,
        red: red,
        by: by,
        errors: __WEBPACK_IMPORTED_MODULE_16_lorautils_errors_ErrorSet__["a" /* default */].createEmpty()
      });
    }
  };

  GpsColor.prototype.touchAll = function touchAll() {
    var touched = this.state.touched;

    this.setState({
      touched: touched.add('green.min').add('green.max').add('yellow.min').add('yellow.max').add('red.min').add('red.max')
    });
  };

  GpsColor.prototype.handleChangeBy = function handleChangeBy(by) {
    this.setState({ by: by });
    var green = {};
    var yellow = {};
    var red = {};

    if (by === 'rssi') {
      green = { min: '-95', max: '-60' };
      yellow = { min: '-105', max: '-95' };
      red = { min: '-115', max: '-105' };
    } else if (by === 'snr') {
      green = { min: '0', max: '30' };
      yellow = { min: '-5', max: '0' };
      red = { min: '-10', max: '-5' };
    }
    this.setState({ green: green, yellow: yellow, red: red, by: by });
  };

  GpsColor.prototype.handleChangeMin = function handleChangeMin(e, key) {
    var _setState;

    var _state = this.state,
        errors = _state.errors,
        touched = _state.touched;

    var values = this.state[key];
    var min = e.target.value;
    if (min.length === 0) {
      this.setState({
        errors: errors.add('FE_EMPTY', key + ".min")
      });
    } else {
      var max = values.max;
      if (!_.isNil(max) && Number(min) > Number(max)) {
        this.setState({
          errors: errors.add('FE_WRONG_MIN', key + ".min"),
          touched: touched.add(key + ".min")
        });
      } else {
        this.setState({ errors: errors.remove(key + ".min") });
      }
    }
    values = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, values, { min: min });
    this.setState((_setState = {}, _setState[key] = values, _setState));
  };

  GpsColor.prototype.handleChangeMax = function handleChangeMax(e, key) {
    var _setState2;

    var _state2 = this.state,
        errors = _state2.errors,
        touched = _state2.touched;

    var values = this.state[key];
    var max = e.target.value;
    if (max.length === 0) {
      this.setState({
        errors: errors.add('FE_EMPTY', key + ".max")
      });
    } else {
      var min = values.min;
      if (!_.isNil(min) && Number(max) < Number(min)) {
        this.setState({
          errors: errors.add('FE_WRONG_MAX', key + ".max"),
          touched: touched.add(key + ".max")
        });
      } else {
        this.setState({ errors: errors.remove(key + ".max") });
      }
    }
    values = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, values, { max: max });
    this.setState((_setState2 = {}, _setState2[key] = values, _setState2));
  };

  GpsColor.prototype.handleOnHide = function handleOnHide() {
    this.handleValue();
    this.setState({ touched: new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a() });
    this.props.onHide();
  };

  GpsColor.prototype.handleOnSubmit = function handleOnSubmit() {
    var _state3 = this.state,
        errors = _state3.errors,
        green = _state3.green,
        yellow = _state3.yellow,
        red = _state3.red,
        by = _state3.by;
    var _props = this.props,
        onHide = _props.onHide,
        getGpsColor = _props.getGpsColor;

    this.touchAll();
    if (!errors.isEmpty()) {
      return;
    }
    var icon = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, { green: green, yellow: yellow, red: red, type: by });
    onHide();
    getGpsColor(icon);
    this.handleSession(icon);
  };

  GpsColor.prototype.handleSession = function handleSession(icon) {
    var roadtest = JSON.parse(sessionStorage.getItem('roadtest')) || {};
    roadtest = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, roadtest, { icon: icon });
    sessionStorage.setItem('roadtest', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(roadtest));
  };

  GpsColor.prototype.render = function render() {
    var _this2 = this;

    var _state4 = this.state,
        _state4$showGpsModal = _state4.showGpsModal,
        showGpsModal = _state4$showGpsModal === undefined ? false : _state4$showGpsModal,
        by = _state4.by,
        errors = _state4.errors,
        green = _state4.green,
        yellow = _state4.yellow,
        red = _state4.red,
        touched = _state4.touched;
    var onHide = this.props.onHide;

    var options = _.map(kDps, function (item) {
      return {
        label: item,
        value: item
      };
    });

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Modal"],
      {
        show: showGpsModal,
        onHide: onHide,
        bsClass: "aisz-modal-light"
      },
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Modal"].Body,
        { styleName: "input-area" },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Row"],
          { styleName: "row-m" },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Col"],
            { md: 2 },
            this.intlMsg.msg('gps.colorset.title1')
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Col"],
            { md: 10 },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_InlineSelect__["a" /* default */], {
              bsStyle: "aisz-primary",
              options: options,
              values: [by],
              onChange: function onChange(selected) {
                return _this2.handleChangeBy(selected[0]);
              }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Row"],
          { styleName: "row-m" },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Col"],
            { md: 2 },
            this.intlMsg.msg('gps.colorset.title2')
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Col"],
            { md: 10 },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("i", {
              className: "fa fa-exclamation-circle",
              styleName: "tip-icon gray"
            }),
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              "span",
              { styleName: "tip gray" },
              this.intlMsg.msg('gps.colorset.tip')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Row"],
          { styleName: "row-m gray" },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Col"],
            { md: 1, mdOffset: 2 },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_22__images_higher_svg___default.a, alt: "default Icon", width: "25" })
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Col"],
            { md: 3, styleName: "line-h " },
            this.intlMsg.msg('gps.colorset.higher')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Row"],
          { styleName: "row-m gray" },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Col"],
            { md: 1, mdOffset: 2 },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_18__images_green_svg___default.a, alt: "Green Icon", width: "25" })
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Col"],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["FormControl"], {
              value: green.min,
              type: "number",
              className: "aisz-form-control-f",
              placeholder: "\u6700\u5C0F\u503C",
              onChange: function onChange(e) {
                return _this2.handleChangeMin(e, 'green');
              }
            }),
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_ControlTips__["a" /* default */], {
              show: touched.has('green.min') && errors.has('green.min'),
              message: this.intlMsg.errorMsg(errors.get('green.min')),
              azStyle: "danger",
              placement: "top"
            })
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            "span",
            { className: "pull-left" },
            "-"
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Col"],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["FormControl"], {
              value: green.max,
              type: "number",
              className: "aisz-form-control-f",
              placeholder: "\u6700\u5927\u503C",
              onChange: function onChange(e) {
                return _this2.handleChangeMax(e, 'green');
              }
            }),
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_ControlTips__["a" /* default */], {
              show: touched.has('green.max') && errors.has('green.max'),
              message: this.intlMsg.errorMsg(errors.get('green.max')),
              azStyle: "danger",
              placement: "top"
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Row"],
          { styleName: "row-m gray" },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Col"],
            { md: 1, mdOffset: 2 },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_20__images_yellow_svg___default.a, alt: "Green Icon", width: "25" })
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Col"],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["FormControl"], {
              value: yellow.min,
              type: "number",
              className: "aisz-form-control-f",
              placeholder: "\u6700\u5C0F\u503C",
              onChange: function onChange(e) {
                return _this2.handleChangeMin(e, 'yellow');
              }
            }),
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_ControlTips__["a" /* default */], {
              show: touched.has('yellow.min') && errors.has('yellow.min'),
              message: this.intlMsg.errorMsg(errors.get('yellow.min')),
              azStyle: "danger",
              placement: "top"
            })
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            "span",
            { className: "pull-left" },
            "-"
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Col"],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["FormControl"], {
              value: yellow.max,
              type: "number",
              className: "aisz-form-control-f",
              placeholder: "\u6700\u5927\u503C",
              onChange: function onChange(e) {
                return _this2.handleChangeMax(e, 'yellow');
              }
            }),
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_ControlTips__["a" /* default */], {
              show: touched.has('yellow.max') && errors.has('yellow.max'),
              message: this.intlMsg.errorMsg(errors.get('yellow.max')),
              azStyle: "danger",
              placement: "top"
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Row"],
          { styleName: "row-m gray" },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Col"],
            { md: 1, mdOffset: 2 },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_21__images_orange_svg___default.a, alt: "Green Icon", width: "25" })
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Col"],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["FormControl"], {
              value: red.min,
              type: "number",
              className: "aisz-form-control-f",
              placeholder: "\u6700\u5C0F\u503C",
              onChange: function onChange(e) {
                return _this2.handleChangeMin(e, 'red');
              }
            }),
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_ControlTips__["a" /* default */], {
              show: touched.has('red.min') && errors.has('red.min'),
              message: this.intlMsg.errorMsg(errors.get('red.min')),
              azStyle: "danger",
              placement: "top"
            })
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            "span",
            { className: "pull-left" },
            "-"
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Col"],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["FormControl"], {
              value: red.max,
              type: "number",
              className: "aisz-form-control-f",
              placeholder: "\u6700\u5927\u503C",
              onChange: function onChange(e) {
                return _this2.handleChangeMax(e, 'red');
              }
            }),
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_ControlTips__["a" /* default */], {
              show: touched.has('red.max') && errors.has('red.max'),
              message: this.intlMsg.errorMsg(errors.get('red.max')),
              azStyle: "danger",
              placement: "top"
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Row"],
          { styleName: "row-m gray" },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Col"],
            { md: 1, mdOffset: 2 },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_19__images_red_svg___default.a, alt: "default Icon", width: "25" })
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Col"],
            { md: 3, styleName: "line-h " },
            this.intlMsg.msg('gps.colorset.other')
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Modal"].Footer,
        null,
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Button"],
          { bsStyle: "aisz-success", onClick: function onClick() {
              return _this2.handleOnSubmit();
            } },
          this.intlMsg.msg('confirm')
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-default",
            styleName: "font-white",
            onClick: function onClick() {
              return _this2.handleOnHide();
            }
          },
          this.intlMsg.msg('cancel')
        )
      )
    );
  };

  return GpsColor;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

GpsColor.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    colorState: state.roadtest.getGpsColor
  };
};

var mapDispatchToProps = {
  getGpsColor: __WEBPACK_IMPORTED_MODULE_17_loraactions_roadtest__["a" /* default */].getGpsColor
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_9_react_css_modules___default()(GpsColor, __WEBPACK_IMPORTED_MODULE_23__styles_scss___default.a, { allowMultiple: true }))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return kAK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return kOptsLg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return kOptsSm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return kDlKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return kheader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return kTimeFormat; });
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

var kAK = 'sKOR1iZ8dB2Ry3o7NjIQaBa0LGA40vY5';

var kOptsLg = {
  title: '',
  width: 300,
  enableMessage: true
};

var kOptsSm = {
  title: '',
  width: 100,
  enableMessage: true
};

var kDlKeys = ['nodeid', 'name', 'metrics.snr', 'metrics.rssi', 'metrics.lng', 'metrics.lat', 'timestamp'];

var kheader = {
  en: {
    nodeid: 'DEVEUI',
    'metrics.snr': 'SNR',
    'metrics.rssi': 'RSSI',
    'metrics.lng': 'Longitude',
    'metrics.lat': 'Latitude',
    timestamp: 'Time',
    name: 'Name'
  },
  zh: {
    nodeid: 'DEVEUI',
    'metrics.snr': 'SNR',
    'metrics.rssi': 'RSSI',
    'metrics.lng': '经度',
    'metrics.lat': '纬度',
    timestamp: '时间',
    name: '名称'
  }
};

var kTimeFormat = {
  zh: 'YYYY-MM-DD HH:mm:ss',
  en: 'MM/DD/YYYY HH:mm:ss'
};

/* unused harmony default export */ var _unused_webpack_default_export = ({
  kAK: kAK,
  kOptsLg: kOptsLg,
  kOptsSm: kOptsSm,
  kDlKeys: kDlKeys,
  kheader: kheader,
  kTimeFormat: kTimeFormat
});

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_map__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_gateway__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lorautils_csvdl__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_WarningModal__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__consts__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_green_svg__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_green_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__images_green_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_red_svg__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_red_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__images_red_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_yellow_svg__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_yellow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__images_yellow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__images_default_svg__ = __webpack_require__(2790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__images_default_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__images_default_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__images_orange_svg__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__images_orange_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__images_orange_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__images_higher_svg__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__images_higher_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__images_higher_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__images_connected_svg__ = __webpack_require__(2789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__images_connected_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__images_connected_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__images_disconnected_svg__ = __webpack_require__(2791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__images_disconnected_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__images_disconnected_svg__);






/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);
























var defaultProps = {
  onZoom: function onZoom() {},
  onDrag: function onDrag() {}
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired,
  time: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired,
  radius: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number.isRequired,
  startDwnld: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number.isRequired,
  colorState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired,
  deviceState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array.isRequired,
  gatewayState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array.isRequired,
  updateState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any.isRequired,
  onZoom: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onDrag: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var GpsMap = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(GpsMap, _React$Component);

  GpsMap.gatewayInfo = function gatewayInfo(gw) {
    return "<div style=\"font-size:13px;\">\n          <p>" + gw.name + "</p>\n      </div>";
  };

  GpsMap.info = function info(obj, map) {
    var content = '';
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(obj.metrics).forEach(function (key) {
      content += " <div class=\"row text-left\"\n                style=\"line-height:20px;border-bottom:1px solid #eee;\">\n              <div class=\"col-md-3 col-md-offset-3\">" + key + "</div>\n              <div class=\"col-md-3\">" + obj.metrics[key] + "</div>\n            </div>";
    });
    return "\n<div style=\"font-size:13px;\">\n  <p class=\"clearfix\">\n    <span class=\"pull-left\">" + map[obj.nodeid] + "</span>\n    <span class=\"pull-right\" style=\"margin-right: 10px;\">" + obj.name + " " + __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(obj.timestamp, 'MM-DD HH:mm:ss') + "</span>\n  </p>\n  " + content + "\n</div>\n";
  };

  function GpsMap(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, GpsMap);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      colorState: props.colorState,
      showModal: false
    };
    _this.device = props.deviceState;
    _this.deviceMap = {};
    _this.markers = [];
    _this.listeners = [];
    _this.time = props.time;
    _this.mapPoints = [];
    _this.fetchPoints = {};
    _this.transPoints = [];
    _this.isTransform = false;
    _this.gateway = props.gatewayState || [];
    _this.radius = props.radius;
    _this.gatewayMarker = [];
    _this.ovals = [];
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.dashboard');
    _this.limit = 10;
    return _this;
  }

  GpsMap.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    _.forEach(this.device, function (d) {
      if (d.deveui) {
        _this2.deviceMap[d.deveui] = d.name;
      }
    });
  };

  GpsMap.prototype.componentDidMount = function componentDidMount() {
    var _this3 = this;

    var tries = 0;
    var init = function init() {
      try {
        _this3.initMap();
        _this3.handleCircle();
      } catch (e) {
        if (tries < 10) {
          tries += 1;
          setTimeout(init, 1000);
        }
      }
    };
    init();
  };

  GpsMap.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this4 = this;

    var time = nextProps.time,
        colorState = nextProps.colorState,
        deviceState = nextProps.deviceState,
        gatewayState = nextProps.gatewayState,
        radius = nextProps.radius,
        updateState = nextProps.updateState,
        startDwnld = nextProps.startDwnld;


    if (!_.isEqual(time, this.props.time)) {
      this.time = time;
      this.refresh = false;
      this.mapPoints = [];
      this.clearMarker();
      this.loadData();
    }
    if (!_.isEqual(colorState, this.props.colorState)) {
      this.setState({ colorState: colorState }, function () {
        _this4.updateData('refresh');
      });
    }

    if (!_.isEmpty(deviceState) && !_.isEqual(deviceState, this.props.deviceState)) {
      this.device = _.filter(deviceState, function (d) {
        if (d.deveui) {
          _this4.deviceMap[d.deveui] = d.name;
        }
        return !_.isEmpty(d);
      });
      this.refresh = false;
      this.mapPoints = [];
      this.fetchPoints = {};
      this.clearMarker();
      this.loadData();
    }

    if (!_.isEqual(gatewayState, this.props.gatewayState)) {
      this.gateway = gatewayState;
      this.handleCircle();
    }
    if (radius !== this.props.radius) {
      this.radius = radius;
      this.handleCircle();
    }
    if (updateState !== this.props.updateState) {
      this.refresh = true;
      this.loadData();
    }

    if (startDwnld !== this.props.startDwnld) {
      this.handleDownload();
    }
  };

  GpsMap.prototype.componentWillUnmount = function componentWillUnmount() {
    _.map(_.zip(this.markers, this.listeners), function (_ref) {
      var marker = _ref[0],
          listener = _ref[1];

      marker.removeEventListener('click', listener);
    });
    $('#gpsmap').empty();
  };

  GpsMap.prototype.initMap = function initMap() {
    var _this5 = this;

    this.map = new BMap.Map('gpsmap');
    this.map.setMapStyle({ features: [] });
    this.map.setMaxZoom(19);
    this.map.setMinZoom(2);
    this.map.enableScrollWheelZoom();
    this.map.removeControl(this.navControl);
    this.map.removeControl(this.scaleControl);
    // eslint-disable-next-line
    this.navControl = new BMap.NavigationControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });
    // eslint-disable-next-line
    this.scaleControl = new BMap.ScaleControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });

    this.map.addControl(this.navControl);
    this.map.addControl(this.scaleControl);
    this.map.addEventListener('zoomend', function () {
      return _this5.props.onZoom(_this5.map);
    });
    this.map.addEventListener('dragend', function () {
      return _this5.props.onDrag(_this5.map);
    });

    this.map.centerAndZoom('深圳', 1);

    if (this.map) {
      this.loadData();
    }
  };

  GpsMap.prototype.loadData = function loadData() {
    var _this6 = this;

    if (!_.isEmpty(this.device)) {
      var from = this.time.from;

      var to = this.refresh ? new Date() : this.time.to;
      var promises = [];

      _.forEach(this.device, function (d) {
        if (d.deveui) {
          var p = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__api_callAPI__["a" /* default */])({
            endpoint: '/lora/timeseries',
            method: 'POST',
            body: { nodeid: d.deveui, dps: ['snr', 'rssi', 'lat', 'lng'], from: from, to: to, limit: 1000 }
          });
          promises.push(p);
        }
      });

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises).then(function (res) {
        _.forEach(res, function (r) {
          _this6.mapPoints = _.concat(_this6.mapPoints, r.list || []);
        });

        // save previous dps to compare with update dps when refresh
        _.forEach(_this6.mapPoints, function (l) {
          if (!_this6.fetchPoints[l.nodeid]) {
            _this6.fetchPoints[l.nodeid] = {};
          }
          _this6.fetchPoints[l.nodeid][l.timestamp] = l;
        });

        if (_this6.refresh) {
          _this6.mapPoints = _.filter(_this6.mapPoints, function (l) {
            return !_this6.fetchPoints[l.nodeid] || !_this6.fetchPoints[l.nodeid][l.timestamp];
          });
        }
        _this6.updateData('transform');
      }).catch(function () {});
    }
  };

  GpsMap.prototype.updateData = function updateData(type) {
    var _this7 = this;

    this.transPoints = type === 'transform' ? [] : this.transPoints;
    this.transCoords(type, function (p, res, symbol) {
      if (type === 'transform' && res.status === 0) {
        _this7.isTransform = true;
        var coords = res.result;

        var ps = p;
        ps = ps.map(function (item, idx) {
          if (coords[idx]) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
              point: new BMap.Point(coords[idx].x, coords[idx].y)
            });
          }
          return null;
        });
        _this7.transPoints = _.concat(_this7.transPoints, ps);
        ps.forEach(function (obj) {
          _this7.addMarker(obj);
        });

        var points = ps.map(function (x) {
          return x.point;
        });
        if (points.length === 1 && (!_this7.refresh || _this7.map.getZoom() <= 3)) {
          _this7.map.centerAndZoom(points[0], 16);
        } else if (points.length > 0 && (!_this7.refresh || _this7.map.getZoom() <= 3)) {
          // decide max span with at most 100 points
          var _getCenterAndZoom = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lorautils_map__["a" /* getCenterAndZoom */])(points),
              center = _getCenterAndZoom[0],
              zoom = _getCenterAndZoom[1];

          if (!symbol && _this7.map.getZoom() <= 3) {
            _this7.map.centerAndZoom(center, zoom);
          }
        } else if (!_this7.refresh) {
          _this7.map.centerAndZoom('深圳', 1);
        }
      } else if (type === 'refresh' && _this7.isTransform) {
        _this7.clearMarker();
        _this7.transPoints.forEach(function (obj) {
          _this7.addMarker(obj);
        });
      } else {
        _this7.map.centerAndZoom('深圳', 1);
      }
    });
  };

  GpsMap.prototype.handleDownload = function handleDownload() {
    var _this8 = this;

    var _props$intl$locale = this.props.intl.locale,
        locale = _props$intl$locale === undefined ? 'zh' : _props$intl$locale;

    if (this.mapPoints.length) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_lorautils_csvdl__["a" /* default */])(this.mapPoints, __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(new Date(), 'YYYYMMDDHHmmss') + ".csv", __WEBPACK_IMPORTED_MODULE_17__consts__["a" /* kDlKeys */], __WEBPACK_IMPORTED_MODULE_17__consts__["b" /* kheader */][locale], {
        timestamp: function timestamp(row) {
          return __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(row.timestamp, __WEBPACK_IMPORTED_MODULE_17__consts__["c" /* kTimeFormat */][locale]);
        },
        name: function name(row) {
          return _this8.deviceMap[row.nodeid];
        }
      });
    } else {
      this.setState({ showModal: true });
    }
  };

  GpsMap.prototype.handleCircle = function handleCircle() {
    var _this9 = this;

    if (this.gateway.length) {
      _.forEach(_.concat(this.ovals, this.gatewayMarker), function (l) {
        return _this9.map.removeOverlay(l);
      });
      this.gatewayMarker = [];
      this.ovals = [];

      _.forEach(this.gateway, function (gw) {
        var lastOn = gw.lastOn,
            lastOff = gw.lastOff,
            lat = gw.lat,
            lng = gw.lng;

        var gatewayImg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_gateway__["a" /* isConnected */])(lastOn, lastOff) ? __WEBPACK_IMPORTED_MODULE_24__images_connected_svg___default.a : __WEBPACK_IMPORTED_MODULE_25__images_disconnected_svg___default.a;

        if (!_.isNil(lat) && !_.isNil(lng)) {
          var point = new BMap.Point(lng, lat);
          var icon = new BMap.Icon(gatewayImg, new BMap.Size(20, 20));
          var marker = new BMap.Marker(point, { icon: icon });
          var oval = new BMap.Polygon(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lorautils_map__["b" /* drawOval */])(point, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lorautils_map__["c" /* calLng */])(_this9.radius), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lorautils_map__["d" /* calLat */])(_this9.radius)), {
            strokeColor: '#f89406',
            strokeWeight: 1,
            strokeOpacity: 1,
            fillColor: 'rgba(255,255,255,0.1)'
          });

          marker.addEventListener('click', function () {
            var info = GpsMap.gatewayInfo(gw);
            var infoWin = new BMap.InfoWindow(info, __WEBPACK_IMPORTED_MODULE_17__consts__["d" /* kOptsSm */]);
            _this9.map.openInfoWindow(infoWin, point);
          });
          _this9.gatewayMarker.push(marker);
          _this9.ovals.push(oval);
        }
      });

      _.forEach(_.concat(this.ovals, this.gatewayMarker), function (l) {
        return _this9.map.addOverlay(l);
      });
      if (this.gatewayMarker.length) {
        var _getCenterAndZoom2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lorautils_map__["a" /* getCenterAndZoom */])([this.gatewayMarker]),
            center = _getCenterAndZoom2[0],
            zoom = _getCenterAndZoom2[1];

        this.map.centerAndZoom(center, zoom);
      }
    }
  };

  GpsMap.prototype.transCoords = function transCoords(type, callback) {
    var _this10 = this;

    if (type === 'transform') {
      var tobeTrans = [];
      var index = 0;

      // if refresh
      this.mapPoints = this.mapPoints.filter(function (device) {
        var _device$metrics = device.metrics,
            _device$metrics$lat = _device$metrics.lat,
            lat = _device$metrics$lat === undefined ? '' : _device$metrics$lat,
            _device$metrics$lng = _device$metrics.lng,
            lng = _device$metrics$lng === undefined ? '' : _device$metrics$lng;

        return lat && lng && lat !== '' && lng !== '' && lng !== '0' && lat !== '0' && Number(lng) >= -180 && Number(lng) <= 180 && Number(lat) >= -90 && Number(lat) <= 90;
      });

      this.maxCount = Math.ceil(this.mapPoints.length / 100);

      if (this.mapPoints.length) {
        for (var i = 0; i < this.maxCount; i += 1) {
          var temp = this.mapPoints.slice(i * 100, (i + 1) * 100);
          tobeTrans.push(temp);
        }

        var loop = function loop() {
          if (index < _this10.maxCount) {
            var arr = tobeTrans[index];
            if (arr.length) {
              var coords = arr.map(function (device) {
                var _device$metrics2 = device.metrics,
                    lng = _device$metrics2.lng,
                    lat = _device$metrics2.lat;

                return lng + "," + lat;
              }).join(';');
              $.ajax({
                url: "https://api.map.baidu.com/geoconv/v1/?coords=" + coords + "&from=1&to=5&ak=" + __WEBPACK_IMPORTED_MODULE_17__consts__["e" /* kAK */] + "&callback=?",
                dataType: 'jsonp',
                success: function success(res) {
                  var symbol = index !== 0;
                  callback(arr, res, symbol);
                  index += 1;
                  loop();
                }
              });
            }
          }
        };
        loop();
      } else if (!this.refresh) {
        this.map.centerAndZoom('深圳', 1);
      }
    } else if (type === 'refresh') {
      callback();
    }
  };

  GpsMap.prototype.addMarker = function addMarker(item) {
    var _this11 = this;

    var _state$colorState = this.state.colorState,
        type = _state$colorState.type,
        green = _state$colorState.green,
        yellow = _state$colorState.yellow,
        red = _state$colorState.red;

    var img = __WEBPACK_IMPORTED_MODULE_21__images_default_svg___default.a;
    var crtVal = Number(item.metrics[type]);
    try {
      if (crtVal > Number(green.max)) {
        img = __WEBPACK_IMPORTED_MODULE_23__images_higher_svg___default.a;
      } else if (crtVal >= Number(green.min) && crtVal <= Number(green.max)) {
        img = __WEBPACK_IMPORTED_MODULE_18__images_green_svg___default.a;
      } else if (crtVal >= Number(yellow.min) && crtVal <= Number(yellow.max)) {
        img = __WEBPACK_IMPORTED_MODULE_20__images_yellow_svg___default.a;
      } else if (crtVal >= Number(red.min) && crtVal <= Number(red.max)) {
        img = __WEBPACK_IMPORTED_MODULE_22__images_orange_svg___default.a;
      } else if (crtVal < Number(red.min)) {
        img = __WEBPACK_IMPORTED_MODULE_19__images_red_svg___default.a;
      }
    } catch (err) {
      //  nothing to do width err
    }
    var openInfo = function openInfo() {
      var info = GpsMap.info(item, _this11.deviceMap);
      var infoWin = new BMap.InfoWindow(info, __WEBPACK_IMPORTED_MODULE_17__consts__["f" /* kOptsLg */]);
      _this11.map.openInfoWindow(infoWin, item.point);
    };
    var icon = new BMap.Icon(img, new BMap.Size(48, 48));
    var marker = new BMap.Marker(item.point, { icon: icon });
    marker.addEventListener('click', openInfo);

    this.map.addOverlay(marker);
    this.markers.push(marker);
    this.listeners.push(openInfo);
  };

  GpsMap.prototype.clearMarker = function clearMarker() {
    var _this12 = this;

    this.markers.forEach(function (marker) {
      _this12.map.removeOverlay(marker);
    });
  };

  GpsMap.prototype.render = function render() {
    var _this13 = this;

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      "div",
      { style: { height: '100%', width: '100%' } },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div", { id: "gpsmap", style: { height: '100%', width: '100%' } }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_WarningModal__["a" /* default */], {
        showModal: this.state.showModal,
        onHide: function onHide() {
          return _this13.setState({ showModal: false });
        },
        text: this.intlMsg.msg('download.nodata'),
        header: this.intlMsg.msg('download.header')
      })
    );
  };

  return GpsMap;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

GpsMap.defaultProps = defaultProps;
GpsMap.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    time: state.roadtest.getTimes,
    colorState: state.roadtest.getGpsColor,
    deviceState: state.roadtest.getDevice,
    gatewayState: state.roadtest.getGateway,
    radius: state.roadtest.getRadius,
    startDwnld: state.roadtest.startDwnld,
    updateState: state.roadtest.updateGps
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["connect"])(mapStateToProps, null)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_intl__["injectIntl"])(GpsMap)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loraactions_roadtest__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_SelectGatewayModal__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_Refresher__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__CoverageModal__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DeviceModal__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__TimeSelect__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__GpsColor__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_scss__ = __webpack_require__(2303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__styles_scss__);





/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_11_react_intl__["intlShape"].isRequired,
  getDevice: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  getGateway: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  getGpsColor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  getRadius: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  updateGps: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  startDwnld: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired
};

var Header = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Header, _React$Component);

  function Header(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Header);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      showDeviceModal: false,
      gateway: []
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_13_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.roadtest');
    _this.handleSelectDevice = _this.handleSelectDevice.bind(_this);
    _this.handleSelectGw = _this.handleSelectGw.bind(_this);
    _this.handleRadius = _this.handleRadius.bind(_this);
    return _this;
  }

  Header.prototype.componentWillMount = function componentWillMount() {
    this.handleSession();
  };

  Header.prototype.handleSelectDevice = function handleSelectDevice(device) {
    var roadtest = JSON.parse(sessionStorage.getItem('roadtest')) || {};
    roadtest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, roadtest, { device: device });

    this.setState({ device: device });
    sessionStorage.setItem('roadtest', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(roadtest));
    this.props.getDevice(device);
  };

  Header.prototype.handleSelectGw = function handleSelectGw() {
    var gateway = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var roadtest = JSON.parse(sessionStorage.getItem('roadtest')) || {};
    roadtest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, roadtest, { gateway: gateway });

    this.props.getGateway(gateway);
    this.setState({ gateway: gateway, showGatewayModal: false });
    sessionStorage.setItem('roadtest', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(roadtest));
  };

  Header.prototype.handleSession = function handleSession() {
    var _props = this.props,
        getDevice = _props.getDevice,
        getGpsColor = _props.getGpsColor,
        getGateway = _props.getGateway,
        getRadius = _props.getRadius;

    var roadtest = JSON.parse(sessionStorage.getItem('roadtest')) || {};
    var device = roadtest.device,
        icon = roadtest.icon,
        gateway = roadtest.gateway,
        radius = roadtest.radius;


    if (!_.isNil(device)) {
      this.setState({ device: device });
      getDevice(device);
    }
    if (!_.isNil(icon)) {
      getGpsColor(icon);
    }
    if (!_.isNil(gateway)) {
      getGateway(gateway);
      this.setState({ gateway: gateway });
    }
    if (!_.isNil(radius)) {
      this.setState({ radius: radius });
      getRadius(radius);
    }
  };

  Header.prototype.handleRadius = function handleRadius(radius) {
    this.props.getRadius(radius);
    this.setState({ radius: radius });

    var roadtest = JSON.parse(sessionStorage.getItem('roadtest')) || {};
    roadtest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, roadtest, { radius: radius });
    sessionStorage.setItem('roadtest', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(roadtest));
  };

  Header.prototype.handleReload = function handleReload() {
    var _this2 = this;

    this.props.updateGps(new Date().getTime());
    this.setState({ status: 'pending' });
    _.delay(function () {
      _this2.setState({ status: 'success' });
    }, 1000);
  };

  Header.prototype.render = function render() {
    var _this3 = this;

    var _state = this.state,
        _state$radius = _state.radius,
        radius = _state$radius === undefined ? 1 : _state$radius,
        showDeviceModal = _state.showDeviceModal,
        _state$device = _state.device,
        device = _state$device === undefined ? {} : _state$device,
        gateway = _state.gateway,
        _state$showGpsModal = _state.showGpsModal,
        showGpsModal = _state$showGpsModal === undefined ? false : _state$showGpsModal,
        _state$showGatewayMod = _state.showGatewayModal,
        showGatewayModal = _state$showGatewayMod === undefined ? false : _state$showGatewayMod,
        _state$showRadiusModa = _state.showRadiusModal,
        showRadiusModal = _state$showRadiusModa === undefined ? false : _state$showRadiusModa,
        _state$status = _state.status,
        status = _state$status === undefined ? '' : _state$status;
    var startDwnld = this.props.startDwnld;


    var header = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      { className: "clearfix " + __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.leftTool },
      device.name && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "span",
        { className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.deviceName },
        device.name
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { className: "pull-left " + __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.addDps },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router__["f" /* Link */], {
          className: "fa fa-eyedropper",
          onClick: function onClick() {
            return _this3.setState({ showGpsModal: true });
          }
        }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "span",
          null,
          this.intlMsg.msg('header.colorset')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { className: "pull-left " + __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.addDps },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router__["f" /* Link */], {
          className: "fa fa-rss",
          onClick: function onClick() {
            return _this3.setState({ showRadiusModal: true });
          }
        }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "span",
          null,
          this.intlMsg.msg('header.radius')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { className: "pull-right" },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-primary-b",
            onClick: function onClick() {
              return _this3.setState({ showDeviceModal: true });
            }
          },
          this.intlMsg.msg('selectdevice')
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-default-b",
            onClick: function onClick() {
              return _this3.setState({ showGatewayModal: true });
            },
            className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.marginLm
          },
          this.intlMsg.msg('selectgateway')
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-info-b",
            className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.marginLm,
            onClick: function onClick() {
              return startDwnld(new Date().valueOf());
            }
          },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-download" }),
          "\xA0",
          this.intlMsg.msg('download')
        )
      )
    );

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: header, styleName: "add-panel" },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Col"],
          { md: 11 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "span",
            { className: "pull-left" },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__TimeSelect__["a" /* default */], null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Col"],
          { md: 1, styleName: "refresh" },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_Refresher__["a" /* default */], {
            onReload: function onReload() {
              return _this3.handleReload();
            },
            reloading: status === 'pending'
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__DeviceModal__["a" /* default */], {
        checked: device,
        showModal: showDeviceModal,
        onHide: function onHide() {
          return _this3.setState({ showDeviceModal: false });
        },
        onSelect: this.handleSelectDevice
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_SelectGatewayModal__["a" /* default */], {
        checked: gateway,
        showModal: showGatewayModal,
        onSuccess: this.handleSelectGw,
        onHide: function onHide() {
          return _this3.setState({ showGatewayModal: false });
        }
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__GpsColor__["a" /* default */], {
        showGpsModal: showGpsModal,
        onHide: function onHide() {
          return _this3.setState({ showGpsModal: false });
        }
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__CoverageModal__["a" /* default */], {
        radius: radius,
        showModal: showRadiusModal,
        onHide: function onHide() {
          return _this3.setState({ showRadiusModal: false });
        },
        onConfirm: this.handleRadius
      })
    );
  };

  return Header;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_9_react_router_redux__["routerActions"].push,
  getDevice: __WEBPACK_IMPORTED_MODULE_14_loraactions_roadtest__["a" /* default */].getDevice,
  getGateway: __WEBPACK_IMPORTED_MODULE_14_loraactions_roadtest__["a" /* default */].getGateway,
  getGpsColor: __WEBPACK_IMPORTED_MODULE_14_loraactions_roadtest__["a" /* default */].getGpsColor,
  getRadius: __WEBPACK_IMPORTED_MODULE_14_loraactions_roadtest__["a" /* default */].getRadius,
  updateGps: __WEBPACK_IMPORTED_MODULE_14_loraactions_roadtest__["a" /* default */].updateGps,
  startDwnld: __WEBPACK_IMPORTED_MODULE_14_loraactions_roadtest__["a" /* default */].startDwnld
};

Header.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_7_react_css_modules___default()(Header, __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_sub_days__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_sub_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_sub_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_sub_hours__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_sub_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_sub_hours__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_set_hours__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_set_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_set_hours__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_set_minutes__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_set_minutes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_set_minutes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_start_of_day__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_start_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns_start_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_end_of_day__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_end_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_date_fns_end_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_difference_in_calendar_days__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_difference_in_calendar_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_date_fns_difference_in_calendar_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_add_days__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_date_fns_add_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_is_after__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_is_after___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_date_fns_is_after__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_is_before__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_is_before___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_date_fns_is_before__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_date_fns_min__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_date_fns_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_date_fns_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loracoms_DatePicker__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_loracoms_TimePicker__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_loracoms_InlineSelect__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_loraactions_roadtest__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__styles_scss__ = __webpack_require__(2304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);























var defaultTo = function defaultTo() {
  return __WEBPACK_IMPORTED_MODULE_11_date_fns_start_of_day___default()(new Date());
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  time: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  getTimes: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};

var TimeSelect = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(TimeSelect, _React$Component);

  TimeSelect.handleDisableDate = function handleDisableDate(d, from) {
    return __WEBPACK_IMPORTED_MODULE_15_date_fns_is_after___default()(d, __WEBPACK_IMPORTED_MODULE_17_date_fns_min___default()(__WEBPACK_IMPORTED_MODULE_14_date_fns_add_days___default()(from, 7), new Date())) || __WEBPACK_IMPORTED_MODULE_16_date_fns_is_before___default()(d, from);
  };

  function TimeSelect(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TimeSelect);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      from: props.time.from,
      to: props.time.to,
      by: props.time.by || 'hour'
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_21_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'applicationdetail.dashboard');
    return _this;
  }

  TimeSelect.prototype.componentWillMount = function componentWillMount() {
    this.initBy();
  };

  TimeSelect.prototype.initBy = function initBy() {
    var _props$time = this.props.time,
        from = _props$time.from,
        to = _props$time.to,
        by = _props$time.by;

    if (!by) {
      var days = __WEBPACK_IMPORTED_MODULE_13_date_fns_difference_in_calendar_days___default()(to, from);
      var sort = 'hour';
      if (days <= 0) {
        sort = 'hour';
      } else if (days <= 1) {
        sort = 'day';
      } else if (days <= 7) {
        sort = 'sevenday';
      }
      this.setState({ by: sort });
    }
  };

  TimeSelect.prototype.handleSetFrom = function handleSetFrom(date) {
    var _this2 = this;

    var from = this.state.from;

    var to = __WEBPACK_IMPORTED_MODULE_12_date_fns_end_of_day___default()(date);
    var d = date;

    d = __WEBPACK_IMPORTED_MODULE_10_date_fns_set_minutes___default()(d, from.getMinutes());
    d = __WEBPACK_IMPORTED_MODULE_9_date_fns_set_hours___default()(d, from.getHours());

    this.setState({ from: d, to: to }, function () {
      _this2.props.getTimes({ from: _this2.state.from, to: to });
    });
  };

  TimeSelect.prototype.handleSetTo = function handleSetTo(date) {
    var _this3 = this;

    var to = this.state.to;

    var d = date;

    d = __WEBPACK_IMPORTED_MODULE_10_date_fns_set_minutes___default()(d, to.getMinutes());
    d = __WEBPACK_IMPORTED_MODULE_9_date_fns_set_hours___default()(d, to.getHours());

    this.setState({ to: d }, function () {
      var from = _this3.state.from;

      _this3.props.getTimes({ from: from, to: _this3.state.to });
    });
  };

  TimeSelect.prototype.handleSetMomentFrom = function handleSetMomentFrom(d) {
    var from = this.state.from;
    var to = this.state.to;


    from = __WEBPACK_IMPORTED_MODULE_10_date_fns_set_minutes___default()(from, d.getMinutes());
    from = __WEBPACK_IMPORTED_MODULE_9_date_fns_set_hours___default()(from, d.getHours());
    this.setState({ from: from });

    this.props.getTimes({ from: from, to: to });
  };

  TimeSelect.prototype.handleSetMomentTo = function handleSetMomentTo(d) {
    var to = this.state.to;
    var from = this.state.from;


    to = __WEBPACK_IMPORTED_MODULE_10_date_fns_set_minutes___default()(to, d.getMinutes());
    to = __WEBPACK_IMPORTED_MODULE_9_date_fns_set_hours___default()(to, d.getHours());
    this.setState({ to: to });

    this.props.getTimes({ from: from, to: to });
  };

  TimeSelect.prototype.handleChangeBy = function handleChangeBy(by) {
    var getTimes = this.props.getTimes;
    var to = this.state.to;

    var from = void 0;
    var defaultto = defaultTo();
    defaultto = __WEBPACK_IMPORTED_MODULE_10_date_fns_set_minutes___default()(defaultto, to.getMinutes());

    switch (by) {
      case 'hour':
        from = __WEBPACK_IMPORTED_MODULE_9_date_fns_set_hours___default()(defaultto, new Date().getHours());
        defaultto = __WEBPACK_IMPORTED_MODULE_9_date_fns_set_hours___default()(defaultto, new Date().getHours() + 1);
        break;
      case 'day':
        from = __WEBPACK_IMPORTED_MODULE_7_date_fns_sub_days___default()(defaultto, 1);
        from = __WEBPACK_IMPORTED_MODULE_9_date_fns_set_hours___default()(from, this.state.from.getHours());
        defaultto = __WEBPACK_IMPORTED_MODULE_9_date_fns_set_hours___default()(defaultto, to.getHours());
        break;
      case 'sevenday':
        from = __WEBPACK_IMPORTED_MODULE_7_date_fns_sub_days___default()(defaultto, 7);
        from = __WEBPACK_IMPORTED_MODULE_9_date_fns_set_hours___default()(from, this.state.from.getHours());
        defaultto = __WEBPACK_IMPORTED_MODULE_9_date_fns_set_hours___default()(defaultto, to.getHours());
        break;
      case 'month':
        from = __WEBPACK_IMPORTED_MODULE_7_date_fns_sub_days___default()(defaultto, 30);
        from = __WEBPACK_IMPORTED_MODULE_9_date_fns_set_hours___default()(from, this.state.from.getHours());
        defaultto = __WEBPACK_IMPORTED_MODULE_9_date_fns_set_hours___default()(defaultto, to.getHours());
        break;
      default:
        from = __WEBPACK_IMPORTED_MODULE_8_date_fns_sub_hours___default()(defaultto, 1);
    }

    from = __WEBPACK_IMPORTED_MODULE_10_date_fns_set_minutes___default()(from, this.state.from.getMinutes());

    this.setState({ by: by, from: from, to: defaultto });
    getTimes({ from: from, to: to, by: by });
  };

  TimeSelect.prototype.render = function render() {
    var _this4 = this;

    var _state = this.state,
        from = _state.from,
        to = _state.to,
        by = _state.by,
        selectDisabled = _state.selectDisabled;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_23__styles_scss___default.a.timesel + " clearfix" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_DatePicker__["a" /* default */], {
        date: from,
        onSelect: function onSelect(date) {
          return _this4.handleSetFrom(date);
        }
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_loracoms_TimePicker__["a" /* default */], {
        date: from,
        onSelect: function onSelect(m) {
          return _this4.handleSetMomentFrom(m);
        }
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "span",
        { className: __WEBPACK_IMPORTED_MODULE_23__styles_scss___default.a.datesel },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_DatePicker__["a" /* default */], {
          date: to,
          onSelect: function onSelect(date) {
            return _this4.handleSetTo(date);
          },
          disabled: function disabled(d) {
            return TimeSelect.handleDisableDate(d, from);
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_loracoms_TimePicker__["a" /* default */], {
        date: to,
        onSelect: function onSelect(c) {
          return _this4.handleSetMomentTo(c);
        }
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_loracoms_InlineSelect__["a" /* default */], {
        bsStyle: "aisz-primary",
        options: [{
          label: this.intlMsg.msg('toolbar.bytime.hour'),
          value: 'hour'
        }, {
          label: this.intlMsg.msg('toolbar.bytime.day'),
          value: 'day'
        }, {
          label: this.intlMsg.msg('toolbar.bytime.sevenday'),
          value: 'sevenday'
        }],
        values: [by],
        disabled: selectDisabled,
        onChange: function onChange(selected) {
          return _this4.handleChangeBy(selected[0]);
        }
      })
    );
  };

  return TimeSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

TimeSelect.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    time: state.roadtest.getTimes
  };
};

var mapDispatchToProps = {
  getTimes: __WEBPACK_IMPORTED_MODULE_22_loraactions_roadtest__["a" /* default */].getTimes
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(TimeSelect)));

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__coms_Header__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__coms_GpsMap__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_scss__ = __webpack_require__(2305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);










var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_react_intl__["intlShape"].isRequired
};

var RoadTestView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(RoadTestView, _React$Component);

  function RoadTestView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RoadTestView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {};
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.roadtest');
    return _this;
  }

  RoadTestView.prototype.componentDidMount = function componentDidMount() {
    this.calMapHeight();
  };

  RoadTestView.prototype.calMapHeight = function calMapHeight() {
    var _this2 = this;

    var timer = 0;
    var mapHeight = void 0;
    if (timer < 5 && !mapHeight) {
      if (this.container) {
        mapHeight = window.innerHeight - this.container.offsetHeight - 100;
        this.setState({ mapHeight: mapHeight });
      } else {
        timer += 1;
        setTimeout(function () {
          _this2.calMapHeight();
        }, 1000);
      }
    }
  };

  RoadTestView.prototype.render = function render() {
    var _this3 = this;

    var mapHeight = this.state.mapHeight;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { styleName: "container", ref: function ref(div) {
          _this3.container = div;
        } },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_loracoms_Toolbar__["a" /* default */], {
        brandTitle: this.intlMsg.msg('title')
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__coms_Header__["a" /* default */], null),
      mapHeight && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { style: { height: mapHeight } },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__coms_GpsMap__["a" /* default */], null)
      )
    );
  };

  return RoadTestView;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

RoadTestView.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_4_react_css_modules___default()(RoadTestView, __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a, { allowMultiple: true })));

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_rangeslider_lib_index_css__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_rangeslider_lib_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_rangeslider_lib_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_rangeslider__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_rangeslider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_rangeslider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_scss__ = __webpack_require__(2306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);










var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired
};

var SignalCoverageView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(SignalCoverageView, _React$Component);

  function SignalCoverageView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SignalCoverageView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      transmitPower: 17,
      structuralAttenuation: 10,
      gatewayAntenna: 3,
      endNodeAntenna: 0,
      fadeMargin: 20,
      Sensitivity: -130,
      gatewayAntennaHeight: 6,
      endNodeHeight: 1,
      distance: 0
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.signalcoverageview');
    return _this;
  }

  SignalCoverageView.prototype.componentDidMount = function componentDidMount() {
    this.doCalculation();
  };

  SignalCoverageView.prototype.handleOnChange = function handleOnChange(value, key) {
    var d = {};
    d[key] = value;
    this.setState(d);
    this.doCalculation();
  };

  SignalCoverageView.prototype.doCalculation = function doCalculation() {
    var _state = this.state,
        transmitPower = _state.transmitPower,
        structuralAttenuation = _state.structuralAttenuation,
        gatewayAntenna = _state.gatewayAntenna,
        endNodeAntenna = _state.endNodeAntenna,
        fadeMargin = _state.fadeMargin,
        Sensitivity = _state.Sensitivity,
        gatewayAntennaHeight = _state.gatewayAntennaHeight,
        endNodeHeight = _state.endNodeHeight;

    var r = Math.pow(0.001 * Math.pow(10, transmitPower / 10) * Math.pow(10, endNodeAntenna / 10) * Math.pow(10, -Math.abs(structuralAttenuation) / 10) * Math.pow(10, gatewayAntenna / 10) * Math.pow(10, fadeMargin / -10) * Math.pow(endNodeHeight, 2) * Math.pow(gatewayAntennaHeight, 2) / (0.001 * Math.pow(10, Sensitivity / 10)), 0.25);
    r = Math.round((r + 0.00001) * 100) / 100;
    this.setState({
      distance: r
    });
  };

  SignalCoverageView.prototype.renderToolbar = function renderToolbar() {
    var title = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      this.intlMsg.msg('title')
    );
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_Toolbar__["a" /* default */], {
      brandTitle: title
    });
  };

  SignalCoverageView.prototype.renderSilider = function renderSilider(value, name, min, max, unit, step) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
          { md: 12 },
          this.intlMsg.msg(name),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: "pull-right" },
            this.state[name],
            "\xA0",
            unit
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_rangeslider___default.a, {
        className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.slider,
        min: min,
        max: max,
        value: value,
        step: step,
        format: function format(p) {
          return p + unit;
        },
        onChange: function onChange(e) {
          return _this2.handleOnChange(e, name);
        },
        onChangeComplete: function onChangeComplete() {
          _this2.doCalculation();
        }
      })
    );
  };

  SignalCoverageView.prototype.render = function render() {
    var _state2 = this.state,
        transmitPower = _state2.transmitPower,
        structuralAttenuation = _state2.structuralAttenuation,
        gatewayAntenna = _state2.gatewayAntenna,
        endNodeAntenna = _state2.endNodeAntenna,
        fadeMargin = _state2.fadeMargin,
        Sensitivity = _state2.Sensitivity,
        gatewayAntennaHeight = _state2.gatewayAntennaHeight,
        endNodeHeight = _state2.endNodeHeight,
        distance = _state2.distance;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
          { md: 12 },
          this.renderToolbar()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Panel"],
            { bsStyle: "aisz-white", header: '' },
            this.renderSilider(transmitPower, 'transmitPower', 0, 30, 'dBm', 1),
            this.renderSilider(structuralAttenuation, 'structuralAttenuation', 0, 40, 'dB', 1),
            this.renderSilider(gatewayAntenna, 'gatewayAntenna', 0, 10, 'dBi', 1),
            this.renderSilider(endNodeAntenna, 'endNodeAntenna', -3, 10, 'dBi', 1),
            this.renderSilider(fadeMargin, 'fadeMargin', 0, 30, 'dB', 1),
            this.renderSilider(Sensitivity, 'Sensitivity', -140, -120, 'dBm', 1),
            this.renderSilider(gatewayAntennaHeight, 'gatewayAntennaHeight', 1, 80, 'm', 0.5),
            this.renderSilider(endNodeHeight, 'endNodeHeight', 0, 5, 'm', 0.1)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Panel"],
            { bsStyle: "aisz-white", header: '' },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Row"],
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
                { md: 1 },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "h1",
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "fa fa-wifi" })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
                { md: 11 },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "h3",
                  null,
                  this.intlMsg.msg('description.heading'),
                  "\xA0"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Row"],
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
                { md: 12 },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.distanceText },
                  distance,
                  "\xA0m"
                )
              )
            )
          )
        )
      )
    );
  };

  return SignalCoverageView;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

SignalCoverageView.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(SignalCoverageView));

/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_HeatmapChart__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_SearchSelector__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_SearchSelMultiple__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_Copy__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__containers_Application_coms_DeviceDetail_coms_DeviceData__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TDMView_NodeStatus_Logs__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_scss__ = __webpack_require__(2307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_scss__);





/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_6_react_intl__["intlShape"].isRequired
};

var TDMStatis = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TDMStatis, _React$Component);

  function TDMStatis(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TDMStatis);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      data: [],
      offsets: [],
      channels: [],
      nodeInfoMap: {},
      channelQuality: {},
      originChannels: [],
      sortKey: "asc",
      showKey: "better"
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__["a" /* default */](props.intl, "network");
    _this.channelxOffData = {};
    _this.nodesData = [];
    _this.originOffsets = [];
    _this.originChannels = [];
    _this.filter = {};
    _this.channelGtwName = {};
    _this.servicesOpts = [{ label: _this.intlMsg.msg("tdmstatis.normal"), value: 1 }, { label: _this.intlMsg.msg("tdmstatis.gongtu"), value: 2 }, {
      label: _this.intlMsg.msg("tdmstatis.diancan"),
      value: 3
    }, { label: _this.intlMsg.msg("tdmstatis.dianliutu"), value: 4 }, { label: _this.intlMsg.msg("tdmstatis.pressure"), value: 5 }, { label: _this.intlMsg.msg("tdmstatis.temperature"), value: 6 }];
    _this.clickFn = _this.clickFn.bind(_this);
    return _this;
  }

  TDMStatis.prototype.componentWillMount = function componentWillMount() {
    this.loadGatewayStatus();
  };

  TDMStatis.prototype.loadGatewayStatus = function loadGatewayStatus() {
    var _this2 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__api_callAPI__["a" /* default */])({
      endpoint: "/tdmng/gatewaystatus",
      method: "GET"
    }).then(function (res) {
      var _res$List = res.List,
          List = _res$List === undefined ? [] : _res$List;

      List.forEach(function (l) {
        var id = l.id;
        l.channels.forEach(function (c) {
          var key = ("00" + c.channel).substr(-2) + "_" + id;
          _this2.channelxOffData[key] = c.sframe.xOffset;
          _this2.channelGtwName[key] = c.channel + "_" + l.name;
        });
      });
      _this2.loadData();
    }).catch();
  };

  TDMStatis.prototype.loadData = function loadData() {
    var _this3 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__api_callAPI__["a" /* default */])({
      endpoint: "/tdmng/nodestatus",
      method: "GET"
    }).then(function (res) {
      var _res$List2 = res.List,
          List = _res$List2 === undefined ? [] : _res$List2;
      // 获取可用的信息

      _this3.nodesData = _.map(List, function (l) {
        if (l.roaming && !_.isNil(l.binds) && l.binds.length > 0) {
          return l;
        }
        return null;
      });
      _this3.nodesData = _.filter(_this3.nodesData, function (s) {
        return s !== null;
      });
      _this3.handleOriginData();
      _this3.handleData();
    }).catch(function () {});
  };

  TDMStatis.prototype.handleOriginData = function handleOriginData() {
    var _this4 = this;

    var originData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util__["a" /* handleNodeData */])(this.nodesData, this.channelxOffData);
    this.originOffsets = originData.offsets;
    this.originChannels = originData.channels;
    var originChannels = _.cloneDeep(this.originChannels);
    var channelQuality = originData.channelQuality;
    this.setState({ channelQuality: channelQuality, originChannels: originChannels }, function () {
      var _state = _this4.state,
          sortKey = _state.sortKey,
          showKey = _state.showKey;

      _this4.handleSort(sortKey, showKey);
    });
    this.handleData();
  };

  TDMStatis.prototype.handleData = function handleData() {
    var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util__["a" /* handleNodeData */])(this.nodesData, this.channelxOffData, this.filter);
    var offsets = result.offsets,
        channels = result.channels;

    var chartWidth = _.uniq(offsets);
    chartWidth = chartWidth.length * 15 + 160; // 因为left=150px, right=10px, 所以要加上160来计算总的宽度
    var chartHeight = channels.length * 25 + 80; // 因为bottom=80px, 所以要加上80来计算总的高度
    this.setState(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, result, { chartWidth: chartWidth, chartHeight: chartHeight }));
  };

  TDMStatis.prototype.handleChangeSelect = function handleChangeSelect(v, key) {
    var _setState;

    this.setState((_setState = {}, _setState[key] = v, _setState));
    this.filter[key] = v;
    this.handleData();
  };

  TDMStatis.prototype.handleSort = function handleSort(sort, show) {
    var sortKey = _.xorBy(["asc", "desc"], [sort]);
    var channelQuality = this.state.channelQuality;

    var sortChannelQuality = _.sortBy(channelQuality, show);
    if (sortKey[0] === "desc") {
      sortChannelQuality = _.reverse(sortChannelQuality);
    }
    var newOriginChannels = [];
    sortChannelQuality.forEach(function (c) {
      newOriginChannels = _.concat(newOriginChannels, [c.key]);
    });
    this.setState({
      sortKey: sortKey[0],
      showKey: show,
      originChannels: newOriginChannels
    });
  };

  TDMStatis.prototype.clickFn = function clickFn() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        value = _ref.value;

    if (!value) return;
    var index = value[0] + "_" + value[1];
    var nodeInfoMap = this.state.nodeInfoMap;

    var node = nodeInfoMap[index];
    if (!node) return;
    var _node$base = node.base;
    _node$base = _node$base === undefined ? {} : _node$base;
    var id = _node$base.id;

    if (!id) return;
    this.setState({ deviceId: id, nodeStatus: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, node, { id: id }) });
  };

  TDMStatis.prototype.renderOffsetOpts = function renderOffsetOpts() {
    var length = 500;
    // 获取一共有几组数据范围
    var endLength = _.ceil(this.originOffsets[this.originOffsets.length - 1] / length) || 0;
    // 获取选择的数据范围
    var offsetOpts = _.map(_.range(endLength), function (f, index) {
      var start = index * length;
      var end = (index + 1) * length;
      var obj = { label: start + "-" + end, value: start + "-" + end };
      return obj;
    });
    offsetOpts = _.concat(offsetOpts, [{ label: "0-" + endLength * length, value: "0-" + endLength * length }]);
    return offsetOpts;
  };

  TDMStatis.prototype.renderChannelsOpts = function renderChannelsOpts() {
    var _this5 = this;

    var channelsOpts = [];
    this.originChannels.forEach(function (c) {
      channelsOpts = _.concat(channelsOpts, [{ label: _this5.channelGtwName[c], value: c }]);
    });
    return channelsOpts;
  };

  TDMStatis.prototype.renderTable = function renderTable() {
    var _this6 = this;

    var _state2 = this.state,
        showKey = _state2.showKey,
        sortKey = _state2.sortKey,
        originChannels = _state2.originChannels,
        channelQuality = _state2.channelQuality;

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      { style: { padding: "15px" } },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Table"],
        { className: "aisz-table-light " + __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.statisTable },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg("tdmstatis.gtwtitle")
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg("tdmstatis.num")
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg("tdmstatis.average")
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              "<5",
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "a",
                {
                  className: showKey === "worst" ? __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.active : __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.noactive
                },
                showKey !== "worst" && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", {
                  className: "fa fa-sort-amount-asc",
                  onClick: function onClick() {
                    return _this6.handleSort("asc", "worst");
                  }
                }),
                showKey === "worst" && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", {
                  className: "fa fa-sort-amount-" + sortKey,
                  onClick: function onClick() {
                    return _this6.handleSort(sortKey, "worst");
                  }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              ">=5",
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "a",
                {
                  className: showKey === "bad" ? __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.active : __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.noactive
                },
                showKey !== "bad" && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", {
                  className: "fa fa-sort-amount-asc",
                  onClick: function onClick() {
                    return _this6.handleSort("asc", "bad");
                  }
                }),
                showKey === "bad" && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", {
                  className: "fa fa-sort-amount-" + sortKey,
                  onClick: function onClick() {
                    return _this6.handleSort(sortKey, "bad");
                  }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              ">=10",
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "a",
                {
                  className: showKey === "middle" ? __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.active : __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.noactive
                },
                showKey !== "middle" && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", {
                  className: "fa fa-sort-amount-asc",
                  onClick: function onClick() {
                    return _this6.handleSort("asc", "middle");
                  }
                }),
                showKey === "middle" && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", {
                  className: "fa fa-sort-amount-" + sortKey,
                  onClick: function onClick() {
                    return _this6.handleSort(sortKey, "middle");
                  }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              ">=20",
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "a",
                {
                  className: showKey === "better" ? __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.active : __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.noactive
                },
                showKey !== "better" && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", {
                  className: "fa fa-sort-amount-asc",
                  onClick: function onClick() {
                    return _this6.handleSort("asc", "better");
                  }
                }),
                showKey === "better" && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", {
                  className: "fa fa-sort-amount-" + sortKey,
                  onClick: function onClick() {
                    return _this6.handleSort(sortKey, "better");
                  }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              ">=40",
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "a",
                {
                  className: showKey === "good" ? __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.active : __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.noactive
                },
                showKey !== "good" && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", {
                  className: "fa fa-sort-amount-asc",
                  onClick: function onClick() {
                    return _this6.handleSort("asc", "good");
                  }
                }),
                showKey === "good" && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", {
                  className: "fa fa-sort-amount-" + sortKey,
                  onClick: function onClick() {
                    return _this6.handleSort(sortKey, "good");
                  }
                })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "tbody",
          null,
          !_.isEmpty(channelQuality) && _.map(originChannels, function (c, idx) {
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "tr",
              { key: idx },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                _this6.channelGtwName[c]
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  "span",
                  null,
                  channelQuality[c].num
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  "span",
                  null,
                  !_.isInteger(channelQuality[c].avg) ? channelQuality[c].avg.toFixed(2) : channelQuality[c].avg
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  "span",
                  null,
                  channelQuality[c].worst
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  "span",
                  null,
                  channelQuality[c].bad
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  "span",
                  null,
                  channelQuality[c].middle
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  "span",
                  null,
                  channelQuality[c].better
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  "span",
                  null,
                  channelQuality[c].good
                )
              )
            );
          })
        )
      )
    );
  };

  TDMStatis.prototype.render = function render() {
    var _this7 = this;

    var _state3 = this.state,
        data = _state3.data,
        offsets = _state3.offsets,
        channels = _state3.channels,
        deviceId = _state3.deviceId,
        nodeInfoMap = _state3.nodeInfoMap,
        chartWidth = _state3.chartWidth,
        chartHeight = _state3.chartHeight,
        _state3$copyText = _state3.copyText,
        copyText = _state3$copyText === undefined ? "" : _state3$copyText,
        _state3$nodeStatus = _state3.nodeStatus,
        nodeStatus = _state3$nodeStatus === undefined ? {} : _state3$nodeStatus;


    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "section",
      null,
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.content },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          null,
          this.intlMsg.msg("tdmstatis.title")
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.filter },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "span",
              null,
              this.intlMsg.msg("tdmstatis.offset")
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_SearchSelector__["a" /* default */], {
              onChange: function onChange(v) {
                return _this7.handleChangeSelect(v, "offset");
              },
              options: this.renderOffsetOpts()
            })
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "span",
              null,
              this.intlMsg.msg("tdmstatis.gateway")
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_SearchSelMultiple__["a" /* default */], {
              onChange: function onChange(v) {
                return _this7.handleChangeSelect(v, "channel");
              },
              options: this.renderChannelsOpts()
            })
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "span",
              null,
              this.intlMsg.msg("tdmstatis.service")
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_SearchSelMultiple__["a" /* default */], {
              onChange: function onChange(v) {
                return _this7.handleChangeSelect(v, "service");
              },
              options: this.servicesOpts
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.chart },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_HeatmapChart__["a" /* default */], {
            series: [{
              name: "TDM",
              type: "heatmap",
              data: data,
              label: {
                normal: {
                  show: false
                }
              }
            }],
            visualMap: {
              min: 5,
              max: 40,
              minOpen: 5,
              maxOpen: 40,
              calculable: true,
              type: "piecewise",
              orient: "horizontal",
              left: "200px",
              top: "top"
            },
            xAxis: {
              type: "category",
              data: offsets,
              splitArea: {
                show: true
              }
            },
            yAxis: {
              type: "category",
              data: channels,
              splitArea: {
                show: true
              },
              offset: 2,
              axisLabel: {
                formatter: function formatter(value) {
                  return _this7.channelGtwName[value];
                }
              }
            },
            animation: false,
            tooltip: {
              formatter: function formatter(params) {
                var nodeInfo = nodeInfoMap[params.data[0] + "_" + params.data[1]];

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(nodeInfo.base) + "<br/>" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(nodeInfo.counters) + "<br />" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(nodeInfo.time);
              }
            },
            grid: {
              left: "150px",
              right: "10px",
              bottom: "80px"
            },
            width: chartWidth + "px",
            height: chartHeight + "px",
            clickFn: this.clickFn
          })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          null,
          this.intlMsg.msg("selectedpoint", "network"),
          deviceId,
          "\xA0",
          deviceId && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Copy__["a" /* default */], { id: "copy", text: deviceId }),
          !deviceId && this.intlMsg.msg("nopoint", "network")
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Tab"].Container,
        {
          id: "tdm_container",
          defaultActiveKey: "gateway",
          className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.tab
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
          { className: "clearfix" },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Nav"],
              { bsStyle: "aisz-tabs" },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["NavItem"],
                { eventKey: "gateway" },
                this.intlMsg.msg("detailview.netstatus.title", "gatewaydetail")
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["NavItem"],
                { eventKey: "data" },
                this.intlMsg.msg("data.header", "devicedetail")
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["NavItem"],
                { eventKey: "logs" },
                this.intlMsg.msg("tdm.node.channel.logs", "network")
              )
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Tab"].Content,
              { animation: true, className: "aisz-tab-content-white" },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Tab"].Pane,
                { eventKey: "gateway" },
                this.renderTable()
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Tab"].Pane,
                { eventKey: "data" },
                deviceId && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__containers_Application_coms_DeviceDetail_coms_DeviceData__["a" /* default */], { deviceId: deviceId }),
                !deviceId && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.nodata },
                  this.intlMsg.msg("nopoint", "network")
                )
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Tab"].Pane,
                { eventKey: "logs" },
                deviceId && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__TDMView_NodeStatus_Logs__["a" /* default */], { nodeStatus: nodeStatus }),
                !deviceId && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.nodata },
                  this.intlMsg.msg("nopoint", "network")
                )
              )
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", {
        id: "tdmchart",
        style: { display: "none" },
        "data-clipboard-text": copyText,
        ref: function ref(_ref2) {
          _this7.ref = _ref2;
        }
      })
    );
  };

  return TDMStatis;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

TDMStatis.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(TDMStatis));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, moment) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleNodeData; });
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

var getChannelKey = function getChannelKey(channel, roaming) {
  return ("00" + channel).substr(-2) + "_" + roaming;
};

var abAbsoluteSlotOffset = function abAbsoluteSlotOffset(slotLocation, logicSlotOffset, xOff) {
  var xint = 3;
  var sizeInWindow = slotLocation.length; // 该slot类型在window 中的数量
  var logicOffsetInWindow = logicSlotOffset % sizeInWindow; // slot节点在window 中的偏移
  var logicWindowOffset = _.parseInt(logicSlotOffset / sizeInWindow); // window在逻辑序列中的偏移

  var groupOffset = _.parseInt(logicWindowOffset / (xint - 1)); // 节点所在goup 在group序列中的偏移
  var offsetInGroup = logicWindowOffset % (xint - 1); // 节点所在window 在group 中的偏移
  if (offsetInGroup >= xOff) {
    offsetInGroup += 1; // 进行校正，如果X型window 在前则需要计算在内。
  }
  return (groupOffset * xint + offsetInGroup) * 10 + slotLocation[logicOffsetInWindow];
};

var absoluteSlotOffset = function absoluteSlotOffset(frame, xOff, logicSlotOffset) {
  var xOffData = xOff % 3;
  var xint = 3;
  var aSlotLocation = [0, 2, 4, 6, 7];
  var bSlotLocation = [1, 3, 5];
  if (Number(frame) === 0) {
    return (xint * logicSlotOffset + xOffData) * 10;
  } else if (Number(frame) === 1) {
    return abAbsoluteSlotOffset(aSlotLocation, logicSlotOffset, xOffData);
  }
  return abAbsoluteSlotOffset(bSlotLocation, logicSlotOffset, xOffData);
};

var handleBind = function handleBind(node, bind, channelxOffData) {
  var channelKey = getChannelKey(bind.channel, node.roaming);
  var offset = absoluteSlotOffset(bind.frame, channelxOffData[channelKey], bind.offset);
  var quality = _.parseInt(node.counters.alohaup * 100 / (node.counters.alohaup + node.counters.tdmup || 1));

  return { channelKey: channelKey, offset: offset, quality: quality };
};

var isPass = function isPass(offset, channel, service) {
  var filter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var offsetData = filter.offset || '';
  offsetData = _.split(offsetData, '-');
  if (offset < Number(offsetData[0]) || offset > Number(offsetData[1])) {
    return true;
  }
  // channel过滤为多选
  var channels = filter.channel || [];
  if (channels.length > 0 && !_.includes(channels, channel)) {
    return true;
  }
  // service过滤为多选
  var services = filter.service || [];
  if (services.length > 0 && !_.includes(services, service)) {
    return true;
  }
  return false;
};

var handleNodeData = function handleNodeData(nodes, channelxOffData, filter) {
  var channels = [];
  var offsets = [];
  var data = [];
  var nodeInfoMap = {};
  var channelQuality = {};
  var allChannels = [];
  nodes.forEach(function (node) {
    node.binds.forEach(function (bind) {
      var _handleBind = handleBind(node, bind, channelxOffData),
          channelKey = _handleBind.channelKey,
          offset = _handleBind.offset,
          quality = _handleBind.quality;

      allChannels.push(channelKey);

      if (isPass(offset, channelKey, bind.service, filter)) {
        return;
      }

      channels.push(channelKey);
      offsets.push(offset);
    });
  });

  channels = _.sortBy(_.uniq(channels));
  offsets = _.sortBy(_.uniq(offsets));
  allChannels = _.sortBy(_.uniq(allChannels));

  allChannels.forEach(function (channelKey) {
    channelQuality[channelKey] = {
      key: channelKey, // key (在排序时用到key)
      num: 0, // 总数
      avg: 0, // 平均
      sum: 0, // 总和
      worst: 0, // < 5
      bad: 0, // >= 5
      middle: 0, // >= 10
      better: 0, // >= 20
      good: 0 // >= 40
    };
  });

  var rangeQuality = { bad: 5, middle: 10, better: 20, good: 40 };
  nodes.forEach(function (node) {
    node.binds.forEach(function (bind) {
      var _handleBind2 = handleBind(node, bind, channelxOffData),
          channelKey = _handleBind2.channelKey,
          offset = _handleBind2.offset,
          quality = _handleBind2.quality;

      // 获取总和，总数


      channelQuality[channelKey].sum += quality;
      channelQuality[channelKey].num += 1;
      // 获取范围的统计数据
      if (quality < 5) {
        channelQuality[channelKey].worst += 1;
      } else {
        _.map(_.keys(rangeQuality), function (key) {
          if (quality >= rangeQuality[key]) {
            channelQuality[channelKey][key] += 1;
          }
        });
      }

      if (isPass(offset, channelKey, bind.service, filter)) {
        return;
      }

      var x = _.indexOf(offsets, offset);
      var y = _.indexOf(channels, channelKey);

      var item = [x, y, quality];
      data.push(item);

      var nodeInfo = {
        base: {
          id: node.id,
          accuracy: node.accuracy,
          service: bind.service,
          frame: bind.frame,
          offset: offset,
          bindOffset: bind.offset
        },
        counters: node.counters,
        time: {
          lastatt: moment(node.lastatt).format('YYYY-MM-DD HH:mm:ss'),
          lastup: moment(node.lastup).format('YYYY-MM-DD HH:mm:ss')
        }
      };

      nodeInfoMap[x + "_" + y] = nodeInfo;
    });
  });

  allChannels.forEach(function (channelKeys) {
    channelQuality[channelKeys].avg = channelQuality[channelKeys].sum / (channelQuality[channelKeys].num || 1);
  });

  return {
    channels: channels,
    offsets: offsets,
    data: data,
    nodeInfoMap: nodeInfoMap,
    channelQuality: channelQuality
  };
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11), __webpack_require__(14)))

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dropzone__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_papaparse__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_papaparse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_InlineSelect__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loracoms_Checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__util__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_scss__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__styles_scss__);





/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



















var kEncodingOptions = [{
  label: 'UTF-8',
  value: 'UTF-8'
}, {
  label: 'GBK',
  value: 'GBK'
}];

var kInnerFields = ['valid', 'idx', 'error', 'result', 'missings'];

var kRequiredFields = ['deveui', 'nodetype'];

var kListHeaders = ['name', 'deveui', 'nodetype', 'sf', 'gateway', 'remark'];

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_11_react_intl__["intlShape"].isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  typesJSON: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  networkDetail: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired
};

var BatchNodes = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(BatchNodes, _React$Component);

  BatchNodes.norm = function norm(rows) {
    var normedRows = _.filter(rows, function (r) {
      if (r.deveui) {
        return r.deveui.trim().length > 0;
      }
      return false;
    });
    normedRows = _.map(normedRows, function (r, idx) {
      var row = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, r);
      row.idx = idx;
      row.missings = _.filter(kRequiredFields, function (f) {
        return !_.has(row, f) || _.isNil(row[f]) || row[f].trim() === '';
      });
      row.valid = row.missings.length === 0;
      row.error = null;
      row = _.mapKeys(row, function (value, key) {
        return key.toLowerCase();
      });
      return row;
    });
    return normedRows;
  };

  function BatchNodes(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, BatchNodes);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    var _parseContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__util__["a" /* parseContent */])(props.typesJSON),
        types = _parseContent.types;

    _this.state = {
      view: 'dropzone',
      encoding: 'UTF-8'
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_18_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.batch');
    _this.types = types;
    _this.addQueue = [];
    _this.networkDetail = props.networkDetail;
    _this.handleDrop = _this.handleDrop.bind(_this);
    _this.handleReImport = _this.handleReImport.bind(_this);
    _this.handleChangeEncoding = _this.handleChangeEncoding.bind(_this);
    _this.handleSubmitImport = _this.handleSubmitImport.bind(_this);
    _this.toggleCheck = _this.toggleCheck.bind(_this);
    _this.toggleCheckAll = _this.toggleCheckAll.bind(_this);
    return _this;
  }

  BatchNodes.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var typesJSON = _ref.typesJSON,
        networkDetail = _ref.networkDetail;

    if (!_.isEqual(typesJSON, this.props.typesJSON)) {
      var _parseContent2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__util__["a" /* parseContent */])(typesJSON),
          types = _parseContent2.types;

      this.types = types;
    }
    if (!_.isEqual(networkDetail, this.props.networkDetail)) {
      this.networkDetail = networkDetail;
    }
  };

  BatchNodes.prototype.cleanse = function cleanse(rows) {
    var nodetypes = this.types.nodetypes;
    if (!nodetypes) return [];

    var nodes = _.map(rows, function (c) {
      var nt = _.find(nodetypes, function (n) {
        return n.type === c.nodetype;
      }) || {};
      var services = nt.services;
      var deveui = _.toLower(c.deveui);
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, c, {
        deveui: deveui,
        id: deveui,
        typ: c.nodetype,
        sf: !_.isNil(c.sf) && c.sf > 0 ? _.toNumber(c.sf) : null,
        home: !_.isNil(c.gateway) ? _.toLower(c.gateway) : '',
        services: services,
        memo: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ remark: c.remark, name: c.name })
      });
    });
    nodes = _.filter(nodes, function (n) {
      return n.typ && n.services;
    });
    return nodes;
  };

  BatchNodes.prototype.handleDrop = function handleDrop(acceptedFiles) {
    if (acceptedFiles.length > 0) {
      this.setState({ file: acceptedFiles[0] });
      this.prepareFile({ file: acceptedFiles[0] });
    }
  };

  BatchNodes.prototype.prepareFile = function prepareFile(options) {
    var _this2 = this;

    var _options$file = options.file,
        file = _options$file === undefined ? this.state.file : _options$file,
        _options$encoding = options.encoding,
        encoding = _options$encoding === undefined ? this.state.encoding : _options$encoding;

    if (!file) {
      return;
    }

    var that = this;
    __WEBPACK_IMPORTED_MODULE_13_papaparse___default.a.parse(file, {
      complete: function complete(result) {
        var rows = BatchNodes.norm(result.data);
        rows = _.filter(rows, { valid: true });
        rows = _this2.cleanse(rows);
        that.setState({
          rows: rows,
          checkedRows: _.filter(rows, 'valid'),
          view: 'preview'
        });
      },
      header: true,
      encoding: encoding
    });
  };

  BatchNodes.prototype.handleChangeEncoding = function handleChangeEncoding(encoding) {
    this.setState({ encoding: encoding });
    this.prepareFile({ encoding: encoding });
  };

  BatchNodes.prototype.handleSubmitImport = function handleSubmitImport() {
    var _this3 = this;

    var _state = this.state,
        rows = _state.rows,
        checkedRows = _state.checkedRows,
        _state$canSubmit = _state.canSubmit,
        canSubmit = _state$canSubmit === undefined ? true : _state$canSubmit;

    if (!canSubmit) {
      return;
    }
    // !!! Oh yeah, we can do the batch import !!!!

    this.setState({ submitStatus: 'pending' });

    var _ref2 = this.networkDetail.data || {},
        netw = _ref2.id;

    this.addQueue = _.map(checkedRows, function (c) {
      return {
        netw: netw,
        id: c.id,
        memo: c.memo,
        services: c.services,
        typ: c.typ,
        sf: !_.isNil(c.sf) && c.sf > 0 ? _.toNumber(c.sf) : null,
        home: !_.isNil(c.gateway) ? _.toLower(c.gateway) : ''
      };
    });
    var addFunc = function addFunc() {
      if (_this3.addQueue.length > 0) {
        var node = _this3.addQueue.pop();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__api_callAPI__["a" /* default */])({
          method: 'POST',
          endpoint: '/tdmng/nodes',
          body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, node)
        }).then(function () {
          _.find(rows, function (d) {
            return d.id === node.id;
          }).added = 'success';
          _this3.setState({ rows: rows });
          addFunc();
        }).catch(function (err) {
          _.find(rows, function (d) {
            return d.id === node.id;
          }).added = err.code;
          _.find(rows, function (d) {
            return d.id === node.id;
          }).errMessage = err.message;
          addFunc();
        });
      } else {
        _this3.setState({ rows: rows, view: 'result', submitStatus: 'success' });
      }
    };
    addFunc();
  };

  BatchNodes.prototype.handleReImport = function handleReImport() {
    this.setState({
      view: 'dropzone',
      file: null
    });
  };

  BatchNodes.prototype.toggleCheck = function toggleCheck(row) {
    var checkedRows = this.state.checkedRows;

    if (_.some(checkedRows, { idx: row.idx })) {
      this.setState({
        checkedRows: _.filter(checkedRows, function (r) {
          return r.idx !== row.idx;
        })
      });
    } else {
      checkedRows.push(row);
      this.setState({ checkedRows: checkedRows });
    }
  };

  BatchNodes.prototype.toggleCheckAll = function toggleCheckAll() {
    var _state2 = this.state,
        rows = _state2.rows,
        checkedRows = _state2.checkedRows;

    var validRows = _.filter(rows, 'valid');
    if (validRows.length === checkedRows.length) {
      this.setState({ checkedRows: [] });
    } else {
      this.setState({ checkedRows: validRows });
    }
  };

  BatchNodes.prototype.parseResultError = function parseResultError(x) {
    var m = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (_.startsWith(x, 'GENERALERROR')) {
      return this.intlMsg.errorMsg('GENERALERROR');
    }
    if (_.startsWith(x, 'NOTFOUND')) {
      if (m.indexOf('home') > -1 || m.indexOf('gateway') > -1) {
        return this.intlMsg.errorMsg('GTW.NOTFOUND');
      }
      return this.intlMsg.errorMsg('NOTFOUND');
    }
    return this.intlMsg.msg('result.fail') + ": " + m;
  };

  BatchNodes.prototype.renderTools = function renderTools() {
    var _this4 = this;

    var encoding = this.state.encoding;

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.tools },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_InlineSelect__["a" /* default */], {
        options: kEncodingOptions,
        onChange: function onChange(xs) {
          return _this4.handleChangeEncoding(xs[0]);
        },
        values: [encoding]
      })
    );
  };

  BatchNodes.prototype.renderDropzone = function renderDropzone() {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      null,
      this.renderTools(),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_react_dropzone___default.a,
        {
          className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.dropzone,
          activeClassName: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a['dropzone-active'],
          onDrop: this.handleDrop
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: "text-center" },
          this.intlMsg.msg('dropzone.text')
        )
      )
    );
  };

  BatchNodes.prototype.renderPreview = function renderPreview() {
    var _this5 = this;

    var _state3 = this.state,
        _state3$canSubmit = _state3.canSubmit,
        canSubmit = _state3$canSubmit === undefined ? true : _state3$canSubmit,
        submitStatus = _state3.submitStatus;


    var isPending = submitStatus === 'pending';
    var _state4 = this.state,
        rows = _state4.rows,
        checkedRows = _state4.checkedRows;

    var headers = kListHeaders;
    headers = _.filter(headers, function (h) {
      return !kInnerFields.includes(h) && !kRequiredFields.includes(h);
    });
    headers = _.concat(kRequiredFields, headers);
    var ths = headers.map(function (h) {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "th",
        { key: h, style: { whiteSpace: 'nowrap' } },
        h
      );
    });
    var trs = rows.map(function (r) {
      var status = null;
      if (r.added === 'success') {
        status = 'result-succ';
      } else if (!_.isNil(r.added)) {
        status = 'result-fail';
      }
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "tr",
        { key: r.deveui, styleName: (r.error ? 'result-fail' : '') + " " + (status || '') },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          { styleName: "f-checkbox" },
          r.error ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-times" }) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_Checkbox__["a" /* default */], {
            id: r.deveui,
            checked: _.some(checkedRows, { idx: r.idx }),
            onChange: function onChange() {
              return _this5.toggleCheck(r);
            },
            disabled: !r.valid || isPending
          })
        ),
        headers.map(function (h) {
          var c = void 0;
          if (r.missings.includes(h)) {
            c = _this5.intlMsg.msg('preview.required');
          } else {
            c = r[h];
          }
          return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "td",
            {
              key: r.deveui + "-" + h,
              className: r.missings.includes(h) ? __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.missing : '',
              style: { whiteSpace: 'nowrap' }
              // styleName={sty}
            },
            c
          );
        })
      );
    });

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      { styleName: "preview" },
      this.renderTools(),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Table"],
        {
          className: "aisz-table-light",
          striped: true,
          responsive: true,
          bordered: true,
          hover: true
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              { styleName: "f-checkbox" },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_Checkbox__["a" /* default */], {
                id: "all",
                disabled: isPending,
                checked: _.filter(rows, 'valid').length === checkedRows.length,
                onChange: this.toggleCheckAll
              })
            ),
            ths
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "tbody",
          null,
          trs
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { styleName: "submit" },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
          { bsStyle: "aisz-warning", onClick: function onClick() {
              return _this5.setState({ view: 'dropzone' });
            } },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-repeat" }),
          ' ',
          this.intlMsg.msg('preview.cancel.btn')
        ),
        ' ',
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-primary",
            onClick: this.handleSubmitImport,
            disabled: checkedRows.length === 0 || !canSubmit
          },
          this.intlMsg.msg('preview.import.btn.seg1'),
          ' ',
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Badge"],
            { bsClass: "aisz-badge-primary-i" },
            checkedRows.length
          ),
          ' ',
          this.intlMsg.msg('preview.import.btn.seg2'),
          ' ',
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-arrow-circle-o-right" })
        )
      )
    );
  };

  BatchNodes.prototype.renderResult = function renderResult() {
    var _this6 = this;

    var rows = this.state.rows;

    var headers = kListHeaders;
    headers = _.filter(headers, function (h) {
      return !kInnerFields.includes(h);
    });
    var ths = headers.map(function (h, i) {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "th",
        { key: i, style: { whiteSpace: 'nowrap' } },
        h
      );
    }); // eslint-disable-line

    var trs = rows.map(function (r, i) {
      var status = r.added === 'success' ? 'succ' : 'fail';
      var icon = void 0;
      var msg = _this6.intlMsg.msg('result.notimport');
      if (status === 'succ') {
        icon = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-check" });
        msg = _this6.intlMsg.msg('result.succ');
      } else {
        icon = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-times" });
        msg = _this6.parseResultError(r.added, r.errMessage);
      }
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "tr",
        { key: String(i), styleName: "result-" + status },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          { style: { whiteSpace: 'nowrap' } },
          icon
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          { style: { whiteSpace: 'nowrap' } },
          msg
        ),
        headers.map(function (h, idx) {
          return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "td",
            { key: idx, style: { whiteSpace: 'nowrap' } },
            r[h]
          ) // eslint-disable-line
          ;
        })
      );
    });

    var succCount = _.filter(rows, function (r) {
      return _.has(r, 'added') && r.added === 'success';
    }).length;
    var failCount = _.filter(rows, function (r) {
      return _.has(r, 'added') && r.added !== 'success';
    }).length;

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Table"],
        {
          className: "aisz-table-light",
          responsive: true,
          bordered: true
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('result.thead.status')
            ),
            ths
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "tbody",
          null,
          trs
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { styleName: "result-summary" },
        this.intlMsg.msg('result.summary.seg1'),
        ': ',
        succCount,
        ",",
        ' ',
        this.intlMsg.msg('result.summary.seg2'),
        ': ',
        failCount,
        ",",
        ' ',
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_router__["f" /* Link */],
          { onClick: this.handleReImport },
          this.intlMsg.msg('result.summary.reimport')
        ),
        ' ',
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_router__["f" /* Link */],
          { onClick: function onClick() {
              return _this6.props.pushState('/network/tdm');
            } },
          this.intlMsg.msg('result.summary.back')
        )
      )
    );
  };

  BatchNodes.prototype.renderErrorModal = function renderErrorModal() {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-warning",
        show: !_.isNil(this.state.error),
        onHide: function onHide() {
          return _this7.setState({ error: null });
        }
      },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle" }),
          ' ',
          this.intlMsg.msg('err.modalheader')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: "text-center" },
          "333333"
        )
      )
    );
  };

  BatchNodes.prototype.render = function render() {
    var _this8 = this;

    var breadcrumb = [{
      content: 'TDM',
      onClick: function onClick() {
        return _this8.props.pushState('/network/tdm');
      }
    }, {
      content: this.intlMsg.msg('node.title'),
      active: true
    }];

    var helpHeader = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "span",
      null,
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-book" }),
      ' ',
      this.intlMsg.msg('help.panelheader')
    );

    var view = this.state.view;


    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Grid"],
        { fluid: true },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Panel"],
              { bsStyle: "aisz-white" },
              view === 'dropzone' && this.renderDropzone(),
              view === 'preview' && this.renderPreview(),
              view === 'result' && this.renderResult()
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Panel"],
              { bsStyle: "aisz-white", header: helpHeader },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "code",
                null,
                "name,deveui,nodetype,sf,gateway,remark"
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("br", null),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "code",
                null,
                "gongtu-001,3a8dec3194fa36ce,\u529F\u56FE,7,123456fffe7890ab,\u5907\u6CE8"
              )
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        null,
        this.renderErrorModal()
      )
    );
  };

  return BatchNodes;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

BatchNodes.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    typesJSON: state.tdm.setting,
    networkDetail: state.tdm.getNetwork
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_14_react_css_modules___default()(BatchNodes, __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a, { allowMultiple: true }))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dropzone__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_papaparse__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_papaparse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_InlineSelect__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loracoms_Checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__util__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__BatchNodes_styles_scss__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__BatchNodes_styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__BatchNodes_styles_scss__);





/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



















var kEncodingOptions = [{
  label: 'UTF-8',
  value: 'UTF-8'
}, {
  label: 'GBK',
  value: 'GBK'
}];

var kInnerFields = ['valid', 'idx', 'error', 'result', 'missings'];

var kRequiredFields = ['deveui', 'deveui2'];

var kListHeaders = ['name', 'deveui', 'name2', 'deveui2', 'remark'];

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_11_react_intl__["intlShape"].isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  typesJSON: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  networkDetail: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired
};

var BatchPairs = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(BatchPairs, _React$Component);

  BatchPairs.norm = function norm(rows) {
    var normedRows = _.filter(rows, function (r) {
      return r.deveui && r.deveui.trim().length > 0;
    });
    normedRows = _.map(normedRows, function (r, idx) {
      var row = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, r);
      row.idx = idx;
      row.missings = _.filter(kRequiredFields, function (f) {
        return !_.has(row, f) || _.isNil(row[f]) || row[f].trim() === '';
      });
      row.valid = row.missings.length === 0;
      row.error = null;
      row = _.mapKeys(row, function (value, key) {
        return key.toLowerCase();
      });
      return row;
    });
    return normedRows;
  };

  BatchPairs.cleanse = function cleanse(rows) {
    var nodes = _.map(rows, function (c) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, c, {
        id: c.deveui,
        rnode: c.deveui2,
        memo: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ name: c.name, rname: c.name2, remark: c.remark })
      });
    });
    nodes = _.filter(nodes, function (n) {
      return n.id && n.rnode;
    });
    return nodes;
  };

  function BatchPairs(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, BatchPairs);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    var _parseContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__util__["a" /* parseContent */])(props.typesJSON),
        types = _parseContent.types;

    _this.state = {
      view: 'dropzone',
      encoding: 'UTF-8'
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_18_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.batch');
    _this.types = types;
    _this.addQueue = [];
    _this.networkDetail = props.networkDetail;
    _this.handleDrop = _this.handleDrop.bind(_this);
    _this.handleReImport = _this.handleReImport.bind(_this);
    _this.handleChangeEncoding = _this.handleChangeEncoding.bind(_this);
    _this.handleSubmitImport = _this.handleSubmitImport.bind(_this);
    _this.toggleCheck = _this.toggleCheck.bind(_this);
    _this.toggleCheckAll = _this.toggleCheckAll.bind(_this);
    return _this;
  }

  BatchPairs.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var typesJSON = _ref.typesJSON,
        networkDetail = _ref.networkDetail;

    if (!_.isEqual(typesJSON, this.props.typesJSON)) {
      var _parseContent2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__util__["a" /* parseContent */])(typesJSON),
          types = _parseContent2.types;

      this.types = types;
    }
    if (!_.isEqual(networkDetail, this.props.networkDetail)) {
      this.networkDetail = networkDetail;
    }
  };

  BatchPairs.prototype.handleDrop = function handleDrop(acceptedFiles) {
    if (acceptedFiles.length > 0) {
      this.setState({ file: acceptedFiles[0] });
      this.prepareFile({ file: acceptedFiles[0] });
    }
  };

  BatchPairs.prototype.prepareFile = function prepareFile(options) {
    var _options$file = options.file,
        file = _options$file === undefined ? this.state.file : _options$file,
        _options$encoding = options.encoding,
        encoding = _options$encoding === undefined ? this.state.encoding : _options$encoding;

    if (!file) {
      return;
    }

    var that = this;
    __WEBPACK_IMPORTED_MODULE_13_papaparse___default.a.parse(file, {
      complete: function complete(result) {
        var rows = BatchPairs.norm(result.data);
        rows = _.filter(rows, { valid: true });
        rows = BatchPairs.cleanse(rows);
        that.setState({
          rows: rows,
          checkedRows: _.filter(rows, 'valid'),
          view: 'preview'
        });
      },
      header: true,
      encoding: encoding
    });
  };

  BatchPairs.prototype.handleChangeEncoding = function handleChangeEncoding(encoding) {
    this.setState({ encoding: encoding });
    this.prepareFile({ encoding: encoding });
  };

  BatchPairs.prototype.handleSubmitImport = function handleSubmitImport() {
    var _this2 = this;

    var _state = this.state,
        rows = _state.rows,
        checkedRows = _state.checkedRows,
        _state$canSubmit = _state.canSubmit,
        canSubmit = _state$canSubmit === undefined ? true : _state$canSubmit;

    if (!canSubmit) {
      return;
    }
    // !!! Oh yeah, we can do the batch import !!!!

    this.setState({ submitStatus: 'pending' });

    var _ref2 = this.networkDetail.data || {},
        netw = _ref2.id;

    this.addQueue = _.map(checkedRows, function (c) {
      return {
        netw: netw,
        id: c.id,
        service: 2,
        rnode: c.rnode,
        rservice: 4,
        memo: c.memo
      };
    });
    var addFunc = function addFunc() {
      if (_this2.addQueue.length > 0) {
        var node = _this2.addQueue.pop();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__api_callAPI__["a" /* default */])({
          method: 'POST',
          endpoint: '/tdmng/pairs',
          body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, node)
        }).then(function () {
          _.find(rows, function (d) {
            return d.id === node.id;
          }).added = 'success';
          _this2.setState({ rows: rows });
          addFunc();
        }).catch(function (err) {
          _.find(rows, function (d) {
            return d.id === node.id;
          }).added = err.code;
          addFunc();
        });
      } else {
        _this2.setState({ rows: rows, view: 'result', submitStatus: 'success' });
      }
    };
    addFunc();
  };

  BatchPairs.prototype.handleReImport = function handleReImport() {
    this.setState({
      view: 'dropzone',
      file: null
    });
  };

  BatchPairs.prototype.toggleCheck = function toggleCheck(row) {
    var checkedRows = this.state.checkedRows;

    if (_.some(checkedRows, { idx: row.idx })) {
      this.setState({
        checkedRows: _.filter(checkedRows, function (r) {
          return r.idx !== row.idx;
        })
      });
    } else {
      checkedRows.push(row);
      this.setState({ checkedRows: checkedRows });
    }
  };

  BatchPairs.prototype.toggleCheckAll = function toggleCheckAll() {
    var _state2 = this.state,
        rows = _state2.rows,
        checkedRows = _state2.checkedRows;

    var validRows = _.filter(rows, 'valid');
    if (validRows.length === checkedRows.length) {
      this.setState({ checkedRows: [] });
    } else {
      this.setState({ checkedRows: validRows });
    }
  };

  BatchPairs.prototype.parseResultError = function parseResultError(x) {
    if (_.startsWith(x, 'GENERALERROR')) {
      return this.intlMsg.errorMsg('GENERALERROR');
    }
    return this.intlMsg.msg('result.fail') + ": " + x;
  };

  BatchPairs.prototype.renderTools = function renderTools() {
    var _this3 = this;

    var encoding = this.state.encoding;

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_21__BatchNodes_styles_scss___default.a.tools },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_InlineSelect__["a" /* default */], {
        options: kEncodingOptions,
        onChange: function onChange(xs) {
          return _this3.handleChangeEncoding(xs[0]);
        },
        values: [encoding]
      })
    );
  };

  BatchPairs.prototype.renderDropzone = function renderDropzone() {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      null,
      this.renderTools(),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_react_dropzone___default.a,
        {
          className: __WEBPACK_IMPORTED_MODULE_21__BatchNodes_styles_scss___default.a.dropzone,
          activeClassName: __WEBPACK_IMPORTED_MODULE_21__BatchNodes_styles_scss___default.a['dropzone-active'],
          onDrop: this.handleDrop
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: "text-center" },
          this.intlMsg.msg('dropzone.text')
        )
      )
    );
  };

  BatchPairs.prototype.renderPreview = function renderPreview() {
    var _this4 = this;

    var _state3 = this.state,
        _state3$canSubmit = _state3.canSubmit,
        canSubmit = _state3$canSubmit === undefined ? true : _state3$canSubmit,
        submitStatus = _state3.submitStatus;


    var isPending = submitStatus === 'pending';
    var _state4 = this.state,
        rows = _state4.rows,
        checkedRows = _state4.checkedRows;

    var headers = kListHeaders;
    headers = _.filter(headers, function (h) {
      return !kInnerFields.includes(h) && !kRequiredFields.includes(h);
    });
    headers = _.concat(kRequiredFields, headers);
    var ths = headers.map(function (h) {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "th",
        { key: h, style: { whiteSpace: 'nowrap' } },
        h
      );
    });
    var trs = rows.map(function (r) {
      var status = null;
      if (r.added === 'success') {
        status = 'result-succ';
      } else if (!_.isNil(r.added)) {
        status = 'result-fail';
      }
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "tr",
        { key: r.deveui, styleName: (r.error ? 'result-fail' : '') + " " + (status || '') },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          { styleName: "f-checkbox" },
          r.error ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-times" }) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_Checkbox__["a" /* default */], {
            id: r.deveui,
            checked: _.some(checkedRows, { idx: r.idx }),
            onChange: function onChange() {
              return _this4.toggleCheck(r);
            },
            disabled: !r.valid || isPending
          })
        ),
        headers.map(function (h) {
          var c = void 0;
          if (r.missings.includes(h)) {
            c = _this4.intlMsg.msg('preview.required');
          } else {
            c = r[h];
          }
          return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "td",
            {
              key: r.deveui + "-" + h,
              className: r.missings.includes(h) ? __WEBPACK_IMPORTED_MODULE_21__BatchNodes_styles_scss___default.a.missing : '',
              style: { whiteSpace: 'nowrap' }
              // styleName={sty}
            },
            c
          );
        })
      );
    });

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      { styleName: "preview" },
      this.renderTools(),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Table"],
        {
          className: "aisz-table-light",
          striped: true,
          responsive: true,
          bordered: true,
          hover: true
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              { styleName: "f-checkbox" },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_Checkbox__["a" /* default */], {
                id: "all",
                disabled: isPending,
                checked: _.filter(rows, 'valid').length === checkedRows.length,
                onChange: this.toggleCheckAll
              })
            ),
            ths
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "tbody",
          null,
          trs
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { styleName: "submit" },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
          { bsStyle: "aisz-warning", onClick: function onClick() {
              return _this4.setState({ view: 'dropzone' });
            } },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-repeat" }),
          ' ',
          this.intlMsg.msg('preview.cancel.btn')
        ),
        ' ',
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-primary",
            onClick: this.handleSubmitImport,
            disabled: checkedRows.length === 0 || !canSubmit
          },
          this.intlMsg.msg('preview.import.btn.seg1'),
          ' ',
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Badge"],
            { bsClass: "aisz-badge-primary-i" },
            checkedRows.length
          ),
          ' ',
          this.intlMsg.msg('preview.import.btn.seg2'),
          ' ',
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-arrow-circle-o-right" })
        )
      )
    );
  };

  BatchPairs.prototype.renderResult = function renderResult() {
    var _this5 = this;

    var rows = this.state.rows;

    var headers = kListHeaders;
    headers = _.filter(headers, function (h) {
      return !kInnerFields.includes(h);
    });
    var ths = headers.map(function (h, i) {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "th",
        { key: i, style: { whiteSpace: 'nowrap' } },
        h
      );
    }); // eslint-disable-line

    var trs = rows.map(function (r, i) {
      var status = r.added === 'success' ? 'succ' : 'fail';
      var icon = void 0;
      var msg = _this5.intlMsg.msg('result.notimport');
      if (status === 'succ') {
        icon = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-check" });
        msg = _this5.intlMsg.msg('result.succ');
      } else {
        icon = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-times" });
        msg = _this5.parseResultError(r.added);
      }
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "tr",
        { key: String(i), styleName: "result-" + status },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          { style: { whiteSpace: 'nowrap' } },
          icon
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          { style: { whiteSpace: 'nowrap' } },
          msg
        ),
        headers.map(function (h, idx) {
          return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "td",
            { key: idx, style: { whiteSpace: 'nowrap' } },
            r[h]
          ) // eslint-disable-line
          ;
        })
      );
    });

    var succCount = _.filter(rows, function (r) {
      return _.has(r, 'added') && r.added === 'success';
    }).length;
    var failCount = _.filter(rows, function (r) {
      return _.has(r, 'added') && r.added !== 'success';
    }).length;

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Table"],
        {
          className: "aisz-table-light",
          responsive: true,
          bordered: true
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('result.thead.status')
            ),
            ths
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "tbody",
          null,
          trs
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        { styleName: "result-summary" },
        this.intlMsg.msg('result.summary.seg1'),
        ': ',
        succCount,
        ",",
        ' ',
        this.intlMsg.msg('result.summary.seg2'),
        ': ',
        failCount,
        ",",
        ' ',
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_router__["f" /* Link */],
          { onClick: this.handleReImport },
          this.intlMsg.msg('result.summary.reimport')
        ),
        ' ',
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_router__["f" /* Link */],
          { onClick: function onClick() {
              return _this5.props.pushState('/network/tdm');
            } },
          this.intlMsg.msg('result.summary.back')
        )
      )
    );
  };

  BatchPairs.prototype.renderErrorModal = function renderErrorModal() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-warning",
        show: !_.isNil(this.state.error),
        onHide: function onHide() {
          return _this6.setState({ error: null });
        }
      },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle" }),
          ' ',
          this.intlMsg.msg('err.modalheader')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: "text-center" },
          "333333"
        )
      )
    );
  };

  BatchPairs.prototype.render = function render() {
    var _this7 = this;

    var breadcrumb = [{
      content: 'TDM',
      onClick: function onClick() {
        return _this7.props.pushState('/network/tdm');
      }
    }, {
      content: this.intlMsg.msg('pairs.title'),
      active: true
    }];

    var helpHeader = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "span",
      null,
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-book" }),
      ' ',
      this.intlMsg.msg('help.panelheader')
    );

    var view = this.state.view;


    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Grid"],
        { fluid: true },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Panel"],
              { bsStyle: "aisz-white" },
              view === 'dropzone' && this.renderDropzone(),
              view === 'preview' && this.renderPreview(),
              view === 'result' && this.renderResult()
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Panel"],
              { bsStyle: "aisz-white", header: helpHeader },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "code",
                null,
                "name,deveui,name2,deveui2, remark"
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("br", null),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "code",
                null,
                "\u529F\u56FE\u540D\u79F0,3a8dec3194fa36ce,\u7535\u53C2\u540D\u79F0,af8dec3194fa36aa,\u5907\u6CE8"
              )
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "div",
        null,
        this.renderErrorModal()
      )
    );
  };

  return BatchPairs;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

BatchPairs.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    typesJSON: state.tdm.setting,
    networkDetail: state.tdm.getNetwork
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_14_react_css_modules___default()(BatchPairs, __WEBPACK_IMPORTED_MODULE_21__BatchNodes_styles_scss___default.a, { allowMultiple: true }))));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loraactions_tdm__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Network__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Node__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Gateway__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Pairs__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);












var propTypes = {
  getNetwork: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  typesJSON: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  networkDetail: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  action: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired
};

var Detail = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Detail, _React$Component);

  function Detail(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Detail);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      network: ""
    };
    _this.onChangeNetwork = _this.onChangeNetwork.bind(_this);
    return _this;
  }

  Detail.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        networkDetail = _props.networkDetail,
        typesJSON = _props.typesJSON;

    this.initNetwork(networkDetail, typesJSON);
  };

  Detail.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var networkDetail = _ref.networkDetail,
        typesJSON = _ref.typesJSON;

    if (!_.isEqual(networkDetail, this.props.networkDetail)) {
      this.initNetwork(networkDetail, typesJSON);
    }
    if (!_.isEqual(typesJSON, this.props.typesJSON)) {
      this.initNetwork(networkDetail, typesJSON);
    }
  };

  Detail.prototype.onChangeNetwork = function onChangeNetwork(network) {
    this.setState({ network: network });
    this.props.getNetwork();
  };

  Detail.prototype.initNetwork = function initNetwork(networkDetail, typesJSON) {
    var _ref2 = networkDetail.data || {},
        name = _ref2.name;

    var _parseContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* parseContent */])(typesJSON),
        types = _parseContent.types;

    if (name && types.networktypes) {
      var nwks = _.find(types.networktypes, function (n) {
        return n.networks && n.networks.name === name;
      });
      if (nwks && nwks.networks) {
        this.setState({ network: nwks.networks.name });
      }
    }
  };

  Detail.prototype.render = function render() {
    var network = this.state.network;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.tdm },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Network__["a" /* default */], { onSubmitted: this.onChangeNetwork, network: network }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Node__["a" /* default */], { network: network, routerAction: this.props.action }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Gateway__["a" /* default */], { network: network, routerAction: this.props.action }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Pairs__["a" /* default */], { network: network, routerAction: this.props.action })
    );
  };

  return Detail;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Detail.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, _ref3) {
  var action = _ref3.location.action;
  return {
    action: action,
    typesJSON: state.tdm.setting,
    networkDetail: state.tdm.getNetwork
  };
};

var mapDispatchToProps = {
  getNetwork: __WEBPACK_IMPORTED_MODULE_6_loraactions_tdm__["a" /* getNetwork */]
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(Detail));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_Select__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_InlineSelect__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_scss__);






/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);















var kInitalState = {
  submitted: false,
  type: 8,
  id: '',
  mac2: '',
  status: '',
  remark: '',
  penalty: null,
  errors: __WEBPACK_IMPORTED_MODULE_11_lorautils_errors_ErrorSet__["a" /* default */].createEmpty().add('FE_EMPTY', 'id')
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_9_react_intl__["intlShape"].isRequired,
  show: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,
  onAdded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
  network: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  typesJSON: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired,
  deleteNode: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired
};

var CreateModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CreateModal, _React$Component);

  function CreateModal(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, CreateModal);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    var _parseContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util__["a" /* parseContent */])(props.typesJSON),
        types = _parseContent.types;

    _this.state = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, kInitalState, {
      show: props.show,
      network: props.network
    });
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_15_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.gateway.create');
    _this.types = types;
    _this.deleteNode = props.deleteNode;
    _this.onHide = _this.onHide.bind(_this);
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.onChangeType = _this.onChangeType.bind(_this);
    _this.typeOptions = [{ label: _this.intlMsg.msg('8channels'), value: 8 }, { label: _this.intlMsg.msg('16channels'), value: 16 }];
    return _this;
  }

  CreateModal.prototype.componentWillMount = function componentWillMount() {
    this.loadGateways();
  };

  CreateModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var show = _ref.show,
        network = _ref.network,
        deleteNode = _ref.deleteNode,
        typesJSON = _ref.typesJSON;

    if (show !== this.props.show) {
      this.setState({ show: show });
    }
    if (network !== this.props.network) {
      this.setState({ network: network });
    }
    if (!_.isEqual(deleteNode, this.deleteNode)) {
      this.deleteNode = deleteNode;
      this.tdmGateways = _.filter(this.tdmGateways, function (t) {
        return t.id !== deleteNode.id;
      });
      this.compareGateways();
    }
    if (!_.isEqual(typesJSON, this.props.typesJSON)) {
      var _parseContent2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util__["a" /* parseContent */])(typesJSON),
          types = _parseContent2.types;

      this.types = types;
    }
  };

  CreateModal.prototype.loadGateways = function loadGateways() {
    var _this2 = this;

    // eslint-disable-line
    var p1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__api_callAPI__["a" /* default */])({ endpoint: '/lora/gateways?q=&mark=&sort=-lastOn&limit=1000' });
    var p2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__api_callAPI__["a" /* default */])({ endpoint: '/tdmng/gateways?mark=&limit=1000' });
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([p1, p2]).then(function (_ref2) {
      var res1 = _ref2[0],
          res2 = _ref2[1];

      _this2.gateways = res1.list;
      _this2.tdmGateways = res2.list;
      _this2.compareGateways();
    }).catch(function () {});
  };

  CreateModal.prototype.compareGateways = function compareGateways() {
    var disableds = [];
    _.forEach(this.tdmGateways, function (t) {
      disableds.push({ id: t.id });
      if (t.mac2) {
        disableds.push({ id: t.mac2 });
      }
    });
    this.availableList = _.xorBy(disableds, this.gateways, 'id');
    var gatewayOpts = _.map(this.availableList, function (a) {
      return { label: a.name, value: a.id };
    });
    this.setState({ gatewayOpts: gatewayOpts });
  };

  CreateModal.prototype.onChangeType = function onChangeType(xs) {
    var errors = this.state.errors;

    this.setState({ type: xs[0] });
    if (xs[0] === 16) {
      this.setState({ mac2: '', errors: errors.add('FE_EMPTY', 'mac2') });
    }
  };

  CreateModal.prototype.onChangeSelect = function onChangeSelect(s, key) {
    var _setState,
        _this3 = this;

    var errors = this.state.errors;

    errors = errors.remove(key);

    this.setState((_setState = {}, _setState[key] = s, _setState.errors = errors, _setState), function () {
      var _state = _this3.state,
          mac2 = _state.mac2,
          id = _state.id;

      if (mac2 && mac2 === id) {
        errors = errors.add('FE_GW_MUST_DIFFEFRENT', 'id').add('FE_GW_MUST_DIFFEFRENT', 'mac2');
        _this3.setState({ errors: errors });
      } else {
        errors = errors.remove('id').remove('mac2');
        _this3.setState({ errors: errors });
      }
    });
  };

  CreateModal.prototype.onChangeIpt = function onChangeIpt(e, key) {
    var _setState2;

    var p = _.trim(e.target.value);
    var errors = this.state.errors;

    if (p === '' || _.isInteger(_.toNumber(p)) && _.toNumber(p) >= 0 && _.toNumber(p) <= 255) {
      errors = errors.remove(key);
    } else {
      errors = errors.add('FE_EMPTY', key);
    }
    this.setState((_setState2 = {}, _setState2[key] = p, _setState2.errors = errors, _setState2));
  };

  CreateModal.prototype.onHide = function onHide() {
    this.props.onHide();
    this.setState(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, kInitalState));
  };

  CreateModal.prototype.onSubmit = function onSubmit() {
    var _this4 = this;

    var errors = this.state.errors;

    errors = errors.remove('submit');
    this.setState({ submitted: true });
    if (!errors.isEmpty()) return;

    var _state2 = this.state,
        type = _state2.type,
        id = _state2.id,
        mac2 = _state2.mac2,
        network = _state2.network,
        remark = _state2.remark,
        penalty = _state2.penalty;

    var config = _.find(this.types.networktypes, function (n) {
      return n.networks && n.networks.name === network;
    });
    if (!config) return;

    var memo = { remark: _.trimEnd(remark) };
    var gw1 = _.find(this.gateways, function (g) {
      return g.id === id;
    });
    var gw2 = _.find(this.gateways, function (g) {
      return g.id === mac2;
    });
    if (gw1) {
      memo.name1 = gw1.name;
    }
    if (gw2) {
      memo.name2 = gw2.name;
    }

    var body = { id: id, mac2: mac2, memo: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(memo) };
    var channelKey = String(type);
    var rxch = 4;
    if (!_.isNil(config.rxch)) {
      rxch = config.rxch[channelKey];
    }
    var bchannels = config.bchannels[channelKey];
    var rx2ch = bchannels[_.random(0, bchannels.length - 1)];

    var channel = config.tchannels.parameters;
    var xoffs = (config.tchannels.xoffs || {})[channelKey] || [];
    var tchannels = _.map(config.tchannels.channels[channelKey], function (id1, idx) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, channel, { id: id1, xoff: xoffs[idx]
      });
    });

    var pair = config.pairs.parameters;
    var pairs = _.map(config.pairs.channels[channelKey], function (id2) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, pair, {
        pairs: (config.pairs.pairs || {})[channelKey],
        src: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, pair.src, { channel: id2 }),
        dst: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, pair.dst, { channel: id2 })
      });
    });

    body = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, body, { rxch: rxch, bchannels: bchannels, rx2ch: rx2ch, tchannels: tchannels, pairs: pairs });
    body.penalty = _.toNumber(penalty) || 0;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__api_callAPI__["a" /* default */])({
      body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, body),
      method: 'POST',
      endpoint: '/tdmng/gateways'
    }).then(function () {
      _this4.onHide();
      _this4.props.onAdded();
      _this4.resetGateways(body);
    }).catch(function (err) {
      _this4.setState({ errors: errors.add(err.code, 'submit') });
    });
  };

  CreateModal.prototype.resetGateways = function resetGateways(gw) {
    this.tdmGateways.push(gw);
    this.compareGateways();
  };

  CreateModal.prototype.render = function render() {
    var _this5 = this;

    var _state3 = this.state,
        id = _state3.id,
        mac2 = _state3.mac2,
        show = _state3.show,
        type = _state3.type,
        status = _state3.status,
        errors = _state3.errors,
        remark = _state3.remark,
        penalty = _state3.penalty,
        submitted = _state3.submitted,
        _state3$gatewayOpts = _state3.gatewayOpts,
        gatewayOpts = _state3$gatewayOpts === undefined ? [] : _state3$gatewayOpts;


    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-light",
        backdrop: "static",
        show: show,
        onHide: this.onHide
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        this.intlMsg.msg('header')
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Form"],
          { horizontal: true, onSubmit: this.handleSubmit },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                this.intlMsg.msg('type')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_InlineSelect__["a" /* default */], {
                options: this.typeOptions,
                onChange: this.onChangeType,
                values: [type]
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormGroup"],
            { validationState: submitted && errors.has('id') ? 'error' : undefined },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                this.intlMsg.msg('id')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Select__["a" /* default */], {
                value: id,
                options: gatewayOpts,
                onChange: function onChange(s) {
                  return _this5.onChangeSelect(s, 'id');
                }
              }),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_ControlTips__["a" /* default */], {
                message: this.intlMsg.errorMsg(errors.get('id')),
                show: submitted && errors.has('id'),
                azStyle: "danger"
              })
            )
          ),
          type === 16 && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormGroup"],
            { validationState: submitted && errors.has('mac2') ? 'error' : undefined },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                this.intlMsg.msg('mac2')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Select__["a" /* default */], {
                value: mac2,
                options: gatewayOpts,
                onChange: function onChange(s) {
                  return _this5.onChangeSelect(s, 'mac2');
                }
              }),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_ControlTips__["a" /* default */], {
                message: this.intlMsg.errorMsg(errors.get('mac2')),
                show: submitted && errors.has('mac2'),
                azStyle: "danger"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                this.intlMsg.msg('penalty')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormControl"], {
                value: penalty,
                placeholder: "0~255",
                bsClass: "aisz-form-control-f",
                onChange: function onChange(e) {
                  return _this5.onChangeIpt(e, 'penalty');
                }
              }),
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_ControlTips__["a" /* default */], {
                message: '0~255',
                show: submitted && errors.has('penalty'),
                azStyle: "danger"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["ControlLabel"],
                { bsClass: "aisz-control-label" },
                this.intlMsg.msg('remark')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["FormControl"], {
                value: remark,
                bsClass: "aisz-form-control-f",
                onChange: function onChange(e) {
                  return _this5.setState({ remark: _.trimStart(e.target.value) });
                }
              })
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"].Footer,
        null,
        errors.has('submit') && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.error },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle", "aria-hidden": "true" }),
          "\xA0",
          this.intlMsg.errorMsg(errors.get('submit'))
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-default",
            onClick: this.onHide,
            className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.white
          },
          this.intlMsg.msg('cancel')
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-success",
            onClick: this.onSubmit,
            disabled: status === 'pending'
          },
          status === 'pending' && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("i", { className: "fa fa-spin fa-spinner m-r-s" }),
          this.intlMsg.msg('confirm')
        )
      )
    );
  };

  return CreateModal;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

CreateModal.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    typesJSON: state.tdm.setting
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["connect"])(mapStateToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"])(CreateModal)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Node_styles_scss__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Node_styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Node_styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);










var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  showModal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  onCancel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};

var ResetModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ResetModal, _React$Component);

  function ResetModal(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ResetModal);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      showModal: props.showModal,
      id: props.id
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.gateway.reset');
    _this.submiteReset = _this.submiteReset.bind(_this);
    return _this;
  }

  ResetModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var showModal = _ref.showModal,
        id = _ref.id;

    if (showModal !== this.props.showModal) {
      this.setState({ showModal: showModal });
    }
    if (id !== this.props.id) {
      this.setState({ id: id });
    }
  };

  ResetModal.prototype.submiteReset = function submiteReset() {
    var _this2 = this;

    var id = this.state.id;


    this.setState({ resetStatus: 'pending' });

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__api_callAPI__["a" /* default */])({
      endpoint: "/tdmng/gateways/" + id + "/ctrl/reset",
      method: 'POST'
    }).then(function () {
      _this2.setState({ resetStatus: 'success' });

      _.delay(function () {
        _this2.setState({ resetStatus: '' });
        _this2.props.onCancel();
      }, 1000);
    }).catch(function () {
      _this2.setState({ resetStatus: 'failure' });

      _.delay(function () {
        _this2.setState({ resetStatus: '' });
      }, 1000);
    });
  };

  ResetModal.prototype.render = function render() {
    var _state = this.state,
        showModal = _state.showModal,
        resetStatus = _state.resetStatus;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-warning",
        backdrop: "static",
        show: showModal,
        onHide: this.props.onCancel
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        this.intlMsg.msg('title')
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "text-center" },
          this.intlMsg.msg('content')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Footer,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
            {
              bsStyle: "aisz-default",
              onClick: this.props.onCancel,
              className: __WEBPACK_IMPORTED_MODULE_10__Node_styles_scss___default.a.white
            },
            this.intlMsg.msg('cancel')
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
            {
              bsStyle: "aisz-warning",
              onClick: this.submiteReset,
              disabled: resetStatus === 'pending'
            },
            resetStatus === 'pending' && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spin fa-spinner m-r-s" }),
            this.intlMsg.msg('confirm')
          )
        )
      )
    );
  };

  return ResetModal;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ResetModal.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(ResetModal));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_TablePagerTDM__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_LoadingTable__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loraactions_tdm__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lorautils_pagerUtil__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__CreateModal__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ResetModal__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



















var kLimit = 10;
var kGatewayTdmLimit = 1000;
var kMarksKey = 'gatewayMarks';
var kRouteAction = ['POP', 'REPLACE'];

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_react_intl__["intlShape"].isRequired,
  network: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  routerAction: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  updateTdmGateways: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};

var Gateway = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Gateway, _React$Component);

  function Gateway(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Gateway);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      list: [],
      status: '',
      deleteNode: {},
      network: props.network
    };
    _this.marks = [];
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.gateway');
    _this.callback = _this.callback.bind(_this);
    _this.handlePaging = _this.handlePaging.bind(_this);
    return _this;
  }

  Gateway.prototype.componentDidMount = function componentDidMount() {
    if (_.includes(kRouteAction, this.props.routerAction)) {
      this.marks = __WEBPACK_IMPORTED_MODULE_16_lorautils_pagerUtil__["a" /* pageParams */].getMarks(kMarksKey) || [];
      if (this.marks.length > 1) {
        this.mark = this.marks[this.marks.length - 2];
      }
    }
    this.loadGateways();
    this.loadGatewaysAll();
  };

  Gateway.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var network = _ref.network;

    if (network !== this.props.network) {
      this.setState({ network: network });
    }
  };

  Gateway.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_16_lorautils_pagerUtil__["a" /* pageParams */].setMarks(this.marks, kMarksKey);
  };

  Gateway.prototype.loadGateways = function loadGateways() {
    var _this2 = this;

    this.setState({ status: 'pending' });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__api_callAPI__["a" /* default */])({
      endpoint: '/tdmng/gateways',
      query: { limit: kLimit, mark: this.mark }
    }).then(function (_ref2) {
      var list = _ref2.list,
          more = _ref2.more,
          mark = _ref2.mark;

      _this2.marks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lorautils_pagerUtil__["b" /* updateMarks */])(_this2.marks, mark);
      _this2.setState({ list: list, more: more, mark: _this2.marks, status: 'success' });
    }).catch(function () {});
  };

  Gateway.prototype.loadGatewaysAll = function loadGatewaysAll() {
    var _this3 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__api_callAPI__["a" /* default */])({
      endpoint: '/tdmng/gateways',
      query: { mark: 0, limit: kGatewayTdmLimit }
    }).then(function (res) {
      var data = res || {};
      _this3.props.updateTdmGateways(data);
    }).catch(function () {});
  };

  Gateway.prototype.deleteGateway = function deleteGateway() {
    var _this4 = this;

    var deleteNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__api_callAPI__["a" /* default */])({
      method: 'DELETE',
      endpoint: "/tdmng/gateways/" + deleteNode.id
    }).then(function () {
      _this4.resetMark();
      _this4.loadGateways();
      _this4.loadGatewaysAll();
      _this4.setState({ deleteNode: deleteNode });
    }).catch(function () {});
  };

  Gateway.prototype.resetGateway = function resetGateway(id) {
    this.setState({ resetId: id, showReset: true });
  };

  Gateway.prototype.handlePaging = function handlePaging(mark) {
    this.mark = mark;
    this.loadGateways();
  };

  Gateway.prototype.resetMark = function resetMark() {
    this.mark = 0;
    this.marks = [];
    this.setState({ reset: new Date().valueOf() });
  };

  Gateway.prototype.callback = function callback() {
    this.resetMark();
    this.loadGateways();
    this.loadGatewaysAll();
  };

  Gateway.prototype.render = function render() {
    var _this5 = this;

    var _state = this.state,
        list = _state.list,
        status = _state.status,
        network = _state.network,
        deleteNode = _state.deleteNode,
        _state$mark = _state.mark,
        mark = _state$mark === undefined ? '' : _state$mark,
        _state$reset = _state.reset,
        reset = _state$reset === undefined ? 0 : _state$reset,
        resetId = _state.resetId,
        _state$more = _state.more,
        more = _state$more === undefined ? false : _state$more,
        _state$showCreate = _state.showCreate,
        showCreate = _state$showCreate === undefined ? false : _state$showCreate,
        _state$showReset = _state.showReset,
        showReset = _state$showReset === undefined ? false : _state$showReset;

    var content = null;
    var thead = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "thead",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('type')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('gateway1')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('mac1')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('gateway2')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('mac2')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('penalty')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('remark')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('reset')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('delete')
        )
      )
    );
    if (status === 'success') {
      content = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Table"],
        { className: "aisz-table-light", striped: true },
        thead,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "tbody",
          null,
          _.map(list, function (l) {
            var memo = l.memo ? JSON.parse(l.memo) : {};
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "tr",
              { key: l.id },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                l.mac2 ? _this5.intlMsg.msg('16channels') : _this5.intlMsg.msg('8channels')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                memo.name1 || '--'
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                  { to: "/network/tdm/gateway/" + l.id },
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_IdUtils__["a" /* normalizeDevEUI */])(l.id)
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                memo.name2 || '--'
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                l.mac2 ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
                  { to: "/network/tdm/gateway/" + l.id },
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_IdUtils__["a" /* normalizeDevEUI */])(l.mac2)
                ) : '--'
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                { className: "text-center" },
                l.penalty
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                memo.remark
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "a",
                  {
                    onClick: function onClick() {
                      return _this5.resetGateway(l.id);
                    },
                    className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.resetGateway
                  },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-repeat" })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "a",
                  {
                    className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.deleteBtn,
                    onClick: function onClick() {
                      return _this5.deleteGateway(l);
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "halflings halflings-trash" })
                )
              )
            );
          })
        )
      );
    } else {
      content = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_loracoms_LoadingTable__["a" /* default */],
        {
          className: "aisz-table-light",
          striped: true,
          bordered: true,
          rows: 1,
          cols: 9
        },
        thead
      );
    }

    var header = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      this.intlMsg.msg('title'),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: "pull-right" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-success",
            disabled: !network,
            onClick: function onClick() {
              return _this5.setState({ showCreate: true });
            },
            className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.addBtn
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-plus", "aria-hidden": "true" }),
          "\xA0",
          this.intlMsg.msg('add')
        )
      )
    );
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: header },
      content,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_loracoms_ShowIf__["a" /* default */],
        { "if": status === 'success' && !list.length },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.noData },
          this.intlMsg.msg('nodata')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_loracoms_ShowIf__["a" /* default */],
        { "if": list.length > 0 },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_19__styles_scss___default.a.pager },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_TablePagerTDM__["a" /* default */], {
            status: status,
            mark: mark,
            more: more,
            reset: reset,
            onPrev: this.handlePaging,
            onNext: this.handlePaging
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__CreateModal__["a" /* default */], {
        show: showCreate,
        deleteNode: deleteNode,
        network: network,
        onAdded: this.callback,
        onHide: function onHide() {
          return _this5.setState({ showCreate: false });
        }
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ResetModal__["a" /* default */], {
        showModal: showReset,
        id: resetId,
        onCancel: function onCancel() {
          return _this5.setState({ showReset: false });
        }
      })
    );
  };

  return Gateway;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Gateway.propTypes = propTypes;

var mapDispatchProps = {
  updateTdmGateways: __WEBPACK_IMPORTED_MODULE_14_loraactions_tdm__["b" /* updateTdmGateways */]
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["connect"])(null, mapDispatchProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(Gateway)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_CollapseToggle__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);











var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_7_react_intl__["intlShape"].isRequired,
  status: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,
  gatewayStatus: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};

var Channels = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Channels, _React$Component);

  function Channels(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Channels);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      list: [],
      status: props.status
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.gateway.channel');
    return _this;
  }

  Channels.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var gatewayStatus = _ref.gatewayStatus,
        status = _ref.status;

    if (!_.isEqual(gatewayStatus, this.props.gatewayStatus)) {
      this.initData(gatewayStatus);
    }
    if (status !== this.props.status) {
      this.setState({ status: status });
    }
  };

  Channels.prototype.initData = function initData() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$channels = _ref2.channels,
        channels = _ref2$channels === undefined ? [] : _ref2$channels;

    var list = [];
    _.forEach(channels, function (_ref3) {
      var channel = _ref3.channel,
          services = _ref3.services;

      var ser = _.map(services, function (s) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, s, { channel: channel });
      });
      list = _.concat(list, ser);
    });
    this.setState({ list: list });
  };

  Channels.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        _state$list = _state.list,
        list = _state$list === undefined ? [] : _state$list,
        _state$expanded = _state.expanded,
        expanded = _state$expanded === undefined ? true : _state$expanded;

    var header = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { styleName: "header" },
      this.intlMsg.msg('header'),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_CollapseToggle__["a" /* default */], {
        expanded: expanded,
        onChange: function onChange(v) {
          return _this2.setState({ expanded: v });
        }
      })
    );
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
      {
        collapsible: true,
        header: header,
        bsStyle: "aisz-white"
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Table"],
        { className: "aisz-table-light", striped: true },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('id')
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('service')
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('used')
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('free')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "tbody",
          null,
          _.map(list, function (l, idx) {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "tr",
              { key: idx },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_RichLabel__["a" /* default */], { content: String(l.channel) })
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                null,
                l.service
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                null,
                l.used
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "td",
                null,
                l.free
              )
            );
          })
        )
      )
    );
  };

  return Channels;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Channels.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_6_react_css_modules___default()(Channels, __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a, { allowMultiple: true })));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loraactions_gateway__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_TablePager__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_loracoms_SearchInput__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




















var kLimit = 20;
var kFormat = 'YYYY-MM-DD HH:mm:ss';
var kNodeHeaderTitle = [{ title: '全部', value: 'allnodes' }, { title: '功图', value: 'workmapnodes' }, { title: '压力', value: 'pressnodes' }, { title: '电参', value: 'electrinodes' }, { title: '温度', value: 'tempnodes' }];

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  gatewayDetail: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  replaceState: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  getGateway: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};

var NodeList = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(NodeList, _React$Component);

  function NodeList(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NodeList);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      gatewayDetail: props.gatewayDetail
    };
    _this.allNodes = [];
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.node');
    _this.handlePaging = _this.handlePaging.bind(_this);
    return _this;
  }

  NodeList.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        getGateway = _props.getGateway,
        id = _props.id;

    getGateway(id);
    this.handleTitle();
    this.loadStatus();
  };

  NodeList.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var gatewayDetail = _ref.gatewayDetail;

    if (!_.isEqual(gatewayDetail, this.props.gatewayDetail)) {
      this.setState({ gatewayDetail: gatewayDetail });
    }
  };

  NodeList.prototype.loadStatus = function loadStatus() {
    var _this2 = this;

    var _props2 = this.props,
        type = _props2.type,
        id = _props2.id;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__api_callAPI__["a" /* default */])({
      endpoint: "/tdmng/gateways/" + id + "/status"
    }).then(function (res) {
      var _ref2 = res || {},
          _ref2$liveness = _ref2.liveness,
          liveness = _ref2$liveness === undefined ? [] : _ref2$liveness;

      var nodeTitle = _.find(kNodeHeaderTitle, { value: type });

      var _ref3 = nodeTitle || {},
          title = _ref3.title;

      var allNodes = liveness;
      if (title !== '全部') {
        allNodes = _.filter(liveness, function (l) {
          return l.type === title;
        });
      }
      _this2.allNodes = _.cloneDeep(allNodes);
      var more = false;
      if (allNodes.length > kLimit) {
        more = true;
      }
      var showNodes = _.slice(allNodes, 0, kLimit);
      _this2.setState({ loadStatus: 'success', allNodes: allNodes, showNodes: showNodes, more: more, mark: kLimit });
    }).catch(function () {});
  };

  NodeList.prototype.handleTitle = function handleTitle() {
    var type = this.props.type;

    var node = _.find(kNodeHeaderTitle, { value: type });

    var _ref4 = node || {},
        title = _ref4.title;

    this.setState({ nodeTitle: title });
  };

  NodeList.prototype.handlePaging = function handlePaging(page) {
    var allNodes = this.state.allNodes;

    var showNodes = _.slice(allNodes, 0, kLimit);
    var mark = kLimit;
    if (_.isInteger(page)) {
      mark = page + kLimit;
      showNodes = _.slice(allNodes, page, mark);
    }
    var more = false;
    if (allNodes.length > mark) {
      more = true;
    }
    this.setState({ showNodes: showNodes, mark: mark, more: more });
  };

  NodeList.prototype.handleSearch = function handleSearch(e) {
    var _this3 = this;

    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }

    var value = e.target.value;
    if (value.length > 0) {
      value = value.replace(/[:-]/g, '');
    }
    this.searchTimer = _.delay(function () {
      var allNodes = _this3.state.allNodes;

      if (value !== '') {
        allNodes = _.filter(_this3.allNodes, function (a) {
          return a.node.indexOf(value) > -1;
        });
      } else {
        allNodes = _this3.allNodes;
      }
      var more = false;
      if (allNodes.length > kLimit) {
        more = true;
      }
      var showNodes = _.slice(allNodes, 0, kLimit);
      _this3.setState({
        allNodes: allNodes,
        showNodes: showNodes,
        more: more,
        mark: kLimit,
        reset: new Date().valueOf()
      });
    }, 250);
  };

  NodeList.prototype.render = function render() {
    var _this4 = this;

    var _props3 = this.props,
        pushState = _props3.pushState,
        replaceState = _props3.replaceState,
        id = _props3.id;
    var _state = this.state,
        nodeTitle = _state.nodeTitle,
        _state$gatewayDetail = _state.gatewayDetail;
    _state$gatewayDetail = _state$gatewayDetail === undefined ? {} : _state$gatewayDetail;
    var status = _state$gatewayDetail.status,
        _state$gatewayDetail$ = _state$gatewayDetail.data,
        data = _state$gatewayDetail$ === undefined ? {} : _state$gatewayDetail$,
        _state$showNodes = _state.showNodes,
        showNodes = _state$showNodes === undefined ? [] : _state$showNodes,
        loadStatus = _state.loadStatus,
        mark = _state.mark,
        reset = _state.reset,
        search = _state.search,
        _state$more = _state.more,
        more = _state$more === undefined ? false : _state$more;


    var tbody = _.map(showNodes, function (n) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
            { onClick: function onClick() {
                return pushState("/network/tdm/node/" + n.node);
              } },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lorautils_IdUtils__["a" /* normalizeDevEUI */])(n.node)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          n.type
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          !_.isNil(n.lastatt) && n.lastatt !== 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["format"])(n.lastatt, kFormat) : '--'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          !_.isNil(n.lastup) && n.lastup !== 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["format"])(n.lastup, kFormat) : '--'
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "td",
          null,
          !_.isNil(n.lastdn) && n.lastdn !== 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["format"])(n.lastdn, kFormat) : '--'
        )
      );
    });

    var breadcrumb = [{
      onClick: function onClick() {
        return replaceState('/network/tdm');
      },
      content: 'TDM'
    }, {
      onClick: function onClick() {
        return pushState("/network/tdm/gateway/" + id);
      },
      content: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_Nvl__["a" /* default */], { status: status, val: data.name })
    }, {
      content: nodeTitle,
      active: true
    }];

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
        { bsStyle: "aisz-white" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.nodeSearch },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_loracoms_SearchInput__["a" /* default */], {
            value: search,
            placeholder: this.intlMsg.msg('search.placeholder'),
            onChange: function onChange(e) {
              return _this4.handleSearch(e);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Table"],
          { className: "aisz-table-light", striped: true },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                "DevEUI"
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('nodetype')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('status.lastatt')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('status.lastup')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "th",
                null,
                this.intlMsg.msg('status.lastdn')
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tbody",
            null,
            tbody
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_17_loracoms_ShowIf__["a" /* default */],
          { "if": loadStatus === 'success' && !tbody.length },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.noData },
            "\u6682\u65E0\u6570\u636E"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.pager },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_loracoms_TablePager__["a" /* default */], {
            status: loadStatus,
            mark: mark,
            more: more,
            reset: reset,
            onPrev: this.handlePaging,
            onNext: this.handlePaging
          })
        )
      )
    );
  };

  return NodeList;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

NodeList.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, _ref5) {
  var _ref5$params = _ref5.params,
      id = _ref5$params.id,
      type = _ref5$params.type;
  return {
    id: id,
    type: type,
    gatewayDetail: state.gateway.gateway
  };
};

var mapDispatchToProps = {
  getGateway: __WEBPACK_IMPORTED_MODULE_13_loraactions_gateway__["a" /* default */].gateway,
  pushState: __WEBPACK_IMPORTED_MODULE_9_react_router_redux__["routerActions"].push,
  replaceState: __WEBPACK_IMPORTED_MODULE_9_react_router_redux__["routerActions"].replace
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(NodeList)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_PieChart__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var kLabel = {
  normal: {
    formatter: '{b}\n{d}%'
  },
  emphasis: {
    formatter: '{b}\n{d}%'
  }
};

var klabelLine = {
  normal: {
    length: 5,
    length2: 5
  }
};

var kLabelPosition = {
  color: '#34495e',
  normal: {
    position: 'inside'
  }
};

var kItemUsed = {
  normal: {
    color: '#59abe3'
  }
};

var kItemFree = {
  normal: {
    color: '#f4b350'
  }
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_react_intl__["intlShape"].isRequired,
  status: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  gatewayStatus: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired
};

var Pies = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Pies, _React$Component);

  function Pies(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Pies);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      channelSeries: [],
      serviceSeries: [],
      status: props.status
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.gateway.channel');
    return _this;
  }

  Pies.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var status = _ref.status,
        gatewayStatus = _ref.gatewayStatus;

    if (status !== this.props.status) {
      this.setState({ status: status });
    }
    if (!_.isEqual(gatewayStatus, this.props.gatewayStatus)) {
      this.initSeries(gatewayStatus);
    }
  };

  Pies.prototype.initSeries = function initSeries(gatewayStatus) {
    var _this2 = this;

    if (!gatewayStatus.channels) return;

    var channelSeries = _.map(gatewayStatus.channels, function (c) {
      var name = "" + _this2.intlMsg.msg('header') + c.channel;
      var used = _.reduce(c.services, function (sum, n) {
        return sum + n.used;
      }, 0);
      var free = _.reduce(c.services, function (sum, n) {
        return sum + n.free;
      }, 0);
      return {
        name: name,
        series: [{
          name: _this2.intlMsg.msg('pie.used'),
          value: used,
          itemStyle: kItemUsed,
          label: kLabelPosition,
          labelLine: klabelLine
        }, {
          name: _this2.intlMsg.msg('pie.free'),
          value: free,
          itemStyle: kItemFree,
          label: kLabelPosition
        }]
      };
    });

    var services = _.reduce(gatewayStatus.channels, function (c, n) {
      return _.concat(c, n.services);
    }, []);
    var g = _.groupBy(services, 'service');
    var serviceSeries = _.map(_.keys(g), function (k) {
      var ss = g[k];
      var name = "" + _this2.intlMsg.msg('pie.service') + k;
      var used = _.reduce(ss, function (sum, n) {
        return sum + n.used;
      }, 0);
      var free = _.reduce(ss, function (sum, n) {
        return sum + n.free;
      }, 0);
      return {
        name: name,
        series: [{
          name: _this2.intlMsg.msg('pie.used'),
          value: used,
          itemStyle: kItemUsed,
          label: kLabelPosition,
          labelLine: klabelLine
        }, {
          name: _this2.intlMsg.msg('pie.free'),
          value: free,
          itemStyle: kItemFree,
          label: kLabelPosition
        }]
      };
    });
    this.setState({ channelSeries: channelSeries, serviceSeries: serviceSeries });
  };

  Pies.prototype.render = function render() {
    var _state = this.state,
        channelSeries = _state.channelSeries,
        serviceSeries = _state.serviceSeries;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Panel"],
      {
        bsStyle: "aisz-white", header: this.intlMsg.msg('pie.header')
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Row"],
        null,
        _.map(channelSeries, function (c, idx) {
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
            { md: 4, key: String(idx) },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.hpie },
              c.name
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_PieChart__["a" /* default */], {
              height: 200,
              series: [{
                label: kLabel,
                data: c.series
              }]
            })
          );
        })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Row"],
        null,
        _.map(serviceSeries, function (c, idx) {
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Col"],
            { md: 4, key: String(idx) },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.hpie },
              c.name
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_PieChart__["a" /* default */], {
              height: 200,
              series: [{
                label: kLabel,
                data: c.series
              }]
            })
          );
        })
      )
    );
  };

  return Pies;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Pies.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(Pies));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_PropsPanel__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_scss__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);











var kFormatter = function kFormatter(x) {
  if (x) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "span",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["format"])(x, 'YYYY-MM-DD HH:mm:ss')
    );
  }
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    "span",
    null,
    "--"
  );
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_6_react_intl__["intlShape"].isRequired,
  status: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  gatewayStatus: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired
};

var Status = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Status, _React$Component);

  function Status(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Status);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      status: props.status,
      gatewayStatus: props.gatewayStatus
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.gateway.status');
    return _this;
  }

  Status.prototype.componentDidMount = function componentDidMount() {
    this.handleStatusData(this.state.gatewayStatus);
  };

  Status.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var gatewayStatus = _ref.gatewayStatus,
        status = _ref.status;

    if (!_.isEqual(gatewayStatus, this.props.gatewayStatus)) {
      this.setState({ gatewayStatus: gatewayStatus });
      this.handleStatusData(gatewayStatus);
    }
    if (status !== this.props.status) {
      this.setState({ status: status });
    }
  };

  Status.prototype.handleStatusData = function handleStatusData() {
    var gateway = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _gateway$liveness = gateway.liveness,
        liveness = _gateway$liveness === undefined ? [] : _gateway$liveness;

    var allNodes = liveness.length;
    var workMapNodes = _.filter(liveness, function (l) {
      return l.type === '功图';
    }).length;
    var pressNodes = _.filter(liveness, function (l) {
      return l.type === '压力';
    }).length;
    var electriNodes = _.filter(liveness, function (l) {
      return l.type === '电参';
    }).length;
    var tempNodes = _.filter(liveness, function (l) {
      return l.type === '温度';
    }).length;

    this.setState({ allNodes: allNodes, workMapNodes: workMapNodes, pressNodes: pressNodes, electriNodes: electriNodes, tempNodes: tempNodes });
  };

  Status.prototype.render = function render() {
    var id = this.props.id;
    var _state = this.state,
        status = _state.status,
        gatewayStatus = _state.gatewayStatus,
        allNodes = _state.allNodes,
        workMapNodes = _state.workMapNodes,
        pressNodes = _state.pressNodes,
        electriNodes = _state.electriNodes,
        tempNodes = _state.tempNodes;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_PropsPanel__["a" /* default */], {
        readOnly: true,
        title: this.intlMsg.msg('basic.header'),
        data: gatewayStatus,
        status: status,
        properties: [{
          id: 'ver',
          name: this.intlMsg.msg('ver')
        }, {
          id: 'now',
          name: this.intlMsg.msg('now'),
          formatter: kFormatter
        }, {
          id: 'since',
          name: this.intlMsg.msg('since'),
          formatter: kFormatter
        }, {
          id: 'lastsync',
          name: this.intlMsg.msg('lastsync'),
          formatter: kFormatter
        }]
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_PropsPanel__["a" /* default */], {
        readOnly: true,
        title: this.intlMsg.msg('counters.header'),
        data: gatewayStatus.counters || {},
        status: status,
        properties: [{
          id: 'attfail',
          name: this.intlMsg.msg('attfail')
        }, {
          id: 'attok',
          name: this.intlMsg.msg('attok')
        }, {
          id: 'overrun',
          name: this.intlMsg.msg('overrun')
        }]
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_PropsPanel__["a" /* default */], {
        readOnly: true,
        title: this.intlMsg.msg('statis.header'),
        data: {
          allNodes: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_router__["f" /* Link */],
            { to: "/network/tdm/gateway/" + id + "/allnodes" },
            allNodes
          ),
          workMapNodes: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_router__["f" /* Link */],
            { to: "/network/tdm/gateway/" + id + "/workmapnodes" },
            workMapNodes
          ),
          pressNodes: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_router__["f" /* Link */],
            { to: "/network/tdm/gateway/" + id + "/pressnodes" },
            pressNodes
          ),
          electriNodes: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_router__["f" /* Link */],
            { to: "/network/tdm/gateway/" + id + "/electrinodes" },
            electriNodes
          ),
          tempNodes: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_router__["f" /* Link */],
            { to: "/network/tdm/gateway/" + id + "/tempnodes" },
            tempNodes
          )
        },
        status: status,
        properties: [{
          id: 'allNodes',
          name: this.intlMsg.msg('node.all')
        }, {
          id: 'workMapNodes',
          name: this.intlMsg.msg('node.work.map')
        }, {
          id: 'pressNodes',
          name: this.intlMsg.msg('node.press')
        }, {
          id: 'electriNodes',
          name: this.intlMsg.msg('node.electri.param')
        }, {
          id: 'tempNodes',
          name: this.intlMsg.msg('node.temp')
        }]
      })
    );
  };

  return Status;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Status.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_5_react_css_modules___default()(Status, __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a, { allowMultiple: true })));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loraactions_gateway__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Status__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Channels__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Pies__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_scss__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);








// import PageLoading from 'loracoms/PageLoading';









var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_7_react_intl__["intlShape"].isRequired,
  id: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  getGateway: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  // pushState: React.PropTypes.func.isRequired,
  replaceState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  gatewayDetail: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired
};

var GatewayStatus = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(GatewayStatus, _React$Component);

  function GatewayStatus(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GatewayStatus);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      status: "",
      gatewayStatus: {},
      gatewayDetail: props.gatewayDetail
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__["a" /* default */](props.intl, "network.tdm.detailview");
    return _this;
  }

  GatewayStatus.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        id = _props.id,
        getGateway = _props.getGateway;

    getGateway(id);
    this.loadStatus();
  };

  GatewayStatus.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var gatewayDetail = _ref.gatewayDetail;

    if (!_.isEqual(gatewayDetail, this.props.gatewayDetail)) {
      this.setState({ gatewayDetail: gatewayDetail });
    }
  };

  GatewayStatus.prototype.loadStatus = function loadStatus() {
    var _this2 = this;

    this.setState({ status: "pending" });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__api_callAPI__["a" /* default */])({
      endpoint: "/tdmng/gateways/" + this.props.id + "/status"
    }).then(function (res) {
      _this2.setState({ status: "success", gatewayStatus: res });
    }).catch(function () {});
  };

  GatewayStatus.prototype.renderToolbar = function renderToolbar() {
    var replaceState = this.props.replaceState;
    var _state$gatewayDetail = this.state.gatewayDetail,
        status = _state$gatewayDetail.status,
        _state$gatewayDetail$ = _state$gatewayDetail.data,
        data = _state$gatewayDetail$ === undefined ? {} : _state$gatewayDetail$;

    // '/network/tdm'

    var breadcrumb = [{
      onClick: function onClick() {
        return replaceState("/network/tdm");
      },
      content: this.intlMsg.msg("toolbar.firstnav")
    }, {
      content: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Nvl__["a" /* default */], { val: data.name, status: status }),
      active: true
    }];
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  GatewayStatus.prototype.render = function render() {
    var _state = this.state,
        status = _state.status,
        gatewayStatus = _state.gatewayStatus;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 12 },
          this.renderToolbar()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        { className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.row },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 8 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Channels__["a" /* default */], { gatewayStatus: gatewayStatus, status: status }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Pies__["a" /* default */], { gatewayStatus: gatewayStatus, status: status })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Status__["a" /* default */], {
            gatewayStatus: gatewayStatus,
            status: status,
            id: this.props.id
          })
        )
      )
    );
  };

  return GatewayStatus;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

GatewayStatus.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.params.id,
    gatewayDetail: state.gateway.gateway
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push,
  replaceState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].replace,
  getGateway: __WEBPACK_IMPORTED_MODULE_10_loraactions_gateway__["a" /* default */].gateway
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(GatewayStatus)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loraactions_tdm__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);











var kInitialState = {
  status: '',
  errorMsg: typeof FileReader === 'undefined' ? 'UNSUPPORT_FILE_READER' : '',
  content: '',
  fileName: ''
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_8_react_intl__["intlShape"].isRequired,
  show: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  getTypesJSON: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  typesJSON: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};

var Upload = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Upload, _React$Component);

  function Upload(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Upload);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, kInitialState, {
      show: props.show
    });
    _this.typesJSON = props.typesJSON;
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.upload');
    _this.onHide = _this.onHide.bind(_this);
    _this.onChangeFile = _this.onChangeFile.bind(_this);
    return _this;
  }

  Upload.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var show = _ref.show,
        typesJSON = _ref.typesJSON;

    if (show !== this.props.show) {
      this.setState({ show: show });
    }
    if (!_.isEqual(typesJSON, this.props.typesJSON)) {
      this.typesJSON = typesJSON;
    }
  };

  Upload.prototype.onChangeFile = function onChangeFile(e) {
    var _this2 = this;

    var file = e.target.files[0];
    var reg = /^\S+(.json)$/g;
    if (!reg.test(file.name)) {
      this.setState({ errorMsg: 'FE_JSON_ONLY' });
      return;
    }
    this.setState({ errorMsg: '', fileName: file.name, status: '' });

    var reader = new FileReader();
    reader.onload = function () {
      var result = reader.result;
      result = result.replace(/[\r\n\s]/g, '');
      try {
        var obj = JSON.parse(result);
        if (!obj.networktypes || !obj.networktypes.length) {
          _this2.setState({ errorMsg: 'REQUIRED_NODETYPES' });
        } else if (!obj.nodetypes || !obj.nodetypes.length) {
          _this2.setState({ errorMsg: 'REQUIRED_NETWORK' });
        } else {
          _this2.setState({ content: result }, function () {});
        }
      } catch (err) {
        // err
        _this2.setState({ errorMsg: 'FE_INVALID_JSON' });
      }
    };
    reader.onerror = function () {
      _this2.setState({ errorMsg: 'FILE_READER_ERROR' });
    };

    reader.readAsText(file);
  };

  Upload.prototype.onHide = function onHide() {
    this.props.onHide();
    this.setState(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, kInitialState));
  };

  Upload.prototype.uploadFile = function uploadFile() {
    var _this3 = this;

    var content = this.state.content;

    if (!content) return;

    this.setState({ status: 'pending' });
    var method = this.typesJSON.data ? 'PUT' : 'POST';
    var endpoint = this.typesJSON.data ? '/orgdocs/types' : '/orgdocs';

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__api_callAPI__["a" /* default */])({
      method: method,
      endpoint: endpoint,
      body: { name: 'types', content: content }
    }).then(function () {
      _this3.setState({ status: 'success', content: '' });
      _this3.props.getTypesJSON();
      _.delay(function () {
        _this3.onHide();
      }, 1000);
    }).catch(function () {
      _this3.setState({ status: 'failure', content: '' });
    });
  };

  Upload.prototype.render = function render() {
    var _this4 = this;

    var _state = this.state,
        show = _state.show,
        status = _state.status,
        content = _state.content,
        fileName = _state.fileName,
        errorMsg = _state.errorMsg;


    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-light",
        backdrop: "static",
        show: show,
        onHide: this.onHide
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        this.intlMsg.msg('header')
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
            {
              bsStyle: "aisz-primary",
              onClick: function onClick() {
                $('#file').trigger('click');
              }
            },
            this.intlMsg.msg('btn'),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("input", { id: "file", type: "file", onChange: this.onChangeFile, style: { display: 'none' } })
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.fileName },
            fileName
          )
        ),
        errorMsg && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.waring },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.error },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle" }),
            "\xA0",
            this.intlMsg.msg(errorMsg)
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Footer,
        null,
        status === 'success' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.uploadSuccess },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-check" }),
          "\xA0",
          this.intlMsg.msg('success')
        ),
        status === 'failure' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.uploadFail },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-times" }),
          "\xA0",
          this.intlMsg.msg('failure')
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-default",
            onClick: this.onHide,
            className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.white
          },
          this.intlMsg.msg('cancel')
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-success",
            onClick: function onClick() {
              return _this4.uploadFile();
            },
            disabled: status === 'pending' || !content
          },
          status === 'pending' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-spin fa-spinner m-r-s" }),
          this.intlMsg.msg('confirm')
        )
      )
    );
  };

  return Upload;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Upload.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    typesJSON: state.tdm.setting
  };
};

var mapDispatchToProps = {
  getTypesJSON: __WEBPACK_IMPORTED_MODULE_9_loraactions_tdm__["d" /* setting */]
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(Upload)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_Select__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Upload__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_scss__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_7_react_intl__["intlShape"].isRequired,
  network: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
  onSubmitted: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  typesJSON: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  networkDetail: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired
};

var Netork = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Netork, _React$Component);

  function Netork(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Netork);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    var _parseContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* parseContent */])(props.typesJSON),
        options = _parseContent.options,
        types = _parseContent.types;

    _this.state = {
      options: options,
      selected: props.network
    };
    _this.network = props.network;
    _this.types = types;
    _this.networkDetail = props.networkDetail;
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.net');
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.onChangeNetwork = _this.onChangeNetwork.bind(_this);
    return _this;
  }

  Netork.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var network = _ref.network,
        networkDetail = _ref.networkDetail,
        typesJSON = _ref.typesJSON;

    if (network !== this.props.network) {
      this.setState({ selected: network });
      this.network = network;
    }
    if (!_.isEqual(networkDetail, this.props.networkDetail)) {
      this.networkDetail = networkDetail;
    }
    if (!_.isEqual(typesJSON, this.props.typesJSON)) {
      var _parseContent2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* parseContent */])(typesJSON),
          options = _parseContent2.options,
          types = _parseContent2.types;

      this.types = types;
      this.setState({ options: options });
    }
  };

  Netork.prototype.onChangeNetwork = function onChangeNetwork(selected) {
    this.setState({ selected: selected });
  };

  Netork.prototype.onSubmit = function onSubmit() {
    var _this2 = this;

    var selected = this.state.selected;

    var network = _.find(this.types.networktypes, function (n) {
      return n.networks && n.networks.name === selected;
    });
    if (!selected) return;
    var body = network.networks;

    // add network or update network
    var method = this.networkDetail.data ? 'PUT' : 'POST';

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__api_callAPI__["a" /* default */])({
      body: body,
      method: method,
      endpoint: '/tdmng/networks'
    }).then(function () {
      _this2.network = selected;
      _this2.props.onSubmitted(selected);
    }).catch(function () {
      _this2.setState({ selected: _this2.network });
    });
  };

  Netork.prototype.render = function render() {
    var _this3 = this;

    var _state = this.state,
        options = _state.options,
        selected = _state.selected,
        _state$showModal = _state.showModal,
        showModal = _state$showModal === undefined ? false : _state$showModal;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.net },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Form"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["FormGroup"],
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
            { sm: 2 },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["ControlLabel"],
              null,
              this.intlMsg.msg('label')
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
            { sm: 6 },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_Select__["a" /* default */], {
              value: selected,
              onChange: this.onChangeNetwork,
              options: options
            })
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
            { md: 4, className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.clearRight },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
              {
                bsStyle: "aisz-primary",
                onClick: function onClick() {
                  return _this3.setState({ showModal: true });
                },
                className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.addBtn
              },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-upload", "aria-hidden": "true" }),
              "\xA0",
              this.intlMsg.msg('upload')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
              {
                bsStyle: "aisz-success",
                onClick: this.onSubmit,
                className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.addBtn
              },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-refresh", "aria-hidden": "true" }),
              "\xA0",
              this.intlMsg.msg('update')
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Upload__["a" /* default */], {
        show: showModal,
        onHide: function onHide() {
          return _this3.setState({ showModal: false });
        }
      })
    );
  };

  return Netork;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Netork.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    typesJSON: state.tdm.setting,
    networkDetail: state.tdm.getNetwork
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(Netork)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Select__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_Checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_TablePager__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_SearchInput__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_LoadingTable__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__styles_scss__);





/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);


















var kOffset = 10;
var kInitalState = {
  list: [],
  reset: 0,
  search: '',
  more: false,
  checked: [],
  submitStatus: '',
  errorMsg: ''
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_8_react_intl__["intlShape"].isRequired,
  show: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  addSucceed: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  typesJSON: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  deleteNode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  networkDetail: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  gatewayOptions: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array.isRequired
};

var CreateNode = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CreateNode, _React$Component);

  function CreateNode(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CreateNode);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    var _parseContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util__["a" /* parseContent */])(props.typesJSON),
        types = _parseContent.types;

    _this.state = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, kInitalState, {
      options: types.nodetypes ? _.map(types.nodetypes, function (n) {
        return { value: n.type, label: n.type };
      }) : [],
      list: '',
      status: '',
      appOpts: [],
      selectedApp: '',
      show: props.show,
      gatewayOptions: props.gatewayOptions
    });
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_16_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.node.create');
    _this.mark = 0;
    _this.list = [];
    _this.types = types;
    _this.allNodes = [];
    _this.addQueue = [];
    _this.deleteNode = props.deleteNode;
    _this.networkDetail = props.networkDetail;
    _this.sfOptions = _.concat([{ label: _this.intlMsg.msg('sf.default'), value: null }], __WEBPACK_IMPORTED_MODULE_19__util__["b" /* kSFOptions */]);
    _this.onHide = _this.onHide.bind(_this);
    _this.loadApps = _this.loadApps.bind(_this);
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.onSearch = _this.onSearch.bind(_this);
    _this.allChecked = _this.allChecked.bind(_this);
    _this.onNextPage = _this.onNextPage.bind(_this);
    _this.onPrevPage = _this.onPrevPage.bind(_this);
    return _this;
  }

  CreateNode.prototype.componentDidMount = function componentDidMount() {
    // this.loadAllNodes(this.loadApps);
    this.loadApps();
  };

  CreateNode.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var show = nextProps.show,
        networkDetail = nextProps.networkDetail,
        typesJSON = nextProps.typesJSON,
        gatewayOptions = nextProps.gatewayOptions;

    if (show !== this.props.show) {
      this.setState({ show: show });
      if (show) {
        this.loadAltNodes();
      }
    }
    if (!_.isEqual(networkDetail, this.props.networkDetail)) {
      this.networkDetail = networkDetail;
    }
    if (!_.isEqual(typesJSON, this.props.typesJSON)) {
      var _parseContent2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util__["a" /* parseContent */])(typesJSON),
          types = _parseContent2.types;

      var options = types.nodetypes ? _.map(types.nodetypes, function (n) {
        return { value: n.type, label: n.type };
      }) : [];
      this.types = types;
      this.setState({ options: options });
    }
    if (!_.isEqual(gatewayOptions, this.props.gatewayOptions)) {
      this.setState({ gatewayOptions: gatewayOptions });
    }
  };

  CreateNode.prototype.onChangeApp = function onChangeApp(selectedApp) {
    if (selectedApp === this.state.selectedApp) return;
    this.list = [];
    this.mark = 0;
    this.setState({ reset: new Date().valueOf(), selectedApp: selectedApp, checked: [] }, this.loadAltNodes);
  };

  CreateNode.prototype.onSearch = function onSearch(e) {
    var search = _.trim(e.target.value);
    this.mark = 0;
    this.setState({ search: search, reset: new Date(), checked: [] }, this.loadAltNodes);
  };

  CreateNode.prototype.onChangeRemark = function onChangeRemark(e, _ref) {
    var _this2 = this;

    var id = _ref.id;

    var memo = e.target.value;
    if (this.remarkTimer) {
      clearTimeout(this.remarkTimer);
    }

    this.remarkTimer = _.delay(function () {
      var list = _.map(_this2.state.list, function (l) {
        if (l.id === id) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, l, { memo: memo });
        }
        return l;
      });
      _this2.setState({ list: list });
    }, 250);
  };

  CreateNode.prototype.onSelectNodeType = function onSelectNodeType(typ, _ref2) {
    var _this3 = this;

    var id = _ref2.id;

    if (!this.types.nodetypes) return;

    var services = _.find(this.types.nodetypes, function (n) {
      return n.type === typ;
    }).services;
    if (this.nodeTimer) {
      clearTimeout(this.nodeTimer);
    }
    this.nodeTimer = _.delay(function () {
      var list = _.map(_this3.state.list, function (l) {
        if (l.id === id) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, l, { typ: typ, services: services });
        }
        return l;
      });
      _this3.setState({ list: list, errorMsg: '' });
    }, 250);
  };

  CreateNode.prototype.onSelectSF = function onSelectSF(sf, _ref3) {
    var _this4 = this;

    var id = _ref3.id;

    if (this.sfTimer) {
      clearTimeout(this.sfTimer);
    }

    this.sfTimer = _.delay(function () {
      var list = _.map(_this4.state.list, function (l) {
        if (l.id === id) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, l, { sf: sf });
        }
        return l;
      });
      _this4.setState({ list: list, errorMsg: '' });
    }, 250);
  };

  CreateNode.prototype.onSelectGateway = function onSelectGateway(h, _ref4) {
    var _this5 = this;

    var id = _ref4.id;

    if (this.gtwTimer) {
      clearTimeout(this.gtwTimer);
    }

    this.gtwTimer = _.delay(function () {
      var list = _.map(_this5.state.list, function (l) {
        if (l.id === id) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, l, { home: h });
        }
        return l;
      });
      _this5.setState({ list: list });
    }, 250);
  };

  CreateNode.prototype.onHide = function onHide() {
    this.mark = 0;
    this.setState(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, kInitalState, { reset: new Date().valueOf() }));
    this.props.onHide();
  };

  CreateNode.prototype.onSubmit = function onSubmit() {
    var _this6 = this;

    var _state = this.state,
        checked = _state.checked,
        list = _state.list;

    if (!checked.length) return;

    var _ref5 = this.networkDetail.data || {},
        netw = _ref5.id;

    var nodes = _.map(checked, function (c) {
      var n = _.find(list, function (l) {
        return l.id === c.id;
      });
      var memo = n ? _.trim(n.memo) : c.memo;
      var name = n ? n.name : '';
      var appeui = n ? n.appeui : null;
      return {
        netw: netw,
        id: c.id,
        typ: n ? n.typ : '',
        services: n ? n.services : [],
        sf: n ? n.sf : null,
        memo: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ remark: memo, name: name, appeui: appeui }),
        home: n ? n.home : null
      };
    });
    nodes = _.filter(nodes, function (n) {
      return n.typ && n.services;
    });

    if (!nodes.length) {
      this.setState({ errorMsg: 'FE_NO_CHECKED_NODES' });
      return;
    }

    this.setState({ submitStatus: 'pending' });
    this.addQueue = _.concat(this.addQueue, nodes);
    var addFunc = function addFunc() {
      if (_this6.addQueue.length > 0) {
        var node = _this6.addQueue.pop();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__api_callAPI__["a" /* default */])({
          method: 'POST',
          endpoint: '/tdmng/nodes',
          body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, node)
        }).then(function () {
          _.find(list, function (d) {
            return d.id === node.id;
          }).added = true;
          _this6.setState({ list: list });
          addFunc();
        }).catch(function () {});
      } else {
        _this6.setState({ submitStatus: 'success' });

        _.delay(function () {
          _this6.props.addSucceed();
          _this6.onHide();
        }, 250);
      }
    };
    addFunc();
  };

  CreateNode.prototype.onNextPage = function onNextPage() {
    this.mark += kOffset;
    this.setState({ checked: [] });
    this.loadAltNodes();
  };

  CreateNode.prototype.onPrevPage = function onPrevPage(m) {
    this.mark = m || 0;
    this.setState({ checked: [] });
    this.loadAltNodes();
  };

  CreateNode.prototype.loadApps = function loadApps() {
    var _this7 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__api_callAPI__["a" /* default */])({
      endpoint: '/lora/applications?pageSize=20'
    }).then(function (_ref6) {
      var list = _ref6.list;

      var appOpts = _.map(list, function (l) {
        return { label: l.name, value: l.appeui };
      });
      _this7.setState({ appOpts: appOpts });
      if (list[0]) {
        _this7.setState({ selectedApp: list[0].appeui }, _this7.loadAltNodes);
      }
    }).catch(function () {});
  };

  CreateNode.prototype.loadAltNodes = function loadAltNodes() {
    var _this8 = this;

    var _state2 = this.state,
        selectedApp = _state2.selectedApp,
        search = _state2.search;


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__api_callAPI__["a" /* default */])({
      endpoint: '/tdmng/alt/nodes',
      query: { appeui: selectedApp, offset: this.mark, limit: kOffset, q: search },
      method: 'GET'
    }).then(function (res) {
      var more = res.more,
          mark = res.mark,
          list = res.list;

      _this8.setState({ list: list, mark: mark, more: more, status: 'success' });
    }).catch(function () {});
  };

  CreateNode.prototype.isChecked = function isChecked(d) {
    var checked = this.state.checked;

    return _.some(checked, { id: d.id });
  };

  CreateNode.prototype.toggleCheck = function toggleCheck(d) {
    var checked = this.state.checked;

    if (this.isChecked(d)) {
      checked = _.filter(checked, function (c) {
        return c.id !== d.id;
      });
    } else {
      checked = _.concat(checked, [d]);
    }
    this.setState({ checked: checked });
  };

  CreateNode.prototype.allChecked = function allChecked() {
    var _state3 = this.state,
        checked = _state3.checked,
        list = _state3.list;

    return list.length > 0 && checked.length === list.length;
  };

  CreateNode.prototype.toggleCheckAll = function toggleCheckAll() {
    this.setState({
      checked: this.allChecked() ? [] : this.state.list
    });
  };

  CreateNode.prototype.render = function render() {
    var _this9 = this;

    var _state4 = this.state,
        show = _state4.show,
        list = _state4.list,
        more = _state4.more,
        mark = _state4.mark,
        reset = _state4.reset,
        search = _state4.search,
        status = _state4.status,
        checked = _state4.checked,
        appOpts = _state4.appOpts,
        options = _state4.options,
        errorMsg = _state4.errorMsg,
        selectedApp = _state4.selectedApp,
        submitStatus = _state4.submitStatus,
        gatewayOptions = _state4.gatewayOptions;

    var disabled = submitStatus === 'pending';

    var content = null;
    var rows = Math.max(1, list.length);
    var thead = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "thead",
      null,
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_Checkbox__["a" /* default */], {
            id: "allAppNodes",
            disabled: disabled,
            checked: this.allChecked(),
            onChange: function onChange(e) {
              return _this9.toggleCheckAll(e);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('name')
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          "DevEUI"
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('nodetype')
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          "SF"
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          this.intlMsg.msg('gateway.bind')
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('remark')
        )
      )
    );
    if (status === 'success') {
      content = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Table"],
        { className: "aisz-table-light", striped: true },
        thead,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "tbody",
          null,
          _.map(list, function (l) {
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "tr",
              { key: l.id, className: l.added ? __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.added : '' },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_Checkbox__["a" /* default */], {
                  id: l.id,
                  disabled: disabled,
                  checked: _this9.isChecked(l),
                  onChange: function onChange() {
                    return _this9.toggleCheck(l);
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                l.name
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_lorautils_IdUtils__["a" /* normalizeDevEUI */])(l.deveui)
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Select__["a" /* default */], {
                  options: options,
                  value: l.typ,
                  onChange: function onChange(s) {
                    return _this9.onSelectNodeType(s, l);
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Select__["a" /* default */], {
                  options: _this9.sfOptions,
                  value: l.sf,
                  onChange: function onChange(s) {
                    return _this9.onSelectSF(s, l);
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Select__["a" /* default */], {
                  options: gatewayOptions,
                  value: l.home,
                  onChange: function onChange(h) {
                    return _this9.onSelectGateway(h, l);
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("input", {
                  className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.memo,
                  onChange: function onChange(e) {
                    return _this9.onChangeRemark(e, l);
                  },
                  placeholder: _this9.intlMsg.msg('remark.placeholder')
                })
              )
            );
          })
        )
      );
    } else {
      content = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_15_loracoms_LoadingTable__["a" /* default */],
        {
          className: "aisz-table-light",
          striped: true,
          bordered: true,
          rows: rows,
          cols: 7
        },
        thead
      );
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-light",
        backdrop: "static",
        show: show,
        onHide: this.onHide,
        className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.create
      },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        this.intlMsg.msg('header')
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.selector },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "span",
              { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.label },
              this.intlMsg.msg('apps')
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Select__["a" /* default */], {
              options: appOpts,
              value: selectedApp,
              onChange: function onChange(s) {
                return _this9.onChangeApp(s);
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_SearchInput__["a" /* default */], {
              onChange: this.onSearch,
              value: search,
              placeholder: this.intlMsg.msg('search.placeholder')
            })
          )
        ),
        content,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12_loracoms_ShowIf__["a" /* default */],
          { "if": list.length > 0 },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.pager },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_TablePager__["a" /* default */], {
              status: status,
              mark: mark,
              more: more,
              reset: reset,
              onPrev: this.onPrevPage,
              onNext: this.onNextPage
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"].Footer,
        null,
        errorMsg && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "span",
          { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.error },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-info-circle" }),
          "\xA0",
          this.intlMsg.msg(errorMsg)
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-default",
            onClick: this.onHide,
            className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.white
          },
          this.intlMsg.msg('cancel')
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-success",
            onClick: this.onSubmit,
            disabled: submitStatus === 'pending' || _.isEmpty(checked)
          },
          submitStatus === 'pending' && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-spin fa-spinner m-r-s" }),
          this.intlMsg.msg('confirm')
        )
      )
    );
  };

  return CreateNode;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

CreateNode.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    typesJSON: state.tdm.setting,
    networkDetail: state.tdm.getNetwork
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(CreateNode)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  showModal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  checkedNodes: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array.isRequired,
  onDelSuccess: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  onCancel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};

var DeleteNodes = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeleteNodes, _React$Component);

  function DeleteNodes(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeleteNodes);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      showModal: props.showModal,
      checkedNodes: props.checkedNodes
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.node.delete');
    return _this;
  }

  DeleteNodes.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var showModal = _ref.showModal,
        checkedNodes = _ref.checkedNodes;

    if (showModal !== this.props.showModal) {
      this.setState({ showModal: showModal });
    }
    if (!_.isEqual(checkedNodes, this.props.checkedNodes)) {
      this.setState({ checkedNodes: checkedNodes });
    }
  };

  DeleteNodes.prototype.onSubmite = function onSubmite() {
    var _this2 = this;

    this.setState({ delStatus: 'pending' });

    var checkedNodes = this.state.checkedNodes;

    var copyNodes = _.cloneDeep(checkedNodes);
    var delFunc = function delFunc() {
      var node = copyNodes.pop();
      if (node) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__api_callAPI__["a" /* default */])({
          endpoint: "/tdmng/nodes/" + node,
          method: 'DELETE'
        }).then(function () {
          delFunc();
        }).catch(function () {});
      } else {
        _this2.setState({ delStatus: 'success' });

        _.delay(function () {
          _this2.props.onDelSuccess();
          _this2.props.onCancel();
        }, 250);
      }
    };
    delFunc();
  };

  DeleteNodes.prototype.render = function render() {
    var _this3 = this;

    var _state = this.state,
        showModal = _state.showModal,
        delStatus = _state.delStatus;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-danger",
        backdrop: "static",
        show: showModal,
        onHide: this.props.onCancel
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        this.intlMsg.msg('title')
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "text-center" },
          this.intlMsg.msg('warn')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Footer,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-default",
            className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.white,
            onClick: function onClick() {
              return _this3.props.onCancel();
            }
          },
          this.intlMsg.msg('cancel')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-danger",
            onClick: function onClick() {
              return _this3.onSubmite();
            },
            disabled: delStatus === 'pending'
          },
          delStatus === 'pending' && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spin fa-spinner m-r-s" }),
          this.intlMsg.msg('confirm')
        )
      )
    );
  };

  return DeleteNodes;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DeleteNodes.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(DeleteNodes));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_Select__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_Checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_scss__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_scss__);





/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  checked: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array.isRequired,
  gatewayOptions: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array.isRequired,
  editSucceed: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  typesJSON: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  onDeleteSucceed: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  onChangeChecked: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  onReset: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired
};

var NodeRow = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NodeRow, _React$Component);

  function NodeRow(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NodeRow);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    var info = props.data.memo ? JSON.parse(props.data.memo) : {};

    var _parseContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util__["a" /* parseContent */])(props.typesJSON),
        types = _parseContent.types;

    _this.state = {
      info: info,
      status: '',
      isEdit: false,
      data: props.data,
      editRemark: false,
      editSF: false,
      editGateway: false,
      remarkStatus: '',
      selected: props.data ? props.data.typ : '',
      remark: info.remark,
      sf: props.data ? props.data.sf : '',
      home: props.data ? props.data.home : '',
      gatewayOptions: props.gatewayOptions,
      options: types.nodetypes ? types.nodetypes.map(function (n) {
        return { label: n.type, value: n.type };
      }) : [],
      checked: props.checked
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_15_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.node');
    _this.sfOptions = _.concat([{ label: _this.intlMsg.msg('sf.default'), value: null }], __WEBPACK_IMPORTED_MODULE_16__util__["b" /* kSFOptions */]);
    _this.types = types;
    _this.onDelete = _this.onDelete.bind(_this);
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.onCancelEdit = _this.onCancelEdit.bind(_this);
    _this.submitSF = _this.submitSF.bind(_this);
    _this.cancelSF = _this.cancelSF.bind(_this);
    _this.submitGateway = _this.submitGateway.bind(_this);
    _this.cancelGateway = _this.cancelGateway.bind(_this);
    return _this;
  }

  NodeRow.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var data = _ref.data,
        typesJSON = _ref.typesJSON,
        checked = _ref.checked,
        gatewayOptions = _ref.gatewayOptions;

    if (!_.isEqual(data, this.props.data)) {
      var selected = data ? data.typ : '';
      var sf = data ? data.sf : '';
      var home = data ? data.home : '';
      var info = data.memo ? JSON.parse(data.memo) : {};
      this.setState({ data: data, selected: selected, info: info, remark: info.remark, sf: sf, home: home });
    }
    if (!_.isEqual(typesJSON, this.props.typesJSON)) {
      var _parseContent2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util__["a" /* parseContent */])(typesJSON),
          types = _parseContent2.types;

      var options = types.nodetypes ? _.map(types.nodetypes, function (n) {
        return { value: n.type, label: n.type };
      }) : [];
      this.setState({ options: options });
      this.types = types;
    }
    if (!_.isEqual(checked, this.props.checked)) {
      this.setState({ checked: checked });
    }
    if (!_.isEqual(gatewayOptions, this.props.gatewayOptions)) {
      this.setState({ gatewayOptions: gatewayOptions });
    }
  };

  NodeRow.prototype.onCancelEdit = function onCancelEdit() {
    this.setState({ isEdit: false });
  };

  NodeRow.prototype.onSubmit = function onSubmit() {
    var _this2 = this;

    var _state = this.state,
        selected = _state.selected,
        data = _state.data;

    if (!selected) return;

    var node = _.find(this.types.nodetypes, function (n) {
      return n.type === selected;
    });
    if (!node) return;

    this.setState({ status: 'pending' });
    var services = node.services || [];
    var body = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, data, { services: services, typ: selected });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__api_callAPI__["a" /* default */])({
      body: body,
      method: 'PUT',
      endpoint: "/tdmng/nodes/" + data.id
    }).then(function () {
      _this2.props.editSucceed(body);
      _this2.setState({ status: 'success', isEdit: false });
    }).catch(function () {});
  };

  NodeRow.prototype.onDelete = function onDelete() {
    var _this3 = this;

    var id = this.state.data.id;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__api_callAPI__["a" /* default */])({
      method: 'DELETE',
      endpoint: "/tdmng/nodes/" + id
    }).then(function () {
      _this3.props.onDeleteSucceed({ id: id });
    }).catch(function () {});
  };

  NodeRow.prototype.handleReset = function handleReset() {
    var data = this.state.data;

    this.props.onReset(data);
  };

  NodeRow.prototype.cancelRemark = function cancelRemark() {
    var info = this.state.info;

    this.setState({ remark: info.remark, editRemark: false, remarkStatus: '' });
  };

  NodeRow.prototype.submitRemark = function submitRemark() {
    var _this4 = this;

    var _state2 = this.state,
        data = _state2.data,
        info = _state2.info,
        remark = _state2.remark;

    var memo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, info, { remark: _.trim(remark) }));
    var body = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, data, { memo: memo });

    this.setState({ remarkStatus: 'pending' });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__api_callAPI__["a" /* default */])({
      body: body,
      method: 'PUT',
      endpoint: "/tdmng/nodes/" + data.id
    }).then(function () {
      _this4.props.editSucceed(body);
      _this4.setState({ remarkStatus: 'success', editRemark: false });
    }).catch(function () {});
  };

  NodeRow.prototype.submitSF = function submitSF() {
    var _this5 = this;

    var _state3 = this.state,
        sf = _state3.sf,
        data = _state3.data;

    var body = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, data, { sf: sf });

    this.setState({ sfLoading: 'pending' });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__api_callAPI__["a" /* default */])({
      endpoint: "/tdmng/nodes/" + data.id,
      body: body,
      method: 'PUT'
    }).then(function () {
      _this5.props.editSucceed(body);
      _this5.setState({ sfLoading: 'success', editSF: false });
    }).catch(function () {});
  };

  NodeRow.prototype.cancelSF = function cancelSF() {
    var data = this.state.data;

    this.setState({ editSF: false, sfLoading: '', sf: data.sf });
  };

  NodeRow.prototype.submitGateway = function submitGateway() {
    var _this6 = this;

    var _state4 = this.state,
        home = _state4.home,
        data = _state4.data;

    var body = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, data, { home: home });

    this.setState({ gatewayLoading: 'pending' });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__api_callAPI__["a" /* default */])({
      endpoint: "/tdmng/nodes/" + data.id,
      body: body,
      method: 'PUT'
    }).then(function () {
      _this6.props.editSucceed(body);
      _this6.setState({ gatewayLoading: 'success', editGateway: false });
    }).catch(function () {});
  };

  NodeRow.prototype.cancelGateway = function cancelGateway() {
    var data = this.state.data;

    this.setState({ editGateway: false, gatewayLoading: '', home: data.home });
  };

  NodeRow.prototype.render = function render() {
    var _this7 = this;

    var _state5 = this.state,
        data = _state5.data,
        info = _state5.info,
        remark = _state5.remark,
        status = _state5.status,
        isEdit = _state5.isEdit,
        options = _state5.options,
        selected = _state5.selected,
        editRemark = _state5.editRemark,
        remarkStatus = _state5.remarkStatus,
        sf = _state5.sf,
        home = _state5.home,
        editSF = _state5.editSF,
        editGateway = _state5.editGateway,
        sfLoading = _state5.sfLoading,
        gatewayLoading = _state5.gatewayLoading,
        checked = _state5.checked,
        gatewayOptions = _state5.gatewayOptions,
        _state5$resetStatus = _state5.resetStatus,
        resetStatus = _state5$resetStatus === undefined ? '' : _state5$resetStatus;

    var isLoading = status === 'pending';
    // const showGateway = _.find(gatewayOptions, { value: data.home });

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      "tr",
      null,
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Checkbox__["a" /* default */], {
          id: data.id + "-node",
          checked: _.includes(checked, data.id),
          onChange: function onChange(e) {
            return _this7.props.onChangeChecked(e, data.id);
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "td",
        null,
        info.name
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_router__["f" /* Link */],
          {
            to: "/network/tdm/node/" + data.id
          },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_IdUtils__["a" /* normalizeDevEUI */])(data.id)
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_loracoms_ShowIf__["a" /* default */],
        { "if": !isEdit },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          data.typ,
          "\xA0",
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "a",
            {
              className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.editBtn + " " + (editSF || editRemark || editGateway ? __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.disabled : ''),
              onClick: editSF || editRemark || editGateway ? null : function () {
                return _this7.setState({ isEdit: true });
              }
            },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "glyphicon glyphicon-pencil" })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_loracoms_ShowIf__["a" /* default */],
        { "if": isEdit },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          !isLoading && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.edit },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_Select__["a" /* default */], {
              options: options,
              value: selected,
              onChange: function onChange(s) {
                return _this7.setState({ selected: s });
              }
            }),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "a",
              { onClick: this.onSubmit, className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.icon },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-check text-success" })
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "a",
              { onClick: this.onCancelEdit, className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.icon },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-times text-warning" })
            )
          ),
          isLoading && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "a",
            { className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.icon },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-spin fa-spinner" })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_loracoms_ShowIf__["a" /* default */],
        { "if": !editSF },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          data.sf,
          "\xA0",
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "a",
            {
              className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.editBtn + " " + (isEdit || editRemark || editGateway ? __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.disabled : ''),
              onClick: isEdit || editRemark || editGateway ? null : function () {
                return _this7.setState({ editSF: true });
              }
            },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "glyphicon glyphicon-pencil" })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_loracoms_ShowIf__["a" /* default */],
        { "if": editSF },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          sfLoading !== 'pending' && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.edit },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_Select__["a" /* default */], {
              options: this.sfOptions,
              value: sf,
              onChange: function onChange(s) {
                return _this7.setState({ sf: s });
              }
            }),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "a",
              { onClick: this.submitSF, className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.icon },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-check text-success" })
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "a",
              { onClick: this.cancelSF, className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.icon },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-times text-warning" })
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_loracoms_ShowIf__["a" /* default */],
        { "if": !editGateway },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          { className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.gateway },
          !_.isNil(data.home) && !_.isEmpty(data.home) ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_router__["f" /* Link */],
            { to: "/network/tdm/gateway/" + data.home },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_IdUtils__["a" /* normalizeDevEUI */])(data.home)
          ) : data.home,
          "\xA0",
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "a",
            {
              className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.editBtn + " " + (isEdit || editRemark || editSF ? __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.disabled : ''),
              onClick: isEdit || editRemark || editSF ? null : function () {
                return _this7.setState({ editGateway: true });
              }
            },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "glyphicon glyphicon-pencil" })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_loracoms_ShowIf__["a" /* default */],
        { "if": editGateway },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          { className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.gateway },
          gatewayLoading !== 'pending' && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.edit },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_Select__["a" /* default */], {
              options: gatewayOptions,
              value: home,
              onChange: function onChange(g) {
                return _this7.setState({ home: g });
              }
            }),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "a",
              { onClick: this.submitGateway, className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.icon },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-check text-success" })
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "a",
              { onClick: this.cancelGateway, className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.icon },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-times text-warning" })
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_loracoms_ShowIf__["a" /* default */],
        { "if": !_.isNil(data.home) && !_.isEmpty(data.home) },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          !_.isNil(_.find(gatewayOptions, { value: data.home })) ? _.find(gatewayOptions, { value: data.home }).label : ''
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_loracoms_ShowIf__["a" /* default */],
        { "if": _.isNil(data.home) || _.isEmpty(data.home) },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          ''
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_loracoms_ShowIf__["a" /* default */],
        { "if": !editRemark },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          info.remark,
          "\xA0",
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "a",
            {
              className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.editBtn + " " + (isEdit || editSF || editGateway ? __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.disabled : ''),
              onClick: isEdit || editSF || editGateway ? null : function () {
                return _this7.setState({ editRemark: true });
              }
            },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "glyphicon glyphicon-pencil" })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_loracoms_ShowIf__["a" /* default */],
        { "if": editRemark },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          remarkStatus !== 'pending' && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.edit },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("input", {
              value: remark,
              className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.memo,
              onChange: function onChange(e) {
                return _this7.setState({ remark: e.target.value });
              }
            }),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "a",
              {
                onClick: function onClick() {
                  return _this7.submitRemark();
                },
                className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.icon
              },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-check text-success" })
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              "a",
              { onClick: function onClick() {
                  return _this7.cancelRemark();
                }, className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.icon },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-times text-warning" })
            )
          ),
          remarkStatus === 'pending' && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "a",
            { className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.icon },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-spin fa-spinner" })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "a",
          {
            className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.editBtn,
            onClick: function onClick() {
              return _this7.handleReset();
            }
          },
          resetStatus !== 'pending' && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-repeat  reset-" + resetStatus }),
          resetStatus === 'pending' && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "fa fa-spin fa-spinner m-r-s" })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "a",
          {
            className: __WEBPACK_IMPORTED_MODULE_17__styles_scss___default.a.deleteBtn,
            onClick: this.onDelete
          },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i", { className: "halflings halflings-trash" })
        )
      )
    );
  };

  return NodeRow;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

NodeRow.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    typesJSON: state.tdm.setting
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"])(NodeRow)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  showModal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  onCancel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};

var ResetNode = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ResetNode, _React$Component);

  function ResetNode(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ResetNode);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      showModal: props.showModal,
      node: props.node
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.node.reset');
    _this.onSubmit = _this.onSubmit.bind(_this);
    return _this;
  }

  ResetNode.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var showModal = _ref.showModal,
        node = _ref.node;

    if (showModal !== this.props.showModal) {
      this.setState({ showModal: showModal });
    }
    if (!_.isEqual(node, this.props.node)) {
      this.setState({ node: node });
    }
  };

  ResetNode.prototype.onSubmit = function onSubmit() {
    var _this2 = this;

    this.setState({ submitStatus: 'pending' });

    var id = this.state.node.id;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__api_callAPI__["a" /* default */])({
      endpoint: "/tdmng/nodes/" + id + "/ctrl/kick",
      method: 'POST'
    }).then(function () {
      _this2.setState({ submitStatus: 'success' });

      _.delay(function () {
        _this2.props.onCancel();
      }, 250);
    }).catch(function () {
      _this2.setState({ submitStatus: 'failure' });
    });
  };

  ResetNode.prototype.render = function render() {
    var _state = this.state,
        showModal = _state.showModal,
        submitStatus = _state.submitStatus;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-warning",
        show: showModal,
        backdrop: "static",
        onHide: this.props.onCancel
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        this.intlMsg.msg('single.title')
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "text-center" },
          this.intlMsg.msg('single.warn')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Footer,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-default",
            onClick: this.props.onCancel,
            className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.white
          },
          this.intlMsg.msg('cancel')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-warning",
            onClick: this.onSubmit,
            disabled: submitStatus === 'pending'
          },
          submitStatus === 'pending' && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spin fa-spinner m-r-s" }),
          this.intlMsg.msg('confirm')
        )
      )
    );
  };

  return ResetNode;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ResetNode.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(ResetNode));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired,
  showModal: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,
  checkedNodes: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array.isRequired,
  onCancel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired
};

var ResetNodes = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ResetNodes, _React$Component);

  function ResetNodes(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ResetNodes);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      showModal: props.showModal,
      checkedNodes: props.checkedNodes
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.node.reset');
    _this.onSubmit = _this.onSubmit.bind(_this);
    return _this;
  }

  ResetNodes.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var showModal = _ref.showModal,
        checkedNodes = _ref.checkedNodes;

    if (showModal !== this.props.showModal) {
      this.setState({ showModal: showModal });
    }
    if (!_.isEqual(checkedNodes, this.props.checkedNodes)) {
      this.setState({ checkedNodes: checkedNodes });
    }
  };

  ResetNodes.prototype.onSubmit = function onSubmit() {
    var _this2 = this;

    this.setState({ submitStatus: 'pending' });

    var checkedNodes = this.state.checkedNodes;

    var copyNodes = _.cloneDeep(checkedNodes);
    var reset = function reset() {
      var node = copyNodes.pop();
      if (node) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__api_callAPI__["a" /* default */])({
          endpoint: "/tdmng/nodes/" + node + "/ctrl/kick",
          method: 'POST'
        }).then(function () {
          reset();
        }).catch(function () {});
      } else {
        _this2.setState({ submitStatus: 'success' });

        _.delay(function () {
          _this2.props.onCancel();
        }, 250);
      }
    };
    reset();
  };

  ResetNodes.prototype.render = function render() {
    var _state = this.state,
        showModal = _state.showModal,
        submitStatus = _state.submitStatus;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-warning",
        show: showModal,
        backdrop: "static",
        onHide: this.props.onCancel
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        this.intlMsg.msg('title')
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "text-center" },
          this.intlMsg.msg('warn')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Footer,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-default",
            className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.white,
            onClick: this.props.onCancel
          },
          this.intlMsg.msg('cancel')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-warning",
            onClick: this.onSubmit,
            disabled: submitStatus === 'pending'
          },
          submitStatus === 'pending' && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spin fa-spinner m-r-s" }),
          this.intlMsg.msg('confirm')
        )
      )
    );
  };

  return ResetNodes;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ResetNodes.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(ResetNodes));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_TablePagerTDM__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_SearchInput__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_LoadingTable__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_Checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loraactions_tdm__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lorautils_pagerUtil__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_loracoms_PageSizer__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__util__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__NodeRow__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_loracoms_TablePagers__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__CreateNode__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__DeleteNodes__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ResetNodes__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ResetNode__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__styles_scss__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__styles_scss__);




/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);


























var kLimit = 10;
var kMarksKey = "nodeMarks";
var kTypeKey = "nodeTypeFilter";
var kRouteAction = ["POP", "REPLACE"];
var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_8_react_intl__["intlShape"].isRequired,
  network: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,
  routerAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,
  typesJSON: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  updateNodes: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  tdmGateways: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};

var Node = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Node, _React$Component);

  function Node(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Node);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_10_lorautils_intl_IntlMsg__["a" /* default */](props.intl, "network.tdm.node");

    var _parseContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__util__["a" /* parseContent */])(props.typesJSON),
        types = _parseContent.types;

    var options = types.nodetypes ? _.map(types.nodetypes, function (n) {
      return { value: n.type, label: n.type };
    }) : [];
    _this.state = {
      list: [],
      status: "",
      deleteNode: {},
      checked: [],
      limit: 20,
      network: props.network,
      tdmGateways: props.tdmGateways,
      options: _.concat([{ label: _this.intlMsg.msg("nodetype.all"), value: "" }], options)
    };
    _this.mark = 0;
    _this.marks = [];
    _this.nodetype = "";
    _this.fallback = _this.fallback.bind(_this);
    _this.editSucceed = _this.editSucceed.bind(_this);
    _this.handlePaging = _this.handlePaging.bind(_this);
    _this.onChangeSearch = _this.onChangeSearch.bind(_this);
    _this.onSearchNodeType = _this.onSearchNodeType.bind(_this);
    _this.onCheckedAll = _this.onCheckedAll.bind(_this);
    _this.checkedSingle = _this.checkedSingle.bind(_this);
    _this.handleReset = _this.handleReset.bind(_this);
    _this.handleChangePageSize = _this.handleChangePageSize.bind(_this);
    _this.handleChangeMark = _this.handleChangeMark.bind(_this);
    return _this;
  }

  Node.prototype.componentDidMount = function componentDidMount() {
    if (_.includes(kRouteAction, this.props.routerAction)) {
      this.marks = __WEBPACK_IMPORTED_MODULE_17_lorautils_pagerUtil__["a" /* pageParams */].getMarks(kMarksKey) || [];
      this.nodetype = __WEBPACK_IMPORTED_MODULE_17_lorautils_pagerUtil__["a" /* pageParams */].getFilter(kTypeKey) || "";
    }
    this.onLoadData();
    if (!_.isEmpty(this.state.tdmGateways)) {
      this.handleTdmGtws(this.state.tdmGateways);
    }
  };

  Node.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var network = _ref.network,
        typesJSON = _ref.typesJSON,
        tdmGateways = _ref.tdmGateways;

    if (network !== this.props.network) {
      this.setState({ network: network });
    }
    if (!_.isEqual(typesJSON, this.props.typesJSON)) {
      var _parseContent2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__util__["a" /* parseContent */])(typesJSON),
          types = _parseContent2.types;

      var options = types.nodetypes ? _.map(types.nodetypes, function (n) {
        return { value: n.type, label: n.type };
      }) : [];
      options = _.concat([{ label: this.intlMsg.msg("nodetype.all"), value: "" }], options);
      this.setState({ options: options });
    }
    if (!_.isEqual(tdmGateways, this.props.tdmGateways)) {
      this.handleTdmGtws(tdmGateways);
    }
  };

  Node.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_17_lorautils_pagerUtil__["a" /* pageParams */].setMarks(this.marks, kMarksKey);
    __WEBPACK_IMPORTED_MODULE_17_lorautils_pagerUtil__["a" /* pageParams */].setFilter(this.nodetype, kTypeKey);
  };

  Node.prototype.onLoadData = function onLoadData(length) {
    var _this2 = this;

    this.setState({ status: "pending" });
    var limit = this.state.limit;


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__api_callAPI__["a" /* default */])({
      endpoint: "/tdmng/nodes",
      query: {
        limit: length || limit,
        mark: this.mark,
        typ: this.nodetype,
        q: this.q
      }
    }).then(function (res) {
      var list = res.list,
          more = res.more,
          mark = res.mark;

      _this2.marks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_lorautils_pagerUtil__["b" /* updateMarks */])(_this2.marks, mark);
      _this2.setState({ list: list, more: more, mark: _this2.marks, status: "success" });
    }).catch(function () {});
  };

  Node.prototype.onDelSuccess = function onDelSuccess() {
    this.mark = 0;
    this.resetMark();
    this.onLoadData();
  };

  Node.prototype.onSearchNodeType = function onSearchNodeType(nodetype) {
    this.nodetype = nodetype;
    this.resetMark();
    this.setState({ selected: nodetype });
    this.onLoadData();
  };

  Node.prototype.onChangeSearch = function onChangeSearch(e) {
    var _this3 = this;

    this.q = e.target.value;
    this.setState({ search: this.q });
    this.mark = 0;
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = _.delay(function () {
      _this3.resetMark();
      _this3.onLoadData();
    }, 250);
  };

  Node.prototype.onCheckedAll = function onCheckedAll(e) {
    var checked = this.state.checked;
    var list = this.state.list;

    if (e) {
      checked = [];
      list.forEach(function (l) {
        checked = _.concat(checked, [l.id]);
      });
    } else {
      checked = [];
    }
    this.setState({ checked: checked });
  };

  Node.prototype.handleTdmGtws = function handleTdmGtws(gtws) {
    var _gtws$list = gtws.list,
        list = _gtws$list === undefined ? [] : _gtws$list;

    var gatewayOptions = _.map(list, function (l) {
      var _l$memo = l.memo,
          memo = _l$memo === undefined ? "{}" : _l$memo;

      var newMemo = JSON.parse(memo) || {};
      return { label: newMemo.name1, value: l.id };
    });
    gatewayOptions = _.concat([{ label: this.intlMsg.msg("bind.default"), value: "" }], gatewayOptions);
    this.setState({ gatewayOptions: gatewayOptions });
  };

  Node.prototype.resetMark = function resetMark() {
    this.mark = 0;
    this.marks = [];
    this.setState({ reset: new Date().valueOf() });
  };

  Node.prototype.checkedAll = function checkedAll() {
    var _state = this.state,
        list = _state.list,
        checked = _state.checked;

    return list.length > 0 && list.length === checked.length;
  };

  Node.prototype.handlePaging = function handlePaging(mark) {
    this.mark = mark;
    this.setState({ checked: [] });
    this.onLoadData();
  };

  Node.prototype.fallback = function fallback(deleteNode) {
    this.resetMark();
    this.onLoadData();
    if (deleteNode) {
      this.setState({ deleteNode: deleteNode });
    }
    this.props.updateNodes(new Date().valueOf());
  };

  Node.prototype.editSucceed = function editSucceed(data) {
    var list = this.state.list;

    list = _.map(list, function (l) {
      if (l.id === data.id) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, l, data);
      }
      return l;
    });
    this.setState({ list: list });
    this.props.updateNodes(new Date().valueOf());
  };

  Node.prototype.checkedSingle = function checkedSingle(e, id) {
    var _this4 = this;

    if (this.checkedTimer) {
      clearTimeout(this.checkedTimer);
    }

    this.checkedTimer = _.delay(function () {
      var checked = _this4.state.checked;

      if (e) {
        checked = _.concat(checked, [id]);
      } else {
        checked = _.filter(checked, function (c) {
          return c !== id;
        });
      }
      _this4.setState({ checked: checked });
    }, 250);
  };

  Node.prototype.handleReset = function handleReset(n) {
    this.setState({ resetNode: n, showSingleReset: true });
  };

  Node.prototype.renderTable = function renderTable() {
    var _this5 = this;

    var _state2 = this.state,
        status = _state2.status,
        list = _state2.list,
        checked = _state2.checked,
        _state2$gatewayOption = _state2.gatewayOptions,
        gatewayOptions = _state2$gatewayOption === undefined ? [] : _state2$gatewayOption;

    var thead = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "thead",
      null,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "th",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_Checkbox__["a" /* default */], {
            id: "all",
            checked: this.checkedAll(),
            onChange: function onChange(e) {
              return _this5.onCheckedAll(e);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg("name")
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "th",
          null,
          "DevEUI"
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg("nodetype")
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "th",
          null,
          "SF"
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg("gateway.bind")
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg("gateway.name")
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg("remark")
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg("reset")
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg("delete")
        )
      )
    );
    if (status === "success") {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Table"],
        { className: "aisz-table-light", striped: true },
        thead,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "tbody",
          null,
          _.map(list, function (l) {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__NodeRow__["a" /* default */], {
              key: l.id,
              data: l,
              checked: checked,
              gatewayOptions: gatewayOptions,
              editSucceed: _this5.editSucceed,
              onDeleteSucceed: _this5.fallback,
              onChangeChecked: _this5.checkedSingle,
              onReset: _this5.handleReset
            });
          })
        )
      );
    }
    var rows = Math.max(1, list.length);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_14_loracoms_LoadingTable__["a" /* default */],
      {
        className: "aisz-table-light",
        striped: true,
        bordered: true,
        rows: rows,
        cols: 10
      },
      thead
    );
  };

  // 改变页面显示数量


  Node.prototype.handleChangePageSize = function handleChangePageSize(length) {
    this.setState({ limit: length });
    this.mark = 0;
    this.onLoadData(length);
  };

  //翻页


  Node.prototype.handleChangeMark = function handleChangeMark(flag) {
    var limit = this.state.limit;

    if (flag) {
      //下一页
      this.mark += limit;
    } else {
      //上一页
      this.mark -= limit;
      this.mark = this.mark < 0 ? 0 : this.mark;
    }
    this.onLoadData();
  };

  Node.prototype.render = function render() {
    var _this6 = this;

    var _state3 = this.state,
        list = _state3.list,
        status = _state3.status,
        network = _state3.network,
        options = _state3.options,
        _state3$selected = _state3.selected,
        selected = _state3$selected === undefined ? this.nodetype : _state3$selected,
        _state3$mark = _state3.mark,
        mark = _state3$mark === undefined ? "" : _state3$mark,
        _state3$reset = _state3.reset,
        reset = _state3$reset === undefined ? 0 : _state3$reset,
        deleteNode = _state3.deleteNode,
        _state3$search = _state3.search,
        search = _state3$search === undefined ? "" : _state3$search,
        checked = _state3.checked,
        _state3$resetNode = _state3.resetNode,
        resetNode = _state3$resetNode === undefined ? {} : _state3$resetNode,
        _state3$gatewayOption = _state3.gatewayOptions,
        gatewayOptions = _state3$gatewayOption === undefined ? [] : _state3$gatewayOption,
        _state3$more = _state3.more,
        more = _state3$more === undefined ? false : _state3$more,
        _state3$showCreate = _state3.showCreate,
        showCreate = _state3$showCreate === undefined ? false : _state3$showCreate,
        _state3$showDelete = _state3.showDelete,
        showDelete = _state3$showDelete === undefined ? false : _state3$showDelete,
        _state3$showReset = _state3.showReset,
        showReset = _state3$showReset === undefined ? false : _state3$showReset,
        _state3$showSingleRes = _state3.showSingleReset,
        showSingleReset = _state3$showSingleRes === undefined ? false : _state3$showSingleRes,
        limit = _state3.limit;


    var header = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      null,
      this.intlMsg.msg("title"),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Button"],
        {
          bsStyle: "aisz-danger",
          disabled: !network || !checked.length,
          className: __WEBPACK_IMPORTED_MODULE_27__styles_scss___default.a.addBtn,
          onClick: function onClick() {
            return _this6.setState({ showDelete: true });
          }
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "halflings halflings-trash" }),
        "\xA0",
        this.intlMsg.msg("batch.delete")
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Button"],
        {
          bsStyle: "aisz-warning",
          disabled: !network || !checked.length,
          className: __WEBPACK_IMPORTED_MODULE_27__styles_scss___default.a.addBtn,
          onClick: function onClick() {
            return _this6.setState({ showReset: true });
          }
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-repeat" }),
        "\xA0",
        this.intlMsg.msg("batch.reset")
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Button"],
        {
          bsStyle: "aisz-primary",
          disabled: !network,
          className: __WEBPACK_IMPORTED_MODULE_27__styles_scss___default.a.addBtn,
          onClick: function onClick() {
            return _this6.props.pushState("/network/tdm/batch/nodes");
          }
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-arrow-circle-right" }),
        "\xA0",
        this.intlMsg.msg("batch")
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Button"],
        {
          bsStyle: "aisz-success",
          disabled: !network,
          onClick: function onClick() {
            return _this6.setState({ showCreate: true });
          },
          className: __WEBPACK_IMPORTED_MODULE_27__styles_scss___default.a.addBtn
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { className: "glyphicons glyphicons-plus", "aria-hidden": "true" }),
        "\xA0",
        this.intlMsg.msg("add")
      )
    );
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: header },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_27__styles_scss___default.a.search },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_SearchInput__["a" /* default */], {
          autoFocus: true,
          placeholder: this.intlMsg.msg("remark.placeholder"),
          value: search,
          onChange: this.onChangeSearch
        }),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          null,
          _.map(options, function (o, idx) {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              "a",
              {
                key: idx,
                className: __WEBPACK_IMPORTED_MODULE_27__styles_scss___default.a.label + " " + (selected === o.value ? __WEBPACK_IMPORTED_MODULE_27__styles_scss___default.a.active : ""),
                onClick: function onClick() {
                  return _this6.onSearchNodeType(o.value);
                }
              },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-circle" }),
              "\xA0",
              o.label
            );
          })
        )
      ),
      this.renderTable(),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__["a" /* default */],
        { "if": status === "success" && !list.length },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_27__styles_scss___default.a.noData },
          this.intlMsg.msg("nodata")
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__["a" /* default */],
        { "if": list.length > 0 },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_27__styles_scss___default.a.pager },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_loracoms_PageSizer__["a" /* default */], {
              pageSize: limit,
              onChange: this.handleChangePageSize,
              options: [20, 100, 500]
            })
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_27__styles_scss___default.a.pagers },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_loracoms_TablePagers__["a" /* default */], {
              status: status,
              mark: this.mark,
              more: more,
              change: this.handleChangeMark
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__CreateNode__["a" /* default */], {
        show: showCreate,
        deleteNode: deleteNode,
        gatewayOptions: gatewayOptions,
        addSucceed: this.fallback,
        onHide: function onHide() {
          return _this6.setState({ showCreate: false });
        }
      }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__DeleteNodes__["a" /* default */], {
        showModal: showDelete,
        checkedNodes: checked,
        onDelSuccess: function onDelSuccess() {
          return _this6.onDelSuccess();
        },
        onCancel: function onCancel() {
          return _this6.setState({ showDelete: false });
        }
      }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__ResetNodes__["a" /* default */], {
        showModal: showReset,
        checkedNodes: checked,
        onCancel: function onCancel() {
          return _this6.setState({ showReset: false });
        }
      }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__ResetNode__["a" /* default */], {
        showModal: showSingleReset,
        node: resetNode,
        onCancel: function onCancel() {
          return _this6.setState({ showSingleReset: false });
        }
      })
    );
  };

  return Node;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Node.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    typesJSON: state.tdm.setting,
    tdmGateways: state.tdm.updateTdmGateways
  };
};

var mapDispatchToprops = {
  updateNodes: __WEBPACK_IMPORTED_MODULE_16_loraactions_tdm__["c" /* updateNodes */],
  pushState: __WEBPACK_IMPORTED_MODULE_7_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps, mapDispatchToprops)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(Node)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_RichLabel__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__ = __webpack_require__(7);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);








var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_react_intl__["intlShape"].isRequired,
  status: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  nodeStatus: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired
};

var Channels = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Channels, _React$Component);

  function Channels(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Channels);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      list: [],
      status: props.status,
      nodeStatus: props.nodeStatus
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.node.channel');
    return _this;
  }

  Channels.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var nodeStatus = _ref.nodeStatus,
        status = _ref.status;

    if (!_.isEqual(nodeStatus, this.props.nodeStatus)) {
      this.setState({ nodeStatus: nodeStatus });
    }
    if (status !== this.props.status) {
      this.setState({ status: status });
    }
  };

  Channels.prototype.render = function render() {
    var _state$nodeStatus = this.state.nodeStatus;
    _state$nodeStatus = _state$nodeStatus === undefined ? {} : _state$nodeStatus;
    var _state$nodeStatus$bin = _state$nodeStatus.binds,
        binds = _state$nodeStatus$bin === undefined ? [] : _state$nodeStatus$bin;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Panel"],
      {
        bsStyle: "aisz-white", header: this.intlMsg.msg('header')
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Table"],
        { className: "aisz-table-light", striped: true },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('channel')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('service')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('frame')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('offset')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "tbody",
          null,
          _.map(binds, function (l, idx) {
            var f = '';
            if (l.frame === 0) {
              f = 'FrameX';
            } else if (l.frame === 1) {
              f = 'FrameA';
            } else if (l.frame === 2) {
              f = 'FrameB';
            } else {
              f = l.frame;
            }
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "tr",
              { key: idx },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_RichLabel__["a" /* default */], { content: String(l.channel) })
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                l.service
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                f
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                l.offset
              )
            );
          })
        )
      )
    );
  };

  return Channels;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Channels.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(Channels));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_PieChart__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__ = __webpack_require__(7);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);








var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_react_intl__["intlShape"].isRequired,
  status: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  nodeStatus: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired
};

var LinksPie = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(LinksPie, _React$Component);

  function LinksPie(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LinksPie);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      status: props.status
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.node');
    return _this;
  }

  LinksPie.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var status = _ref.status,
        nodeStatus = _ref.nodeStatus;

    if (status !== this.props.status) {
      this.setState({ status: status });
    }
    if (!_.isEqual(nodeStatus, this.props.nodeStatus)) {
      this.initSeries(nodeStatus);
    }
  };

  LinksPie.prototype.initSeries = function initSeries(nodeStatus) {
    if (!nodeStatus.counters) return;

    var _ref2 = nodeStatus.counters || {},
        tdmup = _ref2.tdmup,
        alohaup = _ref2.alohaup;

    var series = [{
      name: this.intlMsg.msg('status.tdmup'),
      value: tdmup,
      itemStyle: {
        normal: {
          color: '#59abe3'
        }
      },
      label: {
        normal: {
          position: 'inside'
        }
      },
      labelLine: {
        normal: {
          length: 5,
          length2: 5
        }
      }
    }, {
      name: this.intlMsg.msg('status.alohaup'),
      value: alohaup,
      itemStyle: {
        normal: {
          color: '#f4b350'
        }
      },
      label: {
        normal: {
          position: 'inside'
        }
      }
    }];
    this.setState({ series: series });
  };

  LinksPie.prototype.render = function render() {
    var _state$series = this.state.series,
        series = _state$series === undefined ? [] : _state$series;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Panel"],
      {
        bsStyle: "aisz-white", header: this.intlMsg.msg('pie.header')
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_PieChart__["a" /* default */], {
        series: [{
          label: {
            normal: {
              formatter: '{b}\n{d}%'
            },
            emphasis: {
              formatter: '{b}\n{d}%'
            }
          },
          data: series
        }]
      })
    );
  };

  return LinksPie;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

LinksPie.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(LinksPie));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_PropsPanel__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__GatewayStatus_styles_scss__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__GatewayStatus_styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__GatewayStatus_styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var kFormatter = function kFormatter(x) {
  if (x) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "span",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_date_fns__["format"])(x, 'YYYY-MM-DD HH:mm:ss')
    );
  }
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    "span",
    null,
    "--"
  );
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_react_intl__["intlShape"].isRequired,
  status: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  nodeStatus: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired
};

var Status = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Status, _React$Component);

  function Status(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Status);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      status: props.status,
      nodeStatus: props.nodeStatus
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.node.status');
    return _this;
  }

  Status.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var nodeStatus = _ref.nodeStatus,
        status = _ref.status;

    if (!_.isEqual(nodeStatus, this.props.nodeStatus)) {
      this.setState({ nodeStatus: nodeStatus });
    }
    if (status !== this.props.status) {
      this.setState({ status: status });
    }
  };

  Status.prototype.render = function render() {
    var _state = this.state,
        status = _state.status,
        nodeStatus = _state.nodeStatus;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_9__GatewayStatus_styles_scss___default.a.status },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_PropsPanel__["a" /* default */], {
        readOnly: true,
        title: this.intlMsg.msg('basic.header'),
        data: nodeStatus,
        status: status,
        properties: [{
          id: 'ver',
          name: this.intlMsg.msg('ver')
        }, {
          id: 'accuracy',
          name: this.intlMsg.msg('accuracy')
        }, {
          id: 'roaming',
          name: this.intlMsg.msg('roaming')
        }, {
          id: 'lastatt',
          name: this.intlMsg.msg('lastatt'),
          formatter: kFormatter
        }, {
          id: 'lastdn',
          name: this.intlMsg.msg('lastdn'),
          formatter: kFormatter
        }, {
          id: 'lastup',
          name: this.intlMsg.msg('lastup'),
          formatter: kFormatter
        }, {
          id: 'nextup',
          name: this.intlMsg.msg('nextup'),
          formatter: kFormatter
        }]
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_PropsPanel__["a" /* default */], {
        readOnly: true,
        title: this.intlMsg.msg('counter.header'),
        data: nodeStatus.counters || {},
        status: status,
        properties: [{
          id: 'ackddown',
          name: this.intlMsg.msg('ackddown')
        }, {
          id: 'initdown',
          name: this.intlMsg.msg('initdown')
        }, {
          id: 'retrydown',
          name: this.intlMsg.msg('retrydown')
        }, {
          id: 'tdmup',
          name: this.intlMsg.msg('tdmup')
        }, {
          id: 'alohaup',
          name: this.intlMsg.msg('alohaup')
        }, {
          id: 'okassemble',
          name: this.intlMsg.msg('okassemble')
        }]
      })
    );
  };

  return Status;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Status.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(Status));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Status__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Channels__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__LinksPie__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Logs__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__GatewayStatus_styles_scss__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__GatewayStatus_styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__GatewayStatus_styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);


















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_7_react_intl__["intlShape"].isRequired,
  id: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  getDevice: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  replaceState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  deviceDetail: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired
};

var NodeStatus = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(NodeStatus, _React$Component);

  function NodeStatus(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NodeStatus);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      status: '',
      nodeStatus: {},
      deviceDetail: props.deviceDetail
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_12_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.detailview');
    return _this;
  }

  NodeStatus.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        id = _props.id,
        getDevice = _props.getDevice;

    getDevice(id);
    this.loadStatus();
  };

  NodeStatus.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var deviceDetail = _ref.deviceDetail;

    if (!_.isEqual(deviceDetail, this.props.deviceDetail)) {
      this.setState({ deviceDetail: deviceDetail });
    }
  };

  NodeStatus.prototype.loadStatus = function loadStatus() {
    var _this2 = this;

    this.setState({ status: 'pending' });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__api_callAPI__["a" /* default */])({
      endpoint: "/tdmng/nodes/" + this.props.id + "/status"
    }).then(function (res) {
      _this2.setState({ status: 'success', nodeStatus: res });
    }).catch(function () {});
  };

  NodeStatus.prototype.renderToolbar = function renderToolbar() {
    var replaceState = this.props.replaceState;
    var _state$deviceDetail = this.state.deviceDetail,
        status = _state$deviceDetail.status,
        _state$deviceDetail$d = _state$deviceDetail.data,
        data = _state$deviceDetail$d === undefined ? {} : _state$deviceDetail$d;

    // '/network/tdm'

    var breadcrumb = [{
      onClick: function onClick() {
        return replaceState('/network/tdm');
      },
      content: this.intlMsg.msg('toolbar.firstnav')
    }, {
      content: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Nvl__["a" /* default */], { val: data.name, status: status }),
      active: true
    }];
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_Toolbar__["a" /* default */], { breadcrumb: breadcrumb });
  };

  NodeStatus.prototype.render = function render() {
    var _state = this.state,
        status = _state.status,
        nodeStatus = _state.nodeStatus;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 12 },
          this.renderToolbar()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
        { className: __WEBPACK_IMPORTED_MODULE_18__GatewayStatus_styles_scss___default.a.row },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 8 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Channels__["a" /* default */], { nodeStatus: nodeStatus, status: status }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Logs__["a" /* default */], { nodeStatus: nodeStatus }),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__LinksPie__["a" /* default */], { nodeStatus: nodeStatus, status: status })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Status__["a" /* default */], { nodeStatus: nodeStatus, status: status })
        )
      )
    );
  };

  return NodeStatus;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

NodeStatus.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.params.id,
    deviceDetail: state.device.getDevice
  };
};

var mapDispatchToProps = {
  replaceState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].replace,
  getDevice: __WEBPACK_IMPORTED_MODULE_10_loraactions_device__["a" /* default */].getDevice
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(NodeStatus)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Work__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Pair__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Electric__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_scss__);






/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var kInitalState = {
  status: ''
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_9_react_intl__["intlShape"].isRequired,
  show: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
  onAdded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
  updateNodes: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any.isRequired,
  deletePair: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired,
  networkDetail: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired
};

var CreateModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CreateModal, _React$Component);

  function CreateModal(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, CreateModal);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      submitStatus: '',
      show: props.show,
      resetComponent: 0
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.pairs.create');
    _this.allNodes = [];
    _this.allParis = [];
    _this.addQueue = [];
    _this.checkedPairs = [];
    _this.pairRemarks = {};
    _this.deletePair = props.deletePair;
    _this.networkDetail = props.networkDetail;
    _this.onHide = _this.onHide.bind(_this);
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.onWorkNodes = _this.onWorkNodes.bind(_this);
    _this.onRemovePairs = _this.onRemovePairs.bind(_this);
    _this.onCheckedPairs = _this.onCheckedPairs.bind(_this);
    _this.onElectricNodes = _this.onElectricNodes.bind(_this);
    return _this;
  }

  CreateModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var show = _ref.show,
        networkDetail = _ref.networkDetail,
        deletePair = _ref.deletePair,
        updateNodes = _ref.updateNodes;

    if (show !== this.props.show) {
      this.setState({ show: show });
    }
    if (!_.isEqual(networkDetail, this.props.networkDetail)) {
      this.networkDetail = networkDetail;
    }
    if (!_.isEqual(deletePair, this.deletePair)) {
      this.deletePair = deletePair;
      this.resetNodes();
    }
    if (updateNodes !== this.props.updateNodes) {
      this.resetNodes();
    }
  };

  CreateModal.prototype.onWorkNodes = function onWorkNodes(nodes) {
    var checkedWorkNodes = _.concat(nodes, []);
    this.setState({ checkedWorkNodes: checkedWorkNodes });
  };

  CreateModal.prototype.onElectricNodes = function onElectricNodes(nodes) {
    var checkedElectricNodes = _.concat(nodes, []);
    this.setState({ checkedElectricNodes: checkedElectricNodes });
  };

  CreateModal.prototype.onCheckedPairs = function onCheckedPairs(pairs, remarks) {
    this.pairRemarks = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, remarks);
    this.checkedPairs = _.concat(pairs, []);
  };

  CreateModal.prototype.onRemovePairs = function onRemovePairs(array) {
    var workNode = array[0];
    var electricNode = array[1];
    if (workNode) {
      this.setState({ deleteWorkNode: workNode });
    }
    if (electricNode) {
      this.setState({ deleteElectricNode: electricNode });
    }
  };

  CreateModal.prototype.onHide = function onHide() {
    this.setState(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, kInitalState, {
      checkedWorkNodes: [],
      checkedElectricNodes: [],
      resetComponent: new Date().valueOf()
    }));
    this.props.onHide();
  };

  CreateModal.prototype.onSubmit = function onSubmit() {
    var _this2 = this;

    var id = this.networkDetail.data.id;

    var pairs = [];
    _.forEach(this.checkedPairs, function (items) {
      if (!items[0] || !items[1]) return;

      var memo = {};
      var workNode = items[0];
      var electricNode = items[1];
      if (workNode.memo) {
        var memo1 = JSON.parse(workNode.memo);
        memo.name = memo1.name;
      }
      if (electricNode.memo) {
        var memo2 = JSON.parse(electricNode.memo);
        memo.rname = memo2.name;
      }
      var remark = _this2.pairRemarks[workNode.id] || _this2.pairRemarks[electricNode.id];
      memo.remark = remark;

      pairs.push({
        netw: id,
        id: workNode.id,
        service: 2,
        rnode: electricNode.id,
        rservice: 4,
        memo: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(memo)
      });
    });
    if (!pairs.length) return;

    this.addQueue = _.concat(this.addQueue, pairs);
    var addFunc = function addFunc() {
      if (_this2.addQueue.length > 0) {
        var pair = _this2.addQueue.pop();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__api_callAPI__["a" /* default */])({
          method: 'POST',
          endpoint: '/tdmng/pairs',
          body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, pair)
        }).then(function () {
          addFunc();
        }).catch(function () {});
      } else {
        _this2.setState({ submitStatus: 'success' });

        _.delay(function () {
          _this2.props.onAdded();
          _this2.props.onHide();
          _this2.resetNodes();
        }, 250);
      }
    };
    addFunc();
  };

  CreateModal.prototype.resetNodes = function resetNodes() {
    this.setState({
      checkedWorkNodes: [],
      checkedElectricNodes: [],
      resetComponent: new Date().valueOf()
    });
  };

  CreateModal.prototype.render = function render() {
    var _state = this.state,
        show = _state.show,
        submitStatus = _state.submitStatus,
        resetComponent = _state.resetComponent,
        _state$deleteWorkNode = _state.deleteWorkNode,
        deleteWorkNode = _state$deleteWorkNode === undefined ? {} : _state$deleteWorkNode,
        _state$deleteElectric = _state.deleteElectricNode,
        deleteElectricNode = _state$deleteElectric === undefined ? {} : _state$deleteElectric,
        _state$workNodes = _state.workNodes,
        workNodes = _state$workNodes === undefined ? [] : _state$workNodes,
        _state$electricNodes = _state.electricNodes,
        electricNodes = _state$electricNodes === undefined ? [] : _state$electricNodes,
        _state$checkedWorkNod = _state.checkedWorkNodes,
        checkedWorkNodes = _state$checkedWorkNod === undefined ? [] : _state$checkedWorkNod,
        _state$checkedElectri = _state.checkedElectricNodes,
        checkedElectricNodes = _state$checkedElectri === undefined ? [] : _state$checkedElectri;


    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-light",
        backdrop: "static",
        show: show,
        onHide: this.onHide,
        className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.pairs
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        this.intlMsg.msg('header')
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Row"],
          { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.header },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
            { md: 3 },
            this.intlMsg.msg('title.work')
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
            { md: 6 },
            "Pairs"
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
            { md: 3 },
            this.intlMsg.msg('title.params')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Row"],
          { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.body },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Work__["a" /* default */], {
              nodes: workNodes,
              onChecked: this.onWorkNodes,
              deleteNode: deleteWorkNode,
              resetComponent: resetComponent
            })
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
            { md: 6, className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.pair },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Pair__["a" /* default */], {
              onChecked: this.onCheckedPairs,
              workNodes: checkedWorkNodes,
              electricNodes: checkedElectricNodes,
              onRemove: this.onRemovePairs,
              resetComponent: resetComponent
            })
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Col"],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Electric__["a" /* default */], {
              nodes: electricNodes,
              onChecked: this.onElectricNodes,
              deleteNode: deleteElectricNode,
              resetComponent: resetComponent
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"].Footer,
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-default",
            onClick: this.onHide,
            className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.white
          },
          this.intlMsg.msg('cancel')
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-success",
            onClick: this.onSubmit,
            disabled: submitStatus === 'pending'
          },
          submitStatus === 'pending' && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("i", { className: "fa fa-spin fa-spinner m-r-s" }),
          this.intlMsg.msg('confirm')
        )
      )
    );
  };

  return CreateModal;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

CreateModal.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    updateNodes: state.tdm.updateNodes,
    networkDetail: state.tdm.getNetwork
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["connect"])(mapStateToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"])(CreateModal)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  show: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  checkedPairs: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array.isRequired,
  onDelSuccess: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  onCancel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};

var DeleteModal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeleteModal, _React$Component);

  function DeleteModal(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeleteModal);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      show: props.show,
      checkedPairs: props.checkedPairs
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.pairs.delete');
    _this.onSubmite = _this.onSubmite.bind(_this);
    return _this;
  }

  DeleteModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var show = _ref.show,
        checkedPairs = _ref.checkedPairs;

    if (show !== this.props.show) {
      this.setState({ show: show });
    }
    if (!_.isEqual(checkedPairs, this.props.checkedPairs)) {
      this.setState({ checkedPairs: checkedPairs });
    }
  };

  DeleteModal.prototype.onSubmite = function onSubmite() {
    var _this2 = this;

    this.setState({ submitStatus: 'pending' });

    var checkedPairs = this.state.checkedPairs;

    var delFunc = function delFunc() {
      var pair = checkedPairs.pop();
      if (pair) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__api_callAPI__["a" /* default */])({
          endpoint: "/tdmng/pairs/" + pair,
          method: 'DELETE'
        }).then(function () {
          delFunc();
        }).catch(function () {});
      } else {
        _this2.setState({ submitStatus: '' });

        _.delay(function () {
          _this2.props.onDelSuccess();
          _this2.props.onCancel();
        }, 250);
      }
    };
    delFunc();
  };

  DeleteModal.prototype.render = function render() {
    var _state = this.state,
        show = _state.show,
        submitStatus = _state.submitStatus;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"],
      {
        bsClass: "aisz-modal-danger",
        backdrop: "static",
        show: show,
        onHide: this.props.onCancel
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Header,
        { closeButton: true },
        this.intlMsg.msg('title')
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: "text-center" },
          this.intlMsg.msg('warn')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Footer,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-default",
            className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.white,
            onClick: this.props.onCancel
          },
          this.intlMsg.msg('cancel')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-danger",
            onClick: this.onSubmite,
            disabled: submitStatus === 'pending'
          },
          submitStatus === 'pending' && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spin fa-spinner m-r-s" }),
          this.intlMsg.msg('confirm')
        )
      )
    );
  };

  return DeleteModal;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DeleteModal.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(DeleteModal));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_TablePager__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);












var kOffset = 10;

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_react_intl__["intlShape"].isRequired,
  nodes: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array.isRequired,
  onChecked: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  deleteNode: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  resetComponent: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any.isRequired
};

var Electric = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Electric, _React$Component);

  function Electric(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Electric);

    // const list = _.slice(props.nodes, this.mark, kOffset);
    // this.mark += kOffset;

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      list: [],
      checked: [],
      mark: 0,
      more: false
    };
    _this.mark = 0;
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.pairs.create');
    _this.allNodes = props.nodes;
    _this.deleteNode = props.deleteNode;
    _this.isChecked = _this.isChecked.bind(_this);
    _this.onNextPage = _this.onNextPage.bind(_this);
    _this.onPrevPage = _this.onPrevPage.bind(_this);
    return _this;
  }

  Electric.prototype.componentDidMount = function componentDidMount() {
    this.loadAddElectrictNodes();
  };

  Electric.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var nodes = _ref.nodes,
        deleteNode = _ref.deleteNode,
        resetComponent = _ref.resetComponent;

    if (!_.isEqual(nodes, this.props.nodes)) {
      this.allNodes = nodes;
    }
    if (!_.isEqual(deleteNode, this.deleteNode)) {
      this.deleteNode = deleteNode;
      this.resetChecked();
    }
    if (resetComponent !== this.props.resetComponent) {
      this.resetComponent();
    }
  };

  Electric.prototype.onNextPage = function onNextPage() {
    // const list = _.slice(this.allNodes, this.mark, this.mark + kOffset);
    this.mark += kOffset;
    // const more = this.allNodes.length > this.mark;
    // this.setState({ list, mark: this.mark, more });
    this.loadAddElectrictNodes();
  };

  Electric.prototype.onPrevPage = function onPrevPage(m) {
    this.mark = m || 0;
    // const list = _.slice(this.allNodes, this.mark, this.mark + kOffset);
    // this.mark += kOffset;
    // const more = this.allNodes.length > this.mark;
    // this.setState({ list, mark: this.mark, more });
    this.loadAddElectrictNodes();
  };

  Electric.prototype.loadAddElectrictNodes = function loadAddElectrictNodes() {
    var _this2 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__api_callAPI__["a" /* default */])({
      endpoint: '/tdmng/nodes',
      query: { pair: 'n', typ: '电参', limit: kOffset, mark: this.mark },
      method: 'GET'
    }).then(function (res) {
      var list = res.list,
          mark = res.mark,
          more = res.more;

      _this2.setState({ list: list, mark: mark, more: more });
    }).catch(function () {});
  };

  Electric.prototype.isChecked = function isChecked(d) {
    var checked = this.state.checked;

    return _.some(checked, { id: d.id });
  };

  Electric.prototype.toggleCheck = function toggleCheck(d) {
    var checked = this.state.checked;

    if (this.isChecked(d)) {
      checked = _.filter(checked, function (c) {
        return c.id !== d.id;
      });
    } else {
      checked = _.concat(checked, [d]);
    }
    this.props.onChecked(checked);
    this.setState({ checked: checked });
  };

  Electric.prototype.resetChecked = function resetChecked() {
    var _this3 = this;

    var checked = this.state.checked;

    checked = _.filter(checked, function (c) {
      return c.id !== _this3.deleteNode.id;
    });
    this.setState({ checked: checked });
  };

  Electric.prototype.resetComponent = function resetComponent() {
    this.mark = 0;
    this.setState({ checked: [], reset: new Date().valueOf() });
    this.loadAddElectrictNodes();
  };

  Electric.prototype.render = function render() {
    var _this4 = this;

    var _state = this.state,
        mark = _state.mark,
        more = _state.more,
        list = _state.list,
        _state$reset = _state.reset,
        reset = _state$reset === undefined ? 0 : _state$reset;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.auto },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Table"],
        { className: "aisz-table-light", striped: true },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('name')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              "ID"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "tbody",
          null,
          _.map(list, function (item) {
            var memo = item.memo ? JSON.parse(item.memo) : {};
            var checked = _this4.isChecked(item);
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "tr",
              { key: item.id },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Checkbox__["a" /* default */], {
                  id: item.id,
                  disabled: checked,
                  checked: checked,
                  onChange: function onChange() {
                    return _this4.toggleCheck(item);
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                memo.name
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                item.id
              )
            );
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_loracoms_ShowIf__["a" /* default */],
        { "if": list.length > 0 },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.pager, style: { marginBottom: '10px' } },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_TablePager__["a" /* default */], {
            status: "success",
            mark: mark,
            more: more,
            reset: reset,
            onPrev: this.onPrevPage,
            onNext: this.onNextPage
          })
        )
      )
    );
  };

  return Electric;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Electric.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(Electric));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);








var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_react_intl__["intlShape"].isRequired,
  onRemove: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  onChecked: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  workNodes: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array.isRequired,
  resetComponent: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any.isRequired,
  electricNodes: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array.isRequired
};

var Pair = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Pair, _React$Component);

  function Pair(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Pair);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      pairs: [],
      params: []
    };
    _this.remarks = {};
    _this.workNodes = props.workNodes;
    _this.electricNodes = props.electricNodes;
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_7_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.pairs.create');
    return _this;
  }

  Pair.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var workNodes = _ref.workNodes,
        electricNodes = _ref.electricNodes,
        resetComponent = _ref.resetComponent;

    if (!_.isEqual(workNodes, this.props.workNodes)) {
      this.workNodes = workNodes;
      this.combinePairs();
    }
    if (!_.isEqual(electricNodes, this.props.electricNodes)) {
      this.electricNodes = electricNodes;
      this.combinePairs();
    }
    if (resetComponent !== this.props.resetComponent) {
      this.setState({ pairs: [] });
      this.remarks = {};
    }
  };

  Pair.prototype.onChangeRemark = function onChangeRemark(e, id) {
    var _this2 = this;

    var remark = _.trimStart(e.target.value);
    this.remarks[id] = remark;
    if (this.timer) {
      clearTimeout(this.tiemr);
    }
    this.timer = _.delay(function () {
      _this2.props.onChecked(_this2.state.pairs, _this2.remarks);
    }, 500);
  };

  Pair.prototype.combinePairs = function combinePairs() {
    var pairs = _.zip(this.workNodes, this.electricNodes);
    this.setState({ pairs: pairs });
    this.props.onChecked(pairs, this.remarks);
  };

  Pair.prototype.removePair = function removePair(idx) {
    var pairs = this.state.pairs;

    var removeItem = pairs[idx];
    pairs = _.concat(_.slice(pairs, 0, idx), _.slice(pairs, idx + 1, pairs.length));
    this.setState({ pairs: pairs });
    this.props.onRemove(removeItem);
  };

  Pair.prototype.render = function render() {
    var _this3 = this;

    var pairs = this.state.pairs;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Table"],
        { className: "aisz-table-light", striped: true },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('title.work')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('remark')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('title.params')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('remove')
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "tbody",
          null,
          _.map(pairs, function (item, idx) {
            var workNode = item[0] || {};
            var electricNode = item[1] || {};
            var wMemo = workNode.memo ? JSON.parse(workNode.memo) : {};
            var eMemo = electricNode.memo ? JSON.parse(electricNode.memo) : {};
            var remarkId = '';
            if (workNode.id && _this3.remarks[workNode.id]) {
              remarkId = workNode.id;
            } else if (electricNode.id && _this3.remarks[electricNode.id]) {
              remarkId = electricNode.id;
            } else {
              remarkId = workNode.id || electricNode.id;
            }
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "tr",
              { key: idx },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                wMemo.name || workNode.id || __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "span",
                  { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.empty },
                  _this3.intlMsg.msg('empty')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["FormControl"], {
                  placeholder: "\u5907\u6CE8",
                  className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.input,
                  onChange: function onChange(e) {
                    return _this3.onChangeRemark(e, remarkId);
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                eMemo.name || electricNode.id || __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "span",
                  { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.empty },
                  _this3.intlMsg.msg('empty')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "a",
                  {
                    className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.remove,
                    onClick: function onClick() {
                      return _this3.removePair(idx);
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-minus-circle" })
                )
              )
            );
          })
        )
      )
    );
  };

  return Pair;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Pair.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(Pair));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_TablePager__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_Checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);












var kOffset = 10;

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_5_react_intl__["intlShape"].isRequired,
  nodes: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array.isRequired,
  onChecked: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  deleteNode: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  resetComponent: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any.isRequired
};

var Work = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Work, _React$Component);

  function Work(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Work);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      list: [],
      checked: [],
      mark: 0,
      more: false
    };
    _this.mark = 0;
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.pairs.create');
    _this.allNodes = props.nodes;
    _this.deleteNode = props.deleteNode;
    _this.isChecked = _this.isChecked.bind(_this);
    _this.onNextPage = _this.onNextPage.bind(_this);
    _this.onPrevPage = _this.onPrevPage.bind(_this);
    return _this;
  }

  Work.prototype.componentDidMount = function componentDidMount() {
    this.loadAddWorkNodes();
  };

  Work.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var nodes = _ref.nodes,
        deleteNode = _ref.deleteNode,
        resetComponent = _ref.resetComponent;

    if (!_.isEqual(nodes, this.props.nodes)) {
      this.allNodes = nodes;
    }
    if (!_.isEqual(deleteNode, this.deleteNode)) {
      this.deleteNode = deleteNode;
      this.resetChecked();
    }
    if (resetComponent !== this.props.resetComponent) {
      this.resetComponent();
    }
  };

  Work.prototype.onNextPage = function onNextPage() {
    this.mark += kOffset;
    this.loadAddWorkNodes();
  };

  Work.prototype.onPrevPage = function onPrevPage(m) {
    this.mark = m || 0;
    this.loadAddWorkNodes();
  };

  Work.prototype.loadAddWorkNodes = function loadAddWorkNodes() {
    var _this2 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__api_callAPI__["a" /* default */])({
      endpoint: '/tdmng/nodes',
      query: { pair: 'n', typ: '功图', limit: kOffset, mark: this.mark },
      method: 'GET'
    }).then(function (res) {
      var list = res.list,
          mark = res.mark,
          more = res.more;

      _this2.setState({ list: list, mark: mark, more: more });
    }).catch(function () {});
  };

  Work.prototype.isChecked = function isChecked(d) {
    var checked = this.state.checked;

    return _.some(checked, { id: d.id });
  };

  Work.prototype.toggleCheck = function toggleCheck(d) {
    var checked = this.state.checked;

    if (this.isChecked(d)) {
      checked = _.filter(checked, function (c) {
        return c.id !== d.id;
      });
    } else {
      checked = _.concat(checked, [d]);
    }
    this.props.onChecked(checked);
    this.setState({ checked: checked });
  };

  Work.prototype.resetChecked = function resetChecked() {
    var _this3 = this;

    var checked = this.state.checked;

    checked = _.filter(checked, function (c) {
      return c.id !== _this3.deleteNode.id;
    });
    this.setState({ checked: checked });
  };

  Work.prototype.resetComponent = function resetComponent() {
    this.mark = 0;
    this.setState({ checked: [], reset: new Date().valueOf() });
    this.loadAddWorkNodes();
  };

  Work.prototype.render = function render() {
    var _this4 = this;

    var _state = this.state,
        mark = _state.mark,
        more = _state.more,
        list = _state.list,
        _state$reset = _state.reset,
        reset = _state$reset === undefined ? 0 : _state$reset;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.auto },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Table"],
        { className: "aisz-table-light", striped: true },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              this.intlMsg.msg('name')
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "th",
              null,
              "ID"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "tbody",
          null,
          _.map(list, function (item) {
            var memo = item.memo ? JSON.parse(item.memo) : {};
            var checked = _this4.isChecked(item);
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "tr",
              { key: item.id },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_Checkbox__["a" /* default */], {
                  id: item.id,
                  disabled: checked,
                  checked: checked,
                  onChange: function onChange() {
                    return _this4.toggleCheck(item);
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                memo.name
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                item.id
              )
            );
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_loracoms_ShowIf__["a" /* default */],
        { "if": list.length > 0 },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.pager, style: { marginBottom: '10px' } },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_TablePager__["a" /* default */], {
            status: "success",
            mark: mark,
            more: more,
            reset: reset,
            onPrev: this.onPrevPage,
            onNext: this.onNextPage
          })
        )
      )
    );
  };

  return Work;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Work.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(Work));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_TablePagerTDM__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_LoadingTable__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracoms_Checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loracoms_SearchInput__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__api_callAPI__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lorautils_pagerUtil__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__CreateModal__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DeleteModal__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




















var kLimit = 10;
var kRouterAction = ['POP', 'REPLACE'];
var kMarksKey = 'pairsMarks';

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_7_react_intl__["intlShape"].isRequired,
  network: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  routerAction: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};

var Pairs = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Pairs, _React$Component);

  function Pairs(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Pairs);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      list: [],
      status: '',
      checked: [],
      network: props.network
    };
    _this.marks = [];
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_14_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.tdm.pairs');
    _this.callback = _this.callback.bind(_this);
    _this.handlePaging = _this.handlePaging.bind(_this);
    _this.onChangeSearch = _this.onChangeSearch.bind(_this);
    return _this;
  }

  Pairs.prototype.componentDidMount = function componentDidMount() {
    if (_.includes(kRouterAction, this.props.routerAction)) {
      this.marks = __WEBPACK_IMPORTED_MODULE_17_lorautils_pagerUtil__["a" /* pageParams */].getMarks(kMarksKey) || [];
      if (this.marks.length > 1) {
        this.mark = this.marks[this.marks.length - 2];
      }
    }
    this.loadData();
  };

  Pairs.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var network = _ref.network;

    if (network !== this.props.network) {
      this.setState({ network: network });
    }
  };

  Pairs.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_17_lorautils_pagerUtil__["a" /* pageParams */].setMarks(this.marks, kMarksKey);
  };

  Pairs.prototype.onCheckedAll = function onCheckedAll(c) {
    var checked = this.state.checked;
    var list = this.state.list;

    if (c) {
      checked = [];
      list.forEach(function (l) {
        checked = _.concat(checked, [l.id]);
      });
    } else {
      checked = [];
    }
    this.setState({ checked: checked });
  };

  Pairs.prototype.onCheckedSingle = function onCheckedSingle(c, id) {
    var checked = this.state.checked;

    if (c) {
      checked = _.concat(checked, [id]);
    } else {
      checked = _.filter(checked, function (h) {
        return h !== id;
      });
    }
    this.setState({ checked: checked });
  };

  Pairs.prototype.onChangeSearch = function onChangeSearch(e) {
    var _this2 = this;

    this.q = e.target.value;
    this.setState({ search: this.q });

    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }

    this.searchTimer = _.delay(function () {
      _this2.resetMark();
      _this2.loadData();
    }, 250);
  };

  Pairs.prototype.loadData = function loadData() {
    var _this3 = this;

    this.setState({ status: 'pending' });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__api_callAPI__["a" /* default */])({
      endpoint: '/tdmng/pairs',
      query: { mark: this.mark, limit: kLimit, q: this.q }
    }).then(function (_ref2) {
      var list = _ref2.list,
          more = _ref2.more,
          mark = _ref2.mark;

      _this3.marks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_lorautils_pagerUtil__["b" /* updateMarks */])(_this3.marks, mark);
      _this3.setState({ more: more, mark: _this3.marks, list: list, status: 'success' });
    }).catch(function () {});
  };

  Pairs.prototype.checkedAll = function checkedAll() {
    var _state = this.state,
        list = _state.list,
        checked = _state.checked;

    return list.length > 0 && list.length === checked.length;
  };

  Pairs.prototype.handlePaging = function handlePaging(mark) {
    this.mark = mark;
    this.setState({ checked: [] });
    this.loadData();
  };

  Pairs.prototype.deletePair = function deletePair(pair) {
    var _this4 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__api_callAPI__["a" /* default */])({
      method: 'DELETE',
      endpoint: "/tdmng/pairs/" + pair.id
    }).then(function () {
      _this4.callback();
      _this4.setState({ deletePair: pair });
    }).catch(function () {});
  };

  Pairs.prototype.callback = function callback() {
    this.resetMark();
    this.loadData();
  };

  Pairs.prototype.resetMark = function resetMark() {
    this.mark = 0;
    this.marks = [];
    this.setState({ reset: new Date().valueOf() });
  };

  Pairs.prototype.renderTable = function renderTable() {
    var _this5 = this;

    var _state2 = this.state,
        status = _state2.status,
        list = _state2.list,
        checked = _state2.checked;

    var thead = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "thead",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Checkbox__["a" /* default */], {
            id: "allPairs",
            checked: this.checkedAll(),
            onChange: function onChange(c) {
              return _this5.onCheckedAll(c);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('name1')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('id1')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('name2')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('id2')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('remark')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('remove')
        )
      )
    );
    if (status === 'success') {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Table"],
        { className: "aisz-table-light" },
        thead,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "tbody",
          null,
          _.map(list, function (l) {
            var memo = l.memo ? JSON.parse(l.memo) : {};
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "tr",
              { key: l.id },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_loracoms_Checkbox__["a" /* default */], {
                  id: l.id + "-pairs",
                  checked: _.includes(checked, l.id),
                  onChange: function onChange(c) {
                    return _this5.onCheckedSingle(c, l.id);
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                memo.name || '--'
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lorautils_IdUtils__["a" /* normalizeDevEUI */])(l.id)
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                memo.rname || '--'
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lorautils_IdUtils__["a" /* normalizeDevEUI */])(l.rnode)
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                memo.remark
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "a",
                  {
                    className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.deleteBtn,
                    onClick: function onClick() {
                      return _this5.deletePair(l);
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "halflings halflings-trash" })
                )
              )
            );
          })
        )
      );
    }
    var rows = Math.max(1, list.length);
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_loracoms_LoadingTable__["a" /* default */],
      {
        className: "aisz-table-light",
        striped: true,
        bordered: true,
        rows: rows,
        cols: 6
      },
      thead
    );
  };

  Pairs.prototype.render = function render() {
    var _this6 = this;

    var _state3 = this.state,
        list = _state3.list,
        status = _state3.status,
        network = _state3.network,
        checked = _state3.checked,
        search = _state3.search,
        _state3$mark = _state3.mark,
        mark = _state3$mark === undefined ? '' : _state3$mark,
        _state3$reset = _state3.reset,
        reset = _state3$reset === undefined ? 0 : _state3$reset,
        _state3$more = _state3.more,
        more = _state3$more === undefined ? false : _state3$more,
        _state3$deletePair = _state3.deletePair,
        deletePair = _state3$deletePair === undefined ? {} : _state3$deletePair,
        _state3$showCreate = _state3.showCreate,
        showCreate = _state3$showCreate === undefined ? false : _state3$showCreate,
        _state3$showDelete = _state3.showDelete,
        showDelete = _state3$showDelete === undefined ? false : _state3$showDelete;


    var header = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      this.intlMsg.msg('title'),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: "pull-right" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-danger",
            disabled: !network || !checked.length,
            className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.addBtn,
            onClick: function onClick() {
              return _this6.setState({ showDelete: true });
            }
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "halflings halflings-trash" }),
          "\xA0",
          this.intlMsg.msg('batch.delete')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-primary",
            disabled: !network,
            className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.addBtn,
            onClick: function onClick() {
              return _this6.props.pushState('/network/tdm/batch/pairs');
            }
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-arrow-circle-right" }),
          "\xA0",
          this.intlMsg.msg('batch')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-success",
            disabled: !network,
            onClick: function onClick() {
              return _this6.setState({ showCreate: true });
            },
            className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.addBtn
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-plus", "aria-hidden": "true" }),
          "\xA0",
          this.intlMsg.msg('add')
        )
      )
    );
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: header },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.searchIpt },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_loracoms_SearchInput__["a" /* default */], {
          value: search,
          placeholder: this.intlMsg.msg('search.placeholder'),
          onChange: this.onChangeSearch
        })
      ),
      this.renderTable(),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
        { "if": status === 'success' && !list.length },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.noData },
          this.intlMsg.msg('nodata')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
        { "if": list.length > 0 },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.pager },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_TablePagerTDM__["a" /* default */], {
            status: status,
            mark: mark,
            more: more,
            reset: reset,
            onPrev: this.handlePaging,
            onNext: this.handlePaging
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__CreateModal__["a" /* default */], {
        show: showCreate,
        deletePair: deletePair,
        onHide: function onHide() {
          return _this6.setState({ showCreate: false });
        },
        onAdded: this.callback
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__DeleteModal__["a" /* default */], {
        show: showDelete,
        checkedPairs: checked,
        onDelSuccess: this.callback,
        onCancel: function onCancel() {
          return _this6.setState({ showDelete: false });
        }
      })
    );
  };

  return Pairs;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Pairs.propTypes = propTypes;

var mapDispatchToprops = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(null, mapDispatchToprops)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(Pairs)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loraactions_tdm__ = __webpack_require__(248);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);






var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.node.isRequired,
  getNetwork: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  getTypesJSON: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};

var TDMView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(TDMView, _React$Component);

  function TDMView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TDMView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {};
    return _this;
  }

  TDMView.prototype.componentDidMount = function componentDidMount() {
    this.props.getNetwork();
    this.props.getTypesJSON();
  };

  TDMView.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      this.props.children
    );
  };

  return TDMView;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

TDMView.propTypes = propTypes;

var mapDispatchToProps = {
  getTypesJSON: __WEBPACK_IMPORTED_MODULE_6_loraactions_tdm__["d" /* setting */],
  getNetwork: __WEBPACK_IMPORTED_MODULE_6_loraactions_tdm__["a" /* getNetwork */]
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(null, mapDispatchToProps)(TDMView));

/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_InlineSelect__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_LoadingTable__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_SortBtn__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss__ = __webpack_require__(2308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);












var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired
};

var UnauthorizedPacketView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(UnauthorizedPacketView, _React$Component);

  function UnauthorizedPacketView(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, UnauthorizedPacketView);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      tableData: [],
      initialStatus: 'pending',
      queryHours: 24,
      sortKey: ''
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_6_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network.UnauthorizedPacketView');
    return _this;
  }

  UnauthorizedPacketView.prototype.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.loadNetworkAnalysisList();
  };

  UnauthorizedPacketView.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  UnauthorizedPacketView.prototype.loadNetworkAnalysisList = function loadNetworkAnalysisList() {
    var _this2 = this;

    this.setState({ initialStatus: 'pending' });

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lorautils_api__["a" /* callAPI */])({
      endpoint: '/na/unauthorized_packet_summary',
      query: {
        hours: this.state.queryHours
      }
    }).then(function (data) {
      if (_this2.mounted) {
        _this2.setState({
          initialStatus: 'success',
          tableData: data
        });
      }
    }).catch(function () {
      _this2.setState({
        initialStatus: 'failure'
      });
    });
  };

  UnauthorizedPacketView.prototype.handleSort = function handleSort(sort) {
    var tableData = this.state.tableData || [];
    var sortOrder = true;
    var sortKey = '';
    if (sort.startsWith('-')) {
      sortOrder = true;
      sortKey = sort.substr(1);
    } else {
      sortOrder = false;
      sortKey = sort;
    }
    if (sortKey.endsWith('percentile')) {
      tableData.sort(function (a, b) {
        if (sortOrder) {
          return a[sortKey][1] >= b[sortKey][1];
        }
        return a[sortKey][1] <= b[sortKey][1];
      });
    } else {
      tableData.sort(function (a, b) {
        if (sortOrder) {
          return a[sortKey] >= b[sortKey];
        }
        return a[sortKey] <= b[sortKey];
      });
    }

    this.setState({
      tableData: tableData,
      sortKey: sortKey
    });
  };

  UnauthorizedPacketView.prototype.render = function render() {
    var _this3 = this;

    var _state = this.state,
        initialStatus = _state.initialStatus,
        sortKey = _state.sortKey,
        tableData = _state.tableData;

    var thead = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "thead",
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.devaddr'),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_SortBtn__["a" /* default */], {
            sortName: "devaddr",
            highLight: sortKey === 'devaddr',
            handleSort: function handleSort(s) {
              return _this3.handleSort(s);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.deveui'),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_SortBtn__["a" /* default */], {
            sortName: "deveui",
            highLight: sortKey === 'deveui',
            handleSort: function handleSort(s) {
              return _this3.handleSort(s);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.gateway'),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_SortBtn__["a" /* default */], {
            sortName: "gateway",
            highLight: sortKey === 'gateway',
            handleSort: function handleSort(s) {
              return _this3.handleSort(s);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.frequency'),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_SortBtn__["a" /* default */], {
            sortName: "frequency",
            highLight: sortKey === 'frequency',
            handleSort: function handleSort(s) {
              return _this3.handleSort(s);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.toa_total'),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_SortBtn__["a" /* default */], {
            sortName: "toa_total",
            highLight: sortKey === 'toa_total',
            handleSort: function handleSort(s) {
              return _this3.handleSort(s);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "th",
          null,
          this.intlMsg.msg('thead.total'),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_loracoms_SortBtn__["a" /* default */], {
            sortName: "total",
            highLight: sortKey === 'total',
            handleSort: function handleSort(s) {
              return _this3.handleSort(s);
            }
          })
        )
      )
    );
    var hoursStr = this.intlMsg.msg('hours');
    var rightTools = [{
      type: 'buttons',
      buttons: [__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_InlineSelect__["a" /* default */], {
        options: [{
          label: "1 " + hoursStr,
          value: 1
        }, {
          label: "6 " + hoursStr,
          value: 6
        }, {
          label: "12 " + hoursStr,
          value: 12
        }, {
          label: "24 " + hoursStr,
          value: 24
        }, {
          label: "72 " + hoursStr,
          value: 72
        }],
        values: [this.state.queryHours],
        onChange: function onChange(selected) {
          _this3.setState({
            queryHours: selected[0]
          }, function () {
            _this3.loadNetworkAnalysisList();
          });
        }
      })]
    }];
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_Toolbar__["a" /* default */], {
            brandTitle: this.intlMsg.msg('title'),
            rightTools: rightTools
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Panel"],
            {
              className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.panel,
              bsStyle: "aisz-white",
              header: this.intlMsg.msg('tableHeader')
            },
            initialStatus === 'success' && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Table"],
              { className: "aisz-table-light", striped: true, hover: true, bordered: true, responsive: true },
              thead,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "tbody",
                null,
                tableData.map(function (r, idx) {
                  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "tr",
                    { key: String(idx) },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "td",
                      null,
                      r.devaddr
                    ),
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "td",
                      null,
                      r.deveui
                    ),
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "td",
                      null,
                      r.gateway
                    ),
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "td",
                      null,
                      r.frequency
                    ),
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "td",
                      null,
                      r.toa_total
                    ),
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "td",
                      null,
                      r.total
                    )
                  );
                })
              )
            ),
            initialStatus === 'pending' && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_loracoms_LoadingTable__["a" /* default */],
              { cols: 6, rows: 1, className: "aisz-table-light" },
              thead
            )
          )
        )
      )
    );
  };

  return UnauthorizedPacketView;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

UnauthorizedPacketView.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(UnauthorizedPacketView));

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_SideBar__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_SidebarContainer__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_PageLoading__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_PageNoPerm__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loracfg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__img_TDM_svg__ = __webpack_require__(2792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__img_TDM_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__img_TDM_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__img_heartmap_svg__ = __webpack_require__(2793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__img_heartmap_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__img_heartmap_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_scss__ = __webpack_require__(2309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);















var defaultProps = {
  view: '',
  plan: {}
};

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  view: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  plan: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object,
  children: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.node.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var Network = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Network, _React$Component);

  function Network(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Network);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      view: props.view,
      plan: props.plan
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'network');
    return _this;
  }

  Network.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var plan = nextProps.plan,
        view = nextProps.view;

    if (plan !== this.props.plan) {
      this.setState({ plan: plan });
    }
    if (view !== this.props.view) {
      this.setState({ view: view });
    }
  };

  Network.prototype.renderSideBar = function renderSideBar() {
    var pushState = this.props.pushState;
    var view = this.state.view;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_SideBar__["a" /* default */], {
      height: window.innerHeight,
      title: this.intlMsg.msg('sidebar.title'),
      menuItems: [{
        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-voice" }),
        text: 'ADR',
        onClick: function onClick() {
          return pushState('/network/adr');
        },
        active: view === 'adr' || view === ''
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-equalizer" }),
        text: this.intlMsg.msg('sidebar.menuitems.band'),
        onClick: function onClick() {
          return pushState('/network/chplans');
        },
        active: view === 'chplans'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-remote-control" }),
        text: this.intlMsg.msg('sidebar.menuitems.node'),
        onClick: function onClick() {
          return pushState('/network/node');
        },
        active: view === 'node',
        show: __WEBPACK_IMPORTED_MODULE_12_loracfg__["a" /* default */].profile === 'hide'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-wifi-alt" }),
        text: this.intlMsg.msg('sidebar.menuitems.gateway'),
        onClick: function onClick() {
          return pushState('/network/gateway');
        },
        active: view === 'gateway',
        show: __WEBPACK_IMPORTED_MODULE_12_loracfg__["a" /* default */].profile === 'hide'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-signal" }),
        text: this.intlMsg.msg('sidebar.menuitems.quality'),
        onClick: function onClick() {
          return pushState('/network/quality');
        },
        active: view === 'quality',
        show: __WEBPACK_IMPORTED_MODULE_12_loracfg__["a" /* default */].profile === 'cloud'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-cardio" }),
        text: this.intlMsg.msg('sidebar.menuitems.capacity'),
        onClick: function onClick() {
          return pushState('/network/capacity');
        },
        active: view === 'capacity',
        show: __WEBPACK_IMPORTED_MODULE_12_loracfg__["a" /* default */].profile === 'cloud'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-alert" }),
        text: this.intlMsg.msg('sidebar.menuitems.unauthorized'),
        onClick: function onClick() {
          return pushState('/network/unauthorized');
        },
        active: view === 'unauthorized',
        show: __WEBPACK_IMPORTED_MODULE_12_loracfg__["a" /* default */].profile === 'cloud'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-ruler" }),
        text: this.intlMsg.msg('sidebar.menuitems.coverage'),
        onClick: function onClick() {
          return pushState('/network/coverage');
        },
        active: view === 'coverage',
        show: __WEBPACK_IMPORTED_MODULE_12_loracfg__["a" /* default */].profile === 'cloud'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-pie-chart" }),
        text: this.intlMsg.msg('sidebar.menuitems.capacityCalculation'),
        onClick: function onClick() {
          return pushState('/network/capacityCalculation');
        },
        active: view === 'capacityCalculation',
        show: __WEBPACK_IMPORTED_MODULE_12_loracfg__["a" /* default */].profile === 'cloud'
      },
      // {
      //   icon: <span className="glyphicons glyphicons-car" />,
      //   text: this.intlMsg.msg('sidebar.menuitems.roadtest'),
      //   onClick: () => pushState('/network/roadtest'),
      //   active: view === 'roadtest',
      //   // show: config.profile === 'cloud',
      // }, 
      {
        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_13__img_TDM_svg___default.a, alt: "", style: { width: '25px', height: '32px' } }),
        text: this.intlMsg.msg('sidebar.menuitems.tdm'),
        onClick: function onClick() {
          return pushState('/network/tdm');
        },
        active: view === 'tdm',
        show: __WEBPACK_IMPORTED_MODULE_12_loracfg__["a" /* default */].profile === 'cube'
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_14__img_heartmap_svg___default.a, alt: "", style: { width: '25px', height: '32px' } }),
        text: this.intlMsg.msg('sidebar.menuitems.tdmstatis'),
        onClick: function onClick() {
          return pushState('/network/tdmstatis');
        },
        active: view === 'tdmstatis',
        show: __WEBPACK_IMPORTED_MODULE_12_loracfg__["a" /* default */].profile === 'cube'
      }]
    });
  };

  Network.prototype.render = function render() {
    var _state$plan = this.state.plan,
        status = _state$plan.status,
        data = _state$plan.data;

    if (status !== 'success') {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_PageLoading__["a" /* default */], null);
    }
    if (data.tier === 1) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_PageNoPerm__["a" /* default */], null);
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      null,
      this.renderSideBar(),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_loracoms_SidebarContainer__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_15__styles_scss___default.a.view },
          this.props.children
        )
      )
    );
  };

  return Network;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Network.defaultProps = defaultProps;
Network.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    view: ownProps.location.pathname.split('/')[2] || '',
    plan: state.billing.plan
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(Network)));

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NotFound;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



function NotFound() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "container" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h1",
      null,
      "Doh! 404!"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      "These are ",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "em",
        null,
        "not"
      ),
      " the droids you are looking for!"
    )
  );
}

/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss__ = __webpack_require__(2310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_trial_user_svg__ = __webpack_require__(2799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_trial_user_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_trial_user_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_trial_user_expired_svg__ = __webpack_require__(2798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_trial_user_expired_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_trial_user_expired_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_svcpkg_user_svg__ = __webpack_require__(2797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_svcpkg_user_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_svcpkg_user_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_svcpkg_user_expired_svg__ = __webpack_require__(2796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_svcpkg_user_expired_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_svcpkg_user_expired_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_comm_user_svg__ = __webpack_require__(2795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_comm_user_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_comm_user_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_comm_user_expired_svg__ = __webpack_require__(2794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_comm_user_expired_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_comm_user_expired_svg__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);











var propTypes = {
  plan: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var BillingAvatar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(BillingAvatar, _React$Component);

  function BillingAvatar(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, BillingAvatar);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      plan: props.plan
    };
    return _this;
  }

  BillingAvatar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var plan = nextProps.plan;

    if (plan !== this.props.plan) {
      this.setState({ plan: plan });
    }
  };

  BillingAvatar.prototype.render = function render() {
    var plan = this.state.plan;

    var avatar = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.loading },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" })
    );

    if (plan.status === 'success') {
      var _plan$data = plan.data,
          tier = _plan$data.tier,
          expired = _plan$data.expired;

      if (tier === 1 && expired) {
        avatar = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_7__images_trial_user_expired_svg___default.a, alt: "", className: "img-responsive" });
      } else if (tier === 1) {
        avatar = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_6__images_trial_user_svg___default.a, alt: "", className: "img-responsive" });
      } else if (tier === 2 && expired) {
        avatar = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_9__images_svcpkg_user_expired_svg___default.a, alt: "", className: "img-responsive" });
      } else if (tier === 2) {
        avatar = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_8__images_svcpkg_user_svg___default.a, alt: "", className: "img-responsive" });
      } else if (tier === 3 && expired) {
        avatar = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_11__images_comm_user_expired_svg___default.a, alt: "", className: "img-responsive" });
      } else {
        avatar = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_10__images_comm_user_svg___default.a, alt: "", className: "img-responsive" });
      }
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.avatar },
      avatar
    );
  };

  return BillingAvatar;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

BillingAvatar.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    plan: state.billing.plan
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, null)(BillingAvatar));

/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_Nvl__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_HideIf__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__BillingAvatar__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_scss__ = __webpack_require__(2311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);














var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  orgBasic: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  accountBasic: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  plan: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var BillingCard = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(BillingCard, _React$Component);

  function BillingCard(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, BillingCard);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      orgBasic: props.orgBasic,
      accountBasic: props.accountBasic,
      plan: props.plan
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'overview.billing');
    return _this;
  }

  BillingCard.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var orgBasic = nextProps.orgBasic,
        accountBasic = nextProps.accountBasic,
        plan = nextProps.plan;

    if (orgBasic !== this.props.orgBasic) {
      this.setState({ orgBasic: orgBasic });
    }
    if (accountBasic !== this.props.accountBasic) {
      this.setState({ accountBasic: accountBasic });
    }
    if (plan !== this.props.plan) {
      this.setState({ plan: plan });
    }
  };

  BillingCard.prototype.localeDay = function localeDay(day) {
    var locale = this.props.intl.locale;
    if (locale === 'zh') {
      return day + "\u65E5";
    } else if (day === 1) {
      return day + "st";
    } else if (day === 2) {
      return day + "nd";
    } else if (day === 3) {
      return day + "rd";
    }
    return day + "th";
  };

  BillingCard.prototype.render = function render() {
    var pushState = this.props.pushState;
    var _state = this.state,
        accountBasic = _state.accountBasic,
        orgBasic = _state.orgBasic,
        plan = _state.plan;
    var accStatus = accountBasic.status,
        _accountBasic$data = accountBasic.data;
    _accountBasic$data = _accountBasic$data === undefined ? {} : _accountBasic$data;
    var name = _accountBasic$data.name;
    var orgStatus = orgBasic.status,
        _orgBasic$data = orgBasic.data;
    _orgBasic$data = _orgBasic$data === undefined ? {} : _orgBasic$data;
    var balance = _orgBasic$data.balance;
    var planStatus = plan.status,
        _plan$data = plan.data;
    _plan$data = _plan$data === undefined ? {} : _plan$data;
    var _plan$data$tier = _plan$data.tier,
        tier = _plan$data$tier === undefined ? 999 : _plan$data$tier,
        remaining = _plan$data.remaining,
        billday = _plan$data.billday;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.card },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Col"],
          { md: 4, xs: 4, className: "collapse-right" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
            { "if": "profile:cube" },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__BillingAvatar__["a" /* default */], null)
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_loracoms_HideIf__["a" /* default */],
            { "if": "profile:cube" },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
              { onClick: function onClick() {
                  return pushState('/billing');
                } },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__BillingAvatar__["a" /* default */], null)
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Col"],
          { md: 8, xs: 8 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.basic },
            "Hi, ",
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_Nvl__["a" /* default */], { val: name, status: accStatus }),
            "!"
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_loracoms_HideIf__["a" /* default */],
            { "if": "profile:cube" },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.balance },
                this.intlMsg.msg('balance'),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "span",
                  { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.value + " " + (balance < 0 ? __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.debt : '') },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_Nvl__["a" /* default */], { val: balance, status: orgStatus })
                ),
                this.intlMsg.msg('yuan')
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Button"],
                {
                  bsStyle: "aisz-primary",
                  bsSize: "xsmall",
                  onClick: function onClick() {
                    return pushState('/billing/recharge');
                  }
                },
                this.intlMsg.msg('recharge')
              )
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Col"],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_loracoms_HideIf__["a" /* default */],
            { "if": "profile:cube" },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.tier },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
                  { "if": tier === 1 },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "div",
                    null,
                    " ",
                    this.intlMsg.msg('tier.free'),
                    " "
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
                  { "if": tier === 2 },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "div",
                    null,
                    " ",
                    this.intlMsg.msg('tier.svcpkg'),
                    " "
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
                  { "if": tier <= 2 },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "div",
                    null,
                    this.intlMsg.msg('tier.remaining'),
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "span",
                      { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.value },
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loracoms_Nvl__["a" /* default */], { val: remaining, status: planStatus })
                    ),
                    this.intlMsg.msg('tier.day')
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
                  { "if": tier === 3 },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "span",
                    null,
                    " ",
                    this.intlMsg.msg('tier.comm')
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
                { "if": tier <= 2 },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.promote },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Button"],
                    {
                      bsStyle: "aisz-warning",
                      onClick: function onClick() {
                        return pushState('/billing/plans');
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "halflings halflings-upload" }),
                    ' ',
                    this.intlMsg.msg('promote.upgrade')
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
                { "if": tier === 3 },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.billday },
                  this.intlMsg.msg('tier.comm.billday'),
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "span",
                    { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.value },
                    this.localeDay(billday)
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
                { "if": balance < 0 && remaining > 0 && tier === 3 },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  "div",
                  { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.arrear },
                  this.intlMsg.msg('tier.comm.arrear.willstop.prefix'),
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "span",
                    { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.value },
                    remaining
                  ),
                  this.intlMsg.msg('tier.comm.arrear.willstop.postfix')
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_loracoms_ShowIf__["a" /* default */],
            { "if": "profile:cube" },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              { className: __WEBPACK_IMPORTED_MODULE_14__styles_scss___default.a.greeting },
              this.intlMsg.msg('cube.welcome')
            )
          )
        )
      )
    );
  };

  return BillingCard;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

BillingCard.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    orgBasic: state.org.basic,
    accountBasic: state.account.basic,
    plan: state.billing.plan
  };
};

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_5_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(BillingCard)));

/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_scss__ = __webpack_require__(2312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_scss__);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);










var propTypes = {
  icon: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  handleClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  total: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  bordered: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

var defaultProps = {
  value: 0,
  total: 10,
  bordered: false
};

var Card = function Card(props) {
  var icon = props.icon,
      value = props.value,
      total = props.total,
      name = props.name,
      handleClick = props.handleClick,
      bordered = props.bordered;


  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4_react_router__["f" /* Link */],
    {
      styleName: "card " + (bordered ? 'bordered' : ''),
      onClick: handleClick
    },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      "div",
      { className: "media" },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "div",
        { className: "media-left" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { alt: "", className: "media-object", src: icon })
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "div",
        { className: "media-body" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "h4",
          { className: "media-heading" },
          name
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "p",
          null,
          value,
          ' / ',
          " ",
          total
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["ProgressBar"], { bsStyle: "aisz-primary", now: value / total * 100 })
  );
};

Card.propTypes = propTypes;
Card.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_react_css_modules___default()(Card, __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a, { allowMultiple: true }));

/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_DeviceMap__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss__ = __webpack_require__(2313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var DeviceMapPanel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeviceMapPanel, _React$Component);

  function DeviceMapPanel(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeviceMapPanel);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {};
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'overview');
    return _this;
  }

  DeviceMapPanel.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lorautils_api__["a" /* callAPI */])({
      endpoint: '/lora/nodes',
      query: { limit: 100 }
    }).then(function (data) {
      _this2.setState({ devices: data.list });
    }).catch(function () {});
  };

  DeviceMapPanel.prototype.render = function render() {
    var _state$devices = this.state.devices,
        devices = _state$devices === undefined ? [] : _state$devices;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: this.intlMsg.msg('devicemap') },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.map },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_DeviceMap__["a" /* default */], { devices: devices })
      )
    );
  };

  return DeviceMapPanel;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DeviceMapPanel.propTypes = propTypes;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(DeviceMapPanel));

/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loracoms_GatewayMap__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss__ = __webpack_require__(2314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var GatewayMapPanel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(GatewayMapPanel, _React$Component);

  function GatewayMapPanel(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GatewayMapPanel);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {};
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'overview');
    return _this;
  }

  GatewayMapPanel.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lorautils_api__["a" /* callAPI */])({
      endpoint: '/lora/gateways',
      query: { limit: 100 }
    }).then(function (data) {
      _this2.setState({ gateways: data.list });
    }).catch(function () {});
  };

  GatewayMapPanel.prototype.render = function render() {
    var _state$gateways = this.state.gateways,
        gateways = _state$gateways === undefined ? [] : _state$gateways;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Panel"],
      { bsStyle: "aisz-white", header: this.intlMsg.msg('gatewaymap') },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.map },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loracoms_GatewayMap__["a" /* default */], { gateways: gateways })
      )
    );
  };

  return GatewayMapPanel;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

GatewayMapPanel.propTypes = propTypes;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(GatewayMapPanel));

/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_SearchInput__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loraactions_gateway__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_loraactions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loraactions_app__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lorautils_IdUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss__ = __webpack_require__(2315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);
















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getApps: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getDevices: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  getGateways: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  apps: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  devices: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  gateways: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired
};

var SearchOverlay = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(SearchOverlay, _React$Component);

  function SearchOverlay(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SearchOverlay);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      apps: props.apps,
      devices: props.devices,
      gateways: props.gateways
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'overview.search');
    _this.handleSearch = _this.handleSearch.bind(_this);
    return _this;
  }

  SearchOverlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var apps = nextProps.apps,
        devices = nextProps.devices,
        gateways = nextProps.gateways;

    if (apps !== this.props.apps) {
      this.setState({ apps: apps });
    }
    if (devices !== this.props.devices) {
      this.setState({ devices: devices });
    }
    if (gateways !== this.props.gateways) {
      this.setState({ gateways: gateways });
    }
  };

  SearchOverlay.prototype.handleSearch = function handleSearch(e) {
    var _props = this.props,
        getApps = _props.getApps,
        getDevices = _props.getDevices,
        getGateways = _props.getGateways;

    var q = e.target.value;

    this.setState({
      searchQ: q
    });

    var doSearch = function doSearch() {
      var qq = q.replace(/[-:]/g, '');
      getApps({ q: "or,name:*" + q + "*,APPEUI:*" + qq + "*" });
      getGateways({ q: "or,name:*" + q + "*,id:*" + qq + "*" });
      getDevices({ q: "or,name:*" + q + "*,deveui:*" + qq + "*,devaddr:*" + qq + "*" });
    };

    if (q.length > 0) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(doSearch, 300);
    }
  };

  SearchOverlay.prototype.handleOnHide = function handleOnHide() {
    var _props2 = this.props,
        onHide = _props2.onHide,
        getApps = _props2.getApps;

    getApps({ count: true, tkcnt: true });
    onHide();
  };

  SearchOverlay.prototype.renderList = function renderList(result, major, sub, itemLink, moreLink) {
    var pushState = this.props.pushState;
    var _state$searchQ = this.state.searchQ,
        searchQ = _state$searchQ === undefined ? '' : _state$searchQ;

    if (searchQ === '') {
      return [];
    }

    var loading = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: "text-center " + __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.loading },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin fa-3x" })
    );

    var status = result.status,
        data = result.data;


    if (status === 'pending') {
      return loading;
    }
    if (status === 'success') {
      var list = data.list.map(function (item, idx) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "li",
          { key: idx },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* Link */],
            { onClick: function onClick() {
                return pushState(itemLink(item));
              } },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              { className: "" + __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.item },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.major },
                major(item) || sub(item)
              ),
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "div",
                { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.sub },
                sub(item)
              )
            )
          )
        );
      });
      list.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "li",
        { key: 'more', className: "text-center" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Button"],
          {
            bsStyle: "aisz-link-default",
            onClick: function onClick() {
              return pushState(moreLink);
            }
          },
          this.intlMsg.msg('seemore')
        )
      ));
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "ul",
        { className: "list-unstyled" },
        list
      );
    }

    return null;
  };

  SearchOverlay.prototype.renderResult = function renderResult() {
    var _state = this.state,
        apps = _state.apps,
        devices = _state.devices,
        gateways = _state.gateways;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Grid"],
      { fluid: true },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Row"],
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 4, className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.gateway },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "h2",
            null,
            this.intlMsg.msg('gateways')
          ),
          this.renderList(gateways, function (x) {
            return x.name;
          }, function (x) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lorautils_IdUtils__["b" /* normalizeMac */])(x.mac);
          }, function (x) {
            return "/gateway/detail/" + x.id;
          }, '/gateway')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 4, className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.app },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "h2",
            null,
            this.intlMsg.msg('apps')
          ),
          this.renderList(apps, function (x) {
            return x.name;
          }, function (x) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lorautils_IdUtils__["d" /* normalizeAppEUI */])(x.appeui);
          }, function (x) {
            return "/application/" + x.id;
          }, '/application')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
          { md: 4, className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.device },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "h2",
            null,
            this.intlMsg.msg('devices')
          ),
          this.renderList(devices, function (x) {
            return x.name;
          }, function (x) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lorautils_IdUtils__["a" /* normalizeDevEUI */])(x.deveui);
          }, function (x) {
            return "/application/" + x.appeui + "/devices/" + x.id;
          }, '/application')
        )
      )
    );
  };

  SearchOverlay.prototype.render = function render() {
    var _this2 = this;

    var _state$searchQ2 = this.state.searchQ,
        searchQ = _state$searchQ2 === undefined ? '' : _state$searchQ2;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default.a,
      {
        transitionName: {
          enter: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.overlayEnter,
          enterActive: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.overlayEnterActive,
          leave: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.overlayLeave,
          leaveActive: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.overlayLeaveActive,
          appear: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.overlayAppear,
          appearActive: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.overlayAppearActive
        },
        transitionAppear: true,
        transitionAppearTimeout: 300,
        transitionEnterTimeout: 300,
        transitionLeaveTimeout: 100
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.overlay, key: "overlay" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.closeButton },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Button"],
            { bsStyle: "aisz-link-default", onClick: function onClick() {
                return _this2.handleOnHide();
              } },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", { className: "glyphicons glyphicons-remove" })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.content },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.search },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_SearchInput__["a" /* default */], {
              placeholder: this.intlMsg.msg('placeholder'),
              value: searchQ,
              onChange: this.handleSearch,
              autoFocus: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.result },
            this.renderResult()
          )
        )
      )
    );
  };

  return SearchOverlay;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

SearchOverlay.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    apps: state.app.getApps,
    devices: state.device.getDevices,
    gateways: state.gateway.getGateways
  };
};

var mapDispatchToProps = {
  getApps: __WEBPACK_IMPORTED_MODULE_14_loraactions_app__["a" /* default */].getApps,
  getDevices: __WEBPACK_IMPORTED_MODULE_13_loraactions_device__["a" /* default */].getDevices,
  getGateways: __WEBPACK_IMPORTED_MODULE_12_loraactions_gateway__["a" /* default */].getGateways,
  pushState: __WEBPACK_IMPORTED_MODULE_7_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(SearchOverlay)));

/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_SearchInput__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Count__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__BillingCard__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SearchOverlay__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DeviceMapPanel__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__GatewayMapPanel__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_gateway_lg_svg__ = __webpack_require__(2802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_gateway_lg_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__images_gateway_lg_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_application_lg_svg__ = __webpack_require__(2800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_application_lg_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__images_application_lg_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_device_lg_svg__ = __webpack_require__(2801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_device_lg_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__images_device_lg_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss__ = __webpack_require__(2316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




















var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  usage: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  basic: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  gotoApps: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  gotoGateways: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  plan: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var Overview = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Overview, _React$Component);

  function Overview(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Overview);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      usage: props.usage,
      basic: props.basic,
      plan: props.plan
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_8_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'overview');
    return _this;
  }

  Overview.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var usage = nextProps.usage,
        basic = nextProps.basic,
        plan = nextProps.plan;

    if (usage !== this.props.usage) {
      this.setState({ usage: usage });
    }
    if (basic !== this.props.basic) {
      this.setState({ basic: basic });
    }
    if (plan !== this.props.plan) {
      this.setState({ plan: plan });
    }
  };

  Overview.prototype.renderToolbar = function renderToolbar() {
    var _this2 = this;

    var rightTools = [{
      type: 'search',
      searchInput: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_SearchInput__["a" /* default */], {
        placeholder: this.intlMsg.msg('search.placeholder'),
        value: "",
        onFocus: function onFocus() {
          return _this2.setState({ showSearch: true });
        },
        onChange: function onChange() {}
      })
    }];
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_Toolbar__["a" /* default */], {
      brandTitle: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "span",
        { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.greeting },
        this.intlMsg.msg('greeting')
      ),
      rightTools: rightTools
    });
  };

  Overview.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        gotoApps = _props.gotoApps,
        gotoGateways = _props.gotoGateways;
    var _state = this.state,
        usage = _state.usage,
        _state$basic$data = _state.basic.data,
        basic = _state$basic$data === undefined ? {} : _state$basic$data,
        _state$showSearch = _state.showSearch,
        showSearch = _state$showSearch === undefined ? false : _state$showSearch;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.wrapper },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_20__styles_scss___default.a.toolbar },
        this.renderToolbar()
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Grid"],
        { fluid: true },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"],
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
            { md: 3, className: "collapse-left" },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__BillingCard__["a" /* default */], null)
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
            { md: 3, className: "collapse-both" },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Count__["a" /* default */], {
              key: 1,
              icon: __WEBPACK_IMPORTED_MODULE_17__images_gateway_lg_svg___default.a,
              name: this.intlMsg.msg('gateway'),
              value: usage.gateways,
              total: basic.lrgatewaynum,
              color: "success",
              handleClick: gotoGateways
            })
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
            { md: 3, className: "collapse-both" },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Count__["a" /* default */], {
              icon: __WEBPACK_IMPORTED_MODULE_18__images_application_lg_svg___default.a,
              name: this.intlMsg.msg('application'),
              value: usage.apps,
              total: basic.lrappnum,
              color: "info",
              handleClick: gotoApps
            })
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Col"],
            { md: 3, className: "collapse-both" },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Count__["a" /* default */], {
              icon: __WEBPACK_IMPORTED_MODULE_19__images_device_lg_svg___default.a,
              name: this.intlMsg.msg('device'),
              value: usage.nodes,
              total: basic.lrnodenum,
              color: "warning",
              handleClick: gotoApps
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Row"], null)
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_loracoms_ShowIf__["a" /* default */],
        { "if": showSearch, key: "overlay" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__SearchOverlay__["a" /* default */], { onHide: function onHide() {
            return _this3.setState({ showSearch: false });
          } })
      )
    );
  };

  return Overview;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Overview.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    usage: state.usage,
    basic: state.org.basic,
    plan: state.billing.plan
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    gotoApps: function gotoApps() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__["push"])('/application'));
    },
    gotoGateways: function gotoGateways() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__["push"])('/gateway'));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(Overview)));

/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(5);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var Redirect = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Redirect, _React$Component);

  function Redirect() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Redirect);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.componentWillMount = function componentWillMount() {
    window.location = "/public?=" + this.props.intl.locale;
  };

  Redirect.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", null);
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_intl__["injectIntl"])(Redirect));

/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loraactions_register__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_scss__ = __webpack_require__(2317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);










var propTypes = {
  loadCaptcha: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.func.isRequired,
  captchaState: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.object.isRequired
};

var Captcha = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Captcha, _React$Component);

  function Captcha(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Captcha);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      captchaState: props.captchaState
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'register.captcha');
    return _this;
  }

  Captcha.prototype.componentWillMount = function componentWillMount() {
    var loadCaptcha = this.props.loadCaptcha;

    loadCaptcha();
  };

  Captcha.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var captchaState = nextProps.captchaState;

    if (captchaState !== this.props.captchaState) {
      this.setState({ captchaState: captchaState });
    }
  };

  Captcha.prototype.render = function render() {
    var loadCaptcha = this.props.loadCaptcha;
    var captchaState = this.state.captchaState;
    var _captchaState$data = captchaState.data;
    _captchaState$data = _captchaState$data === undefined ? {} : _captchaState$data;
    var src = _captchaState$data.src,
        _captchaState$status = captchaState.status,
        status = _captchaState$status === undefined ? '' : _captchaState$status;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.captcha },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_loracoms_ShowIf__["a" /* default */],
        { "if": status === 'pending' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" })
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_loracoms_ShowIf__["a" /* default */],
        { "if": status === 'success' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_router__["f" /* Link */],
          { onClick: loadCaptcha },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { alt: "", src: src })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_loracoms_ShowIf__["a" /* default */],
        { "if": status === 'failure' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_router__["f" /* Link */],
          { onClick: loadCaptcha },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle" }),
          ' ',
          this.intlMsg.msg('loadfailed')
        )
      )
    );
  };

  return Captcha;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Captcha.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    captchaState: state.register.captcha
  };
};
var mapDispatchToProps = {
  loadCaptcha: __WEBPACK_IMPORTED_MODULE_7_loraactions_register__["a" /* default */].captcha
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(Captcha)));

/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_zxcvbn__ = __webpack_require__(2849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_zxcvbn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_zxcvbn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_main_scss__ = __webpack_require__(2318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_main_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







var propTypes = {
  password: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired
};

var PwdStrengthMeter = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PwdStrengthMeter, _React$Component);

  PwdStrengthMeter.computeStrength = function computeStrength(password) {
    if (!password || password.length === 0) {
      return 0;
    }

    var result = __WEBPACK_IMPORTED_MODULE_6_zxcvbn___default()(password);
    var score = result.score;
    if (score === 0 || score === 1) {
      return 1;
    } else if (score === 2 || score === 3) {
      return 2;
    }
    return 3;
  };

  function PwdStrengthMeter(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PwdStrengthMeter);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      strength: PwdStrengthMeter.computeStrength(_this.props.password)
    };
    return _this;
  }

  PwdStrengthMeter.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var password = _ref.password;

    this.setState({
      strength: PwdStrengthMeter.computeStrength(password)
    });
  };

  PwdStrengthMeter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { styleName: "psm" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
        styleName: "psm-block psm-weak " + (this.state.strength >= 1 ? 'active' : '')
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
        styleName: "psm-block psm-medium " + (this.state.strength >= 2 ? 'active' : '')
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
        styleName: "psm-block psm-strong " + (this.state.strength >= 3 ? 'active' : '')
      })
    );
  };

  return PwdStrengthMeter;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

PwdStrengthMeter.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5_react_css_modules___default()(PwdStrengthMeter, __WEBPACK_IMPORTED_MODULE_7__styles_main_scss___default.a, { allowMultiple: true }));

/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_split__ = __webpack_require__(2512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_check_svg__ = __webpack_require__(2803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_check_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_clock_svg__ = __webpack_require__(2804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_clock_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_clock_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss__ = __webpack_require__(2319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__emaillinks_json__ = __webpack_require__(2392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__emaillinks_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__emaillinks_json__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.any.isRequired,
  status: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired,
  email: __WEBPACK_IMPORTED_MODULE_3_react___default.a.PropTypes.string.isRequired
};

var RegisterResult = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(RegisterResult, _React$Component);

  function RegisterResult(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RegisterResult);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      status: props.status,
      email: props.email
    };
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_9_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'register.result');
    _this.gotoEmailLogin = _this.gotoEmailLogin.bind(_this);
    return _this;
  }

  RegisterResult.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var status = nextProps.status,
        email = nextProps.email;

    if (status !== this.props.status) {
      this.setState({ status: status });
    }
    if (email !== this.props.email) {
      this.setState({ email: email });
    }
  };

  RegisterResult.prototype.gotoEmailLogin = function gotoEmailLogin() {
    var links = __WEBPACK_IMPORTED_MODULE_13__emaillinks_json___default.a.links;
    var domain = __WEBPACK_IMPORTED_MODULE_5_lodash_split___default()(this.state.email, '@')[1];
    var matches = __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(links, function (lk) {
      return lk.domain === domain;
    });
    if (matches.length > 0) {
      window.open("http://" + matches[0].link);
    }
  };

  RegisterResult.prototype.render = function render() {
    var goBack = this.props.goBack;
    var _state = this.state,
        status = _state.status,
        email = _state.email;

    if (status === 'apply') {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.result },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.body },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "h1",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "span",
              { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.img },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { alt: "", src: __WEBPACK_IMPORTED_MODULE_11__images_clock_svg___default.a, className: "img-responsive" })
            ),
            this.intlMsg.msg('apply.title')
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "p",
            null,
            this.intlMsg.msg('apply.desc')
          )
        )
      );
    }

    // accepted
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.result },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.body },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h1",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "span",
            { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.img },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { alt: "", src: __WEBPACK_IMPORTED_MODULE_10__images_check_svg___default.a, className: "img-responsive" })
          ),
          this.intlMsg.msg('accepted.laststep')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "p",
          null,
          this.intlMsg.msg('accepted.mailsent.p1'),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
            { onClick: this.gotoEmailLogin },
            email
          ),
          this.intlMsg.msg('accepted.mailsent.p2')
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Button"],
          { bsStyle: "aisz-primary", onClick: this.gotoEmailLogin },
          this.intlMsg.msg('accepted.gotoemail'),
          ' ',
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-external-link" })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.footer },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "h3",
          null,
          " ",
          this.intlMsg.msg('accepted.notreceive'),
          " "
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "ul",
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            this.intlMsg.msg('accepted.notreceive.tips1')
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "li",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* Link */],
              { onClick: goBack },
              this.intlMsg.msg('accepted.notreceive.tips2.click')
            ),
            this.intlMsg.msg('accepted.notreceive.tips2.p1')
          )
        )
      )
    );
  };

  return RegisterResult;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

RegisterResult.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(RegisterResult));

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aisztheme__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loraactions_register__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lorautils_errors_ErrorSet__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_loracoms_Checkbox__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_loracoms_RichButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_loracoms_ShowIf__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_loracoms_FormBlock__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__coms_RegisterResult__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__coms_PwdStrengthMeter__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__coms_Captcha__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_scss__ = __webpack_require__(2320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__styles_scss__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);






















var kLabelCols = 3;
var kControlCols = 6;
var kExtraCols = 3;
var kEmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.any.isRequired,
  loadCaptcha: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  captchaState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  checkEmail: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired,
  emailState: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.object.isRequired,
  resetCheckEmail: __WEBPACK_IMPORTED_MODULE_4_react___default.a.PropTypes.func.isRequired
};

var Register = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Register, _React$Component);

  function Register(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Register);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      registerOk: false,
      errors: __WEBPACK_IMPORTED_MODULE_12_lorautils_errors_ErrorSet__["a" /* default */].createEmpty().add('FE_EMPTY', 'email').add('FE_EMPTY', 'password').add('FE_EMPTY', 'name').add('FE_EMPTY', 'tel').add('FE_EMPTY', 'company').add('FE_EMPTY', 'captcha'),
      captchaState: props.captchaState,
      emailState: props.emailState
    };
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleChangeEmail = _this.handleChangeEmail.bind(_this);
    _this.handleCheckEmail = _this.handleCheckEmail.bind(_this);
    _this.handleChangePassword = _this.handleChangePassword.bind(_this);
    _this.handleChangeName = _this.handleChangeName.bind(_this);
    _this.handleChangeTel = _this.handleChangeTel.bind(_this);
    _this.handleChangeCompany = _this.handleChangeCompany.bind(_this);
    _this.handleChangeVerifyCode = _this.handleChangeVerifyCode.bind(_this);
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'register');
    return _this;
  }

  Register.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var captchaState = nextProps.captchaState,
        emailState = nextProps.emailState;

    if (captchaState !== this.props.captchaState) {
      this.setState({ captchaState: captchaState });
    }
    if (emailState !== this.props.emailState) {
      this.setState({ emailState: emailState });
    }
  };

  Register.prototype.componentWillUnmount = function componentWillUnmount() {
    var resetCheckEmail = this.props.resetCheckEmail;

    resetCheckEmail();
  };

  Register.prototype.handleChangeEmail = function handleChangeEmail(e) {
    var email = e.target.value;
    this.setState({ email: email });

    var errors = this.state.errors;

    if (email.trim() === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'email') });
    } else if (!kEmailRegex.test(email)) {
      this.setState({ errors: errors.add('FE_INVALIDEMAIL', 'email') });
    } else {
      this.setState({ errors: errors.remove('email') });
    }
  };

  Register.prototype.handleCheckEmail = function handleCheckEmail() {
    var checkEmail = this.props.checkEmail;
    var _state = this.state,
        errors = _state.errors,
        email = _state.email;

    if (!errors.has('email')) {
      checkEmail(email);
    }
  };

  Register.prototype.handleChangePassword = function handleChangePassword(e) {
    var password = e.target.value;
    this.setState({ password: password });

    var errors = this.state.errors;

    if (password.trim() === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'password') });
    } else if (password.length < 6 || password.length > 16) {
      this.setState({ errors: errors.add('FE_PASSWORDINVALIDLEN', 'password') });
    } else {
      this.setState({ errors: errors.remove('password') });
    }
  };

  Register.prototype.handleChangeName = function handleChangeName(e) {
    var name = e.target.value;
    this.setState({ name: name });

    var errors = this.state.errors;

    if (name.trim() === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'name') });
    } else {
      this.setState({ errors: errors.remove('name') });
    }
  };

  Register.prototype.handleChangeTel = function handleChangeTel(e) {
    var tel = e.target.value;
    this.setState({ tel: tel });

    var errors = this.state.errors;

    if (tel.trim() === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'tel') });
    } else {
      this.setState({ errors: errors.remove('tel') });
    }
  };

  Register.prototype.handleChangeCompany = function handleChangeCompany(e) {
    var company = e.target.value;
    this.setState({ company: company });

    var errors = this.state.errors;

    if (company.trim() === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'company') });
    } else {
      this.setState({ errors: errors.remove('company') });
    }
  };

  Register.prototype.handleChangeVerifyCode = function handleChangeVerifyCode(e) {
    var verifyCode = e.target.value;
    this.setState({ verifyCode: verifyCode });

    var errors = this.state.errors;

    if (verifyCode.trim() === '') {
      this.setSTate({ errors: errors.add('FE_EMPTY', 'captcha') });
    } else {
      this.setState({ errors: errors.remove('captcha') });
    }
  };

  Register.prototype.handleSubmit = function handleSubmit(e) {
    var _this2 = this;

    e.preventDefault();

    this.setState({ submitted: true });

    var errors = this.state.errors;

    errors = errors.remove('submit');
    if (!errors.isEmpty()) {
      return;
    }

    var loadCaptcha = this.props.loadCaptcha;
    var _state2 = this.state,
        _state2$captchaState$ = _state2.captchaState.data;
    _state2$captchaState$ = _state2$captchaState$ === undefined ? {} : _state2$captchaState$;
    var key = _state2$captchaState$.key,
        email = _state2.email,
        password = _state2.password,
        name = _state2.name,
        tel = _state2.tel,
        company = _state2.company,
        verifyCode = _state2.verifyCode;


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lorautils_api__["a" /* callAPI */])({
      endpoint: '/account/regist',
      method: 'POST',
      body: {
        key: key,
        email: email,
        password: password,
        name: name,
        tel: tel,
        company: company,
        verifyCode: verifyCode,
        ref: 'lora'
      }
    }).then(function (resp) {
      _this2.setState({
        registerStatus: resp.status
      });
      if (resp.status === 'apply' || resp.status === 'accepted') {
        _this2.setState({
          registerOk: true
        });
      }
    }).catch(function (error) {
      _this2.setState({
        errors: errors.add(error.code, 'submit')
      });
      if (error.code === 'BADVERIFY') {
        loadCaptcha();
      }
    });
  };

  Register.prototype.render = function render() {
    var _this3 = this;

    var _state3 = this.state,
        registerOk = _state3.registerOk,
        _state3$registerStatu = _state3.registerStatus,
        registerStatus = _state3$registerStatu === undefined ? '' : _state3$registerStatu,
        _state3$status = _state3.status,
        status = _state3$status === undefined ? '' : _state3$status,
        _state3$email = _state3.email,
        email = _state3$email === undefined ? '' : _state3$email,
        _state3$name = _state3.name,
        name = _state3$name === undefined ? '' : _state3$name,
        _state3$password = _state3.password,
        password = _state3$password === undefined ? '' : _state3$password,
        _state3$tel = _state3.tel,
        tel = _state3$tel === undefined ? '' : _state3$tel,
        _state3$company = _state3.company,
        company = _state3$company === undefined ? '' : _state3$company,
        _state3$verifyCode = _state3.verifyCode,
        verifyCode = _state3$verifyCode === undefined ? '' : _state3$verifyCode,
        _state3$agree = _state3.agree,
        agree = _state3$agree === undefined ? false : _state3$agree,
        errors = _state3.errors,
        _state3$submitted = _state3.submitted,
        submitted = _state3$submitted === undefined ? false : _state3$submitted,
        _state3$emailState = _state3.emailState,
        emailState = _state3$emailState === undefined ? {} : _state3$emailState;


    if (registerOk) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.register, style: { minHeight: window.innerHeight } },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__coms_RegisterResult__["a" /* default */], {
          status: registerStatus,
          email: email,
          goBack: function goBack() {
            return _this3.setState({ registerOk: false });
          }
        })
      );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      "div",
      { className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.register, style: { minHeight: window.innerHeight } },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.form },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          "h1",
          null,
          this.intlMsg.msg('title')
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Form"],
          { horizontal: true, onSubmit: this.handleSubmit },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
            { validationState: submitted && errors.has('email') ? 'error' : undefined },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: kLabelCols },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"],
                { className: "aisz-control-label" },
                this.intlMsg.msg('email')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: kControlCols },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormControl"], {
                bsClass: "aisz-form-control-f",
                type: "email",
                value: email,
                placeholder: this.intlMsg.msg('email.placeholder'),
                onChange: this.handleChangeEmail,
                onBlur: this.handleCheckEmail
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
                show: submitted && errors.has('email'),
                message: this.intlMsg.errorMsg(errors.get('email')),
                azStyle: "danger"
              })
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: kExtraCols, className: "collapse-left" },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16_loracoms_ShowIf__["a" /* default */],
                { "if": emailState.status === 'pending' },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.emailCheck },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-spinner fa-spin" })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16_loracoms_ShowIf__["a" /* default */],
                { "if": emailState.status === 'success' },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.emailCheck + " text-success" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-check-circle" })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16_loracoms_ShowIf__["a" /* default */],
                { "if": emailState.status === 'failure' },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  "span",
                  { className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.emailCheck + " text-danger" },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle" }),
                  ' ',
                  emailState.error && this.intlMsg.errorMsg(emailState.error.code)
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
            { validationState: submitted && errors.has('password') ? 'error' : undefined },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: kLabelCols },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"],
                { className: "aisz-control-label" },
                this.intlMsg.msg('password')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: kControlCols },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormControl"], {
                bsClass: "aisz-form-control-f",
                placeholder: this.intlMsg.msg('password.placeholder'),
                type: "password",
                value: password,
                onChange: this.handleChangePassword
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
                show: submitted && errors.has('password'),
                message: this.intlMsg.errorMsg(errors.get('password')),
                azStyle: "danger"
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__coms_PwdStrengthMeter__["a" /* default */], { password: password })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
            { validationState: submitted && errors.has('name') ? 'error' : undefined },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: kLabelCols },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"],
                { className: "aisz-control-label" },
                this.intlMsg.msg('name')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: kControlCols },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormControl"], {
                bsClass: "aisz-form-control-f",
                placeholder: this.intlMsg.msg('name.placeholder'),
                value: name,
                onChange: this.handleChangeName
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
                show: submitted && errors.has('name'),
                message: this.intlMsg.errorMsg(errors.get('name')),
                azStyle: "danger"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
            { validationState: submitted && errors.has('tel') ? 'error' : undefined },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: kLabelCols },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"],
                { className: "aisz-control-label" },
                this.intlMsg.msg('tele')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: kControlCols },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormControl"], {
                bsClass: "aisz-form-control-f",
                placeholder: this.intlMsg.msg('tele.placeholder'),
                value: tel,
                onChange: this.handleChangeTel
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
                show: submitted && errors.has('tel'),
                message: this.intlMsg.errorMsg(errors.get('tel')),
                azStyle: "danger"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
            { validationState: submitted && errors.has('company') ? 'error' : undefined },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: kLabelCols },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"],
                { className: "aisz-control-label" },
                this.intlMsg.msg('company')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: kControlCols },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormControl"], {
                bsClass: "aisz-form-control-f",
                placeholder: this.intlMsg.msg('company.placeholder'),
                value: company,
                onChange: this.handleChangeCompany
              }),
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_loracoms_ControlTips__["a" /* default */], {
                show: submitted && errors.has('company'),
                message: this.intlMsg.errorMsg(errors.get('company')),
                azStyle: "danger"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
            { validationState: submitted && errors.has('captcha') ? 'error' : undefined },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: kLabelCols },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["ControlLabel"],
                { className: "aisz-control-label" },
                this.intlMsg.msg('captcha')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: kControlCols },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Row"],
                null,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormControl"], {
                    bsClass: "aisz-form-control-f",
                    value: verifyCode,
                    onChange: this.handleChangeVerifyCode
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__coms_Captcha__["a" /* default */], null)
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: 9, mdOffset: 3 },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_loracoms_Checkbox__["a" /* default */], {
                id: "agree",
                checked: agree,
                onChange: function onChange() {
                  return _this3.setState({ agree: !agree });
                }
              }),
              ' ',
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                "span",
                { className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.agree },
                this.intlMsg.msg('agree'),
                ' ',
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_react_router__["f" /* Link */],
                  { onClick: function onClick() {
                      return window.open('/public/serviceAgreement');
                    } },
                  this.intlMsg.msg('policy')
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: kControlCols, mdOffset: kLabelCols, className: __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a.submit },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_loracoms_RichButton__["a" /* default */], {
                status: status,
                states: [{
                  status: 'default',
                  type: 'submit',
                  style: 'primary',
                  label: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-user-plus" }),
                    ' ',
                    this.intlMsg.msg('submit')
                  ),
                  disabled: !agree
                }, {
                  status: 'pending',
                  style: 'primary',
                  label: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-spin fa-spinner" }),
                    ' ',
                    this.intlMsg.msg('submit.pending')
                  )
                }, {
                  status: 'failure',
                  style: 'danger',
                  label: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    "span",
                    null,
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", { className: "fa fa-exclamation-triangle" }),
                    ' ',
                    this.intlMsg.msg('submit.failure')
                  )
                }]
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["FormGroup"],
            null,
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Col"],
              { md: kControlCols, mdOffset: kLabelCols },
              __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_loracoms_FormBlock__["a" /* default */], {
                show: errors.has('submit'),
                message: this.intlMsg.errorMsg(errors.get('submit')),
                azStyle: "danger"
              })
            )
          )
        )
      )
    );
  };

  return Register;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Register.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  return {
    captchaState: state.register.captcha,
    emailState: state.register.checkEmail
  };
};

var mapDispatchToProps = {
  loadCaptcha: __WEBPACK_IMPORTED_MODULE_10_loraactions_register__["a" /* default */].captcha,
  checkEmail: __WEBPACK_IMPORTED_MODULE_10_loraactions_register__["a" /* default */].checkEmail,
  resetCheckEmail: __WEBPACK_IMPORTED_MODULE_10_loraactions_register__["a" /* default */].resetCheckEmail
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"])(Register, __WEBPACK_IMPORTED_MODULE_21__styles_scss___default.a)));

/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Application__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Application_coms_ApplicationDetail__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Application_coms_ApplicationDetail_coms_DetailView__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Application_coms_ApplicationDetail_coms_LogView__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Application_coms_ApplicationDetail_coms_APIView__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Application_coms_ApplicationDetail_coms_ExportView__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Application_coms_ApplicationDetail_coms_BatchImport__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Application_coms_ApplicationDetail_coms_ParseView__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Application_coms_ApplicationDetail_coms_ParseView_coms_ParserDetail__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Application_coms_ApplicationDetail_coms_DataPointsView__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Application_coms_ApplicationDetail_coms_DataPointsView_coms_DataPointTrend__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Application_coms_ApplicationDetail_coms_APIView_coms_AppDebug__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Application_coms_ApplicationDetail_coms_FlowsView__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Application_coms_ApplicationDetail_coms_BroadcastView__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Application_coms_ApplicationDetail_coms_DashBoardView__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Application_coms_ApplicationDetail_coms_DashBoardView_coms_NewDashboard__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Application_coms_ApplicationDetail_coms_DashBoardView_coms_SingleDetail__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Application_coms_ApplicationDetail_coms_DashBoardView_coms_MultipleDetail__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Application_coms_ApplicationDetail_coms_DashBoardView_coms_ChartDetail__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Application_coms_ApplicationDetail_coms_FlowsView_coms_AddFlow__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__DeviceRoutes__ = __webpack_require__(1387);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

























var AppRoutes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */],
  { path: "application" },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* IndexRoute */], { component: __WEBPACK_IMPORTED_MODULE_2__Application__["a" /* default */] }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */],
    { path: ":id", component: __WEBPACK_IMPORTED_MODULE_3__Application_coms_ApplicationDetail__["a" /* default */] },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* IndexRoute */], { component: __WEBPACK_IMPORTED_MODULE_4__Application_coms_ApplicationDetail_coms_DetailView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "detail", component: __WEBPACK_IMPORTED_MODULE_4__Application_coms_ApplicationDetail_coms_DetailView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "log", component: __WEBPACK_IMPORTED_MODULE_5__Application_coms_ApplicationDetail_coms_LogView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "api", component: __WEBPACK_IMPORTED_MODULE_6__Application_coms_ApplicationDetail_coms_APIView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "export", component: __WEBPACK_IMPORTED_MODULE_7__Application_coms_ApplicationDetail_coms_ExportView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "batchimp", component: __WEBPACK_IMPORTED_MODULE_8__Application_coms_ApplicationDetail_coms_BatchImport__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "parse", component: __WEBPACK_IMPORTED_MODULE_9__Application_coms_ApplicationDetail_coms_ParseView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "parse/:parserId", component: __WEBPACK_IMPORTED_MODULE_10__Application_coms_ApplicationDetail_coms_ParseView_coms_ParserDetail__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "dps", component: __WEBPACK_IMPORTED_MODULE_11__Application_coms_ApplicationDetail_coms_DataPointsView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "dps/:dpId/trend", component: __WEBPACK_IMPORTED_MODULE_12__Application_coms_ApplicationDetail_coms_DataPointsView_coms_DataPointTrend__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "flows", component: __WEBPACK_IMPORTED_MODULE_14__Application_coms_ApplicationDetail_coms_FlowsView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "flows/add", component: __WEBPACK_IMPORTED_MODULE_21__Application_coms_ApplicationDetail_coms_FlowsView_coms_AddFlow__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "broadcast", component: __WEBPACK_IMPORTED_MODULE_15__Application_coms_ApplicationDetail_coms_BroadcastView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "dashboard", component: __WEBPACK_IMPORTED_MODULE_16__Application_coms_ApplicationDetail_coms_DashBoardView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "dashboard/add", component: __WEBPACK_IMPORTED_MODULE_17__Application_coms_ApplicationDetail_coms_DashBoardView_coms_NewDashboard__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "dashboard/basic/:dashid", component: __WEBPACK_IMPORTED_MODULE_18__Application_coms_ApplicationDetail_coms_DashBoardView_coms_SingleDetail__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "dashboard/map/:dashid", component: __WEBPACK_IMPORTED_MODULE_19__Application_coms_ApplicationDetail_coms_DashBoardView_coms_MultipleDetail__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "dashboard/:dashid/:dps", component: __WEBPACK_IMPORTED_MODULE_20__Application_coms_ApplicationDetail_coms_DashBoardView_coms_ChartDetail__["a" /* default */] })
  ),
  __WEBPACK_IMPORTED_MODULE_22__DeviceRoutes__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: ":id/debug", component: __WEBPACK_IMPORTED_MODULE_13__Application_coms_ApplicationDetail_coms_APIView_coms_AppDebug__["a" /* default */] })
);

/* harmony default export */ __webpack_exports__["a"] = (AppRoutes);

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Billing__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Billing_Balogs__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Billing_BillLogs__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Billing_BillDetail__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Billing_Recharge__ = __webpack_require__(1268);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);









var BillingRoutes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */],
  { path: "billing" },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* IndexRoute */], { component: __WEBPACK_IMPORTED_MODULE_2__Billing__["a" /* default */] }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "balogs", component: __WEBPACK_IMPORTED_MODULE_3__Billing_Balogs__["a" /* default */] }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "billlogs", component: __WEBPACK_IMPORTED_MODULE_4__Billing_BillLogs__["a" /* default */] }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "billdetail", component: __WEBPACK_IMPORTED_MODULE_5__Billing_BillDetail__["a" /* default */] }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "recharge", component: __WEBPACK_IMPORTED_MODULE_6__Billing_Recharge__["a" /* default */] }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "plans", component: __WEBPACK_IMPORTED_MODULE_2__Billing__["a" /* default */] })
);

/* harmony default export */ __webpack_exports__["a"] = (BillingRoutes);

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Application_coms_DeviceDetail__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Application_coms_DeviceDetail_coms_DetailView__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Application_coms_DeviceDetail_coms_StatView__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Application_coms_DeviceDetail_coms_DataToolView__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Application_coms_DeviceDetail_coms_MacView__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Application_coms_DeviceDetail_coms_LRAPView__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Application_coms_DeviceDetail_coms_TopoView__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Application_coms_DeviceDetail_coms_ADRView__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Application_coms_DeviceDetail_coms_DeviceLogs__ = __webpack_require__(1237);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var DeviceRoutes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */],
  { path: ":appId/devices/:deviceId", component: __WEBPACK_IMPORTED_MODULE_2__Application_coms_DeviceDetail__["a" /* default */] },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* IndexRoute */], { component: __WEBPACK_IMPORTED_MODULE_3__Application_coms_DeviceDetail_coms_DetailView__["a" /* default */] }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "stat", component: __WEBPACK_IMPORTED_MODULE_4__Application_coms_DeviceDetail_coms_StatView__["a" /* default */] }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "mac", component: __WEBPACK_IMPORTED_MODULE_6__Application_coms_DeviceDetail_coms_MacView__["a" /* default */] }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "lrap", component: __WEBPACK_IMPORTED_MODULE_7__Application_coms_DeviceDetail_coms_LRAPView__["a" /* default */] }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "adr", component: __WEBPACK_IMPORTED_MODULE_9__Application_coms_DeviceDetail_coms_ADRView__["a" /* default */] }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "datatool", component: __WEBPACK_IMPORTED_MODULE_5__Application_coms_DeviceDetail_coms_DataToolView__["a" /* default */] }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "topo", component: __WEBPACK_IMPORTED_MODULE_8__Application_coms_DeviceDetail_coms_TopoView__["a" /* default */] }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "logs", component: __WEBPACK_IMPORTED_MODULE_10__Application_coms_DeviceDetail_coms_DeviceLogs__["a" /* default */] })
);

/* harmony default export */ __webpack_exports__["a"] = (DeviceRoutes);

/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Gateway__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Gateway_coms_GatewayAdd__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Gateway_coms_GatewayDetail__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Gateway_coms_GatewayDetail_coms_DetailView__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Gateway_coms_GatewayDetail_coms_StatView__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Gateway_coms_GatewayDetail_coms_DataMsgView__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Gateway_coms_GatewayDetail_coms_LogView__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Gateway_coms_GatewayDetail_coms_ConfView__ = __webpack_require__(1277);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);












var GatewayRoutes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */],
  { path: "gateway" },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* IndexRoute */], { component: __WEBPACK_IMPORTED_MODULE_2__Gateway__["a" /* default */] }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "add", component: __WEBPACK_IMPORTED_MODULE_3__Gateway_coms_GatewayAdd__["a" /* default */] }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */],
    { path: "detail/:id", component: __WEBPACK_IMPORTED_MODULE_4__Gateway_coms_GatewayDetail__["a" /* default */] },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* IndexRoute */], { component: __WEBPACK_IMPORTED_MODULE_5__Gateway_coms_GatewayDetail_coms_DetailView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "stat", component: __WEBPACK_IMPORTED_MODULE_6__Gateway_coms_GatewayDetail_coms_StatView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "datamsg", component: __WEBPACK_IMPORTED_MODULE_7__Gateway_coms_GatewayDetail_coms_DataMsgView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "log", component: __WEBPACK_IMPORTED_MODULE_8__Gateway_coms_GatewayDetail_coms_LogView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "conf", component: __WEBPACK_IMPORTED_MODULE_9__Gateway_coms_GatewayDetail_coms_ConfView__["a" /* default */] })
  )
);

/* harmony default export */ __webpack_exports__["a"] = (GatewayRoutes);

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Login__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LostPassword__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__User_ResetPassword__ = __webpack_require__(1394);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







var LoginRoutes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */],
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "login", component: __WEBPACK_IMPORTED_MODULE_2__Login__["a" /* default */] }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "lostpassword", component: __WEBPACK_IMPORTED_MODULE_3__LostPassword__["a" /* default */] }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "password_reset/:token", component: __WEBPACK_IMPORTED_MODULE_4__User_ResetPassword__["a" /* default */] })
);

/* harmony default export */ __webpack_exports__["a"] = (LoginRoutes);

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loracfg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Network__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Network_coms_ADRView__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Network_coms_ChannelView__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Network_coms_ChannelView_coms_ChannelPlans__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Network_coms_ChannelView_coms_AddChannelPlan__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Network_coms_ChannelView_coms_ChannelPlanDetail__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Network_coms_GatewayView__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Network_coms_NodeView__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Network_coms_SignalCoverageView__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Network_coms_QualityView__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Network_coms_QualityView_coms_QualityDetail__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Network_coms_QualityView_coms_DeviceQualityView__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Network_coms_CapacityView__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Network_coms_CapacityCalculationView__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Network_coms_UnauthorizedPacketView__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Network_coms_RoadTestView__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Network_coms_TDMView__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Network_coms_TDMView_Detail__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Network_coms_TDMStatis__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Network_coms_TDMView_GatewayStatus__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Network_coms_TDMView_GatewayStatus_NodeList__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Network_coms_TDMView_NodeStatus__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Network_coms_TDMView_BatchNodes__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Network_coms_TDMView_BatchPairs__ = __webpack_require__(1341);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





























var routes = void 0;
if (__WEBPACK_IMPORTED_MODULE_2_loracfg__["a" /* default */].profile === 'cube') {
  routes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */],
    { path: "network", component: __WEBPACK_IMPORTED_MODULE_3__Network__["a" /* default */] },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* IndexRoute */], { component: __WEBPACK_IMPORTED_MODULE_4__Network_coms_ADRView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "adr", component: __WEBPACK_IMPORTED_MODULE_4__Network_coms_ADRView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */],
      { path: "chplans", component: __WEBPACK_IMPORTED_MODULE_5__Network_coms_ChannelView__["a" /* default */] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* IndexRoute */], { component: __WEBPACK_IMPORTED_MODULE_6__Network_coms_ChannelView_coms_ChannelPlans__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "add", component: __WEBPACK_IMPORTED_MODULE_7__Network_coms_ChannelView_coms_AddChannelPlan__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: ":id", component: __WEBPACK_IMPORTED_MODULE_8__Network_coms_ChannelView_coms_ChannelPlanDetail__["a" /* default */] })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */],
      { path: "tdm", component: __WEBPACK_IMPORTED_MODULE_19__Network_coms_TDMView__["a" /* default */] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* IndexRoute */], { component: __WEBPACK_IMPORTED_MODULE_20__Network_coms_TDMView_Detail__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "gateway/:id", component: __WEBPACK_IMPORTED_MODULE_22__Network_coms_TDMView_GatewayStatus__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "gateway/:id/:type", component: __WEBPACK_IMPORTED_MODULE_23__Network_coms_TDMView_GatewayStatus_NodeList__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "node/:id", component: __WEBPACK_IMPORTED_MODULE_24__Network_coms_TDMView_NodeStatus__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "batch/nodes", component: __WEBPACK_IMPORTED_MODULE_25__Network_coms_TDMView_BatchNodes__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "batch/pairs", component: __WEBPACK_IMPORTED_MODULE_26__Network_coms_TDMView_BatchPairs__["a" /* default */] })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "tdmstatis", component: __WEBPACK_IMPORTED_MODULE_21__Network_coms_TDMStatis__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "roadtest", component: __WEBPACK_IMPORTED_MODULE_18__Network_coms_RoadTestView__["a" /* default */] })
  );
} else {
  routes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */],
    { path: "network", component: __WEBPACK_IMPORTED_MODULE_3__Network__["a" /* default */] },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* IndexRoute */], { component: __WEBPACK_IMPORTED_MODULE_4__Network_coms_ADRView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "adr", component: __WEBPACK_IMPORTED_MODULE_4__Network_coms_ADRView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */],
      { path: "chplans", component: __WEBPACK_IMPORTED_MODULE_5__Network_coms_ChannelView__["a" /* default */] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* IndexRoute */], { component: __WEBPACK_IMPORTED_MODULE_6__Network_coms_ChannelView_coms_ChannelPlans__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "add", component: __WEBPACK_IMPORTED_MODULE_7__Network_coms_ChannelView_coms_AddChannelPlan__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: ":id", component: __WEBPACK_IMPORTED_MODULE_8__Network_coms_ChannelView_coms_ChannelPlanDetail__["a" /* default */] })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "gateway", component: __WEBPACK_IMPORTED_MODULE_9__Network_coms_GatewayView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "node", component: __WEBPACK_IMPORTED_MODULE_10__Network_coms_NodeView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "coverage", component: __WEBPACK_IMPORTED_MODULE_11__Network_coms_SignalCoverageView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */],
      { path: "quality", component: __WEBPACK_IMPORTED_MODULE_12__Network_coms_QualityView__["a" /* default */] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* IndexRoute */], { component: __WEBPACK_IMPORTED_MODULE_13__Network_coms_QualityView_coms_QualityDetail__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: ":id", component: __WEBPACK_IMPORTED_MODULE_14__Network_coms_QualityView_coms_DeviceQualityView__["a" /* default */] })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "unauthorized", component: __WEBPACK_IMPORTED_MODULE_17__Network_coms_UnauthorizedPacketView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "capacity", component: __WEBPACK_IMPORTED_MODULE_15__Network_coms_CapacityView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "capacitycalculation", component: __WEBPACK_IMPORTED_MODULE_16__Network_coms_CapacityCalculationView__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "roadtest", component: __WEBPACK_IMPORTED_MODULE_18__Network_coms_RoadTestView__["a" /* default */] })
  );
}

var NetworkRoutes = routes;

/* harmony default export */ __webpack_exports__["a"] = (NetworkRoutes);

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Register__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__User_RegistSuccess__ = __webpack_require__(1393);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);






var RegisterRoutes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */],
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "register", component: __WEBPACK_IMPORTED_MODULE_2__Register__["a" /* default */] }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "register_success", component: __WEBPACK_IMPORTED_MODULE_3__User_RegistSuccess__["a" /* default */] })
);

/* harmony default export */ __webpack_exports__["a"] = (RegisterRoutes);

/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loracfg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AuthLatch__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ExpireLatch__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ActivationLatch__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Overview__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Redirect__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NotFound__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AccountCenter__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AccountCenter_coms_InfoView__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AccountCenter_coms_ManageView__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AccountCenter_coms_SecurityView__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__GatewayRoutes__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AppRoutes__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__BillingRoutes__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__NetworkRoutes__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__RegisterRoutes__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__LoginRoutes__ = __webpack_require__(1389);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);






















var routes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */],
  { path: "/", component: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* IndexRoute */], { component: __WEBPACK_IMPORTED_MODULE_8__Redirect__["a" /* default */] }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */],
    { component: __WEBPACK_IMPORTED_MODULE_4__AuthLatch__["a" /* default */] },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */],
      { component: __WEBPACK_IMPORTED_MODULE_5__ExpireLatch__["a" /* default */] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* IndexRoute */], { component: __WEBPACK_IMPORTED_MODULE_7__Overview__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "overview", component: __WEBPACK_IMPORTED_MODULE_7__Overview__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_14__GatewayRoutes__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_15__AppRoutes__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_17__NetworkRoutes__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */],
        { path: "accountcenter", component: __WEBPACK_IMPORTED_MODULE_10__AccountCenter__["a" /* default */] },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* IndexRoute */], { component: __WEBPACK_IMPORTED_MODULE_11__AccountCenter_coms_InfoView__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "info", component: __WEBPACK_IMPORTED_MODULE_11__AccountCenter_coms_InfoView__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "security", component: __WEBPACK_IMPORTED_MODULE_13__AccountCenter_coms_SecurityView__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "token", component: __WEBPACK_IMPORTED_MODULE_12__AccountCenter_coms_ManageView__["a" /* default */] })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_16__BillingRoutes__["a" /* default */]
  ),
  __WEBPACK_IMPORTED_MODULE_19__LoginRoutes__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_18__RegisterRoutes__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "*", component: __WEBPACK_IMPORTED_MODULE_9__NotFound__["a" /* default */], status: 404 })
);

if (__WEBPACK_IMPORTED_MODULE_2_loracfg__["a" /* default */].profile === 'cube') {
  routes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */],
    { component: __WEBPACK_IMPORTED_MODULE_6__ActivationLatch__["a" /* default */] },
    routes
  );
}

var propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.any.isRequired
};

var Routes = function Routes(props) {
  var history = props.history;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Router */], { history: history, routes: routes });
};

Routes.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_main_scss__ = __webpack_require__(2321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_check_svg__ = __webpack_require__(2805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_check_svg__);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);










var RegistSuccess = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(RegistSuccess, _React$Component);

  function RegistSuccess(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RegistSuccess);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.gotoLogin = _this.gotoLogin.bind(_this);
    return _this;
  }

  RegistSuccess.prototype.intlMsg = function intlMsg(id, ns) {
    ns = ns || 'newRegisterSuccess';
    return this.props.intl.formatMessage({
      id: ns + "." + id,
      defaultMessage: ns + "." + id
    });
  };

  RegistSuccess.prototype.gotoLogin = function gotoLogin() {
    this.props.pushState('/login');
  };

  RegistSuccess.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { styleName: "wrapper" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { styleName: "regres" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { styleName: "regres-body" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            "h1",
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "span",
              { styleName: "regres-img" },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_10__images_check_svg___default.a, className: "img-responsive", alt: "" })
            ),
            this.intlMsg('h1')
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Button"],
            { bsStyle: "aisz-primary", onClick: this.gotoLogin },
            this.intlMsg('loginbtn'),
            ' ',
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-sign-in", "aria-hidden": "true" })
          )
        )
      )
    );
  };

  return RegistSuccess;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(function () {
  return {};
}, {
  pushState: __WEBPACK_IMPORTED_MODULE_8_react_router_redux__["routerActions"].push
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_9_react_css_modules___default()(RegistSuccess, __WEBPACK_IMPORTED_MODULE_6__styles_main_scss___default.a, { allowMultiple: true }))));;

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_loracoms_ActionButton__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_main_scss__ = __webpack_require__(2322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_ApiClient__ = __webpack_require__(1395);



/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_8_react_intl__["intlShape"].isRequired,
  pushState: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired
};

var ResetPassword = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ResetPassword, _React$Component);

  function ResetPassword(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ResetPassword);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.state = {
      submitStatus: 'ready',
      password: null,
      RPassword: null,
      errmsgNPwd: null,
      errmsgRPwd: null
    };
    _this.newPwd = null;
    _this.RepeatPwd = null;
    _this.intlMsg = new __WEBPACK_IMPORTED_MODULE_11_lorautils_intl_IntlMsg__["a" /* default */](props.intl, 'resetpassword');
    return _this;
  }

  ResetPassword.prototype.intlMsg = function intlMsg(id, ns) {
    var nss = ns || 'resetpassword.new';
    return this.props.intl.formatMessage({
      id: nss + "." + id,
      defaultMessage: nss + "." + id
    });
  };

  ResetPassword.prototype.handleSave = function handleSave() {
    var _this2 = this;

    var data = { password: this.state.password, RPassword: this.state.RPassword };
    var pwdStatus = false;
    var RPwdStatus = false;
    if (data.password === null) {
      pwdStatus = true;
    }
    if (data.RPassword === null) {
      RPwdStatus = true;
    }
    if (!pwdStatus && !RPwdStatus) {
      this.setState({
        submitStatus: 'loading'
      });
      __WEBPACK_IMPORTED_MODULE_13__helpers_ApiClient__["a" /* client */].post('/account/reset', {
        data: { token: this.props.params.token, password: data.password }
      }).then(function () {
        _this2.setState({ submitStatus: 'success' });
        window.setTimeout(function () {
          _this2.props.pushState('/login');
        }, 2000);
      }, function () {
        _this2.setState({
          submitStatus: 'failed'
        });
      });
    } else {
      this.setState({
        errmsgNPwd: pwdStatus ? this.renderErrorTips(this.intlMsg.msg('new.password.error.null')) : null,
        errmsgRPwd: RPwdStatus ? this.renderErrorTips(this.intlMsg.msg('new.password.error.null')) : null
      });
    }
  };

  ResetPassword.prototype.handleChangeNewPwd = function handleChangeNewPwd(value) {
    if (value === undefined || value === '') {
      this.newPwd = null;
      this.setState({
        valid: false,
        errmsgNPwd: this.renderErrorTips(this.intlMsg.msg('new.password.error.null')),
        password: null
      });
    } else {
      this.newPwd = value.toString();
      if (value.toString().length < 6 || value.toString().length > 16) {
        this.setState({
          valid: false,
          errmsgNPwd: this.renderErrorTips(this.intlMsg.msg('new.password.error.validerr')),
          password: null
        });
      } else {
        this.setState({
          valid: true,
          errmsgNPwd: null,
          password: value
        });
      }
      if (this.RepeatPwd !== null) {
        if (value === this.RepeatPwd) {
          this.setState({
            errmsgRPwd: null
          });
        } else {
          this.setState({
            errmsgRPwd: this.renderErrorTips(this.intlMsg.msg('new.password.error.Inconsistent'))
          });
        }
      }
    }
  };

  ResetPassword.prototype.handleChangeRepeatPwd = function handleChangeRepeatPwd(value) {
    if (value === undefined || value === '') {
      this.RepeatPwd = null;
      this.setState({
        valid: false,
        errmsgRPwd: this.renderErrorTips(this.intlMsg.msg('new.password.error.null')),
        RPassword: null
      });
    } else {
      this.RepeatPwd = value.toString();
      if (this.newPwd !== value) {
        this.setState({
          valid: false,
          errmsgRPwd: this.renderErrorTips(this.intlMsg.msg('new.password.error.Inconsistent')),
          RPassword: null
        });
      } else {
        this.setState({
          valid: true,
          RPassword: value,
          errmsgRPwd: null
        });
      }
    }
  };

  ResetPassword.prototype.renderErrorTips = function renderErrorTips(msg) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { styleName: "errortips-wrapper" },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        { styleName: "errortips" },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-exclamation-circle", "aria-hidden": "true" }),
        "\xA0",
        msg
      )
    );
  };

  ResetPassword.prototype.render = function render() {
    var _this3 = this;

    var _state = this.state,
        errmsgNPwd = _state.errmsgNPwd,
        errmsgRPwd = _state.errmsgRPwd;

    var status = false;
    if (errmsgNPwd !== null || errmsgRPwd !== null) {
      status = true;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "div",
      { styleName: "wrapper", style: { minHeight: window.innerHeight } },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "h1",
        null,
        this.intlMsg.msg('new.title.resetpwd')
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          "div",
          { styleName: "wrapper-form" },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Panel"],
            { bsStyle: "aisz-white" },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              "div",
              { styleName: "form-wrapper" },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Form"],
                { horizontal: true },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormGroup"],
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
                    { md: 3, componentClass: __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["ControlLabel"] },
                    this.intlMsg.msg('new.label.newpassword')
                  ),
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
                    { md: 6 },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormControl"], {
                      bsClass: "aisz-form-control-f",
                      type: "password",
                      required: true,
                      placeholder: this.intlMsg.msg('new.placeholder.newpassword'),
                      onChange: function onChange(e) {
                        return _this3.handleChangeNewPwd(e.target.value.trim());
                      }
                    }),
                    errmsgNPwd
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormGroup"],
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
                    { md: 3, componentClass: __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["ControlLabel"] },
                    this.intlMsg.msg('new.label.repeatpwd')
                  ),
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
                    { md: 6 },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormControl"], {
                      bsClass: "aisz-form-control-f",
                      type: "password",
                      required: true,
                      placeholder: this.intlMsg.msg('new.placeholder.repeatpwd'),
                      onChange: function onChange(e) {
                        return _this3.handleChangeRepeatPwd(e.target.value.trim());
                      }
                    }),
                    errmsgRPwd
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["FormGroup"],
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Col"],
                    { md: 6, mdOffset: 3 },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                      "span",
                      { styleName: "submit" },
                      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_loracoms_ActionButton__["a" /* default */], {
                        icon: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-sign-in", "aria-hidden": "true" }),
                        label: this.intlMsg.msg('new.button.label'),
                        successLabel: this.intlMsg.msg('new.button.successlabel'),
                        failedLabel: this.intlMsg.msg('new.resetfailed'),
                        status: this.state.submitStatus,
                        disabled: status,
                        onClick: function onClick() {
                          return _this3.handleSave();
                        },
                        onStatusReset: function onStatusReset() {
                          return _this3.setState({ submitStatus: 'ready' });
                        }
                      })
                    ),
                    "\xA0"
                  )
                )
              )
            )
          )
        )
      )
    );
  };

  return ResetPassword;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ResetPassword.propTypes = propTypes;

var mapDispatchToProps = {
  pushState: __WEBPACK_IMPORTED_MODULE_7_react_router_redux__["routerActions"].push
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(null, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"])(__WEBPACK_IMPORTED_MODULE_6_react_css_modules___default()(ResetPassword, __WEBPACK_IMPORTED_MODULE_12__styles_main_scss___default.a, { allowMultiple: true }))));

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return client; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(240);


/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);


var methods = ['get', 'post', 'put', 'patch', 'del'];
/*
 * This silly underscore is here to avoid a mysterious "ReferenceError: ApiClient is not defined" error.
 * See Issue #14. https://github.com/erikras/react-redux-universal-hot-example/issues/14
 *
 * Remove it at your own risk.
 */

var _ApiClient = function _ApiClient(req) {
  var _this = this;

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _ApiClient);

  methods.forEach(function (method) {
    return _this[method] = function (path) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          params = _ref.params,
          data = _ref.data;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */])(method, path, params, data, function (err, res) {
          if (err) {
            reject(err);
          } else {
            resolve(res.body);
          }
        });
      });
    };
  });
};

var ApiClient = _ApiClient;
var client = new ApiClient();

/* unused harmony default export */ var _unused_webpack_default_export = (ApiClient);

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

/* eslint-env browser */
var Cookies = __webpack_require__(850);

var cookie = {
  set: function set(_ref) {
    var name = _ref.name,
        _ref$value = _ref.value,
        value = _ref$value === undefined ? '' : _ref$value,
        _ref$path = _ref.path,
        path = _ref$path === undefined ? '/' : _ref$path,
        _ref$domain = _ref.domain,
        domain = _ref$domain === undefined ? '' : _ref$domain,
        _ref$expires = _ref.expires,
        expires = _ref$expires === undefined ? '' : _ref$expires;

    Cookies.set(name, value, { path: path, domain: domain, expires: expires });
  },
  unset: function unset(name) {
    Cookies.remove(name);
  },
  get: function get(name) {
    return Cookies.get(name);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (cookie);

/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_hot_loader__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redbox_react__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redbox_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redbox_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_IEUtils__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_store_configureStore__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_Root__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__polyfill__ = __webpack_require__(1127);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);













var history = __WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* browserHistory */];
var iev = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_IEUtils__["a" /* IEVer */])();
if (iev === 8 || iev === 9) {
  // fallback to hashHistory for old version IE
  history = __WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* hashHistory */];
}

var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__redux_store_configureStore__["a" /* default */])(history, {});
window._store = store;

history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__["syncHistoryWithStore"])(history, store);

var render = function render() {
  __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_hot_loader__["AppContainer"],
    { errorReporter: __WEBPACK_IMPORTED_MODULE_3_redbox_react___default.a },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__containers_Root__["a" /* default */], { history: history, store: store })
  ), document.getElementById('root'));
};

render();

if (false) {
  module.hot.accept('./containers/Root', function () {
    render();
  });
}

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lorautils_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lorautils_cookies_auth__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_api__ = __webpack_require__(53);


/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = (function (store) {
  return function (next) {
    return function (action) {
      var type = action.type,
          payload = action.payload,
          _action$meta = action.meta;
      _action$meta = _action$meta === undefined ? {} : _action$meta;

      var api = _action$meta.api,
          nextMeta = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_action$meta, ["api"]),
          rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(action, ["type", "payload", "meta"]);

      if (!api) {
        // no api
        return next(action);
      }
      if (!api.request && !api.reset) {
        // no request and not reset
        return next(action);
      }

      if (api.reset) {
        var _nextAPI = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, api, {
          reset: undefined,
          status: __WEBPACK_IMPORTED_MODULE_4__actions_api__["c" /* API_RESET */]
        });
        return next(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
          type: type,
          payload: payload,
          meta: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, nextMeta, { api: _nextAPI })
        }));
      }

      var request = api.request;
      var nextAPI = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, api, {
        request: undefined,
        status: __WEBPACK_IMPORTED_MODULE_4__actions_api__["d" /* API_PENDING */]
      });
      next(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
        type: type,
        payload: payload,
        meta: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, nextMeta, { api: nextAPI })
      }));

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lorautils_api__["a" /* callAPI */])(request).then(function (response) {
        api.status = __WEBPACK_IMPORTED_MODULE_4__actions_api__["e" /* API_SUCCESS */];
        api.response = response;
        next(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
          type: type,
          payload: payload,
          meta: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, nextMeta, { api: api })
        }));
      }, function (error) {
        if (error.code === 'BADTOKEN') {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lorautils_cookies_auth__["c" /* removeAuthCookies */])();
        }

        api.status = __WEBPACK_IMPORTED_MODULE_4__actions_api__["f" /* API_FAILURE */];
        api.error = error;
        next(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
          type: type,
          payload: payload,
          meta: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, nextMeta, { api: api })
        }));
      });
    };
  };
});

/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_account__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(81);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* combineAPIReducers */])(__WEBPACK_IMPORTED_MODULE_0__actions_account__["b" /* types */]));

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_adr__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(81);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* combineAPIReducers */])(__WEBPACK_IMPORTED_MODULE_0__actions_adr__["b" /* types */]));

/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_app__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(81);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* combineAPIReducers */])(__WEBPACK_IMPORTED_MODULE_0__actions_app__["b" /* types */]));

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lorautils_cookies_auth__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_api__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_auth__ = __webpack_require__(438);

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = (function (state, action) {
  var type = action.type;

  if (type === __WEBPACK_IMPORTED_MODULE_3__actions_auth__["b" /* types */].token) {
    /* Log in */
    var api = action.meta.api;

    switch (api.status) {
      case __WEBPACK_IMPORTED_MODULE_2__actions_api__["g" /* APIStatus */].API_PENDING:
        return {
          authed: false,
          status: 'pending'
        };
      case __WEBPACK_IMPORTED_MODULE_2__actions_api__["g" /* APIStatus */].API_SUCCESS:
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lorautils_cookies_auth__["d" /* setAuthCookies */])(api.response);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          authed: true
        }, api.response);
      case __WEBPACK_IMPORTED_MODULE_2__actions_api__["g" /* APIStatus */].API_FAILURE:
        return {
          authed: false,
          error: api.error
        };
      default:
        return { authed: false };
    }
  } else if (type === __WEBPACK_IMPORTED_MODULE_3__actions_auth__["b" /* types */].revoke) {
    /* Log out */
    var _api = action.meta.api;

    if (__WEBPACK_IMPORTED_MODULE_2__actions_api__["g" /* APIStatus */].complete(_api.status)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lorautils_cookies_auth__["c" /* removeAuthCookies */])();
      return { authed: false };
    }
    return { authed: false };
  } else {
    /* If any api invoke return BADTOKEN */
    var _action$meta = action.meta;
    _action$meta = _action$meta === undefined ? {} : _action$meta;
    var _action$meta$api = _action$meta.api;
    _action$meta$api = _action$meta$api === undefined ? {} : _action$meta$api;
    var _action$meta$api$erro = _action$meta$api.error;
    _action$meta$api$erro = _action$meta$api$erro === undefined ? {} : _action$meta$api$erro;
    var _action$meta$api$erro2 = _action$meta$api$erro.code,
        code = _action$meta$api$erro2 === undefined ? '' : _action$meta$api$erro2;

    if (code === 'BADTOKEN') {
      return { authed: false };
    }
    /* Check auth token */
    var auth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lorautils_cookies_auth__["a" /* getAuthCookies */])();
    if (auth) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ authed: true }, auth, { status: 'cookies' });
    }
    return { authed: false, status: 'idle' };
  }
});

/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_ceil__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_ceil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_ceil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_billing__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_api__ = __webpack_require__(53);

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







function planStateCreator(api) {
  var response = api.response,
      status = api.status,
      error = api.error;

  if (__WEBPACK_IMPORTED_MODULE_5__actions_api__["g" /* APIStatus */].success(status)) {
    var expired = !__WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default()(response.svcExpire) && response.svcExpire < 0.001;
    var remaining = __WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default()(response.svcExpire) ? 0 : __WEBPACK_IMPORTED_MODULE_2_lodash_ceil___default()(response.svcExpire);
    return {
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response, {
        expired: expired,
        remaining: remaining
      }),
      status: __WEBPACK_IMPORTED_MODULE_5__actions_api__["g" /* APIStatus */].name(status),
      error: error
    };
  }

  return {
    data: {},
    status: __WEBPACK_IMPORTED_MODULE_5__actions_api__["g" /* APIStatus */].name(status),
    error: error
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["b" /* combineAPIReducers */])(__WEBPACK_IMPORTED_MODULE_3__actions_billing__["b" /* types */], {
  plan: planStateCreator
}));

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_broadcast__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(81);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* combineAPIReducers */])(__WEBPACK_IMPORTED_MODULE_0__actions_broadcast__["b" /* types */]));

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_chplan__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(81);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* combineAPIReducers */])(__WEBPACK_IMPORTED_MODULE_0__actions_chplan__["b" /* types */]));

/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_sub_hours__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_sub_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_sub_hours__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_dashboard__ = __webpack_require__(138);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);






var defaultState = {
  from: __WEBPACK_IMPORTED_MODULE_1_date_fns_sub_hours___default()(new Date(), 1),
  to: new Date(),
  by: 'hour'
};

var getTimes = function getTimes() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  if (type === __WEBPACK_IMPORTED_MODULE_3__actions_dashboard__["b" /* types */].getTimes) {
    return payload;
  }
  return state;
};

var getDeveui = function getDeveui() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  if (type === __WEBPACK_IMPORTED_MODULE_3__actions_dashboard__["b" /* types */].getDeveui) {
    return payload;
  }
  return state;
};

var getDps = function getDps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  if (type === __WEBPACK_IMPORTED_MODULE_3__actions_dashboard__["b" /* types */].getDps) {
    return payload.join(',');
  }
  return state;
};

var getRefreshCount = function getRefreshCount() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  if (type === __WEBPACK_IMPORTED_MODULE_3__actions_dashboard__["b" /* types */].getRefreshCount) {
    return payload;
  }
  return state;
};

var getGpsColor = function getGpsColor() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  if (type === __WEBPACK_IMPORTED_MODULE_3__actions_dashboard__["b" /* types */].getGpsColor) {
    return payload;
  }
  return state;
};

var getDashboard = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* createAPIReducer */])(__WEBPACK_IMPORTED_MODULE_3__actions_dashboard__["b" /* types */].getDashboard);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* combineReducers */])({
  getTimes: getTimes,
  getDeveui: getDeveui,
  getDashboard: getDashboard,
  getDps: getDps,
  getRefreshCount: getRefreshCount,
  getGpsColor: getGpsColor
}));

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_datapoint__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(81);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* combineAPIReducers */])(__WEBPACK_IMPORTED_MODULE_0__actions_datapoint__["b" /* types */]));

/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_device__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(81);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* combineAPIReducers */])(__WEBPACK_IMPORTED_MODULE_0__actions_device__["b" /* types */]));

/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_enums__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(81);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* combineAPIReducers */])(__WEBPACK_IMPORTED_MODULE_0__actions_enums__["b" /* types */]));

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_flow__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(81);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* combineAPIReducers */])(__WEBPACK_IMPORTED_MODULE_0__actions_flow__["b" /* types */]));

/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_gateway__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(81);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* combineAPIReducers */])(__WEBPACK_IMPORTED_MODULE_0__actions_gateway__["b" /* types */]));

/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__account__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__adr__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__billing__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chplan__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__device__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__enums__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__flow__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__gateway__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loracube__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__org__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__parser__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__register__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__sidebar__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__token__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__usage__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__datapoint__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__dashboard__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mark__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__broadcast__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__roadtest__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__tdm__ = __webpack_require__(1420);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

























/* harmony default export */ __webpack_exports__["a"] = ({
  account: __WEBPACK_IMPORTED_MODULE_0__account__["a" /* default */],
  adr: __WEBPACK_IMPORTED_MODULE_1__adr__["a" /* default */],
  app: __WEBPACK_IMPORTED_MODULE_2__app__["a" /* default */],
  auth: __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */],
  billing: __WEBPACK_IMPORTED_MODULE_4__billing__["a" /* default */],
  chplan: __WEBPACK_IMPORTED_MODULE_5__chplan__["a" /* default */],
  device: __WEBPACK_IMPORTED_MODULE_6__device__["a" /* default */],
  enums: __WEBPACK_IMPORTED_MODULE_7__enums__["a" /* default */],
  flow: __WEBPACK_IMPORTED_MODULE_8__flow__["a" /* default */],
  gateway: __WEBPACK_IMPORTED_MODULE_9__gateway__["a" /* default */],
  loracube: __WEBPACK_IMPORTED_MODULE_10__loracube__["a" /* default */],
  org: __WEBPACK_IMPORTED_MODULE_11__org__["a" /* default */],
  parser: __WEBPACK_IMPORTED_MODULE_12__parser__["a" /* default */],
  register: __WEBPACK_IMPORTED_MODULE_13__register__["a" /* default */],
  sidebar: __WEBPACK_IMPORTED_MODULE_14__sidebar__["a" /* default */],
  token: __WEBPACK_IMPORTED_MODULE_15__token__["a" /* default */],
  usage: __WEBPACK_IMPORTED_MODULE_16__usage__["a" /* default */],
  datapoint: __WEBPACK_IMPORTED_MODULE_17__datapoint__["a" /* default */],
  dashboard: __WEBPACK_IMPORTED_MODULE_18__dashboard__["a" /* default */],
  mark: __WEBPACK_IMPORTED_MODULE_19__mark__["a" /* default */],
  broadcast: __WEBPACK_IMPORTED_MODULE_20__broadcast__["a" /* default */],
  roadtest: __WEBPACK_IMPORTED_MODULE_21__roadtest__["a" /* default */],
  tdm: __WEBPACK_IMPORTED_MODULE_22__tdm__["a" /* default */]
});

/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_loracube__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(81);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* combineAPIReducers */])(__WEBPACK_IMPORTED_MODULE_0__actions_loracube__["b" /* types */]));

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_mark__ = __webpack_require__(638);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



var defaultState = {
  mark: { from: null, to: null }
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  if (type === __WEBPACK_IMPORTED_MODULE_0__actions_mark__["b" /* types */].handleMark) {
    return {
      mark: payload
    };
  }
  return state;
});

/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_org__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(81);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* combineAPIReducers */])(__WEBPACK_IMPORTED_MODULE_0__actions_org__["b" /* types */]));

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_parser__ = __webpack_require__(203);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var getParserCode = function getParserCode() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  if (type === __WEBPACK_IMPORTED_MODULE_2__actions_parser__["d" /* types */].getParserCode) {
    return payload;
  }
  return state;
};

var getDebugResult = function getDebugResult() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  if (type === __WEBPACK_IMPORTED_MODULE_2__actions_parser__["d" /* types */].getDebugResult) {
    return payload;
  }
  return state;
};

var getParsers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* createAPIReducer */])(__WEBPACK_IMPORTED_MODULE_2__actions_parser__["d" /* types */].getParsers);
var getParser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* createAPIReducer */])(__WEBPACK_IMPORTED_MODULE_2__actions_parser__["d" /* types */].getParser);
var deleteParser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* createAPIReducer */])(__WEBPACK_IMPORTED_MODULE_2__actions_parser__["d" /* types */].deleteParser);
var addParser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* createAPIReducer */])(__WEBPACK_IMPORTED_MODULE_2__actions_parser__["d" /* types */].addParser);
var countParsers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* createAPIReducer */])(__WEBPACK_IMPORTED_MODULE_2__actions_parser__["d" /* types */].countParsers);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* combineReducers */])({
  getParserCode: getParserCode,
  getParsers: getParsers,
  getParser: getParser,
  deleteParser: deleteParser,
  addParser: addParser,
  countParsers: countParsers,
  getDebugResult: getDebugResult
}));

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_api__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_register__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(81);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





function checkEmailStateCreator(api) {
  var response = api.response,
      status = api.status;


  if (!__WEBPACK_IMPORTED_MODULE_0__actions_api__["g" /* APIStatus */].complete(status)) {
    return {
      status: 'pending'
    };
  }
  if (status === __WEBPACK_IMPORTED_MODULE_0__actions_api__["g" /* APIStatus */].API_FAILURE) {
    return {
      status: 'failure',
      error: {
        code: 'FE_NETWORKFAIL',
        message: 'network failed'
      }
    };
  }
  if (response.available) {
    return {
      status: 'success'
    };
  }
  return {
    status: 'failure',
    error: {
      code: 'FE_EMAILOCCUPIED',
      message: 'email occupied'
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* combineAPIReducers */])(__WEBPACK_IMPORTED_MODULE_1__actions_register__["b" /* types */], {
  checkEmail: checkEmailStateCreator
}));

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_add_hours__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_add_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_add_hours__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_set_minutes__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_set_minutes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_set_minutes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_roadtest__ = __webpack_require__(339);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);






var defaultState = {
  from: __WEBPACK_IMPORTED_MODULE_2_date_fns_set_minutes___default()(new Date(), 0),
  to: __WEBPACK_IMPORTED_MODULE_2_date_fns_set_minutes___default()(__WEBPACK_IMPORTED_MODULE_1_date_fns_add_hours___default()(new Date(), 1), 0),
  by: 'hour'
};

var defaultColor = {
  green: { min: '0', max: '30' },
  yellow: { min: '-5', max: '0' },
  red: { min: '-10', max: '-5' },
  type: 'snr'
};

var getTimes = function getTimes() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  if (type === __WEBPACK_IMPORTED_MODULE_3__actions_roadtest__["b" /* types */].getTimes) {
    return payload;
  }
  return state;
};

var getDevice = function getDevice() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  if (type === __WEBPACK_IMPORTED_MODULE_3__actions_roadtest__["b" /* types */].getDevice) {
    return payload;
  }
  return state;
};

var getGateway = function getGateway() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  if (type === __WEBPACK_IMPORTED_MODULE_3__actions_roadtest__["b" /* types */].getGateway) {
    return payload;
  }
  return state;
};

var getGpsColor = function getGpsColor() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultColor;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  if (type === __WEBPACK_IMPORTED_MODULE_3__actions_roadtest__["b" /* types */].getGpsColor) {
    return payload;
  }
  return state;
};

var getRadius = function getRadius() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  if (type === __WEBPACK_IMPORTED_MODULE_3__actions_roadtest__["b" /* types */].getRadius) {
    return payload;
  }
  return state;
};

var updateGps = function updateGps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  if (type === __WEBPACK_IMPORTED_MODULE_3__actions_roadtest__["b" /* types */].updateGps) {
    return payload;
  }
  return state;
};

var startDwnld = function startDwnld() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  if (type === __WEBPACK_IMPORTED_MODULE_3__actions_roadtest__["b" /* types */].startDwnld) {
    return payload;
  }
  return state;
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* combineReducers */])({
  getTimes: getTimes,
  getDevice: getDevice,
  getGateway: getGateway,
  getGpsColor: getGpsColor,
  getRadius: getRadius,
  updateGps: updateGps,
  startDwnld: startDwnld
}));

/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_sidebar__ = __webpack_require__(639);

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



var kLocalStorageKey = 'sidebar.collapsed';

function getInitialCollapsed() {
  if (localStorage.getItem(kLocalStorageKey) === 'false') {
    return false;
  }
  return true;
}

var defaultState = {
  collapsed: getInitialCollapsed()
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments[1];
  var type = action.type;

  if (type === __WEBPACK_IMPORTED_MODULE_1__actions_sidebar__["b" /* types */].toggleSidebar) {
    var _state$collapsed = state.collapsed,
        collapsed = _state$collapsed === undefined ? true : _state$collapsed;

    collapsed = !collapsed;
    localStorage.setItem(kLocalStorageKey, String(collapsed));
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state, {
      collapsed: collapsed
    });
  }
  return state;
});

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_tdm__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(81);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var updateNodes = function updateNodes() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  if (type === __WEBPACK_IMPORTED_MODULE_1__actions_tdm__["e" /* types */].updateNodes) {
    return payload;
  }
  return state;
};
var updateTdmGateways = function updateTdmGateways() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  if (type === __WEBPACK_IMPORTED_MODULE_1__actions_tdm__["e" /* types */].updateTdmGateways) {
    return payload;
  }
  return state;
};

var getNetwork = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* createAPIReducer */])(__WEBPACK_IMPORTED_MODULE_1__actions_tdm__["e" /* types */].getNetwork);
var setting = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* createAPIReducer */])(__WEBPACK_IMPORTED_MODULE_1__actions_tdm__["e" /* types */].setting);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* combineReducers */])({
  setting: setting,
  getNetwork: getNetwork,
  updateNodes: updateNodes,
  updateTdmGateways: updateTdmGateways
}));

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_token__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(81);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* combineAPIReducers */])(__WEBPACK_IMPORTED_MODULE_0__actions_token__["b" /* types */]));

/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_union__ = __webpack_require__(2519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_union___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_union__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loraactions_api__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_loraactions_usage__ = __webpack_require__(155);



var _typeKeys;

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);






var typeKeys = (_typeKeys = {}, _typeKeys[__WEBPACK_IMPORTED_MODULE_5_loraactions_usage__["b" /* types */].apps] = 'apps', _typeKeys[__WEBPACK_IMPORTED_MODULE_5_loraactions_usage__["b" /* types */].gateways] = 'gateways', _typeKeys[__WEBPACK_IMPORTED_MODULE_5_loraactions_usage__["b" /* types */].nodes] = 'nodes', _typeKeys);

// state schema:
// {
//   apps?: number,
//   gateways?: number,
//   nodes?: number,
//   pendings: ['apps' | 'gateways' | 'nodes' ...]
//   errors: {
//     apps?: error,
//     gateways?: error,
//     nodes?: error,
//   }
// }
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var type = action.type,
      _action$meta = action.meta;
  _action$meta = _action$meta === undefined ? {} : _action$meta;
  var api = _action$meta.api;

  var key = typeKeys[type];

  if (__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(key)) {
    return state;
  }

  if (!api) {
    return state;
  }

  if (api.status === __WEBPACK_IMPORTED_MODULE_4_loraactions_api__["e" /* API_SUCCESS */]) {
    var _extends2;

    var _state$pendings = state.pendings,
        pendings = _state$pendings === undefined ? [] : _state$pendings,
        rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(state, ["pendings"]);

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, (_extends2 = {}, _extends2[key] = api.response.count, _extends2.pendings = pendings.filter(function (k) {
      return k !== key;
    }), _extends2));
  } else if (api.status === __WEBPACK_IMPORTED_MODULE_4_loraactions_api__["d" /* API_PENDING */]) {
    var _state$pendings2 = state.pendings,
        _pendings = _state$pendings2 === undefined ? [] : _state$pendings2,
        _rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(state, ["pendings"]);

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _rest, {
      pendings: __WEBPACK_IMPORTED_MODULE_2_lodash_union___default()(_pendings, [key])
    });
  } else if (api.status === __WEBPACK_IMPORTED_MODULE_4_loraactions_api__["f" /* API_FAILURE */]) {
    var _state$errors = state.errors,
        errors = _state$errors === undefined ? {} : _state$errors,
        _rest2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(state, ["errors"]);

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _rest2, {
      errors: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, errors, { key: api.error })
    });
  }
  return state;
});

/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lorautils_cookies_auth__ = __webpack_require__(181);

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = (function () {
  var authState = { authed: false, status: 'idle' };
  var auth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lorautils_cookies_auth__["a" /* getAuthCookies */])();
  if (auth) {
    authState = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ authed: true }, auth, { status: 'cookies' });
  }
  return authState;
});

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en__ = __webpack_require__(2671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_zh__ = __webpack_require__(2672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_zh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_zh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lorai18n__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loracfg__ = __webpack_require__(65);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);







__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["addLocaleData"])(__WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en___default.a);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["addLocaleData"])(__WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_zh___default.a);

function chooseLocale() {
  if (__WEBPACK_IMPORTED_MODULE_4_loracfg__["a" /* default */].language) {
    return __WEBPACK_IMPORTED_MODULE_4_loracfg__["a" /* default */].language;
  }

  if (localStorage.getItem('language')) {
    switch (localStorage.getItem('language')) {
      case 'en':
        return 'en';
      case 'zh':
        return 'zh';
      default:
        return 'zh';
    }
  }

  switch (navigator.language.split('-')[0]) {
    case 'en':
      return 'en';
    case 'zh':
      return 'zh';
    default:
      return 'zh';
  }
}

var locale = chooseLocale();

// initial intl state
/* harmony default export */ __webpack_exports__["a"] = ({
  locale: locale,
  messages: __WEBPACK_IMPORTED_MODULE_3_lorai18n__["a" /* default */][locale]
});

/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseAPIError;
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

var wellDefinedErrors = ['BADPASSWORD', 'BADACCOUNT', 'ACCINACTIVE', 'BADTOKEN'];

function parseAPIError(error) {
  // well-defined errors
  var code = error._code || error.error;
  var message = error._message || error.message;
  var defined = wellDefinedErrors.filter(function (c) {
    return c === code;
  });
  if (defined.length > 0) {
    return {
      code: defined[0],
      message: message,
      origin: error
    };
  }

  // ill-defined errors, need some tweaks :p
  switch (code) {
    case 'TypeError':
      if (message === 'Failed to fetch') {
        return {
          code: 'FETCHFAILED',
          message: message,
          origin: error
        };
      }
      break;
    default:
      break;
  }
  return {
    code: code || 'UNKNOWN',
    message: message,
    origin: error
  };
}

/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setCookies;
/* harmony export (immutable) */ __webpack_exports__["c"] = getCookies;
/* harmony export (immutable) */ __webpack_exports__["b"] = getCookiesJSON;
/* harmony export (immutable) */ __webpack_exports__["d"] = removeCookies;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loracfg__ = __webpack_require__(65);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);




var _config$cookiesPrefix = __WEBPACK_IMPORTED_MODULE_1_loracfg__["a" /* default */].cookiesPrefix,
    prefix = _config$cookiesPrefix === undefined ? '' : _config$cookiesPrefix;


function key(name) {
  return "" + prefix + name;
}

function setCookies(name, value, options) {
  __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(key(name), value, options);
}

function getCookies(name) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(key(name));
}

function getCookiesJSON(name) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.getJSON(key(name));
}

function removeCookies(name) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(key(name));
}

/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__intlmap_json__ = __webpack_require__(2395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__intlmap_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__intlmap_json__);

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);





var ErrorIntl = function () {
  function ErrorIntl(intl, context) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ErrorIntl);

    this.intl = intl;
    this.context = context;
  }

  ErrorIntl.prototype.msgId = function msgId(error) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;

    if (!error) {
      return null;
    }

    var code = void 0;

    if (__WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(error)) {
      code = error;
    } else if (__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"].isMap(error)) {
      code = error.get('code');
    } else {
      code = error.code;
    }
    if (!code) {
      return null;
    }

    var key = void 0;
    if (context !== '') {
      key = context + ".E." + code;
    } else {
      key = "E." + code;
    }
    if (__WEBPACK_IMPORTED_MODULE_3__intlmap_json___default.a[key]) {
      return __WEBPACK_IMPORTED_MODULE_3__intlmap_json___default.a[key];
    }
    return key;
  };

  ErrorIntl.prototype.msg = function msg(error) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;

    var id = this.msgId(error, context);
    if (!id) {
      return null;
    }

    return this.intl.formatMessage({
      id: id,
      defaultMessage: id
    });
  };

  return ErrorIntl;
}();

/* harmony default export */ __webpack_exports__["a"] = (ErrorIntl);

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isConnected; });
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);
var $ = __webpack_require__(0);

var isConnected = function isConnected(lastOn, lastOff) {
  if (_.isNil(lastOn)) {
    return false;
  }
  if (_.isNil(lastOff)) {
    return true;
  }
  var onts = new Date(lastOn).valueOf();
  var offts = new Date(lastOff).valueOf();
  if (onts > offts) {
    return true;
  }
  return false;
};

/* unused harmony default export */ var _unused_webpack_default_export = ({
  isConnected: isConnected
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(2740)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('select'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.select);
        global.clipboardAction = mod.exports;
    }
})(this, function (module, _select) {
    'use strict';

    var _select2 = _interopRequireDefault(_select);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var ClipboardAction = function () {
        /**
         * @param {Object} options
         */
        function ClipboardAction(options) {
            _classCallCheck(this, ClipboardAction);

            this.resolveOptions(options);
            this.initSelection();
        }

        /**
         * Defines base properties passed from constructor.
         * @param {Object} options
         */


        _createClass(ClipboardAction, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = options.action;
                this.container = options.container;
                this.emitter = options.emitter;
                this.target = options.target;
                this.text = options.text;
                this.trigger = options.trigger;

                this.selectedText = '';
            }
        }, {
            key: 'initSelection',
            value: function initSelection() {
                if (this.text) {
                    this.selectFake();
                } else if (this.target) {
                    this.selectTarget();
                }
            }
        }, {
            key: 'selectFake',
            value: function selectFake() {
                var _this = this;

                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

                this.removeFake();

                this.fakeHandlerCallback = function () {
                    return _this.removeFake();
                };
                this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

                this.fakeElem = document.createElement('textarea');
                // Prevent zooming on iOS
                this.fakeElem.style.fontSize = '12pt';
                // Reset box model
                this.fakeElem.style.border = '0';
                this.fakeElem.style.padding = '0';
                this.fakeElem.style.margin = '0';
                // Move element out of screen horizontally
                this.fakeElem.style.position = 'absolute';
                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
                // Move element to the same position vertically
                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                this.fakeElem.style.top = yPosition + 'px';

                this.fakeElem.setAttribute('readonly', '');
                this.fakeElem.value = this.text;

                this.container.appendChild(this.fakeElem);

                this.selectedText = (0, _select2.default)(this.fakeElem);
                this.copyText();
            }
        }, {
            key: 'removeFake',
            value: function removeFake() {
                if (this.fakeHandler) {
                    this.container.removeEventListener('click', this.fakeHandlerCallback);
                    this.fakeHandler = null;
                    this.fakeHandlerCallback = null;
                }

                if (this.fakeElem) {
                    this.container.removeChild(this.fakeElem);
                    this.fakeElem = null;
                }
            }
        }, {
            key: 'selectTarget',
            value: function selectTarget() {
                this.selectedText = (0, _select2.default)(this.target);
                this.copyText();
            }
        }, {
            key: 'copyText',
            value: function copyText() {
                var succeeded = void 0;

                try {
                    succeeded = document.execCommand(this.action);
                } catch (err) {
                    succeeded = false;
                }

                this.handleResult(succeeded);
            }
        }, {
            key: 'handleResult',
            value: function handleResult(succeeded) {
                this.emitter.emit(succeeded ? 'success' : 'error', {
                    action: this.action,
                    text: this.selectedText,
                    trigger: this.trigger,
                    clearSelection: this.clearSelection.bind(this)
                });
            }
        }, {
            key: 'clearSelection',
            value: function clearSelection() {
                if (this.trigger) {
                    this.trigger.focus();
                }

                window.getSelection().removeAllRanges();
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.removeFake();
            }
        }, {
            key: 'action',
            set: function set() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

                this._action = action;

                if (this._action !== 'copy' && this._action !== 'cut') {
                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
                }
            },
            get: function get() {
                return this._action;
            }
        }, {
            key: 'target',
            set: function set(target) {
                if (target !== undefined) {
                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                        }

                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        }

                        this._target = target;
                    } else {
                        throw new Error('Invalid "target" value, use a valid Element');
                    }
                }
            },
            get: function get() {
                return this._target;
            }
        }]);

        return ClipboardAction;
    }();

    module.exports = ClipboardAction;
});

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: http://codemirror.net/LICENSE

(function(mod) {
  if (true) // CommonJS
    mod(__webpack_require__(646));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../../lib/codemirror"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
"use strict";

CodeMirror.defineMode("javascript", function(config, parserConfig) {
  var indentUnit = config.indentUnit;
  var statementIndent = parserConfig.statementIndent;
  var jsonldMode = parserConfig.jsonld;
  var jsonMode = parserConfig.json || jsonldMode;
  var isTS = parserConfig.typescript;
  var wordRE = parserConfig.wordCharacters || /[\w$\xa1-\uffff]/;

  // Tokenizer

  var keywords = function(){
    function kw(type) {return {type: type, style: "keyword"};}
    var A = kw("keyword a"), B = kw("keyword b"), C = kw("keyword c"), D = kw("keyword d");
    var operator = kw("operator"), atom = {type: "atom", style: "atom"};

    return {
      "if": kw("if"), "while": A, "with": A, "else": B, "do": B, "try": B, "finally": B,
      "return": D, "break": D, "continue": D, "new": kw("new"), "delete": C, "void": C, "throw": C,
      "debugger": kw("debugger"), "var": kw("var"), "const": kw("var"), "let": kw("var"),
      "function": kw("function"), "catch": kw("catch"),
      "for": kw("for"), "switch": kw("switch"), "case": kw("case"), "default": kw("default"),
      "in": operator, "typeof": operator, "instanceof": operator,
      "true": atom, "false": atom, "null": atom, "undefined": atom, "NaN": atom, "Infinity": atom,
      "this": kw("this"), "class": kw("class"), "super": kw("atom"),
      "yield": C, "export": kw("export"), "import": kw("import"), "extends": C,
      "await": C
    };
  }();

  var isOperatorChar = /[+\-*&%=<>!?|~^@]/;
  var isJsonldKeyword = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;

  function readRegexp(stream) {
    var escaped = false, next, inSet = false;
    while ((next = stream.next()) != null) {
      if (!escaped) {
        if (next == "/" && !inSet) return;
        if (next == "[") inSet = true;
        else if (inSet && next == "]") inSet = false;
      }
      escaped = !escaped && next == "\\";
    }
  }

  // Used as scratch variables to communicate multiple values without
  // consing up tons of objects.
  var type, content;
  function ret(tp, style, cont) {
    type = tp; content = cont;
    return style;
  }
  function tokenBase(stream, state) {
    var ch = stream.next();
    if (ch == '"' || ch == "'") {
      state.tokenize = tokenString(ch);
      return state.tokenize(stream, state);
    } else if (ch == "." && stream.match(/^\d+(?:[eE][+\-]?\d+)?/)) {
      return ret("number", "number");
    } else if (ch == "." && stream.match("..")) {
      return ret("spread", "meta");
    } else if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
      return ret(ch);
    } else if (ch == "=" && stream.eat(">")) {
      return ret("=>", "operator");
    } else if (ch == "0" && stream.match(/^(?:x[\da-f]+|o[0-7]+|b[01]+)n?/i)) {
      return ret("number", "number");
    } else if (/\d/.test(ch)) {
      stream.match(/^\d*(?:n|(?:\.\d*)?(?:[eE][+\-]?\d+)?)?/);
      return ret("number", "number");
    } else if (ch == "/") {
      if (stream.eat("*")) {
        state.tokenize = tokenComment;
        return tokenComment(stream, state);
      } else if (stream.eat("/")) {
        stream.skipToEnd();
        return ret("comment", "comment");
      } else if (expressionAllowed(stream, state, 1)) {
        readRegexp(stream);
        stream.match(/^\b(([gimyus])(?![gimyus]*\2))+\b/);
        return ret("regexp", "string-2");
      } else {
        stream.eat("=");
        return ret("operator", "operator", stream.current());
      }
    } else if (ch == "`") {
      state.tokenize = tokenQuasi;
      return tokenQuasi(stream, state);
    } else if (ch == "#") {
      stream.skipToEnd();
      return ret("error", "error");
    } else if (isOperatorChar.test(ch)) {
      if (ch != ">" || !state.lexical || state.lexical.type != ">") {
        if (stream.eat("=")) {
          if (ch == "!" || ch == "=") stream.eat("=")
        } else if (/[<>*+\-]/.test(ch)) {
          stream.eat(ch)
          if (ch == ">") stream.eat(ch)
        }
      }
      return ret("operator", "operator", stream.current());
    } else if (wordRE.test(ch)) {
      stream.eatWhile(wordRE);
      var word = stream.current()
      if (state.lastType != ".") {
        if (keywords.propertyIsEnumerable(word)) {
          var kw = keywords[word]
          return ret(kw.type, kw.style, word)
        }
        if (word == "async" && stream.match(/^(\s|\/\*.*?\*\/)*[\[\(\w]/, false))
          return ret("async", "keyword", word)
      }
      return ret("variable", "variable", word)
    }
  }

  function tokenString(quote) {
    return function(stream, state) {
      var escaped = false, next;
      if (jsonldMode && stream.peek() == "@" && stream.match(isJsonldKeyword)){
        state.tokenize = tokenBase;
        return ret("jsonld-keyword", "meta");
      }
      while ((next = stream.next()) != null) {
        if (next == quote && !escaped) break;
        escaped = !escaped && next == "\\";
      }
      if (!escaped) state.tokenize = tokenBase;
      return ret("string", "string");
    };
  }

  function tokenComment(stream, state) {
    var maybeEnd = false, ch;
    while (ch = stream.next()) {
      if (ch == "/" && maybeEnd) {
        state.tokenize = tokenBase;
        break;
      }
      maybeEnd = (ch == "*");
    }
    return ret("comment", "comment");
  }

  function tokenQuasi(stream, state) {
    var escaped = false, next;
    while ((next = stream.next()) != null) {
      if (!escaped && (next == "`" || next == "$" && stream.eat("{"))) {
        state.tokenize = tokenBase;
        break;
      }
      escaped = !escaped && next == "\\";
    }
    return ret("quasi", "string-2", stream.current());
  }

  var brackets = "([{}])";
  // This is a crude lookahead trick to try and notice that we're
  // parsing the argument patterns for a fat-arrow function before we
  // actually hit the arrow token. It only works if the arrow is on
  // the same line as the arguments and there's no strange noise
  // (comments) in between. Fallback is to only notice when we hit the
  // arrow, and not declare the arguments as locals for the arrow
  // body.
  function findFatArrow(stream, state) {
    if (state.fatArrowAt) state.fatArrowAt = null;
    var arrow = stream.string.indexOf("=>", stream.start);
    if (arrow < 0) return;

    if (isTS) { // Try to skip TypeScript return type declarations after the arguments
      var m = /:\s*(?:\w+(?:<[^>]*>|\[\])?|\{[^}]*\})\s*$/.exec(stream.string.slice(stream.start, arrow))
      if (m) arrow = m.index
    }

    var depth = 0, sawSomething = false;
    for (var pos = arrow - 1; pos >= 0; --pos) {
      var ch = stream.string.charAt(pos);
      var bracket = brackets.indexOf(ch);
      if (bracket >= 0 && bracket < 3) {
        if (!depth) { ++pos; break; }
        if (--depth == 0) { if (ch == "(") sawSomething = true; break; }
      } else if (bracket >= 3 && bracket < 6) {
        ++depth;
      } else if (wordRE.test(ch)) {
        sawSomething = true;
      } else if (/["'\/]/.test(ch)) {
        return;
      } else if (sawSomething && !depth) {
        ++pos;
        break;
      }
    }
    if (sawSomething && !depth) state.fatArrowAt = pos;
  }

  // Parser

  var atomicTypes = {"atom": true, "number": true, "variable": true, "string": true, "regexp": true, "this": true, "jsonld-keyword": true};

  function JSLexical(indented, column, type, align, prev, info) {
    this.indented = indented;
    this.column = column;
    this.type = type;
    this.prev = prev;
    this.info = info;
    if (align != null) this.align = align;
  }

  function inScope(state, varname) {
    for (var v = state.localVars; v; v = v.next)
      if (v.name == varname) return true;
    for (var cx = state.context; cx; cx = cx.prev) {
      for (var v = cx.vars; v; v = v.next)
        if (v.name == varname) return true;
    }
  }

  function parseJS(state, style, type, content, stream) {
    var cc = state.cc;
    // Communicate our context to the combinators.
    // (Less wasteful than consing up a hundred closures on every call.)
    cx.state = state; cx.stream = stream; cx.marked = null, cx.cc = cc; cx.style = style;

    if (!state.lexical.hasOwnProperty("align"))
      state.lexical.align = true;

    while(true) {
      var combinator = cc.length ? cc.pop() : jsonMode ? expression : statement;
      if (combinator(type, content)) {
        while(cc.length && cc[cc.length - 1].lex)
          cc.pop()();
        if (cx.marked) return cx.marked;
        if (type == "variable" && inScope(state, content)) return "variable-2";
        return style;
      }
    }
  }

  // Combinator utils

  var cx = {state: null, column: null, marked: null, cc: null};
  function pass() {
    for (var i = arguments.length - 1; i >= 0; i--) cx.cc.push(arguments[i]);
  }
  function cont() {
    pass.apply(null, arguments);
    return true;
  }
  function inList(name, list) {
    for (var v = list; v; v = v.next) if (v.name == name) return true
    return false;
  }
  function register(varname) {
    var state = cx.state;
    cx.marked = "def";
    if (state.context) {
      if (state.lexical.info == "var" && state.context && state.context.block) {
        // FIXME function decls are also not block scoped
        var newContext = registerVarScoped(varname, state.context)
        if (newContext != null) {
          state.context = newContext
          return
        }
      } else if (!inList(varname, state.localVars)) {
        state.localVars = new Var(varname, state.localVars)
        return
      }
    }
    // Fall through means this is global
    if (parserConfig.globalVars && !inList(varname, state.globalVars))
      state.globalVars = new Var(varname, state.globalVars)
  }
  function registerVarScoped(varname, context) {
    if (!context) {
      return null
    } else if (context.block) {
      var inner = registerVarScoped(varname, context.prev)
      if (!inner) return null
      if (inner == context.prev) return context
      return new Context(inner, context.vars, true)
    } else if (inList(varname, context.vars)) {
      return context
    } else {
      return new Context(context.prev, new Var(varname, context.vars), false)
    }
  }

  function isModifier(name) {
    return name == "public" || name == "private" || name == "protected" || name == "abstract" || name == "readonly"
  }

  // Combinators

  function Context(prev, vars, block) { this.prev = prev; this.vars = vars; this.block = block }
  function Var(name, next) { this.name = name; this.next = next }

  var defaultVars = new Var("this", new Var("arguments", null))
  function pushcontext() {
    cx.state.context = new Context(cx.state.context, cx.state.localVars, false)
    cx.state.localVars = defaultVars
  }
  function pushblockcontext() {
    cx.state.context = new Context(cx.state.context, cx.state.localVars, true)
    cx.state.localVars = null
  }
  function popcontext() {
    cx.state.localVars = cx.state.context.vars
    cx.state.context = cx.state.context.prev
  }
  popcontext.lex = true
  function pushlex(type, info) {
    var result = function() {
      var state = cx.state, indent = state.indented;
      if (state.lexical.type == "stat") indent = state.lexical.indented;
      else for (var outer = state.lexical; outer && outer.type == ")" && outer.align; outer = outer.prev)
        indent = outer.indented;
      state.lexical = new JSLexical(indent, cx.stream.column(), type, null, state.lexical, info);
    };
    result.lex = true;
    return result;
  }
  function poplex() {
    var state = cx.state;
    if (state.lexical.prev) {
      if (state.lexical.type == ")")
        state.indented = state.lexical.indented;
      state.lexical = state.lexical.prev;
    }
  }
  poplex.lex = true;

  function expect(wanted) {
    function exp(type) {
      if (type == wanted) return cont();
      else if (wanted == ";") return pass();
      else return cont(exp);
    };
    return exp;
  }

  function statement(type, value) {
    if (type == "var") return cont(pushlex("vardef", value), vardef, expect(";"), poplex);
    if (type == "keyword a") return cont(pushlex("form"), parenExpr, statement, poplex);
    if (type == "keyword b") return cont(pushlex("form"), statement, poplex);
    if (type == "keyword d") return cx.stream.match(/^\s*$/, false) ? cont() : cont(pushlex("stat"), maybeexpression, expect(";"), poplex);
    if (type == "debugger") return cont(expect(";"));
    if (type == "{") return cont(pushlex("}"), pushblockcontext, block, poplex, popcontext);
    if (type == ";") return cont();
    if (type == "if") {
      if (cx.state.lexical.info == "else" && cx.state.cc[cx.state.cc.length - 1] == poplex)
        cx.state.cc.pop()();
      return cont(pushlex("form"), parenExpr, statement, poplex, maybeelse);
    }
    if (type == "function") return cont(functiondef);
    if (type == "for") return cont(pushlex("form"), forspec, statement, poplex);
    if (type == "class" || (isTS && value == "interface")) { cx.marked = "keyword"; return cont(pushlex("form"), className, poplex); }
    if (type == "variable") {
      if (isTS && value == "declare") {
        cx.marked = "keyword"
        return cont(statement)
      } else if (isTS && (value == "module" || value == "enum" || value == "type") && cx.stream.match(/^\s*\w/, false)) {
        cx.marked = "keyword"
        if (value == "enum") return cont(enumdef);
        else if (value == "type") return cont(typeexpr, expect("operator"), typeexpr, expect(";"));
        else return cont(pushlex("form"), pattern, expect("{"), pushlex("}"), block, poplex, poplex)
      } else if (isTS && value == "namespace") {
        cx.marked = "keyword"
        return cont(pushlex("form"), expression, block, poplex)
      } else if (isTS && value == "abstract") {
        cx.marked = "keyword"
        return cont(statement)
      } else {
        return cont(pushlex("stat"), maybelabel);
      }
    }
    if (type == "switch") return cont(pushlex("form"), parenExpr, expect("{"), pushlex("}", "switch"), pushblockcontext,
                                      block, poplex, poplex, popcontext);
    if (type == "case") return cont(expression, expect(":"));
    if (type == "default") return cont(expect(":"));
    if (type == "catch") return cont(pushlex("form"), pushcontext, maybeCatchBinding, statement, poplex, popcontext);
    if (type == "export") return cont(pushlex("stat"), afterExport, poplex);
    if (type == "import") return cont(pushlex("stat"), afterImport, poplex);
    if (type == "async") return cont(statement)
    if (value == "@") return cont(expression, statement)
    return pass(pushlex("stat"), expression, expect(";"), poplex);
  }
  function maybeCatchBinding(type) {
    if (type == "(") return cont(funarg, expect(")"))
  }
  function expression(type, value) {
    return expressionInner(type, value, false);
  }
  function expressionNoComma(type, value) {
    return expressionInner(type, value, true);
  }
  function parenExpr(type) {
    if (type != "(") return pass()
    return cont(pushlex(")"), expression, expect(")"), poplex)
  }
  function expressionInner(type, value, noComma) {
    if (cx.state.fatArrowAt == cx.stream.start) {
      var body = noComma ? arrowBodyNoComma : arrowBody;
      if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, expect("=>"), body, popcontext);
      else if (type == "variable") return pass(pushcontext, pattern, expect("=>"), body, popcontext);
    }

    var maybeop = noComma ? maybeoperatorNoComma : maybeoperatorComma;
    if (atomicTypes.hasOwnProperty(type)) return cont(maybeop);
    if (type == "function") return cont(functiondef, maybeop);
    if (type == "class" || (isTS && value == "interface")) { cx.marked = "keyword"; return cont(pushlex("form"), classExpression, poplex); }
    if (type == "keyword c" || type == "async") return cont(noComma ? expressionNoComma : expression);
    if (type == "(") return cont(pushlex(")"), maybeexpression, expect(")"), poplex, maybeop);
    if (type == "operator" || type == "spread") return cont(noComma ? expressionNoComma : expression);
    if (type == "[") return cont(pushlex("]"), arrayLiteral, poplex, maybeop);
    if (type == "{") return contCommasep(objprop, "}", null, maybeop);
    if (type == "quasi") return pass(quasi, maybeop);
    if (type == "new") return cont(maybeTarget(noComma));
    if (type == "import") return cont(expression);
    return cont();
  }
  function maybeexpression(type) {
    if (type.match(/[;\}\)\],]/)) return pass();
    return pass(expression);
  }

  function maybeoperatorComma(type, value) {
    if (type == ",") return cont(expression);
    return maybeoperatorNoComma(type, value, false);
  }
  function maybeoperatorNoComma(type, value, noComma) {
    var me = noComma == false ? maybeoperatorComma : maybeoperatorNoComma;
    var expr = noComma == false ? expression : expressionNoComma;
    if (type == "=>") return cont(pushcontext, noComma ? arrowBodyNoComma : arrowBody, popcontext);
    if (type == "operator") {
      if (/\+\+|--/.test(value) || isTS && value == "!") return cont(me);
      if (isTS && value == "<" && cx.stream.match(/^([^>]|<.*?>)*>\s*\(/, false))
        return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, me);
      if (value == "?") return cont(expression, expect(":"), expr);
      return cont(expr);
    }
    if (type == "quasi") { return pass(quasi, me); }
    if (type == ";") return;
    if (type == "(") return contCommasep(expressionNoComma, ")", "call", me);
    if (type == ".") return cont(property, me);
    if (type == "[") return cont(pushlex("]"), maybeexpression, expect("]"), poplex, me);
    if (isTS && value == "as") { cx.marked = "keyword"; return cont(typeexpr, me) }
    if (type == "regexp") {
      cx.state.lastType = cx.marked = "operator"
      cx.stream.backUp(cx.stream.pos - cx.stream.start - 1)
      return cont(expr)
    }
  }
  function quasi(type, value) {
    if (type != "quasi") return pass();
    if (value.slice(value.length - 2) != "${") return cont(quasi);
    return cont(expression, continueQuasi);
  }
  function continueQuasi(type) {
    if (type == "}") {
      cx.marked = "string-2";
      cx.state.tokenize = tokenQuasi;
      return cont(quasi);
    }
  }
  function arrowBody(type) {
    findFatArrow(cx.stream, cx.state);
    return pass(type == "{" ? statement : expression);
  }
  function arrowBodyNoComma(type) {
    findFatArrow(cx.stream, cx.state);
    return pass(type == "{" ? statement : expressionNoComma);
  }
  function maybeTarget(noComma) {
    return function(type) {
      if (type == ".") return cont(noComma ? targetNoComma : target);
      else if (type == "variable" && isTS) return cont(maybeTypeArgs, noComma ? maybeoperatorNoComma : maybeoperatorComma)
      else return pass(noComma ? expressionNoComma : expression);
    };
  }
  function target(_, value) {
    if (value == "target") { cx.marked = "keyword"; return cont(maybeoperatorComma); }
  }
  function targetNoComma(_, value) {
    if (value == "target") { cx.marked = "keyword"; return cont(maybeoperatorNoComma); }
  }
  function maybelabel(type) {
    if (type == ":") return cont(poplex, statement);
    return pass(maybeoperatorComma, expect(";"), poplex);
  }
  function property(type) {
    if (type == "variable") {cx.marked = "property"; return cont();}
  }
  function objprop(type, value) {
    if (type == "async") {
      cx.marked = "property";
      return cont(objprop);
    } else if (type == "variable" || cx.style == "keyword") {
      cx.marked = "property";
      if (value == "get" || value == "set") return cont(getterSetter);
      var m // Work around fat-arrow-detection complication for detecting typescript typed arrow params
      if (isTS && cx.state.fatArrowAt == cx.stream.start && (m = cx.stream.match(/^\s*:\s*/, false)))
        cx.state.fatArrowAt = cx.stream.pos + m[0].length
      return cont(afterprop);
    } else if (type == "number" || type == "string") {
      cx.marked = jsonldMode ? "property" : (cx.style + " property");
      return cont(afterprop);
    } else if (type == "jsonld-keyword") {
      return cont(afterprop);
    } else if (isTS && isModifier(value)) {
      cx.marked = "keyword"
      return cont(objprop)
    } else if (type == "[") {
      return cont(expression, maybetype, expect("]"), afterprop);
    } else if (type == "spread") {
      return cont(expressionNoComma, afterprop);
    } else if (value == "*") {
      cx.marked = "keyword";
      return cont(objprop);
    } else if (type == ":") {
      return pass(afterprop)
    }
  }
  function getterSetter(type) {
    if (type != "variable") return pass(afterprop);
    cx.marked = "property";
    return cont(functiondef);
  }
  function afterprop(type) {
    if (type == ":") return cont(expressionNoComma);
    if (type == "(") return pass(functiondef);
  }
  function commasep(what, end, sep) {
    function proceed(type, value) {
      if (sep ? sep.indexOf(type) > -1 : type == ",") {
        var lex = cx.state.lexical;
        if (lex.info == "call") lex.pos = (lex.pos || 0) + 1;
        return cont(function(type, value) {
          if (type == end || value == end) return pass()
          return pass(what)
        }, proceed);
      }
      if (type == end || value == end) return cont();
      return cont(expect(end));
    }
    return function(type, value) {
      if (type == end || value == end) return cont();
      return pass(what, proceed);
    };
  }
  function contCommasep(what, end, info) {
    for (var i = 3; i < arguments.length; i++)
      cx.cc.push(arguments[i]);
    return cont(pushlex(end, info), commasep(what, end), poplex);
  }
  function block(type) {
    if (type == "}") return cont();
    return pass(statement, block);
  }
  function maybetype(type, value) {
    if (isTS) {
      if (type == ":") return cont(typeexpr);
      if (value == "?") return cont(maybetype);
    }
  }
  function mayberettype(type) {
    if (isTS && type == ":") {
      if (cx.stream.match(/^\s*\w+\s+is\b/, false)) return cont(expression, isKW, typeexpr)
      else return cont(typeexpr)
    }
  }
  function isKW(_, value) {
    if (value == "is") {
      cx.marked = "keyword"
      return cont()
    }
  }
  function typeexpr(type, value) {
    if (value == "keyof" || value == "typeof") {
      cx.marked = "keyword"
      return cont(value == "keyof" ? typeexpr : expressionNoComma)
    }
    if (type == "variable" || value == "void") {
      cx.marked = "type"
      return cont(afterType)
    }
    if (type == "string" || type == "number" || type == "atom") return cont(afterType);
    if (type == "[") return cont(pushlex("]"), commasep(typeexpr, "]", ","), poplex, afterType)
    if (type == "{") return cont(pushlex("}"), commasep(typeprop, "}", ",;"), poplex, afterType)
    if (type == "(") return cont(commasep(typearg, ")"), maybeReturnType)
    if (type == "<") return cont(commasep(typeexpr, ">"), typeexpr)
  }
  function maybeReturnType(type) {
    if (type == "=>") return cont(typeexpr)
  }
  function typeprop(type, value) {
    if (type == "variable" || cx.style == "keyword") {
      cx.marked = "property"
      return cont(typeprop)
    } else if (value == "?") {
      return cont(typeprop)
    } else if (type == ":") {
      return cont(typeexpr)
    } else if (type == "[") {
      return cont(expression, maybetype, expect("]"), typeprop)
    }
  }
  function typearg(type, value) {
    if (type == "variable" && cx.stream.match(/^\s*[?:]/, false) || value == "?") return cont(typearg)
    if (type == ":") return cont(typeexpr)
    return pass(typeexpr)
  }
  function afterType(type, value) {
    if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType)
    if (value == "|" || type == "." || value == "&") return cont(typeexpr)
    if (type == "[") return cont(expect("]"), afterType)
    if (value == "extends" || value == "implements") { cx.marked = "keyword"; return cont(typeexpr) }
  }
  function maybeTypeArgs(_, value) {
    if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType)
  }
  function typeparam() {
    return pass(typeexpr, maybeTypeDefault)
  }
  function maybeTypeDefault(_, value) {
    if (value == "=") return cont(typeexpr)
  }
  function vardef(_, value) {
    if (value == "enum") {cx.marked = "keyword"; return cont(enumdef)}
    return pass(pattern, maybetype, maybeAssign, vardefCont);
  }
  function pattern(type, value) {
    if (isTS && isModifier(value)) { cx.marked = "keyword"; return cont(pattern) }
    if (type == "variable") { register(value); return cont(); }
    if (type == "spread") return cont(pattern);
    if (type == "[") return contCommasep(pattern, "]");
    if (type == "{") return contCommasep(proppattern, "}");
  }
  function proppattern(type, value) {
    if (type == "variable" && !cx.stream.match(/^\s*:/, false)) {
      register(value);
      return cont(maybeAssign);
    }
    if (type == "variable") cx.marked = "property";
    if (type == "spread") return cont(pattern);
    if (type == "}") return pass();
    return cont(expect(":"), pattern, maybeAssign);
  }
  function maybeAssign(_type, value) {
    if (value == "=") return cont(expressionNoComma);
  }
  function vardefCont(type) {
    if (type == ",") return cont(vardef);
  }
  function maybeelse(type, value) {
    if (type == "keyword b" && value == "else") return cont(pushlex("form", "else"), statement, poplex);
  }
  function forspec(type, value) {
    if (value == "await") return cont(forspec);
    if (type == "(") return cont(pushlex(")"), forspec1, expect(")"), poplex);
  }
  function forspec1(type) {
    if (type == "var") return cont(vardef, expect(";"), forspec2);
    if (type == ";") return cont(forspec2);
    if (type == "variable") return cont(formaybeinof);
    return pass(expression, expect(";"), forspec2);
  }
  function formaybeinof(_type, value) {
    if (value == "in" || value == "of") { cx.marked = "keyword"; return cont(expression); }
    return cont(maybeoperatorComma, forspec2);
  }
  function forspec2(type, value) {
    if (type == ";") return cont(forspec3);
    if (value == "in" || value == "of") { cx.marked = "keyword"; return cont(expression); }
    return pass(expression, expect(";"), forspec3);
  }
  function forspec3(type) {
    if (type != ")") cont(expression);
  }
  function functiondef(type, value) {
    if (value == "*") {cx.marked = "keyword"; return cont(functiondef);}
    if (type == "variable") {register(value); return cont(functiondef);}
    if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, mayberettype, statement, popcontext);
    if (isTS && value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, functiondef)
  }
  function funarg(type, value) {
    if (value == "@") cont(expression, funarg)
    if (type == "spread") return cont(funarg);
    if (isTS && isModifier(value)) { cx.marked = "keyword"; return cont(funarg); }
    return pass(pattern, maybetype, maybeAssign);
  }
  function classExpression(type, value) {
    // Class expressions may have an optional name.
    if (type == "variable") return className(type, value);
    return classNameAfter(type, value);
  }
  function className(type, value) {
    if (type == "variable") {register(value); return cont(classNameAfter);}
  }
  function classNameAfter(type, value) {
    if (value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, classNameAfter)
    if (value == "extends" || value == "implements" || (isTS && type == ",")) {
      if (value == "implements") cx.marked = "keyword";
      return cont(isTS ? typeexpr : expression, classNameAfter);
    }
    if (type == "{") return cont(pushlex("}"), classBody, poplex);
  }
  function classBody(type, value) {
    if (type == "async" ||
        (type == "variable" &&
         (value == "static" || value == "get" || value == "set" || (isTS && isModifier(value))) &&
         cx.stream.match(/^\s+[\w$\xa1-\uffff]/, false))) {
      cx.marked = "keyword";
      return cont(classBody);
    }
    if (type == "variable" || cx.style == "keyword") {
      cx.marked = "property";
      return cont(isTS ? classfield : functiondef, classBody);
    }
    if (type == "[")
      return cont(expression, maybetype, expect("]"), isTS ? classfield : functiondef, classBody)
    if (value == "*") {
      cx.marked = "keyword";
      return cont(classBody);
    }
    if (type == ";") return cont(classBody);
    if (type == "}") return cont();
    if (value == "@") return cont(expression, classBody)
  }
  function classfield(type, value) {
    if (value == "?") return cont(classfield)
    if (type == ":") return cont(typeexpr, maybeAssign)
    if (value == "=") return cont(expressionNoComma)
    return pass(functiondef)
  }
  function afterExport(type, value) {
    if (value == "*") { cx.marked = "keyword"; return cont(maybeFrom, expect(";")); }
    if (value == "default") { cx.marked = "keyword"; return cont(expression, expect(";")); }
    if (type == "{") return cont(commasep(exportField, "}"), maybeFrom, expect(";"));
    return pass(statement);
  }
  function exportField(type, value) {
    if (value == "as") { cx.marked = "keyword"; return cont(expect("variable")); }
    if (type == "variable") return pass(expressionNoComma, exportField);
  }
  function afterImport(type) {
    if (type == "string") return cont();
    if (type == "(") return pass(expression);
    return pass(importSpec, maybeMoreImports, maybeFrom);
  }
  function importSpec(type, value) {
    if (type == "{") return contCommasep(importSpec, "}");
    if (type == "variable") register(value);
    if (value == "*") cx.marked = "keyword";
    return cont(maybeAs);
  }
  function maybeMoreImports(type) {
    if (type == ",") return cont(importSpec, maybeMoreImports)
  }
  function maybeAs(_type, value) {
    if (value == "as") { cx.marked = "keyword"; return cont(importSpec); }
  }
  function maybeFrom(_type, value) {
    if (value == "from") { cx.marked = "keyword"; return cont(expression); }
  }
  function arrayLiteral(type) {
    if (type == "]") return cont();
    return pass(commasep(expressionNoComma, "]"));
  }
  function enumdef() {
    return pass(pushlex("form"), pattern, expect("{"), pushlex("}"), commasep(enummember, "}"), poplex, poplex)
  }
  function enummember() {
    return pass(pattern, maybeAssign);
  }

  function isContinuedStatement(state, textAfter) {
    return state.lastType == "operator" || state.lastType == "," ||
      isOperatorChar.test(textAfter.charAt(0)) ||
      /[,.]/.test(textAfter.charAt(0));
  }

  function expressionAllowed(stream, state, backUp) {
    return state.tokenize == tokenBase &&
      /^(?:operator|sof|keyword [bcd]|case|new|export|default|spread|[\[{}\(,;:]|=>)$/.test(state.lastType) ||
      (state.lastType == "quasi" && /\{\s*$/.test(stream.string.slice(0, stream.pos - (backUp || 0))))
  }

  // Interface

  return {
    startState: function(basecolumn) {
      var state = {
        tokenize: tokenBase,
        lastType: "sof",
        cc: [],
        lexical: new JSLexical((basecolumn || 0) - indentUnit, 0, "block", false),
        localVars: parserConfig.localVars,
        context: parserConfig.localVars && new Context(null, null, false),
        indented: basecolumn || 0
      };
      if (parserConfig.globalVars && typeof parserConfig.globalVars == "object")
        state.globalVars = parserConfig.globalVars;
      return state;
    },

    token: function(stream, state) {
      if (stream.sol()) {
        if (!state.lexical.hasOwnProperty("align"))
          state.lexical.align = false;
        state.indented = stream.indentation();
        findFatArrow(stream, state);
      }
      if (state.tokenize != tokenComment && stream.eatSpace()) return null;
      var style = state.tokenize(stream, state);
      if (type == "comment") return style;
      state.lastType = type == "operator" && (content == "++" || content == "--") ? "incdec" : type;
      return parseJS(state, style, type, content, stream);
    },

    indent: function(state, textAfter) {
      if (state.tokenize == tokenComment) return CodeMirror.Pass;
      if (state.tokenize != tokenBase) return 0;
      var firstChar = textAfter && textAfter.charAt(0), lexical = state.lexical, top
      // Kludge to prevent 'maybelse' from blocking lexical scope pops
      if (!/^\s*else\b/.test(textAfter)) for (var i = state.cc.length - 1; i >= 0; --i) {
        var c = state.cc[i];
        if (c == poplex) lexical = lexical.prev;
        else if (c != maybeelse) break;
      }
      while ((lexical.type == "stat" || lexical.type == "form") &&
             (firstChar == "}" || ((top = state.cc[state.cc.length - 1]) &&
                                   (top == maybeoperatorComma || top == maybeoperatorNoComma) &&
                                   !/^[,\.=+\-*:?[\(]/.test(textAfter))))
        lexical = lexical.prev;
      if (statementIndent && lexical.type == ")" && lexical.prev.type == "stat")
        lexical = lexical.prev;
      var type = lexical.type, closing = firstChar == type;

      if (type == "vardef") return lexical.indented + (state.lastType == "operator" || state.lastType == "," ? lexical.info.length + 1 : 0);
      else if (type == "form" && firstChar == "{") return lexical.indented;
      else if (type == "form") return lexical.indented + indentUnit;
      else if (type == "stat")
        return lexical.indented + (isContinuedStatement(state, textAfter) ? statementIndent || indentUnit : 0);
      else if (lexical.info == "switch" && !closing && parserConfig.doubleIndentSwitch != false)
        return lexical.indented + (/^(?:case|default)\b/.test(textAfter) ? indentUnit : 2 * indentUnit);
      else if (lexical.align) return lexical.column + (closing ? 0 : 1);
      else return lexical.indented + (closing ? 0 : indentUnit);
    },

    electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
    blockCommentStart: jsonMode ? null : "/*",
    blockCommentEnd: jsonMode ? null : "*/",
    blockCommentContinue: jsonMode ? null : " * ",
    lineComment: jsonMode ? null : "//",
    fold: "brace",
    closeBrackets: "()[]{}''\"\"``",

    helperType: jsonMode ? "json" : "javascript",
    jsonldMode: jsonldMode,
    jsonMode: jsonMode,

    expressionAllowed: expressionAllowed,

    skipExpression: function(state) {
      var top = state.cc[state.cc.length - 1]
      if (top == expression || top == expressionNoComma) state.cc.pop()
    }
  };
});

CodeMirror.registerHelper("wordChars", "javascript", /[\w$]/);

CodeMirror.defineMIME("text/javascript", "javascript");
CodeMirror.defineMIME("text/ecmascript", "javascript");
CodeMirror.defineMIME("application/javascript", "javascript");
CodeMirror.defineMIME("application/x-javascript", "javascript");
CodeMirror.defineMIME("application/ecmascript", "javascript");
CodeMirror.defineMIME("application/json", {name: "javascript", json: true});
CodeMirror.defineMIME("application/x-json", {name: "javascript", json: true});
CodeMirror.defineMIME("application/ld+json", {name: "javascript", jsonld: true});
CodeMirror.defineMIME("text/typescript", { name: "javascript", typescript: true });
CodeMirror.defineMIME("application/typescript", { name: "javascript", typescript: true });

});


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 1439 */
/***/ (function(module, exports) {

// Console-polyfill. MIT license.
// https://github.com/paulmillr/console-polyfill
// Make it safe to do console.log() always.
(function(global) {
  'use strict';
  if (!global.console) {
    global.console = {};
  }
  var con = global.console;
  var prop, method;
  var dummy = function() {};
  var properties = ['memory'];
  var methods = ('assert,clear,count,debug,dir,dirxml,error,exception,group,' +
     'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' +
     'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn').split(',');
  while (prop = properties.pop()) if (!con[prop]) con[prop] = {};
  while (method = methods.pop()) if (typeof con[method] !== 'function') con[method] = dummy;
  // Using `this` for web workers & supports Browserify / Webpack.
})(typeof window === 'undefined' ? this : window);


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(698);
module.exports = __webpack_require__(82).Object.assign;


/***/ }),
/* 1441 */,
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(701);
module.exports = __webpack_require__(1502)('String').startsWith;


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(703);
__webpack_require__(1507);
__webpack_require__(293);
__webpack_require__(1509);
__webpack_require__(695);
__webpack_require__(1506);
__webpack_require__(1508);
__webpack_require__(1513);
__webpack_require__(1511);
__webpack_require__(1512);
__webpack_require__(1514);
__webpack_require__(1510);
__webpack_require__(696);
__webpack_require__(1515);
__webpack_require__(1516);
module.exports = __webpack_require__(82);


/***/ }),
/* 1444 */,
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(77);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1485);
module.exports = __webpack_require__(77).Object.keys;


/***/ }),
/* 1450 */,
/* 1451 */,
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(458);
__webpack_require__(345);
__webpack_require__(459);
__webpack_require__(1487);
__webpack_require__(1492);
__webpack_require__(1493);
module.exports = __webpack_require__(77).Promise;


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(458);
__webpack_require__(345);
__webpack_require__(459);
__webpack_require__(1488);
__webpack_require__(1496);
__webpack_require__(1495);
__webpack_require__(1494);
module.exports = __webpack_require__(77).Set;


/***/ }),
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(284);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 1458 */,
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(157);
var IObject = __webpack_require__(446);
var toObject = __webpack_require__(290);
var toLength = __webpack_require__(343);
var asc = __webpack_require__(1461);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(132);
var isArray = __webpack_require__(650);
var SPECIES = __webpack_require__(104)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1460);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(141).f;
var create = __webpack_require__(342);
var redefineAll = __webpack_require__(451);
var ctx = __webpack_require__(157);
var anInstance = __webpack_require__(441);
var forOf = __webpack_require__(284);
var $iterDefine = __webpack_require__(447);
var step = __webpack_require__(653);
var setSpecies = __webpack_require__(661);
var DESCRIPTORS = __webpack_require__(158);
var fastKey = __webpack_require__(448).fastKey;
var validate = __webpack_require__(664);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(442);
var from = __webpack_require__(1457);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(99);
var $export = __webpack_require__(95);
var meta = __webpack_require__(448);
var fails = __webpack_require__(206);
var hide = __webpack_require__(182);
var redefineAll = __webpack_require__(451);
var forOf = __webpack_require__(284);
var anInstance = __webpack_require__(441);
var isObject = __webpack_require__(132);
var setToStringTag = __webpack_require__(289);
var dP = __webpack_require__(141).f;
var each = __webpack_require__(1459)(0);
var DESCRIPTORS = __webpack_require__(158);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 1465 */,
/* 1466 */,
/* 1467 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 1468 */,
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(99);
var macrotask = __webpack_require__(663).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(283)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(95);
var core = __webpack_require__(77);
var fails = __webpack_require__(206);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(95);
var aFunction = __webpack_require__(282);
var ctx = __webpack_require__(157);
var forOf = __webpack_require__(284);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(95);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(99);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(290);
var $keys = __webpack_require__(251);

__webpack_require__(1474)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1486 */,
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(286);
var global = __webpack_require__(99);
var ctx = __webpack_require__(157);
var classof = __webpack_require__(442);
var $export = __webpack_require__(95);
var isObject = __webpack_require__(132);
var aFunction = __webpack_require__(282);
var anInstance = __webpack_require__(441);
var forOf = __webpack_require__(284);
var speciesConstructor = __webpack_require__(662);
var task = __webpack_require__(663).set;
var microtask = __webpack_require__(1469)();
var newPromiseCapabilityModule = __webpack_require__(449);
var perform = __webpack_require__(658);
var userAgent = __webpack_require__(1480);
var promiseResolve = __webpack_require__(659);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(104)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(451)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(289)($Promise, PROMISE);
__webpack_require__(661)(PROMISE);
Wrapper = __webpack_require__(77)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(652)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(1462);
var validate = __webpack_require__(664);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(1464)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(95);
var core = __webpack_require__(77);
var global = __webpack_require__(99);
var speciesConstructor = __webpack_require__(662);
var promiseResolve = __webpack_require__(659);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(95);
var newPromiseCapability = __webpack_require__(449);
var perform = __webpack_require__(658);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(1475)('Set');


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(1476)('Set');


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(95);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(1463)('Set') });


/***/ }),
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(82);
module.exports = function (CONSTRUCTOR) {
  var C = core[CONSTRUCTOR];
  return (C.virtual || C.prototype);
};


/***/ }),
/* 1503 */,
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(161);
var toIObject = __webpack_require__(100);
module.exports = function (object, el) {
  var O = toIObject(object);
  var keys = getKeys(O);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) if (O[key = keys[index++]] === el) return key;
};


/***/ }),
/* 1505 */,
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(37);
var core = __webpack_require__(82);
var $export = __webpack_require__(13);
var partial = __webpack_require__(688);
// https://esdiscuss.org/topic/promise-returning-delay-function
$export($export.G + $export.F, {
  delay: function delay(time) {
    return new (core.Promise || global.Promise)(function (resolve) {
      setTimeout(partial.call(resolve, true), time);
    });
  }
});


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(121);
var $export = __webpack_require__(13);
var createDesc = __webpack_require__(187);
var assign = __webpack_require__(475);
var create = __webpack_require__(160);
var getPrototypeOf = __webpack_require__(113);
var getKeys = __webpack_require__(161);
var dP = __webpack_require__(60);
var keyOf = __webpack_require__(1504);
var aFunction = __webpack_require__(89);
var forOf = __webpack_require__(184);
var isIterable = __webpack_require__(695);
var $iterCreate = __webpack_require__(352);
var step = __webpack_require__(470);
var isObject = __webpack_require__(42);
var toIObject = __webpack_require__(100);
var DESCRIPTORS = __webpack_require__(63);
var has = __webpack_require__(110);

// 0 -> Dict.forEach
// 1 -> Dict.map
// 2 -> Dict.filter
// 3 -> Dict.some
// 4 -> Dict.every
// 5 -> Dict.find
// 6 -> Dict.findKey
// 7 -> Dict.mapPairs
var createDictMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_EVERY = TYPE == 4;
  return function (object, callbackfn, that /* = undefined */) {
    var f = ctx(callbackfn, that, 3);
    var O = toIObject(object);
    var result = IS_MAP || TYPE == 7 || TYPE == 2
          ? new (typeof this == 'function' ? this : Dict)() : undefined;
    var key, val, res;
    for (key in O) if (has(O, key)) {
      val = O[key];
      res = f(val, key, object);
      if (TYPE) {
        if (IS_MAP) result[key] = res;          // map
        else if (res) switch (TYPE) {
          case 2: result[key] = val; break;     // filter
          case 3: return true;                  // some
          case 5: return val;                   // find
          case 6: return key;                   // findKey
          case 7: result[res[0]] = res[1];      // mapPairs
        } else if (IS_EVERY) return false;      // every
      }
    }
    return TYPE == 3 || IS_EVERY ? IS_EVERY : result;
  };
};
var findKey = createDictMethod(6);

var createDictIter = function (kind) {
  return function (it) {
    return new DictIterator(it, kind);
  };
};
var DictIterator = function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._a = getKeys(iterated);   // keys
  this._i = 0;                   // next index
  this._k = kind;                // kind
};
$iterCreate(DictIterator, 'Dict', function () {
  var that = this;
  var O = that._t;
  var keys = that._a;
  var kind = that._k;
  var key;
  do {
    if (that._i >= keys.length) {
      that._t = undefined;
      return step(1);
    }
  } while (!has(O, key = keys[that._i++]));
  if (kind == 'keys') return step(0, key);
  if (kind == 'values') return step(0, O[key]);
  return step(0, [key, O[key]]);
});

function Dict(iterable) {
  var dict = create(null);
  if (iterable != undefined) {
    if (isIterable(iterable)) {
      forOf(iterable, true, function (key, value) {
        dict[key] = value;
      });
    } else assign(dict, iterable);
  }
  return dict;
}
Dict.prototype = null;

function reduce(object, mapfn, init) {
  aFunction(mapfn);
  var O = toIObject(object);
  var keys = getKeys(O);
  var length = keys.length;
  var i = 0;
  var memo, key;
  if (arguments.length < 3) {
    if (!length) throw TypeError('Reduce of empty object with no initial value');
    memo = O[keys[i++]];
  } else memo = Object(init);
  while (length > i) if (has(O, key = keys[i++])) {
    memo = mapfn(memo, O[key], key, object);
  }
  return memo;
}

function includes(object, el) {
  // eslint-disable-next-line no-self-compare
  return (el == el ? keyOf(object, el) : findKey(object, function (it) {
    // eslint-disable-next-line no-self-compare
    return it != it;
  })) !== undefined;
}

function get(object, key) {
  if (has(object, key)) return object[key];
}
function set(object, key, value) {
  if (DESCRIPTORS && key in Object) dP.f(object, key, createDesc(0, value));
  else object[key] = value;
  return object;
}

function isDict(it) {
  return isObject(it) && getPrototypeOf(it) === Dict.prototype;
}

$export($export.G + $export.F, { Dict: Dict });

$export($export.S, 'Dict', {
  keys: createDictIter('keys'),
  values: createDictIter('values'),
  entries: createDictIter('entries'),
  forEach: createDictMethod(0),
  map: createDictMethod(1),
  filter: createDictMethod(2),
  some: createDictMethod(3),
  every: createDictMethod(4),
  find: createDictMethod(5),
  findKey: findKey,
  mapPairs: createDictMethod(7),
  reduce: reduce,
  keyOf: keyOf,
  includes: includes,
  has: has,
  get: get,
  set: set,
  isDict: isDict
});


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(689);
var $export = __webpack_require__(13);

// Placeholder
__webpack_require__(82)._ = path._ = path._ || {};

$export($export.P + $export.F, 'Function', { part: __webpack_require__(688) });


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(35);
var get = __webpack_require__(293);
module.exports = __webpack_require__(82).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(353)(Number, 'Number', function (iterated) {
  this._l = +iterated;
  this._i = 0;
}, function () {
  var i = this._i++;
  var done = !(i < this._l);
  return { done: done, value: done ? undefined : i };
});


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(13);

$export($export.S + $export.F, 'Object', { classof: __webpack_require__(210) });


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(13);
var define = __webpack_require__(681);

$export($export.S + $export.F, 'Object', { define: define });


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(13);

$export($export.S + $export.F, 'Object', { isObject: __webpack_require__(42) });


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(13);
var define = __webpack_require__(681);
var create = __webpack_require__(160);

$export($export.S + $export.F, 'Object', {
  make: function (proto, mixin) {
    return define(create(proto), mixin);
  }
});


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(13);
var $re = __webpack_require__(477)(/[&<>"']/g, {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&apos;'
});

$export($export.P + $export.F, 'String', { escapeHTML: function escapeHTML() { return $re(this); } });


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(13);
var $re = __webpack_require__(477)(/&(?:amp|lt|gt|quot|apos);/g, {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&apos;': "'"
});

$export($export.P + $export.F, 'String', { unescapeHTML: function unescapeHTML() { return $re(this); } });


/***/ }),
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__(1792);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(166);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf = void 0;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM2.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}

/* https://github.com/component/raf */
var prev = new Date().getTime();
function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);

  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};
compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};
exports.default = compatRaf;
module.exports = exports['default'];

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule AtomicBlockUtils
 * @format
 * 
 */



var _assign = __webpack_require__(36);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var BlockMapBuilder = __webpack_require__(299);
var CharacterMetadata = __webpack_require__(117);
var ContentBlock = __webpack_require__(219);
var ContentBlockNode = __webpack_require__(122);
var DraftFeatureFlags = __webpack_require__(190);
var DraftModifier = __webpack_require__(107);
var EditorState = __webpack_require__(51);
var Immutable = __webpack_require__(45);
var SelectionState = __webpack_require__(259);

var generateRandomKey = __webpack_require__(167);
var moveBlockInContentState = __webpack_require__(1869);

var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;

var List = Immutable.List,
    Repeat = Immutable.Repeat;


var AtomicBlockUtils = {
  insertAtomicBlock: function insertAtomicBlock(editorState, entityKey, character) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();

    var afterRemoval = DraftModifier.removeRange(contentState, selectionState, 'backward');

    var targetSelection = afterRemoval.getSelectionAfter();
    var afterSplit = DraftModifier.splitBlock(afterRemoval, targetSelection);
    var insertionTarget = afterSplit.getSelectionAfter();

    var asAtomicBlock = DraftModifier.setBlockType(afterSplit, insertionTarget, 'atomic');

    var charData = CharacterMetadata.create({ entity: entityKey });

    var atomicBlockConfig = {
      key: generateRandomKey(),
      type: 'atomic',
      text: character,
      characterList: List(Repeat(charData, character.length))
    };

    var atomicDividerBlockConfig = {
      key: generateRandomKey(),
      type: 'unstyled'
    };

    if (experimentalTreeDataSupport) {
      atomicBlockConfig = _extends({}, atomicBlockConfig, {
        nextSibling: atomicDividerBlockConfig.key
      });
      atomicDividerBlockConfig = _extends({}, atomicDividerBlockConfig, {
        prevSibling: atomicBlockConfig.key
      });
    }

    var fragmentArray = [new ContentBlockRecord(atomicBlockConfig), new ContentBlockRecord(atomicDividerBlockConfig)];

    var fragment = BlockMapBuilder.createFromArray(fragmentArray);

    var withAtomicBlock = DraftModifier.replaceWithFragment(asAtomicBlock, insertionTarget, fragment);

    var newContent = withAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withAtomicBlock.getSelectionAfter().set('hasFocus', true)
    });

    return EditorState.push(editorState, newContent, 'insert-fragment');
  },

  moveAtomicBlock: function moveAtomicBlock(editorState, atomicBlock, targetRange, insertionMode) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();

    var withMovedAtomicBlock = void 0;

    if (insertionMode === 'before' || insertionMode === 'after') {
      var targetBlock = contentState.getBlockForKey(insertionMode === 'before' ? targetRange.getStartKey() : targetRange.getEndKey());

      withMovedAtomicBlock = moveBlockInContentState(contentState, atomicBlock, targetBlock, insertionMode);
    } else {
      var afterRemoval = DraftModifier.removeRange(contentState, targetRange, 'backward');

      var selectionAfterRemoval = afterRemoval.getSelectionAfter();
      var _targetBlock = afterRemoval.getBlockForKey(selectionAfterRemoval.getFocusKey());

      if (selectionAfterRemoval.getStartOffset() === 0) {
        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'before');
      } else if (selectionAfterRemoval.getEndOffset() === _targetBlock.getLength()) {
        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'after');
      } else {
        var afterSplit = DraftModifier.splitBlock(afterRemoval, selectionAfterRemoval);

        var selectionAfterSplit = afterSplit.getSelectionAfter();
        var _targetBlock2 = afterSplit.getBlockForKey(selectionAfterSplit.getFocusKey());

        withMovedAtomicBlock = moveBlockInContentState(afterSplit, atomicBlock, _targetBlock2, 'before');
      }
    }

    var newContent = withMovedAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withMovedAtomicBlock.getSelectionAfter().set('hasFocus', true)
    });

    return EditorState.push(editorState, newContent, 'move-block');
  }
};

module.exports = AtomicBlockUtils;

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CompositeDraftDecorator
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Immutable = __webpack_require__(45);

var List = Immutable.List;


var DELIMITER = '.';

/**
 * A CompositeDraftDecorator traverses through a list of DraftDecorator
 * instances to identify sections of a ContentBlock that should be rendered
 * in a "decorated" manner. For example, hashtags, mentions, and links may
 * be intended to stand out visually, be rendered as anchors, etc.
 *
 * The list of decorators supplied to the constructor will be used in the
 * order they are provided. This allows the caller to specify a priority for
 * string matching, in case of match collisions among decorators.
 *
 * For instance, I may have a link with a `#` in its text. Though this section
 * of text may match our hashtag decorator, it should not be treated as a
 * hashtag. I should therefore list my link DraftDecorator
 * before my hashtag DraftDecorator when constructing this composite
 * decorator instance.
 *
 * Thus, when a collision like this is encountered, the earlier match is
 * preserved and the new match is discarded.
 */

var CompositeDraftDecorator = function () {
  function CompositeDraftDecorator(decorators) {
    _classCallCheck(this, CompositeDraftDecorator);

    // Copy the decorator array, since we use this array order to determine
    // precedence of decoration matching. If the array is mutated externally,
    // we don't want to be affected here.
    this._decorators = decorators.slice();
  }

  CompositeDraftDecorator.prototype.getDecorations = function getDecorations(block, contentState) {
    var decorations = Array(block.getText().length).fill(null);

    this._decorators.forEach(function ( /*object*/decorator, /*number*/ii) {
      var counter = 0;
      var strategy = decorator.strategy;
      var callback = function callback( /*number*/start, /*number*/end) {
        // Find out if any of our matching range is already occupied
        // by another decorator. If so, discard the match. Otherwise, store
        // the component key for rendering.
        if (canOccupySlice(decorations, start, end)) {
          occupySlice(decorations, start, end, ii + DELIMITER + counter);
          counter++;
        }
      };
      strategy(block, callback, contentState);
    });

    return List(decorations);
  };

  CompositeDraftDecorator.prototype.getComponentForKey = function getComponentForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].component;
  };

  CompositeDraftDecorator.prototype.getPropsForKey = function getPropsForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].props;
  };

  return CompositeDraftDecorator;
}();

/**
 * Determine whether we can occupy the specified slice of the decorations
 * array.
 */


function canOccupySlice(decorations, start, end) {
  for (var ii = start; ii < end; ii++) {
    if (decorations[ii] != null) {
      return false;
    }
  }
  return true;
}

/**
 * Splice the specified component into our decoration array at the desired
 * range.
 */
function occupySlice(targetArr, start, end, componentKey) {
  for (var ii = start; ii < end; ii++) {
    targetArr[ii] = componentKey;
  }
}

module.exports = CompositeDraftDecorator;

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentStateInlineStyle
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(117);

var _require = __webpack_require__(45),
    Map = _require.Map;

var ContentStateInlineStyle = {
  add: function add(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, true);
  },

  remove: function remove(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, false);
  }
};

function modifyInlineStyle(contentState, selectionState, inlineStyle, addOrRemove) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  var newBlocks = blockMap.skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
    var sliceStart;
    var sliceEnd;

    if (startKey === endKey) {
      sliceStart = startOffset;
      sliceEnd = endOffset;
    } else {
      sliceStart = blockKey === startKey ? startOffset : 0;
      sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    }

    var chars = block.getCharacterList();
    var current;
    while (sliceStart < sliceEnd) {
      current = chars.get(sliceStart);
      chars = chars.set(sliceStart, addOrRemove ? CharacterMetadata.applyStyle(current, inlineStyle) : CharacterMetadata.removeStyle(current, inlineStyle));
      sliceStart++;
    }

    return block.set('characterList', chars);
  });

  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = ContentStateInlineStyle;

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditor.react
 * @format
 * 
 * @preventMunge
 */



var _assign = __webpack_require__(36);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultDraftBlockRenderMap = __webpack_require__(504);
var DefaultDraftInlineStyle = __webpack_require__(750);
var DraftEditorCompositionHandler = __webpack_require__(1813);
var DraftEditorContents = __webpack_require__(1815);
var DraftEditorDragHandler = __webpack_require__(1816);
var DraftEditorEditHandler = __webpack_require__(1817);
var DraftEditorPlaceholder = __webpack_require__(1819);
var EditorState = __webpack_require__(51);
var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(64);
var Scroll = __webpack_require__(836);
var Style = __webpack_require__(533);
var UserAgent = __webpack_require__(148);

var cx = __webpack_require__(264);
var emptyFunction = __webpack_require__(103);
var generateRandomKey = __webpack_require__(167);
var getDefaultKeyBinding = __webpack_require__(757);
var getScrollPosition = __webpack_require__(535);
var invariant = __webpack_require__(23);
var nullthrows = __webpack_require__(136);

var isIE = UserAgent.isBrowser('IE');

// IE does not support the `input` event on contentEditable, so we can't
// observe spellcheck behavior.
var allowSpellCheck = !isIE;

// Define a set of handler objects to correspond to each possible `mode`
// of editor behavior.
var handlerMap = {
  edit: DraftEditorEditHandler,
  composite: DraftEditorCompositionHandler,
  drag: DraftEditorDragHandler,
  cut: null,
  render: null
};

/**
 * `DraftEditor` is the root editor component. It composes a `contentEditable`
 * div, and provides a wide variety of useful function props for managing the
 * state of the editor. See `DraftEditorProps` for details.
 */
var DraftEditor = function (_React$Component) {
  _inherits(DraftEditor, _React$Component);

  function DraftEditor(props) {
    _classCallCheck(this, DraftEditor);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.focus = function (scrollPosition) {
      var editorState = _this.props.editorState;

      var alreadyHasFocus = editorState.getSelection().getHasFocus();
      var editorNode = ReactDOM.findDOMNode(_this.editor);

      if (!editorNode) {
        // once in a while people call 'focus' in a setTimeout, and the node has
        // been deleted, so it can be null in that case.
        return;
      }

      var scrollParent = Style.getScrollParent(editorNode);

      var _ref = scrollPosition || getScrollPosition(scrollParent),
          x = _ref.x,
          y = _ref.y;

      !(editorNode instanceof HTMLElement) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
      editorNode.focus();

      // Restore scroll position
      if (scrollParent === window) {
        window.scrollTo(x, y);
      } else {
        Scroll.setTop(scrollParent, y);
      }

      // On Chrome and Safari, calling focus on contenteditable focuses the
      // cursor at the first character. This is something you don't expect when
      // you're clicking on an input element but not directly on a character.
      // Put the cursor back where it was before the blur.
      if (!alreadyHasFocus) {
        _this.update(EditorState.forceSelection(editorState, editorState.getSelection()));
      }
    };

    _this.blur = function () {
      var editorNode = ReactDOM.findDOMNode(_this.editor);
      !(editorNode instanceof HTMLElement) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
      editorNode.blur();
    };

    _this.setMode = function (mode) {
      _this._handler = handlerMap[mode];
    };

    _this.exitCurrentMode = function () {
      _this.setMode('edit');
    };

    _this.restoreEditorDOM = function (scrollPosition) {
      _this.setState({ contentsKey: _this.state.contentsKey + 1 }, function () {
        _this.focus(scrollPosition);
      });
    };

    _this.setClipboard = function (clipboard) {
      _this._clipboard = clipboard;
    };

    _this.getClipboard = function () {
      return _this._clipboard;
    };

    _this.update = function (editorState) {
      _this._latestEditorState = editorState;
      _this.props.onChange(editorState);
    };

    _this.onDragEnter = function () {
      _this._dragCount++;
    };

    _this.onDragLeave = function () {
      _this._dragCount--;
      if (_this._dragCount === 0) {
        _this.exitCurrentMode();
      }
    };

    _this._blockSelectEvents = false;
    _this._clipboard = null;
    _this._handler = null;
    _this._dragCount = 0;
    _this._editorKey = props.editorKey || generateRandomKey();
    _this._placeholderAccessibilityID = 'placeholder-' + _this._editorKey;
    _this._latestEditorState = props.editorState;
    _this._latestCommittedEditorState = props.editorState;

    _this._onBeforeInput = _this._buildHandler('onBeforeInput');
    _this._onBlur = _this._buildHandler('onBlur');
    _this._onCharacterData = _this._buildHandler('onCharacterData');
    _this._onCompositionEnd = _this._buildHandler('onCompositionEnd');
    _this._onCompositionStart = _this._buildHandler('onCompositionStart');
    _this._onCopy = _this._buildHandler('onCopy');
    _this._onCut = _this._buildHandler('onCut');
    _this._onDragEnd = _this._buildHandler('onDragEnd');
    _this._onDragOver = _this._buildHandler('onDragOver');
    _this._onDragStart = _this._buildHandler('onDragStart');
    _this._onDrop = _this._buildHandler('onDrop');
    _this._onInput = _this._buildHandler('onInput');
    _this._onFocus = _this._buildHandler('onFocus');
    _this._onKeyDown = _this._buildHandler('onKeyDown');
    _this._onKeyPress = _this._buildHandler('onKeyPress');
    _this._onKeyUp = _this._buildHandler('onKeyUp');
    _this._onMouseDown = _this._buildHandler('onMouseDown');
    _this._onMouseUp = _this._buildHandler('onMouseUp');
    _this._onPaste = _this._buildHandler('onPaste');
    _this._onSelect = _this._buildHandler('onSelect');

    _this.getEditorKey = function () {
      return _this._editorKey;
    };

    // See `restoreEditorDOM()`.
    _this.state = { contentsKey: 0 };
    return _this;
  }

  /**
   * Build a method that will pass the event to the specified handler method.
   * This allows us to look up the correct handler function for the current
   * editor mode, if any has been specified.
   */


  /**
   * Define proxies that can route events to the current handler.
   */


  DraftEditor.prototype._buildHandler = function _buildHandler(eventName) {
    var _this2 = this;

    return function (e) {
      if (!_this2.props.readOnly) {
        var method = _this2._handler && _this2._handler[eventName];
        method && method(_this2, e);
      }
    };
  };

  DraftEditor.prototype._showPlaceholder = function _showPlaceholder() {
    return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
  };

  DraftEditor.prototype._renderPlaceholder = function _renderPlaceholder() {
    if (this._showPlaceholder()) {
      var placeHolderProps = {
        text: nullthrows(this.props.placeholder),
        editorState: this.props.editorState,
        textAlignment: this.props.textAlignment,
        accessibilityID: this._placeholderAccessibilityID
      };

      return React.createElement(DraftEditorPlaceholder, placeHolderProps);
    }
    return null;
  };

  DraftEditor.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        blockRenderMap = _props.blockRenderMap,
        blockRendererFn = _props.blockRendererFn,
        blockStyleFn = _props.blockStyleFn,
        customStyleFn = _props.customStyleFn,
        customStyleMap = _props.customStyleMap,
        editorState = _props.editorState,
        readOnly = _props.readOnly,
        textAlignment = _props.textAlignment,
        textDirectionality = _props.textDirectionality;


    var rootClass = cx({
      'DraftEditor/root': true,
      'DraftEditor/alignLeft': textAlignment === 'left',
      'DraftEditor/alignRight': textAlignment === 'right',
      'DraftEditor/alignCenter': textAlignment === 'center'
    });

    var contentStyle = {
      outline: 'none',
      // fix parent-draggable Safari bug. #1326
      userSelect: 'text',
      WebkitUserSelect: 'text',
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word'
    };

    // The aria-expanded and aria-haspopup properties should only be rendered
    // for a combobox.
    var ariaRole = this.props.role || 'textbox';
    var ariaExpanded = ariaRole === 'combobox' ? !!this.props.ariaExpanded : null;

    var editorContentsProps = {
      blockRenderMap: blockRenderMap,
      blockRendererFn: blockRendererFn,
      blockStyleFn: blockStyleFn,
      customStyleMap: _extends({}, DefaultDraftInlineStyle, customStyleMap),
      customStyleFn: customStyleFn,
      editorKey: this._editorKey,
      editorState: editorState,
      key: 'contents' + this.state.contentsKey,
      textDirectionality: textDirectionality
    };

    return React.createElement(
      'div',
      { className: rootClass },
      this._renderPlaceholder(),
      React.createElement(
        'div',
        {
          className: cx('DraftEditor/editorContainer'),
          ref: function ref(_ref3) {
            return _this3.editorContainer = _ref3;
          } },
        React.createElement(
          'div',
          {
            'aria-activedescendant': readOnly ? null : this.props.ariaActiveDescendantID,
            'aria-autocomplete': readOnly ? null : this.props.ariaAutoComplete,
            'aria-controls': readOnly ? null : this.props.ariaControls,
            'aria-describedby': this.props.ariaDescribedBy || this._placeholderAccessibilityID,
            'aria-expanded': readOnly ? null : ariaExpanded,
            'aria-label': this.props.ariaLabel,
            'aria-labelledby': this.props.ariaLabelledBy,
            'aria-multiline': this.props.ariaMultiline,
            autoCapitalize: this.props.autoCapitalize,
            autoComplete: this.props.autoComplete,
            autoCorrect: this.props.autoCorrect,
            className: cx({
              // Chrome's built-in translation feature mutates the DOM in ways
              // that Draft doesn't expect (ex: adding <font> tags inside
              // DraftEditorLeaf spans) and causes problems. We add notranslate
              // here which makes its autotranslation skip over this subtree.
              notranslate: !readOnly,
              'public/DraftEditor/content': true
            }),
            contentEditable: !readOnly,
            'data-testid': this.props.webDriverTestID,
            onBeforeInput: this._onBeforeInput,
            onBlur: this._onBlur,
            onCompositionEnd: this._onCompositionEnd,
            onCompositionStart: this._onCompositionStart,
            onCopy: this._onCopy,
            onCut: this._onCut,
            onDragEnd: this._onDragEnd,
            onDragEnter: this.onDragEnter,
            onDragLeave: this.onDragLeave,
            onDragOver: this._onDragOver,
            onDragStart: this._onDragStart,
            onDrop: this._onDrop,
            onFocus: this._onFocus,
            onInput: this._onInput,
            onKeyDown: this._onKeyDown,
            onKeyPress: this._onKeyPress,
            onKeyUp: this._onKeyUp,
            onMouseUp: this._onMouseUp,
            onPaste: this._onPaste,
            onSelect: this._onSelect,
            ref: function ref(_ref2) {
              return _this3.editor = _ref2;
            },
            role: readOnly ? null : ariaRole,
            spellCheck: allowSpellCheck && this.props.spellCheck,
            style: contentStyle,
            suppressContentEditableWarning: true,
            tabIndex: this.props.tabIndex },
          React.createElement(DraftEditorContents, editorContentsProps)
        )
      )
    );
  };

  DraftEditor.prototype.componentDidMount = function componentDidMount() {
    this.setMode('edit');

    /**
     * IE has a hardcoded "feature" that attempts to convert link text into
     * anchors in contentEditable DOM. This breaks the editor's expectations of
     * the DOM, and control is lost. Disable it to make IE behave.
     * See: http://blogs.msdn.com/b/ieinternals/archive/2010/09/15/
     * ie9-beta-minor-change-list.aspx
     */
    if (isIE) {
      document.execCommand('AutoUrlDetect', false, false);
    }
  };

  /**
   * Prevent selection events from affecting the current editor state. This
   * is mostly intended to defend against IE, which fires off `selectionchange`
   * events regardless of whether the selection is set via the browser or
   * programmatically. We only care about selection events that occur because
   * of browser interaction, not re-renders and forced selections.
   */


  DraftEditor.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    this._blockSelectEvents = true;
    this._latestEditorState = nextProps.editorState;
  };

  DraftEditor.prototype.componentDidUpdate = function componentDidUpdate() {
    this._blockSelectEvents = false;
    this._latestCommittedEditorState = this.props.editorState;
  };

  /**
   * Used via `this.focus()`.
   *
   * Force focus back onto the editor node.
   *
   * We attempt to preserve scroll position when focusing. You can also pass
   * a specified scroll position (for cases like `cut` behavior where it should
   * be restored to a known position).
   */


  /**
   * Used via `this.setMode(...)`.
   *
   * Set the behavior mode for the editor component. This switches the current
   * handler module to ensure that DOM events are managed appropriately for
   * the active mode.
   */


  /**
   * Used via `this.restoreEditorDOM()`.
   *
   * Force a complete re-render of the DraftEditorContents based on the current
   * EditorState. This is useful when we know we are going to lose control of
   * the DOM state (cut command, IME) and we want to make sure that
   * reconciliation occurs on a version of the DOM that is synchronized with
   * our EditorState.
   */


  /**
   * Used via `this.setClipboard(...)`.
   *
   * Set the clipboard state for a cut/copy event.
   */


  /**
   * Used via `this.getClipboard()`.
   *
   * Retrieve the clipboard state for a cut/copy event.
   */


  /**
   * Used via `this.update(...)`.
   *
   * Propagate a new `EditorState` object to higher-level components. This is
   * the method by which event handlers inform the `DraftEditor` component of
   * state changes. A component that composes a `DraftEditor` **must** provide
   * an `onChange` prop to receive state updates passed along from this
   * function.
   */


  /**
   * Used in conjunction with `onDragLeave()`, by counting the number of times
   * a dragged element enters and leaves the editor (or any of its children),
   * to determine when the dragged element absolutely leaves the editor.
   */


  /**
   * See `onDragEnter()`.
   */


  return DraftEditor;
}(React.Component);

DraftEditor.defaultProps = {
  blockRenderMap: DefaultDraftBlockRenderMap,
  blockRendererFn: emptyFunction.thatReturnsNull,
  blockStyleFn: emptyFunction.thatReturns(''),
  keyBindingFn: getDefaultKeyBinding,
  readOnly: false,
  spellCheck: false,
  stripPastedStyles: false
};


module.exports = DraftEditor;

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorCompositionHandler
 * @format
 * 
 */



var DraftFeatureFlags = __webpack_require__(190);
var DraftModifier = __webpack_require__(107);
var EditorState = __webpack_require__(51);
var Keys = __webpack_require__(532);

var getEntityKeyForSelection = __webpack_require__(507);
var isEventHandled = __webpack_require__(301);
var isSelectionAtLeafStart = __webpack_require__(767);

/**
 * Millisecond delay to allow `compositionstart` to fire again upon
 * `compositionend`.
 *
 * This is used for Korean input to ensure that typing can continue without
 * the editor trying to render too quickly. More specifically, Safari 7.1+
 * triggers `compositionstart` a little slower than Chrome/FF, which
 * leads to composed characters being resolved and re-render occurring
 * sooner than we want.
 */
var RESOLVE_DELAY = 20;

/**
 * A handful of variables used to track the current composition and its
 * resolution status. These exist at the module level because it is not
 * possible to have compositions occurring in multiple editors simultaneously,
 * and it simplifies state management with respect to the DraftEditor component.
 */
var resolved = false;
var stillComposing = false;
var textInputData = '';

var DraftEditorCompositionHandler = {
  onBeforeInput: function onBeforeInput(editor, e) {
    textInputData = (textInputData || '') + e.data;
  },

  /**
   * A `compositionstart` event has fired while we're still in composition
   * mode. Continue the current composition session to prevent a re-render.
   */
  onCompositionStart: function onCompositionStart(editor) {
    stillComposing = true;
  },

  /**
   * Attempt to end the current composition session.
   *
   * Defer handling because browser will still insert the chars into active
   * element after `compositionend`. If a `compositionstart` event fires
   * before `resolveComposition` executes, our composition session will
   * continue.
   *
   * The `resolved` flag is useful because certain IME interfaces fire the
   * `compositionend` event multiple times, thus queueing up multiple attempts
   * at handling the composition. Since handling the same composition event
   * twice could break the DOM, we only use the first event. Example: Arabic
   * Google Input Tools on Windows 8.1 fires `compositionend` three times.
   */
  onCompositionEnd: function onCompositionEnd(editor) {
    resolved = false;
    stillComposing = false;
    setTimeout(function () {
      if (!resolved) {
        DraftEditorCompositionHandler.resolveComposition(editor);
      }
    }, RESOLVE_DELAY);
  },

  /**
   * In Safari, keydown events may fire when committing compositions. If
   * the arrow keys are used to commit, prevent default so that the cursor
   * doesn't move, otherwise it will jump back noticeably on re-render.
   */
  onKeyDown: function onKeyDown(editor, e) {
    if (!stillComposing) {
      // If a keydown event is received after compositionend but before the
      // 20ms timer expires (ex: type option-E then backspace, or type A then
      // backspace in 2-Set Korean), we should immediately resolve the
      // composition and reinterpret the key press in edit mode.
      DraftEditorCompositionHandler.resolveComposition(editor);
      editor._onKeyDown(e);
      return;
    }
    if (e.which === Keys.RIGHT || e.which === Keys.LEFT) {
      e.preventDefault();
    }
  },

  /**
   * Keypress events may fire when committing compositions. In Firefox,
   * pressing RETURN commits the composition and inserts extra newline
   * characters that we do not want. `preventDefault` allows the composition
   * to be committed while preventing the extra characters.
   */
  onKeyPress: function onKeyPress(editor, e) {
    if (e.which === Keys.RETURN) {
      e.preventDefault();
    }
  },

  /**
   * Attempt to insert composed characters into the document.
   *
   * If we are still in a composition session, do nothing. Otherwise, insert
   * the characters into the document and terminate the composition session.
   *
   * If no characters were composed -- for instance, the user
   * deleted all composed characters and committed nothing new --
   * force a re-render. We also re-render when the composition occurs
   * at the beginning of a leaf, to ensure that if the browser has
   * created a new text node for the composition, we will discard it.
   *
   * Resetting innerHTML will move focus to the beginning of the editor,
   * so we update to force it back to the correct place.
   */
  resolveComposition: function resolveComposition(editor) {
    if (stillComposing) {
      return;
    }

    resolved = true;
    var composedChars = textInputData;
    textInputData = '';

    var editorState = EditorState.set(editor._latestEditorState, {
      inCompositionMode: false
    });

    var currentStyle = editorState.getCurrentInlineStyle();
    var entityKey = getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection());

    var mustReset = !composedChars || isSelectionAtLeafStart(editorState) || currentStyle.size > 0 || entityKey !== null;

    if (mustReset) {
      editor.restoreEditorDOM();
    }

    editor.exitCurrentMode();

    if (composedChars) {
      if (DraftFeatureFlags.draft_handlebeforeinput_composed_text && editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(composedChars, editorState))) {
        return;
      }
      // If characters have been composed, re-rendering with the update
      // is sufficient to reset the editor.
      var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), composedChars, currentStyle, entityKey);
      editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
      return;
    }

    if (mustReset) {
      editor.update(EditorState.set(editorState, {
        nativelyRenderedContent: null,
        forceSelection: true
      }));
    }
  }
};

module.exports = DraftEditorCompositionHandler;

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorContents-core.react
 * @format
 * 
 */



var _assign = __webpack_require__(36);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DraftEditorBlock = __webpack_require__(751);
var DraftOffsetKey = __webpack_require__(371);
var EditorState = __webpack_require__(51);
var React = __webpack_require__(1);

var cx = __webpack_require__(264);
var joinClasses = __webpack_require__(2344);
var nullthrows = __webpack_require__(136);

/**
 * Provide default styling for list items. This way, lists will be styled with
 * proper counters and indentation even if the caller does not specify
 * their own styling at all. If more than five levels of nesting are needed,
 * the necessary CSS classes can be provided via `blockStyleFn` configuration.
 */
var getListItemClasses = function getListItemClasses(type, depth, shouldResetCount, direction) {
  return cx({
    'public/DraftStyleDefault/unorderedListItem': type === 'unordered-list-item',
    'public/DraftStyleDefault/orderedListItem': type === 'ordered-list-item',
    'public/DraftStyleDefault/reset': shouldResetCount,
    'public/DraftStyleDefault/depth0': depth === 0,
    'public/DraftStyleDefault/depth1': depth === 1,
    'public/DraftStyleDefault/depth2': depth === 2,
    'public/DraftStyleDefault/depth3': depth === 3,
    'public/DraftStyleDefault/depth4': depth === 4,
    'public/DraftStyleDefault/listLTR': direction === 'LTR',
    'public/DraftStyleDefault/listRTL': direction === 'RTL'
  });
};

/**
 * `DraftEditorContents` is the container component for all block components
 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
 * re-rendering blocks whenever possible.
 *
 * This component is separate from `DraftEditor` because certain props
 * (for instance, ARIA props) must be allowed to update without affecting
 * the contents of the editor.
 */

var DraftEditorContents = function (_React$Component) {
  _inherits(DraftEditorContents, _React$Component);

  function DraftEditorContents() {
    _classCallCheck(this, DraftEditorContents);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  DraftEditorContents.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var prevEditorState = this.props.editorState;
    var nextEditorState = nextProps.editorState;

    var prevDirectionMap = prevEditorState.getDirectionMap();
    var nextDirectionMap = nextEditorState.getDirectionMap();

    // Text direction has changed for one or more blocks. We must re-render.
    if (prevDirectionMap !== nextDirectionMap) {
      return true;
    }

    var didHaveFocus = prevEditorState.getSelection().getHasFocus();
    var nowHasFocus = nextEditorState.getSelection().getHasFocus();

    if (didHaveFocus !== nowHasFocus) {
      return true;
    }

    var nextNativeContent = nextEditorState.getNativelyRenderedContent();

    var wasComposing = prevEditorState.isInCompositionMode();
    var nowComposing = nextEditorState.isInCompositionMode();

    // If the state is unchanged or we're currently rendering a natively
    // rendered state, there's nothing new to be done.
    if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
      return false;
    }

    var prevContent = prevEditorState.getCurrentContent();
    var nextContent = nextEditorState.getCurrentContent();
    var prevDecorator = prevEditorState.getDecorator();
    var nextDecorator = nextEditorState.getDecorator();
    return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
  };

  DraftEditorContents.prototype.render = function render() {
    var _props = this.props,
        blockRenderMap = _props.blockRenderMap,
        blockRendererFn = _props.blockRendererFn,
        blockStyleFn = _props.blockStyleFn,
        customStyleMap = _props.customStyleMap,
        customStyleFn = _props.customStyleFn,
        editorState = _props.editorState,
        editorKey = _props.editorKey,
        textDirectionality = _props.textDirectionality;


    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var forceSelection = editorState.mustForceSelection();
    var decorator = editorState.getDecorator();
    var directionMap = nullthrows(editorState.getDirectionMap());

    var blocksAsArray = content.getBlocksAsArray();
    var processedBlocks = [];

    var currentDepth = null;
    var lastWrapperTemplate = null;

    for (var ii = 0; ii < blocksAsArray.length; ii++) {
      var _block = blocksAsArray[ii];
      var key = _block.getKey();
      var blockType = _block.getType();

      var customRenderer = blockRendererFn(_block);
      var CustomComponent = void 0,
          customProps = void 0,
          customEditable = void 0;
      if (customRenderer) {
        CustomComponent = customRenderer.component;
        customProps = customRenderer.props;
        customEditable = customRenderer.editable;
      }

      var direction = textDirectionality ? textDirectionality : directionMap.get(key);
      var offsetKey = DraftOffsetKey.encode(key, 0, 0);
      var componentProps = {
        contentState: content,
        block: _block,
        blockProps: customProps,
        blockStyleFn: blockStyleFn,
        customStyleMap: customStyleMap,
        customStyleFn: customStyleFn,
        decorator: decorator,
        direction: direction,
        forceSelection: forceSelection,
        key: key,
        offsetKey: offsetKey,
        selection: selection,
        tree: editorState.getBlockTree(key)
      };

      var configForType = blockRenderMap.get(blockType) || blockRenderMap.get('unstyled');
      var wrapperTemplate = configForType.wrapper;

      var Element = configForType.element || blockRenderMap.get('unstyled').element;

      var depth = _block.getDepth();
      var className = '';
      if (blockStyleFn) {
        className = blockStyleFn(_block);
      }

      // List items are special snowflakes, since we handle nesting and
      // counters manually.
      if (Element === 'li') {
        var shouldResetCount = lastWrapperTemplate !== wrapperTemplate || currentDepth === null || depth > currentDepth;
        className = joinClasses(className, getListItemClasses(blockType, depth, shouldResetCount, direction));
      }

      var Component = CustomComponent || DraftEditorBlock;
      var childProps = {
        className: className,
        'data-block': true,
        'data-editor': editorKey,
        'data-offset-key': offsetKey,
        key: key
      };
      if (customEditable !== undefined) {
        childProps = _extends({}, childProps, {
          contentEditable: customEditable,
          suppressContentEditableWarning: true
        });
      }

      var child = React.createElement(Element, childProps, React.createElement(Component, componentProps));

      processedBlocks.push({
        block: child,
        wrapperTemplate: wrapperTemplate,
        key: key,
        offsetKey: offsetKey
      });

      if (wrapperTemplate) {
        currentDepth = _block.getDepth();
      } else {
        currentDepth = null;
      }
      lastWrapperTemplate = wrapperTemplate;
    }

    // Group contiguous runs of blocks that have the same wrapperTemplate
    var outputBlocks = [];
    for (var _ii = 0; _ii < processedBlocks.length;) {
      var info = processedBlocks[_ii];
      if (info.wrapperTemplate) {
        var blocks = [];
        do {
          blocks.push(processedBlocks[_ii].block);
          _ii++;
        } while (_ii < processedBlocks.length && processedBlocks[_ii].wrapperTemplate === info.wrapperTemplate);
        var wrapperElement = React.cloneElement(info.wrapperTemplate, {
          key: info.key + '-wrap',
          'data-offset-key': info.offsetKey
        }, blocks);
        outputBlocks.push(wrapperElement);
      } else {
        outputBlocks.push(info.block);
        _ii++;
      }
    }

    return React.createElement(
      'div',
      { 'data-contents': 'true' },
      outputBlocks
    );
  };

  return DraftEditorContents;
}(React.Component);

module.exports = DraftEditorContents;

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorContents.react
 * @format
 * 
 */



var DraftEditorContents = __webpack_require__(1814);

module.exports = DraftEditorContents;

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorDragHandler
 * @format
 * 
 */



var DataTransfer = __webpack_require__(834);
var DraftModifier = __webpack_require__(107);
var EditorState = __webpack_require__(51);

var findAncestorOffsetKey = __webpack_require__(506);
var getTextContentFromFiles = __webpack_require__(764);
var getUpdatedSelectionState = __webpack_require__(765);
var isEventHandled = __webpack_require__(301);
var nullthrows = __webpack_require__(136);

/**
 * Get a SelectionState for the supplied mouse event.
 */
function getSelectionForEvent(event, editorState) {
  var node = null;
  var offset = null;

  if (typeof document.caretRangeFromPoint === 'function') {
    var dropRange = document.caretRangeFromPoint(event.x, event.y);
    node = dropRange.startContainer;
    offset = dropRange.startOffset;
  } else if (event.rangeParent) {
    node = event.rangeParent;
    offset = event.rangeOffset;
  } else {
    return null;
  }

  node = nullthrows(node);
  offset = nullthrows(offset);
  var offsetKey = nullthrows(findAncestorOffsetKey(node));

  return getUpdatedSelectionState(editorState, offsetKey, offset, offsetKey, offset);
}

var DraftEditorDragHandler = {
  /**
   * Drag originating from input terminated.
   */
  onDragEnd: function onDragEnd(editor) {
    editor.exitCurrentMode();
  },

  /**
   * Handle data being dropped.
   */
  onDrop: function onDrop(editor, e) {
    var data = new DataTransfer(e.nativeEvent.dataTransfer);

    var editorState = editor._latestEditorState;
    var dropSelection = getSelectionForEvent(e.nativeEvent, editorState);

    e.preventDefault();
    editor.exitCurrentMode();

    if (dropSelection == null) {
      return;
    }

    var files = data.getFiles();
    if (files.length > 0) {
      if (editor.props.handleDroppedFiles && isEventHandled(editor.props.handleDroppedFiles(dropSelection, files))) {
        return;
      }

      getTextContentFromFiles(files, function (fileText) {
        fileText && editor.update(insertTextAtSelection(editorState, dropSelection, fileText));
      });
      return;
    }

    var dragType = editor._internalDrag ? 'internal' : 'external';
    if (editor.props.handleDrop && isEventHandled(editor.props.handleDrop(dropSelection, data, dragType))) {
      return;
    }

    if (editor._internalDrag) {
      editor.update(moveText(editorState, dropSelection));
      return;
    }

    editor.update(insertTextAtSelection(editorState, dropSelection, data.getText()));
  }
};

function moveText(editorState, targetSelection) {
  var newContentState = DraftModifier.moveText(editorState.getCurrentContent(), editorState.getSelection(), targetSelection);
  return EditorState.push(editorState, newContentState, 'insert-fragment');
}

/**
 * Insert text at a specified selection.
 */
function insertTextAtSelection(editorState, selection, text) {
  var newContentState = DraftModifier.insertText(editorState.getCurrentContent(), selection, text, editorState.getCurrentInlineStyle());
  return EditorState.push(editorState, newContentState, 'insert-fragment');
}

module.exports = DraftEditorDragHandler;

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorEditHandler
 * @format
 * 
 */



var onBeforeInput = __webpack_require__(1836);
var onBlur = __webpack_require__(1837);
var onCompositionStart = __webpack_require__(1838);
var onCopy = __webpack_require__(1839);
var onCut = __webpack_require__(1840);
var onDragOver = __webpack_require__(1841);
var onDragStart = __webpack_require__(1842);
var onFocus = __webpack_require__(1843);
var onInput = __webpack_require__(1844);
var onKeyDown = __webpack_require__(1845);
var onPaste = __webpack_require__(1846);
var onSelect = __webpack_require__(1847);

var DraftEditorEditHandler = {
  onBeforeInput: onBeforeInput,
  onBlur: onBlur,
  onCompositionStart: onCompositionStart,
  onCopy: onCopy,
  onCut: onCut,
  onDragOver: onDragOver,
  onDragStart: onDragStart,
  onFocus: onFocus,
  onInput: onInput,
  onKeyDown: onKeyDown,
  onPaste: onPaste,
  onSelect: onSelect
};

module.exports = DraftEditorEditHandler;

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorLeaf.react
 * @format
 * 
 */



var _assign = __webpack_require__(36);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DraftEditorTextNode = __webpack_require__(1820);
var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(64);

var invariant = __webpack_require__(23);
var setDraftEditorSelection = __webpack_require__(1871);

/**
 * All leaf nodes in the editor are spans with single text nodes. Leaf
 * elements are styled based on the merging of an optional custom style map
 * and a default style map.
 *
 * `DraftEditorLeaf` also provides a wrapper for calling into the imperative
 * DOM Selection API. In this way, top-level components can declaratively
 * maintain the selection state.
 */
var DraftEditorLeaf = function (_React$Component) {
  _inherits(DraftEditorLeaf, _React$Component);

  function DraftEditorLeaf() {
    _classCallCheck(this, DraftEditorLeaf);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  DraftEditorLeaf.prototype._setSelection = function _setSelection() {
    var selection = this.props.selection;

    // If selection state is irrelevant to the parent block, no-op.

    if (selection == null || !selection.getHasFocus()) {
      return;
    }

    var _props = this.props,
        block = _props.block,
        start = _props.start,
        text = _props.text;

    var blockKey = block.getKey();
    var end = start + text.length;
    if (!selection.hasEdgeWithin(blockKey, start, end)) {
      return;
    }

    // Determine the appropriate target node for selection. If the child
    // is not a text node, it is a <br /> spacer. In this case, use the
    // <span> itself as the selection target.
    var node = ReactDOM.findDOMNode(this);
    !node ?  false ? invariant(false, 'Missing node') : invariant(false) : void 0;
    var child = node.firstChild;
    !child ?  false ? invariant(false, 'Missing child') : invariant(false) : void 0;
    var targetNode = void 0;

    if (child.nodeType === Node.TEXT_NODE) {
      targetNode = child;
    } else if (child.tagName === 'BR') {
      targetNode = node;
    } else {
      targetNode = child.firstChild;
      !targetNode ?  false ? invariant(false, 'Missing targetNode') : invariant(false) : void 0;
    }

    setDraftEditorSelection(selection, targetNode, blockKey, start, end);
  };
  /**
   * By making individual leaf instances aware of their context within
   * the text of the editor, we can set our selection range more
   * easily than we could in the non-React world.
   *
   * Note that this depends on our maintaining tight control over the
   * DOM structure of the DraftEditor component. If leaves had multiple
   * text nodes, this would be harder.
   */

  DraftEditorLeaf.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var leafNode = ReactDOM.findDOMNode(this.leaf);
    !leafNode ?  false ? invariant(false, 'Missing leafNode') : invariant(false) : void 0;
    return leafNode.textContent !== nextProps.text || nextProps.styleSet !== this.props.styleSet || nextProps.forceSelection;
  };

  DraftEditorLeaf.prototype.componentDidUpdate = function componentDidUpdate() {
    this._setSelection();
  };

  DraftEditorLeaf.prototype.componentDidMount = function componentDidMount() {
    this._setSelection();
  };

  DraftEditorLeaf.prototype.render = function render() {
    var _this2 = this;

    var block = this.props.block;
    var text = this.props.text;

    // If the leaf is at the end of its block and ends in a soft newline, append
    // an extra line feed character. Browsers collapse trailing newline
    // characters, which leaves the cursor in the wrong place after a
    // shift+enter. The extra character repairs this.

    if (text.endsWith('\n') && this.props.isLast) {
      text += '\n';
    }

    var _props2 = this.props,
        customStyleMap = _props2.customStyleMap,
        customStyleFn = _props2.customStyleFn,
        offsetKey = _props2.offsetKey,
        styleSet = _props2.styleSet;

    var styleObj = styleSet.reduce(function (map, styleName) {
      var mergedStyles = {};
      var style = customStyleMap[styleName];

      if (style !== undefined && map.textDecoration !== style.textDecoration) {
        // .trim() is necessary for IE9/10/11 and Edge
        mergedStyles.textDecoration = [map.textDecoration, style.textDecoration].join(' ').trim();
      }

      return _assign(map, style, mergedStyles);
    }, {});

    if (customStyleFn) {
      var newStyles = customStyleFn(styleSet, block);
      styleObj = _assign(styleObj, newStyles);
    }

    return React.createElement(
      'span',
      {
        'data-offset-key': offsetKey,
        ref: function ref(_ref) {
          return _this2.leaf = _ref;
        },
        style: styleObj },
      React.createElement(
        DraftEditorTextNode,
        null,
        text
      )
    );
  };

  return DraftEditorLeaf;
}(React.Component);

module.exports = DraftEditorLeaf;

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorPlaceholder.react
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var cx = __webpack_require__(264);

/**
 * This component is responsible for rendering placeholder text for the
 * `DraftEditor` component.
 *
 * Override placeholder style via CSS.
 */
var DraftEditorPlaceholder = function (_React$Component) {
  _inherits(DraftEditorPlaceholder, _React$Component);

  function DraftEditorPlaceholder() {
    _classCallCheck(this, DraftEditorPlaceholder);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  DraftEditorPlaceholder.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.text !== nextProps.text || this.props.editorState.getSelection().getHasFocus() !== nextProps.editorState.getSelection().getHasFocus();
  };

  DraftEditorPlaceholder.prototype.render = function render() {
    var hasFocus = this.props.editorState.getSelection().getHasFocus();

    var className = cx({
      'public/DraftEditorPlaceholder/root': true,
      'public/DraftEditorPlaceholder/hasFocus': hasFocus
    });

    var contentStyle = {
      whiteSpace: 'pre-wrap'
    };

    return React.createElement(
      'div',
      { className: className },
      React.createElement(
        'div',
        {
          className: cx('public/DraftEditorPlaceholder/inner'),
          id: this.props.accessibilityID,
          style: contentStyle },
        this.props.text
      )
    );
  };

  return DraftEditorPlaceholder;
}(React.Component);

module.exports = DraftEditorPlaceholder;

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorTextNode.react
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(64);
var UserAgent = __webpack_require__(148);

var invariant = __webpack_require__(23);

// In IE, spans with <br> tags render as two newlines. By rendering a span
// with only a newline character, we can be sure to render a single line.
var useNewlineChar = UserAgent.isBrowser('IE <= 11');

/**
 * Check whether the node should be considered a newline.
 */
function isNewline(node) {
  return useNewlineChar ? node.textContent === '\n' : node.tagName === 'BR';
}

/**
 * Placeholder elements for empty text content.
 *
 * What is this `data-text` attribute, anyway? It turns out that we need to
 * put an attribute on the lowest-level text node in order to preserve correct
 * spellcheck handling. If the <span> is naked, Chrome and Safari may do
 * bizarre things to do the DOM -- split text nodes, create extra spans, etc.
 * If the <span> has an attribute, this appears not to happen.
 * See http://jsfiddle.net/9khdavod/ for the failure case, and
 * http://jsfiddle.net/7pg143f7/ for the fixed case.
 */
var NEWLINE_A = useNewlineChar ? React.createElement(
  'span',
  { key: 'A', 'data-text': 'true' },
  '\n'
) : React.createElement('br', { key: 'A', 'data-text': 'true' });

var NEWLINE_B = useNewlineChar ? React.createElement(
  'span',
  { key: 'B', 'data-text': 'true' },
  '\n'
) : React.createElement('br', { key: 'B', 'data-text': 'true' });

/**
 * The lowest-level component in a `DraftEditor`, the text node component
 * replaces the default React text node implementation. This allows us to
 * perform custom handling of newline behavior and avoid re-rendering text
 * nodes with DOM state that already matches the expectations of our immutable
 * editor state.
 */
var DraftEditorTextNode = function (_React$Component) {
  _inherits(DraftEditorTextNode, _React$Component);

  function DraftEditorTextNode(props) {
    _classCallCheck(this, DraftEditorTextNode);

    // By flipping this flag, we also keep flipping keys which forces
    // React to remount this node every time it rerenders.
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._forceFlag = false;
    return _this;
  }

  DraftEditorTextNode.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var node = ReactDOM.findDOMNode(this);
    var shouldBeNewline = nextProps.children === '';
    !(node instanceof Element) ?  false ? invariant(false, 'node is not an Element') : invariant(false) : void 0;
    if (shouldBeNewline) {
      return !isNewline(node);
    }
    return node.textContent !== nextProps.children;
  };

  DraftEditorTextNode.prototype.componentDidMount = function componentDidMount() {
    this._forceFlag = !this._forceFlag;
  };

  DraftEditorTextNode.prototype.componentDidUpdate = function componentDidUpdate() {
    this._forceFlag = !this._forceFlag;
  };

  DraftEditorTextNode.prototype.render = function render() {
    if (this.props.children === '') {
      return this._forceFlag ? NEWLINE_A : NEWLINE_B;
    }
    return React.createElement(
      'span',
      { key: this._forceFlag ? 'A' : 'B', 'data-text': 'true' },
      this.props.children
    );
  };

  return DraftEditorTextNode;
}(React.Component);

module.exports = DraftEditorTextNode;

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEntitySegments
 * @format
 * 
 */



/**
 * Identify the range to delete from a segmented entity.
 *
 * Rules:
 *
 *  Example: 'John F. Kennedy'
 *
 *   - Deletion from within any non-whitespace (i.e. ['John', 'F.', 'Kennedy'])
 *     will return the range of that text.
 *
 *       'John F. Kennedy' -> 'John F.'
 *                  ^
 *
 *   - Forward deletion of whitespace will remove the following section:
 *
 *       'John F. Kennedy' -> 'John Kennedy'
 *            ^
 *
 *   - Backward deletion of whitespace will remove the previous section:
 *
 *       'John F. Kennedy' -> 'F. Kennedy'
 *            ^
 */
var DraftEntitySegments = {
  getRemovalRange: function getRemovalRange(selectionStart, selectionEnd, text, entityStart, direction) {
    var segments = text.split(' ');
    segments = segments.map(function ( /*string*/segment, /*number*/ii) {
      if (direction === 'forward') {
        if (ii > 0) {
          return ' ' + segment;
        }
      } else if (ii < segments.length - 1) {
        return segment + ' ';
      }
      return segment;
    });

    var segmentStart = entityStart;
    var segmentEnd;
    var segment;
    var removalStart = null;
    var removalEnd = null;

    for (var jj = 0; jj < segments.length; jj++) {
      segment = segments[jj];
      segmentEnd = segmentStart + segment.length;

      // Our selection overlaps this segment.
      if (selectionStart < segmentEnd && segmentStart < selectionEnd) {
        if (removalStart !== null) {
          removalEnd = segmentEnd;
        } else {
          removalStart = segmentStart;
          removalEnd = segmentEnd;
        }
      } else if (removalStart !== null) {
        break;
      }

      segmentStart = segmentEnd;
    }

    var entityEnd = entityStart + text.length;
    var atStart = removalStart === entityStart;
    var atEnd = removalEnd === entityEnd;

    if (!atStart && atEnd || atStart && !atEnd) {
      if (direction === 'forward') {
        if (removalEnd !== entityEnd) {
          removalEnd++;
        }
      } else if (removalStart !== entityStart) {
        removalStart--;
      }
    }

    return {
      start: removalStart,
      end: removalEnd
    };
  }
};

module.exports = DraftEntitySegments;

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftFeatureFlags-core
 * @format
 * 
 */



var DraftFeatureFlags = {
  draft_killswitch_allow_nontextnodes: false,
  draft_segmented_entities_behavior: false,
  draft_handlebeforeinput_composed_text: false,
  draft_tree_data_support: false
};

module.exports = DraftFeatureFlags;

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftJsDebugLogging
 */



module.exports = {
  logSelectionStateFailure: function logSelectionStateFailure() {
    return null;
  }
};

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftPasteProcessor
 * @format
 * 
 */



var _assign = __webpack_require__(36);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var CharacterMetadata = __webpack_require__(117);
var ContentBlock = __webpack_require__(219);
var ContentBlockNode = __webpack_require__(122);
var DraftFeatureFlags = __webpack_require__(190);
var Immutable = __webpack_require__(45);

var convertFromHTMLtoContentBlocks = __webpack_require__(756);
var generateRandomKey = __webpack_require__(167);
var getSafeBodyFromHTML = __webpack_require__(762);
var sanitizeDraftText = __webpack_require__(509);

var List = Immutable.List,
    Repeat = Immutable.Repeat;


var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;

var DraftPasteProcessor = {
  processHTML: function processHTML(html, blockRenderMap) {
    return convertFromHTMLtoContentBlocks(html, getSafeBodyFromHTML, blockRenderMap);
  },
  processText: function processText(textBlocks, character, type) {
    return textBlocks.reduce(function (acc, textLine, index) {
      textLine = sanitizeDraftText(textLine);
      var key = generateRandomKey();

      var blockNodeConfig = {
        key: key,
        type: type,
        text: textLine,
        characterList: List(Repeat(character, textLine.length))
      };

      // next block updates previous block
      if (experimentalTreeDataSupport && index !== 0) {
        var prevSiblingIndex = index - 1;
        // update previous block
        var previousBlock = acc[prevSiblingIndex] = acc[prevSiblingIndex].merge({
          nextSibling: key
        });
        blockNodeConfig = _extends({}, blockNodeConfig, {
          prevSibling: previousBlock.getKey()
        });
      }

      acc.push(new ContentBlockRecord(blockNodeConfig));

      return acc;
    }, []);
  }
};

module.exports = DraftPasteProcessor;

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(36);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftTreeAdapter
 * @format
 * 
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */

var invariant = __webpack_require__(23);

var traverseInDepthOrder = function traverseInDepthOrder(blocks, fn) {
  var stack = [].concat(blocks).reverse();
  while (stack.length) {
    var _block = stack.pop();

    fn(_block);

    var children = _block.children;

    !Array.isArray(children) ?  false ? invariant(false, 'Invalid tree raw block') : invariant(false) : void 0;

    stack = stack.concat([].concat(children.reverse()));
  }
};

var isListBlock = function isListBlock(block) {
  if (!(block && block.type)) {
    return false;
  }
  var type = block.type;

  return type === 'unordered-list-item' || type === 'ordered-list-item';
};

var addDepthToChildren = function addDepthToChildren(block) {
  if (Array.isArray(block.children)) {
    block.children = block.children.map(function (child) {
      return child.type === block.type ? _extends({}, child, { depth: (block.depth || 0) + 1 }) : child;
    });
  }
};

/**
 * This adapter is intended to be be used as an adapter to draft tree data
 *
 * draft state <=====> draft tree state
 */
var DraftTreeAdapter = {
  /**
   * Converts from a tree raw state back to  draft raw state
   */
  fromRawTreeStateToRawState: function fromRawTreeStateToRawState(draftTreeState) {
    var blocks = draftTreeState.blocks;

    var transformedBlocks = [];

    !Array.isArray(blocks) ?  false ? invariant(false, 'Invalid raw state') : invariant(false) : void 0;

    if (!Array.isArray(blocks) || !blocks.length) {
      return draftTreeState;
    }

    traverseInDepthOrder(blocks, function (block) {
      var newBlock = _extends({}, block);

      if (isListBlock(block)) {
        newBlock.depth = newBlock.depth || 0;
        addDepthToChildren(block);
      }

      delete newBlock.children;

      transformedBlocks.push(newBlock);
    });

    draftTreeState.blocks = transformedBlocks;

    return _extends({}, draftTreeState, {
      blocks: transformedBlocks
    });
  },


  /**
   * Converts from draft raw state to tree draft state
   */
  fromRawStateToRawTreeState: function fromRawStateToRawTreeState(draftState) {
    var lastListDepthCacheRef = {};
    var transformedBlocks = [];

    draftState.blocks.forEach(function (block) {
      var isList = isListBlock(block);
      var depth = block.depth || 0;
      var treeBlock = _extends({}, block, {
        children: []
      });

      if (!isList) {
        // reset the cache path
        lastListDepthCacheRef = {};
        transformedBlocks.push(treeBlock);
        return;
      }

      // update our depth cache reference path
      lastListDepthCacheRef[depth] = treeBlock;

      // if we are greater than zero we must have seen a parent already
      if (depth > 0) {
        var parent = lastListDepthCacheRef[depth - 1];

        !parent ?  false ? invariant(false, 'Invalid depth for RawDraftContentBlock') : invariant(false) : void 0;

        // push nested list blocks
        parent.children.push(treeBlock);
        return;
      }

      // push root list blocks
      transformedBlocks.push(treeBlock);
    });

    return _extends({}, draftState, {
      blocks: transformedBlocks
    });
  }
};

module.exports = DraftTreeAdapter;

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EditorBidiService
 * @format
 * 
 */



var Immutable = __webpack_require__(45);
var UnicodeBidiService = __webpack_require__(2330);

var nullthrows = __webpack_require__(136);

var OrderedMap = Immutable.OrderedMap;


var bidiService;

var EditorBidiService = {
  getDirectionMap: function getDirectionMap(content, prevBidiMap) {
    if (!bidiService) {
      bidiService = new UnicodeBidiService();
    } else {
      bidiService.reset();
    }

    var blockMap = content.getBlockMap();
    var nextBidi = blockMap.valueSeq().map(function (block) {
      return nullthrows(bidiService).getDirection(block.getText());
    });
    var bidiMap = OrderedMap(blockMap.keySeq().zip(nextBidi));

    if (prevBidiMap != null && Immutable.is(prevBidiMap, bidiMap)) {
      return prevBidiMap;
    }

    return bidiMap;
  }
};

module.exports = EditorBidiService;

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SecondaryClipboard
 * @format
 * 
 */



var DraftModifier = __webpack_require__(107);
var EditorState = __webpack_require__(51);

var getContentStateFragment = __webpack_require__(372);
var nullthrows = __webpack_require__(136);

var clipboard = null;

/**
 * Some systems offer a "secondary" clipboard to allow quick internal cut
 * and paste behavior. For instance, Ctrl+K (cut) and Ctrl+Y (paste).
 */
var SecondaryClipboard = {
  cut: function cut(editorState) {
    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var targetRange = null;

    if (selection.isCollapsed()) {
      var anchorKey = selection.getAnchorKey();
      var blockEnd = content.getBlockForKey(anchorKey).getLength();

      if (blockEnd === selection.getAnchorOffset()) {
        return editorState;
      }

      targetRange = selection.set('focusOffset', blockEnd);
    } else {
      targetRange = selection;
    }

    targetRange = nullthrows(targetRange);
    clipboard = getContentStateFragment(content, targetRange);

    var afterRemoval = DraftModifier.removeRange(content, targetRange, 'forward');

    if (afterRemoval === content) {
      return editorState;
    }

    return EditorState.push(editorState, afterRemoval, 'remove-range');
  },

  paste: function paste(editorState) {
    if (!clipboard) {
      return editorState;
    }

    var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), clipboard);

    return EditorState.push(editorState, newContent, 'insert-fragment');
  }
};

module.exports = SecondaryClipboard;

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule adjustBlockDepthForContentState
 * @format
 * 
 */



function adjustBlockDepthForContentState(contentState, selectionState, adjustment, maxDepth) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var blocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat([[endKey, blockMap.get(endKey)]]).map(function (block) {
    var depth = block.getDepth() + adjustment;
    depth = Math.max(0, Math.min(depth, maxDepth));
    return block.set('depth', depth);
  });

  blockMap = blockMap.merge(blocks);

  return contentState.merge({
    blockMap: blockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = adjustBlockDepthForContentState;

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule applyEntityToContentBlock
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(117);

function applyEntityToContentBlock(contentBlock, start, end, entityKey) {
  var characterList = contentBlock.getCharacterList();
  while (start < end) {
    characterList = characterList.set(start, CharacterMetadata.applyEntity(characterList.get(start), entityKey));
    start++;
  }
  return contentBlock.set('characterList', characterList);
}

module.exports = applyEntityToContentBlock;

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule applyEntityToContentState
 * @format
 * 
 */



var Immutable = __webpack_require__(45);

var applyEntityToContentBlock = __webpack_require__(1829);

function applyEntityToContentState(contentState, selectionState, entityKey) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  var newBlocks = blockMap.skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).toOrderedMap().merge(Immutable.OrderedMap([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
    var sliceStart = blockKey === startKey ? startOffset : 0;
    var sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    return applyEntityToContentBlock(block, sliceStart, sliceEnd, entityKey);
  });

  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = applyEntityToContentState;

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule convertFromDraftStateToRaw
 * @format
 * 
 */



var _assign = __webpack_require__(36);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ContentBlock = __webpack_require__(219);
var ContentBlockNode = __webpack_require__(122);
var DraftStringKey = __webpack_require__(754);

var encodeEntityRanges = __webpack_require__(1848);
var encodeInlineStyleRanges = __webpack_require__(1849);
var invariant = __webpack_require__(23);

var createRawBlock = function createRawBlock(block, entityStorageMap) {
  return {
    key: block.getKey(),
    text: block.getText(),
    type: block.getType(),
    depth: block.getDepth(),
    inlineStyleRanges: encodeInlineStyleRanges(block),
    entityRanges: encodeEntityRanges(block, entityStorageMap),
    data: block.getData().toObject()
  };
};

var insertRawBlock = function insertRawBlock(block, entityMap, rawBlocks, blockCacheRef) {
  if (block instanceof ContentBlock) {
    rawBlocks.push(createRawBlock(block, entityMap));
    return;
  }

  !(block instanceof ContentBlockNode) ?  false ? invariant(false, 'block is not a BlockNode') : invariant(false) : void 0;

  var parentKey = block.getParentKey();
  var rawBlock = blockCacheRef[block.getKey()] = _extends({}, createRawBlock(block, entityMap), {
    children: []
  });

  if (parentKey) {
    blockCacheRef[parentKey].children.push(rawBlock);
    return;
  }

  rawBlocks.push(rawBlock);
};

var encodeRawBlocks = function encodeRawBlocks(contentState, rawState) {
  var entityMap = rawState.entityMap;


  var rawBlocks = [];

  var blockCacheRef = {};
  var entityCacheRef = {};
  var entityStorageKey = 0;

  contentState.getBlockMap().forEach(function (block) {
    block.findEntityRanges(function (character) {
      return character.getEntity() !== null;
    }, function (start) {
      var entityKey = block.getEntityAt(start);
      // Stringify to maintain order of otherwise numeric keys.
      var stringifiedEntityKey = DraftStringKey.stringify(entityKey);
      // This makes this function resilient to two entities
      // erroneously having the same key
      if (entityCacheRef[stringifiedEntityKey]) {
        return;
      }
      entityCacheRef[stringifiedEntityKey] = entityKey;
      // we need the `any` casting here since this is a temporary state
      // where we will later on flip the entity map and populate it with
      // real entity, at this stage we just need to map back the entity
      // key used by the BlockNode
      entityMap[stringifiedEntityKey] = '' + entityStorageKey;
      entityStorageKey++;
    });

    insertRawBlock(block, entityMap, rawBlocks, blockCacheRef);
  });

  return {
    blocks: rawBlocks,
    entityMap: entityMap
  };
};

// Flip storage map so that our storage keys map to global
// DraftEntity keys.
var encodeRawEntityMap = function encodeRawEntityMap(contentState, rawState) {
  var blocks = rawState.blocks,
      entityMap = rawState.entityMap;


  var rawEntityMap = {};

  Object.keys(entityMap).forEach(function (key, index) {
    var entity = contentState.getEntity(DraftStringKey.unstringify(key));
    rawEntityMap[index] = {
      type: entity.getType(),
      mutability: entity.getMutability(),
      data: entity.getData()
    };
  });

  return {
    blocks: blocks,
    entityMap: rawEntityMap
  };
};

var convertFromDraftStateToRaw = function convertFromDraftStateToRaw(contentState) {
  var rawDraftContentState = {
    entityMap: {},
    blocks: []
  };

  // add blocks
  rawDraftContentState = encodeRawBlocks(contentState, rawDraftContentState);

  // add entities
  rawDraftContentState = encodeRawEntityMap(contentState, rawDraftContentState);

  return rawDraftContentState;
};

module.exports = convertFromDraftStateToRaw;

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule convertFromRawToDraftState
 * @format
 * 
 */



var _assign = __webpack_require__(36);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ContentBlock = __webpack_require__(219);
var ContentBlockNode = __webpack_require__(122);
var ContentState = __webpack_require__(503);
var DraftEntity = __webpack_require__(370);
var DraftFeatureFlags = __webpack_require__(190);
var DraftTreeAdapter = __webpack_require__(1825);
var Immutable = __webpack_require__(45);
var SelectionState = __webpack_require__(259);

var createCharacterList = __webpack_require__(1833);
var decodeEntityRanges = __webpack_require__(1834);
var decodeInlineStyleRanges = __webpack_require__(1835);
var generateRandomKey = __webpack_require__(167);
var invariant = __webpack_require__(23);

var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;

var List = Immutable.List,
    Map = Immutable.Map,
    OrderedMap = Immutable.OrderedMap;


var decodeBlockNodeConfig = function decodeBlockNodeConfig(block, entityMap) {
  var key = block.key,
      type = block.type,
      data = block.data,
      text = block.text,
      depth = block.depth;


  var blockNodeConfig = {
    text: text,
    depth: depth || 0,
    type: type || 'unstyled',
    key: key || generateRandomKey(),
    data: Map(data),
    characterList: decodeCharacterList(block, entityMap)
  };

  return blockNodeConfig;
};

var decodeCharacterList = function decodeCharacterList(block, entityMap) {
  var text = block.text,
      rawEntityRanges = block.entityRanges,
      rawInlineStyleRanges = block.inlineStyleRanges;


  var entityRanges = rawEntityRanges || [];
  var inlineStyleRanges = rawInlineStyleRanges || [];

  // Translate entity range keys to the DraftEntity map.
  return createCharacterList(decodeInlineStyleRanges(text, inlineStyleRanges), decodeEntityRanges(text, entityRanges.filter(function (range) {
    return entityMap.hasOwnProperty(range.key);
  }).map(function (range) {
    return _extends({}, range, { key: entityMap[range.key] });
  })));
};

var addKeyIfMissing = function addKeyIfMissing(block) {
  return _extends({}, block, {
    key: block.key || generateRandomKey()
  });
};

/**
 * Node stack is responsible to ensure we traverse the tree only once
 * in depth order, while also providing parent refs to inner nodes to
 * construct their links.
 */
var updateNodeStack = function updateNodeStack(stack, nodes, parentRef) {
  var nodesWithParentRef = nodes.map(function (block) {
    return _extends({}, block, {
      parentRef: parentRef
    });
  });

  // since we pop nodes from the stack we need to insert them in reverse
  return stack.concat(nodesWithParentRef.reverse());
};

/**
 * This will build a tree draft content state by creating the node
 * reference links into a single tree walk. Each node has a link
 * reference to "parent", "children", "nextSibling" and "prevSibling"
 * blockMap will be created using depth ordering.
 */
var decodeContentBlockNodes = function decodeContentBlockNodes(blocks, entityMap) {
  return blocks
  // ensure children have valid keys to enable sibling links
  .map(addKeyIfMissing).reduce(function (blockMap, block, index) {
    !Array.isArray(block.children) ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0;

    // ensure children have valid keys to enable sibling links
    var children = block.children.map(addKeyIfMissing);

    // root level nodes
    var contentBlockNode = new ContentBlockNode(_extends({}, decodeBlockNodeConfig(block, entityMap), {
      prevSibling: index === 0 ? null : blocks[index - 1].key,
      nextSibling: index === blocks.length - 1 ? null : blocks[index + 1].key,
      children: List(children.map(function (child) {
        return child.key;
      }))
    }));

    // push root node to blockMap
    blockMap = blockMap.set(contentBlockNode.getKey(), contentBlockNode);

    // this stack is used to ensure we visit all nodes respecting depth ordering
    var stack = updateNodeStack([], children, contentBlockNode);

    // start computing children nodes
    while (stack.length > 0) {
      // we pop from the stack and start processing this node
      var node = stack.pop();

      // parentRef already points to a converted ContentBlockNode
      var parentRef = node.parentRef;
      var siblings = parentRef.getChildKeys();
      var _index = siblings.indexOf(node.key);
      var isValidBlock = Array.isArray(node.children);

      if (!isValidBlock) {
        !isValidBlock ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0;
        break;
      }

      // ensure children have valid keys to enable sibling links
      var _children = node.children.map(addKeyIfMissing);

      var _contentBlockNode = new ContentBlockNode(_extends({}, decodeBlockNodeConfig(node, entityMap), {
        parent: parentRef.getKey(),
        children: List(_children.map(function (child) {
          return child.key;
        })),
        prevSibling: _index === 0 ? null : siblings.get(_index - 1),
        nextSibling: _index === siblings.size - 1 ? null : siblings.get(_index + 1)
      }));

      // push node to blockMap
      blockMap = blockMap.set(_contentBlockNode.getKey(), _contentBlockNode);

      // this stack is used to ensure we visit all nodes respecting depth ordering
      stack = updateNodeStack(stack, _children, _contentBlockNode);
    }

    return blockMap;
  }, OrderedMap());
};

var decodeContentBlocks = function decodeContentBlocks(blocks, entityMap) {
  return OrderedMap(blocks.map(function (block) {
    var contentBlock = new ContentBlock(decodeBlockNodeConfig(block, entityMap));
    return [contentBlock.getKey(), contentBlock];
  }));
};

var decodeRawBlocks = function decodeRawBlocks(rawState, entityMap) {
  var isTreeRawBlock = Array.isArray(rawState.blocks[0].children);
  var rawBlocks = experimentalTreeDataSupport && !isTreeRawBlock ? DraftTreeAdapter.fromRawStateToRawTreeState(rawState).blocks : rawState.blocks;

  if (!experimentalTreeDataSupport) {
    return decodeContentBlocks(isTreeRawBlock ? DraftTreeAdapter.fromRawTreeStateToRawState(rawState).blocks : rawBlocks, entityMap);
  }

  return decodeContentBlockNodes(rawBlocks, entityMap);
};

var decodeRawEntityMap = function decodeRawEntityMap(rawState) {
  var rawEntityMap = rawState.entityMap;

  var entityMap = {};

  // TODO: Update this once we completely remove DraftEntity
  Object.keys(rawEntityMap).forEach(function (rawEntityKey) {
    var _rawEntityMap$rawEnti = rawEntityMap[rawEntityKey],
        type = _rawEntityMap$rawEnti.type,
        mutability = _rawEntityMap$rawEnti.mutability,
        data = _rawEntityMap$rawEnti.data;

    // get the key reference to created entity

    entityMap[rawEntityKey] = DraftEntity.__create(type, mutability, data || {});
  });

  return entityMap;
};

var convertFromRawToDraftState = function convertFromRawToDraftState(rawState) {
  !Array.isArray(rawState.blocks) ?  false ? invariant(false, 'invalid RawDraftContentState') : invariant(false) : void 0;

  // decode entities
  var entityMap = decodeRawEntityMap(rawState);

  // decode blockMap
  var blockMap = decodeRawBlocks(rawState, entityMap);

  // create initial selection
  var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());

  return new ContentState({
    blockMap: blockMap,
    entityMap: entityMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
};

module.exports = convertFromRawToDraftState;

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule createCharacterList
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(117);
var Immutable = __webpack_require__(45);

var List = Immutable.List;


function createCharacterList(inlineStyles, entities) {
  var characterArray = inlineStyles.map(function (style, ii) {
    var entity = entities[ii];
    return CharacterMetadata.create({ style: style, entity: entity });
  });
  return List(characterArray);
}

module.exports = createCharacterList;

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule decodeEntityRanges
 * @format
 * 
 */



var UnicodeUtils = __webpack_require__(232);

var substr = UnicodeUtils.substr;

/**
 * Convert to native JavaScript string lengths to determine ranges.
 */

function decodeEntityRanges(text, ranges) {
  var entities = Array(text.length).fill(null);
  if (ranges) {
    ranges.forEach(function (range) {
      // Using Unicode-enabled substrings converted to JavaScript lengths,
      // fill the output array with entity keys.
      var start = substr(text, 0, range.offset).length;
      var end = start + substr(text, range.offset, range.length).length;
      for (var ii = start; ii < end; ii++) {
        entities[ii] = range.key;
      }
    });
  }
  return entities;
}

module.exports = decodeEntityRanges;

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule decodeInlineStyleRanges
 * @format
 * 
 */



var _require = __webpack_require__(45),
    OrderedSet = _require.OrderedSet;

var UnicodeUtils = __webpack_require__(232);

var substr = UnicodeUtils.substr;


var EMPTY_SET = OrderedSet();

/**
 * Convert to native JavaScript string lengths to determine ranges.
 */
function decodeInlineStyleRanges(text, ranges) {
  var styles = Array(text.length).fill(EMPTY_SET);
  if (ranges) {
    ranges.forEach(function ( /*object*/range) {
      var cursor = substr(text, 0, range.offset).length;
      var end = cursor + substr(text, range.offset, range.length).length;
      while (cursor < end) {
        styles[cursor] = styles[cursor].add(range.style);
        cursor++;
      }
    });
  }
  return styles;
}

module.exports = decodeInlineStyleRanges;

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnBeforeInput
 * @format
 * 
 */



var BlockTree = __webpack_require__(749);
var DraftModifier = __webpack_require__(107);
var EditorState = __webpack_require__(51);
var UserAgent = __webpack_require__(148);

var getEntityKeyForSelection = __webpack_require__(507);
var isEventHandled = __webpack_require__(301);
var isSelectionAtLeafStart = __webpack_require__(767);
var nullthrows = __webpack_require__(136);
var setImmediate = __webpack_require__(2346);

// When nothing is focused, Firefox regards two characters, `'` and `/`, as
// commands that should open and focus the "quickfind" search bar. This should
// *never* happen while a contenteditable is focused, but as of v28, it
// sometimes does, even when the keypress event target is the contenteditable.
// This breaks the input. Special case these characters to ensure that when
// they are typed, we prevent default on the event to make sure not to
// trigger quickfind.
var FF_QUICKFIND_CHAR = "'";
var FF_QUICKFIND_LINK_CHAR = '/';
var isFirefox = UserAgent.isBrowser('Firefox');

function mustPreventDefaultForCharacter(character) {
  return isFirefox && (character == FF_QUICKFIND_CHAR || character == FF_QUICKFIND_LINK_CHAR);
}

/**
 * Replace the current selection with the specified text string, with the
 * inline style and entity key applied to the newly inserted text.
 */
function replaceText(editorState, text, inlineStyle, entityKey) {
  var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), text, inlineStyle, entityKey);
  return EditorState.push(editorState, contentState, 'insert-characters');
}

/**
 * When `onBeforeInput` executes, the browser is attempting to insert a
 * character into the editor. Apply this character data to the document,
 * allowing native insertion if possible.
 *
 * Native insertion is encouraged in order to limit re-rendering and to
 * preserve spellcheck highlighting, which disappears or flashes if re-render
 * occurs on the relevant text nodes.
 */
function editOnBeforeInput(editor, e) {
  if (editor._pendingStateFromBeforeInput !== undefined) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = undefined;
  }

  var editorState = editor._latestEditorState;

  var chars = e.data;

  // In some cases (ex: IE ideographic space insertion) no character data
  // is provided. There's nothing to do when this happens.
  if (!chars) {
    return;
  }

  // Allow the top-level component to handle the insertion manually. This is
  // useful when triggering interesting behaviors for a character insertion,
  // Simple examples: replacing a raw text ':)' with a smile emoji or image
  // decorator, or setting a block to be a list item after typing '- ' at the
  // start of the block.
  if (editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(chars, editorState))) {
    e.preventDefault();
    return;
  }

  // If selection is collapsed, conditionally allow native behavior. This
  // reduces re-renders and preserves spellcheck highlighting. If the selection
  // is not collapsed, we will re-render.
  var selection = editorState.getSelection();
  var selectionStart = selection.getStartOffset();
  var selectionEnd = selection.getEndOffset();
  var anchorKey = selection.getAnchorKey();

  if (!selection.isCollapsed()) {
    e.preventDefault();

    // If the currently selected text matches what the user is trying to
    // replace it with, let's just update the `SelectionState`. If not, update
    // the `ContentState` with the new text.
    var currentlySelectedChars = editorState.getCurrentContent().getPlainText().slice(selectionStart, selectionEnd);
    if (chars === currentlySelectedChars) {
      editor.update(EditorState.forceSelection(editorState, selection.merge({
        focusOffset: selectionEnd
      })));
    } else {
      editor.update(replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())));
    }
    return;
  }

  var newEditorState = replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection()));

  // Bunch of different cases follow where we need to prevent native insertion.
  var mustPreventNative = false;
  if (!mustPreventNative) {
    // Browsers tend to insert text in weird places in the DOM when typing at
    // the start of a leaf, so we'll handle it ourselves.
    mustPreventNative = isSelectionAtLeafStart(editor._latestCommittedEditorState);
  }
  if (!mustPreventNative) {
    // Chrome will also split up a node into two pieces if it contains a Tab
    // char, for no explicable reason. Seemingly caused by this commit:
    // https://chromium.googlesource.com/chromium/src/+/013ac5eaf3%5E%21/
    var nativeSelection = global.getSelection();
    // Selection is necessarily collapsed at this point due to earlier check.
    if (nativeSelection.anchorNode && nativeSelection.anchorNode.nodeType === Node.TEXT_NODE) {
      // See isTabHTMLSpanElement in chromium EditingUtilities.cpp.
      var parentNode = nativeSelection.anchorNode.parentNode;
      mustPreventNative = parentNode.nodeName === 'SPAN' && parentNode.firstChild.nodeType === Node.TEXT_NODE && parentNode.firstChild.nodeValue.indexOf('\t') !== -1;
    }
  }
  if (!mustPreventNative) {
    // Check the old and new "fingerprints" of the current block to determine
    // whether this insertion requires any addition or removal of text nodes,
    // in which case we would prevent the native character insertion.
    var originalFingerprint = BlockTree.getFingerprint(editorState.getBlockTree(anchorKey));
    var newFingerprint = BlockTree.getFingerprint(newEditorState.getBlockTree(anchorKey));
    mustPreventNative = originalFingerprint !== newFingerprint;
  }
  if (!mustPreventNative) {
    mustPreventNative = mustPreventDefaultForCharacter(chars);
  }
  if (!mustPreventNative) {
    mustPreventNative = nullthrows(newEditorState.getDirectionMap()).get(anchorKey) !== nullthrows(editorState.getDirectionMap()).get(anchorKey);
  }

  if (mustPreventNative) {
    e.preventDefault();
    editor.update(newEditorState);
    return;
  }

  // We made it all the way! Let the browser do its thing and insert the char.
  newEditorState = EditorState.set(newEditorState, {
    nativelyRenderedContent: newEditorState.getCurrentContent()
  });
  // The native event is allowed to occur. To allow user onChange handlers to
  // change the inserted text, we wait until the text is actually inserted
  // before we actually update our state. That way when we rerender, the text
  // we see in the DOM will already have been inserted properly.
  editor._pendingStateFromBeforeInput = newEditorState;
  setImmediate(function () {
    if (editor._pendingStateFromBeforeInput !== undefined) {
      editor.update(editor._pendingStateFromBeforeInput);
      editor._pendingStateFromBeforeInput = undefined;
    }
  });
}

module.exports = editOnBeforeInput;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74)))

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnBlur
 * @format
 * 
 */



var EditorState = __webpack_require__(51);

var containsNode = __webpack_require__(385);
var getActiveElement = __webpack_require__(387);

function editOnBlur(editor, e) {
  // In a contentEditable element, when you select a range and then click
  // another active element, this does trigger a `blur` event but will not
  // remove the DOM selection from the contenteditable.
  // This is consistent across all browsers, but we prefer that the editor
  // behave like a textarea, where a `blur` event clears the DOM selection.
  // We therefore force the issue to be certain, checking whether the active
  // element is `body` to force it when blurring occurs within the window (as
  // opposed to clicking to another tab or window).
  if (getActiveElement() === document.body) {
    var _selection = global.getSelection();
    var editorNode = editor.editor;
    if (_selection.rangeCount === 1 && containsNode(editorNode, _selection.anchorNode) && containsNode(editorNode, _selection.focusNode)) {
      _selection.removeAllRanges();
    }
  }

  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();
  if (!currentSelection.getHasFocus()) {
    return;
  }

  var selection = currentSelection.set('hasFocus', false);
  editor.props.onBlur && editor.props.onBlur(e);
  editor.update(EditorState.acceptSelection(editorState, selection));
}

module.exports = editOnBlur;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74)))

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnCompositionStart
 * @format
 * 
 */



var EditorState = __webpack_require__(51);

/**
 * The user has begun using an IME input system. Switching to `composite` mode
 * allows handling composition input and disables other edit behavior.
 */
function editOnCompositionStart(editor, e) {
  editor.setMode('composite');
  editor.update(EditorState.set(editor._latestEditorState, { inCompositionMode: true }));
  // Allow composition handler to interpret the compositionstart event
  editor._onCompositionStart(e);
}

module.exports = editOnCompositionStart;

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnCopy
 * @format
 * 
 */



var getFragmentFromSelection = __webpack_require__(759);

/**
 * If we have a selection, create a ContentState fragment and store
 * it in our internal clipboard. Subsequent paste events will use this
 * fragment if no external clipboard data is supplied.
 */
function editOnCopy(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection();

  // No selection, so there's nothing to copy.
  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  }

  editor.setClipboard(getFragmentFromSelection(editor._latestEditorState));
}

module.exports = editOnCopy;

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnCut
 * @format
 * 
 */



var DraftModifier = __webpack_require__(107);
var EditorState = __webpack_require__(51);
var Style = __webpack_require__(533);

var getFragmentFromSelection = __webpack_require__(759);
var getScrollPosition = __webpack_require__(535);

/**
 * On `cut` events, native behavior is allowed to occur so that the system
 * clipboard is set properly. This means that we need to take steps to recover
 * the editor DOM state after the `cut` has occurred in order to maintain
 * control of the component.
 *
 * In addition, we can keep a copy of the removed fragment, including all
 * styles and entities, for use as an internal paste.
 */
function editOnCut(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection();
  var element = e.target;
  var scrollPosition = void 0;

  // No selection, so there's nothing to cut.
  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  }

  // Track the current scroll position so that it can be forced back in place
  // after the editor regains control of the DOM.
  if (element instanceof Node) {
    scrollPosition = getScrollPosition(Style.getScrollParent(element));
  }

  var fragment = getFragmentFromSelection(editorState);
  editor.setClipboard(fragment);

  // Set `cut` mode to disable all event handling temporarily.
  editor.setMode('cut');

  // Let native `cut` behavior occur, then recover control.
  setTimeout(function () {
    editor.restoreEditorDOM(scrollPosition);
    editor.exitCurrentMode();
    editor.update(removeFragment(editorState));
  }, 0);
}

function removeFragment(editorState) {
  var newContent = DraftModifier.removeRange(editorState.getCurrentContent(), editorState.getSelection(), 'forward');
  return EditorState.push(editorState, newContent, 'remove-range');
}

module.exports = editOnCut;

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnDragOver
 * @format
 * 
 */



/**
 * Drag behavior has begun from outside the editor element.
 */
function editOnDragOver(editor, e) {
  editor._internalDrag = false;
  editor.setMode('drag');
  e.preventDefault();
}

module.exports = editOnDragOver;

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnDragStart
 * @format
 * 
 */



/**
 * A `dragstart` event has begun within the text editor component.
 */
function editOnDragStart(editor) {
  editor._internalDrag = true;
  editor.setMode('drag');
}

module.exports = editOnDragStart;

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnFocus
 * @format
 * 
 */



var EditorState = __webpack_require__(51);
var UserAgent = __webpack_require__(148);

function editOnFocus(editor, e) {
  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();
  if (currentSelection.getHasFocus()) {
    return;
  }

  var selection = currentSelection.set('hasFocus', true);
  editor.props.onFocus && editor.props.onFocus(e);

  // When the tab containing this text editor is hidden and the user does a
  // find-in-page in a _different_ tab, Chrome on Mac likes to forget what the
  // selection was right after sending this focus event and (if you let it)
  // moves the cursor back to the beginning of the editor, so we force the
  // selection here instead of simply accepting it in order to preserve the
  // old cursor position. See https://crbug.com/540004.
  // But it looks like this is fixed in Chrome 60.0.3081.0.
  // Other browsers also don't have this bug, so we prefer to acceptSelection
  // when possible, to ensure that unfocusing and refocusing a Draft editor
  // doesn't preserve the selection, matching how textareas work.
  if (UserAgent.isBrowser('Chrome < 60.0.3081.0')) {
    editor.update(EditorState.forceSelection(editorState, selection));
  } else {
    editor.update(EditorState.acceptSelection(editorState, selection));
  }
}

module.exports = editOnFocus;

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnInput
 * @format
 * 
 */



var DraftFeatureFlags = __webpack_require__(190);
var DraftModifier = __webpack_require__(107);
var DraftOffsetKey = __webpack_require__(371);
var EditorState = __webpack_require__(51);
var UserAgent = __webpack_require__(148);

var findAncestorOffsetKey = __webpack_require__(506);
var nullthrows = __webpack_require__(136);

var isGecko = UserAgent.isEngine('Gecko');

var DOUBLE_NEWLINE = '\n\n';

/**
 * This function is intended to handle spellcheck and autocorrect changes,
 * which occur in the DOM natively without any opportunity to observe or
 * interpret the changes before they occur.
 *
 * The `input` event fires in contentEditable elements reliably for non-IE
 * browsers, immediately after changes occur to the editor DOM. Since our other
 * handlers override or otherwise handle cover other varieties of text input,
 * the DOM state should match the model in all controlled input cases. Thus,
 * when an `input` change leads to a DOM/model mismatch, the change should be
 * due to a spellcheck change, and we can incorporate it into our model.
 */
function editOnInput(editor) {
  if (editor._pendingStateFromBeforeInput !== undefined) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = undefined;
  }

  var domSelection = global.getSelection();

  var anchorNode = domSelection.anchorNode,
      isCollapsed = domSelection.isCollapsed;

  var isNotTextNode = anchorNode.nodeType !== Node.TEXT_NODE;
  var isNotTextOrElementNode = anchorNode.nodeType !== Node.TEXT_NODE && anchorNode.nodeType !== Node.ELEMENT_NODE;

  if (DraftFeatureFlags.draft_killswitch_allow_nontextnodes) {
    if (isNotTextNode) {
      return;
    }
  } else {
    if (isNotTextOrElementNode) {
      // TODO: (t16149272) figure out context for this change
      return;
    }
  }

  if (anchorNode.nodeType === Node.TEXT_NODE && (anchorNode.previousSibling !== null || anchorNode.nextSibling !== null)) {
    // When typing at the beginning of a visual line, Chrome splits the text
    // nodes into two. Why? No one knows. This commit is suspicious:
    // https://chromium.googlesource.com/chromium/src/+/a3b600981286b135632371477f902214c55a1724
    // To work around, we'll merge the sibling text nodes back into this one.
    var span = anchorNode.parentNode;
    anchorNode.nodeValue = span.textContent;
    for (var child = span.firstChild; child !== null; child = child.nextSibling) {
      if (child !== anchorNode) {
        span.removeChild(child);
      }
    }
  }

  var domText = anchorNode.textContent;
  var editorState = editor._latestEditorState;
  var offsetKey = nullthrows(findAncestorOffsetKey(anchorNode));

  var _DraftOffsetKey$decod = DraftOffsetKey.decode(offsetKey),
      blockKey = _DraftOffsetKey$decod.blockKey,
      decoratorKey = _DraftOffsetKey$decod.decoratorKey,
      leafKey = _DraftOffsetKey$decod.leafKey;

  var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]),
      start = _editorState$getBlock.start,
      end = _editorState$getBlock.end;

  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var modelText = block.getText().slice(start, end);

  // Special-case soft newlines here. If the DOM text ends in a soft newline,
  // we will have manually inserted an extra soft newline in DraftEditorLeaf.
  // We want to remove this extra newline for the purpose of our comparison
  // of DOM and model text.
  if (domText.endsWith(DOUBLE_NEWLINE)) {
    domText = domText.slice(0, -1);
  }

  // No change -- the DOM is up to date. Nothing to do here.
  if (domText === modelText) {
    // This can be buggy for some Android keyboards because they don't fire
    // standard onkeydown/pressed events and only fired editOnInput
    // so domText is already changed by the browser and ends up being equal
    // to modelText unexpectedly
    return;
  }

  var selection = editorState.getSelection();

  // We'll replace the entire leaf with the text content of the target.
  var targetRange = selection.merge({
    anchorOffset: start,
    focusOffset: end,
    isBackward: false
  });

  var entityKey = block.getEntityAt(start);
  var entity = entityKey && content.getEntity(entityKey);
  var entityType = entity && entity.getMutability();
  var preserveEntity = entityType === 'MUTABLE';

  // Immutable or segmented entities cannot properly be handled by the
  // default browser undo, so we have to use a different change type to
  // force using our internal undo method instead of falling through to the
  // native browser undo.
  var changeType = preserveEntity ? 'spellcheck-change' : 'apply-entity';

  var newContent = DraftModifier.replaceText(content, targetRange, domText, block.getInlineStyleAt(start), preserveEntity ? block.getEntityAt(start) : null);

  var anchorOffset, focusOffset, startOffset, endOffset;

  if (isGecko) {
    // Firefox selection does not change while the context menu is open, so
    // we preserve the anchor and focus values of the DOM selection.
    anchorOffset = domSelection.anchorOffset;
    focusOffset = domSelection.focusOffset;
    startOffset = start + Math.min(anchorOffset, focusOffset);
    endOffset = startOffset + Math.abs(anchorOffset - focusOffset);
    anchorOffset = startOffset;
    focusOffset = endOffset;
  } else {
    // Browsers other than Firefox may adjust DOM selection while the context
    // menu is open, and Safari autocorrect is prone to providing an inaccurate
    // DOM selection. Don't trust it. Instead, use our existing SelectionState
    // and adjust it based on the number of characters changed during the
    // mutation.
    var charDelta = domText.length - modelText.length;
    startOffset = selection.getStartOffset();
    endOffset = selection.getEndOffset();

    anchorOffset = isCollapsed ? endOffset + charDelta : startOffset;
    focusOffset = endOffset + charDelta;
  }

  // Segmented entities are completely or partially removed when their
  // text content changes. For this case we do not want any text to be selected
  // after the change, so we are not merging the selection.
  var contentWithAdjustedDOMSelection = newContent.merge({
    selectionBefore: content.getSelectionAfter(),
    selectionAfter: selection.merge({ anchorOffset: anchorOffset, focusOffset: focusOffset })
  });

  editor.update(EditorState.push(editorState, contentWithAdjustedDOMSelection, changeType));
}

module.exports = editOnInput;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74)))

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnKeyDown
 * @format
 * 
 */



var DraftModifier = __webpack_require__(107);
var EditorState = __webpack_require__(51);
var KeyBindingUtil = __webpack_require__(505);
var Keys = __webpack_require__(532);
var SecondaryClipboard = __webpack_require__(1827);
var UserAgent = __webpack_require__(148);

var isEventHandled = __webpack_require__(301);
var keyCommandBackspaceToStartOfLine = __webpack_require__(1858);
var keyCommandBackspaceWord = __webpack_require__(1859);
var keyCommandDeleteWord = __webpack_require__(1860);
var keyCommandInsertNewline = __webpack_require__(1861);
var keyCommandMoveSelectionToEndOfBlock = __webpack_require__(1862);
var keyCommandMoveSelectionToStartOfBlock = __webpack_require__(1863);
var keyCommandPlainBackspace = __webpack_require__(1864);
var keyCommandPlainDelete = __webpack_require__(1865);
var keyCommandTransposeCharacters = __webpack_require__(1866);
var keyCommandUndo = __webpack_require__(1867);

var isOptionKeyCommand = KeyBindingUtil.isOptionKeyCommand;

var isChrome = UserAgent.isBrowser('Chrome');

/**
 * Map a `DraftEditorCommand` command value to a corresponding function.
 */
function onKeyCommand(command, editorState) {
  switch (command) {
    case 'redo':
      return EditorState.redo(editorState);
    case 'delete':
      return keyCommandPlainDelete(editorState);
    case 'delete-word':
      return keyCommandDeleteWord(editorState);
    case 'backspace':
      return keyCommandPlainBackspace(editorState);
    case 'backspace-word':
      return keyCommandBackspaceWord(editorState);
    case 'backspace-to-start-of-line':
      return keyCommandBackspaceToStartOfLine(editorState);
    case 'split-block':
      return keyCommandInsertNewline(editorState);
    case 'transpose-characters':
      return keyCommandTransposeCharacters(editorState);
    case 'move-selection-to-start-of-block':
      return keyCommandMoveSelectionToStartOfBlock(editorState);
    case 'move-selection-to-end-of-block':
      return keyCommandMoveSelectionToEndOfBlock(editorState);
    case 'secondary-cut':
      return SecondaryClipboard.cut(editorState);
    case 'secondary-paste':
      return SecondaryClipboard.paste(editorState);
    default:
      return editorState;
  }
}

/**
 * Intercept keydown behavior to handle keys and commands manually, if desired.
 *
 * Keydown combinations may be mapped to `DraftCommand` values, which may
 * correspond to command functions that modify the editor or its contents.
 *
 * See `getDefaultKeyBinding` for defaults. Alternatively, the top-level
 * component may provide a custom mapping via the `keyBindingFn` prop.
 */
function editOnKeyDown(editor, e) {
  var keyCode = e.which;
  var editorState = editor._latestEditorState;

  switch (keyCode) {
    case Keys.RETURN:
      e.preventDefault();
      // The top-level component may manually handle newline insertion. If
      // no special handling is performed, fall through to command handling.
      if (editor.props.handleReturn && isEventHandled(editor.props.handleReturn(e, editorState))) {
        return;
      }
      break;
    case Keys.ESC:
      e.preventDefault();
      editor.props.onEscape && editor.props.onEscape(e);
      return;
    case Keys.TAB:
      editor.props.onTab && editor.props.onTab(e);
      return;
    case Keys.UP:
      editor.props.onUpArrow && editor.props.onUpArrow(e);
      return;
    case Keys.RIGHT:
      editor.props.onRightArrow && editor.props.onRightArrow(e);
      return;
    case Keys.DOWN:
      editor.props.onDownArrow && editor.props.onDownArrow(e);
      return;
    case Keys.LEFT:
      editor.props.onLeftArrow && editor.props.onLeftArrow(e);
      return;
    case Keys.SPACE:
      // Handling for OSX where option + space scrolls.
      if (isChrome && isOptionKeyCommand(e)) {
        e.preventDefault();
        // Insert a nbsp into the editor.
        var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), '\xA0');
        editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
        return;
      }
  }

  var command = editor.props.keyBindingFn(e);

  // If no command is specified, allow keydown event to continue.
  if (!command) {
    return;
  }

  if (command === 'undo') {
    // Since undo requires some special updating behavior to keep the editor
    // in sync, handle it separately.
    keyCommandUndo(e, editorState, editor.update);
    return;
  }

  // At this point, we know that we're handling a command of some kind, so
  // we don't want to insert a character following the keydown.
  e.preventDefault();

  // Allow components higher up the tree to handle the command first.
  if (editor.props.handleKeyCommand && isEventHandled(editor.props.handleKeyCommand(command, editorState))) {
    return;
  }

  var newState = onKeyCommand(command, editorState);
  if (newState !== editorState) {
    editor.update(newState);
  }
}

module.exports = editOnKeyDown;

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnPaste
 * @format
 * 
 */



var BlockMapBuilder = __webpack_require__(299);
var CharacterMetadata = __webpack_require__(117);
var DataTransfer = __webpack_require__(834);
var DraftModifier = __webpack_require__(107);
var DraftPasteProcessor = __webpack_require__(1824);
var EditorState = __webpack_require__(51);
var RichTextEditorUtil = __webpack_require__(755);

var getEntityKeyForSelection = __webpack_require__(507);
var getTextContentFromFiles = __webpack_require__(764);
var isEventHandled = __webpack_require__(301);
var splitTextIntoTextBlocks = __webpack_require__(1873);

/**
 * Paste content.
 */
function editOnPaste(editor, e) {
  e.preventDefault();
  var data = new DataTransfer(e.clipboardData);

  // Get files, unless this is likely to be a string the user wants inline.
  if (!data.isRichText()) {
    var files = data.getFiles();
    var defaultFileText = data.getText();
    if (files.length > 0) {
      // Allow customized paste handling for images, etc. Otherwise, fall
      // through to insert text contents into the editor.
      if (editor.props.handlePastedFiles && isEventHandled(editor.props.handlePastedFiles(files))) {
        return;
      }

      getTextContentFromFiles(files, function ( /*string*/fileText) {
        fileText = fileText || defaultFileText;
        if (!fileText) {
          return;
        }

        var editorState = editor._latestEditorState;
        var blocks = splitTextIntoTextBlocks(fileText);
        var character = CharacterMetadata.create({
          style: editorState.getCurrentInlineStyle(),
          entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
        });
        var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);

        var text = DraftPasteProcessor.processText(blocks, character, currentBlockType);
        var fragment = BlockMapBuilder.createFromArray(text);

        var withInsertedText = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);

        editor.update(EditorState.push(editorState, withInsertedText, 'insert-fragment'));
      });

      return;
    }
  }

  var textBlocks = [];
  var text = data.getText();
  var html = data.getHTML();
  var editorState = editor._latestEditorState;

  if (editor.props.handlePastedText && isEventHandled(editor.props.handlePastedText(text, html, editorState))) {
    return;
  }

  if (text) {
    textBlocks = splitTextIntoTextBlocks(text);
  }

  if (!editor.props.stripPastedStyles) {
    // If the text from the paste event is rich content that matches what we
    // already have on the internal clipboard, assume that we should just use
    // the clipboard fragment for the paste. This will allow us to preserve
    // styling and entities, if any are present. Note that newlines are
    // stripped during comparison -- this is because copy/paste within the
    // editor in Firefox and IE will not include empty lines. The resulting
    // paste will preserve the newlines correctly.
    var internalClipboard = editor.getClipboard();
    if (data.isRichText() && internalClipboard) {
      if (
      // If the editorKey is present in the pasted HTML, it should be safe to
      // assume this is an internal paste.
      html.indexOf(editor.getEditorKey()) !== -1 ||
      // The copy may have been made within a single block, in which case the
      // editor key won't be part of the paste. In this case, just check
      // whether the pasted text matches the internal clipboard.
      textBlocks.length === 1 && internalClipboard.size === 1 && internalClipboard.first().getText() === text) {
        editor.update(insertFragment(editor._latestEditorState, internalClipboard));
        return;
      }
    } else if (internalClipboard && data.types.includes('com.apple.webarchive') && !data.types.includes('text/html') && areTextBlocksAndClipboardEqual(textBlocks, internalClipboard)) {
      // Safari does not properly store text/html in some cases.
      // Use the internalClipboard if present and equal to what is on
      // the clipboard. See https://bugs.webkit.org/show_bug.cgi?id=19893.
      editor.update(insertFragment(editor._latestEditorState, internalClipboard));
      return;
    }

    // If there is html paste data, try to parse that.
    if (html) {
      var htmlFragment = DraftPasteProcessor.processHTML(html, editor.props.blockRenderMap);
      if (htmlFragment) {
        var contentBlocks = htmlFragment.contentBlocks,
            entityMap = htmlFragment.entityMap;

        if (contentBlocks) {
          var htmlMap = BlockMapBuilder.createFromArray(contentBlocks);
          editor.update(insertFragment(editor._latestEditorState, htmlMap, entityMap));
          return;
        }
      }
    }

    // Otherwise, create a new fragment from our pasted text. Also
    // empty the internal clipboard, since it's no longer valid.
    editor.setClipboard(null);
  }

  if (textBlocks.length) {
    var character = CharacterMetadata.create({
      style: editorState.getCurrentInlineStyle(),
      entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
    });

    var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);

    var textFragment = DraftPasteProcessor.processText(textBlocks, character, currentBlockType);

    var textMap = BlockMapBuilder.createFromArray(textFragment);
    editor.update(insertFragment(editor._latestEditorState, textMap));
  }
}

function insertFragment(editorState, fragment, entityMap) {
  var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
  // TODO: merge the entity map once we stop using DraftEntity
  // like this:
  // const mergedEntityMap = newContent.getEntityMap().merge(entityMap);

  return EditorState.push(editorState, newContent.set('entityMap', entityMap), 'insert-fragment');
}

function areTextBlocksAndClipboardEqual(textBlocks, blockMap) {
  return textBlocks.length === blockMap.size && blockMap.valueSeq().every(function (block, ii) {
    return block.getText() === textBlocks[ii];
  });
}

module.exports = editOnPaste;

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnSelect
 * @format
 * 
 */



var EditorState = __webpack_require__(51);
var ReactDOM = __webpack_require__(64);

var getDraftEditorSelection = __webpack_require__(1852);
var invariant = __webpack_require__(23);

function editOnSelect(editor) {
  if (editor._blockSelectEvents || editor._latestEditorState !== editor.props.editorState) {
    return;
  }

  var editorState = editor.props.editorState;
  var editorNode = ReactDOM.findDOMNode(editor.editorContainer);
  !editorNode ?  false ? invariant(false, 'Missing editorNode') : invariant(false) : void 0;
  !(editorNode.firstChild instanceof HTMLElement) ?  false ? invariant(false, 'editorNode.firstChild is not an HTMLElement') : invariant(false) : void 0;
  var documentSelection = getDraftEditorSelection(editorState, editorNode.firstChild);
  var updatedSelectionState = documentSelection.selectionState;

  if (updatedSelectionState !== editorState.getSelection()) {
    if (documentSelection.needsRecovery) {
      editorState = EditorState.forceSelection(editorState, updatedSelectionState);
    } else {
      editorState = EditorState.acceptSelection(editorState, updatedSelectionState);
    }
    editor.update(editorState);
  }
}

module.exports = editOnSelect;

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule encodeEntityRanges
 * @format
 * 
 */



var DraftStringKey = __webpack_require__(754);
var UnicodeUtils = __webpack_require__(232);

var strlen = UnicodeUtils.strlen;

/**
 * Convert to UTF-8 character counts for storage.
 */

function encodeEntityRanges(block, storageMap) {
  var encoded = [];
  block.findEntityRanges(function (character) {
    return !!character.getEntity();
  }, function ( /*number*/start, /*number*/end) {
    var text = block.getText();
    var key = block.getEntityAt(start);
    encoded.push({
      offset: strlen(text.slice(0, start)),
      length: strlen(text.slice(start, end)),
      // Encode the key as a number for range storage.
      key: Number(storageMap[DraftStringKey.stringify(key)])
    });
  });
  return encoded;
}

module.exports = encodeEntityRanges;

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule encodeInlineStyleRanges
 * @format
 * 
 */



var UnicodeUtils = __webpack_require__(232);

var findRangesImmutable = __webpack_require__(300);

var areEqual = function areEqual(a, b) {
  return a === b;
};
var isTruthy = function isTruthy(a) {
  return !!a;
};
var EMPTY_ARRAY = [];

/**
 * Helper function for getting encoded styles for each inline style. Convert
 * to UTF-8 character counts for storage.
 */
function getEncodedInlinesForType(block, styleList, styleToEncode) {
  var ranges = [];

  // Obtain an array with ranges for only the specified style.
  var filteredInlines = styleList.map(function (style) {
    return style.has(styleToEncode);
  }).toList();

  findRangesImmutable(filteredInlines, areEqual,
  // We only want to keep ranges with nonzero style values.
  isTruthy, function (start, end) {
    var text = block.getText();
    ranges.push({
      offset: UnicodeUtils.strlen(text.slice(0, start)),
      length: UnicodeUtils.strlen(text.slice(start, end)),
      style: styleToEncode
    });
  });

  return ranges;
}

/*
 * Retrieve the encoded arrays of inline styles, with each individual style
 * treated separately.
 */
function encodeInlineStyleRanges(block) {
  var styleList = block.getCharacterList().map(function (c) {
    return c.getStyle();
  }).toList();
  var ranges = styleList.flatten().toSet().map(function (style) {
    return getEncodedInlinesForType(block, styleList, style);
  });

  return Array.prototype.concat.apply(EMPTY_ARRAY, ranges.toJS());
}

module.exports = encodeInlineStyleRanges;

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule expandRangeToStartOfLine
 * @format
 * 
 */

var UnicodeUtils = __webpack_require__(232);

var getRangeClientRects = __webpack_require__(761);
var invariant = __webpack_require__(23);

/**
 * Return the computed line height, in pixels, for the provided element.
 */
function getLineHeightPx(element) {
  var computed = getComputedStyle(element);
  var div = document.createElement('div');
  div.style.fontFamily = computed.fontFamily;
  div.style.fontSize = computed.fontSize;
  div.style.fontStyle = computed.fontStyle;
  div.style.fontWeight = computed.fontWeight;
  div.style.lineHeight = computed.lineHeight;
  div.style.position = 'absolute';
  div.textContent = 'M';

  var documentBody = document.body;
  !documentBody ?  false ? invariant(false, 'Missing document.body') : invariant(false) : void 0;

  // forced layout here
  documentBody.appendChild(div);
  var rect = div.getBoundingClientRect();
  documentBody.removeChild(div);

  return rect.height;
}

/**
 * Return whether every ClientRect in the provided list lies on the same line.
 *
 * We assume that the rects on the same line all contain the baseline, so the
 * lowest top line needs to be above the highest bottom line (i.e., if you were
 * to project the rects onto the y-axis, their intersection would be nonempty).
 *
 * In addition, we require that no two boxes are lineHeight (or more) apart at
 * either top or bottom, which helps protect against false positives for fonts
 * with extremely large glyph heights (e.g., with a font size of 17px, Zapfino
 * produces rects of height 58px!).
 */
function areRectsOnOneLine(rects, lineHeight) {
  var minTop = Infinity;
  var minBottom = Infinity;
  var maxTop = -Infinity;
  var maxBottom = -Infinity;

  for (var ii = 0; ii < rects.length; ii++) {
    var rect = rects[ii];
    if (rect.width === 0 || rect.width === 1) {
      // When a range starts or ends a soft wrap, many browsers (Chrome, IE,
      // Safari) include an empty rect on the previous or next line. When the
      // text lies in a container whose position is not integral (e.g., from
      // margin: auto), Safari makes these empty rects have width 1 (instead of
      // 0). Having one-pixel-wide characters seems unlikely (and most browsers
      // report widths in subpixel precision anyway) so it's relatively safe to
      // skip over them.
      continue;
    }
    minTop = Math.min(minTop, rect.top);
    minBottom = Math.min(minBottom, rect.bottom);
    maxTop = Math.max(maxTop, rect.top);
    maxBottom = Math.max(maxBottom, rect.bottom);
  }

  return maxTop <= minBottom && maxTop - minTop < lineHeight && maxBottom - minBottom < lineHeight;
}

/**
 * Return the length of a node, as used by Range offsets.
 */
function getNodeLength(node) {
  // http://www.w3.org/TR/dom/#concept-node-length
  switch (node.nodeType) {
    case Node.DOCUMENT_TYPE_NODE:
      return 0;
    case Node.TEXT_NODE:
    case Node.PROCESSING_INSTRUCTION_NODE:
    case Node.COMMENT_NODE:
      return node.length;
    default:
      return node.childNodes.length;
  }
}

/**
 * Given a collapsed range, move the start position backwards as far as
 * possible while the range still spans only a single line.
 */
function expandRangeToStartOfLine(range) {
  !range.collapsed ?  false ? invariant(false, 'expandRangeToStartOfLine: Provided range is not collapsed.') : invariant(false) : void 0;
  range = range.cloneRange();

  var containingElement = range.startContainer;
  if (containingElement.nodeType !== 1) {
    containingElement = containingElement.parentNode;
  }
  var lineHeight = getLineHeightPx(containingElement);

  // Imagine our text looks like:
  //   <div><span>once upon a time, there was a <em>boy
  //   who lived</em> </span><q><strong>under^ the
  //   stairs</strong> in a small closet.</q></div>
  // where the caret represents the cursor. First, we crawl up the tree until
  // the range spans multiple lines (setting the start point to before
  // "<strong>", then before "<div>"), then at each level we do a search to
  // find the latest point which is still on a previous line. We'll find that
  // the break point is inside the span, then inside the <em>, then in its text
  // node child, the actual break point before "who".

  var bestContainer = range.endContainer;
  var bestOffset = range.endOffset;
  range.setStart(range.startContainer, 0);

  while (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
    bestContainer = range.startContainer;
    bestOffset = range.startOffset;
    !bestContainer.parentNode ?  false ? invariant(false, 'Found unexpected detached subtree when traversing.') : invariant(false) : void 0;
    range.setStartBefore(bestContainer);
    if (bestContainer.nodeType === 1 && getComputedStyle(bestContainer).display !== 'inline') {
      // The start of the line is never in a different block-level container.
      break;
    }
  }

  // In the above example, range now spans from "<div>" to "under",
  // bestContainer is <div>, and bestOffset is 1 (index of <q> inside <div>)].
  // Picking out which child to recurse into here is a special case since we
  // don't want to check past <q> -- once we find that the final range starts
  // in <span>, we can look at all of its children (and all of their children)
  // to find the break point.

  // At all times, (bestContainer, bestOffset) is the latest single-line start
  // point that we know of.
  var currentContainer = bestContainer;
  var maxIndexToConsider = bestOffset - 1;

  do {
    var nodeValue = currentContainer.nodeValue;

    for (var ii = maxIndexToConsider; ii >= 0; ii--) {
      if (nodeValue != null && ii > 0 && UnicodeUtils.isSurrogatePair(nodeValue, ii - 1)) {
        // We're in the middle of a surrogate pair -- skip over so we never
        // return a range with an endpoint in the middle of a code point.
        continue;
      }

      range.setStart(currentContainer, ii);
      if (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
        bestContainer = currentContainer;
        bestOffset = ii;
      } else {
        break;
      }
    }

    if (ii === -1 || currentContainer.childNodes.length === 0) {
      // If ii === -1, then (bestContainer, bestOffset), which is equal to
      // (currentContainer, 0), was a single-line start point but a start
      // point before currentContainer wasn't, so the line break seems to
      // have occurred immediately after currentContainer's start tag
      //
      // If currentContainer.childNodes.length === 0, we're already at a
      // terminal node (e.g., text node) and should return our current best.
      break;
    }

    currentContainer = currentContainer.childNodes[ii];
    maxIndexToConsider = getNodeLength(currentContainer);
  } while (true);

  range.setStart(bestContainer, bestOffset);
  return range;
}

module.exports = expandRangeToStartOfLine;

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getCharacterRemovalRange
 * @format
 * 
 */



var DraftEntitySegments = __webpack_require__(1821);

var getRangesForDraftEntity = __webpack_require__(1854);
var invariant = __webpack_require__(23);

/**
 * Given a SelectionState and a removal direction, determine the entire range
 * that should be removed from a ContentState. This is based on any entities
 * within the target, with their `mutability` values taken into account.
 *
 * For instance, if we are attempting to remove part of an "immutable" entity
 * range, the entire entity must be removed. The returned `SelectionState`
 * will be adjusted accordingly.
 */
function getCharacterRemovalRange(entityMap, startBlock, endBlock, selectionState, direction) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();
  var startEntityKey = startBlock.getEntityAt(start);
  var endEntityKey = endBlock.getEntityAt(end - 1);
  if (!startEntityKey && !endEntityKey) {
    return selectionState;
  }
  var newSelectionState = selectionState;
  if (startEntityKey && startEntityKey === endEntityKey) {
    newSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, true, true);
  } else if (startEntityKey && endEntityKey) {
    var startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
    var endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
    newSelectionState = newSelectionState.merge({
      anchorOffset: startSelectionState.getAnchorOffset(),
      focusOffset: endSelectionState.getFocusOffset(),
      isBackward: false
    });
  } else if (startEntityKey) {
    var _startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
    newSelectionState = newSelectionState.merge({
      anchorOffset: _startSelectionState.getStartOffset(),
      isBackward: false
    });
  } else if (endEntityKey) {
    var _endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
    newSelectionState = newSelectionState.merge({
      focusOffset: _endSelectionState.getEndOffset(),
      isBackward: false
    });
  }
  return newSelectionState;
}

function getEntityRemovalRange(entityMap, block, selectionState, direction, entityKey, isEntireSelectionWithinEntity, isEntityAtStart) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();
  var entity = entityMap.__get(entityKey);
  var mutability = entity.getMutability();
  var sideToConsider = isEntityAtStart ? start : end;

  // `MUTABLE` entities can just have the specified range of text removed
  // directly. No adjustments are needed.
  if (mutability === 'MUTABLE') {
    return selectionState;
  }

  // Find the entity range that overlaps with our removal range.
  var entityRanges = getRangesForDraftEntity(block, entityKey).filter(function (range) {
    return sideToConsider <= range.end && sideToConsider >= range.start;
  });

  !(entityRanges.length == 1) ?  false ? invariant(false, 'There should only be one entity range within this removal range.') : invariant(false) : void 0;

  var entityRange = entityRanges[0];

  // For `IMMUTABLE` entity types, we will remove the entire entity range.
  if (mutability === 'IMMUTABLE') {
    return selectionState.merge({
      anchorOffset: entityRange.start,
      focusOffset: entityRange.end,
      isBackward: false
    });
  }

  // For `SEGMENTED` entity types, determine the appropriate segment to
  // remove.
  if (!isEntireSelectionWithinEntity) {
    if (isEntityAtStart) {
      end = entityRange.end;
    } else {
      start = entityRange.start;
    }
  }

  var removalRange = DraftEntitySegments.getRemovalRange(start, end, block.getText().slice(entityRange.start, entityRange.end), entityRange.start, direction);

  return selectionState.merge({
    anchorOffset: removalRange.start,
    focusOffset: removalRange.end,
    isBackward: false
  });
}

module.exports = getCharacterRemovalRange;

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getDraftEditorSelection
 * @format
 * 
 */



var getDraftEditorSelectionWithNodes = __webpack_require__(758);

/**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */
function getDraftEditorSelection(editorState, root) {
  var selection = global.getSelection();

  // No active selection.
  if (selection.rangeCount === 0) {
    return {
      selectionState: editorState.getSelection().set('hasFocus', false),
      needsRecovery: false
    };
  }

  return getDraftEditorSelectionWithNodes(editorState, root, selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
}

module.exports = getDraftEditorSelection;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74)))

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getRangeBoundingClientRect
 * @format
 * 
 */



var getRangeClientRects = __webpack_require__(761);

/**
 * Like range.getBoundingClientRect() but normalizes for browser bugs.
 */
function getRangeBoundingClientRect(range) {
  // "Return a DOMRect object describing the smallest rectangle that includes
  // the first rectangle in list and all of the remaining rectangles of which
  // the height or width is not zero."
  // http://www.w3.org/TR/cssom-view/#dom-range-getboundingclientrect
  var rects = getRangeClientRects(range);
  var top = 0;
  var right = 0;
  var bottom = 0;
  var left = 0;

  if (rects.length) {
    // If the first rectangle has 0 width, we use the second, this is needed
    // because Chrome renders a 0 width rectangle when the selection contains
    // a line break.
    if (rects.length > 1 && rects[0].width === 0) {
      var _rects$ = rects[1];
      top = _rects$.top;
      right = _rects$.right;
      bottom = _rects$.bottom;
      left = _rects$.left;
    } else {
      var _rects$2 = rects[0];
      top = _rects$2.top;
      right = _rects$2.right;
      bottom = _rects$2.bottom;
      left = _rects$2.left;
    }

    for (var ii = 1; ii < rects.length; ii++) {
      var rect = rects[ii];
      if (rect.height !== 0 && rect.width !== 0) {
        top = Math.min(top, rect.top);
        right = Math.max(right, rect.right);
        bottom = Math.max(bottom, rect.bottom);
        left = Math.min(left, rect.left);
      }
    }
  }

  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: right - left,
    height: bottom - top
  };
}

module.exports = getRangeBoundingClientRect;

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getRangesForDraftEntity
 * @format
 * 
 */



var invariant = __webpack_require__(23);

/**
 * Obtain the start and end positions of the range that has the
 * specified entity applied to it.
 *
 * Entity keys are applied only to contiguous stretches of text, so this
 * method searches for the first instance of the entity key and returns
 * the subsequent range.
 */
function getRangesForDraftEntity(block, key) {
  var ranges = [];
  block.findEntityRanges(function (c) {
    return c.getEntity() === key;
  }, function (start, end) {
    ranges.push({ start: start, end: end });
  });

  !!!ranges.length ?  false ? invariant(false, 'Entity key not found in this range.') : invariant(false) : void 0;

  return ranges;
}

module.exports = getRangesForDraftEntity;

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getVisibleSelectionRect
 * @format
 * 
 */



var getRangeBoundingClientRect = __webpack_require__(1853);

/**
 * Return the bounding ClientRect for the visible DOM selection, if any.
 * In cases where there are no selected ranges or the bounding rect is
 * temporarily invalid, return null.
 */
function getVisibleSelectionRect(global) {
  var selection = global.getSelection();
  if (!selection.rangeCount) {
    return null;
  }

  var range = selection.getRangeAt(0);
  var boundingRect = getRangeBoundingClientRect(range);
  var top = boundingRect.top,
      right = boundingRect.right,
      bottom = boundingRect.bottom,
      left = boundingRect.left;

  // When a re-render leads to a node being removed, the DOM selection will
  // temporarily be placed on an ancestor node, which leads to an invalid
  // bounding rect. Discard this state.

  if (top === 0 && right === 0 && bottom === 0 && left === 0) {
    return null;
  }

  return boundingRect;
}

module.exports = getVisibleSelectionRect;

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule insertFragmentIntoContentState
 * @format
 * 
 */



var BlockMapBuilder = __webpack_require__(299);
var ContentBlockNode = __webpack_require__(122);
var Immutable = __webpack_require__(45);

var insertIntoList = __webpack_require__(766);
var invariant = __webpack_require__(23);
var randomizeBlockMapKeys = __webpack_require__(769);

var List = Immutable.List;


var updateExistingBlock = function updateExistingBlock(contentState, selectionState, blockMap, fragmentBlock, targetKey, targetOffset) {
  var targetBlock = blockMap.get(targetKey);
  var text = targetBlock.getText();
  var chars = targetBlock.getCharacterList();
  var finalKey = targetKey;
  var finalOffset = targetOffset + fragmentBlock.getText().length;

  var newBlock = targetBlock.merge({
    text: text.slice(0, targetOffset) + fragmentBlock.getText() + text.slice(targetOffset),
    characterList: insertIntoList(chars, fragmentBlock.getCharacterList(), targetOffset),
    data: fragmentBlock.getData()
  });

  return contentState.merge({
    blockMap: blockMap.set(targetKey, newBlock),
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};

/**
 * Appends text/characterList from the fragment first block to
 * target block.
 */
var updateHead = function updateHead(block, targetOffset, fragment) {
  var text = block.getText();
  var chars = block.getCharacterList();

  // Modify head portion of block.
  var headText = text.slice(0, targetOffset);
  var headCharacters = chars.slice(0, targetOffset);
  var appendToHead = fragment.first();

  return block.merge({
    text: headText + appendToHead.getText(),
    characterList: headCharacters.concat(appendToHead.getCharacterList()),
    type: headText ? block.getType() : appendToHead.getType(),
    data: appendToHead.getData()
  });
};

/**
 * Appends offset text/characterList from the target block to the last
 * fragment block.
 */
var updateTail = function updateTail(block, targetOffset, fragment) {
  // Modify tail portion of block.
  var text = block.getText();
  var chars = block.getCharacterList();

  // Modify head portion of block.
  var blockSize = text.length;
  var tailText = text.slice(targetOffset, blockSize);
  var tailCharacters = chars.slice(targetOffset, blockSize);
  var prependToTail = fragment.last();

  return prependToTail.merge({
    text: prependToTail.getText() + tailText,
    characterList: prependToTail.getCharacterList().concat(tailCharacters),
    data: prependToTail.getData()
  });
};

var getRootBlocks = function getRootBlocks(block, blockMap) {
  var headKey = block.getKey();
  var rootBlock = block;
  var rootBlocks = [];

  // sometimes the fragment head block will not be part of the blockMap itself this can happen when
  // the fragment head is used to update the target block, however when this does not happen we need
  // to make sure that we include it on the rootBlocks since the first block of a fragment is always a
  // fragment root block
  if (blockMap.get(headKey)) {
    rootBlocks.push(headKey);
  }

  while (rootBlock && rootBlock.getNextSiblingKey()) {
    var lastSiblingKey = rootBlock.getNextSiblingKey();

    if (!lastSiblingKey) {
      break;
    }

    rootBlocks.push(lastSiblingKey);
    rootBlock = blockMap.get(lastSiblingKey);
  }

  return rootBlocks;
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockMap, targetBlock, fragmentHeadBlock) {
  return blockMap.withMutations(function (blockMapState) {
    var targetKey = targetBlock.getKey();
    var headKey = fragmentHeadBlock.getKey();
    var targetNextKey = targetBlock.getNextSiblingKey();
    var targetParentKey = targetBlock.getParentKey();
    var fragmentRootBlocks = getRootBlocks(fragmentHeadBlock, blockMap);
    var lastRootFragmentBlockKey = fragmentRootBlocks[fragmentRootBlocks.length - 1];

    if (blockMapState.get(headKey)) {
      // update the fragment head when it is part of the blockMap otherwise
      blockMapState.setIn([targetKey, 'nextSibling'], headKey);
      blockMapState.setIn([headKey, 'prevSibling'], targetKey);
    } else {
      // update the target block that had the fragment head contents merged into it
      blockMapState.setIn([targetKey, 'nextSibling'], fragmentHeadBlock.getNextSiblingKey());
      blockMapState.setIn([fragmentHeadBlock.getNextSiblingKey(), 'prevSibling'], targetKey);
    }

    // update the last root block fragment
    blockMapState.setIn([lastRootFragmentBlockKey, 'nextSibling'], targetNextKey);

    // update the original target next block
    if (targetNextKey) {
      blockMapState.setIn([targetNextKey, 'prevSibling'], lastRootFragmentBlockKey);
    }

    // update fragment parent links
    fragmentRootBlocks.forEach(function (blockKey) {
      return blockMapState.setIn([blockKey, 'parent'], targetParentKey);
    });

    // update targetBlock parent child links
    if (targetParentKey) {
      var targetParent = blockMap.get(targetParentKey);
      var originalTargetParentChildKeys = targetParent.getChildKeys();

      var targetBlockIndex = originalTargetParentChildKeys.indexOf(targetKey);
      var insertionIndex = targetBlockIndex + 1;

      var newChildrenKeysArray = originalTargetParentChildKeys.toArray();

      // insert fragment children
      newChildrenKeysArray.splice.apply(newChildrenKeysArray, [insertionIndex, 0].concat(fragmentRootBlocks));

      blockMapState.setIn([targetParentKey, 'children'], List(newChildrenKeysArray));
    }
  });
};

var insertFragment = function insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;
  var newBlockArr = [];
  var fragmentSize = fragment.size;
  var target = blockMap.get(targetKey);
  var head = fragment.first();
  var tail = fragment.last();
  var finalOffset = tail.getLength();
  var finalKey = tail.getKey();
  var shouldNotUpdateFromFragmentBlock = isTreeBasedBlockMap && (!target.getChildKeys().isEmpty() || !head.getChildKeys().isEmpty());

  blockMap.forEach(function (block, blockKey) {
    if (blockKey !== targetKey) {
      newBlockArr.push(block);
      return;
    }

    if (shouldNotUpdateFromFragmentBlock) {
      newBlockArr.push(block);
    } else {
      newBlockArr.push(updateHead(block, targetOffset, fragment));
    }

    // Insert fragment blocks after the head and before the tail.
    fragment
    // when we are updating the target block with the head fragment block we skip the first fragment
    // head since its contents have already been merged with the target block otherwise we include
    // the whole fragment
    .slice(shouldNotUpdateFromFragmentBlock ? 0 : 1, fragmentSize - 1).forEach(function (fragmentBlock) {
      return newBlockArr.push(fragmentBlock);
    });

    // update tail
    newBlockArr.push(updateTail(block, targetOffset, fragment));
  });

  var updatedBlockMap = BlockMapBuilder.createFromArray(newBlockArr);

  if (isTreeBasedBlockMap) {
    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, blockMap, target, head);
  }

  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};

var insertFragmentIntoContentState = function insertFragmentIntoContentState(contentState, selectionState, fragmentBlockMap) {
  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertFragment` should only be called with a collapsed selection state.') : invariant(false) : void 0;

  var blockMap = contentState.getBlockMap();
  var fragment = randomizeBlockMapKeys(fragmentBlockMap);
  var targetKey = selectionState.getStartKey();
  var targetOffset = selectionState.getStartOffset();

  var targetBlock = blockMap.get(targetKey);

  if (targetBlock instanceof ContentBlockNode) {
    !targetBlock.getChildKeys().isEmpty() ?  false ? invariant(false, '`insertFragment` should not be called when a container node is selected.') : invariant(false) : void 0;
  }

  // When we insert a fragment with a single block we simply update the target block
  // with the contents of the inserted fragment block
  if (fragment.size === 1) {
    return updateExistingBlock(contentState, selectionState, blockMap, fragment.first(), targetKey, targetOffset);
  }

  return insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset);
};

module.exports = insertFragmentIntoContentState;

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule insertTextIntoContentState
 * @format
 * 
 */



var Immutable = __webpack_require__(45);

var insertIntoList = __webpack_require__(766);
var invariant = __webpack_require__(23);

var Repeat = Immutable.Repeat;


function insertTextIntoContentState(contentState, selectionState, text, characterMetadata) {
  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertText` should only be called with a collapsed range.') : invariant(false) : void 0;

  var len = text.length;
  if (!len) {
    return contentState;
  }

  var blockMap = contentState.getBlockMap();
  var key = selectionState.getStartKey();
  var offset = selectionState.getStartOffset();
  var block = blockMap.get(key);
  var blockText = block.getText();

  var newBlock = block.merge({
    text: blockText.slice(0, offset) + text + blockText.slice(offset, block.getLength()),
    characterList: insertIntoList(block.getCharacterList(), Repeat(characterMetadata, len).toList(), offset)
  });

  var newOffset = offset + len;

  return contentState.merge({
    blockMap: blockMap.set(key, newBlock),
    selectionAfter: selectionState.merge({
      anchorOffset: newOffset,
      focusOffset: newOffset
    })
  });
}

module.exports = insertTextIntoContentState;

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandBackspaceToStartOfLine
 * @format
 * 
 */



var EditorState = __webpack_require__(51);

var expandRangeToStartOfLine = __webpack_require__(1850);
var getDraftEditorSelectionWithNodes = __webpack_require__(758);
var moveSelectionBackward = __webpack_require__(508);
var removeTextWithStrategy = __webpack_require__(302);

function keyCommandBackspaceToStartOfLine(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    if (selection.isCollapsed() && selection.getAnchorOffset() === 0) {
      return moveSelectionBackward(strategyState, 1);
    }

    var domSelection = global.getSelection();
    var range = domSelection.getRangeAt(0);
    range = expandRangeToStartOfLine(range);

    return getDraftEditorSelectionWithNodes(strategyState, null, range.endContainer, range.endOffset, range.startContainer, range.startOffset).selectionState;
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandBackspaceToStartOfLine;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74)))

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandBackspaceWord
 * @format
 * 
 */



var DraftRemovableWord = __webpack_require__(753);
var EditorState = __webpack_require__(51);

var moveSelectionBackward = __webpack_require__(508);
var removeTextWithStrategy = __webpack_require__(302);

/**
 * Delete the word that is left of the cursor, as well as any spaces or
 * punctuation after the word.
 */
function keyCommandBackspaceWord(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset();
    // If there are no words before the cursor, remove the preceding newline.
    if (offset === 0) {
      return moveSelectionBackward(strategyState, 1);
    }
    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(0, offset);
    var toRemove = DraftRemovableWord.getBackward(text);
    return moveSelectionBackward(strategyState, toRemove.length || 1);
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandBackspaceWord;

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandDeleteWord
 * @format
 * 
 */



var DraftRemovableWord = __webpack_require__(753);
var EditorState = __webpack_require__(51);

var moveSelectionForward = __webpack_require__(768);
var removeTextWithStrategy = __webpack_require__(302);

/**
 * Delete the word that is right of the cursor, as well as any spaces or
 * punctuation before the word.
 */
function keyCommandDeleteWord(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset();
    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(offset);
    var toRemove = DraftRemovableWord.getForward(text);

    // If there are no words in front of the cursor, remove the newline.
    return moveSelectionForward(strategyState, toRemove.length || 1);
  }, 'forward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandDeleteWord;

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandInsertNewline
 * @format
 * 
 */



var DraftModifier = __webpack_require__(107);
var EditorState = __webpack_require__(51);

function keyCommandInsertNewline(editorState) {
  var contentState = DraftModifier.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
  return EditorState.push(editorState, contentState, 'split-block');
}

module.exports = keyCommandInsertNewline;

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandMoveSelectionToEndOfBlock
 * @format
 * 
 */



var EditorState = __webpack_require__(51);

/**
 * See comment for `moveSelectionToStartOfBlock`.
 */
function keyCommandMoveSelectionToEndOfBlock(editorState) {
  var selection = editorState.getSelection();
  var endKey = selection.getEndKey();
  var content = editorState.getCurrentContent();
  var textLength = content.getBlockForKey(endKey).getLength();
  return EditorState.set(editorState, {
    selection: selection.merge({
      anchorKey: endKey,
      anchorOffset: textLength,
      focusKey: endKey,
      focusOffset: textLength,
      isBackward: false
    }),
    forceSelection: true
  });
}

module.exports = keyCommandMoveSelectionToEndOfBlock;

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandMoveSelectionToStartOfBlock
 * @format
 * 
 */



var EditorState = __webpack_require__(51);

/**
 * Collapse selection at the start of the first selected block. This is used
 * for Firefox versions that attempt to navigate forward/backward instead of
 * moving the cursor. Other browsers are able to move the cursor natively.
 */
function keyCommandMoveSelectionToStartOfBlock(editorState) {
  var selection = editorState.getSelection();
  var startKey = selection.getStartKey();
  return EditorState.set(editorState, {
    selection: selection.merge({
      anchorKey: startKey,
      anchorOffset: 0,
      focusKey: startKey,
      focusOffset: 0,
      isBackward: false
    }),
    forceSelection: true
  });
}

module.exports = keyCommandMoveSelectionToStartOfBlock;

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandPlainBackspace
 * @format
 * 
 */



var EditorState = __webpack_require__(51);
var UnicodeUtils = __webpack_require__(232);

var moveSelectionBackward = __webpack_require__(508);
var removeTextWithStrategy = __webpack_require__(302);

/**
 * Remove the selected range. If the cursor is collapsed, remove the preceding
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */
function keyCommandPlainBackspace(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection.getAnchorKey();
    var offset = selection.getAnchorOffset();
    var charBehind = content.getBlockForKey(key).getText()[offset - 1];
    return moveSelectionBackward(strategyState, charBehind ? UnicodeUtils.getUTF16Length(charBehind, 0) : 1);
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  var selection = editorState.getSelection();
  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'backspace-character' : 'remove-range');
}

module.exports = keyCommandPlainBackspace;

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandPlainDelete
 * @format
 * 
 */



var EditorState = __webpack_require__(51);
var UnicodeUtils = __webpack_require__(232);

var moveSelectionForward = __webpack_require__(768);
var removeTextWithStrategy = __webpack_require__(302);

/**
 * Remove the selected range. If the cursor is collapsed, remove the following
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */
function keyCommandPlainDelete(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection.getAnchorKey();
    var offset = selection.getAnchorOffset();
    var charAhead = content.getBlockForKey(key).getText()[offset];
    return moveSelectionForward(strategyState, charAhead ? UnicodeUtils.getUTF16Length(charAhead, 0) : 1);
  }, 'forward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  var selection = editorState.getSelection();

  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'delete-character' : 'remove-range');
}

module.exports = keyCommandPlainDelete;

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandTransposeCharacters
 * @format
 * 
 */



var DraftModifier = __webpack_require__(107);
var EditorState = __webpack_require__(51);

var getContentStateFragment = __webpack_require__(372);

/**
 * Transpose the characters on either side of a collapsed cursor, or
 * if the cursor is at the end of the block, transpose the last two
 * characters.
 */
function keyCommandTransposeCharacters(editorState) {
  var selection = editorState.getSelection();
  if (!selection.isCollapsed()) {
    return editorState;
  }

  var offset = selection.getAnchorOffset();
  if (offset === 0) {
    return editorState;
  }

  var blockKey = selection.getAnchorKey();
  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var length = block.getLength();

  // Nothing to transpose if there aren't two characters.
  if (length <= 1) {
    return editorState;
  }

  var removalRange;
  var finalSelection;

  if (offset === length) {
    // The cursor is at the end of the block. Swap the last two characters.
    removalRange = selection.set('anchorOffset', offset - 1);
    finalSelection = selection;
  } else {
    removalRange = selection.set('focusOffset', offset + 1);
    finalSelection = removalRange.set('anchorOffset', offset + 1);
  }

  // Extract the character to move as a fragment. This preserves its
  // styling and entity, if any.
  var movedFragment = getContentStateFragment(content, removalRange);
  var afterRemoval = DraftModifier.removeRange(content, removalRange, 'backward');

  // After the removal, the insertion target is one character back.
  var selectionAfter = afterRemoval.getSelectionAfter();
  var targetOffset = selectionAfter.getAnchorOffset() - 1;
  var targetRange = selectionAfter.merge({
    anchorOffset: targetOffset,
    focusOffset: targetOffset
  });

  var afterInsert = DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);

  var newEditorState = EditorState.push(editorState, afterInsert, 'insert-fragment');

  return EditorState.acceptSelection(newEditorState, finalSelection);
}

module.exports = keyCommandTransposeCharacters;

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandUndo
 * @format
 * 
 */



var EditorState = __webpack_require__(51);

function keyCommandUndo(e, editorState, updateFn) {
  var undoneState = EditorState.undo(editorState);

  // If the last change to occur was a spellcheck change, allow the undo
  // event to fall through to the browser. This allows the browser to record
  // the unwanted change, which should soon lead it to learn not to suggest
  // the correction again.
  if (editorState.getLastChangeType() === 'spellcheck-change') {
    var nativelyRenderedContent = undoneState.getCurrentContent();
    updateFn(EditorState.set(undoneState, { nativelyRenderedContent: nativelyRenderedContent }));
    return;
  }

  // Otheriwse, manage the undo behavior manually.
  e.preventDefault();
  if (!editorState.getNativelyRenderedContent()) {
    updateFn(undoneState);
    return;
  }

  // Trigger a re-render with the current content state to ensure that the
  // component tree has up-to-date props for comparison.
  updateFn(EditorState.set(editorState, { nativelyRenderedContent: null }));

  // Wait to ensure that the re-render has occurred before performing
  // the undo action.
  setTimeout(function () {
    updateFn(undoneState);
  }, 0);
}

module.exports = keyCommandUndo;

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule modifyBlockForContentState
 * @format
 * 
 */



var Immutable = __webpack_require__(45);

var Map = Immutable.Map;


function modifyBlockForContentState(contentState, selectionState, operation) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(operation);

  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = modifyBlockForContentState;

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule moveBlockInContentState
 * @format
 * 
 */



var ContentBlockNode = __webpack_require__(122);
var Immutable = __webpack_require__(45);

var getNextDelimiterBlockKey = __webpack_require__(760);
var invariant = __webpack_require__(23);

var OrderedMap = Immutable.OrderedMap,
    List = Immutable.List;


var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockToBeMoved, originalTargetBlock, insertionMode, isExperimentalTreeBlock) {
  if (!isExperimentalTreeBlock) {
    return blockMap;
  }
  // possible values of 'insertionMode' are: 'after', 'before'
  var isInsertedAfterTarget = insertionMode === 'after';

  var originalBlockKey = originalBlockToBeMoved.getKey();
  var originalTargetKey = originalTargetBlock.getKey();
  var originalParentKey = originalBlockToBeMoved.getParentKey();
  var originalNextSiblingKey = originalBlockToBeMoved.getNextSiblingKey();
  var originalPrevSiblingKey = originalBlockToBeMoved.getPrevSiblingKey();
  var newParentKey = originalTargetBlock.getParentKey();
  var newNextSiblingKey = isInsertedAfterTarget ? originalTargetBlock.getNextSiblingKey() : originalTargetKey;
  var newPrevSiblingKey = isInsertedAfterTarget ? originalTargetKey : originalTargetBlock.getPrevSiblingKey();

  return blockMap.withMutations(function (blocks) {
    // update old parent
    transformBlock(originalParentKey, blocks, function (block) {
      var parentChildrenList = block.getChildKeys();
      return block.merge({
        children: parentChildrenList['delete'](parentChildrenList.indexOf(originalBlockKey))
      });
    });

    // update old prev
    transformBlock(originalPrevSiblingKey, blocks, function (block) {
      return block.merge({
        nextSibling: originalNextSiblingKey
      });
    });

    // update old next
    transformBlock(originalNextSiblingKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalPrevSiblingKey
      });
    });

    // update new next
    transformBlock(newNextSiblingKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    });

    // update new prev
    transformBlock(newPrevSiblingKey, blocks, function (block) {
      return block.merge({
        nextSibling: originalBlockKey
      });
    });

    // update new parent
    transformBlock(newParentKey, blocks, function (block) {
      var newParentChildrenList = block.getChildKeys();
      var targetBlockIndex = newParentChildrenList.indexOf(originalTargetKey);

      var insertionIndex = isInsertedAfterTarget ? targetBlockIndex + 1 : targetBlockIndex !== 0 ? targetBlockIndex - 1 : 0;

      var newChildrenArray = newParentChildrenList.toArray();
      newChildrenArray.splice(insertionIndex, 0, originalBlockKey);

      return block.merge({
        children: List(newChildrenArray)
      });
    });

    // update block
    transformBlock(originalBlockKey, blocks, function (block) {
      return block.merge({
        nextSibling: newNextSiblingKey,
        prevSibling: newPrevSiblingKey,
        parent: newParentKey
      });
    });
  });
};

var moveBlockInContentState = function moveBlockInContentState(contentState, blockToBeMoved, targetBlock, insertionMode) {
  !(insertionMode !== 'replace') ?  false ? invariant(false, 'Replacing blocks is not supported.') : invariant(false) : void 0;

  var targetKey = targetBlock.getKey();
  var blockKey = blockToBeMoved.getKey();

  !(blockKey !== targetKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;

  var blockMap = contentState.getBlockMap();
  var isExperimentalTreeBlock = blockToBeMoved instanceof ContentBlockNode;

  var blocksToBeMoved = [blockToBeMoved];
  var blockMapWithoutBlocksToBeMoved = blockMap['delete'](blockKey);

  if (isExperimentalTreeBlock) {
    blocksToBeMoved = [];
    blockMapWithoutBlocksToBeMoved = blockMap.withMutations(function (blocks) {
      var nextSiblingKey = blockToBeMoved.getNextSiblingKey();
      var nextDelimiterBlockKey = getNextDelimiterBlockKey(blockToBeMoved, blocks);

      blocks.toSeq().skipUntil(function (block) {
        return block.getKey() === blockKey;
      }).takeWhile(function (block) {
        var key = block.getKey();
        var isBlockToBeMoved = key === blockKey;
        var hasNextSiblingAndIsNotNextSibling = nextSiblingKey && key !== nextSiblingKey;
        var doesNotHaveNextSiblingAndIsNotDelimiter = !nextSiblingKey && block.getParentKey() && (!nextDelimiterBlockKey || key !== nextDelimiterBlockKey);

        return !!(isBlockToBeMoved || hasNextSiblingAndIsNotNextSibling || doesNotHaveNextSiblingAndIsNotDelimiter);
      }).forEach(function (block) {
        blocksToBeMoved.push(block);
        blocks['delete'](block.getKey());
      });
    });
  }

  var blocksBefore = blockMapWithoutBlocksToBeMoved.toSeq().takeUntil(function (v) {
    return v === targetBlock;
  });

  var blocksAfter = blockMapWithoutBlocksToBeMoved.toSeq().skipUntil(function (v) {
    return v === targetBlock;
  }).skip(1);

  var slicedBlocks = blocksToBeMoved.map(function (block) {
    return [block.getKey(), block];
  });

  var newBlocks = OrderedMap();

  if (insertionMode === 'before') {
    var blockBefore = contentState.getBlockBefore(targetKey);

    !(!blockBefore || blockBefore.getKey() !== blockToBeMoved.getKey()) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;

    newBlocks = blocksBefore.concat([].concat(slicedBlocks, [[targetKey, targetBlock]]), blocksAfter).toOrderedMap();
  } else if (insertionMode === 'after') {
    var blockAfter = contentState.getBlockAfter(targetKey);

    !(!blockAfter || blockAfter.getKey() !== blockKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;

    newBlocks = blocksBefore.concat([[targetKey, targetBlock]].concat(slicedBlocks), blocksAfter).toOrderedMap();
  }

  return contentState.merge({
    blockMap: updateBlockMapLinks(newBlocks, blockToBeMoved, targetBlock, insertionMode, isExperimentalTreeBlock),
    selectionBefore: contentState.getSelectionAfter(),
    selectionAfter: contentState.getSelectionAfter().merge({
      anchorKey: blockKey,
      focusKey: blockKey
    })
  });
};

module.exports = moveBlockInContentState;

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule removeRangeFromContentState
 * @format
 * 
 */



var ContentBlockNode = __webpack_require__(122);
var Immutable = __webpack_require__(45);

var getNextDelimiterBlockKey = __webpack_require__(760);

var List = Immutable.List,
    Map = Immutable.Map;


var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

/**
 * Ancestors needs to be preserved when there are non selected
 * children to make sure we do not leave any orphans behind
 */
var getAncestorsKeys = function getAncestorsKeys(blockKey, blockMap) {
  var parents = [];

  if (!blockKey) {
    return parents;
  }

  var blockNode = blockMap.get(blockKey);
  while (blockNode && blockNode.getParentKey()) {
    var parentKey = blockNode.getParentKey();
    if (parentKey) {
      parents.push(parentKey);
    }
    blockNode = parentKey ? blockMap.get(parentKey) : null;
  }

  return parents;
};

/**
 * Get all next delimiter keys until we hit a root delimiter and return
 * an array of key references
 */
var getNextDelimitersBlockKeys = function getNextDelimitersBlockKeys(block, blockMap) {
  var nextDelimiters = [];

  if (!block) {
    return nextDelimiters;
  }

  var nextDelimiter = getNextDelimiterBlockKey(block, blockMap);
  while (nextDelimiter && blockMap.get(nextDelimiter)) {
    var _block = blockMap.get(nextDelimiter);
    nextDelimiters.push(nextDelimiter);

    // we do not need to keep checking all root node siblings, just the first occurance
    nextDelimiter = _block.getParentKey() ? getNextDelimiterBlockKey(_block, blockMap) : null;
  }

  return nextDelimiters;
};

var getNextValidSibling = function getNextValidSibling(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  }

  // note that we need to make sure we refer to the original block since this
  // function is called within a withMutations
  var nextValidSiblingKey = originalBlockMap.get(block.getKey()).getNextSiblingKey();

  while (nextValidSiblingKey && !blockMap.get(nextValidSiblingKey)) {
    nextValidSiblingKey = originalBlockMap.get(nextValidSiblingKey).getNextSiblingKey() || null;
  }

  return nextValidSiblingKey;
};

var getPrevValidSibling = function getPrevValidSibling(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  }

  // note that we need to make sure we refer to the original block since this
  // function is called within a withMutations
  var prevValidSiblingKey = originalBlockMap.get(block.getKey()).getPrevSiblingKey();

  while (prevValidSiblingKey && !blockMap.get(prevValidSiblingKey)) {
    prevValidSiblingKey = originalBlockMap.get(prevValidSiblingKey).getPrevSiblingKey() || null;
  }

  return prevValidSiblingKey;
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, startBlock, endBlock, originalBlockMap) {
  return blockMap.withMutations(function (blocks) {
    // update start block if its retained
    transformBlock(startBlock.getKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(startBlock, blocks, originalBlockMap)
      });
    });

    // update endblock if its retained
    transformBlock(endBlock.getKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(endBlock, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
      });
    });

    // update start block parent ancestors
    getAncestorsKeys(startBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
      return transformBlock(parentKey, blocks, function (block) {
        return block.merge({
          children: block.getChildKeys().filter(function (key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    });

    // update start block next - can only happen if startBlock == endBlock
    transformBlock(startBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: startBlock.getPrevSiblingKey()
      });
    });

    // update start block prev
    transformBlock(startBlock.getPrevSiblingKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap)
      });
    });

    // update end block next
    transformBlock(endBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
      });
    });

    // update end block prev
    transformBlock(endBlock.getPrevSiblingKey(), blocks, function (block) {
      return block.merge({
        nextSibling: endBlock.getNextSiblingKey()
      });
    });

    // update end block parent ancestors
    getAncestorsKeys(endBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
      transformBlock(parentKey, blocks, function (block) {
        return block.merge({
          children: block.getChildKeys().filter(function (key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    });

    // update next delimiters all the way to a root delimiter
    getNextDelimitersBlockKeys(endBlock, originalBlockMap).forEach(function (delimiterKey) {
      return transformBlock(delimiterKey, blocks, function (block) {
        return block.merge({
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    });
  });
};

var removeRangeFromContentState = function removeRangeFromContentState(contentState, selectionState) {
  if (selectionState.isCollapsed()) {
    return contentState;
  }

  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  var startBlock = blockMap.get(startKey);
  var endBlock = blockMap.get(endKey);

  // we assume that ContentBlockNode and ContentBlocks are not mixed together
  var isExperimentalTreeBlock = startBlock instanceof ContentBlockNode;

  // used to retain blocks that should not be deleted to avoid orphan children
  var parentAncestors = [];

  if (isExperimentalTreeBlock) {
    var endBlockchildrenKeys = endBlock.getChildKeys();
    var endBlockAncestors = getAncestorsKeys(endKey, blockMap);

    // endBlock has unselected sibblings so we can not remove its ancestors parents
    if (endBlock.getNextSiblingKey()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors);
    }

    // endBlock has children so can not remove this block or any of its ancestors
    if (!endBlockchildrenKeys.isEmpty()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors.concat([endKey]));
    }

    // we need to retain all ancestors of the next delimiter block
    parentAncestors = parentAncestors.concat(getAncestorsKeys(getNextDelimiterBlockKey(endBlock, blockMap), blockMap));
  }

  var characterList = void 0;

  if (startBlock === endBlock) {
    characterList = removeFromList(startBlock.getCharacterList(), startOffset, endOffset);
  } else {
    characterList = startBlock.getCharacterList().slice(0, startOffset).concat(endBlock.getCharacterList().slice(endOffset));
  }

  var modifiedStart = startBlock.merge({
    text: startBlock.getText().slice(0, startOffset) + endBlock.getText().slice(endOffset),
    characterList: characterList
  });

  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).filter(function (_, k) {
    return parentAncestors.indexOf(k) === -1;
  }).concat(Map([[endKey, null]])).map(function (_, k) {
    return k === startKey ? modifiedStart : null;
  });

  var updatedBlockMap = blockMap.merge(newBlocks).filter(function (block) {
    return !!block;
  });

  if (isExperimentalTreeBlock) {
    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, startBlock, endBlock, blockMap);
  }

  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: startKey,
      anchorOffset: startOffset,
      focusKey: startKey,
      focusOffset: startOffset,
      isBackward: false
    })
  });
};

/**
 * Maintain persistence for target list when removing characters on the
 * head and tail of the character list.
 */
var removeFromList = function removeFromList(targetList, startOffset, endOffset) {
  if (startOffset === 0) {
    while (startOffset < endOffset) {
      targetList = targetList.shift();
      startOffset++;
    }
  } else if (endOffset === targetList.count()) {
    while (endOffset > startOffset) {
      targetList = targetList.pop();
      endOffset--;
    }
  } else {
    var head = targetList.slice(0, startOffset);
    var tail = targetList.slice(endOffset);
    targetList = head.concat(tail).toList();
  }
  return targetList;
};

module.exports = removeRangeFromContentState;

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule setDraftEditorSelection
 * @format
 * 
 */



var DraftJsDebugLogging = __webpack_require__(1823);

var containsNode = __webpack_require__(385);
var getActiveElement = __webpack_require__(387);
var invariant = __webpack_require__(23);

function getAnonymizedDOM(node, getNodeLabels) {
  if (!node) {
    return '[empty]';
  }

  var anonymized = anonymizeTextWithin(node, getNodeLabels);
  if (anonymized.nodeType === Node.TEXT_NODE) {
    return anonymized.textContent;
  }

  !(anonymized instanceof Element) ?  false ? invariant(false, 'Node must be an Element if it is not a text node.') : invariant(false) : void 0;
  return anonymized.outerHTML;
}

function anonymizeTextWithin(node, getNodeLabels) {
  var labels = getNodeLabels !== undefined ? getNodeLabels(node) : [];

  if (node.nodeType === Node.TEXT_NODE) {
    var length = node.textContent.length;
    return document.createTextNode('[text ' + length + (labels.length ? ' | ' + labels.join(', ') : '') + ']');
  }

  var clone = node.cloneNode();
  if (clone.nodeType === 1 && labels.length) {
    clone.setAttribute('data-labels', labels.join(', '));
  }
  var childNodes = node.childNodes;
  for (var ii = 0; ii < childNodes.length; ii++) {
    clone.appendChild(anonymizeTextWithin(childNodes[ii], getNodeLabels));
  }

  return clone;
}

function getAnonymizedEditorDOM(node, getNodeLabels) {
  // grabbing the DOM content of the Draft editor
  var currentNode = node;
  while (currentNode) {
    if (currentNode instanceof Element && currentNode.hasAttribute('contenteditable')) {
      // found the Draft editor container
      return getAnonymizedDOM(currentNode, getNodeLabels);
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return 'Could not find contentEditable parent of node';
}

function getNodeLength(node) {
  return node.nodeValue === null ? node.childNodes.length : node.nodeValue.length;
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 */
function setDraftEditorSelection(selectionState, node, blockKey, nodeStart, nodeEnd) {
  // It's possible that the editor has been removed from the DOM but
  // our selection code doesn't know it yet. Forcing selection in
  // this case may lead to errors, so just bail now.
  if (!containsNode(document.documentElement, node)) {
    return;
  }

  var selection = global.getSelection();
  var anchorKey = selectionState.getAnchorKey();
  var anchorOffset = selectionState.getAnchorOffset();
  var focusKey = selectionState.getFocusKey();
  var focusOffset = selectionState.getFocusOffset();
  var isBackward = selectionState.getIsBackward();

  // IE doesn't support backward selection. Swap key/offset pairs.
  if (!selection.extend && isBackward) {
    var tempKey = anchorKey;
    var tempOffset = anchorOffset;
    anchorKey = focusKey;
    anchorOffset = focusOffset;
    focusKey = tempKey;
    focusOffset = tempOffset;
    isBackward = false;
  }

  var hasAnchor = anchorKey === blockKey && nodeStart <= anchorOffset && nodeEnd >= anchorOffset;

  var hasFocus = focusKey === blockKey && nodeStart <= focusOffset && nodeEnd >= focusOffset;

  // If the selection is entirely bound within this node, set the selection
  // and be done.
  if (hasAnchor && hasFocus) {
    selection.removeAllRanges();
    addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    return;
  }

  if (!isBackward) {
    // If the anchor is within this node, set the range start.
    if (hasAnchor) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    }

    // If the focus is within this node, we can assume that we have
    // already set the appropriate start range on the selection, and
    // can simply extend the selection.
    if (hasFocus) {
      addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    }
  } else {
    // If this node has the focus, set the selection range to be a
    // collapsed range beginning here. Later, when we encounter the anchor,
    // we'll use this information to extend the selection.
    if (hasFocus) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, focusOffset - nodeStart, selectionState);
    }

    // If this node has the anchor, we may assume that the correct
    // focus information is already stored on the selection object.
    // We keep track of it, reset the selection range, and extend it
    // back to the focus point.
    if (hasAnchor) {
      var storedFocusNode = selection.focusNode;
      var storedFocusOffset = selection.focusOffset;

      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
      addFocusToSelection(selection, storedFocusNode, storedFocusOffset, selectionState);
    }
  }
}

/**
 * Extend selection towards focus point.
 */
function addFocusToSelection(selection, node, offset, selectionState) {
  var activeElement = getActiveElement();
  if (selection.extend && containsNode(activeElement, node)) {
    // If `extend` is called while another element has focus, an error is
    // thrown. We therefore disable `extend` if the active element is somewhere
    // other than the node we are selecting. This should only occur in Firefox,
    // since it is the only browser to support multiple selections.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444.

    // logging to catch bug that is being reported in t16250795
    if (offset > getNodeLength(node)) {
      // the call to 'selection.extend' is about to throw
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node),
        extraParams: JSON.stringify({ offset: offset }),
        selectionState: JSON.stringify(selectionState.toJS())
      });
    }

    // logging to catch bug that is being reported in t18110632
    var nodeWasFocus = node === selection.focusNode;
    try {
      selection.extend(node, offset);
    } catch (e) {
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node, function (n) {
          var labels = [];
          if (n === activeElement) {
            labels.push('active element');
          }
          if (n === selection.anchorNode) {
            labels.push('selection anchor node');
          }
          if (n === selection.focusNode) {
            labels.push('selection focus node');
          }
          return labels;
        }),
        extraParams: JSON.stringify({
          activeElementName: activeElement ? activeElement.nodeName : null,
          nodeIsFocus: node === selection.focusNode,
          nodeWasFocus: nodeWasFocus,
          selectionRangeCount: selection.rangeCount,
          selectionAnchorNodeName: selection.anchorNode ? selection.anchorNode.nodeName : null,
          selectionAnchorOffset: selection.anchorOffset,
          selectionFocusNodeName: selection.focusNode ? selection.focusNode.nodeName : null,
          selectionFocusOffset: selection.focusOffset,
          message: e ? '' + e : null,
          offset: offset
        }, null, 2),
        selectionState: JSON.stringify(selectionState.toJS(), null, 2)
      });
      // allow the error to be thrown -
      // better than continuing in a broken state
      throw e;
    }
  } else {
    // IE doesn't support extend. This will mean no backward selection.
    // Extract the existing selection range and add focus to it.
    // Additionally, clone the selection range. IE11 throws an
    // InvalidStateError when attempting to access selection properties
    // after the range is detached.
    var range = selection.getRangeAt(0);
    range.setEnd(node, offset);
    selection.addRange(range.cloneRange());
  }
}

function addPointToSelection(selection, node, offset, selectionState) {
  var range = document.createRange();
  // logging to catch bug that is being reported in t16250795
  if (offset > getNodeLength(node)) {
    // in this case we know that the call to 'range.setStart' is about to throw
    DraftJsDebugLogging.logSelectionStateFailure({
      anonymizedDom: getAnonymizedEditorDOM(node),
      extraParams: JSON.stringify({ offset: offset }),
      selectionState: JSON.stringify(selectionState.toJS())
    });
  }
  range.setStart(node, offset);
  selection.addRange(range);
}

module.exports = setDraftEditorSelection;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74)))

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule splitBlockInContentState
 * @format
 * 
 */



var ContentBlockNode = __webpack_require__(122);
var Immutable = __webpack_require__(45);

var generateRandomKey = __webpack_require__(167);
var invariant = __webpack_require__(23);

var List = Immutable.List,
    Map = Immutable.Map;


var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlock, belowBlock) {
  return blockMap.withMutations(function (blocks) {
    var originalBlockKey = originalBlock.getKey();
    var belowBlockKey = belowBlock.getKey();

    // update block parent
    transformBlock(originalBlock.getParentKey(), blocks, function (block) {
      var parentChildrenList = block.getChildKeys();
      var insertionIndex = parentChildrenList.indexOf(originalBlockKey) + 1;
      var newChildrenArray = parentChildrenList.toArray();

      newChildrenArray.splice(insertionIndex, 0, belowBlockKey);

      return block.merge({
        children: List(newChildrenArray)
      });
    });

    // update original next block
    transformBlock(originalBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: belowBlockKey
      });
    });

    // update original block
    transformBlock(originalBlockKey, blocks, function (block) {
      return block.merge({
        nextSibling: belowBlockKey
      });
    });

    // update below block
    transformBlock(belowBlockKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    });
  });
};

var splitBlockInContentState = function splitBlockInContentState(contentState, selectionState) {
  !selectionState.isCollapsed() ?  false ? invariant(false, 'Selection range must be collapsed.') : invariant(false) : void 0;

  var key = selectionState.getAnchorKey();
  var offset = selectionState.getAnchorOffset();
  var blockMap = contentState.getBlockMap();
  var blockToSplit = blockMap.get(key);
  var text = blockToSplit.getText();
  var chars = blockToSplit.getCharacterList();
  var keyBelow = generateRandomKey();
  var isExperimentalTreeBlock = blockToSplit instanceof ContentBlockNode;

  var blockAbove = blockToSplit.merge({
    text: text.slice(0, offset),
    characterList: chars.slice(0, offset)
  });
  var blockBelow = blockAbove.merge({
    key: keyBelow,
    text: text.slice(offset),
    characterList: chars.slice(offset),
    data: Map()
  });

  var blocksBefore = blockMap.toSeq().takeUntil(function (v) {
    return v === blockToSplit;
  });
  var blocksAfter = blockMap.toSeq().skipUntil(function (v) {
    return v === blockToSplit;
  }).rest();
  var newBlocks = blocksBefore.concat([[key, blockAbove], [keyBelow, blockBelow]], blocksAfter).toOrderedMap();

  if (isExperimentalTreeBlock) {
    !blockToSplit.getChildKeys().isEmpty() ?  false ? invariant(false, 'ContentBlockNode must not have children') : invariant(false) : void 0;

    newBlocks = updateBlockMapLinks(newBlocks, blockAbove, blockBelow);
  }

  return contentState.merge({
    blockMap: newBlocks,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: keyBelow,
      anchorOffset: 0,
      focusKey: keyBelow,
      focusOffset: 0,
      isBackward: false
    })
  });
};

module.exports = splitBlockInContentState;

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule splitTextIntoTextBlocks
 * @format
 * 
 */



var NEWLINE_REGEX = /\r\n?|\n/g;

function splitTextIntoTextBlocks(text) {
  return text.split(NEWLINE_REGEX);
}

module.exports = splitTextIntoTextBlocks;

/***/ }),
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */,
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */,
/* 2098 */,
/* 2099 */,
/* 2100 */,
/* 2101 */,
/* 2102 */,
/* 2103 */,
/* 2104 */,
/* 2105 */,
/* 2106 */,
/* 2107 */,
/* 2108 */,
/* 2109 */,
/* 2110 */,
/* 2111 */,
/* 2112 */,
/* 2113 */,
/* 2114 */,
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
    'use strict';
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

    /* istanbul ignore next */
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2743)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        module.exports = factory(require('stackframe'));
    } else {
        root.ErrorStackParser = factory(root.StackFrame);
    }
}(this, function ErrorStackParser(StackFrame) {
    'use strict';

    var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+\:\d+/;
    var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+\:\d+|\(native\))/m;
    var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code\])?$/;

    function _map(array, fn, thisArg) {
        if (typeof Array.prototype.map === 'function') {
            return array.map(fn, thisArg);
        } else {
            var output = new Array(array.length);
            for (var i = 0; i < array.length; i++) {
                output[i] = fn.call(thisArg, array[i]);
            }
            return output;
        }
    }

    function _filter(array, fn, thisArg) {
        if (typeof Array.prototype.filter === 'function') {
            return array.filter(fn, thisArg);
        } else {
            var output = [];
            for (var i = 0; i < array.length; i++) {
                if (fn.call(thisArg, array[i])) {
                    output.push(array[i]);
                }
            }
            return output;
        }
    }

    function _indexOf(array, target) {
        if (typeof Array.prototype.indexOf === 'function') {
            return array.indexOf(target);
        } else {
            for (var i = 0; i < array.length; i++) {
                if (array[i] === target) {
                    return i;
                }
            }
            return -1;
        }
    }

    return {
        /**
         * Given an Error object, extract the most information from it.
         *
         * @param {Error} error object
         * @return {Array} of StackFrames
         */
        parse: function ErrorStackParser$$parse(error) {
            if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') {
                return this.parseOpera(error);
            } else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) {
                return this.parseV8OrIE(error);
            } else if (error.stack) {
                return this.parseFFOrSafari(error);
            } else {
                throw new Error('Cannot parse given Error object');
            }
        },

        // Separate line and column numbers from a string of the form: (URI:Line:Column)
        extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
            // Fail-fast but return locations like "(native)"
            if (urlLike.indexOf(':') === -1) {
                return [urlLike];
            }

            var regExp = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/;
            var parts = regExp.exec(urlLike.replace(/[\(\)]/g, ''));
            return [parts[1], parts[2] || undefined, parts[3] || undefined];
        },

        parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
            var filtered = _filter(error.stack.split('\n'), function(line) {
                return !!line.match(CHROME_IE_STACK_REGEXP);
            }, this);

            return _map(filtered, function(line) {
                if (line.indexOf('(eval ') > -1) {
                    // Throw away eval information until we implement stacktrace.js/stackframe#8
                    line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, '');
                }
                var tokens = line.replace(/^\s+/, '').replace(/\(eval code/g, '(').split(/\s+/).slice(1);
                var locationParts = this.extractLocation(tokens.pop());
                var functionName = tokens.join(' ') || undefined;
                var fileName = _indexOf(['eval', '<anonymous>'], locationParts[0]) > -1 ? undefined : locationParts[0];

                return new StackFrame(functionName, undefined, fileName, locationParts[1], locationParts[2], line);
            }, this);
        },

        parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
            var filtered = _filter(error.stack.split('\n'), function(line) {
                return !line.match(SAFARI_NATIVE_CODE_REGEXP);
            }, this);

            return _map(filtered, function(line) {
                // Throw away eval information until we implement stacktrace.js/stackframe#8
                if (line.indexOf(' > eval') > -1) {
                    line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ':$1');
                }

                if (line.indexOf('@') === -1 && line.indexOf(':') === -1) {
                    // Safari eval frames only have function names and nothing else
                    return new StackFrame(line);
                } else {
                    var tokens = line.split('@');
                    var locationParts = this.extractLocation(tokens.pop());
                    var functionName = tokens.join('@') || undefined;
                    return new StackFrame(functionName,
                        undefined,
                        locationParts[0],
                        locationParts[1],
                        locationParts[2],
                        line);
                }
            }, this);
        },

        parseOpera: function ErrorStackParser$$parseOpera(e) {
            if (!e.stacktrace || (e.message.indexOf('\n') > -1 &&
                e.message.split('\n').length > e.stacktrace.split('\n').length)) {
                return this.parseOpera9(e);
            } else if (!e.stack) {
                return this.parseOpera10(e);
            } else {
                return this.parseOpera11(e);
            }
        },

        parseOpera9: function ErrorStackParser$$parseOpera9(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
            var lines = e.message.split('\n');
            var result = [];

            for (var i = 2, len = lines.length; i < len; i += 2) {
                var match = lineRE.exec(lines[i]);
                if (match) {
                    result.push(new StackFrame(undefined, undefined, match[2], match[1], undefined, lines[i]));
                }
            }

            return result;
        },

        parseOpera10: function ErrorStackParser$$parseOpera10(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
            var lines = e.stacktrace.split('\n');
            var result = [];

            for (var i = 0, len = lines.length; i < len; i += 2) {
                var match = lineRE.exec(lines[i]);
                if (match) {
                    result.push(
                        new StackFrame(
                            match[3] || undefined,
                            undefined,
                            match[2],
                            match[1],
                            undefined,
                            lines[i]
                        )
                    );
                }
            }

            return result;
        },

        // Opera 10.65+ Error.stack very similar to FF/Safari
        parseOpera11: function ErrorStackParser$$parseOpera11(error) {
            var filtered = _filter(error.stack.split('\n'), function(line) {
                return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
            }, this);

            return _map(filtered, function(line) {
                var tokens = line.split('@');
                var locationParts = this.extractLocation(tokens.pop());
                var functionCall = (tokens.shift() || '');
                var functionName = functionCall
                        .replace(/<anonymous function(: (\w+))?>/, '$2')
                        .replace(/\([^\)]*\)/g, '') || undefined;
                var argsRaw;
                if (functionCall.match(/\(([^\)]*)\)/)) {
                    argsRaw = functionCall.replace(/^[^\(]+\(([^\)]*)\)$/, '$1');
                }
                var args = (argsRaw === undefined || argsRaw === '[arguments not available]') ?
                    undefined : argsRaw.split(',');
                return new StackFrame(
                    functionName,
                    args,
                    locationParts[0],
                    locationParts[1],
                    locationParts[2],
                    line);
            }, this);
        }
    };
}));



/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * https://github.com/es-shims/es5-shim
 * @license es5-shim Copyright 2009-2015 by contributors, MIT License
 * see https://github.com/es-shims/es5-shim/blob/master/LICENSE
 */

// vim: ts=4 sts=4 sw=4 expandtab

// Add semicolon to prevent IIFE from being passed as argument to concatenated code.
;

// UMD (Universal Module Definition)
// see https://github.com/umdjs/umd/blob/master/templates/returnExports.js
(function (root, factory) {
    'use strict';

    /* global define, exports, module */
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like enviroments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        // Browser globals (root is window)
        root.returnExports = factory();
    }
}(this, function () {

    var call = Function.call;
    var prototypeOfObject = Object.prototype;
    var owns = call.bind(prototypeOfObject.hasOwnProperty);
    var isEnumerable = call.bind(prototypeOfObject.propertyIsEnumerable);
    var toStr = call.bind(prototypeOfObject.toString);

    // If JS engine supports accessors creating shortcuts.
    var defineGetter;
    var defineSetter;
    var lookupGetter;
    var lookupSetter;
    var supportsAccessors = owns(prototypeOfObject, '__defineGetter__');
    if (supportsAccessors) {
        /* eslint-disable no-underscore-dangle, no-restricted-properties */
        defineGetter = call.bind(prototypeOfObject.__defineGetter__);
        defineSetter = call.bind(prototypeOfObject.__defineSetter__);
        lookupGetter = call.bind(prototypeOfObject.__lookupGetter__);
        lookupSetter = call.bind(prototypeOfObject.__lookupSetter__);
        /* eslint-enable no-underscore-dangle, no-restricted-properties */
    }

    var isPrimitive = function isPrimitive(o) {
        return o == null || (typeof o !== 'object' && typeof o !== 'function');
    };

    // ES5 15.2.3.2
    // http://es5.github.com/#x15.2.3.2
    if (!Object.getPrototypeOf) {
        // https://github.com/es-shims/es5-shim/issues#issue/2
        // http://ejohn.org/blog/objectgetprototypeof/
        // recommended by fschaefer on github
        //
        // sure, and webreflection says ^_^
        // ... this will nerever possibly return null
        // ... Opera Mini breaks here with infinite loops
        Object.getPrototypeOf = function getPrototypeOf(object) {
            // eslint-disable-next-line no-proto
            var proto = object.__proto__;
            if (proto || proto === null) {
                return proto;
            } else if (toStr(object.constructor) === '[object Function]') {
                return object.constructor.prototype;
            } else if (object instanceof Object) {
                return prototypeOfObject;
            } else {
                // Correctly return null for Objects created with `Object.create(null)`
                // (shammed or native) or `{ __proto__: null}`.  Also returns null for
                // cross-realm objects on browsers that lack `__proto__` support (like
                // IE <11), but that's the best we can do.
                return null;
            }
        };
    }

    // ES5 15.2.3.3
    // http://es5.github.com/#x15.2.3.3

    var doesGetOwnPropertyDescriptorWork = function doesGetOwnPropertyDescriptorWork(object) {
        try {
            object.sentinel = 0;
            return Object.getOwnPropertyDescriptor(object, 'sentinel').value === 0;
        } catch (exception) {
            return false;
        }
    };

    // check whether getOwnPropertyDescriptor works if it's given. Otherwise, shim partially.
    if (Object.defineProperty) {
        var getOwnPropertyDescriptorWorksOnObject = doesGetOwnPropertyDescriptorWork({});
        var getOwnPropertyDescriptorWorksOnDom = typeof document === 'undefined'
            || doesGetOwnPropertyDescriptorWork(document.createElement('div'));
        if (!getOwnPropertyDescriptorWorksOnDom || !getOwnPropertyDescriptorWorksOnObject) {
            var getOwnPropertyDescriptorFallback = Object.getOwnPropertyDescriptor;
        }
    }

    if (!Object.getOwnPropertyDescriptor || getOwnPropertyDescriptorFallback) {
        var ERR_NON_OBJECT = 'Object.getOwnPropertyDescriptor called on a non-object: ';

        /* eslint-disable no-proto */
        Object.getOwnPropertyDescriptor = function getOwnPropertyDescriptor(object, property) {
            if (isPrimitive(object)) {
                throw new TypeError(ERR_NON_OBJECT + object);
            }

            // make a valiant attempt to use the real getOwnPropertyDescriptor
            // for I8's DOM elements.
            if (getOwnPropertyDescriptorFallback) {
                try {
                    return getOwnPropertyDescriptorFallback.call(Object, object, property);
                } catch (exception) {
                    // try the shim if the real one doesn't work
                }
            }

            var descriptor;

            // If object does not owns property return undefined immediately.
            if (!owns(object, property)) {
                return descriptor;
            }

            // If object has a property then it's for sure `configurable`, and
            // probably `enumerable`. Detect enumerability though.
            descriptor = {
                enumerable: isEnumerable(object, property),
                configurable: true
            };

            // If JS engine supports accessor properties then property may be a
            // getter or setter.
            if (supportsAccessors) {
                // Unfortunately `__lookupGetter__` will return a getter even
                // if object has own non getter property along with a same named
                // inherited getter. To avoid misbehavior we temporary remove
                // `__proto__` so that `__lookupGetter__` will return getter only
                // if it's owned by an object.
                var prototype = object.__proto__;
                var notPrototypeOfObject = object !== prototypeOfObject;
                // avoid recursion problem, breaking in Opera Mini when
                // Object.getOwnPropertyDescriptor(Object.prototype, 'toString')
                // or any other Object.prototype accessor
                if (notPrototypeOfObject) {
                    object.__proto__ = prototypeOfObject;
                }

                var getter = lookupGetter(object, property);
                var setter = lookupSetter(object, property);

                if (notPrototypeOfObject) {
                    // Once we have getter and setter we can put values back.
                    object.__proto__ = prototype;
                }

                if (getter || setter) {
                    if (getter) {
                        descriptor.get = getter;
                    }
                    if (setter) {
                        descriptor.set = setter;
                    }
                    // If it was accessor property we're done and return here
                    // in order to avoid adding `value` to the descriptor.
                    return descriptor;
                }
            }

            // If we got this far we know that object has an own property that is
            // not an accessor so we set it as a value and return descriptor.
            descriptor.value = object[property];
            descriptor.writable = true;
            return descriptor;
        };
        /* eslint-enable no-proto */
    }

    // ES5 15.2.3.4
    // http://es5.github.com/#x15.2.3.4
    if (!Object.getOwnPropertyNames) {
        Object.getOwnPropertyNames = function getOwnPropertyNames(object) {
            return Object.keys(object);
        };
    }

    // ES5 15.2.3.5
    // http://es5.github.com/#x15.2.3.5
    if (!Object.create) {

        // Contributed by Brandon Benvie, October, 2012
        var createEmpty;
        var supportsProto = !({ __proto__: null } instanceof Object);
        // the following produces false positives
        // in Opera Mini => not a reliable check
        // Object.prototype.__proto__ === null

        // Check for document.domain and active x support
        // No need to use active x approach when document.domain is not set
        // see https://github.com/es-shims/es5-shim/issues/150
        // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
        /* global ActiveXObject */
        var shouldUseActiveX = function shouldUseActiveX() {
            // return early if document.domain not set
            if (!document.domain) {
                return false;
            }

            try {
                return !!new ActiveXObject('htmlfile');
            } catch (exception) {
                return false;
            }
        };

        // This supports IE8 when document.domain is used
        // see https://github.com/es-shims/es5-shim/issues/150
        // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
        var getEmptyViaActiveX = function getEmptyViaActiveX() {
            var empty;
            var xDoc;

            xDoc = new ActiveXObject('htmlfile');

            var script = 'script';
            xDoc.write('<' + script + '></' + script + '>');
            xDoc.close();

            empty = xDoc.parentWindow.Object.prototype;
            xDoc = null;

            return empty;
        };

        // The original implementation using an iframe
        // before the activex approach was added
        // see https://github.com/es-shims/es5-shim/issues/150
        var getEmptyViaIFrame = function getEmptyViaIFrame() {
            var iframe = document.createElement('iframe');
            var parent = document.body || document.documentElement;
            var empty;

            iframe.style.display = 'none';
            parent.appendChild(iframe);
            // eslint-disable-next-line no-script-url
            iframe.src = 'javascript:';

            empty = iframe.contentWindow.Object.prototype;
            parent.removeChild(iframe);
            iframe = null;

            return empty;
        };

        /* global document */
        if (supportsProto || typeof document === 'undefined') {
            createEmpty = function () {
                return { __proto__: null };
            };
        } else {
            // In old IE __proto__ can't be used to manually set `null`, nor does
            // any other method exist to make an object that inherits from nothing,
            // aside from Object.prototype itself. Instead, create a new global
            // object and *steal* its Object.prototype and strip it bare. This is
            // used as the prototype to create nullary objects.
            createEmpty = function () {
                // Determine which approach to use
                // see https://github.com/es-shims/es5-shim/issues/150
                var empty = shouldUseActiveX() ? getEmptyViaActiveX() : getEmptyViaIFrame();

                delete empty.constructor;
                delete empty.hasOwnProperty;
                delete empty.propertyIsEnumerable;
                delete empty.isPrototypeOf;
                delete empty.toLocaleString;
                delete empty.toString;
                delete empty.valueOf;

                var Empty = function Empty() {};
                Empty.prototype = empty;
                // short-circuit future calls
                createEmpty = function () {
                    return new Empty();
                };
                return new Empty();
            };
        }

        Object.create = function create(prototype, properties) {

            var object;
            var Type = function Type() {}; // An empty constructor.

            if (prototype === null) {
                object = createEmpty();
            } else {
                if (prototype !== null && isPrimitive(prototype)) {
                    // In the native implementation `parent` can be `null`
                    // OR *any* `instanceof Object`  (Object|Function|Array|RegExp|etc)
                    // Use `typeof` tho, b/c in old IE, DOM elements are not `instanceof Object`
                    // like they are in modern browsers. Using `Object.create` on DOM elements
                    // is...err...probably inappropriate, but the native version allows for it.
                    throw new TypeError('Object prototype may only be an Object or null'); // same msg as Chrome
                }
                Type.prototype = prototype;
                object = new Type();
                // IE has no built-in implementation of `Object.getPrototypeOf`
                // neither `__proto__`, but this manually setting `__proto__` will
                // guarantee that `Object.getPrototypeOf` will work as expected with
                // objects created using `Object.create`
                // eslint-disable-next-line no-proto
                object.__proto__ = prototype;
            }

            if (properties !== void 0) {
                Object.defineProperties(object, properties);
            }

            return object;
        };
    }

    // ES5 15.2.3.6
    // http://es5.github.com/#x15.2.3.6

    // Patch for WebKit and IE8 standard mode
    // Designed by hax <hax.github.com>
    // related issue: https://github.com/es-shims/es5-shim/issues#issue/5
    // IE8 Reference:
    //     http://msdn.microsoft.com/en-us/library/dd282900.aspx
    //     http://msdn.microsoft.com/en-us/library/dd229916.aspx
    // WebKit Bugs:
    //     https://bugs.webkit.org/show_bug.cgi?id=36423

    var doesDefinePropertyWork = function doesDefinePropertyWork(object) {
        try {
            Object.defineProperty(object, 'sentinel', {});
            return 'sentinel' in object;
        } catch (exception) {
            return false;
        }
    };

    // check whether defineProperty works if it's given. Otherwise,
    // shim partially.
    if (Object.defineProperty) {
        var definePropertyWorksOnObject = doesDefinePropertyWork({});
        var definePropertyWorksOnDom = typeof document === 'undefined'
            || doesDefinePropertyWork(document.createElement('div'));
        if (!definePropertyWorksOnObject || !definePropertyWorksOnDom) {
            var definePropertyFallback = Object.defineProperty,
                definePropertiesFallback = Object.defineProperties;
        }
    }

    if (!Object.defineProperty || definePropertyFallback) {
        var ERR_NON_OBJECT_DESCRIPTOR = 'Property description must be an object: ';
        var ERR_NON_OBJECT_TARGET = 'Object.defineProperty called on non-object: ';
        var ERR_ACCESSORS_NOT_SUPPORTED = 'getters & setters can not be defined on this javascript engine';

        Object.defineProperty = function defineProperty(object, property, descriptor) {
            if (isPrimitive(object)) {
                throw new TypeError(ERR_NON_OBJECT_TARGET + object);
            }
            if (isPrimitive(descriptor)) {
                throw new TypeError(ERR_NON_OBJECT_DESCRIPTOR + descriptor);
            }
            // make a valiant attempt to use the real defineProperty
            // for I8's DOM elements.
            if (definePropertyFallback) {
                try {
                    return definePropertyFallback.call(Object, object, property, descriptor);
                } catch (exception) {
                    // try the shim if the real one doesn't work
                }
            }

            // If it's a data property.
            if ('value' in descriptor) {
                // fail silently if 'writable', 'enumerable', or 'configurable'
                // are requested but not supported
                /*
                // alternate approach:
                if ( // can't implement these features; allow false but not true
                    ('writable' in descriptor && !descriptor.writable) ||
                    ('enumerable' in descriptor && !descriptor.enumerable) ||
                    ('configurable' in descriptor && !descriptor.configurable)
                ))
                    throw new RangeError(
                        'This implementation of Object.defineProperty does not support configurable, enumerable, or writable.'
                    );
                */

                if (supportsAccessors && (lookupGetter(object, property) || lookupSetter(object, property))) {
                    // As accessors are supported only on engines implementing
                    // `__proto__` we can safely override `__proto__` while defining
                    // a property to make sure that we don't hit an inherited
                    // accessor.
                    /* eslint-disable no-proto */
                    var prototype = object.__proto__;
                    object.__proto__ = prototypeOfObject;
                    // Deleting a property anyway since getter / setter may be
                    // defined on object itself.
                    delete object[property];
                    object[property] = descriptor.value;
                    // Setting original `__proto__` back now.
                    object.__proto__ = prototype;
                    /* eslint-enable no-proto */
                } else {
                    object[property] = descriptor.value;
                }
            } else {
                var hasGetter = 'get' in descriptor;
                var hasSetter = 'set' in descriptor;
                if (!supportsAccessors && (hasGetter || hasSetter)) {
                    throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
                }
                // If we got that far then getters and setters can be defined !!
                if (hasGetter) {
                    defineGetter(object, property, descriptor.get);
                }
                if (hasSetter) {
                    defineSetter(object, property, descriptor.set);
                }
            }
            return object;
        };
    }

    // ES5 15.2.3.7
    // http://es5.github.com/#x15.2.3.7
    if (!Object.defineProperties || definePropertiesFallback) {
        Object.defineProperties = function defineProperties(object, properties) {
            // make a valiant attempt to use the real defineProperties
            if (definePropertiesFallback) {
                try {
                    return definePropertiesFallback.call(Object, object, properties);
                } catch (exception) {
                    // try the shim if the real one doesn't work
                }
            }

            Object.keys(properties).forEach(function (property) {
                if (property !== '__proto__') {
                    Object.defineProperty(object, property, properties[property]);
                }
            });
            return object;
        };
    }

    // ES5 15.2.3.8
    // http://es5.github.com/#x15.2.3.8
    if (!Object.seal) {
        Object.seal = function seal(object) {
            if (Object(object) !== object) {
                throw new TypeError('Object.seal can only be called on Objects.');
            }
            // this is misleading and breaks feature-detection, but
            // allows "securable" code to "gracefully" degrade to working
            // but insecure code.
            return object;
        };
    }

    // ES5 15.2.3.9
    // http://es5.github.com/#x15.2.3.9
    if (!Object.freeze) {
        Object.freeze = function freeze(object) {
            if (Object(object) !== object) {
                throw new TypeError('Object.freeze can only be called on Objects.');
            }
            // this is misleading and breaks feature-detection, but
            // allows "securable" code to "gracefully" degrade to working
            // but insecure code.
            return object;
        };
    }

    // detect a Rhino bug and patch it
    try {
        Object.freeze(function () {});
    } catch (exception) {
        Object.freeze = (function (freezeObject) {
            return function freeze(object) {
                if (typeof object === 'function') {
                    return object;
                } else {
                    return freezeObject(object);
                }
            };
        }(Object.freeze));
    }

    // ES5 15.2.3.10
    // http://es5.github.com/#x15.2.3.10
    if (!Object.preventExtensions) {
        Object.preventExtensions = function preventExtensions(object) {
            if (Object(object) !== object) {
                throw new TypeError('Object.preventExtensions can only be called on Objects.');
            }
            // this is misleading and breaks feature-detection, but
            // allows "securable" code to "gracefully" degrade to working
            // but insecure code.
            return object;
        };
    }

    // ES5 15.2.3.11
    // http://es5.github.com/#x15.2.3.11
    if (!Object.isSealed) {
        Object.isSealed = function isSealed(object) {
            if (Object(object) !== object) {
                throw new TypeError('Object.isSealed can only be called on Objects.');
            }
            return false;
        };
    }

    // ES5 15.2.3.12
    // http://es5.github.com/#x15.2.3.12
    if (!Object.isFrozen) {
        Object.isFrozen = function isFrozen(object) {
            if (Object(object) !== object) {
                throw new TypeError('Object.isFrozen can only be called on Objects.');
            }
            return false;
        };
    }

    // ES5 15.2.3.13
    // http://es5.github.com/#x15.2.3.13
    if (!Object.isExtensible) {
        Object.isExtensible = function isExtensible(object) {
            // 1. If Type(O) is not Object throw a TypeError exception.
            if (Object(object) !== object) {
                throw new TypeError('Object.isExtensible can only be called on Objects.');
            }
            // 2. Return the Boolean value of the [[Extensible]] internal property of O.
            var name = '';
            while (owns(object, name)) {
                name += '?';
            }
            object[name] = true;
            var returnValue = owns(object, name);
            delete object[name];
            return returnValue;
        };
    }

}));


/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * https://github.com/es-shims/es5-shim
 * @license es5-shim Copyright 2009-2015 by contributors, MIT License
 * see https://github.com/es-shims/es5-shim/blob/master/LICENSE
 */

// vim: ts=4 sts=4 sw=4 expandtab

// Add semicolon to prevent IIFE from being passed as argument to concatenated code.
;

// UMD (Universal Module Definition)
// see https://github.com/umdjs/umd/blob/master/templates/returnExports.js
(function (root, factory) {
    'use strict';

    /* global define, exports, module */
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like enviroments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        // Browser globals (root is window)
        root.returnExports = factory();
    }
}(this, function () {
    /**
     * Brings an environment as close to ECMAScript 5 compliance
     * as is possible with the facilities of erstwhile engines.
     *
     * Annotated ES5: http://es5.github.com/ (specific links below)
     * ES5 Spec: http://www.ecma-international.org/publications/files/ECMA-ST/Ecma-262.pdf
     * Required reading: http://javascriptweblog.wordpress.com/2011/12/05/extending-javascript-natives/
     */

    // Shortcut to an often accessed properties, in order to avoid multiple
    // dereference that costs universally. This also holds a reference to known-good
    // functions.
    var $Array = Array;
    var ArrayPrototype = $Array.prototype;
    var $Object = Object;
    var ObjectPrototype = $Object.prototype;
    var $Function = Function;
    var FunctionPrototype = $Function.prototype;
    var $String = String;
    var StringPrototype = $String.prototype;
    var $Number = Number;
    var NumberPrototype = $Number.prototype;
    var array_slice = ArrayPrototype.slice;
    var array_splice = ArrayPrototype.splice;
    var array_push = ArrayPrototype.push;
    var array_unshift = ArrayPrototype.unshift;
    var array_concat = ArrayPrototype.concat;
    var array_join = ArrayPrototype.join;
    var call = FunctionPrototype.call;
    var apply = FunctionPrototype.apply;
    var max = Math.max;
    var min = Math.min;

    // Having a toString local variable name breaks in Opera so use to_string.
    var to_string = ObjectPrototype.toString;

    /* global Symbol */
    /* eslint-disable one-var-declaration-per-line, no-redeclare, max-statements-per-line */
    var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
    var isCallable; /* inlined from https://npmjs.com/is-callable */ var fnToStr = Function.prototype.toString, constructorRegex = /^\s*class /, isES6ClassFn = function isES6ClassFn(value) { try { var fnStr = fnToStr.call(value); var singleStripped = fnStr.replace(/\/\/.*\n/g, ''); var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, ''); var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' '); return constructorRegex.test(spaceStripped); } catch (e) { return false; /* not a function */ } }, tryFunctionObject = function tryFunctionObject(value) { try { if (isES6ClassFn(value)) { return false; } fnToStr.call(value); return true; } catch (e) { return false; } }, fnClass = '[object Function]', genClass = '[object GeneratorFunction]', isCallable = function isCallable(value) { if (!value) { return false; } if (typeof value !== 'function' && typeof value !== 'object') { return false; } if (hasToStringTag) { return tryFunctionObject(value); } if (isES6ClassFn(value)) { return false; } var strClass = to_string.call(value); return strClass === fnClass || strClass === genClass; };

    var isRegex; /* inlined from https://npmjs.com/is-regex */ var regexExec = RegExp.prototype.exec, tryRegexExec = function tryRegexExec(value) { try { regexExec.call(value); return true; } catch (e) { return false; } }, regexClass = '[object RegExp]'; isRegex = function isRegex(value) { if (typeof value !== 'object') { return false; } return hasToStringTag ? tryRegexExec(value) : to_string.call(value) === regexClass; };
    var isString; /* inlined from https://npmjs.com/is-string */ var strValue = String.prototype.valueOf, tryStringObject = function tryStringObject(value) { try { strValue.call(value); return true; } catch (e) { return false; } }, stringClass = '[object String]'; isString = function isString(value) { if (typeof value === 'string') { return true; } if (typeof value !== 'object') { return false; } return hasToStringTag ? tryStringObject(value) : to_string.call(value) === stringClass; };
    /* eslint-enable one-var-declaration-per-line, no-redeclare, max-statements-per-line */

    /* inlined from http://npmjs.com/define-properties */
    var supportsDescriptors = $Object.defineProperty && (function () {
        try {
            var obj = {};
            $Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
            for (var _ in obj) { // jscs:ignore disallowUnusedVariables
                return false;
            }
            return obj.x === obj;
        } catch (e) { /* this is ES3 */
            return false;
        }
    }());
    var defineProperties = (function (has) {
        // Define configurable, writable, and non-enumerable props
        // if they don't exist.
        var defineProperty;
        if (supportsDescriptors) {
            defineProperty = function (object, name, method, forceAssign) {
                if (!forceAssign && (name in object)) {
                    return;
                }
                $Object.defineProperty(object, name, {
                    configurable: true,
                    enumerable: false,
                    writable: true,
                    value: method
                });
            };
        } else {
            defineProperty = function (object, name, method, forceAssign) {
                if (!forceAssign && (name in object)) {
                    return;
                }
                object[name] = method;
            };
        }
        return function defineProperties(object, map, forceAssign) {
            for (var name in map) {
                if (has.call(map, name)) {
                    defineProperty(object, name, map[name], forceAssign);
                }
            }
        };
    }(ObjectPrototype.hasOwnProperty));

    //
    // Util
    // ======
    //

    /* replaceable with https://npmjs.com/package/es-abstract /helpers/isPrimitive */
    var isPrimitive = function isPrimitive(input) {
        var type = typeof input;
        return input === null || (type !== 'object' && type !== 'function');
    };

    var isActualNaN = $Number.isNaN || function isActualNaN(x) {
        return x !== x;
    };

    var ES = {
        // ES5 9.4
        // http://es5.github.com/#x9.4
        // http://jsperf.com/to-integer
        /* replaceable with https://npmjs.com/package/es-abstract ES5.ToInteger */
        ToInteger: function ToInteger(num) {
            var n = +num;
            if (isActualNaN(n)) {
                n = 0;
            } else if (n !== 0 && n !== (1 / 0) && n !== -(1 / 0)) {
                n = (n > 0 || -1) * Math.floor(Math.abs(n));
            }
            return n;
        },

        /* replaceable with https://npmjs.com/package/es-abstract ES5.ToPrimitive */
        ToPrimitive: function ToPrimitive(input) {
            var val, valueOf, toStr;
            if (isPrimitive(input)) {
                return input;
            }
            valueOf = input.valueOf;
            if (isCallable(valueOf)) {
                val = valueOf.call(input);
                if (isPrimitive(val)) {
                    return val;
                }
            }
            toStr = input.toString;
            if (isCallable(toStr)) {
                val = toStr.call(input);
                if (isPrimitive(val)) {
                    return val;
                }
            }
            throw new TypeError();
        },

        // ES5 9.9
        // http://es5.github.com/#x9.9
        /* replaceable with https://npmjs.com/package/es-abstract ES5.ToObject */
        ToObject: function (o) {
            if (o == null) { // this matches both null and undefined
                throw new TypeError("can't convert " + o + ' to object');
            }
            return $Object(o);
        },

        /* replaceable with https://npmjs.com/package/es-abstract ES5.ToUint32 */
        ToUint32: function ToUint32(x) {
            return x >>> 0;
        }
    };

    //
    // Function
    // ========
    //

    // ES-5 15.3.4.5
    // http://es5.github.com/#x15.3.4.5

    var Empty = function Empty() {};

    defineProperties(FunctionPrototype, {
        bind: function bind(that) { // .length is 1
            // 1. Let Target be the this value.
            var target = this;
            // 2. If IsCallable(Target) is false, throw a TypeError exception.
            if (!isCallable(target)) {
                throw new TypeError('Function.prototype.bind called on incompatible ' + target);
            }
            // 3. Let A be a new (possibly empty) internal list of all of the
            //   argument values provided after thisArg (arg1, arg2 etc), in order.
            // XXX slicedArgs will stand in for "A" if used
            var args = array_slice.call(arguments, 1); // for normal call
            // 4. Let F be a new native ECMAScript object.
            // 11. Set the [[Prototype]] internal property of F to the standard
            //   built-in Function prototype object as specified in 15.3.3.1.
            // 12. Set the [[Call]] internal property of F as described in
            //   15.3.4.5.1.
            // 13. Set the [[Construct]] internal property of F as described in
            //   15.3.4.5.2.
            // 14. Set the [[HasInstance]] internal property of F as described in
            //   15.3.4.5.3.
            var bound;
            var binder = function () {

                if (this instanceof bound) {
                    // 15.3.4.5.2 [[Construct]]
                    // When the [[Construct]] internal method of a function object,
                    // F that was created using the bind function is called with a
                    // list of arguments ExtraArgs, the following steps are taken:
                    // 1. Let target be the value of F's [[TargetFunction]]
                    //   internal property.
                    // 2. If target has no [[Construct]] internal method, a
                    //   TypeError exception is thrown.
                    // 3. Let boundArgs be the value of F's [[BoundArgs]] internal
                    //   property.
                    // 4. Let args be a new list containing the same values as the
                    //   list boundArgs in the same order followed by the same
                    //   values as the list ExtraArgs in the same order.
                    // 5. Return the result of calling the [[Construct]] internal
                    //   method of target providing args as the arguments.

                    var result = apply.call(
                        target,
                        this,
                        array_concat.call(args, array_slice.call(arguments))
                    );
                    if ($Object(result) === result) {
                        return result;
                    }
                    return this;

                } else {
                    // 15.3.4.5.1 [[Call]]
                    // When the [[Call]] internal method of a function object, F,
                    // which was created using the bind function is called with a
                    // this value and a list of arguments ExtraArgs, the following
                    // steps are taken:
                    // 1. Let boundArgs be the value of F's [[BoundArgs]] internal
                    //   property.
                    // 2. Let boundThis be the value of F's [[BoundThis]] internal
                    //   property.
                    // 3. Let target be the value of F's [[TargetFunction]] internal
                    //   property.
                    // 4. Let args be a new list containing the same values as the
                    //   list boundArgs in the same order followed by the same
                    //   values as the list ExtraArgs in the same order.
                    // 5. Return the result of calling the [[Call]] internal method
                    //   of target providing boundThis as the this value and
                    //   providing args as the arguments.

                    // equiv: target.call(this, ...boundArgs, ...args)
                    return apply.call(
                        target,
                        that,
                        array_concat.call(args, array_slice.call(arguments))
                    );

                }

            };

            // 15. If the [[Class]] internal property of Target is "Function", then
            //     a. Let L be the length property of Target minus the length of A.
            //     b. Set the length own property of F to either 0 or L, whichever is
            //       larger.
            // 16. Else set the length own property of F to 0.

            var boundLength = max(0, target.length - args.length);

            // 17. Set the attributes of the length own property of F to the values
            //   specified in 15.3.5.1.
            var boundArgs = [];
            for (var i = 0; i < boundLength; i++) {
                array_push.call(boundArgs, '$' + i);
            }

            // XXX Build a dynamic function with desired amount of arguments is the only
            // way to set the length property of a function.
            // In environments where Content Security Policies enabled (Chrome extensions,
            // for ex.) all use of eval or Function costructor throws an exception.
            // However in all of these environments Function.prototype.bind exists
            // and so this code will never be executed.
            bound = $Function('binder', 'return function (' + array_join.call(boundArgs, ',') + '){ return binder.apply(this, arguments); }')(binder);

            if (target.prototype) {
                Empty.prototype = target.prototype;
                bound.prototype = new Empty();
                // Clean up dangling references.
                Empty.prototype = null;
            }

            // TODO
            // 18. Set the [[Extensible]] internal property of F to true.

            // TODO
            // 19. Let thrower be the [[ThrowTypeError]] function Object (13.2.3).
            // 20. Call the [[DefineOwnProperty]] internal method of F with
            //   arguments "caller", PropertyDescriptor {[[Get]]: thrower, [[Set]]:
            //   thrower, [[Enumerable]]: false, [[Configurable]]: false}, and
            //   false.
            // 21. Call the [[DefineOwnProperty]] internal method of F with
            //   arguments "arguments", PropertyDescriptor {[[Get]]: thrower,
            //   [[Set]]: thrower, [[Enumerable]]: false, [[Configurable]]: false},
            //   and false.

            // TODO
            // NOTE Function objects created using Function.prototype.bind do not
            // have a prototype property or the [[Code]], [[FormalParameters]], and
            // [[Scope]] internal properties.
            // XXX can't delete prototype in pure-js.

            // 22. Return F.
            return bound;
        }
    });

    // _Please note: Shortcuts are defined after `Function.prototype.bind` as we
    // use it in defining shortcuts.
    var owns = call.bind(ObjectPrototype.hasOwnProperty);
    var toStr = call.bind(ObjectPrototype.toString);
    var arraySlice = call.bind(array_slice);
    var arraySliceApply = apply.bind(array_slice);
    /* globals document */
    if (typeof document === 'object' && document && document.documentElement) {
        try {
            arraySlice(document.documentElement.childNodes);
        } catch (e) {
            var origArraySlice = arraySlice;
            var origArraySliceApply = arraySliceApply;
            arraySlice = function arraySliceIE(arr) {
                var r = [];
                var i = arr.length;
                while (i-- > 0) {
                    r[i] = arr[i];
                }
                return origArraySliceApply(r, origArraySlice(arguments, 1));
            };
            arraySliceApply = function arraySliceApplyIE(arr, args) {
                return origArraySliceApply(arraySlice(arr), args);
            };
        }
    }
    var strSlice = call.bind(StringPrototype.slice);
    var strSplit = call.bind(StringPrototype.split);
    var strIndexOf = call.bind(StringPrototype.indexOf);
    var pushCall = call.bind(array_push);
    var isEnum = call.bind(ObjectPrototype.propertyIsEnumerable);
    var arraySort = call.bind(ArrayPrototype.sort);

    //
    // Array
    // =====
    //

    var isArray = $Array.isArray || function isArray(obj) {
        return toStr(obj) === '[object Array]';
    };

    // ES5 15.4.4.12
    // http://es5.github.com/#x15.4.4.13
    // Return len+argCount.
    // [bugfix, ielt8]
    // IE < 8 bug: [].unshift(0) === undefined but should be "1"
    var hasUnshiftReturnValueBug = [].unshift(0) !== 1;
    defineProperties(ArrayPrototype, {
        unshift: function () {
            array_unshift.apply(this, arguments);
            return this.length;
        }
    }, hasUnshiftReturnValueBug);

    // ES5 15.4.3.2
    // http://es5.github.com/#x15.4.3.2
    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/isArray
    defineProperties($Array, { isArray: isArray });

    // The IsCallable() check in the Array functions
    // has been replaced with a strict check on the
    // internal class of the object to trap cases where
    // the provided function was actually a regular
    // expression literal, which in V8 and
    // JavaScriptCore is a typeof "function".  Only in
    // V8 are regular expression literals permitted as
    // reduce parameters, so it is desirable in the
    // general case for the shim to match the more
    // strict and common behavior of rejecting regular
    // expressions.

    // ES5 15.4.4.18
    // http://es5.github.com/#x15.4.4.18
    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/array/forEach

    // Check failure of by-index access of string characters (IE < 9)
    // and failure of `0 in boxedString` (Rhino)
    var boxedString = $Object('a');
    var splitString = boxedString[0] !== 'a' || !(0 in boxedString);

    var properlyBoxesContext = function properlyBoxed(method) {
        // Check node 0.6.21 bug where third parameter is not boxed
        var properlyBoxesNonStrict = true;
        var properlyBoxesStrict = true;
        var threwException = false;
        if (method) {
            try {
                method.call('foo', function (_, __, context) {
                    if (typeof context !== 'object') {
                        properlyBoxesNonStrict = false;
                    }
                });

                method.call([1], function () {
                    'use strict';

                    properlyBoxesStrict = typeof this === 'string';
                }, 'x');
            } catch (e) {
                threwException = true;
            }
        }
        return !!method && !threwException && properlyBoxesNonStrict && properlyBoxesStrict;
    };

    defineProperties(ArrayPrototype, {
        forEach: function forEach(callbackfn/*, thisArg*/) {
            var object = ES.ToObject(this);
            var self = splitString && isString(this) ? strSplit(this, '') : object;
            var i = -1;
            var length = ES.ToUint32(self.length);
            var T;
            if (arguments.length > 1) {
                T = arguments[1];
            }

            // If no callback function or if callback is not a callable function
            if (!isCallable(callbackfn)) {
                throw new TypeError('Array.prototype.forEach callback must be a function');
            }

            while (++i < length) {
                if (i in self) {
                    // Invoke the callback function with call, passing arguments:
                    // context, property value, property key, thisArg object
                    if (typeof T === 'undefined') {
                        callbackfn(self[i], i, object);
                    } else {
                        callbackfn.call(T, self[i], i, object);
                    }
                }
            }
        }
    }, !properlyBoxesContext(ArrayPrototype.forEach));

    // ES5 15.4.4.19
    // http://es5.github.com/#x15.4.4.19
    // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/map
    defineProperties(ArrayPrototype, {
        map: function map(callbackfn/*, thisArg*/) {
            var object = ES.ToObject(this);
            var self = splitString && isString(this) ? strSplit(this, '') : object;
            var length = ES.ToUint32(self.length);
            var result = $Array(length);
            var T;
            if (arguments.length > 1) {
                T = arguments[1];
            }

            // If no callback function or if callback is not a callable function
            if (!isCallable(callbackfn)) {
                throw new TypeError('Array.prototype.map callback must be a function');
            }

            for (var i = 0; i < length; i++) {
                if (i in self) {
                    if (typeof T === 'undefined') {
                        result[i] = callbackfn(self[i], i, object);
                    } else {
                        result[i] = callbackfn.call(T, self[i], i, object);
                    }
                }
            }
            return result;
        }
    }, !properlyBoxesContext(ArrayPrototype.map));

    // ES5 15.4.4.20
    // http://es5.github.com/#x15.4.4.20
    // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/filter
    defineProperties(ArrayPrototype, {
        filter: function filter(callbackfn/*, thisArg*/) {
            var object = ES.ToObject(this);
            var self = splitString && isString(this) ? strSplit(this, '') : object;
            var length = ES.ToUint32(self.length);
            var result = [];
            var value;
            var T;
            if (arguments.length > 1) {
                T = arguments[1];
            }

            // If no callback function or if callback is not a callable function
            if (!isCallable(callbackfn)) {
                throw new TypeError('Array.prototype.filter callback must be a function');
            }

            for (var i = 0; i < length; i++) {
                if (i in self) {
                    value = self[i];
                    if (typeof T === 'undefined' ? callbackfn(value, i, object) : callbackfn.call(T, value, i, object)) {
                        pushCall(result, value);
                    }
                }
            }
            return result;
        }
    }, !properlyBoxesContext(ArrayPrototype.filter));

    // ES5 15.4.4.16
    // http://es5.github.com/#x15.4.4.16
    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/every
    defineProperties(ArrayPrototype, {
        every: function every(callbackfn/*, thisArg*/) {
            var object = ES.ToObject(this);
            var self = splitString && isString(this) ? strSplit(this, '') : object;
            var length = ES.ToUint32(self.length);
            var T;
            if (arguments.length > 1) {
                T = arguments[1];
            }

            // If no callback function or if callback is not a callable function
            if (!isCallable(callbackfn)) {
                throw new TypeError('Array.prototype.every callback must be a function');
            }

            for (var i = 0; i < length; i++) {
                if (i in self && !(typeof T === 'undefined' ? callbackfn(self[i], i, object) : callbackfn.call(T, self[i], i, object))) {
                    return false;
                }
            }
            return true;
        }
    }, !properlyBoxesContext(ArrayPrototype.every));

    // ES5 15.4.4.17
    // http://es5.github.com/#x15.4.4.17
    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/some
    defineProperties(ArrayPrototype, {
        some: function some(callbackfn/*, thisArg */) {
            var object = ES.ToObject(this);
            var self = splitString && isString(this) ? strSplit(this, '') : object;
            var length = ES.ToUint32(self.length);
            var T;
            if (arguments.length > 1) {
                T = arguments[1];
            }

            // If no callback function or if callback is not a callable function
            if (!isCallable(callbackfn)) {
                throw new TypeError('Array.prototype.some callback must be a function');
            }

            for (var i = 0; i < length; i++) {
                if (i in self && (typeof T === 'undefined' ? callbackfn(self[i], i, object) : callbackfn.call(T, self[i], i, object))) {
                    return true;
                }
            }
            return false;
        }
    }, !properlyBoxesContext(ArrayPrototype.some));

    // ES5 15.4.4.21
    // http://es5.github.com/#x15.4.4.21
    // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/reduce
    var reduceCoercesToObject = false;
    if (ArrayPrototype.reduce) {
        reduceCoercesToObject = typeof ArrayPrototype.reduce.call('es5', function (_, __, ___, list) {
            return list;
        }) === 'object';
    }
    defineProperties(ArrayPrototype, {
        reduce: function reduce(callbackfn/*, initialValue*/) {
            var object = ES.ToObject(this);
            var self = splitString && isString(this) ? strSplit(this, '') : object;
            var length = ES.ToUint32(self.length);

            // If no callback function or if callback is not a callable function
            if (!isCallable(callbackfn)) {
                throw new TypeError('Array.prototype.reduce callback must be a function');
            }

            // no value to return if no initial value and an empty array
            if (length === 0 && arguments.length === 1) {
                throw new TypeError('reduce of empty array with no initial value');
            }

            var i = 0;
            var result;
            if (arguments.length >= 2) {
                result = arguments[1];
            } else {
                do {
                    if (i in self) {
                        result = self[i++];
                        break;
                    }

                    // if array contains no values, no initial value to return
                    if (++i >= length) {
                        throw new TypeError('reduce of empty array with no initial value');
                    }
                } while (true);
            }

            for (; i < length; i++) {
                if (i in self) {
                    result = callbackfn(result, self[i], i, object);
                }
            }

            return result;
        }
    }, !reduceCoercesToObject);

    // ES5 15.4.4.22
    // http://es5.github.com/#x15.4.4.22
    // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/reduceRight
    var reduceRightCoercesToObject = false;
    if (ArrayPrototype.reduceRight) {
        reduceRightCoercesToObject = typeof ArrayPrototype.reduceRight.call('es5', function (_, __, ___, list) {
            return list;
        }) === 'object';
    }
    defineProperties(ArrayPrototype, {
        reduceRight: function reduceRight(callbackfn/*, initial*/) {
            var object = ES.ToObject(this);
            var self = splitString && isString(this) ? strSplit(this, '') : object;
            var length = ES.ToUint32(self.length);

            // If no callback function or if callback is not a callable function
            if (!isCallable(callbackfn)) {
                throw new TypeError('Array.prototype.reduceRight callback must be a function');
            }

            // no value to return if no initial value, empty array
            if (length === 0 && arguments.length === 1) {
                throw new TypeError('reduceRight of empty array with no initial value');
            }

            var result;
            var i = length - 1;
            if (arguments.length >= 2) {
                result = arguments[1];
            } else {
                do {
                    if (i in self) {
                        result = self[i--];
                        break;
                    }

                    // if array contains no values, no initial value to return
                    if (--i < 0) {
                        throw new TypeError('reduceRight of empty array with no initial value');
                    }
                } while (true);
            }

            if (i < 0) {
                return result;
            }

            do {
                if (i in self) {
                    result = callbackfn(result, self[i], i, object);
                }
            } while (i--);

            return result;
        }
    }, !reduceRightCoercesToObject);

    // ES5 15.4.4.14
    // http://es5.github.com/#x15.4.4.14
    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/indexOf
    var hasFirefox2IndexOfBug = ArrayPrototype.indexOf && [0, 1].indexOf(1, 2) !== -1;
    defineProperties(ArrayPrototype, {
        indexOf: function indexOf(searchElement/*, fromIndex */) {
            var self = splitString && isString(this) ? strSplit(this, '') : ES.ToObject(this);
            var length = ES.ToUint32(self.length);

            if (length === 0) {
                return -1;
            }

            var i = 0;
            if (arguments.length > 1) {
                i = ES.ToInteger(arguments[1]);
            }

            // handle negative indices
            i = i >= 0 ? i : max(0, length + i);
            for (; i < length; i++) {
                if (i in self && self[i] === searchElement) {
                    return i;
                }
            }
            return -1;
        }
    }, hasFirefox2IndexOfBug);

    // ES5 15.4.4.15
    // http://es5.github.com/#x15.4.4.15
    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/lastIndexOf
    var hasFirefox2LastIndexOfBug = ArrayPrototype.lastIndexOf && [0, 1].lastIndexOf(0, -3) !== -1;
    defineProperties(ArrayPrototype, {
        lastIndexOf: function lastIndexOf(searchElement/*, fromIndex */) {
            var self = splitString && isString(this) ? strSplit(this, '') : ES.ToObject(this);
            var length = ES.ToUint32(self.length);

            if (length === 0) {
                return -1;
            }
            var i = length - 1;
            if (arguments.length > 1) {
                i = min(i, ES.ToInteger(arguments[1]));
            }
            // handle negative indices
            i = i >= 0 ? i : length - Math.abs(i);
            for (; i >= 0; i--) {
                if (i in self && searchElement === self[i]) {
                    return i;
                }
            }
            return -1;
        }
    }, hasFirefox2LastIndexOfBug);

    // ES5 15.4.4.12
    // http://es5.github.com/#x15.4.4.12
    var spliceNoopReturnsEmptyArray = (function () {
        var a = [1, 2];
        var result = a.splice();
        return a.length === 2 && isArray(result) && result.length === 0;
    }());
    defineProperties(ArrayPrototype, {
        // Safari 5.0 bug where .splice() returns undefined
        splice: function splice(start, deleteCount) {
            if (arguments.length === 0) {
                return [];
            } else {
                return array_splice.apply(this, arguments);
            }
        }
    }, !spliceNoopReturnsEmptyArray);

    var spliceWorksWithEmptyObject = (function () {
        var obj = {};
        ArrayPrototype.splice.call(obj, 0, 0, 1);
        return obj.length === 1;
    }());
    defineProperties(ArrayPrototype, {
        splice: function splice(start, deleteCount) {
            if (arguments.length === 0) {
                return [];
            }
            var args = arguments;
            this.length = max(ES.ToInteger(this.length), 0);
            if (arguments.length > 0 && typeof deleteCount !== 'number') {
                args = arraySlice(arguments);
                if (args.length < 2) {
                    pushCall(args, this.length - start);
                } else {
                    args[1] = ES.ToInteger(deleteCount);
                }
            }
            return array_splice.apply(this, args);
        }
    }, !spliceWorksWithEmptyObject);
    var spliceWorksWithLargeSparseArrays = (function () {
        // Per https://github.com/es-shims/es5-shim/issues/295
        // Safari 7/8 breaks with sparse arrays of size 1e5 or greater
        var arr = new $Array(1e5);
        // note: the index MUST be 8 or larger or the test will false pass
        arr[8] = 'x';
        arr.splice(1, 1);
        // note: this test must be defined *after* the indexOf shim
        // per https://github.com/es-shims/es5-shim/issues/313
        return arr.indexOf('x') === 7;
    }());
    var spliceWorksWithSmallSparseArrays = (function () {
        // Per https://github.com/es-shims/es5-shim/issues/295
        // Opera 12.15 breaks on this, no idea why.
        var n = 256;
        var arr = [];
        arr[n] = 'a';
        arr.splice(n + 1, 0, 'b');
        return arr[n] === 'a';
    }());
    defineProperties(ArrayPrototype, {
        splice: function splice(start, deleteCount) {
            var O = ES.ToObject(this);
            var A = [];
            var len = ES.ToUint32(O.length);
            var relativeStart = ES.ToInteger(start);
            var actualStart = relativeStart < 0 ? max((len + relativeStart), 0) : min(relativeStart, len);
            var actualDeleteCount = min(max(ES.ToInteger(deleteCount), 0), len - actualStart);

            var k = 0;
            var from;
            while (k < actualDeleteCount) {
                from = $String(actualStart + k);
                if (owns(O, from)) {
                    A[k] = O[from];
                }
                k += 1;
            }

            var items = arraySlice(arguments, 2);
            var itemCount = items.length;
            var to;
            if (itemCount < actualDeleteCount) {
                k = actualStart;
                var maxK = len - actualDeleteCount;
                while (k < maxK) {
                    from = $String(k + actualDeleteCount);
                    to = $String(k + itemCount);
                    if (owns(O, from)) {
                        O[to] = O[from];
                    } else {
                        delete O[to];
                    }
                    k += 1;
                }
                k = len;
                var minK = len - actualDeleteCount + itemCount;
                while (k > minK) {
                    delete O[k - 1];
                    k -= 1;
                }
            } else if (itemCount > actualDeleteCount) {
                k = len - actualDeleteCount;
                while (k > actualStart) {
                    from = $String(k + actualDeleteCount - 1);
                    to = $String(k + itemCount - 1);
                    if (owns(O, from)) {
                        O[to] = O[from];
                    } else {
                        delete O[to];
                    }
                    k -= 1;
                }
            }
            k = actualStart;
            for (var i = 0; i < items.length; ++i) {
                O[k] = items[i];
                k += 1;
            }
            O.length = len - actualDeleteCount + itemCount;

            return A;
        }
    }, !spliceWorksWithLargeSparseArrays || !spliceWorksWithSmallSparseArrays);

    var originalJoin = ArrayPrototype.join;
    var hasStringJoinBug;
    try {
        hasStringJoinBug = Array.prototype.join.call('123', ',') !== '1,2,3';
    } catch (e) {
        hasStringJoinBug = true;
    }
    if (hasStringJoinBug) {
        defineProperties(ArrayPrototype, {
            join: function join(separator) {
                var sep = typeof separator === 'undefined' ? ',' : separator;
                return originalJoin.call(isString(this) ? strSplit(this, '') : this, sep);
            }
        }, hasStringJoinBug);
    }

    var hasJoinUndefinedBug = [1, 2].join(undefined) !== '1,2';
    if (hasJoinUndefinedBug) {
        defineProperties(ArrayPrototype, {
            join: function join(separator) {
                var sep = typeof separator === 'undefined' ? ',' : separator;
                return originalJoin.call(this, sep);
            }
        }, hasJoinUndefinedBug);
    }

    var pushShim = function push(item) {
        var O = ES.ToObject(this);
        var n = ES.ToUint32(O.length);
        var i = 0;
        while (i < arguments.length) {
            O[n + i] = arguments[i];
            i += 1;
        }
        O.length = n + i;
        return n + i;
    };

    var pushIsNotGeneric = (function () {
        var obj = {};
        var result = Array.prototype.push.call(obj, undefined);
        return result !== 1 || obj.length !== 1 || typeof obj[0] !== 'undefined' || !owns(obj, 0);
    }());
    defineProperties(ArrayPrototype, {
        push: function push(item) {
            if (isArray(this)) {
                return array_push.apply(this, arguments);
            }
            return pushShim.apply(this, arguments);
        }
    }, pushIsNotGeneric);

    // This fixes a very weird bug in Opera 10.6 when pushing `undefined
    var pushUndefinedIsWeird = (function () {
        var arr = [];
        var result = arr.push(undefined);
        return result !== 1 || arr.length !== 1 || typeof arr[0] !== 'undefined' || !owns(arr, 0);
    }());
    defineProperties(ArrayPrototype, { push: pushShim }, pushUndefinedIsWeird);

    // ES5 15.2.3.14
    // http://es5.github.io/#x15.4.4.10
    // Fix boxed string bug
    defineProperties(ArrayPrototype, {
        slice: function (start, end) {
            var arr = isString(this) ? strSplit(this, '') : this;
            return arraySliceApply(arr, arguments);
        }
    }, splitString);

    var sortIgnoresNonFunctions = (function () {
        try {
            [1, 2].sort(null);
        } catch (e) {
            try {
                [1, 2].sort({});
            } catch (e2) {
                return false;
            }
        }
        return true;
    }());
    var sortThrowsOnRegex = (function () {
        // this is a problem in Firefox 4, in which `typeof /a/ === 'function'`
        try {
            [1, 2].sort(/a/);
            return false;
        } catch (e) {}
        return true;
    }());
    var sortIgnoresUndefined = (function () {
        // applies in IE 8, for one.
        try {
            [1, 2].sort(undefined);
            return true;
        } catch (e) {}
        return false;
    }());
    defineProperties(ArrayPrototype, {
        sort: function sort(compareFn) {
            if (typeof compareFn === 'undefined') {
                return arraySort(this);
            }
            if (!isCallable(compareFn)) {
                throw new TypeError('Array.prototype.sort callback must be a function');
            }
            return arraySort(this, compareFn);
        }
    }, sortIgnoresNonFunctions || !sortIgnoresUndefined || !sortThrowsOnRegex);

    //
    // Object
    // ======
    //

    // ES5 15.2.3.14
    // http://es5.github.com/#x15.2.3.14

    // http://whattheheadsaid.com/2010/10/a-safer-object-keys-compatibility-implementation
    var hasDontEnumBug = !isEnum({ 'toString': null }, 'toString'); // jscs:ignore disallowQuotedKeysInObjects
    var hasProtoEnumBug = isEnum(function () {}, 'prototype');
    var hasStringEnumBug = !owns('x', '0');
    var equalsConstructorPrototype = function (o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var excludedKeys = {
        $window: true,
        $console: true,
        $parent: true,
        $self: true,
        $frame: true,
        $frames: true,
        $frameElement: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $external: true,
        $width: true,
        $height: true,
        $top: true,
        $localStorage: true
    };
    var hasAutomationEqualityBug = (function () {
        /* globals window */
        if (typeof window === 'undefined') {
            return false;
        }
        for (var k in window) {
            try {
                if (!excludedKeys['$' + k] && owns(window, k) && window[k] !== null && typeof window[k] === 'object') {
                    equalsConstructorPrototype(window[k]);
                }
            } catch (e) {
                return true;
            }
        }
        return false;
    }());
    var equalsConstructorPrototypeIfNotBuggy = function (object) {
        if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
            return equalsConstructorPrototype(object);
        }
        try {
            return equalsConstructorPrototype(object);
        } catch (e) {
            return false;
        }
    };
    var dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var dontEnumsLength = dontEnums.length;

    // taken directly from https://github.com/ljharb/is-arguments/blob/master/index.js
    // can be replaced with require('is-arguments') if we ever use a build process instead
    var isStandardArguments = function isArguments(value) {
        return toStr(value) === '[object Arguments]';
    };
    var isLegacyArguments = function isArguments(value) {
        return value !== null
            && typeof value === 'object'
            && typeof value.length === 'number'
            && value.length >= 0
            && !isArray(value)
            && isCallable(value.callee);
    };
    var isArguments = isStandardArguments(arguments) ? isStandardArguments : isLegacyArguments;

    defineProperties($Object, {
        keys: function keys(object) {
            var isFn = isCallable(object);
            var isArgs = isArguments(object);
            var isObject = object !== null && typeof object === 'object';
            var isStr = isObject && isString(object);

            if (!isObject && !isFn && !isArgs) {
                throw new TypeError('Object.keys called on a non-object');
            }

            var theKeys = [];
            var skipProto = hasProtoEnumBug && isFn;
            if ((isStr && hasStringEnumBug) || isArgs) {
                for (var i = 0; i < object.length; ++i) {
                    pushCall(theKeys, $String(i));
                }
            }

            if (!isArgs) {
                for (var name in object) {
                    if (!(skipProto && name === 'prototype') && owns(object, name)) {
                        pushCall(theKeys, $String(name));
                    }
                }
            }

            if (hasDontEnumBug) {
                var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
                for (var j = 0; j < dontEnumsLength; j++) {
                    var dontEnum = dontEnums[j];
                    if (!(skipConstructor && dontEnum === 'constructor') && owns(object, dontEnum)) {
                        pushCall(theKeys, dontEnum);
                    }
                }
            }
            return theKeys;
        }
    });

    var keysWorksWithArguments = $Object.keys && (function () {
        // Safari 5.0 bug
        return $Object.keys(arguments).length === 2;
    }(1, 2));
    var keysHasArgumentsLengthBug = $Object.keys && (function () {
        var argKeys = $Object.keys(arguments);
        return arguments.length !== 1 || argKeys.length !== 1 || argKeys[0] !== 1;
    }(1));
    var originalKeys = $Object.keys;
    defineProperties($Object, {
        keys: function keys(object) {
            if (isArguments(object)) {
                return originalKeys(arraySlice(object));
            } else {
                return originalKeys(object);
            }
        }
    }, !keysWorksWithArguments || keysHasArgumentsLengthBug);

    //
    // Date
    // ====
    //

    var hasNegativeMonthYearBug = new Date(-3509827329600292).getUTCMonth() !== 0;
    var aNegativeTestDate = new Date(-1509842289600292);
    var aPositiveTestDate = new Date(1449662400000);
    var hasToUTCStringFormatBug = aNegativeTestDate.toUTCString() !== 'Mon, 01 Jan -45875 11:59:59 GMT';
    var hasToDateStringFormatBug;
    var hasToStringFormatBug;
    var timeZoneOffset = aNegativeTestDate.getTimezoneOffset();
    if (timeZoneOffset < -720) {
        hasToDateStringFormatBug = aNegativeTestDate.toDateString() !== 'Tue Jan 02 -45875';
        hasToStringFormatBug = !(/^Thu Dec 10 2015 \d\d:\d\d:\d\d GMT[-+]\d\d\d\d(?: |$)/).test(String(aPositiveTestDate));
    } else {
        hasToDateStringFormatBug = aNegativeTestDate.toDateString() !== 'Mon Jan 01 -45875';
        hasToStringFormatBug = !(/^Wed Dec 09 2015 \d\d:\d\d:\d\d GMT[-+]\d\d\d\d(?: |$)/).test(String(aPositiveTestDate));
    }

    var originalGetFullYear = call.bind(Date.prototype.getFullYear);
    var originalGetMonth = call.bind(Date.prototype.getMonth);
    var originalGetDate = call.bind(Date.prototype.getDate);
    var originalGetUTCFullYear = call.bind(Date.prototype.getUTCFullYear);
    var originalGetUTCMonth = call.bind(Date.prototype.getUTCMonth);
    var originalGetUTCDate = call.bind(Date.prototype.getUTCDate);
    var originalGetUTCDay = call.bind(Date.prototype.getUTCDay);
    var originalGetUTCHours = call.bind(Date.prototype.getUTCHours);
    var originalGetUTCMinutes = call.bind(Date.prototype.getUTCMinutes);
    var originalGetUTCSeconds = call.bind(Date.prototype.getUTCSeconds);
    var originalGetUTCMilliseconds = call.bind(Date.prototype.getUTCMilliseconds);
    var dayName = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var monthName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var daysInMonth = function daysInMonth(month, year) {
        return originalGetDate(new Date(year, month, 0));
    };

    defineProperties(Date.prototype, {
        getFullYear: function getFullYear() {
            if (!this || !(this instanceof Date)) {
                throw new TypeError('this is not a Date object.');
            }
            var year = originalGetFullYear(this);
            if (year < 0 && originalGetMonth(this) > 11) {
                return year + 1;
            }
            return year;
        },
        getMonth: function getMonth() {
            if (!this || !(this instanceof Date)) {
                throw new TypeError('this is not a Date object.');
            }
            var year = originalGetFullYear(this);
            var month = originalGetMonth(this);
            if (year < 0 && month > 11) {
                return 0;
            }
            return month;
        },
        getDate: function getDate() {
            if (!this || !(this instanceof Date)) {
                throw new TypeError('this is not a Date object.');
            }
            var year = originalGetFullYear(this);
            var month = originalGetMonth(this);
            var date = originalGetDate(this);
            if (year < 0 && month > 11) {
                if (month === 12) {
                    return date;
                }
                var days = daysInMonth(0, year + 1);
                return (days - date) + 1;
            }
            return date;
        },
        getUTCFullYear: function getUTCFullYear() {
            if (!this || !(this instanceof Date)) {
                throw new TypeError('this is not a Date object.');
            }
            var year = originalGetUTCFullYear(this);
            if (year < 0 && originalGetUTCMonth(this) > 11) {
                return year + 1;
            }
            return year;
        },
        getUTCMonth: function getUTCMonth() {
            if (!this || !(this instanceof Date)) {
                throw new TypeError('this is not a Date object.');
            }
            var year = originalGetUTCFullYear(this);
            var month = originalGetUTCMonth(this);
            if (year < 0 && month > 11) {
                return 0;
            }
            return month;
        },
        getUTCDate: function getUTCDate() {
            if (!this || !(this instanceof Date)) {
                throw new TypeError('this is not a Date object.');
            }
            var year = originalGetUTCFullYear(this);
            var month = originalGetUTCMonth(this);
            var date = originalGetUTCDate(this);
            if (year < 0 && month > 11) {
                if (month === 12) {
                    return date;
                }
                var days = daysInMonth(0, year + 1);
                return (days - date) + 1;
            }
            return date;
        }
    }, hasNegativeMonthYearBug);

    defineProperties(Date.prototype, {
        toUTCString: function toUTCString() {
            if (!this || !(this instanceof Date)) {
                throw new TypeError('this is not a Date object.');
            }
            var day = originalGetUTCDay(this);
            var date = originalGetUTCDate(this);
            var month = originalGetUTCMonth(this);
            var year = originalGetUTCFullYear(this);
            var hour = originalGetUTCHours(this);
            var minute = originalGetUTCMinutes(this);
            var second = originalGetUTCSeconds(this);
            return dayName[day] + ', '
                + (date < 10 ? '0' + date : date) + ' '
                + monthName[month] + ' '
                + year + ' '
                + (hour < 10 ? '0' + hour : hour) + ':'
                + (minute < 10 ? '0' + minute : minute) + ':'
                + (second < 10 ? '0' + second : second) + ' GMT';
        }
    }, hasNegativeMonthYearBug || hasToUTCStringFormatBug);

    // Opera 12 has `,`
    defineProperties(Date.prototype, {
        toDateString: function toDateString() {
            if (!this || !(this instanceof Date)) {
                throw new TypeError('this is not a Date object.');
            }
            var day = this.getDay();
            var date = this.getDate();
            var month = this.getMonth();
            var year = this.getFullYear();
            return dayName[day] + ' '
                + monthName[month] + ' '
                + (date < 10 ? '0' + date : date) + ' '
                + year;
        }
    }, hasNegativeMonthYearBug || hasToDateStringFormatBug);

    // can't use defineProperties here because of toString enumeration issue in IE <= 8
    if (hasNegativeMonthYearBug || hasToStringFormatBug) {
        Date.prototype.toString = function toString() {
            if (!this || !(this instanceof Date)) {
                throw new TypeError('this is not a Date object.');
            }
            var day = this.getDay();
            var date = this.getDate();
            var month = this.getMonth();
            var year = this.getFullYear();
            var hour = this.getHours();
            var minute = this.getMinutes();
            var second = this.getSeconds();
            var timezoneOffset = this.getTimezoneOffset();
            var hoursOffset = Math.floor(Math.abs(timezoneOffset) / 60);
            var minutesOffset = Math.floor(Math.abs(timezoneOffset) % 60);
            return dayName[day] + ' '
                + monthName[month] + ' '
                + (date < 10 ? '0' + date : date) + ' '
                + year + ' '
                + (hour < 10 ? '0' + hour : hour) + ':'
                + (minute < 10 ? '0' + minute : minute) + ':'
                + (second < 10 ? '0' + second : second) + ' GMT'
                + (timezoneOffset > 0 ? '-' : '+')
                + (hoursOffset < 10 ? '0' + hoursOffset : hoursOffset)
                + (minutesOffset < 10 ? '0' + minutesOffset : minutesOffset);
        };
        if (supportsDescriptors) {
            $Object.defineProperty(Date.prototype, 'toString', {
                configurable: true,
                enumerable: false,
                writable: true
            });
        }
    }

    // ES5 15.9.5.43
    // http://es5.github.com/#x15.9.5.43
    // This function returns a String value represent the instance in time
    // represented by this Date object. The format of the String is the Date Time
    // string format defined in 15.9.1.15. All fields are present in the String.
    // The time zone is always UTC, denoted by the suffix Z. If the time value of
    // this object is not a finite Number a RangeError exception is thrown.
    var negativeDate = -62198755200000;
    var negativeYearString = '-000001';
    var hasNegativeDateBug = Date.prototype.toISOString && new Date(negativeDate).toISOString().indexOf(negativeYearString) === -1; // eslint-disable-line max-len
    var hasSafari51DateBug = Date.prototype.toISOString && new Date(-1).toISOString() !== '1969-12-31T23:59:59.999Z';

    var getTime = call.bind(Date.prototype.getTime);

    defineProperties(Date.prototype, {
        toISOString: function toISOString() {
            if (!isFinite(this) || !isFinite(getTime(this))) {
                // Adope Photoshop requires the second check.
                throw new RangeError('Date.prototype.toISOString called on non-finite value.');
            }

            var year = originalGetUTCFullYear(this);

            var month = originalGetUTCMonth(this);
            // see https://github.com/es-shims/es5-shim/issues/111
            year += Math.floor(month / 12);
            month = ((month % 12) + 12) % 12;

            // the date time string format is specified in 15.9.1.15.
            var result = [
                month + 1,
                originalGetUTCDate(this),
                originalGetUTCHours(this),
                originalGetUTCMinutes(this),
                originalGetUTCSeconds(this)
            ];
            year = (
                (year < 0 ? '-' : (year > 9999 ? '+' : ''))
                + strSlice('00000' + Math.abs(year), (0 <= year && year <= 9999) ? -4 : -6)
            );

            for (var i = 0; i < result.length; ++i) {
                // pad months, days, hours, minutes, and seconds to have two digits.
                result[i] = strSlice('00' + result[i], -2);
            }
            // pad milliseconds to have three digits.
            return (
                year + '-' + arraySlice(result, 0, 2).join('-')
                + 'T' + arraySlice(result, 2).join(':') + '.'
                + strSlice('000' + originalGetUTCMilliseconds(this), -3) + 'Z'
            );
        }
    }, hasNegativeDateBug || hasSafari51DateBug);

    // ES5 15.9.5.44
    // http://es5.github.com/#x15.9.5.44
    // This function provides a String representation of a Date object for use by
    // JSON.stringify (15.12.3).
    var dateToJSONIsSupported = (function () {
        try {
            return Date.prototype.toJSON
                && new Date(NaN).toJSON() === null
                && new Date(negativeDate).toJSON().indexOf(negativeYearString) !== -1
                && Date.prototype.toJSON.call({ // generic
                    toISOString: function () { return true; }
                });
        } catch (e) {
            return false;
        }
    }());
    if (!dateToJSONIsSupported) {
        Date.prototype.toJSON = function toJSON(key) {
            // When the toJSON method is called with argument key, the following
            // steps are taken:

            // 1.  Let O be the result of calling ToObject, giving it the this
            // value as its argument.
            // 2. Let tv be ES.ToPrimitive(O, hint Number).
            var O = $Object(this);
            var tv = ES.ToPrimitive(O);
            // 3. If tv is a Number and is not finite, return null.
            if (typeof tv === 'number' && !isFinite(tv)) {
                return null;
            }
            // 4. Let toISO be the result of calling the [[Get]] internal method of
            // O with argument "toISOString".
            var toISO = O.toISOString;
            // 5. If IsCallable(toISO) is false, throw a TypeError exception.
            if (!isCallable(toISO)) {
                throw new TypeError('toISOString property is not callable');
            }
            // 6. Return the result of calling the [[Call]] internal method of
            //  toISO with O as the this value and an empty argument list.
            return toISO.call(O);

            // NOTE 1 The argument is ignored.

            // NOTE 2 The toJSON function is intentionally generic; it does not
            // require that its this value be a Date object. Therefore, it can be
            // transferred to other kinds of objects for use as a method. However,
            // it does require that any such object have a toISOString method. An
            // object is free to use the argument key to filter its
            // stringification.
        };
    }

    // ES5 15.9.4.2
    // http://es5.github.com/#x15.9.4.2
    // based on work shared by Daniel Friesen (dantman)
    // http://gist.github.com/303249
    var supportsExtendedYears = Date.parse('+033658-09-27T01:46:40.000Z') === 1e15;
    var acceptsInvalidDates = !isNaN(Date.parse('2012-04-04T24:00:00.500Z')) || !isNaN(Date.parse('2012-11-31T23:59:59.000Z')) || !isNaN(Date.parse('2012-12-31T23:59:60.000Z'));
    var doesNotParseY2KNewYear = isNaN(Date.parse('2000-01-01T00:00:00.000Z'));
    if (doesNotParseY2KNewYear || acceptsInvalidDates || !supportsExtendedYears) {
        // XXX global assignment won't work in embeddings that use
        // an alternate object for the context.
        /* global Date: true */
        var maxSafeUnsigned32Bit = Math.pow(2, 31) - 1;
        var hasSafariSignedIntBug = isActualNaN(new Date(1970, 0, 1, 0, 0, 0, maxSafeUnsigned32Bit + 1).getTime());
        // eslint-disable-next-line no-implicit-globals, no-global-assign
        Date = (function (NativeDate) {
            // Date.length === 7
            var DateShim = function Date(Y, M, D, h, m, s, ms) {
                var length = arguments.length;
                var date;
                if (this instanceof NativeDate) {
                    var seconds = s;
                    var millis = ms;
                    if (hasSafariSignedIntBug && length >= 7 && ms > maxSafeUnsigned32Bit) {
                        // work around a Safari 8/9 bug where it treats the seconds as signed
                        var msToShift = Math.floor(ms / maxSafeUnsigned32Bit) * maxSafeUnsigned32Bit;
                        var sToShift = Math.floor(msToShift / 1e3);
                        seconds += sToShift;
                        millis -= sToShift * 1e3;
                    }
                    date = length === 1 && $String(Y) === Y // isString(Y)
                        // We explicitly pass it through parse:
                        ? new NativeDate(DateShim.parse(Y))
                        // We have to manually make calls depending on argument
                        // length here
                        : length >= 7 ? new NativeDate(Y, M, D, h, m, seconds, millis)
                            : length >= 6 ? new NativeDate(Y, M, D, h, m, seconds)
                                : length >= 5 ? new NativeDate(Y, M, D, h, m)
                                    : length >= 4 ? new NativeDate(Y, M, D, h)
                                        : length >= 3 ? new NativeDate(Y, M, D)
                                            : length >= 2 ? new NativeDate(Y, M)
                                                : length >= 1 ? new NativeDate(Y instanceof NativeDate ? +Y : Y)
                                                    : new NativeDate();
                } else {
                    date = NativeDate.apply(this, arguments);
                }
                if (!isPrimitive(date)) {
                    // Prevent mixups with unfixed Date object
                    defineProperties(date, { constructor: DateShim }, true);
                }
                return date;
            };

            // 15.9.1.15 Date Time String Format.
            var isoDateExpression = new RegExp('^'
                + '(\\d{4}|[+-]\\d{6})' // four-digit year capture or sign + 6-digit extended year
                + '(?:-(\\d{2})' // optional month capture
                + '(?:-(\\d{2})' // optional day capture
                + '(?:' // capture hours:minutes:seconds.milliseconds
                    + 'T(\\d{2})' // hours capture
                    + ':(\\d{2})' // minutes capture
                    + '(?:' // optional :seconds.milliseconds
                        + ':(\\d{2})' // seconds capture
                        + '(?:(\\.\\d{1,}))?' // milliseconds capture
                    + ')?'
                + '(' // capture UTC offset component
                    + 'Z|' // UTC capture
                    + '(?:' // offset specifier +/-hours:minutes
                        + '([-+])' // sign capture
                        + '(\\d{2})' // hours offset capture
                        + ':(\\d{2})' // minutes offset capture
                    + ')'
                + ')?)?)?)?'
            + '$');

            var months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365];

            var dayFromMonth = function dayFromMonth(year, month) {
                var t = month > 1 ? 1 : 0;
                return (
                    months[month]
                    + Math.floor((year - 1969 + t) / 4)
                    - Math.floor((year - 1901 + t) / 100)
                    + Math.floor((year - 1601 + t) / 400)
                    + (365 * (year - 1970))
                );
            };

            var toUTC = function toUTC(t) {
                var s = 0;
                var ms = t;
                if (hasSafariSignedIntBug && ms > maxSafeUnsigned32Bit) {
                    // work around a Safari 8/9 bug where it treats the seconds as signed
                    var msToShift = Math.floor(ms / maxSafeUnsigned32Bit) * maxSafeUnsigned32Bit;
                    var sToShift = Math.floor(msToShift / 1e3);
                    s += sToShift;
                    ms -= sToShift * 1e3;
                }
                return $Number(new NativeDate(1970, 0, 1, 0, 0, s, ms));
            };

            // Copy any custom methods a 3rd party library may have added
            for (var key in NativeDate) {
                if (owns(NativeDate, key)) {
                    DateShim[key] = NativeDate[key];
                }
            }

            // Copy "native" methods explicitly; they may be non-enumerable
            defineProperties(DateShim, {
                now: NativeDate.now,
                UTC: NativeDate.UTC
            }, true);
            DateShim.prototype = NativeDate.prototype;
            defineProperties(DateShim.prototype, { constructor: DateShim }, true);

            // Upgrade Date.parse to handle simplified ISO 8601 strings
            var parseShim = function parse(string) {
                var match = isoDateExpression.exec(string);
                if (match) {
                    // parse months, days, hours, minutes, seconds, and milliseconds
                    // provide default values if necessary
                    // parse the UTC offset component
                    var year = $Number(match[1]),
                        month = $Number(match[2] || 1) - 1,
                        day = $Number(match[3] || 1) - 1,
                        hour = $Number(match[4] || 0),
                        minute = $Number(match[5] || 0),
                        second = $Number(match[6] || 0),
                        millisecond = Math.floor($Number(match[7] || 0) * 1000),
                        // When time zone is missed, local offset should be used
                        // (ES 5.1 bug)
                        // see https://bugs.ecmascript.org/show_bug.cgi?id=112
                        isLocalTime = Boolean(match[4] && !match[8]),
                        signOffset = match[9] === '-' ? 1 : -1,
                        hourOffset = $Number(match[10] || 0),
                        minuteOffset = $Number(match[11] || 0),
                        result;
                    var hasMinutesOrSecondsOrMilliseconds = minute > 0 || second > 0 || millisecond > 0;
                    if (
                        hour < (hasMinutesOrSecondsOrMilliseconds ? 24 : 25)
                        && minute < 60 && second < 60 && millisecond < 1000
                        && month > -1 && month < 12 && hourOffset < 24
                        && minuteOffset < 60 // detect invalid offsets
                        && day > -1
                        && day < (dayFromMonth(year, month + 1) - dayFromMonth(year, month))
                    ) {
                        result = (
                            ((dayFromMonth(year, month) + day) * 24)
                            + hour
                            + (hourOffset * signOffset)
                        ) * 60;
                        result = ((
                            ((result + minute + (minuteOffset * signOffset)) * 60)
                            + second
                        ) * 1000) + millisecond;
                        if (isLocalTime) {
                            result = toUTC(result);
                        }
                        if (-8.64e15 <= result && result <= 8.64e15) {
                            return result;
                        }
                    }
                    return NaN;
                }
                return NativeDate.parse.apply(this, arguments);
            };
            defineProperties(DateShim, { parse: parseShim });

            return DateShim;
        }(Date));
        /* global Date: false */
    }

    // ES5 15.9.4.4
    // http://es5.github.com/#x15.9.4.4
    if (!Date.now) {
        Date.now = function now() {
            return new Date().getTime();
        };
    }

    //
    // Number
    // ======
    //

    // ES5.1 15.7.4.5
    // http://es5.github.com/#x15.7.4.5
    var hasToFixedBugs = NumberPrototype.toFixed && (
        (0.00008).toFixed(3) !== '0.000'
        || (0.9).toFixed(0) !== '1'
        || (1.255).toFixed(2) !== '1.25'
        || (1000000000000000128).toFixed(0) !== '1000000000000000128'
    );

    var toFixedHelpers = {
        base: 1e7,
        size: 6,
        data: [0, 0, 0, 0, 0, 0],
        multiply: function multiply(n, c) {
            var i = -1;
            var c2 = c;
            while (++i < toFixedHelpers.size) {
                c2 += n * toFixedHelpers.data[i];
                toFixedHelpers.data[i] = c2 % toFixedHelpers.base;
                c2 = Math.floor(c2 / toFixedHelpers.base);
            }
        },
        divide: function divide(n) {
            var i = toFixedHelpers.size;
            var c = 0;
            while (--i >= 0) {
                c += toFixedHelpers.data[i];
                toFixedHelpers.data[i] = Math.floor(c / n);
                c = (c % n) * toFixedHelpers.base;
            }
        },
        numToString: function numToString() {
            var i = toFixedHelpers.size;
            var s = '';
            while (--i >= 0) {
                if (s !== '' || i === 0 || toFixedHelpers.data[i] !== 0) {
                    var t = $String(toFixedHelpers.data[i]);
                    if (s === '') {
                        s = t;
                    } else {
                        s += strSlice('0000000', 0, 7 - t.length) + t;
                    }
                }
            }
            return s;
        },
        pow: function pow(x, n, acc) {
            return (n === 0 ? acc : (n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc)));
        },
        log: function log(x) {
            var n = 0;
            var x2 = x;
            while (x2 >= 4096) {
                n += 12;
                x2 /= 4096;
            }
            while (x2 >= 2) {
                n += 1;
                x2 /= 2;
            }
            return n;
        }
    };

    var toFixedShim = function toFixed(fractionDigits) {
        var f, x, s, m, e, z, j, k;

        // Test for NaN and round fractionDigits down
        f = $Number(fractionDigits);
        f = isActualNaN(f) ? 0 : Math.floor(f);

        if (f < 0 || f > 20) {
            throw new RangeError('Number.toFixed called with invalid number of decimals');
        }

        x = $Number(this);

        if (isActualNaN(x)) {
            return 'NaN';
        }

        // If it is too big or small, return the string value of the number
        if (x <= -1e21 || x >= 1e21) {
            return $String(x);
        }

        s = '';

        if (x < 0) {
            s = '-';
            x = -x;
        }

        m = '0';

        if (x > 1e-21) {
            // 1e-21 < x < 1e21
            // -70 < log2(x) < 70
            e = toFixedHelpers.log(x * toFixedHelpers.pow(2, 69, 1)) - 69;
            z = (e < 0 ? x * toFixedHelpers.pow(2, -e, 1) : x / toFixedHelpers.pow(2, e, 1));
            z *= 0x10000000000000; // Math.pow(2, 52);
            e = 52 - e;

            // -18 < e < 122
            // x = z / 2 ^ e
            if (e > 0) {
                toFixedHelpers.multiply(0, z);
                j = f;

                while (j >= 7) {
                    toFixedHelpers.multiply(1e7, 0);
                    j -= 7;
                }

                toFixedHelpers.multiply(toFixedHelpers.pow(10, j, 1), 0);
                j = e - 1;

                while (j >= 23) {
                    toFixedHelpers.divide(1 << 23);
                    j -= 23;
                }

                toFixedHelpers.divide(1 << j);
                toFixedHelpers.multiply(1, 1);
                toFixedHelpers.divide(2);
                m = toFixedHelpers.numToString();
            } else {
                toFixedHelpers.multiply(0, z);
                toFixedHelpers.multiply(1 << (-e), 0);
                m = toFixedHelpers.numToString() + strSlice('0.00000000000000000000', 2, 2 + f);
            }
        }

        if (f > 0) {
            k = m.length;

            if (k <= f) {
                m = s + strSlice('0.0000000000000000000', 0, f - k + 2) + m;
            } else {
                m = s + strSlice(m, 0, k - f) + '.' + strSlice(m, k - f);
            }
        } else {
            m = s + m;
        }

        return m;
    };
    defineProperties(NumberPrototype, { toFixed: toFixedShim }, hasToFixedBugs);

    var hasToPrecisionUndefinedBug = (function () {
        try {
            return 1.0.toPrecision(undefined) === '1';
        } catch (e) {
            return true;
        }
    }());
    var originalToPrecision = NumberPrototype.toPrecision;
    defineProperties(NumberPrototype, {
        toPrecision: function toPrecision(precision) {
            return typeof precision === 'undefined' ? originalToPrecision.call(this) : originalToPrecision.call(this, precision);
        }
    }, hasToPrecisionUndefinedBug);

    //
    // String
    // ======
    //

    // ES5 15.5.4.14
    // http://es5.github.com/#x15.5.4.14

    // [bugfix, IE lt 9, firefox 4, Konqueror, Opera, obscure browsers]
    // Many browsers do not split properly with regular expressions or they
    // do not perform the split correctly under obscure conditions.
    // See http://blog.stevenlevithan.com/archives/cross-browser-split
    // I've tested in many browsers and this seems to cover the deviant ones:
    //    'ab'.split(/(?:ab)*/) should be ["", ""], not [""]
    //    '.'.split(/(.?)(.?)/) should be ["", ".", "", ""], not ["", ""]
    //    'tesst'.split(/(s)*/) should be ["t", undefined, "e", "s", "t"], not
    //       [undefined, "t", undefined, "e", ...]
    //    ''.split(/.?/) should be [], not [""]
    //    '.'.split(/()()/) should be ["."], not ["", "", "."]

    if (
        'ab'.split(/(?:ab)*/).length !== 2
        || '.'.split(/(.?)(.?)/).length !== 4
        || 'tesst'.split(/(s)*/)[1] === 't'
        || 'test'.split(/(?:)/, -1).length !== 4
        || ''.split(/.?/).length
        || '.'.split(/()()/).length > 1
    ) {
        (function () {
            var compliantExecNpcg = typeof (/()??/).exec('')[1] === 'undefined'; // NPCG: nonparticipating capturing group
            var maxSafe32BitInt = Math.pow(2, 32) - 1;

            StringPrototype.split = function (separator, limit) {
                var string = String(this);
                if (typeof separator === 'undefined' && limit === 0) {
                    return [];
                }

                // If `separator` is not a regex, use native split
                if (!isRegex(separator)) {
                    return strSplit(this, separator, limit);
                }

                var output = [];
                var flags = (separator.ignoreCase ? 'i' : '')
                            + (separator.multiline ? 'm' : '')
                            + (separator.unicode ? 'u' : '') // in ES6
                            + (separator.sticky ? 'y' : ''), // Firefox 3+ and ES6
                    lastLastIndex = 0,
                    // Make `global` and avoid `lastIndex` issues by working with a copy
                    separator2, match, lastIndex, lastLength;
                var separatorCopy = new RegExp(separator.source, flags + 'g');
                if (!compliantExecNpcg) {
                    // Doesn't need flags gy, but they don't hurt
                    separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
                }
                /* Values for `limit`, per the spec:
                 * If undefined: 4294967295 // maxSafe32BitInt
                 * If 0, Infinity, or NaN: 0
                 * If positive number: limit = Math.floor(limit); if (limit > 4294967295) limit -= 4294967296;
                 * If negative number: 4294967296 - Math.floor(Math.abs(limit))
                 * If other: Type-convert, then use the above rules
                 */
                var splitLimit = typeof limit === 'undefined' ? maxSafe32BitInt : ES.ToUint32(limit);
                match = separatorCopy.exec(string);
                while (match) {
                    // `separatorCopy.lastIndex` is not reliable cross-browser
                    lastIndex = match.index + match[0].length;
                    if (lastIndex > lastLastIndex) {
                        pushCall(output, strSlice(string, lastLastIndex, match.index));
                        // Fix browsers whose `exec` methods don't consistently return `undefined` for
                        // nonparticipating capturing groups
                        if (!compliantExecNpcg && match.length > 1) {
                            /* eslint-disable no-loop-func */
                            match[0].replace(separator2, function () {
                                for (var i = 1; i < arguments.length - 2; i++) {
                                    if (typeof arguments[i] === 'undefined') {
                                        match[i] = void 0;
                                    }
                                }
                            });
                            /* eslint-enable no-loop-func */
                        }
                        if (match.length > 1 && match.index < string.length) {
                            array_push.apply(output, arraySlice(match, 1));
                        }
                        lastLength = match[0].length;
                        lastLastIndex = lastIndex;
                        if (output.length >= splitLimit) {
                            break;
                        }
                    }
                    if (separatorCopy.lastIndex === match.index) {
                        separatorCopy.lastIndex++; // Avoid an infinite loop
                    }
                    match = separatorCopy.exec(string);
                }
                if (lastLastIndex === string.length) {
                    if (lastLength || !separatorCopy.test('')) {
                        pushCall(output, '');
                    }
                } else {
                    pushCall(output, strSlice(string, lastLastIndex));
                }
                return output.length > splitLimit ? arraySlice(output, 0, splitLimit) : output;
            };
        }());

    // [bugfix, chrome]
    // If separator is undefined, then the result array contains just one String,
    // which is the this value (converted to a String). If limit is not undefined,
    // then the output array is truncated so that it contains no more than limit
    // elements.
    // "0".split(undefined, 0) -> []
    } else if ('0'.split(void 0, 0).length) {
        StringPrototype.split = function split(separator, limit) {
            if (typeof separator === 'undefined' && limit === 0) {
                return [];
            }
            return strSplit(this, separator, limit);
        };
    }

    var str_replace = StringPrototype.replace;
    var replaceReportsGroupsCorrectly = (function () {
        var groups = [];
        'x'.replace(/x(.)?/g, function (match, group) {
            pushCall(groups, group);
        });
        return groups.length === 1 && typeof groups[0] === 'undefined';
    }());

    if (!replaceReportsGroupsCorrectly) {
        StringPrototype.replace = function replace(searchValue, replaceValue) {
            var isFn = isCallable(replaceValue);
            var hasCapturingGroups = isRegex(searchValue) && (/\)[*?]/).test(searchValue.source);
            if (!isFn || !hasCapturingGroups) {
                return str_replace.call(this, searchValue, replaceValue);
            } else {
                var wrappedReplaceValue = function (match) {
                    var length = arguments.length;
                    var originalLastIndex = searchValue.lastIndex;
                    searchValue.lastIndex = 0;
                    var args = searchValue.exec(match) || [];
                    searchValue.lastIndex = originalLastIndex;
                    pushCall(args, arguments[length - 2], arguments[length - 1]);
                    return replaceValue.apply(this, args);
                };
                return str_replace.call(this, searchValue, wrappedReplaceValue);
            }
        };
    }

    // ECMA-262, 3rd B.2.3
    // Not an ECMAScript standard, although ECMAScript 3rd Edition has a
    // non-normative section suggesting uniform semantics and it should be
    // normalized across all browsers
    // [bugfix, IE lt 9] IE < 9 substr() with negative value not working in IE
    var string_substr = StringPrototype.substr;
    var hasNegativeSubstrBug = ''.substr && '0b'.substr(-1) !== 'b';
    defineProperties(StringPrototype, {
        substr: function substr(start, length) {
            var normalizedStart = start;
            if (start < 0) {
                normalizedStart = max(this.length + start, 0);
            }
            return string_substr.call(this, normalizedStart, length);
        }
    }, hasNegativeSubstrBug);

    // ES5 15.5.4.20
    // whitespace from: http://es5.github.io/#x15.5.4.20
    var ws = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003'
        + '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028'
        + '\u2029\uFEFF';
    var zeroWidth = '\u200b';
    var wsRegexChars = '[' + ws + ']';
    var trimBeginRegexp = new RegExp('^' + wsRegexChars + wsRegexChars + '*');
    var trimEndRegexp = new RegExp(wsRegexChars + wsRegexChars + '*$');
    var hasTrimWhitespaceBug = StringPrototype.trim && (ws.trim() || !zeroWidth.trim());
    defineProperties(StringPrototype, {
        // http://blog.stevenlevithan.com/archives/faster-trim-javascript
        // http://perfectionkills.com/whitespace-deviations/
        trim: function trim() {
            if (typeof this === 'undefined' || this === null) {
                throw new TypeError("can't convert " + this + ' to object');
            }
            return $String(this).replace(trimBeginRegexp, '').replace(trimEndRegexp, '');
        }
    }, hasTrimWhitespaceBug);
    var trim = call.bind(String.prototype.trim);

    var hasLastIndexBug = StringPrototype.lastIndexOf && 'abcあい'.lastIndexOf('あい', 2) !== -1;
    defineProperties(StringPrototype, {
        lastIndexOf: function lastIndexOf(searchString) {
            if (typeof this === 'undefined' || this === null) {
                throw new TypeError("can't convert " + this + ' to object');
            }
            var S = $String(this);
            var searchStr = $String(searchString);
            var numPos = arguments.length > 1 ? $Number(arguments[1]) : NaN;
            var pos = isActualNaN(numPos) ? Infinity : ES.ToInteger(numPos);
            var start = min(max(pos, 0), S.length);
            var searchLen = searchStr.length;
            var k = start + searchLen;
            while (k > 0) {
                k = max(0, k - searchLen);
                var index = strIndexOf(strSlice(S, k, start + searchLen), searchStr);
                if (index !== -1) {
                    return k + index;
                }
            }
            return -1;
        }
    }, hasLastIndexBug);

    var originalLastIndexOf = StringPrototype.lastIndexOf;
    defineProperties(StringPrototype, {
        lastIndexOf: function lastIndexOf(searchString) {
            return originalLastIndexOf.apply(this, arguments);
        }
    }, StringPrototype.lastIndexOf.length !== 1);

    // ES-5 15.1.2.2
    // eslint-disable-next-line radix
    if (parseInt(ws + '08') !== 8 || parseInt(ws + '0x16') !== 22) {
        /* global parseInt: true */
        parseInt = (function (origParseInt) {
            var hexRegex = /^[-+]?0[xX]/;
            return function parseInt(str, radix) {
                if (typeof str === 'symbol') {
                    // handle Symbols in node 8.3/8.4
                    // eslint-disable-next-line no-implicit-coercion, no-unused-expressions
                    '' + str; // jscs:ignore disallowImplicitTypeConversion
                }

                var string = trim(String(str));
                var defaultedRadix = $Number(radix) || (hexRegex.test(string) ? 16 : 10);
                return origParseInt(string, defaultedRadix);
            };
        }(parseInt));
    }

    // https://es5.github.io/#x15.1.2.3
    if (1 / parseFloat('-0') !== -Infinity) {
        /* global parseFloat: true */
        parseFloat = (function (origParseFloat) {
            return function parseFloat(string) {
                var inputString = trim(String(string));
                var result = origParseFloat(inputString);
                return result === 0 && strSlice(inputString, 0, 1) === '-' ? -0 : result;
            };
        }(parseFloat));
    }

    if (String(new RangeError('test')) !== 'RangeError: test') {
        var errorToStringShim = function toString() {
            if (typeof this === 'undefined' || this === null) {
                throw new TypeError("can't convert " + this + ' to object');
            }
            var name = this.name;
            if (typeof name === 'undefined') {
                name = 'Error';
            } else if (typeof name !== 'string') {
                name = $String(name);
            }
            var msg = this.message;
            if (typeof msg === 'undefined') {
                msg = '';
            } else if (typeof msg !== 'string') {
                msg = $String(msg);
            }
            if (!name) {
                return msg;
            }
            if (!msg) {
                return name;
            }
            return name + ': ' + msg;
        };
        // can't use defineProperties here because of toString enumeration issue in IE <= 8
        Error.prototype.toString = errorToStringShim;
    }

    if (supportsDescriptors) {
        var ensureNonEnumerable = function (obj, prop) {
            if (isEnum(obj, prop)) {
                var desc = Object.getOwnPropertyDescriptor(obj, prop);
                if (desc.configurable) {
                    desc.enumerable = false;
                    Object.defineProperty(obj, prop, desc);
                }
            }
        };
        ensureNonEnumerable(Error.prototype, 'message');
        if (Error.prototype.message !== '') {
            Error.prototype.message = '';
        }
        ensureNonEnumerable(Error.prototype, 'name');
    }

    if (String(/a/mig) !== '/a/gim') {
        var regexToString = function toString() {
            var str = '/' + this.source + '/';
            if (this.global) {
                str += 'g';
            }
            if (this.ignoreCase) {
                str += 'i';
            }
            if (this.multiline) {
                str += 'm';
            }
            return str;
        };
        // can't use defineProperties here because of toString enumeration issue in IE <= 8
        RegExp.prototype.toString = regexToString;
    }
}));


/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.4+314e4831
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var vertx = Function('return this')().require('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(2);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var TRY_CATCH_ERROR = { error: null };

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    TRY_CATCH_ERROR.error = error;
    return TRY_CATCH_ERROR;
  }
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === TRY_CATCH_ERROR) {
      reject(promise, TRY_CATCH_ERROR.error);
      TRY_CATCH_ERROR.error = null;
    } else if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = void 0,
      failed = void 0;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (failed) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = getThen(entry);

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        handleMaybeThenable(promise, entry, _then);
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    return promise.then(function (value) {
      return constructor.resolve(callback()).then(function () {
        return value;
      });
    }, function (reason) {
      return constructor.resolve(callback()).then(function () {
        throw reason;
      });
    });
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
  var local = void 0;

  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  var P = local.Promise;

  if (P) {
    var promiseToString = null;
    try {
      promiseToString = Object.prototype.toString.call(P.resolve());
    } catch (e) {
      // silently ignored
    }

    if (promiseToString === '[object Promise]' && !P.cast) {
      return;
    }
  }

  local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));



//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(408), __webpack_require__(74)))

/***/ }),
/* 2119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bg-blue-0":"bg-blue-0__3p-6G","bg-blue-1":"bg-blue-1__2shuB","bg-blue-2":"bg-blue-2__1A8tm","bg-blue-3":"bg-blue-3__2fz9A","bg-blue-4":"bg-blue-4__2CB-H","bg-blue-5":"bg-blue-5__Cgcyz","bg-blue-6":"bg-blue-6__13jm1","bg-blue-7":"bg-blue-7__26PEs","bg-blue-8":"bg-blue-8__2oMGi","bg-blue-9":"bg-blue-9__Wwg0h","bg-blue-10":"bg-blue-10__3nBk8","bg-blue-11":"bg-blue-11__2Paox","bg-blue-12":"bg-blue-12__3DaLi","bg-blue-13":"bg-blue-13__1mdXc","bg-blue-14":"bg-blue-14__2RPDs","bg-blue-15":"bg-blue-15__MpAkK","bg-blue-16":"bg-blue-16__254GK","bg-blue-17":"bg-blue-17__1VZ-p","bg-blue-18":"bg-blue-18__Iv4Rl","bg-blue-19":"bg-blue-19__2kDko","bg-blue-20":"bg-blue-20__3Awdz","bg-green-0":"bg-green-0__34r1K","bg-green-1":"bg-green-1__1jMKN","bg-green-2":"bg-green-2__14IeA","bg-green-3":"bg-green-3__3tmfD","bg-green-4":"bg-green-4__2C3TT","bg-green-5":"bg-green-5__25Fob","bg-green-6":"bg-green-6__3TY9D","bg-green-7":"bg-green-7__DHM-V","bg-green-8":"bg-green-8__3c-Fn","bg-green-9":"bg-green-9__zhH2I","bg-green-10":"bg-green-10__3FZxQ","bg-green-11":"bg-green-11__FtHkM","bg-green-12":"bg-green-12__1QhtY","bg-green-13":"bg-green-13__HtVAR","bg-green-14":"bg-green-14__2Chve","bg-green-15":"bg-green-15__Wq2w3","bg-green-16":"bg-green-16__2qqDg","bg-green-17":"bg-green-17__3X5ud","bg-green-18":"bg-green-18__yO4ib","bg-green-19":"bg-green-19__1UeXv","bg-green-20":"bg-green-20__30RLq","bg-red-0":"bg-red-0__1Omrd","bg-red-1":"bg-red-1__1oNFn","bg-red-2":"bg-red-2__vWJ1N","bg-red-3":"bg-red-3__3Nhnn","bg-red-4":"bg-red-4__2vO-N","bg-red-5":"bg-red-5__3DXcg","bg-red-6":"bg-red-6__218VF","bg-red-7":"bg-red-7__2lQQA","bg-red-8":"bg-red-8__sbSfu","bg-red-9":"bg-red-9__3Xf6q","bg-red-10":"bg-red-10__1MO4y","bg-red-11":"bg-red-11__2YReM","bg-red-12":"bg-red-12__6uWZ8","bg-red-13":"bg-red-13__2YV20","bg-red-14":"bg-red-14__3gmB_","bg-red-15":"bg-red-15__3x4cO","bg-red-16":"bg-red-16__30Yq4","bg-red-17":"bg-red-17__jKqi_","bg-red-18":"bg-red-18__1Yvdv","bg-red-19":"bg-red-19__3-lZ7","bg-red-20":"bg-red-20__2MgMX","bg-yellow-0":"bg-yellow-0__ksbtX","bg-yellow-1":"bg-yellow-1__13nxA","bg-yellow-2":"bg-yellow-2__2Rb2v","bg-yellow-3":"bg-yellow-3__1uPFc","bg-yellow-4":"bg-yellow-4__2DIDw","bg-yellow-5":"bg-yellow-5__3fquQ","bg-yellow-6":"bg-yellow-6__2EzM7","bg-yellow-7":"bg-yellow-7__1TgPH","bg-yellow-8":"bg-yellow-8__StEw3","bg-yellow-9":"bg-yellow-9__3KPOS","bg-yellow-10":"bg-yellow-10__nvU9P","bg-yellow-11":"bg-yellow-11__3zawt","bg-yellow-12":"bg-yellow-12__ECJSX","bg-yellow-13":"bg-yellow-13__1arn5","bg-yellow-14":"bg-yellow-14__2QRMM","bg-yellow-15":"bg-yellow-15__C5Z-Q","bg-yellow-16":"bg-yellow-16__2g91G","bg-yellow-17":"bg-yellow-17__3n0NJ","bg-yellow-18":"bg-yellow-18__2hgBS","bg-yellow-19":"bg-yellow-19__3GIkM","bg-yellow-20":"bg-yellow-20__1aoyb","bg-yellow-21":"bg-yellow-21__3Sor3","fg-blue-0":"fg-blue-0__3X80T","fg-blue-1":"fg-blue-1__3aCwM","fg-blue-2":"fg-blue-2__3jZI_","fg-blue-3":"fg-blue-3__vB-he","fg-blue-4":"fg-blue-4__2IAXm","fg-blue-5":"fg-blue-5__3nJE5","fg-blue-6":"fg-blue-6__2HdQ_","fg-blue-7":"fg-blue-7__1Bs1D","fg-blue-8":"fg-blue-8__1stWQ","fg-blue-9":"fg-blue-9__2q19p","fg-blue-10":"fg-blue-10__3PfPR","fg-blue-11":"fg-blue-11__10IWc","fg-blue-12":"fg-blue-12__1Lt_W","fg-blue-13":"fg-blue-13__2ZoOr","fg-blue-14":"fg-blue-14__vWeJr","fg-blue-15":"fg-blue-15__3_o9R","fg-blue-16":"fg-blue-16__1cjdr","fg-blue-17":"fg-blue-17__2BxKG","fg-blue-18":"fg-blue-18__12IJn","fg-blue-19":"fg-blue-19__3Ajzx","fg-blue-20":"fg-blue-20__2PmbF","fg-green-0":"fg-green-0__AC89y","fg-green-1":"fg-green-1__3pM78","fg-green-2":"fg-green-2__x0d5n","fg-green-3":"fg-green-3__2MDYl","fg-green-4":"fg-green-4__22-uB","fg-green-5":"fg-green-5__3xnH6","fg-green-6":"fg-green-6__31Vw0","fg-green-7":"fg-green-7__F4xAx","fg-green-8":"fg-green-8__swkiT","fg-green-9":"fg-green-9__1jI_e","fg-green-10":"fg-green-10__2CM2r","fg-green-11":"fg-green-11__3JZx1","fg-green-12":"fg-green-12__YHk1U","fg-green-13":"fg-green-13__3nPAC","fg-green-14":"fg-green-14__1V-3Y","fg-green-15":"fg-green-15__2g-D0","fg-green-16":"fg-green-16__IZGMn","fg-green-17":"fg-green-17__1RuK9","fg-green-18":"fg-green-18__L9dtv","fg-green-19":"fg-green-19__257Qw","fg-green-20":"fg-green-20__3yArh","fg-red-0":"fg-red-0__2Xj77","fg-red-1":"fg-red-1__2NX3J","fg-red-2":"fg-red-2__3FDHI","fg-red-3":"fg-red-3__3Oarg","fg-red-4":"fg-red-4__hMO3S","fg-red-5":"fg-red-5__3bvK0","fg-red-6":"fg-red-6__17oGn","fg-red-7":"fg-red-7__8VC_A","fg-red-8":"fg-red-8__3UHYW","fg-red-9":"fg-red-9__2XXBw","fg-red-10":"fg-red-10__2mw1K","fg-red-11":"fg-red-11__2oPX4","fg-red-12":"fg-red-12__1qOaU","fg-red-13":"fg-red-13__1sAQi","fg-red-14":"fg-red-14__3GZL9","fg-red-15":"fg-red-15__26-vU","fg-red-16":"fg-red-16__FIlCl","fg-red-17":"fg-red-17__2ar2V","fg-red-18":"fg-red-18__kUm4a","fg-red-19":"fg-red-19__3SYVv","fg-red-20":"fg-red-20__2ItBu","fg-yellow-0":"fg-yellow-0___o7mh","fg-yellow-1":"fg-yellow-1__5NLwM","fg-yellow-2":"fg-yellow-2__3uqXF","fg-yellow-3":"fg-yellow-3__3QNxB","fg-yellow-4":"fg-yellow-4__dDErP","fg-yellow-5":"fg-yellow-5__6dv9q","fg-yellow-6":"fg-yellow-6__te4lH","fg-yellow-7":"fg-yellow-7__3vOKT","fg-yellow-8":"fg-yellow-8__1ghLx","fg-yellow-9":"fg-yellow-9__3apuV","fg-yellow-10":"fg-yellow-10__2Glsf","fg-yellow-11":"fg-yellow-11__2ZeKX","fg-yellow-12":"fg-yellow-12__3s3ph","fg-yellow-13":"fg-yellow-13__bKYgy","fg-yellow-14":"fg-yellow-14__2v60P","fg-yellow-15":"fg-yellow-15__2Cqki","fg-yellow-16":"fg-yellow-16__1J-3_","fg-yellow-17":"fg-yellow-17__1h3vg","fg-yellow-18":"fg-yellow-18__PBmcD","fg-yellow-19":"fg-yellow-19__1jEBA","fg-yellow-20":"fg-yellow-20__vb5bI","fg-yellow-21":"fg-yellow-21__F3n1r"};

/***/ }),
/* 2120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1D_08","chart":"chart__1kuX6"};

/***/ }),
/* 2121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"checkbox__2xPBR","disabled":"disabled__3WJGe"};

/***/ }),
/* 2122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"btnLink":"btnLink__-OgBW"};

/***/ }),
/* 2123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1qnIp","right":"right__3zFuA","tips":"tips__S0QnZ","danger":"danger__1tXFi","success":"success__1Zqr0","warning":"warning__2IU0x","primary":"primary__16bqv","info":"info__1XAoh","bottom":"bottom__1Sssf","top":"top__qTcA4","arrow":"arrow__29yIH","left":"left__1-RIN"};

/***/ }),
/* 2124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"datepicker":"datepicker__1kHXn","active":"active__XZoE2","overlay":"overlay__1Yfh-","container":"container__2VbIV","ranges":"ranges__3n8Ux"};

/***/ }),
/* 2125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"datepicker":"datepicker__a4LYO","active":"active__3oYJq","overlay":"overlay__3dZSa","container":"container__3lOb1","ranges":"ranges__1-Ina","selectTime":"selectTime__2uCuE","timeContent":"timeContent__1KSDp","timeList":"timeList__1RHoD","selected":"selected__244vA"};

/***/ }),
/* 2126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"btnLink":"btnLink__3A-43"};

/***/ }),
/* 2127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"editable":"editable__3L_JJ"};

/***/ }),
/* 2128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3Hy3w","wrapper-nopadding":"wrapper-nopadding__2IZrj","loading":"loading__2tq2-","error":"error__3OZ_e","table-loading":"table-loading__3jGG1","empty-val":"empty-val__5rji8","panelheader-tools":"panelheader-tools__3-Svk","propsPanels":"propsPanels__20fbg","new":"new__1JkUH","marginLm":"marginLm__2QDGG","marginRm":"marginRm__CSPlS","fullWidth":"fullWidth__35YJC","fullHeight":"fullHeight__2AOKy","noData":"noData__1eQ8P","flash":"flash__9c0OQ","default":"default__3hTwr","success":"success__3-h-P","primary":"primary__1r4ie","danger":"danger__1Ctn5","warning":"warning__12eXN","info":"info__1etlY","content":"content__1rXlg","appear":"appear__2heQ2","enter":"enter__2aLKl","appearActive":"appearActive__3Izu1","enterActive":"enterActive__3Ix94","leave":"leave__fbrz5","leaveActive":"leaveActive__3-0V0"};

/***/ }),
/* 2129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"formBlock":"formBlock__1UMo7","danger":"danger__1Hh3U","closeButton":"closeButton__Xju16","success":"success__3cilR","warning":"warning__11Whl","primary":"primary__3pHhL","info":"info__u7jcr"};

/***/ }),
/* 2130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1vc5-","wrapper-nopadding":"wrapper-nopadding__VHLUK","loading":"loading__1b1oC","error":"error__3Cejw","table-loading":"table-loading__3J22p","empty-val":"empty-val__3EQ8s","panelheader-tools":"panelheader-tools__2vXNM","propsPanels":"propsPanels__QDEpO","new":"new__3ySN_","marginLm":"marginLm__3dLmJ","marginRm":"marginRm__1TCIb","fullWidth":"fullWidth__6ztxO","fullHeight":"fullHeight__N-lNF","noData":"noData__1ajBf","checkbox":"checkbox__1nIft","disconnected":"disconnected__2cWGk","connected":"connected__3A2Wd"};

/***/ }),
/* 2131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1Q1J9","chart":"chart__DckUs"};

/***/ }),
/* 2132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"inselect":"inselect__3-NTb"};

/***/ }),
/* 2133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2iCpO","chart":"chart__3NqlA"};

/***/ }),
/* 2134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loadingBar":"loadingBar__1WgQB","shimmer":"shimmer__3B49L"};

/***/ }),
/* 2135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__33083","wrapper-nopadding":"wrapper-nopadding__30s_5","loading":"loading__1Yrs4","error":"error__1ADoS","table-loading":"table-loading__1T0Oj","empty-val":"empty-val__3zjS8","panelheader-tools":"panelheader-tools__alC9X","propsPanels":"propsPanels__11v_u","new":"new__3skO3","marginLm":"marginLm__1UjAF","marginRm":"marginRm__2d8_W","fullWidth":"fullWidth__2n8E-","fullHeight":"fullHeight__2C4nK","noData":"noData__UNPi2","moment":"moment__xNuQ_","items":"items__3bZa7","timezoom":"timezoom__3jcZK"};

/***/ }),
/* 2136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__20rS8","wrapper-nopadding":"wrapper-nopadding__1rvNG","loading":"loading__27qEN","error":"error__1vPwY","table-loading":"table-loading__8FNbk","empty-val":"empty-val__PWZzq","panelheader-tools":"panelheader-tools__5DWHa","propsPanels":"propsPanels__2xMmR","new":"new__1q0Ux","marginLm":"marginLm__1NJDj","marginRm":"marginRm__avyHv","fullWidth":"fullWidth__1phRl","fullHeight":"fullHeight__3wG3U","noData":"noData__1IX8c","month":"month__ceMMd","navs":"navs__1KG1r","navCurr":"navCurr__1Baxw","navLeft":"navLeft__t3aGm","navRight":"navRight___zX17","header":"header__Edb0P","box":"box__CrfE0","dates":"dates__1WMCb","week":"week__2g8Od","inMonth":"inMonth__1YU59","anchor":"anchor__3H2Tv","ranged":"ranged__3nzB3","rangedLeft":"rangedLeft__bK6mJ","rangedRight":"rangedRight__2UWeE","selected":"selected__xowJ1","disabled":"disabled__1eJho"};

/***/ }),
/* 2137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"empty":"empty__3CRhE","loading":"loading__iwtDc"};

/***/ }),
/* 2138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1LX10","wrapper-nopadding":"wrapper-nopadding__3Cd0E","loading":"loading__1SlK2","error":"error__27chj","table-loading":"table-loading__3zvan","empty-val":"empty-val__YlXzJ","panelheader-tools":"panelheader-tools__gG4U8","propsPanels":"propsPanels__1rcLV","new":"new__1XJbd","marginLm":"marginLm__2Bsxp","marginRm":"marginRm__2uDfq","fullWidth":"fullWidth__dgtkA","fullHeight":"fullHeight__3hqsL","noData":"noData__1l918","noperm":"noperm__3b7Mu","desc":"desc__2Ly0H","upgrade":"upgrade__2AfW3"};

/***/ }),
/* 2139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"page-sizer":"page-sizer__1-10s","page-select":"page-select__1lrPW"};

/***/ }),
/* 2140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"toolbar":"toolbar__29__L","collapsed":"collapsed__3pJZC","tools":"tools__2P7fO","toggle":"toggle__1vjC0","arrow":"arrow__1BxBw","pullRight":"pullRight__3EEP0"};

/***/ }),
/* 2141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__uMbHh","chart":"chart__29gSk"};

/***/ }),
/* 2142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"plist":"plist__21m3-","pname":"pname__1giUw","pval":"pval__1wEaO","error":"error__3E4VE","punit":"punit__3wJwF","cancelBtn":"cancelBtn__1JIZ4","submitBtn":"submitBtn__2NKrJ"};

/***/ }),
/* 2143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"rich-form":"rich-form__ZY0jx","errortips-wrapper":"errortips-wrapper__3wghV","errortips":"errortips__1qOtL","errtips":"errtips__2Nmep","field-help":"field-help__OgQOu","submit":"submit__2CEj0","btn-label":"btn-label__DwdB8","success":"success__3CSIo","error":"error__om73Y","labeled-input":"labeled-input__26P7w","input-label":"input-label__WlB_K"};

/***/ }),
/* 2144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"richLabel":"richLabel__1PCTo","translated":"translated__1kvLM"};

/***/ }),
/* 2145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1_COh","chart":"chart__2aSs8"};

/***/ }),
/* 2146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"flag":"flag__2pxo6","show":"show__2hNON"};

/***/ }),
/* 2147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"search":"search__2sTuC"};

/***/ }),
/* 2148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"select":"select__29nLT","dropdown":"dropdown__2HQns","hover":"hover__3GvAZ","active":"active__2I9Sv","open":"open__1u7Wq"};

/***/ }),
/* 2149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"select":"select__3vhKW","dropdown":"dropdown__3ECEl","hover":"hover__ncarb","active":"active__2ypM2","open":"open__2UQQb"};

/***/ }),
/* 2150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__QvCmP","wrapper-nopadding":"wrapper-nopadding__3BUfC","loading":"loading__10N6M","error":"error__3tIrd","table-loading":"table-loading__39XgG","empty-val":"empty-val__1I-3i","panelheader-tools":"panelheader-tools__1AxzE","propsPanels":"propsPanels__11s-i","new":"new__2dp7N","marginLm":"marginLm__N4KhP","marginRm":"marginRm__2pBiF","fullWidth":"fullWidth__3rJnm","fullHeight":"fullHeight__mw9gG","noData":"noData__24dQf","checkbox":"checkbox__X67S9","disconnected":"disconnected__2UU3N","connected":"connected__3vY47","tips":"tips__25nE6","flex":"flex__3X5XE"};

/***/ }),
/* 2151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"select-pills":"select-pills__iqAh5"};

/***/ }),
/* 2152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sidebar":"sidebar__CYHRh","toggle":"toggle__37IYa","title":"title__1uly_","arrow":"arrow__1rW0c","collapsed":"collapsed__1shTz","menu":"menu__VRZ59","menu-item":"menu-item__Zl3rx","active":"active__2iDJt","beta":"beta__QY7tG","menu-icon":"menu-icon__1gtSj","menu-text":"menu-text__zU-eY"};

/***/ }),
/* 2153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"content__2ljsH","collapsed":"collapsed__1ZNWl"};

/***/ }),
/* 2154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"defalutColor":"defalutColor__298wq"};

/***/ }),
/* 2155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper-pull-right":"wrapper-pull-right__3ebda","table-pager":"table-pager__1vpWY","pager-button":"pager-button__xPryT"};

/***/ }),
/* 2156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper-pull-right":"wrapper-pull-right__2a9Ej","table-pager":"table-pager__n8KiT","pager-button":"pager-button__6r8qe"};

/***/ }),
/* 2157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper-pull-right":"wrapper-pull-right__3m-rw","table-pager":"table-pager__3VdJ5","pager-button":"pager-button__2OjkZ"};

/***/ }),
/* 2158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__21Cev","wrapper-nopadding":"wrapper-nopadding__3al9b","loading":"loading__1EEFS","error":"error__2tFUe","table-loading":"table-loading__3JGVU","empty-val":"empty-val__BBJln","panelheader-tools":"panelheader-tools__vKFcC","propsPanels":"propsPanels__OjA98","new":"new__2Y0TZ","marginLm":"marginLm__3aUF5","marginRm":"marginRm__Imzwd","fullWidth":"fullWidth__2-Gae","fullHeight":"fullHeight__3ag51","noData":"noData__3PR06","timepicker":"timepicker__2ebY_","active":"active__uCIFU","overlay":"overlay__1jdMt","container":"container__3c9bV"};

/***/ }),
/* 2159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"toolbar":"toolbar__22KwR","navbar-datepicker":"navbar-datepicker__2Vc7s","navbar-label":"navbar-label__v2vvg","navbar-spills":"navbar-spills__1KFod","navbar-input":"navbar-input__7nISL","brand-title":"brand-title__3UviI","brand-icon":"brand-icon__1-5tA","brand-tools":"brand-tools__x_vZm","breadcrumb":"breadcrumb__3ac1l","button-list":"button-list__3Tn0U"};

/***/ }),
/* 2160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__36JRf","wrapper-nopadding":"wrapper-nopadding__wfy6S","loading":"loading__3IdOn","error":"error__XZFoJ","table-loading":"table-loading__htn3Z","empty-val":"empty-val__3-QsJ","panelheader-tools":"panelheader-tools__1k1NU","propsPanels":"propsPanels__HIrew","new":"new__1HWSG","marginLm":"marginLm__1UlBR","marginRm":"marginRm__1noWa","fullWidth":"fullWidth__TOv9s","fullHeight":"fullHeight__i9lns","noData":"noData__Iz5ie","content":"content__2y2uX","propslist":"propslist__3Ohqa","action":"action__1Nnec"};

/***/ }),
/* 2161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1gUd7","wrapper-nopadding":"wrapper-nopadding__cwwmd","loading":"loading__AUl8H","error":"error__1JgNE","table-loading":"table-loading__16GDg","empty-val":"empty-val__nIl9w","panelheader-tools":"panelheader-tools__3a_wA","propsPanels":"propsPanels__1CKlj","new":"new__23Hj0","marginLm":"marginLm__3VZz3","marginRm":"marginRm__1W9x1","fullWidth":"fullWidth__1cElo","fullHeight":"fullHeight__2K7UB","noData":"noData__1aogi","actions":"actions__11Dl1","edit":"edit__37xCF","ok":"ok__1Wqu3","cancel":"cancel__1X4Y7","icon":"icon__2w1Ht","deleteIcon":"deleteIcon__1WOAU","gray":"gray__3c2Cg"};

/***/ }),
/* 2162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table-wrapper":"table-wrapper__iM6fk","page-sizes":"page-sizes__1Kbt7","operate-icon":"operate-icon__3teL_","newly-created":"newly-created__3AZE8","deleted":"deleted__3ggik","label":"label__3VT5a","formControl":"formControl__2YF96","buttons":"buttons__3dkvS","edit-group":"edit-group__15wAV","addon-b1":"addon-b1__2CZox","addon-b2":"addon-b2__Oom53","form-control":"form-control__1W6Pe","tokenContainer":"tokenContainer__SOYS1","mRL":"mRL__7fa0w","mTL":"mTL__3gDuv","fullWidth":"fullWidth__3sF1j"};

/***/ }),
/* 2163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1ygUe","wrapper-nopadding":"wrapper-nopadding__3LBeD","loading":"loading__2JVce","error":"error__2wjeq","table-loading":"table-loading__OtsGW","empty-val":"empty-val__2X1N6","panelheader-tools":"panelheader-tools__2i1zI","propsPanels":"propsPanels__1WGjH","new":"new__1vAwE","marginLm":"marginLm__gJn8w","marginRm":"marginRm__34lJJ","fullWidth":"fullWidth__3jZgl","fullHeight":"fullHeight__2w6mA","noData":"noData__1rXpm","content":"content__37vuL","submit":"submit__zln95","chpwd":"chpwd__2XmAM"};

/***/ }),
/* 2164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"view":"view__1-US2"};

/***/ }),
/* 2165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"navbar-wrapper":"navbar-wrapper__2KlMa","navbar-logo":"navbar-logo__25hbp","navbar-brand-text":"navbar-brand-text__2wyTK","menu-item":"menu-item__3xh1r","beta":"beta__29ez9","navbar-transparent":"navbar-transparent__28y5p"};

/***/ }),
/* 2166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"langswitch":"langswitch__2QJEc"};

/***/ }),
/* 2167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"app":"app__1jWOq","app-body":"app-body__ZDg_6"};

/***/ }),
/* 2168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"submit":"submit__2YulC","random":"random__3Cysc"};

/***/ }),
/* 2169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"content__1-3Qh","title":"title__29dvq","props":"props__1miRZ","label":"label__3tsgH","value":"value__22rQz","datatable":"datatable__3Kqdt","field-help":"field-help__3Rpe_","refresh":"refresh__1RwlD","unconection-websocket":"unconection-websocket__3EmgQ","submit":"submit__14h0p"};

/***/ }),
/* 2170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"submit":"submit__6Cvms","charts":"charts__1ifFm","noMetrics":"noMetrics__2XLXX","guide":"guide__1ZX6J"};

/***/ }),
/* 2171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__5tC24","wrapper-nopadding":"wrapper-nopadding__2dIMY","loading":"loading__dxMUe","error":"error__l8Rq7","table-loading":"table-loading__1DtVh","empty-val":"empty-val__31Ys_","panelheader-tools":"panelheader-tools__2MvWd","propsPanels":"propsPanels__ffTOI","new":"new__1XkDd","marginLm":"marginLm__3eNxb","marginRm":"marginRm__365Q4","fullWidth":"fullWidth__Jqwlf","fullHeight":"fullHeight__F6aSD","noData":"noData__9a6p4","view":"view__zdia2"};

/***/ }),
/* 2172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1VUc7","wrapper-nopadding":"wrapper-nopadding__1K6Yu","loading":"loading__2WB91","error":"error__21g14","table-loading":"table-loading__35b-q","empty-val":"empty-val__1Q3Oq","panelheader-tools":"panelheader-tools__jIvxc","propsPanels":"propsPanels__2Chqc","new":"new__228Mm","marginLm":"marginLm__mUlsL","marginRm":"marginRm__l076h","fullWidth":"fullWidth__1Cj2I","fullHeight":"fullHeight__31gg9","noData":"noData__ot37q","actions":"actions__3S5Ua","edit":"edit__3QLW3","ok":"ok__2rRUg","cancel":"cancel__2hRav","name":"name__1AH37","token":"token__eJo67","note":"note__12RKJ","note-edit":"note-edit__1AYP_","submit":"submit__1BMT-","url":"url__3cqrk","tools":"tools__3RAuZ","urlLink":"urlLink__12NA7","delete":"delete__39bEI","borderBtm":"borderBtm__2kCan","flex2":"flex2__1CmmK","flex1":"flex1__38Jku","borderRight":"borderRight__OXe0Q","flexContainer":"flexContainer__3vUOt","posR":"posR__2Pbtg","noWrap":"noWrap__2h_H7"};

/***/ }),
/* 2173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2wmII","wrapper-nopadding":"wrapper-nopadding__2GQJC","loading":"loading__jXzai","error":"error__ftiyf","table-loading":"table-loading__10RMH","empty-val":"empty-val__zbElR","panelheader-tools":"panelheader-tools__3oPZk","propsPanels":"propsPanels__1OT6c","new":"new__2-3mI","marginLm":"marginLm__AfNfm","marginRm":"marginRm__3iQvR","fullWidth":"fullWidth__32wA6","fullHeight":"fullHeight__gmp_2","noData":"noData__2mE6-","tokens":"tokens__1UHZZ","noTokens":"noTokens__1Wtlp","pager":"pager__1-2y6","interfaceContainer":"interfaceContainer__28MWJ"};

/***/ }),
/* 2174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2XD10","wrapper-nopadding":"wrapper-nopadding__2yb98","loading":"loading__2Qfjp","error":"error__2mVAo","table-loading":"table-loading__26wI_","empty-val":"empty-val__2rBJa","panelheader-tools":"panelheader-tools__M5HAO","propsPanels":"propsPanels__10ZLk","new":"new__kVAoG","marginLm":"marginLm__2YfEg","marginRm":"marginRm__3RGVR","fullWidth":"fullWidth__34BnZ","fullHeight":"fullHeight__3n_4k","noData":"noData__2qRgR","urlInput":"urlInput__1W6hb","chkbox":"chkbox__k-YqS","submitError":"submitError__Lsltc"};

/***/ }),
/* 2175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__NcVGP","wrapper-nopadding":"wrapper-nopadding__1YeNs","loading":"loading__1H2Oz","error":"error__1mhM3","table-loading":"table-loading__SIoAt","empty-val":"empty-val__2uLao","panelheader-tools":"panelheader-tools__RR9YZ","propsPanels":"propsPanels__3vRBF","new":"new__3YjCA","marginLm":"marginLm__Q4XsJ","marginRm":"marginRm__3r-UN","fullWidth":"fullWidth__3ikoz","fullHeight":"fullHeight__3F7l8","noData":"noData__iAcoH"};

/***/ }),
/* 2176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__4H-_y","wrapper-nopadding":"wrapper-nopadding__1J6-9","loading":"loading__31C8m","error":"error__nIt0Z","table-loading":"table-loading__3XBWC","empty-val":"empty-val__2ep-N","panelheader-tools":"panelheader-tools__3hMK9","propsPanels":"propsPanels__24lli","new":"new__2wmbH","marginLm":"marginLm__5PX4h","marginRm":"marginRm__3M0BX","fullWidth":"fullWidth__GZyyk","fullHeight":"fullHeight__iiSeS","noData":"noData__2T4AD","helpdoc":"helpdoc__wSVOS","dropzone":"dropzone__zvCPl","dropzone-active":"dropzone-active__1tKIQ","f-checkbox":"f-checkbox__wekMm","preview":"preview__2U6Sz","submit":"submit__1lQ6a","tips":"tips__2c1bW","result-notimport":"result-notimport__2ucqV","result-succ":"result-succ__2euxM","result-fail":"result-fail__vMiAl","result-summary":"result-summary__1r0AV","tools":"tools__2l5jR","missing":"missing__1EuXU","invalid":"invalid__3AIUQ"};

/***/ }),
/* 2177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__HNPq2","wrapper-nopadding":"wrapper-nopadding__1A2lt","loading":"loading__2ZNGq","error":"error__27K9b","table-loading":"table-loading__1cAD8","empty-val":"empty-val__F7MfD","panelheader-tools":"panelheader-tools__1oYlv","propsPanels":"propsPanels__3vu_Z","new":"new__O7EEL","marginLm":"marginLm__3YY2o","marginRm":"marginRm__3ndQG","fullWidth":"fullWidth__vfXEK","fullHeight":"fullHeight__1Gs18","noData":"noData__1WaMN","unit":"unit__2fNJj"};

/***/ }),
/* 2178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__72DWy","wrapper-nopadding":"wrapper-nopadding____JHc","loading":"loading__3vL1L","error":"error__rQwzU","table-loading":"table-loading__qje_H","empty-val":"empty-val__U5NhW","panelheader-tools":"panelheader-tools__1w3nX","propsPanels":"propsPanels__18eVg","new":"new__3Js-E","marginLm":"marginLm__1ax22","marginRm":"marginRm__3rllJ","fullWidth":"fullWidth__3Et_8","fullHeight":"fullHeight__2p6s9","noData":"noData__BVNoz","checkbox":"checkbox__38Izs","disconnected":"disconnected__2q124","connected":"connected__lmPnD"};

/***/ }),
/* 2179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2uAMc","wrapper-nopadding":"wrapper-nopadding__1XXdb","loading":"loading__2ZcL5","error":"error__1itzu","table-loading":"table-loading__1Lkq6","empty-val":"empty-val__3O678","panelheader-tools":"panelheader-tools__3_Dba","propsPanels":"propsPanels__3Q4bY","new":"new__3NBiO","marginLm":"marginLm__3SvkW","marginRm":"marginRm__2eN3v","fullWidth":"fullWidth__2_tzL","fullHeight":"fullHeight__1yJjV","noData":"noData__W6Oqt","clearMgin":"clearMgin__m5EtA","delete":"delete__UiZNL","edit":"edit__2T-5r","gray":"gray__4_SE8"};

/***/ }),
/* 2180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3piT6","wrapper-nopadding":"wrapper-nopadding__1J4gi","loading":"loading__wMV7w","error":"error__1V7dW","table-loading":"table-loading__2g85M","empty-val":"empty-val__3qQuN","panelheader-tools":"panelheader-tools__3Np6_","propsPanels":"propsPanels__29dZE","new":"new__CQkAo","marginLm":"marginLm__2DdMt","marginRm":"marginRm__ApruV","fullWidth":"fullWidth__2noE6","fullHeight":"fullHeight__3cPUG","noData":"noData__3vcKx"};

/***/ }),
/* 2181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__XjVm_","wrapper-nopadding":"wrapper-nopadding__3AUaz","loading":"loading__1ZBtQ","error":"error__1McAP","table-loading":"table-loading__1Aw84","empty-val":"empty-val__q63AN","panelheader-tools":"panelheader-tools__360bc","propsPanels":"propsPanels__2DErN","new":"new__fXpxo","marginLm":"marginLm__CjgcW","marginRm":"marginRm__L9Z5q","fullWidth":"fullWidth__fAN9k","fullHeight":"fullHeight__3JN-A","noData":"noData__3-EjZ","title":"title__1Hysl","lists":"lists__3oLBe","fail":"fail__2Xwkx","cols":"cols__am9Cc","success":"success__iAI1s","successTitle":"successTitle__3gCEy"};

/***/ }),
/* 2182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3F1eT","wrapper-nopadding":"wrapper-nopadding__29fWG","loading":"loading__gsfhp","error":"error__3P2JQ","table-loading":"table-loading__11R0p","empty-val":"empty-val__2zwI3","panelheader-tools":"panelheader-tools__37dS8","propsPanels":"propsPanels__2MS8-","new":"new__29CBQ","marginLm":"marginLm__2HGv2","marginRm":"marginRm__1aaIr","fullWidth":"fullWidth__1ar7P","fullHeight":"fullHeight__2172A","noData":"noData__xdOS2","gray":"gray__QYhK9","failgateway":"failgateway__1kx-f"};

/***/ }),
/* 2183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3ec7_","wrapper-nopadding":"wrapper-nopadding__28mAo","loading":"loading__1mOSu","error":"error__1p2QI","table-loading":"table-loading__3JFo3","empty-val":"empty-val__-yS0Y","panelheader-tools":"panelheader-tools__1UZ7l","propsPanels":"propsPanels__2RpHu","new":"new__2RrTE","marginLm":"marginLm__2UtCM","marginRm":"marginRm__3H1cx","fullWidth":"fullWidth__cpKAu","fullHeight":"fullHeight__1duzp","clearPLeft":"clearPLeft__2fzzy","noData":"noData__2g-sG","clearMgin":"clearMgin__1b-17","delete":"delete__2rw3p","noMgnB":"noMgnB__p49ri","add":"add__29tTB","black":"black__1y6RU","err":"err__3MT5X"};

/***/ }),
/* 2184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__35gQn","wrapper-nopadding":"wrapper-nopadding__RiaBM","loading":"loading__2MW-B","error":"error__3SWgf","table-loading":"table-loading__2sGpX","empty-val":"empty-val__lDNHk","panelheader-tools":"panelheader-tools__NMcmT","propsPanels":"propsPanels__19EYH","new":"new__3Xtma","marginLm":"marginLm__3oWnK","marginRm":"marginRm__2Ri-2","fullWidth":"fullWidth__1G-SJ","fullHeight":"fullHeight__3vTZ1","noData":"noData__3hL1S","container":"container__24Oac"};

/***/ }),
/* 2185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3iTzU","wrapper-nopadding":"wrapper-nopadding__eARmG","loading":"loading__3H7_P","error":"error__3OIwj","table-loading":"table-loading__1Z0fz","empty-val":"empty-val__jw3cM","panelheader-tools":"panelheader-tools__23hWG","propsPanels":"propsPanels__3CfaD","new":"new__2oyMn","marginLm":"marginLm__2uQQW","marginRm":"marginRm__1xDl2","fullWidth":"fullWidth__7p8Tc","fullHeight":"fullHeight__30Ddc","noData":"noData__PcpZ9","itemLayout":"itemLayout__3Rfd1","boardItem":"boardItem__1B81X","border":"border__nyjAL","db-preview":"db-preview__3mK1N","previewone":"previewone__D3t-T","previewtwo":"previewtwo__IKlJu","previewmore":"previewmore__17D_y","db-info":"db-info__1AuRc","font-sm":"font-sm__1znX5","hand":"hand__2yHuh","edit":"edit__2J9aa","delete":"delete__2Q3fR","m-r-l":"m-r-l__1WRTr","gray":"gray__1GBXG","icon1":"icon1__A2HtM","icon2":"icon2__KZyEv","icon3":"icon3__2yaXQ","icon4":"icon4__uVWo7","icon5":"icon5__1lBcR","icon6":"icon6__11wyz","icon7":"icon7__19TnY","icon8":"icon8__VrIR0","no-padding":"no-padding__1PkB7","nodashboard":"nodashboard__MnmXn","desc":"desc__zfSF9"};

/***/ }),
/* 2186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1U3Ix","wrapper-nopadding":"wrapper-nopadding__3pXUC","loading":"loading__1rxmP","error":"error__2AO0F","table-loading":"table-loading__j1aIK","empty-val":"empty-val__10woz","panelheader-tools":"panelheader-tools__M6uQ2","propsPanels":"propsPanels__1cfsV","new":"new__Xns9w","marginLm":"marginLm__1k8BS","marginRm":"marginRm__AgCiP","fullWidth":"fullWidth__3P1-v","fullHeight":"fullHeight__1-XDi","noData":"noData__ly6bl","chart-preview":"chart-preview__3_ABw","graph":"graph__3Kfnz","gray":"gray__1C-7H","m-t-m":"m-t-m__1zF0R","m-l-n":"m-l-n__3M6Jq","header":"header__36EGM","hand":"hand__3PJaO","compress":"compress__3a-OP","triangle":"triangle__3P8aN","chartName":"chartName__14FHK","fontM":"fontM__d9nwJ","clear-panel":"clear-panel__3ye8N"};

/***/ }),
/* 2187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1qRkR","wrapper-nopadding":"wrapper-nopadding__3LsEP","loading":"loading__3025z","error":"error__3pRdx","table-loading":"table-loading__3qHmB","empty-val":"empty-val__1jgSz","panelheader-tools":"panelheader-tools__2lm_e","propsPanels":"propsPanels__2Cd26","new":"new__u0J2y","marginLm":"marginLm__2HyMF","marginRm":"marginRm__-i9iF","fullWidth":"fullWidth__3kNJL","fullHeight":"fullHeight__8xjDb","noData":"noData__1XYXE","itemLayout":"itemLayout__15JWV","boardItem":"boardItem__2orPk","chart-title":"chart-title__3cnNP","delete":"delete__1-Tsy"};

/***/ }),
/* 2188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2g7Xw","wrapper-nopadding":"wrapper-nopadding__2lTQ8","loading":"loading__XR9Ly","error":"error__1pORt","table-loading":"table-loading__11Wxo","empty-val":"empty-val__16b0m","panelheader-tools":"panelheader-tools__21sC9","propsPanels":"propsPanels__21srQ","new":"new__3Fwkh","marginLm":"marginLm__3fxB4","marginRm":"marginRm__3JPu2","fullWidth":"fullWidth__2KLaz","fullHeight":"fullHeight__17LU1","noData":"noData__rk2gh","content":"content__1Br6z","clearRow":"clearRow__nw4oD","green":"green__3STTp","white":"white__Yp0dI","gray":"gray__3kwtv"};

/***/ }),
/* 2189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3SpOF","wrapper-nopadding":"wrapper-nopadding__2IAv7","loading":"loading__1-4_q","error":"error__9QO_S","table-loading":"table-loading__inAOW","empty-val":"empty-val__2aoI6","panelheader-tools":"panelheader-tools__Ik6DI","propsPanels":"propsPanels__3aXYd","new":"new__2szAh","marginLm":"marginLm__2RQ6l","edit":"edit__172FN","marginRm":"marginRm__2xW1d","fullWidth":"fullWidth__1cfRO","fullHeight":"fullHeight__3aBrS","noData":"noData__3ubVb","icons":"icons__1-yHe","ok":"ok__6awN5","remove":"remove__2NBD1"};

/***/ }),
/* 2190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3mqED","wrapper-nopadding":"wrapper-nopadding__2lnQ4","loading":"loading__3HE7O","error":"error__119_M","table-loading":"table-loading__3_lW5","empty-val":"empty-val__106AP","panelheader-tools":"panelheader-tools__1JOut","propsPanels":"propsPanels__3NdJy","new":"new__3iGGW","marginLm":"marginLm__3phyD","marginRm":"marginRm__ak4Ru","fullWidth":"fullWidth__YCvug","fullHeight":"fullHeight__2yWHe","noData":"noData__1x-2e","marginR":"marginR__2H-sA","marginL":"marginL__3JL_P","addDps":"addDps__17M9D","device":"device__3ep2a","leftTool":"leftTool__879W3","ok":"ok__1tkoV","fontM":"fontM__1IEkh","fontBold":"fontBold__2pnim","gray":"gray___-0fN","add-panel":"add-panel__WNrHy","fontsm":"fontsm__3x3Aa","refresh":"refresh__36zLm"};

/***/ }),
/* 2191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3UT5u","wrapper-nopadding":"wrapper-nopadding__1V4Km","loading":"loading__vti0_","error":"error__bYv4s","table-loading":"table-loading__17QKa","empty-val":"empty-val__3GbAr","panelheader-tools":"panelheader-tools__38OxD","propsPanels":"propsPanels__3ItXQ","new":"new__1vB9w","marginLm":"marginLm__1HTB3","marginRm":"marginRm__3j40i","fullWidth":"fullWidth__t6b4Z","fullHeight":"fullHeight__30YWj","noData":"noData__1GD5F"};

/***/ }),
/* 2192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__4qJn_","wrapper-nopadding":"wrapper-nopadding__HsTO8","loading":"loading__2v7zv","error":"error__UWB_-","table-loading":"table-loading__1ohaW","empty-val":"empty-val__3SJVi","panelheader-tools":"panelheader-tools__t9whb","propsPanels":"propsPanels__baIZt","new":"new__3xihG","marginLm":"marginLm__mzD8F","marginRm":"marginRm__3tqnz","fullWidth":"fullWidth__HPycB","fullHeight":"fullHeight__hKHlW","noData":"noData__yeJ32","gray":"gray__CUITF","green":"green__zy-Jk","white":"white__-4Ke2","red":"red__1WRwf","black":"black__1iaUs","content":"content__10U6a","control":"control__ROd7x","margin":"margin__2inEJ","lineHeight":"lineHeight__3bOCm","m-r-m":"m-r-m__3mdY_","clearRow":"clearRow__2DWqx","m-b-sm":"m-b-sm__2cxiR","help":"help__oZ7T9"};

/***/ }),
/* 2193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2GyE8","wrapper-nopadding":"wrapper-nopadding__31K6f","loading":"loading__2HZlT","error":"error__Ey2jY","table-loading":"table-loading__3C5D5","empty-val":"empty-val__3uw7a","panelheader-tools":"panelheader-tools__2O3vj","propsPanels":"propsPanels__Rq34-","new":"new__2EHj6","marginLm":"marginLm__1dWKc","marginRm":"marginRm__3yDFE","fullWidth":"fullWidth__1Gw6d","fullHeight":"fullHeight__2ehHv","noData":"noData__3svY_","marginR":"marginR__2sdVW","marginL":"marginL__2d6Is","addDps":"addDps__4wado","device":"device__N632h","leftTool":"leftTool__3Dkra","ok":"ok__1GJa8","fontM":"fontM__2SiTR","fontBold":"fontBold__3A7aQ","gray":"gray__1IQZ4","add-panel":"add-panel__3UJvi","fontsm":"fontsm__2y9MU","refresh":"refresh__1M5dw"};

/***/ }),
/* 2194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__ru3Vl","wrapper-nopadding":"wrapper-nopadding__lCqrg","loading":"loading__21WMi","error":"error__vGI3k","table-loading":"table-loading__3urMk","empty-val":"empty-val__3JU-Y","panelheader-tools":"panelheader-tools__3hQVb","propsPanels":"propsPanels__tdOcI","new":"new__1ftIJ","marginLm":"marginLm__10ueW","marginRm":"marginRm__cPNhN","fullWidth":"fullWidth__3okB1","fullHeight":"fullHeight__3nuIm","noData":"noData__TYjYF","gray":"gray__1_sJM"};

/***/ }),
/* 2195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3pkl6","wrapper-nopadding":"wrapper-nopadding__1wQYH","loading":"loading__1Akc0","error":"error__1nNBz","table-loading":"table-loading__hY01U","empty-val":"empty-val__3uScp","panelheader-tools":"panelheader-tools__1cOZD","propsPanels":"propsPanels__1BTVl","new":"new__q66lN","marginLm":"marginLm__1Y54u","marginRm":"marginRm__3WvFW","fullWidth":"fullWidth__1IzUh","fullHeight":"fullHeight__ofUh1","noData":"noData__16nwV","conds":"conds__353e5","collapsed":"collapsed__33cJF","condGroup":"condGroup__a9NJP","label":"label__1I4Bk","en":"en__q6R9l","zh":"zh__1e56c","sub":"sub__YpDfd","condBlock":"condBlock__1t58D","condBlockRow":"condBlockRow__3xAOb","toggle":"toggle__2olty"};

/***/ }),
/* 2197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__E3mQB","wrapper-nopadding":"wrapper-nopadding__plV6x","loading":"loading__1yREO","error":"error__3Q9vz","table-loading":"table-loading__1RuhS","empty-val":"empty-val__29Vo5","panelheader-tools":"panelheader-tools__32nP0","propsPanels":"propsPanels__1Ip37","new":"new__1H6N_","marginLm":"marginLm__mdQB5","marginRm":"marginRm__xobr6","fullWidth":"fullWidth__Uo6Wx","fullHeight":"fullHeight__1HUTc","noData":"noData__2-YGP","filter":"filter__1GijY","label":"label__3bVwQ","closeBtn":"closeBtn__YlmVC"};

/***/ }),
/* 2198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2oHqS","wrapper-nopadding":"wrapper-nopadding__kmWN-","loading":"loading__1kOwr","error":"error__1EQ0X","table-loading":"table-loading__Atwhd","empty-val":"empty-val__2hTq4","panelheader-tools":"panelheader-tools__3SAOl","propsPanels":"propsPanels__1jLlk","new":"new__m8ZVs","marginLm":"marginLm__2AXiF","marginRm":"marginRm__14wao","fullWidth":"fullWidth__PT2-m","fullHeight":"fullHeight__1w74j","noData":"noData__3IMBL","btnGroup":"btnGroup__1LQQT","closeBtn":"closeBtn__3GhgA"};

/***/ }),
/* 2199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__4mk5a","wrapper-nopadding":"wrapper-nopadding__38q4H","loading":"loading__12pyY","error":"error__iy-r5","table-loading":"table-loading__38caL","empty-val":"empty-val__1NFb1","panelheader-tools":"panelheader-tools__4wqlQ","propsPanels":"propsPanels__stqW4","new":"new__3_jDi","marginLm":"marginLm__3KMMD","marginRm":"marginRm__N1J10","fullWidth":"fullWidth__2ulk-","fullHeight":"fullHeight__-oYeL","noData":"noData__3oY9n","btnGroup":"btnGroup__tbVWN","closeBtn":"closeBtn__3XIFL"};

/***/ }),
/* 2200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3O1ep","wrapper-nopadding":"wrapper-nopadding__3BF-O","loading":"loading__3iC_6","error":"error__1R0kC","table-loading":"table-loading__2qlHG","empty-val":"empty-val__3wMpj","panelheader-tools":"panelheader-tools__1x-C5","propsPanels":"propsPanels__zTPu3","new":"new__3m5gu","marginLm":"marginLm__39dUo","marginRm":"marginRm__tI0dd","fullWidth":"fullWidth__YdLH0","fullHeight":"fullHeight__AUCCK","noData":"noData__uoq94","trend":"trend__2lV6e","conds":"conds__3qIgm","condGroup":"condGroup__2Fyeb","label":"label__349K2","en":"en__1HhPD","zh":"zh__3FPAB","chart":"chart__3xsot"};

/***/ }),
/* 2202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3d35u","wrapper-nopadding":"wrapper-nopadding__1T3GA","loading":"loading__1WJV0","error":"error__2KSHa","table-loading":"table-loading__1Kpn9","empty-val":"empty-val__1lPR7","panelheader-tools":"panelheader-tools__3yJKw","propsPanels":"propsPanels__38Ez0","new":"new__2xrg1","marginLm":"marginLm__O5fpk","marginRm":"marginRm__2BRgO","fullWidth":"fullWidth__2RI6m","fullHeight":"fullHeight__35Bfp","noData":"noData__G7XO3","dp":"dp__2zxfA","number":"number__1jkLO","block":"block__11VBm","circle":"circle__2ozg_","basic":"basic__2eFN_","guide":"guide__2tnzw","edit":"edit__35Cve","submit":"submit__2344t","ok":"ok__1hc82","cancel":"cancel__2hd2u","desc":"desc__1z8Aw","clickToEdit":"clickToEdit__1euzb","actions":"actions__1yHaR","delete":"delete__-wkd8","id":"id__1GktG","trend":"trend__2cXdm","trendLink":"trendLink__28hEj"};

/***/ }),
/* 2203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3H4Ix","wrapper-nopadding":"wrapper-nopadding__1nyEZ","loading":"loading__lmkx9","error":"error__2h08M","table-loading":"table-loading__3XsZi","empty-val":"empty-val__1Hapv","panelheader-tools":"panelheader-tools__341bd","propsPanels":"propsPanels__2ilX2","new":"new__3jME4","marginLm":"marginLm__3Azy9","marginRm":"marginRm__1olCJ","fullWidth":"fullWidth__2OxKY","fullHeight":"fullHeight__2NEue","noData":"noData__1f3I-","container":"container__AmHD2","content":"content__7U-y3","name":"name__KXPp2","buttons":"buttons__TY1kx","props":"props__2aNZk","label":"label__cG5FR","edit":"edit__PYOgB","count":"count__2ODuE","basic":"basic__34KtS","delete":"delete__OYrRC"};

/***/ }),
/* 2204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"deviceList":"deviceList__1Nuj1","checkbox":"checkbox__2CrbN","searchable":"searchable__3XVE2","pager":"pager__2ha1d","pagers":"pagers__2IvZV","devices":"devices__3anDF","noDevice":"noDevice__2hspO","newDevice":"newDevice__2P9Ig","deleting":"deleting__2UjZC","deleted":"deleted__2nh5Z","marginT":"marginT__2wfNf"};

/***/ }),
/* 2205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__HVFkX","wrapper-nopadding":"wrapper-nopadding__TD0yV","loading":"loading__MYBRa","error":"error__1RQtH","table-loading":"table-loading__2Fz_S","empty-val":"empty-val__UrQ9U","panelheader-tools":"panelheader-tools__tDi_h","propsPanels":"propsPanels__33LOh","new":"new__2UulE","marginLm":"marginLm__7CKA6","marginRm":"marginRm__Qgfyb","fullWidth":"fullWidth__16Omz","fullHeight":"fullHeight__1a7nl","noData":"noData__wqclY","disconnected":"disconnected__2KIEL","connected":"connected__kIDYL","delete":"delete__2ZLLZ","help":"help__2lxFd"};

/***/ }),
/* 2206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modalform":"modalform__2ZYQP","submit":"submit__1KdMw"};

/***/ }),
/* 2207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modalform":"modalform__3NFbq","submit":"submit__3mol6"};

/***/ }),
/* 2208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__25kle","wrapper-nopadding":"wrapper-nopadding__2S7hO","loading":"loading__2UmrZ","error":"error__3Dc_s","table-loading":"table-loading__2h7Tt","empty-val":"empty-val__1nAor","panelheader-tools":"panelheader-tools__3F57j","propsPanels":"propsPanels__1wAkh","new":"new__1lHjq","marginLm":"marginLm__17RZI","marginRm":"marginRm__26cBA","fullWidth":"fullWidth__2Akds","fullHeight":"fullHeight__19yFZ","noData":"noData__3yM6R","buttons":"buttons__3T1Ee","export-data":"export-data__z8Wrf","errtip-mes":"errtip-mes__1CV2X"};

/***/ }),
/* 2209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1azQ6","wrapper-nopadding":"wrapper-nopadding__18G1e","loading":"loading__2E1c6","error":"error__31vkX","table-loading":"table-loading__1ZBFo","empty-val":"empty-val__35Qjf","panelheader-tools":"panelheader-tools__2ew0f","propsPanels":"propsPanels__1Ftml","new":"new__1dTP9","marginLm":"marginLm__3Unqo","marginRm":"marginRm__uWiwk","fullWidth":"fullWidth__172uL","fullHeight":"fullHeight__1HUVZ","noData":"noData__1Q5Zv","editor":"editor__DQ5Vx","scriptEditor":"scriptEditor__2PV6t","submit":"submit__2stgT"};

/***/ }),
/* 2210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2tgw4","wrapper-nopadding":"wrapper-nopadding__3xD6R","loading":"loading__2947K","error":"error__3Bff8","table-loading":"table-loading__2V3-H","empty-val":"empty-val__1CvVb","panelheader-tools":"panelheader-tools__hh1q8","propsPanels":"propsPanels__m5Toc","new":"new__2iX5l","marginLm":"marginLm__2MAvw","marginRm":"marginRm__2S3CH","fullWidth":"fullWidth__2Cka6","fullHeight":"fullHeight__2r4X9","noData":"noData__2XYp2","help":"help__2bqaA","highlight":"highlight__9rBBh"};

/***/ }),
/* 2211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2GJwF","wrapper-nopadding":"wrapper-nopadding__1VrzH","loading":"loading__2BT-p","error":"error__1KEeF","table-loading":"table-loading__dZk1U","empty-val":"empty-val__2kfTy","panelheader-tools":"panelheader-tools__3MvnM","propsPanels":"propsPanels__3fipf","new":"new__2nkWt","marginLm":"marginLm__3Vx37","marginRm":"marginRm__284bE","fullWidth":"fullWidth__puKnC","fullHeight":"fullHeight__3k55n","noData":"noData__26pf4","body":"body__3UVhp","name":"name__Tq9EJ","buttons":"buttons__2Njiw"};

/***/ }),
/* 2212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2B9Cm","wrapper-nopadding":"wrapper-nopadding__2sux0","loading":"loading__2DX_l","error":"error__2FSAz","table-loading":"table-loading__2S__t","empty-val":"empty-val__3m_J9","panelheader-tools":"panelheader-tools__1JXlq","propsPanels":"propsPanels__12s5g","new":"new__jvB0K","marginLm":"marginLm__3xe4v","marginRm":"marginRm__22mTO","fullWidth":"fullWidth__2VipA","fullHeight":"fullHeight__LL5T6","noData":"noData__2Oldv","container":"container__3LPFv","flow":"flow__1r5KW","block":"block__2FZLJ","basic":"basic__ygmup","name":"name__3WB8g","edit":"edit__2Asv2","desc":"desc__2JRJF","actions":"actions__28cRS","delete":"delete__2PNub","ok":"ok__34Y9U","cancel":"cancel__3Lx7B","help":"help__3eSTP","rule":"rule__1tk3L","hasError":"hasError__1-BQi","errorFade":"errorFade__kKELK","arrow":"arrow__3Wmmn","expr":"expr__2z-hO","source":"source__3PdW8","circle":"circle___dEyv","warn":"warn__2DjyO","info":"info__3ix1L","success":"success__4TrHv","helpDoc":"helpDoc__3xPCI"};

/***/ }),
/* 2213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3l_ne","wrapper-nopadding":"wrapper-nopadding__3zlgB","loading":"loading__2whT2","error":"error__WA2iL","table-loading":"table-loading__1A_DV","empty-val":"empty-val__2TR84","panelheader-tools":"panelheader-tools__2psEy","propsPanels":"propsPanels__PQvQX","new":"new__NglUz","marginLm":"marginLm__3yxK6","marginRm":"marginRm__13jhY","fullWidth":"fullWidth__1eNlu","fullHeight":"fullHeight__18qJo","noData":"noData__2A80J","noflow":"noflow__1wW1-","desc":"desc__3R2Yt"};

/***/ }),
/* 2214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loglevel":"loglevel__nBgdc","pager":"pager__1NJ-1","parsed":"parsed__2AsQE","value":"value__2KEU4","key":"key__3EVlY"};

/***/ }),
/* 2215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3sIWv","wrapper-nopadding":"wrapper-nopadding__3QkG2","loading":"loading__1EVEm","error":"error__3au6O","table-loading":"table-loading__oCprg","empty-val":"empty-val__2kXya","panelheader-tools":"panelheader-tools__3PxeR","propsPanels":"propsPanels__24qAp","new":"new__2YLSb","marginLm":"marginLm__ffIAW","marginRm":"marginRm__2M9yT","fullWidth":"fullWidth__1EVgm","fullHeight":"fullHeight__EVL8m","noData":"noData__25qk5","editor":"editor__EhtHJ","codeBlock":"codeBlock__3t5ew","submitBar":"submitBar__I9B1Q","submitError":"submitError__1FyMA","show":"show__1ucqW","identifier":"identifier__3fqBH","keyword":"keyword__AXSp3","string":"string__EXDRu","punctuator":"punctuator__3dFj8","linecomment":"linecomment__uFL2N","blockcomment":"blockcomment__2RVQ4","numeric":"numeric__2d-oc","copy":"copy__1Feos"};

/***/ }),
/* 2216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2S5Yc","wrapper-nopadding":"wrapper-nopadding__3tfQg","loading":"loading__1Rp7U","error":"error__HpZyQ","table-loading":"table-loading__2yKIB","empty-val":"empty-val__2gZ3e","panelheader-tools":"panelheader-tools__1s9BY","propsPanels":"propsPanels__3vGxs","new":"new__2QsEj","marginLm":"marginLm__Impad","marginRm":"marginRm__2w77l","fullWidth":"fullWidth__1Wljd","fullHeight":"fullHeight__yZ6OX","noData":"noData__uO2z9","sample":"sample__29wsj","Identifier":"Identifier__20oDp","Keyword":"Keyword__1wYpe","String":"String__12Sm3","Punctuator":"Punctuator__8Dz7j","LineComment":"LineComment__3I0vx","BlockComment":"BlockComment__3Md9U","Numeric":"Numeric__3iYHq"};

/***/ }),
/* 2217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1ibGG","wrapper-nopadding":"wrapper-nopadding__WPsLI","loading":"loading__3ERpV","error":"error__vK9KY","table-loading":"table-loading__1Sq35","empty-val":"empty-val__2jL_D","panelheader-tools":"panelheader-tools__3crjt","propsPanels":"propsPanels__2gGIb","new":"new__1ID2X","marginLm":"marginLm__uOvII","marginRm":"marginRm__1t7Df","fullWidth":"fullWidth__1wdzT","fullHeight":"fullHeight__i4j_S","noData":"noData__1CHA9","card":"card__1lLiM"};

/***/ }),
/* 2218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__rEZwB","wrapper-nopadding":"wrapper-nopadding__vk5Hb","loading":"loading__A-3tm","error":"error__2_8a4","table-loading":"table-loading__NBSBJ","empty-val":"empty-val__22ciE","panelheader-tools":"panelheader-tools__3iEDx","propsPanels":"propsPanels__3Hiwd","new":"new__36ZtZ","marginLm":"marginLm__FnhxQ","marginRm":"marginRm__2n2w3","fullWidth":"fullWidth__2RUlZ","fullHeight":"fullHeight__crVpY","noData":"noData__3NI5i","desc":"desc__3QCoP","submit":"submit__2ubQE"};

/***/ }),
/* 2219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1LXpL","wrapper-nopadding":"wrapper-nopadding__12z4S","loading":"loading__2L5e_","error":"error__VlL8Y","table-loading":"table-loading__1qyUe","empty-val":"empty-val__wIdlk","panelheader-tools":"panelheader-tools__2ksIW","propsPanels":"propsPanels__3eFuC","new":"new__3l89c","marginLm":"marginLm__2tGTt","marginRm":"marginRm__1TADG","fullWidth":"fullWidth__1nfCz","fullHeight":"fullHeight__5g9Jb","noData":"noData__xF5v3","card":"card__2k7TO","name":"name__1syY5","desc":"desc__2j8dy","actions":"actions__2Uwzr","delete":"delete__2tjTD","edit":"edit__3Qz7V","ok":"ok__2ysIK","cancel":"cancel__2XSd_","descEditor":"descEditor__22S6U"};

/***/ }),
/* 2220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1BmV6","wrapper-nopadding":"wrapper-nopadding__1bgnK","loading":"loading__A7adp","error":"error__1yRK4","table-loading":"table-loading__1dPTR","empty-val":"empty-val__1bZ_M","panelheader-tools":"panelheader-tools__1tDOx","propsPanels":"propsPanels__2r7pa","new":"new__1BVC9","marginLm":"marginLm__3tGQ5","marginRm":"marginRm__3hjzC","fullWidth":"fullWidth__1D3ww","fullHeight":"fullHeight__2ns4f","noData":"noData__2YvPi"};

/***/ }),
/* 2221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttons":"buttons__22Dwj","name":"name__29HxH"};

/***/ }),
/* 2222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1_Ikm","wrapper-nopadding":"wrapper-nopadding__3PnwV","loading":"loading__2k4GY","error":"error__BE2nm","table-loading":"table-loading__2IUne","empty-val":"empty-val__34kxg","panelheader-tools":"panelheader-tools__1VZjz","propsPanels":"propsPanels__3DMgz","new":"new__2u1uY","marginLm":"marginLm__1ZN7E","marginRm":"marginRm__1HRnb","fullWidth":"fullWidth__28STb","fullHeight":"fullHeight__2G_YR","noData":"noData__3rucp","data":"data__2JrZb","tabBase":"tabBase__BUFtB","tab":"tab__3mOQo","option":"option__GeWju","line":"line__1bUd8","label":"label__fy3we","mgM":"mgM__vMfMu","mgS":"mgS__2cuXm","bgWhite":"bgWhite__3fOYG"};

/***/ }),
/* 2223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2Ke3g","wrapper-nopadding":"wrapper-nopadding__2nQFf","loading":"loading__YoNnb","error":"error__3FEbG","table-loading":"table-loading__1b8FE","empty-val":"empty-val__3Y78e","panelheader-tools":"panelheader-tools__1VEGr","propsPanels":"propsPanels__1OA1U","new":"new__2jbfO","marginLm":"marginLm__3hLtr","marginRm":"marginRm__1KCTt","fullWidth":"fullWidth__1ST2_","fullHeight":"fullHeight__31mN3","noData":"noData__1_huo","card":"card__1_LMZ"};

/***/ }),
/* 2224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1lPHT","wrapper-nopadding":"wrapper-nopadding__1ptHP","loading":"loading__1iMG6","error":"error__1YHcX","table-loading":"table-loading__3UJno","empty-val":"empty-val__10Frd","panelheader-tools":"panelheader-tools__1T57k","propsPanels":"propsPanels__3VePC","new":"new__2b3k5","marginLm":"marginLm__1O32f","marginRm":"marginRm__1rerA","fullWidth":"fullWidth__UcyF0","fullHeight":"fullHeight__A_66W","noData":"noData__3cRKP","editor":"editor__2EpeH","codeBlock":"codeBlock__2OKdY","submitBar":"submitBar__1gyC5","submitError":"submitError__2wE-C","show":"show__1JOS7","identifier":"identifier__1envU","keyword":"keyword__2JMyp","string":"string__1_AdG","punctuator":"punctuator__3r9Zv","linecomment":"linecomment__2bnAR","blockcomment":"blockcomment__Zc4hM","numeric":"numeric__1j-h3","copy":"copy__1a5-N"};

/***/ }),
/* 2226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"view":"view__prjxI"};

/***/ }),
/* 2227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__19ZII","wrapper-nopadding":"wrapper-nopadding__5ILSt","loading":"loading__1qDZE","error":"error__pZZgN","table-loading":"table-loading__2ILhf","empty-val":"empty-val__VA2MH","panelheader-tools":"panelheader-tools__24sid","propsPanels":"propsPanels__3K_FF","new":"new__jtITN","marginLm":"marginLm__1TAMh","marginRm":"marginRm__1la_b","fullWidth":"fullWidth__2DdgS","fullHeight":"fullHeight__2yUyZ","noData":"noData__1axUF","pager":"pager__ubFjv","noapp":"noapp__7vv0Z"};

/***/ }),
/* 2228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__36UPl","wrapper-nopadding":"wrapper-nopadding__3C_G0","loading":"loading__3UO_m","error":"error__3dkfR","table-loading":"table-loading__2U9Ij","empty-val":"empty-val__3_f9L","panelheader-tools":"panelheader-tools__D1s9O","propsPanels":"propsPanels__1nsvn","new":"new__2ZUR7","marginLm":"marginLm__OlQoa","marginRm":"marginRm__qVQwJ","fullWidth":"fullWidth__tIwr0","fullHeight":"fullHeight__3kmoI","noData":"noData__1LEu8","container":"container__HYtFX","switcher":"switcher__2IW2J"};

/***/ }),
/* 2229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1hM09","wrapper-nopadding":"wrapper-nopadding__1EZLP","loading":"loading__3MnN0","error":"error__PWlRm","table-loading":"table-loading__129A2","empty-val":"empty-val__35akt","panelheader-tools":"panelheader-tools__2t7vg","propsPanels":"propsPanels__TRAUa","new":"new__3W2OG","marginLm":"marginLm__3qEpd","marginRm":"marginRm__TKlm7","fullWidth":"fullWidth__3PWqn","fullHeight":"fullHeight__3yF0k","noData":"noData__2SJoP","label":"label__2VIU_","title":"title__3DBBW","pager":"pager__6e32p","adrlogs":"adrlogs__X9Ge8","gray":"gray__1DDjx","adapt":"adapt__2no6m","selectArea":"selectArea__TVDVl","actions":"actions__15ZGl","edit":"edit__QjwF1","ok":"ok__2e99i","cancel":"cancel__3QaTf","infos":"infos__1y3pE","info":"info__2TdA6","resetLoad":"resetLoad__10iKh"};

/***/ }),
/* 2230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__18RAO","wrapper-nopadding":"wrapper-nopadding__2pkhU","loading":"loading___tGYy","error":"error__1sgYs","table-loading":"table-loading__2496C","empty-val":"empty-val__3NVYm","panelheader-tools":"panelheader-tools__3GXxU","propsPanels":"propsPanels__3bV8F","new":"new__35GAD","marginLm":"marginLm__1Su-1","marginRm":"marginRm__DZUxq","fullWidth":"fullWidth__SQgrG","fullHeight":"fullHeight__2vRb2","noData":"noData__3l60Y","graph":"graph__3vmwl","gray":"gray__YTfQu","blue":"blue__2YJNr","load":"load__2ny2Q","timeout":"timeout__2Rzv4"};

/***/ }),
/* 2231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttons":"buttons__tumCY","refresher":"refresher__3Qus0"};

/***/ }),
/* 2232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__da4DQ","wrapper-nopadding":"wrapper-nopadding__3bCxm","loading":"loading__1wK_Q","error":"error__2pX5i","table-loading":"table-loading__3G6yI","empty-val":"empty-val__jDddW","panelheader-tools":"panelheader-tools__2MQFr","propsPanels":"propsPanels__3kOGB","new":"new__3TNC0","marginLm":"marginLm__3EMvq","marginRm":"marginRm__14bpL","fullWidth":"fullWidth__2BjmD","fullHeight":"fullHeight__1BzFb","noData":"noData__bZVAY","sendForm":"sendForm__2k_IL","txSize":"txSize__2Um4G","label":"label__EV0rs","value":"value__CH8dW","refresher":"refresher__3ndnu","marginRight":"marginRight__3pZTj","marginRightO":"marginRightO__3qoys"};

/***/ }),
/* 2233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"toolWrapper":"toolWrapper__22mxa","tools":"tools__2YUZb"};

/***/ }),
/* 2234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1uJVN","wrapper-nopadding":"wrapper-nopadding__1oNp4","loading":"loading__1Z_c-","error":"error__1lLK6","table-loading":"table-loading__1Uadi","empty-val":"empty-val__K0-gm","panelheader-tools":"panelheader-tools__iHSnQ","propsPanels":"propsPanels__3Q5gL","new":"new__2VRs1","marginLm":"marginLm__3_--k","marginRm":"marginRm__1tnLK","fullWidth":"fullWidth__1-_wr","fullHeight":"fullHeight__-5yDX","noData":"noData__6VpR-","chart-toolbar":"chart-toolbar__1C5Ie","chart-canvas":"chart-canvas__w81pX","f-time":"f-time__19uOa","f-appeui":"f-appeui__3sMgr","f-deveui":"f-deveui__1LOQy","datadir":"datadir__2hZDT","msg-box-fail":"msg-box-fail__NYGNt","msg-box-success":"msg-box-success__2R1-Y","noticeHeader":"noticeHeader__rNvLl","notice":"notice__klHHP","noDevice":"noDevice__2OEi-","desc":"desc__3_Xja"};

/***/ }),
/* 2235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__rEf8m","wrapper-nopadding":"wrapper-nopadding__2XtI2","loading":"loading__2ZFO-","error":"error__2267d","table-loading":"table-loading__o6pYZ","empty-val":"empty-val__18w-z","panelheader-tools":"panelheader-tools__18GSe","propsPanels":"propsPanels___eEgB","new":"new__2svwk","marginLm":"marginLm__GJQVd","marginRm":"marginRm__115rN","fullWidth":"fullWidth__1ug7-","fullHeight":"fullHeight__2oYLu","noData":"noData__6Gc6J","dataTable":"dataTable__1W3cZ"};

/***/ }),
/* 2236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__36MZQ","wrapper-nopadding":"wrapper-nopadding__E5b92","loading":"loading__2MPCM","error":"error__z0sCU","table-loading":"table-loading__3aFj2","empty-val":"empty-val__EZZHf","panelheader-tools":"panelheader-tools__2fcNK","propsPanels":"propsPanels__2GXXO","new":"new__1-oYr","marginLm":"marginLm__vrvOC","marginRm":"marginRm__1bXTm","fullWidth":"fullWidth__2l671","fullHeight":"fullHeight__3khvs","noData":"noData__3gxO0","dataTable":"dataTable__YOfKb","pager":"pager__2kb5i"};

/***/ }),
/* 2237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"pager":"pager__1y_i2","parsed":"parsed__N3jDJ","value":"value__1MYG1","key":"key__1-Apk"};

/***/ }),
/* 2238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3RiRc","wrapper-nopadding":"wrapper-nopadding__2g7pm","loading":"loading__3p3jy","error":"error__3Gflr","table-loading":"table-loading__2Oe7e","empty-val":"empty-val__38B-k","panelheader-tools":"panelheader-tools__3d5aP","propsPanels":"propsPanels__2GjmY","new":"new__1VQ_x","marginLm":"marginLm__2AxT0","marginRm":"marginRm__2pUx5","fullWidth":"fullWidth__1FV33","fullHeight":"fullHeight__1o9X-","noData":"noData__34F8D","rxdelay":"rxdelay__1agJn","errorBlock":"errorBlock__NCA7d"};

/***/ }),
/* 2239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ring-switcher":"ring-switcher__398US"};

/***/ }),
/* 2240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2f83I","wrapper-nopadding":"wrapper-nopadding__1YNiL","loading":"loading__3FuT1","error":"error__1LXAk","table-loading":"table-loading__IgeiP","empty-val":"empty-val__3_fDA","panelheader-tools":"panelheader-tools__2imhh","propsPanels":"propsPanels__2dv8P","new":"new__142wo","marginLm":"marginLm__3VoHw","marginRm":"marginRm__FFizL","fullWidth":"fullWidth__rd7Dq","fullHeight":"fullHeight__1ZlMb","noData":"noData__1Oq-9","tabs":"tabs__1KW5a","tab":"tab__1lede","logtable":"logtable__16y9w","tableHeader":"tableHeader__2WtUg","tableTitle":"tableTitle__2c7q5","tableIcon":"tableIcon__3JIFk","submitTips":"submitTips__Objmr","dir":"dir__bsyV9","up":"up__1suq9","down":"down__1kjjt","formatSwitcher":"formatSwitcher__27zv0"};

/***/ }),
/* 2241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__18hN8","wrapper-nopadding":"wrapper-nopadding__2k_Gp","loading":"loading__1XlrA","error":"error__EIrxQ","table-loading":"table-loading__2NGO5","empty-val":"empty-val__3M4hX","panelheader-tools":"panelheader-tools__2KBNg","propsPanels":"propsPanels__1sQp7","new":"new__1QtYQ","marginLm":"marginLm__3abIF","marginRm":"marginRm__31K8v","fullWidth":"fullWidth__2lI2g","fullHeight":"fullHeight__F8etM","noData":"noData__23jup","help":"help__2PyqK","appear":"appear__1ve-9","enter":"enter__2p_cA","appearActive":"appearActive__1m4Zr","enterActive":"enterActive__ewG-T"};

/***/ }),
/* 2242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__QT2qQ","wrapper-nopadding":"wrapper-nopadding__1VlTC","loading":"loading__2YNPQ","error":"error__2XFpN","table-loading":"table-loading__2jT2u","empty-val":"empty-val__1ykNr","panelheader-tools":"panelheader-tools__2A_NP","propsPanels":"propsPanels__1AmWp","new":"new__2mtaP","marginLm":"marginLm__1AcuM","marginRm":"marginRm__2XM7q","fullWidth":"fullWidth__1RJPL","fullHeight":"fullHeight__3nvqH","noData":"noData__1Lh5g","parameter":"parameter__1qEKX","raw":"raw__3Vl0N","parsed":"parsed__2WHF0","value":"value__3bJQd","key":"key__2PW3f"};

/***/ }),
/* 2243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__Urklo","wrapper-nopadding":"wrapper-nopadding__2s5Sv","loading":"loading__2DwIn","error":"error__2UFxC","table-loading":"table-loading__BCfIv","empty-val":"empty-val__1967J","panelheader-tools":"panelheader-tools__Iup7l","propsPanels":"propsPanels__2fqUt","new":"new__1RwwU","marginLm":"marginLm__2Vfka","marginRm":"marginRm__WEpqr","fullWidth":"fullWidth__2FXc6","fullHeight":"fullHeight__2Tmr3","noData":"noData__27Ivu","maccommand":"maccommand__-06o1","macform":"macform__hCWpt","qsize":"qsize__CLw-k","title":"title__1l5zo","value":"value__3JjJ0"};

/***/ }),
/* 2244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2kGvS","wrapper-nopadding":"wrapper-nopadding__1mqZb","loading":"loading__Z8Cu1","error":"error__1UWcD","table-loading":"table-loading__3cUgz","empty-val":"empty-val__Rk9aJ","panelheader-tools":"panelheader-tools__Ex0Rt","propsPanels":"propsPanels__286n0","new":"new__2Krlx","marginLm":"marginLm__346M7","marginRm":"marginRm__1fr2H","fullWidth":"fullWidth__2TPgk","fullHeight":"fullHeight__95RE6","noData":"noData__3gBXE","overlay":"overlay__1QfqF","mapButton":"mapButton__3oN_l","closeButton":"closeButton__3VmM3","mapMarker":"mapMarker__3GfBt","buttonText":"buttonText__7Fl1c","point":"point__1fiUb","searchinput":"searchinput__3-Xf5"};

/***/ }),
/* 2245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3E02R","wrapper-nopadding":"wrapper-nopadding__1cVQB","loading":"loading__1rEBy","error":"error__3CZDX","table-loading":"table-loading__1Xoo-","empty-val":"empty-val__3aw9t","panelheader-tools":"panelheader-tools__2kWTC","propsPanels":"propsPanels__363PE","new":"new__2eMAo","marginLm":"marginLm__PU4RZ","marginRm":"marginRm__2KzQF","fullWidth":"fullWidth__2IKwD","fullHeight":"fullHeight__2lA9W","noData":"noData__3rcfZ","inline":"inline__QzNDe","infos":"infos__O3EcX","info":"info__YOajh"};

/***/ }),
/* 2246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__36mVY","wrapper-nopadding":"wrapper-nopadding__QAo60","loading":"loading__1_H7a","error":"error__22486","table-loading":"table-loading__23Ccg","empty-val":"empty-val__wchpN","panelheader-tools":"panelheader-tools__3Cq2w","propsPanels":"propsPanels__1BWKF","new":"new__JUgTK","marginLm":"marginLm__H7edt","marginRm":"marginRm__1dtfh","fullWidth":"fullWidth__29bmA","fullHeight":"fullHeight__v3NxJ","noData":"noData__37q5Y","gatewayName":"gatewayName__2kRgs","gateway":"gateway__3GnAF","icon":"icon__3HMF2","delete":"delete__xx8mM","edit":"edit__1N8o0"};

/***/ }),
/* 2247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1mFF2","wrapper-nopadding":"wrapper-nopadding__3PdmU","loading":"loading___qgQA","error":"error__3Bdbx","table-loading":"table-loading__2DgmK","empty-val":"empty-val__LMUg1","panelheader-tools":"panelheader-tools__32PGI","propsPanels":"propsPanels__3N_AY","new":"new__Rnxi5","marginLm":"marginLm__3iIdc","marginRm":"marginRm__1jHtp","fullWidth":"fullWidth__b2_9C","fullHeight":"fullHeight__18hpZ","noData":"noData__1pNRd","best":"best__3Y7Za","delete":"delete__2wgtt"};

/***/ }),
/* 2248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"view":"view__3WQKc"};

/***/ }),
/* 2249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3Hq1_","wrapper-nopadding":"wrapper-nopadding__34kOt","loading":"loading__1tBsO","error":"error__1GHUu","table-loading":"table-loading__2Xxi_","empty-val":"empty-val__2xvr1","panelheader-tools":"panelheader-tools__16PC7","propsPanels":"propsPanels__2Dv11","new":"new__2lEvj","marginLm":"marginLm__2x6nM","marginRm":"marginRm__2AnjJ","fullWidth":"fullWidth__1gx83","fullHeight":"fullHeight__2Vwk3","noData":"noData__2EkkL","app-table":"app-table__1uy_r","content":"content__hskbg","modal-form":"modal-form__2YRTR"};

/***/ }),
/* 2250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__sRnhx","wrapper-nopadding":"wrapper-nopadding__ipdNc","loading":"loading__2VDKh","error":"error__8DXYz","table-loading":"table-loading__3baD0","empty-val":"empty-val__-Of5p","panelheader-tools":"panelheader-tools__iCWw5","propsPanels":"propsPanels__1uk6Q","new":"new__cT69E","marginLm":"marginLm__3eO9p","marginRm":"marginRm__1bzRS","fullWidth":"fullWidth__2xMS6","fullHeight":"fullHeight__VASoc","noData":"noData__24JaG","balogs":"balogs__2xnOh","balance":"balance__2zxTb","label":"label__31IJS","recharge":"recharge__2Dgc2"};

/***/ }),
/* 2251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__Rn1U1","wrapper-nopadding":"wrapper-nopadding__2GrF-","loading":"loading__3JEio","error":"error__1OwDu","table-loading":"table-loading__TIShx","empty-val":"empty-val__TnokK","panelheader-tools":"panelheader-tools__2isku","propsPanels":"propsPanels__1UAn_","new":"new__3T9SI","marginLm":"marginLm__1-HlN","marginRm":"marginRm__2bh3t","fullWidth":"fullWidth__2QbiG","fullHeight":"fullHeight__1NO2i","noData":"noData__2qpzA","detail-table-wrapper":"detail-table-wrapper__3L0cM","detail-table":"detail-table__15e72","bill-info":"bill-info__kC3oY","val":"val__2cBRF","sub":"sub__2UEZo"};

/***/ }),
/* 2252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1_AOP","wrapper-nopadding":"wrapper-nopadding__3HKgD","loading":"loading__2Uwj9","error":"error__V4R1h","table-loading":"table-loading__5a7vz","empty-val":"empty-val__3TzIM","panelheader-tools":"panelheader-tools__1wNIF","propsPanels":"propsPanels__28fEc","new":"new__2Np1M","marginLm":"marginLm__Go6Jd","marginRm":"marginRm__3a2jG","fullWidth":"fullWidth__ZJRLv","fullHeight":"fullHeight__2BsJ5","noData":"noData__2lj2k"};

/***/ }),
/* 2253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2oIlM","wrapper-nopadding":"wrapper-nopadding__252EU","loading":"loading__wL5jA","error":"error__25z4y","table-loading":"table-loading__1OWft","empty-val":"empty-val__1bSsr","panelheader-tools":"panelheader-tools__ccMtL","propsPanels":"propsPanels__2rVO1","new":"new__3AHMj","marginLm":"marginLm__1lxpX","marginRm":"marginRm__2v070","fullWidth":"fullWidth__13xLF","fullHeight":"fullHeight__301h4","noData":"noData__1UTMo","methods":"methods__2ns_2","method":"method__2bcdG","active":"active__1CCNB","recharge-form":"recharge-form__3lPOE","wechat":"wechat__2B_I_","scan":"scan__2oTt1","qrcode":"qrcode__2A1PX","result":"result__YdZSr","expired":"expired__1skwz","success":"success__2aCei","countdown":"countdown__1N2kf","remaining":"remaining__1sYqf","footer":"footer__7Hulv","scanillu":"scanillu__3CPot","bill-info":"bill-info__g9Kbm","label":"label__2f9HQ","notes":"notes__3ZuHo","inline":"inline__1rM_M","cardTxt":"cardTxt__1AcIf","clearLine":"clearLine__39w97","widthAuto":"widthAuto__kmNUe","cardLoading":"cardLoading__19Wwv","cancelHeader":"cancelHeader__11y4r"};

/***/ }),
/* 2254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"basic-info":"basic-info__1tx2U","avatar-card":"avatar-card__Z34EL","avatar-img":"avatar-img__1c51g","avatar-desc":"avatar-desc__us25O","content-card":"content-card__tlfpr","bold-title":"bold-title__5nYpW","balance":"balance__2Lr_A","balance-val":"balance-val__XGxy4","bills-info":"bills-info__28orG","billday":"billday__3f0jJ","billday-val":"billday-val__rHyE7","bill-help":"bill-help__2wZoM","extra-pd":"extra-pd__337_n"};

/***/ }),
/* 2255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tier":"tier__3eQEV","price":"price__379XL","card-content":"card-content__NxZhz"};

/***/ }),
/* 2256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1yXWL","comm-up":"comm-up__32oX2","comm-up-desc":"comm-up-desc__2qJJ3","sub":"sub__3bfRJ","svc-pkg":"svc-pkg__2BTYt","svc-pkg-desc":"svc-pkg-desc__6fk4t","svc-pkg-form":"svc-pkg-form__4fajT","buttons":"buttons__oKEfX","remaining-urgent":"remaining-urgent__3kRDc","remaining-tips":"remaining-tips__-L9fZ","heading":"heading__2-h5w"};

/***/ }),
/* 2257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3KRr8","wrapper-nopadding":"wrapper-nopadding__nYbEd","loading":"loading__3rKoA","error":"error__22snW","table-loading":"table-loading__h9aOx","empty-val":"empty-val__Vr0C3","panelheader-tools":"panelheader-tools__3roX7","propsPanels":"propsPanels__2X_pH","new":"new__1_Vp7","marginLm":"marginLm__1ub1-","marginRm":"marginRm__1D_Uh","fullWidth":"fullWidth__3nrmn","fullHeight":"fullHeight__2VI0_","noData":"noData__19FWD","expired-notify-wrapper":"expired-notify-wrapper__2Q6rm","expired-notify":"expired-notify__IsIW9"};

/***/ }),
/* 2258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1uR4L","breadcrumbs":"breadcrumbs__2x7lk","content":"content__2x6oh","form-wrapper":"form-wrapper__s3G0N","form-divider":"form-divider__3XFBs","optional-fields":"optional-fields__XZ42w","field-explain":"field-explain__1JMuS","dotsline":"dotsline__2LOkJ","errortips-wrapper":"errortips-wrapper__2F6C4","errortips":"errortips__IWpAR","errmsg":"errmsg__2goxT"};

/***/ }),
/* 2259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1enjF","wrapper-nopadding":"wrapper-nopadding__3UO3c","loading":"loading__xK5pr","error":"error__2reP-","table-loading":"table-loading__1QCOn","empty-val":"empty-val__2yNew","panelheader-tools":"panelheader-tools__2HuxV","propsPanels":"propsPanels__1_8jg","new":"new__6pQaF","marginLm":"marginLm__hzQYj","marginRm":"marginRm__T64hN","fullWidth":"fullWidth__1oQzC","fullHeight":"fullHeight__2yU8l","noData":"noData__2Gz7w","compact":"compact__3s3kh","dataTable":"dataTable__3ywzy"};

/***/ }),
/* 2260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1il0i","wrapper-nopadding":"wrapper-nopadding__p79Va","loading":"loading__1IXs_","error":"error__h_PWe","table-loading":"table-loading__1qhng","empty-val":"empty-val__3mjgj","panelheader-tools":"panelheader-tools__1_QG-","propsPanels":"propsPanels__2hVsk","new":"new__14K53","marginLm":"marginLm__2AFMM","marginRm":"marginRm__v243M","fullWidth":"fullWidth__2rHRx","fullHeight":"fullHeight__23WQN","noData":"noData__16ssu","props-panel":"props-panel__1KKOq","props-list":"props-list__1z68h","prop-name":"prop-name__LjiFo","prop-value":"prop-value__2b99f","unkownTips":"unkownTips__ZJy-u"};

/***/ }),
/* 2261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__sCB79","wrapper-nopadding":"wrapper-nopadding__335vI","loading":"loading__3-uG_","error":"error__2ygh9","table-loading":"table-loading__1TDAc","empty-val":"empty-val__5S4MM","panelheader-tools":"panelheader-tools__3CWoZ","propsPanels":"propsPanels__1qkKg","new":"new__3G4s0","marginLm":"marginLm__2mrM3","marginRm":"marginRm__3fUmV","fullWidth":"fullWidth__3IVpI","fullHeight":"fullHeight__3r7kH","noData":"noData__2xIsT","toolbar":"toolbar__3u3Xz","breadcrumb":"breadcrumb__3eth9","buttons":"buttons__3Mjts","chart-toolbar":"chart-toolbar__W5EhR"};

/***/ }),
/* 2262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"chart":"chart__1pKdZ"};

/***/ }),
/* 2263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"chart":"chart__1RHm0"};

/***/ }),
/* 2264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1Y3li","wrapper-nopadding":"wrapper-nopadding__rW_Bv","loading":"loading__1jdtd","error":"error__3K5p8","table-loading":"table-loading__1HW2J","empty-val":"empty-val__3a8oi","panelheader-tools":"panelheader-tools__3FAzU","propsPanels":"propsPanels__3j0Zf","new":"new__2RXC2","marginLm":"marginLm__1kezy","marginRm":"marginRm__1uyfG","fullWidth":"fullWidth__1wyjQ","fullHeight":"fullHeight__rYHOD","noData":"noData__MImV9","packets":"packets__1Ghlo","panels":"panels__sX4Zx"};

/***/ }),
/* 2265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"chart":"chart__223-T"};

/***/ }),
/* 2266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"chart":"chart__1I5pl"};

/***/ }),
/* 2267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__37i0r","wrapper-nopadding":"wrapper-nopadding__2vdJg","loading":"loading__2PyY4","error":"error__16uM2","table-loading":"table-loading__2wbwE","empty-val":"empty-val__2VzcJ","panelheader-tools":"panelheader-tools__jGJA2","propsPanels":"propsPanels__2Sv9L","new":"new__Ufvh2","marginLm":"marginLm__136Nm","marginRm":"marginRm__Hb4k3","fullWidth":"fullWidth__3_rxo","fullHeight":"fullHeight__3Qq20","noData":"noData__Jco29","flushcp":"flushcp__tr2xm","errorBlock":"errorBlock__3r6Kw","noauth":"noauth__30zcQ"};

/***/ }),
/* 2268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"chart":"chart__tQams"};

/***/ }),
/* 2269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"chart":"chart__1ZzqC"};

/***/ }),
/* 2270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"chart":"chart__3huPI"};

/***/ }),
/* 2271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3xnIV","wrapper-nopadding":"wrapper-nopadding__1kW2n","loading":"loading__3_Kuf","error":"error__1qTNP","table-loading":"table-loading__1kKNR","empty-val":"empty-val__1iP5S","panelheader-tools":"panelheader-tools__1PdOA","propsPanels":"propsPanels__3nG4_","new":"new__2iiyQ","marginLm":"marginLm__3pYP3","marginRm":"marginRm__2umHW","fullWidth":"fullWidth__12ZR5","fullHeight":"fullHeight__1dcnI","noData":"noData__3zs7K","ota":"ota__2CYU1","panels":"panels__3z3jc"};

/***/ }),
/* 2272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"chart":"chart__HUloz"};

/***/ }),
/* 2273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"chart":"chart__3tw-B"};

/***/ }),
/* 2274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2o9l2","wrapper-nopadding":"wrapper-nopadding__1F5FM","loading":"loading__uAMCl","error":"error__3QMLM","table-loading":"table-loading__3BfE0","empty-val":"empty-val__1dBuh","panelheader-tools":"panelheader-tools__28VLY","propsPanels":"propsPanels__1k_Vi","new":"new__3Enen","marginLm":"marginLm__hQmGg","marginRm":"marginRm__1jZc-","fullWidth":"fullWidth__3Ljky","fullHeight":"fullHeight__2XsTC","noData":"noData__xlvBW"};

/***/ }),
/* 2275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2UsvH","wrapper-nopadding":"wrapper-nopadding__2c7YN","loading":"loading__2Aw0k","error":"error__r-Pud","table-loading":"table-loading__MYBcz","empty-val":"empty-val__1S64d","panelheader-tools":"panelheader-tools__9ZjpU","propsPanels":"propsPanels__2jZJi","new":"new__3hXCJ","marginLm":"marginLm__fArYb","marginRm":"marginRm__3SpZj","fullWidth":"fullWidth__WFCRV","fullHeight":"fullHeight__20K_Z","noData":"noData__cFJOo","view":"view__3o0fY"};

/***/ }),
/* 2276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"disconnected":"disconnected__62hyA","connected":"connected__AwQCV","pager":"pager__2zsV6","noGateway":"noGateway__3XyXM","buy":"buy__37N9d","marginT":"marginT__18SPo"};

/***/ }),
/* 2277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"pager":"pager__37AnK","noData":"noData__2yPDt"};

/***/ }),
/* 2278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2RkRU","wrapper-nopadding":"wrapper-nopadding__q1UmJ","loading":"loading__161rf","error":"error__G85ZV","table-loading":"table-loading__2pMIE","empty-val":"empty-val__1_JPE","panelheader-tools":"panelheader-tools__3ADXn","propsPanels":"propsPanels__14h_c","new":"new__3GjBB","marginLm":"marginLm__2tD--","marginRm":"marginRm__1I8QO","fullWidth":"fullWidth__3rcrR","fullHeight":"fullHeight__1Ri2V","noData":"noData__1SjqQ","map":"map__1ul3o","noGateway":"noGateway__12a72"};

/***/ }),
/* 2279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__ziiO9","wrapper-nopadding":"wrapper-nopadding__-Gd8g","loading":"loading__2VSvX","error":"error__2ET0e","table-loading":"table-loading__2SblE","empty-val":"empty-val__IPZ38","panelheader-tools":"panelheader-tools__WKpPS","propsPanels":"propsPanels__178C4","new":"new__262CY","marginLm":"marginLm__3HZfO","marginRm":"marginRm__3cSq8","fullWidth":"fullWidth__pPOLB","fullHeight":"fullHeight__3E-rI","noData":"noData__2Cyfk","overlay":"overlay__6tl49","mapButton":"mapButton__33VSZ","closeButton":"closeButton__2SZ74","mapMarker":"mapMarker__35Jwt","buttonText":"buttonText__1v58a","point":"point__2ZAsT","searchinput":"searchinput__sw7Ug"};

/***/ }),
/* 2280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__T7EIM","wrapper-nopadding":"wrapper-nopadding__1Zods","loading":"loading__1KTOy","error":"error__1ag91","table-loading":"table-loading__zGjgo","empty-val":"empty-val__2iGkf","panelheader-tools":"panelheader-tools__3997z","propsPanels":"propsPanels__3EPMO","new":"new__1NBqB","marginLm":"marginLm__2MUGT","marginRm":"marginRm__2gQ5I","fullWidth":"fullWidth__9jI58","fullHeight":"fullHeight__1aK51","noData":"noData__1UfBB","view-opts":"view-opts__bhHXq","view-opt":"view-opt__29frC","active":"active__2F5g1","content":"content__2HvcH","toolbar":"toolbar__169MO","brandIcon":"brandIcon__11plP"};

/***/ }),
/* 2281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3Fc7Q","login":"login__3cGKc","login-error":"login-error__2jBBI","login-links":"login-links__1hQ6Q","links":"links__1Mpqe"};

/***/ }),
/* 2282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__sTY2N","wrapper-nopadding":"wrapper-nopadding__2ciKX","loading":"loading__G6hEl","error":"error__H1qGf","table-loading":"table-loading__3hmqD","empty-val":"empty-val__3Fuhs","panelheader-tools":"panelheader-tools__2Bpz_","propsPanels":"propsPanels__26Jkc","new":"new__1cIgo","marginLm":"marginLm__20Gg_","marginRm":"marginRm__2YWCn","fullWidth":"fullWidth__3JcTf","fullHeight":"fullHeight__2yaey","noData":"noData__2ZanK","wrapper-form":"wrapper-form__2Ovnt","form-wrapper":"form-wrapper__3NUkt","hb-error":"hb-error__3jDTO","submit":"submit__3mNQQ","regres":"regres__WJaE5","regres-body":"regres-body__1v9Zp","regres-img":"regres-img__3KDdX","regres-footer":"regres-footer__ReGXD","captcha":"captcha__3gtz5"};

/***/ }),
/* 2283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3O89X","wrapper-nopadding":"wrapper-nopadding__3d-M2","loading":"loading__1tlKK","error":"error__TUgET","table-loading":"table-loading__9OctX","empty-val":"empty-val__1Hs89","panelheader-tools":"panelheader-tools__36_OQ","propsPanels":"propsPanels__3Thcs","new":"new__1Yo2-","marginLm":"marginLm__3jWvW","marginRm":"marginRm__3ulh-","fullWidth":"fullWidth__oW5a4","fullHeight":"fullHeight__2eeNK","noData":"noData__14YFV","switch":"switch__2aL56","label":"label__3wlXw","helpDoc":"helpDoc__24QHu","tips":"tips__2M2HP","errorTips":"errorTips__3wdKW"};

/***/ }),
/* 2284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"distanceText":"distanceText__mlG5k"};

/***/ }),
/* 2285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"distanceText":"distanceText__c9TBt","panel":"panel__4LPFw","loading":"loading__1cQ0m","overflowPanel":"overflowPanel__17dA6"};

/***/ }),
/* 2286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1EQFA","wrapper-nopadding":"wrapper-nopadding__apx-4","loading":"loading__2S8fP","error":"error__3SBr0","table-loading":"table-loading__fw8Ey","empty-val":"empty-val__3rrET","panelheader-tools":"panelheader-tools__3wN3A","propsPanels":"propsPanels__3bkZT","new":"new__12Hva","marginLm":"marginLm__W1YWg","marginRm":"marginRm__3JOhZ","fullWidth":"fullWidth__328Wb","fullHeight":"fullHeight__2P7hr","noData":"noData__1iGXM","form":"form__1RwzM","infos":"infos__3ciaK","info":"info__1Ml4N","submit":"submit__1Iso6"};

/***/ }),
/* 2287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1_IO4","wrapper-nopadding":"wrapper-nopadding__czGuQ","loading":"loading__12UGx","error":"error__ZoW66","table-loading":"table-loading__1t7qL","empty-val":"empty-val__1Rl79","panelheader-tools":"panelheader-tools__3lfCt","propsPanels":"propsPanels__18s9_","new":"new__2c4cT","marginLm":"marginLm__2mBjL","marginRm":"marginRm__26ONc","fullWidth":"fullWidth__2adZf","fullHeight":"fullHeight__35vo2","noData":"noData__2DJLQ","basicForm":"basicForm__UEaux","submit":"submit__1Oy3S","addChannel":"addChannel__Ft0zu","submitTips":"submitTips__1zl4V"};

/***/ }),
/* 2288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__25Vlv","wrapper-nopadding":"wrapper-nopadding__1pVAu","loading":"loading__14yh-","error":"error__2RYxS","table-loading":"table-loading__2HDAY","empty-val":"empty-val__3PQNv","panelheader-tools":"panelheader-tools__k_GA3","propsPanels":"propsPanels__kG5HW","new":"new__3nr8A","marginLm":"marginLm__3-3dS","marginRm":"marginRm__2ytX3","fullWidth":"fullWidth__2YMsy","fullHeight":"fullHeight__Nk-cO","noData":"noData__1tkQM","chplan":"chplan__1zOK-","name":"name__jf_QT","edit":"edit__2lRJM","band":"band__hEcIR","channels":"channels__Oxyg1","label":"label__13xUg","value":"value__2Jkm5","createTime":"createTime__2H5HL","content":"content__f7R8r"};

/***/ }),
/* 2289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2_Yi4","wrapper-nopadding":"wrapper-nopadding__3_-Xg","loading":"loading__3Pxll","error":"error__22Kui","table-loading":"table-loading__2N32j","empty-val":"empty-val__3SJXc","panelheader-tools":"panelheader-tools__35Xmk","propsPanels":"propsPanels__13flN","new":"new__37ONC","marginLm":"marginLm__3keJk","marginRm":"marginRm__3AaHd","fullWidth":"fullWidth__e2-3T","fullHeight":"fullHeight__1mITB","noData":"noData__7t9zq","header":"header__6Wc8Z","placeholder":"placeholder__PQmu3","pointer":"pointer__3R_0j","idx":"idx__a6Ztm","full":"full__30Wly","reserved":"reserved__5tMGy"};

/***/ }),
/* 2290 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2tHxy","wrapper-nopadding":"wrapper-nopadding__39VaR","loading":"loading__1eMHL","error":"error__LfRJR","table-loading":"table-loading__2heMq","empty-val":"empty-val__3Ovjm","panelheader-tools":"panelheader-tools__ez79F","propsPanels":"propsPanels__1C4VO","new":"new__1uWwU","marginLm":"marginLm__3jCI6","marginRm":"marginRm__13Vdh","fullWidth":"fullWidth__EQnKq","fullHeight":"fullHeight__uJPyG","noData":"noData__2_Vu_","errorblock":"errorblock__2hj0E"};

/***/ }),
/* 2291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1mGk7","wrapper-nopadding":"wrapper-nopadding__1ILdp","loading":"loading__3r5JB","error":"error__ex-vW","table-loading":"table-loading__3AIL1","empty-val":"empty-val__1m55v","panelheader-tools":"panelheader-tools__PmRsI","propsPanels":"propsPanels__1x0CT","new":"new__1GxsF","marginLm":"marginLm__1KlW3","marginRm":"marginRm__128Ph","fullWidth":"fullWidth__2kagY","fullHeight":"fullHeight__23fEP","noData":"noData__3YaNx","infos":"infos__3P__G","info":"info__2EyZm"};

/***/ }),
/* 2292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2pF-d","wrapper-nopadding":"wrapper-nopadding__1bNq8","loading":"loading__HjTX6","error":"error__1RwtN","table-loading":"table-loading__1gBlx","empty-val":"empty-val__2U6gW","panelheader-tools":"panelheader-tools__2T8sr","propsPanels":"propsPanels__21pOm","new":"new__3cEF1","marginLm":"marginLm__qikGj","marginRm":"marginRm__3EAux","fullWidth":"fullWidth__1MeDW","fullHeight":"fullHeight__2j7jE","noData":"noData__3gk9U","container":"container__33gqK","channels":"channels__33kbt","box":"box__C6lwq","freq":"freq__3VmoC","id":"id__32Wbz","idx":"idx__2-dNc","grow":"grow__13pnn","selected":"selected__3igR1","full":"full__1AKR1","restrict":"restrict__2otML","detail":"detail__3Ynby","label":"label__38Axs","value":"value__3VT8g","notes":"notes__3geMG","legends":"legends__2sAPD","icon":"icon__16MLZ","available":"available__2TzY_","selectedAlt":"selectedAlt__1tbjp","ref":"ref__10st7","caution":"caution__3Il3U"};

/***/ }),
/* 2293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2Usw_","wrapper-nopadding":"wrapper-nopadding__3ZoAX","loading":"loading__1MrGh","error":"error__3sRFt","table-loading":"table-loading__vtKfR","empty-val":"empty-val__1ON4l","panelheader-tools":"panelheader-tools__2XBOE","propsPanels":"propsPanels__aawGm","new":"new__3u_uZ","marginLm":"marginLm__vQE6p","marginRm":"marginRm__1mOQn","fullWidth":"fullWidth__s0asg","fullHeight":"fullHeight__2xO7g","noData":"noData__11X0X","spectrum":"spectrum__3Fcgr","freq":"freq__3OhZd","tooltip":"tooltip__l--MN","label":"label__wMGFx"};

/***/ }),
/* 2294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"chart":"chart__24_yv"};

/***/ }),
/* 2295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__22eYK","chart":"chart__g0EBG"};

/***/ }),
/* 2296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"flag":"flag__2OjYk","select":"select__1QYhN","hidden":"hidden__2PVqG"};

/***/ }),
/* 2297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"select":"select__1ThE0","selectId":"selectId__3QH0J","help":"help__2D1Df"};

/***/ }),
/* 2298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3GWMu","wrapper-nopadding":"wrapper-nopadding__25MRO","loading":"loading__1ISPh","error":"error__2uO2K","table-loading":"table-loading__XBXVc","empty-val":"empty-val__158JV","panelheader-tools":"panelheader-tools__2GmvF","propsPanels":"propsPanels__2VWZn","new":"new__37oPW","marginLm":"marginLm__2TOuf","marginRm":"marginRm__DeR13","fullWidth":"fullWidth__3y3AY","fullHeight":"fullHeight__20hqa","noData":"noData__23RRS","rank":"rank__3X0_2","title":"title__AkrCC","label":"label__3qHwt","list-tt":"list-tt__2CuPl","tt-index":"tt-index__1fiVZ","tt-key":"tt-key__3q23g","tt-value":"tt-value__MfAKo","item-list":"item-list__eI9qd","item-hd":"item-hd__1t61h","item-index":"item-index__35Odn","item-key":"item-key__3UHRW","item-value":"item-value__3maGH"};

/***/ }),
/* 2299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"distanceText":"distanceText__3fUKz","panel":"panel__3BLw3","loading":"loading__2DwOR","overflowPanel":"overflowPanel__JXz6n"};

/***/ }),
/* 2300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"white":"white__eI1OC","label":"label__1rXO-"};

/***/ }),
/* 2301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"red":"red__2AcZr","gray":"gray__1NKjJ","white":"white__X5Vsb","checkbox":"checkbox__1PPZd","modalbody":"modalbody__3WCRr"};

/***/ }),
/* 2302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__26ooN","wrapper-nopadding":"wrapper-nopadding__s1yH8","loading":"loading__3PkC2","error":"error__1xd5S","table-loading":"table-loading__2yuuA","empty-val":"empty-val__4vbZf","panelheader-tools":"panelheader-tools__3Cbot","propsPanels":"propsPanels__Cz-PZ","new":"new__E1H9J","marginLm":"marginLm__2-EdB","marginRm":"marginRm__18ebq","fullWidth":"fullWidth__2esxH","fullHeight":"fullHeight__33yr0","noData":"noData__1Gc1A","font-white":"font-white__3ARX7","input-area":"input-area__vvqB4","row-m":"row-m__8eqyq","tip":"tip__2mQzW","tip-icon":"tip-icon__2e1V_","gray":"gray__2-3VY","line-h":"line-h__2Cf4W"};

/***/ }),
/* 2303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1yREU","wrapper-nopadding":"wrapper-nopadding__23dqo","loading":"loading__38puF","error":"error__2ypLl","table-loading":"table-loading__3aXWw","empty-val":"empty-val__wFXrZ","panelheader-tools":"panelheader-tools__1kJKE","propsPanels":"propsPanels__eRQiw","new":"new__33iDX","marginLm":"marginLm__14WQr","marginRm":"marginRm__3pHjK","fullWidth":"fullWidth__3bsPR","fullHeight":"fullHeight__2Io4P","noData":"noData__16tab","leftTool":"leftTool__3ESR2","add-panel":"add-panel__RHACf","deviceName":"deviceName__26_pP","addDps":"addDps__1Tf6w","refresh":"refresh__2OHyi"};

/***/ }),
/* 2304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__rtysx","wrapper-nopadding":"wrapper-nopadding__1LeKh","loading":"loading__3qEFt","error":"error__2Ke1d","table-loading":"table-loading__i572b","empty-val":"empty-val__3qOaR","panelheader-tools":"panelheader-tools__11r1o","propsPanels":"propsPanels__36dZV","new":"new__Gm7MN","marginLm":"marginLm__1jwkO","marginRm":"marginRm__2OjIh","fullWidth":"fullWidth__SUGyx","fullHeight":"fullHeight__2Fz3U","noData":"noData__3bwCz","timesel":"timesel__TRrg9","datesel":"datesel__1hGTg"};

/***/ }),
/* 2305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__3MhTv"};

/***/ }),
/* 2306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"distanceText":"distanceText__1kqsC"};

/***/ }),
/* 2307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1gjTG","wrapper-nopadding":"wrapper-nopadding__2yKuB","loading":"loading__2atFd","error":"error__2Q2hl","table-loading":"table-loading__13gtI","empty-val":"empty-val__2Vl0M","panelheader-tools":"panelheader-tools__2bu4O","propsPanels":"propsPanels__2nmt1","new":"new__2y5I9","marginLm":"marginLm__1FTO7","marginRm":"marginRm__2B3cu","fullWidth":"fullWidth__3Z7O6","fullHeight":"fullHeight__2Aq2m","noData":"noData__3d5P6","content":"content__1zxxY","filter":"filter__FTbhS","chart":"chart__30j-G","statisTable":"statisTable__GFpOu","active":"active__JxDqU","noactive":"noactive__2Rnrb","tab":"tab__2iDMY","nodata":"nodata__-Z0rH"};

/***/ }),
/* 2308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"panel":"panel__3kGoS"};

/***/ }),
/* 2309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__9qQar","wrapper-nopadding":"wrapper-nopadding__2XOfw","loading":"loading__2Fgka","error":"error__1vn9-","table-loading":"table-loading__38Dci","empty-val":"empty-val__TsESo","panelheader-tools":"panelheader-tools__jn3oN","propsPanels":"propsPanels__f-oYv","new":"new__2GRh7","marginLm":"marginLm__11JOf","marginRm":"marginRm__1PL-S","fullWidth":"fullWidth__352hc","fullHeight":"fullHeight__PMaho","noData":"noData__PYDKs","view":"view__24o8X"};

/***/ }),
/* 2310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1G_S7","wrapper-nopadding":"wrapper-nopadding__3fl5d","loading":"loading__11S9M","error":"error__36GW8","table-loading":"table-loading__1gwSF","empty-val":"empty-val__2zQWL","panelheader-tools":"panelheader-tools__19KSO","propsPanels":"propsPanels__1-zkI","new":"new__usJrg","marginLm":"marginLm__2DyYc","marginRm":"marginRm__3GZYZ","fullWidth":"fullWidth__3geOO","fullHeight":"fullHeight__3CIfZ","noData":"noData__1xw1s","avatar":"avatar__xp7nU"};

/***/ }),
/* 2311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2aY-f","wrapper-nopadding":"wrapper-nopadding__1GFYR","loading":"loading__28cc-","error":"error__1W2Hr","table-loading":"table-loading__1_M8f","empty-val":"empty-val__1Kl74","panelheader-tools":"panelheader-tools__Lo6z_","propsPanels":"propsPanels__1taPl","new":"new__2VTwp","marginLm":"marginLm__2nlZQ","marginRm":"marginRm__2YnnC","fullWidth":"fullWidth__Ejjm3","fullHeight":"fullHeight__oCCy-","noData":"noData__1p85k","card":"card__2FyII","basic":"basic__2SRmY","balance":"balance__G4aaj","value":"value__1eyqy","debt":"debt__1vF5v","tier":"tier__1K33z","billday":"billday__o6cPb","promote":"promote__2iJyv","greeting":"greeting__WdL5r","arrear":"arrear__sZHtY"};

/***/ }),
/* 2312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__gvj0f","wrapper-nopadding":"wrapper-nopadding__14jaZ","loading":"loading__2KIb8","error":"error__3H8g2","table-loading":"table-loading__3Fwur","empty-val":"empty-val__2OLt2","panelheader-tools":"panelheader-tools__1BWSb","propsPanels":"propsPanels__3TTky","new":"new__1FSb-","marginLm":"marginLm__1jhJo","marginRm":"marginRm__3X_Vr","fullWidth":"fullWidth__1gI-j","fullHeight":"fullHeight__22sQ6","noData":"noData__1nUwn","card":"card__2CtAo","bordered":"bordered__u-kEG"};

/***/ }),
/* 2313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"map":"map__1ffJu"};

/***/ }),
/* 2314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"map":"map__oDQEc"};

/***/ }),
/* 2315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3YV1V","wrapper-nopadding":"wrapper-nopadding__1xYp6","loading":"loading__1YSBY","error":"error__1IxkR","table-loading":"table-loading__3dU33","empty-val":"empty-val__HPCAb","panelheader-tools":"panelheader-tools__1HvdU","propsPanels":"propsPanels__3jQZF","new":"new__1XLL7","marginLm":"marginLm__37nkv","marginRm":"marginRm__uuH8r","fullWidth":"fullWidth__3B7dx","fullHeight":"fullHeight__1YpZo","noData":"noData__2rVQf","overlay":"overlay__2LMCi","overlayAppear":"overlayAppear__3S0Es","overlayEnter":"overlayEnter__3eFBj","overlayAppearActive":"overlayAppearActive__2uzRQ","overlayEnterActive":"overlayEnterActive__2ZPm1","overlayLeave":"overlayLeave__2fUI7","overlayLeaveActive":"overlayLeaveActive__1Zo40","closeButton":"closeButton__1JTT8","content":"content__Xt7FH","search":"search__1d370","result":"result__18qOa","item":"item__2d9mB","major":"major__asoOp","sub":"sub__1F8sQ","app":"app__1uWIN","gateway":"gateway__RVoTb","device":"device__1syd2"};

/***/ }),
/* 2316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__cBP6W","wrapper-nopadding":"wrapper-nopadding__1NaxC","loading":"loading__1xYF1","error":"error__16rrT","table-loading":"table-loading__i1tNz","empty-val":"empty-val__3YArU","panelheader-tools":"panelheader-tools__2kcnK","propsPanels":"propsPanels__2UE-s","new":"new___pcRq","marginLm":"marginLm__2eBLx","marginRm":"marginRm__3mX_5","fullWidth":"fullWidth___G2e8","fullHeight":"fullHeight__2oYqc","noData":"noData__ifO6c","toolbar":"toolbar__3sF09","greeting":"greeting__3EqKj","bordered":"bordered__2zn7m"};

/***/ }),
/* 2317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1UwCE","wrapper-nopadding":"wrapper-nopadding__2h-B_","loading":"loading__1r-QD","error":"error__2nehk","table-loading":"table-loading__3vp7y","empty-val":"empty-val__2KcxI","panelheader-tools":"panelheader-tools__2b7Uc","propsPanels":"propsPanels__gaCt0","new":"new__pG-OR","marginLm":"marginLm__3NYi-","marginRm":"marginRm__2j_cl","fullWidth":"fullWidth__rS05t","fullHeight":"fullHeight__1_vcs","noData":"noData__tucLf","captcha":"captcha__2sd2Z"};

/***/ }),
/* 2318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"psm":"psm__1-o4w","psm-block":"psm-block__385uJ","psm-weak":"psm-weak__3cV9v","active":"active__srriq","psm-medium":"psm-medium__2lcSb","psm-strong":"psm-strong__2UpTX"};

/***/ }),
/* 2319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2IhKX","wrapper-nopadding":"wrapper-nopadding__38z7s","loading":"loading__zsBv0","error":"error__n9hzj","table-loading":"table-loading__NakM8","empty-val":"empty-val__1TSoq","panelheader-tools":"panelheader-tools__3Erbc","propsPanels":"propsPanels__1Of2P","new":"new__3rfpS","marginLm":"marginLm__XtPJI","marginRm":"marginRm__1v9gi","fullWidth":"fullWidth__1Af1a","fullHeight":"fullHeight__1tujW","noData":"noData__2WUkb","result":"result__3e-mr","body":"body__3hubW","img":"img__2J2LY","footer":"footer__PQdf-"};

/***/ }),
/* 2320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"register":"register__19Mgx","form":"form__3NOj5","agree":"agree__IeSSn","submit":"submit__2mnyp","emailCheck":"emailCheck__17rgr"};

/***/ }),
/* 2321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__24-aj","regres":"regres__1T3uw","regres-body":"regres-body__3MsMV","regres-img":"regres-img__jve7x"};

/***/ }),
/* 2322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3WwGm","wrapper-form":"wrapper-form__2hoWf","form-wrapper":"form-wrapper__32cCc","errortips-wrapper":"errortips-wrapper__37Od1","errortips":"errortips__35ITP","submit":"submit__N3_Hi"};

/***/ }),
/* 2323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"radio":"radio__11md7"};

/***/ }),
/* 2324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;;(function () {
	'use strict';

	/**
	 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
	 *
	 * @codingstandard ftlabs-jsv2
	 * @copyright The Financial Times Limited [All Rights Reserved]
	 * @license MIT License (see LICENSE.txt)
	 */

	/*jslint browser:true, node:true*/
	/*global define, Event, Node*/


	/**
	 * Instantiate fast-clicking listeners on the specified layer.
	 *
	 * @constructor
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	function FastClick(layer, options) {
		var oldOnClick;

		options = options || {};

		/**
		 * Whether a click is currently being tracked.
		 *
		 * @type boolean
		 */
		this.trackingClick = false;


		/**
		 * Timestamp for when click tracking started.
		 *
		 * @type number
		 */
		this.trackingClickStart = 0;


		/**
		 * The element being tracked for a click.
		 *
		 * @type EventTarget
		 */
		this.targetElement = null;


		/**
		 * X-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartX = 0;


		/**
		 * Y-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartY = 0;


		/**
		 * ID of the last touch, retrieved from Touch.identifier.
		 *
		 * @type number
		 */
		this.lastTouchIdentifier = 0;


		/**
		 * Touchmove boundary, beyond which a click will be cancelled.
		 *
		 * @type number
		 */
		this.touchBoundary = options.touchBoundary || 10;


		/**
		 * The FastClick layer.
		 *
		 * @type Element
		 */
		this.layer = layer;

		/**
		 * The minimum time between tap(touchstart and touchend) events
		 *
		 * @type number
		 */
		this.tapDelay = options.tapDelay || 200;

		/**
		 * The maximum time for a tap
		 *
		 * @type number
		 */
		this.tapTimeout = options.tapTimeout || 700;

		if (FastClick.notNeeded(layer)) {
			return;
		}

		// Some old versions of Android don't have Function.prototype.bind
		function bind(method, context) {
			return function() { return method.apply(context, arguments); };
		}


		var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
		var context = this;
		for (var i = 0, l = methods.length; i < l; i++) {
			context[methods[i]] = bind(context[methods[i]], context);
		}

		// Set up event handlers as required
		if (deviceIsAndroid) {
			layer.addEventListener('mouseover', this.onMouse, true);
			layer.addEventListener('mousedown', this.onMouse, true);
			layer.addEventListener('mouseup', this.onMouse, true);
		}

		layer.addEventListener('click', this.onClick, true);
		layer.addEventListener('touchstart', this.onTouchStart, false);
		layer.addEventListener('touchmove', this.onTouchMove, false);
		layer.addEventListener('touchend', this.onTouchEnd, false);
		layer.addEventListener('touchcancel', this.onTouchCancel, false);

		// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
		// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
		// layer when they are cancelled.
		if (!Event.prototype.stopImmediatePropagation) {
			layer.removeEventListener = function(type, callback, capture) {
				var rmv = Node.prototype.removeEventListener;
				if (type === 'click') {
					rmv.call(layer, type, callback.hijacked || callback, capture);
				} else {
					rmv.call(layer, type, callback, capture);
				}
			};

			layer.addEventListener = function(type, callback, capture) {
				var adv = Node.prototype.addEventListener;
				if (type === 'click') {
					adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
						if (!event.propagationStopped) {
							callback(event);
						}
					}), capture);
				} else {
					adv.call(layer, type, callback, capture);
				}
			};
		}

		// If a handler is already declared in the element's onclick attribute, it will be fired before
		// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
		// adding it as listener.
		if (typeof layer.onclick === 'function') {

			// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
			// - the old one won't work if passed to addEventListener directly.
			oldOnClick = layer.onclick;
			layer.addEventListener('click', function(event) {
				oldOnClick(event);
			}, false);
			layer.onclick = null;
		}
	}

	/**
	* Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
	*
	* @type boolean
	*/
	var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;

	/**
	 * Android requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;


	/**
	 * iOS requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;


	/**
	 * iOS 4 requires an exception for select elements.
	 *
	 * @type boolean
	 */
	var deviceIsIOS4 = deviceIsIOS && (/OS 4_\d(_\d)?/).test(navigator.userAgent);


	/**
	 * iOS 6.0-7.* requires the target element to be manually derived
	 *
	 * @type boolean
	 */
	var deviceIsIOSWithBadTarget = deviceIsIOS && (/OS [6-7]_\d/).test(navigator.userAgent);

	/**
	 * BlackBerry requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;

	/**
	 * Determine whether a given element requires a native click.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element needs a native click
	 */
	FastClick.prototype.needsClick = function(target) {
		switch (target.nodeName.toLowerCase()) {

		// Don't send a synthetic click to disabled inputs (issue #62)
		case 'button':
		case 'select':
		case 'textarea':
			if (target.disabled) {
				return true;
			}

			break;
		case 'input':

			// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
			if ((deviceIsIOS && target.type === 'file') || target.disabled) {
				return true;
			}

			break;
		case 'label':
		case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
		case 'video':
			return true;
		}

		return (/\bneedsclick\b/).test(target.className);
	};


	/**
	 * Determine whether a given element requires a call to focus to simulate click into element.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
	 */
	FastClick.prototype.needsFocus = function(target) {
		switch (target.nodeName.toLowerCase()) {
		case 'textarea':
			return true;
		case 'select':
			return !deviceIsAndroid;
		case 'input':
			switch (target.type) {
			case 'button':
			case 'checkbox':
			case 'file':
			case 'image':
			case 'radio':
			case 'submit':
				return false;
			}

			// No point in attempting to focus disabled inputs
			return !target.disabled && !target.readOnly;
		default:
			return (/\bneedsfocus\b/).test(target.className);
		}
	};


	/**
	 * Send a click event to the specified element.
	 *
	 * @param {EventTarget|Element} targetElement
	 * @param {Event} event
	 */
	FastClick.prototype.sendClick = function(targetElement, event) {
		var clickEvent, touch;

		// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
		if (document.activeElement && document.activeElement !== targetElement) {
			document.activeElement.blur();
		}

		touch = event.changedTouches[0];

		// Synthesise a click event, with an extra attribute so it can be tracked
		clickEvent = document.createEvent('MouseEvents');
		clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
		clickEvent.forwardedTouchEvent = true;
		targetElement.dispatchEvent(clickEvent);
	};

	FastClick.prototype.determineEventType = function(targetElement) {

		//Issue #159: Android Chrome Select Box does not open with a synthetic click event
		if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
			return 'mousedown';
		}

		return 'click';
	};


	/**
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.focus = function(targetElement) {
		var length;

		// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
		if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
			length = targetElement.value.length;
			targetElement.setSelectionRange(length, length);
		} else {
			targetElement.focus();
		}
	};


	/**
	 * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
	 *
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.updateScrollParent = function(targetElement) {
		var scrollParent, parentElement;

		scrollParent = targetElement.fastClickScrollParent;

		// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
		// target element was moved to another parent.
		if (!scrollParent || !scrollParent.contains(targetElement)) {
			parentElement = targetElement;
			do {
				if (parentElement.scrollHeight > parentElement.offsetHeight) {
					scrollParent = parentElement;
					targetElement.fastClickScrollParent = parentElement;
					break;
				}

				parentElement = parentElement.parentElement;
			} while (parentElement);
		}

		// Always update the scroll top tracker if possible.
		if (scrollParent) {
			scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
		}
	};


	/**
	 * @param {EventTarget} targetElement
	 * @returns {Element|EventTarget}
	 */
	FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {

		// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
		if (eventTarget.nodeType === Node.TEXT_NODE) {
			return eventTarget.parentNode;
		}

		return eventTarget;
	};


	/**
	 * On touch start, record the position and scroll offset.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchStart = function(event) {
		var targetElement, touch, selection;

		// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
		if (event.targetTouches.length > 1) {
			return true;
		}

		targetElement = this.getTargetElementFromEventTarget(event.target);
		touch = event.targetTouches[0];

		if (deviceIsIOS) {

			// Only trusted events will deselect text on iOS (issue #49)
			selection = window.getSelection();
			if (selection.rangeCount && !selection.isCollapsed) {
				return true;
			}

			if (!deviceIsIOS4) {

				// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
				// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
				// with the same identifier as the touch event that previously triggered the click that triggered the alert.
				// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
				// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
				// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
				// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
				// random integers, it's safe to to continue if the identifier is 0 here.
				if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
					event.preventDefault();
					return false;
				}

				this.lastTouchIdentifier = touch.identifier;

				// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
				// 1) the user does a fling scroll on the scrollable layer
				// 2) the user stops the fling scroll with another tap
				// then the event.target of the last 'touchend' event will be the element that was under the user's finger
				// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
				// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
				this.updateScrollParent(targetElement);
			}
		}

		this.trackingClick = true;
		this.trackingClickStart = event.timeStamp;
		this.targetElement = targetElement;

		this.touchStartX = touch.pageX;
		this.touchStartY = touch.pageY;

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			event.preventDefault();
		}

		return true;
	};


	/**
	 * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.touchHasMoved = function(event) {
		var touch = event.changedTouches[0], boundary = this.touchBoundary;

		if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
			return true;
		}

		return false;
	};


	/**
	 * Update the last position.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchMove = function(event) {
		if (!this.trackingClick) {
			return true;
		}

		// If the touch has moved, cancel the click tracking
		if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
			this.trackingClick = false;
			this.targetElement = null;
		}

		return true;
	};


	/**
	 * Attempt to find the labelled control for the given label element.
	 *
	 * @param {EventTarget|HTMLLabelElement} labelElement
	 * @returns {Element|null}
	 */
	FastClick.prototype.findControl = function(labelElement) {

		// Fast path for newer browsers supporting the HTML5 control attribute
		if (labelElement.control !== undefined) {
			return labelElement.control;
		}

		// All browsers under test that support touch events also support the HTML5 htmlFor attribute
		if (labelElement.htmlFor) {
			return document.getElementById(labelElement.htmlFor);
		}

		// If no for attribute exists, attempt to retrieve the first labellable descendant element
		// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
		return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
	};


	/**
	 * On touch end, determine whether to send a click event at once.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchEnd = function(event) {
		var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;

		if (!this.trackingClick) {
			return true;
		}

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			this.cancelNextClick = true;
			return true;
		}

		if ((event.timeStamp - this.trackingClickStart) > this.tapTimeout) {
			return true;
		}

		// Reset to prevent wrong click cancel on input (issue #156).
		this.cancelNextClick = false;

		this.lastClickTime = event.timeStamp;

		trackingClickStart = this.trackingClickStart;
		this.trackingClick = false;
		this.trackingClickStart = 0;

		// On some iOS devices, the targetElement supplied with the event is invalid if the layer
		// is performing a transition or scroll, and has to be re-detected manually. Note that
		// for this to function correctly, it must be called *after* the event target is checked!
		// See issue #57; also filed as rdar://13048589 .
		if (deviceIsIOSWithBadTarget) {
			touch = event.changedTouches[0];

			// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
			targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
			targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
		}

		targetTagName = targetElement.tagName.toLowerCase();
		if (targetTagName === 'label') {
			forElement = this.findControl(targetElement);
			if (forElement) {
				this.focus(targetElement);
				if (deviceIsAndroid) {
					return false;
				}

				targetElement = forElement;
			}
		} else if (this.needsFocus(targetElement)) {

			// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
			// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
			if ((event.timeStamp - trackingClickStart) > 100 || (deviceIsIOS && window.top !== window && targetTagName === 'input')) {
				this.targetElement = null;
				return false;
			}

			this.focus(targetElement);
			this.sendClick(targetElement, event);

			// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
			// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
			if (!deviceIsIOS || targetTagName !== 'select') {
				this.targetElement = null;
				event.preventDefault();
			}

			return false;
		}

		if (deviceIsIOS && !deviceIsIOS4) {

			// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
			// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
			scrollParent = targetElement.fastClickScrollParent;
			if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
				return true;
			}
		}

		// Prevent the actual click from going though - unless the target node is marked as requiring
		// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
		if (!this.needsClick(targetElement)) {
			event.preventDefault();
			this.sendClick(targetElement, event);
		}

		return false;
	};


	/**
	 * On touch cancel, stop tracking the click.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.onTouchCancel = function() {
		this.trackingClick = false;
		this.targetElement = null;
	};


	/**
	 * Determine mouse events which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onMouse = function(event) {

		// If a target element was never set (because a touch event was never fired) allow the event
		if (!this.targetElement) {
			return true;
		}

		if (event.forwardedTouchEvent) {
			return true;
		}

		// Programmatically generated events targeting a specific element should be permitted
		if (!event.cancelable) {
			return true;
		}

		// Derive and check the target element to see whether the mouse event needs to be permitted;
		// unless explicitly enabled, prevent non-touch click events from triggering actions,
		// to prevent ghost/doubleclicks.
		if (!this.needsClick(this.targetElement) || this.cancelNextClick) {

			// Prevent any user-added listeners declared on FastClick element from being fired.
			if (event.stopImmediatePropagation) {
				event.stopImmediatePropagation();
			} else {

				// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
				event.propagationStopped = true;
			}

			// Cancel the event
			event.stopPropagation();
			event.preventDefault();

			return false;
		}

		// If the mouse event is permitted, return true for the action to go through.
		return true;
	};


	/**
	 * On actual clicks, determine whether this is a touch-generated click, a click action occurring
	 * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
	 * an actual click which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onClick = function(event) {
		var permitted;

		// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
		if (this.trackingClick) {
			this.targetElement = null;
			this.trackingClick = false;
			return true;
		}

		// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
		if (event.target.type === 'submit' && event.detail === 0) {
			return true;
		}

		permitted = this.onMouse(event);

		// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
		if (!permitted) {
			this.targetElement = null;
		}

		// If clicks are permitted, return true for the action to go through.
		return permitted;
	};


	/**
	 * Remove all FastClick's event listeners.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.destroy = function() {
		var layer = this.layer;

		if (deviceIsAndroid) {
			layer.removeEventListener('mouseover', this.onMouse, true);
			layer.removeEventListener('mousedown', this.onMouse, true);
			layer.removeEventListener('mouseup', this.onMouse, true);
		}

		layer.removeEventListener('click', this.onClick, true);
		layer.removeEventListener('touchstart', this.onTouchStart, false);
		layer.removeEventListener('touchmove', this.onTouchMove, false);
		layer.removeEventListener('touchend', this.onTouchEnd, false);
		layer.removeEventListener('touchcancel', this.onTouchCancel, false);
	};


	/**
	 * Check whether FastClick is needed.
	 *
	 * @param {Element} layer The layer to listen on
	 */
	FastClick.notNeeded = function(layer) {
		var metaViewport;
		var chromeVersion;
		var blackberryVersion;
		var firefoxVersion;

		// Devices that don't support touch don't need FastClick
		if (typeof window.ontouchstart === 'undefined') {
			return true;
		}

		// Chrome version - zero for other browsers
		chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (chromeVersion) {

			if (deviceIsAndroid) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// Chrome 32 and above with width=device-width or less don't need FastClick
					if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}

			// Chrome desktop doesn't need FastClick (issue #15)
			} else {
				return true;
			}
		}

		if (deviceIsBlackBerry10) {
			blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);

			// BlackBerry 10.3+ does not require Fastclick library.
			// https://github.com/ftlabs/fastclick/issues/251
			if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// user-scalable=no eliminates click delay.
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// width=device-width (or less than device-width) eliminates click delay.
					if (document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}
			}
		}

		// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
		if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		// Firefox version - zero for other browsers
		firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (firefoxVersion >= 27) {
			// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896

			metaViewport = document.querySelector('meta[name=viewport]');
			if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
				return true;
			}
		}

		// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
		// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
		if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		return false;
	};


	/**
	 * Factory method for creating a FastClick object
	 *
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	FastClick.attach = function(layer, options) {
		return new FastClick(layer, options);
	};


	if (true) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return FastClick;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = FastClick.attach;
		module.exports.FastClick = FastClick;
	} else {
		window.FastClick = FastClick;
	}
}());


/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var PhotosMimeType = {
  isImage: function isImage(mimeString) {
    return getParts(mimeString)[0] === 'image';
  },
  isJpeg: function isJpeg(mimeString) {
    var parts = getParts(mimeString);
    return PhotosMimeType.isImage(mimeString) && (
    // see http://fburl.com/10972194
    parts[1] === 'jpeg' || parts[1] === 'pjpeg');
  }
};

function getParts(mimeString) {
  return mimeString.split('/');
}

module.exports = PhotosMimeType;

/***/ }),
/* 2328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * @stub
 * 
 */



// \u00a1-\u00b1\u00b4-\u00b8\u00ba\u00bb\u00bf
//             is latin supplement punctuation except fractions and superscript
//             numbers
// \u2010-\u2027\u2030-\u205e
//             is punctuation from the general punctuation block:
//             weird quotes, commas, bullets, dashes, etc.
// \u30fb\u3001\u3002\u3008-\u3011\u3014-\u301f
//             is CJK punctuation
// \uff1a-\uff1f\uff01-\uff0f\uff3b-\uff40\uff5b-\uff65
//             is some full-width/half-width punctuation
// \u2E2E\u061f\u066a-\u066c\u061b\u060c\u060d\uFD3e\uFD3F
//             is some Arabic punctuation marks
// \u1801\u0964\u104a\u104b
//             is misc. other language punctuation marks

var PUNCTUATION = '[.,+*?$|#{}()\'\\^\\-\\[\\]\\\\\\/!@%"~=<>_:;' + '\u30FB\u3001\u3002\u3008-\u3011\u3014-\u301F\uFF1A-\uFF1F\uFF01-\uFF0F' + '\uFF3B-\uFF40\uFF5B-\uFF65\u2E2E\u061F\u066A-\u066C\u061B\u060C\u060D' + '\uFD3E\uFD3F\u1801\u0964\u104A\u104B\u2010-\u2027\u2030-\u205E' + '\xA1-\xB1\xB4-\xB8\xBA\xBB\xBF]';

module.exports = {
  getPunctuation: function getPunctuation() {
    return PUNCTUATION;
  }
};

/***/ }),
/* 2329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var URI = function () {
  function URI(uri) {
    _classCallCheck(this, URI);

    this._uri = uri;
  }

  URI.prototype.toString = function toString() {
    return this._uri;
  };

  return URI;
}();

module.exports = URI;

/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Stateful API for text direction detection
 *
 * This class can be used in applications where you need to detect the
 * direction of a sequence of text blocks, where each direction shall be used
 * as the fallback direction for the next one.
 *
 * NOTE: A default direction, if not provided, is set based on the global
 *       direction, as defined by `UnicodeBidiDirection`.
 *
 * == Example ==
 * ```
 * var UnicodeBidiService = require('UnicodeBidiService');
 *
 * var bidiService = new UnicodeBidiService();
 *
 * ...
 *
 * bidiService.reset();
 * for (var para in paragraphs) {
 *   var dir = bidiService.getDirection(para);
 *   ...
 * }
 * ```
 *
 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UnicodeBidi = __webpack_require__(837);
var UnicodeBidiDirection = __webpack_require__(534);

var invariant = __webpack_require__(23);

var UnicodeBidiService = function () {

  /**
   * Stateful class for paragraph direction detection
   *
   * @param defaultDir  Default direction of the service
   */
  function UnicodeBidiService(defaultDir) {
    _classCallCheck(this, UnicodeBidiService);

    if (!defaultDir) {
      defaultDir = UnicodeBidiDirection.getGlobalDir();
    } else {
      !UnicodeBidiDirection.isStrong(defaultDir) ?  false ? invariant(false, 'Default direction must be a strong direction (LTR or RTL)') : invariant(false) : void 0;
    }
    this._defaultDir = defaultDir;
    this.reset();
  }

  /**
   * Reset the internal state
   *
   * Instead of creating a new instance, you can just reset() your instance
   * everytime you start a new loop.
   */


  UnicodeBidiService.prototype.reset = function reset() {
    this._lastDir = this._defaultDir;
  };

  /**
   * Returns the direction of a block of text, and remembers it as the
   * fall-back direction for the next paragraph.
   *
   * @param str  A text block, e.g. paragraph, table cell, tag
   * @return     The resolved direction
   */


  UnicodeBidiService.prototype.getDirection = function getDirection(str) {
    this._lastDir = UnicodeBidi.getDirection(str, this._lastDir);
    return this._lastDir;
  };

  return UnicodeBidiService;
}();

module.exports = UnicodeBidiService;

/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Usage note:
 * This module makes a best effort to export the same data we would internally.
 * At Facebook we use a server-generated module that does the parsing and
 * exports the data for the client to use. We can't rely on a server-side
 * implementation in open source so instead we make use of an open source
 * library to do the heavy lifting and then make some adjustments as necessary.
 * It's likely there will be some differences. Some we can smooth over.
 * Others are going to be harder.
 */



var UAParser = __webpack_require__(2755);

var UNKNOWN = 'Unknown';

var PLATFORM_MAP = {
  'Mac OS': 'Mac OS X'
};

/**
 * Convert from UAParser platform name to what we expect.
 */
function convertPlatformName(name) {
  return PLATFORM_MAP[name] || name;
}

/**
 * Get the version number in parts. This is very naive. We actually get major
 * version as a part of UAParser already, which is generally good enough, but
 * let's get the minor just in case.
 */
function getBrowserVersion(version) {
  if (!version) {
    return {
      major: '',
      minor: ''
    };
  }
  var parts = version.split('.');
  return {
    major: parts[0],
    minor: parts[1]
  };
}

/**
 * Get the UA data fom UAParser and then convert it to the format we're
 * expecting for our APIS.
 */
var parser = new UAParser();
var results = parser.getResult();

// Do some conversion first.
var browserVersionData = getBrowserVersion(results.browser.version);
var uaData = {
  browserArchitecture: results.cpu.architecture || UNKNOWN,
  browserFullVersion: results.browser.version || UNKNOWN,
  browserMinorVersion: browserVersionData.minor || UNKNOWN,
  browserName: results.browser.name || UNKNOWN,
  browserVersion: results.browser.major || UNKNOWN,
  deviceName: results.device.model || UNKNOWN,
  engineName: results.engine.name || UNKNOWN,
  engineVersion: results.engine.version || UNKNOWN,
  platformArchitecture: results.cpu.architecture || UNKNOWN,
  platformName: convertPlatformName(results.os.name) || UNKNOWN,
  platformVersion: results.os.version || UNKNOWN,
  platformFullVersion: results.os.version || UNKNOWN
};

module.exports = uaData;

/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var invariant = __webpack_require__(23);

var componentRegex = /\./;
var orRegex = /\|\|/;
var rangeRegex = /\s+\-\s+/;
var modifierRegex = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/;
var numericRegex = /^(\d*)(.*)/;

/**
 * Splits input `range` on "||" and returns true if any subrange matches
 * `version`.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */
function checkOrExpression(range, version) {
  var expressions = range.split(orRegex);

  if (expressions.length > 1) {
    return expressions.some(function (range) {
      return VersionRange.contains(range, version);
    });
  } else {
    range = expressions[0].trim();
    return checkRangeExpression(range, version);
  }
}

/**
 * Splits input `range` on " - " (the surrounding whitespace is required) and
 * returns true if version falls between the two operands.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */
function checkRangeExpression(range, version) {
  var expressions = range.split(rangeRegex);

  !(expressions.length > 0 && expressions.length <= 2) ?  false ? invariant(false, 'the "-" operator expects exactly 2 operands') : invariant(false) : void 0;

  if (expressions.length === 1) {
    return checkSimpleExpression(expressions[0], version);
  } else {
    var startVersion = expressions[0],
        endVersion = expressions[1];

    !(isSimpleVersion(startVersion) && isSimpleVersion(endVersion)) ?  false ? invariant(false, 'operands to the "-" operator must be simple (no modifiers)') : invariant(false) : void 0;

    return checkSimpleExpression('>=' + startVersion, version) && checkSimpleExpression('<=' + endVersion, version);
  }
}

/**
 * Checks if `range` matches `version`. `range` should be a "simple" range (ie.
 * not a compound range using the " - " or "||" operators).
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */
function checkSimpleExpression(range, version) {
  range = range.trim();
  if (range === '') {
    return true;
  }

  var versionComponents = version.split(componentRegex);

  var _getModifierAndCompon = getModifierAndComponents(range),
      modifier = _getModifierAndCompon.modifier,
      rangeComponents = _getModifierAndCompon.rangeComponents;

  switch (modifier) {
    case '<':
      return checkLessThan(versionComponents, rangeComponents);
    case '<=':
      return checkLessThanOrEqual(versionComponents, rangeComponents);
    case '>=':
      return checkGreaterThanOrEqual(versionComponents, rangeComponents);
    case '>':
      return checkGreaterThan(versionComponents, rangeComponents);
    case '~':
    case '~>':
      return checkApproximateVersion(versionComponents, rangeComponents);
    default:
      return checkEqual(versionComponents, rangeComponents);
  }
}

/**
 * Checks whether `a` is less than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkLessThan(a, b) {
  return compareComponents(a, b) === -1;
}

/**
 * Checks whether `a` is less than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkLessThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === -1 || result === 0;
}

/**
 * Checks whether `a` is equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkEqual(a, b) {
  return compareComponents(a, b) === 0;
}

/**
 * Checks whether `a` is greater than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkGreaterThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === 1 || result === 0;
}

/**
 * Checks whether `a` is greater than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkGreaterThan(a, b) {
  return compareComponents(a, b) === 1;
}

/**
 * Checks whether `a` is "reasonably close" to `b` (as described in
 * https://www.npmjs.org/doc/misc/semver.html). For example, if `b` is "1.3.1"
 * then "reasonably close" is defined as ">= 1.3.1 and < 1.4".
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkApproximateVersion(a, b) {
  var lowerBound = b.slice();
  var upperBound = b.slice();

  if (upperBound.length > 1) {
    upperBound.pop();
  }
  var lastIndex = upperBound.length - 1;
  var numeric = parseInt(upperBound[lastIndex], 10);
  if (isNumber(numeric)) {
    upperBound[lastIndex] = numeric + 1 + '';
  }

  return checkGreaterThanOrEqual(a, lowerBound) && checkLessThan(a, upperBound);
}

/**
 * Extracts the optional modifier (<, <=, =, >=, >, ~, ~>) and version
 * components from `range`.
 *
 * For example, given `range` ">= 1.2.3" returns an object with a `modifier` of
 * `">="` and `components` of `[1, 2, 3]`.
 *
 * @param {string} range
 * @returns {object}
 */
function getModifierAndComponents(range) {
  var rangeComponents = range.split(componentRegex);
  var matches = rangeComponents[0].match(modifierRegex);
  !matches ?  false ? invariant(false, 'expected regex to match but it did not') : invariant(false) : void 0;

  return {
    modifier: matches[1],
    rangeComponents: [matches[2]].concat(rangeComponents.slice(1))
  };
}

/**
 * Determines if `number` is a number.
 *
 * @param {mixed} number
 * @returns {boolean}
 */
function isNumber(number) {
  return !isNaN(number) && isFinite(number);
}

/**
 * Tests whether `range` is a "simple" version number without any modifiers
 * (">", "~" etc).
 *
 * @param {string} range
 * @returns {boolean}
 */
function isSimpleVersion(range) {
  return !getModifierAndComponents(range).modifier;
}

/**
 * Zero-pads array `array` until it is at least `length` long.
 *
 * @param {array} array
 * @param {number} length
 */
function zeroPad(array, length) {
  for (var i = array.length; i < length; i++) {
    array[i] = '0';
  }
}

/**
 * Normalizes `a` and `b` in preparation for comparison by doing the following:
 *
 * - zero-pads `a` and `b`
 * - marks any "x", "X" or "*" component in `b` as equivalent by zero-ing it out
 *   in both `a` and `b`
 * - marks any final "*" component in `b` as a greedy wildcard by zero-ing it
 *   and all of its successors in `a`
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {array<array<string>>}
 */
function normalizeVersions(a, b) {
  a = a.slice();
  b = b.slice();

  zeroPad(a, b.length);

  // mark "x" and "*" components as equal
  for (var i = 0; i < b.length; i++) {
    var matches = b[i].match(/^[x*]$/i);
    if (matches) {
      b[i] = a[i] = '0';

      // final "*" greedily zeros all remaining components
      if (matches[0] === '*' && i === b.length - 1) {
        for (var j = i; j < a.length; j++) {
          a[j] = '0';
        }
      }
    }
  }

  zeroPad(b, a.length);

  return [a, b];
}

/**
 * Returns the numerical -- not the lexicographical -- ordering of `a` and `b`.
 *
 * For example, `10-alpha` is greater than `2-beta`.
 *
 * @param {string} a
 * @param {string} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */
function compareNumeric(a, b) {
  var aPrefix = a.match(numericRegex)[1];
  var bPrefix = b.match(numericRegex)[1];
  var aNumeric = parseInt(aPrefix, 10);
  var bNumeric = parseInt(bPrefix, 10);

  if (isNumber(aNumeric) && isNumber(bNumeric) && aNumeric !== bNumeric) {
    return compare(aNumeric, bNumeric);
  } else {
    return compare(a, b);
  }
}

/**
 * Returns the ordering of `a` and `b`.
 *
 * @param {string|number} a
 * @param {string|number} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */
function compare(a, b) {
  !(typeof a === typeof b) ?  false ? invariant(false, '"a" and "b" must be of the same type') : invariant(false) : void 0;

  if (a > b) {
    return 1;
  } else if (a < b) {
    return -1;
  } else {
    return 0;
  }
}

/**
 * Compares arrays of version components.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */
function compareComponents(a, b) {
  var _normalizeVersions = normalizeVersions(a, b),
      aNormalized = _normalizeVersions[0],
      bNormalized = _normalizeVersions[1];

  for (var i = 0; i < bNormalized.length; i++) {
    var result = compareNumeric(aNormalized[i], bNormalized[i]);
    if (result) {
      return result;
    }
  }

  return 0;
}

var VersionRange = {
  /**
   * Checks whether `version` satisfies the `range` specification.
   *
   * We support a subset of the expressions defined in
   * https://www.npmjs.org/doc/misc/semver.html:
   *
   *    version   Must match version exactly
   *    =version  Same as just version
   *    >version  Must be greater than version
   *    >=version Must be greater than or equal to version
   *    <version  Must be less than version
   *    <=version Must be less than or equal to version
   *    ~version  Must be at least version, but less than the next significant
   *              revision above version:
   *              "~1.2.3" is equivalent to ">= 1.2.3 and < 1.3"
   *    ~>version Equivalent to ~version
   *    1.2.x     Must match "1.2.x", where "x" is a wildcard that matches
   *              anything
   *    1.2.*     Similar to "1.2.x", but "*" in the trailing position is a
   *              "greedy" wildcard, so will match any number of additional
   *              components:
   *              "1.2.*" will match "1.2.1", "1.2.1.1", "1.2.1.1.1" etc
   *    *         Any version
   *    ""        (Empty string) Same as *
   *    v1 - v2   Equivalent to ">= v1 and <= v2"
   *    r1 || r2  Passes if either r1 or r2 are satisfied
   *
   * @param {string} range
   * @param {string} version
   * @returns {boolean}
   */
  contains: function contains(range, version) {
    return checkOrExpression(range.trim(), version.trim());
  }
};

module.exports = VersionRange;

/***/ }),
/* 2333 */,
/* 2334 */,
/* 2335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var isWebkit = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('AppleWebKit') > -1;

/**
 * Gets the element with the document scroll properties such as `scrollLeft` and
 * `scrollHeight`. This may differ across different browsers.
 *
 * NOTE: The return value can be null if the DOM is not yet ready.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getDocumentScrollElement(doc) {
  doc = doc || document;
  if (doc.scrollingElement) {
    return doc.scrollingElement;
  }
  return !isWebkit && doc.compatMode === 'CSS1Compat' ? doc.documentElement : doc.body;
}

module.exports = getDocumentScrollElement;

/***/ }),
/* 2336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var getElementRect = __webpack_require__(2337);

/**
 * Gets an element's position in pixels relative to the viewport. The returned
 * object represents the position of the element's top left corner.
 *
 * @param {DOMElement} element
 * @return {object}
 */
function getElementPosition(element) {
  var rect = getElementRect(element);
  return {
    x: rect.left,
    y: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };
}

module.exports = getElementPosition;

/***/ }),
/* 2337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var containsNode = __webpack_require__(385);

/**
 * Gets an element's bounding rect in pixels relative to the viewport.
 *
 * @param {DOMElement} elem
 * @return {object}
 */
function getElementRect(elem) {
  var docElem = elem.ownerDocument.documentElement;

  // FF 2, Safari 3 and Opera 9.5- do not support getBoundingClientRect().
  // IE9- will throw if the element is not in the document.
  if (!('getBoundingClientRect' in elem) || !containsNode(docElem, elem)) {
    return {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
  }

  // Subtracts clientTop/Left because IE8- added a 2px border to the
  // <html> element (see http://fburl.com/1493213). IE 7 in
  // Quicksmode does not report clientLeft/clientTop so there
  // will be an unaccounted offset of 2px when in quirksmode
  var rect = elem.getBoundingClientRect();

  return {
    left: Math.round(rect.left) - docElem.clientLeft,
    right: Math.round(rect.right) - docElem.clientLeft,
    top: Math.round(rect.top) - docElem.clientTop,
    bottom: Math.round(rect.bottom) - docElem.clientTop
  };
}

module.exports = getElementRect;

/***/ }),
/* 2338 */,
/* 2339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var camelize = __webpack_require__(838);
var hyphenate = __webpack_require__(842);

function asString(value) /*?string*/{
  return value == null ? value : String(value);
}

function getStyleProperty( /*DOMNode*/node, /*string*/name) /*?string*/{
  var computedStyle = void 0;

  // W3C Standard
  if (window.getComputedStyle) {
    // In certain cases such as within an iframe in FF3, this returns null.
    computedStyle = window.getComputedStyle(node, null);
    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate(name)));
    }
  }
  // Safari
  if (document.defaultView && document.defaultView.getComputedStyle) {
    computedStyle = document.defaultView.getComputedStyle(node, null);
    // A Safari bug causes this to return null for `display: none` elements.
    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate(name)));
    }
    if (name === 'display') {
      return 'none';
    }
  }
  // Internet Explorer
  if (node.currentStyle) {
    if (name === 'float') {
      return asString(node.currentStyle.cssFloat || node.currentStyle.styleFloat);
    }
    return asString(node.currentStyle[camelize(name)]);
  }
  return asString(node.style && node.style[camelize(name)]);
}

module.exports = getStyleProperty;

/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getViewportWidth() {
  var width = void 0;
  if (document.documentElement) {
    width = document.documentElement.clientWidth;
  }

  if (!width && document.body) {
    width = document.body.clientWidth;
  }

  return width || 0;
} /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * 
   * @typechecks
   */

function getViewportHeight() {
  var height = void 0;
  if (document.documentElement) {
    height = document.documentElement.clientHeight;
  }

  if (!height && document.body) {
    height = document.body.clientHeight;
  }

  return height || 0;
}

/**
 * Gets the viewport dimensions including any scrollbars.
 */
function getViewportDimensions() {
  return {
    width: window.innerWidth || getViewportWidth(),
    height: window.innerHeight || getViewportHeight()
  };
}

/**
 * Gets the viewport dimensions excluding any scrollbars.
 */
getViewportDimensions.withoutScrollbars = function () {
  return {
    width: getViewportWidth(),
    height: getViewportHeight()
  };
};

module.exports = getViewportDimensions;

/***/ }),
/* 2341 */,
/* 2342 */,
/* 2343 */,
/* 2344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks static-only
 */



/**
 * Combines multiple className strings into one.
 * http://jsperf.com/joinclasses-args-vs-array
 *
 * @param {...?string} className
 * @return {string}
 */

function joinClasses(className /*, ... */) {
  if (!className) {
    className = '';
  }
  var nextClass = void 0;
  var argLength = arguments.length;
  if (argLength > 1) {
    for (var ii = 1; ii < argLength; ii++) {
      nextClass = arguments[ii];
      if (nextClass) {
        className = (className ? className + ' ' : '') + nextClass;
      }
    }
  }
  return className;
}

module.exports = joinClasses;

/***/ }),
/* 2345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * Executes the provided `callback` once for each enumerable own property in the
 * object and constructs a new object from the results. The `callback` is
 * invoked with three arguments:
 *
 *  - the property value
 *  - the property name
 *  - the object being traversed
 *
 * Properties that are added after the call to `mapObject` will not be visited
 * by `callback`. If the values of existing properties are changed, the value
 * passed to `callback` will be the value at the time `mapObject` visits them.
 * Properties that are deleted before being visited are not visited.
 *
 * @grep function objectMap()
 * @grep function objMap()
 *
 * @param {?object} object
 * @param {function} callback
 * @param {*} context
 * @return {?object}
 */
function mapObject(object, callback, context) {
  if (!object) {
    return null;
  }
  var result = {};
  for (var name in object) {
    if (hasOwnProperty.call(object, name)) {
      result[name] = callback.call(context, object[name], name, object);
    }
  }
  return result;
}

module.exports = mapObject;

/***/ }),
/* 2346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



// setimmediate adds setImmediate to the global. We want to make sure we export
// the actual function.

__webpack_require__(2741);
module.exports = global.setImmediate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74)))

/***/ }),
/* 2347 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  // if __disableNativeFetch is set to true, the it will always polyfill fetch
  // with Ajax.
  if (!self.__disableNativeFetch && self.fetch) {
    return
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)

    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var list = this.map[name]
    if (!list) {
      list = []
      this.map[name] = list
    }
    list.push(value)
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    var values = this.map[normalizeName(name)]
    return values ? values[0] : null
  }

  Headers.prototype.getAll = function(name) {
    return this.map[normalizeName(name)] || []
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = [normalizeValue(value)]
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    Object.getOwnPropertyNames(this.map).forEach(function(name) {
      this.map[name].forEach(function(value) {
        callback.call(thisArg, value, name, this)
      }, this)
    }, this)
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    reader.readAsArrayBuffer(blob)
    return fileReaderReady(reader)
  }

  function readBlobAsText(blob, options) {
    var reader = new FileReader()
    var contentType = options.headers.map['content-type'] ? options.headers.map['content-type'].toString() : ''
    var regex = /charset\=[0-9a-zA-Z\-\_]*;?/
    var _charset = blob.type.match(regex) || contentType.match(regex)
    var args = [blob]

    if(_charset) {
      args.push(_charset[0].replace(/^charset\=/, '').replace(/;$/, ''))
    }

    reader.readAsText.apply(reader, args)
    return fileReaderReady(reader)
  }

  var support = {
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob();
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  function Body() {
    this.bodyUsed = false


    this._initBody = function(body, options) {
      this._bodyInit = body
      if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
        this._options = options
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (!body) {
        this._bodyText = ''
      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
        // Only support ArrayBuffers for POST method.
        // Receiving ArrayBuffers happens via Blobs, instead.
      } else {
        throw new Error('unsupported BodyInit type')
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        return this.blob().then(readBlobAsArrayBuffer)
      }

      this.text = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return readBlobAsText(this._bodyBlob, this._options)
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as text')
        } else {
          return Promise.resolve(this._bodyText)
        }
      }
    } else {
      this.text = function() {
        var rejected = consumed(this)
        return rejected ? rejected : Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body
    if (Request.prototype.isPrototypeOf(input)) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = input
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body, options)
  }

  Request.prototype.clone = function() {
    return new Request(this)
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function headers(xhr) {
    var head = new Headers()
    var pairs = xhr.getAllResponseHeaders().trim().split('\n')
    pairs.forEach(function(header) {
      var split = header.trim().split(':')
      var key = split.shift().trim()
      var value = split.join(':').trim()
      head.append(key, value)
    })
    return head
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this._initBody(bodyInit, options)
    this.type = 'default'
    this.status = options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = options.statusText
    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
    this.url = options.url || ''
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers;
  self.Request = Request;
  self.Response = Response;

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request
      if (Request.prototype.isPrototypeOf(input) && !init) {
        request = input
      } else {
        request = new Request(input, init)
      }

      var xhr = new XMLHttpRequest()

      function responseURL() {
        if ('responseURL' in xhr) {
          return xhr.responseURL
        }

        // Avoid security warnings on getResponseHeader when not allowed by CORS
        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
          return xhr.getResponseHeader('X-Request-URL')
        }

        return;
      }

      var __onLoadHandled = false;

      function onload() {
        if (xhr.readyState !== 4) {
          return
        }
        var status = (xhr.status === 1223) ? 204 : xhr.status
        if (status < 100 || status > 599) {
          if (__onLoadHandled) { return; } else { __onLoadHandled = true; }
          reject(new TypeError('Network request failed'))
          return
        }
        var options = {
          status: status,
          statusText: xhr.statusText,
          headers: headers(xhr),
          url: responseURL()
        }
        var body = 'response' in xhr ? xhr.response : xhr.responseText;

        if (__onLoadHandled) { return; } else { __onLoadHandled = true; }
        resolve(new Response(body, options))
      }
      xhr.onreadystatechange = onload;
      xhr.onload = onload;
      xhr.onerror = function() {
        if (__onLoadHandled) { return; } else { __onLoadHandled = true; }
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      // `withCredentials` should be setted after calling `.open` in IE10
      // http://stackoverflow.com/a/19667959/1219343
      try {
        if (request.credentials === 'include') {
          if ('withCredentials' in xhr) {
            xhr.withCredentials = true;
          } else {
            console && console.warn && console.warn('withCredentials is not supported, you can ignore this warning');
          }
        }
      } catch (e) {
        console && console.warn && console.warn('set withCredentials error:' + e);
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true

  // Support CommonJS
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = self.fetch;
  }
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 2348 */
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),
/* 2349 */
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__(2348);
var delegate = __webpack_require__(1793);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),
/* 2350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(537);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(68);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(265);

var _DOMUtils = __webpack_require__(389);

var _DOMStateStorage = __webpack_require__(845);

var _PathUtils = __webpack_require__(195);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
  var path = pathCoder.decodePath(getHashPath());
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = pathCoder.encodePath(path);

    if (path !== encodedPath) {
      // Always be sure we have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var currentLocation = getCurrentLocation(pathCoder, queryKey);

      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

      prevLocation = currentLocation;

      listener(currentLocation);
    }
  };

  // Ensure the hash is encoded properly.
  var path = getHashPath();
  var encodedPath = pathCoder.encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
  var state = location.state,
      key = location.key;


  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(537);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(265);

var _PathUtils = __webpack_require__(195);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(57);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(538);

var _BrowserProtocol = __webpack_require__(537);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(2352);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(389);

var _createHistory = __webpack_require__(539);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation,
      getCurrentLocation = Protocol.getCurrentLocation,
      pushLocation = Protocol.pushLocation,
      replaceLocation = Protocol.replaceLocation,
      go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 2354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(68);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(57);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(538);

var _DOMUtils = __webpack_require__(389);

var _HashProtocol = __webpack_require__(2351);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(539);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!' + path;
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substring(1) : path;
    }
  },
  noslash: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '/' ? path.substring(1) : path;
    },
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var createHashHistory = function createHashHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey,
      hashType = options.hashType;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  if (hashType == null) hashType = 'slash';

  if (!(hashType in HashPathCoders)) {
     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;

    hashType = 'slash';
  }

  var pathCoder = HashPathCoders[hashType];

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, pathCoder, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + pathCoder.encodePath(history.createHref(path));
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(68);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(57);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(265);

var _PathUtils = __webpack_require__(195);

var _createHistory = __webpack_require__(539);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(388);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options,
      entries = _options.entries,
      current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;

/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 2357 */,
/* 2358 */,
/* 2359 */,
/* 2360 */,
/* 2361 */,
/* 2362 */,
/* 2363 */,
/* 2364 */,
/* 2365 */,
/* 2366 */,
/* 2367 */,
/* 2368 */,
/* 2369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(2371)['default'];
exports['default'] = exports;


/***/ }),
/* 2370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Function.prototype.bind implementation from Mozilla Developer Network:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill



var bind = Function.prototype.bind || function (oThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs   = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP    = function() {},
        fBound  = function() {
          return fToBind.apply(this instanceof fNOP
                 ? this
                 : oThis,
                 aArgs.concat(Array.prototype.slice.call(arguments)));
        };

    if (this.prototype) {
      // native functions don't have a prototype
      fNOP.prototype = this.prototype;
    }
    fBound.prototype = new fNOP();

    return fBound;
};

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 2371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jshint esnext: true */


var src$es5$$ = __webpack_require__(2370);
exports["default"] = createFormatCache;

// -----------------------------------------------------------------------------

function createFormatCache(FormatConstructor) {
    var cache = src$es5$$.objCreate(null);

    return function () {
        var args    = Array.prototype.slice.call(arguments);
        var cacheId = getCacheId(args);
        var format  = cacheId && cache[cacheId];

        if (!format) {
            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();

            if (cacheId) {
                cache[cacheId] = format;
            }
        }

        return format;
    };
}

// -- Utilities ----------------------------------------------------------------

function getCacheId(inputs) {
    // When JSON is not available in the runtime, we will not create a cache id.
    if (typeof JSON === 'undefined') { return; }

    var cacheId = [];

    var i, len, input;

    for (i = 0, len = inputs.length; i < len; i += 1) {
        input = inputs[i];

        if (input && typeof input === 'object') {
            cacheId.push(orderedProps(input));
        } else {
            cacheId.push(input);
        }
    }

    return JSON.stringify(cacheId);
}

function orderedProps(obj) {
    var props = [],
        keys  = [];

    var key, i, len, prop;

    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            keys.push(key);
        }
    }

    var orderedKeys = keys.sort();

    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
        key  = orderedKeys[i];
        prop = {};

        prop[key] = obj[key];
        props[i]  = prop;
    }

    return props;
}

//# sourceMappingURL=memoizer.js.map

/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(2373)['default'];
exports['default'] = exports;


/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  "use strict";

  /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.location = location;
    this.name     = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  function peg$parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},
        parser  = this,

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements,
                    location: location()
                };
            },
        peg$c1 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c2 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText,
                    location: location()
                };
            },
        peg$c3 = /^[^ \t\n\r,.+={}#]/,
        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c5 = "{",
        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c7 = ",",
        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
        peg$c9 = "}",
        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c11 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2],
                    location: location()
                };
            },
        peg$c12 = "number",
        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c14 = "date",
        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c16 = "time",
        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c18 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2],
                    location: location()
                };
            },
        peg$c19 = "plural",
        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c21 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                };
            },
        peg$c22 = "selectordinal",
        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                }
            },
        peg$c25 = "select",
        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c27 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options,
                    location: location()
                };
            },
        peg$c28 = "=",
        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c30 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern,
                    location: location()
                };
            },
        peg$c31 = "offset:",
        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c33 = function(number) {
                return number;
            },
        peg$c34 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options,
                    location: location()
                };
            },
        peg$c35 = { type: "other", description: "whitespace" },
        peg$c36 = /^[ \t\n\r]/,
        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c38 = { type: "other", description: "optionalWhitespace" },
        peg$c39 = /^[0-9]/,
        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c41 = /^[0-9a-f]/i,
        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c43 = "0",
        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c45 = /^[1-9]/,
        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c47 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
        peg$c50 = "\\\\",
        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c52 = function() { return '\\'; },
        peg$c53 = "\\#",
        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c55 = function() { return '\\#'; },
        peg$c56 = "\\{",
        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c58 = function() { return '\u007B'; },
        peg$c59 = "\\}",
        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c61 = function() { return '\u007D'; },
        peg$c62 = "\\u",
        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c64 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c65 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$savedPos         = 0,
        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function error(message) {
      throw peg$buildException(
        message,
        null,
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p, ch;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line:   details.line,
          column: details.column,
          seenCR: details.seenCR
        };

        while (p < pos) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails   = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line:   startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line:   endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, found, location) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new peg$SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        location
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c2(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c3.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c4); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c3.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c4); }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c6); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c7;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c8); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              if (s5 === peg$FAILED) {
                s5 = null;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c9;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c11(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c13); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c14) {
          s1 = peg$c14;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c15); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c16) {
            s1 = peg$c16;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c17); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c18(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c19) {
        s1 = peg$c19;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c20); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c21(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c28;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c5;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c9;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s1 = peg$c31;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c33(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c36.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c37); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c36.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c37); }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c39.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c41.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c42); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c43;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c44); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c45.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c46); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c47(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c48.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c49); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c50) {
          s1 = peg$c50;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c51); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c54); }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c56) {
              s1 = peg$c56;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c57); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c58();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c59) {
                s1 = peg$c59;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c60); }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c61();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c62) {
                  s1 = peg$c62;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                  } else {
                    s2 = s3;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c64(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c65(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(
        null,
        peg$maxFailExpected,
        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
        peg$maxFailPos < input.length
          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
      );
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse:       peg$parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(849), src$es5$$ = __webpack_require__(2377), src$compiler$$ = __webpack_require__(2374), intl$messageformat$parser$$ = __webpack_require__(2372);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 2376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 2377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(849);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 2378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(2375), src$en$$ = __webpack_require__(2376);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 2379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(2384)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(2853);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 2380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var intl$messageformat$$ = __webpack_require__(848), src$diff$$ = __webpack_require__(2381), src$es5$$ = __webpack_require__(2383);
exports["default"] = RelativeFormat;

// -----------------------------------------------------------------------------

var FIELDS = [
    'second', 'second-short',
    'minute', 'minute-short',
    'hour', 'hour-short',
    'day', 'day-short',
    'month', 'month-short',
    'year', 'year-short'
];
var STYLES = ['best fit', 'numeric'];

// -- RelativeFormat -----------------------------------------------------------

function RelativeFormat(locales, options) {
    options = options || {};

    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (src$es5$$.isArray(locales)) {
        locales = locales.concat();
    }

    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
    src$es5$$.defineProperty(this, '_options', {value: {
        style: this._resolveStyle(options.style),
        units: this._isValidUnits(options.units) && options.units
    }});

    src$es5$$.defineProperty(this, '_locales', {value: locales});
    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlRelativeFormat is missing a ' +
            '`locale` property value'
        );
    }

    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;

    // Add data to IntlMessageFormat.
    intl$messageformat$$["default"].__addLocaleData(data);
}});

// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,

    value: {
        second: 45, 'second-short': 45,  // seconds to minute
        minute: 45, 'minute-short': 45, // minutes to hour
        hour  : 22, 'hour-short': 22, // hours to day
        day   : 26, 'day-short': 26, // days to month
        month : 11, 'month-short': 11 // months to year
    }
});

RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style : this._options.style,
        units : this._options.units
    };
};

RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales        = this._locales;
    var resolvedLocale = this._locale;

    var field        = this._fields[units];
    var relativeTime = field.relativeTime;
    var future       = '';
    var past         = '';
    var i;

    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }

    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }

    var message = '{when, select, future {{0, plural, ' + future + '}}' +
                                 'past {{0, plural, ' + past + '}}}';

    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl$messageformat$$["default"](message, locales);
};

RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;

    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }

    return messages[units];
};

RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];

    if (field.relative) {
        return field.relative[diff];
    }
};

RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale
    );
};

RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();

    if (date === undefined) {
        date = now;
    }

    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError(
            'The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    if (!isFinite(date)) {
        throw new RangeError(
            'The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    var diffReport  = src$diff$$["default"](now, date);
    var units       = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];

    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }

    return this._getMessage(units).format({
        '0' : Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};

RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }

    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error(
                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion
            );
        }
    }

    throw new Error(
        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"'
    );
};

RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);

    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }

    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }

    throw new Error(
        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"'
    );
};

RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;
    var fields = FIELDS.filter(function(field) {
        return field.indexOf('-short') < 1;
    });

    for (i = 0, l = fields.length; i < l; i += 1) {
        units = fields[i];

        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }

    return units;
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 2381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



var round = Math.round;

function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}

exports["default"] = function (from, to) {
    // Convert to ms timestamps.
    from = +from;
    to   = +to;

    var millisecond = round(to - from),
        second      = round(millisecond / 1000),
        minute      = round(second / 60),
        hour        = round(minute / 60),
        day         = round(hour / 24),
        week        = round(day / 7);

    var rawYears = daysToYears(day),
        month    = round(rawYears * 12),
        year     = round(rawYears);

    return {
        millisecond    : millisecond,
        second         : second,
        'second-short' : second,
        minute         : minute,
        'minute-short' : minute,
        hour           : hour,
        'hour-short'   : hour,
        day            : day,
        'day-short'    : day,
        week           : week,
        'week-short'   : week,
        month          : month,
        'month-short'  : month,
        year           : year,
        'year-short'   : year
    };
};

//# sourceMappingURL=diff.js.map

/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"year-short":{"displayName":"yr.","relative":{"0":"this yr.","1":"next yr.","-1":"last yr."},"relativeTime":{"future":{"one":"in {0} yr.","other":"in {0} yr."},"past":{"one":"{0} yr. ago","other":"{0} yr. ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"month-short":{"displayName":"mo.","relative":{"0":"this mo.","1":"next mo.","-1":"last mo."},"relativeTime":{"future":{"one":"in {0} mo.","other":"in {0} mo."},"past":{"one":"{0} mo. ago","other":"{0} mo. ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"day-short":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relative":{"0":"this hour"},"relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"hour-short":{"displayName":"hr.","relative":{"0":"this hour"},"relativeTime":{"future":{"one":"in {0} hr.","other":"in {0} hr."},"past":{"one":"{0} hr. ago","other":"{0} hr. ago"}}},"minute":{"displayName":"minute","relative":{"0":"this minute"},"relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"minute-short":{"displayName":"min.","relative":{"0":"this minute"},"relativeTime":{"future":{"one":"in {0} min.","other":"in {0} min."},"past":{"one":"{0} min. ago","other":"{0} min. ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}},"second-short":{"displayName":"sec.","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} sec.","other":"in {0} sec."},"past":{"one":"{0} sec. ago","other":"{0} sec. ago"}}}}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License



var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }

    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }

    return -1;
};

var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};

var dateNow = Date.now || function () {
    return new Date().getTime();
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 2384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(2380), src$en$$ = __webpack_require__(2382);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 2385 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
  The MIT License (MIT)

  Copyright (c) 2007-2017 Einar Lielmanis, Liam Newman, and contributors.

  Permission is hereby granted, free of charge, to any person
  obtaining a copy of this software and associated documentation files
  (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge,
  publish, distribute, sublicense, and/or sell copies of the Software,
  and to permit persons to whom the Software is furnished to do so,
  subject to the following conditions:

  The above copyright notice and this permission notice shall be
  included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.

*/

/**
The following batches are equivalent:

var beautify_js = require('js-beautify');
var beautify_js = require('js-beautify').js;
var beautify_js = require('js-beautify').js_beautify;

var beautify_css = require('js-beautify').css;
var beautify_css = require('js-beautify').css_beautify;

var beautify_html = require('js-beautify').html;
var beautify_html = require('js-beautify').html_beautify;

All methods returned accept two arguments, the source string and an options object.
**/

function get_beautify(js_beautify, css_beautify, html_beautify) {
    // the default is js
    var beautify = function(src, config) {
        return js_beautify.js_beautify(src, config);
    };

    // short aliases
    beautify.js = js_beautify.js_beautify;
    beautify.css = css_beautify.css_beautify;
    beautify.html = html_beautify.html_beautify;

    // legacy aliases
    beautify.js_beautify = js_beautify.js_beautify;
    beautify.css_beautify = css_beautify.css_beautify;
    beautify.html_beautify = html_beautify.html_beautify;

    return beautify;
}

if (true) {
    // Add support for AMD ( https://github.com/amdjs/amdjs-api/wiki/AMD#defineamd-property- )
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(542),
        __webpack_require__(541),
        __webpack_require__(2386)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function(js_beautify, css_beautify, html_beautify) {
        return get_beautify(js_beautify, css_beautify, html_beautify);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {
    (function(mod) {
        var js_beautify = require('./lib/beautify');
        var css_beautify = require('./lib/beautify-css');
        var html_beautify = require('./lib/beautify-html');

        mod.exports = get_beautify(js_beautify, css_beautify, html_beautify);

    })(module);
}

/***/ }),
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*jshint curly:false, eqeqeq:true, laxbreak:true, noempty:false */
/* AUTO-GENERATED. DO NOT MODIFY. */
/*

  The MIT License (MIT)

  Copyright (c) 2007-2017 Einar Lielmanis, Liam Newman, and contributors.

  Permission is hereby granted, free of charge, to any person
  obtaining a copy of this software and associated documentation files
  (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge,
  publish, distribute, sublicense, and/or sell copies of the Software,
  and to permit persons to whom the Software is furnished to do so,
  subject to the following conditions:

  The above copyright notice and this permission notice shall be
  included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.


 Style HTML
---------------

  Written by Nochum Sossonko, (nsossonko@hotmail.com)

  Based on code initially developed by: Einar Lielmanis, <einar@jsbeautifier.org>
    http://jsbeautifier.org/

  Usage:
    style_html(html_source);

    style_html(html_source, options);

  The options are:
    indent_inner_html (default false)  — indent <head> and <body> sections,
    indent_size (default 4)          — indentation size,
    indent_char (default space)      — character to indent with,
    wrap_line_length (default 250)            -  maximum amount of characters per line (0 = disable)
    brace_style (default "collapse") - "collapse" | "expand" | "end-expand" | "none"
            put braces on the same line as control statements (default), or put braces on own line (Allman / ANSI style), or just put end braces on own line, or attempt to keep them where they are.
    unformatted (defaults to inline tags) - list of tags, that shouldn't be reformatted
    content_unformatted (defaults to pre tag) - list of tags, whose content shouldn't be reformatted
    indent_scripts (default normal)  - "keep"|"separate"|"normal"
    preserve_newlines (default true) - whether existing line breaks before elements should be preserved
                                        Only works before elements, not inside tags or for text.
    max_preserve_newlines (default unlimited) - maximum number of line breaks to be preserved in one chunk
    indent_handlebars (default false) - format and indent {{#foo}} and {{/foo}}
    end_with_newline (false)          - end with a newline
    extra_liners (default [head,body,/html]) -List of tags that should have an extra newline before them.

    e.g.

    style_html(html_source, {
      'indent_inner_html': false,
      'indent_size': 2,
      'indent_char': ' ',
      'wrap_line_length': 78,
      'brace_style': 'expand',
      'preserve_newlines': true,
      'max_preserve_newlines': 5,
      'indent_handlebars': false,
      'extra_liners': ['/html']
    });
*/

(function() {
var legacy_beautify_html =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/*jshint curly:true, eqeqeq:true, laxbreak:true, noempty:false */
/*

  The MIT License (MIT)

  Copyright (c) 2007-2017 Einar Lielmanis, Liam Newman, and contributors.

  Permission is hereby granted, free of charge, to any person
  obtaining a copy of this software and associated documentation files
  (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge,
  publish, distribute, sublicense, and/or sell copies of the Software,
  and to permit persons to whom the Software is furnished to do so,
  subject to the following conditions:

  The above copyright notice and this permission notice shall be
  included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.
*/

var mergeOpts = __webpack_require__(2).mergeOpts;
var acorn = __webpack_require__(1);


var lineBreak = acorn.lineBreak;
var allLineBreaks = acorn.allLineBreaks;

// function trim(s) {
//     return s.replace(/^\s+|\s+$/g, '');
// }

function ltrim(s) {
    return s.replace(/^\s+/g, '');
}

function rtrim(s) {
    return s.replace(/\s+$/g, '');
}

function Beautifier(html_source, options, js_beautify, css_beautify) {
    //Wrapper function to invoke all the necessary constructors and deal with the output.
    html_source = html_source || '';

    var multi_parser,
        indent_inner_html,
        indent_body_inner_html,
        indent_head_inner_html,
        indent_size,
        indent_character,
        wrap_line_length,
        brace_style,
        unformatted,
        content_unformatted,
        preserve_newlines,
        max_preserve_newlines,
        indent_handlebars,
        wrap_attributes,
        wrap_attributes_indent_size,
        is_wrap_attributes_force,
        is_wrap_attributes_force_expand_multiline,
        is_wrap_attributes_force_aligned,
        end_with_newline,
        extra_liners,
        eol;

    options = options || {};

    // Allow the setting of language/file-type specific options
    // with inheritance of overall settings
    options = mergeOpts(options, 'html');

    // backwards compatibility to 1.3.4
    if ((options.wrap_line_length === undefined || parseInt(options.wrap_line_length, 10) === 0) &&
        (options.max_char !== undefined && parseInt(options.max_char, 10) !== 0)) {
        options.wrap_line_length = options.max_char;
    }

    indent_inner_html = (options.indent_inner_html === undefined) ? false : options.indent_inner_html;
    indent_body_inner_html = (options.indent_body_inner_html === undefined) ? true : options.indent_body_inner_html;
    indent_head_inner_html = (options.indent_head_inner_html === undefined) ? true : options.indent_head_inner_html;
    indent_size = (options.indent_size === undefined) ? 4 : parseInt(options.indent_size, 10);
    indent_character = (options.indent_char === undefined) ? ' ' : options.indent_char;
    brace_style = (options.brace_style === undefined) ? 'collapse' : options.brace_style;
    wrap_line_length = parseInt(options.wrap_line_length, 10) === 0 ? 32786 : parseInt(options.wrap_line_length || 250, 10);
    unformatted = options.unformatted || [
        // https://www.w3.org/TR/html5/dom.html#phrasing-content
        'a', 'abbr', 'area', 'audio', 'b', 'bdi', 'bdo', 'br', 'button', 'canvas', 'cite',
        'code', 'data', 'datalist', 'del', 'dfn', 'em', 'embed', 'i', 'iframe', 'img',
        'input', 'ins', 'kbd', 'keygen', 'label', 'map', 'mark', 'math', 'meter', 'noscript',
        'object', 'output', 'progress', 'q', 'ruby', 's', 'samp', /* 'script', */ 'select', 'small',
        'span', 'strong', 'sub', 'sup', 'svg', 'template', 'textarea', 'time', 'u', 'var',
        'video', 'wbr', 'text',
        // prexisting - not sure of full effect of removing, leaving in
        'acronym', 'address', 'big', 'dt', 'ins', 'strike', 'tt',
    ];
    content_unformatted = options.content_unformatted || [
        'pre',
    ];
    preserve_newlines = (options.preserve_newlines === undefined) ? true : options.preserve_newlines;
    max_preserve_newlines = preserve_newlines ?
        (isNaN(parseInt(options.max_preserve_newlines, 10)) ? 32786 : parseInt(options.max_preserve_newlines, 10)) :
        0;
    indent_handlebars = (options.indent_handlebars === undefined) ? false : options.indent_handlebars;
    wrap_attributes = (options.wrap_attributes === undefined) ? 'auto' : options.wrap_attributes;
    wrap_attributes_indent_size = (isNaN(parseInt(options.wrap_attributes_indent_size, 10))) ? indent_size : parseInt(options.wrap_attributes_indent_size, 10);
    is_wrap_attributes_force = wrap_attributes.substr(0, 'force'.length) === 'force';
    is_wrap_attributes_force_expand_multiline = (wrap_attributes === 'force-expand-multiline');
    is_wrap_attributes_force_aligned = (wrap_attributes === 'force-aligned');
    end_with_newline = (options.end_with_newline === undefined) ? false : options.end_with_newline;
    extra_liners = (typeof options.extra_liners === 'object') && options.extra_liners ?
        options.extra_liners.concat() : (typeof options.extra_liners === 'string') ?
        options.extra_liners.split(',') : 'head,body,/html'.split(',');
    eol = options.eol ? options.eol : 'auto';

    if (options.indent_with_tabs) {
        indent_character = '\t';
        indent_size = 1;
    }

    if (eol === 'auto') {
        eol = '\n';
        if (html_source && lineBreak.test(html_source || '')) {
            eol = html_source.match(lineBreak)[0];
        }
    }

    eol = eol.replace(/\\r/, '\r').replace(/\\n/, '\n');

    // HACK: newline parsing inconsistent. This brute force normalizes the input.
    html_source = html_source.replace(allLineBreaks, '\n');

    function Parser() {

        this.pos = 0; //Parser position
        this.token = '';
        this.current_mode = 'CONTENT'; //reflects the current Parser mode: TAG/CONTENT
        this.tags = { //An object to hold tags, their position, and their parent-tags, initiated with default values
            parent: 'parent1',
            parentcount: 1,
            parent1: ''
        };
        this.tag_type = '';
        this.token_text = this.last_token = this.last_text = this.token_type = '';
        this.newlines = 0;
        this.indent_content = indent_inner_html;
        this.indent_body_inner_html = indent_body_inner_html;
        this.indent_head_inner_html = indent_head_inner_html;

        this.Utils = { //Uilities made available to the various functions
            whitespace: "\n\r\t ".split(''),

            single_token: options.void_elements || [
                // HTLM void elements - aka self-closing tags - aka singletons
                // https://www.w3.org/html/wg/drafts/html/master/syntax.html#void-elements
                'area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'keygen',
                'link', 'menuitem', 'meta', 'param', 'source', 'track', 'wbr',
                // NOTE: Optional tags - are not understood.
                // https://www.w3.org/TR/html5/syntax.html#optional-tags
                // The rules for optional tags are too complex for a simple list
                // Also, the content of these tags should still be indented in many cases.
                // 'li' is a good exmple.

                // Doctype and xml elements
                '!doctype', '?xml',
                // ?php tag
                '?php',
                // other tags that were in this list, keeping just in case
                'basefont', 'isindex'
            ],
            extra_liners: extra_liners, //for tags that need a line of whitespace before them
            in_array: function(what, arr) {
                for (var i = 0; i < arr.length; i++) {
                    if (what === arr[i]) {
                        return true;
                    }
                }
                return false;
            }
        };

        // Return true if the given text is composed entirely of whitespace.
        this.is_whitespace = function(text) {
            for (var n = 0; n < text.length; n++) {
                if (!this.Utils.in_array(text.charAt(n), this.Utils.whitespace)) {
                    return false;
                }
            }
            return true;
        };

        this.traverse_whitespace = function() {
            var input_char = '';

            input_char = this.input.charAt(this.pos);
            if (this.Utils.in_array(input_char, this.Utils.whitespace)) {
                this.newlines = 0;
                while (this.Utils.in_array(input_char, this.Utils.whitespace)) {
                    if (preserve_newlines && input_char === '\n' && this.newlines <= max_preserve_newlines) {
                        this.newlines += 1;
                    }

                    this.pos++;
                    input_char = this.input.charAt(this.pos);
                }
                return true;
            }
            return false;
        };

        // Append a space to the given content (string array) or, if we are
        // at the wrap_line_length, append a newline/indentation.
        // return true if a newline was added, false if a space was added
        this.space_or_wrap = function(content) {
            if (this.line_char_count >= this.wrap_line_length) { //insert a line when the wrap_line_length is reached
                this.print_newline(false, content);
                this.print_indentation(content);
                return true;
            } else {
                this.line_char_count++;
                content.push(' ');
                return false;
            }
        };

        this.get_content = function() { //function to capture regular content between tags
            var input_char = '',
                content = [],
                handlebarsStarted = 0;

            while (this.input.charAt(this.pos) !== '<' || handlebarsStarted === 2) {
                if (this.pos >= this.input.length) {
                    return content.length ? content.join('') : ['', 'TK_EOF'];
                }

                if (handlebarsStarted < 2 && this.traverse_whitespace()) {
                    this.space_or_wrap(content);
                    continue;
                }

                input_char = this.input.charAt(this.pos);

                if (indent_handlebars) {
                    if (input_char === '{') {
                        handlebarsStarted += 1;
                    } else if (handlebarsStarted < 2) {
                        handlebarsStarted = 0;
                    }

                    if (input_char === '}' && handlebarsStarted > 0) {
                        if (handlebarsStarted-- === 0) {
                            break;
                        }
                    }
                    // Handlebars parsing is complicated.
                    // {{#foo}} and {{/foo}} are formatted tags.
                    // {{something}} should get treated as content, except:
                    // {{else}} specifically behaves like {{#if}} and {{/if}}
                    var peek3 = this.input.substr(this.pos, 3);
                    if (peek3 === '{{#' || peek3 === '{{/') {
                        // These are tags and not content.
                        break;
                    } else if (peek3 === '{{!') {
                        return [this.get_tag(), 'TK_TAG_HANDLEBARS_COMMENT'];
                    } else if (this.input.substr(this.pos, 2) === '{{') {
                        if (this.get_tag(true) === '{{else}}') {
                            break;
                        }
                    }
                }

                this.pos++;
                this.line_char_count++;
                content.push(input_char); //letter at-a-time (or string) inserted to an array
            }
            return content.length ? content.join('') : '';
        };

        this.get_contents_to = function(name) { //get the full content of a script or style to pass to js_beautify
            if (this.pos === this.input.length) {
                return ['', 'TK_EOF'];
            }
            var content = '';
            var reg_match = new RegExp('</' + name + '\\s*>', 'igm');
            reg_match.lastIndex = this.pos;
            var reg_array = reg_match.exec(this.input);
            var end_script = reg_array ? reg_array.index : this.input.length; //absolute end of script
            if (this.pos < end_script) { //get everything in between the script tags
                content = this.input.substring(this.pos, end_script);
                this.pos = end_script;
            }
            return content;
        };

        this.record_tag = function(tag) { //function to record a tag and its parent in this.tags Object
            if (this.tags[tag + 'count']) { //check for the existence of this tag type
                this.tags[tag + 'count']++;
                this.tags[tag + this.tags[tag + 'count']] = this.indent_level; //and record the present indent level
            } else { //otherwise initialize this tag type
                this.tags[tag + 'count'] = 1;
                this.tags[tag + this.tags[tag + 'count']] = this.indent_level; //and record the present indent level
            }
            this.tags[tag + this.tags[tag + 'count'] + 'parent'] = this.tags.parent; //set the parent (i.e. in the case of a div this.tags.div1parent)
            this.tags.parent = tag + this.tags[tag + 'count']; //and make this the current parent (i.e. in the case of a div 'div1')
        };

        this.retrieve_tag = function(tag) { //function to retrieve the opening tag to the corresponding closer
            if (this.tags[tag + 'count']) { //if the openener is not in the Object we ignore it
                var temp_parent = this.tags.parent; //check to see if it's a closable tag.
                while (temp_parent) { //till we reach '' (the initial value);
                    if (tag + this.tags[tag + 'count'] === temp_parent) { //if this is it use it
                        break;
                    }
                    temp_parent = this.tags[temp_parent + 'parent']; //otherwise keep on climbing up the DOM Tree
                }
                if (temp_parent) { //if we caught something
                    this.indent_level = this.tags[tag + this.tags[tag + 'count']]; //set the indent_level accordingly
                    this.tags.parent = this.tags[temp_parent + 'parent']; //and set the current parent
                }
                delete this.tags[tag + this.tags[tag + 'count'] + 'parent']; //delete the closed tags parent reference...
                delete this.tags[tag + this.tags[tag + 'count']]; //...and the tag itself
                if (this.tags[tag + 'count'] === 1) {
                    delete this.tags[tag + 'count'];
                } else {
                    this.tags[tag + 'count']--;
                }
            }
        };

        this.indent_to_tag = function(tag) {
            // Match the indentation level to the last use of this tag, but don't remove it.
            if (!this.tags[tag + 'count']) {
                return;
            }
            var temp_parent = this.tags.parent;
            while (temp_parent) {
                if (tag + this.tags[tag + 'count'] === temp_parent) {
                    break;
                }
                temp_parent = this.tags[temp_parent + 'parent'];
            }
            if (temp_parent) {
                this.indent_level = this.tags[tag + this.tags[tag + 'count']];
            }
        };

        this.get_tag = function(peek) { //function to get a full tag and parse its type
            var input_char = '',
                content = [],
                comment = '',
                space = false,
                first_attr = true,
                has_wrapped_attrs = false,
                tag_start, tag_end,
                tag_start_char,
                orig_pos = this.pos,
                orig_line_char_count = this.line_char_count,
                is_tag_closed = false,
                tail;

            peek = peek !== undefined ? peek : false;

            do {
                if (this.pos >= this.input.length) {
                    if (peek) {
                        this.pos = orig_pos;
                        this.line_char_count = orig_line_char_count;
                    }
                    return content.length ? content.join('') : ['', 'TK_EOF'];
                }

                input_char = this.input.charAt(this.pos);
                this.pos++;

                if (this.Utils.in_array(input_char, this.Utils.whitespace)) { //don't want to insert unnecessary space
                    space = true;
                    continue;
                }

                if (input_char === "'" || input_char === '"') {
                    input_char += this.get_unformatted(input_char);
                    space = true;
                }

                if (input_char === '=') { //no space before =
                    space = false;
                }
                tail = this.input.substr(this.pos - 1);
                if (is_wrap_attributes_force_expand_multiline && has_wrapped_attrs && !is_tag_closed && (input_char === '>' || input_char === '/')) {
                    if (tail.match(/^\/?\s*>/)) {
                        space = false;
                        is_tag_closed = true;
                        this.print_newline(false, content);
                        this.print_indentation(content);
                    }
                }
                if (content.length && content[content.length - 1] !== '=' && input_char !== '>' && space) {
                    //no space after = or before >
                    var wrapped = this.space_or_wrap(content);
                    var indentAttrs = wrapped && input_char !== '/' && !is_wrap_attributes_force;
                    space = false;

                    if (is_wrap_attributes_force && input_char !== '/') {
                        var force_first_attr_wrap = false;
                        if (is_wrap_attributes_force_expand_multiline && first_attr) {
                            var is_only_attribute = tail.match(/^\S*(="([^"]|\\")*")?\s*\/?\s*>/) !== null;
                            force_first_attr_wrap = !is_only_attribute;
                        }
                        if (!first_attr || force_first_attr_wrap) {
                            this.print_newline(false, content);
                            this.print_indentation(content);
                            indentAttrs = true;
                        }
                    }
                    if (indentAttrs) {
                        has_wrapped_attrs = true;

                        //indent attributes an auto, forced, or forced-align line-wrap
                        var alignment_size = wrap_attributes_indent_size;
                        if (is_wrap_attributes_force_aligned) {
                            alignment_size = content.indexOf(' ') + 1;
                        }

                        for (var count = 0; count < alignment_size; count++) {
                            // only ever further indent with spaces since we're trying to align characters
                            content.push(' ');
                        }
                    }
                    if (first_attr) {
                        for (var i = 0; i < content.length; i++) {
                            if (content[i] === ' ') {
                                first_attr = false;
                                break;
                            }
                        }
                    }
                }

                if (indent_handlebars && tag_start_char === '<') {
                    // When inside an angle-bracket tag, put spaces around
                    // handlebars not inside of strings.
                    if ((input_char + this.input.charAt(this.pos)) === '{{') {
                        input_char += this.get_unformatted('}}');
                        if (content.length && content[content.length - 1] !== ' ' && content[content.length - 1] !== '<') {
                            input_char = ' ' + input_char;
                        }
                        space = true;
                    }
                }

                if (input_char === '<' && !tag_start_char) {
                    tag_start = this.pos - 1;
                    tag_start_char = '<';
                }

                if (indent_handlebars && !tag_start_char) {
                    if (content.length >= 2 && content[content.length - 1] === '{' && content[content.length - 2] === '{') {
                        if (input_char === '#' || input_char === '/' || input_char === '!') {
                            tag_start = this.pos - 3;
                        } else {
                            tag_start = this.pos - 2;
                        }
                        tag_start_char = '{';
                    }
                }

                this.line_char_count++;
                content.push(input_char); //inserts character at-a-time (or string)

                if (content[1] && (content[1] === '!' || content[1] === '?' || content[1] === '%')) { //if we're in a comment, do something special
                    // We treat all comments as literals, even more than preformatted tags
                    // we just look for the appropriate close tag
                    content = [this.get_comment(tag_start)];
                    break;
                }

                if (indent_handlebars && content[1] && content[1] === '{' && content[2] && content[2] === '!') { //if we're in a comment, do something special
                    // We treat all comments as literals, even more than preformatted tags
                    // we just look for the appropriate close tag
                    content = [this.get_comment(tag_start)];
                    break;
                }

                if (indent_handlebars && tag_start_char === '{' && content.length > 2 && content[content.length - 2] === '}' && content[content.length - 1] === '}') {
                    break;
                }
            } while (input_char !== '>');

            var tag_complete = content.join('');
            var tag_index;
            var tag_offset;

            // must check for space first otherwise the tag could have the first attribute included, and
            // then not un-indent correctly
            if (tag_complete.indexOf(' ') !== -1) { //if there's whitespace, thats where the tag name ends
                tag_index = tag_complete.indexOf(' ');
            } else if (tag_complete.indexOf('\n') !== -1) { //if there's a line break, thats where the tag name ends
                tag_index = tag_complete.indexOf('\n');
            } else if (tag_complete.charAt(0) === '{') {
                tag_index = tag_complete.indexOf('}');
            } else { //otherwise go with the tag ending
                tag_index = tag_complete.indexOf('>');
            }
            if (tag_complete.charAt(0) === '<' || !indent_handlebars) {
                tag_offset = 1;
            } else {
                tag_offset = tag_complete.charAt(2) === '#' ? 3 : 2;
            }
            var tag_check = tag_complete.substring(tag_offset, tag_index).toLowerCase();
            if (tag_complete.charAt(tag_complete.length - 2) === '/' ||
                this.Utils.in_array(tag_check, this.Utils.single_token)) { //if this tag name is a single tag type (either in the list or has a closing /)
                if (!peek) {
                    this.tag_type = 'SINGLE';
                }
            } else if (indent_handlebars && tag_complete.charAt(0) === '{' && tag_check === 'else') {
                if (!peek) {
                    this.indent_to_tag('if');
                    this.tag_type = 'HANDLEBARS_ELSE';
                    this.indent_content = true;
                    this.traverse_whitespace();
                }
            } else if (this.is_unformatted(tag_check, unformatted) ||
                this.is_unformatted(tag_check, content_unformatted)) {
                // do not reformat the "unformatted" or "content_unformatted" tags
                comment = this.get_unformatted('</' + tag_check + '>', tag_complete); //...delegate to get_unformatted function
                content.push(comment);
                tag_end = this.pos - 1;
                this.tag_type = 'SINGLE';
            } else if (tag_check === 'script' &&
                (tag_complete.search('type') === -1 ||
                    (tag_complete.search('type') > -1 &&
                        tag_complete.search(/\b(text|application|dojo)\/(x-)?(javascript|ecmascript|jscript|livescript|(ld\+)?json|method|aspect)/) > -1))) {
                if (!peek) {
                    this.record_tag(tag_check);
                    this.tag_type = 'SCRIPT';
                }
            } else if (tag_check === 'style' &&
                (tag_complete.search('type') === -1 ||
                    (tag_complete.search('type') > -1 && tag_complete.search('text/css') > -1))) {
                if (!peek) {
                    this.record_tag(tag_check);
                    this.tag_type = 'STYLE';
                }
            } else if (tag_check.charAt(0) === '!') { //peek for <! comment
                // for comments content is already correct.
                if (!peek) {
                    this.tag_type = 'SINGLE';
                    this.traverse_whitespace();
                }
            } else if (!peek) {
                if (tag_check.charAt(0) === '/') { //this tag is a double tag so check for tag-ending
                    this.retrieve_tag(tag_check.substring(1)); //remove it and all ancestors
                    this.tag_type = 'END';
                } else { //otherwise it's a start-tag
                    this.record_tag(tag_check); //push it on the tag stack
                    if (tag_check.toLowerCase() !== 'html') {
                        this.indent_content = true;
                    }
                    this.tag_type = 'START';
                }

                // Allow preserving of newlines after a start or end tag
                if (this.traverse_whitespace()) {
                    this.space_or_wrap(content);
                }

                if (this.Utils.in_array(tag_check, this.Utils.extra_liners)) { //check if this double needs an extra line
                    this.print_newline(false, this.output);
                    if (this.output.length && this.output[this.output.length - 2] !== '\n') {
                        this.print_newline(true, this.output);
                    }
                }
            }

            if (peek) {
                this.pos = orig_pos;
                this.line_char_count = orig_line_char_count;
            }

            return content.join(''); //returns fully formatted tag
        };

        this.get_comment = function(start_pos) { //function to return comment content in its entirety
            // this is will have very poor perf, but will work for now.
            var comment = '',
                delimiter = '>',
                matched = false;

            this.pos = start_pos;
            var input_char = this.input.charAt(this.pos);
            this.pos++;

            while (this.pos <= this.input.length) {
                comment += input_char;

                // only need to check for the delimiter if the last chars match
                if (comment.charAt(comment.length - 1) === delimiter.charAt(delimiter.length - 1) &&
                    comment.indexOf(delimiter) !== -1) {
                    break;
                }

                // only need to search for custom delimiter for the first few characters
                if (!matched && comment.length < 10) {
                    if (comment.indexOf('<![if') === 0) { //peek for <![if conditional comment
                        delimiter = '<![endif]>';
                        matched = true;
                    } else if (comment.indexOf('<![cdata[') === 0) { //if it's a <[cdata[ comment...
                        delimiter = ']]>';
                        matched = true;
                    } else if (comment.indexOf('<![') === 0) { // some other ![ comment? ...
                        delimiter = ']>';
                        matched = true;
                    } else if (comment.indexOf('<!--') === 0) { // <!-- comment ...
                        delimiter = '-->';
                        matched = true;
                    } else if (comment.indexOf('{{!--') === 0) { // {{!-- handlebars comment
                        delimiter = '--}}';
                        matched = true;
                    } else if (comment.indexOf('{{!') === 0) { // {{! handlebars comment
                        if (comment.length === 5 && comment.indexOf('{{!--') === -1) {
                            delimiter = '}}';
                            matched = true;
                        }
                    } else if (comment.indexOf('<?') === 0) { // {{! handlebars comment
                        delimiter = '?>';
                        matched = true;
                    } else if (comment.indexOf('<%') === 0) { // {{! handlebars comment
                        delimiter = '%>';
                        matched = true;
                    }
                }

                input_char = this.input.charAt(this.pos);
                this.pos++;
            }

            return comment;
        };

        function tokenMatcher(delimiter) {
            var token = '';

            var add = function(str) {
                var newToken = token + str.toLowerCase();
                token = newToken.length <= delimiter.length ? newToken : newToken.substr(newToken.length - delimiter.length, delimiter.length);
            };

            var doesNotMatch = function() {
                return token.indexOf(delimiter) === -1;
            };

            return {
                add: add,
                doesNotMatch: doesNotMatch
            };
        }

        this.get_unformatted = function(delimiter, orig_tag) { //function to return unformatted content in its entirety
            if (orig_tag && orig_tag.toLowerCase().indexOf(delimiter) !== -1) {
                return '';
            }
            var input_char = '';
            var content = '';
            var space = true;

            var delimiterMatcher = tokenMatcher(delimiter);

            do {

                if (this.pos >= this.input.length) {
                    return content;
                }

                input_char = this.input.charAt(this.pos);
                this.pos++;

                if (this.Utils.in_array(input_char, this.Utils.whitespace)) {
                    if (!space) {
                        this.line_char_count--;
                        continue;
                    }
                    if (input_char === '\n' || input_char === '\r') {
                        content += '\n';
                        /*  Don't change tab indention for unformatted blocks.  If using code for html editing, this will greatly affect <pre> tags if they are specified in the 'unformatted array'
            for (var i=0; i<this.indent_level; i++) {
              content += this.indent_string;
            }
            space = false; //...and make sure other indentation is erased
            */
                        this.line_char_count = 0;
                        continue;
                    }
                }
                content += input_char;
                delimiterMatcher.add(input_char);
                this.line_char_count++;
                space = true;

                if (indent_handlebars && input_char === '{' && content.length && content.charAt(content.length - 2) === '{') {
                    // Handlebars expressions in strings should also be unformatted.
                    content += this.get_unformatted('}}');
                    // Don't consider when stopping for delimiters.
                }
            } while (delimiterMatcher.doesNotMatch());

            return content;
        };

        this.get_token = function() { //initial handler for token-retrieval
            var token;

            if (this.last_token === 'TK_TAG_SCRIPT' || this.last_token === 'TK_TAG_STYLE') { //check if we need to format javascript
                var type = this.last_token.substr(7);
                token = this.get_contents_to(type);
                if (typeof token !== 'string') {
                    return token;
                }
                return [token, 'TK_' + type];
            }
            if (this.current_mode === 'CONTENT') {
                token = this.get_content();
                if (typeof token !== 'string') {
                    return token;
                } else {
                    return [token, 'TK_CONTENT'];
                }
            }

            if (this.current_mode === 'TAG') {
                token = this.get_tag();
                if (typeof token !== 'string') {
                    return token;
                } else {
                    var tag_name_type = 'TK_TAG_' + this.tag_type;
                    return [token, tag_name_type];
                }
            }
        };

        this.get_full_indent = function(level) {
            level = this.indent_level + level || 0;
            if (level < 1) {
                return '';
            }

            return Array(level + 1).join(this.indent_string);
        };

        this.is_unformatted = function(tag_check, unformatted) {
            //is this an HTML5 block-level link?
            if (!this.Utils.in_array(tag_check, unformatted)) {
                return false;
            }

            if (tag_check.toLowerCase() !== 'a' || !this.Utils.in_array('a', unformatted)) {
                return true;
            }

            //at this point we have an  tag; is its first child something we want to remain
            //unformatted?
            var next_tag = this.get_tag(true /* peek. */ );

            // test next_tag to see if it is just html tag (no external content)
            var tag = (next_tag || "").match(/^\s*<\s*\/?([a-z]*)\s*[^>]*>\s*$/);

            // if next_tag comes back but is not an isolated tag, then
            // let's treat the 'a' tag as having content
            // and respect the unformatted option
            if (!tag || this.Utils.in_array(tag[1], unformatted)) {
                return true;
            } else {
                return false;
            }
        };

        this.printer = function(js_source, indent_character, indent_size, wrap_line_length, brace_style) { //handles input/output and some other printing functions

            this.input = js_source || ''; //gets the input for the Parser

            // HACK: newline parsing inconsistent. This brute force normalizes the input.
            this.input = this.input.replace(/\r\n|[\r\u2028\u2029]/g, '\n');

            this.output = [];
            this.indent_character = indent_character;
            this.indent_string = '';
            this.indent_size = indent_size;
            this.brace_style = brace_style;
            this.indent_level = 0;
            this.wrap_line_length = wrap_line_length;
            this.line_char_count = 0; //count to see if wrap_line_length was exceeded

            for (var i = 0; i < this.indent_size; i++) {
                this.indent_string += this.indent_character;
            }

            this.print_newline = function(force, arr) {
                this.line_char_count = 0;
                if (!arr || !arr.length) {
                    return;
                }
                if (force || (arr[arr.length - 1] !== '\n')) { //we might want the extra line
                    if ((arr[arr.length - 1] !== '\n')) {
                        arr[arr.length - 1] = rtrim(arr[arr.length - 1]);
                    }
                    arr.push('\n');
                }
            };

            this.print_indentation = function(arr) {
                for (var i = 0; i < this.indent_level; i++) {
                    arr.push(this.indent_string);
                    this.line_char_count += this.indent_string.length;
                }
            };

            this.print_token = function(text) {
                // Avoid printing initial whitespace.
                if (this.is_whitespace(text) && !this.output.length) {
                    return;
                }
                if (text || text !== '') {
                    if (this.output.length && this.output[this.output.length - 1] === '\n') {
                        this.print_indentation(this.output);
                        text = ltrim(text);
                    }
                }
                this.print_token_raw(text);
            };

            this.print_token_raw = function(text) {
                // If we are going to print newlines, truncate trailing
                // whitespace, as the newlines will represent the space.
                if (this.newlines > 0) {
                    text = rtrim(text);
                }

                if (text && text !== '') {
                    if (text.length > 1 && text.charAt(text.length - 1) === '\n') {
                        // unformatted tags can grab newlines as their last character
                        this.output.push(text.slice(0, -1));
                        this.print_newline(false, this.output);
                    } else {
                        this.output.push(text);
                    }
                }

                for (var n = 0; n < this.newlines; n++) {
                    this.print_newline(n > 0, this.output);
                }
                this.newlines = 0;
            };

            this.indent = function() {
                this.indent_level++;
            };

            this.unindent = function() {
                if (this.indent_level > 0) {
                    this.indent_level--;
                }
            };
        };
        return this;
    }

    /*_____________________--------------------_____________________*/

    this.beautify = function() {
        multi_parser = new Parser(); //wrapping functions Parser
        multi_parser.printer(html_source, indent_character, indent_size, wrap_line_length, brace_style); //initialize starting values
        while (true) {
            var t = multi_parser.get_token();
            multi_parser.token_text = t[0];
            multi_parser.token_type = t[1];

            if (multi_parser.token_type === 'TK_EOF') {
                break;
            }

            switch (multi_parser.token_type) {
                case 'TK_TAG_START':
                    multi_parser.print_newline(false, multi_parser.output);
                    multi_parser.print_token(multi_parser.token_text);
                    if (multi_parser.indent_content) {
                        if ((multi_parser.indent_body_inner_html || !multi_parser.token_text.match(/<body(?:.*)>/)) &&
                            (multi_parser.indent_head_inner_html || !multi_parser.token_text.match(/<head(?:.*)>/))) {

                            multi_parser.indent();
                        }

                        multi_parser.indent_content = false;
                    }
                    multi_parser.current_mode = 'CONTENT';
                    break;
                case 'TK_TAG_STYLE':
                case 'TK_TAG_SCRIPT':
                    multi_parser.print_newline(false, multi_parser.output);
                    multi_parser.print_token(multi_parser.token_text);
                    multi_parser.current_mode = 'CONTENT';
                    break;
                case 'TK_TAG_END':
                    //Print new line only if the tag has no content and has child
                    if (multi_parser.last_token === 'TK_CONTENT' && multi_parser.last_text === '') {
                        var tag_name = (multi_parser.token_text.match(/\w+/) || [])[0];
                        var tag_extracted_from_last_output = null;
                        if (multi_parser.output.length) {
                            tag_extracted_from_last_output = multi_parser.output[multi_parser.output.length - 1].match(/(?:<|{{#)\s*(\w+)/);
                        }
                        if (tag_extracted_from_last_output === null ||
                            (tag_extracted_from_last_output[1] !== tag_name && !multi_parser.Utils.in_array(tag_extracted_from_last_output[1], unformatted))) {
                            multi_parser.print_newline(false, multi_parser.output);
                        }
                    }
                    multi_parser.print_token(multi_parser.token_text);
                    multi_parser.current_mode = 'CONTENT';
                    break;
                case 'TK_TAG_SINGLE':
                    // Don't add a newline before elements that should remain unformatted.
                    var tag_check = multi_parser.token_text.match(/^\s*<([a-z-]+)/i);
                    if (!tag_check || !multi_parser.Utils.in_array(tag_check[1], unformatted)) {
                        multi_parser.print_newline(false, multi_parser.output);
                    }
                    multi_parser.print_token(multi_parser.token_text);
                    multi_parser.current_mode = 'CONTENT';
                    break;
                case 'TK_TAG_HANDLEBARS_ELSE':
                    // Don't add a newline if opening {{#if}} tag is on the current line
                    var foundIfOnCurrentLine = false;
                    for (var lastCheckedOutput = multi_parser.output.length - 1; lastCheckedOutput >= 0; lastCheckedOutput--) {
                        if (multi_parser.output[lastCheckedOutput] === '\n') {
                            break;
                        } else {
                            if (multi_parser.output[lastCheckedOutput].match(/{{#if/)) {
                                foundIfOnCurrentLine = true;
                                break;
                            }
                        }
                    }
                    if (!foundIfOnCurrentLine) {
                        multi_parser.print_newline(false, multi_parser.output);
                    }
                    multi_parser.print_token(multi_parser.token_text);
                    if (multi_parser.indent_content) {
                        multi_parser.indent();
                        multi_parser.indent_content = false;
                    }
                    multi_parser.current_mode = 'CONTENT';
                    break;
                case 'TK_TAG_HANDLEBARS_COMMENT':
                    multi_parser.print_token(multi_parser.token_text);
                    multi_parser.current_mode = 'TAG';
                    break;
                case 'TK_CONTENT':
                    multi_parser.print_token(multi_parser.token_text);
                    multi_parser.current_mode = 'TAG';
                    break;
                case 'TK_STYLE':
                case 'TK_SCRIPT':
                    if (multi_parser.token_text !== '') {
                        multi_parser.print_newline(false, multi_parser.output);
                        var text = multi_parser.token_text,
                            _beautifier,
                            script_indent_level = 1;
                        if (multi_parser.token_type === 'TK_SCRIPT') {
                            _beautifier = typeof js_beautify === 'function' && js_beautify;
                        } else if (multi_parser.token_type === 'TK_STYLE') {
                            _beautifier = typeof css_beautify === 'function' && css_beautify;
                        }

                        if (options.indent_scripts === "keep") {
                            script_indent_level = 0;
                        } else if (options.indent_scripts === "separate") {
                            script_indent_level = -multi_parser.indent_level;
                        }

                        var indentation = multi_parser.get_full_indent(script_indent_level);
                        if (_beautifier) {

                            // call the Beautifier if avaliable
                            var Child_options = function() {
                                this.eol = '\n';
                            };
                            Child_options.prototype = options;
                            var child_options = new Child_options();
                            text = _beautifier(text.replace(/^\s*/, indentation), child_options);
                        } else {
                            // simply indent the string otherwise
                            var white = text.match(/^\s*/)[0];
                            var _level = white.match(/[^\n\r]*$/)[0].split(multi_parser.indent_string).length - 1;
                            var reindent = multi_parser.get_full_indent(script_indent_level - _level);
                            text = text.replace(/^\s*/, indentation)
                                .replace(/\r\n|\r|\n/g, '\n' + reindent)
                                .replace(/\s+$/, '');
                        }
                        if (text) {
                            multi_parser.print_token_raw(text);
                            multi_parser.print_newline(true, multi_parser.output);
                        }
                    }
                    multi_parser.current_mode = 'TAG';
                    break;
                default:
                    // We should not be getting here but we don't want to drop input on the floor
                    // Just output the text and move on
                    if (multi_parser.token_text !== '') {
                        multi_parser.print_token(multi_parser.token_text);
                    }
                    break;
            }
            multi_parser.last_token = multi_parser.token_type;
            multi_parser.last_text = multi_parser.token_text;
        }
        var sweet_code = multi_parser.output.join('').replace(/[\r\n\t ]+$/, '');

        // establish end_with_newline
        if (end_with_newline) {
            sweet_code += '\n';
        }

        if (eol !== '\n') {
            sweet_code = sweet_code.replace(/[\n]/g, eol);
        }

        return sweet_code;
    };
}

module.exports.Beautifier = Beautifier;


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* jshint curly: false */
// This section of code is taken from acorn.
//
// Acorn was written by Marijn Haverbeke and released under an MIT
// license. The Unicode regexps (for identifiers and whitespace) were
// taken from [Esprima](http://esprima.org) by Ariya Hidayat.
//
// Git repositories for Acorn are available at
//
//     http://marijnhaverbeke.nl/git/acorn
//     https://github.com/marijnh/acorn.git

// ## Character categories

// Big ugly regular expressions that match characters in the
// whitespace, identifier, and identifier-start categories. These
// are only applied when a character is found to actually have a
// code point above 128.

var nonASCIIwhitespace = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/; // jshint ignore:line
var nonASCIIidentifierStartChars = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u08a0\u08a2-\u08ac\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097f\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c33\u0c35-\u0c39\u0c3d\u0c58\u0c59\u0c60\u0c61\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d60\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f0\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191c\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19c1-\u19c7\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1ce9-\u1cec\u1cee-\u1cf1\u1cf5\u1cf6\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2e2f\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309d-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fcc\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua697\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790-\ua793\ua7a0-\ua7aa\ua7f8-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa80-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uabc0-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc";
var nonASCIIidentifierChars = "\u0300-\u036f\u0483-\u0487\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u0620-\u0649\u0672-\u06d3\u06e7-\u06e8\u06fb-\u06fc\u0730-\u074a\u0800-\u0814\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0840-\u0857\u08e4-\u08fe\u0900-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962-\u0963\u0966-\u096f\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09d7\u09df-\u09e0\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a66-\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2-\u0ae3\u0ae6-\u0aef\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b56\u0b57\u0b5f-\u0b60\u0b66-\u0b6f\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0be6-\u0bef\u0c01-\u0c03\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62-\u0c63\u0c66-\u0c6f\u0c82\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2-\u0ce3\u0ce6-\u0cef\u0d02\u0d03\u0d46-\u0d48\u0d57\u0d62-\u0d63\u0d66-\u0d6f\u0d82\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0df2\u0df3\u0e34-\u0e3a\u0e40-\u0e45\u0e50-\u0e59\u0eb4-\u0eb9\u0ec8-\u0ecd\u0ed0-\u0ed9\u0f18\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f41-\u0f47\u0f71-\u0f84\u0f86-\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u1000-\u1029\u1040-\u1049\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f-\u109d\u135d-\u135f\u170e-\u1710\u1720-\u1730\u1740-\u1750\u1772\u1773\u1780-\u17b2\u17dd\u17e0-\u17e9\u180b-\u180d\u1810-\u1819\u1920-\u192b\u1930-\u193b\u1951-\u196d\u19b0-\u19c0\u19c8-\u19c9\u19d0-\u19d9\u1a00-\u1a15\u1a20-\u1a53\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1b46-\u1b4b\u1b50-\u1b59\u1b6b-\u1b73\u1bb0-\u1bb9\u1be6-\u1bf3\u1c00-\u1c22\u1c40-\u1c49\u1c5b-\u1c7d\u1cd0-\u1cd2\u1d00-\u1dbe\u1e01-\u1f15\u200c\u200d\u203f\u2040\u2054\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2d81-\u2d96\u2de0-\u2dff\u3021-\u3028\u3099\u309a\ua640-\ua66d\ua674-\ua67d\ua69f\ua6f0-\ua6f1\ua7f8-\ua800\ua806\ua80b\ua823-\ua827\ua880-\ua881\ua8b4-\ua8c4\ua8d0-\ua8d9\ua8f3-\ua8f7\ua900-\ua909\ua926-\ua92d\ua930-\ua945\ua980-\ua983\ua9b3-\ua9c0\uaa00-\uaa27\uaa40-\uaa41\uaa4c-\uaa4d\uaa50-\uaa59\uaa7b\uaae0-\uaae9\uaaf2-\uaaf3\uabc0-\uabe1\uabec\uabed\uabf0-\uabf9\ufb20-\ufb28\ufe00-\ufe0f\ufe20-\ufe26\ufe33\ufe34\ufe4d-\ufe4f\uff10-\uff19\uff3f";
var nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]");
var nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]");

// Whether a single character denotes a newline.

exports.newline = /[\n\r\u2028\u2029]/;

// Matches a whole line break (where CRLF is considered a single
// line break). Used to count lines.

// in javascript, these two differ
// in python they are the same, different methods are called on them
exports.lineBreak = new RegExp('\r\n|' + exports.newline.source);
exports.allLineBreaks = new RegExp(exports.lineBreak.source, 'g');


// Test whether a given character code starts an identifier.

exports.isIdentifierStart = function(code) {
    // permit $ (36) and @ (64). @ is used in ES7 decorators.
    if (code < 65) return code === 36 || code === 64;
    // 65 through 91 are uppercase letters.
    if (code < 91) return true;
    // permit _ (95).
    if (code < 97) return code === 95;
    // 97 through 123 are lowercase letters.
    if (code < 123) return true;
    return code >= 0xaa && nonASCIIidentifierStart.test(String.fromCharCode(code));
};

// Test whether a given character is part of an identifier.

exports.isIdentifierChar = function(code) {
    if (code < 48) return code === 36;
    if (code < 58) return true;
    if (code < 65) return false;
    if (code < 91) return true;
    if (code < 97) return code === 95;
    if (code < 123) return true;
    return code >= 0xaa && nonASCIIidentifier.test(String.fromCharCode(code));
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*jshint curly:true, eqeqeq:true, laxbreak:true, noempty:false */
/*

    The MIT License (MIT)

    Copyright (c) 2007-2017 Einar Lielmanis, Liam Newman, and contributors.

    Permission is hereby granted, free of charge, to any person
    obtaining a copy of this software and associated documentation files
    (the "Software"), to deal in the Software without restriction,
    including without limitation the rights to use, copy, modify, merge,
    publish, distribute, sublicense, and/or sell copies of the Software,
    and to permit persons to whom the Software is furnished to do so,
    subject to the following conditions:

    The above copyright notice and this permission notice shall be
    included in all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
    EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
    NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
    BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
    ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
    CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    SOFTWARE.
*/

function mergeOpts(allOptions, targetType) {
    var finalOpts = {};
    var name;

    for (name in allOptions) {
        if (name !== targetType) {
            finalOpts[name] = allOptions[name];
        }
    }

    //merge in the per type settings for the targetType
    if (targetType in allOptions) {
        for (name in allOptions[targetType]) {
            finalOpts[name] = allOptions[targetType][name];
        }
    }
    return finalOpts;
}

module.exports.mergeOpts = mergeOpts;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/*jshint curly:true, eqeqeq:true, laxbreak:true, noempty:false */
/*

    The MIT License (MIT)

    Copyright (c) 2007-2017 Einar Lielmanis, Liam Newman, and contributors.

    Permission is hereby granted, free of charge, to any person
    obtaining a copy of this software and associated documentation files
    (the "Software"), to deal in the Software without restriction,
    including without limitation the rights to use, copy, modify, merge,
    publish, distribute, sublicense, and/or sell copies of the Software,
    and to permit persons to whom the Software is furnished to do so,
    subject to the following conditions:

    The above copyright notice and this permission notice shall be
    included in all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
    EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
    NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
    BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
    ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
    CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    SOFTWARE.
*/

var Beautifier = __webpack_require__(0).Beautifier;

function style_html(html_source, options, js_beautify, css_beautify) {
    var beautifier = new Beautifier(html_source, options, js_beautify, css_beautify);
    return beautifier.beautify();
}

module.exports = style_html;

/***/ })
/******/ ]);
var style_html = legacy_beautify_html;
/* Footer */
if (true) {
    // Add support for AMD ( https://github.com/amdjs/amdjs-api/wiki/AMD#defineamd-property- )
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, __webpack_require__(542), __webpack_require__(541)], __WEBPACK_AMD_DEFINE_RESULT__ = function(requireamd) {
        var js_beautify = __webpack_require__(542);
        var css_beautify = __webpack_require__(541);

        return {
            html_beautify: function(html_source, options) {
                return style_html(html_source, options, js_beautify.js_beautify, css_beautify.css_beautify);
            }
        };
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof exports !== "undefined") {
    // Add support for CommonJS. Just put this file somewhere on your require.paths
    // and you will be able to `var html_beautify = require("beautify").html_beautify`.
    var js_beautify = require('./beautify.js');
    var css_beautify = require('./beautify-css.js');

    exports.html_beautify = function(html_source, options) {
        return style_html(html_source, options, js_beautify.js_beautify, css_beautify.css_beautify);
    };
} else if (typeof window !== "undefined") {
    // If we're running a web page and don't have either of the above, add our one global
    window.html_beautify = function(html_source, options) {
        return style_html(html_source, options, window.js_beautify, window.css_beautify);
    };
} else if (typeof global !== "undefined") {
    // If we don't even have window, try global.
    global.html_beautify = function(html_source, options) {
        return style_html(html_source, options, global.js_beautify, global.css_beautify);
    };
}

}());


/***/ }),
/* 2387 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 2388 */
/***/ (function(module, exports) {

module.exports = {"language":"zh","profile":"cube"}

/***/ }),
/* 2389 */
/***/ (function(module, exports) {

module.exports = {"apiBase":"/v1","wsBase":"/v1"}

/***/ }),
/* 2390 */
/***/ (function(module, exports) {

module.exports = {"apiBase":"http://139.198.125.57:4880/v1","wsBase":"ws://192.168.32.52/v1","profile":"cube"}

/***/ }),
/* 2391 */
/***/ (function(module, exports) {

module.exports = {"links":[{"domain":"163.com","link":"mail.163.com"},{"domain":"vip.163.com","link":"vip.163.com"},{"domain":"126.com","link":"mail.126.com"},{"domain":"qq.com","link":"mail.qq.com"},{"domain":"vip.qq.com","link":"mail.qq.com"},{"domain":"foxmail.com","link":"mail.qq.com"},{"domain":"gmail.com","link":"mail.google.com"},{"domain":"sohu.com","link":"mail.sohu.com"},{"domain":"tom.com","link":"mail.tom.com"},{"domain":"vip.sina.com","link":"vip.sina.com"},{"domain":"sina.com.cn","link":"mail.sina.com.cn"},{"domain":"sina.com","link":"mail.sina.com.cn"},{"domain":"yahoo.com.cn","link":"mail.cn.yahoo.com"},{"domain":"yahoo.cn","link":"mail.cn.yahoo.com"},{"domain":"yahoo.com","link":"mail.yahoo.com"},{"domain":"yeah.net","link":"www.yeah.net"},{"domain":"21cn.com","link":"mail.21cn.com"},{"domain":"hotmail.com","link":"www.hotmail.com"},{"domain":"sogou.com","link":"mail.sogou.com"},{"domain":"188.com","link":"www.188.com"},{"domain":"139.com","link":"mail.10086.cn"},{"domain":"189.cn","link":"webmail15.189.cn/webmail"},{"domain":"wo.com.cn","link":"mail.wo.com.cn/smsmail"},{"domain":"139.com","link":"139.com"}]}

/***/ }),
/* 2392 */
/***/ (function(module, exports) {

module.exports = {"links":[{"domain":"163.com","link":"mail.163.com"},{"domain":"vip.163.com","link":"vip.163.com"},{"domain":"126.com","link":"mail.126.com"},{"domain":"qq.com","link":"mail.qq.com"},{"domain":"vip.qq.com","link":"mail.qq.com"},{"domain":"foxmail.com","link":"mail.qq.com"},{"domain":"gmail.com","link":"mail.google.com"},{"domain":"sohu.com","link":"mail.sohu.com"},{"domain":"tom.com","link":"mail.tom.com"},{"domain":"vip.sina.com","link":"vip.sina.com"},{"domain":"sina.com.cn","link":"mail.sina.com.cn"},{"domain":"sina.com","link":"mail.sina.com.cn"},{"domain":"yahoo.com.cn","link":"mail.cn.yahoo.com"},{"domain":"yahoo.cn","link":"mail.cn.yahoo.com"},{"domain":"yahoo.com","link":"mail.yahoo.com"},{"domain":"yeah.net","link":"www.yeah.net"},{"domain":"21cn.com","link":"mail.21cn.com"},{"domain":"hotmail.com","link":"www.hotmail.com"},{"domain":"sogou.com","link":"mail.sogou.com"},{"domain":"188.com","link":"www.188.com"},{"domain":"139.com","link":"mail.10086.cn"},{"domain":"189.cn","link":"webmail15.189.cn/webmail"},{"domain":"wo.com.cn","link":"mail.wo.com.cn/smsmail"},{"domain":"139.com","link":"139.com"}]}

/***/ }),
/* 2393 */
/***/ (function(module, exports) {

module.exports = {"lora.E.FE_EMPTY":"Cannot be empty","alerts.stateParameter.fail":"fail","alerts.stateParameter.success":"successfully","app.device.mac.label":"MAC command","app.device.mac.modal.button1":"close","app.device.mac.modal.button2":"send","app.device.mac.modal.content":"Whether to transmit the command?","app.device.mac.panel.label1":"MAC command","app.device.mac.panel.label2.button":"check queue","app.device.macLog.label":"MAC command log","ApplySuccess.ApplySuccess":"developer application is successful.","ApplySuccess.ApplySuccessTip":"Thank you for submitting the application, we will review the relevant information as soon as possible.","BaiduMap.label.gatewayId":"gateway id:","commmonModal.simpleModal.button.cancel":"cancel","DashboardForm.onClose":"close","deviceDetail.breadcrumbs.device":"My Devices","DeviceList.menu.batchImport":"batch importing","DeviceList.menu.createDev":"Automatic generation","DeviceList.menu.importABP":"importing ABP device","DeviceList.menu.importOTAA":"importing OTAA device","DeviceList.result.active":"active","DeviceList.result.unActive":"inactive","DeviceList.select.devStatusActive":"active","DeviceList.select.devStatusInActive":"inactive","DeviceList.tip.createDevFail":"Add device failed","DeviceList.tip.createDevSuccess":"Add device success!","DeviceList.tip.deleteSuccess":"deletion is finished","DeviceList.tip.overDevNum":"Quata is exceeded!","forgetPassword.panel.button":"submit","forgetPassword.panel.label1":"mailbox","forgetPassword.panel.label2":"verification code","forgetPassword.respond1":"After a few minutes, you will receive a reset password by email.","forgetPassword.respond2":"Retrieve your password?","forgetPassword.respond3":"login","forgetPassword.respond4":"The message sent failed,and please check the e-mail address or the input of the graphics verification code is correct.","forgetPassword.title1":"Forget Password","gateway":"Gateway","InlineEditComponent.button.edit":"edit","LabelReset.button.devReset":"reset","LabelReset.resetReady":"reset done","lora.button.cancel":"Cancel","lora.button.confirm":"Confirm","lora.button.edit":"Edit","lora.coms.pagesizer.postfix":"/ Page","lora.coms.refresher.pinned.tooltip":"Auto refreshing","lora.coms.refresher.tooltip":"Double click to auto refresh","lora.coms.copy.copied":"Copied","lora.coms.copy.copy":"Copy","lora.coms.collapsetoggle.expand":"Expand","lora.coms.collapsetoggle.collapse":"Collapse","lora.datadir.down":"Downlink","lora.datadir.up":"Uplink","lora.device.err.outofquota":"Out of device quota.","lora.emptyval":"empty","lora.error.badappkey":"Bad AppKey","lora.error.badappskey":"Bad AppSKey","lora.error.baddevaddr":"Bad DevAddr","lora.error.baddeveui":"Bad DevEUI","lora.error.badmacaddr":"Bad MAC Address","lora.error.badnwkskey":"Bad NwkSKey","lora.error.cannotbeempty":"Cannot be empty","lora.error.devaddrunavail":"DevAddr occupied","lora.error.deveuiconflict":"DevEUI conflicts","lora.error.deveuiunavail":"DevEUI occupied","lora.error.generalerror":"Server error","lora.error.integer.nan":"Not a number","lora.error.integer.toolarge":"Value out of upper bound","lora.error.integer.toolow":"Value out of lower bound","lora.error.invalidformat":"Invalid format","lora.error.macaddrunavail":"MAC Address occupied","lora.error.unknown":"Network error","lora.pageerror.default.title":"Network error","lora.pageerror.default.description":"Try refreshing the page","lora.nav.application":"Application","lora.nav.billing":"Billing","lora.nav.documentation":"Documentation","lora.nav.gateway":"Gateway","lora.nav.network":"Network","lora.nav.overview":"Overview","lora.nav.dashboard":"Dashboard","lora.tooltip.copy":"Copy to clipboard","lora.tooltip.edit":"Edit","lora.tooltip.viewdetail":"View detail","lora.trial.noperm":"You are currently trial user, no permission","lora.noperm":"No permission","lora.noperm.undercomm.trial":"You are currently in a trial plan.","lora.noperm.undercomm.upgrade":"Upgrade","lora.noperm.undercomm.upgradeto":" to a enterprise plan or a development service package to unlock this feature.","lora.data.field.bandwidth":"Bandwidth","lora.data.field.channel":"Channel","lora.data.field.data":"Data","lora.data.field.deveui":"DevEUI","lora.data.field.frameno":"Seq No.","lora.data.field.frequency":"Frequency(MHZ)","lora.data.field.msgtype":"Message Type","lora.data.field.size":"Length","lora.data.field.time":"Time","lora.data.field.gateway":"Gateway","lora.data.field.gwname":"Gateway Name","lora.data.field.devname":"Device Name","Mac.valid.number":"input {min}~{max} integer","newRegisterSuccess.h1":"Congratulations on your successful registration, Aisenz will serve you faithfully","newRegisterSuccess.loginbtn":"Login","newRegisterSuccess.row1.title":"registration is successful","newRegisterSuccess.row2.content1":"Congratulations on your registration, please click ","newRegisterSuccess.row2.content2":"login","ParserErr.button.close":"close","ParserErr.message.tip":"The chart  needs JSON format data source generated by the parser.   Please refer to the example below:","ReduxFormModal.button.cancel":"cancel","resetPassword.resetSuccess.respond":"reset the password successfully","resetPassword.row1.title":"reset password","SubAccount.adminUser":"administrator","SubAccount.boxHead.subAccountManage":"Child Account Management","SubAccount.button.addSub":"add child account","SubAccount.button.edit":"edit","SubAccount.modalTitle.deleteSubAccount":"delete child account","SubAccount.modalTitle.sureToDel":"Are you sure to delete this child account?","SubAccount.nothing":"none","SubAccount.th.del":"delete","SubAccount.th.email":"email","SubAccount.th.Jurisdiction":"rights","SubAccount.th.name":"name","SubAccount.user":"user","Token.alert.delTokenTip":"Can not delete tokens in use!","Token.boxHead.tokenManage":"Token management","Token.button.addToken":"add Token","Token.modal.SimpleModalTitle":"delete Token","Token.modal.submitTitle":"delete","Token.modal.sureToDel":"Are you sure to delete this token？","Token.tip.addTipFailed":"Add failed,out of quota!","Token.tip.addTipSuccess":"Add success!","Token.tip.deleteTokenFailed":"Can not delete tokens in use!","Token.tip.deleteTokenSuccess":"delete success","Token.tip.failed":"fail!","Token.tip.modifyAs":"modify as","Token.tip.success":"success!","Token.tipTitle.addTip":"Add prompt","Token.tipTitle.deleteTokenTip":"delete prompt","Token.tipTitle.editTip":"Modify prompt","TokenTable.button.deleteToken":"delete","TokenTable.button.edit":"edit","TokenTable.th.name":"name","TokenTable.th.operater":"operation","selectgateway.name":"Name","selectgateway.mac":"MAC Address","selectgateway.status":"Status","selectgateway.connected":"Connected","selectgateway.disconnected":"Disconnected","selectgateway.confirm":"Confirm","selectgateway.title":"Select Gateway","selectgateway.search.placeholder":"Enter to search","selectgateway.lat":"Latitude","selectgateway.lng":"Longitude","selectgateway.tips":"Latitude and longitude are use for marking on the map","accountcenter.info":"Information","accountcenter.infoview.basic.company":"Company","accountcenter.infoview.basic.email":"Email","accountcenter.infoview.basic.name":"Name","accountcenter.infoview.basic.newpassword":"New Password","accountcenter.infoview.basic.oldpassword":"Old Password","accountcenter.infoview.basic.repeatpassword":"Repeat New Password","accountcenter.infoview.basic.telephone":"Telephone","accountcenter.infoview.basic.title":"My Information","accountcenter.infoview.basic.login":"Login User","accountcenter.infoview.button.changepassword":"Change Password","accountcenter.infoview.changepwd.toolbarbutton.beback":"Back","accountcenter.infoview.changepwd.toolbarnav.basicinfo":"My Information","accountcenter.infoview.changepwd.toolbarnav.changepwd":"Change Password","accountcenter.infoview.edit":"Edit","accountcenter.infoview.error.newpassword":"New password should be input first","accountcenter.infoview.error.newpasswordsame":"The new password can not consistent with the old password","accountcenter.infoview.error.null":"Cannot be empty","accountcenter.infoview.error.password":"Password's length should be 6-16 bit","accountcenter.infoview.error.repeatpassword":"Inconsistent with the new password","accountcenter.infoview.expiration":"Expiration Time","accountcenter.infoview.expiration.unit":"day","accountcenter.infoview.expiration.units":"days","accountcenter.infoview.help.newpassword":"Enter a new password for the 6-16 bit character","accountcenter.infoview.help.repeatpassword":"Keep in line with the new password","accountcenter.infoview.link.changepassword":"change password","accountcenter.infoview.placeholder.newpassword":"Can be composed of numbers, letters, and symbols","accountcenter.infoview.placeholder.oldpassword":"Input old password","accountcenter.infoview.placeholder.repeatpassword":"Repeat new password again","accountcenter.infoview.plan.balance":"Balance","accountcenter.infoview.plan.billday":"Bill date","accountcenter.infoview.plan.commuser":"Enterprise user","accountcenter.infoview.plan.recharge":"Recharge","accountcenter.infoview.plan.rmbyuan":"Yuan","accountcenter.infoview.plan.svcpackuser":"Service package user","accountcenter.infoview.plan.tier":"Plan","accountcenter.infoview.plan.title":"Billing Infomation","accountcenter.infoview.plan.trialuser":"Free user","accountcenter.infoview.plan.upgrade":"Upgrade","accountcenter.infoview.quota.lrappnum":"Applications Quota","accountcenter.infoview.quota.lrgatewaynum":"Gateways Quota","accountcenter.infoview.quota.lrnodenum":"Devices Quota","accountcenter.infoview.quota.title":"Resource Quota","accountcenter.infoview.toolbar.title":"Account Information","accountcenter.management":"Management","accountcenter.manageview.adderrtip.addfail":"Add Failed!","accountcenter.manageview.adderrtip.quota":"Out of quota","accountcenter.manageview.addmodaltip":"Add Token","accountcenter.manageview.button.createtoken":"Add","accountcenter.manageview.button.subaccount":"Sub Account","accountcenter.manageview.deletetip.confirmdelete":"confirm to delete Token","accountcenter.manageview.deletetip.deletetoken":"delete Token","accountcenter.manageview.deletetokentip":"Delete failed, can not delete tokens in use!","accountcenter.manageview.deletetokentipcommon":"Delete failed!","accountcenter.manageview.error.invalidformat":"Invalid format","accountcenter.manageview.error.null":"Cannot be empty","accountcenter.manageview.label.email":"Email","accountcenter.manageview.label.jurisdiction":"Jurisdiction","accountcenter.manageview.label.name":"Name","accountcenter.manageview.label.password":"Password","accountcenter.manageview.modal.delete":"delete sub-account","accountcenter.manageview.modal.deleteconfirm":"Confirm to delete sub-account","accountcenter.manageview.modalheader":"Delete Token","accountcenter.manageview.modaltitle":"Add Token Failed!","accountcenter.manageview.option.administrator":"Administrator","accountcenter.manageview.option.jurisdiction":"No permissions","accountcenter.manageview.option.user":"User","accountcenter.manageview.placeholder.email":"Input sub-account's email","accountcenter.manageview.placeholder.jurisdiction":"Select the sub-account's permissions","accountcenter.manageview.placeholder.name":"Input sub-account's name","accountcenter.manageview.placeholder.password":"Input sub-account's password","accountcenter.manageview.placeholder.token.name":"Should be a description of token","accountcenter.manageview.tablecolumn.createtime":"Create Time","accountcenter.manageview.tablecolumn.email":"Email","accountcenter.manageview.tablecolumn.jurisdiction":"Jurisdiction","accountcenter.manageview.tablecolumn.name":"Name","accountcenter.manageview.tablecolumn.edit":"Edit","accountcenter.manageview.tablecolumn.delete":"Delete","accountcenter.manageview.tablecolumn.operation":"Operation","accountcenter.manageview.title.subaccount":"Sub Account Management","accountcenter.manageview.title.token":"Token Management","accountcenter.manageview.E.FE_EMPTY":"Cannot be empty","accountcenter.security":"Security","accountcenter.securityview.changepwd.newpwd":"New password","accountcenter.securityview.changepwd.newpwd.repeat":"Verify password","accountcenter.securityview.changepwd.oldpwd":"Current password","accountcenter.securityview.changepwd.title":"Change Password","accountcenter.securityview.changepwd.submit":"Change","accountcenter.securityview.changepwd.success":"Change success","accountcenter.securityview.changepwd.failure":"Change failed","accountcenter.securityview.E.FE_EMPTY":"Cannot be empty","accountcenter.securityview.E.FE_NOTSAME":"New password and its verify is not the same","accountcenter.securityview.E.BADPASSWORD":"Current password wrong","accountcenter.securityview.E.PASSWORDPOLICY":"New password policy not met","accountcenter.securityview.E.FE_TOOSHORT":"The length of the new password must be greater than 6","accountcenter.securityview.E.FE_NOTCHANGED":"New password cannot be the same as the current password","accountcenter.title":"Account center","accountcenter.tokenmanagement":"Token","appdebug.chartview.breadcrumb.api":"API","appdebug.chartview.breadcrumb.chart":"Chart","appdebug.chartview.breadcrumb.paesedata":"Prase Data","appdebug.chartview.label.deveui":"DevEUI","appdebug.chartview.label.fport":"Fport","appdebug.chartview.parsererr.button.godecode":"Decode","appdebug.chartview.parsererr.viewtips":"View Tips","appdebug.chartview.parsererr.viewtipsnodata":"Data not reported","appdebug.chartview.placeholder.deveui":"Please choose deveui","appdebug.chartview.placeholder.fport":"Please choose fport","appdebug.chartview.websoketmes.button":"Reconnect","appdebug.chartview.websoketmes.chart":"Connection to WebSocket has been disconnected, can not get the latest data, please click on the button to reconnect","appdebug.detailview.apply":"Apply","appdebug.detailview.applyfailed":"Add Failed","appdebug.detailview.applysuccess":"Apply Success","appdebug.detailview.breadcrumb.detail":"detail","appdebug.detailview.button.close":"Close","appdebug.detailview.button.send":"Send","appdebug.detailview.button.sending":"Sending","appdebug.detailview.button.senddata":"Send Data","appdebug.detailview.button.send.success":"Send succeeded","appdebug.detailview.button.send.failure":"Send failed","appdebug.detailview.feedback.success":"Send succeeded","appdebug.detailview.E.DEVEUINOTFOUND":"deveui not exists","appdebug.detailview.E.SENDFAIL":"Send failed","appdebug.detailview.E.FE_INVALIDHEX":"Invalid Hex data","appdebug.detailview.errortip.errformat":"Invalid format","appdebug.detailview.E.FE_EMPTY":"Cannot be empty","appdebug.detailview.E.FE_INVALIDPORT":"Invalid port","appdebug.detailview.E.FE_INVALIDFMT":"Invalid format","appdebug.detailview.E.NOTFOUND":"Device not found","appdebug.detailview.label.content":"Content","appdebug.detailview.label.deveui":"DevEUI","appdebug.detailview.label.fport":"Fport","appdebug.detailview.label.encoding":"Data Type","appdebug.detailview.nav.api":"API","appdebug.detailview.props.title":"Interface","appdebug.detailview.props.apitype":"Type","appdebug.detailview.props.name":"Name","appdebug.detailview.props.remark":"Remark","appdebug.detailview.senddata.title":"Send data","appdebug.detailview.paneltitle.senddata":"Send Data","appdebug.detailview.parser":"Decoder","appdebug.detailview.placeholder.data.hex":"Enter hexadecimal numbers of an even length","appdebug.detailview.placeholder.data.text":"Enter text","appdebug.detailview.placeholder.fport":"Enter an integer within 1~255","appdebug.detailview.table.httptitle":"The latest 20 messages","appdebug.detailview.table.wstitle":"Real-time data","appdebug.detailview.data.gateway":"Gateway","appdebug.detailview.data.bandwidth":"Bandwidth","appdebug.detailview.data.coderate":"Code rate","appdebug.detailview.data.data":"Data","appdebug.detailview.data.fcnt":"SeqNo.","appdebug.detailview.data.frequency":"Frequency(MHZ)","appdebug.detailview.data.title":"Time","appdebug.detailview.toolbar.api":"API","appdebug.detailview.wsstatus.connecting":"WebSocket connection establishing...","appdebug.detailview.wsstatus.closed":"WebSocket interrupted, retry connecting...","appdebug.detailview.wsstatus.reconnecting":"Reconnecting...","appdebug.parserview.breadcrumb.title":"parse data","appdebug.parserview.toolbarbtn.chart":"Chart","appdebug.parserview.savescript":"Apply parser","appdebug.parserview.savescript.pending":"Applying","appdebug.parserview.savescript.success":"Apply succeeded","appdebug.parserview.nometrics":"No parsed metrics","appdebug.parserview.nometrics.desc":"Write a parser and apply it, the fields of the parsed object will be rendered here as metrics.","appdebug.sidebar.chart":"Chart","appdebug.sidebar.detail":"Detail","appdebug.sidebar.parsedata":"Parse Data","appdebug.sidebar.title":"API","appdebug.websocket.connect":"WebSocket reconnected!","appdebug.websocket.unconnect":"WebSocket disconnected, reconnecting...","application.addapp.appeui.label":"AppEUI","application.addapp.appname.label":"App Name","application.addapp.appname.placeholder":"Application name","application.addapp.btn":"Add Application","application.addapp.E.CONFLICT":"Duplicated AppEUI","application.addapp.E.FE_EMPTY":"Cannot be empty","application.addapp.E.FE_INVALID":"Invalid format","application.addapp.error.modalheader":"Add Application Error","application.addapp.error.outofquota.comm":"Sorry, you are out of app quota. Contact us for creating more.","application.addapp.error.outofquota.cube":"Sorry, you are out of app quota. Contact us for creating more.","application.addapp.error.outofquota.undercomm":"Sorry, you are out of app quota. Upgrade your plan to create more.","application.addapp.header":"Add Application","application.addapp.random":"Random","application.addapp.submit":"Add","application.addapp.submit.failure":"Add error","application.addapp.submit.pending":"Adding","application.addapp.submit.success":"Add success","application.addapp.upgrade.btn":"Upgrade","application.app.fields.devicenum":"Device Count","application.app.fields.name":"Name","application.app.fields.target":"Push Interface","application.app.fields.tokennum":"Interface Count","application.app.panelheader":"My Applications","application.app.search.placeholder":"Enter to search","application.breadcrumb.application":"My Applications","application.noapp":"No applications","applicationdetail.apiview.apidel.btn":"Delete","applicationdetail.apiview.apis.adderr.general":"Add new API error.","applicationdetail.apiview.apis.adderr.modalheader":"Add API Error","applicationdetail.apiview.apis.adderr.quota":"Out of API quota, contact us fo creating more.","applicationdetail.apiview.E.FE_EMPTY":"Cannot be empty","applicationdetail.apiview.help.content1":"LoraFlow default support for WebSocket and HTTP interface. Click 'generate new Token' to get access to URL. Click on the URL link to debug online.","applicationdetail.apiview.help.content2":"LoraFlow can also configure the push interface, push real-time data to senzFlow or third party application platform.","applicationdetail.apiview.help.content3":"For more information, please visit","applicationdetail.apiview.help.content3.link":"Application Documentation","applicationdetail.apiview.newtoken.btn":"New Interface","applicationdetail.apiview.noteedit.link":"Click to add note","applicationdetail.apiview.notokens":"No API Interface","applicationdetail.apiview.pushinterface.header":"Push Interface","applicationdetail.apiview.pushinterface.label":"Interface Type","applicationdetail.apiview.pushinterface.appdataonly.checkbox":"Send App Data Only","applicationdetail.apiview.pushinterface.cancel.btn":"Cancel","applicationdetail.apiview.pushinterface.edit.btn":"Edit","applicationdetail.apiview.pushinterface.save.btn":"Save","applicationdetail.apiview.pushinterface.E.UNKNOWN":"Network error","applicationdetail.apiview.pushinterface.E.GENERALERROR":"Server error","applicationdetail.apiview.showhelp.btn":"Help","applicationdetail.apiview.tokens.panelheader":"API Interfaces","applicationdetail.apiview.tooltip.debug":"Debug","applicationdetail.apiview.tooltip.note":"Notes","applicationdetail.app":"application","applicationdetail.batchimport.breadcrumb":"Batch Import","applicationdetail.batchimport.dropzone.text":"Click or drop file here to import","applicationdetail.batchimport.E.BADDEVEUI":"Bad DevEUI","applicationdetail.batchimport.E.DEVEUICONFLICT":"Duplicated DevEUI","applicationdetail.batchimport.E.DEVEUIUNAVAIL":"Duplicated DevEUI","applicationdetail.batchimport.E.DEVADDRUNAVAIL":"Duplicated DevAddr","applicationdetail.batchimport.E.BANDUNKNOWN":"Unknown band","applicationdetail.batchimport.err.modalheader":"Import Error","applicationdetail.batchimport.err.outofquota.comm":"Insufficient device quota. Try to import less devices, or contact us to upgrade your device quota.","applicationdetail.batchimport.err.outofquota.cube":"Insufficient device quota. Try to import less devices, or contact us to upgrade your device quota.","applicationdetail.batchimport.err.outofquota.undercomm":"Insufficient device quota. Try to import less devices, or upgrade your plan to increase your device quota.","applicationdetail.batchimport.help.abp":"Import ABP Devices","applicationdetail.batchimport.help.abp.thead.fieldname":"Field Name","applicationdetail.batchimport.help.abp.thead.length":"Length","applicationdetail.batchimport.help.abp.thead.mandatory":"Mandatory","applicationdetail.batchimport.help.abp.thead.remark":"Remark","applicationdetail.batchimport.help.otaa":"Import OTAA Devices","applicationdetail.batchimport.help.panelheader":"Batch Import Help","applicationdetail.batchimport.preview.cancel.btn":"Cancel","applicationdetail.batchimport.preview.canimport.tips.desc1":"Your device quota is ","applicationdetail.batchimport.preview.canimport.tips.desc2":", currently have ","applicationdetail.batchimport.preview.canimport.tips.desc3":", can at most import ","applicationdetail.batchimport.preview.canimport.tips.desc4":" devices. ","applicationdetail.batchimport.preview.import.btn.seg1":"Import","applicationdetail.batchimport.preview.import.btn.seg2":"devices","applicationdetail.batchimport.preview.required":"Required","applicationdetail.batchimport.preview.invalidvalue":"Invalid value","applicationdetail.batchimport.result.fail":"Failed","applicationdetail.batchimport.result.notimport":"Not Imported","applicationdetail.batchimport.result.succ":"Succeeded","applicationdetail.batchimport.result.summary.back":"Back to application","applicationdetail.batchimport.result.summary.reimport":"Import more","applicationdetail.batchimport.result.summary.seg1":"Successfully imported","applicationdetail.batchimport.result.summary.seg2":"Failed to imported","applicationdetail.batchimport.result.thead.status":"Import status","applicationdetail.batchimport.upgrade.btn":"Upgrade","applicationdetail.detailview.appprops.createtime":"Created At","applicationdetail.detailview.appprops.delete":"Delete Application","applicationdetail.detailview.appprops.devicecount":"Devices","applicationdetail.detailview.appprops.dpcount":"Data Points","applicationdetail.detailview.appprops.flowcount":"Rules","applicationdetail.detailview.appprops.parsercount":"Parsers","applicationdetail.detailview.appprops.title":"Application Properties","applicationdetail.detailview.appprops.E.FE_EMPTY":"Cannot Empty","applicationdetail.detailview.delete.cancelbtn":"Cancel","applicationdetail.detailview.delete.confirmbtn":"Delete","applicationdetail.detailview.delete.E.FE_DEVICESEXIST":"Cannot delete application with devices.","applicationdetail.detailview.delete.error.modalheader":"Delete Error","applicationdetail.detailview.delete.modalcontent":"Delete appliation","applicationdetail.detailview.delete.modalheader":"Delete Application","applicationdetail.detailview.devicelist.adderr.header":"Add Device Error","applicationdetail.detailview.devicelist.adderr.ooq.comm":"Sorry, you are out of device quota. Contact us for creating more.","applicationdetail.detailview.devicelist.adderr.ooq.cube":"Sorry, you are out of device quota. Contact us for creating more.","applicationdetail.detailview.devicelist.adderr.ooq.undercomm":"Sorry, you are out of device quota. Upgrade your account to create more.","applicationdetail.detailview.devicelist.adderr.upgrade.btn":"Upgrade","applicationdetail.detailview.devicelist.autogendev":"New Device","applicationdetail.detailview.devicelist.batchimport":"Batch Import","applicationdetail.detailview.devicelist.deldev":"Delete Devices","applicationdetail.detailview.devicelist.expalldev":"Export All Devices","applicationdetail.detailview.devicelist.devicenum":"Total Device Count:","applicationdetail.detailview.devicelist.error.empty":"Cannot be empty","applicationdetail.detailview.devicelist.error.invalidformat":"Invalid format","applicationdetail.detailview.devicelist.gendev":"Generate Device","applicationdetail.detailview.devicelist.gendev.band":"Band","applicationdetail.detailview.devicelist.impdev":"Import Device","applicationdetail.detailview.devicelist.importabp":"Import ABP Device","applicationdetail.detailview.devicelist.importabp.band":"ISM Band","applicationdetail.detailview.devicelist.importabp.band.placeholder":"Choose the ISM band","applicationdetail.detailview.devicelist.importabp.E.DEVADDRCONFLICT":"Duplicated DevAddr","applicationdetail.detailview.devicelist.importabp.E.DEVADDRUNAVAIL":"Duplicated DevAddr","applicationdetail.detailview.devicelist.importabp.E.DEVEUICONFLICT":"Duplicated DevEUI","applicationdetail.detailview.devicelist.importabp.E.DEVEUIUNAVAIL":"Duplicated DevEUI","applicationdetail.detailview.devicelist.importabp.E.FE_EMPTY":"Cannot be empty","applicationdetail.detailview.devicelist.importabp.E.FE_INVALIDFORMAT":"Invaid format","applicationdetail.detailview.devicelist.importabp.err.unknown":"Import error","applicationdetail.detailview.devicelist.importabp.modalheader":"Import ABP Device","applicationdetail.detailview.devicelist.importabp.submit":"Import","applicationdetail.detailview.devicelist.importabp.submit.failure":"Import error","applicationdetail.detailview.devicelist.importabp.submit.success":"Import success","applicationdetail.detailview.devicelist.importabp.vendorprovide":"Provided by device vendor","applicationdetail.detailview.devicelist.importotaa":"Import OTAA Device","applicationdetail.detailview.devicelist.importotaa.band":"ISM Band","applicationdetail.detailview.devicelist.importotaa.band.placeholder":"Choose the ISM band","applicationdetail.detailview.devicelist.importotaa.E.DEVEUICONFLICT":"Duplicated DevEUI","applicationdetail.detailview.devicelist.importotaa.E.DEVEUIUNAVAIL":"Duplicated DevEUI","applicationdetail.detailview.devicelist.importotaa.E.FE_EMPTY":"Cannot be empty","applicationdetail.detailview.devicelist.importotaa.E.FE_INVALIDFORMAT":"Invalid format","applicationdetail.detailview.devicelist.importotaa.E.GENERALERROR":"Server error","applicationdetail.detailview.devicelist.importotaa.E.UNKNOWN":"Network error","applicationdetail.detailview.devicelist.importotaa.err.deveui.conflict":"Duplicated DevEUI","applicationdetail.detailview.devicelist.importotaa.err.unknown":"Import error","applicationdetail.detailview.devicelist.importotaa.modalheader":"Import OTAA Device","applicationdetail.detailview.devicelist.importotaa.submit":"Import","applicationdetail.detailview.devicelist.importotaa.submit.failure":"Import error","applicationdetail.detailview.devicelist.importotaa.submit.pending":"Importing","applicationdetail.detailview.devicelist.importotaa.submit.success":"Import success","applicationdetail.detailview.devicelist.nodevice":"No Devices","applicationdetail.detailview.devicelist.search.placeholder":"Enter to search devices","applicationdetail.detailview.devicelist.thead.area":"Area","applicationdetail.detailview.devicelist.thead.band":"ISM Band","applicationdetail.detailview.devicelist.thead.bandplan":"Band Plan","applicationdetail.detailview.devicelist.thead.city":"City","applicationdetail.detailview.devicelist.thead.createtime":"Create Time","applicationdetail.detailview.devicelist.thead.name":"Name","applicationdetail.detailview.devicelist.thead.status":"Recent Activity","applicationdetail.detailview.devicelist.thead.type":"Type","applicationdetail.detailview.devicelist.title":"Device List","applicationdetail.exportData":"Export Data","applicationdetail.exportview.choosedev.label":"DevEUI","applicationdetail.exportview.choosedev.placeholder":"Input the DevEUI","applicationdetail.exportview.deverrtips":"No such device of this application","applicationdetail.exportview.export.btn":"Export","applicationdetail.exportview.exporttype.label":"Export Type","applicationdetail.exportview.exporttype.optionall":"Export the data for all devices","applicationdetail.exportview.exporttype.optionone":"Export the data for one device","applicationdetail.exportview.exporttype.placeholder":"You can choose to export the data for a device","applicationdetail.exportview.format.label":"File Format","applicationdetail.exportview.panelheader":"Export Data","applicationdetail.exportview.timerange.label":"Export Time","applicationdetail.flowsview.add":"Create Rule","applicationdetail.flowsview.addflow.breadcrumb":"Create Rule","applicationdetail.flowsview.addflow.desc":"Description","applicationdetail.flowsview.addflow.E.BADSYNTAX":"Rule syntax error","applicationdetail.flowsview.addflow.E.FE_EMPTY":"Cannot be empty","applicationdetail.flowsview.addflow.E.FE_TOOLONG":"Too long","applicationdetail.flowsview.addflow.E.GENERALERROR":"Server error","applicationdetail.flowsview.addflow.E.UNKNOWN":"Network error","applicationdetail.flowsview.addflow.header":"Add Rule","applicationdetail.flowsview.addflow.name":"Name","applicationdetail.flowsview.addflow.script":"Rule","applicationdetail.flowsview.addflow.submit":"Create Rule","applicationdetail.flowsview.addflow.submit.failure":"Create failed","applicationdetail.flowsview.addflow.submit.success":"Create success","applicationdetail.flowsview.flows.delete.cancel":"Cancel","applicationdetail.flowsview.flows.delete.header":"Delete Rule","applicationdetail.flowsview.flows.delete.rusure":"Are you sure to delete rule","applicationdetail.flowsview.flows.delete.submit":"Yes, Delete","applicationdetail.flowsview.flows.desc":"With rules, you can monitor your data points with customized rules. When rules is met, corresponding actions such as notifications will be triggered.","applicationdetail.flowsview.flows.E.BADSYNTAX":"Rule syntax error","applicationdetail.flowsview.flows.E.FE_EMPTY":"Cannot be empty","applicationdetail.flowsview.flows.E.GENERALERROR":"Server error","applicationdetail.flowsview.flows.E.UNKNOWN":"Network error","applicationdetail.flowsview.flows.noflow":"No rules","applicationdetail.logview.daterangepicker.label":"Time","applicationdetail.logview.panelheader":"Application Logs","applicationdetail.logview.thead.code":"Code","applicationdetail.logview.thead.loglevel":"Level","applicationdetail.logview.thead.remark":"Detail","applicationdetail.logview.thead.time":"Time","applicationdetail.menu.api":"API","applicationdetail.menu.detail":"Detail","applicationdetail.menu.dps":"Data Points","applicationdetail.menu.export":"Export","applicationdetail.menu.flows":"Event Rules","applicationdetail.menu.log":"Log","applicationdetail.menu.parse":"Data Parsing","applicationdetail.menu.dashboard":"Dashboard","applicationdetail.menu.broadcast":"Broadcast","applicationdetail.outPut":"application interface","applicationdetail.parseview.datapoints.clicktoedit":"Click to add","applicationdetail.parseview.datapoints.delete":"Delete","applicationdetail.parseview.datapoints.delete.body.questionmark":"?","applicationdetail.parseview.datapoints.delete.body.text":"Are you sure to delete data point","applicationdetail.parseview.datapoints.delete.header":"Delete Data Point","applicationdetail.parseview.datapoints.delete.submit.cancel":"Cancel","applicationdetail.parseview.datapoints.delete.submit.confirm":"Delete","applicationdetail.parseview.datapoints.field.actions":"Actions","applicationdetail.parseview.datapoints.field.desc":"Description","applicationdetail.parseview.datapoints.field.trend":"Trend","applicationdetail.parseview.datapoints.field.type":"Data Type","applicationdetail.parseview.datapoints.header":"Data Points","applicationdetail.parseview.datapoints.how":"How to generate a data point?","applicationdetail.parseview.datapoints.how.dps":"Parsed data points will be listed here.","applicationdetail.parseview.datapoints.how.parse.parser":"data parser","applicationdetail.parseview.datapoints.how.parse.postfix":", and parsed successfully.","applicationdetail.parseview.datapoints.how.parse.prefix":"Create at least one ","applicationdetail.parseview.datapoints.how.tx":"Make sure device data is received.","applicationdetail.parseview.datapoints.nodps":"No data points","applicationdetail.parseview.dptrend.devicefilter.placeholder":"Enter DevEUI","applicationdetail.parseview.dptrend.deviceserie.label":"Split by device","applicationdetail.parseview.dptrend.filters":"Filters","applicationdetail.parseview.dptrend.filters.device":"Filter by device","applicationdetail.parseview.dptrend.filters.new":"New filter","applicationdetail.parseview.dptrend.groupbys":"Group By","applicationdetail.parseview.dptrend.groupbys.device":"Group by device","applicationdetail.parseview.dptrend.groupbys.dimension":"Dimension","applicationdetail.parseview.dptrend.groupbys.funcs.avg":"Average","applicationdetail.parseview.dptrend.groupbys.funcs.max":"Max","applicationdetail.parseview.dptrend.groupbys.funcs.min":"Min","applicationdetail.parseview.dptrend.groupbys.funcs.sum":"Sum","applicationdetail.parseview.dptrend.groupbys.function":"Function","applicationdetail.parseview.dptrend.groupbys.new":"New group by","applicationdetail.parseview.dptrend.groupbys.time":"Group by time","applicationdetail.parseview.dptrend.groupbytime.onehour":"1 Hour","applicationdetail.parseview.dptrend.groupbytime.onemin":"1 Minute","applicationdetail.parseview.dptrend.groupbytime.tenmin":"10 Minute","applicationdetail.parseview.dptrend.series":"Series","applicationdetail.parseview.dptrend.series.device":"Split by device","applicationdetail.parseview.dptrend.series.new":"Split multiple series","applicationdetail.parseview.dptrend.timerange":"Time Range","applicationdetail.parseview.dptrend.timeranges.lastday":"Last day","applicationdetail.parseview.dptrend.timeranges.lasthour":"Last hour","applicationdetail.parseview.dptrend.timeranges.lastmon":"Last month","applicationdetail.parseview.parserdetail.helptabs.sample":"Code Sample","applicationdetail.parseview.parsers.add":"Add Parser","applicationdetail.parseview.parsers.add.desc":"Description","applicationdetail.parseview.parsers.add.E.FE_EMPTY":"Cannot be empty","applicationdetail.parseview.parsers.add.modalheader":"Add Parser","applicationdetail.parseview.parsers.add.name":"Name","applicationdetail.parseview.parsers.add.submit":"Add","applicationdetail.parseview.parsers.add.submitfail":"Add failure","applicationdetail.parseview.parsers.add.submitsucc":"Add success","applicationdetail.parseview.parsers.add.submitting":"Adding","applicationdetail.parseview.parsers.data.header":"Parsed data","applicationdetail.parseview.parsers.data.nodata":"No data","applicationdetail.parseview.parsers.data.thead.time":"Time","applicationdetail.parseview.parsers.data.thead.name":"Device Name","applicationdetail.parseview.parsers.data.nodata01":"No data","applicationdetail.parseview.parsers.data.back":"back","applicationdetail.parseview.parsers.data.failure":"Service Time out","applicationdetail.parseview.parsers.delete.cancel":"Cancel","applicationdetail.parseview.parsers.delete.modalbody":"Are you sure to delete parser","applicationdetail.parseview.parsers.delete.modalheader":"Delete Parser","applicationdetail.parseview.parsers.delete.submit":"Delete","applicationdetail.parseview.parsers.delete.submitsucc":"Delete success","applicationdetail.parseview.parsers.delete.submitting":"Deleting","applicationdetail.parseview.parsers.E.FE_EMPTY":"Cannot be empty","applicationdetail.parseview.parsers.E.UNKNOWN":"Network error","applicationdetail.parseview.parsers.header":"Data Parsers","applicationdetail.parseview.parsers.scripteditor.E.FE_NODATAPOINTS":"No data point returned","applicationdetail.parseview.parsers.scripteditor.E.FE_RETMISSING":"No return statement","applicationdetail.parseview.parsers.scripteditor.E.FE_SYNTAXINVALID":"Syntax error","applicationdetail.parseview.parsers.scripteditor.E.GENERALERROR":"Server error","applicationdetail.parseview.parsers.scripteditor.E.UNKNOWN":"Network error","applicationdetail.parseview.parsers.scripteditor.submit":"Save","applicationdetail.parseview.parsers.scripteditor.submitfailure":"Save error","applicationdetail.parseview.parsers.scripteditor.submitsucc":"Save success","applicationdetail.parseview.parsers.scripteditor.submitting":"Saving","applicationdetail.parseview.parsers.scripteditor.FE_SYNTAXINVALID":"line","applicationdetail.parseview.parsers.scripteditor.line1":" ","applicationdetail.parseview.parsers.scripteditor.copy":"Copy","applicationdetail.parseview.parsers.scripteditor.copid":"Copid","applicationdetail.parseview.parsers.scripteditor.beauty":"Format","applicationdetail.parseview.parsers.debug.failure":"Invalid","applicationdetail.parseview.parsers.debug.E.FE_RETMISSING":"Parser code invalid: No return statement","applicationdetail.parseview.parsers.debug.E.FE_DEBUG_SYNTAXINVALID":"Debug code syntax error","applicationdetail.parseview.parsers.debug.E.FE_PARSER_SYNTAXINVALID":"Parser code syntax error","applicationdetail.parseview.parsers.debug.E.GENERALERROR":"Server error","applicationdetail.parseview.parsers.debug.line0":"line","applicationdetail.parseview.parsers.debug.line1":" ","applicationdetail.parseview.parsers.debug.E.FE_DEBUG_FAILURE":"Debug Failed","applicationdetail.sidebar.title":"Application","applicationdetail.dashboard.addgw":"Gateway","applicationdetail.dashboard.nodashboard":"No Dashboards","applicationdetail.dashboard.nodashboard.desc":"With dashboards, you can analyze and view the device data through customization","applicationdetail.dashboard.adddashboard":"Dashboard","applicationdetail.dashboard.adddashboard.add":"Add Dashboard","applicationdetail.dashboard.adddashboard.add.placeholder":"A description of the Dashboard","applicationdetail.dashboard.adddashboard.add.mode":"Mode","applicationdetail.dashboard.adddashboard.add.device":"Device","applicationdetail.dashboard.adddashboard.add.select":"Select","applicationdetail.dashboard.adddashboard.add.datapoint":"Select Data Points","applicationdetail.dashboard.adddashboard.add.single":"Charts displayed for the selected data points(One device)","applicationdetail.dashboard.adddashboard.add.multiple":"Distribution of equipment on the map and chart display(Multiple devices)","applicationdetail.dashboard.adddashboard.add.gps":"The track of the device on the map for different time periods","applicationdetail.dashboard.adddevice":"Select Device","applicationdetail.dashboard.changedevice":"Substitute Device","applicationdetail.dashboard.createdat":"Created At","applicationdetail.dashboard.toolbar.bytime.hour":"Last 1 hour","applicationdetail.dashboard.toolbar.bytime.day":"Last 1 day","applicationdetail.dashboard.toolbar.bytime.sevenday":"Last 7 days","applicationdetail.dashboard.toolbar.bytime.month":"Last 30 days","applicationdetail.dashboard.search.placeholder":"search","applicationdetail.dashboard.addmodal.name":"Name","applicationdetail.dashboard.dpsmodal.desc":"Description","applicationdetail.dashboard.singlechart":"separate","applicationdetail.dashboard.mergechart":"merge","applicationdetail.dashboard.addmodal.deveui":"DevEUI","applicationdetail.dashboard.addmodal.createdAt":"Created At","applicationdetail.dashboard.confirm":"Confirm","applicationdetail.dashboard.cancel":"Cancel","applicationdetail.dashboard.customize":"Unnamed","applicationdetail.dashboard.E.FE_EMPTY":"Cannt be empty","applicationdetail.dashboard.delete.dashboard":"Delete Dashboard","applicationdetail.dashboard.delete.confirm":"Confirm to delete?","applicationdetail.dashboard.add.warning":"No choice of device or data points","applicationdetail.dashboard.add.dpschart":"Add charts","applicationdetail.dashboard.adddevice.tip0":"Note: Choose up to","applicationdetail.dashboard.adddevice.tip1":"devices","applicationdetail.dashboard.adddevice.tip2":"Note: Choose up to 1 device","applicationdetail.dashboard.adddevice.nodata":"No device","applicationdetail.dashboard.chart.nodata":"No Data","applicationdetail.dashboard.new.singlemode":"Basic Mode","applicationdetail.dashboard.new.mapmode":"Map Mode","applicationdetail.dashboard.new.gpsmode":"Track","applicationdetail.dashboard.map.drops":"Dropped Packets","applicationdetail.dashboard.map.adddevice":"Add Devices","applicationdetail.dashboard.detail.devicedetail":"Device Detail","applicationdetail.dashboard.gps.colorset":"Color Setting","applicationdetail.dashboard.gps.colorset.other":"Below","applicationdetail.dashboard.gps.colorset.higher":"Above","applicationdetail.dashboard.gps.colorset.title1":"Index Parameter","applicationdetail.dashboard.gps.colorset.title2":"Threshold Setting","applicationdetail.dashboard.gps.colorset.tip":"Note: Customize the threshold range, depending on the range, display different color icons to distinguish the signal strength","applicationdetail.dashboard.E.FE_WRONG_MIN":"Invalid minimum value","applicationdetail.dashboard.E.FE_WRONG_MAX":"Invalid maximum value","applicationdetail.dashboard.download.nodata":"No exportable data!","applicationdetail.dashboard.download.header":"Export Data!","applicationdetail.gatewayview.breadcrumb.application":"My Applications","applicationdetail.broadcast.breadcrumb.application":"My Applications","applicationdetail.broadcast.E.FE_EMPTY":"Cannot be empty","applicationdetail.broadcast.add.confirm":"Confirm","applicationdetail.broadcast.label.name":"Name","applicationdetail.broadcast.add.placeholder":"Enter a readable name","applicationdetail.broadcast.E.FE_INVALIDHEX":"Invalid Hex data","applicationdetail.broadcast.E.FE_INVALIDPORT":"Invalid port","applicationdetail.broadcast.E.FE_OUTOFRANGE":"Out of range","applicationdetail.broadcast.E.FE_INVALIDNUM":"Invalid Number","applicationdetail.broadcast.E.FE_PREC4":"4 digit precision at most","applicationdetail.broadcast.E.FE_INVALIDAPPKEY":"Invalid Key","applicationdetail.broadcast.E.FE_INVALIDADDR":"Invalid Address","applicationdetail.broadcast.E.DEVADDR_NOT_FOUND":"Invalid Address","applicationdetail.broadcast.E.NO_GATEWAY":"No Connected Gateway","applicationdetail.broadcast.E.FE_INVALIDFCNT":"Invalid Seq No.","applicationdetail.broadcast.E.DEVADDR_ALREADY_EXIST":"Address Already Exists","applicationdetail.broadcast.E.BROADCAST_OUT_OF_QUOTA":"Out of address quota","applicationdetail.broadcast.send":"Send","applicationdetail.broadcast.addr.placeholder":"Enter an existing address","applicationdetail.broadcast.addr.quato":"(Up to 10)","applicationdetail.broadcast.sending":"Sending","applicationdetail.broadcast.sendsuccess":"Send Succeed","applicationdetail.broadcast.sendfailure":"Send Failed","applicationdetail.broadcast.send.header":"Send Broadcast","applicationdetail.broadcast.send.addr":"Address","applicationdetail.broadcast.send.addr.placeholder":"Broadcast Address","applicationdetail.broadcast.send.port":"Port","applicationdetail.broadcast.send.port.placeholder":"1 to 223","applicationdetail.broadcast.send.encoding":"Encoding","applicationdetail.broadcast.send.data":"Data","applicationdetail.broadcast.send.gateway":"Gateway","applicationdetail.broadcast.gateway.disconnected":"Disconnected","applicationdetail.broadcast.gateway.connected":"Connected","applicationdetail.broadcast.gateway.header":"Select Gateway","applicationdetail.broadcast.gateway.name":"Name","applicationdetail.broadcast.gateway.mac":"MAC","applicationdetail.broadcast.gateway.connection":"Status","applicationdetail.broadcast.gateway.confirm":"Confirm","applicationdetail.broadcast.add.new":"Automatic generated","applicationdetail.broadcast.add.import":"Manual import","applicationdetail.broadcast.addrlist.delete":"Delete","applicationdetail.broadcast.addrlist.edit":"Edit","applicationdetail.broadcast.addrlist.header":"Address List","applicationdetail.broadcast.addrlist.address":"Address","applicationdetail.broadcast.addrlist.name":"Name","applicationdetail.broadcast.addrlist.appskey":"App Key","applicationdetail.broadcast.addrlist.nwkskey":"Network Key","applicationdetail.broadcast.addrlist.fcntdown":"Seq No.","applicationdetail.broadcast.addrlist.band":"Band","applicationdetail.broadcast.addrlist.operation":"Operation","applicationdetail.broadcast.addrlist.nodata":"No Data","applicationdetail.broadcast.addressmodal.header":"Add Broadcast Address","applicationdetail.broadcast.addressmodal.band":"Band","applicationdetail.broadcast.editmodal.header":"Edit Broadcast Address","applicationdetail.broadcast.logs.header":"Broadcast Message","applicationdetail.broadcast.logs.search.placeholder":"Search address","applicationdetail.broadcast.logs.time":"Time","applicationdetail.broadcast.logs.gateway":"Gateway","applicationdetail.broadcast.logs.address":"Address","applicationdetail.broadcast.logs.port":"Port","applicationdetail.broadcast.logs.encoding":"Encoding","applicationdetail.broadcast.logs.data":"Data","applicationdetail.broadcast.logs.success":"Send Succeed","applicationdetail.broadcast.logs.fail":"Send Failed","applicationdetail.gatewayview.status.disconnected":"Disconnected","applicationdetail.gatewayview.status.connected":"Connected","applicationdetail.gatewayview.gatewaylist.header":"Gateway Filter(Optional)","applicationdetail.gatewayview.gatewaylist.chose":"Select Gateway","applicationdetail.gatewayview.gatewaylist.delete":"Delete","applicationdetail.gatewayview.gatewaylist.name":"Name","applicationdetail.gatewayview.gatewaylist.mac":"\tMAC Address","applicationdetail.gatewayview.gatewaylist.connect":"Status","applicationdetail.gatewayview.gatewaylist.city":"City","applicationdetail.gatewayview.gatewaylist.area":"Area","applicationdetail.gatewayview.gatewaylist.operation":"Operation","applicationdetail.gatewayview.gatewaylist.nodata":"No Data","applicationdetail.gatewayview.gatewaylist.delheader":"Delete Gateway","applicationdetail.gatewayview.gatewaylist.deltext":"Confirm to delete Gateway","applicationdetail.gatewayview.gatewaylist.help0":"Applications can isolate other gateways by configuring certain gateways that can be associated. The gateway configuration brings the following benefits:","applicationdetail.gatewayview.gatewaylist.help1":"The application server can only query the associated gateway and its status through the API","applicationdetail.gatewayview.gatewaylist.help2":"Application downlink broadcast packets only need to be sent to the associated gateway","applicationdetail.gatewayview.gatewaylist.help3":" Application receive  uplink data  only from the associated gateway","applicationdetail.gatewayview.gatewaylist.help4":"Application selects only the associated gateway as a route for downlink data","applicationdetail.gatewayview.gatewaylist.help5":"The default configuration or empty configuration indicates that the application is associated with all gateways.","billing.balogs.balance.lbl":"Balance","billing.balogs.balance.recharge.btn":"Recharge","billing.balogs.balance.unit":"Yuan","billing.balogs.datepicker.language":"en","billing.balogs.form.btn.query":"Search","billing.balogs.form.label.time":"Time","billing.balogs.form.label.to":"to","billing.balogs.form.label.type":"Type","billing.balogs.label.recharge":"My Balance","billing.balogs.table.header.amount":"Amount","billing.balogs.table.header.balance":"Balance","billing.balogs.table.header.ref":"Related Bill No.","billing.balogs.table.header.remark":"Remark","billing.balogs.table.header.time":"Time","billing.balogs.table.header.type":"Type","billing.balogs.table.nodata":"NO DATA","billing.balogs.types.expense":"Expense","billing.balogs.types.options.all":"All","billing.balogs.types.options.expense":"Expense","billing.balogs.types.options.recharge":"Recharge","billing.balogs.types.recharge":"Recharge","billing.billdetail.billid.lbl":"Bill No. ","billing.billdetail.billinfo.desc1":"Your charge of month is totally ","billing.billdetail.billinfo.desc2":" RMB Yuan, including ","billing.billdetail.billinfo.desc3":" resource nodes. ","billing.billdetail.billtime.lbl":"Create time: ","billing.billdetail.info.label.billno":"Bill No.","billing.billdetail.info.label.billperiod":"Bill Period","billing.billdetail.info.label.servicetype":"Service","billing.billdetail.info.label.totalfee":"Total Fee","billing.billdetail.resourcelist.header":"Resource List","billing.billdetail.status.deleted":"Deleted","billing.billdetail.status.inuse":"In use","billing.billdetail.table.header.ctime":"Create Time","billing.billdetail.table.header.dtime":"Delete Time","billing.billdetail.table.header.rid":"Resource ID","billing.billdetail.table.header.status":"Status","billing.billdetail.table.header.uptime":"Up Time","billing.billist.breadcrumbs.path1":"My Account","billing.billist.breadcrumbs.path2":"Bills","billing.billlist.form.btn.query":"Search","billing.billlist.form.label.period":"Bill Period","billing.billlist.form.label.to":"to","billing.billlist.table.nodata":"NO DATA","billing.billlogs.panel.header":"Last 36 Months Bill Logs","billing.billlogs.table.detail.link":"View detail","billing.billlogs.table.feetypes.nodefee":"Monthly fee","billing.billlogs.table.header.actions":"Actions","billing.billlogs.table.header.billno":"Bill No.","billing.billlogs.table.header.billperiod":"Bill Period","billing.billlogs.table.header.itemcount":"Item Number","billing.billlogs.table.header.paystatus":"Status","billing.billlogs.table.header.servicetype":"Service","billing.billlogs.table.header.totalfee":"Total Fee","billing.billlogs.table.header.unitprice":"Unit Price","billing.billlogs.table.paystatus.paid":"Paid","billing.billlogs.table.paystatus.unpaid":"Unpaid","billing.breadcrumb.balogs":"Balance Logs","billing.breadcrumb.billdetail":"Bill Detail","billing.breadcrumb.billing":"My Account","billing.breadcrumb.billlogs":"Bill Logs","billing.breadcrumb.recharge":"Recharge","billing.breadcrumb.recharge.wechat":"Wechat Payment","billing.commercialview.balance.lbl":"Balance","billing.commercialview.balance.logs.link":"Balance Logs","billing.commercialview.balance.unit":"Yuan","billing.commercialview.bills.billday.desc.postfix":" of every month","billing.commercialview.bills.billday.desc.prefix":"Your billing day is ","billing.commercialview.bills.billhelp.desc1":"Bills are generated according to your device usage by system at each billing day automatically. Please make sure your balance is sufficient to cover your cost.","billing.commercialview.bills.billlog.btn":"View Bills","billing.commercialview.bills.lbl":"Bills","billing.commercialview.chart.series.costs":"Costs(Yuan)","billing.commercialview.chart.series.nodes":"Nodes","billing.commercialview.chart.yaxis.costs":"Costs(Yuan)","billing.commercialview.chart.yaxis.nodes":"Nodes","billing.commercialview.recharge.btn":"Recharge","billing.commercialview.paystrategy":"Recharge strategy","billing.expired.notify":"Sorry! Your service is expired, please upgrade your service plan or recharge.","billing.main.balance.label":"My Balance","billing.main.balogs.btn":"Balance Changes","billing.main.billist.btn":"Bills","billing.main.breadcrumbs.path1":"My Account","billing.main.buyplan.btn":"View Plans","billing.main.chart.charges.yname":"Expense","billing.main.chart.chargs.xname":"Bill Period","billing.main.chart.labelformatter.resource.unit":"","billing.main.chart.resource.xname":"Bill Period","billing.main.chart.resource.yname":"Resource Nodes","billing.main.expiretips":"Your service has expired. Please upgrade to a commercial plan.","billing.main.recentexpenses.header":"Recent Expenses","billing.main.recentresources.header":"Recent Resource Usage","billing.main.recharge.btn":"Recharge","billing.main.trial.btn2":"Upgrade To A Bussiness Plan","billing.main.trial.bycode.modal.error.body":"Invalid Service Code","billing.main.trial.bycode.modal.error.title":"Upgrade Failure","billing.main.trial.bycode.modal.success.body":"Upgrade Success","billing.main.trial.bycode.modal.success.btn":"View My Resource Quota","billing.main.trial.bycode.modal.success.title":"Upgrade Success","billing.pay.tier.bymonth":"month","billing.pay.tier.txt1":" nodes: ","billing.pay.tier.txt2":" ","billing.pay.tier.txt3":" above, consult us","billing.recharge.balance.txt":"My Balance","billing.recharge.brand.alipay":"Alipay","billing.recharge.breadcrumbs.path1":"My Account","billing.recharge.breadcrumbs.path2":"Recharge","billing.recharge.confirmmodal.body":"Complete your payment in the new window.","billing.recharge.confirmmodal.button.complete":"Payment completed","billing.recharge.confirmmodal.button.redo":"Go back","billing.recharge.confirmmodal.header":"Recharge","billing.recharge.errmsg.absent":"Enter an amount to recharge","billing.recharge.errmsg.malformed":"Enter an positive amount with no more than two decimal places","billing.recharge.errmsg.negative":"Enter an positive amount to recharge","billing.recharge.errmsg.toolarge":"Amount too large","billing.recharge.errmsg.toolow":"Recharge RMB 200 or above to upgrade to a business plan","billing.recharge.form.alipay.redirecting":"Redirecting to AliPay","billing.recharge.form.err.submiterr":"Recharge Error","billing.recharge.form.placeholder":"Enter Recharge amount","billing.recharge.form.placeholdercard":"Enter Recharge Card Code","billing.recharge.form.submit.btn":"Recharge","billing.recharge.form.unit":"Yuan","billing.recharge.form.wechat.loading":"Requesting","billing.recharge.redirecting.txt":"Redirecting to 3rd party payment site ...","billing.recharge.wechat.amount":"Amount: ","billing.recharge.wechat.billid":"Order ID: ","billing.recharge.wechat.scancode":"Scan the QR code with WeChat to pay","billing.recharge.wechat.countdown.text1":"Please pay in ","billing.recharge.wechat.countdown.text2":" ","billing.recharge.wechat.qrcode.expired":"QR code expired","billing.recharge.wechat.qrcode.refresh":"Refresh","billing.recharge.wechat.qrcode.success":"Paid successfully!","billing.undercommercial.acctcode.activated.desc1":"You are already a development service package user.","billing.undercommercial.acctcode.activated.panelheader":"Development Service Package","billing.undercommercial.acctcode.activated.svcexpire.remain.lbl":"Remaining service time:","billing.undercommercial.acctcode.activated.svcexpire.remain.tips":"Please upgrade to the enterprise plan in time.","billing.undercommercial.acctcode.activated.svcexpire.remain.unit":"days","billing.undercommercial.acctcode.form.activate.btn":"Activate","billing.undercommercial.acctcode.form.activate.failed":"Activation Failed","billing.undercommercial.acctcode.form.activate.success":"Activation Succeeded","billing.undercommercial.acctcode.form.placeholder":"Enter a activation code","billing.undercommercial.acctcode.form.title":"Activate development service package:","billing.undercommercial.acctcode.toactive.btn":"Know more","billing.undercommercial.acctcode.toactive.desc1":"loraFlow.io development service package provides public cloud service quota:","billing.undercommercial.acctcode.toactive.desc2":"1 APP/1 Gateway/10 Terminals/1 Year","billing.undercommercial.acctcode.toactive.panelheader":"Development Service Package","billing.undercommercial.commup.desc1":"Upgrade to the enterprise plan get commercial supports and a long-term cloud service quota promotion.","billing.undercommercial.commup.desc2":"Recharge at least 200 RMB to upgrade to the loraFlow.io enterprise plan. We provides a customized cloud service quota, fully commercial supports and  consult for enterprise users.","billing.undercommercial.commup.panelheader":"loraFlow.io Enterprise Plan","billing.undercommercial.commup.upgrade.btn":"Upgrade","billing.undercommercial.options.heading":"Upgrade to the enterprise plan or obtain a development service package to enjoy a better service.","billing.undercommercial.pay.panelheader":"Charging Strategy","billing.undercommercial.pay.title":"Terminals access tiered pricing by terminal amount","billing.undercommercial.recharge.btn":"Recharge","billing.recharge.types.card":"Recharge card","billing.recharge.rechgcard.errcode":"Error recharge card code","billing.recharge.rechgcard.tryagain":"Try again","billing.recharge.rechgcard.continue":"Continue","billing.recharge.rechgcard.rechging":"Recharging...","billing.recharge.rechgcard.complete":"Recharge completed","billing.recharge.rechgcard.errcodeused":"Recharge card has been used","billing.recharge.rechgcard.errexpired":"Recharge card has been expired","common.accountmanage":"My Account","common.accountupgrade":"My Wallet","common.application":"Application","common.billing":"Billing","common.exit":"Exit","common.login":"Login","common.LoRaWAN":"LoRaWAN network server","common.newresource":"Documentation","common.overview":"Overview","common.register":"Sign up","common.resource":"resource","common.picker.date":"Select date","common.picker.time":"Select time","common.picker.confirm":"Yes","devicedetail.adrview.adr.data.dr":"Data Rate","devicedetail.adrview.adr.data.event":"Event","devicedetail.adrview.adr.data.margin":"Margin","devicedetail.adrview.adr.data.message":"Message","devicedetail.adrview.adr.data.per":"Packet Error Rate","devicedetail.adrview.adr.data.power":"Power(index)","devicedetail.adrview.adr.data.state":"State","devicedetail.adrview.adr.data.time":"Time","devicedetail.adrview.adr.event.auto":"System request","devicedetail.adrview.adr.event.confirm":"Device confirmed","devicedetail.adrview.adr.event.error":"Error","devicedetail.adrview.adr.event.info":"Info","devicedetail.adrview.adr.event.manual":"Manual request","devicedetail.adrview.adr.event.reject":"Device rejected","devicedetail.adrview.adr.event.warning":"Warning","devicedetail.adrview.switch.on":"On","devicedetail.adrview.switch.off":"Off","devicedetail.adrview.switch.reset":"Reset ADR","devicedetail.adrview.E.FE_INVALID_DR":"Invalid value","devicedetail.adrview.E.BADARG":"Invalid value","devicedetail.adrview.adrlogs.panelheader":"ADR Activity Logs","devicedetail.adrview.adrstatus.boxheader.ack":"Device confirmed","devicedetail.adrview.adrstatus.boxheader.nack":"Device rejected","devicedetail.adrview.adrstatus.boxheader.request":"ADR Request","devicedetail.adrview.adrstatus.confirmed":"Last confirmed","devicedetail.adrview.adrstatus.confirmed.title":"ADR Settings","devicedetail.adrview.adrstatus.lastacktime":"Last device confirmed time","devicedetail.adrview.adrstatus.noactivity":"No Activity","devicedetail.adrview.adrstatus.request.title":"Lastest ADR Activity","devicedetail.adrview.maxdr.label":"Maximum DR","devicedetail.adrview.mindr.label":"Minimum DR","devicedetail.adrview.E.GENERALERROR":"Network error","devicedetail.adrview.E.UNKNOWN":"Server error","devicedetail.adrview.E.FE_EMPTY":"Cannot Empty","devicedetail.adrview.E.FE_MINGTMAX":"MinDR cannot be greater than MaxDR","devicedetail.adrview.margin.tips":"The lowest margin value, value 8 ~ 12 is recommended, higher the value, more conservative the ADR is","devicedetail.adrview.marginrate.title":"ADR Trend","devicedetail.adrview.marginrate.nodata":"No recent ADR trend","devicedetail.adrview.marginrate.start":"ADR has started","devicedetail.adrview.marginrate.latest":"Latest","devicedetail.adrview.marginrate.pingpong":"Adjustment Loopback","devicedetail.adrview.marginrate.count":"Number of samples","devicedetail.adrview.marginrate.current":"Current Margin","devicedetail.adrview.marginrate.mean":"Average of Margin Dynamic Range","devicedetail.adrview.marginrate.tips0":"Based on","devicedetail.adrview.marginrate.tips1":"samples","devicedetail.adrview.marginrate.percentile":"Percentile","devicedetail.adrview.marginrate.dynamic":"Dynamic","devicedetail.adrview.marginrate.dynamicrange":"Dynamic Range","devicedetail.adrview.marginrate.range":"ADR convergence range","devicedetail.adrview.marginrate.real":"Margin","devicedetail.bandview.banddetail.bandvalue":"empty","devicedetail.bandview.banddetail.bindbtn":"Bind Band","devicedetail.bandview.banddetail.bindcommonerr":"Bind failed!","devicedetail.bandview.banddetail.flushcommonerr":"Deliver failed!","devicedetail.bandview.banddetail.flushqueueerr":"The delivery queue is full, please be patient!","devicedetail.bandview.banddetail.label":"Band","devicedetail.bandview.banddetail.modalbody":"This operation will modify the radio frequency parameters of the device, continue?","devicedetail.bandview.banddetail.modaltitle":"Send band plan","devicedetail.bandview.banddetail.modaltitle.bind":"Bind failed prompt","devicedetail.bandview.banddetail.modaltitle.flush":"Flush band failed prompt!","devicedetail.bandview.banddetail.placeholder":"Select a band plan","devicedetail.bandview.banddetail.successmodalcontent":"The frequency band plan has been successfully delivered!","devicedetail.bandview.banddetail.successmodaltitle":"Deliver prompt","devicedetail.bandview.banddetail.title":"Device Band","devicedetail.bandview.banddetail.toolbar.toolsbtn":"Send band","devicedetail.bandview.banddetail.unbindbtn":"UnBind","devicedetail.bandview.banddetail.violation":"Frequency band conflict!","devicedetail.data.header":"Data Message","devicedetail.parsed.header":"Parsed Data","devicedetail.datatoolview.header":"Data Ultilities","devicedetail.datatoolview.resetseq.cancel":"Cancel","devicedetail.datatoolview.resetseq.E.GENERALERROR":"Submit error","devicedetail.datatoolview.resetseq.edit":"Edit","devicedetail.datatoolview.resetseq.fcntbits":"Sequence Bits","devicedetail.datatoolview.resetseq.fcntdown":"DownLink Sequence","devicedetail.datatoolview.resetseq.fcntup":"UpLink Sequence","devicedetail.datatoolview.resetseq.ok":"OK","devicedetail.datatoolview.resetseq.reset":"Reset UpLink Sequence","devicedetail.datatoolview.resetseq.reseted":"Reseted","devicedetail.datatoolview.senddata.data":"Data","devicedetail.datatoolview.senddata.data.placeholder.hex":"Hex","devicedetail.datatoolview.senddata.data.placeholder.text":"Text","devicedetail.datatoolview.senddata.E.FE_EMPTY":"Cannot be empty","devicedetail.datatoolview.senddata.E.FE_INVALIDHEX":"Invalid Hex data","devicedetail.datatoolview.senddata.E.FE_INVALIDPORT":"Invalid port","devicedetail.datatoolview.senddata.encoding":"Encoding","devicedetail.datatoolview.senddata.flushing":"Clearing","devicedetail.datatoolview.senddata.flushtx":"Clear Queue","devicedetail.datatoolview.senddata.port":"Port","devicedetail.datatoolview.senddata.port.placeholder":"1 to 223","devicedetail.datatoolview.senddata.send":"Send","devicedetail.datatoolview.senddata.sendfailure":"Send failed","devicedetail.datatoolview.senddata.sending":"Sending","devicedetail.datatoolview.senddata.sendsuccess":"Send succeeded","devicedetail.datatoolview.senddata.txsize":"Send Queue Size","devicedetail.datatoolview.tab.lorawanseq":"LoRaWAN Sequences","devicedetail.datatoolview.tab.senddata":"Send DownLink Packets","devicedetail.detailview.alert.down":"Send transmit downlink packets successfully","devicedetail.detailview.alert.setsuccess":"Set successfully","devicedetail.detailview.app":"Application","devicedetail.detailview.bags":"Packets","devicedetail.detailview.button.day":"Daily","devicedetail.detailview.button.deldev":"Delete device","devicedetail.detailview.button.hour":"Hourly","devicedetail.detailview.button.month":"Monthly","devicedetail.detailview.button.send":"Send","devicedetail.detailview.class.default":"Default","devicedetail.detailview.confirmeddatadown":"ConfirmedDataDown","devicedetail.detailview.confirmeddataup":"ConfirmedDataUp","devicedetail.detailview.datatool.move.notice":"DL Packet and Reset Sequence have been moved to the menu of the left sidebar.","devicedetail.detailview.datavalid":"Hex string of even length","devicedetail.detailview.delete.btn":"Delete Device","devicedetail.detailview.delete.cancelbtn":"Cancel","devicedetail.detailview.delete.confirm":"Are you sure to delete device ","devicedetail.detailview.delete.confirmbtn":"Yes, Delete","devicedetail.detailview.delete.modalheader":"Delete Device","devicedetail.detailview.deviceproperty":"Device","devicedetail.detailview.devicestatus":"Status","devicedetail.detailview.dropsbags":"Dropped Packets","devicedetail.detailview.E.BADDATARATE":"Bad data rate","devicedetail.detailview.E.BADFREQUENCY":"Bad frequency","devicedetail.detailview.E.FE_INVALIDAPPKEY":"Invalid AppKey","devicedetail.detailview.E.FE_INVALIDLAT":"Invalid latitude","devicedetail.detailview.E.FE_INVALIDLNG":"Invalid longitude","devicedetail.detailview.E.FE_INVALIDNUM":"Not a number","devicedetail.detailview.E.FE_OUTOFRANGE":"Out of range","devicedetail.detailview.E.FE_PREC4":"4 digit precision at most","devicedetail.detailview.E.FE_iptNumRange":"Integer of range [1, 255]","devicedetail.detailview.fcntdownvalid":"Integer of range [0, 4294967295]","devicedetail.detailview.fportvalid":"Integer of range [1, 223]","devicedetail.detailview.gatewaymac":"Gateway MAC","devicedetail.detailview.joinaccept":"JoinAccept","devicedetail.detailview.joinrequest":"JoinRequest","devicedetail.detailview.label.address":"Address","devicedetail.detailview.label.area":"Area","devicedetail.detailview.label.band":"ISM Band","devicedetail.detailview.label.batterystatus":"Battery","devicedetail.detailview.label.city":"City","devicedetail.detailview.label.clazz":"Class","devicedetail.detailview.label.content":"Content","devicedetail.detailview.label.devaddr":"DevAddr","devicedetail.detailview.label.deveui":"DevEUI","devicedetail.detailview.label.vendor":"Vendor ID","devicedetail.detailview.label.vendorver":"Vendorver","devicedetail.detailview.label.devid":"User-defined ID","devicedetail.detailview.label.devname":"Name","devicedetail.detailview.label.devtype":"Type","devicedetail.detailview.label.lastactstatus":"Status","devicedetail.detailview.label.lastdataup":"Recent Packet","devicedetail.detailview.label.lat":"Latitude","devicedetail.detailview.label.lng":"Longitude","devicedetail.detailview.label.lwanver":"Version","devicedetail.detailview.label.port":"Port","devicedetail.detailview.label.sendqueue":"DL Queue","devicedetail.detailview.latestdata.header":"Latest Messages","devicedetail.detailview.location.address":"Address","devicedetail.detailview.location.area":"Area","devicedetail.detailview.location.city":"City","devicedetail.detailview.location.coordinate":"Coordinate","devicedetail.detailview.location.editcoordinate":"edit coordinate","devicedetail.detailview.location.lat":"Latitude","devicedetail.detailview.location.lat.placeholder":"-90 ~ +90","devicedetail.detailview.location.lng":"Longitude","devicedetail.detailview.location.lng.placeholder":"-180 ~ +180","devicedetail.detailview.location.title":"Location","devicedetail.detailview.packets":"Packets","devicedetail.detailview.panelhead.devstatdata":"Device Traffic Statistics","devicedetail.detailview.panelhead.lorawan":"LoRaWAN Device Parameter","devicedetail.detailview.panelhead.position":"Location","devicedetail.detailview.panelhead.status":"Status","devicedetail.detailview.properr.lat.missing":"latitude missing","devicedetail.detailview.properr.lat.outofrange":"longitude must in [-90, +90]","devicedetail.detailview.properr.lng.missing":"longitude missing","devicedetail.detailview.properr.lng.outofrange":"latitude must in [-180, +180]","devicedetail.detailview.proprietary":"Proprietary","devicedetail.detailview.props.name":"Name","devicedetail.detailview.propspanel.status":"Device Status","devicedetail.detailview.result.active":"Active","devicedetail.detailview.result.unactive":"Inactive","devicedetail.detailview.rfu":"RFU","devicedetail.detailview.senddata.sendfail":"Data has been sent, the sending queue is full","devicedetail.detailview.senddata.sendsuccess":"Data has been sent","devicedetail.detailview.series.droppedpackets":"Dropped Packets","devicedetail.detailview.series.packets":"Packets","devicedetail.detailview.simplemodal.submittitle":"Delete","devicedetail.detailview.simplemodal.suretodelete":"Are you sure to delete this device?","devicedetail.detailview.simplemodal.title":"Delete Device","devicedetail.detailview.tabstitle.devbasicinfo":"Basic Information","devicedetail.detailview.tabstitle.devstat":"Statistics","devicedetail.detailview.tabstitle.maclog":"MAC Command","devicedetail.detailview.tabstitle.newdata":"Recent Packets","devicedetail.detailview.time":"Time","devicedetail.detailview.tooptip.msgdetail":"View Detail","devicedetail.detailview.tooptip.statdetail":"View Detail","devicedetail.detailview.unconfirmeddatadown":"UnconfirmedDataDown","devicedetail.detailview.unconfirmeddataup":"UnconfirmedDataUp","devicedetail.detailview.valid.data":"Hex string","devicedetail.detailview.valid.fport":"Integer of range [1, 223]","devicedetail.detailview.validmesempty":"can not be empty","devicedetail.detailview.value.batterystatuserr":"No Data","devicedetail.detailview.value.power":"External power supply","devicedetail.detailview.value.unknown":"Unknown","devicedetail.detailview.nodevice":"No such device information","devicedetail.detailview.nodevice.tips":"Device may have been deleted","devicedetail.fieldsgroup.datamsg":"Data Messages","devicedetail.fieldsgroup.radio":"Radio Parameters","devicedetail.lrapview.helpdoc":"LRAP is a protocol for configuring and controlling remote end devices. Reference the documents for more detail.","devicedetail.lrapview.logs.tableheader":"Operation Logs","devicedetail.lrapview.op":"Operation","devicedetail.lrapview.optime":"Time","devicedetail.lrapview.panel.header":"LRAP Registers","devicedetail.lrapview.payload":"Value","devicedetail.lrapview.port":"Port","devicedetail.lrapview.port.placeholder":"1~223, default: 223","devicedetail.lrapview.readsubmit.btn":"Read Register","devicedetail.lrapview.readsubmit.btn.error":"Read request error","devicedetail.lrapview.readsubmit.btn.success":"Read request success","devicedetail.lrapview.readsubmit.tips":"Read request sent, see operation logs for response later.","devicedetail.lrapview.register":"Register ID","devicedetail.lrapview.register.placeholder":"Select a register","devicedetail.lrapview.tabs.read.title":"Read Register","devicedetail.lrapview.tabs.write.title":"Write Register","devicedetail.lrapview.value":"Register Value","devicedetail.lrapview.value.placeholder":"Prefix: '0x'→Hex，'0b'→Binary","devicedetail.lrapview.writesubmit.btn":"Write Register","devicedetail.lrapview.writesubmit.btn.error":"Write error","devicedetail.lrapview.writesubmit.btn.success":"Write success","devicedetail.lrapview.writesubmit.tips":"Write request sent, see operation logs for response later.","devicedetail.macview.checkqueue":"check queue","devicedetail.macview.dlchannelreq.chindex.placeholder":"Channel ID, 1 to 15","devicedetail.macview.dlchannelreq.freq.placeholder":"Base on the ISM band plan, In HZ/100","devicedetail.macview.dutycyclereq.maxdc.placeholder":"Integer of range [0, 15]","devicedetail.macview.E.BADARG":"Bad argument","devicedetail.macview.E.CONFLICT":"Pending command found","devicedetail.macview.E.FE_EMPTY":"Cannot be empty","devicedetail.macview.E.FE_INVALID":"Wrong parameter","devicedetail.macview.E.GENERALERROR":"Send error","devicedetail.macview.E.UNAPPLICABLE":"Command unapplicable","devicedetail.macview.E.UNSUPPORTED":"Command unsupported","devicedetail.macview.E.UNKNOWN":"Server error","devicedetail.macview.error.empty":"Cannot be empty","devicedetail.macview.error.invalidfmt":"Invalid format","devicedetail.macview.linkadrreq.chmask.placeholder":"Integer of range [0, 65535]","devicedetail.macview.linkadrreq.chmaskcntl.placeholder":"Integer of range [0, 7]","devicedetail.macview.linkadrreq.datarate.placeholder":"Integer of range [0, 15]","devicedetail.macview.linkadrreq.nbtrans.placeholder":"Integer of range [0, 15]","devicedetail.macview.linkadrreq.txpower.placeholder":"Integer of range [0, 15]","devicedetail.macview.maccommand":"MAC Command","devicedetail.macview.maclog.maccommand":"MAC Command","devicedetail.macview.maclog.maclog":"MAC command log","devicedetail.macview.maclog.parameter":"Parameter","devicedetail.macview.maclog.parameter.data":"Parameter Data","devicedetail.macview.maclog.time":"Time","devicedetail.macview.newchannelreq.chindex.placeholder":"Channel ID, 1 to 15","devicedetail.macview.newchannelreq.freq.placeholder":"Base on the ISM band plan, In HZ/100","devicedetail.macview.newchannelreq.maxdr.placeholder":"Max Data Rate, 1 to 15","devicedetail.macview.newchannelreq.mindr.placeholder":"Min Data Rate, 1 to 15","devicedetail.macview.refresh":"Refresh","devicedetail.macview.rxparamsetupreq.rx1droffset.placeholder":"Integer of range [0, 5]","devicedetail.macview.rxparamsetupreq.rx2dr.placeholder":"Integer of range [0, 13]","devicedetail.macview.rxparamsetupreq.rx2freq.placeholder":"Base on the ISM band plan, In HZ/100","devicedetail.macview.rxtimingsetupreq.delay.placeholder":"Integer of range [0, 15]","devicedetail.macview.selectmac":"MAC command","devicedetail.macview.senderr.arg":"Argument wrong","devicedetail.macview.senderr.freq":"Frequency wrong","devicedetail.macview.senderr.mindr":"Min DR wrong","devicedetail.macview.senderr.pending":"Pending command found","devicedetail.macview.sendqueue":"Sending queue","devicedetail.macview.submit":"Send command","devicedetail.macview.submit.failure":"Send failed","devicedetail.macview.submit.success":"Send success","devicedetail.macview.time":"Time","devicedetail.macview.txparamsetupreq.dldwelltime.placeholder":"0~1","devicedetail.macview.txparamsetupreq.maxeirp":"Max EIRP","devicedetail.macview.txparamsetupreq.maxeirp.placeholder":"Integer of range [0, 15]","devicedetail.macview.txparamsetupreq.uldwelltime.placeholder":"0~1","devicedetail.macview.updchplanreq.chplan":"Channel Plan","devicedetail.macview.updchplanreq.chplan.placeholder":"Select a channel plan","devicedetail.macview.addbroadcastreq.devaddr.placeholder":"A string of length 8","devicedetail.macview.addbroadcastreq.keys.placeholder":"A string of length 32","devicedetail.macview.addbroadcastreq.fcnt.placeholder":"32-bit unsigned integer","devicedetail.macview.addbroadcastreq.address.label":"Broadcast Address","devicedetail.macview.addbroadcastreq.appskey.label":"App Key","devicedetail.macview.addbroadcastreq.nwskey.label":"Network Key","devicedetail.macview.addbroadcastreq.address":"Broadcast Address","devicedetail.macview.addbroadcastreq.fcnt":"Seq No.","devicedetail.macview.E.FE_INVALIDAPPKEY":"Invalid Key","devicedetail.macview.E.FE_INVALIDADDR":"Invalid Address","devicedetail.macview.E.INVALID_FCNT":"Invalid Seq No.","devicedetail.macview.E.BADARG_FCNT":"Invalid Seq No.","devicedetail.map.address":"Address","devicedetail.map.devaddr":"DevAddr","devicedetail.map.deveui":"DevEUI","devicedetail.map.id":"Device ID","devicedetail.map.name":"Name","devicedetail.sidebar.menu.datatool":"Data Tools","devicedetail.sidebar.menu.devicelog":"Log","devicedetail.sidebar.menu.detail":"Detail","devicedetail.sidebar.menu.lrap":"LRAP","devicedetail.sidebar.menu.maccommand":"MAC Cmd","devicedetail.sidebar.menu.scheme":"Band","devicedetail.sidebar.menu.stat":"Statistics","devicedetail.sidebar.menu.topo":"Topology","devicedetail.sidebar.title":"Detail","devicedetail.statview.button.day":"Daily","devicedetail.statview.button.hour":"Hourly","devicedetail.statview.button.month":"Monthly","devicedetail.statview.devicestatus":"Status","devicedetail.statview.gatewaymac":"Gateway MAC","devicedetail.statview.series.devicestatus":"Status","devicedetail.statview.series.droppedpackets":"Dropped Packets","devicedetail.statview.series.packets":"Packets","devicedetail.statview.timerange":"Time","devicedetail.statview.timerange.lbl":"Time","devicedetail.topoview.best":"Best","devicedetail.topoview.data.bandwidth":"Bandwidth","devicedetail.topoview.data.bitrate":"Bit Rates(bits/sec)","devicedetail.topoview.data.dr":"Data Rate","devicedetail.topoview.data.fcnt":"Sequence","devicedetail.topoview.data.gateway":"Gateway","devicedetail.topoview.data.modulation":"Modulation","devicedetail.topoview.data.sf":"Spread Factor","devicedetail.topoview.data.time":"Last Connect Time","devicedetail.topoview.data.delete":"Delete","devicedetail.topoview.header":"Gateway Links","devicedetail.topoview.deflink.add":"Add","devicedetail.topoview.deflink.gatewayid":"Gateway","devicedetail.topoview.deflink.empty":"Cannot be empty","devicedetail.topoview.deflink.confirm":"Confirm","devicedetail.topoview.deflink.downlink":"Default Downlink","devicedetail.topoview.deflink.delete":"Delete Downlink","devicedetail.topoview.deflink.deletetip":"Confirm to delete the default downlink","devicedetail.topoview.E.GENERALERROR":"Server Error","devicedetail.topoview.E.null":" ","devicedetail.devicelog.header":"Log","devicedetail.devicelog.thead.code":"Code","devicedetail.devicelog.thead.loglevel":"Level","devicedetail.devicelog.thead.remark":"Detail","devicedetail.devicelog.thead.time":"Time","gateway.addgateway.adderr.modalheader":"Add Gateway Error","gateway.addgateway.adderr.outofquota.comm":"Sorry, you are out of gateway quota. Contact us for creating more.","gateway.addgateway.adderr.outofquota.cube":"Sorry, you are out of gateway quota. Contact us for creating more.","gateway.addgateway.adderr.outofquota.undercomm":"Sorry, you are out of gateway quota. Upgrade your account to create more.","gateway.addgateway.adderr.upgrade":"Upgrade","gateway.address":"Area","gateway.area":"City","gateway.gateway":"Gateway","gateway.list.search.placeholder":"Enter to search","gateway.log.daterange.label":"Log Time","gateway.mac":"MAC Address","gateway.map.search.placeholder":"Enter to search gateway","gateway.map.nogateway":"No gateway","gateway.name":"Name","gateway.platform":"Platform Model","gateway.band":"Band","gateway.status":"Status","gateway.coord":"Coordinate","gateway.tooltip.list":"My Gateways","gateway.tooltip.log":"Gateway Log","gateway.tooltip.map":"Gateway Map","gateway.version":"SDK version","gateway.map.id":"Gateway ID","gateway.map.mac":"MAC","gateway.map.address":"Address","gateway.map.name":"Name","gateway.map.status":"Status","gateway.map.status.connected":"Connected","gateway.map.status.disconnected":"Disconnected","gatewaydetail.breadcrumbs.gatewayadd":"Add Gateway","gatewaydetail.breadcrumbs.gateways":"My Gateways","gatewaydetail.datadir.down.btn":"Downlink","gatewaydetail.datadir.up.btn":"Uplink","gatewaydetail.detailview.auth.title":"Authentication","gatewaydetail.detailview.band.nav":"Configuration","gatewaydetail.detailview.band.toolbarbutton.back":"Back","gatewaydetail.detailview.band.unkowntips":"Data is not reported","gatewaydetail.detailview.band.unkowntips.reason1":"Check if your gateway is connected","gatewaydetail.detailview.band.unkowntips.reason2":"Make sure with latest version SDK installed","gatewaydetail.detailview.band.unkowntips.reason3":"Not supported by your gateway","gatewaydetail.detailview.delete":"Delete","gatewaydetail.detailview.delete.cancelbtn":"Cancel","gatewaydetail.detailview.delete.confirmbtn":"Yes","gatewaydetail.detailview.delete.deleting":"Deleting","gatewaydetail.detailview.delete.failure":"Delete failed","gatewaydetail.detailview.delete.modalcontent":"Delete gateway ","gatewaydetail.detailview.delete.modalheader":"Delete Gateway","gatewaydetail.detailview.delete.success":"Delete success","gatewaydetail.detailview.E.FE_INVALIDLAT":"Invalid latitude","gatewaydetail.detailview.E.FE_INVALIDLNG":"Invalid longitude","gatewaydetail.detailview.E.UNAPPLICABLE":"No route to gateway","gatewaydetail.detailview.E.NOROUTE":"No route to gateway","gatewaydetail.detailview.E.GENERALERROR":"Server error","gatewaydetail.detailview.E.UNKNOWN":"Network error","gatewaydetail.detailview.E.UNSUPPORTED":"Unsupported","gatewaydetail.detailview.E.WONTRESTORED":"Write failed. Cannot recover, pktfwd process is stop now.","gatewaydetail.detailview.E.RESTORED":"Write failed. The original configuration is restored, pktfwd process is restarted.","gatewaydetail.detailview.E.FACTORYRESTORED":"Write failed. Reset to the factory settings since the original configuration cannot be restored. pktfwd process is restarted.","gatewaydetail.detailview.E.TIMEOUT":"Write Time Out","gatewaydetail.detailview.gatewaylist.connected":"Connected","gatewaydetail.detailview.gatewaylist.disconnected":"Disconnected","gatewaydetail.detailview.gatewaylist.header":"Gateways","gatewaydetail.detailview.gatewaylist.tipGateway":"gateway doesn't exist,please add new gateway","gatewaydetail.detailview.gatewaylist.nogateway":"No gateways","gatewaydetail.detailview.gatewaylist.buygateway":"Get a gateway","gatewaydetail.detailview.latestdata.header":"Latest Messages","gatewaydetail.detailview.location.address":"Address","gatewaydetail.detailview.location.area":"Area","gatewaydetail.detailview.location.city":"City","gatewaydetail.detailview.location.coordinate":"Coordinate","gatewaydetail.detailview.location.altitude":"Altitude","gatewaydetail.detailview.location.editcoordinate":"edit coordinate","gatewaydetail.detailview.location.title":"Location","gatewaydetail.detailview.loraparams.title":"LoRa Parameters","gatewaydetail.detailview.netstatus.laston":"Recent Connecting","gatewaydetail.detailview.netstatus.lastpacket":"Recent Packet","gatewaydetail.detailview.netstatus.latency":"Latency","gatewaydetail.detailview.netstatus.status":"Status","gatewaydetail.detailview.netstatus.status.connected":"Connected","gatewaydetail.detailview.netstatus.status.disconnected":"Disconnected","gatewaydetail.detailview.netstatus.title":"Status","gatewaydetail.detailview.newdata.thead.time":"Time","gatewaydetail.detailview.noauth":"No authentication","gatewaydetail.detailview.panel.header.gwstat":"Latest Stats","gatewaydetail.detailview.ping":"Ping","gatewaydetail.detailview.pingfail":"Ping failed!","gatewaydetail.detailview.pingsucc":"Ping succeed!","gatewaydetail.detailview.properties.id":"ID","gatewaydetail.detailview.properties.mac":"MAC","gatewaydetail.detailview.properties.name":"Name","gatewaydetail.detailview.properties.platform":"Platform","gatewaydetail.detailview.properties.ip":"IP Address","gatewaydetail.detailview.properties.title":"Properties","gatewaydetail.detailview.restart":"Reboot","gatewaydetail.detailview.restartfail":"Reboot failed!","gatewaydetail.detailview.restartsucc":"Rebooted!","gatewaydetail.detailview.upgradeSDK":"Upgrade SDK","gatewaydetail.detailview.NoSupportUpSDK":"No support upgrade","gatewaydetail.detailview.NoUpgradeSDK":"No new version","gatewaydetail.detailview.sugUpgrade":"A new version","gatewaydetail.detailview.currentVer":"Current version","gatewaydetail.detailview.newVer":"New version","gatewaydetail.detailview.upgrade.cancelbtn":"Cancel","gatewaydetail.detailview.upgradeSDKDur":"Start the upgrade","gatewaydetail.detailview.upgradeSDKfail":"Upgrade failed","gatewaydetail.detailview.upgradeSDKSuccTips":"The upgrade is in progress and the gateway automatically connects after the upgrade is complete","gatewaydetail.detailview.sdk.dl":"Download","gatewaydetail.detailview.sdk.docdl":"Documents","gatewaydetail.detailview.sdk.sdkdl":"SDK","gatewaydetail.detailview.sdk.version":"Version","gatewaydetail.detailview.sdk.view":"View","gatewaydetail.detailview.toolbarbutton.band":"Band","gatewaydetail.detailview.txpower.opts.default":"default","gatewaydetail.detailview.chplan":"Channel Plan","gatewaydetail.detailview.chplan.unbind":"Empty","gatewaydetail.detailview.chplan.flush":"Write to gateway","gatewaydetail.detailview.chplan.flush.failure":"Failed, re-write","gatewaydetail.detailview.tokenmanage":"Token","gatewaydetail.E.BADTOKEN":"Session outdated, refresh page to login","gatewaydetail.E.NOTFOUND":"Gateway Not Found","gatewaydetail.E.UNKNOWN":"Network error","gatewaydetail.error.goback":"Back to Gateways","gatewaydetail.gatewayadd.button.fail":"Add Failed!","gatewaydetail.gatewayadd.button.pending":"Adding","gatewaydetail.gatewayadd.button.submit":"Submit","gatewaydetail.gatewayadd.button.succ":"Add Succeed!","gatewaydetail.gatewayadd.E.FE_EMPTY":"Cannot be empty","gatewaydetail.gatewayadd.E.FE_MACINVALID":"Invalid MAC Address Format","gatewaydetail.gatewayadd.E.MACADDRUNAVAIL":"Duplicated MAC address","gatewaydetail.gatewayadd.E.QUOTA":"Out of quota","gatewaydetail.gatewayadd.field.addr":"Address","gatewaydetail.gatewayadd.field.area":"Area","gatewaydetail.gatewayadd.field.city":"City","gatewaydetail.gatewayadd.field.mac":"MAC address","gatewaydetail.gatewayadd.field.mac.explain":"Gateway MAC address will be used during the connection.","gatewaydetail.gatewayadd.field.name":"Gateway name","gatewaydetail.gatewayadd.field.platform":"Gateway model","gatewaydetail.gatewayadd.field.platform.explain":"Gateway model determines gateway SDK and installation guidance.","gatewaydetail.gatewayadd.fieldgroups.location":"Location","gatewaydetail.gatewayadd.fieldgroups.location.explain":"Add gateway location to help tracking","gatewaydetail.gatewayadd.gateway":"Gateway","gatewaydetail.gatewayadd.tip.createGatewayFailTip":"fail to regiester the existed MAC address.","gatewaydetail.logview.daterangepicker.label":"Time Range","gatewaydetail.menu.conf":"Configuration","gatewaydetail.menu.datamsg":"Data Messages","gatewaydetail.menu.detail":"Detail","gatewaydetail.menu.log":"Logs","gatewaydetail.menu.stat":"Statistics","gatewaydetail.sidebar.title":"Gateway","gatewaydetail.statschart.axis.latency":"Latency(ms)","gatewaydetail.statschart.axis.pkts":"Packets","gatewaydetail.statschart.axis.ms":"Milliseconds","gatewaydetail.statschart.axis.ratio":"Percent","gatewaydetail.statschart.name.freqratio":"Packets Ratio By Frequency","gatewaydetail.statschart.name.pktdistr":"Packets Ratio","gatewaydetail.statschart.name.sfratio":"Packets Ratio By SF","gatewaydetail.statschart.series.latency":"Latency","gatewaydetail.statschart.series.pkts":"Total Packets","gatewaydetail.statschart.series.pktsau":"Authorized Packets","gatewaydetail.statschart.series.pktsun":"Unauthorized Packets","gatewaydetail.statview.data.header":"Data Messages","gatewaydetail.statview.daterangepicker.label":"Time","gatewaydetail.statview.fields.messagedata":"Data Messages","gatewaydetail.statview.fields.radio":"Radio Parameters","gatewaydetail.statview.fields.spills.datamsg":"Data Messages","gatewaydetail.statview.fields.spills.radio":"Radio Parameters","gatewaydetail.statview.packetstat.byfreq":"Distribution By Frequency(MHZ)","gatewaydetail.statview.packetstat.bysf":"Distribution By SF","gatewaydetail.statview.packetstat.packets":"Packets Statistics","gatewaydetail.statview.toastat.byfreq.uplink":"Channel UpLink TOA Statistics","gatewaydetail.statview.toolbar.bytime.minutes":"Ten Minute","gatewaydetail.statview.toolbar.bytime.days":"Daily","gatewaydetail.statview.toolbar.bytime.hours":"Hourly","gatewaydetail.statview.toolbar.bytime.months":"Monthly","gatewaydetail.statview.toolbar.daterangepicker":"Time range","gatewaydetail.statview.toolbar.dataview.ratio":"Ratio","gatewaydetail.statview.toolbar.dataview.ms":"Milli-seconds","gatewaydetail.statview.tabs.packets":"Packet Statistics","gatewaydetail.statview.tabs.tao":"TOA(Time On Air) Statistics","gatewaydetail.statview.unconfirmeddataup":"UnconfirmedDataUp","gatewaydetail.statview.unconfirmeddatadown":"UnconfirmedDataDown","gatewaydetail.statview.confirmeddataup":"ConfirmedDataUp","gatewaydetail.statview.confirmeddatadown":"ConfirmedDataDown","gatewaydetail.statview.joinrequest":"JoinRequest","gatewaydetail.statview.joinaccept":"JoinAccept","gatewaydetail.statview.rfu":"RFU","gatewaydetail.statview.proprietary":"Proprietary","gatewaydetail.detailview.unconfirmeddataup":"UnconfirmedDataUp","gatewaydetail.detailview.unconfirmeddatadown":"UnconfirmedDataDown","gatewaydetail.detailview.confirmeddataup":"ConfirmedDataUp","gatewaydetail.detailview.confirmeddatadown":"ConfirmedDataDown","gatewaydetail.detailview.joinrequest":"JoinRequest","gatewaydetail.detailview.joinaccept":"JoinAccept","gatewaydetail.detailview.rfu":"RFU","gatewaydetail.detailview.proprietary":"Proprietary","gatewaylog.thead.cat":"Log Level","gatewaylog.thead.code":"Log Code","gatewaylog.thead.mac":"MAC Address","gatewaylog.thead.message":"Detail","gatewaylog.thead.panelheader":"Gateway Log","gatewaylog.thead.time":"time","gatewaylog.nodata":"No log","login.E.ACCINACTIVE":"Account not activated","login.E.BADACCOUNT":"Wrong email or password","login.E.BADPASSWORD":"Wrong email or password","login.E.FE_EMAILEMPTY":"Please enter login email","login.E.FE_PASSWORDEMPTY":"Please enter password","login.E.UNKNOWN":"Login error","login.E.GENERALERROR":"Server error","login.button":"Log in","login.email.placeholder":"Email","login.forgetpwd":"Forget password","login.password.placeholder":"Password","login.signup":"Sign up","login.title":"Sign in loraFlow","login.reactivate":"Re-send activation mail","login.reactivate.success":"Activation mail sent!","login.reactivate.failure":"Send error! Click to retry","login.reactivate.pending":"Sending","lostpassword.title":"Reset Password","lostpassword.submit":"Submit","lostpassword.submit.success":"Submit success","lostpassword.submit.failure":"Submit failed","lostpassword.submit.pending":"Submitting","lostpassword.email":"Email","lostpassword.email.placeholder":"Login email","lostpassword.verifycode":"Verify Code","lostpassword.E.FE_EMPTY":"Cannot be empty","lostpassword.E.FE_INVALIDEMAIL":"Invalid Email","lostpassword.E.BADVERIFY":"Verify code wrong","lostpassword.E.BADACCOUNT":"Account not exist","lostpassword.E.GENERALERROR":"Network error, please try later","lostpassword.E.ACCINACTIVE":"Account inactive","lostpassword.success.h1":"One more step to complete reset password","lostpassword.success.p1":"We've sent a activation email to ","lostpassword.success.p2":", click the activation link to complete your password reseting.","lostpassword.success.btn":"Check mail now","lostpassword.success.footer.h3":"No email received?","lostpassword.success.footer.li1":"Check recycle bin or junk mails in your mailbox","lostpassword.success.footer.li2.txt1":"Click here","lostpassword.success.footer.li2.txt2":"to reset password with a different Email","mapoverlay.edit":"Pick a location","mapoverlay.submit":"Save location","network.adrview.E.GENERALERROR":"Server error, unable to set ADR","network.adrview.E.UNKNOWN":"Network error","network.adrview.switch.off":"Off","network.adrview.switch.on":"On","network.adrview.tips.title":"Tips:","network.adrview.tips1":"After ADR is enabled, You can view ADR status and logs in device detail.","network.adrview.tips2":"After ADR is enabled, Network server will apply ADR to devices continuously.","network.adrview.tips3":"No matter ADR is enabled or not, you can adjust ADR parameters with MAC commands manually.","network.analytics.gateway.flow":"Uplink traffic volume","network.analytics.gateway.flow.help":"Flow: Uplink traffic volume per day","network.analytics.gateway.gateway":"gateway","network.analytics.gateway.invalid_pre":"Redunduncy","network.analytics.gateway.invalid_pre.help":"Redunduncy: Redunduncy per day","network.analytics.gateway.name":"name","network.analytics.gateway.node":"DevEUI","network.analytics.gateway.pie.flow.1":"< 1MB","network.analytics.gateway.pie.flow.2":" >1MB and <10MB","network.analytics.gateway.pie.flow.3":">10MB","network.analytics.gateway.pie.invalid_pre.1":"<10%","network.analytics.gateway.pie.invalid_pre.2":"> 10% and < 30%","network.analytics.gateway.pie.invalid_pre.3":"> 30% and < 60%","network.analytics.gateway.pie.invalid_pre.4":"> 60% and <90%","network.analytics.gateway.pie.invalid_pre.5":"> 90%","network.analytics.gateway.pie.title.flow":"Gateway Distribution(By Flow)","network.analytics.gateway.pie.title.invalid_pre":"Gateway Distribution(By Redunduncy)","network.analytics.gateway.pie.title.toa":"Gateway Distribution(By TOA)","network.analytics.gateway.pie.toa.1":"< one minute","network.analytics.gateway.pie.toa.2":"> one minute and < one hour","network.analytics.gateway.pie.toa.3":"> one hour","network.analytics.gateway.rank":"index","network.analytics.gateway.rank.gateway":"Gateway Analytics","network.analytics.gateway.rank.node":"Relevant Nodes","network.analytics.gateway.title":"Gateway Analytics","network.analytics.gateway.toa":"TOA","network.analytics.gateway.toa.help":"TOA: Sum of TOA(Time on Air) per day","network.analytics.gateway.total.help":"Gateway Analytics:","network.analytics.node.appeui":"APPEUI","network.analytics.node.deveui":"DevEUI","network.analytics.node.loss_pre":"PER","network.analytics.node.loss_pre.help":"Packet error ratio per day","network.analytics.node.overtime":"overtime","network.analytics.node.pre":"pre","network.analytics.node.rank":"index","network.analytics.node.rssi":"RSSI","network.analytics.node.rssi.help":"Average Rssi value","network.analytics.node.snr":"SNR","network.analytics.node.snr.help":"Average SNR value","network.analytics.node.toa":"TOA","network.analytics.node.toa.help":"Sum of TOA(Time on Air) per day","network.banddetail.deletemodal.cancel":"Cancel","network.banddetail.deletemodal.confirm":"Confirm","network.banddetail.deletemodal.E.BUSY":"Delete failed! Cannot delete band plan in use.","network.banddetail.deletemodal.E.GENERALERROR":"Server error","network.banddetail.deletemodal.E.UNKNOWN":"Delete failed!","network.banddetail.deletemodal.header":"Delete failed Prompt","network.banddetail.deletemodal.title":"Delete Band Plan","network.banddetail.detailview.channeltag":"Reserved","network.banddetail.detailview.deletebtn":"Delete Plan","network.banddetail.detailview.label.ctime":"Create Time","network.banddetail.detailview.panelhead.channellist":"Channel List","network.banddetail.detailview.renderchannelhead":"Channel","network.banddetail.detailview.renderdetail.title":"Plan Properties","network.banddetail.detailview.tabletd.freechannel":"Free","network.banddetail.detailview.tabletd.reservedchannel":"Reserved","network.banddetail.detailview.tableth.channelid":"Channel ID","network.banddetail.detailview.tableth.define":"Channel Type","network.banddetail.detailview.tableth.type":"Modulation","network.banddetail.detailview.toolbar.firstnav":"Channel Plans","network.banddetail.menuitems.detail":"Detail","network.banddetail.sidebar.title":"Channel Plan","network.bandview.addplan":"Add channel plan","network.bandview.tableth.band":"Band","network.bandview.tableth.channels":"Channels","network.bandview.tableth.createtime":"Create Time","network.bandview.tableth.fixed":"Reserved Channel","network.bandview.tableth.name":"Name","network.bandview.tableth.unfixed":"Editable Channel","network.bandview.title":"Channel Plans","network.channelview.add.band":"Band","network.channelview.channelnumber":"Number of channels","network.channelview.add.firstnav":"Channel Plan","network.channelview.add.fixed.available":"Available","network.channelview.add.fixed.full":"Out of limit","network.channelview.add.fixed.selected":"Selected","network.channelview.add.fixed.restrict":"Available with caution","network.channelview.add.fixed.restrict.caution":"The frequencies of channel 6~38, 45~77 might be used in China power industry.","network.channelview.add.free.freq":"Frequency(MHz)","network.channelview.add.free.type":"Channel Type","network.channelview.add.free.addch":"Add Channel","network.channelview.add.free.E.FE_EMPTY":"Cannot be empty","network.channelview.add.free.E.FE_INVALIDFREQ":"Invalid frequency","network.channelview.add.free.E.FE_DUPFREQ":"Duplicated frequency","network.channelview.add.free.E.FE_MINGTMAX":"MinDR cannot be greater than MaxDR","network.channelview.E.FE_EMPTY":"Cannot Empty","network.channelview.add.E.FE_CHANNEL.EMPTY":"Empty Added Channels","network.channelview.add.name":"Name","network.channelview.add.name.placeholder":"Enter a readable name","network.channelview.add.panelheader":"Create channel plan","network.channelview.add.secondnav":"Create Channel Plan","network.channelview.add.submit":"Create","network.channelview.add.channels.header":"Added channels","network.channelview.add.channels.id":"ID","network.channelview.add.channels.type":"Type","network.channelview.add.channels.freq":"Frequency(MHz)","network.channelview.add.channels.define":"Definition","network.channelview.add.channels.selecttips":"Edit or select to add channels","network.channelview.add.channels.delete":"Remove","network.channelview.add.channels.edit":"Edit","network.channelview.add.channels.reserved":"Reserved","network.channelview.add.E.FE_EMPTY":"Cannot be empty","network.channelview.add.E.GENERALERROR":"Server error","network.channelview.add.E.UNKNOWN":"Network error","network.channelview.add.nametip":"No more than 32 characters in length","network.channelview.editdr.header":"Edit DR","network.channelview.editdr.mindr":"Min DR","network.channelview.editdr.maxdr":"Max DR","network.channelview.editdr.button.confirm":"Confirm","network.channelview.editdr.E.FE_MINGTMAX":"MinDR cannot be greater than MaxDR","network.schemeadd.addchanellimit":"exceeded","network.schemeadd.addchannel.btn":"Add Channel","network.schemeadd.addchannelbtn.tooltipmsg":"Add to Selected Queue","network.schemeadd.channelparameter":"Channel parameters","network.schemeadd.channelslimit":"Up to 16 channels can be added!","network.schemeadd.drvaliderr":"Values range from 0 to 15","network.schemeadd.drvalidinteger":"Value is integers","network.schemeadd.explain.p1":"Channel Index ","network.schemeadd.explain.p2":"6 to 38 and 45 to 77 ","network.schemeadd.explain.p3":"are mainly used by China Electric Power. In the areas where these channels are used by China Electric Power, ","network.schemeadd.explain.p4":"they should be disabled.","network.schemeadd.explain.p5":"Originate From ","network.schemeadd.fixederr":"Fixed value can not greater than channel's length","network.schemeadd.formlabel.fixed":"Retain Channel","network.schemeadd.formplaceholder.bandname":"Enter the band name","network.schemeadd.formplaceholder.fixed":"Enter the part of band plan only can read","network.schemeadd.formplaceholder.freq":"Enter the frequence between 100 and 1670(MHZ)","network.schemeadd.formplaceholder.maxdr":"Max DataRate value between 0 and 15","network.schemeadd.formplaceholder.mindr":"Min DataRate value between 0 and 15","network.schemeadd.formplaceholder.planname":"Enter the band plan name","network.schemeadd.freqerr":"You can not have the same value for the frequency","network.schemeadd.freqintergervalid":"Up to 4 decimal places","network.schemeadd.freqvaliderr":"Values range from ","network.schemeadd.freqvaliderr.to":"to","network.schemeadd.label.channeltype":"Channel Type","network.schemeadd.maxdrerr":"Can not be smaller than Min DR","network.schemeadd.mindrerr":"Can not be greater than Max DR","network.schemeadd.modalhead.title":"Description of this channel","network.schemeadd.panelhead.addchannel":"Add channel","network.schemeadd.panelhead.pickchannel":"Select channel","network.schemeadd.panelhead.property":"Add property","network.schemeadd.panelheadright":"Add channel","network.schemeadd.reservedchanneltag":"Reserved","network.schemeadd.submiterr.err":" error","network.schemeadd.submiterr.frequence":"Frequence","network.schemeadd.submiterr.nochannel":" No channel added!","network.schemeadd.tabletd.freechannel":"Free","network.schemeadd.tabletd.reservedchannel":"Reserved","network.schemeadd.tabletd.tooltipmsg":"Reserved channels can not be edited","network.signalcoverageview.description.heading":"Maximum Signal Coverage","network.signalcoverageview.title":"Coverage Calculator","network.signalcoverageview.transmitPower":"Transmit Power","network.signalcoverageview.structuralAttenuation":"Structural Attenuation","network.signalcoverageview.endNodeAntenna":"End Node Antenna Gain","network.signalcoverageview.gatewayAntenna":"Gateway Antenna Gain","network.signalcoverageview.fadeMargin":"Fade Margin","network.signalcoverageview.Sensitivity":"Sensitivity","network.signalcoverageview.gatewayAntennaHeight":"Gateway Antenna Height","network.signalcoverageview.endNodeHeight":"End Node Height","network.sidebar.menuitems.band":"Channel Plan","network.sidebar.menuitems.gateway":"Gateway Analytics","network.sidebar.menuitems.node":"Node Analytics","network.sidebar.menuitems.coverage":"Coverage Calculation","network.sidebar.menuitems.quality":"Network Quality","network.sidebar.menuitems.capacity":"Network Load","network.sidebar.menuitems.capacityCalculation":"Capacity Calculation","network.sidebar.menuitems.unauthorized":"Unauthorized Packets","network.sidebar.menuitems.roadtest":"Road Test","network.sidebar.menuitems.tdm":"TDM","network.sidebar.menuitems.tdmstatis":"TDM Statistics","network.sidebar.title":"Network","network.qualityView.title":"Signal Quality","network.qualityView.deviceListHeader":"Device List","network.qualityView.deviceScatterHeader":"Device Scatter","network.qualityView.packetHeatmapHeader":"Network Quality Distribution","network.qualityView.header":"Network Quality","network.qualityView.hours":"Hours","network.qualityView.average":"Average","network.qualityView.loss":"Packet Loss","network.qualityView.density":"Density","network.qualityView.frequency":"Frequency","network.qualityView.thead.name":"Name","network.qualityView.thead.deveui":"DevEUI","network.qualityView.thead.packetLossRate":"Packet Loss Rate","network.qualityView.thead.snrAvg":"SNR Average","network.qualityView.thead.snrStd":"SNR Stddev","network.qualityView.thead.rssiAvg":"RSSI Average (dbm)","network.qualityView.thead.rssiStd":"RSSI Stddev (dbm)","network.qualityView.thead.toaAvg":"TOA Average (ms)","network.qualityView.thead.toaSum":"TOA Sum (ms)","network.qualityView.thead.upPacketCount":"UpLink Packets (Lost/Total)","network.capacityview.title":"Network Capacity","network.capacityview.tableHeader":"Device List","network.capacityview.hours":"Hours","network.capacityview.thead.name":"Name","network.capacityview.thead.deveui":"DevEUI","network.capacityview.thead.interval_median":"Interval Median (s)","network.capacityview.thead.interval_percentile":"90% Interval Time (s)","network.capacityview.thead.toa_median":"TOA Median (ms)","network.capacityview.thead.toa_percentile":"90% TOA Time (ms)","network.capacityview.thead.rate":"Redundancy Rate(%)","network.capacityview.thead.total":"Uplink Count","network.capacityview.thead.last_ts":"Latest Uplink Packet","network.capacityview.thead.total_toa":"TOA Total (ms)","network.capacityview.loadBarChartHeader":"Network Load","network.capacityview.freqBarChartHeader":"Frequency Load Distribution","network.capacityview.Load":"Load／Throughput","network.capacityview.LoadG":"Load","network.capacityview.LoadS":"Throughput","network.capacityview.Loss":"Packet Loss Rate","network.CapacityCalculationView.title":"Capacity Calculation","network.CapacityCalculationView.packetRatePerHour":"Packet Rate Per Hour Per Device","network.CapacityCalculationView.spreadFactor":"Spread Factor","network.CapacityCalculationView.payload":"Payload Length","network.CapacityCalculationView.channel":"Channel Number","network.CapacityCalculationView.description.heading":"Number of Devices on One Gateway","network.UnauthorizedPacketView.title":"Unauthorized Packets","network.UnauthorizedPacketView.tableHeader":"Unauthorized Packets List","network.UnauthorizedPacketView.hours":"Hours","network.UnauthorizedPacketView.thead.devaddr":"DevADDR","network.UnauthorizedPacketView.thead.deveui":"DevEUI","network.UnauthorizedPacketView.thead.gateway":"Gateway","network.UnauthorizedPacketView.thead.frequency":"Frequency","network.UnauthorizedPacketView.thead.toa_total":"TOA Total (s)","network.UnauthorizedPacketView.thead.total":"Packets Total","network.roadtest.title":"Road Test Instrument","network.roadtest.header.colorset":"Signal Setting","network.roadtest.header.radius":"Coverage","network.roadtest.selectdevice":"Select Device","network.roadtest.selectgateway":"Select Gateway","network.roadtest.selectgateway.search.placeholder":"Search Gateway","network.roadtest.radius.invalid":"Invalid radius","network.roadtest.radius.name":"Radius","network.roadtest.radius.confirm":"Confirm","network.roadtest.radius.cancel":"Cancel","network.roadtest.download":"Export Data","network.tdm.net.label":"Select TDM Network","network.tdm.net.update":"Update","network.tdm.net.upload":"Update","network.tdm.node.title":"TDM Nodes","network.tdm.node.add":"Node","network.tdm.node.batch":"Batch Import","network.tdm.node.batch.delete":"Batch Delete","network.tdm.node.batch.reset":"Batch Reset","network.tdm.node.reset":"Reset","network.tdm.node.name":"Name","network.tdm.node.nodata":"No data","network.tdm.node.nodetype":"Node Type","network.tdm.node.gateway.bind":"Gateway Bind","network.tdm.node.gateway.name":"Gateway Name","network.tdm.node.nodetype.all":"All","network.tdm.node.remark":"Remark","network.tdm.node.remark.placeholder":"Enter remark","network.tdm.node.search.placeholder":"Search","network.tdm.node.delete":"Delete","network.tdm.node.sf.default":"null","network.tdm.node.bind.default":"auto","network.tdm.node.create.header":"Add Node","network.tdm.node.create.apps":"Application","network.tdm.node.create.name":"Name","network.tdm.node.create.cancel":"Cancel","network.tdm.node.create.confirm":"Add","network.tdm.node.create.nodetype":"Node Type","network.tdm.node.create.gateway.bind":"Gateway Bind","network.tdm.node.create.search.placeholder":"Name, DevEUI","network.tdm.node.create.remark":"Remark","network.tdm.node.create.remark.placeholder":"Enter remark","network.tdm.node.create.FE_NO_CHECKED_NODES":"Node must with Node Type","network.tdm.node.create.sf.default":"null","network.tdm.node.create.bind.default":"auto","network.tdm.node.delete.title":"Delete Nodes","network.tdm.node.delete.confirm":"Delete","network.tdm.node.delete.cancel":"Cancel","network.tdm.node.delete.warn":"Make sure to delete the selected nodes","network.tdm.node.reset.title":"Batch Reset","network.tdm.node.reset.confirm":"Reset","network.tdm.node.reset.cancel":"Cancel","network.tdm.node.reset.warn":"Make sure to reset the selected nodes","network.tdm.node.reset.single.title":"Reset","network.tdm.node.reset.single.warn":"Make sure to reset the node","network.tdm.gateway.title":"TDM Gateways","network.tdm.gateway.add":"Gateway","network.tdm.gateway.gateway1":"Gateway1","network.tdm.gateway.gateway2":"Gateway2","network.tdm.gateway.model":"Model","network.tdm.gateway.type":"Type","network.tdm.gateway.penalty":"SNR Penalty factor","network.tdm.gateway.reset":"reset","network.tdm.gateway.delete":"Delete","network.tdm.gateway.nodata":"No data","network.tdm.gateway.mac1":"MAC ID","network.tdm.gateway.mac2":"MAC ID2","network.tdm.gateway.remark":"Remark","network.tdm.gateway.8channels":"8 Channels","network.tdm.gateway.16channels":"16 Channels","network.tdm.gateway.create.header":"Add TDM Gateway","network.tdm.gateway.create.8channels":"8 Channels","network.tdm.gateway.create.16channels":"16 Channels","network.tdm.gateway.create.type":"Type","network.tdm.gateway.create.id":"Gateway1","network.tdm.gateway.create.mac2":"Gateway2","network.tdm.gateway.create.penalty":"SNR Penalty factor(db)","network.tdm.gateway.create.remark":"Remark","network.tdm.gateway.create.confirm":"Add","network.tdm.gateway.create.cancel":"Cancel","network.tdm.gateway.create.E.FE_EMPTY":"Required","network.tdm.gateway.create.E.FE_GW_MUST_DIFFEFRENT":"Gateway must be unique","network.tdm.gateway.create.E.GENERALERROR":"TDM gateways must have Channel Plan","network.tdm.gateway.reset.title":"Reset","network.tdm.gateway.reset.content":"Make sure to reset the gateway","network.tdm.gateway.reset.confirm":"Reset","network.tdm.gateway.reset.cancel":"Cancel","network.tdm.pairs.title":"Pairs","network.tdm.pairs.add":"Pairs","network.tdm.pairs.name1":"功图名称","network.tdm.pairs.id1":"功图","network.tdm.pairs.name2":"电参名称","network.tdm.pairs.id2":"电参","network.tdm.pairs.batch":"Batch Import","network.tdm.pairs.nodata":"No data","network.tdm.pairs.remark":"Remark","network.tdm.pairs.remove":"Delete","network.tdm.pairs.batch.delete":"Batch Delete","network.tdm.pairs.search.placeholder":"Search","network.tdm.pairs.create.header":"Add Pairs","network.tdm.pairs.create.title.work":"功图","network.tdm.pairs.create.title.params":"电参","network.tdm.pairs.create.cancel":"Cancel","network.tdm.pairs.create.confirm":"Add","network.tdm.pairs.create.name":"Name","network.tdm.pairs.create.remark":"Remark","network.tdm.pairs.create.remove":"Remove","network.tdm.pairs.create.empty":"Empty","network.tdm.pairs.create.help":"Add up to 10 pairs at a time","network.tdm.pairs.delete.title":"Delete Pairs","network.tdm.pairs.delete.warn":"Make sure to delete the selected pairs?","network.tdm.pairs.delete.confirm":"Delete","network.tdm.pairs.delete.cancel":"Cancel","network.tdm.upload.header":"Upload Setting File","network.tdm.upload.cancel":"Cancel","network.tdm.upload.confirm":"Upload","network.tdm.upload.success":"Upload succeed","network.tdm.upload.failure":"Upload failed","network.tdm.upload.btn":"Choose file","network.tdm.upload.FE_JSON_ONLY":"JSON file only","network.tdm.upload.FILE_READER_ERROR":"Error in reading file","network.tdm.upload.REQUIRED_NODETYPES":"Required \"nodetypes\" field in JSON file","network.tdm.upload.REQUIRED_NETWORK":"Required \"networktypes\" field in JSON file","network.tdm.upload.UNSUPPORT_FILE_READER":"Your browser doesn't support FileReader, please change another","network.tdm.detailview.toolbar.firstnav":"TDM","network.tdm.gateway.status.basic.header":"Gateway Status","network.tdm.gateway.status.counters.header":"Gateway Counters","network.tdm.gateway.status.now":"Current Reference Time","network.tdm.gateway.status.ver":"Running Version","network.tdm.gateway.status.since":"Since","network.tdm.gateway.status.lastsync":"Last Sync Time","network.tdm.gateway.status.attfail":"Att Fail","network.tdm.gateway.status.attok":"Att Ok","network.tdm.gateway.status.overrun":"Over Run","network.tdm.gateway.status.statis.header":"Data Statistics","network.tdm.gateway.status.node.all":"All","network.tdm.gateway.status.node.work.map":"Work map","network.tdm.gateway.status.node.press":"Pressure","network.tdm.gateway.status.node.electri.param":"Electric Params","network.tdm.gateway.status.node.temp":"Temperature","network.tdm.gateway.channel.header":"Channels","network.tdm.gateway.channel.id":"Channel ID","network.tdm.gateway.channel.service":"Service ID","network.tdm.gateway.channel.used":"Allocated Time Slot","network.tdm.gateway.channel.free":"Unassigned Time Slot","network.tdm.gateway.channel.pie.header":"Time Slot Statistics","network.tdm.gateway.channel.pie.free":"Unassigned","network.tdm.gateway.channel.pie.used":"Allocated","network.tdm.gateway.channel.pie.service":"Service","network.tdm.node.status.basic.header":"Node Status","network.tdm.node.status.id":"Node ID","network.tdm.node.status.ver":"Version","network.tdm.node.status.roaming":"Roaming Gateway","network.tdm.node.status.accuracy":"Clock Accuracy","network.tdm.node.status.lastatt":"Last Registration","network.tdm.node.status.lastup":"Last Uplink","network.tdm.node.status.lastdn":"Last Down Time","network.tdm.node.status.nextup":"Expected Next Up","network.tdm.node.status.counter.header":"Node Counter","network.tdm.node.status.ackddown":"Downlink Confirmation","network.tdm.node.status.initdown":"Initial Downlinks","network.tdm.node.status.retrydown":"Retransmit Downlinks","network.tdm.node.status.tdmup":"TDM Uplinks","network.tdm.node.status.alohaup":"Aloha Uplinks","network.tdm.node.status.okassemble":"Successful Uplinks","network.tdm.node.channel.header":"Channels","network.tdm.node.channel.channel":"Channel ID","network.tdm.node.channel.service":"Service ID","network.tdm.node.channel.frame":"Frame","network.tdm.node.channel.offset":"Offset","network.tdm.node.channel.logs":"Allocation History","network.tdm.node.channel.startat":"Start At","network.tdm.node.channel.endat":"End At","network.tdm.node.channel.alohapercent":"Aloha Share","network.tdm.node.pie.header":"Uplinks Statistics","network.tdm.batch.node.title":"Import Nodes","network.tdm.batch.pairs.title":"Import Pairs","network.tdm.batch.dropzone.text":"Click or drop file here to import","network.tdm.batch.help.panelheader":"Example CSV File","network.tdm.batch.preview.cancel.btn":"Cancel","network.tdm.batch.preview.import.btn.seg1":"Import","network.tdm.batch.preview.import.btn.seg2":"nodes","network.tdm.batch.err.modalheader":"Import Error","network.tdm.batch.result.succ":"Succeeded","network.tdm.batch.result.notimport":"Not Imported","network.tdm.batch.result.summary.seg1":"Successfully imported","network.tdm.batch.result.summary.seg2":"Failed to imported","network.tdm.batch.result.summary.back":"Back","network.tdm.batch.result.thead.status":"Import Status","network.tdm.batch.result.summary.reimport":"Import more","network.tdm.batch.E.GENERALERROR":"Node already imported","network.tdm.batch.result.fail":"Import Failed","network.tdm.batch.E.NOTFOUND":"DevEUI not exist","network.tdm.batch.E.GTW.NOTFOUND":"Gateway no exist","network.tdmstatis.title":"TDM Network Quality Statistics\"","network.tdmstatis.offset":"Offset","network.tdmstatis.gateway":"Channel","network.tdmstatis.service":"Service","network.tdmstatis.normal":"Power Normal","network.tdmstatis.gongtu":"Power map","network.tdmstatis.diancan":"Electric parameters normal","network.tdmstatis.dianliutu":"Electric current graph","network.tdmstatis.temperature":"Temperature","network.tdmstatis.pressure":"Pressure","network.tdmstatis.gtwtitle":"Gateway name","network.tdmstatis.sum":"Sum","network.tdmstatis.num":"Total","network.tdmstatis.average":"Average","network.nopoint":"No device selected","network.selectedpoint":"Selected point:","overview.application":"Apps","overview.device":"Devices","overview.gateway":"Gateways","overview.greeting":"Welcome to AISenz LoRaWAN IOT platform","overview.search.placeholder":"Search Gateways / Applications / Devices","overview.search.seemore":"View more","overview.search.gateways":"Gateways","overview.search.apps":"Applications","overview.search.devices":"Devices","overview.billing.balance":"Balance:","overview.billing.yuan":"Yuan","overview.billing.recharge":"Recharge","overview.billing.tier.free":"You're in a free plan.","overview.billing.tier.remaining":"Remaining service time is","overview.billing.tier.day":"Days","overview.billing.tier.svcpkg":"You're in a service package plan.","overview.billing.tier.comm":"You're in an enterprise plan.","overview.billing.tier.comm.billday":"Your billing day is","overview.billing.tier.comm.arrear.willstop.prefix":"Your service will be stopped in ","overview.billing.tier.comm.arrear.willstop.postfix":" days. Recharge please.","overview.billing.promote.upgrade":"Upgrade","overview.billing.cube.welcome":"Welcome to LoRaCube!","overview.devicemap":"Device Map","overview.gatewaymap":"Gateway Map","profile.coms.richform.actionbutton.title":"Password is successfully changed","profile.coms.richform.error.null":"Cannot be empty","profile.coms.richform.oldpasswordfailed":"The old password is incorrect","profile.coms.richform.panelright.title":"Change Password","profile.coms.richform.submitFailed":"Password modification failed","register.agree":"Please confirm and agree","register.captcha":"Verify code","register.captcha.loadfailed":"Load error","register.company":"Company","register.company.placeholder":"Your company name","register.E.BADVERIFY":"Wrong verify code","register.E.EMAILREGISTERED":"Email not available","register.E.UNKNOWN":"Network error","register.E.GENERALERROR":"Server error","register.E.FE_EMAILOCCUPIED":"Email not available","register.E.FE_EMPTY":"Cannot be empty","register.E.FE_INVALIDEMAIL":"Invalid Email","register.E.FE_NETWORKFAIL":"Network error","register.E.FE_PASSWORDEMPTY":"Cannot be empty","register.E.FE_PASSWORDINVALIDLEN":"Length must between 6 and 16","register.email":"Email","register.email.placeholder":"Your email","register.name":"Name","register.name.placeholder":"Your name","register.password":"Password","register.password.placeholder":"Password","register.policy":"privacy policy and service agreement","register.result.accepted.gotoemail":"Check mail now","register.result.accepted.laststep":"One more step to complete sign up","register.result.accepted.mailsent.p1":"We've sent a activation email to ","register.result.accepted.mailsent.p2":", click the activation link to complete your registration.","register.result.accepted.notreceive":"No email received?","register.result.accepted.notreceive.tips1":"Check recycle bin or junk mails in your mailbox","register.result.accepted.notreceive.tips2.click":"Click here","register.result.accepted.notreceive.tips2.p1":" to sign up with a different Email","register.result.apply.desc":"Thanks for sign up. We will process your registration as soon as possible. When completed, you'll receive notifications by your Email.","register.result.apply.title":"Your sign up is being reviewed","register.submit":"Sign up","register.submit.failure":"Submit error","register.submit.pending":"Submitting","register.tele":"Telephone","register.tele.placeholder":"Your phone number","register.title":"Sign up loraFlow","register.vcode":"Verify code","register.verifycode.wrong":"Verification code error","resetpassword.actionbutton.label":"Submit","resetpassword.actionbutton.successlabel":"Submit Success","resetpassword.button.submitFailed":"Submit Failed","resetpassword.emailvalidate.errempty":"Email can not be empty","resetpassword.emailvalidate.errfomat":"Email format error","resetpassword.errtips.email":"Please enter the mailbox","resetpassword.errtips.emailandvercode":"Please enter the mailbox and verify code","resetpassword.errtips.vercode":"Please enter the verify code","resetpassword.feedbacktips.email":"Mailbox not registered","resetpassword.feedbacktips.emailinactive":"Account inactive","resetpassword.feedbacktips.vercode":"Verification code is not correct","resetpassword.headtitle":"Reset Your Password","resetpassword.identifyingcode.errempty":"Verification code can not be empty","resetpassword.label.mailbox":"Mailbox","resetpassword.label.vercode":"Verification Code","resetpassword.new.button.label":"Submit","resetpassword.new.button.successlabel":"Reseting Success","resetpassword.new.label.newpassword":"New Password","resetpassword.new.label.repeatpwd":"Repeat Password","resetpassword.new.password.error.Inconsistent":"Inconsistent with the new password","resetpassword.new.password.error.null":"Can not be empty!","resetpassword.new.password.error.validerr":"Invalid format!","resetpassword.new.placeholder.newpassword":"Length must between 6 and 16","resetpassword.new.placeholder.repeatpwd":"Input new password again","resetpassword.new.resetfailed":"Reset Failed","resetpassword.new.title.resetpwd":"Reset Password","resetpassword.placeholder.mailbox":"Enter your registered email","resetpassword.placeholder.vercode":"Enter verification code on the right","resetpassword.success.btn":"Check mail now","resetpassword.success.footer.h3":"No email received?","resetpassword.success.footer.li1":"Check recycle bin or junk mails in your mailbox","resetpassword.success.footer.li2.txt1":"Click here","resetpassword.success.footer.li2.txt2":" to reset password with a different Email","resetpassword.success.h1":"One more step to complete reset password","resetpassword.success.p1":"We've sent a activation email to ","resetpassword.success.p2":", click the activation link to complete your password reseting."}

/***/ }),
/* 2394 */
/***/ (function(module, exports) {

module.exports = {"lora.E.FE_EMPTY":"不能为空","alerts.stateParameter.fail":"失败","alerts.stateParameter.success":"成功","app.device.mac.label":"Mac命令","app.device.mac.modal.button1":"关闭","app.device.mac.modal.button2":"发送","app.device.mac.modal.content":"是否发送该命令？","app.device.mac.panel.label1":"MAC命令","app.device.mac.panel.label2.button":"查看队列","app.device.macLog.label":"Mac命令日志","ApplySuccess.ApplySuccess":"申请开发者认证成功","ApplySuccess.ApplySuccessTip":"感谢您提交认证，我们会尽快审核相关资料。","BaiduMap.label.gatewayId":"网关ID:","commmonModal.simpleModal.button.cancel":"取消","DashboardForm.onClose":"关闭","deviceDetail.breadcrumbs.device":"我的设备","DeviceList.menu.batchImport":"批量导入","DeviceList.menu.createDev":"自动生成设备","DeviceList.menu.importABP":"导入ABP设备","DeviceList.menu.importOTAA":"导入OTAA设备","DeviceList.result.active":"活动","DeviceList.result.unActive":"非活动","DeviceList.select.devStatusActive":"活动","DeviceList.select.devStatusInActive":"非活动","DeviceList.tip.createDevFail":"设备生成失败！","DeviceList.tip.createDevSuccess":"设备生成成功！","DeviceList.tip.deleteSuccess":"删除成功！","DeviceList.tip.overDevNum":"超出配额！","forgetPassword.panel.button":"提交","forgetPassword.panel.label1":"邮箱","forgetPassword.panel.label2":"验证码","forgetPassword.respond1":"几分钟后，您将收到重置密码的电子邮件。","forgetPassword.respond2":"已找回密码?","forgetPassword.respond3":"登录","forgetPassword.respond4":"邮件发送失败，请检查邮件地址或输入的图形验证码是否正确。","forgetPassword.title1":"loraFlow忘记密码","gateway":"网关管理","InlineEditComponent.button.edit":"编辑","LabelReset.button.devReset":"重置序列号","LabelReset.resetReady":"已重置","lora.button.cancel":"取消","lora.button.confirm":"确定","lora.button.edit":"修改","lora.coms.pagesizer.postfix":"/ 页","lora.coms.refresher.pinned.tooltip":"自动刷新中","lora.coms.refresher.tooltip":"双击自动刷新","lora.coms.copy.copied":"已拷贝","lora.coms.copy.copy":"拷贝","lora.coms.collapsetoggle.expand":"展开","lora.coms.collapsetoggle.collapse":"收起","lora.datadir.down":"下行","lora.datadir.up":"上行","lora.device.err.outofquota":"您的设备配额不足。","lora.emptyval":"空","lora.error.badappkey":"AppKey错误","lora.error.badappskey":"AppSKey错误","lora.error.baddevaddr":"DevAddr错误","lora.error.baddeveui":"DevEUI错误","lora.error.badmacaddr":"MAC地址错误","lora.error.badnwkskey":"NwkSKey错误","lora.error.cannotbeempty":"不能为空","lora.error.devaddrunavail":"DevAddr已被占用","lora.error.deveuiconflict":"DevEUI已存在","lora.error.deveuiunavail":"DevEUI已被占用","lora.error.generalerror":"服务器错误","lora.error.integer.nan":"错误数字格式","lora.error.integer.toolarge":"超出最大值范围","lora.error.integer.toolow":"超出最小值范围","lora.error.invalidformat":"格式错误","lora.error.macaddrunavail":"MAC地址已被占用","lora.error.unknown":"网络错误","lora.pageerror.default.title":"网络错误","lora.pageerror.default.description":"请尝试重新刷新页面","lora.nav.application":"应用管理","lora.nav.billing":"费用中心","lora.nav.documentation":"文档","lora.nav.gateway":"网关管理","lora.nav.network":"网络管理","lora.nav.overview":"概览","lora.nav.dashboard":"看板","lora.tooltip.copy":"复制到剪贴板","lora.tooltip.edit":"编辑","lora.tooltip.viewdetail":"查看详情","lora.trial.noperm":"您当前为免费用户，无权限访问","lora.noperm":"无权限访问","lora.noperm.undercomm.trial":"您当前为免费用户。","lora.noperm.undercomm.upgrade":"升级","lora.noperm.undercomm.upgradeto":" 为企业用户或服务套餐用户来使用此功能。","lora.data.field.bandwidth":"带宽","lora.data.field.channel":"信道","lora.data.field.data":"数据","lora.data.field.deveui":"设备EUI","lora.data.field.frameno":"帧号","lora.data.field.frequency":"频点(MHZ)","lora.data.field.msgtype":"消息类型","lora.data.field.size":"帧长","lora.data.field.time":"时间","lora.data.field.gateway":"网关","lora.data.field.gwname":"网关名称","lora.data.field.devname":"设备名称","Mac.valid.number":"请输入{min}~{max}之间的整数","newRegisterSuccess.h1":"恭喜您注册成功，艾森智能将竭诚为您服务","newRegisterSuccess.loginbtn":"登录","newRegisterSuccess.row1.title":"注册成功","newRegisterSuccess.row2.content1":"恭喜你注册成功，请点击","newRegisterSuccess.row2.content2":"登录","ParserErr.button.close":"关闭","ParserErr.message.tip":"查看图表需要解析器返回JSON格式数据，请参考以下示例：","ReduxFormModal.button.cancel":"取消","resetPassword.resetSuccess.respond":"重置密码成功","resetPassword.row1.title":"重置密码","SubAccount.adminUser":"管理员","SubAccount.boxHead.subAccountManage":"子账户管理","SubAccount.button.addSub":"添加子账号","SubAccount.button.edit":"编辑","SubAccount.modalTitle.deleteSubAccount":"删除子账户","SubAccount.modalTitle.sureToDel":"确定删除该子账户？","SubAccount.nothing":"无","SubAccount.th.del":"删除","SubAccount.th.email":"邮件","SubAccount.th.Jurisdiction":"权限","SubAccount.th.name":"名称","SubAccount.user":"用户","Token.alert.delTokenTip":"删除失败，不能删除已经被使用的Token!","Token.boxHead.tokenManage":"Token管理","Token.button.addToken":"添加Token","Token.modal.SimpleModalTitle":"删除Token","Token.modal.submitTitle":"删除","Token.modal.sureToDel":"确定删除该token？","Token.tip.addTipFailed":"添加失败，超出配额！","Token.tip.addTipSuccess":"添加成功！","Token.tip.deleteTokenFailed":"删除失败,不能删除已经被使用的token！","Token.tip.deleteTokenSuccess":"删除成功","Token.tip.failed":"失败！","Token.tip.modifyAs":"修改为","Token.tip.success":"成功！","Token.tipTitle.addTip":"添加提示","Token.tipTitle.deleteTokenTip":"删除提示","Token.tipTitle.editTip":"修改提示","TokenTable.button.deleteToken":"删除","TokenTable.button.edit":"修改","TokenTable.th.name":"名称","TokenTable.th.operater":"操作","selectgateway.name":"名称","selectgateway.mac":"MAC地址","selectgateway.status":"连接状态","selectgateway.connected":"已连接","selectgateway.disconnected":"未连接","selectgateway.confirm":"确定","selectgateway.title":"选择网关","selectgateway.search.placeholder":"搜索网关","selectgateway.lat":"纬度","selectgateway.lng":"经度","selectgateway.tips":"经纬度用于在地图上标注","accountcenter.info":"账户信息","accountcenter.infoview.basic.company":"公司","accountcenter.infoview.basic.email":"邮箱","accountcenter.infoview.basic.name":"姓名","accountcenter.infoview.basic.newpassword":"新密码","accountcenter.infoview.basic.oldpassword":"旧密码","accountcenter.infoview.basic.repeatpassword":"重复密码","accountcenter.infoview.basic.telephone":"电话","accountcenter.infoview.basic.title":"我的信息","accountcenter.infoview.basic.login":"登录用户","accountcenter.infoview.button.changepassword":"修改密码","accountcenter.infoview.changepwd.toolbarbutton.beback":"返回","accountcenter.infoview.changepwd.toolbarnav.basicinfo":"我的信息","accountcenter.infoview.changepwd.toolbarnav.changepwd":"修改密码","accountcenter.infoview.edit":"编辑","accountcenter.infoview.error.newpassword":"必须先输入新密码","accountcenter.infoview.error.newpasswordsame":"新密码与旧密码不能一致","accountcenter.infoview.error.null":"不能为空","accountcenter.infoview.error.password":"密码长度为6-16位","accountcenter.infoview.error.repeatpassword":"与新密码不一致","accountcenter.infoview.expiration":"服务到期时间","accountcenter.infoview.expiration.unit":"天","accountcenter.infoview.expiration.units":"天","accountcenter.infoview.help.newpassword":"输入6-16位字符的新密码","accountcenter.infoview.help.repeatpassword":"注意与新密码保持一致","accountcenter.infoview.link.changepassword":"修改密码","accountcenter.infoview.placeholder.newpassword":"可以由数字，字母，符号组成","accountcenter.infoview.placeholder.oldpassword":"输入旧密码","accountcenter.infoview.placeholder.repeatpassword":"重新输入新密码","accountcenter.infoview.plan.balance":"账户余额","accountcenter.infoview.plan.billday":"账单日","accountcenter.infoview.plan.commuser":"企业用户","accountcenter.infoview.plan.recharge":"充值","accountcenter.infoview.plan.rmbyuan":"元","accountcenter.infoview.plan.svcpackuser":"服务套餐用户","accountcenter.infoview.plan.tier":"账户类型","accountcenter.infoview.plan.title":"费用信息","accountcenter.infoview.plan.trialuser":"免费用户","accountcenter.infoview.plan.upgrade":"升级","accountcenter.infoview.quota.lrappnum":"应用配额","accountcenter.infoview.quota.lrgatewaynum":"网关配额","accountcenter.infoview.quota.lrnodenum":"设备配额","accountcenter.infoview.quota.title":"资源配额","accountcenter.infoview.toolbar.title":"账户信息","accountcenter.management":"账户管理","accountcenter.manageview.adderrtip.addfail":"添加失败","accountcenter.manageview.adderrtip.quota":"配额已满","accountcenter.manageview.addmodaltip":"添加Token","accountcenter.manageview.button.createtoken":"添加","accountcenter.manageview.button.subaccount":"子账户","accountcenter.manageview.deletetip.confirmdelete":"确定删除Token","accountcenter.manageview.deletetip.deletetoken":"删除Token","accountcenter.manageview.deletetokentip":"不能删除已经被使用的token！","accountcenter.manageview.deletetokentipcommon":"删除失败！","accountcenter.manageview.error.invalidformat":"格式错误","accountcenter.manageview.error.null":"不能为空","accountcenter.manageview.label.email":"邮箱","accountcenter.manageview.label.jurisdiction":"权限","accountcenter.manageview.label.name":"名称","accountcenter.manageview.label.password":"密码","accountcenter.manageview.modal.delete":"删除子账户","accountcenter.manageview.modal.deleteconfirm":"确定删除子账户","accountcenter.manageview.modalheader":"删除Token","accountcenter.manageview.modaltitle":"新增Token失败","accountcenter.manageview.option.administrator":"管理员","accountcenter.manageview.option.jurisdiction":"无权限","accountcenter.manageview.option.user":"用户","accountcenter.manageview.placeholder.email":"输入子账户的邮箱","accountcenter.manageview.placeholder.jurisdiction":"选择子账户的权限","accountcenter.manageview.placeholder.name":"输入子账户的名称","accountcenter.manageview.placeholder.password":"输入子账户的密码","accountcenter.manageview.placeholder.token.name":"名称应为对token的描述","accountcenter.manageview.tablecolumn.createtime":"创建时间","accountcenter.manageview.tablecolumn.email":"邮件","accountcenter.manageview.tablecolumn.jurisdiction":"权限","accountcenter.manageview.tablecolumn.name":"名称","accountcenter.manageview.tablecolumn.edit":"编辑","accountcenter.manageview.tablecolumn.delete":"删除","accountcenter.manageview.tablecolumn.operation":"操作","accountcenter.manageview.title.subaccount":"子账户管理","accountcenter.manageview.title.token":"Token管理","accountcenter.manageview.E.FE_EMPTY":"不能为空","accountcenter.security":"账户安全","accountcenter.securityview.changepwd.newpwd":"新密码","accountcenter.securityview.changepwd.newpwd.repeat":"新密码确认","accountcenter.securityview.changepwd.oldpwd":"当前密码","accountcenter.securityview.changepwd.title":"修改密码","accountcenter.securityview.changepwd.submit":"修改","accountcenter.securityview.changepwd.success":"修改成功","accountcenter.securityview.changepwd.failure":"修改失败","accountcenter.securityview.E.FE_EMPTY":"不能为空","accountcenter.securityview.E.FE_NOTSAME":"两次输入不一致","accountcenter.securityview.E.BADPASSWORD":"当前密码错误","accountcenter.securityview.E.PASSWORDPOLICY":"新密码不符合要求","accountcenter.securityview.E.FE_TOOSHORT":"新密码长度至少6位","accountcenter.securityview.E.FE_NOTCHANGED":"新密码与旧密码相同","accountcenter.title":"账户中心","accountcenter.tokenmanagement":"Token管理","appdebug.chartview.breadcrumb.api":"应用接口","appdebug.chartview.breadcrumb.chart":"图表","appdebug.chartview.breadcrumb.paesedata":"解析数据","appdebug.chartview.label.deveui":"设备EUI","appdebug.chartview.label.fport":"端口号","appdebug.chartview.parsererr.button.godecode":"去解码","appdebug.chartview.parsererr.viewtips":"查看提示","appdebug.chartview.parsererr.viewtipsnodata":"数据未上报","appdebug.chartview.placeholder.deveui":"请选择设备(Device EUI)","appdebug.chartview.placeholder.fport":"请选择端口(FPORT)","appdebug.chartview.websoketmes.button":"重新连接","appdebug.chartview.websoketmes.chart":"WebSocket连接已经断开,获取不到最新数据，请点击下方按钮重新连接","appdebug.detailview.apply":"应用","appdebug.detailview.applyfailed":"应用失败","appdebug.detailview.applysuccess":"应用成功","appdebug.detailview.breadcrumb.detail":"接口详情","appdebug.detailview.button.close":"关闭窗口","appdebug.detailview.button.send":"发送","appdebug.detailview.button.sending":"发送中","appdebug.detailview.button.senddata":"发送数据","appdebug.detailview.button.send.success":"发送成功","appdebug.detailview.button.send.failure":"发送失败","appdebug.detailview.feedback.success":"发送成功","appdebug.detailview.E.DEVEUINOTFOUND":"设备EUI不存在","appdebug.detailview.E.SENDFAIL":"发送错误","appdebug.detailview.E.FE_INVALIDHEX":"Hex数据格式错误","appdebug.detailview.errortip.errformat":"格式错误","appdebug.detailview.E.FE_EMPTY":"不能为空","appdebug.detailview.E.FE_INVALIDPORT":"端口不正确","appdebug.detailview.E.FE_INVALIDFMT":"格式不正确","appdebug.detailview.E.NOTFOUND":"设备不存在","appdebug.detailview.label.content":"内容","appdebug.detailview.label.deveui":"设备EUI","appdebug.detailview.label.fport":"端口","appdebug.detailview.label.encoding":"数据类型","appdebug.detailview.nav.api":"应用接口","appdebug.detailview.props.title":"接口详情","appdebug.detailview.props.apitype":"接口类型","appdebug.detailview.props.name":"名称","appdebug.detailview.props.remark":"备注","appdebug.detailview.senddata.title":"发送数据","appdebug.detailview.paneltitle.senddata":"发送数据","appdebug.detailview.parser":"解析器","appdebug.detailview.placeholder.data.hex":"请输入偶数个16进制数","appdebug.detailview.placeholder.data.text":"请输入文本数据","appdebug.detailview.placeholder.fport":"请输入1~255之间的数值","appdebug.detailview.table.httptitle":"最新20条数据","appdebug.detailview.table.wstitle":"实时数据","appdebug.detailview.data.gateway":"网关","appdebug.detailview.data.bandwidth":"带宽","appdebug.detailview.data.coderate":"码率","appdebug.detailview.data.data":"数据","appdebug.detailview.data.fcnt":"帧号","appdebug.detailview.data.frequency":"频点(MHZ)","appdebug.detailview.data.title":"时间","appdebug.detailview.toolbar.api":"接口属性","appdebug.detailview.wsstatus.connecting":"WebSocket连接建立中...","appdebug.detailview.wsstatus.closed":"WebSocket连接中断，重新尝试连接中","appdebug.detailview.wsstatus.reconnecting":"重新尝试连接中","appdebug.parserview.breadcrumb.title":"解析数据","appdebug.parserview.toolbarbtn.chart":"图表","appdebug.parserview.savescript":"应用解析器","appdebug.parserview.savescript.pending":"应用中","appdebug.parserview.savescript.success":"应用成功","appdebug.parserview.nometrics":"无解析指标","appdebug.parserview.nometrics.desc":"使用解析器解析数据并应用，解析结果的每个字段将作为指标在此呈现。","appdebug.sidebar.chart":"图表","appdebug.sidebar.detail":"接口详情","appdebug.sidebar.parsedata":"解析数据","appdebug.sidebar.title":"应用接口","appdebug.websocket.connect":"WebSocket重连成功！","appdebug.websocket.unconnect":"WebSocket断开连接，正在重连......","application.addapp.appeui.label":"AppEUI","application.addapp.appname.label":"应用名称","application.addapp.appname.placeholder":"应用名称","application.addapp.btn":"新增应用","application.addapp.E.CONFLICT":"该AppEUI已存在，无法添加","application.addapp.E.FE_EMPTY":"不能为空","application.addapp.E.FE_INVALID":"格式不正确","application.addapp.error.modalheader":"新增应用错误","application.addapp.error.outofquota.comm":"您的应用配额已满。需要创建更多应用，请联系我们。","application.addapp.error.outofquota.cube":"您的应用配额已满。需要创建更多应用，请联系我们。","application.addapp.error.outofquota.undercomm":"您的应用配额已满。需要创建更多应用，请升级您的账户。","application.addapp.header":"新增应用","application.addapp.random":"随机生成","application.addapp.submit":"新增","application.addapp.submit.failure":"新增失败","application.addapp.submit.pending":"添加中","application.addapp.submit.success":"新增成功","application.addapp.upgrade.btn":"升级","application.app.fields.devicenum":"设备数量","application.app.fields.name":"名称","application.app.fields.target":"推送接口","application.app.fields.tokennum":"接口数量","application.app.panelheader":"我的应用","application.app.search.placeholder":"搜索应用","application.breadcrumb.application":"我的应用","application.noapp":"暂无应用","applicationdetail.apiview.apidel.btn":"删除","applicationdetail.apiview.apis.adderr.general":"创建新API错误。","applicationdetail.apiview.apis.adderr.modalheader":"新增API错误","applicationdetail.apiview.apis.adderr.quota":"您的API配额已满，需要创建更多，请联系我们。","applicationdetail.apiview.E.FE_EMPTY":"不能为空","applicationdetail.apiview.help.content1":"loraFlow默认支持WebSocket和HTTP接口。 点击\"生成新Token\"即可得到访问URL。点击URL链接可在线调试。","applicationdetail.apiview.help.content2":"loraFlow也可以配置推送接口，推送实时数据到senzFlow或者第三方应用平台。","applicationdetail.apiview.help.content3":"详细信息请访问","applicationdetail.apiview.help.content3.link":"应用文档","applicationdetail.apiview.newtoken.btn":"生成新接口","applicationdetail.apiview.noteedit.link":"点击添加备注","applicationdetail.apiview.notokens":"暂无接口","applicationdetail.apiview.pushinterface.header":"推送接口","applicationdetail.apiview.pushinterface.label":"接口类型","applicationdetail.apiview.pushinterface.appdataonly.checkbox":"仅发送应用数据","applicationdetail.apiview.pushinterface.cancel.btn":"取消","applicationdetail.apiview.pushinterface.edit.btn":"编辑","applicationdetail.apiview.pushinterface.save.btn":"保存","applicationdetail.apiview.pushinterface.E.UNKNOWN":"网络错误","applicationdetail.apiview.pushinterface.E.GENERALERROR":"服务器错误","applicationdetail.apiview.showhelp.btn":"帮助","applicationdetail.apiview.tokens.panelheader":"应用接口","applicationdetail.apiview.tooltip.debug":"调试接口","applicationdetail.apiview.tooltip.note":"备注","applicationdetail.app":"应用","applicationdetail.batchimport.breadcrumb":"批量导入","applicationdetail.batchimport.dropzone.text":"点击选择或拖放文件至此导入文件","applicationdetail.batchimport.E.BADDEVEUI":"DevEUI格式不正确","applicationdetail.batchimport.E.DEVEUICONFLICT":"DevEUI已存在","applicationdetail.batchimport.E.DEVEUIUNAVAIL":"DevEUI已存在","applicationdetail.batchimport.E.DEVADDRUNAVAIL":"DevAddr已存在","applicationdetail.batchimport.E.BANDUNKNOWN":"未知频段","applicationdetail.batchimport.err.modalheader":"导入错误","applicationdetail.batchimport.err.outofquota.comm":"您的设备配额不足。尝试减少批量导入的设备数量，或者联系我们提升配额。","applicationdetail.batchimport.err.outofquota.cube":"您的设备配额不足。尝试减少批量导入的设备数量，或者联系我们提升配额。","applicationdetail.batchimport.err.outofquota.undercomm":"您的设备配额不足。尝试减少批量导入的设备数量，或者升级您的账户来提升设备配额。","applicationdetail.batchimport.help.abp":"导入ABP设备","applicationdetail.batchimport.help.abp.thead.fieldname":"字段名称","applicationdetail.batchimport.help.abp.thead.length":"长度","applicationdetail.batchimport.help.abp.thead.mandatory":"是否必选","applicationdetail.batchimport.help.abp.thead.remark":"说明","applicationdetail.batchimport.help.otaa":"导入OTAA设备","applicationdetail.batchimport.help.panelheader":"导入说明","applicationdetail.batchimport.preview.cancel.btn":"取消","applicationdetail.batchimport.preview.canimport.tips.desc1":"您的设备配额为","applicationdetail.batchimport.preview.canimport.tips.desc2":"，当前拥有设备数为","applicationdetail.batchimport.preview.canimport.tips.desc3":"，还可以导入","applicationdetail.batchimport.preview.canimport.tips.desc4":"个设备。","applicationdetail.batchimport.preview.import.btn.seg1":"导入","applicationdetail.batchimport.preview.import.btn.seg2":"个设备","applicationdetail.batchimport.preview.required":"必选","applicationdetail.batchimport.preview.invalidvalue":"非法的值","applicationdetail.batchimport.result.fail":"导入失败","applicationdetail.batchimport.result.notimport":"未导入","applicationdetail.batchimport.result.succ":"导入成功","applicationdetail.batchimport.result.summary.back":"返回应用","applicationdetail.batchimport.result.summary.reimport":"继续导入","applicationdetail.batchimport.result.summary.seg1":"导入成功","applicationdetail.batchimport.result.summary.seg2":"导入失败","applicationdetail.batchimport.result.thead.status":"导入状态","applicationdetail.batchimport.upgrade.btn":"升级","applicationdetail.detailview.appprops.createtime":"创建时间","applicationdetail.detailview.appprops.delete":"删除应用","applicationdetail.detailview.appprops.devicecount":"应用设备","applicationdetail.detailview.appprops.dpcount":"数据点","applicationdetail.detailview.appprops.flowcount":"事件规则","applicationdetail.detailview.appprops.parsercount":"解析器","applicationdetail.detailview.appprops.title":"应用属性","applicationdetail.detailview.appprops.E.FE_EMPTY":"不能为空","applicationdetail.detailview.delete.cancelbtn":"取消","applicationdetail.detailview.delete.confirmbtn":"删除","applicationdetail.detailview.delete.E.FE_DEVICESEXIST":"删除应用之前请删除应用的所有设备。","applicationdetail.detailview.delete.error.modalheader":"删除错误","applicationdetail.detailview.delete.modalcontent":"删除应用","applicationdetail.detailview.delete.modalheader":"删除应用","applicationdetail.detailview.devicelist.adderr.header":"新增设备失败","applicationdetail.detailview.devicelist.adderr.ooq.comm":"您的设备配额已满。需要创建更多设备，请联系我们。","applicationdetail.detailview.devicelist.adderr.ooq.cube":"您的设备配额已满。需要创建更多设备，请联系我们。","applicationdetail.detailview.devicelist.adderr.ooq.undercomm":"您的设备配额已满。需要创建更多设备，请升级您的账户。","applicationdetail.detailview.devicelist.adderr.upgrade.btn":"升级","applicationdetail.detailview.devicelist.autogendev":"生成设备","applicationdetail.detailview.devicelist.batchimport":"批量导入","applicationdetail.detailview.devicelist.deldev":"删除设备","applicationdetail.detailview.devicelist.expalldev":"导出所有设备","applicationdetail.detailview.devicelist.devicenum":"设备总数:","applicationdetail.detailview.devicelist.error.empty":"不能为空","applicationdetail.detailview.devicelist.error.invalidformat":"格式错误","applicationdetail.detailview.devicelist.gendev":"生成设备","applicationdetail.detailview.devicelist.gendev.band":"频段","applicationdetail.detailview.devicelist.impdev":"导入设备","applicationdetail.detailview.devicelist.importabp":"导入ABP设备","applicationdetail.detailview.devicelist.importabp.band":"ISM频段","applicationdetail.detailview.devicelist.importabp.band.placeholder":"选择设备的ISM频段","applicationdetail.detailview.devicelist.importabp.E.DEVADDRCONFLICT":"DevAddr已存在","applicationdetail.detailview.devicelist.importabp.E.DEVADDRUNAVAIL":"DevAddr已存在","applicationdetail.detailview.devicelist.importabp.E.DEVEUICONFLICT":"DevEUI已存在","applicationdetail.detailview.devicelist.importabp.E.DEVEUIUNAVAIL":"DevEUI已存在","applicationdetail.detailview.devicelist.importabp.E.FE_EMPTY":"不能为空","applicationdetail.detailview.devicelist.importabp.E.FE_INVALIDFORMAT":"格式错误","applicationdetail.detailview.devicelist.importabp.err.unknown":"导入错误","applicationdetail.detailview.devicelist.importabp.modalheader":"导入ABP设备","applicationdetail.detailview.devicelist.importabp.submit":"导入","applicationdetail.detailview.devicelist.importabp.submit.failure":"导入失败","applicationdetail.detailview.devicelist.importabp.submit.success":"导入成功","applicationdetail.detailview.devicelist.importabp.vendorprovide":"由设备厂商提供","applicationdetail.detailview.devicelist.importotaa":"导入OTAA设备","applicationdetail.detailview.devicelist.importotaa.band":"ISM频段","applicationdetail.detailview.devicelist.importotaa.band.placeholder":"选择设备的ISM频段","applicationdetail.detailview.devicelist.importotaa.E.DEVEUICONFLICT":"DevEUI已存在","applicationdetail.detailview.devicelist.importotaa.E.DEVEUIUNAVAIL":"DevEUI已存在","applicationdetail.detailview.devicelist.importotaa.E.FE_EMPTY":"不能为空","applicationdetail.detailview.devicelist.importotaa.E.FE_INVALIDFORMAT":"格式不正确","applicationdetail.detailview.devicelist.importotaa.E.GENERALERROR":"服务器错误","applicationdetail.detailview.devicelist.importotaa.E.UNKNOWN":"网络错误","applicationdetail.detailview.devicelist.importotaa.err.deveui.conflict":"DevEUI已存在","applicationdetail.detailview.devicelist.importotaa.err.unknown":"导入错误","applicationdetail.detailview.devicelist.importotaa.modalheader":"导入OTAA设备","applicationdetail.detailview.devicelist.importotaa.submit":"导入","applicationdetail.detailview.devicelist.importotaa.submit.failure":"导入失败","applicationdetail.detailview.devicelist.importotaa.submit.pending":"导入中","applicationdetail.detailview.devicelist.importotaa.submit.success":"导入成功","applicationdetail.detailview.devicelist.nodevice":"暂无设备","applicationdetail.detailview.devicelist.search.placeholder":"搜索设备","applicationdetail.detailview.devicelist.thead.area":"区域","applicationdetail.detailview.devicelist.thead.band":"ISM频段","applicationdetail.detailview.devicelist.thead.bandplan":"频段计划","applicationdetail.detailview.devicelist.thead.city":"城市","applicationdetail.detailview.devicelist.thead.createtime":"创建时间","applicationdetail.detailview.devicelist.thead.name":"名称","applicationdetail.detailview.devicelist.thead.status":"最近活动时间","applicationdetail.detailview.devicelist.thead.type":"类型","applicationdetail.detailview.devicelist.title":"设备列表","applicationdetail.exportData":"导出数据","applicationdetail.exportview.choosedev.label":"选择设备","applicationdetail.exportview.choosedev.placeholder":"输入设备EUI","applicationdetail.exportview.deverrtips":"该应用下没有此设备","applicationdetail.exportview.export.btn":"导出","applicationdetail.exportview.exporttype.label":"导出类型","applicationdetail.exportview.exporttype.optionall":"导出所有设备的数据","applicationdetail.exportview.exporttype.optionone":"导出单个设备的数据","applicationdetail.exportview.exporttype.placeholder":"可以选择导出某个设备的数据","applicationdetail.exportview.format.label":"导出格式","applicationdetail.exportview.panelheader":"导出数据","applicationdetail.exportview.timerange.label":"导出时间","applicationdetail.flowsview.add":"创建规则","applicationdetail.flowsview.addflow.breadcrumb":"创建规则","applicationdetail.flowsview.addflow.desc":"描述","applicationdetail.flowsview.addflow.E.BADSYNTAX":"规则语法错误","applicationdetail.flowsview.addflow.E.FE_EMPTY":"不能为空","applicationdetail.flowsview.addflow.E.FE_TOOLONG":"超出字数限制","applicationdetail.flowsview.addflow.E.GENERALERROR":"服务器错误","applicationdetail.flowsview.addflow.E.UNKNOWN":"网络错误","applicationdetail.flowsview.addflow.header":"添加规则","applicationdetail.flowsview.addflow.name":"名称","applicationdetail.flowsview.addflow.script":"规则","applicationdetail.flowsview.addflow.submit":"创建规则","applicationdetail.flowsview.addflow.submit.failure":"创建失败","applicationdetail.flowsview.addflow.submit.success":"创建成功","applicationdetail.flowsview.flows.delete.cancel":"取消","applicationdetail.flowsview.flows.delete.header":"删除规则","applicationdetail.flowsview.flows.delete.rusure":"确定删除规则","applicationdetail.flowsview.flows.delete.submit":"确定删除","applicationdetail.flowsview.flows.desc":"通过规则，你可以对你的数据点定义数据匹配规则，当数据点符合规则时，系统会自动触发通知等动作。","applicationdetail.flowsview.flows.E.BADSYNTAX":"规则语法错误","applicationdetail.flowsview.flows.E.FE_EMPTY":"不能为空","applicationdetail.flowsview.flows.E.GENERALERROR":"服务器错误","applicationdetail.flowsview.flows.E.UNKNOWN":"网络错误","applicationdetail.flowsview.flows.noflow":"暂无规则","applicationdetail.logview.daterangepicker.label":"数据时间","applicationdetail.logview.panelheader":"应用日志","applicationdetail.logview.thead.code":"代码","applicationdetail.logview.thead.loglevel":"级别","applicationdetail.logview.thead.remark":"详细信息","applicationdetail.logview.thead.time":"时间","applicationdetail.menu.api":"应用接口","applicationdetail.menu.detail":"应用详情","applicationdetail.menu.dps":"数据点","applicationdetail.menu.export":"数据导出","applicationdetail.menu.flows":"事件规则","applicationdetail.menu.log":"应用日志","applicationdetail.menu.parse":"数据解析","applicationdetail.menu.dashboard":"看板","applicationdetail.menu.broadcast":"广播","applicationdetail.outPut":"应用接口","applicationdetail.parseview.datapoints.clicktoedit":"点击进行添加","applicationdetail.parseview.datapoints.delete":"删除","applicationdetail.parseview.datapoints.delete.body.questionmark":"？","applicationdetail.parseview.datapoints.delete.body.text":"确认删除数据点","applicationdetail.parseview.datapoints.delete.header":"删除数据点","applicationdetail.parseview.datapoints.delete.submit.cancel":"取消","applicationdetail.parseview.datapoints.delete.submit.confirm":"删除","applicationdetail.parseview.datapoints.field.actions":"动作","applicationdetail.parseview.datapoints.field.desc":"描述","applicationdetail.parseview.datapoints.field.trend":"趋势","applicationdetail.parseview.datapoints.field.type":"数据类型","applicationdetail.parseview.datapoints.header":"数据点","applicationdetail.parseview.datapoints.how":"如何生成数据点？","applicationdetail.parseview.datapoints.how.dps":"解析器解析成功的数据点会在此显示。","applicationdetail.parseview.datapoints.how.parse.parser":"数据解析器","applicationdetail.parseview.datapoints.how.parse.postfix":"，并在数据解析器界面看到数据解析成功。","applicationdetail.parseview.datapoints.how.parse.prefix":"创建最少一个","applicationdetail.parseview.datapoints.how.tx":"确保有设备数据上报。","applicationdetail.parseview.datapoints.nodps":"暂无数据点","applicationdetail.parseview.dptrend.devicefilter.placeholder":"输入DevEUI","applicationdetail.parseview.dptrend.deviceserie.label":"按设备拆分","applicationdetail.parseview.dptrend.filters":"过滤","applicationdetail.parseview.dptrend.filters.device":"按设备过滤","applicationdetail.parseview.dptrend.filters.new":"新过滤条件","applicationdetail.parseview.dptrend.groupbys":"聚合","applicationdetail.parseview.dptrend.groupbys.device":"按设备聚合","applicationdetail.parseview.dptrend.groupbys.dimension":"维度","applicationdetail.parseview.dptrend.groupbys.funcs.avg":"平均值","applicationdetail.parseview.dptrend.groupbys.funcs.max":"最大值","applicationdetail.parseview.dptrend.groupbys.funcs.min":"最小值","applicationdetail.parseview.dptrend.groupbys.funcs.sum":"求和","applicationdetail.parseview.dptrend.groupbys.function":"方法","applicationdetail.parseview.dptrend.groupbys.new":"新聚合条件","applicationdetail.parseview.dptrend.groupbys.time":"按时间聚合","applicationdetail.parseview.dptrend.groupbytime.onehour":"1小时","applicationdetail.parseview.dptrend.groupbytime.onemin":"1分钟","applicationdetail.parseview.dptrend.groupbytime.tenmin":"10分钟","applicationdetail.parseview.dptrend.series":"系列","applicationdetail.parseview.dptrend.series.device":"按设备拆分","applicationdetail.parseview.dptrend.series.new":"拆分多系列","applicationdetail.parseview.dptrend.timerange":"时间","applicationdetail.parseview.dptrend.timeranges.lastday":"最近一天","applicationdetail.parseview.dptrend.timeranges.lasthour":"最近一小时","applicationdetail.parseview.dptrend.timeranges.lastmon":"最近一个月","applicationdetail.parseview.parserdetail.helptabs.sample":"代码示例","applicationdetail.parseview.parsers.add":"添加解析器","applicationdetail.parseview.parsers.add.desc":"描述","applicationdetail.parseview.parsers.add.E.FE_EMPTY":"不能为空","applicationdetail.parseview.parsers.add.modalheader":"添加解析器","applicationdetail.parseview.parsers.add.name":"名称","applicationdetail.parseview.parsers.add.submit":"添加","applicationdetail.parseview.parsers.add.submitfail":"添加失败","applicationdetail.parseview.parsers.add.submitsucc":"添加成功","applicationdetail.parseview.parsers.add.submitting":"添加中","applicationdetail.parseview.parsers.data.header":"已解析数据","applicationdetail.parseview.parsers.data.nodata":"暂无数据","applicationdetail.parseview.parsers.data.thead.time":"时间","applicationdetail.parseview.parsers.data.thead.name":"设备名称","applicationdetail.parseview.parsers.data.nodata01":"暂无数据","applicationdetail.parseview.parsers.data.back":"返回","applicationdetail.parseview.parsers.data.failure":"服务器超时","applicationdetail.parseview.parsers.delete.cancel":"取消","applicationdetail.parseview.parsers.delete.modalbody":"确认删除解析器","applicationdetail.parseview.parsers.delete.modalheader":"删除解析器","applicationdetail.parseview.parsers.delete.submit":"删除","applicationdetail.parseview.parsers.delete.submitsucc":"删除成功","applicationdetail.parseview.parsers.delete.submitting":"删除中","applicationdetail.parseview.parsers.E.FE_EMPTY":"不能为空","applicationdetail.parseview.parsers.E.UNKNOWN":"网络错误","applicationdetail.parseview.parsers.header":"数据解析器","applicationdetail.parseview.parsers.scripteditor.E.FE_NODATAPOINTS":"未返回数据点","applicationdetail.parseview.parsers.scripteditor.E.FE_RETMISSING":"缺少return语句","applicationdetail.parseview.parsers.scripteditor.E.FE_SYNTAXINVALID":"语法错误","applicationdetail.parseview.parsers.scripteditor.E.GENERALERROR":"服务器错误","applicationdetail.parseview.parsers.scripteditor.E.UNKNOWN":"网络错误","applicationdetail.parseview.parsers.scripteditor.submit":"保存","applicationdetail.parseview.parsers.scripteditor.submitfailure":"保存失败","applicationdetail.parseview.parsers.scripteditor.submitsucc":"保存成功","applicationdetail.parseview.parsers.scripteditor.submitting":"保存中","applicationdetail.parseview.parsers.scripteditor.FE_SYNTAXINVALID":"第","applicationdetail.parseview.parsers.scripteditor.line1":"行","applicationdetail.parseview.parsers.scripteditor.copy":"复制","applicationdetail.parseview.parsers.scripteditor.copid":"已复制","applicationdetail.parseview.parsers.scripteditor.beauty":"格式化","applicationdetail.parseview.parsers.debug.failure":"失败","applicationdetail.parseview.parsers.debug.E.FE_RETMISSING":"解析器错误：缺少return语句","applicationdetail.parseview.parsers.debug.E.FE_DEBUG_SYNTAXINVALID":"debug语法错误","applicationdetail.parseview.parsers.debug.E.FE_PARSER_SYNTAXINVALID":"解析器语法错误","applicationdetail.parseview.parsers.debug.E.GENERALERROR":"服务器错误","applicationdetail.parseview.parsers.debug.line0":"第","applicationdetail.parseview.parsers.debug.line1":"行","applicationdetail.parseview.parsers.debug.E.FE_DEBUG_FAILURE":"debug错误","applicationdetail.sidebar.title":"应用","applicationdetail.dashboard.addgw":"网关看板","applicationdetail.dashboard.nodashboard":"暂无看板","applicationdetail.dashboard.nodashboard.desc":"通过看板，你可以对设备的数据进行定制化的分析与查看","applicationdetail.dashboard.adddashboard":"设备看板","applicationdetail.dashboard.adddashboard.add":"添加看板","applicationdetail.dashboard.adddashboard.add.placeholder":"对看板的描述","applicationdetail.dashboard.adddashboard.add.mode":"模式","applicationdetail.dashboard.adddashboard.add.device":"设备","applicationdetail.dashboard.adddashboard.add.select":"选择","applicationdetail.dashboard.adddashboard.add.datapoint":"选择数据点","applicationdetail.dashboard.adddashboard.add.single":"对选择的数据点进行图表展示（单个设备）","applicationdetail.dashboard.adddashboard.add.multiple":"设备在地图上的分布及图表展示（多个设备）","applicationdetail.dashboard.adddashboard.add.gps":"设备不同时间段在地图上的轨迹","applicationdetail.dashboard.adddevice":"选择设备","applicationdetail.dashboard.changedevice":"更换设备","applicationdetail.dashboard.createdat":"创建于","applicationdetail.dashboard.toolbar.bytime.hour":"最近1小时","applicationdetail.dashboard.toolbar.bytime.day":"最近1天","applicationdetail.dashboard.toolbar.bytime.sevenday":"最近7天","applicationdetail.dashboard.toolbar.bytime.month":"最近30天","applicationdetail.dashboard.search.placeholder":"搜索","applicationdetail.dashboard.addmodal.name":"名称","applicationdetail.dashboard.dpsmodal.desc":"描述","applicationdetail.dashboard.singlechart":"分开","applicationdetail.dashboard.mergechart":"合并","applicationdetail.dashboard.addmodal.deveui":"DevEUI","applicationdetail.dashboard.addmodal.createdAt":"创建时间","applicationdetail.dashboard.confirm":"确定","applicationdetail.dashboard.cancel":"取消","applicationdetail.dashboard.customize":"自定义","applicationdetail.dashboard.E.FE_EMPTY":"不能为空","applicationdetail.dashboard.delete.dashboard":"删除看板","applicationdetail.dashboard.delete.confirm":"确认删除该看板？","applicationdetail.dashboard.add.warning":"无选择的设备或数据点","applicationdetail.dashboard.add.dpschart":"添加图表","applicationdetail.dashboard.adddevice.tip0":"注：最多选","applicationdetail.dashboard.adddevice.tip1":"个设备","applicationdetail.dashboard.adddevice.tip2":"注：只能选择1个设备","applicationdetail.dashboard.adddevice.nodata":"暂无设备","applicationdetail.dashboard.chart.nodata":"暂无数据","applicationdetail.dashboard.new.singlemode":"基础模式","applicationdetail.dashboard.new.mapmode":"地图模式","applicationdetail.dashboard.new.gpsmode":"轨迹追踪","applicationdetail.dashboard.map.drops":"丢包数","applicationdetail.dashboard.map.adddevice":"添加设备","applicationdetail.dashboard.detail.devicedetail":"设备详情","applicationdetail.dashboard.gps.colorset":"颜色设置","applicationdetail.dashboard.gps.colorset.other":"低于","applicationdetail.dashboard.gps.colorset.higher":"高于","applicationdetail.dashboard.gps.colorset.title1":"指标参数","applicationdetail.dashboard.gps.colorset.title2":"阈值设置","applicationdetail.dashboard.gps.colorset.tip":"注：自定义阈值范围，根据不同的范围，显示不同颜色的图标以区分信号强弱","applicationdetail.dashboard.E.FE_WRONG_MIN":"无效的最小值","applicationdetail.dashboard.E.FE_WRONG_MAX":"无效的最大值","applicationdetail.dashboard.download.nodata":"无可导出的数据！","applicationdetail.dashboard.download.header":"导出数据","applicationdetail.gatewayview.breadcrumb.application":"我的应用","applicationdetail.broadcast.breadcrumb.application":"我的应用","applicationdetail.broadcast.E.FE_EMPTY":"不能为空","applicationdetail.broadcast.add.confirm":"确定","applicationdetail.broadcast.label.name":"名称","applicationdetail.broadcast.add.placeholder":"填写利于记忆的名称","applicationdetail.broadcast.E.FE_INVALIDHEX":"非法Hex数据","applicationdetail.broadcast.E.FE_INVALIDPORT":"非法端口","applicationdetail.broadcast.E.FE_OUTOFRANGE":"超出范围","applicationdetail.broadcast.E.FE_INVALIDNUM":"非法数字","applicationdetail.broadcast.E.FE_PREC4":"最多四位小数","applicationdetail.broadcast.E.FE_INVALIDAPPKEY":"非法密钥","applicationdetail.broadcast.E.FE_INVALIDADDR":"非法地址","applicationdetail.broadcast.E.DEVADDR_NOT_FOUND":"非法地址","applicationdetail.broadcast.E.NO_GATEWAY":"无连接的网关","applicationdetail.broadcast.E.FE_INVALIDFCNT":"非法的帧号","applicationdetail.broadcast.E.DEVADDR_ALREADY_EXIST":"广播地址已存在","applicationdetail.broadcast.E.BROADCAST_OUT_OF_QUOTA":"超出广播地址数量限制","applicationdetail.broadcast.send":"发送","applicationdetail.broadcast.addr.placeholder":"填写已有的地址","applicationdetail.broadcast.addr.quato":"（最多10个）","applicationdetail.broadcast.sending":"正在发送","applicationdetail.broadcast.sendsuccess":"已发送","applicationdetail.broadcast.sendfailure":"发送失败","applicationdetail.broadcast.send.header":"发送广播","applicationdetail.broadcast.send.addr":"地址","applicationdetail.broadcast.send.addr.placeholder":"广播地址","applicationdetail.broadcast.send.port":"端口","applicationdetail.broadcast.send.port.placeholder":"1至223","applicationdetail.broadcast.send.encoding":"数据编码","applicationdetail.broadcast.send.data":"数据","applicationdetail.broadcast.send.gateway":"网关","applicationdetail.broadcast.gateway.disconnected":"未连接","applicationdetail.broadcast.gateway.connected":"已连接","applicationdetail.broadcast.gateway.header":"选择网关","applicationdetail.broadcast.gateway.name":"名称","applicationdetail.broadcast.gateway.mac":"MAC地址","applicationdetail.broadcast.gateway.connection":"连接状态","applicationdetail.broadcast.gateway.confirm":"确定","applicationdetail.broadcast.add.new":"自动生成","applicationdetail.broadcast.add.import":"人工导入","applicationdetail.broadcast.addrlist.delete":"删除","applicationdetail.broadcast.addrlist.edit":"编辑","applicationdetail.broadcast.addrlist.header":"地址列表","applicationdetail.broadcast.addrlist.address":"地址","applicationdetail.broadcast.addrlist.name":"名称","applicationdetail.broadcast.addrlist.appskey":"应用密钥","applicationdetail.broadcast.addrlist.nwkskey":"网络密钥","applicationdetail.broadcast.addrlist.fcntdown":"帧号","applicationdetail.broadcast.addrlist.band":"频段","applicationdetail.broadcast.addrlist.operation":"操作","applicationdetail.broadcast.addrlist.nodata":"暂无数据","applicationdetail.broadcast.addressmodal.header":"添加广播地址","applicationdetail.broadcast.addressmodal.band":"频段","applicationdetail.broadcast.editmodal.header":"编辑广播地址","applicationdetail.broadcast.logs.header":"广播消息","applicationdetail.broadcast.logs.search.placeholder":"搜索地址","applicationdetail.broadcast.logs.time":"时间","applicationdetail.broadcast.logs.gateway":"网关","applicationdetail.broadcast.logs.address":"地址","applicationdetail.broadcast.logs.port":"端口","applicationdetail.broadcast.logs.encoding":"编码","applicationdetail.broadcast.logs.data":"数据","applicationdetail.broadcast.logs.success":"发送成功网关","applicationdetail.broadcast.logs.fail":"发送失败网关","applicationdetail.gatewayview.status.disconnected":"未连接","applicationdetail.gatewayview.status.connected":"已连接","applicationdetail.gatewayview.gatewaylist.header":"网关过滤器(可选)","applicationdetail.gatewayview.gatewaylist.chose":"网关选择","applicationdetail.gatewayview.gatewaylist.delete":"删除","applicationdetail.gatewayview.gatewaylist.name":"名称","applicationdetail.gatewayview.gatewaylist.mac":"MAC地址","applicationdetail.gatewayview.gatewaylist.connect":"连接状态","applicationdetail.gatewayview.gatewaylist.city":"城市","applicationdetail.gatewayview.gatewaylist.area":"区域","applicationdetail.gatewayview.gatewaylist.operation":"操作","applicationdetail.gatewayview.gatewaylist.nodata":"暂无数据","applicationdetail.gatewayview.gatewaylist.delheader":"删除网关","applicationdetail.gatewayview.gatewaylist.deltext":"确认删除网关","applicationdetail.gatewayview.gatewaylist.help0":"应用通过配置可关联某些网关，隔离其他网关。网关配置带来如下好处：","applicationdetail.gatewayview.gatewaylist.help1":"应用服务器通过API仅可查询到关联的网关及状态","applicationdetail.gatewayview.gatewaylist.help2":" 应用下行广播包仅需发送到关联的网关","applicationdetail.gatewayview.gatewaylist.help3":"应用仅接收关联网关的上行数据","applicationdetail.gatewayview.gatewaylist.help4":"应用仅选择关联网关作为下行数据的路由","applicationdetail.gatewayview.gatewaylist.help5":"缺省配置或空配置表示应用与所有网关关联","billing.balogs.balance.lbl":"余额","billing.balogs.balance.recharge.btn":"充值","billing.balogs.balance.unit":"元","billing.balogs.datepicker.language":"zh-CN","billing.balogs.form.btn.query":"查询","billing.balogs.form.label.time":"时间","billing.balogs.form.label.to":"至","billing.balogs.form.label.type":"类型","billing.balogs.label.recharge":"帐户余额","billing.balogs.table.header.amount":"金额","billing.balogs.table.header.balance":"帐户余额","billing.balogs.table.header.ref":"关联账单","billing.balogs.table.header.remark":"备注","billing.balogs.table.header.time":"时间","billing.balogs.table.header.type":"类型","billing.balogs.table.nodata":"无数据","billing.balogs.types.expense":"消费","billing.balogs.types.options.all":"全部","billing.balogs.types.options.expense":"消费","billing.balogs.types.options.recharge":"充值","billing.balogs.types.recharge":"充值","billing.billdetail.billid.lbl":"账单号：","billing.billdetail.billinfo.desc1":"您本月账单总共消费 ","billing.billdetail.billinfo.desc2":" 元，计费资源节点 ","billing.billdetail.billinfo.desc3":" 个。","billing.billdetail.billtime.lbl":"创建时间：","billing.billdetail.info.label.billno":"账单号","billing.billdetail.info.label.billperiod":"账期","billing.billdetail.info.label.servicetype":"服务类型","billing.billdetail.info.label.totalfee":"费用","billing.billdetail.resourcelist.header":"资源列表","billing.billdetail.status.deleted":"已删除","billing.billdetail.status.inuse":"在线","billing.billdetail.table.header.ctime":"创建时间","billing.billdetail.table.header.dtime":"删除时间","billing.billdetail.table.header.rid":"资源ID","billing.billdetail.table.header.status":"状态","billing.billdetail.table.header.uptime":"累计使用时长","billing.billist.breadcrumbs.path1":"我的帐户","billing.billist.breadcrumbs.path2":"我的账单","billing.billlist.form.btn.query":"查询","billing.billlist.form.label.period":"账期","billing.billlist.form.label.to":"至","billing.billlist.table.nodata":"无数据","billing.billlogs.panel.header":"过去3年账单历史","billing.billlogs.table.detail.link":"查看详单","billing.billlogs.table.feetypes.nodefee":"节点月租","billing.billlogs.table.header.actions":"操作","billing.billlogs.table.header.billno":"账单号","billing.billlogs.table.header.billperiod":"账期","billing.billlogs.table.header.itemcount":"数量","billing.billlogs.table.header.paystatus":"支付状态","billing.billlogs.table.header.servicetype":"服务类型","billing.billlogs.table.header.totalfee":"金额","billing.billlogs.table.header.unitprice":"单价","billing.billlogs.table.paystatus.paid":"已支付","billing.billlogs.table.paystatus.unpaid":"未支付","billing.breadcrumb.balogs":"余额流水","billing.breadcrumb.billdetail":"账单详情","billing.breadcrumb.billing":"我的帐户","billing.breadcrumb.billlogs":"历史账单","billing.breadcrumb.recharge":"充值","billing.breadcrumb.recharge.wechat":"微信支付","billing.commercialview.balance.lbl":"余额","billing.commercialview.balance.logs.link":"余额流水","billing.commercialview.balance.unit":"元","billing.commercialview.bills.billday.desc.postfix":"日","billing.commercialview.bills.billday.desc.prefix":"您的账单日是每月","billing.commercialview.bills.billhelp.desc1":"系统会在您的账单日根据使用的设备节点数进行计费，自动从余额中扣除费用。请保持余额充足。若余额不足，将无法正常使用功能。","billing.commercialview.bills.billlog.btn":"查看历史账单","billing.commercialview.bills.lbl":"账单","billing.commercialview.chart.series.costs":"消费金额","billing.commercialview.chart.series.nodes":"使用节点","billing.commercialview.chart.yaxis.costs":"消费金额(元)","billing.commercialview.chart.yaxis.nodes":"使用节点","billing.commercialview.recharge.btn":"充值","billing.commercialview.paystrategy":"收费策略","billing.expired.notify":"抱歉！您的服务已过期，请尽快充值或升级您的账户。","billing.main.balance.label":"帐户余额","billing.main.balogs.btn":"查看我的流水","billing.main.billist.btn":"查看我的账单","billing.main.breadcrumbs.path1":"我的帐户","billing.main.buyplan.btn":"购买套餐","billing.main.chart.charges.yname":"消费金额","billing.main.chart.chargs.xname":"账期","billing.main.chart.labelformatter.resource.unit":"个","billing.main.chart.resource.xname":"账期","billing.main.chart.resource.yname":"节点数目","billing.main.expiretips":"您的服务已过期，暂时无法使用此功能。请尽快充值升级为商务用户。","billing.main.recentexpenses.header":"近期消费","billing.main.recentresources.header":"近期资源使用情况","billing.main.recharge.btn":"充值","billing.main.trial.btn2":"升级为商务用户","billing.main.trial.bycode.modal.error.body":"激活码不存在","billing.main.trial.bycode.modal.error.title":"激活错误","billing.main.trial.bycode.modal.success.body":"激活成功","billing.main.trial.bycode.modal.success.btn":"查看我的资源配额","billing.main.trial.bycode.modal.success.title":"激活成功","billing.pay.tier.bymonth":"月","billing.pay.tier.txt1":"单节点按","billing.pay.tier.txt2":"收费","billing.pay.tier.txt3":"以上单独议价","billing.recharge.balance.txt":"帐户余额","billing.recharge.brand.alipay":"支付宝","billing.recharge.breadcrumbs.path1":"我的帐户","billing.recharge.breadcrumbs.path2":"充值","billing.recharge.confirmmodal.body":"请尽快在新窗口完成支付。","billing.recharge.confirmmodal.button.complete":"已完成支付","billing.recharge.confirmmodal.button.redo":"重新选择支付","billing.recharge.confirmmodal.header":"充值支付","billing.recharge.errmsg.absent":"请填写充值金额","billing.recharge.errmsg.malformed":"请输入大于0且两位小数内的充值金额","billing.recharge.errmsg.negative":"充值金额必须大于0","billing.recharge.errmsg.toolarge":"单次充值不能大于100000","billing.recharge.errmsg.toolow":"充值200元或以上升级为企业级用户","billing.recharge.form.alipay.redirecting":"正在跳转支付宝","billing.recharge.form.err.submiterr":"充值失败","billing.recharge.form.placeholder":"请输入充值金额","billing.recharge.form.placeholdercard":"请输入充值码","billing.recharge.form.submit.btn":"充值","billing.recharge.form.unit":"元","billing.recharge.form.wechat.loading":"支付请求中","billing.recharge.redirecting.txt":"准备跳转支付宝支付页面...","billing.recharge.wechat.amount":"充值金额：","billing.recharge.wechat.billid":"订单ID：","billing.recharge.wechat.scancode":"微信扫一扫二维码支付","billing.recharge.wechat.countdown.text1":"请在","billing.recharge.wechat.countdown.text2":"内完成支付","billing.recharge.wechat.qrcode.expired":"二维码已过期","billing.recharge.wechat.qrcode.refresh":"刷新","billing.recharge.wechat.qrcode.success":"支付成功!","billing.undercommercial.acctcode.activated.desc1":"您已是开发服务套餐用户。","billing.undercommercial.acctcode.activated.panelheader":"开发服务套餐","billing.undercommercial.acctcode.activated.svcexpire.remain.lbl":"你的套餐时间剩余：","billing.undercommercial.acctcode.activated.svcexpire.remain.tips":"请尽快升级为企业级用户，以免影响您的使用。","billing.undercommercial.acctcode.activated.svcexpire.remain.unit":"天","billing.undercommercial.acctcode.form.activate.btn":"激活","billing.undercommercial.acctcode.form.activate.failed":"激活失败","billing.undercommercial.acctcode.form.activate.success":"激活成功","billing.undercommercial.acctcode.form.placeholder":"输入开发服务套餐激活码","billing.undercommercial.acctcode.form.title":"输入开发服务套餐激活码激活：","billing.undercommercial.acctcode.toactive.btn":"了解购买","billing.undercommercial.acctcode.toactive.desc1":"loraFlow.io云平台开发服务套餐包含云服务使用配额：","billing.undercommercial.acctcode.toactive.desc2":"1应用/1网关/10终端/1年期限","billing.undercommercial.acctcode.toactive.panelheader":"开发服务套餐","billing.undercommercial.commup.desc1":"升级成为企业级用户，获得全面可靠的商业支持和永久的云服务配额提升！","billing.undercommercial.commup.desc2":"最少充值200元即可升级成为企业级用户。我们根据企业级用户的具体运营情况提供可制定的配额，提供商业支持和咨询。","billing.undercommercial.commup.panelheader":"升级企业级用户","billing.undercommercial.commup.upgrade.btn":"升级","billing.undercommercial.options.heading":"选择升级为 企业用户 或 使用开发服务套餐 获得更好的服务。","billing.undercommercial.pay.panelheader":"收费策略","billing.undercommercial.pay.title":"终端接入按数目区间采用阶梯价格","billing.undercommercial.recharge.btn":"充值","billing.recharge.types.card":"充值卡","billing.recharge.rechgcard.errcode":"充值码错误","billing.recharge.rechgcard.tryagain":"重新充值","billing.recharge.rechgcard.continue":"继续充值","billing.recharge.rechgcard.rechging":"正在充值...","billing.recharge.rechgcard.complete":"已完成充值","billing.recharge.rechgcard.errcodeused":"该充值卡已使用","billing.recharge.rechgcard.errexpired":"该充值卡已过期","common.accountmanage":"我的账户","common.accountupgrade":"我的钱包","common.application":"应用管理","common.billing":"费用中心","common.exit":"退出","common.login":"登录","common.LoRaWAN":"LoRaWAN网络服务","common.newresource":"文档","common.overview":"概览","common.register":"注册","common.resource":"资源","common.picker.date":"选择日期","common.picker.time":"选择时间","common.picker.confirm":"确定","devicedetail.adrview.adr.data.dr":"速率","devicedetail.adrview.adr.data.event":"事件","devicedetail.adrview.adr.data.margin":"链路Margin","devicedetail.adrview.adr.data.message":"消息","devicedetail.adrview.adr.data.per":"丢包率","devicedetail.adrview.adr.data.power":"功率(索引)","devicedetail.adrview.adr.data.state":"状态","devicedetail.adrview.adr.data.time":"时间","devicedetail.adrview.adr.event.auto":"系统触发","devicedetail.adrview.adr.event.confirm":"终端确认","devicedetail.adrview.adr.event.error":"错误","devicedetail.adrview.adr.event.info":"信息","devicedetail.adrview.adr.event.manual":"手动触发","devicedetail.adrview.adr.event.reject":"终端拒绝","devicedetail.adrview.adr.event.warning":"告警","devicedetail.adrview.switch.on":"启用","devicedetail.adrview.switch.off":"禁用","devicedetail.adrview.switch.reset":"ADR状态复位","devicedetail.adrview.E.FE_INVALID_DR":"DR值错误","devicedetail.adrview.E.BADARG":"参数错误","devicedetail.adrview.adrlogs.panelheader":"ADR活动日志","devicedetail.adrview.adrstatus.boxheader.ack":"终端确认","devicedetail.adrview.adrstatus.boxheader.nack":"终端拒绝","devicedetail.adrview.adrstatus.boxheader.request":"ADR触发请求","devicedetail.adrview.adrstatus.confirmed":"已确认","devicedetail.adrview.adrstatus.confirmed.title":"ADR配置","devicedetail.adrview.adrstatus.lastacktime":"终端确认时间","devicedetail.adrview.adrstatus.noactivity":"无活动","devicedetail.adrview.adrstatus.request.title":"最新ADR活动","devicedetail.adrview.maxdr.label":"最大DR值","devicedetail.adrview.mindr.label":"最小DR值","devicedetail.adrview.E.GENERALERROR":"网络错误","devicedetail.adrview.E.UNKNOWN":"服务器错误","devicedetail.adrview.E.FE_EMPTY":"不能为空","devicedetail.adrview.E.FE_MINGTMAX":"MinDR不能大于MaxDR","devicedetail.adrview.margin.tips":"最低Margin值，建议值为8~12，取值越高ADR越保守","devicedetail.adrview.marginrate.title":"ADR趋势","devicedetail.adrview.marginrate.nodata":"无最近ADR活动","devicedetail.adrview.marginrate.start":"ADR已经启动","devicedetail.adrview.marginrate.latest":"最新","devicedetail.adrview.marginrate.pingpong":"循环调整次数","devicedetail.adrview.marginrate.count":"样本数量","devicedetail.adrview.marginrate.current":"当前Margin","devicedetail.adrview.marginrate.mean":"Margin平均变化幅度","devicedetail.adrview.marginrate.tips0":"基于","devicedetail.adrview.marginrate.tips1":"个样本值","devicedetail.adrview.marginrate.percentile":"百分比率","devicedetail.adrview.marginrate.dynamic":"动态值","devicedetail.adrview.marginrate.dynamicrange":"动态范围","devicedetail.adrview.marginrate.range":"ADR收敛区间","devicedetail.adrview.marginrate.real":"Margin值","devicedetail.bandview.banddetail.bandvalue":"空","devicedetail.bandview.banddetail.bindbtn":"绑定频段","devicedetail.bandview.banddetail.bindcommonerr":"绑定失败！","devicedetail.bandview.banddetail.flushcommonerr":"下发失败！","devicedetail.bandview.banddetail.flushqueueerr":"下发失败，下发队列已满，请耐心等待！","devicedetail.bandview.banddetail.label":"已绑定频段","devicedetail.bandview.banddetail.modalbody":"该操作会修改设备的射频工作参数，是否继续？","devicedetail.bandview.banddetail.modaltitle":"下发频段计划","devicedetail.bandview.banddetail.modaltitle.bind":"绑定失败提示","devicedetail.bandview.banddetail.modaltitle.flush":"下发频段失败提示","devicedetail.bandview.banddetail.placeholder":"选择一个频段计划","devicedetail.bandview.banddetail.successmodalcontent":"频段计划已经成功下发！","devicedetail.bandview.banddetail.successmodaltitle":"下发提示","devicedetail.bandview.banddetail.title":"设备频段","devicedetail.bandview.banddetail.toolbar.toolsbtn":"下发频段","devicedetail.bandview.banddetail.unbindbtn":"解除绑定","devicedetail.bandview.banddetail.violation":"频段冲突！","devicedetail.data.header":"数据消息","devicedetail.parsed.header":"已解析数据","devicedetail.datatoolview.header":"数据工具","devicedetail.datatoolview.resetseq.cancel":"取消","devicedetail.datatoolview.resetseq.E.GENERALERROR":"修改错误","devicedetail.datatoolview.resetseq.edit":"修改","devicedetail.datatoolview.resetseq.fcntbits":"序列号位数","devicedetail.datatoolview.resetseq.fcntdown":"下行序列号","devicedetail.datatoolview.resetseq.fcntup":"上行序列号","devicedetail.datatoolview.resetseq.ok":"确认","devicedetail.datatoolview.resetseq.reset":"重置上行序列号","devicedetail.datatoolview.resetseq.reseted":"已重置","devicedetail.datatoolview.senddata.data":"数据","devicedetail.datatoolview.senddata.data.placeholder.hex":"Hex","devicedetail.datatoolview.senddata.data.placeholder.text":"文本","devicedetail.datatoolview.senddata.E.FE_EMPTY":"不能为空","devicedetail.datatoolview.senddata.E.FE_INVALIDHEX":"非法Hex数据","devicedetail.datatoolview.senddata.E.FE_INVALIDPORT":"非法端口","devicedetail.datatoolview.senddata.encoding":"数据编码","devicedetail.datatoolview.senddata.flushing":"清空中","devicedetail.datatoolview.senddata.flushtx":"清空队列","devicedetail.datatoolview.senddata.port":"端口","devicedetail.datatoolview.senddata.port.placeholder":"1 至 223","devicedetail.datatoolview.senddata.send":"发送","devicedetail.datatoolview.senddata.sendfailure":"发送失败","devicedetail.datatoolview.senddata.sending":"发送中","devicedetail.datatoolview.senddata.sendsuccess":"已发送","devicedetail.datatoolview.senddata.txsize":"发送队列大小","devicedetail.datatoolview.tab.lorawanseq":"LoRaWAN 序列号","devicedetail.datatoolview.tab.senddata":"下发数据","devicedetail.detailview.alert.down":"下行数据发送成功","devicedetail.detailview.alert.setsuccess":"设置成功","devicedetail.detailview.app":"应用","devicedetail.detailview.bags":"包数","devicedetail.detailview.button.day":"按天","devicedetail.detailview.button.deldev":"删除设备","devicedetail.detailview.button.hour":"按小时","devicedetail.detailview.button.month":"按月","devicedetail.detailview.button.send":"发送","devicedetail.detailview.class.default":"默认","devicedetail.detailview.confirmeddatadown":"确认下行","devicedetail.detailview.confirmeddataup":"确认上行","devicedetail.detailview.datatool.move.notice":"数据下发和序列号重置功能已调整至左侧菜单","devicedetail.detailview.datavalid":"输入偶数位Hex编码","devicedetail.detailview.delete.btn":"删除设备","devicedetail.detailview.delete.cancelbtn":"取消","devicedetail.detailview.delete.confirm":"确定删除设备","devicedetail.detailview.delete.confirmbtn":"确定删除","devicedetail.detailview.delete.modalheader":"删除设备","devicedetail.detailview.deviceproperty":"设备属性","devicedetail.detailview.devicestatus":"设备最新状态","devicedetail.detailview.dropsbags":"丢包数","devicedetail.detailview.E.BADDATARATE":"数据速率DR不正确","devicedetail.detailview.E.BADFREQUENCY":"频率不正确","devicedetail.detailview.E.FE_INVALIDAPPKEY":"非法AppKey","devicedetail.detailview.E.FE_INVALIDLAT":"非法纬度","devicedetail.detailview.E.FE_INVALIDLNG":"非法经度","devicedetail.detailview.E.FE_INVALIDNUM":"非法数字","devicedetail.detailview.E.FE_OUTOFRANGE":"超出范围","devicedetail.detailview.E.FE_PREC4":"最多四位小数","devicedetail.detailview.E.FE_iptNumRange":"输入[1, 255]之间的整数","devicedetail.detailview.fcntdownvalid":"输入[0, 4294967295]之间的整数","devicedetail.detailview.fportvalid":"输入[1, 223]之间的整数","devicedetail.detailview.gatewaymac":"网关MAC","devicedetail.detailview.joinaccept":"JOIN接受","devicedetail.detailview.joinrequest":"JOIN请求","devicedetail.detailview.label.address":"地址","devicedetail.detailview.label.area":"区域","devicedetail.detailview.label.band":"ISM频段","devicedetail.detailview.label.batterystatus":"电池状态","devicedetail.detailview.label.city":"城市","devicedetail.detailview.label.clazz":"终端类型","devicedetail.detailview.label.content":"内容","devicedetail.detailview.label.devaddr":"设备地址","devicedetail.detailview.label.deveui":"设备EUI","devicedetail.detailview.label.vendor":"厂商ID","devicedetail.detailview.label.vendorver":"厂商版本","devicedetail.detailview.label.devid":"自定义标识","devicedetail.detailview.label.devname":"名称","devicedetail.detailview.label.devtype":"设备类型","devicedetail.detailview.label.lastactstatus":"激活状态","devicedetail.detailview.label.lastdataup":"最新收包时间","devicedetail.detailview.label.lat":"纬度","devicedetail.detailview.label.lng":"经度","devicedetail.detailview.label.lwanver":"协议版本","devicedetail.detailview.label.port":"端口","devicedetail.detailview.label.sendqueue":"发送队列","devicedetail.detailview.latestdata.header":"最新消息","devicedetail.detailview.location.address":"地址","devicedetail.detailview.location.area":"区域","devicedetail.detailview.location.city":"城市","devicedetail.detailview.location.coordinate":"坐标","devicedetail.detailview.location.editcoordinate":"编辑坐标","devicedetail.detailview.location.lat":"纬度","devicedetail.detailview.location.lat.placeholder":"-90 ~ +90","devicedetail.detailview.location.lng":"经度","devicedetail.detailview.location.lng.placeholder":"-180 ~ +180","devicedetail.detailview.location.title":"地理位置","devicedetail.detailview.packets":"接收包数","devicedetail.detailview.panelhead.devstatdata":"设备统计数据","devicedetail.detailview.panelhead.lorawan":"LoRaWAN 设备参数","devicedetail.detailview.panelhead.position":"位置","devicedetail.detailview.panelhead.status":"状态","devicedetail.detailview.properr.lat.missing":"缺少纬度","devicedetail.detailview.properr.lat.outofrange":"纬度应在-90～+90之间","devicedetail.detailview.properr.lng.missing":"缺少经度","devicedetail.detailview.properr.lng.outofrange":"经度应在-180～+180之间","devicedetail.detailview.proprietary":"私有消息","devicedetail.detailview.props.name":"名称","devicedetail.detailview.propspanel.status":"设备状态","devicedetail.detailview.result.active":"已激活","devicedetail.detailview.result.unactive":"未激活","devicedetail.detailview.rfu":"其他","devicedetail.detailview.senddata.sendfail":"数据已发送，发送队列已满","devicedetail.detailview.senddata.sendsuccess":"数据已发送","devicedetail.detailview.series.droppedpackets":"丢包数","devicedetail.detailview.series.packets":"包数","devicedetail.detailview.simplemodal.submittitle":"删除","devicedetail.detailview.simplemodal.suretodelete":"确定删除该设备？","devicedetail.detailview.simplemodal.title":"删除设备","devicedetail.detailview.tabstitle.devbasicinfo":"基本信息","devicedetail.detailview.tabstitle.devstat":"统计","devicedetail.detailview.tabstitle.maclog":"Mac命令","devicedetail.detailview.tabstitle.newdata":"最新数据","devicedetail.detailview.time":"时间","devicedetail.detailview.tooptip.msgdetail":"消息详情","devicedetail.detailview.tooptip.statdetail":"统计详情","devicedetail.detailview.unconfirmeddatadown":"非确认下行","devicedetail.detailview.unconfirmeddataup":"非确认上行","devicedetail.detailview.valid.data":"请输入正确的Hex编码","devicedetail.detailview.valid.fport":"请输入[1, 223]之间的整数","devicedetail.detailview.validmesempty":"不能为空","devicedetail.detailview.value.batterystatuserr":"未上报","devicedetail.detailview.value.power":"外接电源","devicedetail.detailview.value.unknown":"未知","devicedetail.detailview.nodevice":"暂无该设备相关信息","devicedetail.detailview.nodevice.tips":"可能已被删除","devicedetail.fieldsgroup.datamsg":"数据消息","devicedetail.fieldsgroup.radio":"无线参数","devicedetail.lrapview.helpdoc":"LRAP用于远程配置和控制支持LRAP协议的终端设备，具体协议规范参考文档部分。","devicedetail.lrapview.logs.tableheader":"操作日志","devicedetail.lrapview.op":"操作","devicedetail.lrapview.optime":"操作时间","devicedetail.lrapview.panel.header":"LRAP寄存器","devicedetail.lrapview.payload":"值","devicedetail.lrapview.port":"协议端口","devicedetail.lrapview.port.placeholder":"1~223，默认为223","devicedetail.lrapview.readsubmit.btn":"读取寄存器","devicedetail.lrapview.readsubmit.btn.error":"读取请求失败","devicedetail.lrapview.readsubmit.btn.success":"读取请求成功","devicedetail.lrapview.readsubmit.tips":"读取请求成功，请稍后查看操作日志。","devicedetail.lrapview.register":"寄存器ID","devicedetail.lrapview.register.placeholder":"选择寄存器","devicedetail.lrapview.tabs.read.title":"读寄存器","devicedetail.lrapview.tabs.write.title":"写寄存器","devicedetail.lrapview.value":"寄存器值","devicedetail.lrapview.value.placeholder":"前缀：'0x'→16进制，'0b'→2进制","devicedetail.lrapview.writesubmit.btn":"写入寄存器","devicedetail.lrapview.writesubmit.btn.error":"写入失败","devicedetail.lrapview.writesubmit.btn.success":"写入成功","devicedetail.lrapview.writesubmit.tips":"写请求成功，请稍后查看操作日志。","devicedetail.macview.checkqueue":"查看队列","devicedetail.macview.dlchannelreq.chindex.placeholder":"信道ID，取值0~15","devicedetail.macview.dlchannelreq.freq.placeholder":"根据频段计划填写，单位HZ/100","devicedetail.macview.dutycyclereq.maxdc.placeholder":"请输入[0, 15]之间的整数","devicedetail.macview.E.BADARG":"参数错误","devicedetail.macview.E.CONFLICT":"之前的命令尚未完成","devicedetail.macview.E.FE_EMPTY":"不能为空","devicedetail.macview.E.FE_INVALID":"参数错误","devicedetail.macview.E.GENERALERROR":"发送错误","devicedetail.macview.E.UNAPPLICABLE":"命令不可应用","devicedetail.macview.E.UNSUPPORTED":"命令不支持","devicedetail.macview.E.UNKNOWN":"服务器错误","devicedetail.macview.error.empty":"不能为空","devicedetail.macview.error.invalidfmt":"格式错误","devicedetail.macview.linkadrreq.chmask.placeholder":"请输入[0, 65535]之间的整数","devicedetail.macview.linkadrreq.chmaskcntl.placeholder":"请输入[0, 7]之间的整数","devicedetail.macview.linkadrreq.datarate.placeholder":"请输入[0, 15]之间的整数","devicedetail.macview.linkadrreq.nbtrans.placeholder":"请输入[0, 15]之间的整数","devicedetail.macview.linkadrreq.txpower.placeholder":"请输入[0, 15]之间的整数","devicedetail.macview.maccommand":"MAC命令","devicedetail.macview.maclog.maccommand":"MAC命令","devicedetail.macview.maclog.maclog":"MAC命令日志","devicedetail.macview.maclog.parameter":"参数","devicedetail.macview.maclog.parameter.data":"参数数据","devicedetail.macview.maclog.time":"时间","devicedetail.macview.newchannelreq.chindex.placeholder":"信道ID，取值0~15","devicedetail.macview.newchannelreq.freq.placeholder":"根据频段计划填写，单位HZ/100","devicedetail.macview.newchannelreq.maxdr.placeholder":"最大速率，取值0~15","devicedetail.macview.newchannelreq.mindr.placeholder":"最小速率，取值0~15","devicedetail.macview.refresh":"刷新","devicedetail.macview.rxparamsetupreq.rx1droffset.placeholder":"请输入[0, 5]之间的整数","devicedetail.macview.rxparamsetupreq.rx2dr.placeholder":"请输入[0, 13]之间的整数","devicedetail.macview.rxparamsetupreq.rx2freq.placeholder":"根据频段计划填写，单位HZ/100","devicedetail.macview.rxtimingsetupreq.delay.placeholder":"请输入[0, 15]之间的整数","devicedetail.macview.selectmac":"选择MAC命令","devicedetail.macview.senderr.arg":"参数错误","devicedetail.macview.senderr.freq":"Frequence错误","devicedetail.macview.senderr.mindr":"Min DR错误","devicedetail.macview.senderr.pending":"之前的命令尚未完成","devicedetail.macview.sendqueue":"发送队列","devicedetail.macview.submit":"发送命令","devicedetail.macview.submit.failure":"发送失败","devicedetail.macview.submit.success":"发送成功","devicedetail.macview.time":"数据时间","devicedetail.macview.txparamsetupreq.dldwelltime.placeholder":"0~1","devicedetail.macview.txparamsetupreq.maxeirp":"最大EIRP","devicedetail.macview.txparamsetupreq.maxeirp.placeholder":"请输入[0, 15]之间的整数","devicedetail.macview.txparamsetupreq.uldwelltime.placeholder":"0~1","devicedetail.macview.updchplanreq.chplan":"信道计划","devicedetail.macview.updchplanreq.chplan.placeholder":"选择一个信道计划","devicedetail.macview.addbroadcastreq.devaddr.placeholder":"长度为8的字符串","devicedetail.macview.addbroadcastreq.keys.placeholder":"长度为32的字符串","devicedetail.macview.addbroadcastreq.fcnt.placeholder":"32位无符号整数","devicedetail.macview.addbroadcastreq.address.label":"广播地址","devicedetail.macview.addbroadcastreq.appskey.label":"应用密钥","devicedetail.macview.addbroadcastreq.nwskey.label":"网络密钥","devicedetail.macview.addbroadcastreq.address":"广播地址","devicedetail.macview.addbroadcastreq.fcnt":"帧号","devicedetail.macview.E.FE_INVALIDAPPKEY":"非法密钥","devicedetail.macview.E.FE_INVALIDADDR":"非法地址","devicedetail.macview.E.INVALID_FCNT":"非法的帧号","devicedetail.macview.E.BADARG_FCNT":"非法的帧号","devicedetail.map.address":"设备地址","devicedetail.map.devaddr":"DevAddr","devicedetail.map.deveui":"DevEUI","devicedetail.map.id":"设备ID","devicedetail.map.name":"设备名称","devicedetail.sidebar.menu.datatool":"数据工具","devicedetail.sidebar.menu.devicelog":"设备日志","devicedetail.sidebar.menu.detail":"设备详情","devicedetail.sidebar.menu.lrap":"LRAP","devicedetail.sidebar.menu.maccommand":"MAC命令","devicedetail.sidebar.menu.scheme":"设备频段","devicedetail.sidebar.menu.stat":"数据统计","devicedetail.sidebar.menu.topo":"设备拓扑","devicedetail.sidebar.title":"设备详情","devicedetail.statview.button.day":"按天","devicedetail.statview.button.hour":"按小时","devicedetail.statview.button.month":"按月","devicedetail.statview.devicestatus":"设备状态","devicedetail.statview.gatewaymac":"网关MAC","devicedetail.statview.series.devicestatus":"设备状态","devicedetail.statview.series.droppedpackets":"丢包数","devicedetail.statview.series.packets":"包数","devicedetail.statview.timerange":"数据时间","devicedetail.statview.timerange.lbl":"数据时间","devicedetail.topoview.best":"最佳","devicedetail.topoview.data.bandwidth":"带宽","devicedetail.topoview.data.bitrate":"速率(bits/sec)","devicedetail.topoview.data.dr":"速率","devicedetail.topoview.data.fcnt":"帧号","devicedetail.topoview.data.gateway":"网关","devicedetail.topoview.data.modulation":"调制方式","devicedetail.topoview.data.sf":"扩频因子","devicedetail.topoview.data.time":"最后连接时间","devicedetail.topoview.data.delete":"删除","devicedetail.topoview.header":"网关链路","devicedetail.topoview.deflink.add":"添加","devicedetail.topoview.deflink.gatewayid":"网关","devicedetail.topoview.deflink.empty":"不能为空","devicedetail.topoview.deflink.confirm":"确定","devicedetail.topoview.deflink.downlink":"默认下行链路","devicedetail.topoview.deflink.delete":"删除下行链路","devicedetail.topoview.deflink.deletetip":"确认删除默认下行链路","devicedetail.topoview.E.GENERALERROR":"服务器错误","devicedetail.topoview.E.null":" ","devicedetail.devicelog.header":"设备日志","devicedetail.devicelog.thead.code":"代码","devicedetail.devicelog.thead.loglevel":"级别","devicedetail.devicelog.thead.remark":"详细信息","devicedetail.devicelog.thead.time":"时间","gateway.addgateway.adderr.modalheader":"新增网关错误","gateway.addgateway.adderr.outofquota.comm":"您的网关配额已满。需要创建更多网关，请联系我们。","gateway.addgateway.adderr.outofquota.cube":"您的网关配额已满。需要创建更多网关，请联系我们。","gateway.addgateway.adderr.outofquota.undercomm":"您的网关配额已满。需要创建更多网关，请升级您的账户。","gateway.addgateway.adderr.upgrade":"升级","gateway.address":"区域","gateway.area":"城市","gateway.gateway":"网关","gateway.list.search.placeholder":"搜索网关","gateway.log.daterange.label":"日志时间","gateway.mac":"MAC地址","gateway.map.search.placeholder":"搜索网关","gateway.map.nogateway":"暂无网关","gateway.name":"名称","gateway.platform":"网关型号","gateway.band":"频段","gateway.status":"连接状态","gateway.coord":"坐标","gateway.tooltip.list":"我的网关","gateway.tooltip.log":"网关日志","gateway.tooltip.map":"网关地图","gateway.version":"SDK版本","gateway.map.id":"网关ID","gateway.map.mac":"网关MAC","gateway.map.address":"地址","gateway.map.name":"名称","gateway.map.status":"状态","gateway.map.status.connected":"已连接","gateway.map.status.disconnected":"未连接","gatewaydetail.breadcrumbs.gatewayadd":"添加网关","gatewaydetail.breadcrumbs.gateways":"我的网关","gatewaydetail.datadir.down.btn":"下行","gatewaydetail.datadir.up.btn":"上行","gatewaydetail.detailview.auth.title":"鉴权","gatewaydetail.detailview.band.nav":"网关配置","gatewaydetail.detailview.band.toolbarbutton.back":"返回","gatewaydetail.detailview.band.unkowntips":"数据未上报","gatewaydetail.detailview.band.unkowntips.reason1":"检查网关是否连接","gatewaydetail.detailview.band.unkowntips.reason2":"确保正确安装了最新版本的SDK","gatewaydetail.detailview.band.unkowntips.reason3":"部分网关型号暂未支持","gatewaydetail.detailview.delete":"删除","gatewaydetail.detailview.delete.cancelbtn":"取消","gatewaydetail.detailview.delete.confirmbtn":"确定","gatewaydetail.detailview.delete.deleting":"删除中","gatewaydetail.detailview.delete.failure":"删除失败","gatewaydetail.detailview.delete.modalcontent":"确定删除网关","gatewaydetail.detailview.delete.modalheader":"删除网关","gatewaydetail.detailview.delete.success":"删除成功","gatewaydetail.detailview.E.FE_INVALIDLAT":"非法纬度","gatewaydetail.detailview.E.FE_INVALIDLNG":"非法经度","gatewaydetail.detailview.E.UNAPPLICABLE":"无法连接网关","gatewaydetail.detailview.E.NOROUTE":"无法连接网关","gatewaydetail.detailview.E.GENERALERROR":"服务器错误","gatewaydetail.detailview.E.UNKNOWN":"网络错误","gatewaydetail.detailview.E.UNSUPPORTED":"网关不支持","gatewaydetail.detailview.E.WONTRESTORED":"配置更新错误并无法恢复，pktfwd进程无法恢复运行","gatewaydetail.detailview.E.RESTORED":"配置更新错误。已恢复原配置，pktfwd进程已重启。","gatewaydetail.detailview.E.FACTORYRESTORED":"配置更新错误。原配置无法恢复，已恢复出厂配置，pktfwd进程已重启。","gatewaydetail.detailview.E.TIMEOUT":"写入超时","gatewaydetail.detailview.gatewaylist.connected":"已连接","gatewaydetail.detailview.gatewaylist.disconnected":"未连接","gatewaydetail.detailview.gatewaylist.header":"网关列表","gatewaydetail.detailview.gatewaylist.tipGateway":"没有网关存在，请添加网关","gatewaydetail.detailview.gatewaylist.nogateway":"暂无网关","gatewaydetail.detailview.gatewaylist.buygateway":"购买网关","gatewaydetail.detailview.latestdata.header":"最新消息","gatewaydetail.detailview.location.address":"地址","gatewaydetail.detailview.location.area":"区域","gatewaydetail.detailview.location.city":"城市","gatewaydetail.detailview.location.coordinate":"坐标","gatewaydetail.detailview.location.altitude":"海拔","gatewaydetail.detailview.location.editcoordinate":"编辑坐标","gatewaydetail.detailview.location.title":"地理位置","gatewaydetail.detailview.loraparams.title":"LoRa参数","gatewaydetail.detailview.netstatus.laston":"最近连接时间","gatewaydetail.detailview.netstatus.lastpacket":"最新收包时间","gatewaydetail.detailview.netstatus.latency":"时延","gatewaydetail.detailview.netstatus.status":"连接状态","gatewaydetail.detailview.netstatus.status.connected":"已连接","gatewaydetail.detailview.netstatus.status.disconnected":"未连接","gatewaydetail.detailview.netstatus.title":"网关状态","gatewaydetail.detailview.newdata.thead.time":"时间","gatewaydetail.detailview.noauth":"无鉴权","gatewaydetail.detailview.panel.header.gwstat":"网关最新状态","gatewaydetail.detailview.ping":"Ping","gatewaydetail.detailview.pingfail":"无法Ping通!","gatewaydetail.detailview.pingsucc":"已Ping通!","gatewaydetail.detailview.properties.id":"网关ID","gatewaydetail.detailview.properties.mac":"MAC地址","gatewaydetail.detailview.properties.name":"网关名称","gatewaydetail.detailview.properties.platform":"网关型号","gatewaydetail.detailview.properties.ip":"IP地址","gatewaydetail.detailview.properties.title":"网关属性","gatewaydetail.detailview.restart":"重启","gatewaydetail.detailview.restartfail":"重启失败!","gatewaydetail.detailview.restartsucc":"已重启!","gatewaydetail.detailview.upgradeSDK":"SDK升级","gatewaydetail.detailview.NoSupportUpSDK":"不支持升级","gatewaydetail.detailview.NoUpgradeSDK":"没有新版本","gatewaydetail.detailview.sugUpgrade":"有新版本","gatewaydetail.detailview.currentVer":"当前版本","gatewaydetail.detailview.newVer":"新版本","gatewaydetail.detailview.upgrade.cancelbtn":"取消","gatewaydetail.detailview.upgradeSDKDur":"开始升级","gatewaydetail.detailview.upgradeSDKfail":"升级失败","gatewaydetail.detailview.upgradeSDKSuccTips":"升级正在进行，升级完成后网关自动连接","gatewaydetail.detailview.sdk.dl":"下载","gatewaydetail.detailview.sdk.docdl":"SDK文档","gatewaydetail.detailview.sdk.sdkdl":"SDK下载","gatewaydetail.detailview.sdk.version":"SDK版本","gatewaydetail.detailview.sdk.view":"查看","gatewaydetail.detailview.toolbarbutton.band":"频段","gatewaydetail.detailview.txpower.opts.default":"默认","gatewaydetail.detailview.chplan":"信道计划","gatewaydetail.detailview.chplan.unbind":"空","gatewaydetail.detailview.chplan.flush":"写入网关","gatewaydetail.detailview.chplan.flush.failure":"失败，重新写入","gatewaydetail.detailview.tokenmanage":"Token管理","gatewaydetail.E.BADTOKEN":"会话已过期，请刷新页面重新登录","gatewaydetail.E.NOTFOUND":"网关不存在","gatewaydetail.E.UNKNOWN":"网络错误","gatewaydetail.error.goback":"返回网关管理","gatewaydetail.gatewayadd.button.fail":"添加失败!","gatewaydetail.gatewayadd.button.pending":"添加中","gatewaydetail.gatewayadd.button.submit":"确认添加","gatewaydetail.gatewayadd.button.succ":"添加成功!","gatewaydetail.gatewayadd.E.FE_EMPTY":"不能为空","gatewaydetail.gatewayadd.E.FE_MACINVALID":"MAC地址格式不正确","gatewaydetail.gatewayadd.E.MACADDRUNAVAIL":"已存在MAC地址相同网关","gatewaydetail.gatewayadd.E.QUOTA":"配额已满","gatewaydetail.gatewayadd.field.addr":"地址","gatewaydetail.gatewayadd.field.area":"区域","gatewaydetail.gatewayadd.field.city":"城市","gatewaydetail.gatewayadd.field.mac":"MAC地址","gatewaydetail.gatewayadd.field.mac.explain":"网关的MAC地址在网关连接传输期间需要使用","gatewaydetail.gatewayadd.field.name":"网关名称","gatewaydetail.gatewayadd.field.platform":"网关型号","gatewaydetail.gatewayadd.field.platform.explain":"网关的型号决定网关的SDK和安装使用过程","gatewaydetail.gatewayadd.fieldgroups.location":"地址信息","gatewaydetail.gatewayadd.fieldgroups.location.explain":"补充网关地址信息将帮助您跟踪管理设备","gatewaydetail.gatewayadd.gateway":"网关","gatewaydetail.gatewayadd.tip.createGatewayFailTip":"注册失败，此MAC地址已经被注册！","gatewaydetail.logview.daterangepicker.label":"数据时间","gatewaydetail.menu.conf":"网关配置","gatewaydetail.menu.datamsg":"数据消息","gatewaydetail.menu.detail":"网关详情","gatewaydetail.menu.log":"网关日志","gatewaydetail.menu.stat":"数据统计","gatewaydetail.sidebar.title":"网关详情","gatewaydetail.statschart.axis.latency":"时延(ms)","gatewaydetail.statschart.axis.pkts":"包数","gatewaydetail.statschart.axis.ms":"毫秒","gatewaydetail.statschart.axis.ratio":"占比","gatewaydetail.statschart.name.freqratio":"频率包数比例","gatewaydetail.statschart.name.pktdistr":"包数比例","gatewaydetail.statschart.name.sfratio":"扩频因子包数比例","gatewaydetail.statschart.series.latency":"时延","gatewaydetail.statschart.series.pkts":"总包数","gatewaydetail.statschart.series.pktsau":"已授权包数","gatewaydetail.statschart.series.pktsun":"未授权包数","gatewaydetail.statview.data.header":"数据消息","gatewaydetail.statview.daterangepicker.label":"数据时间","gatewaydetail.statview.fields.messagedata":"数据消息","gatewaydetail.statview.fields.radio":"无线参数","gatewaydetail.statview.fields.spills.datamsg":"数据消息","gatewaydetail.statview.fields.spills.radio":"无线参数","gatewaydetail.statview.packetstat.byfreq":"按频率(MHZ)分布","gatewaydetail.statview.packetstat.bysf":"按扩频因子分布","gatewaydetail.statview.packetstat.packets":"包数统计","gatewaydetail.statview.toastat.byfreq.uplink":"信道上行TOA统计","gatewaydetail.statview.toolbar.bytime.minutes":"按十分钟","gatewaydetail.statview.toolbar.bytime.days":"按天","gatewaydetail.statview.toolbar.bytime.hours":"按小时","gatewaydetail.statview.toolbar.bytime.months":"按月","gatewaydetail.statview.toolbar.daterangepicker":"数据时间","gatewaydetail.statview.toolbar.dataview.ratio":"占比","gatewaydetail.statview.toolbar.dataview.ms":"毫秒","gatewaydetail.statview.tabs.packets":"包数统计","gatewaydetail.statview.tabs.tao":"TOA(Time On Air)统计","gatewaydetail.statview.unconfirmeddataup":"非确认上行","gatewaydetail.statview.unconfirmeddatadown":"非确认下行","gatewaydetail.statview.confirmeddataup":"确认上行","gatewaydetail.statview.confirmeddatadown":"确认下行","gatewaydetail.statview.joinrequest":"JOIN请求","gatewaydetail.statview.joinaccept":"JOIN接受","gatewaydetail.statview.rfu":"其他","gatewaydetail.statview.proprietary":"私有消息","gatewaydetail.detailview.unconfirmeddataup":"非确认上行","gatewaydetail.detailview.unconfirmeddatadown":"非确认下行","gatewaydetail.detailview.confirmeddataup":"确认上行","gatewaydetail.detailview.confirmeddatadown":"确认下行","gatewaydetail.detailview.joinrequest":"JOIN请求","gatewaydetail.detailview.joinaccept":"JOIN接受","gatewaydetail.detailview.rfu":"其他","gatewaydetail.detailview.proprietary":"私有消息","gatewaylog.thead.cat":"日志级别","gatewaylog.thead.code":"日志代码","gatewaylog.thead.mac":"MAC地址","gatewaylog.thead.message":"详细信息","gatewaylog.thead.panelheader":"网关日志","gatewaylog.thead.time":"时间","gatewaylog.nodata":"暂无日志","login.E.ACCINACTIVE":"账号尚未激活","login.E.BADACCOUNT":"账号或密码错误","login.E.BADPASSWORD":"账号或密码错误","login.E.FE_EMAILEMPTY":"请输入登录邮箱","login.E.FE_PASSWORDEMPTY":"请输入密码","login.E.UNKNOWN":"登录错误","login.E.GENERALERROR":"服务器错误","login.button":"登录","login.email.placeholder":"邮箱","login.forgetpwd":"忘记密码","login.password.placeholder":"密码","login.signup":"注册","login.title":"登录loraFlow","login.reactivate":"重新发送激活邮件","login.reactivate.success":"发送成功！请检查邮件","login.reactivate.failure":"发送失败！点击重新发送","login.reactivate.pending":"发送中","lostpassword.title":"重置密码","lostpassword.submit":"提交","lostpassword.submit.success":"提交成功","lostpassword.submit.failure":"提交失败","lostpassword.submit.pending":"提交中","lostpassword.email":"邮箱","lostpassword.email.placeholder":"登录邮箱","lostpassword.verifycode":"验证码","lostpassword.E.FE_EMPTY":"不能为空","lostpassword.E.FE_INVALIDEMAIL":"邮箱格式不正确","lostpassword.E.BADVERIFY":"验证码不正确","lostpassword.E.BADACCOUNT":"账户不存在","lostpassword.E.GENERALERROR":"网络错误，请稍后尝试","lostpassword.E.ACCINACTIVE":"账号未激活","lostpassword.success.h1":"最后一步，查看邮件完成密码的重置","lostpassword.success.p1":"我们已经向您的邮箱","lostpassword.success.p2":"发送了一封重置密码的邮件，请点击邮件中的链接重置密码！","lostpassword.success.btn":"立即进入邮箱","lostpassword.success.footer.h3":"没有收到邮件？","lostpassword.success.footer.li1":"看看是否在邮箱的回收站、垃圾邮件中","lostpassword.success.footer.li2.txt1":"点击","lostpassword.success.footer.li2.txt2":"更换重置邮箱","mapoverlay.edit":"选择地点","mapoverlay.submit":"保存位置","network.adrview.E.GENERALERROR":"服务器错误，暂无法调整ADR","network.adrview.E.UNKNOWN":"网络错误","network.adrview.switch.off":"禁用","network.adrview.switch.on":"启用","network.adrview.tips.title":"提示：","network.adrview.tips1":"启用ADR之后，你可以在设备详情中查看每个设备的ADR状态和日志。","network.adrview.tips2":"启用ADR之后，服务器将持续对终端进行ADR优化。","network.adrview.tips3":"不论是否开启ADR服务，你始终可以直接通过MAC命令方式手工调整设备的ADR参数。","network.analytics.gateway.flow":"上行流量","network.analytics.gateway.flow.help":"流量：网关一天之内上行消息大小的总和。值越大表示网关越繁忙。","network.analytics.gateway.gateway":"网关ID","network.analytics.gateway.invalid_pre":"消息冗余度","network.analytics.gateway.invalid_pre.help":"消息冗余度：网关一天之内无效消息数和消息总数的比值。设备发送的一条上行消息被多个网关收到时，其中rssi值最好的消息是有效消息，其他消息是无效消息。无效消息多，会影响网关接收消息的效率，可能原因是网关部署位置不合理或者设备消息发送设置不当。","network.analytics.gateway.name":"名称","network.analytics.gateway.node":"DevEUI","network.analytics.gateway.pie.flow.1":"1MB以下","network.analytics.gateway.pie.flow.2":"1MB 到 10MB","network.analytics.gateway.pie.flow.3":"10MB以上","network.analytics.gateway.pie.invalid_pre.1":"10%以下","network.analytics.gateway.pie.invalid_pre.2":"10% 到 30%","network.analytics.gateway.pie.invalid_pre.3":"30% 到 60%","network.analytics.gateway.pie.invalid_pre.4":"60% 到 90%","network.analytics.gateway.pie.invalid_pre.5":"90%以上","network.analytics.gateway.pie.title.flow":"网关分布(按流量)","network.analytics.gateway.pie.title.invalid_pre":"网关分布(按冗余度)","network.analytics.gateway.pie.title.toa":"网关分布(按TOA)","network.analytics.gateway.pie.toa.1":"1分钟以下","network.analytics.gateway.pie.toa.2":"1分钟 到 1小时","network.analytics.gateway.pie.toa.3":"1小时以上","network.analytics.gateway.rank":"排名","network.analytics.gateway.rank.gateway":"网关排名","network.analytics.gateway.rank.node":"关联设备","network.analytics.gateway.title":"网关分析","network.analytics.gateway.toa":"TOA","network.analytics.gateway.toa.help":"TOA：网关一天之内接收上行消息TOA(Time on Air)的总和。值越大表示网关越繁忙。","network.analytics.gateway.total.help":"通过对网关一天之内收到的消息进行分析，得出网关分布，网关排名，关联设备详情。用于了解跟踪网关、设备状况。根据分析结果调整网络部署，参数配置。","network.analytics.node.appeui":"APPEUI","network.analytics.node.deveui":"DevEUI","network.analytics.node.loss_pre":"丢包率","network.analytics.node.loss_pre.help":"设备一天之内消息丢失数量和消息总数的比值，值越大表示信道质量越差。","network.analytics.node.overtime":"超时时间","network.analytics.node.pre":"丢包率","network.analytics.node.rank":"排名","network.analytics.node.rssi":"RSSI","network.analytics.node.rssi.help":"设备一天之内上行消息RSSI的平均值(按扩频因子分开排名)，值越小表示信道质量越差。0.00表示没有用该扩频因子发送过消息。","network.analytics.node.snr":"SNR","network.analytics.node.snr.help":"设备一天之内消息信噪比的平均值，值越小表示信道质量越差。","network.analytics.node.toa":"TOA","network.analytics.node.toa.help":"设备一天之内发送上行消息TOA(Time on Air)的总和，值越大表示占用信道时间越长。","network.banddetail.deletemodal.cancel":"取消","network.banddetail.deletemodal.confirm":"确定","network.banddetail.deletemodal.E.BUSY":"删除失败，不能删除已经被使用的信道计划。","network.banddetail.deletemodal.E.GENERALERROR":"服务器错误","network.banddetail.deletemodal.E.UNKNOWN":"删除失败","network.banddetail.deletemodal.header":"删除失败提示","network.banddetail.deletemodal.title":"删除信道计划","network.banddetail.detailview.channeltag":"保留","network.banddetail.detailview.deletebtn":"删除计划","network.banddetail.detailview.label.ctime":"创建时间","network.banddetail.detailview.panelhead.channellist":"信道列表","network.banddetail.detailview.renderchannelhead":"信道","network.banddetail.detailview.renderdetail.title":"计划属性","network.banddetail.detailview.tabletd.freechannel":"自由信道","network.banddetail.detailview.tabletd.reservedchannel":"保留信道","network.banddetail.detailview.tableth.channelid":"信道号","network.banddetail.detailview.tableth.define":"信道类型","network.banddetail.detailview.tableth.type":"信道制式","network.banddetail.detailview.toolbar.firstnav":"信道计划","network.banddetail.menuitems.detail":"详情","network.banddetail.sidebar.title":"信道计划","network.bandview.addplan":"新增信道计划","network.bandview.tableth.band":"频段","network.bandview.tableth.channels":"信道数","network.bandview.tableth.createtime":"创建时间","network.bandview.tableth.fixed":"保留信道","network.bandview.tableth.name":"名称","network.bandview.tableth.unfixed":"可编辑信道","network.bandview.title":"信道计划","network.channelview.add.band":"频段","network.channelview.channelnumber":"信道数","network.channelview.add.firstnav":"信道计划","network.channelview.add.fixed.available":"可选信道","network.channelview.add.fixed.full":"已选满","network.channelview.add.fixed.selected":"已选信道","network.channelview.add.fixed.restrict":"可选但不推荐","network.channelview.add.fixed.restrict.caution":"信道 6~38，45~77 所在的频率范围可能被中国电力行业使用。","network.channelview.add.free.freq":"频率(MHz)","network.channelview.add.free.type":"信道类型","network.channelview.add.free.addch":"添加信道","network.channelview.add.free.E.FE_EMPTY":"不能为空","network.channelview.add.free.E.FE_INVALIDFREQ":"频率不正确","network.channelview.add.free.E.FE_DUPFREQ":"频率已重复添加","network.channelview.add.free.E.FE_MINGTMAX":"MinDR不能大于MaxDR","network.channelview.E.FE_EMPTY":"不能为空","network.channelview.add.E.FE_CHANNEL.EMPTY":"添加信道不能为空","network.channelview.add.name":"名称","network.channelview.add.name.placeholder":"填写利于记忆的名称","network.channelview.add.panelheader":"创建信道计划","network.channelview.add.secondnav":"创建信道计划","network.channelview.add.submit":"创建","network.channelview.add.channels.header":"已添加信道","network.channelview.add.channels.id":"信道号","network.channelview.add.channels.type":"信道类型","network.channelview.add.channels.freq":"频率(MHz)","network.channelview.add.channels.define":"信道定义","network.channelview.add.channels.selecttips":"编辑或选择添加信道","network.channelview.add.channels.delete":"删除","network.channelview.add.channels.edit":"编辑","network.channelview.add.channels.reserved":"保留信道","network.channelview.add.E.FE_EMPTY":"不能为空","network.channelview.add.E.GENERALERROR":"服务器错误","network.channelview.add.E.UNKNOWN":"网络错误","network.channelview.add.nametip":"长度不超过32个字符","network.channelview.editdr.header":"编辑DR","network.channelview.editdr.mindr":"Min DR","network.channelview.editdr.maxdr":"Max DR","network.channelview.editdr.button.confirm":"确定","network.channelview.editdr.E.FE_MINGTMAX":"MinDR不能大于MaxDR","network.schemeadd.addchanellimit":"超出限制","network.schemeadd.addchannel.btn":"添加信道","network.schemeadd.addchannelbtn.tooltipmsg":"添加到已选队列","network.schemeadd.channelparameter":"信道参数","network.schemeadd.channelslimit":"最多只能添加16个信道！","network.schemeadd.drvaliderr":"值区间在0~15","network.schemeadd.drvalidinteger":"值为整数","network.schemeadd.explain.p1":"信道","network.schemeadd.explain.p2":"6到38和45到77","network.schemeadd.explain.p3":"主要被用于中国电力。在这些信道被中国电力使用的地区，","network.schemeadd.explain.p4":"它们应该被禁止使用。","network.schemeadd.explain.p5":"翻译于","network.schemeadd.fixederr":"Fixed的值不能大于通道数","network.schemeadd.formlabel.fixed":"保留信道","network.schemeadd.formplaceholder.bandname":"输入频段的名称","network.schemeadd.formplaceholder.fixed":"输入信道计划的只读部分，不能大于通道数","network.schemeadd.formplaceholder.freq":"请输入一个值在100~1670之间的频率","network.schemeadd.formplaceholder.maxdr":"最大DataRate，值在0~15之间","network.schemeadd.formplaceholder.mindr":"最小DataRate，值在0~15之间","network.schemeadd.formplaceholder.planname":"输入信道计划的名称","network.schemeadd.freqerr":"不能有相同的Frequence值","network.schemeadd.freqintergervalid":"最多保留4位小数","network.schemeadd.freqvaliderr":"值区间在","network.schemeadd.freqvaliderr.to":"~","network.schemeadd.label.channeltype":"信道类型","network.schemeadd.maxdrerr":"不能小于Min DR","network.schemeadd.mindrerr":"不能大于Max DR","network.schemeadd.modalhead.title":"信道添加说明","network.schemeadd.panelhead.addchannel":"添加信道","network.schemeadd.panelhead.pickchannel":"选择信道","network.schemeadd.panelhead.property":"添加属性","network.schemeadd.panelheadright":"添加信道","network.schemeadd.reservedchanneltag":"保留","network.schemeadd.submiterr.err":"错误！","network.schemeadd.submiterr.frequence":"频点","network.schemeadd.submiterr.nochannel":"未添加信道！","network.schemeadd.tabletd.freechannel":"自由信道","network.schemeadd.tabletd.reservedchannel":"保留信道","network.schemeadd.tabletd.tooltipmsg":"保留信道，不能编辑","network.signalcoverageview.description.heading":"最大信号覆盖距离","network.signalcoverageview.title":"覆盖计算","network.signalcoverageview.transmitPower":"发射功率（Transmit Power）","network.signalcoverageview.structuralAttenuation":"结构损耗（Structural Attenuation）","network.signalcoverageview.endNodeAntenna":"终端天线增益（End Node Antenna Gain）","network.signalcoverageview.gatewayAntenna":"网关天线增益（Gateway Antenna Gain）","network.signalcoverageview.fadeMargin":"衰落余量（Fade Margin）","network.signalcoverageview.Sensitivity":"灵敏度（Sensitivity）","network.signalcoverageview.gatewayAntennaHeight":"网关天线高度（Gateway Antenna Height）","network.signalcoverageview.endNodeHeight":"终端天线高度（End Node Height）","network.sidebar.menuitems.band":"信道规划","network.sidebar.menuitems.gateway":"网关分析","network.sidebar.menuitems.node":"设备分析","network.sidebar.menuitems.coverage":"覆盖计算","network.sidebar.menuitems.quality":"信号质量","network.sidebar.menuitems.capacity":"网络负载","network.sidebar.menuitems.capacityCalculation":"容量计算","network.sidebar.menuitems.unauthorized":"未授权包","network.sidebar.menuitems.roadtest":"路测仪","network.sidebar.menuitems.tdm":"TDM","network.sidebar.menuitems.tdmstatis":"TDM统计","network.sidebar.title":"网络管理","network.qualityView.title":"信号质量","network.qualityView.deviceListHeader":"设备列表","network.qualityView.deviceScatterHeader":"设备散点图","network.qualityView.packetHeatmapHeader":"网络质量分布","network.qualityView.header":"网络质量","network.qualityView.hours":"小时","network.qualityView.average":"平均","network.qualityView.loss":"丢包率","network.qualityView.density":"密度","network.qualityView.frequency":"频率","network.qualityView.thead.name":"名称","network.qualityView.thead.deveui":"DevEUI","network.qualityView.thead.packetLossRate":"丢包率","network.qualityView.thead.snrAvg":"SNR平均","network.qualityView.thead.snrStd":"SNR抖动","network.qualityView.thead.rssiAvg":"RSSI平均 (dbm)","network.qualityView.thead.rssiStd":"RSSI抖动 (dbm)","network.qualityView.thead.toaAvg":"TOA平均 (ms)","network.qualityView.thead.toaSum":"TOA总数 (ms)","network.qualityView.thead.upPacketCount":"上行包数 (丢包数／总数)","network.capacityview.title":"网络负载","network.capacityview.tableHeader":"设备列表","network.capacityview.hours":"小时","network.capacityview.thead.name":"名称","network.capacityview.thead.deveui":"DevEUI","network.capacityview.thead.interval_median":"周期中位数 (s)","network.capacityview.thead.interval_percentile":"周期 90%分布 (s)","network.capacityview.thead.toa_median":"TOA 中位数 (ms)","network.capacityview.thead.toa_percentile":"TOA 90%分布 (ms)","network.capacityview.thead.rate":"冗余度(%)","network.capacityview.thead.total":"上行包数","network.capacityview.thead.last_ts":"最近上行包","network.capacityview.thead.total_toa":"TOA总数 (ms)","network.capacityview.loadBarChartHeader":"网络负载","network.capacityview.freqBarChartHeader":"频点负载分布","network.capacityview.Load":"负载／吞吐量","network.capacityview.LoadG":"负载","network.capacityview.LoadS":"吞吐量","network.capacityview.Loss":"丢包率","network.CapacityCalculationView.title":"容量计算","network.CapacityCalculationView.packetRatePerHour":"单设备每小时数据包数","network.CapacityCalculationView.spreadFactor":"扩频因子","network.CapacityCalculationView.payload":"Payload长度","network.CapacityCalculationView.channel":"信道数","network.CapacityCalculationView.description.heading":"网关接入设备数","network.UnauthorizedPacketView.title":"未授权包","network.UnauthorizedPacketView.tableHeader":"未授权包列表","network.UnauthorizedPacketView.hours":"小时","network.UnauthorizedPacketView.thead.devaddr":"DevADDR","network.UnauthorizedPacketView.thead.deveui":"DevEUI","network.UnauthorizedPacketView.thead.gateway":"网关","network.UnauthorizedPacketView.thead.frequency":"频率","network.UnauthorizedPacketView.thead.toa_total":"TOA总数(s)","network.UnauthorizedPacketView.thead.total":"总包数","network.roadtest.title":"路测仪测试工具","network.roadtest.header.colorset":"信号设置","network.roadtest.header.radius":"覆盖范围","network.roadtest.selectdevice":"选择设备","network.roadtest.selectgateway":"选择网关","network.roadtest.selectgateway.search.placeholder":"搜索网关","network.roadtest.radius.invalid":"非法半径","network.roadtest.radius.name":"半径","network.roadtest.radius.confirm":"确认","network.roadtest.radius.cancel":"取消","network.roadtest.download":"导出数据","network.tdm.net.label":"选择TDM网络","network.tdm.net.update":"下发","network.tdm.net.upload":"上传配置","network.tdm.node.title":"TDM节点","network.tdm.node.add":"节点","network.tdm.node.batch":"批量导入","network.tdm.node.batch.delete":"批量删除","network.tdm.node.batch.reset":"批量重启","network.tdm.node.reset":"重启","network.tdm.node.name":"名称","network.tdm.node.nodata":"暂无数据","network.tdm.node.nodetype":"节点类型","network.tdm.node.gateway.bind":"网关绑定","network.tdm.node.gateway.name":"网关名称","network.tdm.node.nodetype.all":"全部","network.tdm.node.remark":"备注","network.tdm.node.remark.placeholder":"按备注搜索","network.tdm.node.search.placeholder":"搜索","network.tdm.node.delete":"删除","network.tdm.node.sf.default":"无","network.tdm.node.bind.default":"自动","network.tdm.node.create.header":"添加节点","network.tdm.node.create.apps":"应用","network.tdm.node.create.name":"名称","network.tdm.node.create.cancel":"取消","network.tdm.node.create.confirm":"添加","network.tdm.node.create.nodetype":"节点类型","network.tdm.node.create.gateway.bind":"网关绑定","network.tdm.node.create.search.placeholder":"设备名称，DevEUI","network.tdm.node.create.remark":"备注","network.tdm.node.create.remark.placeholder":"输入备注","network.tdm.node.create.FE_NO_CHECKED_NODES":"节点需配置节点类型","network.tdm.node.create.sf.default":"无","network.tdm.node.create.bind.default":"自动","network.tdm.node.delete.title":"删除节点","network.tdm.node.delete.confirm":"删除","network.tdm.node.delete.cancel":"取消","network.tdm.node.delete.warn":"确定删除所选节点?","network.tdm.node.reset.title":"批量重启","network.tdm.node.reset.confirm":"重启","network.tdm.node.reset.cancel":"取消","network.tdm.node.reset.warn":"确定重启所选节点","network.tdm.node.reset.single.title":"重启","network.tdm.node.reset.single.warn":"确定重启该节点","network.tdm.gateway.title":"TDM网关","network.tdm.gateway.add":"网关","network.tdm.gateway.gateway1":"网关1","network.tdm.gateway.gateway2":"网关2","network.tdm.gateway.model":"网关型号","network.tdm.gateway.type":"网关类型","network.tdm.gateway.penalty":"SNR惩罚系数","network.tdm.gateway.reset":"重启","network.tdm.gateway.delete":"删除","network.tdm.gateway.nodata":"暂无数据","network.tdm.gateway.mac1":"MAC ID","network.tdm.gateway.mac2":"MAC ID2","network.tdm.gateway.remark":"备注","network.tdm.gateway.8channels":"8通道","network.tdm.gateway.16channels":"16通道","network.tdm.gateway.create.header":"添加TDM网关","network.tdm.gateway.create.8channels":"8通道","network.tdm.gateway.create.16channels":"16通道","network.tdm.gateway.create.type":"网关类型","network.tdm.gateway.create.id":"网关1","network.tdm.gateway.create.mac2":"网关2","network.tdm.gateway.create.penalty":"SNR惩罚系数(db)","network.tdm.gateway.create.remark":"备注","network.tdm.gateway.create.confirm":"添加","network.tdm.gateway.create.cancel":"取消","network.tdm.gateway.create.E.FE_EMPTY":"必填","network.tdm.gateway.create.E.FE_GW_MUST_DIFFEFRENT":"网关1与网关2相同","network.tdm.gateway.create.E.GENERALERROR":"网关必须配置信道计划","network.tdm.gateway.reset.title":"重启","network.tdm.gateway.reset.content":"确定重启该网关","network.tdm.gateway.reset.confirm":"确定","network.tdm.gateway.reset.cancel":"取消","network.tdm.pairs.title":"Pairs配置","network.tdm.pairs.add":"Pairs","network.tdm.pairs.name1":"功图名称","network.tdm.pairs.id1":"功图","network.tdm.pairs.name2":"电参名称","network.tdm.pairs.id2":"电参","network.tdm.pairs.batch":"批量导入","network.tdm.pairs.nodata":"暂无数据","network.tdm.pairs.remark":"备注","network.tdm.pairs.remove":"删除","network.tdm.pairs.batch.delete":"批量删除","network.tdm.pairs.search.placeholder":"搜索","network.tdm.pairs.create.header":"添加Pairs","network.tdm.pairs.create.title.work":"功图","network.tdm.pairs.create.title.params":"电参","network.tdm.pairs.create.cancel":"取消","network.tdm.pairs.create.confirm":"添加","network.tdm.pairs.create.name":"名称","network.tdm.pairs.create.remark":"备注","network.tdm.pairs.create.remove":"移除","network.tdm.pairs.create.empty":"未选取","network.tdm.pairs.create.help":"一次最多添加10对pairs","network.tdm.pairs.delete.title":"删除Pairs","network.tdm.pairs.delete.warn":"确定删除所选Pairs?","network.tdm.pairs.delete.confirm":"删除","network.tdm.pairs.delete.cancel":"取消","network.tdm.upload.header":"上传配置文件","network.tdm.upload.cancel":"取消","network.tdm.upload.confirm":"确认","network.tdm.upload.success":"上传成功","network.tdm.upload.failure":"上传失败","network.tdm.upload.btn":"选择文件","network.tdm.upload.FE_JSON_ONLY":"仅支持.json文件","network.tdm.upload.FILE_READER_ERROR":"读取文件发生错误","network.tdm.upload.REQUIRED_NODETYPES":"缺少nodetypes定义","network.tdm.upload.REQUIRED_NETWORK":"缺少networktypes定义","network.tdm.upload.UNSUPPORT_FILE_READER":"该浏览器不支持读取文件，请更换浏览器","network.tdm.detailview.toolbar.firstnav":"TDM","network.tdm.gateway.status.basic.header":"网关状态","network.tdm.gateway.status.counters.header":"网关统计","network.tdm.gateway.status.now":"当前参考时间","network.tdm.gateway.status.ver":"运行版本","network.tdm.gateway.status.since":"Since","network.tdm.gateway.status.lastsync":"上次同步时间","network.tdm.gateway.status.attfail":"Att Fail","network.tdm.gateway.status.attok":"Att Ok","network.tdm.gateway.status.overrun":"Over Run","network.tdm.gateway.status.statis.header":"数据统计","network.tdm.gateway.status.node.all":"总数","network.tdm.gateway.status.node.work.map":"功图","network.tdm.gateway.status.node.press":"压力","network.tdm.gateway.status.node.electri.param":"电参","network.tdm.gateway.status.node.temp":"温度","network.tdm.gateway.channel.header":"信道","network.tdm.gateway.channel.id":"信道ID","network.tdm.gateway.channel.service":"业务ID","network.tdm.gateway.channel.used":"已分配时隙","network.tdm.gateway.channel.free":"未分配时隙","network.tdm.gateway.channel.pie.header":"时隙统计","network.tdm.gateway.channel.pie.free":"未分配","network.tdm.gateway.channel.pie.used":"已分配","network.tdm.gateway.channel.pie.service":"服务","network.tdm.node.status.basic.header":"节点状态","network.tdm.node.status.id":"节点ID","network.tdm.node.status.ver":"版本","network.tdm.node.status.roaming":"漫游网关","network.tdm.node.status.accuracy":"Clock Accuracy","network.tdm.node.status.lastatt":"上次注册","network.tdm.node.status.lastup":"上次上行","network.tdm.node.status.lastdn":"上次下行","network.tdm.node.status.nextup":"预计下次上行","network.tdm.node.status.counter.header":"节点统计","network.tdm.node.status.ackddown":"下行确认","network.tdm.node.status.initdown":"初始下行","network.tdm.node.status.retrydown":"重传下行","network.tdm.node.status.tdmup":"TDM上行","network.tdm.node.status.alohaup":"Aloha上行","network.tdm.node.status.okassemble":"成功上行","network.tdm.node.channel.header":"信道","network.tdm.node.channel.channel":"信道ID","network.tdm.node.channel.service":"服务ID","network.tdm.node.channel.frame":"Frame","network.tdm.node.channel.offset":"分配位置","network.tdm.node.channel.logs":"分配历史","network.tdm.node.channel.startat":"开始时间","network.tdm.node.channel.endat":"结束时间","network.tdm.node.channel.alohapercent":"Aloha占比","network.tdm.node.pie.header":"上行统计","network.tdm.batch.node.title":"导入节点","network.tdm.batch.pairs.title":"导入Pairs","network.tdm.batch.dropzone.text":"点击选择或拖放文件至此导入文件","network.tdm.batch.help.panelheader":"导入文件示例","network.tdm.batch.preview.cancel.btn":"取消","network.tdm.batch.preview.import.btn.seg1":"导入","network.tdm.batch.preview.import.btn.seg2":"个节点","network.tdm.batch.err.modalheader":"导入错误","network.tdm.batch.result.succ":"导入成功","network.tdm.batch.result.notimport":"未导入","network.tdm.batch.result.summary.seg1":"导入成功","network.tdm.batch.result.summary.seg2":"导入失败","network.tdm.batch.result.summary.back":"返回","network.tdm.batch.result.thead.status":"导入状态","network.tdm.batch.result.summary.reimport":"继续导入","network.tdm.batch.E.GENERALERROR":"设备已导入","network.tdm.batch.result.fail":"导入失败","network.tdm.batch.E.NOTFOUND":"DevEUI不存在","network.tdm.batch.E.GTW.NOTFOUND":"Gateway不存在","network.tdmstatis.title":"TDM网络质量统计","network.tdmstatis.offset":"偏移量","network.tdmstatis.gateway":"信道","network.tdmstatis.service":"服务","network.tdmstatis.normal":"功图常规","network.tdmstatis.gongtu":"功图","network.tdmstatis.diancan":"电参常规","network.tdmstatis.dianliutu":"电流图","network.tdmstatis.temperature":"温度","network.tdmstatis.pressure":"压力","network.tdmstatis.gtwtitle":"网关名称","network.tdmstatis.sum":"总和","network.tdmstatis.num":"总数","network.tdmstatis.average":"平均数","network.nopoint":"暂无选中的点","network.selectedpoint":"当前节点：","overview.application":"应用","overview.device":"设备","overview.gateway":"网关","overview.greeting":"欢迎使用艾森智能LoRaWAN物联网云平台","overview.search.placeholder":"搜索网关、应用、设备","overview.search.seemore":"查看更多","overview.search.gateways":"网关","overview.search.apps":"应用","overview.search.devices":"设备","overview.billing.balance":"当前余额:","overview.billing.yuan":"元","overview.billing.recharge":"充值","overview.billing.tier.free":"你当前为免费用户","overview.billing.tier.remaining":"剩余服务时间为","overview.billing.tier.day":"天","overview.billing.tier.svcpkg":"你当前为服务套餐用户","overview.billing.tier.comm":"你当前为企业用户","overview.billing.tier.comm.billday":"你的账单日为每月","overview.billing.tier.comm.arrear.willstop.prefix":"系统将在","overview.billing.tier.comm.arrear.willstop.postfix":"天后停止您的服务，请及时充值。","overview.billing.promote.upgrade":"升级","overview.billing.cube.welcome":"欢迎使用LoRaCube!","overview.devicemap":"设备地图","overview.gatewaymap":"网关地图","profile.coms.richform.actionbutton.title":"密码修改成功","profile.coms.richform.error.null":"不能为空","profile.coms.richform.oldpasswordfailed":"旧密码有误","profile.coms.richform.panelright.title":"修改密码","profile.coms.richform.submitFailed":"密码修改失败","register.agree":"请确认阅读并同意","register.captcha":"验证码","register.captcha.loadfailed":"验证码加载失败","register.company":"公司","register.company.placeholder":"请输入公司名称","register.E.BADVERIFY":"验证码错误","register.E.EMAILREGISTERED":"邮箱已被注册","register.E.UNKNOWN":"网络错误","register.E.GENERALERROR":"服务器错误","register.E.FE_EMAILOCCUPIED":"邮箱已被注册","register.E.FE_EMPTY":"不能为空","register.E.FE_INVALIDEMAIL":"Email地址格式不正确","register.E.FE_NETWORKFAIL":"网络错误","register.E.FE_PASSWORDEMPTY":"请输入密码","register.E.FE_PASSWORDINVALIDLEN":"请输入6～16位密码","register.email":"邮箱","register.email.placeholder":"请输入邮箱名称","register.name":"姓名","register.name.placeholder":"请输入姓名","register.password":"密码","register.password.placeholder":"请输入密码","register.policy":"隐私政策，服务条款","register.result.accepted.gotoemail":"立即进入邮箱","register.result.accepted.laststep":"最后一步，查看激活邮件完成注册","register.result.accepted.mailsent.p1":"我们已经向您的邮箱","register.result.accepted.mailsent.p2":"发送了一封激活邮件，请点击邮件中的链接完成注册！","register.result.accepted.notreceive":"没有收到激活邮件？","register.result.accepted.notreceive.tips1":"看看是否在邮箱的回收站、垃圾邮件中","register.result.accepted.notreceive.tips2.click":"点击","register.result.accepted.notreceive.tips2.p1":"更换注册邮箱","register.result.apply.desc":"感谢注册，我们会尽快审核您的资料。审核通过后，我们会第一时间通过注册邮箱通知您。","register.result.apply.title":"我们会尽快审核您的注册","register.submit":"注册","register.submit.failure":"提交失败","register.submit.pending":"提交中","register.tele":"电话","register.tele.placeholder":"请输入电话","register.title":"注册loraFlow","register.vcode":"验证码","register.verifycode.wrong":"验证码错误","resetpassword.actionbutton.label":"提交","resetpassword.actionbutton.successlabel":"提交成功","resetpassword.button.submitFailed":"提交失败","resetpassword.emailvalidate.errempty":"邮箱不能为空","resetpassword.emailvalidate.errfomat":"邮箱格式错误","resetpassword.errtips.email":"请输入邮箱","resetpassword.errtips.emailandvercode":"请输入邮箱和验证码","resetpassword.errtips.vercode":"请输入验证码","resetpassword.feedbacktips.email":"邮箱未注册","resetpassword.feedbacktips.emailinactive":"账户未激活","resetpassword.feedbacktips.vercode":"验证码不正确","resetpassword.headtitle":"loraFlow重置密码","resetpassword.identifyingcode.errempty":"验证码不能为空","resetpassword.label.mailbox":"邮箱","resetpassword.label.vercode":"验证码","resetpassword.new.button.label":"提交","resetpassword.new.button.successlabel":"密码重置成功","resetpassword.new.label.newpassword":"新密码","resetpassword.new.label.repeatpwd":"重复密码","resetpassword.new.password.error.Inconsistent":"与新密码不一致","resetpassword.new.password.error.null":"不能为空","resetpassword.new.password.error.validerr":"格式错误","resetpassword.new.placeholder.newpassword":"输入6-16位新密码","resetpassword.new.placeholder.repeatpwd":"重复输入","resetpassword.new.resetfailed":"重置失败","resetpassword.new.title.resetpwd":"重置密码","resetpassword.placeholder.mailbox":"输入您的注册邮箱","resetpassword.placeholder.vercode":"输入右侧的验证码","resetpassword.success.btn":"立即进入邮箱","resetpassword.success.footer.h3":"没有收到邮件？","resetpassword.success.footer.li1":"看看是否在邮箱的回收站、垃圾邮件中","resetpassword.success.footer.li2.txt1":"点击","resetpassword.success.footer.li2.txt2":"更换重置邮箱","resetpassword.success.h1":"最后一步，查看邮件完成密码的重置","resetpassword.success.p1":"我们已经向您的邮箱","resetpassword.success.p2":"发送了一封重置密码的邮件，请点击邮件中的链接重置密码！"}

/***/ }),
/* 2395 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 2396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(2399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(2400);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 2397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(74)))

/***/ }),
/* 2398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(2401);


/** Built-in value references. */
var getPrototype = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 2399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(851);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 2400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 2401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 2402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(2397);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 2403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 2404 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74)))

/***/ }),
/* 2405 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(233),
    root = __webpack_require__(149);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 2406 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(2458),
    hashDelete = __webpack_require__(2459),
    hashGet = __webpack_require__(2460),
    hashHas = __webpack_require__(2461),
    hashSet = __webpack_require__(2462);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 2407 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(233),
    root = __webpack_require__(149);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 2408 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(233),
    root = __webpack_require__(149);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 2409 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 2410 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 2411 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

module.exports = arrayEvery;


/***/ }),
/* 2412 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(394);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 2413 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 2414 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 2415 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),
/* 2416 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(118);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 2417 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(314);

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

module.exports = baseEvery;


/***/ }),
/* 2418 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(314);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 2419 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(856),
    isFlattenable = __webpack_require__(2464);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 2420 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(856),
    isArray = __webpack_require__(80);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 2421 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 2422 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 2423 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(169),
    isObjectLike = __webpack_require__(151);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 2424 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(547),
    equalArrays = __webpack_require__(874),
    equalByTag = __webpack_require__(2451),
    equalObjects = __webpack_require__(2452),
    getTag = __webpack_require__(877),
    isArray = __webpack_require__(80),
    isBuffer = __webpack_require__(401),
    isTypedArray = __webpack_require__(404);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 2425 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(547),
    baseIsEqual = __webpack_require__(549);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 2426 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 2427 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(170),
    isMasked = __webpack_require__(2466),
    isObject = __webpack_require__(118),
    toSource = __webpack_require__(885);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 2428 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(169),
    isObjectLike = __webpack_require__(151);

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}

module.exports = baseIsRegExp;


/***/ }),
/* 2429 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(169),
    isLength = __webpack_require__(557),
    isObjectLike = __webpack_require__(151);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 2430 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(118),
    isPrototype = __webpack_require__(315),
    nativeKeysIn = __webpack_require__(2480);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 2431 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(314),
    isArrayLike = __webpack_require__(150);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 2432 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(2425),
    getMatchData = __webpack_require__(2454),
    matchesStrictComparable = __webpack_require__(881);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 2433 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(549),
    get = __webpack_require__(2501),
    hasIn = __webpack_require__(2502),
    isKey = __webpack_require__(554),
    isStrictComparable = __webpack_require__(880),
    matchesStrictComparable = __webpack_require__(881),
    toKey = __webpack_require__(400);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 2434 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(547),
    assignMergeValue = __webpack_require__(858),
    baseFor = __webpack_require__(861),
    baseMergeDeep = __webpack_require__(2435),
    isObject = __webpack_require__(118),
    keysIn = __webpack_require__(560),
    safeGet = __webpack_require__(884);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 2435 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(858),
    cloneBuffer = __webpack_require__(2443),
    cloneTypedArray = __webpack_require__(2444),
    copyArray = __webpack_require__(2445),
    initCloneObject = __webpack_require__(2463),
    isArguments = __webpack_require__(318),
    isArray = __webpack_require__(80),
    isArrayLikeObject = __webpack_require__(556),
    isBuffer = __webpack_require__(401),
    isFunction = __webpack_require__(170),
    isObject = __webpack_require__(118),
    isPlainObject = __webpack_require__(558),
    isTypedArray = __webpack_require__(404),
    safeGet = __webpack_require__(884),
    toPlainObject = __webpack_require__(2517);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 2436 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(862);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 2437 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(2496),
    defineProperty = __webpack_require__(873),
    identity = __webpack_require__(234);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 2438 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 2439 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(314);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),
/* 2440 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(853),
    arrayIncludes = __webpack_require__(2412),
    arrayIncludesWith = __webpack_require__(2413),
    cacheHas = __webpack_require__(867),
    createSet = __webpack_require__(2450),
    setToArray = __webpack_require__(555);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 2441 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(391);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 2442 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(854);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 2443 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(149);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(328)(module)))

/***/ }),
/* 2444 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(2442);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 2445 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 2446 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(149);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 2447 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(150);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 2448 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 2449 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(196),
    isArrayLike = __webpack_require__(150),
    keys = __webpack_require__(268);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 2450 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(852),
    noop = __webpack_require__(2508),
    setToArray = __webpack_require__(555);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 2451 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(312),
    Uint8Array = __webpack_require__(854),
    eq = __webpack_require__(316),
    equalArrays = __webpack_require__(874),
    mapToArray = __webpack_require__(2477),
    setToArray = __webpack_require__(555);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 2452 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(2453);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 2453 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(2420),
    getSymbols = __webpack_require__(2456),
    keys = __webpack_require__(268);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 2454 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(880),
    keys = __webpack_require__(268);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 2455 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(312);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 2456 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(548),
    stubArray = __webpack_require__(2514);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 2457 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 2458 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(398);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 2459 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 2460 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(398);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 2461 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(398);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 2462 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(398);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 2463 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(2416),
    getPrototype = __webpack_require__(876),
    isPrototype = __webpack_require__(315);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 2464 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(312),
    isArguments = __webpack_require__(318),
    isArray = __webpack_require__(80);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 2465 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 2466 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(2446);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 2467 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 2468 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(392);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 2469 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(392);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 2470 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(392);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 2471 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(392);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 2472 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(2406),
    ListCache = __webpack_require__(390),
    Map = __webpack_require__(545);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 2473 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(396);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 2474 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(396);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 2475 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(396);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 2476 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(396);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 2477 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 2478 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(2507);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 2479 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(883);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 2480 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 2481 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 2482 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(2409);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 2483 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 2484 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 2485 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(2437),
    shortOut = __webpack_require__(2486);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 2486 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 2487 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(390);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 2488 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 2489 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 2490 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 2491 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(390),
    Map = __webpack_require__(545),
    MapCache = __webpack_require__(546);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 2492 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 2493 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(2478);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 2494 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 2495 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(551),
    createAssigner = __webpack_require__(552),
    keysIn = __webpack_require__(560);

/**
 * This method is like `_.assign` except that it iterates over own and
 * inherited source properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assign
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
 */
var assignIn = createAssigner(function(object, source) {
  copyObject(source, keysIn(source), object);
});

module.exports = assignIn;


/***/ }),
/* 2496 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 2497 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2495);


/***/ }),
/* 2498 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(2449),
    findIndex = __webpack_require__(2499);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 2499 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(860),
    baseIteratee = __webpack_require__(196),
    toInteger = __webpack_require__(406);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 2500 */
/***/ (function(module, exports) {

/**
 * The inverse of `_.toPairs`; this method returns an object composed
 * from key-value `pairs`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} pairs The key-value pairs.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.fromPairs([['a', 1], ['b', 2]]);
 * // => { 'a': 1, 'b': 2 }
 */
function fromPairs(pairs) {
  var index = -1,
      length = pairs == null ? 0 : pairs.length,
      result = {};

  while (++index < length) {
    var pair = pairs[index];
    result[pair[0]] = pair[1];
  }
  return result;
}

module.exports = fromPairs;


/***/ }),
/* 2501 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(862);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 2502 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(2422),
    hasPath = __webpack_require__(878);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 2503 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(169),
    isObjectLike = __webpack_require__(151);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

module.exports = isBoolean;


/***/ }),
/* 2504 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsRegExp = __webpack_require__(2428),
    baseUnary = __webpack_require__(866),
    nodeUtil = __webpack_require__(882);

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

module.exports = isRegExp;


/***/ }),
/* 2505 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(313),
    baseForOwn = __webpack_require__(393),
    baseIteratee = __webpack_require__(196);

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

module.exports = mapKeys;


/***/ }),
/* 2506 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(313),
    baseForOwn = __webpack_require__(393),
    baseIteratee = __webpack_require__(196);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),
/* 2507 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(546);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 2508 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 2509 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(864),
    basePropertyDeep = __webpack_require__(2436),
    isKey = __webpack_require__(554),
    toKey = __webpack_require__(400);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 2510 */
/***/ (function(module, exports, __webpack_require__) {

var createRound = __webpack_require__(872);

/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */
var round = createRound('round');

module.exports = round;


/***/ }),
/* 2511 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(857),
    baseIteratee = __webpack_require__(196),
    baseSome = __webpack_require__(2439),
    isArray = __webpack_require__(80),
    isIterateeCall = __webpack_require__(397);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),
/* 2512 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(266),
    castSlice = __webpack_require__(395),
    hasUnicode = __webpack_require__(879),
    isIterateeCall = __webpack_require__(397),
    isRegExp = __webpack_require__(2504),
    stringToArray = __webpack_require__(399),
    toString = __webpack_require__(197);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Splits `string` by `separator`.
 *
 * **Note:** This method is based on
 * [`String#split`](https://mdn.io/String/split).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} separator The separator pattern to split by.
 * @param {number} [limit] The length to truncate results to.
 * @returns {Array} Returns the string segments.
 * @example
 *
 * _.split('a-b-c', '-', 2);
 * // => ['a', 'b']
 */
function split(string, separator, limit) {
  if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
    separator = limit = undefined;
  }
  limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
  if (!limit) {
    return [];
  }
  string = toString(string);
  if (string && (
        typeof separator == 'string' ||
        (separator != null && !isRegExp(separator))
      )) {
    separator = baseToString(separator);
    if (!separator && hasUnicode(string)) {
      return castSlice(stringToArray(string), 0, limit);
    }
  }
  return string.split(separator, limit);
}

module.exports = split;


/***/ }),
/* 2513 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(2415),
    baseToString = __webpack_require__(266),
    toInteger = __webpack_require__(406),
    toString = __webpack_require__(197);

/**
 * Checks if `string` starts with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=0] The position to search from.
 * @returns {boolean} Returns `true` if `string` starts with `target`,
 *  else `false`.
 * @example
 *
 * _.startsWith('abc', 'a');
 * // => true
 *
 * _.startsWith('abc', 'b');
 * // => false
 *
 * _.startsWith('abc', 'b', 1);
 * // => true
 */
function startsWith(string, target, position) {
  string = toString(string);
  position = position == null
    ? 0
    : baseClamp(toInteger(position), 0, string.length);

  target = baseToString(target);
  return string.slice(position, position + target.length) == target;
}

module.exports = startsWith;


/***/ }),
/* 2514 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 2515 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 2516 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(894);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 2517 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(551),
    keysIn = __webpack_require__(560);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 2518 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(266),
    castSlice = __webpack_require__(395),
    charsEndIndex = __webpack_require__(870),
    charsStartIndex = __webpack_require__(871),
    stringToArray = __webpack_require__(399),
    toString = __webpack_require__(197);

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrim, '');
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      chrSymbols = stringToArray(chars),
      start = charsStartIndex(strSymbols, chrSymbols),
      end = charsEndIndex(strSymbols, chrSymbols) + 1;

  return castSlice(strSymbols, start, end).join('');
}

module.exports = trim;


/***/ }),
/* 2519 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(2419),
    baseRest = __webpack_require__(550),
    baseUniq = __webpack_require__(2440),
    isArrayLikeObject = __webpack_require__(556);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),
/* 2520 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(548),
    arrayMap = __webpack_require__(391),
    baseProperty = __webpack_require__(864),
    baseTimes = __webpack_require__(865),
    isArrayLikeObject = __webpack_require__(556);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.zip` except that it accepts an array of grouped
 * elements and creates an array regrouping the elements to their pre-zip
 * configuration.
 *
 * @static
 * @memberOf _
 * @since 1.2.0
 * @category Array
 * @param {Array} array The array of grouped elements to process.
 * @returns {Array} Returns the new array of regrouped elements.
 * @example
 *
 * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
 * // => [['a', 1, true], ['b', 2, false]]
 *
 * _.unzip(zipped);
 * // => [['a', 'b'], [1, 2], [true, false]]
 */
function unzip(array) {
  if (!(array && array.length)) {
    return [];
  }
  var length = 0;
  array = arrayFilter(array, function(group) {
    if (isArrayLikeObject(group)) {
      length = nativeMax(group.length, length);
      return true;
    }
  });
  return baseTimes(length, function(index) {
    return arrayMap(array, baseProperty(index));
  });
}

module.exports = unzip;


/***/ }),
/* 2521 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(2441),
    keys = __webpack_require__(268);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 2522 */,
/* 2523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

/**
 * Make a shallow copy of the object maintaining the prototype.
 */

exports.default = function (source) {
    var target = void 0;

    if (source.constructor === Array) {
        target = source.map(function (element) {
            return element;
        });
    } else {
        target = {};
        for (var property in source) {
            if (source.hasOwnProperty(property)) {
                target[property] = source[property];
            }
        }
    }

    _defaults(target, Object.getPrototypeOf(source));

    return target;
};

module.exports = exports['default'];
//# sourceMappingURL=objectUnfreeze.js.map


/***/ }),
/* 2524 */,
/* 2525 */,
/* 2526 */,
/* 2527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(2744);
var objectAssign = __webpack_require__(36);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 2528 */,
/* 2529 */,
/* 2530 */,
/* 2531 */,
/* 2532 */,
/* 2533 */,
/* 2534 */,
/* 2535 */,
/* 2536 */,
/* 2537 */,
/* 2538 */,
/* 2539 */,
/* 2540 */,
/* 2541 */,
/* 2542 */,
/* 2543 */,
/* 2544 */,
/* 2545 */,
/* 2546 */,
/* 2547 */,
/* 2548 */,
/* 2549 */,
/* 2550 */,
/* 2551 */,
/* 2552 */,
/* 2553 */,
/* 2554 */,
/* 2555 */,
/* 2556 */,
/* 2557 */,
/* 2558 */,
/* 2559 */,
/* 2560 */,
/* 2561 */,
/* 2562 */,
/* 2563 */,
/* 2564 */,
/* 2565 */,
/* 2566 */,
/* 2567 */,
/* 2568 */,
/* 2569 */,
/* 2570 */,
/* 2571 */,
/* 2572 */,
/* 2573 */,
/* 2574 */,
/* 2575 */,
/* 2576 */,
/* 2577 */,
/* 2578 */,
/* 2579 */,
/* 2580 */,
/* 2581 */,
/* 2582 */,
/* 2583 */,
/* 2584 */,
/* 2585 */,
/* 2586 */,
/* 2587 */,
/* 2588 */,
/* 2589 */,
/* 2590 */,
/* 2591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var Size = exports.Size = {
  LARGE: 'large',
  SMALL: 'small',
  XSMALL: 'xsmall'
};

var SIZE_MAP = exports.SIZE_MAP = {
  large: 'lg',
  medium: 'md',
  small: 'sm',
  xsmall: 'xs',
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xs: 'xs'
};

var DEVICE_SIZES = exports.DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];

var State = exports.State = {
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info'
};

var Style = exports.Style = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  LINK: 'link',
  INVERSE: 'inverse'
};

/***/ }),
/* 2592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid components".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @return {object} Object containing the ordered map of results.
 */
function map(children, func, context) {
  var index = 0;

  return _react2['default'].Children.map(children, function (child) {
    if (!_react2['default'].isValidElement(child)) {
      return child;
    }

    return func.call(context, child, index++);
  });
}

/**
 * Iterates through children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for context.
 */
// TODO: This module should be ElementChildren, and should use named exports.

function forEach(children, func, context) {
  var index = 0;

  _react2['default'].Children.forEach(children, function (child) {
    if (!_react2['default'].isValidElement(child)) {
      return;
    }

    func.call(context, child, index++);
  });
}

/**
 * Count the number of "valid components" in the Children container.
 *
 * @param {?*} children Children tree container.
 * @returns {number}
 */
function count(children) {
  var result = 0;

  _react2['default'].Children.forEach(children, function (child) {
    if (!_react2['default'].isValidElement(child)) {
      return;
    }

    ++result;
  });

  return result;
}

/**
 * Finds children that are typically specified as `props.children`,
 * but only iterates over children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @returns {array} of children that meet the func return statement
 */
function filter(children, func, context) {
  var index = 0;
  var result = [];

  _react2['default'].Children.forEach(children, function (child) {
    if (!_react2['default'].isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result.push(child);
    }
  });

  return result;
}

function find(children, func, context) {
  var index = 0;
  var result = undefined;

  _react2['default'].Children.forEach(children, function (child) {
    if (result) {
      return;
    }
    if (!_react2['default'].isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = child;
    }
  });

  return result;
}

function every(children, func, context) {
  var index = 0;
  var result = true;

  _react2['default'].Children.forEach(children, function (child) {
    if (!result) {
      return;
    }
    if (!_react2['default'].isValidElement(child)) {
      return;
    }

    if (!func.call(context, child, index++)) {
      result = false;
    }
  });

  return result;
}

function some(children, func, context) {
  var index = 0;
  var result = false;

  _react2['default'].Children.forEach(children, function (child) {
    if (result) {
      return;
    }
    if (!_react2['default'].isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = true;
    }
  });

  return result;
}

function toArray(children) {
  var result = [];

  _react2['default'].Children.forEach(children, function (child) {
    if (!_react2['default'].isValidElement(child)) {
      return;
    }

    result.push(child);
  });

  return result;
}

exports['default'] = {
  map: map,
  forEach: forEach,
  count: count,
  find: find,
  filter: filter,
  every: every,
  some: some,
  toArray: toArray
};
module.exports = exports['default'];

/***/ }),
/* 2593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = undefined;

var _entries = __webpack_require__(440);

var _entries2 = _interopRequireDefault(_entries);

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

exports.prefix = prefix;
exports.getClassSet = getClassSet;
exports.splitBsProps = splitBsProps;
exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
exports.addStyle = addStyle;

var _invariant = __webpack_require__(57);

var _invariant2 = _interopRequireDefault(_invariant);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StyleConfig = __webpack_require__(2591);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function curry(fn) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var last = args[args.length - 1];
    if (typeof last === 'function') {
      return fn.apply(undefined, args);
    }
    return function (Component) {
      return fn.apply(undefined, args.concat([Component]));
    };
  };
} // TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.

function prefix(props, variant) {
  !(props.bsClass != null) ?  false ? (0, _invariant2['default'])(false, 'A `bsClass` prop is required for this component') : (0, _invariant2['default'])(false) : void 0;
  return props.bsClass + (variant ? '-' + variant : '');
}

var bsClass = exports.bsClass = curry(function (defaultClass, Component) {
  var propTypes = Component.propTypes || (Component.propTypes = {});
  var defaultProps = Component.defaultProps || (Component.defaultProps = {});

  propTypes.bsClass = _propTypes2['default'].string;
  defaultProps.bsClass = defaultClass;

  return Component;
});

var bsStyles = exports.bsStyles = curry(function (styles, defaultStyle, Component) {
  if (typeof defaultStyle !== 'string') {
    Component = defaultStyle;
    defaultStyle = undefined;
  }

  var existing = Component.STYLES || [];
  var propTypes = Component.propTypes || {};

  styles.forEach(function (style) {
    if (existing.indexOf(style) === -1) {
      existing.push(style);
    }
  });

  var propType = _propTypes2['default'].oneOf(existing);

  // expose the values on the propType function for documentation
  Component.STYLES = propType._values = existing;

  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
    bsStyle: propType
  });

  if (defaultStyle !== undefined) {
    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
    defaultProps.bsStyle = defaultStyle;
  }

  return Component;
});

var bsSizes = exports.bsSizes = curry(function (sizes, defaultSize, Component) {
  if (typeof defaultSize !== 'string') {
    Component = defaultSize;
    defaultSize = undefined;
  }

  var existing = Component.SIZES || [];
  var propTypes = Component.propTypes || {};

  sizes.forEach(function (size) {
    if (existing.indexOf(size) === -1) {
      existing.push(size);
    }
  });

  var values = [];
  existing.forEach(function (size) {
    var mappedSize = _StyleConfig.SIZE_MAP[size];
    if (mappedSize && mappedSize !== size) {
      values.push(mappedSize);
    }

    values.push(size);
  });

  var propType = _propTypes2['default'].oneOf(values);
  propType._values = values;

  // expose the values on the propType function for documentation
  Component.SIZES = existing;

  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
    bsSize: propType
  });

  if (defaultSize !== undefined) {
    if (!Component.defaultProps) {
      Component.defaultProps = {};
    }
    Component.defaultProps.bsSize = defaultSize;
  }

  return Component;
});

function getClassSet(props) {
  var _classes;

  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);

  if (props.bsSize) {
    var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
    classes[prefix(props, bsSize)] = true;
  }

  if (props.bsStyle) {
    classes[prefix(props, props.bsStyle)] = true;
  }

  return classes;
}

function getBsProps(props) {
  return {
    bsClass: props.bsClass,
    bsSize: props.bsSize,
    bsStyle: props.bsStyle,
    bsRole: props.bsRole
  };
}

function isBsProp(propName) {
  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
}

function splitBsProps(props) {
  var elementProps = {};
  (0, _entries2['default'])(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (!isBsProp(propName)) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}

function splitBsPropsAndOmit(props, omittedPropNames) {
  var isOmittedProp = {};
  omittedPropNames.forEach(function (propName) {
    isOmittedProp[propName] = true;
  });

  var elementProps = {};
  (0, _entries2['default'])(props).forEach(function (_ref2) {
    var propName = _ref2[0],
        propValue = _ref2[1];

    if (!isBsProp(propName) && !isOmittedProp[propName]) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}

/**
 * Add a style variant to a Component. Mutates the propTypes of the component
 * in order to validate the new variant.
 */
function addStyle(Component) {
  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    styleVariant[_key2 - 1] = arguments[_key2];
  }

  bsStyles(styleVariant, Component);
}

var _curry = exports._curry = curry;

/***/ }),
/* 2594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) {
      return f;
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      f.apply(this, args);
    };
  }, null);
}

exports['default'] = createChainedFunction;
module.exports = exports['default'];

/***/ }),
/* 2595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(64);
var findDOMNode = ReactDOM.findDOMNode;
var className = __webpack_require__(19);
var debounce = __webpack_require__(2404);

function normalizeLineEndings(str) {
	if (!str) return str;
	return str.replace(/\r\n|\r/g, '\n');
}

var CodeMirror = React.createClass({
	displayName: 'CodeMirror',

	propTypes: {
		className: React.PropTypes.any,
		codeMirrorInstance: React.PropTypes.func,
		defaultValue: React.PropTypes.string,
		onChange: React.PropTypes.func,
		onFocusChange: React.PropTypes.func,
		onScroll: React.PropTypes.func,
		options: React.PropTypes.object,
		path: React.PropTypes.string,
		value: React.PropTypes.string,
		preserveScrollPosition: React.PropTypes.bool
	},
	getDefaultProps: function getDefaultProps() {
		return {
			preserveScrollPosition: false
		};
	},
	getCodeMirrorInstance: function getCodeMirrorInstance() {
		return this.props.codeMirrorInstance || __webpack_require__(646);
	},
	getInitialState: function getInitialState() {
		return {
			isFocused: false
		};
	},
	componentWillMount: function componentWillMount() {
		this.componentWillReceiveProps = debounce(this.componentWillReceiveProps, 0);
	},
	componentDidMount: function componentDidMount() {
		var textareaNode = findDOMNode(this.refs.textarea);
		var codeMirrorInstance = this.getCodeMirrorInstance();
		this.codeMirror = codeMirrorInstance.fromTextArea(textareaNode, this.props.options);
		this.codeMirror.on('change', this.codemirrorValueChanged);
		this.codeMirror.on('focus', this.focusChanged.bind(this, true));
		this.codeMirror.on('blur', this.focusChanged.bind(this, false));
		this.codeMirror.on('scroll', this.scrollChanged);
		this.codeMirror.setValue(this.props.defaultValue || this.props.value || '');
	},
	componentWillUnmount: function componentWillUnmount() {
		// is there a lighter-weight way to remove the cm instance?
		if (this.codeMirror) {
			this.codeMirror.toTextArea();
		}
	},
	componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		if (this.codeMirror && nextProps.value !== undefined && normalizeLineEndings(this.codeMirror.getValue()) !== normalizeLineEndings(nextProps.value)) {
			if (this.props.preserveScrollPosition) {
				var prevScrollPosition = this.codeMirror.getScrollInfo();
				this.codeMirror.setValue(nextProps.value);
				this.codeMirror.scrollTo(prevScrollPosition.left, prevScrollPosition.top);
			} else {
				this.codeMirror.setValue(nextProps.value);
			}
		}
		if (typeof nextProps.options === 'object') {
			for (var optionName in nextProps.options) {
				if (nextProps.options.hasOwnProperty(optionName)) {
					this.codeMirror.setOption(optionName, nextProps.options[optionName]);
				}
			}
		}
	},
	getCodeMirror: function getCodeMirror() {
		return this.codeMirror;
	},
	focus: function focus() {
		if (this.codeMirror) {
			this.codeMirror.focus();
		}
	},
	focusChanged: function focusChanged(focused) {
		this.setState({
			isFocused: focused
		});
		this.props.onFocusChange && this.props.onFocusChange(focused);
	},
	scrollChanged: function scrollChanged(cm) {
		this.props.onScroll && this.props.onScroll(cm.getScrollInfo());
	},
	codemirrorValueChanged: function codemirrorValueChanged(doc, change) {
		if (this.props.onChange && change.origin !== 'setValue') {
			this.props.onChange(doc.getValue(), change);
		}
	},
	render: function render() {
		var editorClassName = className('ReactCodeMirror', this.state.isFocused ? 'ReactCodeMirror--focused' : null, this.props.className);
		return React.createElement(
			'div',
			{ className: editorClassName },
			React.createElement('textarea', { ref: 'textarea', name: this.props.path, defaultValue: this.props.value, autoComplete: 'off' })
		);
	}
});

module.exports = CodeMirror;

/***/ }),
/* 2596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  function _class() {
    _classCallCheck(this, _class);

    this.size = 0;
    this.keys = [];
    this.values = [];
  }

  _class.prototype.get = function get(key) {
    var index = this.keys.indexOf(key);

    return this.values[index];
  };

  _class.prototype.set = function set(key, value) {
    this.keys.push(key);
    this.values.push(value);
    this.size = this.keys.length;

    return value;
  };

  return _class;
}();

exports.default = _class;
module.exports = exports["default"];

/***/ }),
/* 2597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isObject2 = __webpack_require__(118);

var _isObject3 = _interopRequireDefault(_isObject2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(2356);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _linkClass = __webpack_require__(1042);

var _linkClass2 = _interopRequireDefault(_linkClass);

var _renderNothing = __webpack_require__(1043);

var _renderNothing2 = _interopRequireDefault(_renderNothing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); } /* eslint-disable react/prop-types */

/**
 * @param {ReactClass} Component
 * @param {Object} defaultStyles
 * @param {Object} options
 * @returns {ReactClass}
 */
exports.default = function (Component, defaultStyles, options) {
  var WrappedComponent = function (_Component) {
    _inherits(WrappedComponent, _Component);

    function WrappedComponent() {
      _classCallCheck(this, WrappedComponent);

      return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    WrappedComponent.prototype.render = function render() {
      var styles = void 0;

      var hasDefaultstyles = (0, _isObject3.default)(defaultStyles);

      if (this.props.styles || hasDefaultstyles) {
        var props = Object.assign({}, this.props);

        if (this.props.styles) {
          styles = this.props.styles;
        } else if (hasDefaultstyles) {
          styles = defaultStyles;
          delete this.props.styles;
        }

        Object.defineProperty(props, 'styles', {
          configurable: true,
          enumerable: false,
          value: styles,
          writable: false
        });

        this.props = props;
      } else {
        styles = {};
      }

      var renderResult = _Component.prototype.render.call(this);

      if (renderResult) {
        return (0, _linkClass2.default)(renderResult, styles, options);
      }

      return (0, _renderNothing2.default)(_react2.default.version);
    };

    return WrappedComponent;
  }(Component);

  return (0, _hoistNonReactStatics2.default)(WrappedComponent, Component);
};

module.exports = exports['default'];

/***/ }),
/* 2598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleMap = __webpack_require__(2596);

var _SimpleMap2 = _interopRequireDefault(_SimpleMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomMap = typeof Map === 'undefined' ? _SimpleMap2.default : Map;

var stylesIndex = new CustomMap();

exports.default = function (styles, styleNames, handleNotFoundStyleName) {
  var appendClassName = void 0;
  var stylesIndexMap = void 0;

  stylesIndexMap = stylesIndex.get(styles);

  if (stylesIndexMap) {
    var styleNameIndex = stylesIndexMap.get(styleNames);

    if (styleNameIndex) {
      return styleNameIndex;
    }
  } else {
    stylesIndexMap = new CustomMap();
    stylesIndex.set(styles, new CustomMap());
  }

  appendClassName = '';

  for (var styleName in styleNames) {
    if (styleNames.hasOwnProperty(styleName)) {
      var className = styles[styleNames[styleName]];

      if (className) {
        appendClassName += ' ' + className;
      } else {
        if (handleNotFoundStyleName === 'throw') {
          throw new Error('"' + styleNames[styleName] + '" CSS module is undefined.');
        }
        if (handleNotFoundStyleName === 'log') {
          // eslint-disable-next-line no-console
          console.warn('"' + styleNames[styleName] + '" CSS module is undefined.');
        }
      }
    }
  }

  appendClassName = appendClassName.trim();

  stylesIndexMap.set(styleNames, appendClassName);

  return appendClassName;
};

module.exports = exports['default'];

/***/ }),
/* 2599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isObject2 = __webpack_require__(118);

var _isObject3 = _interopRequireDefault(_isObject2);

var _isFunction2 = __webpack_require__(170);

var _isFunction3 = _interopRequireDefault(_isFunction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ITERATOR_SYMBOL = typeof Symbol !== 'undefined' && (0, _isFunction3.default)(Symbol) && Symbol.iterator;
var OLD_ITERATOR_SYMBOL = '@@iterator';

/**
 * @see https://github.com/lodash/lodash/issues/1668
 * @see https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Iteration_protocols
 */

exports.default = function (maybeIterable) {
  var iterator = void 0;

  if (!(0, _isObject3.default)(maybeIterable)) {
    return false;
  }

  if (ITERATOR_SYMBOL) {
    iterator = maybeIterable[ITERATOR_SYMBOL];
  } else {
    iterator = maybeIterable[OLD_ITERATOR_SYMBOL];
  }

  return (0, _isFunction3.default)(iterator);
};

module.exports = exports['default'];

/***/ }),
/* 2600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _includes2 = __webpack_require__(892);

var _includes3 = _interopRequireDefault(_includes2);

var _isBoolean2 = __webpack_require__(2503);

var _isBoolean3 = _interopRequireDefault(_isBoolean2);

var _isUndefined2 = __webpack_require__(559);

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

var _forEach2 = __webpack_require__(890);

var _forEach3 = _interopRequireDefault(_forEach2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @typedef CSSModules~Options
 * @see {@link https://github.com/gajus/react-css-modules#options}
 * @property {boolean} allowMultiple
 * @property {string} handleNotFoundStyleName
 */

/**
 * @param {CSSModules~Options} userConfiguration
 * @returns {CSSModules~Options}
 */
exports.default = function () {
  var userConfiguration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var configuration = {
    allowMultiple: false,
    handleNotFoundStyleName: 'throw'
  };

  (0, _forEach3.default)(userConfiguration, function (value, name) {
    if ((0, _isUndefined3.default)(configuration[name])) {
      throw new Error('Unknown configuration property "' + name + '".');
    }

    if (name === 'allowMultiple' && !(0, _isBoolean3.default)(value)) {
      throw new Error('"allowMultiple" property value must be a boolean.');
    }

    if (name === 'handleNotFoundStyleName' && !(0, _includes3.default)(['throw', 'log', 'ignore'], value)) {
      throw new Error('"handleNotFoundStyleName" property value must be "throw", "log" or "ignore".');
    }

    configuration[name] = value;
  });

  return configuration;
};

module.exports = exports['default'];

/***/ }),
/* 2601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _filter2 = __webpack_require__(889);

var _filter3 = _interopRequireDefault(_filter2);

var _trim2 = __webpack_require__(2518);

var _trim3 = _interopRequireDefault(_trim2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styleNameIndex = {};

exports.default = function (styleNamePropertyValue, allowMultiple) {
  var styleNames = void 0;

  if (styleNameIndex[styleNamePropertyValue]) {
    styleNames = styleNameIndex[styleNamePropertyValue];
  } else {
    styleNames = (0, _trim3.default)(styleNamePropertyValue).split(/\s+/);
    styleNames = (0, _filter3.default)(styleNames);

    styleNameIndex[styleNamePropertyValue] = styleNames;
  }

  if (allowMultiple === false && styleNames.length > 1) {
    throw new Error('ReactElement styleName property defines multiple module names ("' + styleNamePropertyValue + '").');
  }

  return styleNames;
};

module.exports = exports['default'];

/***/ }),
/* 2602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign2 = __webpack_require__(886);

var _assign3 = _interopRequireDefault(_assign2);

var _isObject2 = __webpack_require__(118);

var _isObject3 = _interopRequireDefault(_isObject2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _linkClass = __webpack_require__(1042);

var _linkClass2 = _interopRequireDefault(_linkClass);

var _renderNothing = __webpack_require__(1043);

var _renderNothing2 = _interopRequireDefault(_renderNothing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @see https://facebook.github.io/react/blog/2015/09/10/react-v0.14-rc1.html#stateless-function-components
 */
exports.default = function (Component, defaultStyles, options) {
  var WrappedComponent = function WrappedComponent() {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var styles = void 0;
    var useProps = void 0;
    var hasDefaultstyles = (0, _isObject3.default)(defaultStyles);

    if (props.styles || hasDefaultstyles) {
      useProps = Object.assign({}, props);

      if (props.styles) {
        styles = props.styles;
      } else {
        styles = defaultStyles;
      }

      Object.defineProperty(useProps, 'styles', {
        configurable: true,
        enumerable: false,
        value: styles,
        writable: false
      });
    } else {
      useProps = props;
      styles = {};
    }

    var renderResult = Component.apply(undefined, [useProps].concat(args));

    if (renderResult) {
      return (0, _linkClass2.default)(renderResult, styles, options);
    }

    return (0, _renderNothing2.default)(_react2.default.version);
  };

  (0, _assign3.default)(WrappedComponent, Component);

  return WrappedComponent;
}; /* eslint-disable react/prop-types */

module.exports = exports['default'];

/***/ }),
/* 2603 */,
/* 2604 */,
/* 2605 */,
/* 2606 */,
/* 2607 */,
/* 2608 */,
/* 2609 */,
/* 2610 */,
/* 2611 */,
/* 2612 */,
/* 2613 */,
/* 2614 */,
/* 2615 */,
/* 2616 */,
/* 2617 */,
/* 2618 */,
/* 2619 */,
/* 2620 */,
/* 2621 */,
/* 2622 */,
/* 2623 */,
/* 2624 */,
/* 2625 */,
/* 2626 */,
/* 2627 */,
/* 2628 */,
/* 2629 */,
/* 2630 */,
/* 2631 */,
/* 2632 */,
/* 2633 */,
/* 2634 */,
/* 2635 */,
/* 2636 */,
/* 2637 */,
/* 2638 */,
/* 2639 */,
/* 2640 */,
/* 2641 */,
/* 2642 */,
/* 2643 */,
/* 2644 */,
/* 2645 */,
/* 2646 */,
/* 2647 */,
/* 2648 */,
/* 2649 */,
/* 2650 */,
/* 2651 */,
/* 2652 */,
/* 2653 */,
/* 2654 */,
/* 2655 */,
/* 2656 */,
/* 2657 */,
/* 2658 */,
/* 2659 */,
/* 2660 */,
/* 2661 */,
/* 2662 */,
/* 2663 */,
/* 2664 */,
/* 2665 */,
/* 2666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(2667);
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),
/* 2667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */

var React = __webpack_require__(1);

var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),
/* 2668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(2669);
} else {
  module.exports = require('./index.dev');
}

/***/ }),
/* 2669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.AppContainer = __webpack_require__(2666);

/***/ }),
/* 2670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(9);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _IntlProvider = __webpack_require__(1065);

var _IntlProvider2 = _interopRequireDefault(_IntlProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line react/prop-types
var Provider = function Provider(_ref) {
  var store = _ref.store,
      children = _ref.children;
  return _react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _react2.default.createElement(
      _IntlProvider2.default,
      null,
      children
    )
  );
};

 false ? Provider.propTypes = {
  children: _react.PropTypes.element.isRequired
} : void 0;

exports.default = Provider;

/***/ }),
/* 2671 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var n=String(e).split("."),l=!n[1],o=Number(n[0])==e,t=o&&n[0].slice(-1),r=o&&n[0].slice(-2);return a?1==t&&11!=r?"one":2==t&&12!=r?"two":3==t&&13!=r?"few":"other":1==e&&l?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}}}},{locale:"en-001",parentLocale:"en"},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001"},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001"},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001"},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ }),
/* 2672 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.zh=t())}(this,function(){"use strict";return[{locale:"zh",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒钟后"},past:{other:"{0}秒钟前"}}}}},{locale:"zh-Hans",parentLocale:"zh"},{locale:"zh-Hans-HK",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans-MO",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans-SG",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hant",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"後天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0} 天後"},past:{other:"{0} 天前"}}},hour:{displayName:"小時",relative:{0:"這一小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},minute:{displayName:"分鐘",relative:{0:"這一分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},second:{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}},{locale:"zh-Hant-HK",parentLocale:"zh-Hant",fields:{year:{displayName:"年",relative:{0:"今年",1:"下年","-1":"上年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},day:{displayName:"日",relative:{0:"今日",1:"明日",2:"後日","-2":"前日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},hour:{displayName:"小時",relative:{0:"這個小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},minute:{displayName:"分鐘",relative:{0:"這分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},second:{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}},{locale:"zh-Hant-MO",parentLocale:"zh-Hant-HK"}]});


/***/ }),
/* 2673 */,
/* 2674 */,
/* 2675 */,
/* 2676 */,
/* 2677 */,
/* 2678 */,
/* 2679 */,
/* 2680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _resizeObserverPolyfill = __webpack_require__(2739);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

var _utils = __webpack_require__(2681);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-debugger: "warn" */


/**
 * Predefined constants
 * @type {Object}
 */
var constants = {
  orientation: {
    horizontal: {
      dimension: 'width',
      direction: 'left',
      reverseDirection: 'right',
      coordinate: 'x'
    },
    vertical: {
      dimension: 'height',
      direction: 'top',
      reverseDirection: 'bottom',
      coordinate: 'y'
    }
  }
};

var Slider = function (_Component) {
  _inherits(Slider, _Component);

  function Slider(props, context) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props, context));

    _this.handleFormat = function (value) {
      var format = _this.props.format;

      return format ? format(value) : value;
    };

    _this.handleUpdate = function () {
      if (!_this.slider) {
        // for shallow rendering
        return;
      }
      var orientation = _this.props.orientation;

      var dimension = (0, _utils.capitalize)(constants.orientation[orientation].dimension);
      var sliderPos = _this.slider['offset' + dimension];
      var handlePos = _this.handle['offset' + dimension];

      _this.setState({
        limit: sliderPos - handlePos,
        grab: handlePos / 2
      });
    };

    _this.handleStart = function (e) {
      var onChangeStart = _this.props.onChangeStart;

      document.addEventListener('mousemove', _this.handleDrag);
      document.addEventListener('mouseup', _this.handleEnd);
      _this.setState({
        active: true
      }, function () {
        onChangeStart && onChangeStart(e);
      });
    };

    _this.handleDrag = function (e) {
      e.stopPropagation();
      var onChange = _this.props.onChange;
      var _e$target = e.target,
          className = _e$target.className,
          classList = _e$target.classList,
          dataset = _e$target.dataset;

      if (!onChange || className === 'rangeslider__labels') return;

      var value = _this.position(e);

      if (classList && classList.contains('rangeslider__label-item') && dataset.value) {
        value = parseFloat(dataset.value);
      }

      onChange && onChange(value, e);
    };

    _this.handleEnd = function (e) {
      var onChangeComplete = _this.props.onChangeComplete;

      _this.setState({
        active: false
      }, function () {
        onChangeComplete && onChangeComplete(e);
      });
      document.removeEventListener('mousemove', _this.handleDrag);
      document.removeEventListener('mouseup', _this.handleEnd);
    };

    _this.handleKeyDown = function (e) {
      e.preventDefault();
      var keyCode = e.keyCode;
      var _this$props = _this.props,
          value = _this$props.value,
          min = _this$props.min,
          max = _this$props.max,
          step = _this$props.step,
          onChange = _this$props.onChange;

      var sliderValue = void 0;

      switch (keyCode) {
        case 38:
        case 39:
          sliderValue = value + step > max ? max : value + step;
          onChange && onChange(sliderValue, e);
          break;
        case 37:
        case 40:
          sliderValue = value - step < min ? min : value - step;
          onChange && onChange(sliderValue, e);
          break;
      }
    };

    _this.getPositionFromValue = function (value) {
      var limit = _this.state.limit;
      var _this$props2 = _this.props,
          min = _this$props2.min,
          max = _this$props2.max;

      var diffMaxMin = max - min;
      var diffValMin = value - min;
      var percentage = diffValMin / diffMaxMin;
      var pos = Math.round(percentage * limit);

      return pos;
    };

    _this.getValueFromPosition = function (pos) {
      var limit = _this.state.limit;
      var _this$props3 = _this.props,
          orientation = _this$props3.orientation,
          min = _this$props3.min,
          max = _this$props3.max,
          step = _this$props3.step;

      var percentage = (0, _utils.clamp)(pos, 0, limit) / (limit || 1);
      var baseVal = step * Math.round(percentage * (max - min) / step);
      var value = orientation === 'horizontal' ? baseVal + min : max - baseVal;

      return (0, _utils.clamp)(value, min, max);
    };

    _this.position = function (e) {
      var grab = _this.state.grab;
      var _this$props4 = _this.props,
          orientation = _this$props4.orientation,
          reverse = _this$props4.reverse;


      var node = _this.slider;
      var coordinateStyle = constants.orientation[orientation].coordinate;
      var directionStyle = reverse ? constants.orientation[orientation].reverseDirection : constants.orientation[orientation].direction;
      var clientCoordinateStyle = 'client' + (0, _utils.capitalize)(coordinateStyle);
      var coordinate = !e.touches ? e[clientCoordinateStyle] : e.touches[0][clientCoordinateStyle];
      var direction = node.getBoundingClientRect()[directionStyle];
      var pos = reverse ? direction - coordinate - grab : coordinate - direction - grab;
      var value = _this.getValueFromPosition(pos);

      return value;
    };

    _this.coordinates = function (pos) {
      var _this$state = _this.state,
          limit = _this$state.limit,
          grab = _this$state.grab;
      var orientation = _this.props.orientation;

      var value = _this.getValueFromPosition(pos);
      var position = _this.getPositionFromValue(value);
      var handlePos = orientation === 'horizontal' ? position + grab : position;
      var fillPos = orientation === 'horizontal' ? handlePos : limit - handlePos;

      return {
        fill: fillPos,
        handle: handlePos,
        label: handlePos
      };
    };

    _this.renderLabels = function (labels) {
      return _react2.default.createElement(
        'ul',
        {
          ref: function ref(sl) {
            _this.labels = sl;
          },
          className: (0, _classnames2.default)('rangeslider__labels')
        },
        labels
      );
    };

    _this.state = {
      active: false,
      limit: 0,
      grab: 0
    };
    return _this;
  }

  _createClass(Slider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleUpdate();
      var resizeObserver = new _resizeObserverPolyfill2.default(this.handleUpdate);
      resizeObserver.observe(this.slider);
    }

    /**
     * Format label/tooltip value
     * @param  {Number} - value
     * @return {Formatted Number}
     */


    /**
     * Update slider state on change
     * @return {void}
     */


    /**
     * Attach event listeners to mousemove/mouseup events
     * @return {void}
     */


    /**
     * Handle drag/mousemove event
     * @param  {Object} e - Event object
     * @return {void}
     */


    /**
     * Detach event listeners to mousemove/mouseup events
     * @return {void}
     */


    /**
     * Support for key events on the slider handle
     * @param  {Object} e - Event object
     * @return {void}
     */


    /**
     * Calculate position of slider based on its value
     * @param  {number} value - Current value of slider
     * @return {position} pos - Calculated position of slider based on value
     */


    /**
     * Translate position of slider to slider value
     * @param  {number} pos - Current position/coordinates of slider
     * @return {number} value - Slider value
     */


    /**
     * Calculate position of slider based on value
     * @param  {Object} e - Event object
     * @return {number} value - Slider value
     */


    /**
     * Grab coordinates of slider
     * @param  {Object} pos - Position object
     * @return {Object} - Slider fill/handle coordinates
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          value = _props.value,
          orientation = _props.orientation,
          className = _props.className,
          tooltip = _props.tooltip,
          reverse = _props.reverse,
          labels = _props.labels,
          min = _props.min,
          max = _props.max,
          handleLabel = _props.handleLabel;
      var active = this.state.active;

      var dimension = constants.orientation[orientation].dimension;
      var direction = reverse ? constants.orientation[orientation].reverseDirection : constants.orientation[orientation].direction;
      var position = this.getPositionFromValue(value);
      var coords = this.coordinates(position);
      var fillStyle = _defineProperty({}, dimension, coords.fill + 'px');
      var handleStyle = _defineProperty({}, direction, coords.handle + 'px');
      var showTooltip = tooltip && active;

      var labelItems = [];
      var labelKeys = Object.keys(labels);

      if (labelKeys.length > 0) {
        labelKeys = labelKeys.sort(function (a, b) {
          return reverse ? a - b : b - a;
        });

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = labelKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var labelPosition = this.getPositionFromValue(key);
            var labelCoords = this.coordinates(labelPosition);
            var labelStyle = _defineProperty({}, direction, labelCoords.label + 'px');

            labelItems.push(_react2.default.createElement(
              'li',
              {
                key: key,
                className: (0, _classnames2.default)('rangeslider__label-item'),
                'data-value': key,
                onMouseDown: this.handleDrag,
                onTouchStart: this.handleStart,
                onTouchEnd: this.handleEnd,
                style: labelStyle
              },
              this.props.labels[key]
            ));
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      return _react2.default.createElement(
        'div',
        {
          ref: function ref(s) {
            _this2.slider = s;
          },
          className: (0, _classnames2.default)('rangeslider', 'rangeslider-' + orientation, { 'rangeslider-reverse': reverse }, className),
          onMouseDown: this.handleDrag,
          onMouseUp: this.handleEnd,
          onTouchStart: this.handleStart,
          onTouchEnd: this.handleEnd,
          'aria-valuemin': min,
          'aria-valuemax': max,
          'aria-valuenow': value,
          'aria-orientation': orientation
        },
        _react2.default.createElement('div', { className: 'rangeslider__fill', style: fillStyle }),
        _react2.default.createElement(
          'div',
          {
            ref: function ref(sh) {
              _this2.handle = sh;
            },
            className: 'rangeslider__handle',
            onMouseDown: this.handleStart,
            onTouchMove: this.handleDrag,
            onTouchEnd: this.handleEnd,
            onKeyDown: this.handleKeyDown,
            style: handleStyle,
            tabIndex: 0
          },
          showTooltip ? _react2.default.createElement(
            'div',
            {
              ref: function ref(st) {
                _this2.tooltip = st;
              },
              className: 'rangeslider__handle-tooltip'
            },
            _react2.default.createElement(
              'span',
              null,
              this.handleFormat(value)
            )
          ) : null,
          _react2.default.createElement(
            'div',
            { className: 'rangeslider__handle-label' },
            handleLabel
          )
        ),
        labels ? this.renderLabels(labelItems) : null
      );
    }
  }]);

  return Slider;
}(_react.Component);

Slider.propTypes = {
  min: _propTypes2.default.number,
  max: _propTypes2.default.number,
  step: _propTypes2.default.number,
  value: _propTypes2.default.number,
  orientation: _propTypes2.default.string,
  tooltip: _propTypes2.default.bool,
  reverse: _propTypes2.default.bool,
  labels: _propTypes2.default.object,
  handleLabel: _propTypes2.default.string,
  format: _propTypes2.default.func,
  onChangeStart: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onChangeComplete: _propTypes2.default.func
};
Slider.defaultProps = {
  min: 0,
  max: 100,
  step: 1,
  value: 0,
  orientation: 'horizontal',
  tooltip: true,
  reverse: false,
  labels: {},
  handleLabel: ''
};
exports.default = Slider;

/***/ }),
/* 2681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalize = capitalize;
exports.clamp = clamp;
/**
 * Capitalize first letter of string
 * @private
 * @param  {string} - String
 * @return {string} - String with first letter capitalized
 */
function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.substr(1);
}

/**
 * Clamp position between a range
 * @param  {number} - Value to be clamped
 * @param  {number} - Minimum value in range
 * @param  {number} - Maximum value in range
 * @return {number} - Clamped value
 */
function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

/***/ }),
/* 2682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(588);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 2683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(2690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(2684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(2685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(2686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(2687);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 2684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(1073);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 2685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(1073);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 2686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(1075);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 2687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(2688);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 2688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(588);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 2689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 2690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 2691 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 2692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(1076);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ }),
/* 2693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(1077);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History 2.x listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      if (!history.getCurrentLocation) {
        listener(lastPublishedLocation);
      }

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),
/* 2694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(1078);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IndexLink',

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexLink);

/***/ }),
/* 2695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redirect__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(326);







/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */
var IndexRedirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRedirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_4__Redirect__["a" /* default */].createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexRedirect);

/***/ }),
/* 2696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(326);







/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */
/* eslint-disable react/require-render-return */
var IndexRoute = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRoute',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["c" /* createRouteFromReactElement */])(element);
      } else {
         false ? warning(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    component: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRoute);

/***/ }),
/* 2697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(326);






/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */
var Route = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Route',

  statics: {
    createRouteFromReactElement: __WEBPACK_IMPORTED_MODULE_3__RouteUtils__["c" /* createRouteFromReactElement */]
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    component: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Route> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 2698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouterContext__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouterUtils__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routerWarning__ = __webpack_require__(273);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"],
  children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */],
  routes: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */], // alias for children
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onError: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onUpdate: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],

  // PRIVATE: For client-side rehydration of server match.
  matchContext: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"]

  /**
   * A <Router> is a high-level API for automatically setting up
   * a router that renders a <RouterContext> with all the props
   * it needs each time the URL changes.
   */
};var Router = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'Router',

  propTypes: propTypes,

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RouterContext__["a" /* default */], props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["a" /* createRouterObject */])(history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ?  false ? invariant(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])(history, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["b" /* createRoutes */])(routes || children));
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["b" /* assignRouterState */])(_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? warning(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? warning((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 2699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionUtils;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(589);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

function getTransitionUtils() {
  var enterHooks = new PendingHooks();
  var changeHooks = new PendingHooks();

  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
    var isSync = hook.length < asyncArity;

    var transitionHook = function transitionHook() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      hook.apply(route, args);

      if (isSync) {
        var callback = args[args.length - 1];
        // Assume hook executes synchronously and
        // automatically call the callback.
        callback();
      }
    };

    pendingHooks.add(transitionHook);

    return transitionHook;
  }

  function getEnterHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
      return hooks;
    }, []);
  }

  function getChangeHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
      return hooks;
    }, []);
  }

  function runTransitionHooks(length, iter, callback) {
    if (!length) {
      callback();
      return;
    }

    var redirectInfo = void 0;
    function replace(location) {
      redirectInfo = location;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(length, function (index, next, done) {
      iter(index, replace, function (error) {
        if (error || redirectInfo) {
          done(error, redirectInfo); // No need to continue.
        } else {
          next();
        }
      });
    }, callback);
  }

  /**
   * Runs all onEnter hooks in the given array of routes in order
   * with onEnter(nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runEnterHooks(routes, nextState, callback) {
    enterHooks.clear();
    var hooks = getEnterHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (enterHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          enterHooks.remove(hooks[index]);
        }
      };
      hooks[index](nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onChange hooks in the given array of routes in order
   * with onChange(prevState, nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runChangeHooks(routes, state, nextState, callback) {
    changeHooks.clear();
    var hooks = getChangeHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (changeHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          changeHooks.remove(hooks[index]);
        }
      };
      hooks[index](state, nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onLeave hooks in the given array of routes in order.
   */
  function runLeaveHooks(routes, prevState) {
    for (var i = 0, len = routes.length; i < len; ++i) {
      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
    }
  }

  return {
    runEnterHooks: runEnterHooks,
    runChangeHooks: runChangeHooks,
    runLeaveHooks: runLeaveHooks
  };
}

/***/ }),
/* 2700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouterContext__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(273);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? warning(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouterContext__["a" /* default */], _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
});

/***/ }),
/* 2701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__ = __webpack_require__(2353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(1083);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default.a));

/***/ }),
/* 2702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(272);


function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["a" /* getParamNames */])(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    var parentIsLeaving = false;
    leaveRoutes = prevRoutes.filter(function (route) {
      if (parentIsLeaving) {
        return true;
      } else {
        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
        if (isLeaving) parentIsLeaving = true;
        return isLeaving;
      }
    });

    // onLeave hooks start at the leaf route.
    leaveRoutes.reverse();

    enterRoutes = [];
    changeRoutes = [];

    nextRoutes.forEach(function (route) {
      var isNew = prevRoutes.indexOf(route) === -1;
      var paramsChanged = leaveRoutes.indexOf(route) !== -1;

      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
    });
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

/* harmony default export */ __webpack_exports__["a"] = (computeChangedRoutes);

/***/ }),
/* 2703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(1079);



function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* mapAsync */])(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

/* harmony default export */ __webpack_exports__["a"] = (getComponents);

/***/ }),
/* 2704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(272);


/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["a" /* getParamNames */])(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

/* harmony default export */ __webpack_exports__["a"] = (getRouteParams);

/***/ }),
/* 2705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__ = __webpack_require__(2354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(1083);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default.a));

/***/ }),
/* 2706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(272);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}

/***/ }),
/* 2707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouterUtils__ = __webpack_require__(1081);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? invariant(false, 'match needs a history or a location') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;

  history = history ? history : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a" /* default */])(options);
  var transitionManager = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])(history, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__RouterUtils__["a" /* createRouterObject */])(history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__["REPLACE"]), renderProps);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (match);

/***/ }),
/* 2708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PatternUtils__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerWarning__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(198);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    });

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes || route.getChildRoutes) {
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
        return;
      }

      var pathless = childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__PatternUtils__["b" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var match = {
        routes: [route],
        params: createParams(paramNames, paramValues)
      };

      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
        if (error) {
          callback(error);
        } else {
          if (Array.isArray(indexRoute)) {
            var _match$routes;

             false ? warning(indexRoute.every(function (route) {
              return !route.path;
            }), 'Index routes should not have paths') : void 0;
            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
          } else if (indexRoute) {
             false ? warning(!indexRoute.path, 'Index routes should not have paths') : void 0;
            match.routes.push(indexRoute);
          }

          callback(null, match);
        }
      });

      return;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}

/***/ }),
/* 2709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(2710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextUtils__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PropTypes__ = __webpack_require__(591);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
    displayName: 'WithRouter',

    mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__ContextUtils__["b" /* ContextSubscriber */])('router')],

    contextTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["a" /* routerShape */] },
    propTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["a" /* routerShape */] },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? invariant(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      if (!router) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, this.props);
      }

      var params = router.params,
          location = router.location,
          routes = router.routes;

      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(WithRouter, WrappedComponent);
}

/***/ }),
/* 2710 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 2711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(2713);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(2712);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(1086);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 2712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__(742);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(744);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(1808);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(502);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(64);

var _PropTypes = __webpack_require__(1086);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 2713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(1435);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(68);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(2714);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 2714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(1);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 2715 */,
/* 2716 */,
/* 2717 */,
/* 2718 */,
/* 2719 */,
/* 2720 */,
/* 2721 */,
/* 2722 */,
/* 2723 */,
/* 2724 */,
/* 2725 */,
/* 2726 */,
/* 2727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var filenameWithoutLoaders = exports.filenameWithoutLoaders = function filenameWithoutLoaders() {
  var filename = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var index = filename.lastIndexOf('!');

  return index < 0 ? filename : filename.substr(index + 1);
};

var filenameHasLoaders = exports.filenameHasLoaders = function filenameHasLoaders(filename) {
  var actualFilename = _get__('filenameWithoutLoaders')(filename);

  return actualFilename !== filename;
};

var filenameHasSchema = exports.filenameHasSchema = function filenameHasSchema(filename) {
  return (/^[\w]+\:/.test(filename)
  );
};

var isFilenameAbsolute = exports.isFilenameAbsolute = function isFilenameAbsolute(filename) {
  var actualFilename = _get__('filenameWithoutLoaders')(filename);

  if (actualFilename.indexOf('/') === 0) {
    return true;
  }

  return false;
};

var makeUrl = exports.makeUrl = function makeUrl(filename, scheme, line, column) {
  var actualFilename = _get__('filenameWithoutLoaders')(filename);

  if (_get__('filenameHasSchema')(filename)) {
    return actualFilename;
  }

  var url = 'file://' + actualFilename;

  if (scheme === 'vscode') {
    url = scheme + '://file/' + url;
    url = url.replace(/file:\/\/\//, ''); // visual studio code does not need file:/// in its scheme
    if (line && actualFilename === filename) {
      url = url + ':' + line;

      if (column) {
        url = url + ':' + column;
      }
    }
  } else if (scheme) {
    url = scheme + '://open?url=' + url;

    if (line && actualFilename === filename) {
      url = url + '&line=' + line;

      if (column) {
        url = url + '&column=' + column;
      }
    }
  }

  return url;
};

var makeLinkText = exports.makeLinkText = function makeLinkText(filename, line, column) {
  var text = _get__('filenameWithoutLoaders')(filename);

  if (line && text === filename) {
    text = text + ':' + line;

    if (column) {
      text = text + ':' + column;
    }
  }

  return text;
};

var _RewiredData__ = Object.create(null);

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  if (_RewiredData__ === undefined || _RewiredData__[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = _RewiredData__[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'filenameWithoutLoaders':
      return filenameWithoutLoaders;

    case 'filenameHasSchema':
      return filenameHasSchema;
  }

  return undefined;
}

function _assign__(variableName, value) {
  if (_RewiredData__ === undefined || _RewiredData__[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return _RewiredData__[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      _RewiredData__[name] = variableName[name];
    });
  } else {
    if (value === undefined) {
      _RewiredData__[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      _RewiredData__[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  delete _RewiredData__[variableName];
}

function _with__(object) {
  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      _RewiredData__[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = _RewiredData__[variableName];
      _RewiredData__[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset).catch(reset);
    } else {
      reset();
    }

    return result;
  };
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
exports.default = _RewireAPI__;

/***/ }),
/* 2728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DefaultExportValue = {
  redbox: {
    boxSizing: 'border-box',
    fontFamily: 'sans-serif',
    position: 'fixed',
    padding: 10,
    top: '0px',
    left: '0px',
    bottom: '0px',
    right: '0px',
    width: '100%',
    background: 'rgb(204, 0, 0)',
    color: 'white',
    zIndex: 2147483647,
    textAlign: 'left',
    fontSize: '16px',
    lineHeight: 1.2,
    overflow: 'auto'
  },
  message: {
    fontWeight: 'bold'
  },
  stack: {
    fontFamily: 'monospace',
    marginTop: '2em'
  },
  frame: {
    marginTop: '1em'
  },
  file: {
    fontSize: '0.8em',
    color: 'rgba(255, 255, 255, 0.7)'
  },
  linkToFile: {
    textDecoration: 'none',
    color: 'rgba(255, 255, 255, 0.7)'
  }
};
exports.default = _DefaultExportValue;

/***/ }),
/* 2729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }

  return function (previous, current) {
    return reducers.reduce(function (p, r) {
      return r(p, current);
    }, previous);
  };
};

module.exports = exports["default"];

/***/ }),
/* 2730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// based on https://github.com/lodash/lodash/blob/4.17.2/lodash.js#L14100
// eslint-disable-next-line max-len
var wordPattern = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:(?:1ST|2ND|3RD|(?![123])\dTH)\b)|\d*(?:(?:1st|2nd|3rd|(?![123])\dth)\b)|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
var namespacer = '/';

function camelCase(string) {
  return string.match(wordPattern).reduce(function (camelCased, word, index) {
    return camelCased + (index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.substring(1).toLowerCase());
  }, '');
}

/* harmony default export */ __webpack_exports__["a"] = (function (actionType) {
  return actionType.split(namespacer).map(camelCase).join(namespacer);
});

/***/ }),
/* 2731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_identity__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__camelCase__ = __webpack_require__(2730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isPlainObject__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isPlainObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isPlainObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isString__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isFunction__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createAction__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_invariant__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }










function createActions(actionsMap) {
  for (var _len = arguments.length, identityActions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    identityActions[_key - 1] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_7_invariant___default()(identityActions.every(__WEBPACK_IMPORTED_MODULE_4_lodash_isString___default.a) && (__WEBPACK_IMPORTED_MODULE_4_lodash_isString___default()(actionsMap) || __WEBPACK_IMPORTED_MODULE_2_lodash_isPlainObject___default()(actionsMap)), 'Expected optional object followed by string action types');
  if (__WEBPACK_IMPORTED_MODULE_4_lodash_isString___default()(actionsMap)) {
    return fromIdentityActions([actionsMap].concat(identityActions));
  }
  return _extends({}, fromActionsMap(actionsMap), fromIdentityActions(identityActions));
}

function isValidActionsMapValue(actionsMapValue) {
  if (__WEBPACK_IMPORTED_MODULE_5_lodash_isFunction___default()(actionsMapValue)) {
    return true;
  } else if (__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(actionsMapValue)) {
    var _actionsMapValue = _slicedToArray(actionsMapValue, 2);

    var _actionsMapValue$ = _actionsMapValue[0];
    var payload = _actionsMapValue$ === undefined ? __WEBPACK_IMPORTED_MODULE_0_lodash_identity___default.a : _actionsMapValue$;
    var meta = _actionsMapValue[1];


    return __WEBPACK_IMPORTED_MODULE_5_lodash_isFunction___default()(payload) && __WEBPACK_IMPORTED_MODULE_5_lodash_isFunction___default()(meta);
  }
  return false;
}

function fromActionsMap(actionsMap) {
  return Object.keys(actionsMap).reduce(function (actionCreatorsMap, type) {
    var actionsMapValue = actionsMap[type];
    __WEBPACK_IMPORTED_MODULE_7_invariant___default()(isValidActionsMapValue(actionsMapValue), 'Expected function, undefined, or array with payload and meta ' + ('functions for ' + type));
    var actionCreator = __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(actionsMapValue) ? __WEBPACK_IMPORTED_MODULE_6__createAction__["a" /* default */].apply(undefined, [type].concat(_toConsumableArray(actionsMapValue))) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__createAction__["a" /* default */])(type, actionsMapValue);
    return _extends({}, actionCreatorsMap, _defineProperty({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__camelCase__["a" /* default */])(type), actionCreator));
  }, {});
}

function fromIdentityActions(identityActions) {
  return fromActionsMap(identityActions.reduce(function (actionsMap, actionType) {
    return _extends({}, actionsMap, _defineProperty({}, actionType, __WEBPACK_IMPORTED_MODULE_0_lodash_identity___default.a));
  }, {}));
}

/***/ }),
/* 2732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__handleAction__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ownKeys__ = __webpack_require__(2733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reduce_reducers__ = __webpack_require__(2729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reduce_reducers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reduce_reducers__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





function handleActions(handlers, defaultState) {
  var reducers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ownKeys__["a" /* default */])(handlers).map(function (type) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__handleAction__["a" /* default */])(type, handlers[type], defaultState);
  });
  var reducer = __WEBPACK_IMPORTED_MODULE_2_reduce_reducers___default.a.apply(undefined, _toConsumableArray(reducers));
  return function (state, action) {
    return reducer(state, action);
  };
}

/***/ }),
/* 2733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ownKeys;
function ownKeys(object) {
  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    return Reflect.ownKeys(object);
  }

  var keys = Object.getOwnPropertyNames(object);

  if (typeof Object.getOwnPropertySymbols === 'function') {
    keys = keys.concat(Object.getOwnPropertySymbols(object));
  }

  return keys;
}

/***/ }),
/* 2734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 2735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(1095);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 2736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 2737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(1097);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 2738 */,
/* 2739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }

    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;

        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;

                return true;
            }

            return false;
        });

        return result;
    }

    return (function () {
        function anonymous() {
            this.__entries__ = [];
        }

        var prototypeAccessors = { size: { configurable: true } };

        /**
         * @returns {boolean}
         */
        prototypeAccessors.size.get = function () {
            return this.__entries__.length;
        };

        /**
         * @param {*} key
         * @returns {*}
         */
        anonymous.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];

            return entry && entry[1];
        };

        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        anonymous.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);

            if (~index) {
                this.__entries__[index][1] = value;
            } else {
                this.__entries__.push([key, value]);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);

            if (~index) {
                entries.splice(index, 1);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };

        /**
         * @returns {void}
         */
        anonymous.prototype.clear = function () {
            this.__entries__.splice(0);
        };

        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        anonymous.prototype.forEach = function (callback, ctx) {
            var this$1 = this;
            if ( ctx === void 0 ) ctx = null;

            for (var i = 0, list = this$1.__entries__; i < list.length; i += 1) {
                var entry = list[i];

                callback.call(ctx, entry[1], entry[0]);
            }
        };

        Object.defineProperties( anonymous.prototype, prototypeAccessors );

        return anonymous;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }

    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }

    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }

    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }

    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;

/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
var throttle = function (callback, delay) {
    var leadingCall = false,
        trailingCall = false,
        lastCallTime = 0;

    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;

            callback();
        }

        if (trailingCall) {
            proxy();
        }
    }

    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }

    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();

        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }

            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;

            setTimeout(timeoutCallback, delay);
        }

        lastCallTime = timeStamp;
    }

    return proxy;
};

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;

// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];

// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';

/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = function() {
    this.connected_ = false;
    this.mutationEventsAdded_ = false;
    this.mutationsObserver_ = null;
    this.observers_ = [];

    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
};

/**
 * Adds observer to observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be added.
 * @returns {void}
 */


/**
 * Holds reference to the controller's instance.
 *
 * @private {ResizeObserverController}
 */


/**
 * Keeps reference to the instance of MutationObserver.
 *
 * @private {MutationObserver}
 */

/**
 * Indicates whether DOM listeners have been added.
 *
 * @private {boolean}
 */
ResizeObserverController.prototype.addObserver = function (observer) {
    if (!~this.observers_.indexOf(observer)) {
        this.observers_.push(observer);
    }

    // Add listeners if they haven't been added yet.
    if (!this.connected_) {
        this.connect_();
    }
};

/**
 * Removes observer from observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be removed.
 * @returns {void}
 */
ResizeObserverController.prototype.removeObserver = function (observer) {
    var observers = this.observers_;
    var index = observers.indexOf(observer);

    // Remove observer if it's present in registry.
    if (~index) {
        observers.splice(index, 1);
    }

    // Remove listeners if controller has no connected observers.
    if (!observers.length && this.connected_) {
        this.disconnect_();
    }
};

/**
 * Invokes the update of observers. It will continue running updates insofar
 * it detects changes.
 *
 * @returns {void}
 */
ResizeObserverController.prototype.refresh = function () {
    var changesDetected = this.updateObservers_();

    // Continue running updates if changes have been detected as there might
    // be future ones caused by CSS transitions.
    if (changesDetected) {
        this.refresh();
    }
};

/**
 * Updates every observer from observers list and notifies them of queued
 * entries.
 *
 * @private
 * @returns {boolean} Returns "true" if any observer has detected changes in
 *  dimensions of it's elements.
 */
ResizeObserverController.prototype.updateObservers_ = function () {
    // Collect observers that have active observations.
    var activeObservers = this.observers_.filter(function (observer) {
        return observer.gatherActive(), observer.hasActive();
    });

    // Deliver notifications in a separate cycle in order to avoid any
    // collisions between observers, e.g. when multiple instances of
    // ResizeObserver are tracking the same element and the callback of one
    // of them changes content dimensions of the observed target. Sometimes
    // this may result in notifications being blocked for the rest of observers.
    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });

    return activeObservers.length > 0;
};

/**
 * Initializes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.connect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already added.
    if (!isBrowser || this.connected_) {
        return;
    }

    // Subscription to the "Transitionend" event is used as a workaround for
    // delayed transitions. This way it's possible to capture at least the
    // final state of an element.
    document.addEventListener('transitionend', this.onTransitionEnd_);

    window.addEventListener('resize', this.refresh);

    if (mutationObserverSupported) {
        this.mutationsObserver_ = new MutationObserver(this.refresh);

        this.mutationsObserver_.observe(document, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
        });
    } else {
        document.addEventListener('DOMSubtreeModified', this.refresh);

        this.mutationEventsAdded_ = true;
    }

    this.connected_ = true;
};

/**
 * Removes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.disconnect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already removed.
    if (!isBrowser || !this.connected_) {
        return;
    }

    document.removeEventListener('transitionend', this.onTransitionEnd_);
    window.removeEventListener('resize', this.refresh);

    if (this.mutationsObserver_) {
        this.mutationsObserver_.disconnect();
    }

    if (this.mutationEventsAdded_) {
        document.removeEventListener('DOMSubtreeModified', this.refresh);
    }

    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
};

/**
 * "Transitionend" event handler.
 *
 * @private
 * @param {TransitionEvent} event
 * @returns {void}
 */
ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
        var propertyName = ref.propertyName; if ( propertyName === void 0 ) propertyName = '';

    // Detect whether transition may affect dimensions of an element.
    var isReflowProperty = transitionKeys.some(function (key) {
        return !!~propertyName.indexOf(key);
    });

    if (isReflowProperty) {
        this.refresh();
    }
};

/**
 * Returns instance of the ResizeObserverController.
 *
 * @returns {ResizeObserverController}
 */
ResizeObserverController.getInstance = function () {
    if (!this.instance_) {
        this.instance_ = new ResizeObserverController();
    }

    return this.instance_;
};

ResizeObserverController.instance_ = null;

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
        var key = list[i];

        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }

    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;

    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);

/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}

/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [], len = arguments.length - 1;
    while ( len-- > 0 ) positions[ len ] = arguments[ len + 1 ];

    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];

        return size + toFloat(value);
    }, 0);
}

/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};

    for (var i = 0, list = positions; i < list.length; i += 1) {
        var position = list[i];

        var value = styles['padding-' + position];

        paddings[position] = toFloat(value);
    }

    return paddings;
}

/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();

    return createRectInit(0, 0, bbox.width, bbox.height);
}

/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth;
    var clientHeight = target.clientHeight;

    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }

    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;

    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width),
        height = toFloat(styles.height);

    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }

        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }

    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;

        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }

        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }

    return createRectInit(paddings.left, paddings.top, width, height);
}

/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }

    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function'; };
})();

/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}

/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }

    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }

    return getHTMLElementContentRect(target);
}

/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(ref) {
    var x = ref.x;
    var y = ref.y;
    var width = ref.width;
    var height = ref.height;

    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);

    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });

    return rect;
}

/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = function(target) {
    this.broadcastWidth = 0;
    this.broadcastHeight = 0;
    this.contentRect_ = createRectInit(0, 0, 0, 0);

    this.target = target;
};

/**
 * Updates content rectangle and tells whether it's width or height properties
 * have changed since the last broadcast.
 *
 * @returns {boolean}
 */


/**
 * Reference to the last observed content rectangle.
 *
 * @private {DOMRectInit}
 */


/**
 * Broadcasted width of content rectangle.
 *
 * @type {number}
 */
ResizeObservation.prototype.isActive = function () {
    var rect = getContentRect(this.target);

    this.contentRect_ = rect;

    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
};

/**
 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
 * from the corresponding properties of the last observed content rectangle.
 *
 * @returns {DOMRectInit} Last observed content rectangle.
 */
ResizeObservation.prototype.broadcastRect = function () {
    var rect = this.contentRect_;

    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;

    return rect;
};

var ResizeObserverEntry = function(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit);

    // According to the specification following properties are not writable
    // and are also not enumerable in the native implementation.
    //
    // Property accessors are not being used as they'd require to define a
    // private WeakMap storage which may cause memory leaks in browsers that
    // don't support this type of collections.
    defineConfigurable(this, { target: target, contentRect: contentRect });
};

var ResizeObserverSPI = function(callback, controller, callbackCtx) {
    this.activeObservations_ = [];
    this.observations_ = new MapShim();

    if (typeof callback !== 'function') {
        throw new TypeError('The callback provided as parameter 1 is not a function.');
    }

    this.callback_ = callback;
    this.controller_ = controller;
    this.callbackCtx_ = callbackCtx;
};

/**
 * Starts observing provided element.
 *
 * @param {Element} target - Element to be observed.
 * @returns {void}
 */


/**
 * Registry of the ResizeObservation instances.
 *
 * @private {Map<Element, ResizeObservation>}
 */


/**
 * Public ResizeObserver instance which will be passed to the callback
 * function and used as a value of it's "this" binding.
 *
 * @private {ResizeObserver}
 */

/**
 * Collection of resize observations that have detected changes in dimensions
 * of elements.
 *
 * @private {Array<ResizeObservation>}
 */
ResizeObserverSPI.prototype.observe = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is already being observed.
    if (observations.has(target)) {
        return;
    }

    observations.set(target, new ResizeObservation(target));

    this.controller_.addObserver(this);

    // Force the update of observations.
    this.controller_.refresh();
};

/**
 * Stops observing provided element.
 *
 * @param {Element} target - Element to stop observing.
 * @returns {void}
 */
ResizeObserverSPI.prototype.unobserve = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is not being observed.
    if (!observations.has(target)) {
        return;
    }

    observations.delete(target);

    if (!observations.size) {
        this.controller_.removeObserver(this);
    }
};

/**
 * Stops observing all elements.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.disconnect = function () {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
};

/**
 * Collects observation instances the associated element of which has changed
 * it's content rectangle.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.gatherActive = function () {
        var this$1 = this;

    this.clearActive();

    this.observations_.forEach(function (observation) {
        if (observation.isActive()) {
            this$1.activeObservations_.push(observation);
        }
    });
};

/**
 * Invokes initial callback function with a list of ResizeObserverEntry
 * instances collected from active resize observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.broadcastActive = function () {
    // Do nothing if observer doesn't have active observations.
    if (!this.hasActive()) {
        return;
    }

    var ctx = this.callbackCtx_;

    // Create ResizeObserverEntry instance for every active observation.
    var entries = this.activeObservations_.map(function (observation) {
        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });

    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
};

/**
 * Clears the collection of active observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.clearActive = function () {
    this.activeObservations_.splice(0);
};

/**
 * Tells whether observer has active observations.
 *
 * @returns {boolean}
 */
ResizeObserverSPI.prototype.hasActive = function () {
    return this.activeObservations_.length > 0;
};

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();

/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = function(callback) {
    if (!(this instanceof ResizeObserver)) {
        throw new TypeError('Cannot call a class as a function.');
    }
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);

    observers.set(this, observer);
};

// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        return (ref = observers.get(this))[method].apply(ref, arguments);
        var ref;
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }

    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(74)))

/***/ }),
/* 2740 */
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),
/* 2741 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74), __webpack_require__(408)))

/***/ }),
/* 2742 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["sourceMappedStackTrace"] = factory();
	else
		root["sourceMappedStackTrace"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * sourcemapped-stacktrace.js
	 * created by James Salter <iteration@gmail.com> (2014)
	 *
	 * https://github.com/novocaine/sourcemapped-stacktrace
	 *
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */

	/*global define */

	// note we only include source-map-consumer, not the whole source-map library,
	// which includes gear for generating source maps that we don't need
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function(source_map_consumer) {

	  var global_mapForUri = {};

	  /**
	   * Re-map entries in a stacktrace using sourcemaps if available.
	   *
	   * @param {Array} stack - Array of strings from the browser's stack
	   *                        representation. Currently only Chrome
	   *                        format is supported.
	   * @param {function} done - Callback invoked with the transformed stacktrace
	   *                          (an Array of Strings) passed as the first
	   *                          argument
	   * @param {Object} [opts] - Optional options object.
	   * @param {Function} [opts.filter] - Filter function applied to each stackTrace line.
	   *                                   Lines which do not pass the filter won't be processesd.
	   * @param {boolean} [opts.cacheGlobally] - Whether to cache sourcemaps globally across multiple calls.
	   */
	  var mapStackTrace = function(stack, done, opts) {
	    var lines;
	    var line;
	    var mapForUri = {};
	    var rows = {};
	    var fields;
	    var uri;
	    var expected_fields;
	    var regex;
	    var skip_lines;

	    var fetcher = new Fetcher(function() {
	      var result = processSourceMaps(lines, rows, fetcher.mapForUri);
	      done(result);
	    }, opts);

	    if (isChromeOrEdge() || isIE11Plus()) {
	      regex = /^ +at.+\((.*):([0-9]+):([0-9]+)/;
	      expected_fields = 4;
	      // (skip first line containing exception message)
	      skip_lines = 1;
	    } else if (isFirefox() || isSafari()) {
	      regex = /@(.*):([0-9]+):([0-9]+)/;
	      expected_fields = 4;
	      skip_lines = 0;
	    } else {
	      throw new Error("unknown browser :(");
	    }

	    lines = stack.split("\n").slice(skip_lines);

	    for (var i=0; i < lines.length; i++) {
	      line = lines[i];
	      if ( opts && opts.filter && !opts.filter(line) ) continue;
	      
	      fields = line.match(regex);
	      if (fields && fields.length === expected_fields) {
	        rows[i] = fields;
	        uri = fields[1];
	        if (!uri.match(/<anonymous>/)) {
	          fetcher.fetchScript(uri);
	        }
	      }
	    }

	    // if opts.cacheGlobally set, all maps could have been cached already,
	    // thus we need to call done callback right away
	    if ( fetcher.sem === 0 ) {
	      fetcher.done(fetcher.mapForUri);
	    }
	  };

	  var isChromeOrEdge = function() {
	    return navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
	  };

	  var isFirefox = function() {
	    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
	  };  

	  var isSafari = function() {
	    return navigator.userAgent.toLowerCase().indexOf('safari') > -1;
	  };
			
	  var isIE11Plus = function() {
	   	return document.documentMode && document.documentMode >= 11;
	  };

	  var Fetcher = function(done, opts) {
	    this.sem = 0;
	    this.mapForUri = opts && opts.cacheGlobally ? global_mapForUri : {};
	    this.done = done;
	  };

	  Fetcher.prototype.fetchScript = function(uri) {
	    if (!(uri in this.mapForUri)) {
	      this.sem++;
	      this.mapForUri[uri] = null;
	    } else {
	      return;
	    }

	    var xhr = createXMLHTTPObject();
	    var that = this;
	    xhr.onreadystatechange = function(e) {
	      that.onScriptLoad.call(that, e, uri);
	    };
	    xhr.open("GET", uri, true);
	    xhr.send();
	  };

	  var absUrlRegex = new RegExp('^(?:[a-z]+:)?//', 'i');

	  Fetcher.prototype.onScriptLoad = function(e, uri) {
	    if (e.target.readyState !== 4) {
	      return;
	    }

	    if (e.target.status === 200 ||
	      (uri.slice(0, 7) === "file://" && e.target.status === 0))
	    {
	      // find .map in file.
	      //
	      // attempt to find it at the very end of the file, but tolerate trailing
	      // whitespace inserted by some packers.
	      var match = e.target.responseText.match("//# [s]ourceMappingURL=(.*)[\\s]*$", "m");
	      if (match && match.length === 2) {
	        // get the map
	        var mapUri = match[1];

	        var embeddedSourceMap = mapUri.match("data:application/json;(charset=[^;]+;)?base64,(.*)");

	        if (embeddedSourceMap && embeddedSourceMap[2]) {
	          this.mapForUri[uri] = new source_map_consumer.SourceMapConsumer(atob(embeddedSourceMap[2]));
	          this.done(this.mapForUri);
	        } else {
	          if (!absUrlRegex.test(mapUri)) {
	            // relative url; according to sourcemaps spec is 'source origin'
	            var origin;
	            var lastSlash = uri.lastIndexOf('/');
	            if (lastSlash !== -1) {
	              origin = uri.slice(0, lastSlash + 1);
	              mapUri = origin + mapUri;
	              // note if lastSlash === -1, actual script uri has no slash
	              // somehow, so no way to use it as a prefix... we give up and try
	              // as absolute
	            }
	          }

	          var xhrMap = createXMLHTTPObject();
	          var that = this;
	          xhrMap.onreadystatechange = function() {
	            if (xhrMap.readyState === 4) {
	              that.sem--;
	              if (xhrMap.status === 200 ||
	                (mapUri.slice(0, 7) === "file://" && xhrMap.status === 0)) {
	                that.mapForUri[uri] = new source_map_consumer.SourceMapConsumer(xhrMap.responseText);
	              }
	              if (that.sem === 0) {
	                that.done(that.mapForUri);
	              }
	            }
	          };

	          xhrMap.open("GET", mapUri, true);
	          xhrMap.send();
	        }
	      } else {
	        // no map
	        this.sem--;
	      }
	    } else {
	      // HTTP error fetching uri of the script
	      this.sem--;
	    }

	    if (this.sem === 0) {
	      this.done(this.mapForUri);
	    }
	  };

	  var processSourceMaps = function(lines, rows, mapForUri) {
	    var result = [];
	    var map;
	    for (var i=0; i < lines.length; i++) {
	      var row = rows[i];
	      if (row) {
	        var uri = row[1];
	        var line = parseInt(row[2], 10);
	        var column = parseInt(row[3], 10);
	        map = mapForUri[uri];

	        if (map) {
	          // we think we have a map for that uri. call source-map library
	          var origPos = map.originalPositionFor(
	            { line: line, column: column });
	          result.push(formatOriginalPosition(origPos.source,
	            origPos.line, origPos.column, origPos.name || origName(lines[i])));
	        } else {
	          // we can't find a map for that url, but we parsed the row.
	          // reformat unchanged line for consistency with the sourcemapped
	          // lines.
	          result.push(formatOriginalPosition(uri, line, column, origName(lines[i])));
	        }
	      } else {
	        // we weren't able to parse the row, push back what we were given
	        result.push(lines[i]);
	      }
	    }

	    return result;
	  };

	  function origName(origLine) {
	    var match = String(origLine).match((isChromeOrEdge() || isIE11Plus()) ?
	      / +at +([^ ]*).*/ :
	      /([^@]*)@.*/);
	    return match && match[1];
	  }

	  var formatOriginalPosition = function(source, line, column, name) {
	    // mimic chrome's format
	    return "    at " + (name ? name : "(unknown)") +
	      " (" + source + ":" + line + ":" + column + ")";
	  };

	  // xmlhttprequest boilerplate
	  var XMLHttpFactories = [
		function () {return new XMLHttpRequest();},
		function () {return new ActiveXObject("Msxml2.XMLHTTP");},
		function () {return new ActiveXObject("Msxml3.XMLHTTP");},
		function () {return new ActiveXObject("Microsoft.XMLHTTP");}
	  ];

	  function createXMLHTTPObject() {
	      var xmlhttp = false;
	      for (var i=0;i<XMLHttpFactories.length;i++) {
	          try {
	              xmlhttp = XMLHttpFactories[i]();
	          }
	          catch (e) {
	              continue;
	          }
	          break;
	      }
	      return xmlhttp;
	  }

	  return {
	    mapStackTrace: mapStackTrace
	  }
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */

	var util = __webpack_require__(2);
	var binarySearch = __webpack_require__(3);
	var ArraySet = __webpack_require__(4).ArraySet;
	var base64VLQ = __webpack_require__(5);
	var quickSort = __webpack_require__(7).quickSort;

	function SourceMapConsumer(aSourceMap) {
	  var sourceMap = aSourceMap;
	  if (typeof aSourceMap === 'string') {
	    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
	  }

	  return sourceMap.sections != null
	    ? new IndexedSourceMapConsumer(sourceMap)
	    : new BasicSourceMapConsumer(sourceMap);
	}

	SourceMapConsumer.fromSourceMap = function(aSourceMap) {
	  return BasicSourceMapConsumer.fromSourceMap(aSourceMap);
	}

	/**
	 * The version of the source mapping spec that we are consuming.
	 */
	SourceMapConsumer.prototype._version = 3;

	// `__generatedMappings` and `__originalMappings` are arrays that hold the
	// parsed mapping coordinates from the source map's "mappings" attribute. They
	// are lazily instantiated, accessed via the `_generatedMappings` and
	// `_originalMappings` getters respectively, and we only parse the mappings
	// and create these arrays once queried for a source location. We jump through
	// these hoops because there can be many thousands of mappings, and parsing
	// them is expensive, so we only want to do it if we must.
	//
	// Each object in the arrays is of the form:
	//
	//     {
	//       generatedLine: The line number in the generated code,
	//       generatedColumn: The column number in the generated code,
	//       source: The path to the original source file that generated this
	//               chunk of code,
	//       originalLine: The line number in the original source that
	//                     corresponds to this chunk of generated code,
	//       originalColumn: The column number in the original source that
	//                       corresponds to this chunk of generated code,
	//       name: The name of the original symbol which generated this chunk of
	//             code.
	//     }
	//
	// All properties except for `generatedLine` and `generatedColumn` can be
	// `null`.
	//
	// `_generatedMappings` is ordered by the generated positions.
	//
	// `_originalMappings` is ordered by the original positions.

	SourceMapConsumer.prototype.__generatedMappings = null;
	Object.defineProperty(SourceMapConsumer.prototype, '_generatedMappings', {
	  get: function () {
	    if (!this.__generatedMappings) {
	      this._parseMappings(this._mappings, this.sourceRoot);
	    }

	    return this.__generatedMappings;
	  }
	});

	SourceMapConsumer.prototype.__originalMappings = null;
	Object.defineProperty(SourceMapConsumer.prototype, '_originalMappings', {
	  get: function () {
	    if (!this.__originalMappings) {
	      this._parseMappings(this._mappings, this.sourceRoot);
	    }

	    return this.__originalMappings;
	  }
	});

	SourceMapConsumer.prototype._charIsMappingSeparator =
	  function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
	    var c = aStr.charAt(index);
	    return c === ";" || c === ",";
	  };

	/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */
	SourceMapConsumer.prototype._parseMappings =
	  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
	    throw new Error("Subclasses must implement _parseMappings");
	  };

	SourceMapConsumer.GENERATED_ORDER = 1;
	SourceMapConsumer.ORIGINAL_ORDER = 2;

	SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
	SourceMapConsumer.LEAST_UPPER_BOUND = 2;

	/**
	 * Iterate over each mapping between an original source/line/column and a
	 * generated line/column in this source map.
	 *
	 * @param Function aCallback
	 *        The function that is called with each mapping.
	 * @param Object aContext
	 *        Optional. If specified, this object will be the value of `this` every
	 *        time that `aCallback` is called.
	 * @param aOrder
	 *        Either `SourceMapConsumer.GENERATED_ORDER` or
	 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
	 *        iterate over the mappings sorted by the generated file's line/column
	 *        order or the original's source/line/column order, respectively. Defaults to
	 *        `SourceMapConsumer.GENERATED_ORDER`.
	 */
	SourceMapConsumer.prototype.eachMapping =
	  function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
	    var context = aContext || null;
	    var order = aOrder || SourceMapConsumer.GENERATED_ORDER;

	    var mappings;
	    switch (order) {
	    case SourceMapConsumer.GENERATED_ORDER:
	      mappings = this._generatedMappings;
	      break;
	    case SourceMapConsumer.ORIGINAL_ORDER:
	      mappings = this._originalMappings;
	      break;
	    default:
	      throw new Error("Unknown order of iteration.");
	    }

	    var sourceRoot = this.sourceRoot;
	    mappings.map(function (mapping) {
	      var source = mapping.source === null ? null : this._sources.at(mapping.source);
	      if (source != null && sourceRoot != null) {
	        source = util.join(sourceRoot, source);
	      }
	      return {
	        source: source,
	        generatedLine: mapping.generatedLine,
	        generatedColumn: mapping.generatedColumn,
	        originalLine: mapping.originalLine,
	        originalColumn: mapping.originalColumn,
	        name: mapping.name === null ? null : this._names.at(mapping.name)
	      };
	    }, this).forEach(aCallback, context);
	  };

	/**
	 * Returns all generated line and column information for the original source,
	 * line, and column provided. If no column is provided, returns all mappings
	 * corresponding to a either the line we are searching for or the next
	 * closest line that has any mappings. Otherwise, returns all mappings
	 * corresponding to the given line and either the column we are searching for
	 * or the next closest column that has any offsets.
	 *
	 * The only argument is an object with the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.
	 *   - column: Optional. the column number in the original source.
	 *
	 * and an array of objects is returned, each with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.
	 *   - column: The column number in the generated source, or null.
	 */
	SourceMapConsumer.prototype.allGeneratedPositionsFor =
	  function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
	    var line = util.getArg(aArgs, 'line');

	    // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
	    // returns the index of the closest mapping less than the needle. By
	    // setting needle.originalColumn to 0, we thus find the last mapping for
	    // the given line, provided such a mapping exists.
	    var needle = {
	      source: util.getArg(aArgs, 'source'),
	      originalLine: line,
	      originalColumn: util.getArg(aArgs, 'column', 0)
	    };

	    if (this.sourceRoot != null) {
	      needle.source = util.relative(this.sourceRoot, needle.source);
	    }
	    if (!this._sources.has(needle.source)) {
	      return [];
	    }
	    needle.source = this._sources.indexOf(needle.source);

	    var mappings = [];

	    var index = this._findMapping(needle,
	                                  this._originalMappings,
	                                  "originalLine",
	                                  "originalColumn",
	                                  util.compareByOriginalPositions,
	                                  binarySearch.LEAST_UPPER_BOUND);
	    if (index >= 0) {
	      var mapping = this._originalMappings[index];

	      if (aArgs.column === undefined) {
	        var originalLine = mapping.originalLine;

	        // Iterate until either we run out of mappings, or we run into
	        // a mapping for a different line than the one we found. Since
	        // mappings are sorted, this is guaranteed to find all mappings for
	        // the line we found.
	        while (mapping && mapping.originalLine === originalLine) {
	          mappings.push({
	            line: util.getArg(mapping, 'generatedLine', null),
	            column: util.getArg(mapping, 'generatedColumn', null),
	            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
	          });

	          mapping = this._originalMappings[++index];
	        }
	      } else {
	        var originalColumn = mapping.originalColumn;

	        // Iterate until either we run out of mappings, or we run into
	        // a mapping for a different line than the one we were searching for.
	        // Since mappings are sorted, this is guaranteed to find all mappings for
	        // the line we are searching for.
	        while (mapping &&
	               mapping.originalLine === line &&
	               mapping.originalColumn == originalColumn) {
	          mappings.push({
	            line: util.getArg(mapping, 'generatedLine', null),
	            column: util.getArg(mapping, 'generatedColumn', null),
	            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
	          });

	          mapping = this._originalMappings[++index];
	        }
	      }
	    }

	    return mappings;
	  };

	exports.SourceMapConsumer = SourceMapConsumer;

	/**
	 * A BasicSourceMapConsumer instance represents a parsed source map which we can
	 * query for information about the original file positions by giving it a file
	 * position in the generated source.
	 *
	 * The only parameter is the raw source map (either as a JSON string, or
	 * already parsed to an object). According to the spec, source maps have the
	 * following attributes:
	 *
	 *   - version: Which version of the source map spec this map is following.
	 *   - sources: An array of URLs to the original source files.
	 *   - names: An array of identifiers which can be referrenced by individual mappings.
	 *   - sourceRoot: Optional. The URL root from which all sources are relative.
	 *   - sourcesContent: Optional. An array of contents of the original source files.
	 *   - mappings: A string of base64 VLQs which contain the actual mappings.
	 *   - file: Optional. The generated file this source map is associated with.
	 *
	 * Here is an example source map, taken from the source map spec[0]:
	 *
	 *     {
	 *       version : 3,
	 *       file: "out.js",
	 *       sourceRoot : "",
	 *       sources: ["foo.js", "bar.js"],
	 *       names: ["src", "maps", "are", "fun"],
	 *       mappings: "AA,AB;;ABCDE;"
	 *     }
	 *
	 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
	 */
	function BasicSourceMapConsumer(aSourceMap) {
	  var sourceMap = aSourceMap;
	  if (typeof aSourceMap === 'string') {
	    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
	  }

	  var version = util.getArg(sourceMap, 'version');
	  var sources = util.getArg(sourceMap, 'sources');
	  // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
	  // requires the array) to play nice here.
	  var names = util.getArg(sourceMap, 'names', []);
	  var sourceRoot = util.getArg(sourceMap, 'sourceRoot', null);
	  var sourcesContent = util.getArg(sourceMap, 'sourcesContent', null);
	  var mappings = util.getArg(sourceMap, 'mappings');
	  var file = util.getArg(sourceMap, 'file', null);

	  // Once again, Sass deviates from the spec and supplies the version as a
	  // string rather than a number, so we use loose equality checking here.
	  if (version != this._version) {
	    throw new Error('Unsupported version: ' + version);
	  }

	  sources = sources
	    .map(String)
	    // Some source maps produce relative source paths like "./foo.js" instead of
	    // "foo.js".  Normalize these first so that future comparisons will succeed.
	    // See bugzil.la/1090768.
	    .map(util.normalize)
	    // Always ensure that absolute sources are internally stored relative to
	    // the source root, if the source root is absolute. Not doing this would
	    // be particularly problematic when the source root is a prefix of the
	    // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
	    .map(function (source) {
	      return sourceRoot && util.isAbsolute(sourceRoot) && util.isAbsolute(source)
	        ? util.relative(sourceRoot, source)
	        : source;
	    });

	  // Pass `true` below to allow duplicate names and sources. While source maps
	  // are intended to be compressed and deduplicated, the TypeScript compiler
	  // sometimes generates source maps with duplicates in them. See Github issue
	  // #72 and bugzil.la/889492.
	  this._names = ArraySet.fromArray(names.map(String), true);
	  this._sources = ArraySet.fromArray(sources, true);

	  this.sourceRoot = sourceRoot;
	  this.sourcesContent = sourcesContent;
	  this._mappings = mappings;
	  this.file = file;
	}

	BasicSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
	BasicSourceMapConsumer.prototype.consumer = SourceMapConsumer;

	/**
	 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
	 *
	 * @param SourceMapGenerator aSourceMap
	 *        The source map that will be consumed.
	 * @returns BasicSourceMapConsumer
	 */
	BasicSourceMapConsumer.fromSourceMap =
	  function SourceMapConsumer_fromSourceMap(aSourceMap) {
	    var smc = Object.create(BasicSourceMapConsumer.prototype);

	    var names = smc._names = ArraySet.fromArray(aSourceMap._names.toArray(), true);
	    var sources = smc._sources = ArraySet.fromArray(aSourceMap._sources.toArray(), true);
	    smc.sourceRoot = aSourceMap._sourceRoot;
	    smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(),
	                                                            smc.sourceRoot);
	    smc.file = aSourceMap._file;

	    // Because we are modifying the entries (by converting string sources and
	    // names to indices into the sources and names ArraySets), we have to make
	    // a copy of the entry or else bad things happen. Shared mutable state
	    // strikes again! See github issue #191.

	    var generatedMappings = aSourceMap._mappings.toArray().slice();
	    var destGeneratedMappings = smc.__generatedMappings = [];
	    var destOriginalMappings = smc.__originalMappings = [];

	    for (var i = 0, length = generatedMappings.length; i < length; i++) {
	      var srcMapping = generatedMappings[i];
	      var destMapping = new Mapping;
	      destMapping.generatedLine = srcMapping.generatedLine;
	      destMapping.generatedColumn = srcMapping.generatedColumn;

	      if (srcMapping.source) {
	        destMapping.source = sources.indexOf(srcMapping.source);
	        destMapping.originalLine = srcMapping.originalLine;
	        destMapping.originalColumn = srcMapping.originalColumn;

	        if (srcMapping.name) {
	          destMapping.name = names.indexOf(srcMapping.name);
	        }

	        destOriginalMappings.push(destMapping);
	      }

	      destGeneratedMappings.push(destMapping);
	    }

	    quickSort(smc.__originalMappings, util.compareByOriginalPositions);

	    return smc;
	  };

	/**
	 * The version of the source mapping spec that we are consuming.
	 */
	BasicSourceMapConsumer.prototype._version = 3;

	/**
	 * The list of original sources.
	 */
	Object.defineProperty(BasicSourceMapConsumer.prototype, 'sources', {
	  get: function () {
	    return this._sources.toArray().map(function (s) {
	      return this.sourceRoot != null ? util.join(this.sourceRoot, s) : s;
	    }, this);
	  }
	});

	/**
	 * Provide the JIT with a nice shape / hidden class.
	 */
	function Mapping() {
	  this.generatedLine = 0;
	  this.generatedColumn = 0;
	  this.source = null;
	  this.originalLine = null;
	  this.originalColumn = null;
	  this.name = null;
	}

	/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */
	BasicSourceMapConsumer.prototype._parseMappings =
	  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
	    var generatedLine = 1;
	    var previousGeneratedColumn = 0;
	    var previousOriginalLine = 0;
	    var previousOriginalColumn = 0;
	    var previousSource = 0;
	    var previousName = 0;
	    var length = aStr.length;
	    var index = 0;
	    var cachedSegments = {};
	    var temp = {};
	    var originalMappings = [];
	    var generatedMappings = [];
	    var mapping, str, segment, end, value;

	    while (index < length) {
	      if (aStr.charAt(index) === ';') {
	        generatedLine++;
	        index++;
	        previousGeneratedColumn = 0;
	      }
	      else if (aStr.charAt(index) === ',') {
	        index++;
	      }
	      else {
	        mapping = new Mapping();
	        mapping.generatedLine = generatedLine;

	        // Because each offset is encoded relative to the previous one,
	        // many segments often have the same encoding. We can exploit this
	        // fact by caching the parsed variable length fields of each segment,
	        // allowing us to avoid a second parse if we encounter the same
	        // segment again.
	        for (end = index; end < length; end++) {
	          if (this._charIsMappingSeparator(aStr, end)) {
	            break;
	          }
	        }
	        str = aStr.slice(index, end);

	        segment = cachedSegments[str];
	        if (segment) {
	          index += str.length;
	        } else {
	          segment = [];
	          while (index < end) {
	            base64VLQ.decode(aStr, index, temp);
	            value = temp.value;
	            index = temp.rest;
	            segment.push(value);
	          }

	          if (segment.length === 2) {
	            throw new Error('Found a source, but no line and column');
	          }

	          if (segment.length === 3) {
	            throw new Error('Found a source and line, but no column');
	          }

	          cachedSegments[str] = segment;
	        }

	        // Generated column.
	        mapping.generatedColumn = previousGeneratedColumn + segment[0];
	        previousGeneratedColumn = mapping.generatedColumn;

	        if (segment.length > 1) {
	          // Original source.
	          mapping.source = previousSource + segment[1];
	          previousSource += segment[1];

	          // Original line.
	          mapping.originalLine = previousOriginalLine + segment[2];
	          previousOriginalLine = mapping.originalLine;
	          // Lines are stored 0-based
	          mapping.originalLine += 1;

	          // Original column.
	          mapping.originalColumn = previousOriginalColumn + segment[3];
	          previousOriginalColumn = mapping.originalColumn;

	          if (segment.length > 4) {
	            // Original name.
	            mapping.name = previousName + segment[4];
	            previousName += segment[4];
	          }
	        }

	        generatedMappings.push(mapping);
	        if (typeof mapping.originalLine === 'number') {
	          originalMappings.push(mapping);
	        }
	      }
	    }

	    quickSort(generatedMappings, util.compareByGeneratedPositionsDeflated);
	    this.__generatedMappings = generatedMappings;

	    quickSort(originalMappings, util.compareByOriginalPositions);
	    this.__originalMappings = originalMappings;
	  };

	/**
	 * Find the mapping that best matches the hypothetical "needle" mapping that
	 * we are searching for in the given "haystack" of mappings.
	 */
	BasicSourceMapConsumer.prototype._findMapping =
	  function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName,
	                                         aColumnName, aComparator, aBias) {
	    // To return the position we are searching for, we must first find the
	    // mapping for the given position and then return the opposite position it
	    // points to. Because the mappings are sorted, we can use binary search to
	    // find the best mapping.

	    if (aNeedle[aLineName] <= 0) {
	      throw new TypeError('Line must be greater than or equal to 1, got '
	                          + aNeedle[aLineName]);
	    }
	    if (aNeedle[aColumnName] < 0) {
	      throw new TypeError('Column must be greater than or equal to 0, got '
	                          + aNeedle[aColumnName]);
	    }

	    return binarySearch.search(aNeedle, aMappings, aComparator, aBias);
	  };

	/**
	 * Compute the last column for each generated mapping. The last column is
	 * inclusive.
	 */
	BasicSourceMapConsumer.prototype.computeColumnSpans =
	  function SourceMapConsumer_computeColumnSpans() {
	    for (var index = 0; index < this._generatedMappings.length; ++index) {
	      var mapping = this._generatedMappings[index];

	      // Mappings do not contain a field for the last generated columnt. We
	      // can come up with an optimistic estimate, however, by assuming that
	      // mappings are contiguous (i.e. given two consecutive mappings, the
	      // first mapping ends where the second one starts).
	      if (index + 1 < this._generatedMappings.length) {
	        var nextMapping = this._generatedMappings[index + 1];

	        if (mapping.generatedLine === nextMapping.generatedLine) {
	          mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
	          continue;
	        }
	      }

	      // The last mapping for each line spans the entire line.
	      mapping.lastGeneratedColumn = Infinity;
	    }
	  };

	/**
	 * Returns the original source, line, and column information for the generated
	 * source's line and column positions provided. The only argument is an object
	 * with the following properties:
	 *
	 *   - line: The line number in the generated source.
	 *   - column: The column number in the generated source.
	 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
	 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - source: The original source file, or null.
	 *   - line: The line number in the original source, or null.
	 *   - column: The column number in the original source, or null.
	 *   - name: The original identifier, or null.
	 */
	BasicSourceMapConsumer.prototype.originalPositionFor =
	  function SourceMapConsumer_originalPositionFor(aArgs) {
	    var needle = {
	      generatedLine: util.getArg(aArgs, 'line'),
	      generatedColumn: util.getArg(aArgs, 'column')
	    };

	    var index = this._findMapping(
	      needle,
	      this._generatedMappings,
	      "generatedLine",
	      "generatedColumn",
	      util.compareByGeneratedPositionsDeflated,
	      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
	    );

	    if (index >= 0) {
	      var mapping = this._generatedMappings[index];

	      if (mapping.generatedLine === needle.generatedLine) {
	        var source = util.getArg(mapping, 'source', null);
	        if (source !== null) {
	          source = this._sources.at(source);
	          if (this.sourceRoot != null) {
	            source = util.join(this.sourceRoot, source);
	          }
	        }
	        var name = util.getArg(mapping, 'name', null);
	        if (name !== null) {
	          name = this._names.at(name);
	        }
	        return {
	          source: source,
	          line: util.getArg(mapping, 'originalLine', null),
	          column: util.getArg(mapping, 'originalColumn', null),
	          name: name
	        };
	      }
	    }

	    return {
	      source: null,
	      line: null,
	      column: null,
	      name: null
	    };
	  };

	/**
	 * Return true if we have the source content for every source in the source
	 * map, false otherwise.
	 */
	BasicSourceMapConsumer.prototype.hasContentsOfAllSources =
	  function BasicSourceMapConsumer_hasContentsOfAllSources() {
	    if (!this.sourcesContent) {
	      return false;
	    }
	    return this.sourcesContent.length >= this._sources.size() &&
	      !this.sourcesContent.some(function (sc) { return sc == null; });
	  };

	/**
	 * Returns the original source content. The only argument is the url of the
	 * original source file. Returns null if no original source content is
	 * available.
	 */
	BasicSourceMapConsumer.prototype.sourceContentFor =
	  function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
	    if (!this.sourcesContent) {
	      return null;
	    }

	    if (this.sourceRoot != null) {
	      aSource = util.relative(this.sourceRoot, aSource);
	    }

	    if (this._sources.has(aSource)) {
	      return this.sourcesContent[this._sources.indexOf(aSource)];
	    }

	    var url;
	    if (this.sourceRoot != null
	        && (url = util.urlParse(this.sourceRoot))) {
	      // XXX: file:// URIs and absolute paths lead to unexpected behavior for
	      // many users. We can help them out when they expect file:// URIs to
	      // behave like it would if they were running a local HTTP server. See
	      // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
	      var fileUriAbsPath = aSource.replace(/^file:\/\//, "");
	      if (url.scheme == "file"
	          && this._sources.has(fileUriAbsPath)) {
	        return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)]
	      }

	      if ((!url.path || url.path == "/")
	          && this._sources.has("/" + aSource)) {
	        return this.sourcesContent[this._sources.indexOf("/" + aSource)];
	      }
	    }

	    // This function is used recursively from
	    // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
	    // don't want to throw if we can't find the source - we just want to
	    // return null, so we provide a flag to exit gracefully.
	    if (nullOnMissing) {
	      return null;
	    }
	    else {
	      throw new Error('"' + aSource + '" is not in the SourceMap.');
	    }
	  };

	/**
	 * Returns the generated line and column information for the original source,
	 * line, and column positions provided. The only argument is an object with
	 * the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.
	 *   - column: The column number in the original source.
	 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
	 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.
	 *   - column: The column number in the generated source, or null.
	 */
	BasicSourceMapConsumer.prototype.generatedPositionFor =
	  function SourceMapConsumer_generatedPositionFor(aArgs) {
	    var source = util.getArg(aArgs, 'source');
	    if (this.sourceRoot != null) {
	      source = util.relative(this.sourceRoot, source);
	    }
	    if (!this._sources.has(source)) {
	      return {
	        line: null,
	        column: null,
	        lastColumn: null
	      };
	    }
	    source = this._sources.indexOf(source);

	    var needle = {
	      source: source,
	      originalLine: util.getArg(aArgs, 'line'),
	      originalColumn: util.getArg(aArgs, 'column')
	    };

	    var index = this._findMapping(
	      needle,
	      this._originalMappings,
	      "originalLine",
	      "originalColumn",
	      util.compareByOriginalPositions,
	      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
	    );

	    if (index >= 0) {
	      var mapping = this._originalMappings[index];

	      if (mapping.source === needle.source) {
	        return {
	          line: util.getArg(mapping, 'generatedLine', null),
	          column: util.getArg(mapping, 'generatedColumn', null),
	          lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
	        };
	      }
	    }

	    return {
	      line: null,
	      column: null,
	      lastColumn: null
	    };
	  };

	exports.BasicSourceMapConsumer = BasicSourceMapConsumer;

	/**
	 * An IndexedSourceMapConsumer instance represents a parsed source map which
	 * we can query for information. It differs from BasicSourceMapConsumer in
	 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
	 * input.
	 *
	 * The only parameter is a raw source map (either as a JSON string, or already
	 * parsed to an object). According to the spec for indexed source maps, they
	 * have the following attributes:
	 *
	 *   - version: Which version of the source map spec this map is following.
	 *   - file: Optional. The generated file this source map is associated with.
	 *   - sections: A list of section definitions.
	 *
	 * Each value under the "sections" field has two fields:
	 *   - offset: The offset into the original specified at which this section
	 *       begins to apply, defined as an object with a "line" and "column"
	 *       field.
	 *   - map: A source map definition. This source map could also be indexed,
	 *       but doesn't have to be.
	 *
	 * Instead of the "map" field, it's also possible to have a "url" field
	 * specifying a URL to retrieve a source map from, but that's currently
	 * unsupported.
	 *
	 * Here's an example source map, taken from the source map spec[0], but
	 * modified to omit a section which uses the "url" field.
	 *
	 *  {
	 *    version : 3,
	 *    file: "app.js",
	 *    sections: [{
	 *      offset: {line:100, column:10},
	 *      map: {
	 *        version : 3,
	 *        file: "section.js",
	 *        sources: ["foo.js", "bar.js"],
	 *        names: ["src", "maps", "are", "fun"],
	 *        mappings: "AAAA,E;;ABCDE;"
	 *      }
	 *    }],
	 *  }
	 *
	 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
	 */
	function IndexedSourceMapConsumer(aSourceMap) {
	  var sourceMap = aSourceMap;
	  if (typeof aSourceMap === 'string') {
	    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
	  }

	  var version = util.getArg(sourceMap, 'version');
	  var sections = util.getArg(sourceMap, 'sections');

	  if (version != this._version) {
	    throw new Error('Unsupported version: ' + version);
	  }

	  this._sources = new ArraySet();
	  this._names = new ArraySet();

	  var lastOffset = {
	    line: -1,
	    column: 0
	  };
	  this._sections = sections.map(function (s) {
	    if (s.url) {
	      // The url field will require support for asynchronicity.
	      // See https://github.com/mozilla/source-map/issues/16
	      throw new Error('Support for url field in sections not implemented.');
	    }
	    var offset = util.getArg(s, 'offset');
	    var offsetLine = util.getArg(offset, 'line');
	    var offsetColumn = util.getArg(offset, 'column');

	    if (offsetLine < lastOffset.line ||
	        (offsetLine === lastOffset.line && offsetColumn < lastOffset.column)) {
	      throw new Error('Section offsets must be ordered and non-overlapping.');
	    }
	    lastOffset = offset;

	    return {
	      generatedOffset: {
	        // The offset fields are 0-based, but we use 1-based indices when
	        // encoding/decoding from VLQ.
	        generatedLine: offsetLine + 1,
	        generatedColumn: offsetColumn + 1
	      },
	      consumer: new SourceMapConsumer(util.getArg(s, 'map'))
	    }
	  });
	}

	IndexedSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
	IndexedSourceMapConsumer.prototype.constructor = SourceMapConsumer;

	/**
	 * The version of the source mapping spec that we are consuming.
	 */
	IndexedSourceMapConsumer.prototype._version = 3;

	/**
	 * The list of original sources.
	 */
	Object.defineProperty(IndexedSourceMapConsumer.prototype, 'sources', {
	  get: function () {
	    var sources = [];
	    for (var i = 0; i < this._sections.length; i++) {
	      for (var j = 0; j < this._sections[i].consumer.sources.length; j++) {
	        sources.push(this._sections[i].consumer.sources[j]);
	      }
	    }
	    return sources;
	  }
	});

	/**
	 * Returns the original source, line, and column information for the generated
	 * source's line and column positions provided. The only argument is an object
	 * with the following properties:
	 *
	 *   - line: The line number in the generated source.
	 *   - column: The column number in the generated source.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - source: The original source file, or null.
	 *   - line: The line number in the original source, or null.
	 *   - column: The column number in the original source, or null.
	 *   - name: The original identifier, or null.
	 */
	IndexedSourceMapConsumer.prototype.originalPositionFor =
	  function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
	    var needle = {
	      generatedLine: util.getArg(aArgs, 'line'),
	      generatedColumn: util.getArg(aArgs, 'column')
	    };

	    // Find the section containing the generated position we're trying to map
	    // to an original position.
	    var sectionIndex = binarySearch.search(needle, this._sections,
	      function(needle, section) {
	        var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
	        if (cmp) {
	          return cmp;
	        }

	        return (needle.generatedColumn -
	                section.generatedOffset.generatedColumn);
	      });
	    var section = this._sections[sectionIndex];

	    if (!section) {
	      return {
	        source: null,
	        line: null,
	        column: null,
	        name: null
	      };
	    }

	    return section.consumer.originalPositionFor({
	      line: needle.generatedLine -
	        (section.generatedOffset.generatedLine - 1),
	      column: needle.generatedColumn -
	        (section.generatedOffset.generatedLine === needle.generatedLine
	         ? section.generatedOffset.generatedColumn - 1
	         : 0),
	      bias: aArgs.bias
	    });
	  };

	/**
	 * Return true if we have the source content for every source in the source
	 * map, false otherwise.
	 */
	IndexedSourceMapConsumer.prototype.hasContentsOfAllSources =
	  function IndexedSourceMapConsumer_hasContentsOfAllSources() {
	    return this._sections.every(function (s) {
	      return s.consumer.hasContentsOfAllSources();
	    });
	  };

	/**
	 * Returns the original source content. The only argument is the url of the
	 * original source file. Returns null if no original source content is
	 * available.
	 */
	IndexedSourceMapConsumer.prototype.sourceContentFor =
	  function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
	    for (var i = 0; i < this._sections.length; i++) {
	      var section = this._sections[i];

	      var content = section.consumer.sourceContentFor(aSource, true);
	      if (content) {
	        return content;
	      }
	    }
	    if (nullOnMissing) {
	      return null;
	    }
	    else {
	      throw new Error('"' + aSource + '" is not in the SourceMap.');
	    }
	  };

	/**
	 * Returns the generated line and column information for the original source,
	 * line, and column positions provided. The only argument is an object with
	 * the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.
	 *   - column: The column number in the original source.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.
	 *   - column: The column number in the generated source, or null.
	 */
	IndexedSourceMapConsumer.prototype.generatedPositionFor =
	  function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
	    for (var i = 0; i < this._sections.length; i++) {
	      var section = this._sections[i];

	      // Only consider this section if the requested source is in the list of
	      // sources of the consumer.
	      if (section.consumer.sources.indexOf(util.getArg(aArgs, 'source')) === -1) {
	        continue;
	      }
	      var generatedPosition = section.consumer.generatedPositionFor(aArgs);
	      if (generatedPosition) {
	        var ret = {
	          line: generatedPosition.line +
	            (section.generatedOffset.generatedLine - 1),
	          column: generatedPosition.column +
	            (section.generatedOffset.generatedLine === generatedPosition.line
	             ? section.generatedOffset.generatedColumn - 1
	             : 0)
	        };
	        return ret;
	      }
	    }

	    return {
	      line: null,
	      column: null
	    };
	  };

	/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */
	IndexedSourceMapConsumer.prototype._parseMappings =
	  function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
	    this.__generatedMappings = [];
	    this.__originalMappings = [];
	    for (var i = 0; i < this._sections.length; i++) {
	      var section = this._sections[i];
	      var sectionMappings = section.consumer._generatedMappings;
	      for (var j = 0; j < sectionMappings.length; j++) {
	        var mapping = sectionMappings[j];

	        var source = section.consumer._sources.at(mapping.source);
	        if (section.consumer.sourceRoot !== null) {
	          source = util.join(section.consumer.sourceRoot, source);
	        }
	        this._sources.add(source);
	        source = this._sources.indexOf(source);

	        var name = section.consumer._names.at(mapping.name);
	        this._names.add(name);
	        name = this._names.indexOf(name);

	        // The mappings coming from the consumer for the section have
	        // generated positions relative to the start of the section, so we
	        // need to offset them to be relative to the start of the concatenated
	        // generated file.
	        var adjustedMapping = {
	          source: source,
	          generatedLine: mapping.generatedLine +
	            (section.generatedOffset.generatedLine - 1),
	          generatedColumn: mapping.generatedColumn +
	            (section.generatedOffset.generatedLine === mapping.generatedLine
	            ? section.generatedOffset.generatedColumn - 1
	            : 0),
	          originalLine: mapping.originalLine,
	          originalColumn: mapping.originalColumn,
	          name: name
	        };

	        this.__generatedMappings.push(adjustedMapping);
	        if (typeof adjustedMapping.originalLine === 'number') {
	          this.__originalMappings.push(adjustedMapping);
	        }
	      }
	    }

	    quickSort(this.__generatedMappings, util.compareByGeneratedPositionsDeflated);
	    quickSort(this.__originalMappings, util.compareByOriginalPositions);
	  };

	exports.IndexedSourceMapConsumer = IndexedSourceMapConsumer;


/***/ },
/* 2 */
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */

	/**
	 * This is a helper function for getting values from parameter/options
	 * objects.
	 *
	 * @param args The object we are extracting values from
	 * @param name The name of the property we are getting.
	 * @param defaultValue An optional value to return if the property is missing
	 * from the object. If this is not specified and the property is missing, an
	 * error will be thrown.
	 */
	function getArg(aArgs, aName, aDefaultValue) {
	  if (aName in aArgs) {
	    return aArgs[aName];
	  } else if (arguments.length === 3) {
	    return aDefaultValue;
	  } else {
	    throw new Error('"' + aName + '" is a required argument.');
	  }
	}
	exports.getArg = getArg;

	var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.]*)(?::(\d+))?(\S*)$/;
	var dataUrlRegexp = /^data:.+\,.+$/;

	function urlParse(aUrl) {
	  var match = aUrl.match(urlRegexp);
	  if (!match) {
	    return null;
	  }
	  return {
	    scheme: match[1],
	    auth: match[2],
	    host: match[3],
	    port: match[4],
	    path: match[5]
	  };
	}
	exports.urlParse = urlParse;

	function urlGenerate(aParsedUrl) {
	  var url = '';
	  if (aParsedUrl.scheme) {
	    url += aParsedUrl.scheme + ':';
	  }
	  url += '//';
	  if (aParsedUrl.auth) {
	    url += aParsedUrl.auth + '@';
	  }
	  if (aParsedUrl.host) {
	    url += aParsedUrl.host;
	  }
	  if (aParsedUrl.port) {
	    url += ":" + aParsedUrl.port
	  }
	  if (aParsedUrl.path) {
	    url += aParsedUrl.path;
	  }
	  return url;
	}
	exports.urlGenerate = urlGenerate;

	/**
	 * Normalizes a path, or the path portion of a URL:
	 *
	 * - Replaces consecutive slashes with one slash.
	 * - Removes unnecessary '.' parts.
	 * - Removes unnecessary '<dir>/..' parts.
	 *
	 * Based on code in the Node.js 'path' core module.
	 *
	 * @param aPath The path or url to normalize.
	 */
	function normalize(aPath) {
	  var path = aPath;
	  var url = urlParse(aPath);
	  if (url) {
	    if (!url.path) {
	      return aPath;
	    }
	    path = url.path;
	  }
	  var isAbsolute = exports.isAbsolute(path);

	  var parts = path.split(/\/+/);
	  for (var part, up = 0, i = parts.length - 1; i >= 0; i--) {
	    part = parts[i];
	    if (part === '.') {
	      parts.splice(i, 1);
	    } else if (part === '..') {
	      up++;
	    } else if (up > 0) {
	      if (part === '') {
	        // The first part is blank if the path is absolute. Trying to go
	        // above the root is a no-op. Therefore we can remove all '..' parts
	        // directly after the root.
	        parts.splice(i + 1, up);
	        up = 0;
	      } else {
	        parts.splice(i, 2);
	        up--;
	      }
	    }
	  }
	  path = parts.join('/');

	  if (path === '') {
	    path = isAbsolute ? '/' : '.';
	  }

	  if (url) {
	    url.path = path;
	    return urlGenerate(url);
	  }
	  return path;
	}
	exports.normalize = normalize;

	/**
	 * Joins two paths/URLs.
	 *
	 * @param aRoot The root path or URL.
	 * @param aPath The path or URL to be joined with the root.
	 *
	 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
	 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
	 *   first.
	 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
	 *   is updated with the result and aRoot is returned. Otherwise the result
	 *   is returned.
	 *   - If aPath is absolute, the result is aPath.
	 *   - Otherwise the two paths are joined with a slash.
	 * - Joining for example 'http://' and 'www.example.com' is also supported.
	 */
	function join(aRoot, aPath) {
	  if (aRoot === "") {
	    aRoot = ".";
	  }
	  if (aPath === "") {
	    aPath = ".";
	  }
	  var aPathUrl = urlParse(aPath);
	  var aRootUrl = urlParse(aRoot);
	  if (aRootUrl) {
	    aRoot = aRootUrl.path || '/';
	  }

	  // `join(foo, '//www.example.org')`
	  if (aPathUrl && !aPathUrl.scheme) {
	    if (aRootUrl) {
	      aPathUrl.scheme = aRootUrl.scheme;
	    }
	    return urlGenerate(aPathUrl);
	  }

	  if (aPathUrl || aPath.match(dataUrlRegexp)) {
	    return aPath;
	  }

	  // `join('http://', 'www.example.com')`
	  if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
	    aRootUrl.host = aPath;
	    return urlGenerate(aRootUrl);
	  }

	  var joined = aPath.charAt(0) === '/'
	    ? aPath
	    : normalize(aRoot.replace(/\/+$/, '') + '/' + aPath);

	  if (aRootUrl) {
	    aRootUrl.path = joined;
	    return urlGenerate(aRootUrl);
	  }
	  return joined;
	}
	exports.join = join;

	exports.isAbsolute = function (aPath) {
	  return aPath.charAt(0) === '/' || !!aPath.match(urlRegexp);
	};

	/**
	 * Make a path relative to a URL or another path.
	 *
	 * @param aRoot The root path or URL.
	 * @param aPath The path or URL to be made relative to aRoot.
	 */
	function relative(aRoot, aPath) {
	  if (aRoot === "") {
	    aRoot = ".";
	  }

	  aRoot = aRoot.replace(/\/$/, '');

	  // It is possible for the path to be above the root. In this case, simply
	  // checking whether the root is a prefix of the path won't work. Instead, we
	  // need to remove components from the root one by one, until either we find
	  // a prefix that fits, or we run out of components to remove.
	  var level = 0;
	  while (aPath.indexOf(aRoot + '/') !== 0) {
	    var index = aRoot.lastIndexOf("/");
	    if (index < 0) {
	      return aPath;
	    }

	    // If the only part of the root that is left is the scheme (i.e. http://,
	    // file:///, etc.), one or more slashes (/), or simply nothing at all, we
	    // have exhausted all components, so the path is not relative to the root.
	    aRoot = aRoot.slice(0, index);
	    if (aRoot.match(/^([^\/]+:\/)?\/*$/)) {
	      return aPath;
	    }

	    ++level;
	  }

	  // Make sure we add a "../" for each component we removed from the root.
	  return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
	}
	exports.relative = relative;

	var supportsNullProto = (function () {
	  var obj = Object.create(null);
	  return !('__proto__' in obj);
	}());

	function identity (s) {
	  return s;
	}

	/**
	 * Because behavior goes wacky when you set `__proto__` on objects, we
	 * have to prefix all the strings in our set with an arbitrary character.
	 *
	 * See https://github.com/mozilla/source-map/pull/31 and
	 * https://github.com/mozilla/source-map/issues/30
	 *
	 * @param String aStr
	 */
	function toSetString(aStr) {
	  if (isProtoString(aStr)) {
	    return '$' + aStr;
	  }

	  return aStr;
	}
	exports.toSetString = supportsNullProto ? identity : toSetString;

	function fromSetString(aStr) {
	  if (isProtoString(aStr)) {
	    return aStr.slice(1);
	  }

	  return aStr;
	}
	exports.fromSetString = supportsNullProto ? identity : fromSetString;

	function isProtoString(s) {
	  if (!s) {
	    return false;
	  }

	  var length = s.length;

	  if (length < 9 /* "__proto__".length */) {
	    return false;
	  }

	  if (s.charCodeAt(length - 1) !== 95  /* '_' */ ||
	      s.charCodeAt(length - 2) !== 95  /* '_' */ ||
	      s.charCodeAt(length - 3) !== 111 /* 'o' */ ||
	      s.charCodeAt(length - 4) !== 116 /* 't' */ ||
	      s.charCodeAt(length - 5) !== 111 /* 'o' */ ||
	      s.charCodeAt(length - 6) !== 114 /* 'r' */ ||
	      s.charCodeAt(length - 7) !== 112 /* 'p' */ ||
	      s.charCodeAt(length - 8) !== 95  /* '_' */ ||
	      s.charCodeAt(length - 9) !== 95  /* '_' */) {
	    return false;
	  }

	  for (var i = length - 10; i >= 0; i--) {
	    if (s.charCodeAt(i) !== 36 /* '$' */) {
	      return false;
	    }
	  }

	  return true;
	}

	/**
	 * Comparator between two mappings where the original positions are compared.
	 *
	 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
	 * mappings with the same original source/line/column, but different generated
	 * line and column the same. Useful when searching for a mapping with a
	 * stubbed out mapping.
	 */
	function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
	  var cmp = mappingA.source - mappingB.source;
	  if (cmp !== 0) {
	    return cmp;
	  }

	  cmp = mappingA.originalLine - mappingB.originalLine;
	  if (cmp !== 0) {
	    return cmp;
	  }

	  cmp = mappingA.originalColumn - mappingB.originalColumn;
	  if (cmp !== 0 || onlyCompareOriginal) {
	    return cmp;
	  }

	  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }

	  cmp = mappingA.generatedLine - mappingB.generatedLine;
	  if (cmp !== 0) {
	    return cmp;
	  }

	  return mappingA.name - mappingB.name;
	}
	exports.compareByOriginalPositions = compareByOriginalPositions;

	/**
	 * Comparator between two mappings with deflated source and name indices where
	 * the generated positions are compared.
	 *
	 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
	 * mappings with the same generated line and column, but different
	 * source/name/original line and column the same. Useful when searching for a
	 * mapping with a stubbed out mapping.
	 */
	function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
	  var cmp = mappingA.generatedLine - mappingB.generatedLine;
	  if (cmp !== 0) {
	    return cmp;
	  }

	  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
	  if (cmp !== 0 || onlyCompareGenerated) {
	    return cmp;
	  }

	  cmp = mappingA.source - mappingB.source;
	  if (cmp !== 0) {
	    return cmp;
	  }

	  cmp = mappingA.originalLine - mappingB.originalLine;
	  if (cmp !== 0) {
	    return cmp;
	  }

	  cmp = mappingA.originalColumn - mappingB.originalColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }

	  return mappingA.name - mappingB.name;
	}
	exports.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;

	function strcmp(aStr1, aStr2) {
	  if (aStr1 === aStr2) {
	    return 0;
	  }

	  if (aStr1 > aStr2) {
	    return 1;
	  }

	  return -1;
	}

	/**
	 * Comparator between two mappings with inflated source and name strings where
	 * the generated positions are compared.
	 */
	function compareByGeneratedPositionsInflated(mappingA, mappingB) {
	  var cmp = mappingA.generatedLine - mappingB.generatedLine;
	  if (cmp !== 0) {
	    return cmp;
	  }

	  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }

	  cmp = strcmp(mappingA.source, mappingB.source);
	  if (cmp !== 0) {
	    return cmp;
	  }

	  cmp = mappingA.originalLine - mappingB.originalLine;
	  if (cmp !== 0) {
	    return cmp;
	  }

	  cmp = mappingA.originalColumn - mappingB.originalColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }

	  return strcmp(mappingA.name, mappingB.name);
	}
	exports.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;


/***/ },
/* 3 */
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */

	exports.GREATEST_LOWER_BOUND = 1;
	exports.LEAST_UPPER_BOUND = 2;

	/**
	 * Recursive implementation of binary search.
	 *
	 * @param aLow Indices here and lower do not contain the needle.
	 * @param aHigh Indices here and higher do not contain the needle.
	 * @param aNeedle The element being searched for.
	 * @param aHaystack The non-empty array being searched.
	 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
	 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
	 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 */
	function recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
	  // This function terminates when one of the following is true:
	  //
	  //   1. We find the exact element we are looking for.
	  //
	  //   2. We did not find the exact element, but we can return the index of
	  //      the next-closest element.
	  //
	  //   3. We did not find the exact element, and there is no next-closest
	  //      element than the one we are searching for, so we return -1.
	  var mid = Math.floor((aHigh - aLow) / 2) + aLow;
	  var cmp = aCompare(aNeedle, aHaystack[mid], true);
	  if (cmp === 0) {
	    // Found the element we are looking for.
	    return mid;
	  }
	  else if (cmp > 0) {
	    // Our needle is greater than aHaystack[mid].
	    if (aHigh - mid > 1) {
	      // The element is in the upper half.
	      return recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
	    }

	    // The exact needle element was not found in this haystack. Determine if
	    // we are in termination case (3) or (2) and return the appropriate thing.
	    if (aBias == exports.LEAST_UPPER_BOUND) {
	      return aHigh < aHaystack.length ? aHigh : -1;
	    } else {
	      return mid;
	    }
	  }
	  else {
	    // Our needle is less than aHaystack[mid].
	    if (mid - aLow > 1) {
	      // The element is in the lower half.
	      return recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
	    }

	    // we are in termination case (3) or (2) and return the appropriate thing.
	    if (aBias == exports.LEAST_UPPER_BOUND) {
	      return mid;
	    } else {
	      return aLow < 0 ? -1 : aLow;
	    }
	  }
	}

	/**
	 * This is an implementation of binary search which will always try and return
	 * the index of the closest element if there is no exact hit. This is because
	 * mappings between original and generated line/col pairs are single points,
	 * and there is an implicit region between each of them, so a miss just means
	 * that you aren't on the very start of a region.
	 *
	 * @param aNeedle The element you are looking for.
	 * @param aHaystack The array that is being searched.
	 * @param aCompare A function which takes the needle and an element in the
	 *     array and returns -1, 0, or 1 depending on whether the needle is less
	 *     than, equal to, or greater than the element, respectively.
	 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
	 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
	 */
	exports.search = function search(aNeedle, aHaystack, aCompare, aBias) {
	  if (aHaystack.length === 0) {
	    return -1;
	  }

	  var index = recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack,
	                              aCompare, aBias || exports.GREATEST_LOWER_BOUND);
	  if (index < 0) {
	    return -1;
	  }

	  // We have found either the exact element, or the next-closest element than
	  // the one we are searching for. However, there may be more than one such
	  // element. Make sure we always return the smallest of these.
	  while (index - 1 >= 0) {
	    if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) {
	      break;
	    }
	    --index;
	  }

	  return index;
	};


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */

	var util = __webpack_require__(2);
	var has = Object.prototype.hasOwnProperty;

	/**
	 * A data structure which is a combination of an array and a set. Adding a new
	 * member is O(1), testing for membership is O(1), and finding the index of an
	 * element is O(1). Removing elements from the set is not supported. Only
	 * strings are supported for membership.
	 */
	function ArraySet() {
	  this._array = [];
	  this._set = Object.create(null);
	}

	/**
	 * Static method for creating ArraySet instances from an existing array.
	 */
	ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
	  var set = new ArraySet();
	  for (var i = 0, len = aArray.length; i < len; i++) {
	    set.add(aArray[i], aAllowDuplicates);
	  }
	  return set;
	};

	/**
	 * Return how many unique items are in this ArraySet. If duplicates have been
	 * added, than those do not count towards the size.
	 *
	 * @returns Number
	 */
	ArraySet.prototype.size = function ArraySet_size() {
	  return Object.getOwnPropertyNames(this._set).length;
	};

	/**
	 * Add the given string to this set.
	 *
	 * @param String aStr
	 */
	ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
	  var sStr = util.toSetString(aStr);
	  var isDuplicate = has.call(this._set, sStr);
	  var idx = this._array.length;
	  if (!isDuplicate || aAllowDuplicates) {
	    this._array.push(aStr);
	  }
	  if (!isDuplicate) {
	    this._set[sStr] = idx;
	  }
	};

	/**
	 * Is the given string a member of this set?
	 *
	 * @param String aStr
	 */
	ArraySet.prototype.has = function ArraySet_has(aStr) {
	  var sStr = util.toSetString(aStr);
	  return has.call(this._set, sStr);
	};

	/**
	 * What is the index of the given string in the array?
	 *
	 * @param String aStr
	 */
	ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
	  var sStr = util.toSetString(aStr);
	  if (has.call(this._set, sStr)) {
	    return this._set[sStr];
	  }
	  throw new Error('"' + aStr + '" is not in the set.');
	};

	/**
	 * What is the element at the given index?
	 *
	 * @param Number aIdx
	 */
	ArraySet.prototype.at = function ArraySet_at(aIdx) {
	  if (aIdx >= 0 && aIdx < this._array.length) {
	    return this._array[aIdx];
	  }
	  throw new Error('No element indexed by ' + aIdx);
	};

	/**
	 * Returns the array representation of this set (which has the proper indices
	 * indicated by indexOf). Note that this is a copy of the internal array used
	 * for storing the members so that no one can mess with internal state.
	 */
	ArraySet.prototype.toArray = function ArraySet_toArray() {
	  return this._array.slice();
	};

	exports.ArraySet = ArraySet;


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 *
	 * Based on the Base 64 VLQ implementation in Closure Compiler:
	 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
	 *
	 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 *  * Redistributions of source code must retain the above copyright
	 *    notice, this list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above
	 *    copyright notice, this list of conditions and the following
	 *    disclaimer in the documentation and/or other materials provided
	 *    with the distribution.
	 *  * Neither the name of Google Inc. nor the names of its
	 *    contributors may be used to endorse or promote products derived
	 *    from this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
	 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
	 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
	 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */

	var base64 = __webpack_require__(6);

	// A single base 64 digit can contain 6 bits of data. For the base 64 variable
	// length quantities we use in the source map spec, the first bit is the sign,
	// the next four bits are the actual value, and the 6th bit is the
	// continuation bit. The continuation bit tells us whether there are more
	// digits in this value following this digit.
	//
	//   Continuation
	//   |    Sign
	//   |    |
	//   V    V
	//   101011

	var VLQ_BASE_SHIFT = 5;

	// binary: 100000
	var VLQ_BASE = 1 << VLQ_BASE_SHIFT;

	// binary: 011111
	var VLQ_BASE_MASK = VLQ_BASE - 1;

	// binary: 100000
	var VLQ_CONTINUATION_BIT = VLQ_BASE;

	/**
	 * Converts from a two-complement value to a value where the sign bit is
	 * placed in the least significant bit.  For example, as decimals:
	 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
	 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
	 */
	function toVLQSigned(aValue) {
	  return aValue < 0
	    ? ((-aValue) << 1) + 1
	    : (aValue << 1) + 0;
	}

	/**
	 * Converts to a two-complement value from a value where the sign bit is
	 * placed in the least significant bit.  For example, as decimals:
	 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
	 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
	 */
	function fromVLQSigned(aValue) {
	  var isNegative = (aValue & 1) === 1;
	  var shifted = aValue >> 1;
	  return isNegative
	    ? -shifted
	    : shifted;
	}

	/**
	 * Returns the base 64 VLQ encoded value.
	 */
	exports.encode = function base64VLQ_encode(aValue) {
	  var encoded = "";
	  var digit;

	  var vlq = toVLQSigned(aValue);

	  do {
	    digit = vlq & VLQ_BASE_MASK;
	    vlq >>>= VLQ_BASE_SHIFT;
	    if (vlq > 0) {
	      // There are still more digits in this value, so we must make sure the
	      // continuation bit is marked.
	      digit |= VLQ_CONTINUATION_BIT;
	    }
	    encoded += base64.encode(digit);
	  } while (vlq > 0);

	  return encoded;
	};

	/**
	 * Decodes the next base 64 VLQ value from the given string and returns the
	 * value and the rest of the string via the out parameter.
	 */
	exports.decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
	  var strLen = aStr.length;
	  var result = 0;
	  var shift = 0;
	  var continuation, digit;

	  do {
	    if (aIndex >= strLen) {
	      throw new Error("Expected more digits in base 64 VLQ value.");
	    }

	    digit = base64.decode(aStr.charCodeAt(aIndex++));
	    if (digit === -1) {
	      throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
	    }

	    continuation = !!(digit & VLQ_CONTINUATION_BIT);
	    digit &= VLQ_BASE_MASK;
	    result = result + (digit << shift);
	    shift += VLQ_BASE_SHIFT;
	  } while (continuation);

	  aOutParam.value = fromVLQSigned(result);
	  aOutParam.rest = aIndex;
	};


/***/ },
/* 6 */
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */

	var intToCharMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');

	/**
	 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
	 */
	exports.encode = function (number) {
	  if (0 <= number && number < intToCharMap.length) {
	    return intToCharMap[number];
	  }
	  throw new TypeError("Must be between 0 and 63: " + number);
	};

	/**
	 * Decode a single base 64 character code digit to an integer. Returns -1 on
	 * failure.
	 */
	exports.decode = function (charCode) {
	  var bigA = 65;     // 'A'
	  var bigZ = 90;     // 'Z'

	  var littleA = 97;  // 'a'
	  var littleZ = 122; // 'z'

	  var zero = 48;     // '0'
	  var nine = 57;     // '9'

	  var plus = 43;     // '+'
	  var slash = 47;    // '/'

	  var littleOffset = 26;
	  var numberOffset = 52;

	  // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
	  if (bigA <= charCode && charCode <= bigZ) {
	    return (charCode - bigA);
	  }

	  // 26 - 51: abcdefghijklmnopqrstuvwxyz
	  if (littleA <= charCode && charCode <= littleZ) {
	    return (charCode - littleA + littleOffset);
	  }

	  // 52 - 61: 0123456789
	  if (zero <= charCode && charCode <= nine) {
	    return (charCode - zero + numberOffset);
	  }

	  // 62: +
	  if (charCode == plus) {
	    return 62;
	  }

	  // 63: /
	  if (charCode == slash) {
	    return 63;
	  }

	  // Invalid base64 digit.
	  return -1;
	};


/***/ },
/* 7 */
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */

	// It turns out that some (most?) JavaScript engines don't self-host
	// `Array.prototype.sort`. This makes sense because C++ will likely remain
	// faster than JS when doing raw CPU-intensive sorting. However, when using a
	// custom comparator function, calling back and forth between the VM's C++ and
	// JIT'd JS is rather slow *and* loses JIT type information, resulting in
	// worse generated code for the comparator function than would be optimal. In
	// fact, when sorting with a comparator, these costs outweigh the benefits of
	// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
	// a ~3500ms mean speed-up in `bench/bench.html`.

	/**
	 * Swap the elements indexed by `x` and `y` in the array `ary`.
	 *
	 * @param {Array} ary
	 *        The array.
	 * @param {Number} x
	 *        The index of the first item.
	 * @param {Number} y
	 *        The index of the second item.
	 */
	function swap(ary, x, y) {
	  var temp = ary[x];
	  ary[x] = ary[y];
	  ary[y] = temp;
	}

	/**
	 * Returns a random integer within the range `low .. high` inclusive.
	 *
	 * @param {Number} low
	 *        The lower bound on the range.
	 * @param {Number} high
	 *        The upper bound on the range.
	 */
	function randomIntInRange(low, high) {
	  return Math.round(low + (Math.random() * (high - low)));
	}

	/**
	 * The Quick Sort algorithm.
	 *
	 * @param {Array} ary
	 *        An array to sort.
	 * @param {function} comparator
	 *        Function to use to compare two items.
	 * @param {Number} p
	 *        Start index of the array
	 * @param {Number} r
	 *        End index of the array
	 */
	function doQuickSort(ary, comparator, p, r) {
	  // If our lower bound is less than our upper bound, we (1) partition the
	  // array into two pieces and (2) recurse on each half. If it is not, this is
	  // the empty array and our base case.

	  if (p < r) {
	    // (1) Partitioning.
	    //
	    // The partitioning chooses a pivot between `p` and `r` and moves all
	    // elements that are less than or equal to the pivot to the before it, and
	    // all the elements that are greater than it after it. The effect is that
	    // once partition is done, the pivot is in the exact place it will be when
	    // the array is put in sorted order, and it will not need to be moved
	    // again. This runs in O(n) time.

	    // Always choose a random pivot so that an input array which is reverse
	    // sorted does not cause O(n^2) running time.
	    var pivotIndex = randomIntInRange(p, r);
	    var i = p - 1;

	    swap(ary, pivotIndex, r);
	    var pivot = ary[r];

	    // Immediately after `j` is incremented in this loop, the following hold
	    // true:
	    //
	    //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
	    //
	    //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
	    for (var j = p; j < r; j++) {
	      if (comparator(ary[j], pivot) <= 0) {
	        i += 1;
	        swap(ary, i, j);
	      }
	    }

	    swap(ary, i + 1, j);
	    var q = i + 1;

	    // (2) Recurse on each half.

	    doQuickSort(ary, comparator, p, q - 1);
	    doQuickSort(ary, comparator, q + 1, r);
	  }
	}

	/**
	 * Sort the given array in-place with the given comparator function.
	 *
	 * @param {Array} ary
	 *        An array to sort.
	 * @param {function} comparator
	 *        Function to use to compare two items.
	 */
	exports.quickSort = function (ary, comparator) {
	  doQuickSort(ary, comparator, 0, ary.length - 1);
	};


/***/ }
/******/ ])
});
;

/***/ }),
/* 2743 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
    'use strict';
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

    /* istanbul ignore next */
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.StackFrame = factory();
    }
}(this, function () {
    'use strict';
    function _isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    function StackFrame(functionName, args, fileName, lineNumber, columnNumber, source) {
        if (functionName !== undefined) {
            this.setFunctionName(functionName);
        }
        if (args !== undefined) {
            this.setArgs(args);
        }
        if (fileName !== undefined) {
            this.setFileName(fileName);
        }
        if (lineNumber !== undefined) {
            this.setLineNumber(lineNumber);
        }
        if (columnNumber !== undefined) {
            this.setColumnNumber(columnNumber);
        }
        if (source !== undefined) {
            this.setSource(source);
        }
    }

    StackFrame.prototype = {
        getFunctionName: function () {
            return this.functionName;
        },
        setFunctionName: function (v) {
            this.functionName = String(v);
        },

        getArgs: function () {
            return this.args;
        },
        setArgs: function (v) {
            if (Object.prototype.toString.call(v) !== '[object Array]') {
                throw new TypeError('Args must be an Array');
            }
            this.args = v;
        },

        // NOTE: Property name may be misleading as it includes the path,
        // but it somewhat mirrors V8's JavaScriptStackTraceApi
        // https://code.google.com/p/v8/wiki/JavaScriptStackTraceApi and Gecko's
        // http://mxr.mozilla.org/mozilla-central/source/xpcom/base/nsIException.idl#14
        getFileName: function () {
            return this.fileName;
        },
        setFileName: function (v) {
            this.fileName = String(v);
        },

        getLineNumber: function () {
            return this.lineNumber;
        },
        setLineNumber: function (v) {
            if (!_isNumber(v)) {
                throw new TypeError('Line Number must be a Number');
            }
            this.lineNumber = Number(v);
        },

        getColumnNumber: function () {
            return this.columnNumber;
        },
        setColumnNumber: function (v) {
            if (!_isNumber(v)) {
                throw new TypeError('Column Number must be a Number');
            }
            this.columnNumber = Number(v);
        },

        getSource: function () {
            return this.source;
        },
        setSource: function (v) {
            this.source = String(v);
        },

        toString: function() {
            var functionName = this.getFunctionName() || '{anonymous}';
            var args = '(' + (this.getArgs() || []).join(',') + ')';
            var fileName = this.getFileName() ? ('@' + this.getFileName()) : '';
            var lineNumber = _isNumber(this.getLineNumber()) ? (':' + this.getLineNumber()) : '';
            var columnNumber = _isNumber(this.getColumnNumber()) ? (':' + this.getColumnNumber()) : '';
            return functionName + args + fileName + lineNumber + columnNumber;
        }
    };

    return StackFrame;
}));


/***/ }),
/* 2744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 2745 */,
/* 2746 */,
/* 2747 */
/***/ (function(module, exports) {

function Agent() {
  this._defaults = [];
}

["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects",
 "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert"].forEach(function(fn) {
  /** Default setting for all requests from this agent */
  Agent.prototype[fn] = function(/*varargs*/) {
    this._defaults.push({fn:fn, arguments:arguments});
    return this;
  }
});

Agent.prototype._setDefaults = function(req) {
    this._defaults.forEach(function(def) {
      req[def.fn].apply(req, def.arguments);
    });
};

module.exports = Agent;


/***/ }),
/* 2748 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = this;
}

var Emitter = __webpack_require__(1438);
var RequestBase = __webpack_require__(2749);
var isObject = __webpack_require__(1098);
var ResponseBase = __webpack_require__(2750);
var Agent = __webpack_require__(2747);

/**
 * Noop.
 */

function noop(){};

/**
 * Expose `request`.
 */

var request = exports = module.exports = function(method, url) {
  // callback
  if ('function' == typeof url) {
    return new exports.Request('GET', method).end(url);
  }

  // url first
  if (1 == arguments.length) {
    return new exports.Request('GET', method);
  }

  return new exports.Request(method, url);
}

exports.Request = Request;

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  throw Error("Browser-only version of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for(var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/**
 * Expose serialization method.
 */

request.serializeObject = serialize;

/**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] =
        decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'text/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

request.serialize = {
  'application/x-www-form-urlencoded': serialize,
  'application/json': JSON.stringify
};

/**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    if (index === -1) { // could be empty line, just skip it
      continue;
    }
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  // should match /json or +json
  // but not /json-seq
  return /[\/+]json($|[^-\w])/.test(mime);
}

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req) {
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  var status = this.xhr.status;
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }
  this._setStatusProperties(status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);

  if (null === this.text && req._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method != 'HEAD'
      ? this._parseBody(this.text ? this.text : this.xhr.response)
      : null;
  }
}

ResponseBase(Response.prototype);

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function(str) {
  var parse = request.parse[this.type];
  if (this.req._parser) {
    return this.req._parser(this, str);
  }
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      if (self.xhr) {
        // ie9 doesn't have 'response' property
        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
        // issue #876: return the http status code if the response parsing fails
        err.status = self.xhr.status ? self.xhr.status : null;
        err.statusCode = err.status; // backwards-compat only
      } else {
        err.rawResponse = null;
        err.status = null;
      }

      return self.callback(err);
    }

    self.emit('response', res);

    var new_err;
    try {
      if (!self._isResponseOK(res)) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
      }
    } catch(custom_err) {
      new_err = custom_err; // ok() callback can throw
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      new_err.original = err;
      new_err.response = res;
      new_err.status = res.status;
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `RequestBase`.
 */

Emitter(Request.prototype);
RequestBase(Request.prototype);

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (1 === arguments.length) pass = '';
  if (typeof pass === 'object' && pass !== null) { // pass is optional and can be replaced with options
    options = pass;
    pass = '';
  }
  if (!options) {
    options = {
      type: 'function' === typeof btoa ? 'basic' : 'auto',
    };
  }

  var encoder = function(string) {
    if ('function' === typeof btoa) {
      return btoa(string);
    }
    throw new Error('Cannot use basic auth, btoa is not a function');
  };

  return this._auth(user, pass, options, encoder);
};

/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, options){
  if (file) {
    if (this._data) {
      throw Error("superagent can't mix .send() and .attach()");
    }

    this._getFormData().append(field, file, options || file.name);
  }
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  if (this._shouldRetry(err, res)) {
    return this._retry();
  }

  var fn = this._callback;
  this.clearTimeout();

  if (err) {
    if (this._maxRetries) err.retries = this._retries - 1;
    this.emit('error', err);
  }

  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

// This only warns, because the request is still likely to work
Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
  console.warn("This is not supported in browser version of superagent");
  return this;
};

// This throws, because it can't send/receive data as expected
Request.prototype.pipe = Request.prototype.write = function(){
  throw Error("Streaming is not supported in browser version of superagent");
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */
Request.prototype._isHost = function _isHost(obj) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
}

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  if (this._endCalled) {
    console.warn("Warning: .end() was called twice. This is not supported in superagent");
  }
  this._endCalled = true;

  // store callback
  this._callback = fn || noop;

  // querystring
  this._finalizeQueryString();

  return this._end();
};

Request.prototype._end = function() {
  var self = this;
  var xhr = (this.xhr = request.getXHR());
  var data = this._formData || this._data;

  this._setTimeouts();

  // state change
  xhr.onreadystatechange = function(){
    var readyState = xhr.readyState;
    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }
    if (4 != readyState) {
      return;
    }

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = direction;
    self.emit('progress', e);
  };
  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');
      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch(e) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  // initiate request
  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) {
      serialize = request.serialize['application/json'];
    }
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;

    if (this.header.hasOwnProperty(field))
      xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};

request.agent = function() {
  return new Agent();
};

["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function(method) {
  Agent.prototype[method.toLowerCase()] = function(url, fn) {
    var req = new request.Request(method, url);
    this._setDefaults(req);
    if (fn) {
      req.end(fn);
    }
    return req;
  };
});

Agent.prototype.del = Agent.prototype['delete'];

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn) {
  var req = request('GET', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn) {
  var req = request('HEAD', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function(url, data, fn) {
  var req = request('OPTIONS', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, data, fn) {
  var req = request('DELETE', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
}

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn) {
  var req = request('PATCH', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn) {
  var req = request('POST', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn) {
  var req = request('PUT', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};


/***/ }),
/* 2749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = __webpack_require__(1098);

/**
 * Expose `RequestBase`.
 */

module.exports = RequestBase;

/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in RequestBase.prototype) {
    obj[key] = RequestBase.prototype[key];
  }
  return obj;
}

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.clearTimeout = function _clearTimeout(){
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.serialize = function serialize(fn){
  this._serializer = fn;
  return this;
};

/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.timeout = function timeout(options){
  if (!options || 'object' !== typeof options) {
    this._timeout = options;
    this._responseTimeout = 0;
    return this;
  }

  for(var option in options) {
    switch(option) {
      case 'deadline':
        this._timeout = options.deadline;
        break;
      case 'response':
        this._responseTimeout = options.response;
        break;
      default:
        console.warn("Unknown timeout option", option);
    }
  }
  return this;
};

/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.retry = function retry(count, fn){
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  this._retryCallback = fn;
  return this;
};

var ERROR_CODES = [
  'ECONNRESET',
  'ETIMEDOUT',
  'EADDRINFO',
  'ESOCKETTIMEDOUT'
];

/**
 * Determine if a request should be retried.
 * (Borrowed from segmentio/superagent-retry)
 *
 * @param {Error} err
 * @param {Response} [res]
 * @returns {Boolean}
 */
RequestBase.prototype._shouldRetry = function(err, res) {
  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
    return false;
  }
  if (this._retryCallback) {
    try {
      var override = this._retryCallback(err, res);
      if (override === true) return true;
      if (override === false) return false;
      // undefined falls back to defaults
    } catch(e) {
      console.error(e);
    }
  }
  if (res && res.status && res.status >= 500 && res.status != 501) return true;
  if (err) {
    if (err.code && ~ERROR_CODES.indexOf(err.code)) return true;
    // Superagent timeout
    if (err.timeout && err.code == 'ECONNABORTED') return true;
    if (err.crossDomain) return true;
  }
  return false;
};

/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */

RequestBase.prototype._retry = function() {

  this.clearTimeout();

  // node
  if (this.req) {
    this.req = null;
    this.req = this.request();
  }

  this._aborted = false;
  this.timedout = false;

  return this._end();
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */

RequestBase.prototype.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;
    if (this._endCalled) {
      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
    }
    this._fullfilledPromise = new Promise(function(innerResolve, innerReject) {
      self.end(function(err, res) {
        if (err) innerReject(err);
        else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
};

RequestBase.prototype['catch'] = function(cb) {
  return this.then(undefined, cb);
};

/**
 * Allow for extension
 */

RequestBase.prototype.use = function use(fn) {
  fn(this);
  return this;
};

RequestBase.prototype.ok = function(cb) {
  if ('function' !== typeof cb) throw Error("Callback required");
  this._okCallback = cb;
  return this;
};

RequestBase.prototype._isResponseOK = function(res) {
  if (!res) {
    return false;
  }

  if (this._okCallback) {
    return this._okCallback(res);
  }

  return res.status >= 200 && res.status < 300;
};

/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

RequestBase.prototype.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

RequestBase.prototype.getHeader = RequestBase.prototype.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
RequestBase.prototype.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
RequestBase.prototype.field = function(name, val) {
  // name should be either a string or an object.
  if (null === name || undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (this._data) {
    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }
    return this;
  }

  if (Array.isArray(val)) {
    for (var i in val) {
      this.field(name, val[i]);
    }
    return this;
  }

  // val should be defined now
  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }
  if ('boolean' === typeof val) {
    val = '' + val;
  }
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
RequestBase.prototype.abort = function(){
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
  switch (options.type) {
    case 'basic':
      this.set('Authorization', 'Basic ' + base64Encoder(user + ':' + pass));
      break;

    case 'auto':
      this.username = user;
      this.password = pass;
      break;

    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', 'Bearer ' + user);
      break;
  }
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

RequestBase.prototype.withCredentials = function(on) {
  // This is browser-only functionality. Node side is no-op.
  if (on == undefined) on = true;
  this._withCredentials = on;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.redirects = function(n){
  this._maxRedirects = n;
  return this;
};

/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n
 * @return {Request} for chaining
 */
RequestBase.prototype.maxResponseSize = function(n){
  if ('number' !== typeof n) {
    throw TypeError("Invalid argument");
  }
  this._maxResponseSize = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

RequestBase.prototype.toJSON = function() {
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header,
  };
};

/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.send = function(data){
  var isObj = isObject(data);
  var type = this._header['content-type'];

  if (this._formData) {
    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObj && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw Error("Can't merge these send calls");
  }

  // merge
  if (isObj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!isObj || this._isHost(data)) {
    return this;
  }

  // default to json
  if (!type) this.type('json');
  return this;
};

/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.sortQuery = function(sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */
RequestBase.prototype._finalizeQueryString = function(){
  var query = this._query.join('&');
  if (query) {
    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
  }
  this._query.length = 0; // Makes the call idempotent

  if (this._sort) {
    var index = this.url.indexOf('?');
    if (index >= 0) {
      var queryArr = this.url.substring(index + 1).split('&');
      if ('function' === typeof this._sort) {
        queryArr.sort(this._sort);
      } else {
        queryArr.sort();
      }
      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
    }
  }
};

// For backwards compat only
RequestBase.prototype._appendQueryString = function() {console.trace("Unsupported");}

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

RequestBase.prototype._timeoutError = function(reason, timeout, errno){
  if (this._aborted) {
    return;
  }
  var err = new Error(reason + timeout + 'ms exceeded');
  err.timeout = timeout;
  err.code = 'ECONNABORTED';
  err.errno = errno;
  this.timedout = true;
  this.abort();
  this.callback(err);
};

RequestBase.prototype._setTimeouts = function() {
  var self = this;

  // deadline
  if (this._timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  }
  // response timeout
  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function(){
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
};


/***/ }),
/* 2750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module dependencies.
 */

var utils = __webpack_require__(2751);

/**
 * Expose `ResponseBase`.
 */

module.exports = ResponseBase;

/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in ResponseBase.prototype) {
    obj[key] = ResponseBase.prototype[key];
  }
  return obj;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

ResponseBase.prototype.get = function(field) {
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

ResponseBase.prototype._setHeaderProperties = function(header){
    // TODO: moar!
    // TODO: make this a util

    // content-type
    var ct = header['content-type'] || '';
    this.type = utils.type(ct);

    // params
    var params = utils.params(ct);
    for (var key in params) this[key] = params[key];

    this.links = {};

    // links
    try {
        if (header.link) {
            this.links = utils.parseLinks(header.link);
        }
    } catch (err) {
        // ignore
    }
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

ResponseBase.prototype._setStatusProperties = function(status){
    var type = status / 100 | 0;

    // status / class
    this.status = this.statusCode = status;
    this.statusType = type;

    // basics
    this.info = 1 == type;
    this.ok = 2 == type;
    this.redirect = 3 == type;
    this.clientError = 4 == type;
    this.serverError = 5 == type;
    this.error = (4 == type || 5 == type)
        ? this.toError()
        : false;

    // sugar
    this.created = 201 == status;
    this.accepted = 202 == status;
    this.noContent = 204 == status;
    this.badRequest = 400 == status;
    this.unauthorized = 401 == status;
    this.notAcceptable = 406 == status;
    this.forbidden = 403 == status;
    this.notFound = 404 == status;
    this.unprocessableEntity = 422 == status;
};


/***/ }),
/* 2751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

exports.type = function(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.params = function(str){
  return str.split(/ *; */).reduce(function(obj, str){
    var parts = str.split(/ *= */);
    var key = parts.shift();
    var val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.parseLinks = function(str){
  return str.split(/ *, */).reduce(function(obj, str){
    var parts = str.split(/ *; */);
    var url = parts[0].slice(1, -1);
    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
    obj[rel] = url;
    return obj;
  }, {});
};

/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */

exports.cleanHeader = function(header, changesOrigin){
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header['host'];
  // secuirty
  if (changesOrigin) {
    delete header['authorization'];
    delete header['cookie'];
  }
  return header;
};


/***/ }),
/* 2752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(2753);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(74), __webpack_require__(2809)(module)))

/***/ }),
/* 2753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 2754 */
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),
/* 2755 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * UAParser.js v0.7.18
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
 * Dual licensed under GPLv2 or MIT
 */

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.18',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major', // deprecated
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded';


    ///////////
    // Helper
    //////////


    var util = {
        extend : function (regexes, extensions) {
            var margedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    margedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    margedRegexes[i] = regexes[i];
                }
            }
            return margedRegexes;
        },
        has : function (str1, str2) {
          if (typeof str1 === "string") {
            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
          } else {
            return false;
          }
        },
        lowerize : function (str) {
            return str.toLowerCase();
        },
        major : function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
        },
        trim : function (str) {
          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        }
    };


    ///////////////
    // Map helper
    //////////////


    var mapper = {

        rgx : function (ua, arrays) {

            //var result = {},
            var i = 0, j, k, p, q, matches, match;//, args = arguments;

            /*// construct object barebones
            for (p = 0; p < args[1].length; p++) {
                q = args[1][p];
                result[typeof q === OBJ_TYPE ? q[0] : q] = undefined;
            }*/

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length == 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length == 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length == 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
            // console.log(this);
            //return this;
        },

        str : function (str, map) {

            for (var i in map) {
                // check if array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (util.has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (util.has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
        }
    };


    ///////////////
    // String map
    //////////////


    var maps = {

        browser : {
            oldsafari : {
                version : {
                    '1.0'   : '/8',
                    '1.2'   : '/1',
                    '1.3'   : '/3',
                    '2.0'   : '/412',
                    '2.0.2' : '/416',
                    '2.0.3' : '/417',
                    '2.0.4' : '/419',
                    '?'     : '/'
                }
            }
        },

        device : {
            amazon : {
                model : {
                    'Fire Phone' : ['SD', 'KF']
                }
            },
            sprint : {
                model : {
                    'Evo Shift 4G' : '7373KT'
                },
                vendor : {
                    'HTC'       : 'APA',
                    'Sprint'    : 'Sprint'
                }
            }
        },

        os : {
            windows : {
                version : {
                    'ME'        : '4.90',
                    'NT 3.11'   : 'NT3.51',
                    'NT 4.0'    : 'NT4.0',
                    '2000'      : 'NT 5.0',
                    'XP'        : ['NT 5.1', 'NT 5.2'],
                    'Vista'     : 'NT 6.0',
                    '7'         : 'NT 6.1',
                    '8'         : 'NT 6.2',
                    '8.1'       : 'NT 6.3',
                    '10'        : ['NT 6.4', 'NT 10.0'],
                    'RT'        : 'ARM'
                }
            }
        }
    };


    //////////////
    // Regex map
    /////////////


    var regexes = {

        browser : [[

            // Presto based
            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
            ], [NAME, VERSION], [

            /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
            ], [[NAME, 'Opera Mini'], VERSION], [

            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
            ], [[NAME, 'Opera'], VERSION], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,
                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer

            // Trident based
            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
                                                                                // Avant/IEMobile/SlimBrowser/Baidu
            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer

            // Webkit/KHTML based
            /(rekonq)\/([\w\.]*)/i,                                             // Rekonq
            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark)\/([\w\.-]+)/i
                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser
            ], [NAME, VERSION], [

            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
            ], [[NAME, 'IE'], VERSION], [

            /(edge|edgios|edgea)\/((\d+)?[\w\.]+)/i                             // Microsoft Edge
            ], [[NAME, 'Edge'], VERSION], [

            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
            ], [[NAME, 'Yandex'], VERSION], [

            /(puffin)\/([\w\.]+)/i                                              // Puffin
            ], [[NAME, 'Puffin'], VERSION], [

            /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i
                                                                                // UCBrowser
            ], [[NAME, 'UCBrowser'], VERSION], [

            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [

            /(micromessenger)\/([\w\.]+)/i                                      // WeChat
            ], [[NAME, 'WeChat'], VERSION], [

            /(qqbrowserlite)\/([\w\.]+)/i                                       // QQBrowserLite
            ], [NAME, VERSION], [

            /(QQ)\/([\d\.]+)/i                                                  // QQ, aka ShouQ
            ], [NAME, VERSION], [

            /m?(qqbrowser)[\/\s]?([\w\.]+)/i                                    // QQBrowser
            ], [NAME, VERSION], [

            /(BIDUBrowser)[\/\s]?([\w\.]+)/i                                    // Baidu Browser
            ], [NAME, VERSION], [

            /(2345Explorer)[\/\s]?([\w\.]+)/i                                   // 2345 Browser
            ], [NAME, VERSION], [

            /(MetaSr)[\/\s]?([\w\.]+)/i                                         // SouGouBrowser
            ], [NAME], [

            /(LBBROWSER)/i                                      // LieBao Browser
            ], [NAME], [

            /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
            ], [VERSION, [NAME, 'MIUI Browser']], [

            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS & Android
            ], [VERSION, [NAME, 'Facebook']], [

            /headlesschrome(?:\/([\w\.]+)|\s)/i                                 // Chrome Headless
            ], [VERSION, [NAME, 'Chrome Headless']], [

            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
            ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [

            /((?:oculus|samsung)browser)\/([\w\.]+)/i
            ], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [                // Oculus / Samsung Browser

            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
            ], [VERSION, [NAME, 'Android Browser']], [

            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
            ], [[NAME, 'Dolphin'], VERSION], [

            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
            ], [[NAME, 'Chrome'], VERSION], [

            /(coast)\/([\w\.]+)/i                                               // Opera Coast
            ], [[NAME, 'Opera Coast'], VERSION], [

            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, 'Firefox']], [

            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [

            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
            ], [VERSION, NAME], [

            /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i  // Google Search Appliance on iOS
            ], [[NAME, 'GSA'], VERSION], [

            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [

            /(konqueror)\/([\w\.]+)/i,                                          // Konqueror
            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,

                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
            /(links)\s\(([\w\.]+)/i,                                            // Links
            /(gobrowser)\/?([\w\.]*)/i,                                         // GoBrowser
            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
            ], [NAME, VERSION]

            /* /////////////////////
            // Media players BEGIN
            ////////////////////////

            , [

            /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
            /(coremedia) v((\d+)[\w\._]+)/i
            ], [NAME, VERSION], [

            /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
            ], [NAME, VERSION], [

            /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
            ], [NAME, VERSION], [

            /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
                                                                                // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
                                                                                // NSPlayer/PSP-InternetRadioPlayer/Videos
            /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
            /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
            /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
            ], [NAME, VERSION], [
            /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
            ], [NAME, VERSION], [

            /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
            ], [[NAME, 'Flip Player'], VERSION], [

            /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
                                                                                // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
            ], [NAME], [

            /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
                                                                                // Gstreamer
            ], [NAME, VERSION], [

            /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
            /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
                                                                                // Java/urllib/requests/wget/cURL
            /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
            ], [NAME, VERSION], [

            /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
            ], [[NAME, /_/g, ' '], VERSION], [

            /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
                                                                                // MPlayer SVN
            ], [NAME, VERSION], [

            /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
            ], [NAME, VERSION], [

            /(mplayer)/i,                                                       // MPlayer (no other info)
            /(yourmuze)/i,                                                      // YourMuze
            /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
            ], [NAME], [

            /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
            ], [NAME, VERSION], [

            /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
            ], [NAME, VERSION], [

            /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
            ], [NAME, VERSION], [

            /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
            /(winamp)\s((\d+)[\w\.-]+)/i,
            /(winamp)mpeg\/((\d+)[\w\.-]+)/i
            ], [NAME, VERSION], [

            /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
                                                                                // inlight radio
            ], [NAME], [

            /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
                                                                                // QuickTime/RealMedia/RadioApp/RadioClientApplication/
                                                                                // SoundTap/Totem/Stagefright/Streamium
            ], [NAME, VERSION], [

            /(smp)((\d+)[\d\.]+)/i                                              // SMP
            ], [NAME, VERSION], [

            /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
            /(vlc)\/((\d+)[\w\.-]+)/i,
            /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
            /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
            /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
            ], [NAME, VERSION], [

            /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
            /(windows-media-player)\/((\d+)[\w\.-]+)/i
            ], [[NAME, /-/g, ' '], VERSION], [

            /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
                                                                                // Windows Media Server
            ], [VERSION, [NAME, 'Windows']], [

            /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
            ], [NAME, VERSION], [

            /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
            /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
            ], [[NAME, 'rad.io'], VERSION]

            //////////////////////
            // Media players END
            ////////////////////*/

        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, util.lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32
            ], [[ARCHITECTURE, 'ia32']], [

            // PocketPC mistakenly identified as PowerPC
            /windows\s(ce|mobile);\sppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, util.lowerize]]
        ],

        device : [[

            /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i                         // iPad/PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [

            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [

            /(apple\s{0,1}tv)/i                                                 // Apple TV
            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [

            /(archos)\s(gamepad2?)/i,                                           // Archos
            /(hp).+(touchpad)/i,                                                // HP TouchPad
            /(hp).+(tablet)/i,                                                  // HP Tablet
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(kf[A-z]+)\sbuild\/.+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
            /(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i                         // Fire Phone
            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [

            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [

            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
            /(asus)-?(\w+)/i                                                    // Asus
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
                                                                                // Asus Tablets
            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i
            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [

            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
            /(sony)?(?:sgp.+)\sbuild\//i
            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
            /android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /\s(ouya)\s/i,                                                      // Ouya
            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [

            /android.+;\s(shield)\sbuild/i                                      // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [

            /(playstation\s[34portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [

            /(sprint\s(\w+))/i                                                  // Sprint Phones
            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [

            /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i                         // Lenovo tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,                               // HTC
            /(zte)-(\w*)/i,                                                     // ZTE
            /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i
                                                                                // Alcatel/GeeksPhone/Lenovo/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            /(nexus\s9)/i                                                       // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [

            /d\/huawei([\w\s-]+)[;\)]/i,
            /(nexus\s6p)/i                                                      // Huawei
            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [

            /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [

                                                                                // Motorola
            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,
            /mot[\s-]?(\w*)/i,
            /(XT\d{3,4}) build\//i,
            /(nexus\s6)/i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [

            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [

            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [

            /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [

            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
            /((SM-T\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
            /smart-tv.+(samsung)/i
            ], [VENDOR, [TYPE, SMARTTV], MODEL], [
            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,
            /sec-((sgh\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [

            /sie-(\w*)/i                                                        // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [

            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
            /(nokia)[\s_-]?([\w-]*)/i
            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [

            /android\s3\.[\s\w;-]{10}(a\d{3})/i                                 // Acer
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            /android.+([vl]k\-?\d{3})\s+build/i                                 // LG Tablet
            ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
            /(lg) netcast\.tv/i                                                 // LG SmartTV
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /(nexus\s[45])/i,                                                   // LG
            /lg[e;\s\/-]+(\w*)/i,
            /android.+lg(\-?[\d\w]+)\s+build/i
            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [

            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            /linux;.+((jolla));/i                                               // Jolla
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [

            /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i                            // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, 'Chromecast'], [VENDOR, 'Google']], [

            /android.+;\s(glass)\s\d/i                                          // Google Glass
            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [

            /android.+;\s(pixel c)\s/i                                          // Google Pixel C
            ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [

            /android.+;\s(pixel xl|pixel)\s/i                                   // Google Pixel
            ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [

            /android.+;\s(\w+)\s+build\/hm\1/i,                                 // Xiaomi Hongmi 'numeric' models
            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
            /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,    // Xiaomi Mi
            /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i       // Redmi Phones
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
            /android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i            // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [
            /android.+;\s(m[1-5]\snote)\sbuild/i                                // Meizu Tablet
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, TABLET]], [

            /android.+a000(1)\s+build/i,                                        // OnePlus
            /android.+oneplus\s(a\d{4})\s+build/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i                            // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [

            /android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i                      // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i                         // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [

            /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i     // Barnes & Noble Tablet
            ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i                           // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [

            /android.+;\s(k88)\sbuild/i                                         // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i                         // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(zur\d{3})\s+build/i                              // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i                         // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [

            /(android).+[;\/]\s+([YR]\d{2})\s+build/i,
            /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i        // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i                            // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i                    // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [                    // Voice Xtreme Phones

            /android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i                     // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [

            /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i          // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i          // Le Pan Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i                         // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i                // Trinity Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*TU_(1491)\s+build/i                               // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [

            /android.+(KS(.+))\s+build/i                                        // Amazon Kindle Tablets
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [

            /android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i                      // Gigaset Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /\s(tablet|tab)[;\/]/i,                                             // Unidentifiable Tablet
            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
            ], [[TYPE, util.lowerize], VENDOR, MODEL], [

            /(android[\w\.\s\-]{0,9});.+build/i                                 // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]


        /*//////////////////////////
            // TODO: move to string map
            ////////////////////////////

            /(C6603)/i                                                          // Sony Xperia Z C6603
            ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
            /(C6903)/i                                                          // Sony Xperia Z 1
            ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
            ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
            ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
            ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G313HZ)/i                                                      // Samsung Galaxy V
            ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
            ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
            /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
            ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
            ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [

            /(T3C)/i                                                            // Advan Vandroid T3C
            ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
            /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
            ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
            /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
            ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [

            /(V972M)/i                                                          // ZTE V972M
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [

            /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
            ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
            /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
            ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [

            /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
            ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [

            /////////////
            // END TODO
            ///////////*/

        ],

        engine : [[

            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, 'EdgeHTML']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,     // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9}).+(gecko)/i                                       // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows based
            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,                   // Windows Phone
            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [

            // Mobile/Embedded OS
            /\((bb)(10);/i                                                      // BlackBerry 10
            ], [[NAME, 'BlackBerry'], VERSION], [
            /(blackberry)\w*\/?([\w\.]*)/i,                                     // Blackberry
            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]*)/i,
                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
            /linux;.+(sailfish);/i                                              // Sailfish OS
            ], [NAME, VERSION], [
            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i                  // Symbian
            ], [[NAME, 'Symbian'], VERSION], [
            /\((series40);/i                                                    // Series 40
            ], [NAME], [
            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
            ], [[NAME, 'Firefox OS'], VERSION], [

            // Console
            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation

            // GNU/Linux based
            /(mint)[\/\s\(]?(\w*)/i,                                            // Mint
            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
            /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,
                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
            /(hurd|linux)\s?([\w\.]*)/i,                                        // Hurd/Linux
            /(gnu)\s?([\w\.]*)/i                                                // GNU
            ], [NAME, VERSION], [

            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Solaris
            /(sunos)\s?([\w\.\d]*)/i                                            // Solaris
            ], [[NAME, 'Solaris'], VERSION], [

            // BSD based
            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i                    // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
            ], [NAME, VERSION],[

            /(haiku)\s(\w+)/i                                                   // Haiku
            ], [NAME, VERSION],[

            /cfnetwork\/.+darwin/i,
            /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i             // iOS
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [

            /(mac\sos\sx)\s?([\w\s\.]*)/i,
            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Other
            /((?:open)?solaris)[\/\s-]?([\w\.]*)/i,                             // Solaris
            /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,                                // AIX
            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,
                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS
            /(unix)\s?([\w\.]*)/i                                               // UNIX
            ], [NAME, VERSION]
        ]
    };


    /////////////////
    // Constructor
    ////////////////
    /*
    var Browser = function (name, version) {
        this[NAME] = name;
        this[VERSION] = version;
    };
    var CPU = function (arch) {
        this[ARCHITECTURE] = arch;
    };
    var Device = function (vendor, model, type) {
        this[VENDOR] = vendor;
        this[MODEL] = model;
        this[TYPE] = type;
    };
    var Engine = Browser;
    var OS = Browser;
    */
    var UAParser = function (uastring, extensions) {

        if (typeof uastring === 'object') {
            extensions = uastring;
            uastring = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(uastring, extensions).getResult();
        }

        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
        //var browser = new Browser();
        //var cpu = new CPU();
        //var device = new Device();
        //var engine = new Engine();
        //var os = new OS();

        this.getBrowser = function () {
            var browser = { name: undefined, version: undefined };
            mapper.rgx.call(browser, ua, rgxmap.browser);
            browser.major = util.major(browser.version); // deprecated
            return browser;
        };
        this.getCPU = function () {
            var cpu = { architecture: undefined };
            mapper.rgx.call(cpu, ua, rgxmap.cpu);
            return cpu;
        };
        this.getDevice = function () {
            var device = { vendor: undefined, model: undefined, type: undefined };
            mapper.rgx.call(device, ua, rgxmap.device);
            return device;
        };
        this.getEngine = function () {
            var engine = { name: undefined, version: undefined };
            mapper.rgx.call(engine, ua, rgxmap.engine);
            return engine;
        };
        this.getOS = function () {
            var os = { name: undefined, version: undefined };
            mapper.rgx.call(os, ua, rgxmap.os);
            return os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return ua;
        };
        this.setUA = function (uastring) {
            ua = uastring;
            //browser = new Browser();
            //cpu = new CPU();
            //device = new Device();
            //engine = new Engine();
            //os = new OS();
            return this;
        };
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
        NAME    : NAME,
        MAJOR   : MAJOR, // deprecated
        VERSION : VERSION
    };
    UAParser.CPU = {
        ARCHITECTURE : ARCHITECTURE
    };
    UAParser.DEVICE = {
        MODEL   : MODEL,
        VENDOR  : VENDOR,
        TYPE    : TYPE,
        CONSOLE : CONSOLE,
        MOBILE  : MOBILE,
        SMARTTV : SMARTTV,
        TABLET  : TABLET,
        WEARABLE: WEARABLE,
        EMBEDDED: EMBEDDED
    };
    UAParser.ENGINE = {
        NAME    : NAME,
        VERSION : VERSION
    };
    UAParser.OS = {
        NAME    : NAME,
        VERSION : VERSION
    };
    //UAParser.Utils = util;

    ///////////
    // Export
    //////////


    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        // TODO: test!!!!!!!!
        /*
        if (require && require.main === module && process) {
            // cli
            var jsonize = function (arr) {
                var res = [];
                for (var i in arr) {
                    res.push(new UAParser(arr[i]).getResult());
                }
                process.stdout.write(JSON.stringify(res, null, 2) + '\n');
            };
            if (process.stdin.isTTY) {
                // via args
                jsonize(process.argv.slice(2));
            } else {
                // via pipe
                var str = '';
                process.stdin.on('readable', function() {
                    var read = process.stdin.read();
                    if (read !== null) {
                        str += read;
                    }
                });
                process.stdin.on('end', function () {
                    jsonize(str.replace(/\n$/, '').split('\n'));
                });
            }
        }
        */
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__(2808)) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
                return UAParser;
            }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (window) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = window && (window.jQuery || window.Zepto);
    if (typeof $ !== UNDEF_TYPE) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (uastring) {
            parser.setUA(uastring);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),
/* 2756 */,
/* 2757 */,
/* 2758 */,
/* 2759 */,
/* 2760 */,
/* 2761 */,
/* 2762 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/a2ca2d9ce6571f5fa699fcc28e7bdf5f.svg";

/***/ }),
/* 2763 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/a2ca2d9ce6571f5fa699fcc28e7bdf5f.svg";

/***/ }),
/* 2764 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ec3ccf55585771612fda848db85d3f35.svg";

/***/ }),
/* 2765 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOS4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA0OCA0OCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDggNDg7IGZpbGw6I2YyMjYxMzsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGcgaWQ9Im1hcC1tYXJrZXJfMl8iPg0KCTxwYXRoIGlkPSJtYXAtbWFya2VyXzRfIiBkPSJNMzMuOTQzLDIxLjE3YzAsMS43NjEtMC4zNjcsMy42NzctMS40NTQsNS40MDFjLTMuMjc2LDUuMDg3LTcuNDIyLDkuNzU2LTcuNDIyLDkuNzU2DQoJCXMtNC43NjctNC41MDUtNy44MTItOS44NDhjLTAuNzYzLTEuNjY3LTEuMjYyLTMuNDMyLTEuMjYyLTUuMTk5YzAtNC45NjcsNC4wMTctOS4yODEsOC45NzUtOS4yODENCgkJQzI5LjkyNiwxMiwzMy45NDMsMTYuMjA0LDMzLjk0MywyMS4xN3ogTTMwLjQxNSwyMC44MDdjMC0yLjk2Ny0yLjQwMy01LjM2Ny01LjM2Ni01LjM2N2MtMi45NjMsMC01LjM2NiwyLjM5OS01LjM2Niw1LjM2Nw0KCQljMCwyLjk2NSwyLjQwMyw1LjM2NSw1LjM2Niw1LjM2NUMyOC4wMTIsMjYuMTcyLDMwLjQxNSwyMy43NzIsMzAuNDE1LDIwLjgwN3oiLz4NCjwvZz4NCjwvc3ZnPg0K"

/***/ }),
/* 2766 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDE0OTAgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjE5MTIiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTQuNSIgaGVpZ2h0PSIxMCI+PGRlZnM+PHN0eWxlIHR5cGU9InRleHQvY3NzIj48IVtDREFUQVsKCl1dPjwvc3R5bGU+PC9kZWZzPjxwYXRoIGQ9Ik0xNDkzLjIxMiAwdjE3MC42ODZoLTEwMjMuNTQ2di0xNzAuNjg2aDEwMjMuNTQ2ek0yOTkuMzIzIDMyMC40NDh2MzQxLjE0NGwtMjk1LjQzMS0xNzAuNjg2IDI5NS40MzEtMTcwLjQ1OHpNMTQ5My4zMjYgNDI2LjY1N3YxNzAuNjg2aC0xMDIzLjU0NnYtMTcwLjY4NmgxMDIzLjU0NnpNMTQ5My4yMTMgODUzLjMxNHYxNzAuNjg2aC0xMDIzLjU0NnYtMTcwLjY4NmgxMDIzLjU0NnoiIHAtaWQ9IjE5MTMiIGZpbGw9IiNEQURGRTEiPjwvcGF0aD48L3N2Zz4K"

/***/ }),
/* 2767 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDE0OTAgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjIxMzAiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTQuNSIgaGVpZ2h0PSIxMCI+PGRlZnM+PHN0eWxlIHR5cGU9InRleHQvY3NzIj48IVtDREFUQVsKCl1dPjwvc3R5bGU+PC9kZWZzPjxwYXRoIGQ9Ik0wLjExMzcxNSAxMDI0IDAuMTEzNzE1IDg1My4zMTQzODEgMTAyMy42NTg4NTYgODUzLjMxNDM4MSAxMDIzLjY1ODg1NiAxMDI0IDAuMTEzNzE1IDEwMjRaTTExOTQuMDAzMzMxIDcwMy41NTIyNDkgMTE5NC4wMDMzMzEgMzYyLjQwODQ0IDE0ODkuNDMzODcgNTMzLjA5NDA1OSAxMTk0LjAwMzMzMSA3MDMuNTUyMjQ5Wk0wIDU5Ny4zNDI4MSAwIDQyNi42NTcxOSAxMDIzLjU0NTE0MiA0MjYuNjU3MTkgMTAyMy41NDUxNDIgNTk3LjM0MjgxIDAgNTk3LjM0MjgxWk0wLjExMzcxNSAxNzAuNjg1NjE5IDAuMTEzNzE1IDAgMTAyMy42NTg4NTYgMCAxMDIzLjY1ODg1NiAxNzAuNjg1NjE5IDAuMTEzNzE1IDE3MC42ODU2MTlaIiBwLWlkPSIyMTMxIiBmaWxsPSIjREFERkUxIj48L3BhdGg+PC9zdmc+Cg=="

/***/ }),
/* 2768 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2769 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBoZWlnaHQ9IjE2IiB3aWR0aD0iMTYiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj4KICA8ZGVmcz4KICAgIDxwYXRoIGlkPSJhIiBmaWxsPSIjZmZkZTAwIiBkPSJNLjk1LS4zMUwtLjU4Ny44MSAwLTEgLjU4OC44MS0uOTUyLS4zMXoiLz4KICA8L2RlZnM+CiAgPHBhdGggZD0iTTAgMGg1MTJ2NTEySDB6IiBmaWxsPSIjZGUyOTEwIi8+CiAgPHVzZSB4bGluazpocmVmPSIjYSIgdHJhbnNmb3JtPSJtYXRyaXgoNzYuOCAwIDAgNzYuOCAxMjggMTI4KSIgd2lkdGg9IjMwIiBoZWlnaHQ9IjIwIi8+CiAgPHVzZSB4bGluazpocmVmPSIjYSIgdHJhbnNmb3JtPSJtYXRyaXgoLTEzLjE1ODQgLTIxLjkzOTIgMjEuOTM5MiAtMTMuMTU4NCAyNTYgNTEuMikiIHdpZHRoPSIzMCIgaGVpZ2h0PSIyMCIvPgogIDx1c2UgeGxpbms6aHJlZj0iI2EiIHRyYW5zZm9ybT0icm90YXRlKC05OC4xMDYgMTk4LjAxNiAtODIuMDc4KSBzY2FsZSgyNS42KSIgd2lkdGg9IjMwIiBoZWlnaHQ9IjIwIi8+CiAgPHVzZSB4bGluazpocmVmPSIjYSIgdHJhbnNmb3JtPSJtYXRyaXgoNy4wNCAtMjQuNjI3MiAyNC42MjcyIDcuMDQgMzA3LjIgMTc5LjIpIiB3aWR0aD0iMzAiIGhlaWdodD0iMjAiLz4KICA8dXNlIHhsaW5rOmhyZWY9IiNhIiB0cmFuc2Zvcm09Im1hdHJpeCgxNiAtMTkuOTY4IDE5Ljk2OCAxNiAyNTYgMjMwLjQpIiB3aWR0aD0iMzAiIGhlaWdodD0iMjAiLz4KPC9zdmc+Cg=="

/***/ }),
/* 2770 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMTYiIHdpZHRoPSIxNiIgdmlld0JveD0iMCAwIDUxMiA1MTIiPgogIDxkZWZzPgogICAgPGNsaXBQYXRoIGlkPSJhIj4KICAgICAgPHBhdGggZmlsbC1vcGFjaXR5PSIuNjciIGQ9Ik0yNTAgMGg1MDB2NTAwSDI1MHoiLz4KICAgIDwvY2xpcFBhdGg+CiAgPC9kZWZzPgogIDxnIGNsaXAtcGF0aD0idXJsKCNhKSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI1Nikgc2NhbGUoMS4wMjQpIj4KICAgIDxnIHN0cm9rZS13aWR0aD0iMXB0Ij4KICAgICAgPHBhdGggZmlsbD0iIzAwNiIgZD0iTTAgMGgxMDAwLjAydjUwMC4wMUgweiIvPgogICAgICA8cGF0aCBkPSJNMCAwdjU1LjkwM2w4ODguMjE4IDQ0NC4xMWgxMTEuODAyVjQ0NC4xMUwxMTEuODAyLjAwM0gwem0xMDAwLjAyIDB2NTUuOUwxMTEuODAyIDUwMC4wMUgwdi01NS45TDg4OC4yMTggMGgxMTEuODAyeiIgZmlsbD0iI2ZmZiIvPgogICAgICA8cGF0aCBkPSJNNDE2LjY3NSAwdjUwMC4wMWgxNjYuNjdWMGgtMTY2LjY3ek0wIDE2Ni42N3YxNjYuNjdoMTAwMC4wMlYxNjYuNjdIMHoiIGZpbGw9IiNmZmYiLz4KICAgICAgPHBhdGggZD0iTTAgMjAwLjAwNHYxMDAuMDAyaDEwMDAuMDJWMjAwLjAwNEgwek00NTAuMDEgMHY1MDAuMDFoMTAwVjBoLTEwMHpNMCA1MDAuMDFsMzMzLjM0LTE2Ni42N2g3NC41MzVMNzQuNTM1IDUwMC4wMUgwek0wIDBsMzMzLjM0IDE2Ni42N2gtNzQuNTM1TDAgMzcuMjdWMHptNTkyLjE0NSAxNjYuNjdMOTI1LjQ4NSAwaDc0LjUzNUw2NjYuNjggMTY2LjY3aC03NC41MzV6bTQwNy44NzUgMzMzLjM0TDY2Ni42OCAzMzMuMzRoNzQuNTM1bDI1OC44MDUgMTI5LjQwM3YzNy4yNjd6IiBmaWxsPSIjYzAwIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),
/* 2771 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2772 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2773 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2774 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2775 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2776 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2777 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNDgzMDE2NjI3NTI0IiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjUgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjE1NzUiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTQiIGhlaWdodD0iMTQiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTkzMy44NzUgNjY3Ljc2OXYtNDE1LjM5OGMwLTg5LjU3OC03Mi42NC0xNjIuMjQ3LTE2Mi4yNDctMTYyLjI0N2gtNTE5LjI1N2MtODkuNTc4IDAtMTYyLjI0NyA3Mi42NC0xNjIuMjQ3IDE2Mi4yNDd2NTE5LjI1N2MwIDg5LjU3OCA3Mi42NCAxNjIuMjQ3IDE2Mi4yNDcgMTYyLjI0N2g1MTkuMjU3Yzc5LjgzMyAwIDE0Ni4yMzQtNTcuNjk0IDE1OS43MzktMTMzLjY3NC00My4wMTAtMTguNTAzLTIyOS41NC05OS4wMzAtMzI2LjY1OS0xNDUuNDgzLTczLjkwOSA4OS41MzktMTUxLjM0MiAxNDMuMjY0LTI2OC4wNTggMTQzLjI2NC0xMTYuNzE2IDAtMTk0LjYwMi03MS43OTgtMTg1LjIxMi0xNTkuODMxIDYuMTYzLTU3Ljc4IDQ1Ljc4LTE1Mi4xMTIgMjE3Ljc3NS0xMzUuODg3IDkwLjY1MSA4LjU1MiAxMzIuMTYyIDI1LjQ2MiAyMDYuMTYzIDQ5LjgyMiAxOS4wMTYtMzUuMDQ1IDM0Ljk3OS03My42NDMgNDYuOTYyLTExNC43MjZoLTMyNy43NjF2LTMyLjQ1MmgxNjIuMTQzdi01OC40MTNoLTE5Ny44MTl2LTM1LjY5N2gxOTcuODE5di04NC4xNTFjMCAwIDEuODY0LTEzLjIwNSAxNi4zMzktMTMuMjA1aDgxLjEzdjk3LjM1NmgyMTAuOTM3djM1LjY5N2gtMjEwLjkzOHY1OC40MTNoMTcxLjk5NWMtMTUuNzY5IDY0LjQzNy0zOS43MTggMTIzLjU0Ny02OS43OTMgMTc1LjI3OCA1MC4wMzAgMTguMDQ4IDI3Ny40ODUgODcuNTgzIDI3Ny40ODUgODcuNTgzIDAgMCAwIDAgMCAwek0zMjMuNzc5IDc0Mi40MDdjLTEyMy4zMTggMC0xNDIuNzg4LTc3Ljg4NS0xMzYuMjk4LTExMC4zMzdzNDIuMTg4LTc0LjY0IDExMC43NDMtNzQuNjRjNzguODMzIDAgMTQ5LjMxNiAyMC4xMTQgMjM0LjAzMyA2MS4zNzctNTkuNDI0IDc3LjQ0LTEzMi41NzUgMTIzLjYtMjA4LjQ3NyAxMjMuNnoiIHAtaWQ9IjE1NzYiIGZpbGw9IiNmZmZmZmYiPjwvcGF0aD48L3N2Zz4="

/***/ }),
/* 2778 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2779 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2780 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2781 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2782 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2783 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2784 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2785 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDMyIDMyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MS40MTQyMTsiPjxnPjxnPjxwYXRoIGQ9Ik0zMC40MDYsMjYuNzkxYzAsMC43MjUgLTAuNjYsMS4zMjMgLTEuNDQ3LDEuMzIzbC0yNS40MTgsMGMtMC44MDMsMCAtMS40NDgsLTAuNTk4IC0xLjQ0OCwtMS4zMjNsMCwtMTcuMjMyYzAsLTAuNzI1IDAuNjYxLC0xLjMyMyAxLjQ0OCwtMS4zMjNsMjUuNDE4LDBjMC44MDIsMCAxLjQ0NywwLjU5OCAxLjQ0NywxLjMyM2wwLDE3LjIzMiIgc3R5bGU9ImZpbGw6I2I5Y2VjZTtmaWxsLXJ1bGU6bm9uemVybzsiLz48cGF0aCBkPSJNMjguOTU5LDI1LjQ3YzAsMC4zOTMgLTAuMzMxLDAuNzIzIC0wLjcyNSwwLjcyM2wtMjMuOTY5LDBjLTAuMzkzLDAgLTAuNzI0LC0wLjMzIC0wLjcyNCwtMC43MjNsMCwtMTQuODg5bDI1LjQxOCwwbDAsMTQuODg5IiBzdHlsZT0iZmlsbDojZWVmMmYwO2ZpbGwtcnVsZTpub256ZXJvOyIvPjxyZWN0IHg9IjQuNjI3IiB5PSIxMi4wMjkiIHdpZHRoPSI3LjQxMyIgaGVpZ2h0PSIxLjA4NiIgc3R5bGU9ImZpbGw6IzQzZDNiMzsiLz48cmVjdCB4PSI0LjYyNyIgeT0iMTQuNTYzIiB3aWR0aD0iMjMuNDgyIiBoZWlnaHQ9IjEuMDg2IiBzdHlsZT0iZmlsbDojYjljZWNlOyIvPjxyZWN0IHg9IjQuNjI3IiB5PSIxNi43NTEiIHdpZHRoPSIyMy40ODIiIGhlaWdodD0iMS4wODYiIHN0eWxlPSJmaWxsOiNiOWNlY2U7Ii8+PHJlY3QgeD0iNC42MjciIHk9IjE4LjkyMyIgd2lkdGg9IjIzLjQ4MiIgaGVpZ2h0PSIxLjA4NiIgc3R5bGU9ImZpbGw6I2I5Y2VjZTsiLz48cmVjdCB4PSI0LjYyNyIgeT0iMjEuMTEiIHdpZHRoPSIyMy40ODIiIGhlaWdodD0iMS4wODYiIHN0eWxlPSJmaWxsOiNiOWNlY2U7Ii8+PHJlY3QgeD0iNC42MjciIHk9IjIzLjI4MiIgd2lkdGg9IjIzLjQ4MiIgaGVpZ2h0PSIxLjA4NiIgc3R5bGU9ImZpbGw6I2I5Y2VjZTsiLz48cmVjdCB4PSIxMi43MDEiIHk9IjEyLjAyOSIgd2lkdGg9IjcuNDEzIiBoZWlnaHQ9IjEuMDg2IiBzdHlsZT0iZmlsbDojNDNkM2IzOyIvPjxyZWN0IHg9IjIwLjY4IiB5PSIxMi4wMjkiIHdpZHRoPSI3LjQxMyIgaGVpZ2h0PSIxLjA4NiIgc3R5bGU9ImZpbGw6IzQzZDNiMzsiLz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),
/* 2786 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2787 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2788 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjE3NjUiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCI+PGRlZnM+PHN0eWxlIHR5cGU9InRleHQvY3NzIj48IVtDREFUQVsKCl1dPjwvc3R5bGU+PC9kZWZzPjxwYXRoIGQ9Ik02NDAgMEgxMjhhNjQgNjQgMCAwIDAtNjQgNjR2ODk2YTY0IDY0IDAgMCAwIDY0IDY0aDc2OGE2NCA2NCAwIDAgMCA2NC02NFYzMjBMNjQwIDB6IiBmaWxsPSIjM0FBRDczIiBwLWlkPSIxNzY2Ij48L3BhdGg+PHBhdGggZD0iTTY0MCAwdjI1NmE2NCA2NCAwIDAgMCA2NCA2NGgyNTZMNjQwIDB6IiBmaWxsPSIjNDM0ODU0IiBwLWlkPSIxNzY3Ij48L3BhdGg+PHBhdGggZD0iTTcwNCAzMjBsMjU2IDI1NnYtMjU2eiIgZmlsbD0iIiBwLWlkPSIxNzY4Ij48L3BhdGg+PHBhdGggZD0iTTc0OC44IDQ3MS44MDhjLTI0LjU0NC0yNC41MTItNzAuNjI0LTE4LjExMi05NS4xMzYgNi4zNjhsLTIwMi4zMDQgMjAyLjMwNC04OC43MzYtODguNzM2YTYyLjc4NCA2Mi43ODQgMCAwIDAtODguNzY4IDg4LjczNmwxMzMuMTUyIDEzMy4xNTJhNjIuNzg0IDYyLjc4NCAwIDAgMCA4OC43MzYgMGwyNTUuMjY0LTI1MS4yMzJjMjQuNDQ4LTI0LjQ0OCAyMi4yNzItNjYuMDgtMi4yMDgtOTAuNTkyeiIgZmlsbD0iI0ZGRkZGRiIgcC1pZD0iMTc2OSI+PC9wYXRoPjwvc3ZnPg=="

/***/ }),
/* 2789 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/779e6fab5971d4d6c72b1605385030b1.svg";

/***/ }),
/* 2790 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTA3NDQ0NDI3MTgxIiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjM1MjAiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTIzNy43ODEgNTIxLjg0N2MwIDE1NS4zMjggMTI1LjkxOSAyODEuMjQ3IDI4MS4yNDcgMjgxLjI0N3MyODEuMjQ3LTEyNS45MTkgMjgxLjI0Ny0yODEuMjQ3YzAtMTU1LjMyOC0xMjUuOTE5LTI4MS4yNDctMjgxLjI0Ny0yODEuMjQ3LTE1NS4zMjggMC0yODEuMjQ3IDEyNS45MTktMjgxLjI0NyAyODEuMjQ3eiIgZmlsbD0iI2NkY2RjZCIgcC1pZD0iMzUyMSI+PC9wYXRoPjwvc3ZnPg=="

/***/ }),
/* 2791 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/b001e6b1866660a512ee7c6e0455f0bb.svg";

/***/ }),
/* 2792 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgMy4xNSAyLjM5Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6bm9uZTt9LmNscy0ye2lzb2xhdGlvbjppc29sYXRlO2ZvbnQtc2l6ZTowLjU4cHg7Zm9udC1mYW1pbHk6QWt0aXZHcm90ZXNrLUJvbGQsIEFrdGl2IEdyb3Rlc2s7Zm9udC13ZWlnaHQ6NzAwO30uY2xzLTIsLmNscy00e2ZpbGw6I2ZmZjt9LmNscy0ze2NsaXAtcGF0aDp1cmwoI2NsaXAtcGF0aCk7fTwvc3R5bGU+PGNsaXBQYXRoIGlkPSJjbGlwLXBhdGgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgeT0iMC4xNCIgd2lkdGg9IjIuMTciIGhlaWdodD0iMi4yNSIvPjwvY2xpcFBhdGg+PC9kZWZzPjx0aXRsZT7otYTmupAgMTwvdGl0bGU+PGcgaWQ9IuWbvuWxgl8yIiBkYXRhLW5hbWU9IuWbvuWxgiAyIj48ZyBpZD0i5Zu+5bGCXzEtMiIgZGF0YS1uYW1lPSLlm77lsYIgMSI+PHRleHQgY2xhc3M9ImNscy0yIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjg2IDAuNSkiPlRETTwvdGV4dD48ZyBjbGFzcz0iY2xzLTMiPjxwYXRoIGNsYXNzPSJjbHMtNCIgZD0iTTEuODYsMS43N2EuMy4zLDAsMCwwLS4zLjI1SC43OWEuMzUuMzUsMCwwLDEsMC0uMTdIMWEuMTkuMTksMCwxLDAsLjE4LS4zMS4xOS4xOSwwLDAsMC0uMjIuMTVILjcyYzAtLjE1LS4wOS0uMzEtLjI5LS4zMUguMDhhLjA4LjA4LDAsMCwwLDAsLjE2SC40M2MuMDgsMCwuMTEsMCwuMTQuMTVILjA4YS4wOC4wOCwwLDAsMCwwLC4xNkguNTljMCwuMTQsMCwuMzIuMi4zMmguNzdhLjMxLjMxLDAsMSwwLC4zLS40Wm0wLC40NmEuMTQuMTQsMCwwLDEtLjEzLS4wNy4xNS4xNSwwLDAsMSwwLS4xNi4xMy4xMywwLDAsMSwuMTMtLjA4QS4xNS4xNSwwLDAsMSwyLDIuMDhhLjE1LjE1LDAsMCwxLS4xNS4xNVptLTEuNzgtMUgxYS4zMS4zMSwwLDEsMCwwLS4xNUguMDhhLjA4LjA4LDAsMCwwLDAsLjE2Wk0xLjMyLDFhLjE2LjE2LDAsMCwxLC4xMy4wOC4xNS4xNSwwLDAsMSwwLC4xNi4xNy4xNywwLDAsMS0uMTMuMDcuMTYuMTYsMCwwLDEtLjE2LS4xNUEuMTYuMTYsMCwwLDEsMS4zMiwxWk0uMDguOTNILjQzQy42OS45My43Mi43MS43NC41OFMuNzcuNDUuNzkuNDVoLjcyYS4xOS4xOSwwLDAsMCwuMzUtLjFBLjIuMiwwLDAsMCwxLjY5LjE0LjIuMiwwLDAsMCwxLjQ4LjNILjc5Qy42My4zLjYxLjQ1LjU5LjU2Uy41NS43OC40My43OEguMDhBLjA3LjA3LDAsMCwwLDAsLjg1LjA3LjA3LDAsMCwwLC4wOC45M1oiLz48L2c+PC9nPjwvZz48L3N2Zz4="

/***/ }),
/* 2793 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2794 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2795 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2796 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2797 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2798 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2799 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2800 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2801 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2802 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2803 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjE3NjUiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCI+PGRlZnM+PHN0eWxlIHR5cGU9InRleHQvY3NzIj48IVtDREFUQVsKCl1dPjwvc3R5bGU+PC9kZWZzPjxwYXRoIGQ9Ik02NDAgMEgxMjhhNjQgNjQgMCAwIDAtNjQgNjR2ODk2YTY0IDY0IDAgMCAwIDY0IDY0aDc2OGE2NCA2NCAwIDAgMCA2NC02NFYzMjBMNjQwIDB6IiBmaWxsPSIjM0FBRDczIiBwLWlkPSIxNzY2Ij48L3BhdGg+PHBhdGggZD0iTTY0MCAwdjI1NmE2NCA2NCAwIDAgMCA2NCA2NGgyNTZMNjQwIDB6IiBmaWxsPSIjNDM0ODU0IiBwLWlkPSIxNzY3Ij48L3BhdGg+PHBhdGggZD0iTTcwNCAzMjBsMjU2IDI1NnYtMjU2eiIgZmlsbD0iIiBwLWlkPSIxNzY4Ij48L3BhdGg+PHBhdGggZD0iTTc0OC44IDQ3MS44MDhjLTI0LjU0NC0yNC41MTItNzAuNjI0LTE4LjExMi05NS4xMzYgNi4zNjhsLTIwMi4zMDQgMjAyLjMwNC04OC43MzYtODguNzM2YTYyLjc4NCA2Mi43ODQgMCAwIDAtODguNzY4IDg4LjczNmwxMzMuMTUyIDEzMy4xNTJhNjIuNzg0IDYyLjc4NCAwIDAgMCA4OC43MzYgMGwyNTUuMjY0LTI1MS4yMzJjMjQuNDQ4LTI0LjQ0OCAyMi4yNzItNjYuMDgtMi4yMDgtOTAuNTkyeiIgZmlsbD0iI0ZGRkZGRiIgcC1pZD0iMTc2OSI+PC9wYXRoPjwvc3ZnPg=="

/***/ }),
/* 2804 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2805 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjE3NjUiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCI+PGRlZnM+PHN0eWxlIHR5cGU9InRleHQvY3NzIj48IVtDREFUQVsKCl1dPjwvc3R5bGU+PC9kZWZzPjxwYXRoIGQ9Ik02NDAgMEgxMjhhNjQgNjQgMCAwIDAtNjQgNjR2ODk2YTY0IDY0IDAgMCAwIDY0IDY0aDc2OGE2NCA2NCAwIDAgMCA2NC02NFYzMjBMNjQwIDB6IiBmaWxsPSIjM0FBRDczIiBwLWlkPSIxNzY2Ij48L3BhdGg+PHBhdGggZD0iTTY0MCAwdjI1NmE2NCA2NCAwIDAgMCA2NCA2NGgyNTZMNjQwIDB6IiBmaWxsPSIjNDM0ODU0IiBwLWlkPSIxNzY3Ij48L3BhdGg+PHBhdGggZD0iTTcwNCAzMjBsMjU2IDI1NnYtMjU2eiIgZmlsbD0iIiBwLWlkPSIxNzY4Ij48L3BhdGg+PHBhdGggZD0iTTc0OC44IDQ3MS44MDhjLTI0LjU0NC0yNC41MTItNzAuNjI0LTE4LjExMi05NS4xMzYgNi4zNjhsLTIwMi4zMDQgMjAyLjMwNC04OC43MzYtODguNzM2YTYyLjc4NCA2Mi43ODQgMCAwIDAtODguNzY4IDg4LjczNmwxMzMuMTUyIDEzMy4xNTJhNjIuNzg0IDYyLjc4NCAwIDAgMCA4OC43MzYgMGwyNTUuMjY0LTI1MS4yMzJjMjQuNDQ4LTI0LjQ0OCAyMi4yNzItNjYuMDgtMi4yMDgtOTAuNTkyeiIgZmlsbD0iI0ZGRkZGRiIgcC1pZD0iMTc2OSI+PC9wYXRoPjwvc3ZnPg=="

/***/ }),
/* 2806 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/d0992d8063a0b7b2d67d4c0d24b207e8.png";

/***/ }),
/* 2807 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/7662cb14bc17049bf30f105a49c82ec3.png";

/***/ }),
/* 2808 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 2809 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 2810 */,
/* 2811 */,
/* 2812 */,
/* 2813 */,
/* 2814 */,
/* 2815 */,
/* 2816 */,
/* 2817 */,
/* 2818 */,
/* 2819 */,
/* 2820 */,
/* 2821 */,
/* 2822 */,
/* 2823 */,
/* 2824 */,
/* 2825 */,
/* 2826 */,
/* 2827 */,
/* 2828 */,
/* 2829 */,
/* 2830 */,
/* 2831 */,
/* 2832 */,
/* 2833 */,
/* 2834 */,
/* 2835 */,
/* 2836 */,
/* 2837 */,
/* 2838 */,
/* 2839 */,
/* 2840 */,
/* 2841 */,
/* 2842 */,
/* 2843 */,
/* 2844 */,
/* 2845 */,
/* 2846 */,
/* 2847 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.10.0
var feedback, scoring;

scoring = __webpack_require__(599);

feedback = {
  default_feedback: {
    warning: '',
    suggestions: ["Use a few words, avoid common phrases", "No need for symbols, digits, or uppercase letters"]
  },
  get_feedback: function(score, sequence) {
    var extra_feedback, i, len, longest_match, match, ref;
    if (sequence.length === 0) {
      return this.default_feedback;
    }
    if (score > 2) {
      return {
        warning: '',
        suggestions: []
      };
    }
    longest_match = sequence[0];
    ref = sequence.slice(1);
    for (i = 0, len = ref.length; i < len; i++) {
      match = ref[i];
      if (match.token.length > longest_match.token.length) {
        longest_match = match;
      }
    }
    feedback = this.get_match_feedback(longest_match, sequence.length === 1);
    extra_feedback = 'Add another word or two. Uncommon words are better.';
    if (feedback != null) {
      feedback.suggestions.unshift(extra_feedback);
      if (feedback.warning == null) {
        feedback.warning = '';
      }
    } else {
      feedback = {
        warning: '',
        suggestions: [extra_feedback]
      };
    }
    return feedback;
  },
  get_match_feedback: function(match, is_sole_match) {
    var layout, warning;
    switch (match.pattern) {
      case 'dictionary':
        return this.get_dictionary_match_feedback(match, is_sole_match);
      case 'spatial':
        layout = match.graph.toUpperCase();
        warning = match.turns === 1 ? 'Straight rows of keys are easy to guess' : 'Short keyboard patterns are easy to guess';
        return {
          warning: warning,
          suggestions: ['Use a longer keyboard pattern with more turns']
        };
      case 'repeat':
        warning = match.base_token.length === 1 ? 'Repeats like "aaa" are easy to guess' : 'Repeats like "abcabcabc" are only slightly harder to guess than "abc"';
        return {
          warning: warning,
          suggestions: ['Avoid repeated words and characters']
        };
      case 'sequence':
        return {
          warning: "Sequences like abc or 6543 are easy to guess",
          suggestions: ['Avoid sequences']
        };
      case 'regex':
        if (match.regex_name === 'recent_year') {
          return {
            warning: "Recent years are easy to guess",
            suggestions: ['Avoid recent years', 'Avoid years that are associated with you']
          };
        }
        break;
      case 'date':
        return {
          warning: "Dates are often easy to guess",
          suggestions: ['Avoid dates and years that are associated with you']
        };
    }
  },
  get_dictionary_match_feedback: function(match, is_sole_match) {
    var ref, result, suggestions, warning, word;
    warning = match.dictionary_name === 'passwords' ? is_sole_match && !match.l33t && !match.reversed ? match.rank <= 10 ? 'This is a top-10 common password' : match.rank <= 100 ? 'This is a top-100 common password' : 'This is a very common password' : match.guesses_log10 <= 4 ? 'This is similar to a commonly used password' : void 0 : match.dictionary_name === 'english_wikipedia' ? is_sole_match ? 'A word by itself is easy to guess' : void 0 : (ref = match.dictionary_name) === 'surnames' || ref === 'male_names' || ref === 'female_names' ? is_sole_match ? 'Names and surnames by themselves are easy to guess' : 'Common names and surnames are easy to guess' : '';
    suggestions = [];
    word = match.token;
    if (word.match(scoring.START_UPPER)) {
      suggestions.push("Capitalization doesn't help very much");
    } else if (word.match(scoring.ALL_UPPER) && word.toLowerCase() !== word) {
      suggestions.push("All-uppercase is almost as easy to guess as all-lowercase");
    }
    if (match.reversed && match.token.length >= 4) {
      suggestions.push("Reversed words aren't much harder to guess");
    }
    if (match.l33t) {
      suggestions.push("Predictable substitutions like '@' instead of 'a' don't help very much");
    }
    result = {
      warning: warning,
      suggestions: suggestions
    };
    return result;
  }
};

module.exports = feedback;

//# sourceMappingURL=feedback.js.map


/***/ }),
/* 2848 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.10.0
var frequency_lists;

frequency_lists = {
  passwords: "123456,password,12345678,qwerty,123456789,12345,1234,111111,1234567,dragon,123123,baseball,abc123,football,monkey,letmein,shadow,master,696969,mustang,666666,qwertyuiop,123321,1234567890,pussy,superman,654321,1qaz2wsx,7777777,fuckyou,qazwsx,jordan,123qwe,000000,killer,trustno1,hunter,harley,zxcvbnm,asdfgh,buster,batman,soccer,tigger,charlie,sunshine,iloveyou,fuckme,ranger,hockey,computer,starwars,asshole,pepper,klaster,112233,zxcvbn,freedom,princess,maggie,pass,ginger,11111111,131313,fuck,love,cheese,159753,summer,chelsea,dallas,biteme,matrix,yankees,6969,corvette,austin,access,thunder,merlin,secret,diamond,hello,hammer,fucker,1234qwer,silver,gfhjkm,internet,samantha,golfer,scooter,test,orange,cookie,q1w2e3r4t5,maverick,sparky,phoenix,mickey,bigdog,snoopy,guitar,whatever,chicken,camaro,mercedes,peanut,ferrari,falcon,cowboy,welcome,sexy,samsung,steelers,smokey,dakota,arsenal,boomer,eagles,tigers,marina,nascar,booboo,gateway,yellow,porsche,monster,spider,diablo,hannah,bulldog,junior,london,purple,compaq,lakers,iceman,qwer1234,hardcore,cowboys,money,banana,ncc1701,boston,tennis,q1w2e3r4,coffee,scooby,123654,nikita,yamaha,mother,barney,brandy,chester,fuckoff,oliver,player,forever,rangers,midnight,chicago,bigdaddy,redsox,angel,badboy,fender,jasper,slayer,rabbit,natasha,marine,bigdick,wizard,marlboro,raiders,prince,casper,fishing,flower,jasmine,iwantu,panties,adidas,winter,winner,gandalf,password1,enter,ghbdtn,1q2w3e4r,golden,cocacola,jordan23,winston,madison,angels,panther,blowme,sexsex,bigtits,spanky,bitch,sophie,asdfasdf,horny,thx1138,toyota,tiger,dick,canada,12344321,blowjob,8675309,muffin,liverpoo,apples,qwerty123,passw0rd,abcd1234,pokemon,123abc,slipknot,qazxsw,123456a,scorpion,qwaszx,butter,startrek,rainbow,asdfghjkl,razz,newyork,redskins,gemini,cameron,qazwsxedc,florida,liverpool,turtle,sierra,viking,booger,butthead,doctor,rocket,159357,dolphins,captain,bandit,jaguar,packers,pookie,peaches,789456,asdf,dolphin,helpme,blue,theman,maxwell,qwertyui,shithead,lovers,maddog,giants,nirvana,metallic,hotdog,rosebud,mountain,warrior,stupid,elephant,suckit,success,bond007,jackass,alexis,porn,lucky,scorpio,samson,q1w2e3,azerty,rush2112,driver,freddy,1q2w3e4r5t,sydney,gators,dexter,red123,123456q,12345a,bubba,creative,voodoo,golf,trouble,america,nissan,gunner,garfield,bullshit,asdfghjk,5150,fucking,apollo,1qazxsw2,2112,eminem,legend,airborne,bear,beavis,apple,brooklyn,godzilla,skippy,4815162342,buddy,qwert,kitten,magic,shelby,beaver,phantom,asdasd,xavier,braves,darkness,blink182,copper,platinum,qweqwe,tomcat,01012011,girls,bigboy,102030,animal,police,online,11223344,voyager,lifehack,12qwaszx,fish,sniper,315475,trinity,blazer,heaven,lover,snowball,playboy,loveme,bubbles,hooters,cricket,willow,donkey,topgun,nintendo,saturn,destiny,pakistan,pumpkin,digital,sergey,redwings,explorer,tits,private,runner,therock,guinness,lasvegas,beatles,789456123,fire,cassie,christin,qwerty1,celtic,asdf1234,andrey,broncos,007007,babygirl,eclipse,fluffy,cartman,michigan,carolina,testing,alexande,birdie,pantera,cherry,vampire,mexico,dickhead,buffalo,genius,montana,beer,minecraft,maximus,flyers,lovely,stalker,metallica,doggie,snickers,speedy,bronco,lol123,paradise,yankee,horses,magnum,dreams,147258369,lacrosse,ou812,goober,enigma,qwertyu,scotty,pimpin,bollocks,surfer,cock,poohbear,genesis,star,asd123,qweasdzxc,racing,hello1,hawaii,eagle1,viper,poopoo,einstein,boobies,12345q,bitches,drowssap,simple,badger,alaska,action,jester,drummer,111222,spitfire,forest,maryjane,champion,diesel,svetlana,friday,hotrod,147258,chevy,lucky1,westside,security,google,badass,tester,shorty,thumper,hitman,mozart,zaq12wsx,boobs,reddog,010203,lizard,a123456,123456789a,ruslan,eagle,1232323q,scarface,qwerty12,147852,a12345,buddha,porno,420420,spirit,money1,stargate,qwe123,naruto,mercury,liberty,12345qwert,semperfi,suzuki,popcorn,spooky,marley,scotland,kitty,cherokee,vikings,simpsons,rascal,qweasd,hummer,loveyou,michael1,patches,russia,jupiter,penguin,passion,cumshot,vfhbyf,honda,vladimir,sandman,passport,raider,bastard,123789,infinity,assman,bulldogs,fantasy,sucker,1234554321,horney,domino,budlight,disney,ironman,usuckballz1,softball,brutus,redrum,bigred,mnbvcxz,fktrcfylh,karina,marines,digger,kawasaki,cougar,fireman,oksana,monday,cunt,justice,nigger,super,wildcats,tinker,logitech,dancer,swordfis,avalon,everton,alexandr,motorola,patriots,hentai,madonna,pussy1,ducati,colorado,connor,juventus,galore,smooth,freeuser,warcraft,boogie,titanic,wolverin,elizabet,arizona,valentin,saints,asdfg,accord,test123,password123,christ,yfnfif,stinky,slut,spiderma,naughty,chopper,hello123,ncc1701d,extreme,skyline,poop,zombie,pearljam,123qweasd,froggy,awesome,vision,pirate,fylhtq,dreamer,bullet,predator,empire,123123a,kirill,charlie1,panthers,penis,skipper,nemesis,rasdzv3,peekaboo,rolltide,cardinal,psycho,danger,mookie,happy1,wanker,chevelle,manutd,goblue,9379992,hobbes,vegeta,fyfcnfcbz,852456,picard,159951,windows,loverboy,victory,vfrcbv,bambam,serega,123654789,turkey,tweety,galina,hiphop,rooster,changeme,berlin,taurus,suckme,polina,electric,avatar,134679,maksim,raptor,alpha1,hendrix,newport,bigcock,brazil,spring,a1b2c3,madmax,alpha,britney,sublime,darkside,bigman,wolfpack,classic,hercules,ronaldo,letmein1,1q2w3e,741852963,spiderman,blizzard,123456789q,cheyenne,cjkysirj,tiger1,wombat,bubba1,pandora,zxc123,holiday,wildcat,devils,horse,alabama,147852369,caesar,12312,buddy1,bondage,pussycat,pickle,shaggy,catch22,leather,chronic,a1b2c3d4,admin,qqq111,qaz123,airplane,kodiak,freepass,billybob,sunset,katana,phpbb,chocolat,snowman,angel1,stingray,firebird,wolves,zeppelin,detroit,pontiac,gundam,panzer,vagina,outlaw,redhead,tarheels,greenday,nastya,01011980,hardon,engineer,dragon1,hellfire,serenity,cobra,fireball,lickme,darkstar,1029384756,01011,mustang1,flash,124578,strike,beauty,pavilion,01012000,bobafett,dbrnjhbz,bigmac,bowling,chris1,ytrewq,natali,pyramid,rulez,welcome1,dodgers,apache,swimming,whynot,teens,trooper,fuckit,defender,precious,135790,packard,weasel,popeye,lucifer,cancer,icecream,142536,raven,swordfish,presario,viktor,rockstar,blonde,james1,wutang,spike,pimp,atlanta,airforce,thailand,casino,lennon,mouse,741852,hacker,bluebird,hawkeye,456123,theone,catfish,sailor,goldfish,nfnmzyf,tattoo,pervert,barbie,maxima,nipples,machine,trucks,wrangler,rocks,tornado,lights,cadillac,bubble,pegasus,madman,longhorn,browns,target,666999,eatme,qazwsx123,microsoft,dilbert,christia,baller,lesbian,shooter,xfiles,seattle,qazqaz,cthutq,amateur,prelude,corona,freaky,malibu,123qweasdzxc,assassin,246810,atlantis,integra,pussies,iloveu,lonewolf,dragons,monkey1,unicorn,software,bobcat,stealth,peewee,openup,753951,srinivas,zaqwsx,valentina,shotgun,trigger,veronika,bruins,coyote,babydoll,joker,dollar,lestat,rocky1,hottie,random,butterfly,wordpass,smiley,sweety,snake,chipper,woody,samurai,devildog,gizmo,maddie,soso123aljg,mistress,freedom1,flipper,express,hjvfirf,moose,cessna,piglet,polaris,teacher,montreal,cookies,wolfgang,scully,fatboy,wicked,balls,tickle,bunny,dfvgbh,foobar,transam,pepsi,fetish,oicu812,basketba,toshiba,hotstuff,sunday,booty,gambit,31415926,impala,stephani,jessica1,hooker,lancer,knicks,shamrock,fuckyou2,stinger,314159,redneck,deftones,squirt,siemens,blaster,trucker,subaru,renegade,ibanez,manson,swinger,reaper,blondie,mylove,galaxy,blahblah,enterpri,travel,1234abcd,babylon5,indiana,skeeter,master1,sugar,ficken,smoke,bigone,sweetpea,fucked,trfnthbyf,marino,escort,smitty,bigfoot,babes,larisa,trumpet,spartan,valera,babylon,asdfghj,yankees1,bigboobs,stormy,mister,hamlet,aardvark,butterfl,marathon,paladin,cavalier,manchester,skater,indigo,hornet,buckeyes,01011990,indians,karate,hesoyam,toronto,diamonds,chiefs,buckeye,1qaz2wsx3edc,highland,hotsex,charger,redman,passwor,maiden,drpepper,storm,pornstar,garden,12345678910,pencil,sherlock,timber,thuglife,insane,pizza,jungle,jesus1,aragorn,1a2b3c,hamster,david1,triumph,techno,lollol,pioneer,catdog,321654,fktrctq,morpheus,141627,pascal,shadow1,hobbit,wetpussy,erotic,consumer,blabla,justme,stones,chrissy,spartak,goforit,burger,pitbull,adgjmptw,italia,barcelona,hunting,colors,kissme,virgin,overlord,pebbles,sundance,emerald,doggy,racecar,irina,element,1478963,zipper,alpine,basket,goddess,poison,nipple,sakura,chichi,huskers,13579,pussys,q12345,ultimate,ncc1701e,blackie,nicola,rommel,matthew1,caserta,omega,geronimo,sammy1,trojan,123qwe123,philips,nugget,tarzan,chicks,aleksandr,bassman,trixie,portugal,anakin,dodger,bomber,superfly,madness,q1w2e3r4t5y6,loser,123asd,fatcat,ybrbnf,soldier,warlock,wrinkle1,desire,sexual,babe,seminole,alejandr,951753,11235813,westham,andrei,concrete,access14,weed,letmein2,ladybug,naked,christop,trombone,tintin,bluesky,rhbcnbyf,qazxswedc,onelove,cdtnkfyf,whore,vfvjxrf,titans,stallion,truck,hansolo,blue22,smiles,beagle,panama,kingkong,flatron,inferno,mongoose,connect,poiuyt,snatch,qawsed,juice,blessed,rocker,snakes,turbo,bluemoon,sex4me,finger,jamaica,a1234567,mulder,beetle,fuckyou1,passat,immortal,plastic,123454321,anthony1,whiskey,dietcoke,suck,spunky,magic1,monitor,cactus,exigen,planet,ripper,teen,spyder,apple1,nolimit,hollywoo,sluts,sticky,trunks,1234321,14789632,pickles,sailing,bonehead,ghbdtnbr,delta,charlott,rubber,911911,112358,molly1,yomama,hongkong,jumper,william1,ilovesex,faster,unreal,cumming,memphis,1123581321,nylons,legion,sebastia,shalom,pentium,geheim,werewolf,funtime,ferret,orion,curious,555666,niners,cantona,sprite,philly,pirates,abgrtyu,lollipop,eternity,boeing,super123,sweets,cooldude,tottenha,green1,jackoff,stocking,7895123,moomoo,martini,biscuit,drizzt,colt45,fossil,makaveli,snapper,satan666,maniac,salmon,patriot,verbatim,nasty,shasta,asdzxc,shaved,blackcat,raistlin,qwerty12345,punkrock,cjkywt,01012010,4128,waterloo,crimson,twister,oxford,musicman,seinfeld,biggie,condor,ravens,megadeth,wolfman,cosmos,sharks,banshee,keeper,foxtrot,gn56gn56,skywalke,velvet,black1,sesame,dogs,squirrel,privet,sunrise,wolverine,sucks,legolas,grendel,ghost,cats,carrot,frosty,lvbnhbq,blades,stardust,frog,qazwsxed,121314,coolio,brownie,groovy,twilight,daytona,vanhalen,pikachu,peanuts,licker,hershey,jericho,intrepid,ninja,1234567a,zaq123,lobster,goblin,punisher,strider,shogun,kansas,amadeus,seven7,jason1,neptune,showtime,muscle,oldman,ekaterina,rfrfirf,getsome,showme,111222333,obiwan,skittles,danni,tanker,maestro,tarheel,anubis,hannibal,anal,newlife,gothic,shark,fighter,blue123,blues,123456z,princes,slick,chaos,thunder1,sabine,1q2w3e4r5t6y,python,test1,mirage,devil,clover,tequila,chelsea1,surfing,delete,potato,chubby,panasonic,sandiego,portland,baggins,fusion,sooners,blackdog,buttons,californ,moscow,playtime,mature,1a2b3c4d,dagger,dima,stimpy,asdf123,gangster,warriors,iverson,chargers,byteme,swallow,liquid,lucky7,dingdong,nymets,cracker,mushroom,456852,crusader,bigguy,miami,dkflbvbh,bugger,nimrod,tazman,stranger,newpass,doodle,powder,gotcha,guardian,dublin,slapshot,septembe,147896325,pepsi1,milano,grizzly,woody1,knights,photos,2468,nookie,charly,rammstein,brasil,123321123,scruffy,munchkin,poopie,123098,kittycat,latino,walnut,1701,thegame,viper1,1passwor,kolobok,picasso,robert1,barcelon,bananas,trance,auburn,coltrane,eatshit,goodluck,starcraft,wheels,parrot,postal,blade,wisdom,pink,gorilla,katerina,pass123,andrew1,shaney14,dumbass,osiris,fuck_inside,oakland,discover,ranger1,spanking,lonestar,bingo,meridian,ping,heather1,dookie,stonecol,megaman,192837465,rjntyjr,ledzep,lowrider,25802580,richard1,firefly,griffey,racerx,paradox,ghjcnj,gangsta,zaq1xsw2,tacobell,weezer,sirius,halflife,buffett,shiloh,123698745,vertigo,sergei,aliens,sobaka,keyboard,kangaroo,sinner,soccer1,0.0.000,bonjour,socrates,chucky,hotboy,sprint,0007,sarah1,scarlet,celica,shazam,formula1,sommer,trebor,qwerasdf,jeep,mailcreated5240,bollox,asshole1,fuckface,honda1,rebels,vacation,lexmark,penguins,12369874,ragnarok,formula,258456,tempest,vfhecz,tacoma,qwertz,colombia,flames,rockon,duck,prodigy,wookie,dodgeram,mustangs,123qaz,sithlord,smoker,server,bang,incubus,scoobydo,oblivion,molson,kitkat,titleist,rescue,zxcv1234,carpet,1122,bigballs,tardis,jimbob,xanadu,blueeyes,shaman,mersedes,pooper,pussy69,golfing,hearts,mallard,12312312,kenwood,patrick1,dogg,cowboys1,oracle,123zxc,nuttertools,102938,topper,1122334455,shemale,sleepy,gremlin,yourmom,123987,gateway1,printer,monkeys,peterpan,mikey,kingston,cooler,analsex,jimbo,pa55word,asterix,freckles,birdman,frank1,defiant,aussie,stud,blondes,tatyana,445566,aspirine,mariners,jackal,deadhead,katrin,anime,rootbeer,frogger,polo,scooter1,hallo,noodles,thomas1,parola,shaolin,celine,11112222,plymouth,creampie,justdoit,ohyeah,fatass,assfuck,amazon,1234567q,kisses,magnus,camel,nopass,bosco,987456,6751520,harley1,putter,champs,massive,spidey,lightnin,camelot,letsgo,gizmodo,aezakmi,bones,caliente,12121,goodtime,thankyou,raiders1,brucelee,redalert,aquarius,456654,catherin,smokin,pooh,mypass,astros,roller,porkchop,sapphire,qwert123,kevin1,a1s2d3f4,beckham,atomic,rusty1,vanilla,qazwsxedcrfv,hunter1,kaktus,cxfcnmt,blacky,753159,elvis1,aggies,blackjac,bangkok,scream,123321q,iforgot,power1,kasper,abc12,buster1,slappy,shitty,veritas,chevrole,amber1,01012001,vader,amsterdam,jammer,primus,spectrum,eduard,granny,horny1,sasha1,clancy,usa123,satan,diamond1,hitler,avenger,1221,spankme,123456qwerty,simba,smudge,scrappy,labrador,john316,syracuse,front242,falcons,husker,candyman,commando,gator,pacman,delta1,pancho,krishna,fatman,clitoris,pineappl,lesbians,8j4ye3uz,barkley,vulcan,punkin,boner,celtics,monopoly,flyboy,romashka,hamburg,123456aa,lick,gangbang,223344,area51,spartans,aaa111,tricky,snuggles,drago,homerun,vectra,homer1,hermes,topcat,cuddles,infiniti,1234567890q,cosworth,goose,phoenix1,killer1,ivanov,bossman,qawsedrf,peugeot,exigent,doberman,durango,brandon1,plumber,telefon,horndog,laguna,rbhbkk,dawg,webmaster,breeze,beast,porsche9,beefcake,leopard,redbull,oscar1,topdog,godsmack,theking,pics,omega1,speaker,viktoria,fuckers,bowler,starbuck,gjkbyf,valhalla,anarchy,blacks,herbie,kingpin,starfish,nokia,loveit,achilles,906090,labtec,ncc1701a,fitness,jordan1,brando,arsenal1,bull,kicker,napass,desert,sailboat,bohica,tractor,hidden,muppet,jackson1,jimmy1,terminator,phillies,pa55w0rd,terror,farside,swingers,legacy,frontier,butthole,doughboy,jrcfyf,tuesday,sabbath,daniel1,nebraska,homers,qwertyuio,azamat,fallen,agent007,striker,camels,iguana,looker,pinkfloy,moloko,qwerty123456,dannyboy,luckydog,789654,pistol,whocares,charmed,skiing,select,franky,puppy,daniil,vladik,vette,vfrcbvrf,ihateyou,nevada,moneys,vkontakte,mandingo,puppies,666777,mystic,zidane,kotenok,dilligaf,budman,bunghole,zvezda,123457,triton,golfball,technics,trojans,panda,laptop,rookie,01011991,15426378,aberdeen,gustav,jethro,enterprise,igor,stripper,filter,hurrican,rfnthbyf,lespaul,gizmo1,butch,132435,dthjybrf,1366613,excalibu,963852,nofear,momoney,possum,cutter,oilers,moocow,cupcake,gbpltw,batman1,splash,svetik,super1,soleil,bogdan,melissa1,vipers,babyboy,tdutybq,lancelot,ccbill,keystone,passwort,flamingo,firefox,dogman,vortex,rebel,noodle,raven1,zaphod,killme,pokemon1,coolman,danila,designer,skinny,kamikaze,deadman,gopher,doobie,warhammer,deeznuts,freaks,engage,chevy1,steve1,apollo13,poncho,hammers,azsxdc,dracula,000007,sassy,bitch1,boots,deskjet,12332,macdaddy,mighty,rangers1,manchest,sterlin,casey1,meatball,mailman,sinatra,cthulhu,summer1,bubbas,cartoon,bicycle,eatpussy,truelove,sentinel,tolkien,breast,capone,lickit,summit,123456k,peter1,daisy1,kitty1,123456789z,crazy1,jamesbon,texas1,sexygirl,362436,sonic,billyboy,redhot,microsof,microlab,daddy1,rockets,iloveyo,fernand,gordon24,danie,cutlass,polska,star69,titties,pantyhos,01011985,thekid,aikido,gofish,mayday,1234qwe,coke,anfield,sony,lansing,smut,scotch,sexx,catman,73501505,hustler,saun,dfkthbz,passwor1,jenny1,azsxdcfv,cheers,irish1,gabrie,tinman,orioles,1225,charlton,fortuna,01011970,airbus,rustam,xtreme,bigmoney,zxcasd,retard,grumpy,huskies,boxing,4runner,kelly1,ultima,warlord,fordf150,oranges,rotten,asdfjkl,superstar,denali,sultan,bikini,saratoga,thor,figaro,sixers,wildfire,vladislav,128500,sparta,mayhem,greenbay,chewie,music1,number1,cancun,fabie,mellon,poiuytrewq,cloud9,crunch,bigtime,chicken1,piccolo,bigbird,321654987,billy1,mojo,01011981,maradona,sandro,chester1,bizkit,rjirfrgbde,789123,rightnow,jasmine1,hyperion,treasure,meatloaf,armani,rovers,jarhead,01011986,cruise,coconut,dragoon,utopia,davids,cosmo,rfhbyf,reebok,1066,charli,giorgi,sticks,sayang,pass1234,exodus,anaconda,zaqxsw,illini,woofwoof,emily1,sandy1,packer,poontang,govols,jedi,tomato,beaner,cooter,creamy,lionking,happy123,albatros,poodle,kenworth,dinosaur,greens,goku,happyday,eeyore,tsunami,cabbage,holyshit,turkey50,memorex,chaser,bogart,orgasm,tommy1,volley,whisper,knopka,ericsson,walleye,321123,pepper1,katie1,chickens,tyler1,corrado,twisted,100000,zorro,clemson,zxcasdqwe,tootsie,milana,zenith,fktrcfylhf,shania,frisco,polniypizdec0211,crazybab,junebug,fugazi,rereirf,vfvekz,1001,sausage,vfczyz,koshka,clapton,justin1,anhyeuem,condom,fubar,hardrock,skywalker,tundra,cocks,gringo,150781,canon,vitalik,aspire,stocks,samsung1,applepie,abc12345,arjay,gandalf1,boob,pillow,sparkle,gmoney,rockhard,lucky13,samiam,everest,hellyeah,bigsexy,skorpion,rfrnec,hedgehog,australi,candle,slacker,dicks,voyeur,jazzman,america1,bobby1,br0d3r,wolfie,vfksirf,1qa2ws3ed,13243546,fright,yosemite,temp,karolina,fart,barsik,surf,cheetah,baddog,deniska,starship,bootie,milena,hithere,kume,greatone,dildo,50cent,0.0.0.000,albion,amanda1,midget,lion,maxell,football1,cyclone,freeporn,nikola,bonsai,kenshin,slider,balloon,roadkill,killbill,222333,jerkoff,78945612,dinamo,tekken,rambler,goliath,cinnamon,malaka,backdoor,fiesta,packers1,rastaman,fletch,sojdlg123aljg,stefano,artemis,calico,nyjets,damnit,robotech,duchess,rctybz,hooter,keywest,18436572,hal9000,mechanic,pingpong,operator,presto,sword,rasputin,spank,bristol,faggot,shado,963852741,amsterda,321456,wibble,carrera,alibaba,majestic,ramses,duster,route66,trident,clipper,steeler,wrestlin,divine,kipper,gotohell,kingfish,snake1,passwords,buttman,pompey,viagra,zxcvbnm1,spurs,332211,slutty,lineage2,oleg,macross,pooter,brian1,qwert1,charles1,slave,jokers,yzerman,swimmer,ne1469,nwo4life,solnce,seamus,lolipop,pupsik,moose1,ivanova,secret1,matador,love69,420247,ktyjxrf,subway,cinder,vermont,pussie,chico,florian,magick,guiness,allsop,ghetto,flash1,a123456789,typhoon,dfkthf,depeche,skydive,dammit,seeker,fuckthis,crysis,kcj9wx5n,umbrella,r2d2c3po,123123q,snoopdog,critter,theboss,ding,162534,splinter,kinky,cyclops,jayhawk,456321,caramel,qwer123,underdog,caveman,onlyme,grapes,feather,hotshot,fuckher,renault,george1,sex123,pippen,000001,789987,floppy,cunts,megapass,1000,pornos,usmc,kickass,great1,quattro,135246,wassup,helloo,p0015123,nicole1,chivas,shannon1,bullseye,java,fishes,blackhaw,jamesbond,tunafish,juggalo,dkflbckfd,123789456,dallas1,translator,122333,beanie,alucard,gfhjkm123,supersta,magicman,ashley1,cohiba,xbox360,caligula,12131415,facial,7753191,dfktynbyf,cobra1,cigars,fang,klingon,bob123,safari,looser,10203,deepthroat,malina,200000,tazmania,gonzo,goalie,jacob1,monaco,cruiser,misfit,vh5150,tommyboy,marino13,yousuck,sharky,vfhufhbnf,horizon,absolut,brighton,123456r,death1,kungfu,maxx,forfun,mamapapa,enter1,budweise,banker,getmoney,kostya,qazwsx12,bigbear,vector,fallout,nudist,gunners,royals,chainsaw,scania,trader,blueboy,walrus,eastside,kahuna,qwerty1234,love123,steph,01011989,cypress,champ,undertaker,ybrjkfq,europa,snowboar,sabres,moneyman,chrisbln,minime,nipper,groucho,whitey,viewsonic,penthous,wolf359,fabric,flounder,coolguy,whitesox,passme,smegma,skidoo,thanatos,fucku2,snapple,dalejr,mondeo,thesims,mybaby,panasoni,sinbad,thecat,topher,frodo,sneakers,q123456,z1x2c3,alfa,chicago1,taylor1,ghjcnjnfr,cat123,olivier,cyber,titanium,0420,madison1,jabroni,dang,hambone,intruder,holly1,gargoyle,sadie1,static,poseidon,studly,newcastl,sexxxx,poppy,johannes,danzig,beastie,musica,buckshot,sunnyday,adonis,bluedog,bonkers,2128506,chrono,compute,spawn,01011988,turbo1,smelly,wapbbs,goldstar,ferrari1,778899,quantum,pisces,boomboom,gunnar,1024,test1234,florida1,nike,superman1,multiplelo,custom,motherlode,1qwerty,westwood,usnavy,apple123,daewoo,korn,stereo,sasuke,sunflowe,watcher,dharma,555777,mouse1,assholes,babyblue,123qwerty,marius,walmart,snoop,starfire,tigger1,paintbal,knickers,aaliyah,lokomotiv,theend,winston1,sapper,rover,erotica,scanner,racer,zeus,sexy69,doogie,bayern,joshua1,newbie,scott1,losers,droopy,outkast,martin1,dodge1,wasser,ufkbyf,rjycnfynby,thirteen,12345z,112211,hotred,deejay,hotpussy,192837,jessic,philippe,scout,panther1,cubbies,havefun,magpie,fghtkm,avalanch,newyork1,pudding,leonid,harry1,cbr600,audia4,bimmer,fucku,01011984,idontknow,vfvfgfgf,1357,aleksey,builder,01011987,zerocool,godfather,mylife,donuts,allmine,redfish,777888,sascha,nitram,bounce,333666,smokes,1x2zkg8w,rodman,stunner,zxasqw12,hoosier,hairy,beretta,insert,123456s,rtyuehe,francesc,tights,cheese1,micron,quartz,hockey1,gegcbr,searay,jewels,bogey,paintball,celeron,padres,bing,syncmaster,ziggy,simon1,beaches,prissy,diehard,orange1,mittens,aleksandra,queens,02071986,biggles,thongs,southpark,artur,twinkle,gretzky,rabota,cambiami,monalisa,gollum,chuckles,spike1,gladiator,whisky,spongebob,sexy1,03082006,mazafaka,meathead,4121,ou8122,barefoot,12345678q,cfitymrf,bigass,a1s2d3,kosmos,blessing,titty,clevelan,terrapin,ginger1,johnboy,maggot,clarinet,deeznutz,336699,stumpy,stoney,footbal,traveler,volvo,bucket,snapon,pianoman,hawkeyes,futbol,casanova,tango,goodboy,scuba,honey1,sexyman,warthog,mustard,abc1234,nickel,10203040,meowmeow,1012,boricua,prophet,sauron,12qwas,reefer,andromeda,crystal1,joker1,90210,goofy,loco,lovesex,triangle,whatsup,mellow,bengals,monster1,maste,01011910,lover1,love1,123aaa,sunshin,smeghead,hokies,sting,welder,rambo,cerberus,bunny1,rockford,monke,1q2w3e4r5,goldwing,gabriell,buzzard,crjhgbjy,james007,rainman,groove,tiberius,purdue,nokia6300,hayabusa,shou,jagger,diver,zigzag,poochie,usarmy,phish,redwood,redwing,12345679,salamander,silver1,abcd123,sputnik,boobie,ripple,eternal,12qw34er,thegreat,allstar,slinky,gesperrt,mishka,whiskers,pinhead,overkill,sweet1,rhfcjnrf,montgom240,sersolution,jamie1,starman,proxy,swords,nikolay,bacardi,rasta,badgirl,rebecca1,wildman,penny1,spaceman,1007,10101,logan1,hacked,bulldog1,helmet,windsor,buffy1,runescape,trapper,123451,banane,dbrnjh,ripken,12345qwe,frisky,shun,fester,oasis,lightning,ib6ub9,cicero,kool,pony,thedog,784512,01011992,megatron,illusion,edward1,napster,11223,squash,roadking,woohoo,19411945,hoosiers,01091989,tracker,bagira,midway,leavemealone,br549,14725836,235689,menace,rachel1,feng,laser,stoned,realmadrid,787898,balloons,tinkerbell,5551212,maria1,pobeda,heineken,sonics,moonlight,optimus,comet,orchid,02071982,jaybird,kashmir,12345678a,chuang,chunky,peach,mortgage,rulezzz,saleen,chuckie,zippy,fishing1,gsxr750,doghouse,maxim,reader,shai,buddah,benfica,chou,salomon,meister,eraser,blackbir,bigmike,starter,pissing,angus,deluxe,eagles1,hardcock,135792468,mian,seahawks,godfathe,bookworm,gregor,intel,talisman,blackjack,babyface,hawaiian,dogfood,zhong,01011975,sancho,ludmila,medusa,mortimer,123456654321,roadrunn,just4me,stalin,01011993,handyman,alphabet,pizzas,calgary,clouds,password2,cgfhnfr,f**k,cubswin,gong,lexus,max123,xxx123,digital1,gfhjkm1,7779311,missy1,michae,beautifu,gator1,1005,pacers,buddie,chinook,heckfy,dutchess,sally1,breasts,beowulf,darkman,jenn,tiffany1,zhei,quan,qazwsx1,satana,shang,idontkno,smiths,puddin,nasty1,teddybea,valkyrie,passwd,chao,boxster,killers,yoda,cheater,inuyasha,beast1,wareagle,foryou,dragonball,mermaid,bhbirf,teddy1,dolphin1,misty1,delphi,gromit,sponge,qazzaq,fytxrf,gameover,diao,sergi,beamer,beemer,kittykat,rancid,manowar,adam12,diggler,assword,austin1,wishbone,gonavy,sparky1,fisting,thedude,sinister,1213,venera,novell,salsero,jayden,fuckoff1,linda1,vedder,02021987,1pussy,redline,lust,jktymrf,02011985,dfcbkbq,dragon12,chrome,gamecube,titten,cong,bella1,leng,02081988,eureka,bitchass,147369,banner,lakota,123321a,mustafa,preacher,hotbox,02041986,z1x2c3v4,playstation,01011977,claymore,electra,checkers,zheng,qing,armagedon,02051986,wrestle,svoboda,bulls,nimbus,alenka,madina,newpass6,onetime,aa123456,bartman,02091987,silverad,electron,12345t,devil666,oliver1,skylar,rhtdtlrj,gobucks,johann,12011987,milkman,02101985,camper,thunderb,bigbutt,jammin,davide,cheeks,goaway,lighter,claudi,thumbs,pissoff,ghostrider,cocaine,teng,squall,lotus,hootie,blackout,doitnow,subzero,02031986,marine1,02021988,pothead,123456qw,skate,1369,peng,antoni,neng,miao,bcfields,1492,marika,794613,musashi,tulips,nong,piao,chai,ruan,southpar,02061985,nude,mandarin,654123,ninjas,cannabis,jetski,xerxes,zhuang,kleopatra,dickie,bilbo,pinky,morgan1,1020,1017,dieter,baseball1,tottenham,quest,yfnfkmz,dirtbike,1234567890a,mango,jackson5,ipswich,iamgod,02011987,tdutybz,modena,qiao,slippery,qweasd123,bluefish,samtron,toon,111333,iscool,02091986,petrov,fuzzy,zhou,1357924680,mollydog,deng,02021986,1236987,pheonix,zhun,ghblehjr,othello,starcraf,000111,sanfran,a11111,cameltoe,badman,vasilisa,jiang,1qaz2ws,luan,sveta,12qw12,akira,chuai,369963,cheech,beatle,pickup,paloma,01011983,caravan,elizaveta,gawker,banzai,pussey,mullet,seng,bingo1,bearcat,flexible,farscape,borussia,zhuai,templar,guitar1,toolman,yfcntymrf,chloe1,xiang,slave1,guai,nuggets,02081984,mantis,slim,scorpio1,fyutkbyf,thedoors,02081987,02061986,123qq123,zappa,fergie,7ugd5hip2j,huai,asdfzxcv,sunflower,pussyman,deadpool,bigtit,01011982,love12,lassie,skyler,gatorade,carpedie,jockey,mancity,spectre,02021984,cameron1,artemka,reng,02031984,iomega,jing,moritz,spice,rhino,spinner,heater,zhai,hover,talon,grease,qiong,corleone,ltybcrf,tian,cowboy1,hippie,chimera,ting,alex123,02021985,mickey1,corsair,sonoma,aaron1,xxxpass,bacchus,webmaste,chuo,xyz123,chrysler,spurs1,artem,shei,cosmic,01020304,deutsch,gabriel1,123455,oceans,987456321,binladen,latinas,a12345678,speedo,buttercu,02081989,21031988,merlot,millwall,ceng,kotaku,jiong,dragonba,2580,stonecold,snuffy,01011999,02011986,hellos,blaze,maggie1,slapper,istanbul,bonjovi,babylove,mazda,bullfrog,phoeni,meng,porsche1,nomore,02061989,bobdylan,capslock,orion1,zaraza,teddybear,ntktajy,myname,rong,wraith,mets,niao,02041984,smokie,chevrolet,dialog,gfhjkmgfhjkm,dotcom,vadim,monarch,athlon,mikey1,hamish,pian,liang,coolness,chui,thoma,ramones,ciccio,chippy,eddie1,house1,ning,marker,cougars,jackpot,barbados,reds,pdtplf,knockers,cobalt,amateurs,dipshit,napoli,kilroy,pulsar,jayhawks,daemon,alexey,weng,shuang,9293709b13,shiner,eldorado,soulmate,mclaren,golfer1,andromed,duan,50spanks,sexyboy,dogshit,02021983,shuo,kakashka,syzygy,111111a,yeahbaby,qiang,netscape,fulham,120676,gooner,zhui,rainbow6,laurent,dog123,halifax,freeway,carlitos,147963,eastwood,microphone,monkey12,1123,persik,coldbeer,geng,nuan,danny1,fgtkmcby,entropy,gadget,just4fun,sophi,baggio,carlito,1234567891,02021989,02041983,specialk,piramida,suan,bigblue,salasana,hopeful,mephisto,bailey1,hack,annie1,generic,violetta,spencer1,arcadia,02051983,hondas,9562876,trainer,jones1,smashing,liao,159632,iceberg,rebel1,snooker,temp123,zang,matteo,fastball,q2w3e4r5,bamboo,fuckyo,shutup,astro,buddyboy,nikitos,redbird,maxxxx,shitface,02031987,kuai,kissmyass,sahara,radiohea,1234asdf,wildcard,maxwell1,patric,plasma,heynow,bruno1,shao,bigfish,misfits,sassy1,sheng,02011988,02081986,testpass,nanook,cygnus,licking,slavik,pringles,xing,1022,ninja1,submit,dundee,tiburon,pinkfloyd,yummy,shuai,guang,chopin,obelix,insomnia,stroker,1a2s3d4f,1223,playboy1,lazarus,jorda,spider1,homerj,sleeper,02041982,darklord,cang,02041988,02041987,tripod,magician,jelly,telephon,15975,vsjasnel12,pasword,iverson3,pavlov,homeboy,gamecock,amigo,brodie,budapest,yjdsqgfhjkm,reckless,02011980,pang,tiger123,2469,mason1,orient,01011979,zong,cdtnbr,maksimka,1011,bushido,taxman,giorgio,sphinx,kazantip,02101984,concorde,verizon,lovebug,georg,sam123,seadoo,qazwsxedc123,jiao,jezebel,pharmacy,abnormal,jellybea,maxime,puffy,islander,bunnies,jiggaman,drakon,010180,pluto,zhjckfd,12365,classics,crusher,mordor,hooligan,strawberry,02081985,scrabble,hawaii50,1224,wg8e3wjf,cthtuf,premium,arrow,123456qwe,mazda626,ramrod,tootie,rhjrjlbk,ghost1,1211,bounty,niang,02071984,goat,killer12,sweetnes,porno1,masamune,426hemi,corolla,mariposa,hjccbz,doomsday,bummer,blue12,zhao,bird33,excalibur,samsun,kirsty,buttfuck,kfhbcf,zhuo,marcello,ozzy,02021982,dynamite,655321,master12,123465,lollypop,stepan,1qa2ws,spiker,goirish,callum,michael2,moonbeam,attila,henry1,lindros,andrea1,sporty,lantern,12365478,nextel,violin,volcom,998877,water1,imation,inspiron,dynamo,citadel,placebo,clowns,tiao,02061988,tripper,dabears,haggis,merlin1,02031985,anthrax,amerika,iloveme,vsegda,burrito,bombers,snowboard,forsaken,katarina,a1a2a3,woofer,tigger2,fullmoon,tiger2,spock,hannah1,snoopy1,sexxxy,sausages,stanislav,cobain,robotics,exotic,green123,mobydick,senators,pumpkins,fergus,asddsa,147741,258852,windsurf,reddevil,vfitymrf,nevermind,nang,woodland,4417,mick,shui,q1q2q3,wingman,69696,superb,zuan,ganesh,pecker,zephyr,anastasiya,icu812,larry1,02081982,broker,zalupa,mihail,vfibyf,dogger,7007,paddle,varvara,schalke,1z2x3c,presiden,yankees2,tuning,poopy,02051982,concord,vanguard,stiffy,rjhjktdf,felix1,wrench,firewall,boxer,bubba69,popper,02011984,temppass,gobears,cuan,tipper,fuckme1,kamila,thong,puss,bigcat,drummer1,02031982,sowhat,digimon,tigers1,rang,jingle,bian,uranus,soprano,mandy1,dusty1,fandango,aloha,pumpkin1,postman,02061980,dogcat,bombay,pussy123,onetwo,highheel,pippo,julie1,laura1,pepito,beng,smokey1,stylus,stratus,reload,duckie,karen1,jimbo1,225588,369258,krusty,snappy,asdf12,electro,111qqq,kuang,fishin,clit,abstr,christma,qqqqq1,1234560,carnage,guyver,boxers,kittens,zeng,1000000,qwerty11,toaster,cramps,yugioh,02061987,icehouse,zxcvbnm123,pineapple,namaste,harrypotter,mygirl,falcon1,earnhard,fender1,spikes,nutmeg,01081989,dogboy,02091983,369852,softail,mypassword,prowler,bigboss,1112,harvest,heng,jubilee,killjoy,basset,keng,zaqxswcde,redsox1,biao,titan,misfit99,robot,wifey,kidrock,02101987,gameboy,enrico,1z2x3c4v,broncos1,arrows,havana,banger,cookie1,chriss,123qw,platypus,cindy1,lumber,pinball,foxy,london1,1023,05051987,02041985,password12,superma,longbow,radiohead,nigga,12051988,spongebo,qwert12345,abrakadabra,dodgers1,02101989,chillin,niceguy,pistons,hookup,santafe,bigben,jets,1013,vikings1,mankind,viktoriya,beardog,hammer1,02071980,reddwarf,magelan,longjohn,jennife,gilles,carmex2,02071987,stasik,bumper,doofus,slamdunk,pixies,garion,steffi,alessandro,beerman,niceass,warrior1,honolulu,134679852,visa,johndeer,mother1,windmill,boozer,oatmeal,aptiva,busty,delight,tasty,slick1,bergkamp,badgers,guitars,puffin,02091981,nikki1,irishman,miller1,zildjian,123000,airwolf,magnet,anai,install,02041981,02061983,astra,romans,megan1,mudvayne,freebird,muscles,dogbert,02091980,02091984,snowflak,01011900,mang,joseph1,nygiants,playstat,junior1,vjcrdf,qwer12,webhompas,giraffe,pelican,jefferso,comanche,bruiser,monkeybo,kjkszpj,123456l,micro,albany,02051987,angel123,epsilon,aladin,death666,hounddog,josephin,altima,chilly,02071988,78945,ultra,02041979,gasman,thisisit,pavel,idunno,kimmie,05051985,paulie,ballin,medion,moondog,manolo,pallmall,climber,fishbone,genesis1,153624,toffee,tbone,clippers,krypton,jerry1,picturs,compass,111111q,02051988,1121,02081977,sairam,getout,333777,cobras,22041987,bigblock,severin,booster,norwich,whiteout,ctrhtn,123456m,02061984,hewlett,shocker,fuckinside,02031981,chase1,white1,versace,123456789s,basebal,iloveyou2,bluebell,08031986,anthon,stubby,foreve,undertak,werder,saiyan,mama123,medic,chipmunk,mike123,mazdarx7,qwe123qwe,bowwow,kjrjvjnbd,celeb,choochoo,demo,lovelife,02051984,colnago,lithium,02051989,15051981,zzzxxx,welcom,anastasi,fidelio,franc,26061987,roadster,stone55,drifter,hookem,hellboy,1234qw,cbr900rr,sinned,good123654,storm1,gypsy,zebra,zachary1,toejam,buceta,02021979,testing1,redfox,lineage,mike1,highbury,koroleva,nathan1,washingt,02061982,02091985,vintage,redbaron,dalshe,mykids,11051987,macbeth,julien,james123,krasotka,111000,10011986,987123,pipeline,tatarin,sensei,codered,komodo,frogman,7894561230,nascar24,juicy,01031988,redrose,mydick,pigeon,tkbpfdtnf,smirnoff,1215,spam,winner1,flyfish,moskva,81fukkc,21031987,olesya,starligh,summer99,13041988,fishhead,freesex,super12,06061986,azazel,scoobydoo,02021981,cabron,yogibear,sheba1,konstantin,tranny,chilli,terminat,ghbywtccf,slowhand,soccer12,cricket1,fuckhead,1002,seagull,achtung,blam,bigbob,bdsm,nostromo,survivor,cnfybckfd,lemonade,boomer1,rainbow1,rober,irinka,cocksuck,peaches1,itsme,sugar1,zodiac,upyours,dinara,135791,sunny1,chiara,johnson1,02041989,solitude,habibi,sushi,markiz,smoke1,rockies,catwoman,johnny1,qwerty7,bearcats,username,01011978,wanderer,ohshit,02101986,sigma,stephen1,paradigm,02011989,flanker,sanity,jsbach,spotty,bologna,fantasia,chevys,borabora,cocker,74108520,123ewq,12021988,01061990,gtnhjdbx,02071981,01011960,sundevil,3000gt,mustang6,gagging,maggi,armstron,yfnfkb,13041987,revolver,02021976,trouble1,madcat,jeremy1,jackass1,volkswag,30051985,corndog,pool6123,marines1,03041991,pizza1,piggy,sissy,02031979,sunfire,angelus,undead,24061986,14061991,wildbill,shinobi,45m2do5bs,123qwer,21011989,cleopatr,lasvega,hornets,amorcit,11081989,coventry,nirvana1,destin,sidekick,20061988,02081983,gbhfvblf,sneaky,bmw325,22021989,nfytxrf,sekret,kalina,zanzibar,hotone,qazws,wasabi,heidi1,highlander,blues1,hitachi,paolo,23041987,slayer1,simba1,02011981,tinkerbe,kieran,01121986,172839,boiler,1125,bluesman,waffle,asdfgh01,threesom,conan,1102,reflex,18011987,nautilus,everlast,fatty,vader1,01071986,cyborg,ghbdtn123,birddog,rubble,02071983,suckers,02021973,skyhawk,12qw12qw,dakota1,joebob,nokia6233,woodie,longdong,lamer,troll,ghjcnjgfhjkm,420000,boating,nitro,armada,messiah,1031,penguin1,02091989,americ,02071989,redeye,asdqwe123,07071987,monty1,goten,spikey,sonata,635241,tokiohotel,sonyericsson,citroen,compaq1,1812,umpire,belmont,jonny,pantera1,nudes,palmtree,14111986,fenway,bighead,razor,gryphon,andyod22,aaaaa1,taco,10031988,enterme,malachi,dogface,reptile,01041985,dindom,handball,marseille,candy1,19101987,torino,tigge,matthias,viewsoni,13031987,stinker,evangelion,24011985,123456123,rampage,sandrine,02081980,thecrow,astral,28041987,sprinter,private1,seabee,shibby,02101988,25081988,fearless,junkie,01091987,aramis,antelope,draven,fuck1,mazda6,eggman,02021990,barselona,buddy123,19061987,fyfnjkbq,nancy1,12121990,10071987,sluggo,kille,hotties,irishka,zxcasdqwe123,shamus,fairlane,honeybee,soccer10,13061986,fantomas,17051988,10051987,20111986,gladiato,karachi,gambler,gordo,01011995,biatch,matthe,25800852,papito,excite,buffalo1,bobdole,cheshire,player1,28021992,thewho,10101986,pinky1,mentor,tomahawk,brown1,03041986,bismillah,bigpoppa,ijrjkfl,01121988,runaway,08121986,skibum,studman,helper,squeak,holycow,manfred,harlem,glock,gideon,987321,14021985,yellow1,wizard1,margarit,success1,medved,sf49ers,lambda,pasadena,johngalt,quasar,1776,02031980,coldplay,amand,playa,bigpimp,04041991,capricorn,elefant,sweetness,bruce1,luca,dominik,10011990,biker,09051945,datsun,elcamino,trinitro,malice,audi,voyager1,02101983,joe123,carpente,spartan1,mario1,glamour,diaper,12121985,22011988,winter1,asimov,callisto,nikolai,pebble,02101981,vendetta,david123,boytoy,11061985,02031989,iloveyou1,stupid1,cayman,casper1,zippo,yamahar1,wildwood,foxylady,calibra,02041980,27061988,dungeon,leedsutd,30041986,11051990,bestbuy,antares,dominion,24680,01061986,skillet,enforcer,derparol,01041988,196969,29071983,f00tball,purple1,mingus,25031987,21031990,remingto,giggles,klaste,3x7pxr,01011994,coolcat,29051989,megane,20031987,02051980,04041988,synergy,0000007,macman,iforget,adgjmp,vjqgfhjkm,28011987,rfvfcenhf,16051989,25121987,16051987,rogue,mamamia,08051990,20091991,1210,carnival,bolitas,paris1,dmitriy,dimas,05051989,papillon,knuckles,29011985,hola,tophat,28021990,100500,cutiepie,devo,415263,ducks,ghjuhfvvf,asdqwe,22021986,freefall,parol,02011983,zarina,buste,vitamin,warez,bigones,17061988,baritone,jamess,twiggy,mischief,bitchy,hetfield,1003,dontknow,grinch,sasha_007,18061990,12031985,12031987,calimero,224466,letmei,15011987,acmilan,alexandre,02031977,08081988,whiteboy,21051991,barney1,02071978,money123,18091985,bigdawg,02031988,cygnusx1,zoloto,31011987,firefigh,blowfish,screamer,lfybbk,20051988,chelse,11121986,01031989,harddick,sexylady,30031988,02041974,auditt,pizdec,kojak,kfgjxrf,20091988,123456ru,wp2003wp,1204,15051990,slugger,kordell1,03031986,swinging,01011974,02071979,rockie,dimples,1234123,1dragon,trucking,rusty2,roger1,marijuana,kerouac,02051978,08031985,paco,thecure,keepout,kernel,noname123,13121985,francisc,bozo,02011982,22071986,02101979,obsidian,12345qw,spud,tabasco,02051985,jaguars,dfktynby,kokomo,popova,notused,sevens,4200,magneto,02051976,roswell,15101986,21101986,lakeside,bigbang,aspen,little1,14021986,loki,suckmydick,strawber,carlos1,nokian73,dirty1,joshu,25091987,16121987,02041975,advent,17011987,slimshady,whistler,10101990,stryker,22031984,15021985,01031985,blueball,26031988,ksusha,bahamut,robocop,w_pass,chris123,impreza,prozac,bookie,bricks,13021990,alice1,cassandr,11111q,john123,4ever,korova,02051973,142857,25041988,paramedi,eclipse1,salope,07091990,1124,darkangel,23021986,999666,nomad,02051981,smackdow,01021990,yoyoma,argentin,moonligh,57chevy,bootys,hardone,capricor,galant,spanker,dkflbr,24111989,magpies,krolik,21051988,cevthrb,cheddar,22041988,bigbooty,scuba1,qwedsa,duffman,bukkake,acura,johncena,sexxy,p@ssw0rd,258369,cherries,12345s,asgard,leopold,fuck123,mopar,lalakers,dogpound,matrix1,crusty,spanner,kestrel,fenris,universa,peachy,assasin,lemmein,eggplant,hejsan,canucks,wendy1,doggy1,aikman,tupac,turnip,godlike,fussball,golden1,19283746,april1,django,petrova,captain1,vincent1,ratman,taekwondo,chocha,serpent,perfect1,capetown,vampir,amore,gymnast,timeout,nbvjatq,blue32,ksenia,k.lvbkf,nazgul,budweiser,clutch,mariya,sylveste,02051972,beaker,cartman1,q11111,sexxx,forever1,loser1,marseill,magellan,vehpbr,sexgod,jktxrf,hallo123,132456,liverpool1,southpaw,seneca,camden,357159,camero,tenchi,johndoe,145236,roofer,741963,vlad,02041978,fktyrf,zxcv123,wingnut,wolfpac,notebook,pufunga7782,brandy1,biteme1,goodgirl,redhat,02031978,challeng,millenium,hoops,maveric,noname,angus1,gaell,onion,olympus,sabrina1,ricard,sixpack,gratis,gagged,camaross,hotgirls,flasher,02051977,bubba123,goldfing,moonshin,gerrard,volkov,sonyfuck,mandrake,258963,tracer,lakers1,asians,susan1,money12,helmut,boater,diablo2,1234zxcv,dogwood,bubbles1,happy2,randy1,aries,beach1,marcius2,navigator,goodie,hellokitty,fkbyjxrf,earthlink,lookout,jumbo,opendoor,stanley1,marie1,12345m,07071977,ashle,wormix,murzik,02081976,lakewood,bluejays,loveya,commande,gateway2,peppe,01011976,7896321,goth,oreo,slammer,rasmus,faith1,knight1,stone1,redskin,ironmaiden,gotmilk,destiny1,dejavu,1master,midnite,timosha,espresso,delfin,toriamos,oberon,ceasar,markie,1a2s3d,ghhh47hj7649,vjkjrj,daddyo,dougie,disco,auggie,lekker,therock1,ou8123,start1,noway,p4ssw0rd,shadow12,333444,saigon,2fast4u,capecod,23skidoo,qazxcv,beater,bremen,aaasss,roadrunner,peace1,12345qwer,02071975,platon,bordeaux,vbkfirf,135798642,test12,supernov,beatles1,qwert40,optimist,vanessa1,prince1,ilovegod,nightwish,natasha1,alchemy,bimbo,blue99,patches1,gsxr1000,richar,hattrick,hott,solaris,proton,nevets,enternow,beavis1,amigos,159357a,ambers,lenochka,147896,suckdick,shag,intercourse,blue1234,spiral,02061977,tosser,ilove,02031975,cowgirl,canuck,q2w3e4,munch,spoons,waterboy,123567,evgeniy,savior,zasada,redcar,mamacita,terefon,globus,doggies,htubcnhfwbz,1008,cuervo,suslik,azertyui,limewire,houston1,stratfor,steaua,coors,tennis1,12345qwerty,stigmata,derf,klondike,patrici,marijuan,hardball,odyssey,nineinch,boston1,pass1,beezer,sandr,charon,power123,a1234,vauxhall,875421,awesome1,reggae,boulder,funstuff,iriska,krokodil,rfntymrf,sterva,champ1,bball,peeper,m123456,toolbox,cabernet,sheepdog,magic32,pigpen,02041977,holein1,lhfrjy,banan,dabomb,natalie1,jennaj,montana1,joecool,funky,steven1,ringo,junio,sammy123,qqqwww,baltimor,footjob,geezer,357951,mash4077,cashmone,pancake,monic,grandam,bongo,yessir,gocubs,nastia,vancouve,barley,dragon69,watford,ilikepie,02071976,laddie,123456789m,hairball,toonarmy,pimpdadd,cvthnm,hunte,davinci,lback,sophie1,firenze,q1234567,admin1,bonanza,elway7,daman,strap,azert,wxcvbn,afrika,theforce,123456t,idefix,wolfen,houdini,scheisse,default,beech,maserati,02061976,sigmachi,dylan1,bigdicks,eskimo,mizzou,02101976,riccardo,egghead,111777,kronos,ghbrjk,chaos1,jomama,rfhnjirf,rodeo,dolemite,cafc91,nittany,pathfind,mikael,password9,vqsablpzla,purpl,gabber,modelsne,myxworld,hellsing,punker,rocknrol,fishon,fuck69,02041976,lolol,twinkie,tripleh,cirrus,redbone,killer123,biggun,allegro,gthcbr,smith1,wanking,bootsy,barry1,mohawk,koolaid,5329,futurama,samoht,klizma,996633,lobo,honeys,peanut1,556677,zxasqw,joemama,javelin,samm,223322,sandra1,flicks,montag,nataly,3006,tasha1,1235789,dogbone,poker1,p0o9i8u7,goodday,smoothie,toocool,max333,metroid,archange,vagabond,billabon,22061941,tyson1,02031973,darkange,skateboard,evolutio,morrowind,wizards,frodo1,rockin,cumslut,plastics,zaqwsxcde,5201314,doit,outback,bumble,dominiqu,persona,nevermore,alinka,02021971,forgetit,sexo,all4one,c2h5oh,petunia,sheeba,kenny1,elisabet,aolsucks,woodstoc,pumper,02011975,fabio,granada,scrapper,123459,minimoni,q123456789,breaker,1004,02091976,ncc74656,slimshad,friendster,austin31,wiseguy,donner,dilbert1,132465,blackbird,buffet,jellybean,barfly,behappy,01011971,carebear,fireblad,02051975,boxcar,cheeky,kiteboy,hello12,panda1,elvisp,opennow,doktor,alex12,02101977,pornking,flamengo,02091975,snowbird,lonesome,robin1,11111a,weed420,baracuda,bleach,12345abc,nokia1,metall,singapor,mariner,herewego,dingo,tycoon,cubs,blunts,proview,123456789d,kamasutra,lagnaf,vipergts,navyseal,starwar,masterbate,wildone,peterbil,cucumber,butkus,123qwert,climax,deniro,gotribe,cement,scooby1,summer69,harrier,shodan,newyear,02091977,starwars1,romeo1,sedona,harald,doubled,sasha123,bigguns,salami,awnyce,kiwi,homemade,pimping,azzer,bradley1,warhamme,linkin,dudeman,qwe321,pinnacle,maxdog,flipflop,lfitymrf,fucker1,acidburn,esquire,sperma,fellatio,jeepster,thedon,sexybitch,pookey,spliff,widget,vfntvfnbrf,trinity1,mutant,samuel1,meliss,gohome,1q2q3q,mercede,comein,grin,cartoons,paragon,henrik,rainyday,pacino,senna,bigdog1,alleycat,12345qaz,narnia,mustang2,tanya1,gianni,apollo11,wetter,clovis,escalade,rainbows,freddy1,smart1,daisydog,s123456,cocksucker,pushkin,lefty,sambo,fyutkjxtr,hiziad,boyz,whiplash,orchard,newark,adrenalin,1598753,bootsie,chelle,trustme,chewy,golfgti,tuscl,ambrosia,5wr2i7h8,penetration,shonuf,jughead,payday,stickman,gotham,kolokol,johnny5,kolbasa,stang,puppydog,charisma,gators1,mone,jakarta,draco,nightmar,01011973,inlove,laetitia,02091973,tarpon,nautica,meadow,0192837465,luckyone,14881488,chessie,goldeney,tarakan,69camaro,bungle,wordup,interne,fuckme2,515000,dragonfl,sprout,02081974,gerbil,bandit1,02071971,melanie1,phialpha,camber,kathy1,adriano,gonzo1,10293847,bigjohn,bismarck,7777777a,scamper,12348765,rabbits,222777,bynthytn,dima123,alexander1,mallorca,dragster,favorite6,beethove,burner,cooper1,fosters,hello2,normandy,777999,sebring,1michael,lauren1,blake1,killa,02091971,nounours,trumpet1,thumper1,playball,xantia,rugby1,rocknroll,guillaum,angela1,strelok,prosper,buttercup,masterp,dbnfkbr,cambridg,venom,treefrog,lumina,1234566,supra,sexybabe,freee,shen,frogs,driller,pavement,grace1,dicky,checker,smackdown,pandas,cannibal,asdffdsa,blue42,zyjxrf,nthvbyfnjh,melrose,neon,jabber,gamma,369258147,aprilia,atticus,benessere,catcher,skipper1,azertyuiop,sixty9,thierry,treetop,jello,melons,123456789qwe,tantra,buzzer,catnip,bouncer,computer1,sexyone,ananas,young1,olenka,sexman,mooses,kittys,sephiroth,contra,hallowee,skylark,sparkles,777333,1qazxsw23edc,lucas1,q1w2e3r,gofast,hannes,amethyst,ploppy,flower2,hotass,amatory,volleyba,dixie1,bettyboo,ticklish,02061974,frenchy,phish1,murphy1,trustno,02061972,leinad,mynameis,spooge,jupiter1,hyundai,frosch,junkmail,abacab,marbles,32167,casio,sunshine1,wayne1,longhair,caster,snicker,02101973,gannibal,skinhead,hansol,gatsby,segblue2,montecar,plato,gumby,kaboom,matty,bosco1,888999,jazzy,panter,jesus123,charlie2,giulia,candyass,sex69,travis1,farmboy,special1,02041973,letsdoit,password01,allison1,abcdefg1,notredam,ilikeit,789654123,liberty1,rugger,uptown,alcatraz,123456w,airman,007bond,navajo,kenobi,terrier,stayout,grisha,frankie1,fluff,1qazzaq1,1234561,virginie,1234568,tango1,werdna,octopus,fitter,dfcbkbcf,blacklab,115599,montrose,allen1,supernova,frederik,ilovepussy,justice1,radeon,playboy2,blubber,sliver,swoosh,motocros,lockdown,pearls,thebear,istheman,pinetree,biit,1234rewq,rustydog,tampabay,titts,babycake,jehovah,vampire1,streaming,collie,camil,fidelity,calvin1,stitch,gatit,restart,puppy1,budgie,grunt,capitals,hiking,dreamcas,zorro1,321678,riffraff,makaka,playmate,napalm,rollin,amstel,zxcvb123,samanth,rumble,fuckme69,jimmys,951357,pizzaman,1234567899,tralala,delpiero,alexi,yamato,itisme,1million,vfndtq,kahlua,londo,wonderboy,carrots,tazz,ratboy,rfgecnf,02081973,nico,fujitsu,tujhrf,sergbest,blobby,02051970,sonic1,1357911,smirnov,video1,panhead,bucky,02031974,44332211,duffer,cashmoney,left4dead,bagpuss,salman,01011972,titfuck,66613666,england1,malish,dresden,lemans,darina,zapper,123456as,123456qqq,met2002,02041972,redstar,blue23,1234509876,pajero,booyah,please1,tetsuo,semper,finder,hanuman,sunlight,123456n,02061971,treble,cupoi,password99,dimitri,3ip76k2,popcorn1,lol12345,stellar,nympho,shark1,keith1,saskia,bigtruck,revoluti,rambo1,asd222,feelgood,phat,gogators,bismark,cola,puck,furball,burnout,slonik,bowtie,mommy1,icecube,fabienn,mouser,papamama,rolex,giants1,blue11,trooper1,momdad,iklo,morten,rhubarb,gareth,123456d,blitz,canada1,r2d2,brest,tigercat,usmarine,lilbit,benny1,azrael,lebowski,12345r,madagaskar,begemot,loverman,dragonballz,italiano,mazda3,naughty1,onions,diver1,cyrano,capcom,asdfg123,forlife,fisherman,weare138,requiem,mufasa,alpha123,piercing,hellas,abracadabra,duckman,caracas,macintos,02011971,jordan2,crescent,fduecn,hogtied,eatmenow,ramjet,18121812,kicksass,whatthe,discus,rfhfvtkmrf,rufus1,sqdwfe,mantle,vegitto,trek,dan123,paladin1,rudeboy,liliya,lunchbox,riversid,acapulco,libero,dnsadm,maison,toomuch,boobear,hemlock,sextoy,pugsley,misiek,athome,migue,altoids,marcin,123450,rhfcfdbwf,jeter2,rhinos,rjhjkm,mercury1,ronaldinho,shampoo,makayla,kamilla,masterbating,tennesse,holger,john1,matchbox,hores,poptart,parlament,goodyear,asdfgh1,02081970,hardwood,alain,erection,hfytnrb,highlife,implants,benjami,dipper,jeeper,bendover,supersonic,babybear,laserjet,gotenks,bama,natedogg,aol123,pokemo,rabbit1,raduga,sopranos,cashflow,menthol,pharao,hacking,334455,ghjcnbnenrf,lizzy,muffin1,pooky,penis1,flyer,gramma,dipset,becca,ireland1,diana1,donjuan,pong,ziggy1,alterego,simple1,cbr900,logger,111555,claudia1,cantona7,matisse,ljxtymrf,victori,harle,mamas,encore,mangos,iceman1,diamon,alexxx,tiamat,5000,desktop,mafia,smurf,princesa,shojou,blueberr,welkom,maximka,123890,123q123,tammy1,bobmarley,clips,demon666,ismail,termite,laser1,missie,altair,donna1,bauhaus,trinitron,mogwai,flyers88,juniper,nokia5800,boroda,jingles,qwerasdfzxcv,shakur,777666,legos,mallrats,1qazxsw,goldeneye,tamerlan,julia1,backbone,spleen,49ers,shady,darkone,medic1,justi,giggle,cloudy,aisan,douche,parkour,bluejay,huskers1,redwine,1qw23er4,satchmo,1231234,nineball,stewart1,ballsack,probes,kappa,amiga,flipper1,dortmund,963258,trigun,1237895,homepage,blinky,screwy,gizzmo,belkin,chemist,coolhand,chachi,braves1,thebest,greedisgood,pro100,banana1,101091m,123456g,wonderfu,barefeet,8inches,1111qqqq,kcchiefs,qweasdzxc123,metal1,jennifer1,xian,asdasd123,pollux,cheerleaers,fruity,mustang5,turbos,shopper,photon,espana,hillbill,oyster,macaroni,gigabyte,jesper,motown,tuxedo,buster12,triplex,cyclones,estrell,mortis,holla,456987,fiddle,sapphic,jurassic,thebeast,ghjcnjq,baura,spock1,metallica1,karaoke,nemrac58,love1234,02031970,flvbybcnhfnjh,frisbee,diva,ajax,feathers,flower1,soccer11,allday,mierda,pearl1,amature,marauder,333555,redheads,womans,egorka,godbless,159263,nimitz,aaaa1111,sashka,madcow,socce,greywolf,baboon,pimpdaddy,123456789r,reloaded,lancia,rfhfylfi,dicker,placid,grimace,22446688,olemiss,whores,culinary,wannabe,maxi,1234567aa,amelie,riley1,trample,phantom1,baberuth,bramble,asdfqwer,vides,4you,abc123456,taichi,aztnm,smother,outsider,hakr,blackhawk,bigblack,girlie,spook,valeriya,gianluca,freedo,1q2q3q4q,handbag,lavalamp,cumm,pertinant,whatup,nokia123,redlight,patrik,111aaa,poppy1,dfytxrf,aviator,sweeps,kristin1,cypher,elway,yinyang,access1,poophead,tucson,noles1,monterey,waterfal,dank,dougal,918273,suede,minnesot,legman,bukowski,ganja,mammoth,riverrat,asswipe,daredevi,lian,arizona1,kamikadze,alex1234,smile1,angel2,55bgates,bellagio,0001,wanrltw,stiletto,lipton,arsena,biohazard,bbking,chappy,tetris,as123456,darthvad,lilwayne,nopassword,7412369,123456789987654321,natchez,glitter,14785236,mytime,rubicon,moto,pyon,wazzup,tbird,shane1,nightowl,getoff,beckham7,trueblue,hotgirl,nevermin,deathnote,13131,taffy,bigal,copenhag,apricot,gallaries,dtkjcbgtl,totoro,onlyone,civicsi,jesse1,baby123,sierra1,festus,abacus,sickboy,fishtank,fungus,charle,golfpro,teensex,mario66,seaside,aleksei,rosewood,blackberry,1020304050,bedlam,schumi,deerhunt,contour,darkelf,surveyor,deltas,pitchers,741258963,dipstick,funny1,lizzard,112233445566,jupiter2,softtail,titman,greenman,z1x2c3v4b5,smartass,12345677,notnow,myworld,nascar1,chewbacc,nosferatu,downhill,dallas22,kuan,blazers,whales,soldat,craving,powerman,yfcntyf,hotrats,cfvceyu,qweasdzx,princess1,feline,qqwwee,chitown,1234qaz,mastermind,114477,dingbat,care1839,standby,kismet,atreides,dogmeat,icarus,monkeyboy,alex1,mouses,nicetits,sealteam,chopper1,crispy,winter99,rrpass1,myporn,myspace1,corazo,topolino,ass123,lawman,muffy,orgy,1love,passord,hooyah,ekmzyf,pretzel,amonra,nestle,01011950,jimbeam,happyman,z12345,stonewal,helios,manunited,harcore,dick1,gaymen,2hot4u,light1,qwerty13,kakashi,pjkjnj,alcatel,taylo,allah,buddydog,ltkmaby,mongo,blonds,start123,audia6,123456v,civilwar,bellaco,turtles,mustan,deadspin,aaa123,fynjirf,lucky123,tortoise,amor,summe,waterski,zulu,drag0n,dtxyjcnm,gizmos,strife,interacial,pusyy,goose1,bear1,equinox,matri,jaguar1,tobydog,sammys,nachos,traktor,bryan1,morgoth,444555,dasani,miami1,mashka,xxxxxx1,ownage,nightwin,hotlips,passmast,cool123,skolko,eldiablo,manu,1357908642,screwyou,badabing,foreplay,hydro,kubrick,seductive,demon1,comeon,galileo,aladdin,metoo,happines,902100,mizuno,caddy,bizzare,girls1,redone,ohmygod,sable,bonovox,girlies,hamper,opus,gizmodo1,aaabbb,pizzahut,999888,rocky2,anton1,kikimora,peavey,ocelot,a1a2a3a4,2wsx3edc,jackie1,solace,sprocket,galary,chuck1,volvo1,shurik,poop123,locutus,virago,wdtnjxtr,tequier,bisexual,doodles,makeitso,fishy,789632145,nothing1,fishcake,sentry,libertad,oaktree,fivestar,adidas1,vegitta,mississi,spiffy,carme,neutron,vantage,agassi,boners,123456789v,hilltop,taipan,barrage,kenneth1,fister,martian,willem,lfybkf,bluestar,moonman,ntktdbpjh,paperino,bikers,daffy,benji,quake,dragonfly,suckcock,danilka,lapochka,belinea,calypso,asshol,camero1,abraxas,mike1234,womam,q1q2q3q4q5,youknow,maxpower,pic\'s,audi80,sonora,raymond1,tickler,tadpole,belair,crazyman,finalfantasy,999000,jonatha,paisley,kissmyas,morgana,monste,mantra,spunk,magic123,jonesy,mark1,alessand,741258,baddest,ghbdtnrfrltkf,zxccxz,tictac,augustin,racers,7grout,foxfire,99762000,openit,nathanie,1z2x3c4v5b,seadog,gangbanged,lovehate,hondacbr,harpoon,mamochka,fisherma,bismilla,locust,wally1,spiderman1,saffron,utjhubq,123456987,20spanks,safeway,pisser,bdfyjd,kristen1,bigdick1,magenta,vfhujif,anfisa,friday13,qaz123wsx,0987654321q,tyrant,guan,meggie,kontol,nurlan,ayanami,rocket1,yaroslav,websol76,mutley,hugoboss,websolutions,elpaso,gagarin,badboys,sephirot,918273645,newuser,qian,edcrfv,booger1,852258,lockout,timoxa94,mazda323,firedog,sokolova,skydiver,jesus777,1234567890z,soulfly,canary,malinka,guillerm,hookers,dogfart,surfer1,osprey,india123,rhjkbr,stoppedby,nokia5530,123456789o,blue1,werter,divers,3000,123456f,alpina,cali,whoknows,godspeed,986532,foreskin,fuzzy1,heyyou,didier,slapnuts,fresno,rosebud1,sandman1,bears1,blade1,honeybun,queen1,baronn,pakista,philipp,9111961,topsecret,sniper1,214365,slipper,letsfuck,pippen33,godawgs,mousey,qw123456,scrotum,loveis,lighthou,bp2002,nancy123,jeffrey1,susieq,buddy2,ralphie,trout1,willi,antonov,sluttey,rehbwf,marty1,darian,losangeles,letme1n,12345d,pusssy,godiva,ender,golfnut,leonidas,a1b2c3d4e5,puffer,general1,wizzard,lehjxrf,racer1,bigbucks,cool12,buddys,zinger,esprit,vbienrf,josep,tickling,froggie,987654321a,895623,daddys,crumbs,gucci,mikkel,opiate,tracy1,christophe,came11,777555,petrovich,humbug,dirtydog,allstate,horatio,wachtwoord,creepers,squirts,rotary,bigd,georgia1,fujifilm,2sweet,dasha,yorkie,slimjim,wiccan,kenzie,system1,skunk,b12345,getit,pommes,daredevil,sugars,bucker,piston,lionheart,1bitch,515051,catfight,recon,icecold,fantom,vodafone,kontakt,boris1,vfcnth,canine,01011961,valleywa,faraon,chickenwing101,qq123456,livewire,livelife,roosters,jeepers,ilya1234,coochie,pavlik,dewalt,dfhdfhf,architec,blackops,1qaz2wsx3edc4rfv,rhfcjnf,wsxedc,teaser,sebora,25252,rhino1,ankara,swifty,decimal,redleg,shanno,nermal,candies,smirnova,dragon01,photo1,ranetki,a1s2d3f4g5,axio,wertzu,maurizio,6uldv8,zxcvasdf,punkass,flowe,graywolf,peddler,3rjs1la7qe,mpegs,seawolf,ladyboy,pianos,piggies,vixen,alexus,orpheus,gdtrfb,z123456,macgyver,hugetits,ralph1,flathead,maurici,mailru,goofball,nissan1,nikon,stopit,odin,big1,smooch,reboot,famil,bullit,anthony7,gerhard,methos,124038,morena,eagle2,jessica2,zebras,getlost,gfynthf,123581321,sarajevo,indon,comets,tatjana,rfgbnjirf,joystick,batman12,123456c,sabre,beerme,victory1,kitties,1475369,badboy1,booboo1,comcast,slava,squid,saxophon,lionhear,qaywsx,bustle,nastena,roadway,loader,hillside,starlight,24681012,niggers,access99,bazooka,molly123,blackice,bandi,cocacol,nfhfrfy,timur,muschi,horse1,quant4307s,squerting,oscars,mygirls,flashman,tangerin,goofy1,p0o9i8,housewifes,newness,monkey69,escorpio,password11,hippo,warcraft3,qazxsw123,qpalzm,ribbit,ghbdtndctv,bogota,star123,258000,lincoln1,bigjim,lacoste,firestorm,legenda,indain,ludacris,milamber,1009,evangeli,letmesee,a111111,hooters1,bigred1,shaker,husky,a4tech,cnfkrth,argyle,rjhjdf,nataha,0o9i8u7y,gibson1,sooners1,glendale,archery,hoochie,stooge,aaaaaa1,scorpions,school1,vegas1,rapier,mike23,bassoon,groupd2013,macaco,baker1,labia,freewill,santiag,silverado,butch1,vflfufcrfh,monica1,rugrat,cornhole,aerosmit,bionicle,gfgfvfvf,daniel12,virgo,fmale,favorite2,detroit1,pokey,shredder,baggies,wednesda,cosmo1,mimosa,sparhawk,firehawk,romario,911turbo,funtimes,fhntvrf,nexus6,159753456,timothy1,bajingan,terry1,frenchie,raiden,1mustang,babemagnet,74123698,nadejda,truffles,rapture,douglas1,lamborghini,motocross,rjcvjc,748596,skeeter1,dante1,angel666,telecom,carsten,pietro,bmw318,astro1,carpediem,samir,orang,helium,scirocco,fuzzball,rushmore,rebelz,hotspur,lacrimosa,chevys10,madonna1,domenico,yfnfirf,jachin,shelby1,bloke,dawgs,dunhill,atlanta1,service1,mikado,devilman,angelit,reznor,euphoria,lesbain,checkmat,browndog,phreak,blaze1,crash1,farida,mutter,luckyme,horsemen,vgirl,jediknig,asdas,cesare,allnight,rockey,starlite,truck1,passfan,close-up,samue,cazzo,wrinkles,homely,eatme1,sexpot,snapshot,dima1995,asthma,thetruth,ducky,blender,priyanka,gaucho,dutchman,sizzle,kakarot,651550,passcode,justinbieber,666333,elodie,sanjay,110442,alex01,lotus1,2300mj,lakshmi,zoomer,quake3,12349876,teapot,12345687,ramada,pennywis,striper,pilot1,chingon,optima,nudity,ethan1,euclid,beeline,loyola,biguns,zaq12345,bravo1,disney1,buffa,assmunch,vivid,6661313,wellingt,aqwzsx,madala11,9874123,sigmar,pictere,tiptop,bettyboop,dinero,tahiti,gregory1,bionic,speed1,fubar1,lexus1,denis1,hawthorn,saxman,suntzu,bernhard,dominika,camaro1,hunter12,balboa,bmw2002,seville,diablo1,vfhbyjxrf,1234abc,carling,lockerroom,punani,darth,baron1,vaness,1password,libido,picher,232425,karamba,futyn007,daydream,11001001,dragon123,friends1,bopper,rocky123,chooch,asslover,shimmer,riddler,openme,tugboat,sexy123,midori,gulnara,christo,swatch,laker,offroad,puddles,hackers,mannheim,manager1,horseman,roman1,dancer1,komputer,pictuers,nokia5130,ejaculation,lioness,123456y,evilone,nastenka,pushok,javie,lilman,3141592,mjolnir,toulouse,pussy2,bigworm,smoke420,fullback,extensa,dreamcast,belize,delboy,willie1,casablanca,csyjxtr,ricky1,bonghit,salvator,basher,pussylover,rosie1,963258741,vivitron,cobra427,meonly,armageddon,myfriend,zardoz,qwedsazxc,kraken,fzappa,starfox,333999,illmatic,capoeira,weenie,ramzes,freedom2,toasty,pupkin,shinigami,fhvfutljy,nocturne,churchil,thumbnils,tailgate,neworder,sexymama,goarmy,cerebus,michelle1,vbifyz,surfsup,earthlin,dabulls,basketbal,aligator,mojojojo,saibaba,welcome2,wifes,wdtnjr,12345w,slasher,papabear,terran,footman,hocke,153759,texans,tom123,sfgiants,billabong,aassdd,monolith,xxx777,l3tm31n,ticktock,newone,hellno,japanees,contortionist,admin123,scout1,alabama1,divx1,rochard,privat,radar1,bigdad,fhctybq,tortuga,citrus,avanti,fantasy1,woodstock,s12345,fireman1,embalmer,woodwork,bonzai,konyor,newstart,jigga,panorama,goats,smithy,rugrats,hotmama,daedalus,nonstop,fruitbat,lisenok,quaker,violator,12345123,my3sons,cajun,fraggle,gayboy,oldfart,vulva,knickerless,orgasms,undertow,binky,litle,kfcnjxrf,masturbation,bunnie,alexis1,planner,transexual,sparty,leeloo,monies,fozzie,stinger1,landrove,anakonda,scoobie,yamaha1,henti,star12,rfhlbyfk,beyonce,catfood,cjytxrf,zealots,strat,fordtruc,archangel,silvi,sativa,boogers,miles1,bigjoe,tulip,petite,greentea,shitter,jonboy,voltron,morticia,evanescence,3edc4rfv,longshot,windows1,serge,aabbcc,starbucks,sinful,drywall,prelude1,www123,camel1,homebrew,marlins,123412,letmeinn,domini,swampy,plokij,fordf350,webcam,michele1,bolivi,27731828,wingzero,qawsedrftg,shinji,sverige,jasper1,piper1,cummer,iiyama,gocats,amour,alfarome,jumanji,mike69,fantasti,1monkey,w00t88,shawn1,lorien,1a2s3d4f5g,koleso,murph,natascha,sunkist,kennwort,emine,grinder,m12345,q1q2q3q4,cheeba,money2,qazwsxedc1,diamante,prosto,pdiddy,stinky1,gabby1,luckys,franci,pornographic,moochie,gfhjdjp,samdog,empire1,comicbookdb,emili,motdepasse,iphone,braveheart,reeses,nebula,sanjose,bubba2,kickflip,arcangel,superbow,porsche911,xyzzy,nigger1,dagobert,devil1,alatam,monkey2,barbara1,12345v,vfpfafrf,alessio,babemagn,aceman,arrakis,kavkaz,987789,jasons,berserk,sublime1,rogue1,myspace,buckwhea,csyekz,pussy4me,vette1,boots1,boingo,arnaud,budlite,redstorm,paramore,becky1,imtheman,chango,marley1,milkyway,666555,giveme,mahalo,lux2000,lucian,paddy,praxis,shimano,bigpenis,creeper,newproject2004,rammstei,j3qq4h7h2v,hfljcnm,lambchop,anthony2,bugman,gfhjkm12,dreamer1,stooges,cybersex,diamant,cowboyup,maximus1,sentra,615243,goethe,manhatta,fastcar,selmer,1213141516,yfnfitymrf,denni,chewey,yankee1,elektra,123456789p,trousers,fishface,topspin,orwell,vorona,sodapop,motherfu,ibilltes,forall,kookie,ronald1,balrog,maximilian,mypasswo,sonny1,zzxxcc,tkfkdg,magoo,mdogg,heeled,gitara,lesbos,marajade,tippy,morozova,enter123,lesbean,pounded,asd456,fialka,scarab,sharpie,spanky1,gstring,sachin,12345asd,princeto,hellohel,ursitesux,billows,1234kekc,kombat,cashew,duracell,kseniya,sevenof9,kostik,arthur1,corvet07,rdfhnbhf,songoku,tiberian,needforspeed,1qwert,dropkick,kevin123,panache,libra,a123456a,kjiflm,vfhnsirf,cntgfy,iamcool,narut,buffer,sk8ordie,urlaub,fireblade,blanked,marishka,gemini1,altec,gorillaz,chief1,revival47,ironman1,space1,ramstein,doorknob,devilmaycry,nemesis1,sosiska,pennstat,monday1,pioner,shevchenko,detectiv,evildead,blessed1,aggie,coffees,tical,scotts,bullwink,marsel,krypto,adrock,rjitxrf,asmodeus,rapunzel,theboys,hotdogs,deepthro,maxpayne,veronic,fyyeirf,otter,cheste,abbey1,thanos,bedrock,bartok,google1,xxxzzz,rodent,montecarlo,hernande,mikayla,123456789l,bravehea,12locked,ltymub,pegasus1,ameteur,saltydog,faisal,milfnew,momsuck,everques,ytngfhjkz,m0nkey,businessbabe,cooki,custard,123456ab,lbvjxrf,outlaws,753357,qwerty78,udacha,insider,chees,fuckmehard,shotokan,katya,seahorse,vtldtlm,turtle1,mike12,beebop,heathe,everton1,darknes,barnie,rbcekz,alisher,toohot,theduke,555222,reddog1,breezy,bulldawg,monkeyman,baylee,losangel,mastermi,apollo1,aurelie,zxcvb12345,cayenne,bastet,wsxzaq,geibcnbr,yello,fucmy69,redwall,ladybird,bitchs,cccccc1,rktjgfnhf,ghjdthrf,quest1,oedipus,linus,impalass,fartman,12345k,fokker,159753a,optiplex,bbbbbb1,realtor,slipkno,santacru,rowdy,jelena,smeller,3984240,ddddd1,sexyme,janet1,3698741,eatme69,cazzone,today1,poobear,ignatius,master123,newpass1,heather2,snoopdogg,blondinka,pass12,honeydew,fuckthat,890098890,lovem,goldrush,gecko,biker1,llama,pendejo,avalanche,fremont,snowman1,gandolf,chowder,1a2b3c4d5e,flyguy,magadan,1fuck,pingvin,nokia5230,ab1234,lothar,lasers,bignuts,renee1,royboy,skynet,12340987,1122334,dragrace,lovely1,22334455,booter,12345612,corvett,123456qq,capital1,videoes,funtik,wyvern,flange,sammydog,hulkster,13245768,not4you,vorlon,omegared,l58jkdjp!,filippo,123mudar,samadams,petrus,chris12,charlie123,123456789123,icetea,sunderla,adrian1,123qweas,kazanova,aslan,monkey123,fktyeirf,goodsex,123ab,lbtest,banaan,bluenose,837519,asd12345,waffenss,whateve,1a2a3a4a,trailers,vfhbirf,bhbcrf,klaatu,turk182,monsoon,beachbum,sunbeam,succes,clyde1,viking1,rawhide,bubblegum,princ,mackenzi,hershey1,222555,dima55,niggaz,manatee,aquila,anechka,pamel,bugsbunn,lovel,sestra,newport1,althor,hornyman,wakeup,zzz111,phishy,cerber,torrent,thething,solnishko,babel,buckeye1,peanu,ethernet,uncencored,baraka,665544,chris2,rb26dett,willy1,choppers,texaco,biggirl,123456b,anna2614,sukebe,caralho,callofduty,rt6ytere,jesus7,angel12,1money,timelord,allblack,pavlova,romanov,tequiero,yitbos,lookup,bulls23,snowflake,dickweed,barks,lever,irisha,firestar,fred1234,ghjnjnbg,danman,gatito,betty1,milhouse,kbctyjr,masterbaiting,delsol,papit,doggys,123698741,bdfyjdf,invictus,bloods,kayla1,yourmama,apple2,angelok,bigboy1,pontiac1,verygood,yeshua,twins2,porn4me,141516,rasta69,james2,bosshog,candys,adventur,stripe,djkjlz,dokken,austin316,skins,hogwarts,vbhevbh,navigato,desperado,xxx666,cneltyn,vasiliy,hazmat,daytek,eightbal,fred1,four20,74227422,fabia,aerosmith,manue,wingchun,boohoo,hombre,sanity72,goatboy,fuckm,partizan,avrora,utahjazz,submarin,pussyeat,heinlein,control1,costaric,smarty,chuan,triplets,snowy,snafu,teacher1,vangogh,vandal,evergree,cochise,qwerty99,pyramid1,saab900,sniffer,qaz741,lebron23,mark123,wolvie,blackbelt,yoshi,feeder,janeway,nutella,fuking,asscock,deepak,poppie,bigshow,housewife,grils,tonto,cynthia1,temptress,irakli,belle1,russell1,manders,frank123,seabass,gforce,songbird,zippy1,naught,brenda1,chewy1,hotshit,topaz,43046721,girfriend,marinka,jakester,thatsme,planeta,falstaff,patrizia,reborn,riptide,cherry1,shuan,nogard,chino,oasis1,qwaszx12,goodlife,davis1,1911a1,harrys,shitfuck,12345678900,russian7,007700,bulls1,porshe,danil,dolphi,river1,sabaka,gobigred,deborah1,volkswagen,miamo,alkaline,muffdive,1letmein,fkbyrf,goodguy,hallo1,nirvan,ozzie,cannonda,cvbhyjdf,marmite,germany1,joeblow,radio1,love11,raindrop,159852,jacko,newday,fathead,elvis123,caspe,citibank,sports1,deuce,boxter,fakepass,golfman,snowdog,birthday4,nonmembe,niklas,parsifal,krasota,theshit,1235813,maganda,nikita1,omicron,cassie1,columbo,buick,sigma1,thistle,bassin,rickster,apteka,sienna,skulls,miamor,coolgirl,gravis,1qazxc,virgini,hunter2,akasha,batma,motorcyc,bambino,tenerife,fordf250,zhuan,iloveporn,markiza,hotbabes,becool,fynjybyf,wapapapa,forme,mamont,pizda,dragonz,sharon1,scrooge,mrbill,pfloyd,leeroy,natedog,ishmael,777111,tecumseh,carajo,nfy.irf,0000000000o,blackcock,fedorov,antigone,feanor,novikova,bobert,peregrin,spartan117,pumkin,rayman,manuals,tooltime,555333,bonethug,marina1,bonnie1,tonyhawk,laracroft,mahalkita,18273645,terriers,gamer,hoser,littlema,molotok,glennwei,lemon1,caboose,tater,12345654321,brians,fritz1,mistral,jigsaw,fuckshit,hornyguy,southside,edthom,antonio1,bobmarle,pitures,ilikesex,crafty,nexus,boarder,fulcrum,astonvil,yanks1,yngwie,account1,zooropa,hotlegs,sammi,gumbo,rover1,perkele,maurolarastefy,lampard,357753,barracud,dmband,abcxyz,pathfinder,335577,yuliya,micky,jayman,asdfg12345,1596321,halcyon,rerfhtre,feniks,zaxscd,gotyoass,jaycee,samson1,jamesb,vibrate,grandpri,camino,colossus,davidb,mamo4ka,nicky1,homer123,pinguin,watermelon,shadow01,lasttime,glider,823762,helen1,pyramids,tulane,osama,rostov,john12,scoote,bhbyrf,gohan,galeries,joyful,bigpussy,tonka,mowgli,astalavista,zzz123,leafs,dalejr8,unicorn1,777000,primal,bigmama,okmijn,killzone,qaz12345,snookie,zxcvvcxz,davidc,epson,rockman,ceaser,beanbag,katten,3151020,duckhunt,segreto,matros,ragnar,699669,sexsexse,123123z,fuckyeah,bigbutts,gbcmrf,element1,marketin,saratov,elbereth,blaster1,yamahar6,grime,masha,juneau,1230123,pappy,lindsay1,mooner,seattle1,katzen,lucent,polly1,lagwagon,pixie,misiaczek,666666a,smokedog,lakers24,eyeball,ironhors,ametuer,volkodav,vepsrf,kimmy,gumby1,poi098,ovation,1q2w3,drinker,penetrating,summertime,1dallas,prima,modles,takamine,hardwork,macintosh,tahoe,passthie,chiks,sundown,flowers1,boromir,music123,phaedrus,albert1,joung,malakas,gulliver,parker1,balder,sonne,jessie1,domainlock2005,express1,vfkbyf,youandme,raketa,koala,dhjnvytyjub,nhfrnjh,testibil,ybrbnjc,987654321q,axeman,pintail,pokemon123,dogggg,shandy,thesaint,11122233,x72jhhu3z,theclash,raptors,zappa1,djdjxrf,hell666,friday1,vivaldi,pluto1,lance1,guesswho,jeadmi,corgan,skillz,skippy1,mango1,gymnastic,satori,362514,theedge,cxfcnkbdfz,sparkey,deicide,bagels,lololol,lemmings,r4e3w2q1,silve,staind,schnuffi,dazzle,basebal1,leroy1,bilbo1,luckie,qwerty2,goodfell,hermione,peaceout,davidoff,yesterda,killah,flippy,chrisb,zelda1,headless,muttley,fuckof,tittys,catdaddy,photog,beeker,reaver,ram1500,yorktown,bolero,tryagain,arman,chicco,learjet,alexei,jenna1,go2hell,12s3t4p55,momsanaladventure,mustang9,protoss,rooter,ginola,dingo1,mojave,erica1,1qazse4,marvin1,redwolf,sunbird,dangerou,maciek,girsl,hawks1,packard1,excellen,dashka,soleda,toonces,acetate,nacked,jbond007,alligator,debbie1,wellhung,monkeyma,supers,rigger,larsson,vaseline,rjnzhf,maripos,123456asd,cbr600rr,doggydog,cronic,jason123,trekker,flipmode,druid,sonyvaio,dodges,mayfair,mystuff,fun4me,samanta,sofiya,magics,1ranger,arcane,sixtynin,222444,omerta,luscious,gbyudby,bobcats,envision,chance1,seaweed,holdem,tomate,mensch,slicer,acura1,goochi,qweewq,punter,repoman,tomboy,never1,cortina,gomets,147896321,369852147,dogma,bhjxrf,loglatin,eragon,strato,gazelle,growler,885522,klaudia,payton34,fuckem,butchie,scorpi,lugano,123456789k,nichola,chipper1,spide,uhbujhbq,rsalinas,vfylfhby,longhorns,bugatti,everquest,!qaz2wsx,blackass,999111,snakeman,p455w0rd,fanatic,family1,pfqxbr,777vlad,mysecret,marat,phoenix2,october1,genghis,panties1,cooker,citron,ace123,1234569,gramps,blackcoc,kodiak1,hickory,ivanhoe,blackboy,escher,sincity,beaks,meandyou,spaniel,canon1,timmy1,lancaste,polaroid,edinburg,fuckedup,hotman,cueball,golfclub,gopack,bookcase,worldcup,dkflbvbhjdbx,twostep,17171717aa,letsplay,zolushka,stella1,pfkegf,kingtut,67camaro,barracuda,wiggles,gjhjkm,prancer,patata,kjifhf,theman1,romanova,sexyass,copper1,dobber,sokolov,pomidor,algernon,cadman,amoremio,william2,silly1,bobbys,hercule,hd764nw5d7e1vb1,defcon,deutschland,robinhood,alfalfa,machoman,lesbens,pandora1,easypay,tomservo,nadezhda,goonies,saab9000,jordyn,f15eagle,dbrecz,12qwerty,greatsex,thrawn,blunted,baywatch,doggystyle,loloxx,chevy2,january1,kodak,bushel,78963214,ub6ib9,zz8807zpl,briefs,hawker,224488,first1,bonzo,brent1,erasure,69213124,sidewind,soccer13,622521,mentos,kolibri,onepiece,united1,ponyboy,keksa12,wayer,mypussy,andrej,mischa,mille,bruno123,garter,bigpun,talgat,familia,jazzy1,mustang8,newjob,747400,bobber,blackbel,hatteras,ginge,asdfjkl;,camelot1,blue44,rebbyt34,ebony1,vegas123,myboys,aleksander,ijrjkflrf,lopata,pilsner,lotus123,m0nk3y,andreev,freiheit,balls1,drjynfrnt,mazda1,waterpolo,shibumi,852963,123bbb,cezer121,blondie1,volkova,rattler,kleenex,ben123,sanane,happydog,satellit,qazplm,qazwsxedcrfvtgb,meowmix,badguy,facefuck,spice1,blondy,major1,25000,anna123,654321a,sober1,deathrow,patterso,china1,naruto1,hawkeye1,waldo1,butchy,crayon,5tgb6yhn,klopik,crocodil,mothra,imhorny,pookie1,splatter,slippy,lizard1,router,buratino,yahweh,123698,dragon11,123qwe456,peepers,trucker1,ganjaman,1hxboqg2,cheyanne,storys,sebastie,zztop,maddison,4rfv3edc,darthvader,jeffro,iloveit,victor1,hotty,delphin,lifeisgood,gooseman,shifty,insertions,dude123,abrupt,123masha,boogaloo,chronos,stamford,pimpster,kthjxrf,getmein,amidala,flubber,fettish,grapeape,dantes,oralsex,jack1,foxcg33,winchest,francis1,getin,archon,cliffy,blueman,1basebal,sport1,emmitt22,porn123,bignasty,morga,123hfjdk147,ferrar,juanito,fabiol,caseydog,steveo,peternorth,paroll,kimchi,bootleg,gaijin,secre,acacia,eatme2,amarillo,monkey11,rfhfgep,tylers,a1a2a3a4a5,sweetass,blower,rodina,babushka,camilo,cimbom,tiffan,vfnbkmlf,ohbaby,gotigers,lindsey1,dragon13,romulus,qazxsw12,zxcvbn1,dropdead,hitman47,snuggle,eleven11,bloopers,357mag,avangard,bmw320,ginscoot,dshade,masterkey,voodoo1,rootedit,caramba,leahcim,hannover,8phrowz622,tim123,cassius,000000a,angelito,zzzzz1,badkarma,star1,malaga,glenwood,footlove,golf1,summer12,helpme1,fastcars,titan1,police1,polinka,k.jdm,marusya,augusto,shiraz,pantyhose,donald1,blaise,arabella,brigada,c3por2d2,peter01,marco1,hellow,dillweed,uzumymw,geraldin,loveyou2,toyota1,088011,gophers,indy500,slainte,5hsu75kpot,teejay,renat,racoon,sabrin,angie1,shiznit,harpua,sexyred,latex,tucker1,alexandru,wahoo,teamwork,deepblue,goodison,rundmc,r2d2c3p0,puppys,samba,ayrton,boobed,999777,topsecre,blowme1,123321z,loudog,random1,pantie,drevil,mandolin,121212q,hottub,brother1,failsafe,spade1,matvey,open1234,carmen1,priscill,schatzi,kajak,gooddog,trojans1,gordon1,kayak,calamity,argent,ufhvjybz,seviyi,penfold,assface,dildos,hawkwind,crowbar,yanks,ruffles,rastus,luv2epus,open123,aquafina,dawns,jared1,teufel,12345c,vwgolf,pepsi123,amores,passwerd,01478520,boliva,smutty,headshot,password3,davidd,zydfhm,gbgbcmrf,pornpass,insertion,ceckbr,test2,car123,checkit,dbnfkbq,niggas,nyyankee,muskrat,nbuhtyjr,gunner1,ocean1,fabienne,chrissy1,wendys,loveme89,batgirl,cerveza,igorek,steel1,ragman,boris123,novifarm,sexy12,qwerty777,mike01,giveitup,123456abc,fuckall,crevice,hackerz,gspot,eight8,assassins,texass,swallows,123458,baldur,moonshine,labatt,modem,sydney1,voland,dbnfkz,hotchick,jacker,princessa,dawgs1,holiday1,booper,reliant,miranda1,jamaica1,andre1,badnaamhere,barnaby,tiger7,david12,margaux,corsica,085tzzqi,universi,thewall,nevermor,martin6,qwerty77,cipher,apples1,0102030405,seraphim,black123,imzadi,gandon,ducati99,1shadow,dkflbvbhjdyf,44magnum,bigbad,feedme,samantha1,ultraman,redneck1,jackdog,usmc0311,fresh1,monique1,tigre,alphaman,cool1,greyhoun,indycar,crunchy,55chevy,carefree,willow1,063dyjuy,xrated,assclown,federica,hilfiger,trivia,bronco1,mamita,100200300,simcity,lexingky,akatsuki,retsam,johndeere,abudfv,raster,elgato,businka,satanas,mattingl,redwing1,shamil,patate,mannn,moonstar,evil666,b123456,bowl300,tanechka,34523452,carthage,babygir,santino,bondarenko,jesuss,chico1,numlock,shyguy,sound1,kirby1,needit,mostwanted,427900,funky1,steve123,passions,anduril,kermit1,prospero,lusty,barakuda,dream1,broodwar,porky,christy1,mahal,yyyyyy1,allan1,1sexy,flintsto,capri,cumeater,heretic,robert2,hippos,blindax,marykay,collecti,kasumi,1qaz!qaz,112233q,123258,chemistr,coolboy,0o9i8u,kabuki,righton,tigress,nessie,sergej,andrew12,yfafyz,ytrhjvfyn,angel7,victo,mobbdeep,lemming,transfor,1725782,myhouse,aeynbr,muskie,leno4ka,westham1,cvbhyjd,daffodil,pussylicker,pamela1,stuffer,warehous,tinker1,2w3e4r,pluton,louise1,polarbea,253634,prime1,anatoliy,januar,wysiwyg,cobraya,ralphy,whaler,xterra,cableguy,112233a,porn69,jamesd,aqualung,jimmy123,lumpy,luckyman,kingsize,golfing1,alpha7,leeds1,marigold,lol1234,teabag,alex11,10sne1,saopaulo,shanny,roland1,basser,3216732167,carol1,year2005,morozov,saturn1,joseluis,bushed,redrock,memnoch,lalaland,indiana1,lovegod,gulnaz,buffalos,loveyou1,anteater,pattaya,jaydee,redshift,bartek,summerti,coffee1,ricochet,incest,schastie,rakkaus,h2opolo,suikoden,perro,dance1,loveme1,whoopass,vladvlad,boober,flyers1,alessia,gfcgjhn,pipers,papaya,gunsling,coolone,blackie1,gonads,gfhjkzytn,foxhound,qwert12,gangrel,ghjvtntq,bluedevi,mywife,summer01,hangman,licorice,patter,vfr750,thorsten,515253,ninguna,dakine,strange1,mexic,vergeten,12345432,8phrowz624,stampede,floyd1,sailfish,raziel,ananda,giacomo,freeme,crfprf,74185296,allstars,master01,solrac,gfnhbjn,bayliner,bmw525,3465xxx,catter,single1,michael3,pentium4,nitrox,mapet123456,halibut,killroy,xxxxx1,phillip1,poopsie,arsenalfc,buffys,kosova,all4me,32165498,arslan,opensesame,brutis,charles2,pochta,nadegda,backspac,mustang0,invis,gogeta,654321q,adam25,niceday,truckin,gfdkbr,biceps,sceptre,bigdave,lauras,user345,sandys,shabba,ratdog,cristiano,natha,march13,gumball,getsdown,wasdwasd,redhead1,dddddd1,longlegs,13572468,starsky,ducksoup,bunnys,omsairam,whoami,fred123,danmark,flapper,swanky,lakings,yfhenj,asterios,rainier,searcher,dapper,ltdjxrf,horsey,seahawk,shroom,tkfkdgo,aquaman,tashkent,number9,messi10,1asshole,milenium,illumina,vegita,jodeci,buster01,bareback,goldfinger,fire1,33rjhjds,sabian,thinkpad,smooth1,sully,bonghits,sushi1,magnavox,colombi,voiture,limpone,oldone,aruba,rooster1,zhenya,nomar5,touchdow,limpbizkit,rhfcfdxbr,baphomet,afrodita,bball1,madiso,ladles,lovefeet,matthew2,theworld,thunderbird,dolly1,123rrr,forklift,alfons,berkut,speedy1,saphire,oilman,creatine,pussylov,bastard1,456258,wicked1,filimon,skyline1,fucing,yfnfkbz,hot123,abdulla,nippon,nolimits,billiard,booty1,buttplug,westlife,coolbean,aloha1,lopas,asasin,1212121,october2,whodat,good4u,d12345,kostas,ilya1992,regal,pioneer1,volodya,focus1,bastos,nbvjif,fenix,anita1,vadimka,nickle,jesusc,123321456,teste,christ1,essendon,evgenii,celticfc,adam1,forumwp,lovesme,26exkp,chillout,burly,thelast1,marcus1,metalgear,test11,ronaldo7,socrate,world1,franki,mommie,vicecity,postov1000,charlie3,oldschool,333221,legoland,antoshka,counterstrike,buggy,mustang3,123454,qwertzui,toons,chesty,bigtoe,tigger12,limpopo,rerehepf,diddle,nokia3250,solidsnake,conan1,rockroll,963369,titanic1,qwezxc,cloggy,prashant,katharin,maxfli,takashi,cumonme,michael9,mymother,pennstate,khalid,48151623,fightclub,showboat,mateusz,elrond,teenie,arrow1,mammamia,dustydog,dominator,erasmus,zxcvb1,1a2a3a,bones1,dennis1,galaxie,pleaseme,whatever1,junkyard,galadriel,charlies,2wsxzaq1,crimson1,behemoth,teres,master11,fairway,shady1,pass99,1batman,joshua12,baraban,apelsin,mousepad,melon,twodogs,123321qwe,metalica,ryjgrf,pipiska,rerfhfxf,lugnut,cretin,iloveu2,powerade,aaaaaaa1,omanko,kovalenko,isabe,chobits,151nxjmt,shadow11,zcxfcnkbdf,gy3yt2rgls,vfhbyrf,159753123,bladerunner,goodone,wonton,doodie,333666999,fuckyou123,kitty123,chisox,orlando1,skateboa,red12345,destroye,snoogans,satan1,juancarlo,goheels,jetson,scottt,fuckup,aleksa,gfhfljrc,passfind,oscar123,derrick1,hateme,viper123,pieman,audi100,tuffy,andover,shooter1,10000,makarov,grant1,nighthaw,13576479,browneye,batigol,nfvfhf,chocolate1,7hrdnw23,petter,bantam,morlii,jediknight,brenden,argonaut,goodstuf,wisconsi,315920,abigail1,dirtbag,splurge,k123456,lucky777,valdepen,gsxr600,322223,ghjnjrjk,zaq1xsw2cde3,schwanz,walter1,letmein22,nomads,124356,codeblue,nokian70,fucke,footbal1,agyvorc,aztecs,passw0r,smuggles,femmes,ballgag,krasnodar,tamuna,schule,sixtynine,empires,erfolg,dvader,ladygaga,elite1,venezuel,nitrous,kochamcie,olivia1,trustn01,arioch,sting1,131415,tristar,555000,maroon,135799,marsik,555556,fomoco,natalka,cwoui,tartan,davecole,nosferat,hotsauce,dmitry,horus,dimasik,skazka,boss302,bluebear,vesper,ultras,tarantul,asd123asd,azteca,theflash,8ball,1footbal,titlover,lucas123,number6,sampson1,789852,party1,dragon99,adonai,carwash,metropol,psychnau,vthctltc,hounds,firework,blink18,145632,wildcat1,satchel,rice80,ghtktcnm,sailor1,cubano,anderso,rocks1,mike11,famili,dfghjc,besiktas,roygbiv,nikko,bethan,minotaur,rakesh,orange12,hfleuf,jackel,myangel,favorite7,1478520,asssss,agnieszka,haley1,raisin,htubyf,1buster,cfiekz,derevo,1a2a3a4a5a,baltika,raffles,scruffy1,clitlick,louis1,buddha1,fy.nrf,walker1,makoto,shadow2,redbeard,vfvfvskfhfve,mycock,sandydog,lineman,network1,favorite8,longdick,mustangg,mavericks,indica,1killer,cisco1,angelofwar,blue69,brianna1,bubbaa,slayer666,level42,baldrick,brutus1,lowdown,haribo,lovesexy,500000,thissuck,picker,stephy,1fuckme,characte,telecast,1bigdog,repytwjdf,thematrix,hammerhe,chucha,ganesha,gunsmoke,georgi,sheltie,1harley,knulla,sallas,westie,dragon7,conker,crappie,margosha,lisboa,3e2w1q,shrike,grifter,ghjcnjghjcnj,asdfg1,mnbvcxz1,myszka,posture,boggie,rocketman,flhtyfkby,twiztid,vostok,pi314159,force1,televizor,gtkmvtym,samhain,imcool,jadzia,dreamers,strannik,k2trix,steelhea,nikitin,commodor,brian123,chocobo,whopper,ibilljpf,megafon,ararat,thomas12,ghbrjkbcn,q1234567890,hibernia,kings1,jim123,redfive,68camaro,iawgk2,xavier1,1234567u,d123456,ndirish,airborn,halfmoon,fluffy1,ranchero,sneaker,soccer2,passion1,cowman,birthday1,johnn,razzle,glock17,wsxqaz,nubian,lucky2,jelly1,henderso,eric1,123123e,boscoe01,fuck0ff,simpson1,sassie,rjyjgkz,nascar3,watashi,loredana,janus,wilso,conman,david2,mothe,iloveher,snikers,davidj,fkmnthyfnbdf,mettss,ratfink,123456h,lostsoul,sweet16,brabus,wobble,petra1,fuckfest,otters,sable1,svetka,spartacu,bigstick,milashka,1lover,pasport,champagn,papichul,hrvatska,hondacivic,kevins,tacit,moneybag,gohogs,rasta1,246813579,ytyfdbcnm,gubber,darkmoon,vitaliy,233223,playboys,tristan1,joyce1,oriflame,mugwump,access2,autocad,thematri,qweqwe123,lolwut,ibill01,multisyn,1233211,pelikan,rob123,chacal,1234432,griffon,pooch,dagestan,geisha,satriani,anjali,rocketma,gixxer,pendrago,vincen,hellokit,killyou,ruger,doodah,bumblebe,badlands,galactic,emachines,foghorn,jackso,jerem,avgust,frontera,123369,daisymae,hornyboy,welcome123,tigger01,diabl,angel13,interex,iwantsex,rockydog,kukolka,sawdust,online1,3234412,bigpapa,jewboy,3263827,dave123,riches,333222,tony1,toggle,farter,124816,tities,balle,brasilia,southsid,micke,ghbdtn12,patit,ctdfcnjgjkm,olds442,zzzzzz1,nelso,gremlins,gypsy1,carter1,slut69,farcry,7415963,michael8,birdie1,charl,123456789abc,100001,aztec,sinjin,bigpimpi,closeup,atlas1,nvidia,doggone,classic1,manana,malcolm1,rfkbyf,hotbabe,rajesh,dimebag,ganjubas,rodion,jagr68,seren,syrinx,funnyman,karapuz,123456789n,bloomin,admin18533362,biggdogg,ocarina,poopy1,hellome,internet1,booties,blowjobs,matt1,donkey1,swede,1jennife,evgeniya,lfhbyf,coach1,444777,green12,patryk,pinewood,justin12,271828,89600506779,notredame,tuborg,lemond,sk8ter,million1,wowser,pablo1,st0n3,jeeves,funhouse,hiroshi,gobucs,angeleye,bereza,winter12,catalin,qazedc,andros,ramazan,vampyre,sweethea,imperium,murat,jamest,flossy,sandeep,morgen,salamandra,bigdogg,stroller,njdevils,nutsack,vittorio,%%passwo,playful,rjyatnrf,tookie,ubnfhf,michi,777444,shadow13,devils1,radiance,toshiba1,beluga,amormi,dandfa,trust1,killemall,smallville,polgara,billyb,landscap,steves,exploite,zamboni,damage11,dzxtckfd,trader12,pokey1,kobe08,damager,egorov,dragon88,ckfdbr,lisa69,blade2,audis4,nelson1,nibbles,23176djivanfros,mutabor,artofwar,matvei,metal666,hrfzlz,schwinn,poohbea,seven77,thinker,123456789qwerty,sobriety,jakers,karamelka,vbkfyf,volodin,iddqd,dale03,roberto1,lizaveta,qqqqqq1,cathy1,08154711,davidm,quixote,bluenote,tazdevil,katrina1,bigfoot1,bublik,marma,olechka,fatpussy,marduk,arina,nonrev67,qqqq1111,camill,wtpfhm,truffle,fairview,mashina,voltaire,qazxswedcvfr,dickface,grassy,lapdance,bosstone,crazy8,yackwin,mobil,danielit,mounta1n,player69,bluegill,mewtwo,reverb,cnthdf,pablito,a123321,elena1,warcraft1,orland,ilovemyself,rfntyjr,joyride,schoo,dthjxrf,thetachi,goodtimes,blacksun,humpty,chewbacca,guyute,123xyz,lexicon,blue45,qwe789,galatasaray,centrino,hendrix1,deimos,saturn5,craig1,vlad1996,sarah123,tupelo,ljrnjh,hotwife,bingos,1231231,nicholas1,flamer,pusher,1233210,heart1,hun999,jiggy,giddyup,oktober,123456zxc,budda,galahad,glamur,samwise,oneton,bugsbunny,dominic1,scooby2,freetime,internat,159753852,sc00ter,wantit,mazinger,inflames,laracrof,greedo,014789,godofwar,repytwjd,water123,fishnet,venus1,wallace1,tenpin,paula1,1475963,mania,novikov,qwertyasdfgh,goldmine,homies,777888999,8balls,holeinon,paper1,samael,013579,mansur,nikit,ak1234,blueline,polska1,hotcock,laredo,windstar,vbkbwbz,raider1,newworld,lfybkrf,catfish1,shorty1,piranha,treacle,royale,2234562,smurfs,minion,cadence,flapjack,123456p,sydne,135531,robinhoo,nasdaq,decatur,cyberonline,newage,gemstone,jabba,touchme,hooch,pigdog,indahous,fonzie,zebra1,juggle,patrick2,nihongo,hitomi,oldnavy,qwerfdsa,ukraina,shakti,allure,kingrich,diane1,canad,piramide,hottie1,clarion,college1,5641110,connect1,therion,clubber,velcro,dave1,astra1,13579-,astroboy,skittle,isgreat,photoes,cvzefh1gkc,001100,2cool4u,7555545,ginger12,2wsxcde3,camaro69,invader,domenow,asd1234,colgate,qwertasdfg,jack123,pass01,maxman,bronte,whkzyc,peter123,bogie,yecgaa,abc321,1qay2wsx,enfield,camaroz2,trashman,bonefish,system32,azsxdcfvgb,peterose,iwantyou,dick69,temp1234,blastoff,capa200,connie1,blazin,12233445,sexybaby,123456j,brentfor,pheasant,hommer,jerryg,thunders,august1,lager,kapusta,boobs1,nokia5300,rocco1,xytfu7,stars1,tugger,123sas,blingbling,1bubba,0wnsyo0,1george,baile,richard2,habana,1diamond,sensatio,1golfer,maverick1,1chris,clinton1,michael7,dragons1,sunrise1,pissant,fatim,mopar1,levani,rostik,pizzapie,987412365,oceans11,748159263,cum4me,palmetto,4r3e2w1q,paige1,muncher,arsehole,kratos,gaffer,banderas,billys,prakash,crabby,bungie,silver12,caddis,spawn1,xboxlive,sylvania,littlebi,524645,futura,valdemar,isacs155,prettygirl,big123,555444,slimer,chicke,newstyle,skypilot,sailormoon,fatluvr69,jetaime,sitruc,jesuschrist,sameer,bear12,hellion,yendor,country1,etnies,conejo,jedimast,darkknight,toobad,yxcvbn,snooks,porn4life,calvary,alfaromeo,ghostman,yannick,fnkfynblf,vatoloco,homebase,5550666,barret,1111111111zz,odysseus,edwardss,favre4,jerrys,crybaby,xsw21qaz,firestor,spanks,indians1,squish,kingair,babycakes,haters,sarahs,212223,teddyb,xfactor,cumload,rhapsody,death123,three3,raccoon,thomas2,slayer66,1q2q3q4q5q,thebes,mysterio,thirdeye,orkiox.,nodoubt,bugsy,schweiz,dima1996,angels1,darkwing,jeronimo,moonpie,ronaldo9,peaches2,mack10,manish,denise1,fellowes,carioca,taylor12,epaulson,makemoney,oc247ngucz,kochanie,3edcvfr4,vulture,1qw23e,1234567z,munchie,picard1,xthtgfirf,sportste,psycho1,tahoe1,creativ,perils,slurred,hermit,scoob,diesel1,cards1,wipeout,weeble,integra1,out3xf,powerpc,chrism,kalle,ariadne,kailua,phatty,dexter1,fordman,bungalow,paul123,compa,train1,thejoker,jys6wz,pussyeater,eatmee,sludge,dominus,denisa,tagheuer,yxcvbnm,bill1,ghfdlf,300zx,nikita123,carcass,semaj,ramone,muenchen,animal1,greeny,annemari,dbrf134,jeepcj7,mollys,garten,sashok,ironmaid,coyotes,astoria,george12,westcoast,primetim,123456o,panchito,rafae,japan1,framer,auralo,tooshort,egorova,qwerty22,callme,medicina,warhawk,w1w2w3w4,cristia,merli,alex22,kawaii,chatte,wargames,utvols,muaddib,trinket,andreas1,jjjjj1,cleric,scooters,cuntlick,gggggg1,slipknot1,235711,handcuff,stussy,guess1,leiceste,ppppp1,passe,lovegun,chevyman,hugecock,driver1,buttsex,psychnaut1,cyber1,black2,alpha12,melbourn,man123,metalman,yjdsqujl,blondi,bungee,freak1,stomper,caitlin1,nikitina,flyaway,prikol,begood,desperad,aurelius,john1234,whosyourdaddy,slimed123,bretagne,den123,hotwheel,king123,roodypoo,izzicam,save13tx,warpten,nokia3310,samolet,ready1,coopers,scott123,bonito,1aaaaa,yomomma,dawg1,rache,itworks,asecret,fencer,451236,polka,olivetti,sysadmin,zepplin,sanjuan,479373,lickem,hondacrx,pulamea,future1,naked1,sexyguy,w4g8at,lollol1,declan,runner1,rumple,daddy123,4snz9g,grandprix,calcio,whatthefuck,nagrom,asslick,pennst,negrit,squiggy,1223334444,police22,giovann,toronto1,tweet,yardbird,seagate,truckers,554455,scimitar,pescator,slydog,gaysex,dogfish,fuck777,12332112,qazxswed,morkovka,daniela1,imback,horny69,789123456,123456789w,jimmy2,bagger,ilove69,nikolaus,atdhfkm,rebirth,1111aaaa,pervasive,gjgeufq,dte4uw,gfhnbpfy,skeletor,whitney1,walkman,delorean,disco1,555888,as1234,ishikawa,fuck12,reaper1,dmitrii,bigshot,morrisse,purgen,qwer4321,itachi,willys,123123qwe,kisska,roma123,trafford,sk84life,326159487,pedros,idiom,plover,bebop,159875321,jailbird,arrowhea,qwaszx123,zaxscdvf,catlover,bakers,13579246,bones69,vermont1,helloyou,simeon,chevyz71,funguy,stargaze,parolparol,steph1,bubby,apathy,poppet,laxman,kelly123,goodnews,741236,boner1,gaetano,astonvilla,virtua,luckyboy,rocheste,hello2u,elohim,trigger1,cstrike,pepsicola,miroslav,96385274,fistfuck,cheval,magyar,svetlanka,lbfyjxrf,mamedov,123123123q,ronaldo1,scotty1,1nicole,pittbull,fredd,bbbbb1,dagwood,gfhkfvtyn,ghblehrb,logan5,1jordan,sexbomb,omega2,montauk,258741,dtythf,gibbon,winamp,thebomb,millerli,852654,gemin,baldy,halflife2,dragon22,mulberry,morrigan,hotel6,zorglub,surfin,951159,excell,arhangel,emachine,moses1,968574,reklama,bulldog2,cuties,barca,twingo,saber,elite11,redtruck,casablan,ashish,moneyy,pepper12,cnhtktw,rjcnbr,arschloch,phenix,cachorro,sunita,madoka,joselui,adams1,mymoney,hemicuda,fyutkjr,jake12,chicas,eeeee1,sonnyboy,smarties,birdy,kitten1,cnfcbr,island1,kurosaki,taekwond,konfetka,bennett1,omega3,jackson2,fresca,minako,octavian,kban667,feyenoord,muaythai,jakedog,fktrcfylhjdyf,1357911q,phuket,sexslave,fktrcfylhjdbx,asdfjk,89015173454,qwerty00,kindbud,eltoro,sex6969,nyknicks,12344321q,caballo,evenflow,hoddle,love22,metro1,mahalko,lawdog,tightass,manitou,buckie,whiskey1,anton123,335533,password4,primo,ramair,timbo,brayden,stewie,pedro1,yorkshir,ganster,hellothe,tippy1,direwolf,genesi,rodrig,enkeli,vaz21099,sorcerer,winky,oneshot,boggle,serebro,badger1,japanes,comicbook,kamehame,alcat,denis123,echo45,sexboy,gr8ful,hondo,voetbal,blue33,2112rush,geneviev,danni1,moosey,polkmn,matthew7,ironhead,hot2trot,ashley12,sweeper,imogen,blue21,retep,stealth1,guitarra,bernard1,tatian,frankfur,vfnhbwf,slacking,haha123,963741,asdasdas,katenok,airforce1,123456789qaz,shotgun1,12qwasz,reggie1,sharo,976431,pacifica,dhip6a,neptun,kardon,spooky1,beaut,555555a,toosweet,tiedup,11121314,startac,lover69,rediska,pirata,vfhrbp,1234qwerty,energize,hansolo1,playbo,larry123,oemdlg,cnjvfnjkju,a123123,alexan,gohawks,antonius,fcbayern,mambo,yummy1,kremlin,ellen1,tremere,vfiekz,bellevue,charlie9,izabella,malishka,fermat,rotterda,dawggy,becket,chasey,kramer1,21125150,lolit,cabrio,schlong,arisha,verity,3some,favorit,maricon,travelle,hotpants,red1234,garrett1,home123,knarf,seven777,figment,asdewq,canseco,good2go,warhol,thomas01,pionee,al9agd,panacea,chevy454,brazzers,oriole,azerty123,finalfan,patricio,northsta,rebelde,bulldo,stallone,boogie1,7uftyx,cfhfnjd,compusa,cornholi,config,deere,hoopster,sepultura,grasshop,babygurl,lesbo,diceman,proverbs,reddragon,nurbek,tigerwoo,superdup,buzzsaw,kakaroto,golgo13,edwar,123qaz123,butter1,sssss1,texas2,respekt,ou812ic,123456qaz,55555a,doctor1,mcgwire,maria123,aol999,cinders,aa1234,joness,ghbrjkmyj,makemone,sammyboy,567765,380zliki,theraven,testme,mylene,elvira26,indiglo,tiramisu,shannara,baby1,123666,gfhreh,papercut,johnmish,orange8,bogey1,mustang7,bagpipes,dimarik,vsijyjr,4637324,ravage,cogito,seven11,natashka,warzone,hr3ytm,4free,bigdee,000006,243462536,bigboi,123333,trouts,sandy123,szevasz,monica2,guderian,newlife1,ratchet,r12345,razorbac,12345i,piazza31,oddjob,beauty1,fffff1,anklet,nodrog,pepit,olivi,puravida,robert12,transam1,portman,bubbadog,steelers1,wilson1,eightball,mexico1,superboy,4rfv5tgb,mzepab,samurai1,fuckslut,colleen1,girdle,vfrcbvec,q1w2e3r4t,soldier1,19844891,alyssa1,a12345a,fidelis,skelter,nolove,mickeymouse,frehley,password69,watermel,aliska,soccer15,12345e,ladybug1,abulafia,adagio,tigerlil,takehana,hecate,bootneck,junfan,arigato,wonkette,bobby123,trustnoone,phantasm,132465798,brianjo,w12345,t34vfrc1991,deadeye,1robert,1daddy,adida,check1,grimlock,muffi,airwalk,prizrak,onclick,longbeac,ernie1,eadgbe,moore1,geniu,shadow123,bugaga,jonathan1,cjrjkjdf,orlova,buldog,talon1,westport,aenima,541233432442,barsuk,chicago2,kellys,hellbent,toughguy,iskander,skoal,whatisit,jake123,scooter2,fgjrfkbgcbc,ghandi,love13,adelphia,vjhrjdrf,adrenali,niunia,jemoeder,rainbo,all4u8,anime1,freedom7,seraph,789321,tommys,antman,firetruc,neogeo,natas,bmwm3,froggy1,paul1,mamit,bayview,gateways,kusanagi,ihateu,frederi,rock1,centurion,grizli,biggin,fish1,stalker1,3girls,ilovepor,klootzak,lollo,redsox04,kirill123,jake1,pampers,vasya,hammers1,teacup,towing,celtic1,ishtar,yingyang,4904s677075,dahc1,patriot1,patrick9,redbirds,doremi,rebecc,yoohoo,makarova,epiphone,rfgbnfy,milesd,blister,chelseafc,katana1,blackrose,1james,primrose,shock5,hard1,scooby12,c6h12o6,dustoff,boing,chisel,kamil,1william,defiant1,tyvugq,mp8o6d,aaa340,nafets,sonnet,flyhigh,242526,crewcom,love23,strike1,stairway,katusha,salamand,cupcake1,password0,007james,sunnie,multisync,harley01,tequila1,fred12,driver8,q8zo8wzq,hunter01,mozzer,temporar,eatmeraw,mrbrownxx,kailey,sycamore,flogger,tincup,rahasia,ganymede,bandera,slinger,1111122222,vander,woodys,1cowboy,khaled,jamies,london12,babyboo,tzpvaw,diogenes,budice,mavrick,135797531,cheeta,macros,squonk,blackber,topfuel,apache1,falcon16,darkjedi,cheeze,vfhvtkfl,sparco,change1,gfhfif,freestyl,kukuruza,loveme2,12345f,kozlov,sherpa,marbella,44445555,bocephus,1winner,alvar,hollydog,gonefish,iwantin,barman,godislove,amanda18,rfpfynbg,eugen,abcdef1,redhawk,thelema,spoonman,baller1,harry123,475869,tigerman,cdtnjxrf,marillio,scribble,elnino,carguy,hardhead,l2g7k3,troopers,selen,dragon76,antigua,ewtosi,ulysse,astana,paroli,cristo,carmex,marjan,bassfish,letitbe,kasparov,jay123,19933991,blue13,eyecandy,scribe,mylord,ukflbjkec,ellie1,beaver1,destro,neuken,halfpint,ameli,lilly1,satanic,xngwoj,12345trewq,asdf1,bulldogg,asakura,jesucrist,flipside,packers4,biggy,kadett,biteme69,bobdog,silverfo,saint1,bobbo,packman,knowledg,foolio,fussbal,12345g,kozerog,westcoas,minidisc,nbvcxw,martini1,alastair,rasengan,superbee,memento,porker,lena123,florenc,kakadu,bmw123,getalife,bigsky,monkee,people1,schlampe,red321,memyself,0147896325,12345678900987654321,soccer14,realdeal,gfgjxrf,bella123,juggs,doritos,celtics1,peterbilt,ghbdtnbrb,gnusmas,xcountry,ghbdtn1,batman99,deusex,gtnhjdf,blablabl,juster,marimba,love2,rerjkrf,alhambra,micros,siemens1,assmaste,moonie,dashadasha,atybrc,eeeeee1,wildrose,blue55,davidl,xrp23q,skyblue,leo123,ggggg1,bestfriend,franny,1234rmvb,fun123,rules1,sebastien,chester2,hakeem,winston2,fartripper,atlant,07831505,iluvsex,q1a2z3,larrys,009900,ghjkju,capitan,rider1,qazxsw21,belochka,andy123,hellya,chicca,maximal,juergen,password1234,howard1,quetzal,daniel123,qpwoeiruty,123555,bharat,ferrari3,numbnuts,savant,ladydog,phipsi,lovepussy,etoile,power2,mitten,britneys,chilidog,08522580,2fchbg,kinky1,bluerose,loulo,ricardo1,doqvq3,kswbdu,013cpfza,timoha,ghbdtnghbdtn,3stooges,gearhead,browns1,g00ber,super7,greenbud,kitty2,pootie,toolshed,gamers,coffe,ibill123,freelove,anasazi,sister1,jigger,natash,stacy1,weronika,luzern,soccer7,hoopla,dmoney,valerie1,canes,razdvatri,washere,greenwoo,rfhjkbyf,anselm,pkxe62,maribe,daniel2,maxim1,faceoff,carbine,xtkjdtr,buddy12,stratos,jumpman,buttocks,aqswdefr,pepsis,sonechka,steeler1,lanman,nietzsch,ballz,biscuit1,wrxsti,goodfood,juventu,federic,mattman,vika123,strelec,jledfyxbr,sideshow,4life,fredderf,bigwilly,12347890,12345671,sharik,bmw325i,fylhtqrf,dannon4,marky,mrhappy,drdoom,maddog1,pompier,cerbera,goobers,howler,jenny69,evely,letitrid,cthuttdyf,felip,shizzle,golf12,t123456,yamah,bluearmy,squishy,roxan,10inches,dollface,babygirl1,blacksta,kaneda,lexingto,canadien,222888,kukushka,sistema,224422,shadow69,ppspankp,mellons,barbie1,free4all,alfa156,lostone,2w3e4r5t,painkiller,robbie1,binger,8dihc6,jaspe,rellik,quark,sogood,hoopstar,number2,snowy1,dad2ownu,cresta,qwe123asd,hjvfyjdf,gibsonsg,qbg26i,dockers,grunge,duckling,lfiekz,cuntsoup,kasia1,1tigger,woaini,reksio,tmoney,firefighter,neuron,audia3,woogie,powerboo,powermac,fatcock,12345666,upnfmc,lustful,porn1,gotlove,amylee,kbytqrf,11924704,25251325,sarasota,sexme,ozzie1,berliner,nigga1,guatemal,seagulls,iloveyou!,chicken2,qwerty21,010203040506,1pillow,libby1,vodoley,backlash,piglets,teiubesc,019283,vonnegut,perico,thunde,buckey,gtxtymrf,manunite,iiiii1,lost4815162342,madonn,270873_,britney1,kevlar,piano1,boondock,colt1911,salamat,doma77ns,anuradha,cnhjqrf,rottweil,newmoon,topgun1,mauser,fightclu,birthday21,reviewpa,herons,aassddff,lakers32,melissa2,vredina,jiujitsu,mgoblue,shakey,moss84,12345zxcvb,funsex,benji1,garci,113322,chipie,windex,nokia5310,pwxd5x,bluemax,cosita,chalupa,trotsky,new123,g3ujwg,newguy,canabis,gnaget,happydays,felixx,1patrick,cumface,sparkie,kozlova,123234,newports,broncos7,golf18,recycle,hahah,harrypot,cachondo,open4me,miria,guessit,pepsione,knocker,usmc1775,countach,playe,wiking,landrover,cracksevi,drumline,a7777777,smile123,manzana,panty,liberta,pimp69,dolfan,quality1,schnee,superson,elaine22,webhompass,mrbrownx,deepsea,4wheel,mamasita,rockport,rollie,myhome,jordan12,kfvgjxrf,hockey12,seagrave,ford1,chelsea2,samsara,marissa1,lamesa,mobil1,piotrek,tommygun,yyyyy1,wesley1,billy123,homersim,julies,amanda12,shaka,maldini,suzenet,springst,iiiiii1,yakuza,111111aa,westwind,helpdesk,annamari,bringit,hopefull,hhhhhhh1,saywhat,mazdarx8,bulova,jennife1,baikal,gfhjkmxbr,victoria1,gizmo123,alex99,defjam,2girls,sandrock,positivo,shingo,syncmast,opensesa,silicone,fuckina,senna1,karlos,duffbeer,montagne,gehrig,thetick,pepino,hamburge,paramedic,scamp,smokeweed,fabregas,phantoms,venom121293,2583458,badone,porno69,manwhore,vfvf123,notagain,vbktyf,rfnthbyrf,wildblue,kelly001,dragon66,camell,curtis1,frolova,1212123,dothedew,tyler123,reddrago,planetx,promethe,gigolo,1001001,thisone,eugeni,blackshe,cruzazul,incognito,puller,joonas,quick1,spirit1,gazza,zealot,gordito,hotrod1,mitch1,pollito,hellcat,mythos,duluth,383pdjvl,easy123,hermos,binkie,its420,lovecraf,darien,romina,doraemon,19877891,syclone,hadoken,transpor,ichiro,intell,gargamel,dragon2,wavpzt,557744,rjw7x4,jennys,kickit,rjynfrn,likeit,555111,corvus,nec3520,133113,mookie1,bochum,samsung2,locoman0,154ugeiu,vfvfbgfgf,135792,[start],tenni,20001,vestax,hufmqw,neveragain,wizkid,kjgfnf,nokia6303,tristen,saltanat,louie1,gandalf2,sinfonia,alpha3,tolstoy,ford150,f00bar,1hello,alici,lol12,riker1,hellou,333888,1hunter,qw1234,vibrator,mets86,43211234,gonzale,cookies1,sissy1,john11,bubber,blue01,cup2006,gtkmvtyb,nazareth,heybaby,suresh,teddie,mozilla,rodeo1,madhouse,gamera,123123321,naresh,dominos,foxtrot1,taras,powerup,kipling,jasonb,fidget,galena,meatman,alpacino,bookmark,farting,humper,titsnass,gorgon,castaway,dianka,anutka,gecko1,fucklove,connery,wings1,erika1,peoria,moneymaker,ichabod,heaven1,paperboy,phaser,breakers,nurse1,westbrom,alex13,brendan1,123asd123,almera,grubber,clarkie,thisisme,welkom01,51051051051,crypto,freenet,pflybwf,black12,testme2,changeit,autobahn,attica,chaoss,denver1,tercel,gnasher23,master2,vasilii,sherman1,gomer,bigbuck,derek1,qwerzxcv,jumble,dragon23,art131313,numark,beasty,cxfcnmttcnm,updown,starion,glist,sxhq65,ranger99,monkey7,shifter,wolves1,4r5t6y,phone1,favorite5,skytommy,abracada,1martin,102030405060,gatech,giulio,blacktop,cheer1,africa1,grizzly1,inkjet,shemales,durango1,booner,11223344q,supergirl,vanyarespekt,dickless,srilanka,weaponx,6string,nashvill,spicey,boxer1,fabien,2sexy2ho,bowhunt,jerrylee,acrobat,tawnee,ulisse,nolimit8,l8g3bkde,pershing,gordo1,allover,gobrowns,123432,123444,321456987,spoon1,hhhhh1,sailing1,gardenia,teache,sexmachine,tratata,pirate1,niceone,jimbos,314159265,qsdfgh,bobbyy,ccccc1,carla1,vjkjltw,savana,biotech,frigid,123456789g,dragon10,yesiam,alpha06,oakwood,tooter,winsto,radioman,vavilon,asnaeb,google123,nariman,kellyb,dthyjcnm,password6,parol1,golf72,skate1,lthtdj,1234567890s,kennet,rossia,lindas,nataliya,perfecto,eminem1,kitana,aragorn1,rexona,arsenalf,planot,coope,testing123,timex,blackbox,bullhead,barbarian,dreamon,polaris1,cfvjktn,frdfhbev,gametime,slipknot666,nomad1,hfgcjlbz,happy69,fiddler,brazil1,joeboy,indianali,113355,obelisk,telemark,ghostrid,preston1,anonim,wellcome,verizon1,sayangku,censor,timeport,dummies,adult1,nbnfybr,donger,thales,iamgay,sexy1234,deadlift,pidaras,doroga,123qwe321,portuga,asdfgh12,happys,cadr14nu,pi3141,maksik,dribble,cortland,darken,stepanova,bommel,tropic,sochi2014,bluegras,shahid,merhaba,nacho,2580456,orange44,kongen,3cudjz,78girl,my3kids,marcopol,deadmeat,gabbie,saruman,jeepman,freddie1,katie123,master99,ronal,ballbag,centauri,killer7,xqgann,pinecone,jdeere,geirby,aceshigh,55832811,pepsimax,rayden,razor1,tallyho,ewelina,coldfire,florid,glotest,999333,sevenup,bluefin,limaperu,apostol,bobbins,charmed1,michelin,sundin,centaur,alphaone,christof,trial1,lions1,45645,just4you,starflee,vicki1,cougar1,green2,jellyfis,batman69,games1,hihje863,crazyzil,w0rm1,oklick,dogbite,yssup,sunstar,paprika,postov10,124578963,x24ik3,kanada,buckster,iloveamy,bear123,smiler,nx74205,ohiostat,spacey,bigbill,doudo,nikolaeva,hcleeb,sex666,mindy1,buster11,deacons,boness,njkcnsq,candy2,cracker1,turkey1,qwertyu1,gogreen,tazzzz,edgewise,ranger01,qwerty6,blazer1,arian,letmeinnow,cigar1,jjjjjj1,grigio,frien,tenchu,f9lmwd,imissyou,filipp,heathers,coolie,salem1,woodduck,scubadiv,123kat,raffaele,nikolaev,dapzu455,skooter,9inches,lthgfhjkm,gr8one,ffffff1,zujlrf,amanda69,gldmeo,m5wkqf,rfrltkf,televisi,bonjou,paleale,stuff1,cumalot,fuckmenow,climb7,mark1234,t26gn4,oneeye,george2,utyyflbq,hunting1,tracy71,ready2go,hotguy,accessno,charger1,rudedog,kmfdm,goober1,sweetie1,wtpmjgda,dimensio,ollie1,pickles1,hellraiser,mustdie,123zzz,99887766,stepanov,verdun,tokenbad,anatol,bartende,cidkid86,onkelz,timmie,mooseman,patch1,12345678c,marta1,dummy1,bethany1,myfamily,history1,178500,lsutiger,phydeaux,moren,dbrnjhjdbx,gnbxrf,uniden,drummers,abpbrf,godboy,daisy123,hogan1,ratpack,irland,tangerine,greddy,flore,sqrunch,billyjoe,q55555,clemson1,98745632,marios,ishot,angelin,access12,naruto12,lolly,scxakv,austin12,sallad,cool99,rockit,mongo1,mark22,ghbynth,ariadna,senha,docto,tyler2,mobius,hammarby,192168,anna12,claire1,pxx3eftp,secreto,greeneye,stjabn,baguvix,satana666,rhbcnbyjxrf,dallastx,garfiel,michaelj,1summer,montan,1234ab,filbert,squids,fastback,lyudmila,chucho,eagleone,kimberle,ar3yuk3,jake01,nokids,soccer22,1066ad,ballon,cheeto,review69,madeira,taylor2,sunny123,chubbs,lakeland,striker1,porche,qwertyu8,digiview,go1234,ferari,lovetits,aditya,minnow,green3,matman,cellphon,fortytwo,minni,pucara,69a20a,roman123,fuente,12e3e456,paul12,jacky,demian,littleman,jadakiss,vlad1997,franca,282860,midian,nunzio,xaccess2,colibri,jessica0,revilo,654456,harvey1,wolf1,macarena,corey1,husky1,arsen,milleniu,852147,crowes,redcat,combat123654,hugger,psalms,quixtar,ilovemom,toyot,ballss,ilovekim,serdar,james23,avenger1,serendip,malamute,nalgas,teflon,shagger,letmein6,vyjujnjxbt,assa1234,student1,dixiedog,gznybwf13,fuckass,aq1sw2de3,robroy,hosehead,sosa21,123345,ias100,teddy123,poppin,dgl70460,zanoza,farhan,quicksilver,1701d,tajmahal,depechemode,paulchen,angler,tommy2,recoil,megamanx,scarecro,nicole2,152535,rfvtgb,skunky,fatty1,saturno,wormwood,milwauke,udbwsk,sexlover,stefa,7bgiqk,gfnhbr,omar10,bratan,lbyfvj,slyfox,forest1,jambo,william3,tempus,solitari,lucydog,murzilka,qweasdzxc1,vehpbkrf,12312345,fixit,woobie,andre123,123456789x,lifter,zinaida,soccer17,andone,foxbat,torsten,apple12,teleport,123456i,leglover,bigcocks,vologda,dodger1,martyn,d6o8pm,naciona,eagleeye,maria6,rimshot,bentley1,octagon,barbos,masaki,gremio,siemen,s1107d,mujeres,bigtits1,cherr,saints1,mrpink,simran,ghzybr,ferrari2,secret12,tornado1,kocham,picolo,deneme,onelove1,rolan,fenster,1fuckyou,cabbie,pegaso,nastyboy,password5,aidana,mine2306,mike13,wetone,tigger69,ytreza,bondage1,myass,golova,tolik,happyboy,poilkj,nimda2k,rammer,rubies,hardcore1,jetset,hoops1,jlaudio,misskitt,1charlie,google12,theone1,phred,porsch,aalborg,luft4,charlie5,password7,gnosis,djgabbab,1daniel,vinny,borris,cumulus,member1,trogdor,darthmau,andrew2,ktjybl,relisys,kriste,rasta220,chgobndg,weener,qwerty66,fritter,followme,freeman1,ballen,blood1,peache,mariso,trevor1,biotch,gtfullam,chamonix,friendste,alligato,misha1,1soccer,18821221,venkat,superd,molotov,bongos,mpower,acun3t1x,dfcmrf,h4x3d,rfhfufylf,tigran,booyaa,plastic1,monstr,rfnhby,lookatme,anabolic,tiesto,simon123,soulman,canes1,skyking,tomcat1,madona,bassline,dasha123,tarheel1,dutch1,xsw23edc,qwerty123456789,imperator,slaveboy,bateau,paypal,house123,pentax,wolf666,drgonzo,perros,digger1,juninho,hellomoto,bladerun,zzzzzzz1,keebler,take8422,fffffff1,ginuwine,israe,caesar1,crack1,precious1,garand,magda1,zigazaga,321ewq,johnpaul,mama1234,iceman69,sanjeev,treeman,elric,rebell,1thunder,cochon,deamon,zoltan,straycat,uhbyuj,luvfur,mugsy,primer,wonder1,teetime,candycan,pfchfytw,fromage,gitler,salvatio,piggy1,23049307,zafira,chicky,sergeev,katze,bangers,andriy,jailbait,vaz2107,ghbhjlf,dbjktnnf,aqswde,zaratustra,asroma,1pepper,alyss,kkkkk1,ryan1,radish,cozumel,waterpol,pentium1,rosebowl,farmall,steinway,dbrekz,baranov,jkmuf,another1,chinacat,qqqqqqq1,hadrian,devilmaycry4,ratbag,teddy2,love21,pullings,packrat,robyn1,boobo,qw12er34,tribe1,rosey,celestia,nikkie,fortune12,olga123,danthema,gameon,vfrfhjys,dilshod,henry14,jenova,redblue,chimaera,pennywise,sokrates,danimal,qqaazz,fuaqz4,killer2,198200,tbone1,kolyan,wabbit,lewis1,maxtor,egoist,asdfas,spyglass,omegas,jack12,nikitka,esperanz,doozer,matematika,wwwww1,ssssss1,poiu0987,suchka,courtney1,gungho,alpha2,fktyjxrf,summer06,bud420,devildriver,heavyd,saracen,foucault,choclate,rjdfktyrj,goblue1,monaro,jmoney,dcpugh,efbcapa201,qqh92r,pepsicol,bbb747,ch5nmk,honeyb,beszoptad,tweeter,intheass,iseedeadpeople,123dan,89231243658s,farside1,findme,smiley1,55556666,sartre,ytcnjh,kacper,costarica,134679258,mikeys,nolimit9,vova123,withyou,5rxypn,love143,freebie,rescue1,203040,michael6,12monkey,redgreen,steff,itstime,naveen,good12345,acidrain,1dawg,miramar,playas,daddio,orion2,852741,studmuff,kobe24,senha123,stephe,mehmet,allalone,scarface1,helloworld,smith123,blueyes,vitali,memphis1,mybitch,colin1,159874,1dick,podaria,d6wnro,brahms,f3gh65,dfcbkmtd,xxxman,corran,ugejvp,qcfmtz,marusia,totem,arachnid,matrix2,antonell,fgntrf,zemfira,christos,surfing1,naruto123,plato1,56qhxs,madzia,vanille,043aaa,asq321,mutton,ohiostate,golde,cdznjckfd,rhfcysq,green5,elephan,superdog,jacqueli,bollock,lolitas,nick12,1orange,maplelea,july23,argento,waldorf,wolfer,pokemon12,zxcvbnmm,flicka,drexel,outlawz,harrie,atrain,juice2,falcons1,charlie6,19391945,tower1,dragon21,hotdamn,dirtyboy,love4ever,1ginger,thunder2,virgo1,alien1,bubblegu,4wwvte,123456789qqq,realtime,studio54,passss,vasilek,awsome,giorgia,bigbass,2002tii,sunghile,mosdef,simbas,count0,uwrl7c,summer05,lhepmz,ranger21,sugarbea,principe,5550123,tatanka,9638v,cheerios,majere,nomercy,jamesbond007,bh90210,7550055,jobber,karaganda,pongo,trickle,defamer,6chid8,1q2a3z,tuscan,nick123,.adgjm,loveyo,hobbes1,note1234,shootme,171819,loveporn,9788960,monty123,fabrice,macduff,monkey13,shadowfa,tweeker,hanna1,madball,telnet,loveu2,qwedcxzas,thatsit,vfhcbr,ptfe3xxp,gblfhfcs,ddddddd1,hakkinen,liverune,deathsta,misty123,suka123,recon1,inferno1,232629,polecat,sanibel,grouch,hitech,hamradio,rkfdbfnehf,vandam,nadin,fastlane,shlong,iddqdidkfa,ledzeppelin,sexyfeet,098123,stacey1,negras,roofing,lucifer1,ikarus,tgbyhn,melnik,barbaria,montego,twisted1,bigal1,jiggle,darkwolf,acerview,silvio,treetops,bishop1,iwanna,pornsite,happyme,gfccdjhl,114411,veritech,batterse,casey123,yhntgb,mailto,milli,guster,q12345678,coronet,sleuth,fuckmeha,armadill,kroshka,geordie,lastochka,pynchon,killall,tommy123,sasha1996,godslove,hikaru,clticic,cornbrea,vfkmdbyf,passmaster,123123123a,souris,nailer,diabolo,skipjack,martin12,hinata,mof6681,brookie,dogfight,johnso,karpov,326598,rfvbrflpt,travesti,caballer,galaxy1,wotan,antoha,art123,xakep1234,ricflair,pervert1,p00kie,ambulanc,santosh,berserker,larry33,bitch123,a987654321,dogstar,angel22,cjcbcrf,redhouse,toodles,gold123,hotspot,kennedy1,glock21,chosen1,schneide,mainman,taffy1,3ki42x,4zqauf,ranger2,4meonly,year2000,121212a,kfylsi,netzwerk,diese,picasso1,rerecz,225522,dastan,swimmer1,brooke1,blackbea,oneway,ruslana,dont4get,phidelt,chrisp,gjyxbr,xwing,kickme,shimmy,kimmy1,4815162342lost,qwerty5,fcporto,jazzbo,mierd,252627,basses,sr20det,00133,florin,howdy1,kryten,goshen,koufax,cichlid,imhotep,andyman,wrest666,saveme,dutchy,anonymou,semprini,siempre,mocha1,forest11,wildroid,aspen1,sesam,kfgekz,cbhbec,a55555,sigmanu,slash1,giggs11,vatech,marias,candy123,jericho1,kingme,123a123,drakula,cdjkjxm,mercur,oneman,hoseman,plumper,ilovehim,lancers,sergey1,takeshi,goodtogo,cranberr,ghjcnj123,harvick,qazxs,1972chev,horsesho,freedom3,letmein7,saitek,anguss,vfvfgfgfz,300000,elektro,toonporn,999111999q,mamuka,q9umoz,edelweis,subwoofer,bayside,disturbe,volition,lucky3,12345678z,3mpz4r,march1,atlantida,strekoza,seagrams,090909t,yy5rbfsc,jack1234,sammy12,sampras,mark12,eintrach,chaucer,lllll1,nochance,whitepower,197000,lbvekz,passer,torana,12345as,pallas,koolio,12qw34,nokia8800,findout,1thomas,mmmmm1,654987,mihaela,chinaman,superduper,donnas,ringo1,jeroen,gfdkjdf,professo,cdtnrf,tranmere,tanstaaf,himera,ukflbfnjh,667788,alex32,joschi,w123456,okidoki,flatline,papercli,super8,doris1,2good4u,4z34l0ts,pedigree,freeride,gsxr1100,wulfgar,benjie,ferdinan,king1,charlie7,djdxbr,fhntvbq,ripcurl,2wsx1qaz,kingsx,desade,sn00py,loveboat,rottie,evgesha,4money,dolittle,adgjmpt,buzzers,brett1,makita,123123qweqwe,rusalka,sluts1,123456e,jameson1,bigbaby,1z2z3z,ckjybr,love4u,fucker69,erhfbyf,jeanluc,farhad,fishfood,merkin,giant1,golf69,rfnfcnhjaf,camera1,stromb,smoothy,774411,nylon,juice1,rfn.irf,newyor,123456789t,marmot,star11,jennyff,jester1,hisashi,kumquat,alex777,helicopt,merkur,dehpye,cummin,zsmj2v,kristjan,april12,englan,honeypot,badgirls,uzumaki,keines,p12345,guita,quake1,duncan1,juicer,milkbone,hurtme,123456789b,qq123456789,schwein,p3wqaw,54132442,qwertyytrewq,andreeva,ruffryde,punkie,abfkrf,kristinka,anna1987,ooooo1,335533aa,umberto,amber123,456123789,456789123,beelch,manta,peeker,1112131415,3141592654,gipper,wrinkle5,katies,asd123456,james11,78n3s5af,michael0,daboss,jimmyb,hotdog1,david69,852123,blazed,sickan,eljefe,2n6wvq,gobills,rfhfcm,squeaker,cabowabo,luebri,karups,test01,melkor,angel777,smallvil,modano,olorin,4rkpkt,leslie1,koffie,shadows1,littleon,amiga1,topeka,summer20,asterix1,pitstop,aloysius,k12345,magazin,joker69,panocha,pass1word,1233214,ironpony,368ejhih,88keys,pizza123,sonali,57np39,quake2,1234567890qw,1020304,sword1,fynjif,abcde123,dfktyjr,rockys,grendel1,harley12,kokakola,super2,azathoth,lisa123,shelley1,girlss,ibragim,seven1,jeff24,1bigdick,dragan,autobot,t4nvp7,omega123,900000,hecnfv,889988,nitro1,doggie1,fatjoe,811pahc,tommyt,savage1,pallino,smitty1,jg3h4hfn,jamielee,1qazwsx,zx123456,machine1,asdfgh123,guinnes,789520,sharkman,jochen,legend1,sonic2,extreme1,dima12,photoman,123459876,nokian95,775533,vaz2109,april10,becks,repmvf,pooker,qwer12345,themaster,nabeel,monkey10,gogetit,hockey99,bbbbbbb1,zinedine,dolphin2,anelka,1superma,winter01,muggsy,horny2,669966,kuleshov,jesusis,calavera,bullet1,87t5hdf,sleepers,winkie,vespa,lightsab,carine,magister,1spider,shitbird,salavat,becca1,wc18c2,shirak,galactus,zaskar,barkley1,reshma,dogbreat,fullsail,asasa,boeder,12345ta,zxcvbnm12,lepton,elfquest,tony123,vkaxcs,savatage,sevilia1,badkitty,munkey,pebbles1,diciembr,qapmoc,gabriel2,1qa2ws3e,cbcmrb,welldone,nfyufh,kaizen,jack11,manisha,grommit,g12345,maverik,chessman,heythere,mixail,jjjjjjj1,sylvia1,fairmont,harve,skully,global1,youwish,pikachu1,badcat,zombie1,49527843,ultra1,redrider,offsprin,lovebird,153426,stymie,aq1sw2,sorrento,0000001,r3ady41t,webster1,95175,adam123,coonass,159487,slut1,gerasim,monkey99,slutwife,159963,1pass1page,hobiecat,bigtymer,all4you,maggie2,olamide,comcast1,infinit,bailee,vasileva,.ktxrf,asdfghjkl1,12345678912,setter,fuckyou7,nnagqx,lifesuck,draken,austi,feb2000,cable1,1234qwerasdf,hax0red,zxcv12,vlad7788,nosaj,lenovo,underpar,huskies1,lovegirl,feynman,suerte,babaloo,alskdjfhg,oldsmobi,bomber1,redrover,pupuce,methodman,phenom,cutegirl,countyli,gretsch,godisgood,bysunsu,hardhat,mironova,123qwe456rty,rusty123,salut,187211,555666777,11111z,mahesh,rjntyjxtr,br00klyn,dunce1,timebomb,bovine,makelove,littlee,shaven,rizwan,patrick7,42042042,bobbijo,rustem,buttmunc,dongle,tiger69,bluecat,blackhol,shirin,peaces,cherub,cubase,longwood,lotus7,gwju3g,bruin,pzaiu8,green11,uyxnyd,seventee,dragon5,tinkerbel,bluess,bomba,fedorova,joshua2,bodyshop,peluche,gbpacker,shelly1,d1i2m3a4,ghtpbltyn,talons,sergeevna,misato,chrisc,sexmeup,brend,olddog,davros,hazelnut,bridget1,hzze929b,readme,brethart,wild1,ghbdtnbr1,nortel,kinger,royal1,bucky1,allah1,drakkar,emyeuanh,gallaghe,hardtime,jocker,tanman,flavio,abcdef123,leviatha,squid1,skeet,sexse,123456x,mom4u4mm,lilred,djljktq,ocean11,cadaver,baxter1,808state,fighton,primavera,1andrew,moogle,limabean,goddess1,vitalya,blue56,258025,bullride,cicci,1234567d,connor1,gsxr11,oliveoil,leonard1,legsex,gavrik,rjnjgtc,mexicano,2bad4u,goodfellas,ornw6d,mancheste,hawkmoon,zlzfrh,schorsch,g9zns4,bashful,rossi46,stephie,rfhfntkm,sellout,123fuck,stewar1,solnze,00007,thor5200,compaq12,didit,bigdeal,hjlbyf,zebulon,wpf8eu,kamran,emanuele,197500,carvin,ozlq6qwm,3syqo15hil,pennys,epvjb6,asdfghjkl123,198000,nfbcbz,jazzer,asfnhg66,zoloft,albundy,aeiou,getlaid,planet1,gjkbyjxrf,alex2000,brianb,moveon,maggie11,eieio,vcradq,shaggy1,novartis,cocoloco,dunamis,554uzpad,sundrop,1qwertyu,alfie,feliks,briand,123www,red456,addams,fhntv1998,goodhead,theway,javaman,angel01,stratoca,lonsdale,15987532,bigpimpin,skater1,issue43,muffie,yasmina,slowride,crm114,sanity729,himmel,carolcox,bustanut,parabola,masterlo,computador,crackhea,dynastar,rockbott,doggysty,wantsome,bigten,gaelle,juicy1,alaska1,etower,sixnine,suntan,froggies,nokia7610,hunter11,njnets,alicante,buttons1,diosesamo,elizabeth1,chiron,trustnoo,amatuers,tinytim,mechta,sammy2,cthulu,trs8f7,poonam,m6cjy69u35,cookie12,blue25,jordans,santa1,kalinka,mikey123,lebedeva,12345689,kissss,queenbee,vjybnjh,ghostdog,cuckold,bearshare,rjcntyrj,alinochka,ghjcnjrdfibyj,aggie1,teens1,3qvqod,dauren,tonino,hpk2qc,iqzzt580,bears85,nascar88,theboy,njqcw4,masyanya,pn5jvw,intranet,lollone,shadow99,00096462,techie,cvtifhbrb,redeemed,gocanes,62717315,topman,intj3a,cobrajet,antivirus,whyme,berserke,ikilz083,airedale,brandon2,hopkig,johanna1,danil8098,gojira,arthu,vision1,pendragon,milen,chrissie,vampiro,mudder,chris22,blowme69,omega7,surfers,goterps,italy1,baseba11,diego1,gnatsum,birdies,semenov,joker123,zenit2011,wojtek,cab4ma99,watchmen,damia,forgotte,fdm7ed,strummer,freelanc,cingular,orange77,mcdonalds,vjhjpjdf,kariya,tombston,starlet,hawaii1,dantheman,megabyte,nbvjirf,anjing,ybrjkftdbx,hotmom,kazbek,pacific1,sashimi,asd12,coorslig,yvtte545,kitte,elysium,klimenko,cobblers,kamehameha,only4me,redriver,triforce,sidorov,vittoria,fredi,dank420,m1234567,fallout2,989244342a,crazy123,crapola,servus,volvos,1scooter,griffin1,autopass,ownzyou,deviant,george01,2kgwai,boeing74,simhrq,hermosa,hardcor,griffy,rolex1,hackme,cuddles1,master3,bujhtr,aaron123,popolo,blader,1sexyred,gerry1,cronos,ffvdj474,yeehaw,bob1234,carlos2,mike77,buckwheat,ramesh,acls2h,monster2,montess,11qq22ww,lazer,zx123456789,chimpy,masterch,sargon,lochness,archana,1234qwert,hbxfhl,sarahb,altoid,zxcvbn12,dakot,caterham,dolomite,chazz,r29hqq,longone,pericles,grand1,sherbert,eagle3,pudge,irontree,synapse,boome,nogood,summer2,pooki,gangsta1,mahalkit,elenka,lbhtrnjh,dukedog,19922991,hopkins1,evgenia,domino1,x123456,manny1,tabbycat,drake1,jerico,drahcir,kelly2,708090a,facesit,11c645df,mac123,boodog,kalani,hiphop1,critters,hellothere,tbirds,valerka,551scasi,love777,paloalto,mrbrown,duke3d,killa1,arcturus,spider12,dizzy1,smudger,goddog,75395,spammy,1357997531,78678,datalife,zxcvbn123,1122112211,london22,23dp4x,rxmtkp,biggirls,ownsu,lzbs2twz,sharps,geryfe,237081a,golakers,nemesi,sasha1995,pretty1,mittens1,d1lakiss,speedrac,gfhjkmm,sabbat,hellrais,159753258,qwertyuiop123,playgirl,crippler,salma,strat1,celest,hello5,omega5,cheese12,ndeyl5,edward12,soccer3,cheerio,davido,vfrcbr,gjhjctyjr,boscoe,inessa,shithole,ibill,qwepoi,201jedlz,asdlkj,davidk,spawn2,ariel1,michael4,jamie123,romantik,micro1,pittsbur,canibus,katja,muhtar,thomas123,studboy,masahiro,rebrov,patrick8,hotboys,sarge1,1hammer,nnnnn1,eistee,datalore,jackdani,sasha2010,mwq6qlzo,cmfnpu,klausi,cnhjbntkm,andrzej,ilovejen,lindaa,hunter123,vvvvv1,novembe,hamster1,x35v8l,lacey1,1silver,iluvporn,valter,herson,alexsandr,cojones,backhoe,womens,777angel,beatit,klingon1,ta8g4w,luisito,benedikt,maxwel,inspecto,zaq12ws,wladimir,bobbyd,peterj,asdfg12,hellspawn,bitch69,nick1234,golfer23,sony123,jello1,killie,chubby1,kodaira52,yanochka,buckfast,morris1,roaddogg,snakeeye,sex1234,mike22,mmouse,fucker11,dantist,brittan,vfrfhjdf,doc123,plokijuh,emerald1,batman01,serafim,elementa,soccer9,footlong,cthuttdbx,hapkido,eagle123,getsmart,getiton,batman2,masons,mastiff,098890,cfvfhf,james7,azalea,sherif,saun24865709,123red,cnhtrjpf,martina1,pupper,michael5,alan12,shakir,devin1,ha8fyp,palom,mamulya,trippy,deerhunter,happyone,monkey77,3mta3,123456789f,crownvic,teodor,natusik,0137485,vovchik,strutter,triumph1,cvetok,moremone,sonnen,screwbal,akira1,sexnow,pernille,independ,poopies,samapi,kbcbxrf,master22,swetlana,urchin,viper2,magica,slurpee,postit,gilgames,kissarmy,clubpenguin,limpbizk,timber1,celin,lilkim,fuckhard,lonely1,mom123,goodwood,extasy,sdsadee23,foxglove,malibog,clark1,casey2,shell1,odense,balefire,dcunited,cubbie,pierr,solei,161718,bowling1,areyukesc,batboy,r123456,1pionee,marmelad,maynard1,cn42qj,cfvehfq,heathrow,qazxcvbn,connecti,secret123,newfie,xzsawq21,tubitzen,nikusha,enigma1,yfcnz123,1austin,michaelc,splunge,wanger,phantom2,jason2,pain4me,primetime21,babes1,liberte,sugarray,undergro,zonker,labatts,djhjyf,watch1,eagle5,madison2,cntgfirf,sasha2,masterca,fiction7,slick50,bruins1,sagitari,12481632,peniss,insuranc,2b8riedt,12346789,mrclean,ssptx452,tissot,q1w2e3r4t5y6u7,avatar1,comet1,spacer,vbrjkf,pass11,wanker1,14vbqk9p,noshit,money4me,sayana,fish1234,seaways,pipper,romeo123,karens,wardog,ab123456,gorilla1,andrey123,lifesucks,jamesr,4wcqjn,bearman,glock22,matt11,dflbvrf,barbi,maine1,dima1997,sunnyboy,6bjvpe,bangkok1,666666q,rafiki,letmein0,0raziel0,dalla,london99,wildthin,patrycja,skydog,qcactw,tmjxn151,yqlgr667,jimmyd,stripclub,deadwood,863abgsg,horses1,qn632o,scatman,sonia1,subrosa,woland,kolya,charlie4,moleman,j12345,summer11,angel11,blasen,sandal,mynewpas,retlaw,cambria,mustang4,nohack04,kimber45,fatdog,maiden1,bigload,necron,dupont24,ghost123,turbo2,.ktymrf,radagast,balzac,vsevolod,pankaj,argentum,2bigtits,mamabear,bumblebee,mercury7,maddie1,chomper,jq24nc,snooky,pussylic,1lovers,taltos,warchild,diablo66,jojo12,sumerki,aventura,gagger,annelies,drumset,cumshots,azimut,123580,clambake,bmw540,birthday54,psswrd,paganini,wildwest,filibert,teaseme,1test,scampi,thunder5,antosha,purple12,supersex,hhhhhh1,brujah,111222333a,13579a,bvgthfnjh,4506802a,killians,choco,qqqwwweee,raygun,1grand,koetsu13,sharp1,mimi92139,fastfood,idontcare,bluered,chochoz,4z3al0ts,target1,sheffiel,labrat,stalingrad,147123,cubfan,corvett1,holden1,snapper1,4071505,amadeo,pollo,desperados,lovestory,marcopolo,mumbles,familyguy,kimchee,marcio,support1,tekila,shygirl1,trekkie,submissi,ilaria,salam,loveu,wildstar,master69,sales1,netware,homer2,arseniy,gerrity1,raspberr,atreyu,stick1,aldric,tennis12,matahari,alohomora,dicanio,michae1,michaeld,666111,luvbug,boyscout,esmerald,mjordan,admiral1,steamboa,616913,ybhdfyf,557711,555999,sunray,apokalipsis,theroc,bmw330,buzzy,chicos,lenusik,shadowma,eagles05,444222,peartree,qqq123,sandmann,spring1,430799,phatass,andi03,binky1,arsch,bamba,kenny123,fabolous,loser123,poop12,maman,phobos,tecate,myxworld4,metros,cocorico,nokia6120,johnny69,hater,spanked,313233,markos,love2011,mozart1,viktoriy,reccos,331234,hornyone,vitesse,1um83z,55555q,proline,v12345,skaven,alizee,bimini,fenerbahce,543216,zaqqaz,poi123,stabilo,brownie1,1qwerty1,dinesh,baggins1,1234567t,davidkin,friend1,lietuva,octopuss,spooks,12345qq,myshit,buttface,paradoxx,pop123,golfin,sweet69,rfghbp,sambuca,kayak1,bogus1,girlz,dallas12,millers,123456zx,operatio,pravda,eternal1,chase123,moroni,proust,blueduck,harris1,redbarch,996699,1010101,mouche,millenni,1123456,score1,1234565,1234576,eae21157,dave12,pussyy,gfif1991,1598741,hoppy,darrian,snoogins,fartface,ichbins,vfkbyrf,rusrap,2741001,fyfrjylf,aprils,favre,thisis,bannana,serval,wiggum,satsuma,matt123,ivan123,gulmira,123zxc123,oscar2,acces,annie2,dragon0,emiliano,allthat,pajaro,amandine,rawiswar,sinead,tassie,karma1,piggys,nokias,orions,origami,type40,mondo,ferrets,monker,biteme2,gauntlet,arkham,ascona,ingram01,klem1,quicksil,bingo123,blue66,plazma,onfire,shortie,spjfet,123963,thered,fire777,lobito,vball,1chicken,moosehea,elefante,babe23,jesus12,parallax,elfstone,number5,shrooms,freya,hacker1,roxette,snoops,number7,fellini,dtlmvf,chigger,mission1,mitsubis,kannan,whitedog,james01,ghjgecr,rfnfgekmnf,everythi,getnaked,prettybo,sylvan,chiller,carrera4,cowbo,biochem,azbuka,qwertyuiop1,midnight1,informat,audio1,alfred1,0range,sucker1,scott2,russland,1eagle,torben,djkrjlfd,rocky6,maddy1,bonobo,portos,chrissi,xjznq5,dexte,vdlxuc,teardrop,pktmxr,iamtheone,danijela,eyphed,suzuki1,etvww4,redtail,ranger11,mowerman,asshole2,coolkid,adriana1,bootcamp,longcut,evets,npyxr5,bighurt,bassman1,stryder,giblet,nastja,blackadd,topflite,wizar,cumnow,technolo,bassboat,bullitt,kugm7b,maksimus,wankers,mine12,sunfish,pimpin1,shearer9,user1,vjzgjxnf,tycobb,80070633pc,stanly,vitaly,shirley1,cinzia,carolyn1,angeliqu,teamo,qdarcv,aa123321,ragdoll,bonit,ladyluck,wiggly,vitara,jetbalance,12345600,ozzman,dima12345,mybuddy,shilo,satan66,erebus,warrio,090808qwe,stupi,bigdan,paul1234,chiapet,brooks1,philly1,dually,gowest,farmer1,1qa2ws3ed4rf,alberto1,beachboy,barne,aa12345,aliyah,radman,benson1,dfkthbq,highball,bonou2,i81u812,workit,darter,redhook,csfbr5yy,buttlove,episode1,ewyuza,porthos,lalal,abcd12,papero,toosexy,keeper1,silver7,jujitsu,corset,pilot123,simonsay,pinggolf,katerinka,kender,drunk1,fylhjvtlf,rashmi,nighthawk,maggy,juggernaut,larryb,cabibble,fyabcf,247365,gangstar,jaybee,verycool,123456789qw,forbidde,prufrock,12345zxc,malaika,blackbur,docker,filipe,koshechka,gemma1,djamaal,dfcbkmtdf,gangst,9988aa,ducks1,pthrfkj,puertorico,muppets,griffins,whippet,sauber,timofey,larinso,123456789zxc,quicken,qsefth,liteon,headcase,bigdadd,zxc321,maniak,jamesc,bassmast,bigdogs,1girls,123xxx,trajan,lerochka,noggin,mtndew,04975756,domin,wer123,fumanchu,lambada,thankgod,june22,kayaking,patchy,summer10,timepass,poiu1234,kondor,kakka,lament,zidane10,686xqxfg,l8v53x,caveman1,nfvthkfy,holymoly,pepita,alex1996,mifune,fighter1,asslicker,jack22,abc123abc,zaxxon,midnigh,winni,psalm23,punky,monkey22,password13,mymusic,justyna,annushka,lucky5,briann,495rus19,withlove,almaz,supergir,miata,bingbong,bradpitt,kamasutr,yfgjktjy,vanman,pegleg,amsterdam1,123a321,letmein9,shivan,korona,bmw520,annette1,scotsman,gandal,welcome12,sc00by,qpwoei,fred69,m1sf1t,hamburg1,1access,dfkmrbhbz,excalibe,boobies1,fuckhole,karamel,starfuck,star99,breakfas,georgiy,ywvxpz,smasher,fatcat1,allanon,12345n,coondog,whacko,avalon1,scythe,saab93,timon,khorne,atlast,nemisis,brady12,blenheim,52678677,mick7278,9skw5g,fleetwoo,ruger1,kissass,pussy7,scruff,12345l,bigfun,vpmfsz,yxkck878,evgeny,55667788,lickher,foothill,alesis,poppies,77777778,californi,mannie,bartjek,qhxbij,thehulk,xirt2k,angelo4ek,rfkmrekznjh,tinhorse,1david,sparky12,night1,luojianhua,bobble,nederland,rosemari,travi,minou,ciscokid,beehive,565hlgqo,alpine1,samsung123,trainman,xpress,logistic,vw198m2n,hanter,zaqwsx123,qwasz,mariachi,paska,kmg365,kaulitz,sasha12,north1,polarbear,mighty1,makeksa11,123456781,one4all,gladston,notoriou,polniypizdec110211,gosia,grandad,xholes,timofei,invalidp,speaker1,zaharov,maggiema,loislane,gonoles,br5499,discgolf,kaskad,snooper,newman1,belial,demigod,vicky1,pridurok,alex1990,tardis1,cruzer,hornie,sacramen,babycat,burunduk,mark69,oakland1,me1234,gmctruck,extacy,sexdog,putang,poppen,billyd,1qaz2w,loveable,gimlet,azwebitalia,ragtop,198500,qweas,mirela,rock123,11bravo,sprewell,tigrenok,jaredleto,vfhbif,blue2,rimjob,catwalk,sigsauer,loqse,doromich,jack01,lasombra,jonny5,newpassword,profesor,garcia1,123as123,croucher,demeter,4_life,rfhfvtkm,superman2,rogues,assword1,russia1,jeff1,mydream,z123456789,rascal1,darre,kimberl,pickle1,ztmfcq,ponchik,lovesporn,hikari,gsgba368,pornoman,chbjun,choppy,diggity,nightwolf,viktori,camar,vfhecmrf,alisa1,minstrel,wishmaster,mulder1,aleks,gogirl,gracelan,8womys,highwind,solstice,dbrnjhjdyf,nightman,pimmel,beertje,ms6nud,wwfwcw,fx3tuo,poopface,asshat,dirtyd,jiminy,luv2fuck,ptybnxtvgbjy,dragnet,pornogra,10inch,scarlet1,guido1,raintree,v123456,1aaaaaaa,maxim1935,hotwater,gadzooks,playaz,harri,brando1,defcon1,ivanna,123654a,arsenal2,candela,nt5d27,jaime1,duke1,burton1,allstar1,dragos,newpoint,albacore,1236987z,verygoodbot,1wildcat,fishy1,ptktysq,chris11,puschel,itdxtyrj,7kbe9d,serpico,jazzie,1zzzzz,kindbuds,wenef45313,1compute,tatung,sardor,gfyfcjybr,test99,toucan,meteora,lysander,asscrack,jowgnx,hevnm4,suckthis,masha123,karinka,marit,oqglh565,dragon00,vvvbbb,cheburashka,vfrfrf,downlow,unforgiven,p3e85tr,kim123,sillyboy,gold1,golfvr6,quicksan,irochka,froglegs,shortsto,caleb1,tishka,bigtitts,smurfy,bosto,dropzone,nocode,jazzbass,digdug,green7,saltlake,therat,dmitriev,lunita,deaddog,summer0,1212qq,bobbyg,mty3rh,isaac1,gusher,helloman,sugarbear,corvair,extrem,teatime,tujazopi,titanik,efyreg,jo9k2jw2,counchac,tivoli,utjvtnhbz,bebit,jacob6,clayton1,incubus1,flash123,squirter,dima2010,cock1,rawks,komatsu,forty2,98741236,cajun1,madelein,mudhoney,magomed,q111111,qaswed,consense,12345b,bakayaro,silencer,zoinks,bigdic,werwolf,pinkpuss,96321478,alfie1,ali123,sarit,minette,musics,chato,iaapptfcor,cobaka,strumpf,datnigga,sonic123,yfnecbr,vjzctvmz,pasta1,tribbles,crasher,htlbcrf,1tiger,shock123,bearshar,syphon,a654321,cubbies1,jlhanes,eyespy,fucktheworld,carrie1,bmw325is,suzuk,mander,dorina,mithril,hondo1,vfhnbyb,sachem,newton1,12345x,7777755102q,230857z,xxxsex,scubapro,hayastan,spankit,delasoul,searock6,fallout3,nilrem,24681357,pashka,voluntee,pharoh,willo,india1,badboy69,roflmao,gunslinger,lovergir,mama12,melange,640xwfkv,chaton,darkknig,bigman1,aabbccdd,harleyd,birdhouse,giggsy,hiawatha,tiberium,joker7,hello1234,sloopy,tm371855,greendog,solar1,bignose,djohn11,espanol,oswego,iridium,kavitha,pavell,mirjam,cyjdsvujljv,alpha5,deluge,hamme,luntik,turismo,stasya,kjkbnf,caeser,schnecke,tweety1,tralfaz,lambrett,prodigy1,trstno1,pimpshit,werty1,karman,bigboob,pastel,blackmen,matthew8,moomin,q1w2e,gilly,primaver,jimmyg,house2,elviss,15975321,1jessica,monaliza,salt55,vfylfhbyrf,harley11,tickleme,murder1,nurgle,kickass1,theresa1,fordtruck,pargolf,managua,inkognito,sherry1,gotit,friedric,metro2033,slk230,freeport,cigarett,492529,vfhctkm,thebeach,twocats,bakugan,yzerman1,charlieb,motoko,skiman,1234567w,pussy3,love77,asenna,buffie,260zntpc,kinkos,access20,mallard1,fuckyou69,monami,rrrrr1,bigdog69,mikola,1boomer,godzila,ginger2,dima2000,skorpion39,dima1234,hawkdog79,warrior2,ltleirf,supra1,jerusale,monkey01,333z333,666888,kelsey1,w8gkz2x1,fdfnfh,msnxbi,qwe123rty,mach1,monkey3,123456789qq,c123456,nezabudka,barclays,nisse,dasha1,12345678987654321,dima1993,oldspice,frank2,rabbitt,prettyboy,ov3ajy,iamthema,kawasak,banjo1,gtivr6,collants,gondor,hibees,cowboys2,codfish,buster2,purzel,rubyred,kayaker,bikerboy,qguvyt,masher,sseexx,kenshiro,moonglow,semenova,rosari,eduard1,deltaforce,grouper,bongo1,tempgod,1taylor,goldsink,qazxsw1,1jesus,m69fg2w,maximili,marysia,husker1,kokanee,sideout,googl,south1,plumber1,trillian,00001,1357900,farkle,1xxxxx,pascha,emanuela,bagheera,hound1,mylov,newjersey,swampfox,sakic19,torey,geforce,wu4etd,conrail,pigman,martin2,ber02,nascar2,angel69,barty,kitsune,cornet,yes90125,goomba,daking,anthea,sivart,weather1,ndaswf,scoubidou,masterchief,rectum,3364068,oranges1,copter,1samanth,eddies,mimoza,ahfywbz,celtic88,86mets,applemac,amanda11,taliesin,1angel,imhere,london11,bandit12,killer666,beer1,06225930,psylocke,james69,schumach,24pnz6kc,endymion,wookie1,poiu123,birdland,smoochie,lastone,rclaki,olive1,pirat,thunder7,chris69,rocko,151617,djg4bb4b,lapper,ajcuivd289,colole57,shadow7,dallas21,ajtdmw,executiv,dickies,omegaman,jason12,newhaven,aaaaaas,pmdmscts,s456123789,beatri,applesauce,levelone,strapon,benladen,creaven,ttttt1,saab95,f123456,pitbul,54321a,sex12345,robert3,atilla,mevefalkcakk,1johnny,veedub,lilleke,nitsuj,5t6y7u8i,teddys,bluefox,nascar20,vwjetta,buffy123,playstation3,loverr,qweasd12,lover2,telekom,benjamin1,alemania,neutrino,rockz,valjean,testicle,trinity3,realty,firestarter,794613852,ardvark,guadalup,philmont,arnold1,holas,zw6syj,birthday299,dover1,sexxy1,gojets,741236985,cance,blue77,xzibit,qwerty88,komarova,qweszxc,footer,rainger,silverst,ghjcnb,catmando,tatooine,31217221027711,amalgam,69dude,qwerty321,roscoe1,74185,cubby,alfa147,perry1,darock,katmandu,darknight,knicks1,freestuff,45454,kidman,4tlved,axlrose,cutie1,quantum1,joseph10,ichigo,pentium3,rfhectkm,rowdy1,woodsink,justforfun,sveta123,pornografia,mrbean,bigpig,tujheirf,delta9,portsmou,hotbod,kartal,10111213,fkbyf001,pavel1,pistons1,necromancer,verga,c7lrwu,doober,thegame1,hatesyou,sexisfun,1melissa,tuczno18,bowhunte,gobama,scorch,campeon,bruce2,fudge1,herpderp,bacon1,redsky,blackeye,19966991,19992000,ripken8,masturba,34524815,primax,paulina1,vp6y38,427cobra,4dwvjj,dracon,fkg7h4f3v6,longview,arakis,panama1,honda2,lkjhgfdsaz,razors,steels,fqkw5m,dionysus,mariajos,soroka,enriqu,nissa,barolo,king1234,hshfd4n279,holland1,flyer1,tbones,343104ky,modems,tk421,ybrbnrf,pikapp,sureshot,wooddoor,florida2,mrbungle,vecmrf,catsdogs,axolotl,nowayout,francoi,chris21,toenail,hartland,asdjkl,nikkii,onlyyou,buckskin,fnord,flutie,holen1,rincewind,lefty1,ducky1,199000,fvthbrf,redskin1,ryno23,lostlove,19mtpgam19,abercrom,benhur,jordan11,roflcopter,ranma,phillesh,avondale,igromania,p4ssword,jenny123,tttttt1,spycams,cardigan,2112yyz,sleepy1,paris123,mopars,lakers34,hustler1,james99,matrix3,popimp,12pack,eggbert,medvedev,testit,performa,logitec,marija,sexybeast,supermanboy,iwantit,rjktcj,jeffer,svarog,halo123,whdbtp,nokia3230,heyjoe,marilyn1,speeder,ibxnsm,prostock,bennyboy,charmin,codydog,parol999,ford9402,jimmer,crayola,159357258,alex77,joey1,cayuga,phish420,poligon,specops,tarasova,caramelo,draconis,dimon,cyzkhw,june29,getbent,1guitar,jimjam,dictiona,shammy,flotsam,0okm9ijn,crapper,technic,fwsadn,rhfdxtyrj,zaq11qaz,anfield1,159753q,curious1,hip-hop,1iiiii,gfhjkm2,cocteau,liveevil,friskie,crackhead,b1afra,elektrik,lancer1,b0ll0cks,jasond,z1234567,tempest1,alakazam,asdfasd,duffy1,oneday,dinkle,qazedctgb,kasimir,happy7,salama,hondaciv,nadezda,andretti,cannondale,sparticu,znbvjd,blueice,money01,finster,eldar,moosie,pappa,delta123,neruda,bmw330ci,jeanpaul,malibu1,alevtina,sobeit,travolta,fullmetal,enamorad,mausi,boston12,greggy,smurf1,ratrace,ichiban,ilovepus,davidg,wolf69,villa1,cocopuff,football12,starfury,zxc12345,forfree,fairfiel,dreams1,tayson,mike2,dogday,hej123,oldtimer,sanpedro,clicker,mollycat,roadstar,golfe,lvbnhbq1,topdevice,a1b2c,sevastopol,calli,milosc,fire911,pink123,team3x,nolimit5,snickers1,annies,09877890,jewel1,steve69,justin11,autechre,killerbe,browncow,slava1,christer,fantomen,redcloud,elenberg,beautiful1,passw0rd1,nazira,advantag,cockring,chaka,rjpzdrf,99941,az123456,biohazar,energie,bubble1,bmw323,tellme,printer1,glavine,1starwar,coolbeans,april17,carly1,quagmire,admin2,djkujuhfl,pontoon,texmex,carlos12,thermo,vaz2106,nougat,bob666,1hockey,1john,cricke,qwerty10,twinz,totalwar,underwoo,tijger,lildevil,123q321,germania,freddd,1scott,beefy,5t4r3e2w1q,fishbait,nobby,hogger,dnstuff,jimmyc,redknapp,flame1,tinfloor,balla,nfnfhby,yukon1,vixens,batata,danny123,1zxcvbnm,gaetan,homewood,greats,tester1,green99,1fucker,sc0tland,starss,glori,arnhem,goatman,1234asd,supertra,bill123,elguapo,sexylegs,jackryan,usmc69,innow,roaddog,alukard,winter11,crawler,gogiants,rvd420,alessandr,homegrow,gobbler,esteba,valeriy,happy12,1joshua,hawking,sicnarf,waynes,iamhappy,bayadera,august2,sashas,gotti,dragonfire,pencil1,halogen,borisov,bassingw,15975346,zachar,sweetp,soccer99,sky123,flipyou,spots3,xakepy,cyclops1,dragon77,rattolo58,motorhea,piligrim,helloween,dmb2010,supermen,shad0w,eatcum,sandokan,pinga,ufkfrnbrf,roksana,amista,pusser,sony1234,azerty1,1qasw2,ghbdt,q1w2e3r4t5y6u7i8,ktutylf,brehznev,zaebali,shitass,creosote,gjrtvjy,14938685,naughtyboy,pedro123,21crack,maurice1,joesakic,nicolas1,matthew9,lbyfhf,elocin,hfcgbplzq,pepper123,tiktak,mycroft,ryan11,firefly1,arriva,cyecvevhbr,loreal,peedee,jessica8,lisa01,anamari,pionex,ipanema,airbag,frfltvbz,123456789aa,epwr49,casper12,sweethear,sanandreas,wuschel,cocodog,france1,119911,redroses,erevan,xtvgbjy,bigfella,geneve,volvo850,evermore,amy123,moxie,celebs,geeman,underwor,haslo1,joy123,hallow,chelsea0,12435687,abarth,12332145,tazman1,roshan,yummie,genius1,chrisd,ilovelife,seventy7,qaz1wsx2,rocket88,gaurav,bobbyboy,tauchen,roberts1,locksmit,masterof,www111,d9ungl,volvos40,asdasd1,golfers,jillian1,7xm5rq,arwpls4u,gbhcf2,elloco,football2,muerte,bob101,sabbath1,strider1,killer66,notyou,lawnboy,de7mdf,johnnyb,voodoo2,sashaa,homedepo,bravos,nihao123,braindea,weedhead,rajeev,artem1,camille1,rockss,bobbyb,aniston,frnhbcf,oakridge,biscayne,cxfcnm,dressage,jesus3,kellyann,king69,juillet,holliste,h00ters,ripoff,123645,1999ar,eric12,123777,tommi,dick12,bilder,chris99,rulezz,getpaid,chicubs,ender1,byajhvfnbrf,milkshak,sk8board,freakshow,antonella,monolit,shelb,hannah01,masters1,pitbull1,1matthew,luvpussy,agbdlcid,panther2,alphas,euskadi,8318131,ronnie1,7558795,sweetgirl,cookie59,sequoia,5552555,ktyxbr,4500455,money7,severus,shinobu,dbityrf,phisig,rogue2,fractal,redfred,sebastian1,nelli,b00mer,cyberman,zqjphsyf6ctifgu,oldsmobile,redeemer,pimpi,lovehurts,1slayer,black13,rtynfdh,airmax,g00gle,1panther,artemon,nopasswo,fuck1234,luke1,trinit,666000,ziadma,oscardog,davex,hazel1,isgood,demond,james5,construc,555551,january2,m1911a1,flameboy,merda,nathan12,nicklaus,dukester,hello99,scorpio7,leviathan,dfcbktr,pourquoi,vfrcbv123,shlomo,rfcgth,rocky3,ignatz,ajhneyf,roger123,squeek,4815162342a,biskit,mossimo,soccer21,gridlock,lunker,popstar,ghhh47hj764,chutney,nitehawk,vortec,gamma1,codeman,dragula,kappasig,rainbow2,milehigh,blueballs,ou8124me,rulesyou,collingw,mystere,aster,astrovan,firetruck,fische,crawfish,hornydog,morebeer,tigerpaw,radost,144000,1chance,1234567890qwe,gracie1,myopia,oxnard,seminoles,evgeni,edvard,partytim,domani,tuffy1,jaimatadi,blackmag,kzueirf,peternor,mathew1,maggie12,henrys,k1234567,fasted,pozitiv,cfdtkbq,jessica7,goleafs,bandito,girl78,sharingan,skyhigh,bigrob,zorros,poopers,oldschoo,pentium2,gripper,norcal,kimba,artiller,moneymak,00197400,272829,shadow1212,thebull,handbags,all4u2c,bigman2,civics,godisgoo,section8,bandaid,suzanne1,zorba,159123,racecars,i62gbq,rambo123,ironroad,johnson2,knobby,twinboys,sausage1,kelly69,enter2,rhjirf,yessss,james12,anguilla,boutit,iggypop,vovochka,06060,budwiser,romuald,meditate,good1,sandrin,herkules,lakers8,honeybea,11111111a,miche,rangers9,lobster1,seiko,belova,midcon,mackdadd,bigdaddy1,daddie,sepultur,freddy12,damon1,stormy1,hockey2,bailey12,hedimaptfcor,dcowboys,sadiedog,thuggin,horny123,josie1,nikki2,beaver69,peewee1,mateus,viktorija,barrys,cubswin1,matt1234,timoxa,rileydog,sicilia,luckycat,candybar,julian1,abc456,pussylip,phase1,acadia,catty,246800,evertonf,bojangle,qzwxec,nikolaj,fabrizi,kagome,noncapa0,marle,popol,hahaha1,cossie,carla10,diggers,spankey,sangeeta,cucciolo,breezer,starwar1,cornholio,rastafari,spring99,yyyyyyy1,webstar,72d5tn,sasha1234,inhouse,gobuffs,civic1,redstone,234523,minnie1,rivaldo,angel5,sti2000,xenocide,11qq11,1phoenix,herman1,holly123,tallguy,sharks1,madri,superbad,ronin,jalal123,hardbody,1234567r,assman1,vivahate,buddylee,38972091,bonds25,40028922,qrhmis,wp2005,ceejay,pepper01,51842543,redrum1,renton,varadero,tvxtjk7r,vetteman,djhvbrc,curly1,fruitcak,jessicas,maduro,popmart,acuari,dirkpitt,buick1,bergerac,golfcart,pdtpljxrf,hooch1,dudelove,d9ebk7,123452000,afdjhbn,greener,123455432,parachut,mookie12,123456780,jeepcj5,potatoe,sanya,qwerty2010,waqw3p,gotika,freaky1,chihuahu,buccanee,ecstacy,crazyboy,slickric,blue88,fktdnbyf,2004rj,delta4,333222111,calient,ptbdhw,1bailey,blitz1,sheila1,master23,hoagie,pyf8ah,orbita,daveyboy,prono1,delta2,heman,1horny,tyrik123,ostrov,md2020,herve,rockfish,el546218,rfhbyjxrf,chessmaster,redmoon,lenny1,215487,tomat,guppy,amekpass,amoeba,my3girls,nottingh,kavita,natalia1,puccini,fabiana,8letters,romeos,netgear,casper2,taters,gowings,iforgot1,pokesmot,pollit,lawrun,petey1,rosebuds,007jr,gthtcnhjqrf,k9dls02a,neener,azertyu,duke11,manyak,tiger01,petros,supermar,mangas,twisty,spotter,takagi,dlanod,qcmfd454,tusymo,zz123456,chach,navyblue,gilbert1,2kash6zq,avemaria,1hxboqg2s,viviane,lhbjkjubz2957704,nowwowtg,1a2b3c4,m0rn3,kqigb7,superpuper,juehtw,gethigh,theclown,makeme,pradeep,sergik,deion21,nurik,devo2706,nbvibt,roman222,kalima,nevaeh,martin7,anathema,florian1,tamwsn3sja,dinmamma,133159,123654q,slicks,pnp0c08,yojimbo,skipp,kiran,pussyfuck,teengirl,apples12,myballs,angeli,1234a,125678,opelastra,blind1,armagedd,fish123,pitufo,chelseaf,thedevil,nugget1,cunt69,beetle1,carter15,apolon,collant,password00,fishboy,djkrjdf,deftone,celti,three11,cyrus1,lefthand,skoal1,ferndale,aries1,fred01,roberta1,chucks,cornbread,lloyd1,icecrea,cisco123,newjerse,vfhrbpf,passio,volcom1,rikimaru,yeah11,djembe,facile,a1l2e3x4,batman7,nurbol,lorenzo1,monica69,blowjob1,998899,spank1,233391,n123456,1bear,bellsout,999998,celtic67,sabre1,putas,y9enkj,alfabeta,heatwave,honey123,hard4u,insane1,xthysq,magnum1,lightsaber,123qweqwe,fisher1,pixie1,precios,benfic,thegirls,bootsman,4321rewq,nabokov,hightime,djghjc,1chelsea,junglist,august16,t3fkvkmj,1232123,lsdlsd12,chuckie1,pescado,granit,toogood,cathouse,natedawg,bmw530,123kid,hajime,198400,engine1,wessonnn,kingdom1,novembre,1rocks,kingfisher,qwerty89,jordan22,zasranec,megat,sucess,installutil,fetish01,yanshi1982,1313666,1314520,clemence,wargod,time1,newzealand,snaker,13324124,cfrehf,hepcat,mazahaka,bigjay,denisov,eastwest,1yellow,mistydog,cheetos,1596357,ginger11,mavrik,bubby1,bhbyf,pyramide,giusepp,luthien,honda250,andrewjackie,kentavr,lampoon,zaq123wsx,sonicx,davidh,1ccccc,gorodok,windsong,programm,blunt420,vlad1995,zxcvfdsa,tarasov,mrskin,sachas,mercedes1,koteczek,rawdog,honeybear,stuart1,kaktys,richard7,55555n,azalia,hockey10,scouter,francy,1xxxxxx,julie456,tequilla,penis123,schmoe,tigerwoods,1ferrari,popov,snowdrop,matthieu,smolensk,cornflak,jordan01,love2000,23wesdxc,kswiss,anna2000,geniusnet,baby2000,33ds5x,waverly,onlyone4,networkingpe,raven123,blesse,gocards,wow123,pjflkork,juicey,poorboy,freeee,billybo,shaheen,zxcvbnm.,berlit,truth1,gepard,ludovic,gunther1,bobby2,bob12345,sunmoon,septembr,bigmac1,bcnjhbz,seaking,all4u,12qw34er56ty,bassie,nokia5228,7355608,sylwia,charvel,billgate,davion,chablis,catsmeow,kjiflrf,amylynn,rfvbkkf,mizredhe,handjob,jasper12,erbol,solara,bagpipe,biffer,notime,erlan,8543852,sugaree,oshkosh,fedora,bangbus,5lyedn,longball,teresa1,bootyman,aleksand,qazwsxedc12,nujbhc,tifosi,zpxvwy,lights1,slowpoke,tiger12,kstate,password10,alex69,collins1,9632147,doglover,baseball2,security1,grunts,orange2,godloves,213qwe879,julieb,1qazxsw23edcvfr4,noidea,8uiazp,betsy1,junior2,parol123,123456zz,piehonkii,kanker,bunky,hingis,reese1,qaz123456,sidewinder,tonedup,footsie,blackpoo,jalapeno,mummy1,always1,josh1,rockyboy,plucky,chicag,nadroj,blarney,blood123,wheaties,packer1,ravens1,mrjones,gfhjkm007,anna2010,awatar,guitar12,hashish,scale1,tomwaits,amrita,fantasma,rfpfym,pass2,tigris,bigair,slicker,sylvi,shilpa,cindylou,archie1,bitches1,poppys,ontime,horney1,camaroz28,alladin,bujhm,cq2kph,alina1,wvj5np,1211123a,tetons,scorelan,concordi,morgan2,awacs,shanty,tomcat14,andrew123,bear69,vitae,fred99,chingy,octane,belgario,fatdaddy,rhodan,password23,sexxes,boomtown,joshua01,war3demo,my2kids,buck1,hot4you,monamour,12345aa,yumiko,parool,carlton1,neverland,rose12,right1,sociald,grouse,brandon0,cat222,alex00,civicex,bintang,malkav,arschloc,dodgeviper,qwerty666,goduke,dante123,boss1,ontheroc,corpsman,love14,uiegu451,hardtail,irondoor,ghjrehfnehf,36460341,konijn,h2slca,kondom25,123456ss,cfytxrf,btnjey,nando,freemail,comander,natas666,siouxsie,hummer1,biomed,dimsum,yankees0,diablo666,lesbian1,pot420,jasonm,glock23,jennyb,itsmine,lena2010,whattheh,beandip,abaddon,kishore,signup,apogee,biteme12,suzieq,vgfun4,iseeyou,rifleman,qwerta,4pussy,hawkman,guest1,june17,dicksuck,bootay,cash12,bassale,ktybyuhfl,leetch,nescafe,7ovtgimc,clapton1,auror,boonie,tracker1,john69,bellas,cabinboy,yonkers,silky1,ladyffesta,drache,kamil1,davidp,bad123,snoopy12,sanche,werthvfy,achille,nefertiti,gerald1,slage33,warszawa,macsan26,mason123,kotopes,welcome8,nascar99,kiril,77778888,hairy1,monito,comicsans,81726354,killabee,arclight,yuo67,feelme,86753099,nnssnn,monday12,88351132,88889999,websters,subito,asdf12345,vaz2108,zvbxrpl,159753456852,rezeda,multimed,noaccess,henrique,tascam,captiva,zadrot,hateyou,sophie12,123123456,snoop1,charlie8,birmingh,hardline,libert,azsxdcf,89172735872,rjpthju,bondar,philips1,olegnaruto,myword,yakman,stardog,banana12,1234567890w,farout,annick,duke01,rfj422,billard,glock19,shaolin1,master10,cinderel,deltaone,manning1,biggreen,sidney1,patty1,goforit1,766rglqy,sevendus,aristotl,armagedo,blumen,gfhfyjz,kazakov,lekbyxxx,accord1,idiota,soccer16,texas123,victoire,ololo,chris01,bobbbb,299792458,eeeeeee1,confiden,07070,clarks,techno1,kayley,stang1,wwwwww1,uuuuu1,neverdie,jasonr,cavscout,481516234,mylove1,shaitan,1qazxcvb,barbaros,123456782000,123wer,thissucks,7seven,227722,faerie,hayduke,dbacks,snorkel,zmxncbv,tiger99,unknown1,melmac,polo1234,sssssss1,1fire,369147,bandung,bluejean,nivram,stanle,ctcnhf,soccer20,blingbli,dirtball,alex2112,183461,skylin,boobman,geronto,brittany1,yyz2112,gizmo69,ktrcec,dakota12,chiken,sexy11,vg08k714,bernadet,1bulldog,beachs,hollyb,maryjoy,margo1,danielle1,chakra,alexand,hullcity,matrix12,sarenna,pablos,antler,supercar,chomsky,german1,airjordan,545ettvy,camaron,flight1,netvideo,tootall,valheru,481516,1234as,skimmer,redcross,inuyash,uthvfy,1012nw,edoardo,bjhgfi,golf11,9379992a,lagarto,socball,boopie,krazy,.adgjmptw,gaydar,kovalev,geddylee,firstone,turbodog,loveee,135711,badbo,trapdoor,opopop11,danny2,max2000,526452,kerry1,leapfrog,daisy2,134kzbip,1andrea,playa1,peekab00,heskey,pirrello,gsewfmck,dimon4ik,puppie,chelios,554433,hypnodanny,fantik,yhwnqc,ghbdtngjrf,anchorag,buffett1,fanta,sappho,024680,vialli,chiva,lucylu,hashem,exbntkm,thema,23jordan,jake11,wildside,smartie,emerica,2wj2k9oj,ventrue,timoth,lamers,baerchen,suspende,boobis,denman85,1adam12,otello,king12,dzakuni,qsawbbs,isgay,porno123,jam123,daytona1,tazzie,bunny123,amaterasu,jeffre,crocus,mastercard,bitchedup,chicago7,aynrand,intel1,tamila,alianza,mulch,merlin12,rose123,alcapone,mircea,loveher,joseph12,chelsea6,dorothy1,wolfgar,unlimite,arturik,qwerty3,paddy1,piramid,linda123,cooool,millie1,warlock1,forgotit,tort02,ilikeyou,avensis,loveislife,dumbass1,clint1,2110se,drlove,olesia,kalinina,sergey123,123423,alicia1,markova,tri5a3,media1,willia1,xxxxxxx1,beercan,smk7366,jesusislord,motherfuck,smacker,birthday5,jbaby,harley2,hyper1,a9387670a,honey2,corvet,gjmptw,rjhjkmbien,apollon,madhuri,3a5irt,cessna17,saluki,digweed,tamia1,yja3vo,cfvlehfr,1111111q,martyna,stimpy1,anjana,yankeemp,jupiler,idkfa,1blue,fromv,afric,3xbobobo,liverp00l,nikon1,amadeus1,acer123,napoleo,david7,vbhjckfdf,mojo69,percy1,pirates1,grunt1,alenushka,finbar,zsxdcf,mandy123,1fred,timewarp,747bbb,druids,julia123,123321qq,spacebar,dreads,fcbarcelona,angela12,anima,christopher1,stargazer,123123s,hockey11,brewski,marlbor,blinker,motorhead,damngood,werthrf,letmein3,moremoney,killer99,anneke,eatit,pilatus,andrew01,fiona1,maitai,blucher,zxgdqn,e5pftu,nagual,panic1,andron,openwide,alphabeta,alison1,chelsea8,fende,mmm666,1shot2,a19l1980,123456@,1black,m1chael,vagner,realgood,maxxx,vekmnbr,stifler,2509mmh,tarkan,sherzod,1234567b,gunners1,artem2010,shooby,sammie1,p123456,piggie,abcde12345,nokia6230,moldir,piter,1qaz3edc,frequenc,acuransx,1star,nikeair,alex21,dapimp,ranjan,ilovegirls,anastasiy,berbatov,manso,21436587,leafs1,106666,angelochek,ingodwetrust,123456aaa,deano,korsar,pipetka,thunder9,minka,himura,installdevic,1qqqqq,digitalprodu,suckmeoff,plonker,headers,vlasov,ktr1996,windsor1,mishanya,garfield1,korvin,littlebit,azaz09,vandamme,scripto,s4114d,passward,britt1,r1chard,ferrari5,running1,7xswzaq,falcon2,pepper76,trademan,ea53g5,graham1,volvos80,reanimator,micasa,1234554321q,kairat,escorpion,sanek94,karolina1,kolovrat,karen2,1qaz@wsx,racing1,splooge,sarah2,deadman1,creed1,nooner,minicoop,oceane,room112,charme,12345ab,summer00,wetcunt,drewman,nastyman,redfire,appels,merlin69,dolfin,bornfree,diskette,ohwell,12345678qwe,jasont,madcap,cobra2,dolemit1,whatthehell,juanit,voldemar,rocke,bianc,elendil,vtufgjkbc,hotwheels,spanis,sukram,pokerface,k1ller,freakout,dontae,realmadri,drumss,gorams,258789,snakey,jasonn,whitewolf,befree,johnny99,pooka,theghost,kennys,vfvektxrf,toby1,jumpman23,deadlock,barbwire,stellina,alexa1,dalamar,mustanggt,northwes,tesoro,chameleo,sigtau,satoshi,george11,hotcum,cornell1,golfer12,geek01d,trololo,kellym,megapolis,pepsi2,hea666,monkfish,blue52,sarajane,bowler1,skeets,ddgirls,hfccbz,bailey01,isabella1,dreday,moose123,baobab,crushme,000009,veryhot,roadie,meanone,mike18,henriett,dohcvtec,moulin,gulnur,adastra,angel9,western1,natura,sweetpe,dtnfkm,marsbar,daisys,frogger1,virus1,redwood1,streetball,fridolin,d78unhxq,midas,michelob,cantik,sk2000,kikker,macanudo,rambone,fizzle,20000,peanuts1,cowpie,stone32,astaroth,dakota01,redso,mustard1,sexylove,giantess,teaparty,bobbin,beerbong,monet1,charles3,anniedog,anna1988,cameleon,longbeach,tamere,qpful542,mesquite,waldemar,12345zx,iamhere,lowboy,canard,granp,daisymay,love33,moosejaw,nivek,ninjaman,shrike01,aaa777,88002000600,vodolei,bambush,falcor,harley69,alphaomega,severine,grappler,bosox,twogirls,gatorman,vettes,buttmunch,chyna,excelsio,crayfish,birillo,megumi,lsia9dnb9y,littlebo,stevek,hiroyuki,firehous,master5,briley2,gangste,chrisk,camaleon,bulle,troyboy,froinlaven,mybutt,sandhya,rapala,jagged,crazycat,lucky12,jetman,wavmanuk,1heather,beegee,negril,mario123,funtime1,conehead,abigai,mhorgan,patagoni,travel1,backspace,frenchfr,mudcat,dashenka,baseball3,rustys,741852kk,dickme,baller23,griffey1,suckmycock,fuhrfzgc,jenny2,spuds,berlin1,justfun,icewind,bumerang,pavlusha,minecraft123,shasta1,ranger12,123400,twisters,buthead,miked,finance1,dignity7,hello9,lvjdp383,jgthfnjh,dalmatio,paparoach,miller31,2bornot2b,fathe,monterre,theblues,satans,schaap,jasmine2,sibelius,manon,heslo,jcnhjd,shane123,natasha2,pierrot,bluecar,iloveass,harriso,red12,london20,job314,beholder,reddawg,fuckyou!,pussylick,bologna1,austintx,ole4ka,blotto,onering,jearly,balbes,lightbul,bighorn,crossfir,lee123,prapor,1ashley,gfhjkm22,wwe123,09090,sexsite,marina123,jagua,witch1,schmoo,parkview,dragon3,chilango,ultimo,abramova,nautique,2bornot2,duende,1arthur,nightwing,surfboar,quant4307,15s9pu03,karina1,shitball,walleye1,wildman1,whytesha,1morgan,my2girls,polic,baranova,berezuckiy,kkkkkk1,forzima,fornow,qwerty02,gokart,suckit69,davidlee,whatnow,edgard,tits1,bayshore,36987412,ghbphfr,daddyy,explore1,zoidberg,5qnzjx,morgane,danilov,blacksex,mickey12,balsam,83y6pv,sarahc,slaye,all4u2,slayer69,nadia1,rlzwp503,4cranker,kaylie,numberon,teremok,wolf12,deeppurple,goodbeer,aaa555,66669999,whatif,harmony1,ue8fpw,3tmnej,254xtpss,dusty197,wcksdypk,zerkalo,dfnheirf,motorol,digita,whoareyou,darksoul,manics,rounders,killer11,d2000lb,cegthgfhjkm,catdog1,beograd,pepsico,julius1,123654987,softbal,killer23,weasel1,lifeson,q123456q,444555666,bunches,andy1,darby1,service01,bear11,jordan123,amega,duncan21,yensid,lerxst,rassvet,bronco2,fortis,pornlove,paiste,198900,asdflkjh,1236547890,futur,eugene1,winnipeg261,fk8bhydb,seanjohn,brimston,matthe1,bitchedu,crisco,302731,roxydog,woodlawn,volgograd,ace1210,boy4u2ownnyc,laura123,pronger,parker12,z123456z,andrew13,longlife,sarang,drogba,gobruins,soccer4,holida,espace,almira,murmansk,green22,safina,wm00022,1chevy,schlumpf,doroth,ulises,golf99,hellyes,detlef,mydog,erkina,bastardo,mashenka,sucram,wehttam,generic1,195000,spaceboy,lopas123,scammer,skynyrd,daddy2,titani,ficker,cr250r,kbnthfnehf,takedown,sticky1,davidruiz,desant,nremtp,painter1,bogies,agamemno,kansas1,smallfry,archi,2b4dnvsx,1player,saddie,peapod,6458zn7a,qvw6n2,gfxqx686,twice2,sh4d0w3d,mayfly,375125,phitau,yqmbevgk,89211375759,kumar1,pfhfpf,toyboy,way2go,7pvn4t,pass69,chipster,spoony,buddycat,diamond3,rincewin,hobie,david01,billbo,hxp4life,matild,pokemon2,dimochka,clown1,148888,jenmt3,cuxldv,cqnwhy,cde34rfv,simone1,verynice,toobig,pasha123,mike00,maria2,lolpop,firewire,dragon9,martesana,a1234567890,birthday3,providen,kiska,pitbulls,556655,misawa,damned69,martin11,goldorak,gunship,glory1,winxclub,sixgun,splodge,agent1,splitter,dome69,ifghjb,eliza1,snaiper,wutang36,phoenix7,666425,arshavin,paulaner,namron,m69fg1w,qwert1234,terrys,zesyrmvu,joeman,scoots,dwml9f,625vrobg,sally123,gostoso,symow8,pelota,c43qpul5rz,majinbuu,lithium1,bigstuff,horndog1,kipelov,kringle,1beavis,loshara,octobe,jmzacf,12342000,qw12qw,runescape1,chargers1,krokus,piknik,jessy,778811,gjvbljh,474jdvff,pleaser,misskitty,breaker1,7f4df451,dayan,twinky,yakumo,chippers,matia,tanith,len2ski1,manni,nichol1,f00b4r,nokia3110,standart,123456789i,shami,steffie,larrywn,chucker,john99,chamois,jjjkkk,penmouse,ktnj2010,gooners,hemmelig,rodney1,merlin01,bearcat1,1yyyyy,159753z,1fffff,1ddddd,thomas11,gjkbyrf,ivanka,f1f2f3,petrovna,phunky,conair,brian2,creative1,klipsch,vbitymrf,freek,breitlin,cecili,westwing,gohabsgo,tippmann,1steve,quattro6,fatbob,sp00ky,rastas,1123581,redsea,rfnmrf,jerky1,1aaaaaa,spk666,simba123,qwert54321,123abcd,beavis69,fyfyfc,starr1,1236547,peanutbutter,sintra,12345abcde,1357246,abcde1,climbon,755dfx,mermaids,monte1,serkan,geilesau,777win,jasonc,parkside,imagine1,rockhead,producti,playhard,principa,spammer,gagher,escada,tsv1860,dbyjuhfl,cruiser1,kennyg,montgome,2481632,pompano,cum123,angel6,sooty,bear01,april6,bodyhamm,pugsly,getrich,mikes,pelusa,fosgate,jasonp,rostislav,kimberly1,128mo,dallas11,gooner1,manuel1,cocacola1,imesh,5782790,password8,daboys,1jones,intheend,e3w2q1,whisper1,madone,pjcgujrat,1p2o3i,jamesp,felicida,nemrac,phikap,firecat,jrcfyjxrf,matt12,bigfan,doedel,005500,jasonx,1234567k,badfish,goosey,utjuhfabz,wilco,artem123,igor123,spike123,jor23dan,dga9la,v2jmsz,morgan12,avery1,dogstyle,natasa,221195ws,twopac,oktober7,karthik,poop1,mightymo,davidr,zermatt,jehova,aezakmi1,dimwit,monkey5,serega123,qwerty111,blabl,casey22,boy123,1clutch,asdfjkl1,hariom,bruce10,jeep95,1smith,sm9934,karishma,bazzzz,aristo,669e53e1,nesterov,kill666,fihdfv,1abc2,anna1,silver11,mojoman,telefono,goeagles,sd3lpgdr,rfhfynby,melinda1,llcoolj,idteul,bigchief,rocky13,timberwo,ballers,gatekeep,kashif,hardass,anastasija,max777,vfuyjkbz,riesling,agent99,kappas,dalglish,tincan,orange3,turtoise,abkbvjy,mike24,hugedick,alabala,geolog,aziza,devilboy,habanero,waheguru,funboy,freedom5,natwest,seashore,impaler,qwaszx1,pastas,bmw535,tecktonik,mika00,jobsearc,pinche,puntang,aw96b6,1corvett,skorpio,foundati,zzr1100,gembird,vfnhjcrby,soccer18,vaz2110,peterp,archer1,cross1,samedi,dima1992,hunter99,lipper,hotbody,zhjckfdf,ducati1,trailer1,04325956,cheryl1,benetton,kononenko,sloneczko,rfgtkmrf,nashua,balalaika,ampere,eliston,dorsai,digge,flyrod,oxymoron,minolta,ironmike,majortom,karimov,fortun,putaria,an83546921an13,blade123,franchis,mxaigtg5,dynxyu,devlt4,brasi,terces,wqmfuh,nqdgxz,dale88,minchia,seeyou,housepen,1apple,1buddy,mariusz,bighouse,tango2,flimflam,nicola1,qwertyasd,tomek1,shumaher,kartoshka,bassss,canaries,redman1,123456789as,preciosa,allblacks,navidad,tommaso,beaudog,forrest1,green23,ryjgjxrf,go4it,ironman2,badnews,butterba,1grizzly,isaeva,rembrand,toront,1richard,bigjon,yfltymrf,1kitty,4ng62t,littlejo,wolfdog,ctvtyjd,spain1,megryan,tatertot,raven69,4809594q,tapout,stuntman,a131313,lagers,hotstuf,lfdbl11,stanley2,advokat,boloto,7894561,dooker,adxel187,cleodog,4play,0p9o8i,masterb,bimota,charlee,toystory,6820055,6666667,crevette,6031769,corsa,bingoo,dima1990,tennis11,samuri,avocado,melissa6,unicor,habari,metart,needsex,cockman,hernan,3891576,3334444,amigo1,gobuffs2,mike21,allianz,2835493,179355,midgard,joey123,oneluv,ellis1,towncar,shonuff,scouse,tool69,thomas19,chorizo,jblaze,lisa1,dima1999,sophia1,anna1989,vfvekbxrf,krasavica,redlegs,jason25,tbontb,katrine,eumesmo,vfhufhbnrf,1654321,asdfghj1,motdepas,booga,doogle,1453145,byron1,158272,kardinal,tanne,fallen1,abcd12345,ufyljy,n12345,kucing,burberry,bodger,1234578,februar,1234512,nekkid,prober,harrison1,idlewild,rfnz90,foiegras,pussy21,bigstud,denzel,tiffany2,bigwill,1234567890zzz,hello69,compute1,viper9,hellspaw,trythis,gococks,dogballs,delfi,lupine,millenia,newdelhi,charlest,basspro,1mike,joeblack,975310,1rosebud,batman11,misterio,fucknut,charlie0,august11,juancho,ilonka,jigei743ks,adam1234,889900,goonie,alicat,ggggggg1,1zzzzzzz,sexywife,northstar,chris23,888111,containe,trojan1,jason5,graikos,1ggggg,1eeeee,tigers01,indigo1,hotmale,jacob123,mishima,richard3,cjxb2014,coco123,meagain,thaman,wallst,edgewood,bundas,1power,matilda1,maradon,hookedup,jemima,r3vi3wpass,2004-10-,mudman,taz123,xswzaq,emerson1,anna21,warlord1,toering,pelle,tgwdvu,masterb8,wallstre,moppel,priora,ghjcnjrdfif,yoland,12332100,1j9e7f6f,jazzzz,yesman,brianm,42qwerty42,12345698,darkmanx,nirmal,john31,bb123456,neuspeed,billgates,moguls,fj1200,hbhlair,shaun1,ghbdfn,305pwzlr,nbu3cd,susanb,pimpdad,mangust6403,joedog,dawidek,gigante,708090,703751,700007,ikalcr,tbivbn,697769,marvi,iyaayas,karen123,jimmyboy,dozer1,e6z8jh,bigtime1,getdown,kevin12,brookly,zjduc3,nolan1,cobber,yr8wdxcq,liebe,m1garand,blah123,616879,action1,600000,sumitomo,albcaz,asian1,557799,dave69,556699,sasa123,streaker,michel1,karate1,buddy7,daulet,koks888,roadtrip,wapiti,oldguy,illini1,1234qq,mrspock,kwiatek,buterfly,august31,jibxhq,jackin,taxicab,tristram,talisker,446655,444666,chrisa,freespace,vfhbfyyf,chevell,444333,notyours,442244,christian1,seemore,sniper12,marlin1,joker666,multik,devilish,crf450,cdfoli,eastern1,asshead,duhast,voyager2,cyberia,1wizard,cybernet,iloveme1,veterok,karandash,392781,looksee,diddy,diabolic,foofight,missey,herbert1,bmw318i,premier1,zsfmpv,eric1234,dun6sm,fuck11,345543,spudman,lurker,bitem,lizzy1,ironsink,minami,339311,s7fhs127,sterne,332233,plankton,galax,azuywe,changepa,august25,mouse123,sikici,killer69,xswqaz,quovadis,gnomik,033028pw,777777a,barrakuda,spawn666,goodgod,slurp,morbius,yelnats,cujo31,norman1,fastone,earwig,aureli,wordlife,bnfkbz,yasmi,austin123,timberla,missy2,legalize,netcom,liljon,takeit,georgin,987654321z,warbird,vitalina,all4u3,mmmmmm1,bichon,ellobo,wahoos,fcazmj,aksarben,lodoss,satnam,vasili,197800,maarten,sam138989,0u812,ankita,walte,prince12,anvils,bestia,hoschi,198300,univer,jack10,ktyecbr,gr00vy,hokie,wolfman1,fuckwit,geyser,emmanue,ybrjkftd,qwerty33,karat,dblock,avocat,bobbym,womersle,1please,nostra,dayana,billyray,alternat,iloveu1,qwerty69,rammstein1,mystikal,winne,drawde,executor,craxxxs,ghjcnjnf,999888777,welshman,access123,963214785,951753852,babe69,fvcnthlfv,****me,666999666,testing2,199200,nintendo64,oscarr,guido8,zhanna,gumshoe,jbird,159357456,pasca,123452345,satan6,mithrand,fhbirf,aa1111aa,viggen,ficktjuv,radial9,davids1,rainbow7,futuro,hipho,platin,poppy123,rhenjq,fulle,rosit,chicano,scrumpy,lumpy1,seifer,uvmrysez,autumn1,xenon,susie1,7u8i9o0p,gamer1,sirene,muffy1,monkeys1,kalinin,olcrackmaster,hotmove,uconn,gshock,merson,lthtdyz,pizzaboy,peggy1,pistache,pinto1,fishka,ladydi,pandor,baileys,hungwell,redboy,rookie1,amanda01,passwrd,clean1,matty1,tarkus,jabba1,bobster,beer30,solomon1,moneymon,sesamo,fred11,sunnysid,jasmine5,thebears,putamadre,workhard,flashbac,counter1,liefde,magnat,corky1,green6,abramov,lordik,univers,shortys,david3,vip123,gnarly,1234567s,billy2,honkey,deathstar,grimmy,govinda,direktor,12345678s,linus1,shoppin,rekbrjdf,santeria,prett,berty75,mohican,daftpunk,uekmyfhf,chupa,strats,ironbird,giants56,salisbur,koldun,summer04,pondscum,jimmyj,miata1,george3,redshoes,weezie,bartman1,0p9o8i7u,s1lver,dorkus,125478,omega9,sexisgood,mancow,patric1,jetta1,074401,ghjuhtcc,gfhjk,bibble,terry2,123213,medicin,rebel2,hen3ry,4freedom,aldrin,lovesyou,browny,renwod,winnie1,belladon,1house,tyghbn,blessme,rfhfrfnbwf,haylee,deepdive,booya,phantasy,gansta,cock69,4mnveh,gazza1,redapple,structur,anakin1,manolito,steve01,poolman,chloe123,vlad1998,qazwsxe,pushit,random123,ontherocks,o236nq,brain1,dimedrol,agape,rovnogod,1balls,knigh,alliso,love01,wolf01,flintstone,beernuts,tuffguy,isengard,highfive,alex23,casper99,rubina,getreal,chinita,italian1,airsoft,qwerty23,muffdiver,willi1,grace123,orioles1,redbull1,chino1,ziggy123,breadman,estefan,ljcneg,gotoit,logan123,wideglid,mancity1,treess,qwe123456,kazumi,qweasdqwe,oddworld,naveed,protos,towson,a801016,godislov,at_asp,bambam1,soccer5,dark123,67vette,carlos123,hoser1,scouser,wesdxc,pelus,dragon25,pflhjn,abdula,1freedom,policema,tarkin,eduardo1,mackdad,gfhjkm11,lfplhfgthvf,adilet,zzzzxxxx,childre,samarkand,cegthgegth,shama,fresher,silvestr,greaser,allout,plmokn,sexdrive,nintendo1,fantasy7,oleander,fe126fd,crumpet,pingzing,dionis,hipster,yfcnz,requin,calliope,jerome1,housecat,abc123456789,doghot,snake123,augus,brillig,chronic1,gfhjkbot,expediti,noisette,master7,caliban,whitetai,favorite3,lisamari,educatio,ghjhjr,saber1,zcegth,1958proman,vtkrbq,milkdud,imajica,thehip,bailey10,hockey19,dkflbdjcnjr,j123456,bernar,aeiouy,gamlet,deltachi,endzone,conni,bcgfybz,brandi1,auckland2010,7653ajl1,mardigra,testuser,bunko18,camaro67,36936,greenie,454dfmcq,6xe8j2z4,mrgreen,ranger5,headhunt,banshee1,moonunit,zyltrc,hello3,pussyboy,stoopid,tigger11,yellow12,drums1,blue02,kils123,junkman,banyan,jimmyjam,tbbucs,sportster,badass1,joshie,braves10,lajolla,1amanda,antani,78787,antero,19216801,chich,rhett32,sarahm,beloit,sucker69,corkey,nicosnn,rccola,caracol,daffyduc,bunny2,mantas,monkies,hedonist,cacapipi,ashton1,sid123,19899891,patche,greekgod,cbr1000,leader1,19977991,ettore,chongo,113311,picass,cfif123,rhtfnbd,frances1,andy12,minnette,bigboy12,green69,alices,babcia,partyboy,javabean,freehand,qawsed123,xxx111,harold1,passwo,jonny1,kappa1,w2dlww3v5p,1merlin,222999,tomjones,jakeman,franken,markhegarty,john01,carole1,daveman,caseys,apeman,mookey,moon123,claret,titans1,residentevil,campari,curitiba,dovetail,aerostar,jackdaniels,basenji,zaq12w,glencoe,biglove,goober12,ncc170,far7766,monkey21,eclipse9,1234567v,vanechka,aristote,grumble,belgorod,abhishek,neworleans,pazzword,dummie,sashadog,diablo11,mst3000,koala1,maureen1,jake99,isaiah1,funkster,gillian1,ekaterina20,chibears,astra123,4me2no,winte,skippe,necro,windows9,vinograd,demolay,vika2010,quiksilver,19371ayj,dollar1,shecky,qzwxecrv,butterfly1,merrill1,scoreland,1crazy,megastar,mandragora,track1,dedhed,jacob2,newhope,qawsedrftgyh,shack1,samvel,gatita,shyster,clara1,telstar,office1,crickett,truls,nirmala,joselito,chrisl,lesnik,aaaabbbb,austin01,leto2010,bubbie,aaa12345,widder,234432,salinger,mrsmith,qazsedcft,newshoes,skunks,yt1300,bmw316,arbeit,smoove,123321qweewq,123qazwsx,22221111,seesaw,0987654321a,peach1,1029384756q,sereda,gerrard8,shit123,batcave,energy1,peterb,mytruck,peter12,alesya,tomato1,spirou,laputaxx,magoo1,omgkremidia,knight12,norton1,vladislava,shaddy,austin11,jlbyjxrf,kbdthgekm,punheta,fetish69,exploiter,roger2,manstein,gtnhjd,32615948worms,dogbreath,ujkjdjkjvrf,vodka1,ripcord,fatrat,kotek1,tiziana,larrybir,thunder3,nbvfnb,9kyq6fge,remembe,likemike,gavin1,shinigam,yfcnfcmz,13245678,jabbar,vampyr,ane4ka,lollipo,ashwin,scuderia,limpdick,deagle,3247562,vishenka,fdhjhf,alex02,volvov70,mandys,bioshock,caraca,tombraider,matrix69,jeff123,13579135,parazit,black3,noway1,diablos,hitmen,garden1,aminor,decembe,august12,b00ger,006900,452073t,schach,hitman1,mariner1,vbnmrf,paint1,742617000027,bitchboy,pfqxjyjr,5681392,marryher,sinnet,malik1,muffin12,aninha,piolin,lady12,traffic1,cbvjyf,6345789,june21,ivan2010,ryan123,honda99,gunny,coorslight,asd321,hunter69,7224763,sonofgod,dolphins1,1dolphin,pavlenko,woodwind,lovelov,pinkpant,gblfhfcbyf,hotel1,justinbiebe,vinter,jeff1234,mydogs,1pizza,boats1,parrothe,shawshan,brooklyn1,cbrown,1rocky,hemi426,dragon64,redwings1,porsches,ghostly,hubbahub,buttnut,b929ezzh,sorokina,flashg,fritos,b7mguk,metatron,treehous,vorpal,8902792,marcu,free123,labamba,chiefs1,zxc123zxc,keli_14,hotti,1steeler,money4,rakker,foxwoods,free1,ahjkjd,sidorova,snowwhit,neptune1,mrlover,trader1,nudelamb,baloo,power7,deltasig,bills1,trevo,7gorwell,nokia6630,nokia5320,madhatte,1cowboys,manga1,namtab,sanjar,fanny1,birdman1,adv12775,carlo1,dude1998,babyhuey,nicole11,madmike,ubvyfpbz,qawsedr,lifetec,skyhook,stalker123,toolong,robertso,ripazha,zippy123,1111111a,manol,dirtyman,analslut,jason3,dutches,minhasenha,cerise,fenrir,jayjay1,flatbush,franka,bhbyjxrf,26429vadim,lawntrax,198700,fritzy,nikhil,ripper1,harami,truckman,nemvxyheqdd5oqxyxyzi,gkfytnf,bugaboo,cableman,hairpie,xplorer,movado,hotsex69,mordred,ohyeah1,patrick3,frolov,katieh,4311111q,mochaj,presari,bigdo,753951852,freedom4,kapitan,tomas1,135795,sweet123,pokers,shagme,tane4ka,sentinal,ufgyndmv,jonnyb,skate123,123456798,123456788,very1,gerrit,damocles,dollarbi,caroline1,lloyds,pizdets,flatland,92702689,dave13,meoff,ajnjuhfabz,achmed,madison9,744744z,amonte,avrillavigne,elaine1,norma1,asseater,everlong,buddy23,cmgang1,trash1,mitsu,flyman,ulugbek,june27,magistr,fittan,sebora64,dingos,sleipnir,caterpil,cindys,212121qaz,partys,dialer,gjytltkmybr,qweqaz,janvier,rocawear,lostboy,aileron,sweety1,everest1,pornman,boombox,potter1,blackdic,44448888,eric123,112233aa,2502557i,novass,nanotech,yourname,x12345,indian1,15975300,1234567l,carla51,chicago0,coleta,cxzdsaewq,qqwweerr,marwan,deltic,hollys,qwerasd,pon32029,rainmake,nathan0,matveeva,legioner,kevink,riven,tombraid,blitzen,a54321,jackyl,chinese1,shalimar,oleg1995,beaches1,tommylee,eknock,berli,monkey23,badbob,pugwash,likewhoa,jesus2,yujyd360,belmar,shadow22,utfp5e,angelo1,minimax,pooder,cocoa1,moresex,tortue,lesbia,panthe,snoopy2,drumnbass,alway,gmcz71,6jhwmqku,leppard,dinsdale,blair1,boriqua,money111,virtuagirl,267605,rattlesn,1sunshin,monica12,veritas1,newmexic,millertime,turandot,rfvxfnrf,jaydog,kakawka,bowhunter,booboo12,deerpark,erreway,taylorma,rfkbybyf,wooglin,weegee,rexdog,iamhorny,cazzo1,vhou812,bacardi1,dctktyyfz,godpasi,peanut12,bertha1,fuckyoubitch,ghosty,altavista,jertoot,smokeit,ghjcnbvtyz,fhnehxbr,rolsen,qazxcdews,maddmaxx,redrocke,qazokm,spencer2,thekiller,asdf11,123sex,tupac1,p1234567,dbrown,1biteme,tgo4466,316769,sunghi,shakespe,frosty1,gucci1,arcana,bandit01,lyubov,poochy,dartmout,magpies1,sunnyd,mouseman,summer07,chester7,shalini,danbury,pigboy,dave99,deniss,harryb,ashley11,pppppp1,01081988m,balloon1,tkachenko,bucks1,master77,pussyca,tricky1,zzxxccvv,zoulou,doomer,mukesh,iluv69,supermax,todays,thefox,don123,dontask,diplom,piglett,shiney,fahbrf,qaz12wsx,temitope,reggin,project1,buffy2,inside1,lbpfqyth,vanilla1,lovecock,u4slpwra,fylh.irf,123211,7ertu3ds,necroman,chalky,artist1,simpso,4x7wjr,chaos666,lazyacres,harley99,ch33s3,marusa,eagle7,dilligas,computadora,lucky69,denwer,nissan350z,unforgiv,oddball,schalke0,aztec1,borisova,branden1,parkave,marie123,germa,lafayett,878kckxy,405060,cheeseca,bigwave,fred22,andreea,poulet,mercutio,psycholo,andrew88,o4izdmxu,sanctuar,newhome,milion,suckmydi,rjvgm.nth,warior,goodgame,1qwertyuiop,6339cndh,scorpio2,macker,southbay,crabcake,toadie,paperclip,fatkid,maddo,cliff1,rastafar,maries,twins1,geujdrf,anjela,wc4fun,dolina,mpetroff,rollout,zydeco,shadow3,pumpki,steeda,volvo240,terras,blowjo,blue2000,incognit,badmojo,gambit1,zhukov,station1,aaronb,graci,duke123,clipper1,qazxsw2,ledzeppe,kukareku,sexkitte,cinco,007008,lakers12,a1234b,acmilan1,afhfjy,starrr,slutty3,phoneman,kostyan,bonzo1,sintesi07,ersatz,cloud1,nephilim,nascar03,rey619,kairos,123456789e,hardon1,boeing1,juliya,hfccdtn,vgfun8,polizei,456838,keithb,minouche,ariston,savag,213141,clarkken,microwav,london2,santacla,campeo,qr5mx7,464811,mynuts,bombo,1mickey,lucky8,danger1,ironside,carter12,wyatt1,borntorun,iloveyou123,jose1,pancake1,tadmichaels,monsta,jugger,hunnie,triste,heat7777,ilovejesus,queeny,luckycharm,lieben,gordolee85,jtkirk,forever21,jetlag,skylane,taucher,neworlea,holera,000005,anhnhoem,melissa7,mumdad,massimiliano,dima1994,nigel1,madison3,slicky,shokolad,serenit,jmh1978,soccer123,chris3,drwho,rfpzdrf,1qasw23ed,free4me,wonka,sasquatc,sanan,maytag,verochka,bankone,molly12,monopoli,xfqybr,lamborgini,gondolin,candycane,needsome,jb007,scottie1,brigit,0147258369,kalamazo,lololyo123,bill1234,ilovejes,lol123123,popkorn,april13,567rntvm,downunde,charle1,angelbab,guildwars,homeworld,qazxcvbnm,superma1,dupa123,kryptoni,happyy,artyom,stormie,cool11,calvin69,saphir,konovalov,jansport,october8,liebling,druuna,susans,megans,tujhjdf,wmegrfux,jumbo1,ljb4dt7n,012345678910,kolesnik,speculum,at4gftlw,kurgan,93pn75,cahek0980,dallas01,godswill,fhifdby,chelsea4,jump23,barsoom,catinhat,urlacher,angel99,vidadi1,678910,lickme69,topaz1,westend,loveone,c12345,gold12,alex1959,mamon,barney12,1maggie,alex12345,lp2568cskt,s1234567,gjikbdctyf,anthony0,browns99,chips1,sunking,widespre,lalala1,tdutif,fucklife,master00,alino4ka,stakan,blonde1,phoebus,tenore,bvgthbz,brunos,suzjv8,uvdwgt,revenant,1banana,veroniqu,sexfun,sp1der,4g3izhox,isakov,shiva1,scooba,bluefire,wizard12,dimitris,funbags,perseus,hoodoo,keving,malboro,157953,a32tv8ls,latics,animate,mossad,yejntb,karting,qmpq39zr,busdrive,jtuac3my,jkne9y,sr20dett,4gxrzemq,keylargo,741147,rfktylfhm,toast1,skins1,xcalibur,gattone,seether,kameron,glock9mm,julio1,delenn,gameday,tommyd,str8edge,bulls123,66699,carlsberg,woodbird,adnama,45auto,codyman,truck2,1w2w3w4w,pvjegu,method1,luetdi,41d8cd98f00b,bankai,5432112345,94rwpe,reneee,chrisx,melvins,775577,sam2000,scrappy1,rachid,grizzley,margare,morgan01,winstons,gevorg,gonzal,crawdad,gfhfdjp,babilon,noneya,pussy11,barbell,easyride,c00li0,777771,311music,karla1,golions,19866891,peejay,leadfoot,hfvbkm,kr9z40sy,cobra123,isotwe,grizz,sallys,****you,aaa123a,dembel,foxs14,hillcres,webman,mudshark,alfredo1,weeded,lester1,hovepark,ratface,000777fffa,huskie,wildthing,elbarto,waikiki,masami,call911,goose2,regin,dovajb,agricola,cjytxrj,andy11,penny123,family01,a121212,1braves,upupa68,happy100,824655,cjlove,firsttim,kalel,redhair,dfhtymt,sliders,bananna,loverbo,fifa2008,crouton,chevy350,panties2,kolya1,alyona,hagrid,spagetti,q2w3e4r,867530,narkoman,nhfdvfnjkju123,1ccccccc,napolean,0072563,allay,w8sted,wigwam,jamesk,state1,parovoz,beach69,kevinb,rossella,logitech1,celula,gnocca,canucks1,loginova,marlboro1,aaaa1,kalleanka,mester,mishutka,milenko,alibek,jersey1,peterc,1mouse,nedved,blackone,ghfplybr,682regkh,beejay,newburgh,ruffian,clarets,noreaga,xenophon,hummerh2,tenshi,smeagol,soloyo,vfhnby,ereiamjh,ewq321,goomie,sportin,cellphone,sonnie,jetblack,saudan,gblfhfc,matheus,uhfvjnf,alicja,jayman1,devon1,hexagon,bailey2,vtufajy,yankees7,salty1,908070,killemal,gammas,eurocard,sydney12,tuesday1,antietam,wayfarer,beast666,19952009sa,aq12ws,eveli,hockey21,haloreach,dontcare,xxxx1,andrea11,karlmarx,jelszo,tylerb,protools,timberwolf,ruffneck,pololo,1bbbbb,waleed,sasami,twinss,fairlady,illuminati,alex007,sucks1,homerjay,scooter7,tarbaby,barmaley,amistad,vanes,randers,tigers12,dreamer2,goleafsg,googie,bernie1,as12345,godeep,james3,phanto,gwbush,cumlover,2196dc,studioworks,995511,golf56,titova,kaleka,itali,socks1,kurwamac,daisuke,hevonen,woody123,daisie,wouter,henry123,gostosa,guppie,porpoise,iamsexy,276115,paula123,1020315,38gjgeuftd,rjrfrjkf,knotty,idiot1,sasha12345,matrix13,securit,radical1,ag764ks,jsmith,coolguy1,secretar,juanas,sasha1988,itout,00000001,tiger11,1butthea,putain,cavalo,basia1,kobebryant,1232323,12345asdfg,sunsh1ne,cyfqgth,tomkat,dorota,dashit,pelmen,5t6y7u,whipit,smokeone,helloall,bonjour1,snowshoe,nilknarf,x1x2x3,lammas,1234599,lol123456,atombomb,ironchef,noclue,alekseev,gwbush1,silver2,12345678m,yesican,fahjlbnf,chapstic,alex95,open1,tiger200,lisichka,pogiako,cbr929,searchin,tanya123,alex1973,phil413,alex1991,dominati,geckos,freddi,silenthill,egroeg,vorobey,antoxa,dark666,shkola,apple22,rebellio,shamanking,7f8srt,cumsucker,partagas,bill99,22223333,arnster55,fucknuts,proxima,silversi,goblues,parcells,vfrcbvjdf,piloto,avocet,emily2,1597530,miniskir,himitsu,pepper2,juiceman,venom1,bogdana,jujube,quatro,botafogo,mama2010,junior12,derrickh,asdfrewq,miller2,chitarra,silverfox,napol,prestigio,devil123,mm111qm,ara123,max33484,sex2000,primo1,sephan,anyuta,alena2010,viborg,verysexy,hibiscus,terps,josefin,oxcart,spooker,speciali,raffaello,partyon,vfhvtkflrf,strela,a123456z,worksuck,glasss,lomonosov,dusty123,dukeblue,1winter,sergeeva,lala123,john22,cmc09,sobolev,bettylou,dannyb,gjkrjdybr,hagakure,iecnhbr,awsedr,pmdmsctsk,costco,alekseeva,fktrcttd,bazuka,flyingv,garuda,buffy16,gutierre,beer12,stomatolog,ernies,palmeiras,golf123,love269,n.kmgfy,gjkysqgbpltw,youare,joeboo,baksik,lifeguar,111a111,nascar8,mindgame,dude1,neopets,frdfkfyu,june24,phoenix8,penelopa,merlin99,mercenar,badluck,mishel,bookert,deadsexy,power9,chinchil,1234567m,alex10,skunk1,rfhkcjy,sammycat,wright1,randy2,marakesh,temppassword,elmer251,mooki,patrick0,bonoedge,1tits,chiar,kylie1,graffix,milkman1,cornel,mrkitty,nicole12,ticketmaster,beatles4,number20,ffff1,terps1,superfre,yfdbufnjh,jake1234,flblfc,1111qq,zanuda,jmol01,wpoolejr,polopol,nicolett,omega13,cannonba,123456789.,sandy69,ribeye,bo243ns,marilena,bogdan123,milla,redskins1,19733791,alias1,movie1,ducat,marzena,shadowru,56565,coolman1,pornlover,teepee,spiff,nafanya,gateway3,fuckyou0,hasher,34778,booboo69,staticx,hang10,qq12345,garnier,bosco123,1234567qw,carson1,samso,1xrg4kcq,cbr929rr,allan123,motorbik,andrew22,pussy101,miroslava,cytujdbr,camp0017,cobweb,snusmumrik,salmon1,cindy2,aliya,serendipity,co437at,tincouch,timmy123,hunter22,st1100,vvvvvv1,blanka,krondor,sweeti,nenit,kuzmich,gustavo1,bmw320i,alex2010,trees1,kyliem,essayons,april26,kumari,sprin,fajita,appletre,fghbjhb,1green,katieb,steven2,corrado1,satelite,1michell,123456789c,cfkfvfylhf,acurarsx,slut543,inhere,bob2000,pouncer,k123456789,fishie,aliso,audia8,bluetick,soccer69,jordan99,fromhell,mammoth1,fighting54,mike25,pepper11,extra1,worldwid,chaise,vfr800,sordfish,almat,nofate,listopad,hellgate,dctvghbdf,jeremia,qantas,lokiju,honker,sprint1,maral,triniti,compaq3,sixsix6,married1,loveman,juggalo1,repvtyrj,zxcasdqw,123445,whore1,123678,monkey6,west123,warcraf,pwnage,mystery1,creamyou,ant123,rehjgfnrf,corona1,coleman1,steve121,alderaan,barnaul,celeste1,junebug1,bombshel,gretzky9,tankist,targa,cachou,vaz2101,playgolf,boneyard,strateg,romawka,iforgotit,pullup,garbage1,irock,archmage,shaft1,oceano,sadies,alvin1,135135ab,psalm69,lmfao,ranger02,zaharova,33334444,perkman,realman,salguod,cmoney,astonmartin,glock1,greyfox,viper99,helpm,blackdick,46775575,family5,shazbot,dewey1,qwertyas,shivani,black22,mailman1,greenday1,57392632,red007,stanky,sanchez1,tysons,daruma,altosax,krayzie,85852008,1forever,98798798,irock.,123456654,142536789,ford22,brick1,michela,preciou,crazy4u,01telemike01,nolife,concac,safety1,annie123,brunswic,destini,123456qwer,madison0,snowball1,137946,1133557799,jarule,scout2,songohan,thedead,00009999,murphy01,spycam,hirsute,aurinko,associat,1miller,baklan,hermes1,2183rm,martie,kangoo,shweta,yvonne1,westsid,jackpot1,rotciv,maratik,fabrika,claude1,nursultan,noentry,ytnhjufnm,electra1,ghjcnjnfr1,puneet,smokey01,integrit,bugeye,trouble2,14071789,paul01,omgwtf,dmh415,ekilpool,yourmom1,moimeme,sparky11,boludo,ruslan123,kissme1,demetrio,appelsin,asshole3,raiders2,bunns,fynjybj,billygoa,p030710p$e4o,macdonal,248ujnfk,acorns,schmidt1,sparrow1,vinbylrj,weasle,jerom,ycwvrxxh,skywalk,gerlinde,solidus,postal1,poochie1,1charles,rhianna,terorist,rehnrf,omgwtfbbq,assfucke,deadend,zidan,jimboy,vengence,maroon5,7452tr,dalejr88,sombra,anatole,elodi,amazonas,147789,q12345q,gawker1,juanma,kassidy,greek1,bruces,bilbob,mike44,0o9i8u7y6t,kaligula,agentx,familie,anders1,pimpjuice,0128um,birthday10,lawncare,hownow,grandorgue,juggerna,scarfac,kensai,swatteam,123four,motorbike,repytxbr,other1,celicagt,pleomax,gen0303,godisgreat,icepick,lucifer666,heavy1,tea4two,forsure,02020,shortdog,webhead,chris13,palenque,3techsrl,knights1,orenburg,prong,nomarg,wutang1,80637852730,laika,iamfree,12345670,pillow1,12343412,bigears,peterg,stunna,rocky5,12123434,damir,feuerwehr,7418529630,danone,yanina,valenci,andy69,111222q,silvia1,1jjjjj,loveforever,passwo1,stratocaster,8928190a,motorolla,lateralu,ujujkm,chubba,ujkjdf,signon,123456789zx,serdce,stevo,wifey200,ololo123,popeye1,1pass,central1,melena,luxor,nemezida,poker123,ilovemusic,qaz1234,noodles1,lakeshow,amarill,ginseng,billiam,trento,321cba,fatback,soccer33,master13,marie2,newcar,bigtop,dark1,camron,nosgoth,155555,biglou,redbud,jordan7,159789,diversio,actros,dazed,drizzit,hjcnjd,wiktoria,justic,gooses,luzifer,darren1,chynna,tanuki,11335577,icculus,boobss,biggi,firstson,ceisi123,gatewa,hrothgar,jarhead1,happyjoy,felipe1,bebop1,medman,athena1,boneman,keiths,djljgfl,dicklick,russ120,mylady,zxcdsa,rock12,bluesea,kayaks,provista,luckies,smile4me,bootycal,enduro,123123f,heartbre,ern3sto,apple13,bigpappa,fy.njxrf,bigtom,cool69,perrito,quiet1,puszek,cious,cruella,temp1,david26,alemap,aa123123,teddies,tricolor,smokey12,kikiriki,mickey01,robert01,super5,ranman,stevenso,deliciou,money777,degauss,mozar,susanne1,asdasd12,shitbag,mommy123,wrestle1,imfree,fuckyou12,barbaris,florent,ujhijr,f8yruxoj,tefjps,anemone,toltec,2gether,left4dead2,ximen,gfkmvf,dunca,emilys,diana123,16473a,mark01,bigbro,annarbor,nikita2000,11aa11,tigres,llllll1,loser2,fbi11213,jupite,qwaszxqw,macabre,123ert,rev2000,mooooo,klapaucius,bagel1,chiquit,iyaoyas,bear101,irocz28,vfktymrfz,smokey2,love99,rfhnbyf,dracul,keith123,slicko,peacock1,orgasmic,thesnake,solder,wetass,doofer,david5,rhfcyjlfh,swanny,tammys,turkiye,tubaman,estefani,firehose,funnyguy,servo,grace17,pippa1,arbiter,jimmy69,nfymrf,asdf67nm,rjcnzy,demon123,thicknes,sexysex,kristall,michail,encarta,banderos,minty,marchenko,de1987ma,mo5kva,aircav,naomi1,bonni,tatoo,cronaldo,49ers1,mama1963,1truck,telecaster,punksnotdead,erotik,1eagles,1fender,luv269,acdeehan,tanner1,freema,1q3e5t7u,linksys,tiger6,megaman1,neophyte,australia1,mydaddy,1jeffrey,fgdfgdfg,gfgekz,1986irachka,keyman,m0b1l3,dfcz123,mikeyg,playstation2,abc125,slacker1,110491g,lordsoth,bhavani,ssecca,dctvghbdtn,niblick,hondacar,baby01,worldcom,4034407,51094didi,3657549,3630000,3578951,sweetpussy,majick,supercoo,robert11,abacabb,panda123,gfhjkm13,ford4x4,zippo1,lapin,1726354,lovesong,dude11,moebius,paravoz,1357642,matkhau,solnyshko,daniel4,multiplelog,starik,martusia,iamtheman,greentre,jetblue,motorrad,vfrcbvev,redoak,dogma1,gnorman,komlos,tonka1,1010220,666satan,losenord,lateralus,absinthe,command1,jigga1,iiiiiii1,pants1,jungfrau,926337,ufhhbgjnnth,yamakasi,888555,sunny7,gemini69,alone1,zxcvbnmz,cabezon,skyblues,zxc1234,456123a,zero00,caseih,azzurra,legolas1,menudo,murcielago,785612,779977,benidorm,viperman,dima1985,piglet1,hemligt,hotfeet,7elephants,hardup,gamess,a000000,267ksyjf,kaitlynn,sharkie,sisyphus,yellow22,667766,redvette,666420,mets69,ac2zxdty,hxxrvwcy,cdavis,alan1,noddy,579300,druss,eatshit1,555123,appleseed,simpleplan,kazak,526282,fynfyfyfhbde,birthday6,dragon6,1pookie,bluedevils,omg123,hj8z6e,x5dxwp,455445,batman23,termin,chrisbrown,animals1,lucky9,443322,kzktxrf,takayuki,fermer,assembler,zomu9q,sissyboy,sergant,felina,nokia6230i,eminem12,croco,hunt4red,festina,darknigh,cptnz062,ndshnx4s,twizzler,wnmaz7sd,aamaax,gfhfcjkmrf,alabama123,barrynov,happy5,punt0it,durandal,8xuuobe4,cmu9ggzh,bruno12,316497,crazyfrog,vfvfktyf,apple3,kasey1,mackdaddy,anthon1,sunnys,angel3,cribbage,moon1,donal,bryce1,pandabear,mwss474,whitesta,freaker,197100,bitche,p2ssw0rd,turnb,tiktonik,moonlite,ferret1,jackas,ferrum,bearclaw,liberty2,1diablo,caribe,snakeeyes,janbam,azonic,rainmaker,vetalik,bigeasy,baby1234,sureno13,blink1,kluivert,calbears,lavanda,198600,dhtlbyf,medvedeva,fox123,whirling,bonscott,freedom9,october3,manoman,segredo,cerulean,robinso,bsmith,flatus,dannon,password21,rrrrrr1,callista,romai,rainman1,trantor,mickeymo,bulldog7,g123456,pavlin,pass22,snowie,hookah,7ofnine,bubba22,cabible,nicerack,moomoo1,summer98,yoyo123,milan1,lieve27,mustang69,jackster,exocet,nadege,qaz12,bahama,watson1,libras,eclipse2,bahram,bapezm,up9x8rww,ghjcnjz,themaste,deflep27,ghost16,gattaca,fotograf,junior123,gilber,gbjyth,8vjzus,rosco1,begonia,aldebara,flower12,novastar,buzzman,manchild,lopez1,mama11,william7,yfcnz1,blackstar,spurs123,moom4242,1amber,iownyou,tightend,07931505,paquito,1johnson,smokepot,pi31415,snowmass,ayacdc,jessicam,giuliana,5tgbnhy6,harlee,giuli,bigwig,tentacle,scoubidou2,benelli,vasilina,nimda,284655,jaihind,lero4ka,1tommy,reggi,ididit,jlbyjxtcndj,mike26,qbert,wweraw,lukasz,loosee123,palantir,flint1,mapper,baldie,saturne,virgin1,meeeee,elkcit,iloveme2,blue15,themoon,radmir,number3,shyanne,missle,hannelor,jasmina,karin1,lewie622,ghjcnjqgfhjkm,blasters,oiseau,sheela,grinders,panget,rapido,positiv,twink,fltkbyf,kzsfj874,daniel01,enjoyit,nofags,doodad,rustler,squealer,fortunat,peace123,khushi,devils2,7inches,candlebo,topdawg,armen,soundman,zxcqweasd,april7,gazeta,netman,hoppers,bear99,ghbjhbntn,mantle7,bigbo,harpo,jgordon,bullshi,vinny1,krishn,star22,thunderc,galinka,phish123,tintable,nightcrawler,tigerboy,rbhgbx,messi,basilisk,masha1998,nina123,yomamma,kayla123,geemoney,0000000000d,motoman,a3jtni,ser123,owen10,italien,vintelok,12345rewq,nightime,jeepin,ch1tt1ck,mxyzptlk,bandido,ohboy,doctorj,hussar,superted,parfilev,grundle,1jack,livestrong,chrisj,matthew3,access22,moikka,fatone,miguelit,trivium,glenn1,smooches,heiko,dezember,spaghett,stason,molokai,bossdog,guitarma,waderh,boriska,photosho,path13,hfrtnf,audre,junior24,monkey24,silke,vaz21093,bigblue1,trident1,candide,arcanum,klinker,orange99,bengals1,rosebu,mjujuj,nallepuh,mtwapa1a,ranger69,level1,bissjop,leica,1tiffany,rutabega,elvis77,kellie1,sameas,barada,karabas,frank12,queenb,toutoune,surfcity,samanth1,monitor1,littledo,kazakova,fodase,mistral1,april22,carlit,shakal,batman123,fuckoff2,alpha01,5544332211,buddy3,towtruck,kenwood1,vfiekmrf,jkl123,pypsik,ranger75,sitges,toyman,bartek1,ladygirl,booman,boeing77,installsqlst,222666,gosling,bigmack,223311,bogos,kevin2,gomez1,xohzi3g4,kfnju842,klubnika,cubalibr,123456789101,kenpo,0147852369,raptor1,tallulah,boobys,jjones,1q2s3c,moogie,vid2600,almas,wombat1,extra300,xfiles1,green77,sexsex1,heyjude,sammyy,missy123,maiyeuem,nccpl25282,thicluv,sissie,raven3,fldjrfn,buster22,broncos2,laurab,letmein4,harrydog,solovey,fishlips,asdf4321,ford123,superjet,norwegen,movieman,psw333333,intoit,postbank,deepwate,ola123,geolog323,murphys,eshort,a3eilm2s2y,kimota,belous,saurus,123321qaz,i81b4u,aaa12,monkey20,buckwild,byabybnb,mapleleafs,yfcnzyfcnz,baby69,summer03,twista,246890,246824,ltcnhjth,z1z2z3,monika1,sad123,uto29321,bathory,villan,funkey,poptarts,spam967888,705499fh,sebast,porn1234,earn381,1porsche,whatthef,123456789y,polo12,brillo,soreilly,waters1,eudora,allochka,is_a_bot,winter00,bassplay,531879fiz,onemore,bjarne,red911,kot123,artur1,qazxdr,c0rvette,diamond7,matematica,klesko,beaver12,2enter,seashell,panam,chaching,edward2,browni,xenogear,cornfed,aniram,chicco22,darwin1,ancella2,sophie2,vika1998,anneli,shawn41,babie,resolute,pandora2,william8,twoone,coors1,jesusis1,teh012,cheerlea,renfield,tessa1,anna1986,madness1,bkmlfh,19719870,liebherr,ck6znp42,gary123,123654z,alsscan,eyedoc,matrix7,metalgea,chinito,4iter,falcon11,7jokx7b9du,bigfeet,tassadar,retnuh,muscle1,klimova,darion,batistuta,bigsur,1herbier,noonie,ghjrehjh,karimova,faustus,snowwhite,1manager,dasboot,michael12,analfuck,inbed,dwdrums,jaysoncj,maranell,bsheep75,164379,rolodex,166666,rrrrrrr1,almaz666,167943,russel1,negrito,alianz,goodpussy,veronik,1w2q3r4e,efremov,emb377,sdpass,william6,alanfahy,nastya1995,panther5,automag,123qwe12,vfvf2011,fishe,1peanut,speedie,qazwsx1234,pass999,171204j,ketamine,sheena1,energizer,usethis1,123abc123,buster21,thechamp,flvbhfk,frank69,chane,hopeful1,claybird,pander,anusha,bigmaxxx,faktor,housebed,dimidrol,bigball,shashi,derby1,fredy,dervish,bootycall,80988218126,killerb,cheese2,pariss,mymail,dell123,catbert,christa1,chevytru,gjgjdf,00998877,overdriv,ratten,golf01,nyyanks,dinamite,bloembol,gismo,magnus1,march2,twinkles,ryan22,duckey,118a105b,kitcat,brielle,poussin,lanzarot,youngone,ssvegeta,hero63,battle1,kiler,fktrcfylh1,newera,vika1996,dynomite,oooppp,beer4me,foodie,ljhjuf,sonshine,godess,doug1,constanc,thinkbig,steve2,damnyou,autogod,www333,kyle1,ranger7,roller1,harry2,dustin1,hopalong,tkachuk,b00bies,bill2,deep111,stuffit,fire69,redfish1,andrei123,graphix,1fishing,kimbo1,mlesp31,ifufkbyf,gurkan,44556,emily123,busman,and123,8546404,paladine,1world,bulgakov,4294967296,bball23,1wwwww,mycats,elain,delta6,36363,emilyb,color1,6060842,cdtnkfyrf,hedonism,gfgfrfhkj,5551298,scubad,gostate,sillyme,hdbiker,beardown,fishers,sektor,00000007,newbaby,rapid1,braves95,gator2,nigge,anthony3,sammmy,oou812,heffer,phishin,roxanne1,yourass,hornet1,albator,2521659,underwat,tanusha,dianas,3f3fpht7op,dragon20,bilbobag,cheroke,radiatio,dwarf1,majik,33st33,dochka,garibald,robinh,sham69,temp01,wakeboar,violet1,1w2w3w,registr,tonite,maranello,1593570,parolamea,galatasara,loranthos,1472583,asmodean,1362840,scylla,doneit,jokerr,porkypig,kungen,mercator,koolhaas,come2me,debbie69,calbear,liverpoolfc,yankees4,12344321a,kennyb,madma,85200258,dustin23,thomas13,tooling,mikasa,mistic,crfnbyf,112233445,sofia1,heinz57,colts1,price1,snowey,joakim,mark11,963147,cnhfcnm,kzinti,1bbbbbbb,rubberdu,donthate,rupert1,sasha1992,regis1,nbuhbwf,fanboy,sundial,sooner1,wayout,vjnjhjkf,deskpro,arkangel,willie12,mikeyb,celtic1888,luis1,buddy01,duane1,grandma1,aolcom,weeman,172839456,basshead,hornball,magnu,pagedown,molly2,131517,rfvtgbyhn,astonmar,mistery,madalina,cash1,1happy,shenlong,matrix01,nazarova,369874125,800500,webguy,rse2540,ashley2,briank,789551,786110,chunli,j0nathan,greshnik,courtne,suckmyco,mjollnir,789632147,asdfg1234,754321,odelay,ranma12,zebedee,artem777,bmw318is,butt1,rambler1,yankees9,alabam,5w76rnqp,rosies,mafioso,studio1,babyruth,tranzit,magical123,gfhjkm135,12345$,soboleva,709394,ubique,drizzt1,elmers,teamster,pokemons,1472583690,1597532486,shockers,merckx,melanie2,ttocs,clarisse,earth1,dennys,slobber,flagman,farfalla,troika,4fa82hyx,hakan,x4ww5qdr,cumsuck,leather1,forum1,july20,barbel,zodiak,samuel12,ford01,rushfan,bugsy1,invest1,tumadre,screwme,a666666,money5,henry8,tiddles,sailaway,starburs,100years,killer01,comando,hiromi,ranetka,thordog,blackhole,palmeira,verboten,solidsna,q1w1e1,humme,kevinc,gbrfxe,gevaudan,hannah11,peter2,vangar,sharky7,talktome,jesse123,chuchi,pammy,!qazxsw2,siesta,twenty1,wetwilly,477041,natural1,sun123,daniel3,intersta,shithead1,hellyea,bonethugs,solitair,bubbles2,father1,nick01,444000,adidas12,dripik,cameron2,442200,a7nz8546,respublika,fkojn6gb,428054,snoppy,rulez1,haslo,rachael1,purple01,zldej102,ab12cd34,cytuehjxrf,madhu,astroman,preteen,handsoff,mrblonde,biggio,testin,vfdhif,twolves,unclesam,asmara,kpydskcw,lg2wmgvr,grolsch,biarritz,feather1,williamm,s62i93,bone1,penske,337733,336633,taurus1,334433,billet,diamondd,333000,nukem,fishhook,godogs,thehun,lena1982,blue00,smelly1,unb4g9ty,65pjv22,applegat,mikehunt,giancarlo,krillin,felix123,december1,soapy,46doris,nicole23,bigsexy1,justin10,pingu,bambou,falcon12,dgthtl,1surfer,qwerty01,estrellit,nfqcjy,easygo,konica,qazqwe,1234567890m,stingers,nonrev,3e4r5t,champio,bbbbbb99,196400,allen123,seppel,simba2,rockme,zebra3,tekken3,endgame,sandy2,197300,fitte,monkey00,eldritch,littleone,rfyfgkz,1member,66chevy,oohrah,cormac,hpmrbm41,197600,grayfox,elvis69,celebrit,maxwell7,rodders,krist,1camaro,broken1,kendall1,silkcut,katenka,angrick,maruni,17071994a,tktyf,kruemel,snuffles,iro4ka,baby12,alexis01,marryme,vlad1994,forward1,culero,badaboom,malvin,hardtoon,hatelove,molley,knopo4ka,duchess1,mensuck,cba321,kickbutt,zastava,wayner,fuckyou6,eddie123,cjkysir,john33,dragonfi,cody1,jabell,cjhjrf,badseed,sweden1,marihuana,brownlov,elland,nike1234,kwiettie,jonnyboy,togepi,billyk,robert123,bb334,florenci,ssgoku,198910,bristol1,bob007,allister,yjdujhjl,gauloise,198920,bellaboo,9lives,aguilas,wltfg4ta,foxyroxy,rocket69,fifty50,babalu,master21,malinois,kaluga,gogosox,obsessio,yeahrigh,panthers1,capstan,liza2000,leigh1,paintball1,blueskie,cbr600f3,bagdad,jose98,mandreki,shark01,wonderbo,muledeer,xsvnd4b2,hangten,200001,grenden,anaell,apa195,model1,245lufpq,zip100,ghjcgtrn,wert1234,misty2,charro,juanjose,fkbcrf,frostbit,badminto,buddyy,1doctor,vanya,archibal,parviz,spunky1,footboy,dm6tzsgp,legola,samadhi,poopee,ytdxz2ca,hallowboy,dposton,gautie,theworm,guilherme,dopehead,iluvtits,bobbob1,ranger6,worldwar,lowkey,chewbaca,oooooo99,ducttape,dedalus,celular,8i9o0p,borisenko,taylor01,111111z,arlingto,p3nnywiz,rdgpl3ds,boobless,kcmfwesg,blacksab,mother2,markus1,leachim,secret2,s123456789,1derful,espero,russell2,tazzer,marykate,freakme,mollyb,lindros8,james00,gofaster,stokrotka,kilbosik,aquamann,pawel1,shedevil,mousie,slot2009,october6,146969,mm259up,brewcrew,choucho,uliana,sexfiend,fktirf,pantss,vladimi,starz,sheeps,12341234q,bigun,tiggers,crjhjcnm,libtech,pudge1,home12,zircon,klaus1,jerry2,pink1,lingus,monkey66,dumass,polopolo09,feuerweh,rjyatnf,chessy,beefer,shamen,poohbear1,4jjcho,bennevis,fatgirls,ujnbrf,cdexswzaq,9noize9,rich123,nomoney,racecar1,hacke,clahay,acuario,getsum,hondacrv,william0,cheyenn,techdeck,atljhjdf,wtcacq,suger,fallenangel,bammer,tranquil,carla123,relayer,lespaul1,portvale,idontno,bycnbnen,trooper2,gennadiy,pompon,billbob,amazonka,akitas,chinatow,atkbrc,busters,fitness1,cateye,selfok2013,1murphy,fullhous,mucker,bajskorv,nectarin,littlebitch,love24,feyenoor,bigal37,lambo1,pussybitch,icecube1,biged,kyocera,ltybcjdf,boodle,theking1,gotrice,sunset1,abm1224,fromme,sexsells,inheat,kenya1,swinger1,aphrodit,kurtcobain,rhind101,poidog,poiulkjh,kuzmina,beantown,tony88,stuttgar,drumer,joaqui,messenge,motorman,amber2,nicegirl,rachel69,andreia,faith123,studmuffin,jaiden,red111,vtkmybr,gamecocks,gumper,bosshogg,4me2know,tokyo1,kleaner,roadhog,fuckmeno,phoenix3,seeme,buttnutt,boner69,andreyka,myheart,katerin,rugburn,jvtuepip,dc3ubn,chile1,ashley69,happy99,swissair,balls2,fylhttdf,jimboo,55555d,mickey11,voronin,m7hsqstm,stufff,merete,weihnachte,dowjones,baloo1,freeones,bears34,auburn1,beverl,timberland,1elvis,guinness1,bombadil,flatron1,logging7,telefoon,merl1n,masha1,andrei1,cowabung,yousuck1,1matrix,peopl,asd123qwe,sweett,mirror1,torrente,joker12,diamond6,jackaroo,00000a,millerlite,ironhorse,2twins,stryke,gggg1,zzzxxxccc,roosevel,8363eddy,angel21,depeche1,d0ct0r,blue14,areyou,veloce,grendal,frederiksberg,cbcntvf,cb207sl,sasha2000,was.here,fritzz,rosedale,spinoza,cokeisit,gandalf3,skidmark,ashley01,12345j,1234567890qaz,sexxxxxx,beagles,lennart,12345789,pass10,politic,max007,gcheckou,12345611,tiffy,lightman,mushin,velosiped,brucewayne,gauthie,elena123,greenegg,h2oski,clocker,nitemare,123321s,megiddo,cassidy1,david13,boywonde,flori,peggy12,pgszt6md,batterie,redlands,scooter6,bckhere,trueno,bailey11,maxwell2,bandana,timoth1,startnow,ducati74,tiern,maxine1,blackmetal,suzyq,balla007,phatfarm,kirsten1,titmouse,benhogan,culito,forbin,chess1,warren1,panman,mickey7,24lover,dascha,speed2,redlion,andrew10,johnwayn,nike23,chacha1,bendog,bullyboy,goldtree,spookie,tigger99,1cookie,poutine,cyclone1,woodpony,camaleun,bluesky1,dfadan,eagles20,lovergirl,peepshow,mine1,dima1989,rjdfkmxer,11111aaaaa,machina,august17,1hhhhh,0773417k,1monster,freaksho,jazzmin,davidw,kurupt,chumly,huggies,sashenka,ccccccc1,bridge1,giggalo,cincinna,pistol1,hello22,david77,lightfoo,lucky6,jimmy12,261397,lisa12,tabaluga,mysite,belo4ka,greenn,eagle99,punkrawk,salvado,slick123,wichsen,knight99,dummys,fefolico,contrera,kalle1,anna1984,delray,robert99,garena,pretende,racefan,alons,serenada,ludmilla,cnhtkjr,l0swf9gx,hankster,dfktynbyrf,sheep1,john23,cv141ab,kalyani,944turbo,crystal2,blackfly,zrjdktdf,eus1sue1,mario5,riverplate,harddriv,melissa3,elliott1,sexybitc,cnhfyybr,jimdavis,bollix,beta1,amberlee,skywalk1,natala,1blood,brattax,shitty1,gb15kv99,ronjon,rothmans,thedoc,joey21,hotboi,firedawg,bimbo38,jibber,aftermat,nomar,01478963,phishing,domodo,anna13,materia,martha1,budman1,gunblade,exclusiv,sasha1997,anastas,rebecca2,fackyou,kallisti,fuckmyass,norseman,ipswich1,151500,1edward,intelinside,darcy1,bcrich,yjdjcnbf,failte,buzzzz,cream1,tatiana1,7eleven,green8,153351,1a2s3d4f5g6h,154263,milano1,bambi1,bruins77,rugby2,jamal1,bolita,sundaypunch,bubba12,realmadr,vfyxtcnth,iwojima,notlob,black666,valkiria,nexus1,millerti,birthday100,swiss1,appollo,gefest,greeneyes,celebrat,tigerr,slava123,izumrud,bubbabub,legoman,joesmith,katya123,sweetdream,john44,wwwwwww1,oooooo1,socal,lovespor,s5r8ed67s,258147,heidis,cowboy22,wachovia,michaelb,qwe1234567,i12345,255225,goldie1,alfa155,45colt,safeu851,antonova,longtong,1sparky,gfvznm,busen,hjlbjy,whateva,rocky4,cokeman,joshua3,kekskek1,sirocco,jagman,123456qwert,phinupi,thomas10,loller,sakur,vika2011,fullred,mariska,azucar,ncstate,glenn74,halima,aleshka,ilovemylife,verlaat,baggie,scoubidou6,phatboy,jbruton,scoop1,barney11,blindman,def456,maximus2,master55,nestea,11223355,diego123,sexpistols,sniffy,philip1,f12345,prisonbreak,nokia2700,ajnjuhfa,yankees3,colfax,ak470000,mtnman,bdfyeirf,fotball,ichbin,trebla,ilusha,riobravo,beaner1,thoradin,polkaudi,kurosawa,honda123,ladybu,valerik,poltava,saviola,fuckyouguys,754740g0,anallove,microlab1,juris01,ncc1864,garfild,shania1,qagsud,makarenko,cindy69,lebedev,andrew11,johnnybo,groovy1,booster1,sanders1,tommyb,johnson4,kd189nlcih,hondaman,vlasova,chick1,sokada,sevisgur,bear2327,chacho,sexmania,roma1993,hjcnbckfd,valley1,howdie,tuppence,jimandanne,strike3,y4kuz4,nhfnfnf,tsubasa,19955991,scabby,quincunx,dima1998,uuuuuu1,logica,skinner1,pinguino,lisa1234,xpressmusic,getfucked,qqqq1,bbbb1,matulino,ulyana,upsman,johnsmith,123579,co2000,spanner1,todiefor,mangoes,isabel1,123852,negra,snowdon,nikki123,bronx1,booom,ram2500,chuck123,fireboy,creek1,batman13,princesse,az12345,maksat,1knight,28infern,241455,r7112s,muselman,mets1986,katydid,vlad777,playme,kmfdm1,asssex,1prince,iop890,bigbroth,mollymoo,waitron,lizottes,125412,juggler,quinta,0sister0,zanardi,nata123,heckfyxbr,22q04w90e,engine2,nikita95,zamira,hammer22,lutscher,carolina1,zz6319,sanman,vfuflfy,buster99,rossco,kourniko,aggarwal,tattoo1,janice1,finger1,125521,19911992,shdwlnds,rudenko,vfvfgfgf123,galatea,monkeybu,juhani,premiumcash,classact,devilmay,helpme2,knuddel,hardpack,ramil,perrit,basil1,zombie13,stockcar,tos8217,honeypie,nowayman,alphadog,melon1,talula,125689,tiribon12,tornike,haribol,telefone,tiger22,sucka,lfytxrf,chicken123,muggins,a23456,b1234567,lytdybr,otter1,pippa,vasilisk,cooking1,helter,78978,bestboy,viper7,ahmed1,whitewol,mommys,apple5,shazam1,chelsea7,kumiko,masterma,rallye,bushmast,jkz123,entrar,andrew6,nathan01,alaric,tavasz,heimdall,gravy1,jimmy99,cthlwt,powerr,gthtrhtcnjr,canesfan,sasha11,ybrbnf_25,august9,brucie,artichok,arnie1,superdude,tarelka,mickey22,dooper,luners,holeshot,good123,gettysbu,bicho,hammer99,divine5,1zxcvbn,stronzo,q22222,disne,bmw750il,godhead,hallodu,aerith,nastik,differen,cestmoi,amber69,5string,pornosta,dirtygirl,ginger123,formel1,scott12,honda200,hotspurs,johnatha,firstone123,lexmark1,msconfig,karlmasc,l123456,123qweasdzx,baldman,sungod,furka,retsub,9811020,ryder1,tcglyued,astron,lbvfcbr,minddoc,dirt49,baseball12,tbear,simpl,schuey,artimus,bikman,plat1num,quantex,gotyou,hailey1,justin01,ellada,8481068,000002,manimal,dthjybxrf,buck123,dick123,6969696,nospam,strong1,kodeord,bama12,123321w,superman123,gladiolus,nintend,5792076,dreamgirl,spankme1,gautam,arianna1,titti,tetas,cool1234,belladog,importan,4206969,87e5nclizry,teufelo7,doller,yfl.irf,quaresma,3440172,melis,bradle,nnmaster,fast1,iverso,blargh,lucas12,chrisg,iamsam,123321az,tomjerry,kawika,2597174,standrew,billyg,muskan,gizmodo2,rz93qpmq,870621345,sathya,qmezrxg4,januari,marthe,moom4261,cum2me,hkger286,lou1988,suckit1,croaker,klaudia1,753951456,aidan1,fsunoles,romanenko,abbydog,isthebes,akshay,corgi,fuck666,walkman555,ranger98,scorpian,hardwareid,bluedragon,fastman,2305822q,iddqdiddqd,1597532,gopokes,zvfrfcb,w1234567,sputnik1,tr1993,pa$$w0rd,2i5fdruv,havvoc,1357913,1313131,bnm123,cowd00d,flexscan,thesims2,boogiema,bigsexxy,powerstr,ngc4565,joshman,babyboy1,123jlb,funfunfu,qwe456,honor1,puttana,bobbyj,daniel21,pussy12,shmuck,1232580,123578951,maxthedo,hithere1,bond0007,gehenna,nomames,blueone,r1234567,bwana,gatinho,1011111,torrents,cinta,123451234,tiger25,money69,edibey,pointman,mmcm19,wales1,caffreys,phaedra,bloodlus,321ret32,rufuss,tarbit,joanna1,102030405,stickboy,lotrfotr34,jamshid,mclarenf1,ataman,99ford,yarrak,logan2,ironlung,pushistik,dragoon1,unclebob,tigereye,pinokio,tylerj,mermaid1,stevie1,jaylen,888777,ramana,roman777,brandon7,17711771s,thiago,luigi1,edgar1,brucey,videogam,classi,birder,faramir,twiddle,cubalibre,grizzy,fucky,jjvwd4,august15,idinahui,ranita,nikita1998,123342,w1w2w3,78621323,4cancel,789963,(null,vassago,jaydog472,123452,timt42,canada99,123589,rebenok,htyfnf,785001,osipov,maks123,neverwinter,love2010,777222,67390436,eleanor1,bykemo,aquemini,frogg,roboto,thorny,shipmate,logcabin,66005918,nokian,gonzos,louisian,1abcdefg,triathlo,ilovemar,couger,letmeino,supera,runvs,fibonacci,muttly,58565254,5thgbqi,vfnehsv,electr,jose12,artemis1,newlove,thd1shr,hawkey,grigoryan,saisha,tosca,redder,lifesux,temple1,bunnyman,thekids,sabbeth,tarzan1,182838,158uefas,dell50,1super,666222,47ds8x,jackhamm,mineonly,rfnfhbyf,048ro,665259,kristina1,bombero,52545856,secure1,bigloser,peterk,alex2,51525354,anarchy1,superx,teenslut,money23,sigmapi,sanfrancisco,acme34,private5,eclips,qwerttrewq,axelle,kokain,hardguy,peter69,jesuschr,dyanna,dude69,sarah69,toyota91,amberr,45645645,bugmenot,bigted,44556677,556644,wwr8x9pu,alphaome,harley13,kolia123,wejrpfpu,revelati,nairda,sodoff,cityboy,pinkpussy,dkalis,miami305,wow12345,triplet,tannenbau,asdfasdf1,darkhors,527952,retired1,soxfan,nfyz123,37583867,goddes,515069,gxlmxbewym,1warrior,36925814,dmb2011,topten,karpova,89876065093rax,naturals,gateway9,cepseoun,turbot,493949,cock22,italia1,sasafras,gopnik,stalke,1qazxdr5,wm2006,ace1062,alieva,blue28,aracel,sandia,motoguzz,terri1,emmajane,conej,recoba,alex1995,jerkyboy,cowboy12,arenrone,precisio,31415927,scsa316,panzer1,studly1,powerhou,bensam,mashoutq,billee,eeyore1,reape,thebeatl,rul3z,montesa,doodle1,cvzefh1gk,424365,a159753,zimmerma,gumdrop,ashaman,grimreap,icandoit,borodina,branca,dima2009,keywest1,vaders,bubluk,diavolo,assss,goleta,eatass,napster1,382436,369741,5411pimo,lenchik,pikach,gilgamesh,kalimera,singer1,gordon2,rjycnbnewbz,maulwurf,joker13,2much4u,bond00,alice123,robotec,fuckgirl,zgjybz,redhorse,margaret1,brady1,pumpkin2,chinky,fourplay,1booger,roisin,1brandon,sandan,blackheart,cheez,blackfin,cntgfyjdf,mymoney1,09080706,goodboss,sebring1,rose1,kensingt,bigboner,marcus12,ym3cautj,struppi,thestone,lovebugs,stater,silver99,forest99,qazwsx12345,vasile,longboar,mkonji,huligan,rhfcbdfz,airmail,porn11,1ooooo,sofun,snake2,msouthwa,dougla,1iceman,shahrukh,sharona,dragon666,france98,196800,196820,ps253535,zjses9evpa,sniper01,design1,konfeta,jack99,drum66,good4you,station2,brucew,regedit,school12,mvtnr765,pub113,fantas,tiburon1,king99,ghjcnjgbpltw,checkito,308win,1ladybug,corneliu,svetasveta,197430,icicle,imaccess,ou81269,jjjdsl,brandon6,bimbo1,smokee,piccolo1,3611jcmg,children2,cookie2,conor1,darth1,margera,aoi856,paully,ou812345,sklave,eklhigcz,30624700,amazing1,wahooo,seau55,1beer,apples2,chulo,dolphin9,heather6,198206,198207,hergood,miracle1,njhyflj,4real,milka,silverfi,fabfive,spring12,ermine,mammy,jumpjet,adilbek,toscana,caustic,hotlove,sammy69,lolita1,byoung,whipme,barney01,mistys,tree1,buster3,kaylin,gfccgjhn,132333,aishiteru,pangaea,fathead1,smurph,198701,ryslan,gasto,xexeylhf,anisimov,chevyss,saskatoo,brandy12,tweaker,irish123,music2,denny1,palpatin,outlaw1,lovesuck,woman1,mrpibb,diadora,hfnfneq,poulette,harlock,mclaren1,cooper12,newpass3,bobby12,rfgecnfcerf,alskdjfh,mini14,dukers,raffael,199103,cleo123,1234567qwertyu,mossberg,scoopy,dctulf,starline,hjvjxrf,misfits1,rangers2,bilbos,blackhea,pappnase,atwork,purple2,daywalker,summoner,1jjjjjjj,swansong,chris10,laluna,12345qqq,charly1,lionsden,money99,silver33,hoghead,bdaddy,199430,saisg002,nosaints,tirpitz,1gggggg,jason13,kingss,ernest1,0cdh0v99ue,pkunzip,arowana,spiri,deskjet1,armine,lances,magic2,thetaxi,14159265,cacique,14142135,orange10,richard0,backdraf,255ooo,humtum,kohsamui,c43dae874d,wrestling1,cbhtym,sorento,megha,pepsiman,qweqwe12,bliss7,mario64,korolev,balls123,schlange,gordit,optiquest,fatdick,fish99,richy,nottoday,dianne1,armyof1,1234qwerasdfzxcv,bbonds,aekara,lidiya,baddog1,yellow5,funkie,ryan01,greentree,gcheckout,marshal1,liliput,000000z,rfhbyrf,gtogto43,rumpole,tarado,marcelit,aqwzsxedc,kenshin1,sassydog,system12,belly1,zilla,kissfan,tools1,desember,donsdad,nick11,scorpio6,poopoo1,toto99,steph123,dogfuck,rocket21,thx113,dude12,sanek,sommar,smacky,pimpsta,letmego,k1200rs,lytghjgtnhjdcr,abigale,buddog,deles,baseball9,roofus,carlsbad,hamzah,hereiam,genial,schoolgirlie,yfz450,breads,piesek,washear,chimay,apocalyp,nicole18,gfgf1234,gobulls,dnevnik,wonderwall,beer1234,1moose,beer69,maryann1,adpass,mike34,birdcage,hottuna,gigant,penquin,praveen,donna123,123lol123,thesame,fregat,adidas11,selrahc,pandoras,test3,chasmo,111222333000,pecos,daniel11,ingersol,shana1,mama12345,cessna15,myhero,1simpson,nazarenko,cognit,seattle2,irina1,azfpc310,rfycthdf,hardy1,jazmyn,sl1200,hotlanta,jason22,kumar123,sujatha,fsd9shtyu,highjump,changer,entertai,kolding,mrbig,sayuri,eagle21,qwertzu,jorge1,0101dd,bigdong,ou812a,sinatra1,htcnjhfy,oleg123,videoman,pbyfblf,tv612se,bigbird1,kenaidog,gunite,silverma,ardmore,123123qq,hotbot,cascada,cbr600f4,harakiri,chico123,boscos,aaron12,glasgow1,kmn5hc,lanfear,1light,liveoak,fizika,ybrjkftdyf,surfside,intermilan,multipas,redcard,72chevy,balata,coolio1,schroede,kanat,testerer,camion,kierra,hejmeddig,antonio2,tornados,isidor,pinkey,n8skfswa,ginny1,houndog,1bill,chris25,hastur,1marine,greatdan,french1,hatman,123qqq,z1z2z3z4,kicker1,katiedog,usopen,smith22,mrmagoo,1234512i,assa123,7seven7,monster7,june12,bpvtyf,149521,guenter,alex1985,voronina,mbkugegs,zaqwsxcderfv,rusty5,mystic1,master0,abcdef12,jndfkb,r4zpm3,cheesey,skripka,blackwhite,sharon69,dro8smwq,lektor,techman,boognish,deidara,heckfyf,quietkey,authcode,monkey4,jayboy,pinkerto,merengue,chulita,bushwick,turambar,kittykit,joseph2,dad123,kristo,pepote,scheiss,hambone1,bigballa,restaura,tequil,111luzer,euro2000,motox,denhaag,chelsi,flaco1,preeti,lillo,1001sin,passw,august24,beatoff,555555d,willis1,kissthis,qwertyz,rvgmw2gl,iloveboobies,timati,kimbo,msinfo,dewdrop,sdbaker,fcc5nky2,messiah1,catboy,small1,chode,beastie1,star77,hvidovre,short1,xavie,dagobah,alex1987,papageno,dakota2,toonami,fuerte,jesus33,lawina,souppp,dirtybir,chrish,naturist,channel1,peyote,flibble,gutentag,lactate,killem,zucchero,robinho,ditka,grumpy1,avr7000,boxxer,topcop,berry1,mypass1,beverly1,deuce1,9638527410,cthuttdf,kzkmrf,lovethem,band1t,cantona1,purple11,apples123,wonderwo,123a456,fuzzie,lucky99,dancer2,hoddling,rockcity,winner12,spooty,mansfiel,aimee1,287hf71h,rudiger,culebra,god123,agent86,daniel0,bunky1,notmine,9ball,goofus,puffy1,xyh28af4,kulikov,bankshot,vurdf5i2,kevinm,ercole,sexygirls,razvan,october7,goater,lollie,raissa,thefrog,mdmaiwa3,mascha,jesussaves,union1,anthony9,crossroa,brother2,areyuke,rodman91,toonsex,dopeman,gericom,vaz2115,cockgobbler,12356789,12345699,signatur,alexandra1,coolwhip,erwin1,awdrgyjilp,pens66,ghjrjgtyrj,linkinpark,emergenc,psych0,blood666,bootmort,wetworks,piroca,johnd,iamthe1,supermario,homer69,flameon,image1,bebert,fylhtq1,annapoli,apple11,hockey22,10048,indahouse,mykiss,1penguin,markp,misha123,foghat,march11,hank1,santorin,defcon4,tampico,vbnhjafy,robert22,bunkie,athlon64,sex777,nextdoor,koskesh,lolnoob,seemnemaailm,black23,march15,yeehaa,chiqui,teagan,siegheil,monday2,cornhusk,mamusia,chilis,sthgrtst,feldspar,scottm,pugdog,rfghjy,micmac,gtnhjdyf,terminato,1jackson,kakosja,bogomol,123321aa,rkbvtyrj,tresor,tigertig,fuckitall,vbkkbjy,caramon,zxc12,balin,dildo1,soccer09,avata,abby123,cheetah1,marquise,jennyc,hondavfr,tinti,anna1985,dennis2,jorel,mayflowe,icema,hal2000,nikkis,bigmouth,greenery,nurjan,leonov,liberty7,fafnir,larionov,sat321321,byteme1,nausicaa,hjvfynbrf,everto,zebra123,sergio1,titone,wisdom1,kahala,104328q,marcin1,salima,pcitra,1nnnnn,nalini,galvesto,neeraj,rick1,squeeky,agnes1,jitterbu,agshar,maria12,0112358,traxxas,stivone,prophet1,bananza,sommer1,canoneos,hotfun,redsox11,1bigmac,dctdjkjl,legion1,everclea,valenok,black9,danny001,roxie1,1theman,mudslide,july16,lechef,chula,glamis,emilka,canbeef,ioanna,cactus1,rockshox,im2cool,ninja9,thvfrjdf,june28,milo17,missyou,micky1,nbibyf,nokiaa,goldi,mattias,fuckthem,asdzxc123,ironfist,junior01,nesta,crazzy,killswit,hygge,zantac,kazama,melvin1,allston,maandag,hiccup,prototyp,specboot,dwl610,hello6,159456,baldhead,redwhite,calpoly,whitetail,agile1,cousteau,matt01,aust1n,malcolmx,gjlfhjr,semperf1,ferarri,a1b2c3d,vangelis,mkvdari,bettis36,andzia,comand,tazzman,morgaine,pepluv,anna1990,inandout,anetka,anna1997,wallpape,moonrake,huntress,hogtie,cameron7,sammy7,singe11,clownboy,newzeala,wilmar,safrane,rebeld,poopi,granat,hammertime,nermin,11251422,xyzzy1,bogeys,jkmxbr,fktrcfyl,11223311,nfyrbcn,11223300,powerpla,zoedog,ybrbnbyf,zaphod42,tarawa,jxfhjdfirf,dude1234,g5wks9,goobe,czekolada,blackros,amaranth,medical1,thereds,julija,nhecsyfujkjdt,promopas,buddy4,marmalad,weihnachten,tronic,letici,passthief,67mustan,ds7zamnw,morri,w8woord,cheops,pinarell,sonofsam,av473dv,sf161pn,5c92v5h6,purple13,tango123,plant1,1baby,xufrgemw,fitta,1rangers,spawns,kenned,taratata,19944991,11111118,coronas,4ebouux8,roadrash,corvette1,dfyjdf846,marley12,qwaszxerdfcv,68stang,67stang,racin,ellehcim,sofiko,nicetry,seabass1,jazzman1,zaqwsx1,laz2937,uuuuuuu1,vlad123,rafale,j1234567,223366,nnnnnn1,226622,junkfood,asilas,cer980,daddymac,persepho,neelam,00700,shithappens,255555,qwertyy,xbox36,19755791,qweasd1,bearcub,jerryb,a1b1c1,polkaudio,basketball1,456rty,1loveyou,marcus2,mama1961,palace1,transcend,shuriken,sudhakar,teenlove,anabelle,matrix99,pogoda,notme,bartend,jordana,nihaoma,ataris,littlegi,ferraris,redarmy,giallo,fastdraw,accountbloc,peludo,pornostar,pinoyako,cindee,glassjaw,dameon,johnnyd,finnland,saudade,losbravo,slonko,toplay,smalltit,nicksfun,stockhol,penpal,caraj,divedeep,cannibus,poppydog,pass88,viktory,walhalla,arisia,lucozade,goldenbo,tigers11,caball,ownage123,tonna,handy1,johny,capital5,faith2,stillher,brandan,pooky1,antananarivu,hotdick,1justin,lacrimos,goathead,bobrik,cgtwbfkbcn,maywood,kamilek,gbplf123,gulnar,beanhead,vfvjyn,shash,viper69,ttttttt1,hondacr,kanako,muffer,dukies,justin123,agapov58,mushka,bad11bad,muleman,jojo123,andreika,makeit,vanill,boomers,bigals,merlin11,quacker,aurelien,spartak1922,ligeti,diana2,lawnmowe,fortune1,awesom,rockyy,anna1994,oinker,love88,eastbay,ab55484,poker0,ozzy666,papasmurf,antihero,photogra,ktm250,painkill,jegr2d2,p3orion,canman,dextur,qwest123,samboy,yomismo,sierra01,herber,vfrcbvvfrcbv,gloria1,llama1,pie123,bobbyjoe,buzzkill,skidrow,grabber,phili,javier1,9379992q,geroin,oleg1994,sovereig,rollover,zaq12qaz,battery1,killer13,alina123,groucho1,mario12,peter22,butterbean,elise1,lucycat,neo123,ferdi,golfer01,randie,gfhfyjbr,ventura1,chelsea3,pinoy,mtgox,yrrim7,shoeman,mirko,ffggyyo,65mustan,ufdibyjd,john55,suckfuck,greatgoo,fvfnjhb,mmmnnn,love20,1bullshi,sucesso,easy1234,robin123,rockets1,diamondb,wolfee,nothing0,joker777,glasnost,richar1,guille,sayan,koresh,goshawk,alexx,batman21,a123456b,hball,243122,rockandr,coolfool,isaia,mary1,yjdbrjdf,lolopc,cleocat,cimbo,lovehina,8vfhnf,passking,bonapart,diamond2,bigboys,kreator,ctvtyjdf,sassy123,shellac,table54781,nedkelly,philbert,sux2bu,nomis,sparky99,python1,littlebear,numpty,silmaril,sweeet,jamesw,cbufhtnf,peggysue,wodahs,luvsex,wizardry,venom123,love4you,bama1,samat,reviewpass,ned467,cjkjdtq,mamula,gijoe,amersham,devochka,redhill,gisel,preggo,polock,cando,rewster,greenlantern,panasonik,dave1234,mikeee,1carlos,miledi,darkness1,p0o9i8u7y6,kathryn1,happyguy,dcp500,assmaster,sambuka,sailormo,antonio3,logans,18254288,nokiax2,qwertzuiop,zavilov,totti,xenon1,edward11,targa1,something1,tony_t,q1w2e3r4t5y6u7i8o9p0,02551670,vladimir1,monkeybutt,greenda,neel21,craiger,saveliy,dei008,honda450,fylhtq95,spike2,fjnq8915,passwordstandard,vova12345,talonesi,richi,gigemags,pierre1,westin,trevoga,dorothee,bastogne,25563o,brandon3,truegrit,krimml,iamgreat,servis,a112233,paulinka,azimuth,corperfmonsy,358hkyp,homerun1,dogbert1,eatmyass,cottage1,savina,baseball7,bigtex,gimmesum,asdcxz,lennon1,a159357,1bastard,413276191q,pngfilt,pchealth,netsnip,bodiroga,1matt,webtvs,ravers,adapters,siddis,mashamasha,coffee2,myhoney,anna1982,marcia1,fairchil,maniek,iloveluc,batmonh,wildon,bowie1,netnwlnk,fancy1,tom204,olga1976,vfif123,queens1,ajax01,lovess,mockba,icam4usb,triada,odinthor,rstlne,exciter,sundog,anchorat,girls69,nfnmzyrf,soloma,gti16v,shadowman,ottom,rataros,tonchin,vishal,chicken0,pornlo,christiaan,volante,likesit,mariupol,runfast,gbpltw123,missys,villevalo,kbpjxrf,ghibli,calla,cessna172,kinglear,dell11,swift1,walera,1cricket,pussy5,turbo911,tucke,maprchem56458,rosehill,thekiwi1,ygfxbkgt,mandarinka,98xa29,magnit,cjfrf,paswoord,grandam1,shenmue,leedsuni,hatrick,zagadka,angeldog,michaell,dance123,koichi,bballs,29palms,xanth,228822,ppppppp1,1kkkkk,1lllll,mynewbots,spurss,madmax1,224455,city1,mmmmmmm1,nnnnnnn1,biedronka,thebeatles,elessar,f14tomcat,jordan18,bobo123,ayi000,tedbear,86chevyx,user123,bobolink,maktub,elmer1,flyfishi,franco1,gandalf0,traxdata,david21,enlighte,dmitrij,beckys,1giants,flippe,12345678w,jossie,rugbyman,snowcat,rapeme,peanut11,gemeni,udders,techn9ne,armani1,chappie,war123,vakantie,maddawg,sewanee,jake5253,tautt1,anthony5,letterma,jimbo2,kmdtyjr,hextall,jessica6,amiga500,hotcunt,phoenix9,veronda,saqartvelo,scubas,sixer3,williamj,nightfal,shihan,melnikova,kosssss,handily,killer77,jhrl0821,march17,rushman,6gcf636i,metoyou,irina123,mine11,primus1,formatters,matthew5,infotech,gangster1,jordan45,moose69,kompas,motoxxx,greatwhi,cobra12,kirpich,weezer1,hello23,montse,tracy123,connecte,cjymrf,hemingwa,azreal,gundam00,mobila,boxman,slayers1,ravshan,june26,fktrcfylhjd,bermuda1,tylerd,maersk,qazwsx11,eybdthcbntn,ash123,camelo,kat123,backd00r,cheyenne1,1king,jerkin,tnt123,trabant,warhammer40k,rambos,punto,home77,pedrito,1frank,brille,guitarman,george13,rakas,tgbxtcrbq,flute1,bananas1,lovezp1314,thespot,postie,buster69,sexytime,twistys,zacharia,sportage,toccata,denver7,terry123,bogdanova,devil69,higgins1,whatluck,pele10,kkk666,jeffery1,1qayxsw2,riptide1,chevy11,munchy,lazer1,hooker1,ghfgjh,vergesse,playgrou,4077mash,gusev,humpin,oneputt,hydepark,monster9,tiger8,tangsoo,guy123,hesoyam1,uhtqneyu,thanku,lomond,ortezza,kronik,geetha,rabbit66,killas,qazxswe,alabaste,1234567890qwerty,capone1,andrea12,geral,beatbox,slutfuck,booyaka,jasmine7,ostsee,maestro1,beatme,tracey1,buster123,donaldduck,ironfish,happy6,konnichi,gintonic,momoney1,dugan1,today2,enkidu,destiny2,trim7gun,katuha,fractals,morganstanley,polkadot,gotime,prince11,204060,fifa2010,bobbyt,seemee,amanda10,airbrush,bigtitty,heidie,layla1,cotton1,5speed,fyfnjkmtdyf,flynavy,joxury8f,meeko,akuma,dudley1,flyboy1,moondog1,trotters,mariami,signin,chinna,legs11,pussy4,1s1h1e1f1,felici,optimus1,iluvu,marlins1,gavaec,balance1,glock40,london01,kokot,southwes,comfort1,sammy11,rockbottom,brianc,litebeer,homero,chopsuey,greenlan,charit,freecell,hampster,smalldog,viper12,blofeld,1234567890987654321,realsex,romann,cartman2,cjdthitycndj,nelly1,bmw528,zwezda,masterba,jeep99,turtl,america2,sunburst,sanyco,auntjudy,125wm,blue10,qwsazx,cartma,toby12,robbob,red222,ilovecock,losfix16,1explore,helge,vaz2114,whynotme,baba123,mugen,1qazwsxedc,albertjr,0101198,sextime,supras,nicolas2,wantsex,pussy6,checkm8,winam,24gordon,misterme,curlew,gbljhfcs,medtech,franzi,butthea,voivod,blackhat,egoiste,pjkeirf,maddog69,pakalolo,hockey4,igor1234,rouges,snowhite,homefree,sexfreak,acer12,dsmith,blessyou,199410,vfrcbvjd,falco02,belinda1,yaglasph,april21,groundho,jasmin1,nevergiveup,elvir,gborv526,c00kie,emma01,awesome2,larina,mike12345,maximu,anupam,bltynbabrfwbz,tanushka,sukkel,raptor22,josh12,schalke04,cosmodog,fuckyou8,busybee,198800,bijoux,frame1,blackmor,giveit,issmall,bear13,123-123,bladez,littlegirl,ultra123,fletch1,flashnet,loploprock,rkelly,12step,lukas1,littlewhore,cuntfinger,stinkyfinger,laurenc,198020,n7td4bjl,jackie69,camel123,ben1234,1gateway,adelheid,fatmike,thuglove,zzaaqq,chivas1,4815162342q,mamadou,nadano,james22,benwin,andrea99,rjirf,michou,abkbgg,d50gnn,aaazzz,a123654,blankman,booboo11,medicus,bigbone,197200,justine1,bendix,morphius,njhvjp,44mag,zsecyus56,goodbye1,nokiadermo,a333444,waratsea,4rzp8ab7,fevral,brillian,kirbys,minim,erathia,grazia,zxcvb1234,dukey,snaggle,poppi,hymen,1video,dune2000,jpthjdf,cvbn123,zcxfcnkbdfz,astonv,ginnie,316271,engine3,pr1ncess,64chevy,glass1,laotzu,hollyy,comicbooks,assasins,nuaddn9561,scottsda,hfcnfvfy,accobra,7777777z,werty123,metalhead,romanson,redsand,365214,shalo,arsenii,1989cc,sissi,duramax,382563,petera,414243,mamapap,jollymon,field1,fatgirl,janets,trompete,matchbox20,rambo2,nepenthe,441232,qwertyuiop10,bozo123,phezc419hv,romantika,lifestyl,pengui,decembre,demon6,panther6,444888,scanman,ghjcnjabkz,pachanga,buzzword,indianer,spiderman3,tony12,startre,frog1,fyutk,483422,tupacshakur,albert12,1drummer,bmw328i,green17,aerdna,invisibl,summer13,calimer,mustaine,lgnu9d,morefun,hesoyam123,escort1,scrapland,stargat,barabbas,dead13,545645,mexicali,sierr,gfhfpbn,gonchar,moonstafa,searock,counte,foster1,jayhawk1,floren,maremma,nastya2010,softball1,adaptec,halloo,barrabas,zxcasd123,hunny,mariana1,kafedra,freedom0,green420,vlad1234,method7,665566,tooting,hallo12,davinchi,conducto,medias,666444,invernes,madhatter,456asd,12345678i,687887,le33px,spring00,help123,bellybut,billy5,vitalik1,river123,gorila,bendis,power666,747200,footslav,acehigh,qazxswedc123,q1a1z1,richard9,peterburg,tabletop,gavrilov,123qwe1,kolosov,fredrau,run4fun,789056,jkbvgbflf,chitra,87654321q,steve22,wideopen,access88,surfe,tdfyutkbjy,impossib,kevin69,880888,cantina,887766,wxcvb,dontforg,qwer1209,asslicke,mamma123,indig,arkasha,scrapp,morelia,vehxbr,jones2,scratch1,cody11,cassie12,gerbera,dontgotm,underhil,maks2010,hollywood1,hanibal,elena2010,jason11,1010321,stewar,elaman,fireplug,goodby,sacrific,babyphat,bobcat12,bruce123,1233215,tony45,tiburo,love15,bmw750,wallstreet,2h0t4me,1346795,lamerz,munkee,134679q,granvill,1512198,armastus,aiden1,pipeutvj,g1234567,angeleyes,usmc1,102030q,putangina,brandnew,shadowfax,eagles12,1falcon,brianw,lokomoti,2022958,scooper,pegas,jabroni1,2121212,buffal,siffredi,wewiz,twotone,rosebudd,nightwis,carpet1,mickey2,2525252,sleddog,red333,jamesm,2797349,jeff12,onizuka,felixxxx,rf6666,fine1,ohlala,forplay,chicago5,muncho,scooby11,ptichka,johnnn,19851985p,dogphil3650,totenkopf,monitor2,macross7,3816778,dudder,semaj1,bounder,racerx1,5556633,7085506,ofclr278,brody1,7506751,nantucke,hedj2n4q,drew1,aessedai,trekbike,pussykat,samatron,imani,9124852,wiley1,dukenukem,iampurehaha2,9556035,obvious1,mccool24,apache64,kravchenko,justforf,basura,jamese,s0ccer,safado,darksta,surfer69,damian1,gjpbnbd,gunny1,wolley,sananton,zxcvbn123456,odt4p6sv8,sergei1,modem1,mansikka,zzzz1,rifraf,dima777,mary69,looking4,donttell,red100,ninjutsu,uaeuaeman,bigbri,brasco,queenas8151,demetri,angel007,bubbl,kolort,conny,antonia1,avtoritet,kaka22,kailayu,sassy2,wrongway,chevy3,1nascar,patriots1,chrisrey,mike99,sexy22,chkdsk,sd3utre7,padawan,a6pihd,doming,mesohorny,tamada,donatello,emma22,eather,susan69,pinky123,stud69,fatbitch,pilsbury,thc420,lovepuss,1creativ,golf1234,hurryup,1honda,huskerdu,marino1,gowron,girl1,fucktoy,gtnhjpfdjlcr,dkjfghdk,pinkfl,loreli,7777777s,donkeykong,rockytop,staples1,sone4ka,xxxjay,flywheel,toppdogg,bigbubba,aaa123456,2letmein,shavkat,paule,dlanor,adamas,0147852,aassaa,dixon1,bmw328,mother12,ilikepussy,holly2,tsmith,excaliber,fhutynbyf,nicole3,tulipan,emanue,flyvholm,currahee,godsgift,antonioj,torito,dinky1,sanna,yfcnzvjz,june14,anime123,123321456654,hanswurst,bandman,hello101,xxxyyy,chevy69,technica,tagada,arnol,v00d00,lilone,filles,drumandbass,dinamit,a1234a,eatmeat,elway07,inout,james6,dawid1,thewolf,diapason,yodaddy,qscwdv,fuckit1,liljoe,sloeber,simbacat,sascha1,qwe1234,1badger,prisca,angel17,gravedig,jakeyboy,longboard,truskawka,golfer11,pyramid7,highspee,pistola,theriver,hammer69,1packers,dannyd,alfonse,qwertgfdsa,11119999,basket1,ghjtrn,saralee,12inches,paolo1,zse4xdr5,taproot,sophieh6,grizzlie,hockey69,danang,biggums,hotbitch,5alive,beloved1,bluewave,dimon95,koketka,multiscan,littleb,leghorn,poker2,delite,skyfir,bigjake,persona1,amberdog,hannah12,derren,ziffle,1sarah,1assword,sparky01,seymur,tomtom1,123321qw,goskins,soccer19,luvbekki,bumhole,2balls,1muffin,borodin,monkey9,yfeiybrb,1alex,betmen,freder,nigger123,azizbek,gjkzrjdf,lilmike,1bigdadd,1rock,taganrog,snappy1,andrey1,kolonka,bunyan,gomango,vivia,clarkkent,satur,gaudeamus,mantaray,1month,whitehea,fargus,andrew99,ray123,redhawks,liza2009,qw12345,den12345,vfhnsyjdf,147258369a,mazepa,newyorke,1arsenal,hondas2000,demona,fordgt,steve12,birthday2,12457896,dickster,edcwsxqaz,sahalin,pantyman,skinny1,hubertus,cumshot1,chiro,kappaman,mark3434,canada12,lichking,bonkers1,ivan1985,sybase,valmet,doors1,deedlit,kyjelly,bdfysx,ford11,throatfuck,backwood,fylhsq,lalit,boss429,kotova,bricky,steveh,joshua19,kissa,imladris,star1234,lubimka,partyman,crazyd,tobias1,ilike69,imhome,whome,fourstar,scanner1,ujhjl312,anatoli,85bears,jimbo69,5678ytr,potapova,nokia7070,sunday1,kalleank,1996gta,refinnej,july1,molodec,nothanks,enigm,12play,sugardog,nhfkbdfkb,larousse,cannon1,144444,qazxcdew,stimorol,jhereg,spawn7,143000,fearme,hambur,merlin21,dobie,is3yeusc,partner1,dekal,varsha,478jfszk,flavi,hippo1,9hmlpyjd,july21,7imjfstw,lexxus,truelov,nokia5200,carlos6,anais,mudbone,anahit,taylorc,tashas,larkspur,animal2000,nibiru,jan123,miyvarxar,deflep,dolore,communit,ifoptfcor,laura2,anadrol,mamaliga,mitzi1,blue92,april15,matveev,kajlas,wowlook1,1flowers,shadow14,alucard1,1golf,bantha,scotlan,singapur,mark13,manchester1,telus01,superdav,jackoff1,madnes,bullnuts,world123,clitty,palmer1,david10,spider10,sargsyan,rattlers,david4,windows2,sony12,visigoth,qqqaaa,penfloor,cabledog,camilla1,natasha123,eagleman,softcore,bobrov,dietmar,divad,sss123,d1234567,tlbyjhju,1q1q1q1,paraiso,dav123,lfiekmrf,drachen,lzhan16889,tplate,gfghbrf,casio1,123boots1,123test,sys64738,heavymetal,andiamo,meduza,soarer,coco12,negrita,amigas,heavymet,bespin,1asdfghj,wharfrat,wetsex,tight1,janus1,sword123,ladeda,dragon98,austin2,atep1,jungle1,12345abcd,lexus300,pheonix1,alex1974,123qw123,137955,bigtim,shadow88,igor1994,goodjob,arzen,champ123,121ebay,changeme1,brooksie,frogman1,buldozer,morrowin,achim,trish1,lasse,festiva,bubbaman,scottb,kramit,august22,tyson123,passsword,oompah,al123456,fucking1,green45,noodle1,looking1,ashlynn,al1716,stang50,coco11,greese,bob111,brennan1,jasonj,1cherry,1q2345,1xxxxxxx,fifa2011,brondby,zachar1,satyam,easy1,magic7,1rainbow,cheezit,1eeeeeee,ashley123,assass1,amanda123,jerbear,1bbbbbb,azerty12,15975391,654321z,twinturb,onlyone1,denis1988,6846kg3r,jumbos,pennydog,dandelion,haileris,epervier,snoopy69,afrodite,oldpussy,green55,poopypan,verymuch,katyusha,recon7,mine69,tangos,contro,blowme2,jade1,skydive1,fiveiron,dimo4ka,bokser,stargirl,fordfocus,tigers2,platina,baseball11,raque,pimper,jawbreak,buster88,walter34,chucko,penchair,horizon1,thecure1,scc1975,adrianna1,kareta,duke12,krille,dumbfuck,cunt1,aldebaran,laverda,harumi,knopfler,pongo1,pfhbyf,dogman1,rossigno,1hardon,scarlets,nuggets1,ibelieve,akinfeev,xfhkbr,athene,falcon69,happie,billly,nitsua,fiocco,qwerty09,gizmo2,slava2,125690,doggy123,craigs,vader123,silkeborg,124365,peterm,123978,krakatoa,123699,123592,kgvebmqy,pensacol,d1d2d3,snowstor,goldenboy,gfg65h7,ev700,church1,orange11,g0dz1ll4,chester3,acheron,cynthi,hotshot1,jesuschris,motdepass,zymurgy,one2one,fietsbel,harryp,wisper,pookster,nn527hp,dolla,milkmaid,rustyboy,terrell1,epsilon1,lillian1,dale3,crhbgrf,maxsim,selecta,mamada,fatman1,ufkjxrf,shinchan,fuckuall,women1,000008,bossss,greta1,rbhjxrf,mamasboy,purple69,felicidade,sexy21,cathay,hunglow,splatt,kahless,shopping1,1gandalf,themis,delta7,moon69,blue24,parliame,mamma1,miyuki,2500hd,jackmeof,razer,rocker1,juvis123,noremac,boing747,9z5ve9rrcz,icewater,titania,alley1,moparman,christo1,oliver2,vinicius,tigerfan,chevyy,joshua99,doda99,matrixx,ekbnrf,jackfrost,viper01,kasia,cnfhsq,triton1,ssbt8ae2,rugby8,ramman,1lucky,barabash,ghtlfntkm,junaid,apeshit,enfant,kenpo1,shit12,007000,marge1,shadow10,qwerty789,richard8,vbitkm,lostboys,jesus4me,richard4,hifive,kolawole,damilola,prisma,paranoya,prince2,lisaann,happyness,cardss,methodma,supercop,a8kd47v5,gamgee,polly123,irene1,number8,hoyasaxa,1digital,matthew0,dclxvi,lisica,roy123,2468013579,sparda,queball,vaffanculo,pass1wor,repmvbx,999666333,freedom8,botanik,777555333,marcos1,lubimaya,flash2,einstei,08080,123456789j,159951159,159357123,carrot1,alina1995,sanjos,dilara,mustang67,wisteria,jhnjgtl12,98766789,darksun,arxangel,87062134,creativ1,malyshka,fuckthemall,barsic,rocksta,2big4u,5nizza,genesis2,romance1,ofcourse,1horse,latenite,cubana,sactown,789456123a,milliona,61808861,57699434,imperia,bubba11,yellow3,change12,55495746,flappy,jimbo123,19372846,19380018,cutlass1,craig123,klepto,beagle1,solus,51502112,pasha1,19822891,46466452,19855891,petshop,nikolaevna,119966,nokia6131,evenpar,hoosier1,contrasena,jawa350,gonzo123,mouse2,115511,eetfuk,gfhfvgfvgfv,1crystal,sofaking,coyote1,kwiatuszek,fhrflbq,valeria1,anthro,0123654789,alltheway,zoltar,maasikas,wildchil,fredonia,earlgrey,gtnhjczy,matrix123,solid1,slavko,12monkeys,fjdksl,inter1,nokia6500,59382113kevinp,spuddy,cachero,coorslit,password!,kiba1z,karizma,vova1994,chicony,english1,bondra12,1rocket,hunden,jimbob1,zpflhjn1,th0mas,deuce22,meatwad,fatfree,congas,sambora,cooper2,janne,clancy1,stonie,busta,kamaz,speedy2,jasmine3,fahayek,arsenal0,beerss,trixie1,boobs69,luansantana,toadman,control2,ewing33,maxcat,mama1964,diamond4,tabaco,joshua0,piper2,music101,guybrush,reynald,pincher,katiebug,starrs,pimphard,frontosa,alex97,cootie,clockwor,belluno,skyeseth,booty69,chaparra,boochie,green4,bobcat1,havok,saraann,pipeman,aekdb,jumpshot,wintermu,chaika,1chester,rjnjatq,emokid,reset1,regal1,j0shua,134679a,asmodey,sarahh,zapidoo,ciccione,sosexy,beckham23,hornets1,alex1971,delerium,manageme,connor11,1rabbit,sane4ek,caseyboy,cbljhjdf,redsox20,tttttt99,haustool,ander,pantera6,passwd1,journey1,9988776655,blue135,writerspace,xiaoyua123,justice2,niagra,cassis,scorpius,bpgjldsgjldthnf,gamemaster,bloody1,retrac,stabbin,toybox,fight1,ytpyf.,glasha,va2001,taylor11,shameles,ladylove,10078,karmann,rodeos,eintritt,lanesra,tobasco,jnrhjqcz,navyman,pablit,leshka,jessica3,123vika,alena1,platinu,ilford,storm7,undernet,sasha777,1legend,anna2002,kanmax1994,porkpie,thunder0,gundog,pallina,easypass,duck1,supermom,roach1,twincam,14028,tiziano,qwerty32,123654789a,evropa,shampoo1,yfxfkmybr,cubby1,tsunami1,fktrcttdf,yasacrac,17098,happyhap,bullrun,rodder,oaktown,holde,isbest,taylor9,reeper,hammer11,julias,rolltide1,compaq123,fourx4,subzero1,hockey9,7mary3,busines,ybrbnjcbr,wagoneer,danniash,portishead,digitex,alex1981,david11,infidel,1snoopy,free30,jaden,tonto1,redcar27,footie,moskwa,thomas21,hammer12,burzum,cosmo123,50000,burltree,54343,54354,vwpassat,jack5225,cougars1,burlpony,blackhorse,alegna,petert,katemoss,ram123,nels0n,ferrina,angel77,cstock,1christi,dave55,abc123a,alex1975,av626ss,flipoff,folgore,max1998,science1,si711ne,yams7,wifey1,sveiks,cabin1,volodia,ox3ford,cartagen,platini,picture1,sparkle1,tiedomi,service321,wooody,christi1,gnasher,brunob,hammie,iraffert,bot2010,dtcyeirf,1234567890p,cooper11,alcoholi,savchenko,adam01,chelsea5,niewiem,icebear,lllooottt,ilovedick,sweetpus,money8,cookie13,rfnthbyf1988,booboo2,angus123,blockbus,david9,chica1,nazaret,samsung9,smile4u,daystar,skinnass,john10,thegirl,sexybeas,wasdwasd1,sigge1,1qa2ws3ed4rf5tg,czarny,ripley1,chris5,ashley19,anitha,pokerman,prevert,trfnthby,tony69,georgia2,stoppedb,qwertyuiop12345,miniclip,franky1,durdom,cabbages,1234567890o,delta5,liudmila,nhfycajhvths,court1,josiew,abcd1,doghead,diman,masiania,songline,boogle,triston,deepika,sexy4me,grapple,spacebal,ebonee,winter0,smokewee,nargiza,dragonla,sassys,andy2000,menards,yoshio,massive1,suckmy1k,passat99,sexybo,nastya1996,isdead,stratcat,hokuto,infix,pidoras,daffyduck,cumhard,baldeagl,kerberos,yardman,shibainu,guitare,cqub6553,tommyy,bk.irf,bigfoo,hecto,july27,james4,biggus,esbjerg,isgod,1irish,phenmarr,jamaic,roma1990,diamond0,yjdbrjd,girls4me,tampa1,kabuto,vaduz,hanse,spieng,dianochka,csm101,lorna1,ogoshi,plhy6hql,2wsx4rfv,cameron0,adebayo,oleg1996,sharipov,bouboule,hollister1,frogss,yeababy,kablam,adelante,memem,howies,thering,cecilia1,onetwo12,ojp123456,jordan9,msorcloledbr,neveraga,evh5150,redwin,1august,canno,1mercede,moody1,mudbug,chessmas,tiikeri,stickdaddy77,alex15,kvartira,7654321a,lollol123,qwaszxedc,algore,solana,vfhbyfvfhbyf,blue72,misha1111,smoke20,junior13,mogli,threee,shannon2,fuckmylife,kevinh,saransk,karenw,isolde,sekirarr,orion123,thomas0,debra1,laketaho,alondra,curiva,jazz1234,1tigers,jambos,lickme2,suomi,gandalf7,028526,zygote,brett123,br1ttany,supafly,159000,kingrat,luton1,cool-ca,bocman,thomasd,skiller,katter,mama777,chanc,tomass,1rachel,oldno7,rfpfyjdf,bigkev,yelrah,primas,osito,kipper1,msvcr71,bigboy11,thesun,noskcaj,chicc,sonja1,lozinka,mobile1,1vader,ummagumma,waves1,punter12,tubgtn,server1,irina1991,magic69,dak001,pandemonium,dead1,berlingo,cherrypi,1montana,lohotron,chicklet,asdfgh123456,stepside,ikmvw103,icebaby,trillium,1sucks,ukrnet,glock9,ab12345,thepower,robert8,thugstools,hockey13,buffon,livefree,sexpics,dessar,ja0000,rosenrot,james10,1fish,svoloch,mykitty,muffin11,evbukb,shwing,artem1992,andrey1992,sheldon1,passpage,nikita99,fubar123,vannasx,eight888,marial,max2010,express2,violentj,2ykn5ccf,spartan11,brenda69,jackiech,abagail,robin2,grass1,andy76,bell1,taison,superme,vika1995,xtr451,fred20,89032073168,denis1984,2000jeep,weetabix,199020,daxter,tevion,panther8,h9iymxmc,bigrig,kalambur,tsalagi,12213443,racecar02,jeffrey4,nataxa,bigsam,purgator,acuracl,troutbum,potsmoke,jimmyz,manutd1,nytimes,pureevil,bearss,cool22,dragonage,nodnarb,dbrbyu,4seasons,freude,elric1,werule,hockey14,12758698,corkie,yeahright,blademan,tafkap,clave,liziko,hofner,jeffhardy,nurich,runne,stanisla,lucy1,monk3y,forzaroma,eric99,bonaire,blackwoo,fengshui,1qaz0okm,newmoney,pimpin69,07078,anonymer,laptop1,cherry12,ace111,salsa1,wilbur1,doom12,diablo23,jgtxzbhr,under1,honda01,breadfan,megan2,juancarlos,stratus1,ackbar,love5683,happytim,lambert1,cbljhtyrj,komarov,spam69,nfhtkrf,brownn,sarmat,ifiksr,spike69,hoangen,angelz,economia,tanzen,avogadro,1vampire,spanners,mazdarx,queequeg,oriana,hershil,sulaco,joseph11,8seconds,aquariu,cumberla,heather9,anthony8,burton12,crystal0,maria3,qazwsxc,snow123,notgood,198520,raindog,heehaw,consulta,dasein,miller01,cthulhu1,dukenuke,iubire,baytown,hatebree,198505,sistem,lena12,welcome01,maraca,middleto,sindhu,mitsou,phoenix5,vovan,donaldo,dylandog,domovoy,lauren12,byrjuybnj,123llll,stillers,sanchin,tulpan,smallvill,1mmmmm,patti1,folgers,mike31,colts18,123456rrr,njkmrjz,phoenix0,biene,ironcity,kasperok,password22,fitnes,matthew6,spotligh,bujhm123,tommycat,hazel5,guitar11,145678,vfcmrf,compass1,willee,1barney,jack2000,littleminge,shemp,derrek,xxx12345,littlefuck,spuds1,karolinka,camneely,qwertyu123,142500,brandon00,munson15,falcon3,passssap,z3cn2erv,goahead,baggio10,141592,denali1,37kazoo,copernic,123456789asd,orange88,bravada,rush211,197700,pablo123,uptheass,samsam1,demoman,mattylad10,heydude,mister2,werken,13467985,marantz,a22222,f1f2f3f4,fm12mn12,gerasimova,burrito1,sony1,glenny,baldeagle,rmfidd,fenomen,verbati,forgetme,5element,wer138,chanel1,ooicu812,10293847qp,minicooper,chispa,myturn,deisel,vthrehbq,boredboi4u,filatova,anabe,poiuyt1,barmalei,yyyy1,fourkids,naumenko,bangbros,pornclub,okaykk,euclid90,warrior3,kornet,palevo,patatina,gocart,antanta,jed1054,clock1,111111w,dewars,mankind1,peugeot406,liten,tahira,howlin,naumov,rmracing,corone,cunthole,passit,rock69,jaguarxj,bumsen,197101,sweet2,197010,whitecat,sawadee,money100,yfhrjnbrb,andyboy,9085603566,trace1,fagget,robot1,angel20,6yhn7ujm,specialinsta,kareena,newblood,chingada,boobies2,bugger1,squad51,133andre,call06,ashes1,ilovelucy,success2,kotton,cavalla,philou,deebee,theband,nine09,artefact,196100,kkkkkkk1,nikolay9,onelov,basia,emilyann,sadman,fkrjujkbr,teamomuch,david777,padrino,money21,firdaus,orion3,chevy01,albatro,erdfcv,2legit,sarah7,torock,kevinn,holio,soloy,enron714,starfleet,qwer11,neverman,doctorwh,lucy11,dino12,trinity7,seatleon,o123456,pimpman,1asdfgh,snakebit,chancho,prorok,bleacher,ramire,darkseed,warhorse,michael123,1spanky,1hotdog,34erdfcv,n0th1ng,dimanche,repmvbyf,michaeljackson,login1,icequeen,toshiro,sperme,racer2,veget,birthday26,daniel9,lbvekmrf,charlus,bryan123,wspanic,schreibe,1andonly,dgoins,kewell,apollo12,egypt1,fernie,tiger21,aa123456789,blowj,spandau,bisquit,12345678d,deadmau5,fredie,311420,happyface,samant,gruppa,filmstar,andrew17,bakesale,sexy01,justlook,cbarkley,paul11,bloodred,rideme,birdbath,nfkbcvfy,jaxson,sirius1,kristof,virgos,nimrod1,hardc0re,killerbee,1abcdef,pitcher1,justonce,vlada,dakota99,vespucci,wpass,outside1,puertori,rfvbkf,teamlosi,vgfun2,porol777,empire11,20091989q,jasong,webuivalidat,escrima,lakers08,trigger2,addpass,342500,mongini,dfhtybr,horndogg,palermo1,136900,babyblu,alla98,dasha2010,jkelly,kernow,yfnecz,rockhopper,toeman,tlaloc,silver77,dave01,kevinr,1234567887654321,135642,me2you,8096468644q,remmus,spider7,jamesa,jilly,samba1,drongo,770129ji,supercat,juntas,tema1234,esthe,1234567892000,drew11,qazqaz123,beegees,blome,rattrace,howhigh,tallboy,rufus2,sunny2,sou812,miller12,indiana7,irnbru,patch123,letmeon,welcome5,nabisco,9hotpoin,hpvteb,lovinit,stormin,assmonke,trill,atlanti,money1234,cubsfan,mello1,stars2,ueptkm,agate,dannym88,lover123,wordz,worldnet,julemand,chaser1,s12345678,pissword,cinemax,woodchuc,point1,hotchkis,packers2,bananana,kalender,420666,penguin8,awo8rx3wa8t,hoppie,metlife,ilovemyfamily,weihnachtsbau,pudding1,luckystr,scully1,fatboy1,amizade,dedham,jahbless,blaat,surrende,****er,1panties,bigasses,ghjuhfvbcn,asshole123,dfktyrb,likeme,nickers,plastik,hektor,deeman,muchacha,cerebro,santana5,testdrive,dracula1,canalc,l1750sq,savannah1,murena,1inside,pokemon00,1iiiiiii,jordan20,sexual1,mailliw,calipso,014702580369,1zzzzzz,1jjjjjj,break1,15253545,yomama1,katinka,kevin11,1ffffff,martijn,sslazio,daniel5,porno2,nosmas,leolion,jscript,15975312,pundai,kelli1,kkkddd,obafgkm,marmaris,lilmama,london123,rfhfnt,elgordo,talk87,daniel7,thesims3,444111,bishkek,afrika2002,toby22,1speedy,daishi,2children,afroman,qqqqwwww,oldskool,hawai,v55555,syndicat,pukimak,fanatik,tiger5,parker01,bri5kev6,timexx,wartburg,love55,ecosse,yelena03,madinina,highway1,uhfdbwfgf,karuna,buhjvfybz,wallie,46and2,khalif,europ,qaz123wsx456,bobbybob,wolfone,falloutboy,manning18,scuba10,schnuff,ihateyou1,lindam,sara123,popcor,fallengun,divine1,montblanc,qwerty8,rooney10,roadrage,bertie1,latinus,lexusis,rhfvfnjhcr,opelgt,hitme,agatka,1yamaha,dmfxhkju,imaloser,michell1,sb211st,silver22,lockedup,andrew9,monica01,sassycat,dsobwick,tinroof,ctrhtnyj,bultaco,rhfcyjzhcr,aaaassss,14ss88,joanne1,momanddad,ahjkjdf,yelhsa,zipdrive,telescop,500600,1sexsex,facial1,motaro,511647,stoner1,temujin,elephant1,greatman,honey69,kociak,ukqmwhj6,altezza,cumquat,zippos,kontiki,123max,altec1,bibigon,tontos,qazsew,nopasaran,militar,supratt,oglala,kobayash,agathe,yawetag,dogs1,cfiekmrf,megan123,jamesdea,porosenok,tiger23,berger1,hello11,seemann,stunner1,walker2,imissu,jabari,minfd,lollol12,hjvfy,1-oct,stjohns,2278124q,123456789qwer,alex1983,glowworm,chicho,mallards,bluedevil,explorer1,543211,casita,1time,lachesis,alex1982,airborn1,dubesor,changa,lizzie1,captaink,socool,bidule,march23,1861brr,k.ljxrf,watchout,fotze,1brian,keksa2,aaaa1122,matrim,providian,privado,dreame,merry1,aregdone,davidt,nounour,twenty2,play2win,artcast2,zontik,552255,shit1,sluggy,552861,dr8350,brooze,alpha69,thunder6,kamelia2011,caleb123,mmxxmm,jamesh,lfybkjd,125267,125000,124536,bliss1,dddsss,indonesi,bob69,123888,tgkbxfgy,gerar,themack,hijodeputa,good4now,ddd123,clk430,kalash,tolkien1,132forever,blackb,whatis,s1s2s3s4,lolkin09,yamahar,48n25rcc,djtiesto,111222333444555,bigbull,blade55,coolbree,kelse,ichwill,yamaha12,sakic,bebeto,katoom,donke,sahar,wahine,645202,god666,berni,starwood,june15,sonoio,time123,llbean,deadsoul,lazarev,cdtnf,ksyusha,madarchod,technik,jamesy,4speed,tenorsax,legshow,yoshi1,chrisbl,44e3ebda,trafalga,heather7,serafima,favorite4,havefun1,wolve,55555r,james13,nosredna,bodean,jlettier,borracho,mickael,marinus,brutu,sweet666,kiborg,rollrock,jackson6,macross1,ousooner,9085084232,takeme,123qwaszx,firedept,vfrfhjd,jackfros,123456789000,briane,cookie11,baby22,bobby18,gromova,systemofadown,martin01,silver01,pimaou,darthmaul,hijinx,commo,chech,skyman,sunse,2vrd6,vladimirovna,uthvfybz,nicole01,kreker,bobo1,v123456789,erxtgb,meetoo,drakcap,vfvf12,misiek1,butane,network2,flyers99,riogrand,jennyk,e12345,spinne,avalon11,lovejone,studen,maint,porsche2,qwerty100,chamberl,bluedog1,sungam,just4u,andrew23,summer22,ludic,musiclover,aguil,beardog1,libertin,pippo1,joselit,patito,bigberth,digler,sydnee,jockstra,poopo,jas4an,nastya123,profil,fuesse,default1,titan2,mendoz,kpcofgs,anamika,brillo021,bomberman,guitar69,latching,69pussy,blues2,phelge,ninja123,m7n56xo,qwertasd,alex1976,cunningh,estrela,gladbach,marillion,mike2000,258046,bypop,muffinman,kd5396b,zeratul,djkxbwf,john77,sigma2,1linda,selur,reppep,quartz1,teen1,freeclus,spook1,kudos4ever,clitring,sexiness,blumpkin,macbook,tileman,centra,escaflowne,pentable,shant,grappa,zverev,1albert,lommerse,coffee11,777123,polkilo,muppet1,alex74,lkjhgfdsazx,olesica,april14,ba25547,souths,jasmi,arashi,smile2,2401pedro,mybabe,alex111,quintain,pimp1,tdeir8b2,makenna,122333444455555,%e2%82%ac,tootsie1,pass111,zaqxsw123,gkfdfybt,cnfnbcnbrf,usermane,iloveyou12,hard69,osasuna,firegod,arvind,babochka,kiss123,cookie123,julie123,kamakazi,dylan2,223355,tanguy,nbhtqa,tigger13,tubby1,makavel,asdflkj,sambo1,mononoke,mickeys,gayguy,win123,green33,wcrfxtvgbjy,bigsmall,1newlife,clove,babyfac,bigwaves,mama1970,shockwav,1friday,bassey,yarddog,codered1,victory7,bigrick,kracker,gulfstre,chris200,sunbanna,bertuzzi,begemotik,kuolema,pondus,destinee,123456789zz,abiodun,flopsy,amadeusptfcor,geronim,yggdrasi,contex,daniel6,suck1,adonis1,moorea,el345612,f22raptor,moviebuf,raunchy,6043dkf,zxcvbnm123456789,eric11,deadmoin,ratiug,nosliw,fannies,danno,888889,blank1,mikey2,gullit,thor99,mamiya,ollieb,thoth,dagger1,websolutionssu,bonker,prive,1346798520,03038,q1234q,mommy2,contax,zhipo,gwendoli,gothic1,1234562000,lovedick,gibso,digital2,space199,b26354,987654123,golive,serious1,pivkoo,better1,824358553,794613258,nata1980,logout,fishpond,buttss,squidly,good4me,redsox19,jhonny,zse45rdx,matrixxx,honey12,ramina,213546879,motzart,fall99,newspape,killit,gimpy,photowiz,olesja,thebus,marco123,147852963,bedbug,147369258,hellbound,gjgjxrf,123987456,lovehurt,five55,hammer01,1234554321a,alina2011,peppino,ang238,questor,112358132,alina1994,alina1998,money77,bobjones,aigerim,cressida,madalena,420smoke,tinchair,raven13,mooser,mauric,lovebu,adidas69,krypton1,1111112,loveline,divin,voshod,michaelm,cocotte,gbkbuhbv,76689295,kellyj,rhonda1,sweetu70,steamforums,geeque,nothere,124c41,quixotic,steam181,1169900,rfcgthcrbq,rfvbkm,sexstuff,1231230,djctvm,rockstar1,fulhamfc,bhecbr,rfntyf,quiksilv,56836803,jedimaster,pangit,gfhjkm777,tocool,1237654,stella12,55378008,19216811,potte,fender12,mortalkombat,ball1,nudegirl,palace22,rattrap,debeers,lickpussy,jimmy6,not4u2c,wert12,bigjuggs,sadomaso,1357924,312mas,laser123,arminia,branford,coastie,mrmojo,19801982,scott11,banaan123,ingres,300zxtt,hooters6,sweeties,19821983,19831985,19833891,sinnfein,welcome4,winner69,killerman,tachyon,tigre1,nymets1,kangol,martinet,sooty1,19921993,789qwe,harsingh,1597535,thecount,phantom3,36985214,lukas123,117711,pakistan1,madmax11,willow01,19932916,fucker12,flhrci,opelagila,theword,ashley24,tigger3,crazyj,rapide,deadfish,allana,31359092,sasha1993,sanders2,discman,zaq!2wsx,boilerma,mickey69,jamesg,babybo,jackson9,orion7,alina2010,indien,breeze1,atease,warspite,bazongaz,1celtic,asguard,mygal,fitzgera,1secret,duke33,cyklone,dipascuc,potapov,1escobar2,c0l0rad0,kki177hk,1little,macondo,victoriya,peter7,red666,winston6,kl?benhavn,muneca,jackme,jennan,happylife,am4h39d8nh,bodybuil,201980,dutchie,biggame,lapo4ka,rauchen,black10,flaquit,water12,31021364,command2,lainth88,mazdamx5,typhon,colin123,rcfhlfc,qwaszx11,g0away,ramir,diesirae,hacked1,cessna1,woodfish,enigma2,pqnr67w5,odgez8j3,grisou,hiheels,5gtgiaxm,2580258,ohotnik,transits,quackers,serjik,makenzie,mdmgatew,bryana,superman12,melly,lokit,thegod,slickone,fun4all,netpass,penhorse,1cooper,nsync,asdasd22,otherside,honeydog,herbie1,chiphi,proghouse,l0nd0n,shagg,select1,frost1996,casper123,countr,magichat,greatzyo,jyothi,3bears,thefly,nikkita,fgjcnjk,nitros,hornys,san123,lightspe,maslova,kimber1,newyork2,spammm,mikejone,pumpk1n,bruiser1,bacons,prelude9,boodie,dragon4,kenneth2,love98,power5,yodude,pumba,thinline,blue30,sexxybj,2dumb2live,matt21,forsale,1carolin,innova,ilikeporn,rbgtkjd,a1s2d3f,wu9942,ruffus,blackboo,qwerty999,draco1,marcelin,hideki,gendalf,trevon,saraha,cartmen,yjhbkmcr,time2go,fanclub,ladder1,chinni,6942987,united99,lindac,quadra,paolit,mainstre,beano002,lincoln7,bellend,anomie,8520456,bangalor,goodstuff,chernov,stepashka,gulla,mike007,frasse,harley03,omnislash,8538622,maryjan,sasha2011,gineok,8807031,hornier,gopinath,princesit,bdr529,godown,bosslady,hakaone,1qwe2,madman1,joshua11,lovegame,bayamon,jedi01,stupid12,sport123,aaa666,tony44,collect1,charliem,chimaira,cx18ka,trrim777,chuckd,thedream,redsox99,goodmorning,delta88,iloveyou11,newlife2,figvam,chicago3,jasonk,12qwer,9875321,lestat1,satcom,conditio,capri50,sayaka,9933162,trunks1,chinga,snooch,alexand1,findus,poekie,cfdbyf,kevind,mike1969,fire13,leftie,bigtuna,chinnu,silence1,celos1,blackdra,alex24,gfgfif,2boobs,happy8,enolagay,sataniv1993,turner1,dylans,peugeo,sasha1994,hoppel,conno,moonshot,santa234,meister1,008800,hanako,tree123,qweras,gfitymrf,reggie31,august29,supert,joshua10,akademia,gbljhfc,zorro123,nathalia,redsox12,hfpdjl,mishmash,nokiae51,nyyankees,tu190022,strongbo,none1,not4u2no,katie2,popart,harlequi,santan,michal1,1therock,screwu,csyekmrf,olemiss1,tyrese,hoople,sunshin1,cucina,starbase,topshelf,fostex,california1,castle1,symantec,pippolo,babare,turntabl,1angela,moo123,ipvteb,gogolf,alex88,cycle1,maxie1,phase2,selhurst,furnitur,samfox,fromvermine,shaq34,gators96,captain2,delonge,tomatoe,bisous,zxcvbnma,glacius,pineapple1,cannelle,ganibal,mko09ijn,paraklast1974,hobbes12,petty43,artema,junior8,mylover,1234567890d,fatal1ty,prostreet,peruan,10020,nadya,caution1,marocas,chanel5,summer08,metal123,111lox,scrapy,thatguy,eddie666,washingto,yannis,minnesota_hp,lucky4,playboy6,naumova,azzurro,patat,dale33,pa55wd,speedster,zemanova,saraht,newto,tony22,qscesz,arkady,1oliver,death6,vkfwx046,antiflag,stangs,jzf7qf2e,brianp,fozzy,cody123,startrek1,yoda123,murciela,trabajo,lvbnhbtdf,canario,fliper,adroit,henry5,goducks,papirus,alskdj,soccer6,88mike,gogetter,tanelorn,donking,marky1,leedsu,badmofo,al1916,wetdog,akmaral,pallet,april24,killer00,nesterova,rugby123,coffee12,browseui,ralliart,paigow,calgary1,armyman,vtldtltd,frodo2,frxtgb,iambigal,benno,jaytee,2hot4you,askar,bigtee,brentwoo,palladin,eddie2,al1916w,horosho,entrada,ilovetits,venture1,dragon19,jayde,chuvak,jamesl,fzr600,brandon8,vjqvbh,snowbal,snatch1,bg6njokf,pudder,karolin,candoo,pfuflrf,satchel1,manteca,khongbiet,critter1,partridg,skyclad,bigdon,ginger69,brave1,anthony4,spinnake,chinadol,passout,cochino,nipples1,15058,lopesk,sixflags,lloo999,parkhead,breakdance,cia123,fidodido,yuitre12,fooey,artem1995,gayathri,medin,nondriversig,l12345,bravo7,happy13,kazuya,camster,alex1998,luckyy,zipcode,dizzle,boating1,opusone,newpassw,movies23,kamikazi,zapato,bart316,cowboys0,corsair1,kingshit,hotdog12,rolyat,h200svrm,qwerty4,boofer,rhtyltkm,chris999,vaz21074,simferopol,pitboss,love3,britania,tanyshka,brause,123qwerty123,abeille,moscow1,ilkaev,manut,process1,inetcfg,dragon05,fortknox,castill,rynner,mrmike,koalas,jeebus,stockpor,longman,juanpabl,caiman,roleplay,jeremi,26058,prodojo,002200,magical1,black5,bvlgari,doogie1,cbhtqa,mahina,a1s2d3f4g5h6,jblpro,usmc01,bismilah,guitar01,april9,santana1,1234aa,monkey14,sorokin,evan1,doohan,animalsex,pfqxtyjr,dimitry,catchme,chello,silverch,glock45,dogleg,litespee,nirvana9,peyton18,alydar,warhamer,iluvme,sig229,minotavr,lobzik,jack23,bushwack,onlin,football123,joshua5,federov,winter2,bigmax,fufnfrhbcnb,hfpldfnhb,1dakota,f56307,chipmonk,4nick8,praline,vbhjh123,king11,22tango,gemini12,street1,77879,doodlebu,homyak,165432,chuluthu,trixi,karlito,salom,reisen,cdtnkzxjr,pookie11,tremendo,shazaam,welcome0,00000ty,peewee51,pizzle,gilead,bydand,sarvar,upskirt,legends1,freeway1,teenfuck,ranger9,darkfire,dfymrf,hunt0802,justme1,buffy1ma,1harry,671fsa75yt,burrfoot,budster,pa437tu,jimmyp,alina2006,malacon,charlize,elway1,free12,summer02,gadina,manara,gomer1,1cassie,sanja,kisulya,money3,pujols,ford50,midiland,turga,orange6,demetriu,freakboy,orosie1,radio123,open12,vfufpby,mustek,chris33,animes,meiling,nthtvjr,jasmine9,gfdkjd,oligarh,marimar,chicago9,.kzirf,bugssgub,samuraix,jackie01,pimpjuic,macdad,cagiva,vernost,willyboy,fynjyjdf,tabby1,privet123,torres9,retype,blueroom,raven11,q12we3,alex1989,bringiton,ridered,kareltje,ow8jtcs8t,ciccia,goniners,countryb,24688642,covingto,24861793,beyblade,vikin,badboyz,wlafiga,walstib,mirand,needajob,chloes,balaton,kbpfdtnf,freyja,bond9007,gabriel12,stormbri,hollage,love4eve,fenomeno,darknite,dragstar,kyle123,milfhunter,ma123123123,samia,ghislain,enrique1,ferien12,xjy6721,natalie2,reglisse,wilson2,wesker,rosebud7,amazon1,robertr,roykeane,xtcnth,mamatata,crazyc,mikie,savanah,blowjob69,jackie2,forty1,1coffee,fhbyjxrf,bubbah,goteam,hackedit,risky1,logoff,h397pnvr,buck13,robert23,bronc,st123st,godflesh,pornog,iamking,cisco69,septiembr,dale38,zhongguo,tibbar,panther9,buffa1,bigjohn1,mypuppy,vehvfycr,april16,shippo,fire1234,green15,q123123,gungadin,steveg,olivier1,chinaski,magnoli,faithy,storm12,toadfrog,paul99,78791,august20,automati,squirtle,cheezy,positano,burbon,nunya,llebpmac,kimmi,turtle2,alan123,prokuror,violin1,durex,pussygal,visionar,trick1,chicken6,29024,plowboy,rfybreks,imbue,sasha13,wagner1,vitalogy,cfymrf,thepro,26028,gorbunov,dvdcom,letmein5,duder,fastfun,pronin,libra1,conner1,harley20,stinker1,20068,20038,amitech,syoung,dugway,18068,welcome7,jimmypag,anastaci,kafka1,pfhfnecnhf,catsss,campus100,shamal,nacho1,fire12,vikings2,brasil1,rangerover,mohamma,peresvet,14058,cocomo,aliona,14038,qwaser,vikes,cbkmdf,skyblue1,ou81234,goodlove,dfkmltvfh,108888,roamer,pinky2,static1,zxcv4321,barmen,rock22,shelby2,morgans,1junior,pasword1,logjam,fifty5,nhfrnjhbcn,chaddy,philli,nemesis2,ingenier,djkrjd,ranger3,aikman8,knothead,daddy69,love007,vsythb,ford350,tiger00,renrut,owen11,energy12,march14,alena123,robert19,carisma,orange22,murphy11,podarok,prozak,kfgeirf,wolf13,lydia1,shazza,parasha,akimov,tobbie,pilote,heather4,baster,leones,gznfxjr,megama,987654321g,bullgod,boxster1,minkey,wombats,vergil,colegiata,lincol,smoothe,pride1,carwash1,latrell,bowling3,fylhtq123,pickwick,eider,bubblebox,bunnies1,loquit,slipper1,nutsac,purina,xtutdfhf,plokiju,1qazxs,uhjpysq,zxcvbasdfg,enjoy1,1pumpkin,phantom7,mama22,swordsma,wonderbr,dogdays,milker,u23456,silvan,dfkthbr,slagelse,yeahman,twothree,boston11,wolf100,dannyg,troll1,fynjy123,ghbcnfd,bftest,ballsdeep,bobbyorr,alphasig,cccdemo,fire123,norwest,claire2,august10,lth1108,problemas,sapito,alex06,1rusty,maccom,goirish1,ohyes,bxdumb,nabila,boobear1,rabbit69,princip,alexsander,travail,chantal1,dogggy,greenpea,diablo69,alex2009,bergen09,petticoa,classe,ceilidh,vlad2011,kamakiri,lucidity,qaz321,chileno,cexfhf,99ranger,mcitra,estoppel,volvos60,carter80,webpass,temp12,touareg,fcgbhby,bubba8,sunitha,200190ru,bitch2,shadow23,iluvit,nicole0,ruben1,nikki69,butttt,shocker1,souschef,lopotok01,kantot,corsano,cfnfyf,riverat,makalu,swapna,all4u9,cdtnkfy,ntktgepbr,ronaldo99,thomasj,bmw540i,chrisw,boomba,open321,z1x2c3v4b5n6m7,gaviota,iceman44,frosya,chris100,chris24,cosette,clearwat,micael,boogyman,pussy9,camus1,chumpy,heccrbq,konoplya,chester8,scooter5,ghjgfufylf,giotto,koolkat,zero000,bonita1,ckflrbq,j1964,mandog,18n28n24a,renob,head1,shergar,ringo123,tanita,sex4free,johnny12,halberd,reddevils,biolog,dillinge,fatb0y,c00per,hyperlit,wallace2,spears1,vitamine,buheirf,sloboda,alkash,mooman,marion1,arsenal7,sunder,nokia5610,edifier,pippone,fyfnjkmtdbx,fujimo,pepsi12,kulikova,bolat,duetto,daimon,maddog01,timoshka,ezmoney,desdemon,chesters,aiden,hugues,patrick5,aikman08,robert4,roenick,nyranger,writer1,36169544,foxmulder,118801,kutter,shashank,jamjar,118811,119955,aspirina,dinkus,1sailor,nalgene,19891959,snarf,allie1,cracky,resipsa,45678912,kemerovo,19841989,netware1,alhimik,19801984,nicole123,19761977,51501984,malaka1,montella,peachfuz,jethro1,cypress1,henkie,holdon,esmith,55443322,1friend,quique,bandicoot,statistika,great123,death13,ucht36,master4,67899876,bobsmith,nikko1,jr1234,hillary1,78978978,rsturbo,lzlzdfcz,bloodlust,shadow00,skagen,bambina,yummies,88887777,91328378,matthew4,itdoes,98256518,102938475,alina2002,123123789,fubared,dannys,123456321,nikifor,suck69,newmexico,scubaman,rhbcnb,fifnfy,puffdadd,159357852,dtheyxbr,theman22,212009164,prohor,shirle,nji90okm,newmedia,goose5,roma1995,letssee,iceman11,aksana,wirenut,pimpdady,1212312121,tamplier,pelican1,domodedovo,1928374655,fiction6,duckpond,ybrecz,thwack,onetwo34,gunsmith,murphydo,fallout1,spectre1,jabberwo,jgjesq,turbo6,bobo12,redryder,blackpus,elena1971,danilova,antoin,bobo1234,bobob,bobbobbo,dean1,222222a,jesusgod,matt23,musical1,darkmage,loppol,werrew,josepha,rebel12,toshka,gadfly,hawkwood,alina12,dnomyar,sexaddict,dangit,cool23,yocrack,archimed,farouk,nhfkzkz,lindalou,111zzzzz,ghjatccjh,wethepeople,m123456789,wowsers,kbkbxrf,bulldog5,m_roesel,sissinit,yamoon6,123ewqasd,dangel,miruvor79,kaytee,falcon7,bandit11,dotnet,dannii,arsenal9,miatamx5,1trouble,strip4me,dogpile,sexyred1,rjdfktdf,google10,shortman,crystal7,awesome123,cowdog,haruka,birthday28,jitter,diabolik,boomer12,dknight,bluewate,hockey123,crm0624,blueboys,willy123,jumpup,google2,cobra777,llabesab,vicelord,hopper1,gerryber,remmah,j10e5d4,qqqqqqw,agusti,fre_ak8yj,nahlik,redrobin,scott3,epson1,dumpy,bundao,aniolek,hola123,jergens,itsasecret,maxsam,bluelight,mountai1,bongwater,1london,pepper14,freeuse,dereks,qweqw,fordgt40,rfhfdfy,raider12,hunnybun,compac,splicer,megamon,tuffgong,gymnast1,butter11,modaddy,wapbbs_1,dandelio,soccer77,ghjnbdjcnjzybt,123xyi2,fishead,x002tp00,whodaman,555aaa,oussama,brunodog,technici,pmtgjnbl,qcxdw8ry,schweden,redsox3,throbber,collecto,japan10,dbm123dm,hellhoun,tech1,deadzone,kahlan,wolf123,dethklok,xzsawq,bigguy1,cybrthc,chandle,buck01,qq123123,secreta,williams1,c32649135,delta12,flash33,123joker,spacejam,polopo,holycrap,daman1,tummybed,financia,nusrat,euroline,magicone,jimkirk,ameritec,daniel26,sevenn,topazz,kingpins,dima1991,macdog,spencer5,oi812,geoffre,music11,baffle,123569,usagi,cassiope,polla,lilcrowe,thecakeisalie,vbhjndjhtw,vthokies,oldmans,sophie01,ghoster,penny2,129834,locutus1,meesha,magik,jerry69,daddysgirl,irondesk,andrey12,jasmine123,vepsrfyn,likesdick,1accord,jetboat,grafix,tomuch,showit,protozoa,mosias98,taburetka,blaze420,esenin,anal69,zhv84kv,puissant,charles0,aishwarya,babylon6,bitter1,lenina,raleigh1,lechat,access01,kamilka,fynjy,sparkplu,daisy3112,choppe,zootsuit,1234567j,rubyrose,gorilla9,nightshade,alternativa,cghfdjxybr,snuggles1,10121v,vova1992,leonardo1,dave2,matthewd,vfhfnbr,1986mets,nobull,bacall,mexican1,juanjo,mafia1,boomer22,soylent,edwards1,jordan10,blackwid,alex86,gemini13,lunar2,dctvcjcfnm,malaki,plugger,eagles11,snafu2,1shelly,cintaku,hannah22,tbird1,maks5843,irish88,homer22,amarok,fktrcfylhjdf,lincoln2,acess,gre69kik,need4speed,hightech,core2duo,blunt1,ublhjgjybrf,dragon33,1autopas,autopas1,wwww1,15935746,daniel20,2500aa,massim,1ggggggg,96ford,hardcor1,cobra5,blackdragon,vovan_lt,orochimaru,hjlbntkb,qwertyuiop12,tallen,paradoks,frozenfish,ghjuhfvvbcn,gerri1,nuggett,camilit,doright,trans1,serena1,catch2,bkmyeh,fireston,afhvfwtdn,purple3,figure8,fuckya,scamp1,laranja,ontheoutside,louis123,yellow7,moonwalk,mercury2,tolkein,raide,amenra,a13579,dranreb,5150vh,harish,tracksta,sexking,ozzmosis,katiee,alomar,matrix19,headroom,jahlove,ringding,apollo8,132546,132613,12345672000,saretta,135798,136666,thomas7,136913,onetwothree,hockey33,calida,nefertit,bitwise,tailhook,boop4,kfgecbr,bujhmbujhm,metal69,thedark,meteoro,felicia1,house12,tinuviel,istina,vaz2105,pimp13,toolfan,nina1,tuesday2,maxmotives,lgkp500,locksley,treech,darling1,kurama,aminka,ramin,redhed,dazzler,jager1,stpiliot,cardman,rfvtym,cheeser,14314314,paramoun,samcat,plumpy,stiffie,vsajyjr,panatha,qqq777,car12345,098poi,asdzx,keegan1,furelise,kalifornia,vbhjckfd,beast123,zcfvfzkexifz,harry5,1birdie,96328i,escola,extra330,henry12,gfhfyjqz,14u2nv,max1234,templar1,1dave,02588520,catrin,pangolin,marhaba,latin1,amorcito,dave22,escape1,advance1,yasuhiro,grepw,meetme,orange01,ernes,erdna,zsergn,nautica1,justinb,soundwav,miasma,greg78,nadine1,sexmad,lovebaby,promo1,excel1,babys,dragonma,camry1,sonnenschein,farooq,wazzkaprivet,magal,katinas,elvis99,redsox24,rooney1,chiefy,peggys,aliev,pilsung,mudhen,dontdoit,dennis12,supercal,energia,ballsout,funone,claudiu,brown2,amoco,dabl1125,philos,gjdtkbntkm,servette,13571113,whizzer,nollie,13467982,upiter,12string,bluejay1,silkie,william4,kosta1,143333,connor12,sustanon,06068,corporat,ssnake,laurita,king10,tahoes,arsenal123,sapato,charless,jeanmarc,levent,algerie,marine21,jettas,winsome,dctvgbplf,1701ab,xxxp455w0rd5,lllllll1,ooooooo1,monalis,koufax32,anastasya,debugger,sarita2,jason69,ufkxjyjr,gjlcnfdf,1jerry,daniel10,balinor,sexkitten,death2,qwertasdfgzxcvb,s9te949f,vegeta1,sysman,maxxam,dimabilan,mooose,ilovetit,june23,illest,doesit,mamou,abby12,longjump,transalp,moderato,littleguy,magritte,dilnoza,hawaiiguy,winbig,nemiroff,kokaine,admira,myemail,dream2,browneyes,destiny7,dragonss,suckme1,asa123,andranik,suckem,fleshbot,dandie,timmys,scitra,timdog,hasbeen,guesss,smellyfe,arachne,deutschl,harley88,birthday27,nobody1,papasmur,home1,jonass,bunia3,epatb1,embalm,vfvekmrf,apacer,12345656,estreet,weihnachtsbaum,mrwhite,admin12,kristie1,kelebek,yoda69,socken,tima123,bayern1,fktrcfylth,tamiya,99strenght,andy01,denis2011,19delta,stokecit,aotearoa,stalker2,nicnac,conrad1,popey,agusta,bowl36,1bigfish,mossyoak,1stunner,getinnow,jessejames,gkfnjy,drako,1nissan,egor123,hotness,1hawaii,zxc123456,cantstop,1peaches,madlen,west1234,jeter1,markis,judit,attack1,artemi,silver69,153246,crazy2,green9,yoshimi,1vette,chief123,jasper2,1sierra,twentyon,drstrang,aspirant,yannic,jenna123,bongtoke,slurpy,1sugar,civic97,rusty21,shineon,james19,anna12345,wonderwoman,1kevin,karol1,kanabis,wert21,fktif6115,evil1,kakaha,54gv768,826248s,tyrone1,1winston,sugar2,falcon01,adelya,mopar440,zasxcd,leecher,kinkysex,mercede1,travka,11234567,rebon,geekboy".split(","),
  english_wikipedia: "the,of,and,in,was,is,for,as,on,with,by,he,at,from,his,an,were,are,which,doc,https,also,or,has,had,first,one,their,its,after,new,who,they,two,her,she,been,other,when,time,during,there,into,school,more,may,years,over,only,year,most,would,world,city,some,where,between,later,three,state,such,then,national,used,made,known,under,many,university,united,while,part,season,team,these,american,than,film,second,born,south,became,states,war,through,being,including,both,before,north,high,however,people,family,early,history,album,area,them,series,against,until,since,district,county,name,work,life,group,music,following,number,company,several,four,called,played,released,career,league,game,government,house,each,based,day,same,won,use,station,club,international,town,located,population,general,college,east,found,age,march,end,september,began,home,public,church,line,june,river,member,system,place,century,band,july,york,january,october,song,august,best,former,british,party,named,held,village,show,local,november,took,service,december,built,another,major,within,along,members,five,single,due,although,small,old,left,final,large,include,building,served,president,received,games,death,february,main,third,set,children,own,order,species,park,law,air,published,road,died,book,men,women,army,often,according,education,central,country,division,english,top,included,development,french,community,among,water,play,side,list,times,near,late,form,original,different,center,power,led,students,german,moved,court,six,land,council,island,u.s.,record,million,research,art,established,award,street,military,television,given,region,support,western,production,non,political,point,cup,period,business,title,started,various,election,using,england,role,produced,become,program,works,field,total,office,class,written,association,radio,union,level,championship,director,few,force,created,department,founded,services,married,though,per,n't,site,open,act,short,society,version,royal,present,northern,worked,professional,full,returned,joined,story,france,european,currently,language,social,california,india,days,design,st.,further,round,australia,wrote,san,project,control,southern,railway,board,popular,continued,free,battle,considered,video,common,position,living,half,playing,recorded,red,post,described,average,records,special,modern,appeared,announced,areas,rock,release,elected,others,example,term,opened,similar,formed,route,census,current,schools,originally,lake,developed,race,himself,forces,addition,information,upon,province,match,event,songs,result,events,win,eastern,track,lead,teams,science,human,construction,minister,germany,awards,available,throughout,training,style,body,museum,australian,health,seven,signed,chief,eventually,appointed,sea,centre,debut,tour,points,media,light,range,character,across,features,families,largest,indian,network,less,performance,players,refer,europe,sold,festival,usually,taken,despite,designed,committee,process,return,official,episode,institute,stage,followed,performed,japanese,personal,thus,arts,space,low,months,includes,china,study,middle,magazine,leading,japan,groups,aircraft,featured,federal,civil,rights,model,coach,canadian,books,remained,eight,type,independent,completed,capital,academy,instead,kingdom,organization,countries,studies,competition,sports,size,above,section,finished,gold,involved,reported,management,systems,industry,directed,market,fourth,movement,technology,bank,ground,campaign,base,lower,sent,rather,added,provided,coast,grand,historic,valley,conference,bridge,winning,approximately,films,chinese,awarded,degree,russian,shows,native,female,replaced,municipality,square,studio,medical,data,african,successful,mid,bay,attack,previous,operations,spanish,theatre,student,republic,beginning,provide,ship,primary,owned,writing,tournament,culture,introduced,texas,related,natural,parts,governor,reached,ireland,units,senior,decided,italian,whose,higher,africa,standard,income,professor,placed,regional,los,buildings,championships,active,novel,energy,generally,interest,via,economic,previously,stated,itself,channel,below,operation,leader,traditional,trade,structure,limited,runs,prior,regular,famous,saint,navy,foreign,listed,artist,catholic,airport,results,parliament,collection,unit,officer,goal,attended,command,staff,commission,lived,location,plays,commercial,places,foundation,significant,older,medal,self,scored,companies,highway,activities,programs,wide,musical,notable,library,numerous,paris,towards,individual,allowed,plant,property,annual,contract,whom,highest,initially,required,earlier,assembly,artists,rural,seat,practice,defeated,ended,soviet,length,spent,manager,press,associated,author,issues,additional,characters,lord,zealand,policy,engine,township,noted,historical,complete,financial,religious,mission,contains,nine,recent,represented,pennsylvania,administration,opening,secretary,lines,report,executive,youth,closed,theory,writer,italy,angeles,appearance,feature,queen,launched,legal,terms,entered,issue,edition,singer,greek,majority,background,source,anti,cultural,complex,changes,recording,stadium,islands,operated,particularly,basketball,month,uses,port,castle,mostly,names,fort,selected,increased,status,earth,subsequently,pacific,cover,variety,certain,goals,remains,upper,congress,becoming,studied,irish,nature,particular,loss,caused,chart,dr.,forced,create,era,retired,material,review,rate,singles,referred,larger,individuals,shown,provides,products,speed,democratic,poland,parish,olympics,cities,themselves,temple,wing,genus,households,serving,cost,wales,stations,passed,supported,view,cases,forms,actor,male,matches,males,stars,tracks,females,administrative,median,effect,biography,train,engineering,camp,offered,chairman,houses,mainly,19th,surface,therefore,nearly,score,ancient,subject,prime,seasons,claimed,experience,specific,jewish,failed,overall,believed,plot,troops,greater,spain,consists,broadcast,heavy,increase,raised,separate,campus,1980s,appears,presented,lies,composed,recently,influence,fifth,nations,creek,references,elections,britain,double,cast,meaning,earned,carried,producer,latter,housing,brothers,attempt,article,response,border,remaining,nearby,direct,ships,value,workers,politician,academic,label,1970s,commander,rule,fellow,residents,authority,editor,transport,dutch,projects,responsible,covered,territory,flight,races,defense,tower,emperor,albums,facilities,daily,stories,assistant,managed,primarily,quality,function,proposed,distribution,conditions,prize,journal,code,vice,newspaper,corps,highly,constructed,mayor,critical,secondary,corporation,rugby,regiment,ohio,appearances,serve,allow,nation,multiple,discovered,directly,scene,levels,growth,elements,acquired,1990s,officers,physical,20th,latin,host,jersey,graduated,arrived,issued,literature,metal,estate,vote,immediately,quickly,asian,competed,extended,produce,urban,1960s,promoted,contemporary,global,formerly,appear,industrial,types,opera,ministry,soldiers,commonly,mass,formation,smaller,typically,drama,shortly,density,senate,effects,iran,polish,prominent,naval,settlement,divided,basis,republican,languages,distance,treatment,continue,product,mile,sources,footballer,format,clubs,leadership,initial,offers,operating,avenue,officially,columbia,grade,squadron,fleet,percent,farm,leaders,agreement,likely,equipment,website,mount,grew,method,transferred,intended,renamed,iron,asia,reserve,capacity,politics,widely,activity,advanced,relations,scottish,dedicated,crew,founder,episodes,lack,amount,build,efforts,concept,follows,ordered,leaves,positive,economy,entertainment,affairs,memorial,ability,illinois,communities,color,text,railroad,scientific,focus,comedy,serves,exchange,environment,cars,direction,organized,firm,description,agency,analysis,purpose,destroyed,reception,planned,revealed,infantry,architecture,growing,featuring,household,candidate,removed,situated,models,knowledge,solo,technical,organizations,assigned,conducted,participated,largely,purchased,register,gained,combined,headquarters,adopted,potential,protection,scale,approach,spread,independence,mountains,titled,geography,applied,safety,mixed,accepted,continues,captured,rail,defeat,principal,recognized,lieutenant,mentioned,semi,owner,joint,liberal,actress,traffic,creation,basic,notes,unique,supreme,declared,simply,plants,sales,massachusetts,designated,parties,jazz,compared,becomes,resources,titles,concert,learning,remain,teaching,versions,content,alongside,revolution,sons,block,premier,impact,champions,districts,generation,estimated,volume,image,sites,account,roles,sport,quarter,providing,zone,yard,scoring,classes,presence,performances,representatives,hosted,split,taught,origin,olympic,claims,critics,facility,occurred,suffered,municipal,damage,defined,resulted,respectively,expanded,platform,draft,opposition,expected,educational,ontario,climate,reports,atlantic,surrounding,performing,reduced,ranked,allows,birth,nominated,younger,newly,kong,positions,theater,philadelphia,heritage,finals,disease,sixth,laws,reviews,constitution,tradition,swedish,theme,fiction,rome,medicine,trains,resulting,existing,deputy,environmental,labour,classical,develop,fans,granted,receive,alternative,begins,nuclear,fame,buried,connected,identified,palace,falls,letters,combat,sciences,effort,villages,inspired,regions,towns,conservative,chosen,animals,labor,attacks,materials,yards,steel,representative,orchestra,peak,entitled,officials,returning,reference,northwest,imperial,convention,examples,ocean,publication,painting,subsequent,frequently,religion,brigade,fully,sides,acts,cemetery,relatively,oldest,suggested,succeeded,achieved,application,programme,cells,votes,promotion,graduate,armed,supply,flying,communist,figures,literary,netherlands,korea,worldwide,citizens,1950s,faculty,draw,stock,seats,occupied,methods,unknown,articles,claim,holds,authorities,audience,sweden,interview,obtained,covers,settled,transfer,marked,allowing,funding,challenge,southeast,unlike,crown,rise,portion,transportation,sector,phase,properties,edge,tropical,standards,institutions,philosophy,legislative,hills,brand,fund,conflict,unable,founding,refused,attempts,metres,permanent,starring,applications,creating,effective,aired,extensive,employed,enemy,expansion,billboard,rank,battalion,multi,vehicle,fought,alliance,category,perform,federation,poetry,bronze,bands,entry,vehicles,bureau,maximum,billion,trees,intelligence,greatest,screen,refers,commissioned,gallery,injury,confirmed,setting,treaty,adult,americans,broadcasting,supporting,pilot,mobile,writers,programming,existence,squad,minnesota,copies,korean,provincial,sets,defence,offices,agricultural,internal,core,northeast,retirement,factory,actions,prevent,communications,ending,weekly,containing,functions,attempted,interior,weight,bowl,recognition,incorporated,increasing,ultimately,documentary,derived,attacked,lyrics,mexican,external,churches,centuries,metropolitan,selling,opposed,personnel,mill,visited,presidential,roads,pieces,norwegian,controlled,18th,rear,influenced,wrestling,weapons,launch,composer,locations,developing,circuit,specifically,studios,shared,canal,wisconsin,publishing,approved,domestic,consisted,determined,comic,establishment,exhibition,southwest,fuel,electronic,cape,converted,educated,melbourne,hits,wins,producing,norway,slightly,occur,surname,identity,represent,constituency,funds,proved,links,structures,athletic,birds,contest,users,poet,institution,display,receiving,rare,contained,guns,motion,piano,temperature,publications,passenger,contributed,toward,cathedral,inhabitants,architect,exist,athletics,muslim,courses,abandoned,signal,successfully,disambiguation,tennessee,dynasty,heavily,maryland,jews,representing,budget,weather,missouri,introduction,faced,pair,chapel,reform,height,vietnam,occurs,motor,cambridge,lands,focused,sought,patients,shape,invasion,chemical,importance,communication,selection,regarding,homes,voivodeship,maintained,borough,failure,aged,passing,agriculture,oregon,teachers,flow,philippines,trail,seventh,portuguese,resistance,reaching,negative,fashion,scheduled,downtown,universities,trained,skills,scenes,views,notably,typical,incident,candidates,engines,decades,composition,commune,chain,inc.,austria,sale,values,employees,chamber,regarded,winners,registered,task,investment,colonial,swiss,user,entirely,flag,stores,closely,entrance,laid,journalist,coal,equal,causes,turkish,quebec,techniques,promote,junction,easily,dates,kentucky,singapore,residence,violence,advance,survey,humans,expressed,passes,streets,distinguished,qualified,folk,establish,egypt,artillery,visual,improved,actual,finishing,medium,protein,switzerland,productions,operate,poverty,neighborhood,organisation,consisting,consecutive,sections,partnership,extension,reaction,factor,costs,bodies,device,ethnic,racial,flat,objects,chapter,improve,musicians,courts,controversy,membership,merged,wars,expedition,interests,arab,comics,gain,describes,mining,bachelor,crisis,joining,decade,1930s,distributed,habitat,routes,arena,cycle,divisions,briefly,vocals,directors,degrees,object,recordings,installed,adjacent,demand,voted,causing,businesses,ruled,grounds,starred,drawn,opposite,stands,formal,operates,persons,counties,compete,wave,israeli,ncaa,resigned,brief,greece,combination,demographics,historian,contain,commonwealth,musician,collected,argued,louisiana,session,cabinet,parliamentary,electoral,loan,profit,regularly,conservation,islamic,purchase,17th,charts,residential,earliest,designs,paintings,survived,moth,items,goods,grey,anniversary,criticism,images,discovery,observed,underground,progress,additionally,participate,thousands,reduce,elementary,owners,stating,iraq,resolution,capture,tank,rooms,hollywood,finance,queensland,reign,maintain,iowa,landing,broad,outstanding,circle,path,manufacturing,assistance,sequence,gmina,crossing,leads,universal,shaped,kings,attached,medieval,ages,metro,colony,affected,scholars,oklahoma,coastal,soundtrack,painted,attend,definition,meanwhile,purposes,trophy,require,marketing,popularity,cable,mathematics,mississippi,represents,scheme,appeal,distinct,factors,acid,subjects,roughly,terminal,economics,senator,diocese,prix,contrast,argentina,czech,wings,relief,stages,duties,16th,novels,accused,whilst,equivalent,charged,measure,documents,couples,request,danish,defensive,guide,devices,statistics,credited,tries,passengers,allied,frame,puerto,peninsula,concluded,instruments,wounded,differences,associate,forests,afterwards,replace,requirements,aviation,solution,offensive,ownership,inner,legislation,hungarian,contributions,actors,translated,denmark,steam,depending,aspects,assumed,injured,severe,admitted,determine,shore,technique,arrival,measures,translation,debuted,delivered,returns,rejected,separated,visitors,damaged,storage,accompanied,markets,industries,losses,gulf,charter,strategy,corporate,socialist,somewhat,significantly,physics,mounted,satellite,experienced,constant,relative,pattern,restored,belgium,connecticut,partners,harvard,retained,networks,protected,mode,artistic,parallel,collaboration,debate,involving,journey,linked,salt,authors,components,context,occupation,requires,occasionally,policies,tamil,ottoman,revolutionary,hungary,poem,versus,gardens,amongst,audio,makeup,frequency,meters,orthodox,continuing,suggests,legislature,coalition,guitarist,eighth,classification,practices,soil,tokyo,instance,limit,coverage,considerable,ranking,colleges,cavalry,centers,daughters,twin,equipped,broadway,narrow,hosts,rates,domain,boundary,arranged,12th,whereas,brazilian,forming,rating,strategic,competitions,trading,covering,baltimore,commissioner,infrastructure,origins,replacement,praised,disc,collections,expression,ukraine,driven,edited,austrian,solar,ensure,premiered,successor,wooden,operational,hispanic,concerns,rapid,prisoners,childhood,meets,influential,tunnel,employment,tribe,qualifying,adapted,temporary,celebrated,appearing,increasingly,depression,adults,cinema,entering,laboratory,script,flows,romania,accounts,fictional,pittsburgh,achieve,monastery,franchise,formally,tools,newspapers,revival,sponsored,processes,vienna,springs,missions,classified,13th,annually,branches,lakes,gender,manner,advertising,normally,maintenance,adding,characteristics,integrated,decline,modified,strongly,critic,victims,malaysia,arkansas,nazi,restoration,powered,monument,hundreds,depth,15th,controversial,admiral,criticized,brick,honorary,initiative,output,visiting,birmingham,progressive,existed,carbon,1920s,credits,colour,rising,hence,defeating,superior,filmed,listing,column,surrounded,orleans,principles,territories,struck,participation,indonesia,movements,index,commerce,conduct,constitutional,spiritual,ambassador,vocal,completion,edinburgh,residing,tourism,finland,bears,medals,resident,themes,visible,indigenous,involvement,basin,electrical,ukrainian,concerts,boats,styles,processing,rival,drawing,vessels,experimental,declined,touring,supporters,compilation,coaching,cited,dated,roots,string,explained,transit,traditionally,poems,minimum,representation,14th,releases,effectively,architectural,triple,indicated,greatly,elevation,clinical,printed,10th,proposal,peaked,producers,romanized,rapidly,stream,innings,meetings,counter,householder,honour,lasted,agencies,document,exists,surviving,experiences,honors,landscape,hurricane,harbor,panel,competing,profile,vessel,farmers,lists,revenue,exception,customers,11th,participants,wildlife,utah,bible,gradually,preserved,replacing,symphony,begun,longest,siege,provinces,mechanical,genre,transmission,agents,executed,videos,benefits,funded,rated,instrumental,ninth,similarly,dominated,destruction,passage,technologies,thereafter,outer,facing,affiliated,opportunities,instrument,governments,scholar,evolution,channels,shares,sessions,widespread,occasions,engineers,scientists,signing,battery,competitive,alleged,eliminated,supplies,judges,hampshire,regime,portrayed,penalty,taiwan,denied,submarine,scholarship,substantial,transition,victorian,http,nevertheless,filed,supports,continental,tribes,ratio,doubles,useful,honours,blocks,principle,retail,departure,ranks,patrol,yorkshire,vancouver,inter,extent,afghanistan,strip,railways,component,organ,symbol,categories,encouraged,abroad,civilian,periods,traveled,writes,struggle,immediate,recommended,adaptation,egyptian,graduating,assault,drums,nomination,historically,voting,allies,detailed,achievement,percentage,arabic,assist,frequent,toured,apply,and/or,intersection,maine,touchdown,throne,produces,contribution,emerged,obtain,archbishop,seek,researchers,remainder,populations,clan,finnish,overseas,fifa,licensed,chemistry,festivals,mediterranean,injuries,animated,seeking,publisher,volumes,limits,venue,jerusalem,generated,trials,islam,youngest,ruling,glasgow,germans,songwriter,persian,municipalities,donated,viewed,belgian,cooperation,posted,tech,dual,volunteer,settlers,commanded,claiming,approval,delhi,usage,terminus,partly,electricity,locally,editions,premiere,absence,belief,traditions,statue,indicate,manor,stable,attributed,possession,managing,viewers,chile,overview,seed,regulations,essential,minority,cargo,segment,endemic,forum,deaths,monthly,playoffs,erected,practical,machines,suburb,relation,mrs.,descent,indoor,continuous,characterized,solutions,caribbean,rebuilt,serbian,summary,contested,psychology,pitch,attending,muhammad,tenure,drivers,diameter,assets,venture,punk,airlines,concentration,athletes,volunteers,pages,mines,influences,sculpture,protest,ferry,behalf,drafted,apparent,furthermore,ranging,romanian,democracy,lanka,significance,linear,d.c.,certified,voters,recovered,tours,demolished,boundaries,assisted,identify,grades,elsewhere,mechanism,1940s,reportedly,aimed,conversion,suspended,photography,departments,beijing,locomotives,publicly,dispute,magazines,resort,conventional,platforms,internationally,capita,settlements,dramatic,derby,establishing,involves,statistical,implementation,immigrants,exposed,diverse,layer,vast,ceased,connections,belonged,interstate,uefa,organised,abuse,deployed,cattle,partially,filming,mainstream,reduction,automatic,rarely,subsidiary,decides,merger,comprehensive,displayed,amendment,guinea,exclusively,manhattan,concerning,commons,radical,serbia,baptist,buses,initiated,portrait,harbour,choir,citizen,sole,unsuccessful,manufactured,enforcement,connecting,increases,patterns,sacred,muslims,clothing,hindu,unincorporated,sentenced,advisory,tanks,campaigns,fled,repeated,remote,rebellion,implemented,texts,fitted,tribute,writings,sufficient,ministers,21st,devoted,jurisdiction,coaches,interpretation,pole,businessman,peru,sporting,prices,cuba,relocated,opponent,arrangement,elite,manufacturer,responded,suitable,distinction,calendar,dominant,tourist,earning,prefecture,ties,preparation,anglo,pursue,worship,archaeological,chancellor,bangladesh,scores,traded,lowest,horror,outdoor,biology,commented,specialized,loop,arriving,farming,housed,historians,'the,patent,pupils,christianity,opponents,athens,northwestern,maps,promoting,reveals,flights,exclusive,lions,norfolk,hebrew,extensively,eldest,shops,acquisition,virtual,renowned,margin,ongoing,essentially,iranian,alternate,sailed,reporting,conclusion,originated,temperatures,exposure,secured,landed,rifle,framework,identical,martial,focuses,topics,ballet,fighters,belonging,wealthy,negotiations,evolved,bases,oriented,acres,democrat,heights,restricted,vary,graduation,aftermath,chess,illness,participating,vertical,collective,immigration,demonstrated,leaf,completing,organic,missile,leeds,eligible,grammar,confederate,improvement,congressional,wealth,cincinnati,spaces,indicates,corresponding,reaches,repair,isolated,taxes,congregation,ratings,leagues,diplomatic,submitted,winds,awareness,photographs,maritime,nigeria,accessible,animation,restaurants,philippine,inaugural,dismissed,armenian,illustrated,reservoir,speakers,programmes,resource,genetic,interviews,camps,regulation,computers,preferred,travelled,comparison,distinctive,recreation,requested,southeastern,dependent,brisbane,breeding,playoff,expand,bonus,gauge,departed,qualification,inspiration,shipping,slaves,variations,shield,theories,munich,recognised,emphasis,favour,variable,seeds,undergraduate,territorial,intellectual,qualify,mini,banned,pointed,democrats,assessment,judicial,examination,attempting,objective,partial,characteristic,hardware,pradesh,execution,ottawa,metre,drum,exhibitions,withdrew,attendance,phrase,journalism,logo,measured,error,christians,trio,protestant,theology,respective,atmosphere,buddhist,substitute,curriculum,fundamental,outbreak,rabbi,intermediate,designation,globe,liberation,simultaneously,diseases,experiments,locomotive,difficulties,mainland,nepal,relegated,contributing,database,developments,veteran,carries,ranges,instruction,lodge,protests,obama,newcastle,experiment,physician,describing,challenges,corruption,delaware,adventures,ensemble,succession,renaissance,tenth,altitude,receives,approached,crosses,syria,croatia,warsaw,professionals,improvements,worn,airline,compound,permitted,preservation,reducing,printing,scientist,activist,comprises,sized,societies,enters,ruler,gospel,earthquake,extend,autonomous,croatian,serial,decorated,relevant,ideal,grows,grass,tier,towers,wider,welfare,columns,alumni,descendants,interface,reserves,banking,colonies,manufacturers,magnetic,closure,pitched,vocalist,preserve,enrolled,cancelled,equation,2000s,nickname,bulgaria,heroes,exile,mathematical,demands,input,structural,tube,stem,approaches,argentine,axis,manuscript,inherited,depicted,targets,visits,veterans,regard,removal,efficiency,organisations,concepts,lebanon,manga,petersburg,rally,supplied,amounts,yale,tournaments,broadcasts,signals,pilots,azerbaijan,architects,enzyme,literacy,declaration,placing,batting,incumbent,bulgarian,consistent,poll,defended,landmark,southwestern,raid,resignation,travels,casualties,prestigious,namely,aims,recipient,warfare,readers,collapse,coached,controls,volleyball,coup,lesser,verse,pairs,exhibited,proteins,molecular,abilities,integration,consist,aspect,advocate,administered,governing,hospitals,commenced,coins,lords,variation,resumed,canton,artificial,elevated,palm,difficulty,civic,efficient,northeastern,inducted,radiation,affiliate,boards,stakes,byzantine,consumption,freight,interaction,oblast,numbered,seminary,contracts,extinct,predecessor,bearing,cultures,functional,neighboring,revised,cylinder,grants,narrative,reforms,athlete,tales,reflect,presidency,compositions,specialist,cricketer,founders,sequel,widow,disbanded,associations,backed,thereby,pitcher,commanding,boulevard,singers,crops,militia,reviewed,centres,waves,consequently,fortress,tributary,portions,bombing,excellence,nest,payment,mars,plaza,unity,victories,scotia,farms,nominations,variant,attacking,suspension,installation,graphics,estates,comments,acoustic,destination,venues,surrender,retreat,libraries,quarterback,customs,berkeley,collaborated,gathered,syndrome,dialogue,recruited,shanghai,neighbouring,psychological,saudi,moderate,exhibit,innovation,depot,binding,brunswick,situations,certificate,actively,shakespeare,editorial,presentation,ports,relay,nationalist,methodist,archives,experts,maintains,collegiate,bishops,maintaining,temporarily,embassy,essex,wellington,connects,reformed,bengal,recalled,inches,doctrine,deemed,legendary,reconstruction,statements,palestinian,meter,achievements,riders,interchange,spots,auto,accurate,chorus,dissolved,missionary,thai,operators,e.g.,generations,failing,delayed,cork,nashville,perceived,venezuela,cult,emerging,tomb,abolished,documented,gaining,canyon,episcopal,stored,assists,compiled,kerala,kilometers,mosque,grammy,theorem,unions,segments,glacier,arrives,theatrical,circulation,conferences,chapters,displays,circular,authored,conductor,fewer,dimensional,nationwide,liga,yugoslavia,peer,vietnamese,fellowship,armies,regardless,relating,dynamic,politicians,mixture,serie,somerset,imprisoned,posts,beliefs,beta,layout,independently,electronics,provisions,fastest,logic,headquartered,creates,challenged,beaten,appeals,plains,protocol,graphic,accommodate,iraqi,midfielder,span,commentary,freestyle,reflected,palestine,lighting,burial,virtually,backing,prague,tribal,heir,identification,prototype,criteria,dame,arch,tissue,footage,extending,procedures,predominantly,updated,rhythm,preliminary,cafe,disorder,prevented,suburbs,discontinued,retiring,oral,followers,extends,massacre,journalists,conquest,larvae,pronounced,behaviour,diversity,sustained,addressed,geographic,restrictions,voiced,milwaukee,dialect,quoted,grid,nationally,nearest,roster,twentieth,separation,indies,manages,citing,intervention,guidance,severely,migration,artwork,focusing,rivals,trustees,varied,enabled,committees,centered,skating,slavery,cardinals,forcing,tasks,auckland,youtube,argues,colored,advisor,mumbai,requiring,theological,registration,refugees,nineteenth,survivors,runners,colleagues,priests,contribute,variants,workshop,concentrated,creator,lectures,temples,exploration,requirement,interactive,navigation,companion,perth,allegedly,releasing,citizenship,observation,stationed,ph.d.,sheep,breed,discovers,encourage,kilometres,journals,performers,isle,saskatchewan,hybrid,hotels,lancashire,dubbed,airfield,anchor,suburban,theoretical,sussex,anglican,stockholm,permanently,upcoming,privately,receiver,optical,highways,congo,colours,aggregate,authorized,repeatedly,varies,fluid,innovative,transformed,praise,convoy,demanded,discography,attraction,export,audiences,ordained,enlisted,occasional,westminster,syrian,heavyweight,bosnia,consultant,eventual,improving,aires,wickets,epic,reactions,scandal,i.e.,discrimination,buenos,patron,investors,conjunction,testament,construct,encountered,celebrity,expanding,georgian,brands,retain,underwent,algorithm,foods,provision,orbit,transformation,associates,tactical,compact,varieties,stability,refuge,gathering,moreover,manila,configuration,gameplay,discipline,entity,comprising,composers,skill,monitoring,ruins,museums,sustainable,aerial,altered,codes,voyage,friedrich,conflicts,storyline,travelling,conducting,merit,indicating,referendum,currency,encounter,particles,automobile,workshops,acclaimed,inhabited,doctorate,cuban,phenomenon,dome,enrollment,tobacco,governance,trend,equally,manufacture,hydrogen,grande,compensation,download,pianist,grain,shifted,neutral,evaluation,define,cycling,seized,array,relatives,motors,firms,varying,automatically,restore,nicknamed,findings,governed,investigate,manitoba,administrator,vital,integral,indonesian,confusion,publishers,enable,geographical,inland,naming,civilians,reconnaissance,indianapolis,lecturer,deer,tourists,exterior,rhode,bassist,symbols,scope,ammunition,yuan,poets,punjab,nursing,cent,developers,estimates,presbyterian,nasa,holdings,generate,renewed,computing,cyprus,arabia,duration,compounds,gastropod,permit,valid,touchdowns,facade,interactions,mineral,practiced,allegations,consequence,goalkeeper,baronet,copyright,uprising,carved,targeted,competitors,mentions,sanctuary,fees,pursued,tampa,chronicle,capabilities,specified,specimens,toll,accounting,limestone,staged,upgraded,philosophical,streams,guild,revolt,rainfall,supporter,princeton,terrain,hometown,probability,assembled,paulo,surrey,voltage,developer,destroyer,floors,lineup,curve,prevention,potentially,onwards,trips,imposed,hosting,striking,strict,admission,apartments,solely,utility,proceeded,observations,euro,incidents,vinyl,profession,haven,distant,expelled,rivalry,runway,torpedo,zones,shrine,dimensions,investigations,lithuania,idaho,pursuit,copenhagen,considerably,locality,wireless,decrease,genes,thermal,deposits,hindi,habitats,withdrawn,biblical,monuments,casting,plateau,thesis,managers,flooding,assassination,acknowledged,interim,inscription,guided,pastor,finale,insects,transported,activists,marshal,intensity,airing,cardiff,proposals,lifestyle,prey,herald,capitol,aboriginal,measuring,lasting,interpreted,occurring,desired,drawings,healthcare,panels,elimination,oslo,ghana,blog,sabha,intent,superintendent,governors,bankruptcy,p.m.,equity,disk,layers,slovenia,prussia,quartet,mechanics,graduates,politically,monks,screenplay,nato,absorbed,topped,petition,bold,morocco,exhibits,canterbury,publish,rankings,crater,dominican,enhanced,planes,lutheran,governmental,joins,collecting,brussels,unified,streak,strategies,flagship,surfaces,oval,archive,etymology,imprisonment,instructor,noting,remix,opposing,servant,rotation,width,trans,maker,synthesis,excess,tactics,snail,ltd.,lighthouse,sequences,cornwall,plantation,mythology,performs,foundations,populated,horizontal,speedway,activated,performer,diving,conceived,edmonton,subtropical,environments,prompted,semifinals,caps,bulk,treasury,recreational,telegraph,continent,portraits,relegation,catholics,graph,velocity,rulers,endangered,secular,observer,learns,inquiry,idol,dictionary,certification,estimate,cluster,armenia,observatory,revived,nadu,consumers,hypothesis,manuscripts,contents,arguments,editing,trails,arctic,essays,belfast,acquire,promotional,undertaken,corridor,proceedings,antarctic,millennium,labels,delegates,vegetation,acclaim,directing,substance,outcome,diploma,philosopher,malta,albanian,vicinity,degc,legends,regiments,consent,terrorist,scattered,presidents,gravity,orientation,deployment,duchy,refuses,estonia,crowned,separately,renovation,rises,wilderness,objectives,agreements,empress,slopes,inclusion,equality,decree,ballot,criticised,rochester,recurring,struggled,disabled,henri,poles,prussian,convert,bacteria,poorly,sudan,geological,wyoming,consistently,minimal,withdrawal,interviewed,proximity,repairs,initiatives,pakistani,republicans,propaganda,viii,abstract,commercially,availability,mechanisms,naples,discussions,underlying,lens,proclaimed,advised,spelling,auxiliary,attract,lithuanian,editors,o'brien,accordance,measurement,novelist,ussr,formats,councils,contestants,indie,facebook,parishes,barrier,battalions,sponsor,consulting,terrorism,implement,uganda,crucial,unclear,notion,distinguish,collector,attractions,filipino,ecology,investments,capability,renovated,iceland,albania,accredited,scouts,armor,sculptor,cognitive,errors,gaming,condemned,successive,consolidated,baroque,entries,regulatory,reserved,treasurer,variables,arose,technological,rounded,provider,rhine,agrees,accuracy,genera,decreased,frankfurt,ecuador,edges,particle,rendered,calculated,careers,faction,rifles,americas,gaelic,portsmouth,resides,merchants,fiscal,premises,coin,draws,presenter,acceptance,ceremonies,pollution,consensus,membrane,brigadier,nonetheless,genres,supervision,predicted,magnitude,finite,differ,ancestry,vale,delegation,removing,proceeds,placement,emigrated,siblings,molecules,payments,considers,demonstration,proportion,newer,valve,achieving,confederation,continuously,luxury,notre,introducing,coordinates,charitable,squadrons,disorders,geometry,winnipeg,ulster,loans,longtime,receptor,preceding,belgrade,mandate,wrestler,neighbourhood,factories,buddhism,imported,sectors,protagonist,steep,elaborate,prohibited,artifacts,prizes,pupil,cooperative,sovereign,subspecies,carriers,allmusic,nationals,settings,autobiography,neighborhoods,analog,facilitate,voluntary,jointly,newfoundland,organizing,raids,exercises,nobel,machinery,baltic,crop,granite,dense,websites,mandatory,seeks,surrendered,anthology,comedian,bombs,slot,synopsis,critically,arcade,marking,equations,halls,indo,inaugurated,embarked,speeds,clause,invention,premiership,likewise,presenting,demonstrate,designers,organize,examined,km/h,bavaria,troop,referee,detection,zurich,prairie,rapper,wingspan,eurovision,luxembourg,slovakia,inception,disputed,mammals,entrepreneur,makers,evangelical,yield,clergy,trademark,defunct,allocated,depicting,volcanic,batted,conquered,sculptures,providers,reflects,armoured,locals,walt,herzegovina,contracted,entities,sponsorship,prominence,flowing,ethiopia,marketed,corporations,withdraw,carnegie,induced,investigated,portfolio,flowering,opinions,viewing,classroom,donations,bounded,perception,leicester,fruits,charleston,academics,statute,complaints,smallest,deceased,petroleum,resolved,commanders,algebra,southampton,modes,cultivation,transmitter,spelled,obtaining,sizes,acre,pageant,bats,abbreviated,correspondence,barracks,feast,tackles,raja,derives,geology,disputes,translations,counted,constantinople,seating,macedonia,preventing,accommodation,homeland,explored,invaded,provisional,transform,sphere,unsuccessfully,missionaries,conservatives,highlights,traces,organisms,openly,dancers,fossils,absent,monarchy,combining,lanes,stint,dynamics,chains,missiles,screening,module,tribune,generating,miners,nottingham,seoul,unofficial,owing,linking,rehabilitation,citation,louisville,mollusk,depicts,differential,zimbabwe,kosovo,recommendations,responses,pottery,scorer,aided,exceptions,dialects,telecommunications,defines,elderly,lunar,coupled,flown,25th,espn,formula_1,bordered,fragments,guidelines,gymnasium,valued,complexity,papal,presumably,maternal,challenging,reunited,advancing,comprised,uncertain,favorable,twelfth,correspondent,nobility,livestock,expressway,chilean,tide,researcher,emissions,profits,lengths,accompanying,witnessed,itunes,drainage,slope,reinforced,feminist,sanskrit,develops,physicians,outlets,isbn,coordinator,averaged,termed,occupy,diagnosed,yearly,humanitarian,prospect,spacecraft,stems,enacted,linux,ancestors,karnataka,constitute,immigrant,thriller,ecclesiastical,generals,celebrations,enhance,heating,advocated,evident,advances,bombardment,watershed,shuttle,wicket,twitter,adds,branded,teaches,schemes,pension,advocacy,conservatory,cairo,varsity,freshwater,providence,seemingly,shells,cuisine,specially,peaks,intensive,publishes,trilogy,skilled,nacional,unemployment,destinations,parameters,verses,trafficking,determination,infinite,savings,alignment,linguistic,countryside,dissolution,measurements,advantages,licence,subfamily,highlands,modest,regent,algeria,crest,teachings,knockout,brewery,combine,conventions,descended,chassis,primitive,fiji,explicitly,cumberland,uruguay,laboratories,bypass,elect,informal,preceded,holocaust,tackle,minneapolis,quantity,securities,console,doctoral,religions,commissioners,expertise,unveiled,precise,diplomat,standings,infant,disciplines,sicily,endorsed,systematic,charted,armored,mild,lateral,townships,hurling,prolific,invested,wartime,compatible,galleries,moist,battlefield,decoration,convent,tubes,terrestrial,nominee,requests,delegate,leased,dubai,polar,applying,addresses,munster,sings,commercials,teamed,dances,eleventh,midland,cedar,flee,sandstone,snails,inspection,divide,asset,themed,comparable,paramount,dairy,archaeology,intact,institutes,rectangular,instances,phases,reflecting,substantially,applies,vacant,lacked,copa,coloured,encounters,sponsors,encoded,possess,revenues,ucla,chaired,a.m.,enabling,playwright,stoke,sociology,tibetan,frames,motto,financing,illustrations,gibraltar,chateau,bolivia,transmitted,enclosed,persuaded,urged,folded,suffolk,regulated,bros.,submarines,myth,oriental,malaysian,effectiveness,narrowly,acute,sunk,replied,utilized,tasmania,consortium,quantities,gains,parkway,enlarged,sided,employers,adequate,accordingly,assumption,ballad,mascot,distances,peaking,saxony,projected,affiliation,limitations,metals,guatemala,scots,theaters,kindergarten,verb,employer,differs,discharge,controller,seasonal,marching,guru,campuses,avoided,vatican,maori,excessive,chartered,modifications,caves,monetary,sacramento,mixing,institutional,celebrities,irrigation,shapes,broadcaster,anthem,attributes,demolition,offshore,specification,surveys,yugoslav,contributor,auditorium,lebanese,capturing,airports,classrooms,chennai,paths,tendency,determining,lacking,upgrade,sailors,detected,kingdoms,sovereignty,freely,decorative,momentum,scholarly,georges,gandhi,speculation,transactions,undertook,interact,similarities,cove,teammate,constituted,painters,tends,madagascar,partnerships,afghan,personalities,attained,rebounds,masses,synagogue,reopened,asylum,embedded,imaging,catalogue,defenders,taxonomy,fiber,afterward,appealed,communists,lisbon,rica,judaism,adviser,batsman,ecological,commands,lgbt,cooling,accessed,wards,shiva,employs,thirds,scenic,worcester,tallest,contestant,humanities,economist,textile,constituencies,motorway,tram,percussion,cloth,leisure,1880s,baden,flags,resemble,riots,coined,sitcom,composite,implies,daytime,tanzania,penalties,optional,competitor,excluded,steering,reversed,autonomy,reviewer,breakthrough,professionally,damages,pomeranian,deputies,valleys,ventures,highlighted,electorate,mapping,shortened,executives,tertiary,specimen,launching,bibliography,sank,pursuing,binary,descendant,marched,natives,ideology,turks,adolf,archdiocese,tribunal,exceptional,nigerian,preference,fails,loading,comeback,vacuum,favored,alter,remnants,consecrated,spectators,trends,patriarch,feedback,paved,sentences,councillor,astronomy,advocates,broader,commentator,commissions,identifying,revealing,theatres,incomplete,enables,constituent,reformation,tract,haiti,atmospheric,screened,explosive,czechoslovakia,acids,symbolic,subdivision,liberals,incorporate,challenger,erie,filmmaker,laps,kazakhstan,organizational,evolutionary,chemicals,dedication,riverside,fauna,moths,maharashtra,annexed,gen.,resembles,underwater,garnered,timeline,remake,suited,educator,hectares,automotive,feared,latvia,finalist,narrator,portable,airways,plaque,designing,villagers,licensing,flank,statues,struggles,deutsche,migrated,cellular,jacksonville,wimbledon,defining,highlight,preparatory,planets,cologne,employ,frequencies,detachment,readily,libya,resign,halt,helicopters,reef,landmarks,collaborative,irregular,retaining,helsinki,folklore,weakened,viscount,interred,professors,memorable,mega,repertoire,rowing,dorsal,albeit,progressed,operative,coronation,liner,telugu,domains,philharmonic,detect,bengali,synthetic,tensions,atlas,dramatically,paralympics,xbox,shire,kiev,lengthy,sued,notorious,seas,screenwriter,transfers,aquatic,pioneers,unesco,radius,abundant,tunnels,syndicated,inventor,accreditation,janeiro,exeter,ceremonial,omaha,cadet,predators,resided,prose,slavic,precision,abbot,deity,engaging,cambodia,estonian,compliance,demonstrations,protesters,reactor,commodore,successes,chronicles,mare,extant,listings,minerals,tonnes,parody,cultivated,traders,pioneering,supplement,slovak,preparations,collision,partnered,vocational,atoms,malayalam,welcomed,documentation,curved,functioning,presently,formations,incorporates,nazis,botanical,nucleus,ethical,greeks,metric,automated,whereby,stance,europeans,duet,disability,purchasing,email,telescope,displaced,sodium,comparative,processor,inning,precipitation,aesthetic,import,coordination,feud,alternatively,mobility,tibet,regained,succeeding,hierarchy,apostolic,catalog,reproduction,inscriptions,vicar,clusters,posthumously,rican,loosely,additions,photographic,nowadays,selective,derivative,keyboards,guides,collectively,affecting,combines,operas,networking,decisive,terminated,continuity,finishes,ancestor,consul,heated,simulation,leipzig,incorporating,georgetown,formula_2,circa,forestry,portrayal,councillors,advancement,complained,forewings,confined,transaction,definitions,reduces,televised,1890s,rapids,phenomena,belarus,alps,landscapes,quarterly,specifications,commemorate,continuation,isolation,antenna,downstream,patents,ensuing,tended,saga,lifelong,columnist,labeled,gymnastics,papua,anticipated,demise,encompasses,madras,antarctica,interval,icon,rams,midlands,ingredients,priory,strengthen,rouge,explicit,gaza,aging,securing,anthropology,listeners,adaptations,underway,vista,malay,fortified,lightweight,violations,concerto,financed,jesuit,observers,trustee,descriptions,nordic,resistant,opted,accepts,prohibition,andhra,inflation,negro,wholly,imagery,spur,instructed,gloucester,cycles,middlesex,destroyers,statewide,evacuated,hyderabad,peasants,mice,shipyard,coordinate,pitching,colombian,exploring,numbering,compression,countess,hiatus,exceed,raced,archipelago,traits,soils,o'connor,vowel,android,facto,angola,amino,holders,logistics,circuits,emergence,kuwait,partition,emeritus,outcomes,submission,promotes,barack,negotiated,loaned,stripped,50th,excavations,treatments,fierce,participant,exports,decommissioned,cameo,remarked,residences,fuselage,mound,undergo,quarry,node,midwest,specializing,occupies,etc.,showcase,molecule,offs,modules,salon,exposition,revision,peers,positioned,hunters,competes,algorithms,reside,zagreb,calcium,uranium,silicon,airs,counterpart,outlet,collectors,sufficiently,canberra,inmates,anatomy,ensuring,curves,aviv,firearms,basque,volcano,thrust,sheikh,extensions,installations,aluminum,darker,sacked,emphasized,aligned,asserted,pseudonym,spanning,decorations,eighteenth,orbital,spatial,subdivided,notation,decay,macedonian,amended,declining,cyclist,feat,unusually,commuter,birthplace,latitude,activation,overhead,30th,finalists,whites,encyclopedia,tenor,qatar,survives,complement,concentrations,uncommon,astronomical,bangalore,pius,genome,memoir,recruit,prosecutor,modification,paired,container,basilica,arlington,displacement,germanic,mongolia,proportional,debates,matched,calcutta,rows,tehran,aerospace,prevalent,arise,lowland,24th,spokesman,supervised,advertisements,clash,tunes,revelation,wanderers,quarterfinals,fisheries,steadily,memoirs,pastoral,renewable,confluence,acquiring,strips,slogan,upstream,scouting,analyst,practitioners,turbine,strengthened,heavier,prehistoric,plural,excluding,isles,persecution,turin,rotating,villain,hemisphere,unaware,arabs,corpus,relied,singular,unanimous,schooling,passive,angles,dominance,instituted,aria,outskirts,balanced,beginnings,financially,structured,parachute,viewer,attitudes,subjected,escapes,derbyshire,erosion,addressing,styled,declaring,originating,colts,adjusted,stained,occurrence,fortifications,baghdad,nitrogen,localities,yemen,galway,debris,lodz,victorious,pharmaceutical,substances,unnamed,dwelling,atop,developmental,activism,voter,refugee,forested,relates,overlooking,genocide,kannada,insufficient,oversaw,partisan,dioxide,recipients,factions,mortality,capped,expeditions,receptors,reorganized,prominently,atom,flooded,flute,orchestral,scripts,mathematician,airplay,detached,rebuilding,dwarf,brotherhood,salvation,expressions,arabian,cameroon,poetic,recruiting,bundesliga,inserted,scrapped,disabilities,evacuation,pasha,undefeated,crafts,rituals,aluminium,norm,pools,submerged,occupying,pathway,exams,prosperity,wrestlers,promotions,basal,permits,nationalism,trim,merge,gazette,tributaries,transcription,caste,porto,emerge,modeled,adjoining,counterparts,paraguay,redevelopment,renewal,unreleased,equilibrium,similarity,minorities,soviets,comprise,nodes,tasked,unrelated,expired,johan,precursor,examinations,electrons,socialism,exiled,admiralty,floods,wigan,nonprofit,lacks,brigades,screens,repaired,hanover,fascist,labs,osaka,delays,judged,statutory,colt,col.,offspring,solving,bred,assisting,retains,somalia,grouped,corresponds,tunisia,chaplain,eminent,chord,22nd,spans,viral,innovations,possessions,mikhail,kolkata,icelandic,implications,introduces,racism,workforce,alto,compulsory,admits,censorship,onset,reluctant,inferior,iconic,progression,liability,turnout,satellites,behavioral,coordinated,exploitation,posterior,averaging,fringe,krakow,mountainous,greenwich,para,plantations,reinforcements,offerings,famed,intervals,constraints,individually,nutrition,1870s,taxation,threshold,tomatoes,fungi,contractor,ethiopian,apprentice,diabetes,wool,gujarat,honduras,norse,bucharest,23rd,arguably,accompany,prone,teammates,perennial,vacancy,polytechnic,deficit,okinawa,functionality,reminiscent,tolerance,transferring,myanmar,concludes,neighbours,hydraulic,economically,slower,plots,charities,synod,investor,catholicism,identifies,bronx,interpretations,adverse,judiciary,hereditary,nominal,sensor,symmetry,cubic,triangular,tenants,divisional,outreach,representations,passages,undergoing,cartridge,testified,exceeded,impacts,limiting,railroads,defeats,regain,rendering,humid,retreated,reliability,governorate,antwerp,infamous,implied,packaging,lahore,trades,billed,extinction,ecole,rejoined,recognizes,projection,qualifications,stripes,forts,socially,lexington,accurately,sexuality,westward,wikipedia,pilgrimage,abolition,choral,stuttgart,nests,expressing,strikeouts,assessed,monasteries,reconstructed,humorous,marxist,fertile,consort,urdu,patronage,peruvian,devised,lyric,baba,nassau,communism,extraction,popularly,markings,inability,litigation,accounted,processed,emirates,tempo,cadets,eponymous,contests,broadly,oxide,courtyard,frigate,directory,apex,outline,regency,chiefly,patrols,secretariat,cliffs,residency,privy,armament,australians,dorset,geometric,genetics,scholarships,fundraising,flats,demographic,multimedia,captained,documentaries,updates,canvas,blockade,guerrilla,songwriting,administrators,intake,drought,implementing,fraction,cannes,refusal,inscribed,meditation,announcing,exported,ballots,formula_3,curator,basel,arches,flour,subordinate,confrontation,gravel,simplified,berkshire,patriotic,tuition,employing,servers,castile,posting,combinations,discharged,miniature,mutations,constellation,incarnation,ideals,necessity,granting,ancestral,crowds,pioneered,mormon,methodology,rama,indirect,complexes,bavarian,patrons,uttar,skeleton,bollywood,flemish,viable,bloc,breeds,triggered,sustainability,tailed,referenced,comply,takeover,latvian,homestead,platoon,communal,nationality,excavated,targeting,sundays,posed,physicist,turret,endowment,marginal,dispatched,commentators,renovations,attachment,collaborations,ridges,barriers,obligations,shareholders,prof.,defenses,presided,rite,backgrounds,arbitrary,affordable,gloucestershire,thirteenth,inlet,miniseries,possesses,detained,pressures,subscription,realism,solidarity,proto,postgraduate,noun,burmese,abundance,homage,reasoning,anterior,robust,fencing,shifting,vowels,garde,profitable,loch,anchored,coastline,samoa,terminology,prostitution,magistrate,venezuelan,speculated,regulate,fixture,colonists,digit,induction,manned,expeditionary,computational,centennial,principally,vein,preserving,engineered,numerical,cancellation,conferred,continually,borne,seeded,advertisement,unanimously,treaties,infections,ions,sensors,lowered,amphibious,lava,fourteenth,bahrain,niagara,nicaragua,squares,congregations,26th,periodic,proprietary,1860s,contributors,seller,overs,emission,procession,presumed,illustrator,zinc,gases,tens,applicable,stretches,reproductive,sixteenth,apparatus,accomplishments,canoe,guam,oppose,recruitment,accumulated,limerick,namibia,staging,remixes,ordnance,uncertainty,pedestrian,temperate,treason,deposited,registry,cerambycidae,attracting,lankan,reprinted,shipbuilding,homosexuality,neurons,eliminating,1900s,resume,ministries,beneficial,blackpool,surplus,northampton,licenses,constructing,announcer,standardized,alternatives,taipei,inadequate,failures,yields,medalist,titular,obsolete,torah,burlington,predecessors,lublin,retailers,castles,depiction,issuing,gubernatorial,propulsion,tiles,damascus,discs,alternating,pomerania,peasant,tavern,redesignated,27th,illustration,focal,mans,codex,specialists,productivity,antiquity,controversies,promoter,pits,companions,behaviors,lyrical,prestige,creativity,swansea,dramas,approximate,feudal,tissues,crude,campaigned,unprecedented,chancel,amendments,surroundings,allegiance,exchanges,align,firmly,optimal,commenting,reigning,landings,obscure,1850s,contemporaries,paternal,devi,endurance,communes,incorporation,denominations,exchanged,routing,resorts,amnesty,slender,explores,suppression,heats,pronunciation,centred,coupe,stirling,freelance,treatise,linguistics,laos,informs,discovering,pillars,encourages,halted,robots,definitive,maturity,tuberculosis,venetian,silesian,unchanged,originates,mali,lincolnshire,quotes,seniors,premise,contingent,distribute,danube,gorge,logging,dams,curling,seventeenth,specializes,wetlands,deities,assess,thickness,rigid,culminated,utilities,substrate,insignia,nile,assam,shri,currents,suffrage,canadians,mortar,asteroid,bosnian,discoveries,enzymes,sanctioned,replica,hymn,investigators,tidal,dominate,derivatives,converting,leinster,verbs,honoured,criticisms,dismissal,discrete,masculine,reorganization,unlimited,wurttemberg,sacks,allocation,bahn,jurisdictions,participates,lagoon,famine,communion,culminating,surveyed,shortage,cables,intersects,cassette,foremost,adopting,solicitor,outright,bihar,reissued,farmland,dissertation,turnpike,baton,photographed,christchurch,kyoto,finances,rails,histories,linebacker,kilkenny,accelerated,dispersed,handicap,absorption,rancho,ceramic,captivity,cites,font,weighed,mater,utilize,bravery,extract,validity,slovenian,seminars,discourse,ranged,duel,ironically,warships,sega,temporal,surpassed,prolonged,recruits,northumberland,greenland,contributes,patented,eligibility,unification,discusses,reply,translates,beirut,relies,torque,northward,reviewers,monastic,accession,neural,tramway,heirs,sikh,subscribers,amenities,taliban,audit,rotterdam,wagons,kurdish,favoured,combustion,meanings,persia,browser,diagnostic,niger,formula_4,denomination,dividing,parameter,branding,badminton,leningrad,sparked,hurricanes,beetles,propeller,mozambique,refined,diagram,exhaust,vacated,readings,markers,reconciliation,determines,concurrent,imprint,primera,organism,demonstrating,filmmakers,vanderbilt,affiliates,traction,evaluated,defendants,megachile,investigative,zambia,assassinated,rewarded,probable,staffordshire,foreigners,directorate,nominees,consolidation,commandant,reddish,differing,unrest,drilling,bohemia,resembling,instrumentation,considerations,haute,promptly,variously,dwellings,clans,tablet,enforced,cockpit,semifinal,hussein,prisons,ceylon,emblem,monumental,phrases,correspond,crossover,outlined,characterised,acceleration,caucus,crusade,protested,composing,rajasthan,habsburg,rhythmic,interception,inherent,cooled,ponds,spokesperson,gradual,consultation,kuala,globally,suppressed,builders,avengers,suffix,integer,enforce,fibers,unionist,proclamation,uncovered,infrared,adapt,eisenhower,utilizing,captains,stretched,observing,assumes,prevents,analyses,saxophone,caucasus,notices,villains,dartmouth,mongol,hostilities,stretching,veterinary,lenses,texture,prompting,overthrow,excavation,islanders,masovian,battleship,biographer,replay,degradation,departing,luftwaffe,fleeing,oversight,immigrated,serbs,fishermen,strengthening,respiratory,italians,denotes,radial,escorted,motif,wiltshire,expresses,accessories,reverted,establishments,inequality,protocols,charting,famously,satirical,entirety,trench,friction,atletico,sampling,subset,weekday,upheld,sharply,correlation,incorrect,mughal,travelers,hasan,earnings,offset,evaluate,specialised,recognizing,flexibility,nagar,postseason,algebraic,capitalism,crystals,melodies,polynomial,racecourse,defences,austro,wembley,attracts,anarchist,resurrection,reviewing,decreasing,prefix,ratified,mutation,displaying,separating,restoring,assemblies,ordinance,priesthood,cruisers,appoint,moldova,imports,directive,epidemic,militant,senegal,signaling,restriction,critique,retrospective,nationalists,undertake,sioux,canals,algerian,redesigned,philanthropist,depict,conceptual,turbines,intellectuals,eastward,applicants,contractors,vendors,undergone,namesake,ensured,tones,substituted,hindwings,arrests,tombs,transitional,principality,reelection,taiwanese,cavity,manifesto,broadcasters,spawned,thoroughbred,identities,generators,proposes,hydroelectric,johannesburg,cortex,scandinavian,killings,aggression,boycott,catalyst,physiology,fifteenth,waterfront,chromosome,organist,costly,calculation,cemeteries,flourished,recognise,juniors,merging,disciples,ashore,workplace,enlightenment,diminished,debated,hailed,podium,educate,mandated,distributor,litre,electromagnetic,flotilla,estuary,peterborough,staircase,selections,melodic,confronts,wholesale,integrate,intercepted,catalonia,unite,immense,palatinate,switches,earthquakes,occupational,successors,praising,concluding,faculties,firstly,overhaul,empirical,metacritic,inauguration,evergreen,laden,winged,philosophers,amalgamated,geoff,centimeters,napoleonic,upright,planting,brewing,fined,sensory,migrants,wherein,inactive,headmaster,warwickshire,siberia,terminals,denounced,academia,divinity,bilateral,clive,omitted,peerage,relics,apartheid,syndicate,fearing,fixtures,desirable,dismantled,ethnicity,valves,biodiversity,aquarium,ideological,visibility,creators,analyzed,tenant,balkan,postwar,supplier,smithsonian,risen,morphology,digits,bohemian,wilmington,vishnu,demonstrates,aforementioned,biographical,mapped,khorasan,phosphate,presentations,ecosystem,processors,calculations,mosaic,clashes,penned,recalls,coding,angular,lattice,macau,accountability,extracted,pollen,therapeutic,overlap,violinist,deposed,candidacy,infants,covenant,bacterial,restructuring,dungeons,ordination,conducts,builds,invasive,customary,concurrently,relocation,cello,statutes,borneo,entrepreneurs,sanctions,packet,rockefeller,piedmont,comparisons,waterfall,receptions,glacial,surge,signatures,alterations,advertised,enduring,somali,botanist,100th,canonical,motifs,longitude,circulated,alloy,indirectly,margins,preserves,internally,besieged,shale,peripheral,drained,baseman,reassigned,tobago,soloist,socio,grazing,contexts,roofs,portraying,ottomans,shrewsbury,noteworthy,lamps,supplying,beams,qualifier,portray,greenhouse,stronghold,hitter,rites,cretaceous,urging,derive,nautical,aiming,fortunes,verde,donors,reliance,exceeding,exclusion,exercised,simultaneous,continents,guiding,pillar,gradient,poznan,eruption,clinics,moroccan,indicator,trams,piers,parallels,fragment,teatro,potassium,satire,compressed,businessmen,influx,seine,perspectives,shelters,decreases,mounting,formula_5,confederacy,equestrian,expulsion,mayors,liberia,resisted,affinity,shrub,unexpectedly,stimulus,amtrak,deported,perpendicular,statesman,wharf,storylines,romanesque,weights,surfaced,interceptions,dhaka,crambidae,orchestras,rwanda,conclude,constitutes,subsidiaries,admissions,prospective,shear,bilingual,campaigning,presiding,domination,commemorative,trailing,confiscated,petrol,acquisitions,polymer,onlyinclude,chloride,elevations,resolutions,hurdles,pledged,likelihood,objected,erect,encoding,databases,aristotle,hindus,marshes,bowled,ministerial,grange,acronym,annexation,squads,ambient,pilgrims,botany,sofla,astronomer,planetary,descending,bestowed,ceramics,diplomacy,metabolism,colonization,potomac,africans,engraved,recycling,commitments,resonance,disciplinary,jamaican,narrated,spectral,tipperary,waterford,stationary,arbitration,transparency,threatens,crossroads,slalom,oversee,centenary,incidence,economies,livery,moisture,newsletter,autobiographical,bhutan,propelled,dependence,moderately,adobe,barrels,subdivisions,outlook,labelled,stratford,arising,diaspora,barony,automobiles,ornamental,slated,norms,primetime,generalized,analysts,vectors,libyan,yielded,certificates,rooted,vernacular,belarusian,marketplace,prediction,fairfax,malawi,viruses,wooded,demos,mauritius,prosperous,coincided,liberties,huddersfield,ascent,warnings,hinduism,glucose,pulitzer,unused,filters,illegitimate,acquitted,protestants,canopy,staple,psychedelic,winding,abbas,pathways,cheltenham,lagos,niche,invaders,proponents,barred,conversely,doncaster,recession,embraced,rematch,concession,emigration,upgrades,bowls,tablets,remixed,loops,kensington,shootout,monarchs,organizers,harmful,punjabi,broadband,exempt,neolithic,profiles,portrays,parma,cyrillic,quasi,attested,regimental,revive,torpedoes,heidelberg,rhythms,spherical,denote,hymns,icons,theologian,qaeda,exceptionally,reinstated,comune,playhouse,lobbying,grossing,viceroy,delivers,visually,armistice,utrecht,syllable,vertices,analogous,annex,refurbished,entrants,knighted,disciple,rhetoric,detailing,inactivated,ballads,algae,intensified,favourable,sanitation,receivers,pornography,commemorated,cannons,entrusted,manifold,photographers,pueblo,textiles,steamer,myths,marquess,onward,liturgical,romney,uzbekistan,consistency,denoted,hertfordshire,convex,hearings,sulfur,universidad,podcast,selecting,emperors,arises,justices,1840s,mongolian,exploited,termination,digitally,infectious,sedan,symmetric,penal,illustrate,formulation,attribute,problematic,modular,inverse,berth,searches,rutgers,leicestershire,enthusiasts,lockheed,upwards,transverse,accolades,backward,archaeologists,crusaders,nuremberg,defects,ferries,vogue,containers,openings,transporting,separates,lumpur,purchases,attain,wichita,topology,woodlands,deleted,periodically,syntax,overturned,musicals,corp.,strasbourg,instability,nationale,prevailing,cache,marathi,versailles,unmarried,grains,straits,antagonist,segregation,assistants,d'etat,contention,dictatorship,unpopular,motorcycles,criterion,analytical,salzburg,militants,hanged,worcestershire,emphasize,paralympic,erupted,convinces,offences,oxidation,nouns,populace,atari,spanned,hazardous,educators,playable,births,baha'i,preseason,generates,invites,meteorological,handbook,foothills,enclosure,diffusion,mirza,convergence,geelong,coefficient,connector,formula_6,cylindrical,disasters,pleaded,knoxville,contamination,compose,libertarian,arrondissement,franciscan,intercontinental,susceptible,initiation,malaria,unbeaten,consonants,waived,saloon,popularized,estadio,pseudo,interdisciplinary,transports,transformers,carriages,bombings,revolves,ceded,collaborator,celestial,exemption,colchester,maltese,oceanic,ligue,crete,shareholder,routed,depictions,ridden,advisors,calculate,lending,guangzhou,simplicity,newscast,scheduling,snout,eliot,undertaking,armenians,nottinghamshire,whitish,consulted,deficiency,salle,cinemas,superseded,rigorous,kerman,convened,landowners,modernization,evenings,pitches,conditional,scandinavia,differed,formulated,cyclists,swami,guyana,dunes,electrified,appalachian,abdomen,scenarios,prototypes,sindh,consonant,adaptive,boroughs,wolverhampton,modelling,cylinders,amounted,minimize,ambassadors,lenin,settler,coincide,approximation,grouping,murals,bullying,registers,rumours,engagements,energetic,vertex,annals,bordering,geologic,yellowish,runoff,converts,allegheny,facilitated,saturdays,colliery,monitored,rainforest,interfaces,geographically,impaired,prevalence,joachim,paperback,slowed,shankar,distinguishing,seminal,categorized,authorised,auspices,bandwidth,asserts,rebranded,balkans,supplemented,seldom,weaving,capsule,apostles,populous,monmouth,payload,symphonic,densely,shoreline,managerial,masonry,antioch,averages,textbooks,royalist,coliseum,tandem,brewers,diocesan,posthumous,walled,incorrectly,distributions,ensued,reasonably,graffiti,propagation,automation,harmonic,augmented,middleweight,limbs,elongated,landfall,comparatively,literal,grossed,koppen,wavelength,1830s,cerebral,boasts,congestion,physiological,practitioner,coasts,cartoonist,undisclosed,frontal,launches,burgundy,qualifiers,imposing,stade,flanked,assyrian,raided,multiplayer,montane,chesapeake,pathology,drains,vineyards,intercollegiate,semiconductor,grassland,convey,citations,predominant,rejects,benefited,yahoo,graphs,busiest,encompassing,hamlets,explorers,suppress,minors,graphical,calculus,sediment,intends,diverted,mainline,unopposed,cottages,initiate,alumnus,towed,autism,forums,darlington,modernist,oxfordshire,lectured,capitalist,suppliers,panchayat,actresses,foundry,southbound,commodity,wesleyan,divides,palestinians,luton,caretaker,nobleman,mutiny,organizer,preferences,nomenclature,splits,unwilling,offenders,timor,relying,halftime,semitic,arithmetic,milestone,jesuits,arctiidae,retrieved,consuming,contender,edged,plagued,inclusive,transforming,khmer,federally,insurgents,distributing,amherst,rendition,prosecutors,viaduct,disqualified,kabul,liturgy,prevailed,reelected,instructors,swimmers,aperture,churchyard,interventions,totals,darts,metropolis,fuels,fluent,northbound,correctional,inflicted,barrister,realms,culturally,aristocratic,collaborating,emphasizes,choreographer,inputs,ensembles,humboldt,practised,endowed,strains,infringement,archaeologist,congregational,magna,relativity,efficiently,proliferation,mixtape,abruptly,regeneration,commissioning,yukon,archaic,reluctantly,retailer,northamptonshire,universally,crossings,boilers,nickelodeon,revue,abbreviation,retaliation,scripture,routinely,medicinal,benedictine,kenyan,retention,deteriorated,glaciers,apprenticeship,coupling,researched,topography,entrances,anaheim,pivotal,compensate,arched,modify,reinforce,dusseldorf,journeys,motorsport,conceded,sumatra,spaniards,quantitative,loire,cinematography,discarded,botswana,morale,engined,zionist,philanthropy,sainte,fatalities,cypriot,motorsports,indicators,pricing,institut,bethlehem,implicated,gravitational,differentiation,rotor,thriving,precedent,ambiguous,concessions,forecast,conserved,fremantle,asphalt,landslide,middlesbrough,formula_7,humidity,overseeing,chronological,diaries,multinational,crimean,turnover,improvised,youths,declares,tasmanian,canadiens,fumble,refinery,weekdays,unconstitutional,upward,guardians,brownish,imminent,hamas,endorsement,naturalist,martyrs,caledonia,chords,yeshiva,reptiles,severity,mitsubishi,fairs,installment,substitution,repertory,keyboardist,interpreter,silesia,noticeable,rhineland,transmit,inconsistent,booklet,academies,epithet,pertaining,progressively,aquatics,scrutiny,prefect,toxicity,rugged,consume,o'donnell,evolve,uniquely,cabaret,mediated,landowner,transgender,palazzo,compilations,albuquerque,induce,sinai,remastered,efficacy,underside,analogue,specify,possessing,advocating,compatibility,liberated,greenville,mecklenburg,header,memorials,sewage,rhodesia,1800s,salaries,atoll,coordinating,partisans,repealed,amidst,subjective,optimization,nectar,evolving,exploits,madhya,styling,accumulation,raion,postage,responds,buccaneers,frontman,brunei,choreography,coated,kinetic,sampled,inflammatory,complementary,eclectic,norte,vijay,a.k.a,mainz,casualty,connectivity,laureate,franchises,yiddish,reputed,unpublished,economical,periodicals,vertically,bicycles,brethren,capacities,unitary,archeological,tehsil,domesday,wehrmacht,justification,angered,mysore,fielded,abuses,nutrients,ambitions,taluk,battleships,symbolism,superiority,neglect,attendees,commentaries,collaborators,predictions,yorker,breeders,investing,libretto,informally,coefficients,memorandum,pounder,collingwood,tightly,envisioned,arbor,mistakenly,captures,nesting,conflicting,enhancing,streetcar,manufactures,buckinghamshire,rewards,commemorating,stony,expenditure,tornadoes,semantic,relocate,weimar,iberian,sighted,intending,ensign,beverages,expectation,differentiate,centro,utilizes,saxophonist,catchment,transylvania,ecosystems,shortest,sediments,socialists,ineffective,kapoor,formidable,heroine,guantanamo,prepares,scattering,pamphlet,verified,elector,barons,totaling,shrubs,pyrenees,amalgamation,mutually,longitudinal,comte,negatively,masonic,envoy,sexes,akbar,mythical,tonga,bishopric,assessments,malaya,warns,interiors,reefs,reflections,neutrality,musically,nomadic,waterways,provence,collaborate,scaled,adulthood,emerges,euros,optics,incentives,overland,periodical,liege,awarding,realization,slang,affirmed,schooner,hokkaido,czechoslovak,protectorate,undrafted,disagreed,commencement,electors,spruce,swindon,fueled,equatorial,inventions,suites,slovene,backdrop,adjunct,energies,remnant,inhabit,alliances,simulcast,reactors,mosques,travellers,outfielder,plumage,migratory,benin,experimented,fibre,projecting,drafting,laude,evidenced,northernmost,indicted,directional,replication,croydon,comedies,jailed,organizes,devotees,reservoirs,turrets,originate,economists,songwriters,junta,trenches,mounds,proportions,comedic,apostle,azerbaijani,farmhouse,resembled,disrupted,playback,mixes,diagonal,relevance,govern,programmer,gdansk,maize,soundtracks,tendencies,mastered,impacted,believers,kilometre,intervene,chairperson,aerodrome,sails,subsidies,ensures,aesthetics,congresses,ratios,sardinia,southernmost,functioned,controllers,downward,randomly,distortion,regents,palatine,disruption,spirituality,vidhan,tracts,compiler,ventilation,anchorage,symposium,assert,pistols,excelled,avenues,convoys,moniker,constructions,proponent,phased,spines,organising,schleswig,policing,campeonato,mined,hourly,croix,lucrative,authenticity,haitian,stimulation,burkina,espionage,midfield,manually,staffed,awakening,metabolic,biographies,entrepreneurship,conspicuous,guangdong,preface,subgroup,mythological,adjutant,feminism,vilnius,oversees,honourable,tripoli,stylized,kinase,societe,notoriety,altitudes,configurations,outward,transmissions,announces,auditor,ethanol,clube,nanjing,mecca,haifa,blogs,postmaster,paramilitary,depart,positioning,potent,recognizable,spire,brackets,remembrance,overlapping,turkic,articulated,scientology,operatic,deploy,readiness,biotechnology,restrict,cinematographer,inverted,synonymous,administratively,westphalia,commodities,replaces,downloads,centralized,munitions,preached,sichuan,fashionable,implementations,matrices,hiv/aids,loyalist,luzon,celebrates,hazards,heiress,mercenaries,synonym,creole,ljubljana,technician,auditioned,technicians,viewpoint,wetland,mongols,princely,sharif,coating,dynasties,southward,doubling,formula_8,mayoral,harvesting,conjecture,goaltender,oceania,spokane,welterweight,bracket,gatherings,weighted,newscasts,mussolini,affiliations,disadvantage,vibrant,spheres,sultanate,distributors,disliked,establishes,marches,drastically,yielding,jewellery,yokohama,vascular,airlift,canons,subcommittee,repression,strengths,graded,outspoken,fused,pembroke,filmography,redundant,fatigue,repeal,threads,reissue,pennant,edible,vapor,corrections,stimuli,commemoration,dictator,anand,secession,amassed,orchards,pontifical,experimentation,greeted,bangor,forwards,decomposition,quran,trolley,chesterfield,traverse,sermons,burials,skier,climbs,consultants,petitioned,reproduce,parted,illuminated,kurdistan,reigned,occupants,packaged,geometridae,woven,regulating,protagonists,crafted,affluent,clergyman,consoles,migrant,supremacy,attackers,caliph,defect,convection,rallies,huron,resin,segunda,quota,warship,overseen,criticizing,shrines,glamorgan,lowering,beaux,hampered,invasions,conductors,collects,bluegrass,surrounds,substrates,perpetual,chronology,pulmonary,executions,crimea,compiling,noctuidae,battled,tumors,minsk,novgorod,serviced,yeast,computation,swamps,theodor,baronetcy,salford,uruguayan,shortages,odisha,siberian,novelty,cinematic,invitational,decks,dowager,oppression,bandits,appellate,state-of-the-art,clade,palaces,signalling,galaxies,industrialist,tensor,learnt,incurred,magistrates,binds,orbits,ciudad,willingness,peninsular,basins,biomedical,shafts,marlborough,bournemouth,withstand,fitzroy,dunedin,variance,steamship,integrating,muscular,fines,akron,bulbophyllum,malmo,disclosed,cornerstone,runways,medicines,twenty20,gettysburg,progresses,frigates,bodied,transformations,transforms,helens,modelled,versatile,regulator,pursuits,legitimacy,amplifier,scriptures,voyages,examines,presenters,octagonal,poultry,formula_9,anatolia,computed,migrate,directorial,hybrids,localized,preferring,guggenheim,persisted,grassroots,inflammation,fishery,otago,vigorous,professions,instructional,inexpensive,insurgency,legislators,sequels,surnames,agrarian,stainless,nairobi,minas,forerunner,aristocracy,transitions,sicilian,showcased,doses,hiroshima,summarized,gearbox,emancipation,limitation,nuclei,seismic,abandonment,dominating,appropriations,occupations,electrification,hilly,contracting,exaggerated,entertainer,kazan,oricon,cartridges,characterization,parcel,maharaja,exceeds,aspiring,obituary,flattened,contrasted,narration,replies,oblique,outpost,fronts,arranger,talmud,keynes,doctrines,endured,confesses,fortification,supervisors,kilometer,academie,jammu,bathurst,piracy,prostitutes,navarre,cumulative,cruises,lifeboat,twinned,radicals,interacting,expenditures,wexford,libre,futsal,curated,clockwise,colloquially,procurement,immaculate,lyricist,enhancement,porcelain,alzheimer,highlighting,judah,disagreements,storytelling,sheltered,wroclaw,vaudeville,contrasts,neoclassical,compares,contrasting,deciduous,francaise,descriptive,cyclic,reactive,antiquities,meiji,repeats,creditors,forcibly,newmarket,picturesque,impending,uneven,bison,raceway,solvent,ecumenical,optic,professorship,harvested,waterway,banjo,pharaoh,geologist,scanning,dissent,recycled,unmanned,retreating,gospels,aqueduct,branched,tallinn,groundbreaking,syllables,hangar,designations,procedural,craters,cabins,encryption,anthropologist,montevideo,outgoing,inverness,chattanooga,fascism,calais,chapels,groundwater,downfall,misleading,robotic,tortricidae,pixel,handel,prohibit,crewe,renaming,reprised,kickoff,leftist,spaced,integers,causeway,pines,authorship,organise,ptolemy,accessibility,virtues,lesions,iroquois,qur'an,atheist,synthesized,biennial,confederates,dietary,skaters,stresses,tariff,koreans,intercity,republics,quintet,baroness,naive,amplitude,insistence,tbilisi,residues,grammatical,diversified,egyptians,accompaniment,vibration,repository,mandal,topological,distinctions,coherent,invariant,batters,nuevo,internationals,implements,follower,bahia,widened,independents,cantonese,totaled,guadalajara,wolverines,befriended,muzzle,surveying,hungarians,medici,deportation,rayon,approx,recounts,attends,clerical,hellenic,furnished,alleging,soluble,systemic,gallantry,bolshevik,intervened,hostel,gunpowder,specialising,stimulate,leiden,removes,thematic,floral,bafta,printers,conglomerate,eroded,analytic,successively,lehigh,thessaloniki,kilda,clauses,ascended,nehru,scripted,tokugawa,competence,diplomats,exclude,consecration,freedoms,assaults,revisions,blacksmith,textual,sparse,concacaf,slain,uploaded,enraged,whaling,guise,stadiums,debuting,dormitory,cardiovascular,yunnan,dioceses,consultancy,notions,lordship,archdeacon,collided,medial,airfields,garment,wrestled,adriatic,reversal,refueling,verification,jakob,horseshoe,intricate,veracruz,sarawak,syndication,synthesizer,anthologies,stature,feasibility,guillaume,narratives,publicized,antrim,intermittent,constituents,grimsby,filmmaking,doping,unlawful,nominally,transmitting,documenting,seater,internationale,ejected,steamboat,alsace,boise,ineligible,geared,vassal,mustered,ville,inline,pairing,eurasian,kyrgyzstan,barnsley,reprise,stereotypes,rushes,conform,firefighters,deportivo,revolutionaries,rabbis,concurrency,charters,sustaining,aspirations,algiers,chichester,falkland,morphological,systematically,volcanoes,designate,artworks,reclaimed,jurist,anglia,resurrected,chaotic,feasible,circulating,simulated,environmentally,confinement,adventist,harrisburg,laborers,ostensibly,universiade,pensions,influenza,bratislava,octave,refurbishment,gothenburg,putin,barangay,annapolis,breaststroke,illustrates,distorted,choreographed,promo,emphasizing,stakeholders,descends,exhibiting,intrinsic,invertebrates,evenly,roundabout,salts,formula_10,strata,inhibition,branching,stylistic,rumored,realises,mitochondrial,commuted,adherents,logos,bloomberg,telenovela,guineas,charcoal,engages,winery,reflective,siena,cambridgeshire,ventral,flashback,installing,engraving,grasses,traveller,rotated,proprietor,nationalities,precedence,sourced,trainers,cambodian,reductions,depleted,saharan,classifications,biochemistry,plaintiffs,arboretum,humanist,fictitious,aleppo,climates,bazaar,his/her,homogeneous,multiplication,moines,indexed,linguist,skeletal,foliage,societal,differentiated,informing,mammal,infancy,archival,cafes,malls,graeme,musee,schizophrenia,fargo,pronouns,derivation,descend,ascending,terminating,deviation,recaptured,confessions,weakening,tajikistan,bahadur,pasture,b/hip,donegal,supervising,sikhs,thinkers,euclidean,reinforcement,friars,portage,fuscous,lucknow,synchronized,assertion,choirs,privatization,corrosion,multitude,skyscraper,royalties,ligament,usable,spores,directs,clashed,stockport,fronted,dependency,contiguous,biologist,backstroke,powerhouse,frescoes,phylogenetic,welding,kildare,gabon,conveyed,augsburg,severn,continuum,sahib,lille,injuring,passeriformesfamily,succeeds,translating,unitarian,startup,turbulent,outlying,philanthropic,stanislaw,idols,claremont,conical,haryana,armagh,blended,implicit,conditioned,modulation,rochdale,labourers,coinage,shortstop,potsdam,gears,obesity,bestseller,advisers,bouts,comedians,jozef,lausanne,taxonomic,correlated,columbian,marne,indications,psychologists,libel,edict,beaufort,disadvantages,renal,finalized,racehorse,unconventional,disturbances,falsely,zoology,adorned,redesign,executing,narrower,commended,appliances,stalls,resurgence,saskatoon,miscellaneous,permitting,epoch,formula_11,cumbria,forefront,vedic,eastenders,disposed,supermarkets,rower,inhibitor,magnesium,colourful,yusuf,harrow,formulas,centrally,balancing,ionic,nocturnal,consolidate,ornate,raiding,charismatic,accelerate,nominate,residual,dhabi,commemorates,attribution,uninhabited,mindanao,atrocities,genealogical,romani,applicant,enactment,abstraction,trough,pulpit,minuscule,misconduct,grenades,timely,supplements,messaging,curvature,ceasefire,telangana,susquehanna,braking,redistribution,shreveport,neighbourhoods,gregorian,widowed,khuzestan,empowerment,scholastic,evangelist,peptide,topical,theorist,historia,thence,sudanese,museo,jurisprudence,masurian,frankish,headlined,recounted,netball,petitions,tolerant,hectare,truncated,southend,methane,captives,reigns,massif,subunit,acidic,weightlifting,footballers,sabah,britannia,tunisian,segregated,sawmill,withdrawing,unpaid,weaponry,somme,perceptions,unicode,alcoholism,durban,wrought,waterfalls,jihad,auschwitz,upland,eastbound,adjective,anhalt,evaluating,regimes,guildford,reproduced,pamphlets,hierarchical,maneuvers,hanoi,fabricated,repetition,enriched,arterial,replacements,tides,globalization,adequately,westbound,satisfactory,fleets,phosphorus,lastly,neuroscience,anchors,xinjiang,membranes,improvisation,shipments,orthodoxy,submissions,bolivian,mahmud,ramps,leyte,pastures,outlines,flees,transmitters,fares,sequential,stimulated,novice,alternately,symmetrical,breakaway,layered,baronets,lizards,blackish,edouard,horsepower,penang,principals,mercantile,maldives,overwhelmingly,hawke,rallied,prostate,conscription,juveniles,maccabi,carvings,strikers,sudbury,spurred,improves,lombardy,macquarie,parisian,elastic,distillery,shetland,humane,brentford,wrexham,warehouses,routines,encompassed,introductory,isfahan,instituto,palais,revolutions,sporadic,impoverished,portico,fellowships,speculative,enroll,dormant,adhere,fundamentally,sculpted,meritorious,template,upgrading,reformer,rectory,uncredited,indicative,creeks,galveston,radically,hezbollah,firearm,educating,prohibits,trondheim,locus,refit,headwaters,screenings,lowlands,wasps,coarse,attaining,sedimentary,perished,pitchfork,interned,cerro,stagecoach,aeronautical,liter,transitioned,haydn,inaccurate,legislatures,bromwich,knesset,spectroscopy,butte,asiatic,degraded,concordia,catastrophic,lobes,wellness,pensacola,periphery,hapoel,theta,horizontally,freiburg,liberalism,pleas,durable,warmian,offenses,mesopotamia,shandong,unsuitable,hospitalized,appropriately,phonetic,encompass,conversions,observes,illnesses,breakout,assigns,crowns,inhibitors,nightly,manifestation,fountains,maximize,alphabetical,sloop,expands,newtown,widening,gaddafi,commencing,camouflage,footprint,tyrol,barangays,universite,highlanders,budgets,query,lobbied,westchester,equator,stipulated,pointe,distinguishes,allotted,embankment,advises,storing,loyalists,fourier,rehearsals,starvation,gland,rihanna,tubular,expressive,baccalaureate,intersections,revered,carbonate,eritrea,craftsmen,cosmopolitan,sequencing,corridors,shortlisted,bangladeshi,persians,mimic,parades,repetitive,recommends,flanks,promoters,incompatible,teaming,ammonia,greyhound,solos,improper,legislator,newsweek,recurrent,vitro,cavendish,eireann,crises,prophets,mandir,strategically,guerrillas,formula_12,ghent,contenders,equivalence,drone,sociological,hamid,castes,statehood,aland,clinched,relaunched,tariffs,simulations,williamsburg,rotate,mediation,smallpox,harmonica,lodges,lavish,restrictive,o'sullivan,detainees,polynomials,echoes,intersecting,learners,elects,charlemagne,defiance,epsom,liszt,facilitating,absorbing,revelations,padua,pieter,pious,penultimate,mammalian,montenegrin,supplementary,widows,aromatic,croats,roanoke,trieste,legions,subdistrict,babylonian,grasslands,volga,violently,sparsely,oldies,telecommunication,respondents,quarries,downloadable,commandos,taxpayer,catalytic,malabar,afforded,copying,declines,nawab,junctions,assessing,filtering,classed,disused,compliant,christoph,gottingen,civilizations,hermitage,caledonian,whereupon,ethnically,springsteen,mobilization,terraces,indus,excel,zoological,enrichment,simulate,guitarists,registrar,cappella,invoked,reused,manchu,configured,uppsala,genealogy,mergers,casts,curricular,rebelled,subcontinent,horticultural,parramatta,orchestrated,dockyard,claudius,decca,prohibiting,turkmenistan,brahmin,clandestine,obligatory,elaborated,parasitic,helix,constraint,spearheaded,rotherham,eviction,adapting,albans,rescues,sociologist,guiana,convicts,occurrences,kamen,antennas,asturias,wheeled,sanitary,deterioration,trier,theorists,baseline,announcements,valea,planners,factual,serialized,serials,bilbao,demoted,fission,jamestown,cholera,alleviate,alteration,indefinite,sulfate,paced,climatic,valuation,artisans,proficiency,aegean,regulators,fledgling,sealing,influencing,servicemen,frequented,cancers,tambon,narayan,bankers,clarified,embodied,engraver,reorganisation,dissatisfied,dictated,supplemental,temperance,ratification,puget,nutrient,pretoria,papyrus,uniting,ascribed,cores,coptic,schoolhouse,barrio,1910s,armory,defected,transatlantic,regulates,ported,artefacts,specifies,boasted,scorers,mollusks,emitted,navigable,quakers,projective,dialogues,reunification,exponential,vastly,banners,unsigned,dissipated,halves,coincidentally,leasing,purported,escorting,estimation,foxes,lifespan,inflorescence,assimilation,showdown,staunch,prologue,ligand,superliga,telescopes,northwards,keynote,heaviest,taunton,redeveloped,vocalists,podlaskie,soyuz,rodents,azores,moravian,outset,parentheses,apparel,domestically,authoritative,polymers,monterrey,inhibit,launcher,jordanian,folds,taxis,mandates,singled,liechtenstein,subsistence,marxism,ousted,governorship,servicing,offseason,modernism,prism,devout,translators,islamist,chromosomes,pitted,bedfordshire,fabrication,authoritarian,javanese,leaflets,transient,substantive,predatory,sigismund,assassinate,diagrams,arrays,rediscovered,reclamation,spawning,fjord,peacekeeping,strands,fabrics,highs,regulars,tirana,ultraviolet,athenian,filly,barnet,naacp,nueva,favourites,terminates,showcases,clones,inherently,interpreting,bjorn,finely,lauded,unspecified,chola,pleistocene,insulation,antilles,donetsk,funnel,nutritional,biennale,reactivated,southport,primate,cavaliers,austrians,interspersed,restarted,suriname,amplifiers,wladyslaw,blockbuster,sportsman,minogue,brightness,benches,bridgeport,initiating,israelis,orbiting,newcomers,externally,scaling,transcribed,impairment,luxurious,longevity,impetus,temperament,ceilings,tchaikovsky,spreads,pantheon,bureaucracy,1820s,heraldic,villas,formula_13,galician,meath,avoidance,corresponded,headlining,connacht,seekers,rappers,solids,monograph,scoreless,opole,isotopes,himalayas,parodies,garments,microscopic,republished,havilland,orkney,demonstrators,pathogen,saturated,hellenistic,facilitates,aerodynamic,relocating,indochina,laval,astronomers,bequeathed,administrations,extracts,nagoya,torquay,demography,medicare,ambiguity,renumbered,pursuant,concave,syriac,electrode,dispersal,henan,bialystok,walsall,crystalline,puebla,janata,illumination,tianjin,enslaved,coloration,championed,defamation,grille,johor,rejoin,caspian,fatally,planck,workings,appointing,institutionalized,wessex,modernized,exemplified,regatta,jacobite,parochial,programmers,blending,eruptions,insurrection,regression,indices,sited,dentistry,mobilized,furnishings,levant,primaries,ardent,nagasaki,conqueror,dorchester,opined,heartland,amman,mortally,wellesley,bowlers,outputs,coveted,orthography,immersion,disrepair,disadvantaged,curate,childless,condensed,codice_1,remodeled,resultant,bolsheviks,superfamily,saxons,2010s,contractual,rivalries,malacca,oaxaca,magnate,vertebrae,quezon,olympiad,yucatan,tyres,macro,specialization,commendation,caliphate,gunnery,exiles,excerpts,fraudulent,adjustable,aramaic,interceptor,drumming,standardization,reciprocal,adolescents,federalist,aeronautics,favorably,enforcing,reintroduced,zhejiang,refining,biplane,banknotes,accordion,intersect,illustrating,summits,classmate,militias,biomass,massacres,epidemiology,reworked,wrestlemania,nantes,auditory,taxon,elliptical,chemotherapy,asserting,avoids,proficient,airmen,yellowstone,multicultural,alloys,utilization,seniority,kuyavian,huntsville,orthogonal,bloomington,cultivars,casimir,internment,repulsed,impedance,revolving,fermentation,parana,shutout,partnering,empowered,islamabad,polled,classify,amphibians,greyish,obedience,4x100,projectile,khyber,halfback,relational,d'ivoire,synonyms,endeavour,padma,customized,mastery,defenceman,berber,purge,interestingly,covent,promulgated,restricting,condemnation,hillsborough,walkers,privateer,intra,captaincy,naturalized,huffington,detecting,hinted,migrating,bayou,counterattack,anatomical,foraging,unsafe,swiftly,outdated,paraguayan,attire,masjid,endeavors,jerseys,triassic,quechua,growers,axial,accumulate,wastewater,cognition,fungal,animator,pagoda,kochi,uniformly,antibody,yerevan,hypotheses,combatants,italianate,draining,fragmentation,snowfall,formative,inversion,kitchener,identifier,additive,lucha,selects,ashland,cambrian,racetrack,trapping,congenital,primates,wavelengths,expansions,yeomanry,harcourt,wealthiest,awaited,punta,intervening,aggressively,vichy,piloted,midtown,tailored,heyday,metadata,guadalcanal,inorganic,hadith,pulses,francais,tangent,scandals,erroneously,tractors,pigment,constabulary,jiangsu,landfill,merton,basalt,astor,forbade,debuts,collisions,exchequer,stadion,roofed,flavour,sculptors,conservancy,dissemination,electrically,undeveloped,existent,surpassing,pentecostal,manifested,amend,formula_14,superhuman,barges,tunis,analytics,argyll,liquids,mechanized,domes,mansions,himalayan,indexing,reuters,nonlinear,purification,exiting,timbers,triangles,decommissioning,departmental,causal,fonts,americana,sept.,seasonally,incomes,razavi,sheds,memorabilia,rotational,terre,sutra,protege,yarmouth,grandmaster,annum,looted,imperialism,variability,liquidation,baptised,isotope,showcasing,milling,rationale,hammersmith,austen,streamlined,acknowledging,contentious,qaleh,breadth,turing,referees,feral,toulon,unofficially,identifiable,standout,labeling,dissatisfaction,jurgen,angrily,featherweight,cantons,constrained,dominates,standalone,relinquished,theologians,markedly,italics,downed,nitrate,likened,gules,craftsman,singaporean,pixels,mandela,moray,parity,departement,antigen,academically,burgh,brahma,arranges,wounding,triathlon,nouveau,vanuatu,banded,acknowledges,unearthed,stemming,authentication,byzantines,converge,nepali,commonplace,deteriorating,recalling,palette,mathematicians,greenish,pictorial,ahmedabad,rouen,validation,u.s.a.,'best,malvern,archers,converter,undergoes,fluorescent,logistical,notification,transvaal,illicit,symphonies,stabilization,worsened,fukuoka,decrees,enthusiast,seychelles,blogger,louvre,dignitaries,burundi,wreckage,signage,pinyin,bursts,federer,polarization,urbana,lazio,schism,nietzsche,venerable,administers,seton,kilograms,invariably,kathmandu,farmed,disqualification,earldom,appropriated,fluctuations,kermanshah,deployments,deformation,wheelbase,maratha,psalm,bytes,methyl,engravings,skirmish,fayette,vaccines,ideally,astrology,breweries,botanic,opposes,harmonies,irregularities,contended,gaulle,prowess,constants,aground,filipinos,fresco,ochreous,jaipur,willamette,quercus,eastwards,mortars,champaign,braille,reforming,horned,hunan,spacious,agitation,draught,specialties,flourishing,greensboro,necessitated,swedes,elemental,whorls,hugely,structurally,plurality,synthesizers,embassies,assad,contradictory,inference,discontent,recreated,inspectors,unicef,commuters,embryo,modifying,stints,numerals,communicated,boosted,trumpeter,brightly,adherence,remade,leases,restrained,eucalyptus,dwellers,planar,grooves,gainesville,daimler,anzac,szczecin,cornerback,prized,peking,mauritania,khalifa,motorized,lodging,instrumentalist,fortresses,cervical,formula_15,passerine,sectarian,researches,apprenticed,reliefs,disclose,gliding,repairing,queue,kyushu,literate,canoeing,sacrament,separatist,calabria,parkland,flowed,investigates,statistically,visionary,commits,dragoons,scrolls,premieres,revisited,subdued,censored,patterned,elective,outlawed,orphaned,leyland,richly,fujian,miniatures,heresy,plaques,countered,nonfiction,exponent,moravia,dispersion,marylebone,midwestern,enclave,ithaca,federated,electronically,handheld,microscopy,tolls,arrivals,climbers,continual,cossacks,moselle,deserts,ubiquitous,gables,forecasts,deforestation,vertebrates,flanking,drilled,superstructure,inspected,consultative,bypassed,ballast,subsidy,socioeconomic,relic,grenada,journalistic,administering,accommodated,collapses,appropriation,reclassified,foreword,porte,assimilated,observance,fragmented,arundel,thuringia,gonzaga,shenzhen,shipyards,sectional,ayrshire,sloping,dependencies,promenade,ecuadorian,mangrove,constructs,goalscorer,heroism,iteration,transistor,omnibus,hampstead,cochin,overshadowed,chieftain,scalar,finishers,ghanaian,abnormalities,monoplane,encyclopaedia,characterize,travancore,baronetage,bearers,biking,distributes,paving,christened,inspections,banco,humber,corinth,quadratic,albanians,lineages,majored,roadside,inaccessible,inclination,darmstadt,fianna,epilepsy,propellers,papacy,montagu,bhutto,sugarcane,optimized,pilasters,contend,batsmen,brabant,housemates,sligo,ascot,aquinas,supervisory,accorded,gerais,echoed,nunavut,conservatoire,carniola,quartermaster,gminas,impeachment,aquitaine,reformers,quarterfinal,karlsruhe,accelerator,coeducational,archduke,gelechiidae,seaplane,dissident,frenchman,palau,depots,hardcover,aachen,darreh,denominational,groningen,parcels,reluctance,drafts,elliptic,counters,decreed,airship,devotional,contradiction,formula_16,undergraduates,qualitative,guatemalan,slavs,southland,blackhawks,detrimental,abolish,chechen,manifestations,arthritis,perch,fated,hebei,peshawar,palin,immensely,havre,totalling,rampant,ferns,concourse,triples,elites,olympian,larva,herds,lipid,karabakh,distal,monotypic,vojvodina,batavia,multiplied,spacing,spellings,pedestrians,parchment,glossy,industrialization,dehydrogenase,patriotism,abolitionist,mentoring,elizabethan,figurative,dysfunction,abyss,constantin,middletown,stigma,mondays,gambia,gaius,israelites,renounced,nepalese,overcoming,buren,sulphur,divergence,predation,looting,iberia,futuristic,shelved,anthropological,innsbruck,escalated,clermont,entrepreneurial,benchmark,mechanically,detachments,populist,apocalyptic,exited,embryonic,stanza,readership,chiba,landlords,expansive,boniface,therapies,perpetrators,whitehall,kassel,masts,carriageway,clinch,pathogens,mazandaran,undesirable,teutonic,miocene,nagpur,juris,cantata,compile,diffuse,dynastic,reopening,comptroller,o'neal,flourish,electing,scientifically,departs,welded,modal,cosmology,fukushima,libertadores,chang'an,asean,generalization,localization,afrikaans,cricketers,accompanies,emigrants,esoteric,southwards,shutdown,prequel,fittings,innate,wrongly,equitable,dictionaries,senatorial,bipolar,flashbacks,semitism,walkway,lyrically,legality,sorbonne,vigorously,durga,samoan,karel,interchanges,patna,decider,registering,electrodes,anarchists,excursion,overthrown,gilan,recited,michelangelo,advertiser,kinship,taboo,cessation,formula_17,premiers,traversed,madurai,poorest,torneo,exerted,replicate,spelt,sporadically,horde,landscaping,razed,hindered,esperanto,manchuria,propellant,jalan,baha'is,sikkim,linguists,pandit,racially,ligands,dowry,francophone,escarpment,behest,magdeburg,mainstay,villiers,yangtze,grupo,conspirators,martyrdom,noticeably,lexical,kazakh,unrestricted,utilised,sired,inhabits,proofs,joseon,pliny,minted,buddhists,cultivate,interconnected,reuse,viability,australasian,derelict,resolving,overlooks,menon,stewardship,playwrights,thwarted,filmfare,disarmament,protections,bundles,sidelined,hypothesized,singer/songwriter,forage,netted,chancery,townshend,restructured,quotation,hyperbolic,succumbed,parliaments,shenandoah,apical,kibbutz,storeys,pastors,lettering,ukrainians,hardships,chihuahua,avail,aisles,taluka,antisemitism,assent,ventured,banksia,seamen,hospice,faroe,fearful,woreda,outfield,chlorine,transformer,tatar,panoramic,pendulum,haarlem,styria,cornice,importing,catalyzes,subunits,enamel,bakersfield,realignment,sorties,subordinates,deanery,townland,gunmen,tutelage,evaluations,allahabad,thrace,veneto,mennonite,sharia,subgenus,satisfies,puritan,unequal,gastrointestinal,ordinances,bacterium,horticulture,argonauts,adjectives,arable,duets,visualization,woolwich,revamped,euroleague,thorax,completes,originality,vasco,freighter,sardar,oratory,sects,extremes,signatories,exporting,arisen,exacerbated,departures,saipan,furlongs,d'italia,goring,dakar,conquests,docked,offshoot,okrug,referencing,disperse,netting,summed,rewritten,articulation,humanoid,spindle,competitiveness,preventive,facades,westinghouse,wycombe,synthase,emulate,fostering,abdel,hexagonal,myriad,caters,arjun,dismay,axiom,psychotherapy,colloquial,complemented,martinique,fractures,culmination,erstwhile,atrium,electronica,anarchism,nadal,montpellier,algebras,submitting,adopts,stemmed,overcame,internacional,asymmetric,gallipoli,gliders,flushing,extermination,hartlepool,tesla,interwar,patriarchal,hitherto,ganges,combatant,marred,philology,glastonbury,reversible,isthmus,undermined,southwark,gateshead,andalusia,remedies,hastily,optimum,smartphone,evade,patrolled,beheaded,dopamine,waivers,ugandan,gujarati,densities,predicting,intestinal,tentative,interstellar,kolonia,soloists,penetrated,rebellions,qeshlaq,prospered,colegio,deficits,konigsberg,deficient,accessing,relays,kurds,politburo,codified,incarnations,occupancy,cossack,metaphysical,deprivation,chopra,piccadilly,formula_18,makeshift,protestantism,alaskan,frontiers,faiths,tendon,dunkirk,durability,autobots,bonuses,coinciding,emails,gunboat,stucco,magma,neutrons,vizier,subscriptions,visuals,envisaged,carpets,smoky,schema,parliamentarian,immersed,domesticated,parishioners,flinders,diminutive,mahabharata,ballarat,falmouth,vacancies,gilded,twigs,mastering,clerics,dalmatia,islington,slogans,compressor,iconography,congolese,sanction,blends,bulgarians,moderator,outflow,textures,safeguard,trafalgar,tramways,skopje,colonialism,chimneys,jazeera,organisers,denoting,motivations,ganga,longstanding,deficiencies,gwynedd,palladium,holistic,fascia,preachers,embargo,sidings,busan,ignited,artificially,clearwater,cemented,northerly,salim,equivalents,crustaceans,oberliga,quadrangle,historiography,romanians,vaults,fiercely,incidental,peacetime,tonal,bhopal,oskar,radha,pesticides,timeslot,westerly,cathedrals,roadways,aldershot,connectors,brahmins,paler,aqueous,gustave,chromatic,linkage,lothian,specialises,aggregation,tributes,insurgent,enact,hampden,ghulam,federations,instigated,lyceum,fredrik,chairmanship,floated,consequent,antagonists,intimidation,patriarchate,warbler,heraldry,entrenched,expectancy,habitation,partitions,widest,launchers,nascent,ethos,wurzburg,lycee,chittagong,mahatma,merseyside,asteroids,yokosuka,cooperatives,quorum,redistricting,bureaucratic,yachts,deploying,rustic,phonology,chorale,cellist,stochastic,crucifixion,surmounted,confucian,portfolios,geothermal,crested,calibre,tropics,deferred,nasir,iqbal,persistence,essayist,chengdu,aborigines,fayetteville,bastion,interchangeable,burlesque,kilmarnock,specificity,tankers,colonels,fijian,quotations,enquiry,quito,palmerston,delle,multidisciplinary,polynesian,iodine,antennae,emphasised,manganese,baptists,galilee,jutland,latent,excursions,skepticism,tectonic,precursors,negligible,musique,misuse,vitoria,expressly,veneration,sulawesi,footed,mubarak,chongqing,chemically,midday,ravaged,facets,varma,yeovil,ethnographic,discounted,physicists,attache,disbanding,essen,shogunate,cooperated,waikato,realising,motherwell,pharmacology,sulfide,inward,expatriate,devoid,cultivar,monde,andean,groupings,goran,unaffected,moldovan,postdoctoral,coleophora,delegated,pronoun,conductivity,coleridge,disapproval,reappeared,microbial,campground,olsztyn,fostered,vaccination,rabbinical,champlain,milestones,viewership,caterpillar,effected,eupithecia,financier,inferred,uzbek,bundled,bandar,balochistan,mysticism,biosphere,holotype,symbolizes,lovecraft,photons,abkhazia,swaziland,subgroups,measurable,falkirk,valparaiso,ashok,discriminatory,rarity,tabernacle,flyweight,jalisco,westernmost,antiquarian,extracellular,margrave,colspan=9,midsummer,digestive,reversing,burgeoning,substitutes,medallist,khrushchev,guerre,folio,detonated,partido,plentiful,aggregator,medallion,infiltration,shaded,santander,fared,auctioned,permian,ramakrishna,andorra,mentors,diffraction,bukit,potentials,translucent,feminists,tiers,protracted,coburg,wreath,guelph,adventurer,he/she,vertebrate,pipelines,celsius,outbreaks,australasia,deccan,garibaldi,unionists,buildup,biochemical,reconstruct,boulders,stringent,barbed,wording,furnaces,pests,befriends,organises,popes,rizal,tentacles,cadre,tallahassee,punishments,occidental,formatted,mitigation,rulings,rubens,cascades,inducing,choctaw,volta,synagogues,movable,altarpiece,mitigate,practise,intermittently,encountering,memberships,earns,signify,retractable,amounting,pragmatic,wilfrid,dissenting,divergent,kanji,reconstituted,devonian,constitutions,levied,hendrik,starch,costal,honduran,ditches,polygon,eindhoven,superstars,salient,argus,punitive,purana,alluvial,flaps,inefficient,retracted,advantageous,quang,andersson,danville,binghamton,symbolize,conclave,shaanxi,silica,interpersonal,adept,frans,pavilions,lubbock,equip,sunken,limburg,activates,prosecutions,corinthian,venerated,shootings,retreats,parapet,orissa,riviere,animations,parodied,offline,metaphysics,bluffs,plume,piety,fruition,subsidized,steeplechase,shanxi,eurasia,angled,forecasting,suffragan,ashram,larval,labyrinth,chronicler,summaries,trailed,merges,thunderstorms,filtered,formula_19,advertisers,alpes,informatics,parti,constituting,undisputed,certifications,javascript,molten,sclerosis,rumoured,boulogne,hmong,lewes,breslau,notts,bantu,ducal,messengers,radars,nightclubs,bantamweight,carnatic,kaunas,fraternal,triggering,controversially,londonderry,visas,scarcity,offaly,uprisings,repelled,corinthians,pretext,kuomintang,kielce,empties,matriculated,pneumatic,expos,agile,treatises,midpoint,prehistory,oncology,subsets,hydra,hypertension,axioms,wabash,reiterated,swapped,achieves,premio,ageing,overture,curricula,challengers,subic,selangor,liners,frontline,shutter,validated,normalized,entertainers,molluscs,maharaj,allegation,youngstown,synth,thoroughfare,regionally,pillai,transcontinental,pedagogical,riemann,colonia,easternmost,tentatively,profiled,herefordshire,nativity,meuse,nucleotide,inhibits,huntingdon,throughput,recorders,conceding,domed,homeowners,centric,gabled,canoes,fringes,breeder,subtitled,fluoride,haplogroup,zionism,izmir,phylogeny,kharkiv,romanticism,adhesion,usaaf,delegations,lorestan,whalers,biathlon,vaulted,mathematically,pesos,skirmishes,heisman,kalamazoo,gesellschaft,launceston,interacts,quadruple,kowloon,psychoanalysis,toothed,ideologies,navigational,valence,induces,lesotho,frieze,rigging,undercarriage,explorations,spoof,eucharist,profitability,virtuoso,recitals,subterranean,sizeable,herodotus,subscriber,huxley,pivot,forewing,warring,boleslaw,bharatiya,suffixes,trois,percussionist,downturn,garrisons,philosophies,chants,mersin,mentored,dramatist,guilds,frameworks,thermodynamic,venomous,mehmed,assembling,rabbinic,hegemony,replicas,enlargement,claimant,retitled,utica,dumfries,metis,deter,assortment,tubing,afflicted,weavers,rupture,ornamentation,transept,salvaged,upkeep,callsign,rajput,stevenage,trimmed,intracellular,synchronization,consular,unfavorable,royalists,goldwyn,fasting,hussars,doppler,obscurity,currencies,amiens,acorn,tagore,townsville,gaussian,migrations,porta,anjou,graphite,seaport,monographs,gladiators,metrics,calligraphy,sculptural,swietokrzyskie,tolombeh,eredivisie,shoals,queries,carts,exempted,fiberglass,mirrored,bazar,progeny,formalized,mukherjee,professed,amazon.com,cathode,moreton,removable,mountaineers,nagano,transplantation,augustinian,steeply,epilogue,adapter,decisively,accelerating,mediaeval,substituting,tasman,devonshire,litres,enhancements,himmler,nephews,bypassing,imperfect,argentinian,reims,integrates,sochi,ascii,licences,niches,surgeries,fables,versatility,indra,footpath,afonso,crore,evaporation,encodes,shelling,conformity,simplify,updating,quotient,overt,firmware,umpires,architectures,eocene,conservatism,secretion,embroidery,f.c..,tuvalu,mosaics,shipwreck,prefectural,cohort,grievances,garnering,centerpiece,apoptosis,djibouti,bethesda,formula_20,shonen,richland,justinian,dormitories,meteorite,reliably,obtains,pedagogy,hardness,cupola,manifolds,amplification,steamers,familial,dumbarton,jerzy,genital,maidstone,salinity,grumman,signifies,presbytery,meteorology,procured,aegis,streamed,deletion,nuestra,mountaineering,accords,neuronal,khanate,grenoble,axles,dispatches,tokens,turku,auctions,propositions,planters,proclaiming,recommissioned,stravinsky,obverse,bombarded,waged,saviour,massacred,reformist,purportedly,resettlement,ravenna,embroiled,minden,revitalization,hikers,bridging,torpedoed,depletion,nizam,affectionately,latitudes,lubeck,spore,polymerase,aarhus,nazism,101st,buyout,galerie,diets,overflow,motivational,renown,brevet,deriving,melee,goddesses,demolish,amplified,tamworth,retake,brokerage,beneficiaries,henceforth,reorganised,silhouette,browsers,pollutants,peron,lichfield,encircled,defends,bulge,dubbing,flamenco,coimbatore,refinement,enshrined,grizzlies,capacitor,usefulness,evansville,interscholastic,rhodesian,bulletins,diamondbacks,rockers,platted,medalists,formosa,transporter,slabs,guadeloupe,disparate,concertos,violins,regaining,mandible,untitled,agnostic,issuance,hamiltonian,brampton,srpska,homology,downgraded,florentine,epitaph,kanye,rallying,analysed,grandstand,infinitely,antitrust,plundered,modernity,colspan=3|total,amphitheatre,doric,motorists,yemeni,carnivorous,probabilities,prelate,struts,scrapping,bydgoszcz,pancreatic,signings,predicts,compendium,ombudsman,apertura,appoints,rebbe,stereotypical,valladolid,clustered,touted,plywood,inertial,kettering,curving,d'honneur,housewives,grenadier,vandals,barbarossa,necked,waltham,reputedly,jharkhand,cistercian,pursues,viscosity,organiser,cloister,islet,stardom,moorish,himachal,strives,scripps,staggered,blasts,westwards,millimeters,angolan,hubei,agility,admirals,mordellistena,coincides,platte,vehicular,cordillera,riffs,schoolteacher,canaan,acoustics,tinged,reinforcing,concentrates,daleks,monza,selectively,musik,polynesia,exporter,reviving,macclesfield,bunkers,ballets,manors,caudal,microbiology,primes,unbroken,outcry,flocks,pakhtunkhwa,abelian,toowoomba,luminous,mould,appraisal,leuven,experimentally,interoperability,hideout,perak,specifying,knighthood,vasily,excerpt,computerized,niels,networked,byzantium,reaffirmed,geographer,obscured,fraternities,mixtures,allusion,accra,lengthened,inquest,panhandle,pigments,revolts,bluetooth,conjugate,overtaken,foray,coils,breech,streaks,impressionist,mendelssohn,intermediary,panned,suggestive,nevis,upazila,rotunda,mersey,linnaeus,anecdotes,gorbachev,viennese,exhaustive,moldavia,arcades,irrespective,orator,diminishing,predictive,cohesion,polarized,montage,avian,alienation,conus,jaffna,urbanization,seawater,extremity,editorials,scrolling,dreyfus,traverses,topographic,gunboats,extratropical,normans,correspondents,recognises,millennia,filtration,ammonium,voicing,complied,prefixes,diplomas,figurines,weakly,gated,oscillator,lucerne,embroidered,outpatient,airframe,fractional,disobedience,quarterbacks,formula_21,shinto,chiapas,epistle,leakage,pacifist,avignon,penrith,renders,mantua,screenplays,gustaf,tesco,alphabetically,rations,discharges,headland,tapestry,manipur,boolean,mediator,ebenezer,subchannel,fable,bestselling,ateneo,trademarks,recurrence,dwarfs,britannica,signifying,vikram,mediate,condensation,censuses,verbandsgemeinde,cartesian,sprang,surat,britons,chelmsford,courtenay,statistic,retina,abortions,liabilities,closures,mississauga,skyscrapers,saginaw,compounded,aristocrat,msnbc,stavanger,septa,interpretive,hinder,visibly,seeding,shutouts,irregularly,quebecois,footbridge,hydroxide,implicitly,lieutenants,simplex,persuades,midshipman,heterogeneous,officiated,crackdown,lends,tartu,altars,fractions,dissidents,tapered,modernisation,scripting,blazon,aquaculture,thermodynamics,sistan,hasidic,bellator,pavia,propagated,theorized,bedouin,transnational,mekong,chronicled,declarations,kickstarter,quotas,runtime,duquesne,broadened,clarendon,brownsville,saturation,tatars,electorates,malayan,replicated,observable,amphitheater,endorsements,referral,allentown,mormons,pantomime,eliminates,typeface,allegorical,varna,conduction,evoke,interviewer,subordinated,uyghur,landscaped,conventionally,ascend,edifice,postulated,hanja,whitewater,embarking,musicologist,tagalog,frontage,paratroopers,hydrocarbons,transliterated,nicolae,viewpoints,surrealist,asheville,falklands,hacienda,glide,opting,zimbabwean,discal,mortgages,nicaraguan,yadav,ghosh,abstracted,castilian,compositional,cartilage,intergovernmental,forfeited,importation,rapping,artes,republika,narayana,condominium,frisian,bradman,duality,marche,extremist,phosphorylation,genomes,allusions,valencian,habeas,ironworks,multiplex,harpsichord,emigrate,alternated,breda,waffen,smartphones,familiarity,regionalliga,herbaceous,piping,dilapidated,carboniferous,xviii,critiques,carcinoma,sagar,chippewa,postmodern,neapolitan,excludes,notoriously,distillation,tungsten,richness,installments,monoxide,chand,privatisation,molded,maths,projectiles,luoyang,epirus,lemma,concentric,incline,erroneous,sideline,gazetted,leopards,fibres,renovate,corrugated,unilateral,repatriation,orchestration,saeed,rockingham,loughborough,formula_22,bandleader,appellation,openness,nanotechnology,massively,tonnage,dunfermline,exposes,moored,ridership,motte,eurobasket,majoring,feats,silla,laterally,playlist,downwards,methodologies,eastbourne,daimyo,cellulose,leyton,norwalk,oblong,hibernian,opaque,insular,allegory,camogie,inactivation,favoring,masterpieces,rinpoche,serotonin,portrayals,waverley,airliner,longford,minimalist,outsourcing,excise,meyrick,qasim,organisational,synaptic,farmington,gorges,scunthorpe,zoned,tohoku,librarians,davao,decor,theatrically,brentwood,pomona,acquires,planter,capacitors,synchronous,skateboarding,coatings,turbocharged,ephraim,capitulation,scoreboard,hebrides,ensues,cereals,ailing,counterpoint,duplication,antisemitic,clique,aichi,oppressive,transcendental,incursions,rename,renumbering,powys,vestry,bitterly,neurology,supplanted,affine,susceptibility,orbiter,activating,overlaps,ecoregion,raman,canoer,darfur,microorganisms,precipitated,protruding,torun,anthropologists,rennes,kangaroos,parliamentarians,edits,littoral,archived,begum,rensselaer,microphones,ypres,empower,etruscan,wisden,montfort,calibration,isomorphic,rioting,kingship,verbally,smyrna,cohesive,canyons,fredericksburg,rahul,relativistic,micropolitan,maroons,industrialized,henchmen,uplift,earthworks,mahdi,disparity,cultured,transliteration,spiny,fragmentary,extinguished,atypical,inventors,biosynthesis,heralded,curacao,anomalies,aeroplane,surya,mangalore,maastricht,ashkenazi,fusiliers,hangzhou,emitting,monmouthshire,schwarzenegger,ramayana,peptides,thiruvananthapuram,alkali,coimbra,budding,reasoned,epithelial,harbors,rudimentary,classically,parque,ealing,crusades,rotations,riparian,pygmy,inertia,revolted,microprocessor,calendars,solvents,kriegsmarine,accademia,cheshmeh,yoruba,ardabil,mitra,genomic,notables,propagate,narrates,univision,outposts,polio,birkenhead,urinary,crocodiles,pectoral,barrymore,deadliest,rupees,chaim,protons,comical,astrophysics,unifying,formula_23,vassals,cortical,audubon,pedals,tenders,resorted,geophysical,lenders,recognising,tackling,lanarkshire,doctrinal,annan,combating,guangxi,estimating,selectors,tribunals,chambered,inhabiting,exemptions,curtailed,abbasid,kandahar,boron,bissau,150th,codenamed,wearer,whorl,adhered,subversive,famer,smelting,inserting,mogadishu,zoologist,mosul,stumps,almanac,olympiacos,stamens,participatory,cults,honeycomb,geologists,dividend,recursive,skiers,reprint,pandemic,liber,percentages,adversely,stoppage,chieftains,tubingen,southerly,overcrowding,unorganized,hangars,fulfil,hails,cantilever,woodbridge,pinus,wiesbaden,fertilization,fluorescence,enhances,plenary,troublesome,episodic,thrissur,kickboxing,allele,staffing,garda,televisions,philatelic,spacetime,bullpen,oxides,leninist,enrolling,inventive,truro,compatriot,ruskin,normative,assay,gotha,murad,illawarra,gendarmerie,strasse,mazraeh,rebounded,fanfare,liaoning,rembrandt,iranians,emirate,governs,latency,waterfowl,chairmen,katowice,aristocrats,eclipsed,sentient,sonatas,interplay,sacking,decepticons,dynamical,arbitrarily,resonant,petar,velocities,alludes,wastes,prefectures,belleville,sensibility,salvadoran,consolidating,medicaid,trainees,vivekananda,molar,porous,upload,youngster,infused,doctorates,wuhan,annihilation,enthusiastically,gamespot,kanpur,accumulating,monorail,operetta,tiling,sapporo,finns,calvinist,hydrocarbon,sparrows,orienteering,cornelis,minster,vuelta,plebiscite,embraces,panchayats,focussed,remediation,brahman,olfactory,reestablished,uniqueness,northumbria,rwandan,predominately,abode,ghats,balances,californian,uptake,bruges,inert,westerns,reprints,cairn,yarra,resurfaced,audible,rossini,regensburg,italiana,fleshy,irrigated,alerts,yahya,varanasi,marginalized,expatriates,cantonment,normandie,sahitya,directives,rounder,hulls,fictionalized,constables,inserts,hipped,potosi,navies,biologists,canteen,husbandry,augment,fortnight,assamese,kampala,o'keefe,paleolithic,bluish,promontory,consecutively,striving,niall,reuniting,dipole,friendlies,disapproved,thrived,netflix,liberian,dielectric,medway,strategist,sankt,pickups,hitters,encode,rerouted,claimants,anglesey,partitioned,cavan,flutes,reared,repainted,armaments,bowed,thoracic,balliol,piero,chaplains,dehestan,sender,junkers,sindhi,sickle,dividends,metallurgy,honorific,berths,namco,springboard,resettled,gansu,copyrighted,criticizes,utopian,bendigo,ovarian,binomial,spaceflight,oratorio,proprietors,supergroup,duplicated,foreground,strongholds,revolved,optimize,layouts,westland,hurler,anthropomorphic,excelsior,merchandising,reeds,vetoed,cryptography,hollyoaks,monash,flooring,ionian,resilience,johnstown,resolves,lawmakers,alegre,wildcards,intolerance,subculture,selector,slums,formulate,bayonet,istvan,restitution,interchangeably,awakens,rostock,serpentine,oscillation,reichstag,phenotype,recessed,piotr,annotated,preparedness,consultations,clausura,preferential,euthanasia,genoese,outcrops,freemasonry,geometrical,genesee,islets,prometheus,panamanian,thunderbolt,terraced,stara,shipwrecks,futebol,faroese,sharqi,aldermen,zeitung,unify,formula_24,humanism,syntactic,earthen,blyth,taxed,rescinded,suleiman,cymru,dwindled,vitality,superieure,resupply,adolphe,ardennes,rajiv,profiling,olympique,gestation,interfaith,milosevic,tagline,funerary,druze,silvery,plough,shrubland,relaunch,disband,nunatak,minimizing,excessively,waned,attaching,luminosity,bugle,encampment,electrostatic,minesweeper,dubrovnik,rufous,greenock,hochschule,assyrians,extracting,malnutrition,priya,attainment,anhui,connotations,predicate,seabirds,deduced,pseudonyms,gopal,plovdiv,refineries,imitated,kwazulu,terracotta,tenets,discourses,brandeis,whigs,dominions,pulmonate,landslides,tutors,determinant,richelieu,farmstead,tubercles,technicolor,hegel,redundancy,greenpeace,shortening,mules,distilled,xxiii,fundamentalist,acrylic,outbuildings,lighted,corals,signaled,transistors,cavite,austerity,76ers,exposures,dionysius,outlining,commutative,permissible,knowledgeable,howrah,assemblage,inhibited,crewmen,mbit/s,pyramidal,aberdeenshire,bering,rotates,atheism,howitzer,saone,lancet,fermented,contradicted,materiel,ofsted,numeric,uniformity,josephus,nazarene,kuwaiti,noblemen,pediment,emergent,campaigner,akademi,murcia,perugia,gallen,allsvenskan,finned,cavities,matriculation,rosters,twickenham,signatory,propel,readable,contends,artisan,flamboyant,reggio,italo,fumbles,widescreen,rectangle,centimetres,collaborates,envoys,rijeka,phonological,thinly,refractive,civilisation,reductase,cognate,dalhousie,monticello,lighthouses,jitsu,luneburg,socialite,fermi,collectible,optioned,marquee,jokingly,architecturally,kabir,concubine,nationalisation,watercolor,wicklow,acharya,pooja,leibniz,rajendra,nationalized,stalemate,bloggers,glutamate,uplands,shivaji,carolingian,bucuresti,dasht,reappears,muscat,functionally,formulations,hinged,hainan,catechism,autosomal,incremental,asahi,coeur,diversification,multilateral,fewest,recombination,finisher,harrogate,hangul,feasts,photovoltaic,paget,liquidity,alluded,incubation,applauded,choruses,malagasy,hispanics,bequest,underparts,cassava,kazimierz,gastric,eradication,mowtowr,tyrosine,archbishopric,e9e9e9,unproductive,uxbridge,hydrolysis,harbours,officio,deterministic,devonport,kanagawa,breaches,freetown,rhinoceros,chandigarh,janos,sanatorium,liberator,inequalities,agonist,hydrophobic,constructors,nagorno,snowboarding,welcomes,subscribed,iloilo,resuming,catalysts,stallions,jawaharlal,harriers,definitively,roughriders,hertford,inhibiting,elgar,randomized,incumbents,episcopate,rainforests,yangon,improperly,kemal,interpreters,diverged,uttarakhand,umayyad,phnom,panathinaikos,shabbat,diode,jiangxi,forbidding,nozzle,artistry,licensee,processions,staffs,decimated,expressionism,shingle,palsy,ontology,mahayana,maribor,sunil,hostels,edwardian,jetty,freehold,overthrew,eukaryotic,schuylkill,rawalpindi,sheath,recessive,ferenc,mandibles,berlusconi,confessor,convergent,ababa,slugging,rentals,sephardic,equivalently,collagen,markov,dynamically,hailing,depressions,sprawling,fairgrounds,indistinguishable,plutarch,pressurized,banff,coldest,braunschweig,mackintosh,sociedad,wittgenstein,tromso,airbase,lecturers,subtitle,attaches,purified,contemplated,dreamworks,telephony,prophetic,rockland,aylesbury,biscay,coherence,aleksandar,judoka,pageants,theses,homelessness,luthor,sitcoms,hinterland,fifths,derwent,privateers,enigmatic,nationalistic,instructs,superimposed,conformation,tricycle,dusan,attributable,unbeknownst,laptops,etching,archbishops,ayatollah,cranial,gharbi,interprets,lackawanna,abingdon,saltwater,tories,lender,minaj,ancillary,ranching,pembrokeshire,topographical,plagiarism,murong,marque,chameleon,assertions,infiltrated,guildhall,reverence,schenectady,formula_25,kollam,notary,mexicana,initiates,abdication,basra,theorems,ionization,dismantling,eared,censors,budgetary,numeral,verlag,excommunicated,distinguishable,quarried,cagliari,hindustan,symbolizing,watertown,descartes,relayed,enclosures,militarily,sault,devolved,dalian,djokovic,filaments,staunton,tumour,curia,villainous,decentralized,galapagos,moncton,quartets,onscreen,necropolis,brasileiro,multipurpose,alamos,comarca,jorgen,concise,mercia,saitama,billiards,entomologist,montserrat,lindbergh,commuting,lethbridge,phoenician,deviations,anaerobic,denouncing,redoubt,fachhochschule,principalities,negros,announcers,seconded,parrots,konami,revivals,approving,devotee,riyadh,overtook,morecambe,lichen,expressionist,waterline,silverstone,geffen,sternites,aspiration,behavioural,grenville,tripura,mediums,genders,pyotr,charlottesville,sacraments,programmable,ps100,shackleton,garonne,sumerian,surpass,authorizing,interlocking,lagoons,voiceless,advert,steeple,boycotted,alouettes,yosef,oxidative,sassanid,benefiting,sayyid,nauru,predetermined,idealism,maxillary,polymerization,semesters,munchen,conor,outfitted,clapham,progenitor,gheorghe,observational,recognitions,numerically,colonized,hazrat,indore,contaminants,fatality,eradicate,assyria,convocation,cameos,skillful,skoda,corfu,confucius,overtly,ramadan,wollongong,placements,d.c..,permutation,contemporaneous,voltages,elegans,universitat,samar,plunder,dwindling,neuter,antonin,sinhala,campania,solidified,stanzas,fibrous,marburg,modernize,sorcery,deutscher,florets,thakur,disruptive,infielder,disintegration,internazionale,vicariate,effigy,tripartite,corrective,klamath,environs,leavenworth,sandhurst,workmen,compagnie,hoseynabad,strabo,palisades,ordovician,sigurd,grandsons,defection,viacom,sinhalese,innovator,uncontrolled,slavonic,indexes,refrigeration,aircrew,superbike,resumption,neustadt,confrontations,arras,hindenburg,ripon,embedding,isomorphism,dwarves,matchup,unison,lofty,argos,louth,constitutionally,transitive,newington,facelift,degeneration,perceptual,aviators,enclosing,igneous,symbolically,academician,constitutionality,iso/iec,sacrificial,maturation,apprentices,enzymology,naturalistic,hajji,arthropods,abbess,vistula,scuttled,gradients,pentathlon,etudes,freedmen,melaleuca,thrice,conductive,sackville,franciscans,stricter,golds,kites,worshiped,monsignor,trios,orally,tiered,primacy,bodywork,castleford,epidemics,alveolar,chapelle,chemists,hillsboro,soulful,warlords,ngati,huguenot,diurnal,remarking,luger,motorways,gauss,jahan,cutoff,proximal,bandai,catchphrase,jonubi,ossetia,codename,codice_2,throated,itinerant,chechnya,riverfront,leela,evoked,entailed,zamboanga,rejoining,circuitry,haymarket,khartoum,feuds,braced,miyazaki,mirren,lubusz,caricature,buttresses,attrition,characterizes,widnes,evanston,materialism,contradictions,marist,midrash,gainsborough,ulithi,turkmen,vidya,escuela,patrician,inspirations,reagent,premierships,humanistic,euphrates,transitioning,belfry,zedong,adaption,kaliningrad,lobos,epics,waiver,coniferous,polydor,inductee,refitted,moraine,unsatisfactory,worsening,polygamy,rajya,nested,subgenre,broadside,stampeders,lingua,incheon,pretender,peloton,persuading,excitation,multan,predates,tonne,brackish,autoimmune,insulated,podcasts,iraqis,bodybuilding,condominiums,midlothian,delft,debtor,asymmetrical,lycaenidae,forcefully,pathogenic,tamaulipas,andaman,intravenous,advancements,senegalese,chronologically,realigned,inquirer,eusebius,dekalb,additives,shortlist,goldwater,hindustani,auditing,caterpillars,pesticide,nakhon,ingestion,lansdowne,traditionalist,northland,thunderbirds,josip,nominating,locale,ventricular,animators,verandah,epistles,surveyors,anthems,dredd,upheaval,passaic,anatolian,svalbard,associative,floodplain,taranaki,estuaries,irreducible,beginners,hammerstein,allocate,coursework,secreted,counteract,handwritten,foundational,passover,discoverer,decoding,wares,bourgeoisie,playgrounds,nazionale,abbreviations,seanad,golan,mishra,godavari,rebranding,attendances,backstory,interrupts,lettered,hasbro,ultralight,hormozgan,armee,moderne,subdue,disuse,improvisational,enrolment,persists,moderated,carinthia,hatchback,inhibitory,capitalized,anatoly,abstracts,albemarle,bergamo,insolvency,sentai,cellars,walloon,joked,kashmiri,dirac,materialized,renomination,homologous,gusts,eighteens,centrifugal,storied,baluchestan,formula_26,poincare,vettel,infuriated,gauges,streetcars,vedanta,stately,liquidated,goguryeo,swifts,accountancy,levee,acadian,hydropower,eustace,comintern,allotment,designating,torsion,molding,irritation,aerobic,halen,concerted,plantings,garrisoned,gramophone,cytoplasm,onslaught,requisitioned,relieving,genitive,centrist,jeong,espanola,dissolving,chatterjee,sparking,connaught,varese,arjuna,carpathian,empowering,meteorologist,decathlon,opioid,hohenzollern,fenced,ibiza,avionics,footscray,scrum,discounts,filament,directories,a.f.c,stiffness,quaternary,adventurers,transmits,harmonious,taizong,radiating,germantown,ejection,projectors,gaseous,nahuatl,vidyalaya,nightlife,redefined,refuted,destitute,arista,potters,disseminated,distanced,jamboree,kaohsiung,tilted,lakeshore,grained,inflicting,kreis,novelists,descendents,mezzanine,recast,fatah,deregulation,ac/dc,australis,kohgiluyeh,boreal,goths,authoring,intoxicated,nonpartisan,theodosius,pyongyang,shree,boyhood,sanfl,plenipotentiary,photosynthesis,presidium,sinaloa,honshu,texan,avenida,transmembrane,malays,acropolis,catalunya,vases,inconsistencies,methodists,quell,suisse,banat,simcoe,cercle,zealanders,discredited,equine,sages,parthian,fascists,interpolation,classifying,spinoff,yehuda,cruised,gypsum,foaled,wallachia,saraswati,imperialist,seabed,footnotes,nakajima,locales,schoolmaster,drosophila,bridgehead,immanuel,courtier,bookseller,niccolo,stylistically,portmanteau,superleague,konkani,millimetres,arboreal,thanjavur,emulation,sounders,decompression,commoners,infusion,methodological,osage,rococo,anchoring,bayreuth,formula_27,abstracting,symbolized,bayonne,electrolyte,rowed,corvettes,traversing,editorship,sampler,presidio,curzon,adirondack,swahili,rearing,bladed,lemur,pashtun,behaviours,bottling,zaire,recognisable,systematics,leeward,formulae,subdistricts,smithfield,vijaya,buoyancy,boosting,cantonal,rishi,airflow,kamakura,adana,emblems,aquifer,clustering,husayn,woolly,wineries,montessori,turntable,exponentially,caverns,espoused,pianists,vorpommern,vicenza,latterly,o'rourke,williamstown,generale,kosice,duisburg,poirot,marshy,mismanagement,mandalay,dagenham,universes,chiral,radiated,stewards,vegan,crankshaft,kyrgyz,amphibian,cymbals,infrequently,offenbach,environmentalist,repatriated,permutations,midshipmen,loudoun,refereed,bamberg,ornamented,nitric,selim,translational,dorsum,annunciation,gippsland,reflector,informational,regia,reactionary,ahmet,weathering,erlewine,legalized,berne,occupant,divas,manifests,analyzes,disproportionate,mitochondria,totalitarian,paulista,interscope,anarcho,correlate,brookfield,elongate,brunel,ordinal,precincts,volatility,equaliser,hittite,somaliland,ticketing,monochrome,ubuntu,chhattisgarh,titleholder,ranches,referendums,blooms,accommodates,merthyr,religiously,ryukyu,tumultuous,checkpoints,anode,mi'kmaq,cannonball,punctuation,remodelled,assassinations,criminology,alternates,yonge,pixar,namibian,piraeus,trondelag,hautes,lifeboats,shoal,atelier,vehemently,sadat,postcode,jainism,lycoming,undisturbed,lutherans,genomics,popmatters,tabriz,isthmian,notched,autistic,horsham,mites,conseil,bloomsbury,seung,cybertron,idris,overhauled,disbandment,idealized,goldfields,worshippers,lobbyist,ailments,paganism,herbarium,athenians,messerschmitt,faraday,entangled,'olya,untreated,criticising,howitzers,parvati,lobed,debussy,atonement,tadeusz,permeability,mueang,sepals,degli,optionally,fuelled,follies,asterisk,pristina,lewiston,congested,overpass,affixed,pleads,telecasts,stanislaus,cryptographic,friesland,hamstring,selkirk,antisubmarine,inundated,overlay,aggregates,fleur,trolleybus,sagan,ibsen,inductees,beltway,tiled,ladders,cadbury,laplace,ascetic,micronesia,conveying,bellingham,cleft,batches,usaid,conjugation,macedon,assisi,reappointed,brine,jinnah,prairies,screenwriting,oxidized,despatches,linearly,fertilizers,brazilians,absorbs,wagga,modernised,scorsese,ashraf,charlestown,esque,habitable,nizhny,lettres,tuscaloosa,esplanade,coalitions,carbohydrates,legate,vermilion,standardised,galleria,psychoanalytic,rearrangement,substation,competency,nationalised,reshuffle,reconstructions,mehdi,bougainville,receivership,contraception,enlistment,conducive,aberystwyth,solicitors,dismisses,fibrosis,montclair,homeowner,surrealism,s.h.i.e.l.d,peregrine,compilers,1790s,parentage,palmas,rzeszow,worldview,eased,svenska,housemate,bundestag,originator,enlisting,outwards,reciprocity,formula_28,carbohydrate,democratically,firefighting,romagna,acknowledgement,khomeini,carbide,quests,vedas,characteristically,guwahati,brixton,unintended,brothels,parietal,namur,sherbrooke,moldavian,baruch,milieu,undulating,laurier,entre,dijon,ethylene,abilene,heracles,paralleling,ceres,dundalk,falun,auspicious,chisinau,polarity,foreclosure,templates,ojibwe,punic,eriksson,biden,bachchan,glaciation,spitfires,norsk,nonviolent,heidegger,algonquin,capacitance,cassettes,balconies,alleles,airdate,conveys,replays,classifies,infrequent,amine,cuttings,rarer,woking,olomouc,amritsar,rockabilly,illyrian,maoist,poignant,tempore,stalinist,segmented,bandmate,mollusc,muhammed,totalled,byrds,tendered,endogenous,kottayam,aisne,oxidase,overhears,illustrators,verve,commercialization,purplish,directv,moulded,lyttelton,baptismal,captors,saracens,georgios,shorten,polity,grids,fitzwilliam,sculls,impurities,confederations,akhtar,intangible,oscillations,parabolic,harlequin,maulana,ovate,tanzanian,singularity,confiscation,qazvin,speyer,phonemes,overgrown,vicarage,gurion,undocumented,niigata,thrones,preamble,stave,interment,liiga,ataturk,aphrodite,groupe,indentured,habsburgs,caption,utilitarian,ozark,slovenes,reproductions,plasticity,serbo,dulwich,castel,barbuda,salons,feuding,lenape,wikileaks,swamy,breuning,shedding,afield,superficially,operationally,lamented,okanagan,hamadan,accolade,furthering,adolphus,fyodor,abridged,cartoonists,pinkish,suharto,cytochrome,methylation,debit,colspan=9|,refine,taoist,signalled,herding,leaved,bayan,fatherland,rampart,sequenced,negation,storyteller,occupiers,barnabas,pelicans,nadir,conscripted,railcars,prerequisite,furthered,columba,carolinas,markup,gwalior,franche,chaco,eglinton,ramparts,rangoon,metabolites,pollination,croat,televisa,holyoke,testimonial,setlist,safavid,sendai,georgians,shakespearean,galleys,regenerative,krzysztof,overtones,estado,barbary,cherbourg,obispo,sayings,composites,sainsbury,deliberation,cosmological,mahalleh,embellished,ascap,biala,pancras,calumet,grands,canvases,antigens,marianas,defenseman,approximated,seedlings,soren,stele,nuncio,immunology,testimonies,glossary,recollections,suitability,tampere,venous,cohomology,methanol,echoing,ivanovich,warmly,sterilization,imran,multiplying,whitechapel,undersea,xuanzong,tacitus,bayesian,roundhouse,correlations,rioters,molds,fiorentina,bandmates,mezzo,thani,guerilla,200th,premiums,tamils,deepwater,chimpanzees,tribesmen,selwyn,globo,turnovers,punctuated,erode,nouvelle,banbury,exponents,abolishing,helical,maimonides,endothelial,goteborg,infield,encroachment,cottonwood,mazowiecki,parable,saarbrucken,reliever,epistemology,artistes,enrich,rationing,formula_29,palmyra,subfamilies,kauai,zoran,fieldwork,arousal,creditor,friuli,celts,comoros,equated,escalation,negev,tallied,inductive,anion,netanyahu,mesoamerican,lepidoptera,aspirated,remit,westmorland,italic,crosse,vaclav,fuego,owain,balmain,venetians,ethnicities,deflected,ticino,apulia,austere,flycatcher,reprising,repressive,hauptbahnhof,subtype,ophthalmology,summarizes,eniwetok,colonisation,subspace,nymphalidae,earmarked,tempe,burnet,crests,abbots,norwegians,enlarge,ashoka,frankfort,livorno,malware,renters,singly,iliad,moresby,rookies,gustavus,affirming,alleges,legume,chekhov,studded,abdicated,suzhou,isidore,townsite,repayment,quintus,yankovic,amorphous,constructor,narrowing,industrialists,tanganyika,capitalization,connective,mughals,rarities,aerodynamics,worthing,antalya,diagnostics,shaftesbury,thracian,obstetrics,benghazi,multiplier,orbitals,livonia,roscommon,intensify,ravel,oaths,overseer,locomotion,necessities,chickasaw,strathclyde,treviso,erfurt,aortic,contemplation,accrington,markazi,predeceased,hippocampus,whitecaps,assemblyman,incursion,ethnography,extraliga,reproducing,directorship,benzene,byway,stupa,taxable,scottsdale,onondaga,favourably,countermeasures,lithuanians,thatched,deflection,tarsus,consuls,annuity,paralleled,contextual,anglian,klang,hoisted,multilingual,enacting,samaj,taoiseach,carthaginian,apologised,hydrology,entrant,seamless,inflorescences,mugabe,westerners,seminaries,wintering,penzance,mitre,sergeants,unoccupied,delimitation,discriminate,upriver,abortive,nihon,bessarabia,calcareous,buffaloes,patil,daegu,streamline,berks,chaparral,laity,conceptions,typified,kiribati,threaded,mattel,eccentricity,signified,patagonia,slavonia,certifying,adnan,astley,sedition,minimally,enumerated,nikos,goalless,walid,narendra,causa,missoula,coolant,dalek,outcrop,hybridization,schoolchildren,peasantry,afghans,confucianism,shahr,gallic,tajik,kierkegaard,sauvignon,commissar,patriarchs,tuskegee,prussians,laois,ricans,talmudic,officiating,aesthetically,baloch,antiochus,separatists,suzerainty,arafat,shading,u.s.c,chancellors,inc..,toolkit,nepenthes,erebidae,solicited,pratap,kabbalah,alchemist,caltech,darjeeling,biopic,spillway,kaiserslautern,nijmegen,bolstered,neath,pahlavi,eugenics,bureaus,retook,northfield,instantaneous,deerfield,humankind,selectivity,putative,boarders,cornhuskers,marathas,raikkonen,aliabad,mangroves,garages,gulch,karzai,poitiers,chernobyl,thane,alexios,belgrano,scion,solubility,urbanized,executable,guizhou,nucleic,tripled,equalled,harare,houseguests,potency,ghazi,repeater,overarching,regrouped,broward,ragtime,d'art,nandi,regalia,campsites,mamluk,plating,wirral,presumption,zenit,archivist,emmerdale,decepticon,carabidae,kagoshima,franconia,guarani,formalism,diagonally,submarginal,denys,walkways,punts,metrolink,hydrographic,droplets,upperside,martyred,hummingbird,antebellum,curiously,mufti,friary,chabad,czechs,shaykh,reactivity,berklee,turbonilla,tongan,sultans,woodville,unlicensed,enmity,dominicans,operculum,quarrying,watercolour,catalyzed,gatwick,'what,mesozoic,auditors,shizuoka,footballing,haldane,telemundo,appended,deducted,disseminate,o'shea,pskov,abrasive,entente,gauteng,calicut,lemurs,elasticity,suffused,scopula,staining,upholding,excesses,shostakovich,loanwords,naidu,championnat,chromatography,boasting,goaltenders,engulfed,salah,kilogram,morristown,shingles,shi'a,labourer,renditions,frantisek,jekyll,zonal,nanda,sheriffs,eigenvalues,divisione,endorsing,ushered,auvergne,cadres,repentance,freemasons,utilising,laureates,diocletian,semiconductors,o'grady,vladivostok,sarkozy,trackage,masculinity,hydroxyl,mervyn,muskets,speculations,gridiron,opportunistic,mascots,aleutian,fillies,sewerage,excommunication,borrowers,capillary,trending,sydenham,synthpop,rajah,cagayan,deportes,kedah,faure,extremism,michoacan,levski,culminates,occitan,bioinformatics,unknowingly,inciting,emulated,footpaths,piacenza,dreadnought,viceroyalty,oceanographic,scouted,combinatorial,ornithologist,cannibalism,mujahideen,independiente,cilicia,hindwing,minimized,odeon,gyorgy,rubles,purchaser,collieries,kickers,interurban,coiled,lynchburg,respondent,plzen,detractors,etchings,centering,intensification,tomography,ranjit,warblers,retelling,reinstatement,cauchy,modulus,redirected,evaluates,beginner,kalateh,perforated,manoeuvre,scrimmage,internships,megawatts,mottled,haakon,tunbridge,kalyan,summarised,sukarno,quetta,canonized,henryk,agglomeration,coahuila,diluted,chiropractic,yogyakarta,talladega,sheik,cation,halting,reprisals,sulfuric,musharraf,sympathizers,publicised,arles,lectionary,fracturing,startups,sangha,latrobe,rideau,ligaments,blockading,cremona,lichens,fabaceae,modulated,evocative,embodies,battersea,indistinct,altai,subsystem,acidity,somatic,formula_30,tariq,rationality,sortie,ashlar,pokal,cytoplasmic,valour,bangla,displacing,hijacking,spectrometry,westmeath,weill,charing,goias,revolvers,individualized,tenured,nawaz,piquet,chanted,discard,bernd,phalanx,reworking,unilaterally,subclass,yitzhak,piloting,circumvent,disregarded,semicircular,viscous,tibetans,endeavours,retaliated,cretan,vienne,workhouse,sufficiency,aurangzeb,legalization,lipids,expanse,eintracht,sanjak,megas,125th,bahraini,yakima,eukaryotes,thwart,affirmation,peloponnese,retailing,carbonyl,chairwoman,macedonians,dentate,rockaway,correctness,wealthier,metamorphic,aragonese,fermanagh,pituitary,schrodinger,evokes,spoiler,chariots,akita,genitalia,combe,confectionery,desegregation,experiential,commodores,persepolis,viejo,restorations,virtualization,hispania,printmaking,stipend,yisrael,theravada,expended,radium,tweeted,polygonal,lippe,charente,leveraged,cutaneous,fallacy,fragrant,bypasses,elaborately,rigidity,majid,majorca,kongo,plasmodium,skits,audiovisual,eerste,staircases,prompts,coulthard,northwestward,riverdale,beatrix,copyrights,prudential,communicates,mated,obscenity,asynchronous,analyse,hansa,searchlight,farnborough,patras,asquith,qarah,contours,fumbled,pasteur,redistributed,almeria,sanctuaries,jewry,israelite,clinicians,koblenz,bookshop,affective,goulburn,panelist,sikorsky,cobham,mimics,ringed,portraiture,probabilistic,girolamo,intelligible,andalusian,jalal,athenaeum,eritrean,auxiliaries,pittsburg,devolution,sangam,isolating,anglers,cronulla,annihilated,kidderminster,synthesize,popularised,theophilus,bandstand,innumerable,chagrin,retroactively,weser,multiples,birdlife,goryeo,pawnee,grosser,grappling,tactile,ahmadinejad,turboprop,erdogan,matchday,proletarian,adhering,complements,austronesian,adverts,luminaries,archeology,impressionism,conifer,sodomy,interracial,platoons,lessen,postings,pejorative,registrations,cookery,persecutions,microbes,audits,idiosyncratic,subsp,suspensions,restricts,colouring,ratify,instrumentals,nucleotides,sulla,posits,bibliotheque,diameters,oceanography,instigation,subsumed,submachine,acceptor,legation,borrows,sedge,discriminated,loaves,insurers,highgate,detectable,abandons,kilns,sportscaster,harwich,iterations,preakness,arduous,tensile,prabhu,shortwave,philologist,shareholding,vegetative,complexities,councilors,distinctively,revitalize,automaton,amassing,montreux,khanh,surabaya,nurnberg,pernambuco,cuisines,charterhouse,firsts,tercera,inhabitant,homophobia,naturalism,einar,powerplant,coruna,entertainments,whedon,rajputs,raton,democracies,arunachal,oeuvre,wallonia,jeddah,trolleybuses,evangelism,vosges,kiowa,minimise,encirclement,undertakes,emigrant,beacons,deepened,grammars,publius,preeminent,seyyed,repechage,crafting,headingley,osteopathic,lithography,hotly,bligh,inshore,betrothed,olympians,formula_31,dissociation,trivandrum,arran,petrovic,stettin,disembarked,simplification,bronzes,philo,acrobatic,jonsson,conjectured,supercharged,kanto,detects,cheeses,correlates,harmonics,lifecycle,sudamericana,reservists,decayed,elitserien,parametric,113th,dusky,hogarth,modulo,symbiotic,monopolies,discontinuation,converges,southerners,tucuman,eclipses,enclaves,emits,famicom,caricatures,artistically,levelled,mussels,erecting,mouthparts,cunard,octaves,crucible,guardia,unusable,lagrangian,droughts,ephemeral,pashto,canis,tapering,sasebo,silurian,metallurgical,outscored,evolves,reissues,sedentary,homotopy,greyhawk,reagents,inheriting,onshore,tilting,rebuffed,reusable,naturalists,basingstoke,insofar,offensives,dravidian,curators,planks,rajan,isoforms,flagstaff,preside,globular,egalitarian,linkages,biographers,goalscorers,molybdenum,centralised,nordland,jurists,ellesmere,rosberg,hideyoshi,restructure,biases,borrower,scathing,redress,tunnelling,workflow,magnates,mahendra,dissenters,plethora,transcriptions,handicrafts,keyword,xi'an,petrograd,unser,prokofiev,90deg,madan,bataan,maronite,kearny,carmarthen,termini,consulates,disallowed,rockville,bowery,fanzine,docklands,bests,prohibitions,yeltsin,selassie,naturalization,realisation,dispensary,tribeca,abdulaziz,pocahontas,stagnation,pamplona,cuneiform,propagating,subsurface,christgau,epithelium,schwerin,lynching,routledge,hanseatic,upanishad,glebe,yugoslavian,complicity,endowments,girona,mynetworktv,entomology,plinth,ba'ath,supercup,torus,akkadian,salted,englewood,commandery,belgaum,prefixed,colorless,dartford,enthroned,caesarea,nominative,sandown,safeguards,hulled,formula_32,leamington,dieppe,spearhead,generalizations,demarcation,llanelli,masque,brickwork,recounting,sufism,strikingly,petrochemical,onslow,monologues,emigrating,anderlecht,sturt,hossein,sakhalin,subduction,novices,deptford,zanjan,airstrikes,coalfield,reintroduction,timbaland,hornby,messianic,stinging,universalist,situational,radiocarbon,strongman,rowling,saloons,traffickers,overran,fribourg,cambrai,gravesend,discretionary,finitely,archetype,assessor,pilipinas,exhumed,invocation,interacted,digitized,timisoara,smelter,teton,sexism,precepts,srinagar,pilsudski,carmelite,hanau,scoreline,hernando,trekking,blogging,fanbase,wielded,vesicles,nationalization,banja,rafts,motoring,luang,takeda,girder,stimulates,histone,sunda,nanoparticles,attains,jumpers,catalogued,alluding,pontus,ancients,examiners,shinkansen,ribbentrop,reimbursement,pharmacological,ramat,stringed,imposes,cheaply,transplanted,taiping,mizoram,looms,wallabies,sideman,kootenay,encased,sportsnet,revolutionized,tangier,benthic,runic,pakistanis,heatseekers,shyam,mishnah,presbyterians,stadt,sutras,straddles,zoroastrian,infer,fueling,gymnasts,ofcom,gunfight,journeyman,tracklist,oshawa,ps500,pa'in,mackinac,xiongnu,mississippian,breckinridge,freemason,bight,autoroute,liberalization,distantly,thrillers,solomons,presumptive,romanization,anecdotal,bohemians,unpaved,milder,concurred,spinners,alphabets,strenuous,rivieres,kerrang,mistreatment,dismounted,intensively,carlist,dancehall,shunting,pluralism,trafficked,brokered,bonaventure,bromide,neckar,designates,malian,reverses,sotheby,sorghum,serine,environmentalists,languedoc,consulship,metering,bankstown,handlers,militiamen,conforming,regularity,pondicherry,armin,capsized,consejo,capitalists,drogheda,granular,purged,acadians,endocrine,intramural,elicit,terns,orientations,miklos,omitting,apocryphal,slapstick,brecon,pliocene,affords,typography,emigre,tsarist,tomasz,beset,nishi,necessitating,encyclical,roleplaying,journeyed,inflow,sprints,progressives,novosibirsk,cameroonian,ephesus,speckled,kinshasa,freiherr,burnaby,dalmatian,torrential,rigor,renegades,bhakti,nurburgring,cosimo,convincingly,reverting,visayas,lewisham,charlottetown,charadriiformesfamily,transferable,jodhpur,converters,deepening,camshaft,underdeveloped,protease,polonia,uterine,quantify,tobruk,dealerships,narasimha,fortran,inactivity,1780s,victors,categorised,naxos,workstation,skink,sardinian,chalice,precede,dammed,sondheim,phineas,tutored,sourcing,uncompromising,placer,tyneside,courtiers,proclaims,pharmacies,hyogo,booksellers,sengoku,kursk,spectrometer,countywide,wielkopolski,bobsleigh,shetty,llywelyn,consistory,heretics,guinean,cliches,individualism,monolithic,imams,usability,bursa,deliberations,railings,torchwood,inconsistency,balearic,stabilizer,demonstrator,facet,radioactivity,outboard,educates,d'oyly,heretical,handover,jurisdictional,shockwave,hispaniola,conceptually,routers,unaffiliated,trentino,formula_33,cypriots,intervenes,neuchatel,formulating,maggiore,delisted,alcohols,thessaly,potable,estimator,suborder,fluency,mimicry,clergymen,infrastructures,rivals.com,baroda,subplot,majlis,plano,clinching,connotation,carinae,savile,intercultural,transcriptional,sandstones,ailerons,annotations,impresario,heinkel,scriptural,intermodal,astrological,ribbed,northeastward,posited,boers,utilise,kalmar,phylum,breakwater,skype,textured,guideline,azeri,rimini,massed,subsidence,anomalous,wolfsburg,polyphonic,accrediting,vodacom,kirov,captaining,kelantan,logie,fervent,eamon,taper,bundeswehr,disproportionately,divination,slobodan,pundits,hispano,kinetics,reunites,makati,ceasing,statistician,amending,chiltern,eparchy,riverine,melanoma,narragansett,pagans,raged,toppled,breaching,zadar,holby,dacian,ochre,velodrome,disparities,amphoe,sedans,webpage,williamsport,lachlan,groton,baring,swastika,heliport,unwillingness,razorbacks,exhibitors,foodstuffs,impacting,tithe,appendages,dermot,subtypes,nurseries,balinese,simulating,stary,remakes,mundi,chautauqua,geologically,stockade,hakka,dilute,kalimantan,pahang,overlapped,fredericton,baha'u'llah,jahangir,damping,benefactors,shomali,triumphal,cieszyn,paradigms,shielded,reggaeton,maharishi,zambian,shearing,golestan,mirroring,partitioning,flyover,songbook,incandescent,merrimack,huguenots,sangeet,vulnerabilities,trademarked,drydock,tantric,honoris,queenstown,labelling,iterative,enlists,statesmen,anglicans,herge,qinghai,burgundian,islami,delineated,zhuge,aggregated,banknote,qatari,suitably,tapestries,asymptotic,charleroi,majorities,pyramidellidae,leanings,climactic,tahir,ramsar,suppressor,revisionist,trawler,ernakulam,penicillium,categorization,slits,entitlement,collegium,earths,benefice,pinochet,puritans,loudspeaker,stockhausen,eurocup,roskilde,alois,jaroslav,rhondda,boutiques,vigor,neurotransmitter,ansar,malden,ferdinando,sported,relented,intercession,camberwell,wettest,thunderbolts,positional,oriel,cloverleaf,penalized,shoshone,rajkumar,completeness,sharjah,chromosomal,belgians,woolen,ultrasonic,sequentially,boleyn,mordella,microsystems,initiator,elachista,mineralogy,rhododendron,integrals,compostela,hamza,sawmills,stadio,berlioz,maidens,stonework,yachting,tappeh,myocardial,laborer,workstations,costumed,nicaea,lanark,roundtable,mashhad,nablus,algonquian,stuyvesant,sarkar,heroines,diwan,laments,intonation,intrigues,almaty,feuded,grandes,algarve,rehabilitate,macrophages,cruciate,dismayed,heuristic,eliezer,kozhikode,covalent,finalised,dimorphism,yaroslavl,overtaking,leverkusen,middlebury,feeders,brookings,speculates,insoluble,lodgings,jozsef,cysteine,shenyang,habilitation,spurious,brainchild,mtdna,comique,albedo,recife,partick,broadening,shahi,orientated,himalaya,swabia,palme,mennonites,spokeswoman,conscripts,sepulchre,chartres,eurozone,scaffold,invertebrate,parishad,bagan,heian,watercolors,basse,supercomputer,commences,tarragona,plainfield,arthurian,functor,identically,murex,chronicling,pressings,burrowing,histoire,guayaquil,goalkeeping,differentiable,warburg,machining,aeneas,kanawha,holocene,ramesses,reprisal,qingdao,avatars,turkestan,cantatas,besieging,repudiated,teamsters,equipping,hydride,ahmadiyya,euston,bottleneck,computations,terengganu,kalinga,stela,rediscovery,'this,azhar,stylised,karelia,polyethylene,kansai,motorised,lounges,normalization,calculators,1700s,goalkeepers,unfolded,commissary,cubism,vignettes,multiverse,heaters,briton,sparingly,childcare,thorium,plock,riksdag,eunuchs,catalysis,limassol,perce,uncensored,whitlam,ulmus,unites,mesopotamian,refraction,biodiesel,forza,fulda,unseated,mountbatten,shahrak,selenium,osijek,mimicking,antimicrobial,axons,simulcasting,donizetti,swabian,sportsmen,hafiz,neared,heraclius,locates,evaded,subcarpathian,bhubaneswar,negeri,jagannath,thaksin,aydin,oromo,lateran,goldsmiths,multiculturalism,cilia,mihai,evangelists,lorient,qajar,polygons,vinod,mechanised,anglophone,prefabricated,mosses,supervillain,airliners,biofuels,iodide,innovators,valais,wilberforce,logarithm,intelligentsia,dissipation,sanctioning,duchies,aymara,porches,simulators,mostar,telepathic,coaxial,caithness,burghs,fourths,stratification,joaquim,scribes,meteorites,monarchist,germination,vries,desiring,replenishment,istria,winemaking,tammany,troupes,hetman,lanceolate,pelagic,triptych,primeira,scant,outbound,hyphae,denser,bentham,basie,normale,executes,ladislaus,kontinental,herat,cruiserweight,activision,customization,manoeuvres,inglewood,northwood,waveform,investiture,inpatient,alignments,kiryat,rabat,archimedes,ustad,monsanto,archetypal,kirkby,sikhism,correspondingly,catskill,overlaid,petrels,widowers,unicameral,federalists,metalcore,gamerankings,mussel,formula_34,lymphocytes,cystic,southgate,vestiges,immortals,kalam,strove,amazons,pocono,sociologists,sopwith,adheres,laurens,caregivers,inspecting,transylvanian,rebroadcast,rhenish,miserables,pyrams,blois,newtonian,carapace,redshirt,gotland,nazir,unilever,distortions,linebackers,federalism,mombasa,lumen,bernoulli,favouring,aligarh,denounce,steamboats,dnieper,stratigraphic,synths,bernese,umass,icebreaker,guanajuato,heisenberg,boldly,diodes,ladakh,dogmatic,scriptwriter,maritimes,battlestar,symposia,adaptable,toluca,bhavan,nanking,ieyasu,picardy,soybean,adalbert,brompton,deutsches,brezhnev,glandular,laotian,hispanicized,ibadan,personification,dalit,yamuna,regio,dispensed,yamagata,zweibrucken,revising,fandom,stances,participle,flavours,khitan,vertebral,crores,mayaguez,dispensation,guntur,undefined,harpercollins,unionism,meena,leveling,philippa,refractory,telstra,judea,attenuation,pylons,elaboration,elegy,edging,gracillariidae,residencies,absentia,reflexive,deportations,dichotomy,stoves,sanremo,shimon,menachem,corneal,conifers,mordellidae,facsimile,diagnoses,cowper,citta,viticulture,divisive,riverview,foals,mystics,polyhedron,plazas,airspeed,redgrave,motherland,impede,multiplicity,barrichello,airships,pharmacists,harvester,clays,payloads,differentiating,popularize,caesars,tunneling,stagnant,circadian,indemnity,sensibilities,musicology,prefects,serfs,metra,lillehammer,carmarthenshire,kiosks,welland,barbican,alkyl,tillandsia,gatherers,asociacion,showings,bharati,brandywine,subversion,scalable,pfizer,dawla,barium,dardanelles,nsdap,konig,ayutthaya,hodgkin,sedimentation,completions,purchasers,sponsorships,maximizing,banked,taoism,minot,enrolls,fructose,aspired,capuchin,outages,artois,carrollton,totality,osceola,pawtucket,fontainebleau,converged,queretaro,competencies,botha,allotments,sheaf,shastri,obliquely,banding,catharines,outwardly,monchengladbach,driest,contemplative,cassini,ranga,pundit,kenilworth,tiananmen,disulfide,formula_35,townlands,codice_3,looping,caravans,rachmaninoff,segmentation,fluorine,anglicised,gnostic,dessau,discern,reconfigured,altrincham,rebounding,battlecruiser,ramblers,1770s,convective,triomphe,miyagi,mourners,instagram,aloft,breastfeeding,courtyards,folkestone,changsha,kumamoto,saarland,grayish,provisionally,appomattox,uncial,classicism,mahindra,elapsed,supremes,monophyletic,cautioned,formula_36,noblewoman,kernels,sucre,swaps,bengaluru,grenfell,epicenter,rockhampton,worshipful,licentiate,metaphorical,malankara,amputated,wattle,palawan,tankobon,nobunaga,polyhedra,transduction,jilin,syrians,affinities,fluently,emanating,anglicized,sportscar,botanists,altona,dravida,chorley,allocations,kunming,luanda,premiering,outlived,mesoamerica,lingual,dissipating,impairments,attenborough,balustrade,emulator,bakhsh,cladding,increments,ascents,workington,qal'eh,winless,categorical,petrel,emphasise,dormer,toros,hijackers,telescopic,solidly,jankovic,cession,gurus,madoff,newry,subsystems,northside,talib,englishmen,farnese,holographic,electives,argonne,scrivener,predated,brugge,nauvoo,catalyses,soared,siddeley,graphically,powerlifting,funicular,sungai,coercive,fusing,uncertainties,locos,acetic,diverge,wedgwood,dressings,tiebreaker,didactic,vyacheslav,acreage,interplanetary,battlecruisers,sunbury,alkaloids,hairpin,automata,wielkie,interdiction,plugins,monkees,nudibranch,esporte,approximations,disabling,powering,characterisation,ecologically,martinsville,termen,perpetuated,lufthansa,ascendancy,motherboard,bolshoi,athanasius,prunus,dilution,invests,nonzero,mendocino,charan,banque,shaheed,counterculture,unita,voivode,hospitalization,vapour,supermarine,resistor,steppes,osnabruck,intermediates,benzodiazepines,sunnyside,privatized,geopolitical,ponta,beersheba,kievan,embody,theoretic,sangh,cartographer,blige,rotors,thruway,battlefields,discernible,demobilized,broodmare,colouration,sagas,policymakers,serialization,augmentation,hoare,frankfurter,transnistria,kinases,detachable,generational,converging,antiaircraft,khaki,bimonthly,coadjutor,arkhangelsk,kannur,buffers,livonian,northwich,enveloped,cysts,yokozuna,herne,beeching,enron,virginian,woollen,excepting,competitively,outtakes,recombinant,hillcrest,clearances,pathe,cumbersome,brasov,u.s.a,likud,christiania,cruciform,hierarchies,wandsworth,lupin,resins,voiceover,sitar,electrochemical,mediacorp,typhus,grenadiers,hepatic,pompeii,weightlifter,bosniak,oxidoreductase,undersecretary,rescuers,ranji,seleucid,analysing,exegesis,tenancy,toure,kristiansand,110th,carillon,minesweepers,poitou,acceded,palladian,redevelop,naismith,rifled,proletariat,shojo,hackensack,harvests,endpoint,kuban,rosenborg,stonehenge,authorisation,jacobean,revocation,compatriots,colliding,undetermined,okayama,acknowledgment,angelou,fresnel,chahar,ethereal,mg/kg,emmet,mobilised,unfavourable,cultura,characterizing,parsonage,skeptics,expressways,rabaul,medea,guardsmen,visakhapatnam,caddo,homophobic,elmwood,encircling,coexistence,contending,seljuk,mycologist,infertility,moliere,insolvent,covenants,underpass,holme,landesliga,workplaces,delinquency,methamphetamine,contrived,tableau,tithes,overlying,usurped,contingents,spares,oligocene,molde,beatification,mordechai,balloting,pampanga,navigators,flowered,debutant,codec,orogeny,newsletters,solon,ambivalent,ubisoft,archdeaconry,harpers,kirkus,jabal,castings,kazhagam,sylhet,yuwen,barnstaple,amidships,causative,isuzu,watchtower,granules,canaveral,remuneration,insurer,payout,horizonte,integrative,attributing,kiwis,skanderbeg,asymmetry,gannett,urbanism,disassembled,unaltered,precluded,melodifestivalen,ascends,plugin,gurkha,bisons,stakeholder,industrialisation,abbotsford,sextet,bustling,uptempo,slavia,choreographers,midwives,haram,javed,gazetteer,subsection,natively,weighting,lysine,meera,redbridge,muchmusic,abruzzo,adjoins,unsustainable,foresters,kbit/s,cosmopterigidae,secularism,poetics,causality,phonograph,estudiantes,ceausescu,universitario,adjoint,applicability,gastropods,nagaland,kentish,mechelen,atalanta,woodpeckers,lombards,gatineau,romansh,avraham,acetylcholine,perturbation,galois,wenceslaus,fuzhou,meandering,dendritic,sacristy,accented,katha,therapeutics,perceives,unskilled,greenhouses,analogues,chaldean,timbre,sloped,volodymyr,sadiq,maghreb,monogram,rearguard,caucuses,mures,metabolite,uyezd,determinism,theosophical,corbet,gaels,disruptions,bicameral,ribosomal,wolseley,clarksville,watersheds,tarsi,radon,milanese,discontinuous,aristotelian,whistleblower,representational,hashim,modestly,localised,atrial,hazara,ravana,troyes,appointees,rubus,morningside,amity,aberdare,ganglia,wests,zbigniew,aerobatic,depopulated,corsican,introspective,twinning,hardtop,shallower,cataract,mesolithic,emblematic,graced,lubrication,republicanism,voronezh,bastions,meissen,irkutsk,oboes,hokkien,sprites,tenet,individualist,capitulated,oakville,dysentery,orientalist,hillsides,keywords,elicited,incised,lagging,apoel,lengthening,attractiveness,marauders,sportswriter,decentralization,boltzmann,contradicts,draftsman,precipitate,solihull,norske,consorts,hauptmann,riflemen,adventists,syndromes,demolishing,customize,continuo,peripherals,seamlessly,linguistically,bhushan,orphanages,paraul,lessened,devanagari,quarto,responders,patronymic,riemannian,altoona,canonization,honouring,geodetic,exemplifies,republica,enzymatic,porters,fairmount,pampa,sufferers,kamchatka,conjugated,coachella,uthman,repositories,copious,headteacher,awami,phoneme,homomorphism,franconian,moorland,davos,quantified,kamloops,quarks,mayoralty,weald,peacekeepers,valerian,particulate,insiders,perthshire,caches,guimaraes,piped,grenadines,kosciuszko,trombonist,artemisia,covariance,intertidal,soybeans,beatified,ellipse,fruiting,deafness,dnipropetrovsk,accrued,zealous,mandala,causation,junius,kilowatt,bakeries,montpelier,airdrie,rectified,bungalows,toleration,debian,pylon,trotskyist,posteriorly,two-and-a-half,herbivorous,islamists,poetical,donne,wodehouse,frome,allium,assimilate,phonemic,minaret,unprofitable,darpa,untenable,leaflet,bitcoin,zahir,thresholds,argentino,jacopo,bespoke,stratified,wellbeing,shiite,basaltic,timberwolves,secrete,taunts,marathons,isomers,carre,consecrators,penobscot,pitcairn,sakha,crosstown,inclusions,impassable,fenders,indre,uscgc,jordi,retinue,logarithmic,pilgrimages,railcar,cashel,blackrock,macroscopic,aligning,tabla,trestle,certify,ronson,palps,dissolves,thickened,silicate,taman,walsingham,hausa,lowestoft,rondo,oleksandr,cuyahoga,retardation,countering,cricketing,holborn,identifiers,hells,geophysics,infighting,sculpting,balaji,webbed,irradiation,runestone,trusses,oriya,sojourn,forfeiture,colonize,exclaimed,eucharistic,lackluster,glazing,northridge,gutenberg,stipulates,macroeconomic,priori,outermost,annular,udinese,insulating,headliner,godel,polytope,megalithic,salix,sharapova,derided,muskegon,braintree,plateaus,confers,autocratic,isomer,interstitial,stamping,omits,kirtland,hatchery,evidences,intifada,111th,podgorica,capua,motivating,nuneaton,jakub,korsakov,amitabh,mundial,monrovia,gluten,predictor,marshalling,d'orleans,levers,touchscreen,brantford,fricative,banishment,descendent,antagonism,ludovico,loudspeakers,formula_37,livelihoods,manassas,steamships,dewsbury,uppermost,humayun,lures,pinnacles,dependents,lecce,clumps,observatories,paleozoic,dedicating,samiti,draughtsman,gauls,incite,infringing,nepean,pythagorean,convents,triumvirate,seigneur,gaiman,vagrant,fossa,byproduct,serrated,renfrewshire,sheltering,achaemenid,dukedom,catchers,sampdoria,platelet,bielefeld,fluctuating,phenomenology,strikeout,ethnology,prospectors,woodworking,tatra,wildfires,meditations,agrippa,fortescue,qureshi,wojciech,methyltransferase,accusative,saatchi,amerindian,volcanism,zeeland,toyama,vladimirovich,allege,polygram,redox,budgeted,advisories,nematode,chipset,starscream,tonbridge,hardening,shales,accompanist,paraded,phonographic,whitefish,sportive,audiobook,kalisz,hibernation,latif,duels,ps200,coxeter,nayak,safeguarding,cantabria,minesweeping,zeiss,dunams,catholicos,sawtooth,ontological,nicobar,bridgend,unclassified,intrinsically,hanoverian,rabbitohs,kenseth,alcalde,northumbrian,raritan,septuagint,presse,sevres,origen,dandenong,peachtree,intersected,impeded,usages,hippodrome,novara,trajectories,customarily,yardage,inflected,yanow,kalan,taverns,liguria,librettist,intermarriage,1760s,courant,gambier,infanta,ptolemaic,ukulele,haganah,sceptical,manchukuo,plexus,implantation,hilal,intersex,efficiencies,arbroath,hagerstown,adelphi,diario,marais,matti,lifes,coining,modalities,divya,bletchley,conserving,ivorian,mithridates,generative,strikeforce,laymen,toponymy,pogrom,satya,meticulously,agios,dufferin,yaakov,fortnightly,cargoes,deterrence,prefrontal,przemysl,mitterrand,commemorations,chatsworth,gurdwara,abuja,chakraborty,badajoz,geometries,artiste,diatonic,ganglion,presides,marymount,nanak,cytokines,feudalism,storks,rowers,widens,politico,evangelicals,assailants,pittsfield,allowable,bijapur,telenovelas,dichomeris,glenelg,herbivores,keita,inked,radom,fundraisers,constantius,boheme,portability,komnenos,crystallography,derrida,moderates,tavistock,fateh,spacex,disjoint,bristles,commercialized,interwoven,empirically,regius,bulacan,newsday,showa,radicalism,yarrow,pleura,sayed,structuring,cotes,reminiscences,acetyl,edicts,escalators,aomori,encapsulated,legacies,bunbury,placings,fearsome,postscript,powerfully,keighley,hildesheim,amicus,crevices,deserters,benelux,aurangabad,freeware,ioannis,carpathians,chirac,seceded,prepaid,landlocked,naturalised,yanukovych,soundscan,blotch,phenotypic,determinants,twente,dictatorial,giessen,composes,recherche,pathophysiology,inventories,ayurveda,elevating,gravestone,degeneres,vilayet,popularizing,spartanburg,bloemfontein,previewed,renunciation,genotype,ogilvy,tracery,blacklisted,emissaries,diploid,disclosures,tupolev,shinjuku,antecedents,pennine,braganza,bhattacharya,countable,spectroscopic,ingolstadt,theseus,corroborated,compounding,thrombosis,extremadura,medallions,hasanabad,lambton,perpetuity,glycol,besancon,palaiologos,pandey,caicos,antecedent,stratum,laserdisc,novitiate,crowdfunding,palatal,sorceress,dassault,toughness,celle,cezanne,vientiane,tioga,hander,crossbar,gisborne,cursor,inspectorate,serif,praia,sphingidae,nameplate,psalter,ivanovic,sitka,equalised,mutineers,sergius,outgrowth,creationism,haredi,rhizomes,predominate,undertakings,vulgate,hydrothermal,abbeville,geodesic,kampung,physiotherapy,unauthorised,asteraceae,conservationist,minoan,supersport,mohammadabad,cranbrook,mentorship,legitimately,marshland,datuk,louvain,potawatomi,carnivores,levies,lyell,hymnal,regionals,tinto,shikoku,conformal,wanganui,beira,lleida,standstill,deloitte,formula_40,corbusier,chancellery,mixtapes,airtime,muhlenberg,formula_39,bracts,thrashers,prodigious,gironde,chickamauga,uyghurs,substitutions,pescara,batangas,gregarious,gijon,paleo,mathura,pumas,proportionally,hawkesbury,yucca,kristiania,funimation,fluted,eloquence,mohun,aftermarket,chroniclers,futurist,nonconformist,branko,mannerisms,lesnar,opengl,altos,retainers,ashfield,shelbourne,sulaiman,divisie,gwent,locarno,lieder,minkowski,bivalve,redeployed,cartography,seaway,bookings,decays,ostend,antiquaries,pathogenesis,formula_38,chrysalis,esperance,valli,motogp,homelands,bridged,bloor,ghazal,vulgaris,baekje,prospector,calculates,debtors,hesperiidae,titian,returner,landgrave,frontenac,kelowna,pregame,castelo,caius,canoeist,watercolours,winterthur,superintendents,dissonance,dubstep,adorn,matic,salih,hillel,swordsman,flavoured,emitter,assays,monongahela,deeded,brazzaville,sufferings,babylonia,fecal,umbria,astrologer,gentrification,frescos,phasing,zielona,ecozone,candido,manoj,quadrilateral,gyula,falsetto,prewar,puntland,infinitive,contraceptive,bakhtiari,ohrid,socialization,tailplane,evoking,havelock,macapagal,plundering,104th,keynesian,templars,phrasing,morphologically,czestochowa,humorously,catawba,burgas,chiswick,ellipsoid,kodansha,inwards,gautama,katanga,orthopaedic,heilongjiang,sieges,outsourced,subterminal,vijayawada,hares,oration,leitrim,ravines,manawatu,cryogenic,tracklisting,about.com,ambedkar,degenerated,hastened,venturing,lobbyists,shekhar,typefaces,northcote,rugen,'good,ornithology,asexual,hemispheres,unsupported,glyphs,spoleto,epigenetic,musicianship,donington,diogo,kangxi,bisected,polymorphism,megawatt,salta,embossed,cheetahs,cruzeiro,unhcr,aristide,rayleigh,maturing,indonesians,noire,llano,ffffff,camus,purges,annales,convair,apostasy,algol,phage,apaches,marketers,aldehyde,pompidou,kharkov,forgeries,praetorian,divested,retrospectively,gornji,scutellum,bitumen,pausanias,magnification,imitations,nyasaland,geographers,floodlights,athlone,hippolyte,expositions,clarinetist,razak,neutrinos,rotax,sheykh,plush,interconnect,andalus,cladogram,rudyard,resonator,granby,blackfriars,placido,windscreen,sahel,minamoto,haida,cations,emden,blackheath,thematically,blacklist,pawel,disseminating,academical,undamaged,raytheon,harsher,powhatan,ramachandran,saddles,paderborn,capping,zahra,prospecting,glycine,chromatin,profane,banska,helmand,okinawan,dislocation,oscillators,insectivorous,foyle,gilgit,autonomic,tuareg,sluice,pollinated,multiplexed,granary,narcissus,ranchi,staines,nitra,goalscoring,midwifery,pensioners,algorithmic,meetinghouse,biblioteca,besar,narva,angkor,predate,lohan,cyclical,detainee,occipital,eventing,faisalabad,dartmoor,kublai,courtly,resigns,radii,megachilidae,cartels,shortfall,xhosa,unregistered,benchmarks,dystopian,bulkhead,ponsonby,jovanovic,accumulates,papuan,bhutanese,intuitively,gotaland,headliners,recursion,dejan,novellas,diphthongs,imbued,withstood,analgesic,amplify,powertrain,programing,maidan,alstom,affirms,eradicated,summerslam,videogame,molla,severing,foundered,gallium,atmospheres,desalination,shmuel,howmeh,catolica,bossier,reconstructing,isolates,lyase,tweets,unconnected,tidewater,divisible,cohorts,orebro,presov,furnishing,folklorist,simplifying,centrale,notations,factorization,monarchies,deepen,macomb,facilitation,hennepin,declassified,redrawn,microprocessors,preliminaries,enlarging,timeframe,deutschen,shipbuilders,patiala,ferrous,aquariums,genealogies,vieux,unrecognized,bridgwater,tetrahedral,thule,resignations,gondwana,registries,agder,dataset,felled,parva,analyzer,worsen,coleraine,columella,blockaded,polytechnique,reassembled,reentry,narvik,greys,nigra,knockouts,bofors,gniezno,slotted,hamasaki,ferrers,conferring,thirdly,domestication,photojournalist,universality,preclude,ponting,halved,thereupon,photosynthetic,ostrava,mismatch,pangasinan,intermediaries,abolitionists,transited,headings,ustase,radiological,interconnection,dabrowa,invariants,honorius,preferentially,chantilly,marysville,dialectical,antioquia,abstained,gogol,dirichlet,muricidae,symmetries,reproduces,brazos,fatwa,bacillus,ketone,paribas,chowk,multiplicative,dermatitis,mamluks,devotes,adenosine,newbery,meditative,minefields,inflection,oxfam,conwy,bystrica,imprints,pandavas,infinitesimal,conurbation,amphetamine,reestablish,furth,edessa,injustices,frankston,serjeant,4x200,khazar,sihanouk,longchamp,stags,pogroms,coups,upperparts,endpoints,infringed,nuanced,summing,humorist,pacification,ciaran,jamaat,anteriorly,roddick,springboks,faceted,hypoxia,rigorously,cleves,fatimid,ayurvedic,tabled,ratna,senhora,maricopa,seibu,gauguin,holomorphic,campgrounds,amboy,coordinators,ponderosa,casemates,ouachita,nanaimo,mindoro,zealander,rimsky,cluny,tomaszow,meghalaya,caetano,tilak,roussillon,landtag,gravitation,dystrophy,cephalopods,trombones,glens,killarney,denominated,anthropogenic,pssas,roubaix,carcasses,montmorency,neotropical,communicative,rabindranath,ordinated,separable,overriding,surged,sagebrush,conciliation,codice_4,durrani,phosphatase,qadir,votive,revitalized,taiyuan,tyrannosaurus,graze,slovaks,nematodes,environmentalism,blockhouse,illiteracy,schengen,ecotourism,alternation,conic,wields,hounslow,blackfoot,kwame,ambulatory,volhynia,hordaland,croton,piedras,rohit,drava,conceptualized,birla,illustrative,gurgaon,barisal,tutsi,dezong,nasional,polje,chanson,clarinets,krasnoyarsk,aleksandrovich,cosmonaut,d'este,palliative,midseason,silencing,wardens,durer,girders,salamanders,torrington,supersonics,lauda,farid,circumnavigation,embankments,funnels,bajnoksag,lorries,cappadocia,jains,warringah,retirees,burgesses,equalization,cusco,ganesan,algal,amazonian,lineups,allocating,conquerors,usurper,mnemonic,predating,brahmaputra,ahmadabad,maidenhead,numismatic,subregion,encamped,reciprocating,freebsd,irgun,tortoises,governorates,zionists,airfoil,collated,ajmer,fiennes,etymological,polemic,chadian,clerestory,nordiques,fluctuated,calvados,oxidizing,trailhead,massena,quarrels,dordogne,tirunelveli,pyruvate,pulsed,athabasca,sylar,appointee,serer,japonica,andronikos,conferencing,nicolaus,chemin,ascertained,incited,woodbine,helices,hospitalised,emplacements,to/from,orchestre,tyrannical,pannonia,methodism,pop/rock,shibuya,berbers,despot,seaward,westpac,separator,perpignan,alamein,judeo,publicize,quantization,ethniki,gracilis,menlo,offside,oscillating,unregulated,succumbing,finnmark,metrical,suleyman,raith,sovereigns,bundesstrasse,kartli,fiduciary,darshan,foramen,curler,concubines,calvinism,larouche,bukhara,sophomores,mohanlal,lutheranism,monomer,eamonn,'black,uncontested,immersive,tutorials,beachhead,bindings,permeable,postulates,comite,transformative,indiscriminate,hofstra,associacao,amarna,dermatology,lapland,aosta,babur,unambiguous,formatting,schoolboys,gwangju,superconducting,replayed,adherent,aureus,compressors,forcible,spitsbergen,boulevards,budgeting,nossa,annandale,perumal,interregnum,sassoon,kwajalein,greenbrier,caldas,triangulation,flavius,increment,shakhtar,nullified,pinfall,nomen,microfinance,depreciation,cubist,steeper,splendour,gruppe,everyman,chasers,campaigners,bridle,modality,percussive,darkly,capes,velar,picton,triennial,factional,padang,toponym,betterment,norepinephrine,112th,estuarine,diemen,warehousing,morphism,ideologically,pairings,immunization,crassus,exporters,sefer,flocked,bulbous,deseret,booms,calcite,bohol,elven,groot,pulau,citigroup,wyeth,modernizing,layering,pastiche,complies,printmaker,condenser,theropod,cassino,oxyrhynchus,akademie,trainings,lowercase,coxae,parte,chetniks,pentagonal,keselowski,monocoque,morsi,reticulum,meiosis,clapboard,recoveries,tinge,an/fps,revista,sidon,livre,epidermis,conglomerates,kampong,congruent,harlequins,tergum,simplifies,epidemiological,underwriting,tcp/ip,exclusivity,multidimensional,mysql,columbine,ecologist,hayat,sicilies,levees,handset,aesop,usenet,pacquiao,archiving,alexandrian,compensatory,broadsheet,annotation,bahamian,d'affaires,interludes,phraya,shamans,marmara,customizable,immortalized,ambushes,chlorophyll,diesels,emulsion,rheumatoid,voluminous,screenwriters,tailoring,sedis,runcorn,democratization,bushehr,anacostia,constanta,antiquary,sixtus,radiate,advaita,antimony,acumen,barristers,reichsbahn,ronstadt,symbolist,pasig,cursive,secessionist,afrikaner,munnetra,inversely,adsorption,syllabic,moltke,idioms,midline,olimpico,diphosphate,cautions,radziwill,mobilisation,copelatus,trawlers,unicron,bhaskar,financiers,minimalism,derailment,marxists,oireachtas,abdicate,eigenvalue,zafar,vytautas,ganguly,chelyabinsk,telluride,subordination,ferried,dived,vendee,pictish,dimitrov,expiry,carnation,cayley,magnitudes,lismore,gretna,sandwiched,unmasked,sandomierz,swarthmore,tetra,nanyang,pevsner,dehradun,mormonism,rashi,complying,seaplanes,ningbo,cooperates,strathcona,mornington,mestizo,yulia,edgbaston,palisade,ethno,polytopes,espirito,tymoshenko,pronunciations,paradoxical,taichung,chipmunks,erhard,maximise,accretion,kanda,`abdu'l,narrowest,umpiring,mycenaean,divisor,geneticist,ceredigion,barque,hobbyists,equates,auxerre,spinose,cheil,sweetwater,guano,carboxylic,archiv,tannery,cormorant,agonists,fundacion,anbar,tunku,hindrance,meerut,concordat,secunderabad,kachin,achievable,murfreesboro,comprehensively,forges,broadest,synchronised,speciation,scapa,aliyev,conmebol,tirelessly,subjugated,pillaged,udaipur,defensively,lakhs,stateless,haasan,headlamps,patterning,podiums,polyphony,mcmurdo,mujer,vocally,storeyed,mucosa,multivariate,scopus,minimizes,formalised,certiorari,bourges,populate,overhanging,gaiety,unreserved,borromeo,woolworths,isotopic,bashar,purify,vertebra,medan,juxtaposition,earthwork,elongation,chaudhary,schematic,piast,steeped,nanotubes,fouls,achaea,legionnaires,abdur,qmjhl,embraer,hardback,centerville,ilocos,slovan,whitehorse,mauritian,moulding,mapuche,donned,provisioning,gazprom,jonesboro,audley,lightest,calyx,coldwater,trigonometric,petroglyphs,psychoanalyst,congregate,zambezi,fissure,supervises,bexley,etobicoke,wairarapa,tectonics,emphasises,formula_41,debugging,linfield,spatially,ionizing,ungulates,orinoco,clades,erlangen,news/talk,vols.,ceara,yakovlev,finsbury,entanglement,fieldhouse,graphene,intensifying,grigory,keyong,zacatecas,ninian,allgemeine,keswick,societa,snorri,femininity,najib,monoclonal,guyanese,postulate,huntly,abbeys,machinist,yunus,emphasising,ishaq,urmia,bremerton,pretenders,lumiere,thoroughfares,chikara,dramatized,metathorax,taiko,transcendence,wycliffe,retrieves,umpired,steuben,racehorses,taylors,kuznetsov,montezuma,precambrian,canopies,gaozong,propodeum,disestablished,retroactive,shoreham,rhizome,doubleheader,clinician,diwali,quartzite,shabaab,agassiz,despatched,stormwater,luxemburg,callao,universidade,courland,skane,glyph,dormers,witwatersrand,curacy,qualcomm,nansen,entablature,lauper,hausdorff,lusaka,ruthenian,360deg,cityscape,douai,vaishnava,spars,vaulting,rationalist,gygax,sequestration,typology,pollinates,accelerators,leben,colonials,cenotaph,imparted,carthaginians,equaled,rostrum,gobind,bodhisattva,oberst,bicycling,arabi,sangre,biophysics,hainaut,vernal,lunenburg,apportioned,finches,lajos,nenad,repackaged,zayed,nikephoros,r.e.m,swaminarayan,gestalt,unplaced,crags,grohl,sialkot,unsaturated,gwinnett,linemen,forays,palakkad,writs,instrumentalists,aircrews,badged,terrapins,180deg,oneness,commissariat,changi,pupation,circumscribed,contador,isotropic,administrated,fiefs,nimes,intrusions,minoru,geschichte,nadph,tainan,changchun,carbondale,frisia,swapo,evesham,hawai'i,encyclopedic,transporters,dysplasia,formula_42,onsite,jindal,guetta,judgements,narbonne,permissions,paleogene,rationalism,vilna,isometric,subtracted,chattahoochee,lamina,missa,greville,pervez,lattices,persistently,crystallization,timbered,hawaiians,fouling,interrelated,masood,ripening,stasi,gamal,visigothic,warlike,cybernetics,tanjung,forfar,cybernetic,karelian,brooklands,belfort,greifswald,campeche,inexplicably,refereeing,understory,uninterested,prius,collegiately,sefid,sarsfield,categorize,biannual,elsevier,eisteddfod,declension,autonoma,procuring,misrepresentation,novelization,bibliographic,shamanism,vestments,potash,eastleigh,ionized,turan,lavishly,scilly,balanchine,importers,parlance,'that,kanyakumari,synods,mieszko,crossovers,serfdom,conformational,legislated,exclave,heathland,sadar,differentiates,propositional,konstantinos,photoshop,manche,vellore,appalachia,orestes,taiga,exchanger,grozny,invalidated,baffin,spezia,staunchly,eisenach,robustness,virtuosity,ciphers,inlets,bolagh,understandings,bosniaks,parser,typhoons,sinan,luzerne,webcomic,subtraction,jhelum,businessweek,ceske,refrained,firebox,mitigated,helmholtz,dilip,eslamabad,metalwork,lucan,apportionment,provident,gdynia,schooners,casement,danse,hajjiabad,benazir,buttress,anthracite,newsreel,wollaston,dispatching,cadastral,riverboat,provincetown,nantwich,missal,irreverent,juxtaposed,darya,ennobled,electropop,stereoscopic,maneuverability,laban,luhansk,udine,collectibles,haulage,holyrood,materially,supercharger,gorizia,shkoder,townhouses,pilate,layoffs,folkloric,dialectic,exuberant,matures,malla,ceuta,citizenry,crewed,couplet,stopover,transposition,tradesmen,antioxidant,amines,utterance,grahame,landless,isere,diction,appellant,satirist,urbino,intertoto,subiaco,antonescu,nehemiah,ubiquitin,emcee,stourbridge,fencers,103rd,wranglers,monteverdi,watertight,expounded,xiamen,manmohan,pirie,threefold,antidepressant,sheboygan,grieg,cancerous,diverging,bernini,polychrome,fundamentalism,bihari,critiqued,cholas,villers,tendulkar,dafydd,vastra,fringed,evangelization,episcopalian,maliki,sana'a,ashburton,trianon,allegany,heptathlon,insufficiently,panelists,pharrell,hexham,amharic,fertilized,plumes,cistern,stratigraphy,akershus,catalans,karoo,rupee,minuteman,quantification,wigmore,leutnant,metanotum,weeknights,iridescent,extrasolar,brechin,deuterium,kuching,lyricism,astrakhan,brookhaven,euphorbia,hradec,bhagat,vardar,aylmer,positron,amygdala,speculators,unaccompanied,debrecen,slurry,windhoek,disaffected,rapporteur,mellitus,blockers,fronds,yatra,sportsperson,precession,physiologist,weeknight,pidgin,pharma,condemns,standardize,zetian,tibor,glycoprotein,emporia,cormorants,amalie,accesses,leonhard,denbighshire,roald,116th,will.i.am,symbiosis,privatised,meanders,chemnitz,jabalpur,shing,secede,ludvig,krajina,homegrown,snippets,sasanian,euripides,peder,cimarron,streaked,graubunden,kilimanjaro,mbeki,middleware,flensburg,bukovina,lindwall,marsalis,profited,abkhaz,polis,camouflaged,amyloid,morgantown,ovoid,bodleian,morte,quashed,gamelan,juventud,natchitoches,storyboard,freeview,enumeration,cielo,preludes,bulawayo,1600s,olympiads,multicast,faunal,asura,reinforces,puranas,ziegfeld,handicraft,seamount,kheil,noche,hallmarks,dermal,colorectal,encircle,hessen,umbilicus,sunnis,leste,unwin,disclosing,superfund,montmartre,refuelling,subprime,kolhapur,etiology,bismuth,laissez,vibrational,mazar,alcoa,rumsfeld,recurve,ticonderoga,lionsgate,onlookers,homesteads,filesystem,barometric,kingswood,biofuel,belleza,moshav,occidentalis,asymptomatic,northeasterly,leveson,huygens,numan,kingsway,primogeniture,toyotomi,yazoo,limpets,greenbelt,booed,concurrence,dihedral,ventrites,raipur,sibiu,plotters,kitab,109th,trackbed,skilful,berthed,effendi,fairing,sephardi,mikhailovich,lockyer,wadham,invertible,paperbacks,alphabetic,deuteronomy,constitutive,leathery,greyhounds,estoril,beechcraft,poblacion,cossidae,excreted,flamingos,singha,olmec,neurotransmitters,ascoli,nkrumah,forerunners,dualism,disenchanted,benefitted,centrum,undesignated,noida,o'donoghue,collages,egrets,egmont,wuppertal,cleave,montgomerie,pseudomonas,srinivasa,lymphatic,stadia,resold,minima,evacuees,consumerism,ronde,biochemist,automorphism,hollows,smuts,improvisations,vespasian,bream,pimlico,eglin,colne,melancholic,berhad,ousting,saale,notaulices,ouest,hunslet,tiberias,abdomina,ramsgate,stanislas,donbass,pontefract,sucrose,halts,drammen,chelm,l'arc,taming,trolleys,konin,incertae,licensees,scythian,giorgos,dative,tanglewood,farmlands,o'keeffe,caesium,romsdal,amstrad,corte,oglethorpe,huntingdonshire,magnetization,adapts,zamosc,shooto,cuttack,centrepiece,storehouse,winehouse,morbidity,woodcuts,ryazan,buddleja,buoyant,bodmin,estero,austral,verifiable,periyar,christendom,curtail,shura,kaifeng,cotswold,invariance,seafaring,gorica,androgen,usman,seabird,forecourt,pekka,juridical,audacious,yasser,cacti,qianlong,polemical,d'amore,espanyol,distrito,cartographers,pacifism,serpents,backa,nucleophilic,overturning,duplicates,marksman,oriente,vuitton,oberleutnant,gielgud,gesta,swinburne,transfiguration,1750s,retaken,celje,fredrikstad,asuka,cropping,mansard,donates,blacksmiths,vijayanagara,anuradhapura,germinate,betis,foreshore,jalandhar,bayonets,devaluation,frazione,ablaze,abidjan,approvals,homeostasis,corollary,auden,superfast,redcliffe,luxembourgish,datum,geraldton,printings,ludhiana,honoree,synchrotron,invercargill,hurriedly,108th,three-and-a-half,colonist,bexar,limousin,bessemer,ossetian,nunataks,buddhas,rebuked,thais,tilburg,verdicts,interleukin,unproven,dordrecht,solent,acclamation,muammar,dahomey,operettas,4x400,arrears,negotiators,whitehaven,apparitions,armoury,psychoactive,worshipers,sculptured,elphinstone,airshow,kjell,o'callaghan,shrank,professorships,predominance,subhash,coulomb,sekolah,retrofitted,samos,overthrowing,vibrato,resistors,palearctic,datasets,doordarshan,subcutaneous,compiles,immorality,patchwork,trinidadian,glycogen,pronged,zohar,visigoths,freres,akram,justo,agora,intakes,craiova,playwriting,bukhari,militarism,iwate,petitioners,harun,wisla,inefficiency,vendome,ledges,schopenhauer,kashi,entombed,assesses,tenn.,noumea,baguio,carex,o'donovan,filings,hillsdale,conjectures,blotches,annuals,lindisfarne,negated,vivek,angouleme,trincomalee,cofactor,verkhovna,backfield,twofold,automaker,rudra,freighters,darul,gharana,busway,formula_43,plattsburgh,portuguesa,showrunner,roadmap,valenciennes,erdos,biafra,spiritualism,transactional,modifies,carne,107th,cocos,gcses,tiverton,radiotherapy,meadowlands,gunma,srebrenica,foxtel,authenticated,enslavement,classicist,klaipeda,minstrels,searchable,infantrymen,incitement,shiga,nadp+,urals,guilders,banquets,exteriors,counterattacks,visualized,diacritics,patrimony,svensson,transepts,prizren,telegraphy,najaf,emblazoned,coupes,effluent,ragam,omani,greensburg,taino,flintshire,cd/dvd,lobbies,narrating,cacao,seafarers,bicolor,collaboratively,suraj,floodlit,sacral,puppetry,tlingit,malwa,login,motionless,thien,overseers,vihar,golem,specializations,bathhouse,priming,overdubs,winningest,archetypes,uniao,acland,creamery,slovakian,lithographs,maryborough,confidently,excavating,stillborn,ramallah,audiencia,alava,ternary,hermits,rostam,bauxite,gawain,lothair,captions,gulfstream,timelines,receded,mediating,petain,bastia,rudbar,bidders,disclaimer,shrews,tailings,trilobites,yuriy,jamil,demotion,gynecology,rajinikanth,madrigals,ghazni,flycatchers,vitebsk,bizet,computationally,kashgar,refinements,frankford,heralds,europe/africa,levante,disordered,sandringham,queues,ransacked,trebizond,verdes,comedie,primitives,figurine,organists,culminate,gosport,coagulation,ferrying,hoyas,polyurethane,prohibitive,midfielders,ligase,progesterone,defectors,sweetened,backcountry,diodorus,waterside,nieuport,khwaja,jurong,decried,gorkha,ismaili,300th,octahedral,kindergartens,paseo,codification,notifications,disregarding,risque,reconquista,shortland,atolls,texarkana,perceval,d'etudes,kanal,herbicides,tikva,nuova,gatherer,dissented,soweto,dexterity,enver,bacharach,placekicker,carnivals,automate,maynooth,symplectic,chetnik,militaire,upanishads,distributive,strafing,championing,moiety,miliband,blackadder,enforceable,maung,dimer,stadtbahn,diverges,obstructions,coleophoridae,disposals,shamrocks,aural,banca,bahru,coxed,grierson,vanadium,watermill,radiative,ecoregions,berets,hariri,bicarbonate,evacuations,mallee,nairn,rushden,loggia,slupsk,satisfactorily,milliseconds,cariboo,reine,cyclo,pigmentation,postmodernism,aqueducts,vasari,bourgogne,dilemmas,liquefied,fluminense,alloa,ibaraki,tenements,kumasi,humerus,raghu,labours,putsch,soundcloud,bodybuilder,rakyat,domitian,pesaro,translocation,sembilan,homeric,enforcers,tombstones,lectureship,rotorua,salamis,nikolaos,inferences,superfortress,lithgow,surmised,undercard,tarnow,barisan,stingrays,federacion,coldstream,haverford,ornithological,heerenveen,eleazar,jyoti,murali,bamako,riverbed,subsidised,theban,conspicuously,vistas,conservatorium,madrasa,kingfishers,arnulf,credential,syndicalist,sheathed,discontinuity,prisms,tsushima,coastlines,escapees,vitis,optimizing,megapixel,overground,embattled,halide,sprinters,buoys,mpumalanga,peculiarities,106th,roamed,menezes,macao,prelates,papyri,freemen,dissertations,irishmen,pooled,sverre,reconquest,conveyance,subjectivity,asturian,circassian,formula_45,comdr,thickets,unstressed,monro,passively,harmonium,moveable,dinar,carlsson,elysees,chairing,b'nai,confusingly,kaoru,convolution,godolphin,facilitator,saxophones,eelam,jebel,copulation,anions,livres,licensure,pontypridd,arakan,controllable,alessandria,propelling,stellenbosch,tiber,wolka,liberators,yarns,d'azur,tsinghua,semnan,amhara,ablation,melies,tonality,historique,beeston,kahne,intricately,sonoran,robespierre,gyrus,boycotts,defaulted,infill,maranhao,emigres,framingham,paraiba,wilhelmshaven,tritium,skyway,labial,supplementation,possessor,underserved,motets,maldivian,marrakech,quays,wikimedia,turbojet,demobilization,petrarch,encroaching,sloops,masted,karbala,corvallis,agribusiness,seaford,stenosis,hieronymus,irani,superdraft,baronies,cortisol,notability,veena,pontic,cyclin,archeologists,newham,culled,concurring,aeolian,manorial,shouldered,fords,philanthropists,105th,siddharth,gotthard,halim,rajshahi,jurchen,detritus,practicable,earthenware,discarding,travelogue,neuromuscular,elkhart,raeder,zygmunt,metastasis,internees,102nd,vigour,upmarket,summarizing,subjunctive,offsets,elizabethtown,udupi,pardubice,repeaters,instituting,archaea,substandard,technische,linga,anatomist,flourishes,velika,tenochtitlan,evangelistic,fitchburg,springbok,cascading,hydrostatic,avars,occasioned,filipina,perceiving,shimbun,africanus,consternation,tsing,optically,beitar,45deg,abutments,roseville,monomers,huelva,lotteries,hypothalamus,internationalist,electromechanical,hummingbirds,fibreglass,salaried,dramatists,uncovers,invokes,earners,excretion,gelding,ancien,aeronautica,haverhill,stour,ittihad,abramoff,yakov,ayodhya,accelerates,industrially,aeroplanes,deleterious,dwelt,belvoir,harpalus,atpase,maluku,alasdair,proportionality,taran,epistemological,interferometer,polypeptide,adjudged,villager,metastatic,marshalls,madhavan,archduchess,weizmann,kalgoorlie,balan,predefined,sessile,sagaing,brevity,insecticide,psychosocial,africana,steelworks,aether,aquifers,belem,mineiro,almagro,radiators,cenozoic,solute,turbocharger,invicta,guested,buccaneer,idolatry,unmatched,paducah,sinestro,dispossessed,conforms,responsiveness,cyanobacteria,flautist,procurator,complementing,semifinalist,rechargeable,permafrost,cytokine,refuges,boomed,gelderland,franchised,jinan,burnie,doubtless,randomness,colspan=12,angra,ginebra,famers,nuestro,declarative,roughness,lauenburg,motile,rekha,issuer,piney,interceptors,napoca,gipsy,formulaic,formula_44,viswanathan,ebrahim,thessalonica,galeria,muskogee,unsold,html5,taito,mobutu,icann,carnarvon,fairtrade,morphisms,upsilon,nozzles,fabius,meander,murugan,strontium,episcopacy,sandinista,parasol,attenuated,bhima,primeval,panay,ordinator,negara,osteoporosis,glossop,ebook,paradoxically,grevillea,modoc,equating,phonetically,legumes,covariant,dorje,quatre,bruxelles,pyroclastic,shipbuilder,zhaozong,obscuring,sveriges,tremolo,extensible,barrack,multnomah,hakon,chaharmahal,parsing,volumetric,astrophysical,glottal,combinatorics,freestanding,encoder,paralysed,cavalrymen,taboos,heilbronn,orientalis,lockport,marvels,ozawa,dispositions,waders,incurring,saltire,modulate,papilio,phenol,intermedia,rappahannock,plasmid,fortify,phenotypes,transiting,correspondences,leaguer,larnaca,incompatibility,mcenroe,deeming,endeavoured,aboriginals,helmed,salar,arginine,werke,ferrand,expropriated,delimited,couplets,phoenicians,petioles,ouster,anschluss,protectionist,plessis,urchins,orquesta,castleton,juniata,bittorrent,fulani,donji,mykola,rosemont,chandos,scepticism,signer,chalukya,wicketkeeper,coquitlam,programmatic,o'brian,carteret,urology,steelhead,paleocene,konkan,bettered,venkatesh,surfacing,longitudinally,centurions,popularization,yazid,douro,widths,premios,leonards,gristmill,fallujah,arezzo,leftists,ecliptic,glycerol,inaction,disenfranchised,acrimonious,depositing,parashah,cockatoo,marechal,bolzano,chios,cablevision,impartiality,pouches,thickly,equities,bentinck,emotive,boson,ashdown,conquistadors,parsi,conservationists,reductive,newlands,centerline,ornithologists,waveguide,nicene,philological,hemel,setanta,masala,aphids,convening,casco,matrilineal,chalcedon,orthographic,hythe,replete,damming,bolivarian,admixture,embarks,borderlands,conformed,nagarjuna,blenny,chaitanya,suwon,shigeru,tatarstan,lingayen,rejoins,grodno,merovingian,hardwicke,puducherry,prototyping,laxmi,upheavals,headquarter,pollinators,bromine,transom,plantagenet,arbuthnot,chidambaram,woburn,osamu,panelling,coauthored,zhongshu,hyaline,omissions,aspergillus,offensively,electrolytic,woodcut,sodom,intensities,clydebank,piotrkow,supplementing,quipped,focke,harbinger,positivism,parklands,wolfenbuttel,cauca,tryptophan,taunus,curragh,tsonga,remand,obscura,ashikaga,eltham,forelimbs,analogs,trnava,observances,kailash,antithesis,ayumi,abyssinia,dorsally,tralee,pursuers,misadventures,padova,perot,mahadev,tarim,granth,licenced,compania,patuxent,baronial,korda,cochabamba,codices,karna,memorialized,semaphore,playlists,mandibular,halal,sivaji,scherzinger,stralsund,foundries,ribosome,mindfulness,nikolayevich,paraphyletic,newsreader,catalyze,ioannina,thalamus,gbit/s,paymaster,sarab,500th,replenished,gamepro,cracow,formula_46,gascony,reburied,lessing,easement,transposed,meurthe,satires,proviso,balthasar,unbound,cuckoos,durbar,louisbourg,cowes,wholesalers,manet,narita,xiaoping,mohamad,illusory,cathal,reuptake,alkaloid,tahrir,mmorpg,underlies,anglicanism,repton,aharon,exogenous,buchenwald,indigent,odostomia,milled,santorum,toungoo,nevsky,steyr,urbanisation,darkseid,subsonic,canaanite,akiva,eglise,dentition,mediators,cirencester,peloponnesian,malmesbury,durres,oerlikon,tabulated,saens,canaria,ischemic,esterhazy,ringling,centralization,walthamstow,nalanda,lignite,takht,leninism,expiring,circe,phytoplankton,promulgation,integrable,breeches,aalto,menominee,borgo,scythians,skrull,galleon,reinvestment,raglan,reachable,liberec,airframes,electrolysis,geospatial,rubiaceae,interdependence,symmetrically,simulcasts,keenly,mauna,adipose,zaidi,fairport,vestibular,actuators,monochromatic,literatures,congestive,sacramental,atholl,skytrain,tycho,tunings,jamia,catharina,modifier,methuen,tapings,infiltrating,colima,grafting,tauranga,halides,pontificate,phonetics,koper,hafez,grooved,kintetsu,extrajudicial,linkoping,cyberpunk,repetitions,laurentian,parnu,bretton,darko,sverdlovsk,foreshadowed,akhenaten,rehnquist,gosford,coverts,pragmatism,broadleaf,ethiopians,instated,mediates,sodra,opulent,descriptor,enugu,shimla,leesburg,officership,giffard,refectory,lusitania,cybermen,fiume,corus,tydfil,lawrenceville,ocala,leviticus,burghers,ataxia,richthofen,amicably,acoustical,watling,inquired,tiempo,multiracial,parallelism,trenchard,tokyopop,germanium,usisl,philharmonia,shapur,jacobites,latinized,sophocles,remittances,o'farrell,adder,dimitrios,peshwa,dimitar,orlov,outstretched,musume,satish,dimensionless,serialised,baptisms,pagasa,antiviral,1740s,quine,arapaho,bombardments,stratosphere,ophthalmic,injunctions,carbonated,nonviolence,asante,creoles,sybra,boilermakers,abington,bipartite,permissive,cardinality,anheuser,carcinogenic,hohenlohe,surinam,szeged,infanticide,generically,floorball,'white,automakers,cerebellar,homozygous,remoteness,effortlessly,allude,'great,headmasters,minting,manchurian,kinabalu,wemyss,seditious,widgets,marbled,almshouses,bards,subgenres,tetsuya,faulting,kickboxer,gaulish,hoseyn,malton,fluvial,questionnaires,mondale,downplayed,traditionalists,vercelli,sumatran,landfills,gamesradar,exerts,franciszek,unlawfully,huesca,diderot,libertarians,professorial,laane,piecemeal,conidae,taiji,curatorial,perturbations,abstractions,szlachta,watercraft,mullah,zoroastrianism,segmental,khabarovsk,rectors,affordability,scuola,diffused,stena,cyclonic,workpiece,romford,'little,jhansi,stalag,zhongshan,skipton,maracaibo,bernadotte,thanet,groening,waterville,encloses,sahrawi,nuffield,moorings,chantry,annenberg,islay,marchers,tenses,wahid,siegen,furstenberg,basques,resuscitation,seminarians,tympanum,gentiles,vegetarianism,tufted,venkata,fantastical,pterophoridae,machined,superposition,glabrous,kaveri,chicane,executors,phyllonorycter,bidirectional,jasta,undertones,touristic,majapahit,navratilova,unpopularity,barbadian,tinian,webcast,hurdler,rigidly,jarrah,staphylococcus,igniting,irrawaddy,stabilised,airstrike,ragas,wakayama,energetically,ekstraklasa,minibus,largemouth,cultivators,leveraging,waitangi,carnaval,weaves,turntables,heydrich,sextus,excavate,govind,ignaz,pedagogue,uriah,borrowings,gemstones,infractions,mycobacterium,batavian,massing,praetor,subalpine,massoud,passers,geostationary,jalil,trainsets,barbus,impair,budejovice,denbigh,pertain,historicity,fortaleza,nederlandse,lamenting,masterchef,doubs,gemara,conductance,ploiesti,cetaceans,courthouses,bhagavad,mihailovic,occlusion,bremerhaven,bulwark,morava,kaine,drapery,maputo,conquistador,kaduna,famagusta,first-past-the-post,erudite,galton,undated,tangential,filho,dismembered,dashes,criterium,darwen,metabolized,blurring,everard,randwick,mohave,impurity,acuity,ansbach,chievo,surcharge,plantain,algoma,porosity,zirconium,selva,sevenoaks,venizelos,gwynne,golgi,imparting,separatism,courtesan,idiopathic,gravestones,hydroelectricity,babar,orford,purposeful,acutely,shard,ridgewood,viterbo,manohar,expropriation,placenames,brevis,cosine,unranked,richfield,newnham,recoverable,flightless,dispersing,clearfield,abu'l,stranraer,kempe,streamlining,goswami,epidermal,pieta,conciliatory,distilleries,electrophoresis,bonne,tiago,curiosities,candidature,picnicking,perihelion,lintel,povoa,gullies,configure,excision,facies,signers,1730s,insufficiency,semiotics,streatham,deactivation,entomological,skippers,albacete,parodying,escherichia,honorees,singaporeans,counterterrorism,tiruchirappalli,omnivorous,metropole,globalisation,athol,unbounded,codice_5,landforms,classifier,farmhouses,reaffirming,reparation,yomiuri,technologists,mitte,medica,viewable,steampunk,konya,kshatriya,repelling,edgewater,lamiinae,devas,potteries,llandaff,engendered,submits,virulence,uplifted,educationist,metropolitans,frontrunner,dunstable,forecastle,frets,methodius,exmouth,linnean,bouchet,repulsion,computable,equalling,liceo,tephritidae,agave,hydrological,azarenka,fairground,l'homme,enforces,xinhua,cinematographers,cooperstown,sa'id,paiute,christianization,tempos,chippenham,insulator,kotor,stereotyped,dello,cours,hisham,d'souza,eliminations,supercars,passau,rebrand,natures,coote,persephone,rededicated,cleaved,plenum,blistering,indiscriminately,cleese,safed,recursively,compacted,revues,hydration,shillong,echelons,garhwal,pedimented,grower,zwolle,wildflower,annexing,methionine,petah,valens,famitsu,petiole,specialities,nestorian,shahin,tokaido,shearwater,barberini,kinsmen,experimenter,alumnae,cloisters,alumina,pritzker,hardiness,soundgarden,julich,ps300,watercourse,cementing,wordplay,olivet,demesne,chasseurs,amide,zapotec,gaozu,porphyry,absorbers,indium,analogies,devotions,engravers,limestones,catapulted,surry,brickworks,gotra,rodham,landline,paleontologists,shankara,islip,raucous,trollope,arpad,embarkation,morphemes,recites,picardie,nakhchivan,tolerances,formula_47,khorramabad,nichiren,adrianople,kirkuk,assemblages,collider,bikaner,bushfires,roofline,coverings,reredos,bibliotheca,mantras,accentuated,commedia,rashtriya,fluctuation,serhiy,referential,fittipaldi,vesicle,geeta,iraklis,immediacy,chulalongkorn,hunsruck,bingen,dreadnoughts,stonemason,meenakshi,lebesgue,undergrowth,baltistan,paradoxes,parlement,articled,tiflis,dixieland,meriden,tejano,underdogs,barnstable,exemplify,venter,tropes,wielka,kankakee,iskandar,zilina,pharyngeal,spotify,materialised,picts,atlantique,theodoric,prepositions,paramilitaries,pinellas,attlee,actuated,piedmontese,grayling,thucydides,multifaceted,unedited,autonomously,universelle,utricularia,mooted,preto,incubated,underlie,brasenose,nootka,bushland,sensu,benzodiazepine,esteghlal,seagoing,amenhotep,azusa,sappers,culpeper,smokeless,thoroughbreds,dargah,gorda,alumna,mankato,zdroj,deleting,culvert,formula_49,punting,wushu,hindering,immunoglobulin,standardisation,birger,oilfield,quadrangular,ulama,recruiters,netanya,1630s,communaute,istituto,maciej,pathan,meher,vikas,characterizations,playmaker,interagency,intercepts,assembles,horthy,introspection,narada,matra,testes,radnicki,estonians,csiro,instar,mitford,adrenergic,crewmembers,haaretz,wasatch,lisburn,rangefinder,ordre,condensate,reforestation,corregidor,spvgg,modulator,mannerist,faulted,aspires,maktoum,squarepants,aethelred,piezoelectric,mulatto,dacre,progressions,jagiellonian,norge,samaria,sukhoi,effingham,coxless,hermetic,humanists,centrality,litters,stirlingshire,beaconsfield,sundanese,geometrically,caretakers,habitually,bandra,pashtuns,bradenton,arequipa,laminar,brickyard,hitchin,sustains,shipboard,ploughing,trechus,wheelers,bracketed,ilyushin,subotica,d'hondt,reappearance,bridgestone,intermarried,fulfilment,aphasia,birkbeck,transformational,strathmore,hornbill,millstone,lacan,voids,solothurn,gymnasiums,laconia,viaducts,peduncle,teachta,edgware,shinty,supernovae,wilfried,exclaim,parthia,mithun,flashpoint,moksha,cumbia,metternich,avalanches,militancy,motorist,rivadavia,chancellorsville,federals,gendered,bounding,footy,gauri,caliphs,lingam,watchmaker,unrecorded,riverina,unmodified,seafloor,droit,pfalz,chrysostom,gigabit,overlordship,besiege,espn2,oswestry,anachronistic,ballymena,reactivation,duchovny,ghani,abacetus,duller,legio,watercourses,nord-pas-de-calais,leiber,optometry,swarms,installer,sancti,adverbs,iheartmedia,meiningen,zeljko,kakheti,notional,circuses,patrilineal,acrobatics,infrastructural,sheva,oregonian,adjudication,aamir,wloclawek,overfishing,obstructive,subtracting,aurobindo,archeologist,newgate,'cause,secularization,tehsils,abscess,fingal,janacek,elkhorn,trims,kraftwerk,mandating,irregulars,faintly,congregationalist,sveti,kasai,mishaps,kennebec,provincially,durkheim,scotties,aicte,rapperswil,imphal,surrenders,morphs,nineveh,hoxha,cotabato,thuringian,metalworking,retold,shogakukan,anthers,proteasome,tippeligaen,disengagement,mockumentary,palatial,erupts,flume,corrientes,masthead,jaroslaw,rereleased,bharti,labors,distilling,tusks,varzim,refounded,enniskillen,melkite,semifinalists,vadodara,bermudian,capstone,grasse,origination,populus,alesi,arrondissements,semigroup,verein,opossum,messrs.,portadown,bulbul,tirupati,mulhouse,tetrahedron,roethlisberger,nonverbal,connexion,warangal,deprecated,gneiss,octet,vukovar,hesketh,chambre,despatch,claes,kargil,hideo,gravelly,tyndale,aquileia,tuners,defensible,tutte,theotokos,constructivist,ouvrage,dukla,polisario,monasticism,proscribed,commutation,testers,nipissing,codon,mesto,olivine,concomitant,exoskeleton,purports,coromandel,eyalet,dissension,hippocrates,purebred,yaounde,composting,oecophoridae,procopius,o'day,angiogenesis,sheerness,intelligencer,articular,felixstowe,aegon,endocrinology,trabzon,licinius,pagodas,zooplankton,hooghly,satie,drifters,sarthe,mercian,neuilly,tumours,canal+,scheldt,inclinations,counteroffensive,roadrunners,tuzla,shoreditch,surigao,predicates,carnot,algeciras,militaries,generalize,bulkheads,gawler,pollutant,celta,rundgren,microrna,gewog,olimpija,placental,lubelski,roxburgh,discerned,verano,kikuchi,musicale,l'enfant,ferocity,dimorphic,antigonus,erzurum,prebendary,recitative,discworld,cyrenaica,stigmella,totnes,sutta,pachuca,ulsan,downton,landshut,castellan,pleural,siedlce,siecle,catamaran,cottbus,utilises,trophic,freeholders,holyhead,u.s.s,chansons,responder,waziristan,suzuka,birding,shogi,asker,acetone,beautification,cytotoxic,dixit,hunterdon,cobblestone,formula_48,kossuth,devizes,sokoto,interlaced,shuttered,kilowatts,assiniboine,isaak,salto,alderney,sugarloaf,franchising,aggressiveness,toponyms,plaintext,antimatter,henin,equidistant,salivary,bilingualism,mountings,obligate,extirpated,irenaeus,misused,pastoralists,aftab,immigrating,warping,tyrolean,seaforth,teesside,soundwave,oligarchy,stelae,pairwise,iupac,tezuka,posht,orchestrations,landmass,ironstone,gallia,hjalmar,carmelites,strafford,elmhurst,palladio,fragility,teleplay,gruffudd,karoly,yerba,potok,espoo,inductance,macaque,nonprofits,pareto,rock'n'roll,spiritualist,shadowed,skateboarder,utterances,generality,congruence,prostrate,deterred,yellowknife,albarn,maldon,battlements,mohsen,insecticides,khulna,avellino,menstruation,glutathione,springdale,parlophone,confraternity,korps,countrywide,bosphorus,preexisting,damodar,astride,alexandrovich,sprinting,crystallized,botev,leaching,interstates,veers,angevin,undaunted,yevgeni,nishapur,northerners,alkmaar,bethnal,grocers,sepia,tornus,exemplar,trobe,charcot,gyeonggi,larne,tournai,lorain,voided,genji,enactments,maxilla,adiabatic,eifel,nazim,transducer,thelonious,pyrite,deportiva,dialectal,bengt,rosettes,labem,sergeyevich,synoptic,conservator,statuette,biweekly,adhesives,bifurcation,rajapaksa,mammootty,republique,yusef,waseda,marshfield,yekaterinburg,minnelli,fundy,fenian,matchups,dungannon,supremacist,panelled,drenthe,iyengar,fibula,narmada,homeport,oceanside,precept,antibacterial,altarpieces,swath,ospreys,lillooet,legnica,lossless,formula_50,galvatron,iorga,stormont,rsfsr,loggers,kutno,phenomenological,medallists,cuatro,soissons,homeopathy,bituminous,injures,syndicates,typesetting,displacements,dethroned,makassar,lucchese,abergavenny,targu,alborz,akb48,boldface,gastronomy,sacra,amenity,accumulator,myrtaceae,cornices,mourinho,denunciation,oxbow,diddley,aargau,arbitrage,bedchamber,gruffydd,zamindar,klagenfurt,caernarfon,slowdown,stansted,abrasion,tamaki,suetonius,dukakis,individualistic,ventrally,hotham,perestroika,ketones,fertilisation,sobriquet,couplings,renderings,misidentified,rundfunk,sarcastically,braniff,concours,dismissals,elegantly,modifiers,crediting,combos,crucially,seafront,lieut,ischemia,manchus,derivations,proteases,aristophanes,adenauer,porting,hezekiah,sante,trulli,hornblower,foreshadowing,ypsilanti,dharwad,khani,hohenstaufen,distillers,cosmodrome,intracranial,turki,salesian,gorzow,jihlava,yushchenko,leichhardt,venables,cassia,eurogamer,airtel,curative,bestsellers,timeform,sortied,grandview,massillon,ceding,pilbara,chillicothe,heredity,elblag,rogaland,ronne,millennial,batley,overuse,bharata,fille,campbelltown,abeyance,counterclockwise,250cc,neurodegenerative,consigned,electromagnetism,sunnah,saheb,exons,coxswain,gleaned,bassoons,worksop,prismatic,immigrate,pickets,takeo,bobsledder,stosur,fujimori,merchantmen,stiftung,forli,endorses,taskforce,thermally,atman,gurps,floodplains,enthalpy,extrinsic,setubal,kennesaw,grandis,scalability,durations,showrooms,prithvi,outro,overruns,andalucia,amanita,abitur,hipper,mozambican,sustainment,arsene,chesham,palaeolithic,reportage,criminality,knowsley,haploid,atacama,shueisha,ridgefield,astern,getafe,lineal,timorese,restyled,hollies,agincourt,unter,justly,tannins,mataram,industrialised,tarnovo,mumtaz,mustapha,stretton,synthetase,condita,allround,putra,stjepan,troughs,aechmea,specialisation,wearable,kadokawa,uralic,aeros,messiaen,existentialism,jeweller,effigies,gametes,fjordane,cochlear,interdependent,demonstrative,unstructured,emplacement,famines,spindles,amplitudes,actuator,tantalum,psilocybe,apnea,monogatari,expulsions,seleucus,tsuen,hospitaller,kronstadt,eclipsing,olympiakos,clann,canadensis,inverter,helio,egyptologist,squamous,resonate,munir,histology,torbay,khans,jcpenney,veterinarians,aintree,microscopes,colonised,reflectors,phosphorylated,pristimantis,tulare,corvinus,multiplexing,midweek,demosthenes,transjordan,ecija,tengku,vlachs,anamorphic,counterweight,radnor,trinitarian,armidale,maugham,njsiaa,futurism,stairways,avicenna,montebello,bridgetown,wenatchee,lyonnais,amass,surinamese,streptococcus,m*a*s*h,hydrogenation,frazioni,proscenium,kalat,pennsylvanian,huracan,tallying,kralove,nucleolar,phrygian,seaports,hyacinthe,ignace,donning,instalment,regnal,fonds,prawn,carell,folktales,goaltending,bracknell,vmware,patriarchy,mitsui,kragujevac,pythagoras,soult,thapa,disproved,suwalki,secures,somoza,l'ecole,divizia,chroma,herders,technologist,deduces,maasai,rampur,paraphrase,raimi,imaged,magsaysay,ivano,turmeric,formula_51,subcommittees,axillary,ionosphere,organically,indented,refurbishing,pequot,violinists,bearn,colle,contralto,silverton,mechanization,etruscans,wittelsbach,pasir,redshirted,marrakesh,scarp,plein,wafers,qareh,teotihuacan,frobenius,sinensis,rehoboth,bundaberg,newbridge,hydrodynamic,traore,abubakar,adjusts,storytellers,dynamos,verbandsliga,concertmaster,exxonmobil,appreciable,sieradz,marchioness,chaplaincy,rechristened,cunxu,overpopulation,apolitical,sequencer,beaked,nemanja,binaries,intendant,absorber,filamentous,indebtedness,nusra,nashik,reprises,psychedelia,abwehr,ligurian,isoform,resistive,pillaging,mahathir,reformatory,lusatia,allerton,ajaccio,tepals,maturin,njcaa,abyssinian,objector,fissures,sinuous,ecclesiastic,dalits,caching,deckers,phosphates,wurlitzer,navigated,trofeo,berea,purefoods,solway,unlockable,grammys,kostroma,vocalizations,basilan,rebuke,abbasi,douala,helsingborg,ambon,bakar,runestones,cenel,tomislav,pigmented,northgate,excised,seconda,kirke,determinations,dedicates,vilas,pueblos,reversion,unexploded,overprinted,ekiti,deauville,masato,anaesthesia,endoplasmic,transponders,aguascalientes,hindley,celluloid,affording,bayeux,piaget,rickshaws,eishockey,camarines,zamalek,undersides,hardwoods,hermitian,mutinied,monotone,blackmails,affixes,jpmorgan,habermas,mitrovica,paleontological,polystyrene,thana,manas,conformist,turbofan,decomposes,logano,castration,metamorphoses,patroness,herbicide,mikolaj,rapprochement,macroeconomics,barranquilla,matsudaira,lintels,femina,hijab,spotsylvania,morpheme,bitola,baluchistan,kurukshetra,otway,extrusion,waukesha,menswear,helder,trung,bingley,protester,boars,overhang,differentials,exarchate,hejaz,kumara,unjustified,timings,sharpness,nuovo,taisho,sundar,etc..,jehan,unquestionably,muscovy,daltrey,canute,paneled,amedeo,metroplex,elaborates,telus,tetrapods,dragonflies,epithets,saffir,parthenon,lucrezia,refitting,pentateuch,hanshin,montparnasse,lumberjacks,sanhedrin,erectile,odors,greenstone,resurgent,leszek,amory,substituents,prototypical,viewfinder,monck,universiteit,joffre,revives,chatillon,seedling,scherzo,manukau,ashdod,gympie,homolog,stalwarts,ruinous,weibo,tochigi,wallenberg,gayatri,munda,satyagraha,storefronts,heterogeneity,tollway,sportswriters,binocular,gendarmes,ladysmith,tikal,ortsgemeinde,ja'far,osmotic,linlithgow,bramley,telecoms,pugin,repose,rupaul,sieur,meniscus,garmisch,reintroduce,400th,shoten,poniatowski,drome,kazakhstani,changeover,astronautics,husserl,herzl,hypertext,katakana,polybius,antananarivo,seong,breguet,reliquary,utada,aggregating,liangshan,sivan,tonawanda,audiobooks,shankill,coulee,phenolic,brockton,bookmakers,handsets,boaters,wylde,commonality,mappings,silhouettes,pennines,maurya,pratchett,singularities,eschewed,pretensions,vitreous,ibero,totalitarianism,poulenc,lingered,directx,seasoning,deputation,interdict,illyria,feedstock,counterbalance,muzik,buganda,parachuted,violist,homogeneity,comix,fjords,corsairs,punted,verandahs,equilateral,laoghaire,magyars,117th,alesund,televoting,mayotte,eateries,refurbish,nswrl,yukio,caragiale,zetas,dispel,codecs,inoperable,outperformed,rejuvenation,elstree,modernise,contributory,pictou,tewkesbury,chechens,ashina,psionic,refutation,medico,overdubbed,nebulae,sandefjord,personages,eccellenza,businessperson,placename,abenaki,perryville,threshing,reshaped,arecibo,burslem,colspan=3|turnout,rebadged,lumia,erinsborough,interactivity,bitmap,indefatigable,theosophy,excitatory,gleizes,edsel,bermondsey,korce,saarinen,wazir,diyarbakir,cofounder,liberalisation,onsen,nighthawks,siting,retirements,semyon,d'histoire,114th,redditch,venetia,praha,'round,valdosta,hieroglyphic,postmedial,edirne,miscellany,savona,cockpits,minimization,coupler,jacksonian,appeasement,argentines,saurashtra,arkwright,hesiod,folios,fitzalan,publica,rivaled,civitas,beermen,constructivism,ribeira,zeitschrift,solanum,todos,deformities,chilliwack,verdean,meagre,bishoprics,gujrat,yangzhou,reentered,inboard,mythologies,virtus,unsurprisingly,rusticated,museu,symbolise,proportionate,thesaban,symbian,aeneid,mitotic,veliki,compressive,cisterns,abies,winemaker,massenet,bertolt,ahmednagar,triplemania,armorial,administracion,tenures,smokehouse,hashtag,fuerza,regattas,gennady,kanazawa,mahmudabad,crustal,asaph,valentinian,ilaiyaraaja,honeyeater,trapezoidal,cooperatively,unambiguously,mastodon,inhospitable,harnesses,riverton,renewables,djurgardens,haitians,airings,humanoids,boatswain,shijiazhuang,faints,veera,punjabis,steepest,narain,karlovy,serre,sulcus,collectives,1500m,arion,subarctic,liberally,apollonius,ostia,droplet,headstones,norra,robusta,maquis,veronese,imola,primers,luminance,escadrille,mizuki,irreconcilable,stalybridge,temur,paraffin,stuccoed,parthians,counsels,fundamentalists,vivendi,polymath,sugababes,mikko,yonne,fermions,vestfold,pastoralist,kigali,unseeded,glarus,cusps,amasya,northwesterly,minorca,astragalus,verney,trevelyan,antipathy,wollstonecraft,bivalves,boulez,royle,divisao,quranic,bareilly,coronal,deviates,lulea,erectus,petronas,chandan,proxies,aeroflot,postsynaptic,memoriam,moyne,gounod,kuznetsova,pallava,ordinating,reigate,'first,lewisburg,exploitative,danby,academica,bailiwick,brahe,injective,stipulations,aeschylus,computes,gulden,hydroxylase,liveries,somalis,underpinnings,muscovite,kongsberg,domus,overlain,shareware,variegated,jalalabad,agence,ciphertext,insectivores,dengeki,menuhin,cladistic,baerum,betrothal,tokushima,wavelet,expansionist,pottsville,siyuan,prerequisites,carpi,nemzeti,nazar,trialled,eliminator,irrorated,homeward,redwoods,undeterred,strayed,lutyens,multicellular,aurelian,notated,lordships,alsatian,idents,foggia,garros,chalukyas,lillestrom,podlaski,pessimism,hsien,demilitarized,whitewashed,willesden,kirkcaldy,sanctorum,lamia,relaying,escondido,paediatric,contemplates,demarcated,bluestone,betula,penarol,capitalise,kreuznach,kenora,115th,hold'em,reichswehr,vaucluse,m.i.a,windings,boys/girls,cajon,hisar,predictably,flemington,ysgol,mimicked,clivina,grahamstown,ionia,glyndebourne,patrese,aquaria,sleaford,dayal,sportscenter,malappuram,m.b.a.,manoa,carbines,solvable,designator,ramanujan,linearity,academicians,sayid,lancastrian,factorial,strindberg,vashem,delos,comyn,condensing,superdome,merited,kabaddi,intransitive,bideford,neuroimaging,duopoly,scorecards,ziggler,heriot,boyars,virology,marblehead,microtubules,westphalian,anticipates,hingham,searchers,harpist,rapides,morricone,convalescent,mises,nitride,metrorail,matterhorn,bicol,drivetrain,marketer,snippet,winemakers,muban,scavengers,halberstadt,herkimer,peten,laborious,stora,montgomeryshire,booklist,shamir,herault,eurostar,anhydrous,spacewalk,ecclesia,calliostoma,highschool,d'oro,suffusion,imparts,overlords,tagus,rectifier,counterinsurgency,ministered,eilean,milecastle,contre,micromollusk,okhotsk,bartoli,matroid,hasidim,thirunal,terme,tarlac,lashkar,presque,thameslink,flyby,troopship,renouncing,fatih,messrs,vexillum,bagration,magnetite,bornholm,androgynous,vehement,tourette,philosophic,gianfranco,tuileries,codice_6,radially,flexion,hants,reprocessing,setae,burne,palaeographically,infantryman,shorebirds,tamarind,moderna,threading,militaristic,crohn,norrkoping,125cc,stadtholder,troms,klezmer,alphanumeric,brome,emmanuelle,tiwari,alchemical,formula_52,onassis,bleriot,bipedal,colourless,hermeneutics,hosni,precipitating,turnstiles,hallucinogenic,panhellenic,wyandotte,elucidated,chita,ehime,generalised,hydrophilic,biota,niobium,rnzaf,gandhara,longueuil,logics,sheeting,bielsko,cuvier,kagyu,trefoil,docent,pancrase,stalinism,postures,encephalopathy,monckton,imbalances,epochs,leaguers,anzio,diminishes,pataki,nitrite,amuro,nabil,maybach,l'aquila,babbler,bacolod,thutmose,evora,gaudi,breakage,recur,preservative,60deg,mendip,functionaries,columnar,maccabiah,chert,verden,bromsgrove,clijsters,dengue,pastorate,phuoc,principia,viareggio,kharagpur,scharnhorst,anyang,bosons,l'art,criticises,ennio,semarang,brownian,mirabilis,asperger,calibers,typographical,cartooning,minos,disembark,supranational,undescribed,etymologically,alappuzha,vilhelm,lanao,pakenham,bhagavata,rakoczi,clearings,astrologers,manitowoc,bunuel,acetylene,scheduler,defamatory,trabzonspor,leaded,scioto,pentathlete,abrahamic,minigames,aldehydes,peerages,legionary,1640s,masterworks,loudness,bryansk,likeable,genocidal,vegetated,towpath,declination,pyrrhus,divinely,vocations,rosebery,associazione,loaders,biswas,oeste,tilings,xianzong,bhojpuri,annuities,relatedness,idolator,psers,constriction,chuvash,choristers,hanafi,fielders,grammarian,orpheum,asylums,millbrook,gyatso,geldof,stabilise,tableaux,diarist,kalahari,panini,cowdenbeath,melanin,4x100m,resonances,pinar,atherosclerosis,sheringham,castlereagh,aoyama,larks,pantograph,protrude,natak,gustafsson,moribund,cerevisiae,cleanly,polymeric,holkar,cosmonauts,underpinning,lithosphere,firuzabad,languished,mingled,citrate,spadina,lavas,daejeon,fibrillation,porgy,pineville,ps1000,cobbled,emamzadeh,mukhtar,dampers,indelible,salonika,nanoscale,treblinka,eilat,purporting,fluctuate,mesic,hagiography,cutscenes,fondation,barrens,comically,accrue,ibrox,makerere,defections,'there,hollandia,skene,grosseto,reddit,objectors,inoculation,rowdies,playfair,calligrapher,namor,sibenik,abbottabad,propellants,hydraulically,chloroplasts,tablelands,tecnico,schist,klasse,shirvan,bashkortostan,bullfighting,north/south,polski,hanns,woodblock,kilmore,ejecta,ignacy,nanchang,danubian,commendations,snohomish,samaritans,argumentation,vasconcelos,hedgehogs,vajrayana,barents,kulkarni,kumbakonam,identifications,hillingdon,weirs,nayanar,beauvoir,messe,divisors,atlantiques,broods,affluence,tegucigalpa,unsuited,autodesk,akash,princeps,culprits,kingstown,unassuming,goole,visayan,asceticism,blagojevich,irises,paphos,unsound,maurier,pontchartrain,desertification,sinfonietta,latins,especial,limpet,valerenga,glial,brainstem,mitral,parables,sauropod,judean,iskcon,sarcoma,venlo,justifications,zhuhai,blavatsky,alleviated,usafe,steppenwolf,inversions,janko,chagall,secretory,basildon,saguenay,pergamon,hemispherical,harmonized,reloading,franjo,domaine,extravagance,relativism,metamorphosed,labuan,baloncesto,gmail,byproducts,calvinists,counterattacked,vitus,bubonic,120th,strachey,ritually,brookwood,selectable,savinja,incontinence,meltwater,jinja,1720s,brahmi,morgenthau,sheaves,sleeved,stratovolcano,wielki,utilisation,avoca,fluxus,panzergrenadier,philately,deflation,podlaska,prerogatives,kuroda,theophile,zhongzong,gascoyne,magus,takao,arundell,fylde,merdeka,prithviraj,venkateswara,liepaja,daigo,dreamland,reflux,sunnyvale,coalfields,seacrest,soldering,flexor,structuralism,alnwick,outweighed,unaired,mangeshkar,batons,glaad,banshees,irradiated,organelles,biathlete,cabling,chairlift,lollapalooza,newsnight,capacitive,succumbs,flatly,miramichi,burwood,comedienne,charteris,biotic,workspace,aficionados,sokolka,chatelet,o'shaughnessy,prosthesis,neoliberal,refloated,oppland,hatchlings,econometrics,loess,thieu,androids,appalachians,jenin,pterostichinae,downsized,foils,chipsets,stencil,danza,narrate,maginot,yemenite,bisects,crustacean,prescriptive,melodious,alleviation,empowers,hansson,autodromo,obasanjo,osmosis,daugava,rheumatism,moraes,leucine,etymologies,chepstow,delaunay,bramall,bajaj,flavoring,approximates,marsupials,incisive,microcomputer,tactically,waals,wilno,fisichella,ursus,hindmarsh,mazarin,lomza,xenophobia,lawlessness,annecy,wingers,gornja,gnaeus,superieur,tlaxcala,clasps,symbolises,slats,rightist,effector,blighted,permanence,divan,progenitors,kunsthalle,anointing,excelling,coenzyme,indoctrination,dnipro,landholdings,adriaan,liturgies,cartan,ethmia,attributions,sanctus,trichy,chronicon,tancred,affinis,kampuchea,gantry,pontypool,membered,distrusted,fissile,dairies,hyposmocoma,craigie,adarsh,martinsburg,taxiway,30deg,geraint,vellum,bencher,khatami,formula_53,zemun,teruel,endeavored,palmares,pavements,u.s..,internationalization,satirized,carers,attainable,wraparound,muang,parkersburg,extinctions,birkenfeld,wildstorm,payers,cohabitation,unitas,culloden,capitalizing,clwyd,daoist,campinas,emmylou,orchidaceae,halakha,orientales,fealty,domnall,chiefdom,nigerians,ladislav,dniester,avowed,ergonomics,newsmagazine,kitsch,cantilevered,benchmarking,remarriage,alekhine,coldfield,taupo,almirante,substations,apprenticeships,seljuq,levelling,eponym,symbolising,salyut,opioids,underscore,ethnologue,mohegan,marikina,libro,bassano,parse,semantically,disjointed,dugdale,padraig,tulsi,modulating,xfinity,headlands,mstislav,earthworms,bourchier,lgbtq,embellishments,pennants,rowntree,betel,motet,mulla,catenary,washoe,mordaunt,dorking,colmar,girardeau,glentoran,grammatically,samad,recreations,technion,staccato,mikoyan,spoilers,lyndhurst,victimization,chertsey,belafonte,tondo,tonsberg,narrators,subcultures,malformations,edina,augmenting,attests,euphemia,cabriolet,disguising,1650s,navarrese,demoralized,cardiomyopathy,welwyn,wallachian,smoothness,planktonic,voles,issuers,sardasht,survivability,cuauhtemoc,thetis,extruded,signet,raghavan,lombok,eliyahu,crankcase,dissonant,stolberg,trencin,desktops,bursary,collectivization,charlottenburg,triathlete,curvilinear,involuntarily,mired,wausau,invades,sundaram,deletions,bootstrap,abellio,axiomatic,noguchi,setups,malawian,visalia,materialist,kartuzy,wenzong,plotline,yeshivas,parganas,tunica,citric,conspecific,idlib,superlative,reoccupied,blagoevgrad,masterton,immunological,hatta,courbet,vortices,swallowtail,delves,haridwar,diptera,boneh,bahawalpur,angering,mardin,equipments,deployable,guanine,normality,rimmed,artisanal,boxset,chandrasekhar,jools,chenar,tanakh,carcassonne,belatedly,millville,anorthosis,reintegration,velde,surfactant,kanaan,busoni,glyphipterix,personas,fullness,rheims,tisza,stabilizers,bharathi,joost,spinola,mouldings,perching,esztergom,afzal,apostate,lustre,s.league,motorboat,monotheistic,armature,barat,asistencia,bloomsburg,hippocampal,fictionalised,defaults,broch,hexadecimal,lusignan,ryanair,boccaccio,breisgau,southbank,bskyb,adjoined,neurobiology,aforesaid,sadhu,langue,headship,wozniacki,hangings,regulus,prioritized,dynamism,allier,hannity,shimin,antoninus,gymnopilus,caledon,preponderance,melayu,electrodynamics,syncopated,ibises,krosno,mechanistic,morpeth,harbored,albini,monotheism,'real,hyperactivity,haveli,writer/director,minato,nimoy,caerphilly,chitral,amirabad,fanshawe,l'oreal,lorde,mukti,authoritarianism,valuing,spyware,hanbury,restarting,stato,embed,suiza,empiricism,stabilisation,stari,castlemaine,orbis,manufactory,mauritanian,shoji,taoyuan,prokaryotes,oromia,ambiguities,embodying,slims,frente,innovate,ojibwa,powdery,gaeltacht,argentinos,quatermass,detergents,fijians,adaptor,tokai,chileans,bulgars,oxidoreductases,bezirksliga,conceicao,myosin,nellore,500cc,supercomputers,approximating,glyndwr,polypropylene,haugesund,cockerell,tudman,ashbourne,hindemith,bloodlines,rigveda,etruria,romanos,steyn,oradea,deceleration,manhunter,laryngeal,fraudulently,janez,wendover,haplotype,janaki,naoki,belizean,mellencamp,cartographic,sadhana,tricolour,pseudoscience,satara,bytow,s.p.a.,jagdgeschwader,arcot,omagh,sverdrup,masterplan,surtees,apocrypha,ahvaz,d'amato,socratic,leumit,unnumbered,nandini,witold,marsupial,coalesced,interpolated,gimnasia,karadzic,keratin,mamoru,aldeburgh,speculator,escapement,irfan,kashyap,satyajit,haddington,solver,rothko,ashkelon,kickapoo,yeomen,superbly,bloodiest,greenlandic,lithic,autofocus,yardbirds,poona,keble,javan,sufis,expandable,tumblr,ursuline,swimwear,winwood,counsellors,aberrations,marginalised,befriending,workouts,predestination,varietal,siddhartha,dunkeld,judaic,esquimalt,shabab,ajith,telefonica,stargard,hoysala,radhakrishnan,sinusoidal,strada,hiragana,cebuano,monoid,independencia,floodwaters,mildura,mudflats,ottokar,translit,radix,wigner,philosophically,tephritid,synthesizing,castletown,installs,stirner,resettle,bushfire,choirmaster,kabbalistic,shirazi,lightship,rebus,colonizers,centrifuge,leonean,kristofferson,thymus,clackamas,ratnam,rothesay,municipally,centralia,thurrock,gulfport,bilinear,desirability,merite,psoriasis,macaw,erigeron,consignment,mudstone,distorting,karlheinz,ramen,tailwheel,vitor,reinsurance,edifices,superannuation,dormancy,contagion,cobden,rendezvoused,prokaryotic,deliberative,patricians,feigned,degrades,starlings,sopot,viticultural,beaverton,overflowed,convener,garlands,michiel,ternopil,naturelle,biplanes,bagot,gamespy,ventspils,disembodied,flattening,profesional,londoners,arusha,scapular,forestall,pyridine,ulema,eurodance,aruna,callus,periodontal,coetzee,immobilized,o'meara,maharani,katipunan,reactants,zainab,microgravity,saintes,britpop,carrefour,constrain,adversarial,firebirds,brahmo,kashima,simca,surety,surpluses,superconductivity,gipuzkoa,cumans,tocantins,obtainable,humberside,roosting,'king,formula_54,minelayer,bessel,sulayman,cycled,biomarkers,annealing,shusha,barda,cassation,djing,polemics,tuple,directorates,indomitable,obsolescence,wilhelmine,pembina,bojan,tambo,dioecious,pensioner,magnificat,1660s,estrellas,southeasterly,immunodeficiency,railhead,surreptitiously,codeine,encores,religiosity,tempera,camberley,efendi,boardings,malleable,hagia,input/output,lucasfilm,ujjain,polymorphisms,creationist,berners,mickiewicz,irvington,linkedin,endures,kinect,munition,apologetics,fairlie,predicated,reprinting,ethnographer,variances,levantine,mariinsky,jadid,jarrow,asia/oceania,trinamool,waveforms,bisexuality,preselection,pupae,buckethead,hieroglyph,lyricists,marionette,dunbartonshire,restorer,monarchical,pazar,kickoffs,cabildo,savannas,gliese,dench,spoonbills,novelette,diliman,hypersensitivity,authorising,montefiore,mladen,qu'appelle,theistic,maruti,laterite,conestoga,saare,californica,proboscis,carrickfergus,imprecise,hadassah,baghdadi,jolgeh,deshmukh,amusements,heliopolis,berle,adaptability,partenkirchen,separations,baikonur,cardamom,southeastward,southfield,muzaffar,adequacy,metropolitana,rajkot,kiyoshi,metrobus,evictions,reconciles,librarianship,upsurge,knightley,badakhshan,proliferated,spirituals,burghley,electroacoustic,professing,featurette,reformists,skylab,descriptors,oddity,greyfriars,injects,salmond,lanzhou,dauntless,subgenera,underpowered,transpose,mahinda,gatos,aerobatics,seaworld,blocs,waratahs,joris,giggs,perfusion,koszalin,mieczyslaw,ayyubid,ecologists,modernists,sant'angelo,quicktime,him/her,staves,sanyo,melaka,acrocercops,qigong,iterated,generalizes,recuperation,vihara,circassians,psychical,chavo,memoires,infiltrates,notaries,pelecaniformesfamily,strident,chivalric,pierrepont,alleviating,broadsides,centipede,b.tech,reinterpreted,sudetenland,hussite,covenanters,radhika,ironclads,gainsbourg,testis,penarth,plantar,azadegan,beano,espn.com,leominster,autobiographies,nbcuniversal,eliade,khamenei,montferrat,undistinguished,ethnological,wenlock,fricatives,polymorphic,biome,joule,sheaths,astrophysicist,salve,neoclassicism,lovat,downwind,belisarius,forma,usurpation,freie,depopulation,backbench,ascenso,'high,aagpbl,gdanski,zalman,mouvement,encapsulation,bolshevism,statny,voyageurs,hywel,vizcaya,mazra'eh,narthex,azerbaijanis,cerebrospinal,mauretania,fantail,clearinghouse,bolingbroke,pequeno,ansett,remixing,microtubule,wrens,jawahar,palembang,gambian,hillsong,fingerboard,repurposed,sundry,incipient,veolia,theologically,ulaanbaatar,atsushi,foundling,resistivity,myeloma,factbook,mazowiecka,diacritic,urumqi,clontarf,provokes,intelsat,professes,materialise,portobello,benedictines,panionios,introverted,reacquired,bridport,mammary,kripke,oratorios,vlore,stoning,woredas,unreported,antti,togolese,fanzines,heuristics,conservatories,carburetors,clitheroe,cofounded,formula_57,erupting,quinnipiac,bootle,ghostface,sittings,aspinall,sealift,transferase,boldklub,siskiyou,predominated,francophonie,ferruginous,castrum,neogene,sakya,madama,precipitous,'love,posix,bithynia,uttara,avestan,thrushes,seiji,memorably,septimius,libri,cibernetico,hyperinflation,dissuaded,cuddalore,peculiarity,vaslui,grojec,albumin,thurles,casks,fasteners,fluidity,buble,casals,terek,gnosticism,cognates,ulnar,radwanska,babylonians,majuro,oxidizer,excavators,rhythmically,liffey,gorakhpur,eurydice,underscored,arborea,lumumba,tuber,catholique,grama,galilei,scrope,centreville,jacobin,bequests,ardeche,polygamous,montauban,terai,weatherboard,readability,attainder,acraea,transversely,rivets,winterbottom,reassures,bacteriology,vriesea,chera,andesite,dedications,homogenous,reconquered,bandon,forrestal,ukiyo,gurdjieff,tethys,sparc,muscogee,grebes,belchatow,mansa,blantyre,palliser,sokolow,fibroblasts,exmoor,misaki,soundscapes,housatonic,middelburg,convenor,leyla,antipope,histidine,okeechobee,alkenes,sombre,alkene,rubik,macaques,calabar,trophee,pinchot,'free,frusciante,chemins,falaise,vasteras,gripped,schwarzenberg,cumann,kanchipuram,acoustically,silverbacks,fangio,inset,plympton,kuril,vaccinations,recep,theropods,axils,stavropol,encroached,apoptotic,papandreou,wailers,moonstone,assizes,micrometers,hornchurch,truncation,annapurna,egyptologists,rheumatic,promiscuity,satiric,fleche,caloptilia,anisotropy,quaternions,gruppo,viscounts,awardees,aftershocks,sigint,concordance,oblasts,gaumont,stent,commissars,kesteven,hydroxy,vijayanagar,belorussian,fabricius,watermark,tearfully,mamet,leukaemia,sorkh,milepost,tattooing,vosta,abbasids,uncompleted,hedong,woodwinds,extinguishing,malus,multiplexes,francoist,pathet,responsa,bassists,'most,postsecondary,ossory,grampian,saakashvili,alito,strasberg,impressionistic,volador,gelatinous,vignette,underwing,campanian,abbasabad,albertville,hopefuls,nieuwe,taxiways,reconvened,recumbent,pathologists,unionized,faversham,asymptotically,romulo,culling,donja,constricted,annesley,duomo,enschede,lovech,sharpshooter,lansky,dhamma,papillae,alanine,mowat,delius,wrest,mcluhan,podkarpackie,imitators,bilaspur,stunting,pommel,casemate,handicaps,nagas,testaments,hemings,necessitate,rearward,locative,cilla,klitschko,lindau,merion,consequential,antic,soong,copula,berthing,chevrons,rostral,sympathizer,budokan,ranulf,beria,stilt,replying,conflated,alcibiades,painstaking,yamanashi,calif.,arvid,ctesiphon,xizong,rajas,caxton,downbeat,resurfacing,rudders,miscegenation,deathmatch,foregoing,arthropod,attestation,karts,reapportionment,harnessing,eastlake,schola,dosing,postcolonial,imtiaz,formula_55,insulators,gunung,accumulations,pampas,llewelyn,bahnhof,cytosol,grosjean,teaneck,briarcliff,arsenio,canara,elaborating,passchendaele,searchlights,holywell,mohandas,preventable,gehry,mestizos,ustinov,cliched,'national,heidfeld,tertullian,jihadist,tourer,miletus,semicircle,outclassed,bouillon,cardinalate,clarifies,dakshina,bilayer,pandyan,unrwa,chandragupta,formula_56,portola,sukumaran,lactation,islamia,heikki,couplers,misappropriation,catshark,montt,ploughs,carib,stator,leaderboard,kenrick,dendrites,scape,tillamook,molesworth,mussorgsky,melanesia,restated,troon,glycoside,truckee,headwater,mashup,sectoral,gangwon,docudrama,skirting,psychopathology,dramatised,ostroleka,infestations,thabo,depolarization,wideroe,eisenbahn,thomond,kumaon,upendra,foreland,acronyms,yaqui,retaking,raphaelite,specie,dupage,villars,lucasarts,chloroplast,werribee,balsa,ascribe,havant,flava,khawaja,tyumen,subtract,interrogators,reshaping,buzzcocks,eesti,campanile,potemkin,apertures,snowboarder,registrars,handbooks,boyar,contaminant,depositors,proximate,jeunesse,zagora,pronouncements,mists,nihilism,deified,margraviate,pietersen,moderators,amalfi,adjectival,copepods,magnetosphere,pallets,clemenceau,castra,perforation,granitic,troilus,grzegorz,luthier,dockyards,antofagasta,ffestiniog,subroutine,afterword,waterwheel,druce,nitin,undifferentiated,emacs,readmitted,barneveld,tapers,hittites,infomercials,infirm,braathens,heligoland,carpark,geomagnetic,musculoskeletal,nigerien,machinima,harmonize,repealing,indecency,muskoka,verite,steubenville,suffixed,cytoskeleton,surpasses,harmonia,imereti,ventricles,heterozygous,envisions,otsego,ecoles,warrnambool,burgenland,seria,rawat,capistrano,welby,kirin,enrollments,caricom,dragonlance,schaffhausen,expanses,photojournalism,brienne,etude,referent,jamtland,schemas,xianbei,cleburne,bicester,maritima,shorelines,diagonals,bjelke,nonpublic,aliasing,m.f.a,ovals,maitreya,skirmishing,grothendieck,sukhothai,angiotensin,bridlington,durgapur,contras,gakuen,skagit,rabbinate,tsunamis,haphazard,tyldesley,microcontroller,discourages,hialeah,compressing,septimus,larvik,condoleezza,psilocybin,protectionism,songbirds,clandestinely,selectmen,wargame,cinemascope,khazars,agronomy,melzer,latifah,cherokees,recesses,assemblymen,basescu,banaras,bioavailability,subchannels,adenine,o'kelly,prabhakar,leonese,dimethyl,testimonials,geoffroy,oxidant,universiti,gheorghiu,bohdan,reversals,zamorin,herbivore,jarre,sebastiao,infanterie,dolmen,teddington,radomsko,spaceships,cuzco,recapitulation,mahoning,bainimarama,myelin,aykroyd,decals,tokelau,nalgonda,rajasthani,121st,quelled,tambov,illyrians,homilies,illuminations,hypertrophy,grodzisk,inundation,incapacity,equilibria,combats,elihu,steinitz,berengar,gowda,canwest,khosrau,maculata,houten,kandinsky,onside,leatherhead,heritable,belvidere,federative,chukchi,serling,eruptive,patan,entitlements,suffragette,evolutions,migrates,demobilisation,athleticism,trope,sarpsborg,kensal,translink,squamish,concertgebouw,energon,timestamp,competences,zalgiris,serviceman,codice_7,spoofing,assange,mahadevan,skien,suceava,augustan,revisionism,unconvincing,hollande,drina,gottlob,lippi,broglie,darkening,tilapia,eagerness,nacht,kolmogorov,photometric,leeuwarden,jrotc,haemorrhage,almanack,cavalli,repudiation,galactose,zwickau,cetinje,houbraken,heavyweights,gabonese,ordinals,noticias,museveni,steric,charaxes,amjad,resection,joinville,leczyca,anastasius,purbeck,subtribe,dalles,leadoff,monoamine,jettisoned,kaori,anthologized,alfreton,indic,bayezid,tottori,colonizing,assassinating,unchanging,eusebian,d'estaing,tsingtao,toshio,transferases,peronist,metrology,equus,mirpur,libertarianism,kovil,indole,'green,abstention,quantitatively,icebreakers,tribals,mainstays,dryandra,eyewear,nilgiri,chrysanthemum,inositol,frenetic,merchantman,hesar,physiotherapist,transceiver,dancefloor,rankine,neisse,marginalization,lengthen,unaided,rework,pageantry,savio,striated,funen,witton,illuminates,frass,hydrolases,akali,bistrita,copywriter,firings,handballer,tachinidae,dmytro,coalesce,neretva,menem,moraines,coatbridge,crossrail,spoofed,drosera,ripen,protour,kikuyu,boleslav,edwardes,troubadours,haplogroups,wrasse,educationalist,sroda,khaneh,dagbladet,apennines,neuroscientist,deplored,terje,maccabees,daventry,spaceport,lessening,ducats,singer/guitarist,chambersburg,yeong,configurable,ceremonially,unrelenting,caffe,graaf,denizens,kingsport,ingush,panhard,synthesised,tumulus,homeschooled,bozorg,idiomatic,thanhouser,queensway,radek,hippolytus,inking,banovina,peacocks,piaui,handsworth,pantomimes,abalone,thera,kurzweil,bandura,augustinians,bocelli,ferrol,jiroft,quadrature,contravention,saussure,rectification,agrippina,angelis,matanzas,nidaros,palestrina,latium,coriolis,clostridium,ordain,uttering,lanchester,proteolytic,ayacucho,merseburg,holbein,sambalpur,algebraically,inchon,ostfold,savoia,calatrava,lahiri,judgeship,ammonite,masaryk,meyerbeer,hemorrhagic,superspeedway,ningxia,panicles,encircles,khmelnytsky,profusion,esher,babol,inflationary,anhydride,gaspe,mossy,periodicity,nacion,meteorologists,mahjong,interventional,sarin,moult,enderby,modell,palgrave,warners,montcalm,siddha,functionalism,rilke,politicized,broadmoor,kunste,orden,brasileira,araneta,eroticism,colquhoun,mamba,blacktown,tubercle,seagrass,manoel,camphor,neoregelia,llandudno,annexe,enplanements,kamien,plovers,statisticians,iturbide,madrasah,nontrivial,publican,landholders,manama,uninhabitable,revivalist,trunkline,friendliness,gurudwara,rocketry,unido,tripos,besant,braque,evolutionarily,abkhazian,staffel,ratzinger,brockville,bohemond,intercut,djurgarden,utilitarianism,deploys,sastri,absolutism,subhas,asghar,fictions,sepinwall,proportionately,titleholders,thereon,foursquare,machinegun,knightsbridge,siauliai,aqaba,gearboxes,castaways,weakens,phallic,strzelce,buoyed,ruthenia,pharynx,intractable,neptunes,koine,leakey,netherlandish,preempted,vinay,terracing,instigating,alluvium,prosthetics,vorarlberg,politiques,joinery,reduplication,nebuchadnezzar,lenticular,banka,seaborne,pattinson,helpline,aleph,beckenham,californians,namgyal,franziska,aphid,branagh,transcribe,appropriateness,surakarta,takings,propagates,juraj,b0d3fb,brera,arrayed,tailback,falsehood,hazleton,prosody,egyptology,pinnate,tableware,ratan,camperdown,ethnologist,tabari,classifiers,biogas,126th,kabila,arbitron,apuestas,membranous,kincardine,oceana,glories,natick,populism,synonymy,ghalib,mobiles,motherboards,stationers,germinal,patronised,formula_58,gaborone,torts,jeezy,interleague,novaya,batticaloa,offshoots,wilbraham,filename,nswrfl,'well,trilobite,pythons,optimally,scientologists,rhesus,pilsen,backdrops,batang,unionville,hermanos,shrikes,fareham,outlawing,discontinuing,boisterous,shamokin,scanty,southwestward,exchangers,unexpired,mewar,h.m.s,saldanha,pawan,condorcet,turbidity,donau,indulgences,coincident,cliques,weeklies,bardhaman,violators,kenai,caspase,xperia,kunal,fistula,epistemic,cammell,nephi,disestablishment,rotator,germaniawerft,pyaar,chequered,jigme,perlis,anisotropic,popstars,kapil,appendices,berat,defecting,shacks,wrangel,panchayath,gorna,suckling,aerosols,sponheim,talal,borehole,encodings,enlai,subduing,agong,nadar,kitsap,syrmia,majumdar,pichilemu,charleville,embryology,booting,literati,abutting,basalts,jussi,repubblica,hertogenbosch,digitization,relents,hillfort,wiesenthal,kirche,bhagwan,bactrian,oases,phyla,neutralizing,helsing,ebooks,spearheading,margarine,'golden,phosphor,picea,stimulants,outliers,timescale,gynaecology,integrator,skyrocketed,bridgnorth,senecio,ramachandra,suffragist,arrowheads,aswan,inadvertent,microelectronics,118th,sofer,kubica,melanesian,tuanku,balkh,vyborg,crystallographic,initiators,metamorphism,ginzburg,looters,unimproved,finistere,newburyport,norges,immunities,franchisees,asterism,kortrijk,camorra,komsomol,fleurs,draughts,patagonian,voracious,artin,collaborationist,revolucion,revitalizing,xaver,purifying,antipsychotic,disjunct,pompeius,dreamwave,juvenal,beinn,adiyaman,antitank,allama,boletus,melanogaster,dumitru,caproni,aligns,athabaskan,stobart,phallus,veikkausliiga,hornsey,buffering,bourbons,dobruja,marga,borax,electrics,gangnam,motorcyclist,whidbey,draconian,lodger,galilean,sanctification,imitates,boldness,underboss,wheatland,cantabrian,terceira,maumee,redefining,uppercase,ostroda,characterise,universalism,equalized,syndicalism,haringey,masovia,deleuze,funkadelic,conceals,thuan,minsky,pluralistic,ludendorff,beekeeping,bonfires,endoscopic,abuts,prebend,jonkoping,amami,tribunes,yup'ik,awadh,gasification,pforzheim,reforma,antiwar,vaishnavism,maryville,inextricably,margrethe,empresa,neutrophils,sanctified,ponca,elachistidae,curiae,quartier,mannar,hyperplasia,wimax,busing,neologism,florins,underrepresented,digitised,nieuw,cooch,howards,frege,hughie,plied,swale,kapellmeister,vajpayee,quadrupled,aeronautique,dushanbe,custos,saltillo,kisan,tigray,manaus,epigrams,shamanic,peppered,frosts,promotion/relegation,concedes,zwingli,charentes,whangarei,hyung,spring/summer,sobre,eretz,initialization,sawai,ephemera,grandfathered,arnaldo,customised,permeated,parapets,growths,visegrad,estudios,altamont,provincia,apologises,stoppard,carburettor,rifts,kinematic,zhengzhou,eschatology,prakrit,folate,yvelines,scapula,stupas,rishon,reconfiguration,flutist,1680s,apostolate,proudhon,lakshman,articulating,stortford,faithfull,bitterns,upwelling,qur'anic,lidar,interferometry,waterlogged,koirala,ditton,wavefunction,fazal,babbage,antioxidants,lemberg,deadlocked,tolled,ramapo,mathematica,leiria,topologies,khali,photonic,balti,1080p,corrects,recommenced,polyglot,friezes,tiebreak,copacabana,cholmondeley,armband,abolishment,sheamus,buttes,glycolysis,cataloged,warrenton,sassari,kishan,foodservice,cryptanalysis,holmenkollen,cosplay,machi,yousuf,mangal,allying,fertiliser,otomi,charlevoix,metallurg,parisians,bottlenose,oakleigh,debug,cidade,accede,ligation,madhava,pillboxes,gatefold,aveyron,sorin,thirsk,immemorial,menelik,mehra,domingos,underpinned,fleshed,harshness,diphthong,crestwood,miskolc,dupri,pyrausta,muskingum,tuoba,prodi,incidences,waynesboro,marquesas,heydar,artesian,calinescu,nucleation,funders,covalently,compaction,derbies,seaters,sodor,tabular,amadou,peckinpah,o'halloran,zechariah,libyans,kartik,daihatsu,chandran,erzhu,heresies,superheated,yarder,dorde,tanjore,abusers,xuanwu,juniperus,moesia,trusteeship,birdwatching,beatz,moorcock,harbhajan,sanga,choreographic,photonics,boylston,amalgamate,prawns,electrifying,sarath,inaccurately,exclaims,powerpoint,chaining,cpusa,adulterous,saccharomyces,glogow,vfl/afl,syncretic,simla,persisting,functors,allosteric,euphorbiaceae,juryo,mlada,moana,gabala,thornycroft,kumanovo,ostrovsky,sitio,tutankhamun,sauropods,kardzhali,reinterpretation,sulpice,rosyth,originators,halesowen,delineation,asesoria,abatement,gardai,elytra,taillights,overlays,monsoons,sandpipers,ingmar,henrico,inaccuracy,irwell,arenabowl,elche,pressburg,signalman,interviewees,sinkhole,pendle,ecommerce,cellos,nebria,organometallic,surrealistic,propagandist,interlaken,canandaigua,aerials,coutinho,pascagoula,tonopah,letterkenny,gropius,carbons,hammocks,childe,polities,hosiery,donitz,suppresses,diaghilev,stroudsburg,bagram,pistoia,regenerating,unitarians,takeaway,offstage,vidin,glorification,bakunin,yavapai,lutzow,sabercats,witney,abrogated,gorlitz,validating,dodecahedron,stubbornly,telenor,glaxosmithkline,solapur,undesired,jellicoe,dramatization,four-and-a-half,seawall,waterpark,artaxerxes,vocalization,typographic,byung,sachsenhausen,shepparton,kissimmee,konnan,belsen,dhawan,khurd,mutagenesis,vejle,perrot,estradiol,formula_60,saros,chiloe,misiones,lamprey,terrains,speke,miasto,eigenvectors,haydock,reservist,corticosteroids,savitri,shinawatra,developmentally,yehudi,berates,janissaries,recapturing,rancheria,subplots,gresley,nikkatsu,oryol,cosmas,boavista,formula_59,playfully,subsections,commentated,kathakali,dorid,vilaine,seepage,hylidae,keiji,kazakhs,triphosphate,1620s,supersede,monarchists,falla,miyako,notching,bhumibol,polarizing,secularized,shingled,bronislaw,lockerbie,soleyman,bundesbahn,latakia,redoubts,boult,inwardly,invents,ondrej,minangkabau,newquay,permanente,alhaji,madhav,malini,ellice,bookmaker,mankiewicz,etihad,o'dea,interrogative,mikawa,wallsend,canisius,bluesy,vitruvius,noord,ratifying,mixtec,gujranwala,subprefecture,keelung,goiania,nyssa,shi'ite,semitone,ch'uan,computerised,pertuan,catapults,nepomuk,shruti,millstones,buskerud,acolytes,tredegar,sarum,armia,dell'arte,devises,custodians,upturned,gallaudet,disembarking,thrashed,sagrada,myeon,undeclared,qumran,gaiden,tepco,janesville,showground,condense,chalon,unstaffed,pasay,undemocratic,hauts,viridis,uninjured,escutcheon,gymkhana,petaling,hammam,dislocations,tallaght,rerum,shias,indios,guaranty,simplicial,benares,benediction,tajiri,prolifically,huawei,onerous,grantee,ferencvaros,otranto,carbonates,conceit,digipak,qadri,masterclasses,swamiji,cradock,plunket,helmsman,119th,salutes,tippecanoe,murshidabad,intelligibility,mittal,diversifying,bidar,asansol,crowdsourcing,rovere,karakoram,grindcore,skylights,tulagi,furrows,ligne,stuka,sumer,subgraph,amata,regionalist,bulkeley,teletext,glorify,readied,lexicographer,sabadell,predictability,quilmes,phenylalanine,bandaranaike,pyrmont,marksmen,quisling,viscountess,sociopolitical,afoul,pediments,swazi,martyrology,nullify,panagiotis,superconductors,veldenz,jujuy,l'isle,hematopoietic,shafi,subsea,hattiesburg,jyvaskyla,kebir,myeloid,landmine,derecho,amerindians,birkenau,scriabin,milhaud,mucosal,nikaya,freikorps,theoretician,proconsul,o'hanlon,clerked,bactria,houma,macular,topologically,shrubby,aryeh,ghazali,afferent,magalhaes,moduli,ashtabula,vidarbha,securitate,ludwigsburg,adoor,varun,shuja,khatun,chengde,bushels,lascelles,professionnelle,elfman,rangpur,unpowered,citytv,chojnice,quaternion,stokowski,aschaffenburg,commutes,subramaniam,methylene,satrap,gharb,namesakes,rathore,helier,gestational,heraklion,colliers,giannis,pastureland,evocation,krefeld,mahadeva,churchmen,egret,yilmaz,galeazzo,pudukkottai,artigas,generalitat,mudslides,frescoed,enfeoffed,aphorisms,melilla,montaigne,gauliga,parkdale,mauboy,linings,prema,sapir,xylophone,kushan,rockne,sequoyah,vasyl,rectilinear,vidyasagar,microcosm,san'a,carcinogen,thicknesses,aleut,farcical,moderating,detested,hegemonic,instalments,vauban,verwaltungsgemeinschaft,picayune,razorback,magellanic,moluccas,pankhurst,exportation,waldegrave,sufferer,bayswater,1up.com,rearmament,orangutans,varazdin,b.o.b,elucidate,harlingen,erudition,brankovic,lapis,slipway,urraca,shinde,unwell,elwes,euboea,colwyn,srivijaya,grandstands,hortons,generalleutnant,fluxes,peterhead,gandhian,reals,alauddin,maximized,fairhaven,endow,ciechanow,perforations,darters,panellist,manmade,litigants,exhibitor,tirol,caracalla,conformance,hotelier,stabaek,hearths,borac,frisians,ident,veliko,emulators,schoharie,uzbeks,samarra,prestwick,wadia,universita,tanah,bucculatrix,predominates,genotypes,denounces,roadsides,ganassi,keokuk,philatelist,tomic,ingots,conduits,samplers,abdus,johar,allegories,timaru,wolfpacks,secunda,smeaton,sportivo,inverting,contraindications,whisperer,moradabad,calamities,bakufu,soundscape,smallholders,nadeem,crossroad,xenophobic,zakir,nationalliga,glazes,retroflex,schwyz,moroder,rubra,quraysh,theodoros,endemol,infidels,km/hr,repositioned,portraitist,lluis,answerable,arges,mindedness,coarser,eyewall,teleported,scolds,uppland,vibraphone,ricoh,isenburg,bricklayer,cuttlefish,abstentions,communicable,cephalopod,stockyards,balto,kinston,armbar,bandini,elphaba,maxims,bedouins,sachsen,friedkin,tractate,pamir,ivanovo,mohini,kovalainen,nambiar,melvyn,orthonormal,matsuyama,cuernavaca,veloso,overstated,streamer,dravid,informers,analyte,sympathized,streetscape,gosta,thomasville,grigore,futuna,depleting,whelks,kiedis,armadale,earner,wynyard,dothan,animating,tridentine,sabri,immovable,rivoli,ariege,parley,clinker,circulates,junagadh,fraunhofer,congregants,180th,buducnost,formula_62,olmert,dedekind,karnak,bayernliga,mazes,sandpiper,ecclestone,yuvan,smallmouth,decolonization,lemmy,adjudicated,retiro,legia,benue,posit,acidification,wahab,taconic,floatplane,perchlorate,atria,wisbech,divestment,dallara,phrygia,palustris,cybersecurity,rebates,facie,mineralogical,substituent,proteges,fowey,mayenne,smoothbore,cherwell,schwarzschild,junin,murrumbidgee,smalltalk,d'orsay,emirati,calaveras,titusville,theremin,vikramaditya,wampanoag,burra,plaines,onegin,emboldened,whampoa,langa,soderbergh,arnaz,sowerby,arendal,godunov,pathanamthitta,damselfly,bestowing,eurosport,iconoclasm,outfitters,acquiesced,badawi,hypotension,ebbsfleet,annulus,sohrab,thenceforth,chagatai,necessitates,aulus,oddities,toynbee,uniontown,innervation,populaire,indivisible,rossellini,minuet,cyrene,gyeongju,chania,cichlids,harrods,1690s,plunges,abdullahi,gurkhas,homebuilt,sortable,bangui,rediff,incrementally,demetrios,medaille,sportif,svend,guttenberg,tubules,carthusian,pleiades,torii,hoppus,phenyl,hanno,conyngham,teschen,cronenberg,wordless,melatonin,distinctiveness,autos,freising,xuanzang,dunwich,satanism,sweyn,predrag,contractually,pavlovic,malaysians,micrometres,expertly,pannonian,abstaining,capensis,southwesterly,catchphrases,commercialize,frankivsk,normanton,hibernate,verso,deportees,dubliners,codice_8,condors,zagros,glosses,leadville,conscript,morrisons,usury,ossian,oulton,vaccinium,civet,ayman,codrington,hadron,nanometers,geochemistry,extractor,grigori,tyrrhenian,neocollyris,drooping,falsification,werft,courtauld,brigantine,orhan,chapultepec,supercopa,federalized,praga,havering,encampments,infallibility,sardis,pawar,undirected,reconstructionist,ardrossan,varuna,pastimes,archdiocesan,fledging,shenhua,molise,secondarily,stagnated,replicates,ciencias,duryodhana,marauding,ruislip,ilyich,intermixed,ravenswood,shimazu,mycorrhizal,icosahedral,consents,dunblane,follicular,pekin,suffield,muromachi,kinsale,gauche,businesspeople,thereto,watauga,exaltation,chelmno,gorse,proliferate,drainages,burdwan,kangra,transducers,inductor,duvalier,maguindanao,moslem,uncaf,givenchy,plantarum,liturgics,telegraphs,lukashenko,chenango,andante,novae,ironwood,faubourg,torme,chinensis,ambala,pietermaritzburg,virginians,landform,bottlenecks,o'driscoll,darbhanga,baptistery,ameer,needlework,naperville,auditoriums,mullingar,starrer,animatronic,topsoil,madura,cannock,vernet,santurce,catocala,ozeki,pontevedra,multichannel,sundsvall,strategists,medio,135th,halil,afridi,trelawny,caloric,ghraib,allendale,hameed,ludwigshafen,spurned,pavlo,palmar,strafed,catamarca,aveiro,harmonization,surah,predictors,solvay,mande,omnipresent,parenthesis,echolocation,equaling,experimenters,acyclic,lithographic,sepoys,katarzyna,sridevi,impoundment,khosrow,caesarean,nacogdoches,rockdale,lawmaker,caucasians,bahman,miyan,rubric,exuberance,bombastic,ductile,snowdonia,inlays,pinyon,anemones,hurries,hospitallers,tayyip,pulleys,treme,photovoltaics,testbed,polonium,ryszard,osgoode,profiting,ironwork,unsurpassed,nepticulidae,makai,lumbini,preclassic,clarksburg,egremont,videography,rehabilitating,ponty,sardonic,geotechnical,khurasan,solzhenitsyn,henna,phoenicia,rhyolite,chateaux,retorted,tomar,deflections,repressions,harborough,renan,brumbies,vandross,storia,vodou,clerkenwell,decking,universo,salon.com,imprisoning,sudwest,ghaziabad,subscribing,pisgah,sukhumi,econometric,clearest,pindar,yildirim,iulia,atlases,cements,remaster,dugouts,collapsible,resurrecting,batik,unreliability,thiers,conjunctions,colophon,marcher,placeholder,flagella,wolds,kibaki,viviparous,twelver,screenshots,aroostook,khadr,iconographic,itasca,jaume,basti,propounded,varro,be'er,jeevan,exacted,shrublands,creditable,brocade,boras,bittern,oneonta,attentional,herzliya,comprehensible,lakeville,discards,caxias,frankland,camerata,satoru,matlab,commutator,interprovincial,yorkville,benefices,nizami,edwardsville,amigaos,cannabinoid,indianola,amateurliga,pernicious,ubiquity,anarchic,novelties,precondition,zardari,symington,sargodha,headphone,thermopylae,mashonaland,zindagi,thalberg,loewe,surfactants,dobro,crocodilians,samhita,diatoms,haileybury,berwickshire,supercritical,sofie,snorna,slatina,intramolecular,agung,osteoarthritis,obstetric,teochew,vakhtang,connemara,deformations,diadem,ferruccio,mainichi,qualitatively,refrigerant,rerecorded,methylated,karmapa,krasinski,restatement,rouvas,cubitt,seacoast,schwarzkopf,homonymous,shipowner,thiamine,approachable,xiahou,160th,ecumenism,polistes,internazionali,fouad,berar,biogeography,texting,inadequately,'when,4kids,hymenoptera,emplaced,cognomen,bellefonte,supplant,michaelmas,uriel,tafsir,morazan,schweinfurt,chorister,ps400,nscaa,petipa,resolutely,ouagadougou,mascarene,supercell,konstanz,bagrat,harmonix,bergson,shrimps,resonators,veneta,camas,mynydd,rumford,generalmajor,khayyam,web.com,pappus,halfdan,tanana,suomen,yutaka,bibliographical,traian,silat,noailles,contrapuntal,agaricus,'special,minibuses,1670s,obadiah,deepa,rorschach,malolos,lymington,valuations,imperials,caballeros,ambroise,judicature,elegiac,sedaka,shewa,checksum,gosforth,legionaries,corneille,microregion,friedrichshafen,antonis,surnamed,mycelium,cantus,educations,topmost,outfitting,ivica,nankai,gouda,anthemic,iosif,supercontinent,antifungal,belarusians,mudaliar,mohawks,caversham,glaciated,basemen,stevan,clonmel,loughton,deventer,positivist,manipuri,tensors,panipat,changeup,impermeable,dubbo,elfsborg,maritimo,regimens,bikram,bromeliad,substratum,norodom,gaultier,queanbeyan,pompeo,redacted,eurocopter,mothballed,centaurs,borno,copra,bemidji,'home,sopron,neuquen,passo,cineplex,alexandrov,wysokie,mammoths,yossi,sarcophagi,congreve,petkovic,extraneous,waterbirds,slurs,indias,phaeton,discontented,prefaced,abhay,prescot,interoperable,nordisk,bicyclists,validly,sejong,litovsk,zanesville,kapitanleutnant,kerch,changeable,mcclatchy,celebi,attesting,maccoll,sepahan,wayans,veined,gaudens,markt,dansk,soane,quantized,petersham,forebears,nayarit,frenzied,queuing,bygone,viggo,ludwik,tanka,hanssen,brythonic,cornhill,primorsky,stockpiles,conceptualization,lampeter,hinsdale,mesoderm,bielsk,rosenheim,ultron,joffrey,stanwyck,khagan,tiraspol,pavelic,ascendant,empoli,metatarsal,descentralizado,masada,ligier,huseyin,ramadi,waratah,tampines,ruthenium,statoil,mladost,liger,grecian,multiparty,digraph,maglev,reconsideration,radiography,cartilaginous,taizu,wintered,anabaptist,peterhouse,shoghi,assessors,numerator,paulet,painstakingly,halakhic,rocroi,motorcycling,gimel,kryptonian,emmeline,cheeked,drawdown,lelouch,dacians,brahmana,reminiscence,disinfection,optimizations,golders,extensor,tsugaru,tolling,liman,gulzar,unconvinced,crataegus,oppositional,dvina,pyrolysis,mandan,alexius,prion,stressors,loomed,moated,dhivehi,recyclable,relict,nestlings,sarandon,kosovar,solvers,czeslaw,kenta,maneuverable,middens,berkhamsted,comilla,folkways,loxton,beziers,batumi,petrochemicals,optimised,sirjan,rabindra,musicality,rationalisation,drillers,subspaces,'live,bbwaa,outfielders,tsung,danske,vandalised,norristown,striae,kanata,gastroenterology,steadfastly,equalising,bootlegging,mannerheim,notodontidae,lagoa,commentating,peninsulas,chishti,seismology,modigliani,preceptor,canonically,awardee,boyaca,hsinchu,stiffened,nacelle,bogor,dryness,unobstructed,yaqub,scindia,peeters,irritant,ammonites,ferromagnetic,speechwriter,oxygenated,walesa,millais,canarian,faience,calvinistic,discriminant,rasht,inker,annexes,howth,allocates,conditionally,roused,regionalism,regionalbahn,functionary,nitrates,bicentenary,recreates,saboteurs,koshi,plasmids,thinned,124th,plainview,kardashian,neuville,victorians,radiates,127th,vieques,schoolmates,petru,tokusatsu,keying,sunaina,flamethrower,'bout,demersal,hosokawa,corelli,omniscient,o'doherty,niksic,reflectivity,transdev,cavour,metronome,temporally,gabba,nsaids,geert,mayport,hematite,boeotia,vaudreuil,torshavn,sailplane,mineralogist,eskisehir,practises,gallifrey,takumi,unease,slipstream,hedmark,paulinus,ailsa,wielkopolska,filmworks,adamantly,vinaya,facelifted,franchisee,augustana,toppling,velvety,crispa,stonington,histological,genealogist,tactician,tebow,betjeman,nyingma,overwinter,oberoi,rampal,overwinters,petaluma,lactarius,stanmore,balikpapan,vasant,inclines,laminate,munshi,sociedade,rabbah,septal,boyband,ingrained,faltering,inhumans,nhtsa,affix,l'ordre,kazuki,rossendale,mysims,latvians,slaveholders,basilicata,neuburg,assize,manzanillo,scrobipalpa,formula_61,belgique,pterosaurs,privateering,vaasa,veria,northport,pressurised,hobbyist,austerlitz,sahih,bhadra,siliguri,bistrica,bursaries,wynton,corot,lepidus,lully,libor,libera,olusegun,choline,mannerism,lymphocyte,chagos,duxbury,parasitism,ecowas,morotai,cancion,coniston,aggrieved,sputnikmusic,parle,ammonian,civilisations,malformation,cattaraugus,skyhawks,d'arc,demerara,bronfman,midwinter,piscataway,jogaila,threonine,matins,kohlberg,hubli,pentatonic,camillus,nigam,potro,unchained,chauvel,orangeville,cistercians,redeployment,xanthi,manju,carabinieri,pakeha,nikolaevich,kantakouzenos,sesquicentennial,gunships,symbolised,teramo,ballo,crusading,l'oeil,bharatpur,lazier,gabrovo,hysteresis,rothbard,chaumont,roundel,ma'mun,sudhir,queried,newts,shimane,presynaptic,playfield,taxonomists,sensitivities,freleng,burkinabe,orfeo,autovia,proselytizing,bhangra,pasok,jujutsu,heung,pivoting,hominid,commending,formula_64,epworth,christianized,oresund,hantuchova,rajputana,hilversum,masoretic,dayak,bakri,assen,magog,macromolecules,waheed,qaida,spassky,rumped,protrudes,preminger,misogyny,glencairn,salafi,lacunae,grilles,racemes,areva,alighieri,inari,epitomized,photoshoot,one-of-a-kind,tring,muralist,tincture,backwaters,weaned,yeasts,analytically,smaland,caltrans,vysocina,jamuna,mauthausen,175th,nouvelles,censoring,reggina,christology,gilad,amplifying,mehmood,johnsons,redirects,eastgate,sacrum,meteoric,riverbanks,guidebooks,ascribes,scoparia,iconoclastic,telegraphic,chine,merah,mistico,lectern,sheung,aethelstan,capablanca,anant,uspto,albatrosses,mymensingh,antiretroviral,clonal,coorg,vaillant,liquidator,gigas,yokai,eradicating,motorcyclists,waitakere,tandon,nears,montenegrins,250th,tatsuya,yassin,atheistic,syncretism,nahum,berisha,transcended,owensboro,lakshmana,abteilung,unadorned,nyack,overflows,harrisonburg,complainant,uematsu,frictional,worsens,sangguniang,abutment,bulwer,sarma,apollinaire,shippers,lycia,alentejo,porpoises,optus,trawling,augustow,blackwall,workbench,westmount,leaped,sikandar,conveniences,stornoway,culverts,zoroastrians,hristo,ansgar,assistive,reassert,fanned,compasses,delgada,maisons,arima,plonsk,verlaine,starstruck,rakhine,befell,spirally,wyclef,expend,colloquium,formula_63,albertus,bellarmine,handedness,holon,introns,movimiento,profitably,lohengrin,discoverers,awash,erste,pharisees,dwarka,oghuz,hashing,heterodox,uloom,vladikavkaz,linesman,rehired,nucleophile,germanicus,gulshan,songz,bayerische,paralympian,crumlin,enjoined,khanum,prahran,penitent,amersfoort,saranac,semisimple,vagrants,compositing,tualatin,oxalate,lavra,ironi,ilkeston,umpqua,calum,stretford,zakat,guelders,hydrazine,birkin,spurring,modularity,aspartate,sodermanland,hopital,bellary,legazpi,clasico,cadfael,hypersonic,volleys,pharmacokinetics,carotene,orientale,pausini,bataille,lunga,retailed,m.phil,mazowieckie,vijayan,rawal,sublimation,promissory,estimators,ploughed,conflagration,penda,segregationist,otley,amputee,coauthor,sopra,pellew,wreckers,tollywood,circumscription,permittivity,strabane,landward,articulates,beaverbrook,rutherglen,coterminous,whistleblowers,colloidal,surbiton,atlante,oswiecim,bhasa,lampooned,chanter,saarc,landkreis,tribulation,tolerates,daiichi,hatun,cowries,dyschirius,abercromby,attock,aldwych,inflows,absolutist,l'histoire,committeeman,vanbrugh,headstock,westbourne,appenzell,hoxton,oculus,westfalen,roundabouts,nickelback,trovatore,quenching,summarises,conservators,transmutation,talleyrand,barzani,unwillingly,axonal,'blue,opining,enveloping,fidesz,rafah,colborne,flickr,lozenge,dulcimer,ndebele,swaraj,oxidize,gonville,resonated,gilani,superiore,endeared,janakpur,shepperton,solidifying,memoranda,sochaux,kurnool,rewari,emirs,kooning,bruford,unavailability,kayseri,judicious,negating,pterosaur,cytosolic,chernihiv,variational,sabretooth,seawolves,devalued,nanded,adverb,volunteerism,sealers,nemours,smederevo,kashubian,bartin,animax,vicomte,polotsk,polder,archiepiscopal,acceptability,quidditch,tussock,seminaire,immolation,belge,coves,wellingborough,khaganate,mckellen,nayaka,brega,kabhi,pontoons,bascule,newsreels,injectors,cobol,weblog,diplo,biggar,wheatbelt,erythrocytes,pedra,showgrounds,bogdanovich,eclecticism,toluene,elegies,formalize,andromedae,airworthiness,springville,mainframes,overexpression,magadha,bijelo,emlyn,glutamine,accenture,uhuru,metairie,arabidopsis,patanjali,peruvians,berezovsky,accion,astrolabe,jayanti,earnestly,sausalito,recurved,1500s,ramla,incineration,galleons,laplacian,shiki,smethwick,isomerase,dordevic,janow,jeffersonville,internationalism,penciled,styrene,ashur,nucleoside,peristome,horsemanship,sedges,bachata,medes,kristallnacht,schneerson,reflectance,invalided,strutt,draupadi,destino,partridges,tejas,quadrennial,aurel,halych,ethnomusicology,autonomist,radyo,rifting,shi'ar,crvena,telefilm,zawahiri,plana,sultanates,theodorus,subcontractors,pavle,seneschal,teleports,chernivtsi,buccal,brattleboro,stankovic,safar,dunhuang,electrocution,chastised,ergonomic,midsomer,130th,zomba,nongovernmental,escapist,localize,xuzhou,kyrie,carinthian,karlovac,nisan,kramnik,pilipino,digitisation,khasi,andronicus,highwayman,maior,misspelling,sebastopol,socon,rhaetian,archimandrite,partway,positivity,otaku,dingoes,tarski,geopolitics,disciplinarian,zulfikar,kenzo,globose,electrophilic,modele,storekeeper,pohang,wheldon,washers,interconnecting,digraphs,intrastate,campy,helvetic,frontispiece,ferrocarril,anambra,petraeus,midrib,endometrial,dwarfism,mauryan,endocytosis,brigs,percussionists,furtherance,synergistic,apocynaceae,krona,berthier,circumvented,casal,siltstone,precast,ethnikos,realists,geodesy,zarzuela,greenback,tripathi,persevered,interments,neutralization,olbermann,departements,supercomputing,demobilised,cassavetes,dunder,ministering,veszprem,barbarism,'world,pieve,apologist,frentzen,sulfides,firewalls,pronotum,staatsoper,hachette,makhachkala,oberland,phonon,yoshihiro,instars,purnima,winslet,mutsu,ergative,sajid,nizamuddin,paraphrased,ardeidae,kodagu,monooxygenase,skirmishers,sportiva,o'byrne,mykolaiv,ophir,prieta,gyllenhaal,kantian,leche,copan,herero,ps250,gelsenkirchen,shalit,sammarinese,chetwynd,wftda,travertine,warta,sigmaringen,concerti,namespace,ostergotland,biomarker,universals,collegio,embarcadero,wimborne,fiddlers,likening,ransomed,stifled,unabated,kalakaua,khanty,gongs,goodrem,countermeasure,publicizing,geomorphology,swedenborg,undefended,catastrophes,diverts,storyboards,amesbury,contactless,placentia,festivity,authorise,terrane,thallium,stradivarius,antonine,consortia,estimations,consecrate,supergiant,belichick,pendants,butyl,groza,univac,afire,kavala,studi,teletoon,paucity,gonbad,koninklijke,128th,stoichiometric,multimodal,facundo,anatomic,melamine,creuse,altan,brigands,mcguinty,blomfield,tsvangirai,protrusion,lurgan,warminster,tenzin,russellville,discursive,definable,scotrail,lignin,reincorporated,o'dell,outperform,redland,multicolored,evaporates,dimitrie,limbic,patapsco,interlingua,surrogacy,cutty,potrero,masud,cahiers,jintao,ardashir,centaurus,plagiarized,minehead,musings,statuettes,logarithms,seaview,prohibitively,downforce,rivington,tomorrowland,microbiologist,ferric,morag,capsid,kucinich,clairvaux,demotic,seamanship,cicada,painterly,cromarty,carbonic,tupou,oconee,tehuantepec,typecast,anstruther,internalized,underwriters,tetrahedra,flagrant,quakes,pathologies,ulrik,nahal,tarquini,dongguan,parnassus,ryoko,senussi,seleucia,airasia,einer,sashes,d'amico,matriculating,arabesque,honved,biophysical,hardinge,kherson,mommsen,diels,icbms,reshape,brasiliensis,palmach,netaji,oblate,functionalities,grigor,blacksburg,recoilless,melanchthon,reales,astrodome,handcrafted,memes,theorizes,isma'il,aarti,pirin,maatschappij,stabilizes,honiara,ashbury,copts,rootes,defensed,queiroz,mantegna,galesburg,coraciiformesfamily,cabrillo,tokio,antipsychotics,kanon,173rd,apollonia,finial,lydian,hadamard,rangi,dowlatabad,monolingual,platformer,subclasses,chiranjeevi,mirabeau,newsgroup,idmanyurdu,kambojas,walkover,zamoyski,generalist,khedive,flanges,knowle,bande,157th,alleyn,reaffirm,pininfarina,zuckerberg,hakodate,131st,aditi,bellinzona,vaulter,planking,boscombe,colombians,lysis,toppers,metered,nahyan,queensryche,minho,nagercoil,firebrand,foundress,bycatch,mendota,freeform,antena,capitalisation,martinus,overijssel,purists,interventionist,zgierz,burgundians,hippolyta,trompe,umatilla,moroccans,dictionnaire,hydrography,changers,chota,rimouski,aniline,bylaw,grandnephew,neamt,lemnos,connoisseurs,tractive,rearrangements,fetishism,finnic,apalachicola,landowning,calligraphic,circumpolar,mansfeld,legible,orientalism,tannhauser,blamey,maximization,noinclude,blackbirds,angara,ostersund,pancreatitis,glabra,acleris,juried,jungian,triumphantly,singlet,plasmas,synesthesia,yellowhead,unleashes,choiseul,quanzhong,brookville,kaskaskia,igcse,skatepark,jatin,jewellers,scaritinae,techcrunch,tellurium,lachaise,azuma,codeshare,dimensionality,unidirectional,scolaire,macdill,camshafts,unassisted,verband,kahlo,eliya,prelature,chiefdoms,saddleback,sockers,iommi,coloratura,llangollen,biosciences,harshest,maithili,k'iche,plical,multifunctional,andreu,tuskers,confounding,sambre,quarterdeck,ascetics,berdych,transversal,tuolumne,sagami,petrobras,brecker,menxia,instilling,stipulating,korra,oscillate,deadpan,v/line,pyrotechnic,stoneware,prelims,intracoastal,retraining,ilija,berwyn,encrypt,achievers,zulfiqar,glycoproteins,khatib,farmsteads,occultist,saman,fionn,derulo,khilji,obrenovic,argosy,toowong,dementieva,sociocultural,iconostasis,craigslist,festschrift,taifa,intercalated,tanjong,penticton,sharad,marxian,extrapolation,guises,wettin,prabang,exclaiming,kosta,famas,conakry,wanderings,'aliabad,macleay,exoplanet,bancorp,besiegers,surmounting,checkerboard,rajab,vliet,tarek,operable,wargaming,haldimand,fukuyama,uesugi,aggregations,erbil,brachiopods,tokyu,anglais,unfavorably,ujpest,escorial,armagnac,nagara,funafuti,ridgeline,cocking,o'gorman,compactness,retardant,krajowa,barua,coking,bestows,thampi,chicagoland,variably,o'loughlin,minnows,schwa,shaukat,polycarbonate,chlorinated,godalming,gramercy,delved,banqueting,enlil,sarada,prasanna,domhnall,decadal,regressive,lipoprotein,collectable,surendra,zaporizhia,cycliste,suchet,offsetting,formula_65,pudong,d'arte,blyton,quonset,osmania,tientsin,manorama,proteomics,bille,jalpaiguri,pertwee,barnegat,inventiveness,gollancz,euthanized,henricus,shortfalls,wuxia,chlorides,cerrado,polyvinyl,folktale,straddled,bioengineering,eschewing,greendale,recharged,olave,ceylonese,autocephalous,peacebuilding,wrights,guyed,rosamund,abitibi,bannockburn,gerontology,scutari,souness,seagram,codice_9,'open,xhtml,taguig,purposed,darbar,orthopedics,unpopulated,kisumu,tarrytown,feodor,polyhedral,monadnock,gottorp,priam,redesigning,gasworks,elfin,urquiza,homologation,filipovic,bohun,manningham,gornik,soundness,shorea,lanus,gelder,darke,sandgate,criticality,paranaense,153rd,vieja,lithograph,trapezoid,tiebreakers,convalescence,yan'an,actuaries,balad,altimeter,thermoelectric,trailblazer,previn,tenryu,ancaster,endoscopy,nicolet,discloses,fracking,plaine,salado,americanism,placards,absurdist,propylene,breccia,jirga,documenta,ismailis,161st,brentano,dallas/fort,embellishment,calipers,subscribes,mahavidyalaya,wednesbury,barnstormers,miwok,schembechler,minigame,unterberger,dopaminergic,inacio,nizamabad,overridden,monotype,cavernous,stichting,sassafras,sotho,argentinean,myrrh,rapidity,flatts,gowrie,dejected,kasaragod,cyprinidae,interlinked,arcseconds,degeneracy,infamously,incubate,substructure,trigeminal,sectarianism,marshlands,hooliganism,hurlers,isolationist,urania,burrard,switchover,lecco,wilts,interrogator,strived,ballooning,volterra,raciborz,relegating,gilding,cybele,dolomites,parachutist,lochaber,orators,raeburn,backend,benaud,rallycross,facings,banga,nuclides,defencemen,futurity,emitters,yadkin,eudonia,zambales,manasseh,sirte,meshes,peculiarly,mcminnville,roundly,boban,decrypt,icelanders,sanam,chelan,jovian,grudgingly,penalised,subscript,gambrinus,poaceae,infringements,maleficent,runciman,148th,supersymmetry,granites,liskeard,eliciting,involution,hallstatt,kitzbuhel,shankly,sandhills,inefficiencies,yishuv,psychotropic,nightjars,wavell,sangamon,vaikundar,choshu,retrospectives,pitesti,gigantea,hashemi,bosna,gakuin,siochana,arrangers,baronetcies,narayani,temecula,creston,koscierzyna,autochthonous,wyandot,anniston,igreja,mobilise,buzau,dunster,musselburgh,wenzhou,khattak,detoxification,decarboxylase,manlius,campbells,coleoptera,copyist,sympathisers,suisun,eminescu,defensor,transshipment,thurgau,somerton,fluctuates,ambika,weierstrass,lukow,giambattista,volcanics,romanticized,innovated,matabeleland,scotiabank,garwolin,purine,d'auvergne,borderland,maozhen,pricewaterhousecoopers,testator,pallium,scout.com,mv/pi,nazca,curacies,upjohn,sarasvati,monegasque,ketrzyn,malory,spikelets,biomechanics,haciendas,rapped,dwarfed,stews,nijinsky,subjection,matsu,perceptible,schwarzburg,midsection,entertains,circuitous,epiphytic,wonsan,alpini,bluefield,sloths,transportable,braunfels,dictum,szczecinek,jukka,wielun,wejherowo,hucknall,grameen,duodenum,ribose,deshpande,shahar,nexstar,injurious,dereham,lithographer,dhoni,structuralist,progreso,deschutes,christus,pulteney,quoins,yitzchak,gyeongsang,breviary,makkah,chiyoda,jutting,vineland,angiosperms,necrotic,novelisation,redistribute,tirumala,140th,featureless,mafic,rivaling,toyline,2/1st,martius,saalfeld,monthan,texian,kathak,melodramas,mithila,regierungsbezirk,509th,fermenting,schoolmate,virtuosic,briain,kokoda,heliocentric,handpicked,kilwinning,sonically,dinars,kasim,parkways,bogdanov,luxembourgian,halland,avesta,bardic,daugavpils,excavator,qwest,frustrate,physiographic,majoris,'ndrangheta,unrestrained,firmness,montalban,abundances,preservationists,adare,executioners,guardsman,bonnaroo,neglects,nazrul,pro12,hoorn,abercorn,refuting,kabud,cationic,parapsychology,troposphere,venezuelans,malignancy,khoja,unhindered,accordionist,medak,visby,ejercito,laparoscopic,dinas,umayyads,valmiki,o'dowd,saplings,stranding,incisions,illusionist,avocets,buccleuch,amazonia,fourfold,turboprops,roosts,priscus,turnstile,areal,certifies,pocklington,spoofs,viseu,commonalities,dabrowka,annam,homesteaders,daredevils,mondrian,negotiates,fiestas,perennials,maximizes,lubavitch,ravindra,scrapers,finials,kintyre,violas,snoqualmie,wilders,openbsd,mlawa,peritoneal,devarajan,congke,leszno,mercurial,fakir,joannes,bognor,overloading,unbuilt,gurung,scuttle,temperaments,bautzen,jardim,tradesman,visitations,barbet,sagamore,graaff,forecasters,wilsons,assis,l'air,shariah,sochaczew,russa,dirge,biliary,neuve,heartbreakers,strathearn,jacobian,overgrazing,edrich,anticline,parathyroid,petula,lepanto,decius,channelled,parvathi,puppeteers,communicators,francorchamps,kahane,longus,panjang,intron,traite,xxvii,matsuri,amrit,katyn,disheartened,cacak,omonia,alexandrine,partaking,wrangling,adjuvant,haskovo,tendrils,greensand,lammermoor,otherworld,volusia,stabling,one-and-a-half,bresson,zapatista,eotvos,ps150,webisodes,stepchildren,microarray,braganca,quanta,dolne,superoxide,bellona,delineate,ratha,lindenwood,bruhl,cingulate,tallies,bickerton,helgi,bevin,takoma,tsukuba,statuses,changeling,alister,bytom,dibrugarh,magnesia,duplicating,outlier,abated,goncalo,strelitz,shikai,mardan,musculature,ascomycota,springhill,tumuli,gabaa,odenwald,reformatted,autocracy,theresienstadt,suplex,chattopadhyay,mencken,congratulatory,weatherfield,systema,solemnity,projekt,quanzhou,kreuzberg,postbellum,nobuo,mediaworks,finisterre,matchplay,bangladeshis,kothen,oocyte,hovered,aromas,afshar,browed,teases,chorlton,arshad,cesaro,backbencher,iquique,vulcans,padmini,unabridged,cyclase,despotic,kirilenko,achaean,queensberry,debre,octahedron,iphigenia,curbing,karimnagar,sagarmatha,smelters,surrealists,sanada,shrestha,turridae,leasehold,jiedushi,eurythmics,appropriating,correze,thimphu,amery,musicomh,cyborgs,sandwell,pushcart,retorts,ameliorate,deteriorates,stojanovic,spline,entrenchments,bourse,chancellorship,pasolini,lendl,personage,reformulated,pubescens,loiret,metalurh,reinvention,nonhuman,eilema,tarsal,complutense,magne,broadview,metrodome,outtake,stouffville,seinen,bataillon,phosphoric,ostensible,opatow,aristides,beefheart,glorifying,banten,romsey,seamounts,fushimi,prophylaxis,sibylla,ranjith,goslar,balustrades,georgiev,caird,lafitte,peano,canso,bankura,halfpenny,segregate,caisson,bizerte,jamshedpur,euromaidan,philosophie,ridged,cheerfully,reclassification,aemilius,visionaries,samoans,wokingham,chemung,wolof,unbranched,cinerea,bhosle,ourense,immortalised,cornerstones,sourcebook,khufu,archimedean,universitatea,intermolecular,fiscally,suffices,metacomet,adjudicator,stablemate,specks,glace,inowroclaw,patristic,muharram,agitating,ashot,neurologic,didcot,gamla,ilves,putouts,siraj,laski,coaling,diarmuid,ratnagiri,rotulorum,liquefaction,morbihan,harel,aftershock,gruiformesfamily,bonnier,falconiformesfamily,adorns,wikis,maastrichtian,stauffenberg,bishopsgate,fakhr,sevenfold,ponders,quantifying,castiel,opacity,depredations,lenten,gravitated,o'mahony,modulates,inuktitut,paston,kayfabe,vagus,legalised,balked,arianism,tendering,sivas,birthdate,awlaki,khvajeh,shahab,samtgemeinde,bridgeton,amalgamations,biogenesis,recharging,tsukasa,mythbusters,chamfered,enthronement,freelancers,maharana,constantia,sutil,messines,monkton,okanogan,reinvigorated,apoplexy,tanahashi,neues,valiants,harappan,russes,carding,volkoff,funchal,statehouse,imitative,intrepidity,mellotron,samaras,turkana,besting,longitudes,exarch,diarrhoea,transcending,zvonareva,darna,ramblin,disconnection,137th,refocused,diarmait,agricole,ba'athist,turenne,contrabass,communis,daviess,fatimids,frosinone,fittingly,polyphyletic,qanat,theocratic,preclinical,abacha,toorak,marketplaces,conidia,seiya,contraindicated,retford,bundesautobahn,rebuilds,climatology,seaworthy,starfighter,qamar,categoria,malai,hellinsia,newstead,airworthy,catenin,avonmouth,arrhythmias,ayyavazhi,downgrade,ashburnham,ejector,kinematics,petworth,rspca,filmation,accipitridae,chhatrapati,g/mol,bacau,agama,ringtone,yudhoyono,orchestrator,arbitrators,138th,powerplants,cumbernauld,alderley,misamis,hawai`i,cuando,meistriliiga,jermyn,alans,pedigrees,ottavio,approbation,omnium,purulia,prioress,rheinland,lymphoid,lutsk,oscilloscope,ballina,iliac,motorbikes,modernising,uffizi,phylloxera,kalevala,bengalis,amravati,syntheses,interviewers,inflectional,outflank,maryhill,unhurt,profiler,nacelles,heseltine,personalised,guarda,herpetologist,airpark,pigot,margaretha,dinos,peleliu,breakbeat,kastamonu,shaivism,delamere,kingsville,epigram,khlong,phospholipids,journeying,lietuvos,congregated,deviance,celebes,subsoil,stroma,kvitova,lubricating,layoff,alagoas,olafur,doron,interuniversity,raycom,agonopterix,uzice,nanna,springvale,raimundo,wrested,pupal,talat,skinheads,vestige,unpainted,handan,odawara,ammar,attendee,lapped,myotis,gusty,ciconiiformesfamily,traversal,subfield,vitaphone,prensa,hasidism,inwood,carstairs,kropotkin,turgenev,dobra,remittance,purim,tannin,adige,tabulation,lethality,pacha,micronesian,dhruva,defensemen,tibeto,siculus,radioisotope,sodertalje,phitsanulok,euphonium,oxytocin,overhangs,skinks,fabrica,reinterred,emulates,bioscience,paragliding,raekwon,perigee,plausibility,frolunda,erroll,aznar,vyasa,albinus,trevally,confederacion,terse,sixtieth,1530s,kendriya,skateboarders,frontieres,muawiyah,easements,shehu,conservatively,keystones,kasem,brutalist,peekskill,cowry,orcas,syllabary,paltz,elisabetta,denticles,hampering,dolni,eidos,aarau,lermontov,yankton,shahbaz,barrages,kongsvinger,reestablishment,acetyltransferase,zulia,mrnas,slingsby,eucalypt,efficacious,weybridge,gradation,cinematheque,malthus,bampton,coexisted,cisse,hamdi,cupertino,saumarez,chionodes,libertine,formers,sakharov,pseudonymous,vol.1,mcduck,gopalakrishnan,amberley,jorhat,grandmasters,rudiments,dwindle,param,bukidnon,menander,americanus,multipliers,pulawy,homoerotic,pillbox,cd+dvd,epigraph,aleksandrow,extrapolated,horseshoes,contemporain,angiography,hasselt,shawinigan,memorization,legitimized,cyclades,outsold,rodolphe,kelis,powerball,dijkstra,analyzers,incompressible,sambar,orangeburg,osten,reauthorization,adamawa,sphagnum,hypermarket,millipedes,zoroaster,madea,ossuary,murrayfield,pronominal,gautham,resellers,ethers,quarrelled,dolna,stragglers,asami,tangut,passos,educacion,sharaf,texel,berio,bethpage,bezalel,marfa,noronha,36ers,genteel,avram,shilton,compensates,sweetener,reinstalled,disables,noether,1590s,balakrishnan,kotaro,northallerton,cataclysm,gholam,cancellara,schiphol,commends,longinus,albinism,gemayel,hamamatsu,volos,islamism,sidereal,pecuniary,diggings,townsquare,neosho,lushan,chittoor,akhil,disputation,desiccation,cambodians,thwarting,deliberated,ellipsis,bahini,susumu,separators,kohneh,plebeians,kultur,ogaden,pissarro,trypeta,latur,liaodong,vetting,datong,sohail,alchemists,lengthwise,unevenly,masterly,microcontrollers,occupier,deviating,farringdon,baccalaureat,theocracy,chebyshev,archivists,jayaram,ineffectiveness,scandinavians,jacobins,encomienda,nambu,g/cm3,catesby,paavo,heeded,rhodium,idealised,10deg,infective,mecyclothorax,halevy,sheared,minbari,audax,lusatian,rebuffs,hitfix,fastener,subjugate,tarun,binet,compuserve,synthesiser,keisuke,amalric,ligatures,tadashi,ignazio,abramovich,groundnut,otomo,maeve,mortlake,ostrogoths,antillean,todor,recto,millimetre,espousing,inaugurate,paracetamol,galvanic,harpalinae,jedrzejow,reassessment,langlands,civita,mikan,stikine,bijar,imamate,istana,kaiserliche,erastus,federale,cytosine,expansionism,hommes,norrland,smriti,snapdragon,gulab,taleb,lossy,khattab,urbanised,sesto,rekord,diffuser,desam,morganatic,silting,pacts,extender,beauharnais,purley,bouches,halfpipe,discontinuities,houthi,farmville,animism,horni,saadi,interpretative,blockades,symeon,biogeographic,transcaucasian,jetties,landrieu,astrocytes,conjunto,stumpings,weevils,geysers,redux,arching,romanus,tazeh,marcellinus,casein,opava,misrata,anare,sattar,declarer,dreux,oporto,venta,vallis,icosahedron,cortona,lachine,mohammedan,sandnes,zynga,clarin,diomedes,tsuyoshi,pribram,gulbarga,chartist,superettan,boscawen,altus,subang,gating,epistolary,vizianagaram,ogdensburg,panna,thyssen,tarkovsky,dzogchen,biograph,seremban,unscientific,nightjar,legco,deism,n.w.a,sudha,siskel,sassou,flintlock,jovial,montbeliard,pallida,formula_66,tranquillity,nisei,adornment,'people,yamhill,hockeyallsvenskan,adopters,appian,lowicz,haplotypes,succinctly,starogard,presidencies,kheyrabad,sobibor,kinesiology,cowichan,militum,cromwellian,leiningen,ps1.5,concourses,dalarna,goldfield,brzeg,faeces,aquarii,matchless,harvesters,181st,numismatics,korfball,sectioned,transpires,facultative,brandishing,kieron,forages,menai,glutinous,debarge,heathfield,1580s,malang,photoelectric,froome,semiotic,alwar,grammophon,chiaroscuro,mentalist,maramures,flacco,liquors,aleutians,marvell,sutlej,patnaik,qassam,flintoff,bayfield,haeckel,sueno,avicii,exoplanets,hoshi,annibale,vojislav,honeycombs,celebrant,rendsburg,veblen,quails,141st,carronades,savar,narrations,jeeva,ontologies,hedonistic,marinette,godot,munna,bessarabian,outrigger,thame,gravels,hoshino,falsifying,stereochemistry,nacionalista,medially,radula,ejecting,conservatorio,odile,ceiba,jaina,essonne,isometry,allophones,recidivism,iveco,ganda,grammarians,jagan,signposted,uncompressed,facilitators,constancy,ditko,propulsive,impaling,interbank,botolph,amlaib,intergroup,sorbus,cheka,debye,praca,adorning,presbyteries,dormition,strategos,qarase,pentecostals,beehives,hashemite,goldust,euronext,egress,arpanet,soames,jurchens,slovenska,copse,kazim,appraisals,marischal,mineola,sharada,caricaturist,sturluson,galba,faizabad,overwintering,grete,uyezds,didsbury,libreville,ablett,microstructure,anadolu,belenenses,elocution,cloaks,timeslots,halden,rashidun,displaces,sympatric,germanus,tuples,ceska,equalize,disassembly,krautrock,babangida,memel,deild,gopala,hematology,underclass,sangli,wawrinka,assur,toshack,refrains,nicotinic,bhagalpur,badami,racetracks,pocatello,walgreens,nazarbayev,occultation,spinnaker,geneon,josias,hydrolyzed,dzong,corregimiento,waistcoat,thermoplastic,soldered,anticancer,lactobacillus,shafi'i,carabus,adjournment,schlumberger,triceratops,despotate,mendicant,krishnamurti,bahasa,earthworm,lavoisier,noetherian,kalki,fervently,bhawan,saanich,coquille,gannet,motagua,kennels,mineralization,fitzherbert,svein,bifurcated,hairdressing,felis,abounded,dimers,fervour,hebdo,bluffton,aetna,corydon,clevedon,carneiro,subjectively,deutz,gastropoda,overshot,concatenation,varman,carolla,maharshi,mujib,inelastic,riverhead,initialized,safavids,rohini,caguas,bulges,fotbollforbund,hefei,spithead,westville,maronites,lytham,americo,gediminas,stephanus,chalcolithic,hijra,gnu/linux,predilection,rulership,sterility,haidar,scarlatti,saprissa,sviatoslav,pointedly,sunroof,guarantor,thevar,airstrips,pultusk,sture,129th,divinities,daizong,dolichoderus,cobourg,maoists,swordsmanship,uprated,bohme,tashi,largs,chandi,bluebeard,householders,richardsonian,drepanidae,antigonish,elbasan,occultism,marca,hypergeometric,oirat,stiglitz,ignites,dzungar,miquelon,pritam,d'automne,ulidiid,niamey,vallecano,fondo,billiton,incumbencies,raceme,chambery,cadell,barenaked,kagame,summerside,haussmann,hatshepsut,apothecaries,criollo,feint,nasals,timurid,feltham,plotinus,oxygenation,marginata,officinalis,salat,participations,ising,downe,izumo,unguided,pretence,coursed,haruna,viscountcy,mainstage,justicia,powiat,takara,capitoline,implacable,farben,stopford,cosmopterix,tuberous,kronecker,galatians,kweli,dogmas,exhorted,trebinje,skanda,newlyn,ablative,basidia,bhiwani,encroachments,stranglers,regrouping,tubal,shoestring,wawel,anionic,mesenchymal,creationists,pyrophosphate,moshi,despotism,powerbook,fatehpur,rupiah,segre,ternate,jessore,b.i.g,shevardnadze,abounds,gliwice,densest,memoria,suborbital,vietcong,ratepayers,karunanidhi,toolbar,descents,rhymney,exhortation,zahedan,carcinomas,hyperbaric,botvinnik,billets,neuropsychological,tigranes,hoards,chater,biennially,thistles,scotus,wataru,flotillas,hungama,monopolistic,payouts,vetch,generalissimo,caries,naumburg,piran,blizzards,escalates,reactant,shinya,theorize,rizzoli,transitway,ecclesiae,streptomyces,cantal,nisibis,superconductor,unworkable,thallus,roehampton,scheckter,viceroys,makuuchi,ilkley,superseding,takuya,klodzko,borbon,raspberries,operand,w.a.k.o,sarabande,factionalism,egalitarianism,temasek,torbat,unscripted,jorma,westerner,perfective,vrije,underlain,goldfrapp,blaenau,jomon,barthes,drivetime,bassa,bannock,umaga,fengxiang,zulus,sreenivasan,farces,codice_10,freeholder,poddebice,imperialists,deregulated,wingtip,o'hagan,pillared,overtone,hofstadter,149th,kitano,saybrook,standardizing,aldgate,staveley,o'flaherty,hundredths,steerable,soltan,empted,cruyff,intramuros,taluks,cotonou,marae,karur,figueres,barwon,lucullus,niobe,zemlya,lathes,homeported,chaux,amyotrophic,opines,exemplars,bhamo,homomorphisms,gauleiter,ladin,mafiosi,airdrieonians,b/soul,decal,transcaucasia,solti,defecation,deaconess,numidia,sampradaya,normalised,wingless,schwaben,alnus,cinerama,yakutsk,ketchikan,orvieto,unearned,monferrato,rotem,aacsb,loong,decoders,skerries,cardiothoracic,repositioning,pimpernel,yohannan,tenebrionoidea,nargis,nouvel,costliest,interdenominational,noize,redirecting,zither,morcha,radiometric,frequenting,irtysh,gbagbo,chakri,litvinenko,infotainment,ravensbruck,harith,corbels,maegashira,jousting,natan,novus,falcao,minis,railed,decile,rauma,ramaswamy,cavitation,paranaque,berchtesgaden,reanimated,schomberg,polysaccharides,exclusionary,cleon,anurag,ravaging,dhanush,mitchells,granule,contemptuous,keisei,rolleston,atlantean,yorkist,daraa,wapping,micrometer,keeneland,comparably,baranja,oranje,schlafli,yogic,dinajpur,unimpressive,masashi,recreativo,alemannic,petersfield,naoko,vasudeva,autosport,rajat,marella,busko,wethersfield,ssris,soulcalibur,kobani,wildland,rookery,hoffenheim,kauri,aliphatic,balaclava,ferrite,publicise,victorias,theism,quimper,chapbook,functionalist,roadbed,ulyanovsk,cupen,purpurea,calthorpe,teofilo,mousavi,cochlea,linotype,detmold,ellerslie,gakkai,telkom,southsea,subcontractor,inguinal,philatelists,zeebrugge,piave,trochidae,dempo,spoilt,saharanpur,mihrab,parasympathetic,barbarous,chartering,antiqua,katsina,bugis,categorizes,altstadt,kandyan,pambansa,overpasses,miters,assimilating,finlandia,uneconomic,am/fm,harpsichordist,dresdner,luminescence,authentically,overpowers,magmatic,cliftonville,oilfields,skirted,berthe,cuman,oakham,frelimo,glockenspiel,confection,saxophonists,piaseczno,multilevel,antipater,levying,maltreatment,velho,opoczno,harburg,pedophilia,unfunded,palettes,plasterwork,breve,dharmendra,auchinleck,nonesuch,blackmun,libretti,rabbani,145th,hasselbeck,kinnock,malate,vanden,cloverdale,ashgabat,nares,radians,steelworkers,sabor,possums,catterick,hemispheric,ostra,outpaced,dungeness,almshouse,penryn,texians,1000m,franchitti,incumbency,texcoco,newar,tramcars,toroidal,meitetsu,spellbound,agronomist,vinifera,riata,bunko,pinas,ba'al,github,vasilyevich,obsolescent,geodesics,ancestries,tujue,capitalised,unassigned,throng,unpaired,psychometric,skegness,exothermic,buffered,kristiansund,tongued,berenger,basho,alitalia,prolongation,archaeologically,fractionation,cyprinid,echinoderms,agriculturally,justiciar,sonam,ilium,baits,danceable,grazer,ardahan,grassed,preemption,glassworks,hasina,ugric,umbra,wahhabi,vannes,tinnitus,capitaine,tikrit,lisieux,scree,hormuz,despenser,jagiellon,maisonneuve,gandaki,santarem,basilicas,lancing,landskrona,weilburg,fireside,elysian,isleworth,krishnamurthy,filton,cynon,tecmo,subcostal,scalars,triglycerides,hyperplane,farmingdale,unione,meydan,pilings,mercosur,reactivate,akiba,fecundity,jatra,natsume,zarqawi,preta,masao,presbyter,oakenfold,rhodri,ferran,ruizong,cloyne,nelvana,epiphanius,borde,scutes,strictures,troughton,whitestone,sholom,toyah,shingon,kutuzov,abelard,passant,lipno,cafeterias,residuals,anabaptists,paratransit,criollos,pleven,radiata,destabilizing,hadiths,bazaars,mannose,taiyo,crookes,welbeck,baoding,archelaus,nguesso,alberni,wingtips,herts,viasat,lankans,evreux,wigram,fassbinder,ryuichi,storting,reducible,olesnica,znojmo,hyannis,theophanes,flatiron,mustering,rajahmundry,kadir,wayang,prome,lethargy,zubin,illegality,conall,dramedy,beerbohm,hipparchus,ziarat,ryuji,shugo,glenorchy,microarchitecture,morne,lewinsky,cauvery,battenberg,hyksos,wayanad,hamilcar,buhari,brazo,bratianu,solms,aksaray,elamite,chilcotin,bloodstock,sagara,dolny,reunified,umlaut,proteaceae,camborne,calabrian,dhanbad,vaxjo,cookware,potez,rediffusion,semitones,lamentations,allgau,guernica,suntory,pleated,stationing,urgell,gannets,bertelsmann,entryway,raphitomidae,acetaldehyde,nephrology,categorizing,beiyang,permeate,tourney,geosciences,khana,masayuki,crucis,universitaria,slaskie,khaimah,finno,advani,astonishingly,tubulin,vampiric,jeolla,sociale,cleethorpes,badri,muridae,suzong,debater,decimation,kenyans,mutualism,pontifex,middlemen,insee,halevi,lamentation,psychopathy,brassey,wenders,kavya,parabellum,prolactin,inescapable,apses,malignancies,rinzai,stigmatized,menahem,comox,ateliers,welshpool,setif,centimetre,truthfulness,downfield,drusus,woden,glycosylation,emanated,agulhas,dalkeith,jazira,nucky,unifil,jobim,operon,oryzomys,heroically,seances,supernumerary,backhouse,hashanah,tatler,imago,invert,hayato,clockmaker,kingsmill,swiecie,analogously,golconda,poste,tacitly,decentralised,ge'ez,diplomatically,fossiliferous,linseed,mahavira,pedestals,archpriest,byelection,domiciled,jeffersonian,bombus,winegrowing,waukegan,uncultivated,haverfordwest,saumur,communally,disbursed,cleeve,zeljeznicar,speciosa,vacationers,sigur,vaishali,zlatko,iftikhar,cropland,transkei,incompleteness,bohra,subantarctic,slieve,physiologic,similis,klerk,replanted,'right,chafee,reproducible,bayburt,regicide,muzaffarpur,plurals,hanyu,orthologs,diouf,assailed,kamui,tarik,dodecanese,gorne,on/off,179th,shimoga,granaries,carlists,valar,tripolitania,sherds,simmern,dissociated,isambard,polytechnical,yuvraj,brabazon,antisense,pubmed,glans,minutely,masaaki,raghavendra,savoury,podcasting,tachi,bienville,gongsun,ridgely,deform,yuichi,binders,canna,carcetti,llobregat,implored,berri,njegos,intermingled,offload,athenry,motherhouse,corpora,kakinada,dannebrog,imperio,prefaces,musicologists,aerospatiale,shirai,nagapattinam,servius,cristoforo,pomfret,reviled,entebbe,stane,east/west,thermometers,matriarchal,siglo,bodil,legionnaire,ze'ev,theorizing,sangeetha,horticulturist,uncountable,lookalike,anoxic,ionospheric,genealogists,chicopee,imprinting,popish,crematoria,diamondback,cyathea,hanzhong,cameramen,halogaland,naklo,waclaw,storehouses,flexed,comuni,frits,glauca,nilgiris,compresses,nainital,continuations,albay,hypoxic,samajwadi,dunkerque,nanticoke,sarwar,interchanged,jubal,corba,jalgaon,derleth,deathstroke,magny,vinnytsia,hyphenated,rimfire,sawan,boehner,disrepute,normalize,aromanian,dualistic,approximant,chama,karimabad,barnacles,sanok,stipends,dyfed,rijksmuseum,reverberation,suncorp,fungicides,reverie,spectrograph,stereophonic,niazi,ordos,alcan,karaite,lautrec,tableland,lamellar,rieti,langmuir,russula,webern,tweaks,hawick,southerner,morphy,naturalisation,enantiomer,michinoku,barbettes,relieves,carburettors,redruth,oblates,vocabularies,mogilev,bagmati,galium,reasserted,extolled,symon,eurosceptic,inflections,tirtha,recompense,oruro,roping,gouverneur,pared,yayoi,watermills,retooled,leukocytes,jubilant,mazhar,nicolau,manheim,touraine,bedser,hambledon,kohat,powerhouses,tlemcen,reuven,sympathetically,afrikaners,interes,handcrafts,etcher,baddeley,wodonga,amaury,155th,vulgarity,pompadour,automorphisms,1540s,oppositions,prekmurje,deryni,fortifying,arcuate,mahila,bocage,uther,nozze,slashes,atlantica,hadid,rhizomatous,azeris,'with,osmena,lewisville,innervated,bandmaster,outcropping,parallelogram,dominicana,twang,ingushetia,extensional,ladino,sastry,zinoviev,relatable,nobilis,cbeebies,hitless,eulima,sporangia,synge,longlisted,criminalized,penitential,weyden,tubule,volyn,priestesses,glenbrook,kibbutzim,windshaft,canadair,falange,zsolt,bonheur,meine,archangels,safeguarded,jamaicans,malarial,teasers,badging,merseyrail,operands,pulsars,gauchos,biotin,bambara,necaxa,egmond,tillage,coppi,anxiolytic,preah,mausoleums,plautus,feroz,debunked,187th,belediyespor,mujibur,wantage,carboxyl,chettiar,murnau,vagueness,racemic,backstretch,courtland,municipio,palpatine,dezful,hyperbola,sreekumar,chalons,altay,arapahoe,tudors,sapieha,quilon,burdensome,kanya,xxviii,recension,generis,siphuncle,repressor,bitrate,mandals,midhurst,dioxin,democratique,upholds,rodez,cinematographic,epoque,jinping,rabelais,zhytomyr,glenview,rebooted,khalidi,reticulata,122nd,monnaie,passersby,ghazals,europaea,lippmann,earthbound,tadic,andorran,artvin,angelicum,banksy,epicentre,resemblances,shuttled,rathaus,bernt,stonemasons,balochi,siang,tynemouth,cygni,biosynthetic,precipitates,sharecroppers,d'annunzio,softbank,shiji,apeldoorn,polycyclic,wenceslas,wuchang,samnites,tamarack,silmarillion,madinah,palaeontology,kirchberg,sculpin,rohtak,aquabats,oviparous,thynne,caney,blimps,minimalistic,whatcom,palatalization,bardstown,direct3d,paramagnetic,kamboja,khash,globemaster,lengua,matej,chernigov,swanage,arsenals,cascadia,cundinamarca,tusculum,leavers,organics,warplanes,'three,exertions,arminius,gandharva,inquires,comercio,kuopio,chabahar,plotlines,mersenne,anquetil,paralytic,buckminster,ambit,acrolophus,quantifiers,clacton,ciliary,ansaldo,fergana,egoism,thracians,chicoutimi,northbrook,analgesia,brotherhoods,hunza,adriaen,fluoridation,snowfalls,soundboard,fangoria,cannibalistic,orthogonius,chukotka,dindigul,manzoni,chainz,macromedia,beltline,muruga,schistura,provable,litex,initio,pneumoniae,infosys,cerium,boonton,cannonballs,d'une,solvency,mandurah,houthis,dolmens,apologists,radioisotopes,blaxploitation,poroshenko,stawell,coosa,maximilien,tempelhof,espouse,declaratory,hambro,xalapa,outmoded,mihiel,benefitting,desirous,archeparchy,repopulated,telescoping,captor,mackaye,disparaged,ramanathan,crowne,tumbled,technetium,silted,chedi,nievre,hyeon,cartoonish,interlock,infocom,rediff.com,dioramas,timekeeping,concertina,kutaisi,cesky,lubomirski,unapologetic,epigraphic,stalactites,sneha,biofilm,falconry,miraflores,catena,'outstanding,prospekt,apotheosis,o'odham,pacemakers,arabica,gandhinagar,reminisces,iroquoian,ornette,tilling,neoliberalism,chameleons,pandava,prefontaine,haiyan,gneisenau,utama,bando,reconstitution,azaria,canola,paratroops,ayckbourn,manistee,stourton,manifestos,lympne,denouement,tractatus,rakim,bellflower,nanometer,sassanids,turlough,presbyterianism,varmland,20deg,phool,nyerere,almohad,manipal,vlaanderen,quickness,removals,makow,circumflex,eatery,morane,fondazione,alkylation,unenforceable,galliano,silkworm,junior/senior,abducts,phlox,konskie,lofoten,buuren,glyphosate,faired,naturae,cobbles,taher,skrulls,dostoevsky,walkout,wagnerian,orbited,methodically,denzil,sarat,extraterritorial,kohima,d'armor,brinsley,rostropovich,fengtian,comitatus,aravind,moche,wrangell,giscard,vantaa,viljandi,hakoah,seabees,muscatine,ballade,camanachd,sothern,mullioned,durad,margraves,maven,arete,chandni,garifuna,142nd,reading/literature,thickest,intensifies,trygve,khaldun,perinatal,asana,powerline,acetylation,nureyev,omiya,montesquieu,riverwalk,marly,correlating,intermountain,bulgar,hammerheads,underscores,wiretapping,quatrain,ruisseau,newsagent,tuticorin,polygyny,hemsworth,partisanship,banna,istrian,evaporator".split(","),
  female_names: "mary,patricia,linda,barbara,elizabeth,jennifer,maria,susan,margaret,dorothy,lisa,nancy,karen,betty,helen,sandra,donna,carol,ruth,sharon,michelle,laura,sarah,kimberly,deborah,jessica,shirley,cynthia,angela,melissa,brenda,amy,anna,rebecca,virginia,kathleen,pamela,martha,debra,amanda,stephanie,carolyn,christine,marie,janet,catherine,frances,ann,joyce,diane,alice,julie,heather,teresa,doris,gloria,evelyn,jean,cheryl,mildred,katherine,joan,ashley,judith,rose,janice,kelly,nicole,judy,christina,kathy,theresa,beverly,denise,tammy,irene,jane,lori,rachel,marilyn,andrea,kathryn,louise,sara,anne,jacqueline,wanda,bonnie,julia,ruby,lois,tina,phyllis,norma,paula,diana,annie,lillian,emily,robin,peggy,crystal,gladys,rita,dawn,connie,florence,tracy,edna,tiffany,carmen,rosa,cindy,grace,wendy,victoria,edith,kim,sherry,sylvia,josephine,thelma,shannon,sheila,ethel,ellen,elaine,marjorie,carrie,charlotte,monica,esther,pauline,emma,juanita,anita,rhonda,hazel,amber,eva,debbie,april,leslie,clara,lucille,jamie,joanne,eleanor,valerie,danielle,megan,alicia,suzanne,michele,gail,bertha,darlene,veronica,jill,erin,geraldine,lauren,cathy,joann,lorraine,lynn,sally,regina,erica,beatrice,dolores,bernice,audrey,yvonne,annette,marion,dana,stacy,ana,renee,ida,vivian,roberta,holly,brittany,melanie,loretta,yolanda,jeanette,laurie,katie,kristen,vanessa,alma,sue,elsie,beth,jeanne,vicki,carla,tara,rosemary,eileen,terri,gertrude,lucy,tonya,ella,stacey,wilma,gina,kristin,jessie,natalie,agnes,vera,charlene,bessie,delores,melinda,pearl,arlene,maureen,colleen,allison,tamara,joy,georgia,constance,lillie,claudia,jackie,marcia,tanya,nellie,minnie,marlene,heidi,glenda,lydia,viola,courtney,marian,stella,caroline,dora,vickie,mattie,maxine,irma,mabel,marsha,myrtle,lena,christy,deanna,patsy,hilda,gwendolyn,jennie,nora,margie,nina,cassandra,leah,penny,kay,priscilla,naomi,carole,olga,billie,dianne,tracey,leona,jenny,felicia,sonia,miriam,velma,becky,bobbie,violet,kristina,toni,misty,mae,shelly,daisy,ramona,sherri,erika,katrina,claire,lindsey,lindsay,geneva,guadalupe,belinda,margarita,sheryl,cora,faye,ada,sabrina,isabel,marguerite,hattie,harriet,molly,cecilia,kristi,brandi,blanche,sandy,rosie,joanna,iris,eunice,angie,inez,lynda,madeline,amelia,alberta,genevieve,monique,jodi,janie,kayla,sonya,jan,kristine,candace,fannie,maryann,opal,alison,yvette,melody,luz,susie,olivia,flora,shelley,kristy,mamie,lula,lola,verna,beulah,antoinette,candice,juana,jeannette,pam,kelli,whitney,bridget,karla,celia,latoya,patty,shelia,gayle,della,vicky,lynne,sheri,marianne,kara,jacquelyn,erma,blanca,myra,leticia,pat,krista,roxanne,angelica,robyn,adrienne,rosalie,alexandra,brooke,bethany,sadie,bernadette,traci,jody,kendra,nichole,rachael,mable,ernestine,muriel,marcella,elena,krystal,angelina,nadine,kari,estelle,dianna,paulette,lora,mona,doreen,rosemarie,desiree,antonia,janis,betsy,christie,freda,meredith,lynette,teri,cristina,eula,leigh,meghan,sophia,eloise,rochelle,gretchen,cecelia,raquel,henrietta,alyssa,jana,gwen,jenna,tricia,laverne,olive,tasha,silvia,elvira,delia,kate,patti,lorena,kellie,sonja,lila,lana,darla,mindy,essie,mandy,lorene,elsa,josefina,jeannie,miranda,dixie,lucia,marta,faith,lela,johanna,shari,camille,tami,shawna,elisa,ebony,melba,ora,nettie,tabitha,ollie,winifred,kristie,alisha,aimee,rena,myrna,marla,tammie,latasha,bonita,patrice,ronda,sherrie,addie,francine,deloris,stacie,adriana,cheri,abigail,celeste,jewel,cara,adele,rebekah,lucinda,dorthy,effie,trina,reba,sallie,aurora,lenora,etta,lottie,kerri,trisha,nikki,estella,francisca,josie,tracie,marissa,karin,brittney,janelle,lourdes,laurel,helene,fern,elva,corinne,kelsey,ina,bettie,elisabeth,aida,caitlin,ingrid,iva,eugenia,christa,goldie,maude,jenifer,therese,dena,lorna,janette,latonya,candy,consuelo,tamika,rosetta,debora,cherie,polly,dina,jewell,fay,jillian,dorothea,nell,trudy,esperanza,patrica,kimberley,shanna,helena,cleo,stefanie,rosario,ola,janine,mollie,lupe,alisa,lou,maribel,susanne,bette,susana,elise,cecile,isabelle,lesley,jocelyn,paige,joni,rachelle,leola,daphne,alta,ester,petra,graciela,imogene,jolene,keisha,lacey,glenna,gabriela,keri,ursula,lizzie,kirsten,shana,adeline,mayra,jayne,jaclyn,gracie,sondra,carmela,marisa,rosalind,charity,tonia,beatriz,marisol,clarice,jeanine,sheena,angeline,frieda,lily,shauna,millie,claudette,cathleen,angelia,gabrielle,autumn,katharine,jodie,staci,lea,christi,justine,elma,luella,margret,dominique,socorro,martina,margo,mavis,callie,bobbi,maritza,lucile,leanne,jeannine,deana,aileen,lorie,ladonna,willa,manuela,gale,selma,dolly,sybil,abby,ivy,dee,winnie,marcy,luisa,jeri,magdalena,ofelia,meagan,audra,matilda,leila,cornelia,bianca,simone,bettye,randi,virgie,latisha,barbra,georgina,eliza,leann,bridgette,rhoda,haley,adela,nola,bernadine,flossie,ila,greta,ruthie,nelda,minerva,lilly,terrie,letha,hilary,estela,valarie,brianna,rosalyn,earline,catalina,ava,mia,clarissa,lidia,corrine,alexandria,concepcion,tia,sharron,rae,dona,ericka,jami,elnora,chandra,lenore,neva,marylou,melisa,tabatha,serena,avis,allie,sofia,jeanie,odessa,nannie,harriett,loraine,penelope,milagros,emilia,benita,allyson,ashlee,tania,esmeralda,eve,pearlie,zelma,malinda,noreen,tameka,saundra,hillary,amie,althea,rosalinda,lilia,alana,clare,alejandra,elinor,lorrie,jerri,darcy,earnestine,carmella,noemi,marcie,liza,annabelle,louisa,earlene,mallory,carlene,nita,selena,tanisha,katy,julianne,lakisha,edwina,maricela,margery,kenya,dollie,roxie,roslyn,kathrine,nanette,charmaine,lavonne,ilene,tammi,suzette,corine,kaye,chrystal,lina,deanne,lilian,juliana,aline,luann,kasey,maryanne,evangeline,colette,melva,lawanda,yesenia,nadia,madge,kathie,ophelia,valeria,nona,mitzi,mari,georgette,claudine,fran,alissa,roseann,lakeisha,susanna,reva,deidre,chasity,sheree,elvia,alyce,deirdre,gena,briana,araceli,katelyn,rosanne,wendi,tessa,berta,marva,imelda,marietta,marci,leonor,arline,sasha,madelyn,janna,juliette,deena,aurelia,josefa,augusta,liliana,lessie,amalia,savannah,anastasia,vilma,natalia,rosella,lynnette,corina,alfreda,leanna,amparo,coleen,tamra,aisha,wilda,karyn,maura,mai,evangelina,rosanna,hallie,erna,enid,mariana,lacy,juliet,jacklyn,freida,madeleine,mara,cathryn,lelia,casandra,bridgett,angelita,jannie,dionne,annmarie,katina,beryl,millicent,katheryn,diann,carissa,maryellen,liz,lauri,helga,gilda,rhea,marquita,hollie,tisha,tamera,angelique,francesca,kaitlin,lolita,florine,rowena,reyna,twila,fanny,janell,ines,concetta,bertie,alba,brigitte,alyson,vonda,pansy,elba,noelle,letitia,deann,brandie,louella,leta,felecia,sharlene,lesa,beverley,isabella,herminia,terra,celina,tori,octavia,jade,denice,germaine,michell,cortney,nelly,doretha,deidra,monika,lashonda,judi,chelsey,antionette,margot,adelaide,leeann,elisha,dessie,libby,kathi,gayla,latanya,mina,mellisa,kimberlee,jasmin,renae,zelda,elda,justina,gussie,emilie,camilla,abbie,rocio,kaitlyn,edythe,ashleigh,selina,lakesha,geri,allene,pamala,michaela,dayna,caryn,rosalia,jacquline,rebeca,marybeth,krystle,iola,dottie,belle,griselda,ernestina,elida,adrianne,demetria,delma,jaqueline,arleen,virgina,retha,fatima,tillie,eleanore,cari,treva,wilhelmina,rosalee,maurine,latrice,jena,taryn,elia,debby,maudie,jeanna,delilah,catrina,shonda,hortencia,theodora,teresita,robbin,danette,delphine,brianne,nilda,danna,cindi,bess,iona,winona,vida,rosita,marianna,racheal,guillermina,eloisa,celestine,caren,malissa,lona,chantel,shellie,marisela,leora,agatha,soledad,migdalia,ivette,christen,athena,janel,veda,pattie,tessie,tera,marilynn,lucretia,karrie,dinah,daniela,alecia,adelina,vernice,shiela,portia,merry,lashawn,dara,tawana,verda,alene,zella,sandi,rafaela,maya,kira,candida,alvina,suzan,shayla,lettie,samatha,oralia,matilde,larissa,vesta,renita,delois,shanda,phillis,lorri,erlinda,cathrine,barb,isabell,ione,gisela,roxanna,mayme,kisha,ellie,mellissa,dorris,dalia,bella,annetta,zoila,reta,reina,lauretta,kylie,christal,pilar,charla,elissa,tiffani,tana,paulina,leota,breanna,jayme,carmel,vernell,tomasa,mandi,dominga,santa,melodie,lura,alexa,tamela,mirna,kerrie,venus,felicita,cristy,carmelita,berniece,annemarie,tiara,roseanne,missy,cori,roxana,pricilla,kristal,jung,elyse,haydee,aletha,bettina,marge,gillian,filomena,zenaida,harriette,caridad,vada,aretha,pearline,marjory,marcela,flor,evette,elouise,alina,damaris,catharine,belva,nakia,marlena,luanne,lorine,karon,dorene,danita,brenna,tatiana,louann,julianna,andria,philomena,lucila,leonora,dovie,romona,mimi,jacquelin,gaye,tonja,misti,chastity,stacia,roxann,micaela,velda,marlys,johnna,aura,ivonne,hayley,nicki,majorie,herlinda,yadira,perla,gregoria,antonette,shelli,mozelle,mariah,joelle,cordelia,josette,chiquita,trista,laquita,georgiana,candi,shanon,hildegard,stephany,magda,karol,gabriella,tiana,roma,richelle,oleta,jacque,idella,alaina,suzanna,jovita,tosha,nereida,marlyn,kyla,delfina,tena,stephenie,sabina,nathalie,marcelle,gertie,darleen,thea,sharonda,shantel,belen,venessa,rosalina,genoveva,clementine,rosalba,renate,renata,georgianna,floy,dorcas,ariana,tyra,theda,mariam,juli,jesica,vikki,verla,roselyn,melvina,jannette,ginny,debrah,corrie,violeta,myrtis,latricia,collette,charleen,anissa,viviana,twyla,nedra,latonia,hellen,fabiola,annamarie,adell,sharyn,chantal,niki,maud,lizette,lindy,kesha,jeana,danelle,charline,chanel,valorie,dortha,cristal,sunny,leone,leilani,gerri,debi,andra,keshia,eulalia,easter,dulce,natividad,linnie,kami,georgie,catina,brook,alda,winnifred,sharla,ruthann,meaghan,magdalene,lissette,adelaida,venita,trena,shirlene,shameka,elizebeth,dian,shanta,latosha,carlotta,windy,rosina,mariann,leisa,jonnie,dawna,cathie,astrid,laureen,janeen,holli,fawn,vickey,teressa,shante,rubye,marcelina,chanda,terese,scarlett,marnie,lulu,lisette,jeniffer,elenor,dorinda,donita,carman,bernita,altagracia,aleta,adrianna,zoraida,lyndsey,janina,starla,phylis,phuong,kyra,charisse,blanch,sanjuanita,rona,nanci,marilee,maranda,brigette,sanjuana,marita,kassandra,joycelyn,felipa,chelsie,bonny,mireya,lorenza,kyong,ileana,candelaria,sherie,lucie,leatrice,lakeshia,gerda,edie,bambi,marylin,lavon,hortense,garnet,evie,tressa,shayna,lavina,kyung,jeanetta,sherrill,shara,phyliss,mittie,anabel,alesia,thuy,tawanda,joanie,tiffanie,lashanda,karissa,enriqueta,daria,daniella,corinna,alanna,abbey,roxane,roseanna,magnolia,lida,joellen,coral,carleen,tresa,peggie,novella,nila,maybelle,jenelle,carina,nova,melina,marquerite,margarette,josephina,evonne,cinthia,albina,toya,tawnya,sherita,myriam,lizabeth,lise,keely,jenni,giselle,cheryle,ardith,ardis,alesha,adriane,shaina,linnea,karolyn,felisha,dori,darci,artie,armida,zola,xiomara,vergie,shamika,nena,nannette,maxie,lovie,jeane,jaimie,inge,farrah,elaina,caitlyn,felicitas,cherly,caryl,yolonda,yasmin,teena,prudence,pennie,nydia,mackenzie,orpha,marvel,lizbeth,laurette,jerrie,hermelinda,carolee,tierra,mirian,meta,melony,kori,jennette,jamila,yoshiko,susannah,salina,rhiannon,joleen,cristine,ashton,aracely,tomeka,shalonda,marti,lacie,kala,jada,ilse,hailey,brittani,zona,syble,sherryl,nidia,marlo,kandice,kandi,alycia,ronna,norene,mercy,ingeborg,giovanna,gemma,christel,audry,zora,vita,trish,stephaine,shirlee,shanika,melonie,mazie,jazmin,inga,hettie,geralyn,fonda,estrella,adella,sarita,rina,milissa,maribeth,golda,evon,ethelyn,enedina,cherise,chana,velva,tawanna,sade,mirta,karie,jacinta,elna,davina,cierra,ashlie,albertha,tanesha,nelle,mindi,lorinda,larue,florene,demetra,dedra,ciara,chantelle,ashly,suzy,rosalva,noelia,lyda,leatha,krystyna,kristan,karri,darline,darcie,cinda,cherrie,awilda,almeda,rolanda,lanette,jerilyn,gisele,evalyn,cyndi,cleta,carin,zina,zena,velia,tanika,charissa,talia,margarete,lavonda,kaylee,kathlene,jonna,irena,ilona,idalia,candis,candance,brandee,anitra,alida,sigrid,nicolette,maryjo,linette,hedwig,christiana,alexia,tressie,modesta,lupita,lita,gladis,evelia,davida,cherri,cecily,ashely,annabel,agustina,wanita,shirly,rosaura,hulda,yetta,verona,thomasina,sibyl,shannan,mechelle,leandra,lani,kylee,kandy,jolynn,ferne,eboni,corene,alysia,zula,nada,moira,lyndsay,lorretta,jammie,hortensia,gaynell,adria,vina,vicenta,tangela,stephine,norine,nella,liana,leslee,kimberely,iliana,glory,felica,emogene,elfriede,eden,eartha,carma,ocie,lennie,kiara,jacalyn,carlota,arielle,otilia,kirstin,kacey,johnetta,joetta,jeraldine,jaunita,elana,dorthea,cami,amada,adelia,vernita,tamar,siobhan,renea,rashida,ouida,nilsa,meryl,kristyn,julieta,danica,breanne,aurea,anglea,sherron,odette,malia,lorelei,leesa,kenna,kathlyn,fiona,charlette,suzie,shantell,sabra,racquel,myong,mira,martine,lucienne,lavada,juliann,elvera,delphia,christiane,charolette,carri,asha,angella,paola,ninfa,leda,stefani,shanell,palma,machelle,lissa,kecia,kathryne,karlene,julissa,jettie,jenniffer,corrina,carolann,alena,rosaria,myrtice,marylee,liane,kenyatta,judie,janey,elmira,eldora,denna,cristi,cathi,zaida,vonnie,viva,vernie,rosaline,mariela,luciana,lesli,karan,felice,deneen,adina,wynona,tarsha,sheron,shanita,shani,shandra,randa,pinkie,nelida,marilou,lyla,laurene,laci,janene,dorotha,daniele,dani,carolynn,carlyn,berenice,ayesha,anneliese,alethea,thersa,tamiko,rufina,oliva,mozell,marylyn,kristian,kathyrn,kasandra,kandace,janae,domenica,debbra,dannielle,chun,arcelia,zenobia,sharen,sharee,lavinia,kacie,jackeline,huong,felisa,emelia,eleanora,cythia,cristin,claribel,anastacia,zulma,zandra,yoko,tenisha,susann,sherilyn,shay,shawanda,romana,mathilda,linsey,keiko,joana,isela,gretta,georgetta,eugenie,desirae,delora,corazon,antonina,anika,willene,tracee,tamatha,nichelle,mickie,maegan,luana,lanita,kelsie,edelmira,bree,afton,teodora,tamie,shena,linh,keli,kaci,danyelle,arlette,albertine,adelle,tiffiny,simona,nicolasa,nichol,nakisha,maira,loreen,kizzy,fallon,christene,bobbye,ying,vincenza,tanja,rubie,roni,queenie,margarett,kimberli,irmgard,idell,hilma,evelina,esta,emilee,dennise,dania,carie,risa,rikki,particia,masako,luvenia,loree,loni,lien,gigi,florencia,denita,billye,tomika,sharita,rana,nikole,neoma,margarite,madalyn,lucina,laila,kali,jenette,gabriele,evelyne,elenora,clementina,alejandrina,zulema,violette,vannessa,thresa,retta,patience,noella,nickie,jonell,chaya,camelia,bethel,anya,suzann,mila,lilla,laverna,keesha,kattie,georgene,eveline,estell,elizbeth,vivienne,vallie,trudie,stephane,magaly,madie,kenyetta,karren,janetta,hermine,drucilla,debbi,celestina,candie,britni,beckie,amina,zita,yolande,vivien,vernetta,trudi,pearle,patrina,ossie,nicolle,loyce,letty,katharina,joselyn,jonelle,jenell,iesha,heide,florinda,florentina,elodia,dorine,brunilda,brigid,ashli,ardella,twana,tarah,shavon,serina,rayna,ramonita,margurite,lucrecia,kourtney,kati,jesenia,crista,ayana,alica,alia,vinnie,suellen,romelia,rachell,olympia,michiko,kathaleen,jolie,jessi,janessa,hana,elease,carletta,britany,shona,salome,rosamond,regena,raina,ngoc,nelia,louvenia,lesia,latrina,laticia,larhonda,jina,jacki,emmy,deeann,coretta,arnetta,thalia,shanice,neta,mikki,micki,lonna,leana,lashunda,kiley,joye,jacqulyn,ignacia,hyun,hiroko,henriette,elayne,delinda,dahlia,coreen,consuela,conchita,babette,ayanna,anette,albertina,shawnee,shaneka,quiana,pamelia,merri,merlene,margit,kiesha,kiera,kaylene,jodee,jenise,erlene,emmie,dalila,daisey,casie,belia,babara,versie,vanesa,shelba,shawnda,nikia,naoma,marna,margeret,madaline,lawana,kindra,jutta,jazmine,janett,hannelore,glendora,gertrud,garnett,freeda,frederica,florance,flavia,carline,beverlee,anjanette,valda,tamala,shonna,sarina,oneida,merilyn,marleen,lurline,lenna,katherin,jeni,gracia,glady,farah,enola,dominque,devona,delana,cecila,caprice,alysha,alethia,vena,theresia,tawny,shakira,samara,sachiko,rachele,pamella,marni,mariel,maren,malisa,ligia,lera,latoria,larae,kimber,kathern,karey,jennefer,janeth,halina,fredia,delisa,debroah,ciera,angelika,andree,altha,vivan,terresa,tanna,sudie,signe,salena,ronni,rebbecca,myrtie,malika,maida,leonarda,kayleigh,ethyl,ellyn,dayle,cammie,brittni,birgit,avelina,asuncion,arianna,akiko,venice,tyesha,tonie,tiesha,takisha,steffanie,sindy,meghann,manda,macie,kellye,kellee,joslyn,inger,indira,glinda,glennis,fernanda,faustina,eneida,elicia,digna,dell,arletta,willia,tammara,tabetha,sherrell,sari,rebbeca,pauletta,natosha,nakita,mammie,kenisha,kazuko,kassie,earlean,daphine,corliss,clotilde,carolyne,bernetta,augustina,audrea,annis,annabell,tennille,tamica,selene,rosana,regenia,qiana,markita,macy,leeanne,laurine,jessenia,janita,georgine,genie,emiko,elvie,deandra,dagmar,corie,collen,cherish,romaine,porsha,pearlene,micheline,merna,margorie,margaretta,lore,jenine,hermina,fredericka,elke,drusilla,dorathy,dione,celena,brigida,allegra,tamekia,synthia,sook,slyvia,rosann,reatha,raye,marquetta,margart,ling,layla,kymberly,kiana,kayleen,katlyn,karmen,joella,emelda,eleni,detra,clemmie,cheryll,chantell,cathey,arnita,arla,angle,angelic,alyse,zofia,thomasine,tennie,sherly,sherley,sharyl,remedios,petrina,nickole,myung,myrle,mozella,louanne,lisha,latia,krysta,julienne,jeanene,jacqualine,isaura,gwenda,earleen,cleopatra,carlie,audie,antonietta,alise,verdell,tomoko,thao,talisha,shemika,savanna,santina,rosia,raeann,odilia,nana,minna,magan,lynelle,karma,joeann,ivana,inell,ilana,gudrun,dreama,crissy,chante,carmelina,arvilla,annamae,alvera,aleida,yanira,vanda,tianna,stefania,shira,nicol,nancie,monserrate,melynda,melany,lovella,laure,kacy,jacquelynn,hyon,gertha,eliana,christena,christeen,charise,caterina,carley,candyce,arlena,ammie,willette,vanita,tuyet,syreeta,penney,nyla,maryam,marya,magen,ludie,loma,livia,lanell,kimberlie,julee,donetta,diedra,denisha,deane,dawne,clarine,cherryl,bronwyn,alla,valery,tonda,sueann,soraya,shoshana,shela,sharleen,shanelle,nerissa,meridith,mellie,maye,maple,magaret,lili,leonila,leonie,leeanna,lavonia,lavera,kristel,kathey,kathe,jann,ilda,hildred,hildegarde,genia,fumiko,evelin,ermelinda,elly,dung,doloris,dionna,danae,berneice,annice,alix,verena,verdie,shawnna,shawana,shaunna,rozella,randee,ranae,milagro,lynell,luise,loida,lisbeth,karleen,junita,jona,isis,hyacinth,hedy,gwenn,ethelene,erline,donya,domonique,delicia,dannette,cicely,branda,blythe,bethann,ashlyn,annalee,alline,yuko,vella,trang,towanda,tesha,sherlyn,narcisa,miguelina,meri,maybell,marlana,marguerita,madlyn,lory,loriann,leonore,leighann,laurice,latesha,laronda,katrice,kasie,kaley,jadwiga,glennie,gearldine,francina,epifania,dyan,dorie,diedre,denese,demetrice,delena,cristie,cleora,catarina,carisa,barbera,almeta,trula,tereasa,solange,sheilah,shavonne,sanora,rochell,mathilde,margareta,maia,lynsey,lawanna,launa,kena,keena,katia,glynda,gaylene,elvina,elanor,danuta,danika,cristen,cordie,coletta,clarita,carmon,brynn,azucena,aundrea,angele,verlie,verlene,tamesha,silvana,sebrina,samira,reda,raylene,penni,norah,noma,mireille,melissia,maryalice,laraine,kimbery,karyl,karine,jolanda,johana,jesusa,jaleesa,jacquelyne,iluminada,hilaria,hanh,gennie,francie,floretta,exie,edda,drema,delpha,barbar,assunta,ardell,annalisa,alisia,yukiko,yolando,wonda,waltraud,veta,temeka,tameika,shirleen,shenita,piedad,ozella,mirtha,marilu,kimiko,juliane,jenice,janay,jacquiline,hilde,elois,echo,devorah,chau,brinda,betsey,arminda,aracelis,apryl,annett,alishia,veola,usha,toshiko,theola,tashia,talitha,shery,renetta,reiko,rasheeda,obdulia,mika,melaine,meggan,marlen,marget,marceline,mana,magdalen,librada,lezlie,latashia,lasandra,kelle,isidra,inocencia,gwyn,francoise,erminia,erinn,dimple,devora,criselda,armanda,arie,ariane,angelena,aliza,adriene,adaline,xochitl,twanna,tomiko,tamisha,taisha,susy,rutha,rhona,noriko,natashia,merrie,marinda,mariko,margert,loris,lizzette,leisha,kaila,joannie,jerrica,jene,jannet,janee,jacinda,herta,elenore,doretta,delaine,daniell,claudie,britta,apolonia,amberly,alease,yuri,waneta,tomi,sharri,sandie,roselle,reynalda,raguel,phylicia,patria,olimpia,odelia,mitzie,minda,mignon,mica,mendy,marivel,maile,lynetta,lavette,lauryn,latrisha,lakiesha,kiersten,kary,josphine,jolyn,jetta,janise,jacquie,ivelisse,glynis,gianna,gaynelle,danyell,danille,dacia,coralee,cher,ceola,arianne,aleshia,yung,williemae,trinh,thora,sherika,shemeka,shaunda,roseline,ricki,melda,mallie,lavonna,latina,laquanda,lala,lachelle,klara,kandis,johna,jeanmarie,jaye,grayce,gertude,emerita,ebonie,clorinda,ching,chery,carola,breann,blossom,bernardine,becki,arletha,argelia,alita,yulanda,yessenia,tobi,tasia,sylvie,shirl,shirely,shella,shantelle,sacha,rebecka,providencia,paulene,misha,miki,marline,marica,lorita,latoyia,lasonya,kerstin,kenda,keitha,kathrin,jaymie,gricelda,ginette,eryn,elina,elfrieda,danyel,cheree,chanelle,barrie,aurore,annamaria,alleen,ailene,aide,yasmine,vashti,treasa,tiffaney,sheryll,sharie,shanae,raisa,neda,mitsuko,mirella,milda,maryanna,maragret,mabelle,luetta,lorina,letisha,latarsha,lanelle,lajuana,krissy,karly,karena,jessika,jerica,jeanelle,jalisa,jacelyn,izola,euna,etha,domitila,dominica,daina,creola,carli,camie,brittny,ashanti,anisha,aleen,adah,yasuko,valrie,tona,tinisha,terisa,taneka,simonne,shalanda,serita,ressie,refugia,olene,margherita,mandie,maire,lyndia,luci,lorriane,loreta,leonia,lavona,lashawnda,lakia,kyoko,krystina,krysten,kenia,kelsi,jeanice,isobel,georgiann,genny,felicidad,eilene,deloise,deedee,conception,clora,cherilyn,calandra,armandina,anisa,tiera,theressa,stephania,sima,shyla,shonta,shera,shaquita,shala,rossana,nohemi,nery,moriah,melita,melida,melani,marylynn,marisha,mariette,malorie,madelene,ludivina,loria,lorette,loralee,lianne,lavenia,laurinda,lashon,kimi,keila,katelynn,jone,joane,jayna,janella,hertha,francene,elinore,despina,delsie,deedra,clemencia,carolin,bulah,brittanie,blondell,bibi,beaulah,beata,annita,agripina,virgen,valene,twanda,tommye,tarra,tari,tammera,shakia,sadye,ruthanne,rochel,rivka,pura,nenita,natisha,ming,merrilee,melodee,marvis,lucilla,leena,laveta,larita,lanie,keren,ileen,georgeann,genna,frida,eufemia,emely,edyth,deonna,deadra,darlena,chanell,cathern,cassondra,cassaundra,bernarda,berna,arlinda,anamaria,vertie,valeri,torri,stasia,sherise,sherill,sanda,ruthe,rosy,robbi,ranee,quyen,pearly,palmira,onita,nisha,niesha,nida,merlyn,mayola,marylouise,marth,margene,madelaine,londa,leontine,leoma,leia,lauralee,lanora,lakita,kiyoko,keturah,katelin,kareen,jonie,johnette,jenee,jeanett,izetta,hiedi,heike,hassie,giuseppina,georgann,fidela,fernande,elwanda,ellamae,eliz,dusti,dotty,cyndy,coralie,celesta,alverta,xenia,wava,vanetta,torrie,tashina,tandy,tambra,tama,stepanie,shila,shaunta,sharan,shaniqua,shae,setsuko,serafina,sandee,rosamaria,priscila,olinda,nadene,muoi,michelina,mercedez,maryrose,marcene,magali,mafalda,lannie,kayce,karoline,kamilah,kamala,justa,joline,jennine,jacquetta,iraida,georgeanna,franchesca,emeline,elane,ehtel,earlie,dulcie,dalene,classie,chere,charis,caroyln,carmina,carita,bethanie,ayako,arica,alysa,alessandra,akilah,adrien,zetta,youlanda,yelena,yahaira,xuan,wendolyn,tijuana,terina,teresia,suzi,sherell,shavonda,shaunte,sharda,shakita,sena,ryann,rubi,riva,reginia,rachal,parthenia,pamula,monnie,monet,michaele,melia,malka,maisha,lisandra,lekisha,lean,lakendra,krystin,kortney,kizzie,kittie,kera,kendal,kemberly,kanisha,julene,jule,johanne,jamee,halley,gidget,fredricka,fleta,fatimah,eusebia,elza,eleonore,dorthey,doria,donella,dinorah,delorse,claretha,christinia,charlyn,bong,belkis,azzie,andera,aiko,adena,yajaira,vania,ulrike,toshia,tifany,stefany,shizue,shenika,shawanna,sharolyn,sharilyn,shaquana,shantay,rozanne,roselee,remona,reanna,raelene,phung,petronila,natacha,nancey,myrl,miyoko,miesha,merideth,marvella,marquitta,marhta,marchelle,lizeth,libbie,lahoma,ladawn,kina,katheleen,katharyn,karisa,kaleigh,junie,julieann,johnsie,janean,jaimee,jackqueline,hisako,herma,helaine,gwyneth,gita,eustolia,emelina,elin,edris,donnette,donnetta,dierdre,denae,darcel,clarisa,cinderella,chia,charlesetta,charita,celsa,cassy,cassi,carlee,bruna,brittaney,brande,billi,antonetta,angla,angelyn,analisa,alane,wenona,wendie,veronique,vannesa,tobie,tempie,sumiko,sulema,somer,sheba,sharice,shanel,shalon,rosio,roselia,renay,rema,reena,ozie,oretha,oralee,ngan,nakesha,milly,marybelle,margrett,maragaret,manie,lurlene,lillia,lieselotte,lavelle,lashaunda,lakeesha,kaycee,kalyn,joya,joette,jenae,janiece,illa,grisel,glayds,genevie,gala,fredda,eleonor,debera,deandrea,corrinne,cordia,contessa,colene,cleotilde,chantay,cecille,beatris,azalee,arlean,ardath,anjelica,anja,alfredia,aleisha,zada,yuonne,xiao,willodean,vennie,vanna,tyisha,tova,torie,tonisha,tilda,tien,sirena,sherril,shanti,shan,senaida,samella,robbyn,renda,reita,phebe,paulita,nobuko,nguyet,neomi,mikaela,melania,maximina,marg,maisie,lynna,lilli,lashaun,lakenya,lael,kirstie,kathline,kasha,karlyn,karima,jovan,josefine,jennell,jacqui,jackelyn,hien,grazyna,florrie,floria,eleonora,dwana,dorla,delmy,deja,dede,dann,crysta,clelia,claris,chieko,cherlyn,cherelle,charmain,chara,cammy,arnette,ardelle,annika,amiee,amee,allena,yvone,yuki,yoshie,yevette,yael,willetta,voncile,venetta,tula,tonette,timika,temika,telma,teisha,taren,stacee,shawnta,saturnina,ricarda,pasty,onie,nubia,marielle,mariella,marianela,mardell,luanna,loise,lisabeth,lindsy,lilliana,lilliam,lelah,leigha,leanora,kristeen,khalilah,keeley,kandra,junko,joaquina,jerlene,jani,jamika,hsiu,hermila,genevive,evia,eugena,emmaline,elfreda,elene,donette,delcie,deeanna,darcey,clarinda,cira,chae,celinda,catheryn,casimira,carmelia,camellia,breana,bobette,bernardina,bebe,basilia,arlyne,amal,alayna,zonia,zenia,yuriko,yaeko,wynell,willena,vernia,tora,terrilyn,terica,tenesha,tawna,tajuana,taina,stephnie,sona,sina,shondra,shizuko,sherlene,sherice,sharika,rossie,rosena,rima,rheba,renna,natalya,nancee,melodi,meda,matha,marketta,maricruz,marcelene,malvina,luba,louetta,leida,lecia,lauran,lashawna,laine,khadijah,katerine,kasi,kallie,julietta,jesusita,jestine,jessia,jeffie,janyce,isadora,georgianne,fidelia,evita,eura,eulah,estefana,elsy,eladia,dodie,denisse,deloras,delila,daysi,crystle,concha,claretta,charlsie,charlena,carylon,bettyann,asley,ashlea,amira,agueda,agnus,yuette,vinita,victorina,tynisha,treena,toccara,tish,thomasena,tegan,soila,shenna,sharmaine,shantae,shandi,saran,sarai,sana,rosette,rolande,regine,otelia,olevia,nicholle,necole,naida,myrta,myesha,mitsue,minta,mertie,margy,mahalia,madalene,loura,lorean,lesha,leonida,lenita,lavone,lashell,lashandra,lamonica,kimbra,katherina,karry,kanesha,jong,jeneva,jaquelyn,gilma,ghislaine,gertrudis,fransisca,fermina,ettie,etsuko,ellan,elidia,edra,dorethea,doreatha,denyse,deetta,daine,cyrstal,corrin,cayla,carlita,camila,burma,bula,buena,barabara,avril,alaine,zana,wilhemina,wanetta,verline,vasiliki,tonita,tisa,teofila,tayna,taunya,tandra,takako,sunni,suanne,sixta,sharell,seema,rosenda,robena,raymonde,pamila,ozell,neida,mistie,micha,merissa,maurita,maryln,maryetta,marcell,malena,makeda,lovetta,lourie,lorrine,lorilee,laurena,lashay,larraine,laree,lacresha,kristle,keva,keira,karole,joie,jinny,jeannetta,jama,heidy,gilberte,gema,faviola,evelynn,enda,elli,ellena,divina,dagny,collene,codi,cindie,chassidy,chasidy,catrice,catherina,cassey,caroll,carlena,candra,calista,bryanna,britteny,beula,bari,audrie,audria,ardelia,annelle,angila,alona,allyn".split(","),
  surnames: "smith,johnson,williams,jones,brown,davis,miller,wilson,moore,taylor,anderson,jackson,white,harris,martin,thompson,garcia,martinez,robinson,clark,rodriguez,lewis,lee,walker,hall,allen,young,hernandez,king,wright,lopez,hill,green,adams,baker,gonzalez,nelson,carter,mitchell,perez,roberts,turner,phillips,campbell,parker,evans,edwards,collins,stewart,sanchez,morris,rogers,reed,cook,morgan,bell,murphy,bailey,rivera,cooper,richardson,cox,howard,ward,torres,peterson,gray,ramirez,watson,brooks,sanders,price,bennett,wood,barnes,ross,henderson,coleman,jenkins,perry,powell,long,patterson,hughes,flores,washington,butler,simmons,foster,gonzales,bryant,alexander,griffin,diaz,hayes,myers,ford,hamilton,graham,sullivan,wallace,woods,cole,west,owens,reynolds,fisher,ellis,harrison,gibson,mcdonald,cruz,marshall,ortiz,gomez,murray,freeman,wells,webb,simpson,stevens,tucker,porter,hicks,crawford,boyd,mason,morales,kennedy,warren,dixon,ramos,reyes,burns,gordon,shaw,holmes,rice,robertson,hunt,black,daniels,palmer,mills,nichols,grant,knight,ferguson,stone,hawkins,dunn,perkins,hudson,spencer,gardner,stephens,payne,pierce,berry,matthews,arnold,wagner,willis,watkins,olson,carroll,duncan,snyder,hart,cunningham,lane,andrews,ruiz,harper,fox,riley,armstrong,carpenter,weaver,greene,elliott,chavez,sims,peters,kelley,franklin,lawson,fields,gutierrez,schmidt,carr,vasquez,castillo,wheeler,chapman,montgomery,richards,williamson,johnston,banks,meyer,bishop,mccoy,howell,alvarez,morrison,hansen,fernandez,garza,harvey,burton,nguyen,jacobs,reid,fuller,lynch,garrett,romero,welch,larson,frazier,burke,hanson,mendoza,moreno,bowman,medina,fowler,brewer,hoffman,carlson,silva,pearson,holland,fleming,jensen,vargas,byrd,davidson,hopkins,herrera,wade,soto,walters,neal,caldwell,lowe,jennings,barnett,graves,jimenez,horton,shelton,barrett,obrien,castro,sutton,mckinney,lucas,miles,rodriquez,chambers,holt,lambert,fletcher,watts,bates,hale,rhodes,pena,beck,newman,haynes,mcdaniel,mendez,bush,vaughn,parks,dawson,santiago,norris,hardy,steele,curry,powers,schultz,barker,guzman,page,munoz,ball,keller,chandler,weber,walsh,lyons,ramsey,wolfe,schneider,mullins,benson,sharp,bowen,barber,cummings,hines,baldwin,griffith,valdez,hubbard,salazar,reeves,warner,stevenson,burgess,santos,tate,cross,garner,mann,mack,moss,thornton,mcgee,farmer,delgado,aguilar,vega,glover,manning,cohen,harmon,rodgers,robbins,newton,blair,higgins,ingram,reese,cannon,strickland,townsend,potter,goodwin,walton,rowe,hampton,ortega,patton,swanson,goodman,maldonado,yates,becker,erickson,hodges,rios,conner,adkins,webster,malone,hammond,flowers,cobb,moody,quinn,pope,osborne,mccarthy,guerrero,estrada,sandoval,gibbs,gross,fitzgerald,stokes,doyle,saunders,wise,colon,gill,alvarado,greer,padilla,waters,nunez,ballard,schwartz,mcbride,houston,christensen,klein,pratt,briggs,parsons,mclaughlin,zimmerman,buchanan,moran,copeland,pittman,brady,mccormick,holloway,brock,poole,logan,bass,marsh,drake,wong,jefferson,morton,abbott,sparks,norton,huff,massey,figueroa,carson,bowers,roberson,barton,tran,lamb,harrington,boone,cortez,clarke,mathis,singleton,wilkins,cain,underwood,hogan,mckenzie,collier,luna,phelps,mcguire,bridges,wilkerson,nash,summers,atkins,wilcox,pitts,conley,marquez,burnett,cochran,chase,davenport,hood,gates,ayala,sawyer,vazquez,dickerson,hodge,acosta,flynn,espinoza,nicholson,monroe,wolf,morrow,whitaker,oconnor,skinner,ware,molina,kirby,huffman,gilmore,dominguez,oneal,lang,combs,kramer,hancock,gallagher,gaines,shaffer,wiggins,mathews,mcclain,fischer,wall,melton,hensley,bond,dyer,grimes,contreras,wyatt,baxter,snow,mosley,shepherd,larsen,hoover,beasley,petersen,whitehead,meyers,garrison,shields,horn,savage,olsen,schroeder,hartman,woodard,mueller,kemp,deleon,booth,patel,calhoun,wiley,eaton,cline,navarro,harrell,humphrey,parrish,duran,hutchinson,hess,dorsey,bullock,robles,beard,dalton,avila,rich,blackwell,johns,blankenship,trevino,salinas,campos,pruitt,callahan,montoya,hardin,guerra,mcdowell,stafford,gallegos,henson,wilkinson,booker,merritt,atkinson,orr,decker,hobbs,tanner,knox,pacheco,stephenson,glass,rojas,serrano,marks,hickman,sweeney,strong,mcclure,conway,roth,maynard,farrell,lowery,hurst,nixon,weiss,trujillo,ellison,sloan,juarez,winters,mclean,boyer,villarreal,mccall,gentry,carrillo,ayers,lara,sexton,pace,hull,leblanc,browning,velasquez,leach,chang,sellers,herring,noble,foley,bartlett,mercado,landry,durham,walls,barr,mckee,bauer,rivers,bradshaw,pugh,velez,rush,estes,dodson,morse,sheppard,weeks,camacho,bean,barron,livingston,middleton,spears,branch,blevins,chen,kerr,mcconnell,hatfield,harding,solis,frost,giles,blackburn,pennington,woodward,finley,mcintosh,koch,mccullough,blanchard,rivas,brennan,mejia,kane,benton,buckley,valentine,maddox,russo,mcknight,buck,moon,mcmillan,crosby,berg,dotson,mays,roach,chan,richmond,meadows,faulkner,oneill,knapp,kline,ochoa,jacobson,gay,hendricks,horne,shepard,hebert,cardenas,mcintyre,waller,holman,donaldson,cantu,morin,gillespie,fuentes,tillman,bentley,peck,key,salas,rollins,gamble,dickson,santana,cabrera,cervantes,howe,hinton,hurley,spence,zamora,yang,mcneil,suarez,petty,gould,mcfarland,sampson,carver,bray,macdonald,stout,hester,melendez,dillon,farley,hopper,galloway,potts,joyner,stein,aguirre,osborn,mercer,bender,franco,rowland,sykes,pickett,sears,mayo,dunlap,hayden,wilder,mckay,coffey,mccarty,ewing,cooley,vaughan,bonner,cotton,holder,stark,ferrell,cantrell,fulton,lott,calderon,pollard,hooper,burch,mullen,fry,riddle,levy,duke,odonnell,britt,daugherty,berger,dillard,alston,frye,riggs,chaney,odom,duffy,fitzpatrick,valenzuela,mayer,alford,mcpherson,acevedo,barrera,cote,reilly,compton,mooney,mcgowan,craft,clemons,wynn,nielsen,baird,stanton,snider,rosales,bright,witt,hays,holden,rutledge,kinney,clements,castaneda,slater,hahn,burks,delaney,pate,lancaster,sharpe,whitfield,talley,macias,burris,ratliff,mccray,madden,kaufman,beach,goff,cash,bolton,mcfadden,levine,byers,kirkland,kidd,workman,carney,mcleod,holcomb,finch,sosa,haney,franks,sargent,nieves,downs,rasmussen,bird,hewitt,foreman,valencia,oneil,delacruz,vinson,dejesus,hyde,forbes,gilliam,guthrie,wooten,huber,barlow,boyle,mcmahon,buckner,rocha,puckett,langley,knowles,cooke,velazquez,whitley,vang,shea,rouse,hartley,mayfield,elder,rankin,hanna,cowan,lucero,arroyo,slaughter,haas,oconnell,minor,boucher,archer,boggs,dougherty,andersen,newell,crowe,wang,friedman,bland,swain,holley,pearce,childs,yarbrough,galvan,proctor,meeks,lozano,mora,rangel,bacon,villanueva,schaefer,rosado,helms,boyce,goss,stinson,ibarra,hutchins,covington,crowley,hatcher,mackey,bunch,womack,polk,dodd,childress,childers,villa,springer,mahoney,dailey,belcher,lockhart,griggs,costa,brandt,walden,moser,tatum,mccann,akers,lutz,pryor,orozco,mcallister,lugo,davies,shoemaker,rutherford,newsome,magee,chamberlain,blanton,simms,godfrey,flanagan,crum,cordova,escobar,downing,sinclair,donahue,krueger,mcginnis,gore,farris,webber,corbett,andrade,starr,lyon,yoder,hastings,mcgrath,spivey,krause,harden,crabtree,kirkpatrick,arrington,ritter,mcghee,bolden,maloney,gagnon,dunbar,ponce,pike,mayes,beatty,mobley,kimball,butts,montes,eldridge,braun,hamm,gibbons,moyer,manley,herron,plummer,elmore,cramer,rucker,pierson,fontenot,rubio,goldstein,elkins,wills,novak,hickey,worley,gorman,katz,dickinson,broussard,woodruff,crow,britton,nance,lehman,bingham,zuniga,whaley,shafer,coffman,steward,delarosa,neely,mata,davila,mccabe,kessler,hinkle,welsh,pagan,goldberg,goins,crouch,cuevas,quinones,mcdermott,hendrickson,samuels,denton,bergeron,ivey,locke,haines,snell,hoskins,byrne,arias,corbin,beltran,chappell,downey,dooley,tuttle,couch,payton,mcelroy,crockett,groves,cartwright,dickey,mcgill,dubois,muniz,tolbert,dempsey,cisneros,sewell,latham,vigil,tapia,rainey,norwood,stroud,meade,tipton,kuhn,hilliard,bonilla,teague,gunn,greenwood,correa,reece,pineda,phipps,frey,kaiser,ames,gunter,schmitt,milligan,espinosa,bowden,vickers,lowry,pritchard,costello,piper,mcclellan,lovell,sheehan,hatch,dobson,singh,jeffries,hollingsworth,sorensen,meza,fink,donnelly,burrell,tomlinson,colbert,billings,ritchie,helton,sutherland,peoples,mcqueen,thomason,givens,crocker,vogel,robison,dunham,coker,swartz,keys,ladner,richter,hargrove,edmonds,brantley,albright,murdock,boswell,muller,quintero,padgett,kenney,daly,connolly,inman,quintana,lund,barnard,villegas,simons,huggins,tidwell,sanderson,bullard,mcclendon,duarte,draper,marrero,dwyer,abrams,stover,goode,fraser,crews,bernal,godwin,conklin,mcneal,baca,esparza,crowder,bower,brewster,mcneill,rodrigues,leal,coates,raines,mccain,mccord,miner,holbrook,swift,dukes,carlisle,aldridge,ackerman,starks,ricks,holliday,ferris,hairston,sheffield,lange,fountain,doss,betts,kaplan,carmichael,bloom,ruffin,penn,kern,bowles,sizemore,larkin,dupree,seals,metcalf,hutchison,henley,farr,mccauley,hankins,gustafson,curran,waddell,ramey,cates,pollock,cummins,messer,heller,funk,cornett,palacios,galindo,cano,hathaway,pham,enriquez,salgado,pelletier,painter,wiseman,blount,feliciano,houser,doherty,mead,mcgraw,swan,capps,blanco,blackmon,thomson,mcmanus,burkett,gleason,dickens,cormier,voss,rushing,rosenberg,hurd,dumas,benitez,arellano,marin,caudill,bragg,jaramillo,huerta,gipson,colvin,biggs,vela,platt,cassidy,tompkins,mccollum,dolan,daley,crump,sneed,kilgore,grove,grimm,davison,brunson,prater,marcum,devine,dodge,stratton,rosas,choi,tripp,ledbetter,hightower,feldman,epps,yeager,posey,scruggs,cope,stubbs,richey,overton,trotter,sprague,cordero,butcher,stiles,burgos,woodson,horner,bassett,purcell,haskins,akins,ziegler,spaulding,hadley,grubbs,sumner,murillo,zavala,shook,lockwood,driscoll,dahl,thorpe,redmond,putnam,mcwilliams,mcrae,romano,joiner,sadler,hedrick,hager,hagen,fitch,coulter,thacker,mansfield,langston,guidry,ferreira,corley,conn,rossi,lackey,baez,saenz,mcnamara,mcmullen,mckenna,mcdonough,link,engel,browne,roper,peacock,eubanks,drummond,stringer,pritchett,parham,mims,landers,grayson,schafer,egan,timmons,ohara,keen,hamlin,finn,cortes,mcnair,nadeau,moseley,michaud,rosen,oakes,kurtz,jeffers,calloway,beal,bautista,winn,suggs,stern,stapleton,lyles,laird,montano,dawkins,hagan,goldman,bryson,barajas,lovett,segura,metz,lockett,langford,hinson,eastman,hooks,smallwood,shapiro,crowell,whalen,triplett,chatman,aldrich,cahill,youngblood,ybarra,stallings,sheets,reeder,connelly,bateman,abernathy,winkler,wilkes,masters,hackett,granger,gillis,schmitz,sapp,napier,souza,lanier,gomes,weir,otero,ledford,burroughs,babcock,ventura,siegel,dugan,bledsoe,atwood,wray,varner,spangler,anaya,staley,kraft,fournier,belanger,wolff,thorne,bynum,burnette,boykin,swenson,purvis,pina,khan,duvall,darby,xiong,kauffman,healy,engle,benoit,valle,steiner,spicer,shaver,randle,lundy,chin,calvert,staton,neff,kearney,darden,oakley,medeiros,mccracken,crenshaw,perdue,dill,whittaker,tobin,washburn,hogue,goodrich,easley,bravo,dennison,shipley,kerns,jorgensen,crain,villalobos,maurer,longoria,keene,coon,witherspoon,staples,pettit,kincaid,eason,madrid,echols,lusk,stahl,currie,thayer,shultz,mcnally,seay,maher,gagne,barrow,nava,moreland,honeycutt,hearn,diggs,caron,whitten,westbrook,stovall,ragland,munson,meier,looney,kimble,jolly,hobson,goddard,culver,burr,presley,negron,connell,tovar,huddleston,ashby,salter,root,pendleton,oleary,nickerson,myrick,judd,jacobsen,bain,adair,starnes,matos,busby,herndon,hanley,bellamy,doty,bartley,yazzie,rowell,parson,gifford,cullen,christiansen,benavides,barnhart,talbot,mock,crandall,connors,bonds,whitt,gage,bergman,arredondo,addison,lujan,dowdy,jernigan,huynh,bouchard,dutton,rhoades,ouellette,kiser,herrington,hare,blackman,babb,allred,rudd,paulson,ogden,koenig,geiger,begay,parra,lassiter,hawk,esposito,waldron,ransom,prather,chacon,vick,sands,roark,parr,mayberry,greenberg,coley,bruner,whitman,skaggs,shipman,leary,hutton,romo,medrano,ladd,kruse,askew,schulz,alfaro,tabor,mohr,gallo,bermudez,pereira,bliss,reaves,flint,comer,woodall,naquin,guevara,delong,carrier,pickens,tilley,schaffer,knutson,fenton,doran,vogt,vann,prescott,mclain,landis,corcoran,zapata,hyatt,hemphill,faulk,dove,boudreaux,aragon,whitlock,trejo,tackett,shearer,saldana,hanks,mckinnon,koehler,bourgeois,keyes,goodson,foote,lunsford,goldsmith,flood,winslow,sams,reagan,mccloud,hough,esquivel,naylor,loomis,coronado,ludwig,braswell,bearden,huang,fagan,ezell,edmondson,cronin,nunn,lemon,guillory,grier,dubose,traylor,ryder,dobbins,coyle,aponte,whitmore,smalls,rowan,malloy,cardona,braxton,borden,humphries,carrasco,ruff,metzger,huntley,hinojosa,finney,madsen,ernst,dozier,burkhart,bowser,peralta,daigle,whittington,sorenson,saucedo,roche,redding,fugate,avalos,waite,lind,huston,hawthorne,hamby,boyles,boles,regan,faust,crook,beam,barger,hinds,gallardo,willoughby,willingham,eckert,busch,zepeda,worthington,tinsley,hoff,hawley,carmona,varela,rector,newcomb,kinsey,dube,whatley,ragsdale,bernstein,becerra,yost,mattson,felder,cheek,handy,grossman,gauthier,escobedo,braden,beckman,mott,hillman,flaherty,dykes,stockton,stearns,lofton,coats,cavazos,beavers,barrios,tang,mosher,cardwell,coles,burnham,weller,lemons,beebe,aguilera,parnell,harman,couture,alley,schumacher,redd,dobbs,blum,blalock,merchant,ennis,denson,cottrell,brannon,bagley,aviles,watt,sousa,rosenthal,rooney,dietz,blank,paquette,mcclelland,duff,velasco,lentz,grubb,burrows,barbour,ulrich,shockley,rader,beyer,mixon,layton,altman,weathers,stoner,squires,shipp,priest,lipscomb,cutler,caballero,zimmer,willett,thurston,storey,medley,epperson,shah,mcmillian,baggett,torrez,hirsch,dent,poirier,peachey,farrar,creech,barth,trimble,dupre,albrecht,sample,lawler,crisp,conroy,wetzel,nesbitt,murry,jameson,wilhelm,patten,minton,matson,kimbrough,guinn,croft,toth,pulliam,nugent,newby,littlejohn,dias,canales,bernier,baron,singletary,renteria,pruett,mchugh,mabry,landrum,brower,stoddard,cagle,stjohn,scales,kohler,kellogg,hopson,gant,tharp,gann,zeigler,pringle,hammons,fairchild,deaton,chavis,carnes,rowley,matlock,kearns,irizarry,carrington,starkey,lopes,jarrell,craven,baum,littlefield,linn,humphreys,etheridge,cuellar,chastain,bundy,speer,skelton,quiroz,pyle,portillo,ponder,moulton,machado,killian,hutson,hitchcock,dowling,cloud,burdick,spann,pedersen,levin,leggett,hayward,dietrich,beaulieu,barksdale,wakefield,snowden,briscoe,bowie,berman,ogle,mcgregor,laughlin,helm,burden,wheatley,schreiber,pressley,parris,alaniz,agee,swann,snodgrass,schuster,radford,monk,mattingly,harp,girard,cheney,yancey,wagoner,ridley,lombardo,hudgins,gaskins,duckworth,coburn,willey,prado,newberry,magana,hammonds,elam,whipple,slade,serna,ojeda,liles,dorman,diehl,upton,reardon,michaels,goetz,eller,bauman,baer,layne,hummel,brenner,amaya,adamson,ornelas,dowell,cloutier,castellanos,wellman,saylor,orourke,moya,montalvo,kilpatrick,durbin,shell,oldham,kang,garvin,foss,branham,bartholomew,templeton,maguire,holton,rider,monahan,mccormack,beaty,anders,streeter,nieto,nielson,moffett,lankford,keating,heck,gatlin,delatorre,callaway,adcock,worrell,unger,robinette,nowak,jeter,brunner,steen,parrott,overstreet,nobles,montanez,clevenger,brinkley,trahan,quarles,pickering,pederson,jansen,grantham,gilchrist,crespo,aiken,schell,schaeffer,lorenz,leyva,harms,dyson,wallis,pease,leavitt,cheng,cavanaugh,batts,warden,seaman,rockwell,quezada,paxton,linder,houck,fontaine,durant,caruso,adler,pimentel,mize,lytle,cleary,cason,acker,switzer,isaacs,higginbotham,waterman,vandyke,stamper,sisk,shuler,riddick,mcmahan,levesque,hatton,bronson,bollinger,arnett,okeefe,gerber,gannon,farnsworth,baughman,silverman,satterfield,mccrary,kowalski,grigsby,greco,cabral,trout,rinehart,mahon,linton,gooden,curley,baugh,wyman,weiner,schwab,schuler,morrissey,mahan,bunn,thrasher,spear,waggoner,qualls,purdy,mcwhorter,mauldin,gilman,perryman,newsom,menard,martino,graf,billingsley,artis,simpkins,salisbury,quintanilla,gilliland,fraley,foust,crouse,scarborough,grissom,fultz,marlow,markham,madrigal,lawton,barfield,whiting,varney,schwarz,gooch,arce,wheat,truong,poulin,hurtado,selby,gaither,fortner,culpepper,coughlin,brinson,boudreau,bales,stepp,holm,schilling,morrell,kahn,heaton,gamez,causey,turpin,shanks,schrader,meek,isom,hardison,carranza,yanez,scroggins,schofield,runyon,ratcliff,murrell,moeller,irby,currier,butterfield,ralston,pullen,pinson,estep,carbone,hawks,ellington,casillas,spurlock,sikes,motley,mccartney,kruger,isbell,houle,burk,tomlin,quigley,neumann,lovelace,fennell,cheatham,bustamante,skidmore,hidalgo,forman,culp,bowens,betancourt,aquino,robb,milner,martel,gresham,wiles,ricketts,dowd,collazo,bostic,blakely,sherrod,kenyon,gandy,ebert,deloach,allard,sauer,robins,olivares,gillette,chestnut,bourque,paine,hite,hauser,devore,crawley,chapa,talbert,poindexter,meador,mcduffie,mattox,kraus,harkins,choate,wren,sledge,sanborn,kinder,geary,cornwell,barclay,abney,seward,rhoads,howland,fortier,benner,vines,tubbs,troutman,rapp,mccurdy,deluca,westmoreland,havens,guajardo,clary,seal,meehan,herzog,guillen,ashcraft,waugh,renner,milam,elrod,churchill,breaux,bolin,asher,windham,tirado,pemberton,nolen,noland,knott,emmons,cornish,christenson,brownlee,barbee,waldrop,pitt,olvera,lombardi,gruber,gaffney,eggleston,banda,archuleta,slone,prewitt,pfeiffer,nettles,mena,mcadams,henning,gardiner,cromwell,chisholm,burleson,vest,oglesby,mccarter,lumpkin,wofford,vanhorn,thorn,teel,swafford,stclair,stanfield,ocampo,herrmann,hannon,arsenault,roush,mcalister,hiatt,gunderson,forsythe,duggan,delvalle,cintron,wilks,weinstein,uribe,rizzo,noyes,mclendon,gurley,bethea,winstead,maples,guyton,giordano,alderman,valdes,polanco,pappas,lively,grogan,griffiths,bobo,arevalo,whitson,sowell,rendon,fernandes,farrow,benavidez,ayres,alicea,stump,smalley,seitz,schulte,gilley,gallant,canfield,wolford,omalley,mcnutt,mcnulty,mcgovern,hardman,harbin,cowart,chavarria,brink,beckett,bagwell,armstead,anglin,abreu,reynoso,krebs,jett,hoffmann,greenfield,forte,burney,broome,sisson,trammell,partridge,mace,lomax,lemieux,gossett,frantz,fogle,cooney,broughton,pence,paulsen,muncy,mcarthur,hollins,beauchamp,withers,osorio,mulligan,hoyle,dockery,cockrell,begley,amador,roby,rains,lindquist,gentile,everhart,bohannon,wylie,sommers,purnell,fortin,dunning,breeden,vail,phelan,phan,marx,cosby,colburn,boling,biddle,ledesma,gaddis,denney,chow,bueno,berrios,wicker,tolliver,thibodeaux,nagle,lavoie,fisk,crist,barbosa,reedy,locklear,kolb,himes,behrens,beckwith,weems,wahl,shorter,shackelford,rees,muse,cerda,valadez,thibodeau,saavedra,ridgeway,reiter,mchenry,majors,lachance,keaton,ferrara,clemens,blocker,applegate,needham,mojica,kuykendall,hamel,escamilla,doughty,burchett,ainsworth,vidal,upchurch,thigpen,strauss,spruill,sowers,riggins,ricker,mccombs,harlow,buffington,sotelo,olivas,negrete,morey,macon,logsdon,lapointe,bigelow,bello,westfall,stubblefield,lindley,hein,hawes,farrington,breen,birch,wilde,steed,sepulveda,reinhardt,proffitt,minter,messina,mcnabb,maier,keeler,gamboa,donohue,basham,shinn,crooks,cota,borders,bills,bachman,tisdale,tavares,schmid,pickard,gulley,fonseca,delossantos,condon,batista,wicks,wadsworth,martell,littleton,ison,haag,folsom,brumfield,broyles,brito,mireles,mcdonnell,leclair,hamblin,gough,fanning,binder,winfield,whitworth,soriano,palumbo,newkirk,mangum,hutcherson,comstock,carlin,beall,bair,wendt,watters,walling,putman,otoole,morley,mares,lemus,keener,hundley,dial,damico,billups,strother,mcfarlane,lamm,eaves,crutcher,caraballo,canty,atwell,taft,siler,rust,rawls,rawlings,prieto,mcneely,mcafee,hulsey,hackney,galvez,escalante,delagarza,crider,bandy,wilbanks,stowe,steinberg,renfro,masterson,massie,lanham,haskell,hamrick,dehart,burdette,branson,bourne,babin,aleman,worthy,tibbs,smoot,slack,paradis,mull,luce,houghton,gantt,furman,danner,christianson,burge,ashford,arndt,almeida,stallworth,shade,searcy,sager,noonan,mclemore,mcintire,maxey,lavigne,jobe,ferrer,falk,coffin,byrnes,aranda,apodaca,stamps,rounds,peek,olmstead,lewandowski,kaminski,dunaway,bruns,brackett,amato,reich,mcclung,lacroix,koontz,herrick,hardesty,flanders,cousins,cato,cade,vickery,shank,nagel,dupuis,croteau,cotter,stuckey,stine,porterfield,pauley,moffitt,knudsen,hardwick,goforth,dupont,blunt,barrows,barnhill,shull,rash,loftis,lemay,kitchens,horvath,grenier,fuchs,fairbanks,culbertson,calkins,burnside,beattie,ashworth,albertson,wertz,vaught,vallejo,turk,tuck,tijerina,sage,peterman,marroquin,marr,lantz,hoang,demarco,cone,berube,barnette,wharton,stinnett,slocum,scanlon,sander,pinto,mancuso,lima,headley,epstein,counts,clarkson,carnahan,boren,arteaga,adame,zook,whittle,whitehurst,wenzel,saxton,reddick,puente,handley,haggerty,earley,devlin,chaffin,cady,acuna,solano,sigler,pollack,pendergrass,ostrander,janes,francois,crutchfield,chamberlin,brubaker,baptiste,willson,reis,neeley,mullin,mercier,lira,layman,keeling,higdon,espinal,chapin,warfield,toledo,pulido,peebles,nagy,montague,mello,lear,jaeger,hogg,graff,furr,soliz,poore,mendenhall,mclaurin,maestas,gable,barraza,tillery,snead,pond,neill,mcculloch,mccorkle,lightfoot,hutchings,holloman,harness,dorn,bock,zielinski,turley,treadwell,stpierre,starling,somers,oswald,merrick,easterling,bivens,truitt,poston,parry,ontiveros,olivarez,moreau,medlin,lenz,knowlton,fairley,cobbs,chisolm,bannister,woodworth,toler,ocasio,noriega,neuman,moye,milburn,mcclanahan,lilley,hanes,flannery,dellinger,danielson,conti,blodgett,beers,weatherford,strain,karr,hitt,denham,custer,coble,clough,casteel,bolduc,batchelor,ammons,whitlow,tierney,staten,sibley,seifert,schubert,salcedo,mattison,laney,haggard,grooms,dees,cromer,cooks,colson,caswell,zarate,swisher,shin,ragan,pridgen,mcvey,matheny,lafleur,franz,ferraro,dugger,whiteside,rigsby,mcmurray,lehmann,jacoby,hildebrand,hendrick,headrick,goad,fincher,drury,borges,archibald,albers,woodcock,trapp,soares,seaton,monson,luckett,lindberg,kopp,keeton,healey,garvey,gaddy,fain,burchfield,wentworth,strand,stack,spooner,saucier,ricci,plunkett,pannell,ness,leger,freitas,fong,elizondo,duval,beaudoin,urbina,rickard,partin,mcgrew,mcclintock,ledoux,forsyth,faison,devries,bertrand,wasson,tilton,scarbrough,leung,irvine,garber,denning,corral,colley,castleberry,bowlin,bogan,beale,baines,trice,rayburn,parkinson,nunes,mcmillen,leahy,kimmel,higgs,fulmer,carden,bedford,taggart,spearman,prichard,morrill,koonce,heinz,hedges,guenther,grice,findley,dover,creighton,boothe,bayer,arreola,vitale,valles,raney,osgood,hanlon,burley,bounds,worden,weatherly,vetter,tanaka,stiltner,nevarez,mosby,montero,melancon,harter,hamer,goble,gladden,gist,ginn,akin,zaragoza,tarver,sammons,royster,oreilly,muir,morehead,luster,kingsley,kelso,grisham,glynn,baumann,alves,yount,tamayo,paterson,oates,menendez,longo,hargis,gillen,desantis,conover,breedlove,sumpter,scherer,rupp,reichert,heredia,creel,cohn,clemmons,casas,bickford,belton,bach,williford,whitcomb,tennant,sutter,stull,mccallum,langlois,keel,keegan,dangelo,dancy,damron,clapp,clanton,bankston,oliveira,mintz,mcinnis,martens,mabe,laster,jolley,hildreth,hefner,glaser,duckett,demers,brockman,blais,alcorn,agnew,toliver,tice,seeley,najera,musser,mcfall,laplante,galvin,fajardo,doan,coyne,copley,clawson,cheung,barone,wynne,woodley,tremblay,stoll,sparrow,sparkman,schweitzer,sasser,samples,roney,legg,heim,farias,colwell,christman,bratcher,winchester,upshaw,southerland,sorrell,sells,mccloskey,martindale,luttrell,loveless,lovejoy,linares,latimer,embry,coombs,bratton,bostick,venable,tuggle,toro,staggs,sandlin,jefferies,heckman,griffis,crayton,clem,browder,thorton,sturgill,sprouse,royer,rousseau,ridenour,pogue,perales,peeples,metzler,mesa,mccutcheon,mcbee,hornsby,heffner,corrigan,armijo,plante,peyton,paredes,macklin,hussey,hodgson,granados,frias,becnel,batten,almanza,turney,teal,sturgeon,meeker,mcdaniels,limon,keeney,hutto,holguin,gorham,fishman,fierro,blanchette,rodrigue,reddy,osburn,oden,lerma,kirkwood,keefer,haugen,hammett,chalmers,brinkman,baumgartner,zhang,valerio,tellez,steffen,shumate,sauls,ripley,kemper,guffey,evers,craddock,carvalho,blaylock,banuelos,balderas,wheaton,turnbull,shuman,pointer,mosier,mccue,ligon,kozlowski,johansen,ingle,herr,briones,snipes,rickman,pipkin,pantoja,orosco,moniz,lawless,kunkel,hibbard,galarza,enos,bussey,schott,salcido,perreault,mcdougal,mccool,haight,garris,easton,conyers,atherton,wimberly,utley,spellman,smithson,slagle,ritchey,rand,petit,osullivan,oaks,nutt,mcvay,mccreary,mayhew,knoll,jewett,harwood,cardoza,ashe,arriaga,zeller,wirth,whitmire,stauffer,rountree,redden,mccaffrey,martz,larose,langdon,humes,gaskin,faber,devito,cass,almond,wingfield,wingate,villareal,tyner,smothers,severson,reno,pennell,maupin,leighton,janssen,hassell,hallman,halcomb,folse,fitzsimmons,fahey,cranford,bolen,battles,battaglia,wooldridge,trask,rosser,regalado,mcewen,keefe,fuqua,echevarria,caro,boynton,andrus,viera,vanmeter,taber,spradlin,seibert,provost,prentice,oliphant,laporte,hwang,hatchett,hass,greiner,freedman,covert,chilton,byars,wiese,venegas,swank,shrader,roberge,mullis,mortensen,mccune,marlowe,kirchner,keck,isaacson,hostetler,halverson,gunther,griswold,fenner,durden,blackwood,ahrens,sawyers,savoy,nabors,mcswain,mackay,lavender,lash,labbe,jessup,fullerton,cruse,crittenden,correia,centeno,caudle,canady,callender,alarcon,ahern,winfrey,tribble,salley,roden,musgrove,minnick,fortenberry,carrion,bunting,batiste,whited,underhill,stillwell,rauch,pippin,perrin,messenger,mancini,lister,kinard,hartmann,fleck,wilt,treadway,thornhill,spalding,rafferty,pitre,patino,ordonez,linkous,kelleher,homan,galbraith,feeney,curtin,coward,camarillo,buss,bunnell,bolt,beeler,autry,alcala,witte,wentz,stidham,shively,nunley,meacham,martins,lemke,lefebvre,hynes,horowitz,hoppe,holcombe,dunne,derr,cochrane,brittain,bedard,beauregard,torrence,strunk,soria,simonson,shumaker,scoggins,oconner,moriarty,kuntz,ives,hutcheson,horan,hales,garmon,fitts,bohn,atchison,wisniewski,vanwinkle,sturm,sallee,prosser,moen,lundberg,kunz,kohl,keane,jorgenson,jaynes,funderburk,freed,durr,creamer,cosgrove,batson,vanhoose,thomsen,teeter,smyth,redmon,orellana,maness,heflin,goulet,frick,forney,bunker,asbury,aguiar,talbott,southard,mowery,mears,lemmon,krieger,hickson,elston,duong,delgadillo,dayton,dasilva,conaway,catron,bruton,bradbury,bordelon,bivins,bittner,bergstrom,beals,abell,whelan,tejada,pulley,pino,norfleet,nealy,maes,loper,gatewood,frierson,freund,finnegan,cupp,covey,catalano,boehm,bader,yoon,walston,tenney,sipes,rawlins,medlock,mccaskill,mccallister,marcotte,maclean,hughey,henke,harwell,gladney,gilson,chism,caskey,brandenburg,baylor,villasenor,veal,thatcher,stegall,petrie,nowlin,navarrete,lombard,loftin,lemaster,kroll,kovach,kimbrell,kidwell,hershberger,fulcher,cantwell,bustos,boland,bobbitt,binkley,wester,weis,verdin,tong,tiller,sisco,sharkey,seymore,rosenbaum,rohr,quinonez,pinkston,malley,logue,lessard,lerner,lebron,krauss,klinger,halstead,haller,getz,burrow,alger,shores,pfeifer,perron,nelms,munn,mcmaster,mckenney,manns,knudson,hutchens,huskey,goebel,flagg,cushman,click,castellano,carder,bumgarner,wampler,spinks,robson,neel,mcreynolds,mathias,maas,loera,jenson,florez,coons,buckingham,brogan,berryman,wilmoth,wilhite,thrash,shephard,seidel,schulze,roldan,pettis,obryan,maki,mackie,hatley,frazer,fiore,chesser,bottoms,bisson,benefield,allman,wilke,trudeau,timm,shifflett,mundy,milliken,mayers,leake,kohn,huntington,horsley,hermann,guerin,fryer,frizzell,foret,flemming,fife,criswell,carbajal,bozeman,boisvert,angulo,wallen,tapp,silvers,ramsay,oshea,orta,moll,mckeever,mcgehee,linville,kiefer,ketchum,howerton,groce,gass,fusco,corbitt,betz,bartels,amaral,aiello,weddle,sperry,seiler,runyan,raley,overby,osteen,olds,mckeown,matney,lauer,lattimore,hindman,hartwell,fredrickson,fredericks,espino,clegg,carswell,cambell,burkholder,woodbury,welker,totten,thornburg,theriault,stitt,stamm,stackhouse,scholl,saxon,rife,razo,quinlan,pinkerton,olivo,nesmith,nall,mattos,lafferty,justus,giron,geer,fielder,drayton,dortch,conners,conger,boatwright,billiot,barden,armenta,tibbetts,steadman,slattery,rinaldi,raynor,pinckney,pettigrew,milne,matteson,halsey,gonsalves,fellows,durand,desimone,cowley,cowles,brill,barham,barela,barba,ashmore,withrow,valenti,tejeda,spriggs,sayre,salerno,peltier,peel,merriman,matheson,lowman,lindstrom,hyland,giroux,earls,dugas,dabney,collado,briseno,baxley,whyte,wenger,vanover,vanburen,thiel,schindler,schiller,rigby,pomeroy,passmore,marble,manzo,mahaffey,lindgren,laflamme,greathouse,fite,calabrese,bayne,yamamoto,wick,townes,thames,reinhart,peeler,naranjo,montez,mcdade,mast,markley,marchand,leeper,kellum,hudgens,hennessey,hadden,gainey,coppola,borrego,bolling,beane,ault,slaton,pape,null,mulkey,lightner,langer,hillard,ethridge,enright,derosa,baskin,weinberg,turman,somerville,pardo,noll,lashley,ingraham,hiller,hendon,glaze,cothran,cooksey,conte,carrico,abner,wooley,swope,summerlin,sturgis,sturdivant,stott,spurgeon,spillman,speight,roussel,popp,nutter,mckeon,mazza,magnuson,lanning,kozak,jankowski,heyward,forster,corwin,callaghan,bays,wortham,usher,theriot,sayers,sabo,poling,loya,lieberman,laroche,labelle,howes,harr,garay,fogarty,everson,durkin,dominquez,chaves,chambliss,witcher,vieira,vandiver,terrill,stoker,schreiner,moorman,liddell,lawhorn,krug,irons,hylton,hollenbeck,herrin,hembree,goolsby,goodin,gilmer,foltz,dinkins,daughtry,caban,brim,briley,bilodeau,wyant,vergara,tallent,swearingen,stroup,scribner,quillen,pitman,mccants,maxfield,martinson,holtz,flournoy,brookins,brody,baumgardner,straub,sills,roybal,roundtree,oswalt,mcgriff,mcdougall,mccleary,maggard,gragg,gooding,godinez,doolittle,donato,cowell,cassell,bracken,appel,zambrano,reuter,perea,nakamura,monaghan,mickens,mcclinton,mcclary,marler,kish,judkins,gilbreath,freese,flanigan,felts,erdmann,dodds,chew,brownell,boatright,barreto,slayton,sandberg,saldivar,pettway,odum,narvaez,moultrie,montemayor,merrell,lees,keyser,hoke,hardaway,hannan,gilbertson,fogg,dumont,deberry,coggins,buxton,bucher,broadnax,beeson,araujo,appleton,amundson,aguayo,ackley,yocum,worsham,shivers,sanches,sacco,robey,rhoden,pender,ochs,mccurry,madera,luong,knotts,jackman,heinrich,hargrave,gault,comeaux,chitwood,caraway,boettcher,bernhardt,barrientos,zink,wickham,whiteman,thorp,stillman,settles,schoonover,roque,riddell,pilcher,phifer,novotny,macleod,hardee,haase,grider,doucette,clausen,bevins,beamon,badillo,tolley,tindall,soule,snook,seale,pinkney,pellegrino,nowell,nemeth,mondragon,mclane,lundgren,ingalls,hudspeth,hixson,gearhart,furlong,downes,dibble,deyoung,cornejo,camara,brookshire,boyette,wolcott,surratt,sellars,segal,salyer,reeve,rausch,labonte,haro,gower,freeland,fawcett,eads,driggers,donley,collett,bromley,boatman,ballinger,baldridge,volz,trombley,stonge,shanahan,rivard,rhyne,pedroza,matias,jamieson,hedgepeth,hartnett,estevez,eskridge,denman,chiu,chinn,catlett,carmack,buie,bechtel,beardsley,bard,ballou,ulmer,skeen,robledo,rincon,reitz,piazza,munger,moten,mcmichael,loftus,ledet,kersey,groff,fowlkes,crumpton,clouse,bettis,villagomez,timmerman,strom,santoro,roddy,penrod,musselman,macpherson,leboeuf,harless,haddad,guido,golding,fulkerson,fannin,dulaney,dowdell,cottle,ceja,cate,bosley,benge,albritton,voigt,trowbridge,soileau,seely,rohde,pearsall,paulk,orth,nason,mota,mcmullin,marquardt,madigan,hoag,gillum,gabbard,fenwick,danforth,cushing,cress,creed,cazares,bettencourt,barringer,baber,stansberry,schramm,rutter,rivero,oquendo,necaise,mouton,montenegro,miley,mcgough,marra,macmillan,lamontagne,jasso,horst,hetrick,heilman,gaytan,gall,fortney,dingle,desjardins,dabbs,burbank,brigham,breland,beaman,arriola,yarborough,wallin,toscano,stowers,reiss,pichardo,orton,michels,mcnamee,mccrory,leatherman,kell,keister,horning,hargett,guay,ferro,deboer,dagostino,carper,blanks,beaudry,towle,tafoya,stricklin,strader,soper,sonnier,sigmon,schenk,saddler,pedigo,mendes,lunn,lohr,lahr,kingsbury,jarman,hume,holliman,hofmann,haworth,harrelson,hambrick,flick,edmunds,dacosta,crossman,colston,chaplin,carrell,budd,weiler,waits,valentino,trantham,tarr,solorio,roebuck,powe,plank,pettus,pagano,mink,luker,leathers,joslin,hartzell,gambrell,cepeda,carty,caputo,brewington,bedell,ballew,applewhite,warnock,walz,urena,tudor,reel,pigg,parton,mickelson,meagher,mclellan,mcculley,mandel,leech,lavallee,kraemer,kling,kipp,kehoe,hochstetler,harriman,gregoire,grabowski,gosselin,gammon,fancher,edens,desai,brannan,armendariz,woolsey,whitehouse,whetstone,ussery,towne,testa,tallman,studer,strait,steinmetz,sorrells,sauceda,rolfe,paddock,mitchem,mcginn,mccrea,lovato,hazen,gilpin,gaynor,fike,devoe,delrio,curiel,burkhardt,bode,backus,zinn,watanabe,wachter,vanpelt,turnage,shaner,schroder,sato,riordan,quimby,portis,natale,mckoy,mccown,kilmer,hotchkiss,hesse,halbert,gwinn,godsey,delisle,chrisman,canter,arbogast,angell,acree,yancy,woolley,wesson,weatherspoon,trainor,stockman,spiller,sipe,rooks,reavis,propst,porras,neilson,mullens,loucks,llewellyn,kumar,koester,klingensmith,kirsch,kester,honaker,hodson,hennessy,helmick,garrity,garibay,drain,casarez,callis,botello,aycock,avant,wingard,wayman,tully,theisen,szymanski,stansbury,segovia,rainwater,preece,pirtle,padron,mincey,mckelvey,mathes,larrabee,kornegay,klug,ingersoll,hecht,germain,eggers,dykstra,deering,decoteau,deason,dearing,cofield,carrigan,bonham,bahr,aucoin,appleby,almonte,yager,womble,wimmer,weimer,vanderpool,stancil,sprinkle,romine,remington,pfaff,peckham,olivera,meraz,maze,lathrop,koehn,hazelton,halvorson,hallock,haddock,ducharme,dehaven,caruthers,brehm,bosworth,bost,bias,beeman,basile,bane,aikens,wold,walther,tabb,suber,strawn,stocker,shirey,schlosser,riedel,rembert,reimer,pyles,peele,merriweather,letourneau,latta,kidder,hixon,hillis,hight,herbst,henriquez,haygood,hamill,gabel,fritts,eubank,dawes,correll,bushey,buchholz,brotherton,botts,barnwell,auger,atchley,westphal,veilleux,ulloa,stutzman,shriver,ryals,pilkington,moyers,marrs,mangrum,maddux,lockard,laing,kuhl,harney,hammock,hamlett,felker,doerr,depriest,carrasquillo,carothers,bogle,bischoff,bergen,albanese,wyckoff,vermillion,vansickle,thibault,tetreault,stickney,shoemake,ruggiero,rawson,racine,philpot,paschal,mcelhaney,mathison,legrand,lapierre,kwan,kremer,jiles,hilbert,geyer,faircloth,ehlers,egbert,desrosiers,dalrymple,cotten,cashman,cadena,boardman,alcaraz,wyrick,therrien,tankersley,strickler,puryear,plourde,pattison,pardue,mcginty,mcevoy,landreth,kuhns,koon,hewett,giddens,emerick,eades,deangelis,cosme,ceballos,birdsong,benham,bemis,armour,anguiano,welborn,tsosie,storms,shoup,sessoms,samaniego,rood,rojo,rhinehart,raby,northcutt,myer,munguia,morehouse,mcdevitt,mallett,lozada,lemoine,kuehn,hallett,grim,gillard,gaylor,garman,gallaher,feaster,faris,darrow,dardar,coney,carreon,braithwaite,boylan,boyett,bixler,bigham,benford,barragan,barnum,zuber,wyche,westcott,vining,stoltzfus,simonds,shupe,sabin,ruble,rittenhouse,richman,perrone,mulholland,millan,lomeli,kite,jemison,hulett,holler,hickerson,herold,hazelwood,griffen,gause,forde,eisenberg,dilworth,charron,chaisson,bristow,breunig,brace,boutwell,bentz,belk,bayless,batchelder,baran,baeza,zimmermann,weathersby,volk,toole,theis,tedesco,searle,schenck,satterwhite,ruelas,rankins,partida,nesbit,morel,menchaca,levasseur,kaylor,johnstone,hulse,hollar,hersey,harrigan,harbison,guyer,gish,giese,gerlach,geller,geisler,falcone,elwell,doucet,deese,darr,corder,chafin,byler,bussell,burdett,brasher,bowe,bellinger,bastian,barner,alleyne,wilborn,weil,wegner,tatro,spitzer,smithers,schoen,resendez,parisi,overman,obrian,mudd,mahler,maggio,lindner,lalonde,lacasse,laboy,killion,kahl,jessen,jamerson,houk,henshaw,gustin,graber,durst,duenas,davey,cundiff,conlon,colunga,coakley,chiles,capers,buell,bricker,bissonnette,bartz,bagby,zayas,volpe,treece,toombs,thom,terrazas,swinney,skiles,silveira,shouse,senn,ramage,moua,langham,kyles,holston,hoagland,herd,feller,denison,carraway,burford,bickel,ambriz,abercrombie,yamada,weidner,waddle,verduzco,thurmond,swindle,schrock,sanabria,rosenberger,probst,peabody,olinger,nazario,mccafferty,mcbroom,mcabee,mazur,matherne,mapes,leverett,killingsworth,heisler,griego,gosnell,frankel,franke,ferrante,fenn,ehrlich,christopherso,chasse,caton,brunelle,bloomfield,babbitt,azevedo,abramson,ables,abeyta,youmans,wozniak,wainwright,stowell,smitherman,samuelson,runge,rothman,rosenfeld,peake,owings,olmos,munro,moreira,leatherwood,larkins,krantz,kovacs,kizer,kindred,karnes,jaffe,hubbell,hosey,hauck,goodell,erdman,dvorak,doane,cureton,cofer,buehler,bierman,berndt,banta,abdullah,warwick,waltz,turcotte,torrey,stith,seger,sachs,quesada,pinder,peppers,pascual,paschall,parkhurst,ozuna,oster,nicholls,lheureux,lavalley,kimura,jablonski,haun,gourley,gilligan,croy,cotto,cargill,burwell,burgett,buckman,booher,adorno,wrenn,whittemore,urias,szabo,sayles,saiz,rutland,rael,pharr,pelkey,ogrady,nickell,musick,moats,mather,massa,kirschner,kieffer,kellar,hendershot,gott,godoy,gadson,furtado,fiedler,erskine,dutcher,dever,daggett,chevalier,brake,ballesteros,amerson,wingo,waldon,trott,silvey,showers,schlegel,ritz,pepin,pelayo,parsley,palermo,moorehead,mchale,lett,kocher,kilburn,iglesias,humble,hulbert,huckaby,hartford,hardiman,gurney,grigg,grasso,goings,fillmore,farber,depew,dandrea,cowen,covarrubias,burrus,bracy,ardoin,thompkins,standley,radcliffe,pohl,persaud,parenteau,pabon,newson,newhouse,napolitano,mulcahy,malave,keim,hooten,hernandes,heffernan,hearne,greenleaf,glick,fuhrman,fetter,faria,dishman,dickenson,crites,criss,clapper,chenault,castor,casto,bugg,bove,bonney,anderton,allgood,alderson,woodman,warrick,toomey,tooley,tarrant,summerville,stebbins,sokol,searles,schutz,schumann,scheer,remillard,raper,proulx,palmore,monroy,messier,melo,melanson,mashburn,manzano,lussier,jenks,huneycutt,hartwig,grimsley,fulk,fielding,fidler,engstrom,eldred,dantzler,crandell,calder,brumley,breton,brann,bramlett,boykins,bianco,bancroft,almaraz,alcantar,whitmer,whitener,welton,vineyard,rahn,paquin,mizell,mcmillin,mckean,marston,maciel,lundquist,liggins,lampkin,kranz,koski,kirkham,jiminez,hazzard,harrod,graziano,grammer,gendron,garrido,fordham,englert,dryden,demoss,deluna,crabb,comeau,brummett,blume,benally,wessel,vanbuskirk,thorson,stumpf,stockwell,reams,radtke,rackley,pelton,niemi,newland,nelsen,morrissette,miramontes,mcginley,mccluskey,marchant,luevano,lampe,lail,jeffcoat,infante,hinman,gaona,eady,desmarais,decosta,dansby,cisco,choe,breckenridge,bostwick,borg,bianchi,alberts,wilkie,whorton,vargo,tait,soucy,schuman,ousley,mumford,lippert,leath,lavergne,laliberte,kirksey,kenner,johnsen,izzo,hiles,gullett,greenwell,gaspar,galbreath,gaitan,ericson,delapaz,croom,cottingham,clift,bushnell,bice,beason,arrowood,waring,voorhees,truax,shreve,shockey,schatz,sandifer,rubino,rozier,roseberry,pieper,peden,nester,nave,murphey,malinowski,macgregor,lafrance,kunkle,kirkman,hipp,hasty,haddix,gervais,gerdes,gamache,fouts,fitzwater,dillingham,deming,deanda,cedeno,cannady,burson,bouldin,arceneaux,woodhouse,whitford,wescott,welty,weigel,torgerson,toms,surber,sunderland,sterner,setzer,riojas,pumphrey,puga,metts,mcgarry,mccandless,magill,lupo,loveland,llamas,leclerc,koons,kahler,huss,holbert,heintz,haupt,grimmett,gaskill,ellingson,dorr,dingess,deweese,desilva,crossley,cordeiro,converse,conde,caldera,cairns,burmeister,burkhalter,brawner,bott,youngs,vierra,valladares,shrum,shropshire,sevilla,rusk,rodarte,pedraza,nino,merino,mcminn,markle,mapp,lajoie,koerner,kittrell,kato,hyder,hollifield,heiser,hazlett,greenwald,fant,eldredge,dreher,delafuente,cravens,claypool,beecher,aronson,alanis,worthen,wojcik,winger,whitacre,valverde,valdivia,troupe,thrower,swindell,suttles,stroman,spires,slate,shealy,sarver,sartin,sadowski,rondeau,rolon,rascon,priddy,paulino,nolte,munroe,molloy,mciver,lykins,loggins,lenoir,klotz,kempf,hupp,hollowell,hollander,haynie,harkness,harker,gottlieb,frith,eddins,driskell,doggett,densmore,charette,cassady,byrum,burcham,buggs,benn,whitted,warrington,vandusen,vaillancourt,steger,siebert,scofield,quirk,purser,plumb,orcutt,nordstrom,mosely,michalski,mcphail,mcdavid,mccraw,marchese,mannino,lefevre,largent,lanza,kress,isham,hunsaker,hoch,hildebrandt,guarino,grijalva,graybill,fick,ewell,ewald,cusick,crumley,coston,cathcart,carruthers,bullington,bowes,blain,blackford,barboza,yingling,wert,weiland,varga,silverstein,sievers,shuster,shumway,runnels,rumsey,renfroe,provencher,polley,mohler,middlebrooks,kutz,koster,groth,glidden,fazio,deen,chipman,chenoweth,champlin,cedillo,carrero,carmody,buckles,brien,boutin,bosch,berkowitz,altamirano,wilfong,wiegand,waites,truesdale,toussaint,tobey,tedder,steelman,sirois,schnell,robichaud,richburg,plumley,pizarro,piercy,ortego,oberg,neace,mertz,mcnew,matta,lapp,lair,kibler,howlett,hollister,hofer,hatten,hagler,falgoust,engelhardt,eberle,dombrowski,dinsmore,daye,casares,braud,balch,autrey,wendel,tyndall,strobel,stoltz,spinelli,serrato,reber,rathbone,palomino,nickels,mayle,mathers,mach,loeffler,littrell,levinson,leong,lemire,lejeune,lazo,lasley,koller,kennard,hoelscher,hintz,hagerman,greaves,fore,eudy,engler,corrales,cordes,brunet,bidwell,bennet,tyrrell,tharpe,swinton,stribling,southworth,sisneros,savoie,samons,ruvalcaba,ries,ramer,omara,mosqueda,millar,mcpeak,macomber,luckey,litton,lehr,lavin,hubbs,hoard,hibbs,hagans,futrell,exum,evenson,culler,carbaugh,callen,brashear,bloomer,blakeney,bigler,addington,woodford,unruh,tolentino,sumrall,stgermain,smock,sherer,rayner,pooler,oquinn,nero,mcglothlin,linden,kowal,kerrigan,ibrahim,harvell,hanrahan,goodall,geist,fussell,fung,ferebee,eley,eggert,dorsett,dingman,destefano,colucci,clemmer,burnell,brumbaugh,boddie,berryhill,avelar,alcantara,winder,winchell,vandenberg,trotman,thurber,thibeault,stlouis,stilwell,sperling,shattuck,sarmiento,ruppert,rumph,renaud,randazzo,rademacher,quiles,pearman,palomo,mercurio,lowrey,lindeman,lawlor,larosa,lander,labrecque,hovis,holifield,henninger,hawkes,hartfield,hann,hague,genovese,garrick,fudge,frink,eddings,dinh,cribbs,calvillo,bunton,brodeur,bolding,blanding,agosto,zahn,wiener,trussell,tello,teixeira,speck,sharma,shanklin,sealy,scanlan,santamaria,roundy,robichaux,ringer,rigney,prevost,polson,nord,moxley,medford,mccaslin,mcardle,macarthur,lewin,lasher,ketcham,keiser,heine,hackworth,grose,grizzle,gillman,gartner,frazee,fleury,edson,edmonson,derry,cronk,conant,burress,burgin,broom,brockington,bolick,boger,birchfield,billington,baily,bahena,armbruster,anson,yoho,wilcher,tinney,timberlake,thielen,sutphin,stultz,sikora,serra,schulman,scheffler,santillan,rego,preciado,pinkham,mickle,lomas,lizotte,lent,kellerman,keil,johanson,hernadez,hartsfield,haber,gorski,farkas,eberhardt,duquette,delano,cropper,cozart,cockerham,chamblee,cartagena,cahoon,buzzell,brister,brewton,blackshear,benfield,aston,ashburn,arruda,wetmore,weise,vaccaro,tucci,sudduth,stromberg,stoops,showalter,shears,runion,rowden,rosenblum,riffle,renfrow,peres,obryant,leftwich,lark,landeros,kistler,killough,kerley,kastner,hoggard,hartung,guertin,govan,gatling,gailey,fullmer,fulford,flatt,esquibel,endicott,edmiston,edelstein,dufresne,dressler,dickman,chee,busse,bonnett,berard,yoshida,velarde,veach,vanhouten,vachon,tolson,tolman,tennyson,stites,soler,shutt,ruggles,rhone,pegues,neese,muro,moncrief,mefford,mcphee,mcmorris,mceachern,mcclurg,mansour,mader,leija,lecompte,lafountain,labrie,jaquez,heald,hash,hartle,gainer,frisby,farina,eidson,edgerton,dyke,durrett,duhon,cuomo,cobos,cervantez,bybee,brockway,borowski,binion,beery,arguello,amaro,acton,yuen,winton,wigfall,weekley,vidrine,vannoy,tardiff,shoop,shilling,schick,safford,prendergast,pilgrim,pellerin,osuna,nissen,nalley,moller,messner,messick,merrifield,mcguinness,matherly,marcano,mahone,lemos,lebrun,jara,hoffer,herren,hecker,haws,haug,gwin,gober,gilliard,fredette,favela,echeverria,downer,donofrio,desrochers,crozier,corson,bechtold,argueta,aparicio,zamudio,westover,westerman,utter,troyer,thies,tapley,slavin,shirk,sandler,roop,rimmer,raymer,radcliff,otten,moorer,millet,mckibben,mccutchen,mcavoy,mcadoo,mayorga,mastin,martineau,marek,madore,leflore,kroeger,kennon,jimerson,hostetter,hornback,hendley,hance,guardado,granado,gowen,goodale,flinn,fleetwood,fitz,durkee,duprey,dipietro,dilley,clyburn,brawley,beckley,arana,weatherby,vollmer,vestal,tunnell,trigg,tingle,takahashi,sweatt,storer,snapp,shiver,rooker,rathbun,poisson,perrine,perri,parmer,parke,pare,papa,palmieri,midkiff,mecham,mccomas,mcalpine,lovelady,lillard,lally,knopp,kile,kiger,haile,gupta,goldsberry,gilreath,fulks,friesen,franzen,flack,findlay,ferland,dreyer,dore,dennard,deckard,debose,crim,coulombe,chancey,cantor,branton,bissell,barns,woolard,witham,wasserman,spiegel,shoffner,scholz,ruch,rossman,petry,palacio,paez,neary,mortenson,millsap,miele,menke,mckim,mcanally,martines,lemley,larochelle,klaus,klatt,kaufmann,kapp,helmer,hedge,halloran,glisson,frechette,fontana,eagan,distefano,danley,creekmore,chartier,chaffee,carillo,burg,bolinger,berkley,benz,basso,bash,zelaya,woodring,witkowski,wilmot,wilkens,wieland,verdugo,urquhart,tsai,timms,swiger,swaim,sussman,pires,molnar,mcatee,lowder,loos,linker,landes,kingery,hufford,higa,hendren,hammack,hamann,gillam,gerhardt,edelman,delk,deans,curl,constantine,cleaver,claar,casiano,carruth,carlyle,brophy,bolanos,bibbs,bessette,beggs,baugher,bartel,averill,andresen,amin,adames,valente,turnbow,swink,sublett,stroh,stringfellow,ridgway,pugliese,poteat,ohare,neubauer,murchison,mingo,lemmons,kwon,kellam,kean,jarmon,hyden,hudak,hollinger,henkel,hemingway,hasson,hansel,halter,haire,ginsberg,gillispie,fogel,flory,etter,elledge,eckman,deas,currin,crafton,coomer,colter,claxton,bulter,braddock,bowyer,binns,bellows,baskerville,barros,ansley,woolf,wight,waldman,wadley,tull,trull,tesch,stouffer,stadler,slay,shubert,sedillo,santacruz,reinke,poynter,neri,neale,mowry,moralez,monger,mitchum,merryman,manion,macdougall,litchfield,levitt,lepage,lasalle,khoury,kavanagh,karns,ivie,huebner,hodgkins,halpin,garica,eversole,dutra,dunagan,duffey,dillman,dillion,deville,dearborn,damato,courson,coulson,burdine,bousquet,bonin,bish,atencio,westbrooks,wages,vaca,toner,tillis,swett,struble,stanfill,solorzano,slusher,sipple,silvas,shults,schexnayder,saez,rodas,rager,pulver,penton,paniagua,meneses,mcfarlin,mcauley,matz,maloy,magruder,lohman,landa,lacombe,jaimes,holzer,holst,heil,hackler,grundy,gilkey,farnham,durfee,dunton,dunston,duda,dews,craver,corriveau,conwell,colella,chambless,bremer,boutte,bourassa,blaisdell,backman,babineaux,audette,alleman,towner,taveras,tarango,sullins,suiter,stallard,solberg,schlueter,poulos,pimental,owsley,okelley,moffatt,metcalfe,meekins,medellin,mcglynn,mccowan,marriott,marable,lennox,lamoureux,koss,kerby,karp,isenberg,howze,hockenberry,highsmith,hallmark,gusman,greeley,giddings,gaudet,gallup,fleenor,eicher,edington,dimaggio,dement,demello,decastro,bushman,brundage,brooker,bourg,blackstock,bergmann,beaton,banister,argo,appling,wortman,watterson,villalpando,tillotson,tighe,sundberg,sternberg,stamey,shipe,seeger,scarberry,sattler,sain,rothstein,poteet,plowman,pettiford,penland,partain,pankey,oyler,ogletree,ogburn,moton,merkel,lucier,lakey,kratz,kinser,kershaw,josephson,imhoff,hendry,hammon,frisbie,frawley,fraga,forester,eskew,emmert,drennan,doyon,dandridge,cawley,carvajal,bracey,belisle,batey,ahner,wysocki,weiser,veliz,tincher,sansone,sankey,sandstrom,rohrer,risner,pridemore,pfeffer,persinger,peery,oubre,nowicki,musgrave,murdoch,mullinax,mccary,mathieu,livengood,kyser,klink,kimes,kellner,kavanaugh,kasten,imes,hoey,hinshaw,hake,gurule,grube,grillo,geter,gatto,garver,garretson,farwell,eiland,dunford,decarlo,corso,colman,collard,cleghorn,chasteen,cavender,carlile,calvo,byerly,brogdon,broadwater,breault,bono,bergin,behr,ballenger,amick,tamez,stiffler,steinke,simmon,shankle,schaller,salmons,sackett,saad,rideout,ratcliffe,ranson,plascencia,petterson,olszewski,olney,olguin,nilsson,nevels,morelli,montiel,monge,michaelson,mertens,mcchesney,mcalpin,mathewson,loudermilk,lineberry,liggett,kinlaw,kight,jost,hereford,hardeman,halpern,halliday,hafer,gaul,friel,freitag,forsberg,evangelista,doering,dicarlo,dendy,delp,deguzman,dameron,curtiss,cosper,cauthen,bradberry,bouton,bonnell,bixby,bieber,beveridge,bedwell,barhorst,bannon,baltazar,baier,ayotte,attaway,arenas,abrego,turgeon,tunstall,thaxton,tenorio,stotts,sthilaire,shedd,seabolt,scalf,salyers,ruhl,rowlett,robinett,pfister,perlman,pepe,parkman,nunnally,norvell,napper,modlin,mckellar,mcclean,mascarenas,leibowitz,ledezma,kuhlman,kobayashi,hunley,holmquist,hinkley,hazard,hartsell,gribble,gravely,fifield,eliason,doak,crossland,carleton,bridgeman,bojorquez,boggess,auten,woosley,whiteley,wexler,twomey,tullis,townley,standridge,santoyo,rueda,riendeau,revell,pless,ottinger,nigro,nickles,mulvey,menefee,mcshane,mcloughlin,mckinzie,markey,lockridge,lipsey,knisley,knepper,kitts,kiel,jinks,hathcock,godin,gallego,fikes,fecteau,estabrook,ellinger,dunlop,dudek,countryman,chauvin,chatham,bullins,brownfield,boughton,bloodworth,bibb,baucom,barbieri,aubin,armitage,alessi,absher,abbate,zito,woolery,wiggs,wacker,tynes,tolle,telles,tarter,swarey,strode,stockdale,stalnaker,spina,schiff,saari,risley,rameriz,rakes,pettaway,penner,paulus,palladino,omeara,montelongo,melnick,mehta,mcgary,mccourt,mccollough,marchetti,manzanares,lowther,leiva,lauderdale,lafontaine,kowalczyk,knighton,joubert,jaworski,huth,hurdle,housley,hackman,gulick,gordy,gilstrap,gehrke,gebhart,gaudette,foxworth,endres,dunkle,cimino,caddell,brauer,braley,bodine,blackmore,belden,backer,ayer,andress,wisner,vuong,valliere,twigg,tavarez,strahan,steib,staub,sowder,seiber,schutt,scharf,schade,rodriques,risinger,renshaw,rahman,presnell,piatt,nieman,nevins,mcilwain,mcgaha,mccully,mccomb,massengale,macedo,lesher,kearse,jauregui,husted,hudnall,holmberg,hertel,hardie,glidewell,frausto,fassett,dalessandro,dahlgren,corum,constantino,conlin,colquitt,colombo,claycomb,cardin,buller,boney,bocanegra,biggers,benedetto,araiza,andino,albin,zorn,werth,weisman,walley,vanegas,ulibarri,towe,tedford,teasley,suttle,steffens,stcyr,squire,singley,sifuentes,shuck,schram,sass,rieger,ridenhour,rickert,richerson,rayborn,rabe,raab,pendley,pastore,ordway,moynihan,mellott,mckissick,mcgann,mccready,mauney,marrufo,lenhart,lazar,lafave,keele,kautz,jardine,jahnke,jacobo,hord,hardcastle,hageman,giglio,gehring,fortson,duque,duplessis,dicken,derosier,deitz,dalessio,cram,castleman,candelario,callison,caceres,bozarth,biles,bejarano,bashaw,avina,armentrout,alverez,acord,waterhouse,vereen,vanlandingham,strawser,shotwell,severance,seltzer,schoonmaker,schock,schaub,schaffner,roeder,rodrigez,riffe,rasberry,rancourt,railey,quade,pursley,prouty,perdomo,oxley,osterman,nickens,murphree,mounts,merida,maus,mattern,masse,martinelli,mangan,lutes,ludwick,loney,laureano,lasater,knighten,kissinger,kimsey,kessinger,honea,hollingshead,hockett,heyer,heron,gurrola,gove,glasscock,gillett,galan,featherstone,eckhardt,duron,dunson,dasher,culbreth,cowden,cowans,claypoole,churchwell,chabot,caviness,cater,caston,callan,byington,burkey,boden,beckford,atwater,archambault,alvey,alsup,whisenant,weese,voyles,verret,tsang,tessier,sweitzer,sherwin,shaughnessy,revis,remy,prine,philpott,peavy,paynter,parmenter,ovalle,offutt,nightingale,newlin,nakano,myatt,muth,mohan,mcmillon,mccarley,mccaleb,maxson,marinelli,maley,liston,letendre,kain,huntsman,hirst,hagerty,gulledge,greenway,grajeda,gorton,goines,gittens,frederickson,fanelli,embree,eichelberger,dunkin,dixson,dillow,defelice,chumley,burleigh,borkowski,binette,biggerstaff,berglund,beller,audet,arbuckle,allain,alfano,youngman,wittman,weintraub,vanzant,vaden,twitty,stollings,standifer,sines,shope,scalise,saville,posada,pisano,otte,nolasco,mier,merkle,mendiola,melcher,mejias,mcmurry,mccalla,markowitz,manis,mallette,macfarlane,lough,looper,landin,kittle,kinsella,kinnard,hobart,helman,hellman,hartsock,halford,hage,gordan,glasser,gayton,gattis,gastelum,gaspard,frisch,fitzhugh,eckstein,eberly,dowden,despain,crumpler,crotty,cornelison,chouinard,chamness,catlin,cann,bumgardner,budde,branum,bradfield,braddy,borst,birdwell,bazan,banas,bade,arango,ahearn,addis,zumwalt,wurth,wilk,widener,wagstaff,urrutia,terwilliger,tart,steinman,staats,sloat,rives,riggle,revels,reichard,prickett,poff,pitzer,petro,pell,northrup,nicks,moline,mielke,maynor,mallon,magness,lingle,lindell,lieb,lesko,lebeau,lammers,lafond,kiernan,ketron,jurado,holmgren,hilburn,hayashi,hashimoto,harbaugh,guillot,gard,froehlich,feinberg,falco,dufour,drees,doney,diep,delao,daves,dail,crowson,coss,congdon,carner,camarena,butterworth,burlingame,bouffard,bloch,bilyeu,barta,bakke,baillargeon,avent,aquilar,zeringue,yarber,wolfson,vogler,voelker,truss,troxell,thrift,strouse,spielman,sistrunk,sevigny,schuller,schaaf,ruffner,routh,roseman,ricciardi,peraza,pegram,overturf,olander,odaniel,millner,melchor,maroney,machuca,macaluso,livesay,layfield,laskowski,kwiatkowski,kilby,hovey,heywood,hayman,havard,harville,haigh,hagood,grieco,glassman,gebhardt,fleischer,fann,elson,eccles,cunha,crumb,blakley,bardwell,abshire,woodham,wines,welter,wargo,varnado,tutt,traynor,swaney,stricker,stoffel,stambaugh,sickler,shackleford,selman,seaver,sansom,sanmiguel,royston,rourke,rockett,rioux,puleo,pitchford,nardi,mulvaney,middaugh,malek,leos,lathan,kujawa,kimbro,killebrew,houlihan,hinckley,herod,hepler,hamner,hammel,hallowell,gonsalez,gingerich,gambill,funkhouser,fricke,fewell,falkner,endsley,dulin,drennen,deaver,dambrosio,chadwell,castanon,burkes,brune,brisco,brinker,bowker,boldt,berner,beaumont,beaird,bazemore,barrick,albano,younts,wunderlich,weidman,vanness,toland,theobald,stickler,steiger,stanger,spies,spector,sollars,smedley,seibel,scoville,saito,rummel,rowles,rouleau,roos,rogan,roemer,ream,raya,purkey,priester,perreira,penick,paulin,parkins,overcash,oleson,neves,muldrow,minard,midgett,michalak,melgar,mcentire,mcauliffe,marte,lydon,lindholm,leyba,langevin,lagasse,lafayette,kesler,kelton,kaminsky,jaggers,humbert,huck,howarth,hinrichs,higley,gupton,guimond,gravois,giguere,fretwell,fontes,feeley,faucher,eichhorn,ecker,earp,dole,dinger,derryberry,demars,deel,copenhaver,collinsworth,colangelo,cloyd,claiborne,caulfield,carlsen,calzada,caffey,broadus,brenneman,bouie,bodnar,blaney,blanc,beltz,behling,barahona,yockey,winkle,windom,wimer,villatoro,trexler,teran,taliaferro,sydnor,swinson,snelling,smtih,simonton,simoneaux,simoneau,sherrer,seavey,scheel,rushton,rupe,ruano,rippy,reiner,reiff,rabinowitz,quach,penley,odle,nock,minnich,mckown,mccarver,mcandrew,longley,laux,lamothe,lafreniere,kropp,krick,kates,jepson,huie,howse,howie,henriques,haydon,haught,hatter,hartzog,harkey,grimaldo,goshorn,gormley,gluck,gilroy,gillenwater,giffin,fluker,feder,eyre,eshelman,eakins,detwiler,delrosario,davisson,catalan,canning,calton,brammer,botelho,blakney,bartell,averett,askins,aker,witmer,winkelman,widmer,whittier,weitzel,wardell,wagers,ullman,tupper,tingley,tilghman,talton,simard,seda,scheller,sala,rundell,rost,ribeiro,rabideau,primm,pinon,peart,ostrom,ober,nystrom,nussbaum,naughton,murr,moorhead,monti,monteiro,melson,meissner,mclin,mcgruder,marotta,makowski,majewski,madewell,lunt,lukens,leininger,lebel,lakin,kepler,jaques,hunnicutt,hungerford,hoopes,hertz,heins,halliburton,grosso,gravitt,glasper,gallman,gallaway,funke,fulbright,falgout,eakin,dostie,dorado,dewberry,derose,cutshall,crampton,costanzo,colletti,cloninger,claytor,chiang,campagna,burd,brokaw,broaddus,bretz,brainard,binford,bilbrey,alpert,aitken,ahlers,zajac,woolfolk,witten,windle,wayland,tramel,tittle,talavera,suter,straley,specht,sommerville,soloman,skeens,sigman,sibert,shavers,schuck,schmit,sartain,sabol,rosenblatt,rollo,rashid,rabb,polston,nyberg,northrop,navarra,muldoon,mikesell,mcdougald,mcburney,mariscal,lozier,lingerfelt,legere,latour,lagunas,lacour,kurth,killen,kiely,kayser,kahle,isley,huertas,hower,hinz,haugh,gumm,galicia,fortunato,flake,dunleavy,duggins,doby,digiovanni,devaney,deltoro,cribb,corpuz,coronel,coen,charbonneau,caine,burchette,blakey,blakemore,bergquist,beene,beaudette,bayles,ballance,bakker,bailes,asberry,arwood,zucker,willman,whitesell,wald,walcott,vancleave,trump,strasser,simas,shick,schleicher,schaal,saleh,rotz,resnick,rainer,partee,ollis,oller,oday,noles,munday,mong,millican,merwin,mazzola,mansell,magallanes,llanes,lewellen,lepore,kisner,keesee,jeanlouis,ingham,hornbeck,hawn,hartz,harber,haffner,gutshall,guth,grays,gowan,finlay,finkelstein,eyler,enloe,dungan,diez,dearman,cull,crosson,chronister,cassity,campion,callihan,butz,breazeale,blumenthal,berkey,batty,batton,arvizu,alderete,aldana,albaugh,abernethy,wolter,wille,tweed,tollefson,thomasson,teter,testerman,sproul,spates,southwick,soukup,skelly,senter,sealey,sawicki,sargeant,rossiter,rosemond,repp,pifer,ormsby,nickelson,naumann,morabito,monzon,millsaps,millen,mcelrath,marcoux,mantooth,madson,macneil,mackinnon,louque,leister,lampley,kushner,krouse,kirwan,jessee,janson,jahn,jacquez,islas,hutt,holladay,hillyer,hepburn,hensel,harrold,gingrich,geis,gales,fults,finnell,ferri,featherston,epley,ebersole,eames,dunigan,drye,dismuke,devaughn,delorenzo,damiano,confer,collum,clower,clow,claussen,clack,caylor,cawthon,casias,carreno,bluhm,bingaman,bewley,belew,beckner,auld,amey,wolfenbarger,wilkey,wicklund,waltman,villalba,valero,valdovinos,ullrich,tyus,twyman,trost,tardif,tanguay,stripling,steinbach,shumpert,sasaki,sappington,sandusky,reinhold,reinert,quijano,placencia,pinkard,phinney,perrotta,pernell,parrett,oxendine,owensby,orman,nuno,mori,mcroberts,mcneese,mckamey,mccullum,markel,mardis,maines,lueck,lubin,lefler,leffler,larios,labarbera,kershner,josey,jeanbaptiste,izaguirre,hermosillo,haviland,hartshorn,hafner,ginter,getty,franck,fiske,dufrene,doody,davie,dangerfield,dahlberg,cuthbertson,crone,coffelt,chidester,chesson,cauley,caudell,cantara,campo,caines,bullis,bucci,brochu,bogard,bickerstaff,benning,arzola,antonelli,adkinson,zellers,wulf,worsley,woolridge,whitton,westerfield,walczak,vassar,truett,trueblood,trawick,townsley,topping,tobar,telford,steverson,stagg,sitton,sill,sergent,schoenfeld,sarabia,rutkowski,rubenstein,rigdon,prentiss,pomerleau,plumlee,philbrick,patnode,oloughlin,obregon,nuss,morell,mikell,mele,mcinerney,mcguigan,mcbrayer,lollar,kuehl,kinzer,kamp,joplin,jacobi,howells,holstein,hedden,hassler,harty,halle,greig,gouge,goodrum,gerhart,geier,geddes,gast,forehand,ferree,fendley,feltner,esqueda,encarnacion,eichler,egger,edmundson,eatmon,doud,donohoe,donelson,dilorenzo,digiacomo,diggins,delozier,dejong,danford,crippen,coppage,cogswell,clardy,cioffi,cabe,brunette,bresnahan,blomquist,blackstone,biller,bevis,bevan,bethune,benbow,baty,basinger,balcom,andes,aman,aguero,adkisson,yandell,wilds,whisenhunt,weigand,weeden,voight,villar,trottier,tillett,suazo,setser,scurry,schuh,schreck,schauer,samora,roane,rinker,reimers,ratchford,popovich,parkin,natal,melville,mcbryde,magdaleno,loehr,lockman,lingo,leduc,larocca,lamere,laclair,krall,korte,koger,jalbert,hughs,higbee,henton,heaney,haith,gump,greeson,goodloe,gholston,gasper,gagliardi,fregoso,farthing,fabrizio,ensor,elswick,elgin,eklund,eaddy,drouin,dorton,dizon,derouen,deherrera,davy,dampier,cullum,culley,cowgill,cardoso,cardinale,brodsky,broadbent,brimmer,briceno,branscum,bolyard,boley,bennington,beadle,baur,ballentine,azure,aultman,arciniega,aguila,aceves,yepez,woodrum,wethington,weissman,veloz,trusty,troup,trammel,tarpley,stivers,steck,sprayberry,spraggins,spitler,spiers,sohn,seagraves,schiffman,rudnick,rizo,riccio,rennie,quackenbush,puma,plott,pearcy,parada,paiz,munford,moskowitz,mease,mcnary,mccusker,lozoya,longmire,loesch,lasky,kuhlmann,krieg,koziol,kowalewski,konrad,kindle,jowers,jolin,jaco,horgan,hine,hileman,hepner,heise,heady,hawkinson,hannigan,haberman,guilford,grimaldi,garton,gagliano,fruge,follett,fiscus,ferretti,ebner,easterday,eanes,dirks,dimarco,depalma,deforest,cruce,craighead,christner,candler,cadwell,burchell,buettner,brinton,brazier,brannen,brame,bova,bomar,blakeslee,belknap,bangs,balzer,athey,armes,alvis,alverson,alvardo,yeung,wheelock,westlund,wessels,volkman,threadgill,thelen,tague,symons,swinford,sturtevant,straka,stier,stagner,segarra,seawright,rutan,roux,ringler,riker,ramsdell,quattlebaum,purifoy,poulson,permenter,peloquin,pasley,pagel,osman,obannon,nygaard,newcomer,munos,motta,meadors,mcquiston,mcniel,mcmann,mccrae,mayne,matte,legault,lechner,kucera,krohn,kratzer,koopman,jeske,horrocks,hock,hibbler,hesson,hersh,harvin,halvorsen,griner,grindle,gladstone,garofalo,frampton,forbis,eddington,diorio,dingus,dewar,desalvo,curcio,creasy,cortese,cordoba,connally,cluff,cascio,capuano,canaday,calabro,bussard,brayton,borja,bigley,arnone,arguelles,acuff,zamarripa,wooton,widner,wideman,threatt,thiele,templin,teeters,synder,swint,swick,sturges,stogner,stedman,spratt,siegfried,shetler,scull,savino,sather,rothwell,rook,rone,rhee,quevedo,privett,pouliot,poche,pickel,petrillo,pellegrini,peaslee,partlow,otey,nunnery,morelock,morello,meunier,messinger,mckie,mccubbin,mccarron,lerch,lavine,laverty,lariviere,lamkin,kugler,krol,kissel,keeter,hubble,hickox,hetzel,hayner,hagy,hadlock,groh,gottschalk,goodsell,gassaway,garrard,galligan,firth,fenderson,feinstein,etienne,engleman,emrick,ellender,drews,doiron,degraw,deegan,dart,crissman,corr,cookson,coil,cleaves,charest,chapple,chaparro,castano,carpio,byer,bufford,bridgewater,bridgers,brandes,borrero,bonanno,aube,ancheta,abarca,abad,wooster,wimbush,willhite,willams,wigley,weisberg,wardlaw,vigue,vanhook,unknow,torre,tasker,tarbox,strachan,slover,shamblin,semple,schuyler,schrimsher,sayer,salzman,rubalcava,riles,reneau,reichel,rayfield,rabon,pyatt,prindle,poss,polito,plemmons,pesce,perrault,pereyra,ostrowski,nilsen,niemeyer,munsey,mundell,moncada,miceli,meader,mcmasters,mckeehan,matsumoto,marron,marden,lizarraga,lingenfelter,lewallen,langan,lamanna,kovac,kinsler,kephart,keown,kass,kammerer,jeffreys,hysell,hosmer,hardnett,hanner,guyette,greening,glazer,ginder,fromm,fluellen,finkle,fessler,essary,eisele,duren,dittmer,crochet,cosentino,cogan,coelho,cavin,carrizales,campuzano,brough,bopp,bookman,bobb,blouin,beesley,battista,bascom,bakken,badgett,arneson,anselmo,albino,ahumada,woodyard,wolters,wireman,willison,warman,waldrup,vowell,vantassel,twombly,toomer,tennison,teets,tedeschi,swanner,stutz,stelly,sheehy,schermerhorn,scala,sandidge,salters,salo,saechao,roseboro,rolle,ressler,renz,renn,redford,raposa,rainbolt,pelfrey,orndorff,oney,nolin,nimmons,nardone,myhre,morman,menjivar,mcglone,mccammon,maxon,marciano,manus,lowrance,lorenzen,lonergan,lollis,littles,lindahl,lamas,lach,kuster,krawczyk,knuth,knecht,kirkendall,keitt,keever,kantor,jarboe,hoye,houchens,holter,holsinger,hickok,helwig,helgeson,hassett,harner,hamman,hames,hadfield,goree,goldfarb,gaughan,gaudreau,gantz,gallion,frady,foti,flesher,ferrin,faught,engram,donegan,desouza,degroot,cutright,crowl,criner,coan,clinkscales,chewning,chavira,catchings,carlock,bulger,buenrostro,bramblett,brack,boulware,bookout,bitner,birt,baranowski,baisden,allmon,acklin,yoakum,wilbourn,whisler,weinberger,washer,vasques,vanzandt,vanatta,troxler,tomes,tindle,tims,throckmorton,thach,stpeter,stlaurent,stenson,spry,spitz,songer,snavely,shroyer,shortridge,shenk,sevier,seabrook,scrivner,saltzman,rosenberry,rockwood,robeson,roan,reiser,ramires,raber,posner,popham,piotrowski,pinard,peterkin,pelham,peiffer,peay,nadler,musso,millett,mestas,mcgowen,marques,marasco,manriquez,manos,mair,lipps,leiker,krumm,knorr,kinslow,kessel,kendricks,kelm,irick,ickes,hurlburt,horta,hoekstra,heuer,helmuth,heatherly,hampson,hagar,haga,greenlaw,grau,godbey,gingras,gillies,gibb,gayden,gauvin,garrow,fontanez,florio,finke,fasano,ezzell,ewers,eveland,eckenrode,duclos,drumm,dimmick,delancey,defazio,dashiell,cusack,crowther,crigger,cray,coolidge,coldiron,cleland,chalfant,cassel,camire,cabrales,broomfield,brittingham,brisson,brickey,braziel,brazell,bragdon,boulanger,boman,bohannan,beem,barre,azar,ashbaugh,armistead,almazan,adamski,zendejas,winburn,willaims,wilhoit,westberry,wentzel,wendling,visser,vanscoy,vankirk,vallee,tweedy,thornberry,sweeny,spradling,spano,smelser,shim,sechrist,schall,scaife,rugg,rothrock,roesler,riehl,ridings,render,ransdell,radke,pinero,petree,pendergast,peluso,pecoraro,pascoe,panek,oshiro,navarrette,murguia,moores,moberg,michaelis,mcwhirter,mcsweeney,mcquade,mccay,mauk,mariani,marceau,mandeville,maeda,lunde,ludlow,loeb,lindo,linderman,leveille,leith,larock,lambrecht,kulp,kinsley,kimberlin,kesterson,hoyos,helfrich,hanke,grisby,goyette,gouveia,glazier,gile,gerena,gelinas,gasaway,funches,fujimoto,flynt,fenske,fellers,fehr,eslinger,escalera,enciso,duley,dittman,dineen,diller,devault,collings,clymer,clowers,chavers,charland,castorena,castello,camargo,bunce,bullen,boyes,borchers,borchardt,birnbaum,birdsall,billman,benites,bankhead,ange,ammerman,adkison,winegar,wickman,warr,warnke,villeneuve,veasey,vassallo,vannatta,vadnais,twilley,towery,tomblin,tippett,theiss,talkington,talamantes,swart,swanger,streit,stines,stabler,spurling,sobel,sine,simmers,shippy,shiflett,shearin,sauter,sanderlin,rusch,runkle,ruckman,rorie,roesch,richert,rehm,randel,ragin,quesenberry,puentes,plyler,plotkin,paugh,oshaughnessy,ohalloran,norsworthy,niemann,nader,moorefield,mooneyham,modica,miyamoto,mickel,mebane,mckinnie,mazurek,mancilla,lukas,lovins,loughlin,lotz,lindsley,liddle,levan,lederman,leclaire,lasseter,lapoint,lamoreaux,lafollette,kubiak,kirtley,keffer,kaczmarek,housman,hiers,hibbert,herrod,hegarty,hathorn,greenhaw,grafton,govea,futch,furst,franko,forcier,foran,flickinger,fairfield,eure,emrich,embrey,edgington,ecklund,eckard,durante,deyo,delvecchio,dade,currey,creswell,cottrill,casavant,cartier,cargile,capel,cammack,calfee,burse,burruss,brust,brousseau,bridwell,braaten,borkholder,bloomquist,bjork,bartelt,amburgey,yeary,whitefield,vinyard,vanvalkenburg,twitchell,timmins,tapper,stringham,starcher,spotts,slaugh,simonsen,sheffer,sequeira,rosati,rhymes,quint,pollak,peirce,patillo,parkerson,paiva,nilson,nevin,narcisse,mitton,merriam,merced,meiners,mckain,mcelveen,mcbeth,marsden,marez,manke,mahurin,mabrey,luper,krull,hunsicker,hornbuckle,holtzclaw,hinnant,heston,hering,hemenway,hegwood,hearns,halterman,guiterrez,grote,granillo,grainger,glasco,gilder,garren,garlock,garey,fryar,fredricks,fraizer,foshee,ferrel,felty,everitt,evens,esser,elkin,eberhart,durso,duguay,driskill,doster,dewall,deveau,demps,demaio,delreal,deleo,darrah,cumberbatch,culberson,cranmer,cordle,colgan,chesley,cavallo,castellon,castelli,carreras,carnell,carlucci,bontrager,blumberg,blasingame,becton,artrip,andujar,alkire,alder,zukowski,zuckerman,wroblewski,wrigley,woodside,wigginton,westman,westgate,werts,washam,wardlow,walser,waiters,tadlock,stringfield,stimpson,stickley,standish,spurlin,spindler,speller,spaeth,sotomayor,sluder,shryock,shepardson,shatley,scannell,santistevan,rosner,resto,reinhard,rathburn,prisco,poulsen,pinney,phares,pennock,pastrana,oviedo,ostler,nauman,mulford,moise,moberly,mirabal,metoyer,metheny,mentzer,meldrum,mcinturff,mcelyea,mcdougle,massaro,lumpkins,loveday,lofgren,lirette,lesperance,lefkowitz,ledger,lauzon,lachapelle,klassen,keough,kempton,kaelin,jeffords,hsieh,hoyer,horwitz,hoeft,hennig,haskin,gourdine,golightly,girouard,fulgham,fritsch,freer,frasher,foulk,firestone,fiorentino,fedor,ensley,englehart,eells,dunphy,donahoe,dileo,dibenedetto,dabrowski,crick,coonrod,conder,coddington,chunn,chaput,cerna,carreiro,calahan,braggs,bourdon,bollman,bittle,bauder,barreras,aubuchon,anzalone,adamo,zerbe,willcox,westberg,weikel,waymire,vroman,vinci,vallejos,truesdell,troutt,trotta,tollison,toles,tichenor,symonds,surles,strayer,stgeorge,sroka,sorrentino,solares,snelson,silvestri,sikorski,shawver,schumaker,schorr,schooley,scates,satterlee,satchell,rymer,roselli,robitaille,riegel,regis,reames,provenzano,priestley,plaisance,pettey,palomares,nowakowski,monette,minyard,mclamb,mchone,mccarroll,masson,magoon,maddy,lundin,licata,leonhardt,landwehr,kircher,kinch,karpinski,johannsen,hussain,houghtaling,hoskinson,hollaway,holeman,hobgood,hiebert,goggin,geissler,gadbois,gabaldon,fleshman,flannigan,fairman,eilers,dycus,dunmire,duffield,dowler,deloatch,dehaan,deemer,clayborn,christofferso,chilson,chesney,chatfield,carron,canale,brigman,branstetter,bosse,borton,bonar,biron,barroso,arispe,zacharias,zabel,yaeger,woolford,whetzel,weakley,veatch,vandeusen,tufts,troxel,troche,traver,townsel,talarico,swilley,sterrett,stenger,speakman,sowards,sours,souders,souder,soles,sobers,snoddy,smither,shute,shoaf,shahan,schuetz,scaggs,santini,rosson,rolen,robidoux,rentas,recio,pixley,pawlowski,pawlak,paull,overbey,orear,oliveri,oldenburg,nutting,naugle,mossman,misner,milazzo,michelson,mcentee,mccullar,mccree,mcaleer,mazzone,mandell,manahan,malott,maisonet,mailloux,lumley,lowrie,louviere,lipinski,lindemann,leppert,leasure,labarge,kubik,knisely,knepp,kenworthy,kennelly,kelch,kanter,houchin,hosley,hosler,hollon,holleman,heitman,haggins,gwaltney,goulding,gorden,geraci,gathers,frison,feagin,falconer,espada,erving,erikson,eisenhauer,ebeling,durgin,dowdle,dinwiddie,delcastillo,dedrick,crimmins,covell,cournoyer,coria,cohan,cataldo,carpentier,canas,campa,brode,brashears,blaser,bicknell,bednar,barwick,ascencio,althoff,almodovar,alamo,zirkle,zabala,wolverton,winebrenner,wetherell,westlake,wegener,weddington,tuten,trosclair,tressler,theroux,teske,swinehart,swensen,sundquist,southall,socha,sizer,silverberg,shortt,shimizu,sherrard,shaeffer,scheid,scheetz,saravia,sanner,rubinstein,rozell,romer,rheaume,reisinger,randles,pullum,petrella,payan,nordin,norcross,nicoletti,nicholes,newbold,nakagawa,monteith,milstead,milliner,mellen,mccardle,liptak,leitch,latimore,larrison,landau,laborde,koval,izquierdo,hymel,hoskin,holte,hoefer,hayworth,hausman,harrill,harrel,hardt,gully,groover,grinnell,greenspan,graver,grandberry,gorrell,goldenberg,goguen,gilleland,fuson,feldmann,everly,dyess,dunnigan,downie,dolby,deatherage,cosey,cheever,celaya,caver,cashion,caplinger,cansler,byrge,bruder,breuer,breslin,brazelton,botkin,bonneau,bondurant,bohanan,bogue,bodner,boatner,blatt,bickley,belliveau,beiler,beier,beckstead,bachmann,atkin,altizer,alloway,allaire,albro,abron,zellmer,yetter,yelverton,wiens,whidden,viramontes,vanwormer,tarantino,tanksley,sumlin,strauch,strang,stice,spahn,sosebee,sigala,shrout,seamon,schrum,schneck,schantz,ruddy,romig,roehl,renninger,reding,polak,pohlman,pasillas,oldfield,oldaker,ohanlon,ogilvie,norberg,nolette,neufeld,nellis,mummert,mulvihill,mullaney,monteleone,mendonca,meisner,mcmullan,mccluney,mattis,massengill,manfredi,luedtke,lounsbury,liberatore,lamphere,laforge,jourdan,iorio,iniguez,ikeda,hubler,hodgdon,hocking,heacock,haslam,haralson,hanshaw,hannum,hallam,haden,garnes,garces,gammage,gambino,finkel,faucett,ehrhardt,eggen,dusek,durrant,dubay,dones,depasquale,delucia,degraff,decamp,davalos,cullins,conard,clouser,clontz,cifuentes,chappel,chaffins,celis,carwile,byram,bruggeman,bressler,brathwaite,brasfield,bradburn,boose,bodie,blosser,bertsch,bernardi,bernabe,bengtson,barrette,astorga,alday,albee,abrahamson,yarnell,wiltse,wiebe,waguespack,vasser,upham,turek,traxler,torain,tomaszewski,tinnin,tiner,tindell,styron,stahlman,staab,skiba,sheperd,seidl,secor,schutte,sanfilippo,ruder,rondon,rearick,procter,prochaska,pettengill,pauly,neilsen,nally,mullenax,morano,meads,mcnaughton,mcmurtry,mcmath,mckinsey,matthes,massenburg,marlar,margolis,malin,magallon,mackin,lovette,loughran,loring,longstreet,loiselle,lenihan,kunze,koepke,kerwin,kalinowski,kagan,innis,innes,holtzman,heinemann,harshman,haider,haack,grondin,grissett,greenawalt,goudy,goodlett,goldston,gokey,gardea,galaviz,gafford,gabrielson,furlow,fritch,fordyce,folger,elizalde,ehlert,eckhoff,eccleston,ealey,dubin,diemer,deschamps,delapena,decicco,debolt,cullinan,crittendon,crase,cossey,coppock,coots,colyer,cluck,chamberland,burkhead,bumpus,buchan,borman,birkholz,berardi,benda,behnke,barter,amezquita,wotring,wirtz,wingert,wiesner,whitesides,weyant,wainscott,venezia,varnell,tussey,thurlow,tabares,stiver,stell,starke,stanhope,stanek,sisler,sinnott,siciliano,shehan,selph,seager,scurlock,scranton,santucci,santangelo,saltsman,rogge,rettig,renwick,reidy,reider,redfield,premo,parente,paolucci,palmquist,ohler,netherton,mutchler,morita,mistretta,minnis,middendorf,menzel,mendosa,mendelson,meaux,mcspadden,mcquaid,mcnatt,manigault,maney,mager,lukes,lopresti,liriano,letson,lechuga,lazenby,lauria,larimore,krupp,krupa,kopec,kinchen,kifer,kerney,kerner,kennison,kegley,karcher,justis,johson,jellison,janke,huskins,holzman,hinojos,hefley,hatmaker,harte,halloway,hallenbeck,goodwyn,glaspie,geise,fullwood,fryman,frakes,fraire,farrer,enlow,engen,ellzey,eckles,earles,dunkley,drinkard,dreiling,draeger,dinardo,dills,desroches,desantiago,curlee,crumbley,critchlow,coury,courtright,coffield,cleek,charpentier,cardone,caples,cantin,buntin,bugbee,brinkerhoff,brackin,bourland,blassingame,beacham,banning,auguste,andreasen,amann,almon,alejo,adelman,abston,yerger,wymer,woodberry,windley,whiteaker,westfield,weibel,wanner,waldrep,villani,vanarsdale,utterback,updike,triggs,topete,tolar,tigner,thoms,tauber,tarvin,tally,swiney,sweatman,studebaker,stennett,starrett,stannard,stalvey,sonnenberg,smithey,sieber,sickles,shinault,segars,sanger,salmeron,rothe,rizzi,restrepo,ralls,ragusa,quiroga,papenfuss,oropeza,okane,mudge,mozingo,molinaro,mcvicker,mcgarvey,mcfalls,mccraney,matus,magers,llanos,livermore,linehan,leitner,laymon,lawing,lacourse,kwong,kollar,kneeland,kennett,kellett,kangas,janzen,hutter,huling,hofmeister,hewes,harjo,habib,guice,grullon,greggs,grayer,granier,grable,gowdy,giannini,getchell,gartman,garnica,ganey,gallimore,fetters,fergerson,farlow,fagundes,exley,esteves,enders,edenfield,easterwood,drakeford,dipasquale,desousa,deshields,deeter,dedmon,debord,daughtery,cutts,courtemanche,coursey,copple,coomes,collis,cogburn,clopton,choquette,chaidez,castrejon,calhoon,burbach,bulloch,buchman,bruhn,bohon,blough,baynes,barstow,zeman,zackery,yardley,yamashita,wulff,wilken,wiliams,wickersham,wible,whipkey,wedgeworth,walmsley,walkup,vreeland,verrill,umana,traub,swingle,summey,stroupe,stockstill,steffey,stefanski,statler,stapp,speights,solari,soderberg,shunk,shorey,shewmaker,sheilds,schiffer,schank,schaff,sagers,rochon,riser,rickett,reale,raglin,polen,plata,pitcock,percival,palen,orona,oberle,nocera,navas,nault,mullings,montejano,monreal,minick,middlebrook,meece,mcmillion,mccullen,mauck,marshburn,maillet,mahaney,magner,maclin,lucey,litteral,lippincott,leite,leaks,lamarre,jurgens,jerkins,jager,hurwitz,hughley,hotaling,horstman,hohman,hocker,hively,hipps,hessler,hermanson,hepworth,helland,hedlund,harkless,haigler,gutierez,grindstaff,glantz,giardina,gerken,gadsden,finnerty,farnum,encinas,drakes,dennie,cutlip,curtsinger,couto,cortinas,corby,chiasson,carle,carballo,brindle,borum,bober,blagg,berthiaume,beahm,batres,basnight,backes,axtell,atterberry,alvares,alegria,woodell,wojciechowski,winfree,winbush,wiest,wesner,wamsley,wakeman,verner,truex,trafton,toman,thorsen,theus,tellier,tallant,szeto,strope,stills,simkins,shuey,shaul,servin,serio,serafin,salguero,ryerson,rudder,ruark,rother,rohrbaugh,rohrbach,rohan,rogerson,risher,reeser,pryce,prokop,prins,priebe,prejean,pinheiro,petrone,petri,penson,pearlman,parikh,natoli,murakami,mullikin,mullane,motes,morningstar,mcveigh,mcgrady,mcgaughey,mccurley,marchan,manske,lusby,linde,likens,licon,leroux,lemaire,legette,laskey,laprade,laplant,kolar,kittredge,kinley,kerber,kanagy,jetton,janik,ippolito,inouye,hunsinger,howley,howery,horrell,holthaus,hiner,hilson,hilderbrand,hartzler,harnish,harada,hansford,halligan,hagedorn,gwynn,gudino,greenstein,greear,gracey,goudeau,goodner,ginsburg,gerth,gerner,fujii,frier,frenette,folmar,fleisher,fleischmann,fetzer,eisenman,earhart,dupuy,dunkelberger,drexler,dillinger,dilbeck,dewald,demby,deford,craine,chesnut,casady,carstens,carrick,carino,carignan,canchola,bushong,burman,buono,brownlow,broach,britten,brickhouse,boyden,boulton,borland,bohrer,blubaugh,bever,berggren,benevides,arocho,arends,amezcua,almendarez,zalewski,witzel,winkfield,wilhoite,vangundy,vanfleet,vanetten,vandergriff,urbanski,troiano,thibodaux,straus,stoneking,stjean,stillings,stange,speicher,speegle,smeltzer,slawson,simmonds,shuttleworth,serpa,senger,seidman,schweiger,schloss,schimmel,schechter,sayler,sabatini,ronan,rodiguez,riggleman,richins,reamer,prunty,porath,plunk,piland,philbrook,pettitt,perna,peralez,pascale,padula,oboyle,nivens,nickols,mundt,munden,montijo,mcmanis,mcgrane,mccrimmon,manzi,mangold,malick,mahar,maddock,losey,litten,leedy,leavell,ladue,krahn,kluge,junker,iversen,imler,hurtt,huizar,hubbert,howington,hollomon,holdren,hoisington,heiden,hauge,hartigan,gutirrez,griffie,greenhill,gratton,granata,gottfried,gertz,gautreaux,furry,furey,funderburg,flippen,fitzgibbon,drucker,donoghue,dildy,devers,detweiler,despres,denby,degeorge,cueto,cranston,courville,clukey,cirillo,chivers,caudillo,butera,bulluck,buckmaster,braunstein,bracamonte,bourdeau,bonnette".split(","),
  us_tv_and_film: "you,i,to,that,it,me,what,this,know,i'm,no,have,my,don't,just,not,do,be,your,we,it's,so,but,all,well,oh,about,right,you're,get,here,out,going,like,yeah,if,can,up,want,think,that's,now,go,him,how,got,did,why,see,come,good,really,look,will,okay,back,can't,mean,tell,i'll,hey,he's,could,didn't,yes,something,because,say,take,way,little,make,need,gonna,never,we're,too,she's,i've,sure,our,sorry,what's,let,thing,maybe,down,man,very,there's,should,anything,said,much,any,even,off,please,doing,thank,give,thought,help,talk,god,still,wait,find,nothing,again,things,let's,doesn't,call,told,great,better,ever,night,away,believe,feel,everything,you've,fine,last,keep,does,put,around,stop,they're,i'd,guy,isn't,always,listen,wanted,guys,huh,those,big,lot,happened,thanks,won't,trying,kind,wrong,talking,guess,care,bad,mom,remember,getting,we'll,together,dad,leave,understand,wouldn't,actually,hear,baby,nice,father,else,stay,done,wasn't,course,might,mind,every,enough,try,hell,came,someone,you'll,whole,yourself,idea,ask,must,coming,looking,woman,room,knew,tonight,real,son,hope,went,hmm,happy,pretty,saw,girl,sir,friend,already,saying,next,job,problem,minute,thinking,haven't,heard,honey,matter,myself,couldn't,exactly,having,probably,happen,we've,hurt,boy,dead,gotta,alone,excuse,start,kill,hard,you'd,today,car,ready,without,wants,hold,wanna,yet,seen,deal,once,gone,morning,supposed,friends,head,stuff,worry,live,truth,face,forget,true,cause,soon,knows,telling,wife,who's,chance,run,move,anyone,person,bye,somebody,heart,miss,making,meet,anyway,phone,reason,damn,lost,looks,bring,case,turn,wish,tomorrow,kids,trust,check,change,anymore,least,aren't,working,makes,taking,means,brother,hate,ago,says,beautiful,gave,fact,crazy,sit,afraid,important,rest,fun,kid,word,watch,glad,everyone,sister,minutes,everybody,bit,couple,whoa,either,mrs,feeling,daughter,wow,gets,asked,break,promise,door,close,hand,easy,question,tried,far,walk,needs,mine,killed,hospital,anybody,alright,wedding,shut,able,die,perfect,stand,comes,hit,waiting,dinner,funny,husband,almost,pay,answer,cool,eyes,news,child,shouldn't,yours,moment,sleep,read,where's,sounds,sonny,pick,sometimes,bed,date,plan,hours,lose,hands,serious,shit,behind,inside,ahead,week,wonderful,fight,past,cut,quite,he'll,sick,it'll,eat,nobody,goes,save,seems,finally,lives,worried,upset,carly,met,brought,seem,sort,safe,weren't,leaving,front,shot,loved,asking,running,clear,figure,hot,felt,parents,drink,absolutely,how's,daddy,sweet,alive,sense,meant,happens,bet,blood,ain't,kidding,lie,meeting,dear,seeing,sound,fault,ten,buy,hour,speak,lady,jen,thinks,christmas,outside,hang,possible,worse,mistake,ooh,handle,spend,totally,giving,here's,marriage,realize,unless,sex,send,needed,scared,picture,talked,ass,hundred,changed,completely,explain,certainly,sign,boys,relationship,loves,hair,lying,choice,anywhere,future,weird,luck,she'll,turned,touch,kiss,crane,questions,obviously,wonder,pain,calling,somewhere,throw,straight,cold,fast,words,food,none,drive,feelings,they'll,marry,drop,cannot,dream,protect,twenty,surprise,sweetheart,poor,looked,mad,except,gun,y'know,dance,takes,appreciate,especially,situation,besides,pull,hasn't,worth,sheridan,amazing,expect,swear,piece,busy,happening,movie,we'd,catch,perhaps,step,fall,watching,kept,darling,dog,honor,moving,till,admit,problems,murder,he'd,evil,definitely,feels,honest,eye,broke,missed,longer,dollars,tired,evening,starting,entire,trip,niles,suppose,calm,imagine,fair,caught,blame,sitting,favor,apartment,terrible,clean,learn,frasier,relax,accident,wake,prove,smart,message,missing,forgot,interested,table,nbsp,mouth,pregnant,ring,careful,shall,dude,ride,figured,wear,shoot,stick,follow,angry,write,stopped,ran,standing,forgive,jail,wearing,ladies,kinda,lunch,cristian,greenlee,gotten,hoping,phoebe,thousand,ridge,paper,tough,tape,count,boyfriend,proud,agree,birthday,they've,share,offer,hurry,feet,wondering,decision,ones,finish,voice,herself,would've,mess,deserve,evidence,cute,dress,interesting,hotel,enjoy,quiet,concerned,staying,beat,sweetie,mention,clothes,fell,neither,mmm,fix,respect,prison,attention,holding,calls,surprised,bar,keeping,gift,hadn't,putting,dark,owe,ice,helping,normal,aunt,lawyer,apart,plans,jax,girlfriend,floor,whether,everything's,box,judge,upstairs,sake,mommy,possibly,worst,acting,accept,blow,strange,saved,conversation,plane,mama,yesterday,lied,quick,lately,stuck,difference,store,she'd,bought,doubt,listening,walking,cops,deep,dangerous,buffy,sleeping,chloe,rafe,join,card,crime,gentlemen,willing,window,walked,guilty,likes,fighting,difficult,soul,joke,favorite,uncle,promised,bother,seriously,cell,knowing,broken,advice,somehow,paid,losing,push,helped,killing,boss,liked,innocent,rules,learned,thirty,risk,letting,speaking,ridiculous,afternoon,apologize,nervous,charge,patient,boat,how'd,hide,detective,planning,huge,breakfast,horrible,awful,pleasure,driving,hanging,picked,sell,quit,apparently,dying,notice,congratulations,visit,could've,c'mon,letter,decide,forward,fool,showed,smell,seemed,spell,memory,pictures,slow,seconds,hungry,hearing,kitchen,ma'am,should've,realized,kick,grab,discuss,fifty,reading,idiot,suddenly,agent,destroy,bucks,shoes,peace,arms,demon,livvie,consider,papers,incredible,witch,drunk,attorney,tells,knock,ways,gives,nose,skye,turns,keeps,jealous,drug,sooner,cares,plenty,extra,outta,weekend,matters,gosh,opportunity,impossible,waste,pretend,jump,eating,proof,slept,arrest,breathe,perfectly,warm,pulled,twice,easier,goin,dating,suit,romantic,drugs,comfortable,finds,checked,divorce,begin,ourselves,closer,ruin,smile,laugh,treat,fear,what'd,otherwise,excited,mail,hiding,stole,pacey,noticed,fired,excellent,bringing,bottom,note,sudden,bathroom,honestly,sing,foot,remind,charges,witness,finding,tree,dare,hardly,that'll,steal,silly,contact,teach,shop,plus,colonel,fresh,trial,invited,roll,reach,dirty,choose,emergency,dropped,butt,credit,obvious,locked,loving,nuts,agreed,prue,goodbye,condition,guard,fuckin,grow,cake,mood,crap,crying,belong,partner,trick,pressure,dressed,taste,neck,nurse,raise,lots,carry,whoever,drinking,they'd,breaking,file,lock,wine,spot,paying,assume,asleep,turning,viki,bedroom,shower,nikolas,camera,fill,reasons,forty,bigger,nope,breath,doctors,pants,freak,movies,folks,cream,wild,truly,desk,convince,client,threw,hurts,spending,answers,shirt,chair,rough,doin,sees,ought,empty,wind,aware,dealing,pack,tight,hurting,guest,arrested,salem,confused,surgery,expecting,deacon,unfortunately,goddamn,bottle,beyond,whenever,pool,opinion,starts,jerk,secrets,falling,necessary,barely,dancing,tests,copy,cousin,ahem,twelve,tess,skin,fifteen,speech,orders,complicated,nowhere,escape,biggest,restaurant,grateful,usual,burn,address,someplace,screw,everywhere,regret,goodness,mistakes,details,responsibility,suspect,corner,hero,dumb,terrific,whoo,hole,memories,o'clock,teeth,ruined,bite,stenbeck,liar,showing,cards,desperate,search,pathetic,spoke,scare,marah,afford,settle,stayed,checking,hired,heads,concern,blew,alcazar,champagne,connection,tickets,happiness,saving,kissing,hated,personally,suggest,prepared,onto,downstairs,ticket,it'd,loose,holy,duty,convinced,throwing,kissed,legs,loud,saturday,babies,where'd,warning,miracle,carrying,blind,ugly,shopping,hates,sight,bride,coat,clearly,celebrate,brilliant,wanting,forrester,lips,custody,screwed,buying,toast,thoughts,reality,lexie,attitude,advantage,grandfather,sami,grandma,someday,roof,marrying,powerful,grown,grandmother,fake,must've,ideas,exciting,familiar,bomb,bout,harmony,schedule,capable,practically,correct,clue,forgotten,appointment,deserves,threat,bloody,lonely,shame,jacket,hook,scary,investigation,invite,shooting,lesson,criminal,victim,funeral,considering,burning,strength,harder,sisters,pushed,shock,pushing,heat,chocolate,miserable,corinthos,nightmare,brings,zander,crash,chances,sending,recognize,healthy,boring,feed,engaged,headed,treated,knife,drag,badly,hire,paint,pardon,behavior,closet,warn,gorgeous,milk,survive,ends,dump,rent,remembered,thanksgiving,rain,revenge,prefer,spare,pray,disappeared,aside,statement,sometime,meat,fantastic,breathing,laughing,stood,affair,ours,depends,protecting,jury,brave,fingers,murdered,explanation,picking,blah,stronger,handsome,unbelievable,anytime,shake,oakdale,wherever,pulling,facts,waited,lousy,circumstances,disappointed,weak,trusted,license,nothin,trash,understanding,slip,sounded,awake,friendship,stomach,weapon,threatened,mystery,vegas,understood,basically,switch,frankly,cheap,lifetime,deny,clock,garbage,why'd,tear,ears,indeed,changing,singing,tiny,decent,avoid,messed,filled,touched,disappear,exact,pills,kicked,harm,fortune,pretending,insurance,fancy,drove,cared,belongs,nights,lorelai,lift,timing,guarantee,chest,woke,burned,watched,heading,selfish,drinks,doll,committed,elevator,freeze,noise,wasting,ceremony,uncomfortable,staring,files,bike,stress,permission,thrown,possibility,borrow,fabulous,doors,screaming,bone,xander,what're,meal,apology,anger,honeymoon,bail,parking,fixed,wash,stolen,sensitive,stealing,photo,chose,lets,comfort,worrying,pocket,mateo,bleeding,shoulder,ignore,talent,tied,garage,dies,demons,dumped,witches,rude,crack,bothering,radar,soft,meantime,gimme,kinds,fate,concentrate,throat,prom,messages,intend,ashamed,somethin,manage,guilt,interrupt,guts,tongue,shoe,basement,sentence,purse,glasses,cabin,universe,repeat,mirror,wound,travers,tall,engagement,therapy,emotional,jeez,decisions,soup,thrilled,stake,chef,moves,extremely,moments,expensive,counting,shots,kidnapped,cleaning,shift,plate,impressed,smells,trapped,aidan,knocked,charming,attractive,argue,puts,whip,embarrassed,package,hitting,bust,stairs,alarm,pure,nail,nerve,incredibly,walks,dirt,stamp,terribly,friendly,damned,jobs,suffering,disgusting,stopping,deliver,riding,helps,disaster,bars,crossed,trap,talks,eggs,chick,threatening,spoken,introduce,confession,embarrassing,bags,impression,gate,reputation,presents,chat,suffer,argument,talkin,crowd,homework,coincidence,cancel,pride,solve,hopefully,pounds,pine,mate,illegal,generous,outfit,maid,bath,punch,freaked,begging,recall,enjoying,prepare,wheel,defend,signs,painful,yourselves,maris,that'd,suspicious,cooking,button,warned,sixty,pity,yelling,awhile,confidence,offering,pleased,panic,hers,gettin,refuse,grandpa,testify,choices,cruel,mental,gentleman,coma,cutting,proteus,guests,expert,benefit,faces,jumped,toilet,sneak,halloween,privacy,smoking,reminds,twins,swing,solid,options,commitment,crush,ambulance,wallet,gang,eleven,option,laundry,assure,stays,skip,fail,discussion,clinic,betrayed,sticking,bored,mansion,soda,sheriff,suite,handled,busted,load,happier,studying,romance,procedure,commit,assignment,suicide,minds,swim,yell,llanview,chasing,proper,believes,humor,hopes,lawyers,giant,latest,escaped,parent,tricks,insist,dropping,cheer,medication,flesh,routine,sandwich,handed,false,beating,warrant,awfully,odds,treating,thin,suggesting,fever,sweat,silent,clever,sweater,mall,sharing,assuming,judgment,goodnight,divorced,surely,steps,confess,math,listened,comin,answered,vulnerable,bless,dreaming,chip,zero,pissed,nate,kills,tears,knees,chill,brains,unusual,packed,dreamed,cure,lookin,grave,cheating,breaks,locker,gifts,awkward,thursday,joking,reasonable,dozen,curse,quartermaine,millions,dessert,rolling,detail,alien,delicious,closing,vampires,wore,tail,secure,salad,murderer,spit,offense,dust,conscience,bread,answering,lame,invitation,grief,smiling,pregnancy,prisoner,delivery,guards,virus,shrink,freezing,wreck,massimo,wire,technically,blown,anxious,cave,holidays,cleared,wishes,caring,candles,bound,charm,pulse,jumping,jokes,boom,occasion,silence,nonsense,frightened,slipped,dimera,blowing,relationships,kidnapping,spin,tool,roxy,packing,blaming,wrap,obsessed,fruit,torture,personality,there'll,fairy,necessarily,seventy,print,motel,underwear,grams,exhausted,believing,freaking,carefully,trace,touching,messing,recovery,intention,consequences,belt,sacrifice,courage,enjoyed,attracted,remove,testimony,intense,heal,defending,unfair,relieved,loyal,slowly,buzz,alcohol,surprises,psychiatrist,plain,attic,who'd,uniform,terrified,cleaned,zach,threaten,fella,enemies,satisfied,imagination,hooked,headache,forgetting,counselor,andie,acted,badge,naturally,frozen,sakes,appropriate,trunk,dunno,costume,sixteen,impressive,kicking,junk,grabbed,understands,describe,clients,owns,affect,witnesses,starving,instincts,happily,discussing,deserved,strangers,surveillance,admire,questioning,dragged,barn,deeply,wrapped,wasted,tense,hoped,fellas,roommate,mortal,fascinating,stops,arrangements,agenda,literally,propose,honesty,underneath,sauce,promises,lecture,eighty,torn,shocked,backup,differently,ninety,deck,biological,pheebs,ease,creep,waitress,telephone,ripped,raising,scratch,rings,prints,thee,arguing,ephram,asks,oops,diner,annoying,taggert,sergeant,blast,towel,clown,habit,creature,bermuda,snap,react,paranoid,handling,eaten,therapist,comment,sink,reporter,nurses,beats,priority,interrupting,warehouse,loyalty,inspector,pleasant,excuses,threats,guessing,tend,praying,motive,unconscious,mysterious,unhappy,tone,switched,rappaport,sookie,neighbor,loaded,swore,piss,balance,toss,misery,thief,squeeze,lobby,goa'uld,geez,exercise,forth,booked,sandburg,poker,eighteen,d'you,bury,everyday,digging,creepy,wondered,liver,hmmm,magical,fits,discussed,moral,helpful,searching,flew,depressed,aisle,cris,amen,vows,neighbors,darn,cents,arrange,annulment,useless,adventure,resist,fourteen,celebrating,inch,debt,violent,sand,teal'c,celebration,reminded,phones,paperwork,emotions,stubborn,pound,tension,stroke,steady,overnight,chips,beef,suits,boxes,cassadine,collect,tragedy,spoil,realm,wipe,surgeon,stretch,stepped,nephew,neat,limo,confident,perspective,climb,punishment,finest,springfield,hint,furniture,blanket,twist,proceed,fries,worries,niece,gloves,soap,signature,disappoint,crawl,convicted,flip,counsel,doubts,crimes,accusing,shaking,remembering,hallway,halfway,bothered,madam,gather,cameras,blackmail,symptoms,rope,ordinary,imagined,cigarette,supportive,explosion,trauma,ouch,furious,cheat,avoiding,whew,thick,oooh,boarding,approve,urgent,shhh,misunderstanding,drawer,phony,interfere,catching,bargain,tragic,respond,punish,penthouse,thou,rach,ohhh,insult,bugs,beside,begged,absolute,strictly,socks,senses,sneaking,reward,polite,checks,tale,physically,instructions,fooled,blows,tabby,bitter,adorable,y'all,tested,suggestion,jewelry,alike,jacks,distracted,shelter,lessons,constable,circus,audition,tune,shoulders,mask,helpless,feeding,explains,sucked,robbery,objection,behave,valuable,shadows,courtroom,confusing,talented,smarter,mistaken,customer,bizarre,scaring,motherfucker,alert,vecchio,reverend,foolish,compliment,bastards,worker,wheelchair,protective,gentle,reverse,picnic,knee,cage,wives,wednesday,voices,toes,stink,scares,pour,cheated,slide,ruining,filling,exit,cottage,upside,proves,parked,diary,complaining,confessed,pipe,merely,massage,chop,spill,prayer,betray,waiter,scam,rats,fraud,brush,tables,sympathy,pill,filthy,seventeen,employee,bracelet,pays,fairly,deeper,arrive,tracking,spite,shed,recommend,oughta,nanny,menu,diet,corn,roses,patch,dime,devastated,subtle,bullets,beans,pile,confirm,strings,parade,borrowed,toys,straighten,steak,premonition,planted,honored,exam,convenient,traveling,laying,insisted,dish,aitoro,kindly,grandson,donor,temper,teenager,proven,mothers,denial,backwards,tent,swell,noon,happiest,drives,thinkin,spirits,potion,holes,fence,whatsoever,rehearsal,overheard,lemme,hostage,bench,tryin,taxi,shove,moron,impress,needle,intelligent,instant,disagree,stinks,rianna,recover,groom,gesture,constantly,bartender,suspects,sealed,legally,hears,dresses,sheet,psychic,teenage,knocking,judging,accidentally,waking,rumor,manners,homeless,hollow,desperately,tapes,referring,item,genoa,gear,majesty,cried,tons,spells,instinct,quote,motorcycle,convincing,fashioned,aids,accomplished,grip,bump,upsetting,needing,invisible,forgiveness,feds,compare,bothers,tooth,inviting,earn,compromise,cocktail,tramp,jabot,intimate,dignity,dealt,souls,informed,gods,dressing,cigarettes,alistair,leak,fond,corky,seduce,liquor,fingerprints,enchantment,butters,stuffed,stavros,emotionally,transplant,tips,oxygen,nicely,lunatic,drill,complain,announcement,unfortunate,slap,prayers,plug,opens,oath,o'neill,mutual,yacht,remembers,fried,extraordinary,bait,warton,sworn,stare,safely,reunion,burst,might've,dive,aboard,expose,buddies,trusting,booze,sweep,sore,scudder,properly,parole,ditch,canceled,speaks,glow,wears,thirsty,skull,ringing,dorm,dining,bend,unexpected,pancakes,harsh,flattered,ahhh,troubles,fights,favourite,eats,rage,undercover,spoiled,sloane,shine,destroying,deliberately,conspiracy,thoughtful,sandwiches,plates,nails,miracles,fridge,drank,contrary,beloved,allergic,washed,stalking,solved,sack,misses,forgiven,bent,maciver,involve,dragging,cooked,pointing,foul,dull,beneath,heels,faking,deaf,stunt,jealousy,hopeless,fears,cuts,scenario,necklace,crashed,accuse,restraining,homicide,helicopter,firing,safer,auction,videotape,tore,reservations,pops,appetite,wounds,vanquish,ironic,fathers,excitement,anyhow,tearing,sends,rape,laughed,belly,dealer,cooperate,accomplish,wakes,spotted,sorts,reservation,ashes,tastes,supposedly,loft,intentions,integrity,wished,towels,suspected,investigating,inappropriate,lipstick,lawn,compassion,cafeteria,scarf,precisely,obsession,loses,lighten,infection,granddaughter,explode,balcony,this'll,spying,publicity,depend,cracked,conscious,ally,absurd,vicious,invented,forbid,directions,defendant,bare,announce,screwing,salesman,robbed,leap,lakeview,insanity,reveal,possibilities,kidnap,gown,chairs,wishing,setup,punished,criminals,regrets,raped,quarters,lamp,dentist,anyways,anonymous,semester,risks,owes,lungs,explaining,delicate,tricked,eager,doomed,adoption,stab,sickness,scum,floating,envelope,vault,sorel,pretended,potatoes,plea,photograph,payback,misunderstood,kiddo,healing,cascade,capeside,stabbed,remarkable,brat,privilege,passionate,nerves,lawsuit,kidney,disturbed,cozy,tire,shirts,oven,ordering,delay,risky,monsters,honorable,grounded,closest,breakdown,bald,abandon,scar,collar,worthless,sucking,enormous,disturbing,disturb,distract,deals,conclusions,vodka,dishes,crawling,briefcase,wiped,whistle,sits,roast,rented,pigs,flirting,deposit,bottles,topic,riot,overreacting,logical,hostile,embarrass,casual,beacon,amusing,altar,claus,survival,skirt,shave,porch,ghosts,favors,drops,dizzy,chili,advise,strikes,rehab,photographer,peaceful,leery,heavens,fortunately,fooling,expectations,cigar,weakness,ranch,practicing,examine,cranes,bribe,sail,prescription,hush,fragile,forensics,expense,drugged,cows,bells,visitor,suitcase,sorta,scan,manticore,insecure,imagining,hardest,clerk,wrist,what'll,starters,silk,pump,pale,nicer,haul,flies,boot,thumb,there'd,how're,elders,quietly,pulls,idiots,erase,denying,ankle,amnesia,accepting,heartbeat,devane,confront,minus,legitimate,fixing,arrogant,tuna,supper,slightest,sins,sayin,recipe,pier,paternity,humiliating,genuine,snack,rational,minded,guessed,weddings,tumor,humiliated,aspirin,spray,picks,eyed,drowning,contacts,ritual,perfume,hiring,hating,docks,creatures,visions,thanking,thankful,sock,nineteen,fork,throws,teenagers,stressed,slice,rolls,plead,ladder,kicks,detectives,assured,tellin,shallow,responsibilities,repay,howdy,girlfriends,deadly,comforting,ceiling,verdict,insensitive,spilled,respected,messy,interrupted,halliwell,blond,bleed,wardrobe,takin,murders,backs,underestimate,justify,harmless,frustrated,fold,enzo,communicate,bugging,arson,whack,salary,rumors,obligation,liking,dearest,congratulate,vengeance,rack,puzzle,fires,courtesy,caller,blamed,tops,quiz,prep,curiosity,circles,barbecue,sunnydale,spinning,psychotic,cough,accusations,resent,laughs,freshman,envy,drown,bartlet,asses,sofa,poster,highness,dock,apologies,theirs,stat,stall,realizes,psych,mmmm,fools,understandable,treats,succeed,stir,relaxed,makin,gratitude,faithful,accent,witter,wandering,locate,inevitable,gretel,deed,crushed,controlling,smelled,robe,gossip,gambling,cosmetics,accidents,surprising,stiff,sincere,rushed,refrigerator,preparing,nightmares,mijo,ignoring,hunch,fireworks,drowned,brass,whispering,sophisticated,luggage,hike,explore,emotion,crashing,contacted,complications,shining,rolled,righteous,reconsider,goody,geek,frightening,ethics,creeps,courthouse,camping,affection,smythe,haircut,essay,baked,apologized,vibe,respects,receipt,mami,hats,destructive,adore,adopt,tracked,shorts,reminding,dough,creations,cabot,barrel,snuck,slight,reporters,pressing,magnificent,madame,lazy,glorious,fiancee,bits,visitation,sane,kindness,shoulda,rescued,mattress,lounge,lifted,importantly,glove,enterprises,disappointment,condo,beings,admitting,yelled,waving,spoon,screech,satisfaction,reads,nailed,worm,tick,resting,marvelous,fuss,cortlandt,chased,pockets,luckily,lilith,filing,conversations,consideration,consciousness,worlds,innocence,forehead,aggressive,trailer,slam,quitting,inform,delighted,daylight,danced,confidential,aunts,washing,tossed,spectra,marrow,lined,implying,hatred,grill,corpse,clues,sober,offended,morgue,infected,humanity,distraction,cart,wired,violation,promising,harassment,glue,d'angelo,cursed,brutal,warlocks,wagon,unpleasant,proving,priorities,mustn't,lease,flame,disappearance,depressing,thrill,sitter,ribs,flush,earrings,deadline,corporal,collapsed,update,snapped,smack,melt,figuring,delusional,coulda,burnt,tender,sperm,realise,pork,popped,interrogation,esteem,choosing,undo,pres,prayed,plague,manipulate,insulting,detention,delightful,coffeehouse,betrayal,apologizing,adjust,wrecked,wont,whipped,rides,reminder,monsieur,faint,bake,distress,correctly,complaint,blocked,tortured,risking,pointless,handing,dumping,cups,alibi,struggling,shiny,risked,mummy,mint,hose,hobby,fortunate,fleischman,fitting,curtain,counseling,rode,puppet,modeling,memo,irresponsible,humiliation,hiya,freakin,felony,choke,blackmailing,appreciated,tabloid,suspicion,recovering,pledge,panicked,nursery,louder,jeans,investigator,homecoming,frustrating,buys,busting,buff,sleeve,irony,dope,declare,autopsy,workin,torch,prick,limb,hysterical,goddamnit,fetch,dimension,crowded,clip,climbing,bonding,woah,trusts,negotiate,lethal,iced,fantasies,deeds,bore,babysitter,questioned,outrageous,kiriakis,insulted,grudge,driveway,deserted,definite,beep,wires,suggestions,searched,owed,lend,drunken,demanding,costanza,conviction,bumped,weigh,touches,tempted,shout,resolve,relate,poisoned,meals,invitations,haunted,bogus,autograph,affects,tolerate,stepping,spontaneous,sleeps,probation,manny,fist,spectacular,hostages,heroin,havin,habits,encouraging,consult,burgers,boyfriends,bailed,baggage,watches,troubled,torturing,teasing,sweetest,qualities,postpone,overwhelmed,malkovich,impulse,classy,charging,amazed,policeman,hypocrite,humiliate,hideous,d'ya,costumes,bluffing,betting,bein,bedtime,alcoholic,vegetable,tray,suspicions,spreading,splendid,shrimp,shouting,pressed,nooo,grieving,gladly,fling,eliminate,cereal,aaah,sonofabitch,paralyzed,lotta,locks,guaranteed,dummy,despise,dental,briefing,bluff,batteries,whatta,sounding,servants,presume,handwriting,fainted,dried,allright,acknowledge,whacked,toxic,reliable,quicker,overwhelming,lining,harassing,fatal,endless,dolls,convict,whatcha,unlikely,shutting,positively,overcome,goddam,essence,dose,diagnosis,cured,bully,ahold,yearbook,tempting,shelf,prosecution,pouring,possessed,greedy,wonders,thorough,spine,rath,psychiatric,meaningless,latte,jammed,ignored,fiance,evidently,contempt,compromised,cans,weekends,urge,theft,suing,shipment,scissors,responding,proposition,noises,matching,hormones,hail,grandchildren,gently,smashed,sexually,sentimental,nicest,manipulated,intern,handcuffs,framed,errands,entertaining,crib,carriage,barge,spends,slipping,seated,rubbing,rely,reject,recommendation,reckon,headaches,float,embrace,corners,whining,sweating,skipped,mountie,motives,listens,cristobel,cleaner,cheerleader,balsom,unnecessary,stunning,scent,quartermaines,pose,montega,loosen,info,hottest,haunt,gracious,forgiving,errand,cakes,blames,abortion,sketch,shifts,plotting,perimeter,pals,mere,mattered,lonigan,interference,eyewitness,enthusiasm,diapers,strongest,shaken,punched,portal,catches,backyard,terrorists,sabotage,organs,needy,cuff,civilization,woof,who'll,prank,obnoxious,mates,hereby,gabby,faked,cellar,whitelighter,void,strangle,sour,muffins,interfering,demonic,clearing,boutique,barrington,terrace,smoked,righty,quack,petey,pact,knot,ketchup,disappearing,cordy,uptight,ticking,terrifying,tease,swamp,secretly,rejection,reflection,realizing,rays,mentally,marone,doubted,deception,congressman,cheesy,toto,stalling,scoop,ribbon,immune,expects,destined,bets,bathing,appreciation,accomplice,wander,shoved,sewer,scroll,retire,lasts,fugitive,freezer,discount,cranky,crank,clearance,bodyguard,anxiety,accountant,whoops,volunteered,talents,stinking,remotely,garlic,decency,cord,beds,altogether,uniforms,tremendous,popping,outa,observe,lung,hangs,feelin,dudes,donation,disguise,curb,bites,antique,toothbrush,realistic,predict,landlord,hourglass,hesitate,consolation,babbling,tipped,stranded,smartest,repeating,puke,psst,paycheck,overreacted,macho,juvenile,grocery,freshen,disposal,cuffs,caffeine,vanished,unfinished,ripping,pinch,flattering,expenses,dinners,colleague,ciao,belthazor,attorneys,woulda,whereabouts,waitin,truce,tripped,tasted,steer,poisoning,manipulative,immature,husbands,heel,granddad,delivering,condoms,addict,trashed,raining,pasta,needles,leaning,detector,coolest,batch,appointments,almighty,vegetables,spark,perfection,pains,momma,mole,meow,hairs,getaway,cracking,compliments,behold,verge,tougher,timer,tapped,taped,specialty,snooping,shoots,rendezvous,pentagon,leverage,jeopardize,janitor,grandparents,forbidden,clueless,bidding,ungrateful,unacceptable,tutor,serum,scuse,pajamas,mouths,lure,irrational,doom,cries,beautifully,arresting,approaching,traitor,sympathetic,smug,smash,rental,prostitute,premonitions,jumps,inventory,darlin,committing,banging,asap,worms,violated,vent,traumatic,traced,sweaty,shaft,overboard,insight,healed,grasp,experiencing,crappy,crab,chunk,awww,stain,shack,reacted,pronounce,poured,moms,marriages,jabez,handful,flipped,fireplace,embarrassment,disappears,concussion,bruises,brakes,twisting,swept,summon,splitting,sloppy,settling,reschedule,notch,hooray,grabbing,exquisite,disrespect,thornhart,straw,slapped,shipped,shattered,ruthless,refill,payroll,numb,mourning,manly,hunk,entertain,drift,dreadful,doorstep,confirmation,chops,appreciates,vague,tires,stressful,stashed,stash,sensed,preoccupied,predictable,noticing,madly,gunshot,dozens,dork,confuse,cleaners,charade,chalk,cappuccino,bouquet,amulet,addiction,who've,warming,unlock,satisfy,sacrificed,relaxing,lone,blocking,blend,blankets,addicted,yuck,hunger,hamburger,greeting,greet,gravy,gram,dreamt,dice,caution,backpack,agreeing,whale,taller,supervisor,sacrifices,phew,ounce,irrelevant,gran,felon,favorites,farther,fade,erased,easiest,convenience,compassionate,cane,backstage,agony,adores,veins,tweek,thieves,surgical,strangely,stetson,recital,proposing,productive,meaningful,immunity,hassle,goddamned,frighten,dearly,cease,ambition,wage,unstable,salvage,richer,refusing,raging,pumping,pressuring,mortals,lowlife,intimidated,intentionally,inspire,forgave,devotion,despicable,deciding,dash,comfy,breach,bark,aaaah,switching,swallowed,stove,screamed,scars,russians,pounding,poof,pipes,pawn,legit,invest,farewell,curtains,civilized,caviar,boost,token,superstition,supernatural,sadness,recorder,psyched,motivated,microwave,hallelujah,fraternity,dryer,cocoa,chewing,acceptable,unbelievably,smiled,smelling,simpler,respectable,remarks,khasinau,indication,gutter,grabs,fulfill,flashlight,ellenor,blooded,blink,blessings,beware,uhhh,turf,swings,slips,shovel,shocking,puff,mirrors,locking,heartless,fras,childish,cardiac,utterly,tuscany,ticked,stunned,statesville,sadly,purely,kiddin,jerks,hitch,flirt,fare,equals,dismiss,christening,casket,c'mere,breakup,biting,antibiotics,accusation,abducted,witchcraft,thread,runnin,punching,paramedics,newest,murdering,masks,lawndale,initials,grampa,choking,charms,careless,bushes,buns,bummed,shred,saves,saddle,rethink,regards,precinct,persuade,meds,manipulating,llanfair,leash,hearted,guarantees,fucks,disgrace,deposition,bookstore,boil,vitals,veil,trespassing,sidewalk,sensible,punishing,overtime,optimistic,obsessing,notify,mornin,jeopardy,jaffa,injection,hilarious,desires,confide,cautious,yada,where're,vindictive,vial,teeny,stroll,sittin,scrub,rebuild,posters,ordeal,nuns,intimacy,inheritance,exploded,donate,distracting,despair,crackers,wildwind,virtue,thoroughly,tails,spicy,sketches,sights,sheer,shaving,seize,scarecrow,refreshing,prosecute,platter,napkin,misplaced,merchandise,loony,jinx,heroic,frankenstein,ambitious,syrup,solitary,resemblance,reacting,premature,lavery,flashes,cheque,awright,acquainted,wrapping,untie,salute,realised,priceless,partying,lightly,lifting,kasnoff,insisting,glowing,generator,explosives,cutie,confronted,buts,blouse,ballistic,antidote,analyze,allowance,adjourned,unto,understatement,tucked,touchy,subconscious,screws,sarge,roommates,rambaldi,offend,nerd,knives,irresistible,incapable,hostility,goddammit,fuse,frat,curfew,blackmailed,walkin,starve,sleigh,sarcastic,recess,rebound,pinned,parlor,outfits,livin,heartache,haired,fundraiser,doorman,discreet,dilucca,cracks,considerate,climbed,catering,apophis,zoey,urine,strung,stitches,sordid,sark,protector,phoned,pets,hostess,flaw,flavor,deveraux,consumed,confidentiality,bourbon,straightened,specials,spaghetti,prettier,powerless,playin,playground,paranoia,instantly,havoc,exaggerating,eavesdropping,doughnuts,diversion,deepest,cutest,comb,bela,behaving,anyplace,accessory,workout,translate,stuffing,speeding,slime,royalty,polls,marital,lurking,lottery,imaginary,greetings,fairwinds,elegant,elbow,credibility,credentials,claws,chopped,bridal,bedside,babysitting,witty,unforgivable,underworld,tempt,tabs,sophomore,selfless,secrecy,restless,okey,movin,metaphor,messes,meltdown,lecter,incoming,gasoline,diefenbaker,buckle,admired,adjustment,warmth,throats,seduced,queer,parenting,noses,luckiest,graveyard,gifted,footsteps,dimeras,cynical,wedded,verbal,unpredictable,tuned,stoop,slides,sinking,rigged,plumbing,lingerie,hankey,greed,everwood,elope,dresser,chauffeur,bulletin,bugged,bouncing,temptation,strangest,slammed,sarcasm,pending,packages,orderly,obsessive,murderers,meteor,inconvenience,glimpse,froze,execute,courageous,consulate,closes,bosses,bees,amends,wuss,wolfram,wacky,unemployed,testifying,syringe,stew,startled,sorrow,sleazy,shaky,screams,rsquo,remark,poke,nutty,mentioning,mend,inspiring,impulsive,housekeeper,foam,fingernails,conditioning,baking,whine,thug,starved,sniffing,sedative,programmed,picket,paged,hound,homosexual,homo,hips,forgets,flipping,flea,flatter,dwell,dumpster,choo,assignments,ants,vile,unreasonable,tossing,thanked,steals,souvenir,scratched,psychopath,outs,obstruction,obey,lump,insists,harass,gloat,filth,edgy,didn,coroner,confessing,bruise,betraying,bailing,appealing,adebisi,wrath,wandered,waist,vain,traps,stepfather,poking,obligated,heavenly,dilemma,crazed,contagious,coaster,cheering,bundle,vomit,thingy,speeches,robbing,raft,pumped,pillows,peep,packs,neglected,m'kay,loneliness,intrude,helluva,gardener,forresters,drooling,betcha,vase,supermarket,squat,spitting,rhyme,relieve,receipts,racket,pictured,pause,overdue,motivation,morgendorffer,kidnapper,insect,horns,feminine,eyeballs,dumps,disappointing,crock,convertible,claw,clamp,canned,cambias,bathtub,avanya,artery,weep,warmer,suspense,summoned,spiders,reiber,raving,pushy,postponed,ohhhh,noooo,mold,laughter,incompetent,hugging,groceries,drip,communicating,auntie,adios,wraps,wiser,willingly,weirdest,timmih,thinner,swelling,swat,steroids,sensitivity,scrape,rehearse,prophecy,ledge,justified,insults,hateful,handles,doorway,chatting,buyer,buckaroo,bedrooms,askin,ammo,tutoring,subpoena,scratching,privileges,pager,mart,intriguing,idiotic,grape,enlighten,corrupt,brunch,bridesmaid,barking,applause,acquaintance,wretched,superficial,soak,smoothly,sensing,restraint,posing,pleading,payoff,oprah,nemo,morals,loaf,jumpy,ignorant,herbal,hangin,germs,generosity,flashing,doughnut,clumsy,chocolates,captive,behaved,apologise,vanity,stumbled,preview,poisonous,perjury,parental,onboard,mugged,minding,linen,knots,interviewing,humour,grind,greasy,goons,drastic,coop,comparing,cocky,clearer,bruised,brag,bind,worthwhile,whoop,vanquishing,tabloids,sprung,spotlight,sentencing,racist,provoke,pining,overly,locket,imply,impatient,hovering,hotter,fest,endure,dots,doren,debts,crawled,chained,brit,breaths,weirdo,warmed,wand,troubling,tok'ra,strapped,soaked,skipping,scrambled,rattle,profound,musta,mocking,misunderstand,limousine,kacl,hustle,forensic,enthusiastic,duct,drawers,devastating,conquer,clarify,chores,cheerleaders,cheaper,callin,blushing,barging,abused,yoga,wrecking,wits,waffles,virginity,vibes,uninvited,unfaithful,teller,strangled,scheming,ropes,rescuing,rave,postcard,o'reily,morphine,lotion,lads,kidneys,judgement,itch,indefinitely,grenade,glamorous,genetically,freud,discretion,delusions,crate,competent,bakery,argh,ahhhh,wedge,wager,unfit,tripping,torment,superhero,stirring,spinal,sorority,seminar,scenery,rabble,pneumonia,perks,override,ooooh,mija,manslaughter,mailed,lime,lettuce,intimidate,guarded,grieve,grad,frustration,doorbell,chinatown,authentic,arraignment,annulled,allergies,wanta,verify,vegetarian,tighter,telegram,stalk,spared,shoo,satisfying,saddam,requesting,pens,overprotective,obstacles,notified,nasedo,grandchild,genuinely,flushed,fluids,floss,escaping,ditched,cramp,corny,bunk,bitten,billions,bankrupt,yikes,wrists,ultrasound,ultimatum,thirst,sniff,shakes,salsa,retrieve,reassuring,pumps,neurotic,negotiating,needn't,monitors,millionaire,lydecker,limp,incriminating,hatchet,gracias,gordie,fills,feeds,doubting,decaf,biopsy,whiz,voluntarily,ventilator,unpack,unload,toad,spooked,snitch,schillinger,reassure,persuasive,mystical,mysteries,matrimony,mails,jock,headline,explanations,dispatch,curly,cupid,condolences,comrade,cassadines,bulb,bragging,awaits,assaulted,ambush,adolescent,abort,yank,whit,vaguely,undermine,tying,swamped,stabbing,slippers,slash,sincerely,sigh,setback,secondly,rotting,precaution,pcpd,melting,liaison,hots,hooking,headlines,haha,ganz,fury,felicity,fangs,encouragement,earring,dreidel,dory,donut,dictate,decorating,cocktails,bumps,blueberry,believable,backfired,backfire,apron,adjusting,vous,vouch,vitamins,ummm,tattoos,slimy,sibling,shhhh,renting,peculiar,parasite,paddington,marries,mailbox,magically,lovebirds,knocks,informant,exits,drazen,distractions,disconnected,dinosaurs,dashwood,crooked,conveniently,wink,warped,underestimated,tacky,shoving,seizure,reset,pushes,opener,mornings,mash,invent,indulge,horribly,hallucinating,festive,eyebrows,enjoys,desperation,dealers,darkest,daph,boragora,belts,bagel,authorization,auditions,agitated,wishful,wimp,vanish,unbearable,tonic,suffice,suction,slaying,safest,rocking,relive,puttin,prettiest,noisy,newlyweds,nauseous,misguided,mildly,midst,liable,judgmental,indy,hunted,givin,fascinated,elephants,dislike,deluded,decorate,crummy,contractions,carve,bottled,bonded,bahamas,unavailable,twenties,trustworthy,surgeons,stupidity,skies,remorse,preferably,pies,nausea,napkins,mule,mourn,melted,mashed,inherit,greatness,golly,excused,dumbo,drifting,delirious,damaging,cubicle,compelled,comm,chooses,checkup,boredom,bandages,alarms,windshield,who're,whaddya,transparent,surprisingly,sunglasses,slit,roar,reade,prognosis,probe,pitiful,persistent,peas,nosy,nagging,morons,masterpiece,martinis,limbo,liars,irritating,inclined,hump,hoynes,fiasco,eatin,cubans,concentrating,colorful,clam,cider,brochure,barto,bargaining,wiggle,welcoming,weighing,vanquished,stains,sooo,snacks,smear,sire,resentment,psychologist,pint,overhear,morality,landingham,kisser,hoot,holling,handshake,grilled,formality,elevators,depths,confirms,boathouse,accidental,westbridge,wacko,ulterior,thugs,thighs,tangled,stirred,snag,sling,sleaze,rumour,ripe,remarried,puddle,pins,perceptive,miraculous,longing,lockup,librarian,impressions,immoral,hypothetically,guarding,gourmet,gabe,faxed,extortion,downright,digest,cranberry,bygones,buzzing,burying,bikes,weary,taping,takeout,sweeping,stepmother,stale,senor,seaborn,pros,pepperoni,newborn,ludicrous,injected,geeks,forged,faults,drue,dire,dief,desi,deceiving,caterer,calmed,budge,ankles,vending,typing,tribbiani,there're,squared,snowing,shades,sexist,rewrite,regretted,raises,picky,orphan,mural,misjudged,miscarriage,memorize,leaking,jitters,invade,interruption,illegally,handicapped,glitch,gittes,finer,distraught,dispose,dishonest,digs,dads,cruelty,circling,canceling,butterflies,belongings,barbrady,amusement,alias,zombies,where've,unborn,swearing,stables,squeezed,sensational,resisting,radioactive,questionable,privileged,portofino,owning,overlook,orson,oddly,interrogate,imperative,impeccable,hurtful,hors,heap,graders,glance,disgust,devious,destruct,crazier,countdown,chump,cheeseburger,burglar,berries,ballroom,assumptions,annoyed,allergy,admirer,admirable,activate,underpants,twit,tack,strokes,stool,sham,scrap,retarded,resourceful,remarkably,refresh,pressured,precautions,pointy,nightclub,mustache,maui,lace,hunh,hubby,flare,dont,dokey,dangerously,crushing,clinging,choked,chem,cheerleading,checkbook,cashmere,calmly,blush,believer,amazingly,alas,what've,toilets,tacos,stairwell,spirited,sewing,rubbed,punches,protects,nuisance,motherfuckers,mingle,kynaston,knack,kinkle,impose,gullible,godmother,funniest,friggin,folding,fashions,eater,dysfunctional,drool,dripping,ditto,cruising,criticize,conceive,clone,cedars,caliber,brighter,blinded,birthdays,banquet,anticipate,annoy,whim,whichever,volatile,veto,vested,shroud,rests,reindeer,quarantine,pleases,painless,orphans,orphanage,offence,obliged,negotiation,narcotics,mistletoe,meddling,manifest,lookit,lilah,intrigued,injustice,homicidal,gigantic,exposing,elves,disturbance,disastrous,depended,demented,correction,cooped,cheerful,buyers,brownies,beverage,basics,arvin,weighs,upsets,unethical,swollen,sweaters,stupidest,sensation,scalpel,props,prescribed,pompous,objections,mushrooms,mulwray,manipulation,lured,internship,insignificant,inmate,incentive,fulfilled,disagreement,crypt,cornered,copied,brightest,beethoven,attendant,amaze,yogurt,wyndemere,vocabulary,tulsa,tactic,stuffy,respirator,pretends,polygraph,pennies,ordinarily,olives,necks,morally,martyr,leftovers,joints,hopping,homey,hints,heartbroken,forge,florist,firsthand,fiend,dandy,crippled,corrected,conniving,conditioner,clears,chemo,bubbly,bladder,beeper,baptism,wiring,wench,weaknesses,volunteering,violating,unlocked,tummy,surrogate,subid,stray,startle,specifics,slowing,scoot,robbers,rightful,richest,qfxmjrie,puffs,pierced,pencils,paralysis,makeover,luncheon,linksynergy,jerky,jacuzzi,hitched,hangover,fracture,flock,firemen,disgusted,darned,clams,borrowing,banged,wildest,weirder,unauthorized,stunts,sleeves,sixties,shush,shalt,retro,quits,pegged,painfully,paging,omelet,memorized,lawfully,jackets,intercept,ingredient,grownup,glued,fulfilling,enchanted,delusion,daring,compelling,carton,bridesmaids,bribed,boiling,bathrooms,bandage,awaiting,assign,arrogance,antiques,ainsley,turkeys,trashing,stockings,stalked,stabilized,skates,sedated,robes,respecting,psyche,presumptuous,prejudice,paragraph,mocha,mints,mating,mantan,lorne,loads,listener,itinerary,hepatitis,heave,guesses,fading,examining,dumbest,dishwasher,deceive,cunning,cripple,convictions,confided,compulsive,compromising,burglary,bumpy,brainwashed,benes,arnie,affirmative,adrenaline,adamant,watchin,waitresses,transgenic,toughest,tainted,surround,stormed,spree,spilling,spectacle,soaking,shreds,sewers,severed,scarce,scamming,scalp,rewind,rehearsing,pretentious,potions,overrated,obstacle,nerds,meems,mcmurphy,maternity,maneuver,loathe,fertility,eloping,ecstatic,ecstasy,divorcing,dignan,costing,clubhouse,clocks,candid,bursting,breather,braces,bending,arsonist,adored,absorb,valiant,uphold,unarmed,topolsky,thrilling,thigh,terminate,sustain,spaceship,snore,sneeze,smuggling,salty,quaint,patronize,patio,morbid,mamma,kettle,joyous,invincible,interpret,insecurities,impulses,illusions,holed,exploit,drivin,defenseless,dedicate,cradle,coupon,countless,conjure,cardboard,booking,backseat,accomplishment,wordsworth,wisely,valet,vaccine,urges,unnatural,unlucky,truths,traumatized,tasting,swears,strawberries,steaks,stats,skank,seducing,secretive,scumbag,screwdriver,schedules,rooting,rightfully,rattled,qualifies,puppets,prospects,pronto,posse,polling,pedestal,palms,muddy,morty,microscope,merci,lecturing,inject,incriminate,hygiene,grapefruit,gazebo,funnier,cuter,bossy,booby,aides,zende,winthrop,warrants,valentines,undressed,underage,truthfully,tampered,suffers,speechless,sparkling,sidelines,shrek,railing,puberty,pesky,outrage,outdoors,motions,moods,lunches,litter,kidnappers,itching,intuition,imitation,humility,hassling,gallons,drugstore,dosage,disrupt,dipping,deranged,debating,cuckoo,cremated,craziness,cooperating,circumstantial,chimney,blinking,biscuits,admiring,weeping,triad,trashy,soothing,slumber,slayers,skirts,siren,shindig,sentiment,rosco,riddance,quaid,purity,proceeding,pretzels,panicking,mckechnie,lovin,leaked,intruding,impersonating,ignorance,hamburgers,footprints,fluke,fleas,festivities,fences,feisty,evacuate,emergencies,deceived,creeping,craziest,corpses,conned,coincidences,bounced,bodyguards,blasted,bitterness,baloney,ashtray,apocalypse,zillion,watergate,wallpaper,telesave,sympathize,sweeter,startin,spades,sodas,snowed,sleepover,signor,seein,retainer,restroom,rested,repercussions,reliving,reconcile,prevail,preaching,overreact,o'neil,noose,moustache,manicure,maids,landlady,hypothetical,hopped,homesick,hives,hesitation,herbs,hectic,heartbreak,haunting,gangs,frown,fingerprint,exhausting,everytime,disregard,cling,chevron,chaperone,blinding,bitty,beads,battling,badgering,anticipation,upstanding,unprofessional,unhealthy,turmoil,truthful,toothpaste,tippin,thoughtless,tagataya,shooters,senseless,rewarding,propane,preposterous,pigeons,pastry,overhearing,obscene,negotiable,loner,jogging,itchy,insinuating,insides,hospitality,hormone,hearst,forthcoming,fists,fifties,etiquette,endings,destroys,despises,deprived,cuddy,crust,cloak,circumstance,chewed,casserole,bidder,bearer,artoo,applaud,appalling,vowed,virgins,vigilante,undone,throttle,testosterone,tailor,symptom,swoop,suitcases,stomp,sticker,stakeout,spoiling,snatched,smoochy,smitten,shameless,restraints,researching,renew,refund,reclaim,raoul,puzzles,purposely,punks,prosecuted,plaid,picturing,pickin,parasites,mysteriously,multiply,mascara,jukebox,interruptions,gunfire,furnace,elbows,duplicate,drapes,deliberate,decoy,cryptic,coupla,condemn,complicate,colossal,clerks,clarity,brushed,banished,argon,alarmed,worships,versa,uncanny,technicality,sundae,stumble,stripping,shuts,schmuck,satin,saliva,robber,relentless,reconnect,recipes,rearrange,rainy,psychiatrists,policemen,plunge,plugged,patched,overload,o'malley,mindless,menus,lullaby,lotte,leavin,killin,karinsky,invalid,hides,grownups,griff,flaws,flashy,flaming,fettes,evicted,dread,degrassi,dealings,dangers,cushion,bowel,barged,abide,abandoning,wonderfully,wait'll,violate,suicidal,stayin,sorted,slamming,sketchy,shoplifting,raiser,quizmaster,prefers,needless,motherhood,momentarily,migraine,lifts,leukemia,leftover,keepin,hinks,hellhole,gowns,goodies,gallon,futures,entertained,eighties,conspiring,cheery,benign,apiece,adjustments,abusive,abduction,wiping,whipping,welles,unspeakable,unidentified,trivial,transcripts,textbook,supervise,superstitious,stricken,stimulating,spielberg,slices,shelves,scratches,sabotaged,retrieval,repressed,rejecting,quickie,ponies,peeking,outraged,o'connell,moping,moaning,mausoleum,licked,kovich,klutz,interrogating,interfered,insulin,infested,incompetence,hyper,horrified,handedly,gekko,fraid,fractured,examiner,eloped,disoriented,dashing,crashdown,courier,cockroach,chipped,brushing,bombed,bolts,baths,baptized,astronaut,assurance,anemia,abuela,abiding,withholding,weave,wearin,weaker,suffocating,straws,straightforward,stench,steamed,starboard,sideways,shrinks,shortcut,scram,roasted,roaming,riviera,respectfully,repulsive,psychiatry,provoked,penitentiary,painkillers,ninotchka,mitzvah,milligrams,midge,marshmallows,looky,lapse,kubelik,intellect,improvise,implant,goa'ulds,giddy,geniuses,fruitcake,footing,fightin,drinkin,doork,detour,cuddle,crashes,combo,colonnade,cheats,cetera,bailiff,auditioning,assed,amused,alienate,aiding,aching,unwanted,topless,tongues,tiniest,superiors,soften,sheldrake,rawley,raisins,presses,plaster,nessa,narrowed,minions,merciful,lawsuits,intimidating,infirmary,inconvenient,imposter,hugged,honoring,holdin,hades,godforsaken,fumes,forgery,foolproof,folder,flattery,fingertips,exterminator,explodes,eccentric,dodging,disguised,crave,constructive,concealed,compartment,chute,chinpokomon,bodily,astronauts,alimony,accustomed,abdominal,wrinkle,wallow,valium,untrue,uncover,trembling,treasures,torched,toenails,timed,termites,telly,taunting,taransky,talker,succubus,smarts,sliding,sighting,semen,seizures,scarred,savvy,sauna,saddest,sacrificing,rubbish,riled,ratted,rationally,provenance,phonse,perky,pedal,overdose,nasal,nanites,mushy,movers,missus,midterm,merits,melodramatic,manure,knitting,invading,interpol,incapacitated,hotline,hauling,gunpoint,grail,ganza,framing,flannel,faded,eavesdrop,desserts,calories,breathtaking,bleak,blacked,batter,aggravated,yanked,wigand,whoah,unwind,undoubtedly,unattractive,twitch,trimester,torrance,timetable,taxpayers,strained,stared,slapping,sincerity,siding,shenanigans,shacking,sappy,samaritan,poorer,politely,paste,oysters,overruled,nightcap,mosquito,millimeter,merrier,manhood,lucked,kilos,ignition,hauled,harmed,goodwill,freshmen,fenmore,fasten,farce,exploding,erratic,drunks,ditching,d'artagnan,cramped,contacting,closets,clientele,chimp,bargained,arranging,anesthesia,amuse,altering,afternoons,accountable,abetting,wolek,waved,uneasy,toddy,tattooed,spauldings,sliced,sirens,schibetta,scatter,rinse,remedy,redemption,pleasures,optimism,oblige,mmmmm,masked,malicious,mailing,kosher,kiddies,judas,isolate,insecurity,incidentally,heals,headlights,growl,grilling,glazed,flunk,floats,fiery,fairness,exercising,excellency,disclosure,cupboard,counterfeit,condescending,conclusive,clicked,cleans,cholesterol,cashed,broccoli,brats,blueprints,blindfold,billing,attach,appalled,alrighty,wynant,unsolved,unreliable,toots,tighten,sweatshirt,steinbrenner,steamy,spouse,sonogram,slots,sleepless,shines,retaliate,rephrase,redeem,rambling,quilt,quarrel,prying,proverbial,priced,prescribe,prepped,pranks,possessive,plaintiff,pediatrics,overlooked,outcast,nightgown,mumbo,mediocre,mademoiselle,lunchtime,lifesaver,leaned,lambs,interns,hounding,hellmouth,hahaha,goner,ghoul,gardening,frenzy,foyer,extras,exaggerate,everlasting,enlightened,dialed,devote,deceitful,d'oeuvres,cosmetic,contaminated,conspired,conning,cavern,carving,butting,boiled,blurry,babysit,ascension,aaaaah,wildly,whoopee,whiny,weiskopf,walkie,vultures,vacations,upfront,unresolved,tampering,stockholders,snaps,sleepwalking,shrunk,sermon,seduction,scams,revolve,phenomenal,patrolling,paranormal,ounces,omigod,nightfall,lashing,innocents,infierno,incision,humming,haunts,gloss,gloating,frannie,fetal,feeny,entrapment,discomfort,detonator,dependable,concede,complication,commotion,commence,chulak,caucasian,casually,brainer,bolie,ballpark,anwar,analyzing,accommodations,youse,wring,wallowing,transgenics,thrive,tedious,stylish,strippers,sterile,squeezing,squeaky,sprained,solemn,snoring,shattering,shabby,seams,scrawny,revoked,residue,reeks,recite,ranting,quoting,predicament,plugs,pinpoint,petrified,pathological,passports,oughtta,nighter,navigate,kippie,intrigue,intentional,insufferable,hunky,how've,horrifying,hearty,hamptons,grazie,funerals,forks,fetched,excruciating,enjoyable,endanger,dumber,drying,diabolical,crossword,corry,comprehend,clipped,classmates,candlelight,brutally,brutality,boarded,bathrobe,authorize,assemble,aerobics,wholesome,whiff,vermin,trophies,trait,tragically,toying,testy,tasteful,stocked,spinach,sipping,sidetracked,scrubbing,scraping,sanctity,robberies,ridin,retribution,refrain,realities,radiant,protesting,projector,plutonium,payin,parting,o'reilly,nooooo,motherfucking,measly,manic,lalita,juggling,jerking,intro,inevitably,hypnosis,huddle,horrendous,hobbies,heartfelt,harlin,hairdresser,gonorrhea,fussing,furtwangler,fleeting,flawless,flashed,fetus,eulogy,distinctly,disrespectful,denies,crossbow,cregg,crabs,cowardly,contraction,contingency,confirming,condone,coffins,cleansing,cheesecake,certainty,cages,c'est,briefed,bravest,bosom,boils,binoculars,bachelorette,appetizer,ambushed,alerted,woozy,withhold,vulgar,utmost,unleashed,unholy,unhappiness,unconditional,typewriter,typed,twists,supermodel,subpoenaed,stringing,skeptical,schoolgirl,romantically,rocked,revoir,reopen,puncture,preach,polished,planetarium,penicillin,peacefully,nurturing,more'n,mmhmm,midgets,marklar,lodged,lifeline,jellyfish,infiltrate,hutch,horseback,heist,gents,frickin,freezes,forfeit,flakes,flair,fathered,eternally,epiphany,disgruntled,discouraged,delinquent,decipher,danvers,cubes,credible,coping,chills,cherished,catastrophe,bombshell,birthright,billionaire,ample,affections,admiration,abbotts,whatnot,watering,vinegar,unthinkable,unseen,unprepared,unorthodox,underhanded,uncool,timeless,thump,thermometer,theoretically,tapping,tagged,swung,stares,spiked,solves,smuggle,scarier,saucer,quitter,prudent,powdered,poked,pointers,peril,penetrate,penance,opium,nudge,nostrils,neurological,mockery,mobster,medically,loudly,insights,implicate,hypocritical,humanly,holiness,healthier,hammered,haldeman,gunman,gloom,freshly,francs,flunked,flawed,emptiness,drugging,dozer,derevko,deprive,deodorant,cryin,crocodile,coloring,colder,cognac,clocked,clippings,charades,chanting,certifiable,caterers,brute,brochures,botched,blinders,bitchin,banter,woken,ulcer,tread,thankfully,swine,swimsuit,swans,stressing,steaming,stamped,stabilize,squirm,snooze,shuffle,shredded,seafood,scratchy,savor,sadistic,rhetorical,revlon,realist,prosecuting,prophecies,polyester,petals,persuasion,paddles,o'leary,nuthin,neighbour,negroes,muster,meningitis,matron,lockers,letterman,legged,indictment,hypnotized,housekeeping,hopelessly,hallucinations,grader,goldilocks,girly,flask,envelopes,downside,doves,dissolve,discourage,disapprove,diabetic,deliveries,decorator,crossfire,criminally,containment,comrades,complimentary,chatter,catchy,cashier,cartel,caribou,cardiologist,brawl,booted,barbershop,aryan,angst,administer,zellie,wreak,whistles,vandalism,vamps,uterus,upstate,unstoppable,understudy,tristin,transcript,tranquilizer,toxins,tonsils,stempel,spotting,spectator,spatula,softer,snotty,slinging,showered,sexiest,sensual,sadder,rimbaud,restrain,resilient,remission,reinstate,rehash,recollection,rabies,popsicle,plausible,pediatric,patronizing,ostrich,ortolani,oooooh,omelette,mistrial,marseilles,loophole,laughin,kevvy,irritated,infidelity,hypothermia,horrific,groupie,grinding,graceful,goodspeed,gestures,frantic,extradition,echelon,disks,dawnie,dared,damsel,curled,collateral,collage,chant,calculating,bumping,bribes,boardwalk,blinds,blindly,bleeds,bickering,beasts,backside,avenge,apprehended,anguish,abusing,youthful,yells,yanking,whomever,when'd,vomiting,vengeful,unpacking,unfamiliar,undying,tumble,trolls,treacherous,tipping,tantrum,tanked,summons,straps,stomped,stinkin,stings,staked,squirrels,sprinkles,speculate,sorting,skinned,sicko,sicker,shootin,shatter,seeya,schnapps,s'posed,ronee,respectful,regroup,regretting,reeling,reckoned,ramifications,puddy,projections,preschool,plissken,platonic,permalash,outdone,outburst,mutants,mugging,misfortune,miserably,miraculously,medications,margaritas,manpower,lovemaking,logically,leeches,latrine,kneel,inflict,impostor,hypocrisy,hippies,heterosexual,heightened,hecuba,healer,gunned,grooming,groin,gooey,gloomy,frying,friendships,fredo,firepower,fathom,exhaustion,evils,endeavor,eggnog,dreaded,d'arcy,crotch,coughing,coronary,cookin,consummate,congrats,companionship,caved,caspar,bulletproof,brilliance,breakin,brash,blasting,aloud,airtight,advising,advertise,adultery,aches,wronged,upbeat,trillion,thingies,tending,tarts,surreal,specs,specialize,spade,shrew,shaping,selves,schoolwork,roomie,recuperating,rabid,quart,provocative,proudly,pretenses,prenatal,pharmaceuticals,pacing,overworked,originals,nicotine,murderous,mileage,mayonnaise,massages,losin,interrogated,injunction,impartial,homing,heartbreaker,hacks,glands,giver,fraizh,flips,flaunt,englishman,electrocuted,dusting,ducking,drifted,donating,cylon,crutches,crates,cowards,comfortably,chummy,chitchat,childbirth,businesswoman,brood,blatant,bethy,barring,bagged,awakened,asbestos,airplanes,worshipped,winnings,why're,visualize,unprotected,unleash,trays,thicker,therapists,takeoff,streisand,storeroom,stethoscope,stacked,spiteful,sneaks,snapping,slaughtered,slashed,simplest,silverware,shits,secluded,scruples,scrubs,scraps,ruptured,roaring,receptionist,recap,raditch,radiator,pushover,plastered,pharmacist,perverse,perpetrator,ornament,ointment,nineties,napping,nannies,mousse,moors,momentary,misunderstandings,manipulator,malfunction,laced,kivar,kickin,infuriating,impressionable,holdup,hires,hesitated,headphones,hammering,groundwork,grotesque,graces,gauze,gangsters,frivolous,freeing,fours,forwarding,ferrars,faulty,fantasizing,extracurricular,empathy,divorces,detonate,depraved,demeaning,deadlines,dalai,cursing,cufflink,crows,coupons,comforted,claustrophobic,casinos,camped,busboy,bluth,bennetts,baskets,attacker,aplastic,angrier,affectionate,zapped,wormhole,weaken,unrealistic,unravel,unimportant,unforgettable,twain,suspend,superbowl,stutter,stewardess,stepson,standin,spandex,souvenirs,sociopath,skeletons,shivering,sexier,selfishness,scrapbook,ritalin,ribbons,reunite,remarry,relaxation,rattling,rapist,psychosis,prepping,poses,pleasing,pisses,piling,persecuted,padded,operatives,negotiator,natty,menopause,mennihan,martimmys,loyalties,laynie,lando,justifies,intimately,inexperienced,impotent,immortality,horrors,hooky,hinges,heartbreaking,handcuffed,gypsies,guacamole,grovel,graziella,goggles,gestapo,fussy,ferragamo,feeble,eyesight,explosions,experimenting,enchanting,doubtful,dizziness,dismantle,detectors,deserving,defective,dangling,dancin,crumble,creamed,cramping,conceal,clockwork,chrissakes,chrissake,chopping,cabinets,brooding,bonfire,blurt,bloated,blackmailer,beforehand,bathed,bathe,barcode,banish,badges,babble,await,attentive,aroused,antibodies,animosity,ya'll,wrinkled,wonderland,willed,whisk,waltzing,waitressing,vigilant,upbringing,unselfish,uncles,trendy,trajectory,striped,stamina,stalled,staking,stacks,spoils,snuff,snooty,snide,shrinking,senora,secretaries,scoundrel,saline,salads,rundown,riddles,relapse,recommending,raspberry,plight,pecan,pantry,overslept,ornaments,niner,negligent,negligence,nailing,mucho,mouthed,monstrous,malpractice,lowly,loitering,logged,lingering,lettin,lattes,kamal,juror,jillefsky,jacked,irritate,intrusion,insatiable,infect,impromptu,icing,hmmmm,hefty,gasket,frightens,flapping,firstborn,faucet,estranged,envious,dopey,doesn,disposition,disposable,disappointments,dipped,dignified,deceit,dealership,deadbeat,curses,coven,counselors,concierge,clutches,casbah,callous,cahoots,brotherly,britches,brides,bethie,beige,autographed,attendants,attaboy,astonishing,appreciative,antibiotic,aneurysm,afterlife,affidavit,zoning,whats,whaddaya,vasectomy,unsuspecting,toula,topanga,tonio,toasted,tiring,terrorized,tenderness,tailing,sweats,suffocated,sucky,subconsciously,starvin,sprouts,spineless,sorrows,snowstorm,smirk,slicery,sledding,slander,simmer,signora,sigmund,seventies,sedate,scented,sandals,rollers,retraction,resigning,recuperate,receptive,racketeering,queasy,provoking,priors,prerogative,premed,pinched,pendant,outsiders,orbing,opportunist,olanov,neurologist,nanobot,mommies,molested,misread,mannered,laundromat,intercom,inspect,insanely,infatuation,indulgent,indiscretion,inconsiderate,hurrah,howling,herpes,hasta,harassed,hanukkah,groveling,groosalug,gander,galactica,futile,fridays,flier,fixes,exploiting,exorcism,evasive,endorse,emptied,dreary,dreamy,downloaded,dodged,doctored,disobeyed,disneyland,disable,dehydrated,contemplating,coconuts,cockroaches,clogged,chilling,chaperon,cameraman,bulbs,bucklands,bribing,brava,bracelets,bowels,bluepoint,appetizers,appendix,antics,anointed,analogy,almonds,yammering,winch,weirdness,wangler,vibrations,vendor,unmarked,unannounced,twerp,trespass,travesty,transfusion,trainee,towelie,tiresome,straightening,staggering,sonar,socializing,sinus,sinners,shambles,serene,scraped,scones,scepter,sarris,saberhagen,ridiculously,ridicule,rents,reconciled,radios,publicist,pubes,prune,prude,precrime,postponing,pluck,perish,peppermint,peeled,overdo,nutshell,nostalgic,mulan,mouthing,mistook,meddle,maybourne,martimmy,lobotomy,livelihood,lippman,likeness,kindest,kaffee,jocks,jerked,jeopardizing,jazzed,insured,inquisition,inhale,ingenious,holier,helmets,heirloom,heinous,haste,harmsway,hardship,hanky,gutters,gruesome,groping,goofing,godson,glare,finesse,figuratively,ferrie,endangerment,dreading,dozed,dorky,dmitri,divert,discredit,dialing,cufflinks,crutch,craps,corrupted,cocoon,cleavage,cannery,bystander,brushes,bruising,bribery,brainstorm,bolted,binge,ballistics,astute,arroway,adventurous,adoptive,addicts,addictive,yadda,whitelighters,wematanye,weeds,wedlock,wallets,vulnerability,vroom,vents,upped,unsettling,unharmed,trippin,trifle,tracing,tormenting,thats,syphilis,subtext,stickin,spices,sores,smacked,slumming,sinks,signore,shitting,shameful,shacked,septic,seedy,righteousness,relish,rectify,ravishing,quickest,phoebs,perverted,peeing,pedicure,pastrami,passionately,ozone,outnumbered,oregano,offender,nukes,nosed,nighty,nifty,mounties,motivate,moons,misinterpreted,mercenary,mentality,marsellus,lupus,lumbar,lovesick,lobsters,leaky,laundering,latch,jafar,instinctively,inspires,indoors,incarcerated,hundredth,handkerchief,gynecologist,guittierez,groundhog,grinning,goodbyes,geese,fullest,eyelashes,eyelash,enquirer,endlessly,elusive,disarm,detest,deluding,dangle,cotillion,corsage,conjugal,confessional,cones,commandment,coded,coals,chuckle,christmastime,cheeseburgers,chardonnay,celery,campfire,calming,burritos,brundle,broflovski,brighten,borderline,blinked,bling,beauties,bauers,battered,articulate,alienated,ahhhhh,agamemnon,accountants,y'see,wrongful,wrapper,workaholic,winnebago,whispered,warts,vacate,unworthy,unanswered,tonane,tolerated,throwin,throbbing,thrills,thorns,thereof,there've,tarot,sunscreen,stretcher,stereotype,soggy,sobbing,sizable,sightings,shucks,shrapnel,sever,senile,seaboard,scorned,saver,rebellious,rained,putty,prenup,pores,pinching,pertinent,peeping,paints,ovulating,opposites,occult,nutcracker,nutcase,newsstand,newfound,mocked,midterms,marshmallow,marbury,maclaren,leans,krudski,knowingly,keycard,junkies,juilliard,jolinar,irritable,invaluable,inuit,intoxicating,instruct,insolent,inexcusable,incubator,illustrious,hunsecker,houseguest,homosexuals,homeroom,hernia,harming,handgun,hallways,hallucination,gunshots,groupies,groggy,goiter,gingerbread,giggling,frigging,fledged,fedex,fairies,exchanging,exaggeration,esteemed,enlist,drags,dispense,disloyal,disconnect,desks,dentists,delacroix,degenerate,daydreaming,cushions,cuddly,corroborate,complexion,compensated,cobbler,closeness,chilled,checkmate,channing,carousel,calms,bylaws,benefactor,ballgame,baiting,backstabbing,artifact,airspace,adversary,actin,accuses,accelerant,abundantly,abstinence,zissou,zandt,yapping,witchy,willows,whadaya,vilandra,veiled,undress,undivided,underestimating,ultimatums,twirl,truckload,tremble,toasting,tingling,tents,tempered,sulking,stunk,sponges,spills,softly,snipers,scourge,rooftop,riana,revolting,revisit,refreshments,redecorating,recapture,raysy,pretense,prejudiced,precogs,pouting,poofs,pimple,piles,pediatrician,padre,packets,paces,orvelle,oblivious,objectivity,nighttime,nervosa,mexicans,meurice,melts,matchmaker,maeby,lugosi,lipnik,leprechaun,kissy,kafka,introductions,intestines,inspirational,insightful,inseparable,injections,inadvertently,hussy,huckabees,hittin,hemorrhaging,headin,haystack,hallowed,grudges,granilith,grandkids,grading,gracefully,godsend,gobbles,fragrance,fliers,finchley,farts,eyewitnesses,expendable,existential,dorms,delaying,degrading,deduction,darlings,danes,cylons,counsellor,contraire,consciously,conjuring,congratulating,cokes,buffay,brooch,bitching,bistro,bijou,bewitched,benevolent,bends,bearings,barren,aptitude,amish,amazes,abomination,worldly,whispers,whadda,wayward,wailing,vanishing,upscale,untouchable,unspoken,uncontrollable,unavoidable,unattended,trite,transvestite,toupee,timid,timers,terrorizing,swana,stumped,strolling,storybook,storming,stomachs,stoked,stationery,springtime,spontaneity,spits,spins,soaps,sentiments,scramble,scone,rooftops,retract,reflexes,rawdon,ragged,quirky,quantico,psychologically,prodigal,pounce,potty,pleasantries,pints,petting,perceive,onstage,notwithstanding,nibble,newmans,neutralize,mutilated,millionaires,mayflower,masquerade,mangy,macreedy,lunatics,lovable,locating,limping,lasagna,kwang,keepers,juvie,jaded,ironing,intuitive,intensely,insure,incantation,hysteria,hypnotize,humping,happenin,griet,grasping,glorified,ganging,g'night,focker,flunking,flimsy,flaunting,fixated,fitzwallace,fainting,eyebrow,exonerated,ether,electrician,egotistical,earthly,dusted,dignify,detonation,debrief,dazzling,dan'l,damnedest,daisies,crushes,crucify,contraband,confronting,collapsing,cocked,clicks,cliche,circled,chandelier,carburetor,callers,broads,breathes,bloodshed,blindsided,blabbing,bialystock,bashing,ballerina,aviva,arteries,anomaly,airstrip,agonizing,adjourn,aaaaa,yearning,wrecker,witnessing,whence,warhead,unsure,unheard,unfreeze,unfold,unbalanced,ugliest,troublemaker,toddler,tiptoe,threesome,thirties,thermostat,swipe,surgically,subtlety,stung,stumbling,stubs,stride,strangling,sprayed,socket,smuggled,showering,shhhhh,sabotaging,rumson,rounding,risotto,repairman,rehearsed,ratty,ragging,radiology,racquetball,racking,quieter,quicksand,prowl,prompt,premeditated,prematurely,prancing,porcupine,plated,pinocchio,peeked,peddle,panting,overweight,overrun,outing,outgrown,obsess,nursed,nodding,negativity,negatives,musketeers,mugger,motorcade,merrily,matured,masquerading,marvellous,maniacs,lovey,louse,linger,lilies,lawful,kudos,knuckle,juices,judgments,itches,intolerable,intermission,inept,incarceration,implication,imaginative,huckleberry,holster,heartburn,gunna,groomed,graciously,fulfillment,fugitives,forsaking,forgives,foreseeable,flavors,flares,fixation,fickle,fantasize,famished,fades,expiration,exclamation,erasing,eiffel,eerie,earful,duped,dulles,dissing,dissect,dispenser,dilated,detergent,desdemona,debriefing,damper,curing,crispina,crackpot,courting,cordial,conflicted,comprehension,commie,cleanup,chiropractor,charmer,chariot,cauldron,catatonic,bullied,buckets,brilliantly,breathed,booths,boardroom,blowout,blindness,blazing,biologically,bibles,biased,beseech,barbaric,balraj,audacity,anticipating,alcoholics,airhead,agendas,admittedly,absolution,youre,yippee,wittlesey,withheld,willful,whammy,weakest,washes,virtuous,videotapes,vials,unplugged,unpacked,unfairly,turbulence,tumbling,tricking,tremendously,traitors,torches,tinga,thyroid,teased,tawdry,taker,sympathies,swiped,sundaes,suave,strut,stepdad,spewing,spasm,socialize,slither,simulator,shutters,shrewd,shocks,semantics,schizophrenic,scans,savages,rya'c,runny,ruckus,royally,roadblocks,rewriting,revoke,repent,redecorate,recovers,recourse,ratched,ramali,racquet,quince,quiche,puppeteer,puking,puffed,problemo,praises,pouch,postcards,pooped,poised,piled,phoney,phobia,patching,parenthood,pardner,oozing,ohhhhh,numbing,nostril,nosey,neatly,nappa,nameless,mortuary,moronic,modesty,midwife,mcclane,matuka,maitre,lumps,lucid,loosened,loins,lawnmower,lamotta,kroehner,jinxy,jessep,jamming,jailhouse,jacking,intruders,inhuman,infatuated,indigestion,implore,implanted,hormonal,hoboken,hillbilly,heartwarming,headway,hatched,hartmans,harping,grapevine,gnome,forties,flyin,flirted,fingernail,exhilarating,enjoyment,embark,dumper,dubious,drell,docking,disillusioned,dishonor,disbarred,dicey,custodial,counterproductive,corned,cords,contemplate,concur,conceivable,cobblepot,chickened,checkout,carpe,cap'n,campers,buyin,bullies,braid,boxed,bouncy,blueberries,blubbering,bloodstream,bigamy,beeped,bearable,autographs,alarming,wretch,wimps,widower,whirlwind,whirl,warms,vandelay,unveiling,undoing,unbecoming,turnaround,touche,togetherness,tickles,ticker,teensy,taunt,sweethearts,stitched,standpoint,staffers,spotless,soothe,smothered,sickening,shouted,shepherds,shawl,seriousness,schooled,schoolboy,s'mores,roped,reminders,raggedy,preemptive,plucked,pheromones,particulars,pardoned,overpriced,overbearing,outrun,ohmigod,nosing,nicked,neanderthal,mosquitoes,mortified,milky,messin,mecha,markinson,marivellas,mannequin,manderley,madder,macready,lookie,locusts,lifetimes,lanna,lakhi,kholi,impersonate,hyperdrive,horrid,hopin,hogging,hearsay,harpy,harboring,hairdo,hafta,grasshopper,gobble,gatehouse,foosball,floozy,fished,firewood,finalize,felons,euphemism,entourage,elitist,elegance,drokken,drier,dredge,dossier,diseased,diarrhea,diagnose,despised,defuse,d'amour,contesting,conserve,conscientious,conjured,collars,clogs,chenille,chatty,chamomile,casing,calculator,brittle,breached,blurted,birthing,bikinis,astounding,assaulting,aroma,appliance,antsy,amnio,alienating,aliases,adolescence,xerox,wrongs,workload,willona,whistling,werewolves,wallaby,unwelcome,unseemly,unplug,undermining,ugliness,tyranny,tuesdays,trumpets,transference,ticks,tangible,tagging,swallowing,superheroes,studs,strep,stowed,stomping,steffy,sprain,spouting,sponsoring,sneezing,smeared,slink,shakin,sewed,seatbelt,scariest,scammed,sanctimonious,roasting,rightly,retinal,rethinking,resented,reruns,remover,racks,purest,progressing,presidente,preeclampsia,postponement,portals,poppa,pliers,pinning,pelvic,pampered,padding,overjoyed,ooooo,one'll,octavius,nonono,nicknames,neurosurgeon,narrows,misled,mislead,mishap,milltown,milking,meticulous,mediocrity,meatballs,machete,lurch,layin,knockin,khruschev,jurors,jumpin,jugular,jeweler,intellectually,inquiries,indulging,indestructible,indebted,imitate,ignores,hyperventilating,hyenas,hurrying,hermano,hellish,heheh,harshly,handout,grunemann,glances,giveaway,getup,gerome,furthest,frosting,frail,forwarded,forceful,flavored,flammable,flaky,fingered,fatherly,ethic,embezzlement,duffel,dotted,distressed,disobey,disappearances,dinky,diminish,diaphragm,deuces,creme,courteous,comforts,coerced,clots,clarification,chunks,chickie,chases,chaperoning,cartons,caper,calves,caged,bustin,bulging,bringin,boomhauer,blowin,blindfolded,biscotti,ballplayer,bagging,auster,assurances,aschen,arraigned,anonymity,alters,albatross,agreeable,adoring,abduct,wolfi,weirded,watchers,washroom,warheads,vincennes,urgency,understandably,uncomplicated,uhhhh,twitching,treadmill,thermos,tenorman,tangle,talkative,swarm,surrendering,summoning,strive,stilts,stickers,squashed,spraying,sparring,soaring,snort,sneezed,slaps,skanky,singin,sidle,shreck,shortness,shorthand,sharper,shamed,sadist,rydell,rusik,roulette,resumes,respiration,recount,reacts,purgatory,princesses,presentable,ponytail,plotted,pinot,pigtails,phillippe,peddling,paroled,orbed,offends,o'hara,moonlit,minefield,metaphors,malignant,mainframe,magicks,maggots,maclaine,loathing,leper,leaps,leaping,lashed,larch,larceny,lapses,ladyship,juncture,jiffy,jakov,invoke,infantile,inadmissible,horoscope,hinting,hideaway,hesitating,heddy,heckles,hairline,gripe,gratifying,governess,goebbels,freddo,foresee,fascination,exemplary,executioner,etcetera,escorts,endearing,eaters,earplugs,draped,disrupting,disagrees,dimes,devastate,detain,depositions,delicacy,darklighter,cynicism,cyanide,cutters,cronus,continuance,conquering,confiding,compartments,combing,cofell,clingy,cleanse,christmases,cheered,cheekbones,buttle,burdened,bruenell,broomstick,brained,bozos,bontecou,bluntman,blazes,blameless,bizarro,bellboy,beaucoup,barkeep,awaken,astray,assailant,appease,aphrodisiac,alleys,yesss,wrecks,woodpecker,wondrous,wimpy,willpower,wheeling,weepy,waxing,waive,videotaped,veritable,untouched,unlisted,unfounded,unforeseen,twinge,triggers,traipsing,toxin,tombstone,thumping,therein,testicles,telephones,tarmac,talby,tackled,swirling,suicides,suckered,subtitles,sturdy,strangler,stockbroker,stitching,steered,standup,squeal,sprinkler,spontaneously,splendor,spiking,spender,snipe,snagged,skimming,siddown,showroom,shovels,shotguns,shoelaces,shitload,shellfish,sharpest,shadowy,seizing,scrounge,scapegoat,sayonara,saddled,rummaging,roomful,renounce,reconsidered,recharge,realistically,radioed,quirks,quadrant,punctual,practising,pours,poolhouse,poltergeist,pocketbook,plainly,picnics,pesto,pawing,passageway,partied,oneself,numero,nostalgia,nitwit,neuro,mixer,meanest,mcbeal,matinee,margate,marce,manipulations,manhunt,manger,magicians,loafers,litvack,lightheaded,lifeguard,lawns,laughingstock,ingested,indignation,inconceivable,imposition,impersonal,imbecile,huddled,housewarming,horizons,homicides,hiccups,hearse,hardened,gushing,gushie,greased,goddamit,freelancer,forging,fondue,flustered,flung,flinch,flicker,fixin,festivus,fertilizer,farted,faggots,exonerate,evict,enormously,encrypted,emdash,embracing,duress,dupres,dowser,doormat,disfigured,disciplined,dibbs,depository,deathbed,dazzled,cuttin,cures,crowding,crepe,crammed,copycat,contradict,confidant,condemning,conceited,commute,comatose,clapping,circumference,chuppah,chore,choksondik,chestnuts,briault,bottomless,bonnet,blokes,berluti,beret,beggars,bankroll,bania,athos,arsenic,apperantly,ahhhhhh,afloat,accents,zipped,zeros,zeroes,zamir,yuppie,youngsters,yorkers,wisest,wipes,wield,whyn't,weirdos,wednesdays,vicksburg,upchuck,untraceable,unsupervised,unpleasantness,unhook,unconscionable,uncalled,trappings,tragedies,townie,thurgood,things'll,thine,tetanus,terrorize,temptations,tanning,tampons,swarming,straitjacket,steroid,startling,starry,squander,speculating,sollozzo,sneaked,slugs,skedaddle,sinker,silky,shortcomings,sellin,seasoned,scrubbed,screwup,scrapes,scarves,sandbox,salesmen,rooming,romances,revere,reproach,reprieve,rearranging,ravine,rationalize,raffle,punchy,psychobabble,provocation,profoundly,prescriptions,preferable,polishing,poached,pledges,pirelli,perverts,oversized,overdressed,outdid,nuptials,nefarious,mouthpiece,motels,mopping,mongrel,missin,metaphorically,mertin,memos,melodrama,melancholy,measles,meaner,mantel,maneuvering,mailroom,luring,listenin,lifeless,licks,levon,legwork,kneecaps,kippur,kiddie,kaput,justifiable,insistent,insidious,innuendo,innit,indecent,imaginable,horseshit,hemorrhoid,hella,healthiest,haywire,hamsters,hairbrush,grouchy,grisly,gratuitous,glutton,glimmer,gibberish,ghastly,gentler,generously,geeky,fuhrer,fronting,foolin,faxes,faceless,extinguisher,expel,etched,endangering,ducked,dodgeball,dives,dislocated,discrepancy,devour,derail,dementia,daycare,cynic,crumbling,cowardice,covet,cornwallis,corkscrew,cookbook,commandments,coincidental,cobwebs,clouded,clogging,clicking,clasp,chopsticks,chefs,chaps,cashing,carat,calmer,brazen,brainwashing,bradys,bowing,boned,bloodsucking,bleachers,bleached,bedpan,bearded,barrenger,bachelors,awwww,assures,assigning,asparagus,apprehend,anecdote,amoral,aggravation,afoot,acquaintances,accommodating,yakking,worshipping,wladek,willya,willies,wigged,whoosh,whisked,watered,warpath,volts,violates,valuables,uphill,unwise,untimely,unsavory,unresponsive,unpunished,unexplained,tubby,trolling,toxicology,tormented,toothache,tingly,timmiihh,thursdays,thoreau,terrifies,temperamental,telegrams,talkie,takers,symbiote,swirl,suffocate,stupider,strapping,steckler,springing,someway,sleepyhead,sledgehammer,slant,slams,showgirl,shoveling,shmoopy,sharkbait,shan't,scrambling,schematics,sandeman,sabbatical,rummy,reykjavik,revert,responsive,rescheduled,requisition,relinquish,rejoice,reckoning,recant,rebadow,reassurance,rattlesnake,ramble,primed,pricey,prance,pothole,pocus,persist,perpetrated,pekar,peeling,pastime,parmesan,pacemaker,overdrive,ominous,observant,nothings,noooooo,nonexistent,nodded,nieces,neglecting,nauseating,mutated,musket,mumbling,mowing,mouthful,mooseport,monologue,mistrust,meetin,masseuse,mantini,mailer,madre,lowlifes,locksmith,livid,liven,limos,liberating,lhasa,leniency,leering,laughable,lashes,lasagne,laceration,korben,katan,kalen,jittery,jammies,irreplaceable,intubate,intolerant,inhaler,inhaled,indifferent,indifference,impound,impolite,humbly,heroics,heigh,guillotine,guesthouse,grounding,grips,gossiping,goatee,gnomes,gellar,frutt,frobisher,freudian,foolishness,flagged,femme,fatso,fatherhood,fantasized,fairest,faintest,eyelids,extravagant,extraterrestrial,extraordinarily,escalator,elevate,drivel,dissed,dismal,disarray,dinnertime,devastation,dermatologist,delicately,defrost,debutante,debacle,damone,dainty,cuvee,culpa,crucified,creeped,crayons,courtship,convene,congresswoman,concocted,compromises,comprende,comma,coleslaw,clothed,clinically,chickenshit,checkin,cesspool,caskets,calzone,brothel,boomerang,bodega,blasphemy,bitsy,bicentennial,berlini,beatin,beards,barbas,barbarians,backpacking,arrhythmia,arousing,arbitrator,antagonize,angling,anesthetic,altercation,aggressor,adversity,acathla,aaahhh,wreaking,workup,wonderin,wither,wielding,what'm,what'cha,waxed,vibrating,veterinarian,venting,vasey,valor,validate,upholstery,untied,unscathed,uninterrupted,unforgiving,undies,uncut,twinkies,tucking,treatable,treasured,tranquility,townspeople,torso,tomei,tipsy,tinsel,tidings,thirtieth,tantrums,tamper,talky,swayed,swapping,suitor,stylist,stirs,standoff,sprinklers,sparkly,snobby,snatcher,smoother,sleepin,shrug,shoebox,sheesh,shackles,setbacks,sedatives,screeching,scorched,scanned,satyr,roadblock,riverbank,ridiculed,resentful,repellent,recreate,reconvene,rebuttal,realmedia,quizzes,questionnaire,punctured,pucker,prolong,professionalism,pleasantly,pigsty,penniless,paychecks,patiently,parading,overactive,ovaries,orderlies,oracles,oiled,offending,nudie,neonatal,neighborly,moops,moonlighting,mobilize,mmmmmm,milkshake,menial,meats,mayan,maxed,mangled,magua,lunacy,luckier,liters,lansbury,kooky,knowin,jeopardized,inkling,inhalation,inflated,infecting,incense,inbound,impractical,impenetrable,idealistic,i'mma,hypocrites,hurtin,humbled,hologram,hokey,hocus,hitchhiking,hemorrhoids,headhunter,hassled,harts,hardworking,haircuts,hacksaw,genitals,gazillion,gammy,gamesphere,fugue,footwear,folly,flashlights,fives,filet,extenuating,estrogen,entails,embezzled,eloquent,egomaniac,ducts,drowsy,drones,doree,donovon,disguises,diggin,deserting,depriving,defying,deductible,decorum,decked,daylights,daybreak,dashboard,damnation,cuddling,crunching,crickets,crazies,councilman,coughed,conundrum,complimented,cohaagen,clutching,clued,clader,cheques,checkpoint,chats,channeling,ceases,carasco,capisce,cantaloupe,cancelling,campsite,burglars,breakfasts,bra'tac,blueprint,bleedin,blabbed,beneficiary,basing,avert,atone,arlyn,approves,apothecary,antiseptic,aleikuum,advisement,zadir,wobbly,withnail,whattaya,whacking,wedged,wanders,vaginal,unimaginable,undeniable,unconditionally,uncharted,unbridled,tweezers,tvmegasite,trumped,triumphant,trimming,treading,tranquilizers,toontown,thunk,suture,suppressing,strays,stonewall,stogie,stepdaughter,stace,squint,spouses,splashed,speakin,sounder,sorrier,sorrel,sombrero,solemnly,softened,snobs,snippy,snare,smoothing,slump,slimeball,slaving,silently,shiller,shakedown,sensations,scrying,scrumptious,screamin,saucy,santoses,roundup,roughed,rosary,robechaux,retrospect,rescind,reprehensible,repel,remodeling,reconsidering,reciprocate,railroaded,psychics,promos,prob'ly,pristine,printout,priestess,prenuptial,precedes,pouty,phoning,peppy,pariah,parched,panes,overloaded,overdoing,nymphs,nother,notebooks,nearing,nearer,monstrosity,milady,mieke,mephesto,medicated,marshals,manilow,mammogram,m'lady,lotsa,loopy,lesion,lenient,learner,laszlo,kross,kinks,jinxed,involuntary,insubordination,ingrate,inflatable,incarnate,inane,hypoglycemia,huntin,humongous,hoodlum,honking,hemorrhage,helpin,hathor,hatching,grotto,grandmama,gorillas,godless,girlish,ghouls,gershwin,frosted,flutter,flagpole,fetching,fatter,faithfully,exert,evasion,escalate,enticing,enchantress,elopement,drills,downtime,downloading,dorks,doorways,divulge,dissociative,disgraceful,disconcerting,deteriorate,destinies,depressive,dented,denim,decruz,decidedly,deactivate,daydreams,curls,culprit,cruelest,crippling,cranberries,corvis,copped,commend,coastguard,cloning,cirque,churning,chock,chivalry,catalogues,cartwheels,carols,canister,buttered,bundt,buljanoff,bubbling,brokers,broaden,brimstone,brainless,bores,badmouthing,autopilot,ascertain,aorta,ampata,allenby,accosted,absolve,aborted,aaagh,aaaaaah,yonder,yellin,wyndham,wrongdoing,woodsboro,wigging,wasteland,warranty,waltzed,walnuts,vividly,veggie,unnecessarily,unloaded,unicorns,understated,unclean,umbrellas,twirling,turpentine,tupperware,triage,treehouse,tidbit,tickled,threes,thousandth,thingie,terminally,teething,tassel,talkies,swoon,switchboard,swerved,suspiciously,subsequentlyne,subscribe,strudel,stroking,strictest,stensland,starin,stannart,squirming,squealing,sorely,softie,snookums,sniveling,smidge,sloth,skulking,simian,sightseeing,siamese,shudder,shoppers,sharpen,shannen,semtex,secondhand,seance,scowl,scorn,safekeeping,russe,rummage,roshman,roomies,roaches,rinds,retrace,retires,resuscitate,rerun,reputations,rekall,refreshment,reenactment,recluse,ravioli,raves,raking,purses,punishable,punchline,puked,prosky,previews,poughkeepsie,poppins,polluted,placenta,pissy,petulant,perseverance,pears,pawns,pastries,partake,panky,palate,overzealous,orchids,obstructing,objectively,obituaries,obedient,nothingness,musty,motherly,mooning,momentous,mistaking,minutemen,milos,microchip,meself,merciless,menelaus,mazel,masturbate,mahogany,lysistrata,lillienfield,likable,liberate,leveled,letdown,larynx,lardass,lainey,lagged,klorel,kidnappings,keyed,karmic,jeebies,irate,invulnerable,intrusive,insemination,inquire,injecting,informative,informants,impure,impasse,imbalance,illiterate,hurled,hunts,hematoma,headstrong,handmade,handiwork,growling,gorky,getcha,gesundheit,gazing,galley,foolishly,fondness,floris,ferocious,feathered,fateful,fancies,fakes,faker,expire,ever'body,essentials,eskimos,enlightening,enchilada,emissary,embolism,elsinore,ecklie,drenched,drazi,doped,dogging,doable,dislikes,dishonesty,disengage,discouraging,derailed,deformed,deflect,defer,deactivated,crips,constellations,congressmen,complimenting,clubbing,clawing,chromium,chimes,chews,cheatin,chaste,cellblock,caving,catered,catacombs,calamari,bucking,brulee,brits,brisk,breezes,bounces,boudoir,binks,better'n,bellied,behrani,behaves,bedding,balmy,badmouth,backers,avenging,aromatherapy,armpit,armoire,anythin,anonymously,anniversaries,aftershave,affliction,adrift,admissible,adieu,acquittal,yucky,yearn,whitter,whirlpool,wendigo,watchdog,wannabes,wakey,vomited,voicemail,valedictorian,uttered,unwed,unrequited,unnoticed,unnerving,unkind,unjust,uniformed,unconfirmed,unadulterated,unaccounted,uglier,turnoff,trampled,tramell,toads,timbuktu,throwback,thimble,tasteless,tarantula,tamale,takeovers,swish,supposing,streaking,stargher,stanzi,stabs,squeamish,splattered,spiritually,spilt,speciality,smacking,skywire,skips,skaara,simpatico,shredding,showin,shortcuts,shite,shielding,shamelessly,serafine,sentimentality,seasick,schemer,scandalous,sainted,riedenschneider,rhyming,revel,retractor,retards,resurrect,remiss,reminiscing,remanded,reiben,regains,refuel,refresher,redoing,redheaded,reassured,rearranged,rapport,qumar,prowling,prejudices,precarious,powwow,pondering,plunger,plunged,pleasantville,playpen,phlegm,perfected,pancreas,paley,ovary,outbursts,oppressed,ooohhh,omoroca,offed,o'toole,nurture,nursemaid,nosebleed,necktie,muttering,munchies,mucking,mogul,mitosis,misdemeanor,miscarried,millionth,migraines,midler,manicurist,mandelbaum,manageable,malfunctioned,magnanimous,loudmouth,longed,lifestyles,liddy,lickety,leprechauns,komako,klute,kennel,justifying,irreversible,inventing,intergalactic,insinuate,inquiring,ingenuity,inconclusive,incessant,improv,impersonation,hyena,humperdinck,hubba,housework,hoffa,hither,hissy,hippy,hijacked,heparin,hellooo,hearth,hassles,hairstyle,hahahaha,hadda,guys'll,gutted,gulls,gritty,grievous,graft,gossamer,gooder,gambled,gadgets,fundamentals,frustrations,frolicking,frock,frilly,foreseen,footloose,fondly,flirtation,flinched,flatten,farthest,exposer,evading,escrow,empathize,embryos,embodiment,ellsberg,ebola,dulcinea,dreamin,drawbacks,doting,doose,doofy,disturbs,disorderly,disgusts,detox,denominator,demeanor,deliriously,decode,debauchery,croissant,cravings,cranked,coworkers,councilor,confuses,confiscate,confines,conduit,compress,combed,clouding,clamps,cinch,chinnery,celebratory,catalogs,carpenters,carnal,canin,bundys,bulldozer,buggers,bueller,brainy,booming,bookstores,bloodbath,bittersweet,bellhop,beeping,beanstalk,beady,baudelaire,bartenders,bargains,averted,armadillo,appreciating,appraised,antlers,aloof,allowances,alleyway,affleck,abject,zilch,youore,xanax,wrenching,wouldn,witted,wicca,whorehouse,whooo,whips,vouchers,victimized,vicodin,untested,unsolicited,unfocused,unfettered,unfeeling,unexplainable,understaffed,underbelly,tutorial,tryst,trampoline,towering,tirade,thieving,thang,swimmin,swayzak,suspecting,superstitions,stubbornness,streamers,strattman,stonewalling,stiffs,stacking,spout,splice,sonrisa,smarmy,slows,slicing,sisterly,shrill,shined,seeming,sedley,seatbelts,scour,scold,schoolyard,scarring,salieri,rustling,roxbury,rewire,revved,retriever,reputable,remodel,reins,reincarnation,rance,rafters,rackets,quail,pumbaa,proclaim,probing,privates,pried,prewedding,premeditation,posturing,posterity,pleasurable,pizzeria,pimps,penmanship,penchant,pelvis,overturn,overstepped,overcoat,ovens,outsmart,outed,ooohh,oncologist,omission,offhand,odour,nyazian,notarized,nobody'll,nightie,navel,nabbed,mystique,mover,mortician,morose,moratorium,mockingbird,mobsters,mingling,methinks,messengered,merde,masochist,martouf,martians,marinara,manray,majorly,magnifying,mackerel,lurid,lugging,lonnegan,loathsome,llantano,liberace,leprosy,latinos,lanterns,lamest,laferette,kraut,intestine,innocencia,inhibitions,ineffectual,indisposed,incurable,inconvenienced,inanimate,improbable,implode,hydrant,hustling,hustled,huevos,how'm,hooey,hoods,honcho,hinge,hijack,heimlich,hamunaptra,haladki,haiku,haggle,gutsy,grunting,grueling,gribbs,greevy,grandstanding,godparents,glows,glistening,gimmick,gaping,fraiser,formalities,foreigner,folders,foggy,fitty,fiends,fe'nos,favours,eyeing,extort,expedite,escalating,epinephrine,entitles,entice,eminence,eights,earthlings,eagerly,dunville,dugout,doublemeat,doling,dispensing,dispatcher,discoloration,diners,diddly,dictates,diazepam,derogatory,delights,defies,decoder,dealio,danson,cutthroat,crumbles,croissants,crematorium,craftsmanship,could'a,cordless,cools,conked,confine,concealing,complicates,communique,cockamamie,coasters,clobbered,clipping,clipboard,clemenza,cleanser,circumcision,chanukah,certainaly,cellmate,cancels,cadmium,buzzed,bumstead,bucko,browsing,broth,braver,boggling,bobbing,blurred,birkhead,benet,belvedere,bellies,begrudge,beckworth,banky,baldness,baggy,babysitters,aversion,astonished,assorted,appetites,angina,amiss,ambulances,alibis,airway,admires,adhesive,yoyou,xxxxxx,wreaked,wracking,woooo,wooing,wised,wilshire,wedgie,waging,violets,vincey,uplifting,untrustworthy,unmitigated,uneventful,undressing,underprivileged,unburden,umbilical,tweaking,turquoise,treachery,tosses,torching,toothpick,toasts,thickens,tereza,tenacious,teldar,taint,swill,sweatin,subtly,subdural,streep,stopwatch,stockholder,stillwater,stalkers,squished,squeegee,splinters,spliced,splat,spied,spackle,sophistication,snapshots,smite,sluggish,slithered,skeeters,sidewalks,sickly,shrugs,shrubbery,shrieking,shitless,settin,sentinels,selfishly,scarcely,sangria,sanctum,sahjhan,rustle,roving,rousing,rosomorf,riddled,responsibly,renoir,remoray,remedial,refundable,redirect,recheck,ravenwood,rationalizing,ramus,ramelle,quivering,pyjamas,psychos,provocations,prouder,protestors,prodded,proctologist,primordial,pricks,prickly,precedents,pentangeli,pathetically,parka,parakeet,panicky,overthruster,outsmarted,orthopedic,oncoming,offing,nutritious,nuthouse,nourishment,nibbling,newlywed,narcissist,mutilation,mundane,mummies,mumble,mowed,morvern,mortem,mopes,molasses,misplace,miscommunication,miney,midlife,menacing,memorizing,massaging,masking,magnets,luxuries,lounging,lothario,liposuction,lidocaine,libbets,levitate,leeway,launcelot,larek,lackeys,kumbaya,kryptonite,knapsack,keyhole,katarangura,juiced,jakey,ironclad,invoice,intertwined,interlude,interferes,injure,infernal,indeedy,incur,incorrigible,incantations,impediment,igloo,hysterectomy,hounded,hollering,hindsight,heebie,havesham,hasenfuss,hankering,hangers,hakuna,gutless,gusto,grubbing,grrrr,grazed,gratification,grandeur,gorak,godammit,gnawing,glanced,frostbite,frees,frazzled,fraulein,fraternizing,fortuneteller,formaldehyde,followup,foggiest,flunky,flickering,firecrackers,figger,fetuses,fates,eyeliner,extremities,extradited,expires,exceedingly,evaporate,erupt,epileptic,entrails,emporium,egregious,eggshells,easing,duwayne,droll,dreyfuss,dovey,doubly,doozy,donkeys,donde,distrust,distressing,disintegrate,discreetly,decapitated,dealin,deader,dashed,darkroom,dares,daddies,dabble,cushy,cupcakes,cuffed,croupier,croak,crapped,coursing,coolers,contaminate,consummated,construed,condos,concoction,compulsion,commish,coercion,clemency,clairvoyant,circulate,chesterton,checkered,charlatan,chaperones,categorically,cataracts,carano,capsules,capitalize,burdon,bullshitting,brewed,breathless,breasted,brainstorming,bossing,borealis,bonsoir,bobka,boast,blimp,bleep,bleeder,blackouts,bisque,billboards,beatings,bayberry,bashed,bamboozled,balding,baklava,baffled,backfires,babak,awkwardness,attest,attachments,apologizes,anyhoo,antiquated,alcante,advisable,aahhh,aaahh,zatarc,yearbooks,wuddya,wringing,womanhood,witless,winging,whatsa,wetting,waterproof,wastin,vogelman,vocation,vindicated,vigilance,vicariously,venza,vacuuming,utensils,uplink,unveil,unloved,unloading,uninhibited,unattached,tweaked,turnips,trinkets,toughen,toting,topside,terrors,terrify,technologically,tarnish,tagliati,szpilman,surly,supple,summation,suckin,stepmom,squeaking,splashmore,souffle,solitaire,solicitation,solarium,smokers,slugged,slobbering,skylight,skimpy,sinuses,silenced,sideburns,shrinkage,shoddy,shhhhhh,shelled,shareef,shangri,seuss,serenade,scuffle,scoff,scanners,sauerkraut,sardines,sarcophagus,salvy,rusted,russells,rowboat,rolfsky,ringside,respectability,reparations,renegotiate,reminisce,reimburse,regimen,raincoat,quibble,puzzled,purposefully,pubic,proofing,prescribing,prelim,poisons,poaching,personalized,personable,peroxide,pentonville,payphone,payoffs,paleontology,overflowing,oompa,oddest,objecting,o'hare,o'daniel,notches,nobody'd,nightstand,neutralized,nervousness,nerdy,needlessly,naquadah,nappy,nantucket,nambla,mountaineer,motherfuckin,morrie,monopolizing,mohel,mistreated,misreading,misbehave,miramax,minivan,milligram,milkshakes,metamorphosis,medics,mattresses,mathesar,matchbook,matata,marys,malucci,magilla,lymphoma,lowers,lordy,linens,lindenmeyer,limelight,leapt,laxative,lather,lapel,lamppost,laguardia,kindling,kegger,kawalsky,juries,jokin,jesminder,interning,innermost,injun,infallible,industrious,indulgence,incinerator,impossibility,impart,illuminate,iguanas,hypnotic,hyped,hospitable,hoses,homemaker,hirschmuller,helpers,headset,guardianship,guapo,grubby,granola,granddaddy,goren,goblet,gluttony,globes,giorno,getter,geritol,gassed,gaggle,foxhole,fouled,foretold,floorboards,flippers,flaked,fireflies,feedings,fashionably,farragut,fallback,facials,exterminate,excites,everything'll,evenin,ethically,ensue,enema,empath,eluded,eloquently,eject,edema,dumpling,droppings,dolled,distasteful,disputing,displeasure,disdain,deterrent,dehydration,defied,decomposing,dawned,dailies,custodian,crusts,crucifix,crowning,crier,crept,craze,crawls,couldn,correcting,corkmaster,copperfield,cooties,contraption,consumes,conspire,consenting,consented,conquers,congeniality,complains,communicator,commendable,collide,coladas,colada,clout,clooney,classifieds,clammy,civility,cirrhosis,chink,catskills,carvers,carpool,carelessness,cardio,carbs,capades,butabi,busmalis,burping,burdens,bunks,buncha,bulldozers,browse,brockovich,breakthroughs,bravado,boogety,blossoms,blooming,bloodsucker,blight,betterton,betrayer,belittle,beeps,bawling,barts,bartending,bankbooks,babish,atropine,assertive,armbrust,anyanka,annoyance,anemic,anago,airwaves,aimlessly,aaargh,aaand,yoghurt,writhing,workable,winking,winded,widen,whooping,whiter,whatya,wazoo,voila,virile,vests,vestibule,versed,vanishes,urkel,uproot,unwarranted,unscheduled,unparalleled,undergrad,tweedle,turtleneck,turban,trickery,transponder,toyed,townhouse,thyself,thunderstorm,thinning,thawed,tether,technicalities,tau'ri,tarnished,taffeta,tacked,systolic,swerve,sweepstakes,swabs,suspenders,superwoman,sunsets,succulent,subpoenas,stumper,stosh,stomachache,stewed,steppin,stepatech,stateside,spicoli,sparing,soulless,sonnets,sockets,snatching,smothering,slush,sloman,slashing,sitters,simpleton,sighs,sidra,sickens,shunned,shrunken,showbiz,shopped,shimmering,shagging,semblance,segue,sedation,scuzzlebutt,scumbags,screwin,scoundrels,scarsdale,scabs,saucers,saintly,saddened,runaways,runaround,rheya,resenting,rehashing,rehabilitated,regrettable,refreshed,redial,reconnecting,ravenous,raping,rafting,quandary,pylea,putrid,puffing,psychopathic,prunes,probate,prayin,pomegranate,plummeting,planing,plagues,pinata,pithy,perversion,personals,perched,peeps,peckish,pavarotti,pajama,packin,pacifier,overstepping,okama,obstetrician,nutso,nuance,normalcy,nonnegotiable,nomak,ninny,nines,nicey,newsflash,neutered,nether,negligee,necrosis,navigating,narcissistic,mylie,muses,momento,moisturizer,moderation,misinformed,misconception,minnifield,mikkos,methodical,mebbe,meager,maybes,matchmaking,masry,markovic,malakai,luzhin,lusting,lumberjack,loopholes,loaning,lightening,leotard,launder,lamaze,kubla,kneeling,kibosh,jumpsuit,joliet,jogger,janover,jakovasaurs,irreparable,innocently,inigo,infomercial,inexplicable,indispensable,impregnated,impossibly,imitating,hunches,hummus,houmfort,hothead,hostiles,hooves,hooligans,homos,homie,hisself,heyyy,hesitant,hangout,handsomest,handouts,hairless,gwennie,guzzling,guinevere,grungy,goading,glaring,gavel,gardino,gangrene,fruitful,friendlier,freckle,freakish,forthright,forearm,footnote,flops,fixer,firecracker,finito,figgered,fezzik,fastened,farfetched,fanciful,familiarize,faire,fahrenheit,extravaganza,exploratory,explanatory,everglades,eunuch,estas,escapade,erasers,emptying,embarassing,dweeb,dutiful,dumplings,dries,drafty,dollhouse,dismissing,disgraced,discrepancies,disbelief,disagreeing,digestion,didnt,deviled,deviated,demerol,delectable,decaying,decadent,dears,dateless,d'algout,cultivating,cryto,crumpled,crumbled,cronies,crease,craves,cozying,corduroy,congratulated,confidante,compressions,complicating,compadre,coerce,classier,chums,chumash,chivalrous,chinpoko,charred,chafing,celibacy,carted,carryin,carpeting,carotid,cannibals,candor,butterscotch,busts,busier,bullcrap,buggin,brookside,brodski,brassiere,brainwash,brainiac,botrelle,bonbon,boatload,blimey,blaring,blackness,bipartisan,bimbos,bigamist,biebe,biding,betrayals,bestow,bellerophon,bedpans,bassinet,basking,barzini,barnyard,barfed,backups,audited,asinine,asalaam,arouse,applejack,annoys,anchovies,ampule,alameida,aggravate,adage,accomplices,yokel,y'ever,wringer,witwer,withdrawals,windward,willfully,whorfin,whimsical,whimpering,weddin,weathered,warmest,wanton,volant,visceral,vindication,veggies,urinate,uproar,unwritten,unwrap,unsung,unsubstantiated,unspeakably,unscrupulous,unraveling,unquote,unqualified,unfulfilled,undetectable,underlined,unattainable,unappreciated,ummmm,ulcers,tylenol,tweak,turnin,tuatha,tropez,trellis,toppings,tootin,toodle,tinkering,thrives,thespis,theatrics,thatherton,tempers,tavington,tartar,tampon,swelled,sutures,sustenance,sunflowers,sublet,stubbins,strutting,strewn,stowaway,stoic,sternin,stabilizing,spiraling,spinster,speedometer,speakeasy,soooo,soiled,sneakin,smithereens,smelt,smacks,slaughterhouse,slacks,skids,sketching,skateboards,sizzling,sixes,sirree,simplistic,shouts,shorted,shoelace,sheeit,shards,shackled,sequestered,selmak,seduces,seclusion,seamstress,seabeas,scoops,scooped,scavenger,satch,s'more,rudeness,romancing,rioja,rifkin,rieper,revise,reunions,repugnant,replicating,repaid,renewing,relaxes,rekindle,regrettably,regenerate,reels,reciting,reappear,readin,ratting,rapes,rancher,rammed,rainstorm,railroading,queers,punxsutawney,punishes,pssst,prudy,proudest,protectors,procrastinating,proactive,priss,postmortem,pompoms,poise,pickings,perfectionist,peretti,people'll,pecking,patrolman,paralegal,paragraphs,paparazzi,pankot,pampering,overstep,overpower,outweigh,omnipotent,odious,nuwanda,nurtured,newsroom,neeson,needlepoint,necklaces,neato,muggers,muffler,mousy,mourned,mosey,mopey,mongolians,moldy,misinterpret,minibar,microfilm,mendola,mended,melissande,masturbating,masbath,manipulates,maimed,mailboxes,magnetism,m'lord,m'honey,lymph,lunge,lovelier,lefferts,leezak,ledgers,larraby,laloosh,kundun,kozinski,knockoff,kissin,kiosk,kennedys,kellman,karlo,kaleidoscope,jeffy,jaywalking,instructing,infraction,informer,infarction,impulsively,impressing,impersonated,impeach,idiocy,hyperbole,hurray,humped,huhuh,hsing,hordes,hoodlums,honky,hitchhiker,hideously,heaving,heathcliff,headgear,headboard,hazing,harem,handprint,hairspray,gutiurrez,goosebumps,gondola,glitches,gasping,frolic,freeways,frayed,fortitude,forgetful,forefathers,fonder,foiled,foaming,flossing,flailing,fitzgeralds,firehouse,finders,fiftieth,fellah,fawning,farquaad,faraway,fancied,extremists,exorcist,exhale,ethros,entrust,ennui,energized,encephalitis,embezzling,elster,elixir,electrolytes,duplex,dryers,drexl,dredging,drawback,don'ts,dobisch,divorcee,disrespected,disprove,disobeying,disinfectant,dingy,digress,dieting,dictating,devoured,devise,detonators,desist,deserter,derriere,deron,deceptive,debilitating,deathwok,daffodils,curtsy,cursory,cuppa,cumin,cronkite,cremation,credence,cranking,coverup,courted,countin,counselling,cornball,contentment,consensual,compost,cluett,cleverly,cleansed,cleanliness,chopec,chomp,chins,chime,cheswick,chessler,cheapest,chatted,cauliflower,catharsis,catchin,caress,camcorder,calorie,cackling,bystanders,buttoned,buttering,butted,buries,burgel,buffoon,brogna,bragged,boutros,bogeyman,blurting,blurb,blowup,bloodhound,blissful,birthmark,bigot,bestest,belted,belligerent,beggin,befall,beeswax,beatnik,beaming,barricade,baggoli,badness,awoke,artsy,artful,aroun,armpits,arming,annihilate,anise,angiogram,anaesthetic,amorous,ambiance,alligators,adoration,admittance,adama,abydos,zonked,zhivago,yorkin,wrongfully,writin,wrappers,worrywart,woops,wonderfalls,womanly,wickedness,whoopie,wholeheartedly,whimper,which'll,wheelchairs,what'ya,warranted,wallop,wading,wacked,virginal,vermouth,vermeil,verger,ventriss,veneer,vampira,utero,ushers,urgently,untoward,unshakable,unsettled,unruly,unlocks,ungodly,undue,uncooperative,uncontrollably,unbeatable,twitchy,tumbler,truest,triumphs,triplicate,tribbey,tortures,tongaree,tightening,thorazine,theres,testifies,teenaged,tearful,taxing,taldor,syllabus,swoops,swingin,suspending,sunburn,stuttering,stupor,strides,strategize,strangulation,stooped,stipulation,stingy,stapled,squeaks,squawking,spoilsport,splicing,spiel,spencers,spasms,spaniard,softener,sodding,soapbox,smoldering,smithbauer,skittish,sifting,sickest,sicilians,shuffling,shrivel,segretti,seeping,securely,scurrying,scrunch,scrote,screwups,schenkman,sawing,savin,satine,sapiens,salvaging,salmonella,sacrilege,rumpus,ruffle,roughing,rotted,rondall,ridding,rickshaw,rialto,rhinestone,restrooms,reroute,requisite,repress,rednecks,redeeming,rayed,ravell,raked,raincheck,raffi,racked,pushin,profess,prodding,procure,presuming,preppy,prednisone,potted,posttraumatic,poorhouse,podiatrist,plowed,pledging,playroom,plait,placate,pinback,picketing,photographing,pharoah,petrak,petal,persecuting,perchance,pellets,peeved,peerless,payable,pauses,pathologist,pagliacci,overwrought,overreaction,overqualified,overheated,outcasts,otherworldly,opinionated,oodles,oftentimes,occured,obstinate,nutritionist,numbness,nubile,nooooooo,nobodies,nepotism,neanderthals,mushu,mucus,mothering,mothballs,monogrammed,molesting,misspoke,misspelled,misconstrued,miscalculated,minimums,mince,mildew,mighta,middleman,mementos,mellowed,mayol,mauled,massaged,marmalade,mardi,makings,lundegaard,lovingly,loudest,lotto,loosing,loompa,looming,longs,loathes,littlest,littering,lifelike,legalities,laundered,lapdog,lacerations,kopalski,knobs,knitted,kittridge,kidnaps,kerosene,karras,jungles,jockeys,iranoff,invoices,invigorating,insolence,insincere,insectopia,inhumane,inhaling,ingrates,infestation,individuality,indeterminate,incomprehensible,inadequacy,impropriety,importer,imaginations,illuminating,ignite,hysterics,hypodermic,hyperventilate,hyperactive,humoring,honeymooning,honed,hoist,hoarding,hitching,hiker,hightail,hemoglobin,hell'd,heinie,growin,grasped,grandparent,granddaughters,gouged,goblins,gleam,glades,gigantor,get'em,geriatric,gatekeeper,gargoyles,gardenias,garcon,garbo,gallows,gabbing,futon,fulla,frightful,freshener,fortuitous,forceps,fogged,fodder,foamy,flogging,flaun,flared,fireplaces,feverish,favell,fattest,fattening,fallow,extraordinaire,evacuating,errant,envied,enchant,enamored,egocentric,dussander,dunwitty,dullest,dropout,dredged,dorsia,doornail,donot,dongs,dogged,dodgy,ditty,dishonorable,discriminating,discontinue,dings,dilly,dictation,dialysis,delly,delightfully,daryll,dandruff,cruddy,croquet,cringe,crimp,credo,crackling,courtside,counteroffer,counterfeiting,corrupting,copping,conveyor,contusions,contusion,conspirator,consoling,connoisseur,confetti,composure,compel,colic,coddle,cocksuckers,coattails,cloned,claustrophobia,clamoring,churn,chugga,chirping,chasin,chapped,chalkboard,centimeter,caymans,catheter,casings,caprica,capelli,cannolis,cannoli,camogli,camembert,butchers,butchered,busboys,bureaucrats,buckled,bubbe,brownstone,bravely,brackley,bouquets,botox,boozing,boosters,bodhi,blunders,blunder,blockage,biocyte,betrays,bested,beryllium,beheading,beggar,begbie,beamed,bastille,barstool,barricades,barbecues,barbecued,bandwagon,backfiring,bacarra,avenged,autopsies,aunties,associating,artichoke,arrowhead,appendage,apostrophe,antacid,ansel,annul,amuses,amped,amicable,amberg,alluring,adversaries,admirers,adlai,acupuncture,abnormality,aaaahhhh,zooming,zippity,zipping,zeroed,yuletide,yoyodyne,yengeese,yeahhh,wrinkly,wracked,withered,winks,windmills,whopping,wendle,weigart,waterworks,waterbed,watchful,wantin,wagging,waaah,vying,ventricle,varnish,vacuumed,unreachable,unprovoked,unmistakable,unfriendly,unfolding,underpaid,uncuff,unappealing,unabomber,typhoid,tuxedos,tushie,turds,tumnus,troubadour,trinium,treaters,treads,transpired,transgression,tought,thready,thins,thinners,techs,teary,tattaglia,tassels,tarzana,tanking,tablecloths,synchronize,symptomatic,sycophant,swimmingly,sweatshop,surfboard,superpowers,sunroom,sunblock,sugarplum,stupidly,strumpet,strapless,stooping,stools,stealthy,stalks,stairmaster,staffer,sshhh,squatting,squatters,spectacularly,sorbet,socked,sociable,snubbed,snorting,sniffles,snazzy,snakebite,smuggler,smorgasbord,smooching,slurping,slouch,slingshot,slaved,skimmed,sisterhood,silliest,sidarthur,sheraton,shebang,sharpening,shanghaied,shakers,sendoff,scurvy,scoliosis,scaredy,scagnetti,sawchuk,saugus,sasquatch,sandbag,saltines,s'pose,roston,rostle,riveting,ristle,rifling,revulsion,reverently,retrograde,restful,resents,reptilian,reorganize,renovating,reiterate,reinvent,reinmar,reibers,reechard,recuse,reconciling,recognizance,reclaiming,recitation,recieved,rebate,reacquainted,rascals,railly,quintuplets,quahog,pygmies,puzzling,punctuality,prosthetic,proms,probie,preys,preserver,preppie,poachers,plummet,plumbers,plannin,pitying,pitfalls,piqued,pinecrest,pinches,pillage,pigheaded,physique,pessimistic,persecute,perjure,percentile,pentothal,pensky,penises,peini,pazzi,pastels,parlour,paperweight,pamper,pained,overwhelm,overalls,outrank,outpouring,outhouse,outage,ouija,obstructed,obsessions,obeying,obese,o'riley,o'higgins,nosebleeds,norad,noooooooo,nononono,nonchalant,nippy,neurosis,nekhorvich,necronomicon,naquada,n'est,mystik,mystified,mumps,muddle,mothership,moped,monumentally,monogamous,mondesi,misogynistic,misinterpreting,mindlock,mending,megaphone,meeny,medicating,meanie,masseur,markstrom,marklars,margueritas,manifesting,maharajah,lukewarm,loveliest,loran,lizardo,liquored,lipped,lingers,limey,lemkin,leisurely,lathe,latched,lapping,ladle,krevlorneswath,kosygin,khakis,kenaru,keats,kaitlan,julliard,jollies,jaundice,jargon,jackals,invisibility,insipid,inflamed,inferiority,inexperience,incinerated,incinerate,incendiary,incan,inbred,implicating,impersonator,hunks,horsing,hooded,hippopotamus,hiked,hetson,hetero,hessian,henslowe,hendler,hellstrom,headstone,hayloft,harbucks,handguns,hallucinate,haldol,haggling,gynaecologist,gulag,guilder,guaranteeing,groundskeeper,grindstone,grimoir,grievance,griddle,gribbit,greystone,graceland,gooders,goeth,gentlemanly,gelatin,gawking,ganged,fukes,fromby,frenchmen,foursome,forsley,forbids,footwork,foothold,floater,flinging,flicking,fittest,fistfight,fireballs,fillings,fiddling,fennyman,felonious,felonies,feces,favoritism,fatten,fanatics,faceman,excusing,excepted,entwined,entree,ensconced,eladio,ehrlichman,easterland,dueling,dribbling,drape,downtrodden,doused,dosed,dorleen,dokie,distort,displeased,disown,dismount,disinherited,disarmed,disapproves,diperna,dined,diligent,dicaprio,depress,decoded,debatable,dealey,darsh,damsels,damning,dad'll,d'oeuvre,curlers,curie,cubed,crikey,crepes,countrymen,cornfield,coppers,copilot,copier,cooing,conspiracies,consigliere,condoning,commoner,commies,combust,comas,colds,clawed,clamped,choosy,chomping,chimps,chigorin,chianti,cheep,checkups,cheaters,celibate,cautiously,cautionary,castell,carpentry,caroling,carjacking,caritas,caregiver,cardiology,candlesticks,canasta,cain't,burro,burnin,bunking,bumming,bullwinkle,brummel,brooms,brews,breathin,braslow,bracing,botulism,boorish,bloodless,blayne,blatantly,blankie,bedbugs,becuase,barmaid,bared,baracus,banal,bakes,backpacks,attentions,atrocious,ativan,athame,asunder,astound,assuring,aspirins,asphyxiation,ashtrays,aryans,arnon,apprehension,applauding,anvil,antiquing,antidepressants,annoyingly,amputate,altruistic,alotta,alerting,afterthought,affront,affirm,actuality,abysmal,absentee,yeller,yakushova,wuzzy,wriggle,worrier,woogyman,womanizer,windpipe,windbag,willin,whisking,whimsy,wendall,weeny,weensy,weasels,watery,watcha,wasteful,waski,washcloth,waaay,vouched,viznick,ventriloquist,vendettas,veils,vayhue,vamanos,vadimus,upstage,uppity,unsaid,unlocking,unintentionally,undetected,undecided,uncaring,unbearably,tween,tryout,trotting,trini,trimmings,trickier,treatin,treadstone,trashcan,transcendent,tramps,townsfolk,torturous,torrid,toothpicks,tolerable,tireless,tiptoeing,timmay,tillinghouse,tidying,tibia,thumbing,thrusters,thrashing,these'll,thatos,testicular,teriyaki,tenors,tenacity,tellers,telemetry,tarragon,switchblade,swicker,swells,sweatshirts,swatches,surging,supremely,sump'n,succumb,subsidize,stumbles,stuffs,stoppin,stipulate,stenographer,steamroll,stasis,stagger,squandered,splint,splendidly,splashy,splashing,specter,sorcerers,somewheres,somber,snuggled,snowmobile,sniffed,snags,smugglers,smudged,smirking,smearing,slings,sleet,sleepovers,sleek,slackers,siree,siphoning,singed,sincerest,sickened,shuffled,shriveled,shorthanded,shittin,shish,shipwrecked,shins,sheetrock,shawshank,shamu,sha're,servitude,sequins,seascape,scrapings,scoured,scorching,sandpaper,saluting,salud,ruffled,roughnecks,rougher,rosslyn,rosses,roost,roomy,romping,revolutionize,reprimanded,refute,refrigerated,reeled,redundancies,rectal,recklessly,receding,reassignment,reapers,readout,ration,raring,ramblings,raccoons,quarantined,purging,punters,psychically,premarital,pregnancies,predisposed,precautionary,pollute,podunk,plums,plaything,pixilated,pitting,piranhas,pieced,piddles,pickled,photogenic,phosphorous,pffft,pestilence,pessimist,perspiration,perps,penticoff,passageways,pardons,panics,pancamo,paleontologist,overwhelms,overstating,overpaid,overdid,outlive,orthodontist,orgies,oreos,ordover,ordinates,ooooooh,oooohhh,omelettes,officiate,obtuse,obits,nymph,novocaine,noooooooooo,nipping,nilly,nightstick,negate,neatness,natured,narcotic,narcissism,namun,nakatomi,murky,muchacho,mouthwash,motzah,morsel,morph,morlocks,mooch,moloch,molest,mohra,modus,modicum,mockolate,misdemeanors,miscalculation,middies,meringue,mercilessly,meditating,mayakovsky,maximillian,marlee,markovski,maniacal,maneuvered,magnificence,maddening,lutze,lunged,lovelies,lorry,loosening,lookee,littered,lilac,lightened,laces,kurzon,kurtzweil,kind've,kimono,kenji,kembu,keanu,kazuo,jonesing,jilted,jiggling,jewelers,jewbilee,jacqnoud,jacksons,ivories,insurmountable,innocuous,innkeeper,infantery,indulged,indescribable,incoherent,impervious,impertinent,imperfections,hunnert,huffy,horsies,horseradish,hollowed,hogwash,hockley,hissing,hiromitsu,hidin,hereafter,helpmann,hehehe,haughty,happenings,hankie,handsomely,halliwells,haklar,haise,gunsights,grossly,grope,grocer,grits,gripping,grabby,glorificus,gizzard,gilardi,gibarian,geminon,gasses,garnish,galloping,gairwyn,futterman,futility,fumigated,fruitless,friendless,freon,foregone,forego,floored,flighty,flapjacks,fizzled,ficus,festering,farbman,fabricate,eyghon,extricate,exalted,eventful,esophagus,enterprising,entail,endor,emphatically,embarrasses,electroshock,easel,duffle,drumsticks,dissection,dissected,disposing,disparaging,disorientation,disintegrated,disarming,devoting,dessaline,deprecating,deplorable,delve,degenerative,deduct,decomposed,deathly,dearie,daunting,dankova,cyclotron,cyberspace,cutbacks,culpable,cuddled,crumpets,cruelly,crouching,cranium,cramming,cowering,couric,cordesh,conversational,conclusively,clung,clotting,cleanest,chipping,chimpanzee,chests,cheapen,chainsaws,censure,catapult,caravaggio,carats,captivating,calrissian,butlers,busybody,bussing,bunion,bulimic,budging,brung,browbeat,brokenhearted,brecher,breakdowns,bracebridge,boning,blowhard,blisters,blackboard,bigotry,bialy,bhamra,bended,begat,battering,baste,basquiat,barricaded,barometer,balled,baited,badenweiler,backhand,ascenscion,argumentative,appendicitis,apparition,anxiously,antagonistic,angora,anacott,amniotic,ambience,alonna,aleck,akashic,ageless,abouts,aawwww,aaaaarrrrrrggghhh,aaaaaa,zendi,yuppies,yodel,y'hear,wrangle,wombosi,wittle,withstanding,wisecracks,wiggling,wierd,whittlesley,whipper,whattya,whatsamatter,whatchamacallit,whassup,whad'ya,weakling,warfarin,waponis,wampum,wadn't,vorash,vizzini,virtucon,viridiana,veracity,ventilated,varicose,varcon,vandalized,vamos,vamoose,vaccinated,vacationing,usted,urinal,uppers,unwittingly,unsealed,unplanned,unhinged,unhand,unfathomable,unequivocally,unbreakable,unadvisedly,udall,tynacorp,tuxes,tussle,turati,tunic,tsavo,trussed,troublemakers,trollop,tremors,transsexual,transfusions,toothbrushes,toned,toddlers,tinted,tightened,thundering,thorpey,this'd,thespian,thaddius,tenuous,tenths,tenement,telethon,teleprompter,teaspoon,taunted,tattle,tardiness,taraka,tappy,tapioca,tapeworm,talcum,tacks,swivel,swaying,superpower,summarize,sumbitch,sultry,suburbia,styrofoam,stylings,strolls,strobe,stockpile,stewardesses,sterilized,sterilize,stealin,stakeouts,squawk,squalor,squabble,sprinkled,sportsmanship,spokes,spiritus,sparklers,spareribs,sowing,sororities,sonovabitch,solicit,softy,softness,softening,snuggling,snatchers,snarling,snarky,snacking,smears,slumped,slowest,slithering,sleazebag,slayed,slaughtering,skidded,skated,sivapathasundaram,sissies,silliness,silences,sidecar,sicced,shylock,shtick,shrugged,shriek,shoves,should'a,shortcake,shockingly,shirking,shaves,shatner,sharpener,shapely,shafted,sexless,septum,selflessness,seabea,scuff,screwball,scoping,scooch,scolding,schnitzel,schemed,scalper,santy,sankara,sanest,salesperson,sakulos,safehouse,sabers,runes,rumblings,rumbling,ruijven,ringers,righto,rhinestones,retrieving,reneging,remodelling,relentlessly,regurgitate,refills,reeking,reclusive,recklessness,recanted,ranchers,rafer,quaking,quacks,prophesied,propensity,profusely,problema,prided,prays,postmark,popsicles,poodles,pollyanna,polaroids,pokes,poconos,pocketful,plunging,plugging,pleeease,platters,pitied,pinetti,piercings,phooey,phonies,pestering,periscope,pentagram,pelts,patronized,paramour,paralyze,parachutes,pales,paella,paducci,owatta,overdone,overcrowded,overcompensating,ostracized,ordinate,optometrist,operandi,omens,okayed,oedipal,nuttier,nuptial,nunheim,noxious,nourish,notepad,nitroglycerin,nibblet,neuroses,nanosecond,nabbit,mythic,munchkins,multimillion,mulroney,mucous,muchas,mountaintop,morlin,mongorians,moneybags,mom'll,molto,mixup,misgivings,mindset,michalchuk,mesmerized,merman,mensa,meaty,mbwun,materialize,materialistic,masterminded,marginally,mapuhe,malfunctioning,magnify,macnamara,macinerney,machinations,macadamia,lysol,lurks,lovelorn,lopsided,locator,litback,litany,linea,limousines,limes,lighters,liebkind,levity,levelheaded,letterhead,lesabre,leron,lepers,lefts,leftenant,laziness,layaway,laughlan,lascivious,laryngitis,lapsed,landok,laminated,kurten,kobol,knucklehead,knowed,knotted,kirkeby,kinsa,karnovsky,jolla,jimson,jettison,jeric,jawed,jankis,janitors,jango,jalopy,jailbreak,jackers,jackasses,invalidate,intercepting,intercede,insinuations,infertile,impetuous,impaled,immerse,immaterial,imbeciles,imagines,idyllic,idolized,icebox,i'd've,hypochondriac,hyphen,hurtling,hurried,hunchback,hullo,horsting,hoooo,homeboys,hollandaise,hoity,hijinks,hesitates,herrero,herndorff,helplessly,heeyy,heathen,hearin,headband,harrassment,harpies,halstrom,hahahahaha,hacer,grumbling,grimlocks,grift,greets,grandmothers,grander,grafts,gordievsky,gondorff,godorsky,glscripts,gaudy,gardeners,gainful,fuses,fukienese,frizzy,freshness,freshening,fraught,frantically,foxbooks,fortieth,forked,foibles,flunkies,fleece,flatbed,fisted,firefight,fingerpaint,filibuster,fhloston,fenceline,femur,fatigues,fanucci,fantastically,familiars,falafel,fabulously,eyesore,expedient,ewwww,eviscerated,erogenous,epidural,enchante,embarassed,embarass,embalming,elude,elspeth,electrocute,eigth,eggshell,echinacea,eases,earpiece,earlobe,dumpsters,dumbshit,dumbasses,duloc,duisberg,drummed,drinkers,dressy,dorma,doily,divvy,diverting,dissuade,disrespecting,displace,disorganized,disgustingly,discord,disapproving,diligence,didja,diced,devouring,detach,destructing,desolate,demerits,delude,delirium,degrade,deevak,deemesa,deductions,deduce,debriefed,deadbeats,dateline,darndest,damnable,dalliance,daiquiri,d'agosta,cussing,cryss,cripes,cretins,crackerjack,cower,coveting,couriers,countermission,cotswolds,convertibles,conversationalist,consorting,consoled,consarn,confides,confidentially,commited,commiserate,comme,comforter,comeuppance,combative,comanches,colosseum,colling,coexist,coaxing,cliffside,chutes,chucked,chokes,childlike,childhoods,chickening,chenowith,charmingly,changin,catsup,captioning,capsize,cappucino,capiche,candlewell,cakewalk,cagey,caddie,buxley,bumbling,bulky,buggered,brussel,brunettes,brumby,brotha,bronck,brisket,bridegroom,braided,bovary,bookkeeper,bluster,bloodline,blissfully,blase,billionaires,bicker,berrisford,bereft,berating,berate,bendy,belive,belated,beikoku,beens,bedspread,bawdy,barreling,baptize,banya,balthazar,balmoral,bakshi,bails,badgered,backstreet,awkwardly,auras,attuned,atheists,astaire,assuredly,arrivederci,appetit,appendectomy,apologetic,antihistamine,anesthesiologist,amulets,albie,alarmist,aiight,adstream,admirably,acquaint,abound,abominable,aaaaaaah,zekes,zatunica,wussy,worded,wooed,woodrell,wiretap,windowsill,windjammer,windfall,whisker,whims,whatiya,whadya,weirdly,weenies,waunt,washout,wanto,waning,victimless,verdad,veranda,vandaley,vancomycin,valise,vaguest,upshot,unzip,unwashed,untrained,unstuck,unprincipled,unmentionables,unjustly,unfolds,unemployable,uneducated,unduly,undercut,uncovering,unconsciousness,unconsciously,tyndareus,turncoat,turlock,tulle,tryouts,trouper,triplette,trepkos,tremor,treeger,trapeze,traipse,tradeoff,trach,torin,tommorow,tollan,toity,timpani,thumbprint,thankless,tell'em,telepathy,telemarketing,telekinesis,teevee,teeming,tarred,tambourine,talentless,swooped,switcheroo,swirly,sweatpants,sunstroke,suitors,sugarcoat,subways,subterfuge,subservient,subletting,stunningly,strongbox,striptease,stravanavitch,stradling,stoolie,stodgy,stocky,stifle,stealer,squeezes,squatter,squarely,sprouted,spool,spindly,speedos,soups,soundly,soulmates,somebody'll,soliciting,solenoid,sobering,snowflakes,snowballs,snores,slung,slimming,skulk,skivvies,skewered,skewer,sizing,sistine,sidebar,sickos,shushing,shunt,shugga,shone,shol'va,sharpened,shapeshifter,shadowing,shadoe,selectman,sefelt,seared,scrounging,scribbling,scooping,scintillating,schmoozing,scallops,sapphires,sanitarium,sanded,safes,rudely,roust,rosebush,rosasharn,rondell,roadhouse,riveted,rewrote,revamp,retaliatory,reprimand,replicators,replaceable,remedied,relinquishing,rejoicing,reincarnated,reimbursed,reevaluate,redid,redefine,recreating,reconnected,rebelling,reassign,rearview,rayne,ravings,ratso,rambunctious,radiologist,quiver,quiero,queef,qualms,pyrotechnics,pulsating,psychosomatic,proverb,promiscuous,profanity,prioritize,preying,predisposition,precocious,precludes,prattling,prankster,povich,potting,postpartum,porridge,polluting,plowing,pistachio,pissin,pickpocket,physicals,peruse,pertains,personified,personalize,perjured,perfecting,pepys,pepperdine,pembry,peering,peels,pedophile,patties,passkey,paratrooper,paraphernalia,paralyzing,pandering,paltry,palpable,pagers,pachyderm,overstay,overestimated,overbite,outwit,outgrow,outbid,ooops,oomph,oohhh,oldie,obliterate,objectionable,nygma,notting,noches,nitty,nighters,newsstands,newborns,neurosurgery,nauseated,nastiest,narcolepsy,mutilate,muscled,murmur,mulva,mulling,mukada,muffled,morgues,moonbeams,monogamy,molester,molestation,molars,moans,misprint,mismatched,mirth,mindful,mimosas,millander,mescaline,menstrual,menage,mellowing,medevac,meddlesome,matey,manicures,malevolent,madmen,macaroons,lydell,lycra,lunchroom,lunching,lozenges,looped,litigious,liquidate,linoleum,lingk,limitless,limber,lilacs,ligature,liftoff,lemmiwinks,leggo,learnin,lazarre,lawyered,lactose,knelt,kenosha,kemosabe,jussy,junky,jordy,jimmies,jeriko,jakovasaur,issacs,isabela,irresponsibility,ironed,intoxication,insinuated,inherits,ingest,ingenue,inflexible,inflame,inevitability,inedible,inducement,indignant,indictments,indefensible,incomparable,incommunicado,improvising,impounded,illogical,ignoramus,hydrochloric,hydrate,hungover,humorless,humiliations,hugest,hoverdrone,hovel,hmmph,hitchhike,hibernating,henchman,helloooo,heirlooms,heartsick,headdress,hatches,harebrained,hapless,hanen,handsomer,hallows,habitual,guten,gummy,guiltier,guidebook,gstaad,gruff,griss,grieved,grata,gorignak,goosed,goofed,glowed,glitz,glimpses,glancing,gilmores,gianelli,geraniums,garroway,gangbusters,gamblers,galls,fuddy,frumpy,frowning,frothy,fro'tak,frere,fragrances,forgettin,follicles,flowery,flophouse,floatin,flirts,flings,flatfoot,fingerprinting,fingerprinted,fingering,finald,fillet,fianc,femoral,federales,fawkes,fascinates,farfel,fambly,falsified,fabricating,exterminators,expectant,excusez,excrement,excercises,evian,etins,esophageal,equivalency,equate,equalizer,entrees,enquire,endearment,empathetic,emailed,eggroll,earmuffs,dyslexic,duper,duesouth,drunker,druggie,dreadfully,dramatics,dragline,downplay,downers,dominatrix,doers,docket,docile,diversify,distracts,disloyalty,disinterested,discharging,disagreeable,dirtier,dinghy,dimwitted,dimoxinil,dimmy,diatribe,devising,deviate,detriment,desertion,depressants,depravity,deniability,delinquents,defiled,deepcore,deductive,decimate,deadbolt,dauthuille,dastardly,daiquiris,daggers,dachau,curiouser,curdled,cucamonga,cruller,cruces,crosswalk,crinkle,crescendo,cremate,counseled,couches,cornea,corday,copernicus,contrition,contemptible,constipated,conjoined,confounded,condescend,concoct,conch,compensating,committment,commandeered,comely,coddled,cockfight,cluttered,clunky,clownfish,cloaked,clenched,cleanin,civilised,circumcised,cimmeria,cilantro,chutzpah,chucking,chiseled,chicka,chattering,cervix,carrey,carpal,carnations,cappuccinos,candied,calluses,calisthenics,bushy,burners,budington,buchanans,brimming,braids,boycotting,bouncers,botticelli,botherin,bookkeeping,bogyman,bogged,bloodthirsty,blintzes,blanky,binturong,billable,bigboote,bewildered,betas,bequeath,behoove,befriend,bedpost,bedded,baudelaires,barreled,barboni,barbeque,bangin,baltus,bailout,backstabber,baccarat,awning,augie,arguillo,archway,apricots,apologising,annyong,anchorman,amenable,amazement,allspice,alannis,airfare,airbags,ahhhhhhhhh,ahhhhhhhh,ahhhhhhh,agitator,adrenal,acidosis,achoo,accessorizing,accentuate,abrasions,abductor,aaaahhh,aaaaaaaa,aaaaaaa,zeroing,zelner,zeldy,yevgeny,yeska,yellows,yeesh,yeahh,yamuri,wouldn't've,workmanship,woodsman,winnin,winked,wildness,whoring,whitewash,whiney,when're,wheezer,wheelman,wheelbarrow,westerburg,weeding,watermelons,washboard,waltzes,wafting,voulez,voluptuous,vitone,vigilantes,videotaping,viciously,vices,veruca,vermeer,verifying,vasculitis,valets,upholstered,unwavering,untold,unsympathetic,unromantic,unrecognizable,unpredictability,unmask,unleashing,unintentional,unglued,unequivocal,underrated,underfoot,unchecked,unbutton,unbind,unbiased,unagi,uhhhhh,tugging,triads,trespasses,treehorn,traviata,trappers,transplants,trannie,tramping,tracheotomy,tourniquet,tooty,toothless,tomarrow,toasters,thruster,thoughtfulness,thornwood,tengo,tenfold,telltale,telephoto,telephoned,telemarketer,tearin,tastic,tastefully,tasking,taser,tamed,tallow,taketh,taillight,tadpoles,tachibana,syringes,sweated,swarthy,swagger,surges,supermodels,superhighway,sunup,sun'll,sulfa,sugarless,sufficed,subside,strolled,stringy,strengthens,straightest,straightens,storefront,stopper,stockpiling,stimulant,stiffed,steyne,sternum,stepladder,stepbrother,steers,steelheads,steakhouse,stathis,stankylecartmankennymr,standoffish,stalwart,squirted,spritz,sprig,sprawl,spousal,sphincter,spenders,spearmint,spatter,spangled,southey,soured,sonuvabitch,somethng,snuffed,sniffs,smokescreen,smilin,slobs,sleepwalker,sleds,slays,slayage,skydiving,sketched,skanks,sixed,siphoned,siphon,simpering,sigfried,sidearm,siddons,sickie,shuteye,shuffleboard,shrubberies,shrouded,showmanship,shouldn't've,shoplift,shiatsu,sentries,sentance,sensuality,seething,secretions,searing,scuttlebutt,sculpt,scowling,scouring,scorecard,schoolers,schmucks,scepters,scaly,scalps,scaffolding,sauces,sartorius,santen,salivating,sainthood,saget,saddens,rygalski,rusting,ruination,rueland,rudabaga,rottweiler,roofies,romantics,rollerblading,roldy,roadshow,rickets,rible,rheza,revisiting,retentive,resurface,restores,respite,resounding,resorting,resists,repulse,repressing,repaying,reneged,refunds,rediscover,redecorated,reconstructive,recommitted,recollect,receptacle,reassess,reanimation,realtors,razinin,rationalization,ratatouille,rashum,rasczak,rancheros,rampler,quizzing,quips,quartered,purring,pummeling,puede,proximo,prospectus,pronouncing,prolonging,procreation,proclamations,principled,prides,preoccupation,prego,precog,prattle,pounced,potshots,potpourri,porque,pomegranates,polenta,plying,pluie,plesac,playmates,plantains,pillowcase,piddle,pickers,photocopied,philistine,perpetuate,perpetually,perilous,pawned,pausing,pauper,parter,parlez,parlay,pally,ovulation,overtake,overstate,overpowering,overpowered,overconfident,overbooked,ovaltine,outweighs,outings,ottos,orrin,orifice,orangutan,oopsy,ooooooooh,oooooo,ooohhhh,ocular,obstruct,obscenely,o'dwyer,nutjob,nunur,notifying,nostrand,nonny,nonfat,noblest,nimble,nikes,nicht,newsworthy,nestled,nearsighted,ne'er,nastier,narco,nakedness,muted,mummified,mudda,mozzarella,moxica,motivator,motility,mothafucka,mortmain,mortgaged,mores,mongers,mobbed,mitigating,mistah,misrepresented,mishke,misfortunes,misdirection,mischievous,mineshaft,millaney,microwaves,metzenbaum,mccovey,masterful,masochistic,marliston,marijawana,manya,mantumbi,malarkey,magnifique,madrona,madox,machida,m'hidi,lullabies,loveliness,lotions,looka,lompoc,litterbug,litigator,lithe,liquorice,linds,limericks,lightbulb,lewises,letch,lemec,layover,lavatory,laurels,lateness,laparotomy,laboring,kuato,kroff,krispy,krauts,knuckleheads,kitschy,kippers,kimbrow,keypad,keepsake,kebab,karloff,junket,judgemental,jointed,jezzie,jetting,jeeze,jeeter,jeesus,jeebs,janeane,jails,jackhammer,ixnay,irritates,irritability,irrevocable,irrefutable,irked,invoking,intricacies,interferon,intents,insubordinate,instructive,instinctive,inquisitive,inlay,injuns,inebriated,indignity,indecisive,incisors,incacha,inalienable,impresses,impregnate,impregnable,implosion,idolizes,hypothyroidism,hypoglycemic,huseni,humvee,huddling,honing,hobnobbing,hobnob,histrionics,histamine,hirohito,hippocratic,hindquarters,hikita,hikes,hightailed,hieroglyphics,heretofore,herbalist,hehey,hedriks,heartstrings,headmistress,headlight,hardheaded,happend,handlebars,hagitha,habla,gyroscope,guys'd,guy'd,guttersnipe,grump,growed,grovelling,groan,greenbacks,gravedigger,grating,grasshoppers,grandiose,grandest,grafted,gooood,goood,gooks,godsakes,goaded,glamorama,giveth,gingham,ghostbusters,germane,georgy,gazzo,gazelles,gargle,garbled,galgenstein,gaffe,g'day,fyarl,furnish,furies,fulfills,frowns,frowned,frighteningly,freebies,freakishly,forewarned,foreclose,forearms,fordson,fonics,flushes,flitting,flemmer,flabby,fishbowl,fidgeting,fevers,feigning,faxing,fatigued,fathoms,fatherless,fancier,fanatical,factored,eyelid,eyeglasses,expresso,expletive,expectin,excruciatingly,evidentiary,ever'thing,eurotrash,eubie,estrangement,erlich,epitome,entrap,enclose,emphysema,embers,emasculating,eighths,eardrum,dyslexia,duplicitous,dumpty,dumbledore,dufus,duddy,duchamp,drunkenness,drumlin,drowns,droid,drinky,drifts,drawbridge,dramamine,douggie,douchebag,dostoyevsky,doodling,don'tcha,domineering,doings,dogcatcher,doctoring,ditzy,dissimilar,dissecting,disparage,disliking,disintegrating,dishwalla,dishonored,dishing,disengaged,disavowed,dippy,diorama,dimmed,dilate,digitalis,diggory,dicing,diagnosing,devola,desolation,dennings,denials,deliverance,deliciously,delicacies,degenerates,degas,deflector,defile,deference,decrepit,deciphered,dawdle,dauphine,daresay,dangles,dampen,damndest,cucumbers,cucaracha,cryogenically,croaks,croaked,criticise,crisper,creepiest,creams,crackle,crackin,covertly,counterintelligence,corrosive,cordially,cops'll,convulsions,convoluted,conversing,conga,confrontational,confab,condolence,condiments,complicit,compiegne,commodus,comings,cometh,collusion,collared,cockeyed,clobber,clemonds,clarithromycin,cienega,christmasy,christmassy,chloroform,chippie,chested,cheeco,checklist,chauvinist,chandlers,chambermaid,chakras,cellophane,caveat,cataloguing,cartmanland,carples,carny,carded,caramels,cappy,caped,canvassing,callback,calibrated,calamine,buttermilk,butterfingers,bunsen,bulimia,bukatari,buildin,budged,brobich,bringer,brendell,brawling,bratty,braised,boyish,boundless,botch,boosh,bookies,bonbons,bodes,bobunk,bluntly,blossoming,bloomers,bloodstains,bloodhounds,blech,biter,biometric,bioethics,bijan,bigoted,bicep,bereaved,bellowing,belching,beholden,beached,batmobile,barcodes,barch,barbecuing,bandanna,backwater,backtrack,backdraft,augustino,atrophy,atrocity,atley,atchoo,asthmatic,assoc,armchair,arachnids,aptly,appetizing,antisocial,antagonizing,anorexia,anini,andersons,anagram,amputation,alleluia,airlock,aimless,agonized,agitate,aggravating,aerosol,acing,accomplishing,accidently,abuser,abstain,abnormally,aberration,aaaaahh,zlotys,zesty,zerzura,zapruder,zantopia,yelburton,yeess,y'knowwhati'msayin,wwhat,wussies,wrenched,would'a,worryin,wormser,wooooo,wookiee,wolchek,wishin,wiseguys,windbreaker,wiggy,wieners,wiedersehen,whoopin,whittled,wherefore,wharvey,welts,wellstone,wedges,wavered,watchit,wastebasket,wango,waken,waitressed,wacquiem,vrykolaka,voula,vitally,visualizing,viciousness,vespers,vertes,verily,vegetarians,vater,vaporize,vannacutt,vallens,ussher,urinating,upping,unwitting,untangle,untamed,unsanitary,unraveled,unopened,unisex,uninvolved,uninteresting,unintelligible,unimaginative,undeserving,undermines,undergarments,unconcerned,tyrants,typist,tykes,tybalt,twosome,twits,tutti,turndown,tularemia,tuberculoma,tsimshian,truffaut,truer,truant,trove,triumphed,tripe,trigonometry,trifled,trifecta,tribulations,tremont,tremoille,transcends,trafficker,touchin,tomfoolery,tinkered,tinfoil,tightrope,thousan,thoracotomy,thesaurus,thawing,thatta,tessio,temps,taxidermist,tator,tachycardia,t'akaya,swelco,sweetbreads,swatting,supercollider,sunbathing,summarily,suffocation,sueleen,succinct,subsided,submissive,subjecting,subbing,subatomic,stupendous,stunted,stubble,stubbed,streetwalker,strategizing,straining,straightaway,stoli,stiffer,stickup,stens,steamroller,steadwell,steadfast,stateroom,stans,sshhhh,squishing,squinting,squealed,sprouting,sprimp,spreadsheets,sprawled,spotlights,spooning,spirals,speedboat,spectacles,speakerphone,southglen,souse,soundproof,soothsayer,sommes,somethings,solidify,soars,snorted,snorkeling,snitches,sniping,snifter,sniffin,snickering,sneer,snarl,smila,slinking,slanted,slanderous,slammin,skimp,skilosh,siteid,sirloin,singe,sighing,sidekicks,sicken,showstopper,shoplifter,shimokawa,sherborne,shavadai,sharpshooters,sharking,shagged,shaddup,senorita,sesterces,sensuous,seahaven,scullery,scorcher,schotzie,schnoz,schmooze,schlep,schizo,scents,scalping,scalped,scallop,scalding,sayeth,saybrooke,sawed,savoring,sardine,sandstorm,sandalwood,salutations,sagman,s'okay,rsvp'd,rousted,rootin,romper,romanovs,rollercoaster,rolfie,robinsons,ritzy,ritualistic,ringwald,rhymed,rheingold,rewrites,revoking,reverts,retrofit,retort,retinas,respirations,reprobate,replaying,repaint,renquist,renege,relapsing,rekindled,rejuvenating,rejuvenated,reinstating,recriminations,rechecked,reassemble,rears,reamed,reacquaint,rayanne,ravish,rathole,raspail,rarest,rapists,rants,racketeer,quittin,quitters,quintessential,queremos,quellek,quelle,quasimodo,pyromaniac,puttanesca,puritanical,purer,puree,pungent,pummel,puedo,psychotherapist,prosecutorial,prosciutto,propositioning,procrastination,probationary,primping,preventative,prevails,preservatives,preachy,praetorians,practicality,powders,potus,postop,positives,poser,portolano,portokalos,poolside,poltergeists,pocketed,poach,plummeted,plucking,plimpton,playthings,plastique,plainclothes,pinpointed,pinkus,pinks,pigskin,piffle,pictionary,piccata,photocopy,phobias,perignon,perfumes,pecks,pecked,patently,passable,parasailing,paramus,papier,paintbrush,pacer,paaiint,overtures,overthink,overstayed,overrule,overestimate,overcooked,outlandish,outgrew,outdoorsy,outdo,orchestrate,oppress,opposable,oooohh,oomupwah,okeydokey,okaaay,ohashi,of'em,obscenities,oakie,o'gar,nurection,nostradamus,norther,norcom,nooch,nonsensical,nipped,nimbala,nervously,neckline,nebbleman,narwhal,nametag,n'n't,mycenae,muzak,muumuu,mumbled,mulvehill,muggings,muffet,mouthy,motivates,motaba,moocher,mongi,moley,moisturize,mohair,mocky,mmkay,mistuh,missis,misdeeds,mincemeat,miggs,miffed,methadone,messieur,menopausal,menagerie,mcgillicuddy,mayflowers,matrimonial,matick,masai,marzipan,maplewood,manzelle,mannequins,manhole,manhandle,malfunctions,madwoman,machiavelli,lynley,lynched,lurconis,lujack,lubricant,looove,loons,loofah,lonelyhearts,lollipops,lineswoman,lifers,lexter,lepner,lemony,leggy,leafy,leadeth,lazerus,lazare,lawford,languishing,lagoda,ladman,kundera,krinkle,krendler,kreigel,kowolski,knockdown,knifed,kneed,kneecap,kids'll,kennie,kenmore,keeled,kazootie,katzenmoyer,kasdan,karak,kapowski,kakistos,julyan,jockstrap,jobless,jiggly,jaunt,jarring,jabbering,irrigate,irrevocably,irrationally,ironies,invitro,intimated,intently,intentioned,intelligently,instill,instigator,instep,inopportune,innuendoes,inflate,infects,infamy,indiscretions,indiscreet,indio,indignities,indict,indecision,inconspicuous,inappropriately,impunity,impudent,impotence,implicates,implausible,imperfection,impatience,immutable,immobilize,idealist,iambic,hysterically,hyperspace,hygienist,hydraulics,hydrated,huzzah,husks,hunched,huffed,hubris,hubbub,hovercraft,houngan,hosed,horoscopes,hopelessness,hoodwinked,honorably,honeysuckle,homegirl,holiest,hippity,hildie,hieroglyphs,hexton,herein,heckle,heaping,healthilizer,headfirst,hatsue,harlot,hardwired,halothane,hairstyles,haagen,haaaaa,gutting,gummi,groundless,groaning,gristle,grills,graynamore,grabbin,goodes,goggle,glittering,glint,gleaming,glassy,girth,gimbal,giblets,gellers,geezers,geeze,garshaw,gargantuan,garfunkel,gangway,gandarium,gamut,galoshes,gallivanting,gainfully,gachnar,fusionlips,fusilli,furiously,frugal,fricking,frederika,freckling,frauds,fountainhead,forthwith,forgo,forgettable,foresight,foresaw,fondling,fondled,fondle,folksy,fluttering,fluffing,floundering,flirtatious,flexing,flatterer,flaring,fixating,finchy,figurehead,fiendish,fertilize,ferment,fending,fellahs,feelers,fascinate,fantabulous,falsify,fallopian,faithless,fairer,fainter,failings,facetious,eyepatch,exxon,extraterrestrials,extradite,extracurriculars,extinguish,expunged,expelling,exorbitant,exhilarated,exertion,exerting,excercise,everbody,evaporated,escargot,escapee,erases,epizootics,epithelials,ephrum,entanglements,enslave,engrossed,emphatic,emeralds,ember,emancipated,elevates,ejaculate,effeminate,eccentricities,easygoing,earshot,dunks,dullness,dulli,dulled,drumstick,dropper,driftwood,dregs,dreck,dreamboat,draggin,downsizing,donowitz,dominoes,diversions,distended,dissipate,disraeli,disqualify,disowned,dishwashing,disciplining,discerning,disappoints,dinged,digested,dicking,detonating,despising,depressor,depose,deport,dents,defused,deflecting,decryption,decoys,decoupage,decompress,decibel,decadence,deafening,dawning,dater,darkened,dappy,dallying,dagon,czechoslovakians,cuticles,cuteness,cupboards,culottes,cruisin,crosshairs,cronyn,criminalistics,creatively,creaming,crapping,cranny,cowed,contradicting,constipation,confining,confidences,conceiving,conceivably,concealment,compulsively,complainin,complacent,compels,communing,commode,comming,commensurate,columnists,colonoscopy,colchicine,coddling,clump,clubbed,clowning,cliffhanger,clang,cissy,choosers,choker,chiffon,channeled,chalet,cellmates,cathartic,caseload,carjack,canvass,canisters,candlestick,candlelit,camry,calzones,calitri,caldy,byline,butterball,bustier,burlap,bureaucrat,buffoons,buenas,brookline,bronzed,broiled,broda,briss,brioche,briar,breathable,brays,brassieres,boysenberry,bowline,boooo,boonies,booklets,bookish,boogeyman,boogey,bogas,boardinghouse,bluuch,blundering,bluer,blowed,blotchy,blossomed,bloodwork,bloodied,blithering,blinks,blathering,blasphemous,blacking,birdson,bings,bfmid,bfast,bettin,berkshires,benjamins,benevolence,benched,benatar,bellybutton,belabor,behooves,beddy,beaujolais,beattle,baxworth,baseless,barfing,bannish,bankrolled,banek,ballsy,ballpoint,baffling,badder,badda,bactine,backgammon,baako,aztreonam,authoritah,auctioning,arachtoids,apropos,aprons,apprised,apprehensive,anythng,antivenin,antichrist,anorexic,anoint,anguished,angioplasty,angio,amply,ampicillin,amphetamines,alternator,alcove,alabaster,airlifted,agrabah,affidavits,admonished,admonish,addled,addendum,accuser,accompli,absurdity,absolved,abrusso,abreast,aboot,abductions,abducting,aback,ababwa,aaahhhh,zorin,zinthar,zinfandel,zillions,zephyrs,zatarcs,zacks,youuu,yokels,yardstick,yammer,y'understand,wynette,wrung,wreaths,wowed,wouldn'ta,worming,wormed,workday,woodsy,woodshed,woodchuck,wojadubakowski,withering,witching,wiseass,wiretaps,wining,willoby,wiccaning,whupped,whoopi,whoomp,wholesaler,whiteness,whiner,whatchya,wharves,wenus,weirdoes,weaning,watusi,waponi,waistband,wackos,vouching,votre,vivica,viveca,vivant,vivacious,visor,visitin,visage,vicrum,vetted,ventriloquism,venison,varnsen,vaporized,vapid,vanstock,uuuuh,ushering,urologist,urination,upstart,uprooted,unsubtitled,unspoiled,unseat,unseasonably,unseal,unsatisfying,unnerve,unlikable,unleaded,uninsured,uninspired,unicycle,unhooked,unfunny,unfreezing,unflattering,unfairness,unexpressed,unending,unencumbered,unearth,undiscovered,undisciplined,understan,undershirt,underlings,underline,undercurrent,uncivilized,uncharacteristic,umpteenth,uglies,tuney,trumps,truckasaurus,trubshaw,trouser,tringle,trifling,trickster,trespassers,trespasser,traumas,trattoria,trashes,transgressions,trampling,tp'ed,toxoplasmosis,tounge,tortillas,topsy,topple,topnotch,tonsil,tions,timmuh,timithious,tilney,tighty,tightness,tightens,tidbits,ticketed,thyme,threepio,thoughtfully,thorkel,thommo,thing'll,thefts,that've,thanksgivings,tetherball,testikov,terraforming,tepid,tendonitis,tenboom,telex,teenybopper,tattered,tattaglias,tanneke,tailspin,tablecloth,swooping,swizzle,swiping,swindled,swilling,swerving,sweatshops,swaddling,swackhammer,svetkoff,supossed,superdad,sumptuous,sugary,sugai,subvert,substantiate,submersible,sublimating,subjugation,stymied,strychnine,streetlights,strassmans,stranglehold,strangeness,straddling,straddle,stowaways,stotch,stockbrokers,stifling,stepford,steerage,steena,statuary,starlets,staggeringly,ssshhh,squaw,spurt,spungeon,spritzer,sprightly,sprays,sportswear,spoonful,splittin,splitsville,speedily,specialise,spastic,sparrin,souvlaki,southie,sourpuss,soupy,soundstage,soothes,somebody'd,softest,sociopathic,socialized,snyders,snowmobiles,snowballed,snatches,smugness,smoothest,smashes,sloshed,sleight,skyrocket,skied,skewed,sixpence,sipowicz,singling,simulates,shyness,shuvanis,showoff,shortsighted,shopkeeper,shoehorn,shithouse,shirtless,shipshape,shifu,shelve,shelbyville,sheepskin,sharpens,shaquille,shanshu,servings,sequined,seizes,seashells,scrambler,scopes,schnauzer,schmo,schizoid,scampered,savagely,saudis,santas,sandovals,sanding,saleswoman,sagging,s'cuse,rutting,ruthlessly,runneth,ruffians,rubes,rosalita,rollerblades,rohypnol,roasts,roadies,ritten,rippling,ripples,rigoletto,richardo,rethought,reshoot,reserving,reseda,rescuer,reread,requisitions,repute,reprogram,replenish,repetitious,reorganizing,reinventing,reinvented,reheat,refrigerators,reenter,recruiter,recliner,rawdy,rashes,rajeski,raison,raisers,rages,quinine,questscape,queller,pygmalion,pushers,pusan,purview,pumpin,pubescent,prudes,provolone,propriety,propped,procrastinate,processional,preyed,pretrial,portent,pooling,poofy,polloi,policia,poacher,pluses,pleasuring,platitudes,plateaued,plaguing,pittance,pinheads,pincushion,pimply,pimped,piggyback,piecing,phillipe,philipse,philby,pharaohs,petyr,petitioner,peshtigo,pesaram,persnickety,perpetrate,percolating,pepto,penne,penell,pemmican,peeks,pedaling,peacemaker,pawnshop,patting,pathologically,patchouli,pasts,pasties,passin,parlors,paltrow,palamon,padlock,paddling,oversleep,overheating,overdosed,overcharge,overblown,outrageously,ornery,opportune,oooooooooh,oohhhh,ohhhhhh,ogres,odorless,obliterated,nyong,nymphomaniac,ntozake,novocain,nough,nonnie,nonissue,nodules,nightmarish,nightline,niceties,newsman,needra,nedry,necking,navour,nauseam,nauls,narim,namath,nagged,naboo,n'sync,myslexia,mutator,mustafi,musketeer,murtaugh,murderess,munching,mumsy,muley,mouseville,mortifying,morgendorffers,moola,montel,mongoloid,molestered,moldings,mocarbies,mo'ss,mixers,misrell,misnomer,misheard,mishandled,miscreant,misconceptions,miniscule,millgate,mettle,metricconverter,meteors,menorah,mengele,melding,meanness,mcgruff,mcarnold,matzoh,matted,mastectomy,massager,marveling,marooned,marmaduke,marick,manhandled,manatees,man'll,maltin,maliciously,malfeasance,malahide,maketh,makeovers,maiming,machismo,lumpectomy,lumbering,lucci,lording,lorca,lookouts,loogie,loners,loathed,lissen,lighthearted,lifer,lickin,lewen,levitation,lestercorp,lessee,lentils,legislate,legalizing,lederhosen,lawmen,lasskopf,lardner,lambeau,lamagra,ladonn,lactic,lacquer,labatier,krabappel,kooks,knickknacks,klutzy,kleynach,klendathu,kinross,kinkaid,kind'a,ketch,kesher,karikos,karenina,kanamits,junshi,jumbled,joust,jotted,jobson,jingling,jigalong,jerries,jellies,jeeps,javna,irresistable,internist,intercranial,inseminated,inquisitor,infuriate,inflating,infidelities,incessantly,incensed,incase,incapacitate,inasmuch,inaccuracies,imploding,impeding,impediments,immaturity,illegible,iditarod,icicles,ibuprofen,i'i'm,hymie,hydrolase,hunker,humps,humons,humidor,humdinger,humbling,huggin,huffing,housecleaning,hothouse,hotcakes,hosty,hootenanny,hootchie,hoosegow,honks,honeymooners,homily,homeopathic,hitchhikers,hissed,hillnigger,hexavalent,hewwo,hershe,hermey,hergott,henny,hennigans,henhouse,hemolytic,helipad,heifer,hebrews,hebbing,heaved,headlock,harrowing,harnessed,hangovers,handi,handbasket,halfrek,hacene,gyges,guys're,gundersons,gumption,gruntmaster,grubs,grossie,groped,grins,greaseball,gravesite,gratuity,granma,grandfathers,grandbaby,gradski,gracing,gossips,gooble,goners,golitsyn,gofer,godsake,goddaughter,gnats,gluing,glares,givers,ginza,gimmie,gimmee,gennero,gemme,gazpacho,gazed,gassy,gargling,gandhiji,galvanized,gallbladder,gaaah,furtive,fumigation,fucka,fronkonsteen,frills,freezin,freewald,freeloader,frailty,forger,foolhardy,fondest,fomin,followin,follicle,flotation,flopping,floodgates,flogged,flicked,flenders,fleabag,fixings,fixable,fistful,firewater,firelight,fingerbang,finalizing,fillin,filipov,fiderer,felling,feldberg,feign,faunia,fatale,farkus,fallible,faithfulness,factoring,eyeful,extramarital,exterminated,exhume,exasperated,eviscerate,estoy,esmerelda,escapades,epoxy,enticed,enthused,entendre,engrossing,endorphins,emptive,emmys,eminently,embezzler,embarressed,embarrassingly,embalmed,eludes,eling,elated,eirie,egotitis,effecting,eerily,eecom,eczema,earthy,earlobes,eally,dyeing,dwells,duvet,duncans,dulcet,droves,droppin,drools,drey'auc,downriver,domesticity,dollop,doesnt,dobler,divulged,diversionary,distancing,dispensers,disorienting,disneyworld,dismissive,disingenuous,disheveled,disfiguring,dinning,dimming,diligently,dilettante,dilation,dickensian,diaphragms,devastatingly,destabilize,desecrate,deposing,deniece,demony,delving,delicates,deigned,defraud,deflower,defibrillator,defiantly,defenceless,defacing,deconstruction,decompose,deciphering,decibels,deceptively,deceptions,decapitation,debutantes,debonair,deadlier,dawdling,davic,darwinism,darnit,darks,danke,danieljackson,dangled,cytoxan,cutout,cutlery,curveball,curfews,cummerbund,crunches,crouched,crisps,cripples,crilly,cribs,crewman,creepin,creeds,credenza,creak,crawly,crawlin,crawlers,crated,crackheads,coworker,couldn't've,corwins,coriander,copiously,convenes,contraceptives,contingencies,contaminating,conniption,condiment,concocting,comprehending,complacency,commendatore,comebacks,com'on,collarbone,colitis,coldly,coiffure,coffers,coeds,codependent,cocksucking,cockney,cockles,clutched,closeted,cloistered,cleve,cleats,clarifying,clapped,cinnabar,chunnel,chumps,cholinesterase,choirboy,chocolatey,chlamydia,chigliak,cheesie,chauvinistic,chasm,chartreuse,charo,charnier,chapil,chalked,chadway,certifiably,cellulite,celled,cavalcade,cataloging,castrated,cassio,cashews,cartouche,carnivore,carcinogens,capulet,captivated,capt'n,cancellations,campin,callate,callar,caffeinated,cadavers,cacophony,cackle,buzzes,buttoning,busload,burglaries,burbs,buona,bunions,bullheaded,buffs,bucyk,buckling,bruschetta,browbeating,broomsticks,broody,bromly,brolin,briefings,brewskies,breathalyzer,breakups,bratwurst,brania,braiding,brags,braggin,bradywood,bottomed,bossa,bordello,bookshelf,boogida,bondsman,bolder,boggles,bludgeoned,blowtorch,blotter,blips,blemish,bleaching,blainetologists,blading,blabbermouth,birdseed,bimmel,biloxi,biggly,bianchinni,betadine,berenson,belus,belloq,begets,befitting,beepers,beelzebub,beefed,bedridden,bedevere,beckons,beaded,baubles,bauble,battleground,bathrobes,basketballs,basements,barroom,barnacle,barkin,barked,baretta,bangles,bangler,banality,bambang,baltar,ballplayers,bagman,baffles,backroom,babysat,baboons,averse,audiotape,auctioneer,atten,atcha,astonishment,arugula,arroz,antihistamines,annoyances,anesthesiology,anatomically,anachronism,amiable,amaretto,allahu,alight,aimin,ailment,afterglow,affronte,advil,adrenals,actualization,acrost,ached,accursed,accoutrements,absconded,aboveboard,abetted,aargh,aaaahh,zuwicky,zolda,ziploc,zakamatak,youve,yippie,yesterdays,yella,yearns,yearnings,yearned,yawning,yalta,yahtzee,y'mean,y'are,wuthering,wreaks,worrisome,workiiing,wooooooo,wonky,womanizing,wolodarsky,wiwith,withdraws,wishy,wisht,wipers,wiper,winos,windthorne,windsurfing,windermere,wiggled,wiggen,whwhat,whodunit,whoaaa,whittling,whitesnake,whereof,wheezing,wheeze,whatd'ya,whataya,whammo,whackin,wellll,weightless,weevil,wedgies,webbing,weasly,wayside,waxes,waturi,washy,washrooms,wandell,waitaminute,waddya,waaaah,vornac,vishnoor,virulent,vindictiveness,vinceres,villier,vigeous,vestigial,ventilate,vented,venereal,veering,veered,veddy,vaslova,valosky,vailsburg,vaginas,vagas,urethra,upstaged,uploading,unwrapping,unwieldy,untapped,unsatisfied,unquenchable,unnerved,unmentionable,unlovable,unknowns,uninformed,unimpressed,unhappily,unguarded,unexplored,undergarment,undeniably,unclench,unclaimed,uncharacteristically,unbuttoned,unblemished,ululd,uhhhm,tweeze,tutsami,tushy,tuscarora,turkle,turghan,turbinium,tubers,trucoat,troxa,tropicana,triquetra,trimmers,triceps,trespassed,traya,traumatizing,transvestites,trainors,tradin,trackers,townies,tourelles,toucha,tossin,tortious,topshop,topes,tonics,tongs,tomsk,tomorrows,toiling,toddle,tizzy,tippers,timmi,thwap,thusly,ththe,thrusts,throwers,throwed,throughway,thickening,thermonuclear,thelwall,thataway,terrifically,tendons,teleportation,telepathically,telekinetic,teetering,teaspoons,tarantulas,tapas,tanned,tangling,tamales,tailors,tahitian,tactful,tachy,tablespoon,syrah,synchronicity,synch,synapses,swooning,switchman,swimsuits,sweltering,sweetly,suvolte,suslov,surfed,supposition,suppertime,supervillains,superfluous,superego,sunspots,sunning,sunless,sundress,suckah,succotash,sublevel,subbasement,studious,striping,strenuously,straights,stonewalled,stillness,stilettos,stevesy,steno,steenwyck,stargates,stammering,staedert,squiggly,squiggle,squashing,squaring,spreadsheet,spramp,spotters,sporto,spooking,splendido,spittin,spirulina,spiky,spate,spartacus,spacerun,soonest,something'll,someth,somepin,someone'll,sofas,soberly,sobered,snowmen,snowbank,snowballing,snivelling,sniffling,snakeskin,snagging,smush,smooter,smidgen,smackers,slumlord,slossum,slimmer,slighted,sleepwalk,sleazeball,skokie,skeptic,sitarides,sistah,sipped,sindell,simpletons,simony,silkwood,silks,silken,sightless,sideboard,shuttles,shrugging,shrouds,showy,shoveled,shouldn'ta,shoplifters,shitstorm,sheeny,shapetype,shaming,shallows,shackle,shabbily,shabbas,seppuku,senility,semite,semiautomatic,selznick,secretarial,sebacio,scuzzy,scummy,scrutinized,scrunchie,scribbled,scotches,scolded,scissor,schlub,scavenging,scarin,scarfing,scallions,scald,savour,savored,saute,sarcoidosis,sandbar,saluted,salish,saith,sailboats,sagittarius,sacre,saccharine,sacamano,rushdie,rumpled,rumba,rulebook,rubbers,roughage,rotisserie,rootie,roofy,roofie,romanticize,rittle,ristorante,rippin,rinsing,ringin,rincess,rickety,reveling,retest,retaliating,restorative,reston,restaurateur,reshoots,resetting,resentments,reprogramming,repossess,repartee,renzo,remore,remitting,remeber,relaxants,rejuvenate,rejections,regenerated,refocus,referrals,reeno,recycles,recrimination,reclining,recanting,reattach,reassigning,razgul,raved,rattlesnakes,rattles,rashly,raquetball,ransack,raisinettes,raheem,radisson,radishes,raban,quoth,qumari,quints,quilts,quilting,quien,quarreled,purty,purblind,punchbowl,publically,psychotics,psychopaths,psychoanalyze,pruning,provasik,protectin,propping,proportioned,prophylactic,proofed,prompter,procreate,proclivities,prioritizing,prinze,pricked,press'll,presets,prescribes,preocupe,prejudicial,prefex,preconceived,precipice,pralines,pragmatist,powerbar,pottie,pottersville,potsie,potholes,posses,posies,portkey,porterhouse,pornographers,poring,poppycock,poppers,pomponi,pokin,poitier,podiatry,pleeze,pleadings,playbook,platelets,plane'arium,placebos,place'll,pistachios,pirated,pinochle,pineapples,pinafore,pimples,piggly,piddling,picon,pickpockets,picchu,physiologically,physic,phobic,philandering,phenomenally,pheasants,pewter,petticoat,petronis,petitioning,perturbed,perpetuating,permutat,perishable,perimeters,perfumed,percocet,per'sus,pepperjack,penalize,pelting,pellet,peignoir,pedicures,peckers,pecans,pawning,paulsson,pattycake,patrolmen,patois,pathos,pasted,parishioner,parcheesi,parachuting,papayas,pantaloons,palpitations,palantine,paintballing,overtired,overstress,oversensitive,overnights,overexcited,overanxious,overachiever,outwitted,outvoted,outnumber,outlast,outlander,out've,orphey,orchestrating,openers,ooooooo,okies,ohhhhhhhhh,ohhhhhhhh,ogling,offbeat,obsessively,obeyed,o'hana,o'bannon,o'bannion,numpce,nummy,nuked,nuances,nourishing,nosedive,norbu,nomlies,nomine,nixed,nihilist,nightshift,newmeat,neglectful,neediness,needin,naphthalene,nanocytes,nanite,naivete,n'yeah,mystifying,myhnegon,mutating,musing,mulled,muggy,muerto,muckraker,muchachos,mountainside,motherless,mosquitos,morphed,mopped,moodoo,moncho,mollem,moisturiser,mohicans,mocks,mistresses,misspent,misinterpretation,miscarry,minuses,mindee,mimes,millisecond,milked,mightn't,mightier,mierzwiak,microchips,meyerling,mesmerizing,mershaw,meecrob,medicate,meddled,mckinnons,mcgewan,mcdunnough,mcats,mbien,matzah,matriarch,masturbated,masselin,martialed,marlboros,marksmanship,marinate,marchin,manicured,malnourished,malign,majorek,magnon,magnificently,macking,machiavellian,macdougal,macchiato,macaws,macanaw,m'self,lydells,lusts,lucite,lubricants,lopper,lopped,loneliest,lonelier,lomez,lojack,loath,liquefy,lippy,limps,likin,lightness,liesl,liebchen,licious,libris,libation,lhamo,leotards,leanin,laxatives,lavished,latka,lanyard,lanky,landmines,lameness,laddies,lacerated,labored,l'amour,kreskin,kovitch,kournikova,kootchy,konoss,knknow,knickety,knackety,kmart,klicks,kiwanis,kissable,kindergartners,kilter,kidnet,kid'll,kicky,kickbacks,kickback,kholokov,kewpie,kendo,katra,kareoke,kafelnikov,kabob,junjun,jumba,julep,jordie,jondy,jolson,jenoff,jawbone,janitorial,janiro,ipecac,invigorated,intruded,intros,intravenously,interruptus,interrogations,interject,interfacing,interestin,insuring,instilled,insensitivity,inscrutable,inroads,innards,inlaid,injector,ingratitude,infuriates,infra,infliction,indelicate,incubators,incrimination,inconveniencing,inconsolable,incestuous,incas,incarcerate,inbreeding,impudence,impressionists,impeached,impassioned,imipenem,idling,idiosyncrasies,icebergs,hypotensive,hydrochloride,hushed,humus,humph,hummm,hulking,hubcaps,hubald,howya,howbout,how'll,housebroken,hotwire,hotspots,hotheaded,horrace,hopsfield,honto,honkin,honeymoons,homewrecker,hombres,hollers,hollerin,hoedown,hoboes,hobbling,hobble,hoarse,hinky,highlighters,hexes,heru'ur,hernias,heppleman,hell're,heighten,heheheheheh,heheheh,hedging,heckling,heckled,heavyset,heatshield,heathens,heartthrob,headpiece,hayseed,haveo,hauls,hasten,harridan,harpoons,hardens,harcesis,harbouring,hangouts,halkein,haleh,halberstam,hairnet,hairdressers,hacky,haaaa,h'yah,gusta,gushy,gurgling,guilted,gruel,grudging,grrrrrr,grosses,groomsmen,griping,gravest,gratified,grated,goulash,goopy,goona,goodly,godliness,godawful,godamn,glycerin,glutes,glowy,globetrotters,glimpsed,glenville,glaucoma,girlscout,giraffes,gilbey,gigglepuss,ghora,gestating,gelato,geishas,gearshift,gayness,gasped,gaslighting,garretts,garba,gablyczyck,g'head,fumigating,fumbling,fudged,fuckwad,fuck're,fuchsia,fretting,freshest,frenchies,freezers,fredrica,fraziers,fraidy,foxholes,fourty,fossilized,forsake,forfeits,foreclosed,foreal,footsies,florists,flopped,floorshow,floorboard,flinching,flecks,flaubert,flatware,flatulence,flatlined,flashdance,flail,flagging,fiver,fitzy,fishsticks,finetti,finelli,finagle,filko,fieldstone,fibber,ferrini,feedin,feasting,favore,fathering,farrouhk,farmin,fairytale,fairservice,factoid,facedown,fabled,eyeballin,extortionist,exquisitely,expedited,exorcise,existentialist,execs,exculpatory,exacerbate,everthing,eventuality,evander,euphoric,euphemisms,estamos,erred,entitle,enquiries,enormity,enfants,endive,encyclopedias,emulating,embittered,effortless,ectopic,ecirc,easely,earphones,earmarks,dweller,durslar,durned,dunois,dunking,dunked,dumdum,dullard,dudleys,druthers,druggist,drossos,drooled,driveways,drippy,dreamless,drawstring,drang,drainpipe,dozing,dotes,dorkface,doorknobs,doohickey,donnatella,doncha,domicile,dokos,dobermans,dizzying,divola,ditsy,distaste,disservice,dislodged,dislodge,disinherit,disinformation,discounting,dinka,dimly,digesting,diello,diddling,dictatorships,dictators,diagnostician,devours,devilishly,detract,detoxing,detours,detente,destructs,desecrated,derris,deplore,deplete,demure,demolitions,demean,delish,delbruck,delaford,degaulle,deftly,deformity,deflate,definatly,defector,decrypted,decontamination,decapitate,decanter,dardis,dampener,damme,daddy'll,dabbling,dabbled,d'etre,d'argent,d'alene,d'agnasti,czechoslovakian,cymbal,cyberdyne,cutoffs,cuticle,curvaceous,curiousity,crowing,crowed,croutons,cropped,criminy,crescentis,crashers,cranwell,coverin,courtrooms,countenance,cosmically,cosign,corroboration,coroners,cornflakes,copperpot,copperhead,copacetic,coordsize,convulsing,consults,conjures,congenial,concealer,compactor,commercialism,cokey,cognizant,clunkers,clumsily,clucking,cloves,cloven,cloths,clothe,clods,clocking,clings,clavicle,classless,clashing,clanking,clanging,clamping,civvies,citywide,circulatory,circuited,chronisters,chromic,choos,chloroformed,chillun,cheesed,chatterbox,chaperoned,channukah,cerebellum,centerpieces,centerfold,ceecee,ccedil,cavorting,cavemen,cauterized,cauldwell,catting,caterine,cassiopeia,carves,cartwheel,carpeted,carob,caressing,carelessly,careening,capricious,capitalistic,capillaries,candidly,camaraderie,callously,calfskin,caddies,buttholes,busywork,busses,burps,burgomeister,bunkhouse,bungchow,bugler,buffets,buffed,brutish,brusque,bronchitis,bromden,brolly,broached,brewskis,brewin,brean,breadwinner,brana,bountiful,bouncin,bosoms,borgnine,bopping,bootlegs,booing,bombosity,bolting,boilerplate,bluey,blowback,blouses,bloodsuckers,bloodstained,bloat,bleeth,blackface,blackest,blackened,blacken,blackballed,blabs,blabbering,birdbrain,bipartisanship,biodegradable,biltmore,bilked,big'uns,bidet,besotted,bernheim,benegas,bendiga,belushi,bellboys,belittling,behinds,begone,bedsheets,beckoning,beaute,beaudine,beastly,beachfront,bathes,batak,baser,baseballs,barbella,bankrolling,bandaged,baerly,backlog,backin,babying,azkaban,awwwww,aviary,authorizes,austero,aunty,attics,atreus,astounded,astonish,artemus,arses,arintero,appraiser,apathetic,anybody'd,anxieties,anticlimactic,antar,anglos,angleman,anesthetist,androscoggin,andolini,andale,amway,amuck,amniocentesis,amnesiac,americano,amara,alvah,altruism,alternapalooza,alphabetize,alpaca,allus,allergist,alexandros,alaikum,akimbo,agoraphobia,agides,aggrhh,aftertaste,adoptions,adjuster,addictions,adamantium,activator,accomplishes,aberrant,aaaaargh,aaaaaaaaaaaaa,a'ight,zzzzzzz,zucchini,zookeeper,zirconia,zippers,zequiel,zellary,zeitgeist,zanuck,zagat,you'n,ylang,yes'm,yenta,yecchh,yecch,yawns,yankin,yahdah,yaaah,y'got,xeroxed,wwooww,wristwatch,wrangled,wouldst,worthiness,worshiping,wormy,wormtail,wormholes,woosh,wollsten,wolfing,woefully,wobbling,wintry,wingding,windstorm,windowtext,wiluna,wilting,wilted,willick,willenholly,wildflowers,wildebeest,whyyy,whoppers,whoaa,whizzing,whizz,whitest,whistled,whist,whinny,wheelies,whazzup,whatwhatwhaaat,whato,whatdya,what'dya,whacks,wewell,wetsuit,welluh,weeps,waylander,wavin,wassail,wasnt,warneford,warbucks,waltons,wallbanger,waiving,waitwait,vowing,voucher,vornoff,vorhees,voldemort,vivre,vittles,vindaloo,videogames,vichyssoise,vicarious,vesuvius,verguenza,ven't,velveteen,velour,velociraptor,vastness,vasectomies,vapors,vanderhof,valmont,validates,valiantly,vacuums,usurp,usernum,us'll,urinals,unyielding,unvarnished,unturned,untouchables,untangled,unsecured,unscramble,unreturned,unremarkable,unpretentious,unnerstand,unmade,unimpeachable,unfashionable,underwrite,underlining,underling,underestimates,underappreciated,uncouth,uncork,uncommonly,unclog,uncircumcised,unchallenged,uncas,unbuttoning,unapproved,unamerican,unafraid,umpteen,umhmm,uhwhy,ughuh,typewriters,twitches,twitched,twirly,twinkling,twinges,twiddling,turners,turnabout,tumblin,tryed,trowel,trousseau,trivialize,trifles,tribianni,trenchcoat,trembled,traumatize,transitory,transients,transfuse,transcribing,tranq,trampy,traipsed,trainin,trachea,traceable,touristy,toughie,toscanini,tortola,tortilla,torreon,toreador,tommorrow,tollbooth,tollans,toidy,togas,tofurkey,toddling,toddies,toasties,toadstool,to've,tingles,timin,timey,timetables,tightest,thuggee,thrusting,thrombus,throes,thrifty,thornharts,thinnest,thicket,thetas,thesulac,tethered,testaburger,tersenadine,terrif,terdlington,tepui,temping,tector,taxidermy,tastebuds,tartlets,tartabull,tar'd,tantamount,tangy,tangles,tamer,tabula,tabletops,tabithia,szechwan,synthedyne,svenjolly,svengali,survivalists,surmise,surfboards,surefire,suprise,supremacists,suppositories,superstore,supercilious,suntac,sunburned,summercliff,sullied,sugared,suckle,subtleties,substantiated,subsides,subliminal,subhuman,strowman,stroked,stroganoff,streetlight,straying,strainer,straighter,straightener,stoplight,stirrups,stewing,stereotyping,stepmommy,stephano,stashing,starshine,stairwells,squatsie,squandering,squalid,squabbling,squab,sprinkling,spreader,spongy,spokesmen,splintered,spittle,spitter,spiced,spews,spendin,spect,spearchucker,spatulas,southtown,soused,soshi,sorter,sorrowful,sooth,some'in,soliloquy,soiree,sodomized,sobriki,soaping,snows,snowcone,snitching,snitched,sneering,snausages,snaking,smoothed,smoochies,smarten,smallish,slushy,slurring,sluman,slithers,slippin,sleuthing,sleeveless,skinless,skillfully,sketchbook,skagnetti,sista,sinning,singularly,sinewy,silverlake,siguto,signorina,sieve,sidearms,shying,shunning,shtud,shrieks,shorting,shortbread,shopkeepers,shmancy,shizzit,shitheads,shitfaced,shipmates,shiftless,shelving,shedlow,shavings,shatters,sharifa,shampoos,shallots,shafter,sha'nauc,sextant,serviceable,sepsis,senores,sendin,semis,semanski,selflessly,seinfelds,seers,seeps,seductress,secaucus,sealant,scuttling,scusa,scrunched,scissorhands,schreber,schmancy,scamps,scalloped,savoir,savagery,sarong,sarnia,santangel,samool,sallow,salino,safecracker,sadism,sacrilegious,sabrini,sabath,s'aright,ruttheimer,rudest,rubbery,rousting,rotarian,roslin,roomed,romari,romanica,rolltop,rolfski,rockettes,roared,ringleader,riffing,ribcage,rewired,retrial,reting,resuscitated,restock,resale,reprogrammed,replicant,repentant,repellant,repays,repainting,renegotiating,rendez,remem,relived,relinquishes,relearn,relaxant,rekindling,rehydrate,refueled,refreshingly,refilling,reexamine,reeseman,redness,redeemable,redcoats,rectangles,recoup,reciprocated,reassessing,realy,realer,reachin,re'kali,rawlston,ravages,rappaports,ramoray,ramming,raindrops,rahesh,radials,racists,rabartu,quiches,quench,quarreling,quaintly,quadrants,putumayo,put'em,purifier,pureed,punitis,pullout,pukin,pudgy,puddings,puckering,pterodactyl,psychodrama,psats,protestations,protectee,prosaic,propositioned,proclivity,probed,printouts,prevision,pressers,preset,preposition,preempt,preemie,preconceptions,prancan,powerpuff,potties,potpie,poseur,porthole,poops,pooping,pomade,polyps,polymerized,politeness,polisher,polack,pocketknife,poatia,plebeian,playgroup,platonically,platitude,plastering,plasmapheresis,plaids,placemats,pizzazz,pintauro,pinstripes,pinpoints,pinkner,pincer,pimento,pileup,pilates,pigmen,pieeee,phrased,photocopies,phoebes,philistines,philanderer,pheromone,phasers,pfeffernuesse,pervs,perspire,personify,perservere,perplexed,perpetrating,perkiness,perjurer,periodontist,perfunctory,perdido,percodan,pentameter,pentacle,pensive,pensione,pennybaker,pennbrooke,penhall,pengin,penetti,penetrates,pegnoir,peeve,peephole,pectorals,peckin,peaky,peaksville,paxcow,paused,patted,parkishoff,parkers,pardoning,paraplegic,paraphrasing,paperers,papered,pangs,paneling,palooza,palmed,palmdale,palatable,pacify,pacified,owwwww,oversexed,overrides,overpaying,overdrawn,overcompensate,overcomes,overcharged,outmaneuver,outfoxed,oughtn't,ostentatious,oshun,orthopedist,or'derves,ophthalmologist,operagirl,oozes,oooooooh,onesie,omnis,omelets,oktoberfest,okeydoke,ofthe,ofher,obstetrical,obeys,obeah,o'henry,nyquil,nyanyanyanyah,nuttin,nutsy,nutball,nurhachi,numbskull,nullifies,nullification,nucking,nubbin,nourished,nonspecific,noing,noinch,nohoho,nobler,nitwits,newsprint,newspaperman,newscaster,neuropathy,netherworld,neediest,navasky,narcissists,napped,nafta,mache,mykonos,mutilating,mutherfucker,mutha,mutates,mutate,musn't,murchy,multitasking,mujeeb,mudslinging,muckraking,mousetrap,mourns,mournful,motherf,mostro,morphing,morphate,moralistic,moochy,mooching,monotonous,monopolize,monocle,molehill,moland,mofet,mockup,mobilizing,mmmmmmm,mitzvahs,mistreating,misstep,misjudge,misinformation,misdirected,miscarriages,miniskirt,mindwarped,minced,milquetoast,miguelito,mightily,midstream,midriff,mideast,microbe,methuselah,mesdames,mescal,men'll,memma,megaton,megara,megalomaniac,meeee,medulla,medivac,meaninglessness,mcnuggets,mccarthyism,maypole,may've,mauve,mateys,marshack,markles,marketable,mansiere,manservant,manse,manhandling,mallomars,malcontent,malaise,majesties,mainsail,mailmen,mahandra,magnolias,magnified,magev,maelstrom,machu,macado,m'boy,m'appelle,lustrous,lureen,lunges,lumped,lumberyard,lulled,luego,lucks,lubricated,loveseat,loused,lounger,loski,lorre,loora,looong,loonies,loincloth,lofts,lodgers,lobbing,loaner,livered,liqueur,ligourin,lifesaving,lifeguards,lifeblood,liaisons,let'em,lesbianism,lence,lemonlyman,legitimize,leadin,lazars,lazarro,lawyering,laugher,laudanum,latrines,lations,laters,lapels,lakefront,lahit,lafortunata,lachrymose,l'italien,kwaini,kruczynski,kramerica,kowtow,kovinsky,korsekov,kopek,knowakowski,knievel,knacks,kiowas,killington,kickball,keyworth,keymaster,kevie,keveral,kenyons,keggers,keepsakes,kechner,keaty,kavorka,karajan,kamerev,kaggs,jujyfruit,jostled,jonestown,jokey,joists,jocko,jimmied,jiggled,jests,jenzen,jenko,jellyman,jedediah,jealitosis,jaunty,jarmel,jankle,jagoff,jagielski,jackrabbits,jabbing,jabberjaw,izzat,irresponsibly,irrepressible,irregularity,irredeemable,inuvik,intuitions,intubated,intimates,interminable,interloper,intercostal,instyle,instigate,instantaneously,ining,ingrown,ingesting,infusing,infringe,infinitum,infact,inequities,indubitably,indisputable,indescribably,indentation,indefinable,incontrovertible,inconsequential,incompletes,incoherently,inclement,incidentals,inarticulate,inadequacies,imprudent,improprieties,imprison,imprinted,impressively,impostors,importante,imperious,impale,immodest,immobile,imbedded,imbecilic,illegals,idn't,hysteric,hypotenuse,hygienic,hyeah,hushpuppies,hunhh,humpback,humored,hummed,humiliates,humidifier,huggy,huggers,huckster,hotbed,hosing,hosers,horsehair,homebody,homebake,holing,holies,hoisting,hogwallop,hocks,hobbits,hoaxes,hmmmmm,hisses,hippest,hillbillies,hilarity,heurh,herniated,hermaphrodite,hennifer,hemlines,hemline,hemery,helplessness,helmsley,hellhound,heheheheh,heeey,hedda,heartbeats,heaped,healers,headstart,headsets,headlong,hawkland,havta,haulin,harvey'll,hanta,hansom,hangnail,handstand,handrail,handoff,hallucinogen,hallor,halitosis,haberdashery,gypped,guy'll,gumbel,guerillas,guava,guardrail,grunther,grunick,groppi,groomer,grodin,gripes,grinds,grifters,gretch,greevey,greasing,graveyards,grandkid,grainy,gouging,gooney,googly,goldmuff,goldenrod,goingo,godly,gobbledygook,gobbledegook,glues,gloriously,glengarry,glassware,glamor,gimmicks,giggly,giambetti,ghoulish,ghettos,ghali,gether,geriatrics,gerbils,geosynchronous,georgio,gente,gendarme,gelbman,gazillionth,gayest,gauging,gastro,gaslight,gasbag,garters,garish,garas,gantu,gangy,gangly,gangland,galling,gadda,furrowed,funnies,funkytown,fugimotto,fudging,fuckeen,frustrates,froufrou,froot,fromberge,frizzies,fritters,frightfully,friendliest,freeloading,freelancing,freakazoid,fraternization,framers,fornication,fornicating,forethought,footstool,foisting,focussing,focking,flurries,fluffed,flintstones,fledermaus,flayed,flawlessly,flatters,flashbang,flapped,fishies,firmer,fireproof,firebug,fingerpainting,finessed,findin,financials,finality,fillets,fiercest,fiefdom,fibbing,fervor,fentanyl,fenelon,fedorchuk,feckless,feathering,faucets,farewells,fantasyland,fanaticism,faltered,faggy,faberge,extorting,extorted,exterminating,exhumation,exhilaration,exhausts,exfoliate,excels,exasperating,exacting,everybody'd,evasions,espressos,esmail,errrr,erratically,eroding,ernswiler,epcot,enthralled,ensenada,enriching,enrage,enhancer,endear,encrusted,encino,empathic,embezzle,emanates,electricians,eking,egomaniacal,egging,effacing,ectoplasm,eavesdropped,dummkopf,dugray,duchaisne,drunkard,drudge,droop,droids,drips,dripped,dribbles,drazens,downy,downsize,downpour,dosages,doppelganger,dopes,doohicky,dontcha,doneghy,divining,divest,diuretics,diuretic,distrustful,disrupts,dismemberment,dismember,disinfect,disillusionment,disheartening,discourteous,discotheque,discolored,dirtiest,diphtheria,dinks,dimpled,didya,dickwad,diatribes,diathesis,diabetics,deviants,detonates,detests,detestable,detaining,despondent,desecration,derision,derailing,deputized,depressors,dependant,dentures,denominators,demur,demonology,delts,dellarte,delacour,deflated,defib,defaced,decorators,deaqon,davola,datin,darwinian,darklighters,dandelions,dampened,damaskinos,dalrimple,d'peshu,d'hoffryn,d'astier,cynics,cutesy,cutaway,curmudgeon,curdle,culpability,cuisinart,cuffing,crypts,cryptid,crunched,crumblers,crudely,crosscheck,croon,crissake,crevasse,creswood,creepo,creases,creased,creaky,cranks,crabgrass,coveralls,couple'a,coughs,coslaw,corporeal,cornucopia,cornering,corks,cordoned,coolly,coolin,cookbooks,contrite,contented,constrictor,confound,confit,confiscating,condoned,conditioners,concussions,comprendo,comers,combustible,combusted,collingswood,coldness,coitus,codicil,coasting,clydesdale,cluttering,clunker,clunk,clumsiness,clotted,clothesline,clinches,clincher,cleverness,clench,clein,cleanses,claymores,clammed,chugging,chronically,christsakes,choque,chompers,chiseling,chirpy,chirp,chinks,chingachgook,chickenpox,chickadee,chewin,chessboard,chargin,chanteuse,chandeliers,chamdo,chagrined,chaff,certs,certainties,cerreno,cerebrum,censured,cemetary,caterwauling,cataclysmic,casitas,cased,carvel,carting,carrear,carolling,carolers,carnie,cardiogram,carbuncle,capulets,canines,candaules,canape,caldecott,calamitous,cadillacs,cachet,cabeza,cabdriver,buzzards,butai,businesswomen,bungled,bumpkins,bummers,bulldoze,buffybot,bubut,bubbies,brrrrr,brownout,brouhaha,bronzing,bronchial,broiler,briskly,briefcases,bricked,breezing,breeher,breakable,breadstick,bravenet,braved,brandies,brainwaves,brainiest,braggart,bradlee,boys're,boys'll,boys'd,boutonniere,bossed,bosomy,borans,boosts,bookshelves,bookends,boneless,bombarding,bollo,boinked,boink,bluest,bluebells,bloodshot,blockhead,blockbusters,blithely,blather,blankly,bladders,blackbeard,bitte,bippy,biogenetics,bilge,bigglesworth,bicuspids,beususe,betaseron,besmirch,bernece,bereavement,bentonville,benchley,benching,bembe,bellyaching,bellhops,belie,beleaguered,behrle,beginnin,begining,beenie,beefs,beechwood,becau,beaverhausen,beakers,bazillion,baudouin,barrytown,barringtons,barneys,barbs,barbers,barbatus,bankrupted,bailiffs,backslide,baby'd,baaad,b'fore,awwwk,aways,awakes,automatics,authenticate,aught,aubyn,attired,attagirl,atrophied,asystole,astroturf,assertiveness,artichokes,arquillians,aright,archenemy,appraise,appeased,antin,anspaugh,anesthetics,anaphylactic,amscray,ambivalence,amalio,alriiight,alphabetized,alpena,alouette,allora,alliteration,allenwood,allegiances,algerians,alcerro,alastor,ahaha,agitators,aforethought,advertises,admonition,adirondacks,adenoids,acupuncturist,acula,actuarial,activators,actionable,achingly,accusers,acclimated,acclimate,absurdly,absorbent,absolvo,absolutes,absences,abdomenizer,aaaaaaaaah,aaaaaaaaaa,a'right".split(","),
  male_names: "james,john,robert,michael,william,david,richard,charles,joseph,thomas,christopher,daniel,paul,mark,donald,george,kenneth,steven,edward,brian,ronald,anthony,kevin,jason,matthew,gary,timothy,jose,larry,jeffrey,frank,scott,eric,stephen,andrew,raymond,gregory,joshua,jerry,dennis,walter,patrick,peter,harold,douglas,henry,carl,arthur,ryan,roger,joe,juan,jack,albert,jonathan,justin,terry,gerald,keith,samuel,willie,ralph,lawrence,nicholas,roy,benjamin,bruce,brandon,adam,harry,fred,wayne,billy,steve,louis,jeremy,aaron,randy,eugene,carlos,russell,bobby,victor,ernest,phillip,todd,jesse,craig,alan,shawn,clarence,sean,philip,chris,johnny,earl,jimmy,antonio,danny,bryan,tony,luis,mike,stanley,leonard,nathan,dale,manuel,rodney,curtis,norman,marvin,vincent,glenn,jeffery,travis,jeff,chad,jacob,melvin,alfred,kyle,francis,bradley,jesus,herbert,frederick,ray,joel,edwin,don,eddie,ricky,troy,randall,barry,bernard,mario,leroy,francisco,marcus,micheal,theodore,clifford,miguel,oscar,jay,jim,tom,calvin,alex,jon,ronnie,bill,lloyd,tommy,leon,derek,darrell,jerome,floyd,leo,alvin,tim,wesley,dean,greg,jorge,dustin,pedro,derrick,dan,zachary,corey,herman,maurice,vernon,roberto,clyde,glen,hector,shane,ricardo,sam,rick,lester,brent,ramon,tyler,gilbert,gene,marc,reginald,ruben,brett,nathaniel,rafael,edgar,milton,raul,ben,cecil,duane,andre,elmer,brad,gabriel,ron,roland,jared,adrian,karl,cory,claude,erik,darryl,neil,christian,javier,fernando,clinton,ted,mathew,tyrone,darren,lonnie,lance,cody,julio,kurt,allan,clayton,hugh,max,dwayne,dwight,armando,felix,jimmie,everett,ian,ken,bob,jaime,casey,alfredo,alberto,dave,ivan,johnnie,sidney,byron,julian,isaac,clifton,willard,daryl,virgil,andy,salvador,kirk,sergio,seth,kent,terrance,rene,eduardo,terrence,enrique,freddie,stuart,fredrick,arturo,alejandro,joey,nick,luther,wendell,jeremiah,evan,julius,donnie,otis,trevor,luke,homer,gerard,doug,kenny,hubert,angelo,shaun,lyle,matt,alfonso,orlando,rex,carlton,ernesto,pablo,lorenzo,omar,wilbur,blake,horace,roderick,kerry,abraham,rickey,ira,andres,cesar,johnathan,malcolm,rudolph,damon,kelvin,rudy,preston,alton,archie,marco,pete,randolph,garry,geoffrey,jonathon,felipe,bennie,gerardo,dominic,loren,delbert,colin,guillermo,earnest,benny,noel,rodolfo,myron,edmund,salvatore,cedric,lowell,gregg,sherman,devin,sylvester,roosevelt,israel,jermaine,forrest,wilbert,leland,simon,irving,owen,rufus,woodrow,sammy,kristopher,levi,marcos,gustavo,jake,lionel,marty,gilberto,clint,nicolas,laurence,ismael,orville,drew,ervin,dewey,wilfred,josh,hugo,ignacio,caleb,tomas,sheldon,erick,frankie,darrel,rogelio,terence,alonzo,elias,bert,elbert,ramiro,conrad,noah,grady,phil,cornelius,lamar,rolando,clay,percy,bradford,merle,darin,amos,terrell,moses,irvin,saul,roman,darnell,randal,tommie,timmy,darrin,brendan,toby,van,abel,dominick,emilio,elijah,cary,domingo,aubrey,emmett,marlon,emanuel,jerald,edmond,emil,dewayne,otto,teddy,reynaldo,bret,jess,trent,humberto,emmanuel,stephan,louie,vicente,lamont,garland,micah,efrain,heath,rodger,demetrius,ethan,eldon,rocky,pierre,eli,bryce,antoine,robbie,kendall,royce,sterling,grover,elton,cleveland,dylan,chuck,damian,reuben,stan,leonardo,russel,erwin,benito,hans,monte,blaine,ernie,curt,quentin,agustin,jamal,devon,adolfo,tyson,wilfredo,bart,jarrod,vance,denis,damien,joaquin,harlan,desmond,elliot,darwin,gregorio,kermit,roscoe,esteban,anton,solomon,norbert,elvin,nolan,carey,rod,quinton,hal,brain,rob,elwood,kendrick,darius,moises,marlin,fidel,thaddeus,cliff,marcel,ali,raphael,bryon,armand,alvaro,jeffry,dane,joesph,thurman,ned,sammie,rusty,michel,monty,rory,fabian,reggie,kris,isaiah,gus,avery,loyd,diego,adolph,millard,rocco,gonzalo,derick,rodrigo,gerry,rigoberto,alphonso,rickie,noe,vern,elvis,bernardo,mauricio,hiram,donovan,basil,nickolas,scot,vince,quincy,eddy,sebastian,federico,ulysses,heriberto,donnell,denny,gavin,emery,romeo,jayson,dion,dante,clement,coy,odell,jarvis,bruno,issac,dudley,sanford,colby,carmelo,nestor,hollis,stefan,donny,linwood,beau,weldon,galen,isidro,truman,delmar,johnathon,silas,frederic,irwin,merrill,charley,marcelino,carlo,trenton,kurtis,aurelio,winfred,vito,collin,denver,leonel,emory,pasquale,mohammad,mariano,danial,landon,dirk,branden,adan,numbers,clair,buford,bernie,wilmer,emerson,zachery,jacques,errol,josue,edwardo,wilford,theron,raymundo,daren,tristan,robby,lincoln,jame,genaro,octavio,cornell,hung,arron,antony,herschel,alva,giovanni,garth,cyrus,cyril,ronny,stevie,lon,kennith,carmine,augustine,erich,chadwick,wilburn,russ,myles,jonas,mitchel,mervin,zane,jamel,lazaro,alphonse,randell,johnie,jarrett,ariel,abdul,dusty,luciano,seymour,scottie,eugenio,mohammed,arnulfo,lucien,ferdinand,thad,ezra,aldo,rubin,mitch,earle,abe,marquis,lanny,kareem,jamar,boris,isiah,emile,elmo,aron,leopoldo,everette,josef,eloy,dorian,rodrick,reinaldo,lucio,jerrod,weston,hershel,lemuel,lavern,burt,jules,gil,eliseo,ahmad,nigel,efren,antwan,alden,margarito,refugio,dino,osvaldo,les,deandre,normand,kieth,ivory,trey,norberto,napoleon,jerold,fritz,rosendo,milford,sang,deon,christoper,alfonzo,lyman,josiah,brant,wilton,rico,jamaal,dewitt,brenton,yong,olin,faustino,claudio,judson,gino,edgardo,alec,jarred,donn,trinidad,tad,porfirio,odis,lenard,chauncey,tod,mel,marcelo,kory,augustus,keven,hilario,bud,sal,orval,mauro,dannie,zachariah,olen,anibal,milo,jed,thanh,amado,lenny,tory,richie,horacio,brice,mohamed,delmer,dario,mac,jonah,jerrold,robt,hank,sung,rupert,rolland,kenton,damion,chi,antone,waldo,fredric,bradly,kip,burl,tyree,jefferey,ahmed,willy,stanford,oren,moshe,mikel,enoch,brendon,quintin,jamison,florencio,darrick,tobias,minh,hassan,giuseppe,demarcus,cletus,tyrell,lyndon,keenan,werner,theo,geraldo,columbus,chet,bertram,markus,huey,hilton,dwain,donte,tyron,omer,isaias,hipolito,fermin,chung,adalberto,jamey,teodoro,mckinley,maximo,raleigh,lawerence,abram,rashad,emmitt,daron,chong,samual,otha,miquel,eusebio,dong,domenic,darron,wilber,renato,hoyt,haywood,ezekiel,chas,florentino,elroy,clemente,arden,neville,edison,deshawn,carrol,shayne,nathanial,jordon,danilo,claud,sherwood,raymon,rayford,cristobal,ambrose,titus,hyman,felton,ezequiel,erasmo,lonny,milan,lino,jarod,herb,andreas,rhett,jude,douglass,cordell,oswaldo,ellsworth,virgilio,toney,nathanael,benedict,mose,hong,isreal,garret,fausto,arlen,zack,modesto,francesco,manual,gaylord,gaston,filiberto,deangelo,michale,granville,malik,zackary,tuan,nicky,cristopher,antione,malcom,korey,jospeh,colton,waylon,hosea,shad,santo,rudolf,rolf,renaldo,marcellus,lucius,kristofer,harland,arnoldo,rueben,leandro,kraig,jerrell,jeromy,hobert,cedrick,arlie,winford,wally,luigi,keneth,jacinto,graig,franklyn,edmundo,leif,jeramy,willian,vincenzo,shon,michal,lynwood,jere,elden,darell,broderick,alonso".split(",")
};

module.exports = frequency_lists;

//# sourceMappingURL=frequency_lists.js.map


/***/ }),
/* 2849 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.10.0
var feedback, matching, scoring, time, time_estimates, zxcvbn;

matching = __webpack_require__(2850);

scoring = __webpack_require__(599);

time_estimates = __webpack_require__(2851);

feedback = __webpack_require__(2847);

time = function() {
  return (new Date()).getTime();
};

zxcvbn = function(password, user_inputs) {
  var arg, attack_times, i, len, matches, prop, ref, result, sanitized_inputs, start, val;
  if (user_inputs == null) {
    user_inputs = [];
  }
  start = time();
  sanitized_inputs = [];
  for (i = 0, len = user_inputs.length; i < len; i++) {
    arg = user_inputs[i];
    if ((ref = typeof arg) === "string" || ref === "number" || ref === "boolean") {
      sanitized_inputs.push(arg.toString().toLowerCase());
    }
  }
  matching.set_user_input_dictionary(sanitized_inputs);
  matches = matching.omnimatch(password);
  result = scoring.most_guessable_match_sequence(password, matches);
  result.calc_time = time() - start;
  attack_times = time_estimates.estimate_attack_times(result.guesses);
  for (prop in attack_times) {
    val = attack_times[prop];
    result[prop] = val;
  }
  result.feedback = feedback.get_feedback(result.score, result.sequence);
  return result;
};

module.exports = zxcvbn;

//# sourceMappingURL=main.js.map


/***/ }),
/* 2850 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.10.0
var DATE_MAX_YEAR, DATE_MIN_YEAR, DATE_SPLITS, GRAPHS, L33T_TABLE, RANKED_DICTIONARIES, REGEXEN, adjacency_graphs, build_ranked_dict, frequency_lists, lst, matching, name, scoring;

frequency_lists = __webpack_require__(2848);

adjacency_graphs = __webpack_require__(1125);

scoring = __webpack_require__(599);

build_ranked_dict = function(ordered_list) {
  var i, len1, o, result, word;
  result = {};
  i = 1;
  for (o = 0, len1 = ordered_list.length; o < len1; o++) {
    word = ordered_list[o];
    result[word] = i;
    i += 1;
  }
  return result;
};

RANKED_DICTIONARIES = {};

for (name in frequency_lists) {
  lst = frequency_lists[name];
  RANKED_DICTIONARIES[name] = build_ranked_dict(lst);
}

GRAPHS = {
  qwerty: adjacency_graphs.qwerty,
  dvorak: adjacency_graphs.dvorak,
  keypad: adjacency_graphs.keypad,
  mac_keypad: adjacency_graphs.mac_keypad
};

L33T_TABLE = {
  a: ['4', '@'],
  b: ['8'],
  c: ['(', '{', '[', '<'],
  e: ['3'],
  g: ['6', '9'],
  i: ['1', '!', '|'],
  l: ['1', '|', '7'],
  o: ['0'],
  s: ['$', '5'],
  t: ['+', '7'],
  x: ['%'],
  z: ['2']
};

REGEXEN = {
  recent_year: /19\d\d|200\d|201\d/g
};

DATE_MAX_YEAR = 2050;

DATE_MIN_YEAR = 1000;

DATE_SPLITS = {
  4: [[1, 2], [2, 3]],
  5: [[1, 3], [2, 3]],
  6: [[1, 2], [2, 4], [4, 5]],
  7: [[1, 3], [2, 3], [4, 5], [4, 6]],
  8: [[2, 4], [4, 6]]
};

matching = {
  empty: function(obj) {
    var k;
    return ((function() {
      var results;
      results = [];
      for (k in obj) {
        results.push(k);
      }
      return results;
    })()).length === 0;
  },
  extend: function(lst, lst2) {
    return lst.push.apply(lst, lst2);
  },
  translate: function(string, chr_map) {
    var chr;
    return ((function() {
      var len1, o, ref, results;
      ref = string.split('');
      results = [];
      for (o = 0, len1 = ref.length; o < len1; o++) {
        chr = ref[o];
        results.push(chr_map[chr] || chr);
      }
      return results;
    })()).join('');
  },
  mod: function(n, m) {
    return ((n % m) + m) % m;
  },
  sorted: function(matches) {
    return matches.sort(function(m1, m2) {
      return (m1.i - m2.i) || (m1.j - m2.j);
    });
  },
  omnimatch: function(password) {
    var len1, matcher, matchers, matches, o;
    matches = [];
    matchers = [this.dictionary_match, this.reverse_dictionary_match, this.l33t_match, this.spatial_match, this.repeat_match, this.sequence_match, this.regex_match, this.date_match];
    for (o = 0, len1 = matchers.length; o < len1; o++) {
      matcher = matchers[o];
      this.extend(matches, matcher.call(this, password));
    }
    return this.sorted(matches);
  },
  dictionary_match: function(password, _ranked_dictionaries) {
    var dictionary_name, i, j, len, matches, o, p, password_lower, rank, ranked_dict, ref, ref1, ref2, word;
    if (_ranked_dictionaries == null) {
      _ranked_dictionaries = RANKED_DICTIONARIES;
    }
    matches = [];
    len = password.length;
    password_lower = password.toLowerCase();
    for (dictionary_name in _ranked_dictionaries) {
      ranked_dict = _ranked_dictionaries[dictionary_name];
      for (i = o = 0, ref = len; 0 <= ref ? o < ref : o > ref; i = 0 <= ref ? ++o : --o) {
        for (j = p = ref1 = i, ref2 = len; ref1 <= ref2 ? p < ref2 : p > ref2; j = ref1 <= ref2 ? ++p : --p) {
          if (password_lower.slice(i, +j + 1 || 9e9) in ranked_dict) {
            word = password_lower.slice(i, +j + 1 || 9e9);
            rank = ranked_dict[word];
            matches.push({
              pattern: 'dictionary',
              i: i,
              j: j,
              token: password.slice(i, +j + 1 || 9e9),
              matched_word: word,
              rank: rank,
              dictionary_name: dictionary_name,
              reversed: false,
              l33t: false
            });
          }
        }
      }
    }
    return this.sorted(matches);
  },
  reverse_dictionary_match: function(password, _ranked_dictionaries) {
    var len1, match, matches, o, ref, reversed_password;
    if (_ranked_dictionaries == null) {
      _ranked_dictionaries = RANKED_DICTIONARIES;
    }
    reversed_password = password.split('').reverse().join('');
    matches = this.dictionary_match(reversed_password, _ranked_dictionaries);
    for (o = 0, len1 = matches.length; o < len1; o++) {
      match = matches[o];
      match.token = match.token.split('').reverse().join('');
      match.reversed = true;
      ref = [password.length - 1 - match.j, password.length - 1 - match.i], match.i = ref[0], match.j = ref[1];
    }
    return this.sorted(matches);
  },
  set_user_input_dictionary: function(ordered_list) {
    return RANKED_DICTIONARIES['user_inputs'] = build_ranked_dict(ordered_list.slice());
  },
  relevant_l33t_subtable: function(password, table) {
    var chr, len1, letter, o, password_chars, ref, relevant_subs, sub, subs, subtable;
    password_chars = {};
    ref = password.split('');
    for (o = 0, len1 = ref.length; o < len1; o++) {
      chr = ref[o];
      password_chars[chr] = true;
    }
    subtable = {};
    for (letter in table) {
      subs = table[letter];
      relevant_subs = (function() {
        var len2, p, results;
        results = [];
        for (p = 0, len2 = subs.length; p < len2; p++) {
          sub = subs[p];
          if (sub in password_chars) {
            results.push(sub);
          }
        }
        return results;
      })();
      if (relevant_subs.length > 0) {
        subtable[letter] = relevant_subs;
      }
    }
    return subtable;
  },
  enumerate_l33t_subs: function(table) {
    var chr, dedup, helper, k, keys, l33t_chr, len1, len2, o, p, ref, sub, sub_dict, sub_dicts, subs;
    keys = (function() {
      var results;
      results = [];
      for (k in table) {
        results.push(k);
      }
      return results;
    })();
    subs = [[]];
    dedup = function(subs) {
      var assoc, deduped, label, len1, members, o, sub, v;
      deduped = [];
      members = {};
      for (o = 0, len1 = subs.length; o < len1; o++) {
        sub = subs[o];
        assoc = (function() {
          var len2, p, results;
          results = [];
          for (v = p = 0, len2 = sub.length; p < len2; v = ++p) {
            k = sub[v];
            results.push([k, v]);
          }
          return results;
        })();
        assoc.sort();
        label = ((function() {
          var len2, p, results;
          results = [];
          for (v = p = 0, len2 = assoc.length; p < len2; v = ++p) {
            k = assoc[v];
            results.push(k + ',' + v);
          }
          return results;
        })()).join('-');
        if (!(label in members)) {
          members[label] = true;
          deduped.push(sub);
        }
      }
      return deduped;
    };
    helper = function(keys) {
      var dup_l33t_index, first_key, i, l33t_chr, len1, len2, next_subs, o, p, q, ref, ref1, rest_keys, sub, sub_alternative, sub_extension;
      if (!keys.length) {
        return;
      }
      first_key = keys[0];
      rest_keys = keys.slice(1);
      next_subs = [];
      ref = table[first_key];
      for (o = 0, len1 = ref.length; o < len1; o++) {
        l33t_chr = ref[o];
        for (p = 0, len2 = subs.length; p < len2; p++) {
          sub = subs[p];
          dup_l33t_index = -1;
          for (i = q = 0, ref1 = sub.length; 0 <= ref1 ? q < ref1 : q > ref1; i = 0 <= ref1 ? ++q : --q) {
            if (sub[i][0] === l33t_chr) {
              dup_l33t_index = i;
              break;
            }
          }
          if (dup_l33t_index === -1) {
            sub_extension = sub.concat([[l33t_chr, first_key]]);
            next_subs.push(sub_extension);
          } else {
            sub_alternative = sub.slice(0);
            sub_alternative.splice(dup_l33t_index, 1);
            sub_alternative.push([l33t_chr, first_key]);
            next_subs.push(sub);
            next_subs.push(sub_alternative);
          }
        }
      }
      subs = dedup(next_subs);
      return helper(rest_keys);
    };
    helper(keys);
    sub_dicts = [];
    for (o = 0, len1 = subs.length; o < len1; o++) {
      sub = subs[o];
      sub_dict = {};
      for (p = 0, len2 = sub.length; p < len2; p++) {
        ref = sub[p], l33t_chr = ref[0], chr = ref[1];
        sub_dict[l33t_chr] = chr;
      }
      sub_dicts.push(sub_dict);
    }
    return sub_dicts;
  },
  l33t_match: function(password, _ranked_dictionaries, _l33t_table) {
    var chr, k, len1, len2, match, match_sub, matches, o, p, ref, ref1, sub, subbed_chr, subbed_password, token, v;
    if (_ranked_dictionaries == null) {
      _ranked_dictionaries = RANKED_DICTIONARIES;
    }
    if (_l33t_table == null) {
      _l33t_table = L33T_TABLE;
    }
    matches = [];
    ref = this.enumerate_l33t_subs(this.relevant_l33t_subtable(password, _l33t_table));
    for (o = 0, len1 = ref.length; o < len1; o++) {
      sub = ref[o];
      if (this.empty(sub)) {
        break;
      }
      subbed_password = this.translate(password, sub);
      ref1 = this.dictionary_match(subbed_password, _ranked_dictionaries);
      for (p = 0, len2 = ref1.length; p < len2; p++) {
        match = ref1[p];
        token = password.slice(match.i, +match.j + 1 || 9e9);
        if (token.toLowerCase() === match.matched_word) {
          continue;
        }
        match_sub = {};
        for (subbed_chr in sub) {
          chr = sub[subbed_chr];
          if (token.indexOf(subbed_chr) !== -1) {
            match_sub[subbed_chr] = chr;
          }
        }
        match.l33t = true;
        match.token = token;
        match.sub = match_sub;
        match.sub_display = ((function() {
          var results;
          results = [];
          for (k in match_sub) {
            v = match_sub[k];
            results.push(k + " -> " + v);
          }
          return results;
        })()).join(', ');
        matches.push(match);
      }
    }
    return this.sorted(matches.filter(function(match) {
      return match.token.length > 1;
    }));
  },
  spatial_match: function(password, _graphs) {
    var graph, graph_name, matches;
    if (_graphs == null) {
      _graphs = GRAPHS;
    }
    matches = [];
    for (graph_name in _graphs) {
      graph = _graphs[graph_name];
      this.extend(matches, this.spatial_match_helper(password, graph, graph_name));
    }
    return this.sorted(matches);
  },
  SHIFTED_RX: /[~!@#$%^&*()_+QWERTYUIOP{}|ASDFGHJKL:"ZXCVBNM<>?]/,
  spatial_match_helper: function(password, graph, graph_name) {
    var adj, adjacents, cur_char, cur_direction, found, found_direction, i, j, last_direction, len1, matches, o, prev_char, shifted_count, turns;
    matches = [];
    i = 0;
    while (i < password.length - 1) {
      j = i + 1;
      last_direction = null;
      turns = 0;
      if ((graph_name === 'qwerty' || graph_name === 'dvorak') && this.SHIFTED_RX.exec(password.charAt(i))) {
        shifted_count = 1;
      } else {
        shifted_count = 0;
      }
      while (true) {
        prev_char = password.charAt(j - 1);
        found = false;
        found_direction = -1;
        cur_direction = -1;
        adjacents = graph[prev_char] || [];
        if (j < password.length) {
          cur_char = password.charAt(j);
          for (o = 0, len1 = adjacents.length; o < len1; o++) {
            adj = adjacents[o];
            cur_direction += 1;
            if (adj && adj.indexOf(cur_char) !== -1) {
              found = true;
              found_direction = cur_direction;
              if (adj.indexOf(cur_char) === 1) {
                shifted_count += 1;
              }
              if (last_direction !== found_direction) {
                turns += 1;
                last_direction = found_direction;
              }
              break;
            }
          }
        }
        if (found) {
          j += 1;
        } else {
          if (j - i > 2) {
            matches.push({
              pattern: 'spatial',
              i: i,
              j: j - 1,
              token: password.slice(i, j),
              graph: graph_name,
              turns: turns,
              shifted_count: shifted_count
            });
          }
          i = j;
          break;
        }
      }
    }
    return matches;
  },
  repeat_match: function(password) {
    var base_analysis, base_guesses, base_matches, base_token, greedy, greedy_match, i, j, lastIndex, lazy, lazy_anchored, lazy_match, match, matches, ref;
    matches = [];
    greedy = /(.+)\1+/g;
    lazy = /(.+?)\1+/g;
    lazy_anchored = /^(.+?)\1+$/;
    lastIndex = 0;
    while (lastIndex < password.length) {
      greedy.lastIndex = lazy.lastIndex = lastIndex;
      greedy_match = greedy.exec(password);
      lazy_match = lazy.exec(password);
      if (greedy_match == null) {
        break;
      }
      if (greedy_match[0].length > lazy_match[0].length) {
        match = greedy_match;
        base_token = lazy_anchored.exec(match[0])[1];
      } else {
        match = lazy_match;
        base_token = match[1];
      }
      ref = [match.index, match.index + match[0].length - 1], i = ref[0], j = ref[1];
      base_analysis = scoring.most_guessable_match_sequence(base_token, this.omnimatch(base_token));
      base_matches = base_analysis.sequence;
      base_guesses = base_analysis.guesses;
      matches.push({
        pattern: 'repeat',
        i: i,
        j: j,
        token: match[0],
        base_token: base_token,
        base_guesses: base_guesses,
        base_matches: base_matches,
        repeat_count: match[0].length / base_token.length
      });
      lastIndex = j + 1;
    }
    return matches;
  },
  MAX_DELTA: 5,
  sequence_match: function(password) {
    var delta, i, j, k, last_delta, o, ref, result, update;
    if (password.length === 1) {
      return [];
    }
    update = (function(_this) {
      return function(i, j, delta) {
        var ref, sequence_name, sequence_space, token;
        if (j - i > 1 || Math.abs(delta) === 1) {
          if ((0 < (ref = Math.abs(delta)) && ref <= _this.MAX_DELTA)) {
            token = password.slice(i, +j + 1 || 9e9);
            if (/^[a-z]+$/.test(token)) {
              sequence_name = 'lower';
              sequence_space = 26;
            } else if (/^[A-Z]+$/.test(token)) {
              sequence_name = 'upper';
              sequence_space = 26;
            } else if (/^\d+$/.test(token)) {
              sequence_name = 'digits';
              sequence_space = 10;
            } else {
              sequence_name = 'unicode';
              sequence_space = 26;
            }
            return result.push({
              pattern: 'sequence',
              i: i,
              j: j,
              token: password.slice(i, +j + 1 || 9e9),
              sequence_name: sequence_name,
              sequence_space: sequence_space,
              ascending: delta > 0
            });
          }
        }
      };
    })(this);
    result = [];
    i = 0;
    last_delta = null;
    for (k = o = 1, ref = password.length; 1 <= ref ? o < ref : o > ref; k = 1 <= ref ? ++o : --o) {
      delta = password.charCodeAt(k) - password.charCodeAt(k - 1);
      if (last_delta == null) {
        last_delta = delta;
      }
      if (delta === last_delta) {
        continue;
      }
      j = k - 1;
      update(i, j, last_delta);
      i = j;
      last_delta = delta;
    }
    update(i, password.length - 1, last_delta);
    return result;
  },
  regex_match: function(password, _regexen) {
    var matches, regex, rx_match, token;
    if (_regexen == null) {
      _regexen = REGEXEN;
    }
    matches = [];
    for (name in _regexen) {
      regex = _regexen[name];
      regex.lastIndex = 0;
      while (rx_match = regex.exec(password)) {
        token = rx_match[0];
        matches.push({
          pattern: 'regex',
          token: token,
          i: rx_match.index,
          j: rx_match.index + rx_match[0].length - 1,
          regex_name: name,
          regex_match: rx_match
        });
      }
    }
    return this.sorted(matches);
  },
  date_match: function(password) {
    var best_candidate, candidate, candidates, distance, dmy, i, j, k, l, len1, len2, matches, maybe_date_no_separator, maybe_date_with_separator, metric, min_distance, o, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, rx_match, s, t, token;
    matches = [];
    maybe_date_no_separator = /^\d{4,8}$/;
    maybe_date_with_separator = /^(\d{1,4})([\s\/\\_.-])(\d{1,2})\2(\d{1,4})$/;
    for (i = o = 0, ref = password.length - 4; 0 <= ref ? o <= ref : o >= ref; i = 0 <= ref ? ++o : --o) {
      for (j = p = ref1 = i + 3, ref2 = i + 7; ref1 <= ref2 ? p <= ref2 : p >= ref2; j = ref1 <= ref2 ? ++p : --p) {
        if (j >= password.length) {
          break;
        }
        token = password.slice(i, +j + 1 || 9e9);
        if (!maybe_date_no_separator.exec(token)) {
          continue;
        }
        candidates = [];
        ref3 = DATE_SPLITS[token.length];
        for (q = 0, len1 = ref3.length; q < len1; q++) {
          ref4 = ref3[q], k = ref4[0], l = ref4[1];
          dmy = this.map_ints_to_dmy([parseInt(token.slice(0, k)), parseInt(token.slice(k, l)), parseInt(token.slice(l))]);
          if (dmy != null) {
            candidates.push(dmy);
          }
        }
        if (!(candidates.length > 0)) {
          continue;
        }
        best_candidate = candidates[0];
        metric = function(candidate) {
          return Math.abs(candidate.year - scoring.REFERENCE_YEAR);
        };
        min_distance = metric(candidates[0]);
        ref5 = candidates.slice(1);
        for (r = 0, len2 = ref5.length; r < len2; r++) {
          candidate = ref5[r];
          distance = metric(candidate);
          if (distance < min_distance) {
            ref6 = [candidate, distance], best_candidate = ref6[0], min_distance = ref6[1];
          }
        }
        matches.push({
          pattern: 'date',
          token: token,
          i: i,
          j: j,
          separator: '',
          year: best_candidate.year,
          month: best_candidate.month,
          day: best_candidate.day
        });
      }
    }
    for (i = s = 0, ref7 = password.length - 6; 0 <= ref7 ? s <= ref7 : s >= ref7; i = 0 <= ref7 ? ++s : --s) {
      for (j = t = ref8 = i + 5, ref9 = i + 9; ref8 <= ref9 ? t <= ref9 : t >= ref9; j = ref8 <= ref9 ? ++t : --t) {
        if (j >= password.length) {
          break;
        }
        token = password.slice(i, +j + 1 || 9e9);
        rx_match = maybe_date_with_separator.exec(token);
        if (rx_match == null) {
          continue;
        }
        dmy = this.map_ints_to_dmy([parseInt(rx_match[1]), parseInt(rx_match[3]), parseInt(rx_match[4])]);
        if (dmy == null) {
          continue;
        }
        matches.push({
          pattern: 'date',
          token: token,
          i: i,
          j: j,
          separator: rx_match[2],
          year: dmy.year,
          month: dmy.month,
          day: dmy.day
        });
      }
    }
    return this.sorted(matches.filter(function(match) {
      var is_submatch, len3, other_match, u;
      is_submatch = false;
      for (u = 0, len3 = matches.length; u < len3; u++) {
        other_match = matches[u];
        if (match === other_match) {
          continue;
        }
        if (other_match.i <= match.i && other_match.j >= match.j) {
          is_submatch = true;
          break;
        }
      }
      return !is_submatch;
    }));
  },
  map_ints_to_dmy: function(ints) {
    var dm, int, len1, len2, len3, o, over_12, over_31, p, possible_year_splits, q, ref, ref1, rest, under_1, y;
    if (ints[1] > 31 || ints[1] <= 0) {
      return;
    }
    over_12 = 0;
    over_31 = 0;
    under_1 = 0;
    for (o = 0, len1 = ints.length; o < len1; o++) {
      int = ints[o];
      if ((99 < int && int < DATE_MIN_YEAR) || int > DATE_MAX_YEAR) {
        return;
      }
      if (int > 31) {
        over_31 += 1;
      }
      if (int > 12) {
        over_12 += 1;
      }
      if (int <= 0) {
        under_1 += 1;
      }
    }
    if (over_31 >= 2 || over_12 === 3 || under_1 >= 2) {
      return;
    }
    possible_year_splits = [[ints[2], ints.slice(0, 2)], [ints[0], ints.slice(1, 3)]];
    for (p = 0, len2 = possible_year_splits.length; p < len2; p++) {
      ref = possible_year_splits[p], y = ref[0], rest = ref[1];
      if ((DATE_MIN_YEAR <= y && y <= DATE_MAX_YEAR)) {
        dm = this.map_ints_to_dm(rest);
        if (dm != null) {
          return {
            year: y,
            month: dm.month,
            day: dm.day
          };
        } else {
          return;
        }
      }
    }
    for (q = 0, len3 = possible_year_splits.length; q < len3; q++) {
      ref1 = possible_year_splits[q], y = ref1[0], rest = ref1[1];
      dm = this.map_ints_to_dm(rest);
      if (dm != null) {
        y = this.two_to_four_digit_year(y);
        return {
          year: y,
          month: dm.month,
          day: dm.day
        };
      }
    }
  },
  map_ints_to_dm: function(ints) {
    var d, len1, m, o, ref, ref1;
    ref = [ints, ints.slice().reverse()];
    for (o = 0, len1 = ref.length; o < len1; o++) {
      ref1 = ref[o], d = ref1[0], m = ref1[1];
      if ((1 <= d && d <= 31) && (1 <= m && m <= 12)) {
        return {
          day: d,
          month: m
        };
      }
    }
  },
  two_to_four_digit_year: function(year) {
    if (year > 99) {
      return year;
    } else if (year > 50) {
      return year + 1900;
    } else {
      return year + 2000;
    }
  }
};

module.exports = matching;

//# sourceMappingURL=matching.js.map


/***/ }),
/* 2851 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.10.0
var time_estimates;

time_estimates = {
  estimate_attack_times: function(guesses) {
    var crack_times_display, crack_times_seconds, scenario, seconds;
    crack_times_seconds = {
      online_throttling_100_per_hour: guesses / (100 / 3600),
      online_no_throttling_10_per_second: guesses / 10,
      offline_slow_hashing_1e4_per_second: guesses / 1e4,
      offline_fast_hashing_1e10_per_second: guesses / 1e10
    };
    crack_times_display = {};
    for (scenario in crack_times_seconds) {
      seconds = crack_times_seconds[scenario];
      crack_times_display[scenario] = this.display_time(seconds);
    }
    return {
      crack_times_seconds: crack_times_seconds,
      crack_times_display: crack_times_display,
      score: this.guesses_to_score(guesses)
    };
  },
  guesses_to_score: function(guesses) {
    var DELTA;
    DELTA = 5;
    if (guesses < 1e3 + DELTA) {
      return 0;
    } else if (guesses < 1e6 + DELTA) {
      return 1;
    } else if (guesses < 1e8 + DELTA) {
      return 2;
    } else if (guesses < 1e10 + DELTA) {
      return 3;
    } else {
      return 4;
    }
  },
  display_time: function(seconds) {
    var base, century, day, display_num, display_str, hour, minute, month, ref, year;
    minute = 60;
    hour = minute * 60;
    day = hour * 24;
    month = day * 31;
    year = month * 12;
    century = year * 100;
    ref = seconds < 1 ? [null, 'less than a second'] : seconds < minute ? (base = Math.round(seconds), [base, base + " second"]) : seconds < hour ? (base = Math.round(seconds / minute), [base, base + " minute"]) : seconds < day ? (base = Math.round(seconds / hour), [base, base + " hour"]) : seconds < month ? (base = Math.round(seconds / day), [base, base + " day"]) : seconds < year ? (base = Math.round(seconds / month), [base, base + " month"]) : seconds < century ? (base = Math.round(seconds / year), [base, base + " year"]) : [null, 'centuries'], display_num = ref[0], display_str = ref[1];
    if ((display_num != null) && display_num !== 1) {
      display_str += 's';
    }
    return display_str;
  }
};

module.exports = time_estimates;

//# sourceMappingURL=time_estimates.js.map


/***/ }),
/* 2852 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2853 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2854 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[1397]);


// WEBPACK FOOTER //
// static/js/app-87cc90d45197a215df99.js